/*!
 * SurveyJS Creator v1.11.5
 * (c) 2015-2024 Devsoft Baltic OÜ - http://surveyjs.io/
 * Github: https://github.com/surveyjs/survey-creator
 * License: https://surveyjs.io/Licenses#SurveyCreator
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("survey-creator-core"));
	else if(typeof define === 'function' && define.amd)
		define("SurveyCreatorLocales", ["survey-creator-core"], factory);
	else if(typeof exports === 'object')
		exports["SurveyCreatorLocales"] = factory(require("survey-creator-core"));
	else
		root["SurveyCreatorLocales"] = factory(root["SurveyCreatorCore"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_survey_creator_core__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/entries/i18n.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/entries/i18n.ts":
/*!*****************************!*\
  !*** ./src/entries/i18n.ts ***!
  \*****************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _localization_arabic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../localization/arabic */ "./src/localization/arabic.ts");
/* harmony import */ var _localization_croatian__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../localization/croatian */ "./src/localization/croatian.ts");
/* harmony import */ var _localization_czech__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../localization/czech */ "./src/localization/czech.ts");
/* harmony import */ var _localization_danish__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../localization/danish */ "./src/localization/danish.ts");
/* harmony import */ var _localization_dutch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../localization/dutch */ "./src/localization/dutch.ts");
/* harmony import */ var _localization_finnish__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../localization/finnish */ "./src/localization/finnish.ts");
/* harmony import */ var _localization_french__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../localization/french */ "./src/localization/french.ts");
/* harmony import */ var _localization_german__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../localization/german */ "./src/localization/german.ts");
/* harmony import */ var _localization_hebrew__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../localization/hebrew */ "./src/localization/hebrew.ts");
/* harmony import */ var _localization_hungarian__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../localization/hungarian */ "./src/localization/hungarian.ts");
/* harmony import */ var _localization_indonesian__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../localization/indonesian */ "./src/localization/indonesian.ts");
/* harmony import */ var _localization_italian__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../localization/italian */ "./src/localization/italian.ts");
/* harmony import */ var _localization_japanese__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../localization/japanese */ "./src/localization/japanese.ts");
/* harmony import */ var _localization_korean__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../localization/korean */ "./src/localization/korean.ts");
/* harmony import */ var _localization_malay__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../localization/malay */ "./src/localization/malay.ts");
/* harmony import */ var _localization_mongolian__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../localization/mongolian */ "./src/localization/mongolian.ts");
/* harmony import */ var _localization_norwegian__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../localization/norwegian */ "./src/localization/norwegian.ts");
/* harmony import */ var _localization_persian__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../localization/persian */ "./src/localization/persian.ts");
/* harmony import */ var _localization_polish__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../localization/polish */ "./src/localization/polish.ts");
/* harmony import */ var _localization_portuguese__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../localization/portuguese */ "./src/localization/portuguese.ts");
/* harmony import */ var _localization_russian__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../localization/russian */ "./src/localization/russian.ts");
/* harmony import */ var _localization_simplified_chinese__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../localization/simplified-chinese */ "./src/localization/simplified-chinese.ts");
/* harmony import */ var _localization_slovak__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../localization/slovak */ "./src/localization/slovak.ts");
/* harmony import */ var _localization_spanish__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../localization/spanish */ "./src/localization/spanish.ts");
/* harmony import */ var _localization_swedish__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../localization/swedish */ "./src/localization/swedish.ts");
/* harmony import */ var _localization_tajik__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../localization/tajik */ "./src/localization/tajik.ts");
/* harmony import */ var _localization_traditional_chinese__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../localization/traditional-chinese */ "./src/localization/traditional-chinese.ts");
/* harmony import */ var _localization_turkish__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../localization/turkish */ "./src/localization/turkish.ts");
/* harmony import */ var _localization_bulgarian__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../localization/bulgarian */ "./src/localization/bulgarian.ts");
//localization































/***/ }),

/***/ "./src/localization/arabic.ts":
/*!************************************!*\
  !*** ./src/localization/arabic.ts ***!
  \************************************/
/*! exports provided: arStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arStrings", function() { return arStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var arStrings = {
    // survey templates
    survey: {
        edit: "تعديل",
        externalHelpLink: "شاهد وتعلم كيف يتم إنشاء إستبيان",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "الرجاء إفلات السؤال هنا من صندوق الأدوات",
        addLogicItem: ".قم بإنشاء قاعدة لتخصيص تدفق الإستبيان",
        copy: "نسخ",
        duplicate: "نسخة طبق الأصل",
        addToToolbox: "إضافة إلى صندوق الأدوات",
        deletePanel: "حذف لوحة",
        deleteQuestion: "حذف سؤال",
        convertTo: "تحويل إلى",
        drag: "إسحب العنصر",
    },
    // Creator tabs
    tabs: {
        preview: "تجربة الإستبيان",
        theme: "المواضيع",
        translation: "Translation",
        designer: "تصميم الإستبيان",
        editor: "JSON Editor",
        logic: "منطق الإستبيان"
    },
    // Question types
    qt: {
        default: "الإفتراضي",
        checkbox: "إختيار من متعدد",
        comment: "تعليق",
        imagepicker: "إنتقاء الصور",
        ranking: "تصنيف",
        image: "صورة",
        dropdown: "قائمة منسدلة",
        tagbox: "قائمة منسدلة متعددة التحديد",
        file: "ملف",
        html: "لغة ترميز النصوص HTML",
        matrix: "مصفوفة (إختيار واحد)",
        matrixdropdown: "مصفوفة (إختيار متعدد)",
        matrixdynamic: "مصفوفة (صفوف ديناميكية)",
        multipletext: "مدخل متعدد",
        panel: "لوحة",
        paneldynamic: "لوحة ديناميكية",
        radiogroup: "إختيار فردي",
        rating: "تقييم",
        text: "مٌدخل فردي",
        boolean: "قيمة منطقية",
        expression: "عملية حسابية (للقرائة فقط)",
        signaturepad: "لوحة توقيع",
        buttongroup: "Button group"
    },
    toolboxCategories: {
        general: "قائمة العام",
        choice: "أسئلة الاختيار",
        text: "أسئلة إدخال النص",
        containers: "حاويات",
        matrix: "أسئلة المصفوفة",
        misc: "متفرقات"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "إفتراضي ({0})",
        survey: "Survey1",
        settings: "Survey Settings",
        settingsTooltip: "Open survey settings",
        surveySettings: "إعدادات الاستطلاع",
        surveySettingsTooltip: "إعدادات الاستطلاع",
        themeSettings: "إعدادات النسق",
        themeSettingsTooltip: "إعدادات النسق",
        showPanel: "إظهار اللوحة",
        hidePanel: "إخفاء اللوحة",
        prevSelected: "Select previous",
        nextSelected: "Select next",
        prevFocus: "التركيز السابق",
        nextFocus: "التركيز التالي",
        surveyTypeName: "الإستبيان",
        pageTypeName: "الصفحة",
        panelTypeName: "اللوحة",
        questionTypeName: "السؤال",
        columnTypeName: "Column",
        addNewPage: "Add New Page",
        moveRight: "Scroll to the Right",
        moveLeft: "Scroll to the Left",
        deletePage: "Delete Page",
        editPage: "Edit Page",
        edit: "التعديل",
        newPageName: "الصفحة",
        newQuestionName: "السؤال",
        newPanelName: "اللوحة",
        newTextItemName: "text",
        defaultV2Theme: "افتراضي",
        modernTheme: "حديث",
        defaultTheme: "الافتراضي (القديم)",
        testSurveyAgain: "Test Survey Again",
        testSurveyWidth: "Survey width: ",
        navigateToMsg: "You had to navigate to:",
        saveSurvey: "Save Survey",
        saveSurveyTooltip: "Save Survey",
        saveTheme: "حفظ السمة",
        saveThemeTooltip: "حفظ السمة",
        jsonHideErrors: "Hide errors",
        jsonShowErrors: "Show errors",
        undo: "Undo",
        redo: "Redo",
        undoTooltip: "Undo last change",
        redoTooltip: "Redo the change",
        showMoreChoices: "استعراض المزيد",
        showLessChoices: "عرض أقل",
        copy: "Copy",
        cut: "Cut",
        paste: "Paste",
        copyTooltip: "Copy selection to clipboard",
        cutTooltip: "Cut selection to clipboard",
        pasteTooltip: "Paste from clipboard",
        options: "Options",
        generateValidJSON: "Generate Valid JSON",
        generateReadableJSON: "Generate Readable JSON",
        toolbox: "Toolbox",
        "property-grid": "Properties",
        toolboxFilteredTextPlaceholder: "اكتب للبحث...",
        toolboxNoResultsFound: "لم يتم العثور على نتائج",
        propertyGridFilteredTextPlaceholder: "Type to search...",
        propertyGridNoResultsFound: "لم يتم العثور على نتائج",
        correctJSON: "Please correct JSON.",
        surveyResults: "Survey Results ",
        surveyResultsTable: "As Table",
        surveyResultsJson: "As JSON",
        resultsTitle: "Question Title",
        resultsName: "Question Name",
        resultsValue: "Answer Value",
        resultsDisplayValue: "Display Value",
        modified: "هناك تعديل جديد",
        saving: "يتم الآن حفظ التغييرات",
        saved: "تم الحفظ",
        propertyEditorError: "خطأ:",
        saveError: "Error! Editor content is not saved.",
        translationPropertyGridTitle: "Language Settings",
        themePropertyGridTitle: "إعدادات النسق",
        translationLanguages: "Languages",
        translationDeleteLanguage: "هل أنت متأكد من أنك ترغب في حذف جميع السلاسل لهذه اللغة؟",
        translationAddLanguage: "Select language to translate",
        translationShowAllStrings: "Show all strings",
        translationShowUsedStringsOnly: "سلاسل مستعملة فقط",
        translationShowAllPages: "Show all pages",
        translationNoStrings: "No strings to translate. Please, change the filter.",
        translationExportToSCVButton: "Export to CSV",
        translationImportFromSCVButton: "Import from CSV",
        translateUsigAI: "ترجمة تلقائية للكل",
        translateUsigAIFrom: "ترجمة من: ",
        translationDialogTitle: "النصوص غير المترجمة",
        translationMergeLocaleWithDefault: "Merge {0} with default locale",
        translationPlaceHolder: "Translation...",
        translationSource: "مصدر: ",
        translationTarget: "هدف: ",
        themeExportButton: "تصدير",
        themeImportButton: "استورد",
        surveyJsonExportButton: "تصدير",
        surveyJsonImportButton: "استورد",
        surveyJsonCopyButton: "نسخ إلى الحافظة",
        themeResetButton: "إعادة تعيين إعدادات النسق إلى الوضع الافتراضي",
        themeResetConfirmation: "هل تريد حقا إعادة تعيين السمة؟ ستفقد جميع تخصيصاتك.",
        themeResetConfirmationOk: "نعم ، إعادة تعيين السمة",
        bold: "Bold",
        italic: "Italic",
        underline: "Underline",
        addNewQuestion: "Add Question",
        selectPage: "Select page...",
        carryForwardChoicesCopied: "يتم نسخ الاختيارات من",
        choicesLoadedFromWebText: "يتم تحميل الاختيارات من خدمة ويب.",
        choicesLoadedFromWebLinkText: "انتقل إلى الإعدادات",
        choicesLoadedFromWebPreviewTitle: "معاينة خيارات الاختيار المحملة",
        htmlPlaceHolder: "محتوى HTML سيكون هنا",
        panelPlaceHolder: "قم بإسقاط السؤال من صندوق الأدوات إلى هنا",
        surveyPlaceHolder: "الاستطلاع فارغ. اسحب عنصرا من صندوق الأدوات أو انقر فوق الزر أدناه.",
        pagePlaceHolder: "الصفحة فارغة. اسحب عنصرا من صندوق الأدوات أو انقر فوق الزر أدناه.",
        imagePlaceHolder: "قم بسحب وإسقاط صورة هنا أو انقر فوق الزر أدناه واختر صورة لتحميلها",
        surveyPlaceHolderMobile: "انقر فوق الزر \"إضافة سؤال\" أدناه لبدء إنشاء النموذج الخاص بك.",
        pagePlaceHolderMobile: "انقر فوق الزر \"إضافة سؤال\" أدناه لإضافة عنصر جديد إلى الصفحة.",
        panelPlaceHolderMobile: "انقر فوق الزر \"إضافة سؤال\" أدناه لإضافة عنصر جديد إلى اللوحة.",
        imagePlaceHolderMobile: "انقر فوق الزر أدناه واختر صورة لتحميلها",
        imageChooseImage: "اختر صورة",
        addNewTypeQuestion: "Add {0}",
        chooseLogoPlaceholder: "[الشعار]",
        choices_Item: "بند ",
        selectFile: "حدد ملفا",
        removeFile: "إزالة الملف",
        lg: {
            addNewItem: "إضافة قاعدة جديدة",
            empty_tab: "قم بإنشاء إرتباط لتخصيص تدفق الإستبيان",
            page_visibilityName: "إظهار (إخفاء) صفحة",
            page_enableName: "تمكين (تعطيل) الصفحة",
            page_requireName: "اجعل الصفحة مطلوبة",
            panel_visibilityName: "إظهار (إخفاء) لوحة",
            panel_enableName: "تفعيل (تعطيل) لوحة",
            panel_requireName: "اجعل الصفحة مطلوبة",
            question_visibilityName: "إظهار (إخفاء) سؤال",
            question_enableName: "تفعيل (تعطيل) سؤال",
            question_requireName: "جعل السؤال إلزامي",
            question_resetValueName: "إعادة تعيين قيمة السؤال",
            question_setValueName: "تعيين قيمة السؤال",
            column_visibilityName: "إظهار (إخفاء) العمود",
            column_enableName: "تمكين (تعطيل) العمود",
            column_requireName: "جعل العمود مطلوبا",
            column_resetValueName: "إعادة تعيين قيمة العمود",
            column_setValueName: "تعيين قيمة العمود",
            trigger_completeName: "أنهي الإستبيان",
            trigger_setvalueName: "تحديد قيمة السؤال",
            trigger_copyvalueName: "نسخ قيمة السؤال",
            trigger_skipName: "التخطي إلى السؤال",
            trigger_runExpressionName: "تشغيل تعبير رياضي مخصص",
            completedHtmlOnConditionName: "نص رسالة شكر مخصصة",
            page_visibilityDescription: "Make the page visible when the logic expression returns true. Otherwise keep it invisible.",
            panel_visibilityDescription: "Make the panel visible when the logic expression returns true. Otherwise keep it invisible.",
            panel_enableDescription: "Make the panel, and all elements inside it, enable when the logic expression returns true. Otherwise keep them disabled.",
            question_visibilityDescription: "Make the question visible when the logic expression returns true. Otherwise keep it invisible.",
            question_enableDescription: "Make the question enable when the logic expression returns true. Otherwise keep it disabled.",
            question_requireDescription: "Question becomes required when the logic expression returns true.",
            trigger_completeDescription: "When the logic expression returns true then the survey becomes completed and an end-user see the 'Thank you page'.",
            trigger_setvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value is set to the selected question.",
            trigger_copyvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value of one selected question is copied to another selected question.",
            trigger_skipDescription: "When the logic expression returns true then the survey skip to / focus the selected question.",
            trigger_runExpressionDescription: "When the logic expression returns true, then the custom expression is performed. You may optionally set this expression result into the selected question",
            completedHtmlOnConditionDescription: "If the logic expression returns true, then the default text for the 'Thank you page' is changed to the given one.",
            itemExpressionText: "عندما التعبير '{0}' رجع قيمة المنطقية صحيح",
            itemEmptyExpressionText: "الإرتباط الجديد لم يحدد",
            page_visibilityText: "جعل الصفحة {0} مرئية",
            panel_visibilityText: "جعل اللوحة {0} مرئية",
            panel_enableText: "جعل اللوحة {0} مفعلة",
            question_visibilityText: "جعل السؤال {0} مرئي",
            question_enableText: "جعل السؤال {0} مفعل",
            question_requireText: "جعل السؤال {0} إلزامي",
            question_resetValueText: "إعادة تعيين قيمة السؤال: {0}",
            question_setValueText: "تعيين قيمة: {1} السؤال: {0}",
            column_visibilityText: "جعل العمود {0} السؤال {1} مرئيا",
            column_enableText: "تمكين {0} عمود السؤال {1}",
            column_requireText: "جعل العمود {0} السؤال {1} مطلوبا",
            column_resetValueText: "إعادة تعيين قيمة الخلية للعمود: {0}",
            column_setValueText: "تعيين قيمة الخلية: {1} إلى العمود: {0}",
            setValueExpressionPlaceholder: " تعبير سيتم تعيين نتيجته للسؤال الهدف.",
            trigger_completeText: "الإستبيان سيصبح مكتمل",
            trigger_setvalueText: "تثبيت إلى السؤال: {0} القيمة {1}",
            trigger_setvalueEmptyText: "قيمة سؤال واضحة: {0}",
            trigger_copyvalueText: "النسخ إلى السؤال: {0} القيمة القادمة من السؤال {1}",
            trigger_skipText: "التخطي إلى السؤال {0}",
            trigger_runExpressionText1: "شغل التعبير الرياضي '{0}'",
            trigger_runExpressionText2: " وثبت نتيجتها إلى السؤال {0}",
            completedHtmlOnConditionText: "عرض نص رسال 'صفحة شكر' مخصصة",
            showAllQuestions: "عرض كل الأسئلة",
            showAllActionTypes: "عرض كل أنواع الإجراءات",
            conditions: "Condition(s)",
            actions: "Action(s)",
            expressionEditorTitle: "تعريف شرط(إشتراطات)",
            actionsEditorTitle: "تعريف إجراء (إجراءات)",
            deleteAction: "حذف الإجراء",
            addNewAction: "إضافة إجراء جديد",
            selectedActionCaption: "حدد الإجراء لأضافته",
            expressionInvalid: "التعبير المنطقي الرياضي فارغ أو غير صحيح، يرجى تصحيحه",
            noActionError: "الرجاء، إضافة إجراء واحد على الأقل",
            actionInvalid: "الرجاء، إصلاح الأخطاء في الإجراء التابع لك",
            uncompletedRule_title: "القواعد المنطقية غير مكتملة",
            uncompletedRule_text: "لم تكمل بعض القواعد المنطقية. إذا تركت علامة التبويب الآن ، فستفقد التغييرات. هل ما زلت تريد مغادرة علامة التبويب دون إكمال التغييرات؟",
            uncompletedRule_apply: "نعم",
            uncompletedRule_cancel: "لا، أريد إكمال القواعد"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "اسم اللوحة",
            title: "عنوان اللوحة",
            description: "وصف اللوحة",
            visibleIf: "اجعل اللوحة مرئية إذا",
            requiredIf: "اجعل اللوحة مطلوبة إذا",
            questionsOrder: "ترتيب الأسئلة داخل اللوحة",
            page: "الصفحة الرئيسية",
            startWithNewLine: "عرض اللوحة على سطر جديد",
            state: "حالة انهيار اللوحة",
            width: "عرض اللوحة المضمنة",
            minWidth: "الحد الأدنى لعرض اللوحة",
            maxWidth: "الحد الأقصى لعرض اللوحة",
            showNumber: "لوحات الأرقام"
        },
        paneldynamic: {
            name: "اسم اللوحة",
            title: "عنوان اللوحة",
            description: "وصف اللوحة",
            visibleIf: "اجعل اللوحة مرئية إذا",
            requiredIf: "اجعل اللوحة مطلوبة إذا",
            page: "نقل اللوحة إلى الصفحة",
            startWithNewLine: "عرض اللوحة على سطر جديد",
            state: "حالة انهيار اللوحة",
            width: "عرض اللوحة المضمنة",
            minWidth: "الحد الأدنى لعرض اللوحة",
            maxWidth: "الحد الأقصى لعرض اللوحة",
            confirmDelete: "تأكيد حذف اللوحة",
            templateDescription: "نمط وصف اللوحة",
            templateTitle: "نمط عنوان اللوحة",
            noEntriesText: "نص لوحة فارغ",
            templateTabTitle: "نمط عنوان علامة التبويب",
            tabTitlePlaceholder: "العنصر النائب لعنوان علامة التبويب",
            templateVisibleIf: "اجعل لوحة فردية مرئية إذا",
            hideNumber: "إخفاء رقم اللوحة",
            titleLocation: "محاذاة عنوان اللوحة",
            descriptionLocation: "محاذاة وصف اللوحة",
            templateTitleLocation: "محاذاة عنوان السؤال",
            templateErrorLocation: "محاذاة رسالة الخطأ",
            newPanelPosition: "موقع لوحة جديد",
            keyName: "منع تكرار الردود في السؤال التالي"
        },
        question: {
            name: "اسم السؤال",
            title: "عنوان السؤال",
            description: "وصف السؤال",
            visibleIf: "اجعل السؤال مرئيا إذا",
            requiredIf: "اجعل السؤال مطلوبا إذا",
            page: "الصفحة الرئيسية",
            state: "حالة طي مربع الأسئلة",
            hideNumber: "إخفاء رقم السؤال",
            titleLocation: "محاذاة عنوان السؤال",
            descriptionLocation: "محاذاة وصف السؤال",
            errorLocation: "محاذاة رسالة الخطأ",
            indent: "زيادة المسافة البادئة الداخلية",
            width: "عرض السؤال المضمن",
            minWidth: "الحد الأدنى لعرض السؤال",
            maxWidth: "الحد الأقصى لعرض السؤال",
            textUpdateMode: "تحديث قيمة حقل الإدخال"
        },
        signaturepad: {
            signatureWidth: "عرض منطقة التوقيع",
            signatureHeight: "ارتفاع منطقة التوقيع",
            signatureAutoScaleEnabled: "تغيير حجم منطقة التوقيع تلقائيا",
            showPlaceholder: "إظهار العنصر النائب",
            placeholder: "نص العنصر النائب",
            placeholderReadOnly: "نص العنصر النائب في وضع القراءة فقط أو المعاينة",
            allowClear: "إظهار الزر مسح داخل منطقة التوقيع",
            penMinWidth: "الحد الأدنى لعرض القلم",
            penMaxWidth: "الحد الأقصى لعرض القلم",
            penColor: "لون الحد"
        },
        comment: {
            rows: "ارتفاع حقل الإدخال (في الأسطر)"
        },
        showQuestionNumbers: "إظهار أرقام الأسئلة",
        questionStartIndex: "فهرس بداية الأسئلة (1،2 أو 'أ' ، 'ب')",
        expression: {
            name: "اسم التعبير",
            title: "عنوان التعبير",
            description: "وصف التعبير",
            expression: "تعبير"
        },
        trigger: {
            expression: "تعبير"
        },
        calculatedvalue: {
            expression: "تعبير"
        },
        // survey templates
        survey: {
            title: "عنوان",
            description: "وصف المسح"
        },
        page: {
            name: "اسم الصفحة",
            title: "عنوان",
            description: "وصف الصفحة",
            visibleIf: "اجعل الصفحة مرئية إذا",
            requiredIf: "اجعل الصفحة مطلوبة إذا",
            maxTimeToFinish: "الحد الزمني لإنهاء الصفحة (بالثواني)",
            questionsOrder: "ترتيب الأسئلة على الصفحة"
        },
        matrixdropdowncolumn: {
            name: "اسم العمود",
            title: "عنوان العمود",
            isUnique: "منع الردود المكررة",
            width: "عرض العمود",
            minWidth: "الحد الأدنى لعرض العمود",
            rows: "ارتفاع حقل الإدخال (في الأسطر)",
            visibleIf: "اجعل العمود مرئيا إذا",
            requiredIf: "اجعل العمود مطلوبا إذا",
            showInMultipleColumns: "كل خيار في عمود منفصل"
        },
        multipletextitem: {
            name: "اسم",
            title: "عنوان"
        },
        masksettings: {
            saveMaskedValue: "حفظ القيمة المقنعة في نتائج الاستطلاع"
        },
        patternmask: {
            pattern: "نمط القيمة"
        },
        datetimemask: {
            min: "الحد الأدنى للقيمة",
            max: "القيمة القصوى"
        },
        numericmask: {
            allowNegativeValues: "السماح بالقيم السالبة",
            thousandsSeparator: "فاصل الآلاف",
            decimalSeparator: "فاصل عشري",
            precision: "دقة القيمة",
            min: "الحد الأدنى للقيمة",
            max: "القيمة القصوى"
        },
        currencymask: {
            prefix: "بادئة العملة",
            suffix: "لاحقة العملة"
        },
        imageHeight: "طول الصورة",
        imageWidth: "عرض الصورة",
        valueName: "اسم القيمة",
        rateDescriptionLocation: "محاذاة التسمية",
        size: "حجم حقل الإدخال (بالأحرف)",
        cellErrorLocation: "محاذاة رسالة خطأ الخلية",
        apply: "تطبيق",
        ok: "موافق",
        save: "حفظ",
        clear: "مسح",
        saveTooltip: "حفظ",
        cancel: "إلغاء",
        set: "تثبيت",
        reset: "Reset",
        change: "تغيير",
        refresh: "Refresh",
        close: "إغلاق",
        delete: "حذف",
        add: "إضافة",
        addNew: "إضافة إرتباط جديد",
        addItem: "Click to add an item...",
        removeItem: "Click to remove the item...",
        dragItem: "Drag the item",
        addOther: "Other",
        addSelectAll: "Select All",
        addNone: "None",
        removeAll: "Remove All",
        edit: "التعديل",
        back: "Return without saving",
        backTooltip: "Return without saving",
        saveAndBack: "Save and return",
        saveAndBackTooltip: "Save and return",
        doneEditing: "إضافة",
        editChoices: "Edit Choices",
        showChoices: "Show Choices",
        move: "Move",
        empty: "<empty>",
        emptyValue: "القيمة فارغة",
        fastEntry: "إدخالات سريعة",
        fastEntryNonUniqueError: "Value '{0}' is not unique",
        fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}",
        fastEntryChoicesMinCountError: "الرجاء إدخال {0} العناصر على الأقل",
        fastEntryPlaceholder: "يمكنك تعيين البيانات بالتنسيق التالي:\nالقيمة1|النص\nقيمة2",
        formEntry: "Form Entry",
        testService: "Test the service",
        itemSelectorEmpty: "Please select the element",
        conditionActionEmpty: "Please select the action",
        conditionSelectQuestion: "إختر السؤال...",
        conditionSelectPage: "Select page...",
        conditionSelectPanel: "Select panel...",
        conditionValueQuestionTitle: "Please enter/select the value",
        aceEditorHelp: "Press ctrl+space to get expression completion hint",
        aceEditorRowTitle: "Current row",
        aceEditorPanelTitle: "Current panel",
        showMore: "For more details please check the documentation",
        assistantTitle: "Available questions:",
        cellsEmptyRowsColumns: "There is should be at least one column or row",
        showPreviewBeforeComplete: "معاينة الإجابات قبل إرسال الاستطلاع",
        overridingPropertyPrefix: "تم تعيينه بواسطة ",
        resetToDefaultCaption: "اعاده تعيين",
        propertyIsEmpty: "Please enter a value",
        propertyIsNoUnique: "Please enter a unique value",
        propertyNameIsNotUnique: "Please enter a unique name",
        propertyNameIsIncorrect: "لا تستخدم الكلمات المحجوزة: \"عنصر\" ، \"اختيار\" ، \"لوحة\" ، \"صف\".",
        listIsEmpty: "No items have been added yet",
        "listIsEmpty@choices": "لم تتم إضافة أي خيارات حتى الآن",
        "listIsEmpty@columns": "ليس لديك أي أعمدة حتى الآن",
        "listIsEmpty@rows": "ليس لديك أي صفوف حتى الآن",
        "listIsEmpty@validators": "ليس لديك أي قواعد تحقق حتى الآن",
        "listIsEmpty@calculatedValues": "ليس لديك أي متغيرات مخصصة حتى الآن",
        "listIsEmpty@triggers": "ليس لديك أي محفزات حتى الآن",
        "listIsEmpty@navigateToUrlOnCondition": "ليس لديك أي روابط حتى الآن",
        "addNew@choices": "إضافة خيار",
        "addNew@columns": "إضافة عمود جديد",
        "addNew@rows": "إضافة صف جديد",
        "addNew@validators": "إضافة قاعدة جديدة",
        "addNew@calculatedValues": "إضافة متغير جديد",
        "addNew@triggers": "إضافة مشغل جديد",
        "addNew@navigateToUrlOnCondition": "إضافة عنوان URL جديد",
        expressionIsEmpty: "Expression is empty",
        value: "القيمة",
        text: "النص",
        rowid: "Row ID",
        imageLink: "رابط الصورة",
        columnEdit: "Edit column: {0}",
        itemEdit: "Edit item: {0}",
        url: "رابط إلكتروني URL",
        path: "المسار",
        choicesbyurl: {
            url: "عنوان URL لخدمة الويب",
            valueName: "الحصول على قيم من حقل JSON التالي"
        },
        titleName: "اسم العنوان",
        imageLinkName: "اسم رابط الصورة",
        allowEmptyResponse: "السماح بجواب فارغ",
        titlePlaceholder: "Input title here",
        surveyTitlePlaceholder: "أدخل عنوان الإستبيان هنا",
        pageTitlePlaceholder: "أدخل عنوان الصفحة هنا",
        descriptionPlaceholder: "Enter a description",
        surveyDescriptionPlaceholder: "أدخل وصف للإستبيان",
        pageDescriptionPlaceholder: "أدخل وصف للصفحة",
        textWrapEnabled: "خيارات الالتفاف",
        showOtherItem: "هل هناك خيار أخرى",
        otherText: "نص خيار أخرى",
        showNoneItem: "هل هناك خيار بلا",
        showRefuseItem: "السماح بخيار رفض الإجابة",
        showDontKnowItem: "السماح بالخيار \"لا أعرف\"",
        noneText: "نص خيار بلا",
        showSelectAllItem: "هل هناك خيار إختيار الكل",
        selectAllText: "نص خيار إختر الكل",
        choicesMin: "Minimum value for auto generated items",
        choicesMax: "Maximum value for auto generated items",
        choicesStep: "The difference between auto generated items",
        name: "الإسم",
        title: "العنوان",
        cellType: "نوع الخلية",
        colCount: "عدد الأعمدة",
        choicesOrder: "إختر ترتيب الإختيارات",
        visible: "مرئي؟",
        isRequired: "مطلوب؟",
        markRequired: "وضع علامة كمطلوب",
        removeRequiredMark: "إزالة العلامة المطلوبة",
        isAllRowRequired: "المطالبة بالأجوبة لكل الصفوف",
        eachRowUnique: "منع تكرار الاستجابات في الصفوف",
        requiredErrorText: "نص خطأ إلزامي السؤال",
        startWithNewLine: "إظهار السؤال في صف جديد",
        rows: "عدد الصفوف",
        cols: "عدد الأعمدة",
        placeholder: "نص حامل خانة الإدخال",
        showPreview: "عرض منطقة المعاينة",
        storeDataAsText: "تخزين محتويات ملف JSON كنص",
        maxSize: "أقصى حجم للملف بالبايت",
        rowCount: "عدد الصفوف",
        columnLayout: "تخطيط الأعمدة",
        addRowLocation: "موقع زر إضافة صف",
        transposeData: "تبديل موضع الصفوف إلى أعمدة",
        addRowText: "نص زر إضافة صف",
        removeRowText: "نص زر حذف صف",
        rateMin: "أصغر معدل",
        rateMax: "أكبر معدل",
        rateStep: "خطوات المعدل",
        minRateDescription: "وصف أصغر معدل",
        maxRateDescription: "وصف أكبر معدل",
        inputType: "نوع المدخل",
        optionsCaption: "خيارات الشرح",
        defaultValue: "القيمة الإفتراضية",
        cellsDefaultRow: "Default cells texts",
        surveyEditorTitle: "Edit survey settings",
        qEditorTitle: "Edit: {0}",
        maxLength: "أقصى طول",
        buildExpression: "Build",
        editExpression: "التعديل",
        and: "و",
        or: "أو",
        remove: "إزالة",
        addCondition: "أضف الشرط",
        emptyLogicPopupMessage: "حدد سؤالا لبدء تكوين الشروط.",
        if: "إذا قيمة",
        then: "ثم",
        setToName: "إلى",
        fromName: "from",
        gotoName: "سؤال للتخطي إليه",
        ruleIsNotSet: "Rule is incorrect",
        includeIntoResult: "تضمين نتائج الاستطلاع",
        showTitle: "إظهار/إخفاء العنوان",
        expandCollapseTitle: "Expand/collapse title",
        locale: "اللغة الإفتراضية",
        simulator: "Choose device",
        landscapeOrientation: "Landscape",
        portraitOrientation: "Portrait",
        mode: "النمط (التعديل، القرائة فقط)",
        clearInvisibleValues: "إمسح القيم الغير مرئية",
        cookieName: "أدخل إسم ملف تعريف الإرتباط (لتعطيل المشاركة بالإستبيان أكثر من مرة)",
        sendResultOnPageNext: "إرسال نتائج الإستبيان على الصفحة التالية",
        storeOthersAsComment: "تخزين قيمة 'أخرى' في حقل منفصل",
        showPageTitles: "عرض عنوان الصفحات",
        showPageNumbers: "عرض أرقام الصفحات",
        pagePrevText: "نص زر الإنتقال للصفحة السابقة",
        pageNextText: "نص زر الإنتقال للصفحة التالية",
        completeText: "نص زر إنهاء الإستبيان",
        previewText: "نص زر المعاينة",
        editText: "نص زر التعديل",
        startSurveyText: "نص زر بدء المشاركة بالإستبيان",
        showNavigationButtons: "إظهار أزرار الإنتقال (التنقل الإفتراضي)",
        showPrevButton: "إظهار زر التنقل السابق (السماح للمستخدم من العودة للصفحة السابقة في الإستبيان)",
        firstPageIsStarted: "الصفحة الأولى في الإستبيان هي صفحة البدء",
        showCompletedPage: "إظهار الصفحة المكتملة في النهاية (صفحة ويب مكتملة)",
        goNextPageAutomatic: "عند الإجابة على جميع الأسئلة، إنتقل إلى الصفحة التالية تلقائياً",
        allowCompleteSurveyAutomatic: "إكمال الاستطلاع تلقائيا",
        showProgressBar: "إظهار شريط التقدم",
        questionTitleLocation: "موقع عنوان السؤال",
        questionTitleWidth: "عرض عنوان السؤال",
        requiredText: "رمز السؤال مطلوب",
        questionTitleTemplate: "Question title template, default is: '{no}. {require} {title}'",
        questionErrorLocation: "موقع خطأ في السؤال",
        focusFirstQuestionAutomatic: "ركز المؤشر على السؤال الأول عند تغير الصفحة",
        questionsOrder: "ترتيب العناصر على الصفحة",
        maxTimeToFinish: "أقصى وقت لإنهاء الإستبيان",
        maxTimeToFinishPage: "أقصى وقت لإنهاء الصفحة في الإستبيان",
        showTimerPanel: "إظهار لوحة المؤقت",
        showTimerPanelMode: "إظهار نمط لوحة المؤقت",
        renderMode: "نمط العرض",
        allowAddPanel: "السماح بإضافة لوحة",
        allowRemovePanel: "السماح بإزالة لوحة",
        panelAddText: "نص إضافة لوحة",
        panelRemoveText: "نص إزالة لوحة",
        isSinglePage: "Show all elements on one page",
        html: "صفحة ويب HTML",
        setValue: "جواب",
        dataFormat: "تنسيق الصورة",
        allowAddRows: "السماح بإضافة صفوف",
        allowRemoveRows: "السماح بإزالة الصفوف",
        allowRowsDragAndDrop: "السماح بسحب الصف وإفلاته",
        responsiveImageSizeHelp: "لا ينطبق إذا قمت بتحديد عرض الصورة أو ارتفاعها بالضبط.",
        minImageWidth: "الحد الأدنى لعرض الصورة",
        maxImageWidth: "الحد الأقصى لعرض الصورة",
        minImageHeight: "الحد الأدنى لارتفاع الصورة",
        maxImageHeight: "الحد الأقصى لارتفاع الصورة",
        minValue: "أقل قيمة",
        maxValue: "أكبر قيمة",
        minLength: "Minimum length",
        allowDigits: "Allow digits",
        minCount: "Minimum count",
        maxCount: "Maximum count",
        regex: "Regular expression",
        surveyvalidator: {
            text: "رسالة خطأ",
            expression: "تعبير التحقق من الصحة"
        },
        totalText: "Total text",
        totalType: "Total type",
        totalExpression: "Total expression",
        totalDisplayStyle: "Total display style",
        totalCurrency: "Total currency",
        totalFormat: "Total format",
        logo: "الشعار (عنوان URL أو سلسلة مشفرة base64)",
        questionsOnPageMode: "هيكل المسح",
        maxTextLength: "الحد الأقصى لطول الإجابة (بالأحرف)",
        maxOthersLength: "الحد الأقصى لطول التعليق (بالأحرف)",
        commentAreaRows: "ارتفاع منطقة التعليق (في الأسطر)",
        autoGrowComment: "توسيع منطقة التعليق تلقائيا إذا لزم الأمر",
        allowResizeComment: "السماح للمستخدمين بتغيير حجم مناطق النص",
        textUpdateMode: "تحديث قيمة السؤال النصي",
        maskType: "نوع قناع الإدخال",
        maskTypes: {
            none: "اي",
            patternmask: "رسم",
            numericmask: "عددي",
            datetimemask: "التاريخ والوقت",
            currencymask: "عملة"
        },
        focusOnFirstError: "تعيين التركيز على أول إجابة غير صالحة",
        checkErrorsMode: "تشغيل التحقق من الصحة",
        navigateToUrl: "انتقل إلى عنوان URL",
        navigateToUrlOnCondition: "عنوان URL الديناميكي",
        completedBeforeHtml: "الترميز لإظهار ما إذا كان المستخدم قد ملأ هذا الاستطلاع بالفعل",
        completedHtml: "ترميز صفحة الاستطلاع الكامل",
        completedHtmlOnCondition: "الاستطلاع الديناميكي إكمال ترميز الصفحة",
        loadingHtml: "الترميز لإظهاره أثناء تحميل نموذج الاستطلاع",
        commentText: "نص منطقة التعليق",
        autocomplete: "نوع الإكمال التلقائي",
        labelTrue: "تسمية \"صحيح\"",
        labelFalse: "تسمية \"خطأ\"",
        allowClear: "Show options caption",
        searchMode: "وضع البحث",
        displayStyle: "نمط عرض القيمة",
        format: "سلسلة منسقة",
        maximumFractionDigits: "الحد الأقصى للأرقام الكسرية",
        minimumFractionDigits: "الحد الأدنى من الأرقام الكسرية",
        useGrouping: "عرض فواصل التجميع",
        allowMultiple: "السماح بملفات متعددة",
        allowImagesPreview: "معاينة الصور",
        acceptedTypes: "أنواع الملفات المقبولة",
        waitForUpload: "انتظر حتى يكتمل التحميل",
        needConfirmRemoveFile: "تأكيد حذف الملف",
        detailPanelMode: "موقع لوحة التفاصيل",
        minRowCount: "الحد الأدنى لعدد الصفوف",
        maxRowCount: "الحد الأقصى لعدد الصفوف",
        confirmDelete: "تأكيد حذف الصف",
        confirmDeleteText: "رسالة تأكيد",
        panelCount: "عدد اللوحات الأولي",
        minPanelCount: "الحد الأدنى لعدد اللوحات",
        maxPanelCount: "الحد الأقصى لعدد اللوحات",
        panelsState: "حالة توسيع اللوحة الداخلية",
        panelPrevText: "تلميح أداة زر اللوحة السابق",
        panelNextText: "تلميح أداة زر اللوحة التالية",
        showRangeInProgress: "إظهار شريط التقدم",
        panelRemoveButtonLocation: "إزالة موقع زر اللوحة",
        hideIfRowsEmpty: "إخفاء السؤال إذا لم تكن هناك صفوف",
        hideColumnsIfEmpty: "إخفاء الأعمدة في حالة عدم وجود صفوف",
        rateValues: "قيم الأسعار المخصصة",
        rateCount: "عدد الأسعار",
        autoGenerate: "كيفية تحديد قيم المعدل؟",
        hideIfChoicesEmpty: "إخفاء السؤال إذا لم يكن يحتوي على خيارات",
        minWidth: "الحد الأدنى للعرض (بالقيم المقبولة في CSS)",
        maxWidth: "الحد الأقصى للعرض (بالقيم المقبولة من CSS)",
        width: "العرض (بالقيم المقبولة من CSS)",
        showHeader: "إظهار رؤوس الأعمدة",
        horizontalScroll: "إظهار شريط التمرير الأفقي",
        columnMinWidth: "الحد الأدنى لعرض العمود (بالقيم المقبولة من CSS)",
        rowTitleWidth: "عرض رأس الصف (بالقيم المقبولة من CSS)",
        valueTrue: "القيمة \"الحقيقية\"",
        valueFalse: "قيمة \"خاطئة\"",
        minErrorText: "رسالة الخطأ \"القيمة أقل من الحد الأدنى\"",
        maxErrorText: "رسالة الخطأ \"القيمة تتجاوز الحد الأقصى\"",
        otherErrorText: "رسالة الخطأ \"تعليق فارغ\"",
        keyDuplicationError: "رسالة الخطأ \"قيمة مفتاح غير فريدة\"",
        minSelectedChoices: "الحد الأدنى من الخيارات المحددة",
        maxSelectedChoices: "الحد الأقصى للخيارات المحددة",
        showClearButton: "إظهار الزر مسح",
        logoWidth: "عرض الشعار (بالقيم المقبولة من CSS)",
        logoHeight: "ارتفاع الشعار (بالقيم المقبولة من CSS)",
        readOnly: "للقراءة فقط",
        enableIf: "قابل للتحرير إذا",
        emptyRowsText: "رسالة \"بلا صفوف\"",
        separateSpecialChoices: "خيارات خاصة منفصلة (لا شيء، أخرى، تحديد الكل)",
        choicesFromQuestion: "نسخ الاختيارات من السؤال التالي",
        choicesFromQuestionMode: "ما هي الخيارات التي تريد نسخها؟",
        progressBarShowPageTitles: "عرض عناوين الصفحات في شريط التقدم",
        progressBarShowPageNumbers: "عرض أرقام الصفحات في شريط التقدم",
        showCommentArea: "إظهار منطقة التعليق",
        commentPlaceholder: "العنصر النائب لمنطقة التعليق",
        displayRateDescriptionsAsExtremeItems: "عرض أوصاف المعدل كقيم قصوى",
        rowsOrder: "ترتيب الصفوف",
        columnsLayout: "تخطيط العمود",
        columnColCount: "عدد الأعمدة المتداخلة",
        correctAnswer: "الإجابة الصحيحة",
        defaultPanelValue: "القيم الافتراضية",
        cells: "نصوص الخلية",
        fileInputPlaceholder: "حدد ملفا أو الصق رابط ملف...",
        keyName: "عمود المفتاح",
        itemvalue: {
            visibleIf: "اجعل الخيار مرئيا إذا",
            enableIf: "اجعل الخيار قابلا للتحديد إذا"
        },
        "itemvalue@rows": {
            visibleIf: "اجعل الصف مرئيا إذا",
            enableIf: "اجعل الصف قابلا للتحرير إذا"
        },
        imageitemvalue: {
            text: "نص بديل"
        },
        logoPosition: "Logo position",
        addLogo: "Add logo...",
        changeLogo: "Change logo...",
        logoPositions: {
            none: "حذف الشعار",
            left: "يسار",
            right: "يمين",
            top: "في الأعلى",
            bottom: "في الأسفل"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "تخطيط اللوحة"
            },
            general: "عام",
            fileOptions: "الخيارات",
            html: "Html Editor",
            columns: "الأعمدة",
            rows: "الصفوف",
            choices: "الخيارات",
            items: "العناصر",
            visibleIf: "مرئي عندما",
            enableIf: "مفعل عندما",
            requiredIf: "مطلوب عندما",
            rateValues: "قيم التقييم",
            choicesByUrl: "خيارات من الإنترنت",
            matrixChoices: "Default Choices",
            multipleTextItems: "Text Inputs",
            numbering: "الترقيم",
            validators: "المدققات",
            navigation: "التنقل",
            question: "السؤال",
            pages: "الصفحات",
            timer: "مؤقت/إختبار قصير",
            calculatedValues: "Calculated Values",
            triggers: "Triggers",
            templateTitle: "عنوان القالب",
            totals: "Totals",
            logic: "المنطق",
            mask: "إعدادات قناع الإدخال",
            layout: {
                panel: "تخطيط",
                question: "تخطيط",
                base: "تخطيط"
            },
            data: "البيانات",
            validation: "التحقق",
            cells: "الخلايا",
            showOnCompleted: "عند الإنتهاء من الإستبيان",
            logo: "الشعار في عنوان الإستبيان",
            slider: "Slider",
            expression: "تعبير",
            questionSettings: "إعدادات السؤال",
            header: "راس",
            background: "خلفية",
            appearance: "مظهر",
            others: "غير ذلك"
        },
        editProperty: "Edit property '{0}'",
        items: "Items",
        choicesVisibleIf: "تكون الخيارات مرئية إذا",
        choicesEnableIf: "يمكن تحديد الخيارات إذا",
        columnsEnableIf: "تكون الأعمدة مرئية إذا",
        rowsEnableIf: "تكون الصفوف مرئية إذا",
        innerIndent: "إضافة مسافات بادئة داخلية",
        defaultValueFromLastRow: "خذ القيم الافتراضية من الصف الأخير",
        defaultValueFromLastPanel: "خذ القيم الافتراضية من اللوحة الأخيرة",
        enterNewValue: "Please, enter the value.",
        noquestions: "There is no any question in the survey.",
        createtrigger: "Please create a trigger",
        titleKeyboardAdornerTip: "Press enter button to edit",
        keyboardAdornerTip: "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item",
        triggerOn: "On ",
        triggerMakePagesVisible: "Make pages visible:",
        triggerMakeQuestionsVisible: "Make elements visible:",
        triggerCompleteText: "Complete the survey if succeed.",
        triggerNotSet: "The trigger is not set",
        triggerRunIf: "Run if",
        triggerSetToName: "Change value of: ",
        triggerFromName: "Copy value from: ",
        triggerRunExpression: "Run this Expression:",
        triggerSetValue: "to: ",
        triggerGotoName: "Go to the question:",
        triggerIsVariable: "Do not put the variable into the survey result.",
        triggerRunExpressionEmpty: "Please enter a valid expression",
        emptyExpressionPlaceHolder: "اكتب التعبير هنا...",
        noFile: "No file choosen",
        clearIfInvisible: "مسح القيمة إذا أصبح السؤال مخفيا",
        valuePropertyName: "اسم خاصية القيمة",
        searchEnabled: "تمكين البحث",
        hideSelectedItems: "إخفاء العناصر المحددة",
        closeOnSelect: "أغلق القائمة المنسدلة بعد التحديد",
        verticalAlign: "المحاذاة الرأسية",
        alternateRows: "صفوف بديلة",
        columnsVisibleIf: "تكون الأعمدة مرئية إذا",
        rowsVisibleIf: "تكون الصفوف مرئية إذا",
        otherPlaceholder: "العنصر النائب لمنطقة التعليق",
        filePlaceholder: "نص العنصر النائب للملف",
        photoPlaceholder: "نص العنصر النائب للصورة",
        fileOrPhotoPlaceholder: "نص العنصر النائب للملف أو الصورة",
        rateType: "نوع السعر",
        url_placeholder: "مثال: https://api.example.com/books",
        path_placeholder: "مثال: فئات.خيال",
        questionStartIndex_placeholder: "مثال: أ)",
        width_placeholder: "مثال: 6 بوصة",
        minWidth_placeholder: "مثال: 600px",
        maxWidth_placeholder: "مثال: 50٪",
        imageHeight_placeholder: "تلقائي",
        imageWidth_placeholder: "تلقائي",
        theme: {
            themeName: "موضوع",
            isPanelless: "مظهر السؤال",
            editorPanel: "الخلفية ونصف قطر الزاوية",
            questionPanel: "الخلفية ونصف قطر الزاوية",
            primaryColor: "لون التمييز",
            panelBackgroundTransparency: "عتامة خلفية اللوحة",
            questionBackgroundTransparency: "عتامة خلفية السؤال",
            fontSize: "حجم الخط",
            scale: "مِيزَان",
            cornerRadius: "نصف قطر الزاوية",
            pageTitle: "خط العنوان",
            pageDescription: "خط الوصف",
            questionTitle: "خط العنوان",
            questionDescription: "خط الوصف",
            editorFont: "الخط",
            backgroundOpacity: "العتامه",
            "--sjs-font-family": "عائلة الخط",
            "--sjs-general-backcolor-dim": "لون الخلفية",
            "--sjs-primary-backcolor": "خلفية لهجة",
            "--sjs-primary-forecolor": "لهجة الصدارة",
            "--sjs-special-red": "رسائل الخطأ",
            "--sjs-shadow-small": "تأثيرات الظل",
            "--sjs-shadow-inner": "تأثيرات الظل",
            "--sjs-border-default": "الوان"
        },
        "header@header": {
            headerView: "منظر",
            logoPosition: "موضع الشعار",
            surveyTitle: "خط عنوان الاستطلاع",
            surveyDescription: "خط وصف الاستطلاع",
            headerTitle: "خط عنوان الاستطلاع",
            headerDescription: "خط وصف الاستطلاع",
            inheritWidthFrom: "عرض منطقة المحتوى",
            textAreaWidth: "عرض النص",
            backgroundColorSwitch: "لون الخلفية",
            backgroundImage: "صورة الخلفية",
            backgroundImageOpacity: "العتامه",
            overlapEnabled: "التداخل",
            logoPositionX: "موضع الشعار",
            titlePositionX: "موضع العنوان",
            descriptionPositionX: "موقف الوصف"
        }
    },
    // Property values
    pv: {
        "true": "صحيح",
        "false": "خطأ",
        file: "الملفات المحلية",
        camera: "كاميرا",
        "file-camera": "الملفات المحلية أو الكاميرا",
        inherit: "يَرث",
        show: "إظهار",
        hide: "إخفاء",
        default: "الإفتراضي",
        initial: "مبدئي",
        random: "عشوائي",
        collapsed: "مقلص",
        expanded: "موسع",
        none: "بلا",
        asc: "تصاعدي",
        desc: "تنازلي",
        indeterminate: "غير محدد",
        selected: "المحدد",
        unselected: "محدد",
        decimal: "عشري",
        currency: "عملة",
        percent: "المائه",
        firstExpanded: "توسيع أول لوح",
        off: "إيقاف",
        list: "قائمة",
        progressTop: "التقدم بالأعلى",
        progressBottom: "التقدم بالأسف",
        progressTopBottom: "التقدم بالأعلى والأسفل معاً",
        tab: "علامات التبويب",
        horizontal: "عرضي",
        vertical: "عمودي",
        top: "الأعلى",
        bottom: "الأسفل",
        topBottom: "الاعلى والأسفل",
        both: "الكل",
        left: "يسار",
        right: "يمين",
        center: "مركز",
        leftRight: "اليسار واليمين",
        middle: "وسط",
        color: "لون",
        date: "تاريخ",
        datetime: "التاريخ والوقت",
        "datetime-local": "التاريخ والوقت-محلي",
        email: "البريد الإلكتروني",
        month: "شهر",
        number: "رقم",
        password: "شعار",
        range: "نطاق",
        tel: "هاء.",
        text: "نص",
        time: "الوقت",
        url: "الرابط",
        week: "أسبوع",
        hidden: "مخفي",
        edit: "التعديل",
        display: "العرض",
        contain: "احتوى",
        cover: "غطاء",
        fill: "ملء",
        next: "مقبل",
        last: "آخر",
        onComplete: "عند الإنتهاء",
        onHidden: "عند الإخفال",
        onHiddenContainer: "عند إخفاء الحاوية",
        clearInvisibleValues: {
            none: "أبدا"
        },
        clearIfInvisible: {
            none: "أبدا"
        },
        inputType: {
            color: "لون",
            date: "تاريخ",
            "datetime-local": "التاريخ والوقت",
            email: "البريد الإلكتروني",
            month: "شهر",
            number: "رقم",
            password: "شعار",
            range: "نطاق",
            tel: "رقم الهاتف",
            text: "نص",
            time: "الوقت",
            url: "الرابط",
            week: "أسبوع"
        },
        all: "الكل",
        page: "الصفحة",
        survey: "الإستبيان",
        onNextPage: "عند الإنتقال للصفحة التالية",
        onValueChanged: "إذا تغيرت القيمة",
        onValueChanging: "عند تغيير القيمة",
        questionsOnPageMode: {
            standard: "الهيكل الأصلي",
            singlePage: "إظهار جميع الأسئلة في صفحة واحدة",
            questionPerPage: "إظهار سؤال واحد لكل صفحة"
        },
        noPreview: "بلا عرض",
        showAllQuestions: "المعاينة مع جميع الأسئلة",
        showAnsweredQuestions: "المعاينة مع الأسئلة المجٌابة",
        pages: "الصفحات",
        questions: "الأسئلة",
        requiredQuestions: "الأسئلة المطلوبة",
        correctQuestions: "الإجابات الصحيحة",
        buttons: "الأزرار",
        underInput: "أسفل خانة الإدخال",
        underTitle: "أعلى العنوان",
        onBlur: "عند الطمس",
        onTyping: "عند الكتابة",
        underRow: "تحت الصف",
        underRowSingle: "أسفل الصف ، تكون لوحة واحدة فقط مرئية",
        auto: "تلقائي",
        showNavigationButtons: {
            none: "مخفي"
        },
        showTimerPanel: {
            none: "مخفي"
        },
        showTimerPanelMode: {
            all: "كلا"
        },
        addRowLocation: {
            default: "يعتمد على تخطيط المصفوفة"
        },
        panelsState: {
            default: "لا يمكن للمستخدمين توسيع اللوحات أو طيها",
            collapsed: "جميع اللوحات مطوية",
            expanded: "يتم توسيع جميع اللوحات",
            firstExpanded: "توسعت لأول مرة"
        },
        widthMode: {
            static: "ثابت",
            responsive: "متجاوب"
        },
        contentMode: {
            image: "صورة",
            video: "فيديو",
            youtube: "يوتيوب"
        },
        displayMode: {
            buttons: "ازرار",
            dropdown: "القائمة المنسدلة"
        },
        rateColorMode: {
            default: "افتراضي",
            scale: "مِيزَان"
        },
        scaleColorMode: {
            monochrome: "أحادي اللون",
            colored: "الملونه"
        },
        autoGenerate: {
            "true": "ولد",
            "false": "أدخل يدويا"
        },
        rateType: {
            labels: "تسميات",
            stars: "النجوم",
            smileys: "الوجوه الضاحكة"
        },
        state: {
            default: "مقفل"
        },
        showQuestionNumbers: {
            default: "الترقيم التلقائي",
            on: "الترقيم التلقائي",
            onPage: "إعادة تعيين على كل صفحة",
            onpanel: "إعادة تعيين على كل لوحة",
            onPanel: "إعادة تعيين على كل لوحة",
            onSurvey: "المتابعة عبر الاستطلاع",
            off: "لا ترقيم"
        },
        descriptionLocation: {
            underTitle: "تحت عنوان السؤال",
            underInput: "ضمن حقل الإدخال"
        },
        selectToRankAreasLayout: {
            horizontal: "بجانب الخيارات",
            vertical: "الخيارات أعلاه"
        },
        displayStyle: {
            decimal: "عشري",
            currency: "عملة",
            percent: "النسبه المئويه",
            date: "تاريخ"
        },
        totalDisplayStyle: {
            decimal: "عشري",
            currency: "عملة",
            percent: "النسبه المئويه",
            date: "تاريخ"
        },
        rowsOrder: {
            initial: "اللغة الأصلية"
        },
        questionsOrder: {
            initial: "اللغة الأصلية"
        },
        showProgressBar: {
            off: "مخفي",
            topbottom: "الاعلى والأسفل",
            aboveheader: "فوق الرأس",
            belowheader: "أسفل الرأس"
        },
        sum: "مجموع",
        count: "عد",
        min: "دقيقه",
        max: "ماكس",
        avg: "متوسط",
        searchMode: {
            contains: "يحتوي",
            startsWith: "يبدأ ب"
        },
        backgroundImageFit: {
            auto: "تلقائي",
            cover: "غطاء",
            contain: "احتوى",
            fill: "مد",
            tile: "بلاط"
        },
        backgroundImageAttachment: {
            fixed: "ثابت",
            scroll: "طومار"
        },
        headerView: {
            basic: "أساسي",
            advanced: "متقدم"
        },
        inheritWidthFrom: {
            survey: "نفس المسح",
            container: "يصلح للحاوية"
        },
        backgroundColorSwitch: {
            none: "اي",
            accentColor: "لون التمييز",
            custom: "تقليد"
        },
        colorPalette: {
            light: "ضوء",
            dark: "داكن"
        },
        isPanelless: {
            "false": "افتراضي",
            "true": "بدون لوحات"
        }
    },
    // Operators
    op: {
        empty: "فارغة",
        notempty: "ليست فارغة",
        equal: "تساوي",
        notequal: "لا تساوي",
        contains: "تحتوي",
        notcontains: "لا تحتوي",
        anyof: "أي من",
        allof: "كلاً من",
        greater: "أكبر",
        less: "أقل",
        greaterorequal: "أكبر أو يساوي",
        lessorequal: "أقل أو يساوي",
        and: "و",
        or: "أو"
    },
    // Embed window
    ew: {
        angular: "Use Angular version",
        jquery: "Use jQuery version",
        knockout: "Use Knockout version",
        react: "Use React version",
        vue: "Use Vue version",
        bootstrap: "For bootstrap framework",
        modern: "Modern theme",
        default: "Default theme",
        orange: "Orange theme",
        darkblue: "Darkblue theme",
        darkrose: "Darkrose theme",
        stone: "Stone theme",
        winter: "Winter theme",
        winterstone: "Winter-Stone theme",
        showOnPage: "Show survey on a page",
        showInWindow: "Show survey in a window",
        loadFromServer: "Load Survey JSON from server",
        titleScript: "Scripts and styles",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Select the page to test it:",
        showInvisibleElements: "إظهار العناصر المخفية",
        hideInvisibleElements: "إخفاء العناصر غير المرئية"
    },
    validators: {
        answercountvalidator: "answer count",
        emailvalidator: "بريد إلكتروني",
        expressionvalidator: "عملية حسابية",
        numericvalidator: "رقمية",
        regexvalidator: "تعبير رياضي",
        textvalidator: "النص"
    },
    triggers: {
        completetrigger: "إنهاء الإستبيان",
        setvaluetrigger: "تحديد قيمة",
        copyvaluetrigger: "نسخ قيمة",
        skiptrigger: "الإنتقال إلى سؤال",
        runexpressiontrigger: "تشغيل العملية الحسابية",
        visibletrigger: "تغيير الرؤية (مهمل)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "مثال: +1 (999) -999-99-99"
        },
        datetimemask: {
            pattern: "مثال: مم / يوم / سنة"
        },
        currencymask: {
            prefix: "مثال: $",
            suffix: "مثال: الدولار الأمريكي"
        },
        panelbase: {
            questionTitleWidth: "مثال: 200 بكسل"
        }
    },
    pehelp: {
        panel: {
            name: "معرف لوحة غير مرئي للمستجيبين.",
            description: "اكتب عنوانا فرعيا للوحة.",
            visibleIf: "استخدم أيقونة العصا السحرية لضبط قاعدة شرطية تحدد رؤية اللوحة.",
            enableIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تعطل وضع القراءة فقط للوحة.",
            requiredIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تمنع إرسال الاستطلاع ما لم يكن لسؤال واحد متداخل على الأقل إجابة.",
            questionTitleLocation: "ينطبق على جميع الأسئلة داخل هذه اللجنة. إذا كنت تريد إلغاء هذا الإعداد، فحدد قواعد محاذاة العنوان للأسئلة الفردية. يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع (\"أعلى\" افتراضيا).",
            questionTitleWidth: "يعين عرضا متناسقا لعناوين الأسئلة عندما تتم محاذاتها إلى يسار مربعات الأسئلة الخاصة بها. يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ).",
            questionErrorLocation: "تعيين موقع رسالة خطأ فيما يتعلق بجميع الأسئلة داخل اللوحة. يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع.",
            questionsOrder: "يحافظ على الترتيب الأصلي للأسئلة أو يحولها عشوائيا. يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع.",
            page: "تغيير موضع اللوحة إلى نهاية الصفحة المحددة.",
            innerIndent: "يضيف مسافة أو هامش بين محتوى اللوحة والحد الأيسر لمربع اللوحة.",
            startWithNewLine: "قم بإلغاء التحديد لعرض اللوحة في سطر واحد مع السؤال أو اللوحة السابقة. لا ينطبق الإعداد إذا كانت اللوحة هي العنصر الأول في النموذج الخاص بك.",
            state: "اختر من بين: \"موسعة\" - يتم عرض اللوحة بالكامل ويمكن طيها ؛ \"مطوي\" - تعرض اللوحة العنوان والوصف فقط ويمكن توسيعها ؛ \"مغلق\" - يتم عرض اللوحة بالكامل ولا يمكن طيها.",
            width: "يضبط عرض اللوحة بما يتناسب مع عناصر الاستطلاع الأخرى في نفس السطر. يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ)."
        },
        paneldynamic: {
            name: "معرف لوحة غير مرئي للمستجيبين.",
            description: "اكتب عنوانا فرعيا للوحة.",
            visibleIf: "استخدم أيقونة العصا السحرية لضبط قاعدة شرطية تحدد رؤية اللوحة.",
            enableIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تعطل وضع القراءة فقط للوحة.",
            requiredIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تمنع إرسال الاستطلاع ما لم يكن لسؤال واحد متداخل على الأقل إجابة.",
            templateTitleLocation: "ينطبق على جميع الأسئلة داخل هذه اللجنة. إذا كنت تريد إلغاء هذا الإعداد، فحدد قواعد محاذاة العنوان للأسئلة الفردية. يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع (\"أعلى\" افتراضيا).",
            templateErrorLocation: "تعيين موقع رسالة خطأ فيما يتعلق بسؤال بإدخال غير صالح. اختر بين: \"أعلى\" - يتم وضع نص خطأ في أعلى مربع السؤال ؛ \"أسفل\" - يتم وضع نص خطأ في أسفل مربع السؤال. يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع (\"أعلى\" افتراضيا).",
            errorLocation: "تعيين موقع رسالة خطأ فيما يتعلق بجميع الأسئلة داخل اللوحة. يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع.",
            page: "تغيير موضع اللوحة إلى نهاية الصفحة المحددة.",
            innerIndent: "يضيف مسافة أو هامش بين محتوى اللوحة والحد الأيسر لمربع اللوحة.",
            startWithNewLine: "قم بإلغاء التحديد لعرض اللوحة في سطر واحد مع السؤال أو اللوحة السابقة. لا ينطبق الإعداد إذا كانت اللوحة هي العنصر الأول في النموذج الخاص بك.",
            state: "اختر من بين: \"موسعة\" - يتم عرض اللوحة بالكامل ويمكن طيها ؛ \"مطوي\" - تعرض اللوحة العنوان والوصف فقط ويمكن توسيعها ؛ \"مغلق\" - يتم عرض اللوحة بالكامل ولا يمكن طيها.",
            width: "يضبط عرض اللوحة بما يتناسب مع عناصر الاستطلاع الأخرى في نفس السطر. يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ).",
            templateTitle: "اكتب قالبا لعناوين اللوحات الديناميكية. استخدم {panelIndex} للموضع العام لللوحة و {visiblePanelIndex} لترتيبها بين اللوحات المرئية. قم بإدراج هذه العناصر النائبة في النموذج لإضافة ترقيم تلقائي.",
            templateTabTitle: "اكتب قالبا لعناوين علامات التبويب. استخدم {panelIndex} للموضع العام للوحة و {visiblePanelIndex} لترتيبها بين اللوحات المرئية. قم بإدراج هذه العناصر النائبة في النموذج لإضافة ترقيم تلقائي.",
            tabTitlePlaceholder: "نص احتياطي لعناوين علامات التبويب يتم تطبيقه عندما لا ينتج نمط عنوان علامة التبويب قيمة ذات معنى.",
            templateVisibleIf: "يتيح لك هذا الإعداد التحكم في رؤية اللوحات الفردية داخل اللوحة الديناميكية. استخدم العنصر النائب \"{panel}\" للإشارة إلى اللوحة الحالية في تعبيرك.",
            titleLocation: "يتم توريث هذا الإعداد تلقائيا من خلال جميع الأسئلة داخل هذه اللوحة. إذا كنت تريد إلغاء هذا الإعداد، فحدد قواعد محاذاة العنوان للأسئلة الفردية. يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع (\"أعلى\" افتراضيا).",
            descriptionLocation: "يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع (\"تحت عنوان اللوحة\" افتراضيا).",
            newPanelPosition: "يحدد موضع اللوحة المضافة حديثا. بشكل افتراضي ، تتم إضافة لوحات جديدة إلى النهاية. حدد \"التالي\" لإدراج لوحة جديدة بعد اللوحة الحالية.",
            defaultValueFromLastPanel: "يضاعف الإجابات من اللوحة الأخيرة ويعينها إلى اللوحة الديناميكية المضافة التالية.",
            keyName: "قم بالإشارة إلى اسم سؤال لمطالبة المستخدم بتقديم إجابة فريدة لهذا السؤال في كل لوحة."
        },
        defaultValueExpression: "يسمح لك هذا الإعداد بتعيين قيمة إجابة افتراضية استنادا إلى تعبير. يمكن أن يتضمن التعبير حسابات أساسية - '{q1_id} + {q2_id}' ، والتعبيرات المنطقية ، مثل '{age} > 60' ، والدوالات: 'iif ()' ، 'today ()' ، 'age ()' ، 'min ()' ، 'max ()' ، 'avg ()' ، إلخ. تعمل القيمة التي يحددها هذا التعبير كقيمة افتراضية أولية يمكن تجاوزها بواسطة الإدخال اليدوي للمستجيب.",
        resetValueIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تحدد متى تتم إعادة تعيين إدخال المستجيب إلى القيمة استنادا إلى \"تعبير القيمة الافتراضية\" أو \"تعيين تعبير القيمة\" أو إلى قيمة \"الإجابة الافتراضية\" (إذا تم تعيين أي منهما).",
        setValueIf: "استخدم رمز العصا السحرية لتعيين قاعدة شرطية تحدد وقت تشغيل \"تعيين تعبير القيمة\" وتعيين القيمة الناتجة ديناميكيا كاستجابة.",
        setValueExpression: "حدد تعبيرا يحدد القيمة المراد تعيينها عند استيفاء الشروط الواردة في قاعدة \"تعيين القيمة إذا\". يمكن أن يتضمن التعبير حسابات أساسية - '{q1_id} + {q2_id}' ، والتعبيرات المنطقية ، مثل '{age} > 60' ، والدوالات: 'iif ()' ، 'today ()' ، 'age ()' ، 'min ()' ، 'max ()' ، 'avg ()' ، إلخ. يمكن تجاوز القيمة التي يحددها هذا التعبير بواسطة الإدخال اليدوي للمستجيب.",
        question: {
            name: "معرف سؤال غير مرئي للمستجيبين.",
            description: "اكتب عنوانا فرعيا للسؤال.",
            visibleIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تحدد رؤية السؤال.",
            enableIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تعطل وضع القراءة فقط للسؤال.",
            requiredIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تمنع تقدم الاستطلاع أو إرساله ما لم يتلق السؤال إجابة.",
            startWithNewLine: "قم بإلغاء التحديد لعرض السؤال في سطر واحد مع السؤال أو اللوحة السابقة. لا ينطبق الإعداد إذا كان السؤال هو العنصر الأول في النموذج الخاص بك.",
            page: "تغيير موضع السؤال إلى نهاية الصفحة المحددة.",
            state: "اختر من بين: \"موسع\" - يتم عرض مربع السؤال بالكامل ويمكن طيه ؛ \"مطوي\" - يعرض مربع الأسئلة العنوان والوصف فقط ويمكن توسيعه ؛ \"مقفل\" - يتم عرض مربع الأسئلة بالكامل ولا يمكن طيه.",
            titleLocation: "يتجاوز قواعد محاذاة العنوان المحددة على مستوى اللوحة أو الصفحة أو الاستطلاع. يطبق خيار \"الوراثة\" أي إعدادات ذات مستوى أعلى (إذا تم تعيينها) أو إعداد على مستوى الاستطلاع (\"أعلى\" افتراضيا).",
            descriptionLocation: "يطبق خيار \"الوراثة\" الإعداد على مستوى الاستطلاع (\"ضمن عنوان السؤال\" افتراضيا).",
            errorLocation: "تعيين موقع رسالة خطأ فيما يتعلق بالسؤال مع إدخال غير صالح. اختر بين: \"أعلى\" - يتم وضع نص خطأ في أعلى مربع السؤال ؛ \"أسفل\" - يتم وضع نص خطأ في أسفل مربع السؤال. يطبق خيار \"الوراثة\" إعداد مستوى الاستطلاع (\"أعلى\" افتراضيا).",
            indent: "إضافة مسافة أو هامش بين محتوى السؤال والحد الأيسر لمربع السؤال.",
            width: "يضبط عرض السؤال بما يتناسب مع عناصر الاستطلاع الأخرى في نفس السطر. يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ).",
            surveyvalidator: {
                expression: "استخدم أيقونة العصا السحرية لتعيين قاعدة التحقق من صحة السؤال."
            },
            textUpdateMode: "اختر من بين: \"عند فقدان التركيز\" - يتم تحديث القيمة عندما يفقد حقل الإدخال التركيز ؛ \"أثناء الكتابة\" - يتم تحديث القيمة في الوقت الفعلي ، حيث يكتب المستخدمون. يطبق خيار \"الوراثة\" إعداد مستوى الاستطلاع (\"عند فقدان التركيز\" افتراضيا).",
            url: "يمكنك استخدام أي خدمة ويب كمصدر بيانات لأسئلة الاختيار من متعدد. لتعبئة قيم الاختيار، أدخل عنوان URL للخدمة التي توفر البيانات.",
            searchMode: "عملية مقارنة تستخدم لتصفية القائمة المنسدلة.",
            textWrapEnabled: "ستنشئ النصوص الطويلة في خيارات الاختيار فواصل أسطر تلقائيا لتلائم القائمة المنسدلة. قم بإلغاء تحديد ما إذا كنت تريد قص النصوص."
        },
        signaturepad: {
            signatureWidth: "يضبط عرض مساحة التوقيع المعروضة والصورة الناتجة.",
            signatureHeight: "يضبط ارتفاع مساحة التوقيع المعروضة والصورة الناتجة.",
            signatureAutoScaleEnabled: "حدد ما إذا كنت تريد أن تملأ منطقة التوقيع كل المساحة المتوفرة داخل مربع السؤال مع الحفاظ على نسبة العرض إلى الارتفاع الافتراضية 3:2. عند تعيين قيم العرض والارتفاع المخصصة، سيحتفظ الإعداد بنسبة العرض إلى الارتفاع لهذه الأبعاد."
        },
        file: {
            imageHeight: "يضبط ارتفاع الصورة في نتائج الاستطلاع.",
            imageWidth: "يضبط عرض الصورة في نتائج الاستطلاع."
        },
        image: {
            contentMode: "يحدد الخيار \"تلقائي\" تلقائيا الوضع المناسب للعرض - الصورة أو الفيديو أو YouTube - بناء على عنوان URL المصدر المقدم."
        },
        imagepicker: {
            imageHeight: "يتخطى قيم الحد الأدنى والحد الأقصى للارتفاع.",
            imageWidth: "يتخطى قيم الحد الأدنى والحد الأقصى للعرض.",
            choices: "تعمل \"القيمة\" كمعرف عنصر مستخدم في القواعد الشرطية ؛ يتم عرض \"النص\" للمستجيبين.",
            contentMode: "اختر بين \"صورة\" و \"فيديو\" لتعيين وضع المحتوى لمحدد الوسائط. إذا تم تحديد \"صورة\" ، فتأكد من أن جميع الخيارات المتوفرة هي ملفات صور بالتنسيقات التالية: JPEG و GIF و PNG و APNG و SVG و BMP و ICO. وبالمثل ، إذا تم تحديد \"فيديو\" ، فتأكد من أن جميع الخيارات هي روابط مباشرة لملفات الفيديو بالتنسيقات التالية: MP4 و MOV و WMV و FLV و AVI و MKV. يرجى ملاحظة أن روابط YouTube غير مدعومة لخيارات الفيديو."
        },
        text: {
            size: "يغير هذا الإعداد حجم حقل الإدخال فقط ولا يؤثر على عرض مربع السؤال. للحد من طول الإدخال المقبول، انتقل إلى <b>التحقق من الصحة → الحد الأقصى لعدد الأحرف</b>."
        },
        comment: {
            rows: "يضبط عدد الأسطر المعروضة في حقل الإدخال. إذا كان الإدخال يشغل المزيد من الأسطر ، فسيظهر شريط التمرير."
        },
        // survey templates
        survey: {
            mode: "اختر بين: \"قابل للتحرير\" - يمكن المستجيبين من ملء الاستبيان الخاص بك ؛ \"للقراءة فقط\" - تعطيل تحرير النموذج."
        },
        matrixdropdowncolumn: {
            name: "معرف عمود غير مرئي للمستجيبين.",
            isUnique: "عند تمكين عمود، يطلب من المستجيب تقديم إجابة فريدة لكل سؤال داخل هذا العمود.",
            rows: "يضبط عدد الأسطر المعروضة في حقل الإدخال. إذا كان الإدخال يشغل المزيد من الأسطر ، فسيظهر شريط التمرير.",
            visibleIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تحدد رؤية العمود.",
            enableIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تعطل وضع القراءة فقط للعمود.",
            requiredIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تمنع إرسال الاستطلاع ما لم يكن لسؤال واحد متداخل على الأقل إجابة.",
            showInMultipleColumns: "عند تحديده، ينشئ عمود منفرد لكل خيار اختيار."
        },
        widthMode: "اختر من بين: \"ثابت\" - يحدد عرضا ثابتا ؛ \"متجاوب\" - يجعل الاستطلاع يشغل العرض الكامل للشاشة ؛ \"تلقائي\" - ينطبق على أي من الاثنين اعتمادا على أنواع الأسئلة المستخدمة.",
        cookieName: "تمنع ملفات تعريف الارتباط المستخدمين من ملء نفس الاستبيان مرتين.",
        logo: "الصق رابط صورة (بلا حدود للحجم) أو انقر فوق رمز المجلد لاستعراض ملف من جهاز الكمبيوتر الخاص بك (حتى 64 كيلوبايت).",
        logoWidth: "يضبط عرض الشعار بوحدات CSS (px ، ٪ ، in ، pt ، إلخ).",
        logoHeight: "يضبط ارتفاع الشعار في وحدات CSS (px ، ٪ ، in ، pt ، إلخ).",
        logoFit: "اختر من بين: \"لا شيء\" - تحافظ الصورة على حجمها الأصلي ؛ \"احتواء\" - يتم تغيير حجم الصورة لتلائم مع الحفاظ على نسبة العرض إلى الارتفاع ؛ \"الغلاف\" - تملأ الصورة المربع بأكمله مع الحفاظ على نسبة العرض إلى الارتفاع ؛ \"تعبئة\" - يتم تمديد الصورة لملء المربع دون الحفاظ على نسبة العرض إلى الارتفاع.",
        goNextPageAutomatic: "حدد ما إذا كنت تريد أن يتقدم الاستطلاع إلى الصفحة التالية تلقائيا بعد أن يجيب المستجيب على جميع الأسئلة في الصفحة الحالية.",
        allowCompleteSurveyAutomatic: "حدد ما إذا كنت تريد إكمال الاستطلاع تلقائيا بعد أن يجيب المستجيب على جميع الأسئلة.",
        showNavigationButtons: "يضبط رؤية وموقع أزرار التنقل على الصفحة.",
        showProgressBar: "يضبط رؤية شريط التقدم وموقعه. تعرض القيمة \"تلقائي\" شريط التقدم أعلى رأس الاستطلاع أو أسفله.",
        showPreviewBeforeComplete: "قم بتمكين صفحة المعاينة مع جميع الأسئلة أو الإجابة عليها فقط.",
        questionTitleLocation: "ينطبق على جميع الأسئلة داخل الاستطلاع. يمكن تجاوز هذا الإعداد من خلال قواعد محاذاة العنوان في المستويات الأدنى: اللوحة أو الصفحة أو السؤال. سيتجاوز إعداد المستوى الأدنى تلك الموجودة في المستوى الأعلى.",
        requiredText: "رمز أو سلسلة من الرموز تشير إلى أن الإجابة مطلوبة.",
        questionStartIndex: "أدخل رقما أو حرفا تريد بدء الترقيم به.",
        questionErrorLocation: "تعيين موقع رسالة خطأ فيما يتعلق بالسؤال مع إدخال غير صالح. اختر بين: \"أعلى\" - يتم وضع نص خطأ في أعلى مربع السؤال ؛ \"أسفل\" - يتم وضع نص خطأ في أسفل مربع السؤال.",
        focusFirstQuestionAutomatic: "حدد ما إذا كنت تريد أن يكون حقل الإدخال الأول في كل صفحة جاهزا لإدخال النص.",
        questionsOrder: "يحافظ على الترتيب الأصلي للأسئلة أو يحولها عشوائيا. يكون تأثير هذا الإعداد مرئيا فقط في علامة التبويب معاينة.",
        maxTextLength: "لأسئلة إدخال النص فقط.",
        maxOthersLength: "لتعليقات الأسئلة فقط.",
        commentAreaRows: "يضبط عدد الأسطر المعروضة في مساحات النص لتعليقات الأسئلة. في الإدخال يأخذ المزيد من الأسطر ، يظهر شريط التمرير.",
        autoGrowComment: "حدد ما إذا كنت تريد زيادة تعليقات الأسئلة وأسئلة النص الطويل تلقائيا في الارتفاع بناء على طول النص الذي تم إدخاله.",
        allowResizeComment: "لتعليقات الأسئلة وأسئلة النص الطويل فقط.",
        calculatedValues: "تعمل المتغيرات المخصصة كمتغيرات وسيطة أو مساعدة تستخدم في حسابات النماذج. يأخذون مدخلات المستجيبين كقيم مصدر. كل متغير مخصص له اسم فريد وتعبير يعتمد عليه.",
        includeIntoResult: "حدد ما إذا كنت ترغب في حفظ القيمة المحسوبة للتعبير مع نتائج الاستطلاع.",
        triggers: "المشغل هو حدث أو شرط يستند إلى تعبير. بمجرد تقييم التعبير إلى \"صواب\" ، يطلق المشغل إجراء. يمكن أن يكون لمثل هذا الإجراء اختياريا سؤال مستهدف يؤثر عليه.",
        clearInvisibleValues: "اختر ما إذا كنت تريد مسح قيم الأسئلة المخفية بواسطة المنطق الشرطي ومتى تريد القيام بذلك أم لا.",
        textUpdateMode: "اختر من بين: \"عند فقدان التركيز\" - يتم تحديث القيمة عندما يفقد حقل الإدخال التركيز ؛ \"أثناء الكتابة\" - يتم تحديث القيمة في الوقت الفعلي ، حيث يكتب المستخدمون.",
        columns: "تعمل القيمة اليسرى كمعرف عمود مستخدم في القواعد الشرطية ، ويتم عرض القيمة الصحيحة للمستجيبين.",
        rows: "تعمل القيمة اليسرى كمعرف صف مستخدم في القواعد الشرطية ، ويتم عرض القيمة الصحيحة للمستجيبين.",
        columnMinWidth: "يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ).",
        rowTitleWidth: "يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ).",
        totalText: "تكون مرئية فقط عندما يحتوي عمود واحد على الأقل على نوع الإجمالي أو تعبير الإجمالي.",
        cellErrorLocation: "تعيين موقع رسالة خطأ فيما يتعلق بخلية ذات إدخال غير صالح. يطبق خيار \"الوراثة\" الإعداد من خاصية \"محاذاة رسالة الخطأ\".",
        keyDuplicationError: "عند تمكين الخاصية \"منع الاستجابات المكررة\"، سيتلقى مستجيب يحاول إرسال إدخال مكرر رسالة الخطأ التالية.",
        totalExpression: "يسمح لك بحساب القيم الإجمالية استنادا إلى تعبير. يمكن أن يتضمن التعبير العمليات الحسابية الأساسية ('{q1_id} + {q2_id}') والتعبيرات المنطقية ('{age} > 60') والوظائف ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', إلخ).",
        confirmDelete: "يؤدي إلى تشغيل مطالبة تطلب تأكيد حذف الصف.",
        defaultValueFromLastRow: "يكرر الإجابات من الصف الأخير ويعينها إلى الصف الديناميكي المضاف التالي.",
        keyName: "إذا كان العمود المحدد يحتوي على قيم متطابقة ، فإن الاستطلاع يلقي الخطأ \"قيمة مفتاح غير فريدة\".",
        description: "اكتب عنوانا فرعيا.",
        locale: "اختر لغة لبدء إنشاء الاستطلاع. لإضافة ترجمة، قم بالتبديل إلى لغة جديدة وترجمة النص الأصلي هنا أو في علامة التبويب الترجمات.",
        detailPanelMode: "يضبط موقع قسم التفاصيل بالنسبة إلى صف. اختر من بين: \"لا شيء\" - لم تتم إضافة أي توسيع ؛ \"تحت الصف\" - يتم وضع توسيع الصف تحت كل صف من المصفوفة ؛ \"أسفل الصف ، اعرض توسيع صف واحد فقط\" - يتم عرض توسيع أسفل صف واحد فقط ، ويتم طي توسعات الصف المتبقية.",
        imageFit: "اختر من بين: \"لا شيء\" - تحافظ الصورة على حجمها الأصلي ؛ \"احتواء\" - يتم تغيير حجم الصورة لتلائم مع الحفاظ على نسبة العرض إلى الارتفاع ؛ \"الغلاف\" - تملأ الصورة المربع بأكمله مع الحفاظ على نسبة العرض إلى الارتفاع ؛ \"تعبئة\" - يتم تمديد الصورة لملء المربع دون الحفاظ على نسبة العرض إلى الارتفاع.",
        autoGrow: "يزيد تدريجيا من ارتفاع حقل الإدخال أثناء إدخال البيانات. يتجاوز إعداد \"ارتفاع حقل الإدخال (في الأسطر)\".",
        allowResize: "يظهر مقبض تغيير الحجم (أو المقبض) في الزاوية ويمكن سحبه لتغيير حجم حقل الإدخال.",
        maxTimeToFinish: "فاصل زمني بالثواني وبعد ذلك يتقدم الاستطلاع تلقائيا إلى صفحة الشكر.",
        maxTimeToFinishPage: "فاصل زمني بالثواني يتقدم بعده الاستطلاع تلقائيا إلى الصفحة التالية.",
        page: {
            maxTimeToFinish: "فاصل زمني بالثواني يتقدم بعده الاستطلاع تلقائيا إلى الصفحة التالية.",
            visibleIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تحدد رؤية الصفحة.",
            enableIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تعطل وضع القراءة فقط للصفحة.",
            requiredIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تمنع إرسال الاستطلاع ما لم يكن لسؤال واحد متداخل على الأقل إجابة.",
            questionTitleLocation: "ينطبق على جميع الأسئلة الواردة في هذه الصفحة. إذا كنت تريد إلغاء هذا الإعداد، فحدد قواعد محاذاة العنوان للأسئلة أو اللوحات الفردية. يطبق خيار \"الوراثة\" إعداد مستوى الاستطلاع (\"أعلى\" افتراضيا).",
            questionTitleWidth: "يعين عرضا متناسقا لعناوين الأسئلة عندما تتم محاذاتها إلى يسار مربعات الأسئلة الخاصة بها. يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ).",
            questionErrorLocation: "تعيين موقع رسالة خطأ فيما يتعلق بالسؤال مع إدخال غير صالح. اختر بين: \"أعلى\" - يتم وضع نص خطأ في أعلى مربع السؤال ؛ \"أسفل\" - يتم وضع نص خطأ في أسفل مربع السؤال. يطبق خيار \"الوراثة\" إعداد مستوى الاستطلاع (\"أعلى\" افتراضيا).",
            questionsOrder: "يحافظ على الترتيب الأصلي للأسئلة أو يحولها عشوائيا. يطبق خيار \"الوراثة\" إعداد مستوى الاستطلاع (\"أصلي\" افتراضيا). يكون تأثير هذا الإعداد مرئيا فقط في علامة التبويب معاينة.",
            navigationButtonsVisibility: "يضبط رؤية أزرار التنقل على الصفحة. يطبق خيار \"الوراثة\" إعداد مستوى الاستطلاع ، والذي يتم تعيينه افتراضيا على \"مرئي\"."
        },
        showTimerPanel: "يضبط رؤية وموقع المؤقت على الصفحة.",
        panelsState: "اختر من بين: \"مقفل\" - لا يمكن للمستخدمين توسيع اللوحات أو طيها ؛ \"طي الكل\" - تبدأ جميع اللوحات في حالة انهيار ؛ \"توسيع الكل\" - تبدأ جميع اللوحات في حالة موسعة ؛ \"تم توسيعه أولا\" - تم توسيع اللوحة الأولى فقط في البداية.",
        imageLinkName: "أدخل اسم خاصية مشتركة ضمن صفيف الكائنات التي تحتوي على عناوين URL لملفات الصور أو الفيديو التي تريد عرضها في قائمة الاختيارات.",
        choices: "تعمل القيمة اليسرى كمعرف عنصر مستخدم في القواعد الشرطية ، ويتم عرض القيمة الصحيحة للمستجيبين.",
        title: "اكتب عنوانا سهل الاستخدام لعرضه.",
        waitForUpload: "يضمن عدم إكمال المستخدمين للاستطلاع حتى يتم تحميل الملفات.",
        minWidth: "يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ).",
        maxWidth: "يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ).",
        width: "يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ).",
        valueName: "إذا لم تقم بتعيين هذه الخاصية، تخزين الإجابة في حقل محدد بواسطة خاصية الاسم.",
        useDisplayValuesInDynamicTexts: "في أنواع الأسئلة ذات التحديد الفردي والمتعدد، يكون لكل خيار اختيار معرف وقيمة عرض. عند تحديده، يعرض هذا الإعداد قيمة عرض بدلا من قيمة معرف في أسئلة HTML والعناوين الديناميكية وأوصاف عناصر الاستطلاع.",
        clearIfInvisible: "اختر ما إذا كنت تريد مسح قيم الأسئلة المخفية بواسطة المنطق الشرطي أم لا ومتى تفعل ذلك. يطبق خيار \"الوراثة\" إعداد مستوى الاستطلاع (\"عند اكتمال الاستطلاع\" افتراضيا).",
        choicesFromQuestionMode: "اختر من بين: \"الكل\" - نسخ جميع خيارات الاختيار من السؤال المحدد ؛ \"محدد\" - ينسخ ديناميكيا خيارات الاختيار المحددة فقط ؛ \"غير محدد\" - ينسخ ديناميكيا خيارات الاختيار غير المحددة فقط. يتم نسخ الخيارين \"بلا\" و \"أخرى\" افتراضيا إذا تم تمكينهما في السؤال المصدر.",
        showOtherItem: "عند تحديده، يمكن للمستخدمين تضمين مدخلات إضافية في مربع تعليق منفصل.",
        separateSpecialChoices: "يعرض كل خيار اختيار خاص (\"بلا\" ، \"أخرى\" ، \"تحديد الكل\") على سطر جديد ، حتى عند استخدام تخطيط متعدد الأعمدة.",
        path: "حدد الموقع داخل مجموعة بيانات الخدمة حيث يوجد الصفيف الهدف من الكائنات. اتركه فارغا إذا كان عنوان URL يشير بالفعل إلى المصفوفة.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "أدخل اسم خاصية موحد ضمن صفيف الكائنات الذي يحتوي على القيم التي تريد عرضها في قائمة الاختيارات.",
        allowEmptyResponse: "حدد للسماح للخدمة بإرجاع استجابة أو صفيف فارغ.",
        choicesVisibleIf: "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تحدد رؤية كل خيارات الاختيار.",
        rateValues: "تعمل القيمة اليسرى كمعرف عنصر مستخدم في القواعد الشرطية ، ويتم عرض القيمة الصحيحة للمستجيبين.",
        rating: {
            displayMode: "يختار \"تلقائي\" بين وضعي \"الأزرار\" و \"القائمة المنسدلة\" بناء على العرض المتاح. عندما يكون العرض غير كاف لعرض الأزرار، يعرض السؤال قائمة منسدلة."
        },
        valuePropertyName: "يسمح لك بتوصيل الأسئلة التي تنتج نتائج بتنسيقات مختلفة. عندما يتم ربط هذه الأسئلة معا باستخدام معرف صلة، تخزن هذه الخاصية المشتركة قيم الأسئلة المحددة.",
        searchEnabled: "حدد ما إذا كنت تريد تحديث محتويات القائمة المنسدلة لمطابقة استعلام البحث الذي يكتبه المستخدم في حقل الإدخال.",
        valueTrue: "قيمة يجب حفظها في نتائج الاستطلاع عندما يعطي المستجيبون إجابة إيجابية.",
        valueFalse: "قيمة يجب حفظها في نتائج الاستطلاع عندما يعطي المستجيبون إجابة سلبية.",
        showPreview: "لا يوصى بتعطيل هذا الخيار لأنه يتجاوز صورة المعاينة ويجعل من الصعب على المستخدم فهم ما إذا كان قد تم تحميل الملفات أم لا.",
        needConfirmRemoveFile: "تشغيل مطالبة تطلب تأكيد حذف الملف.",
        selectToRankEnabled: "تمكين لترتيب الخيارات المحددة فقط. سيقوم المستخدمون بسحب العناصر المحددة من قائمة الاختيار لترتيبها داخل منطقة الترتيب.",
        dataList: "أدخل قائمة بالخيارات التي سيتم اقتراحها على المستجيب أثناء الإدخال.",
        itemSize: "يغير الإعداد حجم حقول الإدخال فقط ولا يؤثر على عرض مربع السؤال.",
        itemTitleWidth: "يضبط عرضا متناسقا لكل تسميات العناصر بالبكسل",
        altText: "يعمل كبديل عندما يتعذر عرض الصورة على جهاز المستخدم ولأغراض إمكانية الوصول.",
        rateColorMode: "يحدد لون الرموز التعبيرية المحددة عند تعيين نوع رمز التقييم على \"الوجوه الضاحكة\". اختر بين: \"افتراضي\" - يظهر الرمز التعبيري المحدد بلون الاستطلاع الافتراضي ؛ \"مقياس\" - يرث الرمز التعبيري المحدد اللون من مقياس التصنيف.",
        expression: {
            name: "معرف تعبير غير مرئي للمستجيبين.",
            description: "اكتب عنوانا فرعيا للتعبير.",
            expression: "يمكن أن يتضمن التعبير العمليات الحسابية الأساسية ('{q1_id} + {q2_id}') والشروط ('{age} > 60') والدوال ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', إلخ)."
        },
        storeOthersAsComment: "حدد لتخزين قيمة الخيار \"أخرى\" كخاصية منفصلة في نتائج الاستطلاع.",
        format: "استخدم {0} كعنصر نائب للقيمة الفعلية.",
        acceptedTypes: "يرجى الرجوع إلى وصف السمة [قبول] (https://www.w3schools.com/tags/att_input_accept.asp) للحصول على مزيد من المعلومات.",
        columnColCount: "ينطبق فقط على أنواع خلايا المجموعة الراديوية وخانة الاختيار.",
        autocomplete: "راجع وصف السمة [الإكمال التلقائي] (https://developer.mozilla.org/en-US/docs/Web/HTML/السمات/الإكمال التلقائي) للحصول على مزيد من المعلومات.",
        filePlaceholder: "ينطبق عندما يكون \"نوع المصدر\" هو \"ملفات محلية\" أو عندما تكون الكاميرا غير متوفرة",
        photoPlaceholder: "ينطبق عندما يكون \"نوع المصدر\" هو \"الكاميرا\".",
        fileOrPhotoPlaceholder: "ينطبق عندما يكون \"نوع المصدر\" هو \"الملفات المحلية أو الكاميرا\".",
        masksettings: {
            saveMaskedValue: "حدد ما إذا كنت تريد تخزين قيمة السؤال باستخدام قناع مطبق في نتائج الاستطلاع."
        },
        patternmask: {
            pattern: "يمكن أن يحتوي النمط على حرفي السلسلة والعناصر النائبة التالية: \"9\" - للرقم ؛ \"a\" - لحرف كبير أو صغير ؛ '#' - لرقم أو حرف كبير أو صغير. استخدم الشرطة المائلة للخلف '\\' للهروب من حرف."
        },
        datetimemask: {
            pattern: "يمكن أن يحتوي النمط على أحرف فاصلة والعناصر النائبة التالية:<br>'m' - رقم الشهر.<br>\"mm\" - رقم الشهر ، مع صفر بادئ للقيم المكونة من رقم واحد. <br>'d' - يوم من الشهر. <br>\"dd\" - يوم من الشهر ، مع صفر بادئ للقيم المكونة من رقم واحد. <br>\"yy\" - آخر رقمين من السنة. <br>\"yyyy\" - سنة مكونة من أربعة أرقام. <br>\"H\" - ساعات بتنسيق 24 ساعة. <br>\"HH\" - ساعات بتنسيق 24 ساعة ، مع صفر بادئ للقيم المكونة من رقم واحد. <br>\"h\" - ساعات بتنسيق 12 ساعة. <br>\"hh\" - ساعات بتنسيق 12 ساعة ، مع صفر بادئ للقيم المكونة من رقم واحد. <br>\"مم\" - دقائق. <br>'ss' - ثواني. <br>\"TT\" - فترة ساعة 12 ساعة بأحرف كبيرة (صباحا / مساء). <br>\"TT\" - فترة ساعة 12 ساعة بأحرف صغيرة (صباحا / مساء)."
        },
        numericmask: {
            decimalSeparator: "رمز يستخدم لفصل الجزء الكسري عن الجزء الصحيح من الرقم المعروض.",
            thousandsSeparator: "رمز يستخدم لفصل أرقام عدد كبير إلى مجموعات من ثلاثة.",
            precision: "يحد من عدد الأرقام التي سيتم الاحتفاظ بها بعد الفاصلة العشرية لرقم معروض."
        },
        currencymask: {
            prefix: "رمز واحد أو عدة رموز ليتم عرضها قبل القيمة.",
            suffix: "رمز واحد أو عدة رموز ليتم عرضها بعد القيمة."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "title",
            title: "Leave it empty, if it is the same as 'Name'"
        },
        multiSelect: "متعدد الإختيار",
        showLabel: "عرض الملصق",
        swapOrder: "مبادلة ترتيب نعم ولا",
        value: "القيمة",
        tabAlign: "محاذاة علامات التبويب",
        sourceType: "نوع المصدر",
        fitToContainer: "يصلح للحاوية",
        setValueExpression: "تعيين تعبير القيمة",
        description: "الوصف",
        logoFit: "تناسب الشعار",
        pages: "الصفحات",
        questions: "الاسئله",
        triggers: "المحفزات",
        calculatedValues: "القيم المحسوبة",
        surveyId: "معرف الاستطلاع",
        surveyPostId: "معرف وظيفة الاستطلاع",
        surveyShowDataSaving: "يظهر الاستطلاع توفير البيانات",
        questionDescriptionLocation: "موقع وصف السؤال",
        progressBarType: "نوع شريط التقدم",
        showTOC: "إظهار جدول المحتويات",
        tocLocation: "موقع جدول المحتويات",
        questionTitlePattern: "تنسيق عنوان السؤال",
        widthMode: "نمط عٌرض الشاشة",
        showBrandInfo: "عرض معلومات العلامة التجارية",
        useDisplayValuesInDynamicTexts: "إستخدم عرض القيم في العنوان",
        visibleIf: "مرئي عندما",
        defaultValueExpression: "العملية الحسابية الإفتراضية",
        requiredIf: "مطلوب عندما",
        resetValueIf: "إعادة تعيين القيمة إذا",
        setValueIf: "تعيين قيمة إذا",
        validators: "المدققات",
        bindings: "الإرتباطات",
        renderAs: "عرض ك",
        attachOriginalItems: "إرفاق العناصر الأصلية",
        choices: "الإختيارات",
        choicesByUrl: "خيار عن طريق رابط إلكتروني URL",
        currency: "currency",
        cellHint: "تلميح الخلية",
        totalMaximumFractionDigits: "إجمالي الحد الأقصى لأرقام الكسور",
        totalMinimumFractionDigits: "إجمالي الحد الأدنى لأرقام الكسور",
        columns: "الأعمدة",
        detailElements: "عناصر التفاصيل",
        allowAdaptiveActions: "السماح بالإجراءات التكيفية",
        defaultRowValue: "قيمة الصف الإفتراضية",
        detailPanelShowOnAdding: "detailPanelShowOnAdding",
        choicesLazyLoadEnabled: "تمكين التحميل البطيء للاختيارات",
        choicesLazyLoadPageSize: "اختيارات كسول تحميل حجم الصفحة",
        inputFieldComponent: "مكون حقل الإدخال",
        itemComponent: "مكون العنصر",
        min: "أقل",
        max: "أكبر",
        minValueExpression: "minValueExpression",
        maxValueExpression: "maxValueExpression",
        step: "step",
        dataList: "قائمة البيانات",
        itemSize: "itemSize",
        itemTitleWidth: "عرض تسمية العنصر (بالبكسل)",
        elements: "عناصر",
        content: "محتوى",
        navigationButtonsVisibility: "رؤية أزرار التنقل",
        navigationTitle: "navigationTitle",
        navigationDescription: "navigationDescription",
        longTap: "نقرة طويلة",
        autoGrow: "تمدد تلقائي",
        allowResize: "السماح بتغيير الحجم",
        acceptCarriageReturn: "قبول إرجاع النقل",
        displayMode: "وضع العرض",
        rateType: "نوع السعر",
        label: "المسمى",
        contentMode: "نمط عرض المحتوى",
        imageFit: "إحتواء الصورة",
        altText: "نص بديل",
        height: "height",
        penColor: "لون القلم",
        backgroundColor: "لون الخلفية",
        templateElements: "عناصر القالب",
        operator: "المشغل",
        isVariable: "متغير",
        runExpression: "تشغيل التعبير",
        showCaption: "showCaption",
        iconName: "iconName",
        iconSize: "iconSize",
        precision: "دقة",
        matrixDragHandleArea: "منطقة مقبض سحب المصفوفة",
        backgroundImage: "صورة الخلفية",
        backgroundImageFit: "ملاءمة صورة الخلفية",
        backgroundImageAttachment: "مرفق صورة الخلفية",
        backgroundOpacity: "عتامة الخلفية",
        selectToRankEnabled: "حدد للترتيب ممكن",
        selectToRankAreasLayout: "حدد لترتيب تخطيط المناطق",
        selectToRankEmptyRankedAreaText: "نص لإظهار ما إذا كانت كل الخيارات محددة",
        selectToRankEmptyUnrankedAreaText: "نص العنصر النائب لمنطقة الترتيب",
        allowCameraAccess: "السماح بالوصول إلى الكاميرا",
        scaleColorMode: "مقياس وضع اللون",
        rateColorMode: "معدل وضع اللون",
        copyDisplayValue: "نسخ قيمة العرض",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "الوضع المتقدم",
        pageTitle: "خط عنوان الصفحة",
        questionTitle: "خط عنوان السؤال",
        editorPanel: "عنصر الإدخال",
        lines: "اسطر",
        primaryDefaultColor: "افتراضي",
        primaryDarkColor: "حم",
        primaryLightColor: "المحدد",
        backgroundDimColor: "لون الخلفية",
        cornerRadius: "نصف قطر الزاوية",
        backcolor: "الخلفية الافتراضية",
        hovercolor: "خلفية التحويم",
        borderDecoration: "زخرفة الحدود",
        fontColor: "لون الخط",
        backgroundColor: "لون الخلفية",
        primaryForecolor: "اللون الافتراضي",
        primaryForecolorLight: "لون معطل",
        font: "الخط",
        borderDefault: "اظلم",
        borderLight: "أخف",
        fontFamily: "عائلة الخط",
        fontWeightRegular: "منتظم",
        fontWeightHeavy: "ثقيل",
        fontWeightSemiBold: "شبه غامق",
        fontWeightBold: "جريء",
        color: "لون",
        placeholderColor: "لون العنصر النائب",
        size: "حجم",
        opacity: "العتامه",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "إضافة تأثير الظل",
        boxShadowBlur: "طمس",
        boxShadowSpread: "انتشار",
        boxShadowDrop: "قطرة",
        boxShadowInner: "باطن",
        names: {
            default: "افتراضي",
            sharp: "حاد",
            borderless: "بلا حدود",
            flat: "وطيء",
            plain: "واضح",
            doubleborder: "حدود مزدوجة",
            layered: "الطبقات",
            solid: "صلب",
            threedimensional: ".3D",
            contrast: "تباين"
        },
        colors: {
            teal: "البط البري",
            blue: "أزرق",
            purple: "بنفسجي",
            orchid: "السحلب",
            tulip: "توليب",
            brown: "أسمر",
            green: "أخضر"
        }
    }
};
//Uncomment this line on creating a translation file. You should replace "en" and enStrings with your locale ("fr", "de" and so on) and your variable.
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["ar"] = arStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// qt.tagbox: "Multi-Select Dropdown" => "قائمة منسدلة متعددة التحديد"
// ed.surveySettings: "Survey Settings" => "إعدادات الاستطلاع"
// ed.surveySettingsTooltip: "Open survey settings" => "افتح إعدادات الاستطلاع"
// ed.themeSurvey: "Themes" => "المواضيع"
// ed.defaultV2Theme: "Default" => "افتراضي"
// ed.modernTheme: "Modern" => "حديث"
// ed.defaultTheme: "Default (legacy)" => "الافتراضي (القديم)"
// ed.showMoreChoices: "Show more" => "استعراض المزيد"
// ed.showLessChoices: "Show less" => "عرض أقل"
// ed.toolboxChoiceCategory: "Choice Questions" => "أسئلة الاختيار"
// ed.toolboxTextCategory: "Text Input Questions" => "أسئلة إدخال النص"
// ed.toolboxContainersCategory: "Containers" => "حاويات"
// ed.toolboxMatrixCategory: "Matrix Questions" => "أسئلة المصفوفة"
// ed.toolboxMiscCategory: "Misc" => "متفرقات"
// ed.themePropertyGridTitle: "Theme Settings" => "إعدادات النسق"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "سلاسل مستعملة فقط"
// ed.themeExportButton: "Export" => "تصدير"
// ed.themeImportButton: "Import" => "استورد"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "يتم نسخ الاختيارات من"
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "الاستطلاع فارغ. اسحب عنصرا من صندوق الأدوات أو انقر فوق الزر أدناه."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "قم بسحب وإسقاط صورة هنا أو انقر فوق الزر أدناه واختر صورة لتحميلها"
// ed.imageChooseImage: "Choose Image" => "اختر صورة"
// ed.auto: "auto" => "تلقائي"
// ed.choices_Item: "Item " => "بند "
// lg.addNewItem: "Add New Rule" => "إضافة قاعدة جديدة"
// lg.page_enableName: "Enable (disable) page" => "تمكين (تعطيل) الصفحة"
// lg.column_visibilityName: "Show (hide) column" => "إظهار (إخفاء) العمود"
// lg.column_enableName: "Enable (disable) column" => "تمكين (تعطيل) العمود"
// lg.column_requireName: "Make column required" => "جعل العمود مطلوبا"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "جعل العمود {0} السؤال {1} مرئيا"
// lg.column_enableText: "make column {0} of question {1} enable" => "تمكين {0} عمود السؤال {1}"
// lg.column_requireText: "make column {0} of question {1} required" => "جعل العمود {0} السؤال {1} مطلوبا"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "قيمة سؤال واضحة: {0}"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "القواعد المنطقية غير مكتملة"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "لم تكمل بعض القواعد المنطقية. إذا تركت علامة التبويب الآن ، فستفقد التغييرات. هل ما زلت تريد مغادرة علامة التبويب دون إكمال التغييرات؟"
// lg.uncompletedRule_apply: "Yes" => "نعم"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "لا، أريد إكمال القواعد"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "يمكنك تعيين البيانات بالتنسيق التالي:\nالقيمة1|النص\nقيمة2"
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "معاينة الإجابات قبل إرسال الاستطلاع"
// pe.overridingPropertyPrefix: "Set by " => "تم تعيينه بواسطة "
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "لا تستخدم الكلمات المحجوزة: \"عنصر\" ، \"اختيار\" ، \"لوحة\" ، \"صف\"."
// pe.listIsEmpty@choices: "No choices have been added yet" => "لم تتم إضافة أي خيارات حتى الآن"
// pe.addNew@choices: "Add a choice" => "إضافة خيار"
// choicesbyurl.valueName: "Get values from the following JSON field" => "الحصول على قيم من حقل JSON التالي"
// pe.and: "and" => "و"
// pe.or: "or" => "أو"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "حدد سؤالا لبدء تكوين الشروط."
// pe.then: "then" => "ثم"
// pe.gotoName: "Question to skip to" => "سؤال للتخطي إليه"
// pe.includeIntoResult: "Include into survey results" => "تضمين نتائج الاستطلاع"
// image.imageHeight: "Image height (in CSS-accepted values)" => "ارتفاع الصورة (بالقيم المقبولة من CSS)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "عرض الصورة (بالقيم المقبولة من CSS)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "الحد الزمني لإنهاء الصفحة (بالثواني)"
// question.page: "Parent page" => "الصفحة الرئيسية"
// pe.noEntriesText: "Empty entries text" => "نص إدخالات فارغ"
// pe.setValue: "Answer" => "جواب"
// pe.dataFormat: "Image format" => "تنسيق الصورة"
// pe.allowAddRows: "Allow adding rows" => "السماح بإضافة صفوف"
// pe.allowRemoveRows: "Allow removing rows" => "السماح بإزالة الصفوف"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "السماح بسحب الصف وإفلاته"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "لا ينطبق إذا قمت بتحديد عرض الصورة أو ارتفاعها بالضبط."
// pe.minImageWidth: "Minimum image width" => "الحد الأدنى لعرض الصورة"
// pe.maxImageWidth: "Maximum image width" => "الحد الأقصى لعرض الصورة"
// pe.minImageHeight: "Minimum image height" => "الحد الأدنى لارتفاع الصورة"
// pe.maxImageHeight: "Maximum image height" => "الحد الأقصى لارتفاع الصورة"
// surveyvalidator.text: "Error message" => "رسالة خطأ"
// surveyvalidator.expression: "Validation expression" => "تعبير التحقق من الصحة"
// pe.logo: "Logo (URL or base64-encoded string)" => "الشعار (عنوان URL أو سلسلة مشفرة base64)"
// pe.questionsOnPageMode: "Survey structure" => "هيكل المسح"
// pe.maxTextLength: "Maximum answer length (in characters)" => "الحد الأقصى لطول الإجابة (بالأحرف)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "الحد الأقصى لطول التعليق (بالأحرف)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "توسيع منطقة التعليق تلقائيا إذا لزم الأمر"
// pe.allowResizeComment: "Allow users to resize text areas" => "السماح للمستخدمين بتغيير حجم مناطق النص"
// pe.textUpdateMode: "Update text question value" => "تحديث قيمة السؤال النصي"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "تعيين التركيز على أول إجابة غير صالحة"
// pe.checkErrorsMode: "Run validation" => "تشغيل التحقق من الصحة"
// pe.navigateToUrl: "Navigate to URL" => "انتقل إلى عنوان URL"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "عنوان URL الديناميكي"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "الترميز لإظهار ما إذا كان المستخدم قد ملأ هذا الاستطلاع بالفعل"
// pe.completedHtml: "Survey Complete page markup" => "ترميز صفحة الاستطلاع الكامل"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "الاستطلاع الديناميكي إكمال ترميز الصفحة"
// pe.loadingHtml: "Markup to show while survey model is loading" => "الترميز لإظهاره أثناء تحميل نموذج الاستطلاع"
// pe.commentText: "Comment area text" => "نص منطقة التعليق"
// pe.autocomplete: "Autocomplete type" => "نوع الإكمال التلقائي"
// pe.labelTrue: "\"True\" label" => "تسمية \"صحيح\""
// pe.labelFalse: "\"False\" label" => "تسمية \"خطأ\""
// pe.displayStyle: "Value display style" => "نمط عرض القيمة"
// pe.format: "Formatted string" => "سلسلة منسقة"
// pe.maximumFractionDigits: "Maximum fractional digits" => "الحد الأقصى للأرقام الكسرية"
// pe.minimumFractionDigits: "Minimum fractional digits" => "الحد الأدنى من الأرقام الكسرية"
// pe.useGrouping: "Display grouping separators" => "عرض فواصل التجميع"
// pe.allowMultiple: "Allow multiple files" => "السماح بملفات متعددة"
// pe.allowImagesPreview: "Preview images" => "معاينة الصور"
// pe.acceptedTypes: "Accepted file types" => "أنواع الملفات المقبولة"
// pe.waitForUpload: "Wait for the upload to complete" => "انتظر حتى يكتمل التحميل"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "تأكيد حذف الملف"
// pe.detailPanelMode: "Detail panel location" => "موقع لوحة التفاصيل"
// pe.minRowCount: "Minimum row count" => "الحد الأدنى لعدد الصفوف"
// pe.maxRowCount: "Maximum row count" => "الحد الأقصى لعدد الصفوف"
// pe.confirmDelete: "Confirm row deletion" => "تأكيد حذف الصف"
// pe.confirmDeleteText: "Confirmation message" => "رسالة تأكيد"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "تأكيد حذف اللوحة"
// pe.panelCount: "Initial panel count" => "عدد اللوحات الأولي"
// pe.minPanelCount: "Minimum panel count" => "الحد الأدنى لعدد اللوحات"
// pe.maxPanelCount: "Maximum panel count" => "الحد الأقصى لعدد اللوحات"
// pe.panelsState: "Inner panel expand state" => "حالة توسيع اللوحة الداخلية"
// pe.templateDescription: "Description template" => "قالب الوصف"
// pe.templateTitle: "Title template" => "قالب العنوان"
// pe.panelPrevText: "Previous Panel button tooltip" => "تلميح أداة زر اللوحة السابق"
// pe.panelNextText: "Next Panel button tooltip" => "تلميح أداة زر اللوحة التالية"
// pe.showRangeInProgress: "Show progress bar" => "إظهار شريط التقدم"
// pe.templateTitleLocation: "Question title location" => "موقع عنوان السؤال"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "إزالة موقع زر اللوحة"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "إخفاء السؤال إذا لم تكن هناك صفوف"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "إخفاء الأعمدة في حالة عدم وجود صفوف"
// pe.rateValues: "Custom rate values" => "قيم الأسعار المخصصة"
// pe.rateCount: "Rate count" => "عدد الأسعار"
// pe.autoGenerate: "How to specify rate values?" => "كيفية تحديد قيم المعدل؟"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "إخفاء السؤال إذا لم يكن يحتوي على خيارات"
// pe.hideNumber: "Hide question number" => "إخفاء رقم السؤال"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "الحد الأدنى للعرض (بالقيم المقبولة في CSS)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "الحد الأقصى للعرض (بالقيم المقبولة من CSS)"
// pe.width: "Width (in CSS-accepted values)" => "العرض (بالقيم المقبولة من CSS)"
// pe.showHeader: "Show column headers" => "إظهار رؤوس الأعمدة"
// pe.horizontalScroll: "Show horizontal scrollbar" => "إظهار شريط التمرير الأفقي"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "الحد الأدنى لعرض العمود (بالقيم المقبولة من CSS)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "عرض رأس الصف (بالقيم المقبولة من CSS)"
// pe.valueTrue: "\"True\" value" => "القيمة \"الحقيقية\""
// pe.valueFalse: "\"False\" value" => "قيمة \"خاطئة\""
// pe.minErrorText: "\"Value is below minimum\" error message" => "رسالة الخطأ \"القيمة أقل من الحد الأدنى\""
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "رسالة الخطأ \"القيمة تتجاوز الحد الأقصى\""
// pe.otherErrorText: "\"Empty comment\" error message" => "رسالة الخطأ \"تعليق فارغ\""
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "رسالة الخطأ \"قيمة مفتاح غير فريدة\""
// pe.minSelectedChoices: "Minimum selected choices" => "الحد الأدنى من الخيارات المحددة"
// pe.maxSelectedChoices: "Maximum selected choices" => "الحد الأقصى للخيارات المحددة"
// pe.showClearButton: "Show the Clear button" => "إظهار الزر مسح"
// pe.showNumber: "Show panel number" => "إظهار رقم اللوحة"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "عرض الشعار (بالقيم المقبولة من CSS)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "ارتفاع الشعار (بالقيم المقبولة من CSS)"
// pe.readOnly: "Read-only" => "للقراءة فقط"
// pe.enableIf: "Editable if" => "قابل للتحرير إذا"
// pe.emptyRowsText: "\"No rows\" message" => "رسالة \"بلا صفوف\""
// pe.size: "Input field size (in characters)" => "حجم حقل الإدخال (بالأحرف)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "خيارات خاصة منفصلة (لا شيء، أخرى، تحديد الكل)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "نسخ الاختيارات من السؤال التالي"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "ما هي الخيارات التي تريد نسخها؟"
// pe.showCommentArea: "Show the comment area" => "إظهار منطقة التعليق"
// pe.commentPlaceholder: "Comment area placeholder" => "العنصر النائب لمنطقة التعليق"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "عرض أوصاف المعدل كقيم قصوى"
// pe.rowsOrder: "Row order" => "ترتيب الصفوف"
// pe.columnsLayout: "Column layout" => "تخطيط العمود"
// pe.columnColCount: "Nested column count" => "عدد الأعمدة المتداخلة"
// pe.state: "Panel expand state" => "حالة توسيع اللوحة"
// pe.correctAnswer: "Correct Answer" => "الإجابة الصحيحة"
// pe.defaultPanelValue: "Default Values" => "القيم الافتراضية"
// pe.cells: "Cell Texts" => "نصوص الخلية"
// pe.keyName: "Key column" => "عمود المفتاح"
// itemvalue.text: "Alt text" => "نص بديل"
// tabs.expression: "Expression" => "تعبير"
// pe.choicesVisibleIf: "Choices are visible if" => "تكون الخيارات مرئية إذا"
// pe.choicesEnableIf: "Choices are selectable if" => "يمكن تحديد الخيارات إذا"
// pe.columnsEnableIf: "Columns are visible if" => "تكون الأعمدة مرئية إذا"
// pe.rowsEnableIf: "Rows are visible if" => "تكون الصفوف مرئية إذا"
// pe.indent: "Add indents" => "إضافة مسافات بادئة"
// panel.indent: "Add outer indents" => "إضافة مسافات بادئة خارجية"
// pe.innerIndent: "Add inner indents" => "إضافة مسافات بادئة داخلية"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "خذ القيم الافتراضية من الصف الأخير"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "خذ القيم الافتراضية من اللوحة الأخيرة"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "اكتب التعبير هنا..."
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "مسح القيمة إذا أصبح السؤال مخفيا"
// pe.valuePropertyName: "Value property name" => "اسم خاصية القيمة"
// pe.searchEnabled: "Enable search" => "تمكين البحث"
// pe.hideSelectedItems: "Hide selected items" => "إخفاء العناصر المحددة"
// pe.closeOnSelect: "Close the dropdown after selection" => "أغلق القائمة المنسدلة بعد التحديد"
// pe.signatureWidth: "Signature width" => "عرض التوقيع"
// pe.signatureHeight: "Signature height" => "ارتفاع التوقيع"
// pe.verticalAlign: "Vertical alignment" => "المحاذاة الرأسية"
// pe.alternateRows: "Alternate rows" => "صفوف بديلة"
// pe.columnsVisibleIf: "Columns are visible if" => "تكون الأعمدة مرئية إذا"
// pe.rowsVisibleIf: "Rows are visible if" => "تكون الصفوف مرئية إذا"
// pe.otherPlaceholder: "Comment area placeholder" => "العنصر النائب لمنطقة التعليق"
// pe.rateType: "Rate type" => "نوع السعر"
// pv.true: "true" => "صحيح"
// pv.false: "false" => "خطأ"
// pv.decimal: "decimal" => "عشري"
// pv.currency: "currency" => "عملة"
// pv.percent: "percent" => "المائه"
// pv.onpanel: "Start on each panel" => "ابدأ في كل لوحة"
// pv.tab: "Tabs" => "علامات التبويب"
// pv.color: "color" => "لون"
// pv.date: "date" => "تاريخ"
// pv.datetime: "datetime" => "التاريخ والوقت"
// pv.datetime-local: "datetime-local" => "التاريخ والوقت-محلي"
// pv.email: "email" => "البريد الإلكتروني"
// pv.month: "month" => "شهر"
// pv.number: "number" => "رقم"
// pv.password: "password" => "شعار"
// pv.range: "range" => "نطاق"
// pv.tel: "tel" => "هاء."
// pv.text: "text" => "نص"
// pv.time: "time" => "الوقت"
// pv.url: "url" => "الرابط"
// pv.week: "week" => "أسبوع"
// clearInvisibleValues.none: "Never" => "أبدا"
// inputType.color: "Color" => "لون"
// inputType.date: "Date" => "تاريخ"
// inputType.datetime-local: "Date and Time" => "التاريخ والوقت"
// inputType.email: "Email" => "البريد الإلكتروني"
// inputType.month: "Month" => "شهر"
// inputType.number: "Number" => "رقم"
// inputType.password: "Password" => "شعار"
// inputType.range: "Range" => "نطاق"
// inputType.tel: "Phone Number" => "رقم الهاتف"
// inputType.text: "Text" => "نص"
// inputType.time: "Time" => "الوقت"
// inputType.url: "URL" => "الرابط"
// inputType.week: "Week" => "أسبوع"
// pv.underRow: "Under the row" => "تحت الصف"
// pv.underRowSingle: "Under the row, only one panel is visible" => "أسفل الصف ، تكون لوحة واحدة فقط مرئية"
// showNavigationButtons.none: "Hidden" => "مخفي"
// showProgressBar.off: "Hidden" => "مخفي"
// showTimerPanel.none: "Hidden" => "مخفي"
// showTimerPanelMode.all: "Both" => "كلا"
// detailPanelMode.none: "Hidden" => "مخفي"
// addRowLocation.default: "Depends on matrix layout" => "يعتمد على تخطيط المصفوفة"
// panelsState.default: "Users cannot expand or collapse panels" => "لا يمكن للمستخدمين توسيع اللوحات أو طيها"
// panelsState.collapsed: "All panels are collapsed" => "جميع اللوحات مطوية"
// panelsState.expanded: "All panels are expanded" => "يتم توسيع جميع اللوحات"
// widthMode.auto: "Auto" => "تلقائي"
// widthMode.static: "Static" => "ثابت"
// widthMode.responsive: "Responsive" => "متجاوب"
// imageFit.none: "None" => "اي"
// imageFit.contain: "Contain" => "احتوى"
// imageFit.cover: "Cover" => "غطاء"
// imageFit.fill: "Fill" => "ملء"
// contentMode.auto: "Auto" => "تلقائي"
// contentMode.image: "Image" => "صورة"
// contentMode.video: "Video" => "فيديو"
// contentMode.youtube: "YouTube" => "يوتيوب"
// displayMode.auto: "Auto" => "تلقائي"
// displayMode.buttons: "Buttons" => "ازرار"
// displayMode.dropdown: "Dropdown" => "القائمة المنسدلة"
// rateColorMode.default: "Default" => "افتراضي"
// autoGenerate.true: "Generate" => "ولد"
// autoGenerate.false: "Enter manually" => "أدخل يدويا"
// rateType.labels: "Labels" => "تسميات"
// rateType.stars: "Stars" => "النجوم"
// rateType.smileys: "Smileys" => "الوجوه الضاحكة"
// op.and: "and" => "و"
// op.or: "or" => "أو"
// ts.hideInvisibleElements: "Hide invisible elements" => "إخفاء العناصر غير المرئية"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "تمنع ملفات تعريف الارتباط المستخدمين من ملء نفس الاستبيان مرتين."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "تغيير حجم المنطقة المرئية لحقل الإدخال. الرجاء استخدام إعداد <b>التحقق من الصحة → الحد الأقصى للطول</b> للحد من طول الإدخال."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "استخدم {0} كعنصر نائب للقيمة الفعلية."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "تكون مرئية فقط عندما يحتوي عمود واحد على الأقل على نوع الإجمالي أو تعبير الإجمالي."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "يرجى الرجوع إلى وصف السمة [قبول] (https://www.w3schools.com/tags/att_input_accept.asp) للحصول على مزيد من المعلومات."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "ينطبق فقط على أنواع خلايا المجموعة الراديوية وخانة الاختيار."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "راجع وصف السمة [الإكمال التلقائي] (https://developer.mozilla.org/en-US/docs/Web/HTML/السمات/الإكمال التلقائي) للحصول على مزيد من المعلومات."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "إذا لم تقم بتعيين هذه الخاصية، تخزين الإجابة في حقل محدد بواسطة خاصية الاسم."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "إذا كان العمود المحدد يحتوي على قيم متطابقة ، فإن الاستطلاع يلقي الخطأ \"قيمة مفتاح غير فريدة\"."
// p.tabAlign: "Tab alignment" => "محاذاة علامات التبويب"
// p.questions: "Questions" => "الاسئله"
// p.surveyId: "Survey id" => "معرف الاستطلاع"
// p.surveyPostId: "Survey post id" => "معرف وظيفة الاستطلاع"
// p.surveyShowDataSaving: "Survey show data saving" => "يظهر الاستطلاع توفير البيانات"
// p.showTOC: "Show TOC" => "إظهار جدول المحتويات"
// p.tocLocation: "Toc location" => "موقع جدول المحتويات"
// p.showBrandInfo: "Show brand info" => "عرض معلومات العلامة التجارية"
// p.renderAs: "Render as" => "عرض ك"
// p.attachOriginalItems: "Attach original items" => "إرفاق العناصر الأصلية"
// p.cellHint: "Cell hint" => "تلميح الخلية"
// p.isUnique: "Is unique" => "فريد من نوعه"
// p.showInMultipleColumns: "Show in multiple columns" => "إظهار في أعمدة متعددة"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "إجمالي الحد الأقصى لأرقام الكسور"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "إجمالي الحد الأدنى لأرقام الكسور"
// p.detailElements: "Detail elements" => "عناصر التفاصيل"
// p.allowAdaptiveActions: "Allow adaptive actions" => "السماح بالإجراءات التكيفية"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "تمكين التحميل البطيء للاختيارات"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "اختيارات كسول تحميل حجم الصفحة"
// p.inputFieldComponent: "Input field component" => "مكون حقل الإدخال"
// p.itemComponent: "Item component" => "مكون العنصر"
// p.elements: "Elements" => "عناصر"
// p.content: "Content" => "محتوى"
// p.longTap: "Long tap" => "نقرة طويلة"
// p.allowResize: "Allow resizing" => "السماح بتغيير الحجم"
// p.acceptCarriageReturn: "Accept carriage return" => "قبول إرجاع النقل"
// p.displayMode: "Display mode" => "وضع العرض"
// p.rateType: "Rate type" => "نوع السعر"
// p.altText: "Alt text" => "نص بديل"
// p.templateElements: "Template elements" => "عناصر القالب"
// p.operator: "Operator" => "المشغل"
// p.isVariable: "Is variable" => "متغير"
// p.runExpression: "Run expression" => "تشغيل التعبير"
// p.precision: "Precision" => "دقة"
// p.matrixDragHandleArea: "Matrix drag handle area" => "منطقة مقبض سحب المصفوفة"
// p.backgroundImage: "Background image" => "صورة الخلفية"
// p.backgroundImageFit: "Background image fit" => "ملاءمة صورة الخلفية"
// p.backgroundImageAttachment: "Background image attachment" => "مرفق صورة الخلفية"
// p.backgroundOpacity: "Background opacity" => "عتامة الخلفية"
// p.selectToRankEnabled: "Select to rank enabled" => "حدد للترتيب ممكن"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "حدد لترتيب تخطيط المناطق"
// p.allowCameraAccess: "Allow camera access" => "السماح بالوصول إلى الكاميرا"
// p.scaleColorMode: "Scale color mode" => "مقياس وضع اللون"
// p.rateColorMode: "Rate color mode" => "معدل وضع اللون"
// p.templateTabTitle: "Template tab title" => "عنوان علامة تبويب القالب"
// p.templateVisibleIf: "Template visible if" => "القالب مرئي إذا"
// p.copyDisplayValue: "Copy display value" => "نسخ قيمة العرض"
// theme.--background: "Background color" => "لون الخلفية"
// theme.--background-dim-light: "Background dim light color" => "خلفية لون فاتح قاتم"
// theme.--primary-foreground: "Primary foreground color" => "لون المقدمة الأساسي"
// theme.--foreground: "Foreground color" => "لون المقدمة"
// theme.--base-unit: "Base unit" => "وحدة القاعدة"
// theme.groupAdvanced: "Advanced" => "متقدم"
// theme.themeName: "Theme" => "موضوع"
// theme.isPanellessss: "Question appearance" => "مظهر السؤال"
// theme.isPanellessPanels: "Default" => "افتراضي"
// theme.isPanellessLightweight: "Without Panels" => "بدون لوحات"
// theme.themePaletteLight: "Light" => "ضوء"
// theme.themePaletteDark: "Dark" => "داكن"
// theme.primaryColor: "Accent color" => "لون التمييز"
// theme.primaryDefaultColor: "Default" => "افتراضي"
// theme.primaryDarkColor: "Hover" => "حم"
// theme.primaryLightColor: "Selected" => "المحدد"
// theme.backgroundDimColor: "Background color" => "لون الخلفية"
// theme.backgroundImage: "Background image" => "صورة الخلفية"
// theme.backgroundImageFitAuto: "Auto" => "تلقائي"
// theme.backgroundImageFitCover: "Cover" => "غطاء"
// theme.backgroundImageFitContain: "Contain" => "احتوى"
// theme.backgroundOpacity: "Opacity" => "العتامه"
// theme.backgroundImageAttachmentFixed: "Fixed" => "ثابت"
// theme.backgroundImageAttachmentScroll: "Scroll" => "طومار"
// theme.panelBackgroundTransparency: "Panel background opacity" => "عتامة خلفية اللوحة"
// theme.questionBackgroundTransparency: "Question background opacity" => "عتامة خلفية السؤال"
// theme.questionPanel: "Panel background and corner radius" => "خلفية اللوحة ونصف قطر الزاوية"
// theme.questionTitle: "Question title font" => "خط عنوان السؤال"
// theme.questionDescription: "Question description font" => "خط وصف السؤال"
// theme.editorPanel: "Input element" => "عنصر الإدخال"
// theme.editorFont: "Input element font" => "خط عنصر الإدخال"
// theme.backcolor: "Default background" => "الخلفية الافتراضية"
// theme.hovercolor: "Hover background" => "خلفية التحويم"
// theme.borderDecoration: "Border decoration" => "زخرفة الحدود"
// theme.accentBackground: "Accent background" => "خلفية لهجة"
// theme.accentForeground: "Accent foreground" => "لهجة الصدارة"
// theme.primaryForecolor: "Default color" => "اللون الافتراضي"
// theme.primaryForecolorLight: "Disabled color" => "لون معطل"
// theme.linesColors: "Minor line colors" => "ألوان الخطوط الثانوية"
// theme.borderDefault: "Darker" => "اظلم"
// theme.borderLight: "Lighter" => "أخف"
// theme.fontFamily: "Font family" => "عائلة الخط"
// theme.fontSize: "Font size" => "حجم الخط"
// theme.color: "Color" => "لون"
// theme.size: "Size" => "حجم"
// theme.fontWeightRegular: "Regular" => "منتظم"
// theme.fontWeightHeavy: "Heavy" => "ثقيل"
// theme.fontWeightSemiBold: "Semi-bold" => "شبه غامق"
// theme.fontWeightBold: "Bold" => "جريء"
// theme.scale: "Scale" => "مِيزَان"
// theme.cornerRadius: "Corner radius" => "نصف قطر الزاوية"
// theme.surveyTitleFont: "Survey title font" => "خط عنوان الاستطلاع"
// theme.pageTitle: "Page title font" => "خط عنوان الصفحة"
// theme.pageDescription: "Page description font" => "خط وصف الصفحة"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "إضافة تأثير الظل"
// theme.opacity: "Opacity" => "العتامه"
// theme.boxShadowBlur: "Blur" => "طمس"
// theme.boxShadowSpread: "Spread" => "انتشار"
// theme.boxShadowDrop: "Drop" => "قطرة"
// theme.boxShadowInner: "Inner" => "باطن"
// theme.questionShadow: "Shadow effects" => "تأثيرات الظل"
// theme.editorShadow: "Input element shadow effects" => "تأثيرات ظل عنصر الإدخال"
// names.default: "Default" => "افتراضي"
// names.contrast: "Contrast" => "تباين"
// names.plain: "Plain" => "واضح"
// names.simple: "Simple" => "بسيط"
// names.blank: "Blank" => "خلبي"
// names.double: "Double" => "مزدوج"
// names.bulk: "Bulk" => "جرم"
// names.pseudo-3d: "Pseudo 3D" => "الزائفة 3D"
// names.playful: "Playful" => "لعوب"
// names.ultra: "Ultra" => "الترا"
// colors.teal: "Teal" => "البط البري"
// colors.blue: "Blue" => "أزرق"
// colors.purple: "Purple" => "بنفسجي"
// colors.orchid: "Orchid" => "السحلب"
// colors.tulip: "Tulip" => "توليب"
// colors.brown: "Brown" => "أسمر"
// colors.green: "Green" => "أخضر"
// names.sharp: "Sharp" => "حاد"
// names.borderless: "Borderless" => "بلا حدود"
// names.flat: "Flat" => "وطيء"
// names.doubleborder: "Double Border" => "حدود مزدوجة"
// names.layered: "Layered" => "الطبقات"
// names.solid: "Solid" => "صلب"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "هل أنت متأكد من أنك ترغب في حذف جميع السلاسل لهذه اللغة؟"
// ed.themeResetButton: "Reset theme settings to default" => "إعادة تعيين إعدادات النسق إلى الوضع الافتراضي"
// theme.placeholderColor: "Placeholder color" => "لون العنصر النائب"
// ed.themeSettings: "Theme Settings" => "إعدادات النسق"
// ed.themeSettingsTooltip: "Open theme settings" => "فتح إعدادات النسق"
// pe.resetToDefaultCaption: "Reset" => "اعاده تعيين"
// pv.file: "Local files" => "الملفات المحلية"
// pv.camera: "Camera" => "كاميرا"
// pv.file-camera: "Local files or camera" => "الملفات المحلية أو الكاميرا"
// ed.translateUsigAI: "Auto-translate All" => "ترجمة تلقائية للكل"
// ed.translationDialogTitle: "Untranslated strings" => "النصوص غير المترجمة"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "الرجاء إدخال {0} العناصر على الأقل"
// pe.markRequired: "Mark as required" => "وضع علامة كمطلوب"
// pe.removeRequiredMark: "Remove the required mark" => "إزالة العلامة المطلوبة"
// lg.question_resetValueName: "Reset question value" => "إعادة تعيين قيمة السؤال"
// lg.column_resetValue: "Reset column value" => "إعادة تعيين قيمة العمود"
// p.resetValueIf: "Reset value if" => "إعادة تعيين القيمة إذا"
// lg.question_setValueName: "Set question value" => "تعيين قيمة السؤال"
// lg.column_resetValueName: "Reset column value" => "إعادة تعيين قيمة العمود"
// lg.column_setValueName: "Set column value" => "تعيين قيمة العمود"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " تعبير سيتم تعيين نتيجته للسؤال الهدف."
// survey.title: "Title" => "عنوان"
// page.title: "Title" => "عنوان"
// p.setValueIf: "Set value if" => "تعيين قيمة إذا"
// theme.header: "Header" => "راس"
// theme.backgroundImageFitFill: "Stretch" => "مد"
// theme.backgroundImageFitTile: "Tile" => "بلاط"
// theme.headerView: "View" => "منظر"
// theme.headerViewBasic: "Basic" => "أساسي"
// theme.headerViewAdvanced: "Advanced" => "متقدم"
// theme.headerInheritWidthFrom: "Content area width" => "عرض منطقة المحتوى"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "نفس المسح"
// theme.headerInheritWidthFromPage: "Fit to page" => "ملائمة للصفحة"
// theme.headerTextAreaWidth: "Text width" => "عرض النص"
// theme.headerBackgroundColorSwitch: "Background color" => "لون الخلفية"
// theme.headerBackgroundColorNone: "None" => "اي"
// theme.headerBackgroundColorAccentColor: "Accent color" => "لون التمييز"
// theme.headerBackgroundColorCustom: "Custom" => "تقليد"
// theme.horizontalAlignmentLeft: "Left" => "يسار"
// theme.horizontalAlignmentCenter: "Center" => "مركز"
// theme.horizontalAlignmentRight: "Right" => "يمين"
// theme.verticalAlignmentTop: "Top" => "أعلى"
// theme.verticalAlignmentMiddle: "Middle" => "وسط"
// theme.verticalAlignmentBottom: "Bottom" => "قاع"
// lg.question_resetValueText: "reset value for question: {0}" => "إعادة تعيين قيمة السؤال: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "تعيين قيمة: {1} السؤال: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "إعادة تعيين قيمة الخلية للعمود: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "تعيين قيمة الخلية: {1} إلى العمود: {0}"
// ed.surveyJsonExportButton: "Export" => "تصدير"
// ed.surveyJsonImportButton: "Import" => "استورد"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "نسخ إلى الحافظة"
// pe.filePlaceholder: "File placeholder text" => "نص العنصر النائب للملف"
// pe.photoPlaceholder: "Photo placeholder text" => "نص العنصر النائب للصورة"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "نص العنصر النائب للملف أو الصورة"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "ينطبق عندما يكون \"نوع المصدر\" هو \"ملفات محلية\" أو عندما تكون الكاميرا غير متوفرة"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "ينطبق عندما يكون \"نوع المصدر\" هو \"الكاميرا\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "ينطبق عندما يكون \"نوع المصدر\" هو \"الملفات المحلية أو الكاميرا\"."
// theme.background: "Background" => "خلفية"
// theme.appearance: "Appearance" => "مظهر"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "هل تريد حقا إعادة تعيين السمة؟ ستفقد جميع تخصيصاتك."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "نعم ، إعادة تعيين السمة"
// theme.headerDescriptionForecolor: "Description forecolor" => "وصف التلوين الأمامي"
// theme.headerInheritWidthFromContainer: "Fit to container" => "يصلح للحاوية"
// signaturepad.showPlaceholder: "Show the placeholder" => "إظهار العنصر النائب"
// signaturepad.placeholder: "Placeholder text" => "نص العنصر النائب"
// theme.surveyDescriptionFont: "Survey description font" => "خط وصف الاستطلاع"
// ed.prevFocus: "Focus previous" => "التركيز السابق"
// ed.nextFocus: "Focus next" => "التركيز التالي"
// ed.saveTheme: "Save Theme" => "حفظ السمة"
// ed.saveThemeTooltip: "Save Theme" => "حفظ السمة"
// lg.page_requireName: "Make page required" => "اجعل الصفحة مطلوبة"
// lg.panel_requireName: "Make page required" => "اجعل الصفحة مطلوبة"
// signaturepad.signatureWidth: "Signature area width" => "عرض منطقة التوقيع"
// signaturepad.signatureHeight: "Signature area height" => "ارتفاع منطقة التوقيع"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "تغيير حجم منطقة التوقيع تلقائيا"
// signaturepad.penMinWidth: "Minimum pen width" => "الحد الأدنى لعرض القلم"
// signaturepad.penMaxWidth: "Maximum pen width" => "الحد الأقصى لعرض القلم"
// theme.logoPosition: "Logo position" => "موضع الشعار"
// theme.headerTitlePosition: "Title position" => "موضع العنوان"
// theme.headerDescriptionPosition: "Description position" => "موقف الوصف"
// ed.propertyGridNoResultsFound: "No results found" => "لم يتم العثور على نتائج"
// pv.leftRight: "Left and right" => "اليسار واليمين"
// p.sourceType: "Source type" => "نوع المصدر"
// p.fitToContainer: "Fit to container" => "يصلح للحاوية"
// p.setValueExpression: "Set value expression" => "تعيين تعبير القيمة"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "يتم تحميل الاختيارات من خدمة ويب."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "انتقل إلى الإعدادات"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "معاينة خيارات الاختيار المحملة"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "منع تكرار الاستجابات في الصفوف"
// theme.advancedMode: "Advanced mode" => "الوضع المتقدم"
// theme.backgroundCornerRadius: "Background and corner radius" => "الخلفية ونصف قطر الزاوية"
// theme.colorsTitle: "Colors" => "الوان"
// theme.font: "Font" => "الخط"
// theme.lines: "Lines" => "اسطر"
// theme.titleFont: "Title font" => "خط العنوان"
// theme.descriptionFont: "Description font" => "خط الوصف"
// theme.shadow: "Shadow effects" => "تأثيرات الظل"
// ed.translateUsigAIFrom: "Translate from: " => "ترجمة من: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "السماح بخيار رفض الإجابة"
// pe.showDontKnowItem: "Allow the Don't Know option" => "السماح بالخيار \"لا أعرف\""
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "السماح بخيار رفض الإجابة"
// pe.showDontKnowItem: "Allow the Don't Know option" => "السماح بالخيار \"لا أعرف\""
// pv.contain: "Contain" => "احتوى"
// pv.cover: "Cover" => "غطاء"
// pv.fill: "Fill" => "ملء"
// pe.transposeData: "Transpose rows to columns" => "تبديل موضع الصفوف إلى أعمدة"
// layout.panel: "Layout" => "تخطيط"
// layout.question: "Layout" => "تخطيط"
// layout.base: "Layout" => "تخطيط"
// panel.name: "Panel name" => "اسم اللوحة"
// panel.title: "Panel title" => "عنوان اللوحة"
// panel.description: "Panel description" => "وصف اللوحة"
// panel.visibleIf: "Make the panel visible if" => "اجعل اللوحة مرئية إذا"
// panel.requiredIf: "Make the panel required if" => "اجعل اللوحة مطلوبة إذا"
// panel.questionsOrder: "Question order within the panel" => "ترتيب الأسئلة داخل اللوحة"
// panel.startWithNewLine: "Display the panel on a new line" => "عرض اللوحة على سطر جديد"
// panel.state: "Panel collapse state" => "حالة انهيار اللوحة"
// panel.width: "Inline panel width" => "عرض اللوحة المضمنة"
// panel.minWidth: "Minimum panel width" => "الحد الأدنى لعرض اللوحة"
// panel.maxWidth: "Maximum panel width" => "الحد الأقصى لعرض اللوحة"
// panel.showNumber: "Number panels" => "لوحات الأرقام"
// paneldynamic.name: "Panel name" => "اسم اللوحة"
// paneldynamic.title: "Panel title" => "عنوان اللوحة"
// paneldynamic.description: "Panel description" => "وصف اللوحة"
// paneldynamic.visibleIf: "Make the panel visible if" => "اجعل اللوحة مرئية إذا"
// paneldynamic.requiredIf: "Make the panel required if" => "اجعل اللوحة مطلوبة إذا"
// paneldynamic.page: "Move the panel to page" => "نقل اللوحة إلى الصفحة"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "عرض اللوحة على سطر جديد"
// paneldynamic.state: "Panel collapse state" => "حالة انهيار اللوحة"
// paneldynamic.width: "Inline panel width" => "عرض اللوحة المضمنة"
// paneldynamic.minWidth: "Minimum panel width" => "الحد الأدنى لعرض اللوحة"
// paneldynamic.maxWidth: "Maximum panel width" => "الحد الأقصى لعرض اللوحة"
// paneldynamic.templateDescription: "Panel description pattern" => "نمط وصف اللوحة"
// paneldynamic.templateTitle: "Panel title pattern" => "نمط عنوان اللوحة"
// paneldynamic.noEntriesText: "Empty panel text" => "نص لوحة فارغ"
// paneldynamic.templateTabTitle: "Tab title pattern" => "نمط عنوان علامة التبويب"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "اجعل لوحة فردية مرئية إذا"
// paneldynamic.hideNumber: "Hide the panel number" => "إخفاء رقم اللوحة"
// paneldynamic.titleLocation: "Panel title alignment" => "محاذاة عنوان اللوحة"
// paneldynamic.descriptionLocation: "Panel description alignment" => "محاذاة وصف اللوحة"
// paneldynamic.templateTitleLocation: "Question title alignment" => "محاذاة عنوان السؤال"
// paneldynamic.templateErrorLocation: "Error message alignment" => "محاذاة رسالة الخطأ"
// paneldynamic.newPanelPosition: "New panel location" => "موقع لوحة جديد"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "منع تكرار الردود في السؤال التالي"
// question.name: "Question name" => "اسم السؤال"
// question.title: "Question title" => "عنوان السؤال"
// question.description: "Question description" => "وصف السؤال"
// question.visibleIf: "Make the question visible if" => "اجعل السؤال مرئيا إذا"
// question.requiredIf: "Make the question required if" => "اجعل السؤال مطلوبا إذا"
// question.state: "Question box collapse state" => "حالة طي مربع الأسئلة"
// question.hideNumber: "Hide the question number" => "إخفاء رقم السؤال"
// question.titleLocation: "Question title alignment" => "محاذاة عنوان السؤال"
// question.descriptionLocation: "Question description alignment" => "محاذاة وصف السؤال"
// question.errorLocation: "Error message alignment" => "محاذاة رسالة الخطأ"
// question.indent: "Increase the inner indent" => "زيادة المسافة البادئة الداخلية"
// question.width: "Inline question width" => "عرض السؤال المضمن"
// question.minWidth: "Minimum question width" => "الحد الأدنى لعرض السؤال"
// question.maxWidth: "Maximum question width" => "الحد الأقصى لعرض السؤال"
// question.textUpdateMode: "Update input field value" => "تحديث قيمة حقل الإدخال"
// signaturepad.allowClear: "Show the Clear button within signature area" => "إظهار الزر مسح داخل منطقة التوقيع"
// signaturepad.penColor: "Stroke color" => "لون الحد"
// comment.rows: "Input field height (in lines)" => "ارتفاع حقل الإدخال (في الأسطر)"
// expression.name: "Expression name" => "اسم التعبير"
// expression.title: "Expression title" => "عنوان التعبير"
// expression.description: "Expression description" => "وصف التعبير"
// expression.expression: "Expression" => "تعبير"
// trigger.expression: "Expression" => "تعبير"
// calculatedvalue.expression: "Expression" => "تعبير"
// survey.description: "Survey description" => "وصف المسح"
// page.name: "Page name" => "اسم الصفحة"
// page.description: "Page description" => "وصف الصفحة"
// page.visibleIf: "Make the page visible if" => "اجعل الصفحة مرئية إذا"
// page.requiredIf: "Make the page required if" => "اجعل الصفحة مطلوبة إذا"
// page.questionsOrder: "Question order on the page" => "ترتيب الأسئلة على الصفحة"
// matrixdropdowncolumn.name: "Column name" => "اسم العمود"
// matrixdropdowncolumn.title: "Column title" => "عنوان العمود"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "منع الردود المكررة"
// matrixdropdowncolumn.width: "Column width" => "عرض العمود"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "الحد الأدنى لعرض العمود"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "ارتفاع حقل الإدخال (في الأسطر)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "اجعل العمود مرئيا إذا"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "اجعل العمود مطلوبا إذا"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "كل خيار في عمود منفصل"
// multipletextitem.name: "Name" => "اسم"
// multipletextitem.title: "Title" => "عنوان"
// pe.rateDescriptionLocation: "Label alignment" => "محاذاة التسمية"
// pe.cellErrorLocation: "Cell error message alignment" => "محاذاة رسالة خطأ الخلية"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "ليس لديك أي أعمدة حتى الآن"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "ليس لديك أي صفوف حتى الآن"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "ليس لديك أي قواعد تحقق حتى الآن"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "ليس لديك أي متغيرات مخصصة حتى الآن"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "ليس لديك أي محفزات حتى الآن"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "ليس لديك أي روابط حتى الآن"
// pe.addNew@columns: "Add new column" => "إضافة عمود جديد"
// pe.addNew@rows: "Add new row" => "إضافة صف جديد"
// pe.addNew@validators: "Add new rule" => "إضافة قاعدة جديدة"
// pe.addNew@calculatedValues: "Add new variable" => "إضافة متغير جديد"
// pe.addNew@triggers: "Add new trigger" => "إضافة مشغل جديد"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "إضافة عنوان URL جديد"
// choicesbyurl.url: "Web service's URL" => "عنوان URL لخدمة الويب"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "عرض عناوين الصفحات في شريط التقدم"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "عرض أرقام الصفحات في شريط التقدم"
// itemvalue.visibleIf: "Make the option visible if" => "اجعل الخيار مرئيا إذا"
// itemvalue.enableIf: "Make the option selectable if" => "اجعل الخيار قابلا للتحديد إذا"
// panel.layout: "Panel Layout" => "تخطيط اللوحة"
// tabs.questionSettings: "Question Settings" => "إعدادات السؤال"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "مثال: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "مثال: فئات.خيال"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "مثال: أ)"
// pe.width_placeholder: "Ex.: 6in" => "مثال: 6 بوصة"
// pe.minWidth_placeholder: "Ex.: 600px" => "مثال: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "مثال: 50٪"
// pv.selected: "Selected" => "المحدد"
// pv.unselected: "Unselected" => "محدد"
// pv.center: "Center" => "مركز"
// pv.middle: "Middle" => "وسط"
// pv.next: "Next" => "مقبل"
// pv.last: "Last" => "آخر"
// clearIfInvisible.none: "Never" => "أبدا"
// questionsOnPageMode.standard: "Original structure" => "الهيكل الأصلي"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "إظهار جميع الأسئلة في صفحة واحدة"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "إظهار سؤال واحد لكل صفحة"
// pv.auto: "Auto" => "تلقائي"
// panelsState.firstExpanded: "First expanded" => "توسعت لأول مرة"
// rateColorMode.scale: "Scale" => "مِيزَان"
// scaleColorMode.monochrome: "Monochrome" => "أحادي اللون"
// scaleColorMode.colored: "Colored" => "الملونه"
// state.default: "Locked" => "مقفل"
// showQuestionNumbers.default: "Auto-numbering" => "الترقيم التلقائي"
// showQuestionNumbers.on: "Auto-numbering" => "الترقيم التلقائي"
// showQuestionNumbers.onPage: "Reset on each page" => "إعادة تعيين على كل صفحة"
// showQuestionNumbers.onpanel: "Reset on each panel" => "إعادة تعيين على كل لوحة"
// showQuestionNumbers.onPanel: "Reset on each panel" => "إعادة تعيين على كل لوحة"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "المتابعة عبر الاستطلاع"
// showQuestionNumbers.off: "No numbering" => "لا ترقيم"
// descriptionLocation.underTitle: "Under the question title" => "تحت عنوان السؤال"
// descriptionLocation.underInput: "Under the input field" => "ضمن حقل الإدخال"
// selectToRankAreasLayout.horizontal: "Next to choices" => "بجانب الخيارات"
// selectToRankAreasLayout.vertical: "Above choices" => "الخيارات أعلاه"
// displayStyle.decimal: "Decimal" => "عشري"
// displayStyle.currency: "Currency" => "عملة"
// displayStyle.percent: "Percentage" => "النسبه المئويه"
// displayStyle.date: "Date" => "تاريخ"
// totalDisplayStyle.decimal: "Decimal" => "عشري"
// totalDisplayStyle.currency: "Currency" => "عملة"
// totalDisplayStyle.percent: "Percentage" => "النسبه المئويه"
// totalDisplayStyle.date: "Date" => "تاريخ"
// rowsOrder.initial: "Original" => "اللغة الأصلية"
// questionsOrder.initial: "Original" => "اللغة الأصلية"
// showProgressBar.aboveheader: "Above the header" => "فوق الرأس"
// showProgressBar.belowheader: "Below the header" => "أسفل الرأس"
// pv.sum: "Sum" => "مجموع"
// pv.count: "Count" => "عد"
// pv.min: "Min" => "دقيقه"
// pv.max: "Max" => "ماكس"
// pv.avg: "Avg" => "متوسط"
// searchMode.contains: "Contains" => "يحتوي"
// searchMode.startsWith: "Starts with" => "يبدأ ب"
// panel.name: "A panel ID that is not visible to respondents." => "معرف لوحة غير مرئي للمستجيبين."
// panel.description: "Type a panel subtitle." => "اكتب عنوانا فرعيا للوحة."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "استخدم أيقونة العصا السحرية لضبط قاعدة شرطية تحدد رؤية اللوحة."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تعطل وضع القراءة فقط للوحة."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تمنع إرسال الاستطلاع ما لم يكن لسؤال واحد متداخل على الأقل إجابة."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "ينطبق على جميع الأسئلة داخل هذه اللجنة. إذا كنت تريد إلغاء هذا الإعداد، فحدد قواعد محاذاة العنوان للأسئلة الفردية. يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع (\"أعلى\" افتراضيا)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "تعيين موقع رسالة خطأ فيما يتعلق بجميع الأسئلة داخل اللوحة. يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "يحافظ على الترتيب الأصلي للأسئلة أو يحولها عشوائيا. يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع."
// panel.page: "Repositions the panel to the end of a selected page." => "تغيير موضع اللوحة إلى نهاية الصفحة المحددة."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "يضيف مسافة أو هامش بين محتوى اللوحة والحد الأيسر لمربع اللوحة."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "قم بإلغاء التحديد لعرض اللوحة في سطر واحد مع السؤال أو اللوحة السابقة. لا ينطبق الإعداد إذا كانت اللوحة هي العنصر الأول في النموذج الخاص بك."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "اختر من بين: \"موسعة\" - يتم عرض اللوحة بالكامل ويمكن طيها ؛ \"مطوي\" - تعرض اللوحة العنوان والوصف فقط ويمكن توسيعها ؛ \"مغلق\" - يتم عرض اللوحة بالكامل ولا يمكن طيها."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "يضبط عرض اللوحة بما يتناسب مع عناصر الاستطلاع الأخرى في نفس السطر. يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "معرف لوحة غير مرئي للمستجيبين."
// paneldynamic.description: "Type a panel subtitle." => "اكتب عنوانا فرعيا للوحة."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "استخدم أيقونة العصا السحرية لضبط قاعدة شرطية تحدد رؤية اللوحة."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تعطل وضع القراءة فقط للوحة."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تمنع إرسال الاستطلاع ما لم يكن لسؤال واحد متداخل على الأقل إجابة."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "ينطبق على جميع الأسئلة داخل هذه اللجنة. إذا كنت تريد إلغاء هذا الإعداد، فحدد قواعد محاذاة العنوان للأسئلة الفردية. يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع (\"أعلى\" افتراضيا)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "تعيين موقع رسالة خطأ فيما يتعلق بسؤال بإدخال غير صالح. اختر بين: \"أعلى\" - يتم وضع نص خطأ في أعلى مربع السؤال ؛ \"أسفل\" - يتم وضع نص خطأ في أسفل مربع السؤال. يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع (\"أعلى\" افتراضيا)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "تعيين موقع رسالة خطأ فيما يتعلق بجميع الأسئلة داخل اللوحة. يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "تغيير موضع اللوحة إلى نهاية الصفحة المحددة."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "يضيف مسافة أو هامش بين محتوى اللوحة والحد الأيسر لمربع اللوحة."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "قم بإلغاء التحديد لعرض اللوحة في سطر واحد مع السؤال أو اللوحة السابقة. لا ينطبق الإعداد إذا كانت اللوحة هي العنصر الأول في النموذج الخاص بك."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "اختر من بين: \"موسعة\" - يتم عرض اللوحة بالكامل ويمكن طيها ؛ \"مطوي\" - تعرض اللوحة العنوان والوصف فقط ويمكن توسيعها ؛ \"مغلق\" - يتم عرض اللوحة بالكامل ولا يمكن طيها."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "يضبط عرض اللوحة بما يتناسب مع عناصر الاستطلاع الأخرى في نفس السطر. يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "اكتب قالبا لعناوين اللوحات الديناميكية. استخدم {panelIndex} للموضع العام لللوحة و {visiblePanelIndex} لترتيبها بين اللوحات المرئية. قم بإدراج هذه العناصر النائبة في النموذج لإضافة ترقيم تلقائي."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "اكتب قالبا لعناوين علامات التبويب. استخدم {panelIndex} للموضع العام للوحة و {visiblePanelIndex} لترتيبها بين اللوحات المرئية. قم بإدراج هذه العناصر النائبة في النموذج لإضافة ترقيم تلقائي."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "يتيح لك هذا الإعداد التحكم في رؤية اللوحات الفردية داخل اللوحة الديناميكية. استخدم العنصر النائب \"{panel}\" للإشارة إلى اللوحة الحالية في تعبيرك."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "يتم توريث هذا الإعداد تلقائيا من خلال جميع الأسئلة داخل هذه اللوحة. إذا كنت تريد إلغاء هذا الإعداد، فحدد قواعد محاذاة العنوان للأسئلة الفردية. يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع (\"أعلى\" افتراضيا)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "يطبق خيار \"الوراثة\" الإعداد على مستوى الصفحة (إذا تم تعيينه) أو على مستوى الاستطلاع (\"تحت عنوان اللوحة\" افتراضيا)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "يحدد موضع اللوحة المضافة حديثا. بشكل افتراضي ، تتم إضافة لوحات جديدة إلى النهاية. حدد \"التالي\" لإدراج لوحة جديدة بعد اللوحة الحالية."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "يضاعف الإجابات من اللوحة الأخيرة ويعينها إلى اللوحة الديناميكية المضافة التالية."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "قم بالإشارة إلى اسم سؤال لمطالبة المستخدم بتقديم إجابة فريدة لهذا السؤال في كل لوحة."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "يسمح لك هذا الإعداد بتعيين قيمة إجابة افتراضية استنادا إلى تعبير. يمكن أن يتضمن التعبير حسابات أساسية - '{q1_id} + {q2_id}' ، والتعبيرات المنطقية ، مثل '{age} > 60' ، والدوالات: 'iif ()' ، 'today ()' ، 'age ()' ، 'min ()' ، 'max ()' ، 'avg ()' ، إلخ. تعمل القيمة التي يحددها هذا التعبير كقيمة افتراضية أولية يمكن تجاوزها بواسطة الإدخال اليدوي للمستجيب."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تحدد متى تتم إعادة تعيين إدخال المستجيب إلى القيمة استنادا إلى \"تعبير القيمة الافتراضية\" أو \"تعيين تعبير القيمة\" أو إلى قيمة \"الإجابة الافتراضية\" (إذا تم تعيين أي منهما)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "استخدم رمز العصا السحرية لتعيين قاعدة شرطية تحدد وقت تشغيل \"تعيين تعبير القيمة\" وتعيين القيمة الناتجة ديناميكيا كاستجابة."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "حدد تعبيرا يحدد القيمة المراد تعيينها عند استيفاء الشروط الواردة في قاعدة \"تعيين القيمة إذا\". يمكن أن يتضمن التعبير حسابات أساسية - '{q1_id} + {q2_id}' ، والتعبيرات المنطقية ، مثل '{age} > 60' ، والدوالات: 'iif ()' ، 'today ()' ، 'age ()' ، 'min ()' ، 'max ()' ، 'avg ()' ، إلخ. يمكن تجاوز القيمة التي يحددها هذا التعبير بواسطة الإدخال اليدوي للمستجيب."
// question.name: "A question ID that is not visible to respondents." => "معرف سؤال غير مرئي للمستجيبين."
// question.description: "Type a question subtitle." => "اكتب عنوانا فرعيا للسؤال."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تحدد رؤية السؤال."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تعطل وضع القراءة فقط للسؤال."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تمنع تقدم الاستطلاع أو إرساله ما لم يتلق السؤال إجابة."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "قم بإلغاء التحديد لعرض السؤال في سطر واحد مع السؤال أو اللوحة السابقة. لا ينطبق الإعداد إذا كان السؤال هو العنصر الأول في النموذج الخاص بك."
// question.page: "Repositions the question to the end of a selected page." => "تغيير موضع السؤال إلى نهاية الصفحة المحددة."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "اختر من بين: \"موسع\" - يتم عرض مربع السؤال بالكامل ويمكن طيه ؛ \"مطوي\" - يعرض مربع الأسئلة العنوان والوصف فقط ويمكن توسيعه ؛ \"مقفل\" - يتم عرض مربع الأسئلة بالكامل ولا يمكن طيه."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "يتجاوز قواعد محاذاة العنوان المحددة على مستوى اللوحة أو الصفحة أو الاستطلاع. يطبق خيار \"الوراثة\" أي إعدادات ذات مستوى أعلى (إذا تم تعيينها) أو إعداد على مستوى الاستطلاع (\"أعلى\" افتراضيا)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "يطبق خيار \"الوراثة\" الإعداد على مستوى الاستطلاع (\"ضمن عنوان السؤال\" افتراضيا)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "تعيين موقع رسالة خطأ فيما يتعلق بالسؤال مع إدخال غير صالح. اختر بين: \"أعلى\" - يتم وضع نص خطأ في أعلى مربع السؤال ؛ \"أسفل\" - يتم وضع نص خطأ في أسفل مربع السؤال. يطبق خيار \"الوراثة\" إعداد مستوى الاستطلاع (\"أعلى\" افتراضيا)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "إضافة مسافة أو هامش بين محتوى السؤال والحد الأيسر لمربع السؤال."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "يضبط عرض السؤال بما يتناسب مع عناصر الاستطلاع الأخرى في نفس السطر. يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "استخدم أيقونة العصا السحرية لتعيين قاعدة التحقق من صحة السؤال."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "اختر من بين: \"عند فقدان التركيز\" - يتم تحديث القيمة عندما يفقد حقل الإدخال التركيز ؛ \"أثناء الكتابة\" - يتم تحديث القيمة في الوقت الفعلي ، حيث يكتب المستخدمون. يطبق خيار \"الوراثة\" إعداد مستوى الاستطلاع (\"عند فقدان التركيز\" افتراضيا)."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "يمكنك استخدام أي خدمة ويب كمصدر بيانات لأسئلة الاختيار من متعدد. لتعبئة قيم الاختيار، أدخل عنوان URL للخدمة التي توفر البيانات."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "عملية مقارنة تستخدم لتصفية القائمة المنسدلة."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "يضبط عرض مساحة التوقيع المعروضة والصورة الناتجة."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "يضبط ارتفاع مساحة التوقيع المعروضة والصورة الناتجة."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "حدد ما إذا كنت تريد أن تملأ منطقة التوقيع كل المساحة المتوفرة داخل مربع السؤال مع الحفاظ على نسبة العرض إلى الارتفاع الافتراضية 3:2. عند تعيين قيم العرض والارتفاع المخصصة، سيحتفظ الإعداد بنسبة العرض إلى الارتفاع لهذه الأبعاد."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "يضبط ارتفاع الصورة في نتائج الاستطلاع."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "يضبط عرض الصورة في نتائج الاستطلاع."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "يتخطى قيم الحد الأدنى والحد الأقصى للارتفاع."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "يتخطى قيم الحد الأدنى والحد الأقصى للعرض."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "تعمل \"القيمة\" كمعرف عنصر مستخدم في القواعد الشرطية ؛ يتم عرض \"النص\" للمستجيبين."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "يغير هذا الإعداد حجم حقل الإدخال فقط ولا يؤثر على عرض مربع السؤال. للحد من طول الإدخال المقبول، انتقل إلى <b>التحقق من الصحة → الحد الأقصى لعدد الأحرف</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "يضبط عدد الأسطر المعروضة في حقل الإدخال. إذا كان الإدخال يشغل المزيد من الأسطر ، فسيظهر شريط التمرير."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "اختر بين: \"قابل للتحرير\" - يمكن المستجيبين من ملء الاستبيان الخاص بك ؛ \"للقراءة فقط\" - تعطيل تحرير النموذج."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "معرف عمود غير مرئي للمستجيبين."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "عند تمكين عمود، يطلب من المستجيب تقديم إجابة فريدة لكل سؤال داخل هذا العمود."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "يضبط عدد الأسطر المعروضة في حقل الإدخال. إذا كان الإدخال يشغل المزيد من الأسطر ، فسيظهر شريط التمرير."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تحدد رؤية العمود."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تعطل وضع القراءة فقط للعمود."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تمنع إرسال الاستطلاع ما لم يكن لسؤال واحد متداخل على الأقل إجابة."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "عند تحديده، ينشئ عمود منفرد لكل خيار اختيار."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "اختر من بين: \"ثابت\" - يحدد عرضا ثابتا ؛ \"متجاوب\" - يجعل الاستطلاع يشغل العرض الكامل للشاشة ؛ \"تلقائي\" - ينطبق على أي من الاثنين اعتمادا على أنواع الأسئلة المستخدمة."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "الصق رابط صورة (بلا حدود للحجم) أو انقر فوق رمز المجلد لاستعراض ملف من جهاز الكمبيوتر الخاص بك (حتى 64 كيلوبايت)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "يضبط عرض الشعار بوحدات CSS (px ، ٪ ، in ، pt ، إلخ)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "يضبط ارتفاع الشعار في وحدات CSS (px ، ٪ ، in ، pt ، إلخ)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "اختر من بين: \"لا شيء\" - تحافظ الصورة على حجمها الأصلي ؛ \"احتواء\" - يتم تغيير حجم الصورة لتلائم مع الحفاظ على نسبة العرض إلى الارتفاع ؛ \"الغلاف\" - تملأ الصورة المربع بأكمله مع الحفاظ على نسبة العرض إلى الارتفاع ؛ \"تعبئة\" - يتم تمديد الصورة لملء المربع دون الحفاظ على نسبة العرض إلى الارتفاع."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "حدد ما إذا كنت تريد أن يتقدم الاستطلاع إلى الصفحة التالية تلقائيا بعد أن يجيب المستجيب على جميع الأسئلة في الصفحة الحالية."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "يضبط رؤية وموقع أزرار التنقل على الصفحة."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "يضبط رؤية شريط التقدم وموقعه. تعرض القيمة \"تلقائي\" شريط التقدم أعلى رأس الاستطلاع أو أسفله."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "قم بتمكين صفحة المعاينة مع جميع الأسئلة أو الإجابة عليها فقط."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "ينطبق على جميع الأسئلة داخل الاستطلاع. يمكن تجاوز هذا الإعداد من خلال قواعد محاذاة العنوان في المستويات الأدنى: اللوحة أو الصفحة أو السؤال. سيتجاوز إعداد المستوى الأدنى تلك الموجودة في المستوى الأعلى."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "رمز أو سلسلة من الرموز تشير إلى أن الإجابة مطلوبة."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "أدخل رقما أو حرفا تريد بدء الترقيم به."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "تعيين موقع رسالة خطأ فيما يتعلق بالسؤال مع إدخال غير صالح. اختر بين: \"أعلى\" - يتم وضع نص خطأ في أعلى مربع السؤال ؛ \"أسفل\" - يتم وضع نص خطأ في أسفل مربع السؤال."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "حدد ما إذا كنت تريد أن يكون حقل الإدخال الأول في كل صفحة جاهزا لإدخال النص."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "يحافظ على الترتيب الأصلي للأسئلة أو يحولها عشوائيا. يكون تأثير هذا الإعداد مرئيا فقط في علامة التبويب معاينة."
// pehelp.maxTextLength: "For text entry questions only." => "لأسئلة إدخال النص فقط."
// pehelp.maxOthersLength: "For question comments only." => "لتعليقات الأسئلة فقط."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "حدد ما إذا كنت تريد زيادة تعليقات الأسئلة وأسئلة النص الطويل تلقائيا في الارتفاع بناء على طول النص الذي تم إدخاله."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "لتعليقات الأسئلة وأسئلة النص الطويل فقط."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "تعمل المتغيرات المخصصة كمتغيرات وسيطة أو مساعدة تستخدم في حسابات النماذج. يأخذون مدخلات المستجيبين كقيم مصدر. كل متغير مخصص له اسم فريد وتعبير يعتمد عليه."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "حدد ما إذا كنت ترغب في حفظ القيمة المحسوبة للتعبير مع نتائج الاستطلاع."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "المشغل هو حدث أو شرط يستند إلى تعبير. بمجرد تقييم التعبير إلى \"صواب\" ، يطلق المشغل إجراء. يمكن أن يكون لمثل هذا الإجراء اختياريا سؤال مستهدف يؤثر عليه."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "اختر ما إذا كنت تريد مسح قيم الأسئلة المخفية بواسطة المنطق الشرطي ومتى تريد القيام بذلك أم لا."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "اختر من بين: \"عند فقدان التركيز\" - يتم تحديث القيمة عندما يفقد حقل الإدخال التركيز ؛ \"أثناء الكتابة\" - يتم تحديث القيمة في الوقت الفعلي ، حيث يكتب المستخدمون."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "تعمل القيمة اليسرى كمعرف عمود مستخدم في القواعد الشرطية ، ويتم عرض القيمة الصحيحة للمستجيبين."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "تعمل القيمة اليسرى كمعرف صف مستخدم في القواعد الشرطية ، ويتم عرض القيمة الصحيحة للمستجيبين."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "تعيين موقع رسالة خطأ فيما يتعلق بخلية ذات إدخال غير صالح. يطبق خيار \"الوراثة\" الإعداد من خاصية \"محاذاة رسالة الخطأ\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "عند تمكين الخاصية \"منع الاستجابات المكررة\"، سيتلقى مستجيب يحاول إرسال إدخال مكرر رسالة الخطأ التالية."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "يسمح لك بحساب القيم الإجمالية استنادا إلى تعبير. يمكن أن يتضمن التعبير العمليات الحسابية الأساسية ('{q1_id} + {q2_id}') والتعبيرات المنطقية ('{age} > 60') والوظائف ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', إلخ)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "يؤدي إلى تشغيل مطالبة تطلب تأكيد حذف الصف."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "يكرر الإجابات من الصف الأخير ويعينها إلى الصف الديناميكي المضاف التالي."
// pehelp.description: "Type a subtitle." => "اكتب عنوانا فرعيا."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "اختر لغة لبدء إنشاء الاستطلاع. لإضافة ترجمة، قم بالتبديل إلى لغة جديدة وترجمة النص الأصلي هنا أو في علامة التبويب الترجمات."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "يضبط موقع قسم التفاصيل بالنسبة إلى صف. اختر من بين: \"لا شيء\" - لم تتم إضافة أي توسيع ؛ \"تحت الصف\" - يتم وضع توسيع الصف تحت كل صف من المصفوفة ؛ \"أسفل الصف ، اعرض توسيع صف واحد فقط\" - يتم عرض توسيع أسفل صف واحد فقط ، ويتم طي توسعات الصف المتبقية."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "اختر من بين: \"لا شيء\" - تحافظ الصورة على حجمها الأصلي ؛ \"احتواء\" - يتم تغيير حجم الصورة لتلائم مع الحفاظ على نسبة العرض إلى الارتفاع ؛ \"الغلاف\" - تملأ الصورة المربع بأكمله مع الحفاظ على نسبة العرض إلى الارتفاع ؛ \"تعبئة\" - يتم تمديد الصورة لملء المربع دون الحفاظ على نسبة العرض إلى الارتفاع."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "يزيد تدريجيا من ارتفاع حقل الإدخال أثناء إدخال البيانات. يتجاوز إعداد \"ارتفاع حقل الإدخال (في الأسطر)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "يظهر مقبض تغيير الحجم (أو المقبض) في الزاوية ويمكن سحبه لتغيير حجم حقل الإدخال."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "فاصل زمني بالثواني وبعد ذلك يتقدم الاستطلاع تلقائيا إلى صفحة الشكر."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "فاصل زمني بالثواني يتقدم بعده الاستطلاع تلقائيا إلى الصفحة التالية."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "فاصل زمني بالثواني يتقدم بعده الاستطلاع تلقائيا إلى الصفحة التالية."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تحدد رؤية الصفحة."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تعطل وضع القراءة فقط للصفحة."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تمنع إرسال الاستطلاع ما لم يكن لسؤال واحد متداخل على الأقل إجابة."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "ينطبق على جميع الأسئلة الواردة في هذه الصفحة. إذا كنت تريد إلغاء هذا الإعداد، فحدد قواعد محاذاة العنوان للأسئلة أو اللوحات الفردية. يطبق خيار \"الوراثة\" إعداد مستوى الاستطلاع (\"أعلى\" افتراضيا)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "تعيين موقع رسالة خطأ فيما يتعلق بالسؤال مع إدخال غير صالح. اختر بين: \"أعلى\" - يتم وضع نص خطأ في أعلى مربع السؤال ؛ \"أسفل\" - يتم وضع نص خطأ في أسفل مربع السؤال. يطبق خيار \"الوراثة\" إعداد مستوى الاستطلاع (\"أعلى\" افتراضيا)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "يحافظ على الترتيب الأصلي للأسئلة أو يحولها عشوائيا. يطبق خيار \"الوراثة\" إعداد مستوى الاستطلاع (\"أصلي\" افتراضيا). يكون تأثير هذا الإعداد مرئيا فقط في علامة التبويب معاينة."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "يضبط رؤية أزرار التنقل على الصفحة. يطبق خيار \"الوراثة\" إعداد مستوى الاستطلاع ، والذي يتم تعيينه افتراضيا على \"مرئي\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "يضبط رؤية وموقع المؤقت على الصفحة."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "اختر من بين: \"مقفل\" - لا يمكن للمستخدمين توسيع اللوحات أو طيها ؛ \"طي الكل\" - تبدأ جميع اللوحات في حالة انهيار ؛ \"توسيع الكل\" - تبدأ جميع اللوحات في حالة موسعة ؛ \"تم توسيعه أولا\" - تم توسيع اللوحة الأولى فقط في البداية."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "أدخل اسم خاصية مشتركة ضمن صفيف الكائنات التي تحتوي على عناوين URL لملفات الصور أو الفيديو التي تريد عرضها في قائمة الاختيارات."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "تعمل القيمة اليسرى كمعرف عنصر مستخدم في القواعد الشرطية ، ويتم عرض القيمة الصحيحة للمستجيبين."
// pehelp.title: "Type a user-friendly title to display." => "اكتب عنوانا سهل الاستخدام لعرضه."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "يضمن عدم إكمال المستخدمين للاستطلاع حتى يتم تحميل الملفات."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "في أنواع الأسئلة ذات التحديد الفردي والمتعدد، يكون لكل خيار اختيار معرف وقيمة عرض. عند تحديده، يعرض هذا الإعداد قيمة عرض بدلا من قيمة معرف في أسئلة HTML والعناوين الديناميكية وأوصاف عناصر الاستطلاع."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "اختر ما إذا كنت تريد مسح قيم الأسئلة المخفية بواسطة المنطق الشرطي أم لا ومتى تفعل ذلك. يطبق خيار \"الوراثة\" إعداد مستوى الاستطلاع (\"عند اكتمال الاستطلاع\" افتراضيا)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "اختر من بين: \"الكل\" - نسخ جميع خيارات الاختيار من السؤال المحدد ؛ \"محدد\" - ينسخ ديناميكيا خيارات الاختيار المحددة فقط ؛ \"غير محدد\" - ينسخ ديناميكيا خيارات الاختيار غير المحددة فقط. يتم نسخ الخيارين \"بلا\" و \"أخرى\" افتراضيا إذا تم تمكينهما في السؤال المصدر."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "عند تحديده، يمكن للمستخدمين تضمين مدخلات إضافية في مربع تعليق منفصل."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "يعرض كل خيار اختيار خاص (\"بلا\" ، \"أخرى\" ، \"تحديد الكل\") على سطر جديد ، حتى عند استخدام تخطيط متعدد الأعمدة."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "حدد الموقع داخل مجموعة بيانات الخدمة حيث يوجد الصفيف الهدف من الكائنات. اتركه فارغا إذا كان عنوان URL يشير بالفعل إلى المصفوفة."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "أدخل اسم خاصية موحد ضمن صفيف الكائنات الذي يحتوي على القيم التي تريد عرضها في قائمة الاختيارات."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "حدد للسماح للخدمة بإرجاع استجابة أو صفيف فارغ."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "استخدم أيقونة العصا السحرية لتعيين قاعدة شرطية تحدد رؤية كل خيارات الاختيار."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "تعمل القيمة اليسرى كمعرف عنصر مستخدم في القواعد الشرطية ، ويتم عرض القيمة الصحيحة للمستجيبين."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "يختار \"تلقائي\" بين وضعي \"الأزرار\" و \"القائمة المنسدلة\" بناء على العرض المتاح. عندما يكون العرض غير كاف لعرض الأزرار، يعرض السؤال قائمة منسدلة."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "يسمح لك بتوصيل الأسئلة التي تنتج نتائج بتنسيقات مختلفة. عندما يتم ربط هذه الأسئلة معا باستخدام معرف صلة، تخزن هذه الخاصية المشتركة قيم الأسئلة المحددة."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "حدد ما إذا كنت تريد تحديث محتويات القائمة المنسدلة لمطابقة استعلام البحث الذي يكتبه المستخدم في حقل الإدخال."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "قيمة يجب حفظها في نتائج الاستطلاع عندما يعطي المستجيبون إجابة إيجابية."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "قيمة يجب حفظها في نتائج الاستطلاع عندما يعطي المستجيبون إجابة سلبية."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "لا يوصى بتعطيل هذا الخيار لأنه يتجاوز صورة المعاينة ويجعل من الصعب على المستخدم فهم ما إذا كان قد تم تحميل الملفات أم لا."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "تشغيل مطالبة تطلب تأكيد حذف الملف."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "تمكين لترتيب الخيارات المحددة فقط. سيقوم المستخدمون بسحب العناصر المحددة من قائمة الاختيار لترتيبها داخل منطقة الترتيب."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "أدخل قائمة بالخيارات التي سيتم اقتراحها على المستجيب أثناء الإدخال."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "يغير الإعداد حجم حقول الإدخال فقط ولا يؤثر على عرض مربع السؤال."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "يضبط عرضا متناسقا لكل تسميات العناصر بالبكسل"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "يحدد الخيار \"تلقائي\" تلقائيا الوضع المناسب للعرض - الصورة أو الفيديو أو YouTube - بناء على عنوان URL المصدر المقدم."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "يعمل كبديل عندما يتعذر عرض الصورة على جهاز المستخدم ولأغراض إمكانية الوصول."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "يحدد لون الرموز التعبيرية المحددة عند تعيين نوع رمز التقييم على \"الوجوه الضاحكة\". اختر بين: \"افتراضي\" - يظهر الرمز التعبيري المحدد بلون الاستطلاع الافتراضي ؛ \"مقياس\" - يرث الرمز التعبيري المحدد اللون من مقياس التصنيف."
// expression.name: "An expression ID that is not visible to respondents." => "معرف تعبير غير مرئي للمستجيبين."
// expression.description: "Type an expression subtitle." => "اكتب عنوانا فرعيا للتعبير."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "يمكن أن يتضمن التعبير العمليات الحسابية الأساسية ('{q1_id} + {q2_id}') والشروط ('{age} > 60') والدوال ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', إلخ)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "حدد لتخزين قيمة الخيار \"أخرى\" كخاصية منفصلة في نتائج الاستطلاع."
// p.swapOrder: "Swap the order of Yes and No" => "مبادلة ترتيب نعم ولا"
// p.itemTitleWidth: "Item label width (in px)" => "عرض تسمية العنصر (بالبكسل)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "نص لإظهار ما إذا كانت كل الخيارات محددة"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "نص العنصر النائب لمنطقة الترتيب"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "إكمال الاستطلاع تلقائيا"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "حدد ما إذا كنت تريد إكمال الاستطلاع تلقائيا بعد أن يجيب المستجيب على جميع الأسئلة."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "حفظ القيمة المقنعة في نتائج الاستطلاع"
// patternmask.pattern: "Value pattern" => "نمط القيمة"
// datetimemask.min: "Minimum value" => "الحد الأدنى للقيمة"
// datetimemask.max: "Maximum value" => "القيمة القصوى"
// numericmask.allowNegativeValues: "Allow negative values" => "السماح بالقيم السالبة"
// numericmask.thousandsSeparator: "Thousands separator" => "فاصل الآلاف"
// numericmask.decimalSeparator: "Decimal separator" => "فاصل عشري"
// numericmask.precision: "Value precision" => "دقة القيمة"
// numericmask.min: "Minimum value" => "الحد الأدنى للقيمة"
// numericmask.max: "Maximum value" => "القيمة القصوى"
// currencymask.prefix: "Currency prefix" => "بادئة العملة"
// currencymask.suffix: "Currency suffix" => "لاحقة العملة"
// pe.maskType: "Input mask type" => "نوع قناع الإدخال"
// maskTypes.patternmask: "Pattern" => "رسم"
// maskTypes.numericmask: "Numeric" => "عددي"
// maskTypes.datetimemask: "Date and Time" => "التاريخ والوقت"
// maskTypes.currencymask: "Currency" => "عملة"
// tabs.mask: "Input Mask Settings" => "إعدادات قناع الإدخال"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "مثال: +1 (999) -999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "مثال: مم / يوم / سنة"
// pe.currencyprefix_placeholder: "Ex.: $" => "مثال: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "مثال: الدولار الأمريكي"
// pv.textWrapEnabled: "Wrap choices" => "خيارات الالتفاف"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "ستنشئ النصوص الطويلة في خيارات الاختيار فواصل أسطر تلقائيا لتلائم القائمة المنسدلة. قم بإلغاء تحديد ما إذا كنت تريد قص النصوص."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "حدد ما إذا كنت تريد تخزين قيمة السؤال باستخدام قناع مطبق في نتائج الاستطلاع."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "يمكن أن يحتوي النمط على حرفي السلسلة والعناصر النائبة التالية: \"9\" - للرقم ؛ \"a\" - لحرف كبير أو صغير ؛ '#' - لرقم أو حرف كبير أو صغير. استخدم الشرطة المائلة للخلف '\\' للهروب من حرف."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "يمكن أن يحتوي النمط على أحرف فاصلة والعناصر النائبة التالية: \"m\" - لرقم الشهر ؛ \"mm\" - لرقم الشهر ، مع صفر بادئ للقيم المكونة من رقم واحد ؛ \"d\" - ليوم من الشهر ؛ \"dd\" - ليوم من الشهر ، مع صفر بادئ للقيم المكونة من رقم واحد ؛ \"yy\" - لآخر رقمين من السنة ؛ \"YYYY\" - لمدة عام مكون من أربعة أرقام."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "رمز يستخدم لفصل الجزء الكسري عن الجزء الصحيح من الرقم المعروض."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "رمز يستخدم لفصل أرقام عدد كبير إلى مجموعات من ثلاثة."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "يحد من عدد الأرقام التي سيتم الاحتفاظ بها بعد الفاصلة العشرية لرقم معروض."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "رمز واحد أو عدة رموز ليتم عرضها قبل القيمة."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "رمز واحد أو عدة رموز ليتم عرضها بعد القيمة."
// ed.translationSource: "Source: " => "مصدر: "
// ed.translationTarget: "Target: " => "هدف: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "الصفحة فارغة. اسحب عنصرا من صندوق الأدوات أو انقر فوق الزر أدناه."
// maskTypes.none: "None" => "اي"
// itemvalue@rows.visibleIf: "Make the row visible if" => "اجعل الصف مرئيا إذا"
// itemvalue@rows.enableIf: "Make the row editable if" => "اجعل الصف قابلا للتحرير إذا"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "نص العنصر النائب في وضع القراءة فقط أو المعاينة"
// pe.textWrapEnabled: "Wrap choices" => "خيارات الالتفاف"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "يحدد الخيار \"تلقائي\" تلقائيا الوضع المناسب للعرض - الصورة أو الفيديو أو YouTube - بناء على عنوان URL المصدر المقدم."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "اختر بين \"صورة\" و \"فيديو\" لتعيين وضع المحتوى لمحدد الوسائط. إذا تم تحديد \"صورة\" ، فتأكد من أن جميع الخيارات المتوفرة هي ملفات صور بالتنسيقات التالية: JPEG و GIF و PNG و APNG و SVG و BMP و ICO. وبالمثل ، إذا تم تحديد \"فيديو\" ، فتأكد من أن جميع الخيارات هي روابط مباشرة لملفات الفيديو بالتنسيقات التالية: MP4 و MOV و WMV و FLV و AVI و MKV. يرجى ملاحظة أن روابط YouTube غير مدعومة لخيارات الفيديو."
// ed.selectFile: "Select a file" => "حدد ملفا"
// ed.removeFile: "Remove the file" => "إزالة الملف"
// pe.searchMode: "Search Mode" => "وضع البحث"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "انقر فوق الزر \"إضافة سؤال\" أدناه لبدء إنشاء النموذج الخاص بك."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "انقر فوق الزر \"إضافة سؤال\" أدناه لإضافة عنصر جديد إلى الصفحة."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "انقر فوق الزر \"إضافة سؤال\" أدناه لإضافة عنصر جديد إلى اللوحة."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "انقر فوق الزر أدناه واختر صورة لتحميلها"
// coloralpha.opacity: "Opacity" => "العتامه"
// font.family: "Font family" => "عائلة الخط"
// font.color: "Color" => "لون"
// font.placeholderColor: "Placeholder color" => "لون العنصر النائب"
// font.size: "Size" => "حجم"
// theme.themeName: "Theme" => "موضوع"
// theme.isPanelless: "Question appearance" => "مظهر السؤال"
// theme.editorPanel: "Background and corner radius" => "الخلفية ونصف قطر الزاوية"
// theme.questionPanel: "Background and corner radius" => "الخلفية ونصف قطر الزاوية"
// theme.primaryColor: "Accent color" => "لون التمييز"
// theme.panelBackgroundTransparency: "Panel background opacity" => "عتامة خلفية اللوحة"
// theme.questionBackgroundTransparency: "Question background opacity" => "عتامة خلفية السؤال"
// theme.fontSize: "Font size" => "حجم الخط"
// theme.scale: "Scale" => "مِيزَان"
// theme.cornerRadius: "Corner radius" => "نصف قطر الزاوية"
// theme.pageTitle: "Title font" => "خط العنوان"
// theme.pageDescription: "Description font" => "خط الوصف"
// theme.questionTitle: "Title font" => "خط العنوان"
// theme.questionDescription: "Description font" => "خط الوصف"
// theme.editorFont: "Font" => "الخط"
// theme.backgroundOpacity: "Opacity" => "العتامه"
// theme.--sjs-font-family: "Font family" => "عائلة الخط"
// theme.--sjs-general-backcolor-dim: "Background color" => "لون الخلفية"
// theme.--sjs-primary-backcolor: "Accent background" => "خلفية لهجة"
// theme.--sjs-primary-forecolor: "Accent foreground" => "لهجة الصدارة"
// theme.--sjs-shadow-small: "Shadow effects" => "تأثيرات الظل"
// theme.--sjs-shadow-inner: "Shadow effects" => "تأثيرات الظل"
// theme.--sjs-border-default: "Colors" => "الوان"
// header@header.headerView: "View" => "منظر"
// header@header.logoPosition: "Logo position" => "موضع الشعار"
// header@header.surveyTitle: "Survey title font" => "خط عنوان الاستطلاع"
// header@header.surveyDescription: "Survey description font" => "خط وصف الاستطلاع"
// header@header.headerTitle: "Survey title font" => "خط عنوان الاستطلاع"
// header@header.headerDescription: "Survey description font" => "خط وصف الاستطلاع"
// header@header.inheritWidthFrom: "Content area width" => "عرض منطقة المحتوى"
// header@header.textAreaWidth: "Text width" => "عرض النص"
// header@header.backgroundColorSwitch: "Background color" => "لون الخلفية"
// header@header.backgroundImage: "Background image" => "صورة الخلفية"
// header@header.backgroundImageOpacity: "Opacity" => "العتامه"
// header@header.overlapEnabled: "Overlap" => "التداخل"
// header@header.logoPositionX: "Logo position" => "موضع الشعار"
// header@header.titlePositionX: "Title position" => "موضع العنوان"
// header@header.descriptionPositionX: "Description position" => "موقف الوصف"
// weight.400: "Regular" => "منتظم"
// weight.600: "Heavy" => "ثقيل"
// weight.700: "Semi-bold" => "شبه غامق"
// weight.800: "Bold" => "جريء"
// backgroundImageFit.auto: "Auto" => "تلقائي"
// backgroundImageFit.cover: "Cover" => "غطاء"
// backgroundImageFit.contain: "Contain" => "احتوى"
// backgroundImageFit.fill: "Stretch" => "مد"
// backgroundImageFit.tile: "Tile" => "بلاط"
// backgroundImageAttachment.fixed: "Fixed" => "ثابت"
// backgroundImageAttachment.scroll: "Scroll" => "طومار"
// headerView.basic: "Basic" => "أساسي"
// headerView.advanced: "Advanced" => "متقدم"
// inheritWidthFrom.survey: "Same as survey" => "نفس المسح"
// inheritWidthFrom.container: "Fit to container" => "يصلح للحاوية"
// backgroundColorSwitch.none: "None" => "اي"
// backgroundColorSwitch.accentColor: "Accent color" => "لون التمييز"
// backgroundColorSwitch.custom: "Custom" => "تقليد"
// colorPalette.light: "Light" => "ضوء"
// colorPalette.dark: "Dark" => "داكن"
// isPanelless.false: "Default" => "افتراضي"
// isPanelless.true: "Without Panels" => "بدون لوحات"
// theme.cornerRadius: "Corner radius" => "نصف قطر الزاوية"
// theme.fontFamily: "Font family" => "عائلة الخط"
// theme.fontWeightRegular: "Regular" => "منتظم"
// theme.fontWeightHeavy: "Heavy" => "ثقيل"
// theme.fontWeightSemiBold: "Semi-bold" => "شبه غامق"
// theme.fontWeightBold: "Bold" => "جريء"
// theme.color: "Color" => "لون"
// theme.placeholderColor: "Placeholder color" => "لون العنصر النائب"
// theme.size: "Size" => "حجم"
// theme.opacity: "Opacity" => "العتامه"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "اكتب للبحث..."
// ed.toolboxNoResultsFound: "No results found" => "لم يتم العثور على نتائج"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "العنصر النائب لعنوان علامة التبويب"
// theme.--sjs-special-red: "Error messages" => "رسائل الخطأ"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "نص احتياطي لعناوين علامات التبويب يتم تطبيقه عندما لا ينتج نمط عنوان علامة التبويب قيمة ذات معنى."
// theme.fontColor: "Font color" => "لون الخط"
// theme.backgroundColor: "Background color" => "لون الخلفية"
// pe.questionTitleWidth: "Question title width" => "عرض عنوان السؤال"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "حدد ملفا أو الصق رابط ملف..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "مثال: 200 بكسل"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "يعين عرضا متناسقا لعناوين الأسئلة عندما تتم محاذاتها إلى يسار مربعات الأسئلة الخاصة بها. يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "يعين عرضا متناسقا لعناوين الأسئلة عندما تتم محاذاتها إلى يسار مربعات الأسئلة الخاصة بها. يقبل قيم CSS (px ، ٪ ، in ، pt ، إلخ)."
// pe.commentAreaRows: "Comment area height (in lines)" => "ارتفاع منطقة التعليق (في الأسطر)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "يضبط عدد الأسطر المعروضة في مساحات النص لتعليقات الأسئلة. في الإدخال يأخذ المزيد من الأسطر ، يظهر شريط التمرير."


/***/ }),

/***/ "./src/localization/bulgarian.ts":
/*!***************************************!*\
  !*** ./src/localization/bulgarian.ts ***!
  \***************************************/
/*! exports provided: bgStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bgStrings", function() { return bgStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var bgStrings = {
    // survey templates
    survey: {
        edit: "Редактиране",
        externalHelpLink: "Гледай и научи как се създават анкети.",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Моля, изтегли въпрос от кутията с инструменти.",
        addLogicItem: "Създай правило, за да персонализираш анкетата.",
        copy: "Копиране",
        duplicate: "Дубликат",
        addToToolbox: "Добавяне към кутията с инструменти",
        deletePanel: "Изтриване на панел",
        deleteQuestion: "Изтриване на въпрос",
        convertTo: "Преобразуване",
        drag: "Изтегляне на елемент",
    },
    // Creator tabs
    tabs: {
        preview: "Преглед",
        theme: "Теми",
        translation: "Превод",
        designer: "Дизайнер",
        editor: "JSON редактор",
        logic: "Логика"
    },
    // Question types
    qt: {
        default: "По подразбиране",
        checkbox: "Квадратчета за отметка",
        comment: "Дълъг текст",
        imagepicker: "Избор на изображение",
        ranking: "Класиране",
        image: "Изображение",
        dropdown: "Падащо меню",
        tagbox: "Падащо меню за множествен избор",
        file: "Качване на файл",
        html: "HTML",
        matrix: "Матрица с единичен избор",
        matrixdropdown: "Матрица с множествен избор",
        matrixdynamic: "Динамична матрица",
        multipletext: "Множество от текстови полета",
        panel: "Панел",
        paneldynamic: "Динамичен панел",
        radiogroup: "Група радиобутони",
        rating: "Рейтингова скала",
        text: "Едноредов вход",
        boolean: "Да/Не (булеви стойности)",
        expression: "Израз (само за четене)",
        signaturepad: "Подпис",
        buttongroup: "Група бутони"
    },
    toolboxCategories: {
        general: "Общ",
        choice: "Въпроси за избор",
        text: "Въпроси с въвеждане на текст",
        containers: "Контейнери",
        matrix: "Матрица с въпроси",
        misc: "Разни"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "По подразбиране ({0})",
        survey: "Анкета",
        settings: "Настройки",
        settingsTooltip: "Отваряне на настройките",
        surveySettings: "Настройки на анкетата",
        surveySettingsTooltip: "Настройки на проучването",
        themeSettings: "Настройки на тема",
        themeSettingsTooltip: "Настройки на тема",
        showPanel: "Показване на панела",
        hidePanel: "Скриване на панела",
        prevSelected: "Избиране на предишен",
        nextSelected: "Избиране на следващ",
        prevFocus: "Фокус предишен",
        nextFocus: "Фокусирай се върху следващия",
        surveyTypeName: "Анкета",
        pageTypeName: "Страница",
        panelTypeName: "Паниел",
        questionTypeName: "Въпрос",
        columnTypeName: "Колона",
        addNewPage: "Добавяне на нова страница",
        moveRight: "Превърти надясно",
        moveLeft: "Превърти наляво",
        deletePage: "Изтриване на страница",
        editPage: "Редактиране на страница",
        edit: "Редактиране",
        newPageName: "страница",
        newQuestionName: "въпрос",
        newPanelName: "панел",
        newTextItemName: "текст",
        defaultV2Theme: "По подразбиране",
        modernTheme: "Модерен",
        defaultTheme: "По подразбиране (по наследство)",
        testSurveyAgain: "Прегледай анкетата отново",
        testSurveyWidth: "Широчина на анкетата: ",
        navigateToMsg: "Трябва да навигираш до",
        saveSurvey: "Запазване на анкетата",
        saveSurveyTooltip: "Запазване на анкетата",
        saveTheme: "Запиши темата",
        saveThemeTooltip: "Запиши темата",
        jsonHideErrors: "Скриване на грешки",
        jsonShowErrors: "Показване на грешки",
        undo: "Отмяна",
        redo: "Повтаряне",
        undoTooltip: "Отмяна на последната промяна",
        redoTooltip: "Повтаряне на последната промяна",
        showMoreChoices: "Покажи повече.",
        showLessChoices: "Покажи по-малко.",
        copy: "Копиране",
        cut: "Изрязване",
        paste: "Поставяне на копираното",
        copyTooltip: "Копиране на селектираното в клипборда",
        cutTooltip: "Изрязване на селекцията в клипборда",
        pasteTooltip: "Поставяне от клипборда",
        options: "Опции",
        generateValidJSON: "Генериране на валиден JSON",
        generateReadableJSON: "Генериране на четим JSON",
        toolbox: "Кутия с инструменти",
        "property-grid": "Свойства",
        toolboxFilteredTextPlaceholder: "Въведете за търсене...",
        toolboxNoResultsFound: "Няма намерени резултати",
        propertyGridFilteredTextPlaceholder: "Въведи за търсене...",
        propertyGridNoResultsFound: "Няма намерени резултати",
        correctJSON: "Моля, коригирай JSON.",
        surveyResults: "Резултати от анкетата ",
        surveyResultsTable: "Като таблица",
        surveyResultsJson: "Като JSON",
        resultsTitle: "Заглавие на въпроса",
        resultsName: "Име на въпроса",
        resultsValue: "Стойност на отговора",
        resultsDisplayValue: "Показване на стойност",
        modified: "Променен",
        saving: "Спасен",
        saved: "Запазен",
        propertyEditorError: "Грешка",
        saveError: "Грешка! Съдържанието на редактора не е запазено.",
        translationPropertyGridTitle: "Езикови настройки",
        themePropertyGridTitle: "Настройки на тема",
        translationLanguages: "Езици",
        translationDeleteLanguage: "Сигурни ли сте, че искате да изтриете всички низове за този език?",
        translationAddLanguage: "Изберане на език за превод",
        translationShowAllStrings: "Всички низове",
        translationShowUsedStringsOnly: "Само използвани низове",
        translationShowAllPages: "Всички страници",
        translationNoStrings: "Няма низове за превод. Моля, промени филтъра.",
        translationExportToSCVButton: "Експортиране в CSV",
        translationImportFromSCVButton: "Импортиране от CSV",
        translateUsigAI: "Автоматичен превод на всички",
        translateUsigAIFrom: "Преведи от: ",
        translationDialogTitle: "Непреведени низове",
        translationMergeLocaleWithDefault: "Обединение {0} с локалната стойност по подразбиране",
        translationPlaceHolder: "Превод...",
        translationSource: "Източник: ",
        translationTarget: "Цел: ",
        themeExportButton: "Износ",
        themeImportButton: "Внос",
        surveyJsonExportButton: "Износ",
        surveyJsonImportButton: "Внос",
        surveyJsonCopyButton: "Копиране в системния буфер",
        themeResetButton: "Връщане на настройките на тема в начално състояние по подразбиране",
        themeResetConfirmation: "Наистина ли искате да нулирате темата? Всички ваши персонализации ще бъдат загубени.",
        themeResetConfirmationOk: "Да, нулирайте темата",
        bold: "Удебелен",
        italic: "Курсив",
        underline: "Подчертан",
        addNewQuestion: "Добавяне на въпрос",
        selectPage: "Избиране на страница...",
        carryForwardChoicesCopied: "Възможностите за избор се копират от",
        choicesLoadedFromWebText: "Възможностите за избор се зареждат от уеб услуга.",
        choicesLoadedFromWebLinkText: "Отидете в настройките",
        choicesLoadedFromWebPreviewTitle: "Визуализация на заредените опции за избор",
        htmlPlaceHolder: "HTML съдържанието ще бъде тук.",
        panelPlaceHolder: "Пусни въпроса от кутията с инструменти тук.",
        surveyPlaceHolder: "Анкетата е празна. Плъзни елемент от кутията с инструменти или щракни върху бутона по-долу.",
        pagePlaceHolder: "Страницата е празна. Плъзнете елемент от кутията с инструменти или щракнете върху бутона по-долу.",
        imagePlaceHolder: "Плъзни и пусни изображение тук или щракни върху бутона по-долу и избери изображение за качване.",
        surveyPlaceHolderMobile: "Кликнете върху бутона \"Добавяне на въпрос\" по-долу, за да започнете да създавате своя формуляр.",
        pagePlaceHolderMobile: "Кликнете върху бутона \"Добавяне на въпрос\" по-долу, за да добавите нов елемент към страницата.",
        panelPlaceHolderMobile: "Кликнете върху бутона \"Добавяне на въпрос\" по-долу, за да добавите нов елемент към панела.",
        imagePlaceHolderMobile: "Кликнете върху бутона по-долу и изберете изображение за качване",
        imageChooseImage: "Избери изображение.",
        addNewTypeQuestion: "Добави {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Елемент ",
        selectFile: "Изберете файл",
        removeFile: "Премахване на файла",
        lg: {
            addNewItem: "Добавяне на ново правило",
            empty_tab: "Създай правило за персонализиране на анкетата.",
            page_visibilityName: "Показване (скриване) на страница",
            page_enableName: "Активиране (деактивиране) на страница",
            page_requireName: "Направи страницата задължителна",
            panel_visibilityName: "Показване (скриване) на панел",
            panel_enableName: "Активиране (деактивиране) на панел",
            panel_requireName: "Направи страницата задължителна",
            question_visibilityName: "Показване (скриване) на въпрос",
            question_enableName: "Активиране (деактивиране) на въпрос",
            question_requireName: "Задай въпроса като задължителен.",
            question_resetValueName: "Нулиране на стойността на въпроса",
            question_setValueName: "Задаване на стойност на въпрос",
            column_visibilityName: "Показване (скриване) на колона",
            column_enableName: "Активиране (деактивиране) на колона",
            column_requireName: "Задай колоната като задължителна.",
            column_resetValueName: "Нулиране на стойността на колона",
            column_setValueName: "Задаване на стойност на колона",
            trigger_completeName: "Попълнена анкета",
            trigger_setvalueName: "Задаване на отговор",
            trigger_copyvalueName: "Копиране на отговор",
            trigger_skipName: "Преминаване към въпрос",
            trigger_runExpressionName: "Стартиране на израза",
            completedHtmlOnConditionName: "Задай маркиране на страницата \"Анкетата е завършена.\".",
            page_visibilityDescription: "Страницата става видима, ако логическият израз върне истина. В противен случай остава невидима.",
            panel_visibilityDescription: "Панелът става видим, ако логическият израз върне истина. В противен случай остава невидим.",
            panel_enableDescription: "Панелът и всички елементи в него стават активирани, ако логическият израз върне истина. В противен случай остават деактивирани.",
            question_visibilityDescription: "Въпросът става видим, ако логическият израз върне истина. В противен случай остава невидим.",
            question_enableDescription: "Въпросът става активиран, ако логическият израз върне истина. В противен случай остава деактивиран.",
            question_requireDescription: "Въпросът става задължителен, ако логическият израз върне истина.",
            trigger_completeDescription: "Когато логическият израз върне вярно, анкетата приключва и потребителят вижда страницата 'Благодаря'.",
            trigger_setvalueDescription: "Когато стойностите на въпроса, които се използват в логическия израз, се променят и логическият израз върне вярно, тогава стойността се задава от избрания въпрос.",
            trigger_copyvalueDescription: "Когато стойностите на въпроса, които се използват в логическия израз, се променят и логическият израз върне вярно, тогава стойността на един избран въпрос се копира в друг избран въпрос.",
            trigger_skipDescription: "Когато логическият израз върне вярно, анкетата преминава / фокусира се към избрания въпрос.",
            trigger_runExpressionDescription: "Когато логическият израз върне истина, тогава се изпълнява персонализираният израз. По желание може да зададете този израз в избрания въпрос.",
            completedHtmlOnConditionDescription: "Ако логическият израз върне вярно, то текстът по подразбиране за страницата „Благодаря“ се променя с дадения.",
            itemExpressionText: "Когато логическият израз: '{0}' върне истина",
            itemEmptyExpressionText: "Ново правило",
            page_visibilityText: "направи страница {0} видима",
            panel_visibilityText: "направи панел {0} видим",
            panel_enableText: "направи панел {0} активен",
            question_visibilityText: "направи въпрос {0} видим",
            question_enableText: "направи въпрос {0} активен",
            question_requireText: "направи въпрос {0} задължителен",
            question_resetValueText: "нулиране на стойността за въпрос: {0}",
            question_setValueText: "присвояване на стойност: {1} на въпрос: {0}",
            column_visibilityText: "направи колона {0} на въпрос {1} видима",
            column_enableText: "направи колона {0} на въпрос {1} активна",
            column_requireText: "направи колона {0} на въпрос {1} задължителна",
            column_resetValueText: "Нулиране на стойността на клетката за колона: {0}",
            column_setValueText: "Присвояване на стойност на клетка: {1} на колона: {0}",
            setValueExpressionPlaceholder: " Израз, чийто резултат ще бъде присвоен на целевия въпрос.",
            trigger_completeText: "анкетата е завършена",
            trigger_setvalueText: "задай на въпрос: {0} стойност {1}",
            trigger_setvalueEmptyText: "ясна стойност на въпроса: {0}",
            trigger_copyvalueText: "копирай във въпрос: {0} стойност от въпрос {1}",
            trigger_skipText: "анкетата преминава към въпрос {0}",
            trigger_runExpressionText1: "стартов израз: '{0}'",
            trigger_runExpressionText2: " и постави резултата му под въпрос: {0}",
            completedHtmlOnConditionText: "показване на персонализиран текст за страницата „Благодарности“.",
            showAllQuestions: "Всички въпроси",
            showAllActionTypes: "Всички типове действие",
            conditions: "Условие/условия",
            actions: "Действие/действия",
            expressionEditorTitle: "Дефинирай условието/условията",
            actionsEditorTitle: "Дефинирай действието/действията",
            deleteAction: "Изтриване на действие",
            addNewAction: "Добавяне на действие",
            selectedActionCaption: "Избиране на действие...",
            expressionInvalid: "Логическият израз е празен или невалиден. Моля, коригирайте го.",
            noActionError: "Моля, добави поне едно действие.",
            actionInvalid: "Моля, отстрани проблемите във вашите действия.",
            uncompletedRule_title: "Сигурен ли си, че искаш да напуснеш раздела?",
            uncompletedRule_text: "Едно или повече логически правила са незавършени. Ако напуснеш раздела, тези промени, които не може да бъдат приложени, ще изчезнат. Сигурен ли си, че искаш да напуснеш раздела?",
            uncompletedRule_apply: "Да",
            uncompletedRule_cancel: "Не, искам да попълня правилата."
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Име на панела",
            title: "Заглавие на панела",
            description: "Описание на панела",
            visibleIf: "Направете панела видим, ако",
            requiredIf: "Направете панела необходим, ако",
            questionsOrder: "Ред на въпросите в рамките на панела",
            page: "Родителска страница",
            startWithNewLine: "Показване на панела на нов ред",
            state: "Състояние на свиване на панела",
            width: "Ширина на вградения панел",
            minWidth: "Минимална ширина на панела",
            maxWidth: "Максимална ширина на панела",
            showNumber: "Числени панели"
        },
        paneldynamic: {
            name: "Име на панела",
            title: "Заглавие на панела",
            description: "Описание на панела",
            visibleIf: "Направете панела видим, ако",
            requiredIf: "Направете панела необходим, ако",
            page: "Преместване на панела на страница",
            startWithNewLine: "Показване на панела на нов ред",
            state: "Състояние на свиване на панела",
            width: "Ширина на вградения панел",
            minWidth: "Минимална ширина на панела",
            maxWidth: "Максимална ширина на панела",
            confirmDelete: "Потвърждаване изтриването на панел",
            templateDescription: "Модел за описание на панела",
            templateTitle: "Модел на заглавие на панел",
            noEntriesText: "Празен текст на панел",
            templateTabTitle: "Шаблон на заглавие на раздел",
            tabTitlePlaceholder: "Контейнер за заглавие на раздел",
            templateVisibleIf: "Направете отделен панел видим, ако",
            hideNumber: "Скриване на номера на панела",
            titleLocation: "Подравняване на заглавието на панела",
            descriptionLocation: "Подравняване на описанието на панела",
            templateTitleLocation: "Подравняване на заглавието на въпроса",
            templateErrorLocation: "Подравняване на съобщение за грешка",
            newPanelPosition: "Ново местоположение на панела",
            keyName: "Предотвратяване на дублиращи се отговори в следния въпрос"
        },
        question: {
            name: "Име на въпрос",
            title: "Заглавие на въпроса",
            description: "Описание на въпроса",
            visibleIf: "Направете въпроса видим, ако",
            requiredIf: "Задайте въпроса, който е необходим, ако",
            page: "Родителска страница",
            state: "Състояние на свиване на полето за въпроси",
            hideNumber: "Скриване на номера на въпроса",
            titleLocation: "Подравняване на заглавието на въпроса",
            descriptionLocation: "Подравняване на описанието на въпроса",
            errorLocation: "Подравняване на съобщение за грешка",
            indent: "Увеличаване на вътрешния отстъп",
            width: "Ширина на вградения въпрос",
            minWidth: "Минимална ширина на въпросите",
            maxWidth: "Максимална ширина на въпроса",
            textUpdateMode: "Актуализиране на стойността на входното поле"
        },
        signaturepad: {
            signatureWidth: "Ширина на областта за подпис",
            signatureHeight: "Височина на областта за подпис",
            signatureAutoScaleEnabled: "Автоматично мащабиране на областта за подписи",
            showPlaceholder: "Показване на контейнера",
            placeholder: "Текст в контейнер",
            placeholderReadOnly: "Текст в контейнер в режим само за четене или визуализация",
            allowClear: "Показване на бутона \"Изчисти\" в областта за подписи",
            penMinWidth: "Минимална ширина на писалката",
            penMaxWidth: "Максимална ширина на перото",
            penColor: "Цвят на щрихите"
        },
        comment: {
            rows: "Височина на входното поле (в редове)"
        },
        showQuestionNumbers: "Номериране на въпросите",
        questionStartIndex: "Начален индекс (цифра или буква)",
        expression: {
            name: "Име на израз",
            title: "Заглавие на израза",
            description: "Описание на израза",
            expression: "Изразяване"
        },
        trigger: {
            expression: "Изразяване"
        },
        calculatedvalue: {
            expression: "Изразяване"
        },
        // survey templates
        survey: {
            title: "Заглавие",
            description: "Описание на проучването"
        },
        page: {
            name: "Име на страница",
            title: "Заглавие",
            description: "Описание на страницата",
            visibleIf: "Направете страницата видима, ако",
            requiredIf: "Направете страницата задължителна, ако",
            maxTimeToFinish: "Времево ограничение за завършване на страницата (в секунди)",
            questionsOrder: "Ред на въпросите на страницата"
        },
        matrixdropdowncolumn: {
            name: "Име на колона",
            title: "Заглавие на колоната",
            isUnique: "Предотвратяване на дублиращи се отговори",
            width: "Ширина на колона",
            minWidth: "Минимална ширина на колоната",
            rows: "Височина на входното поле (в редове)",
            visibleIf: "Направете колоната видима, ако",
            requiredIf: "Направете колоната задължителна, ако",
            showInMultipleColumns: "Всяка опция в отделна колона"
        },
        multipletextitem: {
            name: "Име",
            title: "Заглавие"
        },
        masksettings: {
            saveMaskedValue: "Запазване на маскирана стойност в резултатите от проучването"
        },
        patternmask: {
            pattern: "Шаблон на стойност"
        },
        datetimemask: {
            min: "Минимална стойност",
            max: "Максимална стойност"
        },
        numericmask: {
            allowNegativeValues: "Позволяване на отрицателни стойности",
            thousandsSeparator: "Разделител за хиляди",
            decimalSeparator: "Десетичен разделител",
            precision: "Точност на стойността",
            min: "Минимална стойност",
            max: "Максимална стойност"
        },
        currencymask: {
            prefix: "Валутен префикс",
            suffix: "Валутен суфикс"
        },
        imageHeight: "Височина на изображението",
        imageWidth: "Широчина на изображението",
        valueName: "Съхранявай отговорите в следното JSON поле.",
        rateDescriptionLocation: "Подравняване на етикети",
        size: "Размер на въвеждане (в знаци)",
        cellErrorLocation: "Подравняване на съобщение за грешка в клетка",
        apply: "Приложи",
        ok: "ДА",
        save: "Запази",
        clear: "Изчисти",
        saveTooltip: "Запази",
        cancel: "Откажи",
        set: "Окомплектовай",
        reset: "Нулиране",
        change: "Промени",
        refresh: "Опресни",
        close: "Затвори",
        delete: "Изтрий",
        add: "Добави",
        addNew: "Добави нов",
        addItem: "Кликни за добавяне на елемент...",
        removeItem: "Кликни за изтриване на елемент...",
        dragItem: "Плъзни елемента",
        addOther: "Друг",
        addSelectAll: "Избери всички",
        addNone: "Нито един",
        removeAll: "Премахни всички",
        edit: "Редактиране",
        back: "Връщане без запазване",
        backTooltip: "Връщане без запазване",
        saveAndBack: "Запазване и връщане",
        saveAndBackTooltip: "Запазване и връщане",
        doneEditing: "Завършен",
        editChoices: "Редактиране на избора",
        showChoices: "Показване на избора",
        move: "Ход",
        empty: "<празен>",
        emptyValue: "Стойността е празна.",
        fastEntry: "Ръчно въвеждане",
        fastEntryNonUniqueError: "Стойността '{0}' не е уникална.",
        fastEntryChoicesCountError: "Моля, ограничи броя на елементите от {0} до {1}",
        fastEntryChoicesMinCountError: "Моля, въведете поне {0} артикула",
        fastEntryPlaceholder: "Може да зададеш данни в следния формат:стойност1|текстстойност2",
        formEntry: "Въвеждане на формуляр",
        testService: "Тествай услугата.",
        itemSelectorEmpty: "Моля, избери елемент.",
        conditionActionEmpty: "Моля, избери действие.",
        conditionSelectQuestion: "Избери въпрос...",
        conditionSelectPage: "Избери страница...",
        conditionSelectPanel: "Избери панел...",
        conditionValueQuestionTitle: "Моля, въведи/избери стойността.",
        aceEditorHelp: "Натисни ctrl+space за подсказка за окомплектоване на израза.",
        aceEditorRowTitle: "Текущ ред",
        aceEditorPanelTitle: "Текущ панел",
        showMore: "За повече подробности, моля, провери документацията.",
        assistantTitle: "Налични въпроси",
        cellsEmptyRowsColumns: "Трябва да има поне една колона или ред.",
        showPreviewBeforeComplete: "Визуализирай отговорите, преди да изпратиш анкетата.",
        overridingPropertyPrefix: "Зададено от ",
        resetToDefaultCaption: "Проучване",
        propertyIsEmpty: "Моля, въведи стойност.",
        propertyIsNoUnique: "Моля, въведи уникална стойност.",
        propertyNameIsNotUnique: "Моля, въведи уникално име.",
        propertyNameIsIncorrect: "Не използвай запазени думи, като: \"елемент\", \"избор\", \"панел\", \"ред\".",
        listIsEmpty: "Все още няма добавени елементи.",
        "listIsEmpty@choices": "Все още няма добавени възможности за избор.",
        "listIsEmpty@columns": "Все още нямате колони",
        "listIsEmpty@rows": "Все още нямате никакви редове",
        "listIsEmpty@validators": "Все още нямате правила за валидиране",
        "listIsEmpty@calculatedValues": "Все още нямате никакви персонализирани променливи",
        "listIsEmpty@triggers": "Все още нямате никакви тригери",
        "listIsEmpty@navigateToUrlOnCondition": "Все още нямате връзки",
        "addNew@choices": "Добавяне на възможност за избор",
        "addNew@columns": "Добавяне на нова колона",
        "addNew@rows": "Добавяне на нов ред",
        "addNew@validators": "Добавяне на ново правило",
        "addNew@calculatedValues": "Добавяне на нова променлива",
        "addNew@triggers": "Добавяне на нов превключвател",
        "addNew@navigateToUrlOnCondition": "Добавяне на нов URL адрес",
        expressionIsEmpty: "Изразът е празен.",
        value: "Стойност",
        text: "Текст",
        rowid: "Идентификатор на ред",
        imageLink: "URL на изображение или видео",
        columnEdit: "Редактиране на колона: {0}",
        itemEdit: "Редактиране на елемент: {0}",
        url: "URL на услугата",
        path: "Път до данни в услугата",
        choicesbyurl: {
            url: "URL адрес на уеб услуга",
            valueName: "Вземи стойности от следното JSON поле."
        },
        titleName: "Вземи текстове за показване от следното JSON поле.",
        imageLinkName: "Вземи URL адреси на изображения от следното JSON поле.",
        allowEmptyResponse: "Разреши празен отговор.",
        titlePlaceholder: "Заглавие",
        surveyTitlePlaceholder: "Заглавие на анкетата",
        pageTitlePlaceholder: "Страница {num}",
        descriptionPlaceholder: "Описание",
        surveyDescriptionPlaceholder: "Описание",
        pageDescriptionPlaceholder: "Описание",
        textWrapEnabled: "Опции за обтичане",
        showOtherItem: "Достъп до опция Друго",
        otherText: "Текст на опция Друго",
        showNoneItem: "Достъп до опция Няма",
        showRefuseItem: "Разрешаване на опцията \"Отказ на отговор\"",
        showDontKnowItem: "Разрешаване на опцията \"Не знам\"",
        noneText: "Текст на опция Няма",
        showSelectAllItem: "Достъп до опция Избери всички",
        selectAllText: "Текст на опция Избери всички",
        choicesMin: "Минимална стойност за автоматично генерирани елементи",
        choicesMax: "Максимална стойност за автоматично генерирани елементи",
        choicesStep: "Стъпка за автоматично генерирани елементи",
        name: "Име",
        title: "Заглавие",
        cellType: "Тип на клетката",
        colCount: "Брой колони",
        choicesOrder: "Ред на сортиране на избора",
        visible: "Видим",
        isRequired: "Задължителен",
        markRequired: "Маркирай както се изисква",
        removeRequiredMark: "Премахване на необходимия знак",
        isAllRowRequired: "Изискване за отговор на всички редове",
        eachRowUnique: "Предотвратяване на дублиращи се отговори в редове",
        requiredErrorText: "\"Задължително\" съобщение за грешка",
        startWithNewLine: "Показване на въпроса на нов ред",
        rows: "Редове",
        cols: "Колони",
        placeholder: "Контейнер за област за въвеждане",
        showPreview: "Показване на областта за визуализация",
        storeDataAsText: "Съхранявай съдържанието на файла в JSON резултат като текст",
        maxSize: "Максимален размер на файла (в байтове)",
        rowCount: "Брой редове",
        columnLayout: "Разположение на колоните",
        addRowLocation: "Добавяне на местоположение на бутона за ред",
        transposeData: "Транспониране на редове в колони",
        addRowText: "Добавяне на текст на бутона за ред",
        removeRowText: "Премахване на текста на бутона за ред",
        rateMin: "Минимална стойност на оценката",
        rateMax: "Максимална стойност на оценката",
        rateStep: "Стъпка на оценката",
        minRateDescription: "Описание на минималната оценка",
        maxRateDescription: "Описание на максималната оценка",
        inputType: "Тип на въвеждане",
        optionsCaption: "Контейнер за опция",
        defaultValue: "Отговор по подразбиране",
        cellsDefaultRow: "Текстове по подразбиране",
        surveyEditorTitle: "Редактиране на настройките на анкетата",
        qEditorTitle: "Редактиране: {0}",
        maxLength: "Максимална дължина (в знаци)",
        buildExpression: "Изграждане",
        editExpression: "Редактиране",
        and: "и",
        or: "или",
        remove: "Премахване",
        addCondition: "Добавяне на условие",
        emptyLogicPopupMessage: "Избери въпрос, за да започне конфигурирането на условия.",
        if: "Ако",
        then: "то",
        setToName: "Целеви въпрос",
        fromName: "Въпрос за копиране на отговора",
        gotoName: "Въпрос, към който да се премине",
        ruleIsNotSet: "Правилото е некоректно.",
        includeIntoResult: "Включете в резултатите от анкетата",
        showTitle: "Показване на заглавието",
        expandCollapseTitle: "Разширяване/свиване на заглавие",
        locale: "Език на анкетата",
        simulator: "Изберете тип устройство",
        landscapeOrientation: "Превключване към пейзажна ориентация",
        portraitOrientation: "Превключване към портретна ориентация",
        mode: "Редактируемо или само за четене",
        clearInvisibleValues: "Изчистване на невидими стойности",
        cookieName: "Име на бисквитката",
        sendResultOnPageNext: "Запазване на частични резултати от анкетата в процес на изпълнение",
        storeOthersAsComment: "Съхранявай стойността на Други в отделно поле",
        showPageTitles: "Показване на заглавия на страници",
        showPageNumbers: "Показване на номера на страници",
        pagePrevText: "Текст на бутона за предишна страница",
        pageNextText: "Текст на бутона за следваща страница",
        completeText: "Текст на бутона за попълнена анкета",
        previewText: "Текст на бутона за визуализация на отговорите",
        editText: "Редактиране текста на бутона за отговор",
        startSurveyText: "Текст на бутона за стартиране на анкетата",
        showNavigationButtons: "Разположение на навигационните бутони",
        showPrevButton: "Показване на бутона Предишна страница",
        firstPageIsStarted: "Първата страница е начална.",
        showCompletedPage: "Показване на страницата Завършена анкета",
        goNextPageAutomatic: "Продължи автоматично към следващата страница.",
        allowCompleteSurveyAutomatic: "Попълване на анкетата автоматично",
        showProgressBar: "Местоположение на лентата за напредък",
        questionTitleLocation: "Местоположение на заглавието на въпроса",
        questionTitleWidth: "Ширина на заглавието на въпроса",
        requiredText: "Задължителен символ(и)",
        questionTitleTemplate: "Шаблонът за заглавие на въпрос по подразбиране е:: '{no}. {require} {title}'",
        questionErrorLocation: "Местоположение на съобщението за грешка",
        focusFirstQuestionAutomatic: "Постави първия въпрос на нова страница",
        questionsOrder: "Подреждане на елементите на страницата",
        maxTimeToFinish: "Време за завършване на анкетата (в секунди)",
        maxTimeToFinishPage: "Времево ограничение за завършване на една страница (в секунди)",
        showTimerPanel: "Местоположение на таймера",
        showTimerPanelMode: "Режим на таймера",
        renderMode: "Режим на показване на панела",
        allowAddPanel: "Разрешаване добавянето на панели",
        allowRemovePanel: "Разрешаване премахването на панели",
        panelAddText: "Добавяне на текст на панелен бутон",
        panelRemoveText: "Премахване на текст на панелен бутон",
        isSinglePage: "Показване на всички елементи на една страница",
        html: "HTML маркиране",
        setValue: "Отговор",
        dataFormat: "Формат на изображението",
        allowAddRows: "Разрешаване добавянето на редове",
        allowRemoveRows: "Разрешаване изтриването на редове",
        allowRowsDragAndDrop: "Разрешаване плъзгането и пускане на ред",
        responsiveImageSizeHelp: "Не се прилага, ако се посочи точна широчина или височина на изображението.",
        minImageWidth: "Минимална широчина на изображението",
        maxImageWidth: "Максимална широчина на изображението",
        minImageHeight: "Минимална височина на изображението",
        maxImageHeight: "Максимална височина на изображението",
        minValue: "Минимална стойност",
        maxValue: "Максимална стойност",
        minLength: "Минимална дължина (в символи)",
        allowDigits: "Разрешаване на цифри",
        minCount: "Минимален брой",
        maxCount: "Максимален брой",
        regex: "Регулярен израз",
        surveyvalidator: {
            text: "Съобщение за грешка",
            expression: "Израз за валидиране"
        },
        totalText: "Общ текст в реда",
        totalType: "Общ вид",
        totalExpression: "Тотален израз",
        totalDisplayStyle: "Стил на показване на обща стойност",
        totalCurrency: "Валута",
        totalFormat: "Форматиран низ",
        logo: "Лого (URL или base64-кодиран низ)",
        questionsOnPageMode: "Структура на анкетата",
        maxTextLength: "Максимална дължина на отговора (в символи)",
        maxOthersLength: "Максимална дължина на коментара (в символи)",
        commentAreaRows: "Височина на областта за коментари (в редове)",
        autoGrowComment: "Автоматично разширяване на областта за коментари, ако е необходимо",
        allowResizeComment: "Позволява на потребителите да преоразмеряват текстови области",
        textUpdateMode: "Актуализиране стойността на текстовия въпрос",
        maskType: "Тип маска за въвеждане",
        maskTypes: {
            none: "Никой",
            patternmask: "Шарка",
            numericmask: "Цифров",
            datetimemask: "Дата и час",
            currencymask: "Валута"
        },
        focusOnFirstError: "Фокусиране върху първия невалиден отговор",
        checkErrorsMode: "Стартиране на валидацията",
        navigateToUrl: "Навигирай до URL",
        navigateToUrlOnCondition: "Динамичен URL",
        completedBeforeHtml: "Маркиране за показване дали потребителят вече е попълнил тази анкета",
        completedHtml: "Анкета Пълно маркиране на страница",
        completedHtmlOnCondition: "Динамично проучване Пълно маркиране на страницата",
        loadingHtml: "Маркиране за показване, докато се зарежда моделът на анкетата",
        commentText: "Текст в полето за коментар",
        autocomplete: "Тип автодовършване",
        labelTrue: "\"Вярно\" етикет",
        labelFalse: "\"Невярно\" етикет",
        allowClear: "Показване на бутона Изчистване",
        searchMode: "Режим на търсене",
        displayStyle: "Стил за изобразяване на стойността",
        format: "Форматиран низ",
        maximumFractionDigits: "Максимален брой дробни цифри",
        minimumFractionDigits: "Минимален брой дробни цифри",
        useGrouping: "Показване на разделители за групиране",
        allowMultiple: "Разрешаване на множество файлове",
        allowImagesPreview: "Преглед на изображения",
        acceptedTypes: "Допустими типове файлове",
        waitForUpload: "Изчакай да завърши качването.",
        needConfirmRemoveFile: "Потвърждаване изтриването на файл",
        detailPanelMode: "Местоположение на детайлния панел",
        minRowCount: "Минимален брой редове",
        maxRowCount: "Максимален брой редове",
        confirmDelete: "Потвърждаване изтриването на реда",
        confirmDeleteText: "Съобщение за потвърждаване",
        panelCount: "Първоначален брой панели",
        minPanelCount: "Минимален брой панели",
        maxPanelCount: "Максимален брой панели",
        panelsState: "Разширено състояние на вътрешния панел",
        panelPrevText: "Подсказка към бутона за предишен панел",
        panelNextText: "Подсказка към бутона за следващ панел",
        showRangeInProgress: "Показване на лентата на напредък",
        panelRemoveButtonLocation: "Премахване местоположението на бутона на панела",
        hideIfRowsEmpty: "Скриване на въпроса, ако няма редове",
        hideColumnsIfEmpty: "Скриване на колони, ако няма редове",
        rateValues: "Персонализирани стойности на оценката",
        rateCount: "Брой на оценките",
        autoGenerate: "Как се задават стойности на оценката?",
        hideIfChoicesEmpty: "Показване въпроса, ако не съдържа избор",
        minWidth: "Минимална широчина (в CSS-допустими стойности)",
        maxWidth: "Максимална широчина (в CSS-допустими стойности)",
        width: "Широчина (в CSS-допустими стойности)",
        showHeader: "Показване заглавията на колоните",
        horizontalScroll: "Показване на хоризонталната лента за превъртане",
        columnMinWidth: "Минимална широчина на колоната (в CSS-допустими стойности)",
        rowTitleWidth: "Широчина на заглавния ред (в CSS-допустими стойности)",
        valueTrue: "\"Вярно\" стойност",
        valueFalse: "\"Грешно\" стойност",
        minErrorText: "\"Стойността е под минимума.\" съобщение за грешка",
        maxErrorText: "\"Стойността надвишава максимума.\" съобщение за грешка",
        otherErrorText: "\"Празен коментар\" съобщение за грешка",
        keyDuplicationError: "\"Неуникална стойност на ключ\" съобщение за грешка",
        minSelectedChoices: "Минимален избор",
        maxSelectedChoices: "Максимален брой избрани",
        showClearButton: "Показване на бутона Изчистване (Clear)",
        logoWidth: "Широчина на логото (в CSS-допустими стойности)",
        logoHeight: "Височина на логото (в CSS-допустими стойности)",
        readOnly: "Само за четене",
        enableIf: "Може да се редактира",
        emptyRowsText: "\"Без редове\" съобщение",
        separateSpecialChoices: "Разделяне със специален избор (Не, Други, Избери всички)",
        choicesFromQuestion: "Копиране изборите от следния въпрос",
        choicesFromQuestionMode: "Кои избори да се копират?",
        progressBarShowPageTitles: "Показване на заглавията на страниците в лентата за напредъка",
        progressBarShowPageNumbers: "Показване на номерата на страниците в лентата за напредъка",
        showCommentArea: "Показване на областта за коментари",
        commentPlaceholder: "Заместител на областта за коментари",
        displayRateDescriptionsAsExtremeItems: "Показване описанията на скоростта като екстремни стойности",
        rowsOrder: "Поредност на редовете",
        columnsLayout: "Поредност на колоните",
        columnColCount: "Брой вложени колони",
        correctAnswer: "Правилен отговор",
        defaultPanelValue: "Стойности по подразбиране",
        cells: "Текст в клетката",
        fileInputPlaceholder: "Избор на файл или поставяне на връзка към файл...",
        keyName: "Ключова колона",
        itemvalue: {
            visibleIf: "Направете опцията видима, ако",
            enableIf: "Направете опцията избираема, ако"
        },
        "itemvalue@rows": {
            visibleIf: "Направете реда видим, ако",
            enableIf: "Направете реда редактируем, ако"
        },
        imageitemvalue: {
            text: "Алтернативен текст"
        },
        logoPosition: "Позиция на логото",
        addLogo: "Добавяне на лого...",
        changeLogo: "Промяна на логото...",
        logoPositions: {
            none: "Изтриване на логото",
            left: "Вляво",
            right: "Вдясно",
            top: "Отгоре",
            bottom: "Отдолу"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Оформление на панела"
            },
            general: "Общ (главен)",
            fileOptions: "Настройки",
            html: "HTML Редактор",
            columns: "Колони",
            rows: "редове",
            choices: "Избори",
            items: "Елементи",
            visibleIf: "Видим",
            enableIf: "Редактируем",
            requiredIf: "Задължителен",
            rateValues: "Оценяване на стойностите",
            choicesByUrl: "Избор от услугата RESTful",
            matrixChoices: "Избор по подразбиране",
            multipleTextItems: "Въвеждане на текст",
            numbering: "Номерация",
            validators: "Валидатори",
            navigation: "Навигация",
            question: "Въпрос",
            pages: "Страници",
            timer: "Таймер/Тест",
            calculatedValues: "Изчислени стойности",
            triggers: "Тригери",
            templateTitle: "Шаблон за заглавие",
            totals: "Общо",
            logic: "Логика",
            mask: "Настройки на маската за въвеждане",
            layout: {
                panel: "Оформление",
                question: "Оформление",
                base: "Оформление"
            },
            data: "Данни",
            validation: "Валидиране",
            cells: "Текст в клетката",
            showOnCompleted: "Проучването е завършено.",
            logo: "Лого в заглавието на анкетата",
            slider: "Плъзгач",
            expression: "Израз (фраза)",
            questionSettings: "Настройки на въпроси",
            header: "Заглавка",
            background: "Фон",
            appearance: "Външен вид",
            others: "Други"
        },
        editProperty: "Редактиране на свойства '{0}'",
        items: "Елементи",
        choicesVisibleIf: "Изборите са видими, ако",
        choicesEnableIf: "Изборите може да се избират, ако",
        columnsEnableIf: "Колоните са видими, ако",
        rowsEnableIf: "Редовете са видими, ако",
        innerIndent: "Добавяне на вътрешни отстъпи",
        defaultValueFromLastRow: "Вземане стойностите по подразбиране от последния ред",
        defaultValueFromLastPanel: "Вземане стойностите по подразбиране от последния панел",
        enterNewValue: "Моля, въведете стойността.",
        noquestions: "В анкетата няма въпроси.",
        createtrigger: "Моля, създайте тригер.",
        titleKeyboardAdornerTip: "Натиснете бутона за въвеждане, за да редактирате.",
        keyboardAdornerTip: "Натиснете бутона за въвеждане, за да редактирате елемент, натиснете бутона за изтриване, за да изтриете елемент, натиснете alt плюс стрелка нагоре или стрелка надолу, за да преместите елемент.",
        triggerOn: "На ",
        triggerMakePagesVisible: "Направете страниците видими.",
        triggerMakeQuestionsVisible: "Направете елементите видими.",
        triggerCompleteText: "Попълнете анкетата, ако можете.",
        triggerNotSet: "Тригерът не е зададен.",
        triggerRunIf: "Работете, ако",
        triggerSetToName: "Промяна на стойността на: ",
        triggerFromName: "Копиране на стойност от: ",
        triggerRunExpression: "Изпълнете този израз.",
        triggerSetValue: "до: ",
        triggerGotoName: "Отидете на въпроса.",
        triggerIsVariable: "Не поставяйте променливата в резултата от анкетата.",
        triggerRunExpressionEmpty: "Моля, въведете валиден израз.",
        emptyExpressionPlaceHolder: "Въведете израз тук...",
        noFile: "Няма избран файл.",
        clearIfInvisible: "Изчистване на стойността, ако въпросът се скрие",
        valuePropertyName: "Име на свойството стойност",
        searchEnabled: "Търсенето разрешено",
        hideSelectedItems: "Скриване на избраните елементи",
        closeOnSelect: "Затворете падащото меню след избор.",
        verticalAlign: "Вертикално подравняване",
        alternateRows: "Алтернативни редове",
        columnsVisibleIf: "Колоните се виждат, ако",
        rowsVisibleIf: "Редовете се виждат, ако",
        otherPlaceholder: "Заместител на областта за коментари",
        filePlaceholder: "Текст в контейнер за файл",
        photoPlaceholder: "Текст в контейнер за снимка",
        fileOrPhotoPlaceholder: "Текст в контейнер за файл или снимка",
        rateType: "Тип на тарифата",
        url_placeholder: "Напр.: https://api.example.com/books",
        path_placeholder: "Пример: категории.фантастика",
        questionStartIndex_placeholder: "Напр.: а)",
        width_placeholder: "Пример: 6in",
        minWidth_placeholder: "Примерно: 600px",
        maxWidth_placeholder: "Примерно: 50%",
        imageHeight_placeholder: "Автоматично",
        imageWidth_placeholder: "Автоматично",
        theme: {
            themeName: "Тема",
            isPanelless: "Външен вид на въпроса",
            editorPanel: "Фон и радиус на ъгъла",
            questionPanel: "Фон и радиус на ъгъла",
            primaryColor: "Цвят за акцентиране",
            panelBackgroundTransparency: "Непрозрачност на фона на панела",
            questionBackgroundTransparency: "Непрозрачност на фона на въпроса",
            fontSize: "Размер на шрифта",
            scale: "Мащаб",
            cornerRadius: "Радиус на ъгъла",
            pageTitle: "Шрифт на заглавието",
            pageDescription: "Шрифт за описание",
            questionTitle: "Шрифт на заглавието",
            questionDescription: "Шрифт за описание",
            editorFont: "Шрифт",
            backgroundOpacity: "Непрозрачност",
            "--sjs-font-family": "Семейство шрифтове",
            "--sjs-general-backcolor-dim": "Цвят на фона",
            "--sjs-primary-backcolor": "Фон за акцентиране",
            "--sjs-primary-forecolor": "Акцентиране на преден план",
            "--sjs-special-red": "Съобщения за грешки",
            "--sjs-shadow-small": "Ефекти на сянка",
            "--sjs-shadow-inner": "Ефекти на сянка",
            "--sjs-border-default": "Цветове"
        },
        "header@header": {
            headerView: "Изглед",
            logoPosition: "Позиция на логото",
            surveyTitle: "Шрифт за заглавие на проучване",
            surveyDescription: "Шрифт за описание на проучването",
            headerTitle: "Шрифт за заглавие на проучване",
            headerDescription: "Шрифт за описание на проучването",
            inheritWidthFrom: "Ширина на областта на съдържанието",
            textAreaWidth: "Ширина на текста",
            backgroundColorSwitch: "Цвят на фона",
            backgroundImage: "Фоново изображение",
            backgroundImageOpacity: "Непрозрачност",
            overlapEnabled: "Припокриване",
            logoPositionX: "Позиция на логото",
            titlePositionX: "Позиция на заглавието",
            descriptionPositionX: "Описание позиция"
        }
    },
    // Property values
    pv: {
        "true": "вярно",
        "false": "невярно",
        file: "Локални файлове",
        camera: "Камера",
        "file-camera": "Локални файлове или камера",
        inherit: "Наследяване",
        show: "Видим",
        hide: "Скрит",
        default: "Наследен",
        initial: "Първоначален",
        random: "Произволен",
        collapsed: "Сгънат",
        expanded: "Разширен",
        none: "Нито един",
        asc: "Възходящ",
        desc: "Низходящ",
        indeterminate: "Неопределен",
        selected: "Избран",
        unselected: "Неизбран",
        decimal: "десетичен знак",
        currency: "валута",
        percent: "процент",
        firstExpanded: "Първият панел е разширен.",
        off: "Скриване на номерата на въпросите",
        list: "Списък",
        progressTop: "Панел навигатор + Лента за напредък в горната част",
        progressBottom: "Панел навигатор + Лента за напредък в долната част",
        progressTopBottom: "Панел навигатор + Лента за напредък в горната и долната част",
        tab: "Раздели",
        horizontal: "Хоризонтален",
        vertical: "Вертикален",
        top: "Горен",
        bottom: "Долен",
        topBottom: "Отгоре и отдолу",
        both: "И двете",
        left: "Вляво",
        right: "Отдясно",
        center: "Център",
        leftRight: "Наляво и надясно",
        middle: "Среда",
        color: "цвят",
        date: "дата",
        datetime: "Време за среща",
        "datetime-local": "Време за среща – локално",
        email: "имейл",
        month: "месец",
        number: "номер",
        password: "парола",
        range: "диапазон",
        tel: "телефон",
        text: "текст",
        time: "време",
        url: "url",
        week: "седмица",
        hidden: "Скрит",
        edit: "Редактируем",
        display: "Само за четене",
        contain: "Съдържам",
        cover: "Капак",
        fill: "Запълване",
        next: "Следващ",
        last: "Трая",
        onComplete: "Когато анкетата приключи",
        onHidden: "Когато въпросът стане скрит",
        onHiddenContainer: "Когато въпросът или неговият панел/страница се скрият",
        clearInvisibleValues: {
            none: "Никога"
        },
        clearIfInvisible: {
            none: "Никога"
        },
        inputType: {
            color: "Цвят",
            date: "Дата",
            "datetime-local": "Дата и час",
            email: "Имейл",
            month: "Месец",
            number: "Номер",
            password: "Парола",
            range: "Обхват",
            tel: "Телефонен номер",
            text: "Текст",
            time: "Време",
            url: "URL",
            week: "Седмица"
        },
        all: "Всички",
        page: "Старница",
        survey: "Анкета",
        onNextPage: "При превключване към следващата страница",
        onValueChanged: "След промяна на отговора",
        onValueChanging: "Преди да бъде променен отговор",
        questionsOnPageMode: {
            standard: "Оригинална структура",
            singlePage: "Показване на всички въпроси на една страница",
            questionPerPage: "Показване на единичен въпрос на страница"
        },
        noPreview: "Без визуализация",
        showAllQuestions: "Показване на всички въпроси",
        showAnsweredQuestions: "Показване само на въпроси с отговор",
        pages: "Завършени страници",
        questions: "Отговорени въпроси",
        requiredQuestions: "Отговорени задължителни въпроси",
        correctQuestions: "Валидни отговори",
        buttons: "Завършени страници (бутон UI)",
        underInput: "Под входа",
        underTitle: "Под заглавието",
        onBlur: "Размазване",
        onTyping: "Докато пишете",
        underRow: "Под реда",
        underRowSingle: "Под реда се вижда само един панел.",
        auto: "Авто",
        showNavigationButtons: {
            none: "Скрит"
        },
        showTimerPanel: {
            none: "Скрит"
        },
        showTimerPanelMode: {
            all: "И двете"
        },
        addRowLocation: {
            default: "Зависи от оформлението на матрицата."
        },
        panelsState: {
            default: "Потребителите не може да разгъват или свиват панели.",
            collapsed: "Всички панели са свити.",
            expanded: "Всички панели са разширени.",
            firstExpanded: "Първо разширено"
        },
        widthMode: {
            static: "Статичен",
            responsive: "Адаптивен"
        },
        contentMode: {
            image: "Изображение",
            video: "Видяо",
            youtube: "YouTube"
        },
        displayMode: {
            buttons: "Бутони",
            dropdown: "Падащо меню"
        },
        rateColorMode: {
            default: "По подразбиране",
            scale: "Мащаб"
        },
        scaleColorMode: {
            monochrome: "Монохромен",
            colored: "Оцветен"
        },
        autoGenerate: {
            "true": "Генерирай.",
            "false": "Въведи ръчно."
        },
        rateType: {
            labels: "Етикети",
            stars: "Звезди",
            smileys: "Усмивки"
        },
        state: {
            default: "Заключен"
        },
        showQuestionNumbers: {
            default: "Автоматично номериране",
            on: "Автоматично номериране",
            onPage: "Нулиране на всяка страница",
            onpanel: "Нулиране на всеки панел",
            onPanel: "Нулиране на всеки панел",
            onSurvey: "Продължете през проучването",
            off: "Без номериране"
        },
        descriptionLocation: {
            underTitle: "Под заглавието на въпроса",
            underInput: "Под полето за въвеждане"
        },
        selectToRankAreasLayout: {
            horizontal: "До опциите",
            vertical: "Над опциите"
        },
        displayStyle: {
            decimal: "Десетичен",
            currency: "Валута",
            percent: "Процент",
            date: "Дата"
        },
        totalDisplayStyle: {
            decimal: "Десетичен",
            currency: "Валута",
            percent: "Процент",
            date: "Дата"
        },
        rowsOrder: {
            initial: "Оригинален"
        },
        questionsOrder: {
            initial: "Оригинален"
        },
        showProgressBar: {
            off: "Скрит",
            topbottom: "Отгоре и отдолу",
            aboveheader: "Над горния колонтитул",
            belowheader: "Под заглавката"
        },
        sum: "Сума",
        count: "Граф",
        min: "Мин",
        max: "Макс",
        avg: "Ср",
        searchMode: {
            contains: "Съдържа",
            startsWith: "Започва с"
        },
        backgroundImageFit: {
            auto: "Авто",
            cover: "Капак",
            contain: "Съдържам",
            fill: "Участък",
            tile: "Плочки"
        },
        backgroundImageAttachment: {
            fixed: "Неподвижен",
            scroll: "Свитък"
        },
        headerView: {
            basic: "Основен",
            advanced: "Напреднал"
        },
        inheritWidthFrom: {
            survey: "Същото като проучването",
            container: "Побиране в контейнера"
        },
        backgroundColorSwitch: {
            none: "Никой",
            accentColor: "Цвят за акцентиране",
            custom: "Обичай"
        },
        colorPalette: {
            light: "Светлина",
            dark: "Тъмен"
        },
        isPanelless: {
            "false": "По подразбиране",
            "true": "Без панели"
        }
    },
    // Operators
    op: {
        empty: "празно",
        notempty: "не е празно",
        equal: "равно",
        notequal: "не е равно",
        contains: "съдържа",
        notcontains: "не съдържа",
        anyof: "всеки от",
        allof: "всички",
        greater: "по-голямо",
        less: "по-малко",
        greaterorequal: "по-голямо или равно",
        lessorequal: "по-малко или равно",
        and: "и",
        or: "или"
    },
    // Embed window
    ew: {
        angular: "Използвайте Angular версия",
        jquery: "Използвайте jQuery версия",
        knockout: "Използвайте Knockout версия",
        react: "Използвайте версията на React",
        vue: "Използвайте версията на Vue",
        bootstrap: "За bootstrap framework",
        modern: "Модерна тема",
        default: "тема по подразбиране",
        orange: "Оранжева тема",
        darkblue: "Тъмносиня тема",
        darkrose: "Тъмнорозова тема",
        stone: "Каменна тема",
        winter: "Зимна тема",
        winterstone: "Зимно-каменна тема",
        showOnPage: "Показване на анкетата на страница",
        showInWindow: "Показване на анкетата в прозорец",
        loadFromServer: "Заредете JSON на анкетата от сървъра",
        titleScript: "Скриптове и стилове",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Избери страницата, за да я тестваш.",
        showInvisibleElements: "Показване на невидими елементи",
        hideInvisibleElements: "Скриване на невидими елементи"
    },
    validators: {
        answercountvalidator: "Брой отговори",
        emailvalidator: "Имейл",
        expressionvalidator: "Израз",
        numericvalidator: "Число",
        regexvalidator: "Регулярен израз",
        textvalidator: "Текст"
    },
    triggers: {
        completetrigger: "Попълнена анкета",
        setvaluetrigger: "Задаване на отговор",
        copyvaluetrigger: "Копиране на отговор",
        skiptrigger: "Преминаване към въпроса",
        runexpressiontrigger: "Стартиране на израз",
        visibletrigger: "промяна на видимостта (отхвърлено)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Пример: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Пример: мм/дд/гггг"
        },
        currencymask: {
            prefix: "Пример: $",
            suffix: "Пример: USD"
        },
        panelbase: {
            questionTitleWidth: "Пример: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "ИД на панел, който не е видим за респондентите.",
            description: "Въведете подзаглавие на панела.",
            visibleIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което определя видимостта на панела.",
            enableIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което забранява режима само за четене за панела.",
            requiredIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което не позволява подаване на проучване, освен ако поне един вложен въпрос няма отговор.",
            questionTitleLocation: "Отнася се за всички въпроси в рамките на този панел. Ако искате да заместите тази настройка, определете правила за подравняване на заглавията за отделни въпроси. Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване (\"Горе\" по подразбиране).",
            questionTitleWidth: "Задава еднаква ширина за заглавията на въпросите, когато те са подравнени отляво на техните полета за въпроси. Приема CSS стойности (px, %, in, pt и т.н.).",
            questionErrorLocation: "Задава местоположението на съобщение за грешка във връзка с всички въпроси в панела. Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване.",
            questionsOrder: "Запазва първоначалния ред на въпросите или ги рандомизира. Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване.",
            page: "Премества панела в края на избрана страница.",
            innerIndent: "Добавя интервал или поле между съдържанието на панела и лявата граница на панелното поле.",
            startWithNewLine: "Премахнете отметката, за да покажете панела в един ред с предишния въпрос или панел. Настройката не се прилага, ако панелът е първият елемент във вашия формуляр.",
            state: "Изберете от: \"Разширен\" - панелът се показва изцяло и може да бъде свит; \"Свит\" - панелът показва само заглавието и описанието и може да бъде разширен; \"Заключен\" - панелът се показва изцяло и не може да се свива.",
            width: "Задава ширината на панела пропорционално на другите елементи на изследването в същия ред. Приема CSS стойности (px, %, in, pt и т.н.)."
        },
        paneldynamic: {
            name: "ИД на панел, който не е видим за респондентите.",
            description: "Въведете подзаглавие на панела.",
            visibleIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което определя видимостта на панела.",
            enableIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което забранява режима само за четене за панела.",
            requiredIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което не позволява подаване на проучване, освен ако поне един вложен въпрос няма отговор.",
            templateTitleLocation: "Отнася се за всички въпроси в рамките на този панел. Ако искате да заместите тази настройка, определете правила за подравняване на заглавията за отделни въпроси. Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване (\"Горе\" по подразбиране).",
            templateErrorLocation: "Задава местоположението на съобщение за грешка във връзка с въпрос с невалиден вход. Изберете между: \"Top\" - в горната част на полето за въпроси се поставя текст за грешка; \"Отдолу\" - в долната част на полето за въпроси се поставя текст за грешка. Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване (\"Горе\" по подразбиране).",
            errorLocation: "Задава местоположението на съобщение за грешка във връзка с всички въпроси в панела. Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване.",
            page: "Премества панела в края на избрана страница.",
            innerIndent: "Добавя интервал или поле между съдържанието на панела и лявата граница на панелното поле.",
            startWithNewLine: "Премахнете отметката, за да покажете панела в един ред с предишния въпрос или панел. Настройката не се прилага, ако панелът е първият елемент във вашия формуляр.",
            state: "Изберете от: \"Разширен\" - панелът се показва изцяло и може да бъде свит; \"Свит\" - панелът показва само заглавието и описанието и може да бъде разширен; \"Заключен\" - панелът се показва изцяло и не може да се свива.",
            width: "Задава ширината на панела пропорционално на другите елементи на изследването в същия ред. Приема CSS стойности (px, %, in, pt и т.н.).",
            templateTitle: "Въведете шаблон за динамични заглавия на панели. Използвайте {panelIndex} за общата позиция на панела и {visiblePanelIndex} за реда му сред видимите панели. Вмъкнете тези контейнери в шаблона, за да добавите автоматично номериране.",
            templateTabTitle: "Въведете шаблон за заглавията на разделите. Използвайте {panelIndex} за общата позиция на панела и {visiblePanelIndex} за реда му между видимите панели. Вмъкнете тези контейнери в шаблона, за да добавите автоматично номериране.",
            tabTitlePlaceholder: "Резервен текст за заглавията на разделите, който се прилага, когато шаблонът за заглавие на раздела не създава смислена стойност.",
            templateVisibleIf: "Тази настройка ви позволява да контролирате видимостта на отделните панели в динамичния панел. Използвайте контейнера \"{panel}\", за да препращате към текущия панел във вашия израз.",
            titleLocation: "Тази настройка се наследява автоматично от всички въпроси в този панел. Ако искате да заместите тази настройка, определете правила за подравняване на заглавията за отделни въпроси. Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване (\"Горе\" по подразбиране).",
            descriptionLocation: "Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване (\"Под заглавието на панела\" по подразбиране).",
            newPanelPosition: "Определя позицията на новодобавен панел. По подразбиране в края се добавят нови панели. Изберете \"Напред\", за да вмъкнете нов панел след текущия.",
            defaultValueFromLastPanel: "Дублира отговорите от последния панел и ги присвоява на следващия добавен динамичен панел.",
            keyName: "Препратка към име на въпрос, за да се изисква от потребителя да предостави уникален отговор на този въпрос във всеки панел."
        },
        defaultValueExpression: "Тази настройка ви позволява да присвоите стойност за отговор по подразбиране на базата на израз. Изразът може да включва основни изчисления - '{q1_id} + {q2_id}', булеви изрази, като '{age} > 60', и функции: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и др. Стойността, определена от този израз, служи като начална стойност по подразбиране, която може да бъде заместена от ръчното въвеждане на респондента.",
        resetValueIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което определя кога входът на респондента се връща към стойността въз основа на \"Израз за стойност по подразбиране\" или \"Задаване на израз за стойност\" или към стойността \"Отговор по подразбиране\" (ако е зададена такава).",
        setValueIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което определя кога да изпълните \"Задаване на израз за стойност\" и динамично да зададете получената стойност като отговор.",
        setValueExpression: "Задайте израз, който определя стойността, която трябва да бъде зададена, когато са изпълнени условията в правилото \"Задаване на стойност ако\". Изразът може да включва основни изчисления - '{q1_id} + {q2_id}', булеви изрази, като '{age} > 60', и функции: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и др. Стойността, определена от този израз, може да бъде заместена от ръчното въвеждане на респондента.",
        question: {
            name: "Идентификационен номер на въпрос, който не е видим за респондентите.",
            description: "Въведете подзаглавие на въпрос.",
            visibleIf: "Използвайте иконата на вълшебната пръчица, за да зададете условно правило, което определя видимостта на въпросите.",
            enableIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което забранява режима само за четене за въпроса.",
            requiredIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което предотвратява напредването или подаването на проучването, освен ако въпросът не получи отговор.",
            startWithNewLine: "Премахнете отметката, за да покажете въпроса в един ред с предишния въпрос или панел. Настройката не се прилага, ако въпросът е първият елемент във вашия формуляр.",
            page: "Премества въпроса в края на избрана страница.",
            state: "Изберете от: \"Разширен\" - полето за въпроси се показва изцяло и може да бъде свито; \"Свита\" - полето за въпроси показва само заглавието и описанието и може да бъде разширено; \"Заключена\" - полето за въпроси се показва изцяло и не може да бъде свито.",
            titleLocation: "Отменя правилата за подравняване на заглавията, дефинирани на ниво панел, страница или проучване. Опцията \"Наследяване\" прилага всички настройки от по-високо ниво (ако са зададени) или настройка на ниво проучване (\"Top\" по подразбиране).",
            descriptionLocation: "Опцията \"Наследяване\" прилага настройката на ниво проучване (\"Под заглавието на въпроса\" по подразбиране).",
            errorLocation: "Задава местоположението на съобщение за грешка във връзка с въпроса с невалиден вход. Изберете между: \"Top\" - в горната част на полето за въпроси се поставя текст за грешка; \"Отдолу\" - в долната част на полето за въпроси се поставя текст за грешка. Опцията \"Наследяване\" прилага настройката за ниво проучване (\"Top\" по подразбиране).",
            indent: "Добавя интервал или поле между съдържанието на въпроса и лявата граница на полето за въпроси.",
            width: "Задава ширината на въпроса пропорционално на другите елементи на изследването в същия ред. Приема CSS стойности (px, %, in, pt и т.н.).",
            surveyvalidator: {
                expression: "Използвайте иконата на магическа пръчка, за да зададете валидиращо правило за въпроса."
            },
            textUpdateMode: "Изберете от: \"На загубен фокус\" - стойността се актуализира, когато входното поле загуби фокус; \"Докато пишете\" - стойността се актуализира в реално време, докато потребителите пишат. Опцията \"Наследяване\" прилага настройката на ниво проучване (\"На загубен фокус\" по подразбиране).",
            url: "Можете да използвате всяка уеб услуга като източник на данни за въпроси с множествен избор. За да попълните стойности за избор, въведете URL адреса на услугата, предоставяща данните.",
            searchMode: "Операция за сравнение, използвана за филтриране на падащия списък.",
            textWrapEnabled: "Дългите текстове в опциите за избор автоматично ще генерират нови редове, за да се поберат в падащото меню. Премахнете отметката, ако искате текстовете да бъдат изрязани."
        },
        signaturepad: {
            signatureWidth: "Задава ширината на показаната област за подпис и полученото изображение.",
            signatureHeight: "Задава височината на показаната област за подпис и полученото изображение.",
            signatureAutoScaleEnabled: "Изберете дали искате областта за подпис да запълни цялото налично пространство в полето за въпроси, като същевременно запазите съотношението по подразбиране 3:2. Когато са зададени стойности за ширина и височина по избор, настройката ще запази пропорциите на тези размери."
        },
        file: {
            imageHeight: "Регулира височината на изображението в резултатите от проучването.",
            imageWidth: "Регулира ширината на изображението в резултатите от проучването."
        },
        image: {
            contentMode: "Опцията \"Auto\" автоматично определя подходящия режим за показване - Image, Video или YouTube - въз основа на предоставения URL адрес на източника."
        },
        imagepicker: {
            imageHeight: "Отменя минималните и максималните стойности на височината.",
            imageWidth: "Отменя минималните и максималните стойности на ширината.",
            choices: "\"Стойност\" служи като ИД на артикул, използван в условни правила; \"Текст\" се показва на респондентите.",
            contentMode: "Изберете между \"Изображение\" и \"Видео\", за да зададете режима на съдържание на селектора на мултимедия. Ако е избрано \"Изображение\", уверете се, че всички предоставени опции са файлове с изображения в следните формати: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. По същия начин, ако е избрано \"Видео\", уверете се, че всички опции са директни връзки към видео файлове в следните формати: MP4, MOV, WMV, FLV, AVI, MKV. Моля, имайте предвид, че връзките в YouTube не се поддържат за опции за видео."
        },
        text: {
            size: "Тази настройка само преоразмерява входното поле и не влияе на ширината на полето за въпроси. За да ограничите приетата дължина на въвеждане, отидете на <b>Проверка → Максимален брой знаци</b>."
        },
        comment: {
            rows: "Задава броя на показваните редове в полето за въвеждане. Ако входът заема повече редове, ще се появи плъзгачът."
        },
        // survey templates
        survey: {
            mode: "Изберете между: \"Редактируем\" - дава възможност на респондентите да попълнят анкетата Ви; \"Само за четене\" - забранява редактирането на формуляри."
        },
        matrixdropdowncolumn: {
            name: "ИД на колона, която не се вижда от респондентите.",
            isUnique: "Когато е разрешено за колона, респондентът трябва да предостави уникален отговор за всеки въпрос в тази колона.",
            rows: "Задава броя на показваните редове в полето за въвеждане. Ако входът заема повече редове, ще се появи плъзгачът.",
            visibleIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което определя видимостта на колоната.",
            enableIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което забранява режима само за четене за колоната.",
            requiredIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което не позволява подаване на проучване, освен ако поне един вложен въпрос няма отговор.",
            showInMultipleColumns: "Когато е избрано, създава отделна колона за всяка опция за избор."
        },
        widthMode: "Изберете от: \"Статичен\" - задава фиксирана ширина; \"Responsive\" - прави проучването да заема цялата ширина на екрана; \"Auto\" - прилага се всеки от двата в зависимост от използваните типове въпроси.",
        cookieName: "Бисквитките не позволяват на потребителите да попълнят една и съща анкета два пъти.",
        logo: "Поставете връзка към изображение (без ограничения за размера) или щракнете върху иконата на папката, за да прегледате файл от компютъра си (до 64 КБ).",
        logoWidth: "Задава ширина на логото в CSS единици (px, %, in, pt и т.н.).",
        logoHeight: "Задава височина на логото в CSS единици (px, %, in, pt и т.н.).",
        logoFit: "Изберете от: \"Няма\" - изображението запазва оригиналния си размер; \"Съдържа\" - изображението се преоразмерява, за да се побере, като същевременно се запазва съотношението на страните; \"Cover\" - изображението запълва цялата кутия, като същевременно запазва съотношението на страните; \"Fill\" - изображението се разтяга, за да запълни кутията, без да се поддържа съотношението на страните.",
        goNextPageAutomatic: "Изберете дали искате проучването да премине автоматично към следващата страница, след като респондентът отговори на всички въпроси на текущата страница.",
        allowCompleteSurveyAutomatic: "Изберете дали искате проучването да завърши автоматично, след като респондентът отговори на всички въпроси.",
        showNavigationButtons: "Задава видимостта и местоположението на бутоните за навигация на дадена страница.",
        showProgressBar: "Задава видимостта и местоположението на лентата за напредъка. Стойността \"Автоматично\" показва лентата за напредъка над или под заглавката на проучването.",
        showPreviewBeforeComplete: "Разрешете страницата за визуализация само с всички въпроси или само с отговор.",
        questionTitleLocation: "Отнася се за всички въпроси в рамките на проучването. Тази настройка може да бъде заместена от правилата за подравняване на заглавията на по-ниските нива: панел, страница или въпрос. Настройката от по-ниско ниво ще замени тези на по-високо ниво.",
        requiredText: "Символ или поредица от символи, показващи, че е необходим отговор.",
        questionStartIndex: "Въведете число или буква, с които искате да започнете номерирането.",
        questionErrorLocation: "Задава местоположението на съобщение за грешка във връзка с въпроса с невалиден вход. Изберете между: \"Top\" - в горната част на полето за въпроси се поставя текст за грешка; \"Отдолу\" - в долната част на полето за въпроси се поставя текст за грешка.",
        focusFirstQuestionAutomatic: "Изберете дали искате първото поле за въвеждане на всяка страница да е готово за въвеждане на текст.",
        questionsOrder: "Запазва първоначалния ред на въпросите или ги рандомизира. Ефектът от тази настройка се вижда само в раздела Визуализация .",
        maxTextLength: "Само за въпроси за въвеждане на текст.",
        maxOthersLength: "Само за въпросителни коментари.",
        commentAreaRows: "Задава броя на показваните редове в текстовите области за коментари на въпроси. Във входа заема повече редове, плъзгачът се появява.",
        autoGrowComment: "Изберете дали искате коментарите за въпроси и въпросите с дълъг текст автоматично да нарастват на височина въз основа на въведената дължина на текста.",
        allowResizeComment: "Само за коментари с въпроси и въпроси с дълъг текст.",
        calculatedValues: "Персонализираните променливи служат като междинни или спомагателни променливи, използвани в изчисленията на формуляра. Те приемат входните данни на респондентите като изходни стойности. Всяка персонализирана променлива има уникално име и израз, на който се базира.",
        includeIntoResult: "Изберете дали искате изчислената стойност на израза да бъде записана заедно с резултатите от проучването.",
        triggers: "Превключвателят е събитие или условие, което се основава на израз. След като изразът е оценен като \"true\", спусъкът задейства действие. Такова действие може по избор да има целеви въпрос, който засяга.",
        clearInvisibleValues: "Изберете дали да изчистите стойностите за въпроси, скрити от условната логика, и кога да го направите.",
        textUpdateMode: "Изберете от: \"На загубен фокус\" - стойността се актуализира, когато входното поле загуби фокус; \"Докато пишете\" - стойността се актуализира в реално време, докато потребителите пишат.",
        columns: "Лявата стойност служи като ИД на колона, използвана в условни правила, дясната стойност се показва на респондентите.",
        rows: "Лявата стойност служи като ИД на ред, използван в условни правила, дясната стойност се показва на респондентите.",
        columnMinWidth: "Приема CSS стойности (px, %, in, pt и т.н.).",
        rowTitleWidth: "Приема CSS стойности (px, %, in, pt и т.н.).",
        totalText: "Вижда се, само когато поне една колона има общ тип или общ израз.",
        cellErrorLocation: "Задава местоположението на съобщение за грешка по отношение на клетка с невалиден вход. Опцията \"Наследяване\" прилага настройката от свойството \"Подравняване на съобщение за грешка\".",
        keyDuplicationError: "Когато свойството \"Предотвратяване на дублиращи се отговори\" е разрешено, респондентът, който се опитва да подаде дублиран запис, ще получи следното съобщение за грешка.",
        totalExpression: "Позволява ви да изчислявате общи стойности на базата на израз. Изразът може да включва основни изчисления ('{q1_id} + {q2_id}'), булеви изрази ('{age} > 60') и функции ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и т.н.).",
        confirmDelete: "Задейства подкана с молба за потвърждаване на изтриването на реда.",
        defaultValueFromLastRow: "Дублира отговорите от последния ред и ги присвоява на следващия добавен динамичен ред.",
        keyName: "Ако указаната колона съдържа идентични стойности, анкетата отговаря с \"Неуникална стойност на ключ\" грешка.",
        description: "Въведете субтитри.",
        locale: "Изберете език, за да започнете да създавате проучването си. За да добавите превод, превключете на нов език и преведете оригиналния текст тук или в раздела Преводи.",
        detailPanelMode: "Задава местоположението на раздел с подробни данни по отношение на ред. Изберете от: \"Няма\" - не се добавя разширение; \"Под реда\" - под всеки ред на матрицата се поставя разширение на реда; \"Под реда покажете само разширение на един ред\" - разширение се показва само под един ред, останалите разширения на реда са свити.",
        imageFit: "Изберете от: \"Няма\" - изображението запазва оригиналния си размер; \"Съдържа\" - изображението се преоразмерява, за да се побере, като същевременно се запазва съотношението на страните; \"Cover\" - изображението запълва цялата кутия, като същевременно запазва съотношението на страните; \"Fill\" - изображението се разтяга, за да запълни кутията, без да се поддържа съотношението на страните.",
        autoGrow: "Постепенно увеличава височината на входното поле при въвеждане на данни. Замества настройката \"Височина на входното поле (в редове)\".",
        allowResize: "Манипулаторът за преоразмеряване (или ръкохватката) се появява в ъгъла и може да се плъзга, за да се промени размерът на входното поле.",
        maxTimeToFinish: "Интервал от време в секунди, след което проучването автоматично преминава към страницата \"Благодаря\".",
        maxTimeToFinishPage: "Интервал от време в секунди, след който проучването автоматично преминава към следващата страница.",
        page: {
            maxTimeToFinish: "Интервал от време в секунди, след който проучването автоматично преминава към следващата страница.",
            visibleIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което определя видимостта на страницата.",
            enableIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което забранява режима само за четене за страницата.",
            requiredIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което не позволява подаване на проучване, освен ако поне един вложен въпрос няма отговор.",
            questionTitleLocation: "Отнася се за всички въпроси в тази страница. Ако искате да замените тази настройка, определете правила за подравняване на заглавията за отделни въпроси или панели. Опцията \"Наследяване\" прилага настройката за ниво проучване (\"Top\" по подразбиране).",
            questionTitleWidth: "Задава еднаква ширина за заглавията на въпросите, когато те са подравнени отляво на техните полета за въпроси. Приема CSS стойности (px, %, in, pt и т.н.).",
            questionErrorLocation: "Задава местоположението на съобщение за грешка във връзка с въпроса с невалиден вход. Изберете между: \"Top\" - в горната част на полето за въпроси се поставя текст за грешка; \"Отдолу\" - в долната част на полето за въпроси се поставя текст за грешка. Опцията \"Наследяване\" прилага настройката за ниво проучване (\"Top\" по подразбиране).",
            questionsOrder: "Запазва първоначалния ред на въпросите или ги рандомизира. Опцията \"Наследяване\" прилага настройката на ниво проучване (\"Оригинал\" по подразбиране). Ефектът от тази настройка се вижда само в раздела Визуализация .",
            navigationButtonsVisibility: "Задава видимостта на бутоните за навигация на страницата. Опцията \"Наследяване\" прилага настройката на ниво проучване, която по подразбиране е \"Видима\"."
        },
        showTimerPanel: "Задава видимостта и местоположението на таймера на страницата.",
        panelsState: "Изберете от: \"Заключени\" - потребителите не могат да разширяват или свиват панели; \"Свиване на всички\" - всички панели започват в срутено състояние; \"Разширяване на всички\" - всички панели започват в разширено състояние; \"Първо разширен\" - само първият панел първоначално се разширява.",
        imageLinkName: "Въведете име на споделено свойство в масива от обекти, съдържащ URL адресите на изображения или видеофайлове, които искате да покажете в списъка за избор.",
        choices: "Лявата стойност служи като ИД на артикул, използван в условни правила, дясната стойност се показва на респондентите.",
        title: "Въведете удобно за потребителя заглавие за показване.",
        waitForUpload: "Гарантира, че потребителите няма да завършат проучването, докато не бъдат качени файлове.",
        minWidth: "Приема CSS стойности (px, %, in, pt и т.н.).",
        maxWidth: "Приема CSS стойности (px, %, in, pt и т.н.).",
        width: "Приема CSS стойности (px, %, in, pt и т.н.).",
        valueName: "Ако не зададете това свойство, отговорът ще бъде съхранен в поле, указано от свойството Name.",
        useDisplayValuesInDynamicTexts: "При типовете въпроси с единичен и множествен избор всяка опция за избор има ИД и стойност на показване. Когато е избрана, тази настройка показва показвана стойност вместо стойност на ИД в HTML въпроси и динамични заглавия и описания на елементи от проучване.",
        clearIfInvisible: "Изберете дали да изчистите стойностите на въпросите, скрити от условната логика, и кога да го направите. Опцията \"Наследяване\" прилага настройката на ниво проучване (\"При завършване на проучването\" по подразбиране).",
        choicesFromQuestionMode: "Изберете от: \"Всички\" - копира всички опции за избор от избрания въпрос; \"Избрано\" - динамично копира само избраните опции за избор; \"Неизбрани\" - динамично копира само неизбрани опции за избор. Опциите \"Няма\" и \"Други\" се копират по подразбиране, ако са разрешени във въпроса източник.",
        showOtherItem: "Когато е избрано, потребителите могат да включат допълнително въвеждане в отделно поле за коментари.",
        separateSpecialChoices: "Показва всяка специална опция за избор (\"Няма\", \"Други\", \"Избери всички\") на нов ред, дори когато се използва оформление с няколко колони.",
        path: "Задайте местоположението в набора от данни на услугата, където се намира целевият масив от обекти. Оставете празно, ако URL адресът вече сочи към масива.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Въведете единно име на свойство в масива от обекти, съдържащ стойностите, които искате да покажете в списъка за избор.",
        allowEmptyResponse: "Изберете, за да позволите на услугата да върне празен отговор или масив.",
        choicesVisibleIf: "Използвайте иконата на магическа пръчка, за да зададете условно правило, което определя видимостта на всички опции за избор.",
        rateValues: "Лявата стойност служи като ИД на артикул, използван в условни правила, дясната стойност се показва на респондентите.",
        rating: {
            displayMode: "\"Автоматично\" избира между режимите \"Бутони\" и \"Падащо меню\" въз основа на наличната ширина. Когато ширината е недостатъчна за показване на бутони, въпросът показва падащо меню."
        },
        valuePropertyName: "Позволява ви да свързвате въпроси, които дават резултати в различни формати. Когато такива въпроси са свързани помежду си с помощта на идентификатор на съединение, това споделено свойство съхранява избраните стойности на въпроси.",
        searchEnabled: "Изберете дали искате да актуализирате съдържанието на падащото меню, за да съответства на заявката за търсене, която потребителят въвежда в полето за въвеждане.",
        valueTrue: "Стойност, която трябва да се спести в резултатите от проучването, когато респондентите дадат положителен отговор.",
        valueFalse: "Стойност, която трябва да се спести в резултатите от проучването, когато респондентите дадат отрицателен отговор.",
        showPreview: "Не се препоръчва да деактивирате тази опция, тъй като тя отменя изображението за визуализация и затруднява потребителя да разбере дали файловете са качени.",
        needConfirmRemoveFile: "Задейства подкана с молба за потвърждаване на изтриването на файла.",
        selectToRankEnabled: "Разреши да се класират само избраните възможности за избор. Потребителите ще плъзгат избраните елементи от списъка за избор, за да ги подредят в областта за класиране.",
        dataList: "Въведете списък с възможности за избор, които ще бъдат предложени на респондента по време на въвеждането.",
        itemSize: "Настройката само преоразмерява входните полета и не влияе на ширината на полето за въпроси.",
        itemTitleWidth: "Задава еднаква ширина за всички етикети на елементи в пиксели",
        altText: "Служи като заместител, когато изображението не може да бъде показано на устройството на потребителя и за целите на достъпността.",
        rateColorMode: "Определя цвета на избрания емотикон, когато типът на иконата за оценка е зададен на \"Усмивки\". Изберете между: \"По подразбиране\" - избраният емотикон се появява в цвета на проучването по подразбиране; \"Скала\" - избраният емотикон наследява цвят от рейтинговата скала.",
        expression: {
            name: "ИД на израз, който не е видим за респондентите.",
            description: "Въведете подзаглавие на израз.",
            expression: "Изразът може да включва основни изчисления ('{q1_id} + {q2_id}'), условия ('{age} > 60') и функции ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и т.н.)."
        },
        storeOthersAsComment: "Изберете, за да съхраните стойността на опцията \"Други\" като отделно свойство в резултатите от проучването.",
        format: "Използвай {0} като контейнер за действителната стойност.",
        acceptedTypes: "Направи справка с (https://www.w3schools.com/tags/att_input_accept.asp) за повече информация.",
        columnColCount: "Приложимо само за типове клетки Radiogroup и Checkbox.",
        autocomplete: "Направи справка с [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) за повече информация.",
        filePlaceholder: "Прилага се, когато \"Тип източник\" е \"Локални файлове\" или когато камерата не е налична",
        photoPlaceholder: "Прилага се, когато \"Тип източник\" е \"Камера\".",
        fileOrPhotoPlaceholder: "Прилага се, когато \"Тип източник\" е \"Локални файлове или камера\".",
        masksettings: {
            saveMaskedValue: "Изберете дали искате да съхраните стойността на въпроса с приложена маска в резултатите от проучването."
        },
        patternmask: {
            pattern: "Шаблонът може да съдържа низови литерали и следните контейнери: '9' - за цифра; \"а\" - за главна или малка буква; \"#\" - за цифра или главна или малка буква. Използвайте обратно наклонена черта \"\\\", за да избягате от знак."
        },
        datetimemask: {
            pattern: "Шаблонът може да съдържа разделителни знаци и следните контейнери:<br>'m' - Номер на месец.<br>'mm' - Число на месеца, с водеща нула за едноцифрени стойности. <br>\"d\" - Ден от месеца. <br>'dd' - Ден от месеца, с водеща нула за едноцифрени стойности. <br>'yy' - Последните две цифри на годината. <br>'гггг' - Четирицифрена година. <br>'H' - Часове в 24-часов формат. <br>'HH' - Часове в 24-часов формат, с водеща нула за едноцифрени стойности. <br>'h' - Часове в 12-часов формат. <br>'hh' - Часове в 12-часов формат, с водеща нула за едноцифрени стойности. <br>'ММ' - Минути. <br>'ss' - секунди. <br>\"TT\" - 12-часов период на часовника с главни букви (AM/PM). <br>'tt' - 12-часов период на часовника с малки букви (am/pm)."
        },
        numericmask: {
            decimalSeparator: "Символ, използван за отделяне на дробната част от целочислената част на показваното число.",
            thousandsSeparator: "Символ, използван за разделяне на цифрите на голямо число в групи от по три.",
            precision: "Ограничава колко цифри да се запазят след десетичната запетая за показваното число."
        },
        currencymask: {
            prefix: "Един или няколко символа, които трябва да бъдат показани преди стойността.",
            suffix: "Един или няколко символа, които трябва да се покажат след стойността."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "заглавие",
            title: "Остави го празно, ако е същото като 'Name'"
        },
        multiSelect: "Разрешаване многократен избор",
        showLabel: "Показване на надписи на изображения",
        swapOrder: "Разменете реда на \"Да\" и \"Не\"",
        value: "Стойност",
        tabAlign: "Подравняване на раздели",
        sourceType: "Тип източник",
        fitToContainer: "Побиране в контейнера",
        setValueExpression: "Задаване на израз за стойност",
        description: "Описание",
        logoFit: "Подходящо за лого",
        pages: "Страници",
        questions: "Въпроси",
        triggers: "Тригери",
        calculatedValues: "Изчислени стойности",
        surveyId: "Идентификационен номер на анкетата",
        surveyPostId: "Идентификационен номер на публикацията в проучването",
        surveyShowDataSaving: "Проучването показва спестяване на данни.",
        questionDescriptionLocation: "Местоположение на описанието на въпроса",
        progressBarType: "Тип лента за напредък",
        showTOC: "Показване на съдържание",
        tocLocation: "Местоположение на съдържанието",
        questionTitlePattern: "Шаблон на заглавието на въпроса",
        widthMode: "Режим на широчина",
        showBrandInfo: "Показване на информация за марката (бранда)",
        useDisplayValuesInDynamicTexts: "Стойности за показване на динамични текстове",
        visibleIf: "Видим, ако",
        defaultValueExpression: "Стойност по подразбиране на израза",
        requiredIf: "Задължителен, ако",
        resetValueIf: "Нулиране на стойността, ако",
        setValueIf: "Задайте стойност, ако",
        validators: "Валидатори",
        bindings: "Обвързване",
        renderAs: "Представяне като",
        attachOriginalItems: "Прикрепяне на оригиналните елементи",
        choices: "Избори",
        choicesByUrl: "Избори като url",
        currency: "Валута",
        cellHint: "Подсказка за клетка",
        totalMaximumFractionDigits: "Общо максимални дробни цифри",
        totalMinimumFractionDigits: "Общо минимални дробни цифри",
        columns: "Колони",
        detailElements: "Детайлни елементи",
        allowAdaptiveActions: "Позволи адаптивни действия",
        defaultRowValue: "Стойност на реда по подразбиране",
        detailPanelShowOnAdding: "Панелът с подробности се показва при добавяне.",
        choicesLazyLoadEnabled: "Отложеното зареждане на избора е активирано.",
        choicesLazyLoadPageSize: "Избор на размер на страницата за отложено зареждане",
        inputFieldComponent: "Компонент на полето за въвеждане",
        itemComponent: "Компонент на елемента",
        min: "Минимум",
        max: "Максимум",
        minValueExpression: "Минимална стойност на израза",
        maxValueExpression: "Максимална стойност на израза",
        step: "Стъпка",
        dataList: "Списък с данни",
        itemSize: "Размер на елемента",
        itemTitleWidth: "Ширина на етикета на елемента (в пиксели)",
        elements: "Елементи",
        content: "Съдържание",
        navigationButtonsVisibility: "Видимост на бутоните за навигация",
        navigationTitle: "Навигационно заглавие",
        navigationDescription: "Описание на навигацията",
        longTap: "Дълго докосване",
        autoGrow: "Автоматичен растеж",
        allowResize: "Разреши преоразмеряване.",
        acceptCarriageReturn: "Приеми връщане на каретка.",
        displayMode: "Режим на показване",
        rateType: "Тип на оценката",
        label: "Етикет",
        contentMode: "Съдържателен режим",
        imageFit: "Напасване на изображението",
        altText: "Алтернативен текст",
        height: "Височина",
        penColor: "Цвят на писалката",
        backgroundColor: "Цвят на фона",
        templateElements: "Елементи на шаблона",
        operator: "Оператор",
        isVariable: "Променлива",
        runExpression: "Стартиване на израза",
        showCaption: "Показване на надпис",
        iconName: "Име на икона",
        iconSize: "Размер на иконата",
        precision: "Точност",
        matrixDragHandleArea: "Област на манипулатора за плъзгане на матрицата",
        backgroundImage: "Фоново изображение",
        backgroundImageFit: "Побиране на фоново изображение",
        backgroundImageAttachment: "Прикачен файл с фоново изображение",
        backgroundOpacity: "Непрозрачност на фона",
        selectToRankEnabled: "Изберете за класиране разрешено",
        selectToRankAreasLayout: "Изберете оформление за класиране на области",
        selectToRankEmptyRankedAreaText: "Текст, който да се показва, ако са избрани всички опции",
        selectToRankEmptyUnrankedAreaText: "Текст в контейнер за областта за класиране",
        allowCameraAccess: "Разреши достъп до камерата",
        scaleColorMode: "Режим на мащабиране на цветовете",
        rateColorMode: "Режим на оценяване на цветовете",
        copyDisplayValue: "Копиране на показваната стойност",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Разширен режим",
        pageTitle: "Шрифт на заглавието на страницата",
        questionTitle: "Шрифт на заглавието на въпроса",
        editorPanel: "Редактор",
        lines: "Линии",
        primaryDefaultColor: "По подразбиране",
        primaryDarkColor: "Върху",
        primaryLightColor: "Селектиран",
        backgroundDimColor: "Цвят на фона",
        cornerRadius: "Радиус на ъгъла",
        backcolor: "Фон по подразбиране",
        hovercolor: "Фон под курсора на мишката",
        borderDecoration: "Декорация на контура",
        fontColor: "Цвят на шрифта",
        backgroundColor: "Цвят на фона",
        primaryForecolor: "Цвят по подразбиране",
        primaryForecolorLight: "Деактивиран цвят",
        font: "Шрифт",
        borderDefault: "Преобладаващ",
        borderLight: "Незначителен",
        fontFamily: "Семейство шрифтове",
        fontWeightRegular: "Редовни",
        fontWeightHeavy: "Тежък",
        fontWeightSemiBold: "Полу-полу-получер",
        fontWeightBold: "Безочлив",
        color: "Цвят",
        placeholderColor: "Цвят на контейнера",
        size: "Големина",
        opacity: "Непрозрачност",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Добавяне на ефект на сянка",
        boxShadowBlur: "Замъгляване",
        boxShadowSpread: "Разпространение",
        boxShadowDrop: "Капка",
        boxShadowInner: "Вътрешен",
        names: {
            default: "По подразбиране",
            sharp: "Остър",
            borderless: "Без граници",
            flat: "Апартамент",
            plain: "Равнина",
            doubleborder: "Двойна граница",
            layered: "Пластове",
            solid: "Солиден",
            threedimensional: ".3D",
            contrast: "Контраст"
        },
        colors: {
            teal: "Тийл",
            blue: "Син",
            purple: "Лилав",
            orchid: "Орхидея",
            tulip: "Лале",
            brown: "Кафяв",
            green: "Зелен"
        }
    }
};
// Uncomment the line below if you create a custom dictionary.
// Replace "en" with a custom locale code (for example, "fr" or "de"),
// Replace `enStrings` with the name of the variable that contains the custom dictionary.
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["bg"] = bgStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// ed.themePropertyGridTitle: "Theme Settings" => "Настройки на тема"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Сигурни ли сте, че искате да изтриете всички низове за този език?"
// ed.themeExportButton: "Export" => "Износ"
// ed.themeImportButton: "Import" => "Внос"
// ed.themeResetButton: "Reset theme settings to default" => "Връщане на настройките на тема в начално състояние по подразбиране"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Възможностите за избор се копират от"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "ясна стойност на въпроса: {0}"
// pe.overridingPropertyPrefix: "Set by " => "Зададено от "
// pe.minSelectedChoices: "Minimum selected choices" => "Минимален избор"
// pe.rateType: "Rate type" => "Тип на тарифата"
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Преоразмерява видимата област на входното поле. Моля, използвайте настройката <b>Проверка → максимална</b> дължина, за да ограничите входната дължина."
// p.precision: "Precision" => "Точност"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Област на манипулатора за плъзгане на матрицата"
// p.backgroundImage: "Background image" => "Фоново изображение"
// p.backgroundImageFit: "Background image fit" => "Побиране на фоново изображение"
// p.backgroundImageAttachment: "Background image attachment" => "Прикачен файл с фоново изображение"
// p.backgroundOpacity: "Background opacity" => "Непрозрачност на фона"
// p.selectToRankEnabled: "Select to rank enabled" => "Изберете за класиране разрешено"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Изберете оформление за класиране на области"
// p.allowCameraAccess: "Allow camera access" => "Разреши достъп до камерата"
// p.scaleColorMode: "Scale color mode" => "Режим на мащабиране на цветовете"
// p.rateColorMode: "Rate color mode" => "Режим на оценяване на цветовете"
// p.templateTabTitle: "Template tab title" => "Заглавие на раздела \"Шаблон\""
// p.templateVisibleIf: "Template visible if" => "Шаблонът се вижда, ако"
// p.copyDisplayValue: "Copy display value" => "Копиране на показваната стойност"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Неподвижен"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Свитък"
// theme.placeholderColor: "Placeholder color" => "Цвят на контейнера"
// theme.fontWeightHeavy: "Heavy" => "Тежък"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Добавяне на ефект на сянка"
// theme.boxShadowDrop: "Drop" => "Капка"
// theme.boxShadowInner: "Inner" => "Вътрешен"
// names.default: "Default" => "По подразбиране"
// names.sharp: "Sharp" => "Остър"
// names.borderless: "Borderless" => "Без граници"
// names.flat: "Flat" => "Апартамент"
// names.plain: "Plain" => "Равнина"
// names.doubleborder: "Double Border" => "Двойна граница"
// names.layered: "Layered" => "Пластове"
// names.solid: "Solid" => "Солиден"
// names.threedimensional: "3D" => ".3D"
// names.contrast: "Contrast" => "Контраст"
// colors.teal: "Teal" => "Тийл"
// colors.blue: "Blue" => "Син"
// colors.purple: "Purple" => "Лилав"
// colors.orchid: "Orchid" => "Орхидея"
// colors.tulip: "Tulip" => "Лале"
// colors.brown: "Brown" => "Кафяв"
// colors.green: "Green" => "Зелен"
// ed.themeSettings: "Theme Settings" => "Настройки на тема"
// ed.themeSettingsTooltip: "Open theme settings" => "Отваряне на настройките на тема"
// pe.resetToDefaultCaption: "Reset" => "Проучване"
// pv.file: "Local files" => "Локални файлове"
// pv.camera: "Camera" => "Фотоапарат"
// pv.file-camera: "Local files or camera" => "Локални файлове или камера"
// ed.translateUsigAI: "Auto-translate All" => "Автоматичен превод на всички"
// ed.translationDialogTitle: "Untranslated strings" => "Непреведени низове"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Моля, въведете поне {0} артикула"
// lg.question_resetValueName: "Reset question value" => "Нулиране на стойността на въпроса"
// lg.column_resetValue: "Reset column value" => "Нулиране на стойността на колона"
// pe.markRequired: "Mark as required" => "Маркирай както се изисква"
// pe.removeRequiredMark: "Remove the required mark" => "Премахване на необходимия знак"
// p.resetValueIf: "Reset value if" => "Нулиране на стойността, ако"
// lg.question_setValueName: "Set question value" => "Задаване на стойност на въпрос"
// lg.column_resetValueName: "Reset column value" => "Нулиране на стойността на колона"
// lg.column_setValueName: "Set column value" => "Задаване на стойност на колона"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Израз, чийто резултат ще бъде присвоен на целевия въпрос."
// survey.title: "Title" => "Заглавие"
// page.title: "Title" => "Заглавие"
// p.setValueIf: "Set value if" => "Задайте стойност, ако"
// theme.header: "Header" => "Заглавка"
// theme.backgroundImageFitFill: "Stretch" => "Участък"
// theme.backgroundImageFitTile: "Tile" => "Плочки"
// theme.headerView: "View" => "Изглед"
// theme.headerViewBasic: "Basic" => "Основен"
// theme.headerViewAdvanced: "Advanced" => "Напреднал"
// theme.headerInheritWidthFrom: "Content area width" => "Ширина на областта на съдържанието"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Същото като проучването"
// theme.headerInheritWidthFromPage: "Fit to page" => "Побери в страницата"
// theme.headerTextAreaWidth: "Text width" => "Ширина на текста"
// theme.headerBackgroundColorSwitch: "Background color" => "Цвят на фона"
// theme.headerBackgroundColorNone: "None" => "Никой"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Цвят за акцентиране"
// theme.headerBackgroundColorCustom: "Custom" => "Обичай"
// theme.horizontalAlignmentLeft: "Left" => "Ляво"
// theme.horizontalAlignmentCenter: "Center" => "Център"
// theme.horizontalAlignmentRight: "Right" => "Дясно"
// theme.verticalAlignmentTop: "Top" => "Връх"
// theme.verticalAlignmentMiddle: "Middle" => "Среда"
// theme.verticalAlignmentBottom: "Bottom" => "Дъно"
// lg.question_resetValueText: "reset value for question: {0}" => "нулиране на стойността за въпрос: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "присвояване на стойност: {1} на въпрос: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Нулиране на стойността на клетката за колона: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Присвояване на стойност на клетка: {1} на колона: {0}"
// ed.surveyJsonExportButton: "Export" => "Износ"
// ed.surveyJsonImportButton: "Import" => "Внос"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Копиране в системния буфер"
// pe.filePlaceholder: "File placeholder text" => "Текст в контейнер за файл"
// pe.photoPlaceholder: "Photo placeholder text" => "Текст в контейнер за снимка"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Текст в контейнер за файл или снимка"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Прилага се, когато \"Тип източник\" е \"Локални файлове\" или когато камерата не е налична"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Прилага се, когато \"Тип източник\" е \"Камера\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Прилага се, когато \"Тип източник\" е \"Локални файлове или камера\"."
// theme.background: "Background" => "Фон"
// theme.appearance: "Appearance" => "Външен вид"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Наистина ли искате да нулирате темата? Всички ваши персонализации ще бъдат загубени."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Да, нулирайте темата"
// theme.headerDescriptionForecolor: "Description forecolor" => "Описание цвят на предния цвят"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Побиране в контейнера"
// signaturepad.showPlaceholder: "Show the placeholder" => "Показване на контейнера"
// signaturepad.placeholder: "Placeholder text" => "Текст в контейнер"
// theme.surveyDescriptionFont: "Survey description font" => "Шрифт за описание на проучването"
// ed.prevFocus: "Focus previous" => "Фокус предишен"
// ed.nextFocus: "Focus next" => "Фокусирай се върху следващия"
// ed.saveTheme: "Save Theme" => "Запиши темата"
// ed.saveThemeTooltip: "Save Theme" => "Запиши темата"
// lg.page_requireName: "Make page required" => "Направи страницата задължителна"
// lg.panel_requireName: "Make page required" => "Направи страницата задължителна"
// signaturepad.signatureWidth: "Signature area width" => "Ширина на областта за подпис"
// signaturepad.signatureHeight: "Signature area height" => "Височина на областта за подпис"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Автоматично мащабиране на областта за подписи"
// signaturepad.penMinWidth: "Minimum pen width" => "Минимална ширина на писалката"
// signaturepad.penMaxWidth: "Maximum pen width" => "Максимална ширина на перото"
// theme.logoPosition: "Logo position" => "Позиция на логото"
// theme.headerTitlePosition: "Title position" => "Позиция на заглавието"
// theme.headerDescriptionPosition: "Description position" => "Описание позиция"
// ed.propertyGridNoResultsFound: "No results found" => "Няма намерени резултати"
// pv.leftRight: "Left and right" => "Наляво и надясно"
// p.sourceType: "Source type" => "Тип източник"
// p.fitToContainer: "Fit to container" => "Побиране в контейнера"
// p.setValueExpression: "Set value expression" => "Задаване на израз за стойност"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Възможностите за избор се зареждат от уеб услуга."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Отидете в настройките"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Визуализация на заредените опции за избор"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Предотвратяване на дублиращи се отговори в редове"
// theme.advancedMode: "Advanced mode" => "Разширен режим"
// theme.backgroundCornerRadius: "Background and corner radius" => "Фон и радиус на ъгъла"
// theme.colorsTitle: "Colors" => "Цветове"
// theme.font: "Font" => "Шрифт"
// theme.lines: "Lines" => "Линии"
// theme.titleFont: "Title font" => "Шрифт на заглавието"
// theme.descriptionFont: "Description font" => "Шрифт за описание"
// theme.shadow: "Shadow effects" => "Ефекти на сянка"
// ed.translateUsigAIFrom: "Translate from: " => "Преведи от: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Разрешаване на опцията \"Отказ на отговор\""
// pe.showDontKnowItem: "Allow the Don't Know option" => "Разрешаване на опцията \"Не знам\""
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Разрешаване на опцията \"Отказ на отговор\""
// pe.showDontKnowItem: "Allow the Don't Know option" => "Разрешаване на опцията \"Не знам\""
// pv.contain: "Contain" => "Съдържам"
// pv.cover: "Cover" => "Капак"
// pv.fill: "Fill" => "Запълване"
// pe.transposeData: "Transpose rows to columns" => "Транспониране на редове в колони"
// layout.panel: "Layout" => "Оформление"
// layout.question: "Layout" => "Оформление"
// layout.base: "Layout" => "Оформление"
// panel.name: "Panel name" => "Име на панела"
// panel.title: "Panel title" => "Заглавие на панела"
// panel.description: "Panel description" => "Описание на панела"
// panel.visibleIf: "Make the panel visible if" => "Направете панела видим, ако"
// panel.requiredIf: "Make the panel required if" => "Направете панела необходим, ако"
// panel.questionsOrder: "Question order within the panel" => "Ред на въпросите в рамките на панела"
// panel.startWithNewLine: "Display the panel on a new line" => "Показване на панела на нов ред"
// panel.state: "Panel collapse state" => "Състояние на свиване на панела"
// panel.width: "Inline panel width" => "Ширина на вградения панел"
// panel.minWidth: "Minimum panel width" => "Минимална ширина на панела"
// panel.maxWidth: "Maximum panel width" => "Максимална ширина на панела"
// panel.showNumber: "Number panels" => "Числени панели"
// paneldynamic.name: "Panel name" => "Име на панела"
// paneldynamic.title: "Panel title" => "Заглавие на панела"
// paneldynamic.description: "Panel description" => "Описание на панела"
// paneldynamic.visibleIf: "Make the panel visible if" => "Направете панела видим, ако"
// paneldynamic.requiredIf: "Make the panel required if" => "Направете панела необходим, ако"
// paneldynamic.page: "Move the panel to page" => "Преместване на панела на страница"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Показване на панела на нов ред"
// paneldynamic.state: "Panel collapse state" => "Състояние на свиване на панела"
// paneldynamic.width: "Inline panel width" => "Ширина на вградения панел"
// paneldynamic.minWidth: "Minimum panel width" => "Минимална ширина на панела"
// paneldynamic.maxWidth: "Maximum panel width" => "Максимална ширина на панела"
// paneldynamic.templateDescription: "Panel description pattern" => "Модел за описание на панела"
// paneldynamic.templateTitle: "Panel title pattern" => "Модел на заглавие на панел"
// paneldynamic.noEntriesText: "Empty panel text" => "Празен текст на панел"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Шаблон на заглавие на раздел"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Направете отделен панел видим, ако"
// paneldynamic.hideNumber: "Hide the panel number" => "Скриване на номера на панела"
// paneldynamic.titleLocation: "Panel title alignment" => "Подравняване на заглавието на панела"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Подравняване на описанието на панела"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Подравняване на заглавието на въпроса"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Подравняване на съобщение за грешка"
// paneldynamic.newPanelPosition: "New panel location" => "Ново местоположение на панела"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Предотвратяване на дублиращи се отговори в следния въпрос"
// question.name: "Question name" => "Име на въпрос"
// question.title: "Question title" => "Заглавие на въпроса"
// question.description: "Question description" => "Описание на въпроса"
// question.visibleIf: "Make the question visible if" => "Направете въпроса видим, ако"
// question.requiredIf: "Make the question required if" => "Задайте въпроса, който е необходим, ако"
// question.state: "Question box collapse state" => "Състояние на свиване на полето за въпроси"
// question.hideNumber: "Hide the question number" => "Скриване на номера на въпроса"
// question.titleLocation: "Question title alignment" => "Подравняване на заглавието на въпроса"
// question.descriptionLocation: "Question description alignment" => "Подравняване на описанието на въпроса"
// question.errorLocation: "Error message alignment" => "Подравняване на съобщение за грешка"
// question.indent: "Increase the inner indent" => "Увеличаване на вътрешния отстъп"
// question.width: "Inline question width" => "Ширина на вградения въпрос"
// question.minWidth: "Minimum question width" => "Минимална ширина на въпросите"
// question.maxWidth: "Maximum question width" => "Максимална ширина на въпроса"
// question.textUpdateMode: "Update input field value" => "Актуализиране на стойността на входното поле"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Показване на бутона \"Изчисти\" в областта за подписи"
// signaturepad.penColor: "Stroke color" => "Цвят на щрихите"
// comment.rows: "Input field height (in lines)" => "Височина на входното поле (в редове)"
// expression.name: "Expression name" => "Име на израз"
// expression.title: "Expression title" => "Заглавие на израза"
// expression.description: "Expression description" => "Описание на израза"
// expression.expression: "Expression" => "Изразяване"
// trigger.expression: "Expression" => "Изразяване"
// calculatedvalue.expression: "Expression" => "Изразяване"
// survey.description: "Survey description" => "Описание на проучването"
// page.name: "Page name" => "Име на страница"
// page.description: "Page description" => "Описание на страницата"
// page.visibleIf: "Make the page visible if" => "Направете страницата видима, ако"
// page.requiredIf: "Make the page required if" => "Направете страницата задължителна, ако"
// page.questionsOrder: "Question order on the page" => "Ред на въпросите на страницата"
// matrixdropdowncolumn.name: "Column name" => "Име на колона"
// matrixdropdowncolumn.title: "Column title" => "Заглавие на колоната"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Предотвратяване на дублиращи се отговори"
// matrixdropdowncolumn.width: "Column width" => "Ширина на колона"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Минимална ширина на колоната"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Височина на входното поле (в редове)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Направете колоната видима, ако"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Направете колоната задължителна, ако"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Всяка опция в отделна колона"
// multipletextitem.name: "Name" => "Име"
// multipletextitem.title: "Title" => "Заглавие"
// pe.rateDescriptionLocation: "Label alignment" => "Подравняване на етикети"
// pe.cellErrorLocation: "Cell error message alignment" => "Подравняване на съобщение за грешка в клетка"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Все още нямате колони"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Все още нямате никакви редове"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Все още нямате правила за валидиране"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Все още нямате никакви персонализирани променливи"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Все още нямате никакви тригери"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Все още нямате връзки"
// pe.addNew@columns: "Add new column" => "Добавяне на нова колона"
// pe.addNew@rows: "Add new row" => "Добавяне на нов ред"
// pe.addNew@validators: "Add new rule" => "Добавяне на ново правило"
// pe.addNew@calculatedValues: "Add new variable" => "Добавяне на нова променлива"
// pe.addNew@triggers: "Add new trigger" => "Добавяне на нов превключвател"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Добавяне на нов URL адрес"
// choicesbyurl.url: "Web service's URL" => "URL адрес на уеб услуга"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Показване на заглавията на страниците в лентата за напредъка"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Показване на номерата на страниците в лентата за напредъка"
// itemvalue.visibleIf: "Make the option visible if" => "Направете опцията видима, ако"
// itemvalue.enableIf: "Make the option selectable if" => "Направете опцията избираема, ако"
// panel.layout: "Panel Layout" => "Оформление на панела"
// tabs.questionSettings: "Question Settings" => "Настройки на въпроси"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Напр.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Пример: категории.фантастика"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Напр.: а)"
// pe.width_placeholder: "Ex.: 6in" => "Пример: 6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "Примерно: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Примерно: 50%"
// pv.selected: "Selected" => "Избран"
// pv.unselected: "Unselected" => "Неизбран"
// pv.center: "Center" => "Център"
// pv.middle: "Middle" => "Среда"
// pv.next: "Next" => "Следващ"
// pv.last: "Last" => "Трая"
// clearIfInvisible.none: "Never" => "Никога"
// questionsOnPageMode.standard: "Original structure" => "Оригинална структура"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Показване на всички въпроси на една страница"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Показване на единичен въпрос на страница"
// pv.auto: "Auto" => "Авто"
// panelsState.firstExpanded: "First expanded" => "Първо разширено"
// rateColorMode.scale: "Scale" => "Мащаб"
// scaleColorMode.monochrome: "Monochrome" => "Монохромен"
// scaleColorMode.colored: "Colored" => "Оцветен"
// state.default: "Locked" => "Заключен"
// showQuestionNumbers.default: "Auto-numbering" => "Автоматично номериране"
// showQuestionNumbers.on: "Auto-numbering" => "Автоматично номериране"
// showQuestionNumbers.onPage: "Reset on each page" => "Нулиране на всяка страница"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Нулиране на всеки панел"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Нулиране на всеки панел"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Продължете през проучването"
// showQuestionNumbers.off: "No numbering" => "Без номериране"
// descriptionLocation.underTitle: "Under the question title" => "Под заглавието на въпроса"
// descriptionLocation.underInput: "Under the input field" => "Под полето за въвеждане"
// selectToRankAreasLayout.horizontal: "Next to choices" => "До опциите"
// selectToRankAreasLayout.vertical: "Above choices" => "Над опциите"
// displayStyle.decimal: "Decimal" => "Десетичен"
// displayStyle.currency: "Currency" => "Валута"
// displayStyle.percent: "Percentage" => "Процент"
// displayStyle.date: "Date" => "Дата"
// totalDisplayStyle.decimal: "Decimal" => "Десетичен"
// totalDisplayStyle.currency: "Currency" => "Валута"
// totalDisplayStyle.percent: "Percentage" => "Процент"
// totalDisplayStyle.date: "Date" => "Дата"
// rowsOrder.initial: "Original" => "Оригинален"
// questionsOrder.initial: "Original" => "Оригинален"
// showProgressBar.aboveheader: "Above the header" => "Над горния колонтитул"
// showProgressBar.belowheader: "Below the header" => "Под заглавката"
// pv.sum: "Sum" => "Сума"
// pv.count: "Count" => "Граф"
// pv.min: "Min" => "Мин"
// pv.max: "Max" => "Макс"
// pv.avg: "Avg" => "Ср"
// searchMode.contains: "Contains" => "Съдържа"
// searchMode.startsWith: "Starts with" => "Започва с"
// panel.name: "A panel ID that is not visible to respondents." => "ИД на панел, който не е видим за респондентите."
// panel.description: "Type a panel subtitle." => "Въведете подзаглавие на панела."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което определя видимостта на панела."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което забранява режима само за четене за панела."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което не позволява подаване на проучване, освен ако поне един вложен въпрос няма отговор."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Отнася се за всички въпроси в рамките на този панел. Ако искате да заместите тази настройка, определете правила за подравняване на заглавията за отделни въпроси. Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване (\"Горе\" по подразбиране)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Задава местоположението на съобщение за грешка във връзка с всички въпроси в панела. Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Запазва първоначалния ред на въпросите или ги рандомизира. Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване."
// panel.page: "Repositions the panel to the end of a selected page." => "Премества панела в края на избрана страница."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Добавя интервал или поле между съдържанието на панела и лявата граница на панелното поле."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Премахнете отметката, за да покажете панела в един ред с предишния въпрос или панел. Настройката не се прилага, ако панелът е първият елемент във вашия формуляр."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Изберете от: \"Разширен\" - панелът се показва изцяло и може да бъде свит; \"Свит\" - панелът показва само заглавието и описанието и може да бъде разширен; \"Заключен\" - панелът се показва изцяло и не може да се свива."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Задава ширината на панела пропорционално на другите елементи на изследването в същия ред. Приема CSS стойности (px, %, in, pt и т.н.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "ИД на панел, който не е видим за респондентите."
// paneldynamic.description: "Type a panel subtitle." => "Въведете подзаглавие на панела."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което определя видимостта на панела."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което забранява режима само за четене за панела."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което не позволява подаване на проучване, освен ако поне един вложен въпрос няма отговор."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Отнася се за всички въпроси в рамките на този панел. Ако искате да заместите тази настройка, определете правила за подравняване на заглавията за отделни въпроси. Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване (\"Горе\" по подразбиране)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Задава местоположението на съобщение за грешка във връзка с въпрос с невалиден вход. Изберете между: \"Top\" - в горната част на полето за въпроси се поставя текст за грешка; \"Отдолу\" - в долната част на полето за въпроси се поставя текст за грешка. Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване (\"Горе\" по подразбиране)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Задава местоположението на съобщение за грешка във връзка с всички въпроси в панела. Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Премества панела в края на избрана страница."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Добавя интервал или поле между съдържанието на панела и лявата граница на панелното поле."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Премахнете отметката, за да покажете панела в един ред с предишния въпрос или панел. Настройката не се прилага, ако панелът е първият елемент във вашия формуляр."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Изберете от: \"Разширен\" - панелът се показва изцяло и може да бъде свит; \"Свит\" - панелът показва само заглавието и описанието и може да бъде разширен; \"Заключен\" - панелът се показва изцяло и не може да се свива."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Задава ширината на панела пропорционално на другите елементи на изследването в същия ред. Приема CSS стойности (px, %, in, pt и т.н.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Въведете шаблон за динамични заглавия на панели. Използвайте {panelIndex} за общата позиция на панела и {visiblePanelIndex} за реда му сред видимите панели. Вмъкнете тези контейнери в шаблона, за да добавите автоматично номериране."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Въведете шаблон за заглавията на разделите. Използвайте {panelIndex} за общата позиция на панела и {visiblePanelIndex} за реда му между видимите панели. Вмъкнете тези контейнери в шаблона, за да добавите автоматично номериране."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Тази настройка ви позволява да контролирате видимостта на отделните панели в динамичния панел. Използвайте контейнера \"{panel}\", за да препращате към текущия панел във вашия израз."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Тази настройка се наследява автоматично от всички въпроси в този панел. Ако искате да заместите тази настройка, определете правила за подравняване на заглавията за отделни въпроси. Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване (\"Горе\" по подразбиране)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "Опцията \"Наследяване\" прилага настройката за ниво на страница (ако е зададена) или ниво проучване (\"Под заглавието на панела\" по подразбиране)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Определя позицията на новодобавен панел. По подразбиране в края се добавят нови панели. Изберете \"Напред\", за да вмъкнете нов панел след текущия."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Дублира отговорите от последния панел и ги присвоява на следващия добавен динамичен панел."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Препратка към име на въпрос, за да се изисква от потребителя да предостави уникален отговор на този въпрос във всеки панел."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Тази настройка ви позволява да присвоите стойност за отговор по подразбиране на базата на израз. Изразът може да включва основни изчисления - '{q1_id} + {q2_id}', булеви изрази, като '{age} > 60', и функции: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и др. Стойността, определена от този израз, служи като начална стойност по подразбиране, която може да бъде заместена от ръчното въвеждане на респондента."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което определя кога входът на респондента се връща към стойността въз основа на \"Израз за стойност по подразбиране\" или \"Задаване на израз за стойност\" или към стойността \"Отговор по подразбиране\" (ако е зададена такава)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което определя кога да изпълните \"Задаване на израз за стойност\" и динамично да зададете получената стойност като отговор."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Задайте израз, който определя стойността, която трябва да бъде зададена, когато са изпълнени условията в правилото \"Задаване на стойност ако\". Изразът може да включва основни изчисления - '{q1_id} + {q2_id}', булеви изрази, като '{age} > 60', и функции: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и др. Стойността, определена от този израз, може да бъде заместена от ръчното въвеждане на респондента."
// question.name: "A question ID that is not visible to respondents." => "Идентификационен номер на въпрос, който не е видим за респондентите."
// question.description: "Type a question subtitle." => "Въведете подзаглавие на въпрос."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Използвайте иконата на вълшебната пръчица, за да зададете условно правило, което определя видимостта на въпросите."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което забранява режима само за четене за въпроса."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което предотвратява напредването или подаването на проучването, освен ако въпросът не получи отговор."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Премахнете отметката, за да покажете въпроса в един ред с предишния въпрос или панел. Настройката не се прилага, ако въпросът е първият елемент във вашия формуляр."
// question.page: "Repositions the question to the end of a selected page." => "Премества въпроса в края на избрана страница."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Изберете от: \"Разширен\" - полето за въпроси се показва изцяло и може да бъде свито; \"Свита\" - полето за въпроси показва само заглавието и описанието и може да бъде разширено; \"Заключена\" - полето за въпроси се показва изцяло и не може да бъде свито."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Отменя правилата за подравняване на заглавията, дефинирани на ниво панел, страница или проучване. Опцията \"Наследяване\" прилага всички настройки от по-високо ниво (ако са зададени) или настройка на ниво проучване (\"Top\" по подразбиране)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "Опцията \"Наследяване\" прилага настройката на ниво проучване (\"Под заглавието на въпроса\" по подразбиране)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Задава местоположението на съобщение за грешка във връзка с въпроса с невалиден вход. Изберете между: \"Top\" - в горната част на полето за въпроси се поставя текст за грешка; \"Отдолу\" - в долната част на полето за въпроси се поставя текст за грешка. Опцията \"Наследяване\" прилага настройката за ниво проучване (\"Top\" по подразбиране)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Добавя интервал или поле между съдържанието на въпроса и лявата граница на полето за въпроси."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Задава ширината на въпроса пропорционално на другите елементи на изследването в същия ред. Приема CSS стойности (px, %, in, pt и т.н.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Използвайте иконата на магическа пръчка, за да зададете валидиращо правило за въпроса."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Изберете от: \"На загубен фокус\" - стойността се актуализира, когато входното поле загуби фокус; \"Докато пишете\" - стойността се актуализира в реално време, докато потребителите пишат. Опцията \"Наследяване\" прилага настройката на ниво проучване (\"На загубен фокус\" по подразбиране)."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Можете да използвате всяка уеб услуга като източник на данни за въпроси с множествен избор. За да попълните стойности за избор, въведете URL адреса на услугата, предоставяща данните."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Операция за сравнение, използвана за филтриране на падащия списък."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Задава ширината на показаната област за подпис и полученото изображение."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Задава височината на показаната област за подпис и полученото изображение."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Изберете дали искате областта за подпис да запълни цялото налично пространство в полето за въпроси, като същевременно запазите съотношението по подразбиране 3:2. Когато са зададени стойности за ширина и височина по избор, настройката ще запази пропорциите на тези размери."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Регулира височината на изображението в резултатите от проучването."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Регулира ширината на изображението в резултатите от проучването."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Отменя минималните и максималните стойности на височината."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Отменя минималните и максималните стойности на ширината."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Стойност\" служи като ИД на артикул, използван в условни правила; \"Текст\" се показва на респондентите."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Тази настройка само преоразмерява входното поле и не влияе на ширината на полето за въпроси. За да ограничите приетата дължина на въвеждане, отидете на <b>Проверка → Максимален брой знаци</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Задава броя на показваните редове в полето за въвеждане. Ако входът заема повече редове, ще се появи плъзгачът."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Изберете между: \"Редактируем\" - дава възможност на респондентите да попълнят анкетата Ви; \"Само за четене\" - забранява редактирането на формуляри."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "ИД на колона, която не се вижда от респондентите."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Когато е разрешено за колона, респондентът трябва да предостави уникален отговор за всеки въпрос в тази колона."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Задава броя на показваните редове в полето за въвеждане. Ако входът заема повече редове, ще се появи плъзгачът."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което определя видимостта на колоната."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което забранява режима само за четене за колоната."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което не позволява подаване на проучване, освен ако поне един вложен въпрос няма отговор."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Когато е избрано, създава отделна колона за всяка опция за избор."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Изберете от: \"Статичен\" - задава фиксирана ширина; \"Responsive\" - прави проучването да заема цялата ширина на екрана; \"Auto\" - прилага се всеки от двата в зависимост от използваните типове въпроси."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Поставете връзка към изображение (без ограничения за размера) или щракнете върху иконата на папката, за да прегледате файл от компютъра си (до 64 КБ)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Задава ширина на логото в CSS единици (px, %, in, pt и т.н.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Задава височина на логото в CSS единици (px, %, in, pt и т.н.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Изберете от: \"Няма\" - изображението запазва оригиналния си размер; \"Съдържа\" - изображението се преоразмерява, за да се побере, като същевременно се запазва съотношението на страните; \"Cover\" - изображението запълва цялата кутия, като същевременно запазва съотношението на страните; \"Fill\" - изображението се разтяга, за да запълни кутията, без да се поддържа съотношението на страните."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Изберете дали искате проучването да премине автоматично към следващата страница, след като респондентът отговори на всички въпроси на текущата страница."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Задава видимостта и местоположението на бутоните за навигация на дадена страница."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Задава видимостта и местоположението на лентата за напредъка. Стойността \"Автоматично\" показва лентата за напредъка над или под заглавката на проучването."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Разрешете страницата за визуализация само с всички въпроси или само с отговор."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Отнася се за всички въпроси в рамките на проучването. Тази настройка може да бъде заместена от правилата за подравняване на заглавията на по-ниските нива: панел, страница или въпрос. Настройката от по-ниско ниво ще замени тези на по-високо ниво."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Символ или поредица от символи, показващи, че е необходим отговор."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Въведете число или буква, с които искате да започнете номерирането."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Задава местоположението на съобщение за грешка във връзка с въпроса с невалиден вход. Изберете между: \"Top\" - в горната част на полето за въпроси се поставя текст за грешка; \"Отдолу\" - в долната част на полето за въпроси се поставя текст за грешка."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Изберете дали искате първото поле за въвеждане на всяка страница да е готово за въвеждане на текст."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Запазва първоначалния ред на въпросите или ги рандомизира. Ефектът от тази настройка се вижда само в раздела Визуализация ."
// pehelp.maxTextLength: "For text entry questions only." => "Само за въпроси за въвеждане на текст."
// pehelp.maxOthersLength: "For question comments only." => "Само за въпросителни коментари."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Изберете дали искате коментарите за въпроси и въпросите с дълъг текст автоматично да нарастват на височина въз основа на въведената дължина на текста."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Само за коментари с въпроси и въпроси с дълъг текст."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Персонализираните променливи служат като междинни или спомагателни променливи, използвани в изчисленията на формуляра. Те приемат входните данни на респондентите като изходни стойности. Всяка персонализирана променлива има уникално име и израз, на който се базира."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Изберете дали искате изчислената стойност на израза да бъде записана заедно с резултатите от проучването."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Превключвателят е събитие или условие, което се основава на израз. След като изразът е оценен като \"true\", спусъкът задейства действие. Такова действие може по избор да има целеви въпрос, който засяга."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Изберете дали да изчистите стойностите за въпроси, скрити от условната логика, и кога да го направите."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Изберете от: \"На загубен фокус\" - стойността се актуализира, когато входното поле загуби фокус; \"Докато пишете\" - стойността се актуализира в реално време, докато потребителите пишат."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Лявата стойност служи като ИД на колона, използвана в условни правила, дясната стойност се показва на респондентите."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Лявата стойност служи като ИД на ред, използван в условни правила, дясната стойност се показва на респондентите."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Приема CSS стойности (px, %, in, pt и т.н.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Приема CSS стойности (px, %, in, pt и т.н.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Задава местоположението на съобщение за грешка по отношение на клетка с невалиден вход. Опцията \"Наследяване\" прилага настройката от свойството \"Подравняване на съобщение за грешка\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Когато свойството \"Предотвратяване на дублиращи се отговори\" е разрешено, респондентът, който се опитва да подаде дублиран запис, ще получи следното съобщение за грешка."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Позволява ви да изчислявате общи стойности на базата на израз. Изразът може да включва основни изчисления ('{q1_id} + {q2_id}'), булеви изрази ('{age} > 60') и функции ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и т.н.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Задейства подкана с молба за потвърждаване на изтриването на реда."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Дублира отговорите от последния ред и ги присвоява на следващия добавен динамичен ред."
// pehelp.description: "Type a subtitle." => "Въведете субтитри."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Изберете език, за да започнете да създавате проучването си. За да добавите превод, превключете на нов език и преведете оригиналния текст тук или в раздела Преводи."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Задава местоположението на раздел с подробни данни по отношение на ред. Изберете от: \"Няма\" - не се добавя разширение; \"Под реда\" - под всеки ред на матрицата се поставя разширение на реда; \"Под реда покажете само разширение на един ред\" - разширение се показва само под един ред, останалите разширения на реда са свити."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Изберете от: \"Няма\" - изображението запазва оригиналния си размер; \"Съдържа\" - изображението се преоразмерява, за да се побере, като същевременно се запазва съотношението на страните; \"Cover\" - изображението запълва цялата кутия, като същевременно запазва съотношението на страните; \"Fill\" - изображението се разтяга, за да запълни кутията, без да се поддържа съотношението на страните."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Постепенно увеличава височината на входното поле при въвеждане на данни. Замества настройката \"Височина на входното поле (в редове)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Манипулаторът за преоразмеряване (или ръкохватката) се появява в ъгъла и може да се плъзга, за да се промени размерът на входното поле."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Интервал от време в секунди, след което проучването автоматично преминава към страницата \"Благодаря\"."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Интервал от време в секунди, след който проучването автоматично преминава към следващата страница."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Интервал от време в секунди, след който проучването автоматично преминава към следващата страница."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което определя видимостта на страницата."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което забранява режима само за четене за страницата."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което не позволява подаване на проучване, освен ако поне един вложен въпрос няма отговор."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Отнася се за всички въпроси в тази страница. Ако искате да замените тази настройка, определете правила за подравняване на заглавията за отделни въпроси или панели. Опцията \"Наследяване\" прилага настройката за ниво проучване (\"Top\" по подразбиране)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Задава местоположението на съобщение за грешка във връзка с въпроса с невалиден вход. Изберете между: \"Top\" - в горната част на полето за въпроси се поставя текст за грешка; \"Отдолу\" - в долната част на полето за въпроси се поставя текст за грешка. Опцията \"Наследяване\" прилага настройката за ниво проучване (\"Top\" по подразбиране)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Запазва първоначалния ред на въпросите или ги рандомизира. Опцията \"Наследяване\" прилага настройката на ниво проучване (\"Оригинал\" по подразбиране). Ефектът от тази настройка се вижда само в раздела Визуализация ."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Задава видимостта на бутоните за навигация на страницата. Опцията \"Наследяване\" прилага настройката на ниво проучване, която по подразбиране е \"Видима\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Задава видимостта и местоположението на таймера на страницата."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Изберете от: \"Заключени\" - потребителите не могат да разширяват или свиват панели; \"Свиване на всички\" - всички панели започват в срутено състояние; \"Разширяване на всички\" - всички панели започват в разширено състояние; \"Първо разширен\" - само първият панел първоначално се разширява."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Въведете име на споделено свойство в масива от обекти, съдържащ URL адресите на изображения или видеофайлове, които искате да покажете в списъка за избор."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Лявата стойност служи като ИД на артикул, използван в условни правила, дясната стойност се показва на респондентите."
// pehelp.title: "Type a user-friendly title to display." => "Въведете удобно за потребителя заглавие за показване."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Гарантира, че потребителите няма да завършат проучването, докато не бъдат качени файлове."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Приема CSS стойности (px, %, in, pt и т.н.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Приема CSS стойности (px, %, in, pt и т.н.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Приема CSS стойности (px, %, in, pt и т.н.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "При типовете въпроси с единичен и множествен избор всяка опция за избор има ИД и стойност на показване. Когато е избрана, тази настройка показва показвана стойност вместо стойност на ИД в HTML въпроси и динамични заглавия и описания на елементи от проучване."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Изберете дали да изчистите стойностите на въпросите, скрити от условната логика, и кога да го направите. Опцията \"Наследяване\" прилага настройката на ниво проучване (\"При завършване на проучването\" по подразбиране)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Изберете от: \"Всички\" - копира всички опции за избор от избрания въпрос; \"Избрано\" - динамично копира само избраните опции за избор; \"Неизбрани\" - динамично копира само неизбрани опции за избор. Опциите \"Няма\" и \"Други\" се копират по подразбиране, ако са разрешени във въпроса източник."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Когато е избрано, потребителите могат да включат допълнително въвеждане в отделно поле за коментари."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Показва всяка специална опция за избор (\"Няма\", \"Други\", \"Избери всички\") на нов ред, дори когато се използва оформление с няколко колони."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Задайте местоположението в набора от данни на услугата, където се намира целевият масив от обекти. Оставете празно, ако URL адресът вече сочи към масива."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Въведете единно име на свойство в масива от обекти, съдържащ стойностите, които искате да покажете в списъка за избор."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Изберете, за да позволите на услугата да върне празен отговор или масив."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Използвайте иконата на магическа пръчка, за да зададете условно правило, което определя видимостта на всички опции за избор."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Лявата стойност служи като ИД на артикул, използван в условни правила, дясната стойност се показва на респондентите."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Автоматично\" избира между режимите \"Бутони\" и \"Падащо меню\" въз основа на наличната ширина. Когато ширината е недостатъчна за показване на бутони, въпросът показва падащо меню."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Позволява ви да свързвате въпроси, които дават резултати в различни формати. Когато такива въпроси са свързани помежду си с помощта на идентификатор на съединение, това споделено свойство съхранява избраните стойности на въпроси."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Изберете дали искате да актуализирате съдържанието на падащото меню, за да съответства на заявката за търсене, която потребителят въвежда в полето за въвеждане."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Стойност, която трябва да се спести в резултатите от проучването, когато респондентите дадат положителен отговор."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Стойност, която трябва да се спести в резултатите от проучването, когато респондентите дадат отрицателен отговор."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Не се препоръчва да деактивирате тази опция, тъй като тя отменя изображението за визуализация и затруднява потребителя да разбере дали файловете са качени."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Задейства подкана с молба за потвърждаване на изтриването на файла."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Разреши да се класират само избраните възможности за избор. Потребителите ще плъзгат избраните елементи от списъка за избор, за да ги подредят в областта за класиране."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Въведете списък с възможности за избор, които ще бъдат предложени на респондента по време на въвеждането."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Настройката само преоразмерява входните полета и не влияе на ширината на полето за въпроси."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Задава еднаква ширина за всички етикети на елементи в пиксели"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Опцията \"Auto\" автоматично определя подходящия режим за показване - Image, Video или YouTube - въз основа на предоставения URL адрес на източника."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Служи като заместител, когато изображението не може да бъде показано на устройството на потребителя и за целите на достъпността."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Определя цвета на избрания емотикон, когато типът на иконата за оценка е зададен на \"Усмивки\". Изберете между: \"По подразбиране\" - избраният емотикон се появява в цвета на проучването по подразбиране; \"Скала\" - избраният емотикон наследява цвят от рейтинговата скала."
// expression.name: "An expression ID that is not visible to respondents." => "ИД на израз, който не е видим за респондентите."
// expression.description: "Type an expression subtitle." => "Въведете подзаглавие на израз."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Изразът може да включва основни изчисления ('{q1_id} + {q2_id}'), условия ('{age} > 60') и функции ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и т.н.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Изберете, за да съхраните стойността на опцията \"Други\" като отделно свойство в резултатите от проучването."
// p.swapOrder: "Swap the order of Yes and No" => "Разменете реда на \"Да\" и \"Не\""
// p.itemTitleWidth: "Item label width (in px)" => "Ширина на етикета на елемента (в пиксели)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Текст, който да се показва, ако са избрани всички опции"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Текст в контейнер за областта за класиране"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Попълване на анкетата автоматично"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Изберете дали искате проучването да завърши автоматично, след като респондентът отговори на всички въпроси."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Запазване на маскирана стойност в резултатите от проучването"
// patternmask.pattern: "Value pattern" => "Шаблон на стойност"
// datetimemask.min: "Minimum value" => "Минимална стойност"
// datetimemask.max: "Maximum value" => "Максимална стойност"
// numericmask.allowNegativeValues: "Allow negative values" => "Позволяване на отрицателни стойности"
// numericmask.thousandsSeparator: "Thousands separator" => "Разделител за хиляди"
// numericmask.decimalSeparator: "Decimal separator" => "Десетичен разделител"
// numericmask.precision: "Value precision" => "Точност на стойността"
// numericmask.min: "Minimum value" => "Минимална стойност"
// numericmask.max: "Maximum value" => "Максимална стойност"
// currencymask.prefix: "Currency prefix" => "Валутен префикс"
// currencymask.suffix: "Currency suffix" => "Валутен суфикс"
// pe.maskType: "Input mask type" => "Тип маска за въвеждане"
// maskTypes.patternmask: "Pattern" => "Шарка"
// maskTypes.numericmask: "Numeric" => "Цифров"
// maskTypes.datetimemask: "Date and Time" => "Дата и час"
// maskTypes.currencymask: "Currency" => "Валута"
// tabs.mask: "Input Mask Settings" => "Настройки на маската за въвеждане"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Пример: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Пример: мм/дд/гггг"
// pe.currencyprefix_placeholder: "Ex.: $" => "Пример: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Пример: USD"
// pv.textWrapEnabled: "Wrap choices" => "Опции за обтичане"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Дългите текстове в опциите за избор автоматично ще генерират нови редове, за да се поберат в падащото меню. Премахнете отметката, ако искате текстовете да бъдат изрязани."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Изберете дали искате да съхраните стойността на въпроса с приложена маска в резултатите от проучването."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Шаблонът може да съдържа низови литерали и следните контейнери: '9' - за цифра; \"а\" - за главна или малка буква; \"#\" - за цифра или главна или малка буква. Използвайте обратно наклонена черта \"\\\", за да избягате от знак."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Шаблонът може да съдържа разделителни знаци и следните контейнери: 'm' - за номер на месец; \"mm\" - за номер на месец, с водеща нула за едноцифрени стойности; \"d\" - за ден от месеца; \"dd\" - за ден от месеца, с водеща нула за едноцифрени стойности; \"yy\" - за последните две цифри на годината; 'гггг' - за четирицифрена година."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Символ, използван за отделяне на дробната част от целочислената част на показваното число."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Символ, използван за разделяне на цифрите на голямо число в групи от по три."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Ограничава колко цифри да се запазят след десетичната запетая за показваното число."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Един или няколко символа, които трябва да бъдат показани преди стойността."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Един или няколко символа, които трябва да се покажат след стойността."
// ed.translationSource: "Source: " => "Източник: "
// ed.translationTarget: "Target: " => "Цел: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Страницата е празна. Плъзнете елемент от кутията с инструменти или щракнете върху бутона по-долу."
// maskTypes.none: "None" => "Никой"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Направете реда видим, ако"
// itemvalue@rows.enableIf: "Make the row editable if" => "Направете реда редактируем, ако"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Текст в контейнер в режим само за четене или визуализация"
// pe.textWrapEnabled: "Wrap choices" => "Опции за обтичане"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Опцията \"Auto\" автоматично определя подходящия режим за показване - Image, Video или YouTube - въз основа на предоставения URL адрес на източника."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Изберете между \"Изображение\" и \"Видео\", за да зададете режима на съдържание на селектора на мултимедия. Ако е избрано \"Изображение\", уверете се, че всички предоставени опции са файлове с изображения в следните формати: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. По същия начин, ако е избрано \"Видео\", уверете се, че всички опции са директни връзки към видео файлове в следните формати: MP4, MOV, WMV, FLV, AVI, MKV. Моля, имайте предвид, че връзките в YouTube не се поддържат за опции за видео."
// ed.selectFile: "Select a file" => "Изберете файл"
// ed.removeFile: "Remove the file" => "Премахване на файла"
// pe.searchMode: "Search Mode" => "Режим на търсене"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Кликнете върху бутона \"Добавяне на въпрос\" по-долу, за да започнете да създавате своя формуляр."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Кликнете върху бутона \"Добавяне на въпрос\" по-долу, за да добавите нов елемент към страницата."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Кликнете върху бутона \"Добавяне на въпрос\" по-долу, за да добавите нов елемент към панела."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Кликнете върху бутона по-долу и изберете изображение за качване"
// coloralpha.opacity: "Opacity" => "Непрозрачност"
// font.family: "Font family" => "Семейство шрифтове"
// font.color: "Color" => "Цвят"
// font.placeholderColor: "Placeholder color" => "Цвят на контейнера"
// font.size: "Size" => "Големина"
// theme.themeName: "Theme" => "Тема"
// theme.isPanelless: "Question appearance" => "Външен вид на въпроса"
// theme.editorPanel: "Background and corner radius" => "Фон и радиус на ъгъла"
// theme.questionPanel: "Background and corner radius" => "Фон и радиус на ъгъла"
// theme.primaryColor: "Accent color" => "Цвят за акцентиране"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Непрозрачност на фона на панела"
// theme.questionBackgroundTransparency: "Question background opacity" => "Непрозрачност на фона на въпроса"
// theme.fontSize: "Font size" => "Размер на шрифта"
// theme.scale: "Scale" => "Мащаб"
// theme.cornerRadius: "Corner radius" => "Радиус на ъгъла"
// theme.pageTitle: "Title font" => "Шрифт на заглавието"
// theme.pageDescription: "Description font" => "Шрифт за описание"
// theme.questionTitle: "Title font" => "Шрифт на заглавието"
// theme.questionDescription: "Description font" => "Шрифт за описание"
// theme.editorFont: "Font" => "Шрифт"
// theme.backgroundOpacity: "Opacity" => "Непрозрачност"
// theme.--sjs-font-family: "Font family" => "Семейство шрифтове"
// theme.--sjs-general-backcolor-dim: "Background color" => "Цвят на фона"
// theme.--sjs-primary-backcolor: "Accent background" => "Фон за акцентиране"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Акцентиране на преден план"
// theme.--sjs-shadow-small: "Shadow effects" => "Ефекти на сянка"
// theme.--sjs-shadow-inner: "Shadow effects" => "Ефекти на сянка"
// theme.--sjs-border-default: "Colors" => "Цветове"
// header@header.headerView: "View" => "Изглед"
// header@header.logoPosition: "Logo position" => "Позиция на логото"
// header@header.surveyTitle: "Survey title font" => "Шрифт за заглавие на проучване"
// header@header.surveyDescription: "Survey description font" => "Шрифт за описание на проучването"
// header@header.headerTitle: "Survey title font" => "Шрифт за заглавие на проучване"
// header@header.headerDescription: "Survey description font" => "Шрифт за описание на проучването"
// header@header.inheritWidthFrom: "Content area width" => "Ширина на областта на съдържанието"
// header@header.textAreaWidth: "Text width" => "Ширина на текста"
// header@header.backgroundColorSwitch: "Background color" => "Цвят на фона"
// header@header.backgroundImage: "Background image" => "Фоново изображение"
// header@header.backgroundImageOpacity: "Opacity" => "Непрозрачност"
// header@header.overlapEnabled: "Overlap" => "Припокриване"
// header@header.logoPositionX: "Logo position" => "Позиция на логото"
// header@header.titlePositionX: "Title position" => "Позиция на заглавието"
// header@header.descriptionPositionX: "Description position" => "Описание позиция"
// weight.400: "Regular" => "Редовни"
// weight.600: "Heavy" => "Тежък"
// weight.700: "Semi-bold" => "Полу-полу-получер"
// weight.800: "Bold" => "Безочлив"
// backgroundImageFit.auto: "Auto" => "Авто"
// backgroundImageFit.cover: "Cover" => "Капак"
// backgroundImageFit.contain: "Contain" => "Съдържам"
// backgroundImageFit.fill: "Stretch" => "Участък"
// backgroundImageFit.tile: "Tile" => "Плочки"
// backgroundImageAttachment.fixed: "Fixed" => "Неподвижен"
// backgroundImageAttachment.scroll: "Scroll" => "Свитък"
// headerView.basic: "Basic" => "Основен"
// headerView.advanced: "Advanced" => "Напреднал"
// inheritWidthFrom.survey: "Same as survey" => "Същото като проучването"
// inheritWidthFrom.container: "Fit to container" => "Побиране в контейнера"
// backgroundColorSwitch.none: "None" => "Никой"
// backgroundColorSwitch.accentColor: "Accent color" => "Цвят за акцентиране"
// backgroundColorSwitch.custom: "Custom" => "Обичай"
// colorPalette.light: "Light" => "Светлина"
// colorPalette.dark: "Dark" => "Тъмен"
// isPanelless.false: "Default" => "По подразбиране"
// isPanelless.true: "Without Panels" => "Без панели"
// theme.cornerRadius: "Corner radius" => "Радиус на ъгъла"
// theme.fontFamily: "Font family" => "Семейство шрифтове"
// theme.fontWeightRegular: "Regular" => "Редовни"
// theme.fontWeightHeavy: "Heavy" => "Тежък"
// theme.fontWeightSemiBold: "Semi-bold" => "Полу-полу-получер"
// theme.fontWeightBold: "Bold" => "Безочлив"
// theme.color: "Color" => "Цвят"
// theme.placeholderColor: "Placeholder color" => "Цвят на контейнера"
// theme.size: "Size" => "Големина"
// theme.opacity: "Opacity" => "Непрозрачност"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Въведете за търсене..."
// ed.toolboxNoResultsFound: "No results found" => "Няма намерени резултати"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Контейнер за заглавие на раздел"
// theme.--sjs-special-red: "Error messages" => "Съобщения за грешки"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Резервен текст за заглавията на разделите, който се прилага, когато шаблонът за заглавие на раздела не създава смислена стойност."
// theme.fontColor: "Font color" => "Цвят на шрифта"
// theme.backgroundColor: "Background color" => "Цвят на фона"
// pe.questionTitleWidth: "Question title width" => "Ширина на заглавието на въпроса"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Избор на файл или поставяне на връзка към файл..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Пример: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Задава еднаква ширина за заглавията на въпросите, когато те са подравнени отляво на техните полета за въпроси. Приема CSS стойности (px, %, in, pt и т.н.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Задава еднаква ширина за заглавията на въпросите, когато те са подравнени отляво на техните полета за въпроси. Приема CSS стойности (px, %, in, pt и т.н.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Височина на областта за коментари (в редове)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Задава броя на показваните редове в текстовите области за коментари на въпроси. Във входа заема повече редове, плъзгачът се появява."


/***/ }),

/***/ "./src/localization/croatian.ts":
/*!**************************************!*\
  !*** ./src/localization/croatian.ts ***!
  \**************************************/
/*! exports provided: hrStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hrStrings", function() { return hrStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var hrStrings = {
    // survey templates
    survey: {
        edit: "Uređivanje",
        externalHelpLink: "Gledajte i saznajte kako stvoriti ankete",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Molimo ispustite pitanje ovdje iz Toolbox.",
        addLogicItem: "Izradite pravilo za prilagodbu tijeka ankete.",
        copy: "Kopirati",
        duplicate: "Duplikata",
        addToToolbox: "Dodaj u Toolbox",
        deletePanel: "Brisanje ploče",
        deleteQuestion: "Izbriši pitanje",
        convertTo: "Pretvorite u",
        drag: "Povucite element",
    },
    // Creator tabs
    tabs: {
        preview: "Ispitna anketa",
        theme: "Teme",
        translation: "Prijevod",
        designer: "Dizajner ankete",
        editor: "JSON urednik",
        logic: "Logika ankete"
    },
    // Question types
    qt: {
        default: "Zadani",
        checkbox: "Ček",
        comment: "Komentar",
        imagepicker: "Berač slika",
        ranking: "Rangiranje",
        image: "Slike",
        dropdown: "Padajući",
        tagbox: "Padajući izbornik s višestrukim odabirom",
        file: "Datoteku",
        html: "Html",
        matrix: "Matrica (jedan izbor)",
        matrixdropdown: "Matrica (višestruki izbor)",
        matrixdynamic: "Matrica (dinamički redovi)",
        multipletext: "Više teksta",
        panel: "Ploča",
        paneldynamic: "Ploča (dinamički paneli)",
        radiogroup: "Radiogrupa",
        rating: "Ocjena",
        text: "Jedan ulaz",
        boolean: "Booleova",
        expression: "Izraz (samo za čitanje)",
        signaturepad: "Jastučić za potpis",
        buttongroup: "Grupa gumba"
    },
    toolboxCategories: {
        general: "Općenito",
        choice: "Pitanja o izboru",
        text: "Pitanja o unosu teksta",
        containers: "Kontejnere",
        matrix: "Matrična pitanja",
        misc: "Ostalo"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Zadani ({0})",
        survey: "Anketa",
        settings: "Postavke ankete",
        settingsTooltip: "Otvaranje postavki ankete",
        surveySettings: "Postavke upitnika",
        surveySettingsTooltip: "Postavke upitnika",
        themeSettings: "Postavke teme",
        themeSettingsTooltip: "Postavke teme",
        showPanel: "Pokaži ploču",
        hidePanel: "Sakrij ploču",
        prevSelected: "Odaberi prethodno",
        nextSelected: "Odaberi sljedeće",
        prevFocus: "Fokusiraj prethodno",
        nextFocus: "Usredotoči se sljedeće",
        surveyTypeName: "Anketa",
        pageTypeName: "Stranica",
        panelTypeName: "Panel",
        questionTypeName: "Pitanje",
        columnTypeName: "Stupac",
        addNewPage: "Dodavanje nove stranice",
        moveRight: "Pomicanje udesno",
        moveLeft: "Pomicanje ulijevo",
        deletePage: "Brisanje stranice",
        editPage: "Uređivanje stranice",
        edit: "Uređivanje",
        newPageName: "stranica",
        newQuestionName: "pitanje",
        newPanelName: "ploča",
        newTextItemName: "tekst",
        defaultV2Theme: "Propust",
        modernTheme: "Moderan",
        defaultTheme: "Zadano (naslijeđeno)",
        testSurveyAgain: "Ponovno probna anketa",
        testSurveyWidth: "Širina ankete: ",
        navigateToMsg: "Morao si navigirati do:",
        saveSurvey: "Spremi anketu",
        saveSurveyTooltip: "Spremi anketu",
        saveTheme: "Spremi temu",
        saveThemeTooltip: "Spremi temu",
        jsonHideErrors: "Sakrij pogreške",
        jsonShowErrors: "Pokaži pogreške",
        undo: "Poništiti",
        redo: "Ponoviti",
        undoTooltip: "Poništi posljednju promjenu",
        redoTooltip: "Preusmjeti promjenu",
        showMoreChoices: "Pokaži više",
        showLessChoices: "Pokaži manje",
        copy: "Kopirati",
        cut: "Izrezati",
        paste: "Zalijepite",
        copyTooltip: "Kopiranje odabira u međuspremnik",
        cutTooltip: "Izrežite odabir na međuspremnik",
        pasteTooltip: "Pasta iz međuspremnika",
        options: "Mogućnosti",
        generateValidJSON: "Generiranje valjanog JSON",
        generateReadableJSON: "Generiranje čitljivog JSON",
        toolbox: "Alatni okvir",
        "property-grid": "Svojstva",
        toolboxFilteredTextPlaceholder: "Upišite za pretraživanje...",
        toolboxNoResultsFound: "Nisu pronađeni rezultati",
        propertyGridFilteredTextPlaceholder: "Upišite za pretraživanje...",
        propertyGridNoResultsFound: "Nisu pronađeni rezultati",
        correctJSON: "Ispravite JSON.",
        surveyResults: "Rezultat ankete: ",
        surveyResultsTable: "Kao tablica",
        surveyResultsJson: "Kao JSON",
        resultsTitle: "Naslov pitanja",
        resultsName: "Naziv pitanja",
        resultsValue: "Vrijednost odgovora",
        resultsDisplayValue: "Vrijednost prikaza",
        modified: "Izmjena",
        saving: "Spremanje",
        saved: "Spremiti",
        propertyEditorError: "Pogreška:",
        saveError: "Pogreška! Sadržaj urednika nije spremljen.",
        translationPropertyGridTitle: "Jezične postavke",
        themePropertyGridTitle: "Postavke teme",
        translationLanguages: "Jezici",
        translationDeleteLanguage: "Jeste li sigurni da želite izbrisati sve nizove za ovaj jezik?",
        translationAddLanguage: "Odaberite jezik za prevođenje",
        translationShowAllStrings: "Pokažite sve žice",
        translationShowUsedStringsOnly: "Samo korišteni nizovi",
        translationShowAllPages: "Pokažite sve stranice",
        translationNoStrings: "Nema žica za prevođenje. Promijenite filtar.",
        translationExportToSCVButton: "Izvoz u CSV",
        translationImportFromSCVButton: "Uvoz iz CSV",
        translateUsigAI: "Automatski prevedi sve",
        translateUsigAIFrom: "Prevedi iz: ",
        translationDialogTitle: "Neprevedeni nizovi",
        translationMergeLocaleWithDefault: "Spajanje {0} sa zadanim lokalomwith default locale.",
        translationPlaceHolder: "Prevođenje...",
        translationSource: "Izvor: ",
        translationTarget: "Cilj: ",
        themeExportButton: "Izvoz",
        themeImportButton: "Uvoz",
        surveyJsonExportButton: "Izvoz",
        surveyJsonImportButton: "Uvoz",
        surveyJsonCopyButton: "Kopiraj u međuspremnik",
        themeResetButton: "Vraćanje zadanih postavki teme na zadano",
        themeResetConfirmation: "Želite li zaista resetirati temu? Sve prilagodbe bit će izgubljene.",
        themeResetConfirmationOk: "Da, resetirajte temu",
        bold: "podebljano",
        italic: "kurziv",
        underline: "podcrtavanje",
        addNewQuestion: "Dodaj pitanje",
        selectPage: "Odaberite stranicu...",
        carryForwardChoicesCopied: "Odabiri se kopiraju iz",
        choicesLoadedFromWebText: "Izbori se učitavaju s web-usluge.",
        choicesLoadedFromWebLinkText: "Idi na postavke",
        choicesLoadedFromWebPreviewTitle: "Pretpregled učitanih mogućnosti izbora",
        htmlPlaceHolder: "HTML sadržaj će biti ovdje.",
        panelPlaceHolder: "Ovdje ispustite pitanje iz kutije s alatima.",
        surveyPlaceHolder: "Anketa je prazna. Povucite element iz alatnog okvira ili kliknite donji gumb.",
        pagePlaceHolder: "Stranica je prazna. Povucite element iz alatnog okvira ili kliknite donji gumb.",
        imagePlaceHolder: "Povucite i ispustite sliku ovdje ili kliknite donji gumb i odaberite sliku koju želite prenijeti",
        surveyPlaceHolderMobile: "Kliknite donji gumb \"Dodaj pitanje\" da biste započeli stvaranje obrasca.",
        pagePlaceHolderMobile: "Kliknite donji gumb \"Dodaj pitanje\" da biste na stranicu dodali novi element.",
        panelPlaceHolderMobile: "Kliknite donji gumb \"Dodaj pitanje\" da biste na ploču dodali novi element.",
        imagePlaceHolderMobile: "Kliknite donji gumb i odaberite sliku koju želite prenijeti",
        imageChooseImage: "Odabir slike",
        addNewTypeQuestion: "Dodaj {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Stavka ",
        selectFile: "Odabir datoteke",
        removeFile: "Uklanjanje datoteke",
        lg: {
            addNewItem: "Dodaj novo pravilo",
            empty_tab: "Stvorite pravilo za prilagodbu tijeka upitnika.",
            page_visibilityName: "Vidljivost stranice",
            page_enableName: "Omogući (onemogući stranicu)",
            page_requireName: "Učini stranicu obaveznom",
            panel_visibilityName: "Vidljivost panela",
            panel_enableName: "Omogući/onemogući panel",
            panel_requireName: "Učini stranicu obaveznom",
            question_visibilityName: "Vidljivost pitanja",
            question_enableName: "Pitanje omogućuje/onesposobljava",
            question_requireName: "Pitanje nije obavezno",
            question_resetValueName: "Vrati izvornu vrijednost pitanja",
            question_setValueName: "Postavljanje vrijednosti pitanja",
            column_visibilityName: "Pokaži (sakrij) stupac",
            column_enableName: "Omogući (onemogući stupac)",
            column_requireName: "Učini stupac obaveznim",
            column_resetValueName: "Vraćanje izvorne vrijednosti stupca",
            column_setValueName: "Postavljanje vrijednosti stupca",
            trigger_completeName: "Potpuna anketa",
            trigger_setvalueName: "Postavite vrijednost pitanja",
            trigger_copyvalueName: "Kopiranje vrijednosti pitanja",
            trigger_skipName: "Prijeđite na pitanje",
            trigger_runExpressionName: "Pokretanje prilagođenog izraza",
            completedHtmlOnConditionName: "Prilagođeni 'Thank you page' tekst",
            page_visibilityDescription: "Učinite stranicu vidljivom kada se logička ekspresija vrati istinitom. Inače neka bude nevidljivo.",
            panel_visibilityDescription: "Učinite ploču vidljivom kada se logička ekspresija vrati istinitom. Inače ga držati nevidljivim.",
            panel_enableDescription: "Učinite ploču i sve elemente unutar nje omogućite kada se logička ekspresija vrati istinita. Inače ih držite onesposobljenima.",
            question_visibilityDescription: "Učinite pitanje vidljivim kada se logička ekspresija vrati istinita. Inače ga držati nevidljivim.",
            question_enableDescription: "Omogućite pitanje kada se logička ekspresija vrati istinita. Inače ga držati onemogućen.",
            question_requireDescription: "Pitanje postaje potrebno kada se logička ekspresija vrati istinita.",
            trigger_completeDescription: "Kada se logička ekspresija vrati istinita, anketa postaje dovršena i krajnji korisnik vidi 'Thank you page'.",
            trigger_setvalueDescription: "Kada se vrijednosti pitanja, koje se koriste u logičkom izrazu, mijenjaju i logička ekspresija se vraća istinita, tada se vrijednost postavlja na odabrano pitanje.",
            trigger_copyvalueDescription: "Kada se vrijednosti pitanja, koje se koriste u logičkoj ekspresiji, mijenjaju i logička ekspresija se vraća istinita, tada se vrijednost jednog odabranog pitanja kopira na drugo odabrano pitanje.",
            trigger_skipDescription: "Kada se logička ekspresija vrati istinita, anketa preskače na / fokusira odabrano pitanje.",
            trigger_runExpressionDescription: "Kada se logička ekspresija vrati istinita, tada se izvodi prilagođeni izraz. Taj rezultat izraza možete neobavezno postaviti u odabrano pitanje.",
            completedHtmlOnConditionDescription: "Ako se logička ekspresija vrati istinita, zadani tekst za 'Thank you page' mijenja se u zadani.",
            itemExpressionText: "Kada se izraz '{0}' vrati istinit",
            itemEmptyExpressionText: "Novo pravilo",
            page_visibilityText: "Učinite stranicu {0} vidljivom",
            panel_visibilityText: "Učinite ploču {0} vidljivom",
            panel_enableText: "Omogući panel x {0}",
            question_visibilityText: "Učinite pitanje {0} vidljivim",
            question_enableText: "Omogući pitanje {0}",
            question_requireText: "Neka pitanje {0} bude potrebno",
            question_resetValueText: "Vrati izvornu vrijednost za pitanje: {0}",
            question_setValueText: "Dodijeli vrijednost: {1} pitanje: {0}",
            column_visibilityText: "učiniti stupac {0} pitanja vidljivim {1}",
            column_enableText: "{1} omogućivanje stupca {0} pitanja",
            column_requireText: "Učinite stupac {0} pitanja {1} potrebnim",
            column_resetValueText: "Vrati izvornu vrijednost ćelije za stupac: {0}",
            column_setValueText: "Dodijeli vrijednost ćelije: {1} stupcu: {0}",
            setValueExpressionPlaceholder: " Izraz čiji će rezultat biti dodijeljen ciljnom pitanju.",
            trigger_completeText: "Anketa se dovrša",
            trigger_setvalueText: "Postavljeno u pitanje: {0} vrijednost {1}",
            trigger_setvalueEmptyText: "Očisti vrijednost pitanja: {0}",
            trigger_copyvalueText: "Kopirajte u pitanje: {0} vrijednost od pitanja {1}",
            trigger_skipText: "Anketa preskače na pitanje {0}",
            trigger_runExpressionText1: "Pokretanje izraza: '{0}'",
            trigger_runExpressionText2: " i dovela u pitanje svoj rezultat: {0}",
            completedHtmlOnConditionText: "Prikazati prilagođeni tekst za 'Thank you page'.",
            showAllQuestions: "Sva pitanja",
            showAllActionTypes: "Sve vrste akcija",
            conditions: "Stanje/Stanja",
            actions: "Akcije",
            expressionEditorTitle: "Definiranje uvjeta",
            actionsEditorTitle: "Definiranje radnji",
            deleteAction: "Brisanje radnje",
            addNewAction: "Dodavanje nove akcije",
            selectedActionCaption: "Odaberite radnju za dodavanje...",
            expressionInvalid: "Logička ekspresija je prazna ili nevažeća. Molim vas, ispravite to.",
            noActionError: "Molim vas, dodajte barem jednu akciju.",
            actionInvalid: "Molimo vas da riješite probleme u svojoj akciji.",
            uncompletedRule_title: "Logička pravila nisu potpuna",
            uncompletedRule_text: "Niste dovršili neka logička pravila. Ako sada napustite karticu, promjene će se izgubiti. Želite li ipak napustiti karticu bez dovršetka promjena?",
            uncompletedRule_apply: "Da",
            uncompletedRule_cancel: "Ne, želim ispuniti pravila."
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Naziv ploče",
            title: "Naslov ploče",
            description: "Opis ploče",
            visibleIf: "Učini ploču vidljivom ako",
            requiredIf: "Učinite ploču potrebnom ako",
            questionsOrder: "Redoslijed pitanja unutar ploče",
            page: "Nadređena stranica",
            startWithNewLine: "Prikaz ploče na novom retku",
            state: "Stanje sažimanja ploče",
            width: "Širina umetnute ploče",
            minWidth: "Minimalna širina ploče",
            maxWidth: "Maksimalna širina ploče",
            showNumber: "Brojčane ploče"
        },
        paneldynamic: {
            name: "Naziv ploče",
            title: "Naslov ploče",
            description: "Opis ploče",
            visibleIf: "Učini ploču vidljivom ako",
            requiredIf: "Učinite ploču potrebnom ako",
            page: "Premještanje ploče na stranicu",
            startWithNewLine: "Prikaz ploče na novom retku",
            state: "Stanje sažimanja ploče",
            width: "Širina umetnute ploče",
            minWidth: "Minimalna širina ploče",
            maxWidth: "Maksimalna širina ploče",
            confirmDelete: "Potvrda brisanja ploče",
            templateDescription: "Uzorak opisa ploče",
            templateTitle: "Uzorak naslova ploče",
            noEntriesText: "Prazan tekst ploče",
            templateTabTitle: "Uzorak naslova kartice",
            tabTitlePlaceholder: "Rezervirano mjesto naslova tabulatora",
            templateVisibleIf: "Učinite pojedinačnu ploču vidljivom ako",
            hideNumber: "Skrivanje broja ploče",
            titleLocation: "Poravnanje naslova ploče",
            descriptionLocation: "Poravnanje opisa ploče",
            templateTitleLocation: "Poravnanje naslova pitanja",
            templateErrorLocation: "Poravnanje poruke o pogrešci",
            newPanelPosition: "Novo mjesto ploče",
            keyName: "Spriječite dvostruke odgovore u sljedećem pitanju"
        },
        question: {
            name: "Naziv pitanja",
            title: "Naslov pitanja",
            description: "Opis pitanja",
            visibleIf: "Učinite pitanje vidljivim ako",
            requiredIf: "Neka pitanje bude potrebno ako:",
            page: "Nadređena stranica",
            state: "Stanje sažimanja okvira pitanja",
            hideNumber: "Skrivanje broja pitanja",
            titleLocation: "Poravnanje naslova pitanja",
            descriptionLocation: "Poravnanje opisa pitanja",
            errorLocation: "Poravnanje poruke o pogrešci",
            indent: "Povećajte unutarnju uvlaku",
            width: "Širina umetnutog pitanja",
            minWidth: "Minimalna širina pitanja",
            maxWidth: "Maksimalna širina pitanja",
            textUpdateMode: "Ažuriranje vrijednosti polja unosa"
        },
        signaturepad: {
            signatureWidth: "Širina područja potpisa",
            signatureHeight: "Visina područja potpisa",
            signatureAutoScaleEnabled: "Automatsko mijenjanje područja potpisa",
            showPlaceholder: "Pokaži rezervirano mjesto",
            placeholder: "Tekst rezerviranog mjesta",
            placeholderReadOnly: "Tekst rezerviranog mjesta u načinu samo za čitanje ili pretpregledu",
            allowClear: "Prikaz gumba Očisti unutar područja za potpis",
            penMinWidth: "Minimalna širina olovke",
            penMaxWidth: "Maksimalna širina olovke",
            penColor: "Boja poteza"
        },
        comment: {
            rows: "Visina polja unosa (u recima)"
        },
        showQuestionNumbers: "Prikazate brojeve pitanja",
        questionStartIndex: "Indeks pokretanja pitanja (1, 2 ili 'A', 'a')",
        expression: {
            name: "Naziv izraza",
            title: "Naslov izraza",
            description: "Opis izraza",
            expression: "Izraz"
        },
        trigger: {
            expression: "Izraz"
        },
        calculatedvalue: {
            expression: "Izraz"
        },
        // survey templates
        survey: {
            title: "Naslov",
            description: "Opis upitnika"
        },
        page: {
            name: "Naziv stranice",
            title: "Naslov",
            description: "Opis stranice",
            visibleIf: "Učini stranicu vidljivom ako",
            requiredIf: "Učini stranicu potrebnom ako",
            maxTimeToFinish: "Vremensko ograničenje za dovršetak stranice (u sekundama)",
            questionsOrder: "Redoslijed pitanja na stranici"
        },
        matrixdropdowncolumn: {
            name: "Naziv stupca",
            title: "Naslov stupca",
            isUnique: "Sprječavanje dvostrukih odgovora",
            width: "Širina stupca",
            minWidth: "Minimalna širina stupca",
            rows: "Visina polja unosa (u recima)",
            visibleIf: "Učini stupac vidljivim ako",
            requiredIf: "Učinite stupac potrebnim ako",
            showInMultipleColumns: "Svaka mogućnost u zasebnom stupcu"
        },
        multipletextitem: {
            name: "Ime",
            title: "Naslov"
        },
        masksettings: {
            saveMaskedValue: "Spremanje maskirane vrijednosti u rezultate upitnika"
        },
        patternmask: {
            pattern: "Uzorak vrijednosti"
        },
        datetimemask: {
            min: "Minimalna vrijednost",
            max: "Maksimalna vrijednost"
        },
        numericmask: {
            allowNegativeValues: "Dopusti negativne vrijednosti",
            thousandsSeparator: "Razdjelnik tisućica",
            decimalSeparator: "Decimalni razdjelnik",
            precision: "Preciznost vrijednosti",
            min: "Minimalna vrijednost",
            max: "Maksimalna vrijednost"
        },
        currencymask: {
            prefix: "Prefiks valute",
            suffix: "Sufiks valute"
        },
        imageHeight: "Visina slike",
        imageWidth: "Širina slike",
        valueName: "Naziv vrijednosti",
        rateDescriptionLocation: "Poravnanje natpisa",
        size: "Veličina polja unosa (u znakovima)",
        cellErrorLocation: "Poravnanje poruke o pogrešci ćelije",
        apply: "Primijeniti",
        ok: "OK",
        save: "Spremiti",
        clear: "Jasan",
        saveTooltip: "Spremiti",
        cancel: "Otkazati",
        set: "Skup",
        reset: "Resetirati",
        change: "Mijenjati",
        refresh: "Osvježi",
        close: "Blizak",
        delete: "Izbrisati",
        add: "Dodati",
        addNew: "Dodaj novo",
        addItem: "Kliknite da biste dodali stavku...",
        removeItem: "Kliknite da biste uklonili stavku...",
        dragItem: "Vucite stavku",
        addOther: "Drugih",
        addSelectAll: "Odaberite sve",
        addNone: "Nitko",
        removeAll: "Uklonite sve",
        edit: "Uređivanje",
        back: "Povratak bez uštede",
        backTooltip: "Povratak bez uštede",
        saveAndBack: "Spremanje i vraćanje",
        saveAndBackTooltip: "Spremanje i vraćanje",
        doneEditing: "Učinjeno",
        editChoices: "Uređivanje izbora",
        showChoices: "Pokažite izbore",
        move: "Premjestiti",
        empty: "<empty>",
        emptyValue: "Vrijednost je prazna",
        fastEntry: "Brzi unos",
        fastEntryNonUniqueError: "Vrijednost '{0}' nije jedinstvena",
        fastEntryChoicesCountError: "Ograničite broj stavki s {0} na {1}",
        fastEntryChoicesMinCountError: "Unesite najmanje {0} stavki",
        fastEntryPlaceholder: "Podatke možete postaviti u sljedećem obliku:\nvrijednost1|tekst\nvrijednost2",
        formEntry: "Unos obrasca",
        testService: "Testirajte uslugu",
        itemSelectorEmpty: "Odaberite element",
        conditionActionEmpty: "Odaberite radnju",
        conditionSelectQuestion: "Odaberite pitanje...",
        conditionSelectPage: "Odaberite stranicu...",
        conditionSelectPanel: "Odabir ploče...",
        conditionValueQuestionTitle: "Unesite/odaberite vrijednost",
        aceEditorHelp: "Pritisnite ctrl + prostor kako biste dobili savjet o završetku ekspresije",
        aceEditorRowTitle: "Trenutni redk",
        aceEditorPanelTitle: "Trenutna ploča",
        showMore: "Više detalja potražite u dokumentaciji",
        assistantTitle: "Dostupna pitanja:",
        cellsEmptyRowsColumns: "Trebao bi postojati barem jedan stupac ili red",
        showPreviewBeforeComplete: "Pregled odgovora prije slanja ankete",
        overridingPropertyPrefix: "Postavio ",
        resetToDefaultCaption: "Brisanje",
        propertyIsEmpty: "Unesite vrijednost",
        propertyIsNoUnique: "Unesite jedinstvenu vrijednost",
        propertyNameIsNotUnique: "Unesite jedinstveno ime",
        propertyNameIsIncorrect: "Nemojte koristiti rezervirane riječi: \"stavka\", \"izbor\", \"ploča\", \"red\".",
        listIsEmpty: "Dodavanje nove stavke",
        "listIsEmpty@choices": "Još nema izbora",
        "listIsEmpty@columns": "Još nemate kolumne",
        "listIsEmpty@rows": "Još nemate redaka",
        "listIsEmpty@validators": "Još nemate pravila provjere valjanosti",
        "listIsEmpty@calculatedValues": "Još nemate prilagođene varijable",
        "listIsEmpty@triggers": "Još nemaš okidača",
        "listIsEmpty@navigateToUrlOnCondition": "Još nemate poveznice",
        "addNew@choices": "Dodavanje izbora",
        "addNew@columns": "Dodaj novi stupac",
        "addNew@rows": "Dodaj novi redak",
        "addNew@validators": "Dodaj novo pravilo",
        "addNew@calculatedValues": "Dodaj novu varijablu",
        "addNew@triggers": "Dodaj novi okidač",
        "addNew@navigateToUrlOnCondition": "Dodaj novi URL",
        expressionIsEmpty: "Izraz je prazan",
        value: "Vrijednost",
        text: "tekst",
        rowid: "ID redaka",
        imageLink: "Veza slike",
        columnEdit: "Uređivanje stupca: {0}",
        itemEdit: "Uređivanje stavke: {0}",
        url: "Url",
        path: "Put",
        choicesbyurl: {
            url: "URL web-usluge",
            valueName: "Dohvaćanje vrijednosti iz sljedećeg JSON polja"
        },
        titleName: "Naziv naslova",
        imageLinkName: "Dohvaćanje URL-ova slika iz sljedećeg JSON polja",
        allowEmptyResponse: "Dopusti prazan odgovor",
        titlePlaceholder: "Ulazni naslov ovdje",
        surveyTitlePlaceholder: "Naslov ulazne ankete ovdje",
        pageTitlePlaceholder: "Naslov ulazne stranice ovdje",
        descriptionPlaceholder: "Unesite opis",
        surveyDescriptionPlaceholder: "Unesite opis ankete",
        pageDescriptionPlaceholder: "Unesite opis stranice",
        textWrapEnabled: "Prelamanje izbora",
        showOtherItem: "Ima i drugu stavku",
        otherText: "Tekst druge stavke",
        showNoneItem: "Nema stavku",
        showRefuseItem: "Dopusti mogućnost Odbij odgovoriti",
        showDontKnowItem: "Dopusti mogućnost Ne znam",
        noneText: "Nijedan tekst stavke",
        showSelectAllItem: "Sadrži odaberite sve stavke",
        selectAllText: "Odaberite sve stavke tekst",
        choicesMin: "Minimalna vrijednost za automatski generirane stavke",
        choicesMax: "Maksimalna vrijednost za automatski generirane stavke",
        choicesStep: "Razlika između automatski generiranih stavki",
        name: "Ime",
        title: "Naslov",
        cellType: "Vrsta ćelije",
        colCount: "Broj stupaca",
        choicesOrder: "Odaberite redoslijed izbora",
        visible: "Je li vidljivo?",
        isRequired: "Je potrebno?",
        markRequired: "Označi kao obavezno",
        removeRequiredMark: "Uklanjanje potrebne oznake",
        isAllRowRequired: "Zahtijevati odgovor za sve redove",
        eachRowUnique: "Sprječavanje dvostrukih odgovora u recima",
        requiredErrorText: "Potreban tekst pogreške",
        startWithNewLine: "Počinje li s novom linijom?",
        rows: "Broj redaka",
        cols: "Broj stupaca",
        placeholder: "Držač ulaznog mjesta",
        showPreview: "Prikaz područja pretpregleda",
        storeDataAsText: "Pohranite sadržaj datoteke u rezultat JSON kao tekst",
        maxSize: "Maksimalna veličina datoteke u bytes",
        rowCount: "Broj redaka",
        columnLayout: "Raspored stupaca",
        addRowLocation: "Dodavanje lokacije gumba redaka",
        transposeData: "Transponiranje redaka u stupce",
        addRowText: "Dodavanje teksta gumba redak",
        removeRowText: "Uklanjanje teksta gumba redaka",
        rateMin: "Minimalna stopa",
        rateMax: "Maksimalna stopa",
        rateStep: "Korak stope",
        minRateDescription: "Opis minimalne stope",
        maxRateDescription: "Opis maksimalne stope",
        inputType: "Vrsta unosa",
        optionsCaption: "Opis opcija",
        defaultValue: "Zadana vrijednost",
        cellsDefaultRow: "Zadani tekstovi ćelija",
        surveyEditorTitle: "Uređivanje postavki ankete",
        qEditorTitle: "Uređivanje: {0}",
        maxLength: "Maksimalna duljina",
        buildExpression: "Graditi",
        editExpression: "Uređivanje",
        and: "i",
        or: "ili",
        remove: "Ukloniti",
        addCondition: "Dodavanje stanja",
        emptyLogicPopupMessage: "Odaberite pitanje da biste započeli konfiguriranje uvjeta.",
        if: "Ako",
        then: "zatim",
        setToName: "Ciljno pitanje",
        fromName: "Pitanje iz kojeg treba kopirati odgovor",
        gotoName: "Pitanje na koje treba preskočiti",
        ruleIsNotSet: "Pravilo nije ispravno",
        includeIntoResult: "Uključi u rezultate ankete",
        showTitle: "Pokaži/sakrij naslov",
        expandCollapseTitle: "Naslov proširenja/kolapsa",
        locale: "Zadani jezik",
        simulator: "Odaberite uređaj",
        landscapeOrientation: "Krajolik",
        portraitOrientation: "Prebacivanje na okomito usmjerenje",
        mode: "Način rada (samo uređivanje/čitanje)",
        clearInvisibleValues: "Jasne nevidljive vrijednosti",
        cookieName: "Naziv kolačića (onemogućiti anketu dva puta lokalno)",
        sendResultOnPageNext: "Pošaljite rezultate ankete na sljedeću stranicu",
        storeOthersAsComment: "Pohranite vrijednost 'others' u zasebnom polju",
        showPageTitles: "Prikazate naslove stranica",
        showPageNumbers: "Prikazate brojeve stranica",
        pagePrevText: "Tekst prethodnog gumba stranice",
        pageNextText: "Tekst sljedećeg gumba stranice",
        completeText: "Complete button text",
        previewText: "Tekst gumba za pretpregled",
        editText: "Uređivanje teksta gumba",
        startSurveyText: "Tekst gumba za pokretanje",
        showNavigationButtons: "Prikakanje navigacijskih tipki (zadana navigacija)",
        showPrevButton: "Prikagnite prethodni gumb (korisnik se može vratiti na prethodnu stranicu)",
        firstPageIsStarted: "Prva stranica u anketi je početna stranica.",
        showCompletedPage: "Prikagušite dovršenu stranicu na kraju (completedHtml)",
        goNextPageAutomatic: "Kada odgovarate na sva pitanja, idite automatski na sljedeću stranicu",
        allowCompleteSurveyAutomatic: "Automatsko ispunjavanje upitnika",
        showProgressBar: "Pokaži traku napretka",
        questionTitleLocation: "Lokacija naslova pitanja",
        questionTitleWidth: "Širina naslova pitanja",
        requiredText: "Pitanje je zahtijevalo simbole",
        questionTitleTemplate: "Predložak naslova pitanja, zadano je: '{no}. {require} {title}'",
        questionErrorLocation: "Mjesto pogreške u pitanju",
        focusFirstQuestionAutomatic: "Usredotočite prvo pitanje na promjenu stranice",
        questionsOrder: "Redoslijed elemenata na stranici",
        maxTimeToFinish: "Maksimalno vrijeme za dovršaje ankete",
        maxTimeToFinishPage: "Maksimalno vrijeme za dovršanje stranice u anketi",
        showTimerPanel: "Pokaži ploču timera",
        showTimerPanelMode: "Prikazate način rada timer panela",
        renderMode: "Način prikaza",
        allowAddPanel: "Dopustite dodavanje ploče",
        allowRemovePanel: "Dopustite uklanjanje ploče",
        panelAddText: "Dodavanje teksta panela",
        panelRemoveText: "Removing panel text",
        isSinglePage: "Uklanjanje teksta ploče",
        html: "Html",
        setValue: "Odgovor",
        dataFormat: "Oblik slike",
        allowAddRows: "Dopusti dodavanje redaka",
        allowRemoveRows: "Dopusti uklanjanje redaka",
        allowRowsDragAndDrop: "Dopusti povlačenje i ispuštanje retka",
        responsiveImageSizeHelp: "Ne primjenjuje se ako navedete točnu širinu ili visinu slike.",
        minImageWidth: "Minimalna širina slike",
        maxImageWidth: "Maksimalna širina slike",
        minImageHeight: "Minimalna visina slike",
        maxImageHeight: "Maksimalna visina slike",
        minValue: "Minimalna vrijednost",
        maxValue: "Maksimalna vrijednost",
        minLength: "Minimalna duljina",
        allowDigits: "Dopustite znamenke",
        minCount: "Minimalno brojanje",
        maxCount: "Maksimalni broj",
        regex: "Redoviti izraz",
        surveyvalidator: {
            text: "Poruka o pogrešci",
            expression: "Izraz za provjeru valjanosti"
        },
        totalText: "Ukupan tekst",
        totalType: "Ukupna vrsta",
        totalExpression: "Ukupni izraz",
        totalDisplayStyle: "Ukupan stil prikaza",
        totalCurrency: "Ukupna valuta",
        totalFormat: "Ukupan format",
        logo: "Logotip (URL ili niz kodiran base64)",
        questionsOnPageMode: "Struktura upitnika",
        maxTextLength: "Maksimalna duljina odgovora (u znakovima)",
        maxOthersLength: "Maksimalna duljina komentara (u znakovima)",
        commentAreaRows: "Visina područja komentara (u recima)",
        autoGrowComment: "Ako je potrebno, automatsko proširivanje područja komentara",
        allowResizeComment: "Dopusti korisnicima promjenu veličine tekstnih područja",
        textUpdateMode: "Ažuriranje vrijednosti tekstnog pitanja",
        maskType: "Vrsta maske za unos",
        maskTypes: {
            none: "Nijedan",
            patternmask: "Uzorak",
            numericmask: "Brojčani",
            datetimemask: "Datum i vrijeme",
            currencymask: "Valuta"
        },
        focusOnFirstError: "Postavljanje fokusa na prvi odgovor koji nije valjan",
        checkErrorsMode: "Pokreni provjeru valjanosti",
        navigateToUrl: "Navigacija do URL-a",
        navigateToUrlOnCondition: "Dinamički URL",
        completedBeforeHtml: "Oznaka koja pokazuje je li korisnik već ispunio ovu anketu",
        completedHtml: "Označavanje stranice dovršeno u anketi",
        completedHtmlOnCondition: "Oznaka stranice Dynamic Survey Completed",
        loadingHtml: "Oznaka za prikaz tijekom učitavanja modela upitnika",
        commentText: "Tekst područja komentara",
        autocomplete: "Vrsta samodovršetka",
        labelTrue: "Oznaka \"True\"",
        labelFalse: "Oznaka \"False\"",
        allowClear: "Prikaz gumba Očisti",
        searchMode: "Način pretraživanja",
        displayStyle: "Stil prikaza vrijednosti",
        format: "Oblikovani niz",
        maximumFractionDigits: "Maksimalne djelomične znamenke",
        minimumFractionDigits: "Minimalne djelomične znamenke",
        useGrouping: "Prikaži razdjelnike grupiranja",
        allowMultiple: "Dopusti više datoteka",
        allowImagesPreview: "Pretpregled slika",
        acceptedTypes: "Prihvaćene vrste datoteka",
        waitForUpload: "Pričekajte da se prijenos dovrši",
        needConfirmRemoveFile: "Potvrda brisanja datoteke",
        detailPanelMode: "Mjesto ploče s detaljima",
        minRowCount: "Najmanji broj redaka",
        maxRowCount: "Maksimalan broj redaka",
        confirmDelete: "Potvrda brisanja retka",
        confirmDeleteText: "Potvrdna poruka",
        panelCount: "Početni broj ploča",
        minPanelCount: "Najmanji broj ploča",
        maxPanelCount: "Maksimalan broj ploča",
        panelsState: "Stanje proširenja unutarnje ploče",
        panelPrevText: "Opis alata gumba Prethodna ploča",
        panelNextText: "Opis alata gumba Sljedeća ploča",
        showRangeInProgress: "Pokaži traku tijeka",
        panelRemoveButtonLocation: "Ukloni mjesto gumba ploče",
        hideIfRowsEmpty: "Sakrij pitanje ako nema redaka",
        hideColumnsIfEmpty: "Sakrij stupce ako nema redaka",
        rateValues: "Vrijednosti prilagođene stope",
        rateCount: "Broj stopa",
        autoGenerate: "Kako odrediti vrijednosti stope?",
        hideIfChoicesEmpty: "Sakrij pitanje ako ne sadrži izbora",
        minWidth: "Minimalna širina (u CSS-prihvaćenim vrijednostima)",
        maxWidth: "Maksimalna širina (u CSS-prihvaćenim vrijednostima)",
        width: "Širina (u CSS-prihvaćenim vrijednostima)",
        showHeader: "Pokaži zaglavlja stupaca",
        horizontalScroll: "Pokaži vodoravni klizač",
        columnMinWidth: "Minimalna širina stupca (u CSS-prihvaćenim vrijednostima)",
        rowTitleWidth: "Širina zaglavlja retka (u CSS-prihvaćenim vrijednostima)",
        valueTrue: "Vrijednost \"True\"",
        valueFalse: "Vrijednost \"False\"",
        minErrorText: "Poruka o pogrešci \"Vrijednost je ispod minimuma\"",
        maxErrorText: "Poruka o pogrešci \"Vrijednost premašuje maksimum\"",
        otherErrorText: "Poruka o pogrešci \"Prazan komentar\"",
        keyDuplicationError: "Poruka o pogrešci \"Nejedinstvena vrijednost ključa\"",
        minSelectedChoices: "Minimalno odabrani odabiri",
        maxSelectedChoices: "Maksimalan broj odabranih izbora",
        showClearButton: "Prikaz gumba Očisti",
        logoWidth: "Širina logotipa (u CSS-prihvaćenim vrijednostima)",
        logoHeight: "Visina logotipa (u CSS-prihvaćenim vrijednostima)",
        readOnly: "Samo za čitanje",
        enableIf: "Može se uređivati ako",
        emptyRowsText: "Poruka \"Bez redaka\"",
        separateSpecialChoices: "Razdvoji posebne odabire (Ništa, Ostalo, Odaberi sve)",
        choicesFromQuestion: "Kopiraj odabire iz sljedećeg pitanja",
        choicesFromQuestionMode: "Koje izbore kopirati?",
        progressBarShowPageTitles: "Prikaz naslova stranica na traci tijeka",
        progressBarShowPageNumbers: "Prikaz brojeva stranica na traci tijeka",
        showCommentArea: "Prikaz područja komentara",
        commentPlaceholder: "Rezervirano mjesto područja komentara",
        displayRateDescriptionsAsExtremeItems: "Opisi brzine prikaza kao ekstremne vrijednosti",
        rowsOrder: "Redoslijed redaka",
        columnsLayout: "Izgled stupca",
        columnColCount: "Broj ugniježđenih stupaca",
        correctAnswer: "Točan odgovor",
        defaultPanelValue: "Zadane vrijednosti",
        cells: "Tekstovi ćelija",
        fileInputPlaceholder: "Odabir datoteke ili lijepljenje veze na datoteku...",
        keyName: "Stupac ključa",
        itemvalue: {
            visibleIf: "Učini mogućnost vidljivom ako",
            enableIf: "Učini mogućnost odabranom ako"
        },
        "itemvalue@rows": {
            visibleIf: "Učini redak vidljivim ako",
            enableIf: "Učinite redak mogućim za uređivanje ako"
        },
        imageitemvalue: {
            text: "Zamjenski tekst"
        },
        logoPosition: "Položaj logotipa",
        addLogo: "Dodavanje logotipa...",
        changeLogo: "Promjena logotipa...",
        logoPositions: {
            none: "Uklanjanje logotipa",
            left: "Lijevo",
            right: "Desno",
            top: "Na vrhu",
            bottom: "Na dnu"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Izgled ploče"
            },
            general: "Općenito",
            fileOptions: "Mogućnosti",
            html: "Html Editor",
            columns: "Stupce",
            rows: "Redaka",
            choices: "Izbora",
            items: "Stavke",
            visibleIf: "Vidljivo ako",
            enableIf: "Omogući ako",
            requiredIf: "Potrebno ako",
            rateValues: "Vrijednosti cijena",
            choicesByUrl: "Izbori s weba",
            matrixChoices: "Zadani izbori",
            multipleTextItems: "Unosi teksta",
            numbering: "Numeriranje",
            validators: "Validatori",
            navigation: "Navigacija",
            question: "Pitanje",
            pages: "Stranice",
            timer: "Timer/Kviz",
            calculatedValues: "Izračunate vrijednosti",
            triggers: "Aktivira",
            templateTitle: "Naslov predloška",
            totals: "Zbrojeve",
            logic: "Logika",
            mask: "Postavke maske za unos",
            layout: {
                panel: "Tlocrt",
                question: "Tlocrt",
                base: "Tlocrt"
            },
            data: "Podataka",
            validation: "Provjera valjanosti",
            cells: "Ćelije",
            showOnCompleted: "Prikazuje se na dovršenom",
            logo: "Logotip u naslovu ankete",
            slider: "Klizač",
            expression: "Izraz",
            questionSettings: "Postavke pitanja",
            header: "Zaglavlje",
            background: "Pozadina",
            appearance: "Izgled",
            others: "Drugi"
        },
        editProperty: "Uređivanje objekta '{0}'",
        items: "[ Stavke: {0} ]",
        choicesVisibleIf: "Izbori su vidljivi ako",
        choicesEnableIf: "Izbori se mogu odabrati ako",
        columnsEnableIf: "Stupci su vidljivi ako",
        rowsEnableIf: "Reci su vidljivi ako",
        innerIndent: "Dodavanje unutarnjih uvlaka",
        defaultValueFromLastRow: "Uzimanje zadanih vrijednosti iz posljednjeg retka",
        defaultValueFromLastPanel: "Preuzimanje zadanih vrijednosti s posljednje ploče",
        enterNewValue: "Unesite vrijednost.",
        noquestions: "U anketi nema nikakvog pitanja.",
        createtrigger: "Izradite okidač",
        titleKeyboardAdornerTip: "Pritisnite gumb za unos za uređivanje",
        keyboardAdornerTip: "Pritisnite gumb enter za uređivanje stavke, pritisnite gumb za brisanje stavke, pritisnite alt plus strelica prema gore ili strelica prema dolje za pomicanje stavke.",
        triggerOn: "Na ",
        triggerMakePagesVisible: "Učinite stranice vidljivima:",
        triggerMakeQuestionsVisible: "Učinite elemente vidljivima:",
        triggerCompleteText: "Dovršite anketu ako uspijete.",
        triggerNotSet: "Okidač nije postavljen",
        triggerRunIf: "Trčanje ako",
        triggerSetToName: "Promjena vrijednosti: ",
        triggerFromName: "Vrijednost kopiranja iz: ",
        triggerRunExpression: "Postisni ovaj izraz:",
        triggerSetValue: "za: ",
        triggerGotoName: "Idi na pitanje:",
        triggerIsVariable: "Ne stavljajte varijablu u rezultat ankete.",
        triggerRunExpressionEmpty: "Unesite valjani izraz",
        emptyExpressionPlaceHolder: "Ovdje upišite izraz...",
        noFile: "Nema odabira datoteke",
        clearIfInvisible: "Očisti vrijednost ako pitanje postane skriveno",
        valuePropertyName: "Naziv svojstva Vrijednost",
        searchEnabled: "Omogući pretraživanje",
        hideSelectedItems: "Sakrij odabrane stavke",
        closeOnSelect: "Zatvaranje padajućeg izbornika nakon odabira",
        verticalAlign: "Okomito poravnanje",
        alternateRows: "Zamjenski reci",
        columnsVisibleIf: "Stupci su vidljivi ako",
        rowsVisibleIf: "Reci su vidljivi ako",
        otherPlaceholder: "Rezervirano mjesto područja komentara",
        filePlaceholder: "Tekst rezerviranog mjesta datoteke",
        photoPlaceholder: "Tekst rezerviranog mjesta za fotografije",
        fileOrPhotoPlaceholder: "Tekst rezerviranog mjesta za datoteku ili fotografiju",
        rateType: "Vrsta stope",
        url_placeholder: "Npr.: https://api.example.com/books",
        path_placeholder: "Ex.: kategorije.fiction",
        questionStartIndex_placeholder: "Npr.: a)",
        width_placeholder: "Npr.: 6 inča",
        minWidth_placeholder: "Npr.: 600px",
        maxWidth_placeholder: "Npr.: 50%",
        imageHeight_placeholder: "Автоматично",
        imageWidth_placeholder: "Автоматично",
        theme: {
            themeName: "Tema",
            isPanelless: "Izgled pitanja",
            editorPanel: "Polumjer pozadine i kuta",
            questionPanel: "Polumjer pozadine i kuta",
            primaryColor: "Boja isticanja",
            panelBackgroundTransparency: "Neprozirnost pozadine ploče",
            questionBackgroundTransparency: "Pitanje neprozirnosti pozadine",
            fontSize: "Veličina fonta",
            scale: "Vaga",
            cornerRadius: "Kutni radijus",
            pageTitle: "Font naslova",
            pageDescription: "Font opisa",
            questionTitle: "Font naslova",
            questionDescription: "Font opisa",
            editorFont: "Krstionica",
            backgroundOpacity: "Neprozirnost",
            "--sjs-font-family": "Obitelj fontova",
            "--sjs-general-backcolor-dim": "Boja pozadine",
            "--sjs-primary-backcolor": "Pozadina isticanja",
            "--sjs-primary-forecolor": "Isticanje u prvom planu",
            "--sjs-special-red": "Poruke o pogreškama",
            "--sjs-shadow-small": "Efekti sjene",
            "--sjs-shadow-inner": "Efekti sjene",
            "--sjs-border-default": "Boje"
        },
        "header@header": {
            headerView: "Pogled",
            logoPosition: "Položaj logotipa",
            surveyTitle: "Font naslova upitnika",
            surveyDescription: "Font opisa upitnika",
            headerTitle: "Font naslova upitnika",
            headerDescription: "Font opisa upitnika",
            inheritWidthFrom: "Širina područja sadržaja",
            textAreaWidth: "Širina teksta",
            backgroundColorSwitch: "Boja pozadine",
            backgroundImage: "Pozadinska slika",
            backgroundImageOpacity: "Neprozirnost",
            overlapEnabled: "Preklapanje",
            logoPositionX: "Položaj logotipa",
            titlePositionX: "Položaj naslova",
            descriptionPositionX: "Položaj opisa"
        }
    },
    // Property values
    pv: {
        "true": "istinit",
        "false": "lažan",
        file: "Lokalne datoteke",
        camera: "Kamera",
        "file-camera": "Lokalne datoteke ili kamera",
        inherit: "naslijediti",
        show: "pokazati",
        hide: "sakrij",
        default: "zadani",
        initial: "početni",
        random: "slučajan",
        collapsed: "srušio",
        expanded: "proširio",
        none: "nitko",
        asc: "uzlazno",
        desc: "silazno",
        indeterminate: "neodređeno",
        selected: "Odabrani",
        unselected: "Neodabrano",
        decimal: "decimala",
        currency: "valuta",
        percent: "posto",
        firstExpanded: "firstExpanded",
        off: "isključeno",
        list: "popis",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        tab: "Tabulatori",
        horizontal: "horizontal",
        vertical: "vertical",
        top: "top",
        bottom: "bottom",
        topBottom: "top and bottom",
        both: "oba",
        left: "lijevo",
        right: "Desno",
        center: "Središte",
        leftRight: "Lijevo i desno",
        middle: "Sredina",
        color: "boja",
        date: "datum",
        datetime: "datum i vrijeme",
        "datetime-local": "datetime-local",
        email: "E-pošta",
        month: "mjesec",
        number: "broj",
        password: "lozinka",
        range: "domet",
        tel: "Tel",
        text: "Tekstualna poruka",
        time: "Vrijeme",
        url: "URL",
        week: "tjedan",
        hidden: "hidden",
        edit: "edit",
        display: "display",
        contain: "Sadržavati",
        cover: "Pokriti",
        fill: "Ispuniti",
        next: "Sljedeći",
        last: "Trajati",
        onComplete: "onComplete",
        onHidden: "onHidden",
        onHiddenContainer: "Kada se pitanje ili njegova ploča/stranica sakriju",
        clearInvisibleValues: {
            none: "Nikada"
        },
        clearIfInvisible: {
            none: "Nikada"
        },
        inputType: {
            color: "Boja",
            date: "Datum",
            "datetime-local": "Datum i vrijeme",
            email: "E-pošta",
            month: "Mjesec",
            number: "Broj",
            password: "Lozinka",
            range: "Domet",
            tel: "Telefonski broj",
            text: "Tekstualna poruka",
            time: "Vrijeme",
            url: "URL",
            week: "Tjedan"
        },
        all: "all",
        page: "page",
        survey: "survey",
        onNextPage: "onNextPage",
        onValueChanged: "onValueChanged",
        onValueChanging: "Prije promjene odgovora",
        questionsOnPageMode: {
            standard: "Izvorna struktura",
            singlePage: "Pokaži sva pitanja na jednoj stranici",
            questionPerPage: "Pokaži jedno pitanje po stranici"
        },
        noPreview: "no preview",
        showAllQuestions: "show preview with all questions",
        showAnsweredQuestions: "show preview with answered questions",
        pages: "Dovršene stranice",
        questions: "Odgovorena pitanja",
        requiredQuestions: "Odgovoreno na obavezna pitanja",
        correctQuestions: "Valjani odgovori",
        buttons: "Dovršene stranice (korisničko sučelje gumba)",
        underInput: "Ispod ulaza",
        underTitle: "Pod naslovom",
        onBlur: "Na zamućenju",
        onTyping: "Tijekom tipkanja",
        underRow: "Ispod retka",
        underRowSingle: "Ispod retka vidljiva je samo jedna ploča",
        auto: "Automobil",
        showNavigationButtons: {
            none: "Skriven"
        },
        showTimerPanel: {
            none: "Skriven"
        },
        showTimerPanelMode: {
            all: "Oba"
        },
        addRowLocation: {
            default: "Ovisi o izgledu matrice"
        },
        panelsState: {
            default: "Korisnici ne mogu proširiti ili sažeti ploče",
            collapsed: "Sve ploče su urušene",
            expanded: "Sve ploče su proširene",
            firstExpanded: "Prvo prošireno"
        },
        widthMode: {
            static: "Statički",
            responsive: "Odgovarajući"
        },
        contentMode: {
            image: "Slika",
            video: "Video",
            youtube: "YouTube"
        },
        displayMode: {
            buttons: "Gumbe",
            dropdown: "Padajući izbornik"
        },
        rateColorMode: {
            default: "Propust",
            scale: "Vaga"
        },
        scaleColorMode: {
            monochrome: "Jednobojni",
            colored: "Boji"
        },
        autoGenerate: {
            "true": "Generirati",
            "false": "Ručno unesite"
        },
        rateType: {
            labels: "Natpise",
            stars: "Zvijezde",
            smileys: "Smajlići"
        },
        state: {
            default: "Zaključan"
        },
        showQuestionNumbers: {
            default: "Automatsko numeriranje",
            on: "Automatsko numeriranje",
            onPage: "Vrati izvorno na svaku stranicu",
            onpanel: "Vrati izvorno na svaku ploču",
            onPanel: "Vrati izvorno na svaku ploču",
            onSurvey: "Nastavi kroz anketu",
            off: "Bez numeriranja"
        },
        descriptionLocation: {
            underTitle: "Pod naslovom pitanja",
            underInput: "Ispod polja za unos"
        },
        selectToRankAreasLayout: {
            horizontal: "Pored izbora",
            vertical: "Iznad izbora"
        },
        displayStyle: {
            decimal: "Decimala",
            currency: "Valuta",
            percent: "Postotak",
            date: "Datum"
        },
        totalDisplayStyle: {
            decimal: "Decimala",
            currency: "Valuta",
            percent: "Postotak",
            date: "Datum"
        },
        rowsOrder: {
            initial: "Originalan"
        },
        questionsOrder: {
            initial: "Originalan"
        },
        showProgressBar: {
            off: "Skriven",
            topbottom: "top and bottom",
            aboveheader: "Iznad zaglavlja",
            belowheader: "Ispod zaglavlja"
        },
        sum: "Suma",
        count: "Brojati",
        min: "Min",
        max: "Max",
        avg: "Avg",
        searchMode: {
            contains: "Sadržava",
            startsWith: "Počinje s"
        },
        backgroundImageFit: {
            auto: "Automobil",
            cover: "Pokriti",
            contain: "Sadržavati",
            fill: "Parcela",
            tile: "Crijep"
        },
        backgroundImageAttachment: {
            fixed: "Fiksirane",
            scroll: "Svitak"
        },
        headerView: {
            basic: "Osnovni",
            advanced: "Napredan"
        },
        inheritWidthFrom: {
            survey: "Isto kao i anketa",
            container: "Prilagodi spremniku"
        },
        backgroundColorSwitch: {
            none: "Nijedan",
            accentColor: "Boja isticanja",
            custom: "Običaj"
        },
        colorPalette: {
            light: "Svjetlo",
            dark: "Mračan"
        },
        isPanelless: {
            "false": "Propust",
            "true": "Bez panela"
        }
    },
    // Operators
    op: {
        empty: "is empty",
        notempty: "is not empty",
        equal: "equals",
        notequal: "not equals",
        contains: "contains",
        notcontains: "not contains",
        anyof: "any of",
        allof: "all of",
        greater: "greater",
        less: "less",
        greaterorequal: "greater or equals",
        lessorequal: "less or equals",
        and: "i",
        or: "ili"
    },
    // Embed window
    ew: {
        angular: "Koristite kutnu verziju",
        jquery: "Koristite jQuery verziju",
        knockout: "Korištenje nokaut verzije",
        react: "Korištenje verzije React",
        vue: "Koristite Vue verziju",
        bootstrap: "Za bootstrap okvir",
        modern: "Moderna tema",
        default: "Zadana tema",
        orange: "Narančasta tema",
        darkblue: "Darkblue tema",
        darkrose: "Darkrose tema",
        stone: "Kamena tema",
        winter: "Zimska tema",
        winterstone: "Tema Zimsko-kamen",
        showOnPage: "Pokažite anketu na stranici",
        showInWindow: "Pokažite anketu u prozoru",
        loadFromServer: "Učitavanje Survey JSON s poslužitelja",
        titleScript: "Skripte i stilovi",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Odaberite stranicu da biste je testirali:",
        showInvisibleElements: "Pokaži nevidljive elemente",
        hideInvisibleElements: "Sakrij nevidljive elemente"
    },
    validators: {
        answercountvalidator: "broj odgovora",
        emailvalidator: "e-mail",
        expressionvalidator: "expression",
        numericvalidator: "numeric",
        regexvalidator: "regex",
        textvalidator: "text"
    },
    triggers: {
        completetrigger: "potpuna anketa",
        setvaluetrigger: "postavljena vrijednost",
        copyvaluetrigger: "vrijednost kopiranja",
        skiptrigger: "preskočiti na pitanje",
        runexpressiontrigger: "pokrenuti izraz",
        visibletrigger: "promjena vidljivosti (amortizirati)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Npr.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Npr.: mm/dd/gggg"
        },
        currencymask: {
            prefix: "Npr.: $",
            suffix: "Npr.: USD"
        },
        panelbase: {
            questionTitleWidth: "Npr.: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "ID ploče koji nije vidljiv ispitanicima.",
            description: "Upišite podnaslov ploče.",
            visibleIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje vidljivost ploče.",
            enableIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje onemogućuje način samo za čitanje ploče.",
            requiredIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje sprječava slanje upitnika, osim ako barem jedno ugniježđeno pitanje nema odgovor.",
            questionTitleLocation: "Odnosi se na sva pitanja unutar ovog panela. Ako želite nadjačati ovu postavku, definirajte pravila poravnanja naslova za pojedinačna pitanja. Mogućnost \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika (\"Vrh\" prema zadanim postavkama).",
            questionTitleWidth: "Postavlja dosljednu širinu za naslove pitanja kada su poravnati lijevo od okvira pitanja. Prihvaća CSS vrijednosti (px, %, in, pt itd.).",
            questionErrorLocation: "Postavlja mjesto poruke o pogrešci u odnosu na sva pitanja unutar ploče. Opcija \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika.",
            questionsOrder: "Zadržava izvorni redoslijed pitanja ili ih randomizira. Opcija \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika.",
            page: "Premješta ploču na kraj odabrane stranice.",
            innerIndent: "Dodaje razmak ili marginu između sadržaja ploče i lijevog obruba okvira ploče.",
            startWithNewLine: "Poništite odabir za prikaz ploče u jednom retku s prethodnim pitanjem ili pločom. Postavka se ne primjenjuje ako je ploča prvi element u obrascu.",
            state: "Odaberite između: \"Prošireno\" - ploča je prikazana u cijelosti i može se sažeti; \"Sažeto\" - ploča prikazuje samo naslov i opis i može se proširiti; \"Zaključano\" - ploča je prikazana u cijelosti i ne može se sažeti.",
            width: "Postavlja širinu ploče proporcionalno ostalim elementima istraživanja u istoj liniji. Prihvaća CSS vrijednosti (px, %, in, pt itd.)."
        },
        paneldynamic: {
            name: "ID ploče koji nije vidljiv ispitanicima.",
            description: "Upišite podnaslov ploče.",
            visibleIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje vidljivost ploče.",
            enableIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje onemogućuje način samo za čitanje ploče.",
            requiredIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje sprječava slanje upitnika, osim ako barem jedno ugniježđeno pitanje nema odgovor.",
            templateTitleLocation: "Odnosi se na sva pitanja unutar ovog panela. Ako želite nadjačati ovu postavku, definirajte pravila poravnanja naslova za pojedinačna pitanja. Mogućnost \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika (\"Vrh\" prema zadanim postavkama).",
            templateErrorLocation: "Postavlja mjesto poruke o pogrešci u odnosu na pitanje s unosom koji nije valjan. Odaberite između: \"Vrh\" - tekst pogreške nalazi se na vrhu okvira pitanja; \"Dno\" - tekst pogreške nalazi se na dnu okvira pitanja. Mogućnost \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika (\"Vrh\" prema zadanim postavkama).",
            errorLocation: "Postavlja mjesto poruke o pogrešci u odnosu na sva pitanja unutar ploče. Opcija \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika.",
            page: "Premješta ploču na kraj odabrane stranice.",
            innerIndent: "Dodaje razmak ili marginu između sadržaja ploče i lijevog obruba okvira ploče.",
            startWithNewLine: "Poništite odabir za prikaz ploče u jednom retku s prethodnim pitanjem ili pločom. Postavka se ne primjenjuje ako je ploča prvi element u obrascu.",
            state: "Odaberite između: \"Prošireno\" - ploča je prikazana u cijelosti i može se sažeti; \"Sažeto\" - ploča prikazuje samo naslov i opis i može se proširiti; \"Zaključano\" - ploča je prikazana u cijelosti i ne može se sažeti.",
            width: "Postavlja širinu ploče proporcionalno ostalim elementima istraživanja u istoj liniji. Prihvaća CSS vrijednosti (px, %, in, pt itd.).",
            templateTitle: "Upišite predložak za dinamičke naslove ploča. Koristite {panelIndex} za opći položaj panela i {visiblePanelIndex} za njegov redoslijed među vidljivim pločama. Umetnite ova rezervirana mjesta u uzorak da biste dodali automatsko numeriranje.",
            templateTabTitle: "Upišite predložak za naslove kartica. Koristite {panelIndex} za opći položaj panela i {visiblePanelIndex} za njegov redoslijed među vidljivim pločama. Umetnite ova rezervirana mjesta u uzorak da biste dodali automatsko numeriranje.",
            tabTitlePlaceholder: "Rezervni tekst za naslove kartica koji se primjenjuje kada uzorak naslova kartice ne daje značajnu vrijednost.",
            templateVisibleIf: "Ova postavka omogućuje kontrolu vidljivosti pojedinih ploča unutar dinamičke ploče. Koristite rezervirano mjesto '{panel}' za referenciranje trenutne ploče u izrazu.",
            titleLocation: "Ovu postavku automatski nasljeđuju sva pitanja unutar ove ploče. Ako želite nadjačati ovu postavku, definirajte pravila poravnanja naslova za pojedinačna pitanja. Mogućnost \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika (\"Vrh\" prema zadanim postavkama).",
            descriptionLocation: "Opcija \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika (\"Pod naslovom ploče\" prema zadanim postavkama).",
            newPanelPosition: "Definira položaj novododane ploče. Prema zadanim postavkama na kraj se dodaju nove ploče. Odaberite \"Dalje\" da biste umetnuli novu ploču nakon trenutne.",
            defaultValueFromLastPanel: "Duplicira odgovore s posljednje ploče i dodjeljuje ih sljedećoj dodanoj dinamičkoj ploči.",
            keyName: "Pogledajte naziv pitanja kako biste od korisnika zahtijevali da pruži jedinstven odgovor za ovo pitanje na svakoj ploči."
        },
        defaultValueExpression: "Ova postavka omogućuje dodjeljivanje zadane vrijednosti odgovora na temelju izraza. Izraz može uključivati osnovne izračune - '{q1_id} + {q2_id}', Booleove izraze, kao što su '{age} > 60', i funkcije: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', itd. Vrijednost određena ovim izrazom služi kao početna zadana vrijednost koja se može nadjačati ručnim unosom ispitanika.",
        resetValueIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje kada se unos ispitanika vraća na vrijednost na temelju \"Zadani izraz vrijednosti\" ili \"Postavi izraz vrijednosti\" ili na vrijednost \"Zadani odgovor\" (ako je postavljena).",
        setValueIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje kada pokrenuti \"Postavi izraz vrijednosti\" i dinamički dodijelite dobivenu vrijednost kao odgovor.",
        setValueExpression: "Navedite izraz koji definira vrijednost koju treba postaviti kada se ispune uvjeti u pravilu \"Postavi vrijednost ako\". Izraz može uključivati osnovne izračune - '{q1_id} + {q2_id}', Booleove izraze, kao što su '{age} > 60', i funkcije: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', itd. Vrijednost određena ovim izrazom može se nadjačati ručnim unosom ispitanika.",
        question: {
            name: "ID pitanja koji nije vidljiv ispitanicima.",
            description: "Upišite podnaslov pitanja.",
            visibleIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje vidljivost pitanja.",
            enableIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje onemogućuje način samo za čitanje za pitanje.",
            requiredIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje sprječava napredovanje ili podnošenje upitnika, osim ako pitanje ne dobije odgovor.",
            startWithNewLine: "Poništite odabir za prikaz pitanja u jednom retku s prethodnim pitanjem ili pločom. Postavka se ne primjenjuje ako je pitanje prvi element u obrascu.",
            page: "Premješta pitanje na kraj odabrane stranice.",
            state: "Odaberite između: \"Prošireno\" - okvir pitanja prikazuje se u cijelosti i može se sažeti; \"Sažeto\" - okvir pitanja prikazuje samo naslov i opis i može se proširiti; \"Zaključano\" - okvir s pitanjima prikazuje se u cijelosti i ne može se sažeti.",
            titleLocation: "Nadjačava pravila poravnanja naslova definirana na razini ploče, stranice ili upitnika. Opcija \"Naslijedi\" primjenjuje sve postavke više razine (ako su postavljene) ili postavku na razini upitnika (\"Vrh\" prema zadanim postavkama).",
            descriptionLocation: "Opcija \"Naslijedi\" primjenjuje postavku na razini upitnika (\"Pod naslovom pitanja\" prema zadanim postavkama).",
            errorLocation: "Postavlja mjesto poruke o pogrešci u odnosu na pitanje s unosom koji nije valjan. Odaberite između: \"Vrh\" - tekst pogreške nalazi se na vrhu okvira pitanja; \"Dno\" - tekst pogreške nalazi se na dnu okvira pitanja. Mogućnost \"Naslijedi\" primjenjuje postavku na razini upitnika (\"Vrh\" prema zadanim postavkama).",
            indent: "Dodaje razmak ili marginu između sadržaja pitanja i lijevog obruba okvira pitanja.",
            width: "Postavlja širinu pitanja proporcionalno drugim elementima upitnika u istom retku. Prihvaća CSS vrijednosti (px, %, in, pt itd.).",
            surveyvalidator: {
                expression: "Pomoću ikone čarobnog štapića postavite pravilo provjere valjanosti za pitanje."
            },
            textUpdateMode: "Odaberite između: \"Na izgubljenom fokusu\" - vrijednost se ažurira kada polje za unos izgubi fokus; \"Tijekom tipkanja\" - vrijednost se ažurira u stvarnom vremenu, jer korisnici tipkaju. Opcija \"Naslijedi\" primjenjuje postavku na razini upitnika (\"Pri izgubljenom fokusu\" prema zadanim postavkama).",
            url: "Bilo koju web-uslugu možete koristiti kao izvor podataka za pitanja s višestrukim izborom odgovora. Da biste popunili vrijednosti izbora, unesite URL usluge koja pruža podatke.",
            searchMode: "Operacija usporedbe koja se koristi za filtriranje padajućeg popisa.",
            textWrapEnabled: "Dugi tekstovi u mogućnostima izbora automatski će generirati prijelome redaka kako bi stali unutar padajućeg izbornika. Poništite odabir ako želite da se tekstovi izrežu."
        },
        signaturepad: {
            signatureWidth: "Postavlja širinu prikazanog područja potpisa i rezultirajuću sliku.",
            signatureHeight: "Postavlja visinu prikazanog područja potpisa i rezultirajuću sliku.",
            signatureAutoScaleEnabled: "Odaberite želite li da područje potpisa ispuni sav raspoloživi prostor unutar okvira pitanja uz zadržavanje zadanog omjera slike 3:2. Kada su postavljene prilagođene vrijednosti širine i visine, postavka će zadržati omjer slike tih dimenzija."
        },
        file: {
            imageHeight: "Podešava visinu slike u rezultatima upitnika.",
            imageWidth: "Podešava širinu slike u rezultatima upitnika."
        },
        image: {
            contentMode: "Opcija \"Automatski\" automatski određuje odgovarajući način prikaza - Slika, Videozapis ili YouTube - na temelju navedenog izvornog URL-a."
        },
        imagepicker: {
            imageHeight: "Nadjačava vrijednosti minimalne i maksimalne visine.",
            imageWidth: "Nadjačava vrijednosti minimalne i maksimalne širine.",
            choices: "\"Vrijednost\" služi kao ID stavke koji se koristi u uvjetnim pravilima; \"Tekst\" se prikazuje ispitanicima.",
            contentMode: "Odaberite između \"Slika\" i \"Videozapis\" da biste postavili način sadržaja birača medija. Ako je odabrana opcija \"Slika\", provjerite jesu li sve ponuđene opcije slikovne datoteke u sljedećim formatima: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Slično tome, ako je odabran \"Video\", provjerite jesu li sve opcije izravne veze na video datoteke u sljedećim formatima: MP4, MOV, WMV, FLV, AVI, MKV. Napominjemo da veze na YouTube nisu podržane za opcije videozapisa."
        },
        text: {
            size: "Ova postavka samo mijenja veličinu polja unosa i ne utječe na širinu okvira pitanja. Da biste ograničili prihvaćenu duljinu unosa, idite na <b>Provjera valjanosti → Maksimalno ograničenje znaka</b>."
        },
        comment: {
            rows: "Postavlja broj prikazanih redaka u polju za unos. Ako ulaz zauzima više redaka, pojavit će se klizač."
        },
        // survey templates
        survey: {
            mode: "Odaberite između: \"Može se uređivati\" - omogućuje ispitanicima da ispune vašu anketu; \"Samo za čitanje\" - onemogućuje uređivanje obrazaca."
        },
        matrixdropdowncolumn: {
            name: "ID stupca koji nije vidljiv ispitanicima.",
            isUnique: "Kada je omogućen stupac, ispitanik mora dati jedinstven odgovor za svako pitanje unutar ovog stupca.",
            rows: "Postavlja broj prikazanih redaka u polju za unos. Ako ulaz zauzima više redaka, pojavit će se klizač.",
            visibleIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje vidljivost stupca.",
            enableIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje onemogućuje način samo za čitanje stupca.",
            requiredIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje sprječava slanje upitnika, osim ako barem jedno ugniježđeno pitanje nema odgovor.",
            showInMultipleColumns: "Kada je odabrano, stvara pojedinačni stupac za svaku mogućnost izbora."
        },
        widthMode: "Odaberite između: \"Statika\" - postavlja fiksnu širinu; \"Responsive\" - čini da anketa zauzima punu širinu zaslona; \"Auto\" - primjenjuje se bilo koji od dva ovisno o korištenim vrstama pitanja.",
        cookieName: "Kolačići sprječavaju korisnike da dvaput ispune istu anketu.",
        logo: "Zalijepite slikovnu vezu (bez ograničenja veličine) ili kliknite ikonu mape da biste pregledali datoteku s računala (do 64 KB).",
        logoWidth: "Postavlja širinu logotipa u CSS jedinicama (px, %, in, pt itd.).",
        logoHeight: "Postavlja visinu logotipa u CSS jedinicama (px, %, in, pt itd.).",
        logoFit: "Odaberite između: \"Nema\" - slika zadržava svoju izvornu veličinu; \"Sadrži\" - slika se mijenja kako bi stala uz zadržavanje omjera slike; \"Poklopac\" - slika ispunjava cijelu kutiju zadržavajući omjer slike; \"Ispuna\" - slika se rasteže kako bi ispunila kutiju bez zadržavanja omjera slike.",
        goNextPageAutomatic: "Odaberite želite li da anketa automatski prijeđe na sljedeću stranicu nakon što ispitanik odgovori na sva pitanja na trenutnoj stranici.",
        allowCompleteSurveyAutomatic: "Odaberite želite li da se anketa automatski dovrši nakon što ispitanik odgovori na sva pitanja.",
        showNavigationButtons: "Postavlja vidljivost i mjesto navigacijskih gumba na stranici.",
        showProgressBar: "Postavlja vidljivost i mjesto trake napretka. Vrijednost \"Automatski\" prikazuje traku napretka iznad ili ispod zaglavlja upitnika.",
        showPreviewBeforeComplete: "Omogućite stranicu pretpregleda samo sa svim ili odgovorenim pitanjima.",
        questionTitleLocation: "Odnosi se na sva pitanja unutar ankete. Ova postavka može se nadjačati pravilima poravnanja naslova na nižim razinama: ploča, stranica ili pitanje. Postavka niže razine nadjačat će one na višoj razini.",
        requiredText: "Simbol ili niz simbola koji označavaju da je potreban odgovor.",
        questionStartIndex: "Unesite broj ili slovo s kojim želite započeti numeriranje.",
        questionErrorLocation: "Postavlja mjesto poruke o pogrešci u odnosu na pitanje s unosom koji nije valjan. Odaberite između: \"Vrh\" - tekst pogreške nalazi se na vrhu okvira pitanja; \"Dno\" - tekst pogreške nalazi se na dnu okvira pitanja.",
        focusFirstQuestionAutomatic: "Odaberite želite li da prvo polje za unos na svakoj stranici bude spremno za unos teksta.",
        questionsOrder: "Zadržava izvorni redoslijed pitanja ili ih randomizira. Efekt ove postavke vidljiv je samo na kartici Pretpregled.",
        maxTextLength: "Samo za pitanja o unosu teksta.",
        maxOthersLength: "Samo za komentare pitanja.",
        commentAreaRows: "Postavlja broj prikazanih redaka u tekstnim područjima za komentare pitanja. U ulazu zauzima više redaka pojavljuje se klizač.",
        autoGrowComment: "Odaberite želite li da komentari pitanja i pitanja dugog teksta automatski rastu u visinu na temelju unesene duljine teksta.",
        allowResizeComment: "Samo za komentare pitanja i pitanja dugog teksta.",
        calculatedValues: "Prilagođene varijable služe kao srednje ili pomoćne varijable koje se koriste u izračunima obrazaca. Oni uzimaju unose ispitanika kao izvorne vrijednosti. Svaka prilagođena varijabla ima jedinstveni naziv i izraz na kojem se temelji.",
        includeIntoResult: "Odaberite želite li spremiti izračunatu vrijednost izraza zajedno s rezultatima upitnika.",
        triggers: "Okidač je događaj ili uvjet koji se temelji na izrazu. Nakon što se izraz procijeni kao \"istinit\", okidač pokreće radnju. Takva radnja može po želji imati ciljano pitanje na koje utječe.",
        clearInvisibleValues: "Odaberite želite li očistiti vrijednosti za pitanja skrivena uvjetnom logikom i kada to učiniti.",
        textUpdateMode: "Odaberite između: \"Na izgubljenom fokusu\" - vrijednost se ažurira kada polje za unos izgubi fokus; \"Tijekom tipkanja\" - vrijednost se ažurira u stvarnom vremenu, jer korisnici tipkaju.",
        columns: "Lijeva vrijednost služi kao ID stupca koji se koristi u uvjetnim pravilima, a ispitanicima se prikazuje prava vrijednost.",
        rows: "Lijeva vrijednost služi kao ID retka koji se koristi u uvjetnim pravilima, a ispitanicima se prikazuje prava vrijednost.",
        columnMinWidth: "Prihvaća CSS vrijednosti (px, %, in, pt itd.).",
        rowTitleWidth: "Prihvaća CSS vrijednosti (px, %, in, pt itd.).",
        totalText: "Vidljivo samo ako barem jedan stupac ima izraz Vrsta zbroja ili Ukupno.",
        cellErrorLocation: "Postavlja mjesto poruke o pogrešci u odnosu na ćeliju s unosom koji nije valjan. Mogućnost \"Naslijedi\" primjenjuje postavku iz svojstva \"Poravnanje poruke o pogrešci\".",
        keyDuplicationError: "Kada je omogućeno svojstvo \"Spriječi duplicirane odgovore\", ispitanik koji pokuša poslati duplikat unosa primit će sljedeću poruku o pogrešci.",
        totalExpression: "Omogućuje izračunavanje ukupnih vrijednosti na temelju izraza. Izraz može uključivati osnovne izračune ('{q1_id} + {q2_id}'), Booleove izraze ('{age} > 60') i funkcije ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', itd.).",
        confirmDelete: "Pokreće upit u kojem se traži potvrda brisanja retka.",
        defaultValueFromLastRow: "Duplicira odgovore iz posljednjeg retka i dodjeljuje ih sljedećem dodanom dinamičkom retku.",
        keyName: "Ako navedeni stupac sadrži identične vrijednosti, anketa odbacuje pogrešku \"Nejedinstvena vrijednost ključa\".",
        description: "Upišite podnaslov.",
        locale: "Odaberite jezik za početak stvaranja upitnika. Da biste dodali prijevod, prijeđite na novi jezik i prevedite izvorni tekst ovdje ili na kartici Prijevodi.",
        detailPanelMode: "Postavlja mjesto sekcije s detaljima u odnosu na redak. Odaberite između: \"Nema\" - ne dodaje se proširenje; \"Ispod reda\" - proširenje retka nalazi se ispod svakog retka matrice; \"Ispod retka prikaži samo proširenje jednog retka\" - proširenje se prikazuje samo ispod jednog retka, preostala proširenja retka su sažeta.",
        imageFit: "Odaberite između: \"Nema\" - slika zadržava svoju izvornu veličinu; \"Sadrži\" - slika se mijenja kako bi stala uz zadržavanje omjera slike; \"Poklopac\" - slika ispunjava cijelu kutiju zadržavajući omjer slike; \"Ispuna\" - slika se rasteže kako bi ispunila kutiju bez zadržavanja omjera slike.",
        autoGrow: "Postupno povećava visinu polja unosa tijekom unosa podataka. Nadjačava postavku \"Visina polja unosa (u crtama)\".",
        allowResize: "Ručica za promjenu veličine (ili držač) pojavljuje se u kutu i može se povući kako bi se promijenila veličina polja za unos.",
        maxTimeToFinish: "Vremenski interval u sekundama nakon kojeg anketa automatski prelazi na stranicu zahvale.",
        maxTimeToFinishPage: "Vremenski interval u sekundama nakon kojeg anketa automatski prelazi na sljedeću stranicu.",
        page: {
            maxTimeToFinish: "Vremenski interval u sekundama nakon kojeg anketa automatski prelazi na sljedeću stranicu.",
            visibleIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje vidljivost stranice.",
            enableIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje onemogućuje način samo za čitanje stranice.",
            requiredIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje sprječava slanje upitnika, osim ako barem jedno ugniježđeno pitanje nema odgovor.",
            questionTitleLocation: "Odnosi se na sva pitanja unutar ove stranice. Ako želite nadjačati ovu postavku, definirajte pravila poravnanja naslova za pojedinačna pitanja ili ploče. Mogućnost \"Naslijedi\" primjenjuje postavku na razini upitnika (\"Vrh\" prema zadanim postavkama).",
            questionTitleWidth: "Postavlja dosljednu širinu za naslove pitanja kada su poravnati lijevo od okvira pitanja. Prihvaća CSS vrijednosti (px, %, in, pt itd.).",
            questionErrorLocation: "Postavlja mjesto poruke o pogrešci u odnosu na pitanje s unosom koji nije valjan. Odaberite između: \"Vrh\" - tekst pogreške nalazi se na vrhu okvira pitanja; \"Dno\" - tekst pogreške nalazi se na dnu okvira pitanja. Mogućnost \"Naslijedi\" primjenjuje postavku na razini upitnika (\"Vrh\" prema zadanim postavkama).",
            questionsOrder: "Zadržava izvorni redoslijed pitanja ili ih randomizira. Mogućnost \"Naslijedi\" primjenjuje postavku na razini upitnika (\"Original\" prema zadanim postavkama). Efekt ove postavke vidljiv je samo na kartici Pretpregled.",
            navigationButtonsVisibility: "Postavlja vidljivost navigacijskih gumba na stranici. Opcija \"Naslijedi\" primjenjuje postavku na razini upitnika, koja je zadana kao \"Vidljivo\"."
        },
        showTimerPanel: "Postavlja vidljivost i mjesto mjerača vremena na stranici.",
        panelsState: "Odaberite između: \"Zaključano\" - korisnici ne mogu proširiti ili sažeti ploče; \"Sažmite sve\" - sve ploče počinju u urušenom stanju; \"Proširite sve\" - sve ploče počinju u proširenom stanju; \"Prvo prošireno\" - samo je prva ploča u početku proširena.",
        imageLinkName: "Unesite naziv zajedničkog svojstva unutar polja objekata koje sadrži URL-ove slike ili videodatoteke koje želite prikazati na popisu izbora.",
        choices: "Lijeva vrijednost služi kao ID artikla koji se koristi u uvjetnim pravilima, a ispitanicima se prikazuje prava vrijednost.",
        title: "Upišite naslov prilagođen korisniku za prikaz.",
        waitForUpload: "Osigurava da korisnici neće dovršiti anketu dok se datoteke ne prenesu.",
        minWidth: "Prihvaća CSS vrijednosti (px, %, in, pt itd.).",
        maxWidth: "Prihvaća CSS vrijednosti (px, %, in, pt itd.).",
        width: "Prihvaća CSS vrijednosti (px, %, in, pt itd.).",
        valueName: "Ako ne postavite ovo svojstvo, odgovor će biti pohranjen u polju određenom svojstvom Naziv .",
        useDisplayValuesInDynamicTexts: "U vrstama pitanja s jednim i višestrukim odabirom svaka mogućnost izbora ima ID i vrijednost prikaza. Kada je odabrana, ova postavka prikazuje prikazanu vrijednost umjesto ID vrijednosti u HTML pitanjima te dinamičke naslove i opise elemenata upitnika.",
        clearIfInvisible: "Odaberite želite li očistiti vrijednosti pitanja skrivene uvjetnom logikom i kada to učiniti. Opcija \"Naslijedi\" prema zadanim postavkama primjenjuje postavku na razini upitnika (\"Nakon završetka ankete\").",
        choicesFromQuestionMode: "Odaberite između: \"Sve\" - kopira sve opcije izbora iz odabranog pitanja; \"Odabrano\" - dinamički kopira samo odabrane opcije izbora; \"Neodabrano\" - dinamički kopira samo neodabrane opcije izbora. Opcije \"Ništa\" i \"Ostalo\" kopiraju se prema zadanim postavkama ako su omogućene u izvornom pitanju.",
        showOtherItem: "Kada je odabrano, korisnici mogu uključiti dodatni unos u zaseban okvir za komentare.",
        separateSpecialChoices: "Prikazuje svaku mogućnost posebnog izbora (\"Nema\", \"Ostalo\", \"Odaberi sve\") u novom retku, čak i kada koristite izgled s više stupaca.",
        path: "Navedite mjesto unutar skupa podataka o usluzi na kojem se nalazi ciljno polje objekata. Ostavite prazno ako URL već pokazuje na polje.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Unesite jedinstveni naziv svojstva unutar polja objekata koje sadrži vrijednosti koje želite prikazati na popisu izbora.",
        allowEmptyResponse: "Odaberite da biste servisu dopustili vraćanje praznog odgovora ili polja.",
        choicesVisibleIf: "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje vidljivost svih opcija izbora.",
        rateValues: "Lijeva vrijednost služi kao ID artikla koji se koristi u uvjetnim pravilima, a ispitanicima se prikazuje prava vrijednost.",
        rating: {
            displayMode: "\"Automatski\" odabire između načina rada \"Gumbi\" i \"Padajući izbornik\" na temelju dostupne širine. Kada širina nije dovoljna za prikaz gumba, pitanje prikazuje padajući izbornik."
        },
        valuePropertyName: "Omogućuje povezivanje pitanja koja daju rezultate u različitim formatima. Kada su takva pitanja povezana pomoću identifikatora spoja, ovo zajedničko svojstvo pohranjuje odabrane vrijednosti pitanja.",
        searchEnabled: "Odaberite želite li ažurirati sadržaj padajućeg izbornika tako da odgovara upitu za pretraživanje koji korisnik upisuje u polje za unos.",
        valueTrue: "Vrijednost koju treba uštedjeti u rezultatima ankete kada ispitanici daju pozitivan odgovor.",
        valueFalse: "Vrijednost koju treba spremiti u rezultatima ankete kada ispitanici daju negativan odgovor.",
        showPreview: "Ne preporučuje se onemogućavanje ove mogućnosti jer nadjačava sliku pretpregleda i otežava korisniku razumijevanje jesu li datoteke prenesene.",
        needConfirmRemoveFile: "Pokreće upit u kojem se traži potvrda brisanja datoteke.",
        selectToRankEnabled: "Omogućite rangiranje samo odabranih odabira. Korisnici će povući odabrane stavke s popisa izbora kako bi ih naručili unutar područja rangiranja.",
        dataList: "Unesite popis izbora koji će se predložiti ispitaniku tijekom unosa.",
        itemSize: "Postavka samo mijenja veličinu ulaznih polja i ne utječe na širinu okvira pitanja.",
        itemTitleWidth: "Postavlja dosljednu širinu za sve natpise stavki u pikselima",
        altText: "Služi kao zamjena kada se slika ne može prikazati na korisnikovom uređaju i u svrhu pristupačnosti.",
        rateColorMode: "Definira boju odabranog emojija kada je vrsta ikone Ocjena postavljena na \"Smajlići\". Odaberite između: \"Zadano\" - odabrani emoji pojavljuje se u zadanoj boji ankete; \"Skala\" - odabrani emoji nasljeđuje boju od ljestvice ocjenjivanja.",
        expression: {
            name: "ID izraza koji nije vidljiv ispitanicima.",
            description: "Upišite podnaslov izraza.",
            expression: "Izraz može uključivati osnovne izračune ('{q1_id} + {q2_id}'), uvjete ('{age} > 60') i funkcije ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', itd.)."
        },
        storeOthersAsComment: "Odaberite za spremanje vrijednosti mogućnosti \"Ostalo\" kao zasebnog svojstva u rezultatima upitnika.",
        format: "Koristite {0} kao rezervirano mjesto za stvarnu vrijednost.",
        acceptedTypes: "Dodatne informacije potražite u opisu atributa [accept](https://www.w3schools.com/tags/att_input_accept.asp).",
        columnColCount: "Primjenjivo samo na vrste ćelija Radiogrupa i Potvrdni okvir.",
        autocomplete: "Dodatne informacije potražite u opisu atributa [samodovršetak](https://developer.mozilla.org/en-US/docs/Web/HTML/atributi/samodovršetak).",
        filePlaceholder: "Primjenjuje se kada je \"Vrsta izvora\" \"Lokalne datoteke\" ili kada kamera nije dostupna",
        photoPlaceholder: "Primjenjuje se kada je \"Vrsta izvora\" \"Kamera\".",
        fileOrPhotoPlaceholder: "Primjenjuje se kada je \"Vrsta izvora\" \"Lokalne datoteke ili kamera\".",
        masksettings: {
            saveMaskedValue: "Odaberite želite li spremiti vrijednost pitanja s primijenjenom maskom u rezultatima upitnika."
        },
        patternmask: {
            pattern: "Uzorak može sadržavati slovne dijelove niza i sljedeća rezervirana mjesta: '9' - za znamenku; \"a\" – za veliko ili malo slovo; '#' - za znamenku ili veliko ili malo slovo. Koristite obrnutu kosu crtu '\\' da biste izbjegli znak."
        },
        datetimemask: {
            pattern: "Uzorak može sadržavati znakove razdjelnika i sljedeća rezervirana mjesta:<br>'m' - Broj mjeseca.<br>'mm' - Broj mjeseca, s početnom nulom za jednoznamenkaste vrijednosti. <br>'d' - Dan u mjesecu. <br>'dd' - Dan u mjesecu, s početnom nulom za jednoznamenkaste vrijednosti. <br>'yy' - Posljednje dvije znamenke godine. <br>'gggg' - Četveroznamenkasta godina. <br>'H' - Sati u 24-satnom formatu. <br>'HH' - Sati u 24-satnom formatu, s početnom nulom za jednoznamenkaste vrijednosti. <br>'h' - Sati u 12-satnom formatu. <br>'hh' - Sati u 12-satnom formatu, s početnom nulom za jednoznamenkaste vrijednosti. <br>'MM' - Minute. <br>'ss' - Sekunde. <br>\"TT\" – razdoblje od 12 sati velikim slovima (AM/PM). <br>\"TT\" – 12-satno razdoblje u malim slovima (am/pm)."
        },
        numericmask: {
            decimalSeparator: "Simbol koji se koristi za odvajanje djelomičnog dijela od cijelog broja prikazanog broja.",
            thousandsSeparator: "Simbol koji se koristi za odvajanje znamenki velikog broja u grupe od tri.",
            precision: "Ograničava broj znamenki koje treba zadržati nakon decimalnog zareza za prikazani broj."
        },
        currencymask: {
            prefix: "Jedan ili više simbola koji će se prikazati prije vrijednosti.",
            suffix: "Jedan ili više simbola koji će se prikazati nakon vrijednosti."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "title",
            title: "Ostavite prazno, ako je isto kao 'Name'"
        },
        multiSelect: "Dopusti višestruki odabir",
        showLabel: "Pokaži opise slika",
        swapOrder: "Zamjena redoslijeda Da i Ne",
        value: "Vrijednost",
        tabAlign: "Poravnanje tabulatora",
        sourceType: "Vrsta izvora",
        fitToContainer: "Prilagodi spremniku",
        setValueExpression: "Postavljanje izraza vrijednosti",
        description: "description",
        logoFit: "Prilagođavanje logotipa",
        pages: "Stranice",
        questions: "Pitanja",
        triggers: "triggers",
        calculatedValues: "Izračunate vrijednosti",
        surveyId: "ID upitnika",
        surveyPostId: "ID objave upitnika",
        surveyShowDataSaving: "Anketa pokazuje spremanje podataka",
        questionDescriptionLocation: "Mjesto opisa pitanja",
        progressBarType: "Vrsta trake napretka",
        showTOC: "Pokaži tablicu sadržaja",
        tocLocation: "Mjesto tablice sadržaja",
        questionTitlePattern: "Uzorak naslova pitanja",
        widthMode: "Način širine",
        showBrandInfo: "Pokaži informacije o robnoj marki",
        useDisplayValuesInDynamicTexts: "Korištenje vrijednosti prikaza u dinamičkim tekstovima",
        visibleIf: "visibleIf",
        defaultValueExpression: "Zadani izraz vrijednosti",
        requiredIf: "requiredIf",
        resetValueIf: "Vrati izvornu vrijednost ako",
        setValueIf: "Postavi vrijednost ako",
        validators: "validators",
        bindings: "Vezovi",
        renderAs: "Iscrtaj kao",
        attachOriginalItems: "Priloži izvorne stavke",
        choices: "choices",
        choicesByUrl: "choicesByUrl",
        currency: "currency",
        cellHint: "Savjet za ćeliju",
        totalMaximumFractionDigits: "Ukupan maksimalni broj znamenki razlomka",
        totalMinimumFractionDigits: "Ukupan minimum znamenki razlomka",
        columns: "columns",
        detailElements: "Elementi detalja",
        allowAdaptiveActions: "Dopusti prilagodljive radnje",
        defaultRowValue: "defaultRowValue",
        detailPanelShowOnAdding: "Prikaži na ploči s detaljima prilikom dodavanja",
        choicesLazyLoadEnabled: "Omogućeno lijeno opterećenje izbora",
        choicesLazyLoadPageSize: "Odabiri lijeno učitavanje veličine stranice",
        inputFieldComponent: "Komponenta polja za unos",
        itemComponent: "Komponenta artikla",
        min: "Min",
        max: "Max",
        minValueExpression: "Izraz minimalne vrijednosti",
        maxValueExpression: "Izraz maksimalne vrijednosti",
        step: "Korak",
        dataList: "Popis podataka",
        itemSize: "itemSize",
        itemTitleWidth: "Širina natpisa stavke (u px)",
        elements: "Elemenata",
        content: "Sadržaj",
        navigationButtonsVisibility: "navigationButtonsVisibility",
        navigationTitle: "Naslov navigacije",
        navigationDescription: "Opis navigacije",
        longTap: "Dugi dodir",
        autoGrow: "Automatski rast",
        allowResize: "Dopusti promjenu veličine",
        acceptCarriageReturn: "Prihvati povratak prijevoza",
        displayMode: "Način prikaza",
        rateType: "Vrsta stope",
        label: "label",
        contentMode: "Način sadržaja",
        imageFit: "Prilagodba slike",
        altText: "Zamjenski tekst",
        height: "Visina",
        penColor: "Boja olovke",
        backgroundColor: "Boja pozadine",
        templateElements: "Elementi predloška",
        operator: "Operator",
        isVariable: "Je promjenjivo",
        runExpression: "Pokreni izraz",
        showCaption: "Pokaži opis",
        iconName: "Naziv ikone",
        iconSize: "Veličina ikone",
        precision: "Preciznost",
        matrixDragHandleArea: "Područje držača za povlačenje matrice",
        backgroundImage: "Pozadinska slika",
        backgroundImageFit: "Prilagodba pozadinske slike",
        backgroundImageAttachment: "Privitak pozadinske slike",
        backgroundOpacity: "Neprozirnost pozadine",
        selectToRankEnabled: "Odaberite za omogućen rang",
        selectToRankAreasLayout: "Odabir za rangiranje izgleda područja",
        selectToRankEmptyRankedAreaText: "Tekst koji prikazuje jesu li odabrane sve mogućnosti",
        selectToRankEmptyUnrankedAreaText: "Tekst rezerviranog mjesta za područje rangiranja",
        allowCameraAccess: "Dopusti pristup kameri",
        scaleColorMode: "Način skaliranja boje",
        rateColorMode: "Način ocjenjivanja boja",
        copyDisplayValue: "Kopiraj vrijednost prikaza",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Napredni način rada",
        pageTitle: "Font naslova stranice",
        questionTitle: "Font naslova pitanja",
        editorPanel: "Ulazni element",
        lines: "Linije",
        primaryDefaultColor: "Propust",
        primaryDarkColor: "Lebdjeti",
        primaryLightColor: "Odabrani",
        backgroundDimColor: "Boja pozadine",
        cornerRadius: "Kutni radijus",
        backcolor: "Zadana pozadina",
        hovercolor: "Pozadina držanja pokazivača miša",
        borderDecoration: "Uređenje obruba",
        fontColor: "Boja fonta",
        backgroundColor: "Boja pozadine",
        primaryForecolor: "Zadana boja",
        primaryForecolorLight: "Onemogućena boja",
        font: "Krstionica",
        borderDefault: "Tamnije",
        borderLight: "Upaljač",
        fontFamily: "Obitelj fontova",
        fontWeightRegular: "Redovan",
        fontWeightHeavy: "Težak",
        fontWeightSemiBold: "Polupodebljano",
        fontWeightBold: "Odvažan",
        color: "Boja",
        placeholderColor: "Boja rezerviranog mjesta",
        size: "Veličina",
        opacity: "Neprozirnost",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Dodaj efekt sjene",
        boxShadowBlur: "Mrlja",
        boxShadowSpread: "Širenje",
        boxShadowDrop: "Ispustiti",
        boxShadowInner: "Unutarnji",
        names: {
            default: "Propust",
            sharp: "Oštar",
            borderless: "Bez obruba",
            flat: "Stan",
            plain: "Ravnica",
            doubleborder: "Dvostruki obrub",
            layered: "Slojevita",
            solid: "Solidan",
            threedimensional: ".3D",
            contrast: "Razlika"
        },
        colors: {
            teal: "Teal",
            blue: "Plav",
            purple: "Ljubičast",
            orchid: "Orhideja",
            tulip: "Lala",
            brown: "Smeđ",
            green: "Zelen"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["hr"] = hrStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// qt.ranking: "Ranking" => "Rangiranje"
// qt.tagbox: "Multi-Select Dropdown" => "Padajući izbornik s višestrukim odabirom"
// qt.buttongroup: "Button Group" => "Grupa gumba"
// ed.surveySettings: "Survey Settings" => "Postavke upitnika"
// ed.surveySettingsTooltip: "Open survey settings" => "Otvaranje postavki upitnika"
// ed.prevSelected: "Select previous" => "Odaberi prethodno"
// ed.nextSelected: "Select next" => "Odaberi sljedeće"
// ed.surveyTypeName: "Survey" => "Anketa"
// ed.pageTypeName: "Page" => "Stranica"
// ed.panelTypeName: "Panel" => "Panel"
// ed.questionTypeName: "Question" => "Pitanje"
// ed.columnTypeName: "Column" => "Stupac"
// ed.themeSurvey: "Themes" => "Teme"
// ed.defaultV2Theme: "Default" => "Propust"
// ed.modernTheme: "Modern" => "Moderan"
// ed.defaultTheme: "Default (legacy)" => "Zadano (naslijeđeno)"
// ed.jsonHideErrors: "Hide errors" => "Sakrij pogreške"
// ed.jsonShowErrors: "Show errors" => "Pokaži pogreške"
// ed.showMoreChoices: "Show more" => "Pokaži više"
// ed.showLessChoices: "Show less" => "Pokaži manje"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "Upišite za pretraživanje..."
// ed.toolboxChoiceCategory: "Choice Questions" => "Pitanja o izboru"
// ed.toolboxTextCategory: "Text Input Questions" => "Pitanja o unosu teksta"
// ed.toolboxContainersCategory: "Containers" => "Kontejnere"
// ed.toolboxMatrixCategory: "Matrix Questions" => "Matrična pitanja"
// ed.toolboxMiscCategory: "Misc" => "Ostalo"
// ed.translationPropertyGridTitle: "Language Settings" => "Jezične postavke"
// ed.themePropertyGridTitle: "Theme Settings" => "Postavke teme"
// ed.translationLanguages: "Languages" => "Jezici"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "Samo korišteni nizovi"
// ed.translationPlaceHolder: "Translation..." => "Prevođenje..."
// ed.themeExportButton: "Export" => "Izvoz"
// ed.themeImportButton: "Import" => "Uvoz"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Odabiri se kopiraju iz"
// ed.htmlPlaceHolder: "HTML content will be here." => "HTML sadržaj će biti ovdje."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "Ovdje ispustite pitanje iz kutije s alatima."
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "Anketa je prazna. Povucite element iz alatnog okvira ili kliknite donji gumb."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Povucite i ispustite sliku ovdje ili kliknite donji gumb i odaberite sliku koju želite prenijeti"
// ed.imageChooseImage: "Choose Image" => "Odabir slike"
// ed.addNewTypeQuestion: "Add {0}" => "Dodaj {0}"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[LOGO]"
// ed.auto: "auto" => "automobil"
// ed.choices_Item: "Item " => "Stavka "
// lg.addNewItem: "Add New Rule" => "Dodaj novo pravilo"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "Stvorite pravilo za prilagodbu tijeka upitnika."
// lg.page_enableName: "Enable (disable) page" => "Omogući (onemogući stranicu)"
// lg.column_visibilityName: "Show (hide) column" => "Pokaži (sakrij) stupac"
// lg.column_enableName: "Enable (disable) column" => "Omogući (onemogući stupac)"
// lg.column_requireName: "Make column required" => "Učini stupac obaveznim"
// lg.itemEmptyExpressionText: "New rule" => "Novo pravilo"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "učiniti stupac {0} pitanja vidljivim {1}"
// lg.column_enableText: "make column {0} of question {1} enable" => "{1} omogućivanje stupca {0} pitanja"
// lg.column_requireText: "make column {0} of question {1} required" => "Učinite stupac {0} pitanja {1} potrebnim"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "Očisti vrijednost pitanja: {0}"
// lg.showAllQuestions: "All Questions" => "Sva pitanja"
// lg.showAllActionTypes: "All Action Types" => "Sve vrste akcija"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Logička pravila nisu potpuna"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Niste dovršili neka logička pravila. Ako sada napustite karticu, promjene će se izgubiti. Želite li ipak napustiti karticu bez dovršetka promjena?"
// lg.uncompletedRule_apply: "Yes" => "Da"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Ne, želim ispuniti pravila."
// pe.clear: "Clear" => "Jasan"
// pe.set: "Set" => "Skup"
// pe.change: "Change" => "Mijenjati"
// pe.close: "Close" => "Blizak"
// pe.removeItem: "Click to remove the item..." => "Kliknite da biste uklonili stavku..."
// pe.dragItem: "Drag the item" => "Vucite stavku"
// pe.doneEditing: "Done" => "Učinjeno"
// pe.emptyValue: "Value is empty" => "Vrijednost je prazna"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "Vrijednost '{0}' nije jedinstvena"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "Ograničite broj stavki s {0} na {1}"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "Podatke možete postaviti u sljedećem obliku:\nvrijednost1|tekst\nvrijednost2"
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "Pregled odgovora prije slanja ankete"
// pe.overridingPropertyPrefix: "Set by " => "Postavio "
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Nemojte koristiti rezervirane riječi: \"stavka\", \"izbor\", \"ploča\", \"red\"."
// pe.listIsEmpty@choices: "No choices have been added yet" => "Još nema izbora"
// pe.addNew@choices: "Add a choice" => "Dodavanje izbora"
// choicesbyurl.valueName: "Get values from the following JSON field" => "Dohvaćanje vrijednosti iz sljedećeg JSON polja"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "Dohvaćanje URL-ova slika iz sljedećeg JSON polja"
// pe.allowEmptyResponse: "Allow empty response" => "Dopusti prazan odgovor"
// pe.and: "and" => "i"
// pe.or: "or" => "ili"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Odaberite pitanje da biste započeli konfiguriranje uvjeta."
// pe.if: "If" => "Ako"
// pe.then: "then" => "zatim"
// pe.setToName: "Target question" => "Ciljno pitanje"
// pe.fromName: "Question to copy answer from" => "Pitanje iz kojeg treba kopirati odgovor"
// pe.gotoName: "Question to skip to" => "Pitanje na koje treba preskočiti"
// pe.ruleIsNotSet: "Rule is incorrect" => "Pravilo nije ispravno"
// pe.includeIntoResult: "Include into survey results" => "Uključi u rezultate ankete"
// pe.portraitOrientation: "Switch to portrait orientation" => "Prebacivanje na okomito usmjerenje"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Visina slike (u CSS-prihvaćenim vrijednostima)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Širina slike (u CSS-prihvaćenim vrijednostima)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "Vremensko ograničenje za dovršetak stranice (u sekundama)"
// question.page: "Parent page" => "Nadređena stranica"
// pe.noEntriesText: "Empty entries text" => "Prazan tekst unosa"
// pe.setValue: "Answer" => "Odgovor"
// pe.dataFormat: "Image format" => "Oblik slike"
// pe.allowAddRows: "Allow adding rows" => "Dopusti dodavanje redaka"
// pe.allowRemoveRows: "Allow removing rows" => "Dopusti uklanjanje redaka"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "Dopusti povlačenje i ispuštanje retka"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "Ne primjenjuje se ako navedete točnu širinu ili visinu slike."
// pe.minImageWidth: "Minimum image width" => "Minimalna širina slike"
// pe.maxImageWidth: "Maximum image width" => "Maksimalna širina slike"
// pe.minImageHeight: "Minimum image height" => "Minimalna visina slike"
// pe.maxImageHeight: "Maximum image height" => "Maksimalna visina slike"
// surveyvalidator.text: "Error message" => "Poruka o pogrešci"
// surveyvalidator.expression: "Validation expression" => "Izraz za provjeru valjanosti"
// pe.logo: "Logo (URL or base64-encoded string)" => "Logotip (URL ili niz kodiran base64)"
// pe.questionsOnPageMode: "Survey structure" => "Struktura upitnika"
// pe.maxTextLength: "Maximum answer length (in characters)" => "Maksimalna duljina odgovora (u znakovima)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "Maksimalna duljina komentara (u znakovima)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "Ako je potrebno, automatsko proširivanje područja komentara"
// pe.allowResizeComment: "Allow users to resize text areas" => "Dopusti korisnicima promjenu veličine tekstnih područja"
// pe.textUpdateMode: "Update text question value" => "Ažuriranje vrijednosti tekstnog pitanja"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "Postavljanje fokusa na prvi odgovor koji nije valjan"
// pe.checkErrorsMode: "Run validation" => "Pokreni provjeru valjanosti"
// pe.navigateToUrl: "Navigate to URL" => "Navigacija do URL-a"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "Dinamički URL"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "Oznaka koja pokazuje je li korisnik već ispunio ovu anketu"
// pe.completedHtml: "Survey Complete page markup" => "Označavanje stranice dovršeno u anketi"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "Oznaka stranice Dynamic Survey Completed"
// pe.loadingHtml: "Markup to show while survey model is loading" => "Oznaka za prikaz tijekom učitavanja modela upitnika"
// pe.commentText: "Comment area text" => "Tekst područja komentara"
// pe.autocomplete: "Autocomplete type" => "Vrsta samodovršetka"
// pe.labelTrue: "\"True\" label" => "Oznaka \"True\""
// pe.labelFalse: "\"False\" label" => "Oznaka \"False\""
// pe.allowClear: "Show the Clear button" => "Prikaz gumba Očisti"
// pe.displayStyle: "Value display style" => "Stil prikaza vrijednosti"
// pe.format: "Formatted string" => "Oblikovani niz"
// pe.maximumFractionDigits: "Maximum fractional digits" => "Maksimalne djelomične znamenke"
// pe.minimumFractionDigits: "Minimum fractional digits" => "Minimalne djelomične znamenke"
// pe.useGrouping: "Display grouping separators" => "Prikaži razdjelnike grupiranja"
// pe.allowMultiple: "Allow multiple files" => "Dopusti više datoteka"
// pe.allowImagesPreview: "Preview images" => "Pretpregled slika"
// pe.acceptedTypes: "Accepted file types" => "Prihvaćene vrste datoteka"
// pe.waitForUpload: "Wait for the upload to complete" => "Pričekajte da se prijenos dovrši"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "Potvrda brisanja datoteke"
// pe.detailPanelMode: "Detail panel location" => "Mjesto ploče s detaljima"
// pe.minRowCount: "Minimum row count" => "Najmanji broj redaka"
// pe.maxRowCount: "Maximum row count" => "Maksimalan broj redaka"
// pe.confirmDelete: "Confirm row deletion" => "Potvrda brisanja retka"
// pe.confirmDeleteText: "Confirmation message" => "Potvrdna poruka"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "Potvrda brisanja ploče"
// pe.panelCount: "Initial panel count" => "Početni broj ploča"
// pe.minPanelCount: "Minimum panel count" => "Najmanji broj ploča"
// pe.maxPanelCount: "Maximum panel count" => "Maksimalan broj ploča"
// pe.panelsState: "Inner panel expand state" => "Stanje proširenja unutarnje ploče"
// pe.templateDescription: "Description template" => "Predložak opisa"
// pe.templateTitle: "Title template" => "Predložak naslova"
// pe.panelPrevText: "Previous Panel button tooltip" => "Opis alata gumba Prethodna ploča"
// pe.panelNextText: "Next Panel button tooltip" => "Opis alata gumba Sljedeća ploča"
// pe.showRangeInProgress: "Show progress bar" => "Pokaži traku tijeka"
// pe.templateTitleLocation: "Question title location" => "Mjesto naslova pitanja"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "Ukloni mjesto gumba ploče"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "Sakrij pitanje ako nema redaka"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Sakrij stupce ako nema redaka"
// pe.rateValues: "Custom rate values" => "Vrijednosti prilagođene stope"
// pe.rateCount: "Rate count" => "Broj stopa"
// pe.autoGenerate: "How to specify rate values?" => "Kako odrediti vrijednosti stope?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "Sakrij pitanje ako ne sadrži izbora"
// pe.hideNumber: "Hide question number" => "Sakrij broj pitanja"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Minimalna širina (u CSS-prihvaćenim vrijednostima)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Maksimalna širina (u CSS-prihvaćenim vrijednostima)"
// pe.width: "Width (in CSS-accepted values)" => "Širina (u CSS-prihvaćenim vrijednostima)"
// pe.showHeader: "Show column headers" => "Pokaži zaglavlja stupaca"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Pokaži vodoravni klizač"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Minimalna širina stupca (u CSS-prihvaćenim vrijednostima)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Širina zaglavlja retka (u CSS-prihvaćenim vrijednostima)"
// pe.valueTrue: "\"True\" value" => "Vrijednost \"True\""
// pe.valueFalse: "\"False\" value" => "Vrijednost \"False\""
// pe.minErrorText: "\"Value is below minimum\" error message" => "Poruka o pogrešci \"Vrijednost je ispod minimuma\""
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "Poruka o pogrešci \"Vrijednost premašuje maksimum\""
// pe.otherErrorText: "\"Empty comment\" error message" => "Poruka o pogrešci \"Prazan komentar\""
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "Poruka o pogrešci \"Nejedinstvena vrijednost ključa\""
// pe.minSelectedChoices: "Minimum selected choices" => "Minimalno odabrani odabiri"
// pe.maxSelectedChoices: "Maximum selected choices" => "Maksimalan broj odabranih izbora"
// pe.showClearButton: "Show the Clear button" => "Prikaz gumba Očisti"
// pe.showNumber: "Show panel number" => "Pokaži broj ploče"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "Širina logotipa (u CSS-prihvaćenim vrijednostima)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "Visina logotipa (u CSS-prihvaćenim vrijednostima)"
// pe.readOnly: "Read-only" => "Samo za čitanje"
// pe.enableIf: "Editable if" => "Može se uređivati ako"
// pe.emptyRowsText: "\"No rows\" message" => "Poruka \"Bez redaka\""
// pe.size: "Input field size (in characters)" => "Veličina polja unosa (u znakovima)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "Razdvoji posebne odabire (Ništa, Ostalo, Odaberi sve)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Kopiraj odabire iz sljedećeg pitanja"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Koje izbore kopirati?"
// pe.showCommentArea: "Show the comment area" => "Prikaz područja komentara"
// pe.commentPlaceholder: "Comment area placeholder" => "Rezervirano mjesto područja komentara"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Opisi brzine prikaza kao ekstremne vrijednosti"
// pe.rowsOrder: "Row order" => "Redoslijed redaka"
// pe.columnsLayout: "Column layout" => "Izgled stupca"
// pe.columnColCount: "Nested column count" => "Broj ugniježđenih stupaca"
// pe.state: "Panel expand state" => "Stanje proširenja ploče"
// pe.correctAnswer: "Correct Answer" => "Točan odgovor"
// pe.defaultPanelValue: "Default Values" => "Zadane vrijednosti"
// pe.cells: "Cell Texts" => "Tekstovi ćelija"
// pe.keyName: "Key column" => "Stupac ključa"
// itemvalue.text: "Alt text" => "Zamjenski tekst"
// tabs.expression: "Expression" => "Izraz"
// pe.choicesVisibleIf: "Choices are visible if" => "Izbori su vidljivi ako"
// pe.choicesEnableIf: "Choices are selectable if" => "Izbori se mogu odabrati ako"
// pe.columnsEnableIf: "Columns are visible if" => "Stupci su vidljivi ako"
// pe.rowsEnableIf: "Rows are visible if" => "Reci su vidljivi ako"
// pe.indent: "Add indents" => "Dodavanje uvlaka"
// panel.indent: "Add outer indents" => "Dodavanje vanjskih uvlaka"
// pe.innerIndent: "Add inner indents" => "Dodavanje unutarnjih uvlaka"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "Uzimanje zadanih vrijednosti iz posljednjeg retka"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "Preuzimanje zadanih vrijednosti s posljednje ploče"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "Ovdje upišite izraz..."
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "Očisti vrijednost ako pitanje postane skriveno"
// pe.valuePropertyName: "Value property name" => "Naziv svojstva Vrijednost"
// pe.searchEnabled: "Enable search" => "Omogući pretraživanje"
// pe.hideSelectedItems: "Hide selected items" => "Sakrij odabrane stavke"
// pe.closeOnSelect: "Close the dropdown after selection" => "Zatvaranje padajućeg izbornika nakon odabira"
// pe.signatureWidth: "Signature width" => "Širina potpisa"
// pe.signatureHeight: "Signature height" => "Visina potpisa"
// pe.verticalAlign: "Vertical alignment" => "Okomito poravnanje"
// pe.alternateRows: "Alternate rows" => "Zamjenski reci"
// pe.columnsVisibleIf: "Columns are visible if" => "Stupci su vidljivi ako"
// pe.rowsVisibleIf: "Rows are visible if" => "Reci su vidljivi ako"
// pe.otherPlaceholder: "Comment area placeholder" => "Rezervirano mjesto područja komentara"
// pe.rateType: "Rate type" => "Vrsta stope"
// pv.true: "true" => "istinit"
// pv.false: "false" => "lažan"
// pv.decimal: "decimal" => "decimala"
// pv.currency: "currency" => "valuta"
// pv.percent: "percent" => "posto"
// pv.onpanel: "Start on each panel" => "Započni na svakoj ploči"
// pv.tab: "Tabs" => "Tabulatori"
// pv.right: "Right" => "Desno"
// pv.color: "color" => "boja"
// pv.date: "date" => "datum"
// pv.datetime: "datetime" => "datum i vrijeme"
// pv.datetime-local: "datetime-local" => "datetime-local"
// pv.email: "email" => "E-pošta"
// pv.month: "month" => "mjesec"
// pv.number: "number" => "broj"
// pv.password: "password" => "lozinka"
// pv.range: "range" => "domet"
// pv.tel: "tel" => "Tel"
// pv.text: "text" => "Tekstualna poruka"
// pv.time: "time" => "Vrijeme"
// pv.url: "url" => "URL"
// pv.week: "week" => "tjedan"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "Kada se pitanje ili njegova ploča/stranica sakriju"
// clearInvisibleValues.none: "Never" => "Nikada"
// inputType.color: "Color" => "Boja"
// inputType.date: "Date" => "Datum"
// inputType.datetime-local: "Date and Time" => "Datum i vrijeme"
// inputType.email: "Email" => "E-pošta"
// inputType.month: "Month" => "Mjesec"
// inputType.number: "Number" => "Broj"
// inputType.password: "Password" => "Lozinka"
// inputType.range: "Range" => "Domet"
// inputType.tel: "Phone Number" => "Telefonski broj"
// inputType.text: "Text" => "Tekstualna poruka"
// inputType.time: "Time" => "Vrijeme"
// inputType.url: "URL" => "URL"
// inputType.week: "Week" => "Tjedan"
// pv.onValueChanging: "Before an answer is changed" => "Prije promjene odgovora"
// pv.pages: "Completed pages" => "Dovršene stranice"
// pv.questions: "Answered questions" => "Odgovorena pitanja"
// pv.requiredQuestions: "Answered required questions" => "Odgovoreno na obavezna pitanja"
// pv.correctQuestions: "Valid answers" => "Valjani odgovori"
// pv.buttons: "Completed pages (button UI)" => "Dovršene stranice (korisničko sučelje gumba)"
// pv.underInput: "Under the input" => "Ispod ulaza"
// pv.underTitle: "Under the title" => "Pod naslovom"
// pv.onBlur: "On blur" => "Na zamućenju"
// pv.onTyping: "While typing" => "Tijekom tipkanja"
// pv.underRow: "Under the row" => "Ispod retka"
// pv.underRowSingle: "Under the row, only one panel is visible" => "Ispod retka vidljiva je samo jedna ploča"
// showNavigationButtons.none: "Hidden" => "Skriven"
// showProgressBar.off: "Hidden" => "Skriven"
// showTimerPanel.none: "Hidden" => "Skriven"
// showTimerPanelMode.all: "Both" => "Oba"
// detailPanelMode.none: "Hidden" => "Skriven"
// addRowLocation.default: "Depends on matrix layout" => "Ovisi o izgledu matrice"
// panelsState.default: "Users cannot expand or collapse panels" => "Korisnici ne mogu proširiti ili sažeti ploče"
// panelsState.collapsed: "All panels are collapsed" => "Sve ploče su urušene"
// panelsState.expanded: "All panels are expanded" => "Sve ploče su proširene"
// widthMode.auto: "Auto" => "Automobil"
// widthMode.static: "Static" => "Statički"
// widthMode.responsive: "Responsive" => "Odgovarajući"
// imageFit.none: "None" => "Nijedan"
// imageFit.contain: "Contain" => "Sadržavati"
// imageFit.cover: "Cover" => "Pokriti"
// imageFit.fill: "Fill" => "Ispuniti"
// contentMode.auto: "Auto" => "Automobil"
// contentMode.image: "Image" => "Slika"
// contentMode.video: "Video" => "Video"
// contentMode.youtube: "YouTube" => "YouTube"
// displayMode.auto: "Auto" => "Automobil"
// displayMode.buttons: "Buttons" => "Gumbe"
// displayMode.dropdown: "Dropdown" => "Padajući izbornik"
// rateColorMode.default: "Default" => "Propust"
// autoGenerate.true: "Generate" => "Generirati"
// autoGenerate.false: "Enter manually" => "Ručno unesite"
// rateType.labels: "Labels" => "Natpise"
// rateType.stars: "Stars" => "Zvijezde"
// rateType.smileys: "Smileys" => "Smajlići"
// op.and: "and" => "i"
// op.or: "or" => "ili"
// ts.hideInvisibleElements: "Hide invisible elements" => "Sakrij nevidljive elemente"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Kolačići sprječavaju korisnike da dvaput ispune istu anketu."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Mijenja veličinu vidljivog područja polja unosa. Da biste ograničili duljinu unosa, koristite postavku <b>Provjera valjanosti → maksimalnu duljinu</b>."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Koristite {0} kao rezervirano mjesto za stvarnu vrijednost."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Vidljivo samo ako barem jedan stupac ima izraz Vrsta zbroja ili Ukupno."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Dodatne informacije potražite u opisu atributa [accept](https://www.w3schools.com/tags/att_input_accept.asp)."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Primjenjivo samo na vrste ćelija Radiogrupa i Potvrdni okvir."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Dodatne informacije potražite u opisu atributa [samodovršetak](https://developer.mozilla.org/en-US/docs/Web/HTML/atributi/samodovršetak)."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Ako ne postavite ovo svojstvo, odgovor će biti pohranjen u polju određenom svojstvom Naziv ."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Ako navedeni stupac sadrži identične vrijednosti, anketa odbacuje pogrešku \"Nejedinstvena vrijednost ključa\"."
// p.multiSelect: "Allow multiple selection" => "Dopusti višestruki odabir"
// p.showLabel: "Show image captions" => "Pokaži opise slika"
// p.value: "Value" => "Vrijednost"
// p.tabAlign: "Tab alignment" => "Poravnanje tabulatora"
// p.logoFit: "Logo fit" => "Prilagođavanje logotipa"
// p.pages: "Pages" => "Stranice"
// p.questions: "Questions" => "Pitanja"
// p.calculatedValues: "Calculated values" => "Izračunate vrijednosti"
// p.surveyId: "Survey id" => "ID upitnika"
// p.surveyPostId: "Survey post id" => "ID objave upitnika"
// p.surveyShowDataSaving: "Survey show data saving" => "Anketa pokazuje spremanje podataka"
// p.questionDescriptionLocation: "Question description location" => "Mjesto opisa pitanja"
// p.progressBarType: "Progress bar type" => "Vrsta trake napretka"
// p.showTOC: "Show TOC" => "Pokaži tablicu sadržaja"
// p.tocLocation: "Toc location" => "Mjesto tablice sadržaja"
// p.questionTitlePattern: "Question title pattern" => "Uzorak naslova pitanja"
// p.widthMode: "Width mode" => "Način širine"
// p.showBrandInfo: "Show brand info" => "Pokaži informacije o robnoj marki"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "Korištenje vrijednosti prikaza u dinamičkim tekstovima"
// p.descriptionLocation: "Description location" => "Mjesto opisa"
// p.defaultValueExpression: "Default value expression" => "Zadani izraz vrijednosti"
// p.bindings: "Bindings" => "Vezovi"
// p.renderAs: "Render as" => "Iscrtaj kao"
// p.attachOriginalItems: "Attach original items" => "Priloži izvorne stavke"
// p.cellHint: "Cell hint" => "Savjet za ćeliju"
// p.isUnique: "Is unique" => "Jedinstven je"
// p.showInMultipleColumns: "Show in multiple columns" => "Prikaži u više stupaca"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Ukupan maksimalni broj znamenki razlomka"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Ukupan minimum znamenki razlomka"
// p.detailElements: "Detail elements" => "Elementi detalja"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Dopusti prilagodljive radnje"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "Prikaži na ploči s detaljima prilikom dodavanja"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Omogućeno lijeno opterećenje izbora"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Odabiri lijeno učitavanje veličine stranice"
// p.inputFieldComponent: "Input field component" => "Komponenta polja za unos"
// p.itemComponent: "Item component" => "Komponenta artikla"
// p.min: "Min" => "Min"
// p.max: "Max" => "Max"
// p.minValueExpression: "Min value expression" => "Izraz minimalne vrijednosti"
// p.maxValueExpression: "Max value expression" => "Izraz maksimalne vrijednosti"
// p.step: "Step" => "Korak"
// p.dataList: "Data list" => "Popis podataka"
// p.elements: "Elements" => "Elemenata"
// p.content: "Content" => "Sadržaj"
// p.navigationTitle: "Navigation title" => "Naslov navigacije"
// p.navigationDescription: "Navigation description" => "Opis navigacije"
// p.longTap: "Long tap" => "Dugi dodir"
// p.autoGrow: "Auto grow" => "Automatski rast"
// p.allowResize: "Allow resizing" => "Dopusti promjenu veličine"
// p.acceptCarriageReturn: "Accept carriage return" => "Prihvati povratak prijevoza"
// p.displayMode: "Display mode" => "Način prikaza"
// p.rateType: "Rate type" => "Vrsta stope"
// p.contentMode: "Content mode" => "Način sadržaja"
// p.imageFit: "Image fit" => "Prilagodba slike"
// p.altText: "Alt text" => "Zamjenski tekst"
// p.height: "Height" => "Visina"
// p.penColor: "Pen color" => "Boja olovke"
// p.backgroundColor: "Background color" => "Boja pozadine"
// p.templateElements: "Template elements" => "Elementi predloška"
// p.operator: "Operator" => "Operator"
// p.isVariable: "Is variable" => "Je promjenjivo"
// p.runExpression: "Run expression" => "Pokreni izraz"
// p.showCaption: "Show caption" => "Pokaži opis"
// p.iconName: "Icon name" => "Naziv ikone"
// p.iconSize: "Icon size" => "Veličina ikone"
// p.precision: "Precision" => "Preciznost"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Područje držača za povlačenje matrice"
// p.backgroundImage: "Background image" => "Pozadinska slika"
// p.backgroundImageFit: "Background image fit" => "Prilagodba pozadinske slike"
// p.backgroundImageAttachment: "Background image attachment" => "Privitak pozadinske slike"
// p.backgroundOpacity: "Background opacity" => "Neprozirnost pozadine"
// p.selectToRankEnabled: "Select to rank enabled" => "Odaberite za omogućen rang"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Odabir za rangiranje izgleda područja"
// p.allowCameraAccess: "Allow camera access" => "Dopusti pristup kameri"
// p.scaleColorMode: "Scale color mode" => "Način skaliranja boje"
// p.rateColorMode: "Rate color mode" => "Način ocjenjivanja boja"
// p.templateTabTitle: "Template tab title" => "Naslov kartice Predložak"
// p.templateVisibleIf: "Template visible if" => "Predložak vidljiv ako"
// p.copyDisplayValue: "Copy display value" => "Kopiraj vrijednost prikaza"
// theme.--background: "Background color" => "Boja pozadine"
// theme.--background-dim-light: "Background dim light color" => "Pozadina prigušena svijetla boja"
// theme.--primary-foreground: "Primary foreground color" => "Primarna boja prednjeg plana"
// theme.--foreground: "Foreground color" => "Boja prednjeg plana"
// theme.--base-unit: "Base unit" => "Osnovna jedinica"
// theme.groupAdvanced: "Advanced" => "Napredan"
// theme.themeName: "Theme" => "Tema"
// theme.isPanellessss: "Question appearance" => "Izgled pitanja"
// theme.isPanellessPanels: "Default" => "Propust"
// theme.isPanellessLightweight: "Without Panels" => "Bez panela"
// theme.themePaletteLight: "Light" => "Svjetlo"
// theme.themePaletteDark: "Dark" => "Mračan"
// theme.primaryColor: "Accent color" => "Boja isticanja"
// theme.primaryDefaultColor: "Default" => "Propust"
// theme.primaryDarkColor: "Hover" => "Lebdjeti"
// theme.primaryLightColor: "Selected" => "Odabrani"
// theme.backgroundDimColor: "Background color" => "Boja pozadine"
// theme.backgroundImage: "Background image" => "Pozadinska slika"
// theme.backgroundImageFitAuto: "Auto" => "Automobil"
// theme.backgroundImageFitCover: "Cover" => "Pokriti"
// theme.backgroundImageFitContain: "Contain" => "Sadržavati"
// theme.backgroundOpacity: "Opacity" => "Neprozirnost"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Fiksirane"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Svitak"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Neprozirnost pozadine ploče"
// theme.questionBackgroundTransparency: "Question background opacity" => "Pitanje neprozirnosti pozadine"
// theme.questionPanel: "Panel background and corner radius" => "Pozadina ploče i kutni radijus"
// theme.questionTitle: "Question title font" => "Font naslova pitanja"
// theme.questionDescription: "Question description font" => "Font opisa pitanja"
// theme.editorPanel: "Input element" => "Ulazni element"
// theme.editorFont: "Input element font" => "Font elementa unosa"
// theme.backcolor: "Default background" => "Zadana pozadina"
// theme.hovercolor: "Hover background" => "Pozadina držanja pokazivača miša"
// theme.borderDecoration: "Border decoration" => "Uređenje obruba"
// theme.accentBackground: "Accent background" => "Pozadina isticanja"
// theme.accentForeground: "Accent foreground" => "Isticanje u prvom planu"
// theme.primaryForecolor: "Default color" => "Zadana boja"
// theme.primaryForecolorLight: "Disabled color" => "Onemogućena boja"
// theme.linesColors: "Minor line colors" => "Sporedne boje crta"
// theme.borderDefault: "Darker" => "Tamnije"
// theme.borderLight: "Lighter" => "Upaljač"
// theme.fontFamily: "Font family" => "Obitelj fontova"
// theme.fontSize: "Font size" => "Veličina fonta"
// theme.color: "Color" => "Boja"
// theme.size: "Size" => "Veličina"
// theme.fontWeightRegular: "Regular" => "Redovan"
// theme.fontWeightHeavy: "Heavy" => "Težak"
// theme.fontWeightSemiBold: "Semi-bold" => "Polupodebljano"
// theme.fontWeightBold: "Bold" => "Odvažan"
// theme.scale: "Scale" => "Vaga"
// theme.cornerRadius: "Corner radius" => "Kutni radijus"
// theme.surveyTitleFont: "Survey title font" => "Font naslova upitnika"
// theme.pageTitle: "Page title font" => "Font naslova stranice"
// theme.pageDescription: "Page description font" => "Font opisa stranice"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Dodaj efekt sjene"
// theme.opacity: "Opacity" => "Neprozirnost"
// theme.boxShadowBlur: "Blur" => "Mrlja"
// theme.boxShadowSpread: "Spread" => "Širenje"
// theme.boxShadowDrop: "Drop" => "Ispustiti"
// theme.boxShadowInner: "Inner" => "Unutarnji"
// theme.questionShadow: "Shadow effects" => "Efekti sjene"
// theme.editorShadow: "Input element shadow effects" => "Efekti sjene ulaznog elementa"
// names.default: "Default" => "Propust"
// names.contrast: "Contrast" => "Razlika"
// names.plain: "Plain" => "Ravnica"
// names.simple: "Simple" => "Jednostavan"
// names.blank: "Blank" => "Prazno"
// names.double: "Double" => "Dvostruk"
// names.bulk: "Bulk" => "Veličina"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo 3D"
// names.playful: "Playful" => "Razigran"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Teal"
// colors.blue: "Blue" => "Plav"
// colors.purple: "Purple" => "Ljubičast"
// colors.orchid: "Orchid" => "Orhideja"
// colors.tulip: "Tulip" => "Lala"
// colors.brown: "Brown" => "Smeđ"
// colors.green: "Green" => "Zelen"
// names.sharp: "Sharp" => "Oštar"
// names.borderless: "Borderless" => "Bez obruba"
// names.flat: "Flat" => "Stan"
// names.doubleborder: "Double Border" => "Dvostruki obrub"
// names.layered: "Layered" => "Slojevita"
// names.solid: "Solid" => "Solidan"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Jeste li sigurni da želite izbrisati sve nizove za ovaj jezik?"
// ed.themeResetButton: "Reset theme settings to default" => "Vraćanje zadanih postavki teme na zadano"
// theme.placeholderColor: "Placeholder color" => "Boja rezerviranog mjesta"
// ed.themeSettings: "Theme Settings" => "Postavke teme"
// ed.themeSettingsTooltip: "Open theme settings" => "Otvaranje postavki teme"
// pe.resetToDefaultCaption: "Reset" => "Brisanje"
// pv.file: "Local files" => "Lokalne datoteke"
// pv.camera: "Camera" => "Kamera"
// pv.file-camera: "Local files or camera" => "Lokalne datoteke ili kamera"
// ed.translateUsigAI: "Auto-translate All" => "Automatski prevedi sve"
// ed.translationDialogTitle: "Untranslated strings" => "Neprevedeni nizovi"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Unesite najmanje {0} stavki"
// lg.question_resetValueName: "Reset question value" => "Vrati izvornu vrijednost pitanja"
// lg.column_resetValue: "Reset column value" => "Vraćanje izvorne vrijednosti stupca"
// pe.markRequired: "Mark as required" => "Označi kao obavezno"
// pe.removeRequiredMark: "Remove the required mark" => "Uklanjanje potrebne oznake"
// p.resetValueIf: "Reset value if" => "Vrati izvornu vrijednost ako"
// lg.question_setValueName: "Set question value" => "Postavljanje vrijednosti pitanja"
// lg.column_resetValueName: "Reset column value" => "Vraćanje izvorne vrijednosti stupca"
// lg.column_setValueName: "Set column value" => "Postavljanje vrijednosti stupca"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Izraz čiji će rezultat biti dodijeljen ciljnom pitanju."
// survey.title: "Title" => "Naslov"
// page.title: "Title" => "Naslov"
// p.setValueIf: "Set value if" => "Postavi vrijednost ako"
// theme.header: "Header" => "Zaglavlje"
// theme.backgroundImageFitFill: "Stretch" => "Parcela"
// theme.backgroundImageFitTile: "Tile" => "Crijep"
// theme.headerView: "View" => "Pogled"
// theme.headerViewBasic: "Basic" => "Osnovni"
// theme.headerViewAdvanced: "Advanced" => "Napredan"
// theme.headerInheritWidthFrom: "Content area width" => "Širina područja sadržaja"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Isto kao i anketa"
// theme.headerInheritWidthFromPage: "Fit to page" => "Prilagodi stranici"
// theme.headerTextAreaWidth: "Text width" => "Širina teksta"
// theme.headerBackgroundColorSwitch: "Background color" => "Boja pozadine"
// theme.headerBackgroundColorNone: "None" => "Nijedan"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Boja isticanja"
// theme.headerBackgroundColorCustom: "Custom" => "Običaj"
// theme.horizontalAlignmentLeft: "Left" => "Lijevo"
// theme.horizontalAlignmentCenter: "Center" => "Središte"
// theme.horizontalAlignmentRight: "Right" => "Desno"
// theme.verticalAlignmentTop: "Top" => "Vrh"
// theme.verticalAlignmentMiddle: "Middle" => "Sredina"
// theme.verticalAlignmentBottom: "Bottom" => "Dno"
// theme.logoPosition: "Logo Position" => "Položaj logotipa"
// theme.headerTitlePosition: "Title Position" => "Položaj naslova"
// theme.headerDescriptionPosition: "Description Position" => "Položaj opisa"
// lg.question_resetValueText: "reset value for question: {0}" => "Vrati izvornu vrijednost za pitanje: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Dodijeli vrijednost: {1} pitanje: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Vrati izvornu vrijednost ćelije za stupac: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Dodijeli vrijednost ćelije: {1} stupcu: {0}"
// ed.surveyJsonExportButton: "Export" => "Izvoz"
// ed.surveyJsonImportButton: "Import" => "Uvoz"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Kopiraj u međuspremnik"
// pe.filePlaceholder: "File placeholder text" => "Tekst rezerviranog mjesta datoteke"
// pe.photoPlaceholder: "Photo placeholder text" => "Tekst rezerviranog mjesta za fotografije"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Tekst rezerviranog mjesta za datoteku ili fotografiju"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Primjenjuje se kada je \"Vrsta izvora\" \"Lokalne datoteke\" ili kada kamera nije dostupna"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Primjenjuje se kada je \"Vrsta izvora\" \"Kamera\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Primjenjuje se kada je \"Vrsta izvora\" \"Lokalne datoteke ili kamera\"."
// theme.background: "Background" => "Pozadina"
// theme.appearance: "Appearance" => "Izgled"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Želite li zaista resetirati temu? Sve prilagodbe bit će izgubljene."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Da, resetirajte temu"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Prilagodi spremniku"
// signaturepad.showPlaceholder: "Show the placeholder" => "Pokaži rezervirano mjesto"
// signaturepad.placeholder: "Placeholder text" => "Tekst rezerviranog mjesta"
// theme.surveyDescriptionFont: "Survey description font" => "Font opisa upitnika"
// ed.prevFocus: "Focus previous" => "Fokusiraj prethodno"
// ed.nextFocus: "Focus next" => "Usredotoči se sljedeće"
// ed.saveTheme: "Save Theme" => "Spremi temu"
// ed.saveThemeTooltip: "Save Theme" => "Spremi temu"
// lg.page_requireName: "Make page required" => "Učini stranicu obaveznom"
// lg.panel_requireName: "Make page required" => "Učini stranicu obaveznom"
// signaturepad.signatureWidth: "Signature area width" => "Širina područja potpisa"
// signaturepad.signatureHeight: "Signature area height" => "Visina područja potpisa"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Automatsko mijenjanje područja potpisa"
// signaturepad.penMinWidth: "Minimum pen width" => "Minimalna širina olovke"
// signaturepad.penMaxWidth: "Maximum pen width" => "Maksimalna širina olovke"
// ed.propertyGridNoResultsFound: "No results found" => "Nisu pronađeni rezultati"
// pv.leftRight: "Left and right" => "Lijevo i desno"
// p.sourceType: "Source type" => "Vrsta izvora"
// p.fitToContainer: "Fit to container" => "Prilagodi spremniku"
// p.setValueExpression: "Set value expression" => "Postavljanje izraza vrijednosti"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Izbori se učitavaju s web-usluge."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Idi na postavke"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Pretpregled učitanih mogućnosti izbora"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Sprječavanje dvostrukih odgovora u recima"
// theme.advancedMode: "Advanced mode" => "Napredni način rada"
// theme.backgroundCornerRadius: "Background and corner radius" => "Polumjer pozadine i kuta"
// theme.colorsTitle: "Colors" => "Boje"
// theme.font: "Font" => "Krstionica"
// theme.lines: "Lines" => "Linije"
// theme.titleFont: "Title font" => "Font naslova"
// theme.descriptionFont: "Description font" => "Font opisa"
// theme.shadow: "Shadow effects" => "Efekti sjene"
// ed.translateUsigAIFrom: "Translate from: " => "Prevedi iz: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Dopusti mogućnost Odbij odgovoriti"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Dopusti mogućnost Ne znam"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Dopusti mogućnost Odbij odgovoriti"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Dopusti mogućnost Ne znam"
// pv.contain: "Contain" => "Sadržavati"
// pv.cover: "Cover" => "Pokriti"
// pv.fill: "Fill" => "Ispuniti"
// pe.transposeData: "Transpose rows to columns" => "Transponiranje redaka u stupce"
// layout.panel: "Layout" => "Tlocrt"
// layout.question: "Layout" => "Tlocrt"
// layout.base: "Layout" => "Tlocrt"
// panel.name: "Panel name" => "Naziv ploče"
// panel.title: "Panel title" => "Naslov ploče"
// panel.description: "Panel description" => "Opis ploče"
// panel.visibleIf: "Make the panel visible if" => "Učini ploču vidljivom ako"
// panel.requiredIf: "Make the panel required if" => "Učinite ploču potrebnom ako"
// panel.questionsOrder: "Question order within the panel" => "Redoslijed pitanja unutar ploče"
// panel.startWithNewLine: "Display the panel on a new line" => "Prikaz ploče na novom retku"
// panel.state: "Panel collapse state" => "Stanje sažimanja ploče"
// panel.width: "Inline panel width" => "Širina umetnute ploče"
// panel.minWidth: "Minimum panel width" => "Minimalna širina ploče"
// panel.maxWidth: "Maximum panel width" => "Maksimalna širina ploče"
// panel.showNumber: "Number panels" => "Brojčane ploče"
// paneldynamic.name: "Panel name" => "Naziv ploče"
// paneldynamic.title: "Panel title" => "Naslov ploče"
// paneldynamic.description: "Panel description" => "Opis ploče"
// paneldynamic.visibleIf: "Make the panel visible if" => "Učini ploču vidljivom ako"
// paneldynamic.requiredIf: "Make the panel required if" => "Učinite ploču potrebnom ako"
// paneldynamic.page: "Move the panel to page" => "Premještanje ploče na stranicu"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Prikaz ploče na novom retku"
// paneldynamic.state: "Panel collapse state" => "Stanje sažimanja ploče"
// paneldynamic.width: "Inline panel width" => "Širina umetnute ploče"
// paneldynamic.minWidth: "Minimum panel width" => "Minimalna širina ploče"
// paneldynamic.maxWidth: "Maximum panel width" => "Maksimalna širina ploče"
// paneldynamic.templateDescription: "Panel description pattern" => "Uzorak opisa ploče"
// paneldynamic.templateTitle: "Panel title pattern" => "Uzorak naslova ploče"
// paneldynamic.noEntriesText: "Empty panel text" => "Prazan tekst ploče"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Uzorak naslova kartice"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Učinite pojedinačnu ploču vidljivom ako"
// paneldynamic.hideNumber: "Hide the panel number" => "Skrivanje broja ploče"
// paneldynamic.titleLocation: "Panel title alignment" => "Poravnanje naslova ploče"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Poravnanje opisa ploče"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Poravnanje naslova pitanja"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Poravnanje poruke o pogrešci"
// paneldynamic.newPanelPosition: "New panel location" => "Novo mjesto ploče"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Spriječite dvostruke odgovore u sljedećem pitanju"
// question.name: "Question name" => "Naziv pitanja"
// question.title: "Question title" => "Naslov pitanja"
// question.description: "Question description" => "Opis pitanja"
// question.visibleIf: "Make the question visible if" => "Učinite pitanje vidljivim ako"
// question.requiredIf: "Make the question required if" => "Neka pitanje bude potrebno ako:"
// question.state: "Question box collapse state" => "Stanje sažimanja okvira pitanja"
// question.hideNumber: "Hide the question number" => "Skrivanje broja pitanja"
// question.titleLocation: "Question title alignment" => "Poravnanje naslova pitanja"
// question.descriptionLocation: "Question description alignment" => "Poravnanje opisa pitanja"
// question.errorLocation: "Error message alignment" => "Poravnanje poruke o pogrešci"
// question.indent: "Increase the inner indent" => "Povećajte unutarnju uvlaku"
// question.width: "Inline question width" => "Širina umetnutog pitanja"
// question.minWidth: "Minimum question width" => "Minimalna širina pitanja"
// question.maxWidth: "Maximum question width" => "Maksimalna širina pitanja"
// question.textUpdateMode: "Update input field value" => "Ažuriranje vrijednosti polja unosa"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Prikaz gumba Očisti unutar područja za potpis"
// signaturepad.penColor: "Stroke color" => "Boja poteza"
// comment.rows: "Input field height (in lines)" => "Visina polja unosa (u recima)"
// expression.name: "Expression name" => "Naziv izraza"
// expression.title: "Expression title" => "Naslov izraza"
// expression.description: "Expression description" => "Opis izraza"
// expression.expression: "Expression" => "Izraz"
// trigger.expression: "Expression" => "Izraz"
// calculatedvalue.expression: "Expression" => "Izraz"
// survey.description: "Survey description" => "Opis upitnika"
// page.name: "Page name" => "Naziv stranice"
// page.description: "Page description" => "Opis stranice"
// page.visibleIf: "Make the page visible if" => "Učini stranicu vidljivom ako"
// page.requiredIf: "Make the page required if" => "Učini stranicu potrebnom ako"
// page.questionsOrder: "Question order on the page" => "Redoslijed pitanja na stranici"
// matrixdropdowncolumn.name: "Column name" => "Naziv stupca"
// matrixdropdowncolumn.title: "Column title" => "Naslov stupca"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Sprječavanje dvostrukih odgovora"
// matrixdropdowncolumn.width: "Column width" => "Širina stupca"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Minimalna širina stupca"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Visina polja unosa (u recima)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Učini stupac vidljivim ako"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Učinite stupac potrebnim ako"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Svaka mogućnost u zasebnom stupcu"
// multipletextitem.name: "Name" => "Ime"
// multipletextitem.title: "Title" => "Naslov"
// pe.rateDescriptionLocation: "Label alignment" => "Poravnanje natpisa"
// pe.cellErrorLocation: "Cell error message alignment" => "Poravnanje poruke o pogrešci ćelije"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Još nemate kolumne"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Još nemate redaka"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Još nemate pravila provjere valjanosti"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Još nemate prilagođene varijable"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Još nemaš okidača"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Još nemate poveznice"
// pe.addNew@columns: "Add new column" => "Dodaj novi stupac"
// pe.addNew@rows: "Add new row" => "Dodaj novi redak"
// pe.addNew@validators: "Add new rule" => "Dodaj novo pravilo"
// pe.addNew@calculatedValues: "Add new variable" => "Dodaj novu varijablu"
// pe.addNew@triggers: "Add new trigger" => "Dodaj novi okidač"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Dodaj novi URL"
// choicesbyurl.url: "Web service's URL" => "URL web-usluge"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Prikaz naslova stranica na traci tijeka"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Prikaz brojeva stranica na traci tijeka"
// itemvalue.visibleIf: "Make the option visible if" => "Učini mogućnost vidljivom ako"
// itemvalue.enableIf: "Make the option selectable if" => "Učini mogućnost odabranom ako"
// panel.layout: "Panel Layout" => "Izgled ploče"
// tabs.questionSettings: "Question Settings" => "Postavke pitanja"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Npr.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Ex.: kategorije.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Npr.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Npr.: 6 inča"
// pe.minWidth_placeholder: "Ex.: 600px" => "Npr.: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Npr.: 50%"
// pv.selected: "Selected" => "Odabrani"
// pv.unselected: "Unselected" => "Neodabrano"
// pv.center: "Center" => "Središte"
// pv.middle: "Middle" => "Sredina"
// pv.next: "Next" => "Sljedeći"
// pv.last: "Last" => "Trajati"
// clearIfInvisible.none: "Never" => "Nikada"
// questionsOnPageMode.standard: "Original structure" => "Izvorna struktura"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Pokaži sva pitanja na jednoj stranici"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Pokaži jedno pitanje po stranici"
// pv.auto: "Auto" => "Automobil"
// panelsState.firstExpanded: "First expanded" => "Prvo prošireno"
// rateColorMode.scale: "Scale" => "Vaga"
// scaleColorMode.monochrome: "Monochrome" => "Jednobojni"
// scaleColorMode.colored: "Colored" => "Boji"
// state.default: "Locked" => "Zaključan"
// showQuestionNumbers.default: "Auto-numbering" => "Automatsko numeriranje"
// showQuestionNumbers.on: "Auto-numbering" => "Automatsko numeriranje"
// showQuestionNumbers.onPage: "Reset on each page" => "Vrati izvorno na svaku stranicu"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Vrati izvorno na svaku ploču"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Vrati izvorno na svaku ploču"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Nastavi kroz anketu"
// showQuestionNumbers.off: "No numbering" => "Bez numeriranja"
// descriptionLocation.underTitle: "Under the question title" => "Pod naslovom pitanja"
// descriptionLocation.underInput: "Under the input field" => "Ispod polja za unos"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Pored izbora"
// selectToRankAreasLayout.vertical: "Above choices" => "Iznad izbora"
// displayStyle.decimal: "Decimal" => "Decimala"
// displayStyle.currency: "Currency" => "Valuta"
// displayStyle.percent: "Percentage" => "Postotak"
// displayStyle.date: "Date" => "Datum"
// totalDisplayStyle.decimal: "Decimal" => "Decimala"
// totalDisplayStyle.currency: "Currency" => "Valuta"
// totalDisplayStyle.percent: "Percentage" => "Postotak"
// totalDisplayStyle.date: "Date" => "Datum"
// rowsOrder.initial: "Original" => "Originalan"
// questionsOrder.initial: "Original" => "Originalan"
// showProgressBar.aboveheader: "Above the header" => "Iznad zaglavlja"
// showProgressBar.belowheader: "Below the header" => "Ispod zaglavlja"
// pv.sum: "Sum" => "Suma"
// pv.count: "Count" => "Brojati"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Max"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Sadržava"
// searchMode.startsWith: "Starts with" => "Počinje s"
// panel.name: "A panel ID that is not visible to respondents." => "ID ploče koji nije vidljiv ispitanicima."
// panel.description: "Type a panel subtitle." => "Upišite podnaslov ploče."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje vidljivost ploče."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje onemogućuje način samo za čitanje ploče."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje sprječava slanje upitnika, osim ako barem jedno ugniježđeno pitanje nema odgovor."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Odnosi se na sva pitanja unutar ovog panela. Ako želite nadjačati ovu postavku, definirajte pravila poravnanja naslova za pojedinačna pitanja. Mogućnost \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika (\"Vrh\" prema zadanim postavkama)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Postavlja mjesto poruke o pogrešci u odnosu na sva pitanja unutar ploče. Opcija \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Zadržava izvorni redoslijed pitanja ili ih randomizira. Opcija \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika."
// panel.page: "Repositions the panel to the end of a selected page." => "Premješta ploču na kraj odabrane stranice."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Dodaje razmak ili marginu između sadržaja ploče i lijevog obruba okvira ploče."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Poništite odabir za prikaz ploče u jednom retku s prethodnim pitanjem ili pločom. Postavka se ne primjenjuje ako je ploča prvi element u obrascu."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Odaberite između: \"Prošireno\" - ploča je prikazana u cijelosti i može se sažeti; \"Sažeto\" - ploča prikazuje samo naslov i opis i može se proširiti; \"Zaključano\" - ploča je prikazana u cijelosti i ne može se sažeti."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Postavlja širinu ploče proporcionalno ostalim elementima istraživanja u istoj liniji. Prihvaća CSS vrijednosti (px, %, in, pt itd.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "ID ploče koji nije vidljiv ispitanicima."
// paneldynamic.description: "Type a panel subtitle." => "Upišite podnaslov ploče."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje vidljivost ploče."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje onemogućuje način samo za čitanje ploče."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje sprječava slanje upitnika, osim ako barem jedno ugniježđeno pitanje nema odgovor."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Odnosi se na sva pitanja unutar ovog panela. Ako želite nadjačati ovu postavku, definirajte pravila poravnanja naslova za pojedinačna pitanja. Mogućnost \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika (\"Vrh\" prema zadanim postavkama)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Postavlja mjesto poruke o pogrešci u odnosu na pitanje s unosom koji nije valjan. Odaberite između: \"Vrh\" - tekst pogreške nalazi se na vrhu okvira pitanja; \"Dno\" - tekst pogreške nalazi se na dnu okvira pitanja. Mogućnost \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika (\"Vrh\" prema zadanim postavkama)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Postavlja mjesto poruke o pogrešci u odnosu na sva pitanja unutar ploče. Opcija \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Premješta ploču na kraj odabrane stranice."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Dodaje razmak ili marginu između sadržaja ploče i lijevog obruba okvira ploče."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Poništite odabir za prikaz ploče u jednom retku s prethodnim pitanjem ili pločom. Postavka se ne primjenjuje ako je ploča prvi element u obrascu."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Odaberite između: \"Prošireno\" - ploča je prikazana u cijelosti i može se sažeti; \"Sažeto\" - ploča prikazuje samo naslov i opis i može se proširiti; \"Zaključano\" - ploča je prikazana u cijelosti i ne može se sažeti."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Postavlja širinu ploče proporcionalno ostalim elementima istraživanja u istoj liniji. Prihvaća CSS vrijednosti (px, %, in, pt itd.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Upišite predložak za dinamičke naslove ploča. Koristite {panelIndex} za opći položaj panela i {visiblePanelIndex} za njegov redoslijed među vidljivim pločama. Umetnite ova rezervirana mjesta u uzorak da biste dodali automatsko numeriranje."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Upišite predložak za naslove kartica. Koristite {panelIndex} za opći položaj panela i {visiblePanelIndex} za njegov redoslijed među vidljivim pločama. Umetnite ova rezervirana mjesta u uzorak da biste dodali automatsko numeriranje."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Ova postavka omogućuje kontrolu vidljivosti pojedinih ploča unutar dinamičke ploče. Koristite rezervirano mjesto '{panel}' za referenciranje trenutne ploče u izrazu."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Ovu postavku automatski nasljeđuju sva pitanja unutar ove ploče. Ako želite nadjačati ovu postavku, definirajte pravila poravnanja naslova za pojedinačna pitanja. Mogućnost \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika (\"Vrh\" prema zadanim postavkama)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "Opcija \"Naslijedi\" primjenjuje postavku na razini stranice (ako je postavljena) ili na razini upitnika (\"Pod naslovom ploče\" prema zadanim postavkama)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Definira položaj novododane ploče. Prema zadanim postavkama na kraj se dodaju nove ploče. Odaberite \"Dalje\" da biste umetnuli novu ploču nakon trenutne."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Duplicira odgovore s posljednje ploče i dodjeljuje ih sljedećoj dodanoj dinamičkoj ploči."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Pogledajte naziv pitanja kako biste od korisnika zahtijevali da pruži jedinstven odgovor za ovo pitanje na svakoj ploči."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Ova postavka omogućuje dodjeljivanje zadane vrijednosti odgovora na temelju izraza. Izraz može uključivati osnovne izračune - '{q1_id} + {q2_id}', Booleove izraze, kao što su '{age} > 60', i funkcije: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', itd. Vrijednost određena ovim izrazom služi kao početna zadana vrijednost koja se može nadjačati ručnim unosom ispitanika."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje kada se unos ispitanika vraća na vrijednost na temelju \"Zadani izraz vrijednosti\" ili \"Postavi izraz vrijednosti\" ili na vrijednost \"Zadani odgovor\" (ako je postavljena)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje kada pokrenuti \"Postavi izraz vrijednosti\" i dinamički dodijelite dobivenu vrijednost kao odgovor."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Navedite izraz koji definira vrijednost koju treba postaviti kada se ispune uvjeti u pravilu \"Postavi vrijednost ako\". Izraz može uključivati osnovne izračune - '{q1_id} + {q2_id}', Booleove izraze, kao što su '{age} > 60', i funkcije: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', itd. Vrijednost određena ovim izrazom može se nadjačati ručnim unosom ispitanika."
// question.name: "A question ID that is not visible to respondents." => "ID pitanja koji nije vidljiv ispitanicima."
// question.description: "Type a question subtitle." => "Upišite podnaslov pitanja."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje vidljivost pitanja."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje onemogućuje način samo za čitanje za pitanje."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje sprječava napredovanje ili podnošenje upitnika, osim ako pitanje ne dobije odgovor."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Poništite odabir za prikaz pitanja u jednom retku s prethodnim pitanjem ili pločom. Postavka se ne primjenjuje ako je pitanje prvi element u obrascu."
// question.page: "Repositions the question to the end of a selected page." => "Premješta pitanje na kraj odabrane stranice."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Odaberite između: \"Prošireno\" - okvir pitanja prikazuje se u cijelosti i može se sažeti; \"Sažeto\" - okvir pitanja prikazuje samo naslov i opis i može se proširiti; \"Zaključano\" - okvir s pitanjima prikazuje se u cijelosti i ne može se sažeti."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Nadjačava pravila poravnanja naslova definirana na razini ploče, stranice ili upitnika. Opcija \"Naslijedi\" primjenjuje sve postavke više razine (ako su postavljene) ili postavku na razini upitnika (\"Vrh\" prema zadanim postavkama)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "Opcija \"Naslijedi\" primjenjuje postavku na razini upitnika (\"Pod naslovom pitanja\" prema zadanim postavkama)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Postavlja mjesto poruke o pogrešci u odnosu na pitanje s unosom koji nije valjan. Odaberite između: \"Vrh\" - tekst pogreške nalazi se na vrhu okvira pitanja; \"Dno\" - tekst pogreške nalazi se na dnu okvira pitanja. Mogućnost \"Naslijedi\" primjenjuje postavku na razini upitnika (\"Vrh\" prema zadanim postavkama)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Dodaje razmak ili marginu između sadržaja pitanja i lijevog obruba okvira pitanja."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Postavlja širinu pitanja proporcionalno drugim elementima upitnika u istom retku. Prihvaća CSS vrijednosti (px, %, in, pt itd.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Pomoću ikone čarobnog štapića postavite pravilo provjere valjanosti za pitanje."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Odaberite između: \"Na izgubljenom fokusu\" - vrijednost se ažurira kada polje za unos izgubi fokus; \"Tijekom tipkanja\" - vrijednost se ažurira u stvarnom vremenu, jer korisnici tipkaju. Opcija \"Naslijedi\" primjenjuje postavku na razini upitnika (\"Pri izgubljenom fokusu\" prema zadanim postavkama)."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Bilo koju web-uslugu možete koristiti kao izvor podataka za pitanja s višestrukim izborom odgovora. Da biste popunili vrijednosti izbora, unesite URL usluge koja pruža podatke."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Operacija usporedbe koja se koristi za filtriranje padajućeg popisa."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Postavlja širinu prikazanog područja potpisa i rezultirajuću sliku."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Postavlja visinu prikazanog područja potpisa i rezultirajuću sliku."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Odaberite želite li da područje potpisa ispuni sav raspoloživi prostor unutar okvira pitanja uz zadržavanje zadanog omjera slike 3:2. Kada su postavljene prilagođene vrijednosti širine i visine, postavka će zadržati omjer slike tih dimenzija."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Podešava visinu slike u rezultatima upitnika."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Podešava širinu slike u rezultatima upitnika."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Nadjačava vrijednosti minimalne i maksimalne visine."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Nadjačava vrijednosti minimalne i maksimalne širine."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Vrijednost\" služi kao ID stavke koji se koristi u uvjetnim pravilima; \"Tekst\" se prikazuje ispitanicima."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Ova postavka samo mijenja veličinu polja unosa i ne utječe na širinu okvira pitanja. Da biste ograničili prihvaćenu duljinu unosa, idite na <b>Provjera valjanosti → Maksimalno ograničenje znaka</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Postavlja broj prikazanih redaka u polju za unos. Ako ulaz zauzima više redaka, pojavit će se klizač."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Odaberite između: \"Može se uređivati\" - omogućuje ispitanicima da ispune vašu anketu; \"Samo za čitanje\" - onemogućuje uređivanje obrazaca."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "ID stupca koji nije vidljiv ispitanicima."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Kada je omogućen stupac, ispitanik mora dati jedinstven odgovor za svako pitanje unutar ovog stupca."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Postavlja broj prikazanih redaka u polju za unos. Ako ulaz zauzima više redaka, pojavit će se klizač."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje vidljivost stupca."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje onemogućuje način samo za čitanje stupca."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje sprječava slanje upitnika, osim ako barem jedno ugniježđeno pitanje nema odgovor."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Kada je odabrano, stvara pojedinačni stupac za svaku mogućnost izbora."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Odaberite između: \"Statika\" - postavlja fiksnu širinu; \"Responsive\" - čini da anketa zauzima punu širinu zaslona; \"Auto\" - primjenjuje se bilo koji od dva ovisno o korištenim vrstama pitanja."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Zalijepite slikovnu vezu (bez ograničenja veličine) ili kliknite ikonu mape da biste pregledali datoteku s računala (do 64 KB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Postavlja širinu logotipa u CSS jedinicama (px, %, in, pt itd.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Postavlja visinu logotipa u CSS jedinicama (px, %, in, pt itd.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Odaberite između: \"Nema\" - slika zadržava svoju izvornu veličinu; \"Sadrži\" - slika se mijenja kako bi stala uz zadržavanje omjera slike; \"Poklopac\" - slika ispunjava cijelu kutiju zadržavajući omjer slike; \"Ispuna\" - slika se rasteže kako bi ispunila kutiju bez zadržavanja omjera slike."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Odaberite želite li da anketa automatski prijeđe na sljedeću stranicu nakon što ispitanik odgovori na sva pitanja na trenutnoj stranici."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Postavlja vidljivost i mjesto navigacijskih gumba na stranici."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Postavlja vidljivost i mjesto trake napretka. Vrijednost \"Automatski\" prikazuje traku napretka iznad ili ispod zaglavlja upitnika."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Omogućite stranicu pretpregleda samo sa svim ili odgovorenim pitanjima."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Odnosi se na sva pitanja unutar ankete. Ova postavka može se nadjačati pravilima poravnanja naslova na nižim razinama: ploča, stranica ili pitanje. Postavka niže razine nadjačat će one na višoj razini."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Simbol ili niz simbola koji označavaju da je potreban odgovor."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Unesite broj ili slovo s kojim želite započeti numeriranje."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Postavlja mjesto poruke o pogrešci u odnosu na pitanje s unosom koji nije valjan. Odaberite između: \"Vrh\" - tekst pogreške nalazi se na vrhu okvira pitanja; \"Dno\" - tekst pogreške nalazi se na dnu okvira pitanja."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Odaberite želite li da prvo polje za unos na svakoj stranici bude spremno za unos teksta."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Zadržava izvorni redoslijed pitanja ili ih randomizira. Efekt ove postavke vidljiv je samo na kartici Pretpregled."
// pehelp.maxTextLength: "For text entry questions only." => "Samo za pitanja o unosu teksta."
// pehelp.maxOthersLength: "For question comments only." => "Samo za komentare pitanja."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Odaberite želite li da komentari pitanja i pitanja dugog teksta automatski rastu u visinu na temelju unesene duljine teksta."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Samo za komentare pitanja i pitanja dugog teksta."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Prilagođene varijable služe kao srednje ili pomoćne varijable koje se koriste u izračunima obrazaca. Oni uzimaju unose ispitanika kao izvorne vrijednosti. Svaka prilagođena varijabla ima jedinstveni naziv i izraz na kojem se temelji."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Odaberite želite li spremiti izračunatu vrijednost izraza zajedno s rezultatima upitnika."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Okidač je događaj ili uvjet koji se temelji na izrazu. Nakon što se izraz procijeni kao \"istinit\", okidač pokreće radnju. Takva radnja može po želji imati ciljano pitanje na koje utječe."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Odaberite želite li očistiti vrijednosti za pitanja skrivena uvjetnom logikom i kada to učiniti."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Odaberite između: \"Na izgubljenom fokusu\" - vrijednost se ažurira kada polje za unos izgubi fokus; \"Tijekom tipkanja\" - vrijednost se ažurira u stvarnom vremenu, jer korisnici tipkaju."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Lijeva vrijednost služi kao ID stupca koji se koristi u uvjetnim pravilima, a ispitanicima se prikazuje prava vrijednost."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Lijeva vrijednost služi kao ID retka koji se koristi u uvjetnim pravilima, a ispitanicima se prikazuje prava vrijednost."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Prihvaća CSS vrijednosti (px, %, in, pt itd.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Prihvaća CSS vrijednosti (px, %, in, pt itd.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Postavlja mjesto poruke o pogrešci u odnosu na ćeliju s unosom koji nije valjan. Mogućnost \"Naslijedi\" primjenjuje postavku iz svojstva \"Poravnanje poruke o pogrešci\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Kada je omogućeno svojstvo \"Spriječi duplicirane odgovore\", ispitanik koji pokuša poslati duplikat unosa primit će sljedeću poruku o pogrešci."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Omogućuje izračunavanje ukupnih vrijednosti na temelju izraza. Izraz može uključivati osnovne izračune ('{q1_id} + {q2_id}'), Booleove izraze ('{age} > 60') i funkcije ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', itd.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Pokreće upit u kojem se traži potvrda brisanja retka."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Duplicira odgovore iz posljednjeg retka i dodjeljuje ih sljedećem dodanom dinamičkom retku."
// pehelp.description: "Type a subtitle." => "Upišite podnaslov."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Odaberite jezik za početak stvaranja upitnika. Da biste dodali prijevod, prijeđite na novi jezik i prevedite izvorni tekst ovdje ili na kartici Prijevodi."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Postavlja mjesto sekcije s detaljima u odnosu na redak. Odaberite između: \"Nema\" - ne dodaje se proširenje; \"Ispod reda\" - proširenje retka nalazi se ispod svakog retka matrice; \"Ispod retka prikaži samo proširenje jednog retka\" - proširenje se prikazuje samo ispod jednog retka, preostala proširenja retka su sažeta."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Odaberite između: \"Nema\" - slika zadržava svoju izvornu veličinu; \"Sadrži\" - slika se mijenja kako bi stala uz zadržavanje omjera slike; \"Poklopac\" - slika ispunjava cijelu kutiju zadržavajući omjer slike; \"Ispuna\" - slika se rasteže kako bi ispunila kutiju bez zadržavanja omjera slike."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Postupno povećava visinu polja unosa tijekom unosa podataka. Nadjačava postavku \"Visina polja unosa (u crtama)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Ručica za promjenu veličine (ili držač) pojavljuje se u kutu i može se povući kako bi se promijenila veličina polja za unos."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Vremenski interval u sekundama nakon kojeg anketa automatski prelazi na stranicu zahvale."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Vremenski interval u sekundama nakon kojeg anketa automatski prelazi na sljedeću stranicu."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Vremenski interval u sekundama nakon kojeg anketa automatski prelazi na sljedeću stranicu."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje vidljivost stranice."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje onemogućuje način samo za čitanje stranice."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje sprječava slanje upitnika, osim ako barem jedno ugniježđeno pitanje nema odgovor."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Odnosi se na sva pitanja unutar ove stranice. Ako želite nadjačati ovu postavku, definirajte pravila poravnanja naslova za pojedinačna pitanja ili ploče. Mogućnost \"Naslijedi\" primjenjuje postavku na razini upitnika (\"Vrh\" prema zadanim postavkama)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Postavlja mjesto poruke o pogrešci u odnosu na pitanje s unosom koji nije valjan. Odaberite između: \"Vrh\" - tekst pogreške nalazi se na vrhu okvira pitanja; \"Dno\" - tekst pogreške nalazi se na dnu okvira pitanja. Mogućnost \"Naslijedi\" primjenjuje postavku na razini upitnika (\"Vrh\" prema zadanim postavkama)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Zadržava izvorni redoslijed pitanja ili ih randomizira. Mogućnost \"Naslijedi\" primjenjuje postavku na razini upitnika (\"Original\" prema zadanim postavkama). Efekt ove postavke vidljiv je samo na kartici Pretpregled."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Postavlja vidljivost navigacijskih gumba na stranici. Opcija \"Naslijedi\" primjenjuje postavku na razini upitnika, koja je zadana kao \"Vidljivo\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Postavlja vidljivost i mjesto mjerača vremena na stranici."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Odaberite između: \"Zaključano\" - korisnici ne mogu proširiti ili sažeti ploče; \"Sažmite sve\" - sve ploče počinju u urušenom stanju; \"Proširite sve\" - sve ploče počinju u proširenom stanju; \"Prvo prošireno\" - samo je prva ploča u početku proširena."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Unesite naziv zajedničkog svojstva unutar polja objekata koje sadrži URL-ove slike ili videodatoteke koje želite prikazati na popisu izbora."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Lijeva vrijednost služi kao ID artikla koji se koristi u uvjetnim pravilima, a ispitanicima se prikazuje prava vrijednost."
// pehelp.title: "Type a user-friendly title to display." => "Upišite naslov prilagođen korisniku za prikaz."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Osigurava da korisnici neće dovršiti anketu dok se datoteke ne prenesu."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Prihvaća CSS vrijednosti (px, %, in, pt itd.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Prihvaća CSS vrijednosti (px, %, in, pt itd.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Prihvaća CSS vrijednosti (px, %, in, pt itd.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "U vrstama pitanja s jednim i višestrukim odabirom svaka mogućnost izbora ima ID i vrijednost prikaza. Kada je odabrana, ova postavka prikazuje prikazanu vrijednost umjesto ID vrijednosti u HTML pitanjima te dinamičke naslove i opise elemenata upitnika."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Odaberite želite li očistiti vrijednosti pitanja skrivene uvjetnom logikom i kada to učiniti. Opcija \"Naslijedi\" prema zadanim postavkama primjenjuje postavku na razini upitnika (\"Nakon završetka ankete\")."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Odaberite između: \"Sve\" - kopira sve opcije izbora iz odabranog pitanja; \"Odabrano\" - dinamički kopira samo odabrane opcije izbora; \"Neodabrano\" - dinamički kopira samo neodabrane opcije izbora. Opcije \"Ništa\" i \"Ostalo\" kopiraju se prema zadanim postavkama ako su omogućene u izvornom pitanju."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Kada je odabrano, korisnici mogu uključiti dodatni unos u zaseban okvir za komentare."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Prikazuje svaku mogućnost posebnog izbora (\"Nema\", \"Ostalo\", \"Odaberi sve\") u novom retku, čak i kada koristite izgled s više stupaca."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Navedite mjesto unutar skupa podataka o usluzi na kojem se nalazi ciljno polje objekata. Ostavite prazno ako URL već pokazuje na polje."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Unesite jedinstveni naziv svojstva unutar polja objekata koje sadrži vrijednosti koje želite prikazati na popisu izbora."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Odaberite da biste servisu dopustili vraćanje praznog odgovora ili polja."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Pomoću ikone čarobnog štapića postavite uvjetno pravilo koje određuje vidljivost svih opcija izbora."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Lijeva vrijednost služi kao ID artikla koji se koristi u uvjetnim pravilima, a ispitanicima se prikazuje prava vrijednost."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Automatski\" odabire između načina rada \"Gumbi\" i \"Padajući izbornik\" na temelju dostupne širine. Kada širina nije dovoljna za prikaz gumba, pitanje prikazuje padajući izbornik."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Omogućuje povezivanje pitanja koja daju rezultate u različitim formatima. Kada su takva pitanja povezana pomoću identifikatora spoja, ovo zajedničko svojstvo pohranjuje odabrane vrijednosti pitanja."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Odaberite želite li ažurirati sadržaj padajućeg izbornika tako da odgovara upitu za pretraživanje koji korisnik upisuje u polje za unos."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Vrijednost koju treba uštedjeti u rezultatima ankete kada ispitanici daju pozitivan odgovor."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Vrijednost koju treba spremiti u rezultatima ankete kada ispitanici daju negativan odgovor."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Ne preporučuje se onemogućavanje ove mogućnosti jer nadjačava sliku pretpregleda i otežava korisniku razumijevanje jesu li datoteke prenesene."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Pokreće upit u kojem se traži potvrda brisanja datoteke."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Omogućite rangiranje samo odabranih odabira. Korisnici će povući odabrane stavke s popisa izbora kako bi ih naručili unutar područja rangiranja."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Unesite popis izbora koji će se predložiti ispitaniku tijekom unosa."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Postavka samo mijenja veličinu ulaznih polja i ne utječe na širinu okvira pitanja."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Postavlja dosljednu širinu za sve natpise stavki u pikselima"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Opcija \"Automatski\" automatski određuje odgovarajući način prikaza - Slika, Videozapis ili YouTube - na temelju navedenog izvornog URL-a."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Služi kao zamjena kada se slika ne može prikazati na korisnikovom uređaju i u svrhu pristupačnosti."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Definira boju odabranog emojija kada je vrsta ikone Ocjena postavljena na \"Smajlići\". Odaberite između: \"Zadano\" - odabrani emoji pojavljuje se u zadanoj boji ankete; \"Skala\" - odabrani emoji nasljeđuje boju od ljestvice ocjenjivanja."
// expression.name: "An expression ID that is not visible to respondents." => "ID izraza koji nije vidljiv ispitanicima."
// expression.description: "Type an expression subtitle." => "Upišite podnaslov izraza."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Izraz može uključivati osnovne izračune ('{q1_id} + {q2_id}'), uvjete ('{age} > 60') i funkcije ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', itd.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Odaberite za spremanje vrijednosti mogućnosti \"Ostalo\" kao zasebnog svojstva u rezultatima upitnika."
// p.swapOrder: "Swap the order of Yes and No" => "Zamjena redoslijeda Da i Ne"
// p.itemTitleWidth: "Item label width (in px)" => "Širina natpisa stavke (u px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Tekst koji prikazuje jesu li odabrane sve mogućnosti"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Tekst rezerviranog mjesta za područje rangiranja"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Automatsko ispunjavanje upitnika"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Odaberite želite li da se anketa automatski dovrši nakon što ispitanik odgovori na sva pitanja."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Spremanje maskirane vrijednosti u rezultate upitnika"
// patternmask.pattern: "Value pattern" => "Uzorak vrijednosti"
// datetimemask.min: "Minimum value" => "Minimalna vrijednost"
// datetimemask.max: "Maximum value" => "Maksimalna vrijednost"
// numericmask.allowNegativeValues: "Allow negative values" => "Dopusti negativne vrijednosti"
// numericmask.thousandsSeparator: "Thousands separator" => "Razdjelnik tisućica"
// numericmask.decimalSeparator: "Decimal separator" => "Decimalni razdjelnik"
// numericmask.precision: "Value precision" => "Preciznost vrijednosti"
// numericmask.min: "Minimum value" => "Minimalna vrijednost"
// numericmask.max: "Maximum value" => "Maksimalna vrijednost"
// currencymask.prefix: "Currency prefix" => "Prefiks valute"
// currencymask.suffix: "Currency suffix" => "Sufiks valute"
// pe.maskType: "Input mask type" => "Vrsta maske za unos"
// maskTypes.patternmask: "Pattern" => "Uzorak"
// maskTypes.numericmask: "Numeric" => "Brojčani"
// maskTypes.datetimemask: "Date and Time" => "Datum i vrijeme"
// maskTypes.currencymask: "Currency" => "Valuta"
// tabs.mask: "Input Mask Settings" => "Postavke maske za unos"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Npr.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Npr.: mm/dd/gggg"
// pe.currencyprefix_placeholder: "Ex.: $" => "Npr.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Npr.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Prelamanje izbora"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Dugi tekstovi u mogućnostima izbora automatski će generirati prijelome redaka kako bi stali unutar padajućeg izbornika. Poništite odabir ako želite da se tekstovi izrežu."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Odaberite želite li spremiti vrijednost pitanja s primijenjenom maskom u rezultatima upitnika."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Uzorak može sadržavati slovne dijelove niza i sljedeća rezervirana mjesta: '9' - za znamenku; \"a\" – za veliko ili malo slovo; '#' - za znamenku ili veliko ili malo slovo. Koristite obrnutu kosu crtu '\\' da biste izbjegli znak."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Uzorak može sadržavati znakove razdjelnika i sljedeća rezervirana mjesta: 'm' - za broj mjeseca; 'mm' - za broj mjeseca, s početnom nulom za jednoznamenkaste vrijednosti; 'd' - za dan u mjesecu; \"dd\" – za dan u mjesecu, s početnom nulom za jednoznamenkaste vrijednosti; \"gg\" - za posljednje dvije znamenke godine; 'gggg' - za četveroznamenkastu godinu."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Simbol koji se koristi za odvajanje djelomičnog dijela od cijelog broja prikazanog broja."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Simbol koji se koristi za odvajanje znamenki velikog broja u grupe od tri."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Ograničava broj znamenki koje treba zadržati nakon decimalnog zareza za prikazani broj."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Jedan ili više simbola koji će se prikazati prije vrijednosti."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Jedan ili više simbola koji će se prikazati nakon vrijednosti."
// ed.translationSource: "Source: " => "Izvor: "
// ed.translationTarget: "Target: " => "Cilj: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Stranica je prazna. Povucite element iz alatnog okvira ili kliknite donji gumb."
// maskTypes.none: "None" => "Nijedan"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Učini redak vidljivim ako"
// itemvalue@rows.enableIf: "Make the row editable if" => "Učinite redak mogućim za uređivanje ako"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Tekst rezerviranog mjesta u načinu samo za čitanje ili pretpregledu"
// pe.textWrapEnabled: "Wrap choices" => "Prelamanje izbora"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Opcija \"Automatski\" automatski određuje odgovarajući način prikaza - Slika, Videozapis ili YouTube - na temelju navedenog izvornog URL-a."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Odaberite između \"Slika\" i \"Videozapis\" da biste postavili način sadržaja birača medija. Ako je odabrana opcija \"Slika\", provjerite jesu li sve ponuđene opcije slikovne datoteke u sljedećim formatima: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Slično tome, ako je odabran \"Video\", provjerite jesu li sve opcije izravne veze na video datoteke u sljedećim formatima: MP4, MOV, WMV, FLV, AVI, MKV. Napominjemo da veze na YouTube nisu podržane za opcije videozapisa."
// ed.selectFile: "Select a file" => "Odabir datoteke"
// ed.removeFile: "Remove the file" => "Uklanjanje datoteke"
// pe.searchMode: "Search Mode" => "Način pretraživanja"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Kliknite donji gumb \"Dodaj pitanje\" da biste započeli stvaranje obrasca."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Kliknite donji gumb \"Dodaj pitanje\" da biste na stranicu dodali novi element."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Kliknite donji gumb \"Dodaj pitanje\" da biste na ploču dodali novi element."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Kliknite donji gumb i odaberite sliku koju želite prenijeti"
// coloralpha.opacity: "Opacity" => "Neprozirnost"
// font.family: "Font family" => "Obitelj fontova"
// font.color: "Color" => "Boja"
// font.placeholderColor: "Placeholder color" => "Boja rezerviranog mjesta"
// font.size: "Size" => "Veličina"
// theme.themeName: "Theme" => "Tema"
// theme.isPanelless: "Question appearance" => "Izgled pitanja"
// theme.editorPanel: "Background and corner radius" => "Polumjer pozadine i kuta"
// theme.questionPanel: "Background and corner radius" => "Polumjer pozadine i kuta"
// theme.primaryColor: "Accent color" => "Boja isticanja"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Neprozirnost pozadine ploče"
// theme.questionBackgroundTransparency: "Question background opacity" => "Pitanje neprozirnosti pozadine"
// theme.fontSize: "Font size" => "Veličina fonta"
// theme.scale: "Scale" => "Vaga"
// theme.cornerRadius: "Corner radius" => "Kutni radijus"
// theme.pageTitle: "Title font" => "Font naslova"
// theme.pageDescription: "Description font" => "Font opisa"
// theme.questionTitle: "Title font" => "Font naslova"
// theme.questionDescription: "Description font" => "Font opisa"
// theme.editorFont: "Font" => "Krstionica"
// theme.backgroundOpacity: "Opacity" => "Neprozirnost"
// theme.--sjs-font-family: "Font family" => "Obitelj fontova"
// theme.--sjs-general-backcolor-dim: "Background color" => "Boja pozadine"
// theme.--sjs-primary-backcolor: "Accent background" => "Pozadina isticanja"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Isticanje u prvom planu"
// theme.--sjs-shadow-small: "Shadow effects" => "Efekti sjene"
// theme.--sjs-shadow-inner: "Shadow effects" => "Efekti sjene"
// theme.--sjs-border-default: "Colors" => "Boje"
// header@header.headerView: "View" => "Pogled"
// header@header.logoPosition: "Logo position" => "Položaj logotipa"
// header@header.surveyTitle: "Survey title font" => "Font naslova upitnika"
// header@header.surveyDescription: "Survey description font" => "Font opisa upitnika"
// header@header.headerTitle: "Survey title font" => "Font naslova upitnika"
// header@header.headerDescription: "Survey description font" => "Font opisa upitnika"
// header@header.inheritWidthFrom: "Content area width" => "Širina područja sadržaja"
// header@header.textAreaWidth: "Text width" => "Širina teksta"
// header@header.backgroundColorSwitch: "Background color" => "Boja pozadine"
// header@header.backgroundImage: "Background image" => "Pozadinska slika"
// header@header.backgroundImageOpacity: "Opacity" => "Neprozirnost"
// header@header.overlapEnabled: "Overlap" => "Preklapanje"
// header@header.logoPositionX: "Logo position" => "Položaj logotipa"
// header@header.titlePositionX: "Title position" => "Položaj naslova"
// header@header.descriptionPositionX: "Description position" => "Položaj opisa"
// weight.400: "Regular" => "Redovan"
// weight.600: "Heavy" => "Težak"
// weight.700: "Semi-bold" => "Polupodebljano"
// weight.800: "Bold" => "Odvažan"
// backgroundImageFit.auto: "Auto" => "Automobil"
// backgroundImageFit.cover: "Cover" => "Pokriti"
// backgroundImageFit.contain: "Contain" => "Sadržavati"
// backgroundImageFit.fill: "Stretch" => "Parcela"
// backgroundImageFit.tile: "Tile" => "Crijep"
// backgroundImageAttachment.fixed: "Fixed" => "Fiksirane"
// backgroundImageAttachment.scroll: "Scroll" => "Svitak"
// headerView.basic: "Basic" => "Osnovni"
// headerView.advanced: "Advanced" => "Napredan"
// inheritWidthFrom.survey: "Same as survey" => "Isto kao i anketa"
// inheritWidthFrom.container: "Fit to container" => "Prilagodi spremniku"
// backgroundColorSwitch.none: "None" => "Nijedan"
// backgroundColorSwitch.accentColor: "Accent color" => "Boja isticanja"
// backgroundColorSwitch.custom: "Custom" => "Običaj"
// colorPalette.light: "Light" => "Svjetlo"
// colorPalette.dark: "Dark" => "Mračan"
// isPanelless.false: "Default" => "Propust"
// isPanelless.true: "Without Panels" => "Bez panela"
// theme.cornerRadius: "Corner radius" => "Kutni radijus"
// theme.fontFamily: "Font family" => "Obitelj fontova"
// theme.fontWeightRegular: "Regular" => "Redovan"
// theme.fontWeightHeavy: "Heavy" => "Težak"
// theme.fontWeightSemiBold: "Semi-bold" => "Polupodebljano"
// theme.fontWeightBold: "Bold" => "Odvažan"
// theme.color: "Color" => "Boja"
// theme.placeholderColor: "Placeholder color" => "Boja rezerviranog mjesta"
// theme.size: "Size" => "Veličina"
// theme.opacity: "Opacity" => "Neprozirnost"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Upišite za pretraživanje..."
// ed.toolboxNoResultsFound: "No results found" => "Nisu pronađeni rezultati"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Rezervirano mjesto naslova tabulatora"
// theme.--sjs-special-red: "Error messages" => "Poruke o pogreškama"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Rezervni tekst za naslove kartica koji se primjenjuje kada uzorak naslova kartice ne daje značajnu vrijednost."
// theme.fontColor: "Font color" => "Boja fonta"
// theme.backgroundColor: "Background color" => "Boja pozadine"
// pe.questionTitleWidth: "Question title width" => "Širina naslova pitanja"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Odabir datoteke ili lijepljenje veze na datoteku..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Npr.: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Postavlja dosljednu širinu za naslove pitanja kada su poravnati lijevo od okvira pitanja. Prihvaća CSS vrijednosti (px, %, in, pt itd.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Postavlja dosljednu širinu za naslove pitanja kada su poravnati lijevo od okvira pitanja. Prihvaća CSS vrijednosti (px, %, in, pt itd.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Visina područja komentara (u recima)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Postavlja broj prikazanih redaka u tekstnim područjima za komentare pitanja. U ulazu zauzima više redaka pojavljuje se klizač."


/***/ }),

/***/ "./src/localization/czech.ts":
/*!***********************************!*\
  !*** ./src/localization/czech.ts ***!
  \***********************************/
/*! exports provided: czStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "czStrings", function() { return czStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var czStrings = {
    // survey templates
    survey: {
        edit: "Upravit",
        externalHelpLink: "Podívejte se a naučte se vytvářet průzkumy",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Sem napište otázku ze sady nástrojů.",
        addLogicItem: "Vytvořte pravidlo pro přizpůsobení průběhu průzkumu.",
        copy: "Kopírovat",
        duplicate: "Duplikovat",
        addToToolbox: "Přidat do sady nástrojů",
        deletePanel: "Odstranit panel",
        deleteQuestion: "Odstranit otázku",
        convertTo: "Převést na",
        drag: "Přetáhnout prvek",
    },
    // Creator tabs
    tabs: {
        preview: "Otestovat průzkum",
        theme: "Motivy",
        translation: "Překlad",
        designer: "Návrhář průzkumů",
        editor: "Editor JSON",
        logic: "Logika průzkumu"
    },
    // Question types
    qt: {
        default: "Výchozí",
        checkbox: "Zaškrtávací pole",
        comment: "Komentář",
        imagepicker: "Nástroj pro výběr obrázku",
        ranking: "Pořadí",
        image: "Obrázek",
        dropdown: "Rozbalovací nabídka",
        tagbox: "Vícevýběrová rozbalovací nabídka",
        file: "Soubor",
        html: "HTML",
        matrix: "Matice (jedna volba)",
        matrixdropdown: "Matice (výběr z více možností)",
        matrixdynamic: "Matice (dynamické řádky)",
        multipletext: "Více textů",
        panel: "Panel",
        paneldynamic: "Panel (dynamické panely)",
        radiogroup: "Přepínač",
        rating: "Hodnocení",
        text: "Jeden vstup",
        boolean: "Přepínač (Ano/Ne)",
        expression: "Výraz (pouze pro čtení)",
        signaturepad: "Podpisová podložka",
        buttongroup: "Skupina tlačítek"
    },
    toolboxCategories: {
        general: "Obecné",
        choice: "Výběrové otázky",
        text: "Textové otázky",
        containers: "Kontejnery",
        matrix: "Maticové otázky",
        misc: "Ostatní"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Výchozí ({0})",
        survey: "Průzkum",
        settings: "Nastavení průzkumu",
        settingsTooltip: "Otevřít nastavení průzkumu",
        surveySettings: "Nastavení průzkumu",
        surveySettingsTooltip: "Nastavení průzkumu",
        themeSettings: "Nastavení motivu",
        themeSettingsTooltip: "Nastavení motivu",
        showPanel: "Zobrazit panel",
        hidePanel: "Skrýt panel",
        prevSelected: "Vybrat předchozí",
        nextSelected: "Vybrat další",
        prevFocus: "Zaostřeno předchozí",
        nextFocus: "Zaostřit na další",
        surveyTypeName: "Průzkum",
        pageTypeName: "Stránka",
        panelTypeName: "Panel",
        questionTypeName: "Otázka",
        columnTypeName: "Sloupec",
        addNewPage: "Přidat novou stránku",
        moveRight: "Přejděte doprava",
        moveLeft: "Přejděte doleva",
        deletePage: "Smazat stránku",
        editPage: "Upravit stránku",
        edit: "Upravit",
        newPageName: "stránka",
        newQuestionName: "otázka",
        newPanelName: "panel",
        newTextItemName: "text",
        defaultV2Theme: "Výchozí",
        modernTheme: "Moderní",
        defaultTheme: "Výchozí (původní)",
        testSurveyAgain: "Znovu otestovat průzkum",
        testSurveyWidth: "Šířka průzkumu: ",
        navigateToMsg: "Museli jste přejít na:",
        saveSurvey: "Uložit průzkum",
        saveSurveyTooltip: "Uložit průzkum",
        saveTheme: "Uložit motiv",
        saveThemeTooltip: "Uložit motiv",
        jsonHideErrors: "Skrýt chyby",
        jsonShowErrors: "Zobrazit chyby",
        undo: "Zrušit",
        redo: "Opětovně vrátit",
        undoTooltip: "Vrátit poslední změnu",
        redoTooltip: "Znovu provést změnu",
        showMoreChoices: "Zobrazit více",
        showLessChoices: "Zobrazit méně",
        copy: "Kopírovat",
        cut: "Vyjmout",
        paste: "Vložit",
        copyTooltip: "Zkopírovat výběr do schránky",
        cutTooltip: "Vyjmout výběr do schránky",
        pasteTooltip: "Vložit ze schránky",
        options: "Možnosti",
        generateValidJSON: "Generovat platný JSON",
        generateReadableJSON: "Generovat čitelný JSON",
        toolbox: "Sada nástrojů",
        "property-grid": "Vlastnosti",
        toolboxFilteredTextPlaceholder: "Chcete-li hledat, zadejte jej...",
        toolboxNoResultsFound: "Nebyly nalezeny žádné výsledky",
        propertyGridFilteredTextPlaceholder: "Zadejte hledaný text...",
        propertyGridNoResultsFound: "Nebyly nalezeny žádné výsledky",
        correctJSON: "Opravte JSON.",
        surveyResults: "Výsledek průzkumu: ",
        surveyResultsTable: "Jako tabulka",
        surveyResultsJson: "Jako JSON",
        resultsTitle: "Nadpis otázky",
        resultsName: "Název otázky",
        resultsValue: "Hodnota odpovědi",
        resultsDisplayValue: "Hodnota zobrazení",
        modified: "Upraveno",
        saving: "Ukládání",
        saved: "Uloženo",
        propertyEditorError: "Chyba:",
        saveError: "Chyba! Obsah editoru není uložen.",
        translationPropertyGridTitle: "Nastavení jazyka",
        themePropertyGridTitle: "Nastavení motivu",
        translationLanguages: "Jazyky",
        translationDeleteLanguage: "Jste si jisti, že chcete odstranit všechny řetězce pro tento jazyk?",
        translationAddLanguage: "Vyberte jazyk pro překlad",
        translationShowAllStrings: "Zobrazit všechny řetězce",
        translationShowUsedStringsOnly: "Pouze použité řetězce",
        translationShowAllPages: "Zobrazit všechny stránky",
        translationNoStrings: "Žádné řetězce k překladu. Změňte filtr.",
        translationExportToSCVButton: "Export do CSV",
        translationImportFromSCVButton: "Import z CSV",
        translateUsigAI: "Automatický překlad Vše",
        translateUsigAIFrom: "Přeložit z: ",
        translationDialogTitle: "Nepřeložené řetězce",
        translationMergeLocaleWithDefault: "Sloučit {0} s výchozím lokálem",
        translationPlaceHolder: "Překlad...",
        translationSource: "Zdroj: ",
        translationTarget: "Cíl: ",
        themeExportButton: "Vývoz",
        themeImportButton: "Dovoz",
        surveyJsonExportButton: "Vývoz",
        surveyJsonImportButton: "Dovoz",
        surveyJsonCopyButton: "Zkopírovat do schránky",
        themeResetButton: "Obnovení výchozího nastavení motivu",
        themeResetConfirmation: "Opravdu chcete resetovat motiv? Všechna vaše přizpůsobení budou ztracena.",
        themeResetConfirmationOk: "Ano, resetovat motiv",
        bold: "Tučně",
        italic: "Kurzíva",
        underline: "Podtržení",
        addNewQuestion: "Přidat otázku",
        selectPage: "Vyberte stránku...",
        carryForwardChoicesCopied: "Volby jsou zkopírovány z",
        choicesLoadedFromWebText: "Volby se načítají z webové služby.",
        choicesLoadedFromWebLinkText: "Přejděte do nastavení",
        choicesLoadedFromWebPreviewTitle: "Náhled načtených voleb",
        htmlPlaceHolder: "Zde bude HTML obsah.",
        panelPlaceHolder: "Sem přetáhněte otázku z panelu nástrojů.",
        surveyPlaceHolder: "Průzkum je prázdný. Přetáhněte prvek z panelu nástrojů nebo klikněte na tlačítko níže.",
        pagePlaceHolder: "Stránka je prázdná. Přetáhněte prvek z palety nástrojů nebo klikněte na tlačítko níže.",
        imagePlaceHolder: "Obrázek můžete vložit jeho přetažením na toto místo nebo kliknutím na tlačítko níže",
        surveyPlaceHolderMobile: "Kliknutím na tlačítko \"Přidat otázku\" níže zahájíte vytváření formuláře.",
        pagePlaceHolderMobile: "Kliknutím na tlačítko \"Přidat otázku\" níže přidáte na stránku nový prvek.",
        panelPlaceHolderMobile: "Kliknutím na tlačítko \"Přidat otázku\" níže přidáte do panelu nový prvek.",
        imagePlaceHolderMobile: "Klikněte na tlačítko níže a vyberte obrázek, který chcete nahrát",
        imageChooseImage: "Vybrat obrázek",
        addNewTypeQuestion: "Přidat {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Položka ",
        selectFile: "Vyberte soubor",
        removeFile: "Odebrání souboru",
        lg: {
            addNewItem: "Přidat nové pravidlo",
            empty_tab: "Vytvořte pravidlo pro přizpůsobení průběhu průzkumu.",
            page_visibilityName: "Viditelnost stránky",
            page_enableName: "Zapnutí (vypnutí) stránky",
            page_requireName: "Nastavit stránku jako povinné",
            panel_visibilityName: "Viditelnost panelu",
            panel_enableName: "Zapnutí/vypnutí panelu",
            panel_requireName: "Nastavit stránku jako povinné",
            question_visibilityName: "Viditelnost otázky",
            question_enableName: "Zapnutí/vypnutí otázky",
            question_requireName: "Povinné vyplnění otázky",
            question_resetValueName: "Obnovit hodnotu otázky",
            question_setValueName: "Nastavit hodnotu otázky",
            column_visibilityName: "Zobrazit (skrýt) sloupec",
            column_enableName: "Zapnout (vypnout) sloupec",
            column_requireName: "Povinný sloupec",
            column_resetValueName: "Obnovit hodnotu sloupce",
            column_setValueName: "Nastavit hodnotu sloupce",
            trigger_completeName: "Dokončení průzkumu",
            trigger_setvalueName: "Nastavení hodnoty otázky",
            trigger_copyvalueName: "Kopírovat hodnotu otázky",
            trigger_skipName: "Přeskočit na otázku",
            trigger_runExpressionName: "Spuštění vlastního výrazu",
            completedHtmlOnConditionName: "Vlastní text stránky s poděkováním",
            page_visibilityDescription: "Zobrazení stránky, když se logický výraz vrátí jako true. V opačném případě zůstane neviditelná.",
            panel_visibilityDescription: "Zobrazení panel, když se logický výraz vrátí jako true. V opačném případě zůstane neviditelný.",
            panel_enableDescription: "Panel a všechny prvky v něm se aktivují, když logický výraz vrátí hodnotu true. V opačném případě je nechte vypnuté.",
            question_visibilityDescription: "Zobrazit otázku, když logický výraz vrátí hodnotu true. V opačném případě zůstane neviditelná.",
            question_enableDescription: "Povolit otázku, když logický výraz vrátí hodnotu true. V opačném případě zůstane neviditelná.",
            question_requireDescription: "Otázka se stává povinnou, když logický výraz vrátí hodnotu true.",
            trigger_completeDescription: "Když logický výraz vrátí hodnotu true, průzkum je dokončen a koncovému uživateli se zobrazí stránka s poděkováním.",
            trigger_setvalueDescription: "Pokud se změní hodnoty otázek, které jsou použity v logickém výrazu, a logický výraz vrátí hodnotu true, nastaví se hodnota na vybranou otázku.",
            trigger_copyvalueDescription: "Pokud se změní hodnoty otázek, které jsou použity v logickém výrazu, a logický výraz vrátí hodnotu true, pak se hodnota jedné vybrané otázky zkopíruje do jiné vybrané otázky.",
            trigger_skipDescription: "Pokud logický výraz vrátí hodnotu true, průzkum přejde na vybranou otázku/zaměří se na ni.",
            trigger_runExpressionDescription: "Pokud logický výraz vrátí hodnotu true, provede se vlastní výraz. Výsledek tohoto výrazu můžete volitelně nastavit do vybrané otázky.",
            completedHtmlOnConditionDescription: "Pokud logický výraz vrátí hodnotu true, změní se výchozí text stránky s poděkováním na zadaný text.",
            itemExpressionText: "Pokud výraz „{0}“ vrátí hodnotu true:",
            itemEmptyExpressionText: "Nové pravidlo",
            page_visibilityText: "Zobrazit stránku {0}",
            panel_visibilityText: "Zobrazit panel {0}",
            panel_enableText: "Povolit panel {0}",
            question_visibilityText: "Zobrazit otázku {0}",
            question_enableText: "Povolit otázku {0}",
            question_requireText: "Otázka {0} je povinná",
            question_resetValueText: "Resetovat hodnotu pro otázku: {0}",
            question_setValueText: "přiřadit hodnotu: {1} na otázku: {0}",
            column_visibilityText: "zviditelnit sloupec {0} úlohy {1}",
            column_enableText: "povolit sloupec {0} otázky {1}",
            column_requireText: "povinný sloupec {0} otázky {1}",
            column_resetValueText: "Obnovit hodnotu buňky pro sloupec: {0}",
            column_setValueText: "Přiřaďte hodnotu buňky: {1} sloupci: {0}",
            setValueExpressionPlaceholder: " Výraz, jehož výsledek bude přiřazen cílové otázce.",
            trigger_completeText: "Průzkum se stává dokončeným",
            trigger_setvalueText: "Zpochybnit: {0} hodnota {1}",
            trigger_setvalueEmptyText: "Jasná hodnota otázky: {0}",
            trigger_copyvalueText: "Kopírovat do otázky: {0} hodnota z otázky {1}",
            trigger_skipText: "Průzkum přeskočí na otázku {0}",
            trigger_runExpressionText1: "Spustit výraz: „{0}“",
            trigger_runExpressionText2: " a zpochybnit jeho výsledek: {0}",
            completedHtmlOnConditionText: "Zobrazit vlastní text pro stránku s poděkováním.",
            showAllQuestions: "Všechny otázky",
            showAllActionTypes: "Všechny typy akcí",
            conditions: "Podmínky",
            actions: "Akce",
            expressionEditorTitle: "Definovat podmínky",
            actionsEditorTitle: "Definovat akce",
            deleteAction: "Smazat akci",
            addNewAction: "Přidat novou akci",
            selectedActionCaption: "Vyberte akci, kterou chcete přidat...",
            expressionInvalid: "Logický výraz je prázdný nebo neplatný. Opravte jej.",
            noActionError: "Přidejte alespoň jednu akci.",
            actionInvalid: "Opravte prosím problémy v akcích.",
            uncompletedRule_title: "Opustit záložku?",
            uncompletedRule_text: "Jedno nebo více logických pravidel není dokončeno. Opuštěním záložky dojde ke ztrátě všech neaplikovatelných změn. Jste si jisti, že chcete odejít?",
            uncompletedRule_apply: "Ano",
            uncompletedRule_cancel: "Ne, chci pravidla dokončit"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Název panelu",
            title: "Název panelu",
            description: "Popis panelu",
            visibleIf: "Zviditelněte panel, pokud",
            requiredIf: "Zajistěte, aby byl panel povinný, pokud",
            questionsOrder: "Pořadí otázek v rámci panelu",
            page: "Nadřazená stránka",
            startWithNewLine: "Zobrazení obrazu na novém řádku",
            state: "Stav sbalení panelu",
            width: "Šířka vloženého panelu",
            minWidth: "Minimální šířka panelu",
            maxWidth: "Maximální šířka panelu",
            showNumber: "Číselné panely"
        },
        paneldynamic: {
            name: "Název panelu",
            title: "Název panelu",
            description: "Popis panelu",
            visibleIf: "Zviditelněte panel, pokud",
            requiredIf: "Zajistěte, aby byl panel povinný, pokud",
            page: "Přesunutí panelu na stránku",
            startWithNewLine: "Zobrazení obrazu na novém řádku",
            state: "Stav sbalení panelu",
            width: "Šířka vloženého panelu",
            minWidth: "Minimální šířka panelu",
            maxWidth: "Maximální šířka panelu",
            confirmDelete: "Potvrdit smazání panelu",
            templateDescription: "Vzor popisu panelu",
            templateTitle: "Vzor titulku panelu",
            noEntriesText: "Prázdný text panelu",
            templateTabTitle: "Vzor názvu tabulátoru",
            tabTitlePlaceholder: "Zástupný symbol názvu tabulátoru",
            templateVisibleIf: "Zviditelněte jednotlivý panel, pokud",
            hideNumber: "Skrýt číslo panelu",
            titleLocation: "Zarovnání názvu panelu",
            descriptionLocation: "Zarovnání popisu panelu",
            templateTitleLocation: "Zarovnání názvu otázky",
            templateErrorLocation: "Zarovnání chybové zprávy",
            newPanelPosition: "Nové umístění panelu",
            keyName: "Zabraňte duplicitním odpovědím v následující otázce"
        },
        question: {
            name: "Název otázky",
            title: "Název otázky",
            description: "Popis otázky",
            visibleIf: "Zviditelněte otázku, pokud",
            requiredIf: "Otázku povinně zjišťte, pokud",
            page: "Nadřazená stránka",
            state: "Stav sbalení pole otázek",
            hideNumber: "Skrýt číslo otázky",
            titleLocation: "Zarovnání názvu otázky",
            descriptionLocation: "Zarovnání popisu otázky",
            errorLocation: "Zarovnání chybové zprávy",
            indent: "Zvětšete vnitřní odsazení",
            width: "Vložená šířka otázky",
            minWidth: "Minimální šířka otázky",
            maxWidth: "Maximální šířka otázky",
            textUpdateMode: "Aktualizovat hodnotu vstupního pole"
        },
        signaturepad: {
            signatureWidth: "Šířka oblasti podpisu",
            signatureHeight: "Výška signatury",
            signatureAutoScaleEnabled: "Automatické škálování oblasti podpisu",
            showPlaceholder: "Zobrazení zástupného symbolu",
            placeholder: "Zástupný text",
            placeholderReadOnly: "Zástupný text v režimu jen pro čtení nebo v režimu náhledu",
            allowClear: "Zobrazení tlačítka Vymazat v oblasti podpisu",
            penMinWidth: "Minimální šířka pera",
            penMaxWidth: "Maximální šířka pera",
            penColor: "Barva tahu"
        },
        comment: {
            rows: "Výška vstupního pole (v řádcích)"
        },
        showQuestionNumbers: "Zobrazit čísla otázek",
        questionStartIndex: "Index začátku otázky (1, 2 nebo A, a)",
        expression: {
            name: "Název výrazu",
            title: "Název výrazu",
            description: "Popis výrazu",
            expression: "Výraz"
        },
        trigger: {
            expression: "Výraz"
        },
        calculatedvalue: {
            expression: "Výraz"
        },
        // survey templates
        survey: {
            title: "Titul",
            description: "Popis průzkumu"
        },
        page: {
            name: "Název stránky",
            title: "Titul",
            description: "Popis stránky",
            visibleIf: "Zviditelněte stránku, pokud",
            requiredIf: "Zajistěte, aby stránka byla povinná, pokud",
            maxTimeToFinish: "Časový limit pro dokončení stránky (v sekundách)",
            questionsOrder: "Pořadí otázek na stránce"
        },
        matrixdropdowncolumn: {
            name: "Název sloupce",
            title: "Název sloupce",
            isUnique: "Zabraňte duplicitním odpovědím",
            width: "Šířka sloupce",
            minWidth: "Minimální šířka sloupce",
            rows: "Výška vstupního pole (v řádcích)",
            visibleIf: "Zviditelněte sloupec, pokud",
            requiredIf: "Vytvořte sloupec jako povinný, pokud",
            showInMultipleColumns: "Každá možnost v samostatném sloupci"
        },
        multipletextitem: {
            name: "Jméno",
            title: "Titul"
        },
        masksettings: {
            saveMaskedValue: "Uložit maskovanou hodnotu ve výsledcích průzkumu"
        },
        patternmask: {
            pattern: "Vzor hodnoty"
        },
        datetimemask: {
            min: "Minimální hodnota",
            max: "Maximální hodnota"
        },
        numericmask: {
            allowNegativeValues: "Povolit záporné hodnoty",
            thousandsSeparator: "Oddělovač tisíců",
            decimalSeparator: "Oddělovač desetinných míst",
            precision: "Přesnost hodnoty",
            min: "Minimální hodnota",
            max: "Maximální hodnota"
        },
        currencymask: {
            prefix: "Předpona měny",
            suffix: "Přípona měny"
        },
        imageHeight: "Výška obrázku",
        imageWidth: "Šířka obrázku",
        valueName: "Název hodnoty",
        rateDescriptionLocation: "Zarovnání štítků",
        size: "Velikost vstupu (v počtu znaků)",
        cellErrorLocation: "Zarovnání chybové zprávy buňky",
        apply: "Použít",
        ok: "OK",
        save: "Uložit",
        clear: "Vymazat",
        saveTooltip: "Uložit",
        cancel: "Zrušit",
        set: "Nastavit",
        reset: "Resetovat",
        change: "Změnit",
        refresh: "Obnovit",
        close: "Zavřít",
        delete: "Smazat",
        add: "Přidat",
        addNew: "Přidat novou",
        addItem: "Kliknutím přidáte položku...",
        removeItem: "Kliknutím odstraníte položku...",
        dragItem: "Přetáhněte položku",
        addOther: "Ostatní",
        addSelectAll: "Vybrat vše",
        addNone: "Žádné",
        removeAll: "Odstranit vše",
        edit: "Upravit",
        back: "Návrat bez uložení",
        backTooltip: "Návrat bez uložení",
        saveAndBack: "Uložit a vrátit",
        saveAndBackTooltip: "Uložit a vrátit",
        doneEditing: "Hotovo",
        editChoices: "Upravit volby",
        showChoices: "Zobrazit volby",
        move: "Přesunout",
        empty: "<prázdné>",
        emptyValue: "Hodnota je prázdná",
        fastEntry: "Rychlý vstup",
        fastEntryNonUniqueError: "Hodnota \"{0}\" není unikátní",
        fastEntryChoicesCountError: "Prosím, omezte počet položek od {0} do {1}",
        fastEntryChoicesMinCountError: "Zadejte alespoň {0} položek",
        fastEntryPlaceholder: "Data můžete nastavit v následujícím formátu:\nhodnota1|text\nhodnota2",
        formEntry: "Vstupní formulář",
        testService: "Testování služby",
        itemSelectorEmpty: "Vyberte prvek",
        conditionActionEmpty: "Vyberte akci",
        conditionSelectQuestion: "Vyberte otázku...",
        conditionSelectPage: "Vyberte stránku...",
        conditionSelectPanel: "Vyberte panel...",
        conditionValueQuestionTitle: "Zadejte/vyberte hodnotu",
        aceEditorHelp: "Stisknutím kláves ctrl+mezerník získáte nápovědu k dokončení výrazu",
        aceEditorRowTitle: "Aktuální řádek",
        aceEditorPanelTitle: "Aktuální panel",
        showMore: "Další podrobnosti naleznete v dokumentaci",
        assistantTitle: "Dostupné otázky:",
        cellsEmptyRowsColumns: "Měl by existovat alespoň jeden sloupec nebo řádek.",
        showPreviewBeforeComplete: "Zobrazit náhled odpovědí před odesláním průzkumu",
        overridingPropertyPrefix: "Nastavit podle ",
        resetToDefaultCaption: "Resetovat",
        propertyIsEmpty: "Zadejte hodnotu",
        propertyIsNoUnique: "Zadejte jedinečnou hodnotu",
        propertyNameIsNotUnique: "Zadejte jedinečný název",
        propertyNameIsIncorrect: "Nepoužívejte vyhrazená slova: \"položka\", \"volba\", \"panel\", \"řádek\".",
        listIsEmpty: "Přidat novou položku",
        "listIsEmpty@choices": "Zatím nebyly přidány žádné volby",
        "listIsEmpty@columns": "Zatím nemáte žádné sloupce.",
        "listIsEmpty@rows": "Zatím nemáte žádné řádky",
        "listIsEmpty@validators": "Zatím nemáte žádná ověřovací pravidla.",
        "listIsEmpty@calculatedValues": "Zatím nemáte žádné vlastní proměnné.",
        "listIsEmpty@triggers": "Zatím nemáte žádné spouštěče",
        "listIsEmpty@navigateToUrlOnCondition": "Zatím nemáte žádné odkazy",
        "addNew@choices": "Přidat volbu",
        "addNew@columns": "Přidat nový sloupec",
        "addNew@rows": "Přidat nový řádek",
        "addNew@validators": "Přidat nové pravidlo",
        "addNew@calculatedValues": "Přidat novou proměnnou",
        "addNew@triggers": "Přidání nového triggeru",
        "addNew@navigateToUrlOnCondition": "Přidat novou adresu URL",
        expressionIsEmpty: "Výraz je prázdný",
        value: "Hodnota",
        text: "Text",
        rowid: "ID řady",
        imageLink: "Odkaz na obrázek",
        columnEdit: "Upravit sloupec: {0}",
        itemEdit: "Upravit položku: {0}",
        url: "URL",
        path: "Cesta",
        choicesbyurl: {
            url: "Adresa URL webové služby",
            valueName: "Získat hodnoty z následujícího JSON pole"
        },
        titleName: "Získat texty z následujícího JSON pole",
        imageLinkName: "Získat URL obrázku z následujícího JSON pole",
        allowEmptyResponse: "Povolit prázdnou odpověď",
        titlePlaceholder: "Sem zadejte název",
        surveyTitlePlaceholder: "Sem zadejte název průzkumu",
        pageTitlePlaceholder: "Sem zadejte název stránky",
        descriptionPlaceholder: "Zadejte popis",
        surveyDescriptionPlaceholder: "Zadejte popis průzkumu",
        pageDescriptionPlaceholder: "Zadejte popis stránky",
        textWrapEnabled: "Možnosti obtékání",
        showOtherItem: "Má jinou položku",
        otherText: "Další text položky",
        showNoneItem: "Nemá žádnou položku",
        showRefuseItem: "Povolte možnost Odmítnout odpověď",
        showDontKnowItem: "Povolit možnost Nevím",
        noneText: "Žádný text položky",
        showSelectAllItem: "Vybral/a všechny položky",
        selectAllText: "Vyberte veškerý text položky",
        choicesMin: "Minimální hodnota pro automaticky generované položky",
        choicesMax: "Maximální hodnota pro automaticky generované položky",
        choicesStep: "Rozdíl mezi automaticky generovanými položkami",
        name: "Název",
        title: "Nadpis",
        cellType: "Typ buňky",
        colCount: "Počet sloupců",
        choicesOrder: "Vyberte pořadí voleb",
        visible: "Viditelná?",
        isRequired: "Povinná?",
        markRequired: "Označit podle potřeby",
        removeRequiredMark: "Odstraňte požadovanou značku",
        isAllRowRequired: "Povinná odpověď pro všechny řádky",
        eachRowUnique: "Zabránění duplicitním odpovědím v řádcích",
        requiredErrorText: "Text chyby pro povinnou otázku",
        startWithNewLine: "Začátek s novým řádkem?",
        rows: "Počet řádků",
        cols: "Počet sloupců",
        placeholder: "Vstupní zástupný text",
        showPreview: "Zobrazit oblast náhledu",
        storeDataAsText: "Uložit obsah souboru ve výsledku JSON jako text",
        maxSize: "Maximální velikost souboru v bajtech",
        rowCount: "Počet řádků",
        columnLayout: "Rozložení sloupců",
        addRowLocation: "Přidat umístění tlačítka řádku",
        transposeData: "Transponování řádků do sloupců",
        addRowText: "Přidat text tlačítka řádku",
        removeRowText: "Odebrat text tlačítka řádku",
        rateMin: "Minimální frekvence",
        rateMax: "Maximální frekvence",
        rateStep: "Krok frekvence",
        minRateDescription: "Popis minimální frekvence",
        maxRateDescription: "Popis maximální sazby",
        inputType: "Typ vstupu",
        optionsCaption: "Popisek možností",
        defaultValue: "Výchozí hodnota",
        cellsDefaultRow: "Výchozí texty buněk",
        surveyEditorTitle: "Upravit nastavení průzkumu",
        qEditorTitle: "Upravit: {0}",
        maxLength: "Maximální délka",
        buildExpression: "Vytvořit",
        editExpression: "Upravit",
        and: "a zároveň",
        or: "nebo",
        remove: "Odebrat",
        addCondition: "Přidat podmínku",
        emptyLogicPopupMessage: "Pro zahájení konfigurace podmínek vyberte otázku.",
        if: "Pokud",
        then: "pak",
        setToName: "Cílová otázka",
        fromName: "Otázka, ze které bude zkopírována odpověď",
        gotoName: "Přeskočit na otázku",
        ruleIsNotSet: "Pravidlo je chybné",
        includeIntoResult: "Zahrnout do výsledků průzkumu",
        showTitle: "Zobrazit/skrýt název",
        expandCollapseTitle: "Rozbalit/sbalit název",
        locale: "Výchozí jazyk",
        simulator: "Vybrat zařízení",
        landscapeOrientation: "Na šířku",
        portraitOrientation: "Přepnout orientaci na výšku",
        mode: "Režim (pouze pro úpravy/čtení)",
        clearInvisibleValues: "Vymazat neviditelné hodnoty",
        cookieName: "Název souboru cookie (pro zakázání dvojího lokálního spuštění průzkumu)",
        sendResultOnPageNext: "Odeslání výsledků průzkumu na další straně",
        storeOthersAsComment: "Uložení hodnoty „others“ do samostatného pole",
        showPageTitles: "Zobrazit názvy stránek",
        showPageNumbers: "Zobrazit čísla stránek",
        pagePrevText: "Text tlačítka předchozí stránky",
        pageNextText: "Text tlačítka další stránky",
        completeText: "Úplný text tlačítka",
        previewText: "Text tlačítka náhledu",
        editText: "Text tlačítka úpravy",
        startSurveyText: "Text tlačítka zahájení",
        showNavigationButtons: "Zobrazit navigační tlačítka (výchozí navigace)",
        showPrevButton: "Zobrazit předchozí tlačítko (uživatel se může vrátit na předchozí stránku)",
        firstPageIsStarted: "První stránka průzkumu je úvodní stránka.",
        showCompletedPage: "Zobrazení dokončené stránky na konci (completedHtml)",
        goNextPageAutomatic: "Po zodpovězení všech otázek automaticky přejít na další stránku",
        allowCompleteSurveyAutomatic: "Automatické vyplnění dotazníku",
        showProgressBar: "Zobrazit ukazatel průběhu",
        questionTitleLocation: "Umístění názvu otázky",
        questionTitleWidth: "Šířka názvu otázky",
        requiredText: "Povinné symboly otázky",
        questionTitleTemplate: "Šablona názvu otázky, výchozí je: „{no}. {require} {title}“",
        questionErrorLocation: "Umístění chyby v otázce",
        focusFirstQuestionAutomatic: "Zaměřte se na první otázku týkající se změny stránky",
        questionsOrder: "Pořadí prvků na stránce",
        maxTimeToFinish: "Maximální doba pro dokončení průzkumu",
        maxTimeToFinishPage: "Maximální doba pro dokončení stránky v průzkumu",
        showTimerPanel: "Zobrazit panel časovače",
        showTimerPanelMode: "Zobrazit režim panelu časovače",
        renderMode: "Režim vykreslování",
        allowAddPanel: "Povolit přidání panelu",
        allowRemovePanel: "Povolit odstranění panelu",
        panelAddText: "Přidávání textu na panel",
        panelRemoveText: "Odstraňování textu panelu",
        isSinglePage: "Zobrazit všechny prvky na jedné stránce",
        html: "HTML",
        setValue: "Odpověď",
        dataFormat: "Formát obrázku",
        allowAddRows: "Povolit přidání řádků",
        allowRemoveRows: "Povolit odstranění řádků",
        allowRowsDragAndDrop: "Povolit přetahování řádků",
        responsiveImageSizeHelp: "Nepoužije se, pokud specifikujete přesnou šířku nebo výšku obrázku.",
        minImageWidth: "Minimální šířka obrázku",
        maxImageWidth: "Maximální šířka obrázku",
        minImageHeight: "Minimální výška obrázku",
        maxImageHeight: "Maximální výška obrázku",
        minValue: "Minimální hodnota",
        maxValue: "Maximální hodnota",
        minLength: "Minimální délka",
        allowDigits: "Povolit číslice",
        minCount: "Minimální počet",
        maxCount: "Maximální počet",
        regex: "Pravidelný výraz",
        surveyvalidator: {
            text: "Chybová zpráva",
            expression: "Ověřovací výraz"
        },
        totalText: "Celkový text",
        totalType: "Celkový typ",
        totalExpression: "Celkový výraz",
        totalDisplayStyle: "Celkový styl zobrazení",
        totalCurrency: "Celková měna",
        totalFormat: "Celkový formát",
        logo: "Logo (URL nebo base64-kódovaný řetězec)",
        questionsOnPageMode: "Struktura průzkumu",
        maxTextLength: "Maximální délka odpovědi (v počtu znaků)",
        maxOthersLength: "Maximální délka komentáře (v počtu znaků)",
        commentAreaRows: "Výška oblasti komentářů (v řádcích)",
        autoGrowComment: "V případě potřeby automaticky rozbalit komentář",
        allowResizeComment: "Povolit uživatelům změnit velikost textových polí",
        textUpdateMode: "Aktualizovat hodnotu textové otázky",
        maskType: "Typ vstupní masky",
        maskTypes: {
            none: "Žádný",
            patternmask: "Vzor",
            numericmask: "Číselný",
            datetimemask: "Datum a čas",
            currencymask: "Měna"
        },
        focusOnFirstError: "Zvýraznit první neplatnou odpověď",
        checkErrorsMode: "Spustit ověření",
        navigateToUrl: "Přejít na URL",
        navigateToUrlOnCondition: "Dynamická URL",
        completedBeforeHtml: "Text, který se uživateli zobrazí v případě, kdy má již průzkum vyplněný",
        completedHtml: "Text, který se uživateli zobrazí po vyplnění průzkumu",
        completedHtmlOnCondition: "Dynamický text, který se uživateli zobrazí po vyplnění průzkumu",
        loadingHtml: "Text, který se zobrazí během načítání průzkumu",
        commentText: "Text komentáře",
        autocomplete: "Typ automatického vyplňování",
        labelTrue: "Popisek \"pravdivé\" hodnoty",
        labelFalse: "Popisek \"nepravdivé\" hodnoty",
        allowClear: "Zobrazit popisek možností",
        searchMode: "Režim vyhledávání",
        displayStyle: "Styl zobrazení hodnoty",
        format: "Formátovaný řetězec",
        maximumFractionDigits: "Maximální počet desetinných míst",
        minimumFractionDigits: "Minimální počet desetinných míst",
        useGrouping: "Zobrazit oddělovač tisíců",
        allowMultiple: "Povolit více souborů",
        allowImagesPreview: "Náhled obrázků",
        acceptedTypes: "Povolené typy souborů",
        waitForUpload: "Počkejte na dokončení nahrávání",
        needConfirmRemoveFile: "Potvrdit smazání souboru",
        detailPanelMode: "Umístění detailního panelu",
        minRowCount: "Minimální počet řádků",
        maxRowCount: "Maximální počet řádků",
        confirmDelete: "Potvrdit smazání řádku",
        confirmDeleteText: "Potvrzovací zpráva",
        panelCount: "Počáteční počet panelů",
        minPanelCount: "Minimální počet panelů",
        maxPanelCount: "Maximální počet panelů",
        panelsState: "Stav rozbalení vnitřního panelu",
        panelPrevText: "Nápověda pro tlačítko \"Předchozí panel\"",
        panelNextText: "Nápověda pro tlačítko \"Další panel\"",
        showRangeInProgress: "Zobrazit ukazatel postupu",
        panelRemoveButtonLocation: "Umístění tlačítka \"Odstranit panel\"",
        hideIfRowsEmpty: "Skrýt otázku, pokud neexistují žádné řádky",
        hideColumnsIfEmpty: "Skrýt sloupce, pokud neexistují žádné řádky",
        rateValues: "Vlastní hodnoty kurzu",
        rateCount: "Počet kurzů",
        autoGenerate: "Jak určit hodnoty kurzu?",
        hideIfChoicesEmpty: "Skrýt otázku, pokud neobsahuje žádné volby",
        minWidth: "Minimální šířka (v hodnotách akceptovaných CSS)",
        maxWidth: "Maximální šířka (v hodnotách akceptovaných CSS)",
        width: "Šířka (v hodnotách akceptovaných CSS)",
        showHeader: "Zobrazit záhlaví sloupce",
        horizontalScroll: "Zobrazit horizontální posuvník",
        columnMinWidth: "Minimální šířka sloupce (v hodnotách akceptovaných CSS)",
        rowTitleWidth: "Šířka záhlaví řádku (v hodnotách akceptovaných CSS)",
        valueTrue: "\"Pravdivá\" hodnota",
        valueFalse: "\"Nepravdivá\" hodnota",
        minErrorText: "Zpráva pro chybu \"Hodnota je nižší než minimální\"",
        maxErrorText: "Zpráva pro chybu \"Hodnota překračuje maximum\"",
        otherErrorText: "Zpráva pro chybu \"Prázdný komentář\"",
        keyDuplicationError: "Zpráva pro chybu \"Klíč není unikátní\"",
        minSelectedChoices: "Minimální vybrané volby",
        maxSelectedChoices: "Maximální počet vybraných možností",
        showClearButton: "Zobrazit tlačítko \"Vymazat\"",
        logoWidth: "Šířka loga (v hodnotách akceptovaných CSS)",
        logoHeight: "Výška loga (v hodnotách akceptovaných CSS)",
        readOnly: "Pouze pro čtení",
        enableIf: "Upravitelná pokud",
        emptyRowsText: "Zpráva \"Žádné řádky\"",
        separateSpecialChoices: "Oddělit speciální volby (žádná, ostatní, vybrat vše)",
        choicesFromQuestion: "Kopírovat volby z následující otázky",
        choicesFromQuestionMode: "Které volby zkopírovat?",
        progressBarShowPageTitles: "Zobrazení názvů stránek na ukazateli průběhu",
        progressBarShowPageNumbers: "Zobrazení čísel stránek na indikátoru průběhu",
        showCommentArea: "Zobrazit komentář",
        commentPlaceholder: "Zástupný text komentáře",
        displayRateDescriptionsAsExtremeItems: "Zobrazit popisy kurzů jako extrémní hodnoty",
        rowsOrder: "Pořadí řádků",
        columnsLayout: "Rozložení sloupce",
        columnColCount: "Počet vnořených sloupců",
        correctAnswer: "Správná odpověď",
        defaultPanelValue: "Výchozí hodnoty",
        cells: "Texty buněk",
        fileInputPlaceholder: "Vyberte soubor nebo vložte odkaz na soubor...",
        keyName: "Klíčový sloupec",
        itemvalue: {
            visibleIf: "Zviditelněte tuto možnost, pokud",
            enableIf: "Zajistěte, aby byla možnost vybratelná, pokud"
        },
        "itemvalue@rows": {
            visibleIf: "Zviditelněte řádek, pokud",
            enableIf: "Zajistěte, aby byl řádek upravitelný, pokud"
        },
        imageitemvalue: {
            text: "Alternativní text"
        },
        logoPosition: "Pozice loga",
        addLogo: "Přidat logo...",
        changeLogo: "Změnit logo...",
        logoPositions: {
            none: "Odstranit logo",
            left: "Vlevo",
            right: "Vpravo",
            top: "Nahoře",
            bottom: "Dole"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Rozvržení panelu"
            },
            general: "Obecné",
            fileOptions: "Možnosti",
            html: "Editor HTML",
            columns: "Sloupce",
            rows: "Řádky",
            choices: "Volby",
            items: "Položky",
            visibleIf: "Viditelná, pokud",
            enableIf: "Povolená, pokud",
            requiredIf: "Povinná, pokud",
            rateValues: "Hodnoty sazeb",
            choicesByUrl: "Volby z webu",
            matrixChoices: "Výchozí volby",
            multipleTextItems: "Textové vstupy",
            numbering: "Číslování",
            validators: "Validátory",
            navigation: "Navigace",
            question: "Otázka",
            pages: "Stránky",
            timer: "Časovač/kvíz",
            calculatedValues: "Vypočítané hodnoty",
            triggers: "Spouštěče",
            templateTitle: "Název šablony",
            totals: "Součty",
            logic: "Logika",
            mask: "Nastavení vstupní masky",
            layout: {
                panel: "Rozložení",
                question: "Rozložení",
                base: "Rozložení"
            },
            data: "Data",
            validation: "Ověřování",
            cells: "Buňky",
            showOnCompleted: "Zobrazit na stránce Dokončeno",
            logo: "Logo v názvu průzkumu",
            slider: "Posuvník",
            expression: "Výraz",
            questionSettings: "Nastavení otázek",
            header: "Záhlaví",
            background: "Pozadí",
            appearance: "Vzhled",
            others: "Ostatní"
        },
        editProperty: "Upravit vlastnost „{0}“",
        items: "[ Položky: {0} ]",
        choicesVisibleIf: "Volby jsou viditelné, pokud",
        choicesEnableIf: "Volby jsou volitelné, pokud",
        columnsEnableIf: "Sloupce jsou viditelné, pokud",
        rowsEnableIf: "Řádky jsou viditelné, pokud",
        innerIndent: "Přidat vnitřní odsazení",
        defaultValueFromLastRow: "Vzít výchozí hodnoty z posledního řádku",
        defaultValueFromLastPanel: "Vzít výchozí hodnoty z posledního panelu",
        enterNewValue: "Zadejte hodnotu.",
        noquestions: "V průzkumu není žádná otázka.",
        createtrigger: "Vytvořte spouštěč",
        titleKeyboardAdornerTip: "Zadejte tlačítko k úpravě",
        keyboardAdornerTip: "Stisknutím klávesy enter upravíte položku, stisknutím klávesy delete položku odstraníte, stisknutím klávesy alt plus šipky nahoru nebo šipky dolů položku přesunete.",
        triggerOn: "Zapnout ",
        triggerMakePagesVisible: "Zobrazit stránky:",
        triggerMakeQuestionsVisible: "Zobrazit prvky:",
        triggerCompleteText: "Vyplňte průzkum, pokud se vám to podaří.",
        triggerNotSet: "Spouštěč není nastaven",
        triggerRunIf: "Spustit, pokud",
        triggerSetToName: "Změnit hodnotu: ",
        triggerFromName: "Zkopírovat hodnotu z: ",
        triggerRunExpression: "Spustit tento výraz:",
        triggerSetValue: "do: ",
        triggerGotoName: "Přejít na otázku:",
        triggerIsVariable: "Nevkládejte proměnnou do výsledku průzkumu.",
        triggerRunExpressionEmpty: "Zadejte platný výraz",
        emptyExpressionPlaceHolder: "Zde napište výraz...",
        noFile: "Nebyl vybrán žádný soubor",
        clearIfInvisible: "Vymazat hodnotu, pokud se otázka skryje",
        valuePropertyName: "Název hodnotové vlastnosti",
        searchEnabled: "Povolit vyhledávání",
        hideSelectedItems: "Skrýt vybrané položky",
        closeOnSelect: "Po výběru zavřít rozbalovací nabídku",
        verticalAlign: "Vertikální zarovnání",
        alternateRows: "Alternativní řádky",
        columnsVisibleIf: "Sloupce jsou viditelné, pokud",
        rowsVisibleIf: "Řádky jsou viditelné, pokud",
        otherPlaceholder: "Zástupný text komentáře",
        filePlaceholder: "Text zástupného symbolu souboru",
        photoPlaceholder: "Text zástupného symbolu fotografie",
        fileOrPhotoPlaceholder: "Zástupný text souboru nebo fotografie",
        rateType: "Typ sazby",
        url_placeholder: "Př.: https://api.example.com/books",
        path_placeholder: "Př.: categories.fiction",
        questionStartIndex_placeholder: "Př.: a)",
        width_placeholder: "Př.: 6in",
        minWidth_placeholder: "Př.: 600px",
        maxWidth_placeholder: "Př.: 50%",
        imageHeight_placeholder: "automaticky",
        imageWidth_placeholder: "automaticky",
        theme: {
            themeName: "Téma",
            isPanelless: "Vzhled otázky",
            editorPanel: "Pozadí a poloměr rohů",
            questionPanel: "Pozadí a poloměr rohů",
            primaryColor: "Barva zvýraznění",
            panelBackgroundTransparency: "Neprůhlednost pozadí panelu",
            questionBackgroundTransparency: "Neprůhlednost pozadí otázky",
            fontSize: "Velikost písma",
            scale: "Škála",
            cornerRadius: "Poloměr rohu",
            pageTitle: "Písmo nadpisu",
            pageDescription: "Popisné písmo",
            questionTitle: "Písmo nadpisu",
            questionDescription: "Popisné písmo",
            editorFont: "Písmo",
            backgroundOpacity: "Neprůhlednost",
            "--sjs-font-family": "Rodina písem",
            "--sjs-general-backcolor-dim": "Barva pozadí",
            "--sjs-primary-backcolor": "Zvýraznění pozadí",
            "--sjs-primary-forecolor": "Zvýraznění popředí",
            "--sjs-special-red": "Chybové zprávy",
            "--sjs-shadow-small": "Stínové efekty",
            "--sjs-shadow-inner": "Stínové efekty",
            "--sjs-border-default": "Barvy"
        },
        "header@header": {
            headerView: "Pohled",
            logoPosition: "Umístění loga",
            surveyTitle: "Písmo názvu průzkumu",
            surveyDescription: "Písmo popisu průzkumu",
            headerTitle: "Písmo názvu průzkumu",
            headerDescription: "Písmo popisu průzkumu",
            inheritWidthFrom: "Šířka oblasti obsahu",
            textAreaWidth: "Šířka textu",
            backgroundColorSwitch: "Barva pozadí",
            backgroundImage: "Obrázek na pozadí",
            backgroundImageOpacity: "Neprůhlednost",
            overlapEnabled: "Překrytí",
            logoPositionX: "Umístění loga",
            titlePositionX: "Pozice v titulu",
            descriptionPositionX: "Popis pozice"
        }
    },
    // Property values
    pv: {
        "true": "pravda",
        "false": "nepravda",
        file: "Místní soubory",
        camera: "Fotoaparát",
        "file-camera": "Místní soubory nebo fotoaparát",
        inherit: "zdědit",
        show: "zobrazit",
        hide: "skrýt",
        default: "výchozí",
        initial: "úvodní",
        random: "náhodný",
        collapsed: "sbalený",
        expanded: "rozbalený",
        none: "žádný",
        asc: "vzestupný",
        desc: "sestupný",
        indeterminate: "neurčitý",
        selected: "Vybraný",
        unselected: "Nezvolený",
        decimal: "desetinné číslo",
        currency: "měna",
        percent: "procento",
        firstExpanded: "firstExpanded",
        off: "vypnout",
        list: "seznam",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        tab: "Záložky",
        horizontal: "horizontální",
        vertical: "vertikální",
        top: "nahoře",
        bottom: "dole",
        topBottom: "nahoře a dole",
        both: "obě",
        left: "vlevo",
        right: "Pravá",
        center: "Střed",
        leftRight: "Vlevo a vpravo",
        middle: "Prostřední",
        color: "barva",
        date: "datum",
        datetime: "datum a čas",
        "datetime-local": "datum a čas - lokální",
        email: "email",
        month: "měsíc",
        number: "číslo",
        password: "heslo",
        range: "rozsah",
        tel: "tel",
        text: "text",
        time: "čas",
        url: "url",
        week: "týden",
        hidden: "skrytý",
        edit: "upravit",
        display: "zobrazit",
        contain: "Obsahovat",
        cover: "Krýt",
        fill: "Vyplnit",
        next: "Další",
        last: "Poslední",
        onComplete: "onComplete",
        onHidden: "onHidden",
        onHiddenContainer: "Když se otázka nebo její panel/stránka skryje",
        clearInvisibleValues: {
            none: "Nikdy"
        },
        clearIfInvisible: {
            none: "Nikdy"
        },
        inputType: {
            color: "Barva",
            date: "Datum",
            "datetime-local": "Datum a čas",
            email: "Email",
            month: "Měsíc",
            number: "Číslo",
            password: "Heslo",
            range: "Rozsah",
            tel: "Telefon",
            text: "Text",
            time: "Čas",
            url: "URL",
            week: "Týden"
        },
        all: "vše",
        page: "stránka",
        survey: "průzkum",
        onNextPage: "onNextPage",
        onValueChanged: "onValueChanged",
        onValueChanging: "onValueChanging",
        questionsOnPageMode: {
            standard: "Původní struktura",
            singlePage: "Zobrazit všechny otázky na jedné stránce",
            questionPerPage: "Zobrazit jednu otázku na stránku"
        },
        noPreview: "bez náhledu",
        showAllQuestions: "zobrazit náhled se všemi otázkami",
        showAnsweredQuestions: "zobrazit náhled se zodpovězenými otázkami",
        pages: "stránky",
        questions: "otázky",
        requiredQuestions: "Odpovězené povinné otázky",
        correctQuestions: "správné otázky",
        buttons: "tlačítka",
        underInput: "pod vstupem",
        underTitle: "pod nadpisem",
        onBlur: "Při ztrátě zvýraznění",
        onTyping: "Během psaní",
        underRow: "Pod řádkem",
        underRowSingle: "Pod řádkem, pouze jeden panel je viditelný",
        auto: "Auto",
        showNavigationButtons: {
            none: "Skrytý"
        },
        showTimerPanel: {
            none: "Skrytý"
        },
        showTimerPanelMode: {
            all: "Obě"
        },
        addRowLocation: {
            default: "Závisí na rozložení matice"
        },
        panelsState: {
            default: "Uživatelé nemohou rozbalit nebo sbalit panely",
            collapsed: "Všechny panely jsou sbaleny",
            expanded: "Všechny panely jsou rozbaleny",
            firstExpanded: "První rozšířeno"
        },
        widthMode: {
            static: "Statický",
            responsive: "Responzivní"
        },
        contentMode: {
            image: "Obrázek",
            video: "Video",
            youtube: "YouTube"
        },
        displayMode: {
            buttons: "Tlačítka",
            dropdown: "Rozbalovací nabídka"
        },
        rateColorMode: {
            default: "Výchozí",
            scale: "Škála"
        },
        scaleColorMode: {
            monochrome: "Monochromatický",
            colored: "Barevný"
        },
        autoGenerate: {
            "true": "Generovat",
            "false": "Vložit ručně"
        },
        rateType: {
            labels: "Popisky",
            stars: "Hvězdy",
            smileys: "Smajlíci"
        },
        state: {
            default: "Zamčený"
        },
        showQuestionNumbers: {
            default: "Automatické číslování",
            on: "Automatické číslování",
            onPage: "Resetovat na každé stránce",
            onpanel: "Resetovat na každém panelu",
            onPanel: "Resetovat na každém panelu",
            onSurvey: "Pokračovat v průzkumu",
            off: "Žádné číslování"
        },
        descriptionLocation: {
            underTitle: "Pod nadpisem otázky",
            underInput: "Pod vstupním polem"
        },
        selectToRankAreasLayout: {
            horizontal: "Vedle voleb",
            vertical: "Výše uvedené možnosti"
        },
        displayStyle: {
            decimal: "Desetinný",
            currency: "Měna",
            percent: "Procento",
            date: "Rande"
        },
        totalDisplayStyle: {
            decimal: "Desetinný",
            currency: "Měna",
            percent: "Procento",
            date: "Rande"
        },
        rowsOrder: {
            initial: "Původní"
        },
        questionsOrder: {
            initial: "Původní"
        },
        showProgressBar: {
            off: "Skrytý",
            topbottom: "nahoře a dole",
            aboveheader: "Nad záhlavím",
            belowheader: "Pod záhlavím"
        },
        sum: "Součet",
        count: "Počítat",
        min: "Min",
        max: "Max",
        avg: "Průměr",
        searchMode: {
            contains: "Obsahuje",
            startsWith: "Začíná na"
        },
        backgroundImageFit: {
            auto: "Auto",
            cover: "Krýt",
            contain: "Obsahovat",
            fill: "Natáhnout",
            tile: "Dlaždice"
        },
        backgroundImageAttachment: {
            fixed: "Stabilní",
            scroll: "Svitek"
        },
        headerView: {
            basic: "Základní",
            advanced: "Pokročilý"
        },
        inheritWidthFrom: {
            survey: "Stejné jako průzkum",
            container: "Vhodné pro kontejner"
        },
        backgroundColorSwitch: {
            none: "Žádný",
            accentColor: "Barva zvýraznění",
            custom: "Zvyk"
        },
        colorPalette: {
            light: "Světlo",
            dark: "Temný"
        },
        isPanelless: {
            "false": "Výchozí",
            "true": "Bez panelů"
        }
    },
    // Operators
    op: {
        empty: "je prázdný",
        notempty: "není prázdný",
        equal: "se rovná",
        notequal: "se nerovná",
        contains: "obsahuje",
        notcontains: "neobsahuje",
        anyof: "žádný z",
        allof: "všechny",
        greater: "větší",
        less: "nižší",
        greaterorequal: "větší nebo se rovná",
        lessorequal: "nižší nebo se rovná",
        and: "a zároveň",
        or: "nebo"
    },
    // Embed window
    ew: {
        angular: "Použít verzi Angular",
        jquery: "Použít verzi jQuery",
        knockout: "Použít verzi Knockout",
        react: "Použít verzi React",
        vue: "Použít verzi Vue",
        bootstrap: "Pro framework bootstrap",
        modern: "Moderní motiv",
        default: "Výchozí motiv",
        orange: "Oranžový motiv",
        darkblue: "Tmavěmodrý motiv",
        darkrose: "Tmavěrůžový motiv",
        stone: "Kamenný motiv",
        winter: "Zimní motiv",
        winterstone: "Téma zima-kámen",
        showOnPage: "Zobrazit průzkum na stránce",
        showInWindow: "Zobrazit průzkum v okně",
        loadFromServer: "Načíst průzkum JSON ze serveru",
        titleScript: "Skripty a styly",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Vyberte stránku a otestujte ji:",
        showInvisibleElements: "Zobrazit neviditelné prvky",
        hideInvisibleElements: "Skrýt neviditelné prvky"
    },
    validators: {
        answercountvalidator: "počet odpovědí",
        emailvalidator: "e-mail",
        expressionvalidator: "výraz",
        numericvalidator: "Číslo",
        regexvalidator: "regex",
        textvalidator: "text"
    },
    triggers: {
        completetrigger: "dokončit průzkum",
        setvaluetrigger: "nastavit hodnotu",
        copyvaluetrigger: "zkopírovat hodnotu",
        skiptrigger: "přeskočit na otázku",
        runexpressiontrigger: "spustit výraz",
        visibletrigger: "změnit viditelnost (zastaralé)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Př.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Př.: dd/mm/rrrr"
        },
        currencymask: {
            prefix: "Př.: $",
            suffix: "Př.: USD"
        },
        panelbase: {
            questionTitleWidth: "Př.: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "ID panelu, které není viditelné pro respondenty.",
            description: "Zadejte titulky panelu.",
            visibleIf: "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje viditelnost panelu.",
            enableIf: "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které pro panel zakáže režim jen pro čtení.",
            requiredIf: "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které zabrání odeslání průzkumu, pokud alespoň jedna vnořená otázka nemá odpověď.",
            questionTitleLocation: "Platí pro všechny otázky v rámci tohoto panelu. Chcete-li toto nastavení přepsat, definujte pravidla zarovnání nadpisů pro jednotlivé otázky. Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu (ve výchozím nastavení \"Nahoře\").",
            questionTitleWidth: "Nastaví konzistentní šířku názvů otázek, pokud jsou zarovnány nalevo od polí s otázkami. Přijímá hodnoty CSS (px, %, in, pt atd.).",
            questionErrorLocation: "Nastaví umístění chybové zprávy ve vztahu ke všem otázkám v panelu. Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu.",
            questionsOrder: "Zachová původní pořadí otázek nebo je náhodně vybere. Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu.",
            page: "Přemístí panel na konec vybrané stránky.",
            innerIndent: "Přidá mezeru nebo okraj mezi obsah panelu a levý okraj rámečku panelu.",
            startWithNewLine: "Zrušte výběr, chcete-li panel zobrazit v jednom řádku s předchozí otázkou nebo panelem. Nastavení se nepoužije, pokud je panel prvním prvkem ve formuláři.",
            state: "Vyberte si z: \"Rozbalený\" - panel se zobrazí celý a lze jej sbalit; \"Sbaleno\" - panel zobrazuje pouze název a popis a lze jej rozbalit; \"Zamčeno\" - obraz je zobrazen celý a nelze jej sbalit.",
            width: "Nastaví šířku panelu v poměru k ostatním prvkům zaměření ve stejném řádku. Přijímá hodnoty CSS (px, %, in, pt atd.)."
        },
        paneldynamic: {
            name: "ID panelu, které není viditelné pro respondenty.",
            description: "Zadejte titulky panelu.",
            visibleIf: "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje viditelnost panelu.",
            enableIf: "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které pro panel zakáže režim jen pro čtení.",
            requiredIf: "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které zabrání odeslání průzkumu, pokud alespoň jedna vnořená otázka nemá odpověď.",
            templateTitleLocation: "Platí pro všechny otázky v rámci tohoto panelu. Chcete-li toto nastavení přepsat, definujte pravidla zarovnání nadpisů pro jednotlivé otázky. Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu (ve výchozím nastavení \"Nahoře\").",
            templateErrorLocation: "Nastaví umístění chybové zprávy ve vztahu k otázce s neplatným vstupem. Vyberte si mezi: \"Nahoře\" - text chyby je umístěn v horní části pole s otázkou; \"Bottom\" - text chyby je umístěn ve spodní části pole s otázkou. Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu (ve výchozím nastavení \"Nahoře\").",
            errorLocation: "Nastaví umístění chybové zprávy ve vztahu ke všem otázkám v panelu. Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu.",
            page: "Přemístí panel na konec vybrané stránky.",
            innerIndent: "Přidá mezeru nebo okraj mezi obsah panelu a levý okraj rámečku panelu.",
            startWithNewLine: "Zrušte výběr, chcete-li panel zobrazit v jednom řádku s předchozí otázkou nebo panelem. Nastavení se nepoužije, pokud je panel prvním prvkem ve formuláři.",
            state: "Vyberte si z: \"Rozbalený\" - panel se zobrazí celý a lze jej sbalit; \"Sbaleno\" - panel zobrazuje pouze název a popis a lze jej rozbalit; \"Zamčeno\" - obraz je zobrazen celý a nelze jej sbalit.",
            width: "Nastaví šířku panelu v poměru k ostatním prvkům zaměření ve stejném řádku. Přijímá hodnoty CSS (px, %, in, pt atd.).",
            templateTitle: "Zadejte šablonu pro dynamické názvy panelů. Použijte {panelIndex} pro obecnou pozici panelu a {visiblePanelIndex} pro jeho pořadí mezi viditelnými panely. Vložením těchto zástupných symbolů do vzorku přidáte automatické číslování.",
            templateTabTitle: "Zadejte šablonu pro názvy karet. Použijte {panelIndex} pro obecnou pozici panelu a {visiblePanelIndex} pro jeho pořadí mezi viditelnými panely. Vložením těchto zástupných symbolů do vzorku přidáte automatické číslování.",
            tabTitlePlaceholder: "Záložní text pro názvy karet, který se použije, když vzor názvu karty nevytváří smysluplnou hodnotu.",
            templateVisibleIf: "Toto nastavení umožňuje řídit viditelnost jednotlivých panelů v rámci dynamického panelu. Pomocí zástupného symbolu {panel} můžete odkazovat na aktuální panel ve výrazu.",
            titleLocation: "Toto nastavení je automaticky převzato všemi otázkami v tomto panelu. Chcete-li toto nastavení přepsat, definujte pravidla zarovnání nadpisů pro jednotlivé otázky. Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu (ve výchozím nastavení \"Nahoře\").",
            descriptionLocation: "Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu (ve výchozím nastavení \"Pod názvem panelu\").",
            newPanelPosition: "Definuje polohu nově přidaného panelu. Ve výchozím nastavení se nové panely přidávají na konec. Výběrem možnosti \"Další\" vložíte nový panel za aktuální.",
            defaultValueFromLastPanel: "Duplikuje odpovědi z posledního panelu a přiřadí je dalšímu přidanému dynamickému panelu.",
            keyName: "Odkazujte na název otázky, chcete-li vyžadovat, aby uživatel na tuto otázku v každém panelu poskytl jedinečnou odpověď."
        },
        defaultValueExpression: "Toto nastavení umožňuje přiřadit výchozí hodnotu odpovědi na základě výrazu. Výraz může obsahovat základní výpočty - '{q1_id} + {q2_id}', logické výrazy, například '{age} > 60', a funkce: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' atd. Hodnota určená tímto výrazem slouží jako počáteční výchozí hodnota, kterou lze přepsat ručním zadáním respondenta.",
        resetValueIf: "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje, kdy se vstup respondenta resetuje na hodnotu na základě \"Výrazu výchozí hodnoty\" nebo \"Výrazu nastavit hodnotu\" nebo na hodnotu \"Výchozí odpověď\" (pokud je nastavena kterákoli z nich).",
        setValueIf: "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje, kdy se má spustit výraz \"Nastavit hodnotu\", a dynamicky přiřadit výslednou hodnotu jako odpověď.",
        setValueExpression: "Zadejte výraz, který definuje hodnotu, která má být nastavena, když jsou splněny podmínky v pravidle \"Nastavit hodnotu, pokud\". Výraz může obsahovat základní výpočty - '{q1_id} + {q2_id}', logické výrazy, například '{age} > 60', a funkce: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' atd. Hodnota určená tímto výrazem může být přepsána ručním zadáním respondenta.",
        question: {
            name: "ID otázky, které respondenti nevidí.",
            description: "Zadejte podnadpis otázky.",
            visibleIf: "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje viditelnost otázky.",
            enableIf: "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které pro otázku zakáže režim jen pro čtení.",
            requiredIf: "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které zabrání postupu nebo odeslání průzkumu, pokud otázka neobdržela odpověď.",
            startWithNewLine: "Zrušte výběr, chcete-li otázku zobrazit v jednom řádku s předchozí otázkou nebo panelem. Nastavení se nepoužije, pokud je otázka prvním prvkem ve formuláři.",
            page: "Přemístí otázku na konec vybrané stránky.",
            state: "Vyberte si z: \"Rozbalené\" - pole s otázkou se zobrazí celé a lze jej sbalit; \"Sbaleno\" - pole s otázkou zobrazuje pouze název a popis a lze jej rozbalit; \"Zamčeno\" - pole s otázkou je zobrazeno celé a nelze jej sbalit.",
            titleLocation: "Přepíše pravidla zarovnání nadpisů definovaná na úrovni panelu, stránky nebo průzkumu. Možnost \"Zdědit\" použije všechna nastavení vyšší úrovně (pokud je nastavena) nebo nastavení na úrovni průzkumu (ve výchozím nastavení \"Nahoře\").",
            descriptionLocation: "Možnost \"Zdědit\" použije nastavení na úrovni průzkumu (ve výchozím nastavení \"Pod názvem otázky\").",
            errorLocation: "Nastaví umístění chybové zprávy ve vztahu k otázce s neplatným vstupem. Vyberte si mezi: \"Nahoře\" - text chyby je umístěn v horní části pole s otázkou; \"Bottom\" - text chyby je umístěn ve spodní části pole s otázkou. Možnost \"Zdědit\" použije nastavení na úrovni průzkumu (ve výchozím nastavení \"Nahoře\").",
            indent: "Přidá mezeru nebo okraj mezi obsah otázky a levý okraj pole otázky.",
            width: "Nastaví šířku otázky v poměru k ostatním prvkům průzkumu ve stejném řádku. Přijímá hodnoty CSS (px, %, in, pt atd.).",
            surveyvalidator: {
                expression: "Pomocí ikony kouzelné hůlky nastavte ověřovací pravidlo pro otázku."
            },
            textUpdateMode: "Vyberte si z těchto možností: \"Při ztrátě fokusu\" - hodnota se aktualizuje, když vstupní pole ztratí fokus; \"Při psaní\" - hodnota se aktualizuje v reálném čase, jak uživatelé píší. Možnost \"Zdědit\" použije nastavení na úrovni průzkumu (ve výchozím nastavení \"Při ztrátě fokusu\").",
            url: "Jako zdroj dat pro otázky s výběrem odpovědí můžete použít libovolnou webovou službu. Pokud chcete naplnit hodnoty voleb, zadejte adresu URL služby, která data poskytuje.",
            searchMode: "Operace porovnání, která se používá k filtrování rozevíracího seznamu.",
            textWrapEnabled: "Dlouhé texty v možnostech volby automaticky vygenerují zalomení řádků, aby se vešly do rozbalovací nabídky. Odznačte, pokud chcete, aby se texty ořízly."
        },
        signaturepad: {
            signatureWidth: "Nastaví šířku zobrazené oblasti podpisu a výsledného obrazu.",
            signatureHeight: "Nastaví výšku zobrazené oblasti podpisu a výsledného obrazu.",
            signatureAutoScaleEnabled: "Vyberte, zda chcete, aby oblast podpisu vyplnila veškerý dostupný prostor v poli pro otázky při zachování výchozího poměru stran 3:2. Pokud jsou nastaveny vlastní hodnoty šířky a výšky, nastavení zachová poměr stran těchto rozměrů."
        },
        file: {
            imageHeight: "Upraví výšku obrázku ve výsledcích měření.",
            imageWidth: "Upraví šířku obrázku ve výsledcích měření."
        },
        image: {
            contentMode: "Možnost \"Auto\" automaticky určí vhodný režim pro zobrazení – Obrázek, Video nebo YouTube – na základě zadané zdrojové adresy URL."
        },
        imagepicker: {
            imageHeight: "Přepíše minimální a maximální hodnoty výšky.",
            imageWidth: "Přepíše minimální a maximální hodnoty šířky.",
            choices: "\"Hodnota\" slouží jako ID položky používané v podmíněných pravidlech; Respondentům se zobrazí \"Text\".",
            contentMode: "Vyberte si mezi \"Obrazem\" a \"Video\" a nastavte režim obsahu voliče médií. Pokud je vybrána možnost \"Obrázek\", ujistěte se, že všechny nabízené možnosti jsou obrazové soubory v následujících formátech: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Podobně, pokud je vybráno \"Video\", ujistěte se, že všechny možnosti jsou přímými odkazy na video soubory v následujících formátech: MP4, MOV, WMV, FLV, AVI, MKV. Upozorňujeme, že odkazy na YouTube nejsou podporovány u možností videa."
        },
        text: {
            size: "Toto nastavení pouze mění velikost vstupního pole a nemá vliv na šířku pole s otázkou. Chcete-li omezit přijatelnou délku vstupu, přejděte na <b>Ověření → Maximální limit znaků</b>."
        },
        comment: {
            rows: "Nastaví počet zobrazených řádků ve vstupním poli. Pokud vstup zabírá více řádků, zobrazí se posuvník."
        },
        // survey templates
        survey: {
            mode: "Vyberte si mezi: \"Upravitelné\" - umožňuje respondentům vyplnit váš průzkum; \"Read-only\" - zakáže editaci formulářů."
        },
        matrixdropdowncolumn: {
            name: "ID sloupce, které není viditelné pro respondenty.",
            isUnique: "Pokud je tato možnost povolena pro sloupec, respondent musí poskytnout jedinečnou odpověď na každou otázku v tomto sloupci.",
            rows: "Nastaví počet zobrazených řádků ve vstupním poli. Pokud vstup zabírá více řádků, zobrazí se posuvník.",
            visibleIf: "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje viditelnost sloupce.",
            enableIf: "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které zakáže režim jen pro čtení pro sloupec.",
            requiredIf: "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které zabrání odeslání průzkumu, pokud alespoň jedna vnořená otázka nemá odpověď.",
            showInMultipleColumns: "Pokud je tato možnost vybraná, vytvoří samostatný sloupec pro každou možnost volby."
        },
        widthMode: "Vyberte si z: \"Statické\" - nastaví pevnou šířku; \"Responzivní\" - způsobí, že průzkum bude zabírat celou šířku obrazovky; \"Auto\" – použije jednu z těchto dvou možností v závislosti na použitých typech otázek.",
        cookieName: "Cookies brání uživatelům vyplnit průzkum vícekrát.",
        logo: "Vložte odkaz na obrázek (bez omezení velikosti) nebo klikněte na ikonu složky a procházejte soubor z počítače (až 64 kB).",
        logoWidth: "Nastaví šířku loga v jednotkách CSS (px, %, in, pt atd.).",
        logoHeight: "Nastaví výšku loga v jednotkách CSS (px, %, in, pt atd.).",
        logoFit: "Vyberte si z těchto možností: \"Žádné\" - obrázek si zachová svou původní velikost; \"Obsahovat\" - velikost obrázku se změní tak, aby se vešel při zachování poměru stran; \"Obálka\" - obrázek vyplní celý rámeček při zachování poměru stran; \"Výplň\" - obrázek je roztažen tak, aby vyplnil rámeček bez zachování poměru stran.",
        goNextPageAutomatic: "Vyberte, zda chcete, aby průzkum automaticky postoupil na další stránku poté, co respondent odpoví na všechny otázky na aktuální stránce.",
        allowCompleteSurveyAutomatic: "Vyberte, zda chcete, aby se průzkum vyplnil automaticky poté, co respondent odpoví na všechny otázky.",
        showNavigationButtons: "Nastaví viditelnost a umístění navigačních tlačítek na stránce.",
        showProgressBar: "Nastaví viditelnost a umístění indikátoru průběhu. Hodnota \"Auto\" zobrazuje indikátor průběhu nad nebo pod záhlavím průzkumu.",
        showPreviewBeforeComplete: "Povolte stránku náhledu pouze se všemi nebo zodpovězenými otázkami.",
        questionTitleLocation: "Platí pro všechny otázky v rámci průzkumu. Toto nastavení lze přepsat pravidly zarovnání nadpisů na nižších úrovních: panel, stránka nebo otázka. Nastavení nižší úrovně přepíše nastavení na vyšší úrovni.",
        requiredText: "Symbol nebo posloupnost symbolů označující, že je vyžadována odpověď.",
        questionStartIndex: "Zadejte číslo nebo písmeno, kterým chcete začít číslovat.",
        questionErrorLocation: "Nastaví umístění chybové zprávy ve vztahu k otázce s neplatným vstupem. Vyberte si mezi: \"Nahoře\" - text chyby je umístěn v horní části pole s otázkou; \"Bottom\" - text chyby je umístěn ve spodní části pole s otázkou.",
        focusFirstQuestionAutomatic: "Vyberte, zda chcete, aby první vstupní pole na každé stránce bylo připraveno pro zadání textu.",
        questionsOrder: "Zachová původní pořadí otázek nebo je náhodně vybere. Účinek tohoto nastavení je viditelný pouze na kartě Náhled.",
        maxTextLength: "Pouze pro otázky pro zadávání textu.",
        maxOthersLength: "Pouze pro komentáře k otázkám.",
        commentAreaRows: "Nastaví počet zobrazených řádků v textových oblastech pro komentáře k otázkám. V případě, že vstup zabírá více řádků, zobrazí se posuvník.",
        autoGrowComment: "Vyberte, zda chcete, aby se komentáře k otázkám a otázky s dlouhým textem automaticky zvětšovaly na výšku podle zadané délky textu.",
        allowResizeComment: "Pouze pro komentáře k otázkám a otázky s dlouhým textem.",
        calculatedValues: "Vlastní proměnné slouží jako mezilehlé nebo pomocné proměnné používané při výpočtech formulářů. Jako zdrojové hodnoty berou vstupy respondentů. Každá vlastní proměnná má jedinečný název a výraz, na kterém je založena.",
        includeIntoResult: "Vyberte, zda chcete, aby byla vypočtená hodnota výrazu uložena spolu s výsledky průzkumu.",
        triggers: "Aktivační událost je událost nebo podmínka, která je založena na výrazu. Jakmile je výraz vyhodnocen jako \"true\", trigger spustí akci. Taková akce může mít volitelně cílovou otázku, kterou ovlivňuje.",
        clearInvisibleValues: "Zvolte, zda chcete vymazat hodnoty otázek skrytých podmíněnou logikou a kdy to udělat.",
        textUpdateMode: "Vyberte si z těchto možností: \"Při ztrátě fokusu\" - hodnota se aktualizuje, když vstupní pole ztratí fokus; \"Při psaní\" - hodnota se aktualizuje v reálném čase, jak uživatelé píší.",
        columns: "Levá hodnota slouží jako ID sloupce používané v podmíněných pravidlech, pravá hodnota se zobrazuje respondentům.",
        rows: "Levá hodnota slouží jako ID řádku používané v podmíněných pravidlech, pravá hodnota se zobrazuje respondentům.",
        columnMinWidth: "Přijímá hodnoty CSS (px, %, in, pt atd.).",
        rowTitleWidth: "Přijímá hodnoty CSS (px, %, in, pt atd.).",
        totalText: "Viditelné pouze v případě, že alespoň jeden sloupec je typu suma nebo obsahuje sumarizační výraz.",
        cellErrorLocation: "Nastaví umístění chybové zprávy ve vztahu k buňce s neplatným vstupem. Možnost \"Zdědit\" použije nastavení z vlastnosti \"Zarovnání chybové zprávy\".",
        keyDuplicationError: "Pokud je povolena vlastnost \"Zabránit duplicitním odpovědím\", respondentovi, který se pokouší odeslat duplicitní záznam, se zobrazí následující chybová zpráva.",
        totalExpression: "Umožňuje vypočítat celkové hodnoty na základě výrazu. Výraz může obsahovat základní výpočty ('{q1_id} + {q2_id}'), logické výrazy ('{age} > 60') a funkce ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' atd.).",
        confirmDelete: "Spustí výzvu s žádostí o potvrzení odstranění řádku.",
        defaultValueFromLastRow: "Duplikuje odpovědi z posledního řádku a přiřadí je k dalšímu přidanému dynamickému řádku.",
        keyName: "Pokud zadaný sloupec obsahuje totožné hodnoty, průzkum vyhodí chybu „Klíč není unikátní“.",
        description: "Zadejte titulky.",
        locale: "Vyberte jazyk a začněte vytvářet průzkum. Chcete-li přidat překlad, přepněte do nového jazyka a přeložte původní text zde nebo na kartě Překlady.",
        detailPanelMode: "Nastaví umístění oddílu podrobností ve vztahu k řádku. Vyberte si z těchto možností: \"Žádné\" - není přidáno žádné rozšíření; \"Pod řádkem\" - pod každým řádkem matice je umístěno rozšíření řádku; \"Pod řádkem zobrazit pouze jedno rozšíření řádku\" - rozšíření je zobrazeno pouze pod jedním řádkem, zbývající rozšíření řádků jsou sbalena.",
        imageFit: "Vyberte si z těchto možností: \"Žádné\" - obrázek si zachová svou původní velikost; \"Obsahovat\" - velikost obrázku se změní tak, aby se vešel při zachování poměru stran; \"Obálka\" - obrázek vyplní celý rámeček při zachování poměru stran; \"Výplň\" - obrázek je roztažen tak, aby vyplnil rámeček bez zachování poměru stran.",
        autoGrow: "Postupně zvětšuje výšku vstupního pole při zadávání dat. Přepíše nastavení \"Výška vstupního pole (v řádcích)\".",
        allowResize: "Úchyt pro změnu velikosti (nebo uzel) se zobrazí v rohu a lze jej přetáhnout a změnit tak velikost vstupního pole.",
        maxTimeToFinish: "Časový interval v sekundách, po jehož uplynutí se průzkum automaticky přesune na stránku s poděkováním.",
        maxTimeToFinishPage: "Časový interval v sekundách, po jehož uplynutí se průzkum automaticky přesune na další stránku.",
        page: {
            maxTimeToFinish: "Časový interval v sekundách, po jehož uplynutí se průzkum automaticky přesune na další stránku.",
            visibleIf: "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje viditelnost stránky.",
            enableIf: "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které zakáže režim pouze pro čtení stránky.",
            requiredIf: "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které zabrání odeslání průzkumu, pokud alespoň jedna vnořená otázka nemá odpověď.",
            questionTitleLocation: "Platí pro všechny otázky na této stránce. Chcete-li toto nastavení přepsat, definujte pravidla zarovnání nadpisů pro jednotlivé otázky nebo panely. Možnost \"Zdědit\" použije nastavení na úrovni průzkumu (ve výchozím nastavení \"Nahoře\").",
            questionTitleWidth: "Nastaví konzistentní šířku názvů otázek, pokud jsou zarovnány nalevo od polí s otázkami. Přijímá hodnoty CSS (px, %, in, pt atd.).",
            questionErrorLocation: "Nastaví umístění chybové zprávy ve vztahu k otázce s neplatným vstupem. Vyberte si mezi: \"Nahoře\" - text chyby je umístěn v horní části pole s otázkou; \"Bottom\" - text chyby je umístěn ve spodní části pole s otázkou. Možnost \"Zdědit\" použije nastavení na úrovni průzkumu (ve výchozím nastavení \"Nahoře\").",
            questionsOrder: "Zachová původní pořadí otázek nebo je náhodně vybere. Možnost \"Zdědit\" použije nastavení na úrovni průzkumu (ve výchozím nastavení \"Původní\"). Účinek tohoto nastavení je viditelný pouze na kartě Náhled.",
            navigationButtonsVisibility: "Nastaví viditelnost navigačních tlačítek na stránce. Možnost \"Zdědit\" použije nastavení na úrovni průzkumu, které je ve výchozím nastavení \"Viditelné\"."
        },
        showTimerPanel: "Nastaví viditelnost a umístění časovače na stránce.",
        panelsState: "Vyberte si z těchto možností: \"Uzamčeno\" - uživatelé nemohou rozbalit nebo sbalit panely; \"Sbalit vše\" - všechny panely začínají ve sbaleném stavu; \"Rozbalit vše\" - všechny panely začínají v rozbaleném stavu; \"První rozbalený\" - zpočátku se rozbalí pouze první panel.",
        imageLinkName: "Zadejte název sdílené vlastnosti v poli objektů, které obsahuje adresy URL souborů obrázků nebo videí, které chcete zobrazit v seznamu voleb.",
        choices: "Levá hodnota slouží jako ID položky používané v podmíněných pravidlech, pravá hodnota se zobrazuje respondentům.",
        title: "Zadejte uživatelsky přívětivý název, který chcete zobrazit.",
        waitForUpload: "Zajistí, že uživatelé nedokončí průzkum, dokud nebudou soubory nahrány.",
        minWidth: "Přijímá hodnoty CSS (px, %, in, pt atd.).",
        maxWidth: "Přijímá hodnoty CSS (px, %, in, pt atd.).",
        width: "Přijímá hodnoty CSS (px, %, in, pt atd.).",
        valueName: "Pokud tuto vlastnost nenastavíte, odpověď bude uložena v poli specifikovaném názvem otázky.",
        useDisplayValuesInDynamicTexts: "V typech otázek s jedním a vícenásobným výběrem má každá možnost volby ID a zobrazovanou hodnotu. Pokud je tato možnost vybrána, zobrazí se v otázkách HTML a dynamických názvech a popisech prvků průzkumu zobrazená hodnota místo hodnoty ID.",
        clearIfInvisible: "Zvolte, zda chcete vymazat hodnoty otázek skryté podmíněnou logikou a kdy to udělat. Možnost \"Zdědit\" použije nastavení na úrovni průzkumu (ve výchozím nastavení \"Po dokončení průzkumu\").",
        choicesFromQuestionMode: "Vyberte si z: \"Vše\" - zkopíruje všechny možnosti výběru z vybrané otázky; \"Vybrané\" - dynamicky kopíruje pouze vybrané možnosti volby; \"Nevybráno\" - dynamicky zkopíruje pouze nevybrané možnosti výběru. Možnosti \"Žádné\" a \"Jiné\" jsou ve výchozím nastavení zkopírovány, pokud jsou povoleny ve zdrojové otázce.",
        showOtherItem: "Pokud je tato možnost vybraná, mohou uživatelé zahrnout další vstup do samostatného pole pro komentář.",
        separateSpecialChoices: "Zobrazí každou speciální volbu (\"Žádná\", \"Jiné\", \"Vybrat vše\") na novém řádku, a to i při použití rozložení s více sloupci.",
        path: "Zadejte umístění v datové sadě služby, kde se nachází cílové pole objektů. Ponechte prázdné, pokud adresa URL již odkazuje na pole.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Zadejte jednotný název vlastnosti v poli objektů, které obsahuje hodnoty, které chcete zobrazit v seznamu voleb.",
        allowEmptyResponse: "Tuto možnost vyberte, pokud chcete, aby služba vracela prázdnou odpověď nebo pole.",
        choicesVisibleIf: "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje viditelnost všech voleb.",
        rateValues: "Levá hodnota slouží jako ID položky používané v podmíněných pravidlech, pravá hodnota se zobrazuje respondentům.",
        rating: {
            displayMode: "\"Auto\" vybírá mezi režimy \"Tlačítka\" a \"Rozbalovací nabídka\" na základě dostupné šířky. Pokud šířka není dostatečná k zobrazení tlačítek, zobrazí se v otázce rozevírací seznam."
        },
        valuePropertyName: "Umožňuje propojit otázky, které poskytují výsledky v různých formátech. Pokud jsou takové otázky propojeny pomocí identifikátoru spojení, tato sdílená vlastnost ukládá vybrané hodnoty otázek.",
        searchEnabled: "Vyberte, zda chcete aktualizovat obsah rozevírací nabídky tak, aby odpovídal vyhledávacímu dotazu, který uživatel zadává do vstupního pole.",
        valueTrue: "Hodnota, která se uloží do výsledků průzkumu, když respondenti odpoví kladně.",
        valueFalse: "Hodnota, která se má uložit do výsledků průzkumu, když respondenti odpoví záporně.",
        showPreview: "Tuto možnost se nedoporučuje zakazovat, protože přepíše obrázek náhledu a uživateli ztíží pochopení, jestli byly soubory nahrány.",
        needConfirmRemoveFile: "Spustí výzvu s žádostí o potvrzení odstranění souboru.",
        selectToRankEnabled: "Povolením seřadíte pouze vybrané volby. Uživatelé přetáhnou vybrané položky ze seznamu voleb a seřadí je v oblasti hodnocení.",
        dataList: "Zadejte seznam možností, které budou respondentovi navrženy během vstupu.",
        itemSize: "Nastavení mění pouze velikost vstupních polí a nemá vliv na šířku pole pro otázky.",
        itemTitleWidth: "Nastaví konzistentní šířku pro všechny popisky položek v pixelech",
        altText: "Slouží jako náhrada v případě, že obrázek nelze zobrazit na zařízení uživatele, a pro účely usnadnění.",
        rateColorMode: "Definuje barvu vybraného emotikonu, když je typ ikony Hodnocení nastaven na \"Smajlíky\". Vyberte si mezi: \"Výchozí\" - vybraný emotikon se zobrazí ve výchozí barvě průzkumu; \"Měřítko\" - vybraný emotikon zdědí barvu ze stupnice hodnocení.",
        expression: {
            name: "ID výrazu, které není viditelné pro respondenty.",
            description: "Zadejte výraz subtitle.",
            expression: "Výraz může obsahovat základní výpočty ('{q1_id} + {q2_id}'), podmínky ('{age} > 60') a funkce ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' atd.)."
        },
        storeOthersAsComment: "Tuto možnost vyberte, chcete-li uložit hodnotu možnosti \"Jiné\" jako samostatnou vlastnost ve výsledcích průzkumu.",
        format: "Použít {0} jako zástupný text pro skutečnou hodnotu.",
        acceptedTypes: "Pro více informací viz [accept](https://www.w3schools.com/tags/att_input_accept.asp).",
        columnColCount: "Vztahuje se pouze na typy přepínač a zaškrtávací políčka.",
        autocomplete: "Pro více informací viz [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete).",
        filePlaceholder: "Platí, když je \"Typ zdroje\" nastaven na \"Místní soubory\" nebo když je kamera nedostupná",
        photoPlaceholder: "Platí, když je \"Typ zdroje\" nastaven na \"Fotoaparát\".",
        fileOrPhotoPlaceholder: "Platí, když \"Typ zdroje\" je \"Místní soubory nebo kamera\".",
        masksettings: {
            saveMaskedValue: "Vyberte, zda chcete uložit hodnotu otázky s použitou maskou do výsledků průzkumu."
        },
        patternmask: {
            pattern: "Vzor může obsahovat řetězcové literály a následující zástupné symboly: \"9\" - pro číslici; \"a\" - pro velké nebo malé písmeno; '#' - pro číslici nebo velké či malé písmeno. Pomocí zpětného lomítka \\ můžete znak uvozovat."
        },
        datetimemask: {
            pattern: "Vzor může obsahovat oddělovací znaky a následující zástupné symboly:<br>'m' - Číslo měsíce.<br>'mm' - Číslo měsíce s úvodní nulou pro jednociferné hodnoty. <br>\"d\" - Den v měsíci. <br>'dd' - Den v měsíci, s úvodní nulou pro jednociferné hodnoty. <br>\"yy\" – poslední dvě číslice roku. <br>\"yyyy\" – čtyřmístný rok. <br>\"H\" – hodiny ve 24hodinovém formátu. <br>\"HH\" – hodiny ve 24hodinovém formátu, s úvodní nulou pro jednociferné hodnoty. <br>\"h\" – hodiny ve 12hodinovém formátu. <br>'hh' - Hodiny ve 12hodinovém formátu, s úvodní nulou pro jednociferné hodnoty. <br>'MM' - Zápisy. <br>'ss' - Sekundy. <br>\"TT\" – 12hodinový časový interval psaný velkými písmeny (AM/PM). <br>'tt' - 12hodinový časový interval psaný malými písmeny (am/pm)."
        },
        numericmask: {
            decimalSeparator: "Symbol používaný k oddělení zlomkové části od celočíselné části zobrazeného čísla.",
            thousandsSeparator: "Symbol používaný k oddělení číslic velkého čísla do skupin po třech.",
            precision: "Omezuje, kolik číslic se má zachovat za desetinnou čárkou zobrazeného čísla."
        },
        currencymask: {
            prefix: "Jeden nebo více symbolů, které mají být zobrazeny před hodnotou.",
            suffix: "Jeden nebo více symbolů, které se zobrazí za hodnotou."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "nadpis",
            title: "Nechte pole prázdné, pokud je stejné jako „Název”"
        },
        multiSelect: "Povolit výběr více položek",
        showLabel: "Zobrazit popisky obrázku",
        swapOrder: "Prohození pořadí Ano a Ne",
        value: "Hodnota",
        tabAlign: "Zarovnání záložek",
        sourceType: "Typ zdroje",
        fitToContainer: "Vhodné pro kontejner",
        setValueExpression: "Nastavit výraz hodnoty",
        description: "Popis",
        logoFit: "Přizpůsobit logo",
        pages: "Stránky",
        questions: "Otázky",
        triggers: "Spouštěče",
        calculatedValues: "Vypočítané hodnoty",
        surveyId: "Id průzkumu",
        surveyPostId: "Id příspěvku průzkumu",
        surveyShowDataSaving: "Zobrazit hlášku pro ukládání dat",
        questionDescriptionLocation: "Umístění popisu otázky",
        progressBarType: "Typ ukazatele postupu",
        showTOC: "Zobrazit TOC",
        tocLocation: "Umístění Toc",
        questionTitlePattern: "Vzor pro nadpis otázky",
        widthMode: "Režim šířky",
        showBrandInfo: "Zobrazit informace o značce",
        useDisplayValuesInDynamicTexts: "Použít hodnoty zobrazení v dynamických textech",
        visibleIf: "Viditelná, pokud",
        defaultValueExpression: "Výraz pro výchozí hodnotu",
        requiredIf: "Povinná, pokud",
        resetValueIf: "Resetovat hodnotu, pokud",
        setValueIf: "Nastavte hodnotu, pokud",
        validators: "Validátory",
        bindings: "Vazby",
        renderAs: "Vykreslit jako",
        attachOriginalItems: "Připojit původní položky",
        choices: "Volby",
        choicesByUrl: "Volby podle Url",
        currency: "Měna",
        cellHint: "Nápověda buňky",
        totalMaximumFractionDigits: "Maximální počet desetinných míst",
        totalMinimumFractionDigits: "Minimální počet desetinných míst",
        columns: "Sloupce",
        detailElements: "Podrobné prvky",
        allowAdaptiveActions: "Povolit adaptivní akce",
        defaultRowValue: "Výchozí hodnota řádku",
        detailPanelShowOnAdding: "Detailní zobrazení panelu při přidání",
        choicesLazyLoadEnabled: "Povolit lazy loading voleb",
        choicesLazyLoadPageSize: "Počet voleb na jednu stránku",
        inputFieldComponent: "Komponenta vstupního pole",
        itemComponent: "Komponenty položky",
        min: "Min",
        max: "Max",
        minValueExpression: "Minimální hodnota výrazu",
        maxValueExpression: "Maximální hodnota výrazu",
        step: "Krok",
        dataList: "Datový list",
        itemSize: "Velikost položky",
        itemTitleWidth: "Šířka popisku položky (v px)",
        elements: "Prvky",
        content: "Obsah",
        navigationButtonsVisibility: "Viditelnost navigačních tlačítek",
        navigationTitle: "Napids navigace",
        navigationDescription: "Popis navigace",
        longTap: "Dlouhé poklepání",
        autoGrow: "Automatický růst",
        allowResize: "Povolit změnu velikosti",
        acceptCarriageReturn: "Povolit znak pro \"návrat vozíku\"",
        displayMode: "Režim zobrazení",
        rateType: "Typ kurzu",
        label: "Popisek",
        contentMode: "Režim obsahu",
        imageFit: "Přizpůsobení obrázku",
        altText: "Alternativní text",
        height: "Výška",
        penColor: "Barva pera",
        backgroundColor: "Barva pozadí",
        templateElements: "Prvky šablony",
        operator: "Operátor",
        isVariable: "Je proměnná",
        runExpression: "Spustit výraz",
        showCaption: "Zobrazit popis",
        iconName: "Název ikony",
        iconSize: "Velikost ikony",
        precision: "Přesnost",
        matrixDragHandleArea: "Oblast úchytu pro přetažení matice",
        backgroundImage: "Obrázek na pozadí",
        backgroundImageFit: "Přizpůsobení obrázku na pozadí",
        backgroundImageAttachment: "Příloha obrázku na pozadí",
        backgroundOpacity: "Neprůhlednost pozadí",
        selectToRankEnabled: "Vyberte pro hodnocení povoleno",
        selectToRankAreasLayout: "Výběrem seřadíte rozvržení oblastí",
        selectToRankEmptyRankedAreaText: "Text, který se zobrazí, pokud jsou vybrány všechny možnosti",
        selectToRankEmptyUnrankedAreaText: "Zástupný text pro oblast hodnocení",
        allowCameraAccess: "Povolit přístup ke kameře",
        scaleColorMode: "Barevný režim měřítka",
        rateColorMode: "Barevný režim s ohodnocením",
        copyDisplayValue: "Kopírovat zobrazovanou hodnotu",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Pokročilý režim",
        pageTitle: "Font nadpisu stránky",
        questionTitle: "Font nadpisu otázky",
        editorPanel: "Editor",
        lines: "Řádky",
        primaryDefaultColor: "Výchozí",
        primaryDarkColor: "Hover",
        primaryLightColor: "Vybraný",
        backgroundDimColor: "Barva pozadí",
        cornerRadius: "Poloměr rohu",
        backcolor: "Výchozí pozadí",
        hovercolor: "Pozadí při přejetí myší",
        borderDecoration: "Dekorace hran",
        fontColor: "Barva písma",
        backgroundColor: "Barva pozadí",
        primaryForecolor: "Výchozí barva",
        primaryForecolorLight: "Barva vypnutého pole",
        font: "Písmo",
        borderDefault: "Hlavní",
        borderLight: "Vedlejší",
        fontFamily: "Rodina písem",
        fontWeightRegular: "Pravidelný",
        fontWeightHeavy: "Těžký",
        fontWeightSemiBold: "Polotučné písmo",
        fontWeightBold: "Tučný",
        color: "Barva",
        placeholderColor: "Barva zástupného symbolu",
        size: "Velikost",
        opacity: "Neprůhlednost",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Přidat stínový efekt",
        boxShadowBlur: "Blur",
        boxShadowSpread: "Rozšíření",
        boxShadowDrop: "Kapka",
        boxShadowInner: "Vnitřní",
        names: {
            default: "Výchozí",
            sharp: "Ostrý",
            borderless: "Bez okrajů",
            flat: "Byt",
            plain: "Planina",
            doubleborder: "Dvojitý okraj",
            layered: "Vrstvený",
            solid: "Solidní",
            threedimensional: ".3D",
            contrast: "Kontrast"
        },
        colors: {
            teal: "Modrozelený",
            blue: "Modrý",
            purple: "Nachový",
            orchid: "Orchidea",
            tulip: "Tulipán",
            brown: "Hnědý",
            green: "Zelený"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["cs"] = czStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// ed.themePropertyGridTitle: "Theme Settings" => "Nastavení motivu"
// ed.themeExportButton: "Export" => "Vývoz"
// ed.themeImportButton: "Import" => "Dovoz"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Volby jsou zkopírovány z"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "Jasná hodnota otázky: {0}"
// pe.overridingPropertyPrefix: "Set by " => "Nastavit podle "
// pe.minSelectedChoices: "Minimum selected choices" => "Minimální vybrané volby"
// pe.rateType: "Rate type" => "Typ sazby"
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Změní velikost viditelné oblasti vstupního pole. <b>Použijte nastavení Ověření → Maximální délka</b> pro omezení vstupní délky."
// p.precision: "Precision" => "Přesnost"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Oblast úchytu pro přetažení matice"
// p.backgroundImage: "Background image" => "Obrázek na pozadí"
// p.backgroundImageFit: "Background image fit" => "Přizpůsobení obrázku na pozadí"
// p.backgroundImageAttachment: "Background image attachment" => "Příloha obrázku na pozadí"
// p.backgroundOpacity: "Background opacity" => "Neprůhlednost pozadí"
// p.selectToRankEnabled: "Select to rank enabled" => "Vyberte pro hodnocení povoleno"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Výběrem seřadíte rozvržení oblastí"
// p.allowCameraAccess: "Allow camera access" => "Povolit přístup ke kameře"
// p.scaleColorMode: "Scale color mode" => "Barevný režim měřítka"
// p.rateColorMode: "Rate color mode" => "Barevný režim s ohodnocením"
// p.templateTabTitle: "Template tab title" => "Název karty šablony"
// p.templateVisibleIf: "Template visible if" => "Šablona viditelná, pokud"
// p.copyDisplayValue: "Copy display value" => "Kopírovat zobrazovanou hodnotu"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Stabilní"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Svitek"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Přidat stínový efekt"
// theme.boxShadowDrop: "Drop" => "Kapka"
// theme.boxShadowInner: "Inner" => "Vnitřní"
// names.default: "Default" => "Výchozí"
// names.contrast: "Contrast" => "Kontrast"
// names.plain: "Plain" => "Planina"
// names.simple: "Simple" => "Jednoduchý"
// names.blank: "Blank" => "Bianko"
// names.double: "Double" => "Dvojitý"
// names.bulk: "Bulk" => "Množství"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo 3D"
// names.playful: "Playful" => "Hravý"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Modrozelený"
// colors.blue: "Blue" => "Modrý"
// colors.purple: "Purple" => "Nachový"
// colors.orchid: "Orchid" => "Orchidea"
// colors.tulip: "Tulip" => "Tulipán"
// colors.brown: "Brown" => "Hnědý"
// colors.green: "Green" => "Zelený"
// names.sharp: "Sharp" => "Ostrý"
// names.borderless: "Borderless" => "Bez okrajů"
// names.flat: "Flat" => "Byt"
// names.doubleborder: "Double Border" => "Dvojitý okraj"
// names.layered: "Layered" => "Vrstvený"
// names.solid: "Solid" => "Solidní"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Jste si jisti, že chcete odstranit všechny řetězce pro tento jazyk?"
// ed.themeResetButton: "Reset theme settings to default" => "Obnovení výchozího nastavení motivu"
// theme.placeholderColor: "Placeholder color" => "Zástupná barva"
// ed.themeSettings: "Theme Settings" => "Nastavení motivu"
// ed.themeSettingsTooltip: "Open theme settings" => "Otevření nastavení motivu"
// pe.resetToDefaultCaption: "Reset" => "Resetovat"
// pv.file: "Local files" => "Místní soubory"
// pv.camera: "Camera" => "Fotoaparát"
// pv.file-camera: "Local files or camera" => "Místní soubory nebo fotoaparát"
// ed.translationDialogTitle: "Untranslated strings" => "Nepřeložené řetězce"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Zadejte alespoň {0} položek"
// lg.question_resetValueName: "Reset question value" => "Obnovit hodnotu otázky"
// lg.column_resetValue: "Reset column value" => "Obnovit hodnotu sloupce"
// pe.markRequired: "Mark as required" => "Označit podle potřeby"
// pe.removeRequiredMark: "Remove the required mark" => "Odstraňte požadovanou značku"
// p.resetValueIf: "Reset value if" => "Resetovat hodnotu, pokud"
// lg.question_setValueName: "Set question value" => "Nastavit hodnotu otázky"
// lg.column_resetValueName: "Reset column value" => "Obnovit hodnotu sloupce"
// lg.column_setValueName: "Set column value" => "Nastavit hodnotu sloupce"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Výraz, jehož výsledek bude přiřazen cílové otázce."
// survey.title: "Title" => "Titul"
// page.title: "Title" => "Titul"
// p.setValueIf: "Set value if" => "Nastavte hodnotu, pokud"
// theme.header: "Header" => "Záhlaví"
// theme.backgroundImageFitFill: "Stretch" => "Natáhnout"
// theme.backgroundImageFitTile: "Tile" => "Dlaždice"
// theme.headerView: "View" => "Pohled"
// theme.headerViewBasic: "Basic" => "Základní"
// theme.headerViewAdvanced: "Advanced" => "Pokročilý"
// theme.coverInheritWidthFrom: "Content area width" => "Šířka oblasti obsahu"
// theme.coverInheritWidthFromSurvey: "Same as survey" => "Stejné jako průzkum"
// theme.coverInheritWidthFromPage: "Fit to page" => "Přizpůsobit stránce"
// theme.coverTextAreaWidth: "Text width" => "Šířka textu"
// theme.coverBackgroundColorSwitch: "Background color" => "Barva pozadí"
// theme.coverBackgroundColorNone: "None" => "Žádný"
// theme.coverBackgroundColorAccentColor: "Accent color" => "Barva zvýraznění"
// theme.coverBackgroundColorCustom: "Custom" => "Zvyk"
// theme.headerInheritWidthFrom: "Content area width" => "Šířka oblasti obsahu"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Stejné jako průzkum"
// theme.headerInheritWidthFromPage: "Fit to page" => "Přizpůsobit stránce"
// theme.headerTextAreaWidth: "Text width" => "Šířka textu"
// theme.headerBackgroundColorSwitch: "Background color" => "Barva pozadí"
// theme.headerBackgroundColorNone: "None" => "Žádný"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Barva zvýraznění"
// theme.headerBackgroundColorCustom: "Custom" => "Zvyk"
// theme.horizontalAlignmentLeft: "Left" => "Vlevo"
// theme.horizontalAlignmentCenter: "Center" => "Střed"
// theme.horizontalAlignmentRight: "Right" => "Vpravo"
// theme.verticalAlignmentTop: "Top" => "Vrchol"
// theme.verticalAlignmentMiddle: "Middle" => "Prostřední"
// theme.verticalAlignmentBottom: "Bottom" => "Dno"
// theme.logoPosition: "Logo Position" => "Pozice loga"
// theme.coverTitlePosition: "Title Position" => "Titulní pozice"
// theme.headerTitlePosition: "Title Position" => "Titulní pozice"
// lg.question_resetValueText: "reset value for question: {0}" => "Resetovat hodnotu pro otázku: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "přiřadit hodnotu: {1} na otázku: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Obnovit hodnotu buňky pro sloupec: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Přiřaďte hodnotu buňky: {1} sloupci: {0}"
// ed.surveyJsonExportButton: "Export" => "Vývoz"
// ed.surveyJsonImportButton: "Import" => "Dovoz"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Zkopírovat do schránky"
// pe.filePlaceholder: "File placeholder text" => "Text zástupného symbolu souboru"
// pe.photoPlaceholder: "Photo placeholder text" => "Text zástupného symbolu fotografie"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Zástupný text souboru nebo fotografie"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Platí, když je \"Typ zdroje\" nastaven na \"Místní soubory\" nebo když je kamera nedostupná"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Platí, když je \"Typ zdroje\" nastaven na \"Fotoaparát\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Platí, když \"Typ zdroje\" je \"Místní soubory nebo kamera\"."
// theme.background: "Background" => "Pozadí"
// theme.appearance: "Appearance" => "Vzhled"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Opravdu chcete resetovat motiv? Všechna vaše přizpůsobení budou ztracena."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Ano, resetovat motiv"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Vhodné pro kontejner"
// signaturepad.showPlaceholder: "Show the placeholder" => "Zobrazení zástupného symbolu"
// signaturepad.placeholder: "Placeholder text" => "Zástupný text"
// theme.surveyDescriptionFont: "Survey description font" => "Písmo popisu průzkumu"
// ed.prevFocus: "Focus previous" => "Zaostřeno předchozí"
// ed.nextFocus: "Focus next" => "Zaostřit na další"
// ed.saveTheme: "Save Theme" => "Uložit motiv"
// ed.saveThemeTooltip: "Save Theme" => "Uložit motiv"
// lg.page_requireName: "Make page required" => "Nastavit stránku jako povinné"
// lg.panel_requireName: "Make page required" => "Nastavit stránku jako povinné"
// signaturepad.signatureWidth: "Signature area width" => "Šířka oblasti podpisu"
// signaturepad.signatureHeight: "Signature area height" => "Výška signatury"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Automatické škálování oblasti podpisu"
// signaturepad.penMinWidth: "Minimum pen width" => "Minimální šířka pera"
// signaturepad.penMaxWidth: "Maximum pen width" => "Maximální šířka pera"
// theme.headerDescriptionPosition: "Description position" => "Popis pozice"
// ed.propertyGridNoResultsFound: "No results found" => "Nebyly nalezeny žádné výsledky"
// pv.leftRight: "Left and right" => "Vlevo a vpravo"
// p.sourceType: "Source type" => "Typ zdroje"
// p.fitToContainer: "Fit to container" => "Vhodné pro kontejner"
// p.setValueExpression: "Set value expression" => "Nastavit výraz hodnoty"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Volby se načítají z webové služby."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Přejděte do nastavení"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Náhled načtených voleb"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Zabránění duplicitním odpovědím v řádcích"
// theme.advancedMode: "Advanced mode" => "Pokročilý režim"
// theme.backgroundCornerRadius: "Background and corner radius" => "Pozadí a poloměr rohů"
// theme.colorsTitle: "Colors" => "Barvy"
// theme.font: "Font" => "Písmo"
// theme.lines: "Lines" => "Řádky"
// theme.titleFont: "Title font" => "Písmo nadpisu"
// theme.descriptionFont: "Description font" => "Popisné písmo"
// theme.shadow: "Shadow effects" => "Stínové efekty"
// ed.translateUsigAIFrom: "Translate from: " => "Přeložit z: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Povolte možnost Odmítnout odpověď"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Povolit možnost Nevím"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Povolte možnost Odmítnout odpověď"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Povolit možnost Nevím"
// pv.contain: "Contain" => "Obsahovat"
// pv.cover: "Cover" => "Krýt"
// pv.fill: "Fill" => "Vyplnit"
// pe.transposeData: "Transpose rows to columns" => "Transponování řádků do sloupců"
// layout.panel: "Layout" => "Rozložení"
// layout.question: "Layout" => "Rozložení"
// layout.base: "Layout" => "Rozložení"
// panel.name: "Panel name" => "Název panelu"
// panel.title: "Panel title" => "Název panelu"
// panel.description: "Panel description" => "Popis panelu"
// panel.visibleIf: "Make the panel visible if" => "Zviditelněte panel, pokud"
// panel.requiredIf: "Make the panel required if" => "Zajistěte, aby byl panel povinný, pokud"
// panel.questionsOrder: "Question order within the panel" => "Pořadí otázek v rámci panelu"
// panel.startWithNewLine: "Display the panel on a new line" => "Zobrazení obrazu na novém řádku"
// panel.state: "Panel collapse state" => "Stav sbalení panelu"
// panel.width: "Inline panel width" => "Šířka vloženého panelu"
// panel.minWidth: "Minimum panel width" => "Minimální šířka panelu"
// panel.maxWidth: "Maximum panel width" => "Maximální šířka panelu"
// panel.showNumber: "Number panels" => "Číselné panely"
// paneldynamic.name: "Panel name" => "Název panelu"
// paneldynamic.title: "Panel title" => "Název panelu"
// paneldynamic.description: "Panel description" => "Popis panelu"
// paneldynamic.visibleIf: "Make the panel visible if" => "Zviditelněte panel, pokud"
// paneldynamic.requiredIf: "Make the panel required if" => "Zajistěte, aby byl panel povinný, pokud"
// paneldynamic.page: "Move the panel to page" => "Přesunutí panelu na stránku"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Zobrazení obrazu na novém řádku"
// paneldynamic.state: "Panel collapse state" => "Stav sbalení panelu"
// paneldynamic.width: "Inline panel width" => "Šířka vloženého panelu"
// paneldynamic.minWidth: "Minimum panel width" => "Minimální šířka panelu"
// paneldynamic.maxWidth: "Maximum panel width" => "Maximální šířka panelu"
// paneldynamic.templateDescription: "Panel description pattern" => "Vzor popisu panelu"
// paneldynamic.templateTitle: "Panel title pattern" => "Vzor titulku panelu"
// paneldynamic.noEntriesText: "Empty panel text" => "Prázdný text panelu"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Vzor názvu tabulátoru"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Zviditelněte jednotlivý panel, pokud"
// paneldynamic.hideNumber: "Hide the panel number" => "Skrýt číslo panelu"
// paneldynamic.titleLocation: "Panel title alignment" => "Zarovnání názvu panelu"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Zarovnání popisu panelu"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Zarovnání názvu otázky"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Zarovnání chybové zprávy"
// paneldynamic.newPanelPosition: "New panel location" => "Nové umístění panelu"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Zabraňte duplicitním odpovědím v následující otázce"
// question.name: "Question name" => "Název otázky"
// question.title: "Question title" => "Název otázky"
// question.description: "Question description" => "Popis otázky"
// question.visibleIf: "Make the question visible if" => "Zviditelněte otázku, pokud"
// question.requiredIf: "Make the question required if" => "Otázku povinně zjišťte, pokud"
// question.state: "Question box collapse state" => "Stav sbalení pole otázek"
// question.hideNumber: "Hide the question number" => "Skrýt číslo otázky"
// question.titleLocation: "Question title alignment" => "Zarovnání názvu otázky"
// question.descriptionLocation: "Question description alignment" => "Zarovnání popisu otázky"
// question.errorLocation: "Error message alignment" => "Zarovnání chybové zprávy"
// question.indent: "Increase the inner indent" => "Zvětšete vnitřní odsazení"
// question.width: "Inline question width" => "Vložená šířka otázky"
// question.minWidth: "Minimum question width" => "Minimální šířka otázky"
// question.maxWidth: "Maximum question width" => "Maximální šířka otázky"
// question.textUpdateMode: "Update input field value" => "Aktualizovat hodnotu vstupního pole"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Zobrazení tlačítka Vymazat v oblasti podpisu"
// signaturepad.penColor: "Stroke color" => "Barva tahu"
// comment.rows: "Input field height (in lines)" => "Výška vstupního pole (v řádcích)"
// expression.name: "Expression name" => "Název výrazu"
// expression.title: "Expression title" => "Název výrazu"
// expression.description: "Expression description" => "Popis výrazu"
// expression.expression: "Expression" => "Výraz"
// trigger.expression: "Expression" => "Výraz"
// calculatedvalue.expression: "Expression" => "Výraz"
// survey.description: "Survey description" => "Popis průzkumu"
// page.name: "Page name" => "Název stránky"
// page.description: "Page description" => "Popis stránky"
// page.visibleIf: "Make the page visible if" => "Zviditelněte stránku, pokud"
// page.requiredIf: "Make the page required if" => "Zajistěte, aby stránka byla povinná, pokud"
// page.questionsOrder: "Question order on the page" => "Pořadí otázek na stránce"
// matrixdropdowncolumn.name: "Column name" => "Název sloupce"
// matrixdropdowncolumn.title: "Column title" => "Název sloupce"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Zabraňte duplicitním odpovědím"
// matrixdropdowncolumn.width: "Column width" => "Šířka sloupce"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Minimální šířka sloupce"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Výška vstupního pole (v řádcích)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Zviditelněte sloupec, pokud"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Vytvořte sloupec jako povinný, pokud"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Každá možnost v samostatném sloupci"
// multipletextitem.name: "Name" => "Jméno"
// multipletextitem.title: "Title" => "Titul"
// pe.rateDescriptionLocation: "Label alignment" => "Zarovnání štítků"
// pe.cellErrorLocation: "Cell error message alignment" => "Zarovnání chybové zprávy buňky"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Zatím nemáte žádné sloupce."
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Zatím nemáte žádné řádky"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Zatím nemáte žádná ověřovací pravidla."
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Zatím nemáte žádné vlastní proměnné."
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Zatím nemáte žádné spouštěče"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Zatím nemáte žádné odkazy"
// pe.addNew@columns: "Add new column" => "Přidat nový sloupec"
// pe.addNew@rows: "Add new row" => "Přidat nový řádek"
// pe.addNew@validators: "Add new rule" => "Přidat nové pravidlo"
// pe.addNew@calculatedValues: "Add new variable" => "Přidat novou proměnnou"
// pe.addNew@triggers: "Add new trigger" => "Přidání nového triggeru"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Přidat novou adresu URL"
// choicesbyurl.url: "Web service's URL" => "Adresa URL webové služby"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Zobrazení názvů stránek na ukazateli průběhu"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Zobrazení čísel stránek na indikátoru průběhu"
// itemvalue.visibleIf: "Make the option visible if" => "Zviditelněte tuto možnost, pokud"
// itemvalue.enableIf: "Make the option selectable if" => "Zajistěte, aby byla možnost vybratelná, pokud"
// panel.layout: "Panel Layout" => "Rozvržení panelu"
// tabs.questionSettings: "Question Settings" => "Nastavení otázek"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Př.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Př.: categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Př.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Př.: 6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "Př.: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Př.: 50%"
// pv.selected: "Selected" => "Vybraný"
// pv.unselected: "Unselected" => "Nezvolený"
// pv.center: "Center" => "Střed"
// pv.middle: "Middle" => "Prostřední"
// pv.next: "Next" => "Další"
// pv.last: "Last" => "Poslední"
// clearIfInvisible.none: "Never" => "Nikdy"
// questionsOnPageMode.standard: "Original structure" => "Původní struktura"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Zobrazit všechny otázky na jedné stránce"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Zobrazit jednu otázku na stránku"
// pv.auto: "Auto" => "Auto"
// panelsState.firstExpanded: "First expanded" => "První rozšířeno"
// rateColorMode.scale: "Scale" => "Škála"
// scaleColorMode.monochrome: "Monochrome" => "Monochromatický"
// scaleColorMode.colored: "Colored" => "Barevný"
// state.default: "Locked" => "Zamčený"
// showQuestionNumbers.default: "Auto-numbering" => "Automatické číslování"
// showQuestionNumbers.on: "Auto-numbering" => "Automatické číslování"
// showQuestionNumbers.onPage: "Reset on each page" => "Resetovat na každé stránce"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Resetovat na každém panelu"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Resetovat na každém panelu"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Pokračovat v průzkumu"
// showQuestionNumbers.off: "No numbering" => "Žádné číslování"
// descriptionLocation.underTitle: "Under the question title" => "Pod nadpisem otázky"
// descriptionLocation.underInput: "Under the input field" => "Pod vstupním polem"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Vedle voleb"
// selectToRankAreasLayout.vertical: "Above choices" => "Výše uvedené možnosti"
// displayStyle.decimal: "Decimal" => "Desetinný"
// displayStyle.currency: "Currency" => "Měna"
// displayStyle.percent: "Percentage" => "Procento"
// displayStyle.date: "Date" => "Rande"
// totalDisplayStyle.decimal: "Decimal" => "Desetinný"
// totalDisplayStyle.currency: "Currency" => "Měna"
// totalDisplayStyle.percent: "Percentage" => "Procento"
// totalDisplayStyle.date: "Date" => "Rande"
// rowsOrder.initial: "Original" => "Původní"
// questionsOrder.initial: "Original" => "Původní"
// showProgressBar.aboveheader: "Above the header" => "Nad záhlavím"
// showProgressBar.belowheader: "Below the header" => "Pod záhlavím"
// pv.sum: "Sum" => "Součet"
// pv.count: "Count" => "Počítat"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Max"
// pv.avg: "Avg" => "Průměr"
// searchMode.contains: "Contains" => "Obsahuje"
// searchMode.startsWith: "Starts with" => "Začíná na"
// panel.name: "A panel ID that is not visible to respondents." => "ID panelu, které není viditelné pro respondenty."
// panel.description: "Type a panel subtitle." => "Zadejte titulky panelu."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje viditelnost panelu."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které pro panel zakáže režim jen pro čtení."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které zabrání odeslání průzkumu, pokud alespoň jedna vnořená otázka nemá odpověď."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Platí pro všechny otázky v rámci tohoto panelu. Chcete-li toto nastavení přepsat, definujte pravidla zarovnání nadpisů pro jednotlivé otázky. Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu (ve výchozím nastavení \"Nahoře\")."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Nastaví umístění chybové zprávy ve vztahu ke všem otázkám v panelu. Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Zachová původní pořadí otázek nebo je náhodně vybere. Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu."
// panel.page: "Repositions the panel to the end of a selected page." => "Přemístí panel na konec vybrané stránky."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Přidá mezeru nebo okraj mezi obsah panelu a levý okraj rámečku panelu."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Zrušte výběr, chcete-li panel zobrazit v jednom řádku s předchozí otázkou nebo panelem. Nastavení se nepoužije, pokud je panel prvním prvkem ve formuláři."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Vyberte si z: \"Rozbalený\" - panel se zobrazí celý a lze jej sbalit; \"Sbaleno\" - panel zobrazuje pouze název a popis a lze jej rozbalit; \"Zamčeno\" - obraz je zobrazen celý a nelze jej sbalit."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Nastaví šířku panelu v poměru k ostatním prvkům zaměření ve stejném řádku. Přijímá hodnoty CSS (px, %, in, pt atd.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "ID panelu, které není viditelné pro respondenty."
// paneldynamic.description: "Type a panel subtitle." => "Zadejte titulky panelu."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje viditelnost panelu."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které pro panel zakáže režim jen pro čtení."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které zabrání odeslání průzkumu, pokud alespoň jedna vnořená otázka nemá odpověď."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Platí pro všechny otázky v rámci tohoto panelu. Chcete-li toto nastavení přepsat, definujte pravidla zarovnání nadpisů pro jednotlivé otázky. Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu (ve výchozím nastavení \"Nahoře\")."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Nastaví umístění chybové zprávy ve vztahu k otázce s neplatným vstupem. Vyberte si mezi: \"Nahoře\" - text chyby je umístěn v horní části pole s otázkou; \"Bottom\" - text chyby je umístěn ve spodní části pole s otázkou. Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu (ve výchozím nastavení \"Nahoře\")."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Nastaví umístění chybové zprávy ve vztahu ke všem otázkám v panelu. Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Přemístí panel na konec vybrané stránky."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Přidá mezeru nebo okraj mezi obsah panelu a levý okraj rámečku panelu."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Zrušte výběr, chcete-li panel zobrazit v jednom řádku s předchozí otázkou nebo panelem. Nastavení se nepoužije, pokud je panel prvním prvkem ve formuláři."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Vyberte si z: \"Rozbalený\" - panel se zobrazí celý a lze jej sbalit; \"Sbaleno\" - panel zobrazuje pouze název a popis a lze jej rozbalit; \"Zamčeno\" - obraz je zobrazen celý a nelze jej sbalit."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Nastaví šířku panelu v poměru k ostatním prvkům zaměření ve stejném řádku. Přijímá hodnoty CSS (px, %, in, pt atd.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Zadejte šablonu pro dynamické názvy panelů. Použijte {panelIndex} pro obecnou pozici panelu a {visiblePanelIndex} pro jeho pořadí mezi viditelnými panely. Vložením těchto zástupných symbolů do vzorku přidáte automatické číslování."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Zadejte šablonu pro názvy karet. Použijte {panelIndex} pro obecnou pozici panelu a {visiblePanelIndex} pro jeho pořadí mezi viditelnými panely. Vložením těchto zástupných symbolů do vzorku přidáte automatické číslování."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Toto nastavení umožňuje řídit viditelnost jednotlivých panelů v rámci dynamického panelu. Pomocí zástupného symbolu {panel} můžete odkazovat na aktuální panel ve výrazu."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Toto nastavení je automaticky převzato všemi otázkami v tomto panelu. Chcete-li toto nastavení přepsat, definujte pravidla zarovnání nadpisů pro jednotlivé otázky. Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu (ve výchozím nastavení \"Nahoře\")."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "Možnost \"Zdědit\" použije nastavení na úrovni stránky (pokud je nastaveno) nebo na úrovni průzkumu (ve výchozím nastavení \"Pod názvem panelu\")."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Definuje polohu nově přidaného panelu. Ve výchozím nastavení se nové panely přidávají na konec. Výběrem možnosti \"Další\" vložíte nový panel za aktuální."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Duplikuje odpovědi z posledního panelu a přiřadí je dalšímu přidanému dynamickému panelu."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Odkazujte na název otázky, chcete-li vyžadovat, aby uživatel na tuto otázku v každém panelu poskytl jedinečnou odpověď."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Toto nastavení umožňuje přiřadit výchozí hodnotu odpovědi na základě výrazu. Výraz může obsahovat základní výpočty - '{q1_id} + {q2_id}', logické výrazy, například '{age} > 60', a funkce: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' atd. Hodnota určená tímto výrazem slouží jako počáteční výchozí hodnota, kterou lze přepsat ručním zadáním respondenta."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje, kdy se vstup respondenta resetuje na hodnotu na základě \"Výrazu výchozí hodnoty\" nebo \"Výrazu nastavit hodnotu\" nebo na hodnotu \"Výchozí odpověď\" (pokud je nastavena kterákoli z nich)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje, kdy se má spustit výraz \"Nastavit hodnotu\", a dynamicky přiřadit výslednou hodnotu jako odpověď."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Zadejte výraz, který definuje hodnotu, která má být nastavena, když jsou splněny podmínky v pravidle \"Nastavit hodnotu, pokud\". Výraz může obsahovat základní výpočty - '{q1_id} + {q2_id}', logické výrazy, například '{age} > 60', a funkce: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' atd. Hodnota určená tímto výrazem může být přepsána ručním zadáním respondenta."
// question.name: "A question ID that is not visible to respondents." => "ID otázky, které respondenti nevidí."
// question.description: "Type a question subtitle." => "Zadejte podnadpis otázky."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje viditelnost otázky."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které pro otázku zakáže režim jen pro čtení."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které zabrání postupu nebo odeslání průzkumu, pokud otázka neobdržela odpověď."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Zrušte výběr, chcete-li otázku zobrazit v jednom řádku s předchozí otázkou nebo panelem. Nastavení se nepoužije, pokud je otázka prvním prvkem ve formuláři."
// question.page: "Repositions the question to the end of a selected page." => "Přemístí otázku na konec vybrané stránky."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Vyberte si z: \"Rozbalené\" - pole s otázkou se zobrazí celé a lze jej sbalit; \"Sbaleno\" - pole s otázkou zobrazuje pouze název a popis a lze jej rozbalit; \"Zamčeno\" - pole s otázkou je zobrazeno celé a nelze jej sbalit."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Přepíše pravidla zarovnání nadpisů definovaná na úrovni panelu, stránky nebo průzkumu. Možnost \"Zdědit\" použije všechna nastavení vyšší úrovně (pokud je nastavena) nebo nastavení na úrovni průzkumu (ve výchozím nastavení \"Nahoře\")."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "Možnost \"Zdědit\" použije nastavení na úrovni průzkumu (ve výchozím nastavení \"Pod názvem otázky\")."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Nastaví umístění chybové zprávy ve vztahu k otázce s neplatným vstupem. Vyberte si mezi: \"Nahoře\" - text chyby je umístěn v horní části pole s otázkou; \"Bottom\" - text chyby je umístěn ve spodní části pole s otázkou. Možnost \"Zdědit\" použije nastavení na úrovni průzkumu (ve výchozím nastavení \"Nahoře\")."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Přidá mezeru nebo okraj mezi obsah otázky a levý okraj pole otázky."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Nastaví šířku otázky v poměru k ostatním prvkům průzkumu ve stejném řádku. Přijímá hodnoty CSS (px, %, in, pt atd.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Pomocí ikony kouzelné hůlky nastavte ověřovací pravidlo pro otázku."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Vyberte si z těchto možností: \"Při ztrátě fokusu\" - hodnota se aktualizuje, když vstupní pole ztratí fokus; \"Při psaní\" - hodnota se aktualizuje v reálném čase, jak uživatelé píší. Možnost \"Zdědit\" použije nastavení na úrovni průzkumu (ve výchozím nastavení \"Při ztrátě fokusu\")."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Jako zdroj dat pro otázky s výběrem odpovědí můžete použít libovolnou webovou službu. Pokud chcete naplnit hodnoty voleb, zadejte adresu URL služby, která data poskytuje."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Operace porovnání, která se používá k filtrování rozevíracího seznamu."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Nastaví šířku zobrazené oblasti podpisu a výsledného obrazu."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Nastaví výšku zobrazené oblasti podpisu a výsledného obrazu."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Vyberte, zda chcete, aby oblast podpisu vyplnila veškerý dostupný prostor v poli pro otázky při zachování výchozího poměru stran 3:2. Pokud jsou nastaveny vlastní hodnoty šířky a výšky, nastavení zachová poměr stran těchto rozměrů."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Upraví výšku obrázku ve výsledcích měření."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Upraví šířku obrázku ve výsledcích měření."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Přepíše minimální a maximální hodnoty výšky."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Přepíše minimální a maximální hodnoty šířky."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Hodnota\" slouží jako ID položky používané v podmíněných pravidlech; Respondentům se zobrazí \"Text\"."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Toto nastavení pouze mění velikost vstupního pole a nemá vliv na šířku pole s otázkou. Chcete-li omezit přijatelnou délku vstupu, přejděte na <b>Ověření → Maximální limit znaků</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Nastaví počet zobrazených řádků ve vstupním poli. Pokud vstup zabírá více řádků, zobrazí se posuvník."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Vyberte si mezi: \"Upravitelné\" - umožňuje respondentům vyplnit váš průzkum; \"Read-only\" - zakáže editaci formulářů."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "ID sloupce, které není viditelné pro respondenty."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Pokud je tato možnost povolena pro sloupec, respondent musí poskytnout jedinečnou odpověď na každou otázku v tomto sloupci."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Nastaví počet zobrazených řádků ve vstupním poli. Pokud vstup zabírá více řádků, zobrazí se posuvník."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje viditelnost sloupce."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které zakáže režim jen pro čtení pro sloupec."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které zabrání odeslání průzkumu, pokud alespoň jedna vnořená otázka nemá odpověď."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Pokud je tato možnost vybraná, vytvoří samostatný sloupec pro každou možnost volby."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Vyberte si z: \"Statické\" - nastaví pevnou šířku; \"Responzivní\" - způsobí, že průzkum bude zabírat celou šířku obrazovky; \"Auto\" – použije jednu z těchto dvou možností v závislosti na použitých typech otázek."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Vložte odkaz na obrázek (bez omezení velikosti) nebo klikněte na ikonu složky a procházejte soubor z počítače (až 64 kB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Nastaví šířku loga v jednotkách CSS (px, %, in, pt atd.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Nastaví výšku loga v jednotkách CSS (px, %, in, pt atd.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Vyberte si z těchto možností: \"Žádné\" - obrázek si zachová svou původní velikost; \"Obsahovat\" - velikost obrázku se změní tak, aby se vešel při zachování poměru stran; \"Obálka\" - obrázek vyplní celý rámeček při zachování poměru stran; \"Výplň\" - obrázek je roztažen tak, aby vyplnil rámeček bez zachování poměru stran."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Vyberte, zda chcete, aby průzkum automaticky postoupil na další stránku poté, co respondent odpoví na všechny otázky na aktuální stránce."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Nastaví viditelnost a umístění navigačních tlačítek na stránce."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Nastaví viditelnost a umístění indikátoru průběhu. Hodnota \"Auto\" zobrazuje indikátor průběhu nad nebo pod záhlavím průzkumu."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Povolte stránku náhledu pouze se všemi nebo zodpovězenými otázkami."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Platí pro všechny otázky v rámci průzkumu. Toto nastavení lze přepsat pravidly zarovnání nadpisů na nižších úrovních: panel, stránka nebo otázka. Nastavení nižší úrovně přepíše nastavení na vyšší úrovni."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Symbol nebo posloupnost symbolů označující, že je vyžadována odpověď."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Zadejte číslo nebo písmeno, kterým chcete začít číslovat."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Nastaví umístění chybové zprávy ve vztahu k otázce s neplatným vstupem. Vyberte si mezi: \"Nahoře\" - text chyby je umístěn v horní části pole s otázkou; \"Bottom\" - text chyby je umístěn ve spodní části pole s otázkou."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Vyberte, zda chcete, aby první vstupní pole na každé stránce bylo připraveno pro zadání textu."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Zachová původní pořadí otázek nebo je náhodně vybere. Účinek tohoto nastavení je viditelný pouze na kartě Náhled."
// pehelp.maxTextLength: "For text entry questions only." => "Pouze pro otázky pro zadávání textu."
// pehelp.maxOthersLength: "For question comments only." => "Pouze pro komentáře k otázkám."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Vyberte, zda chcete, aby se komentáře k otázkám a otázky s dlouhým textem automaticky zvětšovaly na výšku podle zadané délky textu."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Pouze pro komentáře k otázkám a otázky s dlouhým textem."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Vlastní proměnné slouží jako mezilehlé nebo pomocné proměnné používané při výpočtech formulářů. Jako zdrojové hodnoty berou vstupy respondentů. Každá vlastní proměnná má jedinečný název a výraz, na kterém je založena."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Vyberte, zda chcete, aby byla vypočtená hodnota výrazu uložena spolu s výsledky průzkumu."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Aktivační událost je událost nebo podmínka, která je založena na výrazu. Jakmile je výraz vyhodnocen jako \"true\", trigger spustí akci. Taková akce může mít volitelně cílovou otázku, kterou ovlivňuje."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Zvolte, zda chcete vymazat hodnoty otázek skrytých podmíněnou logikou a kdy to udělat."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Vyberte si z těchto možností: \"Při ztrátě fokusu\" - hodnota se aktualizuje, když vstupní pole ztratí fokus; \"Při psaní\" - hodnota se aktualizuje v reálném čase, jak uživatelé píší."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Levá hodnota slouží jako ID sloupce používané v podmíněných pravidlech, pravá hodnota se zobrazuje respondentům."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Levá hodnota slouží jako ID řádku používané v podmíněných pravidlech, pravá hodnota se zobrazuje respondentům."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Přijímá hodnoty CSS (px, %, in, pt atd.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Přijímá hodnoty CSS (px, %, in, pt atd.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Nastaví umístění chybové zprávy ve vztahu k buňce s neplatným vstupem. Možnost \"Zdědit\" použije nastavení z vlastnosti \"Zarovnání chybové zprávy\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Pokud je povolena vlastnost \"Zabránit duplicitním odpovědím\", respondentovi, který se pokouší odeslat duplicitní záznam, se zobrazí následující chybová zpráva."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Umožňuje vypočítat celkové hodnoty na základě výrazu. Výraz může obsahovat základní výpočty ('{q1_id} + {q2_id}'), logické výrazy ('{age} > 60') a funkce ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' atd.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Spustí výzvu s žádostí o potvrzení odstranění řádku."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Duplikuje odpovědi z posledního řádku a přiřadí je k dalšímu přidanému dynamickému řádku."
// pehelp.description: "Type a subtitle." => "Zadejte titulky."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Vyberte jazyk a začněte vytvářet průzkum. Chcete-li přidat překlad, přepněte do nového jazyka a přeložte původní text zde nebo na kartě Překlady."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Nastaví umístění oddílu podrobností ve vztahu k řádku. Vyberte si z těchto možností: \"Žádné\" - není přidáno žádné rozšíření; \"Pod řádkem\" - pod každým řádkem matice je umístěno rozšíření řádku; \"Pod řádkem zobrazit pouze jedno rozšíření řádku\" - rozšíření je zobrazeno pouze pod jedním řádkem, zbývající rozšíření řádků jsou sbalena."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Vyberte si z těchto možností: \"Žádné\" - obrázek si zachová svou původní velikost; \"Obsahovat\" - velikost obrázku se změní tak, aby se vešel při zachování poměru stran; \"Obálka\" - obrázek vyplní celý rámeček při zachování poměru stran; \"Výplň\" - obrázek je roztažen tak, aby vyplnil rámeček bez zachování poměru stran."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Postupně zvětšuje výšku vstupního pole při zadávání dat. Přepíše nastavení \"Výška vstupního pole (v řádcích)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Úchyt pro změnu velikosti (nebo uzel) se zobrazí v rohu a lze jej přetáhnout a změnit tak velikost vstupního pole."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Časový interval v sekundách, po jehož uplynutí se průzkum automaticky přesune na stránku s poděkováním."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Časový interval v sekundách, po jehož uplynutí se průzkum automaticky přesune na další stránku."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Časový interval v sekundách, po jehož uplynutí se průzkum automaticky přesune na další stránku."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje viditelnost stránky."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které zakáže režim pouze pro čtení stránky."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Pomocí ikony kouzelné hůlky nastavte podmíněné pravidlo, které zabrání odeslání průzkumu, pokud alespoň jedna vnořená otázka nemá odpověď."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Platí pro všechny otázky na této stránce. Chcete-li toto nastavení přepsat, definujte pravidla zarovnání nadpisů pro jednotlivé otázky nebo panely. Možnost \"Zdědit\" použije nastavení na úrovni průzkumu (ve výchozím nastavení \"Nahoře\")."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Nastaví umístění chybové zprávy ve vztahu k otázce s neplatným vstupem. Vyberte si mezi: \"Nahoře\" - text chyby je umístěn v horní části pole s otázkou; \"Bottom\" - text chyby je umístěn ve spodní části pole s otázkou. Možnost \"Zdědit\" použije nastavení na úrovni průzkumu (ve výchozím nastavení \"Nahoře\")."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Zachová původní pořadí otázek nebo je náhodně vybere. Možnost \"Zdědit\" použije nastavení na úrovni průzkumu (ve výchozím nastavení \"Původní\"). Účinek tohoto nastavení je viditelný pouze na kartě Náhled."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Nastaví viditelnost navigačních tlačítek na stránce. Možnost \"Zdědit\" použije nastavení na úrovni průzkumu, které je ve výchozím nastavení \"Viditelné\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Nastaví viditelnost a umístění časovače na stránce."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Vyberte si z těchto možností: \"Uzamčeno\" - uživatelé nemohou rozbalit nebo sbalit panely; \"Sbalit vše\" - všechny panely začínají ve sbaleném stavu; \"Rozbalit vše\" - všechny panely začínají v rozbaleném stavu; \"První rozbalený\" - zpočátku se rozbalí pouze první panel."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Zadejte název sdílené vlastnosti v poli objektů, které obsahuje adresy URL souborů obrázků nebo videí, které chcete zobrazit v seznamu voleb."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Levá hodnota slouží jako ID položky používané v podmíněných pravidlech, pravá hodnota se zobrazuje respondentům."
// pehelp.title: "Type a user-friendly title to display." => "Zadejte uživatelsky přívětivý název, který chcete zobrazit."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Zajistí, že uživatelé nedokončí průzkum, dokud nebudou soubory nahrány."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Přijímá hodnoty CSS (px, %, in, pt atd.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Přijímá hodnoty CSS (px, %, in, pt atd.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Přijímá hodnoty CSS (px, %, in, pt atd.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "V typech otázek s jedním a vícenásobným výběrem má každá možnost volby ID a zobrazovanou hodnotu. Pokud je tato možnost vybrána, zobrazí se v otázkách HTML a dynamických názvech a popisech prvků průzkumu zobrazená hodnota místo hodnoty ID."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Zvolte, zda chcete vymazat hodnoty otázek skryté podmíněnou logikou a kdy to udělat. Možnost \"Zdědit\" použije nastavení na úrovni průzkumu (ve výchozím nastavení \"Po dokončení průzkumu\")."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Vyberte si z: \"Vše\" - zkopíruje všechny možnosti výběru z vybrané otázky; \"Vybrané\" - dynamicky kopíruje pouze vybrané možnosti volby; \"Nevybráno\" - dynamicky zkopíruje pouze nevybrané možnosti výběru. Možnosti \"Žádné\" a \"Jiné\" jsou ve výchozím nastavení zkopírovány, pokud jsou povoleny ve zdrojové otázce."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Pokud je tato možnost vybraná, mohou uživatelé zahrnout další vstup do samostatného pole pro komentář."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Zobrazí každou speciální volbu (\"Žádná\", \"Jiné\", \"Vybrat vše\") na novém řádku, a to i při použití rozložení s více sloupci."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Zadejte umístění v datové sadě služby, kde se nachází cílové pole objektů. Ponechte prázdné, pokud adresa URL již odkazuje na pole."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Zadejte jednotný název vlastnosti v poli objektů, které obsahuje hodnoty, které chcete zobrazit v seznamu voleb."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Tuto možnost vyberte, pokud chcete, aby služba vracela prázdnou odpověď nebo pole."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Pomocí ikony kouzelné hůlky můžete nastavit podmíněné pravidlo, které určuje viditelnost všech voleb."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Levá hodnota slouží jako ID položky používané v podmíněných pravidlech, pravá hodnota se zobrazuje respondentům."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" vybírá mezi režimy \"Tlačítka\" a \"Rozbalovací nabídka\" na základě dostupné šířky. Pokud šířka není dostatečná k zobrazení tlačítek, zobrazí se v otázce rozevírací seznam."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Umožňuje propojit otázky, které poskytují výsledky v různých formátech. Pokud jsou takové otázky propojeny pomocí identifikátoru spojení, tato sdílená vlastnost ukládá vybrané hodnoty otázek."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Vyberte, zda chcete aktualizovat obsah rozevírací nabídky tak, aby odpovídal vyhledávacímu dotazu, který uživatel zadává do vstupního pole."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Hodnota, která se uloží do výsledků průzkumu, když respondenti odpoví kladně."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Hodnota, která se má uložit do výsledků průzkumu, když respondenti odpoví záporně."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Tuto možnost se nedoporučuje zakazovat, protože přepíše obrázek náhledu a uživateli ztíží pochopení, jestli byly soubory nahrány."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Spustí výzvu s žádostí o potvrzení odstranění souboru."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Povolením seřadíte pouze vybrané volby. Uživatelé přetáhnou vybrané položky ze seznamu voleb a seřadí je v oblasti hodnocení."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Zadejte seznam možností, které budou respondentovi navrženy během vstupu."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Nastavení mění pouze velikost vstupních polí a nemá vliv na šířku pole pro otázky."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Nastaví konzistentní šířku pro všechny popisky položek v pixelech"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Možnost \"Auto\" automaticky určí vhodný režim pro zobrazení – Obrázek, Video nebo YouTube – na základě zadané zdrojové adresy URL."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Slouží jako náhrada v případě, že obrázek nelze zobrazit na zařízení uživatele, a pro účely usnadnění."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Definuje barvu vybraného emotikonu, když je typ ikony Hodnocení nastaven na \"Smajlíky\". Vyberte si mezi: \"Výchozí\" - vybraný emotikon se zobrazí ve výchozí barvě průzkumu; \"Měřítko\" - vybraný emotikon zdědí barvu ze stupnice hodnocení."
// expression.name: "An expression ID that is not visible to respondents." => "ID výrazu, které není viditelné pro respondenty."
// expression.description: "Type an expression subtitle." => "Zadejte výraz subtitle."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Výraz může obsahovat základní výpočty ('{q1_id} + {q2_id}'), podmínky ('{age} > 60') a funkce ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' atd.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Tuto možnost vyberte, chcete-li uložit hodnotu možnosti \"Jiné\" jako samostatnou vlastnost ve výsledcích průzkumu."
// p.swapOrder: "Swap the order of Yes and No" => "Prohození pořadí Ano a Ne"
// p.itemTitleWidth: "Item label width (in px)" => "Šířka popisku položky (v px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Text, který se zobrazí, pokud jsou vybrány všechny možnosti"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Zástupný text pro oblast hodnocení"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Automatické vyplnění dotazníku"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Vyberte, zda chcete, aby se průzkum vyplnil automaticky poté, co respondent odpoví na všechny otázky."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Uložit maskovanou hodnotu ve výsledcích průzkumu"
// patternmask.pattern: "Value pattern" => "Vzor hodnoty"
// datetimemask.min: "Minimum value" => "Minimální hodnota"
// datetimemask.max: "Maximum value" => "Maximální hodnota"
// numericmask.allowNegativeValues: "Allow negative values" => "Povolit záporné hodnoty"
// numericmask.thousandsSeparator: "Thousands separator" => "Oddělovač tisíců"
// numericmask.decimalSeparator: "Decimal separator" => "Oddělovač desetinných míst"
// numericmask.precision: "Value precision" => "Přesnost hodnoty"
// numericmask.min: "Minimum value" => "Minimální hodnota"
// numericmask.max: "Maximum value" => "Maximální hodnota"
// currencymask.prefix: "Currency prefix" => "Předpona měny"
// currencymask.suffix: "Currency suffix" => "Přípona měny"
// pe.maskType: "Input mask type" => "Typ vstupní masky"
// maskTypes.patternmask: "Pattern" => "Vzor"
// maskTypes.numericmask: "Numeric" => "Číselný"
// maskTypes.datetimemask: "Date and Time" => "Datum a čas"
// maskTypes.currencymask: "Currency" => "Měna"
// tabs.mask: "Input Mask Settings" => "Nastavení vstupní masky"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Př.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Př.: dd/mm/rrrr"
// pe.currencyprefix_placeholder: "Ex.: $" => "Př.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Př.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Možnosti obtékání"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Dlouhé texty v možnostech volby automaticky vygenerují zalomení řádků, aby se vešly do rozbalovací nabídky. Odznačte, pokud chcete, aby se texty ořízly."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Vyberte, zda chcete uložit hodnotu otázky s použitou maskou do výsledků průzkumu."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Vzor může obsahovat řetězcové literály a následující zástupné symboly: \"9\" - pro číslici; \"a\" - pro velké nebo malé písmeno; '#' - pro číslici nebo velké či malé písmeno. Pomocí zpětného lomítka \\ můžete znak uvozovat."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Vzor může obsahovat oddělovací znaky a následující zástupné symboly: 'm' - pro číslo měsíce; 'mm' - pro číslo měsíce, s úvodní nulou pro jednociferné hodnoty; \"d\" - pro den v měsíci; 'dd' - pro den v měsíci, s úvodní nulou pro jednociferné hodnoty; \"yy\" – pro poslední dvě číslice roku; \"rrrr\" – pro čtyřmístný rok."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Symbol používaný k oddělení zlomkové části od celočíselné části zobrazeného čísla."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Symbol používaný k oddělení číslic velkého čísla do skupin po třech."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Omezuje, kolik číslic se má zachovat za desetinnou čárkou zobrazeného čísla."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Jeden nebo více symbolů, které mají být zobrazeny před hodnotou."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Jeden nebo více symbolů, které se zobrazí za hodnotou."
// ed.translationSource: "Source: " => "Zdroj: "
// ed.translationTarget: "Target: " => "Cíl: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Stránka je prázdná. Přetáhněte prvek z palety nástrojů nebo klikněte na tlačítko níže."
// maskTypes.none: "None" => "Žádný"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Zviditelněte řádek, pokud"
// itemvalue@rows.enableIf: "Make the row editable if" => "Zajistěte, aby byl řádek upravitelný, pokud"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Zástupný text v režimu jen pro čtení nebo v režimu náhledu"
// pe.textWrapEnabled: "Wrap choices" => "Možnosti obtékání"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Možnost \"Auto\" automaticky určí vhodný režim pro zobrazení – Obrázek, Video nebo YouTube – na základě zadané zdrojové adresy URL."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Vyberte si mezi \"Obrazem\" a \"Video\" a nastavte režim obsahu voliče médií. Pokud je vybrána možnost \"Obrázek\", ujistěte se, že všechny nabízené možnosti jsou obrazové soubory v následujících formátech: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Podobně, pokud je vybráno \"Video\", ujistěte se, že všechny možnosti jsou přímými odkazy na video soubory v následujících formátech: MP4, MOV, WMV, FLV, AVI, MKV. Upozorňujeme, že odkazy na YouTube nejsou podporovány u možností videa."
// ed.selectFile: "Select a file" => "Vyberte soubor"
// ed.removeFile: "Remove the file" => "Odebrání souboru"
// pe.searchMode: "Search Mode" => "Režim vyhledávání"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Kliknutím na tlačítko \"Přidat otázku\" níže zahájíte vytváření formuláře."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Kliknutím na tlačítko \"Přidat otázku\" níže přidáte na stránku nový prvek."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Kliknutím na tlačítko \"Přidat otázku\" níže přidáte do panelu nový prvek."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Klikněte na tlačítko níže a vyberte obrázek, který chcete nahrát"
// coloralpha.opacity: "Opacity" => "Neprůhlednost"
// font.family: "Font family" => "Rodina písem"
// font.color: "Color" => "Barva"
// font.placeholderColor: "Placeholder color" => "Barva zástupného symbolu"
// font.size: "Size" => "Velikost"
// theme.themeName: "Theme" => "Téma"
// theme.isPanelless: "Question appearance" => "Vzhled otázky"
// theme.editorPanel: "Background and corner radius" => "Pozadí a poloměr rohů"
// theme.questionPanel: "Background and corner radius" => "Pozadí a poloměr rohů"
// theme.primaryColor: "Accent color" => "Barva zvýraznění"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Neprůhlednost pozadí panelu"
// theme.questionBackgroundTransparency: "Question background opacity" => "Neprůhlednost pozadí otázky"
// theme.fontSize: "Font size" => "Velikost písma"
// theme.scale: "Scale" => "Škála"
// theme.cornerRadius: "Corner radius" => "Poloměr rohu"
// theme.pageTitle: "Title font" => "Písmo nadpisu"
// theme.pageDescription: "Description font" => "Popisné písmo"
// theme.questionTitle: "Title font" => "Písmo nadpisu"
// theme.questionDescription: "Description font" => "Popisné písmo"
// theme.editorFont: "Font" => "Písmo"
// theme.backgroundOpacity: "Opacity" => "Neprůhlednost"
// theme.--sjs-font-family: "Font family" => "Rodina písem"
// theme.--sjs-general-backcolor-dim: "Background color" => "Barva pozadí"
// theme.--sjs-primary-backcolor: "Accent background" => "Zvýraznění pozadí"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Zvýraznění popředí"
// theme.--sjs-shadow-small: "Shadow effects" => "Stínové efekty"
// theme.--sjs-shadow-inner: "Shadow effects" => "Stínové efekty"
// theme.--sjs-border-default: "Colors" => "Barvy"
// header@header.headerView: "View" => "Pohled"
// header@header.logoPosition: "Logo position" => "Umístění loga"
// header@header.surveyTitle: "Survey title font" => "Písmo názvu průzkumu"
// header@header.surveyDescription: "Survey description font" => "Písmo popisu průzkumu"
// header@header.headerTitle: "Survey title font" => "Písmo názvu průzkumu"
// header@header.headerDescription: "Survey description font" => "Písmo popisu průzkumu"
// header@header.inheritWidthFrom: "Content area width" => "Šířka oblasti obsahu"
// header@header.textAreaWidth: "Text width" => "Šířka textu"
// header@header.backgroundColorSwitch: "Background color" => "Barva pozadí"
// header@header.backgroundImage: "Background image" => "Obrázek na pozadí"
// header@header.backgroundImageOpacity: "Opacity" => "Neprůhlednost"
// header@header.overlapEnabled: "Overlap" => "Překrytí"
// header@header.logoPositionX: "Logo position" => "Umístění loga"
// header@header.titlePositionX: "Title position" => "Pozice v titulu"
// header@header.descriptionPositionX: "Description position" => "Popis pozice"
// weight.400: "Regular" => "Pravidelný"
// weight.600: "Heavy" => "Těžký"
// weight.700: "Semi-bold" => "Polotučné písmo"
// weight.800: "Bold" => "Tučný"
// backgroundImageFit.auto: "Auto" => "Auto"
// backgroundImageFit.cover: "Cover" => "Krýt"
// backgroundImageFit.contain: "Contain" => "Obsahovat"
// backgroundImageFit.fill: "Stretch" => "Natáhnout"
// backgroundImageFit.tile: "Tile" => "Dlaždice"
// backgroundImageAttachment.fixed: "Fixed" => "Stabilní"
// backgroundImageAttachment.scroll: "Scroll" => "Svitek"
// headerView.basic: "Basic" => "Základní"
// headerView.advanced: "Advanced" => "Pokročilý"
// inheritWidthFrom.survey: "Same as survey" => "Stejné jako průzkum"
// inheritWidthFrom.container: "Fit to container" => "Vhodné pro kontejner"
// backgroundColorSwitch.none: "None" => "Žádný"
// backgroundColorSwitch.accentColor: "Accent color" => "Barva zvýraznění"
// backgroundColorSwitch.custom: "Custom" => "Zvyk"
// colorPalette.light: "Light" => "Světlo"
// colorPalette.dark: "Dark" => "Temný"
// isPanelless.false: "Default" => "Výchozí"
// isPanelless.true: "Without Panels" => "Bez panelů"
// theme.cornerRadius: "Corner radius" => "Poloměr rohu"
// theme.fontFamily: "Font family" => "Rodina písem"
// theme.fontWeightRegular: "Regular" => "Pravidelný"
// theme.fontWeightHeavy: "Heavy" => "Těžký"
// theme.fontWeightSemiBold: "Semi-bold" => "Polotučné písmo"
// theme.fontWeightBold: "Bold" => "Tučný"
// theme.color: "Color" => "Barva"
// theme.placeholderColor: "Placeholder color" => "Barva zástupného symbolu"
// theme.size: "Size" => "Velikost"
// theme.opacity: "Opacity" => "Neprůhlednost"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Chcete-li hledat, zadejte jej..."
// ed.toolboxNoResultsFound: "No results found" => "Nebyly nalezeny žádné výsledky"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Zástupný symbol názvu tabulátoru"
// theme.--sjs-special-red: "Error messages" => "Chybové zprávy"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Záložní text pro názvy karet, který se použije, když vzor názvu karty nevytváří smysluplnou hodnotu."
// theme.fontColor: "Font color" => "Barva písma"
// theme.backgroundColor: "Background color" => "Barva pozadí"
// pe.questionTitleWidth: "Question title width" => "Šířka názvu otázky"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Vyberte soubor nebo vložte odkaz na soubor..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Př.: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Nastaví konzistentní šířku názvů otázek, pokud jsou zarovnány nalevo od polí s otázkami. Přijímá hodnoty CSS (px, %, in, pt atd.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Nastaví konzistentní šířku názvů otázek, pokud jsou zarovnány nalevo od polí s otázkami. Přijímá hodnoty CSS (px, %, in, pt atd.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Výška oblasti komentářů (v řádcích)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Nastaví počet zobrazených řádků v textových oblastech pro komentáře k otázkám. V případě, že vstup zabírá více řádků, zobrazí se posuvník."


/***/ }),

/***/ "./src/localization/danish.ts":
/*!************************************!*\
  !*** ./src/localization/danish.ts ***!
  \************************************/
/*! exports provided: danishStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "danishStrings", function() { return danishStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var danishStrings = {
    // survey templates
    survey: {
        edit: "Rediger",
        externalHelpLink: "Se og lær, hvordan du opretter undersøgelser",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Træk et spørgsmål hertil fra paletten til venstre.",
        addLogicItem: "Opret en regel for at tilpasse undersøgelsens flow.",
        copy: "Kopier",
        duplicate: "Multiplicere",
        addToToolbox: "Tilføj til paletten",
        deletePanel: "Slet panel",
        deleteQuestion: "Slet spørgsmål",
        convertTo: "Konverter til",
        drag: "Træk element",
    },
    // Creator tabs
    tabs: {
        preview: "Afprøv undersøgelse",
        theme: "Temaer",
        translation: "Oversættelse",
        designer: "Undersøgelsesdesigner",
        editor: "JSON Editor",
        logic: "Logik"
    },
    // Question types
    qt: {
        default: "Standard",
        checkbox: "Afkrydsningsfelt",
        comment: "Kommentar",
        imagepicker: "Billedvælger",
        ranking: "Rangering",
        image: "Billede",
        dropdown: "Dropdown",
        tagbox: "Rullemenu med flere valg",
        file: "Fil",
        html: "Html",
        matrix: "Matrice (ét valg)",
        matrixdropdown: "Matrice (flere valg)",
        matrixdynamic: "Matrice (dynamiske rækker)",
        multipletext: "Flere tekstfelter",
        panel: "Panel",
        paneldynamic: "Panel (dynamiske paneler)",
        radiogroup: "Alternativknap",
        rating: "Vurdering",
        text: "Tekstfelt",
        boolean: "Sandt/falsk",
        expression: "Udtryk",
        signaturepad: "Underskrift",
        buttongroup: "Knap gruppe"
    },
    toolboxCategories: {
        general: "Generelt",
        choice: "Spørgsmål om valg",
        text: "Spørgsmål om tekstinput",
        containers: "Containere",
        matrix: "Matrix spørgsmål",
        misc: "Misc"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Standard ({0})",
        survey: "Undersøgelse",
        settings: "Indstillinger for undersøgelse",
        settingsTooltip: "Åbn indstillinger",
        surveySettings: "Indstillinger for undersøgelse",
        surveySettingsTooltip: "Indstillinger for undersøgelse",
        themeSettings: "Temaindstillinger",
        themeSettingsTooltip: "Temaindstillinger",
        showPanel: "Vis panel",
        hidePanel: "Skjul panel",
        prevSelected: "Vælg forrige",
        nextSelected: "Vælg næste",
        prevFocus: "Fokus forrige",
        nextFocus: "Fokuser næste",
        surveyTypeName: "Spørgeundersøgelse",
        pageTypeName: "Side",
        panelTypeName: "Panelet",
        questionTypeName: "Spørgsmål",
        columnTypeName: "Kolonne",
        addNewPage: "Tilføj ny side",
        moveRight: "Gå til højre",
        moveLeft: "Gå til venstre",
        deletePage: "Slet side",
        editPage: "Rediger side",
        edit: "Rediger",
        newPageName: "side",
        newQuestionName: "spørgsmål",
        newPanelName: "panel",
        newTextItemName: "Tekst",
        defaultV2Theme: "Standard",
        modernTheme: "Moderne",
        defaultTheme: "Standard (ældre)",
        testSurveyAgain: "Afprøv undersøgelse igen",
        testSurveyWidth: "Bredde af undersøgelse: ",
        navigateToMsg: "Du var nødt til at navigere til",
        saveSurvey: "Gem undersøgelse",
        saveSurveyTooltip: "Gem undersøgelse",
        saveTheme: "Gem tema",
        saveThemeTooltip: "Gem tema",
        jsonHideErrors: "Skjul fejl",
        jsonShowErrors: "Vis fejl",
        undo: "Fortryd",
        redo: "Annuller fortryd",
        undoTooltip: "Fortryd seneste ændring",
        redoTooltip: "Fortryd ændringen",
        showMoreChoices: "Vis mere",
        showLessChoices: "Vis mindre",
        copy: "Eksemplar",
        cut: "Skære",
        paste: "Indsætte",
        copyTooltip: "Kopiere markering til Udklipsholder",
        cutTooltip: "Klip markering til udklipsholder",
        pasteTooltip: "Indsæt fra udklipsholder",
        options: "Indstillinger",
        generateValidJSON: "Generer gylding JSON",
        generateReadableJSON: "Generer læsbar JSON",
        toolbox: "Værktøjskasse",
        "property-grid": "Egenskaber",
        toolboxFilteredTextPlaceholder: "Skriv for at søge...",
        toolboxNoResultsFound: "Ingen resultater fundet",
        propertyGridFilteredTextPlaceholder: "Skriv for at søge...",
        propertyGridNoResultsFound: "Ingen resultater fundet",
        correctJSON: "Ret venligst JSON.",
        surveyResults: "Undersøgelsesresultat: ",
        surveyResultsTable: "Som tabel",
        surveyResultsJson: "Som JSON",
        resultsTitle: "Spørgsmålets titel",
        resultsName: "Spørgsmålets navn",
        resultsValue: "Svarværdi",
        resultsDisplayValue: "Visningsværdi",
        modified: "Ændret",
        saving: "Gemmer",
        saved: "Gemt",
        propertyEditorError: "Fejl",
        saveError: "Fejl! Undersøgelsen er ikke blevet gemt.",
        translationPropertyGridTitle: "Sprogindstillinger",
        themePropertyGridTitle: "Temaindstillinger",
        translationLanguages: "Sprog",
        translationDeleteLanguage: "Er du sikker på, at du ønsker at slette alle strenge for dette sprog?",
        translationAddLanguage: "Vælg et sprog at oversætte",
        translationShowAllStrings: "Vis alle tekststrenge",
        translationShowUsedStringsOnly: "Kun brugte strenge",
        translationShowAllPages: "Vis alle sider",
        translationNoStrings: "Ingen tekststrenge at oversætte. Ret filteret.",
        translationExportToSCVButton: "Eksporter til CSV",
        translationImportFromSCVButton: "Importer fra CSV",
        translateUsigAI: "Oversæt automatisk alle",
        translateUsigAIFrom: "Oversæt fra: ",
        translationDialogTitle: "Uoversatte strenge",
        translationMergeLocaleWithDefault: "Flet {0} med standardsprog",
        translationPlaceHolder: "Oversættelse...",
        translationSource: "Kilde: ",
        translationTarget: "Mål: ",
        themeExportButton: "Eksport",
        themeImportButton: "Import",
        surveyJsonExportButton: "Eksport",
        surveyJsonImportButton: "Import",
        surveyJsonCopyButton: "Kopier til udklipsholder",
        themeResetButton: "Nulstil temaindstillinger til standard",
        themeResetConfirmation: "Vil du virkelig nulstille temaet? Alle dine tilpasninger går tabt.",
        themeResetConfirmationOk: "Ja, nulstil temaet",
        bold: "Modig",
        italic: "Kursiv",
        underline: "Understrege",
        addNewQuestion: "Tilføj spørgsmål",
        selectPage: "Vælg side...",
        carryForwardChoicesCopied: "Valg kopieres fra",
        choicesLoadedFromWebText: "Valg indlæses fra en webtjeneste.",
        choicesLoadedFromWebLinkText: "Gå til indstillinger",
        choicesLoadedFromWebPreviewTitle: "Forhåndsvisning af indlæste valgmuligheder",
        htmlPlaceHolder: "HTML-indhold vil være her.",
        panelPlaceHolder: "Smid et spørgsmål fra værktøjskassen her.",
        surveyPlaceHolder: "Undersøgelsen er tom. Træk et element fra værktøjskassen, eller klik på knappen nedenfor.",
        pagePlaceHolder: "Siden er tom. Træk et element fra værktøjskassen, eller klik på knappen nedenfor.",
        imagePlaceHolder: "Træk og slip et billede her, eller klik på knappen nedenfor, og vælg et billede, der skal uploades",
        surveyPlaceHolderMobile: "Klik på knappen \"Tilføj spørgsmål\" nedenfor for at begynde at oprette din formular.",
        pagePlaceHolderMobile: "Klik på knappen \"Tilføj spørgsmål\" nedenfor for at tilføje et nyt element til siden.",
        panelPlaceHolderMobile: "Klik på knappen \"Tilføj spørgsmål\" nedenfor for at tilføje et nyt element til panelet.",
        imagePlaceHolderMobile: "Klik på knappen nedenfor, og vælg et billede, der skal uploades",
        imageChooseImage: "Vælg billede",
        addNewTypeQuestion: "Tilføj {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Vare ",
        selectFile: "Vælg en fil",
        removeFile: "Fjern filen",
        lg: {
            addNewItem: "Tilføj ny regel",
            empty_tab: "Opret en regel for at tilpasse undersøgelsens flow.",
            page_visibilityName: "Vis (skjul) side",
            page_enableName: "Aktivér (deaktiver) side",
            page_requireName: "Gør siden påkrævet",
            panel_visibilityName: "Panelet Vis (skjul)",
            panel_enableName: "Aktivér (deaktiver) panel",
            panel_requireName: "Gør siden påkrævet",
            question_visibilityName: "Vis (skjul) spørgsmål",
            question_enableName: "Aktivér (deaktiver) spørgsmål",
            question_requireName: "Gør spørgsmål påkrævet",
            question_resetValueName: "Nulstil spørgsmålsværdi",
            question_setValueName: "Angiv spørgsmålsværdi",
            column_visibilityName: "Vis (skjul) kolonne",
            column_enableName: "Aktivér (deaktiver) kolonne",
            column_requireName: "Gør kolonne påkrævet",
            column_resetValueName: "Nulstil kolonneværdi",
            column_setValueName: "Angiv kolonneværdi",
            trigger_completeName: "Komplet undersøgelse",
            trigger_setvalueName: "Indstil svar",
            trigger_copyvalueName: "Kopier svar",
            trigger_skipName: "Spring til spørgsmål",
            trigger_runExpressionName: "Kør udtryk",
            completedHtmlOnConditionName: "Indstil sidemarkering af \"Undersøgelse fuldført\"",
            page_visibilityDescription: "Gør siden synlig, når det logiske udtryk returnerer sand. Ellers skal du holde det usynligt.",
            panel_visibilityDescription: "Gør panelet synligt, når det logiske udtryk returnerer sand. Ellers skal du holde det usynligt.",
            panel_enableDescription: "Få panelet og alle elementer i det til at aktivere, når det logiske udtryk returnerer sand. Ellers skal du holde dem deaktiveret.",
            question_visibilityDescription: "Gør spørgsmålet synligt, når det logiske udtryk returnerer sand. Ellers skal du holde det usynligt.",
            question_enableDescription: "Få spørgsmålet til at aktivere, når det logiske udtryk returnerer sand. Ellers skal du holde det deaktiveret.",
            question_requireDescription: "Spørgsmål bliver påkrævet, når det logiske udtryk returnerer sandt.",
            trigger_completeDescription: "Når det logiske udtryk returnerer sand, afsluttes undersøgelsen, og en slutbruger ser siden \"Tak\".",
            trigger_setvalueDescription: "Når spørgsmålsværdier, der bruges i det logiske udtryk, ændres, og det logiske udtryk returnerer sand, angives værdien til det valgte spørgsmål.",
            trigger_copyvalueDescription: "Når spørgsmålsværdier, der bruges i det logiske udtryk, ændres, og det logiske udtryk returnerer sand, kopieres værdien af et markeret spørgsmål til et andet markeret spørgsmål.",
            trigger_skipDescription: "Når det logiske udtryk returnerer sandt, springer undersøgelsen til / fokuserer det valgte spørgsmål.",
            trigger_runExpressionDescription: "Når det logiske udtryk returnerer sand, udføres det brugerdefinerede udtryk. Du kan eventuelt angive dette udtryksresultat i det valgte spørgsmål",
            completedHtmlOnConditionDescription: "Hvis det logiske udtryk returnerer sandt, ændres standardteksten for 'Tak-siden' til den givne.",
            itemExpressionText: "Når udtrykket: '{0}' returnerer sandt",
            itemEmptyExpressionText: "Ny regel",
            page_visibilityText: "Gør siden {0} synlig",
            panel_visibilityText: "Gør panelet {0} synligt",
            panel_enableText: "Få panelet {0} aktivere",
            question_visibilityText: "Gør spørgsmål {0} synlige",
            question_enableText: "Foretag spørgsmål{0} aktiver",
            question_requireText: "Gør spørgsmål {0} påkrævet",
            question_resetValueText: "Nulstil værdi for spørgsmål: {0}",
            question_setValueText: "Tildel værdi: {1} til spørgsmål: {0}",
            column_visibilityText: "Gør kolonne {0} af spørgsmål {1} synlig",
            column_enableText: "Få kolonne {0} af spørgsmål {1} aktivere",
            column_requireText: "Gøre kolonne {0} af spørgsmål {1} påkrævet",
            column_resetValueText: "Nulstil celleværdi for kolonne: {0}",
            column_setValueText: "Tildel celleværdi: {1} til kolonne: {0}",
            setValueExpressionPlaceholder: " Et udtryk, hvis resultat vil blive tildelt målspørgsmålet.",
            trigger_completeText: "Undersøgelsen bliver afsluttet",
            trigger_setvalueText: "Sæt spørgsmålstegn ved: {0} værdi {1}",
            trigger_setvalueEmptyText: "Klar spørgsmålsværdi: {0}",
            trigger_copyvalueText: "Kopi i spørgsmål: {0} værdi fra spørgsmål {1}",
            trigger_skipText: "Undersøgelse Spring til spørgsmålet {0}",
            trigger_runExpressionText1: "Kør udtryk: '{0}'",
            trigger_runExpressionText2: " og sætte spørgsmålstegn ved resultatet: {0}",
            completedHtmlOnConditionText: "Vis brugerdefineret tekst til siden \"Tak\".",
            showAllQuestions: "Alle spørgsmål",
            showAllActionTypes: "Alle handlingstyper",
            conditions: "Tilstand(e)",
            actions: "Foranstaltning(er)",
            expressionEditorTitle: "Definer betingelse(r)",
            actionsEditorTitle: "Definer handling(er)",
            deleteAction: "Slet handling",
            addNewAction: "Tilføj handling",
            selectedActionCaption: "Vælg handling...",
            expressionInvalid: "Det logiske udtryk er tomt eller ugyldigt. Vær venlig at rette det.",
            noActionError: "Tilføj mindst én handling.",
            actionInvalid: "Løs venligst problemer i din(e) handling(er).",
            uncompletedRule_title: "Logiske regler er ufuldstændige",
            uncompletedRule_text: "Du har ikke gennemført nogle af de logiske regler. Hvis du forlader fanen nu, vil ændringerne gå tabt. Vil du stadig forlade fanen uden at gennemføre ændringerne?",
            uncompletedRule_apply: "Ja",
            uncompletedRule_cancel: "Nej, jeg vil gerne udfylde reglerne"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Panelets navn",
            title: "Panelets titel",
            description: "Beskrivelse af panelet",
            visibleIf: "Gør panelet synligt, hvis",
            requiredIf: "Gør panelet påkrævet, hvis",
            questionsOrder: "Spørgsmålsrækkefølge i panelet",
            page: "Overordnet side",
            startWithNewLine: "Få vist panelet på en ny linje",
            state: "Panelets sammenbrudstilstand",
            width: "Indlejret panelbredde",
            minWidth: "Mindste panelbredde",
            maxWidth: "Maksimal panelbredde",
            showNumber: "Paneler med tal"
        },
        paneldynamic: {
            name: "Panelets navn",
            title: "Panelets titel",
            description: "Beskrivelse af panelet",
            visibleIf: "Gør panelet synligt, hvis",
            requiredIf: "Gør panelet påkrævet, hvis",
            page: "Flyt panelet til siden",
            startWithNewLine: "Få vist panelet på en ny linje",
            state: "Panelets sammenbrudstilstand",
            width: "Indlejret panelbredde",
            minWidth: "Mindste panelbredde",
            maxWidth: "Maksimal panelbredde",
            confirmDelete: "Bekræft sletning af panel",
            templateDescription: "Panel beskrivelse mønster",
            templateTitle: "Panelets titelmønster",
            noEntriesText: "Tom paneltekst",
            templateTabTitle: "Fanetitel mønster",
            tabTitlePlaceholder: "Pladsholder til fanetitel",
            templateVisibleIf: "Gør et individuelt panel synligt, hvis",
            hideNumber: "Skjul panelnummeret",
            titleLocation: "Justering af paneltitel",
            descriptionLocation: "Justering af panelbeskrivelse",
            templateTitleLocation: "Tilpasning af spørgsmålets titel",
            templateErrorLocation: "Justering af fejlmeddelelse",
            newPanelPosition: "Ny panelplacering",
            keyName: "Undgå dublerede svar i følgende spørgsmål"
        },
        question: {
            name: "Navn på spørgsmål",
            title: "Spørgsmålets titel",
            description: "Beskrivelse af spørgsmål",
            visibleIf: "Gør spørgsmålet synligt, hvis",
            requiredIf: "Foretag spørgsmålet påkrævet, hvis",
            page: "Overordnet side",
            state: "Tilstand for sammenbrud af spørgsmålsfelt",
            hideNumber: "Skjul spørgsmålsnummeret",
            titleLocation: "Tilpasning af spørgsmålets titel",
            descriptionLocation: "Tilpasning af spørgsmålsbeskrivelse",
            errorLocation: "Justering af fejlmeddelelse",
            indent: "Forøg det indre indryk",
            width: "Indbygget spørgsmålsbredde",
            minWidth: "Mindste spørgsmålsbredde",
            maxWidth: "Maksimal spørgsmålsbredde",
            textUpdateMode: "Opdater inputfeltværdi"
        },
        signaturepad: {
            signatureWidth: "Bredde på signaturområde",
            signatureHeight: "Højde på signaturområde",
            signatureAutoScaleEnabled: "Skaler signaturområdet automatisk",
            showPlaceholder: "Vis pladsholderen",
            placeholder: "Pladsholdertekst",
            placeholderReadOnly: "Pladsholdertekst i skrivebeskyttet tilstand eller eksempeltilstand",
            allowClear: "Vis knappen Ryd i signaturområdet",
            penMinWidth: "Mindste bredde på pennen",
            penMaxWidth: "Maksimal bredde på pennen",
            penColor: "Stregfarve"
        },
        comment: {
            rows: "Inputfelthøjde (i linjer)"
        },
        showQuestionNumbers: "Vis spørgsmålsnumre",
        questionStartIndex: "Spørgsmål startindex (1, 2 eller 'A', 'a')",
        expression: {
            name: "Navn på udtryk",
            title: "Udtryk titel",
            description: "Beskrivelse af udtryk",
            expression: "Udtryk"
        },
        trigger: {
            expression: "Udtryk"
        },
        calculatedvalue: {
            expression: "Udtryk"
        },
        // survey templates
        survey: {
            title: "Titel",
            description: "Beskrivelse af undersøgelsen"
        },
        page: {
            name: "Sidenavn",
            title: "Titel",
            description: "Sidebeskrivelse",
            visibleIf: "Gør siden synlig, hvis",
            requiredIf: "Gør siden påkrævet, hvis",
            maxTimeToFinish: "Tidsgrænse for at afslutte siden (i sekunder)",
            questionsOrder: "Spørgsmålsrækkefølge på siden"
        },
        matrixdropdowncolumn: {
            name: "Kolonnens navn",
            title: "Kolonnens titel",
            isUnique: "Undgå dublerede svar",
            width: "Kolonnebredde",
            minWidth: "Mindste kolonnebredde",
            rows: "Inputfelthøjde (i linjer)",
            visibleIf: "Gør kolonnen synlig, hvis",
            requiredIf: "Gør kolonnen obligatorisk, hvis",
            showInMultipleColumns: "Hver indstilling i en separat kolonne"
        },
        multipletextitem: {
            name: "Navn",
            title: "Titel"
        },
        masksettings: {
            saveMaskedValue: "Gem maskeret værdi i undersøgelsesresultater"
        },
        patternmask: {
            pattern: "Værdimønster"
        },
        datetimemask: {
            min: "Mindste værdi",
            max: "Maksimal værdi"
        },
        numericmask: {
            allowNegativeValues: "Tillad negative værdier",
            thousandsSeparator: "Tusindtalsseparator",
            decimalSeparator: "Decimalseparator",
            precision: "Værdi præcision",
            min: "Mindste værdi",
            max: "Maksimal værdi"
        },
        currencymask: {
            prefix: "Valutapræfiks",
            suffix: "Suffiks for valuta"
        },
        imageHeight: "Billedhøjde",
        imageWidth: "Billedbredde",
        valueName: "Værdiens navn",
        rateDescriptionLocation: "Justering af etiketter",
        size: "Inputfeltstørrelse (i tegn)",
        cellErrorLocation: "Justering af cellefejlmeddelelse",
        apply: "Anvend",
        ok: "OK",
        save: "Spare",
        clear: "Tydelig",
        saveTooltip: "Spare",
        cancel: "Annuller",
        set: "Sæt",
        reset: "Nulstil",
        change: "Forandre",
        refresh: "Opdatere",
        close: "Luk",
        delete: "Slet",
        add: "Tilføje",
        addNew: "Tilføj ny",
        addItem: "Klik for at tilføje...",
        removeItem: "Klik for at fjerne elementet...",
        dragItem: "Træk elementet",
        addOther: "Anden",
        addSelectAll: "Vælg alle",
        addNone: "Ingen",
        removeAll: "Fjern alle",
        edit: "Rediger",
        back: "Returner uden at gemme",
        backTooltip: "Returner uden at gemme",
        saveAndBack: "Gem og returner",
        saveAndBackTooltip: "Gem og returner",
        doneEditing: "Gjort",
        editChoices: "Rediger valgmuligheder",
        showChoices: "Vis valgmuligheder",
        move: "Flyt",
        empty: "<tom>",
        emptyValue: "Værdien er tom",
        fastEntry: "Fast Entry",
        fastEntryNonUniqueError: "Værdien '{0}' er ikke unik",
        fastEntryChoicesCountError: "Begræns antallet af varer fra {0} til {1}",
        fastEntryChoicesMinCountError: "Indtast mindst {0} punkter",
        fastEntryPlaceholder: "Du kan indstille data i følgende format:\nværdi1|tekst\nværdi2",
        formEntry: "Form Entry",
        testService: "Test the service",
        itemSelectorEmpty: "Vælg elementet",
        conditionActionEmpty: "Vælg handlingen",
        conditionSelectQuestion: "Vælg spørgsmål...",
        conditionSelectPage: "Vælg side...",
        conditionSelectPanel: "Vælg panel...",
        conditionValueQuestionTitle: "Indtast/vælg værdi",
        aceEditorHelp: "Tast ctrl+space for hjælp til at afslutte udtrykket",
        aceEditorRowTitle: "Aktuel række",
        aceEditorPanelTitle: "Aktuelt panel",
        showMore: "Se dokumentationen for flere informationer",
        assistantTitle: "Tilgængelige spørgsmål:",
        cellsEmptyRowsColumns: "Der skal være mindst én kolonne eller række",
        showPreviewBeforeComplete: "Få vist et eksempel på svarene, før du indsender undersøgelsen",
        overridingPropertyPrefix: "Indstillet af ",
        resetToDefaultCaption: "Nulstille",
        propertyIsEmpty: "Indtast en værdi",
        propertyIsNoUnique: "Indtast en unik værdi",
        propertyNameIsNotUnique: "Indtast et unikt navn",
        propertyNameIsIncorrect: "Brug ikke reserverede ord: \"element\", \"valg\", \"panel\", \"række\".",
        listIsEmpty: "Der er endnu ikke tilføjet nogen varer",
        "listIsEmpty@choices": "Der er endnu ikke tilføjet nogen valgmuligheder",
        "listIsEmpty@columns": "Du har ikke nogen kolonner endnu",
        "listIsEmpty@rows": "Du har ingen rækker endnu",
        "listIsEmpty@validators": "Du har endnu ingen valideringsregler",
        "listIsEmpty@calculatedValues": "Du har endnu ingen tilpassede variabler",
        "listIsEmpty@triggers": "Du har ingen udløsere endnu",
        "listIsEmpty@navigateToUrlOnCondition": "Du har ingen links endnu",
        "addNew@choices": "Tilføj et valg",
        "addNew@columns": "Tilføj ny kolonne",
        "addNew@rows": "Tilføj ny række",
        "addNew@validators": "Tilføj ny regel",
        "addNew@calculatedValues": "Tilføj ny variabel",
        "addNew@triggers": "Tilføj ny udløser",
        "addNew@navigateToUrlOnCondition": "Tilføj ny webadresse",
        expressionIsEmpty: "Udtrykket er tomt",
        value: "Værdi",
        text: "Tekst",
        rowid: "Række ID",
        imageLink: "Billedlink",
        columnEdit: "Rediger kolonne: {0}",
        itemEdit: "Redigér: {0}",
        url: "URL",
        path: "Sti",
        choicesbyurl: {
            url: "Webtjenestens URL-adresse",
            valueName: "Hent værdier fra følgende JSON-felt"
        },
        titleName: "Titelnavn",
        imageLinkName: "Hent URL-adresser til billeder fra følgende JSON-felt",
        allowEmptyResponse: "Tillad tomt svar",
        titlePlaceholder: "Titel",
        surveyTitlePlaceholder: "Undersøgelsens titel",
        pageTitlePlaceholder: "Side {num}",
        descriptionPlaceholder: "Beskrivelse",
        surveyDescriptionPlaceholder: "Beskrivelse",
        pageDescriptionPlaceholder: "Beskrivelse",
        textWrapEnabled: "Valg af wrap",
        showOtherItem: "Har andet element",
        otherText: "Andet element tekst",
        showNoneItem: "Tillad indstillingen Ingen",
        showRefuseItem: "Tillad indstillingen Afvis at svare",
        showDontKnowItem: "Tillad indstillingen Ved ikke",
        noneText: "Ingen tekst til valgmulighed",
        showSelectAllItem: "Tillad indstillingen Vælg alt",
        selectAllText: "Vælg tekst med valgmuligheden Alle",
        choicesMin: "Minimumsværdi for automatisk genererede varer",
        choicesMax: "Maksimal værdi for automatisk genererede varer",
        choicesStep: "Trin for automatisk genererede elementer",
        name: "Navn",
        title: "Titel",
        cellType: "Celletype",
        colCount: "Antal kolonner",
        choicesOrder: "Vælg rækkefølge på valg",
        visible: "Er synlig?",
        isRequired: "Er påkrævet?",
        markRequired: "Markér efter behov",
        removeRequiredMark: "Fjern det påkrævede mærke",
        isAllRowRequired: "Kræv svar for alle rækker",
        eachRowUnique: "Undgå dublerede svar i rækker",
        requiredErrorText: "Fejlmeddelelsen \"Påkrævet\"",
        startWithNewLine: "Skal starte med ny linie?",
        rows: "Antal rækker",
        cols: "Kolonner",
        placeholder: "Hint-tekst",
        showPreview: "Vises forhåndsvisning af billeder?",
        storeDataAsText: "Gem filindhold i JSON-resultat som tekst",
        maxSize: "Maksimal filstørrelse i bytes",
        rowCount: "Antal rækker",
        columnLayout: "Kolonnelayout",
        addRowLocation: "Tilføj række knapplacering",
        transposeData: "Transponere rækker til kolonner",
        addRowText: "Tilføj række knaptekst",
        removeRowText: "Fjern række knaptekst",
        rateMin: "Mindste sats værdi",
        rateMax: "Maksimal sats værdi",
        rateStep: "Sats trin",
        minRateDescription: "Beskriv laveste vurdering",
        maxRateDescription: "Beskriv højeste vurdering",
        inputType: "Inputtype",
        optionsCaption: "Muligheder tekst",
        defaultValue: "Standardværdi",
        cellsDefaultRow: "Standard celletekst",
        surveyEditorTitle: "Rediger undersøgelsesindstillinger",
        qEditorTitle: "Redigér: {0}",
        maxLength: "Maximal længde",
        buildExpression: "Bygge",
        editExpression: "Redigere",
        and: "og",
        or: "eller",
        remove: "Fjerne",
        addCondition: "Tilføj betingelse",
        emptyLogicPopupMessage: "Vælg et spørgsmål for at begynde at konfigurere betingelser.",
        if: "Hvis",
        then: "derpå",
        setToName: "Mål spørgsmål",
        fromName: "Spørgsmål at kopiere svar fra",
        gotoName: "Spørgsmål at springe til",
        ruleIsNotSet: "Reglen er forkert",
        includeIntoResult: "Medtag i undersøgelsesresultater",
        showTitle: "Vis/skjul titel",
        expandCollapseTitle: "Udvid/skjul titel",
        locale: "Standardsprog",
        simulator: "Vælg enhedstype",
        landscapeOrientation: "Skift til liggende retning",
        portraitOrientation: "Skift til stående format",
        mode: "Mode (rediger/skrivebeskyttet)",
        clearInvisibleValues: "Fjern usynlige værdier",
        cookieName: "Cookienavn (for at undgå at afvikle undersøgelsen to gange lokalt)",
        sendResultOnPageNext: "Send undersøgelsesresultatet ved næste side",
        storeOthersAsComment: "Gem 'others' værdien i et seperat felt",
        showPageTitles: "Vis sidetitler",
        showPageNumbers: "Vis sidenumre",
        pagePrevText: "Forrige side knaptekst",
        pageNextText: "Næste side knaptekst",
        completeText: "Færdig knaptekst",
        previewText: "Tekst til knappen Vis svar",
        editText: "Tekst til knappen Rediger svar",
        startSurveyText: "Start knaptekst",
        showNavigationButtons: "Vis navigationsknapper (standard navigation)",
        showPrevButton: "Vis forrige knap (brugeren må gå tilbage til forrige side)",
        firstPageIsStarted: "Den første side in undersøgelsen er starten på undersøgelsen.",
        showCompletedPage: "Vis afslutningssiden til slut (completedHtml)",
        goNextPageAutomatic: "Gå til næste side automatisk når alle spørgsmål er besvaret",
        allowCompleteSurveyAutomatic: "Udfyld undersøgelsen automatisk",
        showProgressBar: "Vis fremdriftslinje",
        questionTitleLocation: "Spørgsmålstitel placering",
        questionTitleWidth: "Spørgsmålets titelbredde",
        requiredText: "Påkrævet spørgsmålssymbol(er)",
        questionTitleTemplate: "Spørgsmålstitel template, standard er: '{no}. {require} {title}'",
        questionErrorLocation: "Spørgsmålsfejl placering",
        focusFirstQuestionAutomatic: "Fokusér første spørgsmål ved sideskift",
        questionsOrder: "Rækkefølge af spørgsmål på siden",
        maxTimeToFinish: "Maximal tid til at gennemføre undersøgelsen",
        maxTimeToFinishPage: "Maximal tid til at gennemføre en side i undersøgelsen",
        showTimerPanel: "Vis tidspanel",
        showTimerPanelMode: "Vis tidspanel tilstand",
        renderMode: "Renderingstilstand",
        allowAddPanel: "Tillad at tilføje et panel",
        allowRemovePanel: "Tillad at fjerne et panel",
        panelAddText: "Tilføj panel tekst",
        panelRemoveText: "Fjern panel tekst",
        isSinglePage: "Vis alle elementer på én side",
        html: "HTML-markering",
        setValue: "Svare",
        dataFormat: "Billedformat",
        allowAddRows: "Tillad tilføjelse af rækker",
        allowRemoveRows: "Tillad fjernelse af rækker",
        allowRowsDragAndDrop: "Tillad træk og slip af rækker",
        responsiveImageSizeHelp: "Gælder ikke, hvis du angiver den nøjagtige billedbredde eller -højde.",
        minImageWidth: "Mindste billedbredde",
        maxImageWidth: "Maksimal billedbredde",
        minImageHeight: "Mindste billedhøjde",
        maxImageHeight: "Maksimal billedhøjde",
        minValue: "Mindste værdi",
        maxValue: "Maksimal værdi",
        minLength: "Mindste længde (med bogstaver)",
        allowDigits: "Tillad cifre",
        minCount: "Mindste antal",
        maxCount: "Maksimalt antal",
        regex: "Regulært udtryk",
        surveyvalidator: {
            text: "Fejlmeddelelse",
            expression: "Valideringsudtryk"
        },
        totalText: "Tekst i samlet række",
        totalType: "Samlet type",
        totalExpression: "Samlet udtryk",
        totalDisplayStyle: "Visningstypografi for samlet værdi",
        totalCurrency: "Valuta",
        totalFormat: "Formateret streng",
        logo: "Logo (URL eller base64-kodet streng)",
        questionsOnPageMode: "Undersøgelsens opbygning",
        maxTextLength: "Maksimal svarlængde (med tegn)",
        maxOthersLength: "Maksimal kommentarlængde (i tegn)",
        commentAreaRows: "Højde på kommentarområdet (i linjer)",
        autoGrowComment: "Udvid automatisk kommentarområdet, hvis det er nødvendigt",
        allowResizeComment: "Tillad brugere at ændre størrelsen på tekstområder",
        textUpdateMode: "Opdater værdi for tekstspørgsmål",
        maskType: "Type af inputmaske",
        maskTypes: {
            none: "Ingen",
            patternmask: "Mønster",
            numericmask: "Numerisk",
            datetimemask: "Dato og klokkeslæt",
            currencymask: "Valuta"
        },
        focusOnFirstError: "Sæt fokus på det første ugyldige svar",
        checkErrorsMode: "Kør validering",
        navigateToUrl: "Naviger til URL",
        navigateToUrlOnCondition: "Dynamisk webadresse",
        completedBeforeHtml: "Markering for at vise, om brugeren allerede har udfyldt denne undersøgelse",
        completedHtml: "Opmærkning af siden Undersøgelse fuldført",
        completedHtmlOnCondition: "Dynamisk undersøgelse fuldført sidemarkering",
        loadingHtml: "Markering, der skal vises, mens undersøgelsesmodellen indlæses",
        commentText: "Tekst i kommentarområdet",
        autocomplete: "Type Autofuldførelse",
        labelTrue: "\"True\" etiket",
        labelFalse: "Etiketten \"Falsk\"",
        allowClear: "Vis knappen Ryd",
        searchMode: "Søgetilstand",
        displayStyle: "Værdi visningsstil",
        format: "Formateret streng",
        maximumFractionDigits: "Maksimalt antal brøkdele",
        minimumFractionDigits: "Mindste brøkdele",
        useGrouping: "Vis grupperingsseparatorer",
        allowMultiple: "Tillad flere filer",
        allowImagesPreview: "Se eksempler på billeder",
        acceptedTypes: "Accepterede filtyper",
        waitForUpload: "Vent på, at overførslen er fuldført",
        needConfirmRemoveFile: "Bekræft sletning af fil",
        detailPanelMode: "Placering af panelet Detaljer",
        minRowCount: "Mindste antal rækker",
        maxRowCount: "Maksimalt antal rækker",
        confirmDelete: "Bekræft sletning af række",
        confirmDeleteText: "Bekræftelsesmeddelelse",
        panelCount: "Indledende antal paneler",
        minPanelCount: "Mindste antal paneler",
        maxPanelCount: "Maksimalt antal paneler",
        panelsState: "Udvid tilstand for indvendigt panel",
        panelPrevText: "Forrige værktøjstip til panelknap",
        panelNextText: "Værktøjstip til knappen Næste panel",
        showRangeInProgress: "Vis statuslinje",
        panelRemoveButtonLocation: "Fjern placering af panelknap",
        hideIfRowsEmpty: "Skjul spørgsmålet, hvis der ikke er nogen rækker",
        hideColumnsIfEmpty: "Skjule kolonner, hvis der ikke er nogen rækker",
        rateValues: "Tilpassede satsværdier",
        rateCount: "Antal satser",
        autoGenerate: "Hvordan angives satsværdier?",
        hideIfChoicesEmpty: "Skjul spørgsmålet, hvis det ikke indeholder nogen valgmuligheder",
        minWidth: "Minimumbredde (i CSS-accepterede værdier)",
        maxWidth: "Maksimal bredde (i CSS-accepterede værdier)",
        width: "Bredde (i CSS-accepterede værdier)",
        showHeader: "Vis kolonneoverskrifter",
        horizontalScroll: "Vis vandret rullepanel",
        columnMinWidth: "Mindste kolonnebredde (i CSS-accepterede værdier)",
        rowTitleWidth: "Bredde på rækkeoverskrift (i CSS-accepterede værdier)",
        valueTrue: "\"Sand\" værdi",
        valueFalse: "\"Falsk\" værdi",
        minErrorText: "Fejlmeddelelsen \"Værdien er under minimum\"",
        maxErrorText: "Fejlmeddelelsen \"Værdien overstiger maksimum\"",
        otherErrorText: "Fejlmeddelelsen \"Tom kommentar\"",
        keyDuplicationError: "Fejlmeddelelsen \"Ikke-entydig nøgleværdi\"",
        minSelectedChoices: "Minimum valgte valg",
        maxSelectedChoices: "Maksimalt antal valgte valg",
        showClearButton: "Vis knappen Ryd",
        logoWidth: "Logobredde (i CSS-accepterede værdier)",
        logoHeight: "Logohøjde (i CSS-accepterede værdier)",
        readOnly: "Skrivebeskyttet",
        enableIf: "Redigerbar, hvis",
        emptyRowsText: "Meddelelsen \"Ingen rækker\"",
        separateSpecialChoices: "Adskil særlige valg (Ingen, Andet, Vælg alle)",
        choicesFromQuestion: "Kopiér valg fra følgende spørgsmål",
        choicesFromQuestionMode: "Hvilke valgmuligheder skal kopieres?",
        progressBarShowPageTitles: "Vis sidetitler på statuslinjen",
        progressBarShowPageNumbers: "Vis sidetal på statuslinjen",
        showCommentArea: "Vis kommentarområdet",
        commentPlaceholder: "Pladsholder til kommentarområde",
        displayRateDescriptionsAsExtremeItems: "Beskrivelser af visningshastighed som ekstreme værdier",
        rowsOrder: "Rækkefølge af rækker",
        columnsLayout: "Kolonnelayout",
        columnColCount: "Antal indlejrede kolonner",
        correctAnswer: "Korrekt svar",
        defaultPanelValue: "Standardværdier",
        cells: "Celle tekster",
        fileInputPlaceholder: "Vælg en fil, eller indsæt et fillink...",
        keyName: "Nøglekolonne",
        itemvalue: {
            visibleIf: "Gør indstillingen synlig, hvis",
            enableIf: "Gør indstillingen valgbar, hvis"
        },
        "itemvalue@rows": {
            visibleIf: "Gør rækken synlig, hvis",
            enableIf: "Gør rækken redigerbar, hvis"
        },
        imageitemvalue: {
            text: "Alternativ tekst"
        },
        logoPosition: "Logo position",
        addLogo: "Tilføj logo...",
        changeLogo: "Skift logo...",
        logoPositions: {
            none: "Fjern logo",
            left: "Venstre",
            right: "Højre",
            top: "På toppen",
            bottom: "I bunden"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Panel Layout"
            },
            general: "Generelt",
            fileOptions: "Indstillinger",
            html: "Html-editor",
            columns: "Kolonner",
            rows: "Rækker",
            choices: "Valgmuligheder",
            items: "Elementer",
            visibleIf: "Synlig hvis",
            enableIf: "Aktiv hvis",
            requiredIf: "Påkrævet, hvis",
            rateValues: "Bedøm-værdier",
            choicesByUrl: "Valgmuligheder fra Web",
            matrixChoices: "Standard valgmuligheder",
            multipleTextItems: "Tekst inputmuligheder",
            numbering: "Nummerering",
            validators: "Valideringer",
            navigation: "Navigation",
            question: "Spørgsmål",
            pages: "Sider",
            timer: "Tid/Quiz",
            calculatedValues: "Beregnede værdier",
            triggers: "Triggere",
            templateTitle: "Skabelon titel",
            totals: "Totaler",
            logic: "Logik",
            mask: "Indstillinger for inputmaske",
            layout: {
                panel: "Layout",
                question: "Layout",
                base: "Layout"
            },
            data: "Data",
            validation: "Validering",
            cells: "Celle tekster",
            showOnCompleted: "Undersøgelsen er fuldført",
            logo: "Logo i undersøgelsens titel",
            slider: "Skyderen",
            expression: "Udtryk",
            questionSettings: "Indstillinger for spørgsmål",
            header: "Header",
            background: "Baggrund",
            appearance: "Udseende",
            others: "Andre"
        },
        editProperty: "Rediger egenskab '{0}'",
        items: "[ Element: {0} ]",
        choicesVisibleIf: "Valg er synlige, hvis",
        choicesEnableIf: "Valg kan vælges, hvis:",
        columnsEnableIf: "Kolonner er synlige, hvis",
        rowsEnableIf: "Rækker er synlige, hvis",
        innerIndent: "Tilføj indre indrykninger",
        defaultValueFromLastRow: "Tag standardværdier fra den sidste række",
        defaultValueFromLastPanel: "Tag standardværdier fra det sidste panel",
        enterNewValue: "Indtast værdien.",
        noquestions: "Der er ingen spørgsmål i undersøgelsen.",
        createtrigger: "Opret en trigger",
        titleKeyboardAdornerTip: "Tryk på enter-knappen for at redigere",
        keyboardAdornerTip: "Tryk på enter-knappen for at redigere elementet, tryk på slet-knappen for at slette elementet, tryk på alt plus pil op eller pil ned for at flytte elementet",
        triggerOn: "På ",
        triggerMakePagesVisible: "Gør sider synlige:",
        triggerMakeQuestionsVisible: "Gør spørgsmål synlige:",
        triggerCompleteText: "Aflslut spørgeskema ved at fortsætte.",
        triggerNotSet: "Triggerer er ikke sat",
        triggerRunIf: "Afvikl hvis",
        triggerSetToName: "Ændr værdien af: ",
        triggerFromName: "Kopier værdi fra: ",
        triggerRunExpression: "Afvikl dette udtryk:",
        triggerSetValue: "til: ",
        triggerGotoName: "Gå til spørgsmålet",
        triggerIsVariable: "Gem ikke variablen i undersøgelsesresultatet.",
        triggerRunExpressionEmpty: "Indtast et gyldigt udtryk",
        emptyExpressionPlaceHolder: "Skriv udtryk her...",
        noFile: "Ingen fil valgt",
        clearIfInvisible: "Ryd værdien, hvis spørgsmålet bliver skjult",
        valuePropertyName: "Egenskabsnavn for værdi",
        searchEnabled: "Aktivér søgning",
        hideSelectedItems: "Skjule markerede elementer",
        closeOnSelect: "Luk rullemenuen efter markering",
        verticalAlign: "Lodret justering",
        alternateRows: "Alternative rækker",
        columnsVisibleIf: "Kolonner er synlige, hvis",
        rowsVisibleIf: "Rækker er synlige, hvis",
        otherPlaceholder: "Pladsholder til kommentarområde",
        filePlaceholder: "Filpladsholdertekst",
        photoPlaceholder: "Eksempeltekst til billeder",
        fileOrPhotoPlaceholder: "Arkiv- eller fotopladsholdertekst",
        rateType: "Sats type",
        url_placeholder: "Eks.: https://api.example.com/books",
        path_placeholder: "Eks.: kategorier.fiktion",
        questionStartIndex_placeholder: "Eks.: a)",
        width_placeholder: "Eks.: 6in",
        minWidth_placeholder: "Eks.: 600px",
        maxWidth_placeholder: "Eks.: 50%",
        imageHeight_placeholder: "auto",
        imageWidth_placeholder: "auto",
        theme: {
            themeName: "Tema",
            isPanelless: "Spørgsmål udseende",
            editorPanel: "Baggrund og hjørneradius",
            questionPanel: "Baggrund og hjørneradius",
            primaryColor: "Accent farve",
            panelBackgroundTransparency: "Opacitet af panelets baggrund",
            questionBackgroundTransparency: "Spørgsmål baggrundsuigennemsigtighed",
            fontSize: "Skrifttypestørrelse",
            scale: "Skæl",
            cornerRadius: "Hjørne radius",
            pageTitle: "Titel skrifttype",
            pageDescription: "Beskrivelse skrifttype",
            questionTitle: "Titel skrifttype",
            questionDescription: "Beskrivelse skrifttype",
            editorFont: "Skrifttype",
            backgroundOpacity: "Opacitet",
            "--sjs-font-family": "Skrifttypefamilie",
            "--sjs-general-backcolor-dim": "Baggrundsfarve",
            "--sjs-primary-backcolor": "Accent baggrund",
            "--sjs-primary-forecolor": "Accent forgrund",
            "--sjs-special-red": "Fejlmeddelelser",
            "--sjs-shadow-small": "Skyggeeffekter",
            "--sjs-shadow-inner": "Skyggeeffekter",
            "--sjs-border-default": "Farver"
        },
        "header@header": {
            headerView: "Udsigt",
            logoPosition: "Logo position",
            surveyTitle: "Skrifttype for undersøgelsestitel",
            surveyDescription: "Skrifttype til undersøgelsesbeskrivelse",
            headerTitle: "Skrifttype for undersøgelsestitel",
            headerDescription: "Skrifttype til undersøgelsesbeskrivelse",
            inheritWidthFrom: "Bredde på indholdsområde",
            textAreaWidth: "Tekstbredde",
            backgroundColorSwitch: "Baggrundsfarve",
            backgroundImage: "Baggrundsbillede",
            backgroundImageOpacity: "Opacitet",
            overlapEnabled: "Overlapning",
            logoPositionX: "Logo position",
            titlePositionX: "Titel position",
            descriptionPositionX: "Beskrivelse position"
        }
    },
    // Property values
    pv: {
        "true": "sand",
        "false": "falsk",
        file: "Lokale filer",
        camera: "Kamera",
        "file-camera": "Lokale filer eller kamera",
        inherit: "inherit",
        show: "show",
        hide: "hide",
        default: "default",
        initial: "initial",
        random: "random",
        collapsed: "collapsed",
        expanded: "expanded",
        none: "none",
        asc: "ascending",
        desc: "descending",
        indeterminate: "indeterminate",
        selected: "Valgte",
        unselected: "Markerede",
        decimal: "decimal",
        currency: "valuta",
        percent: "procent",
        firstExpanded: "firstExpanded",
        off: "off",
        list: "list",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        tab: "Faner",
        horizontal: "horizontal",
        vertical: "vertical",
        top: "top",
        bottom: "bottom",
        topBottom: "top and bottom",
        both: "Begge",
        left: "left",
        right: "Højre",
        center: "Midte",
        leftRight: "Venstre og højre",
        middle: "Midte",
        color: "farve",
        date: "dato",
        datetime: "datetime",
        "datetime-local": "datetime-lokal",
        email: "E-mail",
        month: "måned",
        number: "tal",
        password: "kodeord",
        range: "interval",
        tel: "Tel",
        text: "Tekst",
        time: "Tidspunkt",
        url: "URL-adresse",
        week: "uge",
        hidden: "hidden",
        edit: "edit",
        display: "display",
        contain: "Indeholde",
        cover: "Dække",
        fill: "Fylde",
        next: "Næste",
        last: "Sidst",
        onComplete: "onComplete",
        onHidden: "onHidden",
        onHiddenContainer: "Når spørgsmålet eller dets panel/side bliver skjult",
        clearInvisibleValues: {
            none: "Aldrig"
        },
        clearIfInvisible: {
            none: "Aldrig"
        },
        inputType: {
            color: "Farve",
            date: "Dato",
            "datetime-local": "Dato og klokkeslæt",
            email: "E-mail",
            month: "Måned",
            number: "Tal",
            password: "Kodeord",
            range: "Interval",
            tel: "Telefonnummer",
            text: "Tekst",
            time: "Tidspunkt",
            url: "URL-adresse",
            week: "Uge"
        },
        all: "all",
        page: "page",
        survey: "survey",
        onNextPage: "onNextPage",
        onValueChanged: "onValueChanged",
        onValueChanging: "Før et svar ændres",
        questionsOnPageMode: {
            standard: "Oprindelig struktur",
            singlePage: "Vis alle spørgsmål på én side",
            questionPerPage: "Vis et enkelt spørgsmål pr. side"
        },
        noPreview: "Ingen forhåndsvisning",
        showAllQuestions: "Vis alle spørgsmål",
        showAnsweredQuestions: "Vis kun besvarede spørgsmål",
        pages: "Afsluttede sider",
        questions: "Besvarede spørgsmål",
        requiredQuestions: "Besvarede nødvendige spørgsmål",
        correctQuestions: "Gyldige svar",
        buttons: "Afsluttede sider (knapbrugergrænseflade)",
        underInput: "Under indgangen",
        underTitle: "Under titlen",
        onBlur: "På sløring",
        onTyping: "Mens du skriver",
        underRow: "Under rækken",
        underRowSingle: "Under rækken er kun ét panel synligt",
        auto: "Auto",
        showNavigationButtons: {
            none: "Skjult"
        },
        showTimerPanel: {
            none: "Skjult"
        },
        showTimerPanelMode: {
            all: "Begge"
        },
        addRowLocation: {
            default: "Afhænger af matrixlayout"
        },
        panelsState: {
            default: "Brugere kan ikke udvide eller skjule paneler",
            collapsed: "Alle paneler er skjult",
            expanded: "Alle paneler er udvidet",
            firstExpanded: "Først udvidet"
        },
        widthMode: {
            static: "Statisk",
            responsive: "Lydhør"
        },
        contentMode: {
            image: "Billede",
            video: "Video",
            youtube: "YouTube"
        },
        displayMode: {
            buttons: "Knapper",
            dropdown: "Rullemenu"
        },
        rateColorMode: {
            default: "Standard",
            scale: "Skæl"
        },
        scaleColorMode: {
            monochrome: "Monokrom",
            colored: "Farvet"
        },
        autoGenerate: {
            "true": "Frembringe",
            "false": "Indtast manuelt"
        },
        rateType: {
            labels: "Etiketter",
            stars: "Stjerner",
            smileys: "Smileys"
        },
        state: {
            default: "Låst"
        },
        showQuestionNumbers: {
            default: "Automatisk nummerering",
            on: "Automatisk nummerering",
            onPage: "Nulstil på hver side",
            onpanel: "Nulstil på hvert panel",
            onPanel: "Nulstil på hvert panel",
            onSurvey: "Fortsæt på tværs af undersøgelsen",
            off: "Ingen nummerering"
        },
        descriptionLocation: {
            underTitle: "Under spørgsmålets titel",
            underInput: "Under indtastningsfeltet"
        },
        selectToRankAreasLayout: {
            horizontal: "Ved siden af valgmuligheder",
            vertical: "Ovenstående valg"
        },
        displayStyle: {
            decimal: "Decimal",
            currency: "Valuta",
            percent: "Procentdel",
            date: "Dato"
        },
        totalDisplayStyle: {
            decimal: "Decimal",
            currency: "Valuta",
            percent: "Procentdel",
            date: "Dato"
        },
        rowsOrder: {
            initial: "Oprindelig"
        },
        questionsOrder: {
            initial: "Oprindelig"
        },
        showProgressBar: {
            off: "Skjult",
            topbottom: "top and bottom",
            aboveheader: "Over overskriften",
            belowheader: "Under overskriften"
        },
        sum: "Sum",
        count: "Tælle",
        min: "Min.",
        max: "Maks",
        avg: "Avg",
        searchMode: {
            contains: "Indeholder",
            startsWith: "Begynder med"
        },
        backgroundImageFit: {
            auto: "Auto",
            cover: "Dække",
            contain: "Indeholde",
            fill: "Stræk",
            tile: "Flise"
        },
        backgroundImageAttachment: {
            fixed: "Fast",
            scroll: "Rulle"
        },
        headerView: {
            basic: "Grundlæggende",
            advanced: "Avanceret"
        },
        inheritWidthFrom: {
            survey: "Samme som undersøgelse",
            container: "Passer til beholder"
        },
        backgroundColorSwitch: {
            none: "Ingen",
            accentColor: "Accent farve",
            custom: "Sædvane"
        },
        colorPalette: {
            light: "Lys",
            dark: "Mørk"
        },
        isPanelless: {
            "false": "Standard",
            "true": "Uden paneler"
        }
    },
    // Operators
    op: {
        empty: "is empty",
        notempty: "is not empty",
        equal: "equals",
        notequal: "not equals",
        contains: "contains",
        notcontains: "not contains",
        anyof: "Enhver af",
        allof: "Alle af",
        greater: "greater",
        less: "less",
        greaterorequal: "greater or equals",
        lessorequal: "less or equals",
        and: "og",
        or: "eller"
    },
    // Embed window
    ew: {
        angular: "Benyt Angular version",
        jquery: "Benyt jQuery version",
        knockout: "Benyt Knockout version",
        react: "Benyt React version",
        vue: "Benyt Vue version",
        bootstrap: "For bootstrap framework",
        modern: "Moderne tema",
        default: "Standardtema",
        orange: "Orange tema",
        darkblue: "Mørkeblåt tema",
        darkrose: "Temaet Darkrose",
        stone: "Temaet Sten",
        winter: "Vinter tema",
        winterstone: "Temaet Vintersten",
        showOnPage: "Vis undersøgelsen på en side",
        showInWindow: "Vis undersøgelsen i et vindue",
        loadFromServer: "Hent undersøgelsen som JSON fra serveren",
        titleScript: "Scripts og styles",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Vælg siden for at teste den:",
        showInvisibleElements: "Vis usynlige elementer",
        hideInvisibleElements: "Skjul usynlige elementer"
    },
    validators: {
        answercountvalidator: "answer count",
        emailvalidator: "e-mail",
        expressionvalidator: "expression",
        numericvalidator: "numeric",
        regexvalidator: "regex",
        textvalidator: "text"
    },
    triggers: {
        completetrigger: "undersøgelse gennemført",
        setvaluetrigger: "sæt værdi",
        copyvaluetrigger: "kopiér værdi",
        skiptrigger: "Spring til spørgsmål",
        runexpressiontrigger: "afvikl udtry",
        visibletrigger: "skift synlighed"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Ex.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Ex.: mm/dd/yyyy"
        },
        currencymask: {
            prefix: "Ex.: $",
            suffix: "Ex.: USD"
        },
        panelbase: {
            questionTitleWidth: "Eks.: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "Et panel-id, der ikke er synligt for svarpersonerne.",
            description: "Skriv en undertitel til panelet.",
            visibleIf: "Brug tryllestavsikonet til at indstille en betinget regel, der bestemmer panelets synlighed.",
            enableIf: "Brug tryllestavsikonet til at indstille en betinget regel, der deaktiverer panelets skrivebeskyttede tilstand.",
            requiredIf: "Brug tryllestavsikonet til at angive en betinget regel, der forhindrer indsendelse af undersøgelser, medmindre mindst ét indlejret spørgsmål har et svar.",
            questionTitleLocation: "Gælder for alle spørgsmål i dette panel. Hvis du vil tilsidesætte denne indstilling, skal du definere regler for titeljustering for individuelle spørgsmål. Indstillingen \"Nedarv\" anvender indstillingen på sideniveau (hvis angivet) eller undersøgelsesniveau (\"Top\" som standard).",
            questionTitleWidth: "Angiver ensartet bredde for spørgsmålstitler, når de er justeret til venstre for deres spørgsmålsbokse. Accepterer CSS-værdier (px, %, in, pt osv.).",
            questionErrorLocation: "Angiver placeringen af en fejlmeddelelse i forhold til alle spørgsmål i panelet. Indstillingen \"Nedarv\" anvender indstillingen for sideniveau (hvis angivet) eller undersøgelsesniveau.",
            questionsOrder: "Bevarer den oprindelige rækkefølge af spørgsmål eller randomiserer dem. Indstillingen \"Nedarv\" anvender indstillingen for sideniveau (hvis angivet) eller undersøgelsesniveau.",
            page: "Flytter panelet til slutningen af en markeret side.",
            innerIndent: "Tilføjer mellemrum eller margen mellem panelindholdet og panelboksens venstre kant.",
            startWithNewLine: "Fjern markeringen for at få vist panelet på én linje med det forrige spørgsmål eller panel. Indstillingen gælder ikke, hvis panelet er det første element i formularen.",
            state: "Vælg mellem: \"Udvidet\" - panelet vises fuldt ud og kan skjules; \"Skjult\" - panelet viser kun titlen og beskrivelsen og kan udvides; \"Låst\" - panelet vises fuldt ud og kan ikke skjules.",
            width: "Indstiller panelets bredde i forhold til andre undersøgelseselementer på samme linje. Accepterer CSS-værdier (px, %, in, pt osv.)."
        },
        paneldynamic: {
            name: "Et panel-id, der ikke er synligt for svarpersonerne.",
            description: "Skriv en undertitel til panelet.",
            visibleIf: "Brug tryllestavsikonet til at indstille en betinget regel, der bestemmer panelets synlighed.",
            enableIf: "Brug tryllestavsikonet til at indstille en betinget regel, der deaktiverer panelets skrivebeskyttede tilstand.",
            requiredIf: "Brug tryllestavsikonet til at angive en betinget regel, der forhindrer indsendelse af undersøgelser, medmindre mindst ét indlejret spørgsmål har et svar.",
            templateTitleLocation: "Gælder for alle spørgsmål i dette panel. Hvis du vil tilsidesætte denne indstilling, skal du definere regler for titeljustering for individuelle spørgsmål. Indstillingen \"Nedarv\" anvender indstillingen på sideniveau (hvis angivet) eller undersøgelsesniveau (\"Top\" som standard).",
            templateErrorLocation: "Angiver placeringen af en fejlmeddelelse i forhold til et spørgsmål med ugyldigt input. Vælg mellem: \"Top\" - en fejltekst placeres øverst i spørgsmålsfeltet; \"Nederst\" - en fejltekst placeres nederst i spørgsmålsfeltet. Indstillingen \"Nedarv\" anvender indstillingen på sideniveau (hvis angivet) eller undersøgelsesniveau (\"Top\" som standard).",
            errorLocation: "Angiver placeringen af en fejlmeddelelse i forhold til alle spørgsmål i panelet. Indstillingen \"Nedarv\" anvender indstillingen for sideniveau (hvis angivet) eller undersøgelsesniveau.",
            page: "Flytter panelet til slutningen af en markeret side.",
            innerIndent: "Tilføjer mellemrum eller margen mellem panelindholdet og panelboksens venstre kant.",
            startWithNewLine: "Fjern markeringen for at få vist panelet på én linje med det forrige spørgsmål eller panel. Indstillingen gælder ikke, hvis panelet er det første element i formularen.",
            state: "Vælg mellem: \"Udvidet\" - panelet vises fuldt ud og kan skjules; \"Skjult\" - panelet viser kun titlen og beskrivelsen og kan udvides; \"Låst\" - panelet vises fuldt ud og kan ikke skjules.",
            width: "Indstiller panelets bredde i forhold til andre undersøgelseselementer på samme linje. Accepterer CSS-værdier (px, %, in, pt osv.).",
            templateTitle: "Indtast en skabelon til dynamiske paneltitler. Brug {panelIndex} til panelets generelle placering og {visiblePanelIndex} til dets rækkefølge blandt synlige paneler. Indsæt disse pladsholdere i mønsteret for at tilføje automatisk nummerering.",
            templateTabTitle: "Indtast en skabelon til fanetitler. Brug {panelIndex} til et panels generelle placering og {visiblePanelIndex} til dets rækkefølge blandt synlige paneler. Indsæt disse pladsholdere i mønsteret for at tilføje automatisk nummerering.",
            tabTitlePlaceholder: "En reservetekst til fanetitler, der gælder, når fanetitelmønsteret ikke giver en meningsfuld værdi.",
            templateVisibleIf: "Denne indstilling giver dig mulighed for at styre synligheden af individuelle paneler i det dynamiske panel. Brug pladsholderen '{panel}' til at referere til det aktuelle panel i dit udtryk.",
            titleLocation: "Denne indstilling nedarves automatisk af alle spørgsmål i dette panel. Hvis du vil tilsidesætte denne indstilling, skal du definere regler for titeljustering for individuelle spørgsmål. Indstillingen \"Nedarv\" anvender indstillingen på sideniveau (hvis angivet) eller undersøgelsesniveau (\"Top\" som standard).",
            descriptionLocation: "Indstillingen \"Nedarv\" anvender indstillingen på sideniveau (hvis angivet) eller undersøgelsesniveau (\"Under paneltitlen\" som standard).",
            newPanelPosition: "Definerer placeringen af et nyligt tilføjet panel. Som standard tilføjes nye paneler til slutningen. Vælg \"Næste\" for at indsætte et nyt panel efter det aktuelle.",
            defaultValueFromLastPanel: "Duplikerer svar fra det sidste panel og tildeler dem til det næste tilføjede dynamiske panel.",
            keyName: "Henvis til et spørgsmålsnavn for at kræve, at en bruger giver et entydigt svar på dette spørgsmål i hvert panel."
        },
        defaultValueExpression: "Med denne indstilling kan du tildele en standardsvarværdi baseret på et udtryk. Udtrykket kan omfatte grundlæggende beregninger - '{q1_id} + {q2_id}', booleske udtryk, såsom '{alder} > 60' og funktioner: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' osv. Den værdi, der bestemmes af dette udtryk, fungerer som den oprindelige standardværdi, der kan tilsidesættes af svarpersonens manuelle input.",
        resetValueIf: "Brug tryllestavsikonet til at angive en betinget regel, der bestemmer, hvornår en svarpersons input nulstilles til værdien baseret på værdien \"Standardværdiudtryk\" eller \"Angiv værdiudtryk\" eller til værdien \"Standardsvar\" (hvis en af dem er angivet).",
        setValueIf: "Brug tryllestavsikonet til at indstille en betinget regel, der bestemmer, hvornår \"Indstil værdiudtryk\" skal køres, og tildele den resulterende værdi dynamisk som et svar.",
        setValueExpression: "Angiv et udtryk, der definerer den værdi, der skal angives, når betingelserne i reglen \"Angiv værdi hvis\" er opfyldt. Udtrykket kan omfatte grundlæggende beregninger - '{q1_id} + {q2_id}', booleske udtryk, såsom '{alder} > 60' og funktioner: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' osv. Den værdi, der bestemmes af dette udtryk, kan tilsidesættes af svarpersonens manuelle input.",
        question: {
            name: "Et spørgsmåls-id, der ikke er synligt for svarpersonerne.",
            description: "Skriv et spørgsmåls undertitel.",
            visibleIf: "Brug tryllestavsikonet til at angive en betinget regel, der bestemmer spørgsmålets synlighed.",
            enableIf: "Brug tryllestavsikonet til at angive en betinget regel, der deaktiverer skrivebeskyttet tilstand for spørgsmålet.",
            requiredIf: "Brug tryllestavsikonet til at angive en betinget regel, der forhindrer undersøgelse i at gå videre eller blive sendt, medmindre spørgsmålet blev besvaret.",
            startWithNewLine: "Fjern markeringen for at få vist spørgsmålet på én linje med det forrige spørgsmål eller panel. Indstillingen gælder ikke, hvis spørgsmålet er det første element i formularen.",
            page: "Flytter spørgsmålet til slutningen af en markeret side.",
            state: "Vælg mellem: \"Udvidet\" - spørgsmålsfeltet vises fuldt ud og kan skjules; \"Skjult\" - spørgsmålsfeltet viser kun titlen og beskrivelsen og kan udvides; \"Låst\" - spørgsmålsfeltet vises fuldt ud og kan ikke skjules.",
            titleLocation: "Tilsidesætter regler for titeljustering, der er defineret på panel-, side- eller undersøgelsesniveau. Indstillingen \"Nedarv\" anvender alle indstillinger på højere niveau (hvis indstillet) eller indstilling på undersøgelsesniveau (\"Top\" som standard).",
            descriptionLocation: "Indstillingen \"Nedarv\" anvender indstillingen på undersøgelsesniveau (\"Under spørgsmålets titel\" som standard).",
            errorLocation: "Angiver placeringen af en fejlmeddelelse i forhold til spørgsmålet med ugyldigt input. Vælg mellem: \"Top\" - en fejltekst placeres øverst i spørgsmålsfeltet; \"Nederst\" - en fejltekst placeres nederst i spørgsmålsfeltet. Indstillingen \"Nedarv\" anvender indstillingen på undersøgelsesniveau (\"Top\" som standard).",
            indent: "Tilføjer mellemrum eller margen mellem spørgsmålsindholdet og spørgsmålsfeltets venstre kant.",
            width: "Angiver bredden af spørgsmålet i forhold til andre undersøgelseselementer på samme linje. Accepterer CSS-værdier (px, %, in, pt osv.).",
            surveyvalidator: {
                expression: "Brug tryllestavsikonet til at angive en valideringsregel for spørgsmålet."
            },
            textUpdateMode: "Vælg mellem: \"Ved tabt fokus\" - værdien opdateres, når indtastningsfeltet mister fokus; \"Mens du skriver\" - værdien opdateres i realtid, da brugerne skriver. Indstillingen \"Nedarv\" anvender indstillingen på undersøgelsesniveau (\"Ved mistet fokus\" som standard).",
            url: "Du kan bruge enhver webtjeneste som datakilde til multiple choice-spørgsmål. Hvis du vil udfylde valgværdier, skal du angive URL-adressen på den tjeneste, der leverer dataene.",
            searchMode: "En sammenligningshandling, der bruges til at filtrere rullelisten.",
            textWrapEnabled: "Lange tekster i valgmuligheder genererer automatisk linjeskift, så de passer ind i rullemenuen. Fjern markeringen, hvis teksterne skal klippes."
        },
        signaturepad: {
            signatureWidth: "Indstiller bredden på det viste signaturområde og det resulterende billede.",
            signatureHeight: "Indstiller højden på det viste signaturområde og det resulterende billede.",
            signatureAutoScaleEnabled: "Vælg, om signaturområdet skal udfylde al tilgængelig plads i spørgsmålsfeltet, samtidig med at standardformatet 3:2 bevares. Når brugerdefinerede bredde- og højdeværdier er angivet, bevarer indstillingen højde-bredde-forholdet for disse dimensioner."
        },
        file: {
            imageHeight: "Justerer billedets højde i undersøgelsesresultaterne.",
            imageWidth: "Justerer billedets bredde i undersøgelsesresultaterne."
        },
        image: {
            contentMode: "Indstillingen \"Auto\" bestemmer automatisk den passende tilstand til visning - Billede, Video eller YouTube - baseret på den angivne kilde-URL."
        },
        imagepicker: {
            imageHeight: "Tilsidesætter minimum- og maksimumhøjdeværdierne.",
            imageWidth: "Tilsidesætter værdierne for minimum- og maksimumbredde.",
            choices: "\"Værdi\" fungerer som et vare-id, der bruges i betingede regler; \"Tekst\" vises til respondenterne.",
            contentMode: "Vælg mellem \"Billede\" og \"Video\" for at indstille medievælgerens indholdstilstand. Hvis \"Billede\" er valgt, skal du sikre dig, at alle angivne indstillinger er billedfiler i følgende formater: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Tilsvarende, hvis \"Video\" er valgt, skal du sikre dig, at alle indstillinger er direkte links til videofiler i følgende formater: MP4, MOV, WMV, FLV, AVI, MKV. Bemærk, at YouTube-links ikke understøttes for videoindstillinger."
        },
        text: {
            size: "Denne indstilling ændrer kun størrelsen på inputfeltet og påvirker ikke bredden af spørgsmålsfeltet. Hvis du vil begrænse den accepterede inputlængde, skal du gå til <b>Validering → Maksimal tegngrænse</b>."
        },
        comment: {
            rows: "Indstiller antallet af viste linjer i indtastningsfeltet. Hvis indgangen fylder flere linjer, vises rullepanelet."
        },
        // survey templates
        survey: {
            mode: "Vælg mellem: \"Redigerbar\" - gør det muligt for respondenter at udfylde din undersøgelse; \"Skrivebeskyttet\" - deaktiverer formularredigering."
        },
        matrixdropdowncolumn: {
            name: "Et kolonne-id, der ikke er synligt for svarpersoner.",
            isUnique: "Når det er aktiveret for en kolonne, skal en svarperson give et entydigt svar på hvert spørgsmål i denne kolonne.",
            rows: "Indstiller antallet af viste linjer i indtastningsfeltet. Hvis indgangen fylder flere linjer, vises rullepanelet.",
            visibleIf: "Brug tryllestavsikonet til at angive en betinget regel, der bestemmer kolonnesynligheden.",
            enableIf: "Brug tryllestavsikonet til at angive en betinget regel, der deaktiverer skrivebeskyttet tilstand for kolonnen.",
            requiredIf: "Brug tryllestavsikonet til at angive en betinget regel, der forhindrer indsendelse af undersøgelser, medmindre mindst ét indlejret spørgsmål har et svar.",
            showInMultipleColumns: "Når denne indstilling er valgt, oprettes der en individuel kolonne for hver valgmulighed."
        },
        widthMode: "Vælg mellem: \"Statisk\" - indstiller en fast bredde; \"Responsive\" - får undersøgelsen til at optage skærmens fulde bredde; \"Auto\" - gælder for en af de to afhængigt af de anvendte spørgsmålstyper.",
        cookieName: "Cookies forhindrer brugere i at udfylde den samme undersøgelse to gange.",
        logo: "Indsæt et billedlink (ingen størrelsesbegrænsninger), eller klik på mappeikonet for at gennemse en fil fra din computer (op til 64 KB).",
        logoWidth: "Indstiller en logobredde i CSS-enheder (px, %, in, pt osv.).",
        logoHeight: "Indstiller en logohøjde i CSS-enheder (px, %, i, pt osv.).",
        logoFit: "Vælg mellem: \"Ingen\" - billedet bevarer sin oprindelige størrelse; \"Contain\" - billedet ændres til at passe, samtidig med at dets billedformat opretholdes; \"Cover\" - billedet fylder hele kassen, samtidig med at billedformatet opretholdes; \"Fyld\" - billedet strækkes for at udfylde boksen uden at opretholde dets billedformat.",
        goNextPageAutomatic: "Vælg, om undersøgelsen automatisk skal gå videre til næste side, når en svarperson har besvaret alle spørgsmål på den aktuelle side.",
        allowCompleteSurveyAutomatic: "Vælg, om undersøgelsen skal fuldføres automatisk, når svarpersonen har besvaret alle spørgsmål.",
        showNavigationButtons: "Angiver synligheden og placeringen af navigationsknapper på en side.",
        showProgressBar: "Indstiller synligheden og placeringen af en statuslinje. Værdien \"Auto\" viser statuslinjen over eller under undersøgelsesoverskriften.",
        showPreviewBeforeComplete: "Aktivér eksempelsiden med alle eller kun besvarede spørgsmål.",
        questionTitleLocation: "Gælder for alle spørgsmål i undersøgelsen. Denne indstilling kan tilsidesættes af titeljusteringsregler på lavere niveauer: panel, side eller spørgsmål. En indstilling på lavere niveau tilsidesætter dem på et højere niveau.",
        requiredText: "Et symbol eller en sekvens af symboler, der angiver, at et svar er påkrævet.",
        questionStartIndex: "Indtast et tal eller bogstav, som du vil starte nummereringen med.",
        questionErrorLocation: "Angiver placeringen af en fejlmeddelelse i forhold til spørgsmålet med ugyldigt input. Vælg mellem: \"Top\" - en fejltekst placeres øverst i spørgsmålsfeltet; \"Nederst\" - en fejltekst placeres nederst i spørgsmålsfeltet.",
        focusFirstQuestionAutomatic: "Vælg, om det første indtastningsfelt på hver side skal være klar til indtastning af tekst.",
        questionsOrder: "Bevarer den oprindelige rækkefølge af spørgsmål eller randomiserer dem. Effekten af denne indstilling er kun synlig under fanen Eksempel.",
        maxTextLength: "Kun til spørgsmål om indtastning af tekst.",
        maxOthersLength: "Kun til kommentarer til spørgsmål.",
        commentAreaRows: "Angiver antallet af viste linjer i tekstområder for spørgsmålskommentarer. I indgangen optager flere linjer, rullepanelet vises.",
        autoGrowComment: "Vælg, om spørgsmålskommentarer og lange tekstspørgsmål automatisk skal vokse i højden baseret på den indtastede tekstlængde.",
        allowResizeComment: "Kun til spørgsmålskommentarer og lange tekstspørgsmål.",
        calculatedValues: "Brugerdefinerede variabler fungerer som mellemliggende eller hjælpevariabler, der bruges i formularberegninger. De tager respondentinput som kildeværdier. Hver brugerdefineret variabel har et entydigt navn og et udtryk, den er baseret på.",
        includeIntoResult: "Vælg, om den beregnede værdi af udtrykket skal gemmes sammen med undersøgelsesresultaterne.",
        triggers: "En udløser er en hændelse eller betingelse, der er baseret på et udtryk. Når udtrykket er evalueret til \"sand\", udløser en udløser en handling. En sådan handling kan eventuelt have et målspørgsmål, den påvirker.",
        clearInvisibleValues: "Vælg, om du vil rydde værdier for spørgsmål, der er skjult af betinget logik, og hvornår du vil gøre det.",
        textUpdateMode: "Vælg mellem: \"Ved tabt fokus\" - værdien opdateres, når indtastningsfeltet mister fokus; \"Mens du skriver\" - værdien opdateres i realtid, da brugerne skriver.",
        columns: "Den venstre værdi fungerer som et kolonne-id, der bruges i betingede regler, den rigtige værdi vises for respondenterne.",
        rows: "Den venstre værdi fungerer som et række-id, der bruges i betingede regler, den rigtige værdi vises for respondenterne.",
        columnMinWidth: "Accepterer CSS-værdier (px, %, in, pt osv.).",
        rowTitleWidth: "Accepterer CSS-værdier (px, %, in, pt osv.).",
        totalText: "Kun synlig, når mindst én kolonne har typen Total eller Totaludtryk.",
        cellErrorLocation: "Angiver placeringen af en fejlmeddelelse i forhold til en celle med ugyldigt input. Indstillingen \"Arv\" anvender indstillingen fra egenskaben \"Justering af fejlmeddelelse\".",
        keyDuplicationError: "Når egenskaben \"Undgå dublerede svar\" er aktiveret, modtager en svarperson, der forsøger at sende en dubletpost, følgende fejlmeddelelse.",
        totalExpression: "Giver dig mulighed for at beregne samlede værdier baseret på et udtryk. Udtrykket kan omfatte grundlæggende beregninger ('{q1_id} + {q2_id}'), booleske udtryk ('{alder} > 60') og funktioner ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' osv.).",
        confirmDelete: "Udløser en prompt, der beder om at bekræfte sletningen af rækken.",
        defaultValueFromLastRow: "Dublerer svar fra den sidste række og tildeler dem til den næste tilføjede dynamiske række.",
        keyName: "Hvis den angivne kolonne indeholder identiske værdier, kaster undersøgelsen fejlen \"Ikke-unik nøgleværdi\".",
        description: "Skriv en undertekst.",
        locale: "Vælg et sprog for at begynde at oprette undersøgelsen. Hvis du vil tilføje en oversættelse, skal du skifte til et nyt sprog og oversætte den oprindelige tekst her eller på fanen Oversættelser.",
        detailPanelMode: "Angiver placeringen af en detaljesektion i forhold til en række. Vælg mellem: \"Ingen\" - ingen udvidelse tilføjes; \"Under rækken\" - en rækkeudvidelse placeres under hver række i matrixen; \"Vis kun én rækkeudvidelse under rækken\" - en udvidelse vises kun under en enkelt række, de resterende rækkeudvidelser skjules.",
        imageFit: "Vælg mellem: \"Ingen\" - billedet bevarer sin oprindelige størrelse; \"Contain\" - billedet ændres til at passe, samtidig med at dets billedformat opretholdes; \"Cover\" - billedet fylder hele kassen, samtidig med at billedformatet opretholdes; \"Fyld\" - billedet strækkes for at udfylde boksen uden at opretholde dets billedformat.",
        autoGrow: "Øger gradvist inputfeltets højde, efterhånden som data indtastes. Tilsidesætter indstillingen \"Inputfelthøjde (i linjer)\".",
        allowResize: "Størrelseshåndtaget (eller grebet) vises i hjørnet og kan trækkes for at ændre størrelsen på indtastningsfeltet.",
        maxTimeToFinish: "Et tidsinterval i sekunder, hvorefter undersøgelsen automatisk går videre til siden Tak.",
        maxTimeToFinishPage: "Et tidsinterval i sekunder, hvorefter undersøgelsen automatisk går videre til næste side.",
        page: {
            maxTimeToFinish: "Et tidsinterval i sekunder, hvorefter undersøgelsen automatisk går videre til næste side.",
            visibleIf: "Brug tryllestavsikonet til at indstille en betinget regel, der bestemmer sidens synlighed.",
            enableIf: "Brug tryllestavsikonet til at angive en betinget regel, der deaktiverer skrivebeskyttet tilstand for siden.",
            requiredIf: "Brug tryllestavsikonet til at angive en betinget regel, der forhindrer indsendelse af undersøgelser, medmindre mindst ét indlejret spørgsmål har et svar.",
            questionTitleLocation: "Gælder for alle spørgsmål på denne side. Hvis du vil tilsidesætte denne indstilling, skal du definere regler for titeljustering for individuelle spørgsmål eller paneler. Indstillingen \"Nedarv\" anvender indstillingen på undersøgelsesniveau (\"Top\" som standard).",
            questionTitleWidth: "Angiver ensartet bredde for spørgsmålstitler, når de er justeret til venstre for deres spørgsmålsbokse. Accepterer CSS-værdier (px, %, in, pt osv.).",
            questionErrorLocation: "Angiver placeringen af en fejlmeddelelse i forhold til spørgsmålet med ugyldigt input. Vælg mellem: \"Top\" - en fejltekst placeres øverst i spørgsmålsfeltet; \"Nederst\" - en fejltekst placeres nederst i spørgsmålsfeltet. Indstillingen \"Nedarv\" anvender indstillingen på undersøgelsesniveau (\"Top\" som standard).",
            questionsOrder: "Bevarer den oprindelige rækkefølge af spørgsmål eller randomiserer dem. Indstillingen \"Arv\" anvender indstillingen på undersøgelsesniveau (\"Original\" som standard). Effekten af denne indstilling er kun synlig under fanen Eksempel.",
            navigationButtonsVisibility: "Indstiller synligheden af navigationsknapper på siden. Indstillingen \"Arv\" anvender indstillingen på undersøgelsesniveau, som som standard er \"Synlig\"."
        },
        showTimerPanel: "Indstiller synligheden og placeringen af en timer på en side.",
        panelsState: "Vælg mellem: \"Låst\" - brugere kan ikke udvide eller skjule paneler; \"Skjul alle\" - alle paneler starter i kollapset tilstand; \"Udvid alle\" - alle paneler starter i udvidet tilstand; \"Først udvidet\" - kun det første panel udvides oprindeligt.",
        imageLinkName: "Angiv et delt egenskabsnavn i den række objekter, der indeholder de URL-adresser til billeder eller videofiler, du vil have vist på valglisten.",
        choices: "Den venstre værdi fungerer som et vare-id, der bruges i betingede regler, den rigtige værdi vises for respondenterne.",
        title: "Skriv en brugervenlig titel, der skal vises.",
        waitForUpload: "Sikrer, at brugerne ikke gennemfører undersøgelsen, før filerne er uploadet.",
        minWidth: "Accepterer CSS-værdier (px, %, in, pt osv.).",
        maxWidth: "Accepterer CSS-værdier (px, %, in, pt osv.).",
        width: "Accepterer CSS-værdier (px, %, in, pt osv.).",
        valueName: "Hvis du ikke angiver denne egenskab, gemmes svaret i et felt, der er angivet af egenskaben Navn.",
        useDisplayValuesInDynamicTexts: "I spørgsmålstyper med et enkelt og flere valg har hver valgmulighed et id og en visningsværdi. Når denne indstilling er valgt, vises der en visningsværdi i stedet for en id-værdi i HTML-spørgsmål og dynamiske titler og beskrivelser af undersøgelseselementer.",
        clearIfInvisible: "Vælg, om du vil rydde spørgsmålsværdier, der er skjult af betinget logik, og hvornår det skal gøres. Indstillingen \"Nedarv\" anvender indstillingen på undersøgelsesniveau (\"Ved afslutning af undersøgelsen\" som standard).",
        choicesFromQuestionMode: "Vælg mellem: \"Alle\" - kopierer alle valgmuligheder fra det valgte spørgsmål; \"Valgt\" - kopierer dynamisk kun valgte valgindstillinger; \"Ikke valgt\" - kopierer dynamisk kun ikke-valgte valgindstillinger. Indstillingerne \"Ingen\" og \"Andre\" kopieres som standard, hvis de er aktiveret i kildespørgsmålet.",
        showOtherItem: "Når denne indstilling er valgt, kan brugerne medtage yderligere input i et separat kommentarfelt.",
        separateSpecialChoices: "Viser hver indstilling for særlige valgmuligheder (\"Ingen\", \"Andet\", \"Vælg alle\") på en ny linje, selv når du bruger et layout med flere kolonner.",
        path: "Angiv placeringen i tjenestedatasættet, hvor målmatrixen af objekter er placeret. Lad feltet stå tomt, hvis URL-adressen allerede peger på arrayet.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Angiv et ensartet egenskabsnavn i den matrix af objekter, der indeholder de værdier, du vil have vist på valglisten.",
        allowEmptyResponse: "Vælg for at tillade, at tjenesten returnerer et tomt svar eller en matrix.",
        choicesVisibleIf: "Brug tryllestavsikonet til at angive en betinget regel, der bestemmer synligheden af alle valgmuligheder.",
        rateValues: "Den venstre værdi fungerer som et vare-id, der bruges i betingede regler, den rigtige værdi vises for respondenterne.",
        rating: {
            displayMode: "\"Auto\" vælger mellem tilstandene \"Knapper\" og \"Dropdown\" baseret på den tilgængelige bredde. Når bredden ikke er tilstrækkelig til at vise knapper, vises der en rullemenu i spørgsmålet."
        },
        valuePropertyName: "Giver dig mulighed for at forbinde spørgsmål, der giver resultater i forskellige formater. Når sådanne spørgsmål kædes sammen ved hjælp af et join-id, gemmer denne delte ejendom valgte spørgsmålsværdier.",
        searchEnabled: "Vælg, om du vil opdatere indholdet i rullemenuen, så det svarer til den søgeforespørgsel, som en bruger skriver i indtastningsfeltet.",
        valueTrue: "En værdi, der skal gemmes i undersøgelsesresultater, når respondenterne giver et positivt svar.",
        valueFalse: "En værdi, der skal gemmes i undersøgelsesresultater, når respondenterne giver et negativt svar.",
        showPreview: "Det anbefales ikke at deaktivere denne indstilling, da den tilsidesætter eksempelbilledet og gør det svært for en bruger at forstå, om filerne er blevet uploadet.",
        needConfirmRemoveFile: "Udløser en prompt, der beder om at bekræfte filsletningen.",
        selectToRankEnabled: "Aktivér for kun at rangere valgte valg. Brugere trækker valgte elementer fra valglisten for at sortere dem inden for rangeringsområdet.",
        dataList: "Angiv en liste over valgmuligheder, der vil blive foreslået svarpersonen under input.",
        itemSize: "Indstillingen ændrer kun størrelsen på inputfelterne og påvirker ikke bredden af spørgsmålsfeltet.",
        itemTitleWidth: "Angiver ensartet bredde for alle vareetiketter i pixel",
        altText: "Fungerer som erstatning, når billedet ikke kan vises på en brugers enhed og af tilgængelighedshensyn.",
        rateColorMode: "Definerer farven på den valgte emoji, når ikontypen Vurdering er indstillet til \"Smileys\". Vælg mellem: \"Standard\" - den valgte emoji vises i standard undersøgelsesfarve; \"Skala\" - den valgte emoji arver farve fra vurderingsskalaen.",
        expression: {
            name: "Et udtryks-id, der ikke er synligt for svarpersoner.",
            description: "Skriv et udtryk undertekst.",
            expression: "Et udtryk kan omfatte grundlæggende beregninger ('{q1_id} + {q2_id}'), betingelser ('{alder} > 60') og funktioner ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' osv.)."
        },
        storeOthersAsComment: "Vælg for at gemme værdien \"Andet\" som en separat egenskab i undersøgelsesresultater.",
        format: "Brug {0} som pladsholder for den faktiske værdi.",
        acceptedTypes: "Se beskrivelsen af attributten [accept](https://www.w3schools.com/tags/att_input_accept.asp) for at få flere oplysninger.",
        columnColCount: "Gælder kun for celletyperne Radiogruppe og afkrydsningsfelt.",
        autocomplete: "Se beskrivelsen af attributten [autofuldførelse](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) for at få flere oplysninger.",
        filePlaceholder: "Gælder, når \"Kildetype\" er \"Lokale filer\", eller når kameraet ikke er tilgængeligt",
        photoPlaceholder: "Gælder, når \"Kildetype\" er \"Kamera\".",
        fileOrPhotoPlaceholder: "Gælder, når \"Kildetype\" er \"Lokale filer eller kamera\".",
        masksettings: {
            saveMaskedValue: "Vælg, om du vil gemme spørgsmålsværdien med en anvendt maske i undersøgelsesresultater."
        },
        patternmask: {
            pattern: "Mønsteret kan indeholde strengkonstanter og følgende pladsholdere: '9' - for et ciffer; »a« - for store eller små bogstaver '#' - for et ciffer eller et stort eller lille bogstav. Brug omvendt skråstreg '\\' for at undslippe et tegn."
        },
        datetimemask: {
            pattern: "Mønsteret kan indeholde separatortegn og følgende pladsholdere:<br>'m' - Månedsnummer.<br>'mm' – Månedstal med foranstillet nul for encifrede værdier. <br>'d' - Dag i måneden. <br>'dd' – Dag i måneden med foranstillet nul for encifrede værdier. <br>'yy' - De sidste to cifre i året. <br>'åååå' - Firecifret årstal. <br>'H' - Timer i 24-timers format. <br>'HH' – timer i 24-timers format med foranstillet nul for encifrede værdier. <br>'h' - Timer i 12-timers format. <br>'hh' – Timer i 12-timers format med foranstillet nul for encifrede værdier. <br>»MM« - Minutter. <br>'ss' - sekunder. <br>'TT' - 12-timers urperiode med store bogstaver (AM/PM). <br>'TT' - 12-timers urperiode med små bogstaver (am / pm)."
        },
        numericmask: {
            decimalSeparator: "Et symbol, der bruges til at adskille brøkdelen fra heltalsdelen af et vist tal.",
            thousandsSeparator: "Et symbol, der bruges til at adskille cifrene i et stort tal i grupper på tre.",
            precision: "Begrænser, hvor mange cifre der skal bevares efter decimaltegnet for et vist tal."
        },
        currencymask: {
            prefix: "Et eller flere symboler, der skal vises før værdien.",
            suffix: "Et eller flere symboler, der skal vises efter værdien."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "titel",
            title: "Lad den være tom hvis det er det samme som 'Navn'"
        },
        multiSelect: "Tillad flere valg",
        showLabel: "Vis billedtekster",
        swapOrder: "Skift rækkefølgen Ja og Nej",
        value: "Værdi",
        tabAlign: "Tabulatorjustering",
        sourceType: "Kilde type",
        fitToContainer: "Passer til beholder",
        setValueExpression: "Angiv værdiudtryk",
        description: "description",
        logoFit: "Logo pasform",
        pages: "Sider",
        questions: "Spørgsmål",
        triggers: "triggers",
        calculatedValues: "Beregnede værdier",
        surveyId: "Undersøgelses-id",
        surveyPostId: "Id for undersøgelsespost",
        surveyShowDataSaving: "Undersøgelse viser lagring af data",
        questionDescriptionLocation: "Placering af spørgsmålsbeskrivelse",
        progressBarType: "Type af statuslinje",
        showTOC: "Vis indholdsfortegnelse",
        tocLocation: "Toc placering",
        questionTitlePattern: "Mønster for spørgsmålets titel",
        widthMode: "Bredde-tilstand",
        showBrandInfo: "Vis brandoplysninger",
        useDisplayValuesInDynamicTexts: "Brug visningsværdier i dynamiske tekster",
        visibleIf: "visibleIf",
        defaultValueExpression: "Standardværdiudtryk",
        requiredIf: "Påkrævet, hvis",
        resetValueIf: "Nulstil værdi, hvis",
        setValueIf: "Angiv værdi, hvis",
        validators: "validators",
        bindings: "Bindings",
        renderAs: "Gengiv som",
        attachOriginalItems: "Vedhæft originale elementer",
        choices: "choices",
        choicesByUrl: "choicesByUrl",
        currency: "currency",
        cellHint: "Celle tip",
        totalMaximumFractionDigits: "Maksimale brøkdele i alt",
        totalMinimumFractionDigits: "Mindste brøkdele i alt",
        columns: "columns",
        detailElements: "Detaljeelementer",
        allowAdaptiveActions: "Tillad adaptive handlinger",
        defaultRowValue: "defaultRowValue",
        detailPanelShowOnAdding: "Panelet Detaljer vises ved tilføjelse",
        choicesLazyLoadEnabled: "Valg doven belastning aktiveret",
        choicesLazyLoadPageSize: "Valg doven indlæsningssidestørrelse",
        inputFieldComponent: "Inputfeltkomponent",
        itemComponent: "Element komponent",
        min: "Min.",
        max: "Maks",
        minValueExpression: "Min værdi udtryk",
        maxValueExpression: "Maks. værdiudtryk",
        step: "Skridt",
        dataList: "Dataliste",
        itemSize: "itemSize",
        itemTitleWidth: "Bredde på vareetiket (i px)",
        elements: "Elementer",
        content: "Indhold",
        navigationButtonsVisibility: "navigationButtonsVisibility",
        navigationTitle: "Navigation titel",
        navigationDescription: "Beskrivelse af navigation",
        longTap: "Langt tryk",
        autoGrow: "Automatisk vækst",
        allowResize: "Tillad ændring af størrelse",
        acceptCarriageReturn: "Accepter retur af transport",
        displayMode: "Visningstilstand",
        rateType: "Sats type",
        label: "label",
        contentMode: "Indholdstilstand",
        imageFit: "Billede passer",
        altText: "Alternativ tekst",
        height: "Højde",
        penColor: "Pen farve",
        backgroundColor: "Baggrundsfarve",
        templateElements: "Skabelon elementer",
        operator: "Operatør",
        isVariable: "Er variabel",
        runExpression: "Kør udtryk",
        showCaption: "Vis billedtekst",
        iconName: "Ikon navn",
        iconSize: "Ikon størrelse",
        precision: "Præcision",
        matrixDragHandleArea: "Området for matrix-trækhåndtaget",
        backgroundImage: "Baggrundsbillede",
        backgroundImageFit: "Tilpasning af baggrundsbillede",
        backgroundImageAttachment: "Vedhæftet fil til baggrundsbillede",
        backgroundOpacity: "Opacitet i baggrunden",
        selectToRankEnabled: "Vælg at rangere aktiveret",
        selectToRankAreasLayout: "Vælg for at rangere områdelayout",
        selectToRankEmptyRankedAreaText: "Tekst, der viser, om alle indstillinger er markeret",
        selectToRankEmptyUnrankedAreaText: "Pladsholdertekst for rangeringsområdet",
        allowCameraAccess: "Tillad kameraadgang",
        scaleColorMode: "Skaler farvetilstand",
        rateColorMode: "Bedøm farvetilstand",
        copyDisplayValue: "Kopiér visningsværdi",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Avanceret tilstand",
        pageTitle: "Sidetitel skrifttype",
        questionTitle: "Skrifttype for spørgsmålstitel",
        editorPanel: "Input element",
        lines: "Linjer",
        primaryDefaultColor: "Standard",
        primaryDarkColor: "Hover",
        primaryLightColor: "Valgte",
        backgroundDimColor: "Baggrundsfarve",
        cornerRadius: "Hjørne radius",
        backcolor: "Standard baggrund",
        hovercolor: "Hold markøren over baggrunden",
        borderDecoration: "Kant dekoration",
        fontColor: "Skriftfarve",
        backgroundColor: "Baggrundsfarve",
        primaryForecolor: "Standardfarve",
        primaryForecolorLight: "Deaktiveret farve",
        font: "Skrifttype",
        borderDefault: "Mørkere",
        borderLight: "Lighter",
        fontFamily: "Skrifttypefamilie",
        fontWeightRegular: "Regelmæssig",
        fontWeightHeavy: "Tung",
        fontWeightSemiBold: "Halvfed skrift",
        fontWeightBold: "Modig",
        color: "Farve",
        placeholderColor: "Pladsholderfarve",
        size: "Størrelse",
        opacity: "Opacitet",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Tilføj skyggeeffekt",
        boxShadowBlur: "Sløring",
        boxShadowSpread: "Spredning",
        boxShadowDrop: "Dråbe",
        boxShadowInner: "Indre",
        names: {
            default: "Standard",
            sharp: "Skarp",
            borderless: "Kant",
            flat: "Flad",
            plain: "Slette",
            doubleborder: "Dobbelt kant",
            layered: "Lagdelte",
            solid: "Fast",
            threedimensional: ".3D",
            contrast: "Kontrast"
        },
        colors: {
            teal: "Krikand",
            blue: "Blå",
            purple: "Lilla",
            orchid: "Orkide",
            tulip: "Tulipan",
            brown: "Brun",
            green: "Grøn"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["da"] = danishStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// survey.externalHelpLink: "Watch and learn how to create surveys" => "Se og lær, hvordan du opretter undersøgelser"
// survey.externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber" => "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber"
// survey.addLogicItem: "Create a rule to customize the flow of the survey." => "Opret en regel for at tilpasse undersøgelsens flow."
// survey.duplicate: "Duplicate" => "Multiplicere"
// qt.ranking: "Ranking" => "Rangering"
// qt.image: "Image" => "Billede"
// qt.tagbox: "Multi-Select Dropdown" => "Rullemenu med flere valg"
// qt.signaturepad: "Signature" => "Underskrift"
// qt.buttongroup: "Button Group" => "Knap gruppe"
// ed.settingsTooltip: "Open settings" => "Åbn indstillinger"
// ed.surveySettings: "Survey Settings" => "Indstillinger for undersøgelse"
// ed.surveySettingsTooltip: "Open survey settings" => "Åbn undersøgelsesindstillinger"
// ed.showPanel: "Show Panel" => "Vis panel"
// ed.hidePanel: "Hide Panel" => "Skjul panel"
// ed.prevSelected: "Select previous" => "Vælg forrige"
// ed.nextSelected: "Select next" => "Vælg næste"
// ed.surveyTypeName: "Survey" => "Spørgeundersøgelse"
// ed.pageTypeName: "Page" => "Side"
// ed.panelTypeName: "Panel" => "Panelet"
// ed.questionTypeName: "Question" => "Spørgsmål"
// ed.columnTypeName: "Column" => "Kolonne"
// ed.newTextItemName: "text" => "Tekst"
// ed.themeSurvey: "Themes" => "Temaer"
// ed.defaultV2Theme: "Default" => "Standard"
// ed.modernTheme: "Modern" => "Moderne"
// ed.defaultTheme: "Default (legacy)" => "Standard (ældre)"
// ed.navigateToMsg: "You had to navigate to" => "Du var nødt til at navigere til"
// ed.logic: "Logic" => "Logik"
// ed.saveSurveyTooltip: "Save Survey" => "Gem undersøgelse"
// ed.jsonHideErrors: "Hide errors" => "Skjul fejl"
// ed.jsonShowErrors: "Show errors" => "Vis fejl"
// ed.undoTooltip: "Undo last change" => "Fortryd seneste ændring"
// ed.redoTooltip: "Redo the change" => "Fortryd ændringen"
// ed.showMoreChoices: "Show more" => "Vis mere"
// ed.showLessChoices: "Show less" => "Vis mindre"
// ed.copy: "Copy" => "Eksemplar"
// ed.cut: "Cut" => "Skære"
// ed.paste: "Paste" => "Indsætte"
// ed.copyTooltip: "Copy selection to clipboard" => "Kopiere markering til Udklipsholder"
// ed.cutTooltip: "Cut selection to clipboard" => "Klip markering til udklipsholder"
// ed.pasteTooltip: "Paste from clipboard" => "Indsæt fra udklipsholder"
// ed.property-grid: "Properties" => "Egenskaber"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "Skriv for at søge..."
// ed.toolboxChoiceCategory: "Choice Questions" => "Spørgsmål om valg"
// ed.toolboxTextCategory: "Text Input Questions" => "Spørgsmål om tekstinput"
// ed.toolboxContainersCategory: "Containers" => "Containere"
// ed.toolboxMatrixCategory: "Matrix Questions" => "Matrix spørgsmål"
// ed.toolboxMiscCategory: "Misc" => "Misc"
// ed.surveyResultsTable: "As Table" => "Som tabel"
// ed.surveyResultsJson: "As JSON" => "Som JSON"
// ed.resultsTitle: "Question Title" => "Spørgsmålets titel"
// ed.resultsName: "Question Name" => "Spørgsmålets navn"
// ed.resultsValue: "Answer Value" => "Svarværdi"
// ed.resultsDisplayValue: "Display Value" => "Visningsværdi"
// ed.propertyEditorError: "Error" => "Fejl"
// ed.translationPropertyGridTitle: "Language Settings" => "Sprogindstillinger"
// ed.themePropertyGridTitle: "Theme Settings" => "Temaindstillinger"
// ed.translationLanguages: "Languages" => "Sprog"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "Kun brugte strenge"
// ed.translationPlaceHolder: "Translation..." => "Oversættelse..."
// ed.themeExportButton: "Export" => "Eksport"
// ed.themeImportButton: "Import" => "Import"
// ed.bold: "Bold" => "Modig"
// ed.italic: "Italic" => "Kursiv"
// ed.underline: "Underline" => "Understrege"
// ed.addNewQuestion: "Add Question" => "Tilføj spørgsmål"
// ed.selectPage: "Select page..." => "Vælg side..."
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Valg kopieres fra"
// ed.htmlPlaceHolder: "HTML content will be here." => "HTML-indhold vil være her."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "Smid et spørgsmål fra værktøjskassen her."
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "Undersøgelsen er tom. Træk et element fra værktøjskassen, eller klik på knappen nedenfor."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Træk og slip et billede her, eller klik på knappen nedenfor, og vælg et billede, der skal uploades"
// ed.imageChooseImage: "Choose Image" => "Vælg billede"
// ed.addNewTypeQuestion: "Add {0}" => "Tilføj {0}"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[LOGO]"
// ed.auto: "auto" => "auto"
// ed.choices_Item: "Item " => "Vare "
// lg.addNewItem: "Add New Rule" => "Tilføj ny regel"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "Opret en regel for at tilpasse undersøgelsens flow."
// lg.page_visibilityName: "Show (hide) page" => "Vis (skjul) side"
// lg.page_enableName: "Enable (disable) page" => "Aktivér (deaktiver) side"
// lg.panel_visibilityName: "Show (hide) panel" => "Panelet Vis (skjul)"
// lg.panel_enableName: "Enable (disable) panel" => "Aktivér (deaktiver) panel"
// lg.question_visibilityName: "Show (hide) question" => "Vis (skjul) spørgsmål"
// lg.question_enableName: "Enable (disable) question" => "Aktivér (deaktiver) spørgsmål"
// lg.question_requireName: "Make question required" => "Gør spørgsmål påkrævet"
// lg.column_visibilityName: "Show (hide) column" => "Vis (skjul) kolonne"
// lg.column_enableName: "Enable (disable) column" => "Aktivér (deaktiver) kolonne"
// lg.column_requireName: "Make column required" => "Gør kolonne påkrævet"
// lg.trigger_completeName: "Complete survey" => "Komplet undersøgelse"
// lg.trigger_setvalueName: "Set answer" => "Indstil svar"
// lg.trigger_copyvalueName: "Copy answer" => "Kopier svar"
// lg.trigger_skipName: "Skip to question" => "Spring til spørgsmål"
// lg.trigger_runExpressionName: "Run expression" => "Kør udtryk"
// lg.completedHtmlOnConditionName: "Set \"Survey Complete\" page markup" => "Indstil sidemarkering af \"Undersøgelse fuldført\""
// lg.page_visibilityDescription: "Make the page visible when the logic expression returns true. Otherwise keep it invisible." => "Gør siden synlig, når det logiske udtryk returnerer sand. Ellers skal du holde det usynligt."
// lg.panel_visibilityDescription: "Make the panel visible when the logic expression returns true. Otherwise keep it invisible." => "Gør panelet synligt, når det logiske udtryk returnerer sand. Ellers skal du holde det usynligt."
// lg.panel_enableDescription: "Make the panel, and all elements inside it, enable when the logic expression returns true. Otherwise keep them disabled." => "Få panelet og alle elementer i det til at aktivere, når det logiske udtryk returnerer sand. Ellers skal du holde dem deaktiveret."
// lg.question_visibilityDescription: "Make the question visible when the logic expression returns true. Otherwise keep it invisible." => "Gør spørgsmålet synligt, når det logiske udtryk returnerer sand. Ellers skal du holde det usynligt."
// lg.question_enableDescription: "Make the question enable when the logic expression returns true. Otherwise keep it disabled." => "Få spørgsmålet til at aktivere, når det logiske udtryk returnerer sand. Ellers skal du holde det deaktiveret."
// lg.question_requireDescription: "Question becomes required when the logic expression returns true." => "Spørgsmål bliver påkrævet, når det logiske udtryk returnerer sandt."
// lg.trigger_completeDescription: "When the logic expression returns true then the survey becomes completed and an end-user see the 'Thank you page'." => "Når det logiske udtryk returnerer sand, afsluttes undersøgelsen, og en slutbruger ser siden \"Tak\"."
// lg.trigger_setvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value is set to the selected question." => "Når spørgsmålsværdier, der bruges i det logiske udtryk, ændres, og det logiske udtryk returnerer sand, angives værdien til det valgte spørgsmål."
// lg.trigger_copyvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value of one selected question is copied to another selected question." => "Når spørgsmålsværdier, der bruges i det logiske udtryk, ændres, og det logiske udtryk returnerer sand, kopieres værdien af et markeret spørgsmål til et andet markeret spørgsmål."
// lg.trigger_skipDescription: "When the logic expression returns true then the survey skip to / focus the selected question." => "Når det logiske udtryk returnerer sandt, springer undersøgelsen til / fokuserer det valgte spørgsmål."
// lg.trigger_runExpressionDescription: "When the logic expression returns true, then the custom expression is performed. You may optionally set this expression result into the selected question" => "Når det logiske udtryk returnerer sand, udføres det brugerdefinerede udtryk. Du kan eventuelt angive dette udtryksresultat i det valgte spørgsmål"
// lg.completedHtmlOnConditionDescription: "If the logic expression returns true, then the default text for the 'Thank you page' is changed to the given one." => "Hvis det logiske udtryk returnerer sandt, ændres standardteksten for 'Tak-siden' til den givne."
// lg.itemExpressionText: "When expression: '{0}' returns true" => "Når udtrykket: '{0}' returnerer sandt"
// lg.itemEmptyExpressionText: "New rule" => "Ny regel"
// lg.page_visibilityText: "make page {0} visible" => "Gør siden {0} synlig"
// lg.panel_visibilityText: "make panel {0} visible" => "Gør panelet {0} synligt"
// lg.panel_enableText: "make panel {0} enable" => "Få panelet {0} aktivere"
// lg.question_visibilityText: "make question {0} visible" => "Gør spørgsmål {0} synlige"
// lg.question_enableText: "make question {0} enable" => "Foretag spørgsmål{0} aktiver"
// lg.question_requireText: "make question {0} required" => "Gør spørgsmål {0} påkrævet"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "Gør kolonne {0} af spørgsmål {1} synlig"
// lg.column_enableText: "make column {0} of question {1} enable" => "Få kolonne {0} af spørgsmål {1} aktivere"
// lg.column_requireText: "make column {0} of question {1} required" => "Gøre kolonne {0} af spørgsmål {1} påkrævet"
// lg.trigger_completeText: "survey becomes completed" => "Undersøgelsen bliver afsluttet"
// lg.trigger_setvalueText: "set into question: {0} value {1}" => "Sæt spørgsmålstegn ved: {0} værdi {1}"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "Klar spørgsmålsværdi: {0}"
// lg.trigger_copyvalueText: "copy into question: {0} value from question {1}" => "Kopi i spørgsmål: {0} værdi fra spørgsmål {1}"
// lg.trigger_skipText: "survey skip to the question {0}" => "Undersøgelse Spring til spørgsmålet {0}"
// lg.trigger_runExpressionText1: "run expression: '{0}'" => "Kør udtryk: '{0}'"
// lg.trigger_runExpressionText2: " and set its result into question: {0}" => " og sætte spørgsmålstegn ved resultatet: {0}"
// lg.completedHtmlOnConditionText: "show custom text for the 'Thank you page'." => "Vis brugerdefineret tekst til siden \"Tak\"."
// lg.showAllQuestions: "All Questions" => "Alle spørgsmål"
// lg.showAllActionTypes: "All Action Types" => "Alle handlingstyper"
// lg.conditions: "Condition(s)" => "Tilstand(e)"
// lg.actions: "Action(s)" => "Foranstaltning(er)"
// lg.expressionEditorTitle: "Define condition(s)" => "Definer betingelse(r)"
// lg.actionsEditorTitle: "Define action(s)" => "Definer handling(er)"
// lg.deleteAction: "Delete Action" => "Slet handling"
// lg.addNewAction: "Add Action" => "Tilføj handling"
// lg.selectedActionCaption: "Select action..." => "Vælg handling..."
// lg.expressionInvalid: "The logic expression is empty or invalid. Please correct it." => "Det logiske udtryk er tomt eller ugyldigt. Vær venlig at rette det."
// lg.noActionError: "Please, add at least one action." => "Tilføj mindst én handling."
// lg.actionInvalid: "Please, fix problems in your action(s)." => "Løs venligst problemer i din(e) handling(er)."
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Logiske regler er ufuldstændige"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Du har ikke gennemført nogle af de logiske regler. Hvis du forlader fanen nu, vil ændringerne gå tabt. Vil du stadig forlade fanen uden at gennemføre ændringerne?"
// lg.uncompletedRule_apply: "Yes" => "Ja"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Nej, jeg vil gerne udfylde reglerne"
// pe.save: "Save" => "Spare"
// pe.clear: "Clear" => "Tydelig"
// pe.saveTooltip: "Save" => "Spare"
// pe.set: "Set" => "Sæt"
// pe.change: "Change" => "Forandre"
// pe.refresh: "Refresh" => "Opdatere"
// pe.add: "Add" => "Tilføje"
// pe.removeItem: "Click to remove the item..." => "Klik for at fjerne elementet..."
// pe.dragItem: "Drag the item" => "Træk elementet"
// pe.addOther: "Other" => "Anden"
// pe.addSelectAll: "Select All" => "Vælg alle"
// pe.addNone: "None" => "Ingen"
// pe.back: "Return without saving" => "Returner uden at gemme"
// pe.backTooltip: "Return without saving" => "Returner uden at gemme"
// pe.saveAndBack: "Save and return" => "Gem og returner"
// pe.saveAndBackTooltip: "Save and return" => "Gem og returner"
// pe.doneEditing: "Done" => "Gjort"
// pe.showChoices: "Show Choices" => "Vis valgmuligheder"
// pe.emptyValue: "Value is empty" => "Værdien er tom"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "Værdien '{0}' er ikke unik"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "Begræns antallet af varer fra {0} til {1}"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "Du kan indstille data i følgende format:\nværdi1|tekst\nværdi2"
// pe.itemSelectorEmpty: "Please select the element" => "Vælg elementet"
// pe.conditionActionEmpty: "Please select the action" => "Vælg handlingen"
// pe.conditionSelectPage: "Select page..." => "Vælg side..."
// pe.conditionSelectPanel: "Select panel..." => "Vælg panel..."
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "Få vist et eksempel på svarene, før du indsender undersøgelsen"
// pe.overridingPropertyPrefix: "Set by " => "Indstillet af "
// pe.propertyIsNoUnique: "Please enter a unique value" => "Indtast en unik værdi"
// pe.propertyNameIsNotUnique: "Please enter a unique name" => "Indtast et unikt navn"
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Brug ikke reserverede ord: \"element\", \"valg\", \"panel\", \"række\"."
// pe.listIsEmpty: "No items have been added yet" => "Der er endnu ikke tilføjet nogen varer"
// pe.listIsEmpty@choices: "No choices have been added yet" => "Der er endnu ikke tilføjet nogen valgmuligheder"
// pe.addNew@choices: "Add a choice" => "Tilføj et valg"
// pe.expressionIsEmpty: "Expression is empty" => "Udtrykket er tomt"
// choicesbyurl.valueName: "Get values from the following JSON field" => "Hent værdier fra følgende JSON-felt"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "Hent URL-adresser til billeder fra følgende JSON-felt"
// pe.allowEmptyResponse: "Allow empty response" => "Tillad tomt svar"
// pe.titlePlaceholder: "Title" => "Titel"
// pe.surveyTitlePlaceholder: "Survey Title" => "Undersøgelsens titel"
// pe.pageTitlePlaceholder: "Page {num}" => "Side {num}"
// pe.descriptionPlaceholder: "Description" => "Beskrivelse"
// pe.surveyDescriptionPlaceholder: "Description" => "Beskrivelse"
// pe.pageDescriptionPlaceholder: "Description" => "Beskrivelse"
// pe.showNoneItem: "Allow the None option" => "Tillad indstillingen Ingen"
// pe.noneText: "None option text" => "Ingen tekst til valgmulighed"
// pe.showSelectAllItem: "Allow the Select All option" => "Tillad indstillingen Vælg alt"
// pe.selectAllText: "Select All option text" => "Vælg tekst med valgmuligheden Alle"
// pe.choicesMin: "Minimum value for auto-generated items" => "Minimumsværdi for automatisk genererede varer"
// pe.choicesMax: "Maximum value for auto-generated items" => "Maksimal værdi for automatisk genererede varer"
// pe.choicesStep: "Step for auto-generated items" => "Trin for automatisk genererede elementer"
// pe.isAllRowRequired: "Require answer for all rows" => "Kræv svar for alle rækker"
// pe.requiredErrorText: "\"Required\" error message" => "Fejlmeddelelsen \"Påkrævet\""
// pe.cols: "Columns" => "Kolonner"
// pe.rateMin: "Minimum rate value" => "Mindste sats værdi"
// pe.rateMax: "Maximum rate value" => "Maksimal sats værdi"
// pe.rateStep: "Rate step" => "Sats trin"
// pe.buildExpression: "Build" => "Bygge"
// pe.editExpression: "Edit" => "Redigere"
// pe.and: "and" => "og"
// pe.or: "or" => "eller"
// pe.remove: "Remove" => "Fjerne"
// pe.addCondition: "Add Condition" => "Tilføj betingelse"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Vælg et spørgsmål for at begynde at konfigurere betingelser."
// pe.if: "If" => "Hvis"
// pe.then: "then" => "derpå"
// pe.setToName: "Target question" => "Mål spørgsmål"
// pe.fromName: "Question to copy answer from" => "Spørgsmål at kopiere svar fra"
// pe.gotoName: "Question to skip to" => "Spørgsmål at springe til"
// pe.ruleIsNotSet: "Rule is incorrect" => "Reglen er forkert"
// pe.includeIntoResult: "Include into survey results" => "Medtag i undersøgelsesresultater"
// pe.expandCollapseTitle: "Expand/collapse title" => "Udvid/skjul titel"
// pe.simulator: "Select device type" => "Vælg enhedstype"
// pe.landscapeOrientation: "Switch to landscape orientation" => "Skift til liggende retning"
// pe.portraitOrientation: "Switch to portrait orientation" => "Skift til stående format"
// pe.previewText: "Preview Answers button text" => "Tekst til knappen Vis svar"
// pe.editText: "Edit Answer button text" => "Tekst til knappen Rediger svar"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Billedhøjde (i CSS-accepterede værdier)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Billedbredde (i CSS-accepterede værdier)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "Tidsgrænse for at afslutte siden (i sekunder)"
// question.page: "Parent page" => "Overordnet side"
// pe.noEntriesText: "Empty entries text" => "Tekst til tomme poster"
// pe.html: "HTML markup" => "HTML-markering"
// pe.expression: "Expression" => "Udtryk"
// pe.setValue: "Answer" => "Svare"
// pe.dataFormat: "Image format" => "Billedformat"
// pe.allowAddRows: "Allow adding rows" => "Tillad tilføjelse af rækker"
// pe.allowRemoveRows: "Allow removing rows" => "Tillad fjernelse af rækker"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "Tillad træk og slip af rækker"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "Gælder ikke, hvis du angiver den nøjagtige billedbredde eller -højde."
// pe.minImageWidth: "Minimum image width" => "Mindste billedbredde"
// pe.maxImageWidth: "Maximum image width" => "Maksimal billedbredde"
// pe.minImageHeight: "Minimum image height" => "Mindste billedhøjde"
// pe.maxImageHeight: "Maximum image height" => "Maksimal billedhøjde"
// pe.minValue: "Minimum value" => "Mindste værdi"
// pe.maxValue: "Maximum value" => "Maksimal værdi"
// pe.minLength: "Minimum length (in characters)" => "Mindste længde (med bogstaver)"
// pe.allowDigits: "Allow digits" => "Tillad cifre"
// pe.minCount: "Minimum count" => "Mindste antal"
// pe.maxCount: "Maximum count" => "Maksimalt antal"
// pe.regex: "Regular expression" => "Regulært udtryk"
// surveyvalidator.text: "Error message" => "Fejlmeddelelse"
// surveyvalidator.expression: "Validation expression" => "Valideringsudtryk"
// pe.totalText: "Total row text" => "Tekst i samlet række"
// pe.totalType: "Total type" => "Samlet type"
// pe.totalExpression: "Total expression" => "Samlet udtryk"
// pe.totalDisplayStyle: "Total value display style" => "Visningstypografi for samlet værdi"
// pe.totalCurrency: "Currency" => "Valuta"
// pe.totalFormat: "Formatted string" => "Formateret streng"
// pe.logo: "Logo (URL or base64-encoded string)" => "Logo (URL eller base64-kodet streng)"
// pe.questionsOnPageMode: "Survey structure" => "Undersøgelsens opbygning"
// pe.maxTextLength: "Maximum answer length (in characters)" => "Maksimal svarlængde (med tegn)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "Maksimal kommentarlængde (i tegn)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "Udvid automatisk kommentarområdet, hvis det er nødvendigt"
// pe.allowResizeComment: "Allow users to resize text areas" => "Tillad brugere at ændre størrelsen på tekstområder"
// pe.textUpdateMode: "Update text question value" => "Opdater værdi for tekstspørgsmål"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "Sæt fokus på det første ugyldige svar"
// pe.checkErrorsMode: "Run validation" => "Kør validering"
// pe.navigateToUrl: "Navigate to URL" => "Naviger til URL"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "Dynamisk webadresse"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "Markering for at vise, om brugeren allerede har udfyldt denne undersøgelse"
// pe.completedHtml: "Survey Complete page markup" => "Opmærkning af siden Undersøgelse fuldført"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "Dynamisk undersøgelse fuldført sidemarkering"
// pe.loadingHtml: "Markup to show while survey model is loading" => "Markering, der skal vises, mens undersøgelsesmodellen indlæses"
// pe.commentText: "Comment area text" => "Tekst i kommentarområdet"
// pe.autocomplete: "Autocomplete type" => "Type Autofuldførelse"
// pe.labelTrue: "\"True\" label" => "\"True\" etiket"
// pe.labelFalse: "\"False\" label" => "Etiketten \"Falsk\""
// pe.allowClear: "Show the Clear button" => "Vis knappen Ryd"
// pe.displayStyle: "Value display style" => "Værdi visningsstil"
// pe.format: "Formatted string" => "Formateret streng"
// pe.maximumFractionDigits: "Maximum fractional digits" => "Maksimalt antal brøkdele"
// pe.minimumFractionDigits: "Minimum fractional digits" => "Mindste brøkdele"
// pe.useGrouping: "Display grouping separators" => "Vis grupperingsseparatorer"
// pe.allowMultiple: "Allow multiple files" => "Tillad flere filer"
// pe.allowImagesPreview: "Preview images" => "Se eksempler på billeder"
// pe.acceptedTypes: "Accepted file types" => "Accepterede filtyper"
// pe.waitForUpload: "Wait for the upload to complete" => "Vent på, at overførslen er fuldført"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "Bekræft sletning af fil"
// pe.detailPanelMode: "Detail panel location" => "Placering af panelet Detaljer"
// pe.minRowCount: "Minimum row count" => "Mindste antal rækker"
// pe.maxRowCount: "Maximum row count" => "Maksimalt antal rækker"
// pe.confirmDelete: "Confirm row deletion" => "Bekræft sletning af række"
// pe.confirmDeleteText: "Confirmation message" => "Bekræftelsesmeddelelse"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "Bekræft sletning af panel"
// pe.panelCount: "Initial panel count" => "Indledende antal paneler"
// pe.minPanelCount: "Minimum panel count" => "Mindste antal paneler"
// pe.maxPanelCount: "Maximum panel count" => "Maksimalt antal paneler"
// pe.panelsState: "Inner panel expand state" => "Udvid tilstand for indvendigt panel"
// pe.templateDescription: "Description template" => "Beskrivelse skabelon"
// pe.templateTitle: "Title template" => "Titel skabelon"
// pe.panelPrevText: "Previous Panel button tooltip" => "Forrige værktøjstip til panelknap"
// pe.panelNextText: "Next Panel button tooltip" => "Værktøjstip til knappen Næste panel"
// pe.showRangeInProgress: "Show progress bar" => "Vis statuslinje"
// pe.templateTitleLocation: "Question title location" => "Placering af spørgsmålets titel"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "Fjern placering af panelknap"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "Skjul spørgsmålet, hvis der ikke er nogen rækker"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Skjule kolonner, hvis der ikke er nogen rækker"
// pe.rateValues: "Custom rate values" => "Tilpassede satsværdier"
// pe.rateCount: "Rate count" => "Antal satser"
// pe.autoGenerate: "How to specify rate values?" => "Hvordan angives satsværdier?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "Skjul spørgsmålet, hvis det ikke indeholder nogen valgmuligheder"
// pe.hideNumber: "Hide question number" => "Skjul spørgsmålsnummer"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Minimumbredde (i CSS-accepterede værdier)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Maksimal bredde (i CSS-accepterede værdier)"
// pe.width: "Width (in CSS-accepted values)" => "Bredde (i CSS-accepterede værdier)"
// pe.showHeader: "Show column headers" => "Vis kolonneoverskrifter"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Vis vandret rullepanel"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Mindste kolonnebredde (i CSS-accepterede værdier)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Bredde på rækkeoverskrift (i CSS-accepterede værdier)"
// pe.valueTrue: "\"True\" value" => "\"Sand\" værdi"
// pe.valueFalse: "\"False\" value" => "\"Falsk\" værdi"
// pe.minErrorText: "\"Value is below minimum\" error message" => "Fejlmeddelelsen \"Værdien er under minimum\""
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "Fejlmeddelelsen \"Værdien overstiger maksimum\""
// pe.otherErrorText: "\"Empty comment\" error message" => "Fejlmeddelelsen \"Tom kommentar\""
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "Fejlmeddelelsen \"Ikke-entydig nøgleværdi\""
// pe.minSelectedChoices: "Minimum selected choices" => "Minimum valgte valg"
// pe.maxSelectedChoices: "Maximum selected choices" => "Maksimalt antal valgte valg"
// pe.showClearButton: "Show the Clear button" => "Vis knappen Ryd"
// pe.showNumber: "Show panel number" => "Vis panelnummer"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "Logobredde (i CSS-accepterede værdier)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "Logohøjde (i CSS-accepterede værdier)"
// pe.readOnly: "Read-only" => "Skrivebeskyttet"
// pe.enableIf: "Editable if" => "Redigerbar, hvis"
// pe.emptyRowsText: "\"No rows\" message" => "Meddelelsen \"Ingen rækker\""
// pe.size: "Input field size (in characters)" => "Inputfeltstørrelse (i tegn)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "Adskil særlige valg (Ingen, Andet, Vælg alle)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Kopiér valg fra følgende spørgsmål"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Hvilke valgmuligheder skal kopieres?"
// pe.showCommentArea: "Show the comment area" => "Vis kommentarområdet"
// pe.commentPlaceholder: "Comment area placeholder" => "Pladsholder til kommentarområde"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Beskrivelser af visningshastighed som ekstreme værdier"
// pe.rowsOrder: "Row order" => "Rækkefølge af rækker"
// pe.columnsLayout: "Column layout" => "Kolonnelayout"
// pe.columnColCount: "Nested column count" => "Antal indlejrede kolonner"
// pe.state: "Panel expand state" => "Panel udvide tilstand"
// pe.correctAnswer: "Correct Answer" => "Korrekt svar"
// pe.defaultPanelValue: "Default Values" => "Standardværdier"
// pe.cells: "Cell Texts" => "Celle tekster"
// pe.keyName: "Key column" => "Nøglekolonne"
// itemvalue.text: "Alt text" => "Alternativ tekst"
// pe.logoPosition: "Logo position" => "Logo position"
// pe.addLogo: "Add logo..." => "Tilføj logo..."
// pe.changeLogo: "Change logo..." => "Skift logo..."
// logoPositions.none: "Remove logo" => "Fjern logo"
// logoPositions.left: "Left" => "Venstre"
// logoPositions.right: "Right" => "Højre"
// logoPositions.top: "On the top" => "På toppen"
// logoPositions.bottom: "In the bottom" => "I bunden"
// tabs.requiredIf: "Required If" => "Påkrævet, hvis"
// tabs.numbering: "Numbering" => "Nummerering"
// tabs.pages: "Pages" => "Sider"
// tabs.calculatedValues: "Calculated Values" => "Beregnede værdier"
// tabs.totals: "Totals" => "Totaler"
// tabs.logic: "Logic" => "Logik"
// tabs.layout: "Layout" => "Layout"
// tabs.data: "Data" => "Data"
// tabs.validation: "Validation" => "Validering"
// tabs.cells: "Cell Texts" => "Celle tekster"
// tabs.showOnCompleted: "Survey Complete" => "Undersøgelsen er fuldført"
// tabs.logo: "Logo in Survey Title" => "Logo i undersøgelsens titel"
// tabs.slider: "Slider" => "Skyderen"
// tabs.expression: "Expression" => "Udtryk"
// tabs.others: "Others" => "Andre"
// pe.choicesVisibleIf: "Choices are visible if" => "Valg er synlige, hvis"
// pe.choicesEnableIf: "Choices are selectable if" => "Valg kan vælges, hvis:"
// pe.columnsEnableIf: "Columns are visible if" => "Kolonner er synlige, hvis"
// pe.rowsEnableIf: "Rows are visible if" => "Rækker er synlige, hvis"
// pe.indent: "Add indents" => "Tilføj indrykninger"
// panel.indent: "Add outer indents" => "Tilføj ydre indrykninger"
// pe.innerIndent: "Add inner indents" => "Tilføj indre indrykninger"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "Tag standardværdier fra den sidste række"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "Tag standardværdier fra det sidste panel"
// pe.titleKeyboardAdornerTip: "Press enter button to edit" => "Tryk på enter-knappen for at redigere"
// pe.keyboardAdornerTip: "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item" => "Tryk på enter-knappen for at redigere elementet, tryk på slet-knappen for at slette elementet, tryk på alt plus pil op eller pil ned for at flytte elementet"
// pe.triggerGotoName: "Go to the question" => "Gå til spørgsmålet"
// pe.triggerRunExpressionEmpty: "Please enter a valid expression" => "Indtast et gyldigt udtryk"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "Skriv udtryk her..."
// pe.noFile: "No file choosen" => "Ingen fil valgt"
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "Ryd værdien, hvis spørgsmålet bliver skjult"
// pe.valuePropertyName: "Value property name" => "Egenskabsnavn for værdi"
// pe.searchEnabled: "Enable search" => "Aktivér søgning"
// pe.hideSelectedItems: "Hide selected items" => "Skjule markerede elementer"
// pe.closeOnSelect: "Close the dropdown after selection" => "Luk rullemenuen efter markering"
// pe.signatureWidth: "Signature width" => "Signaturens bredde"
// pe.signatureHeight: "Signature height" => "Signatur højde"
// pe.verticalAlign: "Vertical alignment" => "Lodret justering"
// pe.alternateRows: "Alternate rows" => "Alternative rækker"
// pe.columnsVisibleIf: "Columns are visible if" => "Kolonner er synlige, hvis"
// pe.rowsVisibleIf: "Rows are visible if" => "Rækker er synlige, hvis"
// pe.otherPlaceholder: "Comment area placeholder" => "Pladsholder til kommentarområde"
// pe.rateType: "Rate type" => "Sats type"
// pv.true: "true" => "sand"
// pv.false: "false" => "falsk"
// pv.decimal: "decimal" => "decimal"
// pv.currency: "currency" => "valuta"
// pv.percent: "percent" => "procent"
// pv.onpanel: "Start on each panel" => "Start på hvert panel"
// pv.tab: "Tabs" => "Faner"
// pv.both: "Both" => "Begge"
// pv.right: "Right" => "Højre"
// pv.color: "color" => "farve"
// pv.date: "date" => "dato"
// pv.datetime: "datetime" => "datetime"
// pv.datetime-local: "datetime-local" => "datetime-lokal"
// pv.email: "email" => "E-mail"
// pv.month: "month" => "måned"
// pv.number: "number" => "tal"
// pv.password: "password" => "kodeord"
// pv.range: "range" => "interval"
// pv.tel: "tel" => "Tel"
// pv.text: "text" => "Tekst"
// pv.time: "time" => "Tidspunkt"
// pv.url: "url" => "URL-adresse"
// pv.week: "week" => "uge"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "Når spørgsmålet eller dets panel/side bliver skjult"
// clearInvisibleValues.none: "Never" => "Aldrig"
// inputType.color: "Color" => "Farve"
// inputType.date: "Date" => "Dato"
// inputType.datetime-local: "Date and Time" => "Dato og klokkeslæt"
// inputType.email: "Email" => "E-mail"
// inputType.month: "Month" => "Måned"
// inputType.number: "Number" => "Tal"
// inputType.password: "Password" => "Kodeord"
// inputType.range: "Range" => "Interval"
// inputType.tel: "Phone Number" => "Telefonnummer"
// inputType.text: "Text" => "Tekst"
// inputType.time: "Time" => "Tidspunkt"
// inputType.url: "URL" => "URL-adresse"
// inputType.week: "Week" => "Uge"
// pv.onValueChanging: "Before an answer is changed" => "Før et svar ændres"
// pv.standard: "Original structure" => "Oprindelig struktur"
// pv.singlePage: "All questions on a single page" => "Alle spørgsmål på en enkelt side"
// pv.questionPerPage: "Each question on an individual page" => "Hvert spørgsmål på en individuel side"
// pv.noPreview: "No preview" => "Ingen forhåndsvisning"
// pv.showAllQuestions: "Show all questions" => "Vis alle spørgsmål"
// pv.showAnsweredQuestions: "Show answered questions only" => "Vis kun besvarede spørgsmål"
// pv.pages: "Completed pages" => "Afsluttede sider"
// pv.questions: "Answered questions" => "Besvarede spørgsmål"
// pv.requiredQuestions: "Answered required questions" => "Besvarede nødvendige spørgsmål"
// pv.correctQuestions: "Valid answers" => "Gyldige svar"
// pv.buttons: "Completed pages (button UI)" => "Afsluttede sider (knapbrugergrænseflade)"
// pv.underInput: "Under the input" => "Under indgangen"
// pv.underTitle: "Under the title" => "Under titlen"
// pv.onBlur: "On blur" => "På sløring"
// pv.onTyping: "While typing" => "Mens du skriver"
// pv.underRow: "Under the row" => "Under rækken"
// pv.underRowSingle: "Under the row, only one panel is visible" => "Under rækken er kun ét panel synligt"
// showNavigationButtons.none: "Hidden" => "Skjult"
// showProgressBar.off: "Hidden" => "Skjult"
// showTimerPanel.none: "Hidden" => "Skjult"
// showTimerPanelMode.all: "Both" => "Begge"
// detailPanelMode.none: "Hidden" => "Skjult"
// addRowLocation.default: "Depends on matrix layout" => "Afhænger af matrixlayout"
// panelsState.default: "Users cannot expand or collapse panels" => "Brugere kan ikke udvide eller skjule paneler"
// panelsState.collapsed: "All panels are collapsed" => "Alle paneler er skjult"
// panelsState.expanded: "All panels are expanded" => "Alle paneler er udvidet"
// widthMode.auto: "Auto" => "Auto"
// widthMode.static: "Static" => "Statisk"
// widthMode.responsive: "Responsive" => "Lydhør"
// imageFit.none: "None" => "Ingen"
// imageFit.contain: "Contain" => "Indeholde"
// imageFit.cover: "Cover" => "Dække"
// imageFit.fill: "Fill" => "Fylde"
// contentMode.auto: "Auto" => "Auto"
// contentMode.image: "Image" => "Billede"
// contentMode.video: "Video" => "Video"
// contentMode.youtube: "YouTube" => "YouTube"
// displayMode.auto: "Auto" => "Auto"
// displayMode.buttons: "Buttons" => "Knapper"
// displayMode.dropdown: "Dropdown" => "Rullemenu"
// rateColorMode.default: "Default" => "Standard"
// autoGenerate.true: "Generate" => "Frembringe"
// autoGenerate.false: "Enter manually" => "Indtast manuelt"
// rateType.labels: "Labels" => "Etiketter"
// rateType.stars: "Stars" => "Stjerner"
// rateType.smileys: "Smileys" => "Smileys"
// op.anyof: "Any of" => "Enhver af"
// op.allof: "All of" => "Alle af"
// op.and: "and" => "og"
// op.or: "or" => "eller"
// ew.modern: "Modern theme" => "Moderne tema"
// ew.default: "Default theme" => "Standardtema"
// ew.orange: "Orange theme" => "Orange tema"
// ew.darkblue: "Darkblue theme" => "Mørkeblåt tema"
// ew.darkrose: "Darkrose theme" => "Temaet Darkrose"
// ew.stone: "Stone theme" => "Temaet Sten"
// ew.winter: "Winter theme" => "Vinter tema"
// ew.winterstone: "Winter-Stone theme" => "Temaet Vintersten"
// ts.showInvisibleElements: "Show invisible elements" => "Vis usynlige elementer"
// ts.hideInvisibleElements: "Hide invisible elements" => "Skjul usynlige elementer"
// triggers.skiptrigger: "Skip to question" => "Spring til spørgsmål"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Cookies forhindrer brugere i at udfylde den samme undersøgelse to gange."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Ændrer størrelsen på det synlige område af inputfeltet. Brug indstillingen <b>Validering → Maksimal længde</b> for at begrænse inputlængden."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Brug {0} som pladsholder for den faktiske værdi."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Kun synlig, når mindst én kolonne har typen Total eller Totaludtryk."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Se beskrivelsen af attributten [accept](https://www.w3schools.com/tags/att_input_accept.asp) for at få flere oplysninger."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Gælder kun for celletyperne Radiogruppe og afkrydsningsfelt."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Se beskrivelsen af attributten [autofuldførelse](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) for at få flere oplysninger."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Hvis du ikke angiver denne egenskab, gemmes svaret i et felt, der er angivet af egenskaben Navn."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Hvis den angivne kolonne indeholder identiske værdier, kaster undersøgelsen fejlen \"Ikke-unik nøgleværdi\"."
// p.multiSelect: "Allow multiple selection" => "Tillad flere valg"
// p.showLabel: "Show image captions" => "Vis billedtekster"
// p.value: "Value" => "Værdi"
// p.tabAlign: "Tab alignment" => "Tabulatorjustering"
// p.logoFit: "Logo fit" => "Logo pasform"
// p.pages: "Pages" => "Sider"
// p.questions: "Questions" => "Spørgsmål"
// p.calculatedValues: "Calculated values" => "Beregnede værdier"
// p.surveyId: "Survey id" => "Undersøgelses-id"
// p.surveyPostId: "Survey post id" => "Id for undersøgelsespost"
// p.surveyShowDataSaving: "Survey show data saving" => "Undersøgelse viser lagring af data"
// p.questionDescriptionLocation: "Question description location" => "Placering af spørgsmålsbeskrivelse"
// p.progressBarType: "Progress bar type" => "Type af statuslinje"
// p.showTOC: "Show TOC" => "Vis indholdsfortegnelse"
// p.tocLocation: "Toc location" => "Toc placering"
// p.questionTitlePattern: "Question title pattern" => "Mønster for spørgsmålets titel"
// p.widthMode: "Width mode" => "Bredde-tilstand"
// p.showBrandInfo: "Show brand info" => "Vis brandoplysninger"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "Brug visningsværdier i dynamiske tekster"
// p.descriptionLocation: "Description location" => "Beskrivelse placering"
// p.defaultValueExpression: "Default value expression" => "Standardværdiudtryk"
// p.requiredIf: "Required if" => "Påkrævet, hvis"
// p.bindings: "Bindings" => "Bindings"
// p.renderAs: "Render as" => "Gengiv som"
// p.attachOriginalItems: "Attach original items" => "Vedhæft originale elementer"
// p.cellHint: "Cell hint" => "Celle tip"
// p.isUnique: "Is unique" => "Er unik"
// p.showInMultipleColumns: "Show in multiple columns" => "Vis i flere kolonner"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Maksimale brøkdele i alt"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Mindste brøkdele i alt"
// p.detailElements: "Detail elements" => "Detaljeelementer"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Tillad adaptive handlinger"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "Panelet Detaljer vises ved tilføjelse"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Valg doven belastning aktiveret"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Valg doven indlæsningssidestørrelse"
// p.inputFieldComponent: "Input field component" => "Inputfeltkomponent"
// p.itemComponent: "Item component" => "Element komponent"
// p.min: "Min" => "Min."
// p.max: "Max" => "Maks"
// p.minValueExpression: "Min value expression" => "Min værdi udtryk"
// p.maxValueExpression: "Max value expression" => "Maks. værdiudtryk"
// p.step: "Step" => "Skridt"
// p.dataList: "Data list" => "Dataliste"
// p.elements: "Elements" => "Elementer"
// p.content: "Content" => "Indhold"
// p.navigationTitle: "Navigation title" => "Navigation titel"
// p.navigationDescription: "Navigation description" => "Beskrivelse af navigation"
// p.longTap: "Long tap" => "Langt tryk"
// p.autoGrow: "Auto grow" => "Automatisk vækst"
// p.allowResize: "Allow resizing" => "Tillad ændring af størrelse"
// p.acceptCarriageReturn: "Accept carriage return" => "Accepter retur af transport"
// p.displayMode: "Display mode" => "Visningstilstand"
// p.rateType: "Rate type" => "Sats type"
// p.contentMode: "Content mode" => "Indholdstilstand"
// p.imageFit: "Image fit" => "Billede passer"
// p.altText: "Alt text" => "Alternativ tekst"
// p.height: "Height" => "Højde"
// p.penColor: "Pen color" => "Pen farve"
// p.backgroundColor: "Background color" => "Baggrundsfarve"
// p.templateElements: "Template elements" => "Skabelon elementer"
// p.operator: "Operator" => "Operatør"
// p.isVariable: "Is variable" => "Er variabel"
// p.runExpression: "Run expression" => "Kør udtryk"
// p.showCaption: "Show caption" => "Vis billedtekst"
// p.iconName: "Icon name" => "Ikon navn"
// p.iconSize: "Icon size" => "Ikon størrelse"
// p.precision: "Precision" => "Præcision"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Området for matrix-trækhåndtaget"
// p.backgroundImage: "Background image" => "Baggrundsbillede"
// p.backgroundImageFit: "Background image fit" => "Tilpasning af baggrundsbillede"
// p.backgroundImageAttachment: "Background image attachment" => "Vedhæftet fil til baggrundsbillede"
// p.backgroundOpacity: "Background opacity" => "Opacitet i baggrunden"
// p.selectToRankEnabled: "Select to rank enabled" => "Vælg at rangere aktiveret"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Vælg for at rangere områdelayout"
// p.allowCameraAccess: "Allow camera access" => "Tillad kameraadgang"
// p.scaleColorMode: "Scale color mode" => "Skaler farvetilstand"
// p.rateColorMode: "Rate color mode" => "Bedøm farvetilstand"
// p.templateTabTitle: "Template tab title" => "Titel på fanen Skabelon"
// p.templateVisibleIf: "Template visible if" => "Skabelon synlig, hvis"
// p.copyDisplayValue: "Copy display value" => "Kopiér visningsværdi"
// theme.--background: "Background color" => "Baggrundsfarve"
// theme.--background-dim-light: "Background dim light color" => "Baggrund svag lys farve"
// theme.--primary-foreground: "Primary foreground color" => "Primær forgrundsfarve"
// theme.--foreground: "Foreground color" => "Forgrundsfarve"
// theme.--base-unit: "Base unit" => "Basisenhed"
// theme.groupAdvanced: "Advanced" => "Avanceret"
// theme.themeName: "Theme" => "Tema"
// theme.isPanellessss: "Question appearance" => "Spørgsmål udseende"
// theme.isPanellessPanels: "Default" => "Standard"
// theme.isPanellessLightweight: "Without Panels" => "Uden paneler"
// theme.themePaletteLight: "Light" => "Lys"
// theme.themePaletteDark: "Dark" => "Mørk"
// theme.primaryColor: "Accent color" => "Accent farve"
// theme.primaryDefaultColor: "Default" => "Standard"
// theme.primaryDarkColor: "Hover" => "Hover"
// theme.primaryLightColor: "Selected" => "Valgte"
// theme.backgroundDimColor: "Background color" => "Baggrundsfarve"
// theme.backgroundImage: "Background image" => "Baggrundsbillede"
// theme.backgroundImageFitAuto: "Auto" => "Auto"
// theme.backgroundImageFitCover: "Cover" => "Dække"
// theme.backgroundImageFitContain: "Contain" => "Indeholde"
// theme.backgroundOpacity: "Opacity" => "Opacitet"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Fast"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Rulle"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Opacitet af panelets baggrund"
// theme.questionBackgroundTransparency: "Question background opacity" => "Spørgsmål baggrundsuigennemsigtighed"
// theme.questionPanel: "Panel background and corner radius" => "Panelbaggrund og hjørneradius"
// theme.questionTitle: "Question title font" => "Skrifttype for spørgsmålstitel"
// theme.questionDescription: "Question description font" => "Skrifttype til beskrivelse af spørgsmål"
// theme.editorPanel: "Input element" => "Input element"
// theme.editorFont: "Input element font" => "Skrifttype for inputelement"
// theme.backcolor: "Default background" => "Standard baggrund"
// theme.hovercolor: "Hover background" => "Hold markøren over baggrunden"
// theme.borderDecoration: "Border decoration" => "Kant dekoration"
// theme.accentBackground: "Accent background" => "Accent baggrund"
// theme.accentForeground: "Accent foreground" => "Accent forgrund"
// theme.primaryForecolor: "Default color" => "Standardfarve"
// theme.primaryForecolorLight: "Disabled color" => "Deaktiveret farve"
// theme.linesColors: "Minor line colors" => "Mindre stregfarver"
// theme.borderDefault: "Darker" => "Mørkere"
// theme.borderLight: "Lighter" => "Lighter"
// theme.fontFamily: "Font family" => "Skrifttypefamilie"
// theme.fontSize: "Font size" => "Skrifttypestørrelse"
// theme.color: "Color" => "Farve"
// theme.size: "Size" => "Størrelse"
// theme.fontWeightRegular: "Regular" => "Regelmæssig"
// theme.fontWeightHeavy: "Heavy" => "Tung"
// theme.fontWeightSemiBold: "Semi-bold" => "Halvfed skrift"
// theme.fontWeightBold: "Bold" => "Modig"
// theme.scale: "Scale" => "Skæl"
// theme.cornerRadius: "Corner radius" => "Hjørne radius"
// theme.surveyTitleFont: "Survey title font" => "Skrifttype for undersøgelsestitel"
// theme.pageTitle: "Page title font" => "Sidetitel skrifttype"
// theme.pageDescription: "Page description font" => "Sidebeskrivelse skrifttype"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Tilføj skyggeeffekt"
// theme.opacity: "Opacity" => "Opacitet"
// theme.boxShadowBlur: "Blur" => "Sløring"
// theme.boxShadowSpread: "Spread" => "Spredning"
// theme.boxShadowDrop: "Drop" => "Dråbe"
// theme.boxShadowInner: "Inner" => "Indre"
// theme.questionShadow: "Shadow effects" => "Skyggeeffekter"
// theme.editorShadow: "Input element shadow effects" => "Skyggeeffekter for inputelement"
// names.default: "Default" => "Standard"
// names.contrast: "Contrast" => "Kontrast"
// names.plain: "Plain" => "Slette"
// names.simple: "Simple" => "Simpel"
// names.blank: "Blank" => "Hvid"
// names.double: "Double" => "Dobbelt"
// names.bulk: "Bulk" => "Bulk"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo 3D"
// names.playful: "Playful" => "Legende"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Krikand"
// colors.blue: "Blue" => "Blå"
// colors.purple: "Purple" => "Lilla"
// colors.orchid: "Orchid" => "Orkide"
// colors.tulip: "Tulip" => "Tulipan"
// colors.brown: "Brown" => "Brun"
// colors.green: "Green" => "Grøn"
// names.sharp: "Sharp" => "Skarp"
// names.borderless: "Borderless" => "Kant"
// names.flat: "Flat" => "Flad"
// names.doubleborder: "Double Border" => "Dobbelt kant"
// names.layered: "Layered" => "Lagdelte"
// names.solid: "Solid" => "Fast"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Er du sikker på, at du ønsker at slette alle strenge for dette sprog?"
// ed.themeResetButton: "Reset theme settings to default" => "Nulstil temaindstillinger til standard"
// theme.placeholderColor: "Placeholder color" => "Pladsholderfarve"
// ed.themeSettings: "Theme Settings" => "Temaindstillinger"
// ed.themeSettingsTooltip: "Open theme settings" => "Åbn temaindstillinger"
// pe.resetToDefaultCaption: "Reset" => "Nulstille"
// pv.file: "Local files" => "Lokale filer"
// pv.camera: "Camera" => "Kamera"
// pv.file-camera: "Local files or camera" => "Lokale filer eller kamera"
// ed.translateUsigAI: "Auto-translate All" => "Oversæt automatisk alle"
// ed.translationDialogTitle: "Untranslated strings" => "Uoversatte strenge"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Indtast mindst {0} punkter"
// lg.question_resetValueName: "Reset question value" => "Nulstil spørgsmålsværdi"
// lg.column_resetValue: "Reset column value" => "Nulstil kolonneværdi"
// pe.markRequired: "Mark as required" => "Markér efter behov"
// pe.removeRequiredMark: "Remove the required mark" => "Fjern det påkrævede mærke"
// p.resetValueIf: "Reset value if" => "Nulstil værdi, hvis"
// lg.question_setValueName: "Set question value" => "Angiv spørgsmålsværdi"
// lg.column_resetValueName: "Reset column value" => "Nulstil kolonneværdi"
// lg.column_setValueName: "Set column value" => "Angiv kolonneværdi"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Et udtryk, hvis resultat vil blive tildelt målspørgsmålet."
// survey.title: "Title" => "Titel"
// page.title: "Title" => "Titel"
// p.setValueIf: "Set value if" => "Angiv værdi, hvis"
// theme.header: "Header" => "Header"
// theme.backgroundImageFitFill: "Stretch" => "Stræk"
// theme.backgroundImageFitTile: "Tile" => "Flise"
// theme.headerView: "View" => "Udsigt"
// theme.headerViewBasic: "Basic" => "Grundlæggende"
// theme.headerViewAdvanced: "Advanced" => "Avanceret"
// theme.headerInheritWidthFrom: "Content area width" => "Bredde på indholdsområde"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Samme som undersøgelse"
// theme.headerInheritWidthFromPage: "Fit to page" => "Tilpas til side"
// theme.headerTextAreaWidth: "Text width" => "Tekstbredde"
// theme.headerBackgroundColorSwitch: "Background color" => "Baggrundsfarve"
// theme.headerBackgroundColorNone: "None" => "Ingen"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Accent farve"
// theme.headerBackgroundColorCustom: "Custom" => "Sædvane"
// theme.horizontalAlignmentLeft: "Left" => "Venstre"
// theme.horizontalAlignmentCenter: "Center" => "Midte"
// theme.horizontalAlignmentRight: "Right" => "Højre"
// theme.verticalAlignmentTop: "Top" => "Top"
// theme.verticalAlignmentMiddle: "Middle" => "Midte"
// theme.verticalAlignmentBottom: "Bottom" => "Bund"
// lg.question_resetValueText: "reset value for question: {0}" => "Nulstil værdi for spørgsmål: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Tildel værdi: {1} til spørgsmål: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Nulstil celleværdi for kolonne: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Tildel celleværdi: {1} til kolonne: {0}"
// ed.surveyJsonExportButton: "Export" => "Eksport"
// ed.surveyJsonImportButton: "Import" => "Import"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Kopier til udklipsholder"
// pe.filePlaceholder: "File placeholder text" => "Filpladsholdertekst"
// pe.photoPlaceholder: "Photo placeholder text" => "Eksempeltekst til billeder"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Arkiv- eller fotopladsholdertekst"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Gælder, når \"Kildetype\" er \"Lokale filer\", eller når kameraet ikke er tilgængeligt"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Gælder, når \"Kildetype\" er \"Kamera\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Gælder, når \"Kildetype\" er \"Lokale filer eller kamera\"."
// theme.background: "Background" => "Baggrund"
// theme.appearance: "Appearance" => "Udseende"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Vil du virkelig nulstille temaet? Alle dine tilpasninger går tabt."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Ja, nulstil temaet"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Passer til beholder"
// signaturepad.showPlaceholder: "Show the placeholder" => "Vis pladsholderen"
// signaturepad.placeholder: "Placeholder text" => "Pladsholdertekst"
// theme.surveyDescriptionFont: "Survey description font" => "Skrifttype til undersøgelsesbeskrivelse"
// ed.prevFocus: "Focus previous" => "Fokus forrige"
// ed.nextFocus: "Focus next" => "Fokuser næste"
// ed.saveTheme: "Save Theme" => "Gem tema"
// ed.saveThemeTooltip: "Save Theme" => "Gem tema"
// lg.page_requireName: "Make page required" => "Gør siden påkrævet"
// lg.panel_requireName: "Make page required" => "Gør siden påkrævet"
// signaturepad.signatureWidth: "Signature area width" => "Bredde på signaturområde"
// signaturepad.signatureHeight: "Signature area height" => "Højde på signaturområde"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Skaler signaturområdet automatisk"
// signaturepad.penMinWidth: "Minimum pen width" => "Mindste bredde på pennen"
// signaturepad.penMaxWidth: "Maximum pen width" => "Maksimal bredde på pennen"
// theme.logoPosition: "Logo position" => "Logo position"
// theme.headerTitlePosition: "Title position" => "Titel position"
// theme.headerDescriptionPosition: "Description position" => "Beskrivelse position"
// ed.propertyGridNoResultsFound: "No results found" => "Ingen resultater fundet"
// pv.leftRight: "Left and right" => "Venstre og højre"
// p.sourceType: "Source type" => "Kilde type"
// p.fitToContainer: "Fit to container" => "Passer til beholder"
// p.setValueExpression: "Set value expression" => "Angiv værdiudtryk"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Valg indlæses fra en webtjeneste."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Gå til indstillinger"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Forhåndsvisning af indlæste valgmuligheder"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Undgå dublerede svar i rækker"
// theme.advancedMode: "Advanced mode" => "Avanceret tilstand"
// theme.backgroundCornerRadius: "Background and corner radius" => "Baggrund og hjørneradius"
// theme.colorsTitle: "Colors" => "Farver"
// theme.font: "Font" => "Skrifttype"
// theme.lines: "Lines" => "Linjer"
// theme.titleFont: "Title font" => "Titel skrifttype"
// theme.descriptionFont: "Description font" => "Beskrivelse skrifttype"
// theme.shadow: "Shadow effects" => "Skyggeeffekter"
// ed.translateUsigAIFrom: "Translate from: " => "Oversæt fra: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Tillad indstillingen Afvis at svare"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Tillad indstillingen Ved ikke"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Tillad indstillingen Afvis at svare"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Tillad indstillingen Ved ikke"
// pv.contain: "Contain" => "Indeholde"
// pv.cover: "Cover" => "Dække"
// pv.fill: "Fill" => "Fylde"
// pe.transposeData: "Transpose rows to columns" => "Transponere rækker til kolonner"
// layout.panel: "Layout" => "Layout"
// layout.question: "Layout" => "Layout"
// layout.base: "Layout" => "Layout"
// panel.name: "Panel name" => "Panelets navn"
// panel.title: "Panel title" => "Panelets titel"
// panel.description: "Panel description" => "Beskrivelse af panelet"
// panel.visibleIf: "Make the panel visible if" => "Gør panelet synligt, hvis"
// panel.requiredIf: "Make the panel required if" => "Gør panelet påkrævet, hvis"
// panel.questionsOrder: "Question order within the panel" => "Spørgsmålsrækkefølge i panelet"
// panel.startWithNewLine: "Display the panel on a new line" => "Få vist panelet på en ny linje"
// panel.state: "Panel collapse state" => "Panelets sammenbrudstilstand"
// panel.width: "Inline panel width" => "Indlejret panelbredde"
// panel.minWidth: "Minimum panel width" => "Mindste panelbredde"
// panel.maxWidth: "Maximum panel width" => "Maksimal panelbredde"
// panel.showNumber: "Number panels" => "Paneler med tal"
// paneldynamic.name: "Panel name" => "Panelets navn"
// paneldynamic.title: "Panel title" => "Panelets titel"
// paneldynamic.description: "Panel description" => "Beskrivelse af panelet"
// paneldynamic.visibleIf: "Make the panel visible if" => "Gør panelet synligt, hvis"
// paneldynamic.requiredIf: "Make the panel required if" => "Gør panelet påkrævet, hvis"
// paneldynamic.page: "Move the panel to page" => "Flyt panelet til siden"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Få vist panelet på en ny linje"
// paneldynamic.state: "Panel collapse state" => "Panelets sammenbrudstilstand"
// paneldynamic.width: "Inline panel width" => "Indlejret panelbredde"
// paneldynamic.minWidth: "Minimum panel width" => "Mindste panelbredde"
// paneldynamic.maxWidth: "Maximum panel width" => "Maksimal panelbredde"
// paneldynamic.templateDescription: "Panel description pattern" => "Panel beskrivelse mønster"
// paneldynamic.templateTitle: "Panel title pattern" => "Panelets titelmønster"
// paneldynamic.noEntriesText: "Empty panel text" => "Tom paneltekst"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Fanetitel mønster"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Gør et individuelt panel synligt, hvis"
// paneldynamic.hideNumber: "Hide the panel number" => "Skjul panelnummeret"
// paneldynamic.titleLocation: "Panel title alignment" => "Justering af paneltitel"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Justering af panelbeskrivelse"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Tilpasning af spørgsmålets titel"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Justering af fejlmeddelelse"
// paneldynamic.newPanelPosition: "New panel location" => "Ny panelplacering"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Undgå dublerede svar i følgende spørgsmål"
// question.name: "Question name" => "Navn på spørgsmål"
// question.title: "Question title" => "Spørgsmålets titel"
// question.description: "Question description" => "Beskrivelse af spørgsmål"
// question.visibleIf: "Make the question visible if" => "Gør spørgsmålet synligt, hvis"
// question.requiredIf: "Make the question required if" => "Foretag spørgsmålet påkrævet, hvis"
// question.state: "Question box collapse state" => "Tilstand for sammenbrud af spørgsmålsfelt"
// question.hideNumber: "Hide the question number" => "Skjul spørgsmålsnummeret"
// question.titleLocation: "Question title alignment" => "Tilpasning af spørgsmålets titel"
// question.descriptionLocation: "Question description alignment" => "Tilpasning af spørgsmålsbeskrivelse"
// question.errorLocation: "Error message alignment" => "Justering af fejlmeddelelse"
// question.indent: "Increase the inner indent" => "Forøg det indre indryk"
// question.width: "Inline question width" => "Indbygget spørgsmålsbredde"
// question.minWidth: "Minimum question width" => "Mindste spørgsmålsbredde"
// question.maxWidth: "Maximum question width" => "Maksimal spørgsmålsbredde"
// question.textUpdateMode: "Update input field value" => "Opdater inputfeltværdi"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Vis knappen Ryd i signaturområdet"
// signaturepad.penColor: "Stroke color" => "Stregfarve"
// comment.rows: "Input field height (in lines)" => "Inputfelthøjde (i linjer)"
// expression.name: "Expression name" => "Navn på udtryk"
// expression.title: "Expression title" => "Udtryk titel"
// expression.description: "Expression description" => "Beskrivelse af udtryk"
// expression.expression: "Expression" => "Udtryk"
// trigger.expression: "Expression" => "Udtryk"
// calculatedvalue.expression: "Expression" => "Udtryk"
// survey.description: "Survey description" => "Beskrivelse af undersøgelsen"
// page.name: "Page name" => "Sidenavn"
// page.description: "Page description" => "Sidebeskrivelse"
// page.visibleIf: "Make the page visible if" => "Gør siden synlig, hvis"
// page.requiredIf: "Make the page required if" => "Gør siden påkrævet, hvis"
// page.questionsOrder: "Question order on the page" => "Spørgsmålsrækkefølge på siden"
// matrixdropdowncolumn.name: "Column name" => "Kolonnens navn"
// matrixdropdowncolumn.title: "Column title" => "Kolonnens titel"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Undgå dublerede svar"
// matrixdropdowncolumn.width: "Column width" => "Kolonnebredde"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Mindste kolonnebredde"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Inputfelthøjde (i linjer)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Gør kolonnen synlig, hvis"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Gør kolonnen obligatorisk, hvis"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Hver indstilling i en separat kolonne"
// multipletextitem.name: "Name" => "Navn"
// multipletextitem.title: "Title" => "Titel"
// pe.rateDescriptionLocation: "Label alignment" => "Justering af etiketter"
// pe.cellErrorLocation: "Cell error message alignment" => "Justering af cellefejlmeddelelse"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Du har ikke nogen kolonner endnu"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Du har ingen rækker endnu"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Du har endnu ingen valideringsregler"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Du har endnu ingen tilpassede variabler"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Du har ingen udløsere endnu"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Du har ingen links endnu"
// pe.addNew@columns: "Add new column" => "Tilføj ny kolonne"
// pe.addNew@rows: "Add new row" => "Tilføj ny række"
// pe.addNew@validators: "Add new rule" => "Tilføj ny regel"
// pe.addNew@calculatedValues: "Add new variable" => "Tilføj ny variabel"
// pe.addNew@triggers: "Add new trigger" => "Tilføj ny udløser"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Tilføj ny webadresse"
// choicesbyurl.url: "Web service's URL" => "Webtjenestens URL-adresse"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Vis sidetitler på statuslinjen"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Vis sidetal på statuslinjen"
// itemvalue.visibleIf: "Make the option visible if" => "Gør indstillingen synlig, hvis"
// itemvalue.enableIf: "Make the option selectable if" => "Gør indstillingen valgbar, hvis"
// panel.layout: "Panel Layout" => "Panel Layout"
// tabs.questionSettings: "Question Settings" => "Indstillinger for spørgsmål"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Eks.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Eks.: kategorier.fiktion"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Eks.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Eks.: 6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "Eks.: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Eks.: 50%"
// pv.selected: "Selected" => "Valgte"
// pv.unselected: "Unselected" => "Markerede"
// pv.center: "Center" => "Midte"
// pv.middle: "Middle" => "Midte"
// pv.next: "Next" => "Næste"
// pv.last: "Last" => "Sidst"
// clearIfInvisible.none: "Never" => "Aldrig"
// questionsOnPageMode.standard: "Original structure" => "Oprindelig struktur"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Vis alle spørgsmål på én side"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Vis et enkelt spørgsmål pr. side"
// pv.auto: "Auto" => "Auto"
// panelsState.firstExpanded: "First expanded" => "Først udvidet"
// rateColorMode.scale: "Scale" => "Skæl"
// scaleColorMode.monochrome: "Monochrome" => "Monokrom"
// scaleColorMode.colored: "Colored" => "Farvet"
// state.default: "Locked" => "Låst"
// showQuestionNumbers.default: "Auto-numbering" => "Automatisk nummerering"
// showQuestionNumbers.on: "Auto-numbering" => "Automatisk nummerering"
// showQuestionNumbers.onPage: "Reset on each page" => "Nulstil på hver side"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Nulstil på hvert panel"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Nulstil på hvert panel"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Fortsæt på tværs af undersøgelsen"
// showQuestionNumbers.off: "No numbering" => "Ingen nummerering"
// descriptionLocation.underTitle: "Under the question title" => "Under spørgsmålets titel"
// descriptionLocation.underInput: "Under the input field" => "Under indtastningsfeltet"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Ved siden af valgmuligheder"
// selectToRankAreasLayout.vertical: "Above choices" => "Ovenstående valg"
// displayStyle.decimal: "Decimal" => "Decimal"
// displayStyle.currency: "Currency" => "Valuta"
// displayStyle.percent: "Percentage" => "Procentdel"
// displayStyle.date: "Date" => "Dato"
// totalDisplayStyle.decimal: "Decimal" => "Decimal"
// totalDisplayStyle.currency: "Currency" => "Valuta"
// totalDisplayStyle.percent: "Percentage" => "Procentdel"
// totalDisplayStyle.date: "Date" => "Dato"
// rowsOrder.initial: "Original" => "Oprindelig"
// questionsOrder.initial: "Original" => "Oprindelig"
// showProgressBar.aboveheader: "Above the header" => "Over overskriften"
// showProgressBar.belowheader: "Below the header" => "Under overskriften"
// pv.sum: "Sum" => "Sum"
// pv.count: "Count" => "Tælle"
// pv.min: "Min" => "Min."
// pv.max: "Max" => "Maks"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Indeholder"
// searchMode.startsWith: "Starts with" => "Begynder med"
// panel.name: "A panel ID that is not visible to respondents." => "Et panel-id, der ikke er synligt for svarpersonerne."
// panel.description: "Type a panel subtitle." => "Skriv en undertitel til panelet."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Brug tryllestavsikonet til at indstille en betinget regel, der bestemmer panelets synlighed."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Brug tryllestavsikonet til at indstille en betinget regel, der deaktiverer panelets skrivebeskyttede tilstand."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Brug tryllestavsikonet til at angive en betinget regel, der forhindrer indsendelse af undersøgelser, medmindre mindst ét indlejret spørgsmål har et svar."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Gælder for alle spørgsmål i dette panel. Hvis du vil tilsidesætte denne indstilling, skal du definere regler for titeljustering for individuelle spørgsmål. Indstillingen \"Nedarv\" anvender indstillingen på sideniveau (hvis angivet) eller undersøgelsesniveau (\"Top\" som standard)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Angiver placeringen af en fejlmeddelelse i forhold til alle spørgsmål i panelet. Indstillingen \"Nedarv\" anvender indstillingen for sideniveau (hvis angivet) eller undersøgelsesniveau."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Bevarer den oprindelige rækkefølge af spørgsmål eller randomiserer dem. Indstillingen \"Nedarv\" anvender indstillingen for sideniveau (hvis angivet) eller undersøgelsesniveau."
// panel.page: "Repositions the panel to the end of a selected page." => "Flytter panelet til slutningen af en markeret side."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Tilføjer mellemrum eller margen mellem panelindholdet og panelboksens venstre kant."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Fjern markeringen for at få vist panelet på én linje med det forrige spørgsmål eller panel. Indstillingen gælder ikke, hvis panelet er det første element i formularen."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Vælg mellem: \"Udvidet\" - panelet vises fuldt ud og kan skjules; \"Skjult\" - panelet viser kun titlen og beskrivelsen og kan udvides; \"Låst\" - panelet vises fuldt ud og kan ikke skjules."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Indstiller panelets bredde i forhold til andre undersøgelseselementer på samme linje. Accepterer CSS-værdier (px, %, in, pt osv.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "Et panel-id, der ikke er synligt for svarpersonerne."
// paneldynamic.description: "Type a panel subtitle." => "Skriv en undertitel til panelet."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Brug tryllestavsikonet til at indstille en betinget regel, der bestemmer panelets synlighed."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Brug tryllestavsikonet til at indstille en betinget regel, der deaktiverer panelets skrivebeskyttede tilstand."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Brug tryllestavsikonet til at angive en betinget regel, der forhindrer indsendelse af undersøgelser, medmindre mindst ét indlejret spørgsmål har et svar."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Gælder for alle spørgsmål i dette panel. Hvis du vil tilsidesætte denne indstilling, skal du definere regler for titeljustering for individuelle spørgsmål. Indstillingen \"Nedarv\" anvender indstillingen på sideniveau (hvis angivet) eller undersøgelsesniveau (\"Top\" som standard)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Angiver placeringen af en fejlmeddelelse i forhold til et spørgsmål med ugyldigt input. Vælg mellem: \"Top\" - en fejltekst placeres øverst i spørgsmålsfeltet; \"Nederst\" - en fejltekst placeres nederst i spørgsmålsfeltet. Indstillingen \"Nedarv\" anvender indstillingen på sideniveau (hvis angivet) eller undersøgelsesniveau (\"Top\" som standard)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Angiver placeringen af en fejlmeddelelse i forhold til alle spørgsmål i panelet. Indstillingen \"Nedarv\" anvender indstillingen for sideniveau (hvis angivet) eller undersøgelsesniveau."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Flytter panelet til slutningen af en markeret side."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Tilføjer mellemrum eller margen mellem panelindholdet og panelboksens venstre kant."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Fjern markeringen for at få vist panelet på én linje med det forrige spørgsmål eller panel. Indstillingen gælder ikke, hvis panelet er det første element i formularen."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Vælg mellem: \"Udvidet\" - panelet vises fuldt ud og kan skjules; \"Skjult\" - panelet viser kun titlen og beskrivelsen og kan udvides; \"Låst\" - panelet vises fuldt ud og kan ikke skjules."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Indstiller panelets bredde i forhold til andre undersøgelseselementer på samme linje. Accepterer CSS-værdier (px, %, in, pt osv.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Indtast en skabelon til dynamiske paneltitler. Brug {panelIndex} til panelets generelle placering og {visiblePanelIndex} til dets rækkefølge blandt synlige paneler. Indsæt disse pladsholdere i mønsteret for at tilføje automatisk nummerering."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Indtast en skabelon til fanetitler. Brug {panelIndex} til et panels generelle placering og {visiblePanelIndex} til dets rækkefølge blandt synlige paneler. Indsæt disse pladsholdere i mønsteret for at tilføje automatisk nummerering."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Denne indstilling giver dig mulighed for at styre synligheden af individuelle paneler i det dynamiske panel. Brug pladsholderen '{panel}' til at referere til det aktuelle panel i dit udtryk."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Denne indstilling nedarves automatisk af alle spørgsmål i dette panel. Hvis du vil tilsidesætte denne indstilling, skal du definere regler for titeljustering for individuelle spørgsmål. Indstillingen \"Nedarv\" anvender indstillingen på sideniveau (hvis angivet) eller undersøgelsesniveau (\"Top\" som standard)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "Indstillingen \"Nedarv\" anvender indstillingen på sideniveau (hvis angivet) eller undersøgelsesniveau (\"Under paneltitlen\" som standard)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Definerer placeringen af et nyligt tilføjet panel. Som standard tilføjes nye paneler til slutningen. Vælg \"Næste\" for at indsætte et nyt panel efter det aktuelle."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Duplikerer svar fra det sidste panel og tildeler dem til det næste tilføjede dynamiske panel."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Henvis til et spørgsmålsnavn for at kræve, at en bruger giver et entydigt svar på dette spørgsmål i hvert panel."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Med denne indstilling kan du tildele en standardsvarværdi baseret på et udtryk. Udtrykket kan omfatte grundlæggende beregninger - '{q1_id} + {q2_id}', booleske udtryk, såsom '{alder} > 60' og funktioner: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' osv. Den værdi, der bestemmes af dette udtryk, fungerer som den oprindelige standardværdi, der kan tilsidesættes af svarpersonens manuelle input."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Brug tryllestavsikonet til at angive en betinget regel, der bestemmer, hvornår en svarpersons input nulstilles til værdien baseret på værdien \"Standardværdiudtryk\" eller \"Angiv værdiudtryk\" eller til værdien \"Standardsvar\" (hvis en af dem er angivet)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Brug tryllestavsikonet til at indstille en betinget regel, der bestemmer, hvornår \"Indstil værdiudtryk\" skal køres, og tildele den resulterende værdi dynamisk som et svar."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Angiv et udtryk, der definerer den værdi, der skal angives, når betingelserne i reglen \"Angiv værdi hvis\" er opfyldt. Udtrykket kan omfatte grundlæggende beregninger - '{q1_id} + {q2_id}', booleske udtryk, såsom '{alder} > 60' og funktioner: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' osv. Den værdi, der bestemmes af dette udtryk, kan tilsidesættes af svarpersonens manuelle input."
// question.name: "A question ID that is not visible to respondents." => "Et spørgsmåls-id, der ikke er synligt for svarpersonerne."
// question.description: "Type a question subtitle." => "Skriv et spørgsmåls undertitel."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Brug tryllestavsikonet til at angive en betinget regel, der bestemmer spørgsmålets synlighed."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Brug tryllestavsikonet til at angive en betinget regel, der deaktiverer skrivebeskyttet tilstand for spørgsmålet."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Brug tryllestavsikonet til at angive en betinget regel, der forhindrer undersøgelse i at gå videre eller blive sendt, medmindre spørgsmålet blev besvaret."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Fjern markeringen for at få vist spørgsmålet på én linje med det forrige spørgsmål eller panel. Indstillingen gælder ikke, hvis spørgsmålet er det første element i formularen."
// question.page: "Repositions the question to the end of a selected page." => "Flytter spørgsmålet til slutningen af en markeret side."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Vælg mellem: \"Udvidet\" - spørgsmålsfeltet vises fuldt ud og kan skjules; \"Skjult\" - spørgsmålsfeltet viser kun titlen og beskrivelsen og kan udvides; \"Låst\" - spørgsmålsfeltet vises fuldt ud og kan ikke skjules."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Tilsidesætter regler for titeljustering, der er defineret på panel-, side- eller undersøgelsesniveau. Indstillingen \"Nedarv\" anvender alle indstillinger på højere niveau (hvis indstillet) eller indstilling på undersøgelsesniveau (\"Top\" som standard)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "Indstillingen \"Nedarv\" anvender indstillingen på undersøgelsesniveau (\"Under spørgsmålets titel\" som standard)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Angiver placeringen af en fejlmeddelelse i forhold til spørgsmålet med ugyldigt input. Vælg mellem: \"Top\" - en fejltekst placeres øverst i spørgsmålsfeltet; \"Nederst\" - en fejltekst placeres nederst i spørgsmålsfeltet. Indstillingen \"Nedarv\" anvender indstillingen på undersøgelsesniveau (\"Top\" som standard)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Tilføjer mellemrum eller margen mellem spørgsmålsindholdet og spørgsmålsfeltets venstre kant."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Angiver bredden af spørgsmålet i forhold til andre undersøgelseselementer på samme linje. Accepterer CSS-værdier (px, %, in, pt osv.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Brug tryllestavsikonet til at angive en valideringsregel for spørgsmålet."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Vælg mellem: \"Ved tabt fokus\" - værdien opdateres, når indtastningsfeltet mister fokus; \"Mens du skriver\" - værdien opdateres i realtid, da brugerne skriver. Indstillingen \"Nedarv\" anvender indstillingen på undersøgelsesniveau (\"Ved mistet fokus\" som standard)."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Du kan bruge enhver webtjeneste som datakilde til multiple choice-spørgsmål. Hvis du vil udfylde valgværdier, skal du angive URL-adressen på den tjeneste, der leverer dataene."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "En sammenligningshandling, der bruges til at filtrere rullelisten."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Indstiller bredden på det viste signaturområde og det resulterende billede."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Indstiller højden på det viste signaturområde og det resulterende billede."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Vælg, om signaturområdet skal udfylde al tilgængelig plads i spørgsmålsfeltet, samtidig med at standardformatet 3:2 bevares. Når brugerdefinerede bredde- og højdeværdier er angivet, bevarer indstillingen højde-bredde-forholdet for disse dimensioner."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Justerer billedets højde i undersøgelsesresultaterne."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Justerer billedets bredde i undersøgelsesresultaterne."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Tilsidesætter minimum- og maksimumhøjdeværdierne."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Tilsidesætter værdierne for minimum- og maksimumbredde."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Værdi\" fungerer som et vare-id, der bruges i betingede regler; \"Tekst\" vises til respondenterne."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Denne indstilling ændrer kun størrelsen på inputfeltet og påvirker ikke bredden af spørgsmålsfeltet. Hvis du vil begrænse den accepterede inputlængde, skal du gå til <b>Validering → Maksimal tegngrænse</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Indstiller antallet af viste linjer i indtastningsfeltet. Hvis indgangen fylder flere linjer, vises rullepanelet."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Vælg mellem: \"Redigerbar\" - gør det muligt for respondenter at udfylde din undersøgelse; \"Skrivebeskyttet\" - deaktiverer formularredigering."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "Et kolonne-id, der ikke er synligt for svarpersoner."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Når det er aktiveret for en kolonne, skal en svarperson give et entydigt svar på hvert spørgsmål i denne kolonne."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Indstiller antallet af viste linjer i indtastningsfeltet. Hvis indgangen fylder flere linjer, vises rullepanelet."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Brug tryllestavsikonet til at angive en betinget regel, der bestemmer kolonnesynligheden."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Brug tryllestavsikonet til at angive en betinget regel, der deaktiverer skrivebeskyttet tilstand for kolonnen."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Brug tryllestavsikonet til at angive en betinget regel, der forhindrer indsendelse af undersøgelser, medmindre mindst ét indlejret spørgsmål har et svar."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Når denne indstilling er valgt, oprettes der en individuel kolonne for hver valgmulighed."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Vælg mellem: \"Statisk\" - indstiller en fast bredde; \"Responsive\" - får undersøgelsen til at optage skærmens fulde bredde; \"Auto\" - gælder for en af de to afhængigt af de anvendte spørgsmålstyper."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Indsæt et billedlink (ingen størrelsesbegrænsninger), eller klik på mappeikonet for at gennemse en fil fra din computer (op til 64 KB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Indstiller en logobredde i CSS-enheder (px, %, in, pt osv.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Indstiller en logohøjde i CSS-enheder (px, %, i, pt osv.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Vælg mellem: \"Ingen\" - billedet bevarer sin oprindelige størrelse; \"Contain\" - billedet ændres til at passe, samtidig med at dets billedformat opretholdes; \"Cover\" - billedet fylder hele kassen, samtidig med at billedformatet opretholdes; \"Fyld\" - billedet strækkes for at udfylde boksen uden at opretholde dets billedformat."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Vælg, om undersøgelsen automatisk skal gå videre til næste side, når en svarperson har besvaret alle spørgsmål på den aktuelle side."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Angiver synligheden og placeringen af navigationsknapper på en side."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Indstiller synligheden og placeringen af en statuslinje. Værdien \"Auto\" viser statuslinjen over eller under undersøgelsesoverskriften."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Aktivér eksempelsiden med alle eller kun besvarede spørgsmål."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Gælder for alle spørgsmål i undersøgelsen. Denne indstilling kan tilsidesættes af titeljusteringsregler på lavere niveauer: panel, side eller spørgsmål. En indstilling på lavere niveau tilsidesætter dem på et højere niveau."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Et symbol eller en sekvens af symboler, der angiver, at et svar er påkrævet."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Indtast et tal eller bogstav, som du vil starte nummereringen med."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Angiver placeringen af en fejlmeddelelse i forhold til spørgsmålet med ugyldigt input. Vælg mellem: \"Top\" - en fejltekst placeres øverst i spørgsmålsfeltet; \"Nederst\" - en fejltekst placeres nederst i spørgsmålsfeltet."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Vælg, om det første indtastningsfelt på hver side skal være klar til indtastning af tekst."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Bevarer den oprindelige rækkefølge af spørgsmål eller randomiserer dem. Effekten af denne indstilling er kun synlig under fanen Eksempel."
// pehelp.maxTextLength: "For text entry questions only." => "Kun til spørgsmål om indtastning af tekst."
// pehelp.maxOthersLength: "For question comments only." => "Kun til kommentarer til spørgsmål."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Vælg, om spørgsmålskommentarer og lange tekstspørgsmål automatisk skal vokse i højden baseret på den indtastede tekstlængde."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Kun til spørgsmålskommentarer og lange tekstspørgsmål."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Brugerdefinerede variabler fungerer som mellemliggende eller hjælpevariabler, der bruges i formularberegninger. De tager respondentinput som kildeværdier. Hver brugerdefineret variabel har et entydigt navn og et udtryk, den er baseret på."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Vælg, om den beregnede værdi af udtrykket skal gemmes sammen med undersøgelsesresultaterne."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "En udløser er en hændelse eller betingelse, der er baseret på et udtryk. Når udtrykket er evalueret til \"sand\", udløser en udløser en handling. En sådan handling kan eventuelt have et målspørgsmål, den påvirker."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Vælg, om du vil rydde værdier for spørgsmål, der er skjult af betinget logik, og hvornår du vil gøre det."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Vælg mellem: \"Ved tabt fokus\" - værdien opdateres, når indtastningsfeltet mister fokus; \"Mens du skriver\" - værdien opdateres i realtid, da brugerne skriver."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Den venstre værdi fungerer som et kolonne-id, der bruges i betingede regler, den rigtige værdi vises for respondenterne."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Den venstre værdi fungerer som et række-id, der bruges i betingede regler, den rigtige værdi vises for respondenterne."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepterer CSS-værdier (px, %, in, pt osv.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepterer CSS-værdier (px, %, in, pt osv.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Angiver placeringen af en fejlmeddelelse i forhold til en celle med ugyldigt input. Indstillingen \"Arv\" anvender indstillingen fra egenskaben \"Justering af fejlmeddelelse\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Når egenskaben \"Undgå dublerede svar\" er aktiveret, modtager en svarperson, der forsøger at sende en dubletpost, følgende fejlmeddelelse."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Giver dig mulighed for at beregne samlede værdier baseret på et udtryk. Udtrykket kan omfatte grundlæggende beregninger ('{q1_id} + {q2_id}'), booleske udtryk ('{alder} > 60') og funktioner ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' osv.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Udløser en prompt, der beder om at bekræfte sletningen af rækken."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Dublerer svar fra den sidste række og tildeler dem til den næste tilføjede dynamiske række."
// pehelp.description: "Type a subtitle." => "Skriv en undertekst."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Vælg et sprog for at begynde at oprette undersøgelsen. Hvis du vil tilføje en oversættelse, skal du skifte til et nyt sprog og oversætte den oprindelige tekst her eller på fanen Oversættelser."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Angiver placeringen af en detaljesektion i forhold til en række. Vælg mellem: \"Ingen\" - ingen udvidelse tilføjes; \"Under rækken\" - en rækkeudvidelse placeres under hver række i matrixen; \"Vis kun én rækkeudvidelse under rækken\" - en udvidelse vises kun under en enkelt række, de resterende rækkeudvidelser skjules."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Vælg mellem: \"Ingen\" - billedet bevarer sin oprindelige størrelse; \"Contain\" - billedet ændres til at passe, samtidig med at dets billedformat opretholdes; \"Cover\" - billedet fylder hele kassen, samtidig med at billedformatet opretholdes; \"Fyld\" - billedet strækkes for at udfylde boksen uden at opretholde dets billedformat."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Øger gradvist inputfeltets højde, efterhånden som data indtastes. Tilsidesætter indstillingen \"Inputfelthøjde (i linjer)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Størrelseshåndtaget (eller grebet) vises i hjørnet og kan trækkes for at ændre størrelsen på indtastningsfeltet."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Et tidsinterval i sekunder, hvorefter undersøgelsen automatisk går videre til siden Tak."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Et tidsinterval i sekunder, hvorefter undersøgelsen automatisk går videre til næste side."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Et tidsinterval i sekunder, hvorefter undersøgelsen automatisk går videre til næste side."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Brug tryllestavsikonet til at indstille en betinget regel, der bestemmer sidens synlighed."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Brug tryllestavsikonet til at angive en betinget regel, der deaktiverer skrivebeskyttet tilstand for siden."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Brug tryllestavsikonet til at angive en betinget regel, der forhindrer indsendelse af undersøgelser, medmindre mindst ét indlejret spørgsmål har et svar."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Gælder for alle spørgsmål på denne side. Hvis du vil tilsidesætte denne indstilling, skal du definere regler for titeljustering for individuelle spørgsmål eller paneler. Indstillingen \"Nedarv\" anvender indstillingen på undersøgelsesniveau (\"Top\" som standard)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Angiver placeringen af en fejlmeddelelse i forhold til spørgsmålet med ugyldigt input. Vælg mellem: \"Top\" - en fejltekst placeres øverst i spørgsmålsfeltet; \"Nederst\" - en fejltekst placeres nederst i spørgsmålsfeltet. Indstillingen \"Nedarv\" anvender indstillingen på undersøgelsesniveau (\"Top\" som standard)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Bevarer den oprindelige rækkefølge af spørgsmål eller randomiserer dem. Indstillingen \"Arv\" anvender indstillingen på undersøgelsesniveau (\"Original\" som standard). Effekten af denne indstilling er kun synlig under fanen Eksempel."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Indstiller synligheden af navigationsknapper på siden. Indstillingen \"Arv\" anvender indstillingen på undersøgelsesniveau, som som standard er \"Synlig\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Indstiller synligheden og placeringen af en timer på en side."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Vælg mellem: \"Låst\" - brugere kan ikke udvide eller skjule paneler; \"Skjul alle\" - alle paneler starter i kollapset tilstand; \"Udvid alle\" - alle paneler starter i udvidet tilstand; \"Først udvidet\" - kun det første panel udvides oprindeligt."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Angiv et delt egenskabsnavn i den række objekter, der indeholder de URL-adresser til billeder eller videofiler, du vil have vist på valglisten."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Den venstre værdi fungerer som et vare-id, der bruges i betingede regler, den rigtige værdi vises for respondenterne."
// pehelp.title: "Type a user-friendly title to display." => "Skriv en brugervenlig titel, der skal vises."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Sikrer, at brugerne ikke gennemfører undersøgelsen, før filerne er uploadet."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepterer CSS-værdier (px, %, in, pt osv.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepterer CSS-værdier (px, %, in, pt osv.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepterer CSS-værdier (px, %, in, pt osv.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "I spørgsmålstyper med et enkelt og flere valg har hver valgmulighed et id og en visningsværdi. Når denne indstilling er valgt, vises der en visningsværdi i stedet for en id-værdi i HTML-spørgsmål og dynamiske titler og beskrivelser af undersøgelseselementer."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Vælg, om du vil rydde spørgsmålsværdier, der er skjult af betinget logik, og hvornår det skal gøres. Indstillingen \"Nedarv\" anvender indstillingen på undersøgelsesniveau (\"Ved afslutning af undersøgelsen\" som standard)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Vælg mellem: \"Alle\" - kopierer alle valgmuligheder fra det valgte spørgsmål; \"Valgt\" - kopierer dynamisk kun valgte valgindstillinger; \"Ikke valgt\" - kopierer dynamisk kun ikke-valgte valgindstillinger. Indstillingerne \"Ingen\" og \"Andre\" kopieres som standard, hvis de er aktiveret i kildespørgsmålet."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Når denne indstilling er valgt, kan brugerne medtage yderligere input i et separat kommentarfelt."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Viser hver indstilling for særlige valgmuligheder (\"Ingen\", \"Andet\", \"Vælg alle\") på en ny linje, selv når du bruger et layout med flere kolonner."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Angiv placeringen i tjenestedatasættet, hvor målmatrixen af objekter er placeret. Lad feltet stå tomt, hvis URL-adressen allerede peger på arrayet."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Angiv et ensartet egenskabsnavn i den matrix af objekter, der indeholder de værdier, du vil have vist på valglisten."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Vælg for at tillade, at tjenesten returnerer et tomt svar eller en matrix."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Brug tryllestavsikonet til at angive en betinget regel, der bestemmer synligheden af alle valgmuligheder."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Den venstre værdi fungerer som et vare-id, der bruges i betingede regler, den rigtige værdi vises for respondenterne."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" vælger mellem tilstandene \"Knapper\" og \"Dropdown\" baseret på den tilgængelige bredde. Når bredden ikke er tilstrækkelig til at vise knapper, vises der en rullemenu i spørgsmålet."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Giver dig mulighed for at forbinde spørgsmål, der giver resultater i forskellige formater. Når sådanne spørgsmål kædes sammen ved hjælp af et join-id, gemmer denne delte ejendom valgte spørgsmålsværdier."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Vælg, om du vil opdatere indholdet i rullemenuen, så det svarer til den søgeforespørgsel, som en bruger skriver i indtastningsfeltet."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "En værdi, der skal gemmes i undersøgelsesresultater, når respondenterne giver et positivt svar."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "En værdi, der skal gemmes i undersøgelsesresultater, når respondenterne giver et negativt svar."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Det anbefales ikke at deaktivere denne indstilling, da den tilsidesætter eksempelbilledet og gør det svært for en bruger at forstå, om filerne er blevet uploadet."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Udløser en prompt, der beder om at bekræfte filsletningen."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Aktivér for kun at rangere valgte valg. Brugere trækker valgte elementer fra valglisten for at sortere dem inden for rangeringsområdet."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Angiv en liste over valgmuligheder, der vil blive foreslået svarpersonen under input."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Indstillingen ændrer kun størrelsen på inputfelterne og påvirker ikke bredden af spørgsmålsfeltet."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Angiver ensartet bredde for alle vareetiketter i pixel"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Indstillingen \"Auto\" bestemmer automatisk den passende tilstand til visning - Billede, Video eller YouTube - baseret på den angivne kilde-URL."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Fungerer som erstatning, når billedet ikke kan vises på en brugers enhed og af tilgængelighedshensyn."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Definerer farven på den valgte emoji, når ikontypen Vurdering er indstillet til \"Smileys\". Vælg mellem: \"Standard\" - den valgte emoji vises i standard undersøgelsesfarve; \"Skala\" - den valgte emoji arver farve fra vurderingsskalaen."
// expression.name: "An expression ID that is not visible to respondents." => "Et udtryks-id, der ikke er synligt for svarpersoner."
// expression.description: "Type an expression subtitle." => "Skriv et udtryk undertekst."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Et udtryk kan omfatte grundlæggende beregninger ('{q1_id} + {q2_id}'), betingelser ('{alder} > 60') og funktioner ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' osv.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Vælg for at gemme værdien \"Andet\" som en separat egenskab i undersøgelsesresultater."
// p.swapOrder: "Swap the order of Yes and No" => "Skift rækkefølgen Ja og Nej"
// p.itemTitleWidth: "Item label width (in px)" => "Bredde på vareetiket (i px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Tekst, der viser, om alle indstillinger er markeret"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Pladsholdertekst for rangeringsområdet"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Udfyld undersøgelsen automatisk"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Vælg, om undersøgelsen skal fuldføres automatisk, når svarpersonen har besvaret alle spørgsmål."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Gem maskeret værdi i undersøgelsesresultater"
// patternmask.pattern: "Value pattern" => "Værdimønster"
// datetimemask.min: "Minimum value" => "Mindste værdi"
// datetimemask.max: "Maximum value" => "Maksimal værdi"
// numericmask.allowNegativeValues: "Allow negative values" => "Tillad negative værdier"
// numericmask.thousandsSeparator: "Thousands separator" => "Tusindtalsseparator"
// numericmask.decimalSeparator: "Decimal separator" => "Decimalseparator"
// numericmask.precision: "Value precision" => "Værdi præcision"
// numericmask.min: "Minimum value" => "Mindste værdi"
// numericmask.max: "Maximum value" => "Maksimal værdi"
// currencymask.prefix: "Currency prefix" => "Valutapræfiks"
// currencymask.suffix: "Currency suffix" => "Suffiks for valuta"
// pe.maskType: "Input mask type" => "Type af inputmaske"
// maskTypes.patternmask: "Pattern" => "Mønster"
// maskTypes.numericmask: "Numeric" => "Numerisk"
// maskTypes.datetimemask: "Date and Time" => "Dato og klokkeslæt"
// maskTypes.currencymask: "Currency" => "Valuta"
// tabs.mask: "Input Mask Settings" => "Indstillinger for inputmaske"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Eks.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Eks.: mm/dd/åååå"
// pe.currencyprefix_placeholder: "Ex.: $" => "Eks.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Eks.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Valg af wrap"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Lange tekster i valgmuligheder genererer automatisk linjeskift, så de passer ind i rullemenuen. Fjern markeringen, hvis teksterne skal klippes."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Vælg, om du vil gemme spørgsmålsværdien med en anvendt maske i undersøgelsesresultater."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Mønsteret kan indeholde strengkonstanter og følgende pladsholdere: '9' - for et ciffer; »a« - for store eller små bogstaver '#' - for et ciffer eller et stort eller lille bogstav. Brug omvendt skråstreg '\\' for at undslippe et tegn."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Mønsteret kan indeholde separatortegn og følgende pladsholdere: 'm' - for månedsnummer; »mm« — for månedsnummer med foranstillet nul for encifrede værdier 'd' - for dag i måneden; 'dd' - for dag i måneden med foranstillet nul for encifrede værdier 'yy' - for de sidste to cifre i året; 'YYYY' - for et firecifret år."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Et symbol, der bruges til at adskille brøkdelen fra heltalsdelen af et vist tal."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Et symbol, der bruges til at adskille cifrene i et stort tal i grupper på tre."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Begrænser, hvor mange cifre der skal bevares efter decimaltegnet for et vist tal."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Et eller flere symboler, der skal vises før værdien."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Et eller flere symboler, der skal vises efter værdien."
// ed.translationSource: "Source: " => "Kilde: "
// ed.translationTarget: "Target: " => "Mål: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Siden er tom. Træk et element fra værktøjskassen, eller klik på knappen nedenfor."
// maskTypes.none: "None" => "Ingen"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Gør rækken synlig, hvis"
// itemvalue@rows.enableIf: "Make the row editable if" => "Gør rækken redigerbar, hvis"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Pladsholdertekst i skrivebeskyttet tilstand eller eksempeltilstand"
// pe.textWrapEnabled: "Wrap choices" => "Valg af wrap"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Indstillingen \"Auto\" bestemmer automatisk den passende tilstand til visning - Billede, Video eller YouTube - baseret på den angivne kilde-URL."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Vælg mellem \"Billede\" og \"Video\" for at indstille medievælgerens indholdstilstand. Hvis \"Billede\" er valgt, skal du sikre dig, at alle angivne indstillinger er billedfiler i følgende formater: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Tilsvarende, hvis \"Video\" er valgt, skal du sikre dig, at alle indstillinger er direkte links til videofiler i følgende formater: MP4, MOV, WMV, FLV, AVI, MKV. Bemærk, at YouTube-links ikke understøttes for videoindstillinger."
// ed.selectFile: "Select a file" => "Vælg en fil"
// ed.removeFile: "Remove the file" => "Fjern filen"
// pe.searchMode: "Search Mode" => "Søgetilstand"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Klik på knappen \"Tilføj spørgsmål\" nedenfor for at begynde at oprette din formular."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Klik på knappen \"Tilføj spørgsmål\" nedenfor for at tilføje et nyt element til siden."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Klik på knappen \"Tilføj spørgsmål\" nedenfor for at tilføje et nyt element til panelet."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Klik på knappen nedenfor, og vælg et billede, der skal uploades"
// coloralpha.opacity: "Opacity" => "Opacitet"
// font.family: "Font family" => "Skrifttypefamilie"
// font.color: "Color" => "Farve"
// font.placeholderColor: "Placeholder color" => "Pladsholderfarve"
// font.size: "Size" => "Størrelse"
// theme.themeName: "Theme" => "Tema"
// theme.isPanelless: "Question appearance" => "Spørgsmål udseende"
// theme.editorPanel: "Background and corner radius" => "Baggrund og hjørneradius"
// theme.questionPanel: "Background and corner radius" => "Baggrund og hjørneradius"
// theme.primaryColor: "Accent color" => "Accent farve"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Opacitet af panelets baggrund"
// theme.questionBackgroundTransparency: "Question background opacity" => "Spørgsmål baggrundsuigennemsigtighed"
// theme.fontSize: "Font size" => "Skrifttypestørrelse"
// theme.scale: "Scale" => "Skæl"
// theme.cornerRadius: "Corner radius" => "Hjørne radius"
// theme.pageTitle: "Title font" => "Titel skrifttype"
// theme.pageDescription: "Description font" => "Beskrivelse skrifttype"
// theme.questionTitle: "Title font" => "Titel skrifttype"
// theme.questionDescription: "Description font" => "Beskrivelse skrifttype"
// theme.editorFont: "Font" => "Skrifttype"
// theme.backgroundOpacity: "Opacity" => "Opacitet"
// theme.--sjs-font-family: "Font family" => "Skrifttypefamilie"
// theme.--sjs-general-backcolor-dim: "Background color" => "Baggrundsfarve"
// theme.--sjs-primary-backcolor: "Accent background" => "Accent baggrund"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Accent forgrund"
// theme.--sjs-shadow-small: "Shadow effects" => "Skyggeeffekter"
// theme.--sjs-shadow-inner: "Shadow effects" => "Skyggeeffekter"
// theme.--sjs-border-default: "Colors" => "Farver"
// header@header.headerView: "View" => "Udsigt"
// header@header.logoPosition: "Logo position" => "Logo position"
// header@header.surveyTitle: "Survey title font" => "Skrifttype for undersøgelsestitel"
// header@header.surveyDescription: "Survey description font" => "Skrifttype til undersøgelsesbeskrivelse"
// header@header.headerTitle: "Survey title font" => "Skrifttype for undersøgelsestitel"
// header@header.headerDescription: "Survey description font" => "Skrifttype til undersøgelsesbeskrivelse"
// header@header.inheritWidthFrom: "Content area width" => "Bredde på indholdsområde"
// header@header.textAreaWidth: "Text width" => "Tekstbredde"
// header@header.backgroundColorSwitch: "Background color" => "Baggrundsfarve"
// header@header.backgroundImage: "Background image" => "Baggrundsbillede"
// header@header.backgroundImageOpacity: "Opacity" => "Opacitet"
// header@header.overlapEnabled: "Overlap" => "Overlapning"
// header@header.logoPositionX: "Logo position" => "Logo position"
// header@header.titlePositionX: "Title position" => "Titel position"
// header@header.descriptionPositionX: "Description position" => "Beskrivelse position"
// weight.400: "Regular" => "Regelmæssig"
// weight.600: "Heavy" => "Tung"
// weight.700: "Semi-bold" => "Halvfed skrift"
// weight.800: "Bold" => "Modig"
// backgroundImageFit.auto: "Auto" => "Auto"
// backgroundImageFit.cover: "Cover" => "Dække"
// backgroundImageFit.contain: "Contain" => "Indeholde"
// backgroundImageFit.fill: "Stretch" => "Stræk"
// backgroundImageFit.tile: "Tile" => "Flise"
// backgroundImageAttachment.fixed: "Fixed" => "Fast"
// backgroundImageAttachment.scroll: "Scroll" => "Rulle"
// headerView.basic: "Basic" => "Grundlæggende"
// headerView.advanced: "Advanced" => "Avanceret"
// inheritWidthFrom.survey: "Same as survey" => "Samme som undersøgelse"
// inheritWidthFrom.container: "Fit to container" => "Passer til beholder"
// backgroundColorSwitch.none: "None" => "Ingen"
// backgroundColorSwitch.accentColor: "Accent color" => "Accent farve"
// backgroundColorSwitch.custom: "Custom" => "Sædvane"
// colorPalette.light: "Light" => "Lys"
// colorPalette.dark: "Dark" => "Mørk"
// isPanelless.false: "Default" => "Standard"
// isPanelless.true: "Without Panels" => "Uden paneler"
// theme.cornerRadius: "Corner radius" => "Hjørne radius"
// theme.fontFamily: "Font family" => "Skrifttypefamilie"
// theme.fontWeightRegular: "Regular" => "Regelmæssig"
// theme.fontWeightHeavy: "Heavy" => "Tung"
// theme.fontWeightSemiBold: "Semi-bold" => "Halvfed skrift"
// theme.fontWeightBold: "Bold" => "Modig"
// theme.color: "Color" => "Farve"
// theme.placeholderColor: "Placeholder color" => "Pladsholderfarve"
// theme.size: "Size" => "Størrelse"
// theme.opacity: "Opacity" => "Opacitet"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Skriv for at søge..."
// ed.toolboxNoResultsFound: "No results found" => "Ingen resultater fundet"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Pladsholder til fanetitel"
// theme.--sjs-special-red: "Error messages" => "Fejlmeddelelser"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "En reservetekst til fanetitler, der gælder, når fanetitelmønsteret ikke giver en meningsfuld værdi."
// theme.fontColor: "Font color" => "Skriftfarve"
// theme.backgroundColor: "Background color" => "Baggrundsfarve"
// pe.questionTitleWidth: "Question title width" => "Spørgsmålets titelbredde"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Vælg en fil, eller indsæt et fillink..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Eks.: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Angiver ensartet bredde for spørgsmålstitler, når de er justeret til venstre for deres spørgsmålsbokse. Accepterer CSS-værdier (px, %, in, pt osv.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Angiver ensartet bredde for spørgsmålstitler, når de er justeret til venstre for deres spørgsmålsbokse. Accepterer CSS-værdier (px, %, in, pt osv.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Højde på kommentarområdet (i linjer)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Angiver antallet af viste linjer i tekstområder for spørgsmålskommentarer. I indgangen optager flere linjer, rullepanelet vises."


/***/ }),

/***/ "./src/localization/dutch.ts":
/*!***********************************!*\
  !*** ./src/localization/dutch.ts ***!
  \***********************************/
/*! exports provided: nlStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nlStrings", function() { return nlStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var nlStrings = {
    // survey templates
    survey: {
        edit: "Bewerk",
        externalHelpLink: "Bekijk en leer hoe u enquêtes maakt",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Stel hier een vraag vanuit de Toolbox.",
        addLogicItem: "Maak een regel om de stroom van de enquête aan te passen.",
        copy: "Kopiëren",
        duplicate: "Duplicaat",
        addToToolbox: "Toevoegen aan toolbox",
        deletePanel: "Paneel verwijderen",
        deleteQuestion: "Vraag verwijderen",
        convertTo: "Omzetten naar",
        drag: "Sleep element",
    },
    // Creator tabs
    tabs: {
        preview: "Test de enquête",
        theme: "Thema 's",
        translation: "Vertaling",
        designer: "Enquête-ontwerper",
        editor: "JSON-editor",
        logic: "Onderzoekslogica"
    },
    // Question types
    qt: {
        default: "Standaard",
        checkbox: "Selectievakje",
        comment: "Commentaar",
        imagepicker: "Afbeelingsvraag",
        ranking: "Ranking",
        image: "Afbeelding",
        dropdown: "Keuzelijst",
        tagbox: "Vervolgkeuzemenu voor meerdere selecties",
        file: "Bestandsupload",
        html: "Html",
        matrix: "Matrix (enkele keuze)",
        matrixdropdown: "Matrix (meerkeuze)",
        matrixdynamic: "Matrix (dynamische rijen)",
        multipletext: "Meervoudige tekstvak",
        panel: "Paneel",
        paneldynamic: "Paneel (dynamische panelen)",
        radiogroup: "Meerkeuzevraag",
        rating: "Beoordeling",
        text: "Tekstvak",
        boolean: "Yes/No (Boolean)",
        expression: "Berekening",
        signaturepad: "Handtekening",
        buttongroup: "Knoppengroep"
    },
    toolboxCategories: {
        general: "Algemeen",
        choice: "Keuzevragen",
        text: "Vragen over tekstinvoer",
        containers: "Containers",
        matrix: "Matrix vragen",
        misc: "MISC"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Standaard ({0})",
        survey: "Enquête",
        settings: "Enquête-instellingen",
        settingsTooltip: "Open enquête-instellingen",
        surveySettings: "Enquête-instellingen",
        surveySettingsTooltip: "Enquête instellingen",
        themeSettings: "Thema-instellingen",
        themeSettingsTooltip: "Thema-instellingen",
        showPanel: "Toon paneel",
        hidePanel: "Verberg paneel",
        prevSelected: "Selecteer vorige",
        nextSelected: "Selecteer volgende",
        prevFocus: "Focus vorige",
        nextFocus: "Focus volgende",
        surveyTypeName: "Enquête",
        pageTypeName: "Bladzijde",
        panelTypeName: "Paneel",
        questionTypeName: "Vraag",
        columnTypeName: "Kolom",
        addNewPage: "Pagina toevoegen",
        moveRight: "Scroll naar rechts",
        moveLeft: "Scroll naar links",
        deletePage: "Pagina verwijderen",
        editPage: "Pagina aanpassen",
        edit: "Bewerk",
        newPageName: "Pagina",
        newQuestionName: "Vraag",
        newPanelName: "Paneel",
        newTextItemName: "Tekst",
        defaultV2Theme: "Verstek",
        modernTheme: "Modern",
        defaultTheme: "Standaard (verouderd)",
        testSurveyAgain: "Test de enquête opnieuw",
        testSurveyWidth: "Onderzoeksbreedte: ",
        navigateToMsg: "Je moest navigeren naar:",
        saveSurvey: "Enquête opslaan",
        saveSurveyTooltip: "Enquête opslaan",
        saveTheme: "Thema opslaan",
        saveThemeTooltip: "Thema opslaan",
        jsonHideErrors: "Fouten verbergen",
        jsonShowErrors: "Toon fouten",
        undo: "Ongedaan maken",
        redo: "Opnieuw uitvoeren",
        undoTooltip: "Maak de laatste wijziging ongedaan",
        redoTooltip: "Voer de wijziging opnieuw uit",
        showMoreChoices: "Toon meer",
        showLessChoices: "Toon minder",
        copy: "Kopiëren",
        cut: "Besnoeiing",
        paste: "Plakken",
        copyTooltip: "Kopieer selectie naar klembord",
        cutTooltip: "Knip de selectie naar het klembord",
        pasteTooltip: "Plakken vanaf klembord",
        options: "Opties",
        generateValidJSON: "Genereer geldige JSON",
        generateReadableJSON: "Genereer leesbare JSON",
        toolbox: "Gereedschap",
        "property-grid": "Eigenschappen",
        toolboxFilteredTextPlaceholder: "Typ om te zoeken...",
        toolboxNoResultsFound: "Geen resultaten gevonden",
        propertyGridFilteredTextPlaceholder: "Typ om te zoeken...",
        propertyGridNoResultsFound: "Geen resultaten gevonden",
        correctJSON: "Corrigeer JSON.",
        surveyResults: "Enquêteresultaat: ",
        surveyResultsTable: "Als tabel",
        surveyResultsJson: "Als JSON",
        resultsTitle: "Vraag titel",
        resultsName: "Vraag naam",
        resultsValue: "Antwoordwaarde",
        resultsDisplayValue: "Waarde weergeven",
        modified: "Gewijzigd",
        saving: "Besparing",
        saved: "Opgeslagen",
        propertyEditorError: "Fout:",
        saveError: "Fout! De inhoud van de editor wordt niet opgeslagen.",
        translationPropertyGridTitle: "Taalinstellingen",
        themePropertyGridTitle: "Thema-instellingen",
        translationLanguages: "Talen",
        translationDeleteLanguage: "Weet u zeker dat u alle tekenreeksen voor deze taal wilt verwijderen?",
        translationAddLanguage: "Selecteer de taal om te vertalen",
        translationShowAllStrings: "Toon alle snaren",
        translationShowUsedStringsOnly: "Alleen gebruikte tekenreeksen",
        translationShowAllPages: "Toon alle paginas",
        translationNoStrings: "Geen verplichtingen om te vertalen. Vervang alstublieft het filter.",
        translationExportToSCVButton: "Exporteren naar CSV",
        translationImportFromSCVButton: "Importeren vanuit CSV",
        translateUsigAI: "Alles automatisch vertalen",
        translateUsigAIFrom: "Vertalen van: ",
        translationDialogTitle: "Onvertaalde tekenreeksen",
        translationMergeLocaleWithDefault: "Voeg {0} samen met de standaardlandinstelling",
        translationPlaceHolder: "Vertaling...",
        translationSource: "Bron: ",
        translationTarget: "Doel: ",
        themeExportButton: "Exporteren",
        themeImportButton: "Importeren",
        surveyJsonExportButton: "Exporteren",
        surveyJsonImportButton: "Importeren",
        surveyJsonCopyButton: "Naar klembord kopiëren",
        themeResetButton: "Thema-instellingen terugzetten op de standaardinstellingen",
        themeResetConfirmation: "Wil je het thema echt resetten? Al uw aanpassingen gaan verloren.",
        themeResetConfirmationOk: "Ja, reset het thema",
        bold: "Vetgedrukt",
        italic: "Cursief",
        underline: "Onderstrepen",
        addNewQuestion: "Vraag toevoegen",
        selectPage: "Selecteer pagina...",
        carryForwardChoicesCopied: "Keuzes worden gekopieerd van",
        choicesLoadedFromWebText: "Keuzes worden geladen vanuit een webservice.",
        choicesLoadedFromWebLinkText: "Ga naar instellingen",
        choicesLoadedFromWebPreviewTitle: "Voorbeeld van geladen keuzeopties",
        htmlPlaceHolder: "HTML-inhoud zal hier zijn.",
        panelPlaceHolder: "Drop hier een vraag uit de toolbox.",
        surveyPlaceHolder: "De enquête is leeg. Sleep een element uit de gereedschapskist of klik op de onderstaande knop.",
        pagePlaceHolder: "De pagina is leeg. Sleep een element uit de gereedschapskist of klik op de knop hieronder.",
        imagePlaceHolder: "Sleep een afbeelding hierheen of klik op de onderstaande knop en kies een afbeelding om te uploaden",
        surveyPlaceHolderMobile: "Klik hieronder op de knop \"Vraag toevoegen\" om te beginnen met het maken van uw formulier.",
        pagePlaceHolderMobile: "Klik op de knop \"Vraag toevoegen\" hieronder om een nieuw element aan de pagina toe te voegen.",
        panelPlaceHolderMobile: "Klik op de knop \"Vraag toevoegen\" hieronder om een nieuw element aan het paneel toe te voegen.",
        imagePlaceHolderMobile: "Klik op de onderstaande knop en kies een afbeelding om te uploaden",
        imageChooseImage: "Kies afbeelding",
        addNewTypeQuestion: "Voeg {0} toe",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Item ",
        selectFile: "Selecteer een bestand",
        removeFile: "Verwijder het bestand",
        lg: {
            addNewItem: "Nieuwe regel toevoegen",
            empty_tab: "Maak een regel om de stroom van de enquête aan te passen.",
            page_visibilityName: "Pagina zichtbaarheid",
            page_enableName: "Pagina inschakelen (uitschakelen)",
            page_requireName: "Pagina verplicht maken",
            panel_visibilityName: "Paneel zichtbaarheid",
            panel_enableName: "Paneel inschakelen/uitschakelen",
            panel_requireName: "Pagina verplicht maken",
            question_visibilityName: "Vraag zichtbaarheid",
            question_enableName: "Vraag inschakelen/uitschakelen",
            question_requireName: "Vraag optioneel vereist",
            question_resetValueName: "Vraagwaarde opnieuw instellen",
            question_setValueName: "Vraagwaarde instellen",
            column_visibilityName: "Kolom weergeven (verbergen)",
            column_enableName: "Kolom Inschakelen (uitschakelen)",
            column_requireName: "Kolom verplicht maken",
            column_resetValueName: "Kolomwaarde opnieuw instellen",
            column_setValueName: "Kolomwaarde instellen",
            trigger_completeName: "Volledige enquête",
            trigger_setvalueName: "Stel vraagwaarde in",
            trigger_copyvalueName: "Kopieer de vraagwaarde",
            trigger_skipName: "Ga naar de vraag",
            trigger_runExpressionName: "Voer een aangepaste expressie uit",
            completedHtmlOnConditionName: "Aangepaste 'Bedanktpagina'-tekst",
            page_visibilityDescription: "Maak de pagina zichtbaar wanneer de logische uitdrukking true retourneert. Houd het anders onzichtbaar.",
            panel_visibilityDescription: "Maak het paneel zichtbaar wanneer de logische uitdrukking true retourneert. Houd het anders onzichtbaar.",
            panel_enableDescription: "Zorg ervoor dat het paneel en alle elementen erin worden ingeschakeld wanneer de logische uitdrukking true retourneert. Houd ze anders uitgeschakeld.",
            question_visibilityDescription: "Maak de vraag zichtbaar wanneer de logische uitdrukking true retourneert. Houd het anders onzichtbaar.",
            question_enableDescription: "Schakel de vraag in wanneer de logische uitdrukking true retourneert. Houd het anders uitgeschakeld.",
            question_requireDescription: "Vraag wordt vereist wanneer de logische uitdrukking true retourneert.",
            trigger_completeDescription: "Wanneer de logische uitdrukking true retourneert, wordt de enquête voltooid en ziet een eindgebruiker de 'Bedankpagina'.",
            trigger_setvalueDescription: "Wanneer vraagwaarden, die worden gebruikt in de logische uitdrukking, worden gewijzigd en de logische uitdrukking true retourneert, wordt de waarde ingesteld op de geselecteerde vraag.",
            trigger_copyvalueDescription: "Wanneer vraagwaarden, die worden gebruikt in de logische uitdrukking, worden gewijzigd en de logische uitdrukking true retourneert, wordt de waarde van een geselecteerde vraag gekopieerd naar een andere geselecteerde vraag.",
            trigger_skipDescription: "Als de logische uitdrukking true retourneert, gaat de enquête naar/focust de geselecteerde vraag.",
            trigger_runExpressionDescription: "Wanneer de logische expressie true retourneert, wordt de aangepaste expressie uitgevoerd. U kunt dit expressieresultaat optioneel instellen voor de geselecteerde vraag",
            completedHtmlOnConditionDescription: "Als de logische uitdrukking true retourneert, wordt de standaardtekst voor de 'Bedankpagina' gewijzigd in de opgegeven tekst.",
            itemExpressionText: "Wanneer expressie: '{0}' true retourneert:",
            itemEmptyExpressionText: "Nieuwe regel",
            page_visibilityText: "Maak pagina {0} zichtbaar",
            panel_visibilityText: "Maak paneel {0} zichtbaar",
            panel_enableText: "Schakel paneel {0} in",
            question_visibilityText: "Maak vraag {0} zichtbaar",
            question_enableText: "Schakel vraag {0} in",
            question_requireText: "Stel vraag {0} verplicht",
            question_resetValueText: "Resetwaarde voor vraag: {0}",
            question_setValueText: "Waarde: {1} toewijzen aan vraag: {0}",
            column_visibilityText: "Kolom {0} van vraag {1} zichtbaar maken",
            column_enableText: "Kolom {0} van vraag maken {1} inschakelen",
            column_requireText: "Kolom {0} met vraag {1} verplicht maken",
            column_resetValueText: "Celwaarde voor kolom opnieuw instellen: {0}",
            column_setValueText: "Celwaarde: {1} toewijzen aan kolom: {0}",
            setValueExpressionPlaceholder: " Een expressie waarvan het resultaat wordt toegewezen aan de doelvraag.",
            trigger_completeText: "Enquête wordt voltooid",
            trigger_setvalueText: "Stel de vraag: {0} waarde {1}",
            trigger_setvalueEmptyText: "verwijder vraagwaarde: {0}",
            trigger_copyvalueText: "Kopieer naar vraag: {0} waarde uit vraag {1}",
            trigger_skipText: "Enquête ga verder met de vraag {0}",
            trigger_runExpressionText1: "Uitdrukking uitvoeren: '{0}'",
            trigger_runExpressionText2: " en stel het resultaat in vraag: {0}",
            completedHtmlOnConditionText: "Toon aangepaste tekst voor de 'Bedankpagina'.",
            showAllQuestions: "Alle vragen",
            showAllActionTypes: "Alle actietypen",
            conditions: "Voorwaard(en)",
            actions: "Actie(s)",
            expressionEditorTitle: "Definieer conditie(s)",
            actionsEditorTitle: "Definieer actie(s)",
            deleteAction: "Actie verwijderen",
            addNewAction: "Voeg nieuwe actie toe",
            selectedActionCaption: "Selecteer een actie om toe te voegen...",
            expressionInvalid: "De logische uitdrukking is leeg of ongeldig. Verbeter dit alstublieft.",
            noActionError: "Voeg ten minste één actie toe.",
            actionInvalid: "Los problemen in uw actie(s) op.",
            uncompletedRule_title: "Logische regels zijn onvolledig",
            uncompletedRule_text: "U hebt een aantal van de logische regels niet voltooid. Als u het tabblad nu verlaat, gaan de wijzigingen verloren. Wilt u het tabblad nog steeds verlaten zonder de wijzigingen te voltooien?",
            uncompletedRule_apply: "Ja",
            uncompletedRule_cancel: "Nee, ik wil de regels invullen"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Naam van het paneel",
            title: "Titel van het paneel",
            description: "Beschrijving van het paneel",
            visibleIf: "Maak het paneel zichtbaar als",
            requiredIf: "Maak het paneel vereist als",
            questionsOrder: "Volgorde van de vragen binnen het panel",
            page: "Bovenliggende pagina",
            startWithNewLine: "Het paneel op een nieuwe regel weergeven",
            state: "Status van paneel samenvouwen",
            width: "Inline paneelbreedte",
            minWidth: "Minimale paneelbreedte",
            maxWidth: "Maximale paneelbreedte",
            showNumber: "Nummerpanelen"
        },
        paneldynamic: {
            name: "Naam van het paneel",
            title: "Titel van het paneel",
            description: "Beschrijving van het paneel",
            visibleIf: "Maak het paneel zichtbaar als",
            requiredIf: "Maak het paneel vereist als",
            page: "Het deelvenster naar pagina verplaatsen",
            startWithNewLine: "Het paneel op een nieuwe regel weergeven",
            state: "Status van paneel samenvouwen",
            width: "Inline paneelbreedte",
            minWidth: "Minimale paneelbreedte",
            maxWidth: "Maximale paneelbreedte",
            confirmDelete: "Het verwijderen van het deelvenster bevestigen",
            templateDescription: "Patroon van paneelbeschrijving",
            templateTitle: "Patroon voor paneeltitel",
            noEntriesText: "Lege paneeltekst",
            templateTabTitle: "Patroon voor tabbladtitel",
            tabTitlePlaceholder: "Tijdelijke aanduiding voor tabtitel",
            templateVisibleIf: "Maak een afzonderlijk paneel zichtbaar als",
            hideNumber: "Het paneelnummer verbergen",
            titleLocation: "Uitlijning van paneeltitels",
            descriptionLocation: "Uitlijning van paneelbeschrijving",
            templateTitleLocation: "Uitlijning van vraagtitels",
            templateErrorLocation: "Uitlijning van foutmeldingen",
            newPanelPosition: "Nieuwe paneellocatie",
            keyName: "Voorkom dubbele antwoorden in de volgende vraag"
        },
        question: {
            name: "Naam van de vraag",
            title: "Titel van de vraag",
            description: "Beschrijving van de vraag",
            visibleIf: "Maak de vraag zichtbaar als",
            requiredIf: "Maak de vraag verplicht als",
            page: "Bovenliggende pagina",
            state: "Samenvouwen van vragenvak",
            hideNumber: "Verberg het vraagnummer",
            titleLocation: "Uitlijning van vraagtitels",
            descriptionLocation: "Uitlijning van vraagbeschrijvingen",
            errorLocation: "Uitlijning van foutmeldingen",
            indent: "Vergroot de binnenste inspringing",
            width: "Breedte inline vraag",
            minWidth: "Minimale vraagbreedte",
            maxWidth: "Maximale vraagbreedte",
            textUpdateMode: "Invoerveldwaarde bijwerken"
        },
        signaturepad: {
            signatureWidth: "Breedte van het handtekeninggebied",
            signatureHeight: "Hoogte van het handtekeninggebied",
            signatureAutoScaleEnabled: "Het handtekeninggebied automatisch schalen",
            showPlaceholder: "De tijdelijke aanduiding weergeven",
            placeholder: "Tijdelijke aanduiding voor tekst",
            placeholderReadOnly: "Tijdelijke tekst in de modus Alleen-lezen of voorvertoning",
            allowClear: "De knop Wissen weergeven in het handtekeninggebied",
            penMinWidth: "Minimale penbreedte",
            penMaxWidth: "Maximale breedte van het hok",
            penColor: "Kleur van de lijn"
        },
        comment: {
            rows: "Hoogte invoerveld (in lijnen)"
        },
        showQuestionNumbers: "Toon vraagnummers",
        questionStartIndex: "Eerste vraag (1, 2 or 'A', 'a')",
        expression: {
            name: "Naam van expressie",
            title: "Titel van expressie",
            description: "Beschrijving van expressie",
            expression: "Uitdrukking"
        },
        trigger: {
            expression: "Uitdrukking"
        },
        calculatedvalue: {
            expression: "Uitdrukking"
        },
        // survey templates
        survey: {
            title: "Titel",
            description: "Beschrijving van de enquête"
        },
        page: {
            name: "Paginanaam",
            title: "Titel",
            description: "Pagina beschrijving",
            visibleIf: "Maak de pagina zichtbaar als",
            requiredIf: "Maak de pagina vereist als",
            maxTimeToFinish: "Tijdslimiet om de pagina te voltooien (in seconden)",
            questionsOrder: "Volgorde van vragen op de pagina"
        },
        matrixdropdowncolumn: {
            name: "Naam van de kolom",
            title: "Titel van de kolom",
            isUnique: "Voorkom dubbele reacties",
            width: "Kolombreedte",
            minWidth: "Minimale kolombreedte",
            rows: "Hoogte invoerveld (in lijnen)",
            visibleIf: "Maak de kolom zichtbaar als",
            requiredIf: "Maak de kolom verplicht als",
            showInMultipleColumns: "Elke optie in een aparte kolom"
        },
        multipletextitem: {
            name: "Naam",
            title: "Titel"
        },
        masksettings: {
            saveMaskedValue: "Gemaskeerde waarde opslaan in enquêteresultaten"
        },
        patternmask: {
            pattern: "Waardepatroon"
        },
        datetimemask: {
            min: "Minimumwaarde",
            max: "Maximale waarde"
        },
        numericmask: {
            allowNegativeValues: "Negatieve waarden toestaan",
            thousandsSeparator: "Scheidingsteken voor duizendtallen",
            decimalSeparator: "Decimaalteken",
            precision: "Waarde precisie",
            min: "Minimumwaarde",
            max: "Maximale waarde"
        },
        currencymask: {
            prefix: "Valuta voorvoegsel",
            suffix: "Valuta achtervoegsel"
        },
        imageHeight: "Afbeelding hoogte",
        imageWidth: "Afbeelding breedte",
        valueName: "Waardenaam",
        rateDescriptionLocation: "Etiket uitlijnen",
        size: "Grootte invoerveld (in tekens)",
        cellErrorLocation: "Uitlijning van celfoutmeldingen",
        apply: "Van toepassing zijn",
        ok: "OK",
        save: "Opslaan",
        clear: "Verwijder alles",
        saveTooltip: "Opslaan",
        cancel: "Annuleren",
        set: "Set",
        reset: "Resetten",
        change: "Veranderen",
        refresh: "Opslaan",
        close: "Sluiten",
        delete: "Verwijderen",
        add: "Toevoegen",
        addNew: "Nieuwe toevoegen",
        addItem: "Klik om een item toe te voegen...",
        removeItem: "Klik om het item te verwijderen...",
        dragItem: "Sleep het item",
        addOther: "Andere",
        addSelectAll: "Selecteer alles",
        addNone: "Geen",
        removeAll: "Verwijder alles",
        edit: "Bewerk",
        back: "Keer terug zonder op te slaan",
        backTooltip: "Keer terug zonder op te slaan",
        saveAndBack: "Bewaar en keer terug",
        saveAndBackTooltip: "Bewaar en keer terug",
        doneEditing: "Klaar",
        editChoices: "Keuzes bewerken",
        showChoices: "Toon keuzes",
        move: "Bewegen",
        empty: "<leeg>",
        emptyValue: "Waarde is leeg",
        fastEntry: "Snelle toegang",
        fastEntryNonUniqueError: "Waarde '{0}' is niet uniek",
        fastEntryChoicesCountError: "Beperk het aantal objecten van {0} tot {1}",
        fastEntryChoicesMinCountError: "Voer ten minste {0} objecten in",
        fastEntryPlaceholder: "U kunt gegevens instellen in de volgende indeling:\nwaarde1|tekst\nwaarde2",
        formEntry: "Formulierinvoer",
        testService: "Test de service",
        itemSelectorEmpty: "Selecteer het element",
        conditionActionEmpty: "Selecteer de actie",
        conditionSelectQuestion: "Selecteer vraag...",
        conditionSelectPage: "Selecteer pagina...",
        conditionSelectPanel: "Selecteer paneel...",
        conditionValueQuestionTitle: "Voer/selecteer de waarde",
        aceEditorHelp: "Druk op Ctrl+spatiebalk om een hint voor het voltooien van een uitdrukking te krijgen",
        aceEditorRowTitle: "Huidige rij",
        aceEditorPanelTitle: "Huidig paneel",
        showMore: "Raadpleeg de documentatie voor meer details",
        assistantTitle: "Beschikbare vragen:",
        cellsEmptyRowsColumns: "Er moet minimaal één kolom of rij zijn",
        showPreviewBeforeComplete: "Voorbeeldweergave voor afronden",
        overridingPropertyPrefix: "Ingesteld door ",
        resetToDefaultCaption: "Terugstellen",
        propertyIsEmpty: "Voer alstublieft een waarde in",
        propertyIsNoUnique: "Voer een unieke waarde in",
        propertyNameIsNotUnique: "Voer een unieke naam in",
        propertyNameIsIncorrect: "Gebruik geen gereserveerde woorden: \"item\", \"keuze\", \"paneel\", \"rij\".",
        listIsEmpty: "Voeg een nieuw item toe",
        "listIsEmpty@choices": "Er zijn nog geen keuzes toegevoegd",
        "listIsEmpty@columns": "Je hebt nog geen kolommen",
        "listIsEmpty@rows": "Je hebt nog geen rijen",
        "listIsEmpty@validators": "Je hebt nog geen validatieregels",
        "listIsEmpty@calculatedValues": "Je hebt nog geen aangepaste variabelen",
        "listIsEmpty@triggers": "Je hebt nog geen triggers",
        "listIsEmpty@navigateToUrlOnCondition": "Je hebt nog geen links",
        "addNew@choices": "Een keuze toevoegen",
        "addNew@columns": "Nieuwe kolom toevoegen",
        "addNew@rows": "Nieuwe rij toevoegen",
        "addNew@validators": "Nieuwe regel toevoegen",
        "addNew@calculatedValues": "Nieuwe variabele toevoegen",
        "addNew@triggers": "Nieuwe trigger toevoegen",
        "addNew@navigateToUrlOnCondition": "Nieuwe URL toevoegen",
        expressionIsEmpty: "Expressie is leeg",
        value: "Waarde",
        text: "Tekst",
        rowid: "Rij-ID",
        imageLink: "Afbeeldingslink",
        columnEdit: "Kolom bewerken: {0}",
        itemEdit: "Bewerk item: {0}",
        url: "URL",
        path: "Pad",
        choicesbyurl: {
            url: "URL van de webservice",
            valueName: "Haal waarden op uit het volgende JSON-veld"
        },
        titleName: "Titel",
        imageLinkName: "Afbeeldings-URL's ophalen uit het volgende JSON-veld",
        allowEmptyResponse: "Leeg respons toestaan",
        titlePlaceholder: "Voer hier de titel in",
        surveyTitlePlaceholder: "Voer de enquêtetitel hier in",
        pageTitlePlaceholder: "Voer hier de paginatitel in",
        descriptionPlaceholder: "Voer een omschrijving in",
        surveyDescriptionPlaceholder: "Voer een onderzoeksbeschrijving in",
        pageDescriptionPlaceholder: "Voer een paginabeschrijving in",
        textWrapEnabled: "Wrap-keuzes",
        showOtherItem: "De optie 'Anders' tonen",
        otherText: "Titel 'Anders:'-optie",
        showNoneItem: "De optie 'Geen' tonen",
        showRefuseItem: "De optie Weigeren om te antwoorden toestaan",
        showDontKnowItem: "De optie 'Weet niet' toestaan",
        noneText: "Titel 'Geen'-optie",
        showSelectAllItem: "Heeft de 'Alles selecteren'-optie",
        selectAllText: "Titel 'Alles selecteren'-optie",
        choicesMin: "Minimumwaarde voor automatisch gegenereerde items",
        choicesMax: "Maximale waarde voor automatisch gegenereerde items",
        choicesStep: "Het verschil tussen automatisch gegenereerde items",
        name: "Naam",
        title: "Titel",
        cellType: "Celtype",
        colCount: "Kolom tellen",
        choicesOrder: "Volgorde opties",
        visible: "Is zichtbaar?",
        isRequired: "Is verplicht?",
        markRequired: "Markeren zoals vereist",
        removeRequiredMark: "Verwijder de vereiste markering",
        isAllRowRequired: "Antwoord vereisen voor alle rijen",
        eachRowUnique: "Voorkom dubbele antwoorden in rijen",
        requiredErrorText: "Tekst bij niet-ingevulde verplichte vraag",
        startWithNewLine: "Beginnen met een nieuwe regel?",
        rows: "Aantal rijen",
        cols: "Kolom tellen",
        placeholder: "Hulptekst",
        showPreview: "Toon voorbeeldgebied",
        storeDataAsText: "Bewaar bestandsinhoud in JSON-resultaat als tekst",
        maxSize: "Maximale bestandsgrootte in bytes",
        rowCount: "Aantal rijen",
        columnLayout: "Kolommen layout",
        addRowLocation: "Voeg de locatie van de rijknop toe",
        transposeData: "Rijen transponeren naar kolommen",
        addRowText: "Voeg tekst van de rijknop toe",
        removeRowText: "Verwijder de tekst van de rijknop",
        rateMin: "Minimumtarief",
        rateMax: "Maximaal tarief",
        rateStep: "Beoordeel stap",
        minRateDescription: "Beschrijving minimumtarief",
        maxRateDescription: "Maximale tariefomschrijving",
        inputType: "Invoertype",
        optionsCaption: "Bijschrift opties",
        defaultValue: "Standaardwaarde",
        cellsDefaultRow: "Standaard celteksten",
        surveyEditorTitle: "Bewerk enquête-instellingen",
        qEditorTitle: "Bewerken: {0}",
        maxLength: "Maximale lengte",
        buildExpression: "Bouwen",
        editExpression: "Bewerk",
        and: "en",
        or: "of",
        remove: "Verwijderen",
        addCondition: "Voorwaarde toevoegen",
        emptyLogicPopupMessage: "Selecteer een vraag om te beginnen met het configureren van voorwaarden.",
        if: "Als",
        then: "dan",
        setToName: "Doelvraag",
        fromName: "Vraag om het antwoord van te kopiëren",
        gotoName: "Vraag om naar over te slaan",
        ruleIsNotSet: "Regel is onjuist",
        includeIntoResult: "Opnemen in enquêteresultaten",
        showTitle: "Titel weergeven/verbergen",
        expandCollapseTitle: "Titel uitvouwen/samenvouwen",
        locale: "Standaardtaal",
        simulator: "Kies apparaat",
        landscapeOrientation: "Landschap",
        portraitOrientation: "Overschakelen naar staande stand",
        mode: "Modus (bewerken/alleen lezen)",
        clearInvisibleValues: "Wis onzichtbare waarden",
        cookieName: "Cookienaam (zodat enquête slechts éénmalig wordt ingevuld)",
        sendResultOnPageNext: "Antwoorden opslaan bij pagina-overgang",
        storeOthersAsComment: "Sla de waarde van 'anderen' op in een apart veld",
        showPageTitles: "Toon paginatitels",
        showPageNumbers: "Toon paginanummers",
        pagePrevText: "Knoptitel 'Vorige pagina'",
        pageNextText: "Knoptitel 'Volgende pagina'",
        completeText: "Knoptitel 'Afronden'",
        previewText: "Knoptitel 'Voorbeeldweergave'",
        editText: "Knoptitel 'Bewerken'",
        startSurveyText: "Knoptitel 'Starten'",
        showNavigationButtons: "Navigatieknoppen weergeven (standaardnavigatie)",
        showPrevButton: "Toon knop 'Vorige pagina' (gebruiker kan terugkeren)",
        firstPageIsStarted: "De eerste pagina in de enquête is een startpagina",
        showCompletedPage: "Toon bij afronden deze HTML-code",
        goNextPageAutomatic: "Na alle vragen automatisch naar volgende pagina gaan",
        allowCompleteSurveyAutomatic: "Vul de enquête automatisch in",
        showProgressBar: "Toon voortgangsbalk",
        questionTitleLocation: "Plek vraagtitel",
        questionTitleWidth: "Breedte van de vraagtitel",
        requiredText: "Symbool(en) verplichte vraag",
        questionTitleTemplate: "Vraagtitelsjabloon, standaard is: '{no}. {vereisen} {titel}'",
        questionErrorLocation: "Plek vraagfoutmelding",
        focusFirstQuestionAutomatic: "Op volgende pagina focus op de eerste vraag zetten",
        questionsOrder: "Volgorde elementen op pagina",
        maxTimeToFinish: "Maximale tijd om de enquête te voltooien",
        maxTimeToFinishPage: "Maximale tijd om een pagina in de enquête te voltooien",
        showTimerPanel: "Toon timerpaneel",
        showTimerPanelMode: "Modus timerpaneel",
        renderMode: "Render-modus",
        allowAddPanel: "Sta het toevoegen van een paneel toe",
        allowRemovePanel: "Laat het verwijderen van het paneel toe",
        panelAddText: "Paneeltekst toevoegen",
        panelRemoveText: "Paneeltekst verwijderen",
        isSinglePage: "Toon alle elementen op één pagina",
        html: "Html",
        setValue: "Antwoorden",
        dataFormat: "Beeldformaat",
        allowAddRows: "Het toevoegen van rijen toestaan",
        allowRemoveRows: "Het verwijderen van rijen toestaan",
        allowRowsDragAndDrop: "Rij slepen en neerzetten toestaan",
        responsiveImageSizeHelp: "Is niet van toepassing als u de exacte breedte of hoogte van de afbeelding opgeeft.",
        minImageWidth: "Minimale afbeeldingsbreedte",
        maxImageWidth: "Maximale afbeeldingsbreedte",
        minImageHeight: "Minimale beeldhoogte",
        maxImageHeight: "Maximale beeldhoogte",
        minValue: "Minimale waarde",
        maxValue: "Maximale waarde",
        minLength: "Minimale lengte",
        allowDigits: "Cijfers toestaan",
        minCount: "Minimum aantal",
        maxCount: "Maximale telling",
        regex: "Reguliere expressie",
        surveyvalidator: {
            text: "Foutmelding",
            expression: "Validatie-expressie"
        },
        totalText: "Totale tekst",
        totalType: "Totaal type",
        totalExpression: "Totale expressie",
        totalDisplayStyle: "Totale weergavestijl",
        totalCurrency: "Totale valuta",
        totalFormat: "Totaal formaat",
        logo: "Logo (URL of base64-gecodeerde tekenreeks)",
        questionsOnPageMode: "Structuur van de enquête",
        maxTextLength: "Maximale tekstlengte",
        maxOthersLength: "Maximale tekstlengte optie 'Anders:'",
        commentAreaRows: "Hoogte commentaargebied (in lijnen)",
        autoGrowComment: "Commentaargebied indien nodig automatisch uitvouwen",
        allowResizeComment: "Gebruikers toestaan het formaat van tekstgebieden te wijzigen",
        textUpdateMode: "Modus tekstvernieuwing",
        maskType: "Type invoermasker",
        maskTypes: {
            none: "Geen",
            patternmask: "Patroon",
            numericmask: "Numeriek",
            datetimemask: "Datum en tijd",
            currencymask: "Valuta"
        },
        focusOnFirstError: "Focus op eerste fout zetten",
        checkErrorsMode: "Validatie uitvoeren",
        navigateToUrl: "Navigeer naar URL",
        navigateToUrlOnCondition: "Dynamische URL",
        completedBeforeHtml: "Markering om aan te geven of de gebruiker deze enquête al heeft ingevuld",
        completedHtml: "Paginaopmaak voor voltooide enquête",
        completedHtmlOnCondition: "Dynamische enquête volledige paginaopmaak",
        loadingHtml: "Markeringen om weer te geven terwijl het enquêtemodel wordt geladen",
        commentText: "Tekst in het commentaargebied",
        autocomplete: "Type Automatisch aanvullen",
        labelTrue: "Label \"Waar\"",
        labelFalse: "Label 'Onwaar'",
        allowClear: "De knop Wissen weergeven",
        searchMode: "Zoekmodus",
        displayStyle: "Waarde weergavestijl",
        format: "Opgemaakte tekenreeks",
        maximumFractionDigits: "Maximum fractionele cijfers",
        minimumFractionDigits: "Minimale fractionele cijfers",
        useGrouping: "Scheidingstekens voor groeperingen weergeven",
        allowMultiple: "Meerdere bestanden toestaan",
        allowImagesPreview: "Afbeeldingen bekijken",
        acceptedTypes: "Geaccepteerde bestandstypen",
        waitForUpload: "Wacht tot het uploaden is voltooid",
        needConfirmRemoveFile: "Bevestig het verwijderen van bestanden",
        detailPanelMode: "Locatie van het detailpaneel",
        minRowCount: "Minimaal aantal rijen",
        maxRowCount: "Maximaal aantal rijen",
        confirmDelete: "Rijverwijdering bevestigen",
        confirmDeleteText: "Bevestigingsbericht",
        panelCount: "Initiële paneeltelling",
        minPanelCount: "Minimaal aantal panelen",
        maxPanelCount: "Maximaal aantal panelen",
        panelsState: "Uitvouwstatus binnenpaneel",
        panelPrevText: "Knopinfo vorige deelvensterknop",
        panelNextText: "knopinfo voor het volgende deelvenster",
        showRangeInProgress: "Voortgangsbalk weergeven",
        panelRemoveButtonLocation: "Locatie van de knop Deelvenster verwijderen",
        hideIfRowsEmpty: "Verberg de vraag als er geen rijen zijn",
        hideColumnsIfEmpty: "Kolommen verbergen als er geen rijen zijn",
        rateValues: "Aangepaste tariefwaarden",
        rateCount: "Aantal tarieven",
        autoGenerate: "Hoe geef ik tariefwaarden op?",
        hideIfChoicesEmpty: "Verberg de vraag als deze geen keuzes bevat",
        minWidth: "Minimale breedte (in css-geaccepteerde waarden)",
        maxWidth: "Maximale breedte (in css-geaccepteerde waarden)",
        width: "Breedte (in CSS-geaccepteerde waarden)",
        showHeader: "Kolomkoppen weergeven",
        horizontalScroll: "Horizontale schuifbalk weergeven",
        columnMinWidth: "Minimale kolombreedte (in css-geaccepteerde waarden)",
        rowTitleWidth: "Breedte van rijkoptekst (in css-geaccepteerde waarden)",
        valueTrue: "Waarde 'Waar'",
        valueFalse: "Waarde 'Onwaar'",
        minErrorText: "Foutbericht 'Waarde is onder het minimum'",
        maxErrorText: "Foutbericht 'Waarde overschrijdt maximum'",
        otherErrorText: "Foutbericht 'Lege opmerking'",
        keyDuplicationError: "Foutbericht 'Niet-unieke sleutelwaarde'",
        minSelectedChoices: "Minimaal geselecteerde keuzes",
        maxSelectedChoices: "Maximum aantal geselecteerde keuzes",
        showClearButton: "De knop Wissen weergeven",
        logoWidth: "Breedte logo",
        logoHeight: "Hoogte logo",
        readOnly: "Alleen-lezen",
        enableIf: "Bewerkbaar als",
        emptyRowsText: "Bericht 'Geen rijen'",
        separateSpecialChoices: "Speciale keuzes afzonderlijk (Geen, Overig, Alles selecteren)",
        choicesFromQuestion: "Kopieer keuzes uit de volgende vraag",
        choicesFromQuestionMode: "Welke keuzes kopiëren?",
        progressBarShowPageTitles: "Paginatitels weergeven in de voortgangsbalk",
        progressBarShowPageNumbers: "Paginanummers weergeven in de voortgangsbalk",
        showCommentArea: "Het opmerkingenveld weergeven",
        commentPlaceholder: "Tijdelijke aanduiding voor het opmerkingengebied",
        displayRateDescriptionsAsExtremeItems: "Beschrijvingen van tarieven weergeven als extreme waarden",
        rowsOrder: "Rijvolgorde",
        columnsLayout: "Kolomindeling",
        columnColCount: "Aantal geneste kolommen",
        correctAnswer: "Juist antwoord",
        defaultPanelValue: "Standaardwaarden",
        cells: "Celteksten",
        fileInputPlaceholder: "Selecteer een bestand of plak een bestandslink...",
        keyName: "Sleutelkolom",
        itemvalue: {
            visibleIf: "Maak de optie zichtbaar als",
            enableIf: "Maak de optie selecteerbaar als"
        },
        "itemvalue@rows": {
            visibleIf: "Maak de rij zichtbaar als",
            enableIf: "De rij bewerkbaar maken als:"
        },
        imageitemvalue: {
            text: "Alternatieve tekst"
        },
        logoPosition: "Positie logo",
        addLogo: "Logo toevoegen...",
        changeLogo: "Logo wijzigen...",
        logoPositions: {
            none: "Logo verwijderen",
            left: "Links",
            right: "Rechtsaf",
            top: "Bovenop",
            bottom: "Onder aan"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Paneel Lay-out"
            },
            general: "Algemeen",
            fileOptions: "Opties",
            html: "Html-editor",
            columns: "Kolommen",
            rows: "Rijen",
            choices: "Keuzes",
            items: "Artikelen",
            visibleIf: "Zichtbaar als",
            enableIf: "Schakel If in",
            requiredIf: "Vereist als",
            rateValues: "Beoordeel waarden",
            choicesByUrl: "Keuzes van internet",
            matrixChoices: "Standaardkeuzes",
            multipleTextItems: "Tekstinvoer",
            numbering: "Nummering",
            validators: "Validators",
            navigation: "Navigatie",
            question: "Vraag",
            pages: "Pagina's",
            timer: "Timer/Quiz",
            calculatedValues: "Berekende waardes",
            triggers: "Triggers",
            templateTitle: "Sjabloontitel",
            totals: "Totalen",
            logic: "Logica",
            mask: "Instellingen voor invoermasker",
            layout: {
                panel: "Indeling",
                question: "Indeling",
                base: "Indeling"
            },
            data: "Gegevens",
            validation: "Validatie",
            cells: "Cellen",
            showOnCompleted: "Weergeven bij afronden",
            logo: "Logo in enquêtetitel",
            slider: "Schuifregelaar",
            expression: "Uitdrukking",
            questionSettings: "Vraag-instellingen",
            header: "Rubriek",
            background: "Achtergrond",
            appearance: "Uiterlijk",
            others: "Anderen"
        },
        editProperty: "Eigenschap '{0}' bewerken",
        items: "Items",
        choicesVisibleIf: "Keuzes zijn zichtbaar als",
        choicesEnableIf: "Keuzes kunnen worden geselecteerd als",
        columnsEnableIf: "Kolommen zijn zichtbaar als",
        rowsEnableIf: "Rijen zijn zichtbaar als",
        innerIndent: "Binnenste inspringingen toevoegen",
        defaultValueFromLastRow: "Standaardwaarden uit de laatste rij nemen",
        defaultValueFromLastPanel: "Standaardwaarden uit het laatste deelvenster overnemen",
        enterNewValue: "Voer de waarde in.",
        noquestions: "Er is geen enkele vraag in de enquête.",
        createtrigger: "Maak een trigger",
        titleKeyboardAdornerTip: "Druk op de enter-knop om te bewerken",
        keyboardAdornerTip: "Druk op de enter-knop om het item te bewerken, druk op de delete-knop om het item te verwijderen, druk op alt plus pijl omhoog of pijl omlaag om item te verplaatsen",
        triggerOn: "Aan ",
        triggerMakePagesVisible: "Maak pagina's zichtbaar:",
        triggerMakeQuestionsVisible: "Maak elementen zichtbaar:",
        triggerCompleteText: "Vul de enquête in als dit lukt.",
        triggerNotSet: "De trigger is niet ingesteld",
        triggerRunIf: "Voer als",
        triggerSetToName: "Verander waarde van: ",
        triggerFromName: "Waarde kopiëren van: ",
        triggerRunExpression: "Voer deze expressie uit:",
        triggerSetValue: "naar: ",
        triggerGotoName: "Ga naar de vraag:",
        triggerIsVariable: "Zet de variabele niet in het onderzoeksresultaat.",
        triggerRunExpressionEmpty: "Voer een geldige uitdrukking in",
        emptyExpressionPlaceHolder: "Typ hier expressie...",
        noFile: "Geen bestand gekozen",
        clearIfInvisible: "Wis de waarde als de vraag verborgen wordt",
        valuePropertyName: "Naam van de eigenschap Value",
        searchEnabled: "Zoeken inschakelen",
        hideSelectedItems: "Geselecteerde items verbergen",
        closeOnSelect: "Sluit de vervolgkeuzelijst na selectie",
        verticalAlign: "Verticale uitlijning",
        alternateRows: "Alternatieve rijen",
        columnsVisibleIf: "Kolommen zijn zichtbaar als",
        rowsVisibleIf: "Rijen zijn zichtbaar als",
        otherPlaceholder: "Plaatshouder tekst voor het invulveld",
        filePlaceholder: "Plaatshouder tekst voor bestanden",
        photoPlaceholder: "Plaatshouder tekst voor foto's",
        fileOrPhotoPlaceholder: "Plaatshouder tekst voor bestanden of foto's",
        rateType: "Type tarief",
        url_placeholder: "Vb.: https://api.example.com/books",
        path_placeholder: "Vb.: categories.fiction",
        questionStartIndex_placeholder: "Vb.: a)",
        width_placeholder: "Bijv.: 6in",
        minWidth_placeholder: "Bijv.: 600px",
        maxWidth_placeholder: "Vb.: 50%",
        imageHeight_placeholder: "Auto",
        imageWidth_placeholder: "Auto",
        theme: {
            themeName: "Thema",
            isPanelless: "Weergave van de vraag",
            editorPanel: "Achtergrond en hoekradius",
            questionPanel: "Achtergrond en hoekradius",
            primaryColor: "Accent kleur",
            panelBackgroundTransparency: "Dekking van de achtergrond van het deelvenster",
            questionBackgroundTransparency: "Ondoorzichtigheid van de achtergrond van de vraag",
            fontSize: "Tekengrootte",
            scale: "Schub",
            cornerRadius: "De straal van de hoek",
            pageTitle: "Titel lettertype",
            pageDescription: "Beschrijving lettertype",
            questionTitle: "Titel lettertype",
            questionDescription: "Beschrijving lettertype",
            editorFont: "Lettertype",
            backgroundOpacity: "Dekking",
            "--sjs-font-family": "Lettertype familie",
            "--sjs-general-backcolor-dim": "Achtergrondkleur",
            "--sjs-primary-backcolor": "De achtergrond van het accent",
            "--sjs-primary-forecolor": "Accent voorgrond",
            "--sjs-special-red": "Foutberichten",
            "--sjs-shadow-small": "Schaduweffecten",
            "--sjs-shadow-inner": "Schaduweffecten",
            "--sjs-border-default": "Kleuren"
        },
        "header@header": {
            headerView: "Bekijken",
            logoPosition: "Positie van het logo",
            surveyTitle: "Lettertype van de titel van de enquête",
            surveyDescription: "Lettertype voor enquêtebeschrijving",
            headerTitle: "Lettertype van de titel van de enquête",
            headerDescription: "Lettertype voor enquêtebeschrijving",
            inheritWidthFrom: "Breedte inhoudsgebied",
            textAreaWidth: "Breedte van de tekst",
            backgroundColorSwitch: "Achtergrondkleur",
            backgroundImage: "Achtergrondafbeelding",
            backgroundImageOpacity: "Dekking",
            overlapEnabled: "Overlappen",
            logoPositionX: "Positie van het logo",
            titlePositionX: "Titel positie",
            descriptionPositionX: "Beschrijving positie"
        }
    },
    // Property values
    pv: {
        "true": "waar",
        "false": "vals",
        file: "Lokale bestanden",
        camera: "Fototoestel",
        "file-camera": "Lokale bestanden of camera",
        inherit: "Erven",
        show: "Tonen",
        hide: "Zich verstoppen",
        default: "Standaard",
        initial: "Standaard",
        random: "Willekeurig",
        collapsed: "Ingestort",
        expanded: "Uitgebreid",
        none: "Geen",
        asc: "Oplopend",
        desc: "Aflopend",
        indeterminate: "Onbepaald",
        selected: "Uitverkoren",
        unselected: "Geselecteerd",
        decimal: "decimaal",
        currency: "valuta",
        percent: "procent",
        firstExpanded: "Eerste uitgevouwen",
        off: "Uit",
        list: "Lijst",
        progressTop: "Voortgang top",
        progressBottom: "Voortgang bodem",
        progressTopBottom: "Voortgang top bodem",
        tab: "Tabs",
        horizontal: "Horizontaal",
        vertical: "Verticaal",
        top: "Top",
        bottom: "Beneden",
        topBottom: "Top en beneden",
        both: "Beide",
        left: "Links",
        right: "Rechts",
        center: "Middelpunt",
        leftRight: "Links en rechts",
        middle: "Midden",
        color: "Kleur",
        date: "datum",
        datetime: "datetime",
        "datetime-local": "datetime-lokaal",
        email: "E-mail",
        month: "maand",
        number: "getal",
        password: "wachtwoord",
        range: "bereik",
        tel: "Tel",
        text: "Sms",
        time: "Tijd",
        url: "Url",
        week: "week",
        hidden: "Verborgen",
        edit: "Bewerk",
        display: "Scherm",
        contain: "Bevatten",
        cover: "Bedekken",
        fill: "Vullen",
        next: "Volgend",
        last: "Laatste",
        onComplete: "Bij afronden",
        onHidden: "Bij verbergen",
        onHiddenContainer: "Wanneer de vraag of het bijbehorende paneel/de bijbehorende pagina verborgen raakt",
        clearInvisibleValues: {
            none: "Nooit"
        },
        clearIfInvisible: {
            none: "Nooit"
        },
        inputType: {
            color: "Kleur",
            date: "Datum",
            "datetime-local": "Datum en tijd",
            email: "E-mail",
            month: "Maand",
            number: "Getal",
            password: "Wachtwoord",
            range: "Bereik",
            tel: "Telefoonnummer",
            text: "Sms",
            time: "Tijd",
            url: "Url",
            week: "Week"
        },
        all: "Alle",
        page: "Pagina",
        survey: "Enquête",
        onNextPage: "Bij pagina-overgang",
        onValueChanged: "Bij waardeverandering",
        onValueChanging: "Voordat een antwoord wordt gewijzigd",
        questionsOnPageMode: {
            standard: "Oorspronkelijke structuur",
            singlePage: "Toon alle vragen op één pagina",
            questionPerPage: "Toon één vraag per pagina"
        },
        noPreview: "Geen preview",
        showAllQuestions: "Toon voorbeeld met alle vragen",
        showAnsweredQuestions: "Toon voorbeeld met beantwoorde vragen",
        pages: "Voltooide pagina's",
        questions: "Beantwoorde vragen",
        requiredQuestions: "Vereiste vragen beantwoord",
        correctQuestions: "Geldige antwoorden",
        buttons: "Voltooide pagina's (knop UI)",
        underInput: "Onder het invoerveld",
        underTitle: "Onder de titel",
        onBlur: "Bij verliezen focus",
        onTyping: "Tijdens het typen",
        underRow: "Onder de rij",
        underRowSingle: "Onder de rij is slechts één paneel zichtbaar",
        auto: "Auto",
        showNavigationButtons: {
            none: "Verborgen"
        },
        showTimerPanel: {
            none: "Verborgen"
        },
        showTimerPanelMode: {
            all: "Beide"
        },
        addRowLocation: {
            default: "Afhankelijk van de matrixindeling"
        },
        panelsState: {
            default: "Gebruikers kunnen deelvensters niet uitvouwen of samenvouwen",
            collapsed: "Alle panelen zijn samengevouwen",
            expanded: "Alle panelen zijn uitgebreid",
            firstExpanded: "Eerst uitgebreid"
        },
        widthMode: {
            static: "Statisch",
            responsive: "Responsieve"
        },
        contentMode: {
            image: "Beeld",
            video: "Video",
            youtube: "YouTube"
        },
        displayMode: {
            buttons: "Knopen",
            dropdown: "Vervolgkeuzemenu"
        },
        rateColorMode: {
            default: "Verstek",
            scale: "Schub"
        },
        scaleColorMode: {
            monochrome: "Monochroom",
            colored: "Gekleurd"
        },
        autoGenerate: {
            "true": "Genereren",
            "false": "Handmatig invoeren"
        },
        rateType: {
            labels: "Etiketten",
            stars: "Sterren",
            smileys: "Smileys"
        },
        state: {
            default: "Op slot"
        },
        showQuestionNumbers: {
            default: "Automatische nummering",
            on: "Automatische nummering",
            onPage: "Reset op elke pagina",
            onpanel: "Reset op elk paneel",
            onPanel: "Reset op elk paneel",
            onSurvey: "Doorgaan in de enquête",
            off: "Geen nummering"
        },
        descriptionLocation: {
            underTitle: "Onder de titel van de vraag",
            underInput: "Onder het invoerveld"
        },
        selectToRankAreasLayout: {
            horizontal: "Naast keuzes",
            vertical: "Bovenstaande keuzes"
        },
        displayStyle: {
            decimal: "Decimaal",
            currency: "Valuta",
            percent: "Percentage",
            date: "Datum"
        },
        totalDisplayStyle: {
            decimal: "Decimaal",
            currency: "Valuta",
            percent: "Percentage",
            date: "Datum"
        },
        rowsOrder: {
            initial: "Origineel"
        },
        questionsOrder: {
            initial: "Origineel"
        },
        showProgressBar: {
            off: "Verborgen",
            topbottom: "Top en beneden",
            aboveheader: "Boven de koptekst",
            belowheader: "Onder de kop"
        },
        sum: "Som",
        count: "Tellen",
        min: "Min",
        max: "Max",
        avg: "Avg",
        searchMode: {
            contains: "Bevat",
            startsWith: "Begint met"
        },
        backgroundImageFit: {
            auto: "Auto",
            cover: "Bedekken",
            contain: "Bevatten",
            fill: "Strekken",
            tile: "Tegel"
        },
        backgroundImageAttachment: {
            fixed: "Vast",
            scroll: "Scrollen"
        },
        headerView: {
            basic: "Basisch",
            advanced: "Geavanceerd"
        },
        inheritWidthFrom: {
            survey: "Zelfde als enquête",
            container: "Aanpassen aan container"
        },
        backgroundColorSwitch: {
            none: "Geen",
            accentColor: "Accent kleur",
            custom: "Gewoonte"
        },
        colorPalette: {
            light: "Licht",
            dark: "Donker"
        },
        isPanelless: {
            "false": "Verstek",
            "true": "Zonder panelen"
        }
    },
    // Operators
    op: {
        empty: "is leeg",
        notempty: "is niet leeg",
        equal: "gelijk is",
        notequal: "niet gelijk",
        contains: "bevat",
        notcontains: "bevat niet",
        anyof: "een van",
        allof: "alles van",
        greater: "groter",
        less: "minder",
        greaterorequal: "groter of gelijk aan",
        lessorequal: "minder of gelijk aan",
        and: "en",
        or: "of"
    },
    // Embed window
    ew: {
        angular: "Gebruik de Angular-versie",
        jquery: "Gebruik de jQuery-versie",
        knockout: "Gebruik de Knockout-versie",
        react: "Gebruik de React-versie",
        vue: "Gebruik de Vue-versie",
        bootstrap: "Voor bootstrap-framework",
        modern: "Modern thema",
        default: "Standaard thema",
        orange: "Oranje thema",
        darkblue: "Donkerblauw thema",
        darkrose: "Donkereroos thema",
        stone: "Stenen thema",
        winter: "Winter thema",
        winterstone: "Wintersteen thema",
        showOnPage: "Toon enquête op een pagina",
        showInWindow: "Toon enquête in een venster",
        loadFromServer: "Laad Survey JSON vanaf de server",
        titleScript: "Scripts en stijlen",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Selecteer de pagina om deze te testen:",
        showInvisibleElements: "Toon onzichtbare elementen",
        hideInvisibleElements: "Onzichtbare elementen verbergen"
    },
    validators: {
        answercountvalidator: "Aantal antwoorden",
        emailvalidator: "E-mail",
        expressionvalidator: "Uitdrukking",
        numericvalidator: "Numeriek",
        regexvalidator: "Regex",
        textvalidator: "Tekst"
    },
    triggers: {
        completetrigger: "Volledige enquête",
        setvaluetrigger: "Ingestelde waarde",
        copyvaluetrigger: "Kopie waarde",
        skiptrigger: "Ga naar de vraag",
        runexpressiontrigger: "Run expressie",
        visibletrigger: "Zichtbaarheid wijzigen (verouderd)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Vb.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Bijv.: mm/dd/jjjj"
        },
        currencymask: {
            prefix: "Bijv.: $",
            suffix: "Bijv.: USD"
        },
        panelbase: {
            questionTitleWidth: "Bijv.: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "Een panel-ID die niet zichtbaar is voor respondenten.",
            description: "Typ een ondertitel in het deelvenster.",
            visibleIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de zichtbaarheid van het deelvenster bepaalt.",
            enableIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de alleen-lezen modus voor het deelvenster uitschakelt.",
            requiredIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die het verzenden van enquêtes verhindert, tenzij ten minste één geneste vraag een antwoord heeft.",
            questionTitleLocation: "Geldt voor alle vragen binnen dit panel. Als u deze instelling wilt overschrijven, definieert u regels voor titeluitlijning voor afzonderlijke vragen. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau (\"Standaard bovenaan\") toe.",
            questionTitleWidth: "Hiermee stelt u een consistente breedte in voor vraagtitels wanneer deze links van de vraagvakken zijn uitgelijnd. Accepteert CSS-waarden (px, %, in, pt, enz.).",
            questionErrorLocation: "Hiermee stelt u de locatie van een foutmelding in met betrekking tot alle vragen in het panel. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau toe.",
            questionsOrder: "Behoudt de oorspronkelijke volgorde van vragen of maakt ze willekeurig. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau toe.",
            page: "Hiermee verplaatst u het deelvenster naar het einde van een geselecteerde pagina.",
            innerIndent: "Hiermee voegt u ruimte of marge toe tussen de inhoud van het deelvenster en de linkerrand van het deelvenstervak.",
            startWithNewLine: "Schakel de optie uit om het deelvenster op één regel weer te geven met de vorige vraag of het vorige deelvenster. De instelling is niet van toepassing als het deelvenster het eerste element in uw formulier is.",
            state: "Kies uit: \"Uitgevouwen\" - het paneel wordt volledig weergegeven en kan worden ingeklapt; \"Samengevouwen\" - het paneel toont alleen de titel en beschrijving en kan worden uitgevouwen; \"Vergrendeld\" - het paneel wordt volledig weergegeven en kan niet worden ingeklapt.",
            width: "Hiermee stelt u de breedte van het paneel in verhouding tot andere enquête-elementen in dezelfde lijn. Accepteert CSS-waarden (px, %, in, pt, enz.)."
        },
        paneldynamic: {
            name: "Een panel-ID die niet zichtbaar is voor respondenten.",
            description: "Typ een ondertitel in het deelvenster.",
            visibleIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de zichtbaarheid van het deelvenster bepaalt.",
            enableIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de alleen-lezen modus voor het deelvenster uitschakelt.",
            requiredIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die het verzenden van enquêtes verhindert, tenzij ten minste één geneste vraag een antwoord heeft.",
            templateTitleLocation: "Geldt voor alle vragen binnen dit panel. Als u deze instelling wilt overschrijven, definieert u regels voor titeluitlijning voor afzonderlijke vragen. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau (\"Standaard bovenaan\") toe.",
            templateErrorLocation: "Hiermee stelt u de locatie in van een foutmelding met betrekking tot een vraag met ongeldige invoer. Kies tussen: \"Top\" - er wordt een fouttekst bovenaan het vraagvak geplaatst; \"Onderaan\" - er wordt een fouttekst onderaan het vraagvak geplaatst. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau (\"Standaard bovenaan\") toe.",
            errorLocation: "Hiermee stelt u de locatie van een foutmelding in met betrekking tot alle vragen in het panel. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau toe.",
            page: "Hiermee verplaatst u het deelvenster naar het einde van een geselecteerde pagina.",
            innerIndent: "Hiermee voegt u ruimte of marge toe tussen de inhoud van het deelvenster en de linkerrand van het deelvenstervak.",
            startWithNewLine: "Schakel de optie uit om het deelvenster op één regel weer te geven met de vorige vraag of het vorige deelvenster. De instelling is niet van toepassing als het deelvenster het eerste element in uw formulier is.",
            state: "Kies uit: \"Uitgevouwen\" - het paneel wordt volledig weergegeven en kan worden ingeklapt; \"Samengevouwen\" - het paneel toont alleen de titel en beschrijving en kan worden uitgevouwen; \"Vergrendeld\" - het paneel wordt volledig weergegeven en kan niet worden ingeklapt.",
            width: "Hiermee stelt u de breedte van het paneel in verhouding tot andere enquête-elementen in dezelfde lijn. Accepteert CSS-waarden (px, %, in, pt, enz.).",
            templateTitle: "Typ een sjabloon voor dynamische paneeltitels. Gebruik {panelIndex} voor de algemene positie van het paneel en {visiblePanelIndex} voor de volgorde tussen de zichtbare panelen. Voeg deze tijdelijke aanduidingen toe aan het patroon om automatische nummering toe te voegen.",
            templateTabTitle: "Typ een sjabloon voor tabbladtitels. Gebruik {panelIndex} voor de algemene positie van een paneel en {visiblePanelIndex} voor de volgorde tussen zichtbare panelen. Voeg deze tijdelijke aanduidingen toe aan het patroon om automatische nummering toe te voegen.",
            tabTitlePlaceholder: "Een terugvaltekst voor tabbladtitels die van toepassing is wanneer het patroon van de tabbladtitel geen zinvolle waarde oplevert.",
            templateVisibleIf: "Met deze instelling kunt u de zichtbaarheid van afzonderlijke panelen binnen het dynamische paneel regelen. Gebruik de tijdelijke aanduiding '{panel}' om te verwijzen naar het huidige deelvenster in uw expressie.",
            titleLocation: "Deze instelling wordt automatisch overgenomen door alle vragen in dit paneel. Als u deze instelling wilt overschrijven, definieert u regels voor titeluitlijning voor afzonderlijke vragen. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau (\"Standaard bovenaan\") toe.",
            descriptionLocation: "De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau toe (\"Standaard onder de paneeltitel\").",
            newPanelPosition: "Definieert de positie van een nieuw toegevoegd deelvenster. Standaard worden er nieuwe panelen aan het einde toegevoegd. Selecteer \"Volgende\" om een nieuw paneel in te voegen na het huidige.",
            defaultValueFromLastPanel: "Dupliceert antwoorden uit het laatste deelvenster en wijst ze toe aan het volgende toegevoegde dynamische deelvenster.",
            keyName: "Verwijs naar een vraagnaam om te vereisen dat een gebruiker in elk deelvenster een uniek antwoord geeft op deze vraag."
        },
        defaultValueExpression: "Met deze instelling kunt u een standaardantwoordwaarde toewijzen op basis van een expressie. De expressie kan basisberekeningen bevatten - '{q1_id} + {q2_id}', Booleaanse expressies, zoals '{age} > 60', en functies: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', enz. De waarde die door deze expressie wordt bepaald, dient als de oorspronkelijke standaardwaarde die kan worden overschreven door de handmatige invoer van een respondent.",
        resetValueIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die bepaalt wanneer de invoer van een respondent wordt teruggezet naar de waarde op basis van de \"Standaardwaarde-expressie\" of \"Waarde-expressie instellen\" of naar de waarde \"Standaardantwoord\" (als een van beide is ingesteld).",
        setValueIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die bepaalt wanneer de expressie 'Waarde instellen' moet worden uitgevoerd en wijs de resulterende waarde dynamisch toe als antwoord.",
        setValueExpression: "Geef een expressie op die de waarde definieert die moet worden ingesteld wanneer aan de voorwaarden in de regel 'Waarde instellen als' wordt voldaan. De expressie kan basisberekeningen bevatten - '{q1_id} + {q2_id}', Booleaanse expressies, zoals '{age} > 60', en functies: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', enz. De waarde die door deze expressie wordt bepaald, kan worden overschreven door de handmatige invoer van een respondent.",
        question: {
            name: "Een vraag-ID die niet zichtbaar is voor respondenten.",
            description: "Typ de ondertitel van een vraag.",
            visibleIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die de zichtbaarheid van de vraag bepaalt.",
            enableIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die de alleen-lezen modus voor de vraag uitschakelt.",
            requiredIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die voorkomt dat de enquête wordt voortgezet of verzonden, tenzij de vraag een antwoord heeft gekregen.",
            startWithNewLine: "Schakel de optie uit om de vraag op één regel weer te geven met de vorige vraag of het vorige deelvenster. De instelling is niet van toepassing als de vraag het eerste element in uw formulier is.",
            page: "Hiermee verplaatst u de vraag naar het einde van een geselecteerde pagina.",
            state: "Kies uit: \"Uitgevouwen\" - het vraagvak wordt volledig weergegeven en kan worden ingeklapt; \"Samengevouwen\" - het vraagvak toont alleen de titel en beschrijving en kan worden uitgevouwen; \"Vergrendeld\" - het vraagvak wordt volledig weergegeven en kan niet worden ingeklapt.",
            titleLocation: "Hiermee worden regels voor titeluitlijning overschreven die zijn gedefinieerd op paneel-, pagina- of enquêteniveau. De optie \"Overnemen\" past alle instellingen op een hoger niveau (indien ingesteld) of instellingen op enquêteniveau (\"Top\" standaard) toe.",
            descriptionLocation: "De optie \"Overnemen\" past de instelling op enquêteniveau toe (\"Standaard onder de vraagtitel\").",
            errorLocation: "Hiermee stelt u de locatie van een foutmelding in ten opzichte van de vraag met ongeldige invoer. Kies tussen: \"Top\" - er wordt een fouttekst bovenaan het vraagvak geplaatst; \"Onderaan\" - er wordt een fouttekst onderaan het vraagvak geplaatst. De optie \"Overnemen\" past de instelling op enquêteniveau toe (\"Top\" standaard).",
            indent: "Hiermee voegt u ruimte of marge toe tussen de inhoud van de vraag en de linkerrand van het vraagvak.",
            width: "Hiermee stelt u de breedte van de vraag in verhouding tot andere enquête-elementen in dezelfde regel. Accepteert CSS-waarden (px, %, in, pt, enz.).",
            surveyvalidator: {
                expression: "Gebruik het toverstafpictogram om een validatieregel voor de vraag in te stellen."
            },
            textUpdateMode: "Kies uit: \"Bij verloren focus\" - de waarde wordt bijgewerkt wanneer het invoerveld de focus verliest; \"Tijdens het typen\" - de waarde wordt in realtime bijgewerkt, terwijl gebruikers typen. Met de optie \"Overerven\" wordt de instelling op enquêteniveau toegepast (\"Standaard bij verloren focus\").",
            url: "U kunt elke webservice gebruiken als gegevensbron voor meerkeuzevragen. Als u keuzewaarden wilt invullen, voert u de URL in van de service die de gegevens levert.",
            searchMode: "Een vergelijkingsbewerking die wordt gebruikt om de vervolgkeuzelijst te filteren.",
            textWrapEnabled: "Lange teksten in keuze-opties genereren automatisch regeleinden die in het vervolgkeuzemenu passen. Schakel de selectie uit als u wilt dat de teksten worden afgekapt."
        },
        signaturepad: {
            signatureWidth: "Hiermee stelt u de breedte van het weergegeven handtekeninggebied en de resulterende afbeelding in.",
            signatureHeight: "Hiermee stelt u de hoogte in van het weergegeven handtekeninggebied en de resulterende afbeelding.",
            signatureAutoScaleEnabled: "Selecteer of u wilt dat het handtekeninggebied alle beschikbare ruimte in het vraagvak vult met behoud van de standaardverhouding van 3:2. Wanneer aangepaste breedte- en hoogtewaarden zijn ingesteld, blijft de hoogte-breedteverhouding van deze afmetingen behouden."
        },
        file: {
            imageHeight: "Hiermee past u de hoogte van de afbeelding in de enquêteresultaten aan.",
            imageWidth: "Hiermee past u de breedte van de afbeelding in de enquêteresultaten aan."
        },
        image: {
            contentMode: "De optie \"Auto\" bepaalt automatisch de geschikte modus voor weergave - Afbeelding, Video of YouTube - op basis van de opgegeven bron-URL."
        },
        imagepicker: {
            imageHeight: "Hiermee worden de minimum- en maximumhoogtewaarden overschreven.",
            imageWidth: "Hiermee worden de waarden voor de minimum- en maximumbreedte overschreven.",
            choices: "\"Waarde\" dient als een item-ID die wordt gebruikt in voorwaardelijke regels; \"Tekst\" wordt getoond aan respondenten.",
            contentMode: "Kies tussen \"Afbeelding\" en \"Video\" om de inhoudsmodus van de mediakiezer in te stellen. Als \"Afbeelding\" is geselecteerd, zorg er dan voor dat alle beschikbare opties afbeeldingsbestanden zijn in de volgende formaten: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Evenzo, als \"Video\" is geselecteerd, zorg er dan voor dat alle opties directe links zijn naar videobestanden in de volgende formaten: MP4, MOV, WMV, FLV, AVI, MKV. Houd er rekening mee dat YouTube-links niet worden ondersteund voor video-opties."
        },
        text: {
            size: "Deze instelling wijzigt alleen de grootte van het invoerveld en heeft geen invloed op de breedte van het vraagvak. Als u de geaccepteerde invoerlengte wilt beperken, gaat u naar <b>Validatie → Maximale tekenlimiet</b>."
        },
        comment: {
            rows: "Hiermee stelt u het aantal weergegeven regels in het invoerveld in. Als de invoer meer regels in beslag neemt, verschijnt de schuifbalk."
        },
        // survey templates
        survey: {
            mode: "Kies tussen: \"Bewerkbaar\" - stelt respondenten in staat uw enquête in te vullen; \"Alleen-lezen\" - schakelt het bewerken van formulieren uit."
        },
        matrixdropdowncolumn: {
            name: "Een kolom-id die niet zichtbaar is voor respondenten.",
            isUnique: "Als deze optie is ingeschakeld voor een kolom, moet een respondent een uniek antwoord geven voor elke vraag in deze kolom.",
            rows: "Hiermee stelt u het aantal weergegeven regels in het invoerveld in. Als de invoer meer regels in beslag neemt, verschijnt de schuifbalk.",
            visibleIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de zichtbaarheid van de kolom bepaalt.",
            enableIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen waarmee de alleen-lezen modus voor de kolom wordt uitgeschakeld.",
            requiredIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die het verzenden van enquêtes verhindert, tenzij ten minste één geneste vraag een antwoord heeft.",
            showInMultipleColumns: "Als deze optie is geselecteerd, wordt er een afzonderlijke kolom gemaakt voor elke keuzeoptie."
        },
        widthMode: "Kies uit: \"Statisch\" - stelt een vaste breedte in; \"Responsief\" - zorgt ervoor dat de enquête de volledige breedte van het scherm in beslag neemt; \"Auto\" - past een van de twee toe, afhankelijk van de gebruikte vraagtypen.",
        cookieName: "Cookies voorkomen dat gebruikers dezelfde enquête twee keer invullen.",
        logo: "Plak een afbeeldingslink (geen maximale grootte) of klik op het mappictogram om door een bestand vanaf uw computer te bladeren (maximaal 64 KB).",
        logoWidth: "Hiermee stelt u de breedte van het logo in CSS-eenheden in (px, %, in, pt, enz.).",
        logoHeight: "Hiermee stelt u de hoogte van een logo in CSS-eenheden in (px, %, in, pt, enz.).",
        logoFit: "Kies uit: \"Geen\" - afbeelding behoudt zijn oorspronkelijke grootte; \"Bevatten\" - het formaat van de afbeelding wordt aangepast aan de beeldverhouding met behoud van de beeldverhouding; \"Omslag\" - afbeelding vult het hele vak met behoud van de beeldverhouding; \"Vullen\" - de afbeelding wordt uitgerekt om het vak te vullen zonder de beeldverhouding te behouden.",
        goNextPageAutomatic: "Selecteer of u wilt dat de enquête automatisch naar de volgende pagina wordt verplaatst nadat een respondent alle vragen op de huidige pagina heeft beantwoord.",
        allowCompleteSurveyAutomatic: "Selecteer of u wilt dat de enquête automatisch wordt ingevuld nadat een respondent alle vragen heeft beantwoord.",
        showNavigationButtons: "Hiermee stelt u de zichtbaarheid en locatie van navigatieknoppen op een pagina in.",
        showProgressBar: "Hiermee stelt u de zichtbaarheid en locatie van een voortgangsbalk in. De waarde \"Auto\" geeft de voortgangsbalk boven of onder de kop van de enquête weer.",
        showPreviewBeforeComplete: "Schakel de voorbeeldpagina in met alleen alle of beantwoorde vragen.",
        questionTitleLocation: "Geldt voor alle vragen in de enquête. Deze instelling kan worden overschreven door regels voor titeluitlijning op lagere niveaus: deelvenster, pagina of vraag. Een instelling op een lager niveau heeft voorrang op die op een hoger niveau.",
        requiredText: "Een symbool of een reeks symbolen die aangeven dat een antwoord vereist is.",
        questionStartIndex: "Voer een cijfer of letter in waarmee u wilt beginnen met nummeren.",
        questionErrorLocation: "Hiermee stelt u de locatie van een foutmelding in ten opzichte van de vraag met ongeldige invoer. Kies tussen: \"Top\" - er wordt een fouttekst bovenaan het vraagvak geplaatst; \"Onderaan\" - er wordt een fouttekst onderaan het vraagvak geplaatst.",
        focusFirstQuestionAutomatic: "Selecteer of u het eerste invoerveld op elke pagina klaar wilt maken voor tekstinvoer.",
        questionsOrder: "Behoudt de oorspronkelijke volgorde van vragen of maakt ze willekeurig. Het effect van deze instelling is alleen zichtbaar op het tabblad Voorbeeld.",
        maxTextLength: "Alleen voor vragen over tekstinvoer.",
        maxOthersLength: "Alleen voor opmerkingen over vragen.",
        commentAreaRows: "Hiermee stelt u het aantal weergegeven regels in tekstgebieden in voor opmerkingen bij vragen. In de invoer neemt meer regels in beslag, de schuifbalk verschijnt.",
        autoGrowComment: "Selecteer of u wilt dat vraagopmerkingen en lange tekstvragen automatisch in hoogte groeien op basis van de ingevoerde tekstlengte.",
        allowResizeComment: "Alleen voor vraagopmerkingen en lange tekstvragen.",
        calculatedValues: "Aangepaste variabelen dienen als tussenliggende of hulpvariabelen die worden gebruikt in formulierberekeningen. Ze nemen de input van respondenten als bronwaarden. Elke aangepaste variabele heeft een unieke naam en een expressie waarop deze is gebaseerd.",
        includeIntoResult: "Selecteer of u wilt dat de berekende waarde van de expressie samen met de enquêteresultaten wordt opgeslagen.",
        triggers: "Een trigger is een gebeurtenis of voorwaarde die is gebaseerd op een expressie. Zodra de expressie is geëvalueerd naar 'waar', wordt een actie geactiveerd door een trigger. Zo'n actie kan optioneel een doelvraag hebben die het beïnvloedt.",
        clearInvisibleValues: "Kies of u de waarden wilt wissen voor vragen die verborgen zijn door voorwaardelijke logica en wanneer u dit wilt doen.",
        textUpdateMode: "Kies uit: \"Bij verloren focus\" - de waarde wordt bijgewerkt wanneer het invoerveld de focus verliest; \"Tijdens het typen\" - de waarde wordt in realtime bijgewerkt, terwijl gebruikers typen.",
        columns: "De linkerwaarde dient als een kolom-ID die wordt gebruikt in voorwaardelijke regels, de rechterwaarde wordt weergegeven aan respondenten.",
        rows: "De linkerwaarde dient als een rij-ID die wordt gebruikt in voorwaardelijke regels, de rechterwaarde wordt weergegeven aan respondenten.",
        columnMinWidth: "Accepteert CSS-waarden (px, %, in, pt, enz.).",
        rowTitleWidth: "Accepteert CSS-waarden (px, %, in, pt, enz.).",
        totalText: "Alleen zichtbaar als ten minste één kolom het type Totaal of de expressie Totaal heeft.",
        cellErrorLocation: "Hiermee stelt u de locatie van een foutbericht in ten opzichte van een cel met ongeldige invoer. Met de optie 'Overerven' wordt de instelling van de eigenschap 'Uitlijning van foutberichten' toegepast.",
        keyDuplicationError: "Wanneer de eigenschap 'Dubbele antwoorden voorkomen' is ingeschakeld, ontvangt een respondent die een dubbele vermelding probeert in te dienen, het volgende foutbericht.",
        totalExpression: "Hiermee kunt u totale waarden berekenen op basis van een expressie. De expressie kan basisberekeningen ('{q1_id} + {q2_id}'), Booleaanse expressies ('{age} > 60') en functies ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.) bevatten.",
        confirmDelete: "Hiermee wordt gevraagd om het verwijderen van de rij te bevestigen.",
        defaultValueFromLastRow: "Dupliceert antwoorden uit de laatste rij en wijst ze toe aan de volgende toegevoegde dynamische rij.",
        keyName: "Als de opgegeven kolom identieke waarden bevat, genereert de enquête de fout 'Niet-unieke sleutelwaarde'.",
        description: "Typ een ondertitel.",
        locale: "Kies een taal om te beginnen met het maken van uw enquête. Als u een vertaling wilt toevoegen, schakelt u over naar een nieuwe taal en vertaalt u de originele tekst hier of op het tabblad Vertalingen.",
        detailPanelMode: "Hiermee stelt u de locatie van een detailsectie ten opzichte van een rij in. Kies uit: \"Geen\" - er wordt geen uitbreiding toegevoegd; \"Onder de rij\" - onder elke rij van de matrix wordt een rij-uitbreiding geplaatst; \"Onder de rij, slechts één rij-uitbreiding weergeven\" - een uitbreiding wordt alleen onder een enkele rij weergegeven, de resterende rij-uitbreidingen zijn samengevouwen.",
        imageFit: "Kies uit: \"Geen\" - afbeelding behoudt zijn oorspronkelijke grootte; \"Bevatten\" - het formaat van de afbeelding wordt aangepast aan de beeldverhouding met behoud van de beeldverhouding; \"Omslag\" - afbeelding vult het hele vak met behoud van de beeldverhouding; \"Vullen\" - de afbeelding wordt uitgerekt om het vak te vullen zonder de beeldverhouding te behouden.",
        autoGrow: "Verhoogt geleidelijk de hoogte van het invoerveld terwijl gegevens worden ingevoerd. Hiermee wordt de instelling \"Invoerveldhoogte (in lijnen)\" overschreven.",
        allowResize: "De formaatgreep (of greep) verschijnt in de hoek en kan worden gesleept om de grootte van het invoerveld te wijzigen.",
        maxTimeToFinish: "Een tijdsinterval in seconden, waarna de enquête automatisch doorgaat naar de bedankpagina.",
        maxTimeToFinishPage: "Een tijdsinterval in seconden, waarna de enquête automatisch doorgaat naar de volgende pagina.",
        page: {
            maxTimeToFinish: "Een tijdsinterval in seconden, waarna de enquête automatisch doorgaat naar de volgende pagina.",
            visibleIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die de zichtbaarheid van de pagina bepaalt.",
            enableIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen waarmee de alleen-lezen modus voor de pagina wordt uitgeschakeld.",
            requiredIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die het verzenden van enquêtes verhindert, tenzij ten minste één geneste vraag een antwoord heeft.",
            questionTitleLocation: "Geldt voor alle vragen op deze pagina. Als je deze instelling wilt overschrijven, definieer je regels voor titeluitlijning voor afzonderlijke vragen of panelen. De optie \"Overnemen\" past de instelling op enquêteniveau toe (\"Top\" standaard).",
            questionTitleWidth: "Hiermee stelt u een consistente breedte in voor vraagtitels wanneer deze links van de vraagvakken zijn uitgelijnd. Accepteert CSS-waarden (px, %, in, pt, enz.).",
            questionErrorLocation: "Hiermee stelt u de locatie van een foutmelding in ten opzichte van de vraag met ongeldige invoer. Kies tussen: \"Top\" - er wordt een fouttekst bovenaan het vraagvak geplaatst; \"Onderaan\" - er wordt een fouttekst onderaan het vraagvak geplaatst. De optie \"Overnemen\" past de instelling op enquêteniveau toe (\"Top\" standaard).",
            questionsOrder: "Behoudt de oorspronkelijke volgorde van vragen of maakt ze willekeurig. De optie \"Overerven\" past de instelling op enquêteniveau toe (\"Standaard Origineel\"). Het effect van deze instelling is alleen zichtbaar op het tabblad Voorbeeld.",
            navigationButtonsVisibility: "Hiermee stelt u de zichtbaarheid van navigatieknoppen op de pagina in. De optie \"Overerven\" past de instelling op enquêteniveau toe, die standaard op \"Zichtbaar\" staat."
        },
        showTimerPanel: "Hiermee stelt u de zichtbaarheid en locatie van een timer op een pagina in.",
        panelsState: "Kies uit: \"Vergrendeld\" - gebruikers kunnen panelen niet uitvouwen of samenvouwen; \"Alles samenvouwen\" - alle deelvensters beginnen in een samengevouwen toestand; \"Alles uitvouwen\" - alle deelvensters beginnen in een uitgevouwen staat; \"Eerst uitgevouwen\" - alleen het eerste paneel wordt in eerste instantie uitgevouwen.",
        imageLinkName: "Voer de naam van een gedeelde eigenschap in binnen de matrix met objecten die de URL's van afbeeldings- of videobestanden bevat die u in de keuzelijst wilt weergeven.",
        choices: "De linkerwaarde dient als een item-ID die wordt gebruikt in voorwaardelijke regels, de rechterwaarde wordt weergegeven aan respondenten.",
        title: "Typ een gebruiksvriendelijke titel om weer te geven.",
        waitForUpload: "Zorgt ervoor dat gebruikers de enquête pas invullen als de bestanden zijn geüpload.",
        minWidth: "Accepteert CSS-waarden (px, %, in, pt, enz.).",
        maxWidth: "Accepteert CSS-waarden (px, %, in, pt, enz.).",
        width: "Accepteert CSS-waarden (px, %, in, pt, enz.).",
        valueName: "Als u deze eigenschap niet instelt, wordt het antwoord opgeslagen in een veld dat is opgegeven door de eigenschap Name.",
        useDisplayValuesInDynamicTexts: "In vraagtypen met enkelvoudige en meervoudige selectie heeft elke keuzeoptie een ID en weergavewaarde. Als deze instelling is geselecteerd, wordt een weergavewaarde weergegeven in plaats van een ID-waarde in HTML-vragen en dynamische titels en beschrijvingen van enquête-elementen.",
        clearIfInvisible: "Kies of vraagwaarden die verborgen zijn door voorwaardelijke logica al dan niet moeten worden gewist en wanneer u dit wilt doen. Met de optie \"Overnemen\" wordt de instelling op enquêteniveau toegepast (\"Na voltooiing van de enquête\" standaard).",
        choicesFromQuestionMode: "Kies uit: \"Alle\" - kopieert alle keuzemogelijkheden van de geselecteerde vraag; \"Geselecteerd\" - kopieert dynamisch alleen geselecteerde keuzeopties; \"Niet geselecteerd\" - kopieert dynamisch alleen niet-geselecteerde keuzeopties. De opties \"Geen\" en \"Overig\" worden standaard gekopieerd als deze zijn ingeschakeld in de bronvraag.",
        showOtherItem: "Als deze optie is geselecteerd, kunnen gebruikers extra invoer invullen in een apart invulveld.",
        separateSpecialChoices: "Geeft elke speciale keuzeoptie ('Geen', 'Overig', 'Alles selecteren') weer op een nieuwe regel, zelfs bij gebruik van een lay-out met meerdere kolommen.",
        path: "Geef de locatie binnen de servicegegevensset op waar de doelmatrix met objecten zich bevindt. Laat leeg als de URL al naar de array verwijst.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Voer een uniforme eigenschapsnaam in binnen de matrix met objecten die de waarden bevat die u in de keuzelijst wilt weergeven.",
        allowEmptyResponse: "Selecteer deze optie om toe te staan dat de service een leeg antwoord of een lege matrix retourneert.",
        choicesVisibleIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die de zichtbaarheid van alle keuzeopties bepaalt.",
        rateValues: "De linkerwaarde dient als een item-ID die wordt gebruikt in voorwaardelijke regels, de rechterwaarde wordt weergegeven aan respondenten.",
        rating: {
            displayMode: "\"Auto\" kiest tussen de modi \"Knoppen\" en \"Dropdown\" op basis van de beschikbare breedte. Wanneer de breedte onvoldoende is om knoppen weer te geven, wordt er een dropdown weergegeven in de vraag."
        },
        valuePropertyName: "Hiermee kunt u vragen verbinden die resultaten opleveren in verschillende formaten. Wanneer dergelijke vragen aan elkaar zijn gekoppeld met behulp van een join-id, worden in deze gedeelde eigenschap geselecteerde vraagwaarden opgeslagen.",
        searchEnabled: "Selecteer of u de inhoud van het vervolgkeuzemenu wilt bijwerken zodat deze overeenkomt met de zoekopdracht die een gebruiker in het invoerveld typt.",
        valueTrue: "Een waarde die moet worden opgeslagen in enquêteresultaten wanneer respondenten een positief antwoord geven.",
        valueFalse: "Een waarde die moet worden opgeslagen in enquêteresultaten wanneer respondenten een negatief antwoord geven.",
        showPreview: "Het wordt niet aanbevolen om deze optie uit te schakelen, omdat deze de voorbeeldafbeelding overschrijft en het voor een gebruiker moeilijk maakt om te begrijpen of de bestanden zijn geüpload.",
        needConfirmRemoveFile: "Hiermee wordt een prompt geactiveerd waarin wordt gevraagd om het verwijderen van het bestand te bevestigen.",
        selectToRankEnabled: "Schakel in om alleen geselecteerde keuzes te rangschikken. Gebruikers slepen geselecteerde items uit de keuzelijst om ze binnen het rangschikkingsgebied te rangschikken.",
        dataList: "Voer een lijst met keuzes in die tijdens de invoer aan de respondent worden voorgesteld.",
        itemSize: "De instelling wijzigt alleen de grootte van de invoervelden en heeft geen invloed op de breedte van het vraagvak.",
        itemTitleWidth: "Hiermee stelt u een consistente breedte in voor alle artikellabels in pixels",
        altText: "Dient als vervanging wanneer de afbeelding niet kan worden weergegeven op het apparaat van een gebruiker en voor toegankelijkheidsdoeleinden.",
        rateColorMode: "Definieert de kleur van de geselecteerde emoji wanneer het type Beoordelingspictogram is ingesteld op \"Smileys\". Kies tussen: \"Standaard\" - de geselecteerde emoji verschijnt in de standaard enquêtekleur; \"Schaal\" - de geselecteerde emoji erft de kleur van de beoordelingsschaal.",
        expression: {
            name: "Een expressie-ID die niet zichtbaar is voor respondenten.",
            description: "Typ de ondertitel van een expressie.",
            expression: "Een expressie kan basisberekeningen ('{q1_id} + {q2_id}'), voorwaarden ('{leeftijd} > 60') en functies ('iif()', 'vandaag()', 'leeftijd()', 'min()', 'max()', 'gem()', enz.) bevatten."
        },
        storeOthersAsComment: "Selecteer deze optie om de waarde van de optie 'Overig' op te slaan als een afzonderlijke eigenschap in enquêteresultaten.",
        format: "Gebruik {0} als tijdelijke aanduiding voor de werkelijke waarde.",
        acceptedTypes: "Raadpleeg de beschrijving van het kenmerk [accepteren](https://www.w3schools.com/tags/att_input_accept.asp) voor meer informatie.",
        columnColCount: "Alleen van toepassing op de celtypen Radiogroep en selectievakje.",
        autocomplete: "Raadpleeg de [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) kenmerkbeschrijving voor meer informatie.",
        filePlaceholder: "Van toepassing wanneer \"Brontype\" \"Lokale bestanden\" is of wanneer de camera niet beschikbaar is",
        photoPlaceholder: "Van toepassing wanneer \"Brontype\" \"Camera\" is.",
        fileOrPhotoPlaceholder: "Van toepassing wanneer \"Brontype\" \"Lokale bestanden of camera\" is.",
        masksettings: {
            saveMaskedValue: "Selecteer of u de vraagwaarde met een toegepast masker wilt opslaan in enquêteresultaten."
        },
        patternmask: {
            pattern: "Het patroon kan letterlijke tekenreeksen en de volgende tijdelijke aanduidingen bevatten: '9' - voor een cijfer; \"a\" - voor een hoofdletter of kleine letter; '#' - voor een cijfer of een hoofdletter of kleine letter. Gebruik backslash '\\' om een teken te escapen."
        },
        datetimemask: {
            pattern: "Het patroon kan scheidingstekens en de volgende tijdelijke aanduidingen bevatten:<br>'m' - Maandnummer.<br>'mm' - Maandnummer, met voorloopnul voor eencijferige waarden. <br>'d' - Dag van de maand. <br>'dd' - Dag van de maand, met voorloopnul voor eencijferige waarden. <br>'yy' - De laatste twee cijfers van het jaar. <br>'yyyy' - Viercijferig jaartal. <br>'H' - Uren in 24-uursnotatie. <br>'HH' - Uren in 24-uursnotatie, met voorloopnul voor eencijferige waarden. <br>'h' - Uren in 12-uurs notatie. <br>'hh' - Uren in 12-uursnotatie, met voorloopnul voor eencijferige waarden. <br>\"MM\" - Notulen. <br>'ss' - Seconden. <br>'TT' - 12-uurs kloktijd in hoofdletters (AM/PM). <br>'tt' - 12-uurs kloktijd in kleine letters (am/pm)."
        },
        numericmask: {
            decimalSeparator: "Een symbool dat wordt gebruikt om het fractionele deel te scheiden van het gehele deel van een weergegeven getal.",
            thousandsSeparator: "Een symbool dat wordt gebruikt om de cijfers van een groot getal in groepen van drie te scheiden.",
            precision: "Hiermee beperkt u het aantal cijfers dat moet worden behouden na de komma voor een weergegeven getal."
        },
        currencymask: {
            prefix: "Een of meer symbolen die vóór de waarde moeten worden weergegeven.",
            suffix: "Een of meer symbolen die na de waarde moeten worden weergegeven."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "Titel",
            title: "Laat het leeg als het hetzelfde is als 'Naam'"
        },
        multiSelect: "Meerdere selecties toestaan",
        showLabel: "Afbeeldingsbijschriften weergeven",
        swapOrder: "Verwissel de volgorde van Ja en Nee",
        value: "Waarde",
        tabAlign: "Uitlijning van tabbladen",
        sourceType: "Type bron",
        fitToContainer: "Aanpassen aan container",
        setValueExpression: "Expressie van ingestelde waarde",
        description: "Omschrijving",
        logoFit: "Logo past",
        pages: "Bladzijden",
        questions: "Vragen",
        triggers: "Triggers",
        calculatedValues: "Berekende waarden",
        surveyId: "Enquête-id",
        surveyPostId: "Enquête post-ID",
        surveyShowDataSaving: "Enquête toont gegevensbesparing",
        questionDescriptionLocation: "Plek vraagomschrijving",
        progressBarType: "Type voortgangsbalk",
        showTOC: "Inhoudsopgave weergeven",
        tocLocation: "Toc locatie",
        questionTitlePattern: "Patroon van de vraagtitel",
        widthMode: "Breedte-modus",
        showBrandInfo: "Toon merkinformatie",
        useDisplayValuesInDynamicTexts: "Waardes in titel gebruiken",
        visibleIf: "Zichtbaar als",
        defaultValueExpression: "Standaardwaarde-expressie",
        requiredIf: "Vereist als",
        resetValueIf: "Waarde opnieuw instellen als",
        setValueIf: "Stel de waarde in als",
        validators: "Validators",
        bindings: "Bindings",
        renderAs: "Renderen als",
        attachOriginalItems: "Voeg originele items toe",
        choices: "Keuzes",
        choicesByUrl: "Keuzes per url",
        currency: "Valuta",
        cellHint: "Hint voor cel",
        totalMaximumFractionDigits: "Totaal maximum fractiecijfers",
        totalMinimumFractionDigits: "Totaal minimum breukcijfers",
        columns: "Kolommen",
        detailElements: "Detailelementen",
        allowAdaptiveActions: "Adaptieve acties toestaan",
        defaultRowValue: "Standaard rijwaarde",
        detailPanelShowOnAdding: "Detailpaneel weergeven bij toevoegen",
        choicesLazyLoadEnabled: "Keuzes lazy load ingeschakeld",
        choicesLazyLoadPageSize: "Keuzes lui laad paginaformaat",
        inputFieldComponent: "Component invoerveld",
        itemComponent: "Onderdeel Item",
        min: "Min",
        max: "Max",
        minValueExpression: "Expressie van de min-waarde",
        maxValueExpression: "Maximale waarde-expressie",
        step: "Stap",
        dataList: "Gegevenslijst",
        itemSize: "Item grootte",
        itemTitleWidth: "Breedte artikellabel (in px)",
        elements: "Elementen",
        content: "Tevreden",
        navigationButtonsVisibility: "Navigatie Knoppen zichtbaarheid",
        navigationTitle: "Titel navigatie",
        navigationDescription: "Navigatie beschrijving",
        longTap: "Lange tik",
        autoGrow: "Automatisch groeien",
        allowResize: "Formaat wijzigen toestaan",
        acceptCarriageReturn: "Accepteer retour vervoer",
        displayMode: "Weergavemodus",
        rateType: "Type tarief",
        label: "Etiket",
        contentMode: "Inhoudsmodus",
        imageFit: "Passend bij het beeld",
        altText: "Alternatieve tekst",
        height: "Hoogte",
        penColor: "Kleur van de pen",
        backgroundColor: "Achtergrondkleur",
        templateElements: "Sjabloonelementen",
        operator: "Bediener",
        isVariable: "Is variabel",
        runExpression: "Expressie uitvoeren",
        showCaption: "Toon bijschrift",
        iconName: "Naam van pictogram",
        iconSize: "Pictogramgrootte",
        precision: "Precisie",
        matrixDragHandleArea: "Matrix sleepgreep gebied",
        backgroundImage: "Achtergrondafbeelding",
        backgroundImageFit: "Passend op de achtergrondafbeelding",
        backgroundImageAttachment: "Bijlage bij achtergrondafbeelding",
        backgroundOpacity: "Dekking op de achtergrond",
        selectToRankEnabled: "Selecteer om te rangschikken ingeschakeld",
        selectToRankAreasLayout: "Selecteer om de indeling van gebieden te rangschikken",
        selectToRankEmptyRankedAreaText: "Tekst om aan te geven of alle opties zijn geselecteerd",
        selectToRankEmptyUnrankedAreaText: "Tijdelijke tekst voor het rangschikkingsgebied",
        allowCameraAccess: "Toegang tot de camera toestaan",
        scaleColorMode: "Kleurmodus schalen",
        rateColorMode: "Kleurmodus beoordelen",
        copyDisplayValue: "Weergavewaarde kopiëren",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Geavanceerde modus",
        pageTitle: "Lettertype voor paginatitel",
        questionTitle: "Lettertype voor de titel van de vraag",
        editorPanel: "Invoerelement",
        lines: "Lijnen",
        primaryDefaultColor: "Verstek",
        primaryDarkColor: "Zweven",
        primaryLightColor: "Uitverkoren",
        backgroundDimColor: "Achtergrondkleur",
        cornerRadius: "De straal van de hoek",
        backcolor: "Standaard achtergrond",
        hovercolor: "Achtergrond aanwijzen",
        borderDecoration: "Randdecoratie",
        fontColor: "Tekstkleur",
        backgroundColor: "Achtergrondkleur",
        primaryForecolor: "Standaardkleur",
        primaryForecolorLight: "Uitgeschakelde kleur",
        font: "Lettertype",
        borderDefault: "Donkerder",
        borderLight: "Aansteker",
        fontFamily: "Lettertype familie",
        fontWeightRegular: "Regelmatig",
        fontWeightHeavy: "Zwaar",
        fontWeightSemiBold: "Semi-vet",
        fontWeightBold: "Brutaal",
        color: "Kleur",
        placeholderColor: "Tijdelijke aanduiding voor kleur",
        size: "Grootte",
        opacity: "Dekking",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Schaduweffect toevoegen",
        boxShadowBlur: "Vervagen",
        boxShadowSpread: "Verspreiden",
        boxShadowDrop: "Druppel",
        boxShadowInner: "Binnenste",
        names: {
            default: "Verstek",
            sharp: "Scherp",
            borderless: "Grenzeloos",
            flat: "Plat",
            plain: "Vlakte",
            doubleborder: "Dubbele rand",
            layered: "Gelaagd",
            solid: "Degelijk",
            threedimensional: ".3D",
            contrast: "Tegenstelling"
        },
        colors: {
            teal: "Taling",
            blue: "Blauw",
            purple: "Paars",
            orchid: "Orchidee",
            tulip: "Tulp",
            brown: "Bruin",
            green: "Groen"
        }
    }
};
//Uncomment this line on creating a translation file. You should replace "en" and enStrings with your locale ("fr", "de" and so on) and your variable.
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["nl"] = nlStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// survey.duplicate: "Duplicate" => "Duplicaat"
// qt.ranking: "Ranking" => "Ranking"
// qt.tagbox: "Multi-Select Dropdown" => "Vervolgkeuzemenu voor meerdere selecties"
// qt.buttongroup: "Button Group" => "Knoppengroep"
// ed.surveySettings: "Survey Settings" => "Enquête-instellingen"
// ed.surveySettingsTooltip: "Open survey settings" => "Enquête-instellingen openen"
// ed.prevSelected: "Select previous" => "Selecteer vorige"
// ed.nextSelected: "Select next" => "Selecteer volgende"
// ed.surveyTypeName: "Survey" => "Enquête"
// ed.pageTypeName: "Page" => "Bladzijde"
// ed.panelTypeName: "Panel" => "Paneel"
// ed.questionTypeName: "Question" => "Vraag"
// ed.columnTypeName: "Column" => "Kolom"
// ed.themeSurvey: "Themes" => "Thema 's"
// ed.defaultV2Theme: "Default" => "Verstek"
// ed.modernTheme: "Modern" => "Modern"
// ed.defaultTheme: "Default (legacy)" => "Standaard (verouderd)"
// ed.jsonHideErrors: "Hide errors" => "Fouten verbergen"
// ed.jsonShowErrors: "Show errors" => "Toon fouten"
// ed.showMoreChoices: "Show more" => "Toon meer"
// ed.showLessChoices: "Show less" => "Toon minder"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "Typ om te zoeken..."
// ed.toolboxChoiceCategory: "Choice Questions" => "Keuzevragen"
// ed.toolboxTextCategory: "Text Input Questions" => "Vragen over tekstinvoer"
// ed.toolboxContainersCategory: "Containers" => "Containers"
// ed.toolboxMatrixCategory: "Matrix Questions" => "Matrix vragen"
// ed.toolboxMiscCategory: "Misc" => "MISC"
// ed.translationPropertyGridTitle: "Language Settings" => "Taalinstellingen"
// ed.themePropertyGridTitle: "Theme Settings" => "Thema-instellingen"
// ed.translationLanguages: "Languages" => "Talen"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "Alleen gebruikte tekenreeksen"
// ed.translationPlaceHolder: "Translation..." => "Vertaling..."
// ed.themeExportButton: "Export" => "Exporteren"
// ed.themeImportButton: "Import" => "Importeren"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Keuzes worden gekopieerd van"
// ed.htmlPlaceHolder: "HTML content will be here." => "HTML-inhoud zal hier zijn."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "Drop hier een vraag uit de toolbox."
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "De enquête is leeg. Sleep een element uit de gereedschapskist of klik op de onderstaande knop."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Sleep een afbeelding hierheen of klik op de onderstaande knop en kies een afbeelding om te uploaden"
// ed.imageChooseImage: "Choose Image" => "Kies afbeelding"
// ed.addNewTypeQuestion: "Add {0}" => "Voeg {0} toe"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[LOGO]"
// ed.auto: "auto" => "Auto"
// ed.choices_Item: "Item " => "Item "
// lg.addNewItem: "Add New Rule" => "Nieuwe regel toevoegen"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "Maak een regel om de stroom van de enquête aan te passen."
// lg.page_enableName: "Enable (disable) page" => "Pagina inschakelen (uitschakelen)"
// lg.column_visibilityName: "Show (hide) column" => "Kolom weergeven (verbergen)"
// lg.column_enableName: "Enable (disable) column" => "Kolom Inschakelen (uitschakelen)"
// lg.column_requireName: "Make column required" => "Kolom verplicht maken"
// lg.itemEmptyExpressionText: "New rule" => "Nieuwe regel"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "Kolom {0} van vraag {1} zichtbaar maken"
// lg.column_enableText: "make column {0} of question {1} enable" => "Kolom {0} van vraag maken {1} inschakelen"
// lg.column_requireText: "make column {0} of question {1} required" => "Kolom {0} met vraag {1} verplicht maken"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "verwijder vraagwaarde: {0}"
// lg.showAllQuestions: "All Questions" => "Alle vragen"
// lg.showAllActionTypes: "All Action Types" => "Alle actietypen"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Logische regels zijn onvolledig"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "U hebt een aantal van de logische regels niet voltooid. Als u het tabblad nu verlaat, gaan de wijzigingen verloren. Wilt u het tabblad nog steeds verlaten zonder de wijzigingen te voltooien?"
// lg.uncompletedRule_apply: "Yes" => "Ja"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Nee, ik wil de regels invullen"
// pe.clear: "Clear" => "Verwijder alles"
// pe.set: "Set" => "Set"
// pe.change: "Change" => "Veranderen"
// pe.close: "Close" => "Sluiten"
// pe.removeItem: "Click to remove the item..." => "Klik om het item te verwijderen..."
// pe.dragItem: "Drag the item" => "Sleep het item"
// pe.doneEditing: "Done" => "Klaar"
// pe.emptyValue: "Value is empty" => "Waarde is leeg"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "Waarde '{0}' is niet uniek"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "Beperk het aantal objecten van {0} tot {1}"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "U kunt gegevens instellen in de volgende indeling:\nwaarde1|tekst\nwaarde2"
// pe.overridingPropertyPrefix: "Set by " => "Ingesteld door "
// pe.propertyIsNoUnique: "Please enter a unique value" => "Voer een unieke waarde in"
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Gebruik geen gereserveerde woorden: \"item\", \"keuze\", \"paneel\", \"rij\"."
// pe.listIsEmpty@choices: "No choices have been added yet" => "Er zijn nog geen keuzes toegevoegd"
// pe.addNew@choices: "Add a choice" => "Een keuze toevoegen"
// choicesbyurl.valueName: "Get values from the following JSON field" => "Haal waarden op uit het volgende JSON-veld"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "Afbeeldings-URL's ophalen uit het volgende JSON-veld"
// pe.and: "and" => "en"
// pe.or: "or" => "of"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Selecteer een vraag om te beginnen met het configureren van voorwaarden."
// pe.if: "If" => "Als"
// pe.then: "then" => "dan"
// pe.setToName: "Target question" => "Doelvraag"
// pe.fromName: "Question to copy answer from" => "Vraag om het antwoord van te kopiëren"
// pe.gotoName: "Question to skip to" => "Vraag om naar over te slaan"
// pe.ruleIsNotSet: "Rule is incorrect" => "Regel is onjuist"
// pe.includeIntoResult: "Include into survey results" => "Opnemen in enquêteresultaten"
// pe.portraitOrientation: "Switch to portrait orientation" => "Overschakelen naar staande stand"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Afbeeldingshoogte (in css-geaccepteerde waarden)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Afbeeldingsbreedte (in css-geaccepteerde waarden)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "Tijdslimiet om de pagina te voltooien (in seconden)"
// question.page: "Parent page" => "Bovenliggende pagina"
// pe.noEntriesText: "Empty entries text" => "Lege invoertekst"
// pe.setValue: "Answer" => "Antwoorden"
// pe.dataFormat: "Image format" => "Beeldformaat"
// pe.allowAddRows: "Allow adding rows" => "Het toevoegen van rijen toestaan"
// pe.allowRemoveRows: "Allow removing rows" => "Het verwijderen van rijen toestaan"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "Rij slepen en neerzetten toestaan"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "Is niet van toepassing als u de exacte breedte of hoogte van de afbeelding opgeeft."
// pe.minImageWidth: "Minimum image width" => "Minimale afbeeldingsbreedte"
// pe.maxImageWidth: "Maximum image width" => "Maximale afbeeldingsbreedte"
// pe.minImageHeight: "Minimum image height" => "Minimale beeldhoogte"
// pe.maxImageHeight: "Maximum image height" => "Maximale beeldhoogte"
// surveyvalidator.text: "Error message" => "Foutmelding"
// surveyvalidator.expression: "Validation expression" => "Validatie-expressie"
// pe.logo: "Logo (URL or base64-encoded string)" => "Logo (URL of base64-gecodeerde tekenreeks)"
// pe.questionsOnPageMode: "Survey structure" => "Structuur van de enquête"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "Commentaargebied indien nodig automatisch uitvouwen"
// pe.allowResizeComment: "Allow users to resize text areas" => "Gebruikers toestaan het formaat van tekstgebieden te wijzigen"
// pe.checkErrorsMode: "Run validation" => "Validatie uitvoeren"
// pe.navigateToUrl: "Navigate to URL" => "Navigeer naar URL"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "Dynamische URL"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "Markering om aan te geven of de gebruiker deze enquête al heeft ingevuld"
// pe.completedHtml: "Survey Complete page markup" => "Paginaopmaak voor voltooide enquête"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "Dynamische enquête volledige paginaopmaak"
// pe.loadingHtml: "Markup to show while survey model is loading" => "Markeringen om weer te geven terwijl het enquêtemodel wordt geladen"
// pe.commentText: "Comment area text" => "Tekst in het commentaargebied"
// pe.autocomplete: "Autocomplete type" => "Type Automatisch aanvullen"
// pe.labelTrue: "\"True\" label" => "Label \"Waar\""
// pe.labelFalse: "\"False\" label" => "Label 'Onwaar'"
// pe.allowClear: "Show the Clear button" => "De knop Wissen weergeven"
// pe.displayStyle: "Value display style" => "Waarde weergavestijl"
// pe.format: "Formatted string" => "Opgemaakte tekenreeks"
// pe.maximumFractionDigits: "Maximum fractional digits" => "Maximum fractionele cijfers"
// pe.minimumFractionDigits: "Minimum fractional digits" => "Minimale fractionele cijfers"
// pe.useGrouping: "Display grouping separators" => "Scheidingstekens voor groeperingen weergeven"
// pe.allowMultiple: "Allow multiple files" => "Meerdere bestanden toestaan"
// pe.allowImagesPreview: "Preview images" => "Afbeeldingen bekijken"
// pe.acceptedTypes: "Accepted file types" => "Geaccepteerde bestandstypen"
// pe.waitForUpload: "Wait for the upload to complete" => "Wacht tot het uploaden is voltooid"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "Bevestig het verwijderen van bestanden"
// pe.detailPanelMode: "Detail panel location" => "Locatie van het detailpaneel"
// pe.minRowCount: "Minimum row count" => "Minimaal aantal rijen"
// pe.maxRowCount: "Maximum row count" => "Maximaal aantal rijen"
// pe.confirmDelete: "Confirm row deletion" => "Rijverwijdering bevestigen"
// pe.confirmDeleteText: "Confirmation message" => "Bevestigingsbericht"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "Het verwijderen van het deelvenster bevestigen"
// pe.panelCount: "Initial panel count" => "Initiële paneeltelling"
// pe.minPanelCount: "Minimum panel count" => "Minimaal aantal panelen"
// pe.maxPanelCount: "Maximum panel count" => "Maximaal aantal panelen"
// pe.panelsState: "Inner panel expand state" => "Uitvouwstatus binnenpaneel"
// pe.templateDescription: "Description template" => "Beschrijving sjabloon"
// pe.templateTitle: "Title template" => "Titel sjabloon"
// pe.panelPrevText: "Previous Panel button tooltip" => "Knopinfo vorige deelvensterknop"
// pe.panelNextText: "Next Panel button tooltip" => "knopinfo voor het volgende deelvenster"
// pe.showRangeInProgress: "Show progress bar" => "Voortgangsbalk weergeven"
// pe.templateTitleLocation: "Question title location" => "Locatie van de vraagtitel"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "Locatie van de knop Deelvenster verwijderen"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "Verberg de vraag als er geen rijen zijn"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Kolommen verbergen als er geen rijen zijn"
// pe.rateValues: "Custom rate values" => "Aangepaste tariefwaarden"
// pe.rateCount: "Rate count" => "Aantal tarieven"
// pe.autoGenerate: "How to specify rate values?" => "Hoe geef ik tariefwaarden op?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "Verberg de vraag als deze geen keuzes bevat"
// pe.hideNumber: "Hide question number" => "Verberg vraagnummer"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Minimale breedte (in css-geaccepteerde waarden)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Maximale breedte (in css-geaccepteerde waarden)"
// pe.width: "Width (in CSS-accepted values)" => "Breedte (in CSS-geaccepteerde waarden)"
// pe.showHeader: "Show column headers" => "Kolomkoppen weergeven"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Horizontale schuifbalk weergeven"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Minimale kolombreedte (in css-geaccepteerde waarden)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Breedte van rijkoptekst (in css-geaccepteerde waarden)"
// pe.valueTrue: "\"True\" value" => "Waarde 'Waar'"
// pe.valueFalse: "\"False\" value" => "Waarde 'Onwaar'"
// pe.minErrorText: "\"Value is below minimum\" error message" => "Foutbericht 'Waarde is onder het minimum'"
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "Foutbericht 'Waarde overschrijdt maximum'"
// pe.otherErrorText: "\"Empty comment\" error message" => "Foutbericht 'Lege opmerking'"
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "Foutbericht 'Niet-unieke sleutelwaarde'"
// pe.minSelectedChoices: "Minimum selected choices" => "Minimaal geselecteerde keuzes"
// pe.maxSelectedChoices: "Maximum selected choices" => "Maximum aantal geselecteerde keuzes"
// pe.showClearButton: "Show the Clear button" => "De knop Wissen weergeven"
// pe.showNumber: "Show panel number" => "Toon paneelnummer"
// pe.readOnly: "Read-only" => "Alleen-lezen"
// pe.enableIf: "Editable if" => "Bewerkbaar als"
// pe.emptyRowsText: "\"No rows\" message" => "Bericht 'Geen rijen'"
// pe.size: "Input field size (in characters)" => "Grootte invoerveld (in tekens)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "Speciale keuzes afzonderlijk (Geen, Overig, Alles selecteren)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Kopieer keuzes uit de volgende vraag"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Welke keuzes kopiëren?"
// pe.showCommentArea: "Show the comment area" => "Het opmerkingenveld weergeven"
// pe.commentPlaceholder: "Comment area placeholder" => "Tijdelijke aanduiding voor het opmerkingengebied"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Beschrijvingen van tarieven weergeven als extreme waarden"
// pe.rowsOrder: "Row order" => "Rijvolgorde"
// pe.columnsLayout: "Column layout" => "Kolomindeling"
// pe.columnColCount: "Nested column count" => "Aantal geneste kolommen"
// pe.state: "Panel expand state" => "Uitvouwstatus deelvenster"
// pe.correctAnswer: "Correct Answer" => "Juist antwoord"
// pe.defaultPanelValue: "Default Values" => "Standaardwaarden"
// pe.cells: "Cell Texts" => "Celteksten"
// pe.keyName: "Key column" => "Sleutelkolom"
// itemvalue.text: "Alt text" => "Alternatieve tekst"
// tabs.expression: "Expression" => "Uitdrukking"
// pe.choicesVisibleIf: "Choices are visible if" => "Keuzes zijn zichtbaar als"
// pe.choicesEnableIf: "Choices are selectable if" => "Keuzes kunnen worden geselecteerd als"
// pe.columnsEnableIf: "Columns are visible if" => "Kolommen zijn zichtbaar als"
// pe.rowsEnableIf: "Rows are visible if" => "Rijen zijn zichtbaar als"
// pe.indent: "Add indents" => "Inspringingen toevoegen"
// panel.indent: "Add outer indents" => "Buitenste streepjes toevoegen"
// pe.innerIndent: "Add inner indents" => "Binnenste inspringingen toevoegen"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "Standaardwaarden uit de laatste rij nemen"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "Standaardwaarden uit het laatste deelvenster overnemen"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "Typ hier expressie..."
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "Wis de waarde als de vraag verborgen wordt"
// pe.valuePropertyName: "Value property name" => "Naam van de eigenschap Value"
// pe.searchEnabled: "Enable search" => "Zoeken inschakelen"
// pe.hideSelectedItems: "Hide selected items" => "Geselecteerde items verbergen"
// pe.closeOnSelect: "Close the dropdown after selection" => "Sluit de vervolgkeuzelijst na selectie"
// pe.signatureWidth: "Signature width" => "Breedte handtekening"
// pe.signatureHeight: "Signature height" => "Kenmerkende hoogte"
// pe.verticalAlign: "Vertical alignment" => "Verticale uitlijning"
// pe.alternateRows: "Alternate rows" => "Alternatieve rijen"
// pe.columnsVisibleIf: "Columns are visible if" => "Kolommen zijn zichtbaar als"
// pe.rowsVisibleIf: "Rows are visible if" => "Rijen zijn zichtbaar als"
// pe.otherPlaceholder: "Comment area placeholder" => "Tijdelijke aanduiding voor het opmerkingengebied"
// pe.rateType: "Rate type" => "Type tarief"
// pv.true: "true" => "waar"
// pv.false: "false" => "vals"
// pv.decimal: "decimal" => "decimaal"
// pv.currency: "currency" => "valuta"
// pv.percent: "percent" => "procent"
// pv.onpanel: "Start on each panel" => "Begin op elk paneel"
// pv.tab: "Tabs" => "Tabs"
// pv.color: "color" => "Kleur"
// pv.date: "date" => "datum"
// pv.datetime: "datetime" => "datetime"
// pv.datetime-local: "datetime-local" => "datetime-lokaal"
// pv.email: "email" => "E-mail"
// pv.month: "month" => "maand"
// pv.number: "number" => "getal"
// pv.password: "password" => "wachtwoord"
// pv.range: "range" => "bereik"
// pv.tel: "tel" => "Tel"
// pv.text: "text" => "Sms"
// pv.time: "time" => "Tijd"
// pv.url: "url" => "Url"
// pv.week: "week" => "week"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "Wanneer de vraag of het bijbehorende paneel/de bijbehorende pagina verborgen raakt"
// clearInvisibleValues.none: "Never" => "Nooit"
// inputType.color: "Color" => "Kleur"
// inputType.date: "Date" => "Datum"
// inputType.datetime-local: "Date and Time" => "Datum en tijd"
// inputType.email: "Email" => "E-mail"
// inputType.month: "Month" => "Maand"
// inputType.number: "Number" => "Getal"
// inputType.password: "Password" => "Wachtwoord"
// inputType.range: "Range" => "Bereik"
// inputType.tel: "Phone Number" => "Telefoonnummer"
// inputType.text: "Text" => "Sms"
// inputType.time: "Time" => "Tijd"
// inputType.url: "URL" => "Url"
// inputType.week: "Week" => "Week"
// pv.onValueChanging: "Before an answer is changed" => "Voordat een antwoord wordt gewijzigd"
// pv.pages: "Completed pages" => "Voltooide pagina's"
// pv.questions: "Answered questions" => "Beantwoorde vragen"
// pv.requiredQuestions: "Answered required questions" => "Vereiste vragen beantwoord"
// pv.correctQuestions: "Valid answers" => "Geldige antwoorden"
// pv.buttons: "Completed pages (button UI)" => "Voltooide pagina's (knop UI)"
// pv.underRow: "Under the row" => "Onder de rij"
// pv.underRowSingle: "Under the row, only one panel is visible" => "Onder de rij is slechts één paneel zichtbaar"
// showNavigationButtons.none: "Hidden" => "Verborgen"
// showProgressBar.off: "Hidden" => "Verborgen"
// showTimerPanel.none: "Hidden" => "Verborgen"
// showTimerPanelMode.all: "Both" => "Beide"
// detailPanelMode.none: "Hidden" => "Verborgen"
// addRowLocation.default: "Depends on matrix layout" => "Afhankelijk van de matrixindeling"
// panelsState.default: "Users cannot expand or collapse panels" => "Gebruikers kunnen deelvensters niet uitvouwen of samenvouwen"
// panelsState.collapsed: "All panels are collapsed" => "Alle panelen zijn samengevouwen"
// panelsState.expanded: "All panels are expanded" => "Alle panelen zijn uitgebreid"
// widthMode.auto: "Auto" => "Auto"
// widthMode.static: "Static" => "Statisch"
// widthMode.responsive: "Responsive" => "Responsieve"
// imageFit.none: "None" => "Geen"
// imageFit.contain: "Contain" => "Bevatten"
// imageFit.cover: "Cover" => "Bedekken"
// imageFit.fill: "Fill" => "Vullen"
// contentMode.auto: "Auto" => "Auto"
// contentMode.image: "Image" => "Beeld"
// contentMode.video: "Video" => "Video"
// contentMode.youtube: "YouTube" => "YouTube"
// displayMode.auto: "Auto" => "Auto"
// displayMode.buttons: "Buttons" => "Knopen"
// displayMode.dropdown: "Dropdown" => "Vervolgkeuzemenu"
// rateColorMode.default: "Default" => "Verstek"
// autoGenerate.true: "Generate" => "Genereren"
// autoGenerate.false: "Enter manually" => "Handmatig invoeren"
// rateType.labels: "Labels" => "Etiketten"
// rateType.stars: "Stars" => "Sterren"
// rateType.smileys: "Smileys" => "Smileys"
// op.and: "and" => "en"
// op.or: "or" => "of"
// ts.hideInvisibleElements: "Hide invisible elements" => "Onzichtbare elementen verbergen"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Cookies voorkomen dat gebruikers dezelfde enquête twee keer invullen."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Hiermee wijzigt u het formaat van het zichtbare gebied van het invoerveld. Gebruik de instelling <b>Validatie → Maximale lengte</b> om de invoerlengte te beperken."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Gebruik {0} als tijdelijke aanduiding voor de werkelijke waarde."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Alleen zichtbaar als ten minste één kolom het type Totaal of de expressie Totaal heeft."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Raadpleeg de beschrijving van het kenmerk [accepteren](https://www.w3schools.com/tags/att_input_accept.asp) voor meer informatie."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Alleen van toepassing op de celtypen Radiogroep en selectievakje."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Raadpleeg de [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) kenmerkbeschrijving voor meer informatie."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Als u deze eigenschap niet instelt, wordt het antwoord opgeslagen in een veld dat is opgegeven door de eigenschap Name."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Als de opgegeven kolom identieke waarden bevat, genereert de enquête de fout 'Niet-unieke sleutelwaarde'."
// p.multiSelect: "Allow multiple selection" => "Meerdere selecties toestaan"
// p.showLabel: "Show image captions" => "Afbeeldingsbijschriften weergeven"
// p.value: "Value" => "Waarde"
// p.tabAlign: "Tab alignment" => "Uitlijning van tabbladen"
// p.logoFit: "Logo fit" => "Logo past"
// p.pages: "Pages" => "Bladzijden"
// p.questions: "Questions" => "Vragen"
// p.calculatedValues: "Calculated values" => "Berekende waarden"
// p.surveyId: "Survey id" => "Enquête-id"
// p.surveyPostId: "Survey post id" => "Enquête post-ID"
// p.surveyShowDataSaving: "Survey show data saving" => "Enquête toont gegevensbesparing"
// p.showTOC: "Show TOC" => "Inhoudsopgave weergeven"
// p.tocLocation: "Toc location" => "Toc locatie"
// p.questionTitlePattern: "Question title pattern" => "Patroon van de vraagtitel"
// p.widthMode: "Width mode" => "Breedte-modus"
// p.showBrandInfo: "Show brand info" => "Toon merkinformatie"
// p.defaultValueExpression: "Default value expression" => "Standaardwaarde-expressie"
// p.bindings: "Bindings" => "Bindings"
// p.renderAs: "Render as" => "Renderen als"
// p.attachOriginalItems: "Attach original items" => "Voeg originele items toe"
// p.cellHint: "Cell hint" => "Hint voor cel"
// p.isUnique: "Is unique" => "Is uniek"
// p.showInMultipleColumns: "Show in multiple columns" => "Weergeven in meerdere kolommen"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Totaal maximum fractiecijfers"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Totaal minimum breukcijfers"
// p.detailElements: "Detail elements" => "Detailelementen"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Adaptieve acties toestaan"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "Detailpaneel weergeven bij toevoegen"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Keuzes lazy load ingeschakeld"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Keuzes lui laad paginaformaat"
// p.inputFieldComponent: "Input field component" => "Component invoerveld"
// p.itemComponent: "Item component" => "Onderdeel Item"
// p.min: "Min" => "Min"
// p.max: "Max" => "Max"
// p.minValueExpression: "Min value expression" => "Expressie van de min-waarde"
// p.maxValueExpression: "Max value expression" => "Maximale waarde-expressie"
// p.step: "Step" => "Stap"
// p.dataList: "Data list" => "Gegevenslijst"
// p.elements: "Elements" => "Elementen"
// p.content: "Content" => "Tevreden"
// p.navigationTitle: "Navigation title" => "Titel navigatie"
// p.navigationDescription: "Navigation description" => "Navigatie beschrijving"
// p.longTap: "Long tap" => "Lange tik"
// p.autoGrow: "Auto grow" => "Automatisch groeien"
// p.allowResize: "Allow resizing" => "Formaat wijzigen toestaan"
// p.acceptCarriageReturn: "Accept carriage return" => "Accepteer retour vervoer"
// p.displayMode: "Display mode" => "Weergavemodus"
// p.rateType: "Rate type" => "Type tarief"
// p.contentMode: "Content mode" => "Inhoudsmodus"
// p.imageFit: "Image fit" => "Passend bij het beeld"
// p.altText: "Alt text" => "Alternatieve tekst"
// p.height: "Height" => "Hoogte"
// p.penColor: "Pen color" => "Kleur van de pen"
// p.backgroundColor: "Background color" => "Achtergrondkleur"
// p.templateElements: "Template elements" => "Sjabloonelementen"
// p.operator: "Operator" => "Bediener"
// p.isVariable: "Is variable" => "Is variabel"
// p.runExpression: "Run expression" => "Expressie uitvoeren"
// p.showCaption: "Show caption" => "Toon bijschrift"
// p.iconName: "Icon name" => "Naam van pictogram"
// p.iconSize: "Icon size" => "Pictogramgrootte"
// p.precision: "Precision" => "Precisie"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Matrix sleepgreep gebied"
// p.backgroundImage: "Background image" => "Achtergrondafbeelding"
// p.backgroundImageFit: "Background image fit" => "Passend op de achtergrondafbeelding"
// p.backgroundImageAttachment: "Background image attachment" => "Bijlage bij achtergrondafbeelding"
// p.backgroundOpacity: "Background opacity" => "Dekking op de achtergrond"
// p.selectToRankEnabled: "Select to rank enabled" => "Selecteer om te rangschikken ingeschakeld"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Selecteer om de indeling van gebieden te rangschikken"
// p.allowCameraAccess: "Allow camera access" => "Toegang tot de camera toestaan"
// p.scaleColorMode: "Scale color mode" => "Kleurmodus schalen"
// p.rateColorMode: "Rate color mode" => "Kleurmodus beoordelen"
// p.templateTabTitle: "Template tab title" => "Titel van sjabloontabblad"
// p.templateVisibleIf: "Template visible if" => "Sjabloon zichtbaar als"
// p.copyDisplayValue: "Copy display value" => "Weergavewaarde kopiëren"
// theme.--background: "Background color" => "Achtergrondkleur"
// theme.--background-dim-light: "Background dim light color" => "Achtergrond dim licht kleur"
// theme.--primary-foreground: "Primary foreground color" => "Primaire voorgrondkleur"
// theme.--foreground: "Foreground color" => "Voorgrondkleur"
// theme.--base-unit: "Base unit" => "Basiseenheid"
// theme.groupAdvanced: "Advanced" => "Geavanceerd"
// theme.themeName: "Theme" => "Thema"
// theme.isPanellessss: "Question appearance" => "Uiterlijk van de vraag"
// theme.isPanellessPanels: "Default" => "Verstek"
// theme.isPanellessLightweight: "Without Panels" => "Zonder panelen"
// theme.themePaletteLight: "Light" => "Licht"
// theme.themePaletteDark: "Dark" => "Donker"
// theme.primaryColor: "Accent color" => "Accentkleur"
// theme.primaryDefaultColor: "Default" => "Verstek"
// theme.primaryDarkColor: "Hover" => "Zweven"
// theme.primaryLightColor: "Selected" => "Uitverkoren"
// theme.backgroundDimColor: "Background color" => "Achtergrondkleur"
// theme.backgroundImage: "Background image" => "Achtergrondafbeelding"
// theme.backgroundImageFitAuto: "Auto" => "Auto"
// theme.backgroundImageFitCover: "Cover" => "Bedekken"
// theme.backgroundImageFitContain: "Contain" => "Bevatten"
// theme.backgroundOpacity: "Opacity" => "Dekking"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Vast"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Scrollen"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Dekking van de achtergrond van het deelvenster"
// theme.questionBackgroundTransparency: "Question background opacity" => "Ondoorzichtigheid van de vraagachtergrond"
// theme.questionPanel: "Panel background and corner radius" => "Achtergrond van het deelvenster en hoekradius"
// theme.questionTitle: "Question title font" => "Lettertype voor de titel van de vraag"
// theme.questionDescription: "Question description font" => "Lettertype voor vraagbeschrijving"
// theme.editorPanel: "Input element" => "Invoerelement"
// theme.editorFont: "Input element font" => "Lettertype van invoerelement"
// theme.backcolor: "Default background" => "Standaard achtergrond"
// theme.hovercolor: "Hover background" => "Achtergrond aanwijzen"
// theme.borderDecoration: "Border decoration" => "Randdecoratie"
// theme.accentBackground: "Accent background" => "Accentachtergrond"
// theme.accentForeground: "Accent foreground" => "Accent voorgrond"
// theme.primaryForecolor: "Default color" => "Standaardkleur"
// theme.primaryForecolorLight: "Disabled color" => "Uitgeschakelde kleur"
// theme.linesColors: "Minor line colors" => "Kleine lijnkleuren"
// theme.borderDefault: "Darker" => "Donkerder"
// theme.borderLight: "Lighter" => "Aansteker"
// theme.fontFamily: "Font family" => "Lettertypefamilie"
// theme.fontSize: "Font size" => "Tekengrootte"
// theme.color: "Color" => "Kleur"
// theme.size: "Size" => "Grootte"
// theme.fontWeightRegular: "Regular" => "Regelmatig"
// theme.fontWeightHeavy: "Heavy" => "Zwaar"
// theme.fontWeightSemiBold: "Semi-bold" => "Semi-vet"
// theme.fontWeightBold: "Bold" => "Brutaal"
// theme.scale: "Scale" => "Schub"
// theme.cornerRadius: "Corner radius" => "Hoekradius"
// theme.surveyTitleFont: "Survey title font" => "Lettertype voor enquêtetitel"
// theme.pageTitle: "Page title font" => "Lettertype voor paginatitel"
// theme.pageDescription: "Page description font" => "Lettertype paginabeschrijving"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Schaduweffect toevoegen"
// theme.opacity: "Opacity" => "Dekking"
// theme.boxShadowBlur: "Blur" => "Vervagen"
// theme.boxShadowSpread: "Spread" => "Verspreiden"
// theme.boxShadowDrop: "Drop" => "Druppel"
// theme.boxShadowInner: "Inner" => "Binnenste"
// theme.questionShadow: "Shadow effects" => "Schaduweffecten"
// theme.editorShadow: "Input element shadow effects" => "Schaduweffecten van invoerelementen"
// names.default: "Default" => "Verstek"
// names.contrast: "Contrast" => "Tegenstelling"
// names.plain: "Plain" => "Vlakte"
// names.simple: "Simple" => "Eenvoudig"
// names.blank: "Blank" => "Blanco"
// names.double: "Double" => "Dubbel"
// names.bulk: "Bulk" => "Omvang"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo-3D"
// names.playful: "Playful" => "Dartel"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Taling"
// colors.blue: "Blue" => "Blauw"
// colors.purple: "Purple" => "Paars"
// colors.orchid: "Orchid" => "Orchidee"
// colors.tulip: "Tulip" => "Tulp"
// colors.brown: "Brown" => "Bruin"
// colors.green: "Green" => "Groen"
// names.sharp: "Sharp" => "Scherp"
// names.borderless: "Borderless" => "Grenzeloos"
// names.flat: "Flat" => "Plat"
// names.doubleborder: "Double Border" => "Dubbele rand"
// names.layered: "Layered" => "Gelaagd"
// names.solid: "Solid" => "Degelijk"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Weet u zeker dat u alle tekenreeksen voor deze taal wilt verwijderen?"
// ed.themeResetButton: "Reset theme settings to default" => "Thema-instellingen terugzetten op de standaardinstellingen"
// theme.placeholderColor: "Placeholder color" => "Kleur van tijdelijke aanduiding"
// ed.themeSettings: "Theme Settings" => "Thema-instellingen"
// ed.themeSettingsTooltip: "Open theme settings" => "Thema-instellingen openen"
// pe.resetToDefaultCaption: "Reset" => "Terugstellen"
// pv.file: "Local files" => "Lokale bestanden"
// pv.camera: "Camera" => "Fototoestel"
// pv.file-camera: "Local files or camera" => "Lokale bestanden of camera"
// ed.translateUsigAI: "Auto-translate All" => "Alles automatisch vertalen"
// ed.translationDialogTitle: "Untranslated strings" => "Onvertaalde tekenreeksen"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Voer ten minste {0} objecten in"
// lg.question_resetValueName: "Reset question value" => "Vraagwaarde opnieuw instellen"
// lg.column_resetValue: "Reset column value" => "Kolomwaarde opnieuw instellen"
// pe.markRequired: "Mark as required" => "Markeren zoals vereist"
// pe.removeRequiredMark: "Remove the required mark" => "Verwijder de vereiste markering"
// p.resetValueIf: "Reset value if" => "Waarde opnieuw instellen als"
// lg.question_setValueName: "Set question value" => "Vraagwaarde instellen"
// lg.column_resetValueName: "Reset column value" => "Kolomwaarde opnieuw instellen"
// lg.column_setValueName: "Set column value" => "Kolomwaarde instellen"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Een expressie waarvan het resultaat wordt toegewezen aan de doelvraag."
// survey.title: "Title" => "Titel"
// page.title: "Title" => "Titel"
// p.setValueIf: "Set value if" => "Stel de waarde in als"
// theme.header: "Header" => "Rubriek"
// theme.backgroundImageFitFill: "Stretch" => "Strekken"
// theme.backgroundImageFitTile: "Tile" => "Tegel"
// theme.headerView: "View" => "Bekijken"
// theme.headerViewBasic: "Basic" => "Basisch"
// theme.headerViewAdvanced: "Advanced" => "Geavanceerd"
// theme.headerInheritWidthFrom: "Content area width" => "Breedte van het inhoudsgebied"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Hetzelfde als enquête"
// theme.headerInheritWidthFromPage: "Fit to page" => "Aanpassen aan pagina"
// theme.headerTextAreaWidth: "Text width" => "Tekstbreedte"
// theme.headerBackgroundColorSwitch: "Background color" => "Achtergrondkleur"
// theme.headerBackgroundColorNone: "None" => "Geen"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Accentkleur"
// theme.headerBackgroundColorCustom: "Custom" => "Gewoonte"
// theme.horizontalAlignmentLeft: "Left" => "Links"
// theme.horizontalAlignmentCenter: "Center" => "Middelpunt"
// theme.horizontalAlignmentRight: "Right" => "Rechts"
// theme.verticalAlignmentTop: "Top" => "Boven"
// theme.verticalAlignmentMiddle: "Middle" => "Midden"
// theme.verticalAlignmentBottom: "Bottom" => "Bodem"
// theme.logoPosition: "Logo Position" => "Logo positie"
// theme.headerTitlePosition: "Title Position" => "Titel positie"
// lg.question_resetValueText: "reset value for question: {0}" => "Resetwaarde voor vraag: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Waarde: {1} toewijzen aan vraag: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Celwaarde voor kolom opnieuw instellen: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Celwaarde: {1} toewijzen aan kolom: {0}"
// ed.surveyJsonExportButton: "Export" => "Exporteren"
// ed.surveyJsonImportButton: "Import" => "Importeren"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Naar klembord kopiëren"
// pe.filePlaceholder: "File placeholder text" => "Tijdelijke tekst voor bestanden"
// pe.photoPlaceholder: "Photo placeholder text" => "Tijdelijke tekst voor foto's"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Tijdelijke tekst voor bestanden of foto's"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Van toepassing wanneer \"Brontype\" \"Lokale bestanden\" is of wanneer de camera niet beschikbaar is"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Van toepassing wanneer \"Brontype\" \"Camera\" is."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Van toepassing wanneer \"Brontype\" \"Lokale bestanden of camera\" is."
// theme.background: "Background" => "Achtergrond"
// theme.appearance: "Appearance" => "Uiterlijk"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Wil je het thema echt resetten? Al uw aanpassingen gaan verloren."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Ja, reset het thema"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Geschikt voor containers"
// signaturepad.showPlaceholder: "Show the placeholder" => "De tijdelijke aanduiding weergeven"
// signaturepad.placeholder: "Placeholder text" => "Tijdelijke aanduiding voor tekst"
// theme.surveyDescriptionFont: "Survey description font" => "Lettertype met enquêtebeschrijving"
// ed.prevFocus: "Focus previous" => "Focus vorige"
// ed.nextFocus: "Focus next" => "Focus volgende"
// ed.saveTheme: "Save Theme" => "Thema opslaan"
// ed.saveThemeTooltip: "Save Theme" => "Thema opslaan"
// lg.page_requireName: "Make page required" => "Pagina verplicht maken"
// lg.panel_requireName: "Make page required" => "Pagina verplicht maken"
// signaturepad.signatureWidth: "Signature area width" => "Breedte van het handtekeninggebied"
// signaturepad.signatureHeight: "Signature area height" => "Hoogte van het handtekeninggebied"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Het handtekeninggebied automatisch schalen"
// signaturepad.penMinWidth: "Minimum pen width" => "Minimale penbreedte"
// signaturepad.penMaxWidth: "Maximum pen width" => "Maximale breedte van het hok"
// theme.headerDescriptionPosition: "Description position" => "Beschrijving positie"
// ed.propertyGridNoResultsFound: "No results found" => "Geen resultaten gevonden"
// pv.leftRight: "Left and right" => "Links en rechts"
// p.sourceType: "Source type" => "Type bron"
// p.fitToContainer: "Fit to container" => "Aanpassen aan container"
// p.setValueExpression: "Set value expression" => "Expressie van ingestelde waarde"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Keuzes worden geladen vanuit een webservice."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Ga naar instellingen"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Voorbeeld van geladen keuzeopties"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Voorkom dubbele antwoorden in rijen"
// theme.advancedMode: "Advanced mode" => "Geavanceerde modus"
// theme.backgroundCornerRadius: "Background and corner radius" => "Achtergrond en hoekradius"
// theme.colorsTitle: "Colors" => "Kleuren"
// theme.font: "Font" => "Lettertype"
// theme.lines: "Lines" => "Lijnen"
// theme.titleFont: "Title font" => "Titel lettertype"
// theme.descriptionFont: "Description font" => "Beschrijving lettertype"
// theme.shadow: "Shadow effects" => "Schaduweffecten"
// ed.translateUsigAIFrom: "Translate from: " => "Vertalen van: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "De optie Weigeren om te antwoorden toestaan"
// pe.showDontKnowItem: "Allow the Don't Know option" => "De optie 'Weet niet' toestaan"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "De optie Weigeren om te antwoorden toestaan"
// pe.showDontKnowItem: "Allow the Don't Know option" => "De optie 'Weet niet' toestaan"
// pv.contain: "Contain" => "Bevatten"
// pv.cover: "Cover" => "Bedekken"
// pv.fill: "Fill" => "Vullen"
// pe.transposeData: "Transpose rows to columns" => "Rijen transponeren naar kolommen"
// layout.panel: "Layout" => "Indeling"
// layout.question: "Layout" => "Indeling"
// layout.base: "Layout" => "Indeling"
// panel.name: "Panel name" => "Naam van het paneel"
// panel.title: "Panel title" => "Titel van het paneel"
// panel.description: "Panel description" => "Beschrijving van het paneel"
// panel.visibleIf: "Make the panel visible if" => "Maak het paneel zichtbaar als"
// panel.requiredIf: "Make the panel required if" => "Maak het paneel vereist als"
// panel.questionsOrder: "Question order within the panel" => "Volgorde van de vragen binnen het panel"
// panel.startWithNewLine: "Display the panel on a new line" => "Het paneel op een nieuwe regel weergeven"
// panel.state: "Panel collapse state" => "Status van paneel samenvouwen"
// panel.width: "Inline panel width" => "Inline paneelbreedte"
// panel.minWidth: "Minimum panel width" => "Minimale paneelbreedte"
// panel.maxWidth: "Maximum panel width" => "Maximale paneelbreedte"
// panel.showNumber: "Number panels" => "Nummerpanelen"
// paneldynamic.name: "Panel name" => "Naam van het paneel"
// paneldynamic.title: "Panel title" => "Titel van het paneel"
// paneldynamic.description: "Panel description" => "Beschrijving van het paneel"
// paneldynamic.visibleIf: "Make the panel visible if" => "Maak het paneel zichtbaar als"
// paneldynamic.requiredIf: "Make the panel required if" => "Maak het paneel vereist als"
// paneldynamic.page: "Move the panel to page" => "Het deelvenster naar pagina verplaatsen"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Het paneel op een nieuwe regel weergeven"
// paneldynamic.state: "Panel collapse state" => "Status van paneel samenvouwen"
// paneldynamic.width: "Inline panel width" => "Inline paneelbreedte"
// paneldynamic.minWidth: "Minimum panel width" => "Minimale paneelbreedte"
// paneldynamic.maxWidth: "Maximum panel width" => "Maximale paneelbreedte"
// paneldynamic.templateDescription: "Panel description pattern" => "Patroon van paneelbeschrijving"
// paneldynamic.templateTitle: "Panel title pattern" => "Patroon voor paneeltitel"
// paneldynamic.noEntriesText: "Empty panel text" => "Lege paneeltekst"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Patroon voor tabbladtitel"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Maak een afzonderlijk paneel zichtbaar als"
// paneldynamic.hideNumber: "Hide the panel number" => "Het paneelnummer verbergen"
// paneldynamic.titleLocation: "Panel title alignment" => "Uitlijning van paneeltitels"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Uitlijning van paneelbeschrijving"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Uitlijning van vraagtitels"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Uitlijning van foutmeldingen"
// paneldynamic.newPanelPosition: "New panel location" => "Nieuwe paneellocatie"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Voorkom dubbele antwoorden in de volgende vraag"
// question.name: "Question name" => "Naam van de vraag"
// question.title: "Question title" => "Titel van de vraag"
// question.description: "Question description" => "Beschrijving van de vraag"
// question.visibleIf: "Make the question visible if" => "Maak de vraag zichtbaar als"
// question.requiredIf: "Make the question required if" => "Maak de vraag verplicht als"
// question.state: "Question box collapse state" => "Samenvouwen van vragenvak"
// question.hideNumber: "Hide the question number" => "Verberg het vraagnummer"
// question.titleLocation: "Question title alignment" => "Uitlijning van vraagtitels"
// question.descriptionLocation: "Question description alignment" => "Uitlijning van vraagbeschrijvingen"
// question.errorLocation: "Error message alignment" => "Uitlijning van foutmeldingen"
// question.indent: "Increase the inner indent" => "Vergroot de binnenste inspringing"
// question.width: "Inline question width" => "Breedte inline vraag"
// question.minWidth: "Minimum question width" => "Minimale vraagbreedte"
// question.maxWidth: "Maximum question width" => "Maximale vraagbreedte"
// question.textUpdateMode: "Update input field value" => "Invoerveldwaarde bijwerken"
// signaturepad.allowClear: "Show the Clear button within signature area" => "De knop Wissen weergeven in het handtekeninggebied"
// signaturepad.penColor: "Stroke color" => "Kleur van de lijn"
// comment.rows: "Input field height (in lines)" => "Hoogte invoerveld (in lijnen)"
// expression.name: "Expression name" => "Naam van expressie"
// expression.title: "Expression title" => "Titel van expressie"
// expression.description: "Expression description" => "Beschrijving van expressie"
// expression.expression: "Expression" => "Uitdrukking"
// trigger.expression: "Expression" => "Uitdrukking"
// calculatedvalue.expression: "Expression" => "Uitdrukking"
// survey.description: "Survey description" => "Beschrijving van de enquête"
// page.name: "Page name" => "Paginanaam"
// page.description: "Page description" => "Pagina beschrijving"
// page.visibleIf: "Make the page visible if" => "Maak de pagina zichtbaar als"
// page.requiredIf: "Make the page required if" => "Maak de pagina vereist als"
// page.questionsOrder: "Question order on the page" => "Volgorde van vragen op de pagina"
// matrixdropdowncolumn.name: "Column name" => "Naam van de kolom"
// matrixdropdowncolumn.title: "Column title" => "Titel van de kolom"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Voorkom dubbele reacties"
// matrixdropdowncolumn.width: "Column width" => "Kolombreedte"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Minimale kolombreedte"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Hoogte invoerveld (in lijnen)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Maak de kolom zichtbaar als"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Maak de kolom verplicht als"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Elke optie in een aparte kolom"
// multipletextitem.name: "Name" => "Naam"
// multipletextitem.title: "Title" => "Titel"
// pe.rateDescriptionLocation: "Label alignment" => "Etiket uitlijnen"
// pe.cellErrorLocation: "Cell error message alignment" => "Uitlijning van celfoutmeldingen"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Je hebt nog geen kolommen"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Je hebt nog geen rijen"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Je hebt nog geen validatieregels"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Je hebt nog geen aangepaste variabelen"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Je hebt nog geen triggers"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Je hebt nog geen links"
// pe.addNew@columns: "Add new column" => "Nieuwe kolom toevoegen"
// pe.addNew@rows: "Add new row" => "Nieuwe rij toevoegen"
// pe.addNew@validators: "Add new rule" => "Nieuwe regel toevoegen"
// pe.addNew@calculatedValues: "Add new variable" => "Nieuwe variabele toevoegen"
// pe.addNew@triggers: "Add new trigger" => "Nieuwe trigger toevoegen"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Nieuwe URL toevoegen"
// choicesbyurl.url: "Web service's URL" => "URL van de webservice"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Paginatitels weergeven in de voortgangsbalk"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Paginanummers weergeven in de voortgangsbalk"
// itemvalue.visibleIf: "Make the option visible if" => "Maak de optie zichtbaar als"
// itemvalue.enableIf: "Make the option selectable if" => "Maak de optie selecteerbaar als"
// panel.layout: "Panel Layout" => "Paneel Lay-out"
// tabs.questionSettings: "Question Settings" => "Vraag-instellingen"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Vb.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Vb.: categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Vb.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Bijv.: 6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "Bijv.: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Vb.: 50%"
// pv.selected: "Selected" => "Uitverkoren"
// pv.unselected: "Unselected" => "Geselecteerd"
// pv.center: "Center" => "Middelpunt"
// pv.middle: "Middle" => "Midden"
// pv.next: "Next" => "Volgend"
// pv.last: "Last" => "Laatste"
// clearIfInvisible.none: "Never" => "Nooit"
// questionsOnPageMode.standard: "Original structure" => "Oorspronkelijke structuur"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Toon alle vragen op één pagina"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Toon één vraag per pagina"
// pv.auto: "Auto" => "Auto"
// panelsState.firstExpanded: "First expanded" => "Eerst uitgebreid"
// rateColorMode.scale: "Scale" => "Schub"
// scaleColorMode.monochrome: "Monochrome" => "Monochroom"
// scaleColorMode.colored: "Colored" => "Gekleurd"
// state.default: "Locked" => "Op slot"
// showQuestionNumbers.default: "Auto-numbering" => "Automatische nummering"
// showQuestionNumbers.on: "Auto-numbering" => "Automatische nummering"
// showQuestionNumbers.onPage: "Reset on each page" => "Reset op elke pagina"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Reset op elk paneel"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Reset op elk paneel"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Doorgaan in de enquête"
// showQuestionNumbers.off: "No numbering" => "Geen nummering"
// descriptionLocation.underTitle: "Under the question title" => "Onder de titel van de vraag"
// descriptionLocation.underInput: "Under the input field" => "Onder het invoerveld"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Naast keuzes"
// selectToRankAreasLayout.vertical: "Above choices" => "Bovenstaande keuzes"
// displayStyle.decimal: "Decimal" => "Decimaal"
// displayStyle.currency: "Currency" => "Valuta"
// displayStyle.percent: "Percentage" => "Percentage"
// displayStyle.date: "Date" => "Datum"
// totalDisplayStyle.decimal: "Decimal" => "Decimaal"
// totalDisplayStyle.currency: "Currency" => "Valuta"
// totalDisplayStyle.percent: "Percentage" => "Percentage"
// totalDisplayStyle.date: "Date" => "Datum"
// rowsOrder.initial: "Original" => "Origineel"
// questionsOrder.initial: "Original" => "Origineel"
// showProgressBar.aboveheader: "Above the header" => "Boven de koptekst"
// showProgressBar.belowheader: "Below the header" => "Onder de kop"
// pv.sum: "Sum" => "Som"
// pv.count: "Count" => "Tellen"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Max"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Bevat"
// searchMode.startsWith: "Starts with" => "Begint met"
// panel.name: "A panel ID that is not visible to respondents." => "Een panel-ID die niet zichtbaar is voor respondenten."
// panel.description: "Type a panel subtitle." => "Typ een ondertitel in het deelvenster."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de zichtbaarheid van het deelvenster bepaalt."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de alleen-lezen modus voor het deelvenster uitschakelt."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die het verzenden van enquêtes verhindert, tenzij ten minste één geneste vraag een antwoord heeft."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Geldt voor alle vragen binnen dit panel. Als u deze instelling wilt overschrijven, definieert u regels voor titeluitlijning voor afzonderlijke vragen. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau (\"Standaard bovenaan\") toe."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Hiermee stelt u de locatie van een foutmelding in met betrekking tot alle vragen in het panel. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau toe."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Behoudt de oorspronkelijke volgorde van vragen of maakt ze willekeurig. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau toe."
// panel.page: "Repositions the panel to the end of a selected page." => "Hiermee verplaatst u het deelvenster naar het einde van een geselecteerde pagina."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Hiermee voegt u ruimte of marge toe tussen de inhoud van het deelvenster en de linkerrand van het deelvenstervak."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Schakel de optie uit om het deelvenster op één regel weer te geven met de vorige vraag of het vorige deelvenster. De instelling is niet van toepassing als het deelvenster het eerste element in uw formulier is."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Kies uit: \"Uitgevouwen\" - het paneel wordt volledig weergegeven en kan worden ingeklapt; \"Samengevouwen\" - het paneel toont alleen de titel en beschrijving en kan worden uitgevouwen; \"Vergrendeld\" - het paneel wordt volledig weergegeven en kan niet worden ingeklapt."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Hiermee stelt u de breedte van het paneel in verhouding tot andere enquête-elementen in dezelfde lijn. Accepteert CSS-waarden (px, %, in, pt, enz.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "Een panel-ID die niet zichtbaar is voor respondenten."
// paneldynamic.description: "Type a panel subtitle." => "Typ een ondertitel in het deelvenster."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de zichtbaarheid van het deelvenster bepaalt."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de alleen-lezen modus voor het deelvenster uitschakelt."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die het verzenden van enquêtes verhindert, tenzij ten minste één geneste vraag een antwoord heeft."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Geldt voor alle vragen binnen dit panel. Als u deze instelling wilt overschrijven, definieert u regels voor titeluitlijning voor afzonderlijke vragen. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau (\"Standaard bovenaan\") toe."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Hiermee stelt u de locatie in van een foutmelding met betrekking tot een vraag met ongeldige invoer. Kies tussen: \"Top\" - er wordt een fouttekst bovenaan het vraagvak geplaatst; \"Onderaan\" - er wordt een fouttekst onderaan het vraagvak geplaatst. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau (\"Standaard bovenaan\") toe."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Hiermee stelt u de locatie van een foutmelding in met betrekking tot alle vragen in het panel. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau toe."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Hiermee verplaatst u het deelvenster naar het einde van een geselecteerde pagina."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Hiermee voegt u ruimte of marge toe tussen de inhoud van het deelvenster en de linkerrand van het deelvenstervak."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Schakel de optie uit om het deelvenster op één regel weer te geven met de vorige vraag of het vorige deelvenster. De instelling is niet van toepassing als het deelvenster het eerste element in uw formulier is."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Kies uit: \"Uitgevouwen\" - het paneel wordt volledig weergegeven en kan worden ingeklapt; \"Samengevouwen\" - het paneel toont alleen de titel en beschrijving en kan worden uitgevouwen; \"Vergrendeld\" - het paneel wordt volledig weergegeven en kan niet worden ingeklapt."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Hiermee stelt u de breedte van het paneel in verhouding tot andere enquête-elementen in dezelfde lijn. Accepteert CSS-waarden (px, %, in, pt, enz.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Typ een sjabloon voor dynamische paneeltitels. Gebruik {panelIndex} voor de algemene positie van het paneel en {visiblePanelIndex} voor de volgorde tussen de zichtbare panelen. Voeg deze tijdelijke aanduidingen toe aan het patroon om automatische nummering toe te voegen."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Typ een sjabloon voor tabbladtitels. Gebruik {panelIndex} voor de algemene positie van een paneel en {visiblePanelIndex} voor de volgorde tussen zichtbare panelen. Voeg deze tijdelijke aanduidingen toe aan het patroon om automatische nummering toe te voegen."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Met deze instelling kunt u de zichtbaarheid van afzonderlijke panelen binnen het dynamische paneel regelen. Gebruik de tijdelijke aanduiding '{panel}' om te verwijzen naar het huidige deelvenster in uw expressie."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Deze instelling wordt automatisch overgenomen door alle vragen in dit paneel. Als u deze instelling wilt overschrijven, definieert u regels voor titeluitlijning voor afzonderlijke vragen. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau (\"Standaard bovenaan\") toe."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau toe (\"Standaard onder de paneeltitel\")."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Definieert de positie van een nieuw toegevoegd deelvenster. Standaard worden er nieuwe panelen aan het einde toegevoegd. Selecteer \"Volgende\" om een nieuw paneel in te voegen na het huidige."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Dupliceert antwoorden uit het laatste deelvenster en wijst ze toe aan het volgende toegevoegde dynamische deelvenster."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Verwijs naar een vraagnaam om te vereisen dat een gebruiker in elk deelvenster een uniek antwoord geeft op deze vraag."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Met deze instelling kunt u een standaardantwoordwaarde toewijzen op basis van een expressie. De expressie kan basisberekeningen bevatten - '{q1_id} + {q2_id}', Booleaanse expressies, zoals '{age} > 60', en functies: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', enz. De waarde die door deze expressie wordt bepaald, dient als de oorspronkelijke standaardwaarde die kan worden overschreven door de handmatige invoer van een respondent."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die bepaalt wanneer de invoer van een respondent wordt teruggezet naar de waarde op basis van de \"Standaardwaarde-expressie\" of \"Waarde-expressie instellen\" of naar de waarde \"Standaardantwoord\" (als een van beide is ingesteld)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die bepaalt wanneer de expressie 'Waarde instellen' moet worden uitgevoerd en wijs de resulterende waarde dynamisch toe als antwoord."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Geef een expressie op die de waarde definieert die moet worden ingesteld wanneer aan de voorwaarden in de regel 'Waarde instellen als' wordt voldaan. De expressie kan basisberekeningen bevatten - '{q1_id} + {q2_id}', Booleaanse expressies, zoals '{age} > 60', en functies: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', enz. De waarde die door deze expressie wordt bepaald, kan worden overschreven door de handmatige invoer van een respondent."
// question.name: "A question ID that is not visible to respondents." => "Een vraag-ID die niet zichtbaar is voor respondenten."
// question.description: "Type a question subtitle." => "Typ de ondertitel van een vraag."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die de zichtbaarheid van de vraag bepaalt."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die de alleen-lezen modus voor de vraag uitschakelt."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die voorkomt dat de enquête wordt voortgezet of verzonden, tenzij de vraag een antwoord heeft gekregen."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Schakel de optie uit om de vraag op één regel weer te geven met de vorige vraag of het vorige deelvenster. De instelling is niet van toepassing als de vraag het eerste element in uw formulier is."
// question.page: "Repositions the question to the end of a selected page." => "Hiermee verplaatst u de vraag naar het einde van een geselecteerde pagina."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Kies uit: \"Uitgevouwen\" - het vraagvak wordt volledig weergegeven en kan worden ingeklapt; \"Samengevouwen\" - het vraagvak toont alleen de titel en beschrijving en kan worden uitgevouwen; \"Vergrendeld\" - het vraagvak wordt volledig weergegeven en kan niet worden ingeklapt."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Hiermee worden regels voor titeluitlijning overschreven die zijn gedefinieerd op paneel-, pagina- of enquêteniveau. De optie \"Overnemen\" past alle instellingen op een hoger niveau (indien ingesteld) of instellingen op enquêteniveau (\"Top\" standaard) toe."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "De optie \"Overnemen\" past de instelling op enquêteniveau toe (\"Standaard onder de vraagtitel\")."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Hiermee stelt u de locatie van een foutmelding in ten opzichte van de vraag met ongeldige invoer. Kies tussen: \"Top\" - er wordt een fouttekst bovenaan het vraagvak geplaatst; \"Onderaan\" - er wordt een fouttekst onderaan het vraagvak geplaatst. De optie \"Overnemen\" past de instelling op enquêteniveau toe (\"Top\" standaard)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Hiermee voegt u ruimte of marge toe tussen de inhoud van de vraag en de linkerrand van het vraagvak."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Hiermee stelt u de breedte van de vraag in verhouding tot andere enquête-elementen in dezelfde regel. Accepteert CSS-waarden (px, %, in, pt, enz.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Gebruik het toverstafpictogram om een validatieregel voor de vraag in te stellen."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Kies uit: \"Bij verloren focus\" - de waarde wordt bijgewerkt wanneer het invoerveld de focus verliest; \"Tijdens het typen\" - de waarde wordt in realtime bijgewerkt, terwijl gebruikers typen. Met de optie \"Overerven\" wordt de instelling op enquêteniveau toegepast (\"Standaard bij verloren focus\")."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "U kunt elke webservice gebruiken als gegevensbron voor meerkeuzevragen. Als u keuzewaarden wilt invullen, voert u de URL in van de service die de gegevens levert."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Een vergelijkingsbewerking die wordt gebruikt om de vervolgkeuzelijst te filteren."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Hiermee stelt u de breedte van het weergegeven handtekeninggebied en de resulterende afbeelding in."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Hiermee stelt u de hoogte in van het weergegeven handtekeninggebied en de resulterende afbeelding."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Selecteer of u wilt dat het handtekeninggebied alle beschikbare ruimte in het vraagvak vult met behoud van de standaardverhouding van 3:2. Wanneer aangepaste breedte- en hoogtewaarden zijn ingesteld, blijft de hoogte-breedteverhouding van deze afmetingen behouden."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Hiermee past u de hoogte van de afbeelding in de enquêteresultaten aan."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Hiermee past u de breedte van de afbeelding in de enquêteresultaten aan."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Hiermee worden de minimum- en maximumhoogtewaarden overschreven."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Hiermee worden de waarden voor de minimum- en maximumbreedte overschreven."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Waarde\" dient als een item-ID die wordt gebruikt in voorwaardelijke regels; \"Tekst\" wordt getoond aan respondenten."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Deze instelling wijzigt alleen de grootte van het invoerveld en heeft geen invloed op de breedte van het vraagvak. Als u de geaccepteerde invoerlengte wilt beperken, gaat u naar <b>Validatie → Maximale tekenlimiet</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Hiermee stelt u het aantal weergegeven regels in het invoerveld in. Als de invoer meer regels in beslag neemt, verschijnt de schuifbalk."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Kies tussen: \"Bewerkbaar\" - stelt respondenten in staat uw enquête in te vullen; \"Alleen-lezen\" - schakelt het bewerken van formulieren uit."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "Een kolom-id die niet zichtbaar is voor respondenten."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Als deze optie is ingeschakeld voor een kolom, moet een respondent een uniek antwoord geven voor elke vraag in deze kolom."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Hiermee stelt u het aantal weergegeven regels in het invoerveld in. Als de invoer meer regels in beslag neemt, verschijnt de schuifbalk."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de zichtbaarheid van de kolom bepaalt."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen waarmee de alleen-lezen modus voor de kolom wordt uitgeschakeld."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die het verzenden van enquêtes verhindert, tenzij ten minste één geneste vraag een antwoord heeft."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Als deze optie is geselecteerd, wordt er een afzonderlijke kolom gemaakt voor elke keuzeoptie."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Kies uit: \"Statisch\" - stelt een vaste breedte in; \"Responsief\" - zorgt ervoor dat de enquête de volledige breedte van het scherm in beslag neemt; \"Auto\" - past een van de twee toe, afhankelijk van de gebruikte vraagtypen."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Plak een afbeeldingslink (geen maximale grootte) of klik op het mappictogram om door een bestand vanaf uw computer te bladeren (maximaal 64 KB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Hiermee stelt u de breedte van het logo in CSS-eenheden in (px, %, in, pt, enz.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Hiermee stelt u de hoogte van een logo in CSS-eenheden in (px, %, in, pt, enz.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Kies uit: \"Geen\" - afbeelding behoudt zijn oorspronkelijke grootte; \"Bevatten\" - het formaat van de afbeelding wordt aangepast aan de beeldverhouding met behoud van de beeldverhouding; \"Omslag\" - afbeelding vult het hele vak met behoud van de beeldverhouding; \"Vullen\" - de afbeelding wordt uitgerekt om het vak te vullen zonder de beeldverhouding te behouden."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Selecteer of u wilt dat de enquête automatisch naar de volgende pagina wordt verplaatst nadat een respondent alle vragen op de huidige pagina heeft beantwoord."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Hiermee stelt u de zichtbaarheid en locatie van navigatieknoppen op een pagina in."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Hiermee stelt u de zichtbaarheid en locatie van een voortgangsbalk in. De waarde \"Auto\" geeft de voortgangsbalk boven of onder de kop van de enquête weer."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Schakel de voorbeeldpagina in met alleen alle of beantwoorde vragen."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Geldt voor alle vragen in de enquête. Deze instelling kan worden overschreven door regels voor titeluitlijning op lagere niveaus: deelvenster, pagina of vraag. Een instelling op een lager niveau heeft voorrang op die op een hoger niveau."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Een symbool of een reeks symbolen die aangeven dat een antwoord vereist is."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Voer een cijfer of letter in waarmee u wilt beginnen met nummeren."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Hiermee stelt u de locatie van een foutmelding in ten opzichte van de vraag met ongeldige invoer. Kies tussen: \"Top\" - er wordt een fouttekst bovenaan het vraagvak geplaatst; \"Onderaan\" - er wordt een fouttekst onderaan het vraagvak geplaatst."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Selecteer of u het eerste invoerveld op elke pagina klaar wilt maken voor tekstinvoer."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Behoudt de oorspronkelijke volgorde van vragen of maakt ze willekeurig. Het effect van deze instelling is alleen zichtbaar op het tabblad Voorbeeld."
// pehelp.maxTextLength: "For text entry questions only." => "Alleen voor vragen over tekstinvoer."
// pehelp.maxOthersLength: "For question comments only." => "Alleen voor opmerkingen over vragen."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Selecteer of u wilt dat vraagopmerkingen en lange tekstvragen automatisch in hoogte groeien op basis van de ingevoerde tekstlengte."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Alleen voor vraagopmerkingen en lange tekstvragen."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Aangepaste variabelen dienen als tussenliggende of hulpvariabelen die worden gebruikt in formulierberekeningen. Ze nemen de input van respondenten als bronwaarden. Elke aangepaste variabele heeft een unieke naam en een expressie waarop deze is gebaseerd."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Selecteer of u wilt dat de berekende waarde van de expressie samen met de enquêteresultaten wordt opgeslagen."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Een trigger is een gebeurtenis of voorwaarde die is gebaseerd op een expressie. Zodra de expressie is geëvalueerd naar 'waar', wordt een actie geactiveerd door een trigger. Zo'n actie kan optioneel een doelvraag hebben die het beïnvloedt."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Kies of u de waarden wilt wissen voor vragen die verborgen zijn door voorwaardelijke logica en wanneer u dit wilt doen."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Kies uit: \"Bij verloren focus\" - de waarde wordt bijgewerkt wanneer het invoerveld de focus verliest; \"Tijdens het typen\" - de waarde wordt in realtime bijgewerkt, terwijl gebruikers typen."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "De linkerwaarde dient als een kolom-ID die wordt gebruikt in voorwaardelijke regels, de rechterwaarde wordt weergegeven aan respondenten."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "De linkerwaarde dient als een rij-ID die wordt gebruikt in voorwaardelijke regels, de rechterwaarde wordt weergegeven aan respondenten."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepteert CSS-waarden (px, %, in, pt, enz.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepteert CSS-waarden (px, %, in, pt, enz.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Hiermee stelt u de locatie van een foutbericht in ten opzichte van een cel met ongeldige invoer. Met de optie 'Overerven' wordt de instelling van de eigenschap 'Uitlijning van foutberichten' toegepast."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Wanneer de eigenschap 'Dubbele antwoorden voorkomen' is ingeschakeld, ontvangt een respondent die een dubbele vermelding probeert in te dienen, het volgende foutbericht."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Hiermee kunt u totale waarden berekenen op basis van een expressie. De expressie kan basisberekeningen ('{q1_id} + {q2_id}'), Booleaanse expressies ('{age} > 60') en functies ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.) bevatten."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Hiermee wordt gevraagd om het verwijderen van de rij te bevestigen."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Dupliceert antwoorden uit de laatste rij en wijst ze toe aan de volgende toegevoegde dynamische rij."
// pehelp.description: "Type a subtitle." => "Typ een ondertitel."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Kies een taal om te beginnen met het maken van uw enquête. Als u een vertaling wilt toevoegen, schakelt u over naar een nieuwe taal en vertaalt u de originele tekst hier of op het tabblad Vertalingen."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Hiermee stelt u de locatie van een detailsectie ten opzichte van een rij in. Kies uit: \"Geen\" - er wordt geen uitbreiding toegevoegd; \"Onder de rij\" - onder elke rij van de matrix wordt een rij-uitbreiding geplaatst; \"Onder de rij, slechts één rij-uitbreiding weergeven\" - een uitbreiding wordt alleen onder een enkele rij weergegeven, de resterende rij-uitbreidingen zijn samengevouwen."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Kies uit: \"Geen\" - afbeelding behoudt zijn oorspronkelijke grootte; \"Bevatten\" - het formaat van de afbeelding wordt aangepast aan de beeldverhouding met behoud van de beeldverhouding; \"Omslag\" - afbeelding vult het hele vak met behoud van de beeldverhouding; \"Vullen\" - de afbeelding wordt uitgerekt om het vak te vullen zonder de beeldverhouding te behouden."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Verhoogt geleidelijk de hoogte van het invoerveld terwijl gegevens worden ingevoerd. Hiermee wordt de instelling \"Invoerveldhoogte (in lijnen)\" overschreven."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "De formaatgreep (of greep) verschijnt in de hoek en kan worden gesleept om de grootte van het invoerveld te wijzigen."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Een tijdsinterval in seconden, waarna de enquête automatisch doorgaat naar de bedankpagina."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Een tijdsinterval in seconden, waarna de enquête automatisch doorgaat naar de volgende pagina."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Een tijdsinterval in seconden, waarna de enquête automatisch doorgaat naar de volgende pagina."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die de zichtbaarheid van de pagina bepaalt."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen waarmee de alleen-lezen modus voor de pagina wordt uitgeschakeld."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die het verzenden van enquêtes verhindert, tenzij ten minste één geneste vraag een antwoord heeft."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Geldt voor alle vragen op deze pagina. Als je deze instelling wilt overschrijven, definieer je regels voor titeluitlijning voor afzonderlijke vragen of panelen. De optie \"Overnemen\" past de instelling op enquêteniveau toe (\"Top\" standaard)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Hiermee stelt u de locatie van een foutmelding in ten opzichte van de vraag met ongeldige invoer. Kies tussen: \"Top\" - er wordt een fouttekst bovenaan het vraagvak geplaatst; \"Onderaan\" - er wordt een fouttekst onderaan het vraagvak geplaatst. De optie \"Overnemen\" past de instelling op enquêteniveau toe (\"Top\" standaard)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Behoudt de oorspronkelijke volgorde van vragen of maakt ze willekeurig. De optie \"Overerven\" past de instelling op enquêteniveau toe (\"Standaard Origineel\"). Het effect van deze instelling is alleen zichtbaar op het tabblad Voorbeeld."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Hiermee stelt u de zichtbaarheid van navigatieknoppen op de pagina in. De optie \"Overerven\" past de instelling op enquêteniveau toe, die standaard op \"Zichtbaar\" staat."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Hiermee stelt u de zichtbaarheid en locatie van een timer op een pagina in."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Kies uit: \"Vergrendeld\" - gebruikers kunnen panelen niet uitvouwen of samenvouwen; \"Alles samenvouwen\" - alle deelvensters beginnen in een samengevouwen toestand; \"Alles uitvouwen\" - alle deelvensters beginnen in een uitgevouwen staat; \"Eerst uitgevouwen\" - alleen het eerste paneel wordt in eerste instantie uitgevouwen."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Voer de naam van een gedeelde eigenschap in binnen de matrix met objecten die de URL's van afbeeldings- of videobestanden bevat die u in de keuzelijst wilt weergeven."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "De linkerwaarde dient als een item-ID die wordt gebruikt in voorwaardelijke regels, de rechterwaarde wordt weergegeven aan respondenten."
// pehelp.title: "Type a user-friendly title to display." => "Typ een gebruiksvriendelijke titel om weer te geven."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Zorgt ervoor dat gebruikers de enquête pas invullen als de bestanden zijn geüpload."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepteert CSS-waarden (px, %, in, pt, enz.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepteert CSS-waarden (px, %, in, pt, enz.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepteert CSS-waarden (px, %, in, pt, enz.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "In vraagtypen met enkelvoudige en meervoudige selectie heeft elke keuzeoptie een ID en weergavewaarde. Als deze instelling is geselecteerd, wordt een weergavewaarde weergegeven in plaats van een ID-waarde in HTML-vragen en dynamische titels en beschrijvingen van enquête-elementen."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Kies of vraagwaarden die verborgen zijn door voorwaardelijke logica al dan niet moeten worden gewist en wanneer u dit wilt doen. Met de optie \"Overnemen\" wordt de instelling op enquêteniveau toegepast (\"Na voltooiing van de enquête\" standaard)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Kies uit: \"Alle\" - kopieert alle keuzemogelijkheden van de geselecteerde vraag; \"Geselecteerd\" - kopieert dynamisch alleen geselecteerde keuzeopties; \"Niet geselecteerd\" - kopieert dynamisch alleen niet-geselecteerde keuzeopties. De opties \"Geen\" en \"Overig\" worden standaard gekopieerd als deze zijn ingeschakeld in de bronvraag."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Als deze optie is geselecteerd, kunnen gebruikers extra invoer invullen in een apart invulveld."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Geeft elke speciale keuzeoptie ('Geen', 'Overig', 'Alles selecteren') weer op een nieuwe regel, zelfs bij gebruik van een lay-out met meerdere kolommen."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Geef de locatie binnen de servicegegevensset op waar de doelmatrix met objecten zich bevindt. Laat leeg als de URL al naar de array verwijst."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Voer een uniforme eigenschapsnaam in binnen de matrix met objecten die de waarden bevat die u in de keuzelijst wilt weergeven."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Selecteer deze optie om toe te staan dat de service een leeg antwoord of een lege matrix retourneert."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die de zichtbaarheid van alle keuzeopties bepaalt."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "De linkerwaarde dient als een item-ID die wordt gebruikt in voorwaardelijke regels, de rechterwaarde wordt weergegeven aan respondenten."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" kiest tussen de modi \"Knoppen\" en \"Dropdown\" op basis van de beschikbare breedte. Wanneer de breedte onvoldoende is om knoppen weer te geven, wordt er een dropdown weergegeven in de vraag."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Hiermee kunt u vragen verbinden die resultaten opleveren in verschillende formaten. Wanneer dergelijke vragen aan elkaar zijn gekoppeld met behulp van een join-id, worden in deze gedeelde eigenschap geselecteerde vraagwaarden opgeslagen."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Selecteer of u de inhoud van het vervolgkeuzemenu wilt bijwerken zodat deze overeenkomt met de zoekopdracht die een gebruiker in het invoerveld typt."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Een waarde die moet worden opgeslagen in enquêteresultaten wanneer respondenten een positief antwoord geven."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Een waarde die moet worden opgeslagen in enquêteresultaten wanneer respondenten een negatief antwoord geven."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Het wordt niet aanbevolen om deze optie uit te schakelen, omdat deze de voorbeeldafbeelding overschrijft en het voor een gebruiker moeilijk maakt om te begrijpen of de bestanden zijn geüpload."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Hiermee wordt een prompt geactiveerd waarin wordt gevraagd om het verwijderen van het bestand te bevestigen."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Schakel in om alleen geselecteerde keuzes te rangschikken. Gebruikers slepen geselecteerde items uit de keuzelijst om ze binnen het rangschikkingsgebied te rangschikken."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Voer een lijst met keuzes in die tijdens de invoer aan de respondent worden voorgesteld."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "De instelling wijzigt alleen de grootte van de invoervelden en heeft geen invloed op de breedte van het vraagvak."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Hiermee stelt u een consistente breedte in voor alle artikellabels in pixels"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "De optie \"Auto\" bepaalt automatisch de geschikte modus voor weergave - Afbeelding, Video of YouTube - op basis van de opgegeven bron-URL."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Dient als vervanging wanneer de afbeelding niet kan worden weergegeven op het apparaat van een gebruiker en voor toegankelijkheidsdoeleinden."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Definieert de kleur van de geselecteerde emoji wanneer het type Beoordelingspictogram is ingesteld op \"Smileys\". Kies tussen: \"Standaard\" - de geselecteerde emoji verschijnt in de standaard enquêtekleur; \"Schaal\" - de geselecteerde emoji erft de kleur van de beoordelingsschaal."
// expression.name: "An expression ID that is not visible to respondents." => "Een expressie-ID die niet zichtbaar is voor respondenten."
// expression.description: "Type an expression subtitle." => "Typ de ondertitel van een expressie."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Een expressie kan basisberekeningen ('{q1_id} + {q2_id}'), voorwaarden ('{leeftijd} > 60') en functies ('iif()', 'vandaag()', 'leeftijd()', 'min()', 'max()', 'gem()', enz.) bevatten."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Selecteer deze optie om de waarde van de optie 'Overig' op te slaan als een afzonderlijke eigenschap in enquêteresultaten."
// p.swapOrder: "Swap the order of Yes and No" => "Verwissel de volgorde van Ja en Nee"
// p.itemTitleWidth: "Item label width (in px)" => "Breedte artikellabel (in px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Tekst om aan te geven of alle opties zijn geselecteerd"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Tijdelijke tekst voor het rangschikkingsgebied"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Vul de enquête automatisch in"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Selecteer of u wilt dat de enquête automatisch wordt ingevuld nadat een respondent alle vragen heeft beantwoord."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Gemaskeerde waarde opslaan in enquêteresultaten"
// patternmask.pattern: "Value pattern" => "Waardepatroon"
// datetimemask.min: "Minimum value" => "Minimumwaarde"
// datetimemask.max: "Maximum value" => "Maximale waarde"
// numericmask.allowNegativeValues: "Allow negative values" => "Negatieve waarden toestaan"
// numericmask.thousandsSeparator: "Thousands separator" => "Scheidingsteken voor duizendtallen"
// numericmask.decimalSeparator: "Decimal separator" => "Decimaalteken"
// numericmask.precision: "Value precision" => "Waarde precisie"
// numericmask.min: "Minimum value" => "Minimumwaarde"
// numericmask.max: "Maximum value" => "Maximale waarde"
// currencymask.prefix: "Currency prefix" => "Valuta voorvoegsel"
// currencymask.suffix: "Currency suffix" => "Valuta achtervoegsel"
// pe.maskType: "Input mask type" => "Type invoermasker"
// maskTypes.patternmask: "Pattern" => "Patroon"
// maskTypes.numericmask: "Numeric" => "Numeriek"
// maskTypes.datetimemask: "Date and Time" => "Datum en tijd"
// maskTypes.currencymask: "Currency" => "Valuta"
// tabs.mask: "Input Mask Settings" => "Instellingen voor invoermasker"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Vb.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Bijv.: mm/dd/jjjj"
// pe.currencyprefix_placeholder: "Ex.: $" => "Bijv.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Bijv.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Wrap-keuzes"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Lange teksten in keuze-opties genereren automatisch regeleinden die in het vervolgkeuzemenu passen. Schakel de selectie uit als u wilt dat de teksten worden afgekapt."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Selecteer of u de vraagwaarde met een toegepast masker wilt opslaan in enquêteresultaten."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Het patroon kan letterlijke tekenreeksen en de volgende tijdelijke aanduidingen bevatten: '9' - voor een cijfer; \"a\" - voor een hoofdletter of kleine letter; '#' - voor een cijfer of een hoofdletter of kleine letter. Gebruik backslash '\\' om een teken te escapen."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Het patroon kan scheidingstekens en de volgende tijdelijke aanduidingen bevatten: 'm' - voor maandnummer; 'mm' - voor maandnummer, met voorloopnul voor eencijferige waarden; 'd' - voor dag van de maand; 'dd' - voor dag van de maand, met voorloopnul voor eencijferige waarden; \"yy\" - voor de laatste twee cijfers van het jaar; 'yyyy' - voor een jaar van vier cijfers."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Een symbool dat wordt gebruikt om het fractionele deel te scheiden van het gehele deel van een weergegeven getal."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Een symbool dat wordt gebruikt om de cijfers van een groot getal in groepen van drie te scheiden."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Hiermee beperkt u het aantal cijfers dat moet worden behouden na de komma voor een weergegeven getal."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Een of meer symbolen die vóór de waarde moeten worden weergegeven."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Een of meer symbolen die na de waarde moeten worden weergegeven."
// ed.translationSource: "Source: " => "Bron: "
// ed.translationTarget: "Target: " => "Doel: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "De pagina is leeg. Sleep een element uit de gereedschapskist of klik op de knop hieronder."
// maskTypes.none: "None" => "Geen"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Maak de rij zichtbaar als"
// itemvalue@rows.enableIf: "Make the row editable if" => "De rij bewerkbaar maken als:"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Tijdelijke tekst in de modus Alleen-lezen of voorvertoning"
// pe.textWrapEnabled: "Wrap choices" => "Wrap-keuzes"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "De optie \"Auto\" bepaalt automatisch de geschikte modus voor weergave - Afbeelding, Video of YouTube - op basis van de opgegeven bron-URL."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Kies tussen \"Afbeelding\" en \"Video\" om de inhoudsmodus van de mediakiezer in te stellen. Als \"Afbeelding\" is geselecteerd, zorg er dan voor dat alle beschikbare opties afbeeldingsbestanden zijn in de volgende formaten: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Evenzo, als \"Video\" is geselecteerd, zorg er dan voor dat alle opties directe links zijn naar videobestanden in de volgende formaten: MP4, MOV, WMV, FLV, AVI, MKV. Houd er rekening mee dat YouTube-links niet worden ondersteund voor video-opties."
// ed.selectFile: "Select a file" => "Selecteer een bestand"
// ed.removeFile: "Remove the file" => "Verwijder het bestand"
// pe.searchMode: "Search Mode" => "Zoekmodus"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Klik hieronder op de knop \"Vraag toevoegen\" om te beginnen met het maken van uw formulier."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Klik op de knop \"Vraag toevoegen\" hieronder om een nieuw element aan de pagina toe te voegen."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Klik op de knop \"Vraag toevoegen\" hieronder om een nieuw element aan het paneel toe te voegen."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Klik op de onderstaande knop en kies een afbeelding om te uploaden"
// coloralpha.opacity: "Opacity" => "Dekking"
// font.family: "Font family" => "Lettertype familie"
// font.color: "Color" => "Kleur"
// font.placeholderColor: "Placeholder color" => "Tijdelijke aanduiding voor kleur"
// font.size: "Size" => "Grootte"
// theme.themeName: "Theme" => "Thema"
// theme.isPanelless: "Question appearance" => "Weergave van de vraag"
// theme.editorPanel: "Background and corner radius" => "Achtergrond en hoekradius"
// theme.questionPanel: "Background and corner radius" => "Achtergrond en hoekradius"
// theme.primaryColor: "Accent color" => "Accent kleur"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Dekking van de achtergrond van het deelvenster"
// theme.questionBackgroundTransparency: "Question background opacity" => "Ondoorzichtigheid van de achtergrond van de vraag"
// theme.fontSize: "Font size" => "Tekengrootte"
// theme.scale: "Scale" => "Schub"
// theme.cornerRadius: "Corner radius" => "De straal van de hoek"
// theme.pageTitle: "Title font" => "Titel lettertype"
// theme.pageDescription: "Description font" => "Beschrijving lettertype"
// theme.questionTitle: "Title font" => "Titel lettertype"
// theme.questionDescription: "Description font" => "Beschrijving lettertype"
// theme.editorFont: "Font" => "Lettertype"
// theme.backgroundOpacity: "Opacity" => "Dekking"
// theme.--sjs-font-family: "Font family" => "Lettertype familie"
// theme.--sjs-general-backcolor-dim: "Background color" => "Achtergrondkleur"
// theme.--sjs-primary-backcolor: "Accent background" => "De achtergrond van het accent"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Accent voorgrond"
// theme.--sjs-shadow-small: "Shadow effects" => "Schaduweffecten"
// theme.--sjs-shadow-inner: "Shadow effects" => "Schaduweffecten"
// theme.--sjs-border-default: "Colors" => "Kleuren"
// header@header.headerView: "View" => "Bekijken"
// header@header.logoPosition: "Logo position" => "Positie van het logo"
// header@header.surveyTitle: "Survey title font" => "Lettertype van de titel van de enquête"
// header@header.surveyDescription: "Survey description font" => "Lettertype voor enquêtebeschrijving"
// header@header.headerTitle: "Survey title font" => "Lettertype van de titel van de enquête"
// header@header.headerDescription: "Survey description font" => "Lettertype voor enquêtebeschrijving"
// header@header.inheritWidthFrom: "Content area width" => "Breedte inhoudsgebied"
// header@header.textAreaWidth: "Text width" => "Breedte van de tekst"
// header@header.backgroundColorSwitch: "Background color" => "Achtergrondkleur"
// header@header.backgroundImage: "Background image" => "Achtergrondafbeelding"
// header@header.backgroundImageOpacity: "Opacity" => "Dekking"
// header@header.overlapEnabled: "Overlap" => "Overlappen"
// header@header.logoPositionX: "Logo position" => "Positie van het logo"
// header@header.titlePositionX: "Title position" => "Titel positie"
// header@header.descriptionPositionX: "Description position" => "Beschrijving positie"
// weight.400: "Regular" => "Regelmatig"
// weight.600: "Heavy" => "Zwaar"
// weight.700: "Semi-bold" => "Semi-vet"
// weight.800: "Bold" => "Brutaal"
// backgroundImageFit.auto: "Auto" => "Auto"
// backgroundImageFit.cover: "Cover" => "Bedekken"
// backgroundImageFit.contain: "Contain" => "Bevatten"
// backgroundImageFit.fill: "Stretch" => "Strekken"
// backgroundImageFit.tile: "Tile" => "Tegel"
// backgroundImageAttachment.fixed: "Fixed" => "Vast"
// backgroundImageAttachment.scroll: "Scroll" => "Scrollen"
// headerView.basic: "Basic" => "Basisch"
// headerView.advanced: "Advanced" => "Geavanceerd"
// inheritWidthFrom.survey: "Same as survey" => "Zelfde als enquête"
// inheritWidthFrom.container: "Fit to container" => "Aanpassen aan container"
// backgroundColorSwitch.none: "None" => "Geen"
// backgroundColorSwitch.accentColor: "Accent color" => "Accent kleur"
// backgroundColorSwitch.custom: "Custom" => "Gewoonte"
// colorPalette.light: "Light" => "Licht"
// colorPalette.dark: "Dark" => "Donker"
// isPanelless.false: "Default" => "Verstek"
// isPanelless.true: "Without Panels" => "Zonder panelen"
// theme.cornerRadius: "Corner radius" => "De straal van de hoek"
// theme.fontFamily: "Font family" => "Lettertype familie"
// theme.fontWeightRegular: "Regular" => "Regelmatig"
// theme.fontWeightHeavy: "Heavy" => "Zwaar"
// theme.fontWeightSemiBold: "Semi-bold" => "Semi-vet"
// theme.fontWeightBold: "Bold" => "Brutaal"
// theme.color: "Color" => "Kleur"
// theme.placeholderColor: "Placeholder color" => "Tijdelijke aanduiding voor kleur"
// theme.size: "Size" => "Grootte"
// theme.opacity: "Opacity" => "Dekking"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Typ om te zoeken..."
// ed.toolboxNoResultsFound: "No results found" => "Geen resultaten gevonden"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Tijdelijke aanduiding voor tabtitel"
// theme.--sjs-special-red: "Error messages" => "Foutberichten"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Een terugvaltekst voor tabbladtitels die van toepassing is wanneer het patroon van de tabbladtitel geen zinvolle waarde oplevert."
// theme.fontColor: "Font color" => "Tekstkleur"
// theme.backgroundColor: "Background color" => "Achtergrondkleur"
// pe.questionTitleWidth: "Question title width" => "Breedte van de vraagtitel"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Selecteer een bestand of plak een bestandslink..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Bijv.: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Hiermee stelt u een consistente breedte in voor vraagtitels wanneer deze links van de vraagvakken zijn uitgelijnd. Accepteert CSS-waarden (px, %, in, pt, enz.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Hiermee stelt u een consistente breedte in voor vraagtitels wanneer deze links van de vraagvakken zijn uitgelijnd. Accepteert CSS-waarden (px, %, in, pt, enz.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Hoogte commentaargebied (in lijnen)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Hiermee stelt u het aantal weergegeven regels in tekstgebieden in voor opmerkingen bij vragen. In de invoer neemt meer regels in beslag, de schuifbalk verschijnt."


/***/ }),

/***/ "./src/localization/finnish.ts":
/*!*************************************!*\
  !*** ./src/localization/finnish.ts ***!
  \*************************************/
/*! exports provided: fiStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fiStrings", function() { return fiStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var fiStrings = {
    // survey templates
    survey: {
        edit: "Muokkaa",
        externalHelpLink: "Katso ja opi luomaan kyselyjä",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Pudota kysymys Työkalupakista tähän.",
        addLogicItem: "Luo sääntö mukauttamaan kyselyn kulkua.",
        copy: "Kopioi",
        duplicate: "Monista",
        addToToolbox: "Lisää Työkalupakkiin",
        deletePanel: "Poista Paneeli",
        deleteQuestion: "Poista Kysymys",
        convertTo: "Konvertoi",
        drag: "Vedä elementtiä",
    },
    // Creator tabs
    tabs: {
        preview: "Testaa kysely",
        theme: "Teemoja",
        translation: "Käännös",
        designer: "Kyselyn suunnittelija",
        editor: "JSON Editori",
        logic: "Kysely logiikka"
    },
    // Question types
    qt: {
        default: "Oletusarvo",
        checkbox: "Valintaruutu",
        comment: "Kommentti",
        imagepicker: "Kuvanvalitsin",
        ranking: "Sijoitus",
        image: "Kuva",
        dropdown: "Pudotusvalikko",
        tagbox: "Avattava monivalintavalikko",
        file: "Tiedosto",
        html: "Html",
        matrix: "Matrix (yksi valinta)",
        matrixdropdown: "Matrix (monivalinta)",
        matrixdynamic: "Matrix (dynaamiset rivit)",
        multipletext: "Useita tekstejä",
        panel: "Paneeli",
        paneldynamic: "Paneeli (dynaamiset paneelit)",
        radiogroup: "Radiopainikeryhmä",
        rating: "Luokitus",
        text: "Teksti",
        boolean: "Totuusarvomuuttuja",
        expression: "Lauseke(vain luku)",
        signaturepad: "Allekirjoitusalusta",
        buttongroup: "Painike-ryhmä"
    },
    toolboxCategories: {
        general: "Yleinen",
        choice: "Valintaa koskevat kysymykset",
        text: "Tekstinsyöttökysymykset",
        containers: "Säiliöt",
        matrix: "Matriisin kysymykset",
        misc: "Muut"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Vakio ({0})",
        survey: "Kysely",
        settings: "Kyselyn asetukset",
        settingsTooltip: "Avaa kyselyn asetukset",
        surveySettings: "Kyselyn asetukset",
        surveySettingsTooltip: "Kyselyn asetukset",
        themeSettings: "Teeman asetukset",
        themeSettingsTooltip: "Teeman asetukset",
        showPanel: "Näytä Paneeli",
        hidePanel: "Piilota Paneeli",
        prevSelected: "Valitse edellinen",
        nextSelected: "Valitse seuraava",
        prevFocus: "Keskity edelliseen",
        nextFocus: "Keskity seuraavaksi",
        surveyTypeName: "Tutkimus",
        pageTypeName: "Sivu",
        panelTypeName: "Paneeli",
        questionTypeName: "Kysymys",
        columnTypeName: "Sarake",
        addNewPage: "Lisää uusi sivu",
        moveRight: "Selaa oikealle",
        moveLeft: "Selaa vasemmalle",
        deletePage: "Poista sivu",
        editPage: "Muokkaa sivua",
        edit: "Muokkaa",
        newPageName: "sivu",
        newQuestionName: "kysymys",
        newPanelName: "paneeli",
        newTextItemName: "teksti",
        defaultV2Theme: "Laiminlyönti",
        modernTheme: "Nykyaikainen",
        defaultTheme: "Oletus (vanha)",
        testSurveyAgain: "Testaa kysely uudestaan",
        testSurveyWidth: "Kyselyn laajuus: ",
        navigateToMsg: "Sinun piti navigoida:",
        saveSurvey: "Tallenna kysely",
        saveSurveyTooltip: "Tallenna kysely",
        saveTheme: "Tallenna teema",
        saveThemeTooltip: "Tallenna teema",
        jsonHideErrors: "Piilota virheet",
        jsonShowErrors: "Näytä virheet",
        undo: "Kumoa",
        redo: "Tee uudelleen",
        undoTooltip: "Kumoa viimeinen muutos",
        redoTooltip: "Tee muutos uudelleen",
        showMoreChoices: "Näytä lisää",
        showLessChoices: "Näytä vähemmän",
        copy: "Kopioi",
        cut: "Leikkaa",
        paste: "Liitä",
        copyTooltip: "Kopioi valinta leikepöydälle",
        cutTooltip: "Leikkaa valinta leikepöydälle",
        pasteTooltip: "Liitä leikepöydältä",
        options: "Vaihtoehdot",
        generateValidJSON: "Luo kelvollinen JSON",
        generateReadableJSON: "Luo luettava JSON",
        toolbox: "Työkalupakki",
        "property-grid": "Properties",
        toolboxFilteredTextPlaceholder: "Kirjoita etsiäksesi...",
        toolboxNoResultsFound: "Tuloksia ei löytynyt",
        propertyGridFilteredTextPlaceholder: "Kirjoita etsiäksesi...",
        propertyGridNoResultsFound: "Tuloksia ei löytynyt",
        correctJSON: "Korjaa JSON.",
        surveyResults: "Kyselyn tulos:",
        surveyResultsTable: "Taulukossa",
        surveyResultsJson: "JSON:ssa",
        resultsTitle: "Kysymyksen otsikko",
        resultsName: "Kysymyksen nimi",
        resultsValue: "Vastauksen arvo",
        resultsDisplayValue: "Näytä arvo",
        modified: "Muokattu",
        saving: "Tallentaa",
        saved: "Tallennettu",
        propertyEditorError: "Virhe:",
        saveError: "Virhe! Editorin sisältöä ei ole tallennettu.",
        translationPropertyGridTitle: "Kieliasetukset",
        themePropertyGridTitle: "Teeman asetukset",
        translationLanguages: "Kielet",
        translationDeleteLanguage: "Oletko varma, että haluat poistaa kaikki merkkijonot tältä kieleltä?",
        translationAddLanguage: "Valitse käännettävä kieli",
        translationShowAllStrings: "Näytä kaikki merkkijonot",
        translationShowUsedStringsOnly: "Vain käytetyt merkkijonot",
        translationShowAllPages: "Näytä kaikki sivut",
        translationNoStrings: "Ei merkkijonoja käännettäväksi. Vaihda suodatin.",
        translationExportToSCVButton: "Vie (CSV)",
        translationImportFromSCVButton: "Tuo (CSV)",
        translateUsigAI: "Käännä kaikki automaattisesti",
        translateUsigAIFrom: "Käännös: ",
        translationDialogTitle: "Kääntämättömät merkkijonot",
        translationMergeLocaleWithDefault: "Yhdistä {0} oletuskielellä",
        translationPlaceHolder: "Käännös...",
        translationSource: "Lähde: ",
        translationTarget: "Kohde: ",
        themeExportButton: "Vienti",
        themeImportButton: "Tuoda",
        surveyJsonExportButton: "Vienti",
        surveyJsonImportButton: "Tuoda",
        surveyJsonCopyButton: "Kopioi leikepöydälle",
        themeResetButton: "Palauta teema-asetukset oletusasetuksiin",
        themeResetConfirmation: "Haluatko todella nollata teeman? Kaikki mukautuksesi menetetään.",
        themeResetConfirmationOk: "Kyllä, nollaa teema",
        bold: "Lihavoitu",
        italic: "Kursiivi",
        underline: "Alleviivaa",
        addNewQuestion: "Lisää kysymys",
        selectPage: "Valitse sivu...",
        carryForwardChoicesCopied: "Valinnat kopioidaan kohteesta",
        choicesLoadedFromWebText: "Valinnat ladataan verkkopalvelusta.",
        choicesLoadedFromWebLinkText: "Siirry asetuksiin",
        choicesLoadedFromWebPreviewTitle: "Ladattujen valintavaihtoehtojen esikatselu",
        htmlPlaceHolder: "HTML-sisältö on täällä.",
        panelPlaceHolder: "Pudota kysymys työkalupakista tähän.",
        surveyPlaceHolder: "Kysely on tyhjä. Vedä elementti työkalupakista tai napsauta alla olevaa painiketta.",
        pagePlaceHolder: "Sivu on tyhjä. Vedä elementti työkalupakista tai napsauta alla olevaa painiketta.",
        imagePlaceHolder: "Vedä ja pudota kuva tähän tai napsauta alla olevaa painiketta ja valitse ladattava kuva",
        surveyPlaceHolderMobile: "Napsauta alla olevaa Lisää kysymys -painiketta aloittaaksesi lomakkeen luomisen.",
        pagePlaceHolderMobile: "Napsauta alla olevaa Lisää kysymys -painiketta lisätäksesi sivulle uuden elementin.",
        panelPlaceHolderMobile: "Napsauta alla olevaa Lisää kysymys -painiketta lisätäksesi uuden elementin paneeliin.",
        imagePlaceHolderMobile: "Klikkaa alla olevaa painiketta ja valitse ladattava kuva",
        imageChooseImage: "Valitse kuva",
        addNewTypeQuestion: "Lisää {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Kohta ",
        selectFile: "Valitse tiedosto",
        removeFile: "Poista tiedosto",
        lg: {
            addNewItem: "Lisää uusi sääntö",
            empty_tab: "Luo sääntö kyselyn kulun mukauttamista varten.",
            page_visibilityName: "Sivun näkyvyys",
            page_enableName: "Ota käyttöön (poista käytöstä) sivu",
            page_requireName: "Tee sivusta pakollinen",
            panel_visibilityName: "Panelin näkyvyys",
            panel_enableName: "Paneeli käytössä/Ei käytössä",
            panel_requireName: "Tee sivusta pakollinen",
            question_visibilityName: "Kysymyksen näkyvyys",
            question_enableName: "Kysymys käytössä/Ei käytössä",
            question_requireName: "Kysymys valinnainen vaaditaan",
            question_resetValueName: "Palauta kysymyksen arvo",
            question_setValueName: "Aseta kysymyksen arvo",
            column_visibilityName: "Näytä (piilota) -sarake",
            column_enableName: "Ota käyttöön (poista käytöstä) sarake",
            column_requireName: "Tee sarakkeesta pakollinen",
            column_resetValueName: "Palauta sarakkeen arvo",
            column_setValueName: "Sarakkeen arvon määrittäminen",
            trigger_completeName: "Valmis kysely",
            trigger_setvalueName: "Aseta kysymyksen arvo",
            trigger_copyvalueName: "Kopioi kysymyksen arvo",
            trigger_skipName: "Ohita kysymys",
            trigger_runExpressionName: "Suorita mukautettu lauseke",
            completedHtmlOnConditionName: "Mukautettu Kiitos -sivuteksti",
            page_visibilityDescription: "Tee sivusta näkyvä, kun looginen lauseke palauttaa arvon tosi. Muuten pidä se näkymättömänä.",
            panel_visibilityDescription: "Tee paneelista näkyvä, kun looginen lauseke palauttaa arvon tosi. Muuten pidä se näkymättömänä.",
            panel_enableDescription: "Ota paneeli ja kaikki sen sisällä olevat elementit käyttöön, kun looginen lauseke palauttaa arvon tosi. Muuten pidä ne poissa käytöstä.",
            question_visibilityDescription: "Tee kysymyksestä näkyvä, kun looginen lauseke palauttaa arvon tosi. Muuten pidä se näkymättömänä.",
            question_enableDescription: "Ota kysymys käyttöön, kun looginen lauseke palauttaa arvon tosi. Muussa tapauksessa pidä se poissa käytöstä.",
            question_requireDescription: "Kysymys tulee pakolliseksi, kun looginen lauseke palauttaa arvon tosi.",
            trigger_completeDescription: "Kun looginen lauseke palauttaa arvon tosi, kysely valmistuu ja loppukäyttäjä näkee Kiitos -sivun.",
            trigger_setvalueDescription: "Kun loogisessa lausekkeessa käytettyjä kysymysarvoja muutetaan ja looginen lauseke palauttaa arvon tosi, arvo asetetaan valitulle kysymykselle.",
            trigger_copyvalueDescription: "Kun loogisessa lausekkeessa käytettyjä kysymysarvoja muutetaan ja looginen lauseke palauttaa arvon tosi, yhden valitun kysymyksen arvo kopioidaan toiseen valittuun kysymykseen.",
            trigger_skipDescription: "Kun looginen lauseke palauttaa arvon tosi, kysely siirtyy valittuun kysymykseen / kohdista valittu kysymys.",
            trigger_runExpressionDescription: "When the logic expression returns true, then the custom expression is performed. You may optionally set this expression result into the selected question",
            completedHtmlOnConditionDescription: "If the logic expression returns true, then the default text for the 'Thank you page' is changed to the given one.",
            itemExpressionText: "Kun lauseke: '{0}' palauttaa arvon tosi:",
            itemEmptyExpressionText: "Uusi sääntö",
            page_visibilityText: "Tee sivu {0} näkyväksi",
            panel_visibilityText: "Tee paneelista {0} näkyvä",
            panel_enableText: "Ota paneeli {0} käyttöön",
            question_visibilityText: "Tee kysymys {0} näkyväksi",
            question_enableText: "Ota kysymys {0} käyttöön",
            question_requireText: "Tee kysymyksestä {0} pakollinen",
            question_resetValueText: "nollaa kysymyksen arvo: {0}",
            question_setValueText: "Määritä arvo: {1} kysymykseen: {0}",
            column_visibilityText: "Tee kysymyksen {1} sarakkeesta {0} näkyvä",
            column_enableText: "Ota kysymyksen sarake {0} {1} käyttöön",
            column_requireText: "Tee kysymyksen sarake {0} {1} pakollinen",
            column_resetValueText: "Palauta sarakkeen soluarvo: {0}",
            column_setValueText: "Määritä solun arvo: {1} sarakkeeseen: {0}",
            setValueExpressionPlaceholder: " Lauseke, jonka tulos määritetään kohdekysymykselle.",
            trigger_completeText: "Kyselystä tulee täytetty",
            trigger_setvalueText: "Laita arvo {1} kysymykseen {0}",
            trigger_setvalueEmptyText: "Selkeän kysymyksen arvo: {0}",
            trigger_copyvalueText: "Kopioi kysymykseen: {0} arvo kysymyksestä {1}",
            trigger_skipText: "Siirry kyselyn kysymykseen {0}",
            trigger_runExpressionText1: "Suorita lauseke: '{0}'",
            trigger_runExpressionText2: " ja aseta sen tulos kysymykseen: {0}",
            completedHtmlOnConditionText: "Näytä mukautettu teksti Kiitos -sivulle.",
            showAllQuestions: "Kaikki kysymykset",
            showAllActionTypes: "Kaikki toimintotyypit",
            conditions: "Ehdot",
            actions: "Toiminnot",
            expressionEditorTitle: "Määritä olosuhteet",
            actionsEditorTitle: "Määritä toiminnot",
            deleteAction: "Poista toiminto",
            addNewAction: "Lisää uusi toiminto",
            selectedActionCaption: "Valitse lisättävä toiminto ...",
            expressionInvalid: "Looginen lauseke on tyhjä tai virheellinen. Korjaa se.",
            noActionError: "Lisää ainakin yksi toiminto.",
            actionInvalid: "Korjaa ongelmat toiminnoissa.",
            uncompletedRule_title: "Loogiset säännöt ovat epätäydellisiä",
            uncompletedRule_text: "Et ole suorittanut joitakin loogisia sääntöjä. Jos poistut välilehdestä nyt, muutokset menetetään. Haluatko silti poistua välilehdeltä suorittamatta muutoksia?",
            uncompletedRule_apply: "Kyllä",
            uncompletedRule_cancel: "Ei, haluan täyttää säännöt"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Paneelin nimi",
            title: "Paneelin otsikko",
            description: "Paneelin kuvaus",
            visibleIf: "Tee paneeli näkyväksi, jos",
            requiredIf: "Tee paneeli pakolliseksi, jos",
            questionsOrder: "Kyselyjärjestys paneelissa",
            page: "Pääsivu",
            startWithNewLine: "Näytä paneeli uudella rivillä",
            state: "Paneelin tiivistystila",
            width: "Tekstiin sidotun paneelin leveys",
            minWidth: "Paneelin vähimmäisleveys",
            maxWidth: "Paneelin enimmäisleveys",
            showNumber: "Numeropaneelit"
        },
        paneldynamic: {
            name: "Paneelin nimi",
            title: "Paneelin otsikko",
            description: "Paneelin kuvaus",
            visibleIf: "Tee paneeli näkyväksi, jos",
            requiredIf: "Tee paneeli pakolliseksi, jos",
            page: "Paneelin siirtäminen sivulle",
            startWithNewLine: "Näytä paneeli uudella rivillä",
            state: "Paneelin tiivistystila",
            width: "Tekstiin sidotun paneelin leveys",
            minWidth: "Paneelin vähimmäisleveys",
            maxWidth: "Paneelin enimmäisleveys",
            confirmDelete: "Vahvista paneelin poisto",
            templateDescription: "Paneelin kuvauskuvio",
            templateTitle: "Paneelin otsikkomalli",
            noEntriesText: "Tyhjä paneelin teksti",
            templateTabTitle: "Välilehden otsikkomalli",
            tabTitlePlaceholder: "Välilehden otsikon paikkamerkki",
            templateVisibleIf: "Tee yksittäinen paneeli näkyväksi, jos",
            hideNumber: "Piilota paneelin numero",
            titleLocation: "Paneelin otsikon tasaus",
            descriptionLocation: "Paneelin kuvauksen tasaus",
            templateTitleLocation: "Kysymyksen otsikon tasaus",
            templateErrorLocation: "Virhesanoman tasaus",
            newPanelPosition: "Uusi paneelin sijainti",
            keyName: "Päällekkäisten vastausten estäminen seuraavassa kysymyksessä"
        },
        question: {
            name: "Kysymyksen nimi",
            title: "Kysymyksen otsikko",
            description: "Kysymyksen kuvaus",
            visibleIf: "Tee kysymys näkyväksi, jos",
            requiredIf: "Tee kysymys pakolliseksi, jos",
            page: "Pääsivu",
            state: "Kysymysruudun tiivistystila",
            hideNumber: "Piilota kysymyksen numero",
            titleLocation: "Kysymyksen otsikon tasaus",
            descriptionLocation: "Kysymyksen kuvauksen tasaus",
            errorLocation: "Virhesanoman tasaus",
            indent: "Suurentaa sisintä sisennystä",
            width: "Tekstiin sitoutuvan kysymyksen leveys",
            minWidth: "Kysymyksen vähimmäisleveys",
            maxWidth: "Kysymyksen enimmäisleveys",
            textUpdateMode: "Päivitä syöttökentän arvo"
        },
        signaturepad: {
            signatureWidth: "Allekirjoitusalueen leveys",
            signatureHeight: "Allekirjoitusalueen korkeus",
            signatureAutoScaleEnabled: "Allekirjoitusalueen automaattinen skaalaus",
            showPlaceholder: "Paikkamerkin näyttäminen",
            placeholder: "Paikkamerkkiteksti",
            placeholderReadOnly: "Paikkamerkkiteksti vain luku -tilassa tai esikatselutilassa",
            allowClear: "Näytä Tyhjennä-painike allekirjoitusalueella",
            penMinWidth: "Kynän vähimmäisleveys",
            penMaxWidth: "Kynän enimmäisleveys",
            penColor: "Iskun väri"
        },
        comment: {
            rows: "Syöttökentän korkeus (viivoina)"
        },
        showQuestionNumbers: "Näytä kysymysnumerot",
        questionStartIndex: "Kysymyksen aloitus indeksi (1, 2 or 'A', 'a')",
        expression: {
            name: "Lausekkeen nimi",
            title: "Lausekkeen otsikko",
            description: "Lausekkeen kuvaus",
            expression: "Lauseke"
        },
        trigger: {
            expression: "Lauseke"
        },
        calculatedvalue: {
            expression: "Lauseke"
        },
        // survey templates
        survey: {
            title: "Nimike",
            description: "Tutkimuksen kuvaus"
        },
        page: {
            name: "Sivun nimi",
            title: "Nimike",
            description: "Sivun kuvaus",
            visibleIf: "Tee sivusta näkyvä, jos",
            requiredIf: "Tee sivusta pakollinen, jos",
            maxTimeToFinish: "Sivun viimeistelyn aikaraja (sekunteina)",
            questionsOrder: "Kyselyjärjestys sivulla"
        },
        matrixdropdowncolumn: {
            name: "Sarakkeen nimi",
            title: "Sarakkeen otsikko",
            isUnique: "Päällekkäisten vastausten estäminen",
            width: "Sarakeleveys",
            minWidth: "Sarakkeen vähimmäisleveys",
            rows: "Syöttökentän korkeus (viivoina)",
            visibleIf: "Tee sarakkeesta näkyvä, jos",
            requiredIf: "Tee sarakkeesta pakollinen, jos",
            showInMultipleColumns: "Jokainen vaihtoehto erillisessä sarakkeessa"
        },
        multipletextitem: {
            name: "Nimi",
            title: "Nimike"
        },
        masksettings: {
            saveMaskedValue: "Peitetyn arvon tallentaminen kyselyn tuloksiin"
        },
        patternmask: {
            pattern: "Arvon kuvio"
        },
        datetimemask: {
            min: "Pienin arvo",
            max: "Suurin arvo"
        },
        numericmask: {
            allowNegativeValues: "Salli negatiiviset arvot",
            thousandsSeparator: "Tuhansien erotin",
            decimalSeparator: "Desimaalierotin",
            precision: "Arvon tarkkuus",
            min: "Pienin arvo",
            max: "Suurin arvo"
        },
        currencymask: {
            prefix: "Valuutan etuliite",
            suffix: "Valuutan jälkiliite"
        },
        imageHeight: "Kuvan korkeus",
        imageWidth: "Kuvan leveys",
        valueName: "Arvon nimi",
        rateDescriptionLocation: "Otsikon tasaus",
        size: "Syöttökentän koko (merkkeinä)",
        cellErrorLocation: "Solun virhesanoman tasaus",
        apply: "Käytä",
        ok: "OK",
        save: "Tallenna",
        clear: "Selvä",
        saveTooltip: "Tallenna",
        cancel: "Peruuta",
        set: "Joukko",
        reset: "Nollaa",
        change: "Muuttaa",
        refresh: "Päivitä",
        close: "Sulkea",
        delete: "Poista",
        add: "Lisää",
        addNew: "Lisää uusi",
        addItem: "Klikkaa lisätäksesi uusi kohde...",
        removeItem: "Poista kohde napsauttamalla...",
        dragItem: "Kohteen vetäminen",
        addOther: "Muu",
        addSelectAll: "Valitse kaikki",
        addNone: "Ei mitään",
        removeAll: "Poista kaikki",
        edit: "Muokkaa",
        back: "Palaa tallentamatta",
        backTooltip: "Palaa tallentamatta",
        saveAndBack: "Tallenna ja palaa",
        saveAndBackTooltip: "Tallenna ja palaa",
        doneEditing: "Valmis",
        editChoices: "Muokkaa valintoja",
        showChoices: "Näytä valinnat",
        move: "Siirrä",
        empty: "<tyhjä>",
        emptyValue: "Arvo on tyhjä",
        fastEntry: "Nopea pääsy",
        fastEntryNonUniqueError: "Arvo \"{0}\" ei ole ainutkertainen",
        fastEntryChoicesCountError: "Rajoita tuotteiden määrä {0} {1}",
        fastEntryChoicesMinCountError: "Anna vähintään {0} kohdetta",
        fastEntryPlaceholder: "Voit asettaa tiedot seuraavassa muodossa:\narvo1|teksti\narvo2",
        formEntry: "Lomakkeen pääsy",
        testService: "Testaa palvelu",
        itemSelectorEmpty: "Valitse elementti",
        conditionActionEmpty: "Valitse toiminto",
        conditionSelectQuestion: "Valitse kysymys...",
        conditionSelectPage: "Valitse sivu...",
        conditionSelectPanel: "Valitse paneeli...",
        conditionValueQuestionTitle: "Syötä / valitse arvo",
        aceEditorHelp: "Paina ctrl + välilyönti saadaksesi lausekkeen täydennysvihje",
        aceEditorRowTitle: "Nykyinen rivi",
        aceEditorPanelTitle: "Nykyinen paneeli",
        showMore: "Katso lisätietoja dokumentaatiosta",
        assistantTitle: "Saatavilla olevat kysymykset:",
        cellsEmptyRowsColumns: "Sarakkeita tai rivejä on oltava vähintään yksi",
        showPreviewBeforeComplete: "Esikatsele vastauksia ennen kyselyn lähettämistä",
        overridingPropertyPrefix: "Asettaja ",
        resetToDefaultCaption: "Nollata",
        propertyIsEmpty: "Anna arvo",
        propertyIsNoUnique: "Anna yksilöllinen arvo",
        propertyNameIsNotUnique: "Anna yksilöllinen nimi",
        propertyNameIsIncorrect: "Älä käytä varattuja sanoja: \"kohde\", \"valinta\", \"paneeli\", \"rivi\".",
        listIsEmpty: "Lisää uusi kohde",
        "listIsEmpty@choices": "Vaihtoehtoja ei ole vielä lisätty",
        "listIsEmpty@columns": "Sinulla ei ole vielä sarakkeita",
        "listIsEmpty@rows": "Sinulla ei ole vielä rivejä",
        "listIsEmpty@validators": "Sinulla ei ole vielä vahvistussääntöjä",
        "listIsEmpty@calculatedValues": "Sinulla ei ole vielä mukautettuja muuttujia",
        "listIsEmpty@triggers": "Sinulla ei ole vielä käynnistimiä",
        "listIsEmpty@navigateToUrlOnCondition": "Sinulla ei ole vielä linkkejä",
        "addNew@choices": "Lisää vaihtoehto",
        "addNew@columns": "Lisää uusi sarake",
        "addNew@rows": "Lisää uusi rivi",
        "addNew@validators": "Lisää uusi sääntö",
        "addNew@calculatedValues": "Lisää uusi muuttuja",
        "addNew@triggers": "Lisää uusi käynnistin",
        "addNew@navigateToUrlOnCondition": "Lisää uusi URL-osoite",
        expressionIsEmpty: "Lauseke on tyhjä",
        value: "Arvo",
        text: "Teksti",
        rowid: "Rivi ID",
        imageLink: "Kuvalinkki",
        columnEdit: "Muokkaa saraketta: {0}",
        itemEdit: "Muokkaa kohdetta: {0}",
        url: "URL",
        path: "Polku",
        choicesbyurl: {
            url: "Verkkopalvelun URL-osoite",
            valueName: "Hae arvot seuraavasta JSON-kentästä"
        },
        titleName: "Otsikon nimi",
        imageLinkName: "Hae kuvien URL-osoitteet seuraavasta JSON-kentästä",
        allowEmptyResponse: "Salli tyhjä vastaus",
        titlePlaceholder: "Syötä otsikko tähän",
        surveyTitlePlaceholder: "Syötä kyselyn otsikko tähän",
        pageTitlePlaceholder: "Syötä sivun otsikko tähän",
        descriptionPlaceholder: "Lisää kuvaus",
        surveyDescriptionPlaceholder: "Lisää kyselyn kuvaus",
        pageDescriptionPlaceholder: "Lisää sivun kuvaus",
        textWrapEnabled: "Kääri valinnat",
        showOtherItem: "On muu",
        otherText: "Muu teksti",
        showNoneItem: "Ei mitään",
        showRefuseItem: "Salli Kieltäydy vastaamasta -vaihtoehto",
        showDontKnowItem: "Salli En tiedä -vaihtoehto",
        noneText: "Ei mitään tekstiä",
        showSelectAllItem: "On valinnut kaikki",
        selectAllText: "Valitse kaikki tekstit",
        choicesMin: "Automaattisesti luotujen valintojen vähimmäisarvo",
        choicesMax: "Automaattisesti luotujen valintojen enimmäisarvo",
        choicesStep: "Automaattisesti luotujen valintojen ero",
        name: "Nimi",
        title: "Otsikko",
        cellType: "Solutyyppi",
        colCount: "Sarakemäärä",
        choicesOrder: "Valitse valintojen järjestys",
        visible: "On näkyvä?",
        isRequired: "On vaadittu?",
        markRequired: "Merkitse pakollisesti",
        removeRequiredMark: "Poista vaadittu merkki",
        isAllRowRequired: "Vaadi vastaus kaikille riveille",
        eachRowUnique: "Estä päällekkäiset vastaukset riveillä",
        requiredErrorText: "Vaadittu virheteksti",
        startWithNewLine: "Onko aloitus uudella rivillä?",
        rows: "Rivit",
        cols: "Sarakeet",
        placeholder: "Syötä paikkamerkintä",
        showPreview: "Näytä esikatselu",
        storeDataAsText: "Tallenna tiedostosisältö JSON-tulokseen tekstinä",
        maxSize: "Tiedoston enimmäiskoko tavuina",
        rowCount: "Rivien määrä",
        columnLayout: "Sarakkeiden asettelu",
        addRowLocation: "Lisää rivipainikkeen sijainti",
        transposeData: "Rivien transponointi sarakkeisiin",
        addRowText: "Lisää rivipainikkeen teksti",
        removeRowText: "Poista rivipainikkeen teksti",
        rateMin: "Vähimmäismäärä",
        rateMax: "Enimmäismäärä",
        rateStep: "Arvostele askel",
        minRateDescription: "Vähimmäismäärän kuvaus",
        maxRateDescription: "Enimmäismäärän kuvaus",
        inputType: "Syötä tyyppi",
        optionsCaption: "Vaihtoehdot kuvateksti",
        defaultValue: "Oletusarvo",
        cellsDefaultRow: "Oletussolutekstit",
        surveyEditorTitle: "Muokkaa kyselyn asetuksia",
        qEditorTitle: "Muokkaa: {0}",
        maxLength: "Enimmäispituus",
        buildExpression: "Luo",
        editExpression: "Muokkaa",
        and: "ja",
        or: "tai",
        remove: "Poista",
        addCondition: "Lisää ehto",
        emptyLogicPopupMessage: "Aloita ehtojen määrittäminen valitsemalla kysymys.",
        if: "Jos",
        then: "sitten",
        setToName: "Kohteen kysymys",
        fromName: "Kysymys, josta vastaus kopioidaan",
        gotoName: "Kysymys, johon kannattaa siirtyä",
        ruleIsNotSet: "Sääntö on virheellinen",
        includeIntoResult: "Sisällytä kyselyn tuloksiin",
        showTitle: "Näytä/piilota otsikko",
        expandCollapseTitle: "Laajenna / tiivistä otsikkoa",
        locale: "Oletus kieli",
        simulator: "Valitse laite",
        landscapeOrientation: "Vaakasuunta",
        portraitOrientation: "Pystysuuntaan vaihtaminen",
        mode: "Tila (vain muokkaus / vain luku)",
        clearInvisibleValues: "Tyhjennä näkymättömät arvot",
        cookieName: "Evästeen nimi (poistaaksesi kysely käytöstä suorita kysely kaksi kertaa paikallisesti)",
        sendResultOnPageNext: "Lähetä kyselyn tulokset seuraavalla sivulla",
        storeOthersAsComment: "Tallenna 'muut' arvo erilliseen kenttään",
        showPageTitles: "Näytä sivun otsikot",
        showPageNumbers: "Näytä sivunumerot",
        pagePrevText: "Edellinen sivu -painikkeen teksti",
        pageNextText: "Seuraava sivu -painikkeen teksti",
        completeText: "Valmis -painikkeen teksti",
        previewText: "Esikatsele -painikkeen teksti",
        editText: "Muokkaa -painikkeen teksti",
        startSurveyText: "Aloita -painikkeen teksti",
        showNavigationButtons: "Näytä navigointipainikkeet (oletusnavigointi)",
        showPrevButton: "Näytä edellinen -painike (käyttäjä voi palata edelliselle sivulle)",
        firstPageIsStarted: "Kyselyn ensimmäinen sivu on aloitussivu.",
        showCompletedPage: "Näytä valmis sivu lopussa (completeHtml)",
        goNextPageAutomatic: "Kun vastaat kaikkiin kysymyksiin, siirry seuraavalle sivulle automaattisesti",
        allowCompleteSurveyAutomatic: "Vastaa kyselyyn automaattisesti",
        showProgressBar: "Näytä edistymispalkki",
        questionTitleLocation: "Kysymyksen otsikon sijainti",
        questionTitleWidth: "Kysymyksen otsikon leveys",
        requiredText: "Kysymys vaadittu symboli (t)",
        questionTitleTemplate: "Kysymyksen otsikkomalli, oletusarvo: '{no}. {require} {title}'",
        questionErrorLocation: "Kysymyksen virheen sijainti",
        focusFirstQuestionAutomatic: "Fokusoi ensimmäiseen kysymykseen sivun vaihtuessa",
        questionsOrder: "Elementtien järjestys sivulla",
        maxTimeToFinish: "Enimmäisaika saada kysely täytettyä",
        maxTimeToFinishPage: "Enimmäisaika kyselyn sivun täyttämiseen",
        showTimerPanel: "Näytä ajastus -paneeli",
        showTimerPanelMode: "Näytä ajastus -paneelin tila",
        renderMode: "Renderöinnin tila",
        allowAddPanel: "Salli paneelin lisääminen",
        allowRemovePanel: "Salli paneelin poistaminen",
        panelAddText: "Paneelin tekstin lisääminen",
        panelRemoveText: "Paneelin tekstin poistaminen",
        isSinglePage: "Näytä kaikki elementit yhdellä sivulla",
        html: "Html",
        setValue: "Vastata",
        dataFormat: "Kuvan muoto",
        allowAddRows: "Salli rivien lisääminen",
        allowRemoveRows: "Salli rivien poistaminen",
        allowRowsDragAndDrop: "Salli rivin vetäminen ja pudottaminen",
        responsiveImageSizeHelp: "Ei sovelleta, jos määrität kuvan tarkan leveyden tai korkeuden.",
        minImageWidth: "Kuvan vähimmäisleveys",
        maxImageWidth: "Kuvan enimmäisleveys",
        minImageHeight: "Kuvan vähimmäiskorkeus",
        maxImageHeight: "Kuvan enimmäiskorkeus",
        minValue: "Vähimmäisarvo",
        maxValue: "Suurin arvo",
        minLength: "Vähimmäispituus",
        allowDigits: "Salli numerot",
        minCount: "Vähimmäismäärä",
        maxCount: "Enimmäismäärä",
        regex: "Regular expression",
        surveyvalidator: {
            text: "Virheviesti",
            expression: "Vahvistuksen lauseke"
        },
        totalText: "Rivin teksti yhteensä",
        totalType: "Tyyppi yhteensä",
        totalExpression: "Kokonaislauseke",
        totalDisplayStyle: "Kokonaisarvon näyttötyyli",
        totalCurrency: "Valuutta",
        totalFormat: "Muotoiltu merkkijono",
        logo: "Logo (URL-osoite tai base64-koodattu merkkijono)",
        questionsOnPageMode: "Kyselyn rakenne",
        maxTextLength: "Vastauksen enimmäispituus (merkkeinä)",
        maxOthersLength: "Kommentin enimmäispituus (merkkeinä)",
        commentAreaRows: "Kommenttialueen korkeus (riveinä)",
        autoGrowComment: "Laajenna kommenttialue tarvittaessa automaattisesti",
        allowResizeComment: "Salli käyttäjien muuttaa tekstialueiden kokoa",
        textUpdateMode: "Tekstikysymyksen arvon päivittäminen",
        maskType: "Syöttörajoitteen tyyppi",
        maskTypes: {
            none: "Ei lainkaan",
            patternmask: "Kuvio",
            numericmask: "Numeerinen",
            datetimemask: "Päivämäärä ja kellonaika",
            currencymask: "Valuutta"
        },
        focusOnFirstError: "Aseta kohdistus ensimmäiseen virheelliseen vastaukseen",
        checkErrorsMode: "Suorita vahvistus",
        navigateToUrl: "Siirry URL-osoitteeseen",
        navigateToUrlOnCondition: "Dynaaminen URL-osoite",
        completedBeforeHtml: "Merkintä, joka osoittaa, onko käyttäjä jo täyttänyt tämän kyselyn",
        completedHtml: "Kyselyn sivujen merkinnät suoritettu",
        completedHtmlOnCondition: "Dynaaminen kysely viimeistelee sivun merkinnät",
        loadingHtml: "Merkintä, joka näkyy, kun kyselymalli latautuu",
        commentText: "Kommenttialueen teksti",
        autocomplete: "Automaattisen täydennyksen tyyppi",
        labelTrue: "\"True\"-merkintä",
        labelFalse: "Epätosi-tunniste",
        allowClear: "Näytä Tyhjennä-painike",
        searchMode: "Hakutila",
        displayStyle: "Arvon näyttötyyli",
        format: "Muotoiltu merkkijono",
        maximumFractionDigits: "Murtolukujen enimmäismäärä",
        minimumFractionDigits: "Murtolukujen vähimmäismäärä",
        useGrouping: "Näytä ryhmittelyerottimet",
        allowMultiple: "Salli useita tiedostoja",
        allowImagesPreview: "Esikatsele kuvia",
        acceptedTypes: "Hyväksytyt tiedostotyypit",
        waitForUpload: "Odota, että lataus on valmis",
        needConfirmRemoveFile: "Vahvista tiedoston poistaminen",
        detailPanelMode: "Yksityiskohtapaneelin sijainti",
        minRowCount: "Rivien vähimmäismäärä",
        maxRowCount: "Rivien enimmäismäärä",
        confirmDelete: "Vahvista rivin poisto",
        confirmDeleteText: "Vahvistussanoma",
        panelCount: "Paneelien alkuperäinen määrä",
        minPanelCount: "Paneelien vähimmäismäärä",
        maxPanelCount: "Paneelien enimmäismäärä",
        panelsState: "Sisäpaneelin laajennustila",
        panelPrevText: "Edellinen paneeli -painikkeen työkaluvihje",
        panelNextText: "Seuraava paneeli -painikkeen työkaluvihje",
        showRangeInProgress: "Näytä edistymispalkki",
        panelRemoveButtonLocation: "Poista paneelipainikkeen sijainti",
        hideIfRowsEmpty: "Piilota kysymys, jos rivejä ei ole",
        hideColumnsIfEmpty: "Piilota sarakkeet, jos rivejä ei ole",
        rateValues: "Muokatut hinta-arvot",
        rateCount: "Hintojen määrä",
        autoGenerate: "Miten korkoarvot määritetään?",
        hideIfChoicesEmpty: "Piilota kysymys, jos se ei sisällä vaihtoehtoja",
        minWidth: "Vähimmäisleveys (CSS-hyväksyttyinä arvoina)",
        maxWidth: "Suurin leveys (CSS-hyväksytyissä arvoissa)",
        width: "Leveys (CSS-hyväksytyissä arvoissa)",
        showHeader: "Näytä sarakeotsikot",
        horizontalScroll: "Näytä vaakasuora vierityspalkki",
        columnMinWidth: "Sarakkeen vähimmäisleveys (CSS-hyväksytyissä arvoissa)",
        rowTitleWidth: "Riviotsikon leveys (CSS-hyväksytyissä arvoissa)",
        valueTrue: "\"Tosi\"-arvo",
        valueFalse: "Epätosi-arvo",
        minErrorText: "Arvo on alle minimin -virhesanoma",
        maxErrorText: "\"Arvo ylittää maksimin\" -virhesanoma",
        otherErrorText: "Tyhjä kommentti -virhesanoma",
        keyDuplicationError: "Ei-yksilöllinen avainarvo -virhesanoma",
        minSelectedChoices: "Valitut valinnat vähintään:",
        maxSelectedChoices: "Valittujen vaihtoehtojen enimmäismäärä",
        showClearButton: "Näytä Tyhjennä-painike",
        logoWidth: "Logon leveys (CSS-hyväksytyissä arvoissa)",
        logoHeight: "Logon korkeus (CSS:n hyväksymissä arvoissa)",
        readOnly: "Vain luku -tilassa",
        enableIf: "Muokattavissa, jos",
        emptyRowsText: "Ei rivejä -viesti",
        separateSpecialChoices: "Erilliset erikoisvalinnat (Ei mitään, Muu, Valitse kaikki)",
        choicesFromQuestion: "Kopioi valinnat seuraavasta kysymyksestä",
        choicesFromQuestionMode: "Mitkä vaihtoehdot kopioidaan?",
        progressBarShowPageTitles: "Sivujen otsikoiden näyttäminen edistymispalkissa",
        progressBarShowPageNumbers: "Sivunumeroiden näyttäminen edistymispalkissa",
        showCommentArea: "Näytä kommenttialue",
        commentPlaceholder: "Kommenttialueen paikkamerkki",
        displayRateDescriptionsAsExtremeItems: "Näytä nopeuskuvaukset ääriarvoina",
        rowsOrder: "Rivien järjestys",
        columnsLayout: "Sarakkeen asettelu",
        columnColCount: "Sisäkkäisten sarakkeiden määrä",
        correctAnswer: "Oikea vastaus",
        defaultPanelValue: "Oletusarvot",
        cells: "Solujen tekstit",
        fileInputPlaceholder: "Valitse tiedosto tai liitä tiedostolinkki...",
        keyName: "Avainsarake",
        itemvalue: {
            visibleIf: "Tee vaihtoehto näkyväksi, jos",
            enableIf: "Tee vaihtoehdosta valittava, jos"
        },
        "itemvalue@rows": {
            visibleIf: "Tee rivistä näkyvä, jos",
            enableIf: "Tee rivistä muokattava, jos"
        },
        imageitemvalue: {
            text: "Vaihtoehtoinen teksti"
        },
        logoPosition: "Logo sijainti",
        addLogo: "Lisää logo...",
        changeLogo: "Muuta logo...",
        logoPositions: {
            none: "Poista logo",
            left: "Vasen",
            right: "Oikea",
            top: "Päällä",
            bottom: "Alla"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Paneelin asettelu"
            },
            general: "Yleinen",
            fileOptions: "Vaihtoehdot",
            html: "Html Editori",
            columns: "Sarakkeet",
            rows: "Rivit",
            choices: "Valinnat",
            items: "Kohteet",
            visibleIf: "Näkyvä jos",
            enableIf: "Käytössä jos",
            requiredIf: "Vaadittu jos",
            rateValues: "Järjestä arvot",
            choicesByUrl: "Valintoja verkosta",
            matrixChoices: "Oletus valinnat",
            multipleTextItems: "Tekstinsyötöt",
            numbering: "Numerointi",
            validators: "Validattorit",
            navigation: "Navigointi",
            question: "Kysymys",
            pages: "Sivut",
            timer: "Ajastin / tietovisa",
            calculatedValues: "Lasketut arvot",
            triggers: "Triggerit",
            templateTitle: "Mallin otsikko",
            totals: "Yhteensä",
            logic: "Logiikka",
            mask: "Syöttörajoitteen asetukset",
            layout: {
                panel: "Asettelu",
                question: "Asettelu",
                base: "Asettelu"
            },
            data: "Data",
            validation: "Validointi",
            cells: "Solut",
            showOnCompleted: "Näytä kun valmis",
            logo: "Logo kyselyn otsikossa",
            slider: "Liukusäädin",
            expression: "Lauseke",
            questionSettings: "Kysymyksen asetukset",
            header: "Otsikko",
            background: "Tausta",
            appearance: "Ulkonäkö",
            others: "Muut"
        },
        editProperty: "Muokkaa ominaisuutta'{0}'",
        items: "[ Kohteet: {0} ]",
        choicesVisibleIf: "Valinnat näkyvät, jos",
        choicesEnableIf: "Valinnat ovat valittavissa, jos",
        columnsEnableIf: "Sarakkeet ovat näkyvissä, jos",
        rowsEnableIf: "Rivit ovat näkyvissä, jos",
        innerIndent: "Sisäisten sisennysten lisääminen",
        defaultValueFromLastRow: "Oletusarvojen ottaminen viimeiseltä riviltä",
        defaultValueFromLastPanel: "Ota oletusarvot viimeisestä paneelista",
        enterNewValue: "Anna arvo.",
        noquestions: "Kyselyssä ei ole yhtään kysymystä.",
        createtrigger: "Luo triggeri",
        titleKeyboardAdornerTip: "Paina Enter -painiketta muokataksesi",
        keyboardAdornerTip: "Voit muokata kohdetta painamalla Enter -painiketta, poistaa kohteen painamalla poistopainiketta, siirtää kohdetta painamalla Alt plus nuoli ylös tai nuoli alas",
        triggerOn: "Päällä ",
        triggerMakePagesVisible: "Tee sivuista näkyviä:",
        triggerMakeQuestionsVisible: "Tee elementit näkyviksi:",
        triggerCompleteText: "Valmista kysely, jos se on onnistunut.",
        triggerNotSet: "Triggeriä ei ole asetettu",
        triggerRunIf: "Suorita jos",
        triggerSetToName: "Muuta arvoa: ",
        triggerFromName: "Kopioi arvo kohteesta: ",
        triggerRunExpression: "Suorita tämä lauseke:",
        triggerSetValue: "kohtaan: ",
        triggerGotoName: "Siirry kysymykseen:",
        triggerIsVariable: "Älä lisää muuttujaa kyselyn tulokseen.",
        triggerRunExpressionEmpty: "Anna kelvollinen lauseke",
        emptyExpressionPlaceHolder: "Kirjoita lauseke tähän...",
        noFile: "Tiedostoa ei ole valittuna",
        clearIfInvisible: "Poista arvo, jos kysymys piilotetaan",
        valuePropertyName: "Arvo-ominaisuuden nimi",
        searchEnabled: "Ota haku käyttöön",
        hideSelectedItems: "Piilota valitut kohteet",
        closeOnSelect: "Sulkee valinnan jälkeisen avattavan valikon.",
        verticalAlign: "Pystysuuntainen tasaus",
        alternateRows: "Vaihtoehtoiset rivit",
        columnsVisibleIf: "Sarakkeet ovat näkyvissä, jos",
        rowsVisibleIf: "Rivit ovat näkyvissä, jos",
        otherPlaceholder: "Kommenttialueen paikkamerkki",
        filePlaceholder: "Tiedoston paikkamerkkiteksti",
        photoPlaceholder: "Valokuvan paikkamerkkiteksti",
        fileOrPhotoPlaceholder: "Tiedoston tai valokuvan paikkamerkkiteksti",
        rateType: "Hinnan tyyppi",
        url_placeholder: "Esimerkki: https://api.example.com/books",
        path_placeholder: "Esimerkki: categories.fiction",
        questionStartIndex_placeholder: "Esim.: a)",
        width_placeholder: "Esimerkki: 6 tuumaa",
        minWidth_placeholder: "Esimerkki: 600 pikseliä",
        maxWidth_placeholder: "Esimerkki: 50 %",
        imageHeight_placeholder: "auto",
        imageWidth_placeholder: "auto",
        theme: {
            themeName: "Teema",
            isPanelless: "Kysymyksen ulkonäkö",
            editorPanel: "Taustan ja kulman säde",
            questionPanel: "Taustan ja kulman säde",
            primaryColor: "Korostusväri",
            panelBackgroundTransparency: "Paneelin taustan peittävyys",
            questionBackgroundTransparency: "Taustan peittävyyden kyseenalaistaminen",
            fontSize: "Kirjasinkoko",
            scale: "Mittakaava",
            cornerRadius: "Kulman säde",
            pageTitle: "Otsikon fontti",
            pageDescription: "Kuvauksen fontti",
            questionTitle: "Otsikon fontti",
            questionDescription: "Kuvauksen fontti",
            editorFont: "Fontti",
            backgroundOpacity: "Läpikuultamattomuus",
            "--sjs-font-family": "Fonttiperhe",
            "--sjs-general-backcolor-dim": "Taustaväri",
            "--sjs-primary-backcolor": "Aksentti tausta",
            "--sjs-primary-forecolor": "Aksentti etualalla",
            "--sjs-special-red": "Virhesanomista",
            "--sjs-shadow-small": "Varjo-tehosteet",
            "--sjs-shadow-inner": "Varjo-tehosteet",
            "--sjs-border-default": "Värit"
        },
        "header@header": {
            headerView: "Näkymä",
            logoPosition: "Logon sijainti",
            surveyTitle: "Kyselyn otsikon fontti",
            surveyDescription: "Kyselyn kuvauksen fontti",
            headerTitle: "Kyselyn otsikon fontti",
            headerDescription: "Kyselyn kuvauksen fontti",
            inheritWidthFrom: "Sisältöalueen leveys",
            textAreaWidth: "Tekstin leveys",
            backgroundColorSwitch: "Taustaväri",
            backgroundImage: "Taustakuvan",
            backgroundImageOpacity: "Läpikuultamattomuus",
            overlapEnabled: "Limittyä",
            logoPositionX: "Logon sijainti",
            titlePositionX: "Otsikon sijainti",
            descriptionPositionX: "Kuvauksen sijainti"
        }
    },
    // Property values
    pv: {
        "true": "tosi",
        "false": "väärä",
        file: "Paikalliset tiedostot",
        camera: "Kamera",
        "file-camera": "Paikalliset tiedostot tai kamera",
        inherit: "inherit",
        show: "show",
        hide: "hide",
        default: "default",
        initial: "initial",
        random: "random",
        collapsed: "collapsed",
        expanded: "expanded",
        none: "none",
        asc: "ascending",
        desc: "descending",
        indeterminate: "indeterminate",
        selected: "Valittu",
        unselected: "Valitsematta",
        decimal: "desimaali",
        currency: "valuutta",
        percent: "prosentti",
        firstExpanded: "firstExpanded",
        off: "off",
        list: "list",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        tab: "Välilehdet",
        horizontal: "horizontal",
        vertical: "vertical",
        top: "top",
        bottom: "bottom",
        topBottom: "top and bottom",
        both: "both",
        left: "left",
        right: "Oikea",
        center: "Keskus",
        leftRight: "Vasen ja oikea",
        middle: "Keskus",
        color: "väri",
        date: "päivämäärä",
        datetime: "päivämäärä ja aika",
        "datetime-local": "datetime-local",
        email: "Sähköposti",
        month: "kuukausi",
        number: "numero",
        password: "salasana",
        range: "etäisyys",
        tel: "puh",
        text: "Tekstiviesti",
        time: "Aika",
        url: "URL",
        week: "viikko",
        hidden: "hidden",
        edit: "edit",
        display: "display",
        contain: "Sisältää",
        cover: "Kansi",
        fill: "Täyttää",
        next: "Seuraava",
        last: "Viime",
        onComplete: "onComplete",
        onHidden: "onHidden",
        onHiddenContainer: "Kun kysymys tai sen paneeli/sivu piilotetaan",
        clearInvisibleValues: {
            none: "Koskaan"
        },
        clearIfInvisible: {
            none: "Koskaan"
        },
        inputType: {
            color: "Väri",
            date: "Päivämäärä",
            "datetime-local": "Päivämäärä ja kellonaika",
            email: "Sähköposti",
            month: "Kuukausi",
            number: "Numero",
            password: "Salasana",
            range: "Etäisyys",
            tel: "Puhelinnumero",
            text: "Tekstiviesti",
            time: "Aika",
            url: "URL",
            week: "Viikko"
        },
        all: "all",
        page: "page",
        survey: "survey",
        onNextPage: "onNextPage",
        onValueChanged: "onValueChanged",
        onValueChanging: "Ennen vastauksen muuttamista",
        questionsOnPageMode: {
            standard: "Alkuperäinen rakenne",
            singlePage: "Näytä kaikki kysymykset yhdellä sivulla",
            questionPerPage: "Näytä yksittäinen kysymys sivua kohden"
        },
        noPreview: "no preview",
        showAllQuestions: "show preview with all questions",
        showAnsweredQuestions: "show preview with answered questions",
        pages: "Valmiit sivut",
        questions: "Vastatut kysymykset",
        requiredQuestions: "Vastatut vaaditut kysymykset",
        correctQuestions: "Kelvolliset vastaukset",
        buttons: "Valmiit sivut (painike Käyttöliittymä)",
        underInput: "Tulon alla",
        underTitle: "Otsikon alla",
        onBlur: "Sumennuksessa",
        onTyping: "Kirjoittamisen aikana",
        underRow: "Rivin alla",
        underRowSingle: "Rivin alla näkyy vain yksi paneeli",
        auto: "Auto",
        showNavigationButtons: {
            none: "Piilevä"
        },
        showTimerPanel: {
            none: "Piilevä"
        },
        showTimerPanelMode: {
            all: "Molemmat"
        },
        addRowLocation: {
            default: "Riippuu matriisin asettelusta"
        },
        panelsState: {
            default: "Käyttäjät eivät voi laajentaa tai kutistaa paneeleja",
            collapsed: "Kaikki paneelit on tiivistetty",
            expanded: "Kaikki paneelit on laajennettu",
            firstExpanded: "Ensimmäinen laajennettu"
        },
        widthMode: {
            static: "Staattinen",
            responsive: "Reagoiva"
        },
        contentMode: {
            image: "Kuva",
            video: "Video",
            youtube: "YouTubessa"
        },
        displayMode: {
            buttons: "Painikkeet",
            dropdown: "Avattava valikko"
        },
        rateColorMode: {
            default: "Laiminlyönti",
            scale: "Mittakaava"
        },
        scaleColorMode: {
            monochrome: "Yksivärinen",
            colored: "Värillinen"
        },
        autoGenerate: {
            "true": "Synnyttää",
            "false": "Kirjoita manuaalisesti"
        },
        rateType: {
            labels: "Otsikot",
            stars: "Tähteä",
            smileys: "Hymiöt"
        },
        state: {
            default: "Lukittu"
        },
        showQuestionNumbers: {
            default: "Automaattinen numerointi",
            on: "Automaattinen numerointi",
            onPage: "Nollaa jokaisella sivulla",
            onpanel: "Nollaa jokaisessa paneelissa",
            onPanel: "Nollaa jokaisessa paneelissa",
            onSurvey: "Jatka kyselyssä",
            off: "Ei numerointia"
        },
        descriptionLocation: {
            underTitle: "Kysymyksen otsikon alla",
            underInput: "Syöttökentän alla"
        },
        selectToRankAreasLayout: {
            horizontal: "Valintojen vieressä",
            vertical: "Yllä olevat valinnat"
        },
        displayStyle: {
            decimal: "Desimaali",
            currency: "Valuutta",
            percent: "Prosenttiosuus",
            date: "Päivämäärä"
        },
        totalDisplayStyle: {
            decimal: "Desimaali",
            currency: "Valuutta",
            percent: "Prosenttiosuus",
            date: "Päivämäärä"
        },
        rowsOrder: {
            initial: "Alkuperäinen"
        },
        questionsOrder: {
            initial: "Alkuperäinen"
        },
        showProgressBar: {
            off: "Piilevä",
            topbottom: "top and bottom",
            aboveheader: "Otsikon yläpuolella",
            belowheader: "Otsikon alapuolella"
        },
        sum: "Summa",
        count: "Kreivi",
        min: "Min",
        max: "Max",
        avg: "Avg",
        searchMode: {
            contains: "Sisältää",
            startsWith: "Alkaa"
        },
        backgroundImageFit: {
            auto: "Auto",
            cover: "Kansi",
            contain: "Sisältää",
            fill: "Venyä",
            tile: "Laatta"
        },
        backgroundImageAttachment: {
            fixed: "Kiinteä",
            scroll: "Vierittää"
        },
        headerView: {
            basic: "Emäksinen",
            advanced: "Edistynyt"
        },
        inheritWidthFrom: {
            survey: "Sama kuin kyselyssä",
            container: "Sovita konttiin"
        },
        backgroundColorSwitch: {
            none: "Ei lainkaan",
            accentColor: "Korostusväri",
            custom: "Tapa"
        },
        colorPalette: {
            light: "Valo",
            dark: "Tumma"
        },
        isPanelless: {
            "false": "Laiminlyönti",
            "true": "Ilman paneeleja"
        }
    },
    // Operators
    op: {
        empty: "on tyhjä",
        notempty: "ei ole tyhjä",
        equal: "yhtäsuurikuin",
        notequal: "ei ole yhtäsuurikuin",
        contains: "sisältää",
        notcontains: "ei sisällä",
        anyof: "mikä tahansa",
        allof: "kaikki",
        greater: "suurempi",
        less: "vähemmän",
        greaterorequal: "suurempi tai yhtäsuurikuin",
        lessorequal: "vähemmän tai yhtäsuurikuin",
        and: "ja",
        or: "tai"
    },
    // Embed window
    ew: {
        angular: "Käytä Angular versiota",
        jquery: "Käytä jQuery versiota",
        knockout: "Käytä Knockout versiota",
        react: "Käytä React versiota",
        vue: "Käytä Vue versiota",
        bootstrap: "Bootstrap työkalulle",
        modern: "Moderni teema",
        default: "Oletus teema",
        orange: "Oranssi teema",
        darkblue: "Tummansininen teema",
        darkrose: "Tumma ruusu teema",
        stone: "Kiviteema",
        winter: "Talvi teema",
        winterstone: "Talvi-kivi-teema",
        showOnPage: "Näytä kysely sivulla",
        showInWindow: "Näytä kysely ikkunassa",
        loadFromServer: "Lataa kysely palvelimelta JSON muodossa",
        titleScript: "Skriptit ja tyylit",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Valitse sivu testataksesi sitä:",
        showInvisibleElements: "Näytä näkymätön elementti",
        hideInvisibleElements: "Piilota näkymättömät elementit"
    },
    validators: {
        answercountvalidator: "vastausten määrä",
        emailvalidator: "sähköposti",
        expressionvalidator: "lauseke",
        numericvalidator: "lukumääräinen",
        regexvalidator: "säännöllinen lauseke",
        textvalidator: "teksti"
    },
    triggers: {
        completetrigger: "valmis kysely",
        setvaluetrigger: "aseta arvo",
        copyvaluetrigger: "kopioi arvo",
        skiptrigger: "siirry kysymykseen",
        runexpressiontrigger: "suorita lauseke",
        visibletrigger: "muuta näkyvyyttä (vanhentunut)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Esimerkki: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Esimerkki: kk/pp/v"
        },
        currencymask: {
            prefix: "Esimerkki: $",
            suffix: "Esimerkki: USD"
        },
        panelbase: {
            questionTitleWidth: "Esimerkki: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "Paneelin tunnus, joka ei näy vastaajille.",
            description: "Kirjoita paneelin tekstitys.",
            visibleIf: "Käytä taikasauvakuvaketta asettaaksesi ehdollisen säännön, joka määrittää paneelin näkyvyyden.",
            enableIf: "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka poistaa paneelin vain luku -tilan käytöstä.",
            requiredIf: "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka estää kyselyn lähettämisen, ellei vähintään yhteen sisäkkäiseen kysymykseen ole vastausta.",
            questionTitleLocation: "Koskee kaikkia tämän paneelin kysymyksiä. Jos haluat ohittaa tämän asetuksen, määritä otsikon tasaussäännöt yksittäisille kysymyksille. Peri-vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta (\"Ylin\" oletuksena).",
            questionTitleWidth: "Määrittää kysymysten otsikoiden tasaisen leveyden, kun ne tasataan kysymysruutujen vasemmalle puolelle. Hyväksyy CSS-arvot (px, %, in, pt jne.).",
            questionErrorLocation: "Määrittää virhesanoman sijainnin suhteessa kaikkiin paneelin kysymyksiin. Peri-vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta.",
            questionsOrder: "Säilyttää kysymysten alkuperäisen järjestyksen tai satunnaistaa ne. Peri-vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta.",
            page: "Siirtää paneelin valitun sivun loppuun.",
            innerIndent: "Lisää tilaa tai reunuksen paneelin sisällön ja paneeliruudun vasemman reunan väliin.",
            startWithNewLine: "Poista valinta, jos haluat näyttää paneelin yhdellä rivillä edellisen kysymyksen tai paneelin kanssa. Asetusta ei käytetä, jos paneeli on lomakkeen ensimmäinen elementti.",
            state: "Valitse seuraavista: \"Laajennettu\" - paneeli näytetään kokonaisuudessaan ja se voidaan kutistaa; \"Tiivistetty\" - paneeli näyttää vain otsikon ja kuvauksen ja sitä voidaan laajentaa; \"Lukittu\" - paneeli näkyy kokonaisuudessaan eikä sitä voi kutistaa.",
            width: "Asettaa paneelin leveyden suhteessa muihin saman rivin mittauselementteihin. Hyväksyy CSS-arvot (px, %, in, pt jne.)."
        },
        paneldynamic: {
            name: "Paneelin tunnus, joka ei näy vastaajille.",
            description: "Kirjoita paneelin tekstitys.",
            visibleIf: "Käytä taikasauvakuvaketta asettaaksesi ehdollisen säännön, joka määrittää paneelin näkyvyyden.",
            enableIf: "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka poistaa paneelin vain luku -tilan käytöstä.",
            requiredIf: "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka estää kyselyn lähettämisen, ellei vähintään yhteen sisäkkäiseen kysymykseen ole vastausta.",
            templateTitleLocation: "Koskee kaikkia tämän paneelin kysymyksiä. Jos haluat ohittaa tämän asetuksen, määritä otsikon tasaussäännöt yksittäisille kysymyksille. Peri-vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta (\"Ylin\" oletuksena).",
            templateErrorLocation: "Määrittää virhesanoman sijainnin suhteessa kysymykseen, jonka syöte on virheellinen. Valitse seuraavista: \"Top\" - virheteksti sijoitetaan kysymysruudun yläosaan; \"Pohja\" - virheteksti sijoitetaan kysymysruudun alaosaan. Peri-vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta (\"Ylin\" oletuksena).",
            errorLocation: "Määrittää virhesanoman sijainnin suhteessa kaikkiin paneelin kysymyksiin. Peri-vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta.",
            page: "Siirtää paneelin valitun sivun loppuun.",
            innerIndent: "Lisää tilaa tai reunuksen paneelin sisällön ja paneeliruudun vasemman reunan väliin.",
            startWithNewLine: "Poista valinta, jos haluat näyttää paneelin yhdellä rivillä edellisen kysymyksen tai paneelin kanssa. Asetusta ei käytetä, jos paneeli on lomakkeen ensimmäinen elementti.",
            state: "Valitse seuraavista: \"Laajennettu\" - paneeli näytetään kokonaisuudessaan ja se voidaan kutistaa; \"Tiivistetty\" - paneeli näyttää vain otsikon ja kuvauksen ja sitä voidaan laajentaa; \"Lukittu\" - paneeli näkyy kokonaisuudessaan eikä sitä voi kutistaa.",
            width: "Asettaa paneelin leveyden suhteessa muihin saman rivin mittauselementteihin. Hyväksyy CSS-arvot (px, %, in, pt jne.).",
            templateTitle: "Kirjoita malli dynaamisten paneelien otsikoille. Käytä {panelIndex} paneelin yleistä sijaintia ja {visiblePanelIndex} sen järjestystä näkyvien paneelien joukossa. Lisää nämä paikkamerkit kuvioon lisätäksesi automaattisen numeroinnin.",
            templateTabTitle: "Kirjoita välilehtien otsikoiden malli. Käytä {panelIndex} paneelin yleistä sijaintia ja {visiblePanelIndex} sen järjestystä näkyvien paneelien joukossa. Lisää nämä paikkamerkit kuvioon lisätäksesi automaattisen numeroinnin.",
            tabTitlePlaceholder: "Välilehtien otsikoiden varateksti, jota käytetään, kun välilehden otsikkomalli ei tuota merkityksellistä arvoa.",
            templateVisibleIf: "Tämän asetuksen avulla voit hallita yksittäisten paneelien näkyvyyttä dynaamisessa paneelissa. {panel}-paikkamerkin avulla voit viitata lausekkeen nykyiseen paneeliin.",
            titleLocation: "Tämä asetus periytyy automaattisesti kaikkiin tämän paneelin kysymyksiin. Jos haluat ohittaa tämän asetuksen, määritä otsikon tasaussäännöt yksittäisille kysymyksille. Peri-vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta (\"Ylin\" oletuksena).",
            descriptionLocation: "\"Peri\" -vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta (\"Paneelin otsikon alla\" oletuksena).",
            newPanelPosition: "Määrittää juuri lisätyn paneelin sijainnin. Oletuksena uudet paneelit lisätään loppuun. Valitse \"Seuraava\" lisätäksesi uuden paneelin nykyisen jälkeen.",
            defaultValueFromLastPanel: "Monistaa edellisen paneelin vastaukset ja määrittää ne seuraavaan lisättyyn dynaamiseen paneeliin.",
            keyName: "Viittaa kysymyksen nimeen, jos haluat edellyttää, että käyttäjä antaa yksilöllisen vastauksen tähän kysymykseen kussakin paneelissa."
        },
        defaultValueExpression: "Tämän asetuksen avulla voit määrittää oletusarvoisen vastausarvon lausekkeen perusteella. Lauseke voi sisältää peruslaskutoimituksia - '{q1_id} + {q2_id}', totuusarvolausekkeita, kuten '{age} > 60', ja funktioita: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' jne. Tämän lausekkeen määrittämä arvo toimii alkuperäisenä oletusarvona, jonka vastaajan manuaalinen syöttö voi ohittaa.",
        resetValueIf: "Käytä taikasauvakuvaketta asettaaksesi ehdollisen säännön, joka määrittää, milloin vastaajan syöte palautetaan arvoon \"Oletusarvolauseke\" tai \"Aseta arvolauseke\" tai \"Oletusvastaus\" -arvoon (jos jompikumpi on asetettu).",
        setValueIf: "Käytä taikasauvakuvaketta asettaaksesi ehdollisen säännön, joka määrittää, milloin \"Aseta arvolauseke\" suoritetaan, ja määritä tuloksena oleva arvo dynaamisesti vastauksena.",
        setValueExpression: "Määritä lauseke, joka määrittää arvon, joka määritetään, kun Aseta arvo jos -säännön ehdot täyttyvät. Lauseke voi sisältää peruslaskutoimituksia - '{q1_id} + {q2_id}', totuusarvolausekkeita, kuten '{age} > 60', ja funktioita: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' jne. Tämän lausekkeen määrittämä arvo voidaan ohittaa vastaajan manuaalisella syötöllä.",
        question: {
            name: "Kysymystunnus, joka ei näy vastaajille.",
            description: "Kirjoita kysymyksen alaotsikko.",
            visibleIf: "Käytä taikasauvakuvaketta asettaaksesi ehdollisen säännön, joka määrittää kysymyksen näkyvyyden.",
            enableIf: "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka poistaa kysymyksen vain luku -tilan käytöstä.",
            requiredIf: "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka estää kyselyn etenemisen tai lähettämisen, ellei kysymykseen ole vastattu.",
            startWithNewLine: "Poista valinta, jos haluat näyttää kysymyksen yhdellä rivillä edellisen kysymyksen tai paneelin kanssa. Asetusta ei käytetä, jos kysymys on lomakkeen ensimmäinen elementti.",
            page: "Sijoittaa kysymyksen uudelleen valitun sivun loppuun.",
            state: "Valitse seuraavista: \"Laajennettu\" - kysymysruutu näytetään kokonaisuudessaan ja se voidaan kutistaa; \"Tiivistetty\" - kysymysruutu näyttää vain otsikon ja kuvauksen ja sitä voidaan laajentaa; \"Lukittu\" - kysymysruutu näkyy kokonaisuudessaan eikä sitä voi kutistaa.",
            titleLocation: "Ohittaa paneeli-, sivu- tai kyselytasolla määritetyt otsikon tasaussäännöt. \"Peri\"-vaihtoehto käyttää kaikkia ylemmän tason asetuksia (jos määritetty) tai kyselytason asetuksia (\"Ylin\" oletuksena).",
            descriptionLocation: "\"Peri\"-vaihtoehto käyttää kyselytason asetusta (\"Kysymyksen otsikon alla\" oletuksena).",
            errorLocation: "Määrittää virhesanoman sijainnin suhteessa kysymykseen, jonka syöte on virheellinen. Valitse seuraavista: \"Top\" - virheteksti sijoitetaan kysymysruudun yläosaan; \"Pohja\" - virheteksti sijoitetaan kysymysruudun alaosaan. \"Peri\"-vaihtoehto käyttää kyselytason asetusta (\"Ylin\" oletuksena).",
            indent: "Lisää välilyönnin tai reunuksen kysymyksen sisällön ja kysymysruudun vasemman reunan väliin.",
            width: "Määrittää kysymyksen leveyden suhteessa saman rivin muihin kyselyelementteihin. Hyväksyy CSS-arvot (px, %, in, pt jne.).",
            surveyvalidator: {
                expression: "Käytä taikasauvakuvaketta asettaaksesi kysymyksen vahvistussäännön."
            },
            textUpdateMode: "Valitse seuraavista: \"Kadonneessa tarkennuksessa\" - arvo päivitetään, kun syöttökenttä menettää tarkennuksen; \"Kirjoitettaessa\" - arvo päivitetään reaaliajassa, kun käyttäjät kirjoittavat. \"Peri\"-vaihtoehto käyttää kyselytason asetusta (\"Oletusarvoisesti menetetty kohdistus\").",
            url: "Voit käyttää mitä tahansa verkkopalvelua tietolähteenä monivalintakysymyksissä. Voit täyttää valinta-arvot antamalla tiedot tarjoavan palvelun URL-osoitteen.",
            searchMode: "Vertailutoiminto, jota käytetään avattavan luettelon suodattamiseen.",
            textWrapEnabled: "Valintavaihtoehtojen pitkät tekstit luovat automaattisesti rivinvaihdot, jotka mahtuvat avattavaan valikkoon. Poista valinta, jos haluat leikata tekstit."
        },
        signaturepad: {
            signatureWidth: "Määrittää näytettävän allekirjoitusalueen ja tuloksena olevan kuvan leveyden.",
            signatureHeight: "Määrittää näytettävän allekirjoitusalueen ja tuloksena olevan kuvan korkeuden.",
            signatureAutoScaleEnabled: "Valitse tämä, jos haluat, että allekirjoitusalue täyttää kaiken kysymysruudussa käytettävissä olevan tilan säilyttäen oletusarvoisen 3:2-kuvasuhteen. Kun mukautetut leveys- ja korkeusarvot on määritetty, asetus säilyttää näiden mittojen kuvasuhteen."
        },
        file: {
            imageHeight: "Säätää kuvan korkeutta kyselyn tuloksissa.",
            imageWidth: "Säätää kuvan leveyttä kyselyn tuloksissa."
        },
        image: {
            contentMode: "\"Auto\" -vaihtoehto määrittää automaattisesti sopivan näyttötilan - Kuva, Video tai YouTube - annetun lähde-URL-osoitteen perusteella."
        },
        imagepicker: {
            imageHeight: "Ohittaa vähimmäis- ja enimmäiskorkeusarvot.",
            imageWidth: "Ohittaa vähimmäis- ja enimmäisleveysarvot.",
            choices: "\"Arvo\" toimii ehdollisissa säännöissä käytettynä tuotetunnuksena; \"Teksti\" näkyy vastaajille.",
            contentMode: "Valitse \"Kuva\" tai \"Video\" asettaaksesi mediavalitsimen sisältötilan. Jos \"Kuva\" on valittuna, varmista, että kaikki annetut vaihtoehdot ovat kuvatiedostoja seuraavissa muodoissa: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Samoin, jos \"Video\" on valittuna, varmista, että kaikki vaihtoehdot ovat suoria linkkejä videotiedostoihin seuraavissa muodoissa: MP4, MOV, WMV, FLV, AVI, MKV. Huomaa, että YouTube-linkkejä ei tueta videoasetuksissa."
        },
        text: {
            size: "Tämä asetus muuttaa vain syöttökentän kokoa eikä vaikuta kysymysruudun leveyteen. Jos haluat rajoittaa hyväksyttyä syötteen pituutta, siirry kohtaan <b>Vahvistus → merkkien enimmäismäärä</b>."
        },
        comment: {
            rows: "Määrittää syöttökentässä näytettävien rivien määrän. Jos tulo vie enemmän rivejä, vierityspalkki tulee näkyviin."
        },
        // survey templates
        survey: {
            mode: "Valitse jompikumpi seuraavista: \"Muokattavissa\" - vastaajat voivat täyttää kyselysi; \"Vain luku\" - poistaa lomakkeen muokkauksen käytöstä."
        },
        matrixdropdowncolumn: {
            name: "Sarakkeen tunnus, joka ei näy vastaajille.",
            isUnique: "Kun sarake on otettu käyttöön, vastaajan on annettava yksilöllinen vastaus jokaiseen tämän sarakkeen kysymykseen.",
            rows: "Määrittää syöttökentässä näytettävien rivien määrän. Jos tulo vie enemmän rivejä, vierityspalkki tulee näkyviin.",
            visibleIf: "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka määrittää sarakkeen näkyvyyden.",
            enableIf: "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka poistaa sarakkeen vain luku -tilan käytöstä.",
            requiredIf: "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka estää kyselyn lähettämisen, ellei vähintään yhteen sisäkkäiseen kysymykseen ole vastausta.",
            showInMultipleColumns: "Kun tämä asetus on valittuna, kullekin vaihtoehdolle luodaan oma sarake."
        },
        widthMode: "Valitse seuraavista: \"Staattinen\" - asettaa kiinteän leveyden; \"Reagoiva\" - tekee kyselystä koko näytön leveyden; \"Auto\" - soveltaa jompaakumpaa näistä kahdesta riippuen käytetyistä kysymystyypeistä.",
        cookieName: "Evästeet estävät käyttäjiä täyttämästä samaa kyselyä kahdesti.",
        logo: "Liitä kuvalinkki (ei kokorajoituksia) tai napsauta kansiokuvaketta selataksesi tiedostoa tietokoneeltasi (enintään 64 kt).",
        logoWidth: "Määrittää logon leveyden CSS-yksiköissä (px, %, in, pt jne.).",
        logoHeight: "Asettaa logon korkeuden CSS-yksiköinä (px, %, in, pt jne.).",
        logoFit: "Valitse seuraavista: \"Ei mitään\" - kuva säilyttää alkuperäisen kokonsa; \"Sisältää\" - kuvan kokoa muutetaan sopivaksi säilyttäen samalla kuvasuhteensa; \"Kansi\" - kuva täyttää koko laatikon säilyttäen samalla kuvasuhteensa; \"Täytä\" - kuva venytetään täyttämään laatikko säilyttämättä sen kuvasuhdetta.",
        goNextPageAutomatic: "Valitse, haluatko kyselyn siirtyvän seuraavalle sivulle automaattisesti, kun vastaaja on vastannut kaikkiin nykyisen sivun kysymyksiin.",
        allowCompleteSurveyAutomatic: "Valitse, haluatko kyselyn täyttyvän automaattisesti, kun vastaaja on vastannut kaikkiin kysymyksiin.",
        showNavigationButtons: "Määrittää sivun navigointipainikkeiden näkyvyyden ja sijainnin.",
        showProgressBar: "Määrittää edistymispalkin näkyvyyden ja sijainnin. \"Auto\"-arvo näyttää edistymispalkin kyselyn otsikon ylä- tai alapuolella.",
        showPreviewBeforeComplete: "Ota esikatselusivu käyttöön vain kaikilla kysymyksillä tai vastatuilla kysymyksillä.",
        questionTitleLocation: "Koskee kaikkia kyselyn kysymyksiä. Tämä asetus voidaan ohittaa otsikon tasaussäännöillä alemmilla tasoilla: paneeli, sivu tai kysymys. Alemman tason asetus ohittaa korkeammalla tasolla olevat.",
        requiredText: "Symboli tai symbolisarja, joka osoittaa, että vastaus vaaditaan.",
        questionStartIndex: "Kirjoita numero tai kirjain, jolla haluat aloittaa numeroinnin.",
        questionErrorLocation: "Määrittää virhesanoman sijainnin suhteessa kysymykseen, jonka syöte on virheellinen. Valitse seuraavista: \"Top\" - virheteksti sijoitetaan kysymysruudun yläosaan; \"Pohja\" - virheteksti sijoitetaan kysymysruudun alaosaan.",
        focusFirstQuestionAutomatic: "Valitse tämä, jos haluat, että kunkin sivun ensimmäinen syöttökenttä on valmis tekstinsyöttöä varten.",
        questionsOrder: "Säilyttää kysymysten alkuperäisen järjestyksen tai satunnaistaa ne. Tämän asetuksen vaikutus näkyy vain Esikatselu-välilehdessä.",
        maxTextLength: "Vain tekstinsyöttökysymykset.",
        maxOthersLength: "Vain kysymysten kommentit.",
        commentAreaRows: "Määrittää tekstialueilla näytettävien rivien määrän kysymyskommentteja varten. Tulossa vie enemmän rivejä, vierityspalkki tulee näkyviin.",
        autoGrowComment: "Valitse tämä, jos haluat, että kysymysten kommentit ja pitkät tekstit -kysymykset kasvavat automaattisesti syötetyn tekstin pituuden perusteella.",
        allowResizeComment: "Vain kysymyskommentit ja pitkän tekstin kysymykset.",
        calculatedValues: "Mukautetut muuttujat toimivat väli- tai apumuuttujina, joita käytetään lomakelaskelmissa. He ottavat vastaajan syötteet lähdearvoina. Jokaisella mukautetulla muuttujalla on yksilöllinen nimi ja lauseke, johon se perustuu.",
        includeIntoResult: "Valitse tämä, jos haluat, että lausekkeen laskettu arvo tallennetaan yhdessä kyselyn tulosten kanssa.",
        triggers: "Käynnistin on tapahtuma tai ehto, joka perustuu lausekkeeseen. Kun lausekkeen arvoksi on arvioitu \"tosi\", käynnistin käynnistää toiminnon. Tällaisella toiminnalla voi valinnaisesti olla kohdekysymys, johon se vaikuttaa.",
        clearInvisibleValues: "Valitse, tyhjennetäänkö ehdollisen logiikan piilottamien kysymysten arvot ja milloin se tehdään.",
        textUpdateMode: "Valitse seuraavista: \"Kadonneessa tarkennuksessa\" - arvo päivitetään, kun syöttökenttä menettää tarkennuksen; \"Kirjoitettaessa\" - arvo päivitetään reaaliajassa, kun käyttäjät kirjoittavat.",
        columns: "Vasen arvo toimii ehdollisissa säännöissä käytettynä saraketunnuksena, oikea arvo näkyy vastaajille.",
        rows: "Vasen arvo toimii rivitunnuksena, jota käytetään ehdollisissa säännöissä, oikea arvo näytetään vastaajille.",
        columnMinWidth: "Hyväksyy CSS-arvot (px, %, in, pt jne.).",
        rowTitleWidth: "Hyväksyy CSS-arvot (px, %, in, pt jne.).",
        totalText: "Näkyy vain, kun vähintään yhdessä sarakkeessa on Summa-tyyppi tai Summa-lauseke.",
        cellErrorLocation: "Määrittää virhesanoman sijainnin suhteessa soluun, jonka syöte on virheellinen. \"Peri\" -vaihtoehto käyttää asetusta \"Virheilmoituksen kohdistus\" -ominaisuudesta.",
        keyDuplicationError: "Kun Estä päällekkäiset vastaukset -ominaisuus on käytössä, vastaaja, joka yrittää lähettää merkinnän kaksoiskappaleen, saa seuraavan virhesanoman.",
        totalExpression: "Voit laskea kokonaisarvot lausekkeen perusteella. Lauseke voi sisältää peruslaskutoimituksia ('{q1_id} + {q2_id}'), totuusarvolausekkeita ('{age} > 60') ja funktioita ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' jne.).",
        confirmDelete: "Käynnistää kehotteen, jossa pyydetään vahvistamaan rivin poisto.",
        defaultValueFromLastRow: "Monistaa vastaukset viimeiseltä riviltä ja määrittää ne seuraavalle lisätylle dynaamiselle riville.",
        keyName: "Jos määritetty sarake sisältää samat arvot, kysely heittää \"Ei-yksilöllinen avainarvo\" -virheen.",
        description: "Kirjoita tekstitys.",
        locale: "Aloita kyselyn luominen valitsemalla kieli. Jos haluat lisätä käännöksen, vaihda uuteen kieleen ja käännä alkuperäinen teksti täällä tai Käännökset-välilehdessä.",
        detailPanelMode: "Määrittää tieto-osan sijainnin suhteessa riviin. Valitse seuraavista: \"Ei mitään\" - laajennusta ei lisätä; \"Rivin alla\" - matriisin jokaisen rivin alle sijoitetaan rivilaajennus; \"Näytä rivin alla vain yhden rivin laajennus\" - laajennus näkyy vain yhden rivin alla, loput rivilaajennukset kutistetaan.",
        imageFit: "Valitse seuraavista: \"Ei mitään\" - kuva säilyttää alkuperäisen kokonsa; \"Sisältää\" - kuvan kokoa muutetaan sopivaksi säilyttäen samalla kuvasuhteensa; \"Kansi\" - kuva täyttää koko laatikon säilyttäen samalla kuvasuhteensa; \"Täytä\" - kuva venytetään täyttämään laatikko säilyttämättä sen kuvasuhdetta.",
        autoGrow: "Lisää vähitellen syöttökentän korkeutta, kun tietoja syötetään. Ohittaa \"Syöttökentän korkeus (viivoina)\" -asetuksen.",
        allowResize: "Koonmuuttokahva (tai kahva) tulee näkyviin kulmaan, ja sitä vetämällä voit muuttaa syöttökentän kokoa.",
        maxTimeToFinish: "Sekunteina oleva aikaväli, jonka jälkeen kysely etenee automaattisesti Kiitos-sivulle.",
        maxTimeToFinishPage: "Sekunteina ilmaistu aikaväli, jonka jälkeen kysely siirtyy automaattisesti seuraavalle sivulle.",
        page: {
            maxTimeToFinish: "Sekunteina ilmaistu aikaväli, jonka jälkeen kysely siirtyy automaattisesti seuraavalle sivulle.",
            visibleIf: "Käytä taikasauvakuvaketta asettaaksesi ehdollisen säännön, joka määrittää sivun näkyvyyden.",
            enableIf: "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka poistaa sivun vain luku -tilan käytöstä.",
            requiredIf: "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka estää kyselyn lähettämisen, ellei vähintään yhteen sisäkkäiseen kysymykseen ole vastausta.",
            questionTitleLocation: "Koskee kaikkia tämän sivun kysymyksiä. Jos haluat ohittaa tämän asetuksen, määritä otsikon tasaussäännöt yksittäisille kysymyksille tai paneeleille. \"Peri\"-vaihtoehto käyttää kyselytason asetusta (\"Ylin\" oletuksena).",
            questionTitleWidth: "Määrittää kysymysten otsikoiden tasaisen leveyden, kun ne tasataan kysymysruutujen vasemmalle puolelle. Hyväksyy CSS-arvot (px, %, in, pt jne.).",
            questionErrorLocation: "Määrittää virhesanoman sijainnin suhteessa kysymykseen, jonka syöte on virheellinen. Valitse seuraavista: \"Top\" - virheteksti sijoitetaan kysymysruudun yläosaan; \"Pohja\" - virheteksti sijoitetaan kysymysruudun alaosaan. \"Peri\"-vaihtoehto käyttää kyselytason asetusta (\"Ylin\" oletuksena).",
            questionsOrder: "Säilyttää kysymysten alkuperäisen järjestyksen tai satunnaistaa ne. \"Peri\" -vaihtoehto käyttää kyselytason asetusta (\"Alkuperäinen\" oletuksena). Tämän asetuksen vaikutus näkyy vain Esikatselu-välilehdessä.",
            navigationButtonsVisibility: "Määrittää navigointipainikkeiden näkyvyyden sivulla. \"Peri\" -vaihtoehto käyttää kyselytason asetusta, jonka oletusarvo on \"Näkyvä\"."
        },
        showTimerPanel: "Määrittää ajastimen näkyvyyden ja sijainnin sivulla.",
        panelsState: "Valitse seuraavista: \"Lukittu\" - käyttäjät eivät voi laajentaa tai kutistaa paneeleja; \"Kutista kaikki\" - kaikki paneelit alkavat romahtaneessa tilassa; \"Laajenna kaikki\" - kaikki paneelit alkavat laajennetussa tilassa; \"Ensimmäinen laajennettu\" - vain ensimmäistä paneelia laajennetaan aluksi.",
        imageLinkName: "Kirjoita jaetun ominaisuuden nimi objektiryhmään, joka sisältää valintaluettelossa näytettävät kuvan tai videotiedoston URL-osoitteet.",
        choices: "Vasen arvo toimii ehdollisissa säännöissä käytettynä kohteen tunnuksena, oikea arvo näytetään vastaajille.",
        title: "Kirjoita käyttäjäystävällinen otsikko näytettäväksi.",
        waitForUpload: "Varmistaa, että käyttäjät eivät vastaa kyselyyn, ennen kuin tiedostot on ladattu.",
        minWidth: "Hyväksyy CSS-arvot (px, %, in, pt jne.).",
        maxWidth: "Hyväksyy CSS-arvot (px, %, in, pt jne.).",
        width: "Hyväksyy CSS-arvot (px, %, in, pt jne.).",
        valueName: "Jos et määritä tätä ominaisuutta, vastaus tallennetaan Name-ominaisuuden määrittämään kenttään.",
        useDisplayValuesInDynamicTexts: "Yksi- ja monivalintakysymystyypeissä kullakin valintavaihtoehdolla on tunnus ja näyttöarvo. Kun tämä asetus on valittuna, se näyttää tunnusarvon sijaan HTML-kysymyksissä ja kyselyelementtien dynaamisissa otsikoissa ja kuvauksissa.",
        clearIfInvisible: "Valitse, poistetaanko ehdollisen logiikan piilottamat kysymysarvot ja milloin se tehdään. \"Peri\"-vaihtoehto käyttää kyselytason asetusta (\"Kyselyn valmistuttua\" oletuksena).",
        choicesFromQuestionMode: "Valitse seuraavista: \"Kaikki\" - kopioi kaikki valintavaihtoehdot valitusta kysymyksestä; \"Valittu\" - kopioi dynaamisesti vain valitut valintavaihtoehdot; \"Ei valittu\" - kopioi dynaamisesti vain valitsemattomat valintavaihtoehdot. Vaihtoehdot \"Ei mitään\" ja \"Muut\" kopioidaan oletusarvoisesti, jos ne on otettu käyttöön lähdekysymyksessä.",
        showOtherItem: "Kun tämä on valittuna, käyttäjät voivat lisätä lisätietoja erilliseen kommenttiruutuun.",
        separateSpecialChoices: "Näyttää jokaisen erityisen valintavaihtoehdon (\"Ei mitään\", \"Muu\", \"Valitse kaikki\") uudella rivillä, vaikka käytettäisiin monisarakkeista asettelua.",
        path: "Määritä palvelutietojoukon sijainti, jossa objektien kohderyhmä sijaitsee. Jätä tyhjäksi, jos URL-osoite osoittaa jo matriisiin.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Kirjoita objektimatriisiin yhtenäinen ominaisuuden nimi, joka sisältää valintaluettelossa näytettävät arvot.",
        allowEmptyResponse: "Valitse tämä, jos haluat, että palvelu palauttaa tyhjän vastauksen tai matriisin.",
        choicesVisibleIf: "Taikasauvakuvakkeen avulla voit määrittää ehdollisen säännön, joka määrittää kaikkien valintavaihtoehtojen näkyvyyden.",
        rateValues: "Vasen arvo toimii ehdollisissa säännöissä käytettynä kohteen tunnuksena, oikea arvo näytetään vastaajille.",
        rating: {
            displayMode: "\"Auto\" valitsee \"Painikkeet\" ja \"Avattava\" -tilojen välillä käytettävissä olevan leveyden perusteella. Kun leveys ei riitä painikkeiden näyttämiseen, kysymyksessä näkyy avattava valikko."
        },
        valuePropertyName: "Voit yhdistää kysymyksiä, jotka tuottavat tuloksia eri muodoissa. Kun tällaiset kysymykset linkitetään toisiinsa liitostunnuksen avulla, tähän jaettuun ominaisuuteen tallennetaan valitut kysymysarvot.",
        searchEnabled: "Valitse tämä, jos haluat päivittää avattavan valikon sisällön vastaamaan hakukyselyä, jonka käyttäjä kirjoittaa syöttökenttään.",
        valueTrue: "Arvo, joka tallennetaan kyselyn tuloksiin, kun vastaajat antavat myönteisen vastauksen.",
        valueFalse: "Arvo, joka tallennetaan kyselyn tuloksiin, kun vastaajat antavat kielteisen vastauksen.",
        showPreview: "Tätä asetusta ei suositella poistamaan käytöstä, koska se ohittaa esikatselukuvan ja vaikeuttaa käyttäjän ymmärtämistä, onko tiedostot ladattu.",
        needConfirmRemoveFile: "Käynnistää kehotteen, jossa pyydetään vahvistamaan tiedoston poistaminen.",
        selectToRankEnabled: "Ota käyttöön, jos haluat luokitella vain valitut vaihtoehdot. Käyttäjät vetävät valitut kohteet valintaluettelosta järjestääkseen ne sijoitusalueella.",
        dataList: "Kirjoita luettelo vaihtoehdoista, joita vastaajalle ehdotetaan syötteen aikana.",
        itemSize: "Asetus muuttaa vain syöttökenttien kokoa eikä vaikuta kysymysruudun leveyteen.",
        itemTitleWidth: "Määrittää yhdenmukaisen leveyden kaikille tuoteotsikoille kuvapisteinä",
        altText: "Toimii korvikkeena, kun kuvaa ei voida näyttää käyttäjän laitteella, ja esteettömyyssyistä.",
        rateColorMode: "Määrittää valitun emojin värin, kun luokituskuvakkeen tyypiksi on asetettu \"Hymiöt\". Valitse seuraavista: \"Oletus\" - valittu emoji näkyy kyselyn oletusvärillä; \"Scale\" - valittu emoji perii värin luokitusasteikolta.",
        expression: {
            name: "Lausekkeen tunnus, joka ei näy vastaajille.",
            description: "Kirjoita lausekkeen alaotsikko.",
            expression: "Lauseke voi sisältää peruslaskutoimituksia ('{q1_id} + {q2_id}'), ehtoja ('{age} > 60') ja funktioita ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' jne.)."
        },
        storeOthersAsComment: "Valitse tämä, jos haluat tallentaa Muu-vaihtoehdon arvon erillisenä ominaisuutena kyselyn tuloksiin.",
        format: "Käytä {0} todellisen arvon paikkamerkkinä.",
        acceptedTypes: "Katso lisätietoja määritteen [accept](https://www.w3schools.com/tags/att_input_accept.asp) kuvauksesta.",
        columnColCount: "Koskee vain radioryhmä- ja valintaruutusolutyyppejä.",
        autocomplete: "Lisätietoja on [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) -määritteen kuvauksessa.",
        filePlaceholder: "Käytetään, kun \"Lähdetyyppi\" on \"Paikalliset tiedostot\" tai kun kamera ei ole käytettävissä",
        photoPlaceholder: "Käytetään, kun \"Lähdetyyppi\" on \"Kamera\".",
        fileOrPhotoPlaceholder: "Käytetään, kun \"Lähdetyyppi\" on \"Paikalliset tiedostot tai kamera\".",
        masksettings: {
            saveMaskedValue: "Valitse, haluatko tallentaa kyselyn tuloksiin kysymyksen arvon käyttämällä maskia."
        },
        patternmask: {
            pattern: "Kuvio voi sisältää merkkijonoliteraaleja ja seuraavia paikkamerkkejä: '9' - numerolle; \"a\" - isoille tai pienille kirjaimille; '#' - numerolle tai isolle tai pienelle kirjaimelle. Käytä kenoviivaa '\\' paetaksesi hahmoa."
        },
        datetimemask: {
            pattern: "Kuvio voi sisältää erotinmerkkejä ja seuraavia paikkamerkkejä:<br>'m' - Kuukauden numero.<br>'mm' - Kuukauden numero, jonka alussa on nolla yksinumeroisille arvoille. <br>'d' - kuukauden päivä. <br>'dd' - kuukauden päivä, jonka alussa on nolla yksinumeroisille arvoille. <br>'yy' - Vuoden kaksi viimeistä numeroa. <br>\"yyyy\" - nelinumeroinen vuosi. <br>'H' - Tunnit 24 tunnin muodossa. <br>\"HH\" - Tunnit 24 tunnin muodossa, jonka alussa on nolla yksinumeroisille arvoille. <br>'h' - Tunnit 12 tunnin muodossa. <br>\"hh\" - Tunnit 12 tunnin muodossa, jonka alussa on nolla yksinumeroisille arvoille. <br>'MM' - Pöytäkirja. <br>'ss' - sekuntia. <br>\"TT\" - 12 tunnin kellojakso isoilla kirjaimilla (AM/PM). <br>'TT' - 12 tunnin kellonaika pienillä kirjaimilla (am/pm)."
        },
        numericmask: {
            decimalSeparator: "Symboli, jota käytetään erottamaan murto-osa näytetyn luvun kokonaislukuosasta.",
            thousandsSeparator: "Symboli, jota käytetään erottamaan suuren luvun numerot kolmen ryhmiin.",
            precision: "Rajoittaa näytettävän luvun desimaalipilkun jälkeen säilytettävien numeroiden määrää."
        },
        currencymask: {
            prefix: "Yksi tai useampi symboli, joka näytetään ennen arvoa.",
            suffix: "Yksi tai useampi symboli, joka näytetään arvon jälkeen."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "otsikko",
            title: "Jätä se tyhjäksi, jos se on sama kuin 'Nimi'"
        },
        multiSelect: "Salli monivalinta",
        showLabel: "Näytä kuvatekstit",
        swapOrder: "Kyllä- ja Ei-järjestyksen vaihtaminen",
        value: "Arvo",
        tabAlign: "Sarkaimen tasaus",
        sourceType: "Lähteen tyyppi",
        fitToContainer: "Sovita konttiin",
        setValueExpression: "Arvolausekkeen määrittäminen",
        description: "description",
        logoFit: "Logon sopivuus",
        pages: "Sivut",
        questions: "Kysymyksiä",
        triggers: "triggers",
        calculatedValues: "Lasketut arvot",
        surveyId: "Kyselyn tunnus",
        surveyPostId: "Kyselyn viestin tunnus",
        surveyShowDataSaving: "Kysely näyttää tietojen tallennuksen",
        questionDescriptionLocation: "Kysymyksen kuvauksen sijainti",
        progressBarType: "Edistymispalkin tyyppi",
        showTOC: "Näytä sisällysluettelo",
        tocLocation: "Toc-sijainti",
        questionTitlePattern: "Kysymyksen otsikkomalli",
        widthMode: "Leveys-tila",
        showBrandInfo: "Näytä brändin tiedot",
        useDisplayValuesInDynamicTexts: "Näyttöarvojen käyttäminen dynaamisissa teksteissä",
        visibleIf: "visibleIf",
        defaultValueExpression: "Oletusarvon lauseke",
        requiredIf: "requiredIf",
        resetValueIf: "Nollaa arvo, jos",
        setValueIf: "Aseta arvo, jos",
        validators: "validators",
        bindings: "Siteet",
        renderAs: "Hahmonna muodossa",
        attachOriginalItems: "Alkuperäisten kohteiden liittäminen",
        choices: "choices",
        choicesByUrl: "choicesByUrl",
        currency: "currency",
        cellHint: "Solun vihje",
        totalMaximumFractionDigits: "Murtolukujen enimmäismäärä yhteensä",
        totalMinimumFractionDigits: "Murtolukujen vähimmäismäärä",
        columns: "columns",
        detailElements: "Yksityiskohtaiset elementit",
        allowAdaptiveActions: "Salli mukautuvat toiminnot",
        defaultRowValue: "defaultRowValue",
        detailPanelShowOnAdding: "Tietopaneeli näyttää lisäyksen yhteydessä",
        choicesLazyLoadEnabled: "Valinnat laiska kuorma käytössä",
        choicesLazyLoadPageSize: "Valinnat laiska lataussivun koko",
        inputFieldComponent: "Syöttökentän komponentti",
        itemComponent: "Nimikkeen osa",
        min: "Min",
        max: "Max",
        minValueExpression: "Pienin arvon lauseke",
        maxValueExpression: "Enimmäisarvon lauseke",
        step: "Askel",
        dataList: "Tietoluettelo",
        itemSize: "itemSize",
        itemTitleWidth: "Nimikkeen otsikon leveys (px)",
        elements: "Luonnonvoimat",
        content: "Sisältö",
        navigationButtonsVisibility: "navigationButtonsVisibility",
        navigationTitle: "Navigoinnin otsikko",
        navigationDescription: "Navigoinnin kuvaus",
        longTap: "Pitkä napautus",
        autoGrow: "Automaattinen kasvu",
        allowResize: "Salli koon muuttaminen",
        acceptCarriageReturn: "Hyväksy vaunun palautus",
        displayMode: "Näyttötila",
        rateType: "Hinnan tyyppi",
        label: "label",
        contentMode: "Sisältö-tila",
        imageFit: "Kuva sopii",
        altText: "Vaihtoehtoinen teksti",
        height: "Korkeus",
        penColor: "Kynän väri",
        backgroundColor: "Taustaväri",
        templateElements: "Mallin elementit",
        operator: "Operaattori",
        isVariable: "On vaihteleva",
        runExpression: "Suorita lauseke",
        showCaption: "Näytä kuvateksti",
        iconName: "Kuvakkeen nimi",
        iconSize: "Kuvakkeen koko",
        precision: "Tarkkuus",
        matrixDragHandleArea: "Matriisin vetokahva-alue",
        backgroundImage: "Taustakuvan",
        backgroundImageFit: "Taustakuvan sovitus",
        backgroundImageAttachment: "Taustakuvan liite",
        backgroundOpacity: "Taustan peittävyys",
        selectToRankEnabled: "Valitse sijoitus käytössä",
        selectToRankAreasLayout: "Valitse alueiden asettelu",
        selectToRankEmptyRankedAreaText: "Teksti, joka näyttää, onko kaikki asetukset valittu",
        selectToRankEmptyUnrankedAreaText: "Sijoitusalueen paikkamerkkiteksti",
        allowCameraAccess: "Salli kameran käyttö",
        scaleColorMode: "Skaalaa väriä -tila",
        rateColorMode: "Arvioi väritila",
        copyDisplayValue: "Kopioi näyttöarvo",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Edistynyt tila",
        pageTitle: "Sivun otsikon fontti",
        questionTitle: "Kysymyksen otsikon fontti",
        editorPanel: "Syötä elementti",
        lines: "Rivit",
        primaryDefaultColor: "Laiminlyönti",
        primaryDarkColor: "Häilyä",
        primaryLightColor: "Valittu",
        backgroundDimColor: "Taustaväri",
        cornerRadius: "Kulman säde",
        backcolor: "Oletustausta",
        hovercolor: "Vie hiiri taustalle",
        borderDecoration: "Reunusten koristelu",
        fontColor: "Fontin väri",
        backgroundColor: "Taustaväri",
        primaryForecolor: "Oletusväri",
        primaryForecolorLight: "Käytöstä poistettu väri",
        font: "Fontti",
        borderDefault: "Tummempi",
        borderLight: "Sytytin",
        fontFamily: "Fonttiperhe",
        fontWeightRegular: "Säännöllinen",
        fontWeightHeavy: "Raskas",
        fontWeightSemiBold: "Puoliksi lihavoitu",
        fontWeightBold: "Rohkea",
        color: "Väri",
        placeholderColor: "Paikkamerkin väri",
        size: "Koko",
        opacity: "Läpikuultamattomuus",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Lisää varjotehoste",
        boxShadowBlur: "Hämärtyä",
        boxShadowSpread: "Leviäminen",
        boxShadowDrop: "Pisara",
        boxShadowInner: "Sisäinen",
        names: {
            default: "Laiminlyönti",
            sharp: "Terävä",
            borderless: "Reunukseton",
            flat: "Tasainen",
            plain: "Tasanko",
            doubleborder: "Kaksinkertainen reunus",
            layered: "Kerroksellinen",
            solid: "Kiinteä",
            threedimensional: ".3D",
            contrast: "Kontrasti"
        },
        colors: {
            teal: "Tavi",
            blue: "Sininen",
            purple: "Purppura",
            orchid: "Orkidea",
            tulip: "Tulppaani",
            brown: "Ruskea",
            green: "Vihreä"
        }
    }
};
// Uncomment this line on creating a translation file. You should replace "en" and enStrings with your locale ("fr", "de" and so on) and your variable.
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["fi"] = fiStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// qt.tagbox: "Multi-Select Dropdown" => "Avattava monivalintavalikko"
// qt.buttongroup: "Button Group" => "Painike-ryhmä"
// ed.surveySettings: "Survey Settings" => "Kyselyn asetukset"
// ed.surveySettingsTooltip: "Open survey settings" => "Avaa kyselyn asetukset"
// ed.prevSelected: "Select previous" => "Valitse edellinen"
// ed.nextSelected: "Select next" => "Valitse seuraava"
// ed.surveyTypeName: "Survey" => "Tutkimus"
// ed.pageTypeName: "Page" => "Sivu"
// ed.panelTypeName: "Panel" => "Paneeli"
// ed.questionTypeName: "Question" => "Kysymys"
// ed.columnTypeName: "Column" => "Sarake"
// ed.themeSurvey: "Themes" => "Teemoja"
// ed.defaultV2Theme: "Default" => "Laiminlyönti"
// ed.modernTheme: "Modern" => "Nykyaikainen"
// ed.defaultTheme: "Default (legacy)" => "Oletus (vanha)"
// ed.jsonHideErrors: "Hide errors" => "Piilota virheet"
// ed.jsonShowErrors: "Show errors" => "Näytä virheet"
// ed.showMoreChoices: "Show more" => "Näytä lisää"
// ed.showLessChoices: "Show less" => "Näytä vähemmän"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "Kirjoita etsiäksesi..."
// ed.toolboxChoiceCategory: "Choice Questions" => "Valintaa koskevat kysymykset"
// ed.toolboxTextCategory: "Text Input Questions" => "Tekstinsyöttökysymykset"
// ed.toolboxContainersCategory: "Containers" => "Säiliöt"
// ed.toolboxMatrixCategory: "Matrix Questions" => "Matriisin kysymykset"
// ed.toolboxMiscCategory: "Misc" => "Muut"
// ed.translationPropertyGridTitle: "Language Settings" => "Kieliasetukset"
// ed.themePropertyGridTitle: "Theme Settings" => "Teeman asetukset"
// ed.translationLanguages: "Languages" => "Kielet"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "Vain käytetyt merkkijonot"
// ed.translationPlaceHolder: "Translation..." => "Käännös..."
// ed.themeExportButton: "Export" => "Vienti"
// ed.themeImportButton: "Import" => "Tuoda"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Valinnat kopioidaan kohteesta"
// ed.htmlPlaceHolder: "HTML content will be here." => "HTML-sisältö on täällä."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "Pudota kysymys työkalupakista tähän."
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "Kysely on tyhjä. Vedä elementti työkalupakista tai napsauta alla olevaa painiketta."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Vedä ja pudota kuva tähän tai napsauta alla olevaa painiketta ja valitse ladattava kuva"
// ed.imageChooseImage: "Choose Image" => "Valitse kuva"
// ed.addNewTypeQuestion: "Add {0}" => "Lisää {0}"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[LOGO]"
// ed.auto: "auto" => "auto"
// ed.choices_Item: "Item " => "Kohta "
// lg.addNewItem: "Add New Rule" => "Lisää uusi sääntö"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "Luo sääntö kyselyn kulun mukauttamista varten."
// lg.page_enableName: "Enable (disable) page" => "Ota käyttöön (poista käytöstä) sivu"
// lg.column_visibilityName: "Show (hide) column" => "Näytä (piilota) -sarake"
// lg.column_enableName: "Enable (disable) column" => "Ota käyttöön (poista käytöstä) sarake"
// lg.column_requireName: "Make column required" => "Tee sarakkeesta pakollinen"
// lg.itemEmptyExpressionText: "New rule" => "Uusi sääntö"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "Tee kysymyksen {1} sarakkeesta {0} näkyvä"
// lg.column_enableText: "make column {0} of question {1} enable" => "Ota kysymyksen sarake {0} {1} käyttöön"
// lg.column_requireText: "make column {0} of question {1} required" => "Tee kysymyksen sarake {0} {1} pakollinen"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "Selkeän kysymyksen arvo: {0}"
// lg.showAllQuestions: "All Questions" => "Kaikki kysymykset"
// lg.showAllActionTypes: "All Action Types" => "Kaikki toimintotyypit"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Loogiset säännöt ovat epätäydellisiä"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Et ole suorittanut joitakin loogisia sääntöjä. Jos poistut välilehdestä nyt, muutokset menetetään. Haluatko silti poistua välilehdeltä suorittamatta muutoksia?"
// lg.uncompletedRule_apply: "Yes" => "Kyllä"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Ei, haluan täyttää säännöt"
// pe.clear: "Clear" => "Selvä"
// pe.set: "Set" => "Joukko"
// pe.change: "Change" => "Muuttaa"
// pe.close: "Close" => "Sulkea"
// pe.removeItem: "Click to remove the item..." => "Poista kohde napsauttamalla..."
// pe.dragItem: "Drag the item" => "Kohteen vetäminen"
// pe.doneEditing: "Done" => "Valmis"
// pe.emptyValue: "Value is empty" => "Arvo on tyhjä"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "Arvo \"{0}\" ei ole ainutkertainen"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "Rajoita tuotteiden määrä {0} {1}"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "Voit asettaa tiedot seuraavassa muodossa:\narvo1|teksti\narvo2"
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "Esikatsele vastauksia ennen kyselyn lähettämistä"
// pe.overridingPropertyPrefix: "Set by " => "Asettaja "
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Älä käytä varattuja sanoja: \"kohde\", \"valinta\", \"paneeli\", \"rivi\"."
// pe.listIsEmpty@choices: "No choices have been added yet" => "Vaihtoehtoja ei ole vielä lisätty"
// pe.addNew@choices: "Add a choice" => "Lisää vaihtoehto"
// choicesbyurl.valueName: "Get values from the following JSON field" => "Hae arvot seuraavasta JSON-kentästä"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "Hae kuvien URL-osoitteet seuraavasta JSON-kentästä"
// pe.allowEmptyResponse: "Allow empty response" => "Salli tyhjä vastaus"
// pe.and: "and" => "ja"
// pe.or: "or" => "tai"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Aloita ehtojen määrittäminen valitsemalla kysymys."
// pe.if: "If" => "Jos"
// pe.then: "then" => "sitten"
// pe.setToName: "Target question" => "Kohteen kysymys"
// pe.fromName: "Question to copy answer from" => "Kysymys, josta vastaus kopioidaan"
// pe.gotoName: "Question to skip to" => "Kysymys, johon kannattaa siirtyä"
// pe.ruleIsNotSet: "Rule is incorrect" => "Sääntö on virheellinen"
// pe.includeIntoResult: "Include into survey results" => "Sisällytä kyselyn tuloksiin"
// pe.portraitOrientation: "Switch to portrait orientation" => "Pystysuuntaan vaihtaminen"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Kuvan korkeus (CSS:n hyväksymissä arvoissa)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Kuvan leveys (CSS-hyväksytyissä arvoissa)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "Sivun viimeistelyn aikaraja (sekunteina)"
// question.page: "Parent page" => "Pääsivu"
// pe.noEntriesText: "Empty entries text" => "Tyhjät merkinnät -teksti"
// pe.setValue: "Answer" => "Vastata"
// pe.dataFormat: "Image format" => "Kuvan muoto"
// pe.allowAddRows: "Allow adding rows" => "Salli rivien lisääminen"
// pe.allowRemoveRows: "Allow removing rows" => "Salli rivien poistaminen"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "Salli rivin vetäminen ja pudottaminen"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "Ei sovelleta, jos määrität kuvan tarkan leveyden tai korkeuden."
// pe.minImageWidth: "Minimum image width" => "Kuvan vähimmäisleveys"
// pe.maxImageWidth: "Maximum image width" => "Kuvan enimmäisleveys"
// pe.minImageHeight: "Minimum image height" => "Kuvan vähimmäiskorkeus"
// pe.maxImageHeight: "Maximum image height" => "Kuvan enimmäiskorkeus"
// surveyvalidator.text: "Error message" => "Virheviesti"
// surveyvalidator.expression: "Validation expression" => "Vahvistuksen lauseke"
// pe.totalText: "Total row text" => "Rivin teksti yhteensä"
// pe.totalType: "Total type" => "Tyyppi yhteensä"
// pe.totalExpression: "Total expression" => "Kokonaislauseke"
// pe.totalDisplayStyle: "Total value display style" => "Kokonaisarvon näyttötyyli"
// pe.totalCurrency: "Currency" => "Valuutta"
// pe.totalFormat: "Formatted string" => "Muotoiltu merkkijono"
// pe.logo: "Logo (URL or base64-encoded string)" => "Logo (URL-osoite tai base64-koodattu merkkijono)"
// pe.questionsOnPageMode: "Survey structure" => "Kyselyn rakenne"
// pe.maxTextLength: "Maximum answer length (in characters)" => "Vastauksen enimmäispituus (merkkeinä)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "Kommentin enimmäispituus (merkkeinä)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "Laajenna kommenttialue tarvittaessa automaattisesti"
// pe.allowResizeComment: "Allow users to resize text areas" => "Salli käyttäjien muuttaa tekstialueiden kokoa"
// pe.textUpdateMode: "Update text question value" => "Tekstikysymyksen arvon päivittäminen"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "Aseta kohdistus ensimmäiseen virheelliseen vastaukseen"
// pe.checkErrorsMode: "Run validation" => "Suorita vahvistus"
// pe.navigateToUrl: "Navigate to URL" => "Siirry URL-osoitteeseen"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "Dynaaminen URL-osoite"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "Merkintä, joka osoittaa, onko käyttäjä jo täyttänyt tämän kyselyn"
// pe.completedHtml: "Survey Complete page markup" => "Kyselyn sivujen merkinnät suoritettu"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "Dynaaminen kysely viimeistelee sivun merkinnät"
// pe.loadingHtml: "Markup to show while survey model is loading" => "Merkintä, joka näkyy, kun kyselymalli latautuu"
// pe.commentText: "Comment area text" => "Kommenttialueen teksti"
// pe.autocomplete: "Autocomplete type" => "Automaattisen täydennyksen tyyppi"
// pe.labelTrue: "\"True\" label" => "\"True\"-merkintä"
// pe.labelFalse: "\"False\" label" => "Epätosi-tunniste"
// pe.allowClear: "Show the Clear button" => "Näytä Tyhjennä-painike"
// pe.displayStyle: "Value display style" => "Arvon näyttötyyli"
// pe.format: "Formatted string" => "Muotoiltu merkkijono"
// pe.maximumFractionDigits: "Maximum fractional digits" => "Murtolukujen enimmäismäärä"
// pe.minimumFractionDigits: "Minimum fractional digits" => "Murtolukujen vähimmäismäärä"
// pe.useGrouping: "Display grouping separators" => "Näytä ryhmittelyerottimet"
// pe.allowMultiple: "Allow multiple files" => "Salli useita tiedostoja"
// pe.allowImagesPreview: "Preview images" => "Esikatsele kuvia"
// pe.acceptedTypes: "Accepted file types" => "Hyväksytyt tiedostotyypit"
// pe.waitForUpload: "Wait for the upload to complete" => "Odota, että lataus on valmis"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "Vahvista tiedoston poistaminen"
// pe.detailPanelMode: "Detail panel location" => "Yksityiskohtapaneelin sijainti"
// pe.minRowCount: "Minimum row count" => "Rivien vähimmäismäärä"
// pe.maxRowCount: "Maximum row count" => "Rivien enimmäismäärä"
// pe.confirmDelete: "Confirm row deletion" => "Vahvista rivin poisto"
// pe.confirmDeleteText: "Confirmation message" => "Vahvistussanoma"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "Vahvista paneelin poisto"
// pe.panelCount: "Initial panel count" => "Paneelien alkuperäinen määrä"
// pe.minPanelCount: "Minimum panel count" => "Paneelien vähimmäismäärä"
// pe.maxPanelCount: "Maximum panel count" => "Paneelien enimmäismäärä"
// pe.panelsState: "Inner panel expand state" => "Sisäpaneelin laajennustila"
// pe.templateDescription: "Description template" => "Kuvaus-malli"
// pe.templateTitle: "Title template" => "Otsikko-malli"
// pe.panelPrevText: "Previous Panel button tooltip" => "Edellinen paneeli -painikkeen työkaluvihje"
// pe.panelNextText: "Next Panel button tooltip" => "Seuraava paneeli -painikkeen työkaluvihje"
// pe.showRangeInProgress: "Show progress bar" => "Näytä edistymispalkki"
// pe.templateTitleLocation: "Question title location" => "Kysymyksen otsikon sijainti"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "Poista paneelipainikkeen sijainti"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "Piilota kysymys, jos rivejä ei ole"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Piilota sarakkeet, jos rivejä ei ole"
// pe.rateValues: "Custom rate values" => "Muokatut hinta-arvot"
// pe.rateCount: "Rate count" => "Hintojen määrä"
// pe.autoGenerate: "How to specify rate values?" => "Miten korkoarvot määritetään?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "Piilota kysymys, jos se ei sisällä vaihtoehtoja"
// pe.hideNumber: "Hide question number" => "Piilota kysymyksen numero"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Vähimmäisleveys (CSS-hyväksyttyinä arvoina)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Suurin leveys (CSS-hyväksytyissä arvoissa)"
// pe.width: "Width (in CSS-accepted values)" => "Leveys (CSS-hyväksytyissä arvoissa)"
// pe.showHeader: "Show column headers" => "Näytä sarakeotsikot"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Näytä vaakasuora vierityspalkki"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Sarakkeen vähimmäisleveys (CSS-hyväksytyissä arvoissa)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Riviotsikon leveys (CSS-hyväksytyissä arvoissa)"
// pe.valueTrue: "\"True\" value" => "\"Tosi\"-arvo"
// pe.valueFalse: "\"False\" value" => "Epätosi-arvo"
// pe.minErrorText: "\"Value is below minimum\" error message" => "Arvo on alle minimin -virhesanoma"
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "\"Arvo ylittää maksimin\" -virhesanoma"
// pe.otherErrorText: "\"Empty comment\" error message" => "Tyhjä kommentti -virhesanoma"
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "Ei-yksilöllinen avainarvo -virhesanoma"
// pe.minSelectedChoices: "Minimum selected choices" => "Valitut valinnat vähintään:"
// pe.maxSelectedChoices: "Maximum selected choices" => "Valittujen vaihtoehtojen enimmäismäärä"
// pe.showClearButton: "Show the Clear button" => "Näytä Tyhjennä-painike"
// pe.showNumber: "Show panel number" => "Näytä paneelin numero"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "Logon leveys (CSS-hyväksytyissä arvoissa)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "Logon korkeus (CSS:n hyväksymissä arvoissa)"
// pe.readOnly: "Read-only" => "Vain luku -tilassa"
// pe.enableIf: "Editable if" => "Muokattavissa, jos"
// pe.emptyRowsText: "\"No rows\" message" => "Ei rivejä -viesti"
// pe.size: "Input field size (in characters)" => "Syöttökentän koko (merkkeinä)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "Erilliset erikoisvalinnat (Ei mitään, Muu, Valitse kaikki)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Kopioi valinnat seuraavasta kysymyksestä"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Mitkä vaihtoehdot kopioidaan?"
// pe.showCommentArea: "Show the comment area" => "Näytä kommenttialue"
// pe.commentPlaceholder: "Comment area placeholder" => "Kommenttialueen paikkamerkki"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Näytä nopeuskuvaukset ääriarvoina"
// pe.rowsOrder: "Row order" => "Rivien järjestys"
// pe.columnsLayout: "Column layout" => "Sarakkeen asettelu"
// pe.columnColCount: "Nested column count" => "Sisäkkäisten sarakkeiden määrä"
// pe.state: "Panel expand state" => "Paneelin laajenna tila"
// pe.correctAnswer: "Correct Answer" => "Oikea vastaus"
// pe.defaultPanelValue: "Default Values" => "Oletusarvot"
// pe.cells: "Cell Texts" => "Solujen tekstit"
// pe.keyName: "Key column" => "Avainsarake"
// itemvalue.text: "Alt text" => "Vaihtoehtoinen teksti"
// tabs.expression: "Expression" => "Lauseke"
// pe.choicesVisibleIf: "Choices are visible if" => "Valinnat näkyvät, jos"
// pe.choicesEnableIf: "Choices are selectable if" => "Valinnat ovat valittavissa, jos"
// pe.columnsEnableIf: "Columns are visible if" => "Sarakkeet ovat näkyvissä, jos"
// pe.rowsEnableIf: "Rows are visible if" => "Rivit ovat näkyvissä, jos"
// pe.indent: "Add indents" => "Sisennysten lisääminen"
// panel.indent: "Add outer indents" => "Ulompien sisennysten lisääminen"
// pe.innerIndent: "Add inner indents" => "Sisäisten sisennysten lisääminen"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "Oletusarvojen ottaminen viimeiseltä riviltä"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "Ota oletusarvot viimeisestä paneelista"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "Kirjoita lauseke tähän..."
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "Poista arvo, jos kysymys piilotetaan"
// pe.valuePropertyName: "Value property name" => "Arvo-ominaisuuden nimi"
// pe.searchEnabled: "Enable search" => "Ota haku käyttöön"
// pe.hideSelectedItems: "Hide selected items" => "Piilota valitut kohteet"
// pe.closeOnSelect: "Close the dropdown after selection" => "Sulkee valinnan jälkeisen avattavan valikon."
// pe.signatureWidth: "Signature width" => "Allekirjoituksen leveys"
// pe.signatureHeight: "Signature height" => "Allekirjoituksen korkeus"
// pe.verticalAlign: "Vertical alignment" => "Pystysuuntainen tasaus"
// pe.alternateRows: "Alternate rows" => "Vaihtoehtoiset rivit"
// pe.columnsVisibleIf: "Columns are visible if" => "Sarakkeet ovat näkyvissä, jos"
// pe.rowsVisibleIf: "Rows are visible if" => "Rivit ovat näkyvissä, jos"
// pe.otherPlaceholder: "Comment area placeholder" => "Kommenttialueen paikkamerkki"
// pe.rateType: "Rate type" => "Hinnan tyyppi"
// pv.true: "true" => "tosi"
// pv.false: "false" => "väärä"
// pv.decimal: "decimal" => "desimaali"
// pv.currency: "currency" => "valuutta"
// pv.percent: "percent" => "prosentti"
// pv.onpanel: "Start on each panel" => "Aloita jokaisesta paneelista"
// pv.tab: "Tabs" => "Välilehdet"
// pv.right: "Right" => "Oikea"
// pv.color: "color" => "väri"
// pv.date: "date" => "päivämäärä"
// pv.datetime: "datetime" => "päivämäärä ja aika"
// pv.datetime-local: "datetime-local" => "datetime-local"
// pv.email: "email" => "Sähköposti"
// pv.month: "month" => "kuukausi"
// pv.number: "number" => "numero"
// pv.password: "password" => "salasana"
// pv.range: "range" => "etäisyys"
// pv.tel: "tel" => "puh"
// pv.text: "text" => "Tekstiviesti"
// pv.time: "time" => "Aika"
// pv.url: "url" => "URL"
// pv.week: "week" => "viikko"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "Kun kysymys tai sen paneeli/sivu piilotetaan"
// clearInvisibleValues.none: "Never" => "Koskaan"
// inputType.color: "Color" => "Väri"
// inputType.date: "Date" => "Päivämäärä"
// inputType.datetime-local: "Date and Time" => "Päivämäärä ja kellonaika"
// inputType.email: "Email" => "Sähköposti"
// inputType.month: "Month" => "Kuukausi"
// inputType.number: "Number" => "Numero"
// inputType.password: "Password" => "Salasana"
// inputType.range: "Range" => "Etäisyys"
// inputType.tel: "Phone Number" => "Puhelinnumero"
// inputType.text: "Text" => "Tekstiviesti"
// inputType.time: "Time" => "Aika"
// inputType.url: "URL" => "URL"
// inputType.week: "Week" => "Viikko"
// pv.onValueChanging: "Before an answer is changed" => "Ennen vastauksen muuttamista"
// pv.pages: "Completed pages" => "Valmiit sivut"
// pv.questions: "Answered questions" => "Vastatut kysymykset"
// pv.requiredQuestions: "Answered required questions" => "Vastatut vaaditut kysymykset"
// pv.correctQuestions: "Valid answers" => "Kelvolliset vastaukset"
// pv.buttons: "Completed pages (button UI)" => "Valmiit sivut (painike Käyttöliittymä)"
// pv.underInput: "Under the input" => "Tulon alla"
// pv.underTitle: "Under the title" => "Otsikon alla"
// pv.onBlur: "On blur" => "Sumennuksessa"
// pv.onTyping: "While typing" => "Kirjoittamisen aikana"
// pv.underRow: "Under the row" => "Rivin alla"
// pv.underRowSingle: "Under the row, only one panel is visible" => "Rivin alla näkyy vain yksi paneeli"
// showNavigationButtons.none: "Hidden" => "Piilevä"
// showProgressBar.off: "Hidden" => "Piilevä"
// showTimerPanel.none: "Hidden" => "Piilevä"
// showTimerPanelMode.all: "Both" => "Molemmat"
// detailPanelMode.none: "Hidden" => "Piilevä"
// addRowLocation.default: "Depends on matrix layout" => "Riippuu matriisin asettelusta"
// panelsState.default: "Users cannot expand or collapse panels" => "Käyttäjät eivät voi laajentaa tai kutistaa paneeleja"
// panelsState.collapsed: "All panels are collapsed" => "Kaikki paneelit on tiivistetty"
// panelsState.expanded: "All panels are expanded" => "Kaikki paneelit on laajennettu"
// widthMode.auto: "Auto" => "Auto"
// widthMode.static: "Static" => "Staattinen"
// widthMode.responsive: "Responsive" => "Reagoiva"
// imageFit.none: "None" => "Ei lainkaan"
// imageFit.contain: "Contain" => "Sisältää"
// imageFit.cover: "Cover" => "Kansi"
// imageFit.fill: "Fill" => "Täyttää"
// contentMode.auto: "Auto" => "Auto"
// contentMode.image: "Image" => "Kuva"
// contentMode.video: "Video" => "Video"
// contentMode.youtube: "YouTube" => "YouTubessa"
// displayMode.auto: "Auto" => "Auto"
// displayMode.buttons: "Buttons" => "Painikkeet"
// displayMode.dropdown: "Dropdown" => "Avattava valikko"
// rateColorMode.default: "Default" => "Laiminlyönti"
// autoGenerate.true: "Generate" => "Synnyttää"
// autoGenerate.false: "Enter manually" => "Kirjoita manuaalisesti"
// rateType.labels: "Labels" => "Otsikot"
// rateType.stars: "Stars" => "Tähteä"
// rateType.smileys: "Smileys" => "Hymiöt"
// op.and: "and" => "ja"
// op.or: "or" => "tai"
// ts.hideInvisibleElements: "Hide invisible elements" => "Piilota näkymättömät elementit"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Evästeet estävät käyttäjiä täyttämästä samaa kyselyä kahdesti."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Muuttaa syöttökentän näkyvän alueen kokoa. Käytä <b>Validointi → enimmäispituus</b> -asetusta rajoittaaksesi tulon pituutta."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Käytä {0} todellisen arvon paikkamerkkinä."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Näkyy vain, kun vähintään yhdessä sarakkeessa on Summa-tyyppi tai Summa-lauseke."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Katso lisätietoja määritteen [accept](https://www.w3schools.com/tags/att_input_accept.asp) kuvauksesta."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Koskee vain radioryhmä- ja valintaruutusolutyyppejä."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Lisätietoja on [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) -määritteen kuvauksessa."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Jos et määritä tätä ominaisuutta, vastaus tallennetaan Name-ominaisuuden määrittämään kenttään."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Jos määritetty sarake sisältää samat arvot, kysely heittää \"Ei-yksilöllinen avainarvo\" -virheen."
// p.multiSelect: "Allow multiple selection" => "Salli monivalinta"
// p.showLabel: "Show image captions" => "Näytä kuvatekstit"
// p.value: "Value" => "Arvo"
// p.tabAlign: "Tab alignment" => "Sarkaimen tasaus"
// p.logoFit: "Logo fit" => "Logon sopivuus"
// p.pages: "Pages" => "Sivut"
// p.questions: "Questions" => "Kysymyksiä"
// p.calculatedValues: "Calculated values" => "Lasketut arvot"
// p.surveyId: "Survey id" => "Kyselyn tunnus"
// p.surveyPostId: "Survey post id" => "Kyselyn viestin tunnus"
// p.surveyShowDataSaving: "Survey show data saving" => "Kysely näyttää tietojen tallennuksen"
// p.questionDescriptionLocation: "Question description location" => "Kysymyksen kuvauksen sijainti"
// p.progressBarType: "Progress bar type" => "Edistymispalkin tyyppi"
// p.showTOC: "Show TOC" => "Näytä sisällysluettelo"
// p.tocLocation: "Toc location" => "Toc-sijainti"
// p.questionTitlePattern: "Question title pattern" => "Kysymyksen otsikkomalli"
// p.widthMode: "Width mode" => "Leveys-tila"
// p.showBrandInfo: "Show brand info" => "Näytä brändin tiedot"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "Näyttöarvojen käyttäminen dynaamisissa teksteissä"
// p.descriptionLocation: "Description location" => "Kuvaus, sijainti"
// p.defaultValueExpression: "Default value expression" => "Oletusarvon lauseke"
// p.bindings: "Bindings" => "Siteet"
// p.renderAs: "Render as" => "Hahmonna muodossa"
// p.attachOriginalItems: "Attach original items" => "Alkuperäisten kohteiden liittäminen"
// p.cellHint: "Cell hint" => "Solun vihje"
// p.isUnique: "Is unique" => "On ainutlaatuinen"
// p.showInMultipleColumns: "Show in multiple columns" => "Näytä useissa sarakkeissa"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Murtolukujen enimmäismäärä yhteensä"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Murtolukujen vähimmäismäärä"
// p.detailElements: "Detail elements" => "Yksityiskohtaiset elementit"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Salli mukautuvat toiminnot"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "Tietopaneeli näyttää lisäyksen yhteydessä"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Valinnat laiska kuorma käytössä"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Valinnat laiska lataussivun koko"
// p.inputFieldComponent: "Input field component" => "Syöttökentän komponentti"
// p.itemComponent: "Item component" => "Nimikkeen osa"
// p.min: "Min" => "Min"
// p.max: "Max" => "Max"
// p.minValueExpression: "Min value expression" => "Pienin arvon lauseke"
// p.maxValueExpression: "Max value expression" => "Enimmäisarvon lauseke"
// p.step: "Step" => "Askel"
// p.dataList: "Data list" => "Tietoluettelo"
// p.elements: "Elements" => "Luonnonvoimat"
// p.content: "Content" => "Sisältö"
// p.navigationTitle: "Navigation title" => "Navigoinnin otsikko"
// p.navigationDescription: "Navigation description" => "Navigoinnin kuvaus"
// p.longTap: "Long tap" => "Pitkä napautus"
// p.autoGrow: "Auto grow" => "Automaattinen kasvu"
// p.allowResize: "Allow resizing" => "Salli koon muuttaminen"
// p.acceptCarriageReturn: "Accept carriage return" => "Hyväksy vaunun palautus"
// p.displayMode: "Display mode" => "Näyttötila"
// p.rateType: "Rate type" => "Hinnan tyyppi"
// p.contentMode: "Content mode" => "Sisältö-tila"
// p.imageFit: "Image fit" => "Kuva sopii"
// p.altText: "Alt text" => "Vaihtoehtoinen teksti"
// p.height: "Height" => "Korkeus"
// p.penColor: "Pen color" => "Kynän väri"
// p.backgroundColor: "Background color" => "Taustaväri"
// p.templateElements: "Template elements" => "Mallin elementit"
// p.operator: "Operator" => "Operaattori"
// p.isVariable: "Is variable" => "On vaihteleva"
// p.runExpression: "Run expression" => "Suorita lauseke"
// p.showCaption: "Show caption" => "Näytä kuvateksti"
// p.iconName: "Icon name" => "Kuvakkeen nimi"
// p.iconSize: "Icon size" => "Kuvakkeen koko"
// p.precision: "Precision" => "Tarkkuus"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Matriisin vetokahva-alue"
// p.backgroundImage: "Background image" => "Taustakuvan"
// p.backgroundImageFit: "Background image fit" => "Taustakuvan sovitus"
// p.backgroundImageAttachment: "Background image attachment" => "Taustakuvan liite"
// p.backgroundOpacity: "Background opacity" => "Taustan peittävyys"
// p.selectToRankEnabled: "Select to rank enabled" => "Valitse sijoitus käytössä"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Valitse alueiden asettelu"
// p.allowCameraAccess: "Allow camera access" => "Salli kameran käyttö"
// p.scaleColorMode: "Scale color mode" => "Skaalaa väriä -tila"
// p.rateColorMode: "Rate color mode" => "Arvioi väritila"
// p.templateTabTitle: "Template tab title" => "Malli-välilehden otsikko"
// p.templateVisibleIf: "Template visible if" => "Malli näkyvissä, jos"
// p.copyDisplayValue: "Copy display value" => "Kopioi näyttöarvo"
// theme.--background: "Background color" => "Taustaväri"
// theme.--background-dim-light: "Background dim light color" => "Taustan himmeä vaalea väri"
// theme.--primary-foreground: "Primary foreground color" => "Ensisijainen etualan väri"
// theme.--foreground: "Foreground color" => "Edustan väri"
// theme.--base-unit: "Base unit" => "Perusyksikkö"
// theme.groupAdvanced: "Advanced" => "Edistynyt"
// theme.themeName: "Theme" => "Teema"
// theme.isPanellessss: "Question appearance" => "Kysymyksen ulkonäkö"
// theme.isPanellessPanels: "Default" => "Laiminlyönti"
// theme.isPanellessLightweight: "Without Panels" => "Ilman paneeleja"
// theme.themePaletteLight: "Light" => "Valo"
// theme.themePaletteDark: "Dark" => "Tumma"
// theme.primaryColor: "Accent color" => "Korostusväri"
// theme.primaryDefaultColor: "Default" => "Laiminlyönti"
// theme.primaryDarkColor: "Hover" => "Häilyä"
// theme.primaryLightColor: "Selected" => "Valittu"
// theme.backgroundDimColor: "Background color" => "Taustaväri"
// theme.backgroundImage: "Background image" => "Taustakuvan"
// theme.backgroundImageFitAuto: "Auto" => "Auto"
// theme.backgroundImageFitCover: "Cover" => "Kansi"
// theme.backgroundImageFitContain: "Contain" => "Sisältää"
// theme.backgroundOpacity: "Opacity" => "Läpikuultamattomuus"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Kiinteä"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Vierittää"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Paneelin taustan peittävyys"
// theme.questionBackgroundTransparency: "Question background opacity" => "Taustan peittävyyden kyseenalaistaminen"
// theme.questionPanel: "Panel background and corner radius" => "Paneelin tausta ja kulmasäde"
// theme.questionTitle: "Question title font" => "Kysymyksen otsikon fontti"
// theme.questionDescription: "Question description font" => "Kysymyksen kuvauksen fontti"
// theme.editorPanel: "Input element" => "Syötä elementti"
// theme.editorFont: "Input element font" => "Syöttöelementin fontti"
// theme.backcolor: "Default background" => "Oletustausta"
// theme.hovercolor: "Hover background" => "Vie hiiri taustalle"
// theme.borderDecoration: "Border decoration" => "Reunusten koristelu"
// theme.accentBackground: "Accent background" => "Aksentti tausta"
// theme.accentForeground: "Accent foreground" => "Aksentti etualalla"
// theme.primaryForecolor: "Default color" => "Oletusväri"
// theme.primaryForecolorLight: "Disabled color" => "Käytöstä poistettu väri"
// theme.linesColors: "Minor line colors" => "Pienet viivan värit"
// theme.borderDefault: "Darker" => "Tummempi"
// theme.borderLight: "Lighter" => "Sytytin"
// theme.fontFamily: "Font family" => "Fonttiperhe"
// theme.fontSize: "Font size" => "Kirjasinkoko"
// theme.color: "Color" => "Väri"
// theme.size: "Size" => "Koko"
// theme.fontWeightRegular: "Regular" => "Säännöllinen"
// theme.fontWeightHeavy: "Heavy" => "Raskas"
// theme.fontWeightSemiBold: "Semi-bold" => "Puoliksi lihavoitu"
// theme.fontWeightBold: "Bold" => "Rohkea"
// theme.scale: "Scale" => "Mittakaava"
// theme.cornerRadius: "Corner radius" => "Kulman säde"
// theme.surveyTitleFont: "Survey title font" => "Kyselyn otsikon fontti"
// theme.pageTitle: "Page title font" => "Sivun otsikon fontti"
// theme.pageDescription: "Page description font" => "Sivun kuvauksen fontti"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Lisää varjotehoste"
// theme.opacity: "Opacity" => "Läpikuultamattomuus"
// theme.boxShadowBlur: "Blur" => "Hämärtyä"
// theme.boxShadowSpread: "Spread" => "Leviäminen"
// theme.boxShadowDrop: "Drop" => "Pisara"
// theme.boxShadowInner: "Inner" => "Sisäinen"
// theme.questionShadow: "Shadow effects" => "Varjo-tehosteet"
// theme.editorShadow: "Input element shadow effects" => "Syöttöelementin varjotehosteet"
// names.default: "Default" => "Laiminlyönti"
// names.contrast: "Contrast" => "Kontrasti"
// names.plain: "Plain" => "Tasanko"
// names.simple: "Simple" => "Yksinkertainen"
// names.blank: "Blank" => "Aihio"
// names.double: "Double" => "Kaksinkertainen"
// names.bulk: "Bulk" => "Massa"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo 3D"
// names.playful: "Playful" => "Leikkisä"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Tavi"
// colors.blue: "Blue" => "Sininen"
// colors.purple: "Purple" => "Purppura"
// colors.orchid: "Orchid" => "Orkidea"
// colors.tulip: "Tulip" => "Tulppaani"
// colors.brown: "Brown" => "Ruskea"
// colors.green: "Green" => "Vihreä"
// names.sharp: "Sharp" => "Terävä"
// names.borderless: "Borderless" => "Reunukseton"
// names.flat: "Flat" => "Tasainen"
// names.doubleborder: "Double Border" => "Kaksinkertainen reunus"
// names.layered: "Layered" => "Kerroksellinen"
// names.solid: "Solid" => "Kiinteä"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Oletko varma, että haluat poistaa kaikki merkkijonot tältä kieleltä?"
// ed.themeResetButton: "Reset theme settings to default" => "Palauta teema-asetukset oletusasetuksiin"
// theme.placeholderColor: "Placeholder color" => "Paikkamerkin väri"
// ed.themeSettings: "Theme Settings" => "Teeman asetukset"
// ed.themeSettingsTooltip: "Open theme settings" => "Avaa teema-asetukset"
// pe.resetToDefaultCaption: "Reset" => "Nollata"
// pv.file: "Local files" => "Paikalliset tiedostot"
// pv.camera: "Camera" => "Kamera"
// pv.file-camera: "Local files or camera" => "Paikalliset tiedostot tai kamera"
// ed.translateUsigAI: "Auto-translate All" => "Käännä kaikki automaattisesti"
// ed.translationDialogTitle: "Untranslated strings" => "Kääntämättömät merkkijonot"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Anna vähintään {0} kohdetta"
// lg.question_resetValueName: "Reset question value" => "Palauta kysymyksen arvo"
// lg.column_resetValue: "Reset column value" => "Palauta sarakkeen arvo"
// pe.markRequired: "Mark as required" => "Merkitse pakollisesti"
// pe.removeRequiredMark: "Remove the required mark" => "Poista vaadittu merkki"
// p.resetValueIf: "Reset value if" => "Nollaa arvo, jos"
// lg.question_setValueName: "Set question value" => "Aseta kysymyksen arvo"
// lg.column_resetValueName: "Reset column value" => "Palauta sarakkeen arvo"
// lg.column_setValueName: "Set column value" => "Sarakkeen arvon määrittäminen"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Lauseke, jonka tulos määritetään kohdekysymykselle."
// survey.title: "Title" => "Nimike"
// page.title: "Title" => "Nimike"
// p.setValueIf: "Set value if" => "Aseta arvo, jos"
// theme.header: "Header" => "Otsikko"
// theme.backgroundImageFitFill: "Stretch" => "Venyä"
// theme.backgroundImageFitTile: "Tile" => "Laatta"
// theme.headerView: "View" => "Näkymä"
// theme.headerViewBasic: "Basic" => "Emäksinen"
// theme.headerViewAdvanced: "Advanced" => "Edistynyt"
// theme.headerInheritWidthFrom: "Content area width" => "Sisältöalueen leveys"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Sama kuin kyselyssä"
// theme.headerInheritWidthFromPage: "Fit to page" => "Sovita sivulle"
// theme.headerTextAreaWidth: "Text width" => "Tekstin leveys"
// theme.headerBackgroundColorSwitch: "Background color" => "Taustaväri"
// theme.headerBackgroundColorNone: "None" => "Ei lainkaan"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Korostusväri"
// theme.headerBackgroundColorCustom: "Custom" => "Tapa"
// theme.horizontalAlignmentLeft: "Left" => "Vasen"
// theme.horizontalAlignmentCenter: "Center" => "Keskus"
// theme.horizontalAlignmentRight: "Right" => "Oikea"
// theme.verticalAlignmentTop: "Top" => "Huippu"
// theme.verticalAlignmentMiddle: "Middle" => "Keskus"
// theme.verticalAlignmentBottom: "Bottom" => "Pohja"
// theme.logoPosition: "Logo Position" => "Logon sijainti"
// theme.headerTitlePosition: "Title Position" => "Otsikon sijainti"
// lg.question_resetValueText: "reset value for question: {0}" => "nollaa kysymyksen arvo: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Määritä arvo: {1} kysymykseen: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Palauta sarakkeen soluarvo: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Määritä solun arvo: {1} sarakkeeseen: {0}"
// ed.surveyJsonExportButton: "Export" => "Vienti"
// ed.surveyJsonImportButton: "Import" => "Tuoda"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Kopioi leikepöydälle"
// pe.filePlaceholder: "File placeholder text" => "Tiedoston paikkamerkkiteksti"
// pe.photoPlaceholder: "Photo placeholder text" => "Valokuvan paikkamerkkiteksti"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Tiedoston tai valokuvan paikkamerkkiteksti"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Käytetään, kun \"Lähdetyyppi\" on \"Paikalliset tiedostot\" tai kun kamera ei ole käytettävissä"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Käytetään, kun \"Lähdetyyppi\" on \"Kamera\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Käytetään, kun \"Lähdetyyppi\" on \"Paikalliset tiedostot tai kamera\"."
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Haluatko todella nollata teeman? Kaikki mukautuksesi menetetään."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Kyllä, nollaa teema"
// theme.background: "Background" => "Tausta"
// theme.appearance: "Appearance" => "Ulkonäkö"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Sovita konttiin"
// signaturepad.showPlaceholder: "Show the placeholder" => "Paikkamerkin näyttäminen"
// signaturepad.placeholder: "Placeholder text" => "Paikkamerkkiteksti"
// theme.surveyDescriptionFont: "Survey description font" => "Kyselyn kuvauksen fontti"r
// ed.prevFocus: "Focus previous" => "Keskity edelliseen"
// ed.nextFocus: "Focus next" => "Keskity seuraavaksi"
// ed.saveTheme: "Save Theme" => "Tallenna teema"
// ed.saveThemeTooltip: "Save Theme" => "Tallenna teema"
// lg.page_requireName: "Make page required" => "Tee sivusta pakollinen"
// lg.panel_requireName: "Make page required" => "Tee sivusta pakollinen"
// signaturepad.signatureWidth: "Signature area width" => "Allekirjoitusalueen leveys"
// signaturepad.signatureHeight: "Signature area height" => "Allekirjoitusalueen korkeus"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Allekirjoitusalueen automaattinen skaalaus"
// signaturepad.penMinWidth: "Minimum pen width" => "Kynän vähimmäisleveys"
// signaturepad.penMaxWidth: "Maximum pen width" => "Kynän enimmäisleveys"
// theme.headerDescriptionPosition: "Description position" => "Kuvauksen sijainti"
// ed.propertyGridNoResultsFound: "No results found" => "Tuloksia ei löytynyt"
// pv.leftRight: "Left and right" => "Vasen ja oikea"
// p.sourceType: "Source type" => "Lähteen tyyppi"
// p.fitToContainer: "Fit to container" => "Sovita konttiin"
// p.setValueExpression: "Set value expression" => "Arvolausekkeen määrittäminen"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Valinnat ladataan verkkopalvelusta."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Siirry asetuksiin"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Ladattujen valintavaihtoehtojen esikatselu"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Estä päällekkäiset vastaukset riveillä"
// theme.advancedMode: "Advanced mode" => "Edistynyt tila"
// theme.backgroundCornerRadius: "Background and corner radius" => "Taustan ja kulman säde"
// theme.colorsTitle: "Colors" => "Värit"
// theme.font: "Font" => "Fontti"
// theme.lines: "Lines" => "Rivit"
// theme.titleFont: "Title font" => "Otsikon fontti"
// theme.descriptionFont: "Description font" => "Kuvauksen fontti"
// theme.shadow: "Shadow effects" => "Varjo-tehosteet"
// ed.translateUsigAIFrom: "Translate from: " => "Käännös: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Salli Kieltäydy vastaamasta -vaihtoehto"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Salli En tiedä -vaihtoehto"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Salli Kieltäydy vastaamasta -vaihtoehto"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Salli En tiedä -vaihtoehto"
// pv.contain: "Contain" => "Sisältää"
// pv.cover: "Cover" => "Kansi"
// pv.fill: "Fill" => "Täyttää"
// pe.transposeData: "Transpose rows to columns" => "Rivien transponointi sarakkeisiin"
// layout.panel: "Layout" => "Asettelu"
// layout.question: "Layout" => "Asettelu"
// layout.base: "Layout" => "Asettelu"
// panel.name: "Panel name" => "Paneelin nimi"
// panel.title: "Panel title" => "Paneelin otsikko"
// panel.description: "Panel description" => "Paneelin kuvaus"
// panel.visibleIf: "Make the panel visible if" => "Tee paneeli näkyväksi, jos"
// panel.requiredIf: "Make the panel required if" => "Tee paneeli pakolliseksi, jos"
// panel.questionsOrder: "Question order within the panel" => "Kyselyjärjestys paneelissa"
// panel.startWithNewLine: "Display the panel on a new line" => "Näytä paneeli uudella rivillä"
// panel.state: "Panel collapse state" => "Paneelin tiivistystila"
// panel.width: "Inline panel width" => "Tekstiin sidotun paneelin leveys"
// panel.minWidth: "Minimum panel width" => "Paneelin vähimmäisleveys"
// panel.maxWidth: "Maximum panel width" => "Paneelin enimmäisleveys"
// panel.showNumber: "Number panels" => "Numeropaneelit"
// paneldynamic.name: "Panel name" => "Paneelin nimi"
// paneldynamic.title: "Panel title" => "Paneelin otsikko"
// paneldynamic.description: "Panel description" => "Paneelin kuvaus"
// paneldynamic.visibleIf: "Make the panel visible if" => "Tee paneeli näkyväksi, jos"
// paneldynamic.requiredIf: "Make the panel required if" => "Tee paneeli pakolliseksi, jos"
// paneldynamic.page: "Move the panel to page" => "Paneelin siirtäminen sivulle"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Näytä paneeli uudella rivillä"
// paneldynamic.state: "Panel collapse state" => "Paneelin tiivistystila"
// paneldynamic.width: "Inline panel width" => "Tekstiin sidotun paneelin leveys"
// paneldynamic.minWidth: "Minimum panel width" => "Paneelin vähimmäisleveys"
// paneldynamic.maxWidth: "Maximum panel width" => "Paneelin enimmäisleveys"
// paneldynamic.templateDescription: "Panel description pattern" => "Paneelin kuvauskuvio"
// paneldynamic.templateTitle: "Panel title pattern" => "Paneelin otsikkomalli"
// paneldynamic.noEntriesText: "Empty panel text" => "Tyhjä paneelin teksti"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Välilehden otsikkomalli"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Tee yksittäinen paneeli näkyväksi, jos"
// paneldynamic.hideNumber: "Hide the panel number" => "Piilota paneelin numero"
// paneldynamic.titleLocation: "Panel title alignment" => "Paneelin otsikon tasaus"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Paneelin kuvauksen tasaus"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Kysymyksen otsikon tasaus"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Virhesanoman tasaus"
// paneldynamic.newPanelPosition: "New panel location" => "Uusi paneelin sijainti"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Päällekkäisten vastausten estäminen seuraavassa kysymyksessä"
// question.name: "Question name" => "Kysymyksen nimi"
// question.title: "Question title" => "Kysymyksen otsikko"
// question.description: "Question description" => "Kysymyksen kuvaus"
// question.visibleIf: "Make the question visible if" => "Tee kysymys näkyväksi, jos"
// question.requiredIf: "Make the question required if" => "Tee kysymys pakolliseksi, jos"
// question.state: "Question box collapse state" => "Kysymysruudun tiivistystila"
// question.hideNumber: "Hide the question number" => "Piilota kysymyksen numero"
// question.titleLocation: "Question title alignment" => "Kysymyksen otsikon tasaus"
// question.descriptionLocation: "Question description alignment" => "Kysymyksen kuvauksen tasaus"
// question.errorLocation: "Error message alignment" => "Virhesanoman tasaus"
// question.indent: "Increase the inner indent" => "Suurentaa sisintä sisennystä"
// question.width: "Inline question width" => "Tekstiin sitoutuvan kysymyksen leveys"
// question.minWidth: "Minimum question width" => "Kysymyksen vähimmäisleveys"
// question.maxWidth: "Maximum question width" => "Kysymyksen enimmäisleveys"
// question.textUpdateMode: "Update input field value" => "Päivitä syöttökentän arvo"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Näytä Tyhjennä-painike allekirjoitusalueella"
// signaturepad.penColor: "Stroke color" => "Iskun väri"
// comment.rows: "Input field height (in lines)" => "Syöttökentän korkeus (viivoina)"
// expression.name: "Expression name" => "Lausekkeen nimi"
// expression.title: "Expression title" => "Lausekkeen otsikko"
// expression.description: "Expression description" => "Lausekkeen kuvaus"
// expression.expression: "Expression" => "Lauseke"
// trigger.expression: "Expression" => "Lauseke"
// calculatedvalue.expression: "Expression" => "Lauseke"
// survey.description: "Survey description" => "Tutkimuksen kuvaus"
// page.name: "Page name" => "Sivun nimi"
// page.description: "Page description" => "Sivun kuvaus"
// page.visibleIf: "Make the page visible if" => "Tee sivusta näkyvä, jos"
// page.requiredIf: "Make the page required if" => "Tee sivusta pakollinen, jos"
// page.questionsOrder: "Question order on the page" => "Kyselyjärjestys sivulla"
// matrixdropdowncolumn.name: "Column name" => "Sarakkeen nimi"
// matrixdropdowncolumn.title: "Column title" => "Sarakkeen otsikko"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Päällekkäisten vastausten estäminen"
// matrixdropdowncolumn.width: "Column width" => "Sarakeleveys"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Sarakkeen vähimmäisleveys"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Syöttökentän korkeus (viivoina)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Tee sarakkeesta näkyvä, jos"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Tee sarakkeesta pakollinen, jos"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Jokainen vaihtoehto erillisessä sarakkeessa"
// multipletextitem.name: "Name" => "Nimi"
// multipletextitem.title: "Title" => "Nimike"
// pe.rateDescriptionLocation: "Label alignment" => "Otsikon tasaus"
// pe.cellErrorLocation: "Cell error message alignment" => "Solun virhesanoman tasaus"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Sinulla ei ole vielä sarakkeita"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Sinulla ei ole vielä rivejä"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Sinulla ei ole vielä vahvistussääntöjä"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Sinulla ei ole vielä mukautettuja muuttujia"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Sinulla ei ole vielä käynnistimiä"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Sinulla ei ole vielä linkkejä"
// pe.addNew@columns: "Add new column" => "Lisää uusi sarake"
// pe.addNew@rows: "Add new row" => "Lisää uusi rivi"
// pe.addNew@validators: "Add new rule" => "Lisää uusi sääntö"
// pe.addNew@calculatedValues: "Add new variable" => "Lisää uusi muuttuja"
// pe.addNew@triggers: "Add new trigger" => "Lisää uusi käynnistin"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Lisää uusi URL-osoite"
// choicesbyurl.url: "Web service's URL" => "Verkkopalvelun URL-osoite"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Sivujen otsikoiden näyttäminen edistymispalkissa"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Sivunumeroiden näyttäminen edistymispalkissa"
// itemvalue.visibleIf: "Make the option visible if" => "Tee vaihtoehto näkyväksi, jos"
// itemvalue.enableIf: "Make the option selectable if" => "Tee vaihtoehdosta valittava, jos"
// panel.layout: "Panel Layout" => "Paneelin asettelu"
// tabs.questionSettings: "Question Settings" => "Kysymyksen asetukset"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Esimerkki: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Esimerkki: categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Esim.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Esimerkki: 6 tuumaa"
// pe.minWidth_placeholder: "Ex.: 600px" => "Esimerkki: 600 pikseliä"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Esimerkki: 50 %"
// pv.selected: "Selected" => "Valittu"
// pv.unselected: "Unselected" => "Valitsematta"
// pv.center: "Center" => "Keskus"
// pv.middle: "Middle" => "Keskus"
// pv.next: "Next" => "Seuraava"
// pv.last: "Last" => "Viime"
// clearIfInvisible.none: "Never" => "Koskaan"
// questionsOnPageMode.standard: "Original structure" => "Alkuperäinen rakenne"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Näytä kaikki kysymykset yhdellä sivulla"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Näytä yksittäinen kysymys sivua kohden"
// pv.auto: "Auto" => "Auto"
// panelsState.firstExpanded: "First expanded" => "Ensimmäinen laajennettu"
// rateColorMode.scale: "Scale" => "Mittakaava"
// scaleColorMode.monochrome: "Monochrome" => "Yksivärinen"
// scaleColorMode.colored: "Colored" => "Värillinen"
// state.default: "Locked" => "Lukittu"
// showQuestionNumbers.default: "Auto-numbering" => "Automaattinen numerointi"
// showQuestionNumbers.on: "Auto-numbering" => "Automaattinen numerointi"
// showQuestionNumbers.onPage: "Reset on each page" => "Nollaa jokaisella sivulla"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Nollaa jokaisessa paneelissa"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Nollaa jokaisessa paneelissa"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Jatka kyselyssä"
// showQuestionNumbers.off: "No numbering" => "Ei numerointia"
// descriptionLocation.underTitle: "Under the question title" => "Kysymyksen otsikon alla"
// descriptionLocation.underInput: "Under the input field" => "Syöttökentän alla"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Valintojen vieressä"
// selectToRankAreasLayout.vertical: "Above choices" => "Yllä olevat valinnat"
// displayStyle.decimal: "Decimal" => "Desimaali"
// displayStyle.currency: "Currency" => "Valuutta"
// displayStyle.percent: "Percentage" => "Prosenttiosuus"
// displayStyle.date: "Date" => "Päivämäärä"
// totalDisplayStyle.decimal: "Decimal" => "Desimaali"
// totalDisplayStyle.currency: "Currency" => "Valuutta"
// totalDisplayStyle.percent: "Percentage" => "Prosenttiosuus"
// totalDisplayStyle.date: "Date" => "Päivämäärä"
// rowsOrder.initial: "Original" => "Alkuperäinen"
// questionsOrder.initial: "Original" => "Alkuperäinen"
// showProgressBar.aboveheader: "Above the header" => "Otsikon yläpuolella"
// showProgressBar.belowheader: "Below the header" => "Otsikon alapuolella"
// pv.sum: "Sum" => "Summa"
// pv.count: "Count" => "Kreivi"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Max"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Sisältää"
// searchMode.startsWith: "Starts with" => "Alkaa"
// panel.name: "A panel ID that is not visible to respondents." => "Paneelin tunnus, joka ei näy vastaajille."
// panel.description: "Type a panel subtitle." => "Kirjoita paneelin tekstitys."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Käytä taikasauvakuvaketta asettaaksesi ehdollisen säännön, joka määrittää paneelin näkyvyyden."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka poistaa paneelin vain luku -tilan käytöstä."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka estää kyselyn lähettämisen, ellei vähintään yhteen sisäkkäiseen kysymykseen ole vastausta."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Koskee kaikkia tämän paneelin kysymyksiä. Jos haluat ohittaa tämän asetuksen, määritä otsikon tasaussäännöt yksittäisille kysymyksille. Peri-vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta (\"Ylin\" oletuksena)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Määrittää virhesanoman sijainnin suhteessa kaikkiin paneelin kysymyksiin. Peri-vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Säilyttää kysymysten alkuperäisen järjestyksen tai satunnaistaa ne. Peri-vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta."
// panel.page: "Repositions the panel to the end of a selected page." => "Siirtää paneelin valitun sivun loppuun."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Lisää tilaa tai reunuksen paneelin sisällön ja paneeliruudun vasemman reunan väliin."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Poista valinta, jos haluat näyttää paneelin yhdellä rivillä edellisen kysymyksen tai paneelin kanssa. Asetusta ei käytetä, jos paneeli on lomakkeen ensimmäinen elementti."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Valitse seuraavista: \"Laajennettu\" - paneeli näytetään kokonaisuudessaan ja se voidaan kutistaa; \"Tiivistetty\" - paneeli näyttää vain otsikon ja kuvauksen ja sitä voidaan laajentaa; \"Lukittu\" - paneeli näkyy kokonaisuudessaan eikä sitä voi kutistaa."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Asettaa paneelin leveyden suhteessa muihin saman rivin mittauselementteihin. Hyväksyy CSS-arvot (px, %, in, pt jne.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "Paneelin tunnus, joka ei näy vastaajille."
// paneldynamic.description: "Type a panel subtitle." => "Kirjoita paneelin tekstitys."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Käytä taikasauvakuvaketta asettaaksesi ehdollisen säännön, joka määrittää paneelin näkyvyyden."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka poistaa paneelin vain luku -tilan käytöstä."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka estää kyselyn lähettämisen, ellei vähintään yhteen sisäkkäiseen kysymykseen ole vastausta."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Koskee kaikkia tämän paneelin kysymyksiä. Jos haluat ohittaa tämän asetuksen, määritä otsikon tasaussäännöt yksittäisille kysymyksille. Peri-vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta (\"Ylin\" oletuksena)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Määrittää virhesanoman sijainnin suhteessa kysymykseen, jonka syöte on virheellinen. Valitse seuraavista: \"Top\" - virheteksti sijoitetaan kysymysruudun yläosaan; \"Pohja\" - virheteksti sijoitetaan kysymysruudun alaosaan. Peri-vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta (\"Ylin\" oletuksena)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Määrittää virhesanoman sijainnin suhteessa kaikkiin paneelin kysymyksiin. Peri-vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Siirtää paneelin valitun sivun loppuun."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Lisää tilaa tai reunuksen paneelin sisällön ja paneeliruudun vasemman reunan väliin."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Poista valinta, jos haluat näyttää paneelin yhdellä rivillä edellisen kysymyksen tai paneelin kanssa. Asetusta ei käytetä, jos paneeli on lomakkeen ensimmäinen elementti."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Valitse seuraavista: \"Laajennettu\" - paneeli näytetään kokonaisuudessaan ja se voidaan kutistaa; \"Tiivistetty\" - paneeli näyttää vain otsikon ja kuvauksen ja sitä voidaan laajentaa; \"Lukittu\" - paneeli näkyy kokonaisuudessaan eikä sitä voi kutistaa."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Asettaa paneelin leveyden suhteessa muihin saman rivin mittauselementteihin. Hyväksyy CSS-arvot (px, %, in, pt jne.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Kirjoita malli dynaamisten paneelien otsikoille. Käytä {panelIndex} paneelin yleistä sijaintia ja {visiblePanelIndex} sen järjestystä näkyvien paneelien joukossa. Lisää nämä paikkamerkit kuvioon lisätäksesi automaattisen numeroinnin."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Kirjoita välilehtien otsikoiden malli. Käytä {panelIndex} paneelin yleistä sijaintia ja {visiblePanelIndex} sen järjestystä näkyvien paneelien joukossa. Lisää nämä paikkamerkit kuvioon lisätäksesi automaattisen numeroinnin."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Tämän asetuksen avulla voit hallita yksittäisten paneelien näkyvyyttä dynaamisessa paneelissa. {panel}-paikkamerkin avulla voit viitata lausekkeen nykyiseen paneeliin."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Tämä asetus periytyy automaattisesti kaikkiin tämän paneelin kysymyksiin. Jos haluat ohittaa tämän asetuksen, määritä otsikon tasaussäännöt yksittäisille kysymyksille. Peri-vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta (\"Ylin\" oletuksena)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "\"Peri\" -vaihtoehto käyttää sivutason (jos määritetty) tai kyselytason asetusta (\"Paneelin otsikon alla\" oletuksena)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Määrittää juuri lisätyn paneelin sijainnin. Oletuksena uudet paneelit lisätään loppuun. Valitse \"Seuraava\" lisätäksesi uuden paneelin nykyisen jälkeen."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Monistaa edellisen paneelin vastaukset ja määrittää ne seuraavaan lisättyyn dynaamiseen paneeliin."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Viittaa kysymyksen nimeen, jos haluat edellyttää, että käyttäjä antaa yksilöllisen vastauksen tähän kysymykseen kussakin paneelissa."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Tämän asetuksen avulla voit määrittää oletusarvoisen vastausarvon lausekkeen perusteella. Lauseke voi sisältää peruslaskutoimituksia - '{q1_id} + {q2_id}', totuusarvolausekkeita, kuten '{age} > 60', ja funktioita: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' jne. Tämän lausekkeen määrittämä arvo toimii alkuperäisenä oletusarvona, jonka vastaajan manuaalinen syöttö voi ohittaa."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Käytä taikasauvakuvaketta asettaaksesi ehdollisen säännön, joka määrittää, milloin vastaajan syöte palautetaan arvoon \"Oletusarvolauseke\" tai \"Aseta arvolauseke\" tai \"Oletusvastaus\" -arvoon (jos jompikumpi on asetettu)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Käytä taikasauvakuvaketta asettaaksesi ehdollisen säännön, joka määrittää, milloin \"Aseta arvolauseke\" suoritetaan, ja määritä tuloksena oleva arvo dynaamisesti vastauksena."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Määritä lauseke, joka määrittää arvon, joka määritetään, kun Aseta arvo jos -säännön ehdot täyttyvät. Lauseke voi sisältää peruslaskutoimituksia - '{q1_id} + {q2_id}', totuusarvolausekkeita, kuten '{age} > 60', ja funktioita: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' jne. Tämän lausekkeen määrittämä arvo voidaan ohittaa vastaajan manuaalisella syötöllä."
// question.name: "A question ID that is not visible to respondents." => "Kysymystunnus, joka ei näy vastaajille."
// question.description: "Type a question subtitle." => "Kirjoita kysymyksen alaotsikko."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Käytä taikasauvakuvaketta asettaaksesi ehdollisen säännön, joka määrittää kysymyksen näkyvyyden."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka poistaa kysymyksen vain luku -tilan käytöstä."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka estää kyselyn etenemisen tai lähettämisen, ellei kysymykseen ole vastattu."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Poista valinta, jos haluat näyttää kysymyksen yhdellä rivillä edellisen kysymyksen tai paneelin kanssa. Asetusta ei käytetä, jos kysymys on lomakkeen ensimmäinen elementti."
// question.page: "Repositions the question to the end of a selected page." => "Sijoittaa kysymyksen uudelleen valitun sivun loppuun."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Valitse seuraavista: \"Laajennettu\" - kysymysruutu näytetään kokonaisuudessaan ja se voidaan kutistaa; \"Tiivistetty\" - kysymysruutu näyttää vain otsikon ja kuvauksen ja sitä voidaan laajentaa; \"Lukittu\" - kysymysruutu näkyy kokonaisuudessaan eikä sitä voi kutistaa."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Ohittaa paneeli-, sivu- tai kyselytasolla määritetyt otsikon tasaussäännöt. \"Peri\"-vaihtoehto käyttää kaikkia ylemmän tason asetuksia (jos määritetty) tai kyselytason asetuksia (\"Ylin\" oletuksena)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "\"Peri\"-vaihtoehto käyttää kyselytason asetusta (\"Kysymyksen otsikon alla\" oletuksena)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Määrittää virhesanoman sijainnin suhteessa kysymykseen, jonka syöte on virheellinen. Valitse seuraavista: \"Top\" - virheteksti sijoitetaan kysymysruudun yläosaan; \"Pohja\" - virheteksti sijoitetaan kysymysruudun alaosaan. \"Peri\"-vaihtoehto käyttää kyselytason asetusta (\"Ylin\" oletuksena)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Lisää välilyönnin tai reunuksen kysymyksen sisällön ja kysymysruudun vasemman reunan väliin."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Määrittää kysymyksen leveyden suhteessa saman rivin muihin kyselyelementteihin. Hyväksyy CSS-arvot (px, %, in, pt jne.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Käytä taikasauvakuvaketta asettaaksesi kysymyksen vahvistussäännön."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Valitse seuraavista: \"Kadonneessa tarkennuksessa\" - arvo päivitetään, kun syöttökenttä menettää tarkennuksen; \"Kirjoitettaessa\" - arvo päivitetään reaaliajassa, kun käyttäjät kirjoittavat. \"Peri\"-vaihtoehto käyttää kyselytason asetusta (\"Oletusarvoisesti menetetty kohdistus\")."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Voit käyttää mitä tahansa verkkopalvelua tietolähteenä monivalintakysymyksissä. Voit täyttää valinta-arvot antamalla tiedot tarjoavan palvelun URL-osoitteen."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Vertailutoiminto, jota käytetään avattavan luettelon suodattamiseen."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Määrittää näytettävän allekirjoitusalueen ja tuloksena olevan kuvan leveyden."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Määrittää näytettävän allekirjoitusalueen ja tuloksena olevan kuvan korkeuden."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Valitse tämä, jos haluat, että allekirjoitusalue täyttää kaiken kysymysruudussa käytettävissä olevan tilan säilyttäen oletusarvoisen 3:2-kuvasuhteen. Kun mukautetut leveys- ja korkeusarvot on määritetty, asetus säilyttää näiden mittojen kuvasuhteen."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Säätää kuvan korkeutta kyselyn tuloksissa."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Säätää kuvan leveyttä kyselyn tuloksissa."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Ohittaa vähimmäis- ja enimmäiskorkeusarvot."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Ohittaa vähimmäis- ja enimmäisleveysarvot."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Arvo\" toimii ehdollisissa säännöissä käytettynä tuotetunnuksena; \"Teksti\" näkyy vastaajille."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Tämä asetus muuttaa vain syöttökentän kokoa eikä vaikuta kysymysruudun leveyteen. Jos haluat rajoittaa hyväksyttyä syötteen pituutta, siirry kohtaan <b>Vahvistus → merkkien enimmäismäärä</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Määrittää syöttökentässä näytettävien rivien määrän. Jos tulo vie enemmän rivejä, vierityspalkki tulee näkyviin."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Valitse jompikumpi seuraavista: \"Muokattavissa\" - vastaajat voivat täyttää kyselysi; \"Vain luku\" - poistaa lomakkeen muokkauksen käytöstä."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "Sarakkeen tunnus, joka ei näy vastaajille."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Kun sarake on otettu käyttöön, vastaajan on annettava yksilöllinen vastaus jokaiseen tämän sarakkeen kysymykseen."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Määrittää syöttökentässä näytettävien rivien määrän. Jos tulo vie enemmän rivejä, vierityspalkki tulee näkyviin."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka määrittää sarakkeen näkyvyyden."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka poistaa sarakkeen vain luku -tilan käytöstä."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka estää kyselyn lähettämisen, ellei vähintään yhteen sisäkkäiseen kysymykseen ole vastausta."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Kun tämä asetus on valittuna, kullekin vaihtoehdolle luodaan oma sarake."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Valitse seuraavista: \"Staattinen\" - asettaa kiinteän leveyden; \"Reagoiva\" - tekee kyselystä koko näytön leveyden; \"Auto\" - soveltaa jompaakumpaa näistä kahdesta riippuen käytetyistä kysymystyypeistä."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Liitä kuvalinkki (ei kokorajoituksia) tai napsauta kansiokuvaketta selataksesi tiedostoa tietokoneeltasi (enintään 64 kt)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Määrittää logon leveyden CSS-yksiköissä (px, %, in, pt jne.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Asettaa logon korkeuden CSS-yksiköinä (px, %, in, pt jne.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Valitse seuraavista: \"Ei mitään\" - kuva säilyttää alkuperäisen kokonsa; \"Sisältää\" - kuvan kokoa muutetaan sopivaksi säilyttäen samalla kuvasuhteensa; \"Kansi\" - kuva täyttää koko laatikon säilyttäen samalla kuvasuhteensa; \"Täytä\" - kuva venytetään täyttämään laatikko säilyttämättä sen kuvasuhdetta."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Valitse, haluatko kyselyn siirtyvän seuraavalle sivulle automaattisesti, kun vastaaja on vastannut kaikkiin nykyisen sivun kysymyksiin."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Määrittää sivun navigointipainikkeiden näkyvyyden ja sijainnin."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Määrittää edistymispalkin näkyvyyden ja sijainnin. \"Auto\"-arvo näyttää edistymispalkin kyselyn otsikon ylä- tai alapuolella."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Ota esikatselusivu käyttöön vain kaikilla kysymyksillä tai vastatuilla kysymyksillä."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Koskee kaikkia kyselyn kysymyksiä. Tämä asetus voidaan ohittaa otsikon tasaussäännöillä alemmilla tasoilla: paneeli, sivu tai kysymys. Alemman tason asetus ohittaa korkeammalla tasolla olevat."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Symboli tai symbolisarja, joka osoittaa, että vastaus vaaditaan."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Kirjoita numero tai kirjain, jolla haluat aloittaa numeroinnin."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Määrittää virhesanoman sijainnin suhteessa kysymykseen, jonka syöte on virheellinen. Valitse seuraavista: \"Top\" - virheteksti sijoitetaan kysymysruudun yläosaan; \"Pohja\" - virheteksti sijoitetaan kysymysruudun alaosaan."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Valitse tämä, jos haluat, että kunkin sivun ensimmäinen syöttökenttä on valmis tekstinsyöttöä varten."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Säilyttää kysymysten alkuperäisen järjestyksen tai satunnaistaa ne. Tämän asetuksen vaikutus näkyy vain Esikatselu-välilehdessä."
// pehelp.maxTextLength: "For text entry questions only." => "Vain tekstinsyöttökysymykset."
// pehelp.maxOthersLength: "For question comments only." => "Vain kysymysten kommentit."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Valitse tämä, jos haluat, että kysymysten kommentit ja pitkät tekstit -kysymykset kasvavat automaattisesti syötetyn tekstin pituuden perusteella."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Vain kysymyskommentit ja pitkän tekstin kysymykset."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Mukautetut muuttujat toimivat väli- tai apumuuttujina, joita käytetään lomakelaskelmissa. He ottavat vastaajan syötteet lähdearvoina. Jokaisella mukautetulla muuttujalla on yksilöllinen nimi ja lauseke, johon se perustuu."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Valitse tämä, jos haluat, että lausekkeen laskettu arvo tallennetaan yhdessä kyselyn tulosten kanssa."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Käynnistin on tapahtuma tai ehto, joka perustuu lausekkeeseen. Kun lausekkeen arvoksi on arvioitu \"tosi\", käynnistin käynnistää toiminnon. Tällaisella toiminnalla voi valinnaisesti olla kohdekysymys, johon se vaikuttaa."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Valitse, tyhjennetäänkö ehdollisen logiikan piilottamien kysymysten arvot ja milloin se tehdään."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Valitse seuraavista: \"Kadonneessa tarkennuksessa\" - arvo päivitetään, kun syöttökenttä menettää tarkennuksen; \"Kirjoitettaessa\" - arvo päivitetään reaaliajassa, kun käyttäjät kirjoittavat."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Vasen arvo toimii ehdollisissa säännöissä käytettynä saraketunnuksena, oikea arvo näkyy vastaajille."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Vasen arvo toimii rivitunnuksena, jota käytetään ehdollisissa säännöissä, oikea arvo näytetään vastaajille."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Hyväksyy CSS-arvot (px, %, in, pt jne.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Hyväksyy CSS-arvot (px, %, in, pt jne.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Määrittää virhesanoman sijainnin suhteessa soluun, jonka syöte on virheellinen. \"Peri\" -vaihtoehto käyttää asetusta \"Virheilmoituksen kohdistus\" -ominaisuudesta."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Kun Estä päällekkäiset vastaukset -ominaisuus on käytössä, vastaaja, joka yrittää lähettää merkinnän kaksoiskappaleen, saa seuraavan virhesanoman."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Voit laskea kokonaisarvot lausekkeen perusteella. Lauseke voi sisältää peruslaskutoimituksia ('{q1_id} + {q2_id}'), totuusarvolausekkeita ('{age} > 60') ja funktioita ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' jne.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Käynnistää kehotteen, jossa pyydetään vahvistamaan rivin poisto."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Monistaa vastaukset viimeiseltä riviltä ja määrittää ne seuraavalle lisätylle dynaamiselle riville."
// pehelp.description: "Type a subtitle." => "Kirjoita tekstitys."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Aloita kyselyn luominen valitsemalla kieli. Jos haluat lisätä käännöksen, vaihda uuteen kieleen ja käännä alkuperäinen teksti täällä tai Käännökset-välilehdessä."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Määrittää tieto-osan sijainnin suhteessa riviin. Valitse seuraavista: \"Ei mitään\" - laajennusta ei lisätä; \"Rivin alla\" - matriisin jokaisen rivin alle sijoitetaan rivilaajennus; \"Näytä rivin alla vain yhden rivin laajennus\" - laajennus näkyy vain yhden rivin alla, loput rivilaajennukset kutistetaan."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Valitse seuraavista: \"Ei mitään\" - kuva säilyttää alkuperäisen kokonsa; \"Sisältää\" - kuvan kokoa muutetaan sopivaksi säilyttäen samalla kuvasuhteensa; \"Kansi\" - kuva täyttää koko laatikon säilyttäen samalla kuvasuhteensa; \"Täytä\" - kuva venytetään täyttämään laatikko säilyttämättä sen kuvasuhdetta."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Lisää vähitellen syöttökentän korkeutta, kun tietoja syötetään. Ohittaa \"Syöttökentän korkeus (viivoina)\" -asetuksen."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Koonmuuttokahva (tai kahva) tulee näkyviin kulmaan, ja sitä vetämällä voit muuttaa syöttökentän kokoa."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Sekunteina oleva aikaväli, jonka jälkeen kysely etenee automaattisesti Kiitos-sivulle."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Sekunteina ilmaistu aikaväli, jonka jälkeen kysely siirtyy automaattisesti seuraavalle sivulle."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Sekunteina ilmaistu aikaväli, jonka jälkeen kysely siirtyy automaattisesti seuraavalle sivulle."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Käytä taikasauvakuvaketta asettaaksesi ehdollisen säännön, joka määrittää sivun näkyvyyden."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka poistaa sivun vain luku -tilan käytöstä."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Määritä taikasauvakuvakkeen avulla ehdollinen sääntö, joka estää kyselyn lähettämisen, ellei vähintään yhteen sisäkkäiseen kysymykseen ole vastausta."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Koskee kaikkia tämän sivun kysymyksiä. Jos haluat ohittaa tämän asetuksen, määritä otsikon tasaussäännöt yksittäisille kysymyksille tai paneeleille. \"Peri\"-vaihtoehto käyttää kyselytason asetusta (\"Ylin\" oletuksena)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Määrittää virhesanoman sijainnin suhteessa kysymykseen, jonka syöte on virheellinen. Valitse seuraavista: \"Top\" - virheteksti sijoitetaan kysymysruudun yläosaan; \"Pohja\" - virheteksti sijoitetaan kysymysruudun alaosaan. \"Peri\"-vaihtoehto käyttää kyselytason asetusta (\"Ylin\" oletuksena)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Säilyttää kysymysten alkuperäisen järjestyksen tai satunnaistaa ne. \"Peri\" -vaihtoehto käyttää kyselytason asetusta (\"Alkuperäinen\" oletuksena). Tämän asetuksen vaikutus näkyy vain Esikatselu-välilehdessä."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Määrittää navigointipainikkeiden näkyvyyden sivulla. \"Peri\" -vaihtoehto käyttää kyselytason asetusta, jonka oletusarvo on \"Näkyvä\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Määrittää ajastimen näkyvyyden ja sijainnin sivulla."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Valitse seuraavista: \"Lukittu\" - käyttäjät eivät voi laajentaa tai kutistaa paneeleja; \"Kutista kaikki\" - kaikki paneelit alkavat romahtaneessa tilassa; \"Laajenna kaikki\" - kaikki paneelit alkavat laajennetussa tilassa; \"Ensimmäinen laajennettu\" - vain ensimmäistä paneelia laajennetaan aluksi."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Kirjoita jaetun ominaisuuden nimi objektiryhmään, joka sisältää valintaluettelossa näytettävät kuvan tai videotiedoston URL-osoitteet."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Vasen arvo toimii ehdollisissa säännöissä käytettynä kohteen tunnuksena, oikea arvo näytetään vastaajille."
// pehelp.title: "Type a user-friendly title to display." => "Kirjoita käyttäjäystävällinen otsikko näytettäväksi."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Varmistaa, että käyttäjät eivät vastaa kyselyyn, ennen kuin tiedostot on ladattu."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Hyväksyy CSS-arvot (px, %, in, pt jne.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Hyväksyy CSS-arvot (px, %, in, pt jne.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Hyväksyy CSS-arvot (px, %, in, pt jne.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "Yksi- ja monivalintakysymystyypeissä kullakin valintavaihtoehdolla on tunnus ja näyttöarvo. Kun tämä asetus on valittuna, se näyttää tunnusarvon sijaan HTML-kysymyksissä ja kyselyelementtien dynaamisissa otsikoissa ja kuvauksissa."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Valitse, poistetaanko ehdollisen logiikan piilottamat kysymysarvot ja milloin se tehdään. \"Peri\"-vaihtoehto käyttää kyselytason asetusta (\"Kyselyn valmistuttua\" oletuksena)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Valitse seuraavista: \"Kaikki\" - kopioi kaikki valintavaihtoehdot valitusta kysymyksestä; \"Valittu\" - kopioi dynaamisesti vain valitut valintavaihtoehdot; \"Ei valittu\" - kopioi dynaamisesti vain valitsemattomat valintavaihtoehdot. Vaihtoehdot \"Ei mitään\" ja \"Muut\" kopioidaan oletusarvoisesti, jos ne on otettu käyttöön lähdekysymyksessä."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Kun tämä on valittuna, käyttäjät voivat lisätä lisätietoja erilliseen kommenttiruutuun."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Näyttää jokaisen erityisen valintavaihtoehdon (\"Ei mitään\", \"Muu\", \"Valitse kaikki\") uudella rivillä, vaikka käytettäisiin monisarakkeista asettelua."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Määritä palvelutietojoukon sijainti, jossa objektien kohderyhmä sijaitsee. Jätä tyhjäksi, jos URL-osoite osoittaa jo matriisiin."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Kirjoita objektimatriisiin yhtenäinen ominaisuuden nimi, joka sisältää valintaluettelossa näytettävät arvot."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Valitse tämä, jos haluat, että palvelu palauttaa tyhjän vastauksen tai matriisin."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Taikasauvakuvakkeen avulla voit määrittää ehdollisen säännön, joka määrittää kaikkien valintavaihtoehtojen näkyvyyden."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Vasen arvo toimii ehdollisissa säännöissä käytettynä kohteen tunnuksena, oikea arvo näytetään vastaajille."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" valitsee \"Painikkeet\" ja \"Avattava\" -tilojen välillä käytettävissä olevan leveyden perusteella. Kun leveys ei riitä painikkeiden näyttämiseen, kysymyksessä näkyy avattava valikko."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Voit yhdistää kysymyksiä, jotka tuottavat tuloksia eri muodoissa. Kun tällaiset kysymykset linkitetään toisiinsa liitostunnuksen avulla, tähän jaettuun ominaisuuteen tallennetaan valitut kysymysarvot."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Valitse tämä, jos haluat päivittää avattavan valikon sisällön vastaamaan hakukyselyä, jonka käyttäjä kirjoittaa syöttökenttään."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Arvo, joka tallennetaan kyselyn tuloksiin, kun vastaajat antavat myönteisen vastauksen."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Arvo, joka tallennetaan kyselyn tuloksiin, kun vastaajat antavat kielteisen vastauksen."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Tätä asetusta ei suositella poistamaan käytöstä, koska se ohittaa esikatselukuvan ja vaikeuttaa käyttäjän ymmärtämistä, onko tiedostot ladattu."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Käynnistää kehotteen, jossa pyydetään vahvistamaan tiedoston poistaminen."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Ota käyttöön, jos haluat luokitella vain valitut vaihtoehdot. Käyttäjät vetävät valitut kohteet valintaluettelosta järjestääkseen ne sijoitusalueella."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Kirjoita luettelo vaihtoehdoista, joita vastaajalle ehdotetaan syötteen aikana."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Asetus muuttaa vain syöttökenttien kokoa eikä vaikuta kysymysruudun leveyteen."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Määrittää yhdenmukaisen leveyden kaikille tuoteotsikoille kuvapisteinä"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "\"Auto\" -vaihtoehto määrittää automaattisesti sopivan näyttötilan - Kuva, Video tai YouTube - annetun lähde-URL-osoitteen perusteella."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Toimii korvikkeena, kun kuvaa ei voida näyttää käyttäjän laitteella, ja esteettömyyssyistä."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Määrittää valitun emojin värin, kun luokituskuvakkeen tyypiksi on asetettu \"Hymiöt\". Valitse seuraavista: \"Oletus\" - valittu emoji näkyy kyselyn oletusvärillä; \"Scale\" - valittu emoji perii värin luokitusasteikolta."
// expression.name: "An expression ID that is not visible to respondents." => "Lausekkeen tunnus, joka ei näy vastaajille."
// expression.description: "Type an expression subtitle." => "Kirjoita lausekkeen alaotsikko."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Lauseke voi sisältää peruslaskutoimituksia ('{q1_id} + {q2_id}'), ehtoja ('{age} > 60') ja funktioita ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' jne.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Valitse tämä, jos haluat tallentaa Muu-vaihtoehdon arvon erillisenä ominaisuutena kyselyn tuloksiin."
// p.swapOrder: "Swap the order of Yes and No" => "Kyllä- ja Ei-järjestyksen vaihtaminen"
// p.itemTitleWidth: "Item label width (in px)" => "Nimikkeen otsikon leveys (px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Teksti, joka näyttää, onko kaikki asetukset valittu"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Sijoitusalueen paikkamerkkiteksti"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Vastaa kyselyyn automaattisesti"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Valitse, haluatko kyselyn täyttyvän automaattisesti, kun vastaaja on vastannut kaikkiin kysymyksiin."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Peitetyn arvon tallentaminen kyselyn tuloksiin"
// patternmask.pattern: "Value pattern" => "Arvon kuvio"
// datetimemask.min: "Minimum value" => "Pienin arvo"
// datetimemask.max: "Maximum value" => "Suurin arvo"
// numericmask.allowNegativeValues: "Allow negative values" => "Salli negatiiviset arvot"
// numericmask.thousandsSeparator: "Thousands separator" => "Tuhansien erotin"
// numericmask.decimalSeparator: "Decimal separator" => "Desimaalierotin"
// numericmask.precision: "Value precision" => "Arvon tarkkuus"
// numericmask.min: "Minimum value" => "Pienin arvo"
// numericmask.max: "Maximum value" => "Suurin arvo"
// currencymask.prefix: "Currency prefix" => "Valuutan etuliite"
// currencymask.suffix: "Currency suffix" => "Valuutan jälkiliite"
// pe.maskType: "Input mask type" => "Syöttörajoitteen tyyppi"
// maskTypes.patternmask: "Pattern" => "Kuvio"
// maskTypes.numericmask: "Numeric" => "Numeerinen"
// maskTypes.datetimemask: "Date and Time" => "Päivämäärä ja kellonaika"
// maskTypes.currencymask: "Currency" => "Valuutta"
// tabs.mask: "Input Mask Settings" => "Syöttörajoitteen asetukset"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Esimerkki: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Esimerkki: kk/pp/v"
// pe.currencyprefix_placeholder: "Ex.: $" => "Esimerkki: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Esimerkki: USD"
// pv.textWrapEnabled: "Wrap choices" => "Kääri valinnat"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Valintavaihtoehtojen pitkät tekstit luovat automaattisesti rivinvaihdot, jotka mahtuvat avattavaan valikkoon. Poista valinta, jos haluat leikata tekstit."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Valitse, haluatko tallentaa kyselyn tuloksiin kysymyksen arvon käyttämällä maskia."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Kuvio voi sisältää merkkijonoliteraaleja ja seuraavia paikkamerkkejä: '9' - numerolle; \"a\" - isoille tai pienille kirjaimille; '#' - numerolle tai isolle tai pienelle kirjaimelle. Käytä kenoviivaa '\\' paetaksesi hahmoa."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Kuvio voi sisältää erotinmerkkejä ja seuraavia paikkamerkkejä: 'm' - kuukauden numero; 'mm' - kuukauden numero, jonka alussa on nolla yksinumeroisille arvoille; \"d\" - kuukauden päivä; 'dd' - kuukauden päivä, jonka alussa on nolla yksinumeroisille arvoille; \"yy\" - vuoden kaksi viimeistä numeroa; \"VVVV\" - nelinumeroinen vuosi."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Symboli, jota käytetään erottamaan murto-osa näytetyn luvun kokonaislukuosasta."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Symboli, jota käytetään erottamaan suuren luvun numerot kolmen ryhmiin."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Rajoittaa näytettävän luvun desimaalipilkun jälkeen säilytettävien numeroiden määrää."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Yksi tai useampi symboli, joka näytetään ennen arvoa."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Yksi tai useampi symboli, joka näytetään arvon jälkeen."
// ed.translationSource: "Source: " => "Lähde: "
// ed.translationTarget: "Target: " => "Kohde: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Sivu on tyhjä. Vedä elementti työkalupakista tai napsauta alla olevaa painiketta."
// maskTypes.none: "None" => "Ei lainkaan"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Tee rivistä näkyvä, jos"
// itemvalue@rows.enableIf: "Make the row editable if" => "Tee rivistä muokattava, jos"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Paikkamerkkiteksti vain luku -tilassa tai esikatselutilassa"
// pe.textWrapEnabled: "Wrap choices" => "Kääri valinnat"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "\"Auto\" -vaihtoehto määrittää automaattisesti sopivan näyttötilan - Kuva, Video tai YouTube - annetun lähde-URL-osoitteen perusteella."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Valitse \"Kuva\" tai \"Video\" asettaaksesi mediavalitsimen sisältötilan. Jos \"Kuva\" on valittuna, varmista, että kaikki annetut vaihtoehdot ovat kuvatiedostoja seuraavissa muodoissa: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Samoin, jos \"Video\" on valittuna, varmista, että kaikki vaihtoehdot ovat suoria linkkejä videotiedostoihin seuraavissa muodoissa: MP4, MOV, WMV, FLV, AVI, MKV. Huomaa, että YouTube-linkkejä ei tueta videoasetuksissa."
// ed.selectFile: "Select a file" => "Valitse tiedosto"
// ed.removeFile: "Remove the file" => "Poista tiedosto"
// pe.searchMode: "Search Mode" => "Hakutila"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Napsauta alla olevaa Lisää kysymys -painiketta aloittaaksesi lomakkeen luomisen."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Napsauta alla olevaa Lisää kysymys -painiketta lisätäksesi sivulle uuden elementin."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Napsauta alla olevaa Lisää kysymys -painiketta lisätäksesi uuden elementin paneeliin."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Klikkaa alla olevaa painiketta ja valitse ladattava kuva"
// coloralpha.opacity: "Opacity" => "Läpikuultamattomuus"
// font.family: "Font family" => "Fonttiperhe"
// font.color: "Color" => "Väri"
// font.placeholderColor: "Placeholder color" => "Paikkamerkin väri"
// font.size: "Size" => "Koko"
// theme.themeName: "Theme" => "Teema"
// theme.isPanelless: "Question appearance" => "Kysymyksen ulkonäkö"
// theme.editorPanel: "Background and corner radius" => "Taustan ja kulman säde"
// theme.questionPanel: "Background and corner radius" => "Taustan ja kulman säde"
// theme.primaryColor: "Accent color" => "Korostusväri"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Paneelin taustan peittävyys"
// theme.questionBackgroundTransparency: "Question background opacity" => "Taustan peittävyyden kyseenalaistaminen"
// theme.fontSize: "Font size" => "Kirjasinkoko"
// theme.scale: "Scale" => "Mittakaava"
// theme.cornerRadius: "Corner radius" => "Kulman säde"
// theme.pageTitle: "Title font" => "Otsikon fontti"
// theme.pageDescription: "Description font" => "Kuvauksen fontti"
// theme.questionTitle: "Title font" => "Otsikon fontti"
// theme.questionDescription: "Description font" => "Kuvauksen fontti"
// theme.editorFont: "Font" => "Fontti"
// theme.backgroundOpacity: "Opacity" => "Läpikuultamattomuus"
// theme.--sjs-font-family: "Font family" => "Fonttiperhe"
// theme.--sjs-general-backcolor-dim: "Background color" => "Taustaväri"
// theme.--sjs-primary-backcolor: "Accent background" => "Aksentti tausta"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Aksentti etualalla"
// theme.--sjs-shadow-small: "Shadow effects" => "Varjo-tehosteet"
// theme.--sjs-shadow-inner: "Shadow effects" => "Varjo-tehosteet"
// theme.--sjs-border-default: "Colors" => "Värit"
// header@header.headerView: "View" => "Näkymä"
// header@header.logoPosition: "Logo position" => "Logon sijainti"
// header@header.surveyTitle: "Survey title font" => "Kyselyn otsikon fontti"
// header@header.surveyDescription: "Survey description font" => "Kyselyn kuvauksen fontti"
// header@header.headerTitle: "Survey title font" => "Kyselyn otsikon fontti"
// header@header.headerDescription: "Survey description font" => "Kyselyn kuvauksen fontti"
// header@header.inheritWidthFrom: "Content area width" => "Sisältöalueen leveys"
// header@header.textAreaWidth: "Text width" => "Tekstin leveys"
// header@header.backgroundColorSwitch: "Background color" => "Taustaväri"
// header@header.backgroundImage: "Background image" => "Taustakuvan"
// header@header.backgroundImageOpacity: "Opacity" => "Läpikuultamattomuus"
// header@header.overlapEnabled: "Overlap" => "Limittyä"
// header@header.logoPositionX: "Logo position" => "Logon sijainti"
// header@header.titlePositionX: "Title position" => "Otsikon sijainti"
// header@header.descriptionPositionX: "Description position" => "Kuvauksen sijainti"
// weight.400: "Regular" => "Säännöllinen"
// weight.600: "Heavy" => "Raskas"
// weight.700: "Semi-bold" => "Puoliksi lihavoitu"
// weight.800: "Bold" => "Rohkea"
// backgroundImageFit.auto: "Auto" => "Auto"
// backgroundImageFit.cover: "Cover" => "Kansi"
// backgroundImageFit.contain: "Contain" => "Sisältää"
// backgroundImageFit.fill: "Stretch" => "Venyä"
// backgroundImageFit.tile: "Tile" => "Laatta"
// backgroundImageAttachment.fixed: "Fixed" => "Kiinteä"
// backgroundImageAttachment.scroll: "Scroll" => "Vierittää"
// headerView.basic: "Basic" => "Emäksinen"
// headerView.advanced: "Advanced" => "Edistynyt"
// inheritWidthFrom.survey: "Same as survey" => "Sama kuin kyselyssä"
// inheritWidthFrom.container: "Fit to container" => "Sovita konttiin"
// backgroundColorSwitch.none: "None" => "Ei lainkaan"
// backgroundColorSwitch.accentColor: "Accent color" => "Korostusväri"
// backgroundColorSwitch.custom: "Custom" => "Tapa"
// colorPalette.light: "Light" => "Valo"
// colorPalette.dark: "Dark" => "Tumma"
// isPanelless.false: "Default" => "Laiminlyönti"
// isPanelless.true: "Without Panels" => "Ilman paneeleja"
// theme.cornerRadius: "Corner radius" => "Kulman säde"
// theme.fontFamily: "Font family" => "Fonttiperhe"
// theme.fontWeightRegular: "Regular" => "Säännöllinen"
// theme.fontWeightHeavy: "Heavy" => "Raskas"
// theme.fontWeightSemiBold: "Semi-bold" => "Puoliksi lihavoitu"
// theme.fontWeightBold: "Bold" => "Rohkea"
// theme.color: "Color" => "Väri"
// theme.placeholderColor: "Placeholder color" => "Paikkamerkin väri"
// theme.size: "Size" => "Koko"
// theme.opacity: "Opacity" => "Läpikuultamattomuus"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Kirjoita etsiäksesi..."
// ed.toolboxNoResultsFound: "No results found" => "Tuloksia ei löytynyt"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Välilehden otsikon paikkamerkki"
// theme.--sjs-special-red: "Error messages" => "Virhesanomista"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Välilehtien otsikoiden varateksti, jota käytetään, kun välilehden otsikkomalli ei tuota merkityksellistä arvoa."
// theme.fontColor: "Font color" => "Fontin väri"
// theme.backgroundColor: "Background color" => "Taustaväri"
// pe.questionTitleWidth: "Question title width" => "Kysymyksen otsikon leveys"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Valitse tiedosto tai liitä tiedostolinkki..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Esimerkki: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Määrittää kysymysten otsikoiden tasaisen leveyden, kun ne tasataan kysymysruutujen vasemmalle puolelle. Hyväksyy CSS-arvot (px, %, in, pt jne.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Määrittää kysymysten otsikoiden tasaisen leveyden, kun ne tasataan kysymysruutujen vasemmalle puolelle. Hyväksyy CSS-arvot (px, %, in, pt jne.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Kommenttialueen korkeus (riveinä)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Määrittää tekstialueilla näytettävien rivien määrän kysymyskommentteja varten. Tulossa vie enemmän rivejä, vierityspalkki tulee näkyviin."


/***/ }),

/***/ "./src/localization/french.ts":
/*!************************************!*\
  !*** ./src/localization/french.ts ***!
  \************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var frenchTranslation = {
    // survey templates
    survey: {
        edit: "Éditer",
        externalHelpLink: "Regardez et apprenez à créer des sondages",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Déposer votre question ici.",
        addLogicItem: "Créez une règle pour personnaliser le déroulement du sondage.",
        copy: "Copier",
        duplicate: "Dupliquer",
        addToToolbox: "Ajouter à la boîte à outils",
        deletePanel: "Supprimer le panneau",
        deleteQuestion: "Supprimer la question",
        convertTo: "Convertir en",
        drag: "Élément Drag",
    },
    // Creator tabs
    tabs: {
        preview: "Tester le sondage",
        theme: "Thèmes",
        translation: "Traduction",
        designer: "Éditeur de sondage",
        editor: "Éditeur JSON",
        logic: "Condition"
    },
    // Question types
    qt: {
        default: "Par défaut",
        checkbox: "Cases à cocher",
        comment: "Commentaire",
        imagepicker: "Choix d'image",
        ranking: "Classement",
        image: "Image",
        dropdown: "Liste déroulante",
        tagbox: "Liste déroulante (choix multiples)",
        file: "Fichier",
        html: "Code HTML",
        matrix: "Matrice (choix unique)",
        matrixdropdown: "Matrice (choix multiples)",
        matrixdynamic: "Matrice (lignes dynamiques)",
        multipletext: "Champ multilignes",
        panel: "Section",
        paneldynamic: "Section (dynamique)",
        radiogroup: "Choix unique (radio)",
        rating: "Évaluation",
        text: "Champ de saisie",
        boolean: "Vrai/Faux (Booléen)",
        expression: "Titre (lecture seule)",
        signaturepad: "Signature",
        buttongroup: "Groupe de boutons"
    },
    toolboxCategories: {
        general: "Général",
        choice: "Questions à choix",
        text: "Questions de saisie libre",
        containers: "Conteneurs",
        matrix: "Questions matricielles",
        misc: "Divers"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Valeur par défaut ({0})",
        survey: "Sondage",
        settings: "Configuration du sondage",
        settingsTooltip: "Ouvrir paramètres",
        surveySettings: "Paramètres du sondage",
        surveySettingsTooltip: "Paramètres de l’enquête",
        themeSettings: "Paramètres du thème",
        themeSettingsTooltip: "Paramètres du thème",
        showPanel: "Afficher le panneau",
        hidePanel: "Masquer le panneau",
        prevSelected: "Sélectionnez précédent",
        nextSelected: "Sélectionnez Suivant",
        prevFocus: "Mise au point précédente",
        nextFocus: "Focus suivant",
        surveyTypeName: "Sondage",
        pageTypeName: "Page",
        panelTypeName: "Panneau",
        questionTypeName: "Question",
        columnTypeName: "Colonne",
        addNewPage: "Ajouter une page",
        moveRight: "Défiler à droite",
        moveLeft: "Défiler à gauche",
        deletePage: "Supprimer une page",
        editPage: "Éditer une page",
        edit: "Éditer",
        newPageName: "page",
        newQuestionName: "question",
        newPanelName: "panneau",
        newTextItemName: "texte",
        defaultV2Theme: "Défaut",
        modernTheme: "Moderne",
        defaultTheme: "Valeur par défaut (héritée)",
        testSurveyAgain: "Tester à nouveau le sondage",
        testSurveyWidth: "Largeur du sondage : ",
        navigateToMsg: "Vous deviez naviguer vers",
        saveSurvey: "Sauvegarder le sondage",
        saveSurveyTooltip: "Enregistrer le sondage",
        saveTheme: "Enregistrer le thème",
        saveThemeTooltip: "Enregistrer le thème",
        jsonHideErrors: "Masquer les erreurs",
        jsonShowErrors: "Afficher les erreurs",
        undo: "Annuler",
        redo: "Rétablir",
        undoTooltip: "Annuler la dernière modification",
        redoTooltip: "Rétablir la modification",
        showMoreChoices: "Afficher plus",
        showLessChoices: "Afficher moins",
        copy: "Copier",
        cut: "Couper",
        paste: "Coller",
        copyTooltip: "Copier la sélection dans le presse-papiers",
        cutTooltip: "Couper la sélection dans le presse-papiers",
        pasteTooltip: "Coller à partir du presse-papiers",
        options: "Options",
        generateValidJSON: "Générer un JSON valide",
        generateReadableJSON: "Générer un JSON lisible",
        toolbox: "Boîte à outils",
        "property-grid": "Propriétés",
        toolboxFilteredTextPlaceholder: "Tapez pour rechercher...",
        toolboxNoResultsFound: "Aucun résultat trouvé",
        propertyGridFilteredTextPlaceholder: "Tapez pour rechercher...",
        propertyGridNoResultsFound: "Aucun résultat trouvé",
        correctJSON: "Merci de corriger le JSON",
        surveyResults: "Résultat du sondage : ",
        surveyResultsTable: "Format tableau",
        surveyResultsJson: "Format JSON",
        resultsTitle: "Titre de la question",
        resultsName: "Nom de la question",
        resultsValue: "Valeur de la réponse",
        resultsDisplayValue: "Valeur affichée",
        modified: "Modifié",
        saving: "Sauvegarde en cours",
        saved: "Sauvegardé",
        propertyEditorError: "Erreur",
        saveError: "Erreur! Le contenu de l'éditeur n'a pas été sauvegardé.",
        translationPropertyGridTitle: "Paramètres de langue",
        themePropertyGridTitle: "Paramètres du thème",
        translationLanguages: "Traduction",
        translationDeleteLanguage: "Êtes-vous certain de vouloir supprimer toutes les chaînes pour cette langue ?",
        translationAddLanguage: "Choisir langue à traduire",
        translationShowAllStrings: "Afficher tous les termes",
        translationShowUsedStringsOnly: "Termes utilisés uniquement",
        translationShowAllPages: "Afficher toutes les pages",
        translationNoStrings: "Aucun terme à traduire. Veuillez modifier le filtre.",
        translationExportToSCVButton: "Exporter en CSV",
        translationImportFromSCVButton: "Importer d'un CSV",
        translateUsigAI: "Traduire automatiquement tout",
        translateUsigAIFrom: "Traduction: ",
        translationDialogTitle: "Chaînes non traduites",
        translationMergeLocaleWithDefault: "Fusionner {0} avec langue par défaut",
        translationPlaceHolder: "Traduction...",
        translationSource: "Source: ",
        translationTarget: "Cible: ",
        themeExportButton: "Exportation",
        themeImportButton: "Importation",
        surveyJsonExportButton: "Exportation",
        surveyJsonImportButton: "Importation",
        surveyJsonCopyButton: "Copier dans le Presse-papiers",
        themeResetButton: "Réinitialiser les paramètres de thème par défaut",
        themeResetConfirmation: "Voulez-vous vraiment réinitialiser le thème ? Toutes vos personnalisations seront perdues.",
        themeResetConfirmationOk: "Oui, réinitialisez le thème",
        bold: "Gras",
        italic: "Italique",
        underline: "Souligné",
        addNewQuestion: "Ajouter Question",
        selectPage: "Sélectionner une page...",
        carryForwardChoicesCopied: "Les choix sont copiés à partir de",
        choicesLoadedFromWebText: "Les choix sont chargés à partir d’un service Web.",
        choicesLoadedFromWebLinkText: "Accédez aux paramètres",
        choicesLoadedFromWebPreviewTitle: "Aperçu des options de choix chargées",
        htmlPlaceHolder: "Le contenu HTML se trouvera ici.",
        panelPlaceHolder: "Déposez une question de la boîte à outils ici.",
        surveyPlaceHolder: "Le sondage est vide. Faites glisser un élément de la boîte à outils ou cliquez sur le bouton ci-dessous.",
        pagePlaceHolder: "La page est vide. Faites glisser un élément de la boîte à outils ou cliquez sur le bouton ci-dessous.",
        imagePlaceHolder: "Glissez et déposez une image ici ou cliquez sur le bouton ci-dessous pour choisir une image à télécharger",
        surveyPlaceHolderMobile: "Cliquez sur le bouton « Ajouter une question » ci-dessous pour commencer à créer votre formulaire.",
        pagePlaceHolderMobile: "Cliquez sur le bouton « Ajouter une question » ci-dessous pour ajouter un nouvel élément à la page.",
        panelPlaceHolderMobile: "Cliquez sur le bouton « Ajouter une question » ci-dessous pour ajouter un nouvel élément au panneau.",
        imagePlaceHolderMobile: "Cliquez sur le bouton ci-dessous et choisissez une image à télécharger",
        imageChooseImage: "Choisir une image",
        addNewTypeQuestion: "Ajouter {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Article ",
        selectFile: "Sélectionner un fichier",
        removeFile: "Supprimer le fichier",
        lg: {
            addNewItem: "Ajouter une nouvelle règle",
            empty_tab: "Créez une règle pour personnaliser le déroulement du sondage.",
            page_visibilityName: "Afficher/masquer la page",
            page_enableName: "Activer (désactiver) la page",
            page_requireName: "Rendre la page obligatoire",
            panel_visibilityName: "Afficher/masquer le panneau",
            panel_enableName: "Activer/désactiver le panneau",
            panel_requireName: "Rendre la page obligatoire",
            question_visibilityName: "Afficher/masquer la question",
            question_enableName: "Activer/désactiver la question",
            question_requireName: "Rendre la question obligatoire",
            question_resetValueName: "Réinitialiser la valeur de la question",
            question_setValueName: "Définir la valeur de la question",
            column_visibilityName: "Afficher/masquer la colonne",
            column_enableName: "Activer/désactiver la colonne",
            column_requireName: "Rendre la colonne obligatoire",
            column_resetValueName: "Réinitialiser la valeur de la colonne",
            column_setValueName: "Définition de la valeur de colonne",
            trigger_completeName: "Terminer le sondage",
            trigger_setvalueName: "Définir la valeur de la question",
            trigger_copyvalueName: "Copier la valeur de la question",
            trigger_skipName: "Passer à la question",
            trigger_runExpressionName: "Exécuter une expression personnalisée",
            completedHtmlOnConditionName: "Personnaliser le texte de la page de remerciements",
            page_visibilityDescription: "Rendre la page visible lorsque la condition renvoie 'vrai'. Sinon, la rendre invisible.",
            panel_visibilityDescription: "Rendre le panneau visible lorsque la condition renvoie 'vrai'. Sinon, le rendre invisible.",
            panel_enableDescription: "Activer le panneau et tous les éléments qu'il contient lorsque la condition renvoie 'vrai'. Sinon, le laisser désactivé.",
            question_visibilityDescription: "Render la question visible lorsque la condition renvoie 'vrai'. Sinon, la rendre invisible.",
            question_enableDescription: "Activer la question lorsque la condition renvoie 'vrai'. Sinon, la laisser désactivée.",
            question_requireDescription: "La question devient requise lorsque la condition renvoie 'vrai'.",
            trigger_completeDescription: "Lorsque la condition renvoie 'vrai', l'enquête est alors terminée et un utilisateur voit la page de remerciements.",
            trigger_setvalueDescription: "Lorsque les valeurs des questions utilisées dans la condition sont modifiées et que la condition renvoie 'vrai', la valeur est définie à la question sélectionnée.",
            trigger_copyvalueDescription: "Lorsque les valeurs de question, qui sont utilisées dans la condition, sont modifiées et que la condition renvoie 'vrai', la valeur d'une question sélectionnée est copiée dans une autre question sélectionnée.",
            trigger_skipDescription: "Lorsque la condition renvoie 'vrai', l'enquête passe à la question sélectionnée.",
            trigger_runExpressionDescription: "Lorsque la condition renvoie 'vrai', alors la condition personnalisée est exécutée. Vous pouvez éventuellement définir ce résultat de condition dans la question sélectionnée.",
            completedHtmlOnConditionDescription: "Si la condition renvoie 'vrai', le texte par défaut de la page de remerciements est remplacé par celui que vous avez défini.",
            itemExpressionText: "Lorsque la condition: '{0}' renvoie 'vrai':",
            itemEmptyExpressionText: "Nouvelle règle",
            page_visibilityText: "Rendre la page {0} visible",
            panel_visibilityText: "Rendre le panneau {0} visible",
            panel_enableText: "Activer le panneau {0}",
            question_visibilityText: "Rendre la question {0} visible",
            question_enableText: "Activer la question {0}",
            question_requireText: "Rendre la question {0} obligatoire",
            question_resetValueText: "Réinitialisez la valeur pour la question : {0}",
            question_setValueText: "Attribuer une valeur : {1} à la question : {0}",
            column_visibilityText: "Rendre visible les {0} de la colonne de questions {1}",
            column_enableText: "Activer la {0} de la colonne de questions {1}",
            column_requireText: "rendre obligatoire la colonne {0} de la question {1}",
            column_resetValueText: "Réinitialiser la valeur de la cellule pour la colonne : {0}",
            column_setValueText: "Affecter la valeur de la cellule : {1} à la colonne : {0}",
            setValueExpressionPlaceholder: " Expression dont le résultat sera affecté à la question cible.",
            trigger_completeText: "Le sondage se termine.",
            trigger_setvalueText: "Définir dans la question: {0} valeur {1}",
            trigger_setvalueEmptyText: "Valeur de la question claire : {0}",
            trigger_copyvalueText: "Copier dans la question: {0} valeur de la question {1}",
            trigger_skipText: "Dans le sondage, passez à la question {0}",
            trigger_runExpressionText1: "Exécuter l'expression: '{0}'",
            trigger_runExpressionText2: " et définissez son résultat dans la question: {0}",
            completedHtmlOnConditionText: "Afficher un texte personnalisé pour la page de remerciements.",
            showAllQuestions: "Toutes les questions",
            showAllActionTypes: "Tous les types d’action",
            conditions: "Condition(s)",
            actions: "Action(s)",
            expressionEditorTitle: "Définissez le(s) condition(s)",
            actionsEditorTitle: "Définissez le(s) action(s)",
            deleteAction: "Supprimer l'action",
            addNewAction: "Ajouter une nouvelle action",
            selectedActionCaption: "Sélectionnez une action à ajouter …",
            expressionInvalid: "La condition est vide ou non valide. Merci de corriger.",
            noActionError: "Veuillez ajouter au moins une action.",
            actionInvalid: "Veuillez corriger les problèmes dans vos actions.",
            uncompletedRule_title: "Les règles logiques sont incomplètes",
            uncompletedRule_text: "Vous n’avez pas terminé certaines des règles logiques. Si vous quittez l’onglet maintenant, les modifications seront perdues. Voulez-vous toujours quitter sans sauvegarder ?",
            uncompletedRule_apply: "Oui",
            uncompletedRule_cancel: "Non, je veux compléter les règles"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Nom du panneau",
            title: "Titre du panneau",
            description: "Description du panneau",
            visibleIf: "Rendre le panneau visible si",
            requiredIf: "Rendez le panneau requis si",
            questionsOrder: "Ordre des questions au sein du panel",
            page: "Page parent",
            startWithNewLine: "Afficher le panneau sur une nouvelle ligne",
            state: "État de réduction du panneau",
            width: "Largeur du panneau en ligne",
            minWidth: "Largeur minimale du panneau",
            maxWidth: "Largeur maximale du panneau",
            showNumber: "Panneaux numériques"
        },
        paneldynamic: {
            name: "Nom du panneau",
            title: "Titre du panneau",
            description: "Description du panneau",
            visibleIf: "Rendre le panneau visible si",
            requiredIf: "Rendez le panneau requis si",
            page: "Déplacer le panneau vers la page",
            startWithNewLine: "Afficher le panneau sur une nouvelle ligne",
            state: "État de réduction du panneau",
            width: "Largeur du panneau en ligne",
            minWidth: "Largeur minimale du panneau",
            maxWidth: "Largeur maximale du panneau",
            confirmDelete: "Confirmer la suppression de la section",
            templateDescription: "Modèle de description du panneau",
            templateTitle: "Modèle de titre de panneau",
            noEntriesText: "Texte du panneau vide",
            templateTabTitle: "Modèle de titre de tabulation",
            tabTitlePlaceholder: "Espace réservé au titre de l’onglet",
            templateVisibleIf: "Rendre un panneau individuel visible si :",
            hideNumber: "Masquer le numéro du panneau",
            titleLocation: "Alignement du titre du panneau",
            descriptionLocation: "Alignement de la description du panneau",
            templateTitleLocation: "Alignement du titre de la question",
            templateErrorLocation: "Alignement des messages d’erreur",
            newPanelPosition: "Nouvel emplacement du panneau",
            keyName: "Éviter les réponses en double à la question suivante"
        },
        question: {
            name: "Nom de la question",
            title: "Titre de la question",
            description: "Description de la question",
            visibleIf: "Rendez la question visible si",
            requiredIf: "Faites en sorte que la question soit obligatoire si",
            page: "Page parent",
            state: "État de réduction de la zone de question",
            hideNumber: "Masquer le numéro de la question",
            titleLocation: "Alignement du titre de la question",
            descriptionLocation: "Alignement de la description de la question",
            errorLocation: "Alignement des messages d’erreur",
            indent: "Augmenter le retrait intérieur",
            width: "Largeur de la question en ligne",
            minWidth: "Largeur minimale de la question",
            maxWidth: "Largeur maximale de la question",
            textUpdateMode: "Mettre à jour la valeur du champ de saisie"
        },
        signaturepad: {
            signatureWidth: "Largeur de la zone de signature",
            signatureHeight: "Hauteur de la zone de signature",
            signatureAutoScaleEnabled: "Mise à l’échelle automatique de la zone de signature",
            showPlaceholder: "Afficher l’espace réservé",
            placeholder: "Texte d’espace réservé",
            placeholderReadOnly: "Texte d’espace réservé en lecture seule ou en mode d’aperçu",
            allowClear: "Afficher le bouton Effacer dans la zone de signature",
            penMinWidth: "Largeur minimale du stylo",
            penMaxWidth: "Largeur maximale du stylo",
            penColor: "Couleur du trait"
        },
        comment: {
            rows: "Hauteur du champ de saisie (en lignes)"
        },
        showQuestionNumbers: "Afficher les numéros de questions",
        questionStartIndex: "Index de départ de la question (1, 2 ou 'A', 'a')",
        expression: {
            name: "Nom de l’expression",
            title: "Titre de l’expression",
            description: "Description de l’expression",
            expression: "Expression"
        },
        trigger: {
            expression: "Expression"
        },
        calculatedvalue: {
            expression: "Expression"
        },
        // survey templates
        survey: {
            title: "Titre du questionnaire",
            description: "Description de l’enquête"
        },
        page: {
            name: "Nom de la page",
            title: "Titre",
            description: "Description de la page",
            visibleIf: "Rendre la page visible si",
            requiredIf: "Rendez la page obligatoire si",
            maxTimeToFinish: "Limite de temps pour terminer la page (en secondes)",
            questionsOrder: "Ordre des questions sur la page"
        },
        matrixdropdowncolumn: {
            name: "Nom de la colonne",
            title: "Titre de la colonne",
            isUnique: "Éviter les réponses en double",
            width: "Largeur de la colonne",
            minWidth: "Largeur minimale de la colonne",
            rows: "Hauteur du champ de saisie (en lignes)",
            visibleIf: "Rendre la colonne visible si",
            requiredIf: "Rendez la colonne obligatoire si",
            showInMultipleColumns: "Chaque option dans une colonne distincte"
        },
        multipletextitem: {
            name: "Nom",
            title: "Titre"
        },
        masksettings: {
            saveMaskedValue: "Enregistrer la valeur masquée dans les résultats de l’enquête"
        },
        patternmask: {
            pattern: "Modèle de valeur"
        },
        datetimemask: {
            min: "Valeur minimale",
            max: "Valeur maximale"
        },
        numericmask: {
            allowNegativeValues: "Autoriser les valeurs négatives",
            thousandsSeparator: "Séparateur de milliers",
            decimalSeparator: "Séparateur décimal",
            precision: "Précision de la valeur",
            min: "Valeur minimale",
            max: "Valeur maximale"
        },
        currencymask: {
            prefix: "Préfixe de devise",
            suffix: "Suffixe de devise"
        },
        imageHeight: "Hauteur de l'image",
        imageWidth: "Largeur de l'image",
        valueName: "Variable de stockage",
        rateDescriptionLocation: "Alignement des étiquettes",
        size: "Taille du champ de saisie (en caractères)",
        cellErrorLocation: "Alignement des messages d’erreur de cellule",
        apply: "Appliquer",
        ok: "Ok",
        save: "Enregistrer",
        clear: "Effacer",
        saveTooltip: "Sauvegarder",
        cancel: "Annuler",
        set: "Définir",
        reset: "Réinitialiser",
        change: "Changer",
        refresh: "Rafraîchir",
        close: "Fermer",
        delete: "Supprimer",
        add: "Ajouter",
        addNew: "Ajouter un nouvel élément",
        addItem: "Cliquez pour ajouter un item...",
        removeItem: "Cliquez pour supprimer l’élément...",
        dragItem: "Faire glisser l’élément",
        addOther: "Autre",
        addSelectAll: "Tout sélectionner",
        addNone: "Aucun",
        removeAll: "Tout supprimer",
        edit: "Éditer",
        back: "Quitter sans sauvegarder",
        backTooltip: "Quitter sans sauvegarder",
        saveAndBack: "Sauvegarder et quitter",
        saveAndBackTooltip: "Sauvegarder et quitter",
        doneEditing: "Terminé",
        editChoices: "Editer les choix",
        showChoices: "Afficher les choix",
        move: "Déplacer",
        empty: "<vide>",
        emptyValue: "La valeur est vide",
        fastEntry: "Ajout rapide",
        fastEntryNonUniqueError: "La valeur '{0}' n’est pas unique",
        fastEntryChoicesCountError: "Veuillez limiter le nombre d'éléments de {0} à {1}",
        fastEntryChoicesMinCountError: "Veuillez saisir au moins {0} éléments",
        fastEntryPlaceholder: "Vous pouvez définir les données au format suivant :\nvaleur1|texte\nvaleur2",
        formEntry: "Ajout via formulaire",
        testService: "Tester le service",
        itemSelectorEmpty: "Veuillez sélectionner l’élément",
        conditionActionEmpty: "Veuillez sélectionner l’action",
        conditionSelectQuestion: "Sélectionner une question...",
        conditionSelectPage: "Sélectionner une page...",
        conditionSelectPanel: "Sélectionner un panneau...",
        conditionValueQuestionTitle: "Sélectionner ou saisir la valeur",
        aceEditorHelp: "Appuyer sur Ctrl + espace pour obtenir une aide pour la saisie d'expression",
        aceEditorRowTitle: "Ligne actuelle",
        aceEditorPanelTitle: "Panneau actuel",
        showMore: "Pour plus d'informations, veuillez vous référer à la documentation",
        assistantTitle: "Questions disponibles :",
        cellsEmptyRowsColumns: "Ajoutez au minimum une ligne ou une colonne",
        showPreviewBeforeComplete: "Prévisualiser les réponses avant d'envoyer le sondage",
        overridingPropertyPrefix: "Défini par ",
        resetToDefaultCaption: "Réinitialisation",
        propertyIsEmpty: "Veuillez entrer une valeur",
        propertyIsNoUnique: "Veuillez saisir une valeur unique",
        propertyNameIsNotUnique: "Veuillez saisir une variable unique",
        propertyNameIsIncorrect: "N’utilisez pas de mots réservés : « item », « choice », « panel », « row ».",
        listIsEmpty: "Ajouter un nouvel élément",
        "listIsEmpty@choices": "Aucun choix n’a encore été ajouté",
        "listIsEmpty@columns": "Vous n’avez pas encore de colonnes",
        "listIsEmpty@rows": "Vous n’avez pas encore de lignes",
        "listIsEmpty@validators": "Vous n’avez pas encore de règles de validation",
        "listIsEmpty@calculatedValues": "Vous n’avez pas encore de variables personnalisées",
        "listIsEmpty@triggers": "Vous n’avez pas encore de déclencheurs",
        "listIsEmpty@navigateToUrlOnCondition": "Vous n’avez pas encore de liens",
        "addNew@choices": "Ajouter un choix",
        "addNew@columns": "Ajouter une nouvelle colonne",
        "addNew@rows": "Ajouter une nouvelle ligne",
        "addNew@validators": "Ajouter une nouvelle règle",
        "addNew@calculatedValues": "Ajouter une nouvelle variable",
        "addNew@triggers": "Ajouter un nouveau déclencheur",
        "addNew@navigateToUrlOnCondition": "Ajouter une nouvelle URL",
        expressionIsEmpty: "La condition est vide",
        value: "Valeur",
        text: "Texte",
        rowid: "ID Ligne",
        imageLink: "URL de l'image",
        columnEdit: "Éditer la colonne: {0}",
        itemEdit: "Éditer l'item: {0}",
        url: "URL",
        path: "Chemin",
        choicesbyurl: {
            url: "URL du service Web",
            valueName: "Obtenir des valeurs à partir du champ JSON suivant"
        },
        titleName: "Obtenir le texte à afficher à partir du champ JSON suivant",
        imageLinkName: "Obtenir les URL d’image à partir du champ JSON suivant",
        allowEmptyResponse: "Autoriser les réponses vides",
        titlePlaceholder: "Titre de la page",
        surveyTitlePlaceholder: "Saisissez le titre du sondage",
        pageTitlePlaceholder: "Saisissez le titre de la page",
        descriptionPlaceholder: "Entrez une description",
        surveyDescriptionPlaceholder: "Entrez une description pour l'enquête",
        pageDescriptionPlaceholder: "Entrez une description pour la page",
        textWrapEnabled: "Choix d’enveloppes",
        showOtherItem: "Contient choix \"Autre\"",
        otherText: "Texte du choix \"Autre\"",
        showNoneItem: "Contient un choix \"Aucun\"",
        showRefuseItem: "Autoriser l’option Refuser de répondre",
        showDontKnowItem: "Autoriser l’option Ne sait pas",
        noneText: "Texte du choix \"Aucun\"",
        showSelectAllItem: "Contient un choix \"Tout sélectionner\"",
        selectAllText: "Texte du choix \"Tout sélectionner\"",
        choicesMin: "Valeur minimum pour les choix générés automatiquement",
        choicesMax: "Valeur maximum pour les choix générés automatiquement",
        choicesStep: "Écart entre les choix générés automatiquement",
        name: "Variable de stockage",
        title: "Intitulé de la question",
        cellType: "Type de cellule",
        colCount: "Nombre de colonnes",
        choicesOrder: "Sélectionner l'ordre des choix",
        visible: "Est visible ?",
        isRequired: "Est obligatoire ?",
        markRequired: "Marquer au besoin",
        removeRequiredMark: "Supprimer la marque requise",
        isAllRowRequired: "Réponse obligatoire pour toutes les lignes",
        eachRowUnique: "Éviter les réponses dupliquées dans les lignes",
        requiredErrorText: "Message d'erreur lorsque obligatoire",
        startWithNewLine: "Afficher la question sur une nouvelle ligne",
        rows: "Lignes",
        cols: "Colonnes",
        placeholder: "Placeholder (texte indicatif)",
        showPreview: "Afficher les informations du fichier",
        storeDataAsText: "Stocker le contenu du fichier dans le résultat JSON sous forme de texte",
        maxSize: "Taille maximum du fichier en octets",
        rowCount: "Nombre de lignes",
        columnLayout: "Inverser les lignes et les colonnes",
        addRowLocation: "Emplacement bouton \"Ajouter une ligne\"",
        transposeData: "Transposer des lignes en colonnes",
        addRowText: "Texte bouton \"Ajouter une ligne\"",
        removeRowText: "Texte bouton \"Supprimer une ligne\"",
        rateMin: "Note minimum",
        rateMax: "Note maximum",
        rateStep: "Intervalle des notes",
        minRateDescription: "Description note minimum",
        maxRateDescription: "Description note maximum",
        inputType: "Type de champ",
        optionsCaption: "Texte par défaut",
        defaultValue: "Valeur par défaut",
        cellsDefaultRow: "Texte de cellule par défaut",
        surveyEditorTitle: "Éditer les paramètres du sondage",
        qEditorTitle: "Éditer la question: {0}",
        maxLength: "Longueur maximum",
        buildExpression: "Construire",
        editExpression: "Editer",
        and: "et",
        or: "ou",
        remove: "Enlever",
        addCondition: "Ajouter une condition",
        emptyLogicPopupMessage: "Sélectionnez une question pour commencer à configurer les conditions.",
        if: "Si",
        then: "alors",
        setToName: "Question ciblée",
        fromName: "Copier les réponses de la question :",
        gotoName: "Passer à la question :",
        ruleIsNotSet: "La règle est incorrecte",
        includeIntoResult: "Inclure dans les résultats du sondage",
        showTitle: "Afficher/masquer le titre",
        expandCollapseTitle: "Développer/réduire le titre",
        locale: "Langue par défaut",
        simulator: "Choisir l'appareil",
        landscapeOrientation: "Paysage",
        portraitOrientation: "Passer en orientation portrait",
        mode: "Mode (édition/lecture seule)",
        clearInvisibleValues: "Effacer les valeurs invisibles",
        cookieName: "Nom du cookie (pour empêcher de compléter 2 fois le sondage localement)",
        sendResultOnPageNext: "Envoyer les résultats au changement de page",
        storeOthersAsComment: "Sauvegarder la valeur \"Autres\" dans un champ séparé",
        showPageTitles: "Afficher les titres de pages",
        showPageNumbers: "Afficher les numéros de pages",
        pagePrevText: "Texte bouton page précédente",
        pageNextText: "Texte bouton page suivante",
        completeText: "Texte bouton terminer",
        previewText: "Aperçu du texte du bouton Réponses",
        editText: "Modifier le texte du bouton de réponse",
        startSurveyText: "Texte bouton commencer",
        showNavigationButtons: "Afficher les boutons de navigation (navigation par défaut)",
        showPrevButton: "Afficher le bouton précédent (l'utilisateur pourra retourner sur la page précédente)",
        firstPageIsStarted: "La première page du sondage est une page de démarrage.",
        showCompletedPage: "Afficher la page de fin une fois le sondage terminé",
        goNextPageAutomatic: "Aller à la page suivante automatiquement pour toutes les questions",
        allowCompleteSurveyAutomatic: "Répondez automatiquement à l’enquête",
        showProgressBar: "Afficher la barre de progression",
        questionTitleLocation: "Emplacement du titre de la question",
        questionTitleWidth: "Largeur du titre de la question",
        requiredText: "Symbole(s) des questions obligatoires",
        questionTitleTemplate: "Emplacement du symbole obligatoire'",
        questionErrorLocation: "Emplacement de l'erreur",
        focusFirstQuestionAutomatic: "Focus sur la première question au changement de page",
        questionsOrder: "Ordre des éléments sur la page",
        maxTimeToFinish: "Temps maximum pour terminer le sondage",
        maxTimeToFinishPage: "Temps maximum pour terminer une page",
        showTimerPanel: "Afficher le panneau chronomètre",
        showTimerPanelMode: "Mode d'affichage du panneau chronomètre",
        renderMode: "Mode de rendu",
        allowAddPanel: "Autoriser l'ajout de sections",
        allowRemovePanel: "Autoriser la suppression de sections",
        panelAddText: "Ajouter le texte du bouton de la section",
        panelRemoveText: "Supprimer la section texte",
        isSinglePage: "Afficher tous les éléments sur une seule page",
        html: "Balisage HTML",
        setValue: "Réponse",
        dataFormat: "Format de l’image",
        allowAddRows: "Autoriser l’ajout de lignes",
        allowRemoveRows: "Autoriser la suppression de lignes",
        allowRowsDragAndDrop: "Autoriser le glisser-déposer de lignes",
        responsiveImageSizeHelp: "Ne s’applique pas si vous spécifiez la largeur ou la hauteur exacte de l’image.",
        minImageWidth: "Largeur minimale de l’image",
        maxImageWidth: "Largeur maximale de l’image",
        minImageHeight: "Hauteur minimale de l’image",
        maxImageHeight: "Hauteur maximale de l’image",
        minValue: "Valeur minimum",
        maxValue: "Valeur maximum",
        minLength: "Longueur minimum",
        allowDigits: "Autoriser les chiffres",
        minCount: "Nombre minimum",
        maxCount: "Nombre maximum",
        regex: "Expression régulière (RegEx)",
        surveyvalidator: {
            text: "Message d'erreur",
            expression: "Condition à respecter"
        },
        totalText: "Texte pour le total",
        totalType: "Type de total",
        totalExpression: "Calcul total",
        totalDisplayStyle: "Format d'affichage",
        totalCurrency: "Monnaie",
        totalFormat: "Format du total",
        logo: "Logo (URL ou chaîne codée en base64)",
        questionsOnPageMode: "Structure du sondage",
        maxTextLength: "Longueur maximale de réponse (en caractères)",
        maxOthersLength: "Longueur maximale des commentaires (en caractères)",
        commentAreaRows: "Hauteur de la zone de commentaires (en lignes)",
        autoGrowComment: "Développer automatiquement la zone de commentaires si nécessaire",
        allowResizeComment: "Autoriser les utilisateurs à redimensionner les zones de texte",
        textUpdateMode: "Mettre à jour la valeur de la question textuelle",
        maskType: "Type de masque de saisie",
        maskTypes: {
            none: "Aucun",
            patternmask: "Modèle",
            numericmask: "Numérique",
            datetimemask: "Date et heure",
            currencymask: "Monnaie"
        },
        focusOnFirstError: "Renvoyer vers la première question ayant une erreur",
        checkErrorsMode: "Exécuter la validation",
        navigateToUrl: "Accédez à l'URL",
        navigateToUrlOnCondition: "URL dynamique",
        completedBeforeHtml: "Message (HTML) à afficher si l’utilisateur a déjà rempli cette enquête",
        completedHtml: "Page de fin (format HTML)",
        completedHtmlOnCondition: "Page de fin conditionnées (format HTML)",
        loadingHtml: "Message (HTML) à afficher pendant le chargement du sondage",
        commentText: "Texte de la zone de commentaires",
        autocomplete: "Type de saisie semi-automatique",
        labelTrue: "Texte du bouton « Vrai »",
        labelFalse: "Texte du bouton « Faux »",
        allowClear: "Afficher le bouton Effacer",
        searchMode: "Mode de recherche",
        displayStyle: "Style d’affichage de la valeur",
        format: "Chaîne de caractères formatée",
        maximumFractionDigits: "Nombre maximal de décimales",
        minimumFractionDigits: "Nombre minimum de décimales",
        useGrouping: "Afficher les séparateurs de groupes",
        allowMultiple: "Autoriser plusieurs fichiers",
        allowImagesPreview: "Afficher la prévisualisation des images",
        acceptedTypes: "Types de fichiers acceptés",
        waitForUpload: "Attendez la fin du téléchargement",
        needConfirmRemoveFile: "Confirmer la suppression du fichier",
        detailPanelMode: "Emplacement du panneau de détails",
        minRowCount: "Nombre minimal de lignes",
        maxRowCount: "Nombre maximal de lignes",
        confirmDelete: "Confirmer la suppression de lignes",
        confirmDeleteText: "Message de confirmation",
        panelCount: "Nombre initial de sections",
        minPanelCount: "Nombre minimal de sections",
        maxPanelCount: "Nombre maximal de sections",
        panelsState: "Déploiement de la section",
        panelPrevText: "Info-bulle du bouton Section précédente",
        panelNextText: "Info-bulle du bouton Section suivante",
        showRangeInProgress: "Afficher la barre de progression",
        panelRemoveButtonLocation: "Emplacement du bouton Supprimer la Section",
        hideIfRowsEmpty: "Masquer la question s’il n’y a pas de lignes",
        hideColumnsIfEmpty: "Masquer les colonnes s’il n’y a pas de lignes",
        rateValues: "Valeurs des notes personnalisées",
        rateCount: "Nombre notes sur le barème",
        autoGenerate: "Comment définir les valeurs possibles ?",
        hideIfChoicesEmpty: "Masquer la question si elle ne contient pas de choix",
        minWidth: "Largeur minimale (en valeurs acceptées par CSS)",
        maxWidth: "Largeur maximale (en valeurs acceptées par CSS)",
        width: "Largeur (en valeurs acceptées par CSS)",
        showHeader: "Afficher les en-têtes de colonne",
        horizontalScroll: "Afficher la barre de défilement horizontale",
        columnMinWidth: "Largeur minimale de colonne (en valeurs acceptées par CSS)",
        rowTitleWidth: "Largeur de l’en-tête de ligne (en valeurs acceptées par CSS)",
        valueTrue: "Valeur à sauvegarder pour « Vrai »",
        valueFalse: "Valeur à sauvegarder pour « Faux »",
        minErrorText: "Message d’erreur « La valeur est inférieure au minimum »",
        maxErrorText: "Message d’erreur « La valeur dépasse le maximum »",
        otherErrorText: "Message d’erreur « Commentaire vide »",
        keyDuplicationError: "Message d’erreur « Valeur de clé non unique »",
        minSelectedChoices: "Nombre minimum de choix sélectionnables",
        maxSelectedChoices: "Nombre maximal de choix sélectionnables",
        showClearButton: "Afficher le bouton Effacer",
        logoWidth: "Largeur du logo (en valeurs acceptées par CSS)",
        logoHeight: "Hauteur du logo (en valeurs acceptées par CSS)",
        readOnly: "Lecture seule",
        enableIf: "Modifiable si",
        emptyRowsText: "Message « Aucune ligne »",
        separateSpecialChoices: "Afficher séparément les choix spéciaux (Aucun, Autre, Sélectionner tout)",
        choicesFromQuestion: "Copier les choix à partir de la question",
        choicesFromQuestionMode: "Quels choix copier ?",
        progressBarShowPageTitles: "Afficher les titres des pages dans la barre de progression",
        progressBarShowPageNumbers: "Afficher les numéros de page dans la barre de progression",
        showCommentArea: "Afficher la zone de commentaire",
        commentPlaceholder: "Espace réservé pour la zone de commentaires",
        displayRateDescriptionsAsExtremeItems: "Afficher la description des notes sur les valeurs des extrémités",
        rowsOrder: "Ordre des lignes",
        columnsLayout: "Disposition des colonnes",
        columnColCount: "Nombre de colonnes imbriquées",
        correctAnswer: "Réponse correcte",
        defaultPanelValue: "Valeurs par défaut",
        cells: "Texte des cellules",
        fileInputPlaceholder: "Sélectionnez un fichier ou collez un lien de fichier...",
        keyName: "Colonne clé",
        itemvalue: {
            visibleIf: "Rendre l’option visible si",
            enableIf: "Rendez l’option sélectionnable si"
        },
        "itemvalue@rows": {
            visibleIf: "Rendre la ligne visible si",
            enableIf: "Rendez la ligne modifiable si"
        },
        imageitemvalue: {
            text: "Texte de remplacement"
        },
        logoPosition: "Position du logo",
        addLogo: "Ajouter un logo...",
        changeLogo: "Changer le logo...",
        logoPositions: {
            none: "Retirer le logo",
            left: "Gauche",
            right: "Droite",
            top: "Au dessus",
            bottom: "En dessous"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Disposition du panneau"
            },
            general: "Général",
            fileOptions: "Options",
            html: "Éditeur HTML",
            columns: "Colonnes",
            rows: "Lignes",
            choices: "Choix",
            items: "Éléments",
            visibleIf: "Visible si",
            enableIf: "Activé si",
            requiredIf: "Obligatoire si",
            rateValues: "Barème",
            choicesByUrl: "Choix depuis API web",
            matrixChoices: "Choix par défaut",
            multipleTextItems: "Champs de saisie multiples",
            numbering: "Numérotation",
            validators: "Validateurs",
            navigation: "Navigation",
            question: "Question",
            pages: "Pages",
            timer: "Chronomètre/Quiz",
            calculatedValues: "Valeurs calculées",
            triggers: "Déclencheurs",
            templateTitle: "Titre du modèle",
            totals: "Totaux",
            logic: "Conditions",
            mask: "Paramètres du masque de saisie",
            layout: {
                panel: "Disposition",
                question: "Disposition",
                base: "Disposition"
            },
            data: "Données",
            validation: "Validateurs",
            cells: "Cellules",
            showOnCompleted: "Sondage terminé",
            logo: "Logo dans le titre du sondage",
            slider: "Curseur",
            expression: "Condition",
            questionSettings: "Paramètres de la question",
            header: "En-tête",
            background: "Arrière-plan",
            appearance: "Apparence",
            others: "Autres"
        },
        editProperty: "Éditer la propriété \"{0}\"",
        items: "[ Éléments: {0} ]",
        choicesVisibleIf: "Les choix sont visibles si",
        choicesEnableIf: "Les choix sont sélectionnables si",
        columnsEnableIf: "Les colonnes sont visibles si",
        rowsEnableIf: "Les lignes sont visibles si",
        innerIndent: "Ajouter des tabulations internes",
        defaultValueFromLastRow: "Prendre les valeurs par défaut de la dernière ligne",
        defaultValueFromLastPanel: "Prendre les valeurs par défaut de la dernière section",
        enterNewValue: "Veuillez saisir la valeur.",
        noquestions: "Il n'y a aucune question dans le sondage.",
        createtrigger: "Veuillez créer un déclencheur",
        titleKeyboardAdornerTip: "Appuyez sur le bouton Entrée pour modifier",
        keyboardAdornerTip: "Appuyez sur le bouton Entrée pour modifier l’élément, appuyez sur le bouton Supprimer pour supprimer l’élément, appuyez sur alt plus flèche vers le haut ou flèche vers le bas pour déplacer l’élément",
        triggerOn: "Quand ",
        triggerMakePagesVisible: "Rendre les pages visibles :",
        triggerMakeQuestionsVisible: "Rendre les questions visibles :",
        triggerCompleteText: "Terminer le sondage si la condition est remplie.",
        triggerNotSet: "Le déclencheur n'est pas défini",
        triggerRunIf: "Exécuter si",
        triggerSetToName: "Changer la valeur de : ",
        triggerFromName: "Copier la valeur de : ",
        triggerRunExpression: "Exécuter cette expression :",
        triggerSetValue: "à : ",
        triggerGotoName: "Aller à la question :",
        triggerIsVariable: "Ne pas enregistrer le résultat dans les résultats du sondage.",
        triggerRunExpressionEmpty: "Veuillez entrer une condition valide",
        emptyExpressionPlaceHolder: "Saisir la condition ici...",
        noFile: "Aucun fichier sélectionné",
        clearIfInvisible: "Effacer la valeur si la question devient masquée",
        valuePropertyName: "Propriété du nom de la valeur",
        searchEnabled: "Activer la recherche",
        hideSelectedItems: "Masquer les éléments sélectionnés",
        closeOnSelect: "Fermer la liste déroulante après la sélection",
        verticalAlign: "Alignement vertical",
        alternateRows: "Lignes alternatives",
        columnsVisibleIf: "Les colonnes sont visibles si",
        rowsVisibleIf: "Les lignes sont visibles si",
        otherPlaceholder: "Espace réservé pour la zone de commentaires",
        filePlaceholder: "Texte de l’espace réservé au fichier",
        photoPlaceholder: "Texte de l’espace réservé à la photo",
        fileOrPhotoPlaceholder: "Texte de l’espace réservé au fichier ou à la photo",
        rateType: "Type de notation",
        url_placeholder: "Ex. : https://api.example.com/books",
        path_placeholder: "Ex. : categories.fiction",
        questionStartIndex_placeholder: "Ex. : a)",
        width_placeholder: "Ex. : 6po",
        minWidth_placeholder: "Ex. : 600px",
        maxWidth_placeholder: "Ex. : 50 %",
        imageHeight_placeholder: "auto",
        imageWidth_placeholder: "auto",
        theme: {
            themeName: "Thème",
            isPanelless: "Apparence de la question",
            editorPanel: "Arrière-plan et rayon d’angle",
            questionPanel: "Arrière-plan et rayon d’angle",
            primaryColor: "Couleur d’accentuation",
            panelBackgroundTransparency: "Opacité de l’arrière-plan du panneau",
            questionBackgroundTransparency: "Opacité de l’arrière-plan de la question",
            fontSize: "Taille de la police",
            scale: "Écaille",
            cornerRadius: "Rayon d’angle",
            pageTitle: "Police de titre",
            pageDescription: "Police de description",
            questionTitle: "Police de titre",
            questionDescription: "Police de description",
            editorFont: "Police",
            backgroundOpacity: "Opacité",
            "--sjs-font-family": "Famille de polices",
            "--sjs-general-backcolor-dim": "Couleur de fond",
            "--sjs-primary-backcolor": "Fond d’accent",
            "--sjs-primary-forecolor": "Premier plan accentué",
            "--sjs-special-red": "Messages d’erreur",
            "--sjs-shadow-small": "Effets d’ombre",
            "--sjs-shadow-inner": "Effets d’ombre",
            "--sjs-border-default": "Couleurs"
        },
        "header@header": {
            headerView: "Vue",
            logoPosition: "Position du logo",
            surveyTitle: "Police de titre de l’enquête",
            surveyDescription: "Police de description de l’enquête",
            headerTitle: "Police de titre de l’enquête",
            headerDescription: "Police de description de l’enquête",
            inheritWidthFrom: "Largeur de la zone de contenu",
            textAreaWidth: "Largeur du texte",
            backgroundColorSwitch: "Couleur de fond",
            backgroundImage: "Image d’arrière-plan",
            backgroundImageOpacity: "Opacité",
            overlapEnabled: "Chevauchement",
            logoPositionX: "Position du logo",
            titlePositionX: "Position du titre",
            descriptionPositionX: "Description du poste"
        }
    },
    // Property values
    pv: {
        "true": "vrai",
        "false": "faux",
        file: "Fichiers locaux",
        camera: "Caméra",
        "file-camera": "Fichiers locaux ou caméra",
        inherit: "Hérité",
        show: "Afficher",
        hide: "Masquer",
        default: "Par défaut",
        initial: "Initial",
        random: "Aléatoire",
        collapsed: "Réduite",
        expanded: "Déployée",
        none: "Aucun",
        asc: "Ascendant",
        desc: "Descendant",
        indeterminate: "Indeterminé",
        selected: "Sélectionné",
        unselected: "Non sélectionné",
        decimal: "Décimal",
        currency: "Devise",
        percent: "Pour cent",
        firstExpanded: "Déployer la première section",
        off: "Désactiver",
        list: "liste",
        progressTop: "Barre de progression en haut",
        progressBottom: "Barre de progression en bas",
        progressTopBottom: "Barre de progression en haut et en bas",
        tab: "Onglets",
        horizontal: "Horizontal",
        vertical: "Vertical",
        top: "Haut",
        bottom: "Bas",
        topBottom: "Haut et bas",
        both: "Les deux",
        left: "Gauche",
        right: "Droite",
        center: "Centre",
        leftRight: "Gauche et droite",
        middle: "Milieu",
        color: "Couleur",
        date: "Date",
        datetime: "Date et heure",
        "datetime-local": "dateheure-local",
        email: "Email",
        month: "Mois",
        number: "Nombre",
        password: "Mot de passe",
        range: "Curseur",
        tel: "Numéro de téléphone",
        text: "texte",
        time: "Heure",
        url: "URL",
        week: "Semaine",
        hidden: "Masqué",
        edit: "Éditer",
        display: "Affichage",
        contain: "Contenir",
        cover: "Couvrir",
        fill: "Remplir",
        next: "Prochain",
        last: "Dernier",
        onComplete: "Quand terminé",
        onHidden: "Quand masqué",
        onHiddenContainer: "Lorsque la question ou sa section/page devient masquée",
        clearInvisibleValues: {
            none: "Jamais"
        },
        clearIfInvisible: {
            none: "Jamais"
        },
        inputType: {
            color: "Couleur",
            date: "Date",
            "datetime-local": "Date et heure",
            email: "Messagerie électronique",
            month: "Mois",
            number: "Nombre",
            password: "Mot de passe",
            range: "Curseur",
            tel: "Numéro de téléphone",
            text: "Texte",
            time: "Heure",
            url: "URL",
            week: "Semaine"
        },
        all: "Tous",
        page: "Page",
        survey: "Sondage",
        onNextPage: "Lors du passage à la page suivante",
        onValueChanged: "Après la modification d’une réponse",
        onValueChanging: "Avant qu’une réponse ne soit modifiée",
        questionsOnPageMode: {
            standard: "Structure d’origine",
            singlePage: "Afficher toutes les questions sur une seule page",
            questionPerPage: "Afficher une seule question par page"
        },
        noPreview: "Pas d’aperçu",
        showAllQuestions: "Afficher toutes les questions",
        showAnsweredQuestions: "Afficher uniquement les questions complétées",
        pages: "Pages complétées",
        questions: "Questions complétées",
        requiredQuestions: "Questions obligatoires complétées",
        correctQuestions: "Réponses valides",
        buttons: "Pages terminées (bouton UI)",
        underInput: "Sous le champ",
        underTitle: "Sous le titre",
        onBlur: "En quittant le champ",
        onTyping: "Pendant la saisie",
        underRow: "Sous la ligne",
        underRowSingle: "Sous la ligne, une seule section est visible",
        auto: "Auto",
        showNavigationButtons: {
            none: "Masqué"
        },
        showTimerPanel: {
            none: "Masqué"
        },
        showTimerPanelMode: {
            all: "Les deux"
        },
        addRowLocation: {
            default: "Dépend de la disposition de la matrice"
        },
        panelsState: {
            default: "Les utilisateurs ne peuvent pas déployer ou réduire les sections",
            collapsed: "Toutes les sections sont réduites",
            expanded: "Toutes les sections sont déployées",
            firstExpanded: "D’abord élargi"
        },
        widthMode: {
            static: "Statique",
            responsive: "Adaptative"
        },
        contentMode: {
            image: "Image",
            video: "Vidéo",
            youtube: "Youtube"
        },
        displayMode: {
            buttons: "Boutons",
            dropdown: "Liste déroulante"
        },
        rateColorMode: {
            default: "Par défaut",
            scale: "Écaille"
        },
        scaleColorMode: {
            monochrome: "Monochrome",
            colored: "Coloré"
        },
        autoGenerate: {
            "true": "Générer",
            "false": "Saisie manuelle"
        },
        rateType: {
            labels: "Labels",
            stars: "Étoiles",
            smileys: "Smileys"
        },
        state: {
            default: "Verrouillé"
        },
        showQuestionNumbers: {
            default: "Numérotation automatique",
            on: "Numérotation automatique",
            onPage: "Réinitialisation sur chaque page",
            onpanel: "Réinitialisation sur chaque panneau",
            onPanel: "Réinitialisation sur chaque panneau",
            onSurvey: "Continuez tout au long de l’enquête",
            off: "Pas de numérotation"
        },
        descriptionLocation: {
            underTitle: "Sous le titre de la question",
            underInput: "Sous le champ de saisie"
        },
        selectToRankAreasLayout: {
            horizontal: "À côté des choix",
            vertical: "Choix ci-dessus"
        },
        displayStyle: {
            decimal: "Décimal",
            currency: "Monnaie",
            percent: "Pourcentage",
            date: "Date"
        },
        totalDisplayStyle: {
            decimal: "Décimal",
            currency: "Monnaie",
            percent: "Pourcentage",
            date: "Date"
        },
        rowsOrder: {
            initial: "Langue source"
        },
        questionsOrder: {
            initial: "Langue source"
        },
        showProgressBar: {
            off: "Masqué",
            topbottom: "Haut et bas",
            aboveheader: "Au-dessus de l’en-tête",
            belowheader: "Sous l’en-tête"
        },
        sum: "Somme",
        count: "Compter",
        min: "Min",
        max: "Max",
        avg: "Avg",
        searchMode: {
            contains: "Contient",
            startsWith: "Commence par"
        },
        backgroundImageFit: {
            auto: "Auto",
            cover: "Couvrir",
            contain: "Contenir",
            fill: "Étirer",
            tile: "Carreau"
        },
        backgroundImageAttachment: {
            fixed: "Fixe",
            scroll: "Faire défiler"
        },
        headerView: {
            basic: "Basique",
            advanced: "Avancé"
        },
        inheritWidthFrom: {
            survey: "Identique à l’enquête",
            container: "Adapter au conteneur"
        },
        backgroundColorSwitch: {
            none: "Aucun",
            accentColor: "Couleur d’accentuation",
            custom: "Coutume"
        },
        colorPalette: {
            light: "Lumière",
            dark: "Sombre"
        },
        isPanelless: {
            "false": "Faire défaut",
            "true": "Sans panneaux"
        }
    },
    // Operators
    op: {
        empty: "Est vide",
        notempty: "N'est pas vide",
        equal: "Égal",
        notequal: "N'est pas égal",
        contains: "Contient",
        notcontains: "Ne contient pas",
        anyof: "N'importe quel de",
        allof: "Tous parmi",
        greater: "Supérieur",
        less: "Inférieur",
        greaterorequal: "Supérieur ou égal",
        lessorequal: "Inférieur ou égal",
        and: "Et",
        or: "Ou"
    },
    // Embed window
    ew: {
        angular: "Utiliser la version Angular",
        jquery: "Utiliser la version jQuery",
        knockout: "Utiliser la version Knockout",
        react: "Utiliser la version React",
        vue: "Utiliser la version Vue",
        bootstrap: "Pour le framework Bootstrap",
        modern: "Thème Moderne",
        default: "Thème par défaut",
        orange: "Thème Orange",
        darkblue: "Thème Bleu foncé",
        darkrose: "Thème Rose foncé",
        stone: "Thème Pierre",
        winter: "Thème Hiver",
        winterstone: "Thème Winter-Stone",
        showOnPage: "Afficher le sondage dans une page",
        showInWindow: "Afficher le sondage dans une fenêtre",
        loadFromServer: "Charger le JSON du sondage depuis un serveur",
        titleScript: "Scripts et styles",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Sélectionner une page pour la tester",
        showInvisibleElements: "Afficher les éléments invisibles",
        hideInvisibleElements: "Masquer les éléments invisibles"
    },
    validators: {
        answercountvalidator: "Total de réponses",
        emailvalidator: "Email",
        expressionvalidator: "Condition",
        numericvalidator: "Numérique",
        regexvalidator: "Expression régulière (RegEx)",
        textvalidator: "Texte"
    },
    triggers: {
        completetrigger: "Terminer le sondage",
        setvaluetrigger: "Définir la valeur",
        copyvaluetrigger: "Copier la valeur",
        skiptrigger: "Sauter à la question",
        runexpressiontrigger: "Exécuter une expression",
        visibletrigger: "Modifier la visibilité"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Ex. : +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Ex. : mm/jj/aaaa"
        },
        currencymask: {
            prefix: "Ex. : $",
            suffix: "Ex. : USD"
        },
        panelbase: {
            questionTitleWidth: "Ex. : 200px"
        }
    },
    pehelp: {
        panel: {
            name: "Un ID de panel qui n’est pas visible par les personnes interrogées.",
            description: "Saisissez un sous-titre de panneau.",
            visibleIf: "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui détermine la visibilité du panneau.",
            enableIf: "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui désactive le mode lecture seule du panneau.",
            requiredIf: "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui empêche l’envoi d’un sondage à moins qu’au moins une question imbriquée n’ait une réponse.",
            questionTitleLocation: "S’applique à toutes les questions de ce panneau. Si vous souhaitez remplacer ce paramètre, définissez des règles d’alignement des titres pour les questions individuelles. L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête (« Haut » par défaut).",
            questionTitleWidth: "Définit une largeur cohérente pour les titres de questions lorsqu’ils sont alignés à gauche de leurs zones de questions. Accepte les valeurs CSS (px, %, in, pt, etc.).",
            questionErrorLocation: "Définit l’emplacement d’un message d’erreur par rapport à toutes les questions du panneau. L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête.",
            questionsOrder: "Conserve l’ordre d’origine des questions ou les rend aléatoires. L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête.",
            page: "Repositionne le panneau à la fin d’une page sélectionnée.",
            innerIndent: "Ajoute un espace ou une marge entre le contenu du panneau et le bord gauche de la zone du panneau.",
            startWithNewLine: "Désélectionnez cette option pour afficher le panneau sur une seule ligne avec la question ou le panneau précédent. Ce paramètre ne s’applique pas si le panneau est le premier élément de votre formulaire.",
            state: "Choisissez parmi : « Développé » - le panneau s’affiche en entier et peut être réduit ; « Réduit » - le panneau n’affiche que le titre et la description et peut être développé ; « Verrouillé » - le panneau est affiché en entier et ne peut pas être réduit.",
            width: "Définit la largeur du panneau par rapport aux autres éléments de topographie de la même ligne. Accepte les valeurs CSS (px, %, in, pt, etc.)."
        },
        paneldynamic: {
            name: "Un ID de panel qui n’est pas visible par les personnes interrogées.",
            description: "Saisissez un sous-titre de panneau.",
            visibleIf: "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui détermine la visibilité du panneau.",
            enableIf: "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui désactive le mode lecture seule du panneau.",
            requiredIf: "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui empêche l’envoi d’un sondage à moins qu’au moins une question imbriquée n’ait une réponse.",
            templateTitleLocation: "S’applique à toutes les questions de ce panneau. Si vous souhaitez remplacer ce paramètre, définissez des règles d’alignement des titres pour les questions individuelles. L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête (« Haut » par défaut).",
            templateErrorLocation: "Définit l’emplacement d’un message d’erreur par rapport à une question dont l’entrée n’est pas valide. Choisissez entre : « Haut » - un texte d’erreur est placé en haut de la zone de question ; « Bas » - un texte d’erreur est placé en bas de la zone de question. L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête (« Haut » par défaut).",
            errorLocation: "Définit l’emplacement d’un message d’erreur par rapport à toutes les questions du panneau. L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête.",
            page: "Repositionne le panneau à la fin d’une page sélectionnée.",
            innerIndent: "Ajoute un espace ou une marge entre le contenu du panneau et le bord gauche de la zone du panneau.",
            startWithNewLine: "Désélectionnez cette option pour afficher le panneau sur une seule ligne avec la question ou le panneau précédent. Ce paramètre ne s’applique pas si le panneau est le premier élément de votre formulaire.",
            state: "Choisissez parmi : « Développé » - le panneau s’affiche en entier et peut être réduit ; « Réduit » - le panneau n’affiche que le titre et la description et peut être développé ; « Verrouillé » - le panneau est affiché en entier et ne peut pas être réduit.",
            width: "Définit la largeur du panneau par rapport aux autres éléments de topographie de la même ligne. Accepte les valeurs CSS (px, %, in, pt, etc.).",
            templateTitle: "Saisissez un modèle pour les titres de panneau dynamiques. Utilisez {panelIndex} pour la position générale du panneau et {visiblePanelIndex} pour son ordre parmi les panneaux visibles. Insérez ces espaces réservés dans le motif pour ajouter une numérotation automatique.",
            templateTabTitle: "Saisissez un modèle pour les titres d’onglets. Utilisez {panelIndex} pour la position générale d’un panneau et {visiblePanelIndex} pour son ordre parmi les panneaux visibles. Insérez ces espaces réservés dans le motif pour ajouter une numérotation automatique.",
            tabTitlePlaceholder: "Texte de secours pour les titres d’onglet qui s’applique lorsque le modèle de titre d’onglet ne produit pas de valeur significative.",
            templateVisibleIf: "Ce paramètre vous permet de contrôler la visibilité des panneaux individuels dans le panneau dynamique. Utilisez l’espace réservé '{panel}' pour référencer le panneau actuel dans votre expression.",
            titleLocation: "Ce paramètre est automatiquement hérité par toutes les questions de ce panneau. Si vous souhaitez remplacer ce paramètre, définissez des règles d’alignement des titres pour les questions individuelles. L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête (« Haut » par défaut).",
            descriptionLocation: "L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête (« Sous le titre du panneau » par défaut).",
            newPanelPosition: "Définit la position d’un panneau nouvellement ajouté. Par défaut, de nouveaux panneaux sont ajoutés à la fin. Sélectionnez « Suivant » pour insérer un nouveau panneau après le panneau actuel.",
            defaultValueFromLastPanel: "Duplique les réponses du dernier panneau et les attribue au panneau dynamique suivant.",
            keyName: "Faites référence à un nom de question pour demander à un utilisateur de fournir une réponse unique à cette question dans chaque panneau."
        },
        defaultValueExpression: "Ce paramètre vous permet d’attribuer une valeur de réponse par défaut en fonction d’une expression. L’expression peut inclure des calculs de base - '{q1_id} + {q2_id}', des expressions booléennes, telles que '{age} > 60', et des fonctions : 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. La valeur déterminée par cette expression sert de valeur par défaut initiale qui peut être remplacée par la saisie manuelle d’une personne interrogée.",
        resetValueIf: "Utilisez l’icône de la baguette magique pour définir une règle conditionnelle qui détermine le moment où l’entrée d’une personne interrogée est réinitialisée à la valeur basée sur l’expression de valeur par défaut ou l’expression de valeur définie ou à la valeur de la réponse par défaut (si l’une ou l’autre est définie).",
        setValueIf: "Utilisez l’icône de la baguette magique pour définir une règle conditionnelle qui détermine quand exécuter l’expression « Définir la valeur » et attribuer dynamiquement la valeur résultante en tant que réponse.",
        setValueExpression: "Spécifiez une expression qui définit la valeur à définir lorsque les conditions de la règle « Définir la valeur si » sont remplies. L’expression peut inclure des calculs de base - '{q1_id} + {q2_id}', des expressions booléennes, telles que '{age} > 60', et des fonctions : 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. La valeur déterminée par cette expression peut être remplacée par la saisie manuelle d’un répondant.",
        question: {
            name: "ID de question qui n’est pas visible par les personnes interrogées.",
            description: "Saisissez un sous-titre de question.",
            visibleIf: "Utilisez l’icône de la baguette magique pour définir une règle conditionnelle qui détermine la visibilité de la question.",
            enableIf: "Utilisez l’icône de la baguette magique pour définir une règle conditionnelle qui désactive le mode lecture seule pour la question.",
            requiredIf: "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui empêche l’avancement ou la soumission de l’enquête à moins que la question n’ait reçu une réponse.",
            startWithNewLine: "Désélectionnez cette option pour afficher la question sur une seule ligne avec la question ou le panneau précédent. Ce paramètre ne s’applique pas si la question est le premier élément de votre formulaire.",
            page: "Repositionne la question à la fin d’une page sélectionnée.",
            state: "Choisissez parmi : « Développé » - la boîte de questions s’affiche en entier et peut être réduite ; « Réduit » - la boîte de question n’affiche que le titre et la description et peut être développée ; « Verrouillé » - la boîte de questions s’affiche en entier et ne peut pas être réduite.",
            titleLocation: "Remplace les règles d’alignement des titres définies au niveau d’un panneau, d’une page ou d’une enquête. L’option « Hériter » applique tous les paramètres de niveau supérieur (s’ils sont définis) ou tous les paramètres de niveau d’enquête (« Top » par défaut).",
            descriptionLocation: "L’option « Hériter » applique le paramètre au niveau de l’enquête (« Sous le titre de la question » par défaut).",
            errorLocation: "Définit l’emplacement d’un message d’erreur par rapport à la question dont l’entrée n’est pas valide. Choisissez entre : « Haut » - un texte d’erreur est placé en haut de la zone de question ; « Bas » - un texte d’erreur est placé en bas de la zone de question. L’option « Hériter » applique le paramètre au niveau de l’enquête (« Top » par défaut).",
            indent: "Ajoute un espace ou une marge entre le contenu de la question et la bordure gauche de la zone de question.",
            width: "Définit la largeur de la question par rapport aux autres éléments de l’enquête sur la même ligne. Accepte les valeurs CSS (px, %, in, pt, etc.).",
            surveyvalidator: {
                expression: "Utilisez l’icône de la baguette magique pour définir une règle de validation pour la question."
            },
            textUpdateMode: "Choisissez parmi : « En cas de perte de focus » - la valeur est mise à jour lorsque le champ de saisie perd le focus ; « Pendant la saisie » - la valeur est mise à jour en temps réel, au fur et à mesure que les utilisateurs tapent. L’option « Hériter » applique le paramètre au niveau de l’enquête (« En cas de perte de focus » par défaut).",
            url: "Vous pouvez utiliser n’importe quel service Web comme source de données pour les questions à choix multiples. Pour renseigner les valeurs de choix, entrez l’URL du service fournissant les données.",
            searchMode: "Opération de comparaison permettant de filtrer la liste déroulante.",
            textWrapEnabled: "Les longs textes dans les options de choix généreront automatiquement des sauts de ligne pour s’adapter au menu déroulant. Désélectionnez cette option si vous souhaitez que les textes soient coupés."
        },
        signaturepad: {
            signatureWidth: "Définit la largeur de la zone de signature affichée et l’image résultante.",
            signatureHeight: "Définit la hauteur de la zone de signature affichée et de l’image résultante.",
            signatureAutoScaleEnabled: "Sélectionnez cette option si vous souhaitez que la zone de signature occupe tout l’espace disponible dans la zone de question tout en conservant le format d’image 3 :2 par défaut. Lorsque des valeurs de largeur et de hauteur personnalisées sont définies, le paramètre conserve les proportions de ces dimensions."
        },
        file: {
            imageHeight: "Ajuste la hauteur de l’image dans les résultats de l’enquête.",
            imageWidth: "Ajuste la largeur de l’image dans les résultats de l’enquête."
        },
        image: {
            contentMode: "L’option « Auto » détermine automatiquement le mode d’affichage approprié - Image, Vidéo ou YouTube - en fonction de l’URL source fournie."
        },
        imagepicker: {
            imageHeight: "Remplace les valeurs de hauteur minimale et maximale.",
            imageWidth: "Remplace les valeurs de largeur minimale et maximale.",
            choices: "« Valeur » sert d’ID d’élément utilisé dans les règles conditionnelles ; La mention « Texte » s’affiche pour les personnes interrogées.",
            contentMode: "Choisissez entre « Image » et « Vidéo » pour définir le mode de contenu du sélecteur de médias. Si « Image » est sélectionné, assurez-vous que toutes les options fournies sont des fichiers image dans les formats suivants : JPEG, GIF, PNG, APNG, SVG, BMP, ICO. De même, si « Vidéo » est sélectionné, assurez-vous que toutes les options sont des liens directs vers des fichiers vidéo dans les formats suivants : MP4, MOV, WMV, FLV, AVI, MKV. Veuillez noter que les liens YouTube ne sont pas pris en charge pour les options vidéo."
        },
        text: {
            size: "Ce paramètre ne redimensionne que le champ de saisie et n’affecte pas la largeur de la zone de question. Pour limiter la longueur d’entrée acceptée, reportez-vous à <b>Validation → Limite maximale de caractères</b>."
        },
        comment: {
            rows: "Définit le nombre de lignes affichées dans le champ de saisie. Si l’entrée occupe plus de lignes, la barre de défilement apparaîtra."
        },
        // survey templates
        survey: {
            mode: "Choisissez entre : « Modifiable » - permet aux personnes interrogées de remplir votre sondage ; « Lecture seule » - désactive l’édition de formulaire."
        },
        matrixdropdowncolumn: {
            name: "ID de colonne qui n’est pas visible par les personnes interrogées.",
            isUnique: "Lorsque cette option est activée pour une colonne, une personne interrogée doit fournir une réponse unique pour chaque question de cette colonne.",
            rows: "Définit le nombre de lignes affichées dans le champ de saisie. Si l’entrée occupe plus de lignes, la barre de défilement apparaîtra.",
            visibleIf: "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui détermine la visibilité des colonnes.",
            enableIf: "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui désactive le mode lecture seule de la colonne.",
            requiredIf: "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui empêche l’envoi d’un sondage à moins qu’au moins une question imbriquée n’ait une réponse.",
            showInMultipleColumns: "Lorsque cette option est sélectionnée, une colonne individuelle est créée pour chaque option de choix."
        },
        widthMode: "Choisissez parmi : « Statique » - définit une largeur fixe ; « Responsive » - permet à l’enquête d’occuper toute la largeur de l’écran ; « Auto » - s’applique à l’un ou l’autre des deux en fonction des types de questions utilisés.",
        cookieName: "Les cookies empêchent les utilisateurs de remplir deux fois le même sondage.",
        logo: "Collez un lien d’image (aucune limite de taille) ou cliquez sur l’icône de dossier pour parcourir un fichier à partir de votre ordinateur (jusqu’à 64 Ko).",
        logoWidth: "Définit la largeur d’un logo en unités CSS (px, %, in, pt, etc.).",
        logoHeight: "Définit une hauteur de logo en unités CSS (px, %, in, pt, etc.).",
        logoFit: "Choisissez parmi : « Aucun » - l’image conserve sa taille d’origine ; « Contenir » - l’image est redimensionnée pour s’adapter tout en conservant son rapport hauteur/largeur ; « Couverture » - l’image remplit toute la boîte tout en conservant son rapport hauteur/largeur ; « Remplir » - l’image est étirée pour remplir la boîte sans conserver son rapport hauteur/largeur.",
        goNextPageAutomatic: "Sélectionnez cette option si vous souhaitez que le sondage passe automatiquement à la page suivante une fois qu’une personne interrogée a répondu à toutes les questions de la page actuelle.",
        allowCompleteSurveyAutomatic: "Sélectionnez cette option si vous souhaitez que l’enquête se termine automatiquement une fois qu’une personne interrogée a répondu à toutes les questions.",
        showNavigationButtons: "Définit la visibilité et l’emplacement des boutons de navigation sur une page.",
        showProgressBar: "Définit la visibilité et l’emplacement d’une barre de progression. La valeur « Auto » affiche la barre de progression au-dessus ou au-dessous de l’en-tête de l’enquête.",
        showPreviewBeforeComplete: "Activez la page d’aperçu avec toutes les questions ou les questions auxquelles on a répondu uniquement.",
        questionTitleLocation: "S’applique à toutes les questions de l’enquête. Ce paramètre peut être remplacé par des règles d’alignement des titres aux niveaux inférieurs : panneau, page ou question. Un paramètre de niveau inférieur remplacera ceux d’un niveau supérieur.",
        requiredText: "Symbole ou séquence de symboles indiquant qu’une réponse est requise.",
        questionStartIndex: "Entrez un chiffre ou une lettre avec laquelle vous souhaitez commencer la numérotation.",
        questionErrorLocation: "Définit l’emplacement d’un message d’erreur par rapport à la question dont l’entrée n’est pas valide. Choisissez entre : « Haut » - un texte d’erreur est placé en haut de la zone de question ; « Bas » - un texte d’erreur est placé en bas de la zone de question.",
        focusFirstQuestionAutomatic: "Sélectionnez cette option si vous souhaitez que le premier champ de saisie de chaque page soit prêt pour la saisie de texte.",
        questionsOrder: "Conserve l’ordre d’origine des questions ou les rend aléatoires. L’effet de ce paramètre n’est visible que dans l’onglet Aperçu.",
        maxTextLength: "Pour les questions de saisie de texte uniquement.",
        maxOthersLength: "Pour les commentaires sur les questions seulement.",
        commentAreaRows: "Définit le nombre de lignes affichées dans les zones de texte pour les commentaires de question. Lorsque l’entrée occupe plus de lignes, la barre de défilement apparaît.",
        autoGrowComment: "Indiquez si vous souhaitez que les commentaires de question et les questions de texte long augmentent automatiquement en hauteur en fonction de la longueur du texte saisi.",
        allowResizeComment: "Pour les questions, les commentaires et les questions de texte long uniquement.",
        calculatedValues: "Les variables personnalisées servent de variables intermédiaires ou auxiliaires utilisées dans les calculs de formulaire. Ils prennent les données des répondants comme valeurs sources. Chaque variable personnalisée a un nom unique et une expression sur laquelle elle est basée.",
        includeIntoResult: "Sélectionnez cette option si vous souhaitez que la valeur calculée de l’expression soit enregistrée avec les résultats de l’enquête.",
        triggers: "Un déclencheur est un événement ou une condition qui est basé sur une expression. Une fois que l’expression est évaluée à « true », un déclencheur déclenche une action. Une telle action peut éventuellement avoir une question cible qu’elle affecte.",
        clearInvisibleValues: "Choisissez d’effacer ou non les valeurs pour les questions masquées par la logique conditionnelle et quand le faire.",
        textUpdateMode: "Choisissez parmi : « En cas de perte de focus » - la valeur est mise à jour lorsque le champ de saisie perd le focus ; « Pendant la saisie » - la valeur est mise à jour en temps réel, au fur et à mesure que les utilisateurs tapent.",
        columns: "La valeur de gauche sert d’ID de colonne utilisé dans les règles conditionnelles, la valeur de droite est affichée aux personnes interrogées.",
        rows: "La valeur de gauche sert d’ID de ligne utilisé dans les règles conditionnelles, la valeur de droite est affichée aux personnes interrogées.",
        columnMinWidth: "Accepte les valeurs CSS (px, %, in, pt, etc.).",
        rowTitleWidth: "Accepte les valeurs CSS (px, %, in, pt, etc.).",
        totalText: "Visible uniquement lorsqu’au moins une colonne a un type Total ou une expression Total.",
        cellErrorLocation: "Définit l’emplacement d’un message d’erreur par rapport à une cellule dont l’entrée n’est pas valide. L’option « Hériter » applique le paramètre de la propriété « Alignement du message d’erreur ».",
        keyDuplicationError: "Lorsque la propriété « Empêcher les réponses en double » est activée, un répondant qui tente de soumettre une entrée en double recevra le message d’erreur suivant.",
        totalExpression: "Permet de calculer des valeurs totales en fonction d’une expression. L’expression peut inclure des calculs de base ('{q1_id} + {q2_id}'), des expressions booléennes ('{age} > 60') et des fonctions ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.).",
        confirmDelete: "Déclenche une invite vous demandant de confirmer la suppression de ligne.",
        defaultValueFromLastRow: "Duplique les réponses de la dernière ligne et les attribue à la ligne dynamique suivante ajoutée.",
        keyName: "Si la colonne spécifiée contient des valeurs identiques, le sondage renvoie l’erreur « Valeur de clé non unique ».",
        description: "Saisissez un sous-titre.",
        locale: "Choisissez une langue pour commencer à créer votre sondage. Pour ajouter une traduction, passez à une nouvelle langue et traduisez le texte original ici ou dans l’onglet Traductions.",
        detailPanelMode: "Définit l’emplacement d’une section de détails par rapport à une ligne. Choisissez parmi : « Aucun » - aucune extension n’est ajoutée ; « Sous la ligne » - un développement de ligne est placé sous chaque ligne de la matrice ; « Sous la ligne, afficher un seul développement de ligne » - un développement est affiché sous une seule ligne, les développements de ligne restants sont réduits.",
        imageFit: "Choisissez parmi : « Aucun » - l’image conserve sa taille d’origine ; « Contenir » - l’image est redimensionnée pour s’adapter tout en conservant son rapport hauteur/largeur ; « Couverture » - l’image remplit toute la boîte tout en conservant son rapport hauteur/largeur ; « Remplir » - l’image est étirée pour remplir la boîte sans conserver son rapport hauteur/largeur.",
        autoGrow: "Augmente progressivement la hauteur du champ de saisie au fur et à mesure de la saisie des données. Remplace le paramètre « Hauteur du champ de saisie (en lignes) ».",
        allowResize: "La poignée de redimensionnement (ou poignée) apparaît dans le coin et peut être déplacée pour modifier la taille du champ de saisie.",
        maxTimeToFinish: "Intervalle de temps en secondes après lequel l’enquête passe automatiquement à la page de remerciement.",
        maxTimeToFinishPage: "Intervalle de temps en secondes après lequel l’enquête passe automatiquement à la page suivante.",
        page: {
            maxTimeToFinish: "Intervalle de temps en secondes après lequel l’enquête passe automatiquement à la page suivante.",
            visibleIf: "Utilisez l’icône de la baguette magique pour définir une règle conditionnelle qui détermine la visibilité de la page.",
            enableIf: "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui désactive le mode lecture seule de la page.",
            requiredIf: "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui empêche l’envoi d’un sondage à moins qu’au moins une question imbriquée n’ait une réponse.",
            questionTitleLocation: "S’applique à toutes les questions de cette page. Si vous souhaitez remplacer ce paramètre, définissez des règles d’alignement des titres pour des questions ou des panneaux individuels. L’option « Hériter » applique le paramètre au niveau de l’enquête (« Top » par défaut).",
            questionTitleWidth: "Définit une largeur cohérente pour les titres de questions lorsqu’ils sont alignés à gauche de leurs zones de questions. Accepte les valeurs CSS (px, %, in, pt, etc.).",
            questionErrorLocation: "Définit l’emplacement d’un message d’erreur par rapport à la question dont l’entrée n’est pas valide. Choisissez entre : « Haut » - un texte d’erreur est placé en haut de la zone de question ; « Bas » - un texte d’erreur est placé en bas de la zone de question. L’option « Hériter » applique le paramètre au niveau de l’enquête (« Top » par défaut).",
            questionsOrder: "Conserve l’ordre d’origine des questions ou les rend aléatoires. L’option « Hériter » applique le paramètre au niveau de l’enquête (« Original » par défaut). L’effet de ce paramètre n’est visible que dans l’onglet Aperçu.",
            navigationButtonsVisibility: "Définit la visibilité des boutons de navigation sur la page. L’option « Hériter » applique le paramètre au niveau de l’enquête, qui est par défaut « Visible »."
        },
        showTimerPanel: "Définit la visibilité et l’emplacement d’un minuteur sur une page.",
        panelsState: "Choisissez parmi : « Verrouillé » - les utilisateurs ne peuvent pas développer ou réduire les panneaux ; « Réduire tout » - tous les panneaux commencent dans un état réduit ; « Développer tout » - tous les panneaux commencent dans un état développé ; « Premier développé » - seul le premier panneau est initialement développé.",
        imageLinkName: "Entrez un nom de propriété partagée dans le tableau d’objets qui contient les URL de fichier image ou vidéo que vous souhaitez afficher dans la liste de choix.",
        choices: "La valeur de gauche sert d’ID d’élément utilisé dans les règles conditionnelles, la valeur de droite est affichée aux personnes interrogées.",
        title: "Saisissez un titre convivial à afficher.",
        waitForUpload: "Garantit que les utilisateurs ne répondront pas à l’enquête tant que les fichiers n’auront pas été téléchargés.",
        minWidth: "Accepte les valeurs CSS (px, %, in, pt, etc.).",
        maxWidth: "Accepte les valeurs CSS (px, %, in, pt, etc.).",
        width: "Accepte les valeurs CSS (px, %, in, pt, etc.).",
        valueName: "Si vous ne définissez pas cette propriété, la réponse sera stockée dans un champ spécifié par la propriété Variable de stockage.",
        useDisplayValuesInDynamicTexts: "Dans les types de questions à sélection unique et multiple, chaque option de choix a un ID et une valeur d’affichage. Lorsqu’il est sélectionné, ce paramètre affiche une valeur d’affichage au lieu d’une valeur d’ID dans les questions HTML et les titres et descriptions dynamiques des éléments d’enquête.",
        clearIfInvisible: "Choisissez d’effacer ou non les valeurs de question masquées par la logique conditionnelle et quand le faire. L’option « Hériter » applique le paramètre au niveau de l’enquête (« À la fin de l’enquête » par défaut).",
        choicesFromQuestionMode: "Choisissez parmi : « Tous » - copie toutes les options de choix de la question sélectionnée ; « Sélectionné » - copie dynamiquement uniquement les options de choix sélectionnées ; « Non sélectionné » - copie dynamiquement uniquement les options de choix non sélectionnées. Les options « Aucun » et « Autre » sont copiées par défaut si elles sont activées dans la question source.",
        showOtherItem: "Lorsque cette option est sélectionnée, les utilisateurs peuvent inclure des entrées supplémentaires dans une zone de commentaire distincte.",
        separateSpecialChoices: "Affiche chaque option de choix spécial (« Aucun », « Autre », « Tout sélectionner ») sur une nouvelle ligne, même en cas d’utilisation d’une mise en page à plusieurs colonnes.",
        path: "Spécifiez l’emplacement dans le jeu de données de service où se trouve le tableau cible d’objets. Laissez vide si l’URL pointe déjà vers le tableau.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Entrez un nom de propriété uniforme dans le tableau d’objets qui contient les valeurs que vous souhaitez afficher dans la liste de choix.",
        allowEmptyResponse: "Sélectionnez cette option pour permettre au service de renvoyer une réponse ou un tableau vide.",
        choicesVisibleIf: "Utilisez l’icône de la baguette magique pour définir une règle conditionnelle qui détermine la visibilité de toutes les options de choix.",
        rateValues: "La valeur de gauche sert d’ID d’élément utilisé dans les règles conditionnelles, la valeur de droite est affichée aux personnes interrogées.",
        rating: {
            displayMode: "« Auto » sélectionne entre les modes « Boutons » et « Menu déroulant » en fonction de la largeur disponible. Lorsque la largeur est insuffisante pour afficher les boutons, la question affiche une liste déroulante."
        },
        valuePropertyName: "Vous permet de connecter des questions qui produisent des résultats dans différents formats. Lorsque ces questions sont liées entre elles à l’aide d’un identificateur de jointure, cette propriété partagée stocke les valeurs de question sélectionnées.",
        searchEnabled: "Sélectionnez cette option si vous souhaitez mettre à jour le contenu du menu déroulant pour qu’il corresponde à la requête de recherche qu’un utilisateur saisit dans le champ de saisie.",
        valueTrue: "Une valeur à enregistrer dans les résultats de l’enquête lorsque les répondants donnent une réponse positive.",
        valueFalse: "Une valeur à enregistrer dans les résultats de l’enquête lorsque les personnes interrogées donnent une réponse négative.",
        showPreview: "Il n’est pas recommandé de désactiver cette option, car elle remplace l’image d’aperçu et rend difficile pour l’utilisateur de savoir si les fichiers ont été téléchargés.",
        needConfirmRemoveFile: "Déclenche une invite vous demandant de confirmer la suppression du fichier.",
        selectToRankEnabled: "Activez cette option pour classer uniquement les choix sélectionnés. Les utilisateurs feront glisser les éléments sélectionnés de la liste de choix pour les classer dans la zone de classement.",
        dataList: "Entrez une liste de choix qui seront suggérés au répondant lors de la saisie.",
        itemSize: "Le paramètre ne redimensionne que les champs de saisie et n’affecte pas la largeur de la zone de question.",
        itemTitleWidth: "Définit une largeur cohérente pour toutes les étiquettes d’élément en pixels",
        altText: "Sert de substitut lorsque l’image ne peut pas être affichée sur l’appareil d’un utilisateur et à des fins d’accessibilité.",
        rateColorMode: "Définit la couleur de l’emoji sélectionné lorsque le type d’icône d’évaluation est défini sur « Smileys ». Choisissez entre : « Par défaut » - l’emoji sélectionné apparaît dans la couleur par défaut de l’enquête ; « Échelle » - l’emoji sélectionné hérite de la couleur de l’échelle d’évaluation.",
        expression: {
            name: "ID d’expression qui n’est pas visible par les personnes interrogées.",
            description: "Saisissez un sous-titre d’expression.",
            expression: "Une expression peut inclure des calculs de base ('{q1_id} + {q2_id}'), des conditions ('{age} > 60') et des fonctions ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.)."
        },
        storeOthersAsComment: "Sélectionnez cette option pour stocker la valeur de l’option « Autre » en tant que propriété distincte dans les résultats de l’enquête.",
        format: "Utilisez {0} comme espace réservé pour la valeur réelle.",
        acceptedTypes: "Reportez-vous à la description de l’attribut [accept](https://www.w3schools.com/tags/att_input_accept.asp) pour plus d’informations.",
        columnColCount: "Applicable uniquement aux types de cellules Choix unique (radio) et Cases à cocher.",
        autocomplete: "Reportez-vous à la description de l’attribut [saisie semi-automatique](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/saisie semi-automatique) pour plus d’informations.",
        filePlaceholder: "S’applique lorsque le « Type de source » est « Fichiers locaux » ou lorsque l’appareil photo n’est pas disponible",
        photoPlaceholder: "S’applique lorsque le « Type de source » est « Appareil photo ».",
        fileOrPhotoPlaceholder: "S’applique lorsque le « Type de source » est « Fichiers locaux ou appareil photo ».",
        masksettings: {
            saveMaskedValue: "Sélectionnez cette option si vous souhaitez stocker la valeur de la question à l’aide d’un masque appliqué dans les résultats de l’enquête."
        },
        patternmask: {
            pattern: "Le modèle peut contenir des littéraux de chaîne et les espaces réservés suivants : '9' - pour un chiffre ; 'a' - pour une lettre majuscule ou minuscule ; '#' - pour un chiffre ou une lettre majuscule ou minuscule. Utilisez la barre oblique inverse '\\' pour échapper un caractère."
        },
        datetimemask: {
            pattern: "Le modèle peut contenir des caractères de séparation et les espaces réservés suivants :<br>'m' - Numéro du mois.<br>'mm' - Numéro du mois, avec zéro non significatif pour les valeurs à un chiffre. <br>'d' - Jour du mois. <br>'dd' - Jour du mois, avec zéro non significatif pour les valeurs à un chiffre. <br>'yy' - Les deux derniers chiffres de l’année. <br>'yyyy' - Année à quatre chiffres. <br>'H' - Heures au format 24 heures. <br>'HH' - Heures au format 24 heures, avec zéro non significatif pour les valeurs à un chiffre. <br>'h' - Heures au format 12 heures. <br>'hh' - Heures au format 12 heures, avec zéro non significatif pour les valeurs à un chiffre. <br>'MM' - Procès-verbaux. <br>'ss' - Secondes. <br>'TT' - Période d’horloge de 12 heures en majuscules (AM/PM). <br>'tt' - Période d’horloge de 12 heures en minuscules (AM/PM)."
        },
        numericmask: {
            decimalSeparator: "Symbole utilisé pour séparer la partie fractionnaire de la partie entière d’un nombre affiché.",
            thousandsSeparator: "Symbole utilisé pour séparer les chiffres d’un grand nombre en groupes de trois.",
            precision: "Limite le nombre de chiffres à conserver après la virgule décimale pour un nombre affiché."
        },
        currencymask: {
            prefix: "Un ou plusieurs symboles à afficher avant la valeur.",
            suffix: "Un ou plusieurs symboles à afficher après la valeur."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "Titre",
            title: "Laissez vide, si même texte que \"Variable de stockage\""
        },
        multiSelect: "Autoriser la sélection multiple",
        showLabel: "Afficher les légendes des images",
        swapOrder: "Permuter l’ordre de Oui et Non",
        value: "Valeur",
        tabAlign: "Alignement des tabulations",
        sourceType: "Type de source",
        fitToContainer: "S’adapte au conteneur",
        setValueExpression: "Définir l’expression de valeur",
        description: "Description",
        logoFit: "Ajustement du logo",
        pages: "Pages",
        questions: "Questions",
        triggers: "Déclencheurs",
        calculatedValues: "Valeurs calculées",
        surveyId: "ID du sondage",
        surveyPostId: "ID de publication du sondage",
        surveyShowDataSaving: "Le sondage montre l'enregistrement des données",
        questionDescriptionLocation: "Emplacement de la description de la question",
        progressBarType: "Type de barre de progression",
        showTOC: "Afficher le menu de navigation",
        tocLocation: "Emplacement du menu de navigation",
        questionTitlePattern: "Modèle de titre de question",
        widthMode: "Largeur du sondage",
        showBrandInfo: "Afficher les informations sur la marque",
        useDisplayValuesInDynamicTexts: "Utiliser des valeurs d’affichage dans des textes dynamiques",
        visibleIf: "Visible si ",
        defaultValueExpression: "Expression de valeur par défaut",
        requiredIf: "Obligatoire si",
        resetValueIf: "Réinitialiser la valeur si",
        setValueIf: "Définir la valeur si",
        validators: "Validateurs",
        bindings: "Liaisons",
        renderAs: "Rendre en tant que",
        attachOriginalItems: "Joindre des documents originaux",
        choices: "Choix",
        choicesByUrl: "Définir les choix par API",
        currency: "Devise",
        cellHint: "Indication de cellule",
        totalMaximumFractionDigits: "Total de décimales maximale",
        totalMinimumFractionDigits: "Total de décimales minimales",
        columns: "Colonnes",
        detailElements: "Détails de l'élément",
        allowAdaptiveActions: "Autoriser les actions adaptatives",
        defaultRowValue: "Valeur de ligne par défaut",
        detailPanelShowOnAdding: "Affichage des détails de la section lors de l’ajout",
        choicesLazyLoadEnabled: "Choix de chargement paresseux activé",
        choicesLazyLoadPageSize: "Choix de taille de page de chargement paresseux",
        inputFieldComponent: "Composant du champ de saisie",
        itemComponent: "Composant de l'élément",
        min: "Min",
        max: "Max",
        minValueExpression: "Expression de valeur minimale",
        maxValueExpression: "Expression de valeur maximale",
        step: "Intervalle",
        dataList: "Liste de données",
        itemSize: "Nombre maximum de caractères",
        itemTitleWidth: "Largeur de l’étiquette de l’article (en px)",
        elements: "Éléments",
        content: "Contenu",
        navigationButtonsVisibility: "Visibilité des boutons de navigation",
        navigationTitle: "Titre de la navigation",
        navigationDescription: "Description de la navigation",
        longTap: "Appuyez longuement",
        autoGrow: "Agrandissement automatique",
        allowResize: "Autoriser le redimensionnement",
        acceptCarriageReturn: "Accepter le retour à la ligne",
        displayMode: "Mode d’affichage",
        rateType: "Type de notation",
        label: "Intitulé",
        contentMode: "Mode de contenu",
        imageFit: "Ajustement de l’image",
        altText: "Texte de remplacement",
        height: "Hauteur",
        penColor: "Couleur du stylo",
        backgroundColor: "Couleur d’arrière-plan",
        templateElements: "Modèle des éléments",
        operator: "Opérateur",
        isVariable: "Est variable",
        runExpression: "Exécuter l’expression",
        showCaption: "Afficher la légende",
        iconName: "Nom de l’icône",
        iconSize: "Taille de l’icône",
        precision: "Précision",
        matrixDragHandleArea: "Zone de poignée de déplacement de la matrice",
        backgroundImage: "Image d’arrière-plan",
        backgroundImageFit: "Ajustement de l’image d’arrière-plan",
        backgroundImageAttachment: "Pièce jointe de l’image d’arrière-plan",
        backgroundOpacity: "Opacité de l’arrière-plan",
        selectToRankEnabled: "Sélectionner pour classer activé",
        selectToRankAreasLayout: "Sélectionner pour classer la disposition des zones",
        selectToRankEmptyRankedAreaText: "Texte pour indiquer si toutes les options sont sélectionnées",
        selectToRankEmptyUnrankedAreaText: "Texte d’espace réservé pour la zone de classement",
        allowCameraAccess: "Autoriser l’accès à la caméra",
        scaleColorMode: "Mode de couleur de mise à l’échelle",
        rateColorMode: "Évaluer le mode de couleur",
        copyDisplayValue: "Copier la valeur d’affichage",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Mode avancé",
        pageTitle: "Police du titre de la page",
        questionTitle: "Police du titre de la question",
        editorPanel: "Champs de réponse",
        lines: "Lignes",
        primaryDefaultColor: "Faire défaut",
        primaryDarkColor: "Au survol",
        primaryLightColor: "Sélectionné",
        backgroundDimColor: "Couleur d’arrière-plan",
        cornerRadius: "Rayon d’angle",
        backcolor: "Arrière-plan par défaut",
        hovercolor: "Arrière-plan du survol",
        borderDecoration: "Décoration de bordure",
        fontColor: "Couleur de la police",
        backgroundColor: "Couleur de fond",
        primaryForecolor: "Couleur par défaut",
        primaryForecolorLight: "Couleur Désactivée",
        font: "Police",
        borderDefault: "Sombre",
        borderLight: "Clair",
        fontFamily: "Famille de polices",
        fontWeightRegular: "Régulier",
        fontWeightHeavy: "Lourd",
        fontWeightSemiBold: "Semi-gras",
        fontWeightBold: "Audacieux",
        color: "Couleur",
        placeholderColor: "Couleur de l’espace réservé",
        size: "Taille",
        opacity: "Opacité",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Ajouter un effet d’ombre",
        boxShadowBlur: "Flou",
        boxShadowSpread: "Propagation",
        boxShadowDrop: "Extérieur",
        boxShadowInner: "Intérieur",
        names: {
            default: "Par défaut",
            sharp: "Tranchant",
            borderless: "Sans bord",
            flat: "Plat",
            plain: "Plaine",
            doubleborder: "Double bordure",
            layered: "Superposé",
            solid: "Solide",
            threedimensional: "3D",
            contrast: "Contraste"
        },
        colors: {
            teal: "Bleu Sarcelle",
            blue: "Bleu",
            purple: "Pourpre",
            orchid: "Orchidée",
            tulip: "Tulipe",
            brown: "Marron",
            green: "Vert"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["fr"] = frenchTranslation;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// survey.externalHelpLink: "Watch and learn how to create surveys" => "Regardez et apprenez à créer des sondages"
// survey.externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber" => "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber"
// survey.addLogicItem: "Create a rule to customize the flow of the survey." => "Créez une règle pour personnaliser le flux de l’enquête."
// survey.duplicate: "Duplicate" => "Dupliquer"
// survey.drag: "Drag element" => "Élément Drag"
// qt.ranking: "Ranking" => "Classement"
// qt.image: "Image" => "Image"
// qt.tagbox: "Multi-Select Dropdown" => "Liste déroulante à sélection multiple"
// qt.signaturepad: "Signature" => "Signature"
// qt.buttongroup: "Button Group" => "Groupe de boutons"
// ed.defaultLocale: "Default ({0})" => "Valeur par défaut ({0})"
// ed.settingsTooltip: "Open settings" => "Paramètres ouverts"
// ed.surveySettings: "Survey Settings" => "Paramètres de l’enquête"
// ed.surveySettingsTooltip: "Open survey settings" => "Paramètres d’enquête ouverts"
// ed.showPanel: "Show Panel" => "Afficher le panneau"
// ed.hidePanel: "Hide Panel" => "Masquer le panneau"
// ed.prevSelected: "Select previous" => "Sélectionnez précédent"
// ed.nextSelected: "Select next" => "Sélectionnez Suivant"
// ed.surveyTypeName: "Survey" => "Enquête"
// ed.pageTypeName: "Page" => "Page"
// ed.panelTypeName: "Panel" => "Panneau"
// ed.questionTypeName: "Question" => "Question"
// ed.columnTypeName: "Column" => "Colonne"
// ed.themeSurvey: "Themes" => "Thèmes"
// ed.defaultV2Theme: "Default" => "Faire défaut"
// ed.modernTheme: "Modern" => "Moderne"
// ed.defaultTheme: "Default (legacy)" => "Valeur par défaut (héritée)"
// ed.navigateToMsg: "You had to navigate to" => "Vous deviez naviguer vers"
// ed.logic: "Logic" => "Logique"
// ed.saveSurveyTooltip: "Save Survey" => "Enregistrer l’enquête"
// ed.jsonHideErrors: "Hide errors" => "Masquer les erreurs"
// ed.jsonShowErrors: "Show errors" => "Afficher les erreurs"
// ed.undoTooltip: "Undo last change" => "Annuler la dernière modification"
// ed.redoTooltip: "Redo the change" => "Rétablir la modification"
// ed.showMoreChoices: "Show more" => "Afficher plus"
// ed.showLessChoices: "Show less" => "Afficher moins"
// ed.copy: "Copy" => "Copier"
// ed.cut: "Cut" => "Couper"
// ed.paste: "Paste" => "Pâte"
// ed.copyTooltip: "Copy selection to clipboard" => "Copier la sélection dans le presse-papiers"
// ed.cutTooltip: "Cut selection to clipboard" => "Couper la sélection dans le presse-papiers"
// ed.pasteTooltip: "Paste from clipboard" => "Coller à partir du presse-papiers"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "Tapez pour rechercher..."
// ed.toolboxChoiceCategory: "Choice Questions" => "Questions de choix"
// ed.toolboxTextCategory: "Text Input Questions" => "Questions de saisie de texte"
// ed.toolboxContainersCategory: "Containers" => "Conteneurs"
// ed.toolboxMatrixCategory: "Matrix Questions" => "Questions matricielles"
// ed.toolboxMiscCategory: "Misc" => "Divers"
// ed.propertyEditorError: "Error" => "Erreur"
// ed.translationPropertyGridTitle: "Language Settings" => "Paramètres de langue"
// ed.themePropertyGridTitle: "Theme Settings" => "Paramètres du thème"
// ed.translationLanguages: "Languages" => "Traduction"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "Chaînes utilisées uniquement"
// ed.translationPlaceHolder: "Translation..." => "Traduction..."
// ed.themeExportButton: "Export" => "Exportation"
// ed.themeImportButton: "Import" => "Importation"
// ed.selectPage: "Select page..." => "Sélectionner une page..."
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Les choix sont copiés à partir de"
// ed.htmlPlaceHolder: "HTML content will be here." => "Le contenu HTML sera ici."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "Déposez une question de la boîte à outils ici."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Faites glisser et déposez une image ici ou cliquez sur le bouton ci-dessous et choisissez une image à télécharger"
// ed.imageChooseImage: "Choose Image" => "Choisir une image"
// ed.addNewTypeQuestion: "Add {0}" => "Ajouter {0}"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[LOGO]"
// ed.auto: "auto" => "auto"
// ed.choices_Item: "Item " => "Article "
// lg.addNewItem: "Add New Rule" => "Ajouter une nouvelle règle"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "Créez une règle pour personnaliser le flux de l’enquête."
// lg.page_enableName: "Enable (disable) page" => "Activer (désactiver) la page"
// lg.column_visibilityName: "Show (hide) column" => "Afficher (masquer) la colonne"
// lg.column_enableName: "Enable (disable) column" => "Activer (désactiver) la colonne"
// lg.column_requireName: "Make column required" => "Rendre la colonne obligatoire"
// lg.itemEmptyExpressionText: "New rule" => "Nouvelle règle"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "Rendre visible les {0} de la colonne de questions {1}"
// lg.column_enableText: "make column {0} of question {1} enable" => "Activer la {0} de la colonne de questions {1}"
// lg.column_requireText: "make column {0} of question {1} required" => "rendre obligatoire la colonne {0} de la question {1}"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "Valeur de la question claire : {0}"
// lg.showAllQuestions: "All Questions" => "Toutes les questions"
// lg.showAllActionTypes: "All Action Types" => "Tous les types d’action"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Les règles logiques sont incomplètes"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Vous n’avez pas terminé certaines des règles logiques. Si vous quittez l’onglet maintenant, les modifications seront perdues. Voulez-vous toujours quitter l’onglet sans terminer les modifications?"
// lg.uncompletedRule_apply: "Yes" => "Oui"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Non, je veux compléter les règles"
// pe.clear: "Clear" => "Clair"
// pe.saveTooltip: "Save" => "Sauvegarder"
// pe.set: "Set" => "Poser"
// pe.change: "Change" => "Changement"
// pe.refresh: "Refresh" => "Rafraîchir"
// pe.add: "Add" => "Ajouter"
// pe.removeItem: "Click to remove the item..." => "Cliquez pour supprimer l’élément..."
// pe.dragItem: "Drag the item" => "Faire glisser l’élément"
// pe.doneEditing: "Done" => "Fait"
// pe.showChoices: "Show Choices" => "Afficher les choix"
// pe.emptyValue: "Value is empty" => "La valeur est vide"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "La valeur '{0}' n’est pas unique"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "Veuillez limiter le nombre d’articles de {0} à {1}"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "Vous pouvez définir les données au format suivant :\nvaleur1|texte\nvaleur2"
// pe.itemSelectorEmpty: "Please select the element" => "Veuillez sélectionner l’élément"
// pe.conditionActionEmpty: "Please select the action" => "Veuillez sélectionner l’action"
// pe.conditionSelectPage: "Select page..." => "Sélectionner une page..."
// pe.conditionSelectPanel: "Select panel..." => "Sélectionner un panneau..."
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "Prévisualiser les réponses avant de soumettre le sondage"
// pe.overridingPropertyPrefix: "Set by " => "Défini par "
// pe.propertyIsNoUnique: "Please enter a unique value" => "Veuillez saisir une valeur unique"
// pe.propertyNameIsNotUnique: "Please enter a unique name" => "Veuillez saisir un nom unique"
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "N’utilisez pas de mots réservés : « item », « choice », « panel », « row »."
// pe.listIsEmpty@choices: "No choices have been added yet" => "Aucun choix n’a encore été ajouté"
// pe.addNew@choices: "Add a choice" => "Ajouter un choix"
// choicesbyurl.valueName: "Get values from the following JSON field" => "Obtenir des valeurs à partir du champ JSON suivant"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "Obtenir les URL d’image à partir du champ JSON suivant"
// pe.allowEmptyResponse: "Allow empty response" => "Autoriser les réponses vides"
// pe.cols: "Columns" => "Colonnes"
// pe.and: "and" => "et"
// pe.or: "or" => "ou"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Sélectionnez une question pour commencer à configurer les conditions."
// pe.if: "If" => "Si"
// pe.then: "then" => "alors"
// pe.setToName: "Target question" => "Question cible"
// pe.fromName: "Question to copy answer from" => "Question à partir de laquelle copier la réponse"
// pe.gotoName: "Question to skip to" => "Question à passer à"
// pe.ruleIsNotSet: "Rule is incorrect" => "La règle est incorrecte"
// pe.includeIntoResult: "Include into survey results" => "Inclure dans les résultats de l’enquête"
// pe.expandCollapseTitle: "Expand/collapse title" => "Développer/réduire le titre"
// pe.portraitOrientation: "Switch to portrait orientation" => "Passer en orientation portrait"
// pe.previewText: "Preview Answers button text" => "Aperçu du texte du bouton Réponses"
// pe.editText: "Edit Answer button text" => "Modifier le texte du bouton de réponse"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Hauteur de l’image (en valeurs acceptées par CSS)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Largeur de l’image (en valeurs acceptées par CSS)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "Limite de temps pour terminer la page (en secondes)"
// question.page: "Parent page" => "Page parent"
// pe.noEntriesText: "Empty entries text" => "Texte des entrées vides"
// pe.html: "HTML markup" => "Balisage HTML"
// pe.setValue: "Answer" => "Répondre"
// pe.dataFormat: "Image format" => "Format de l’image"
// pe.allowAddRows: "Allow adding rows" => "Autoriser l’ajout de lignes"
// pe.allowRemoveRows: "Allow removing rows" => "Autoriser la suppression de lignes"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "Autoriser le glisser-déposer de lignes"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "Ne s’applique pas si vous spécifiez la largeur ou la hauteur exacte de l’image."
// pe.minImageWidth: "Minimum image width" => "Largeur minimale de l’image"
// pe.maxImageWidth: "Maximum image width" => "Largeur maximale de l’image"
// pe.minImageHeight: "Minimum image height" => "Hauteur minimale de l’image"
// pe.maxImageHeight: "Maximum image height" => "Hauteur maximale de l’image"
// surveyvalidator.text: "Error message" => "Message d'erreur"
// surveyvalidator.expression: "Validation expression" => "Expression de validation"
// pe.logo: "Logo (URL or base64-encoded string)" => "Logo (URL ou chaîne codée en base64)"
// pe.questionsOnPageMode: "Survey structure" => "Structure de l’enquête"
// pe.maxTextLength: "Maximum answer length (in characters)" => "Longueur maximale de réponse (en caractères)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "Longueur maximale des commentaires (en caractères)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "Développer automatiquement la zone de commentaires si nécessaire"
// pe.allowResizeComment: "Allow users to resize text areas" => "Autoriser les utilisateurs à redimensionner les zones de texte"
// pe.textUpdateMode: "Update text question value" => "Mettre à jour la valeur de la question textuelle"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "Concentrez-vous sur la première réponse non valide"
// pe.checkErrorsMode: "Run validation" => "Exécuter la validation"
// pe.navigateToUrl: "Navigate to URL" => "Accédez à URL"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "URL dynamique"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "Balisage pour indiquer si l’utilisateur a déjà rempli cette enquête"
// pe.completedHtml: "Survey Complete page markup" => "Balisage de page Enquête terminée"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "Balisage de page Dynamic Survey Complete"
// pe.loadingHtml: "Markup to show while survey model is loading" => "Balisage à afficher pendant le chargement du modèle d’enquête"
// pe.commentText: "Comment area text" => "Texte de la zone de commentaires"
// pe.autocomplete: "Autocomplete type" => "Type de saisie semi-automatique"
// pe.labelTrue: "\"True\" label" => "Étiquette « vraie »"
// pe.labelFalse: "\"False\" label" => "Étiquette « Faux »"
// pe.allowClear: "Show the Clear button" => "Afficher le bouton Effacer"
// pe.displayStyle: "Value display style" => "Style d’affichage de la valeur"
// pe.format: "Formatted string" => "Chaîne mise en forme"
// pe.maximumFractionDigits: "Maximum fractional digits" => "Nombre maximal de chiffres fractionnaires"
// pe.minimumFractionDigits: "Minimum fractional digits" => "Nombre minimum de fractions"
// pe.useGrouping: "Display grouping separators" => "Séparateurs de groupes d’affichage"
// pe.allowMultiple: "Allow multiple files" => "Autoriser plusieurs fichiers"
// pe.allowImagesPreview: "Preview images" => "Prévisualiser les images"
// pe.acceptedTypes: "Accepted file types" => "Types de fichiers acceptés"
// pe.waitForUpload: "Wait for the upload to complete" => "Attendez la fin du téléchargement"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "Confirmer la suppression du fichier"
// pe.detailPanelMode: "Detail panel location" => "Emplacement du panneau de détails"
// pe.minRowCount: "Minimum row count" => "Nombre minimal de lignes"
// pe.maxRowCount: "Maximum row count" => "Nombre maximal de lignes"
// pe.confirmDelete: "Confirm row deletion" => "Confirmer la suppression de lignes"
// pe.confirmDeleteText: "Confirmation message" => "Message de confirmation"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "Confirmer la suppression du panneau"
// pe.panelCount: "Initial panel count" => "Nombre initial de panels"
// pe.minPanelCount: "Minimum panel count" => "Nombre minimal de panneaux"
// pe.maxPanelCount: "Maximum panel count" => "Nombre maximal de panneaux"
// pe.panelsState: "Inner panel expand state" => "État d’expansion du panneau intérieur"
// pe.templateDescription: "Description template" => "Modèle de description"
// pe.templateTitle: "Title template" => "Modèle de titre"
// pe.panelPrevText: "Previous Panel button tooltip" => "Info-bulle précédente du bouton Panneau"
// pe.panelNextText: "Next Panel button tooltip" => "Info-bulle du bouton Panneau suivant"
// pe.showRangeInProgress: "Show progress bar" => "Afficher la barre de progression"
// pe.templateTitleLocation: "Question title location" => "Emplacement du titre de la question"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "Supprimer l’emplacement du bouton Panneau"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "Masquer la question s’il n’y a pas de lignes"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Masquer les colonnes s’il n’y a pas de lignes"
// pe.rateValues: "Custom rate values" => "Valeurs de taux personnalisées"
// pe.rateCount: "Rate count" => "Nombre de taux"
// pe.autoGenerate: "How to specify rate values?" => "Comment spécifier les valeurs de taux?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "Masquer la question si elle ne contient pas de choix"
// pe.hideNumber: "Hide question number" => "Masquer le numéro de la question"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Largeur minimale (en valeurs acceptées par CSS)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Largeur maximale (en valeurs acceptées par CSS)"
// pe.width: "Width (in CSS-accepted values)" => "Largeur (en valeurs acceptées par CSS)"
// pe.showHeader: "Show column headers" => "Afficher les en-têtes de colonne"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Afficher la barre de défilement horizontale"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Largeur minimale de colonne (en valeurs acceptées par CSS)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Largeur de l’en-tête de ligne (en valeurs acceptées par CSS)"
// pe.valueTrue: "\"True\" value" => "Valeur « vraie »"
// pe.valueFalse: "\"False\" value" => "Valeur « False »"
// pe.minErrorText: "\"Value is below minimum\" error message" => "Message d’erreur « La valeur est inférieure au minimum »"
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "Message d’erreur « La valeur dépasse le maximum »"
// pe.otherErrorText: "\"Empty comment\" error message" => "Message d’erreur « Commentaire vide »"
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "Message d’erreur « Valeur de clé non unique »"
// pe.minSelectedChoices: "Minimum selected choices" => "Choix minimum sélectionnés"
// pe.maxSelectedChoices: "Maximum selected choices" => "Nombre maximal de choix sélectionnés"
// pe.showClearButton: "Show the Clear button" => "Afficher le bouton Effacer"
// pe.showNumber: "Show panel number" => "Afficher le numéro du panneau"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "Largeur du logo (en valeurs acceptées par CSS)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "Hauteur du logo (en valeurs acceptées par CSS)"
// pe.readOnly: "Read-only" => "Lecture seule"
// pe.enableIf: "Editable if" => "Modifiable si"
// pe.emptyRowsText: "\"No rows\" message" => "Message « Aucune ligne »"
// pe.size: "Input field size (in characters)" => "Taille du champ d’entrée (en caractères)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "Choix spéciaux distincts (Aucun, Autre, Sélectionner tout)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Choix de copie de la question suivante"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Quels choix copier ?"
// pe.showCommentArea: "Show the comment area" => "Afficher la zone de commentaires"
// pe.commentPlaceholder: "Comment area placeholder" => "Espace réservé pour la zone de commentaires"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Afficher les descriptions de taux sous forme de valeurs extrêmes"
// pe.rowsOrder: "Row order" => "Ordre des lignes"
// pe.columnsLayout: "Column layout" => "Disposition des colonnes"
// pe.columnColCount: "Nested column count" => "Nombre de colonnes imbriquées"
// pe.state: "Panel expand state" => "État de développement du panneau"
// pe.correctAnswer: "Correct Answer" => "Réponse correcte"
// pe.defaultPanelValue: "Default Values" => "Valeurs par défaut"
// pe.cells: "Cell Texts" => "Textes cellulaires"
// pe.keyName: "Key column" => "Colonne clé"
// itemvalue.text: "Alt text" => "Texte de remplacement"
// tabs.items: "Items" => "Articles"
// tabs.numbering: "Numbering" => "Numérotation"
// tabs.pages: "Pages" => "Pages"
// tabs.showOnCompleted: "Survey Complete" => "Sondage terminé"
// tabs.slider: "Slider" => "Glisseur"
// tabs.expression: "Expression" => "Expression"
// pe.choicesVisibleIf: "Choices are visible if" => "Les choix sont visibles si"
// pe.choicesEnableIf: "Choices are selectable if" => "Les choix sont sélectionnables si"
// pe.columnsEnableIf: "Columns are visible if" => "Les colonnes sont visibles si"
// pe.rowsEnableIf: "Rows are visible if" => "Les lignes sont visibles si"
// pe.indent: "Add indents" => "Ajouter des retraits"
// panel.indent: "Add outer indents" => "Ajouter des retraits externes"
// pe.innerIndent: "Add inner indents" => "Ajouter des retraits internes"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "Prendre les valeurs par défaut de la dernière ligne"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "Prendre les valeurs par défaut du dernier panneau"
// pe.titleKeyboardAdornerTip: "Press enter button to edit" => "Appuyez sur le bouton Entrée pour modifier"
// pe.keyboardAdornerTip: "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item" => "Appuyez sur le bouton Entrée pour modifier l’élément, appuyez sur le bouton Supprimer pour supprimer l’élément, appuyez sur alt plus flèche vers le haut ou flèche vers le bas pour déplacer l’élément"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "Tapez expression ici..."
// pe.noFile: "No file choosen" => "Aucun fichier choisi"
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "Effacer la valeur si la question devient masquée"
// pe.valuePropertyName: "Value property name" => "Nom de la propriété Value"
// pe.searchEnabled: "Enable search" => "Activer la recherche"
// pe.hideSelectedItems: "Hide selected items" => "Masquer les éléments sélectionnés"
// pe.closeOnSelect: "Close the dropdown after selection" => "Fermer la liste déroulante après la sélection"
// pe.signatureWidth: "Signature width" => "Largeur de la signature"
// pe.signatureHeight: "Signature height" => "Hauteur de signature"
// pe.verticalAlign: "Vertical alignment" => "Alignement vertical"
// pe.alternateRows: "Alternate rows" => "Lignes alternées"
// pe.columnsVisibleIf: "Columns are visible if" => "Les colonnes sont visibles si"
// pe.rowsVisibleIf: "Rows are visible if" => "Les lignes sont visibles si"
// pe.otherPlaceholder: "Comment area placeholder" => "Espace réservé pour la zone de commentaires"
// pe.rateType: "Rate type" => "Type de tarif"
// pv.true: "true" => "vrai"
// pv.false: "false" => "faux"
// pv.decimal: "decimal" => "décimal"
// pv.currency: "currency" => "monnaie"
// pv.percent: "percent" => "pour cent"
// pv.onpanel: "Start on each panel" => "Commencez sur chaque panneau"
// pv.tab: "Tabs" => "Onglets"
// pv.horizontal: "Horizontal" => "Horizontal"
// pv.vertical: "Vertical" => "Vertical"
// pv.right: "Right" => "Droite"
// pv.color: "color" => "Couleur"
// pv.date: "date" => "date"
// pv.datetime: "datetime" => "dateheure"
// pv.datetime-local: "datetime-local" => "dateheure-local"
// pv.email: "email" => "Messagerie électronique"
// pv.month: "month" => "mois"
// pv.number: "number" => "nombre"
// pv.password: "password" => "mot de passe"
// pv.range: "range" => "gamme"
// pv.tel: "tel" => "Tél"
// pv.text: "text" => "SMS"
// pv.time: "time" => "Heure"
// pv.url: "url" => "URL"
// pv.week: "week" => "semaine"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "Lorsque la question ou son panneau/page devient masqué"
// clearInvisibleValues.none: "Never" => "Jamais"
// inputType.color: "Color" => "Couleur"
// inputType.date: "Date" => "Date"
// inputType.datetime-local: "Date and Time" => "Date et heure"
// inputType.email: "Email" => "Messagerie électronique"
// inputType.month: "Month" => "Mois"
// inputType.number: "Number" => "Nombre"
// inputType.password: "Password" => "Mot de passe"
// inputType.range: "Range" => "Gamme"
// inputType.tel: "Phone Number" => "Numéro de téléphone"
// inputType.text: "Text" => "SMS"
// inputType.time: "Time" => "Heure"
// inputType.url: "URL" => "URL"
// inputType.week: "Week" => "Semaine"
// pv.onNextPage: "When switching to the next page" => "Lors du passage à la page suivante"
// pv.onValueChanged: "After an answer is changed" => "Après la modification d’une réponse"
// pv.onValueChanging: "Before an answer is changed" => "Avant qu’une réponse ne soit modifiée"
// pv.standard: "Original structure" => "Structure originale"
// pv.singlePage: "All questions on a single page" => "Toutes les questions sur une seule page"
// pv.questionPerPage: "Each question on an individual page" => "Chaque question sur une page individuelle"
// pv.noPreview: "No preview" => "Pas d’aperçu"
// pv.showAllQuestions: "Show all questions" => "Afficher toutes les questions"
// pv.showAnsweredQuestions: "Show answered questions only" => "Afficher uniquement les réponses aux questions"
// pv.pages: "Completed pages" => "Pages complétées"
// pv.questions: "Answered questions" => "Questions répondues"
// pv.requiredQuestions: "Answered required questions" => "Réponses aux questions requises"
// pv.correctQuestions: "Valid answers" => "Réponses valides"
// pv.buttons: "Completed pages (button UI)" => "Pages terminées (bouton UI)"
// pv.underInput: "Under the input" => "Sous l’entrée"
// pv.underTitle: "Under the title" => "Sous le titre"
// pv.onBlur: "On blur" => "Sur le flou"
// pv.onTyping: "While typing" => "Pendant la saisie"
// pv.underRow: "Under the row" => "Sous la rangée"
// pv.underRowSingle: "Under the row, only one panel is visible" => "Sous la ligne, un seul panneau est visible"
// showNavigationButtons.none: "Hidden" => "Caché"
// showProgressBar.off: "Hidden" => "Caché"
// showTimerPanel.none: "Hidden" => "Caché"
// showTimerPanelMode.all: "Both" => "Les deux"
// detailPanelMode.none: "Hidden" => "Caché"
// addRowLocation.default: "Depends on matrix layout" => "Dépend de la disposition de la matrice"
// panelsState.default: "Users cannot expand or collapse panels" => "Les utilisateurs ne peuvent pas agrandir ou réduire les panneaux"
// panelsState.collapsed: "All panels are collapsed" => "Tous les panneaux sont réduits"
// panelsState.expanded: "All panels are expanded" => "Tous les panneaux sont agrandis"
// widthMode.auto: "Auto" => "Auto"
// widthMode.static: "Static" => "Statique"
// widthMode.responsive: "Responsive" => "Sensible"
// imageFit.none: "None" => "Aucun"
// imageFit.contain: "Contain" => "Contenir"
// imageFit.cover: "Cover" => "Couvrir"
// imageFit.fill: "Fill" => "Remplir"
// contentMode.auto: "Auto" => "Auto"
// contentMode.image: "Image" => "Image"
// contentMode.video: "Video" => "Vidéo"
// contentMode.youtube: "YouTube" => "Youtube"
// displayMode.auto: "Auto" => "Auto"
// displayMode.buttons: "Buttons" => "Boutons"
// displayMode.dropdown: "Dropdown" => "Liste déroulante"
// rateColorMode.default: "Default" => "Faire défaut"
// autoGenerate.true: "Generate" => "Générer"
// autoGenerate.false: "Enter manually" => "Saisie manuelle"
// rateType.labels: "Labels" => "Étiquettes"
// rateType.stars: "Stars" => "Étoiles"
// rateType.smileys: "Smileys" => "Smileys"
// op.and: "and" => "et"
// op.or: "or" => "ou"
// ew.modern: "Modern theme" => "Thème moderne"
// ew.default: "Default theme" => "Thème par défaut"
// ew.orange: "Orange theme" => "Thème orange"
// ew.darkblue: "Darkblue theme" => "Thème bleu foncé"
// ew.darkrose: "Darkrose theme" => "Thème Darkrose"
// ew.stone: "Stone theme" => "Thème de la pierre"
// ew.winter: "Winter theme" => "Thème d’hiver"
// ew.winterstone: "Winter-Stone theme" => "Thème Winter-Stone"
// ts.hideInvisibleElements: "Hide invisible elements" => "Masquer les éléments invisibles"
// validators.expressionvalidator: "Expression" => "Expression"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Les cookies empêchent les utilisateurs de remplir deux fois la même enquête."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Redimensionne la zone visible du champ de saisie. Veuillez utiliser le paramètre <b>Validation → Longueur maximale</b> pour limiter la longueur d’entrée."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Utilisez {0} comme espace réservé pour la valeur réelle."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Visible uniquement lorsqu’au moins une colonne a un type Total ou une expression Total."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Reportez-vous à la description de l’attribut [accept](https://www.w3schools.com/tags/att_input_accept.asp) pour plus d’informations."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Applicable uniquement aux types de cellules Radiogroup et Checkbox."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Reportez-vous à la description de l’attribut [saisie semi-automatique](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/saisie semi-automatique) pour plus d’informations."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Si vous ne définissez pas cette propriété, la réponse sera stockée dans un champ spécifié par la propriété Name."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Si la colonne spécifiée contient des valeurs identiques, l’enquête renvoie l’erreur « Valeur de clé non unique »."
// p.multiSelect: "Allow multiple selection" => "Autoriser la sélection multiple"
// p.showLabel: "Show image captions" => "Afficher les légendes des images"
// p.value: "Value" => "Valeur"
// p.tabAlign: "Tab alignment" => "Alignement des tabulations"
// p.logoFit: "Logo fit" => "Ajustement du logo"
// p.pages: "Pages" => "Pages"
// p.questions: "Questions" => "Questionne"
// p.calculatedValues: "Calculated values" => "Valeurs calculées"
// p.surveyId: "Survey id" => "ID de l’enquête"
// p.surveyPostId: "Survey post id" => "ID de l’article de l’enquête"
// p.surveyShowDataSaving: "Survey show data saving" => "L’enquête montre l’économie de données"
// p.questionDescriptionLocation: "Question description location" => "Description de la question emplacement"
// p.progressBarType: "Progress bar type" => "Type de barre de progression"
// p.showTOC: "Show TOC" => "Afficher la table des matières"
// p.tocLocation: "Toc location" => "Emplacement de Toc"
// p.questionTitlePattern: "Question title pattern" => "Modèle de titre de question"
// p.widthMode: "Width mode" => "Mode largeur"
// p.showBrandInfo: "Show brand info" => "Afficher les informations sur la marque"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "Utiliser des valeurs d’affichage dans des textes dynamiques"
// p.descriptionLocation: "Description location" => "Description de l’emplacement"
// p.defaultValueExpression: "Default value expression" => "Expression de valeur par défaut"
// p.requiredIf: "Required if" => "Obligatoire si"
// p.bindings: "Bindings" => "Liaisons"
// p.renderAs: "Render as" => "Rendu en tant que"
// p.attachOriginalItems: "Attach original items" => "Joindre des éléments originaux"
// p.cellHint: "Cell hint" => "Indice de cellule"
// p.isUnique: "Is unique" => "Est unique"
// p.showInMultipleColumns: "Show in multiple columns" => "Afficher en plusieurs colonnes"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Total des chiffres de fraction maximale"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Nombre total de fractions minimales"
// p.detailElements: "Detail elements" => "Éléments de détail"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Autoriser les actions adaptatives"
// p.defaultRowValue: "Default row value" => "Valeur de ligne par défaut"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "Affichage du panneau de détail lors de l’ajout"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Choix de chargement paresseux activé"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Choix de taille de page de chargement paresseux"
// p.inputFieldComponent: "Input field component" => "Composant de champ d’entrée"
// p.itemComponent: "Item component" => "Composant d’article"
// p.min: "Min" => "Min"
// p.max: "Max" => "Max"
// p.minValueExpression: "Min value expression" => "Expression de valeur min"
// p.maxValueExpression: "Max value expression" => "Expression de valeur maximale"
// p.step: "Step" => "Pas"
// p.dataList: "Data list" => "Liste de données"
// p.elements: "Elements" => "Éléments"
// p.content: "Content" => "Contenu"
// p.navigationTitle: "Navigation title" => "Titre de navigation"
// p.navigationDescription: "Navigation description" => "Description de la navigation"
// p.longTap: "Long tap" => "Appuyez longuement"
// p.autoGrow: "Auto grow" => "Croissance automatique"
// p.allowResize: "Allow resizing" => "Autoriser le redimensionnement"
// p.acceptCarriageReturn: "Accept carriage return" => "Accepter le retour chariot"
// p.displayMode: "Display mode" => "Mode d’affichage"
// p.rateType: "Rate type" => "Type de tarif"
// p.contentMode: "Content mode" => "Mode de contenu"
// p.imageFit: "Image fit" => "Ajustement de l’image"
// p.altText: "Alt text" => "Texte de remplacement"
// p.height: "Height" => "Hauteur"
// p.penColor: "Pen color" => "Couleur du stylo"
// p.backgroundColor: "Background color" => "Couleur d’arrière-plan"
// p.templateElements: "Template elements" => "Éléments de modèle"
// p.operator: "Operator" => "Opérateur"
// p.isVariable: "Is variable" => "Est variable"
// p.runExpression: "Run expression" => "Exécuter l’expression"
// p.showCaption: "Show caption" => "Afficher la légende"
// p.iconName: "Icon name" => "Nom de l’icône"
// p.iconSize: "Icon size" => "Taille de l’icône"
// p.precision: "Precision" => "Précision"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Zone de poignée de glissement matriciel"
// p.backgroundImage: "Background image" => "Image d’arrière-plan"
// p.backgroundImageFit: "Background image fit" => "Ajustement de l’image d’arrière-plan"
// p.backgroundImageAttachment: "Background image attachment" => "Pièce jointe à l’image d’arrière-plan"
// p.backgroundOpacity: "Background opacity" => "Opacité de l’arrière-plan"
// p.selectToRankEnabled: "Select to rank enabled" => "Sélectionner pour classer activé"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Sélectionner pour classer la disposition des zones"
// p.allowCameraAccess: "Allow camera access" => "Autoriser l’accès à la caméra"
// p.scaleColorMode: "Scale color mode" => "Mode de couleur de mise à l’échelle"
// p.rateColorMode: "Rate color mode" => "Évaluer le mode de couleur"
// p.templateTabTitle: "Template tab title" => "Titre de l’onglet Modèle"
// p.templateVisibleIf: "Template visible if" => "Modèle visible si"
// p.copyDisplayValue: "Copy display value" => "Copier la valeur d’affichage"
// theme.--background: "Background color" => "Couleur d’arrière-plan"
// theme.--background-dim-light: "Background dim light color" => "Couleur de lumière faible d’arrière-plan"
// theme.--primary-foreground: "Primary foreground color" => "Couleur de premier plan primaire"
// theme.--foreground: "Foreground color" => "Couleur de premier plan"
// theme.--base-unit: "Base unit" => "Unité de base"
// theme.groupAdvanced: "Advanced" => "Avancé"
// theme.themeName: "Theme" => "Thème"
// theme.isPanellessss: "Question appearance" => "Apparence de la question"
// theme.isPanellessPanels: "Default" => "Faire défaut"
// theme.isPanellessLightweight: "Without Panels" => "Sans panneaux"
// theme.themePaletteLight: "Light" => "Lumière"
// theme.themePaletteDark: "Dark" => "Sombre"
// theme.primaryColor: "Accent color" => "Couleur d’accentuation"
// theme.primaryDefaultColor: "Default" => "Faire défaut"
// theme.primaryDarkColor: "Hover" => "Flotter"
// theme.primaryLightColor: "Selected" => "Sélectionné"
// theme.backgroundDimColor: "Background color" => "Couleur d’arrière-plan"
// theme.backgroundImage: "Background image" => "Image d’arrière-plan"
// theme.backgroundImageFitAuto: "Auto" => "Auto"
// theme.backgroundImageFitCover: "Cover" => "Couvrir"
// theme.backgroundImageFitContain: "Contain" => "Contenir"
// theme.backgroundOpacity: "Opacity" => "Opacité"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Fixe"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Faire défiler"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Opacité de l’arrière-plan du panneau"
// theme.questionBackgroundTransparency: "Question background opacity" => "Opacité de l’arrière-plan de la question"
// theme.questionPanel: "Panel background and corner radius" => "Arrière-plan du panneau et rayon d’angle"
// theme.questionTitle: "Question title font" => "Police du titre de la question"
// theme.questionDescription: "Question description font" => "Police de description de la question"
// theme.editorPanel: "Input element" => "Elément d’entrée"
// theme.editorFont: "Input element font" => "Police de l’élément d’entrée"
// theme.backcolor: "Default background" => "Arrière-plan par défaut"
// theme.hovercolor: "Hover background" => "Arrière-plan du survol"
// theme.borderDecoration: "Border decoration" => "Décoration de bordure"
// theme.accentBackground: "Accent background" => "Arrière-plan d’accent"
// theme.accentForeground: "Accent foreground" => "Accent au premier plan"
// theme.primaryForecolor: "Default color" => "Couleur par défaut"
// theme.primaryForecolorLight: "Disabled color" => "Couleur désactivée"
// theme.linesColors: "Minor line colors" => "Couleurs de trait mineures"
// theme.borderDefault: "Darker" => "Sombre"
// theme.borderLight: "Lighter" => "Briquet"
// theme.fontFamily: "Font family" => "Famille de polices"
// theme.fontSize: "Font size" => "Taille de police"
// theme.color: "Color" => "Couleur"
// theme.size: "Size" => "Taille"
// theme.fontWeightRegular: "Regular" => "Régulier"
// theme.fontWeightHeavy: "Heavy" => "Lourd"
// theme.fontWeightSemiBold: "Semi-bold" => "Semi-gras"
// theme.fontWeightBold: "Bold" => "Audacieux"
// theme.scale: "Scale" => "Écaille"
// theme.cornerRadius: "Corner radius" => "Rayon d’angle"
// theme.surveyTitleFont: "Survey title font" => "Police du titre de l’enquête"
// theme.pageTitle: "Page title font" => "Police du titre de la page"
// theme.pageDescription: "Page description font" => "Police de description de page"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Ajouter un effet d’ombre"
// theme.opacity: "Opacity" => "Opacité"
// theme.boxShadowBlur: "Blur" => "Brouiller"
// theme.boxShadowSpread: "Spread" => "Propagation"
// theme.boxShadowDrop: "Drop" => "Goutte"
// theme.boxShadowInner: "Inner" => "Intérieur"
// theme.questionShadow: "Shadow effects" => "Effets d’ombre"
// theme.editorShadow: "Input element shadow effects" => "Effets d’ombre de l’élément d’entrée"
// names.default: "Default" => "Faire défaut"
// names.contrast: "Contrast" => "Contraste"
// names.plain: "Plain" => "Plaine"
// names.simple: "Simple" => "Simple"
// names.blank: "Blank" => "Blanc"
// names.double: "Double" => "Double"
// names.bulk: "Bulk" => "Vrac"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo 3D"
// names.playful: "Playful" => "Enjoué"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Sarcelle"
// colors.blue: "Blue" => "Bleu"
// colors.purple: "Purple" => "Pourpre"
// colors.orchid: "Orchid" => "Orchidée"
// colors.tulip: "Tulip" => "Tulipe"
// colors.brown: "Brown" => "Marron"
// colors.green: "Green" => "Vert"
// names.sharp: "Sharp" => "Tranchant"
// names.borderless: "Borderless" => "Borderless"
// names.flat: "Flat" => "Plat"
// names.doubleborder: "Double Border" => "Double bordure"
// names.layered: "Layered" => "Couches"
// names.solid: "Solid" => "Solide"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Êtes-vous certain de vouloir supprimer toutes les chaînes pour cette langue ?"
// ed.themeResetButton: "Reset theme settings to default" => "Réinitialiser les paramètres de thème par défaut"
// theme.placeholderColor: "Placeholder color" => "Couleur de l’espace réservé"
// ed.themeSettings: "Theme Settings" => "Paramètres du thème"
// ed.themeSettingsTooltip: "Open theme settings" => "Ouvrir les paramètres du thème"
// pe.resetToDefaultCaption: "Reset" => "Réinitialisation"
// pv.file: "Local files" => "Fichiers locaux"
// pv.camera: "Camera" => "Caméra"
// pv.file-camera: "Local files or camera" => "Fichiers locaux ou caméra"
// ed.translateUsigAI: "Auto-translate All" => "Traduire automatiquement tout"
// ed.translationDialogTitle: "Untranslated strings" => "Chaînes non traduites"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Veuillez saisir au moins {0} éléments"
// lg.question_resetValueName: "Reset question value" => "Réinitialiser la valeur de la question"
// lg.column_resetValue: "Reset column value" => "Réinitialiser la valeur de la colonne"
// pe.markRequired: "Mark as required" => "Marquer au besoin"
// pe.removeRequiredMark: "Remove the required mark" => "Supprimer la marque requise"
// p.resetValueIf: "Reset value if" => "Réinitialiser la valeur si"
// lg.question_setValueName: "Set question value" => "Définir la valeur de la question"
// lg.column_resetValueName: "Reset column value" => "Réinitialiser la valeur de la colonne"
// lg.column_setValueName: "Set column value" => "Définition de la valeur de colonne"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Expression dont le résultat sera affecté à la question cible."
// p.setValueIf: "Set value if" => "Définir la valeur si"
// theme.header: "Header" => "En-tête"
// theme.backgroundImageFitFill: "Stretch" => "Étirer"
// theme.backgroundImageFitTile: "Tile" => "Carreau"
// theme.headerView: "View" => "Vue"
// theme.headerViewBasic: "Basic" => "Basique"
// theme.headerViewAdvanced: "Advanced" => "Avancé"
// theme.headerInheritWidthFrom: "Content area width" => "Largeur de la zone de contenu"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Identique à l’enquête"
// theme.headerInheritWidthFromPage: "Fit to page" => "Ajuster à la page"
// theme.headerTextAreaWidth: "Text width" => "Largeur du texte"
// theme.headerBackgroundColorSwitch: "Background color" => "Couleur d’arrière-plan"
// theme.headerBackgroundColorNone: "None" => "Aucun"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Couleur d’accentuation"
// theme.headerBackgroundColorCustom: "Custom" => "Coutume"
// theme.horizontalAlignmentLeft: "Left" => "Gauche"
// theme.horizontalAlignmentCenter: "Center" => "Centre"
// theme.horizontalAlignmentRight: "Right" => "Droite"
// theme.verticalAlignmentTop: "Top" => "Retour au début"
// theme.verticalAlignmentMiddle: "Middle" => "Milieu"
// theme.verticalAlignmentBottom: "Bottom" => "Fond"
// theme.headerTitlePosition: "Title Position" => "Position du titre"
// theme.headerDescriptionPosition: "Description Position" => "Description du poste"
// lg.question_resetValueText: "reset value for question: {0}" => "Réinitialisez la valeur pour la question : {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Attribuer une valeur : {1} à la question : {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Réinitialiser la valeur de la cellule pour la colonne : {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Affecter la valeur de la cellule : {1} à la colonne : {0}"
// ed.surveyJsonExportButton: "Export" => "Exportation"
// ed.surveyJsonImportButton: "Import" => "Importation"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Copier dans le Presse-papiers"
// pe.filePlaceholder: "File placeholder text" => "Texte de l’espace réservé au fichier"
// pe.photoPlaceholder: "Photo placeholder text" => "Texte de l’espace réservé à la photo"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Texte de l’espace réservé au fichier ou à la photo"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "S’applique lorsque le « Type de source » est « Fichiers locaux » ou lorsque l’appareil photo n’est pas disponible"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "S’applique lorsque le «Type de source» est «Appareil photo»."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "S’applique lorsque le «Type de source» est «Fichiers locaux ou appareil photo»."
// theme.background: "Background" => "Arrière-plan"
// theme.appearance: "Appearance" => "Apparence"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Voulez-vous vraiment réinitialiser le thème ? Toutes vos personnalisations seront perdues."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Oui, réinitialisez le thème"
// theme.headerInheritWidthFromContainer: "Fit to container" => "S’adapte au conteneur"
// signaturepad.showPlaceholder: "Show the placeholder" => "Afficher l’espace réservé"
// signaturepad.placeholder: "Placeholder text" => "Texte d’espace réservé"
// theme.surveyDescriptionFont: "Survey description font" => "Police de description de l’enquête"
// ed.prevFocus: "Focus previous" => "Mise au point précédente"
// ed.nextFocus: "Focus next" => "Focus suivant"
// ed.saveTheme: "Save Theme" => "Enregistrer le thème"
// ed.saveThemeTooltip: "Save Theme" => "Enregistrer le thème"
// lg.page_requireName: "Make page required" => "Rendre la page obligatoire"
// lg.panel_requireName: "Make page required" => "Rendre la page obligatoire"
// signaturepad.signatureWidth: "Signature area width" => "Largeur de la zone de signature"
// signaturepad.signatureHeight: "Signature area height" => "Hauteur de la zone de signature"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Mise à l’échelle automatique de la zone de signature"
// signaturepad.penMinWidth: "Minimum pen width" => "Largeur minimale du stylo"
// signaturepad.penMaxWidth: "Maximum pen width" => "Largeur maximale du stylo"
// theme.logoPosition: "Logo position" => "Position du logo"
// ed.propertyGridNoResultsFound: "No results found" => "Aucun résultat trouvé"
// pv.leftRight: "Left and right" => "Gauche et droite"
// p.sourceType: "Source type" => "Type de source"
// p.fitToContainer: "Fit to container" => "S’adapte au conteneur"
// p.setValueExpression: "Set value expression" => "Définir l’expression de valeur"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Les choix sont chargés à partir d’un service Web."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Accédez aux paramètres"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Aperçu des options de choix chargées"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Éviter les réponses dupliquées dans les lignes"
// theme.advancedMode: "Advanced mode" => "Mode avancé"
// theme.backgroundCornerRadius: "Background and corner radius" => "Arrière-plan et rayon d’angle"
// theme.colorsTitle: "Colors" => "Couleurs"
// theme.font: "Font" => "Police"
// theme.lines: "Lines" => "Lignes"
// theme.titleFont: "Title font" => "Police du titre"
// theme.descriptionFont: "Description font" => "Police de description"
// theme.shadow: "Shadow effects" => "Effets d’ombre"
// ed.translateUsigAIFrom: "Translate from: " => "Traduction: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Autoriser l’option Refuser de répondre"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Autoriser l’option Ne sait pas"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Autoriser l’option Refuser de répondre"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Autoriser l’option Ne sait pas"
// pv.contain: "Contain" => "Contenir"
// pv.cover: "Cover" => "Couvrir"
// pv.fill: "Fill" => "Remplir"
// pe.transposeData: "Transpose rows to columns" => "Transposer des lignes en colonnes"
// layout.panel: "Layout" => "Disposition"
// layout.question: "Layout" => "Disposition"
// layout.base: "Layout" => "Disposition"
// panel.name: "Panel name" => "Nom du panneau"
// panel.title: "Panel title" => "Titre du panneau"
// panel.description: "Panel description" => "Description du panneau"
// panel.visibleIf: "Make the panel visible if" => "Rendre le panneau visible si"
// panel.requiredIf: "Make the panel required if" => "Rendez le panneau requis si"
// panel.questionsOrder: "Question order within the panel" => "Ordre des questions au sein du panel"
// panel.startWithNewLine: "Display the panel on a new line" => "Afficher le panneau sur une nouvelle ligne"
// panel.state: "Panel collapse state" => "État de réduction du panneau"
// panel.width: "Inline panel width" => "Largeur du panneau en ligne"
// panel.minWidth: "Minimum panel width" => "Largeur minimale du panneau"
// panel.maxWidth: "Maximum panel width" => "Largeur maximale du panneau"
// panel.showNumber: "Number panels" => "Panneaux numériques"
// paneldynamic.name: "Panel name" => "Nom du panneau"
// paneldynamic.title: "Panel title" => "Titre du panneau"
// paneldynamic.description: "Panel description" => "Description du panneau"
// paneldynamic.visibleIf: "Make the panel visible if" => "Rendre le panneau visible si"
// paneldynamic.requiredIf: "Make the panel required if" => "Rendez le panneau requis si"
// paneldynamic.page: "Move the panel to page" => "Déplacer le panneau vers la page"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Afficher le panneau sur une nouvelle ligne"
// paneldynamic.state: "Panel collapse state" => "État de réduction du panneau"
// paneldynamic.width: "Inline panel width" => "Largeur du panneau en ligne"
// paneldynamic.minWidth: "Minimum panel width" => "Largeur minimale du panneau"
// paneldynamic.maxWidth: "Maximum panel width" => "Largeur maximale du panneau"
// paneldynamic.templateDescription: "Panel description pattern" => "Modèle de description du panneau"
// paneldynamic.templateTitle: "Panel title pattern" => "Modèle de titre de panneau"
// paneldynamic.noEntriesText: "Empty panel text" => "Texte du panneau vide"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Modèle de titre de tabulation"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Rendre un panneau individuel visible si :"
// paneldynamic.hideNumber: "Hide the panel number" => "Masquer le numéro du panneau"
// paneldynamic.titleLocation: "Panel title alignment" => "Alignement du titre du panneau"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Alignement de la description du panneau"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Alignement du titre de la question"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Alignement des messages d’erreur"
// paneldynamic.newPanelPosition: "New panel location" => "Nouvel emplacement du panneau"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Éviter les réponses en double à la question suivante"
// question.name: "Question name" => "Nom de la question"
// question.title: "Question title" => "Titre de la question"
// question.description: "Question description" => "Description de la question"
// question.visibleIf: "Make the question visible if" => "Rendez la question visible si"
// question.requiredIf: "Make the question required if" => "Faites en sorte que la question soit obligatoire si"
// question.state: "Question box collapse state" => "État de réduction de la zone de question"
// question.hideNumber: "Hide the question number" => "Masquer le numéro de la question"
// question.titleLocation: "Question title alignment" => "Alignement du titre de la question"
// question.descriptionLocation: "Question description alignment" => "Alignement de la description de la question"
// question.errorLocation: "Error message alignment" => "Alignement des messages d’erreur"
// question.indent: "Increase the inner indent" => "Augmenter le retrait intérieur"
// question.width: "Inline question width" => "Largeur de la question en ligne"
// question.minWidth: "Minimum question width" => "Largeur minimale de la question"
// question.maxWidth: "Maximum question width" => "Largeur maximale de la question"
// question.textUpdateMode: "Update input field value" => "Mettre à jour la valeur du champ de saisie"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Afficher le bouton Effacer dans la zone de signature"
// signaturepad.penColor: "Stroke color" => "Couleur du trait"
// comment.rows: "Input field height (in lines)" => "Hauteur du champ de saisie (en lignes)"
// expression.name: "Expression name" => "Nom de l’expression"
// expression.title: "Expression title" => "Titre de l’expression"
// expression.description: "Expression description" => "Description de l’expression"
// expression.expression: "Expression" => "Expression"
// trigger.expression: "Expression" => "Expression"
// calculatedvalue.expression: "Expression" => "Expression"
// survey.description: "Survey description" => "Description de l’enquête"
// page.name: "Page name" => "Nom de la page"
// page.description: "Page description" => "Description de la page"
// page.visibleIf: "Make the page visible if" => "Rendre la page visible si"
// page.requiredIf: "Make the page required if" => "Rendez la page obligatoire si"
// page.questionsOrder: "Question order on the page" => "Ordre des questions sur la page"
// matrixdropdowncolumn.name: "Column name" => "Nom de la colonne"
// matrixdropdowncolumn.title: "Column title" => "Titre de la colonne"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Éviter les réponses en double"
// matrixdropdowncolumn.width: "Column width" => "Largeur de la colonne"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Largeur minimale de la colonne"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Hauteur du champ de saisie (en lignes)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Rendre la colonne visible si"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Rendez la colonne obligatoire si"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Chaque option dans une colonne distincte"
// multipletextitem.name: "Name" => "Nom"
// multipletextitem.title: "Title" => "Titre"
// pe.rateDescriptionLocation: "Label alignment" => "Alignement des étiquettes"
// pe.cellErrorLocation: "Cell error message alignment" => "Alignement des messages d’erreur de cellule"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Vous n’avez pas encore de colonnes"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Vous n’avez pas encore de lignes"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Vous n’avez pas encore de règles de validation"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Vous n’avez pas encore de variables personnalisées"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Vous n’avez pas encore de déclencheurs"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Vous n’avez pas encore de liens"
// pe.addNew@columns: "Add new column" => "Ajouter une nouvelle colonne"
// pe.addNew@rows: "Add new row" => "Ajouter une nouvelle ligne"
// pe.addNew@validators: "Add new rule" => "Ajouter une nouvelle règle"
// pe.addNew@calculatedValues: "Add new variable" => "Ajouter une nouvelle variable"
// pe.addNew@triggers: "Add new trigger" => "Ajouter un nouveau déclencheur"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Ajouter une nouvelle URL"
// choicesbyurl.url: "Web service's URL" => "URL du service Web"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Afficher les titres des pages dans la barre de progression"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Afficher les numéros de page dans la barre de progression"
// itemvalue.visibleIf: "Make the option visible if" => "Rendre l’option visible si"
// itemvalue.enableIf: "Make the option selectable if" => "Rendez l’option sélectionnable si"
// panel.layout: "Panel Layout" => "Disposition du panneau"
// tabs.questionSettings: "Question Settings" => "Paramètres de la question"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Ex. : https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Ex. : categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Ex. : a)"
// pe.width_placeholder: "Ex.: 6in" => "Ex. : 6po"
// pe.minWidth_placeholder: "Ex.: 600px" => "Ex. : 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Ex. : 50 %"
// pv.selected: "Selected" => "Sélectionné"
// pv.unselected: "Unselected" => "Non sélectionné"
// pv.center: "Center" => "Centre"
// pv.middle: "Middle" => "Milieu"
// pv.next: "Next" => "Prochain"
// pv.last: "Last" => "Dernier"
// clearIfInvisible.none: "Never" => "Jamais"
// questionsOnPageMode.standard: "Original structure" => "Structure d’origine"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Afficher toutes les questions sur une seule page"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Afficher une seule question par page"
// pv.auto: "Auto" => "Auto"
// panelsState.firstExpanded: "First expanded" => "D’abord élargi"
// rateColorMode.scale: "Scale" => "Écaille"
// scaleColorMode.monochrome: "Monochrome" => "Monochrome"
// scaleColorMode.colored: "Colored" => "Coloré"
// state.default: "Locked" => "Verrouillé"
// showQuestionNumbers.default: "Auto-numbering" => "Numérotation automatique"
// showQuestionNumbers.on: "Auto-numbering" => "Numérotation automatique"
// showQuestionNumbers.onPage: "Reset on each page" => "Réinitialisation sur chaque page"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Réinitialisation sur chaque panneau"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Réinitialisation sur chaque panneau"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Continuez tout au long de l’enquête"
// showQuestionNumbers.off: "No numbering" => "Pas de numérotation"
// descriptionLocation.underTitle: "Under the question title" => "Sous le titre de la question"
// descriptionLocation.underInput: "Under the input field" => "Sous le champ de saisie"
// selectToRankAreasLayout.horizontal: "Next to choices" => "À côté des choix"
// selectToRankAreasLayout.vertical: "Above choices" => "Choix ci-dessus"
// displayStyle.decimal: "Decimal" => "Décimal"
// displayStyle.currency: "Currency" => "Monnaie"
// displayStyle.percent: "Percentage" => "Pourcentage"
// displayStyle.date: "Date" => "Date"
// totalDisplayStyle.decimal: "Decimal" => "Décimal"
// totalDisplayStyle.currency: "Currency" => "Monnaie"
// totalDisplayStyle.percent: "Percentage" => "Pourcentage"
// totalDisplayStyle.date: "Date" => "Date"
// rowsOrder.initial: "Original" => "Langue source"
// questionsOrder.initial: "Original" => "Langue source"
// showProgressBar.aboveheader: "Above the header" => "Au-dessus de l’en-tête"
// showProgressBar.belowheader: "Below the header" => "Sous l’en-tête"
// pv.sum: "Sum" => "Somme"
// pv.count: "Count" => "Compter"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Max"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Contient"
// searchMode.startsWith: "Starts with" => "Commence par"
// panel.name: "A panel ID that is not visible to respondents." => "Un ID de panel qui n’est pas visible par les personnes interrogées."
// panel.description: "Type a panel subtitle." => "Saisissez un sous-titre de panneau."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui détermine la visibilité du panneau."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui désactive le mode lecture seule du panneau."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui empêche l’envoi d’un sondage à moins qu’au moins une question imbriquée n’ait une réponse."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "S’applique à toutes les questions de ce panneau. Si vous souhaitez remplacer ce paramètre, définissez des règles d’alignement des titres pour les questions individuelles. L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête (« Haut » par défaut)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Définit l’emplacement d’un message d’erreur par rapport à toutes les questions du panneau. L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Conserve l’ordre d’origine des questions ou les rend aléatoires. L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête."
// panel.page: "Repositions the panel to the end of a selected page." => "Repositionne le panneau à la fin d’une page sélectionnée."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Ajoute un espace ou une marge entre le contenu du panneau et le bord gauche de la zone du panneau."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Désélectionnez cette option pour afficher le panneau sur une seule ligne avec la question ou le panneau précédent. Ce paramètre ne s’applique pas si le panneau est le premier élément de votre formulaire."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Choisissez parmi : « Développé » - le panneau s’affiche en entier et peut être réduit ; « Réduit » - le panneau n’affiche que le titre et la description et peut être développé ; « Verrouillé » - le panneau est affiché en entier et ne peut pas être réduit."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Définit la largeur du panneau par rapport aux autres éléments de topographie de la même ligne. Accepte les valeurs CSS (px, %, in, pt, etc.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "Un ID de panel qui n’est pas visible par les personnes interrogées."
// paneldynamic.description: "Type a panel subtitle." => "Saisissez un sous-titre de panneau."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui détermine la visibilité du panneau."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui désactive le mode lecture seule du panneau."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui empêche l’envoi d’un sondage à moins qu’au moins une question imbriquée n’ait une réponse."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "S’applique à toutes les questions de ce panneau. Si vous souhaitez remplacer ce paramètre, définissez des règles d’alignement des titres pour les questions individuelles. L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête (« Haut » par défaut)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Définit l’emplacement d’un message d’erreur par rapport à une question dont l’entrée n’est pas valide. Choisissez entre : « Haut » - un texte d’erreur est placé en haut de la zone de question ; « Bas » - un texte d’erreur est placé en bas de la zone de question. L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête (« Haut » par défaut)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Définit l’emplacement d’un message d’erreur par rapport à toutes les questions du panneau. L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Repositionne le panneau à la fin d’une page sélectionnée."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Ajoute un espace ou une marge entre le contenu du panneau et le bord gauche de la zone du panneau."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Désélectionnez cette option pour afficher le panneau sur une seule ligne avec la question ou le panneau précédent. Ce paramètre ne s’applique pas si le panneau est le premier élément de votre formulaire."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Choisissez parmi : « Développé » - le panneau s’affiche en entier et peut être réduit ; « Réduit » - le panneau n’affiche que le titre et la description et peut être développé ; « Verrouillé » - le panneau est affiché en entier et ne peut pas être réduit."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Définit la largeur du panneau par rapport aux autres éléments de topographie de la même ligne. Accepte les valeurs CSS (px, %, in, pt, etc.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Saisissez un modèle pour les titres de panneau dynamiques. Utilisez {panelIndex} pour la position générale du panneau et {visiblePanelIndex} pour son ordre parmi les panneaux visibles. Insérez ces espaces réservés dans le motif pour ajouter une numérotation automatique."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Saisissez un modèle pour les titres d’onglets. Utilisez {panelIndex} pour la position générale d’un panneau et {visiblePanelIndex} pour son ordre parmi les panneaux visibles. Insérez ces espaces réservés dans le motif pour ajouter une numérotation automatique."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Ce paramètre vous permet de contrôler la visibilité des panneaux individuels dans le panneau dynamique. Utilisez l’espace réservé '{panel}' pour référencer le panneau actuel dans votre expression."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Ce paramètre est automatiquement hérité par toutes les questions de ce panneau. Si vous souhaitez remplacer ce paramètre, définissez des règles d’alignement des titres pour les questions individuelles. L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête (« Haut » par défaut)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "L’option « Hériter » applique le paramètre au niveau de la page (s’il est défini) ou au niveau de l’enquête (« Sous le titre du panneau » par défaut)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Définit la position d’un panneau nouvellement ajouté. Par défaut, de nouveaux panneaux sont ajoutés à la fin. Sélectionnez « Suivant » pour insérer un nouveau panneau après le panneau actuel."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Duplique les réponses du dernier panneau et les attribue au panneau dynamique suivant."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Faites référence à un nom de question pour demander à un utilisateur de fournir une réponse unique à cette question dans chaque panneau."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Ce paramètre vous permet d’attribuer une valeur de réponse par défaut en fonction d’une expression. L’expression peut inclure des calculs de base - '{q1_id} + {q2_id}', des expressions booléennes, telles que '{age} > 60', et des fonctions : 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. La valeur déterminée par cette expression sert de valeur par défaut initiale qui peut être remplacée par la saisie manuelle d’une personne interrogée."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Utilisez l’icône de la baguette magique pour définir une règle conditionnelle qui détermine le moment où l’entrée d’une personne interrogée est réinitialisée à la valeur basée sur l’expression de valeur par défaut ou l’expression de valeur définie ou à la valeur de la réponse par défaut (si l’une ou l’autre est définie)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Utilisez l’icône de la baguette magique pour définir une règle conditionnelle qui détermine quand exécuter l’expression « Définir la valeur » et attribuer dynamiquement la valeur résultante en tant que réponse."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Spécifiez une expression qui définit la valeur à définir lorsque les conditions de la règle « Définir la valeur si » sont remplies. L’expression peut inclure des calculs de base - '{q1_id} + {q2_id}', des expressions booléennes, telles que '{age} > 60', et des fonctions : 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. La valeur déterminée par cette expression peut être remplacée par la saisie manuelle d’un répondant."
// question.name: "A question ID that is not visible to respondents." => "ID de question qui n’est pas visible par les personnes interrogées."
// question.description: "Type a question subtitle." => "Saisissez un sous-titre de question."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Utilisez l’icône de la baguette magique pour définir une règle conditionnelle qui détermine la visibilité de la question."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Utilisez l’icône de la baguette magique pour définir une règle conditionnelle qui désactive le mode lecture seule pour la question."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui empêche l’avancement ou la soumission de l’enquête à moins que la question n’ait reçu une réponse."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Désélectionnez cette option pour afficher la question sur une seule ligne avec la question ou le panneau précédent. Ce paramètre ne s’applique pas si la question est le premier élément de votre formulaire."
// question.page: "Repositions the question to the end of a selected page." => "Repositionne la question à la fin d’une page sélectionnée."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Choisissez parmi : « Développé » - la boîte de questions s’affiche en entier et peut être réduite ; « Réduit » - la boîte de question n’affiche que le titre et la description et peut être développée ; « Verrouillé » - la boîte de questions s’affiche en entier et ne peut pas être réduite."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Remplace les règles d’alignement des titres définies au niveau d’un panneau, d’une page ou d’une enquête. L’option « Hériter » applique tous les paramètres de niveau supérieur (s’ils sont définis) ou tous les paramètres de niveau d’enquête (« Top » par défaut)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "L’option « Hériter » applique le paramètre au niveau de l’enquête (« Sous le titre de la question » par défaut)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Définit l’emplacement d’un message d’erreur par rapport à la question dont l’entrée n’est pas valide. Choisissez entre : « Haut » - un texte d’erreur est placé en haut de la zone de question ; « Bas » - un texte d’erreur est placé en bas de la zone de question. L’option « Hériter » applique le paramètre au niveau de l’enquête (« Top » par défaut)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Ajoute un espace ou une marge entre le contenu de la question et la bordure gauche de la zone de question."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Définit la largeur de la question par rapport aux autres éléments de l’enquête sur la même ligne. Accepte les valeurs CSS (px, %, in, pt, etc.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Utilisez l’icône de la baguette magique pour définir une règle de validation pour la question."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Choisissez parmi : « En cas de perte de focus » - la valeur est mise à jour lorsque le champ de saisie perd le focus ; « Pendant la saisie » - la valeur est mise à jour en temps réel, au fur et à mesure que les utilisateurs tapent. L’option « Hériter » applique le paramètre au niveau de l’enquête (« En cas de perte de focus » par défaut)."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Vous pouvez utiliser n’importe quel service Web comme source de données pour les questions à choix multiples. Pour renseigner les valeurs de choix, entrez l’URL du service fournissant les données."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Opération de comparaison permettant de filtrer la liste déroulante."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Définit la largeur de la zone de signature affichée et l’image résultante."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Définit la hauteur de la zone de signature affichée et de l’image résultante."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Sélectionnez cette option si vous souhaitez que la zone de signature occupe tout l’espace disponible dans la zone de question tout en conservant le format d’image 3 :2 par défaut. Lorsque des valeurs de largeur et de hauteur personnalisées sont définies, le paramètre conserve les proportions de ces dimensions."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Ajuste la hauteur de l’image dans les résultats de l’enquête."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Ajuste la largeur de l’image dans les résultats de l’enquête."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Remplace les valeurs de hauteur minimale et maximale."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Remplace les valeurs de largeur minimale et maximale."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "« Valeur » sert d’ID d’élément utilisé dans les règles conditionnelles ; La mention « Texte » s’affiche pour les personnes interrogées."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Ce paramètre ne redimensionne que le champ de saisie et n’affecte pas la largeur de la zone de question. Pour limiter la longueur d’entrée acceptée, reportez-vous à <b>Validation → Limite maximale de caractères</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Définit le nombre de lignes affichées dans le champ de saisie. Si l’entrée occupe plus de lignes, la barre de défilement apparaîtra."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Choisissez entre : « Modifiable » - permet aux personnes interrogées de remplir votre sondage ; « Lecture seule » - désactive l’édition de formulaire."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "ID de colonne qui n’est pas visible par les personnes interrogées."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Lorsque cette option est activée pour une colonne, une personne interrogée doit fournir une réponse unique pour chaque question de cette colonne."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Définit le nombre de lignes affichées dans le champ de saisie. Si l’entrée occupe plus de lignes, la barre de défilement apparaîtra."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui détermine la visibilité des colonnes."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui désactive le mode lecture seule de la colonne."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui empêche l’envoi d’un sondage à moins qu’au moins une question imbriquée n’ait une réponse."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Lorsque cette option est sélectionnée, une colonne individuelle est créée pour chaque option de choix."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Choisissez parmi : « Statique » - définit une largeur fixe ; « Responsive » - permet à l’enquête d’occuper toute la largeur de l’écran ; « Auto » - s’applique à l’un ou l’autre des deux en fonction des types de questions utilisés."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Collez un lien d’image (aucune limite de taille) ou cliquez sur l’icône de dossier pour parcourir un fichier à partir de votre ordinateur (jusqu’à 64 Ko)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Définit la largeur d’un logo en unités CSS (px, %, in, pt, etc.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Définit une hauteur de logo en unités CSS (px, %, in, pt, etc.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Choisissez parmi : « Aucun » - l’image conserve sa taille d’origine ; « Contenir » - l’image est redimensionnée pour s’adapter tout en conservant son rapport hauteur/largeur ; « Couverture » - l’image remplit toute la boîte tout en conservant son rapport hauteur/largeur ; « Remplir » - l’image est étirée pour remplir la boîte sans conserver son rapport hauteur/largeur."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Sélectionnez cette option si vous souhaitez que le sondage passe automatiquement à la page suivante une fois qu’une personne interrogée a répondu à toutes les questions de la page actuelle."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Définit la visibilité et l’emplacement des boutons de navigation sur une page."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Définit la visibilité et l’emplacement d’une barre de progression. La valeur « Auto » affiche la barre de progression au-dessus ou au-dessous de l’en-tête de l’enquête."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Activez la page d’aperçu avec toutes les questions ou les questions auxquelles on a répondu uniquement."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "S’applique à toutes les questions de l’enquête. Ce paramètre peut être remplacé par des règles d’alignement des titres aux niveaux inférieurs : panneau, page ou question. Un paramètre de niveau inférieur remplacera ceux d’un niveau supérieur."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Symbole ou séquence de symboles indiquant qu’une réponse est requise."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Entrez un chiffre ou une lettre avec laquelle vous souhaitez commencer la numérotation."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Définit l’emplacement d’un message d’erreur par rapport à la question dont l’entrée n’est pas valide. Choisissez entre : « Haut » - un texte d’erreur est placé en haut de la zone de question ; « Bas » - un texte d’erreur est placé en bas de la zone de question."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Sélectionnez cette option si vous souhaitez que le premier champ de saisie de chaque page soit prêt pour la saisie de texte."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Conserve l’ordre d’origine des questions ou les rend aléatoires. L’effet de ce paramètre n’est visible que dans l’onglet Aperçu."
// pehelp.maxTextLength: "For text entry questions only." => "Pour les questions de saisie de texte uniquement."
// pehelp.maxOthersLength: "For question comments only." => "Pour les commentaires sur les questions seulement."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Indiquez si vous souhaitez que les commentaires de question et les questions de texte long augmentent automatiquement en hauteur en fonction de la longueur du texte saisi."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Pour les questions, les commentaires et les questions de texte long uniquement."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Les variables personnalisées servent de variables intermédiaires ou auxiliaires utilisées dans les calculs de formulaire. Ils prennent les données des répondants comme valeurs sources. Chaque variable personnalisée a un nom unique et une expression sur laquelle elle est basée."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Sélectionnez cette option si vous souhaitez que la valeur calculée de l’expression soit enregistrée avec les résultats de l’enquête."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Un déclencheur est un événement ou une condition qui est basé sur une expression. Une fois que l’expression est évaluée à « true », un déclencheur déclenche une action. Une telle action peut éventuellement avoir une question cible qu’elle affecte."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Choisissez d’effacer ou non les valeurs pour les questions masquées par la logique conditionnelle et quand le faire."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Choisissez parmi : « En cas de perte de focus » - la valeur est mise à jour lorsque le champ de saisie perd le focus ; « Pendant la saisie » - la valeur est mise à jour en temps réel, au fur et à mesure que les utilisateurs tapent."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "La valeur de gauche sert d’ID de colonne utilisé dans les règles conditionnelles, la valeur de droite est affichée aux personnes interrogées."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "La valeur de gauche sert d’ID de ligne utilisé dans les règles conditionnelles, la valeur de droite est affichée aux personnes interrogées."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepte les valeurs CSS (px, %, in, pt, etc.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepte les valeurs CSS (px, %, in, pt, etc.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Définit l’emplacement d’un message d’erreur par rapport à une cellule dont l’entrée n’est pas valide. L’option « Hériter » applique le paramètre de la propriété « Alignement du message d’erreur »."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Lorsque la propriété « Empêcher les réponses en double » est activée, un répondant qui tente de soumettre une entrée en double recevra le message d’erreur suivant."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Permet de calculer des valeurs totales en fonction d’une expression. L’expression peut inclure des calculs de base ('{q1_id} + {q2_id}'), des expressions booléennes ('{age} > 60') et des fonctions ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Déclenche une invite vous demandant de confirmer la suppression de ligne."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Duplique les réponses de la dernière ligne et les attribue à la ligne dynamique suivante ajoutée."
// pehelp.description: "Type a subtitle." => "Saisissez un sous-titre."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Choisissez une langue pour commencer à créer votre sondage. Pour ajouter une traduction, passez à une nouvelle langue et traduisez le texte original ici ou dans l’onglet Traductions."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Définit l’emplacement d’une section de détails par rapport à une ligne. Choisissez parmi : « Aucun » - aucune extension n’est ajoutée ; « Sous la ligne » - un développement de ligne est placé sous chaque ligne de la matrice ; « Sous la ligne, afficher un seul développement de ligne » - un développement est affiché sous une seule ligne, les développements de ligne restants sont réduits."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Choisissez parmi : « Aucun » - l’image conserve sa taille d’origine ; « Contenir » - l’image est redimensionnée pour s’adapter tout en conservant son rapport hauteur/largeur ; « Couverture » - l’image remplit toute la boîte tout en conservant son rapport hauteur/largeur ; « Remplir » - l’image est étirée pour remplir la boîte sans conserver son rapport hauteur/largeur."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Augmente progressivement la hauteur du champ de saisie au fur et à mesure de la saisie des données. Remplace le paramètre « Hauteur du champ de saisie (en lignes) »."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "La poignée de redimensionnement (ou poignée) apparaît dans le coin et peut être déplacée pour modifier la taille du champ de saisie."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Intervalle de temps en secondes après lequel l’enquête passe automatiquement à la page de remerciement."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Intervalle de temps en secondes après lequel l’enquête passe automatiquement à la page suivante."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Intervalle de temps en secondes après lequel l’enquête passe automatiquement à la page suivante."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Utilisez l’icône de la baguette magique pour définir une règle conditionnelle qui détermine la visibilité de la page."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui désactive le mode lecture seule de la page."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Utilisez l’icône en forme de baguette magique pour définir une règle conditionnelle qui empêche l’envoi d’un sondage à moins qu’au moins une question imbriquée n’ait une réponse."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "S’applique à toutes les questions de cette page. Si vous souhaitez remplacer ce paramètre, définissez des règles d’alignement des titres pour des questions ou des panneaux individuels. L’option « Hériter » applique le paramètre au niveau de l’enquête (« Top » par défaut)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Définit l’emplacement d’un message d’erreur par rapport à la question dont l’entrée n’est pas valide. Choisissez entre : « Haut » - un texte d’erreur est placé en haut de la zone de question ; « Bas » - un texte d’erreur est placé en bas de la zone de question. L’option « Hériter » applique le paramètre au niveau de l’enquête (« Top » par défaut)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Conserve l’ordre d’origine des questions ou les rend aléatoires. L’option « Hériter » applique le paramètre au niveau de l’enquête (« Original » par défaut). L’effet de ce paramètre n’est visible que dans l’onglet Aperçu."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Définit la visibilité des boutons de navigation sur la page. L’option « Hériter » applique le paramètre au niveau de l’enquête, qui est par défaut « Visible »."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Définit la visibilité et l’emplacement d’un minuteur sur une page."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Choisissez parmi : « Verrouillé » - les utilisateurs ne peuvent pas développer ou réduire les panneaux ; « Réduire tout » - tous les panneaux commencent dans un état réduit ; « Développer tout » - tous les panneaux commencent dans un état développé ; « Premier développé » - seul le premier panneau est initialement développé."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Entrez un nom de propriété partagée dans le tableau d’objets qui contient les URL de fichier image ou vidéo que vous souhaitez afficher dans la liste de choix."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "La valeur de gauche sert d’ID d’élément utilisé dans les règles conditionnelles, la valeur de droite est affichée aux personnes interrogées."
// pehelp.title: "Type a user-friendly title to display." => "Saisissez un titre convivial à afficher."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Garantit que les utilisateurs ne répondront pas à l’enquête tant que les fichiers n’auront pas été téléchargés."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepte les valeurs CSS (px, %, in, pt, etc.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepte les valeurs CSS (px, %, in, pt, etc.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepte les valeurs CSS (px, %, in, pt, etc.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "Dans les types de questions à sélection unique et multiple, chaque option de choix a un ID et une valeur d’affichage. Lorsqu’il est sélectionné, ce paramètre affiche une valeur d’affichage au lieu d’une valeur d’ID dans les questions HTML et les titres et descriptions dynamiques des éléments d’enquête."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Choisissez d’effacer ou non les valeurs de question masquées par la logique conditionnelle et quand le faire. L’option « Hériter » applique le paramètre au niveau de l’enquête (« À la fin de l’enquête » par défaut)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Choisissez parmi : « Tous » - copie toutes les options de choix de la question sélectionnée ; « Sélectionné » - copie dynamiquement uniquement les options de choix sélectionnées ; « Non sélectionné » - copie dynamiquement uniquement les options de choix non sélectionnées. Les options « Aucun » et « Autre » sont copiées par défaut si elles sont activées dans la question source."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Lorsque cette option est sélectionnée, les utilisateurs peuvent inclure des entrées supplémentaires dans une zone de commentaire distincte."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Affiche chaque option de choix spécial (« Aucun », « Autre », « Tout sélectionner ») sur une nouvelle ligne, même en cas d’utilisation d’une mise en page à plusieurs colonnes."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Spécifiez l’emplacement dans le jeu de données de service où se trouve le tableau cible d’objets. Laissez vide si l’URL pointe déjà vers le tableau."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Entrez un nom de propriété uniforme dans le tableau d’objets qui contient les valeurs que vous souhaitez afficher dans la liste de choix."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Sélectionnez cette option pour permettre au service de renvoyer une réponse ou un tableau vide."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Utilisez l’icône de la baguette magique pour définir une règle conditionnelle qui détermine la visibilité de toutes les options de choix."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "La valeur de gauche sert d’ID d’élément utilisé dans les règles conditionnelles, la valeur de droite est affichée aux personnes interrogées."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "« Auto » sélectionne entre les modes « Boutons » et « Menu déroulant » en fonction de la largeur disponible. Lorsque la largeur est insuffisante pour afficher les boutons, la question affiche une liste déroulante."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Vous permet de connecter des questions qui produisent des résultats dans différents formats. Lorsque ces questions sont liées entre elles à l’aide d’un identificateur de jointure, cette propriété partagée stocke les valeurs de question sélectionnées."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Sélectionnez cette option si vous souhaitez mettre à jour le contenu du menu déroulant pour qu’il corresponde à la requête de recherche qu’un utilisateur saisit dans le champ de saisie."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Une valeur à enregistrer dans les résultats de l’enquête lorsque les répondants donnent une réponse positive."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Une valeur à enregistrer dans les résultats de l’enquête lorsque les personnes interrogées donnent une réponse négative."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Il n’est pas recommandé de désactiver cette option, car elle remplace l’image d’aperçu et rend difficile pour l’utilisateur de savoir si les fichiers ont été téléchargés."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Déclenche une invite vous demandant de confirmer la suppression du fichier."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Activez cette option pour classer uniquement les choix sélectionnés. Les utilisateurs feront glisser les éléments sélectionnés de la liste de choix pour les classer dans la zone de classement."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Entrez une liste de choix qui seront suggérés au répondant lors de la saisie."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Le paramètre ne redimensionne que les champs de saisie et n’affecte pas la largeur de la zone de question."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Définit une largeur cohérente pour toutes les étiquettes d’élément en pixels"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "L’option « Auto » détermine automatiquement le mode d’affichage approprié - Image, Vidéo ou YouTube - en fonction de l’URL source fournie."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Sert de substitut lorsque l’image ne peut pas être affichée sur l’appareil d’un utilisateur et à des fins d’accessibilité."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Définit la couleur de l’emoji sélectionné lorsque le type d’icône d’évaluation est défini sur « Smileys ». Choisissez entre : « Par défaut » - l’emoji sélectionné apparaît dans la couleur par défaut de l’enquête ; « Échelle » - l’emoji sélectionné hérite de la couleur de l’échelle d’évaluation."
// expression.name: "An expression ID that is not visible to respondents." => "ID d’expression qui n’est pas visible par les personnes interrogées."
// expression.description: "Type an expression subtitle." => "Saisissez un sous-titre d’expression."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Une expression peut inclure des calculs de base ('{q1_id} + {q2_id}'), des conditions ('{age} > 60') et des fonctions ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Sélectionnez cette option pour stocker la valeur de l’option « Autre » en tant que propriété distincte dans les résultats de l’enquête."
// p.swapOrder: "Swap the order of Yes and No" => "Permuter l’ordre de Oui et Non"
// p.itemTitleWidth: "Item label width (in px)" => "Largeur de l’étiquette de l’article (en px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Texte pour indiquer si toutes les options sont sélectionnées"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Texte d’espace réservé pour la zone de classement"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Répondez automatiquement à l’enquête"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Sélectionnez cette option si vous souhaitez que l’enquête se termine automatiquement une fois qu’une personne interrogée a répondu à toutes les questions."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Enregistrer la valeur masquée dans les résultats de l’enquête"
// patternmask.pattern: "Value pattern" => "Modèle de valeur"
// datetimemask.min: "Minimum value" => "Valeur minimale"
// datetimemask.max: "Maximum value" => "Valeur maximale"
// numericmask.allowNegativeValues: "Allow negative values" => "Autoriser les valeurs négatives"
// numericmask.thousandsSeparator: "Thousands separator" => "Séparateur de milliers"
// numericmask.decimalSeparator: "Decimal separator" => "Séparateur décimal"
// numericmask.precision: "Value precision" => "Précision de la valeur"
// numericmask.min: "Minimum value" => "Valeur minimale"
// numericmask.max: "Maximum value" => "Valeur maximale"
// currencymask.prefix: "Currency prefix" => "Préfixe de devise"
// currencymask.suffix: "Currency suffix" => "Suffixe de devise"
// pe.maskType: "Input mask type" => "Type de masque de saisie"
// maskTypes.patternmask: "Pattern" => "Modèle"
// maskTypes.numericmask: "Numeric" => "Numérique"
// maskTypes.datetimemask: "Date and Time" => "Date et heure"
// maskTypes.currencymask: "Currency" => "Monnaie"
// tabs.mask: "Input Mask Settings" => "Paramètres du masque de saisie"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Ex. : +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Ex. : mm/jj/aaaa"
// pe.currencyprefix_placeholder: "Ex.: $" => "Ex. : $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Ex. : USD"
// pv.textWrapEnabled: "Wrap choices" => "Choix d’enveloppes"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Les longs textes dans les options de choix généreront automatiquement des sauts de ligne pour s’adapter au menu déroulant. Désélectionnez cette option si vous souhaitez que les textes soient coupés."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Sélectionnez cette option si vous souhaitez stocker la valeur de la question à l’aide d’un masque appliqué dans les résultats de l’enquête."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Le modèle peut contenir des littéraux de chaîne et les espaces réservés suivants : '9' - pour un chiffre ; 'a' - pour une lettre majuscule ou minuscule ; '#' - pour un chiffre ou une lettre majuscule ou minuscule. Utilisez la barre oblique inverse '\\' pour échapper un caractère."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Le modèle peut contenir des caractères de séparation et les espaces réservés suivants : 'm' - pour le numéro du mois ; 'mm' - pour le numéro du mois, avec un zéro non significatif pour les valeurs à un chiffre ; 'd' - pour le jour du mois ; 'dd' - pour le jour du mois, avec zéro en tête pour les valeurs à un chiffre ; 'yy' - pour les deux derniers chiffres de l’année ; 'yyyy' - pour une année à quatre chiffres."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Symbole utilisé pour séparer la partie fractionnaire de la partie entière d’un nombre affiché."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Symbole utilisé pour séparer les chiffres d’un grand nombre en groupes de trois."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Limite le nombre de chiffres à conserver après la virgule décimale pour un nombre affiché."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Un ou plusieurs symboles à afficher avant la valeur."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Un ou plusieurs symboles à afficher après la valeur."
// ed.translationSource: "Source: " => "Source: "
// ed.translationTarget: "Target: " => "Cible: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "La page est vide. Faites glisser un élément de la boîte à outils ou cliquez sur le bouton ci-dessous."
// maskTypes.none: "None" => "Aucun"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Rendre la ligne visible si"
// itemvalue@rows.enableIf: "Make the row editable if" => "Rendez la ligne modifiable si"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Texte d’espace réservé en lecture seule ou en mode d’aperçu"
// pe.textWrapEnabled: "Wrap choices" => "Choix d’enveloppes"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "L’option «Auto» détermine automatiquement le mode d’affichage approprié - Image, Vidéo ou YouTube - en fonction de l’URL source fournie."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Choisissez entre «Image» et «Vidéo» pour définir le mode de contenu du sélecteur de médias. Si «Image» est sélectionné, assurez-vous que toutes les options fournies sont des fichiers image dans les formats suivants : JPEG, GIF, PNG, APNG, SVG, BMP, ICO. De même, si «Vidéo» est sélectionné, assurez-vous que toutes les options sont des liens directs vers des fichiers vidéo dans les formats suivants : MP4, MOV, WMV, FLV, AVI, MKV. Veuillez noter que les liens YouTube ne sont pas pris en charge pour les options vidéo."
// ed.selectFile: "Select a file" => "Sélectionner un fichier"
// ed.removeFile: "Remove the file" => "Supprimer le fichier"
// pe.searchMode: "Search Mode" => "Mode de recherche"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Cliquez sur le bouton « Ajouter une question » ci-dessous pour commencer à créer votre formulaire."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Cliquez sur le bouton « Ajouter une question » ci-dessous pour ajouter un nouvel élément à la page."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Cliquez sur le bouton « Ajouter une question » ci-dessous pour ajouter un nouvel élément au panneau."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Cliquez sur le bouton ci-dessous et choisissez une image à télécharger"
// coloralpha.opacity: "Opacity" => "Opacité"
// font.family: "Font family" => "Famille de polices"
// font.color: "Color" => "Couleur"
// font.placeholderColor: "Placeholder color" => "Couleur de l’espace réservé"
// font.size: "Size" => "Taille"
// theme.themeName: "Theme" => "Thème"
// theme.isPanelless: "Question appearance" => "Apparence de la question"
// theme.editorPanel: "Background and corner radius" => "Arrière-plan et rayon d’angle"
// theme.questionPanel: "Background and corner radius" => "Arrière-plan et rayon d’angle"
// theme.primaryColor: "Accent color" => "Couleur d’accentuation"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Opacité de l’arrière-plan du panneau"
// theme.questionBackgroundTransparency: "Question background opacity" => "Opacité de l’arrière-plan de la question"
// theme.fontSize: "Font size" => "Taille de la police"
// theme.scale: "Scale" => "Écaille"
// theme.cornerRadius: "Corner radius" => "Rayon d’angle"
// theme.pageTitle: "Title font" => "Police de titre"
// theme.pageDescription: "Description font" => "Police de description"
// theme.questionTitle: "Title font" => "Police de titre"
// theme.questionDescription: "Description font" => "Police de description"
// theme.editorFont: "Font" => "Police"
// theme.backgroundOpacity: "Opacity" => "Opacité"
// theme.--sjs-font-family: "Font family" => "Famille de polices"
// theme.--sjs-general-backcolor-dim: "Background color" => "Couleur de fond"
// theme.--sjs-primary-backcolor: "Accent background" => "Fond d’accent"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Premier plan accentué"
// theme.--sjs-shadow-small: "Shadow effects" => "Effets d’ombre"
// theme.--sjs-shadow-inner: "Shadow effects" => "Effets d’ombre"
// theme.--sjs-border-default: "Colors" => "Couleurs"
// header@header.headerView: "View" => "Vue"
// header@header.logoPosition: "Logo position" => "Position du logo"
// header@header.surveyTitle: "Survey title font" => "Police de titre de l’enquête"
// header@header.surveyDescription: "Survey description font" => "Police de description de l’enquête"
// header@header.headerTitle: "Survey title font" => "Police de titre de l’enquête"
// header@header.headerDescription: "Survey description font" => "Police de description de l’enquête"
// header@header.inheritWidthFrom: "Content area width" => "Largeur de la zone de contenu"
// header@header.textAreaWidth: "Text width" => "Largeur du texte"
// header@header.backgroundColorSwitch: "Background color" => "Couleur de fond"
// header@header.backgroundImage: "Background image" => "Image d’arrière-plan"
// header@header.backgroundImageOpacity: "Opacity" => "Opacité"
// header@header.overlapEnabled: "Overlap" => "Chevauchement"
// header@header.logoPositionX: "Logo position" => "Position du logo"
// header@header.titlePositionX: "Title position" => "Position du titre"
// header@header.descriptionPositionX: "Description position" => "Description du poste"
// weight.400: "Regular" => "Régulier"
// weight.600: "Heavy" => "Lourd"
// weight.700: "Semi-bold" => "Semi-gras"
// weight.800: "Bold" => "Audacieux"
// backgroundImageFit.auto: "Auto" => "Auto"
// backgroundImageFit.cover: "Cover" => "Couvrir"
// backgroundImageFit.contain: "Contain" => "Contenir"
// backgroundImageFit.fill: "Stretch" => "Étirer"
// backgroundImageFit.tile: "Tile" => "Carreau"
// backgroundImageAttachment.fixed: "Fixed" => "Fixe"
// backgroundImageAttachment.scroll: "Scroll" => "Faire défiler"
// headerView.basic: "Basic" => "Basique"
// headerView.advanced: "Advanced" => "Avancé"
// inheritWidthFrom.survey: "Same as survey" => "Identique à l’enquête"
// inheritWidthFrom.container: "Fit to container" => "Adapter au conteneur"
// backgroundColorSwitch.none: "None" => "Aucun"
// backgroundColorSwitch.accentColor: "Accent color" => "Couleur d’accentuation"
// backgroundColorSwitch.custom: "Custom" => "Coutume"
// colorPalette.light: "Light" => "Lumière"
// colorPalette.dark: "Dark" => "Sombre"
// isPanelless.false: "Default" => "Faire défaut"
// isPanelless.true: "Without Panels" => "Sans panneaux"
// theme.cornerRadius: "Corner radius" => "Rayon d’angle"
// theme.fontFamily: "Font family" => "Famille de polices"
// theme.fontWeightRegular: "Regular" => "Régulier"
// theme.fontWeightHeavy: "Heavy" => "Lourd"
// theme.fontWeightSemiBold: "Semi-bold" => "Semi-gras"
// theme.fontWeightBold: "Bold" => "Audacieux"
// theme.color: "Color" => "Couleur"
// theme.placeholderColor: "Placeholder color" => "Couleur de l’espace réservé"
// theme.size: "Size" => "Taille"
// theme.opacity: "Opacity" => "Opacité"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Tapez pour rechercher..."
// ed.toolboxNoResultsFound: "No results found" => "Aucun résultat trouvé"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Espace réservé au titre de l’onglet"
// theme.--sjs-special-red: "Error messages" => "Messages d’erreur"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Texte de secours pour les titres d’onglet qui s’applique lorsque le modèle de titre d’onglet ne produit pas de valeur significative."
// theme.fontColor: "Font color" => "Couleur de la police"
// theme.backgroundColor: "Background color" => "Couleur de fond"
// pe.questionTitleWidth: "Question title width" => "Largeur du titre de la question"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Sélectionnez un fichier ou collez un lien de fichier..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Ex. : 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Définit une largeur cohérente pour les titres de questions lorsqu’ils sont alignés à gauche de leurs zones de questions. Accepte les valeurs CSS (px, %, in, pt, etc.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Définit une largeur cohérente pour les titres de questions lorsqu’ils sont alignés à gauche de leurs zones de questions. Accepte les valeurs CSS (px, %, in, pt, etc.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Hauteur de la zone de commentaires (en lignes)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Définit le nombre de lignes affichées dans les zones de texte pour les commentaires de question. Lorsque l’entrée occupe plus de lignes, la barre de défilement apparaît."


/***/ }),

/***/ "./src/localization/german.ts":
/*!************************************!*\
  !*** ./src/localization/german.ts ***!
  \************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var germanTranslation = {
    // survey templates
    survey: {
        edit: "Bearbeiten",
        externalHelpLink: "Schauen Sie sich an, wie Sie Umfragen erstellen können",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Frage bitte hier platzieren.",
        addLogicItem: "Eine Regel erstellen, um den Fluss der Umfrage anzupassen.",
        copy: "Kopieren",
        duplicate: "Duplizieren",
        addToToolbox: "Zur Werkzeugleiste hinzufügen",
        deletePanel: "Panel löschen",
        deleteQuestion: "Frage löschen",
        convertTo: "Konvertieren zu",
        drag: "Element ziehen",
    },
    // Creator tabs
    tabs: {
        preview: "Test",
        theme: "Themen",
        translation: "Übersetzung",
        designer: "Designer",
        editor: "JSON",
        logic: "Logik"
    },
    // Question types
    qt: {
        default: "Standard",
        checkbox: "Auswahl",
        comment: "Kommentar",
        imagepicker: "Bildauswahl",
        ranking: "Reihenfolge",
        image: "Bild",
        dropdown: "Dropdown",
        tagbox: "Dropdown-Menü mit Mehrfachauswahl",
        file: "Datei",
        html: "HTML",
        matrix: "Matrix (einfache Auswahl)",
        matrixdropdown: "Matrix (mehrfache Auswahl)",
        matrixdynamic: "Matrix (dynamische Zeilen)",
        multipletext: "Text (mehrzeilig)",
        panel: "Panel",
        paneldynamic: "Panel (dynamisch)",
        radiogroup: "Option",
        rating: "Bewertung",
        text: "Text",
        boolean: "Wahrheitswert",
        expression: "Ausdruck (schreibgeschützt)",
        signaturepad: "Unterschrift",
        buttongroup: "Schaltfläche-Gruppe"
    },
    toolboxCategories: {
        general: "Allgemein",
        choice: "Auswahl-Fragen",
        text: "Text-Eingabe-Fragen",
        containers: "Kontainer",
        matrix: "Matrix-Fragen",
        misc: "Verschiedenes"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Standard ({0})",
        survey: "Umfrage",
        settings: "Umfrageeinstellungen",
        settingsTooltip: "Umfrageeinstellungen öffnen",
        surveySettings: "Umfrage Einstellungen",
        surveySettingsTooltip: "Einstellungen für Umfragen",
        themeSettings: "Theme-Einstellungen",
        themeSettingsTooltip: "Theme-Einstellungen",
        showPanel: "Panel anzeigen",
        hidePanel: "Panel verstecken",
        prevSelected: "Vorheriges auswählen",
        nextSelected: "Nächstes auswählen",
        prevFocus: "Fokus zurück",
        nextFocus: "Weiter fokussieren",
        surveyTypeName: "Umfrage",
        pageTypeName: "Seite",
        panelTypeName: "Panel",
        questionTypeName: "Frage",
        columnTypeName: "Spalte",
        addNewPage: "Neue Seite hinzufügen",
        moveRight: "Nach rechts scrollen",
        moveLeft: "Nach links scrollen",
        deletePage: "Seite löschen",
        editPage: "Seite bearbeiten",
        edit: "Bearbeiten",
        newPageName: "Seite",
        newQuestionName: "Frage",
        newPanelName: "Panel",
        newTextItemName: "Text",
        defaultV2Theme: "Standard",
        modernTheme: "Modern",
        defaultTheme: "Standard (veraltet)",
        testSurveyAgain: "Testumfrage wiederholen",
        testSurveyWidth: "Umfragebreite: ",
        navigateToMsg: "Sie werden weitergeleitet: ",
        saveSurvey: "Umfrage speichern",
        saveSurveyTooltip: "Umfrage speichern",
        saveTheme: "Theme speichern",
        saveThemeTooltip: "Theme speichern",
        jsonHideErrors: "Fehler verstecken",
        jsonShowErrors: "Fehler anzeigen",
        undo: "Rückgängig",
        redo: "Wiederherstellen",
        undoTooltip: "Letzte Änderung rückgängig machen",
        redoTooltip: "Letzte Änderung wiederherstellen",
        showMoreChoices: "Zeige mehr",
        showLessChoices: "Zeige weniger",
        copy: "Kopieren",
        cut: "Ausschneiden",
        paste: "Einfügen",
        copyTooltip: "Auswahl in die Zwischenablage kopieren",
        cutTooltip: "Auswahl ausschneiden",
        pasteTooltip: "Aus der Zwischenablage einfügen",
        options: "Optionen",
        generateValidJSON: "Gültiges JSON generieren",
        generateReadableJSON: "Lesbares JSON generieren",
        toolbox: "Werkzeugleiste",
        "property-grid": "Eigenschaften",
        toolboxFilteredTextPlaceholder: "Geben Sie ein, um zu suchen...",
        toolboxNoResultsFound: "Keine Ergebnisse gefunden",
        propertyGridFilteredTextPlaceholder: "Tippen, um zu suchen ...",
        propertyGridNoResultsFound: "Keine Ergebnisse gefunden",
        correctJSON: "Bitte JSON korrigieren.",
        surveyResults: "Umfrageergebnis: ",
        surveyResultsTable: "Als Tabelle",
        surveyResultsJson: "Als JSON",
        resultsTitle: "Titel der Frage",
        resultsName: "Name der Frage",
        resultsValue: "Wert der Antwort",
        resultsDisplayValue: "Anzeigewert",
        modified: "Modifiziert",
        saving: "Speichern",
        saved: "Gespeichert",
        propertyEditorError: "Fehler:",
        saveError: "Fehler! Der Inhalt des Editors wurde nicht gespeichert.",
        translationPropertyGridTitle: "Übersetzungseinstellungen",
        themePropertyGridTitle: "Theme-Einstellungen",
        translationLanguages: "Sprachen",
        translationDeleteLanguage: "Sind Sie sicher, dass Sie alle Texte für diese Sprache löschen möchten?",
        translationAddLanguage: "Wählen Sie eine Sprache aus",
        translationShowAllStrings: "Alle Texte anzeigen",
        translationShowUsedStringsOnly: "Verwendete Texte",
        translationShowAllPages: "Alle Seiten anzeigen",
        translationNoStrings: "Keine Texte zum Übersetzen. Bitte den Filter anpassen.",
        translationExportToSCVButton: "Export (CSV)",
        translationImportFromSCVButton: "Import (CSV)",
        translateUsigAI: "Alle automatisch übersetzen",
        translateUsigAIFrom: "Sprachrichtung: ",
        translationDialogTitle: "Nicht übersetzte Texte",
        translationMergeLocaleWithDefault: "{0} mit der Standardsprache zusammenführen",
        translationPlaceHolder: "Übersetzung ...",
        translationSource: "Quelle: ",
        translationTarget: "Ziel: ",
        themeExportButton: "Exportieren",
        themeImportButton: "Importieren",
        surveyJsonExportButton: "Exportieren",
        surveyJsonImportButton: "Importieren",
        surveyJsonCopyButton: "In Zwischenablage kopieren",
        themeResetButton: "Theme-Einstellungen auf die Standardeinstellungen zurücksetzen",
        themeResetConfirmation: "Möchten Sie das Theme wirklich zurücksetzen? Alle Ihre Anpassungen gehen verloren.",
        themeResetConfirmationOk: "Ja, Design zurücksetzen.",
        bold: "Fett",
        italic: "Kursiv",
        underline: "Unterstrichen",
        addNewQuestion: "Frage hinzufügen",
        selectPage: "Seite auswählen ...",
        carryForwardChoicesCopied: "Auswahlmöglichkeiten werden kopiert von",
        choicesLoadedFromWebText: "Auswahlmöglichkeiten werden aus einem Webdienst geladen.",
        choicesLoadedFromWebLinkText: "Gehen Sie zu den Einstellungen",
        choicesLoadedFromWebPreviewTitle: "Vorschau der geladenen Auswahloptionen",
        htmlPlaceHolder: "HTML wird hier dargestellt werden.",
        panelPlaceHolder: "Ziehe eine Frage aus der Toolbox hier her.",
        surveyPlaceHolder: "Die Umfrage enthält keine Frage. Ziehen Sie ein Element aus der Toolbox hier her oder drücken Sie auf die Schaltfläche unten.",
        pagePlaceHolder: "Die Seite ist leer. Ziehen Sie ein Element aus der Toolbox oder klicken Sie auf die Schaltfläche unten.",
        imagePlaceHolder: "Ziehen Sie ein Bild per Drag & Drop hierher oder klicken Sie auf die Schaltfläche unten und wählen Sie ein Bild zum Hochladen aus",
        surveyPlaceHolderMobile: "Klicken Sie unten auf die Schaltfläche \"Frage hinzufügen\", um mit der Erstellung Ihres Formulars zu beginnen.",
        pagePlaceHolderMobile: "Klicken Sie unten auf die Schaltfläche \"Frage hinzufügen\", um der Seite ein neues Element hinzuzufügen.",
        panelPlaceHolderMobile: "Klicken Sie unten auf die Schaltfläche \"Frage hinzufügen\", um dem Bedienfeld ein neues Element hinzuzufügen.",
        imagePlaceHolderMobile: "Klicken Sie auf die Schaltfläche unten und wählen Sie ein Bild zum Hochladen aus",
        imageChooseImage: "Bild auswählen",
        addNewTypeQuestion: "Add {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Artikel ",
        selectFile: "Wählen Sie eine Datei aus",
        removeFile: "Entfernen Sie die Datei",
        lg: {
            addNewItem: "Neue Regel hinzufügen",
            empty_tab: "Erstellen Sie eine Regel, um den Fluss der Umfrage anzupassen.",
            page_visibilityName: "Seite anzeigen/verstecken",
            page_enableName: "Seite aktivieren/deaktivieren",
            page_requireName: "Seite als erforderlich festlegen",
            panel_visibilityName: "Panel anzeigen/verstecken",
            panel_enableName: "Panel aktivieren/deaktivieren",
            panel_requireName: "Panel als erforderlich festlegen",
            question_visibilityName: "Frage anzeigen/verstecken",
            question_enableName: "Frage aktivieren/deaktivieren",
            question_requireName: "Frage optional/erforderlich",
            question_resetValueName: "Fragewert zurücksetzen",
            question_setValueName: "Festlegen des Fragewerts",
            column_visibilityName: "Spalte anzeigen/verstecken",
            column_enableName: "Spalte aktivieren/deaktivieren",
            column_requireName: "Spalte optional/erforderlich",
            column_resetValueName: "Spaltenwert zurücksetzen",
            column_setValueName: "Festlegen des Spaltenwerts",
            trigger_completeName: "Umfrage abschließen",
            trigger_setvalueName: "Antwort setzen",
            trigger_copyvalueName: "Antwort kopieren",
            trigger_skipName: "Zu Frage springen",
            trigger_runExpressionName: "Ausdruck ausführen",
            completedHtmlOnConditionName: "Seite nach Abschluss der Umfrage anzeigen",
            page_visibilityDescription: "Seite sichtbar machen, wenn der logische Ausdruck wahr ergibt. Andernfalls unsichtbar lassen.",
            panel_visibilityDescription: "Panel sichtbar machen, wenn der logische Ausdruck wahr ergibt. Andernfalls unsichtbar lassen.",
            panel_enableDescription: "Panel zusammen mit all seinen Elementen aktivieren, wenn der logische Ausdruck wahr ergibt. Andernfalls deaktiviert lassen.",
            question_visibilityDescription: "Frage sichtbar machen, wenn der logische Ausdruck wahr ergibt. Andernfalls unsichtbar lassen.",
            question_enableDescription: "Frage aktivieren, wenn der logische Ausdruck wahr ergibt. Andernfalls deaktiviert lassen.",
            question_requireDescription: "Frage wird erforderlich, wenn der logische Ausdruck wahr ergibt.",
            trigger_completeDescription: "Wenn der logische Ausdruck wahr ergibt, wird die Umfrage abgeschlossen und der Benutzer sieht die Abschlussseite der Umfrage.",
            trigger_setvalueDescription: "Wenn Werte, die im logischen Ausdruck verwendet werden, geändert werden und der logische Ausdruck wahr ergibt, dann wird der Wert in die ausgewählte Frage eingesetzt.",
            trigger_copyvalueDescription: "Wenn Werte, die im logischen Ausdruck verwendet werden, geändert werden und der logische Ausdruck wahr ergibt, dann wird der Wert einer ausgewählte Frage kopiert und in eine andere ausgewählte Frage eingesetzt.",
            trigger_skipDescription: "Wenn der logische Ausdruck wahr ergibt, springt die Umfrage zur ausgewählten Frage.",
            trigger_runExpressionDescription: "Wenn der logische Ausdruck wahr ergibt, wird die benutzerdefinierte Anweisung ausgeführt. Sie können optional das Ergebnis der Anweisung in die ausgewählte Frage einsetzen.",
            completedHtmlOnConditionDescription: "Wenn der logische Ausdruck wahr ergibt, wird der Standardtext der Abschlussseite der Umfrage mit dem gegebenen Text ersetzt.",
            itemExpressionText: "Wenn der Ausdruck '{0}' wahr ergibt:",
            itemEmptyExpressionText: "Neue Regel",
            page_visibilityText: "Seite {0} sichtbar machen",
            panel_visibilityText: "Panel {0} sichtbar machen",
            panel_enableText: "Panel {0} aktivieren",
            question_visibilityText: "Frage {0} sichtbar machen",
            question_enableText: "Frage {0} aktivieren",
            question_requireText: "Frage {0} erforderlich machen",
            question_resetValueText: "Reset-Wert für Frage: {0}",
            question_setValueText: "Wert zuweisen: {1} zu fragen: {0}",
            column_visibilityText: "Spalte {0} von Frage {1} sichtbar machen",
            column_enableText: "Spalte {0} von Frage {1} aktivieren",
            column_requireText: "Spalte {0} von Frage {1} erforderlich machen",
            column_resetValueText: "Zellenwert für Spalte zurücksetzen: {0}",
            column_setValueText: "Zellenwert zuweisen: {1} zur Spalte: {0}",
            setValueExpressionPlaceholder: "Ein Ausdruck, dessen Ergebnis der Zielfrage zugewiesen wird.",
            trigger_completeText: "Umfrage abschließen",
            trigger_setvalueText: " In Frage {0} den Wert {1} einsetzen",
            trigger_setvalueEmptyText: "Fragewert: {0} löschen",
            trigger_copyvalueText: "In Frage {0} den Wert von Frage {1} kopieren",
            trigger_skipText: "Zu Frage {0} gehen",
            trigger_runExpressionText1: "Folgendee Ausdruck ausführen: '{0}'",
            trigger_runExpressionText2: " und das Ergebnis in Frage {0} einsetzen",
            completedHtmlOnConditionText: "Benutzerdefinierter Text auf der Abschlussseite der Umfrage anzeigen.",
            showAllQuestions: "Alle Fragen anzeigen",
            showAllActionTypes: "Alle Aktionen anzeigen",
            conditions: "Bedingungen",
            actions: "Aktionen",
            expressionEditorTitle: "Bedingungen definieren",
            actionsEditorTitle: "Aktionen definieren",
            deleteAction: "Aktion löschen",
            addNewAction: "Aktion hinzufügen",
            selectedActionCaption: "Aktion zum Hinzufügen auswählen...",
            expressionInvalid: "Der logische Ausdruck ist leer oder ungültig. Bitte korrigieren Sie ihn.",
            noActionError: "Bitte fügen Sie mindestens eine Aktion hinzu.",
            actionInvalid: "Bitte beheben Sie die bestehenden Probleme in Ihren Aktionen.",
            uncompletedRule_title: "Logische Regeln sind unvollständig",
            uncompletedRule_text: "Sie haben einige der logischen Regeln nicht erfüllt. Wenn Sie den Tab jetzt verlassen, gehen die Änderungen verloren. Möchten Sie den Tab dennoch verlassen, ohne die Änderungen abzuschließen?",
            uncompletedRule_apply: "Ja",
            uncompletedRule_cancel: "Nein, ich möchte die Regeln vervollständigen"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Name des Panels",
            title: "Titel des Panels",
            description: "Beschreibung des Panels",
            visibleIf: "Panel sichtbar machen, wenn",
            requiredIf: "Panel erforderlich machen, wenn",
            questionsOrder: "Reihenfolge der Fragen innerhalb des Panels",
            page: "Panel auf die Seite verschieben",
            startWithNewLine: "Panel in einer neuen Zeile anzeigen",
            state: "Status des Ausblendens des Panels",
            width: "Breite des Inline-Panels",
            minWidth: "Minimale Breite des Panels",
            maxWidth: "Maximale Breite des Panels",
            showNumber: "Nummernfelder"
        },
        paneldynamic: {
            name: "Name des Panels",
            title: "Titel des Panels",
            description: "Beschreibung des Panels",
            visibleIf: "Panel sichtbar machen, wenn",
            requiredIf: "Panel erforderlich machen, wenn",
            page: "Panel auf die Seite verschieben",
            startWithNewLine: "Anzeigen des Panels in einer neuen Zeile",
            state: "Status des Ausblendens des Panels",
            width: "Breite des Inline-Panels",
            minWidth: "Minimale Breite des Panels",
            maxWidth: "Maximale Breite des Panels",
            confirmDelete: "Bestätigen Sie das Löschen des Panels",
            templateDescription: "Muster für die Panelbeschreibung",
            templateTitle: "Muster für den Panel-Titel",
            noEntriesText: "Text für leeres Panel",
            templateTabTitle: "Muster des Tab-Titels",
            tabTitlePlaceholder: "Platzhalter für Registerkartentitel",
            templateVisibleIf: "Machen Sie ein einzelnes Panel sichtbar, wenn",
            hideNumber: "Ausblenden der Panel-Nummer",
            titleLocation: "Ausrichtung des Panel-Titels",
            descriptionLocation: "Ausrichtung der Panelbeschreibung",
            templateTitleLocation: "Ausrichtung des Fragetitels",
            templateErrorLocation: "Ausrichtung von Fehlermeldungen",
            newPanelPosition: "Neue Panel-Position",
            keyName: "Doppelte Antworten in der folgenden Frage verhindern"
        },
        question: {
            name: "Name der Frage",
            title: "Titel der Frage",
            description: "Beschreibung der Frage",
            visibleIf: "Frage sichtbar machen, wenn",
            requiredIf: "Frage erforderlich machen, wenn",
            page: "Frage auf die Seite verschieben",
            state: "Status des Ausblendens des Fragefelds",
            hideNumber: "Ausblenden der Fragenummer",
            titleLocation: "Ausrichtung des Fragetitels",
            descriptionLocation: "Ausrichtung der Fragebeschreibung",
            errorLocation: "Ausrichtung von Fehlermeldungen",
            indent: "Innerer Einzug vergrößern",
            width: "Breite der Inline-Frage",
            minWidth: "Minimale Fragebreite",
            maxWidth: "Maximale Fragebreite",
            textUpdateMode: "Eingabefeldwert aktualisieren"
        },
        signaturepad: {
            signatureWidth: "Breite des Signaturbereichs",
            signatureHeight: "Höhe des Signaturbereichs",
            signatureAutoScaleEnabled: "Automatisches Skalieren des Signaturbereichs",
            showPlaceholder: "Platzhalter anzeigen",
            placeholder: "Platzhaltertext",
            placeholderReadOnly: "Platzhaltertext im schreibgeschützten oder Vorschaumodus",
            allowClear: "Schaltfläche \"Löschen\" im Signaturbereich anzeigen",
            penMinWidth: "Minimale Stiftbreite",
            penMaxWidth: "Maximale Stiftbreite",
            penColor: "Farbe des Strichs"
        },
        comment: {
            rows: "Höhe des Eingabefeldes (in Zeilen)"
        },
        showQuestionNumbers: "Fragennummern anzeigen",
        questionStartIndex: "Startindex der Fragen (bspw. \"1\", \"A\", \"a\", ...)",
        expression: {
            name: "Name des Ausdrucks",
            title: "Titel des Ausdrucks",
            description: "Beschreibung des Ausdrucks",
            expression: "Ausdruck"
        },
        trigger: {
            expression: "Ausdruck"
        },
        calculatedvalue: {
            expression: "Ausdruck"
        },
        // survey templates
        survey: {
            title: "Titel",
            description: "Beschreibung der Umfrage"
        },
        page: {
            name: "Name der Seite",
            title: "Titel",
            description: "Seitenbeschreibung",
            visibleIf: "Seite sichtbar machen, wenn",
            requiredIf: "Seite erforderlich machen, wenn",
            maxTimeToFinish: "Zeitlimit zum Beenden der Seite (in Sekunden)",
            questionsOrder: "Reihenfolge der Fragen auf der Seite"
        },
        matrixdropdowncolumn: {
            name: "Name der Spalte",
            title: "Titel der Spalte",
            isUnique: "Doppelte Beantwortungen verhindern",
            width: "Spaltenbreite",
            minWidth: "Minimale Spaltenbreite",
            rows: "Höhe des Eingabefeldes (in Zeilen)",
            visibleIf: "Spalte sichtbar machen, wenn",
            requiredIf: "Spalte erforderlich machen, wenn",
            showInMultipleColumns: "Jede Option in einer separaten Spalte"
        },
        multipletextitem: {
            name: "Name",
            title: "Titel"
        },
        masksettings: {
            saveMaskedValue: "Maskierte Werte in Umfrageergebnissen speichern"
        },
        patternmask: {
            pattern: "Werte-Muster"
        },
        datetimemask: {
            min: "Mindestwert",
            max: "Maximalwert"
        },
        numericmask: {
            allowNegativeValues: "Negative Werte zulassen",
            thousandsSeparator: "Tausender-Trennzeichen",
            decimalSeparator: "Dezimaltrennzeichen",
            precision: "Wertgenauigkeit",
            min: "Mindestwert",
            max: "Maximalwert"
        },
        currencymask: {
            prefix: "Währungs-Präfix",
            suffix: "Währungs-Suffix"
        },
        imageHeight: "Bildhöhe",
        imageWidth: "Bildbreite",
        valueName: "Name der Antwort",
        rateDescriptionLocation: "Ausrichtung der Beschriftung",
        size: "Größe des Eingabefeldes (in Zeichen)",
        cellErrorLocation: "Ausrichtung von Zellenfehlermeldungen",
        apply: "Anwenden",
        ok: "OK",
        save: "Speichern",
        clear: "Leeren",
        saveTooltip: "Speichern",
        cancel: "Abbrechen",
        set: "Setze",
        reset: "Zurücksetzen",
        change: "Verändern",
        refresh: "Neu laden",
        close: "Schliessen",
        delete: "Löschen",
        add: "Hinzufügen",
        addNew: "Neues Element hinzufügen",
        addItem: "Klicken, um ein Element hinzuzufügen ...",
        removeItem: "Klicken, um ein Element zu entfernen ...",
        dragItem: "Element ziehen",
        addOther: "Weiteres Element",
        addSelectAll: "Alle Elemente auswählen hinzufügen",
        addNone: "Alle Elemente abwählen hinzufügen",
        removeAll: "Alle löschen",
        edit: "Bearbeiten",
        back: "Zurück ohne zu speichern",
        backTooltip: "Zurück ohne zu speichern",
        saveAndBack: "Speichern und zurück",
        saveAndBackTooltip: "Speichern und zurück",
        doneEditing: "Fertig",
        editChoices: "Auswahlmöglichkeiten bearbeiten",
        showChoices: "Auswahlmöglichkeiten anzeigen",
        move: "Verschieben",
        empty: "<leer>",
        emptyValue: "Wert is leer",
        fastEntry: "Schnelleintrag",
        fastEntryNonUniqueError: "Wert '{0}' ist nicht eindeutig",
        fastEntryChoicesCountError: "Anzahl der Elemente von {0} bis {1} begrenzen",
        fastEntryChoicesMinCountError: "Bitte geben Sie mindestens {0} Artikel ein",
        fastEntryPlaceholder: "Daten im folgenden Format setzen:\nwert1|text\nwert2",
        formEntry: "Formulareintrag",
        testService: "Service testen",
        itemSelectorEmpty: "Bitte ein Element auswählen",
        conditionActionEmpty: "Bitte eine Aktion auswählen",
        conditionSelectQuestion: "Frage auswählen ...",
        conditionSelectPage: "Seite auswählen ...",
        conditionSelectPanel: "Panel auswählen ...",
        conditionValueQuestionTitle: "Bitte den Wert eingeben oder auswählen",
        aceEditorHelp: "Bitte drücken Sie Strg+Leertaste, um Vervollständigungsvorschläge für den Ausdruck zu erhalten",
        aceEditorRowTitle: "Aktuelle Zeile",
        aceEditorPanelTitle: "Aktuelles Panel",
        showMore: "Weitere Informationen finden Sie in der Dokumentation",
        assistantTitle: "Verfügbare Fragen:",
        cellsEmptyRowsColumns: "Es sollte mindestens eine Spalte oder Zeile geben",
        showPreviewBeforeComplete: "Vorschau der Antworten vor dem Absenden anzeigen",
        overridingPropertyPrefix: "Gesetzt von ",
        resetToDefaultCaption: "Zurücksetzen",
        propertyIsEmpty: "Bitte geben Sie einen Wert ein",
        propertyIsNoUnique: "Bitte geben Sie einen eindeutigen Wert ein",
        propertyNameIsNotUnique: "Bitte geben Sie einen eindeutigen Wert ein",
        propertyNameIsIncorrect: "Verwenden Sie keine reservierten Wörter: \"Element\", \"Auswahl\", \"Panel\", \"Zeile\".",
        listIsEmpty: "Neues Element hinzufügen",
        "listIsEmpty@choices": "Bisher wurden noch keine Auswahlmöglichkeiten hinzugefügt",
        "listIsEmpty@columns": "Sie haben noch keine Spalten",
        "listIsEmpty@rows": "Sie haben noch keine Zeilen",
        "listIsEmpty@validators": "Sie haben noch keine Validierungsregeln",
        "listIsEmpty@calculatedValues": "Sie haben noch keine benutzerdefinierten Variablen",
        "listIsEmpty@triggers": "Sie haben noch keine Auslöser",
        "listIsEmpty@navigateToUrlOnCondition": "Sie haben noch keine Links",
        "addNew@choices": "Auswahlmöglichkeit hinzufügen",
        "addNew@columns": "Neue Spalte hinzufügen",
        "addNew@rows": "Neue Zeile hinzufügen",
        "addNew@validators": "Neue Regel hinzufügen",
        "addNew@calculatedValues": "Neue Variable hinzufügen",
        "addNew@triggers": "Neuen Auslöser hinzufügen",
        "addNew@navigateToUrlOnCondition": "Neue URL hinzufügen",
        expressionIsEmpty: "Keinen Ausdruck definiert",
        value: "Wert",
        text: "Text",
        rowid: "Zeilen-ID",
        imageLink: "Link auf das Bild",
        columnEdit: "Spalte bearbeiten: {0}",
        itemEdit: "Element bearbeiten: {0}",
        url: "URL",
        path: "Pfad",
        choicesbyurl: {
            url: "URL des Webdienstes",
            valueName: "Werte von folgenden JSON Feld übernehmen"
        },
        titleName: "Name des Titels",
        imageLinkName: "Name des Links zum Bild",
        allowEmptyResponse: "Keine Antwort erlauben",
        titlePlaceholder: "Titel eingeben",
        surveyTitlePlaceholder: "Umfragetitel eingeben",
        pageTitlePlaceholder: "Seitenbeschreibung eingeben",
        descriptionPlaceholder: "Beschreibung eingeben",
        surveyDescriptionPlaceholder: "Umfragebeschreibung eingeben",
        pageDescriptionPlaceholder: "Seitenbeschreibung eingeben",
        textWrapEnabled: "Wrap-Auswahl",
        showOtherItem: "\"Sonstiges\" auswählbar?",
        otherText: "Text für \"Sonstiges\"",
        showNoneItem: "Alle Elemente abwählbar?",
        showRefuseItem: "Option \"Antwort ablehnen\" zulassen",
        showDontKnowItem: "Option \"Weiß nicht\" zulassen",
        noneText: "Text für die Abwahl aller Elemente",
        showSelectAllItem: "Alle Elemente auswählbar?",
        selectAllText: "Text für die Auswahl aller Elemente",
        choicesMin: "Minimaler Wert für automatisch erzeugte Elemente",
        choicesMax: "Maximaler Wert für automatisch erzeugte Elemente",
        choicesStep: "Schrittwert für automatisch erzeugte Elemente",
        name: "Name",
        title: "Titel",
        cellType: "Zellentyp",
        colCount: "Spaltenanzahl",
        choicesOrder: "Auswahlreihenfolge",
        visible: "Sichtbar?",
        isRequired: "Erforderlich?",
        markRequired: "Als erforderlich markieren",
        removeRequiredMark: "Erforderliche Markierung entfernen",
        isAllRowRequired: "Eine Antwort in jeder Zeile erforderlich machen",
        eachRowUnique: "Doppelte Beantwortungen in Zeilen verhindern",
        requiredErrorText: "Fehlermeldung bei nicht beantworteten erforderlichen Fragen",
        startWithNewLine: "Mit einer neuen Zeile starten",
        rows: "Zeilenanzahl",
        cols: "Spaltenanzahl",
        placeholder: "Platzhalter",
        showPreview: "Bildvorschau angezeigen",
        storeDataAsText: "Dateininhalt des JSON-Resultats als Text speichern",
        maxSize: "Maximale Dateigröße in Bytes",
        rowCount: "Zeilenanzahl",
        columnLayout: "Spaltenlayout",
        addRowLocation: "Zeilenknopfposition hinzufügen",
        transposeData: "Transponieren von Zeilen in Spalten",
        addRowText: "Text für die Schaltfläche \"Zeile hinzufügen\"",
        removeRowText: "Text für die Schaltfläche \"Zeile entfernen\"",
        rateMin: "Minimum",
        rateMax: "Maximum",
        rateStep: "Schritt Bewertung",
        minRateDescription: "Beschreibung für minimale Bewertung",
        maxRateDescription: "Beschreibung für maximale Bewertung",
        inputType: "Eingabetyp",
        optionsCaption: "Auswahlbeschriftung",
        defaultValue: "Standardantwort",
        cellsDefaultRow: "Standardzellentext",
        surveyEditorTitle: "Umfrageeinstellungen bearbeiten",
        qEditorTitle: "Frage bearbeiten: {0}",
        maxLength: "Maximale Länge",
        buildExpression: "Einfach",
        editExpression: "Erweitert",
        and: "und",
        or: "oder",
        remove: "Entfernen",
        addCondition: "Bedingung hinzufügen",
        emptyLogicPopupMessage: "Wählen Sie eine Frage aus, um die Bedingungen festzulegen.",
        if: "Wenn",
        then: "dann",
        setToName: "von",
        fromName: "bis",
        gotoName: "Zur Frage springen",
        ruleIsNotSet: "Regel is nicht korrekt",
        includeIntoResult: "In Umfrageergebnisse einbeziehen",
        showTitle: "Titel anzeigen",
        expandCollapseTitle: "Titel ausklappen/einklappen",
        locale: "Standardsprache",
        simulator: "Gerät auswählen",
        landscapeOrientation: "Querformat",
        portraitOrientation: "Hochformat",
        mode: "Modus (editierbar/schreibgeschützt)",
        clearInvisibleValues: "Alle unsichtbaren Werte leeren",
        cookieName: "Cookie-Name (um zu unterdrücken, dass die Umfrage lokal zwei Mal ausgefüllt werden kann)",
        sendResultOnPageNext: "Umfrageergebnisse beim Seitenwechsel automatisch speichern",
        storeOthersAsComment: "\"Sonstige\" Werte als Kommentar speichern",
        showPageTitles: "Seitenbeschreibung anzeigen",
        showPageNumbers: "Seitennummern anzeigen",
        pagePrevText: "Text für die Schaltfläche \"Vorherige Seite\"",
        pageNextText: "Text für die Schaltfläche \"Nächste Seite\"",
        completeText: "Text für die Schaltfläche \"Abschließen\"",
        previewText: "Text für die Schaltfläche \"Vorschau\"",
        editText: "Text für die Schaltfläche \"Antwort bearbeiten\"",
        startSurveyText: "Text für die Schaltfläche \"Umfrage starten\"",
        showNavigationButtons: "Navigationsschaltflächen anzeigen",
        showPrevButton: "Schaltfläche \"Vorherige Seite\" anzeigen (Benutzer können auf die vorherige Seite zurückkehren)",
        firstPageIsStarted: "Die erste Seite der Umfrage ist die Startseite",
        showCompletedPage: "Nach Abschluss die Seite \"Umfrage abgeschlossen\" anzeigen",
        goNextPageAutomatic: "Automatisch zur nächsten Seiten wechseln",
        allowCompleteSurveyAutomatic: "Umfrage automatisch ausfüllen",
        showProgressBar: "Fortschrittsbalken anzeigen",
        questionTitleLocation: "Position des Fragentitels",
        questionTitleWidth: "Breite des Fragetitels",
        requiredText: "Symbol für erforderliche Fragen",
        questionTitleTemplate: "Template für den Fragentitel. Standard ist: \"{no}. {require} {title}\"",
        questionErrorLocation: "Position der Fehlermeldungen",
        focusFirstQuestionAutomatic: "Erste Frage auf einer neuen Seite fokussieren",
        questionsOrder: "Reihenfolge der Fragen auf der Seite",
        maxTimeToFinish: "Maximale Zeit, um die Umfrage zu beenden",
        maxTimeToFinishPage: "Maximale Zeit, um eine Seite der Umfrage zu beenden",
        showTimerPanel: "Position des Timers",
        showTimerPanelMode: "Modus des Timers",
        renderMode: "Anzeigemodus",
        allowAddPanel: "Hinzufügen eines Panels erlauben",
        allowRemovePanel: "Entfernen eines Panels erlauben",
        panelAddText: "Text für die Schaltfläche \"Panel hinzufügen\"",
        panelRemoveText: "Text für die Schaltfläche \"Panel entfernen\"",
        isSinglePage: "Alle Elemente auf einer Seite anzeigen",
        html: "HTML",
        setValue: "Antwort",
        dataFormat: "Bildformat",
        allowAddRows: "Hinzufügen von Zeilen zulassen",
        allowRemoveRows: "Entfernen von Zeilen zulassen",
        allowRowsDragAndDrop: "Verschieben von Zeilen zulassen",
        responsiveImageSizeHelp: "Gilt nicht, wenn Sie die genaue Bildbreite oder -höhe angeben.",
        minImageWidth: "Minimale Bildbreite",
        maxImageWidth: "Maximale Bildbreite",
        minImageHeight: "Minimale Bildhöhe",
        maxImageHeight: "Maximale Bildhöhe",
        minValue: "Minimaler Wert",
        maxValue: "Maximaler Wert",
        minLength: "Minimale Länge",
        allowDigits: "Ziffern erlaubt",
        minCount: "Minimale Anzahl",
        maxCount: "Maximale Anzahl",
        regex: "Regulärer Ausdruck",
        surveyvalidator: {
            text: "Fehlermeldung",
            expression: "Validierungsausdruck"
        },
        totalText: "Text (total)",
        totalType: "Typ (total)",
        totalExpression: "Ausdruck (total)",
        totalDisplayStyle: "Anzeigestil (total)",
        totalCurrency: "Währung (total)",
        totalFormat: "Format (total)",
        logo: "Logo (URL oder base64-codierte Zeichenfolge)",
        questionsOnPageMode: "Umfrage Struktur",
        maxTextLength: "Maximale Antwortlänge (in Zeichen)",
        maxOthersLength: "Maximale Kommentarlänge (in Zeichen)",
        commentAreaRows: "Höhe des Kommentarbereichs (in Zeilen)",
        autoGrowComment: "Kommentarbereich bei Bedarf automatisch erweitern",
        allowResizeComment: "Benutzern erlauben, die Größe von Textbereichen zu ändern",
        textUpdateMode: "Wert der Textfrage aktualisieren",
        maskType: "Typ der Eingabemaske",
        maskTypes: {
            none: "Nichts",
            patternmask: "Muster",
            numericmask: "Numerisch",
            datetimemask: "Datum und Uhrzeit",
            currencymask: "Währung"
        },
        focusOnFirstError: "Fokus auf die erste ungültige Antwort setzen",
        checkErrorsMode: "Validierung ausführen",
        navigateToUrl: "Zur externen URL umleiten",
        navigateToUrlOnCondition: "Dynamische URL",
        completedBeforeHtml: "Markup, um anzuzeigen, ob der Benutzer diese Umfrage bereits ausgefüllt hat",
        completedHtml: "Markup der Seite \"Umfrage abgeschlossen\".",
        completedHtmlOnCondition: "Dynamisches Markup der Seite \"Umfrage abgeschlossen\".",
        loadingHtml: "Markup, das angezeigt werden soll, während die Umfrage geladen wird",
        commentText: "Text im Kommentarbereich",
        autocomplete: "Autocomplete-Typ",
        labelTrue: "Bezeichner \"Wahr\".",
        labelFalse: "Bezeichner \"Falsch\"",
        allowClear: "Überschrift der Auswahlmöglichkeiten anzeigen",
        searchMode: "Suchmodus",
        displayStyle: "Wertanzeigestil",
        format: "Formatierte Zeichenfolge",
        maximumFractionDigits: "Maximale Nachkommastellen",
        minimumFractionDigits: "Minimale Nachkommastellen",
        useGrouping: "Gruppierungstrennzeichen anzeigen",
        allowMultiple: "Mehrere Dateien zulassen",
        allowImagesPreview: "Vorschaubilder",
        acceptedTypes: "Akzeptierte Dateitypen",
        waitForUpload: "Warten bis der Upload abgeschlossen ist",
        needConfirmRemoveFile: "Löschen der Datei bestätigen",
        detailPanelMode: "Position des Detailbereichs",
        minRowCount: "Mindestzeilenanzahl",
        maxRowCount: "Maximale Zeilenanzahl",
        confirmDelete: "Zeilenlöschung bestätigen",
        confirmDeleteText: "Bestätigungsmeldung",
        panelCount: "Anfängliche Panel-Anzahl",
        minPanelCount: "Minimale Panelanzahl",
        maxPanelCount: "Maximale Panelanzahl",
        panelsState: "Erweiterungszustand des inneren Bereichs",
        panelPrevText: "Text für die Schaltfläche \"Vorheriges Panel\".",
        panelNextText: "Text für die Schaltfläche \"Nächstes Panel\".",
        showRangeInProgress: "Fortschrittsbalken anzeigen",
        panelRemoveButtonLocation: "Position der Schaltfläche \"Panel entfernen\"",
        hideIfRowsEmpty: "Frage ausblenden, wenn keine Zeilen vorhanden sind",
        hideColumnsIfEmpty: "Spalten ausblenden, wenn keine Zeilen vorhanden sind",
        rateValues: "Benutzerdefinierte Bewertungswerte",
        rateCount: "Anzahl der Bewertung",
        autoGenerate: "Bewertung konfigurieren",
        hideIfChoicesEmpty: "Frage ausblenden, wenn sie keine Auswahlmöglichkeiten enthält",
        minWidth: "Minimale Breite",
        maxWidth: "Maximale Breite",
        width: "Breite ",
        showHeader: "Spaltenüberschriften anzeigen",
        horizontalScroll: "Horizontaler Scrollbar anzeigen",
        columnMinWidth: "Minimale Spaltenbreite",
        rowTitleWidth: "Breite der Zeilenüberschrift",
        valueTrue: "Zu speichender Wert wenn \"Wahr\" ausgewählt wird",
        valueFalse: "Zu speichender Wert wenn \"Falsch\" ausgewählt wird",
        minErrorText: "Fehlermeldung \"Wert liegt unter dem Mindestwert\"",
        maxErrorText: "Fehlermeldung \"Wert überschreitet das Maximum\"",
        otherErrorText: "Fehlermeldung \"Leerer Kommentar\"",
        keyDuplicationError: "Fehlermeldung bei doppelter Beantwortung",
        minSelectedChoices: "Mindestanzahl an Auswahlmöglichkeiten",
        maxSelectedChoices: "Maximum an Auswahlmöglichkeiten",
        showClearButton: "Schaltfläche \"Löschen\" anzeigen",
        logoWidth: "Logobreite",
        logoHeight: "Logohöhe",
        readOnly: "Schreibgeschützt",
        enableIf: "Bearbeitbar, wenn",
        emptyRowsText: "Meldung \"Keine Zeilen\"",
        separateSpecialChoices: "Spezielle Auswahlmöglichkeiten separieren",
        choicesFromQuestion: "Auswahlmöglichkeiten aus folgender Frage kopieren",
        choicesFromQuestionMode: "Auswahlmöglichkeiten, die kopiert werden sollen",
        progressBarShowPageTitles: "Seitentitel in der Fortschrittsbalke anzeigen",
        progressBarShowPageNumbers: "Seitenzahlen in der Fortschrittsbalke anzeigen",
        showCommentArea: "Kommentarbereich anzeigen",
        commentPlaceholder: "Platzhaltertext für den Kommentarbereich",
        displayRateDescriptionsAsExtremeItems: "Beschreibung für minimale und maximale Bewertung als Werte anzeigen",
        rowsOrder: "Reihenfolge der Zeilen",
        columnsLayout: "Spalten-Layout",
        columnColCount: "Anzahl der geschachtelten Spalten",
        correctAnswer: "Richtige Antwort",
        defaultPanelValue: "Standardwerte",
        cells: "Zellentexte",
        fileInputPlaceholder: "Wählen Sie eine Datei aus oder fügen Sie einen Dateilink ein...",
        keyName: "Spalte \"Schlüssel\"",
        itemvalue: {
            visibleIf: "Option sichtbar machen, wenn",
            enableIf: "Option auswählbar machen, wenn"
        },
        "itemvalue@rows": {
            visibleIf: "Zeile sichtbar machen, wenn",
            enableIf: "Zeile bearbeitbar machen, wenn"
        },
        imageitemvalue: {
            text: "Alt-Text"
        },
        logoPosition: "Logoposition",
        addLogo: "Logo hinzufügen ...",
        changeLogo: "Logo bearbeiten ...",
        logoPositions: {
            none: "ausblenden",
            left: "links",
            right: "rechts",
            top: "oben",
            bottom: "unten"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Panel-Layout"
            },
            general: "Allgemein",
            fileOptions: "Optionen",
            html: "Html-Editor",
            columns: "Spalten",
            rows: "Zeilen",
            choices: "Auswahlmöglichkeiten",
            items: "Elemente",
            visibleIf: "Sichtbar wenn ...",
            enableIf: "Aktiviert wenn ...",
            requiredIf: "Erforderlich wenn ...",
            rateValues: "Bewertungsskala",
            choicesByUrl: "Auswahlmöglichkeiten aus dem Internet",
            matrixChoices: "Standardauswahl",
            multipleTextItems: "Texteingabe",
            numbering: "Nummerierung",
            validators: "Überprüfung",
            navigation: "Navigation",
            question: "Fragen",
            pages: "Seiten",
            timer: "Timer",
            calculatedValues: "Berechnete Werte",
            triggers: "Auslöser",
            templateTitle: "Titeltemplate",
            totals: "Summen",
            logic: "Logik",
            mask: "Einstellungen für die Eingabemaske",
            layout: {
                panel: "Layout",
                question: "Layout",
                base: "Layout"
            },
            data: "Daten",
            validation: "Validierung",
            cells: "Zellen",
            showOnCompleted: "Abschluss",
            logo: "Logo im Umfragetitel",
            slider: "Slider",
            expression: "Ausdruck",
            questionSettings: "Einstellungen für Fragen",
            header: "Titelzeile",
            background: "Hintergrund",
            appearance: "Erscheinungsbild",
            others: "Weiteres"
        },
        editProperty: "Eigenschaft bearbeiten '{0}'",
        items: "Eiträge",
        choicesVisibleIf: "Auswahl sichtbar machen, wenn",
        choicesEnableIf: "Auswahl wählbar machen, wenn",
        columnsEnableIf: "Spalten sichtbar machen, wenn",
        rowsEnableIf: "Zeilen sichtbar machen, wenn",
        innerIndent: "Inneren Einzug vergrößern",
        defaultValueFromLastRow: "Werte aus der letzten Zeile als Standard festlegen",
        defaultValueFromLastPanel: "Werte aus dem letzten Panel als Standard festlegen",
        enterNewValue: "Bitte einen Wert eingeben.",
        noquestions: "Die Umfrage enthält keine Fragen.",
        createtrigger: "Bitte einen Auslöser eingeben.",
        titleKeyboardAdornerTip: "Drücken Sie ENTER, um bearbeiten zu können",
        keyboardAdornerTip: "Drücken Sie ENTER, um das Element zu bearbeiten, ENTFERNEN, um das Element zu entfernen, STRG + PFEIL NACH OBEN/UNTEN, um das Element zu verschieben",
        triggerOn: "Ein",
        triggerMakePagesVisible: "Seiten sichtbar machen:",
        triggerMakeQuestionsVisible: "Elemente sichtbar machen:",
        triggerCompleteText: "Bei Erfolg die Umfrage abschließen.",
        triggerNotSet: "Der Auslöser ist nicht gesetzt",
        triggerRunIf: "Ausführen wenn ...",
        triggerSetToName: "Wert ändern von: ",
        triggerFromName: "Wert kopieren von: ",
        triggerRunExpression: "Diesen Ausdruck ausführen:",
        triggerSetValue: "nach: ",
        triggerGotoName: "Zu Frage:",
        triggerIsVariable: "Die Variable nicht in das Umfrageergebnis setzen.",
        triggerRunExpressionEmpty: "Bitte geben Sie einen gültigen Ausdruck ein",
        emptyExpressionPlaceHolder: "Ausdruck hier eingeben ...",
        noFile: "Keine Datei ausgewählt",
        clearIfInvisible: "Wert löschen, wenn die Frage ausgeblendet wird",
        valuePropertyName: "Werte in dieser Eigenschaft speichern",
        searchEnabled: "Suche aktivieren",
        hideSelectedItems: "Ausgewählte Elemente ausblenden",
        closeOnSelect: "Dropdown-Menü nach der Auswahl schließen",
        verticalAlign: "Vertikale Ausrichtung",
        alternateRows: "Zeilen wechseln",
        columnsVisibleIf: "Spalten sichtbar machen, wenn",
        rowsVisibleIf: "Zeilen sichtbar machen, wenn",
        otherPlaceholder: "Platzhaltertext für den Kommentarbereich",
        filePlaceholder: "Platzhaltertext für Dateien",
        photoPlaceholder: "Platzhaltertext für Fotos",
        fileOrPhotoPlaceholder: "Datei- oder Foto-Platzhaltertext",
        rateType: "Bewertungssymbol",
        url_placeholder: "Bsp.: https://api.example.com/books",
        path_placeholder: "Bsp.: categories.fiction",
        questionStartIndex_placeholder: "Bsp.: a)",
        width_placeholder: "Bsp.: 6in",
        minWidth_placeholder: "Bsp.: 600px",
        maxWidth_placeholder: "Bsp.: 50%",
        imageHeight_placeholder: "auto",
        imageWidth_placeholder: "auto",
        theme: {
            themeName: "Thema",
            isPanelless: "Aussehen der Frage",
            editorPanel: "Hintergrund und Eckenradius",
            questionPanel: "Hintergrund und Eckenradius",
            primaryColor: "Akzentfarbe",
            panelBackgroundTransparency: "Deckkraft des Bedienfeldhintergrunds",
            questionBackgroundTransparency: "Deckkraft des Hintergrunds der Frage",
            fontSize: "Schriftgrad",
            scale: "Maßstab",
            cornerRadius: "Ecken-Radius",
            pageTitle: "Schriftart des Titels",
            pageDescription: "Beschreibung Schriftart",
            questionTitle: "Schriftart des Titels",
            questionDescription: "Beschreibung Schriftart",
            editorFont: "Schriftart",
            backgroundOpacity: "Undurchsichtigkeit",
            "--sjs-font-family": "Schriftfamilie",
            "--sjs-general-backcolor-dim": "Hintergrundfarbe",
            "--sjs-primary-backcolor": "Akzent-Hintergrund",
            "--sjs-primary-forecolor": "Akzent Vordergrund",
            "--sjs-special-red": "Fehlermeldungen",
            "--sjs-shadow-small": "Schatten-Effekte",
            "--sjs-shadow-inner": "Schatten-Effekte",
            "--sjs-border-default": "Farben"
        },
        "header@header": {
            headerView: "Ansehen",
            logoPosition: "Logo-Position",
            surveyTitle: "Schriftart des Umfragetitels",
            surveyDescription: "Schriftart der Umfragebeschreibung",
            headerTitle: "Schriftart des Umfragetitels",
            headerDescription: "Schriftart der Umfragebeschreibung",
            inheritWidthFrom: "Breite des Inhaltsbereichs",
            textAreaWidth: "Textbreite",
            backgroundColorSwitch: "Hintergrundfarbe",
            backgroundImage: "Hintergrundbild",
            backgroundImageOpacity: "Undurchsichtigkeit",
            overlapEnabled: "Überlappung",
            logoPositionX: "Logo-Position",
            titlePositionX: "Titelposition",
            descriptionPositionX: "Beschreibung Position"
        }
    },
    // Property values
    pv: {
        "true": "wahr",
        "false": "falsch",
        file: "Lokale Dateien",
        camera: "Kamera",
        "file-camera": "Lokale Dateien oder Kamera",
        inherit: "vererbt",
        show: "anzeigen",
        hide: "verstecken",
        default: "Standard",
        initial: "initial",
        random: "zufällig",
        collapsed: "eingeklappt",
        expanded: "ausgeklappt",
        none: "/",
        asc: "aufsteigend",
        desc: "absteigend",
        indeterminate: "unentschieden",
        selected: "Ausgewählt",
        unselected: "Deaktiviert",
        decimal: "Dezimal",
        currency: "Währung",
        percent: "Prozent",
        firstExpanded: "ausgeklappt (erstes Element)",
        off: "aus",
        list: "Liste",
        progressTop: "oben (Fortschritt)",
        progressBottom: "unten (Fortschritt)",
        progressTopBottom: "oben und unten (Fortschritt)",
        tab: "Tabulatoren",
        horizontal: "horizontal",
        vertical: "vertikal",
        top: "oben",
        bottom: "unten",
        topBottom: "oben und unten",
        both: "beides",
        left: "links",
        right: "rechts",
        center: "Mitte",
        leftRight: "Links und rechts",
        middle: "Mitte",
        color: "Farbe",
        date: "Datum",
        datetime: "Datum/Uhrzeit",
        "datetime-local": "Datum/Uhrzeit (Lokal)",
        email: "E-Mail",
        month: "Monat",
        number: "Nummer",
        password: "Passwort",
        range: "Bereich",
        tel: "Telefon",
        text: "Text",
        time: "Uhrzeit",
        url: "URL",
        week: "Woche",
        hidden: "versteckt",
        edit: "Bearbeiten",
        display: "Anzeigen",
        contain: "Enthalten",
        cover: "Deckel",
        fill: "Füllen",
        next: "Nächster",
        last: "Letzte",
        onComplete: "Wenn die Umfrage abgeschlossen wird",
        onHidden: "Wenn die Umfrage versteckt wird",
        onHiddenContainer: "Wenn die Frage oder deren Panel/Seite versteckt wird",
        clearInvisibleValues: {
            none: "Nie"
        },
        clearIfInvisible: {
            none: "Nie"
        },
        inputType: {
            color: "Farbe",
            date: "Datum",
            "datetime-local": "Datum und Uhrzeit",
            email: "E-Mail",
            month: "Monat",
            number: "Zahl",
            password: "Passwort",
            range: "Bereich",
            tel: "Telefonnummer",
            text: "Text",
            time: "Zeit",
            url: "Web-URL",
            week: "Woche"
        },
        all: "alle",
        page: "Seite",
        survey: "Umfrage",
        onNextPage: "Wenn die Seite gewechselt wird",
        onValueChanged: "Wenn ein Wert geändert wird",
        onValueChanging: "Bevor eine Antwort geändert wird",
        questionsOnPageMode: {
            standard: "Ursprüngliche Struktur",
            singlePage: "Alle Fragen auf einer Seite anzeigen",
            questionPerPage: "Eine Frage pro Seite anzeigen"
        },
        noPreview: "Keine Vorschau",
        showAllQuestions: "Vorschau mit allen Fragen anzeigen",
        showAnsweredQuestions: "Vorschau mit beantworteten Fragen anzeigen",
        pages: "Seiten",
        questions: "Fragen",
        requiredQuestions: "Erforderliche Fragen",
        correctQuestions: "Richtig beantwortete Fragen",
        buttons: "Schaltflächen",
        underInput: "Unterhalb des Eingabefelds",
        underTitle: "Unterhalb des Titels",
        onBlur: "Bei verlorenem Fokus",
        onTyping: "Während der Eingabe",
        underRow: "Unter der Reihe",
        underRowSingle: "Unter der Zeile ist nur ein Bereich sichtbar",
        auto: "Auto",
        showNavigationButtons: {
            none: "Versteckt"
        },
        showTimerPanel: {
            none: "Versteckt"
        },
        showTimerPanelMode: {
            all: "Beide"
        },
        addRowLocation: {
            default: "Basierend auf dem Matrix-Layout"
        },
        panelsState: {
            default: "Benutzer können Panele nicht ein- oder ausblenden",
            collapsed: "Alle Panele einklappen",
            expanded: "Alle Panele ausklappen",
            firstExpanded: "Erstmals erweitert"
        },
        widthMode: {
            static: "Statisch",
            responsive: "Anpassend"
        },
        contentMode: {
            image: "Bild",
            video: "Video",
            youtube: "YouTube (Englisch)"
        },
        displayMode: {
            buttons: "Tasten",
            dropdown: "Dropdown-Liste"
        },
        rateColorMode: {
            default: "Default",
            scale: "Maßstab"
        },
        scaleColorMode: {
            monochrome: "Monochrom",
            colored: "Farbig"
        },
        autoGenerate: {
            "true": "Generieren",
            "false": "Manuell Eintragen"
        },
        rateType: {
            labels: "Beschriftung",
            stars: "Sterne",
            smileys: "Smileys"
        },
        state: {
            default: "Verschlossen"
        },
        showQuestionNumbers: {
            default: "Automatische Nummerierung",
            on: "Automatische Nummerierung",
            onPage: "Auf jeder Seite zurücksetzen",
            onpanel: "Bei jedem Panel zurücksetzen",
            onPanel: "Bei jedem Panel zurücksetzen",
            onSurvey: "Weiter in der Umfrage",
            off: "Keine Nummerierung"
        },
        descriptionLocation: {
            underTitle: "Unter dem Titel der Frage",
            underInput: "Unter dem Eingabefeld"
        },
        selectToRankAreasLayout: {
            horizontal: "Neben der Auswahl",
            vertical: "Über der Auswahl"
        },
        displayStyle: {
            decimal: "Dezimal",
            currency: "Währung",
            percent: "Prozentsatz",
            date: "Datum"
        },
        totalDisplayStyle: {
            decimal: "Dezimal",
            currency: "Währung",
            percent: "Prozentsatz",
            date: "Datum"
        },
        rowsOrder: {
            initial: "Original"
        },
        questionsOrder: {
            initial: "Original"
        },
        showProgressBar: {
            off: "Versteckt",
            topbottom: "oben und unten",
            aboveheader: "Über der Kopfzeile",
            belowheader: "Unterhalb der Kopfzeile"
        },
        sum: "Summe",
        count: "Zahl",
        min: "Min",
        max: "Max",
        avg: "Avg",
        searchMode: {
            contains: "Enthält",
            startsWith: "Beginnt mit"
        },
        backgroundImageFit: {
            auto: "Auto",
            cover: "Deckel",
            contain: "Enthalten",
            fill: "Strecken",
            tile: "Fliese"
        },
        backgroundImageAttachment: {
            fixed: "Fest",
            scroll: "Schriftrolle"
        },
        headerView: {
            basic: "Grundlegend",
            advanced: "Fortgeschritten"
        },
        inheritWidthFrom: {
            survey: "Wie bei der Umfrage",
            container: "An Container anpassen"
        },
        backgroundColorSwitch: {
            none: "Nichts",
            accentColor: "Akzentfarbe",
            custom: "Gewohnheit"
        },
        colorPalette: {
            light: "Licht",
            dark: "Dunkel"
        },
        isPanelless: {
            "false": "Vorgabe",
            "true": "Ohne Paneele"
        }
    },
    // Operators
    op: {
        empty: "ist leer",
        notempty: "ist nicht leer",
        equal: "ist gleich",
        notequal: "ist ungleich",
        contains: "enthält",
        notcontains: "enthält nicht",
        anyof: "eins aus",
        allof: "alle aus",
        greater: "größer als",
        less: "kleiner als",
        greaterorequal: "größer oder gleich als",
        lessorequal: "kleiner oder gleich als",
        and: "und",
        or: "oder"
    },
    // Embed window
    ew: {
        angular: "Angular-Version benutzen",
        jquery: "jQuery-Version benutzen",
        knockout: "Knockout-Version benutzen",
        react: "React-Version benutzen",
        vue: "Vue-Version benutzen",
        bootstrap: "Als Bootstrap-Framework",
        modern: "Theme: Modern",
        default: "Theme: Standard",
        orange: "Theme: Orange",
        darkblue: "Theme: Dunkelblau",
        darkrose: "Theme: Dunklerosa",
        stone: "Theme: Stein",
        winter: "Theme: Winter",
        winterstone: "Theme: Winterstein",
        showOnPage: "Umfrage auf Seite anzeigen",
        showInWindow: "Umfrage als Fenster anzeigen",
        loadFromServer: "Umfrage als JSON vom Server laden",
        titleScript: "Skripte und Styles",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Seite:",
        showInvisibleElements: "Unsichtbare Elemente anzeigen",
        hideInvisibleElements: "Unsichtbare Elemente ausblenden"
    },
    validators: {
        answercountvalidator: "Antwortanzahl",
        emailvalidator: "E-Mail",
        expressionvalidator: "Ausdruck",
        numericvalidator: "Zahl",
        regexvalidator: "Regulärer Ausdruck",
        textvalidator: "Text"
    },
    triggers: {
        completetrigger: "Umfrage abschließen",
        setvaluetrigger: "Wert setzen",
        copyvaluetrigger: "Wert kopieren",
        skiptrigger: "Frage wechseln",
        runexpressiontrigger: "Anweisung ausführen",
        visibletrigger: "Sichtbarkeit ändern (deprecated)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Bsp.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Beispiel: mm/tt/jjjj"
        },
        currencymask: {
            prefix: "Bsp.: $",
            suffix: "Bsp.: USD"
        },
        panelbase: {
            questionTitleWidth: "Beispiel: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "Eine Panel-ID, die für die Befragten nicht sichtbar ist.",
            description: "Geben Sie einen Untertitel für das Panel ein.",
            visibleIf: "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Sichtbarkeit des Panels bestimmt.",
            enableIf: "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die den schreibgeschützten Modus für das Panel deaktiviert.",
            requiredIf: "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Übermittlung von Umfragen verhindert, es sei denn, mindestens eine verschachtelte Frage enthält eine Antwort.",
            questionTitleLocation: "Gilt für alle Fragen in diesem Bereich. Wenn Sie diese Einstellung außer Kraft setzen möchten, definieren Sie Regeln für die Titelausrichtung für einzelne Fragen. Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an (standardmäßig \"Oben\").",
            questionTitleWidth: "Legt eine konsistente Breite für Fragetitel fest, wenn sie links neben den Fragefeldern ausgerichtet sind. Akzeptiert CSS-Werte (px, %, in, pt usw.).",
            questionErrorLocation: "Legt die Position einer Fehlermeldung in Bezug auf alle Fragen innerhalb des Bereichs fest. Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an.",
            questionsOrder: "Behält die ursprüngliche Reihenfolge der Fragen bei oder randomisiert sie. Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an.",
            page: "Positioniert das Panel am Ende einer ausgewählten Seite.",
            innerIndent: "Fügt Abstand oder Rand zwischen dem Inhalt des Panels und dem linken Rand des Panels hinzu.",
            startWithNewLine: "Deaktivieren Sie diese Option, um den Bereich in einer Zeile mit der vorherigen Frage oder dem vorherigen Bereich anzuzeigen. Die Einstellung gilt nicht, wenn der Bereich das erste Element in Ihrem Formular ist.",
            state: "Wählen Sie aus: \"Erweitert\" - das Panel wird vollständig angezeigt und kann eingeklappt werden; \"Reduziert\" - das Panel zeigt nur den Titel und die Beschreibung an und kann erweitert werden; \"Gesperrt\" - das Panel wird vollständig angezeigt und kann nicht eingeklappt werden.",
            width: "Legt die Breite des Fensters im Verhältnis zu anderen Vermessungselementen in derselben Linie fest. Akzeptiert CSS-Werte (px, %, in, pt usw.)."
        },
        paneldynamic: {
            name: "Eine Panel-ID, die für die Befragten nicht sichtbar ist.",
            description: "Geben Sie einen Untertitel für das Panel ein.",
            visibleIf: "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Sichtbarkeit des Panels bestimmt.",
            enableIf: "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die den schreibgeschützten Modus für das Panel deaktiviert.",
            requiredIf: "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Übermittlung von Umfragen verhindert, es sei denn, mindestens eine verschachtelte Frage enthält eine Antwort.",
            templateTitleLocation: "Gilt für alle Fragen in diesem Bereich. Wenn Sie diese Einstellung außer Kraft setzen möchten, definieren Sie Regeln für die Titelausrichtung für einzelne Fragen. Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an (standardmäßig \"Oben\").",
            templateErrorLocation: "Legt die Position einer Fehlermeldung in Bezug auf eine Frage mit ungültiger Eingabe fest. Wählen Sie zwischen: \"Oben\" - ein Fehlertext wird am oberen Rand des Fragefelds platziert; \"Unten\" - ein Fehlertext wird am unteren Rand des Fragefelds platziert. Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an (standardmäßig \"Oben\").",
            errorLocation: "Legt die Position einer Fehlermeldung in Bezug auf alle Fragen innerhalb des Bereichs fest. Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an.",
            page: "Positioniert das Panel am Ende einer ausgewählten Seite.",
            innerIndent: "Fügt Abstand oder Rand zwischen dem Inhalt des Panels und dem linken Rand des Panels hinzu.",
            startWithNewLine: "Deaktivieren Sie diese Option, um den Bereich in einer Zeile mit der vorherigen Frage oder dem vorherigen Bereich anzuzeigen. Die Einstellung gilt nicht, wenn der Bereich das erste Element in Ihrem Formular ist.",
            state: "Wählen Sie aus: \"Erweitert\" - das Panel wird vollständig angezeigt und kann eingeklappt werden; \"Reduziert\" - das Panel zeigt nur den Titel und die Beschreibung an und kann erweitert werden; \"Gesperrt\" - das Panel wird vollständig angezeigt und kann nicht eingeklappt werden.",
            width: "Legt die Breite des Fensters im Verhältnis zu anderen Vermessungselementen in derselben Linie fest. Akzeptiert CSS-Werte (px, %, in, pt usw.).",
            templateTitle: "Geben Sie eine Vorlage für die Titeln von dynamischen Panele. Verwenden Sie {panelIndex} für die allgemeine Position des Panels und {visiblePanelIndex} für die Reihenfolge der sichtbaren Panele. Fügen Sie diese Platzhalter in das Muster ein, um eine automatische Nummerierung hinzuzufügen.",
            templateTabTitle: "Geben Sie eine Vorlage für Tab-titel ein. Verwenden Sie {panelIndex} für die allgemeine Position eines Panels und {visiblePanelIndex} für die Reihenfolge der sichtbaren Panele. Fügen Sie diese Platzhalter in das Muster ein, um eine automatische Nummerierung hinzuzufügen.",
            tabTitlePlaceholder: "Ein Fallbacktext für Registerkartentitel, der angewendet wird, wenn das Registerkartentitelmuster keinen aussagekräftigen Wert erzeugt.",
            templateVisibleIf: "Mit dieser Einstellung können Sie die Sichtbarkeit einzelner Panele innerhalb des dynamischen Panels steuern. Verwenden Sie den Platzhalter '{panel}', um auf das aktuelle Panel in Ihrem Ausdruck zu verweisen.",
            titleLocation: "Diese Einstellung wird automatisch von allen Fragen in diesem Bereich übernommen. Wenn Sie diese Einstellung außer Kraft setzen möchten, definieren Sie Regeln für die Titelausrichtung für einzelne Fragen. Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an (standardmäßig \"Oben\").",
            descriptionLocation: "Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an (standardmäßig unter dem Panel-Titel).",
            newPanelPosition: "Definiert die Position eines neu hinzugefügten Panels. Standardmäßig werden neue Panele am Ende hinzugefügt. Wählen Sie \"Weiter\", um ein neues Panel nach dem aktuellen einzufügen.",
            defaultValueFromLastPanel: "Dupliziert die Antworten aus dem letzten Bereich und weist sie dem nächsten hinzugefügten dynamischen Bereich zu.",
            keyName: "Verweisen Sie auf einen Fragenamen, um einen Benutzer aufzufordern, in jedem Bereich eine eindeutige Antwort auf diese Frage zu geben."
        },
        defaultValueExpression: "Mit dieser Einstellung können Sie einen Standardantwortwert basierend auf einem Ausdruck zuweisen. Der Ausdruck kann grundlegende Berechnungen enthalten - '{q1_id} + {q2_id}', boolesche Ausdrücke wie '{age} > 60' und Funktionen: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' usw. Der durch diesen Ausdruck ermittelte Wert dient als anfänglicher Standardwert, der durch die manuelle Eingabe eines Befragten überschrieben werden kann.",
        resetValueIf: "Verwenden Sie das Zauberstabsymbol, um eine Bedingungsregel festzulegen, die bestimmt, wann die Eingabe eines Befragten auf den Wert zurückgesetzt wird, der auf dem Wert \"Standardwertausdruck\" oder \"Wertausdruck festlegen\" oder auf dem Wert \"Standardantwort\" (falls einer dieser Werte festgelegt ist) basiert.",
        setValueIf: "Verwenden Sie das Zauberstabsymbol, um eine Bedingungsregel festzulegen, die bestimmt, wann der \"Wertausdruck festlegen\" ausgeführt werden soll, und weisen Sie den resultierenden Wert dynamisch als Antwort zu.",
        setValueExpression: "Geben Sie einen Ausdruck an, der den Wert definiert, der festgelegt werden soll, wenn die Bedingungen in der Regel \"Wert festlegen, wenn\" erfüllt sind. Der Ausdruck kann grundlegende Berechnungen enthalten - '{q1_id} + {q2_id}', boolesche Ausdrücke wie '{age} > 60' und Funktionen: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' usw. Der durch diesen Ausdruck ermittelte Wert kann durch die manuelle Eingabe eines Befragten überschrieben werden.",
        question: {
            name: "Eine Frage-ID, die für die Befragten nicht sichtbar ist.",
            description: "Geben Sie einen Untertitel für die Frage ein.",
            visibleIf: "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Sichtbarkeit von Fragen bestimmt.",
            enableIf: "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die den schreibgeschützten Modus für die Frage deaktiviert.",
            requiredIf: "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die verhindert, dass die Umfrage fortgesetzt oder gesendet wird, es sei denn, die Frage wurde beantwortet.",
            startWithNewLine: "Deaktivieren Sie diese Option, um die Frage in einer Zeile mit der vorherigen Frage oder dem vorherigen Bereich anzuzeigen. Die Einstellung gilt nicht, wenn die Frage das erste Element in Ihrem Formular ist.",
            page: "Positioniert die Frage an das Ende einer ausgewählten Seite.",
            state: "Wählen Sie aus: \"Erweitert\" - das Fragefeld wird vollständig angezeigt und kann eingeklappt werden; \"Zugeklappt\" - das Fragefeld zeigt nur den Titel und die Beschreibung an und kann erweitert werden; \"Gesperrt\" - das Fragefeld wird vollständig angezeigt und kann nicht eingeklappt werden.",
            titleLocation: "Überschreibt Regeln für die Titelausrichtung, die auf Bereichs-, Seiten- oder Umfrageebene definiert sind. Mit der Option \"Vererben\" werden alle übergeordneten Einstellungen (falls gesetzt) oder Einstellungen auf Umfrageebene (\"Standardmäßig oben\") angewendet.",
            descriptionLocation: "Die Option \"Vererben\" wendet die Einstellung auf Umfrageebene an (\"Standardmäßig unter dem Fragetitel\").",
            errorLocation: "Legt die Position einer Fehlermeldung in Bezug auf die Frage mit ungültiger Eingabe fest. Wählen Sie zwischen: \"Oben\" - ein Fehlertext wird am oberen Rand des Fragefelds platziert; \"Unten\" - ein Fehlertext wird am unteren Rand des Fragefelds platziert. Die Option \"Vererben\" wendet die Einstellung auf Umfrageebene an (standardmäßig \"Oben\").",
            indent: "Fügt Leerzeichen oder Ränder zwischen dem Inhalt der Frage und dem linken Rand des Fragefelds hinzu.",
            width: "Legt die Breite der Frage im Verhältnis zu anderen Umfrageelementen in derselben Zeile fest. Akzeptiert CSS-Werte (px, %, in, pt usw.).",
            surveyvalidator: {
                expression: "Verwenden Sie das Zauberstabsymbol, um eine Validierungsregel für die Frage festzulegen."
            },
            textUpdateMode: "Wählen Sie aus: \"Bei Fokusverlust\" - der Wert wird aktualisiert, wenn das Eingabefeld den Fokus verliert; \"Während der Eingabe\" - der Wert wird in Echtzeit aktualisiert, während Benutzer tippen. Die Option \"Vererben\" wendet die Einstellung auf Umfrageebene an (\"Standardmäßig bei verlorenem Fokus\").",
            url: "Sie können einen beliebigen Webdienst als Datenquelle für Multiple-Choice-Fragen verwenden. Um Auswahlwerte aufzufüllen, geben Sie die URL des Diensts ein, der die Daten bereitstellt.",
            searchMode: "Ein Vergleichsvorgang, der zum Filtern der Dropdownliste verwendet wird.",
            textWrapEnabled: "Lange Texte in Auswahloptionen generieren automatisch Zeilenumbrüche, die in das Dropdown-Menü passen. Deaktivieren Sie diese Option, wenn die Texte abgeschnitten werden sollen."
        },
        signaturepad: {
            signatureWidth: "Legt die Breite des angezeigten Signaturbereichs und des resultierenden Bildes fest.",
            signatureHeight: "Legt die Höhe des angezeigten Signaturbereichs und des resultierenden Bildes fest.",
            signatureAutoScaleEnabled: "Wählen Sie diese Option aus, wenn der Signaturbereich den gesamten verfügbaren Platz innerhalb des Fragefelds ausfüllen soll, während das Standardseitenverhältnis von 3:2 beibehalten wird. Wenn benutzerdefinierte Werte für Breite und Höhe festgelegt sind, behält die Einstellung das Seitenverhältnis dieser Abmessungen bei."
        },
        file: {
            imageHeight: "Passt die Höhe des Bildes in den Umfrageergebnissen an.",
            imageWidth: "Passt die Breite des Bildes in den Umfrageergebnissen an."
        },
        image: {
            contentMode: "Die Option \"Auto\" bestimmt automatisch den geeigneten Anzeigemodus - Bild, Video oder YouTube - basierend auf der bereitgestellten Quell-URL."
        },
        imagepicker: {
            imageHeight: "Überschreibt die minimalen und maximalen Höhenwerte.",
            imageWidth: "Überschreibt die minimalen und maximalen Breitenwerte.",
            choices: "\"Wert\" dient als Element-ID, die in bedingten Regeln verwendet wird. Den Befragten wird \"Text\" angezeigt.",
            contentMode: "Wählen Sie zwischen \"Bild\" und \"Video\", um den Inhaltsmodus der Medienauswahl festzulegen. Wenn \"Bild\" ausgewählt ist, stellen Sie sicher, dass es sich bei allen bereitgestellten Optionen um Bilddateien in den folgenden Formaten handelt: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Wenn \"Video\" ausgewählt ist, stellen Sie sicher, dass alle Optionen direkte Links zu Videodateien in den folgenden Formaten sind: MP4, MOV, WMV, FLV, AVI, MKV. Bitte beachten Sie, dass YouTube-Links für Videooptionen nicht unterstützt werden."
        },
        text: {
            size: "Diese Einstellung ändert nur die Größe des Eingabefelds und wirkt sich nicht auf die Breite des Fragefelds aus. Um die zulässige Eingabelänge zu begrenzen, gehen Sie zu <b>Validierung → Maximales Zeichenlimit</b>."
        },
        comment: {
            rows: "Legt die Anzahl der angezeigten Zeilen im Eingabefeld fest. Wenn die Eingabe mehr Zeilen einnimmt, wird die Bildlaufleiste angezeigt."
        },
        // survey templates
        survey: {
            mode: "Wählen Sie zwischen: \"Bearbeiten\" - ermöglicht es den Befragten, Ihre Umfrage auszufüllen; \"Anzeigen\" - deaktiviert die Formularbearbeitung."
        },
        matrixdropdowncolumn: {
            name: "Eine Spalten-ID, die für die Befragten nicht sichtbar ist.",
            isUnique: "Wenn diese Option für eine Spalte aktiviert ist, muss ein Befragter für jede Frage in dieser Spalte eine eindeutige Antwort geben.",
            rows: "Legt die Anzahl der angezeigten Zeilen im Eingabefeld fest. Wenn die Eingabe mehr Zeilen einnimmt, wird die Bildlaufleiste angezeigt.",
            visibleIf: "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Sichtbarkeit von Spalten bestimmt.",
            enableIf: "Verwenden Sie das Zauberstabsymbol, um eine Bedingungsregel festzulegen, die den schreibgeschützten Modus für die Spalte deaktiviert.",
            requiredIf: "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Übermittlung von Umfragen verhindert, es sei denn, mindestens eine verschachtelte Frage enthält eine Antwort.",
            showInMultipleColumns: "Wenn diese Option aktiviert ist, wird für jede Auswahloption eine eigene Spalte erstellt."
        },
        widthMode: "Wählen Sie aus: \"Statisch\" - legt eine feste Breite fest; \"Responsive\" - lässt die Umfrage die gesamte Breite des Bildschirms einnehmen; \"Auto\" - wendet je nach verwendetem Fragetyp einen der beiden an.",
        cookieName: "Cookies verhindern, dass Benutzer dieselbe Umfrage zweimal ausfüllen.",
        logo: "Fügen Sie einen Bildlink ein (keine Größenbeschränkung) oder klicken Sie auf das Ordnersymbol, um eine Datei von Ihrem Computer (bis zu 64 KB) zu durchsuchen.",
        logoWidth: "Legt eine Logobreite in CSS-Einheiten (px, %, in, pt usw.) fest.",
        logoHeight: "Legt die Höhe eines Logos in CSS-Einheiten (px, %, in, pt usw.) fest.",
        logoFit: "Wählen Sie aus: \"Keine\" - das Bild behält seine ursprüngliche Größe; \"Enthalten\" - die Größe des Bildes wird angepasst, wobei das Seitenverhältnis beibehalten wird. \"Cover\" - das Bild füllt den gesamten Rahmen aus, während das Seitenverhältnis beibehalten wird. \"Füllen\" - Das Bild wird gestreckt, um den Rahmen auszufüllen, ohne das Seitenverhältnis beizubehalten.",
        goNextPageAutomatic: "Wählen Sie diese Option aus, wenn die Umfrage automatisch zur nächsten Seite weitergeleitet werden soll, nachdem ein Befragter alle Fragen auf der aktuellen Seite beantwortet hat.",
        allowCompleteSurveyAutomatic: "Wählen Sie diese Option aus, wenn die Umfrage automatisch abgeschlossen werden soll, nachdem ein Befragter alle Fragen beantwortet hat.",
        showNavigationButtons: "Legt die Sichtbarkeit und Position von Navigationsschaltflächen auf einer Seite fest.",
        showProgressBar: "Legt die Sichtbarkeit und Position einer Statusanzeige fest. Der Wert \"Auto\" zeigt den Fortschrittsbalken über oder unter der Kopfzeile der Umfrage an.",
        showPreviewBeforeComplete: "Aktivieren Sie die Vorschauseite nur mit allen oder beantworteten Fragen.",
        questionTitleLocation: "Gilt für alle Fragen innerhalb der Umfrage. Diese Einstellung kann durch Regeln für die Titelausrichtung auf niedrigeren Ebenen außer Kraft gesetzt werden: Bereich, Seite oder Frage. Eine Einstellung auf niedrigerer Ebene überschreibt die Einstellung auf einer höheren Ebene.",
        requiredText: "Ein Symbol oder eine Sequenz von Symbolen, die darauf hinweist, dass eine Antwort erforderlich ist.",
        questionStartIndex: "Geben Sie eine Zahl oder einen Buchstaben ein, mit der Sie die Nummerierung beginnen möchten.",
        questionErrorLocation: "Legt die Position einer Fehlermeldung in Bezug auf die Frage mit ungültiger Eingabe fest. Wählen Sie zwischen: \"Oben\" - ein Fehlertext wird am oberen Rand des Fragefelds platziert; \"Unten\" - ein Fehlertext wird am unteren Rand des Fragefelds platziert.",
        focusFirstQuestionAutomatic: "Wählen Sie diese Option aus, wenn das erste Eingabefeld auf jeder Seite für die Texteingabe bereit sein soll.",
        questionsOrder: "Behält die ursprüngliche Reihenfolge der Fragen bei oder randomisiert sie. Die Auswirkungen dieser Einstellung sind nur auf dem Tab \"Vorschau\" sichtbar.",
        maxTextLength: "Nur für Fragen zur Texteingabe.",
        maxOthersLength: "Nur für Fragenkommentare.",
        commentAreaRows: "Legt die Anzahl der angezeigten Zeilen in Textbereichen für Fragenkommentare fest. Wenn die Eingabe mehr Zeilen einnimmt, erscheint die Bildlaufleiste.",
        autoGrowComment: "Wählen Sie diese Option aus, wenn Fragenkommentare und Langtextfragen basierend auf der eingegebenen Textlänge automatisch in die Höhe wachsen sollen.",
        allowResizeComment: "Nur für Fragenkommentare und Langtextfragen.",
        calculatedValues: "Benutzerdefinierte Variablen dienen als Zwischen- oder Hilfsvariablen, die in Formularberechnungen verwendet werden. Sie nehmen die Eingaben der Befragten als Quellwerte. Jede benutzerdefinierte Variable hat einen eindeutigen Namen und einen Ausdruck, auf dem sie basiert.",
        includeIntoResult: "Wählen Sie diese Option aus, wenn der berechnete Wert des Ausdrucks zusammen mit den Umfrageergebnissen gespeichert werden soll.",
        triggers: "Ein Auslöser ist ein Ereignis oder eine Bedingung, die auf einem Ausdruck basiert. Sobald der Ausdruck als \"true\" ausgewertet wird, löst ein Auslöser eine Aktion aus. Eine solche Aktion kann optional eine Zielfrage haben, auf die sie sich auswirkt.",
        clearInvisibleValues: "Wählen Sie aus, ob und wann Werte für Fragen, die durch bedingte Logik ausgeblendet werden, gelöscht werden sollen.",
        textUpdateMode: "Wählen Sie aus: \"Bei Fokusverlust\" - der Wert wird aktualisiert, wenn das Eingabefeld den Fokus verliert; \"Während der Eingabe\" - der Wert wird in Echtzeit aktualisiert, während Benutzer tippen.",
        columns: "Der linke Wert dient als Spalten-ID, die in bedingten Regeln verwendet wird, der rechte Wert wird den Befragten angezeigt.",
        rows: "Der linke Wert dient als Zeilen-ID, die in bedingten Regeln verwendet wird, der rechte Wert wird den Befragten angezeigt.",
        columnMinWidth: "Akzeptiert CSS-Werte (px, %, in, pt usw.).",
        rowTitleWidth: "Akzeptiert CSS-Werte (px, %, in, pt usw.).",
        totalText: "Diese Option ist nur sichtbar, wenn mindestens eine Spalte über den Total-Typ oder den Total-Ausdruck verfügt.",
        cellErrorLocation: "Legt die Position einer Fehlermeldung in Bezug auf eine Zelle mit ungültiger Eingabe fest. Die Option \"Vererben\" übernimmt die Einstellung aus der Eigenschaft \"Fehlermeldungsausrichtung\".",
        keyDuplicationError: "Wenn die Eigenschaft \"Doppelte Beantwortungen verhindern\" aktiviert ist, erhält ein Befragter, der versucht, einen doppelten Beitrag einzureichen, die folgende Fehlermeldung.",
        totalExpression: "Hiermit können Sie Gesamtwerte basierend auf einem Ausdruck berechnen. Der Ausdruck kann grundlegende Berechnungen ('{q1_id} + {q2_id}'), boolesche Ausdrücke ('{age} > 60') und Funktionen ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' usw.) enthalten.",
        confirmDelete: "Löst eine Eingabeaufforderung aus, in der Sie aufgefordert werden, das Löschen der Zeile zu bestätigen.",
        defaultValueFromLastRow: "Dupliziert Antworten aus der letzten Zeile und weist sie der nächsten hinzugefügten dynamischen Zeile zu.",
        keyName: "Wenn die angegebene Spalte identische Werte enthält, löst die Umfrage den Fehler \"Nicht eindeutiger Schlüsselwert\" aus.",
        description: "Geben Sie einen Untertitel ein.",
        locale: "Wählen Sie eine Sprache aus, um mit der Erstellung Ihrer Umfrage zu beginnen. Um eine Übersetzung hinzuzufügen, wechseln Sie in eine neue Sprache und übersetzen Sie den Originaltext hier oder auf dem Tab \"Übersetzungen\".",
        detailPanelMode: "Legt die Position eines Detailabschnitts in Bezug auf eine Zeile fest. Wählen Sie aus: \"Keine\" - es wird keine Erweiterung hinzugefügt; \"Unter der Zeile\" - unter jeder Zeile der Matrix wird eine Zeilenerweiterung platziert; \"Unter der Zeile nur eine Zeilenerweiterung anzeigen\" - eine Erweiterung wird nur unter einer einzelnen Zeile angezeigt, die restlichen Zeilenerweiterungen werden ausgeblendet.",
        imageFit: "Wählen Sie aus: \"Keine\" - das Bild behält seine ursprüngliche Größe; \"Enthalten\" - die Größe des Bildes wird angepasst, wobei das Seitenverhältnis beibehalten wird. \"Cover\" - das Bild füllt den gesamten Rahmen aus, während das Seitenverhältnis beibehalten wird. \"Füllen\" - Das Bild wird gestreckt, um den Rahmen auszufüllen, ohne das Seitenverhältnis beizubehalten.",
        autoGrow: "Erhöht die Höhe des Eingabefelds schrittweise, während Daten eingegeben werden. Überschreibt die Einstellung \"Höhe des Eingabefelds (in Zeilen)\".",
        allowResize: "Der Ziehpunkt (oder Griff) wird in der Ecke angezeigt und kann gezogen werden, um die Größe des Eingabefelds zu ändern.",
        maxTimeToFinish: "Ein Zeitintervall in Sekunden, nach dem die Umfrage automatisch zur Danke-Seite wechselt.",
        maxTimeToFinishPage: "Ein Zeitintervall in Sekunden, nach dem die Umfrage automatisch zur nächsten Seite wechselt.",
        page: {
            maxTimeToFinish: "Ein Zeitintervall in Sekunden, nach dem die Umfrage automatisch zur nächsten Seite wechselt.",
            visibleIf: "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Sichtbarkeit der Seite bestimmt.",
            enableIf: "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die den schreibgeschützten Modus für die Seite deaktiviert.",
            requiredIf: "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Übermittlung von Umfragen verhindert, es sei denn, mindestens eine verschachtelte Frage enthält eine Antwort.",
            questionTitleLocation: "Gilt für alle Fragen auf dieser Seite. Wenn Sie diese Einstellung außer Kraft setzen möchten, definieren Sie Regeln für die Titelausrichtung für einzelne Fragen oder Bereiche. Die Option \"Vererben\" wendet die Einstellung auf Umfrageebene an (standardmäßig \"Oben\").",
            questionTitleWidth: "Legt eine konsistente Breite für Fragetitel fest, wenn sie links neben den Fragefeldern ausgerichtet sind. Akzeptiert CSS-Werte (px, %, in, pt usw.).",
            questionErrorLocation: "Legt die Position einer Fehlermeldung in Bezug auf die Frage mit ungültiger Eingabe fest. Wählen Sie zwischen: \"Oben\" - ein Fehlertext wird am oberen Rand des Fragefelds platziert; \"Unten\" - ein Fehlertext wird am unteren Rand des Fragefelds platziert. Die Option \"Vererben\" wendet die Einstellung auf Umfrageebene an (standardmäßig \"Oben\").",
            questionsOrder: "Behält die ursprüngliche Reihenfolge der Fragen bei oder randomisiert sie. Mit der Option \"Vererben\" wird die Einstellung auf Umfrageebene (\"Original\" standardmäßig) angewendet. Die Auswirkungen dieser Einstellung sind nur auf dem Tab \"Vorschau\" sichtbar.",
            navigationButtonsVisibility: "Legt die Sichtbarkeit von Navigationsschaltflächen auf der Seite fest. Mit der Option \"Vererben\" wird die Einstellung auf Umfrageebene angewendet, die standardmäßig auf \"Sichtbar\" eingestellt ist."
        },
        showTimerPanel: "Legt die Sichtbarkeit und Position eines Timers auf einer Seite fest.",
        panelsState: "Wählen Sie aus: \"Gesperrt\" - Benutzer können Panele nicht erweitern oder reduzieren; \"Alle ausblenden\" - alle Panele beginnen in einem zusammengeklappten Zustand; \"Alle erweitern\" - alle Panele beginnen in einem erweiterten Zustand; \"First expanded\" - nur das erste Panel wird zunächst erweitert.",
        imageLinkName: "Geben Sie einen freigegebenen Eigenschaftsnamen in das Array von Objekten ein, das die Bild- oder Videodatei-URLs enthält, die in der Auswahlliste angezeigt werden sollen.",
        choices: "Der linke Wert dient als Element-ID, die in bedingten Regeln verwendet wird, der rechte Wert wird den Befragten angezeigt.",
        title: "Geben Sie einen benutzerfreundlichen Titel ein, der angezeigt werden soll.",
        waitForUpload: "Stellt sicher, dass Benutzer die Umfrage erst abschließen, wenn die Dateien hochgeladen wurden.",
        minWidth: "Akzeptiert CSS-Werte (px, %, in, pt usw.).",
        maxWidth: "Akzeptiert CSS-Werte (px, %, in, pt usw.).",
        width: "Akzeptiert CSS-Werte (px, %, in, pt usw.).",
        valueName: "Wenn Sie diese Eigenschaft nicht festlegen, wird die Antwort in einem Feld gespeichert, das durch die Name-Eigenschaft angegeben wird.",
        useDisplayValuesInDynamicTexts: "Bei Fragetypen mit einfacher und mehrfacher Auswahl verfügt jede Auswahloption über eine ID und einen Anzeigewert. Wenn diese Einstellung aktiviert ist, wird in HTML-Fragen und dynamischen Titeln und Beschreibungen von Umfrageelementen ein Anzeigewert anstelle eines ID-Werts angezeigt.",
        clearIfInvisible: "Wählen Sie aus, ob und wann Fragenwerte, die durch bedingte Logik ausgeblendet werden, gelöscht werden sollen. Die Option \"Vererben\" wendet die Einstellung auf Umfrageebene an (standardmäßig \"Nach Abschluss der Umfrage\").",
        choicesFromQuestionMode: "Wählen Sie aus: \"Alle\" - kopiert alle Auswahloptionen aus der ausgewählten Frage; \"Ausgewählt\" - kopiert dynamisch nur ausgewählte Auswahloptionen; \"Nicht ausgewählt\" - kopiert dynamisch nur nicht ausgewählte Auswahloptionen. Die Optionen \"Keine\" und \"Sonstiges\" werden standardmäßig kopiert, wenn sie in der Quellfrage aktiviert sind.",
        showOtherItem: "Wenn diese Option ausgewählt ist, können Benutzer zusätzliche Eingaben in ein separates Kommentarfeld einfügen.",
        separateSpecialChoices: "Zeigt jede spezielle Auswahloption (\"Keine\", \"Andere\", \"Alle auswählen\") in einer neuen Zeile an, auch wenn ein mehrspaltiges Layout verwendet wird.",
        path: "Geben Sie die Position innerhalb des Service-Datasets an, an der sich das Ziel-Array von Objekten befindet. Lassen Sie das Feld leer, wenn die URL bereits auf das Array verweist.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Geben Sie innerhalb des Objektarrays einen einheitlichen Eigenschaftsnamen ein, der die Werte enthält, die in der Auswahlliste angezeigt werden sollen.",
        allowEmptyResponse: "Wählen Sie diese Option aus, damit der Dienst eine leere Antwort oder ein leeres Array zurückgeben kann.",
        choicesVisibleIf: "Verwenden Sie das Zauberstabsymbol, um eine Bedingungsregel festzulegen, die die Sichtbarkeit aller Auswahloptionen bestimmt.",
        rateValues: "Der linke Wert dient als Element-ID, die in bedingten Regeln verwendet wird, der rechte Wert wird den Befragten angezeigt.",
        rating: {
            displayMode: "\"Auto\" wählt zwischen den Modi \"Buttons\" und \"Dropdown\" basierend auf der verfügbaren Breite. Wenn die Breite nicht ausreicht, um Schaltflächen anzuzeigen, wird für die Frage ein Dropdown-Menü angezeigt."
        },
        valuePropertyName: "Ermöglicht es Ihnen, Fragen zu verbinden, die Ergebnisse in verschiedenen Formaten liefern. Wenn solche Fragen mithilfe eines Verknüpfungsbezeichners miteinander verknüpft sind, speichert diese gemeinsam genutzte Eigenschaft ausgewählte Fragewerte.",
        searchEnabled: "Wählen Sie diese Option aus, wenn Sie den Inhalt des Dropdown-Menüs so aktualisieren möchten, dass er der Suchabfrage entspricht, die ein Benutzer in das Eingabefeld eingibt.",
        valueTrue: "Ein Wert, der in den Umfrageergebnissen gespeichert werden soll, wenn die Befragten eine positive Antwort geben.",
        valueFalse: "Ein Wert, der in den Umfrageergebnissen gespeichert werden soll, wenn die Befragten eine negative Antwort geben.",
        showPreview: "Es wird nicht empfohlen, diese Option zu deaktivieren, da sie das Vorschaubild überschreibt und es für einen Benutzer schwierig macht, zu verstehen, ob die Dateien hochgeladen wurden.",
        needConfirmRemoveFile: "Löst eine Eingabeaufforderung aus, in der Sie aufgefordert werden, das Löschen der Datei zu bestätigen.",
        selectToRankEnabled: "Aktivieren Sie diese Option, um nur ausgewählte Auswahlmöglichkeiten in eine Rangfolge zu bringen. Benutzer ziehen ausgewählte Elemente aus der Auswahlliste, um sie innerhalb des Ranking-Bereichs zu sortieren.",
        dataList: "Geben Sie eine Liste mit Auswahlmöglichkeiten ein, die dem Befragten während der Eingabe vorgeschlagen werden.",
        itemSize: "Die Einstellung ändert nur die Größe der Eingabefelder und wirkt sich nicht auf die Breite des Fragefelds aus.",
        itemTitleWidth: "Legt eine konsistente Breite für alle Elementbeschriftungen in Pixeln fest",
        altText: "Dient als Ersatz, wenn das Bild nicht auf dem Gerät eines Benutzers angezeigt werden kann, und aus Gründen der Barrierefreiheit.",
        rateColorMode: "Definiert die Farbe des ausgewählten Emojis, wenn der Symboltyp \"Bewertung\" auf \"Smileys\" eingestellt ist. Wählen Sie zwischen: \"Standard\" - das ausgewählte Emoji erscheint in der Standardfarbe der Umfrage; \"Skala\" - das ausgewählte Emoji erbt die Farbe von der Bewertungsskala.",
        expression: {
            name: "Eine Ausdrucks-ID, die für die Befragten nicht sichtbar ist.",
            description: "Geben Sie einen Ausdrucksuntertitel ein.",
            expression: "Ein Ausdruck kann grundlegende Berechnungen ('{q1_id} + {q2_id}'), Bedingungen ('{age} > 60') und Funktionen ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' usw.) enthalten."
        },
        storeOthersAsComment: "Wählen Sie diese Option aus, um den Wert der Option \"Sonstiges\" als separate Eigenschaft in den Umfrageergebnissen zu speichern.",
        format: "Verwenden Sie {0} als Platzhalter für den tatsächlichen Wert.",
        acceptedTypes: "Weitere Informationen finden Sie in der Beschreibung des Attributs [accept](https://www.w3schools.com/tags/att_input_accept.asp).",
        columnColCount: "Gilt nur für die Zellentypen \"Radiogruppe\" und \"Kontrollkästchen\".",
        autocomplete: "Weitere Informationen finden Sie in der Attributbeschreibung [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete).",
        filePlaceholder: "Gilt, wenn \"Quelltyp\" \"Lokale Dateien\" ist oder wenn die Kamera nicht verfügbar ist",
        photoPlaceholder: "Gilt, wenn der \"Quellentyp\" auf \"Kamera\" festgelegt ist.",
        fileOrPhotoPlaceholder: "Gilt, wenn \"Quelltyp\" \"Lokale Dateien oder Kamera\" ist.",
        masksettings: {
            saveMaskedValue: "Wählen Sie diese Option aus, wenn Sie den Fragewert mit einer angewendeten Maske in den Umfrageergebnissen speichern möchten."
        },
        patternmask: {
            pattern: "Das Muster kann Zeichenfolgenliterale und die folgenden Platzhalter enthalten: '9' - für eine Ziffer; \"a\" - für einen Groß- oder Kleinbuchstaben; '#' - für eine Ziffer oder einen Groß- oder Kleinbuchstaben. Verwenden Sie den umgekehrten Schrägstrich '\\', um ein Zeichen mit Escapezeichen zu versehen."
        },
        datetimemask: {
            pattern: "Das Muster kann Trennzeichen und die folgenden Platzhalter enthalten:<br>'m' - Monatszahl.<br>'mm' - Monatszahl mit führender Null für einstellige Werte. <br>'d' - Tag des Monats. <br>'dd' - Tag des Monats mit führender Null für einstellige Werte. <br>'yy' - Die letzten beiden Ziffern des Jahres. <br>'yyyy' - Vierstellige Jahreszahl. <br>'H' - Stunden im 24-Stunden-Format. <br>'HH' - Stunden im 24-Stunden-Format, mit führender Null für einstellige Werte. <br>'h' - Stunden im 12-Stunden-Format. <br>'hh' - Stunden im 12-Stunden-Format, mit führender Null für einstellige Werte. <br>'MM' - Minuten. <br>'ss' - Sekunden. <br>'TT' - 12-Stunden-Takt in Großbuchstaben (AM/PM). <br>'tt' - 12-Stunden-Takt in Kleinbuchstaben (am/pm)."
        },
        numericmask: {
            decimalSeparator: "Ein Symbol, das verwendet wird, um den Bruchteil vom ganzzahligen Teil einer angezeigten Zahl zu trennen.",
            thousandsSeparator: "Ein Symbol, das verwendet wird, um die Ziffern einer großen Zahl in Dreiergruppen zu unterteilen.",
            precision: "Schränkt die Anzahl der Nachkommastellen für eine angezeigte Zahl ein."
        },
        currencymask: {
            prefix: "Ein oder mehrere Symbole, die vor dem Wert angezeigt werden sollen.",
            suffix: "Ein oder mehrere Symbole, die nach dem Wert angezeigt werden sollen."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "Titel",
            title: "Bitte leer lassen, falls gleich wie \"Name\""
        },
        multiSelect: "Mehrfachauswahl",
        showLabel: "Label anzeigen",
        swapOrder: "Reihenfolge von Ja und Nein vertauschen",
        value: "Wert",
        tabAlign: "Ausrichtung der Tabs",
        sourceType: "Quellentyp",
        fitToContainer: "Passend zum Behälter",
        setValueExpression: "Ausdruck \"Wert festlegen\"",
        description: "Beschreibung",
        logoFit: "Passform des Logos",
        pages: "Seiten",
        questions: "Fragen",
        triggers: "Auslöser",
        calculatedValues: "Berechnete Werte",
        surveyId: "surveyId",
        surveyPostId: "surveyPostId",
        surveyShowDataSaving: "surveyShowDataSaving",
        questionDescriptionLocation: "Position der Fragenbeschreibung",
        progressBarType: "Fortschrittsbalkentyp",
        showTOC: "Inhaltsverzeichnis anzeigen",
        tocLocation: "Toc-Standort",
        questionTitlePattern: "Pattern für Fragentitel",
        widthMode: "Modus für die Breite",
        showBrandInfo: "Markeninfo anzeigen",
        useDisplayValuesInDynamicTexts: "Verwende Anzeigewerte im Titel",
        visibleIf: "Sichtbar wenn ...",
        defaultValueExpression: "Ausdruck für Standardwerte",
        requiredIf: "Erforderlich wenn ...",
        resetValueIf: "Wert zurücksetzen, wenn",
        setValueIf: "Wert setzen, wenn",
        validators: "Validierungen",
        bindings: "Bindings",
        renderAs: "Rendern als",
        attachOriginalItems: "Originalartikel anbringen",
        choices: "Auswahlmöglichkeiten",
        choicesByUrl: "Auswahlreihenfolge nach URL",
        currency: "Währung",
        cellHint: "Hinweis auf die Zelle",
        totalMaximumFractionDigits: "Maximale Nachkommastellen insgesamt",
        totalMinimumFractionDigits: "Minimale Nachkommastellen insgesamt",
        columns: "Spalten",
        detailElements: "Detail-Elemente",
        allowAdaptiveActions: "Adaptive Aktionen zulassen",
        defaultRowValue: "Standardwert für Zeilen",
        detailPanelShowOnAdding: "Panel für Details beim Hinzufügen anzeigen",
        choicesLazyLoadEnabled: "Auswahlmöglichkeiten Lazy Load aktiviert",
        choicesLazyLoadPageSize: "Auswahlmöglichkeiten Lazy Load-Seitengröße",
        inputFieldComponent: "Eingabefeld-Komponente",
        itemComponent: "Artikelkomponente",
        min: "Minimaler Wert",
        max: "Maximaler Wert",
        minValueExpression: "Ausdruck für minimalen Wert",
        maxValueExpression: "Ausdruck für maximalen Wert",
        step: "Schritt",
        dataList: "Datenliste",
        itemSize: "Elementgröße",
        itemTitleWidth: "Breite der Artikelbeschriftung (in px)",
        elements: "Elemente",
        content: "Inhalt",
        navigationButtonsVisibility: "Sichtbarkeit der Navigationsbuttons",
        navigationTitle: "Navigationstitel",
        navigationDescription: "Navigationsbeschreibung",
        longTap: "langtippen",
        autoGrow: "Automatisch vergrößern",
        allowResize: "Größenänderung zulassen",
        acceptCarriageReturn: "akzeptieren CarriageReturn",
        displayMode: "Anzeigemodus",
        rateType: "Ansicht der Bewertungssymbole",
        label: "Label",
        contentMode: "Inhaltsmodus",
        imageFit: "Passform des Bildes",
        altText: "altText",
        height: "Höhe",
        penColor: "Stiftfarbe",
        backgroundColor: "Hintergrundfarbe",
        templateElements: "VorlagenElemente",
        operator: "Operator",
        isVariable: "istVariable",
        runExpression: "runExpression",
        showCaption: "Titel anzeigen",
        iconName: "Name des Icons",
        iconSize: "Größe des Icons",
        precision: "Präzision",
        matrixDragHandleArea: "Matrix-Ziehgriffbereich",
        backgroundImage: "Hintergrundbild",
        backgroundImageFit: "Anpassung des Hintergrundbildes",
        backgroundImageAttachment: "Anhang des Hintergrundbildes",
        backgroundOpacity: "Deckkraft des Hintergrunds",
        selectToRankEnabled: "Wählen Sie diese Option aus, um eine aktivierte Rangfolge zu erzielen",
        selectToRankAreasLayout: "Wählen Sie aus, um das Layout der Bereiche zu ordnen",
        selectToRankEmptyRankedAreaText: "Text, der angezeigt werden soll, wenn alle Optionen ausgewählt sind",
        selectToRankEmptyUnrankedAreaText: "Platzhaltertext für den Rankingbereich",
        allowCameraAccess: "Kamerazugriff zulassen",
        scaleColorMode: "Farbmodus skalieren",
        rateColorMode: "Farbmodus bewerten",
        copyDisplayValue: "Anzeigewert kopieren",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Erweiterter Modus",
        pageTitle: "Schriftart des Seitentitels",
        questionTitle: "Schriftart des Fragetitels",
        editorPanel: "Eingabeelement",
        lines: "Linien",
        primaryDefaultColor: "Standard",
        primaryDarkColor: "Schweben",
        primaryLightColor: "Ausgewählt",
        backgroundDimColor: "Hintergrundfarbe",
        cornerRadius: "Ecken-Radius",
        backcolor: "Standard-Hintergrund",
        hovercolor: "Hover-Hintergrund",
        borderDecoration: "Bordüren-Verzierung",
        fontColor: "Schriftfarbe",
        backgroundColor: "Hintergrundfarbe",
        primaryForecolor: "Standardfarbe",
        primaryForecolorLight: "Deaktivierte Farbe",
        font: "Schriftart",
        borderDefault: "Dunkler",
        borderLight: "Heller",
        fontFamily: "Schriftfamilie",
        fontWeightRegular: "Regelmäßig",
        fontWeightHeavy: "Schwer",
        fontWeightSemiBold: "Halbfett",
        fontWeightBold: "Kühn",
        color: "Farbe",
        placeholderColor: "Platzhalterfarbe",
        size: "Größe",
        opacity: "Undurchsichtigkeit",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Schatteneffekt hinzufügen",
        boxShadowBlur: "Verwischen",
        boxShadowSpread: "Verbreitung",
        boxShadowDrop: "Tropfen",
        boxShadowInner: "Inner",
        names: {
            default: "Default",
            sharp: "Scharf",
            borderless: "Ohne Rand",
            flat: "Flach",
            plain: "Einfach",
            doubleborder: "Doppelter Rand",
            layered: "Stufig",
            solid: "Fest",
            threedimensional: ".3D",
            contrast: "Kontrast"
        },
        colors: {
            teal: "Blaugrün",
            blue: "Blau",
            purple: "Lila",
            orchid: "Orchidee",
            tulip: "Tulpe",
            brown: "Braun",
            green: "Grün"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["de"] = germanTranslation;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// ed.themeSurvey: "Themes" => "Themen"
// ed.themePropertyGridTitle: "Theme Settings" => "Theme-Einstellungen"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Auswahlmöglichkeiten werden kopiert von"
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Ziehen Sie ein Bild per Drag & Drop hierher oder klicken Sie auf die Schaltfläche unten und wählen Sie ein Bild zum Hochladen aus"
// ed.choices_Item: "Item " => "Artikel "
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "Klarer Fragewert: {0}"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Logische Regeln sind unvollständig"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Sie haben einige der logischen Regeln nicht erfüllt. Wenn Sie den Tab jetzt verlassen, gehen die Änderungen verloren. Möchten Sie die Registerkarte dennoch verlassen, ohne die Änderungen abzuschließen?"
// lg.uncompletedRule_apply: "Yes" => "Ja"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Nein, ich möchte die Regeln vervollständigen"
// pe.overridingPropertyPrefix: "Set by " => "Gesetzt von "
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Verwenden Sie keine reservierten Wörter: \"Element\", \"Auswahl\", \"Panel\", \"Zeile\"."
// image.imageHeight: "Image height (in CSS-accepted values)" => "Bildhöhe (in CSS-akzeptierten Werten)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Bildbreite (in CSS-akzeptierten Werten)"
// pe.allowResizeComment: "Allow users to resize text areas" => "Benutzern erlauben, die Größe von Textbereichen zu ändern"
// pe.templateTitleLocation: "Question title location" => "Position des Fragetitels"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "Position der Panel-Schaltfläche entfernen"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "Blenden Sie die Frage aus, wenn keine Zeilen vorhanden sind"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Spalten ausblenden, wenn keine Zeilen vorhanden sind"
// pe.rateValues: "Custom rate values" => "Benutzerdefinierte Ratenwerte"
// pe.autoGenerate: "How to specify rate values?" => "Wie lege ich Tarifwerte fest?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "Blenden Sie die Frage aus, wenn sie keine Auswahlmöglichkeiten enthält"
// pe.hideNumber: "Hide question number" => "Fragenummer ausblenden"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Minimale Breite (in CSS-akzeptierten Werten)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Maximale Breite (in CSS-akzeptierten Werten)"
// pe.width: "Width (in CSS-accepted values)" => "Breite (in CSS-akzeptierten Werten)"
// pe.showHeader: "Show column headers" => "Spaltenüberschriften anzeigen"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Horizontale Bildlaufleiste anzeigen"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Minimale Spaltenbreite (in CSS-akzeptierten Werten)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Breite der Zeilenüberschrift (in CSS-akzeptierten Werten)"
// pe.valueTrue: "\"True\" value" => "\"Wahrer\" Wert"
// pe.valueFalse: "\"False\" value" => "\"False\"-Wert"
// pe.minErrorText: "\"Value is below minimum\" error message" => "Fehlermeldung \"Wert liegt unter Minimum\""
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "Fehlermeldung \"Wert überschreitet Maximum\""
// pe.otherErrorText: "\"Empty comment\" error message" => "Fehlermeldung \"Leerer Kommentar\""
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "Fehlermeldung \"Nicht eindeutiger Schlüsselwert\""
// pe.minSelectedChoices: "Minimum selected choices" => "Minimale Auswahlmöglichkeiten"
// pe.maxSelectedChoices: "Maximum selected choices" => "Maximale Auswahlmöglichkeiten"
// pe.showClearButton: "Show the Clear button" => "Zeigen Sie die Schaltfläche \"Löschen\" an"
// pe.showNumber: "Show panel number" => "Panel-Nummer anzeigen"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "Logobreite (in CSS-akzeptierten Werten)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "Logohöhe (in CSS-akzeptierten Werten)"
// pe.enableIf: "Editable if" => "Bearbeitbar, wenn"
// pe.emptyRowsText: "\"No rows\" message" => "Meldung \"Keine Zeilen\""
// pe.size: "Input field size (in characters)" => "Größe des Eingabefeldes (in Zeichen)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Kopieren Sie die Auswahlmöglichkeiten aus der folgenden Frage"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Welche Auswahlmöglichkeiten sollen kopiert werden?"
// pe.showCommentArea: "Show the comment area" => "Kommentarbereich anzeigen"
// pe.commentPlaceholder: "Comment area placeholder" => "Platzhalter für den Kommentarbereich"
// pe.rowsOrder: "Row order" => "Reihenfolge der Zeilen"
// pe.columnsLayout: "Column layout" => "Spalten-Layout"
// pe.columnColCount: "Nested column count" => "Anzahl der geschachtelten Spalten"
// pe.state: "Panel expand state" => "Status erweitern des Panels"
// pe.correctAnswer: "Correct Answer" => "Richtige Antwort"
// pe.defaultPanelValue: "Default Values" => "Standardwerte"
// pe.cells: "Cell Texts" => "Zellentexte"
// pe.keyName: "Key column" => "Spalte \"Schlüssel\""
// itemvalue.text: "Alt text" => "Alt-Text"
// pe.closeOnSelect: "Close the dropdown after selection" => "Schließen Sie das Dropdown-Menü nach der Auswahl"
// pv.tab: "Tabs" => "Tabulatoren"
// inputType.datetime-local: "Date and Time" => "Datum und Uhrzeit"
// inputType.range: "Range" => "Bereich"
// inputType.url: "URL" => "Web-URL"
// inputType.week: "Week" => "Woche"
// pv.onBlur: "On blur" => "Bei Unschärfe"
// pv.onTyping: "While typing" => "Während der Eingabe"
// pv.underRow: "Under the row" => "Unter der Reihe"
// pv.underRowSingle: "Under the row, only one panel is visible" => "Unter der Zeile ist nur ein Bereich sichtbar"
// panelsState.default: "Users cannot expand or collapse panels" => "Benutzer können Bedienfelder nicht ein- oder ausblenden"
// panelsState.collapsed: "All panels are collapsed" => "Alle Paneele sind eingeklappt"
// panelsState.expanded: "All panels are expanded" => "Alle Panels sind ausgeklappt"
// widthMode.auto: "Auto" => "Auto"
// widthMode.static: "Static" => "Statisch"
// widthMode.responsive: "Responsive" => "Ansprechbar"
// imageFit.none: "None" => "Nichts"
// imageFit.contain: "Contain" => "Enthalten"
// imageFit.cover: "Cover" => "Deckel"
// imageFit.fill: "Fill" => "Füllen"
// contentMode.auto: "Auto" => "Auto"
// contentMode.youtube: "YouTube" => "YouTube (Englisch)"
// displayMode.auto: "Auto" => "Auto"
// displayMode.buttons: "Buttons" => "Tasten"
// displayMode.dropdown: "Dropdown" => "Dropdown-Liste"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Cookies verhindern, dass Benutzer dieselbe Umfrage zweimal ausfüllen."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Ändert die Größe des sichtbaren Bereichs des Eingabefelds. Bitte verwenden Sie die Einstellung <b>Validierung → Maximale Länge</b>, um die Eingabelänge zu begrenzen."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Verwenden Sie {0} als Platzhalter für den tatsächlichen Wert."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Diese Option ist nur sichtbar, wenn mindestens eine Spalte über den Total-Typ oder den Total-Ausdruck verfügt."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Weitere Informationen finden Sie in der Beschreibung des Attributs [accept](https://www.w3schools.com/tags/att_input_accept.asp)."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Gilt nur für die Zellentypen \"Radiogruppe\" und \"Kontrollkästchen\"."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Weitere Informationen finden Sie in der Attributbeschreibung [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete)."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Wenn Sie diese Eigenschaft nicht festlegen, wird die Antwort in einem Feld gespeichert, das durch die Name-Eigenschaft angegeben wird."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Wenn die angegebene Spalte identische Werte enthält, löst die Umfrage den Fehler \"Nicht eindeutiger Schlüsselwert\" aus."
// p.value: "Value" => "Wert"
// p.tabAlign: "Tab alignment" => "Ausrichtung der Registerkarten"
// p.tocLocation: "Toc location" => "Toc-Standort"
// p.showBrandInfo: "Show brand info" => "Markeninfo anzeigen"
// p.renderAs: "Render as" => "Rendern als"
// p.attachOriginalItems: "Attach original items" => "Originalartikel anbringen"
// p.cellHint: "Cell hint" => "Hinweis auf die Zelle"
// p.isUnique: "Is unique" => "Ist einzigartig"
// p.showInMultipleColumns: "Show in multiple columns" => "In mehreren Spalten anzeigen"
// p.detailElements: "Detail elements" => "Detail-Elemente"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Adaptive Aktionen zulassen"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Auswahlmöglichkeiten Lazy Load aktiviert"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Auswahlmöglichkeiten Lazy Load-Seitengröße"
// p.inputFieldComponent: "Input field component" => "Eingabefeld-Komponente"
// p.itemComponent: "Item component" => "Artikelkomponente"
// p.allowResize: "Allow resizing" => "Größenänderung zulassen"
// p.precision: "Precision" => "Präzision"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Matrix-Ziehgriffbereich"
// p.backgroundImage: "Background image" => "Hintergrundbild"
// p.backgroundImageFit: "Background image fit" => "Anpassung des Hintergrundbildes"
// p.backgroundImageAttachment: "Background image attachment" => "Anhang des Hintergrundbildes"
// p.backgroundOpacity: "Background opacity" => "Deckkraft des Hintergrunds"
// p.selectToRankEnabled: "Select to rank enabled" => "Wählen Sie diese Option aus, um eine aktivierte Rangfolge zu erzielen"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Wählen Sie aus, um das Layout der Bereiche zu ordnen"
// p.allowCameraAccess: "Allow camera access" => "Kamerazugriff zulassen"
// p.scaleColorMode: "Scale color mode" => "Farbmodus skalieren"
// p.rateColorMode: "Rate color mode" => "Farbmodus bewerten"
// p.templateTabTitle: "Template tab title" => "Titel der Registerkarte \"Vorlage\""
// p.templateVisibleIf: "Template visible if" => "Vorlage sichtbar, wenn"
// p.copyDisplayValue: "Copy display value" => "Anzeigewert kopieren"
// theme.--background: "Background color" => "Hintergrundfarbe"
// theme.--background-dim-light: "Background dim light color" => "Hintergrund schwache Lichtfarbe"
// theme.--primary-foreground: "Primary foreground color" => "Primäre Vordergrundfarbe"
// theme.--foreground: "Foreground color" => "Vordergrundfarbe"
// theme.--base-unit: "Base unit" => "Basiseinheit"
// theme.groupAdvanced: "Advanced" => "Fortgeschritten"
// theme.themeName: "Theme" => "Thema"
// theme.isPanellessss: "Question appearance" => "Erscheinungsbild der Frage"
// theme.isPanellessLightweight: "Without Panels" => "Ohne Paneele"
// theme.themePaletteDark: "Dark" => "Dunkel"
// theme.primaryColor: "Accent color" => "Akzentfarbe"
// theme.primaryDarkColor: "Hover" => "Schweben"
// theme.primaryLightColor: "Selected" => "Ausgewählt"
// theme.backgroundDimColor: "Background color" => "Hintergrundfarbe"
// theme.backgroundImage: "Background image" => "Hintergrundbild"
// theme.backgroundImageFitAuto: "Auto" => "Auto"
// theme.backgroundImageFitContain: "Contain" => "Enthalten"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Deckkraft des Panel-Hintergrunds"
// theme.questionBackgroundTransparency: "Question background opacity" => "Deckkraft des Hintergrunds der Frage"
// theme.questionPanel: "Panel background and corner radius" => "Paneelhintergrund und Eckenradius"
// theme.questionTitle: "Question title font" => "Schriftart des Fragetitels"
// theme.questionDescription: "Question description font" => "Frage-Beschreibung-Schriftart"
// theme.editorPanel: "Input element" => "Eingabeelement"
// theme.editorFont: "Input element font" => "Schriftart des Eingabeelements"
// theme.backcolor: "Default background" => "Standard-Hintergrund"
// theme.hovercolor: "Hover background" => "Hover-Hintergrund"
// theme.borderDecoration: "Border decoration" => "Bordüren-Verzierung"
// theme.accentBackground: "Accent background" => "Akzent-Hintergrund"
// theme.accentForeground: "Accent foreground" => "Akzent Vordergrund"
// theme.primaryForecolor: "Default color" => "Standardfarbe"
// theme.primaryForecolorLight: "Disabled color" => "Deaktivierte Farbe"
// theme.linesColors: "Minor line colors" => "Kleinere Linienfarben"
// theme.borderDefault: "Darker" => "Dunkler"
// theme.borderLight: "Lighter" => "Feuerzeug"
// theme.fontFamily: "Font family" => "Schriftfamilie"
// theme.fontSize: "Font size" => "Schriftgrad"
// theme.color: "Color" => "Farbe"
// theme.size: "Size" => "Größe"
// theme.fontWeightRegular: "Regular" => "Regelmäßig"
// theme.fontWeightHeavy: "Heavy" => "Schwer"
// theme.fontWeightSemiBold: "Semi-bold" => "Halbfett"
// theme.scale: "Scale" => "Maßstab"
// theme.cornerRadius: "Corner radius" => "Eckenradius"
// theme.surveyTitleFont: "Survey title font" => "Schriftart für den Umfragetitel"
// theme.pageTitle: "Page title font" => "Schriftart des Seitentitels"
// theme.pageDescription: "Page description font" => "Schriftart für die Seitenbeschreibung"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Schatteneffekt hinzufügen"
// theme.opacity: "Opacity" => "Undurchsichtigkeit"
// theme.boxShadowBlur: "Blur" => "Verwischen"
// theme.boxShadowSpread: "Spread" => "Verbreitung"
// theme.boxShadowDrop: "Drop" => "Tropfen"
// theme.boxShadowInner: "Inner" => "Inner"
// theme.questionShadow: "Shadow effects" => "Schatteneffekte"
// theme.editorShadow: "Input element shadow effects" => "Schatteneffekte von Eingabeelementen"
// names.contrast: "Contrast" => "Kontrast"
// names.plain: "Plain" => "Einfach"
// names.simple: "Simple" => "Einfach"
// names.blank: "Blank" => "Leer"
// names.double: "Double" => "Doppelt"
// names.bulk: "Bulk" => "Masse"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo 3D"
// names.playful: "Playful" => "Verspielt"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Krickente"
// colors.orchid: "Orchid" => "Orchidee"
// colors.tulip: "Tulip" => "Tulpe"
// names.sharp: "Sharp" => "Scharf"
// names.borderless: "Borderless" => "Ohne Rand"
// names.flat: "Flat" => "Flach"
// names.doubleborder: "Double Border" => "Doppelter Rand"
// names.layered: "Layered" => "Stufig"
// names.solid: "Solid" => "Fest"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Sind Sie sicher, dass Sie alle Zeichenfolgen für diese Sprache löschen möchten?"
// ed.themeResetButton: "Reset theme settings to default" => "Theme-Einstellungen auf die Standardeinstellungen zurücksetzen"
// theme.placeholderColor: "Placeholder color" => "Farbe des Platzhalters"
// ed.themeSettings: "Theme Settings" => "Theme-Einstellungen"
// ed.themeSettingsTooltip: "Open theme settings" => "Öffnen Sie die Theme-Einstellungen"
// pe.resetToDefaultCaption: "Reset" => "Zurücksetzen"
// pv.file: "Local files" => "Lokale Dateien"
// pv.camera: "Camera" => "Kamera"
// pv.file-camera: "Local files or camera" => "Lokale Dateien oder Kamera"
// ed.translateUsigAI: "Auto-translate All" => "Alle automatisch übersetzen"
// ed.translationDialogTitle: "Untranslated strings" => "Nicht übersetzte Zeichenketten"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Bitte geben Sie mindestens {0} Artikel ein"
// lg.question_resetValueName: "Reset question value" => "Fragewert zurücksetzen"
// lg.column_resetValue: "Reset column value" => "Spaltenwert zurücksetzen"
// pe.markRequired: "Mark as required" => "Als erforderlich markieren"
// pe.removeRequiredMark: "Remove the required mark" => "Entfernen Sie die erforderliche Markierung"
// p.resetValueIf: "Reset value if" => "Wert zurücksetzen, wenn"
// lg.question_setValueName: "Set question value" => "Festlegen des Fragewerts"
// lg.column_resetValueName: "Reset column value" => "Spaltenwert zurücksetzen"
// lg.column_setValueName: "Set column value" => "Festlegen des Spaltenwerts"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Ein Ausdruck, dessen Ergebnis der Zielfrage zugewiesen wird."
// survey.title: "Title" => "Titel"
// page.title: "Title" => "Titel"
// p.setValueIf: "Set value if" => "Wert setzen, wenn"
// theme.backgroundImageFitFill: "Stretch" => "Strecken"
// theme.headerView: "View" => "Ansehen"
// theme.headerViewBasic: "Basic" => "Grundlegend"
// theme.headerViewAdvanced: "Advanced" => "Fortgeschritten"
// theme.headerInheritWidthFrom: "Content area width" => "Breite des Inhaltsbereichs"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Wie Umfrage"
// theme.headerInheritWidthFromPage: "Fit to page" => "An Seite anpassen"
// theme.headerTextAreaWidth: "Text width" => "Textbreite"
// theme.headerBackgroundColorSwitch: "Background color" => "Hintergrundfarbe"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Akzentfarbe"
// theme.horizontalAlignmentLeft: "Left" => "Links"
// theme.horizontalAlignmentCenter: "Center" => "Mitte"
// theme.horizontalAlignmentRight: "Right" => "Rechts"
// theme.verticalAlignmentMiddle: "Middle" => "Mitte"
// theme.logoPosition: "Logo Position" => "Position des Logos"
// theme.headerTitlePosition: "Title Position" => "Position des Titels"
// theme.headerDescriptionPosition: "Description Position" => "Beschreibung Position"
// lg.question_resetValueText: "reset value for question: {0}" => "Reset-Wert für Frage: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Wert zuweisen: {1} zu fragen: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Zellenwert für Spalte zurücksetzen: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Zellenwert zuweisen: {1} zur Spalte: {0}"
// ed.surveyJsonExportButton: "Export" => "Exportieren"
// ed.surveyJsonImportButton: "Import" => "Importieren"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "In Zwischenablage kopieren"
// pe.filePlaceholder: "File placeholder text" => "Platzhaltertext für Dateien"
// pe.photoPlaceholder: "Photo placeholder text" => "Platzhaltertext für Fotos"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Datei- oder Foto-Platzhaltertext"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Gilt, wenn \"Quelltyp\" \"Lokale Dateien\" ist oder wenn die Kamera nicht verfügbar ist"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Gilt, wenn der \"Quellentyp\" auf \"Kamera\" festgelegt ist."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Gilt, wenn \"Quelltyp\" \"Lokale Dateien oder Kamera\" ist."
// theme.background: "Background" => "Hintergrund"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Möchten Sie das Theme wirklich zurücksetzen? Alle Ihre Anpassungen gehen verloren."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Ja, setzen Sie das Design zurück"
// theme.background: "Background" => "Hintergrund"
// theme.appearance: "Appearance" => "Aussehen"
// signaturepad.showPlaceholder: "Show the placeholder" => "Platzhalter anzeigen"
// signaturepad.placeholder: "Placeholder text" => "Platzhaltertext"
// theme.surveyDescriptionFont: "Survey description font" => "Schriftart der Umfragebeschreibung"
// ed.prevFocus: "Focus previous" => "Fokus zurück"
// ed.nextFocus: "Focus next" => "Weiter fokussieren"
// ed.saveTheme: "Save Theme" => "Theme speichern"
// ed.saveThemeTooltip: "Save Theme" => "Theme speichern"
// lg.page_requireName: "Make page required" => "Als Seite erforderlich festlegen"
// lg.panel_requireName: "Make page required" => "Als Seite erforderlich festlegen"
// signaturepad.signatureWidth: "Signature area width" => "Breite des Signaturbereichs"
// signaturepad.signatureHeight: "Signature area height" => "Höhe des Signaturbereichs"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Automatisches Skalieren des Signaturbereichs"
// signaturepad.penMinWidth: "Minimum pen width" => "Minimale Stiftbreite"
// signaturepad.penMaxWidth: "Maximum pen width" => "Maximale Stiftbreite"
// ed.propertyGridNoResultsFound: "No results found" => "Keine Ergebnisse gefunden"
// pv.leftRight: "Left and right" => "Links und rechts"
// p.sourceType: "Source type" => "Quellentyp"
// p.fitToContainer: "Fit to container" => "Passend zum Behälter"
// p.setValueExpression: "Set value expression" => "Ausdruck \"Wert festlegen\""
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Auswahlmöglichkeiten werden aus einem Webdienst geladen."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Gehen Sie zu den Einstellungen"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Vorschau der geladenen Auswahloptionen"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Doppelte Beantwortungen in Zeilen verhindern"
// theme.advancedMode: "Advanced mode" => "Erweiterter Modus"
// theme.backgroundCornerRadius: "Background and corner radius" => "Hintergrund und Eckenradius"
// theme.colorsTitle: "Colors" => "Farben"
// theme.font: "Font" => "Schriftart"
// theme.lines: "Lines" => "Linien"
// theme.titleFont: "Title font" => "Schriftart des Titels"
// theme.descriptionFont: "Description font" => "Beschreibung Schriftart"
// theme.shadow: "Shadow effects" => "Schatten-Effekte"
// ed.translateUsigAIFrom: "Translate from: " => "Sprachrichtung: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Zulassen der Option \"Antwort ablehnen\""
// pe.showDontKnowItem: "Allow the Don't Know option" => "Erlauben Sie die Option \"Weiß nicht\""
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Zulassen der Option \"Antwort ablehnen\""
// pe.showDontKnowItem: "Allow the Don't Know option" => "Erlauben Sie die Option \"Weiß nicht\""
// pv.contain: "Contain" => "Enthalten"
// pv.cover: "Cover" => "Deckel"
// pv.fill: "Fill" => "Füllen"
// pe.transposeData: "Transpose rows to columns" => "Transponieren von Zeilen in Spalten"
// layout.panel: "Layout" => "Layout"
// layout.question: "Layout" => "Layout"
// layout.base: "Layout" => "Layout"
// panel.name: "Panel name" => "Name des Panels"
// panel.title: "Panel title" => "Titel des Panels"
// panel.description: "Panel description" => "Beschreibung des Panels"
// panel.visibleIf: "Make the panel visible if" => "Machen Sie das Panel sichtbar, wenn"
// panel.requiredIf: "Make the panel required if" => "Machen Sie das Panel erforderlich, wenn"
// panel.questionsOrder: "Question order within the panel" => "Reihenfolge der Fragen innerhalb des Panels"
// panel.startWithNewLine: "Display the panel on a new line" => "Anzeigen des Panels in einer neuen Zeile"
// panel.state: "Panel collapse state" => "Status des Ausblendens des Panels"
// panel.width: "Inline panel width" => "Breite des Inline-Panels"
// panel.minWidth: "Minimum panel width" => "Minimale Breite der Platte"
// panel.maxWidth: "Maximum panel width" => "Maximale Breite des Paneels"
// panel.showNumber: "Number panels" => "Nummernfelder"
// paneldynamic.name: "Panel name" => "Name des Panels"
// paneldynamic.title: "Panel title" => "Titel des Panels"
// paneldynamic.description: "Panel description" => "Beschreibung des Panels"
// paneldynamic.visibleIf: "Make the panel visible if" => "Machen Sie das Panel sichtbar, wenn"
// paneldynamic.requiredIf: "Make the panel required if" => "Machen Sie das Panel erforderlich, wenn"
// paneldynamic.page: "Move the panel to page" => "Verschieben des Panels auf die Seite"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Anzeigen des Panels in einer neuen Zeile"
// paneldynamic.state: "Panel collapse state" => "Status des Ausblendens des Panels"
// paneldynamic.width: "Inline panel width" => "Breite des Inline-Panels"
// paneldynamic.minWidth: "Minimum panel width" => "Minimale Breite der Platte"
// paneldynamic.maxWidth: "Maximum panel width" => "Maximale Breite des Paneels"
// paneldynamic.templateDescription: "Panel description pattern" => "Muster für die Bereichsbeschreibung"
// paneldynamic.templateTitle: "Panel title pattern" => "Muster für den Panel-Titel"
// paneldynamic.noEntriesText: "Empty panel text" => "Leerer Bedienfeldtext"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Muster des Tab-Titels"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Machen Sie ein einzelnes Panel sichtbar, wenn"
// paneldynamic.hideNumber: "Hide the panel number" => "Ausblenden der Panel-Nummer"
// paneldynamic.titleLocation: "Panel title alignment" => "Ausrichtung des Panel-Titels"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Ausrichtung der Panelbeschreibung"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Ausrichtung des Fragetitels"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Ausrichtung von Fehlermeldungen"
// paneldynamic.newPanelPosition: "New panel location" => "Neue Panel-Position"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Verhindern Sie doppelte Antworten in der folgenden Frage"
// question.name: "Question name" => "Name der Frage"
// question.title: "Question title" => "Titel der Frage"
// question.description: "Question description" => "Beschreibung der Frage"
// question.visibleIf: "Make the question visible if" => "Machen Sie die Frage sichtbar, wenn"
// question.requiredIf: "Make the question required if" => "Machen Sie die Frage erforderlich, wenn"
// question.state: "Question box collapse state" => "Status des Ausblendens des Fragefelds"
// question.hideNumber: "Hide the question number" => "Ausblenden der Fragenummer"
// question.titleLocation: "Question title alignment" => "Ausrichtung des Fragetitels"
// question.descriptionLocation: "Question description alignment" => "Ausrichtung der Fragebeschreibung"
// question.errorLocation: "Error message alignment" => "Ausrichtung von Fehlermeldungen"
// question.indent: "Increase the inner indent" => "Vergrößern Sie den inneren Einzug"
// question.width: "Inline question width" => "Breite der Inline-Frage"
// question.minWidth: "Minimum question width" => "Minimale Fragebreite"
// question.maxWidth: "Maximum question width" => "Maximale Fragebreite"
// question.textUpdateMode: "Update input field value" => "Aktualisieren des Eingabefeldwerts"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Zeigen Sie die Schaltfläche \"Löschen\" im Signaturbereich an"
// signaturepad.penColor: "Stroke color" => "Farbe des Strichs"
// comment.rows: "Input field height (in lines)" => "Höhe des Eingabefeldes (in Zeilen)"
// expression.name: "Expression name" => "Name des Ausdrucks"
// expression.title: "Expression title" => "Titel des Ausdrucks"
// expression.description: "Expression description" => "Beschreibung des Ausdrucks"
// expression.expression: "Expression" => "Ausdruck"
// trigger.expression: "Expression" => "Ausdruck"
// calculatedvalue.expression: "Expression" => "Ausdruck"
// survey.description: "Survey description" => "Beschreibung der Umfrage"
// page.name: "Page name" => "Name der Seite"
// page.description: "Page description" => "Seitenbeschreibung"
// page.visibleIf: "Make the page visible if" => "Machen Sie die Seite sichtbar, wenn"
// page.requiredIf: "Make the page required if" => "Machen Sie die Seite erforderlich, wenn"
// page.questionsOrder: "Question order on the page" => "Reihenfolge der Fragen auf der Seite"
// matrixdropdowncolumn.name: "Column name" => "Name der Spalte"
// matrixdropdowncolumn.title: "Column title" => "Titel der Spalte"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Doppelte Beantwortungen verhindern"
// matrixdropdowncolumn.width: "Column width" => "Spaltenbreite"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Minimale Spaltenbreite"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Höhe des Eingabefeldes (in Zeilen)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Machen Sie die Spalte sichtbar, wenn"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Machen Sie die Spalte erforderlich, wenn"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Jede Option in einer separaten Spalte"
// multipletextitem.name: "Name" => "Name"
// multipletextitem.title: "Title" => "Titel"
// pe.rateDescriptionLocation: "Label alignment" => "Ausrichtung der Beschriftung"
// pe.cellErrorLocation: "Cell error message alignment" => "Ausrichtung von Zellenfehlermeldungen"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Sie haben noch keine Spalten"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Sie haben noch keine Zeilen"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Sie haben noch keine Validierungsregeln"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Sie haben noch keine benutzerdefinierten Variablen"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Sie haben noch keine Auslöser"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Sie haben noch keine Links"
// pe.addNew@columns: "Add new column" => "Neue Spalte hinzufügen"
// pe.addNew@rows: "Add new row" => "Neue Zeile hinzufügen"
// pe.addNew@validators: "Add new rule" => "Neue Regel hinzufügen"
// pe.addNew@calculatedValues: "Add new variable" => "Neue Variable hinzufügen"
// pe.addNew@triggers: "Add new trigger" => "Neuen Auslöser hinzufügen"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Neue URL hinzufügen"
// choicesbyurl.url: "Web service's URL" => "URL des Webdienstes"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Seitentitel in der Fortschrittsleiste anzeigen"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Seitenzahlen in der Fortschrittsleiste anzeigen"
// itemvalue.visibleIf: "Make the option visible if" => "Machen Sie die Option sichtbar, wenn"
// itemvalue.enableIf: "Make the option selectable if" => "Machen Sie die Option auswählbar, wenn"
// panel.layout: "Panel Layout" => "Panel-Layout"
// tabs.questionSettings: "Question Settings" => "Einstellungen für Fragen"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Bsp.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Bsp.: categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Bsp.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Bsp.: 6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "Bsp.: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Bsp.: 50%"
// pv.selected: "Selected" => "Ausgewählt"
// pv.unselected: "Unselected" => "Deaktiviert"
// pv.center: "Center" => "Mitte"
// pv.middle: "Middle" => "Mitte"
// pv.next: "Next" => "Nächster"
// pv.last: "Last" => "Letzte"
// clearIfInvisible.none: "Never" => "Nie"
// questionsOnPageMode.standard: "Original structure" => "Ursprüngliche Struktur"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Alle Fragen auf einer Seite anzeigen"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Einzelne Frage pro Seite anzeigen"
// pv.auto: "Auto" => "Auto"
// panelsState.firstExpanded: "First expanded" => "Erstmals erweitert"
// rateColorMode.scale: "Scale" => "Maßstab"
// scaleColorMode.monochrome: "Monochrome" => "Monochrom"
// scaleColorMode.colored: "Colored" => "Farbig"
// state.default: "Locked" => "Verschlossen"
// showQuestionNumbers.default: "Auto-numbering" => "Automatische Nummerierung"
// showQuestionNumbers.on: "Auto-numbering" => "Automatische Nummerierung"
// showQuestionNumbers.onPage: "Reset on each page" => "Zurücksetzen auf jeder Seite"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Zurücksetzen auf jedem Panel"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Zurücksetzen auf jedem Panel"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Weiter in der Umfrage"
// showQuestionNumbers.off: "No numbering" => "Keine Nummerierung"
// descriptionLocation.underTitle: "Under the question title" => "Unter dem Titel der Frage"
// descriptionLocation.underInput: "Under the input field" => "Unter dem Eingabefeld"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Neben den Auswahlmöglichkeiten"
// selectToRankAreasLayout.vertical: "Above choices" => "Oben genannte Auswahlmöglichkeiten"
// displayStyle.decimal: "Decimal" => "Dezimal"
// displayStyle.currency: "Currency" => "Währung"
// displayStyle.percent: "Percentage" => "Prozentsatz"
// displayStyle.date: "Date" => "Datum"
// totalDisplayStyle.decimal: "Decimal" => "Dezimal"
// totalDisplayStyle.currency: "Currency" => "Währung"
// totalDisplayStyle.percent: "Percentage" => "Prozentsatz"
// totalDisplayStyle.date: "Date" => "Datum"
// rowsOrder.initial: "Original" => "Original"
// questionsOrder.initial: "Original" => "Original"
// showProgressBar.aboveheader: "Above the header" => "Über der Kopfzeile"
// showProgressBar.belowheader: "Below the header" => "Unterhalb der Kopfzeile"
// pv.sum: "Sum" => "Summe"
// pv.count: "Count" => "Zählen"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Max"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Enthält"
// searchMode.startsWith: "Starts with" => "Beginnt mit"
// panel.name: "A panel ID that is not visible to respondents." => "Eine Panel-ID, die für die Befragten nicht sichtbar ist."
// panel.description: "Type a panel subtitle." => "Geben Sie einen Untertitel für das Panel ein."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Sichtbarkeit des Panels bestimmt."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die den schreibgeschützten Modus für das Panel deaktiviert."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Übermittlung von Umfragen verhindert, es sei denn, mindestens eine verschachtelte Frage enthält eine Antwort."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Gilt für alle Fragen in diesem Bereich. Wenn Sie diese Einstellung außer Kraft setzen möchten, definieren Sie Regeln für die Titelausrichtung für einzelne Fragen. Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an (standardmäßig \"Oben\")."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Legt die Position einer Fehlermeldung in Bezug auf alle Fragen innerhalb des Bereichs fest. Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Behält die ursprüngliche Reihenfolge der Fragen bei oder randomisiert sie. Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an."
// panel.page: "Repositions the panel to the end of a selected page." => "Positioniert das Panel am Ende einer ausgewählten Seite."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Fügt Abstand oder Rand zwischen dem Inhalt des Panels und dem linken Rand des Panels hinzu."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Deaktivieren Sie diese Option, um den Bereich in einer Zeile mit der vorherigen Frage oder dem vorherigen Bereich anzuzeigen. Die Einstellung gilt nicht, wenn der Bereich das erste Element in Ihrem Formular ist."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Wählen Sie aus: \"Erweitert\" - das Panel wird vollständig angezeigt und kann eingeklappt werden; \"Reduziert\" - das Panel zeigt nur den Titel und die Beschreibung an und kann erweitert werden; \"Gesperrt\" - das Panel wird vollständig angezeigt und kann nicht eingeklappt werden."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Legt die Breite des Fensters im Verhältnis zu anderen Vermessungselementen in derselben Linie fest. Akzeptiert CSS-Werte (px, %, in, pt usw.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "Eine Panel-ID, die für die Befragten nicht sichtbar ist."
// paneldynamic.description: "Type a panel subtitle." => "Geben Sie einen Untertitel für das Panel ein."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Sichtbarkeit des Panels bestimmt."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die den schreibgeschützten Modus für das Panel deaktiviert."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Übermittlung von Umfragen verhindert, es sei denn, mindestens eine verschachtelte Frage enthält eine Antwort."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Gilt für alle Fragen in diesem Bereich. Wenn Sie diese Einstellung außer Kraft setzen möchten, definieren Sie Regeln für die Titelausrichtung für einzelne Fragen. Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an (standardmäßig \"Oben\")."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Legt die Position einer Fehlermeldung in Bezug auf eine Frage mit ungültiger Eingabe fest. Wählen Sie zwischen: \"Oben\" - ein Fehlertext wird am oberen Rand des Fragefelds platziert; \"Unten\" - ein Fehlertext wird am unteren Rand des Fragefelds platziert. Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an (standardmäßig \"Oben\")."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Legt die Position einer Fehlermeldung in Bezug auf alle Fragen innerhalb des Bereichs fest. Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Positioniert das Panel am Ende einer ausgewählten Seite."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Fügt Abstand oder Rand zwischen dem Inhalt des Panels und dem linken Rand des Panels hinzu."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Deaktivieren Sie diese Option, um den Bereich in einer Zeile mit der vorherigen Frage oder dem vorherigen Bereich anzuzeigen. Die Einstellung gilt nicht, wenn der Bereich das erste Element in Ihrem Formular ist."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Wählen Sie aus: \"Erweitert\" - das Panel wird vollständig angezeigt und kann eingeklappt werden; \"Reduziert\" - das Panel zeigt nur den Titel und die Beschreibung an und kann erweitert werden; \"Gesperrt\" - das Panel wird vollständig angezeigt und kann nicht eingeklappt werden."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Legt die Breite des Fensters im Verhältnis zu anderen Vermessungselementen in derselben Linie fest. Akzeptiert CSS-Werte (px, %, in, pt usw.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Geben Sie eine Vorlage für dynamische Panel-Titel ein. Verwenden Sie {panelIndex} für die allgemeine Position des Panels und {visiblePanelIndex} für die Reihenfolge der sichtbaren Bedienfelder. Fügen Sie diese Platzhalter in das Muster ein, um eine automatische Nummerierung hinzuzufügen."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Geben Sie eine Vorlage für Registerkartentitel ein. Verwenden Sie {panelIndex} für die allgemeine Position eines Panels und {visiblePanelIndex} für die Reihenfolge der sichtbaren Bedienfelder. Fügen Sie diese Platzhalter in das Muster ein, um eine automatische Nummerierung hinzuzufügen."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Mit dieser Einstellung können Sie die Sichtbarkeit einzelner Bedienfelder innerhalb des dynamischen Panels steuern. Verwenden Sie den Platzhalter '{panel}', um auf das aktuelle Panel in Ihrem Ausdruck zu verweisen."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Diese Einstellung wird automatisch von allen Fragen in diesem Bereich übernommen. Wenn Sie diese Einstellung außer Kraft setzen möchten, definieren Sie Regeln für die Titelausrichtung für einzelne Fragen. Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an (standardmäßig \"Oben\")."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "Die Option \"Vererben\" wendet die Einstellung auf Seitenebene (falls gesetzt) oder auf Umfrageebene an (standardmäßig unter dem Panel-Titel)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Definiert die Position eines neu hinzugefügten Panels. Standardmäßig werden neue Bedienfelder am Ende hinzugefügt. Wählen Sie \"Weiter\", um ein neues Panel nach dem aktuellen einzufügen."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Dupliziert die Antworten aus dem letzten Bereich und weist sie dem nächsten hinzugefügten dynamischen Bereich zu."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Verweisen Sie auf einen Fragenamen, um einen Benutzer aufzufordern, in jedem Bereich eine eindeutige Antwort auf diese Frage zu geben."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Mit dieser Einstellung können Sie einen Standardantwortwert basierend auf einem Ausdruck zuweisen. Der Ausdruck kann grundlegende Berechnungen enthalten - '{q1_id} + {q2_id}', boolesche Ausdrücke wie '{age} > 60' und Funktionen: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' usw. Der durch diesen Ausdruck ermittelte Wert dient als anfänglicher Standardwert, der durch die manuelle Eingabe eines Befragten überschrieben werden kann."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Verwenden Sie das Zauberstabsymbol, um eine Bedingungsregel festzulegen, die bestimmt, wann die Eingabe eines Befragten auf den Wert zurückgesetzt wird, der auf dem Wert \"Standardwertausdruck\" oder \"Wertausdruck festlegen\" oder auf dem Wert \"Standardantwort\" (falls einer dieser Werte festgelegt ist) basiert."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Verwenden Sie das Zauberstabsymbol, um eine Bedingungsregel festzulegen, die bestimmt, wann der \"Wertausdruck festlegen\" ausgeführt werden soll, und weisen Sie den resultierenden Wert dynamisch als Antwort zu."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Geben Sie einen Ausdruck an, der den Wert definiert, der festgelegt werden soll, wenn die Bedingungen in der Regel \"Wert festlegen, wenn\" erfüllt sind. Der Ausdruck kann grundlegende Berechnungen enthalten - '{q1_id} + {q2_id}', boolesche Ausdrücke wie '{age} > 60' und Funktionen: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' usw. Der durch diesen Ausdruck ermittelte Wert kann durch die manuelle Eingabe eines Befragten überschrieben werden."
// question.name: "A question ID that is not visible to respondents." => "Eine Frage-ID, die für die Befragten nicht sichtbar ist."
// question.description: "Type a question subtitle." => "Geben Sie einen Untertitel für die Frage ein."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Sichtbarkeit von Fragen bestimmt."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die den schreibgeschützten Modus für die Frage deaktiviert."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die verhindert, dass die Umfrage fortgesetzt oder gesendet wird, es sei denn, die Frage wurde beantwortet."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Deaktivieren Sie diese Option, um die Frage in einer Zeile mit der vorherigen Frage oder dem vorherigen Bereich anzuzeigen. Die Einstellung gilt nicht, wenn die Frage das erste Element in Ihrem Formular ist."
// question.page: "Repositions the question to the end of a selected page." => "Positioniert die Frage an das Ende einer ausgewählten Seite."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Wählen Sie aus: \"Erweitert\" - das Fragefeld wird vollständig angezeigt und kann eingeklappt werden; \"Zugeklappt\" - das Fragefeld zeigt nur den Titel und die Beschreibung an und kann erweitert werden; \"Gesperrt\" - das Fragefeld wird vollständig angezeigt und kann nicht eingeklappt werden."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Überschreibt Regeln für die Titelausrichtung, die auf Bereichs-, Seiten- oder Umfrageebene definiert sind. Mit der Option \"Vererben\" werden alle übergeordneten Einstellungen (falls gesetzt) oder Einstellungen auf Umfrageebene (\"Standardmäßig oben\") angewendet."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "Die Option \"Vererben\" wendet die Einstellung auf Umfrageebene an (\"Standardmäßig unter dem Fragetitel\")."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Legt die Position einer Fehlermeldung in Bezug auf die Frage mit ungültiger Eingabe fest. Wählen Sie zwischen: \"Oben\" - ein Fehlertext wird am oberen Rand des Fragefelds platziert; \"Unten\" - ein Fehlertext wird am unteren Rand des Fragefelds platziert. Die Option \"Vererben\" wendet die Einstellung auf Umfrageebene an (standardmäßig \"Oben\")."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Fügt Leerzeichen oder Ränder zwischen dem Inhalt der Frage und dem linken Rand des Fragefelds hinzu."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Legt die Breite der Frage im Verhältnis zu anderen Umfrageelementen in derselben Zeile fest. Akzeptiert CSS-Werte (px, %, in, pt usw.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Verwenden Sie das Zauberstabsymbol, um eine Validierungsregel für die Frage festzulegen."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Wählen Sie aus: \"Bei Fokusverlust\" - der Wert wird aktualisiert, wenn das Eingabefeld den Fokus verliert; \"Während der Eingabe\" - der Wert wird in Echtzeit aktualisiert, während Benutzer tippen. Die Option \"Vererben\" wendet die Einstellung auf Umfrageebene an (\"Standardmäßig bei verlorenem Fokus\")."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Sie können einen beliebigen Webdienst als Datenquelle für Multiple-Choice-Fragen verwenden. Um Auswahlwerte aufzufüllen, geben Sie die URL des Diensts ein, der die Daten bereitstellt."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Ein Vergleichsvorgang, der zum Filtern der Dropdownliste verwendet wird."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Legt die Breite des angezeigten Signaturbereichs und des resultierenden Bildes fest."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Legt die Höhe des angezeigten Signaturbereichs und des resultierenden Bildes fest."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Wählen Sie diese Option aus, wenn der Signaturbereich den gesamten verfügbaren Platz innerhalb des Fragefelds ausfüllen soll, während das Standardseitenverhältnis von 3:2 beibehalten wird. Wenn benutzerdefinierte Werte für Breite und Höhe festgelegt sind, behält die Einstellung das Seitenverhältnis dieser Abmessungen bei."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Passt die Höhe des Bildes in den Umfrageergebnissen an."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Passt die Breite des Bildes in den Umfrageergebnissen an."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Überschreibt die minimalen und maximalen Höhenwerte."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Überschreibt die minimalen und maximalen Breitenwerte."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Wert\" dient als Element-ID, die in bedingten Regeln verwendet wird. Den Befragten wird \"Text\" angezeigt."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Diese Einstellung ändert nur die Größe des Eingabefelds und wirkt sich nicht auf die Breite des Fragefelds aus. Um die zulässige Eingabelänge zu begrenzen, gehen Sie zu <b>Validierung → Maximales Zeichenlimit</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Legt die Anzahl der angezeigten Zeilen im Eingabefeld fest. Wenn die Eingabe mehr Zeilen einnimmt, wird die Bildlaufleiste angezeigt."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Wählen Sie zwischen: \"Bearbeitbar\" - ermöglicht es den Befragten, Ihre Umfrage auszufüllen; \"Schreibgeschützt\" - deaktiviert die Formularbearbeitung."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "Eine Spalten-ID, die für die Befragten nicht sichtbar ist."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Wenn diese Option für eine Spalte aktiviert ist, muss ein Befragter für jede Frage in dieser Spalte eine eindeutige Antwort geben."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Legt die Anzahl der angezeigten Zeilen im Eingabefeld fest. Wenn die Eingabe mehr Zeilen einnimmt, wird die Bildlaufleiste angezeigt."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Sichtbarkeit von Spalten bestimmt."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Verwenden Sie das Zauberstabsymbol, um eine Bedingungsregel festzulegen, die den schreibgeschützten Modus für die Spalte deaktiviert."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Übermittlung von Umfragen verhindert, es sei denn, mindestens eine verschachtelte Frage enthält eine Antwort."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Wenn diese Option aktiviert ist, wird für jede Auswahloption eine eigene Spalte erstellt."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Wählen Sie aus: \"Statisch\" - legt eine feste Breite fest; \"Responsive\" - lässt die Umfrage die gesamte Breite des Bildschirms einnehmen; \"Auto\" - wendet je nach verwendetem Fragetyp einen der beiden an."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Fügen Sie einen Bildlink ein (keine Größenbeschränkung) oder klicken Sie auf das Ordnersymbol, um eine Datei von Ihrem Computer (bis zu 64 KB) zu durchsuchen."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Legt eine Logobreite in CSS-Einheiten (px, %, in, pt usw.) fest."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Legt die Höhe eines Logos in CSS-Einheiten (px, %, in, pt usw.) fest."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Wählen Sie aus: \"Keine\" - das Bild behält seine ursprüngliche Größe; \"Enthalten\" - die Größe des Bildes wird angepasst, wobei das Seitenverhältnis beibehalten wird. \"Cover\" - das Bild füllt den gesamten Rahmen aus, während das Seitenverhältnis beibehalten wird. \"Füllen\" - Das Bild wird gestreckt, um den Rahmen auszufüllen, ohne das Seitenverhältnis beizubehalten."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page. The survey is also completed automatically." => "Wählen Sie diese Option aus, wenn die Umfrage automatisch zur nächsten Seite weitergeleitet werden soll, nachdem ein Befragter alle Fragen auf der aktuellen Seite beantwortet hat."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Legt die Sichtbarkeit und Position von Navigationsschaltflächen auf einer Seite fest."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Legt die Sichtbarkeit und Position einer Statusanzeige fest. Der Wert \"Auto\" zeigt den Fortschrittsbalken über oder unter der Kopfzeile der Umfrage an."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Aktivieren Sie die Vorschauseite nur mit allen oder beantworteten Fragen."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Gilt für alle Fragen innerhalb der Umfrage. Diese Einstellung kann durch Regeln für die Titelausrichtung auf niedrigeren Ebenen außer Kraft gesetzt werden: Bereich, Seite oder Frage. Eine Einstellung auf niedrigerer Ebene überschreibt die Einstellung auf einer höheren Ebene."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Ein Symbol oder eine Sequenz von Symbolen, die darauf hinweist, dass eine Antwort erforderlich ist."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Geben Sie eine Zahl oder einen Buchstaben ein, mit der Sie die Nummerierung beginnen möchten."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Legt die Position einer Fehlermeldung in Bezug auf die Frage mit ungültiger Eingabe fest. Wählen Sie zwischen: \"Oben\" - ein Fehlertext wird am oberen Rand des Fragefelds platziert; \"Unten\" - ein Fehlertext wird am unteren Rand des Fragefelds platziert."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Wählen Sie diese Option aus, wenn das erste Eingabefeld auf jeder Seite für die Texteingabe bereit sein soll."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Behält die ursprüngliche Reihenfolge der Fragen bei oder randomisiert sie. Die Auswirkungen dieser Einstellung sind nur auf der Registerkarte Vorschau sichtbar."
// pehelp.maxTextLength: "For text entry questions only." => "Nur für Fragen zur Texteingabe."
// pehelp.maxOthersLength: "For question comments only." => "Nur für Fragenkommentare."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Wählen Sie diese Option aus, wenn Fragenkommentare und Langtextfragen basierend auf der eingegebenen Textlänge automatisch in die Höhe wachsen sollen."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Nur für Fragenkommentare und Langtextfragen."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Benutzerdefinierte Variablen dienen als Zwischen- oder Hilfsvariablen, die in Formularberechnungen verwendet werden. Sie nehmen die Eingaben der Befragten als Quellwerte. Jede benutzerdefinierte Variable hat einen eindeutigen Namen und einen Ausdruck, auf dem sie basiert."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Wählen Sie diese Option aus, wenn der berechnete Wert des Ausdrucks zusammen mit den Umfrageergebnissen gespeichert werden soll."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Ein Trigger ist ein Ereignis oder eine Bedingung, die auf einem Ausdruck basiert. Sobald der Ausdruck als \"true\" ausgewertet wird, löst ein Trigger eine Aktion aus. Eine solche Aktion kann optional eine Zielfrage haben, auf die sie sich auswirkt."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Wählen Sie aus, ob und wann Werte für Fragen, die durch bedingte Logik ausgeblendet werden, gelöscht werden sollen."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Wählen Sie aus: \"Bei Fokusverlust\" - der Wert wird aktualisiert, wenn das Eingabefeld den Fokus verliert; \"Während der Eingabe\" - der Wert wird in Echtzeit aktualisiert, während Benutzer tippen."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Der linke Wert dient als Spalten-ID, die in bedingten Regeln verwendet wird, der rechte Wert wird den Befragten angezeigt."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Der linke Wert dient als Zeilen-ID, die in bedingten Regeln verwendet wird, der rechte Wert wird den Befragten angezeigt."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Akzeptiert CSS-Werte (px, %, in, pt usw.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Akzeptiert CSS-Werte (px, %, in, pt usw.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Legt die Position einer Fehlermeldung in Bezug auf eine Zelle mit ungültiger Eingabe fest. Die Option \"Vererben\" übernimmt die Einstellung aus der Eigenschaft \"Fehlermeldungsausrichtung\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Wenn die Eigenschaft \"Doppelte Beantwortungen verhindern\" aktiviert ist, erhält ein Befragter, der versucht, einen doppelten Beitrag einzureichen, die folgende Fehlermeldung."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Hiermit können Sie Gesamtwerte basierend auf einem Ausdruck berechnen. Der Ausdruck kann grundlegende Berechnungen ('{q1_id} + {q2_id}'), boolesche Ausdrücke ('{age} > 60') und Funktionen ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' usw.) enthalten."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Löst eine Eingabeaufforderung aus, in der Sie aufgefordert werden, das Löschen der Zeile zu bestätigen."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Dupliziert Antworten aus der letzten Zeile und weist sie der nächsten hinzugefügten dynamischen Zeile zu."
// pehelp.description: "Type a subtitle." => "Geben Sie einen Untertitel ein."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Wählen Sie eine Sprache aus, um mit der Erstellung Ihrer Umfrage zu beginnen. Um eine Übersetzung hinzuzufügen, wechseln Sie in eine neue Sprache und übersetzen Sie den Originaltext hier oder auf der Registerkarte Übersetzungen."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Legt die Position eines Detailabschnitts in Bezug auf eine Zeile fest. Wählen Sie aus: \"Keine\" - es wird keine Erweiterung hinzugefügt; \"Unter der Zeile\" - unter jeder Zeile der Matrix wird eine Zeilenerweiterung platziert; \"Unter der Zeile nur eine Zeilenerweiterung anzeigen\" - eine Erweiterung wird nur unter einer einzelnen Zeile angezeigt, die restlichen Zeilenerweiterungen werden ausgeblendet."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Wählen Sie aus: \"Keine\" - das Bild behält seine ursprüngliche Größe; \"Enthalten\" - die Größe des Bildes wird angepasst, wobei das Seitenverhältnis beibehalten wird. \"Cover\" - das Bild füllt den gesamten Rahmen aus, während das Seitenverhältnis beibehalten wird. \"Füllen\" - Das Bild wird gestreckt, um den Rahmen auszufüllen, ohne das Seitenverhältnis beizubehalten."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Erhöht die Höhe des Eingabefelds schrittweise, während Daten eingegeben werden. Überschreibt die Einstellung \"Höhe des Eingabefelds (in Zeilen)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Der Ziehpunkt (oder Griff) wird in der Ecke angezeigt und kann gezogen werden, um die Größe des Eingabefelds zu ändern."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Ein Zeitintervall in Sekunden, nach dem die Umfrage automatisch zur Danke-Seite wechselt."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Ein Zeitintervall in Sekunden, nach dem die Umfrage automatisch zur nächsten Seite wechselt."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Ein Zeitintervall in Sekunden, nach dem die Umfrage automatisch zur nächsten Seite wechselt."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Sichtbarkeit der Seite bestimmt."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die den schreibgeschützten Modus für die Seite deaktiviert."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Verwenden Sie das Zauberstabsymbol, um eine bedingte Regel festzulegen, die die Übermittlung von Umfragen verhindert, es sei denn, mindestens eine verschachtelte Frage enthält eine Antwort."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Gilt für alle Fragen auf dieser Seite. Wenn Sie diese Einstellung außer Kraft setzen möchten, definieren Sie Regeln für die Titelausrichtung für einzelne Fragen oder Bereiche. Die Option \"Vererben\" wendet die Einstellung auf Umfrageebene an (standardmäßig \"Oben\")."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Legt die Position einer Fehlermeldung in Bezug auf die Frage mit ungültiger Eingabe fest. Wählen Sie zwischen: \"Oben\" - ein Fehlertext wird am oberen Rand des Fragefelds platziert; \"Unten\" - ein Fehlertext wird am unteren Rand des Fragefelds platziert. Die Option \"Vererben\" wendet die Einstellung auf Umfrageebene an (standardmäßig \"Oben\")."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Behält die ursprüngliche Reihenfolge der Fragen bei oder randomisiert sie. Mit der Option \"Vererben\" wird die Einstellung auf Umfrageebene (\"Original\" standardmäßig) angewendet. Die Auswirkungen dieser Einstellung sind nur auf der Registerkarte Vorschau sichtbar."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Legt die Sichtbarkeit von Navigationsschaltflächen auf der Seite fest. Mit der Option \"Vererben\" wird die Einstellung auf Umfrageebene angewendet, die standardmäßig auf \"Sichtbar\" eingestellt ist."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Legt die Sichtbarkeit und Position eines Timers auf einer Seite fest."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Wählen Sie aus: \"Gesperrt\" - Benutzer können Bedienfelder nicht erweitern oder reduzieren; \"Alle ausblenden\" - alle Bedienfelder beginnen in einem zusammengeklappten Zustand; \"Alle erweitern\" - alle Bedienfelder beginnen in einem erweiterten Zustand; \"First expanded\" - nur das erste Panel wird zunächst erweitert."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Geben Sie einen freigegebenen Eigenschaftsnamen in das Array von Objekten ein, das die Bild- oder Videodatei-URLs enthält, die in der Auswahlliste angezeigt werden sollen."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Der linke Wert dient als Element-ID, die in bedingten Regeln verwendet wird, der rechte Wert wird den Befragten angezeigt."
// pehelp.title: "Type a user-friendly title to display." => "Geben Sie einen benutzerfreundlichen Titel ein, der angezeigt werden soll."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Stellt sicher, dass Benutzer die Umfrage erst abschließen, wenn die Dateien hochgeladen wurden."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Akzeptiert CSS-Werte (px, %, in, pt usw.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Akzeptiert CSS-Werte (px, %, in, pt usw.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Akzeptiert CSS-Werte (px, %, in, pt usw.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "Bei Fragetypen mit einfacher und mehrfacher Auswahl verfügt jede Auswahloption über eine ID und einen Anzeigewert. Wenn diese Einstellung aktiviert ist, wird in HTML-Fragen und dynamischen Titeln und Beschreibungen von Umfrageelementen ein Anzeigewert anstelle eines ID-Werts angezeigt."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Wählen Sie aus, ob und wann Fragenwerte, die durch bedingte Logik ausgeblendet werden, gelöscht werden sollen. Die Option \"Vererben\" wendet die Einstellung auf Umfrageebene an (standardmäßig \"Nach Abschluss der Umfrage\")."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Wählen Sie aus: \"Alle\" - kopiert alle Auswahloptionen aus der ausgewählten Frage; \"Ausgewählt\" - kopiert dynamisch nur ausgewählte Auswahloptionen; \"Nicht ausgewählt\" - kopiert dynamisch nur nicht ausgewählte Auswahloptionen. Die Optionen \"Keine\" und \"Sonstiges\" werden standardmäßig kopiert, wenn sie in der Quellfrage aktiviert sind."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Wenn diese Option ausgewählt ist, können Benutzer zusätzliche Eingaben in ein separates Kommentarfeld einfügen."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Zeigt jede spezielle Auswahloption (\"Keine\", \"Andere\", \"Alle auswählen\") in einer neuen Zeile an, auch wenn ein mehrspaltiges Layout verwendet wird."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Geben Sie die Position innerhalb des Service-Datasets an, an der sich das Ziel-Array von Objekten befindet. Lassen Sie das Feld leer, wenn die URL bereits auf das Array verweist."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Geben Sie innerhalb des Objektarrays einen einheitlichen Eigenschaftsnamen ein, der die Werte enthält, die in der Auswahlliste angezeigt werden sollen."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Wählen Sie diese Option aus, damit der Dienst eine leere Antwort oder ein leeres Array zurückgeben kann."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Verwenden Sie das Zauberstabsymbol, um eine Bedingungsregel festzulegen, die die Sichtbarkeit aller Auswahloptionen bestimmt."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Der linke Wert dient als Element-ID, die in bedingten Regeln verwendet wird, der rechte Wert wird den Befragten angezeigt."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" wählt zwischen den Modi \"Buttons\" und \"Dropdown\" basierend auf der verfügbaren Breite. Wenn die Breite nicht ausreicht, um Schaltflächen anzuzeigen, wird für die Frage ein Dropdown-Menü angezeigt."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Ermöglicht es Ihnen, Fragen zu verbinden, die Ergebnisse in verschiedenen Formaten liefern. Wenn solche Fragen mithilfe eines Verknüpfungsbezeichners miteinander verknüpft sind, speichert diese gemeinsam genutzte Eigenschaft ausgewählte Fragewerte."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Wählen Sie diese Option aus, wenn Sie den Inhalt des Dropdown-Menüs so aktualisieren möchten, dass er der Suchabfrage entspricht, die ein Benutzer in das Eingabefeld eingibt."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Ein Wert, der in den Umfrageergebnissen gespeichert werden soll, wenn die Befragten eine positive Antwort geben."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Ein Wert, der in den Umfrageergebnissen gespeichert werden soll, wenn die Befragten eine negative Antwort geben."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Es wird nicht empfohlen, diese Option zu deaktivieren, da sie das Vorschaubild überschreibt und es für einen Benutzer schwierig macht, zu verstehen, ob die Dateien hochgeladen wurden."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Löst eine Eingabeaufforderung aus, in der Sie aufgefordert werden, das Löschen der Datei zu bestätigen."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Aktivieren Sie diese Option, um nur ausgewählte Auswahlmöglichkeiten in eine Rangfolge zu bringen. Benutzer ziehen ausgewählte Elemente aus der Auswahlliste, um sie innerhalb des Ranking-Bereichs zu sortieren."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Geben Sie eine Liste mit Auswahlmöglichkeiten ein, die dem Befragten während der Eingabe vorgeschlagen werden."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Die Einstellung ändert nur die Größe der Eingabefelder und wirkt sich nicht auf die Breite des Fragefelds aus."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Legt eine konsistente Breite für alle Elementbeschriftungen in Pixeln fest"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Die Option \"Auto\" bestimmt automatisch den geeigneten Anzeigemodus - Bild, Video oder YouTube - basierend auf der bereitgestellten Quell-URL."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Dient als Ersatz, wenn das Bild nicht auf dem Gerät eines Benutzers angezeigt werden kann, und aus Gründen der Barrierefreiheit."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Definiert die Farbe des ausgewählten Emojis, wenn der Symboltyp \"Bewertung\" auf \"Smileys\" eingestellt ist. Wählen Sie zwischen: \"Standard\" - das ausgewählte Emoji erscheint in der Standardfarbe der Umfrage; \"Skala\" - das ausgewählte Emoji erbt die Farbe von der Bewertungsskala."
// expression.name: "An expression ID that is not visible to respondents." => "Eine Ausdrucks-ID, die für die Befragten nicht sichtbar ist."
// expression.description: "Type an expression subtitle." => "Geben Sie einen Ausdrucksuntertitel ein."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Ein Ausdruck kann grundlegende Berechnungen ('{q1_id} + {q2_id}'), Bedingungen ('{age} > 60') und Funktionen ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' usw.) enthalten."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Wählen Sie diese Option aus, um den Wert der Option \"Sonstiges\" als separate Eigenschaft in den Umfrageergebnissen zu speichern."
// p.swapOrder: "Swap the order of Yes and No" => "Vertauschen Sie die Reihenfolge von Ja und Nein"
// p.itemTitleWidth: "Item label width (in px)" => "Breite der Artikelbeschriftung (in px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Text, der angezeigt werden soll, wenn alle Optionen ausgewählt sind"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Platzhaltertext für den Rankingbereich"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Automatisches Ausfüllen der Umfrage"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Wählen Sie diese Option aus, wenn die Umfrage automatisch abgeschlossen werden soll, nachdem ein Befragter alle Fragen beantwortet hat."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Maskierte Werte in Umfrageergebnissen speichern"
// patternmask.pattern: "Value pattern" => "Werte-Muster"
// datetimemask.min: "Minimum value" => "Mindestwert"
// datetimemask.max: "Maximum value" => "Maximalwert"
// numericmask.allowNegativeValues: "Allow negative values" => "Negative Werte zulassen"
// numericmask.thousandsSeparator: "Thousands separator" => "Tausender-Trennzeichen"
// numericmask.decimalSeparator: "Decimal separator" => "Dezimaltrennzeichen"
// numericmask.precision: "Value precision" => "Wertgenauigkeit"
// numericmask.min: "Minimum value" => "Mindestwert"
// numericmask.max: "Maximum value" => "Maximalwert"
// currencymask.prefix: "Currency prefix" => "Währungs-Präfix"
// currencymask.suffix: "Currency suffix" => "Währungs-Suffix"
// pe.maskType: "Input mask type" => "Typ der Eingabemaske"
// maskTypes.patternmask: "Pattern" => "Muster"
// maskTypes.numericmask: "Numeric" => "Numerisch"
// maskTypes.datetimemask: "Date and Time" => "Datum und Uhrzeit"
// maskTypes.currencymask: "Currency" => "Währung"
// tabs.mask: "Input Mask Settings" => "Einstellungen für die Eingabemaske"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Bsp.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Beispiel: mm/tt/jjjj"
// pe.currencyprefix_placeholder: "Ex.: $" => "Bsp.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Bsp.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Auswahl an Wraps"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Lange Texte in Auswahloptionen generieren automatisch Zeilenumbrüche, die in das Dropdown-Menü passen. Deaktivieren Sie diese Option, wenn die Texte abgeschnitten werden sollen."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Wählen Sie diese Option aus, wenn Sie den Fragewert mit einer angewendeten Maske in den Umfrageergebnissen speichern möchten."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Das Muster kann Zeichenfolgenliterale und die folgenden Platzhalter enthalten: '9' - für eine Ziffer; \"a\" - für einen Groß- oder Kleinbuchstaben; '#' - für eine Ziffer oder einen Groß- oder Kleinbuchstaben. Verwenden Sie den umgekehrten Schrägstrich '\\', um ein Zeichen mit Escapezeichen zu versehen."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Das Muster kann Trennzeichen und die folgenden Platzhalter enthalten: 'm' - für Monatsnummer; 'mm' - für Monatszahl, mit führender Null für einstellige Werte; 'd' - für Tag des Monats; 'dd' - für Tag des Monats, mit führender Null für einstellige Werte; 'yy' - für die letzten beiden Ziffern des Jahres; 'yyyy' - für ein vierstelliges Jahr."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Ein Symbol, das verwendet wird, um den Bruchteil vom ganzzahligen Teil einer angezeigten Zahl zu trennen."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Ein Symbol, das verwendet wird, um die Ziffern einer großen Zahl in Dreiergruppen zu unterteilen."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Schränkt die Anzahl der Nachkommastellen für eine angezeigte Zahl ein."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Ein oder mehrere Symbole, die vor dem Wert angezeigt werden sollen."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Ein oder mehrere Symbole, die nach dem Wert angezeigt werden sollen."
// ed.translationSource: "Source: " => "Quelle: "
// ed.translationTarget: "Target: " => "Ziel: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Die Seite ist leer. Ziehen Sie ein Element aus der Toolbox oder klicken Sie auf die Schaltfläche unten."
// maskTypes.none: "None" => "Nichts"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Machen Sie die Zeile sichtbar, wenn"
// itemvalue@rows.enableIf: "Make the row editable if" => "Machen Sie die Zeile bearbeitbar, wenn"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Platzhaltertext im schreibgeschützten oder Vorschaumodus"
// pe.textWrapEnabled: "Wrap choices" => "Auswahl an Wraps"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Die Option \"Auto\" bestimmt automatisch den geeigneten Anzeigemodus - Bild, Video oder YouTube - basierend auf der bereitgestellten Quell-URL."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Wählen Sie zwischen \"Bild\" und \"Video\", um den Inhaltsmodus der Medienauswahl festzulegen. Wenn \"Bild\" ausgewählt ist, stellen Sie sicher, dass es sich bei allen bereitgestellten Optionen um Bilddateien in den folgenden Formaten handelt: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Wenn \"Video\" ausgewählt ist, stellen Sie sicher, dass alle Optionen direkte Links zu Videodateien in den folgenden Formaten sind: MP4, MOV, WMV, FLV, AVI, MKV. Bitte beachten Sie, dass YouTube-Links für Videooptionen nicht unterstützt werden."
// ed.selectFile: "Select a file" => "Wählen Sie eine Datei aus"
// ed.removeFile: "Remove the file" => "Entfernen Sie die Datei"
// pe.searchMode: "Search Mode" => "Suchmodus"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Klicken Sie unten auf die Schaltfläche \"Frage hinzufügen\", um mit der Erstellung Ihres Formulars zu beginnen."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Klicken Sie unten auf die Schaltfläche \"Frage hinzufügen\", um der Seite ein neues Element hinzuzufügen."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Klicken Sie unten auf die Schaltfläche \"Frage hinzufügen\", um dem Bedienfeld ein neues Element hinzuzufügen."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Klicken Sie auf die Schaltfläche unten und wählen Sie ein Bild zum Hochladen aus"
// coloralpha.opacity: "Opacity" => "Undurchsichtigkeit"
// font.family: "Font family" => "Schriftfamilie"
// font.color: "Color" => "Farbe"
// font.placeholderColor: "Placeholder color" => "Platzhalterfarbe"
// font.size: "Size" => "Größe"
// theme.themeName: "Theme" => "Thema"
// theme.isPanelless: "Question appearance" => "Aussehen der Frage"
// theme.editorPanel: "Background and corner radius" => "Hintergrund und Eckenradius"
// theme.questionPanel: "Background and corner radius" => "Hintergrund und Eckenradius"
// theme.primaryColor: "Accent color" => "Akzentfarbe"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Deckkraft des Bedienfeldhintergrunds"
// theme.questionBackgroundTransparency: "Question background opacity" => "Deckkraft des Hintergrunds der Frage"
// theme.fontSize: "Font size" => "Schriftgrad"
// theme.scale: "Scale" => "Maßstab"
// theme.cornerRadius: "Corner radius" => "Ecken-Radius"
// theme.pageTitle: "Title font" => "Schriftart des Titels"
// theme.pageDescription: "Description font" => "Beschreibung Schriftart"
// theme.questionTitle: "Title font" => "Schriftart des Titels"
// theme.questionDescription: "Description font" => "Beschreibung Schriftart"
// theme.editorFont: "Font" => "Schriftart"
// theme.backgroundOpacity: "Opacity" => "Undurchsichtigkeit"
// theme.--sjs-font-family: "Font family" => "Schriftfamilie"
// theme.--sjs-general-backcolor-dim: "Background color" => "Hintergrundfarbe"
// theme.--sjs-primary-backcolor: "Accent background" => "Akzent-Hintergrund"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Akzent Vordergrund"
// theme.--sjs-shadow-small: "Shadow effects" => "Schatten-Effekte"
// theme.--sjs-shadow-inner: "Shadow effects" => "Schatten-Effekte"
// theme.--sjs-border-default: "Colors" => "Farben"
// header@header.headerView: "View" => "Ansehen"
// header@header.logoPosition: "Logo position" => "Logo-Position"
// header@header.surveyTitle: "Survey title font" => "Schriftart des Umfragetitels"
// header@header.surveyDescription: "Survey description font" => "Schriftart der Umfragebeschreibung"
// header@header.headerTitle: "Survey title font" => "Schriftart des Umfragetitels"
// header@header.headerDescription: "Survey description font" => "Schriftart der Umfragebeschreibung"
// header@header.inheritWidthFrom: "Content area width" => "Breite des Inhaltsbereichs"
// header@header.textAreaWidth: "Text width" => "Textbreite"
// header@header.backgroundColorSwitch: "Background color" => "Hintergrundfarbe"
// header@header.backgroundImage: "Background image" => "Hintergrundbild"
// header@header.backgroundImageOpacity: "Opacity" => "Undurchsichtigkeit"
// header@header.overlapEnabled: "Overlap" => "Überlappung"
// header@header.logoPositionX: "Logo position" => "Logo-Position"
// header@header.titlePositionX: "Title position" => "Titelposition"
// header@header.descriptionPositionX: "Description position" => "Beschreibung Position"
// weight.400: "Regular" => "Regelmäßig"
// weight.600: "Heavy" => "Schwer"
// weight.700: "Semi-bold" => "Halbfett"
// weight.800: "Bold" => "Kühn"
// backgroundImageFit.auto: "Auto" => "Auto"
// backgroundImageFit.cover: "Cover" => "Deckel"
// backgroundImageFit.contain: "Contain" => "Enthalten"
// backgroundImageFit.fill: "Stretch" => "Strecken"
// backgroundImageFit.tile: "Tile" => "Fliese"
// backgroundImageAttachment.fixed: "Fixed" => "Fest"
// backgroundImageAttachment.scroll: "Scroll" => "Schriftrolle"
// headerView.basic: "Basic" => "Grundlegend"
// headerView.advanced: "Advanced" => "Fortgeschritten"
// inheritWidthFrom.survey: "Same as survey" => "Wie bei der Umfrage"
// inheritWidthFrom.container: "Fit to container" => "An Container anpassen"
// backgroundColorSwitch.none: "None" => "Nichts"
// backgroundColorSwitch.accentColor: "Accent color" => "Akzentfarbe"
// backgroundColorSwitch.custom: "Custom" => "Gewohnheit"
// colorPalette.light: "Light" => "Licht"
// colorPalette.dark: "Dark" => "Dunkel"
// isPanelless.false: "Default" => "Vorgabe"
// isPanelless.true: "Without Panels" => "Ohne Paneele"
// theme.cornerRadius: "Corner radius" => "Ecken-Radius"
// theme.fontFamily: "Font family" => "Schriftfamilie"
// theme.fontWeightRegular: "Regular" => "Regelmäßig"
// theme.fontWeightHeavy: "Heavy" => "Schwer"
// theme.fontWeightSemiBold: "Semi-bold" => "Halbfett"
// theme.fontWeightBold: "Bold" => "Kühn"
// theme.color: "Color" => "Farbe"
// theme.placeholderColor: "Placeholder color" => "Platzhalterfarbe"
// theme.size: "Size" => "Größe"
// theme.opacity: "Opacity" => "Undurchsichtigkeit"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Geben Sie ein, um zu suchen..."
// ed.toolboxNoResultsFound: "No results found" => "Keine Ergebnisse gefunden"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Platzhalter für Registerkartentitel"
// theme.--sjs-special-red: "Error messages" => "Fehlermeldungen"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Ein Fallbacktext für Registerkartentitel, der angewendet wird, wenn das Registerkartentitelmuster keinen aussagekräftigen Wert erzeugt."
// theme.fontColor: "Font color" => "Schriftfarbe"
// theme.backgroundColor: "Background color" => "Hintergrundfarbe"
// pe.questionTitleWidth: "Question title width" => "Breite des Fragetitels"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Wählen Sie eine Datei aus oder fügen Sie einen Dateilink ein..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Beispiel: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Legt eine konsistente Breite für Fragetitel fest, wenn sie links neben den Fragefeldern ausgerichtet sind. Akzeptiert CSS-Werte (px, %, in, pt usw.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Legt eine konsistente Breite für Fragetitel fest, wenn sie links neben den Fragefeldern ausgerichtet sind. Akzeptiert CSS-Werte (px, %, in, pt usw.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Höhe des Kommentarbereichs (in Zeilen)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Legt die Anzahl der angezeigten Zeilen in Textbereichen für Fragenkommentare fest. Wenn die Eingabe mehr Zeilen einnimmt, erscheint die Bildlaufleiste."


/***/ }),

/***/ "./src/localization/hebrew.ts":
/*!************************************!*\
  !*** ./src/localization/hebrew.ts ***!
  \************************************/
/*! exports provided: hebrewStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hebrewStrings", function() { return hebrewStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var hebrewStrings = {
    // survey templates
    survey: {
        edit: "עריכה",
        externalHelpLink: "צפו ולמדו כיצד ליצור סקרים",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "אנא הזינו שאלה מארגז הכלים כאן.",
        addLogicItem: "צרו כלל להתאמה אישית של זרימת הסקר.",
        copy: "העתק",
        duplicate: "שכפול",
        addToToolbox: "הוסיפו לכלי הכלים",
        deletePanel: "מחיקת לוח",
        deleteQuestion: "מחיקת שאלה",
        convertTo: "המרה ל",
        drag: "גרירת אלמנט",
    },
    // Creator tabs
    tabs: {
        preview: "תצוגה מקדימה",
        theme: "ערכות נושא",
        translation: "תרגום",
        designer: "מעצב",
        editor: "עורך JSON",
        logic: "לוגיקה"
    },
    // Question types
    qt: {
        default: "ברירת מחדל",
        checkbox: "תיבות סימון",
        comment: "טקסט ארוך",
        imagepicker: "בורר תמונות",
        ranking: "דירוג",
        image: "תמונה",
        dropdown: "תפריט נפתח",
        tagbox: "תפריט נפתח מרובה בחירה",
        file: "העלאת קובץ",
        html: "HTML",
        matrix: "מטריצת בחירה יחידה",
        matrixdropdown: "מטריצת בחירה מרובה",
        matrixdynamic: "מטריצה דינמית",
        multipletext: "תיבות טקסט מרובות",
        panel: "לוח",
        paneldynamic: "לוח דינמי",
        radiogroup: "קבוצת כפתורי רדיו",
        rating: "סולם דירוג",
        text: "קלט בשורה אחת",
        boolean: "כן/לא (בוליאני)",
        expression: "ביטוי (קריאה בלבד)",
        signaturepad: "חתימה",
        buttongroup: "קבוצת כפתורים"
    },
    toolboxCategories: {
        general: "כללי",
        choice: "שאלות עם בחירה",
        text: "שאלות טקסטואליות",
        containers: "מכילים",
        matrix: "שאלות מטריצה",
        misc: "שונות"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "ברירת מחדל ({0})",
        survey: "סקר",
        settings: "הגדרות",
        settingsTooltip: "פתח הגדרות",
        surveySettings: "הגדרות הסקר",
        surveySettingsTooltip: "הגדרות סקר",
        themeSettings: "הגדרות ערכת העיצוב",
        themeSettingsTooltip: "הגדרות ערכת נושא",
        showPanel: "הצג לוח",
        hidePanel: "הסתר לוח",
        prevSelected: "בחר קודם",
        nextSelected: "בחר בבא בתור",
        prevFocus: "פוקוס קודם",
        nextFocus: "התמקד הבא",
        surveyTypeName: "סקר",
        pageTypeName: "דף",
        panelTypeName: "לוח",
        questionTypeName: "שאלה",
        columnTypeName: "עמודה",
        addNewPage: "הוסף דף חדש",
        moveRight: "גלול ימינה",
        moveLeft: "גלול שמאלה",
        deletePage: "מחק דף",
        editPage: "ערוך דף",
        edit: "ערוך",
        newPageName: "דף",
        newQuestionName: "שאלה",
        newPanelName: "לוח",
        newTextItemName: "טקסט",
        defaultV2Theme: "ברירת מחדל",
        modernTheme: "מודרני",
        defaultTheme: "ברירת מחדל (ירושה)",
        testSurveyAgain: "תצוגה מקדימה שוב",
        testSurveyWidth: "רוחב הסקר: ",
        navigateToMsg: "הייתם צריכים לנווט אל",
        saveSurvey: "שמור סקר",
        saveSurveyTooltip: "שמור סקר",
        saveTheme: "שמור ערכת נושא",
        saveThemeTooltip: "שמור ערכת נושא",
        jsonHideErrors: "הסתר שגיאות",
        jsonShowErrors: "הצג שגיאות",
        undo: "בטל",
        redo: "בצע מחדש",
        undoTooltip: "בטל שינוי אחרון",
        redoTooltip: "בצע מחדש את השינוי",
        showMoreChoices: "הצג עוד",
        showLessChoices: "הצג פחות",
        copy: "העתק",
        cut: "גזור",
        paste: "הדבק",
        copyTooltip: "העתק את הבחירה ללוח הגזירים",
        cutTooltip: "גזור את הבחירה ללוח הגזירים",
        pasteTooltip: "הדבק מלוח הגזירים",
        options: "אפשרויות",
        generateValidJSON: "צור JSON תקין",
        generateReadableJSON: "צור JSON קריא",
        toolbox: "ארגז הכלים",
        "property-grid": "מאפיינים",
        toolboxFilteredTextPlaceholder: "הקלד כדי לחפש...",
        toolboxNoResultsFound: "לא נמצאו תוצאות",
        propertyGridFilteredTextPlaceholder: "הקלד כדי לחפש...",
        propertyGridNoResultsFound: "לא נמצאו תוצאות",
        correctJSON: "אנא תקנו את ה-JSON.",
        surveyResults: "תוצאות הסקר",
        surveyResultsTable: "כטבלה",
        surveyResultsJson: "כ-JSON",
        resultsTitle: "כותרת השאלה",
        resultsName: "שם השאלה",
        resultsValue: "ערך התשובה",
        resultsDisplayValue: "ערך תצוגה",
        modified: "שונה",
        saving: "שומר",
        saved: "נשמר",
        propertyEditorError: "שגיאה",
        saveError: "שגיאה! התוכן של העורך לא נשמר.",
        translationPropertyGridTitle: "הגדרות שפה",
        themePropertyGridTitle: "הגדרות ערכת העיצוב",
        translationLanguages: "שפות",
        translationDeleteLanguage: "האם אתה בטוח שברצונך למחוק את כל המחרוזות לשפה זו?",
        translationAddLanguage: "בחר שפה לתרגום",
        translationShowAllStrings: "כל המחרוזות",
        translationShowUsedStringsOnly: "רק מחרוזות בשימוש",
        translationShowAllPages: "כל הדפים",
        translationNoStrings: "אין מחרוזות לתרגום. אנא שנה את הסינון.",
        translationExportToSCVButton: "ייצא ל-CSV",
        translationImportFromSCVButton: "ייבא מ-CSV",
        translateUsigAI: "תרגום אוטומטי של הכל",
        translateUsigAIFrom: "תרגם מ: ",
        translationDialogTitle: "מחרוזות לא מתורגמות",
        translationMergeLocaleWithDefault: "מזג {0} עם הגדרות ברירת המחדל",
        translationPlaceHolder: "תרגום...",
        translationSource: "מקור: ",
        translationTarget: "יעד: ",
        themeExportButton: "ייצא",
        themeImportButton: "ייבא",
        surveyJsonExportButton: "ייצא",
        surveyJsonImportButton: "ייבוא",
        surveyJsonCopyButton: "העתק ללוח",
        themeResetButton: "אפס הגדרות ערכת העיצוב לברירת המחדל",
        themeResetConfirmation: "האם אתה באמת רוצה לאפס את ערכת הנושא? כל ההתאמות האישיות שלך יאבדו.",
        themeResetConfirmationOk: "כן, אפס את ערכת הנושא",
        bold: "מודגש",
        italic: "נטוי",
        underline: "קו תחתון",
        addNewQuestion: "הוסף שאלה",
        selectPage: "בחר דף...",
        carryForwardChoicesCopied: "הטענות הועתקו מ",
        choicesLoadedFromWebText: "האפשרויות נטענות משירות אינטרנט.",
        choicesLoadedFromWebLinkText: "עבור אל הגדרות",
        choicesLoadedFromWebPreviewTitle: "תצוגה מקדימה של אפשרויות בחירה שנטענו",
        htmlPlaceHolder: "התוכן של HTML יופיע כאן.",
        panelPlaceHolder: "גרר שאלה מתיק כלי הכלים לכאן.",
        surveyPlaceHolder: "הסקר ריק. גרור אלמנט מארגז הכלים או לחץ על הכפתור למטה.",
        pagePlaceHolder: "הדף ריק. גרור רכיב מארגז הכלים או לחץ על הלחצן למטה.",
        imagePlaceHolder: "גרור ושחרר תמונה לכאן או לחץ על הכפתור למטה ובחר תמונה להעלאה",
        surveyPlaceHolderMobile: "לחץ על הלחצן \"הוסף שאלה\" למטה כדי להתחיל ליצור את הטופס שלך.",
        pagePlaceHolderMobile: "לחץ על כפתור \"הוסף שאלה\" למטה כדי להוסיף אלמנט חדש לדף.",
        panelPlaceHolderMobile: "לחץ על הלחצן \"הוסף שאלה\" למטה כדי להוסיף אלמנט חדש לחלונית.",
        imagePlaceHolderMobile: "לחץ על הלחצן למטה ובחר תמונה להעלאה",
        imageChooseImage: "בחר תמונה",
        addNewTypeQuestion: "הוסף {0}",
        chooseLogoPlaceholder: "[לוגו]",
        choices_Item: "פריט ",
        selectFile: "בחר קובץ",
        removeFile: "הסרת הקובץ",
        lg: {
            addNewItem: "הוספת כלל חדש",
            empty_tab: "צור כלל כדי להתאים אישית את זרימת הסקר.",
            page_visibilityName: "הצג (הסתר) עמוד",
            page_enableName: "הפוך דף לזמין (הפוך ללא זמין)",
            page_requireName: "הפיכת הדף לנדרש",
            panel_visibilityName: "הצג (הסתר) החלונית",
            panel_enableName: "הפעל (השבית) את החלונית",
            panel_requireName: "הפיכת הדף לנדרש",
            question_visibilityName: "הצג (הסתר) שאלה",
            question_enableName: "הפיכת שאלה לזמינה (השבתה",
            question_requireName: "הפוך את השאלה לנדרשת",
            question_resetValueName: "איפוס ערך שאלה",
            question_setValueName: "הגדרת ערך שאלה",
            column_visibilityName: "הצג (הסתר) עמודה",
            column_enableName: "הפיכת עמודה לזמינה (ללא זמינה)",
            column_requireName: "הפיכת עמודה לנדרשת",
            column_resetValueName: "איפוס ערך עמודה",
            column_setValueName: "הגדרת ערך עמודה",
            trigger_completeName: "הסקר המלא",
            trigger_setvalueName: "הגדר תשובה",
            trigger_copyvalueName: "העתק תשובה",
            trigger_skipName: "דלג לשאלה",
            trigger_runExpressionName: "הפעל ביטוי",
            completedHtmlOnConditionName: "הגדרת סימון דף \"סקר הושלם\"",
            page_visibilityDescription: "הפוך את הדף לגלוי כאשר ביטוי הלוגיקה מחזיר True. אחרת, שמור אותו בלתי נראה.",
            panel_visibilityDescription: "הפוך את החלונית לגלויה כשביטוי הלוגיקה מחזיר True. אחרת, שמור אותו בלתי נראה.",
            panel_enableDescription: "הפוך את החלונית, ואת כל הרכיבים בתוכה, לזמינים כאשר ביטוי הלוגיקה מחזיר True. אחרת, השאר אותם מושבתים.",
            question_visibilityDescription: "הפוך את השאלה לגלויה כאשר ביטוי הלוגיקה חוזר True. אחרת, שמור אותו בלתי נראה.",
            question_enableDescription: "הפוך את השאלה לזמינה כאשר ביטוי הלוגיקה מחזיר True. אחרת, השאר אותו מושבת.",
            question_requireDescription: "השאלה הופכת לנדרשת כאשר ביטוי הלוגיקה מחזיר True.",
            trigger_completeDescription: "כאשר ביטוי הלוגיקה חוזר True, הסקר הושלם ומשתמש קצה רואה את 'דף התודה'.",
            trigger_setvalueDescription: "כאשר ערכי שאלה, המשמשים בביטוי הלוגי, משתנים וביטוי הלוגיקה מחזיר True, הערך מוגדר לשאלה שנבחרה.",
            trigger_copyvalueDescription: "כאשר ערכי שאלה, המשמשים בביטוי הלוגי, משתנים וביטוי הלוגיקה מחזיר True, הערך של שאלה נבחרת אחת מועתק לשאלה נבחרת אחרת.",
            trigger_skipDescription: "כאשר ביטוי הלוגיקה חוזר True אז הסקר מדלג / ממקד את השאלה שנבחרה.",
            trigger_runExpressionDescription: "כאשר ביטוי הלוגיקה מחזיר true, הביטוי המותאם אישית מתבצע. באפשרותך להגדיר תוצאת ביטוי זו בשאלה שנבחרה",
            completedHtmlOnConditionDescription: "אם ביטוי הלוגיקה מחזיר true, טקסט ברירת המחדל עבור 'דף תודה' משתנה לטקסט הנתון.",
            itemExpressionText: "כאשר expression: '{0}' מחזיר ערך True",
            itemEmptyExpressionText: "כלל חדש",
            page_visibilityText: "הפיכת {0} הדף לגלויות",
            panel_visibilityText: "הפיכת {0} החלונית לגלויה",
            panel_enableText: "הפיכת {0} החלונית לזמינה",
            question_visibilityText: "הפוך את {0} השאלה לגלויה",
            question_enableText: "הפוך שאלה {0} לזמינה",
            question_requireText: "יש צורך בשאלה {0}",
            question_resetValueText: "אפס ערך עבור שאלה: {0}",
            question_setValueText: "הקצאת ערך: {1} לשאלה: {0}",
            column_visibilityText: "הפוך את {0} העמודות של {1} השאלה לגלויות",
            column_enableText: "הפיכת עמודה {0} של שאלה לזמינה {1}",
            column_requireText: "הפוך את {0} העמודות של השאלה {1} לנדרש",
            column_resetValueText: "איפוס ערך תא עבור עמודה: {0}",
            column_setValueText: "הקצאת ערך תא: {1} לעמודה: {0}",
            setValueExpressionPlaceholder: "ביטוי שתוצאתו תוקצה לשאלת היעד.",
            trigger_completeText: "הסקר הושלם",
            trigger_setvalueText: "העמידו בסימן שאלה: ערך {0} {1}",
            trigger_setvalueEmptyText: "ערך שאלה ברור: {0}",
            trigger_copyvalueText: "העתק לשאלה: ערך {0} משאלה {1}",
            trigger_skipText: "סקר דלג לשאלה {0}",
            trigger_runExpressionText1: "ביטוי הפעלה: '{0}'",
            trigger_runExpressionText2: " ולהעמיד את תוצאתו בסימן שאלה: {0}",
            completedHtmlOnConditionText: "הצג טקסט מותאם אישית עבור 'דף תודה'.",
            showAllQuestions: "כל השאלות",
            showAllActionTypes: "כל סוגי הפעולות",
            conditions: "תנאים(ים)",
            actions: "פעולה(ות)",
            expressionEditorTitle: "הגדרת תנאים",
            actionsEditorTitle: "הגדרת פעולות",
            deleteAction: "מחיקת פעולה",
            addNewAction: "הוסף פעולה",
            selectedActionCaption: "בחר פעולה...",
            expressionInvalid: "ביטוי הלוגיקה ריק או לא חוקי. אנא תקן זאת.",
            noActionError: "אנא, הוסף לפחות פעולה אחת.",
            actionInvalid: "אנא, תקן בעיות בפעולות שלך.",
            uncompletedRule_title: "כללים לוגיים אינם שלמים",
            uncompletedRule_text: "לא השלמת חלק מהכללים הלוגיים. אם תעזוב את הכרטיסיה כעת, השינויים יאבדו. האם אתה עדיין רוצה לעזוב את הכרטיסייה מבלי להשלים את השינויים?",
            uncompletedRule_apply: "כן",
            uncompletedRule_cancel: "לא, אני רוצה להשלים את הכללים"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "שם החלונית",
            title: "כותרת הפאנל",
            description: "תיאור הלוח",
            visibleIf: "הפוך את החלונית לגלויה אם",
            requiredIf: "הפוך את החלונית לנדרשת אם",
            questionsOrder: "סדר השאלות בתוך הפאנל",
            page: "עמוד הורה",
            startWithNewLine: "הצגת החלונית בשורה חדשה",
            state: "מצב כיווץ לוח",
            width: "רוחב החלונית בתוך שורה",
            minWidth: "רוחב לוח מינימלי",
            maxWidth: "רוחב לוח מרבי",
            showNumber: "חלוניות מספרים"
        },
        paneldynamic: {
            name: "שם החלונית",
            title: "כותרת הפאנל",
            description: "תיאור הלוח",
            visibleIf: "הפוך את החלונית לגלויה אם",
            requiredIf: "הפוך את החלונית לנדרשת אם",
            page: "העברת החלונית לעמוד",
            startWithNewLine: "הצגת החלונית בשורה חדשה",
            state: "מצב כיווץ לוח",
            width: "רוחב החלונית בתוך שורה",
            minWidth: "רוחב לוח מינימלי",
            maxWidth: "רוחב לוח מרבי",
            confirmDelete: "אישור מחיקת פאנל",
            templateDescription: "תבנית תיאור חלונית",
            templateTitle: "תבנית כותרת חלונית",
            noEntriesText: "טקסט ריק בחלונית",
            templateTabTitle: "תבנית כותרת טאב",
            tabTitlePlaceholder: "מציין מיקום של כותרת טאב",
            templateVisibleIf: "הפיכת חלונית בודדת לגלויה אם",
            hideNumber: "הסתרת מספר החלונית",
            titleLocation: "יישור כותרת חלונית",
            descriptionLocation: "יישור תיאור החלונית",
            templateTitleLocation: "יישור כותרת שאלה",
            templateErrorLocation: "יישור הודעת שגיאה",
            newPanelPosition: "מיקום חדש בלוח",
            keyName: "מניעת תגובות כפולות בשאלה הבאה"
        },
        question: {
            name: "שם שאלה",
            title: "כותרת השאלה",
            description: "תיאור השאלה",
            visibleIf: "הפוך את השאלה לגלויה אם",
            requiredIf: "הפוך את השאלה לנדרשת אם",
            page: "עמוד הורה",
            state: "מצב כיווץ תיבת שאלה",
            hideNumber: "הסתרת מספר השאלה",
            titleLocation: "יישור כותרת שאלה",
            descriptionLocation: "יישור תיאור השאלה",
            errorLocation: "יישור הודעת שגיאה",
            indent: "הגדלת הכניסה הפנימית",
            width: "רוחב שאלה מוטבעת",
            minWidth: "רוחב שאלה מינימלי",
            maxWidth: "רוחב שאלה מרבי",
            textUpdateMode: "עדכון ערך שדה קלט"
        },
        signaturepad: {
            signatureWidth: "רוחב אזור חתימה",
            signatureHeight: "גובה אזור חתימה",
            signatureAutoScaleEnabled: "שינוי גודל אוטומטי של אזור החתימה",
            showPlaceholder: "הצגת מציין המיקום",
            placeholder: "טקסט מציין מיקום",
            placeholderReadOnly: "טקסט מציין מיקום במצב קריאה בלבד או תצוגה מקדימה",
            allowClear: "הצגת לחצן 'נקה' בתוך אזור החתימה",
            penMinWidth: "רוחב עט מינימלי",
            penMaxWidth: "רוחב עט מרבי",
            penColor: "צבע קו"
        },
        comment: {
            rows: "גובה שדה קלט (בקווים)"
        },
        showQuestionNumbers: "מספור שאלות",
        questionStartIndex: "אינדקס התחלה (מספר או אות)",
        expression: {
            name: "שם ביטוי",
            title: "כותרת ביטוי",
            description: "תיאור ביטוי",
            expression: "ביטוי"
        },
        trigger: {
            expression: "ביטוי"
        },
        calculatedvalue: {
            expression: "ביטוי"
        },
        // survey templates
        survey: {
            title: "כותר",
            description: "תיאור הסקר"
        },
        page: {
            name: "שם הדף",
            title: "כותר",
            description: "תיאור הדף",
            visibleIf: "הפוך את הדף לגלוי אם",
            requiredIf: "הפוך את הדף לנדרש אם",
            maxTimeToFinish: "גבול זמן לסיום העמוד (בשניות)",
            questionsOrder: "סדר השאלות בדף"
        },
        matrixdropdowncolumn: {
            name: "שם עמודה",
            title: "כותרת עמודה",
            isUnique: "מניעת תגובות כפולות",
            width: "רוחב עמודה",
            minWidth: "רוחב עמודה מינימלי",
            rows: "גובה שדה קלט (בקווים)",
            visibleIf: "הפיכת העמודה לגלויה אם",
            requiredIf: "הפוך את העמודה לנדרשת אם",
            showInMultipleColumns: "כל אפשרות בעמודה נפרדת"
        },
        multipletextitem: {
            name: "שם",
            title: "כותר"
        },
        masksettings: {
            saveMaskedValue: "שמירת ערך מוסווה בתוצאות הסקר"
        },
        patternmask: {
            pattern: "תבנית ערך"
        },
        datetimemask: {
            min: "ערך מינימלי",
            max: "ערך מרבי"
        },
        numericmask: {
            allowNegativeValues: "התרת ערכים שליליים",
            thousandsSeparator: "מפריד אלפים",
            decimalSeparator: "מפריד עשרוני",
            precision: "דיוק ערך",
            min: "ערך מינימלי",
            max: "ערך מרבי"
        },
        currencymask: {
            prefix: "קידומת מטבע",
            suffix: "סיומת מטבע"
        },
        imageHeight: "גובה התמונה",
        imageWidth: "רוחב התמונה",
        valueName: "אחסן תשובות בשדה JSON הבא",
        rateDescriptionLocation: "יישור תוויות",
        size: "גודל שדה הקלט (בתווים)",
        cellErrorLocation: "יישור הודעת שגיאה של תא",
        apply: "החל",
        ok: "אוקי",
        save: "שמור",
        clear: "נקה",
        saveTooltip: "שמור",
        cancel: "בטל",
        set: "הגדר",
        reset: "איפוס",
        change: "שנה",
        refresh: "רענן",
        close: "סגור",
        delete: "מחק",
        add: "הוסף",
        addNew: "הוסף חדש",
        addItem: "לחץ להוספת פריט...",
        removeItem: "לחץ להסרת הפריט...",
        dragItem: "גרור את הפריט",
        addOther: "אחר",
        addSelectAll: "בחר הכל",
        addNone: "אף אחד",
        removeAll: "הסר הכל",
        edit: "ערוך",
        back: "חזור ללא שמירה",
        backTooltip: "חזור ללא שמירה",
        saveAndBack: "שמור וחזור",
        saveAndBackTooltip: "שמור וחזור",
        doneEditing: "סיום",
        editChoices: "ערוך ברירות בחירה",
        showChoices: "הצג ברירות בחירה",
        move: "הזז",
        empty: "<ריק>",
        emptyValue: "הערך ריק",
        fastEntry: "הזנה ידנית",
        fastEntryNonUniqueError: "הערך '{0}' אינו ייחודי",
        fastEntryChoicesCountError: "אנא הגבל את מספר הפריטים מ-{0} ל-{1}",
        fastEntryChoicesMinCountError: "אנא הכנס לפחות {0} פריטים",
        fastEntryPlaceholder: "תוכל להזין נתונים בפורמט הבא:\nערך1|טקסט1\nערך2|טקסט2",
        formEntry: "הזנת טופס",
        testService: "בדוק את השירות",
        itemSelectorEmpty: "בחר את האלמנט",
        conditionActionEmpty: "בחר את הפעולה",
        conditionSelectQuestion: "בחר שאלה...",
        conditionSelectPage: "בחר עמוד...",
        conditionSelectPanel: "בחר פאנל...",
        conditionValueQuestionTitle: "אנא הכנס/בחר את הערך",
        aceEditorHelp: "לחץ על ctrl+space כדי לקבל הצעות להשלמה של הביטוי",
        aceEditorRowTitle: "שורה נוכחית",
        aceEditorPanelTitle: "פאנל נוכחי",
        showMore: "לקבלת פרטים נוספים, אנא בדוק את התיעוד",
        assistantTitle: "שאלות זמינות",
        cellsEmptyRowsColumns: "חייב להיות לפחות עמודה או שורה אחת",
        showPreviewBeforeComplete: "הצג תצוגה מקדימה לפני השלמת הסקר",
        overridingPropertyPrefix: "נקבע על ידי ",
        resetToDefaultCaption: "איפוס",
        propertyIsEmpty: "אנא הכנס ערך",
        propertyIsNoUnique: "אנא הכנס ערך ייחודי",
        propertyNameIsNotUnique: "אנא הכנס שם ייחודי",
        propertyNameIsIncorrect: "אין להשתמש במילים שמורות: \"item\", \"choice\", \"panel\", \"row\".",
        listIsEmpty: "טרם הוספו פריטים",
        "listIsEmpty@choices": "טרם הוספו ברירות בחירה",
        "listIsEmpty@columns": "עדיין אין לך עמודות",
        "listIsEmpty@rows": "עדיין אין לך שורות",
        "listIsEmpty@validators": "עדיין אין לך כללי אימות",
        "listIsEmpty@calculatedValues": "עדיין אין לך משתנים מותאמים אישית",
        "listIsEmpty@triggers": "עדיין אין לך טריגרים",
        "listIsEmpty@navigateToUrlOnCondition": "עדיין אין לך קישורים",
        "addNew@choices": "הוסף ברירת בחירה",
        "addNew@columns": "הוספת עמודה חדשה",
        "addNew@rows": "הוספת שורה חדשה",
        "addNew@validators": "הוספת כלל חדש",
        "addNew@calculatedValues": "הוספת משתנה חדש",
        "addNew@triggers": "הוספת גורם מפעיל חדש",
        "addNew@navigateToUrlOnCondition": "הוספת כתובת URL חדשה",
        expressionIsEmpty: "הביטוי ריק",
        value: "ערך",
        text: "טקסט",
        rowid: "מזהה שורה",
        imageLink: "קישור לתמונה או וידיאו",
        columnEdit: "ערוך עמודה: {0}",
        itemEdit: "ערוך פריט: {0}",
        url: "כתובת URL של השירות",
        path: "נתיב למידע במקור השירות",
        choicesbyurl: {
            url: "כתובת URL של שירות אינטרנט",
            valueName: "קבל ערכים משדה JSON הבא"
        },
        titleName: "קבל טקסטים להצגה משדה JSON הבא",
        imageLinkName: "קבל קישורים לתמונות משדה JSON הבא",
        allowEmptyResponse: "אפשר תשובה ריקה",
        titlePlaceholder: "כותרת",
        surveyTitlePlaceholder: "כותרת הסקר",
        pageTitlePlaceholder: "עמוד {num}",
        descriptionPlaceholder: "תיאור",
        surveyDescriptionPlaceholder: "תיאור הסקר",
        pageDescriptionPlaceholder: "תיאור העמוד",
        textWrapEnabled: "אפשרויות גלישה",
        showOtherItem: "אפשר אפשרות אחרת",
        otherText: "טקסט לאפשרות אחרת",
        showNoneItem: "אפשר אפשרות 'אף אחד'",
        showRefuseItem: "אפשר את האפשרות סרב לענות",
        showDontKnowItem: "אפשר את האפשרות 'לא יודע'",
        noneText: "טקסט לאפשרות 'אף אחד'",
        showSelectAllItem: "אפשר אפשרות 'בחר הכל'",
        selectAllText: "טקסט לאפשרות 'בחר הכל'",
        choicesMin: "ערך מינימלי לפריטים שנוצרים אוטומטית",
        choicesMax: "ערך מקסימלי לפריטים שנוצרים אוטומטית",
        choicesStep: "צעד לפריטים שנוצרים אוטומטית",
        name: "שם",
        title: "כותרת",
        cellType: "סוג התא",
        colCount: "מספר העמודות",
        choicesOrder: "סדר מיון של ברירות הבחירה",
        visible: "נראה",
        isRequired: "נדרש",
        markRequired: "סמן כשדה חובה",
        removeRequiredMark: "הסר את הסימון כשדה חובה",
        isAllRowRequired: "חובה על תשובה בכל השורות",
        eachRowUnique: "מניעת תגובות כפולות בשורות",
        requiredErrorText: "הודעת שגיאה לשדה חובה",
        startWithNewLine: "הצג את השאלה בשורה חדשה",
        rows: "שורות",
        cols: "עמודות",
        placeholder: "מקום להזנה",
        showPreview: "הצג אזור תצוגה מקדימה",
        storeDataAsText: "אחסן תוכן קובץ בתוצאת JSON כטקסט",
        maxSize: "גודל הקובץ המרבי (בבתים)",
        rowCount: "כמות השורות",
        columnLayout: "סידור העמודות",
        addRowLocation: "מיקום כפתור הוסף שורה",
        transposeData: "ביצוע חילוף שורות לעמודות",
        addRowText: "טקסט לכפתור הוסף שורה",
        removeRowText: "טקסט לכפתור הסר שורה",
        rateMin: "ערך מינימלי לדרגה",
        rateMax: "ערך מקסימלי לדרגה",
        rateStep: "צעד דרגה",
        minRateDescription: "תיאור ערך מינימלי לדרגה",
        maxRateDescription: "תיאור ערך מקסימלי לדרגה",
        inputType: "סוג הקלט",
        optionsCaption: "טקסט מציין אפשרויות",
        defaultValue: "תשובת ברירת המחדל",
        cellsDefaultRow: "טקסטים ברירת המחדל",
        surveyEditorTitle: "ערוך הגדרות סקר",
        qEditorTitle: "ערוך: {0}",
        maxLength: "אורך מרבי (בתווים)",
        buildExpression: "בנה",
        editExpression: "ערוך",
        and: "וגם",
        or: "או",
        remove: "הסר",
        addCondition: "הוסף תנאי",
        emptyLogicPopupMessage: "בחר שאלה להתחלת הגדרת תנאים.",
        if: "אם",
        then: "אז",
        setToName: "שאלת יעד",
        fromName: "שאלה להעתיק ממנה את התשובה",
        gotoName: "שאלה לדלג אליה",
        ruleIsNotSet: "הכלל אינו נקבע",
        includeIntoResult: "כלול בתוצאות הסקר",
        showTitle: "הצג את הכותרת",
        expandCollapseTitle: "הרחב/כווץ את הכותרת",
        locale: "שפת הסקר",
        simulator: "בחר סוג מכשיר",
        landscapeOrientation: "עבור לתצוגה אופקית",
        portraitOrientation: "עבור לתצוגה אנכית",
        mode: "עריכה או לקריאה בלבד",
        clearInvisibleValues: "נקה ערכים בלתי נראים",
        cookieName: "שם העוגיה",
        sendResultOnPageNext: "שמור תוצאות סקר חלקיות בתהליך",
        storeOthersAsComment: "אחסן את ערך 'אחר' בשדה נפרד",
        showPageTitles: "הצג כותרות עמוד",
        showPageNumbers: "הצג מספרי עמוד",
        pagePrevText: "טקסט לכפתור 'עמוד קודם'",
        pageNextText: "טקסט לכפתור 'עמוד הבא'",
        completeText: "טקסט לכפתור 'סיום סקר'",
        previewText: "טקסט לכפתור 'תצוגה מקדימה לתשובות'",
        editText: "טקסט לכפתור 'ערוך תשובה'",
        startSurveyText: "טקסט לכפתור 'התחל סקר'",
        showNavigationButtons: "מיקום לכפתורי ניווט",
        showPrevButton: "הצג את לחצן 'עמוד קודם'",
        firstPageIsStarted: "העמוד הראשון הוא עמוד התחלה",
        showCompletedPage: "הצג עמוד 'סקר הושלם'",
        goNextPageAutomatic: "עבור אוטומטית לעמוד הבא",
        allowCompleteSurveyAutomatic: "השלם את הסקר באופן אוטומטי",
        showProgressBar: "מיקום שורת ההתקדמות",
        questionTitleLocation: "מיקום כותרת השאלה",
        questionTitleWidth: "רוחב כותרת השאלה",
        requiredText: "סמן נדרש(ים)",
        questionTitleTemplate: "תבנית כותרת השאלה, ברירת המחדל היא: '{no}. {require} {title}'",
        questionErrorLocation: "מיקום הודעת השגיאה",
        focusFirstQuestionAutomatic: "התמקד על השאלה הראשונה בעמוד חדש",
        questionsOrder: "סדר הרכיבים בעמוד",
        maxTimeToFinish: "גבול זמן לסיום הסקר (בשניות)",
        maxTimeToFinishPage: "גבול זמן לסיום עמוד אחד (בשניות)",
        showTimerPanel: "מיקום הטיימר",
        showTimerPanelMode: "מצב הטיימר",
        renderMode: "מצב תצוגת הפאנל",
        allowAddPanel: "אפשר הוספת פאנלים",
        allowRemovePanel: "אפשר הסרת פאנלים",
        panelAddText: "טקסט לכפתור 'הוסף פאנל'",
        panelRemoveText: "טקסט לכפתור 'הסר פאנל'",
        isSinglePage: "הצג את כל הרכיבים בעמוד אחד",
        html: "קוד HTML",
        setValue: "תשובה",
        dataFormat: "פורמט תמונה",
        allowAddRows: "אפשר הוספת שורות",
        allowRemoveRows: "אפשר הסרת שורות",
        allowRowsDragAndDrop: "אפשר גרירה ושחרור שורות",
        responsiveImageSizeHelp: "לא יחול אם אתה מציין את רוחב או גובה התמונה באופן ישיר.",
        minImageWidth: "רוחב תמונה מינימלי",
        maxImageWidth: "רוחב תמונה מקסימלי",
        minImageHeight: "גובה תמונה מינימלי",
        maxImageHeight: "גובה תמונה מקסימלי",
        minValue: "ערך מינימלי",
        maxValue: "ערך מקסימלי",
        minLength: "אורך מינימלי (בתווים)",
        allowDigits: "אפשר ספרות",
        minCount: "מינימום כמות",
        maxCount: "מקסימום כמות",
        regex: "ביטוי רגולרי",
        surveyvalidator: {
            text: "הודעת שגיאה",
            expression: "ביטוי אימות"
        },
        totalText: "טקסט לשורת סיכום",
        totalType: "סוג סיכום",
        totalExpression: "ביטוי סיכום",
        totalDisplayStyle: "סגנון תצוגת ערך סיכום",
        totalCurrency: "מטבע",
        totalFormat: "מחרוזת מסוגננת",
        logo: "לוגו (כתובת URL או מחרוזת base64-מוצפנת)",
        questionsOnPageMode: "מבנה הסקר",
        maxTextLength: "אורך מקסימלי לתשובה (בתווים)",
        maxOthersLength: "אורך מקסימלי להערות (בתווים)",
        commentAreaRows: "גובה אזור הערה (בשורות)",
        autoGrowComment: "הרחבה אוטומטית של אזור ההערות כראוי",
        allowResizeComment: "אפשר התאמה ידנית של אזורי טקסט על ידי המשתמש",
        textUpdateMode: "עדכן את ערך הטקסט של השאלה",
        maskType: "סוג מסיכת קלט",
        maskTypes: {
            none: "ללא",
            patternmask: "תבנית",
            numericmask: "מספריים",
            datetimemask: "תאריך ושעה",
            currencymask: "מטבע"
        },
        focusOnFirstError: "קפיצה לתשובה השגויה הראשונה",
        checkErrorsMode: "הפעל את האימות",
        navigateToUrl: "נווט לכתובת URL",
        navigateToUrlOnCondition: "כתובת URL דינמית",
        completedBeforeHtml: "קוד HTML להצגה אם המשתמש כבר מילא את הסקר הזה",
        completedHtml: "קוד HTML לעמוד הסקר הושלם",
        completedHtmlOnCondition: "קוד HTML דינמי לעמוד הסקר הושלם",
        loadingHtml: "קוד HTML להצגה בזמן טעינת דגם הסקר",
        commentText: "טקסט אזור הערות",
        autocomplete: "סוג השלמה אוטומטית",
        labelTrue: "תוית 'נכון'",
        labelFalse: "תוית 'לא נכון'",
        allowClear: "הצג את לחצן הניקוי",
        searchMode: "מצב חיפוש",
        displayStyle: "סגנון תצוגת ערך",
        format: "מחרוזת מסוגננת",
        maximumFractionDigits: "ספרות עשרוניות מקסימליות",
        minimumFractionDigits: "ספרות עשרוניות מינימליות",
        useGrouping: "הצג סימני קבוצה",
        allowMultiple: "אפשר קבצים מרובים",
        allowImagesPreview: "תצוגה מקדימה של תמונות",
        acceptedTypes: "סוגי קבצים מקובלים",
        waitForUpload: "המתן להשלמת ההעלאה",
        needConfirmRemoveFile: "אישור מחיקת הקובץ",
        detailPanelMode: "מקום הפאנל המפרט",
        minRowCount: "מספר שורות מינימלי",
        maxRowCount: "מספר שורות מקסימלי",
        confirmDelete: "אישור מחיקת שורה",
        confirmDeleteText: "הודעת אישור",
        panelCount: "מספר פאנלים ראשוני",
        minPanelCount: "מספר פאנלים מינימלי",
        maxPanelCount: "מספר פאנלים מקסימלי",
        panelsState: "מצב הרחבת הפאנל הפנימי",
        panelPrevText: "טקסט הרחבת הפאנל הקודם",
        panelNextText: "טקסט הרחבת הפאנל הבא",
        showRangeInProgress: "הצג את סרגל ההתקדמות",
        panelRemoveButtonLocation: "מיקום לחצן 'הסר פאנל'",
        hideIfRowsEmpty: "הסתר את השאלה אם אין שורות",
        hideColumnsIfEmpty: "הסתר עמודות אם אין שורות",
        rateValues: "ערכי דירוג מותאמים אישית",
        rateCount: "כמות הדירוגים",
        autoGenerate: "איך לציין ערכי דירוג?",
        hideIfChoicesEmpty: "הסתר את השאלה אם אין בה בחירות",
        minWidth: "רוחב מינימלי (בערכים שמקובלים ב- CSS)",
        maxWidth: "רוחב מקסימלי (בערכים שמקובלים ב- CSS)",
        width: "רוחב (בערכים שמקובלים ב- CSS)",
        showHeader: "הצג כותרות עמודות",
        horizontalScroll: "הצג את סרגל הגלילה האופקי",
        columnMinWidth: "רוחב עמודה מינימלי (בערכים שמקובלים ב- CSS)",
        rowTitleWidth: "רוחב כותרת השורה (בערכים שמקובלים ב- CSS)",
        valueTrue: "ערך 'נכון'",
        valueFalse: "ערך 'לא נכון'",
        minErrorText: "הודעת שגיאה: 'הערך נמוך מהמינימום'",
        maxErrorText: "הודעת שגיאה: 'הערך חורג מהמקסימום'",
        otherErrorText: "הודעת שגיאה: 'תגובה ריקה'",
        keyDuplicationError: "הודעת שגיאה: 'ערך המפתח אינו ייחודי'",
        minSelectedChoices: "מספר הבחירות המינימלי",
        maxSelectedChoices: "מספר הבחירות המקסימלי",
        showClearButton: "הצג את לחצן הניקוי",
        logoWidth: "רוחב הלוגו (בערכים שמקובלים ב- CSS)",
        logoHeight: "גובה הלוגו (בערכים שמקובלים ב- CSS)",
        readOnly: "קריאה בלבד",
        enableIf: "ניתן לעריכה אם",
        emptyRowsText: "הודעה: 'אין שורות'",
        separateSpecialChoices: "הפרד בחירות מיוחדות (אף אחת, אחר, בחר הכול)",
        choicesFromQuestion: "העתק בחירות משאלה זו",
        choicesFromQuestionMode: "אילו בחירות להעתיק?",
        progressBarShowPageTitles: "הצגת כותרות עמודים בסרגל ההתקדמות",
        progressBarShowPageNumbers: "הצגת מספרי עמודים במד ההתקדמות",
        showCommentArea: "הצג את אזור התגובה",
        commentPlaceholder: "טקסט ממלא מקום לאזור התגובה",
        displayRateDescriptionsAsExtremeItems: "הצג תיאורי דירוג כערכים קצה",
        rowsOrder: "סדר השורות",
        columnsLayout: "פריסת עמודות",
        columnColCount: "ספירת עמודות מקוננות",
        correctAnswer: "תשובה נכונה",
        defaultPanelValue: "ערכים ברירת מחדל",
        cells: "טקסטי תאים",
        fileInputPlaceholder: "בחר קובץ או הדבק קישור לקובץ...",
        keyName: "עמודת מפתח",
        itemvalue: {
            visibleIf: "הפוך את האפשרות לגלויה אם",
            enableIf: "הפוך את האפשרות לניתנת לבחירה אם"
        },
        "itemvalue@rows": {
            visibleIf: "הפיכת השורה לגלויה אם",
            enableIf: "הפיכת השורה לניתנת לעריכה אם"
        },
        imageitemvalue: {
            text: "טקסט אלטרנטיבי"
        },
        logoPosition: "מיקום הלוגו",
        addLogo: "הוסף לוגו...",
        changeLogo: "שנה לוגו...",
        logoPositions: {
            none: "הסר לוגו",
            left: "שמאלה",
            right: "ימינה",
            top: "מלמעלה",
            bottom: "מלמטה"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "פריסת חלונית"
            },
            general: "כללי",
            fileOptions: "אפשרויות",
            html: "עורך HTML",
            columns: "עמודות",
            rows: "שורות",
            choices: "בחירות",
            items: "פריטים",
            visibleIf: "נראה אם",
            enableIf: "ניתן לערוך אם",
            requiredIf: "חובה אם",
            rateValues: "ערכי דירוג",
            choicesByUrl: "בחירות משירות RESTful",
            matrixChoices: "בחירות דיפולטיות",
            multipleTextItems: "קלטי טקסט",
            numbering: "מספור",
            validators: "אמינות",
            navigation: "ניווט",
            question: "שאלה",
            pages: "עמודים",
            timer: "שעון/חידון",
            calculatedValues: "ערכים מחושבים",
            triggers: "טריגרים",
            templateTitle: "תבנית כותרת",
            totals: "סכומים",
            logic: "לוגיקה",
            mask: "הגדרות מסיכת קלט",
            layout: {
                panel: "פריסה",
                question: "פריסה",
                base: "פריסה"
            },
            data: "נתונים",
            validation: "אימות",
            cells: "טקסטי תאים",
            showOnCompleted: "השאלון הושלם",
            logo: "לוגו בכותרת השאלון",
            slider: "מחוון",
            expression: "ביטוי",
            questionSettings: "הגדרות שאלה",
            header: "כותרת",
            background: "רקע",
            appearance: "מראה",
            others: "אחרים"
        },
        editProperty: "עריכת מאפיין '{0}'",
        items: "פריטים",
        choicesVisibleIf: "הבחירות יוצגו אם",
        choicesEnableIf: "ניתן לבחור את האפשרויות אם",
        columnsEnableIf: "העמודות יוצגו אם",
        rowsEnableIf: "השורות יוצגו אם",
        innerIndent: "הוסף כניסות פנימיות",
        defaultValueFromLastRow: "קבל ערכי ברירת מחדל מהשורה האחרונה",
        defaultValueFromLastPanel: "קבל ערכי ברירת מחדל מהפאנל האחרון",
        enterNewValue: "נא להזין את הערך.",
        noquestions: "אין שאלות בשאלון.",
        createtrigger: "יש ליצור מפעיל",
        titleKeyboardAdornerTip: "לחץ על כפתור Enter לעריכה",
        keyboardAdornerTip: "לחץ על כפתור Enter לעריכת פריט, לחץ על מקש מחיקה למחיקת פריט, לחץ על Alt + חץ למעלה או חץ למטה להעברת פריט",
        triggerOn: "ב-",
        triggerMakePagesVisible: "הצג עמודים",
        triggerMakeQuestionsVisible: "הצג רכיבים",
        triggerCompleteText: "השלם את השאלון אם הצליח.",
        triggerNotSet: "המפעיל לא הוגדר",
        triggerRunIf: "הפעל אם",
        triggerSetToName: "שנה את הערך של: ",
        triggerFromName: "העתק את הערך מ: ",
        triggerRunExpression: "הפעל ביטוי זה",
        triggerSetValue: "ל: ",
        triggerGotoName: "עבור לשאלה",
        triggerIsVariable: "אל תכלול את המשתנה בתוצאה של השאלון.",
        triggerRunExpressionEmpty: "יש להזין ביטוי חוקי",
        emptyExpressionPlaceHolder: "הקלד ביטוי כאן...",
        noFile: "לא נבחר קובץ",
        clearIfInvisible: "נקה את הערך אם השאלה הופכת חבויה",
        valuePropertyName: "שם מאפיין ערך",
        searchEnabled: "אפשר חיפוש",
        hideSelectedItems: "הסתר פריטים נבחרים",
        closeOnSelect: "סגור את התפריט לאחר בחירה",
        verticalAlign: "יישור אנכי",
        alternateRows: "שורות חלופיות",
        columnsVisibleIf: "העמודות יוצגו אם",
        rowsVisibleIf: "השורות יוצגו אם",
        otherPlaceholder: "מציין מקום לתגובה",
        filePlaceholder: "טקסט מציין מיקום קובץ",
        photoPlaceholder: "טקסט מציין מיקום תמונה",
        fileOrPhotoPlaceholder: "טקסט מציין מיקום של קובץ או תמונה",
        rateType: "סוג דירוג",
        url_placeholder: "לדוגמה: https://api.example.com/books",
        path_placeholder: "לדוגמה: קטגוריות.בדיוני",
        questionStartIndex_placeholder: "לדוגמה: א)",
        width_placeholder: "לדוגמה: 6in",
        minWidth_placeholder: "לדוגמה: 600px",
        maxWidth_placeholder: "לדוגמה: 50%",
        imageHeight_placeholder: "אוטומטי",
        imageWidth_placeholder: "אוטומטי",
        theme: {
            themeName: "ערכת נושא",
            isPanelless: "מראה השאלה",
            editorPanel: "רקע ורדיוס פינה",
            questionPanel: "רקע ורדיוס פינה",
            primaryColor: "צבע הדגשה",
            panelBackgroundTransparency: "אטימות רקע של החלונית",
            questionBackgroundTransparency: "אטימות רקע השאלה",
            fontSize: "גודל גופן",
            scale: "סולם",
            cornerRadius: "רדיוס פינה",
            pageTitle: "גופן כותרת",
            pageDescription: "גופן תיאור",
            questionTitle: "גופן כותרת",
            questionDescription: "גופן תיאור",
            editorFont: "גופן",
            backgroundOpacity: "אטימות",
            "--sjs-font-family": "משפחת גופנים",
            "--sjs-general-backcolor-dim": "צבע רקע",
            "--sjs-primary-backcolor": "רקע הדגשה",
            "--sjs-primary-forecolor": "הדגשת החזית",
            "--sjs-special-red": "הודעות שגיאה",
            "--sjs-shadow-small": "אפקטי צל",
            "--sjs-shadow-inner": "אפקטי צל",
            "--sjs-border-default": "צבעים"
        },
        "header@header": {
            headerView: "נוף",
            logoPosition: "מיקום הלוגו",
            surveyTitle: "גופן כותרת סקר",
            surveyDescription: "גופן תיאור סקר",
            headerTitle: "גופן כותרת סקר",
            headerDescription: "גופן תיאור סקר",
            inheritWidthFrom: "רוחב אזור תוכן",
            textAreaWidth: "רוחב טקסט",
            backgroundColorSwitch: "צבע רקע",
            backgroundImage: "תמונת רקע",
            backgroundImageOpacity: "אטימות",
            overlapEnabled: "חופפים",
            logoPositionX: "מיקום הלוגו",
            titlePositionX: "מיקום בתפקיד",
            descriptionPositionX: "תיאור מיקום"
        }
    },
    // Property values
    pv: {
        "true": "אמת",
        "false": "שקר",
        file: "קבצים מקומיים",
        camera: "מצלמה",
        "file-camera": "קבצים מקומיים או מצלמה",
        inherit: "ירושה",
        show: "נראה",
        hide: "מוסתר",
        default: "ירושה",
        initial: "התחלתי",
        random: "אקראי",
        collapsed: "מכווץ",
        expanded: "מורחב",
        none: "ללא",
        asc: "סדר עולה",
        desc: "סדר יורד",
        indeterminate: "לא קבוע",
        selected: "שנבחרו",
        unselected: "לא נבחר",
        decimal: "עשרוני",
        currency: "מטבע",
        percent: "אחוזים",
        firstExpanded: "הפאנל הראשון מורחב",
        off: "הסתר מספרי שאלות",
        list: "רשימה",
        progressTop: "ניווט בפאנל + סרגל התקדמות בחלק העליון",
        progressBottom: "ניווט בפאנל + סרגל התקדמות בחלק התחתון",
        progressTopBottom: "ניווט בפאנל + סרגל התקדמות בחלק העליון והתחתון",
        tab: "כרטיסיות",
        horizontal: "אופקי",
        vertical: "אנכי",
        top: "עליון",
        bottom: "תחתון",
        topBottom: "עליון ותחתון",
        both: "שניהם",
        left: "שמאל",
        right: "ימין",
        center: "מרכז",
        leftRight: "ימין ושמאל",
        middle: "אמצע",
        color: "צבע",
        date: "תאריך",
        datetime: "תאריך ושעה",
        "datetime-local": "תאריך ושעה מקומיים",
        email: "אימייל",
        month: "חודש",
        number: "מספר",
        password: "סיסמה",
        range: "טווח",
        tel: "טלפון",
        text: "טקסט",
        time: "שעה",
        url: "קישור",
        week: "שבוע",
        hidden: "מוסתר",
        edit: "ניתן לעריכה",
        display: "לקריאה בלבד",
        contain: "להכיל",
        cover: "כריכה",
        fill: "מילוי",
        next: "הבא",
        last: "אחרון",
        onComplete: "כאשר השאלון הושלם",
        onHidden: "כאשר השאלה הוסתרה",
        onHiddenContainer: "כאשר השאלה או הפאנל/העמוד שלה מוסתרים",
        clearInvisibleValues: {
            none: "לעולם"
        },
        clearIfInvisible: {
            none: "אף פעם"
        },
        inputType: {
            color: "צבע",
            date: "תאריך",
            "datetime-local": "תאריך ושעה",
            email: "אימייל",
            month: "חודש",
            number: "מספר",
            password: "סיסמה",
            range: "טווח",
            tel: "מספר טלפון",
            text: "טקסט",
            time: "שעה",
            url: "כתובת URL",
            week: "שבוע"
        },
        all: "הכל",
        page: "עמוד",
        survey: "שאלון",
        onNextPage: "כאשר מתבצע מעבר לעמוד הבא",
        onValueChanged: "לאחר שהתשובה השתנתה",
        onValueChanging: "לפני שהתשובה השתנתה",
        questionsOnPageMode: {
            standard: "מבנה מקורי",
            singlePage: "הצג את כל השאלות בעמוד אחד",
            questionPerPage: "הצגת שאלה בודדת בכל עמוד"
        },
        noPreview: "אין תצוגה מקדימה",
        showAllQuestions: "הצג את כל השאלות",
        showAnsweredQuestions: "הצג רק שאלות עם תשובות",
        pages: "עמודים שהושלמו",
        questions: "שאלות שקיבלו תשובה",
        requiredQuestions: "שאלות חובה שקיבלו תשובה",
        correctQuestions: "תשובות נכונות",
        buttons: "עמודים שהושלמו (ממשק כפתורים)",
        underInput: "מתחת לקלט",
        underTitle: "מתחת לכותרת",
        onBlur: "כאשר מאבד פוקוס",
        onTyping: "בזמן הקלדה",
        underRow: "מתחת לשורה",
        underRowSingle: "מתחת לשורה, עם פאנל יחיד בלבד",
        auto: "אוטומטי",
        showNavigationButtons: {
            none: "מוסתר"
        },
        showTimerPanel: {
            none: "מוסתר"
        },
        showTimerPanelMode: {
            all: "שני הצדדים"
        },
        addRowLocation: {
            default: "תלוי בפריסת המטריצה"
        },
        panelsState: {
            default: "המשתמשים לא יכולים להרחיב או לכווץ פאנלים",
            collapsed: "כל הפאנלים מכווצים",
            expanded: "כל הפאנלים מורחבים",
            firstExpanded: "הראשון הורחב"
        },
        widthMode: {
            static: "סטטי",
            responsive: "רספונסיבי"
        },
        contentMode: {
            image: "תמונה",
            video: "וידאו",
            youtube: "YouTube"
        },
        displayMode: {
            buttons: "כפתורים",
            dropdown: "רשימה נפתחת"
        },
        rateColorMode: {
            default: "ברירת מחדל",
            scale: "סולם"
        },
        scaleColorMode: {
            monochrome: "מונוכרום",
            colored: "צבעוניים"
        },
        autoGenerate: {
            "true": "יצירה אוטומטית",
            "false": "הזנה ידנית"
        },
        rateType: {
            labels: "תווי ניקוד",
            stars: "כוכבים",
            smileys: "סמיילים"
        },
        state: {
            default: "נעול"
        },
        showQuestionNumbers: {
            default: "מספור אוטומטי",
            on: "מספור אוטומטי",
            onPage: "איפוס בכל עמוד",
            onpanel: "איפוס בכל חלונית",
            onPanel: "איפוס בכל חלונית",
            onSurvey: "המשך לאורך הסקר",
            off: "ללא מספור"
        },
        descriptionLocation: {
            underTitle: "תחת כותרת השאלה",
            underInput: "מתחת לשדה הקלט"
        },
        selectToRankAreasLayout: {
            horizontal: "לצד אפשרויות בחירה",
            vertical: "אפשרויות מעל"
        },
        displayStyle: {
            decimal: "עשרוני",
            currency: "מטבע",
            percent: "אחוז",
            date: "תמר"
        },
        totalDisplayStyle: {
            decimal: "עשרוני",
            currency: "מטבע",
            percent: "אחוז",
            date: "תמר"
        },
        rowsOrder: {
            initial: "מקורי"
        },
        questionsOrder: {
            initial: "מקורי"
        },
        showProgressBar: {
            off: "מוסתר",
            topbottom: "עליון ותחתון",
            aboveheader: "מעל הכותרת העליונה",
            belowheader: "מתחת לכותרת העליונה"
        },
        sum: "סכום",
        count: "מנה",
        min: "דקות",
        max: "מקס",
        avg: "ממוצע",
        searchMode: {
            contains: "מכיל",
            startsWith: "מתחיל ב"
        },
        backgroundImageFit: {
            auto: "אוטומטי",
            cover: "כריכה",
            contain: "להכיל",
            fill: "מתיחה",
            tile: "אריח"
        },
        backgroundImageAttachment: {
            fixed: "קבוע",
            scroll: "לגלול"
        },
        headerView: {
            basic: "בסיסי",
            advanced: "מתקדמים"
        },
        inheritWidthFrom: {
            survey: "זהה לסקר",
            container: "התאמה למיכל"
        },
        backgroundColorSwitch: {
            none: "ללא",
            accentColor: "צבע הדגשה",
            custom: "מנהג"
        },
        colorPalette: {
            light: "אור",
            dark: "חשוך"
        },
        isPanelless: {
            "false": "ברירת מחדל",
            "true": "ללא פאנלים"
        }
    },
    // Operators
    op: {
        empty: "ריק",
        notempty: "לא ריק",
        equal: "שווה ל",
        notequal: "אינו שווה ל",
        contains: "מכיל",
        notcontains: "אינו מכיל",
        anyof: "כל אחד מתוך",
        allof: "כולם מתוך",
        greater: "גדול מ",
        less: "קטן מ",
        greaterorequal: "גדול או שווה ל",
        lessorequal: "קטן או שווה ל",
        and: "וגם",
        or: "או"
    },
    // Embed window
    ew: {
        angular: "השתמש בגרסת Angular",
        jquery: "השתמש בגרסת jQuery",
        knockout: "השתמש בגרסת Knockout",
        react: "השתמש בגרסת React",
        vue: "השתמש בגרסת Vue",
        bootstrap: "למסגרת Bootstrap",
        modern: "ערכת עיצוב מודרנית",
        default: "ערכת עיצוב ברירת מחדל",
        orange: "ערכת עיצוב כתומה",
        darkblue: "ערכת עיצוב כחולה כהה",
        darkrose: "ערכת עיצוב ורודה כהה",
        stone: "ערכת עיצוב אבן",
        winter: "ערכת עיצוב חורף",
        winterstone: "ערכת עיצוב חורף-אבן",
        showOnPage: "הצג את השאלון בעמוד",
        showInWindow: "הצג את השאלון בחלון",
        loadFromServer: "טען מסגרת JSON מהשרת",
        titleScript: "סקריפטים וסגנונות",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "בחר את העמוד לבדיקה",
        showInvisibleElements: "הצג רכיבים בלתי נראים",
        hideInvisibleElements: "הסתר רכיבים בלתי נראים"
    },
    validators: {
        answercountvalidator: "מספר תשובות",
        emailvalidator: "אימייל",
        expressionvalidator: "ביטוי",
        numericvalidator: "מספר",
        regexvalidator: "ביטוי רגולרי",
        textvalidator: "טקסט"
    },
    triggers: {
        completetrigger: "השלם את הסקר",
        setvaluetrigger: "קבע ערך",
        copyvaluetrigger: "העתק ערך",
        skiptrigger: "דלג לשאלה",
        runexpressiontrigger: "הפעל ביטוי",
        visibletrigger: "שנה נראות (לא מומלץ)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "לדוגמה: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "לדוגמה: mm/dd/yyyy"
        },
        currencymask: {
            prefix: "לדוגמה: $",
            suffix: "לדוגמה: USD"
        },
        panelbase: {
            questionTitleWidth: "לדוגמה: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "מזהה חלונית שאינו גלוי למשיבים.",
            description: "הקלד כותרת משנה של חלונית.",
            visibleIf: "השתמשו בסמל מטה הקסם כדי להגדיר כלל תנאי הקובע את תצוגת החלונית.",
            enableIf: "השתמשו בסמל מטה הקסם כדי להגדיר כלל מותנה שמשבית את מצב הקריאה בלבד של החלונית.",
            requiredIf: "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי המונע שליחת סקר, אלא אם לשאלה מקוננת אחת לפחות יש תשובה.",
            questionTitleLocation: "חל על כל השאלות בפאנל זה. אם ברצונך לעקוף הגדרה זו, הגדר כללי יישור כותרת עבור שאלות בודדות. האפשרות \"הירושה\" מחילה את ההגדרה ברמת הדף (אם הוגדרה) או ברמת הסקר (\"למעלה\" כברירת מחדל).",
            questionTitleWidth: "הגדרת רוחב עקבי לכותרות שאלות כאשר הן מיושרות משמאל לתיבות השאלות. מקבל ערכי CSS (px, %, in, pt וכו').",
            questionErrorLocation: "קובע את המיקום של הודעת שגיאה ביחס לכל השאלות בחלונית. האפשרות \"הירושה\" מחילה את ההגדרה ברמת הדף (אם הוגדרה) או ברמת הסקר.",
            questionsOrder: "שומר על הסדר המקורי של השאלות או מסדר אותן באופן אקראי. האפשרות \"הירושה\" מחילה את ההגדרה ברמת הדף (אם הוגדרה) או ברמת הסקר.",
            page: "מיקום מחדש של החלונית לסוף עמוד שנבחר.",
            innerIndent: "מוסיף רווח או שוליים בין תוכן החלונית לגבול השמאלי של תיבת החלונית.",
            startWithNewLine: "בטל את הבחירה כדי להציג את החלונית בשורה אחת עם השאלה או החלונית הקודמת. ההגדרה אינה חלה אם החלונית היא הרכיב הראשון בטופס.",
            state: "בחר מתוך: \"מורחב\" - הלוח מוצג במלואו וניתן לכווץ; \"מכווץ\" - הלוח מציג רק את הכותרת והתיאור וניתן להרחיבו; \"נעול\" - הלוח מוצג במלואו ולא ניתן לכווץ.",
            width: "קובע את רוחב החלונית ביחס לרכיבי סקר אחרים באותה שורה. מקבל ערכי CSS (px, %, in, pt וכו')."
        },
        paneldynamic: {
            name: "מזהה חלונית שאינו גלוי למשיבים.",
            description: "הקלד כותרת משנה של חלונית.",
            visibleIf: "השתמשו בסמל מטה הקסם כדי להגדיר כלל תנאי הקובע את תצוגת החלונית.",
            enableIf: "השתמשו בסמל מטה הקסם כדי להגדיר כלל מותנה שמשבית את מצב הקריאה בלבד של החלונית.",
            requiredIf: "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי המונע שליחת סקר, אלא אם לשאלה מקוננת אחת לפחות יש תשובה.",
            templateTitleLocation: "חל על כל השאלות בפאנל זה. אם ברצונך לעקוף הגדרה זו, הגדר כללי יישור כותרת עבור שאלות בודדות. האפשרות \"הירושה\" מחילה את ההגדרה ברמת הדף (אם הוגדרה) או ברמת הסקר (\"למעלה\" כברירת מחדל).",
            templateErrorLocation: "הגדרת המיקום של הודעת שגיאה ביחס לשאלה עם קלט לא חוקי. בחר בין: \"למעלה\" - טקסט שגיאה ממוקם בחלק העליון של תיבת השאלה; \"תחתית\" - טקסט שגיאה ממוקם בחלק התחתון של תיבת השאלה. האפשרות \"הירושה\" מחילה את ההגדרה ברמת הדף (אם הוגדרה) או ברמת הסקר (\"למעלה\" כברירת מחדל).",
            errorLocation: "קובע את המיקום של הודעת שגיאה ביחס לכל השאלות בחלונית. האפשרות \"הירושה\" מחילה את ההגדרה ברמת הדף (אם הוגדרה) או ברמת הסקר.",
            page: "מיקום מחדש של החלונית לסוף עמוד שנבחר.",
            innerIndent: "מוסיף רווח או שוליים בין תוכן החלונית לגבול השמאלי של תיבת החלונית.",
            startWithNewLine: "בטל את הבחירה כדי להציג את החלונית בשורה אחת עם השאלה או החלונית הקודמת. ההגדרה אינה חלה אם החלונית היא הרכיב הראשון בטופס.",
            state: "בחר מתוך: \"מורחב\" - הלוח מוצג במלואו וניתן לכווץ; \"מכווץ\" - הלוח מציג רק את הכותרת והתיאור וניתן להרחיבו; \"נעול\" - הלוח מוצג במלואו ולא ניתן לכווץ.",
            width: "קובע את רוחב החלונית ביחס לרכיבי סקר אחרים באותה שורה. מקבל ערכי CSS (px, %, in, pt וכו').",
            templateTitle: "הקלד תבנית לכותרות חלוניות דינמיות. השתמש ב- {panelIndex} למיקום הכללי של החלונית וב- {visiblePanelIndex} לסדר שלה בין חלוניות גלויות. הוסף מצייני מיקום אלה לתבנית כדי להוסיף מספור אוטומטי.",
            templateTabTitle: "הקלד תבנית עבור כותרות כרטיסיות. השתמש ב- {panelIndex} למיקום הכללי של חלונית וב- {visiblePanelIndex} לסדר שלה בין חלוניות גלויות. הוסף מצייני מיקום אלה לתבנית כדי להוסיף מספור אוטומטי.",
            tabTitlePlaceholder: "טקסט נסיגה עבור כותרות טאבים שחל כאשר תבנית כותרת הטאב אינה מפיקה ערך בעל משמעות.",
            templateVisibleIf: "קביעה זו מאפשרת לשלוט בתצוגה של חלוניות בודדות בחלונית הדינמית. השתמש במציין המיקום '{panel}' כדי להפנות לחלונית הנוכחית בביטוי שלך.",
            titleLocation: "הגדרה זו עוברת בירושה אוטומטית לכל השאלות בחלונית זו. אם ברצונך לעקוף הגדרה זו, הגדר כללי יישור כותרת עבור שאלות בודדות. האפשרות \"הירושה\" מחילה את ההגדרה ברמת הדף (אם הוגדרה) או ברמת הסקר (\"למעלה\" כברירת מחדל).",
            descriptionLocation: "האפשרות \"הירושה\" מחילה את ההגדרה ברמת העמוד (אם הוגדרה) או ברמת הסקר (\"תחת כותרת החלונית\" כברירת מחדל).",
            newPanelPosition: "מגדיר את המיקום של חלונית חדשה שנוספה. כברירת מחדל, חלוניות חדשות מתווספות לסוף. בחר \"הבא\" כדי להוסיף חלונית חדשה אחרי הנוכחית.",
            defaultValueFromLastPanel: "משכפל תשובות מהחלונית האחרונה ומקצה אותן לחלונית הדינמית הבאה שנוספה.",
            keyName: "הפנה לשם שאלה כדי לדרוש מהמשתמש לספק תשובה ייחודית לשאלה זו בכל חלונית."
        },
        defaultValueExpression: "הגדרה זו מאפשרת לך להקצות ערך ברירת מחדל לתשובה בהתבסס על ביטוי. הביטוי יכול לכלול חישובים בסיסיים - '{q1_id} + {q2_id}', ביטויים בוליאניים, כגון '{age} > 60', ופונקציות: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' וכו'. הערך שנקבע על-ידי ביטוי זה משמש כערך ברירת המחדל הראשוני שניתן לעקוף באמצעות קלט ידני של משיב.",
        resetValueIf: "השתמש בסמל מטה הקסם כדי להגדיר כלל מותנה הקובע מתי הקלט של המשיב יאופס לערך בהתבסס על \"ביטוי ערך ברירת מחדל\" או \"הגדר ביטוי ערך\" או על הערך \"תשובת ברירת מחדל\" (אם אחד מהם מוגדר).",
        setValueIf: "השתמש בסמל מטה הקסם כדי להגדיר כלל מותנה הקובע מתי להפעיל את \"Set value expression\" ולהקצות באופן דינמי את הערך המתקבל כתגובה.",
        setValueExpression: "ציין ביטוי המגדיר את הערך שיש להגדיר כשהתנאים בכלל \"הגדר ערך אם\" מתקיימים. הביטוי יכול לכלול חישובים בסיסיים - '{q1_id} + {q2_id}', ביטויים בוליאניים, כגון '{age} > 60', ופונקציות: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' וכו'. הערך שנקבע על ידי ביטוי זה ניתן לדריסת קלט ידני של המשיב.",
        question: {
            name: "מזהה שאלה שאינו גלוי למשיבים.",
            description: "הקלד כותרת משנה של שאלה.",
            visibleIf: "השתמש בסמל מטה הקסם כדי להגדיר כלל מותנה הקובע את נראות השאלה.",
            enableIf: "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי שמשבית את מצב הקריאה בלבד עבור השאלה.",
            requiredIf: "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי המונע קידום או שליחה של סקר, אלא אם כן השאלה קיבלה תשובה.",
            startWithNewLine: "בטל את הבחירה כדי להציג את השאלה בשורה אחת עם השאלה או החלונית הקודמת. ההגדרה אינה חלה אם השאלה היא הרכיב הראשון בטופס.",
            page: "מיקום מחדש של השאלה לסוף עמוד שנבחר.",
            state: "בחר מתוך: \"מורחב\" - תיבת השאלה מוצגת במלואה וניתן לכווץ אותה; \"מכווץ\" - תיבת השאלה מציגה רק את הכותרת והתיאור וניתן להרחיבה; \"נעול\" - תיבת השאלה מוצגת במלואה ולא ניתן לכווץ אותה.",
            titleLocation: "דורס כללי יישור כותרות שהוגדרו ברמת חלונית, עמוד או סקר. האפשרות \"ירושה\" מחילה הגדרות ברמה גבוהה יותר (אם הוגדרה) או הגדרה ברמת הסקר (\"עליון\" כברירת מחדל).",
            descriptionLocation: "האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר (\"תחת כותרת השאלה\" כברירת מחדל).",
            errorLocation: "הגדרת המיקום של הודעת שגיאה ביחס לשאלה עם קלט לא חוקי. בחר בין: \"למעלה\" - טקסט שגיאה ממוקם בחלק העליון של תיבת השאלה; \"תחתית\" - טקסט שגיאה ממוקם בחלק התחתון של תיבת השאלה. האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר (\"למעלה\" כברירת מחדל).",
            indent: "מוסיף רווח או שוליים בין תוכן השאלה לבין הגבול השמאלי של תיבת השאלה.",
            width: "קובע את רוחב השאלה ביחס לרכיבי סקר אחרים באותה שורה. מקבל ערכי CSS (px, %, in, pt וכו').",
            surveyvalidator: {
                expression: "השתמש בסמל מטה הקסמים כדי להגדיר כלל אימות עבור השאלה."
            },
            textUpdateMode: "בחר מתוך: \"על מיקוד אבוד\" - הערך מתעדכן כאשר שדה הקלט מאבד את המיקוד; \"בעת הקלדה\" - הערך מתעדכן בזמן אמת, כאשר המשתמשים מקלידים. האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר (\"מיקוד אבוד\" כברירת מחדל).",
            url: "באפשרותך להשתמש בכל שירות אינטרנט כמקור נתונים לשאלות אמריקאיות. כדי לאכלס ערכי בחירה, הזן את כתובת ה- URL של השירות המספק את הנתונים.",
            searchMode: "פעולת השוואה המשמשת לסינון הרשימה הנפתחת.",
            textWrapEnabled: "טקסטים ארוכים באפשרויות בחירה ייצרו באופן אוטומטי מעברי שורה שיתאימו לתפריט הנפתח. בטל את הבחירה אם ברצונך שהטקסטים ייחתכו."
        },
        signaturepad: {
            signatureWidth: "קובע את רוחב אזור החתימה המוצג ואת התמונה שתיווצר.",
            signatureHeight: "קובע את גובה אזור החתימה המוצג ואת התמונה שתיווצר.",
            signatureAutoScaleEnabled: "בחר אם ברצונך שאזור החתימה ימלא את כל השטח הזמין בתיבת השאלה תוך שמירה על יחס הרוחב-גובה המוגדר כברירת מחדל של 3:2. כאשר מוגדרים ערכי רוחב וגובה מותאמים אישית, ההגדרה תשמור על יחס הרוחב-גובה של ממדים אלה."
        },
        file: {
            imageHeight: "התאמת גובה התמונה בתוצאות הסקר.",
            imageWidth: "התאמת רוחב התמונה בתוצאות הסקר."
        },
        image: {
            contentMode: "האפשרות \"אוטומטי\" קובעת אוטומטית את המצב המתאים לתצוגה - תמונה, וידאו או YouTube - בהתבסס על כתובת האתר המקורית שסופקה."
        },
        imagepicker: {
            imageHeight: "דורס את ערכי הגובה המינימליים והמרביים.",
            imageWidth: "דורס את ערכי הרוחב המינימליים והמרביים.",
            choices: "\"ערך\" משמש כמזהה פריט המשמש בכללים מותנים; \"טקסט\" מוצג למשיבים.",
            contentMode: "בחר בין \"תמונה\" ו\"וידאו\" כדי להגדיר את מצב התוכן של בורר המדיה. אם נבחרה האפשרות \"תמונה\", ודא שכל האפשרויות שסופקו הן קובצי תמונה בתבניות הבאות: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. באופן דומה, אם נבחר \"וידאו\", ודא שכל האפשרויות הן קישורים ישירים לקבצי וידאו בפורמטים הבאים: MP4, MOV, WMV, FLV, AVI, MKV. שים לב שקישורי YouTube אינם נתמכים עבור אפשרויות וידאו."
        },
        text: {
            size: "הגדרה זו משנה את גודל שדה הקלט בלבד ואינה משפיעה על רוחב תיבת השאלה. כדי להגביל את אורך הקלט המקובל, עבור אל <b>אימות → מגבלת תווים מרבית</b>."
        },
        comment: {
            rows: "מגדיר את מספר השורות המוצגות בשדה הקלט. אם הקלט תופס שורות נוספות, פס הגלילה יופיע."
        },
        // survey templates
        survey: {
            mode: "בחר בין: \"ניתן לעריכה\" - מאפשר למשיבים למלא את הסקר שלך; \"לקריאה בלבד\" - משבית עריכת טפסים."
        },
        matrixdropdowncolumn: {
            name: "מזהה עמודה שאינו גלוי למשיבים.",
            isUnique: "כאשר אפשרות זו זמינה עבור עמודה, המשיב נדרש לספק תשובה ייחודית לכל שאלה בעמודה זו.",
            rows: "מגדיר את מספר השורות המוצגות בשדה הקלט. אם הקלט תופס שורות נוספות, פס הגלילה יופיע.",
            visibleIf: "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי הקובע את נראות העמודה.",
            enableIf: "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי שמשבית את מצב הקריאה בלבד עבור העמודה.",
            requiredIf: "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי המונע שליחת סקר, אלא אם לשאלה מקוננת אחת לפחות יש תשובה.",
            showInMultipleColumns: "כשבוחרים באפשרות זו, יוצר עמודה נפרדת לכל אחת מאפשרויות הבחירה."
        },
        widthMode: "בחר מתוך: \"סטטי\" - קובע רוחב קבוע; \"מגיב\" - עושה את הסקר לתפוס את מלוא רוחב המסך; \"אוטומטי\" - חל על כל אחד מהשניים בהתאם לסוגי השאלות המשמשים.",
        cookieName: "עוגיות מונעות ממשתמשים למלא את אותו סקר פעמיים.",
        logo: "הדבק קישור לתמונה (ללא מגבלות גודל) או לחץ על סמל התיקייה כדי לעיין בקובץ מהמחשב שלך (עד 64KB).",
        logoWidth: "הגדרת רוחב לוגו ביחידות CSS (px, %, in, pt וכו').",
        logoHeight: "הגדרת גובה סמל ביחידות CSS (px, %, in, pt וכו').",
        logoFit: "בחר מתוך: \"ללא\" - התמונה שומרת על גודלה המקורי; \"להכיל\" - גודל התמונה משתנה כדי להתאים תוך שמירה על יחס גובה-רוחב שלה; \"כיסוי\" - התמונה ממלאת את התיבה כולה תוך שמירה על יחס הגובה-רוחב שלה; \"מילוי\" - התמונה נמתחת כדי למלא את התיבה מבלי לשמור על יחס הגובה-רוחב שלה.",
        goNextPageAutomatic: "בחר אם ברצונך שהסקר יתקדם לדף הבא באופן אוטומטי לאחר שמשיב יענה על כל השאלות בדף הנוכחי.",
        allowCompleteSurveyAutomatic: "בחר אם ברצונך שהסקר יושלם באופן אוטומטי לאחר שמשיב עונה על כל השאלות.",
        showNavigationButtons: "מגדיר את התצוגה והמיקום של לחצני ניווט בעמוד.",
        showProgressBar: "הגדרת הניראות והמיקום של מד התקדמות. הערך \"אוטומטי\" מציג את מד ההתקדמות מעל או מתחת לכותרת הסקר.",
        showPreviewBeforeComplete: "הפעל את דף התצוגה המקדימה עם כל השאלות או שאלות שנענו בלבד.",
        questionTitleLocation: "חל על כל השאלות בסקר. ניתן לדרוס הגדרה זו באמצעות כללי יישור כותרות ברמות נמוכות יותר: חלונית, עמוד או שאלה. הגדרה ברמה נמוכה יותר תעקוף את אלה ברמה גבוהה יותר.",
        requiredText: "סמל או רצף של סמלים המציינים כי נדרשת תשובה.",
        questionStartIndex: "הזן מספר או אות שבאמצעותם ברצונך להתחיל במספור.",
        questionErrorLocation: "הגדרת המיקום של הודעת שגיאה ביחס לשאלה עם קלט לא חוקי. בחר בין: \"למעלה\" - טקסט שגיאה ממוקם בחלק העליון של תיבת השאלה; \"תחתית\" - טקסט שגיאה ממוקם בחלק התחתון של תיבת השאלה.",
        focusFirstQuestionAutomatic: "בחר אם ברצונך ששדה הקלט הראשון בכל עמוד יהיה מוכן להזנת טקסט.",
        questionsOrder: "שומר על הסדר המקורי של השאלות או מסדר אותן באופן אקראי. ההשפעה של הגדרה זו גלויה רק בכרטיסיה תצוגה מקדימה.",
        maxTextLength: "לשאלות הזנת טקסט בלבד.",
        maxOthersLength: "להערות לשאלה בלבד.",
        commentAreaRows: "מגדיר את מספר השורות המוצגות באזורי טקסט להערות שאלה. בקלט תופס יותר שורות, פס הגלילה מופיע.",
        autoGrowComment: "בחר אם ברצונך שהערות שאלה ושאלות טקסט ארוך יגדלו באופן אוטומטי לגובה בהתבסס על אורך הטקסט שהוזנו.",
        allowResizeComment: "להערות לשאלות ולשאלות טקסט ארוך בלבד.",
        calculatedValues: "משתנים מותאמים אישית משמשים כמשתני ביניים או משתני עזר המשמשים בחישובי טפסים. הם לוקחים תשומות משיבים כערכי מקור. לכל משתנה מותאם אישית יש שם ייחודי וביטוי שעליו הוא מבוסס.",
        includeIntoResult: "בחר אם ברצונך לשמור את הערך המחושב של הביטוי יחד עם תוצאות הסקר.",
        triggers: "גורם מפעיל הוא אירוע או תנאי המבוסס על ביטוי. לאחר הערכת הביטוי כ- \"true\", גורם מפעיל מגדיר פעולה. לפעולה כזו יכולה להיות שאלת יעד שהיא משפיעה עליה.",
        clearInvisibleValues: "בחר אם לנקות ערכים עבור שאלות המוסתרות על-ידי לוגיקה מותנית ומתי לעשות זאת.",
        textUpdateMode: "בחר מתוך: \"על מיקוד אבוד\" - הערך מתעדכן כאשר שדה הקלט מאבד את המיקוד; \"בעת הקלדה\" - הערך מתעדכן בזמן אמת, כאשר המשתמשים מקלידים.",
        columns: "הערך השמאלי משמש כמזהה עמודה המשמש בכללי תנאי, הערך הימני מוצג למשיבים.",
        rows: "הערך השמאלי משמש כמזהה שורה המשמש בכללי תנאי, הערך הימני מוצג למשיבים.",
        columnMinWidth: "מקבל ערכי CSS (px, %, in, pt וכו').",
        rowTitleWidth: "מקבל ערכי CSS (px, %, in, pt וכו').",
        totalText: "נראה רק כאשר לפחות עמוד אחד מכיל עמוד סוג או ביטוי סוג.",
        cellErrorLocation: "הגדרת המיקום של הודעת שגיאה ביחס לתא עם קלט לא חוקי. האפשרות \"ירושה\" מחילה את ההגדרה מהמאפיין \"יישור הודעת שגיאה\".",
        keyDuplicationError: "כאשר המאפיין \"מנע תגובות כפולות\" מופעל, משיב שינסה לשלוח ערך כפול יקבל את הודעת השגיאה הבאה.",
        totalExpression: "מאפשר לחשב ערכים כוללים בהתבסס על ביטוי. הביטוי יכול לכלול חישובים בסיסיים ('{q1_id} + {q2_id}'), ביטויים בוליאניים ('{age} > 60') ופונקציות ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' וכו').",
        confirmDelete: "מפעיל בקשה המבקשת לאשר את מחיקת השורות.",
        defaultValueFromLastRow: "משכפל תשובות מהשורה האחרונה ומקצה אותן לשורה הדינמית הבאה שנוספה.",
        keyName: "אם העמודה שצוינה מכילה ערכים זהים, הסקר יזרוק את השגיאה \"ערך מפתח לא ייחודי\".",
        description: "הקלד כותרת משנה.",
        locale: "בחר שפה כדי להתחיל ליצור את הסקר. כדי להוסיף תרגום, עבור לשפה חדשה ותרגם את הטקסט המקורי כאן או בכרטיסיה תרגומים.",
        detailPanelMode: "הגדרת המיקום של מקטע פרטים ביחס לשורה. בחר מתוך: \"ללא\" - לא נוספה הרחבה; \"מתחת לשורה\" - הרחבת שורה ממוקמת מתחת לכל שורה של המטריצה; \"מתחת לשורה, הצג הרחבת שורה אחת בלבד\" - הרחבה מוצגת תחת שורה אחת בלבד, הרחבות השורה הנותרות מכווצות.",
        imageFit: "בחר מתוך: \"ללא\" - התמונה שומרת על גודלה המקורי; \"להכיל\" - גודל התמונה משתנה כדי להתאים תוך שמירה על יחס גובה-רוחב שלה; \"כיסוי\" - התמונה ממלאת את התיבה כולה תוך שמירה על יחס הגובה-רוחב שלה; \"מילוי\" - התמונה נמתחת כדי למלא את התיבה מבלי לשמור על יחס הגובה-רוחב שלה.",
        autoGrow: "מגדיל בהדרגה את גובה שדה הקלט בעת הזנת הנתונים. דורס את ההגדרה \"גובה שדה קלט (בקווים)\".",
        allowResize: "נקודת האחיזה לשינוי גודל (או נקודת האחיזה) מופיעה בפינה וניתן לגרור אותה כדי לשנות את גודל שדה הקלט.",
        maxTimeToFinish: "מרווח זמן בשניות שלאחריו הסקר מתקדם אוטומטית לדף התודה.",
        maxTimeToFinishPage: "מרווח זמן בשניות שלאחריו הסקר מתקדם אוטומטית לעמוד הבא.",
        page: {
            maxTimeToFinish: "מרווח זמן בשניות שלאחריו הסקר מתקדם אוטומטית לעמוד הבא.",
            visibleIf: "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי הקובע את תצוגת העמוד.",
            enableIf: "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי שמשבית את מצב הקריאה בלבד של העמוד.",
            requiredIf: "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי המונע שליחת סקר, אלא אם לשאלה מקוננת אחת לפחות יש תשובה.",
            questionTitleLocation: "חל על כל השאלות בדף זה. אם ברצונך לדרוס הגדרה זו, הגדר כללי יישור כותרת לשאלות או חלוניות בודדות. האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר (\"למעלה\" כברירת מחדל).",
            questionTitleWidth: "הגדרת רוחב עקבי לכותרות שאלות כאשר הן מיושרות משמאל לתיבות השאלות. מקבל ערכי CSS (px, %, in, pt וכו').",
            questionErrorLocation: "הגדרת המיקום של הודעת שגיאה ביחס לשאלה עם קלט לא חוקי. בחר בין: \"למעלה\" - טקסט שגיאה ממוקם בחלק העליון של תיבת השאלה; \"תחתית\" - טקסט שגיאה ממוקם בחלק התחתון של תיבת השאלה. האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר (\"למעלה\" כברירת מחדל).",
            questionsOrder: "שומר על הסדר המקורי של השאלות או מסדר אותן באופן אקראי. האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר (\"מקורי\" כברירת מחדל). ההשפעה של הגדרה זו גלויה רק בכרטיסיה תצוגה מקדימה.",
            navigationButtonsVisibility: "מגדיר את התצוגה של לחצני ניווט בעמוד. האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר, המוגדרת כברירת מחדל ל\"גלוי\"."
        },
        showTimerPanel: "מגדיר את הניראות והמיקום של טיימר בדף.",
        panelsState: "בחר מתוך: \"נעול\" - משתמשים אינם יכולים להרחיב או לכווץ חלוניות; \"כווץ הכל\" - כל הלוחות מתחילים במצב מכווץ; \"הרחב הכל\" - כל הלוחות מתחילים במצב מורחב; \"מורחב ראשון\" - רק הלוח הראשון מורחב בתחילה.",
        imageLinkName: "הזן שם מאפיין משותף בתוך מערך האובייקטים המכיל את כתובות ה- URL של תמונות או קבצי וידאו שברצונך להציג ברשימת האפשרויות.",
        choices: "הערך השמאלי משמש כמזהה פריט המשמש בכללי תנאי, הערך הימני מוצג למשיבים.",
        title: "הקלד כותרת ידידותית למשתמש להצגה.",
        waitForUpload: "מבטיח שמשתמשים לא ישלימו את הסקר עד להעלאת קבצים.",
        minWidth: "מקבל ערכי CSS (px, %, in, pt וכו').",
        maxWidth: "מקבל ערכי CSS (px, %, in, pt וכו').",
        width: "מקבל ערכי CSS (px, %, in, pt וכו').",
        valueName: "אם אינך מגדיר מאפיין זה, התשובה תאוחסן בשדה המסוים במאפיין השם.",
        useDisplayValuesInDynamicTexts: "בסוגי שאלות של בחירה בודדת ושאלות מרובות, לכל אפשרות בחירה יש מזהה וערך תצוגה. כשבוחרים באפשרות זו, הגדרה זו מציגה ערך תצוגה במקום ערך מזהה בשאלות HTML ובכותרות דינמיות ובתיאורים של רכיבי סקר.",
        clearIfInvisible: "בחר אם לנקות או לא לנקות ערכי שאלות המוסתרים על-ידי לוגיקה מותנית ומתי לעשות זאת. האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר (\"עם השלמת הסקר\" כברירת מחדל).",
        choicesFromQuestionMode: "בחר מתוך: \"הכל\" - מעתיק את כל אפשרויות הבחירה מהשאלה שנבחרה; \"נבחר\" - מעתיק באופן דינמי רק אפשרויות בחירה שנבחרו; \"לא נבחר\" - מעתיק באופן דינמי רק אפשרויות בחירה שלא נבחרו. האפשרויות \"ללא\" ו\"אחר\" מועתקות כברירת מחדל אם הן מופעלות בשאלת המקור.",
        showOtherItem: "כשבוחרים באפשרות זו, משתמשים יכולים לכלול קלט נוסף בתיבת הערות נפרדת.",
        separateSpecialChoices: "מציג כל אפשרות בחירה מיוחדת (\"ללא\", \"אחר\", \"בחר הכל\") בשורה חדשה, גם בשעת שימוש בפריסה מרובת עמודות.",
        path: "ציין את המיקום בתוך ערכת נתוני השירות שבו ממוקם מערך האובייקטים המשמש כיעד. השאר ריק אם כתובת ה- URL כבר מצביעה על המערך.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "הזן שם מאפיין אחיד במערך האובייקטים הכולל את הערכים שברצונך להציג ברשימת הבחירה.",
        allowEmptyResponse: "בחר כדי לאפשר לשירות להחזיר תגובה או מערך ריקים.",
        choicesVisibleIf: "השתמש בסמל מטה הקסם כדי להגדיר כלל מותנה הקובע את התצוגה של כל אפשרויות הבחירה.",
        rateValues: "הערך השמאלי משמש כמזהה פריט המשמש בכללי תנאי, הערך הימני מוצג למשיבים.",
        rating: {
            displayMode: "\"אוטומטי\" בוחר בין המצבים \"לחצנים\" ו \"נפתח\" מבוסס על הרוחב הזמין. כאשר הרוחב אינו מספיק להצגת לחצנים, השאלה מציגה רשימה נפתחת."
        },
        valuePropertyName: "מאפשר לך לחבר שאלות המייצרות תוצאות בפורמטים שונים. כאשר שאלות כאלה מקושרות יחד באמצעות מזהה צירוף, מאפיין משותף זה מאחסן ערכי שאלות נבחרים.",
        searchEnabled: "בחר אם ברצונך לעדכן את תוכן התפריט הנפתח כך שיתאים לשאילתת החיפוש שמשתמש מקליד בשדה הקלט.",
        valueTrue: "ערך שיש לשמור בתוצאות הסקר כאשר המשיבים נותנים תשובה חיובית.",
        valueFalse: "ערך שיש לשמור בתוצאות הסקר כאשר המשיבים נותנים תשובה שלילית.",
        showPreview: "לא מומלץ להפוך אפשרות זו ללא זמינה מכיוון שהיא דורסת את תמונת התצוגה המקדימה ומקשה על המשתמש להבין אם הקבצים הועלו.",
        needConfirmRemoveFile: "מפעיל בקשה המבקשת לאשר את מחיקת הקובץ.",
        selectToRankEnabled: "אפשר לדרג רק בחירות נבחרות. המשתמשים יגררו פריטים נבחרים מרשימת האפשרויות כדי לסדר אותם באזור הדירוג.",
        dataList: "הזן רשימה של אפשרויות שיוצעו למשיב במהלך הקלט.",
        itemSize: "ההגדרה משנה את גודל שדות הקלט בלבד ואינה משפיעה על רוחב תיבת השאלה.",
        itemTitleWidth: "קובע רוחב עקבי לכל תוויות הפריטים בפיקסלים",
        altText: "משמש כתחליף כאשר לא ניתן להציג את התמונה במכשיר המשתמש ולמטרות נגישות.",
        rateColorMode: "מגדיר את צבע האמוג'י שנבחר כשסוג סמל הדירוג מוגדר ל\"סמיילי\". בחר בין: \"ברירת מחדל\" - האמוג'י שנבחר מופיע בצבע סקר ברירת מחדל; \"קנה מידה\" - האמוג'י שנבחר יורש צבע מסולם הדירוג.",
        expression: {
            name: "מזהה ביטוי שאינו גלוי למשיבים.",
            description: "הקלד כותרת משנה של ביטוי.",
            expression: "ביטוי יכול לכלול חישובים בסיסיים ('{q1_id} + {q2_id}'), תנאים ('{age} > 60') ופונקציות ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' וכו')."
        },
        storeOthersAsComment: "בחר כדי לאחסן את ערך האפשרות \"אחר\" כמאפיין נפרד בתוצאות הסקר.",
        format: "השתמש ב-{0} כמציין מקום ריק.",
        acceptedTypes: "התייחסות ל-[accept](https://www.w3schools.com/tags/att_input_accept.asp) למידע נוסף.",
        columnColCount: "ישומם רק לסוגי תא רדיו וקופסת סימון.",
        autocomplete: "התייחסות לתיאור של [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) למידע נוסף.",
        filePlaceholder: "חל כאשר \"סוג מקור\" הוא \"קבצים מקומיים\" או כאשר המצלמה אינה זמינה",
        photoPlaceholder: "חל כאשר \"סוג מקור\" הוא \"מצלמה\".",
        fileOrPhotoPlaceholder: "חל כאשר \"סוג מקור\" הוא \"קבצים מקומיים או מצלמה\".",
        masksettings: {
            saveMaskedValue: "בחר אם ברצונך לאחסן את ערך השאלה עם מסיכה שהוחלה בתוצאות הסקר."
        },
        patternmask: {
            pattern: "התבנית יכולה להכיל מילולי מחרוזת ואת מצייני המיקום הבאים: '9' - עבור ספרה; 'a' - עבור אות גדולה או קטנה; '#' - עבור ספרה או אות גדולה או קטנה. השתמש בקו נטוי הפוך '\\' כדי לברוח מתו."
        },
        datetimemask: {
            pattern: "התבנית יכולה להכיל תווים מפרידים ואת מצייני המיקום הבאים:<br>'m' - מספר חודש.<br>'mm' - מספר חודש, עם אפס מוביל עבור ערכים חד-ספרתיים. <br>'ד' - יום בחודש. <br>'dd' - יום בחודש, עם אפס מוביל עבור ערכים חד-ספרתיים. <br>'yy' - שתי הספרות האחרונות של השנה. <br>'yyyy' - שנה בת ארבע ספרות. <br>'H' - שעות בפורמט של 24 שעות. <br>'HH' - שעות בתבנית של 24 שעות, עם אפס מוביל עבור ערכים חד-ספרתיים. <br>'h' - שעות בפורמט של 12 שעות. <br>'hh' - שעות בתבנית של 12 שעות, עם אפס מוביל עבור ערכים חד-ספרתיים. <br>'ממ' - דקות. <br>'ss' - שניות. <br>'TT' - שעון של 12 שעות באותיות גדולות (AM/PM). <br>'tt' - שעון של 12 שעות באותיות קטנות (AM / PM)."
        },
        numericmask: {
            decimalSeparator: "סמל המשמש להפרדת חלק השבר מהחלק השלם של מספר מוצג.",
            thousandsSeparator: "סמל המשמש להפרדת הספרות של מספר גדול לקבוצות של שלושה.",
            precision: "מגביל את מספר הספרות שיש לשמור אחרי הנקודה העשרונית עבור מספר מוצג."
        },
        currencymask: {
            prefix: "סימן אחד או יותר שיוצגו לפני הערך.",
            suffix: "סימן אחד או יותר שיוצגו לאחר הערך."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "כותרת",
            title: "השאר ריק אם זה זהה ל'שם'"
        },
        multiSelect: "אפשר בחירה מרובה",
        showLabel: "הצגת כתוביות לתמונות",
        swapOrder: "החלפת הסדר של כן ולא",
        value: "ערך",
        tabAlign: "יישור לשונית",
        sourceType: "סוג מקור",
        fitToContainer: "התאמה למיכל",
        setValueExpression: "הגדרת ביטוי ערך",
        description: "תיאור",
        logoFit: "התאמת הלוגו",
        pages: "עמודים",
        questions: "שאלות",
        triggers: "מפעילים",
        calculatedValues: "ערכים מחושבים",
        surveyId: "מזהה סקר",
        surveyPostId: "מזהה פוסט סקר",
        surveyShowDataSaving: "הצגת שמירת נתונים",
        questionDescriptionLocation: "מיקום תיאור השאלה",
        progressBarType: "סוג סרגל התקדמות",
        showTOC: "הצגת תוכן הקריאה",
        tocLocation: "מיקום תוכן הקריאה",
        questionTitlePattern: "תבנית כותרת השאלה",
        widthMode: "מצב רוחב",
        showBrandInfo: "הצגת מידע על המותג",
        useDisplayValuesInDynamicTexts: "שימוש בערכי תצוגה בטקסטים דינמיים",
        visibleIf: "נראה אם",
        defaultValueExpression: "ביטוי ערך ברירת מחדל",
        requiredIf: "נדרש אם",
        resetValueIf: "איפוס ערך אם",
        setValueIf: "הגדר ערך אם",
        validators: "מאמתים",
        bindings: "קישורים",
        renderAs: "תצוגה כ",
        attachOriginalItems: "צרף פריטים מקוריים",
        choices: "בחירות",
        choicesByUrl: "בחירות דרך URL",
        currency: "מטבע",
        cellHint: "רמז לתא",
        totalMaximumFractionDigits: "מספר ספרות עשרוניות מרבי",
        totalMinimumFractionDigits: "מספר ספרות עשרוניות מינימלי",
        columns: "עמודות",
        detailElements: "רכיבי פרטים",
        allowAdaptiveActions: "אפשר פעולות מותאמות",
        defaultRowValue: "ערך ברירת מחדל לשורה",
        detailPanelShowOnAdding: "הצג פאנל פרטים בעת הוספה",
        choicesLazyLoadEnabled: "אפשר טעינת רשימות עם פריטים עצלים",
        choicesLazyLoadPageSize: "גודל עמוד בטעינת רשימות",
        inputFieldComponent: "רכיב שדה קלט",
        itemComponent: "רכיב פריט",
        min: "מינימום",
        max: "מקסימום",
        minValueExpression: "ביטוי ערך מינימלי",
        maxValueExpression: "ביטוי ערך מקסימלי",
        step: "צעד",
        dataList: "רשימת נתונים",
        itemSize: "גודל פריט",
        itemTitleWidth: "רוחב תווית פריט (בפיקסלים)",
        elements: "רכיבים",
        content: "תוכן",
        navigationButtonsVisibility: "נראות כפתורי ניווט",
        navigationTitle: "כותרת ניווט",
        navigationDescription: "תיאור ניווט",
        longTap: "לחיצה ארוכה",
        autoGrow: "התרחבות אוטומטית",
        allowResize: "אפשר שינוי גודל",
        acceptCarriageReturn: "קבלת Enter",
        displayMode: "מצב תצוגה",
        rateType: "סוג דירוג",
        label: "תווית",
        contentMode: "מצב תוכן",
        imageFit: "התאמת התמונה",
        altText: "טקסט חלופי",
        height: "גובה",
        penColor: "צבע העט",
        backgroundColor: "צבע רקע",
        templateElements: "רכיבי תבנית",
        operator: "אופרטור",
        isVariable: "משתנה",
        runExpression: "הפעל ביטוי",
        showCaption: "הצג כיתוב",
        iconName: "שם סמל",
        iconSize: "גודל סמל",
        precision: "דיוק",
        matrixDragHandleArea: "אזור גרירה במטריצה",
        backgroundImage: "תמונת רקע",
        backgroundImageFit: "התאמת תמונת רקע",
        backgroundImageAttachment: "קשר תמונת רקע",
        backgroundOpacity: "שקיפות רקע",
        selectToRankEnabled: "אפשר בחירה לדירוג",
        selectToRankAreasLayout: "תצוגת אזורי בחירה לדירוג",
        selectToRankEmptyRankedAreaText: "טקסט שיציג אם כל האפשרויות נבחרו",
        selectToRankEmptyUnrankedAreaText: "טקסט מציין מיקום עבור אזור הדירוג",
        allowCameraAccess: "אפשר גישה למצלמה",
        scaleColorMode: "מצב צבע לסולם",
        rateColorMode: "מצב צבע לדירוג",
        copyDisplayValue: "העתקת ערך תצוגה",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "מצב מתקדם",
        pageTitle: "גופן כותרת עמוד",
        questionTitle: "גופן כותרת שאלה",
        editorPanel: "רקע אלמנט קלט",
        lines: "קווים",
        primaryDefaultColor: "ברירת מחדל",
        primaryDarkColor: "עכבר",
        primaryLightColor: "נבחר",
        backgroundDimColor: "צבע רקע",
        cornerRadius: "רדיוס פינה",
        backcolor: "רקע ברירת מחדל",
        hovercolor: "רקע העברת עכבר",
        borderDecoration: "קישוט גבול",
        fontColor: "צבע גופן",
        backgroundColor: "צבע רקע",
        primaryForecolor: "צבע ברירת מחדל",
        primaryForecolorLight: "צבע כבוי",
        font: "גופן",
        borderDefault: "כהה",
        borderLight: "בהיר",
        fontFamily: "משפחת גופנים",
        fontWeightRegular: "רגיל",
        fontWeightHeavy: "כבד",
        fontWeightSemiBold: "חצי נועז",
        fontWeightBold: "נועז",
        color: "צבע",
        placeholderColor: "צבע מציין מיקום",
        size: "גודל",
        opacity: "אטימות",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "הוספת אפקט צל",
        boxShadowBlur: "טשטוש",
        boxShadowSpread: "התפשטות",
        boxShadowDrop: "הטפה",
        boxShadowInner: "פנימי",
        names: {
            default: "ברירת מחדל",
            sharp: "חד",
            borderless: "ללא גבול",
            flat: "שטוח",
            plain: "פשוט",
            doubleborder: "גבול כפול",
            layered: "בשכבות",
            solid: "מוצק",
            threedimensional: "שלושה מימדים",
            contrast: "ניגודיות"
        },
        colors: {
            teal: "טיל",
            blue: "כחול",
            purple: "סגול",
            orchid: "אורכידיה",
            tulip: "טוליפ",
            brown: "חום",
            green: "ירוק"
        }
    }
};
// Uncomment the line below if you create a custom dictionary.
// Replace "en" with a custom locale code (for example, "fr" or "de"),
// Replace `enStrings` with the name of the variable that contains the custom dictionary.
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["he"] = hebrewStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// ed.prevFocus: "Focus previous" => "פוקוס קודם"
// ed.nextFocus: "Focus next" => "התמקד הבא"
// ed.saveTheme: "Save Theme" => "שמור ערכת נושא"
// ed.saveThemeTooltip: "Save Theme" => "שמור ערכת נושא"
// ed.propertyGridNoResultsFound: "No results found" => "לא נמצאו תוצאות"
// ed.translateUsigAI: "Auto-translate All" => "תרגום אוטומטי של הכל"
// ed.translationDialogTitle: "Untranslated strings" => "מחרוזות לא מתורגמות"
// ed.surveyJsonExportButton: "Export" => "ייצא"
// ed.surveyJsonImportButton: "Import" => "ייבוא"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "העתק ללוח"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "האם אתה באמת רוצה לאפס את ערכת הנושא? כל ההתאמות האישיות שלך יאבדו."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "כן, אפס את ערכת הנושא"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "האפשרויות נטענות משירות אינטרנט."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "עבור אל הגדרות"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "תצוגה מקדימה של אפשרויות בחירה שנטענו"
// lg.addNewItem: "Add New Rule" => "הוספת כלל חדש"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "צור כלל כדי להתאים אישית את זרימת הסקר."
// lg.page_visibilityName: "Show (hide) page" => "הצג (הסתר) עמוד"
// lg.page_enableName: "Enable (disable) page" => "הפוך דף לזמין (הפוך ללא זמין)"
// lg.page_requireName: "Make page required" => "הפיכת הדף לנדרש"
// lg.panel_visibilityName: "Show (hide) panel" => "הצג (הסתר) החלונית"
// lg.panel_enableName: "Enable (disable) panel" => "הפעל (השבית) את החלונית"
// lg.panel_requireName: "Make page required" => "הפיכת הדף לנדרש"
// lg.question_visibilityName: "Show (hide) question" => "הצג (הסתר) שאלה"
// lg.question_enableName: "Enable (disable) question" => "הפיכת שאלה לזמינה (השבתה"
// lg.question_requireName: "Make question required" => "הפוך את השאלה לנדרשת"
// lg.question_resetValueName: "Reset question value" => "איפוס ערך שאלה"
// lg.question_setValueName: "Set question value" => "הגדרת ערך שאלה"
// lg.column_visibilityName: "Show (hide) column" => "הצג (הסתר) עמודה"
// lg.column_enableName: "Enable (disable) column" => "הפיכת עמודה לזמינה (ללא זמינה)"
// lg.column_requireName: "Make column required" => "הפיכת עמודה לנדרשת"
// lg.column_resetValueName: "Reset column value" => "איפוס ערך עמודה"
// lg.column_setValueName: "Set column value" => "הגדרת ערך עמודה"
// lg.trigger_completeName: "Complete survey" => "הסקר המלא"
// lg.trigger_setvalueName: "Set answer" => "הגדר תשובה"
// lg.trigger_copyvalueName: "Copy answer" => "העתק תשובה"
// lg.trigger_skipName: "Skip to question" => "דלג לשאלה"
// lg.trigger_runExpressionName: "Run expression" => "הפעל ביטוי"
// lg.completedHtmlOnConditionName: "Set \"Survey Complete\" page markup" => "הגדרת סימון דף \"סקר הושלם\""
// lg.page_visibilityDescription: "Make the page visible when the logic expression returns true. Otherwise keep it invisible." => "הפוך את הדף לגלוי כאשר ביטוי הלוגיקה מחזיר True. אחרת, שמור אותו בלתי נראה."
// lg.panel_visibilityDescription: "Make the panel visible when the logic expression returns true. Otherwise keep it invisible." => "הפוך את החלונית לגלויה כשביטוי הלוגיקה מחזיר True. אחרת, שמור אותו בלתי נראה."
// lg.panel_enableDescription: "Make the panel, and all elements inside it, enable when the logic expression returns true. Otherwise keep them disabled." => "הפוך את החלונית, ואת כל הרכיבים בתוכה, לזמינים כאשר ביטוי הלוגיקה מחזיר True. אחרת, השאר אותם מושבתים."
// lg.question_visibilityDescription: "Make the question visible when the logic expression returns true. Otherwise keep it invisible." => "הפוך את השאלה לגלויה כאשר ביטוי הלוגיקה חוזר True. אחרת, שמור אותו בלתי נראה."
// lg.question_enableDescription: "Make the question enable when the logic expression returns true. Otherwise keep it disabled." => "הפוך את השאלה לזמינה כאשר ביטוי הלוגיקה מחזיר True. אחרת, השאר אותו מושבת."
// lg.question_requireDescription: "Question becomes required when the logic expression returns true." => "השאלה הופכת לנדרשת כאשר ביטוי הלוגיקה מחזיר True."
// lg.trigger_completeDescription: "When the logic expression returns true then the survey becomes completed and an end-user see the 'Thank you page'." => "כאשר ביטוי הלוגיקה חוזר True, הסקר הושלם ומשתמש קצה רואה את 'דף התודה'."
// lg.trigger_setvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value is set to the selected question." => "כאשר ערכי שאלה, המשמשים בביטוי הלוגי, משתנים וביטוי הלוגיקה מחזיר True, הערך מוגדר לשאלה שנבחרה."
// lg.trigger_copyvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value of one selected question is copied to another selected question." => "כאשר ערכי שאלה, המשמשים בביטוי הלוגי, משתנים וביטוי הלוגיקה מחזיר True, הערך של שאלה נבחרת אחת מועתק לשאלה נבחרת אחרת."
// lg.trigger_skipDescription: "When the logic expression returns true then the survey skip to / focus the selected question." => "כאשר ביטוי הלוגיקה חוזר True אז הסקר מדלג / ממקד את השאלה שנבחרה."
// lg.trigger_runExpressionDescription: "When the logic expression returns true, then the custom expression is performed. You may optionally set this expression result into the selected question" => "כאשר ביטוי הלוגיקה מחזיר true, הביטוי המותאם אישית מתבצע. באפשרותך להגדיר תוצאת ביטוי זו בשאלה שנבחרה"
// lg.completedHtmlOnConditionDescription: "If the logic expression returns true, then the default text for the 'Thank you page' is changed to the given one." => "אם ביטוי הלוגיקה מחזיר true, טקסט ברירת המחדל עבור 'דף תודה' משתנה לטקסט הנתון."
// lg.itemExpressionText: "When expression: '{0}' returns true" => "כאשר expression: '{0}' מחזיר ערך True"
// lg.itemEmptyExpressionText: "New rule" => "כלל חדש"
// lg.page_visibilityText: "make page {0} visible" => "הפיכת {0} הדף לגלויות"
// lg.panel_visibilityText: "make panel {0} visible" => "הפיכת {0} החלונית לגלויה"
// lg.panel_enableText: "make panel {0} enable" => "הפיכת {0} החלונית לזמינה"
// lg.question_visibilityText: "make question {0} visible" => "הפוך את {0} השאלה לגלויה"
// lg.question_enableText: "make question {0} enable" => "הפוך שאלה {0} לזמינה"
// lg.question_requireText: "make question {0} required" => "יש צורך בשאלה {0}"
// lg.question_resetValueText: "reset value for question: {0}" => "אפס ערך עבור שאלה: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "הקצאת ערך: {1} לשאלה: {0}"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "הפוך את {0} העמודות של {1} השאלה לגלויות"
// lg.column_enableText: "make column {0} of question {1} enable" => "הפיכת עמודה {0} של שאלה לזמינה {1}"
// lg.column_requireText: "make column {0} of question {1} required" => "הפוך את {0} העמודות של השאלה {1} לנדרש"
// lg.column_resetValueText: "reset cell value for column: {0}" => "איפוס ערך תא עבור עמודה: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "הקצאת ערך תא: {1} לעמודה: {0}"
// lg.setValueExpressionPlaceholder: "An expression whose result will be assigned to the target question." => "ביטוי שתוצאתו תוקצה לשאלת היעד."
// lg.trigger_completeText: "survey becomes completed" => "הסקר הושלם"
// lg.trigger_setvalueText: "set into question: {0} value {1}" => "העמידו בסימן שאלה: ערך {0} {1}"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "ערך שאלה ברור: {0}"
// lg.trigger_copyvalueText: "copy into question: {0} value from question {1}" => "העתק לשאלה: ערך {0} משאלה {1}"
// lg.trigger_skipText: "survey skip to the question {0}" => "סקר דלג לשאלה {0}"
// lg.trigger_runExpressionText1: "run expression: '{0}'" => "ביטוי הפעלה: '{0}'"
// lg.trigger_runExpressionText2: " and set its result into question: {0}" => " ולהעמיד את תוצאתו בסימן שאלה: {0}"
// lg.completedHtmlOnConditionText: "show custom text for the 'Thank you page'." => "הצג טקסט מותאם אישית עבור 'דף תודה'."
// lg.showAllQuestions: "All Questions" => "כל השאלות"
// lg.showAllActionTypes: "All Action Types" => "כל סוגי הפעולות"
// lg.conditions: "Condition(s)" => "תנאים(ים)"
// lg.actions: "Action(s)" => "פעולה(ות)"
// lg.expressionEditorTitle: "Define condition(s)" => "הגדרת תנאים"
// lg.actionsEditorTitle: "Define action(s)" => "הגדרת פעולות"
// lg.deleteAction: "Delete Action" => "מחיקת פעולה"
// lg.addNewAction: "Add Action" => "הוסף פעולה"
// lg.selectedActionCaption: "Select action..." => "בחר פעולה..."
// lg.expressionInvalid: "The logic expression is empty or invalid. Please correct it." => "ביטוי הלוגיקה ריק או לא חוקי. אנא תקן זאת."
// lg.noActionError: "Please, add at least one action." => "אנא, הוסף לפחות פעולה אחת."
// lg.actionInvalid: "Please, fix problems in your action(s)." => "אנא, תקן בעיות בפעולות שלך."
// lg.uncompletedRule_title: "Logical rules are incomplete" => "כללים לוגיים אינם שלמים"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "לא השלמת חלק מהכללים הלוגיים. אם תעזוב את הכרטיסיה כעת, השינויים יאבדו. האם אתה עדיין רוצה לעזוב את הכרטיסייה מבלי להשלים את השינויים?"
// lg.uncompletedRule_apply: "Yes" => "כן"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "לא, אני רוצה להשלים את הכללים"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "אנא הכנס לפחות {0} פריטים"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "מניעת תגובות כפולות בשורות"
// survey.title: "Title" => "כותר"
// page.title: "Title" => "כותר"
// signaturepad.showPlaceholder: "Show the placeholder" => "הצגת מציין המיקום"
// signaturepad.placeholder: "Placeholder text" => "טקסט מציין מיקום"
// signaturepad.signatureWidth: "Signature area width" => "רוחב אזור חתימה"
// signaturepad.signatureHeight: "Signature area height" => "גובה אזור חתימה"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "שינוי גודל אוטומטי של אזור החתימה"
// signaturepad.penMinWidth: "Minimum pen width" => "רוחב עט מינימלי"
// signaturepad.penMaxWidth: "Maximum pen width" => "רוחב עט מרבי"
// pe.filePlaceholder: "File placeholder text" => "טקסט מציין מיקום קובץ"
// pe.photoPlaceholder: "Photo placeholder text" => "טקסט מציין מיקום תמונה"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "טקסט מציין מיקום של קובץ או תמונה"
// pv.leftRight: "Left and right" => "ימין ושמאל"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "חל כאשר \"סוג מקור\" הוא \"קבצים מקומיים\" או כאשר המצלמה אינה זמינה"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "חל כאשר \"סוג מקור\" הוא \"מצלמה\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "חל כאשר \"סוג מקור\" הוא \"קבצים מקומיים או מצלמה\"."
// p.sourceType: "Source type" => "סוג מקור"
// p.fitToContainer: "Fit to container" => "התאמה למיכל"
// p.setValueExpression: "Set value expression" => "הגדרת ביטוי ערך"
// p.resetValueIf: "Reset value if" => "איפוס ערך אם"
// p.setValueIf: "Set value if" => "הגדר ערך אם"
// theme.advancedMode: "Advanced mode" => "מצב מתקדם"
// theme.header: "Header" => "כותרת"
// theme.background: "Background" => "רקע"
// theme.appearance: "Appearance" => "מראה"
// theme.backgroundImageFitFill: "Stretch" => "מתיחה"
// theme.backgroundImageFitTile: "Tile" => "אריח"
// theme.backgroundCornerRadius: "Background and corner radius" => "רקע ורדיוס פינה"
// theme.colorsTitle: "Colors" => "צבעים"
// theme.font: "Font" => "גופן"
// theme.lines: "Lines" => "קווים"
// theme.surveyDescriptionFont: "Survey description font" => "גופן תיאור סקר"
// theme.titleFont: "Title font" => "גופן כותרת"
// theme.descriptionFont: "Description font" => "גופן תיאור"
// theme.shadow: "Shadow effects" => "אפקטי צל"
// theme.headerView: "View" => "נוף"
// theme.headerViewBasic: "Basic" => "בסיסי"
// theme.headerViewAdvanced: "Advanced" => "מתקדמים"
// theme.headerInheritWidthFrom: "Content area width" => "רוחב אזור תוכן"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "זהה לסקר"
// theme.headerInheritWidthFromContainer: "Fit to container" => "התאמה למיכל"
// theme.headerTextAreaWidth: "Text width" => "רוחב טקסט"
// theme.headerBackgroundColorSwitch: "Background color" => "צבע רקע"
// theme.headerBackgroundColorNone: "None" => "ללא"
// theme.headerBackgroundColorAccentColor: "Accent color" => "צבע הדגשה"
// theme.headerBackgroundColorCustom: "Custom" => "מנהג"
// theme.horizontalAlignmentLeft: "Left" => "שמאל"
// theme.horizontalAlignmentCenter: "Center" => "מרכז"
// theme.horizontalAlignmentRight: "Right" => "ימין"
// theme.verticalAlignmentTop: "Top" => "סביבון"
// theme.verticalAlignmentMiddle: "Middle" => "אמצע"
// theme.verticalAlignmentBottom: "Bottom" => "ישבן"
// theme.logoPosition: "Logo position" => "מיקום הלוגו"
// theme.headerTitlePosition: "Title position" => "מיקום בתפקיד"
// theme.headerDescriptionPosition: "Description position" => "תיאור מיקום"
// ed.translateUsigAIFrom: "Translate from: " => "תרגם מ: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "אפשר את האפשרות סרב לענות"
// pe.showDontKnowItem: "Allow the Don't Know option" => "אפשר את האפשרות 'לא יודע'"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "אפשר את האפשרות סרב לענות"
// pe.showDontKnowItem: "Allow the Don't Know option" => "אפשר את האפשרות 'לא יודע'"
// pv.contain: "Contain" => "להכיל"
// pv.cover: "Cover" => "כריכה"
// pv.fill: "Fill" => "מילוי"
// pe.transposeData: "Transpose rows to columns" => "ביצוע חילוף שורות לעמודות"
// layout.panel: "Layout" => "פריסה"
// layout.question: "Layout" => "פריסה"
// layout.base: "Layout" => "פריסה"
// panel.name: "Panel name" => "שם החלונית"
// panel.title: "Panel title" => "כותרת הפאנל"
// panel.description: "Panel description" => "תיאור הלוח"
// panel.visibleIf: "Make the panel visible if" => "הפוך את החלונית לגלויה אם"
// panel.requiredIf: "Make the panel required if" => "הפוך את החלונית לנדרשת אם"
// panel.questionsOrder: "Question order within the panel" => "סדר השאלות בתוך הפאנל"
// panel.startWithNewLine: "Display the panel on a new line" => "הצגת החלונית בשורה חדשה"
// panel.state: "Panel collapse state" => "מצב כיווץ לוח"
// panel.width: "Inline panel width" => "רוחב החלונית בתוך שורה"
// panel.minWidth: "Minimum panel width" => "רוחב לוח מינימלי"
// panel.maxWidth: "Maximum panel width" => "רוחב לוח מרבי"
// panel.showNumber: "Number panels" => "חלוניות מספרים"
// paneldynamic.name: "Panel name" => "שם החלונית"
// paneldynamic.title: "Panel title" => "כותרת הפאנל"
// paneldynamic.description: "Panel description" => "תיאור הלוח"
// paneldynamic.visibleIf: "Make the panel visible if" => "הפוך את החלונית לגלויה אם"
// paneldynamic.requiredIf: "Make the panel required if" => "הפוך את החלונית לנדרשת אם"
// paneldynamic.page: "Move the panel to page" => "העברת החלונית לעמוד"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "הצגת החלונית בשורה חדשה"
// paneldynamic.state: "Panel collapse state" => "מצב כיווץ לוח"
// paneldynamic.width: "Inline panel width" => "רוחב החלונית בתוך שורה"
// paneldynamic.minWidth: "Minimum panel width" => "רוחב לוח מינימלי"
// paneldynamic.maxWidth: "Maximum panel width" => "רוחב לוח מרבי"
// paneldynamic.templateDescription: "Panel description pattern" => "תבנית תיאור חלונית"
// paneldynamic.templateTitle: "Panel title pattern" => "תבנית כותרת חלונית"
// paneldynamic.noEntriesText: "Empty panel text" => "טקסט ריק בחלונית"
// paneldynamic.templateTabTitle: "Tab title pattern" => "תבנית כותרת טאב"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "הפיכת חלונית בודדת לגלויה אם"
// paneldynamic.hideNumber: "Hide the panel number" => "הסתרת מספר החלונית"
// paneldynamic.titleLocation: "Panel title alignment" => "יישור כותרת חלונית"
// paneldynamic.descriptionLocation: "Panel description alignment" => "יישור תיאור החלונית"
// paneldynamic.templateTitleLocation: "Question title alignment" => "יישור כותרת שאלה"
// paneldynamic.templateErrorLocation: "Error message alignment" => "יישור הודעת שגיאה"
// paneldynamic.newPanelPosition: "New panel location" => "מיקום חדש בלוח"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "מניעת תגובות כפולות בשאלה הבאה"
// question.name: "Question name" => "שם שאלה"
// question.title: "Question title" => "כותרת השאלה"
// question.description: "Question description" => "תיאור השאלה"
// question.visibleIf: "Make the question visible if" => "הפוך את השאלה לגלויה אם"
// question.requiredIf: "Make the question required if" => "הפוך את השאלה לנדרשת אם"
// question.state: "Question box collapse state" => "מצב כיווץ תיבת שאלה"
// question.hideNumber: "Hide the question number" => "הסתרת מספר השאלה"
// question.titleLocation: "Question title alignment" => "יישור כותרת שאלה"
// question.descriptionLocation: "Question description alignment" => "יישור תיאור השאלה"
// question.errorLocation: "Error message alignment" => "יישור הודעת שגיאה"
// question.indent: "Increase the inner indent" => "הגדלת הכניסה הפנימית"
// question.width: "Inline question width" => "רוחב שאלה מוטבעת"
// question.minWidth: "Minimum question width" => "רוחב שאלה מינימלי"
// question.maxWidth: "Maximum question width" => "רוחב שאלה מרבי"
// question.textUpdateMode: "Update input field value" => "עדכון ערך שדה קלט"
// signaturepad.allowClear: "Show the Clear button within signature area" => "הצגת לחצן 'נקה' בתוך אזור החתימה"
// signaturepad.penColor: "Stroke color" => "צבע קו"
// comment.rows: "Input field height (in lines)" => "גובה שדה קלט (בקווים)"
// expression.name: "Expression name" => "שם ביטוי"
// expression.title: "Expression title" => "כותרת ביטוי"
// expression.description: "Expression description" => "תיאור ביטוי"
// expression.expression: "Expression" => "ביטוי"
// trigger.expression: "Expression" => "ביטוי"
// calculatedvalue.expression: "Expression" => "ביטוי"
// survey.description: "Survey description" => "תיאור הסקר"
// page.name: "Page name" => "שם הדף"
// page.description: "Page description" => "תיאור הדף"
// page.visibleIf: "Make the page visible if" => "הפוך את הדף לגלוי אם"
// page.requiredIf: "Make the page required if" => "הפוך את הדף לנדרש אם"
// page.questionsOrder: "Question order on the page" => "סדר השאלות בדף"
// matrixdropdowncolumn.name: "Column name" => "שם עמודה"
// matrixdropdowncolumn.title: "Column title" => "כותרת עמודה"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "מניעת תגובות כפולות"
// matrixdropdowncolumn.width: "Column width" => "רוחב עמודה"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "רוחב עמודה מינימלי"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "גובה שדה קלט (בקווים)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "הפיכת העמודה לגלויה אם"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "הפוך את העמודה לנדרשת אם"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "כל אפשרות בעמודה נפרדת"
// multipletextitem.name: "Name" => "שם"
// multipletextitem.title: "Title" => "כותר"
// pe.rateDescriptionLocation: "Label alignment" => "יישור תוויות"
// pe.cellErrorLocation: "Cell error message alignment" => "יישור הודעת שגיאה של תא"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "עדיין אין לך עמודות"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "עדיין אין לך שורות"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "עדיין אין לך כללי אימות"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "עדיין אין לך משתנים מותאמים אישית"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "עדיין אין לך טריגרים"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "עדיין אין לך קישורים"
// pe.addNew@columns: "Add new column" => "הוספת עמודה חדשה"
// pe.addNew@rows: "Add new row" => "הוספת שורה חדשה"
// pe.addNew@validators: "Add new rule" => "הוספת כלל חדש"
// pe.addNew@calculatedValues: "Add new variable" => "הוספת משתנה חדש"
// pe.addNew@triggers: "Add new trigger" => "הוספת גורם מפעיל חדש"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "הוספת כתובת URL חדשה"
// choicesbyurl.url: "Web service's URL" => "כתובת URL של שירות אינטרנט"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "הצגת כותרות עמודים בסרגל ההתקדמות"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "הצגת מספרי עמודים במד ההתקדמות"
// itemvalue.visibleIf: "Make the option visible if" => "הפוך את האפשרות לגלויה אם"
// itemvalue.enableIf: "Make the option selectable if" => "הפוך את האפשרות לניתנת לבחירה אם"
// panel.layout: "Panel Layout" => "פריסת חלונית"
// tabs.questionSettings: "Question Settings" => "הגדרות שאלה"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "לדוגמה: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "לדוגמה: קטגוריות.בדיוני"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "לדוגמה: א)"
// pe.width_placeholder: "Ex.: 6in" => "לדוגמה: 6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "לדוגמה: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "לדוגמה: 50%"
// pv.selected: "Selected" => "שנבחרו"
// pv.unselected: "Unselected" => "לא נבחר"
// pv.center: "Center" => "מרכז"
// pv.middle: "Middle" => "אמצע"
// pv.next: "Next" => "הבא"
// pv.last: "Last" => "אחרון"
// clearIfInvisible.none: "Never" => "אף פעם"
// questionsOnPageMode.standard: "Original structure" => "מבנה מקורי"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "הצג את כל השאלות בעמוד אחד"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "הצגת שאלה בודדת בכל עמוד"
// pv.auto: "Auto" => "אוטומטי"
// panelsState.firstExpanded: "First expanded" => "הראשון הורחב"
// rateColorMode.scale: "Scale" => "סולם"
// scaleColorMode.monochrome: "Monochrome" => "מונוכרום"
// scaleColorMode.colored: "Colored" => "צבעוניים"
// state.default: "Locked" => "נעול"
// showQuestionNumbers.default: "Auto-numbering" => "מספור אוטומטי"
// showQuestionNumbers.on: "Auto-numbering" => "מספור אוטומטי"
// showQuestionNumbers.onPage: "Reset on each page" => "איפוס בכל עמוד"
// showQuestionNumbers.onpanel: "Reset on each panel" => "איפוס בכל חלונית"
// showQuestionNumbers.onPanel: "Reset on each panel" => "איפוס בכל חלונית"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "המשך לאורך הסקר"
// showQuestionNumbers.off: "No numbering" => "ללא מספור"
// descriptionLocation.underTitle: "Under the question title" => "תחת כותרת השאלה"
// descriptionLocation.underInput: "Under the input field" => "מתחת לשדה הקלט"
// selectToRankAreasLayout.horizontal: "Next to choices" => "לצד אפשרויות בחירה"
// selectToRankAreasLayout.vertical: "Above choices" => "אפשרויות מעל"
// displayStyle.decimal: "Decimal" => "עשרוני"
// displayStyle.currency: "Currency" => "מטבע"
// displayStyle.percent: "Percentage" => "אחוז"
// displayStyle.date: "Date" => "תמר"
// totalDisplayStyle.decimal: "Decimal" => "עשרוני"
// totalDisplayStyle.currency: "Currency" => "מטבע"
// totalDisplayStyle.percent: "Percentage" => "אחוז"
// totalDisplayStyle.date: "Date" => "תמר"
// rowsOrder.initial: "Original" => "מקורי"
// questionsOrder.initial: "Original" => "מקורי"
// showProgressBar.aboveheader: "Above the header" => "מעל הכותרת העליונה"
// showProgressBar.belowheader: "Below the header" => "מתחת לכותרת העליונה"
// pv.sum: "Sum" => "סכום"
// pv.count: "Count" => "מנה"
// pv.min: "Min" => "דקות"
// pv.max: "Max" => "מקס"
// pv.avg: "Avg" => "ממוצע"
// searchMode.contains: "Contains" => "מכיל"
// searchMode.startsWith: "Starts with" => "מתחיל ב"
// panel.name: "A panel ID that is not visible to respondents." => "מזהה חלונית שאינו גלוי למשיבים."
// panel.description: "Type a panel subtitle." => "הקלד כותרת משנה של חלונית."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "השתמשו בסמל מטה הקסם כדי להגדיר כלל תנאי הקובע את תצוגת החלונית."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "השתמשו בסמל מטה הקסם כדי להגדיר כלל מותנה שמשבית את מצב הקריאה בלבד של החלונית."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי המונע שליחת סקר, אלא אם לשאלה מקוננת אחת לפחות יש תשובה."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "חל על כל השאלות בפאנל זה. אם ברצונך לעקוף הגדרה זו, הגדר כללי יישור כותרת עבור שאלות בודדות. האפשרות \"הירושה\" מחילה את ההגדרה ברמת הדף (אם הוגדרה) או ברמת הסקר (\"למעלה\" כברירת מחדל)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "קובע את המיקום של הודעת שגיאה ביחס לכל השאלות בחלונית. האפשרות \"הירושה\" מחילה את ההגדרה ברמת הדף (אם הוגדרה) או ברמת הסקר."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "שומר על הסדר המקורי של השאלות או מסדר אותן באופן אקראי. האפשרות \"הירושה\" מחילה את ההגדרה ברמת הדף (אם הוגדרה) או ברמת הסקר."
// panel.page: "Repositions the panel to the end of a selected page." => "מיקום מחדש של החלונית לסוף עמוד שנבחר."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "מוסיף רווח או שוליים בין תוכן החלונית לגבול השמאלי של תיבת החלונית."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "בטל את הבחירה כדי להציג את החלונית בשורה אחת עם השאלה או החלונית הקודמת. ההגדרה אינה חלה אם החלונית היא הרכיב הראשון בטופס."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "בחר מתוך: \"מורחב\" - הלוח מוצג במלואו וניתן לכווץ; \"מכווץ\" - הלוח מציג רק את הכותרת והתיאור וניתן להרחיבו; \"נעול\" - הלוח מוצג במלואו ולא ניתן לכווץ."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "קובע את רוחב החלונית ביחס לרכיבי סקר אחרים באותה שורה. מקבל ערכי CSS (px, %, in, pt וכו')."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "מזהה חלונית שאינו גלוי למשיבים."
// paneldynamic.description: "Type a panel subtitle." => "הקלד כותרת משנה של חלונית."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "השתמשו בסמל מטה הקסם כדי להגדיר כלל תנאי הקובע את תצוגת החלונית."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "השתמשו בסמל מטה הקסם כדי להגדיר כלל מותנה שמשבית את מצב הקריאה בלבד של החלונית."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי המונע שליחת סקר, אלא אם לשאלה מקוננת אחת לפחות יש תשובה."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "חל על כל השאלות בפאנל זה. אם ברצונך לעקוף הגדרה זו, הגדר כללי יישור כותרת עבור שאלות בודדות. האפשרות \"הירושה\" מחילה את ההגדרה ברמת הדף (אם הוגדרה) או ברמת הסקר (\"למעלה\" כברירת מחדל)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "הגדרת המיקום של הודעת שגיאה ביחס לשאלה עם קלט לא חוקי. בחר בין: \"למעלה\" - טקסט שגיאה ממוקם בחלק העליון של תיבת השאלה; \"תחתית\" - טקסט שגיאה ממוקם בחלק התחתון של תיבת השאלה. האפשרות \"הירושה\" מחילה את ההגדרה ברמת הדף (אם הוגדרה) או ברמת הסקר (\"למעלה\" כברירת מחדל)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "קובע את המיקום של הודעת שגיאה ביחס לכל השאלות בחלונית. האפשרות \"הירושה\" מחילה את ההגדרה ברמת הדף (אם הוגדרה) או ברמת הסקר."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "מיקום מחדש של החלונית לסוף עמוד שנבחר."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "מוסיף רווח או שוליים בין תוכן החלונית לגבול השמאלי של תיבת החלונית."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "בטל את הבחירה כדי להציג את החלונית בשורה אחת עם השאלה או החלונית הקודמת. ההגדרה אינה חלה אם החלונית היא הרכיב הראשון בטופס."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "בחר מתוך: \"מורחב\" - הלוח מוצג במלואו וניתן לכווץ; \"מכווץ\" - הלוח מציג רק את הכותרת והתיאור וניתן להרחיבו; \"נעול\" - הלוח מוצג במלואו ולא ניתן לכווץ."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "קובע את רוחב החלונית ביחס לרכיבי סקר אחרים באותה שורה. מקבל ערכי CSS (px, %, in, pt וכו')."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "הקלד תבנית לכותרות חלוניות דינמיות. השתמש ב- {panelIndex} למיקום הכללי של החלונית וב- {visiblePanelIndex} לסדר שלה בין חלוניות גלויות. הוסף מצייני מיקום אלה לתבנית כדי להוסיף מספור אוטומטי."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "הקלד תבנית עבור כותרות כרטיסיות. השתמש ב- {panelIndex} למיקום הכללי של חלונית וב- {visiblePanelIndex} לסדר שלה בין חלוניות גלויות. הוסף מצייני מיקום אלה לתבנית כדי להוסיף מספור אוטומטי."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "קביעה זו מאפשרת לשלוט בתצוגה של חלוניות בודדות בחלונית הדינמית. השתמש במציין המיקום '{panel}' כדי להפנות לחלונית הנוכחית בביטוי שלך."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "הגדרה זו עוברת בירושה אוטומטית לכל השאלות בחלונית זו. אם ברצונך לעקוף הגדרה זו, הגדר כללי יישור כותרת עבור שאלות בודדות. האפשרות \"הירושה\" מחילה את ההגדרה ברמת הדף (אם הוגדרה) או ברמת הסקר (\"למעלה\" כברירת מחדל)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "האפשרות \"הירושה\" מחילה את ההגדרה ברמת העמוד (אם הוגדרה) או ברמת הסקר (\"תחת כותרת החלונית\" כברירת מחדל)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "מגדיר את המיקום של חלונית חדשה שנוספה. כברירת מחדל, חלוניות חדשות מתווספות לסוף. בחר \"הבא\" כדי להוסיף חלונית חדשה אחרי הנוכחית."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "משכפל תשובות מהחלונית האחרונה ומקצה אותן לחלונית הדינמית הבאה שנוספה."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "הפנה לשם שאלה כדי לדרוש מהמשתמש לספק תשובה ייחודית לשאלה זו בכל חלונית."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "הגדרה זו מאפשרת לך להקצות ערך ברירת מחדל לתשובה בהתבסס על ביטוי. הביטוי יכול לכלול חישובים בסיסיים - '{q1_id} + {q2_id}', ביטויים בוליאניים, כגון '{age} > 60', ופונקציות: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' וכו'. הערך שנקבע על-ידי ביטוי זה משמש כערך ברירת המחדל הראשוני שניתן לעקוף באמצעות קלט ידני של משיב."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "השתמש בסמל מטה הקסם כדי להגדיר כלל מותנה הקובע מתי הקלט של המשיב יאופס לערך בהתבסס על \"ביטוי ערך ברירת מחדל\" או \"הגדר ביטוי ערך\" או על הערך \"תשובת ברירת מחדל\" (אם אחד מהם מוגדר)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "השתמש בסמל מטה הקסם כדי להגדיר כלל מותנה הקובע מתי להפעיל את \"Set value expression\" ולהקצות באופן דינמי את הערך המתקבל כתגובה."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "ציין ביטוי המגדיר את הערך שיש להגדיר כשהתנאים בכלל \"הגדר ערך אם\" מתקיימים. הביטוי יכול לכלול חישובים בסיסיים - '{q1_id} + {q2_id}', ביטויים בוליאניים, כגון '{age} > 60', ופונקציות: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' וכו'. הערך שנקבע על ידי ביטוי זה ניתן לדריסת קלט ידני של המשיב."
// question.name: "A question ID that is not visible to respondents." => "מזהה שאלה שאינו גלוי למשיבים."
// question.description: "Type a question subtitle." => "הקלד כותרת משנה של שאלה."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "השתמש בסמל מטה הקסם כדי להגדיר כלל מותנה הקובע את נראות השאלה."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי שמשבית את מצב הקריאה בלבד עבור השאלה."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי המונע קידום או שליחה של סקר, אלא אם כן השאלה קיבלה תשובה."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "בטל את הבחירה כדי להציג את השאלה בשורה אחת עם השאלה או החלונית הקודמת. ההגדרה אינה חלה אם השאלה היא הרכיב הראשון בטופס."
// question.page: "Repositions the question to the end of a selected page." => "מיקום מחדש של השאלה לסוף עמוד שנבחר."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "בחר מתוך: \"מורחב\" - תיבת השאלה מוצגת במלואה וניתן לכווץ אותה; \"מכווץ\" - תיבת השאלה מציגה רק את הכותרת והתיאור וניתן להרחיבה; \"נעול\" - תיבת השאלה מוצגת במלואה ולא ניתן לכווץ אותה."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "דורס כללי יישור כותרות שהוגדרו ברמת חלונית, עמוד או סקר. האפשרות \"ירושה\" מחילה הגדרות ברמה גבוהה יותר (אם הוגדרה) או הגדרה ברמת הסקר (\"עליון\" כברירת מחדל)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר (\"תחת כותרת השאלה\" כברירת מחדל)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "הגדרת המיקום של הודעת שגיאה ביחס לשאלה עם קלט לא חוקי. בחר בין: \"למעלה\" - טקסט שגיאה ממוקם בחלק העליון של תיבת השאלה; \"תחתית\" - טקסט שגיאה ממוקם בחלק התחתון של תיבת השאלה. האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר (\"למעלה\" כברירת מחדל)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "מוסיף רווח או שוליים בין תוכן השאלה לבין הגבול השמאלי של תיבת השאלה."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "קובע את רוחב השאלה ביחס לרכיבי סקר אחרים באותה שורה. מקבל ערכי CSS (px, %, in, pt וכו')."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "השתמש בסמל מטה הקסמים כדי להגדיר כלל אימות עבור השאלה."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "בחר מתוך: \"על מיקוד אבוד\" - הערך מתעדכן כאשר שדה הקלט מאבד את המיקוד; \"בעת הקלדה\" - הערך מתעדכן בזמן אמת, כאשר המשתמשים מקלידים. האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר (\"מיקוד אבוד\" כברירת מחדל)."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "באפשרותך להשתמש בכל שירות אינטרנט כמקור נתונים לשאלות אמריקאיות. כדי לאכלס ערכי בחירה, הזן את כתובת ה- URL של השירות המספק את הנתונים."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "פעולת השוואה המשמשת לסינון הרשימה הנפתחת."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "קובע את רוחב אזור החתימה המוצג ואת התמונה שתיווצר."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "קובע את גובה אזור החתימה המוצג ואת התמונה שתיווצר."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "בחר אם ברצונך שאזור החתימה ימלא את כל השטח הזמין בתיבת השאלה תוך שמירה על יחס הרוחב-גובה המוגדר כברירת מחדל של 3:2. כאשר מוגדרים ערכי רוחב וגובה מותאמים אישית, ההגדרה תשמור על יחס הרוחב-גובה של ממדים אלה."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "התאמת גובה התמונה בתוצאות הסקר."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "התאמת רוחב התמונה בתוצאות הסקר."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "דורס את ערכי הגובה המינימליים והמרביים."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "דורס את ערכי הרוחב המינימליים והמרביים."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"ערך\" משמש כמזהה פריט המשמש בכללים מותנים; \"טקסט\" מוצג למשיבים."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "הגדרה זו משנה את גודל שדה הקלט בלבד ואינה משפיעה על רוחב תיבת השאלה. כדי להגביל את אורך הקלט המקובל, עבור אל <b>אימות → מגבלת תווים מרבית</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "מגדיר את מספר השורות המוצגות בשדה הקלט. אם הקלט תופס שורות נוספות, פס הגלילה יופיע."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "בחר בין: \"ניתן לעריכה\" - מאפשר למשיבים למלא את הסקר שלך; \"לקריאה בלבד\" - משבית עריכת טפסים."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "מזהה עמודה שאינו גלוי למשיבים."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "כאשר אפשרות זו זמינה עבור עמודה, המשיב נדרש לספק תשובה ייחודית לכל שאלה בעמודה זו."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "מגדיר את מספר השורות המוצגות בשדה הקלט. אם הקלט תופס שורות נוספות, פס הגלילה יופיע."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי הקובע את נראות העמודה."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי שמשבית את מצב הקריאה בלבד עבור העמודה."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי המונע שליחת סקר, אלא אם לשאלה מקוננת אחת לפחות יש תשובה."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "כשבוחרים באפשרות זו, יוצר עמודה נפרדת לכל אחת מאפשרויות הבחירה."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "בחר מתוך: \"סטטי\" - קובע רוחב קבוע; \"מגיב\" - עושה את הסקר לתפוס את מלוא רוחב המסך; \"אוטומטי\" - חל על כל אחד מהשניים בהתאם לסוגי השאלות המשמשים."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "הדבק קישור לתמונה (ללא מגבלות גודל) או לחץ על סמל התיקייה כדי לעיין בקובץ מהמחשב שלך (עד 64KB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "הגדרת רוחב לוגו ביחידות CSS (px, %, in, pt וכו')."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "הגדרת גובה סמל ביחידות CSS (px, %, in, pt וכו')."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "בחר מתוך: \"ללא\" - התמונה שומרת על גודלה המקורי; \"להכיל\" - גודל התמונה משתנה כדי להתאים תוך שמירה על יחס גובה-רוחב שלה; \"כיסוי\" - התמונה ממלאת את התיבה כולה תוך שמירה על יחס הגובה-רוחב שלה; \"מילוי\" - התמונה נמתחת כדי למלא את התיבה מבלי לשמור על יחס הגובה-רוחב שלה."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "בחר אם ברצונך שהסקר יתקדם לדף הבא באופן אוטומטי לאחר שמשיב יענה על כל השאלות בדף הנוכחי."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "מגדיר את התצוגה והמיקום של לחצני ניווט בעמוד."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "הגדרת הניראות והמיקום של מד התקדמות. הערך \"אוטומטי\" מציג את מד ההתקדמות מעל או מתחת לכותרת הסקר."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "הפעל את דף התצוגה המקדימה עם כל השאלות או שאלות שנענו בלבד."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "חל על כל השאלות בסקר. ניתן לדרוס הגדרה זו באמצעות כללי יישור כותרות ברמות נמוכות יותר: חלונית, עמוד או שאלה. הגדרה ברמה נמוכה יותר תעקוף את אלה ברמה גבוהה יותר."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "סמל או רצף של סמלים המציינים כי נדרשת תשובה."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "הזן מספר או אות שבאמצעותם ברצונך להתחיל במספור."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "הגדרת המיקום של הודעת שגיאה ביחס לשאלה עם קלט לא חוקי. בחר בין: \"למעלה\" - טקסט שגיאה ממוקם בחלק העליון של תיבת השאלה; \"תחתית\" - טקסט שגיאה ממוקם בחלק התחתון של תיבת השאלה."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "בחר אם ברצונך ששדה הקלט הראשון בכל עמוד יהיה מוכן להזנת טקסט."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "שומר על הסדר המקורי של השאלות או מסדר אותן באופן אקראי. ההשפעה של הגדרה זו גלויה רק בכרטיסיה תצוגה מקדימה."
// pehelp.maxTextLength: "For text entry questions only." => "לשאלות הזנת טקסט בלבד."
// pehelp.maxOthersLength: "For question comments only." => "להערות לשאלה בלבד."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "בחר אם ברצונך שהערות שאלה ושאלות טקסט ארוך יגדלו באופן אוטומטי לגובה בהתבסס על אורך הטקסט שהוזנו."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "להערות לשאלות ולשאלות טקסט ארוך בלבד."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "משתנים מותאמים אישית משמשים כמשתני ביניים או משתני עזר המשמשים בחישובי טפסים. הם לוקחים תשומות משיבים כערכי מקור. לכל משתנה מותאם אישית יש שם ייחודי וביטוי שעליו הוא מבוסס."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "בחר אם ברצונך לשמור את הערך המחושב של הביטוי יחד עם תוצאות הסקר."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "גורם מפעיל הוא אירוע או תנאי המבוסס על ביטוי. לאחר הערכת הביטוי כ- \"true\", גורם מפעיל מגדיר פעולה. לפעולה כזו יכולה להיות שאלת יעד שהיא משפיעה עליה."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "בחר אם לנקות ערכים עבור שאלות המוסתרות על-ידי לוגיקה מותנית ומתי לעשות זאת."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "בחר מתוך: \"על מיקוד אבוד\" - הערך מתעדכן כאשר שדה הקלט מאבד את המיקוד; \"בעת הקלדה\" - הערך מתעדכן בזמן אמת, כאשר המשתמשים מקלידים."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "הערך השמאלי משמש כמזהה עמודה המשמש בכללי תנאי, הערך הימני מוצג למשיבים."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "הערך השמאלי משמש כמזהה שורה המשמש בכללי תנאי, הערך הימני מוצג למשיבים."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "מקבל ערכי CSS (px, %, in, pt וכו')."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "מקבל ערכי CSS (px, %, in, pt וכו')."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "הגדרת המיקום של הודעת שגיאה ביחס לתא עם קלט לא חוקי. האפשרות \"ירושה\" מחילה את ההגדרה מהמאפיין \"יישור הודעת שגיאה\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "כאשר המאפיין \"מנע תגובות כפולות\" מופעל, משיב שינסה לשלוח ערך כפול יקבל את הודעת השגיאה הבאה."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "מאפשר לחשב ערכים כוללים בהתבסס על ביטוי. הביטוי יכול לכלול חישובים בסיסיים ('{q1_id} + {q2_id}'), ביטויים בוליאניים ('{age} > 60') ופונקציות ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' וכו')."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "מפעיל בקשה המבקשת לאשר את מחיקת השורות."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "משכפל תשובות מהשורה האחרונה ומקצה אותן לשורה הדינמית הבאה שנוספה."
// pehelp.description: "Type a subtitle." => "הקלד כותרת משנה."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "בחר שפה כדי להתחיל ליצור את הסקר. כדי להוסיף תרגום, עבור לשפה חדשה ותרגם את הטקסט המקורי כאן או בכרטיסיה תרגומים."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "הגדרת המיקום של מקטע פרטים ביחס לשורה. בחר מתוך: \"ללא\" - לא נוספה הרחבה; \"מתחת לשורה\" - הרחבת שורה ממוקמת מתחת לכל שורה של המטריצה; \"מתחת לשורה, הצג הרחבת שורה אחת בלבד\" - הרחבה מוצגת תחת שורה אחת בלבד, הרחבות השורה הנותרות מכווצות."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "בחר מתוך: \"ללא\" - התמונה שומרת על גודלה המקורי; \"להכיל\" - גודל התמונה משתנה כדי להתאים תוך שמירה על יחס גובה-רוחב שלה; \"כיסוי\" - התמונה ממלאת את התיבה כולה תוך שמירה על יחס הגובה-רוחב שלה; \"מילוי\" - התמונה נמתחת כדי למלא את התיבה מבלי לשמור על יחס הגובה-רוחב שלה."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "מגדיל בהדרגה את גובה שדה הקלט בעת הזנת הנתונים. דורס את ההגדרה \"גובה שדה קלט (בקווים)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "נקודת האחיזה לשינוי גודל (או נקודת האחיזה) מופיעה בפינה וניתן לגרור אותה כדי לשנות את גודל שדה הקלט."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "מרווח זמן בשניות שלאחריו הסקר מתקדם אוטומטית לדף התודה."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "מרווח זמן בשניות שלאחריו הסקר מתקדם אוטומטית לעמוד הבא."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "מרווח זמן בשניות שלאחריו הסקר מתקדם אוטומטית לעמוד הבא."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי הקובע את תצוגת העמוד."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי שמשבית את מצב הקריאה בלבד של העמוד."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "השתמש בסמל מטה הקסם כדי להגדיר כלל תנאי המונע שליחת סקר, אלא אם לשאלה מקוננת אחת לפחות יש תשובה."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "חל על כל השאלות בדף זה. אם ברצונך לדרוס הגדרה זו, הגדר כללי יישור כותרת לשאלות או חלוניות בודדות. האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר (\"למעלה\" כברירת מחדל)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "הגדרת המיקום של הודעת שגיאה ביחס לשאלה עם קלט לא חוקי. בחר בין: \"למעלה\" - טקסט שגיאה ממוקם בחלק העליון של תיבת השאלה; \"תחתית\" - טקסט שגיאה ממוקם בחלק התחתון של תיבת השאלה. האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר (\"למעלה\" כברירת מחדל)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "שומר על הסדר המקורי של השאלות או מסדר אותן באופן אקראי. האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר (\"מקורי\" כברירת מחדל). ההשפעה של הגדרה זו גלויה רק בכרטיסיה תצוגה מקדימה."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "מגדיר את התצוגה של לחצני ניווט בעמוד. האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר, המוגדרת כברירת מחדל ל\"גלוי\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "מגדיר את הניראות והמיקום של טיימר בדף."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "בחר מתוך: \"נעול\" - משתמשים אינם יכולים להרחיב או לכווץ חלוניות; \"כווץ הכל\" - כל הלוחות מתחילים במצב מכווץ; \"הרחב הכל\" - כל הלוחות מתחילים במצב מורחב; \"מורחב ראשון\" - רק הלוח הראשון מורחב בתחילה."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "הזן שם מאפיין משותף בתוך מערך האובייקטים המכיל את כתובות ה- URL של תמונות או קבצי וידאו שברצונך להציג ברשימת האפשרויות."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "הערך השמאלי משמש כמזהה פריט המשמש בכללי תנאי, הערך הימני מוצג למשיבים."
// pehelp.title: "Type a user-friendly title to display." => "הקלד כותרת ידידותית למשתמש להצגה."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "מבטיח שמשתמשים לא ישלימו את הסקר עד להעלאת קבצים."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "מקבל ערכי CSS (px, %, in, pt וכו')."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "מקבל ערכי CSS (px, %, in, pt וכו')."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "מקבל ערכי CSS (px, %, in, pt וכו')."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "בסוגי שאלות של בחירה בודדת ושאלות מרובות, לכל אפשרות בחירה יש מזהה וערך תצוגה. כשבוחרים באפשרות זו, הגדרה זו מציגה ערך תצוגה במקום ערך מזהה בשאלות HTML ובכותרות דינמיות ובתיאורים של רכיבי סקר."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "בחר אם לנקות או לא לנקות ערכי שאלות המוסתרים על-ידי לוגיקה מותנית ומתי לעשות זאת. האפשרות \"ירושה\" מחילה את ההגדרה ברמת הסקר (\"עם השלמת הסקר\" כברירת מחדל)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "בחר מתוך: \"הכל\" - מעתיק את כל אפשרויות הבחירה מהשאלה שנבחרה; \"נבחר\" - מעתיק באופן דינמי רק אפשרויות בחירה שנבחרו; \"לא נבחר\" - מעתיק באופן דינמי רק אפשרויות בחירה שלא נבחרו. האפשרויות \"ללא\" ו\"אחר\" מועתקות כברירת מחדל אם הן מופעלות בשאלת המקור."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "כשבוחרים באפשרות זו, משתמשים יכולים לכלול קלט נוסף בתיבת הערות נפרדת."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "מציג כל אפשרות בחירה מיוחדת (\"ללא\", \"אחר\", \"בחר הכל\") בשורה חדשה, גם בשעת שימוש בפריסה מרובת עמודות."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "ציין את המיקום בתוך ערכת נתוני השירות שבו ממוקם מערך האובייקטים המשמש כיעד. השאר ריק אם כתובת ה- URL כבר מצביעה על המערך."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "הזן שם מאפיין אחיד במערך האובייקטים הכולל את הערכים שברצונך להציג ברשימת הבחירה."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "בחר כדי לאפשר לשירות להחזיר תגובה או מערך ריקים."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "השתמש בסמל מטה הקסם כדי להגדיר כלל מותנה הקובע את התצוגה של כל אפשרויות הבחירה."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "הערך השמאלי משמש כמזהה פריט המשמש בכללי תנאי, הערך הימני מוצג למשיבים."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"אוטומטי\" בוחר בין המצבים \"לחצנים\" ו \"נפתח\" מבוסס על הרוחב הזמין. כאשר הרוחב אינו מספיק להצגת לחצנים, השאלה מציגה רשימה נפתחת."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "מאפשר לך לחבר שאלות המייצרות תוצאות בפורמטים שונים. כאשר שאלות כאלה מקושרות יחד באמצעות מזהה צירוף, מאפיין משותף זה מאחסן ערכי שאלות נבחרים."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "בחר אם ברצונך לעדכן את תוכן התפריט הנפתח כך שיתאים לשאילתת החיפוש שמשתמש מקליד בשדה הקלט."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "ערך שיש לשמור בתוצאות הסקר כאשר המשיבים נותנים תשובה חיובית."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "ערך שיש לשמור בתוצאות הסקר כאשר המשיבים נותנים תשובה שלילית."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "לא מומלץ להפוך אפשרות זו ללא זמינה מכיוון שהיא דורסת את תמונת התצוגה המקדימה ומקשה על המשתמש להבין אם הקבצים הועלו."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "מפעיל בקשה המבקשת לאשר את מחיקת הקובץ."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "אפשר לדרג רק בחירות נבחרות. המשתמשים יגררו פריטים נבחרים מרשימת האפשרויות כדי לסדר אותם באזור הדירוג."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "הזן רשימה של אפשרויות שיוצעו למשיב במהלך הקלט."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "ההגדרה משנה את גודל שדות הקלט בלבד ואינה משפיעה על רוחב תיבת השאלה."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "קובע רוחב עקבי לכל תוויות הפריטים בפיקסלים"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "האפשרות \"אוטומטי\" קובעת אוטומטית את המצב המתאים לתצוגה - תמונה, וידאו או YouTube - בהתבסס על כתובת האתר המקורית שסופקה."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "משמש כתחליף כאשר לא ניתן להציג את התמונה במכשיר המשתמש ולמטרות נגישות."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "מגדיר את צבע האמוג'י שנבחר כשסוג סמל הדירוג מוגדר ל\"סמיילי\". בחר בין: \"ברירת מחדל\" - האמוג'י שנבחר מופיע בצבע סקר ברירת מחדל; \"קנה מידה\" - האמוג'י שנבחר יורש צבע מסולם הדירוג."
// expression.name: "An expression ID that is not visible to respondents." => "מזהה ביטוי שאינו גלוי למשיבים."
// expression.description: "Type an expression subtitle." => "הקלד כותרת משנה של ביטוי."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "ביטוי יכול לכלול חישובים בסיסיים ('{q1_id} + {q2_id}'), תנאים ('{age} > 60') ופונקציות ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' וכו')."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "בחר כדי לאחסן את ערך האפשרות \"אחר\" כמאפיין נפרד בתוצאות הסקר."
// p.swapOrder: "Swap the order of Yes and No" => "החלפת הסדר של כן ולא"
// p.itemTitleWidth: "Item label width (in px)" => "רוחב תווית פריט (בפיקסלים)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "טקסט שיציג אם כל האפשרויות נבחרו"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "טקסט מציין מיקום עבור אזור הדירוג"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "השלם את הסקר באופן אוטומטי"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "בחר אם ברצונך שהסקר יושלם באופן אוטומטי לאחר שמשיב עונה על כל השאלות."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "שמירת ערך מוסווה בתוצאות הסקר"
// patternmask.pattern: "Value pattern" => "תבנית ערך"
// datetimemask.min: "Minimum value" => "ערך מינימלי"
// datetimemask.max: "Maximum value" => "ערך מרבי"
// numericmask.allowNegativeValues: "Allow negative values" => "התרת ערכים שליליים"
// numericmask.thousandsSeparator: "Thousands separator" => "מפריד אלפים"
// numericmask.decimalSeparator: "Decimal separator" => "מפריד עשרוני"
// numericmask.precision: "Value precision" => "דיוק ערך"
// numericmask.min: "Minimum value" => "ערך מינימלי"
// numericmask.max: "Maximum value" => "ערך מרבי"
// currencymask.prefix: "Currency prefix" => "קידומת מטבע"
// currencymask.suffix: "Currency suffix" => "סיומת מטבע"
// pe.maskType: "Input mask type" => "סוג מסיכת קלט"
// maskTypes.patternmask: "Pattern" => "תבנית"
// maskTypes.numericmask: "Numeric" => "מספריים"
// maskTypes.datetimemask: "Date and Time" => "תאריך ושעה"
// maskTypes.currencymask: "Currency" => "מטבע"
// tabs.mask: "Input Mask Settings" => "הגדרות מסיכת קלט"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "לדוגמה: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "לדוגמה: mm/dd/yyyy"
// pe.currencyprefix_placeholder: "Ex.: $" => "לדוגמה: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "לדוגמה: USD"
// pv.textWrapEnabled: "Wrap choices" => "אפשרויות גלישה"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "טקסטים ארוכים באפשרויות בחירה ייצרו באופן אוטומטי מעברי שורה שיתאימו לתפריט הנפתח. בטל את הבחירה אם ברצונך שהטקסטים ייחתכו."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "בחר אם ברצונך לאחסן את ערך השאלה עם מסיכה שהוחלה בתוצאות הסקר."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "התבנית יכולה להכיל מילולי מחרוזת ואת מצייני המיקום הבאים: '9' - עבור ספרה; 'a' - עבור אות גדולה או קטנה; '#' - עבור ספרה או אות גדולה או קטנה. השתמש בקו נטוי הפוך '\\' כדי לברוח מתו."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "התבנית יכולה להכיל תווים מפרידים ואת מצייני המיקום הבאים: 'm' - עבור מספר חודש; 'mm' - עבור מספר חודש, עם אפס מוביל עבור ערכים חד-ספרתיים; 'ד' - ליום בחודש; 'dd' - עבור יום בחודש, עם אפס מוביל עבור ערכים חד-ספרתיים; 'yy' - עבור שתי הספרות האחרונות של השנה; 'yyyy' - לשנה בת ארבע ספרות."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "סמל המשמש להפרדת חלק השבר מהחלק השלם של מספר מוצג."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "סמל המשמש להפרדת הספרות של מספר גדול לקבוצות של שלושה."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "מגביל את מספר הספרות שיש לשמור אחרי הנקודה העשרונית עבור מספר מוצג."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "סימן אחד או יותר שיוצגו לפני הערך."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "סימן אחד או יותר שיוצגו לאחר הערך."
// ed.translationSource: "Source: " => "מקור: "
// ed.translationTarget: "Target: " => "יעד: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "הדף ריק. גרור רכיב מארגז הכלים או לחץ על הלחצן למטה."
// maskTypes.none: "None" => "ללא"
// itemvalue@rows.visibleIf: "Make the row visible if" => "הפיכת השורה לגלויה אם"
// itemvalue@rows.enableIf: "Make the row editable if" => "הפיכת השורה לניתנת לעריכה אם"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "טקסט מציין מיקום במצב קריאה בלבד או תצוגה מקדימה"
// pe.textWrapEnabled: "Wrap choices" => "אפשרויות גלישה"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "האפשרות \"אוטומטי\" קובעת אוטומטית את המצב המתאים לתצוגה - תמונה, וידאו או YouTube - בהתבסס על כתובת האתר המקורית שסופקה."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "בחר בין \"תמונה\" ו\"וידאו\" כדי להגדיר את מצב התוכן של בורר המדיה. אם נבחרה האפשרות \"תמונה\", ודא שכל האפשרויות שסופקו הן קובצי תמונה בתבניות הבאות: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. באופן דומה, אם נבחר \"וידאו\", ודא שכל האפשרויות הן קישורים ישירים לקבצי וידאו בפורמטים הבאים: MP4, MOV, WMV, FLV, AVI, MKV. שים לב שקישורי YouTube אינם נתמכים עבור אפשרויות וידאו."
// ed.selectFile: "Select a file" => "בחר קובץ"
// ed.removeFile: "Remove the file" => "הסרת הקובץ"
// pe.searchMode: "Search Mode" => "מצב חיפוש"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "לחץ על הלחצן \"הוסף שאלה\" למטה כדי להתחיל ליצור את הטופס שלך."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "לחץ על כפתור \"הוסף שאלה\" למטה כדי להוסיף אלמנט חדש לדף."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "לחץ על הלחצן \"הוסף שאלה\" למטה כדי להוסיף אלמנט חדש לחלונית."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "לחץ על הלחצן למטה ובחר תמונה להעלאה"
// coloralpha.opacity: "Opacity" => "אטימות"
// font.family: "Font family" => "משפחת גופנים"
// font.color: "Color" => "צבע"
// font.placeholderColor: "Placeholder color" => "צבע מציין מיקום"
// font.size: "Size" => "גודל"
// theme.themeName: "Theme" => "ערכת נושא"
// theme.isPanelless: "Question appearance" => "מראה השאלה"
// theme.editorPanel: "Background and corner radius" => "רקע ורדיוס פינה"
// theme.questionPanel: "Background and corner radius" => "רקע ורדיוס פינה"
// theme.primaryColor: "Accent color" => "צבע הדגשה"
// theme.panelBackgroundTransparency: "Panel background opacity" => "אטימות רקע של החלונית"
// theme.questionBackgroundTransparency: "Question background opacity" => "אטימות רקע השאלה"
// theme.fontSize: "Font size" => "גודל גופן"
// theme.scale: "Scale" => "סולם"
// theme.cornerRadius: "Corner radius" => "רדיוס פינה"
// theme.pageTitle: "Title font" => "גופן כותרת"
// theme.pageDescription: "Description font" => "גופן תיאור"
// theme.questionTitle: "Title font" => "גופן כותרת"
// theme.questionDescription: "Description font" => "גופן תיאור"
// theme.editorFont: "Font" => "גופן"
// theme.backgroundOpacity: "Opacity" => "אטימות"
// theme.--sjs-font-family: "Font family" => "משפחת גופנים"
// theme.--sjs-general-backcolor-dim: "Background color" => "צבע רקע"
// theme.--sjs-primary-backcolor: "Accent background" => "רקע הדגשה"
// theme.--sjs-primary-forecolor: "Accent foreground" => "הדגשת החזית"
// theme.--sjs-shadow-small: "Shadow effects" => "אפקטי צל"
// theme.--sjs-shadow-inner: "Shadow effects" => "אפקטי צל"
// theme.--sjs-border-default: "Colors" => "צבעים"
// header@header.headerView: "View" => "נוף"
// header@header.logoPosition: "Logo position" => "מיקום הלוגו"
// header@header.surveyTitle: "Survey title font" => "גופן כותרת סקר"
// header@header.surveyDescription: "Survey description font" => "גופן תיאור סקר"
// header@header.headerTitle: "Survey title font" => "גופן כותרת סקר"
// header@header.headerDescription: "Survey description font" => "גופן תיאור סקר"
// header@header.inheritWidthFrom: "Content area width" => "רוחב אזור תוכן"
// header@header.textAreaWidth: "Text width" => "רוחב טקסט"
// header@header.backgroundColorSwitch: "Background color" => "צבע רקע"
// header@header.backgroundImage: "Background image" => "תמונת רקע"
// header@header.backgroundImageOpacity: "Opacity" => "אטימות"
// header@header.overlapEnabled: "Overlap" => "חופפים"
// header@header.logoPositionX: "Logo position" => "מיקום הלוגו"
// header@header.titlePositionX: "Title position" => "מיקום בתפקיד"
// header@header.descriptionPositionX: "Description position" => "תיאור מיקום"
// weight.400: "Regular" => "רגיל"
// weight.600: "Heavy" => "כבד"
// weight.700: "Semi-bold" => "חצי נועז"
// weight.800: "Bold" => "נועז"
// backgroundImageFit.auto: "Auto" => "אוטומטי"
// backgroundImageFit.cover: "Cover" => "כריכה"
// backgroundImageFit.contain: "Contain" => "להכיל"
// backgroundImageFit.fill: "Stretch" => "מתיחה"
// backgroundImageFit.tile: "Tile" => "אריח"
// backgroundImageAttachment.fixed: "Fixed" => "קבוע"
// backgroundImageAttachment.scroll: "Scroll" => "לגלול"
// headerView.basic: "Basic" => "בסיסי"
// headerView.advanced: "Advanced" => "מתקדמים"
// inheritWidthFrom.survey: "Same as survey" => "זהה לסקר"
// inheritWidthFrom.container: "Fit to container" => "התאמה למיכל"
// backgroundColorSwitch.none: "None" => "ללא"
// backgroundColorSwitch.accentColor: "Accent color" => "צבע הדגשה"
// backgroundColorSwitch.custom: "Custom" => "מנהג"
// colorPalette.light: "Light" => "אור"
// colorPalette.dark: "Dark" => "חשוך"
// isPanelless.false: "Default" => "ברירת מחדל"
// isPanelless.true: "Without Panels" => "ללא פאנלים"
// theme.cornerRadius: "Corner radius" => "רדיוס פינה"
// theme.fontFamily: "Font family" => "משפחת גופנים"
// theme.fontWeightRegular: "Regular" => "רגיל"
// theme.fontWeightHeavy: "Heavy" => "כבד"
// theme.fontWeightSemiBold: "Semi-bold" => "חצי נועז"
// theme.fontWeightBold: "Bold" => "נועז"
// theme.color: "Color" => "צבע"
// theme.placeholderColor: "Placeholder color" => "צבע מציין מיקום"
// theme.size: "Size" => "גודל"
// theme.opacity: "Opacity" => "אטימות"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "הקלד כדי לחפש..."
// ed.toolboxNoResultsFound: "No results found" => "לא נמצאו תוצאות"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "מציין מיקום של כותרת טאב"
// theme.--sjs-special-red: "Error messages" => "הודעות שגיאה"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "טקסט נסיגה עבור כותרות טאבים שחל כאשר תבנית כותרת הטאב אינה מפיקה ערך בעל משמעות."
// theme.fontColor: "Font color" => "צבע גופן"
// theme.backgroundColor: "Background color" => "צבע רקע"
// pe.questionTitleWidth: "Question title width" => "רוחב כותרת השאלה"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "בחר קובץ או הדבק קישור לקובץ..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "לדוגמה: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "הגדרת רוחב עקבי לכותרות שאלות כאשר הן מיושרות משמאל לתיבות השאלות. מקבל ערכי CSS (px, %, in, pt וכו')."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "הגדרת רוחב עקבי לכותרות שאלות כאשר הן מיושרות משמאל לתיבות השאלות. מקבל ערכי CSS (px, %, in, pt וכו')."
// pe.commentAreaRows: "Comment area height (in lines)" => "גובה אזור הערה (בשורות)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "מגדיר את מספר השורות המוצגות באזורי טקסט להערות שאלה. בקלט תופס יותר שורות, פס הגלילה מופיע."


/***/ }),

/***/ "./src/localization/hungarian.ts":
/*!***************************************!*\
  !*** ./src/localization/hungarian.ts ***!
  \***************************************/
/*! exports provided: huStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "huStrings", function() { return huStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var huStrings = {
    // survey templates
    survey: {
        edit: "Szerkesztés",
        externalHelpLink: "Nézze meg, hogyan kell kérdőíveket készíteni.",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Kérem dobjon ide egy kérdést a bal oldali menüből.",
        addLogicItem: "Hozzon létre egy szabályt a felmérés folyamatának testreszabásához.",
        copy: "Másolás",
        duplicate: "Ismétlődő",
        addToToolbox: "Hozzáadás az eszköztárhoz",
        deletePanel: "Panel eltávolítása",
        deleteQuestion: "Kérdés eltávolítása",
        convertTo: "Konvertálás",
        drag: "Elem mozgatása",
    },
    // Creator tabs
    tabs: {
        preview: "Próba",
        theme: "Témák",
        translation: "Fordítás",
        designer: "Kérdőívtervező",
        editor: "JSON szerkesztő",
        logic: "Logika"
    },
    // Question types
    qt: {
        default: "Alapértelmezett",
        checkbox: "Jelölőnégyzet",
        comment: "Megjegyzés",
        imagepicker: "Képválasztó",
        ranking: "Rangú",
        image: "Kép",
        dropdown: "Legördülő",
        tagbox: "Többszörös kijelölés legördülő menü",
        file: "Állomány",
        html: "HTML",
        matrix: "Mátrix (egyválasztós)",
        matrixdropdown: "Mátrix (többválasztós)",
        matrixdynamic: "Mátrix (dinamikus)",
        multipletext: "Többsoros szöveg",
        panel: "Panel",
        paneldynamic: "Panel (dinamikus)",
        radiogroup: "Választógomb",
        rating: "Értékelés",
        text: "Egysoros szöveg",
        boolean: "Igaz-hamis",
        expression: "Kifejezés (csak olvasható)",
        signaturepad: "Aláírás",
        buttongroup: "Gombcsoport"
    },
    toolboxCategories: {
        general: "Általános",
        choice: "Választási kérdések",
        text: "Szövegbeviteli kérdések",
        containers: "Konténerek",
        matrix: "Mátrix kérdések",
        misc: "Misc"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Alapértelmezett ({0})",
        survey: "Kérdőív",
        settings: "Kérdőívbeállítások",
        settingsTooltip: "Nyissa meg a beállításokat",
        surveySettings: "Földmérési beállítások",
        surveySettingsTooltip: "Földmérési beállítások",
        themeSettings: "Téma beállítások",
        themeSettingsTooltip: "Téma beállításai",
        showPanel: "Panel megjelenítése",
        hidePanel: "Panel elrejtése",
        prevSelected: "Előző kiválasztása",
        nextSelected: "Válassza a következőt",
        prevFocus: "Fókusz előző",
        nextFocus: "Fókusz következő",
        surveyTypeName: "Felmérés",
        pageTypeName: "Oldal",
        panelTypeName: "Panel",
        questionTypeName: "Kérdés",
        columnTypeName: "Oszlop",
        addNewPage: "Új lap felvétele",
        moveRight: "Görgetés jobbra",
        moveLeft: "Görgetés balra",
        deletePage: "Lap eltávolítása",
        editPage: "Lap szerkesztése",
        edit: "Szerkesztés",
        newPageName: "lap",
        newQuestionName: "kérdés",
        newPanelName: "panel",
        newTextItemName: "szöveg",
        defaultV2Theme: "Alapértelmezett",
        modernTheme: "Modern",
        defaultTheme: "Alapértelmezett (örökölt)",
        testSurveyAgain: "Próba ismét",
        testSurveyWidth: "Kérdőív szélessége: ",
        navigateToMsg: "Navigálnia kellett",
        saveSurvey: "Kérdőív mentése",
        saveSurveyTooltip: "Felmérés mentése",
        saveTheme: "Téma mentése",
        saveThemeTooltip: "Téma mentése",
        jsonHideErrors: "Hibák elrejtése",
        jsonShowErrors: "Hibák megjelenítése",
        undo: "Mégse",
        redo: "Ismét",
        undoTooltip: "Utolsó módosítás visszavonása",
        redoTooltip: "Ismételje meg a módosítást",
        showMoreChoices: "Bővebben",
        showLessChoices: "Rövidebben",
        copy: "Másolat",
        cut: "Vág",
        paste: "Paszta",
        copyTooltip: "Kijelölés másolása a vágólapra",
        cutTooltip: "Kijelölés kivágása a vágólapra",
        pasteTooltip: "Beillesztés vágólapról",
        options: "Beállítások",
        generateValidJSON: "Érvényes JSON generálása",
        generateReadableJSON: "Olvasható JSON generálása",
        toolbox: "Eszköztár",
        "property-grid": "Kellékek",
        toolboxFilteredTextPlaceholder: "Írja be a kereséshez...",
        toolboxNoResultsFound: "Nincs találat",
        propertyGridFilteredTextPlaceholder: "Írja be a kereséshez...",
        propertyGridNoResultsFound: "Nincs találat",
        correctJSON: "Kérem javítsa a JSON-t.",
        surveyResults: "Kérdőív eredménye: ",
        surveyResultsTable: "Táblaként",
        surveyResultsJson: "JSON-ként",
        resultsTitle: "Kérdés címe",
        resultsName: "Kérdés megnevezése",
        resultsValue: "Válasz értéke",
        resultsDisplayValue: "Kijelzett értéke",
        modified: "Módosított",
        saving: "Mentés folyamatban",
        saved: "Mentve",
        propertyEditorError: "Hiba",
        saveError: "Hiba! A szerkesztő értéke nem került mentésre.",
        translationPropertyGridTitle: "Nyelvi beállítások",
        themePropertyGridTitle: "Téma beállítások",
        translationLanguages: "Nyelvek",
        translationDeleteLanguage: "Biztos benne, hogy törölni szeretné az összes karakterláncot ehhez a nyelvhez?",
        translationAddLanguage: "Válasszon egy nyelvet a fordításhoz.",
        translationShowAllStrings: "Összes szöveg mutatása",
        translationShowUsedStringsOnly: "Csak használt karakterláncok",
        translationShowAllPages: "Összes lap mutatása",
        translationNoStrings: "Nincs fordítható szöveg. Kérem változtasson a szűrési feltételeken.",
        translationExportToSCVButton: "Mentés CSV-ként",
        translationImportFromSCVButton: "Betöltés CSV-ből.",
        translateUsigAI: "Összes automatikus fordítása",
        translateUsigAIFrom: "Fordítás: ",
        translationDialogTitle: "Lefordítatlan karakterláncok",
        translationMergeLocaleWithDefault: "{0} összefűzése az alapértelmezett szöveggel.",
        translationPlaceHolder: "Fordítás...",
        translationSource: "Forrás: ",
        translationTarget: "Cél: ",
        themeExportButton: "Kivitel",
        themeImportButton: "Importál",
        surveyJsonExportButton: "Kivitel",
        surveyJsonImportButton: "Importál",
        surveyJsonCopyButton: "Másolás a vágólapra",
        themeResetButton: "Témabeállítások visszaállítása alapértelmezettre",
        themeResetConfirmation: "Tényleg vissza akarja állítani a témát? Az összes testreszabás elvész.",
        themeResetConfirmationOk: "Igen, állítsa vissza a témát",
        bold: "Félkövér",
        italic: "Dőlt",
        underline: "Aláhúzott",
        addNewQuestion: "Kérdés felvétele",
        selectPage: "Válasszon oldalt...",
        carryForwardChoicesCopied: "A választási lehetőségek másolása innen történik",
        choicesLoadedFromWebText: "A választási lehetőségek egy webszolgáltatásból töltődnek be.",
        choicesLoadedFromWebLinkText: "Válassza a beállítások",
        choicesLoadedFromWebPreviewTitle: "A betöltött választási lehetőségek előnézete",
        htmlPlaceHolder: "A HTML tartalom itt lesz.",
        panelPlaceHolder: "Itt dobjon el egy kérdést az eszköztárból.",
        surveyPlaceHolder: "A felmérés üres. Húzzon egy elemet az eszköztárról, vagy kattintson az alábbi gombra.",
        pagePlaceHolder: "Az oldal üres. Húzzon egy elemet az eszköztárról, vagy kattintson az alábbi gombra.",
        imagePlaceHolder: "Húzzon ide egy képet, vagy kattintson az alábbi gombra, és válassza ki a feltölteni kívánt képet",
        surveyPlaceHolderMobile: "Kattintson az alábbi \"Kérdés hozzáadása\" gombra az űrlap létrehozásának megkezdéséhez.",
        pagePlaceHolderMobile: "Kattintson az alábbi \"Kérdés hozzáadása\" gombra, hogy új elemet adjon az oldalhoz.",
        panelPlaceHolderMobile: "Kattintson az alábbi \"Kérdés hozzáadása\" gombra, hogy új elemet adjon a panelhez.",
        imagePlaceHolderMobile: "Kattintson az alábbi gombra, és válassza ki a feltölteni kívánt képet",
        imageChooseImage: "Válassza a Kép lehetőséget",
        addNewTypeQuestion: "{0} hozzáadása",
        chooseLogoPlaceholder: "[LOGÓ]",
        choices_Item: "Cikk ",
        selectFile: "Válasszon ki egy fájlt",
        removeFile: "A fájl eltávolítása",
        lg: {
            addNewItem: "Új szabály hozzáadása",
            empty_tab: "Hozzon létre egy szabályt a felmérés folyamatának testreszabásához.",
            page_visibilityName: "Oldal megjelenítése (elrejtése)",
            page_enableName: "Oldal engedélyezése (letiltása)",
            page_requireName: "Az oldal kötelezővé tétele",
            panel_visibilityName: "Panel megjelenítése (elrejtése)",
            panel_enableName: "Panel engedélyezése (letiltása)",
            panel_requireName: "Az oldal kötelezővé tétele",
            question_visibilityName: "Kérdés megjelenítése (elrejtése)",
            question_enableName: "Kérdés engedélyezése (letiltása)",
            question_requireName: "Kérdés feltevése kötelező",
            question_resetValueName: "Kérdés értékének visszaállítása",
            question_setValueName: "Kérdésérték beállítása",
            column_visibilityName: "Oszlop megjelenítése (elrejtése)",
            column_enableName: "Oszlop engedélyezése (letiltása)",
            column_requireName: "Oszlop kötelezővé tétele",
            column_resetValueName: "Oszlopérték visszaállítása",
            column_setValueName: "Oszlopérték beállítása",
            trigger_completeName: "Teljes felmérés",
            trigger_setvalueName: "Válasz beállítása",
            trigger_copyvalueName: "Válasz másolása",
            trigger_skipName: "Ugrás a kérdésre",
            trigger_runExpressionName: "Kifejezés futtatása",
            completedHtmlOnConditionName: "A \"Felmérés kész\" oldaljelölés beállítása",
            page_visibilityDescription: "Tegye láthatóvá az oldalt, ha a logikai kifejezés igaz értéket ad vissza. Ellenkező esetben tartsa láthatatlanul.",
            panel_visibilityDescription: "Tegye láthatóvá a panelt, ha a logikai kifejezés igaz értéket ad vissza. Ellenkező esetben tartsa láthatatlanul.",
            panel_enableDescription: "Engedélyezze a panelt és a benne lévő összes elemet, ha a logikai kifejezés igaz értéket ad vissza. Ellenkező esetben tartsa őket letiltva.",
            question_visibilityDescription: "Tegye láthatóvá a kérdést, ha a logikai kifejezés igaz értéket ad vissza. Ellenkező esetben tartsa láthatatlanul.",
            question_enableDescription: "Engedélyezze a kérdést, ha a logikai kifejezés igaz értéket ad vissza. Ellenkező esetben tartsa letiltva.",
            question_requireDescription: "A kérdés akkor válik kötelezővé, ha a logikai kifejezés igaz értéket ad vissza.",
            trigger_completeDescription: "Amikor a logikai kifejezés igaz értéket ad vissza, a felmérés befejeződik, és a végfelhasználó a \"Köszönöm oldalt\" látja.",
            trigger_setvalueDescription: "Ha a logikai kifejezésben használt kérdésértékek megváltoznak, és a logikai kifejezés igaz értéket ad vissza, akkor az érték a kiválasztott kérdésre lesz beállítva.",
            trigger_copyvalueDescription: "Ha a logikai kifejezésben használt kérdésértékek megváltoznak, és a logikai kifejezés igaz értéket ad vissza, akkor az egyik kiválasztott kérdés értéke átmásolódik egy másik kijelölt kérdésbe.",
            trigger_skipDescription: "Ha a logikai kifejezés igaz értéket ad vissza, akkor a felmérés a kiválasztott kérdésre ugrik/fókuszál.",
            trigger_runExpressionDescription: "Ha a logikai kifejezés igaz értéket ad vissza, a rendszer végrehajtja az egyéni kifejezést. Ezt a kifejezéseredményt opcionálisan beállíthatja a kiválasztott kérdésbe",
            completedHtmlOnConditionDescription: "Ha a logikai kifejezés igaz értéket ad vissza, akkor a \"Köszönöm oldal\" alapértelmezett szövege a megadott szövegre változik.",
            itemExpressionText: "Amikor a kifejezés: \"{0}\" igaz értéket ad vissza",
            itemEmptyExpressionText: "Új szabály",
            page_visibilityText: "Az oldal {0} láthatóvá tétele",
            panel_visibilityText: "A panel {0} láthatóvá tétele",
            panel_enableText: "A panel {0} engedélyezése",
            question_visibilityText: "tegye láthatóvá a {0} kérdést",
            question_enableText: "Kérdés {0} engedélyezése",
            question_requireText: "Tegye fel a kérdést {0} szükséges",
            question_resetValueText: "Kérdés visszaállítási értéke: {0}",
            question_setValueText: "Érték hozzárendelése: {1} a kérdéshez: {0}",
            column_visibilityText: "A {1}. kérdés {0} oszlopának láthatóvá tétele",
            column_enableText: "A kérdés {0} oszlopának engedélyezése {1} engedélyezése",
            column_requireText: "Tegye kötelezővé a kérdés {0} oszlopát {1}",
            column_resetValueText: "Az oszlop cellaértékének visszaállítása: {0}",
            column_setValueText: "Cellaérték hozzárendelése: {1} oszlophoz: {0}",
            setValueExpressionPlaceholder: " Olyan kifejezés, amelynek eredménye a célkérdéshez lesz rendelve.",
            trigger_completeText: "A felmérés befejeződött",
            trigger_setvalueText: "Kérdéses érték: {0} érték {1}",
            trigger_setvalueEmptyText: "Egyértelmű kérdésérték: {0}",
            trigger_copyvalueText: "Másolás kérdésbe: {0} kérdés értéke {1}",
            trigger_skipText: "felmérés ugrás a kérdésre {0}",
            trigger_runExpressionText1: "Run kifejezés: '{0}'",
            trigger_runExpressionText2: " és megkérdőjelezi annak eredményét: {0}",
            completedHtmlOnConditionText: "egyéni szöveg megjelenítése a \"Köszönöm oldalhoz\".",
            showAllQuestions: "Minden kérdés",
            showAllActionTypes: "Minden művelettípus",
            conditions: "Állapot(ok)",
            actions: "Művelet(ek)",
            expressionEditorTitle: "Feltétel(ek) meghatározása",
            actionsEditorTitle: "Művelet(ek) meghatározása",
            deleteAction: "Művelet törlése",
            addNewAction: "Művelet hozzáadása",
            selectedActionCaption: "Válassza ki a műveletet...",
            expressionInvalid: "A logikai kifejezés üres vagy érvénytelen. Kérjük, javítsa ki.",
            noActionError: "Kérjük, adjon hozzá legalább egy műveletet.",
            actionInvalid: "Kérjük, javítsa ki a problémákat a művelet(ek)ben.",
            uncompletedRule_title: "A logikai szabályok hiányosak",
            uncompletedRule_text: "Nem teljesített néhány logikai szabályt. Ha most elhagyja a lapot, a módosítások elvesznek. Továbbra is el akarja hagyni a lapot a módosítások végrehajtása nélkül?",
            uncompletedRule_apply: "Igen",
            uncompletedRule_cancel: "Nem, szeretném kiegészíteni a szabályokat"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Panel neve",
            title: "Panel címe",
            description: "Panel leírása",
            visibleIf: "A panel láthatóvá tétele, ha",
            requiredIf: "Tegye szükségessé a panelt, ha",
            questionsOrder: "Kérdések sorrendje a panelen belül",
            page: "Szülőoldal",
            startWithNewLine: "A panel megjelenítése új sorban",
            state: "Panel összecsukási állapota",
            width: "Szövegközi panel szélessége",
            minWidth: "Minimális panelszélesség",
            maxWidth: "Maximális panelszélesség",
            showNumber: "Szám panelek"
        },
        paneldynamic: {
            name: "Panel neve",
            title: "Panel címe",
            description: "Panel leírása",
            visibleIf: "A panel láthatóvá tétele, ha",
            requiredIf: "Tegye szükségessé a panelt, ha",
            page: "A panel áthelyezése oldalra",
            startWithNewLine: "A panel megjelenítése új sorban",
            state: "Panel összecsukási állapota",
            width: "Szövegközi panel szélessége",
            minWidth: "Minimális panelszélesség",
            maxWidth: "Maximális panelszélesség",
            confirmDelete: "Panel törlésének megerősítése",
            templateDescription: "Panel leírási minta",
            templateTitle: "Panel címmintája",
            noEntriesText: "Üres panelszöveg",
            templateTabTitle: "Lapcím mintája",
            tabTitlePlaceholder: "Lapcím helyőrzője",
            templateVisibleIf: "Egy adott panel láthatóvá tétele, ha",
            hideNumber: "A panel számának elrejtése",
            titleLocation: "Panelcím igazítása",
            descriptionLocation: "Panel leírás igazítása",
            templateTitleLocation: "Kérdés címének igazítása",
            templateErrorLocation: "Hibaüzenetek igazítása",
            newPanelPosition: "Új panel helye",
            keyName: "Az ismétlődő válaszok elkerülése a következő kérdésben"
        },
        question: {
            name: "Kérdés neve",
            title: "Kérdés címe",
            description: "Kérdés leírása",
            visibleIf: "Tegye láthatóvá a kérdést, ha",
            requiredIf: "Tegye kötelezővé a kérdést, ha",
            page: "Szülőoldal",
            state: "Kérdésmező összecsukási állapota",
            hideNumber: "A kérdés számának elrejtése",
            titleLocation: "Kérdés címének igazítása",
            descriptionLocation: "Kérdés leírás igazítása",
            errorLocation: "Hibaüzenetek igazítása",
            indent: "A belső behúzás növelése",
            width: "Szövegközi kérdés szélessége",
            minWidth: "Minimális kérdésszélesség",
            maxWidth: "Maximális kérdésszélesség",
            textUpdateMode: "Beviteli mező értékének frissítése"
        },
        signaturepad: {
            signatureWidth: "Aláírási terület szélessége",
            signatureHeight: "Aláírási terület magassága",
            signatureAutoScaleEnabled: "Az aláírási terület automatikus méretezése",
            showPlaceholder: "A helyőrző megjelenítése",
            placeholder: "Helyőrző szöveg",
            placeholderReadOnly: "Helyőrző szöveg írásvédett vagy előnézeti módban",
            allowClear: "A Törlés gomb megjelenítése az aláírási területen belül",
            penMinWidth: "Tollszélesség minimális",
            penMaxWidth: "Maximális tollszélesség",
            penColor: "Körvonal színe"
        },
        comment: {
            rows: "Beviteli mező magassága (sorokban)"
        },
        showQuestionNumbers: "Kérdés számának mutatása",
        questionStartIndex: "Kérdés kezdőindexe (1, 2 vagy 'A', 'a')",
        expression: {
            name: "Kifejezés neve",
            title: "Kifejezés címe",
            description: "Kifejezés leírása",
            expression: "Kifejezés"
        },
        trigger: {
            expression: "Kifejezés"
        },
        calculatedvalue: {
            expression: "Kifejezés"
        },
        // survey templates
        survey: {
            title: "Cím",
            description: "A felmérés leírása"
        },
        page: {
            name: "Oldal neve",
            title: "Cím",
            description: "Oldal leírása",
            visibleIf: "Tegye láthatóvá az oldalt, ha",
            requiredIf: "Az oldal kötelezővé tétele, ha",
            maxTimeToFinish: "Az oldal befejezésének határideje (másodpercben)",
            questionsOrder: "Kérdések sorrendje az oldalon"
        },
        matrixdropdowncolumn: {
            name: "Oszlop neve",
            title: "Oszlop címe",
            isUnique: "Az ismétlődő válaszok megakadályozása",
            width: "Oszlopszélesség",
            minWidth: "Minimális oszlopszélesség",
            rows: "Beviteli mező magassága (sorokban)",
            visibleIf: "Tegye láthatóvá az oszlopot, ha",
            requiredIf: "Tegye kötelezővé az oszlopot, ha",
            showInMultipleColumns: "Minden beállítás külön oszlopban"
        },
        multipletextitem: {
            name: "Név",
            title: "Cím"
        },
        masksettings: {
            saveMaskedValue: "Maszkolt érték mentése a felmérés eredményeiben"
        },
        patternmask: {
            pattern: "Értékminta"
        },
        datetimemask: {
            min: "Minimális érték",
            max: "Maximális érték"
        },
        numericmask: {
            allowNegativeValues: "Negatív értékek engedélyezése",
            thousandsSeparator: "Több ezer szeparátor",
            decimalSeparator: "Tizedeselválasztó",
            precision: "Érték pontossága",
            min: "Minimális érték",
            max: "Maximális érték"
        },
        currencymask: {
            prefix: "Pénznem előtag",
            suffix: "Pénznem utótagja"
        },
        imageHeight: "Kép magassága",
        imageWidth: "Kép szélessége",
        valueName: "Érték megnevezése",
        rateDescriptionLocation: "Feliratigazítás",
        size: "Beviteli mező mérete (karakterben)",
        cellErrorLocation: "Cellahibaüzenet igazítása",
        apply: "Alkalmaz",
        ok: "OK",
        save: "Megment",
        clear: "Világos",
        saveTooltip: "Megment",
        cancel: "Mégsem",
        set: "Beállít",
        reset: "Visszaállítás",
        change: "Változás",
        refresh: "Felfrissít",
        close: "Bezárás",
        delete: "Eltávolítás",
        add: "Hozzáad",
        addNew: "Új felvétele",
        addItem: "Kattintson egy elem felvételéhez...",
        removeItem: "Kattintson az elem eltávolításához...",
        dragItem: "Húzza az elemet",
        addOther: "Egyéb",
        addSelectAll: "Összes kijelölése",
        addNone: "Semmi",
        removeAll: "Összes eltávolítása",
        edit: "Szerkesztés",
        back: "Visszaküldés mentés nélkül",
        backTooltip: "Visszaküldés mentés nélkül",
        saveAndBack: "Mentés és visszaküldés",
        saveAndBackTooltip: "Mentés és visszaküldés",
        doneEditing: "Kész",
        editChoices: "Lehetőségek szerkesztése",
        showChoices: "Választási lehetőségek megjelenítése",
        move: "Mozgatás",
        empty: "<üres>",
        emptyValue: "Az érték üres",
        fastEntry: "Gyors felvétel",
        fastEntryNonUniqueError: "A \"{0}\" érték nem egyedi",
        fastEntryChoicesCountError: "Kérjük, korlátozza a tételek számát {0} és {1} között",
        fastEntryChoicesMinCountError: "Kérjük, adjon meg legalább {0} elemet",
        fastEntryPlaceholder: "Az adatokat a következő formátumban állíthatja be:\nérték1|szöveg\nérték2",
        formEntry: "Felvétel űrlappal",
        testService: "Szolgáltatás tesztelése",
        itemSelectorEmpty: "Kérjük, válassza ki az elemet",
        conditionActionEmpty: "Kérjük, válassza ki a műveletet",
        conditionSelectQuestion: "Válasszon kérdést...",
        conditionSelectPage: "Válasszon oldalt...",
        conditionSelectPanel: "Panel kiválasztása...",
        conditionValueQuestionTitle: "Kérem adjon meg, vagy válasszon értéket",
        aceEditorHelp: "Nyomja meg a ctrl+space billentyűkombinációt a kifejezés befejezésére vonatkozó segítségért.",
        aceEditorRowTitle: "Jelenlegi sor",
        aceEditorPanelTitle: "Jelenlegi panel",
        showMore: "További információért kérem tekintse meg a dokumentációt",
        assistantTitle: "Elérhető kérdések:",
        cellsEmptyRowsColumns: "Legalább egy sornak vagy egy oszlopnak lennie kell",
        showPreviewBeforeComplete: "A válaszok előnézete a felmérés elküldése előtt",
        overridingPropertyPrefix: "Állítsa be ",
        resetToDefaultCaption: "Átszed",
        propertyIsEmpty: "Kérem adjon meg egy értéket",
        propertyIsNoUnique: "Kérjük, adjon meg egy egyedi értéket",
        propertyNameIsNotUnique: "Kérjük, adjon meg egy egyedi nevet",
        propertyNameIsIncorrect: "Ne használjon fenntartott szavakat: \"elem\", \"választás\", \"panel\", \"sor\".",
        listIsEmpty: "Még nincsenek hozzáadott elemek",
        "listIsEmpty@choices": "Még nincsenek választási lehetőségek hozzáadva",
        "listIsEmpty@columns": "Még nincsenek oszlopai",
        "listIsEmpty@rows": "Még nincsenek sorai",
        "listIsEmpty@validators": "Még nincsenek érvényességi szabályai",
        "listIsEmpty@calculatedValues": "Még nincsenek egyéni változói",
        "listIsEmpty@triggers": "Még nincsenek triggerek",
        "listIsEmpty@navigateToUrlOnCondition": "Még nincsenek linkek",
        "addNew@choices": "Választási lehetőség hozzáadása",
        "addNew@columns": "Új oszlop hozzáadása",
        "addNew@rows": "Új sor hozzáadása",
        "addNew@validators": "Új szabály hozzáadása",
        "addNew@calculatedValues": "Új változó hozzáadása",
        "addNew@triggers": "Új eseményindító hozzáadása",
        "addNew@navigateToUrlOnCondition": "Új URL hozzáadása",
        expressionIsEmpty: "A kifejezés üres",
        value: "Érték",
        text: "Szöveg",
        rowid: "Sor ID",
        imageLink: "Kép URL",
        columnEdit: "Oszlop szerkesztése: {0}",
        itemEdit: "Elem szerkesztése: {0}",
        url: "URL",
        path: "Útvonal",
        choicesbyurl: {
            url: "Webszolgáltatás URL-címe",
            valueName: "Értékek beolvasása a következő JSON-mezőből"
        },
        titleName: "Cím megnevezése",
        imageLinkName: "Képek URL-címének beolvasása a következő JSON-mezőből",
        allowEmptyResponse: "Üres válasz engedélyezése",
        titlePlaceholder: "Cím",
        surveyTitlePlaceholder: "Felmérés címe",
        pageTitlePlaceholder: "Oldal {num}",
        descriptionPlaceholder: "Leírás: __________",
        surveyDescriptionPlaceholder: "Leírás: __________",
        pageDescriptionPlaceholder: "Leírás: __________",
        textWrapEnabled: "Tördelési lehetőségek",
        showOtherItem: "Rendelkezik egyéb értékkel",
        otherText: "Az egyéb érték szövege",
        showNoneItem: "A Nincs lehetőség engedélyezése",
        showRefuseItem: "A Válasz megtagadása lehetőség engedélyezése",
        showDontKnowItem: "A Nem tudom lehetőség engedélyezése",
        noneText: "Nincs opció szövege",
        showSelectAllItem: "Az összes kijelölése lehetőség engedélyezése",
        selectAllText: "Az Összes kijelölése opció szövege",
        choicesMin: "Az automatikusan létrehozott elemek minimális értéke",
        choicesMax: "Az automatikusan létrehozott elemek maximális értéke",
        choicesStep: "Az automatikusan létrehozott elemek lépése",
        name: "Megnevezés",
        title: "Cím",
        cellType: "Cellatípus",
        colCount: "Oszlopok száma",
        choicesOrder: "Válassza ki a lehetőséget rendezését",
        visible: "Látható?",
        isRequired: "Kötelező?",
        markRequired: "Megjelölés kötelezőként",
        removeRequiredMark: "Távolítsa el a szükséges jelet",
        isAllRowRequired: "Válasz kérése minden sorhoz",
        eachRowUnique: "A sorokban ismétlődő válaszok megakadályozása",
        requiredErrorText: "\"Kötelező\" hibaüzenet",
        startWithNewLine: "Új sorban kezdődik?",
        rows: "Sorok száma",
        cols: "Oszlopok",
        placeholder: "Mező kitöltőszövege",
        showPreview: "A kép előnézete látható?",
        storeDataAsText: "Az állomány tartalmát tárolja a JSON-ben, szövegként",
        maxSize: "Maximális állományméret byte-ban",
        rowCount: "Sorok száma",
        columnLayout: "Oszlopok elrendezése",
        addRowLocation: "'Új sor felvétele' gomb elhelyezése",
        transposeData: "Sorok átültetése oszlopokba",
        addRowText: "'Új sor felvétele' gomb szövege",
        removeRowText: "'Sor eltávolítása' gomb szövege",
        rateMin: "Legkisebb szorzó",
        rateMax: "Legnagyobb szorzó",
        rateStep: "Szorzó lépésköze",
        minRateDescription: "Legkisebb szorzó leírása",
        maxRateDescription: "Legnagyobb szorzó leírása",
        inputType: "Mező típusa",
        optionsCaption: "Beállítások felirata",
        defaultValue: "Alapértelmezett érték",
        cellsDefaultRow: "Cellák alapértelmezett szövege",
        surveyEditorTitle: "Kérdőív beállításainak módosítása",
        qEditorTitle: "Szerkesztés: {0}",
        maxLength: "Maximális hossz",
        buildExpression: "Épít",
        editExpression: "Szerkeszt",
        and: "és",
        or: "vagy",
        remove: "Eltávolít",
        addCondition: "Feltétel hozzáadása",
        emptyLogicPopupMessage: "Válasszon ki egy kérdést a feltételek konfigurálásának megkezdéséhez.",
        if: "Ha",
        then: "akkor",
        setToName: "Célkérdés",
        fromName: "Másolandó kérdés innen: válasz",
        gotoName: "Kérdés, amelyre ugrani kell",
        ruleIsNotSet: "A szabály helytelen",
        includeIntoResult: "Felvétel a felmérés eredményeibe",
        showTitle: "Cím mutatása/elrejtése",
        expandCollapseTitle: "Cím kibontása/összecsukása",
        locale: "Alapértelmezett nyelv",
        simulator: "Válassza ki az eszköz típusát",
        landscapeOrientation: "Váltás fekvő tájolásra",
        portraitOrientation: "Váltás álló tájolásra",
        mode: "Mód (szerkesztés/megtekintés)",
        clearInvisibleValues: "Nemlátható értékek törlése",
        cookieName: "Süti megnevezése (a kérdőív csak egyszer kitölthető)",
        sendResultOnPageNext: "Kérdőív értékének küldése a következő lapra lépéskor",
        storeOthersAsComment: "Az 'egyéb' mező értékének tárolása külön mezőben",
        showPageTitles: "Lapok címének mutatása",
        showPageNumbers: "Lapok számának mutatása",
        pagePrevText: "'Előző lap' gomb felirata",
        pageNextText: "'Következő lap' gomb felirata",
        completeText: "'Befejezés' gomb felirata",
        previewText: "A Válaszok előnézete gomb szövege",
        editText: "A Válasz gomb szövegének szerkesztése",
        startSurveyText: "'Kezdés' gomb felirata",
        showNavigationButtons: "Navigációs gombok mutatása (alapértelmezett navigáció)",
        showPrevButton: "'Előző lap' gomb mutatása",
        firstPageIsStarted: "Az megkezdett lap a kérdőív első oldala.",
        showCompletedPage: "Befejező szöveg mutatása a kérdőív befejezésekor",
        goNextPageAutomatic: "Minden kérdés megválaszolásakor automatikusan a következő lapra lépés",
        allowCompleteSurveyAutomatic: "A felmérés automatikus kitöltése",
        showProgressBar: "Előrehaladás-mutató megjelenítése",
        questionTitleLocation: "Kérdés címének helye",
        questionTitleWidth: "Kérdés címének szélessége",
        requiredText: "Kötelező szimbólum",
        questionTitleTemplate: "Kérdés címének sablonja: '{szám}. {kötelező} {cím}'",
        questionErrorLocation: "Kérdés hibaüzenetének helyzete",
        focusFirstQuestionAutomatic: "Első kérdés automatikus kijelölése lapváltás esetén",
        questionsOrder: "Elemek rendezése a lapon",
        maxTimeToFinish: "A kérdőív kitöltésére fordítható maximális idő",
        maxTimeToFinishPage: "Egy lap kitöltésére fordítható maximális idő",
        showTimerPanel: "Időzító mutatása",
        showTimerPanelMode: "Időzító módja",
        renderMode: "Megjelenítés módja",
        allowAddPanel: "Új panel hozzáadásának engedélyezése",
        allowRemovePanel: "Panel eltávolításának engedélyezése",
        panelAddText: "'Új panel felvétele' gomb szövege",
        panelRemoveText: "'Panel eltávolítása' gomb szövege",
        isSinglePage: "Minden elem mutatása egy lapon",
        html: "HTML",
        setValue: "Válasz",
        dataFormat: "Képformátum",
        allowAddRows: "Sorok hozzáadásának engedélyezése",
        allowRemoveRows: "Sorok eltávolításának engedélyezése",
        allowRowsDragAndDrop: "Sorhúzás engedélyezése",
        responsiveImageSizeHelp: "Nem érvényes, ha megadja a kép pontos szélességét vagy magasságát.",
        minImageWidth: "Minimális képszélesség",
        maxImageWidth: "Maximális képszélesség",
        minImageHeight: "Minimális képmagasság",
        maxImageHeight: "Maximális képmagasság",
        minValue: "Minimális érték",
        maxValue: "Maximális érték",
        minLength: "Minimális hossz",
        allowDigits: "Számjegyek engedélyezése",
        minCount: "Minimális darabszám",
        maxCount: "Maximális darabszám",
        regex: "Reguláris kifejezés",
        surveyvalidator: {
            text: "Hibaüzenet",
            expression: "Érvényesítési kifejezés"
        },
        totalText: "Sorszöveg összesen",
        totalType: "Teljes típus",
        totalExpression: "Teljes kifejezés",
        totalDisplayStyle: "Teljes érték megjelenítési stílusa",
        totalCurrency: "Valuta",
        totalFormat: "Formázott karakterlánc",
        logo: "Embléma (URL vagy base64 kódolású karakterlánc)",
        questionsOnPageMode: "Felmérési struktúra",
        maxTextLength: "Válasz maximális hossza (karakterben)",
        maxOthersLength: "Megjegyzés maximális hossza (karakterben)",
        commentAreaRows: "Megjegyzés területének magassága (sorokban)",
        autoGrowComment: "Szükség esetén automatikusan bontsa ki a megjegyzésterületet",
        allowResizeComment: "A szövegterületek átméretezésének engedélyezése a felhasználók számára",
        textUpdateMode: "Szöveges kérdés értékének frissítése",
        maskType: "Beviteli maszk típusa",
        maskTypes: {
            none: "Egyik sem",
            patternmask: "Minta",
            numericmask: "Numerikus",
            datetimemask: "Dátum és idő",
            currencymask: "Valuta"
        },
        focusOnFirstError: "Fókusz beállítása az első érvénytelen válaszra",
        checkErrorsMode: "Érvényesítés futtatása",
        navigateToUrl: "Navigálás az URL-hez",
        navigateToUrlOnCondition: "Dinamikus URL",
        completedBeforeHtml: "Jelölés annak jelzésére, hogy a felhasználó kitöltötte-e már ezt a felmérést",
        completedHtml: "Felmérés teljes oldaljelölése",
        completedHtmlOnCondition: "Dinamikus felmérés teljes oldaljelölése",
        loadingHtml: "A földmérési modell betöltése közben megjelenítendő jelölés",
        commentText: "Megjegyzés terület szövege",
        autocomplete: "Automatikus kiegészítés típusa",
        labelTrue: "\"Igaz\" címke",
        labelFalse: "\"Hamis\" címke",
        allowClear: "A Törlés gomb megjelenítése",
        searchMode: "Keresési mód",
        displayStyle: "Értékmegjelenítési stílus",
        format: "Formázott karakterlánc",
        maximumFractionDigits: "Tört számjegyek maximális száma",
        minimumFractionDigits: "Minimális tört számjegyek",
        useGrouping: "Csoportosítási elválasztók megjelenítése",
        allowMultiple: "Több fájl engedélyezése",
        allowImagesPreview: "Képek előnézete",
        acceptedTypes: "Elfogadott fájltípusok",
        waitForUpload: "Várja meg, amíg a feltöltés befejeződik",
        needConfirmRemoveFile: "Fájltörlés megerősítése",
        detailPanelMode: "A részletek panel helye",
        minRowCount: "Sorszám minimális száma",
        maxRowCount: "Sorszám maximális száma",
        confirmDelete: "Sor törlésének megerősítése",
        confirmDeleteText: "Megerősítő üzenet",
        panelCount: "Kezdeti panelszám",
        minPanelCount: "Panelek minimális száma",
        maxPanelCount: "Panelek maximális száma",
        panelsState: "Belső panel kibontási állapota",
        panelPrevText: "Előző Panel gomb eszköztipp",
        panelNextText: "Következő Panel gomb elemleírása",
        showRangeInProgress: "Folyamatjelző sáv megjelenítése",
        panelRemoveButtonLocation: "A Panel gomb helyének eltávolítása",
        hideIfRowsEmpty: "A kérdés elrejtése, ha nincsenek sorok",
        hideColumnsIfEmpty: "Oszlopok elrejtése, ha nincsenek sorok",
        rateValues: "Egyéni díjértékek",
        rateCount: "Árak száma",
        autoGenerate: "Hogyan lehet megadni a díjértékeket?",
        hideIfChoicesEmpty: "A kérdés elrejtése, ha nem tartalmaz választási lehetőségeket",
        minWidth: "Minimális szélesség (CSS által elfogadott értékekben)",
        maxWidth: "Maximális szélesség (CSS által elfogadott értékekben)",
        width: "Szélesség (CSS által elfogadott értékekben)",
        showHeader: "Oszlopfejlécek megjelenítése",
        horizontalScroll: "Vízszintes görgetősáv megjelenítése",
        columnMinWidth: "Minimális oszlopszélesség (CSS által elfogadott értékekben)",
        rowTitleWidth: "Sorfejléc szélessége (CSS által elfogadott értékekben)",
        valueTrue: "\"Igaz\" érték",
        valueFalse: "\"Hamis\" érték",
        minErrorText: "\"Az érték a minimális érték alatt van\" hibaüzenet",
        maxErrorText: "\"Az érték meghaladja a maximumot\" hibaüzenet",
        otherErrorText: "\"Üres megjegyzés\" hibaüzenet",
        keyDuplicationError: "\"Nem egyedi kulcsérték\" hibaüzenet",
        minSelectedChoices: "Minimálisan kiválasztott választási lehetőségek",
        maxSelectedChoices: "Maximális kijelölt választási lehetőségek",
        showClearButton: "A Törlés gomb megjelenítése",
        logoWidth: "Embléma szélessége (CSS által elfogadott értékekben)",
        logoHeight: "Logó magassága (CSS által elfogadott értékekben)",
        readOnly: "Csak olvasható",
        enableIf: "Szerkeszthető, ha",
        emptyRowsText: "\"Nincsenek sorok\" üzenet",
        separateSpecialChoices: "Külön speciális választási lehetőségek (Nincs, Egyéb, Összes kijelölése)",
        choicesFromQuestion: "Másolja ki a következő kérdés választási lehetőségeit",
        choicesFromQuestionMode: "Milyen lehetőségeket másoljon?",
        progressBarShowPageTitles: "Oldalcímek megjelenítése a folyamatjelző sávon",
        progressBarShowPageNumbers: "Oldalszámok megjelenítése a folyamatjelző sávon",
        showCommentArea: "A megjegyzésterület megjelenítése",
        commentPlaceholder: "Megjegyzés terület helyőrzője",
        displayRateDescriptionsAsExtremeItems: "Sebességleírások megjelenítése extrém értékként",
        rowsOrder: "Sorsorrend",
        columnsLayout: "Oszlopelrendezés",
        columnColCount: "Beágyazott oszlopok száma",
        correctAnswer: "Helyes válasz",
        defaultPanelValue: "Alapértelmezett értékek",
        cells: "Cella szövegek",
        fileInputPlaceholder: "Válasszon ki egy fájlt, vagy illesszen be egy fájlhivatkozást...",
        keyName: "Fő oszlop",
        itemvalue: {
            visibleIf: "Tegye láthatóvá a beállítást, ha",
            enableIf: "Tegye kiválaszthatóvá a beállítást, ha"
        },
        "itemvalue@rows": {
            visibleIf: "Tegye láthatóvá a sort, ha",
            enableIf: "Tegye szerkeszthetővé a sort, ha:"
        },
        imageitemvalue: {
            text: "Helyettesítő szöveg"
        },
        logoPosition: "Logó pozíciója",
        addLogo: "Logó hozzáadása...",
        changeLogo: "Logó módosítása...",
        logoPositions: {
            none: "Embléma eltávolítása",
            left: "Balra",
            right: "Jobbra",
            top: "A tetején",
            bottom: "Alul"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Panel elrendezése"
            },
            general: "Általános",
            fileOptions: "Beállítások",
            html: "HTML szerkesztő",
            columns: "Oszlopok",
            rows: "Sorok",
            choices: "Lehetőségek",
            items: "Elemek",
            visibleIf: "Látható ha",
            enableIf: "Engedélyezve ha",
            requiredIf: "Kötelező ha",
            rateValues: "Szorzó értékek",
            choicesByUrl: "Lehetőségek a webről",
            matrixChoices: "Alapértelmezett lehetőségek",
            multipleTextItems: "Szövegmezők",
            numbering: "Számozás",
            validators: "Validátorok",
            navigation: "Navigáció",
            question: "Kérdés",
            pages: "Oldalak",
            timer: "Időzítő/Kvíz",
            calculatedValues: "Számított értékek",
            triggers: "Eseményvezérlők",
            templateTitle: "Sablon címe",
            totals: "Összegek",
            logic: "Logika",
            mask: "Beviteli maszk beállításai",
            layout: {
                panel: "Elrendezés",
                question: "Elrendezés",
                base: "Elrendezés"
            },
            data: "Adat",
            validation: "Érvényesítés",
            cells: "Cella szövegek",
            showOnCompleted: "Felmérés kész",
            logo: "Embléma a felmérés címében",
            slider: "Csúszka",
            expression: "Kifejezés",
            questionSettings: "Kérdés beállítások",
            header: "Fejléc",
            background: "Háttér",
            appearance: "Megjelenés",
            others: "Mások"
        },
        editProperty: "Tulajdonság szerkesztése '{0}'",
        items: "[ Elemek: {0} ]",
        choicesVisibleIf: "A választási lehetőségek akkor láthatók, ha",
        choicesEnableIf: "A választási lehetőségek akkor választhatók ki, ha",
        columnsEnableIf: "Az oszlopok akkor láthatók, ha",
        rowsEnableIf: "A sorok akkor láthatók, ha",
        innerIndent: "Belső behúzások hozzáadása",
        defaultValueFromLastRow: "Alapértelmezett értékek felvétele az utolsó sorból",
        defaultValueFromLastPanel: "Alapértelmezett értékek felvétele az utolsó panelről",
        enterNewValue: "Kérem, adja meg az értéket.",
        noquestions: "Nincsenek kérdések a kérdőívben.",
        createtrigger: "Kérem hozzon létre egy eseményvezérlőt",
        titleKeyboardAdornerTip: "Nyomja meg az Enter gombot a szerkesztéshez",
        keyboardAdornerTip: "Nyomja meg az Enter gombot az elem szerkesztéséhez, nyomja meg a törlés gombot az elem törléséhez, nyomja meg az alt plusz felfelé vagy lefelé mutató nyilat az elem áthelyezéséhez",
        triggerOn: "Be ",
        triggerMakePagesVisible: "Lapok láthatóvá tétele:",
        triggerMakeQuestionsVisible: "Elemek láthatóvá tétele:",
        triggerCompleteText: "Kérdőív befejezése, ha sikeres.",
        triggerNotSet: "Nincs eseménykezelő beállítva",
        triggerRunIf: "Futtatás ha",
        triggerSetToName: "A következő értékének cseréje: ",
        triggerFromName: "A következő értékének másolása: ",
        triggerRunExpression: "A következő kifejezés futtatása:",
        triggerSetValue: "erre: ",
        triggerGotoName: "Tovább a kérdéshez",
        triggerIsVariable: "Ne mentse az eredményt a kérdőív eredményébe.",
        triggerRunExpressionEmpty: "Kérjük, adjon meg egy érvényes kifejezést",
        emptyExpressionPlaceHolder: "Írja be ide a kifejezést...",
        noFile: "Nincs kiválasztott fájl",
        clearIfInvisible: "Az érték törlése, ha a kérdés rejtetté válik",
        valuePropertyName: "Értéktulajdonság neve",
        searchEnabled: "Keresés engedélyezése",
        hideSelectedItems: "A kijelölt elemek elrejtése",
        closeOnSelect: "A legördülő menü bezárása a kiválasztás után",
        verticalAlign: "Függőleges igazítás",
        alternateRows: "Alternatív sorok",
        columnsVisibleIf: "Az oszlopok akkor láthatók, ha",
        rowsVisibleIf: "A sorok akkor láthatók, ha",
        otherPlaceholder: "Megjegyzés terület helyőrzője",
        filePlaceholder: "Fájl helyőrző szövege",
        photoPlaceholder: "Fénykép helyőrző szövege",
        fileOrPhotoPlaceholder: "Fájl vagy fénykép helyőrző szövege",
        rateType: "Ár típusa",
        url_placeholder: "Pl.: https://api.example.com/books",
        path_placeholder: "Pl.: kategóriák.fikció",
        questionStartIndex_placeholder: "Pl.: a)",
        width_placeholder: "Pl.: 6 hüvelyk",
        minWidth_placeholder: "Pl.: 600px",
        maxWidth_placeholder: "Pl.: 50%",
        imageHeight_placeholder: "kocsi",
        imageWidth_placeholder: "kocsi",
        theme: {
            themeName: "Téma",
            isPanelless: "Kérdés megjelenése",
            editorPanel: "Háttér és saroksugár",
            questionPanel: "Háttér és saroksugár",
            primaryColor: "Kiemelő szín",
            panelBackgroundTransparency: "Panel hátterének átlátszatlansága",
            questionBackgroundTransparency: "Kérdés hátterének átlátszatlansága",
            fontSize: "Betűméret",
            scale: "Hangsor",
            cornerRadius: "Sarok sugara",
            pageTitle: "Cím betűtípusa",
            pageDescription: "Leírás betűtípus",
            questionTitle: "Cím betűtípusa",
            questionDescription: "Leírás betűtípus",
            editorFont: "Betűkészlet",
            backgroundOpacity: "Átlátszatlanság",
            "--sjs-font-family": "Betűcsalád",
            "--sjs-general-backcolor-dim": "Háttérszín",
            "--sjs-primary-backcolor": "Ékezetes háttér",
            "--sjs-primary-forecolor": "Hangsúlyos előtér",
            "--sjs-special-red": "Hibaüzenetek",
            "--sjs-shadow-small": "Árnyék effektusok",
            "--sjs-shadow-inner": "Árnyék effektusok",
            "--sjs-border-default": "Színek"
        },
        "header@header": {
            headerView: "Nézet",
            logoPosition: "Logó pozíciója",
            surveyTitle: "Felmérés címének betűtípusa",
            surveyDescription: "Felmérés leírásának betűtípusa",
            headerTitle: "Felmérés címének betűtípusa",
            headerDescription: "Felmérés leírásának betűtípusa",
            inheritWidthFrom: "Tartalomterület szélessége",
            textAreaWidth: "Szöveg szélessége",
            backgroundColorSwitch: "Háttérszín",
            backgroundImage: "Háttérkép",
            backgroundImageOpacity: "Átlátszatlanság",
            overlapEnabled: "Átfed",
            logoPositionX: "Logó pozíciója",
            titlePositionX: "Cím pozíciója",
            descriptionPositionX: "Leírás pozíciója"
        }
    },
    // Property values
    pv: {
        "true": "igaz",
        "false": "téves",
        file: "Helyi fájlok",
        camera: "Fényképezőgép",
        "file-camera": "Helyi fájlok vagy kamera",
        inherit: "öröklött",
        show: "mutatás",
        hide: "elrejtés",
        default: "alapértelmezett",
        initial: "kezdeti",
        random: "véletlen",
        collapsed: "csukott",
        expanded: "nyitott",
        none: "semmi",
        asc: "növekvő",
        desc: "csökkenő",
        indeterminate: "határozatlan",
        selected: "Kiválasztott",
        unselected: "Kijelöletlen",
        decimal: "tizedes",
        currency: "valuta",
        percent: "százalék",
        firstExpanded: "első nyitva",
        off: "ki",
        list: "lista",
        progressTop: "felül",
        progressBottom: "alul",
        progressTopBottom: "alül és felül",
        tab: "Lapfülek",
        horizontal: "horizontális",
        vertical: "vertikális",
        top: "fent",
        bottom: "lent",
        topBottom: "fent és lent",
        both: "Mindkettő",
        left: "bal",
        right: "Jobbra",
        center: "Központ",
        leftRight: "Balra és jobbra",
        middle: "Középső",
        color: "szín",
        date: "dátum",
        datetime: "Dátum/idő",
        "datetime-local": "datetime-local",
        email: "E-mail",
        month: "hónap",
        number: "szám",
        password: "jelszó",
        range: "tartomány",
        tel: "Tel",
        text: "SMS",
        time: "Idő",
        url: "URL-cím",
        week: "hét",
        hidden: "rejtett",
        edit: "szerkesztés",
        display: "mutatás",
        contain: "Tartalmaz",
        cover: "Fedő",
        fill: "Tölt",
        next: "Következő",
        last: "Utolsó",
        onComplete: "befejezéskor",
        onHidden: "eltűnéskor",
        onHiddenContainer: "Amikor a kérdés vagy annak panelje/oldala rejtetté válik",
        clearInvisibleValues: {
            none: "Soha"
        },
        clearIfInvisible: {
            none: "Soha"
        },
        inputType: {
            color: "Szín",
            date: "Dátum",
            "datetime-local": "Dátum és idő",
            email: "E-mail",
            month: "Hónap",
            number: "Szám",
            password: "Jelszó",
            range: "Tartomány",
            tel: "Telefonszám",
            text: "SMS",
            time: "Idő",
            url: "URL",
            week: "Hét"
        },
        all: "összes",
        page: "lap",
        survey: "kérdőív",
        onNextPage: "a következő lapra lépéskor",
        onValueChanged: "az érték változásakor",
        onValueChanging: "A válasz módosítása előtt",
        questionsOnPageMode: {
            standard: "Eredeti szerkezet",
            singlePage: "Az összes kérdés megjelenítése egy oldalon",
            questionPerPage: "Egyetlen kérdés megjelenítése oldalanként"
        },
        noPreview: "Nincs előnézet",
        showAllQuestions: "Az összes kérdés megjelenítése",
        showAnsweredQuestions: "Csak a megválaszolt kérdések megjelenítése",
        pages: "Befejezett oldalak",
        questions: "Megválaszolt kérdések",
        requiredQuestions: "Megválaszolt kötelező kérdések",
        correctQuestions: "Érvényes válaszok",
        buttons: "Befejezett oldalak (gombos felhasználói felület)",
        underInput: "A bemenet alatt",
        underTitle: "A cím alatt",
        onBlur: "Elmosódáskor",
        onTyping: "Gépelés közben",
        underRow: "A sor alatt",
        underRowSingle: "A sor alatt csak egy panel látható",
        auto: "Kocsi",
        showNavigationButtons: {
            none: "Rejtett"
        },
        showTimerPanel: {
            none: "Rejtett"
        },
        showTimerPanelMode: {
            all: "Mindkettő"
        },
        addRowLocation: {
            default: "A mátrix elrendezésétől függ"
        },
        panelsState: {
            default: "A felhasználók nem bonthatják ki és nem csukhatják össze a paneleket",
            collapsed: "Minden panel össze van csukva",
            expanded: "Minden panel ki van bontva",
            firstExpanded: "Először bővített"
        },
        widthMode: {
            static: "Statikus",
            responsive: "Fogékony"
        },
        contentMode: {
            image: "Kép",
            video: "Video",
            youtube: "Youtube-videók"
        },
        displayMode: {
            buttons: "Gombok",
            dropdown: "Legördülő menü"
        },
        rateColorMode: {
            default: "Alapértelmezett",
            scale: "Hangsor"
        },
        scaleColorMode: {
            monochrome: "Monokróm",
            colored: "Színes"
        },
        autoGenerate: {
            "true": "Létrehoz",
            "false": "Manuális bevitel"
        },
        rateType: {
            labels: "Címkék",
            stars: "Csillagok",
            smileys: "Hangulatjelek"
        },
        state: {
            default: "Zárolt"
        },
        showQuestionNumbers: {
            default: "Automatikus számozás",
            on: "Automatikus számozás",
            onPage: "Visszaállítás minden oldalon",
            onpanel: "Visszaállítás az egyes paneleken",
            onPanel: "Visszaállítás az egyes paneleken",
            onSurvey: "Folytassa a felmérést",
            off: "Nincs számozás"
        },
        descriptionLocation: {
            underTitle: "A kérdés címe alatt",
            underInput: "A beviteli mező alatt"
        },
        selectToRankAreasLayout: {
            horizontal: "A választási lehetőségek mellett",
            vertical: "A fenti választási lehetőségek"
        },
        displayStyle: {
            decimal: "Tizedes",
            currency: "Valuta",
            percent: "Százalék",
            date: "Dátum"
        },
        totalDisplayStyle: {
            decimal: "Tizedes",
            currency: "Valuta",
            percent: "Százalék",
            date: "Dátum"
        },
        rowsOrder: {
            initial: "Eredeti"
        },
        questionsOrder: {
            initial: "Eredeti"
        },
        showProgressBar: {
            off: "Rejtett",
            topbottom: "fent és lent",
            aboveheader: "A fejléc felett",
            belowheader: "A fejléc alatt"
        },
        sum: "Összeg",
        count: "Gróf",
        min: "Min",
        max: "Max",
        avg: "Avg",
        searchMode: {
            contains: "Tartalmaz",
            startsWith: "Ezzel kezdődik"
        },
        backgroundImageFit: {
            auto: "Kocsi",
            cover: "Fedő",
            contain: "Tartalmaz",
            fill: "Nyúlik",
            tile: "Cserép"
        },
        backgroundImageAttachment: {
            fixed: "Fix",
            scroll: "Kézirattekercs"
        },
        headerView: {
            basic: "Alapvető",
            advanced: "Haladó"
        },
        inheritWidthFrom: {
            survey: "Ugyanaz, mint a felmérés",
            container: "Tárolóhoz igazítás"
        },
        backgroundColorSwitch: {
            none: "Egyik sem",
            accentColor: "Kiemelő szín",
            custom: "Szokás"
        },
        colorPalette: {
            light: "Fény",
            dark: "Sötét"
        },
        isPanelless: {
            "false": "Alapértelmezett",
            "true": "Panelek nélkül"
        }
    },
    // Operators
    op: {
        empty: "üres",
        notempty: "nem üres",
        equal: "megegyezik",
        notequal: "nem egyezik meg",
        contains: "tartalmazza",
        notcontains: "nem tartalmazza",
        anyof: "Bármelyike",
        allof: "Az összes",
        greater: "nagyobb mint",
        less: "kisebb mint",
        greaterorequal: "nagyobb vagy egyenlő",
        lessorequal: "kisebb vagy egyenlő",
        and: "és",
        or: "vagy"
    },
    // Embed window
    ew: {
        angular: "Angular verzió használata",
        jquery: "jQuery verzió használata",
        knockout: "Knockout verzió használata",
        react: "React verzió használata",
        vue: "Vue verzió használata",
        bootstrap: "Használat Bootstrap frameworkkel",
        modern: "Modern téma",
        default: "Alapértelmezett téma",
        orange: "Narancssárga téma",
        darkblue: "Sötétkék téma",
        darkrose: "Darkrose téma",
        stone: "Kő téma",
        winter: "Téli téma",
        winterstone: "Téli-kő téma",
        showOnPage: "Kérdőív mutatása a lapon",
        showInWindow: "Kérdőív mutatása egy ablakban",
        loadFromServer: "Kérdőív JSON betöltése a szerverről",
        titleScript: "Szkriptek és stíluslapok",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Válassza ki a tesztelni kívánt lapot:",
        showInvisibleElements: "Nemlátható elemek megjelnítése",
        hideInvisibleElements: "Láthatatlan elemek elrejtése"
    },
    validators: {
        answercountvalidator: "válaszok száma",
        emailvalidator: "e-mail",
        expressionvalidator: "kifejezés",
        numericvalidator: "szám",
        regexvalidator: "reguláris kifejezés",
        textvalidator: "szöveg"
    },
    triggers: {
        completetrigger: "kérdőív befejezése",
        setvaluetrigger: "érték beállítása",
        copyvaluetrigger: "érték másolása",
        skiptrigger: "Ugrás a kérdésre",
        runexpressiontrigger: "kifejezés futtatása",
        visibletrigger: "láthatóság megváltoztatása (már nincs használatban)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Pl.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Pl.: éééé/hh/nn"
        },
        currencymask: {
            prefix: "Pl.: $",
            suffix: "Pl.: USD"
        },
        panelbase: {
            questionTitleWidth: "Pl.: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "Olyan panelazonosító, amely nem látható a válaszadók számára.",
            description: "Írja be a panel feliratát.",
            visibleIf: "A varázspálca ikonnal feltételes szabályt állíthat be, amely meghatározza a panel láthatóságát.",
            enableIf: "A varázspálca ikonnal állítson be egy feltételes szabályt, amely letiltja a panel írásvédett módját.",
            requiredIf: "A varázspálca ikonnal állítson be egy feltételes szabályt, amely megakadályozza a felmérés elküldését, kivéve, ha legalább egy beágyazott kérdésre van válasz.",
            questionTitleLocation: "A panelen található összes kérdésre vonatkozik. Ha felül szeretné bírálni ezt a beállítást, határozzon meg címigazítási szabályokat az egyes kérdésekhez. Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást (\"Alapértelmezetten felül\") alkalmazza.",
            questionTitleWidth: "Egységes szélességet állít be a kérdéscímekhez, ha azok a kérdésmezőktől balra vannak igazítva. CSS-értékeket fogad el (px, %, in, pt stb.).",
            questionErrorLocation: "Beállítja a hibaüzenet helyét a panelen belüli összes kérdéssel kapcsolatban. Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást alkalmazza.",
            questionsOrder: "Megtartja a kérdések eredeti sorrendjét, vagy véletlenszerűvé teszi őket. Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást alkalmazza.",
            page: "A kijelölt oldal végére helyezi a panelt.",
            innerIndent: "Térközt vagy margót ad a panel tartalma és a paneldoboz bal szegélye közé.",
            startWithNewLine: "Törölje a jelölést, ha a panel egy sorban jelenik meg az előző kérdéssel vagy panellel. A beállítás nem érvényes, ha a panel az űrlap első eleme.",
            state: "Válasszon a következők közül: \"Kibontott\" - a panel teljes egészében megjelenik és összecsukható; \"Összecsukott\" - a panel csak a címet és a leírást jeleníti meg, és bővíthető; \"Zárolva\" - a panel teljes egészében megjelenik, és nem csukható össze.",
            width: "A panel szélességét az ugyanabban a sorban lévő többi földmérési elemhez viszonyítva állítja be. CSS-értékeket fogad el (px, %, in, pt stb.)."
        },
        paneldynamic: {
            name: "Olyan panelazonosító, amely nem látható a válaszadók számára.",
            description: "Írja be a panel feliratát.",
            visibleIf: "A varázspálca ikonnal feltételes szabályt állíthat be, amely meghatározza a panel láthatóságát.",
            enableIf: "A varázspálca ikonnal állítson be egy feltételes szabályt, amely letiltja a panel írásvédett módját.",
            requiredIf: "A varázspálca ikonnal állítson be egy feltételes szabályt, amely megakadályozza a felmérés elküldését, kivéve, ha legalább egy beágyazott kérdésre van válasz.",
            templateTitleLocation: "A panelen található összes kérdésre vonatkozik. Ha felül szeretné bírálni ezt a beállítást, határozzon meg címigazítási szabályokat az egyes kérdésekhez. Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást (\"Alapértelmezetten felül\") alkalmazza.",
            templateErrorLocation: "Beállítja egy érvénytelen bevitelű kérdéssel kapcsolatos hibaüzenet helyét. Válasszon a következők közül: \"Felső\" - egy hibaüzenet kerül a kérdésmező tetejére; \"Alsó\" - egy hibaüzenet kerül a kérdésmező aljára. Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást (\"Alapértelmezetten felül\") alkalmazza.",
            errorLocation: "Beállítja a hibaüzenet helyét a panelen belüli összes kérdéssel kapcsolatban. Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást alkalmazza.",
            page: "A kijelölt oldal végére helyezi a panelt.",
            innerIndent: "Térközt vagy margót ad a panel tartalma és a paneldoboz bal szegélye közé.",
            startWithNewLine: "Törölje a jelölést, ha a panel egy sorban jelenik meg az előző kérdéssel vagy panellel. A beállítás nem érvényes, ha a panel az űrlap első eleme.",
            state: "Válasszon a következők közül: \"Kibontott\" - a panel teljes egészében megjelenik és összecsukható; \"Összecsukott\" - a panel csak a címet és a leírást jeleníti meg, és bővíthető; \"Zárolva\" - a panel teljes egészében megjelenik, és nem csukható össze.",
            width: "A panel szélességét az ugyanabban a sorban lévő többi földmérési elemhez viszonyítva állítja be. CSS-értékeket fogad el (px, %, in, pt stb.).",
            templateTitle: "Írjon be egy sablont a dinamikus panelcímekhez. Használja a {panelIndex} elemet a panel általános pozíciójához, a {visiblePanelIndex} értéket pedig a látható panelek közötti sorrendjéhez. Szúrja be ezeket a helyőrzőket a mintába az automatikus számozás hozzáadásához.",
            templateTabTitle: "Írjon be egy sablont a lapcímekhez. Használja a {panelIndex} elemet a panel általános pozíciójához, a {visiblePanelIndex} sablont pedig a látható panelek közötti sorrendjéhez. Szúrja be ezeket a helyőrzőket a mintába az automatikus számozás hozzáadásához.",
            tabTitlePlaceholder: "A lapcímek alapszövege, amely akkor érvényes, ha a lap címmintája nem ad értelmes értéket.",
            templateVisibleIf: "Ezzel a beállítással szabályozhatja az egyes panelek láthatóságát a dinamikus panelen. A \"{panel}\" helyőrzővel hivatkozhat a kifejezés aktuális paneljére.",
            titleLocation: "Ezt a beállítást a panelen található összes kérdés automatikusan örökli. Ha felül szeretné bírálni ezt a beállítást, határozzon meg címigazítási szabályokat az egyes kérdésekhez. Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást (\"Alapértelmezetten felül\") alkalmazza.",
            descriptionLocation: "Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást alkalmazza (\"Alapértelmezés szerint a panel címe alatt\").",
            newPanelPosition: "Az újonnan hozzáadott panel helyét határozza meg. Alapértelmezés szerint az új panelek hozzáadódnak a végéhez. Válassza a \"Tovább\" lehetőséget, ha új panelt szeretne beilleszteni az aktuális után.",
            defaultValueFromLastPanel: "Megkettőzi a válaszokat az utolsó panelről, és hozzárendeli őket a következő hozzáadott dinamikus panelhez.",
            keyName: "Hivatkozzon egy kérdés nevére, hogy a felhasználónak egyedi választ kell adnia erre a kérdésre minden panelen."
        },
        defaultValueExpression: "Ezzel a beállítással alapértelmezett válaszértéket rendelhet hozzá egy kifejezés alapján. A kifejezés tartalmazhat alapvető számításokat - '{q1_id} + {q2_id}', logikai kifejezéseket, például \"{age} > 60\" és függvényeket: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' stb. A kifejezés által meghatározott érték a kezdeti alapértelmezett érték, amelyet a válaszadó kézi bevitele felülbírálhat.",
        resetValueIf: "A varázspálca ikonnal feltételes szabályt állíthat be, amely meghatározza, hogy a válaszadó bemenete mikor áll vissza az \"Alapértelmezett érték kifejezés\" vagy az \"Értékkifejezés beállítása\" vagy az \"Alapértelmezett válasz\" érték alapján (ha bármelyik be van állítva).",
        setValueIf: "A varázspálca ikonnal beállíthat egy feltételes szabályt, amely meghatározza, hogy mikor kell futtatni az \"Érték beállítása kifejezést\", és dinamikusan hozzárendelni az eredményül kapott értéket válaszként.",
        setValueExpression: "Adjon meg egy kifejezést, amely meghatározza az \"Érték beállítása, ha\" szabály feltételeinek teljesülése esetén beállítandó értéket. A kifejezés tartalmazhat alapvető számításokat - '{q1_id} + {q2_id}', logikai kifejezéseket, például \"{age} > 60\" és függvényeket: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' stb. A kifejezés által meghatározott értéket felülbírálhatja a válaszadó kézi bevitele.",
        question: {
            name: "A válaszadók számára nem látható kérdésazonosító.",
            description: "Írja be a kérdés alcímét.",
            visibleIf: "A varázspálca ikonnal állítson be egy feltételes szabályt, amely meghatározza a kérdések láthatóságát.",
            enableIf: "A varázspálca ikonnal állítson be egy feltételes szabályt, amely letiltja a kérdés írásvédett módját.",
            requiredIf: "A varázspálca ikonnal állítson be egy feltételes szabályt, amely megakadályozza a felmérés előrehaladását vagy elküldését, kivéve, ha a kérdésre választ kapott.",
            startWithNewLine: "Törölje a jelölést, ha a kérdést egy sorban szeretné megjeleníteni az előző kérdéssel vagy panellel. A beállítás nem érvényes, ha a kérdés az űrlap első eleme.",
            page: "A kérdést a kijelölt oldal végére helyezi.",
            state: "Válasszon a következők közül: \"Kibontott\" - a kérdésmező teljes egészében megjelenik és összecsukható; \"Összecsukott\" - a kérdésmező csak a címet és a leírást jeleníti meg, és kibontható; \"Zárolva\" - a kérdésmező teljes egészében megjelenik, és nem csukható össze.",
            titleLocation: "Felülbírálja a panel-, oldal- vagy felmérésszinten definiált címigazítási szabályokat. Az \"Öröklés\" opció minden magasabb szintű beállítást (ha be van állítva) vagy felmérésszintű beállítást (\"Alapértelmezetten Felül\") alkalmaz.",
            descriptionLocation: "Az \"Öröklés\" opció a felmérés szintű beállítást alkalmazza (\"Alapértelmezés szerint a kérdés címe alatt\").",
            errorLocation: "Beállítja az érvénytelen bevitelű kérdéssel kapcsolatos hibaüzenet helyét. Válasszon a következők közül: \"Felső\" - egy hibaüzenet kerül a kérdésmező tetejére; \"Alsó\" - egy hibaüzenet kerül a kérdésmező aljára. Az \"Öröklés\" opció a felmérés szintű beállítást alkalmazza (\"Felül\" alapértelmezés szerint).",
            indent: "Térközt vagy margót ad a kérdés tartalma és a kérdésmező bal szegélye közé.",
            width: "A kérdés szélességét az ugyanabban a sorban lévő többi földmérési elemhez viszonyítva állítja be. CSS-értékeket fogad el (px, %, in, pt stb.).",
            surveyvalidator: {
                expression: "A varázspálca ikonnal állítson be érvényességi szabályt a kérdéshez."
            },
            textUpdateMode: "Válasszon a következők közül: \"Elveszett fókuszban\" - az érték frissül, amikor a beviteli mező elveszíti a fókuszt; \"Gépelés közben\" - az érték valós időben frissül, ahogy a felhasználók gépelnek. Az \"Öröklés\" opció a felmérés szintű beállítást alkalmazza (\"Alapértelmezés szerint elveszett fókuszban\").",
            url: "Bármely webszolgáltatást használhat adatforrásként feleletválasztós kérdésekhez. A választási lehetőségek értékeinek feltöltéséhez adja meg az adatokat szolgáltató szolgáltatás URL-címét.",
            searchMode: "A legördülő lista szűrésére szolgáló összehasonlító művelet.",
            textWrapEnabled: "A választási lehetőségekben szereplő hosszú szövegek automatikusan sortöréseket generálnak, hogy elférjenek a legördülő menüben. Törölje a jelet a jelölőnégyzetből, ha le szeretné vágni a szövegeket."
        },
        signaturepad: {
            signatureWidth: "Beállítja a megjelenített aláírási terület szélességét és az eredményül kapott képet.",
            signatureHeight: "Beállítja a megjelenített aláírási terület magasságát és az eredményül kapott képet.",
            signatureAutoScaleEnabled: "Jelölje be, ha azt szeretné, hogy az aláírási terület kitöltse a kérdésmezőben rendelkezésre álló összes helyet, miközben megtartja az alapértelmezett 3:2 képarányt. Egyéni szélességi és magassági értékek beállításakor a beállítás megtartja ezeknek a méreteknek a méretarányát."
        },
        file: {
            imageHeight: "Beállítja a kép magasságát a felmérés eredményeiben.",
            imageWidth: "Beállítja a kép szélességét a felmérés eredményeiben."
        },
        image: {
            contentMode: "Az \"Automatikus\" opció automatikusan meghatározza a megjelenítéshez megfelelő módot - Kép, Videó vagy YouTube - a megadott forrás URL alapján."
        },
        imagepicker: {
            imageHeight: "Felülbírálja a minimális és maximális magassági értékeket.",
            imageWidth: "Felülbírálja a minimális és maximális szélességi értékeket.",
            choices: "Az \"érték\" a feltételes szabályokban használt elemazonosítóként szolgál; A \"Szöveg\" felirat jelenik meg a válaszadók számára.",
            contentMode: "Válasszon a \"Kép\" és a \"Videó\" között a médiaválasztó tartalommódjának beállításához. Ha a \"Kép\" van kiválasztva, győződjön meg arról, hogy az összes rendelkezésre álló opció a következő formátumú képfájlok: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Hasonlóképpen, ha a \"Video\" van kiválasztva, győződjön meg arról, hogy az összes opció közvetlen link a következő formátumú videofájlokhoz: MP4, MOV, WMV, FLV, AVI, MKV. Felhívjuk figyelmét, hogy a YouTube-linkek nem támogatottak a videóbeállításoknál."
        },
        text: {
            size: "Ez a beállítás csak a beviteli mezőt méretezi át, és nincs hatással a kérdésmező szélességére. Az elfogadott bemeneti hossz korlátozásához lépjen az <b>Érvényesítés → Maximális karakterkorlát</b> elemre."
        },
        comment: {
            rows: "Beállítja a beviteli mezőben megjelenített sorok számát. Ha a bemenet több sort foglal el, megjelenik a görgetősáv."
        },
        // survey templates
        survey: {
            mode: "Válasszon a következők közül: \"Szerkeszthető\" - lehetővé teszi a válaszadók számára a felmérés kitöltését; \"Csak olvasható\" - letiltja az űrlapszerkesztést."
        },
        matrixdropdowncolumn: {
            name: "A válaszadók számára nem látható oszlopazonosító.",
            isUnique: "Ha engedélyezve van egy oszlophoz, a válaszadónak egyedi választ kell adnia az oszlop minden kérdésére.",
            rows: "Beállítja a beviteli mezőben megjelenített sorok számát. Ha a bemenet több sort foglal el, megjelenik a görgetősáv.",
            visibleIf: "A varázspálca ikonnal feltételes szabályt állíthat be, amely meghatározza az oszlop láthatóságát.",
            enableIf: "A varázspálca ikonnal állítson be egy feltételes szabályt, amely letiltja az oszlop írásvédett módját.",
            requiredIf: "A varázspálca ikonnal állítson be egy feltételes szabályt, amely megakadályozza a felmérés elküldését, kivéve, ha legalább egy beágyazott kérdésre van válasz.",
            showInMultipleColumns: "Ha be van jelölve, minden választási lehetőséghez külön oszlopot hoz létre."
        },
        widthMode: "Válasszon a következők közül: \"Statikus\" - rögzített szélességet állít be; \"Reszponzív\" - a felmérés a képernyő teljes szélességét elfoglalja; \"Automatikus\" - a használt kérdéstípusoktól függően a kettő egyikét alkalmazza.",
        cookieName: "A cookie-k megakadályozzák, hogy a felhasználók kétszer töltsék ki ugyanazt a felmérést.",
        logo: "Illesszen be egy képhivatkozást (méretkorlátozás nélkül), vagy kattintson a mappa ikonra egy fájl böngészéséhez a számítógépről (legfeljebb 64 KB).",
        logoWidth: "Beállítja az embléma szélességét CSS egységekben (px, %, in, pt stb.).",
        logoHeight: "Beállítja az embléma magasságát CSS egységekben (px, %, in, pt stb.).",
        logoFit: "Válasszon a következők közül: \"Nincs\" - a kép megőrzi eredeti méretét; \"Tartalmaz\" - a kép átméreteződik, hogy illeszkedjen, miközben megtartja képarányát; \"Borító\" - a kép kitölti az egész dobozt, miközben megtartja képarányát; \"Kitöltés\" - a kép a doboz kitöltéséhez nyúlik a képarány megtartása nélkül.",
        goNextPageAutomatic: "Válassza ki, hogy a felmérés automatikusan továbblépjen-e a következő oldalra, miután a válaszadó megválaszolta az aktuális oldalon található összes kérdést.",
        allowCompleteSurveyAutomatic: "Válassza ki, hogy szeretné-e, hogy a felmérés automatikusan kitöltődjön, miután a válaszadó megválaszolta az összes kérdést.",
        showNavigationButtons: "Beállítja a navigációs gombok láthatóságát és helyét az oldalon.",
        showProgressBar: "Beállítja a folyamatjelző sáv láthatóságát és helyét. Az \"Automatikus\" érték megjeleníti a folyamatjelző sávot a felmérés fejléce felett vagy alatt.",
        showPreviewBeforeComplete: "Engedélyezze az előnézeti oldalt csak az összes vagy megválaszolt kérdéssel.",
        questionTitleLocation: "A felmérésben szereplő összes kérdésre vonatkozik. Ezt a beállítást felülbírálhatják az alacsonyabb szinteken lévő címigazítási szabályok: panel, oldal vagy kérdés. Az alacsonyabb szintű beállítás felülírja a magasabb szinten lévőket.",
        requiredText: "Egy szimbólum vagy szimbólumsorozat, amely jelzi, hogy válaszolni kell.",
        questionStartIndex: "Írja be azt a számot vagy betűt, amellyel a számozást kezdeni szeretné.",
        questionErrorLocation: "Beállítja az érvénytelen bevitelű kérdéssel kapcsolatos hibaüzenet helyét. Válasszon a következők közül: \"Felső\" - egy hibaüzenet kerül a kérdésmező tetejére; \"Alsó\" - egy hibaüzenet kerül a kérdésmező aljára.",
        focusFirstQuestionAutomatic: "Válassza ki, ha azt szeretné, hogy az egyes oldalak első beviteli mezője készen álljon a szövegbevitelre.",
        questionsOrder: "Megtartja a kérdések eredeti sorrendjét, vagy véletlenszerűvé teszi őket. A beállítás hatása csak az Előnézet lapon látható.",
        maxTextLength: "Csak szövegbeviteli kérdések esetén.",
        maxOthersLength: "Csak kérdésekhez fűzött megjegyzésekhez.",
        commentAreaRows: "Beállítja a kérdésmegjegyzések szövegterületein megjelenített sorok számát. A bemenet több sort foglal el, megjelenik a görgetősáv.",
        autoGrowComment: "Válassza ki, ha azt szeretné, hogy a kérdésmegjegyzések és a hosszú szöveges kérdések magassága automatikusan növekedjen a beírt szöveg hossza alapján.",
        allowResizeComment: "Csak kérdésekhez és hosszú szöveges kérdésekhez.",
        calculatedValues: "Az egyéni változók köztes vagy kiegészítő változókként szolgálnak az űrlapszámításokban. A válaszadó bemeneteit forrásértékként veszik fel. Minden egyéni változónak egyedi neve és egy kifejezése van, amelyen alapul.",
        includeIntoResult: "Válassza ezt a lehetőséget, ha a kifejezés számított értékét a felmérés eredményeivel együtt szeretné menteni.",
        triggers: "Az eseményindító egy kifejezésen alapuló esemény vagy feltétel. Miután a kifejezés \"true\" (igaz) értékre lett kiértékelve, az eseményindító elindít egy műveletet. Egy ilyen műveletnek opcionálisan lehet egy célkérdése, amelyet érint.",
        clearInvisibleValues: "Válassza ki, hogy törli-e a feltételes logika által elrejtett kérdések értékeit, és mikor tegye meg.",
        textUpdateMode: "Válasszon a következők közül: \"Elveszett fókuszban\" - az érték frissül, amikor a beviteli mező elveszíti a fókuszt; \"Gépelés közben\" - az érték valós időben frissül, ahogy a felhasználók gépelnek.",
        columns: "A bal oldali érték a feltételes szabályokban használt oszlopazonosítóként szolgál, a jobb oldali érték pedig a válaszadók számára jelenik meg.",
        rows: "A bal oldali érték a feltételes szabályokban használt sorazonosítóként szolgál, a jobb oldali érték a válaszadók számára jelenik meg.",
        columnMinWidth: "CSS-értékeket fogad el (px, %, in, pt stb.).",
        rowTitleWidth: "CSS-értékeket fogad el (px, %, in, pt stb.).",
        totalText: "Csak akkor látható, ha legalább egy oszlop Összeg típusú vagy Összeg kifejezéssel rendelkezik.",
        cellErrorLocation: "Beállítja a hibaüzenet helyét egy érvénytelen bevitelű cellával kapcsolatban. Az \"Öröklés\" opció a \"Hibaüzenetek igazítása\" tulajdonság beállítását alkalmazza.",
        keyDuplicationError: "Ha az \"Ismétlődő válaszok megakadályozása\" tulajdonság engedélyezve van, az ismétlődő bejegyzést beküldeni próbáló válaszadó a következő hibaüzenetet kapja.",
        totalExpression: "Lehetővé teszi az összesített értékek kiszámítását egy kifejezés alapján. A kifejezés tartalmazhat alapvető számításokat ('{q1_id} + {q2_id}'), logikai kifejezéseket ('{age} > 60') és függvényeket ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' stb.).",
        confirmDelete: "Elindít egy kérést, amely a sor törlésének megerősítését kéri.",
        defaultValueFromLastRow: "Megkettőzi a válaszokat az utolsó sorból, és hozzárendeli őket a következő hozzáadott dinamikus sorhoz.",
        keyName: "Ha a megadott oszlop azonos értékeket tartalmaz, a felmérés a \"Nem egyedi kulcsérték\" hibát adja vissza.",
        description: "Írjon be egy feliratot.",
        locale: "Válassza ki a nyelvet a felmérés létrehozásának megkezdéséhez. Fordítás hozzáadásához váltson új nyelvre, és fordítsa le az eredeti szöveget itt vagy a Fordítások lapon.",
        detailPanelMode: "Beállítja a részletszakasz helyét egy sorhoz képest. Válasszon a következők közül: \"Nincs\" - nincs bővítés; \"A sor alatt\" - a mátrix minden sora alá sorbővítés kerül; \"A sor alatt csak egy sor bővítés megjelenítése\" - a bővítés csak egyetlen sor alatt jelenik meg, a fennmaradó sorbővítések összecsukódnak.",
        imageFit: "Válasszon a következők közül: \"Nincs\" - a kép megőrzi eredeti méretét; \"Tartalmaz\" - a kép átméreteződik, hogy illeszkedjen, miközben megtartja képarányát; \"Borító\" - a kép kitölti az egész dobozt, miközben megtartja képarányát; \"Kitöltés\" - a kép a doboz kitöltéséhez nyúlik a képarány megtartása nélkül.",
        autoGrow: "Fokozatosan növeli a beviteli mező magasságát az adatok bevitele közben. Felülbírálja a \"Beviteli mező magassága (sorokban)\" beállítást.",
        allowResize: "Az átméretező fogópont (vagy fogópont) megjelenik a sarokban, és húzással módosítható a beviteli mező mérete.",
        maxTimeToFinish: "Az az időintervallum másodpercben, amely után a felmérés automatikusan továbblép a Köszönet oldalra.",
        maxTimeToFinishPage: "Az az időintervallum másodpercben, amely után a felmérés automatikusan továbblép a következő oldalra.",
        page: {
            maxTimeToFinish: "Az az időintervallum másodpercben, amely után a felmérés automatikusan továbblép a következő oldalra.",
            visibleIf: "A varázspálca ikonnal állítson be egy feltételes szabályt, amely meghatározza az oldal láthatóságát.",
            enableIf: "A varázspálca ikonnal állítson be egy feltételes szabályt, amely letiltja az oldal írásvédett módját.",
            requiredIf: "A varázspálca ikonnal állítson be egy feltételes szabályt, amely megakadályozza a felmérés elküldését, kivéve, ha legalább egy beágyazott kérdésre van válasz.",
            questionTitleLocation: "Az ezen az oldalon található összes kérdésre vonatkozik. Ha felül szeretné bírálni ezt a beállítást, határozzon meg címigazítási szabályokat az egyes kérdésekhez vagy panelekhez. Az \"Öröklés\" opció a felmérés szintű beállítást alkalmazza (\"Felül\" alapértelmezés szerint).",
            questionTitleWidth: "Egységes szélességet állít be a kérdéscímekhez, ha azok a kérdésmezőktől balra vannak igazítva. CSS-értékeket fogad el (px, %, in, pt stb.).",
            questionErrorLocation: "Beállítja az érvénytelen bevitelű kérdéssel kapcsolatos hibaüzenet helyét. Válasszon a következők közül: \"Felső\" - egy hibaüzenet kerül a kérdésmező tetejére; \"Alsó\" - egy hibaüzenet kerül a kérdésmező aljára. Az \"Öröklés\" opció a felmérés szintű beállítást alkalmazza (\"Felül\" alapértelmezés szerint).",
            questionsOrder: "Megtartja a kérdések eredeti sorrendjét, vagy véletlenszerűvé teszi őket. Az \"Öröklés\" opció a felmérési szintű beállítást alkalmazza (\"Eredeti\" alapértelmezés szerint). A beállítás hatása csak az Előnézet lapon látható.",
            navigationButtonsVisibility: "Beállítja a navigációs gombok láthatóságát az oldalon. Az \"Öröklés\" opció a felmérés szintű beállítást alkalmazza, amely alapértelmezés szerint \"Látható\"."
        },
        showTimerPanel: "Beállítja az időzítő láthatóságát és helyét az oldalon.",
        panelsState: "Válasszon a következők közül: \"Zárolt\" - a felhasználók nem bonthatják ki vagy csukhatják össze a paneleket; \"Az összes összecsukása\" - minden panel összecsukott állapotban indul; \"Összes kibontása\" - minden panel kibővített állapotban indul; \"Először bővített\" - csak az első panel bővül.",
        imageLinkName: "Adjon meg egy megosztott tulajdonságnevet az objektumok tömbjében, amely tartalmazza az adatválaszték-listában megjeleníteni kívánt kép- vagy videofájl URL-címeit.",
        choices: "A bal oldali érték a feltételes szabályokban használt elemazonosítóként szolgál, a jobb oldali érték megjelenik a válaszadók számára.",
        title: "Írja be a megjelenítendő felhasználóbarát címet.",
        waitForUpload: "Biztosítja, hogy a felhasználók ne töltsék ki a felmérést a fájlok feltöltéséig.",
        minWidth: "CSS-értékeket fogad el (px, %, in, pt stb.).",
        maxWidth: "CSS-értékeket fogad el (px, %, in, pt stb.).",
        width: "CSS-értékeket fogad el (px, %, in, pt stb.).",
        valueName: "Ha nem állítja be ezt a tulajdonságot, a válasz a Name tulajdonságban megadott mezőben lesz tárolva.",
        useDisplayValuesInDynamicTexts: "Az egyszeres és többszörös kijelölésű kérdéstípusokban minden választási lehetőség rendelkezik azonosítóval és megjelenített értékkel. Ha be van jelölve, ez a beállítás azonosító érték helyett megjelenítési értéket jelenít meg a HTML-kérdésekben, valamint a dinamikus címekben és a földmérési elemek leírásában.",
        clearIfInvisible: "Válassza ki, hogy törli-e a feltételes logika által elrejtett kérdésértékeket, és mikor tegye meg. Az \"Öröklés\" opció a felmérési szintű beállítást alkalmazza (\"Felmérés befejezésekor\" alapértelmezés szerint).",
        choicesFromQuestionMode: "Válasszon a következők közül: \"Összes\" - átmásolja az összes választási lehetőséget a kiválasztott kérdésből; \"Kiválasztott\" - dinamikusan másolja csak a kiválasztott választási lehetőségeket; \"Nem kiválasztott\" - dinamikusan csak a nem kiválasztott választási lehetőségeket másolja. A \"Nincs\" és az \"Egyéb\" opciók alapértelmezés szerint másolásra kerülnek, ha engedélyezve vannak a forráskérdésben.",
        showOtherItem: "Ha be van jelölve, a felhasználók további bevitelt adhatnak meg egy külön megjegyzésmezőben.",
        separateSpecialChoices: "Minden speciális választási lehetőséget (\"Nincs\", \"Egyéb\", \"Összes kijelölése\") új sorban jelenít meg, még akkor is, ha többoszlopos elrendezést használ.",
        path: "Adja meg azt a helyet a szolgáltatás adatkészletén belül, ahol az objektumok céltömbje található. Hagyja üresen, ha az URL-cím már a tömbre mutat.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Adjon meg egy egységes tulajdonságnevet az adatválaszték-listában megjeleníteni kívánt értékeket tartalmazó objektumtömbben.",
        allowEmptyResponse: "Jelölje be, ha engedélyezni szeretné, hogy a szolgáltatás üres választ vagy tömböt adjon vissza.",
        choicesVisibleIf: "A varázspálca ikonnal feltételes szabályt állíthat be, amely meghatározza az összes választási lehetőség láthatóságát.",
        rateValues: "A bal oldali érték a feltételes szabályokban használt elemazonosítóként szolgál, a jobb oldali érték megjelenik a válaszadók számára.",
        rating: {
            displayMode: "Az \"Automatikus\" a rendelkezésre álló szélesség alapján választ a \"Gombok\" és a \"Legördülő menü\" módok között. Ha a szélesség nem elegendő a gombok megjelenítéséhez, a kérdés legördülő menüt jelenít meg."
        },
        valuePropertyName: "Lehetővé teszi olyan kérdések összekapcsolását, amelyek különböző formátumú eredményeket hoznak. Ha az ilyen kérdések illesztési azonosítóval vannak összekapcsolva, ez a megosztott tulajdonság tárolja a kiválasztott kérdésértékeket.",
        searchEnabled: "Válassza ki, ha frissíteni szeretné a legördülő menü tartalmát, hogy megfeleljen a felhasználó által a beviteli mezőbe beírt keresési lekérdezésnek.",
        valueTrue: "Olyan érték, amelyet meg kell menteni a felmérés eredményeiben, amikor a válaszadók pozitív választ adnak.",
        valueFalse: "A felmérés eredményeiben mentendő érték, ha a válaszadók negatív választ adnak.",
        showPreview: "Nem ajánlott letiltani ezt a beállítást, mivel felülbírálja az előnézeti képet, és megnehezíti a felhasználó számára annak megértését, hogy a fájlok fel lettek-e töltve.",
        needConfirmRemoveFile: "A fájl törlésének megerősítését kérő üzenet jelenik meg.",
        selectToRankEnabled: "Engedélyezésével csak a kiválasztott választásokat rangsorolhatja. A felhasználók a kiválasztott elemeket az adatválaszték-listából húzzák, hogy a rangsorolási területen belül rendezzék őket.",
        dataList: "Adja meg azoknak a választási lehetőségeknek a listáját, amelyeket a rendszer javasolni fog a válaszadónak a bevitel során.",
        itemSize: "A beállítás csak a beviteli mezőket méretezi át, és nincs hatással a kérdésmező szélességére.",
        itemTitleWidth: "Konzisztens szélességet állít be az összes elemfelirathoz képpontban",
        altText: "Helyettesítőként szolgál, ha a kép nem jeleníthető meg a felhasználó eszközén, valamint kisegítő lehetőségek céljából.",
        rateColorMode: "Meghatározza a kiválasztott hangulatjel színét, ha az Értékelés ikon típusa \"Hangulatjelek\". Válasszon a következők közül: \"Alapértelmezett\" - a kiválasztott hangulatjel alapértelmezett felmérési színben jelenik meg; \"Skála\" - a kiválasztott hangulatjel örökli a színt a minősítési skálától.",
        expression: {
            name: "Olyan kifejezésazonosító, amely nem látható a válaszadók számára.",
            description: "Írja be a kifejezés alcímét.",
            expression: "A kifejezések tartalmazhatnak alapvető számításokat ('{q1_id} + {q2_id}'), feltételeket ('{age} > 60') és függvényeket ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' stb.)."
        },
        storeOthersAsComment: "Válassza ezt a lehetőséget, ha az \"Egyéb\" beállítás értékét külön tulajdonságként szeretné tárolni a felmérés eredményeiben.",
        format: "Használja {0} a tényleges érték helyőrzőjeként.",
        acceptedTypes: "További információt az [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribútum leírásában talál.",
        columnColCount: "Csak a Radiogroup és a Checkbox cellatípusokra vonatkozik.",
        autocomplete: "További információkért tekintse meg az [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribútum leírását.",
        filePlaceholder: "Akkor érvényes, ha a \"Forrás típusa\" \"Helyi fájlok\", vagy ha a kamera nem érhető el",
        photoPlaceholder: "Akkor érvényes, ha a \"Forrás típusa\" a \"Kamera\".",
        fileOrPhotoPlaceholder: "Akkor érvényes, ha a \"Forrás típusa\" értéke \"Helyi fájlok vagy kamera\".",
        masksettings: {
            saveMaskedValue: "Válassza ki, ha a kérdés értékét alkalmazott maszkkal szeretné tárolni a felmérés eredményeiben."
        },
        patternmask: {
            pattern: "A minta karakterlánc-konstansokat és a következő helyőrzőket tartalmazhatja: \"9\" - egy számjegyhez; \"a\" - kis- vagy nagybetű esetében; '#' - számjegy vagy kis- vagy nagybetű. A fordított perjel használata \"\\\" a karakter elhagyásához."
        },
        datetimemask: {
            pattern: "A minta elválasztó karaktereket és a következő helyőrzőket tartalmazhatja:<br>'m' - Hónap száma.<br>\"mm\" – A hónap száma, az első nullával az egyjegyű értékek esetében. <br>'d' - a hónap napja. <br>'dd' – A hónap napja, az első nullával az egyjegyű értékek esetében. <br>\"yy\" – Az év utolsó két számjegye. <br>\"yyyy\" – négy számjegyű évszám. <br>\"H\" – órák száma 24 órás formátumban. <br>'HH' – Órák 24 órás formátumban, az első nullával az egyjegyű értékek esetében. <br>\"h\" – órák száma 12 órás formátumban. <br>'hh' – Órák 12 órás formátumban, az első nullával az egyjegyű értékek esetében. <br>\"MM\" - perc. <br>'ss' - másodperc. <br>\"TT\" – 12 órás időszámítás nagybetűvel (AM/PM). <br>\"tt\" - 12 órás időtartam kisbetűvel (am/pm)."
        },
        numericmask: {
            decimalSeparator: "A törtrész és a megjelenített szám egész részének elválasztására szolgáló szimbólum.",
            thousandsSeparator: "Egy szimbólum, amely nagy szám számjegyeit három csoportba sorolja.",
            precision: "Korlátozza, hogy hány számjegy maradjon meg a megjelenített szám tizedesvesszője után."
        },
        currencymask: {
            prefix: "Egy vagy több szimbólum jelenik meg az érték előtt.",
            suffix: "Egy vagy több szimbólum jelenik meg az érték után."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "Cím",
            title: "Hagyja üresen, ha megegyezik a 'Megnevezés'-el"
        },
        multiSelect: "Többszörös kijelölés engedélyezése",
        showLabel: "Képfeliratok megjelenítése",
        swapOrder: "Az Igen és a Nem sorrendjének felcserélése",
        value: "Érték",
        tabAlign: "Tabulátorigazítás",
        sourceType: "Forrás típusa",
        fitToContainer: "Tárolóhoz igazítás",
        setValueExpression: "Értékkifejezés beállítása",
        description: "Leírás",
        logoFit: "Logó illeszkedés",
        pages: "Oldalak",
        questions: "Kérdések",
        triggers: "Eseményvezérlők",
        calculatedValues: "Számított értékek",
        surveyId: "Felmérés azonosítója",
        surveyPostId: "Felmérés bejegyzésének azonosítója",
        surveyShowDataSaving: "A felmérés adatmentést mutat",
        questionDescriptionLocation: "Kérdés leírása, helye",
        progressBarType: "Folyamatjelző sáv típusa",
        showTOC: "Tartalomjegyzék megjelenítése",
        tocLocation: "Tartalomjegyzék helye",
        questionTitlePattern: "Kérdés címének mintája",
        widthMode: "Szélesség mód",
        showBrandInfo: "Márkainformációk megjelenítése",
        useDisplayValuesInDynamicTexts: "Megjelenítési értékek használata dinamikus szövegekben",
        visibleIf: "Látható ha",
        defaultValueExpression: "Alapértelmezett értékkifejezés",
        requiredIf: "Kötelező ha",
        resetValueIf: "Érték visszaállítása, ha",
        setValueIf: "Érték beállítása, ha",
        validators: "Validátorok",
        bindings: "Kötések",
        renderAs: "Renderelés mint",
        attachOriginalItems: "Eredeti elemek csatolása",
        choices: "Lehetőségek",
        choicesByUrl: "Lehetőségek a webről",
        currency: "Pénz",
        cellHint: "Cella-tipp",
        totalMaximumFractionDigits: "Törtszámjegyek teljes száma",
        totalMinimumFractionDigits: "Minimális törtszámjegyek összesen",
        columns: "Oszlopok",
        detailElements: "Részletelemek",
        allowAdaptiveActions: "Adaptív műveletek engedélyezése",
        defaultRowValue: "Sor alapértelmezett értéke",
        detailPanelShowOnAdding: "A részletek panel megjelenítése hozzáadáskor",
        choicesLazyLoadEnabled: "Választási lehetőségek lusta betöltés engedélyezve",
        choicesLazyLoadPageSize: "Választási lehetőségek lusta betöltési oldalméret",
        inputFieldComponent: "Beviteli mező összetevő",
        itemComponent: "Elem összetevő",
        min: "Min",
        max: "Max",
        minValueExpression: "Minimális érték kifejezése",
        maxValueExpression: "Max. érték kifejezés",
        step: "Lépés",
        dataList: "Adatlista",
        itemSize: "Elem mérete",
        itemTitleWidth: "Elemcímke szélessége (képpontban)",
        elements: "Elemek",
        content: "Tartalom",
        navigationButtonsVisibility: "Navigációs gombok láthatósága",
        navigationTitle: "Navigációs cím",
        navigationDescription: "Navigáció leírása",
        longTap: "Hosszú koppintás",
        autoGrow: "Automatikus növekedés",
        allowResize: "Átméretezés engedélyezése",
        acceptCarriageReturn: "Kocsivissza elfogadása",
        displayMode: "Megjelenítési mód",
        rateType: "Ár típusa",
        label: "Cimke",
        contentMode: "Tartalom mód",
        imageFit: "Kép illeszkedése",
        altText: "Helyettesítő szöveg",
        height: "Magasság",
        penColor: "Toll színe",
        backgroundColor: "Háttérszín",
        templateElements: "Sablon elemek",
        operator: "Operátor",
        isVariable: "Változó",
        runExpression: "Kifejezés futtatása",
        showCaption: "Felirat megjelenítése",
        iconName: "Ikon neve",
        iconSize: "Ikon mérete",
        precision: "Precizitás",
        matrixDragHandleArea: "Mátrix húzófogantyújának területe",
        backgroundImage: "Háttérkép",
        backgroundImageFit: "Háttérkép illesztése",
        backgroundImageAttachment: "Háttérkép melléklet",
        backgroundOpacity: "Háttér átlátszatlansága",
        selectToRankEnabled: "Válassza ki a rangsorolás engedélyezéséhez",
        selectToRankAreasLayout: "Válassza ki a területek elrendezésének rangsorolásához",
        selectToRankEmptyRankedAreaText: "Megjelenítendő szöveg, ha az összes beállítás ki van jelölve",
        selectToRankEmptyUnrankedAreaText: "A rangsorolási terület helyőrző szövege",
        allowCameraAccess: "Kamera-hozzáférés engedélyezése",
        scaleColorMode: "Színmód méretezése",
        rateColorMode: "Értékelje a színmódot",
        copyDisplayValue: "Megjelenített érték másolása",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Speciális mód",
        pageTitle: "Oldalcím betűtípusa",
        questionTitle: "Kérdés címének betűtípusa",
        editorPanel: "Bemeneti elem",
        lines: "Sorok",
        primaryDefaultColor: "Alapértelmezett",
        primaryDarkColor: "Lebeg",
        primaryLightColor: "Kiválasztott",
        backgroundDimColor: "Háttérszín",
        cornerRadius: "Sarok sugara",
        backcolor: "Alapértelmezett háttér",
        hovercolor: "Háttér rámutatása",
        borderDecoration: "Szegély dekoráció",
        fontColor: "Betűszín",
        backgroundColor: "Háttérszín",
        primaryForecolor: "Alapértelmezett szín",
        primaryForecolorLight: "Letiltott szín",
        font: "Betűkészlet",
        borderDefault: "Sötétebb",
        borderLight: "Öngyújtó",
        fontFamily: "Betűcsalád",
        fontWeightRegular: "Rendszeres",
        fontWeightHeavy: "Nehéz",
        fontWeightSemiBold: "Félig félkövér",
        fontWeightBold: "Merész",
        color: "Szín",
        placeholderColor: "Helyőrző színe",
        size: "Méret",
        opacity: "Átlátszatlanság",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Árnyékhatás hozzáadása",
        boxShadowBlur: "Elken",
        boxShadowSpread: "Terjedés",
        boxShadowDrop: "Csepp",
        boxShadowInner: "Belső",
        names: {
            default: "Alapértelmezett",
            sharp: "Éles",
            borderless: "Szegély nélküli",
            flat: "Lapos",
            plain: "Síkság",
            doubleborder: "Dupla szegély",
            layered: "Rakott",
            solid: "Szilárd",
            threedimensional: ".3D",
            contrast: "Kontraszt"
        },
        colors: {
            teal: "Kékeszöld",
            blue: "Kék",
            purple: "Lila",
            orchid: "Orchidea",
            tulip: "Tulipán",
            brown: "Barna",
            green: "Zöld"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["hu"] = huStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// survey.addLogicItem: "Create a rule to customize the flow of the survey." => "Hozzon létre egy szabályt a felmérés folyamatának testreszabásához."
// survey.duplicate: "Duplicate" => "Ismétlődő"
// qt.ranking: "Ranking" => "Rangú"
// qt.image: "Image" => "Kép"
// qt.tagbox: "Multi-Select Dropdown" => "Többszörös kijelölés legördülő menü"
// qt.signaturepad: "Signature" => "Aláírás"
// qt.buttongroup: "Button Group" => "Gombcsoport"
// ed.settingsTooltip: "Open settings" => "Nyissa meg a beállításokat"
// ed.surveySettings: "Survey Settings" => "Földmérési beállítások"
// ed.surveySettingsTooltip: "Open survey settings" => "Nyissa meg a felmérési beállításokat"
// ed.showPanel: "Show Panel" => "Panel megjelenítése"
// ed.hidePanel: "Hide Panel" => "Panel elrejtése"
// ed.prevSelected: "Select previous" => "Előző kiválasztása"
// ed.nextSelected: "Select next" => "Válassza a következőt"
// ed.surveyTypeName: "Survey" => "Felmérés"
// ed.pageTypeName: "Page" => "Oldal"
// ed.panelTypeName: "Panel" => "Panel"
// ed.questionTypeName: "Question" => "Kérdés"
// ed.columnTypeName: "Column" => "Oszlop"
// ed.themeSurvey: "Themes" => "Témák"
// ed.defaultV2Theme: "Default" => "Alapértelmezett"
// ed.modernTheme: "Modern" => "Modern"
// ed.defaultTheme: "Default (legacy)" => "Alapértelmezett (örökölt)"
// ed.navigateToMsg: "You had to navigate to" => "Navigálnia kellett"
// ed.logic: "Logic" => "Logika"
// ed.saveSurveyTooltip: "Save Survey" => "Felmérés mentése"
// ed.jsonHideErrors: "Hide errors" => "Hibák elrejtése"
// ed.jsonShowErrors: "Show errors" => "Hibák megjelenítése"
// ed.undoTooltip: "Undo last change" => "Utolsó módosítás visszavonása"
// ed.redoTooltip: "Redo the change" => "Ismételje meg a módosítást"
// ed.showMoreChoices: "Show more" => "Bővebben"
// ed.showLessChoices: "Show less" => "Rövidebben"
// ed.copy: "Copy" => "Másolat"
// ed.cut: "Cut" => "Vág"
// ed.paste: "Paste" => "Paszta"
// ed.copyTooltip: "Copy selection to clipboard" => "Kijelölés másolása a vágólapra"
// ed.cutTooltip: "Cut selection to clipboard" => "Kijelölés kivágása a vágólapra"
// ed.pasteTooltip: "Paste from clipboard" => "Beillesztés vágólapról"
// ed.property-grid: "Properties" => "Kellékek"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "Írja be a kereséshez..."
// ed.toolboxChoiceCategory: "Choice Questions" => "Választási kérdések"
// ed.toolboxTextCategory: "Text Input Questions" => "Szövegbeviteli kérdések"
// ed.toolboxContainersCategory: "Containers" => "Konténerek"
// ed.toolboxMatrixCategory: "Matrix Questions" => "Mátrix kérdések"
// ed.toolboxMiscCategory: "Misc" => "Misc"
// ed.propertyEditorError: "Error" => "Hiba"
// ed.translationPropertyGridTitle: "Language Settings" => "Nyelvi beállítások"
// ed.themePropertyGridTitle: "Theme Settings" => "Téma beállítások"
// ed.translationLanguages: "Languages" => "Nyelvek"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "Csak használt karakterláncok"
// ed.translationPlaceHolder: "Translation..." => "Fordítás..."
// ed.themeExportButton: "Export" => "Kivitel"
// ed.themeImportButton: "Import" => "Importál"
// ed.selectPage: "Select page..." => "Válasszon oldalt..."
// ed.carryForwardChoicesCopied: "Choices are copied from" => "A választási lehetőségek másolása innen történik"
// ed.htmlPlaceHolder: "HTML content will be here." => "A HTML tartalom itt lesz."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "Itt dobjon el egy kérdést az eszköztárból."
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "A felmérés üres. Húzzon egy elemet az eszköztárról, vagy kattintson az alábbi gombra."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Húzzon ide egy képet, vagy kattintson az alábbi gombra, és válassza ki a feltölteni kívánt képet"
// ed.imageChooseImage: "Choose Image" => "Válassza a Kép lehetőséget"
// ed.addNewTypeQuestion: "Add {0}" => "{0} hozzáadása"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[LOGÓ]"
// ed.auto: "auto" => "kocsi"
// ed.choices_Item: "Item " => "Cikk "
// lg.addNewItem: "Add New Rule" => "Új szabály hozzáadása"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "Hozzon létre egy szabályt a felmérés folyamatának testreszabásához."
// lg.page_visibilityName: "Show (hide) page" => "Oldal megjelenítése (elrejtése)"
// lg.page_enableName: "Enable (disable) page" => "Oldal engedélyezése (letiltása)"
// lg.panel_visibilityName: "Show (hide) panel" => "Panel megjelenítése (elrejtése)"
// lg.panel_enableName: "Enable (disable) panel" => "Panel engedélyezése (letiltása)"
// lg.question_visibilityName: "Show (hide) question" => "Kérdés megjelenítése (elrejtése)"
// lg.question_enableName: "Enable (disable) question" => "Kérdés engedélyezése (letiltása)"
// lg.question_requireName: "Make question required" => "Kérdés feltevése kötelező"
// lg.column_visibilityName: "Show (hide) column" => "Oszlop megjelenítése (elrejtése)"
// lg.column_enableName: "Enable (disable) column" => "Oszlop engedélyezése (letiltása)"
// lg.column_requireName: "Make column required" => "Oszlop kötelezővé tétele"
// lg.trigger_completeName: "Complete survey" => "Teljes felmérés"
// lg.trigger_setvalueName: "Set answer" => "Válasz beállítása"
// lg.trigger_copyvalueName: "Copy answer" => "Válasz másolása"
// lg.trigger_skipName: "Skip to question" => "Ugrás a kérdésre"
// lg.trigger_runExpressionName: "Run expression" => "Kifejezés futtatása"
// lg.completedHtmlOnConditionName: "Set \"Survey Complete\" page markup" => "A \"Felmérés kész\" oldaljelölés beállítása"
// lg.page_visibilityDescription: "Make the page visible when the logic expression returns true. Otherwise keep it invisible." => "Tegye láthatóvá az oldalt, ha a logikai kifejezés igaz értéket ad vissza. Ellenkező esetben tartsa láthatatlanul."
// lg.panel_visibilityDescription: "Make the panel visible when the logic expression returns true. Otherwise keep it invisible." => "Tegye láthatóvá a panelt, ha a logikai kifejezés igaz értéket ad vissza. Ellenkező esetben tartsa láthatatlanul."
// lg.panel_enableDescription: "Make the panel, and all elements inside it, enable when the logic expression returns true. Otherwise keep them disabled." => "Engedélyezze a panelt és a benne lévő összes elemet, ha a logikai kifejezés igaz értéket ad vissza. Ellenkező esetben tartsa őket letiltva."
// lg.question_visibilityDescription: "Make the question visible when the logic expression returns true. Otherwise keep it invisible." => "Tegye láthatóvá a kérdést, ha a logikai kifejezés igaz értéket ad vissza. Ellenkező esetben tartsa láthatatlanul."
// lg.question_enableDescription: "Make the question enable when the logic expression returns true. Otherwise keep it disabled." => "Engedélyezze a kérdést, ha a logikai kifejezés igaz értéket ad vissza. Ellenkező esetben tartsa letiltva."
// lg.question_requireDescription: "Question becomes required when the logic expression returns true." => "A kérdés akkor válik kötelezővé, ha a logikai kifejezés igaz értéket ad vissza."
// lg.trigger_completeDescription: "When the logic expression returns true then the survey becomes completed and an end-user see the 'Thank you page'." => "Amikor a logikai kifejezés igaz értéket ad vissza, a felmérés befejeződik, és a végfelhasználó a \"Köszönöm oldalt\" látja."
// lg.trigger_setvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value is set to the selected question." => "Ha a logikai kifejezésben használt kérdésértékek megváltoznak, és a logikai kifejezés igaz értéket ad vissza, akkor az érték a kiválasztott kérdésre lesz beállítva."
// lg.trigger_copyvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value of one selected question is copied to another selected question." => "Ha a logikai kifejezésben használt kérdésértékek megváltoznak, és a logikai kifejezés igaz értéket ad vissza, akkor az egyik kiválasztott kérdés értéke átmásolódik egy másik kijelölt kérdésbe."
// lg.trigger_skipDescription: "When the logic expression returns true then the survey skip to / focus the selected question." => "Ha a logikai kifejezés igaz értéket ad vissza, akkor a felmérés a kiválasztott kérdésre ugrik/fókuszál."
// lg.trigger_runExpressionDescription: "When the logic expression returns true, then the custom expression is performed. You may optionally set this expression result into the selected question" => "Ha a logikai kifejezés igaz értéket ad vissza, a rendszer végrehajtja az egyéni kifejezést. Ezt a kifejezéseredményt opcionálisan beállíthatja a kiválasztott kérdésbe"
// lg.completedHtmlOnConditionDescription: "If the logic expression returns true, then the default text for the 'Thank you page' is changed to the given one." => "Ha a logikai kifejezés igaz értéket ad vissza, akkor a \"Köszönöm oldal\" alapértelmezett szövege a megadott szövegre változik."
// lg.itemExpressionText: "When expression: '{0}' returns true" => "Amikor a kifejezés: \"{0}\" igaz értéket ad vissza"
// lg.itemEmptyExpressionText: "New rule" => "Új szabály"
// lg.page_visibilityText: "make page {0} visible" => "Az oldal {0} láthatóvá tétele"
// lg.panel_visibilityText: "make panel {0} visible" => "A panel {0} láthatóvá tétele"
// lg.panel_enableText: "make panel {0} enable" => "A panel {0} engedélyezése"
// lg.question_visibilityText: "make question {0} visible" => "tegye láthatóvá a {0} kérdést"
// lg.question_enableText: "make question {0} enable" => "Kérdés {0} engedélyezése"
// lg.question_requireText: "make question {0} required" => "Tegye fel a kérdést {0} szükséges"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "A {1}. kérdés {0} oszlopának láthatóvá tétele"
// lg.column_enableText: "make column {0} of question {1} enable" => "A kérdés {0} oszlopának engedélyezése {1} engedélyezése"
// lg.column_requireText: "make column {0} of question {1} required" => "Tegye kötelezővé a kérdés {0} oszlopát {1}"
// lg.trigger_completeText: "survey becomes completed" => "A felmérés befejeződött"
// lg.trigger_setvalueText: "set into question: {0} value {1}" => "Kérdéses érték: {0} érték {1}"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "Egyértelmű kérdésérték: {0}"
// lg.trigger_copyvalueText: "copy into question: {0} value from question {1}" => "Másolás kérdésbe: {0} kérdés értéke {1}"
// lg.trigger_skipText: "survey skip to the question {0}" => "felmérés ugrás a kérdésre {0}"
// lg.trigger_runExpressionText1: "run expression: '{0}'" => "Run kifejezés: '{0}'"
// lg.trigger_runExpressionText2: " and set its result into question: {0}" => " és megkérdőjelezi annak eredményét: {0}"
// lg.completedHtmlOnConditionText: "show custom text for the 'Thank you page'." => "egyéni szöveg megjelenítése a \"Köszönöm oldalhoz\"."
// lg.showAllQuestions: "All Questions" => "Minden kérdés"
// lg.showAllActionTypes: "All Action Types" => "Minden művelettípus"
// lg.conditions: "Condition(s)" => "Állapot(ok)"
// lg.actions: "Action(s)" => "Művelet(ek)"
// lg.expressionEditorTitle: "Define condition(s)" => "Feltétel(ek) meghatározása"
// lg.actionsEditorTitle: "Define action(s)" => "Művelet(ek) meghatározása"
// lg.deleteAction: "Delete Action" => "Művelet törlése"
// lg.addNewAction: "Add Action" => "Művelet hozzáadása"
// lg.selectedActionCaption: "Select action..." => "Válassza ki a műveletet..."
// lg.expressionInvalid: "The logic expression is empty or invalid. Please correct it." => "A logikai kifejezés üres vagy érvénytelen. Kérjük, javítsa ki."
// lg.noActionError: "Please, add at least one action." => "Kérjük, adjon hozzá legalább egy műveletet."
// lg.actionInvalid: "Please, fix problems in your action(s)." => "Kérjük, javítsa ki a problémákat a művelet(ek)ben."
// lg.uncompletedRule_title: "Logical rules are incomplete" => "A logikai szabályok hiányosak"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Nem teljesített néhány logikai szabályt. Ha most elhagyja a lapot, a módosítások elvesznek. Továbbra is el akarja hagyni a lapot a módosítások végrehajtása nélkül?"
// lg.uncompletedRule_apply: "Yes" => "Igen"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Nem, szeretném kiegészíteni a szabályokat"
// pe.save: "Save" => "Megment"
// pe.clear: "Clear" => "Világos"
// pe.saveTooltip: "Save" => "Megment"
// pe.set: "Set" => "Beállít"
// pe.change: "Change" => "Változás"
// pe.refresh: "Refresh" => "Felfrissít"
// pe.add: "Add" => "Hozzáad"
// pe.removeItem: "Click to remove the item..." => "Kattintson az elem eltávolításához..."
// pe.dragItem: "Drag the item" => "Húzza az elemet"
// pe.back: "Return without saving" => "Visszaküldés mentés nélkül"
// pe.backTooltip: "Return without saving" => "Visszaküldés mentés nélkül"
// pe.saveAndBack: "Save and return" => "Mentés és visszaküldés"
// pe.saveAndBackTooltip: "Save and return" => "Mentés és visszaküldés"
// pe.doneEditing: "Done" => "Kész"
// pe.showChoices: "Show Choices" => "Választási lehetőségek megjelenítése"
// pe.emptyValue: "Value is empty" => "Az érték üres"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "A \"{0}\" érték nem egyedi"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "Kérjük, korlátozza a tételek számát {0} és {1} között"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "Az adatokat a következő formátumban állíthatja be:\nérték1|szöveg\nérték2"
// pe.itemSelectorEmpty: "Please select the element" => "Kérjük, válassza ki az elemet"
// pe.conditionActionEmpty: "Please select the action" => "Kérjük, válassza ki a műveletet"
// pe.conditionSelectPage: "Select page..." => "Válasszon oldalt..."
// pe.conditionSelectPanel: "Select panel..." => "Panel kiválasztása..."
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "A válaszok előnézete a felmérés elküldése előtt"
// pe.overridingPropertyPrefix: "Set by " => "Állítsa be "
// pe.propertyIsNoUnique: "Please enter a unique value" => "Kérjük, adjon meg egy egyedi értéket"
// pe.propertyNameIsNotUnique: "Please enter a unique name" => "Kérjük, adjon meg egy egyedi nevet"
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Ne használjon fenntartott szavakat: \"elem\", \"választás\", \"panel\", \"sor\"."
// pe.listIsEmpty: "No items have been added yet" => "Még nincsenek hozzáadott elemek"
// pe.listIsEmpty@choices: "No choices have been added yet" => "Még nincsenek választási lehetőségek hozzáadva"
// pe.addNew@choices: "Add a choice" => "Választási lehetőség hozzáadása"
// pe.expressionIsEmpty: "Expression is empty" => "A kifejezés üres"
// choicesbyurl.valueName: "Get values from the following JSON field" => "Értékek beolvasása a következő JSON-mezőből"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "Képek URL-címének beolvasása a következő JSON-mezőből"
// pe.allowEmptyResponse: "Allow empty response" => "Üres válasz engedélyezése"
// pe.titlePlaceholder: "Title" => "Cím"
// pe.surveyTitlePlaceholder: "Survey Title" => "Felmérés címe"
// pe.pageTitlePlaceholder: "Page {num}" => "Oldal {num}"
// pe.descriptionPlaceholder: "Description" => "Leírás: __________"
// pe.surveyDescriptionPlaceholder: "Description" => "Leírás: __________"
// pe.pageDescriptionPlaceholder: "Description" => "Leírás: __________"
// pe.showNoneItem: "Allow the None option" => "A Nincs lehetőség engedélyezése"
// pe.noneText: "None option text" => "Nincs opció szövege"
// pe.showSelectAllItem: "Allow the Select All option" => "Az összes kijelölése lehetőség engedélyezése"
// pe.selectAllText: "Select All option text" => "Az Összes kijelölése opció szövege"
// pe.choicesMin: "Minimum value for auto-generated items" => "Az automatikusan létrehozott elemek minimális értéke"
// pe.choicesMax: "Maximum value for auto-generated items" => "Az automatikusan létrehozott elemek maximális értéke"
// pe.choicesStep: "Step for auto-generated items" => "Az automatikusan létrehozott elemek lépése"
// pe.isAllRowRequired: "Require answer for all rows" => "Válasz kérése minden sorhoz"
// pe.requiredErrorText: "\"Required\" error message" => "\"Kötelező\" hibaüzenet"
// pe.cols: "Columns" => "Oszlopok"
// pe.buildExpression: "Build" => "Épít"
// pe.editExpression: "Edit" => "Szerkeszt"
// pe.and: "and" => "és"
// pe.or: "or" => "vagy"
// pe.remove: "Remove" => "Eltávolít"
// pe.addCondition: "Add Condition" => "Feltétel hozzáadása"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Válasszon ki egy kérdést a feltételek konfigurálásának megkezdéséhez."
// pe.if: "If" => "Ha"
// pe.then: "then" => "akkor"
// pe.setToName: "Target question" => "Célkérdés"
// pe.fromName: "Question to copy answer from" => "Másolandó kérdés innen: válasz"
// pe.gotoName: "Question to skip to" => "Kérdés, amelyre ugrani kell"
// pe.ruleIsNotSet: "Rule is incorrect" => "A szabály helytelen"
// pe.includeIntoResult: "Include into survey results" => "Felvétel a felmérés eredményeibe"
// pe.expandCollapseTitle: "Expand/collapse title" => "Cím kibontása/összecsukása"
// pe.simulator: "Select device type" => "Válassza ki az eszköz típusát"
// pe.landscapeOrientation: "Switch to landscape orientation" => "Váltás fekvő tájolásra"
// pe.portraitOrientation: "Switch to portrait orientation" => "Váltás álló tájolásra"
// pe.previewText: "Preview Answers button text" => "A Válaszok előnézete gomb szövege"
// pe.editText: "Edit Answer button text" => "A Válasz gomb szövegének szerkesztése"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Képmagasság (CSS által elfogadott értékekben)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Képszélesség (CSS által elfogadott értékekben)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "Az oldal befejezésének határideje (másodpercben)"
// question.page: "Parent page" => "Szülőoldal"
// pe.noEntriesText: "Empty entries text" => "Üres bejegyzések szövege"
// pe.setValue: "Answer" => "Válasz"
// pe.dataFormat: "Image format" => "Képformátum"
// pe.allowAddRows: "Allow adding rows" => "Sorok hozzáadásának engedélyezése"
// pe.allowRemoveRows: "Allow removing rows" => "Sorok eltávolításának engedélyezése"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "Sorhúzás engedélyezése"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "Nem érvényes, ha megadja a kép pontos szélességét vagy magasságát."
// pe.minImageWidth: "Minimum image width" => "Minimális képszélesség"
// pe.maxImageWidth: "Maximum image width" => "Maximális képszélesség"
// pe.minImageHeight: "Minimum image height" => "Minimális képmagasság"
// pe.maxImageHeight: "Maximum image height" => "Maximális képmagasság"
// surveyvalidator.text: "Error message" => "Hibaüzenet"
// surveyvalidator.expression: "Validation expression" => "Érvényesítési kifejezés"
// pe.totalText: "Total row text" => "Sorszöveg összesen"
// pe.totalType: "Total type" => "Teljes típus"
// pe.totalExpression: "Total expression" => "Teljes kifejezés"
// pe.totalDisplayStyle: "Total value display style" => "Teljes érték megjelenítési stílusa"
// pe.totalCurrency: "Currency" => "Valuta"
// pe.totalFormat: "Formatted string" => "Formázott karakterlánc"
// pe.logo: "Logo (URL or base64-encoded string)" => "Embléma (URL vagy base64 kódolású karakterlánc)"
// pe.questionsOnPageMode: "Survey structure" => "Felmérési struktúra"
// pe.maxTextLength: "Maximum answer length (in characters)" => "Válasz maximális hossza (karakterben)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "Megjegyzés maximális hossza (karakterben)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "Szükség esetén automatikusan bontsa ki a megjegyzésterületet"
// pe.allowResizeComment: "Allow users to resize text areas" => "A szövegterületek átméretezésének engedélyezése a felhasználók számára"
// pe.textUpdateMode: "Update text question value" => "Szöveges kérdés értékének frissítése"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "Fókusz beállítása az első érvénytelen válaszra"
// pe.checkErrorsMode: "Run validation" => "Érvényesítés futtatása"
// pe.navigateToUrl: "Navigate to URL" => "Navigálás az URL-hez"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "Dinamikus URL"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "Jelölés annak jelzésére, hogy a felhasználó kitöltötte-e már ezt a felmérést"
// pe.completedHtml: "Survey Complete page markup" => "Felmérés teljes oldaljelölése"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "Dinamikus felmérés teljes oldaljelölése"
// pe.loadingHtml: "Markup to show while survey model is loading" => "A földmérési modell betöltése közben megjelenítendő jelölés"
// pe.commentText: "Comment area text" => "Megjegyzés terület szövege"
// pe.autocomplete: "Autocomplete type" => "Automatikus kiegészítés típusa"
// pe.labelTrue: "\"True\" label" => "\"Igaz\" címke"
// pe.labelFalse: "\"False\" label" => "\"Hamis\" címke"
// pe.allowClear: "Show the Clear button" => "A Törlés gomb megjelenítése"
// pe.displayStyle: "Value display style" => "Értékmegjelenítési stílus"
// pe.format: "Formatted string" => "Formázott karakterlánc"
// pe.maximumFractionDigits: "Maximum fractional digits" => "Tört számjegyek maximális száma"
// pe.minimumFractionDigits: "Minimum fractional digits" => "Minimális tört számjegyek"
// pe.useGrouping: "Display grouping separators" => "Csoportosítási elválasztók megjelenítése"
// pe.allowMultiple: "Allow multiple files" => "Több fájl engedélyezése"
// pe.allowImagesPreview: "Preview images" => "Képek előnézete"
// pe.acceptedTypes: "Accepted file types" => "Elfogadott fájltípusok"
// pe.waitForUpload: "Wait for the upload to complete" => "Várja meg, amíg a feltöltés befejeződik"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "Fájltörlés megerősítése"
// pe.detailPanelMode: "Detail panel location" => "A részletek panel helye"
// pe.minRowCount: "Minimum row count" => "Sorszám minimális száma"
// pe.maxRowCount: "Maximum row count" => "Sorszám maximális száma"
// pe.confirmDelete: "Confirm row deletion" => "Sor törlésének megerősítése"
// pe.confirmDeleteText: "Confirmation message" => "Megerősítő üzenet"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "Panel törlésének megerősítése"
// pe.panelCount: "Initial panel count" => "Kezdeti panelszám"
// pe.minPanelCount: "Minimum panel count" => "Panelek minimális száma"
// pe.maxPanelCount: "Maximum panel count" => "Panelek maximális száma"
// pe.panelsState: "Inner panel expand state" => "Belső panel kibontási állapota"
// pe.templateDescription: "Description template" => "Leíró sablon"
// pe.templateTitle: "Title template" => "Cím sablon"
// pe.panelPrevText: "Previous Panel button tooltip" => "Előző Panel gomb eszköztipp"
// pe.panelNextText: "Next Panel button tooltip" => "Következő Panel gomb elemleírása"
// pe.showRangeInProgress: "Show progress bar" => "Folyamatjelző sáv megjelenítése"
// pe.templateTitleLocation: "Question title location" => "Kérdés címének helye"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "A Panel gomb helyének eltávolítása"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "A kérdés elrejtése, ha nincsenek sorok"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Oszlopok elrejtése, ha nincsenek sorok"
// pe.rateValues: "Custom rate values" => "Egyéni díjértékek"
// pe.rateCount: "Rate count" => "Árak száma"
// pe.autoGenerate: "How to specify rate values?" => "Hogyan lehet megadni a díjértékeket?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "A kérdés elrejtése, ha nem tartalmaz választási lehetőségeket"
// pe.hideNumber: "Hide question number" => "Kérdés számának elrejtése"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Minimális szélesség (CSS által elfogadott értékekben)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Maximális szélesség (CSS által elfogadott értékekben)"
// pe.width: "Width (in CSS-accepted values)" => "Szélesség (CSS által elfogadott értékekben)"
// pe.showHeader: "Show column headers" => "Oszlopfejlécek megjelenítése"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Vízszintes görgetősáv megjelenítése"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Minimális oszlopszélesség (CSS által elfogadott értékekben)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Sorfejléc szélessége (CSS által elfogadott értékekben)"
// pe.valueTrue: "\"True\" value" => "\"Igaz\" érték"
// pe.valueFalse: "\"False\" value" => "\"Hamis\" érték"
// pe.minErrorText: "\"Value is below minimum\" error message" => "\"Az érték a minimális érték alatt van\" hibaüzenet"
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "\"Az érték meghaladja a maximumot\" hibaüzenet"
// pe.otherErrorText: "\"Empty comment\" error message" => "\"Üres megjegyzés\" hibaüzenet"
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "\"Nem egyedi kulcsérték\" hibaüzenet"
// pe.minSelectedChoices: "Minimum selected choices" => "Minimálisan kiválasztott választási lehetőségek"
// pe.maxSelectedChoices: "Maximum selected choices" => "Maximális kijelölt választási lehetőségek"
// pe.showClearButton: "Show the Clear button" => "A Törlés gomb megjelenítése"
// pe.showNumber: "Show panel number" => "Panelszám megjelenítése"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "Embléma szélessége (CSS által elfogadott értékekben)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "Logó magassága (CSS által elfogadott értékekben)"
// pe.readOnly: "Read-only" => "Csak olvasható"
// pe.enableIf: "Editable if" => "Szerkeszthető, ha"
// pe.emptyRowsText: "\"No rows\" message" => "\"Nincsenek sorok\" üzenet"
// pe.size: "Input field size (in characters)" => "Beviteli mező mérete (karakterben)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "Külön speciális választási lehetőségek (Nincs, Egyéb, Összes kijelölése)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Másolja ki a következő kérdés választási lehetőségeit"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Milyen lehetőségeket másoljon?"
// pe.showCommentArea: "Show the comment area" => "A megjegyzésterület megjelenítése"
// pe.commentPlaceholder: "Comment area placeholder" => "Megjegyzés terület helyőrzője"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Sebességleírások megjelenítése extrém értékként"
// pe.rowsOrder: "Row order" => "Sorsorrend"
// pe.columnsLayout: "Column layout" => "Oszlopelrendezés"
// pe.columnColCount: "Nested column count" => "Beágyazott oszlopok száma"
// pe.state: "Panel expand state" => "Panel kibontási állapota"
// pe.correctAnswer: "Correct Answer" => "Helyes válasz"
// pe.defaultPanelValue: "Default Values" => "Alapértelmezett értékek"
// pe.cells: "Cell Texts" => "Cella szövegek"
// pe.keyName: "Key column" => "Fő oszlop"
// itemvalue.text: "Alt text" => "Helyettesítő szöveg"
// pe.logoPosition: "Logo position" => "Logó pozíciója"
// pe.addLogo: "Add logo..." => "Logó hozzáadása..."
// pe.changeLogo: "Change logo..." => "Logó módosítása..."
// logoPositions.none: "Remove logo" => "Embléma eltávolítása"
// logoPositions.left: "Left" => "Balra"
// logoPositions.right: "Right" => "Jobbra"
// logoPositions.top: "On the top" => "A tetején"
// logoPositions.bottom: "In the bottom" => "Alul"
// tabs.numbering: "Numbering" => "Számozás"
// tabs.pages: "Pages" => "Oldalak"
// tabs.calculatedValues: "Calculated Values" => "Számított értékek"
// tabs.totals: "Totals" => "Összegek"
// tabs.logic: "Logic" => "Logika"
// tabs.layout: "Layout" => "Elrendezés"
// tabs.data: "Data" => "Adat"
// tabs.validation: "Validation" => "Érvényesítés"
// tabs.cells: "Cell Texts" => "Cella szövegek"
// tabs.showOnCompleted: "Survey Complete" => "Felmérés kész"
// tabs.logo: "Logo in Survey Title" => "Embléma a felmérés címében"
// tabs.slider: "Slider" => "Csúszka"
// tabs.expression: "Expression" => "Kifejezés"
// tabs.others: "Others" => "Mások"
// pe.choicesVisibleIf: "Choices are visible if" => "A választási lehetőségek akkor láthatók, ha"
// pe.choicesEnableIf: "Choices are selectable if" => "A választási lehetőségek akkor választhatók ki, ha"
// pe.columnsEnableIf: "Columns are visible if" => "Az oszlopok akkor láthatók, ha"
// pe.rowsEnableIf: "Rows are visible if" => "A sorok akkor láthatók, ha"
// pe.indent: "Add indents" => "Behúzások hozzáadása"
// panel.indent: "Add outer indents" => "Külső behúzások hozzáadása"
// pe.innerIndent: "Add inner indents" => "Belső behúzások hozzáadása"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "Alapértelmezett értékek felvétele az utolsó sorból"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "Alapértelmezett értékek felvétele az utolsó panelről"
// pe.titleKeyboardAdornerTip: "Press enter button to edit" => "Nyomja meg az Enter gombot a szerkesztéshez"
// pe.keyboardAdornerTip: "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item" => "Nyomja meg az Enter gombot az elem szerkesztéséhez, nyomja meg a törlés gombot az elem törléséhez, nyomja meg az alt plusz felfelé vagy lefelé mutató nyilat az elem áthelyezéséhez"
// pe.triggerGotoName: "Go to the question" => "Tovább a kérdéshez"
// pe.triggerRunExpressionEmpty: "Please enter a valid expression" => "Kérjük, adjon meg egy érvényes kifejezést"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "Írja be ide a kifejezést..."
// pe.noFile: "No file choosen" => "Nincs kiválasztott fájl"
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "Az érték törlése, ha a kérdés rejtetté válik"
// pe.valuePropertyName: "Value property name" => "Értéktulajdonság neve"
// pe.searchEnabled: "Enable search" => "Keresés engedélyezése"
// pe.hideSelectedItems: "Hide selected items" => "A kijelölt elemek elrejtése"
// pe.closeOnSelect: "Close the dropdown after selection" => "A legördülő menü bezárása a kiválasztás után"
// pe.signatureWidth: "Signature width" => "Aláírás szélessége"
// pe.signatureHeight: "Signature height" => "Aláírási magasság"
// pe.verticalAlign: "Vertical alignment" => "Függőleges igazítás"
// pe.alternateRows: "Alternate rows" => "Alternatív sorok"
// pe.columnsVisibleIf: "Columns are visible if" => "Az oszlopok akkor láthatók, ha"
// pe.rowsVisibleIf: "Rows are visible if" => "A sorok akkor láthatók, ha"
// pe.otherPlaceholder: "Comment area placeholder" => "Megjegyzés terület helyőrzője"
// pe.rateType: "Rate type" => "Ár típusa"
// pv.true: "true" => "igaz"
// pv.false: "false" => "téves"
// pv.decimal: "decimal" => "tizedes"
// pv.currency: "currency" => "valuta"
// pv.percent: "percent" => "százalék"
// pv.onpanel: "Start on each panel" => "Kezdés az egyes paneleken"
// pv.tab: "Tabs" => "Lapfülek"
// pv.both: "Both" => "Mindkettő"
// pv.right: "Right" => "Jobbra"
// pv.color: "color" => "szín"
// pv.date: "date" => "dátum"
// pv.datetime: "datetime" => "Dátum/idő"
// pv.datetime-local: "datetime-local" => "datetime-local"
// pv.email: "email" => "E-mail"
// pv.month: "month" => "hónap"
// pv.number: "number" => "szám"
// pv.password: "password" => "jelszó"
// pv.range: "range" => "tartomány"
// pv.tel: "tel" => "Tel"
// pv.text: "text" => "SMS"
// pv.time: "time" => "Idő"
// pv.url: "url" => "URL-cím"
// pv.week: "week" => "hét"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "Amikor a kérdés vagy annak panelje/oldala rejtetté válik"
// clearInvisibleValues.none: "Never" => "Soha"
// inputType.color: "Color" => "Szín"
// inputType.date: "Date" => "Dátum"
// inputType.datetime-local: "Date and Time" => "Dátum és idő"
// inputType.email: "Email" => "E-mail"
// inputType.month: "Month" => "Hónap"
// inputType.number: "Number" => "Szám"
// inputType.password: "Password" => "Jelszó"
// inputType.range: "Range" => "Tartomány"
// inputType.tel: "Phone Number" => "Telefonszám"
// inputType.text: "Text" => "SMS"
// inputType.time: "Time" => "Idő"
// inputType.url: "URL" => "URL"
// inputType.week: "Week" => "Hét"
// pv.onValueChanging: "Before an answer is changed" => "A válasz módosítása előtt"
// pv.standard: "Original structure" => "Eredeti szerkezet"
// pv.singlePage: "All questions on a single page" => "Minden kérdés egyetlen oldalon"
// pv.questionPerPage: "Each question on an individual page" => "Minden kérdés egy adott oldalon"
// pv.noPreview: "No preview" => "Nincs előnézet"
// pv.showAllQuestions: "Show all questions" => "Az összes kérdés megjelenítése"
// pv.showAnsweredQuestions: "Show answered questions only" => "Csak a megválaszolt kérdések megjelenítése"
// pv.pages: "Completed pages" => "Befejezett oldalak"
// pv.questions: "Answered questions" => "Megválaszolt kérdések"
// pv.requiredQuestions: "Answered required questions" => "Megválaszolt kötelező kérdések"
// pv.correctQuestions: "Valid answers" => "Érvényes válaszok"
// pv.buttons: "Completed pages (button UI)" => "Befejezett oldalak (gombos felhasználói felület)"
// pv.underInput: "Under the input" => "A bemenet alatt"
// pv.underTitle: "Under the title" => "A cím alatt"
// pv.onBlur: "On blur" => "Elmosódáskor"
// pv.onTyping: "While typing" => "Gépelés közben"
// pv.underRow: "Under the row" => "A sor alatt"
// pv.underRowSingle: "Under the row, only one panel is visible" => "A sor alatt csak egy panel látható"
// showNavigationButtons.none: "Hidden" => "Rejtett"
// showProgressBar.off: "Hidden" => "Rejtett"
// showTimerPanel.none: "Hidden" => "Rejtett"
// showTimerPanelMode.all: "Both" => "Mindkettő"
// detailPanelMode.none: "Hidden" => "Rejtett"
// addRowLocation.default: "Depends on matrix layout" => "A mátrix elrendezésétől függ"
// panelsState.default: "Users cannot expand or collapse panels" => "A felhasználók nem bonthatják ki és nem csukhatják össze a paneleket"
// panelsState.collapsed: "All panels are collapsed" => "Minden panel össze van csukva"
// panelsState.expanded: "All panels are expanded" => "Minden panel ki van bontva"
// widthMode.auto: "Auto" => "Kocsi"
// widthMode.static: "Static" => "Statikus"
// widthMode.responsive: "Responsive" => "Fogékony"
// imageFit.none: "None" => "Egyik sem"
// imageFit.contain: "Contain" => "Tartalmaz"
// imageFit.cover: "Cover" => "Fedő"
// imageFit.fill: "Fill" => "Tölt"
// contentMode.auto: "Auto" => "Kocsi"
// contentMode.image: "Image" => "Kép"
// contentMode.video: "Video" => "Video"
// contentMode.youtube: "YouTube" => "Youtube-videók"
// displayMode.auto: "Auto" => "Kocsi"
// displayMode.buttons: "Buttons" => "Gombok"
// displayMode.dropdown: "Dropdown" => "Legördülő menü"
// rateColorMode.default: "Default" => "Alapértelmezett"
// autoGenerate.true: "Generate" => "Létrehoz"
// autoGenerate.false: "Enter manually" => "Manuális bevitel"
// rateType.labels: "Labels" => "Címkék"
// rateType.stars: "Stars" => "Csillagok"
// rateType.smileys: "Smileys" => "Hangulatjelek"
// op.anyof: "Any of" => "Bármelyike"
// op.allof: "All of" => "Az összes"
// op.and: "and" => "és"
// op.or: "or" => "vagy"
// ew.modern: "Modern theme" => "Modern téma"
// ew.default: "Default theme" => "Alapértelmezett téma"
// ew.orange: "Orange theme" => "Narancssárga téma"
// ew.darkblue: "Darkblue theme" => "Sötétkék téma"
// ew.darkrose: "Darkrose theme" => "Darkrose téma"
// ew.stone: "Stone theme" => "Kő téma"
// ew.winter: "Winter theme" => "Téli téma"
// ew.winterstone: "Winter-Stone theme" => "Téli-kő téma"
// ts.hideInvisibleElements: "Hide invisible elements" => "Láthatatlan elemek elrejtése"
// triggers.skiptrigger: "Skip to question" => "Ugrás a kérdésre"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "A cookie-k megakadályozzák, hogy a felhasználók kétszer töltsék ki ugyanazt a felmérést."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Átméretezi a beviteli mező látható területét. Kérjük, használja a <b>Validation → Maximum length</b> beállítást a bemeneti hossz korlátozásához."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Használja {0} a tényleges érték helyőrzőjeként."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Csak akkor látható, ha legalább egy oszlop Összeg típusú vagy Összeg kifejezéssel rendelkezik."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "További információt az [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribútum leírásában talál."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Csak a Radiogroup és a Checkbox cellatípusokra vonatkozik."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "További információkért tekintse meg az [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribútum leírását."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Ha nem állítja be ezt a tulajdonságot, a válasz a Name tulajdonságban megadott mezőben lesz tárolva."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Ha a megadott oszlop azonos értékeket tartalmaz, a felmérés a \"Nem egyedi kulcsérték\" hibát adja vissza."
// p.multiSelect: "Allow multiple selection" => "Többszörös kijelölés engedélyezése"
// p.showLabel: "Show image captions" => "Képfeliratok megjelenítése"
// p.value: "Value" => "Érték"
// p.tabAlign: "Tab alignment" => "Tabulátorigazítás"
// p.logoFit: "Logo fit" => "Logó illeszkedés"
// p.pages: "Pages" => "Oldalak"
// p.questions: "Questions" => "Kérdések"
// p.calculatedValues: "Calculated values" => "Számított értékek"
// p.surveyId: "Survey id" => "Felmérés azonosítója"
// p.surveyPostId: "Survey post id" => "Felmérés bejegyzésének azonosítója"
// p.surveyShowDataSaving: "Survey show data saving" => "A felmérés adatmentést mutat"
// p.questionDescriptionLocation: "Question description location" => "Kérdés leírása, helye"
// p.progressBarType: "Progress bar type" => "Folyamatjelző sáv típusa"
// p.showTOC: "Show TOC" => "Tartalomjegyzék megjelenítése"
// p.tocLocation: "Toc location" => "Tartalomjegyzék helye"
// p.questionTitlePattern: "Question title pattern" => "Kérdés címének mintája"
// p.widthMode: "Width mode" => "Szélesség mód"
// p.showBrandInfo: "Show brand info" => "Márkainformációk megjelenítése"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "Megjelenítési értékek használata dinamikus szövegekben"
// p.descriptionLocation: "Description location" => "Leírás, hely"
// p.defaultValueExpression: "Default value expression" => "Alapértelmezett értékkifejezés"
// p.bindings: "Bindings" => "Kötések"
// p.renderAs: "Render as" => "Renderelés mint"
// p.attachOriginalItems: "Attach original items" => "Eredeti elemek csatolása"
// p.cellHint: "Cell hint" => "Cella-tipp"
// p.isUnique: "Is unique" => "Egyedülálló"
// p.showInMultipleColumns: "Show in multiple columns" => "Megjelenítés több oszlopban"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Törtszámjegyek teljes száma"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Minimális törtszámjegyek összesen"
// p.detailElements: "Detail elements" => "Részletelemek"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Adaptív műveletek engedélyezése"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "A részletek panel megjelenítése hozzáadáskor"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Választási lehetőségek lusta betöltés engedélyezve"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Választási lehetőségek lusta betöltési oldalméret"
// p.inputFieldComponent: "Input field component" => "Beviteli mező összetevő"
// p.itemComponent: "Item component" => "Elem összetevő"
// p.min: "Min" => "Min"
// p.max: "Max" => "Max"
// p.minValueExpression: "Min value expression" => "Minimális érték kifejezése"
// p.maxValueExpression: "Max value expression" => "Max. érték kifejezés"
// p.step: "Step" => "Lépés"
// p.dataList: "Data list" => "Adatlista"
// p.elements: "Elements" => "Elemek"
// p.content: "Content" => "Tartalom"
// p.navigationTitle: "Navigation title" => "Navigációs cím"
// p.navigationDescription: "Navigation description" => "Navigáció leírása"
// p.longTap: "Long tap" => "Hosszú koppintás"
// p.autoGrow: "Auto grow" => "Automatikus növekedés"
// p.allowResize: "Allow resizing" => "Átméretezés engedélyezése"
// p.acceptCarriageReturn: "Accept carriage return" => "Kocsivissza elfogadása"
// p.displayMode: "Display mode" => "Megjelenítési mód"
// p.rateType: "Rate type" => "Ár típusa"
// p.contentMode: "Content mode" => "Tartalom mód"
// p.imageFit: "Image fit" => "Kép illeszkedése"
// p.altText: "Alt text" => "Helyettesítő szöveg"
// p.height: "Height" => "Magasság"
// p.penColor: "Pen color" => "Toll színe"
// p.backgroundColor: "Background color" => "Háttérszín"
// p.templateElements: "Template elements" => "Sablon elemek"
// p.operator: "Operator" => "Operátor"
// p.isVariable: "Is variable" => "Változó"
// p.runExpression: "Run expression" => "Kifejezés futtatása"
// p.showCaption: "Show caption" => "Felirat megjelenítése"
// p.iconName: "Icon name" => "Ikon neve"
// p.iconSize: "Icon size" => "Ikon mérete"
// p.precision: "Precision" => "Precizitás"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Mátrix húzófogantyújának területe"
// p.backgroundImage: "Background image" => "Háttérkép"
// p.backgroundImageFit: "Background image fit" => "Háttérkép illesztése"
// p.backgroundImageAttachment: "Background image attachment" => "Háttérkép melléklet"
// p.backgroundOpacity: "Background opacity" => "Háttér átlátszatlansága"
// p.selectToRankEnabled: "Select to rank enabled" => "Válassza ki a rangsorolás engedélyezéséhez"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Válassza ki a területek elrendezésének rangsorolásához"
// p.allowCameraAccess: "Allow camera access" => "Kamera-hozzáférés engedélyezése"
// p.scaleColorMode: "Scale color mode" => "Színmód méretezése"
// p.rateColorMode: "Rate color mode" => "Értékelje a színmódot"
// p.templateTabTitle: "Template tab title" => "Sablon lap címe"
// p.templateVisibleIf: "Template visible if" => "A sablon akkor látható, ha"
// p.copyDisplayValue: "Copy display value" => "Megjelenített érték másolása"
// theme.--background: "Background color" => "Háttérszín"
// theme.--background-dim-light: "Background dim light color" => "Háttér halvány világos színe"
// theme.--primary-foreground: "Primary foreground color" => "Elsődleges festőszín"
// theme.--foreground: "Foreground color" => "Festőszín"
// theme.--base-unit: "Base unit" => "Alapegység"
// theme.groupAdvanced: "Advanced" => "Haladó"
// theme.themeName: "Theme" => "Téma"
// theme.isPanellessss: "Question appearance" => "Kérdés megjelenése"
// theme.isPanellessPanels: "Default" => "Alapértelmezett"
// theme.isPanellessLightweight: "Without Panels" => "Panelek nélkül"
// theme.themePaletteLight: "Light" => "Fény"
// theme.themePaletteDark: "Dark" => "Sötét"
// theme.primaryColor: "Accent color" => "Kiemelő szín"
// theme.primaryDefaultColor: "Default" => "Alapértelmezett"
// theme.primaryDarkColor: "Hover" => "Lebeg"
// theme.primaryLightColor: "Selected" => "Kiválasztott"
// theme.backgroundDimColor: "Background color" => "Háttérszín"
// theme.backgroundImage: "Background image" => "Háttérkép"
// theme.backgroundImageFitAuto: "Auto" => "Kocsi"
// theme.backgroundImageFitCover: "Cover" => "Fedő"
// theme.backgroundImageFitContain: "Contain" => "Tartalmaz"
// theme.backgroundOpacity: "Opacity" => "Átlátszatlanság"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Fix"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Kézirattekercs"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Panel hátterének átlátszatlansága"
// theme.questionBackgroundTransparency: "Question background opacity" => "Kérdés hátterének átlátszatlansága"
// theme.questionPanel: "Panel background and corner radius" => "Panel háttere és saroksugara"
// theme.questionTitle: "Question title font" => "Kérdés címének betűtípusa"
// theme.questionDescription: "Question description font" => "Kérdés leíró betűtípus"
// theme.editorPanel: "Input element" => "Bemeneti elem"
// theme.editorFont: "Input element font" => "Bemeneti elem betűtípusa"
// theme.backcolor: "Default background" => "Alapértelmezett háttér"
// theme.hovercolor: "Hover background" => "Háttér rámutatása"
// theme.borderDecoration: "Border decoration" => "Szegély dekoráció"
// theme.accentBackground: "Accent background" => "Ékezetes háttér"
// theme.accentForeground: "Accent foreground" => "Hangsúlyos előtér"
// theme.primaryForecolor: "Default color" => "Alapértelmezett szín"
// theme.primaryForecolorLight: "Disabled color" => "Letiltott szín"
// theme.linesColors: "Minor line colors" => "Alvonalszínek"
// theme.borderDefault: "Darker" => "Sötétebb"
// theme.borderLight: "Lighter" => "Öngyújtó"
// theme.fontFamily: "Font family" => "Betűcsalád"
// theme.fontSize: "Font size" => "Betűméret"
// theme.color: "Color" => "Szín"
// theme.size: "Size" => "Méret"
// theme.fontWeightRegular: "Regular" => "Rendszeres"
// theme.fontWeightHeavy: "Heavy" => "Nehéz"
// theme.fontWeightSemiBold: "Semi-bold" => "Félig félkövér"
// theme.fontWeightBold: "Bold" => "Merész"
// theme.scale: "Scale" => "Hangsor"
// theme.cornerRadius: "Corner radius" => "Sarok sugara"
// theme.surveyTitleFont: "Survey title font" => "Felmérés címének betűtípusa"
// theme.pageTitle: "Page title font" => "Oldalcím betűtípusa"
// theme.pageDescription: "Page description font" => "Oldalleíró betűtípus"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Árnyékhatás hozzáadása"
// theme.opacity: "Opacity" => "Átlátszatlanság"
// theme.boxShadowBlur: "Blur" => "Elken"
// theme.boxShadowSpread: "Spread" => "Terjedés"
// theme.boxShadowDrop: "Drop" => "Csepp"
// theme.boxShadowInner: "Inner" => "Belső"
// theme.questionShadow: "Shadow effects" => "Árnyék effektusok"
// theme.editorShadow: "Input element shadow effects" => "Bemeneti elem árnyékeffektusai"
// names.default: "Default" => "Alapértelmezett"
// names.contrast: "Contrast" => "Kontraszt"
// names.plain: "Plain" => "Síkság"
// names.simple: "Simple" => "Egyszerű"
// names.blank: "Blank" => "Üres"
// names.double: "Double" => "Dupla"
// names.bulk: "Bulk" => "Terjedelem"
// names.pseudo-3d: "Pseudo 3D" => "Pszeudo 3D"
// names.playful: "Playful" => "Játékos"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Kékeszöld"
// colors.blue: "Blue" => "Kék"
// colors.purple: "Purple" => "Lila"
// colors.orchid: "Orchid" => "Orchidea"
// colors.tulip: "Tulip" => "Tulipán"
// colors.brown: "Brown" => "Barna"
// colors.green: "Green" => "Zöld"
// names.sharp: "Sharp" => "Éles"
// names.borderless: "Borderless" => "Szegély nélküli"
// names.flat: "Flat" => "Lapos"
// names.doubleborder: "Double Border" => "Dupla szegély"
// names.layered: "Layered" => "Rakott"
// names.solid: "Solid" => "Szilárd"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Biztos benne, hogy törölni szeretné az összes karakterláncot ehhez a nyelvhez?"
// ed.themeResetButton: "Reset theme settings to default" => "Témabeállítások visszaállítása alapértelmezettre"
// theme.placeholderColor: "Placeholder color" => "Helyőrző színe"
// ed.themeSettings: "Theme Settings" => "Téma beállítások"
// ed.themeSettingsTooltip: "Open theme settings" => "Nyissa meg a témabeállításokat"
// pe.resetToDefaultCaption: "Reset" => "Átszed"
// pv.file: "Local files" => "Helyi fájlok"
// pv.camera: "Camera" => "Fényképezőgép"
// pv.file-camera: "Local files or camera" => "Helyi fájlok vagy kamera"
// ed.translateUsigAI: "Auto-translate All" => "Összes automatikus fordítása"
// ed.translationDialogTitle: "Untranslated strings" => "Lefordítatlan karakterláncok"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Kérjük, adjon meg legalább {0} elemet"
// lg.question_resetValueName: "Reset question value" => "Kérdés értékének visszaállítása"
// lg.column_resetValue: "Reset column value" => "Oszlopérték visszaállítása"
// pe.markRequired: "Mark as required" => "Megjelölés kötelezőként"
// pe.removeRequiredMark: "Remove the required mark" => "Távolítsa el a szükséges jelet"
// p.resetValueIf: "Reset value if" => "Érték visszaállítása, ha"
// lg.question_setValueName: "Set question value" => "Kérdésérték beállítása"
// lg.column_resetValueName: "Reset column value" => "Oszlopérték visszaállítása"
// lg.column_setValueName: "Set column value" => "Oszlopérték beállítása"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Olyan kifejezés, amelynek eredménye a célkérdéshez lesz rendelve."
// survey.title: "Title" => "Cím"
// page.title: "Title" => "Cím"
// p.setValueIf: "Set value if" => "Érték beállítása, ha"
// theme.header: "Header" => "Fejléc"
// theme.backgroundImageFitFill: "Stretch" => "Nyúlik"
// theme.backgroundImageFitTile: "Tile" => "Cserép"
// theme.headerView: "View" => "Nézet"
// theme.headerViewBasic: "Basic" => "Alapvető"
// theme.headerViewAdvanced: "Advanced" => "Haladó"
// theme.headerInheritWidthFrom: "Content area width" => "Tartalomterület szélessége"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Ugyanaz, mint a felmérés"
// theme.headerInheritWidthFromPage: "Fit to page" => "Laphoz igazítás"
// theme.headerTextAreaWidth: "Text width" => "Szöveg szélessége"
// theme.headerBackgroundColorSwitch: "Background color" => "Háttérszín"
// theme.headerBackgroundColorNone: "None" => "Egyik sem"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Kiemelő szín"
// theme.headerBackgroundColorCustom: "Custom" => "Szokás"
// theme.horizontalAlignmentLeft: "Left" => "Balra"
// theme.horizontalAlignmentCenter: "Center" => "Központ"
// theme.horizontalAlignmentRight: "Right" => "Jobbra"
// theme.verticalAlignmentTop: "Top" => "Felső"
// theme.verticalAlignmentMiddle: "Middle" => "Középső"
// theme.verticalAlignmentBottom: "Bottom" => "Fenék"
// theme.logoPosition: "Logo Position" => "Logó pozíciója"
// theme.headerTitlePosition: "Title Position" => "Cím pozíciója"
// lg.question_resetValueText: "reset value for question: {0}" => "Kérdés visszaállítási értéke: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Érték hozzárendelése: {1} a kérdéshez: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Az oszlop cellaértékének visszaállítása: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Cellaérték hozzárendelése: {1} oszlophoz: {0}"
// ed.surveyJsonExportButton: "Export" => "Kivitel"
// ed.surveyJsonImportButton: "Import" => "Importál"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Másolás a vágólapra"
// pe.filePlaceholder: "File placeholder text" => "Fájl helyőrző szövege"
// pe.photoPlaceholder: "Photo placeholder text" => "Fénykép helyőrző szövege"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Fájl vagy fénykép helyőrző szövege"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Akkor érvényes, ha a \"Forrás típusa\" \"Helyi fájlok\", vagy ha a kamera nem érhető el"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Akkor érvényes, ha a \"Forrás típusa\" a \"Kamera\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Akkor érvényes, ha a \"Forrás típusa\" értéke \"Helyi fájlok vagy kamera\"."
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Tényleg vissza akarja állítani a témát? Az összes testreszabás elvész."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Igen, állítsa vissza a témát"
// theme.background: "Background" => "Háttér"
// theme.appearance: "Appearance" => "Megjelenés"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Tárolóhoz igazítás"
// signaturepad.showPlaceholder: "Show the placeholder" => "A helyőrző megjelenítése"
// signaturepad.placeholder: "Placeholder text" => "Helyőrző szöveg"
// theme.surveyDescriptionFont: "Survey description font" => "Felmérés leírásának betűtípusa"
// ed.prevFocus: "Focus previous" => "Fókusz előző"
// ed.nextFocus: "Focus next" => "Fókusz következő"
// ed.saveTheme: "Save Theme" => "Téma mentése"
// ed.saveThemeTooltip: "Save Theme" => "Téma mentése"
// lg.page_requireName: "Make page required" => "Az oldal kötelezővé tétele"
// lg.panel_requireName: "Make page required" => "Az oldal kötelezővé tétele"
// signaturepad.signatureWidth: "Signature area width" => "Aláírási terület szélessége"
// signaturepad.signatureHeight: "Signature area height" => "Aláírási terület magassága"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Az aláírási terület automatikus méretezése"
// signaturepad.penMinWidth: "Minimum pen width" => "Tollszélesség minimális"
// signaturepad.penMaxWidth: "Maximum pen width" => "Maximális tollszélesség"
// theme.headerDescriptionPosition: "Description position" => "Leírás pozíciója"
// ed.propertyGridNoResultsFound: "No results found" => "Nincs találat"
// pv.leftRight: "Left and right" => "Balra és jobbra"
// p.sourceType: "Source type" => "Forrás típusa"
// p.fitToContainer: "Fit to container" => "Tárolóhoz igazítás"
// p.setValueExpression: "Set value expression" => "Értékkifejezés beállítása"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "A választási lehetőségek egy webszolgáltatásból töltődnek be."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Válassza a beállítások"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "A betöltött választási lehetőségek előnézete"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "A sorokban ismétlődő válaszok megakadályozása"
// theme.advancedMode: "Advanced mode" => "Speciális mód"
// theme.backgroundCornerRadius: "Background and corner radius" => "Háttér és saroksugár"
// theme.colorsTitle: "Colors" => "Színek"
// theme.font: "Font" => "Betűkészlet"
// theme.lines: "Lines" => "Sorok"
// theme.titleFont: "Title font" => "Cím betűtípusa"
// theme.descriptionFont: "Description font" => "Leírás betűtípus"
// theme.shadow: "Shadow effects" => "Árnyék effektusok"
// ed.translateUsigAIFrom: "Translate from: " => "Fordítás: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "A Válasz megtagadása lehetőség engedélyezése"
// pe.showDontKnowItem: "Allow the Don't Know option" => "A Nem tudom lehetőség engedélyezése"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "A Válasz megtagadása lehetőség engedélyezése"
// pe.showDontKnowItem: "Allow the Don't Know option" => "A Nem tudom lehetőség engedélyezése"
// pv.contain: "Contain" => "Tartalmaz"
// pv.cover: "Cover" => "Fedő"
// pv.fill: "Fill" => "Tölt"
// pe.transposeData: "Transpose rows to columns" => "Sorok átültetése oszlopokba"
// layout.panel: "Layout" => "Elrendezés"
// layout.question: "Layout" => "Elrendezés"
// layout.base: "Layout" => "Elrendezés"
// panel.name: "Panel name" => "Panel neve"
// panel.title: "Panel title" => "Panel címe"
// panel.description: "Panel description" => "Panel leírása"
// panel.visibleIf: "Make the panel visible if" => "A panel láthatóvá tétele, ha"
// panel.requiredIf: "Make the panel required if" => "Tegye szükségessé a panelt, ha"
// panel.questionsOrder: "Question order within the panel" => "Kérdések sorrendje a panelen belül"
// panel.startWithNewLine: "Display the panel on a new line" => "A panel megjelenítése új sorban"
// panel.state: "Panel collapse state" => "Panel összecsukási állapota"
// panel.width: "Inline panel width" => "Szövegközi panel szélessége"
// panel.minWidth: "Minimum panel width" => "Minimális panelszélesség"
// panel.maxWidth: "Maximum panel width" => "Maximális panelszélesség"
// panel.showNumber: "Number panels" => "Szám panelek"
// paneldynamic.name: "Panel name" => "Panel neve"
// paneldynamic.title: "Panel title" => "Panel címe"
// paneldynamic.description: "Panel description" => "Panel leírása"
// paneldynamic.visibleIf: "Make the panel visible if" => "A panel láthatóvá tétele, ha"
// paneldynamic.requiredIf: "Make the panel required if" => "Tegye szükségessé a panelt, ha"
// paneldynamic.page: "Move the panel to page" => "A panel áthelyezése oldalra"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "A panel megjelenítése új sorban"
// paneldynamic.state: "Panel collapse state" => "Panel összecsukási állapota"
// paneldynamic.width: "Inline panel width" => "Szövegközi panel szélessége"
// paneldynamic.minWidth: "Minimum panel width" => "Minimális panelszélesség"
// paneldynamic.maxWidth: "Maximum panel width" => "Maximális panelszélesség"
// paneldynamic.templateDescription: "Panel description pattern" => "Panel leírási minta"
// paneldynamic.templateTitle: "Panel title pattern" => "Panel címmintája"
// paneldynamic.noEntriesText: "Empty panel text" => "Üres panelszöveg"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Lapcím mintája"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Egy adott panel láthatóvá tétele, ha"
// paneldynamic.hideNumber: "Hide the panel number" => "A panel számának elrejtése"
// paneldynamic.titleLocation: "Panel title alignment" => "Panelcím igazítása"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Panel leírás igazítása"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Kérdés címének igazítása"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Hibaüzenetek igazítása"
// paneldynamic.newPanelPosition: "New panel location" => "Új panel helye"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Az ismétlődő válaszok elkerülése a következő kérdésben"
// question.name: "Question name" => "Kérdés neve"
// question.title: "Question title" => "Kérdés címe"
// question.description: "Question description" => "Kérdés leírása"
// question.visibleIf: "Make the question visible if" => "Tegye láthatóvá a kérdést, ha"
// question.requiredIf: "Make the question required if" => "Tegye kötelezővé a kérdést, ha"
// question.state: "Question box collapse state" => "Kérdésmező összecsukási állapota"
// question.hideNumber: "Hide the question number" => "A kérdés számának elrejtése"
// question.titleLocation: "Question title alignment" => "Kérdés címének igazítása"
// question.descriptionLocation: "Question description alignment" => "Kérdés leírás igazítása"
// question.errorLocation: "Error message alignment" => "Hibaüzenetek igazítása"
// question.indent: "Increase the inner indent" => "A belső behúzás növelése"
// question.width: "Inline question width" => "Szövegközi kérdés szélessége"
// question.minWidth: "Minimum question width" => "Minimális kérdésszélesség"
// question.maxWidth: "Maximum question width" => "Maximális kérdésszélesség"
// question.textUpdateMode: "Update input field value" => "Beviteli mező értékének frissítése"
// signaturepad.allowClear: "Show the Clear button within signature area" => "A Törlés gomb megjelenítése az aláírási területen belül"
// signaturepad.penColor: "Stroke color" => "Körvonal színe"
// comment.rows: "Input field height (in lines)" => "Beviteli mező magassága (sorokban)"
// expression.name: "Expression name" => "Kifejezés neve"
// expression.title: "Expression title" => "Kifejezés címe"
// expression.description: "Expression description" => "Kifejezés leírása"
// expression.expression: "Expression" => "Kifejezés"
// trigger.expression: "Expression" => "Kifejezés"
// calculatedvalue.expression: "Expression" => "Kifejezés"
// survey.description: "Survey description" => "A felmérés leírása"
// page.name: "Page name" => "Oldal neve"
// page.description: "Page description" => "Oldal leírása"
// page.visibleIf: "Make the page visible if" => "Tegye láthatóvá az oldalt, ha"
// page.requiredIf: "Make the page required if" => "Az oldal kötelezővé tétele, ha"
// page.questionsOrder: "Question order on the page" => "Kérdések sorrendje az oldalon"
// matrixdropdowncolumn.name: "Column name" => "Oszlop neve"
// matrixdropdowncolumn.title: "Column title" => "Oszlop címe"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Az ismétlődő válaszok megakadályozása"
// matrixdropdowncolumn.width: "Column width" => "Oszlopszélesség"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Minimális oszlopszélesség"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Beviteli mező magassága (sorokban)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Tegye láthatóvá az oszlopot, ha"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Tegye kötelezővé az oszlopot, ha"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Minden beállítás külön oszlopban"
// multipletextitem.name: "Name" => "Név"
// multipletextitem.title: "Title" => "Cím"
// pe.rateDescriptionLocation: "Label alignment" => "Feliratigazítás"
// pe.cellErrorLocation: "Cell error message alignment" => "Cellahibaüzenet igazítása"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Még nincsenek oszlopai"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Még nincsenek sorai"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Még nincsenek érvényességi szabályai"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Még nincsenek egyéni változói"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Még nincsenek triggerek"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Még nincsenek linkek"
// pe.addNew@columns: "Add new column" => "Új oszlop hozzáadása"
// pe.addNew@rows: "Add new row" => "Új sor hozzáadása"
// pe.addNew@validators: "Add new rule" => "Új szabály hozzáadása"
// pe.addNew@calculatedValues: "Add new variable" => "Új változó hozzáadása"
// pe.addNew@triggers: "Add new trigger" => "Új eseményindító hozzáadása"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Új URL hozzáadása"
// choicesbyurl.url: "Web service's URL" => "Webszolgáltatás URL-címe"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Oldalcímek megjelenítése a folyamatjelző sávon"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Oldalszámok megjelenítése a folyamatjelző sávon"
// itemvalue.visibleIf: "Make the option visible if" => "Tegye láthatóvá a beállítást, ha"
// itemvalue.enableIf: "Make the option selectable if" => "Tegye kiválaszthatóvá a beállítást, ha"
// panel.layout: "Panel Layout" => "Panel elrendezése"
// tabs.questionSettings: "Question Settings" => "Kérdés beállítások"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Pl.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Pl.: kategóriák.fikció"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Pl.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Pl.: 6 hüvelyk"
// pe.minWidth_placeholder: "Ex.: 600px" => "Pl.: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Pl.: 50%"
// pv.selected: "Selected" => "Kiválasztott"
// pv.unselected: "Unselected" => "Kijelöletlen"
// pv.center: "Center" => "Központ"
// pv.middle: "Middle" => "Középső"
// pv.next: "Next" => "Következő"
// pv.last: "Last" => "Utolsó"
// clearIfInvisible.none: "Never" => "Soha"
// questionsOnPageMode.standard: "Original structure" => "Eredeti szerkezet"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Az összes kérdés megjelenítése egy oldalon"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Egyetlen kérdés megjelenítése oldalanként"
// pv.auto: "Auto" => "Kocsi"
// panelsState.firstExpanded: "First expanded" => "Először bővített"
// rateColorMode.scale: "Scale" => "Hangsor"
// scaleColorMode.monochrome: "Monochrome" => "Monokróm"
// scaleColorMode.colored: "Colored" => "Színes"
// state.default: "Locked" => "Zárolt"
// showQuestionNumbers.default: "Auto-numbering" => "Automatikus számozás"
// showQuestionNumbers.on: "Auto-numbering" => "Automatikus számozás"
// showQuestionNumbers.onPage: "Reset on each page" => "Visszaállítás minden oldalon"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Visszaállítás az egyes paneleken"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Visszaállítás az egyes paneleken"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Folytassa a felmérést"
// showQuestionNumbers.off: "No numbering" => "Nincs számozás"
// descriptionLocation.underTitle: "Under the question title" => "A kérdés címe alatt"
// descriptionLocation.underInput: "Under the input field" => "A beviteli mező alatt"
// selectToRankAreasLayout.horizontal: "Next to choices" => "A választási lehetőségek mellett"
// selectToRankAreasLayout.vertical: "Above choices" => "A fenti választási lehetőségek"
// displayStyle.decimal: "Decimal" => "Tizedes"
// displayStyle.currency: "Currency" => "Valuta"
// displayStyle.percent: "Percentage" => "Százalék"
// displayStyle.date: "Date" => "Dátum"
// totalDisplayStyle.decimal: "Decimal" => "Tizedes"
// totalDisplayStyle.currency: "Currency" => "Valuta"
// totalDisplayStyle.percent: "Percentage" => "Százalék"
// totalDisplayStyle.date: "Date" => "Dátum"
// rowsOrder.initial: "Original" => "Eredeti"
// questionsOrder.initial: "Original" => "Eredeti"
// showProgressBar.aboveheader: "Above the header" => "A fejléc felett"
// showProgressBar.belowheader: "Below the header" => "A fejléc alatt"
// pv.sum: "Sum" => "Összeg"
// pv.count: "Count" => "Gróf"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Max"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Tartalmaz"
// searchMode.startsWith: "Starts with" => "Ezzel kezdődik"
// panel.name: "A panel ID that is not visible to respondents." => "Olyan panelazonosító, amely nem látható a válaszadók számára."
// panel.description: "Type a panel subtitle." => "Írja be a panel feliratát."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "A varázspálca ikonnal feltételes szabályt állíthat be, amely meghatározza a panel láthatóságát."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "A varázspálca ikonnal állítson be egy feltételes szabályt, amely letiltja a panel írásvédett módját."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "A varázspálca ikonnal állítson be egy feltételes szabályt, amely megakadályozza a felmérés elküldését, kivéve, ha legalább egy beágyazott kérdésre van válasz."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "A panelen található összes kérdésre vonatkozik. Ha felül szeretné bírálni ezt a beállítást, határozzon meg címigazítási szabályokat az egyes kérdésekhez. Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást (\"Alapértelmezetten felül\") alkalmazza."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Beállítja a hibaüzenet helyét a panelen belüli összes kérdéssel kapcsolatban. Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást alkalmazza."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Megtartja a kérdések eredeti sorrendjét, vagy véletlenszerűvé teszi őket. Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást alkalmazza."
// panel.page: "Repositions the panel to the end of a selected page." => "A kijelölt oldal végére helyezi a panelt."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Térközt vagy margót ad a panel tartalma és a paneldoboz bal szegélye közé."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Törölje a jelölést, ha a panel egy sorban jelenik meg az előző kérdéssel vagy panellel. A beállítás nem érvényes, ha a panel az űrlap első eleme."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Válasszon a következők közül: \"Kibontott\" - a panel teljes egészében megjelenik és összecsukható; \"Összecsukott\" - a panel csak a címet és a leírást jeleníti meg, és bővíthető; \"Zárolva\" - a panel teljes egészében megjelenik, és nem csukható össze."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "A panel szélességét az ugyanabban a sorban lévő többi földmérési elemhez viszonyítva állítja be. CSS-értékeket fogad el (px, %, in, pt stb.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "Olyan panelazonosító, amely nem látható a válaszadók számára."
// paneldynamic.description: "Type a panel subtitle." => "Írja be a panel feliratát."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "A varázspálca ikonnal feltételes szabályt állíthat be, amely meghatározza a panel láthatóságát."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "A varázspálca ikonnal állítson be egy feltételes szabályt, amely letiltja a panel írásvédett módját."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "A varázspálca ikonnal állítson be egy feltételes szabályt, amely megakadályozza a felmérés elküldését, kivéve, ha legalább egy beágyazott kérdésre van válasz."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "A panelen található összes kérdésre vonatkozik. Ha felül szeretné bírálni ezt a beállítást, határozzon meg címigazítási szabályokat az egyes kérdésekhez. Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást (\"Alapértelmezetten felül\") alkalmazza."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Beállítja egy érvénytelen bevitelű kérdéssel kapcsolatos hibaüzenet helyét. Válasszon a következők közül: \"Felső\" - egy hibaüzenet kerül a kérdésmező tetejére; \"Alsó\" - egy hibaüzenet kerül a kérdésmező aljára. Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást (\"Alapértelmezetten felül\") alkalmazza."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Beállítja a hibaüzenet helyét a panelen belüli összes kérdéssel kapcsolatban. Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást alkalmazza."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "A kijelölt oldal végére helyezi a panelt."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Térközt vagy margót ad a panel tartalma és a paneldoboz bal szegélye közé."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Törölje a jelölést, ha a panel egy sorban jelenik meg az előző kérdéssel vagy panellel. A beállítás nem érvényes, ha a panel az űrlap első eleme."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Válasszon a következők közül: \"Kibontott\" - a panel teljes egészében megjelenik és összecsukható; \"Összecsukott\" - a panel csak a címet és a leírást jeleníti meg, és bővíthető; \"Zárolva\" - a panel teljes egészében megjelenik, és nem csukható össze."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "A panel szélességét az ugyanabban a sorban lévő többi földmérési elemhez viszonyítva állítja be. CSS-értékeket fogad el (px, %, in, pt stb.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Írjon be egy sablont a dinamikus panelcímekhez. Használja a {panelIndex} elemet a panel általános pozíciójához, a {visiblePanelIndex} értéket pedig a látható panelek közötti sorrendjéhez. Szúrja be ezeket a helyőrzőket a mintába az automatikus számozás hozzáadásához."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Írjon be egy sablont a lapcímekhez. Használja a {panelIndex} elemet a panel általános pozíciójához, a {visiblePanelIndex} sablont pedig a látható panelek közötti sorrendjéhez. Szúrja be ezeket a helyőrzőket a mintába az automatikus számozás hozzáadásához."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Ezzel a beállítással szabályozhatja az egyes panelek láthatóságát a dinamikus panelen. A \"{panel}\" helyőrzővel hivatkozhat a kifejezés aktuális paneljére."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Ezt a beállítást a panelen található összes kérdés automatikusan örökli. Ha felül szeretné bírálni ezt a beállítást, határozzon meg címigazítási szabályokat az egyes kérdésekhez. Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást (\"Alapértelmezetten felül\") alkalmazza."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "Az \"Öröklés\" opció az oldalszintű (ha be van állítva) vagy a felmérés szintű beállítást alkalmazza (\"Alapértelmezés szerint a panel címe alatt\")."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Az újonnan hozzáadott panel helyét határozza meg. Alapértelmezés szerint az új panelek hozzáadódnak a végéhez. Válassza a \"Tovább\" lehetőséget, ha új panelt szeretne beilleszteni az aktuális után."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Megkettőzi a válaszokat az utolsó panelről, és hozzárendeli őket a következő hozzáadott dinamikus panelhez."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Hivatkozzon egy kérdés nevére, hogy a felhasználónak egyedi választ kell adnia erre a kérdésre minden panelen."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Ezzel a beállítással alapértelmezett válaszértéket rendelhet hozzá egy kifejezés alapján. A kifejezés tartalmazhat alapvető számításokat - '{q1_id} + {q2_id}', logikai kifejezéseket, például \"{age} > 60\" és függvényeket: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' stb. A kifejezés által meghatározott érték a kezdeti alapértelmezett érték, amelyet a válaszadó kézi bevitele felülbírálhat."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "A varázspálca ikonnal feltételes szabályt állíthat be, amely meghatározza, hogy a válaszadó bemenete mikor áll vissza az \"Alapértelmezett érték kifejezés\" vagy az \"Értékkifejezés beállítása\" vagy az \"Alapértelmezett válasz\" érték alapján (ha bármelyik be van állítva)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "A varázspálca ikonnal beállíthat egy feltételes szabályt, amely meghatározza, hogy mikor kell futtatni az \"Érték beállítása kifejezést\", és dinamikusan hozzárendelni az eredményül kapott értéket válaszként."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Adjon meg egy kifejezést, amely meghatározza az \"Érték beállítása, ha\" szabály feltételeinek teljesülése esetén beállítandó értéket. A kifejezés tartalmazhat alapvető számításokat - '{q1_id} + {q2_id}', logikai kifejezéseket, például \"{age} > 60\" és függvényeket: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' stb. A kifejezés által meghatározott értéket felülbírálhatja a válaszadó kézi bevitele."
// question.name: "A question ID that is not visible to respondents." => "A válaszadók számára nem látható kérdésazonosító."
// question.description: "Type a question subtitle." => "Írja be a kérdés alcímét."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "A varázspálca ikonnal állítson be egy feltételes szabályt, amely meghatározza a kérdések láthatóságát."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "A varázspálca ikonnal állítson be egy feltételes szabályt, amely letiltja a kérdés írásvédett módját."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "A varázspálca ikonnal állítson be egy feltételes szabályt, amely megakadályozza a felmérés előrehaladását vagy elküldését, kivéve, ha a kérdésre választ kapott."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Törölje a jelölést, ha a kérdést egy sorban szeretné megjeleníteni az előző kérdéssel vagy panellel. A beállítás nem érvényes, ha a kérdés az űrlap első eleme."
// question.page: "Repositions the question to the end of a selected page." => "A kérdést a kijelölt oldal végére helyezi."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Válasszon a következők közül: \"Kibontott\" - a kérdésmező teljes egészében megjelenik és összecsukható; \"Összecsukott\" - a kérdésmező csak a címet és a leírást jeleníti meg, és kibontható; \"Zárolva\" - a kérdésmező teljes egészében megjelenik, és nem csukható össze."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Felülbírálja a panel-, oldal- vagy felmérésszinten definiált címigazítási szabályokat. Az \"Öröklés\" opció minden magasabb szintű beállítást (ha be van állítva) vagy felmérésszintű beállítást (\"Alapértelmezetten Felül\") alkalmaz."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "Az \"Öröklés\" opció a felmérés szintű beállítást alkalmazza (\"Alapértelmezés szerint a kérdés címe alatt\")."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Beállítja az érvénytelen bevitelű kérdéssel kapcsolatos hibaüzenet helyét. Válasszon a következők közül: \"Felső\" - egy hibaüzenet kerül a kérdésmező tetejére; \"Alsó\" - egy hibaüzenet kerül a kérdésmező aljára. Az \"Öröklés\" opció a felmérés szintű beállítást alkalmazza (\"Felül\" alapértelmezés szerint)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Térközt vagy margót ad a kérdés tartalma és a kérdésmező bal szegélye közé."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "A kérdés szélességét az ugyanabban a sorban lévő többi földmérési elemhez viszonyítva állítja be. CSS-értékeket fogad el (px, %, in, pt stb.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "A varázspálca ikonnal állítson be érvényességi szabályt a kérdéshez."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Válasszon a következők közül: \"Elveszett fókuszban\" - az érték frissül, amikor a beviteli mező elveszíti a fókuszt; \"Gépelés közben\" - az érték valós időben frissül, ahogy a felhasználók gépelnek. Az \"Öröklés\" opció a felmérés szintű beállítást alkalmazza (\"Alapértelmezés szerint elveszett fókuszban\")."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Bármely webszolgáltatást használhat adatforrásként feleletválasztós kérdésekhez. A választási lehetőségek értékeinek feltöltéséhez adja meg az adatokat szolgáltató szolgáltatás URL-címét."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "A legördülő lista szűrésére szolgáló összehasonlító művelet."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Beállítja a megjelenített aláírási terület szélességét és az eredményül kapott képet."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Beállítja a megjelenített aláírási terület magasságát és az eredményül kapott képet."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Jelölje be, ha azt szeretné, hogy az aláírási terület kitöltse a kérdésmezőben rendelkezésre álló összes helyet, miközben megtartja az alapértelmezett 3:2 képarányt. Egyéni szélességi és magassági értékek beállításakor a beállítás megtartja ezeknek a méreteknek a méretarányát."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Beállítja a kép magasságát a felmérés eredményeiben."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Beállítja a kép szélességét a felmérés eredményeiben."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Felülbírálja a minimális és maximális magassági értékeket."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Felülbírálja a minimális és maximális szélességi értékeket."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "Az \"érték\" a feltételes szabályokban használt elemazonosítóként szolgál; A \"Szöveg\" felirat jelenik meg a válaszadók számára."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Ez a beállítás csak a beviteli mezőt méretezi át, és nincs hatással a kérdésmező szélességére. Az elfogadott bemeneti hossz korlátozásához lépjen az <b>Érvényesítés → Maximális karakterkorlát</b> elemre."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Beállítja a beviteli mezőben megjelenített sorok számát. Ha a bemenet több sort foglal el, megjelenik a görgetősáv."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Válasszon a következők közül: \"Szerkeszthető\" - lehetővé teszi a válaszadók számára a felmérés kitöltését; \"Csak olvasható\" - letiltja az űrlapszerkesztést."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "A válaszadók számára nem látható oszlopazonosító."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Ha engedélyezve van egy oszlophoz, a válaszadónak egyedi választ kell adnia az oszlop minden kérdésére."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Beállítja a beviteli mezőben megjelenített sorok számát. Ha a bemenet több sort foglal el, megjelenik a görgetősáv."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "A varázspálca ikonnal feltételes szabályt állíthat be, amely meghatározza az oszlop láthatóságát."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "A varázspálca ikonnal állítson be egy feltételes szabályt, amely letiltja az oszlop írásvédett módját."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "A varázspálca ikonnal állítson be egy feltételes szabályt, amely megakadályozza a felmérés elküldését, kivéve, ha legalább egy beágyazott kérdésre van válasz."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Ha be van jelölve, minden választási lehetőséghez külön oszlopot hoz létre."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Válasszon a következők közül: \"Statikus\" - rögzített szélességet állít be; \"Reszponzív\" - a felmérés a képernyő teljes szélességét elfoglalja; \"Automatikus\" - a használt kérdéstípusoktól függően a kettő egyikét alkalmazza."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Illesszen be egy képhivatkozást (méretkorlátozás nélkül), vagy kattintson a mappa ikonra egy fájl böngészéséhez a számítógépről (legfeljebb 64 KB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Beállítja az embléma szélességét CSS egységekben (px, %, in, pt stb.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Beállítja az embléma magasságát CSS egységekben (px, %, in, pt stb.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Válasszon a következők közül: \"Nincs\" - a kép megőrzi eredeti méretét; \"Tartalmaz\" - a kép átméreteződik, hogy illeszkedjen, miközben megtartja képarányát; \"Borító\" - a kép kitölti az egész dobozt, miközben megtartja képarányát; \"Kitöltés\" - a kép a doboz kitöltéséhez nyúlik a képarány megtartása nélkül."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Válassza ki, hogy a felmérés automatikusan továbblépjen-e a következő oldalra, miután a válaszadó megválaszolta az aktuális oldalon található összes kérdést."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Beállítja a navigációs gombok láthatóságát és helyét az oldalon."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Beállítja a folyamatjelző sáv láthatóságát és helyét. Az \"Automatikus\" érték megjeleníti a folyamatjelző sávot a felmérés fejléce felett vagy alatt."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Engedélyezze az előnézeti oldalt csak az összes vagy megválaszolt kérdéssel."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "A felmérésben szereplő összes kérdésre vonatkozik. Ezt a beállítást felülbírálhatják az alacsonyabb szinteken lévő címigazítási szabályok: panel, oldal vagy kérdés. Az alacsonyabb szintű beállítás felülírja a magasabb szinten lévőket."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Egy szimbólum vagy szimbólumsorozat, amely jelzi, hogy válaszolni kell."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Írja be azt a számot vagy betűt, amellyel a számozást kezdeni szeretné."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Beállítja az érvénytelen bevitelű kérdéssel kapcsolatos hibaüzenet helyét. Válasszon a következők közül: \"Felső\" - egy hibaüzenet kerül a kérdésmező tetejére; \"Alsó\" - egy hibaüzenet kerül a kérdésmező aljára."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Válassza ki, ha azt szeretné, hogy az egyes oldalak első beviteli mezője készen álljon a szövegbevitelre."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Megtartja a kérdések eredeti sorrendjét, vagy véletlenszerűvé teszi őket. A beállítás hatása csak az Előnézet lapon látható."
// pehelp.maxTextLength: "For text entry questions only." => "Csak szövegbeviteli kérdések esetén."
// pehelp.maxOthersLength: "For question comments only." => "Csak kérdésekhez fűzött megjegyzésekhez."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Válassza ki, ha azt szeretné, hogy a kérdésmegjegyzések és a hosszú szöveges kérdések magassága automatikusan növekedjen a beírt szöveg hossza alapján."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Csak kérdésekhez és hosszú szöveges kérdésekhez."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Az egyéni változók köztes vagy kiegészítő változókként szolgálnak az űrlapszámításokban. A válaszadó bemeneteit forrásértékként veszik fel. Minden egyéni változónak egyedi neve és egy kifejezése van, amelyen alapul."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Válassza ezt a lehetőséget, ha a kifejezés számított értékét a felmérés eredményeivel együtt szeretné menteni."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Az eseményindító egy kifejezésen alapuló esemény vagy feltétel. Miután a kifejezés \"true\" (igaz) értékre lett kiértékelve, az eseményindító elindít egy műveletet. Egy ilyen műveletnek opcionálisan lehet egy célkérdése, amelyet érint."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Válassza ki, hogy törli-e a feltételes logika által elrejtett kérdések értékeit, és mikor tegye meg."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Válasszon a következők közül: \"Elveszett fókuszban\" - az érték frissül, amikor a beviteli mező elveszíti a fókuszt; \"Gépelés közben\" - az érték valós időben frissül, ahogy a felhasználók gépelnek."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "A bal oldali érték a feltételes szabályokban használt oszlopazonosítóként szolgál, a jobb oldali érték pedig a válaszadók számára jelenik meg."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "A bal oldali érték a feltételes szabályokban használt sorazonosítóként szolgál, a jobb oldali érték a válaszadók számára jelenik meg."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS-értékeket fogad el (px, %, in, pt stb.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS-értékeket fogad el (px, %, in, pt stb.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Beállítja a hibaüzenet helyét egy érvénytelen bevitelű cellával kapcsolatban. Az \"Öröklés\" opció a \"Hibaüzenetek igazítása\" tulajdonság beállítását alkalmazza."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Ha az \"Ismétlődő válaszok megakadályozása\" tulajdonság engedélyezve van, az ismétlődő bejegyzést beküldeni próbáló válaszadó a következő hibaüzenetet kapja."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Lehetővé teszi az összesített értékek kiszámítását egy kifejezés alapján. A kifejezés tartalmazhat alapvető számításokat ('{q1_id} + {q2_id}'), logikai kifejezéseket ('{age} > 60') és függvényeket ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' stb.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Elindít egy kérést, amely a sor törlésének megerősítését kéri."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Megkettőzi a válaszokat az utolsó sorból, és hozzárendeli őket a következő hozzáadott dinamikus sorhoz."
// pehelp.description: "Type a subtitle." => "Írjon be egy feliratot."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Válassza ki a nyelvet a felmérés létrehozásának megkezdéséhez. Fordítás hozzáadásához váltson új nyelvre, és fordítsa le az eredeti szöveget itt vagy a Fordítások lapon."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Beállítja a részletszakasz helyét egy sorhoz képest. Válasszon a következők közül: \"Nincs\" - nincs bővítés; \"A sor alatt\" - a mátrix minden sora alá sorbővítés kerül; \"A sor alatt csak egy sor bővítés megjelenítése\" - a bővítés csak egyetlen sor alatt jelenik meg, a fennmaradó sorbővítések összecsukódnak."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Válasszon a következők közül: \"Nincs\" - a kép megőrzi eredeti méretét; \"Tartalmaz\" - a kép átméreteződik, hogy illeszkedjen, miközben megtartja képarányát; \"Borító\" - a kép kitölti az egész dobozt, miközben megtartja képarányát; \"Kitöltés\" - a kép a doboz kitöltéséhez nyúlik a képarány megtartása nélkül."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Fokozatosan növeli a beviteli mező magasságát az adatok bevitele közben. Felülbírálja a \"Beviteli mező magassága (sorokban)\" beállítást."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Az átméretező fogópont (vagy fogópont) megjelenik a sarokban, és húzással módosítható a beviteli mező mérete."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Az az időintervallum másodpercben, amely után a felmérés automatikusan továbblép a Köszönet oldalra."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Az az időintervallum másodpercben, amely után a felmérés automatikusan továbblép a következő oldalra."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Az az időintervallum másodpercben, amely után a felmérés automatikusan továbblép a következő oldalra."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "A varázspálca ikonnal állítson be egy feltételes szabályt, amely meghatározza az oldal láthatóságát."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "A varázspálca ikonnal állítson be egy feltételes szabályt, amely letiltja az oldal írásvédett módját."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "A varázspálca ikonnal állítson be egy feltételes szabályt, amely megakadályozza a felmérés elküldését, kivéve, ha legalább egy beágyazott kérdésre van válasz."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Az ezen az oldalon található összes kérdésre vonatkozik. Ha felül szeretné bírálni ezt a beállítást, határozzon meg címigazítási szabályokat az egyes kérdésekhez vagy panelekhez. Az \"Öröklés\" opció a felmérés szintű beállítást alkalmazza (\"Felül\" alapértelmezés szerint)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Beállítja az érvénytelen bevitelű kérdéssel kapcsolatos hibaüzenet helyét. Válasszon a következők közül: \"Felső\" - egy hibaüzenet kerül a kérdésmező tetejére; \"Alsó\" - egy hibaüzenet kerül a kérdésmező aljára. Az \"Öröklés\" opció a felmérés szintű beállítást alkalmazza (\"Felül\" alapértelmezés szerint)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Megtartja a kérdések eredeti sorrendjét, vagy véletlenszerűvé teszi őket. Az \"Öröklés\" opció a felmérési szintű beállítást alkalmazza (\"Eredeti\" alapértelmezés szerint). A beállítás hatása csak az Előnézet lapon látható."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Beállítja a navigációs gombok láthatóságát az oldalon. Az \"Öröklés\" opció a felmérés szintű beállítást alkalmazza, amely alapértelmezés szerint \"Látható\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Beállítja az időzítő láthatóságát és helyét az oldalon."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Válasszon a következők közül: \"Zárolt\" - a felhasználók nem bonthatják ki vagy csukhatják össze a paneleket; \"Az összes összecsukása\" - minden panel összecsukott állapotban indul; \"Összes kibontása\" - minden panel kibővített állapotban indul; \"Először bővített\" - csak az első panel bővül."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Adjon meg egy megosztott tulajdonságnevet az objektumok tömbjében, amely tartalmazza az adatválaszték-listában megjeleníteni kívánt kép- vagy videofájl URL-címeit."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "A bal oldali érték a feltételes szabályokban használt elemazonosítóként szolgál, a jobb oldali érték megjelenik a válaszadók számára."
// pehelp.title: "Type a user-friendly title to display." => "Írja be a megjelenítendő felhasználóbarát címet."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Biztosítja, hogy a felhasználók ne töltsék ki a felmérést a fájlok feltöltéséig."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS-értékeket fogad el (px, %, in, pt stb.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS-értékeket fogad el (px, %, in, pt stb.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS-értékeket fogad el (px, %, in, pt stb.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "Az egyszeres és többszörös kijelölésű kérdéstípusokban minden választási lehetőség rendelkezik azonosítóval és megjelenített értékkel. Ha be van jelölve, ez a beállítás azonosító érték helyett megjelenítési értéket jelenít meg a HTML-kérdésekben, valamint a dinamikus címekben és a földmérési elemek leírásában."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Válassza ki, hogy törli-e a feltételes logika által elrejtett kérdésértékeket, és mikor tegye meg. Az \"Öröklés\" opció a felmérési szintű beállítást alkalmazza (\"Felmérés befejezésekor\" alapértelmezés szerint)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Válasszon a következők közül: \"Összes\" - átmásolja az összes választási lehetőséget a kiválasztott kérdésből; \"Kiválasztott\" - dinamikusan másolja csak a kiválasztott választási lehetőségeket; \"Nem kiválasztott\" - dinamikusan csak a nem kiválasztott választási lehetőségeket másolja. A \"Nincs\" és az \"Egyéb\" opciók alapértelmezés szerint másolásra kerülnek, ha engedélyezve vannak a forráskérdésben."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Ha be van jelölve, a felhasználók további bevitelt adhatnak meg egy külön megjegyzésmezőben."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Minden speciális választási lehetőséget (\"Nincs\", \"Egyéb\", \"Összes kijelölése\") új sorban jelenít meg, még akkor is, ha többoszlopos elrendezést használ."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Adja meg azt a helyet a szolgáltatás adatkészletén belül, ahol az objektumok céltömbje található. Hagyja üresen, ha az URL-cím már a tömbre mutat."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Adjon meg egy egységes tulajdonságnevet az adatválaszték-listában megjeleníteni kívánt értékeket tartalmazó objektumtömbben."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Jelölje be, ha engedélyezni szeretné, hogy a szolgáltatás üres választ vagy tömböt adjon vissza."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "A varázspálca ikonnal feltételes szabályt állíthat be, amely meghatározza az összes választási lehetőség láthatóságát."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "A bal oldali érték a feltételes szabályokban használt elemazonosítóként szolgál, a jobb oldali érték megjelenik a válaszadók számára."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "Az \"Automatikus\" a rendelkezésre álló szélesség alapján választ a \"Gombok\" és a \"Legördülő menü\" módok között. Ha a szélesség nem elegendő a gombok megjelenítéséhez, a kérdés legördülő menüt jelenít meg."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Lehetővé teszi olyan kérdések összekapcsolását, amelyek különböző formátumú eredményeket hoznak. Ha az ilyen kérdések illesztési azonosítóval vannak összekapcsolva, ez a megosztott tulajdonság tárolja a kiválasztott kérdésértékeket."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Válassza ki, ha frissíteni szeretné a legördülő menü tartalmát, hogy megfeleljen a felhasználó által a beviteli mezőbe beírt keresési lekérdezésnek."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Olyan érték, amelyet meg kell menteni a felmérés eredményeiben, amikor a válaszadók pozitív választ adnak."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "A felmérés eredményeiben mentendő érték, ha a válaszadók negatív választ adnak."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Nem ajánlott letiltani ezt a beállítást, mivel felülbírálja az előnézeti képet, és megnehezíti a felhasználó számára annak megértését, hogy a fájlok fel lettek-e töltve."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "A fájl törlésének megerősítését kérő üzenet jelenik meg."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Engedélyezésével csak a kiválasztott választásokat rangsorolhatja. A felhasználók a kiválasztott elemeket az adatválaszték-listából húzzák, hogy a rangsorolási területen belül rendezzék őket."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Adja meg azoknak a választási lehetőségeknek a listáját, amelyeket a rendszer javasolni fog a válaszadónak a bevitel során."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "A beállítás csak a beviteli mezőket méretezi át, és nincs hatással a kérdésmező szélességére."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Konzisztens szélességet állít be az összes elemfelirathoz képpontban"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Az \"Automatikus\" opció automatikusan meghatározza a megjelenítéshez megfelelő módot - Kép, Videó vagy YouTube - a megadott forrás URL alapján."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Helyettesítőként szolgál, ha a kép nem jeleníthető meg a felhasználó eszközén, valamint kisegítő lehetőségek céljából."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Meghatározza a kiválasztott hangulatjel színét, ha az Értékelés ikon típusa \"Hangulatjelek\". Válasszon a következők közül: \"Alapértelmezett\" - a kiválasztott hangulatjel alapértelmezett felmérési színben jelenik meg; \"Skála\" - a kiválasztott hangulatjel örökli a színt a minősítési skálától."
// expression.name: "An expression ID that is not visible to respondents." => "Olyan kifejezésazonosító, amely nem látható a válaszadók számára."
// expression.description: "Type an expression subtitle." => "Írja be a kifejezés alcímét."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "A kifejezések tartalmazhatnak alapvető számításokat ('{q1_id} + {q2_id}'), feltételeket ('{age} > 60') és függvényeket ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' stb.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Válassza ezt a lehetőséget, ha az \"Egyéb\" beállítás értékét külön tulajdonságként szeretné tárolni a felmérés eredményeiben."
// p.swapOrder: "Swap the order of Yes and No" => "Az Igen és a Nem sorrendjének felcserélése"
// p.itemTitleWidth: "Item label width (in px)" => "Elemcímke szélessége (képpontban)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Megjelenítendő szöveg, ha az összes beállítás ki van jelölve"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "A rangsorolási terület helyőrző szövege"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "A felmérés automatikus kitöltése"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Válassza ki, hogy szeretné-e, hogy a felmérés automatikusan kitöltődjön, miután a válaszadó megválaszolta az összes kérdést."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Maszkolt érték mentése a felmérés eredményeiben"
// patternmask.pattern: "Value pattern" => "Értékminta"
// datetimemask.min: "Minimum value" => "Minimális érték"
// datetimemask.max: "Maximum value" => "Maximális érték"
// numericmask.allowNegativeValues: "Allow negative values" => "Negatív értékek engedélyezése"
// numericmask.thousandsSeparator: "Thousands separator" => "Több ezer szeparátor"
// numericmask.decimalSeparator: "Decimal separator" => "Tizedeselválasztó"
// numericmask.precision: "Value precision" => "Érték pontossága"
// numericmask.min: "Minimum value" => "Minimális érték"
// numericmask.max: "Maximum value" => "Maximális érték"
// currencymask.prefix: "Currency prefix" => "Pénznem előtag"
// currencymask.suffix: "Currency suffix" => "Pénznem utótagja"
// pe.maskType: "Input mask type" => "Beviteli maszk típusa"
// maskTypes.patternmask: "Pattern" => "Minta"
// maskTypes.numericmask: "Numeric" => "Numerikus"
// maskTypes.datetimemask: "Date and Time" => "Dátum és idő"
// maskTypes.currencymask: "Currency" => "Valuta"
// tabs.mask: "Input Mask Settings" => "Beviteli maszk beállításai"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Pl.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Pl.: éééé/hh/nn"
// pe.currencyprefix_placeholder: "Ex.: $" => "Pl.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Pl.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Tördelési lehetőségek"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "A választási lehetőségekben szereplő hosszú szövegek automatikusan sortöréseket generálnak, hogy elférjenek a legördülő menüben. Törölje a jelet a jelölőnégyzetből, ha le szeretné vágni a szövegeket."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Válassza ki, ha a kérdés értékét alkalmazott maszkkal szeretné tárolni a felmérés eredményeiben."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "A minta karakterlánc-konstansokat és a következő helyőrzőket tartalmazhatja: \"9\" - egy számjegyhez; \"a\" - kis- vagy nagybetű esetében; '#' - számjegy vagy kis- vagy nagybetű. A fordított perjel használata \"\\\" a karakter elhagyásához."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "A minta elválasztó karaktereket és a következő helyőrzőket tartalmazhatja: \"m\" - a hónap száma; \"mm\" – a hónap száma, az első nullával az egyjegyű értékek esetében; \"d\" - a hónap napja; \"dd\" – a hónap napja, az első nullával az egyjegyű értékek esetében; \"yy\" – az év utolsó két számjegye; \"yyyy\" – négy számjegyű évre."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "A törtrész és a megjelenített szám egész részének elválasztására szolgáló szimbólum."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Egy szimbólum, amely nagy szám számjegyeit három csoportba sorolja."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Korlátozza, hogy hány számjegy maradjon meg a megjelenített szám tizedesvesszője után."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Egy vagy több szimbólum jelenik meg az érték előtt."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Egy vagy több szimbólum jelenik meg az érték után."
// ed.translationSource: "Source: " => "Forrás: "
// ed.translationTarget: "Target: " => "Cél: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Az oldal üres. Húzzon egy elemet az eszköztárról, vagy kattintson az alábbi gombra."
// maskTypes.none: "None" => "Egyik sem"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Tegye láthatóvá a sort, ha"
// itemvalue@rows.enableIf: "Make the row editable if" => "Tegye szerkeszthetővé a sort, ha:"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Helyőrző szöveg írásvédett vagy előnézeti módban"
// pe.textWrapEnabled: "Wrap choices" => "Tördelési lehetőségek"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Az \"Automatikus\" opció automatikusan meghatározza a megjelenítéshez megfelelő módot - Kép, Videó vagy YouTube - a megadott forrás URL alapján."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Válasszon a \"Kép\" és a \"Videó\" között a médiaválasztó tartalommódjának beállításához. Ha a \"Kép\" van kiválasztva, győződjön meg arról, hogy az összes rendelkezésre álló opció a következő formátumú képfájlok: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Hasonlóképpen, ha a \"Video\" van kiválasztva, győződjön meg arról, hogy az összes opció közvetlen link a következő formátumú videofájlokhoz: MP4, MOV, WMV, FLV, AVI, MKV. Felhívjuk figyelmét, hogy a YouTube-linkek nem támogatottak a videóbeállításoknál."
// ed.selectFile: "Select a file" => "Válasszon ki egy fájlt"
// ed.removeFile: "Remove the file" => "A fájl eltávolítása"
// pe.searchMode: "Search Mode" => "Keresési mód"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Kattintson az alábbi \"Kérdés hozzáadása\" gombra az űrlap létrehozásának megkezdéséhez."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Kattintson az alábbi \"Kérdés hozzáadása\" gombra, hogy új elemet adjon az oldalhoz."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Kattintson az alábbi \"Kérdés hozzáadása\" gombra, hogy új elemet adjon a panelhez."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Kattintson az alábbi gombra, és válassza ki a feltölteni kívánt képet"
// coloralpha.opacity: "Opacity" => "Átlátszatlanság"
// font.family: "Font family" => "Betűcsalád"
// font.color: "Color" => "Szín"
// font.placeholderColor: "Placeholder color" => "Helyőrző színe"
// font.size: "Size" => "Méret"
// theme.themeName: "Theme" => "Téma"
// theme.isPanelless: "Question appearance" => "Kérdés megjelenése"
// theme.editorPanel: "Background and corner radius" => "Háttér és saroksugár"
// theme.questionPanel: "Background and corner radius" => "Háttér és saroksugár"
// theme.primaryColor: "Accent color" => "Kiemelő szín"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Panel hátterének átlátszatlansága"
// theme.questionBackgroundTransparency: "Question background opacity" => "Kérdés hátterének átlátszatlansága"
// theme.fontSize: "Font size" => "Betűméret"
// theme.scale: "Scale" => "Hangsor"
// theme.cornerRadius: "Corner radius" => "Sarok sugara"
// theme.pageTitle: "Title font" => "Cím betűtípusa"
// theme.pageDescription: "Description font" => "Leírás betűtípus"
// theme.questionTitle: "Title font" => "Cím betűtípusa"
// theme.questionDescription: "Description font" => "Leírás betűtípus"
// theme.editorFont: "Font" => "Betűkészlet"
// theme.backgroundOpacity: "Opacity" => "Átlátszatlanság"
// theme.--sjs-font-family: "Font family" => "Betűcsalád"
// theme.--sjs-general-backcolor-dim: "Background color" => "Háttérszín"
// theme.--sjs-primary-backcolor: "Accent background" => "Ékezetes háttér"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Hangsúlyos előtér"
// theme.--sjs-shadow-small: "Shadow effects" => "Árnyék effektusok"
// theme.--sjs-shadow-inner: "Shadow effects" => "Árnyék effektusok"
// theme.--sjs-border-default: "Colors" => "Színek"
// header@header.headerView: "View" => "Nézet"
// header@header.logoPosition: "Logo position" => "Logó pozíciója"
// header@header.surveyTitle: "Survey title font" => "Felmérés címének betűtípusa"
// header@header.surveyDescription: "Survey description font" => "Felmérés leírásának betűtípusa"
// header@header.headerTitle: "Survey title font" => "Felmérés címének betűtípusa"
// header@header.headerDescription: "Survey description font" => "Felmérés leírásának betűtípusa"
// header@header.inheritWidthFrom: "Content area width" => "Tartalomterület szélessége"
// header@header.textAreaWidth: "Text width" => "Szöveg szélessége"
// header@header.backgroundColorSwitch: "Background color" => "Háttérszín"
// header@header.backgroundImage: "Background image" => "Háttérkép"
// header@header.backgroundImageOpacity: "Opacity" => "Átlátszatlanság"
// header@header.overlapEnabled: "Overlap" => "Átfed"
// header@header.logoPositionX: "Logo position" => "Logó pozíciója"
// header@header.titlePositionX: "Title position" => "Cím pozíciója"
// header@header.descriptionPositionX: "Description position" => "Leírás pozíciója"
// weight.400: "Regular" => "Rendszeres"
// weight.600: "Heavy" => "Nehéz"
// weight.700: "Semi-bold" => "Félig félkövér"
// weight.800: "Bold" => "Merész"
// backgroundImageFit.auto: "Auto" => "Kocsi"
// backgroundImageFit.cover: "Cover" => "Fedő"
// backgroundImageFit.contain: "Contain" => "Tartalmaz"
// backgroundImageFit.fill: "Stretch" => "Nyúlik"
// backgroundImageFit.tile: "Tile" => "Cserép"
// backgroundImageAttachment.fixed: "Fixed" => "Fix"
// backgroundImageAttachment.scroll: "Scroll" => "Kézirattekercs"
// headerView.basic: "Basic" => "Alapvető"
// headerView.advanced: "Advanced" => "Haladó"
// inheritWidthFrom.survey: "Same as survey" => "Ugyanaz, mint a felmérés"
// inheritWidthFrom.container: "Fit to container" => "Tárolóhoz igazítás"
// backgroundColorSwitch.none: "None" => "Egyik sem"
// backgroundColorSwitch.accentColor: "Accent color" => "Kiemelő szín"
// backgroundColorSwitch.custom: "Custom" => "Szokás"
// colorPalette.light: "Light" => "Fény"
// colorPalette.dark: "Dark" => "Sötét"
// isPanelless.false: "Default" => "Alapértelmezett"
// isPanelless.true: "Without Panels" => "Panelek nélkül"
// theme.cornerRadius: "Corner radius" => "Sarok sugara"
// theme.fontFamily: "Font family" => "Betűcsalád"
// theme.fontWeightRegular: "Regular" => "Rendszeres"
// theme.fontWeightHeavy: "Heavy" => "Nehéz"
// theme.fontWeightSemiBold: "Semi-bold" => "Félig félkövér"
// theme.fontWeightBold: "Bold" => "Merész"
// theme.color: "Color" => "Szín"
// theme.placeholderColor: "Placeholder color" => "Helyőrző színe"
// theme.size: "Size" => "Méret"
// theme.opacity: "Opacity" => "Átlátszatlanság"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Írja be a kereséshez..."
// ed.toolboxNoResultsFound: "No results found" => "Nincs találat"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Lapcím helyőrzője"
// theme.--sjs-special-red: "Error messages" => "Hibaüzenetek"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "A lapcímek alapszövege, amely akkor érvényes, ha a lap címmintája nem ad értelmes értéket."
// theme.fontColor: "Font color" => "Betűszín"
// theme.backgroundColor: "Background color" => "Háttérszín"
// pe.questionTitleWidth: "Question title width" => "Kérdés címének szélessége"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Válasszon ki egy fájlt, vagy illesszen be egy fájlhivatkozást..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Pl.: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Egységes szélességet állít be a kérdéscímekhez, ha azok a kérdésmezőktől balra vannak igazítva. CSS-értékeket fogad el (px, %, in, pt stb.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Egységes szélességet állít be a kérdéscímekhez, ha azok a kérdésmezőktől balra vannak igazítva. CSS-értékeket fogad el (px, %, in, pt stb.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Megjegyzés területének magassága (sorokban)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Beállítja a kérdésmegjegyzések szövegterületein megjelenített sorok számát. A bemenet több sort foglal el, megjelenik a görgetősáv."


/***/ }),

/***/ "./src/localization/indonesian.ts":
/*!****************************************!*\
  !*** ./src/localization/indonesian.ts ***!
  \****************************************/
/*! exports provided: indonesianStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indonesianStrings", function() { return indonesianStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var indonesianStrings = {
    // survey templates
    survey: {
        edit: "Ubah",
        externalHelpLink: "Tonton dan pelajari cara membuat survei",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Silahkan letakkan pertanyaan di sini dari Kotak Perkakas di sebelah kiri.",
        addLogicItem: "Buat aturan untuk menyesuaikan alur survei.",
        copy: "Salin",
        duplicate: "Duplikat",
        addToToolbox: "Tambahkan ke Kotak Perkakas",
        deletePanel: "Hapus Panel",
        deleteQuestion: "Hapus Pertanyaan",
        convertTo: "Mengubah ke",
        drag: "Tarik elemen",
    },
    // Creator tabs
    tabs: {
        preview: "Coba Survei",
        theme: "Tema",
        translation: "Terjemahan",
        designer: "Rancangan Survei",
        editor: "Pengubah JSON",
        logic: "Logika"
    },
    // Question types
    qt: {
        default: "Default",
        checkbox: "Kotak Centang",
        comment: "Komentar",
        imagepicker: "Gambar",
        ranking: "Peringkat",
        image: "Citra",
        dropdown: "Kotak Kombo",
        tagbox: "Dropdown Multi-Pilih",
        file: "Berkas",
        html: "Html",
        matrix: "Matriks (pilihan tunggal)",
        matrixdropdown: "Matriks (pilihan ganda)",
        matrixdynamic: "Matriks (baris dinamis)",
        multipletext: "Teks Ganda",
        panel: "Panel",
        paneldynamic: "Panel (panel dinamis)",
        radiogroup: "Pilihan Ganda",
        rating: "Peringkat",
        text: "Input Tunggal",
        boolean: "Yes/No (Boolean)",
        expression: "Ekspresi (dibaca saja)",
        signaturepad: "Tanda tangan",
        buttongroup: "Grup Tombol"
    },
    toolboxCategories: {
        general: "Umum",
        choice: "Pertanyaan Pilihan",
        text: "Pertanyaan Input Teks",
        containers: "Wadah",
        matrix: "Pertanyaan Matriks",
        misc: "Misc"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Default ({0})",
        survey: "Survei",
        settings: "Pengaturan Survei",
        settingsTooltip: "Buka pengaturan",
        surveySettings: "Pengaturan Survei",
        surveySettingsTooltip: "Pengaturan survei",
        themeSettings: "Pengaturan Tema",
        themeSettingsTooltip: "Pengaturan tema",
        showPanel: "Tampilkan Panel",
        hidePanel: "Sembunyikan Panel",
        prevSelected: "Pilih sebelumnya",
        nextSelected: "Pilih selanjutnya",
        prevFocus: "Fokus sebelumnya",
        nextFocus: "Fokus berikutnya",
        surveyTypeName: "Survei",
        pageTypeName: "Halaman",
        panelTypeName: "Panel",
        questionTypeName: "Pertanyaan",
        columnTypeName: "Kolom",
        addNewPage: "Tambah Halaman Baru",
        moveRight: "Geser ke Kanan",
        moveLeft: "Geser ke Kiri",
        deletePage: "Hapus Halaman",
        editPage: "Ubah Halaman",
        edit: "Ubah",
        newPageName: "halaman",
        newQuestionName: "pertanyaan",
        newPanelName: "panel",
        newTextItemName: "Teks",
        defaultV2Theme: "Default",
        modernTheme: "Modern",
        defaultTheme: "Default (warisan)",
        testSurveyAgain: "Coba Survei Lagi",
        testSurveyWidth: "Lebar survei: ",
        navigateToMsg: "Anda harus menavigasi ke",
        saveSurvey: "Simpan Survei",
        saveSurveyTooltip: "Simpan Survei",
        saveTheme: "Simpan Tema",
        saveThemeTooltip: "Simpan Tema",
        jsonHideErrors: "Menyembunyikan kesalahan",
        jsonShowErrors: "Tampilkan kesalahan",
        undo: "Urungkan",
        redo: "Ulangi",
        undoTooltip: "Mengurungkan perubahan terakhir",
        redoTooltip: "Mengulangi perubahan",
        showMoreChoices: "Tampilkan lebih banyak",
        showLessChoices: "Tampilkan lebih sedikit",
        copy: "Menyalin",
        cut: "Memotong",
        paste: "Pasta",
        copyTooltip: "Salin pilihan ke clipboard",
        cutTooltip: "Memotong pilihan ke clipboard",
        pasteTooltip: "Tempel dari papan klip",
        options: "Pilihan",
        generateValidJSON: "Hasilkan JSON yang Valid",
        generateReadableJSON: "Hasilkan JSON yang dapat dibaca",
        toolbox: "Kotak Perkakas",
        "property-grid": "Properti",
        toolboxFilteredTextPlaceholder: "Ketik untuk mencari...",
        toolboxNoResultsFound: "Tidak ada hasil yang ditemukan",
        propertyGridFilteredTextPlaceholder: "Ketik untuk mencari...",
        propertyGridNoResultsFound: "Tidak ada hasil yang ditemukan",
        correctJSON: "Please correct JSON.",
        surveyResults: "Hasil survei: ",
        surveyResultsTable: "Sebagai tabel",
        surveyResultsJson: "Sebagai JSON",
        resultsTitle: "Judul Pertanyaan",
        resultsName: "Nama Pertanyaan",
        resultsValue: "Nilai Jawaban",
        resultsDisplayValue: "Tampilkan Nilai",
        modified: "Dimodifikasi",
        saving: "Menyimpan",
        saved: "Tersimpan",
        propertyEditorError: "Kesalahan",
        saveError: "Error! Konten editor tidak berhasil disimpan.",
        translationPropertyGridTitle: "Pengaturan Bahasa",
        themePropertyGridTitle: "Pengaturan Tema",
        translationLanguages: "Bahasa",
        translationDeleteLanguage: "Apakah Anda yakin ingin menghapus semua string untuk bahasa ini?",
        translationAddLanguage: "Pilih bahasa untuk terjemahan",
        translationShowAllStrings: "Tampilkan seluruh string",
        translationShowUsedStringsOnly: "Hanya String yang Digunakan",
        translationShowAllPages: "Tampilkan seluruh halaman",
        translationNoStrings: "Tidak ada string diterjemahkan. Silahkan ganti penyaring.",
        translationExportToSCVButton: "Eksport ke CSV",
        translationImportFromSCVButton: "Import dari CSV",
        translateUsigAI: "Terjemahkan otomatis Semua",
        translateUsigAIFrom: "Terjemahkan dari: ",
        translationDialogTitle: "String yang tidak diterjemahkan",
        translationMergeLocaleWithDefault: "Gabungkan {0} dengan default locale",
        translationPlaceHolder: "Terjemahan...",
        translationSource: "Sumber: ",
        translationTarget: "Target: ",
        themeExportButton: "Ekspor",
        themeImportButton: "Mengimpor",
        surveyJsonExportButton: "Ekspor",
        surveyJsonImportButton: "Mengimpor",
        surveyJsonCopyButton: "Salin ke papan klip",
        themeResetButton: "Setel ulang pengaturan tema ke default",
        themeResetConfirmation: "Apakah Anda benar-benar ingin mengatur ulang tema? Semua penyesuaian Anda akan hilang.",
        themeResetConfirmationOk: "Ya, atur ulang tema",
        bold: "Tebal",
        italic: "Miring",
        underline: "Garis Bawah",
        addNewQuestion: "Tambah pertanyaan",
        selectPage: "Pilih halaman...",
        carryForwardChoicesCopied: "Pilihan disalin dari",
        choicesLoadedFromWebText: "Pilihan dimuat dari layanan web.",
        choicesLoadedFromWebLinkText: "Buka pengaturan",
        choicesLoadedFromWebPreviewTitle: "Pratinjau opsi pilihan yang dimuat",
        htmlPlaceHolder: "Konten HTML akan ada di sini.",
        panelPlaceHolder: "Jatuhkan pertanyaan dari kotak alat di sini.",
        surveyPlaceHolder: "Survei kosong. Seret elemen dari kotak alat atau klik tombol di bawah.",
        pagePlaceHolder: "Halaman kosong. Seret elemen dari kotak alat atau klik tombol di bawah.",
        imagePlaceHolder: "Seret dan lepas gambar di sini atau klik tombol di bawah ini dan pilih gambar untuk diunggah",
        surveyPlaceHolderMobile: "Klik tombol \"Tambahkan Pertanyaan\" di bawah ini untuk mulai membuat formulir Anda.",
        pagePlaceHolderMobile: "Klik tombol \"Tambahkan Pertanyaan\" di bawah ini untuk menambahkan elemen baru ke halaman.",
        panelPlaceHolderMobile: "Klik tombol \"Tambahkan Pertanyaan\" di bawah ini untuk menambahkan elemen baru ke panel.",
        imagePlaceHolderMobile: "Klik tombol di bawah ini dan pilih gambar untuk diunggah",
        imageChooseImage: "Pilih Gambar",
        addNewTypeQuestion: "Tambahkan {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Benda ",
        selectFile: "Pilih file",
        removeFile: "Menghapus file",
        lg: {
            addNewItem: "Tambahkan Aturan Baru",
            empty_tab: "Buat aturan untuk menyesuaikan alur survei.",
            page_visibilityName: "Tampilkan (sembunyikan) halaman",
            page_enableName: "Aktifkan (nonaktifkan) halaman",
            page_requireName: "Buat halaman diperlukan",
            panel_visibilityName: "Tampilkan (sembunyikan) panel",
            panel_enableName: "Aktifkan (nonaktifkan) panel",
            panel_requireName: "Buat halaman diperlukan",
            question_visibilityName: "Tampilkan (sembunyikan) pertanyaan",
            question_enableName: "Aktifkan (nonaktifkan) pertanyaan",
            question_requireName: "Buat pertanyaan diperlukan",
            question_resetValueName: "Mereset nilai pertanyaan",
            question_setValueName: "Tetapkan nilai pertanyaan",
            column_visibilityName: "Perlihatkan (sembunyikan) kolom",
            column_enableName: "Mengaktifkan (menonaktifkan) kolom",
            column_requireName: "Buat kolom diperlukan",
            column_resetValueName: "Mereset nilai kolom",
            column_setValueName: "Mengatur nilai kolom",
            trigger_completeName: "Survei lengkap",
            trigger_setvalueName: "Tetapkan jawaban",
            trigger_copyvalueName: "Salin jawaban",
            trigger_skipName: "Lanjut ke pertanyaan",
            trigger_runExpressionName: "Menjalankan ekspresi",
            completedHtmlOnConditionName: "Mengatur markup halaman \"Survei Selesai\"",
            page_visibilityDescription: "Membuat halaman terlihat saat ekspresi logika mengembalikan true. Jika tidak, jaga agar tidak terlihat.",
            panel_visibilityDescription: "Buat panel terlihat saat ekspresi logika mengembalikan true. Jika tidak, jaga agar tidak terlihat.",
            panel_enableDescription: "Buat panel, dan semua elemen di dalamnya, aktifkan saat ekspresi logika mengembalikan true. Jika tidak, biarkan mereka dinonaktifkan.",
            question_visibilityDescription: "Buat pertanyaan terlihat saat ekspresi logika mengembalikan true. Jika tidak, jaga agar tidak terlihat.",
            question_enableDescription: "Aktifkan pertanyaan saat ekspresi logika mengembalikan true. Jika tidak, tetap nonaktifkan.",
            question_requireDescription: "Pertanyaan menjadi diperlukan saat ekspresi logika mengembalikan true.",
            trigger_completeDescription: "Ketika ekspresi logika mengembalikan true maka survei menjadi selesai dan pengguna akhir melihat 'Halaman terima kasih'.",
            trigger_setvalueDescription: "Ketika nilai pertanyaan, yang digunakan dalam ekspresi logika, diubah dan ekspresi logika mengembalikan true, maka nilai diatur ke pertanyaan yang dipilih.",
            trigger_copyvalueDescription: "Ketika nilai pertanyaan, yang digunakan dalam ekspresi logika, diubah dan ekspresi logika mengembalikan true, maka nilai satu pertanyaan yang dipilih disalin ke pertanyaan lain yang dipilih.",
            trigger_skipDescription: "Ketika ekspresi logika mengembalikan true maka survei melompat ke / memfokuskan pertanyaan yang dipilih.",
            trigger_runExpressionDescription: "Ketika ekspresi logika mengembalikan true, maka ekspresi kustom dilakukan. Anda dapat secara opsional mengatur hasil ekspresi ini ke dalam pertanyaan yang dipilih",
            completedHtmlOnConditionDescription: "Jika ekspresi logika mengembalikan true, maka teks default untuk 'Halaman terima kasih' diubah ke yang diberikan.",
            itemExpressionText: "Ketika ekspresi: '{0}' mengembalikan true",
            itemEmptyExpressionText: "Aturan baru",
            page_visibilityText: "Membuat halaman {0} terlihat",
            panel_visibilityText: "Membuat panel {0} terlihat",
            panel_enableText: "Membuat panel {0} mengaktifkan",
            question_visibilityText: "Buat pertanyaan {0} terlihat",
            question_enableText: "Buat pertanyaan {0} aktifkan",
            question_requireText: "Buat pertanyaan {0} diperlukan",
            question_resetValueText: "reset nilai untuk pertanyaan: {0}",
            question_setValueText: "Tetapkan nilai: {1} pertanyaan: {0}",
            column_visibilityText: "Membuat kolom {0} pertanyaan {1} terlihat",
            column_enableText: "Buat kolom {0} pertanyaan {1} aktifkan",
            column_requireText: "membuat kolom {0} pertanyaan {1} diperlukan",
            column_resetValueText: "Setel ulang nilai sel untuk kolom: {0}",
            column_setValueText: "Menetapkan nilai sel: {1} ke kolom: {0}",
            setValueExpressionPlaceholder: " Ekspresi yang hasilnya akan ditetapkan ke pertanyaan target.",
            trigger_completeText: "Survei menjadi selesai",
            trigger_setvalueText: "Pertanyaan: {0} nilai {1}",
            trigger_setvalueEmptyText: "Nilai Pertanyaan yang Jelas: {0}",
            trigger_copyvalueText: "Salin ke pertanyaan: {0} nilai dari pertanyaan {1}",
            trigger_skipText: "Survei Lewati ke pertanyaan {0}",
            trigger_runExpressionText1: "menjalankan ekspresi: '{0}'",
            trigger_runExpressionText2: " dan mempertanyakan hasilnya: {0}",
            completedHtmlOnConditionText: "tampilkan teks kustom untuk \"Halaman terima kasih\".",
            showAllQuestions: "Semua Pertanyaan",
            showAllActionTypes: "Semua Jenis Tindakan",
            conditions: "Ketentuan",
            actions: "Tindakan",
            expressionEditorTitle: "Tentukan kondisi",
            actionsEditorTitle: "Menentukan tindakan",
            deleteAction: "Hapus Tindakan",
            addNewAction: "Tambahkan Tindakan",
            selectedActionCaption: "Pilih tindakan...",
            expressionInvalid: "Ekspresi logika kosong atau tidak valid. Mohon koreksinya.",
            noActionError: "Tolong, tambahkan setidaknya satu tindakan.",
            actionInvalid: "Tolong, perbaiki masalah dalam tindakan Anda.",
            uncompletedRule_title: "Aturan logis tidak lengkap",
            uncompletedRule_text: "Anda belum menyelesaikan beberapa aturan logis. Jika Anda meninggalkan tab sekarang, perubahan akan hilang. Apakah Anda masih ingin meninggalkan tab tanpa menyelesaikan perubahan?",
            uncompletedRule_apply: "Ya",
            uncompletedRule_cancel: "Tidak, saya ingin menyelesaikan aturan"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Nama panel",
            title: "Judul panel",
            description: "Deskripsi panel",
            visibleIf: "Buat panel terlihat jika",
            requiredIf: "Buat panel diperlukan jika",
            questionsOrder: "Urutan pertanyaan dalam panel",
            page: "Halaman induk",
            startWithNewLine: "Menampilkan panel pada baris baru",
            state: "Status keruntuhan panel",
            width: "Lebar panel sejajar",
            minWidth: "Lebar panel minimum",
            maxWidth: "Lebar panel maksimum",
            showNumber: "Panel angka"
        },
        paneldynamic: {
            name: "Nama panel",
            title: "Judul panel",
            description: "Deskripsi panel",
            visibleIf: "Buat panel terlihat jika",
            requiredIf: "Buat panel diperlukan jika",
            page: "Memindahkan panel ke halaman",
            startWithNewLine: "Menampilkan panel pada baris baru",
            state: "Status keruntuhan panel",
            width: "Lebar panel sejajar",
            minWidth: "Lebar panel minimum",
            maxWidth: "Lebar panel maksimum",
            confirmDelete: "Konfirmasi penghapusan panel",
            templateDescription: "Pola deskripsi panel",
            templateTitle: "Pola judul panel",
            noEntriesText: "Teks panel kosong",
            templateTabTitle: "Pola judul tab",
            tabTitlePlaceholder: "Tempat penampung judul tab",
            templateVisibleIf: "Membuat panel individual terlihat jika",
            hideNumber: "Menyembunyikan nomor panel",
            titleLocation: "Perataan judul panel",
            descriptionLocation: "Perataan deskripsi panel",
            templateTitleLocation: "Perataan judul pertanyaan",
            templateErrorLocation: "Perataan pesan kesalahan",
            newPanelPosition: "Lokasi panel baru",
            keyName: "Cegah respons duplikat dalam pertanyaan berikut"
        },
        question: {
            name: "Nama pertanyaan",
            title: "Judul pertanyaan",
            description: "Deskripsi pertanyaan",
            visibleIf: "Buat pertanyaan terlihat jika",
            requiredIf: "Buat pertanyaan diperlukan jika",
            page: "Halaman induk",
            state: "Status ciutkan kotak pertanyaan",
            hideNumber: "Menyembunyikan nomor pertanyaan",
            titleLocation: "Perataan judul pertanyaan",
            descriptionLocation: "Perataan deskripsi pertanyaan",
            errorLocation: "Perataan pesan kesalahan",
            indent: "Tingkatkan indentasi batin",
            width: "Lebar pertanyaan sebaris",
            minWidth: "Lebar pertanyaan minimum",
            maxWidth: "Lebar pertanyaan maksimum",
            textUpdateMode: "Perbarui nilai bidang input"
        },
        signaturepad: {
            signatureWidth: "Lebar area tanda tangan",
            signatureHeight: "Tinggi area tanda tangan",
            signatureAutoScaleEnabled: "Menskalakan area tanda tangan secara otomatis",
            showPlaceholder: "Memperlihatkan tempat penampung",
            placeholder: "Teks tempat penampung",
            placeholderReadOnly: "Teks tempat penampung dalam mode baca-saja atau pratinjau",
            allowClear: "Perlihatkan tombol Hapus di dalam area tanda tangan",
            penMinWidth: "Lebar pena minimum",
            penMaxWidth: "Lebar pena maksimum",
            penColor: "Warna goresan"
        },
        comment: {
            rows: "Tinggi bidang input (dalam baris)"
        },
        showQuestionNumbers: "Tampilkan nomor pertanyaan",
        questionStartIndex: "Indeks mulai pertanyaan (1, 2 atau 'A', 'a')",
        expression: {
            name: "Nama ekspresi",
            title: "Judul ekspresi",
            description: "Deskripsi ekspresi",
            expression: "Ekspresi"
        },
        trigger: {
            expression: "Ekspresi"
        },
        calculatedvalue: {
            expression: "Ekspresi"
        },
        // survey templates
        survey: {
            title: "Titel",
            description: "Deskripsi survei"
        },
        page: {
            name: "Nama halaman",
            title: "Titel",
            description: "Deskripsi halaman",
            visibleIf: "Membuat halaman terlihat jika",
            requiredIf: "Buat halaman diperlukan jika",
            maxTimeToFinish: "Batas waktu untuk menyelesaikan halaman (dalam detik)",
            questionsOrder: "Urutan pertanyaan di halaman"
        },
        matrixdropdowncolumn: {
            name: "Nama kolom",
            title: "Judul kolom",
            isUnique: "Mencegah respons duplikat",
            width: "Lebar kolom",
            minWidth: "Lebar kolom minimum",
            rows: "Tinggi bidang input (dalam baris)",
            visibleIf: "Membuat kolom terlihat jika",
            requiredIf: "Buat kolom diperlukan jika",
            showInMultipleColumns: "Setiap opsi dalam kolom terpisah"
        },
        multipletextitem: {
            name: "Nama",
            title: "Titel"
        },
        masksettings: {
            saveMaskedValue: "Simpan nilai terselubung dalam hasil survei"
        },
        patternmask: {
            pattern: "Pola nilai"
        },
        datetimemask: {
            min: "Nilai minimum",
            max: "Nilai maksimum"
        },
        numericmask: {
            allowNegativeValues: "Izinkan nilai negatif",
            thousandsSeparator: "Pemisah ribuan",
            decimalSeparator: "Pemisah desimal",
            precision: "Presisi nilai",
            min: "Nilai minimum",
            max: "Nilai maksimum"
        },
        currencymask: {
            prefix: "Awalan mata uang",
            suffix: "Akhiran mata uang"
        },
        imageHeight: "Tinggi gambar",
        imageWidth: "Lebar gambar",
        valueName: "Nama nilai",
        rateDescriptionLocation: "Perataan label",
        size: "Ukuran bidang input (dalam karakter)",
        cellErrorLocation: "Perataan pesan kesalahan sel",
        apply: "Terapkan",
        ok: "OK",
        save: "Simpan",
        clear: "Jelas",
        saveTooltip: "Simpan",
        cancel: "Batal",
        set: "Mengeset",
        reset: "Reset",
        change: "Ubah",
        refresh: "Refresh",
        close: "Tutup",
        delete: "Hapus",
        add: "Tambah",
        addNew: "Tambahkan Baru",
        addItem: "Klik untuk menambahkan sebuah item...",
        removeItem: "Klik untuk menghapus item...",
        dragItem: "Seret item",
        addOther: "Lain",
        addSelectAll: "Pilih Semua",
        addNone: "Tidak",
        removeAll: "Hapus Semua",
        edit: "Ubah",
        back: "Pengembalian tanpa menabung",
        backTooltip: "Pengembalian tanpa menabung",
        saveAndBack: "Simpan dan kembalikan",
        saveAndBackTooltip: "Simpan dan kembalikan",
        doneEditing: "Selesai",
        editChoices: "Ubah Pilihan",
        showChoices: "Tampilkan Pilihan",
        move: "Pindah",
        empty: "<kosong>",
        emptyValue: "Nilai kosong",
        fastEntry: "Entri Cepat",
        fastEntryNonUniqueError: "Nilai '{0}' tidak unik",
        fastEntryChoicesCountError: "Harap batasi jumlah item dari {0} ke {1}",
        fastEntryChoicesMinCountError: "Harap masukkan setidaknya {0} item",
        fastEntryPlaceholder: "Anda dapat mengatur data dalam format berikut:\nvalue1|text\nnilai2",
        formEntry: "Entri Form",
        testService: "Coba layanan",
        itemSelectorEmpty: "Silakan pilih elemen",
        conditionActionEmpty: "Silakan pilih tindakan",
        conditionSelectQuestion: "Pilih pertanyaan...",
        conditionSelectPage: "Pilih halaman...",
        conditionSelectPanel: "Pilih panel...",
        conditionValueQuestionTitle: "Silahkan masukkan/pilih nilai",
        aceEditorHelp: "Tekan ctrl+spasi untuk mendapatkan petunjuk penyelesaian ekspresi",
        aceEditorRowTitle: "Baris saat ini",
        aceEditorPanelTitle: "Panel saat ini",
        showMore: "Untuk detil selanjutnya silahkan periksa dokumentasi",
        assistantTitle: "Pertanyaan tersedia:",
        cellsEmptyRowsColumns: "Harus ada setidaknya satu kolom atau baris",
        showPreviewBeforeComplete: "Melihat pratinjau jawaban sebelum mengirimkan survei",
        overridingPropertyPrefix: "Ditetapkan oleh ",
        resetToDefaultCaption: "Reset",
        propertyIsEmpty: "Silahkan masukkan nilai",
        propertyIsNoUnique: "Silakan masukkan nilai unik",
        propertyNameIsNotUnique: "Silakan masukkan nama yang unik",
        propertyNameIsIncorrect: "Jangan gunakan kata-kata khusus: \"item\", \"pilihan\", \"panel\", \"baris\".",
        listIsEmpty: "Belum ada item yang ditambahkan",
        "listIsEmpty@choices": "Belum ada pilihan yang ditambahkan",
        "listIsEmpty@columns": "Anda belum memiliki kolom apa pun",
        "listIsEmpty@rows": "Anda belum memiliki baris",
        "listIsEmpty@validators": "Anda belum memiliki aturan validasi apa pun",
        "listIsEmpty@calculatedValues": "Anda belum memiliki variabel khusus",
        "listIsEmpty@triggers": "Anda belum memiliki pemicu apa pun",
        "listIsEmpty@navigateToUrlOnCondition": "Anda belum memiliki tautan apa pun",
        "addNew@choices": "Menambahkan pilihan",
        "addNew@columns": "Tambahkan kolom baru",
        "addNew@rows": "Menambahkan baris baru",
        "addNew@validators": "Tambahkan aturan baru",
        "addNew@calculatedValues": "Tambahkan variabel baru",
        "addNew@triggers": "Tambahkan pemicu baru",
        "addNew@navigateToUrlOnCondition": "Tambahkan URL baru",
        expressionIsEmpty: "Ekspresi kosong",
        value: "Nilai",
        text: "Teks",
        rowid: "ID baris",
        imageLink: "Link Gambar",
        columnEdit: "Ubah kolom: {0}",
        itemEdit: "Ubah item: {0}",
        url: "URL",
        path: "Path",
        choicesbyurl: {
            url: "URL layanan web",
            valueName: "Dapatkan nilai dari bidang JSON berikut"
        },
        titleName: "Nama judul",
        imageLinkName: "Dapatkan URL gambar dari bidang JSON berikut",
        allowEmptyResponse: "Izinkan respons kosong",
        titlePlaceholder: "Titel",
        surveyTitlePlaceholder: "Judul Survei",
        pageTitlePlaceholder: "Halaman {num}",
        descriptionPlaceholder: "Deskripsi",
        surveyDescriptionPlaceholder: "Deskripsi",
        pageDescriptionPlaceholder: "Deskripsi",
        textWrapEnabled: "Pilihan bungkus",
        showOtherItem: "Memiliki item lain",
        otherText: "Teks item lain",
        showNoneItem: "Perbolehkan opsi Tidak Ada",
        showRefuseItem: "Perbolehkan opsi Tolak Jawab",
        showDontKnowItem: "Perbolehkan opsi Tidak Tahu",
        noneText: "Tidak ada teks opsi",
        showSelectAllItem: "Perbolehkan opsi Pilih Semua",
        selectAllText: "Pilih Semua teks opsi",
        choicesMin: "Nilai minimum untuk item yang dibuat secara otomatis",
        choicesMax: "Nilai maksimum untuk item yang dibuat secara otomatis",
        choicesStep: "Langkah untuk item yang dibuat secara otomatis",
        name: "Nama",
        title: "Judul",
        cellType: "Jenis sel",
        colCount: "Jumlah kolom",
        choicesOrder: "Tentukan urutan pilihan",
        visible: "Terlihat?",
        isRequired: "Wajib?",
        markRequired: "Tandai sesuai kebutuhan",
        removeRequiredMark: "Hapus tanda yang diperlukan",
        isAllRowRequired: "Memerlukan jawaban untuk semua baris",
        eachRowUnique: "Mencegah respons duplikat dalam baris",
        requiredErrorText: "Pesan kesalahan \"Wajib\"",
        startWithNewLine: "Mulai dengan baris baru?",
        rows: "Jumlah baris",
        cols: "Kolom",
        placeholder: "Masukkan placeholder",
        showPreview: "Tunjukkan tinjauan gambar?",
        storeDataAsText: "Simpan konten berkas dalam hasil JSON sebagai teks",
        maxSize: "Ukuran maksimum berkas dalam byte",
        rowCount: "Jumlah baris",
        columnLayout: "Tata letak kolom",
        addRowLocation: "Tambah lokasi tombol baris",
        transposeData: "Mengubah urutan baris menjadi kolom",
        addRowText: "Teks tambah tombol baris",
        removeRowText: "Teks hapus tombol baris",
        rateMin: "Nilai tarif minimum",
        rateMax: "Nilai tarif maksimum",
        rateStep: "Langkah tingkat",
        minRateDescription: "Deskripsi nilai minimum",
        maxRateDescription: "Deskripsi nilai maksimum",
        inputType: "Jenis masukan",
        optionsCaption: "Keterangan pilihan",
        defaultValue: "Nilai standar",
        cellsDefaultRow: "Teks sel standar",
        surveyEditorTitle: "Ubah pengaturan survei",
        qEditorTitle: "Ubah: {0}",
        maxLength: "Panjang maksimum",
        buildExpression: "Membangun",
        editExpression: "Mengedit",
        and: "dan",
        or: "atau",
        remove: "Buka",
        addCondition: "Tambahkan Kondisi",
        emptyLogicPopupMessage: "Pilih pertanyaan untuk mulai mengonfigurasi kondisi.",
        if: "Kalau",
        then: "kemudian",
        setToName: "Pertanyaan target",
        fromName: "Pertanyaan untuk disalin jawabannya",
        gotoName: "Pertanyaan untuk dilewati",
        ruleIsNotSet: "Aturan salah",
        includeIntoResult: "Sertakan ke dalam hasil survei",
        showTitle: "Tampilkan/sembunyikan judul",
        expandCollapseTitle: "Perluas/ciutkan judul",
        locale: "Bahasa standar",
        simulator: "Pilih jenis perangkat",
        landscapeOrientation: "Beralih ke orientasi lanskap",
        portraitOrientation: "Beralih ke orientasi potret",
        mode: "Mode (ubah/baca saja)",
        clearInvisibleValues: "Bersihkan nilai tak terlihat",
        cookieName: "Nama cookie (untuk menonaktifkan menjalankan survei dua kali secara lokal)",
        sendResultOnPageNext: "Kirim hasil survei pada halaman selanjutnya",
        storeOthersAsComment: "Simpan nilai 'lainnya' pada bidang lainnya",
        showPageTitles: "Tampilkan judul halaman",
        showPageNumbers: "Tampilkan nomor halaman",
        pagePrevText: "Teks halaman tombol sebelumnya",
        pageNextText: "Teks halaman tombol selanjutnya",
        completeText: "Teks tombol selesai",
        previewText: "Teks tombol Pratinjau Jawaban",
        editText: "Teks tombol Edit Jawaban",
        startSurveyText: "Teks tombol mulai",
        showNavigationButtons: "Tampilkan tombol navigasi (navigasi standar)",
        showPrevButton: "Tampilkan tombol sebelumnya (pengguna mungkin kembali ke halaman sebelumnya)",
        firstPageIsStarted: "Halaman pertama pada survei adalah halaman yang telah dimulai.",
        showCompletedPage: "Tampilkan keseluruhan halaman di akhir (completedHtml)",
        goNextPageAutomatic: "Setelah menjawa seluruh pertanyaan, pergi ke halaman berikutnya secara otomatis",
        allowCompleteSurveyAutomatic: "Selesaikan survei secara otomatis",
        showProgressBar: "Tampilkan progress bar",
        questionTitleLocation: "Lokasi judul pertanyaan",
        questionTitleWidth: "Lebar judul pertanyaan",
        requiredText: "Simbil pertanyaan wajib",
        questionTitleTemplate: "Template Judul Pertanyaan, default adalah: '{no}. {require} {title}'",
        questionErrorLocation: "Lokasi Pertanyaan Error",
        focusFirstQuestionAutomatic: "Fokus ke pertanyaan pertama saat pergantian halaman",
        questionsOrder: "Urutakan elemen pada halaan",
        maxTimeToFinish: "Waktu maksimum untuk menyelesaikan survei",
        maxTimeToFinishPage: "Waktu maksimum untuk menyelesaikan suatu halaman",
        showTimerPanel: "Tampilkan panel pengatur waktu",
        showTimerPanelMode: "Tampilkan mode panel pengatur waktu",
        renderMode: "Mode render",
        allowAddPanel: "Bolehkan penambahan panel",
        allowRemovePanel: "Bolehkan penghapusan panel",
        panelAddText: "Teks tambah panel",
        panelRemoveText: "Teks hapus panel",
        isSinglePage: "Tampilkan seluruh elemen pada halaman",
        html: "Html",
        setValue: "Menjawab",
        dataFormat: "Format gambar",
        allowAddRows: "Perbolehkan menambahkan baris",
        allowRemoveRows: "Perbolehkan menghapus baris",
        allowRowsDragAndDrop: "Perbolehkan baris seret dan lepas",
        responsiveImageSizeHelp: "Tidak berlaku jika Anda menentukan lebar atau tinggi gambar yang tepat.",
        minImageWidth: "Lebar gambar minimum",
        maxImageWidth: "Lebar gambar maksimum",
        minImageHeight: "Tinggi gambar minimum",
        maxImageHeight: "Tinggi gambar maksimum",
        minValue: "Nilai minimum",
        maxValue: "Nilai maksimum",
        minLength: "Panjang minimum",
        allowDigits: "Bolehkan angka",
        minCount: "Hitungan minimum",
        maxCount: "Hitungan maksimum",
        regex: "Ekspresi reguler",
        surveyvalidator: {
            text: "Pesan kesalahan",
            expression: "Ekspresi validasi"
        },
        totalText: "Total teks",
        totalType: "Total jenis",
        totalExpression: "Total ekspresi",
        totalDisplayStyle: "Total gaya tampilan",
        totalCurrency: "Total mata uang",
        totalFormat: "Total format",
        logo: "Logo (URL atau string yang dikodekan base64)",
        questionsOnPageMode: "Struktur survei",
        maxTextLength: "Panjang jawaban maksimum (dalam karakter)",
        maxOthersLength: "Panjang komentar maksimum (dalam karakter)",
        commentAreaRows: "Tinggi area komentar (dalam baris)",
        autoGrowComment: "Perluas area komentar secara otomatis jika perlu",
        allowResizeComment: "Mengizinkan pengguna mengubah ukuran area teks",
        textUpdateMode: "Memperbarui nilai pertanyaan teks",
        maskType: "Jenis masker input",
        maskTypes: {
            none: "Tidak",
            patternmask: "Pola",
            numericmask: "Numerik",
            datetimemask: "Tanggal dan Waktu",
            currencymask: "Mata uang"
        },
        focusOnFirstError: "Mengatur fokus pada jawaban pertama yang tidak valid",
        checkErrorsMode: "Jalankan validasi",
        navigateToUrl: "Arahkan ke URL",
        navigateToUrlOnCondition: "URL dinamis",
        completedBeforeHtml: "Markup untuk menunjukkan apakah pengguna sudah mengisi survei ini",
        completedHtml: "Markup halaman Survei Selesai",
        completedHtmlOnCondition: "Survei Dinamis Markup halaman lengkap",
        loadingHtml: "Markup untuk ditampilkan saat model survei dimuat",
        commentText: "Teks area komentar",
        autocomplete: "Tipe pelengkapan otomatis",
        labelTrue: "Label \"Benar\"",
        labelFalse: "Label \"Salah\"",
        allowClear: "Tampilkan tombol Hapus",
        searchMode: "Mode Pencarian",
        displayStyle: "Gaya tampilan nilai",
        format: "String yang diformat",
        maximumFractionDigits: "Digit pecahan maksimum",
        minimumFractionDigits: "Digit pecahan minimum",
        useGrouping: "Menampilkan pemisah pengelompokan",
        allowMultiple: "Izinkan beberapa file",
        allowImagesPreview: "Pratinjau gambar",
        acceptedTypes: "Jenis file yang diterima",
        waitForUpload: "Tunggu hingga upload selesai",
        needConfirmRemoveFile: "Konfirmasi penghapusan file",
        detailPanelMode: "Lokasi panel detail",
        minRowCount: "Jumlah baris minimum",
        maxRowCount: "Jumlah baris maksimum",
        confirmDelete: "Mengonfirmasi penghapusan baris",
        confirmDeleteText: "Pesan konfirmasi",
        panelCount: "Jumlah panel awal",
        minPanelCount: "Jumlah panel minimum",
        maxPanelCount: "Jumlah panel maksimum",
        panelsState: "Status perluasan panel dalam",
        panelPrevText: "Tooltip tombol Panel sebelumnya",
        panelNextText: "Tooltip tombol Panel Berikutnya",
        showRangeInProgress: "Perlihatkan bilah kemajuan",
        panelRemoveButtonLocation: "Hapus lokasi tombol Panel",
        hideIfRowsEmpty: "Menyembunyikan pertanyaan jika tidak ada baris",
        hideColumnsIfEmpty: "Menyembunyikan kolom jika tidak ada baris",
        rateValues: "Nilai tarif kustom",
        rateCount: "Jumlah tarif",
        autoGenerate: "Bagaimana cara menentukan nilai tarif?",
        hideIfChoicesEmpty: "Sembunyikan pertanyaan jika tidak berisi pilihan",
        minWidth: "Lebar minimum (dalam nilai yang diterima CSS)",
        maxWidth: "Lebar maksimum (dalam nilai yang diterima CSS)",
        width: "Lebar (dalam nilai yang diterima CSS)",
        showHeader: "Perlihatkan header kolom",
        horizontalScroll: "Tampilkan scrollbar horizontal",
        columnMinWidth: "Lebar kolom minimum (dalam nilai yang diterima CSS)",
        rowTitleWidth: "Lebar header baris (dalam nilai yang diterima CSS)",
        valueTrue: "Nilai \"Benar\"",
        valueFalse: "Nilai \"False\"",
        minErrorText: "Pesan kesalahan \"Nilai di bawah minimum\"",
        maxErrorText: "Pesan kesalahan \"Nilai melebihi maksimum\"",
        otherErrorText: "Pesan kesalahan \"Komentar kosong\"",
        keyDuplicationError: "Pesan galat \"Nilai kunci tidak unik\"",
        minSelectedChoices: "Pilihan minimum yang dipilih",
        maxSelectedChoices: "Pilihan maksimum yang dipilih",
        showClearButton: "Tampilkan tombol Hapus",
        logoWidth: "Lebar logo (dalam nilai yang diterima CSS)",
        logoHeight: "Tinggi logo (dalam nilai yang diterima CSS)",
        readOnly: "Baca-saja",
        enableIf: "Dapat diedit jika",
        emptyRowsText: "Pesan \"Tidak ada baris\"",
        separateSpecialChoices: "Pisahkan pilihan khusus (Tidak Ada, Lainnya, Pilih Semua)",
        choicesFromQuestion: "Salin pilihan dari pertanyaan berikut",
        choicesFromQuestionMode: "Pilihan mana yang harus disalin?",
        progressBarShowPageTitles: "Menampilkan judul halaman di bilah kemajuan",
        progressBarShowPageNumbers: "Menampilkan nomor halaman di bilah kemajuan",
        showCommentArea: "Tampilkan area komentar",
        commentPlaceholder: "Tempat penampung area komentar",
        displayRateDescriptionsAsExtremeItems: "Menampilkan deskripsi tingkat sebagai nilai ekstrem",
        rowsOrder: "Urutan baris",
        columnsLayout: "Tata letak kolom",
        columnColCount: "Jumlah kolom bertumpuk",
        correctAnswer: "Jawaban yang Benar",
        defaultPanelValue: "Nilai Default",
        cells: "Teks Sel",
        fileInputPlaceholder: "Pilih file atau tempel tautan file...",
        keyName: "Kolom kunci",
        itemvalue: {
            visibleIf: "Buat opsi terlihat jika",
            enableIf: "Buat opsi dapat dipilih jika"
        },
        "itemvalue@rows": {
            visibleIf: "Membuat baris terlihat jika",
            enableIf: "Membuat baris dapat diedit jika"
        },
        imageitemvalue: {
            text: "Teks alternatif"
        },
        logoPosition: "Posisi logo",
        addLogo: "Tambahkan logo...",
        changeLogo: "Ubah logo...",
        logoPositions: {
            none: "Hapus logo",
            left: "Kiri",
            right: "Kanan",
            top: "Di atas",
            bottom: "Di bagian bawah"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Tata Letak Panel"
            },
            general: "Umum",
            fileOptions: "Pilihan berkas",
            html: "Editor Html",
            columns: "Kolom",
            rows: "Baris",
            choices: "Pilihan",
            items: "Barang",
            visibleIf: "Terlihat Jika",
            enableIf: "Memungkinkan Jika",
            requiredIf: "Wajib Jika",
            rateValues: "Nilai Tingkat",
            choicesByUrl: "Pilih dari Web",
            matrixChoices: "Pilihan Standar",
            multipleTextItems: "Masukan Teks",
            numbering: "Penomoran",
            validators: "Validator",
            navigation: "Navigasi",
            question: "Pertanyaan",
            pages: "Halaman",
            timer: "Pengatur Waktu/Kuis",
            calculatedValues: "Nilai terhitung",
            triggers: "Trigger",
            templateTitle: "Judul templat",
            totals: "Total",
            logic: "Logika",
            mask: "Pengaturan Masker Input",
            layout: {
                panel: "Tata letak",
                question: "Tata letak",
                base: "Tata letak"
            },
            data: "Data",
            validation: "Validasi",
            cells: "Teks Sel",
            showOnCompleted: "Survei Selesai",
            logo: "Logo dalam Judul Survei",
            slider: "Slider",
            expression: "Ekspresi",
            questionSettings: "Pengaturan Pertanyaan",
            header: "Header",
            background: "Latar",
            appearance: "Rupa",
            others: "Lain"
        },
        editProperty: "Ubah properti '{0}'",
        items: "[ Barang: {0} ]",
        choicesVisibleIf: "Pilihan terlihat jika",
        choicesEnableIf: "Pilihan dapat dipilih jika",
        columnsEnableIf: "Kolom terlihat jika",
        rowsEnableIf: "Baris terlihat jika",
        innerIndent: "Menambahkan inden dalam",
        defaultValueFromLastRow: "Mengambil nilai default dari baris terakhir",
        defaultValueFromLastPanel: "Mengambil nilai default dari panel terakhir",
        enterNewValue: "Silahkan masukkan nilai",
        noquestions: "Tidak ada pertanyaan dalam survei.",
        createtrigger: "Silahkan buat sebuah trigger",
        titleKeyboardAdornerTip: "Tekan tombol enter untuk mengedit",
        keyboardAdornerTip: "Tekan tombol enter untuk mengedit item, tekan tombol hapus untuk menghapus item, tekan alt plus panah ke atas atau panah ke bawah untuk memindahkan item",
        triggerOn: "On ",
        triggerMakePagesVisible: "Buat halaman terlihat:",
        triggerMakeQuestionsVisible: "Buat elemen terlihat:",
        triggerCompleteText: "Selesaikan survei jika sukses.",
        triggerNotSet: "Trigger belum diatur",
        triggerRunIf: "Berjalan jika",
        triggerSetToName: "Ubah nilai dari: ",
        triggerFromName: "Salin nilai dari: ",
        triggerRunExpression: "Jalankan ekspresi ini:",
        triggerSetValue: "ke: ",
        triggerGotoName: "Pergi ke pertanyaan",
        triggerIsVariable: "Jangan meletakkan variabel ke hasil survey.",
        triggerRunExpressionEmpty: "Silakan masukkan ekspresi yang valid",
        emptyExpressionPlaceHolder: "Ketik ekspresi di sini...",
        noFile: "Tidak ada file yang dipilih",
        clearIfInvisible: "Hapus nilai jika pertanyaan menjadi tersembunyi",
        valuePropertyName: "Nama properti nilai",
        searchEnabled: "Aktifkan pencarian",
        hideSelectedItems: "Menyembunyikan item yang dipilih",
        closeOnSelect: "Tutup menu turun bawah setelah pemilihan",
        verticalAlign: "Perataan vertikal",
        alternateRows: "Baris alternatif",
        columnsVisibleIf: "Kolom terlihat jika",
        rowsVisibleIf: "Baris terlihat jika",
        otherPlaceholder: "Tempat penampung area komentar",
        filePlaceholder: "Teks tempat penampung file",
        photoPlaceholder: "Teks placeholder foto",
        fileOrPhotoPlaceholder: "Teks placeholder file atau foto",
        rateType: "Jenis tarif",
        url_placeholder: "Mis.: https://api.example.com/books",
        path_placeholder: "Mis.: categories.fiction",
        questionStartIndex_placeholder: "Mis.: a)",
        width_placeholder: "Contoh: 6in",
        minWidth_placeholder: "Contoh: 600px",
        maxWidth_placeholder: "Contoh: 50%",
        imageHeight_placeholder: "Auto",
        imageWidth_placeholder: "Auto",
        theme: {
            themeName: "Tema",
            isPanelless: "Penampilan pertanyaan",
            editorPanel: "Latar belakang dan radius sudut",
            questionPanel: "Latar belakang dan radius sudut",
            primaryColor: "Warna aksen",
            panelBackgroundTransparency: "Opasitas latar belakang panel",
            questionBackgroundTransparency: "Opasitas latar belakang pertanyaan",
            fontSize: "Ukuran font",
            scale: "Sisik",
            cornerRadius: "Radius sudut",
            pageTitle: "Font judul",
            pageDescription: "Font deskripsi",
            questionTitle: "Font judul",
            questionDescription: "Font deskripsi",
            editorFont: "Font",
            backgroundOpacity: "Opacity",
            "--sjs-font-family": "Keluarga font",
            "--sjs-general-backcolor-dim": "Warna latar belakang",
            "--sjs-primary-backcolor": "Latar belakang aksen",
            "--sjs-primary-forecolor": "Latar depan aksen",
            "--sjs-special-red": "Pesan kesalahan",
            "--sjs-shadow-small": "Efek bayangan",
            "--sjs-shadow-inner": "Efek bayangan",
            "--sjs-border-default": "Warna"
        },
        "header@header": {
            headerView: "Melihat",
            logoPosition: "Posisi logo",
            surveyTitle: "Font judul survei",
            surveyDescription: "Font deskripsi survei",
            headerTitle: "Font judul survei",
            headerDescription: "Font deskripsi survei",
            inheritWidthFrom: "Lebar area konten",
            textAreaWidth: "Lebar teks",
            backgroundColorSwitch: "Warna latar belakang",
            backgroundImage: "Gambar latar belakang",
            backgroundImageOpacity: "Opacity",
            overlapEnabled: "Tumpang tindih",
            logoPositionX: "Posisi logo",
            titlePositionX: "Posisi judul",
            descriptionPositionX: "Deskripsi posisi"
        }
    },
    // Property values
    pv: {
        "true": "benar",
        "false": "palsu",
        file: "File lokal",
        camera: "Kamera",
        "file-camera": "File atau kamera lokal",
        inherit: "inherit",
        show: "tampilkan",
        hide: "sembunyikan",
        default: "standar",
        initial: "inisial",
        random: "acak",
        collapsed: "dilipat",
        expanded: "direntangkan",
        none: "tidak ada",
        asc: "naik",
        desc: "turun",
        indeterminate: "tidak tentu",
        selected: "Dipilih",
        unselected: "Tidak dipilih",
        decimal: "desimal",
        currency: "mata uang",
        percent: "persen",
        firstExpanded: "perluasanPertama",
        off: "mati",
        list: "daftar",
        progressTop: "progress atas",
        progressBottom: "progress bawah",
        progressTopBottom: "progress atas bawah",
        tab: "Tab",
        horizontal: "horizontal",
        vertical: "vertikal",
        top: "atas",
        bottom: "bawah",
        topBottom: "atas dan bawah",
        both: "Keduanya",
        left: "kiri",
        right: "Kanan",
        center: "Pusat",
        leftRight: "Kiri dan kanan",
        middle: "Tengah",
        color: "warna",
        date: "tanggal",
        datetime: "Waktu tanggal",
        "datetime-local": "datetime-lokal",
        email: "Email",
        month: "bulan",
        number: "angka",
        password: "kata sandi",
        range: "lingkup",
        tel: "Tel",
        text: "Teks",
        time: "Waktu",
        url: "URL",
        week: "minggu",
        hidden: "tersembunyi",
        edit: "ubah",
        display: "tampilan",
        contain: "Mengandung",
        cover: "Menutupi",
        fill: "Isi",
        next: "Depan",
        last: "Terakhir",
        onComplete: "saat selesai",
        onHidden: "saat tersembunyi",
        onHiddenContainer: "Ketika pertanyaan atau panel/halamannya disembunyikan",
        clearInvisibleValues: {
            none: "Tidak pernah"
        },
        clearIfInvisible: {
            none: "Tidak pernah"
        },
        inputType: {
            color: "Warna",
            date: "Tanggal",
            "datetime-local": "Tanggal dan Waktu",
            email: "Email",
            month: "Bulan",
            number: "Angka",
            password: "Kata sandi",
            range: "Lingkup",
            tel: "Nomor Telepon",
            text: "Teks",
            time: "Waktu",
            url: "URL",
            week: "Minggu"
        },
        all: "semua",
        page: "halaman",
        survey: "survei",
        onNextPage: "pada halaman selanjutnya",
        onValueChanged: "saat nilai berubah",
        onValueChanging: "Sebelum jawaban diubah",
        questionsOnPageMode: {
            standard: "Struktur asli",
            singlePage: "Tampilkan semua pertanyaan di satu halaman",
            questionPerPage: "Tampilkan pertanyaan tunggal per halaman"
        },
        noPreview: "Tidak ada pratinjau",
        showAllQuestions: "Tampilkan semua pertanyaan",
        showAnsweredQuestions: "Tampilkan pertanyaan yang sudah terjawab saja",
        pages: "Halaman lengkap",
        questions: "Pertanyaan yang dijawab",
        requiredQuestions: "Menjawab pertanyaan yang diperlukan",
        correctQuestions: "Jawaban yang valid",
        buttons: "Halaman selesai (tombol UI)",
        underInput: "Di bawah input",
        underTitle: "Di bawah judul",
        onBlur: "Saat buram",
        onTyping: "Saat mengetik",
        underRow: "Di bawah baris",
        underRowSingle: "Di bawah baris, hanya satu panel yang terlihat",
        auto: "Auto",
        showNavigationButtons: {
            none: "Sembunyi"
        },
        showTimerPanel: {
            none: "Sembunyi"
        },
        showTimerPanelMode: {
            all: "Keduanya"
        },
        addRowLocation: {
            default: "Tergantung pada tata letak matriks"
        },
        panelsState: {
            default: "Pengguna tidak dapat memperluas atau menciutkan panel",
            collapsed: "Semua panel diciutkan",
            expanded: "Semua panel diperluas",
            firstExpanded: "Pertama diperluas"
        },
        widthMode: {
            static: "Statis",
            responsive: "Responsif"
        },
        contentMode: {
            image: "Citra",
            video: "Video",
            youtube: "YouTube"
        },
        displayMode: {
            buttons: "Tombol",
            dropdown: "Tarik-turun"
        },
        rateColorMode: {
            default: "Default",
            scale: "Sisik"
        },
        scaleColorMode: {
            monochrome: "Monokrom",
            colored: "Berwarna"
        },
        autoGenerate: {
            "true": "Menghasilkan",
            "false": "Masukkan secara manual"
        },
        rateType: {
            labels: "Label",
            stars: "Bintang",
            smileys: "Smiley"
        },
        state: {
            default: "Terkunci"
        },
        showQuestionNumbers: {
            default: "Penomoran otomatis",
            on: "Penomoran otomatis",
            onPage: "Setel ulang di setiap halaman",
            onpanel: "Setel ulang pada setiap panel",
            onPanel: "Setel ulang pada setiap panel",
            onSurvey: "Lanjutkan di seluruh survei",
            off: "Tanpa penomoran"
        },
        descriptionLocation: {
            underTitle: "Di bawah judul pertanyaan",
            underInput: "Di bawah bidang input"
        },
        selectToRankAreasLayout: {
            horizontal: "Di samping pilihan",
            vertical: "Pilihan di atas"
        },
        displayStyle: {
            decimal: "Desimal",
            currency: "Mata uang",
            percent: "Persentase",
            date: "Tanggal"
        },
        totalDisplayStyle: {
            decimal: "Desimal",
            currency: "Mata uang",
            percent: "Persentase",
            date: "Tanggal"
        },
        rowsOrder: {
            initial: "Asli"
        },
        questionsOrder: {
            initial: "Asli"
        },
        showProgressBar: {
            off: "Sembunyi",
            topbottom: "atas dan bawah",
            aboveheader: "Di atas header",
            belowheader: "Di bawah header"
        },
        sum: "Jumlah",
        count: "Hitung",
        min: "Min",
        max: "Maks",
        avg: "Avg",
        searchMode: {
            contains: "Berisi",
            startsWith: "Dimulai dengan"
        },
        backgroundImageFit: {
            auto: "Auto",
            cover: "Menutupi",
            contain: "Mengandung",
            fill: "Merentangkan",
            tile: "Ubin"
        },
        backgroundImageAttachment: {
            fixed: "Tetap",
            scroll: "Gulir"
        },
        headerView: {
            basic: "Dasar",
            advanced: "Maju"
        },
        inheritWidthFrom: {
            survey: "Sama seperti survei",
            container: "Sesuai dengan kontainer"
        },
        backgroundColorSwitch: {
            none: "Tidak",
            accentColor: "Warna aksen",
            custom: "Adat"
        },
        colorPalette: {
            light: "Ringan",
            dark: "Gelap"
        },
        isPanelless: {
            "false": "Default",
            "true": "Tanpa Panel"
        }
    },
    // Operators
    op: {
        empty: "kosong",
        notempty: "tidak kosong",
        equal: "sama dengan",
        notequal: "tidak sama dengan",
        contains: "mengandung",
        notcontains: "tidak mengandung",
        anyof: "Salah satu dari",
        allof: "Semua",
        greater: "lebih besar",
        less: "lebih kecil",
        greaterorequal: "lebih besar atau sama dengan",
        lessorequal: "lebih kecil atau sama dengan",
        and: "dan",
        or: "atau"
    },
    // Embed window
    ew: {
        angular: "Gunakan versi Angular",
        jquery: "Gunakan versi JQuery",
        knockout: "Gunakan versi Knockout",
        react: "Gunakan versi React",
        vue: "Gunakan versi Vue",
        bootstrap: "Untuk framework bootstrap",
        modern: "Tema modern",
        default: "Tema default",
        orange: "Tema oranye",
        darkblue: "Tema biru tua",
        darkrose: "Tema Darkrose",
        stone: "Tema batu",
        winter: "Tema musim dingin",
        winterstone: "Tema Winter-Stone",
        showOnPage: "Tampilkan survei pada sebuah halaman",
        showInWindow: "Tampilkan survei pada sebuah jendela",
        loadFromServer: "Muat survei JSON dari server",
        titleScript: "Skrip dan gaya",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Pilih halaman untuk dicoba:",
        showInvisibleElements: "Tampilkan elemen tak terlihat",
        hideInvisibleElements: "Sembunyikan elemen tak terlihat"
    },
    validators: {
        answercountvalidator: "jumlah jawaban",
        emailvalidator: "surel",
        expressionvalidator: "ekspresi",
        numericvalidator: "numerik",
        regexvalidator: "ekspresi reguler",
        textvalidator: "teks"
    },
    triggers: {
        completetrigger: "selesaikan survei",
        setvaluetrigger: "atur nilai",
        copyvaluetrigger: "salin nilai",
        skiptrigger: "Lanjut ke pertanyaan",
        runexpressiontrigger: "jalankan ekspresi",
        visibletrigger: "ubah visibilitas"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Contoh: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Contoh: mm/dd/yyyy"
        },
        currencymask: {
            prefix: "Contoh.: $",
            suffix: "Contoh: USD"
        },
        panelbase: {
            questionTitleWidth: "Contoh: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "ID panel yang tidak terlihat oleh responden.",
            description: "Ketik subtitle panel.",
            visibleIf: "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang menentukan visibilitas panel.",
            enableIf: "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menonaktifkan mode baca-saja untuk panel.",
            requiredIf: "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang mencegah pengiriman survei kecuali setidaknya satu pertanyaan bertingkat memiliki jawaban.",
            questionTitleLocation: "Berlaku untuk semua pertanyaan dalam panel ini. Jika Anda ingin mengganti setelan ini, tentukan aturan perataan judul untuk masing-masing pertanyaan. Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei (\"Teratas\" secara default).",
            questionTitleWidth: "Mengatur lebar yang konsisten untuk judul pertanyaan bila disejajarkan di sebelah kiri kotak pertanyaan. Menerima nilai CSS (px, %, in, pt, dll.).",
            questionErrorLocation: "Mengatur lokasi pesan kesalahan sehubungan dengan semua pertanyaan dalam panel. Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei.",
            questionsOrder: "Menyimpan urutan pertanyaan asli atau mengacaknya. Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei.",
            page: "Memposisikan ulang panel ke akhir halaman yang dipilih.",
            innerIndent: "Menambahkan spasi atau margin antara konten panel dan batas kiri kotak panel.",
            startWithNewLine: "Batalkan pilihan untuk menampilkan panel dalam satu baris dengan pertanyaan atau panel sebelumnya. Pengaturan tidak berlaku jika panel adalah elemen pertama dalam formulir Anda.",
            state: "Pilih dari: \"Diperluas\" - panel ditampilkan secara penuh dan dapat diciutkan; \"Collapsed\" - panel hanya menampilkan judul dan deskripsi dan dapat diperluas; \"Terkunci\" - panel ditampilkan secara penuh dan tidak dapat diciutkan.",
            width: "Mengatur lebar panel secara proporsional dengan elemen survei lainnya di baris yang sama. Menerima nilai CSS (px, %, in, pt, dll.)."
        },
        paneldynamic: {
            name: "ID panel yang tidak terlihat oleh responden.",
            description: "Ketik subtitle panel.",
            visibleIf: "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang menentukan visibilitas panel.",
            enableIf: "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menonaktifkan mode baca-saja untuk panel.",
            requiredIf: "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang mencegah pengiriman survei kecuali setidaknya satu pertanyaan bertingkat memiliki jawaban.",
            templateTitleLocation: "Berlaku untuk semua pertanyaan dalam panel ini. Jika Anda ingin mengganti setelan ini, tentukan aturan perataan judul untuk masing-masing pertanyaan. Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei (\"Teratas\" secara default).",
            templateErrorLocation: "Mengatur lokasi pesan kesalahan sehubungan dengan pertanyaan dengan input yang tidak valid. Pilih antara: \"Atas\" - teks kesalahan ditempatkan di bagian atas kotak pertanyaan; \"Bawah\" - teks kesalahan ditempatkan di bagian bawah kotak pertanyaan. Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei (\"Teratas\" secara default).",
            errorLocation: "Mengatur lokasi pesan kesalahan sehubungan dengan semua pertanyaan dalam panel. Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei.",
            page: "Memposisikan ulang panel ke akhir halaman yang dipilih.",
            innerIndent: "Menambahkan spasi atau margin antara konten panel dan batas kiri kotak panel.",
            startWithNewLine: "Batalkan pilihan untuk menampilkan panel dalam satu baris dengan pertanyaan atau panel sebelumnya. Pengaturan tidak berlaku jika panel adalah elemen pertama dalam formulir Anda.",
            state: "Pilih dari: \"Diperluas\" - panel ditampilkan secara penuh dan dapat diciutkan; \"Collapsed\" - panel hanya menampilkan judul dan deskripsi dan dapat diperluas; \"Terkunci\" - panel ditampilkan secara penuh dan tidak dapat diciutkan.",
            width: "Mengatur lebar panel secara proporsional dengan elemen survei lainnya di baris yang sama. Menerima nilai CSS (px, %, in, pt, dll.).",
            templateTitle: "Ketik template untuk judul panel dinamis. Gunakan {panelIndex} untuk posisi umum panel dan {visiblePanelIndex} untuk urutannya di antara panel yang terlihat. Masukkan tempat penampung ini ke dalam pola untuk menambahkan penomoran otomatis.",
            templateTabTitle: "Ketik templat untuk judul tab. Gunakan {panelIndex} untuk posisi umum panel dan {visiblePanelIndex} untuk urutannya di antara panel yang terlihat. Masukkan tempat penampung ini ke dalam pola untuk menambahkan penomoran otomatis.",
            tabTitlePlaceholder: "Teks fallback untuk judul tab yang berlaku saat pola judul tab tidak menghasilkan nilai yang berarti.",
            templateVisibleIf: "Pengaturan ini memungkinkan Anda mengontrol visibilitas masing-masing panel dalam panel dinamis. Gunakan placeholder '{panel}' untuk mereferensikan panel saat ini dalam ekspresi Anda.",
            titleLocation: "Setelan ini secara otomatis diwarisi oleh semua pertanyaan dalam panel ini. Jika Anda ingin mengganti setelan ini, tentukan aturan perataan judul untuk masing-masing pertanyaan. Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei (\"Teratas\" secara default).",
            descriptionLocation: "Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei (\"Di bawah judul panel\" secara default).",
            newPanelPosition: "Menentukan posisi panel yang baru ditambahkan. Secara default, panel baru ditambahkan ke akhir. Pilih \"Next\" untuk memasukkan panel baru setelah yang sekarang.",
            defaultValueFromLastPanel: "Menduplikasi jawaban dari panel terakhir dan menetapkannya ke panel dinamis tambahan berikutnya.",
            keyName: "Rujuk nama pertanyaan untuk mengharuskan pengguna memberikan respons unik untuk pertanyaan ini di setiap panel."
        },
        defaultValueExpression: "Pengaturan ini memungkinkan Anda menetapkan nilai jawaban default berdasarkan ekspresi. Ekspresi dapat mencakup perhitungan dasar - '{q1_id} + {q2_id}', ekspresi Boolean, seperti '{age} > 60', dan fungsi: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', dll. Nilai yang ditentukan oleh ekspresi ini berfungsi sebagai nilai default awal yang dapat ditimpa oleh input manual responden.",
        resetValueIf: "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menentukan kapan input responden diatur ulang ke nilai berdasarkan \"Ekspresi nilai default\" atau \"Atur ekspresi nilai\" atau ke nilai \"Jawaban default\" (jika salah satu diatur).",
        setValueIf: "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menentukan kapan harus menjalankan \"Atur ekspresi nilai\" dan secara dinamis menetapkan nilai yang dihasilkan sebagai respons.",
        setValueExpression: "Tentukan ekspresi yang menentukan nilai yang akan ditetapkan saat kondisi dalam aturan \"Tetapkan nilai jika\" terpenuhi. Ekspresi dapat mencakup perhitungan dasar - '{q1_id} + {q2_id}', ekspresi Boolean, seperti '{age} > 60', dan fungsi: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', dll. Nilai yang ditentukan oleh ekspresi ini dapat ditimpa oleh input manual responden.",
        question: {
            name: "ID pertanyaan yang tidak terlihat oleh responden.",
            description: "Ketik subtitle pertanyaan.",
            visibleIf: "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang menentukan visibilitas pertanyaan.",
            enableIf: "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang menonaktifkan mode baca-saja untuk pertanyaan.",
            requiredIf: "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang mencegah survei maju atau dikirim kecuali pertanyaan menerima jawaban.",
            startWithNewLine: "Batalkan pilihan untuk menampilkan pertanyaan dalam satu baris dengan pertanyaan atau panel sebelumnya. Pengaturan tidak berlaku jika pertanyaan adalah elemen pertama dalam formulir Anda.",
            page: "Memposisikan ulang pertanyaan ke akhir halaman yang dipilih.",
            state: "Pilih dari: \"Diperluas\" - kotak pertanyaan ditampilkan secara penuh dan dapat diciutkan; \"Diciutkan\" - kotak pertanyaan hanya menampilkan judul dan deskripsi dan dapat diperluas; \"Terkunci\" - kotak pertanyaan ditampilkan secara penuh dan tidak dapat diciutkan.",
            titleLocation: "Mengganti aturan penyelarasan judul yang ditentukan pada tingkat panel, halaman, atau survei. Opsi \"Warisi\" menerapkan pengaturan tingkat yang lebih tinggi (jika diatur) atau pengaturan tingkat survei (\"Atas\" secara default).",
            descriptionLocation: "Opsi \"Warisi\" menerapkan setelan tingkat survei (\"Di bawah judul pertanyaan\" secara default).",
            errorLocation: "Mengatur lokasi pesan kesalahan sehubungan dengan pertanyaan dengan input yang tidak valid. Pilih antara: \"Atas\" - teks kesalahan ditempatkan di bagian atas kotak pertanyaan; \"Bawah\" - teks kesalahan ditempatkan di bagian bawah kotak pertanyaan. Opsi \"Warisi\" menerapkan setelan tingkat survei (\"Teratas\" secara default).",
            indent: "Menambahkan spasi atau margin antara konten pertanyaan dan batas kiri kotak pertanyaan.",
            width: "Mengatur lebar pertanyaan secara proporsional dengan elemen survei lain di baris yang sama. Menerima nilai CSS (px, %, in, pt, dll.).",
            surveyvalidator: {
                expression: "Gunakan ikon tongkat ajaib untuk menetapkan aturan validasi untuk pertanyaan."
            },
            textUpdateMode: "Pilih dari: \"On lost focus\" - nilai diperbarui ketika bidang input kehilangan fokus; \"Saat mengetik\" - nilainya diperbarui secara real-time, saat pengguna mengetik. Opsi \"Warisi\" menerapkan pengaturan tingkat survei (\"Pada fokus yang hilang\" secara default).",
            url: "Anda dapat menggunakan layanan web apa pun sebagai sumber data untuk pertanyaan pilihan ganda. Untuk mengisi nilai pilihan, masukkan URL layanan yang menyediakan data.",
            searchMode: "Operasi perbandingan yang digunakan untuk memfilter daftar turun bawah.",
            textWrapEnabled: "Teks panjang dalam opsi pilihan akan secara otomatis menghasilkan jeda baris agar sesuai dengan menu tarik-turun. Batalkan pilihan jika Anda ingin teks dipotong."
        },
        signaturepad: {
            signatureWidth: "Mengatur lebar area tanda tangan yang ditampilkan dan gambar yang dihasilkan.",
            signatureHeight: "Mengatur ketinggian area tanda tangan yang ditampilkan dan gambar yang dihasilkan.",
            signatureAutoScaleEnabled: "Pilih apakah Anda ingin area tanda tangan mengisi semua ruang yang tersedia di dalam kotak pertanyaan sambil mempertahankan rasio aspek default 3:2. Saat nilai lebar dan tinggi kustom ditetapkan, pengaturan akan mempertahankan rasio aspek dimensi ini."
        },
        file: {
            imageHeight: "Menyesuaikan tinggi gambar dalam hasil survei.",
            imageWidth: "Menyesuaikan lebar gambar dalam hasil survei."
        },
        image: {
            contentMode: "Opsi \"Otomatis\" secara otomatis menentukan mode yang sesuai untuk tampilan - Gambar, Video, atau YouTube - berdasarkan URL sumber yang disediakan."
        },
        imagepicker: {
            imageHeight: "Mengganti nilai tinggi minimum dan maksimum.",
            imageWidth: "Mengganti nilai lebar minimum dan maksimum.",
            choices: "\"Nilai\" berfungsi sebagai ID item yang digunakan dalam aturan bersyarat; \"Teks\" ditampilkan kepada responden.",
            contentMode: "Pilih antara \"Gambar\" dan \"Video\" untuk mengatur mode konten pemilih media. Jika \"Gambar\" dipilih, pastikan bahwa semua opsi yang disediakan adalah file gambar dalam format berikut: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Demikian pula, jika \"Video\" dipilih, pastikan bahwa semua opsi adalah tautan langsung ke file video dalam format berikut: MP4, MOV, WMV, FLV, AVI, MKV. Perhatikan bahwa tautan YouTube tidak didukung untuk opsi video."
        },
        text: {
            size: "Pengaturan ini hanya mengubah ukuran bidang input dan tidak memengaruhi lebar kotak pertanyaan. Untuk membatasi panjang input yang diterima, buka <b>Validasi → Batas karakter maksimum</b>."
        },
        comment: {
            rows: "Mengatur jumlah baris yang ditampilkan di bidang input. Jika input mengambil lebih banyak baris, bilah gulir akan muncul."
        },
        // survey templates
        survey: {
            mode: "Pilih antara: \"Dapat Diedit\" - memungkinkan responden mengisi survei Anda; \"Read-only\" - menonaktifkan pengeditan formulir."
        },
        matrixdropdowncolumn: {
            name: "ID kolom yang tidak terlihat oleh responden.",
            isUnique: "Saat diaktifkan untuk kolom, responden diharuskan memberikan respons unik untuk setiap pertanyaan dalam kolom ini.",
            rows: "Mengatur jumlah baris yang ditampilkan di bidang input. Jika input mengambil lebih banyak baris, bilah gulir akan muncul.",
            visibleIf: "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menentukan visibilitas kolom.",
            enableIf: "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menonaktifkan mode baca-saja untuk kolom.",
            requiredIf: "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang mencegah pengiriman survei kecuali setidaknya satu pertanyaan bertingkat memiliki jawaban.",
            showInMultipleColumns: "Saat dipilih, buat kolom individual untuk setiap opsi pilihan."
        },
        widthMode: "Pilih dari: \"Statis\" - menetapkan lebar tetap; \"Responsif\" - membuat survei menempati lebar penuh layar; \"Otomatis\" - berlaku salah satu dari keduanya tergantung pada jenis pertanyaan yang digunakan.",
        cookieName: "Cookie mencegah pengguna mengisi survei yang sama dua kali.",
        logo: "Tempel tautan gambar (tanpa batas ukuran) atau klik ikon folder untuk menelusuri file dari komputer Anda (hingga 64 KB).",
        logoWidth: "Mengatur lebar logo dalam satuan CSS (px, %, in, pt, dll.).",
        logoHeight: "Mengatur tinggi logo dalam satuan CSS (px, %, in, pt, dll.).",
        logoFit: "Pilih dari: \"Tidak ada\" - gambar mempertahankan ukuran aslinya; \"Berisi\" - gambar diubah ukurannya agar pas dengan tetap mempertahankan rasio aspeknya; \"Cover\" - gambar mengisi seluruh kotak sambil mempertahankan rasio aspeknya; \"Isi\" - gambar direntangkan untuk mengisi kotak tanpa mempertahankan rasio aspeknya.",
        goNextPageAutomatic: "Pilih apakah Anda ingin survei maju ke halaman berikutnya secara otomatis setelah responden menjawab semua pertanyaan di halaman saat ini.",
        allowCompleteSurveyAutomatic: "Pilih apakah Anda ingin survei selesai secara otomatis setelah responden menjawab semua pertanyaan.",
        showNavigationButtons: "Mengatur visibilitas dan lokasi tombol navigasi pada halaman.",
        showProgressBar: "Mengatur visibilitas dan lokasi bilah kemajuan. Nilai \"Otomatis\" menampilkan bilah kemajuan di atas atau di bawah header survei.",
        showPreviewBeforeComplete: "Aktifkan halaman pratinjau hanya dengan semua atau pertanyaan yang dijawab.",
        questionTitleLocation: "Berlaku untuk semua pertanyaan dalam survei. Setelan ini dapat diganti dengan aturan penyelarasan judul di tingkat yang lebih rendah: panel, halaman, atau pertanyaan. Pengaturan tingkat yang lebih rendah akan menggantikan pengaturan tingkat yang lebih tinggi.",
        requiredText: "Simbol atau urutan simbol yang menunjukkan bahwa jawaban diperlukan.",
        questionStartIndex: "Masukkan angka atau huruf yang ingin Anda gunakan untuk memulai penomoran.",
        questionErrorLocation: "Mengatur lokasi pesan kesalahan sehubungan dengan pertanyaan dengan input yang tidak valid. Pilih antara: \"Atas\" - teks kesalahan ditempatkan di bagian atas kotak pertanyaan; \"Bawah\" - teks kesalahan ditempatkan di bagian bawah kotak pertanyaan.",
        focusFirstQuestionAutomatic: "Pilih apakah Anda ingin bidang input pertama pada setiap halaman siap untuk entri teks.",
        questionsOrder: "Menyimpan urutan pertanyaan asli atau mengacaknya. Efek pengaturan ini hanya terlihat di tab Pratinjau.",
        maxTextLength: "Hanya untuk pertanyaan entri teks.",
        maxOthersLength: "Hanya untuk komentar pertanyaan.",
        commentAreaRows: "Mengatur jumlah baris yang ditampilkan di area teks untuk komentar pertanyaan. Dalam input mengambil lebih banyak baris, bilah gulir muncul.",
        autoGrowComment: "Pilih apakah Anda ingin komentar pertanyaan dan pertanyaan Teks Panjang bertambah tinggi secara otomatis berdasarkan panjang teks yang dimasukkan.",
        allowResizeComment: "Hanya untuk komentar pertanyaan dan pertanyaan Teks Panjang.",
        calculatedValues: "Variabel kustom berfungsi sebagai variabel perantara atau tambahan yang digunakan dalam perhitungan formulir. Mereka mengambil input responden sebagai nilai sumber. Setiap variabel kustom memiliki nama unik dan ekspresi yang menjadi dasarnya.",
        includeIntoResult: "Pilih apakah Anda ingin nilai terhitung ekspresi disimpan bersama dengan hasil survei.",
        triggers: "Pemicu adalah peristiwa atau kondisi yang didasarkan pada ekspresi. Setelah ekspresi dievaluasi ke \"true\", pemicu memicu tindakan. Tindakan semacam itu secara opsional dapat memiliki pertanyaan target yang dipengaruhinya.",
        clearInvisibleValues: "Pilih apakah akan menghapus nilai untuk pertanyaan yang disembunyikan oleh logika kondisional atau tidak dan kapan melakukannya.",
        textUpdateMode: "Pilih dari: \"On lost focus\" - nilai diperbarui ketika bidang input kehilangan fokus; \"Saat mengetik\" - nilainya diperbarui secara real-time, saat pengguna mengetik.",
        columns: "Nilai kiri berfungsi sebagai ID kolom yang digunakan dalam aturan bersyarat, nilai kanan ditampilkan kepada responden.",
        rows: "Nilai kiri berfungsi sebagai ID baris yang digunakan dalam aturan bersyarat, nilai kanan ditampilkan kepada responden.",
        columnMinWidth: "Menerima nilai CSS (px, %, in, pt, dll.).",
        rowTitleWidth: "Menerima nilai CSS (px, %, in, pt, dll.).",
        totalText: "Hanya terlihat bila setidaknya satu kolom memiliki Tipe total atau Ekspresi total.",
        cellErrorLocation: "Mengatur lokasi pesan kesalahan dalam kaitannya dengan sel dengan input yang tidak valid. Opsi \"Warisi\" menerapkan pengaturan dari properti \"Perataan pesan kesalahan\".",
        keyDuplicationError: "Ketika properti \"mencegah duplikat respons\" diaktifkan, responden mencoba untuk mengirimkan entri duplikat akan menerima pesan galat berikut.",
        totalExpression: "Memungkinkan Anda menghitung nilai total berdasarkan ekspresi. Ekspresi dapat mencakup perhitungan dasar ('{q1_id} + {q2_id}'), ekspresi Boolean ('{age} > 60') dan fungsi ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', dll.).",
        confirmDelete: "Memicu prompt yang meminta konfirmasi penghapusan baris.",
        defaultValueFromLastRow: "Menduplikasi jawaban dari baris terakhir dan menetapkannya ke baris dinamis berikutnya yang ditambahkan.",
        keyName: "Jika kolom yang ditentukan berisi nilai yang identik, survei akan memunculkan kesalahan \"Nilai kunci tidak unik\".",
        description: "Ketik subtitle.",
        locale: "Pilih bahasa untuk mulai membuat survei. Untuk menambahkan terjemahan, beralihlah ke bahasa baru dan terjemahkan teks asli di sini atau di tab Terjemahan.",
        detailPanelMode: "Mengatur lokasi bagian detail dalam kaitannya dengan baris. Pilih dari: \"Tidak ada\" - tidak ada ekspansi yang ditambahkan; \"Di bawah baris\" - ekspansi baris ditempatkan di bawah setiap baris matriks; \"Di bawah baris, tampilkan satu baris ekspansi saja\" - ekspansi ditampilkan di bawah satu baris saja, ekspansi baris yang tersisa diciutkan.",
        imageFit: "Pilih dari: \"Tidak ada\" - gambar mempertahankan ukuran aslinya; \"Berisi\" - gambar diubah ukurannya agar pas dengan tetap mempertahankan rasio aspeknya; \"Cover\" - gambar mengisi seluruh kotak sambil mempertahankan rasio aspeknya; \"Isi\" - gambar direntangkan untuk mengisi kotak tanpa mempertahankan rasio aspeknya.",
        autoGrow: "Secara bertahap meningkatkan ketinggian bidang input saat data dimasukkan. Mengganti setelan \"Tinggi bidang input (dalam baris)\".",
        allowResize: "Gagang pengubah ukuran (atau pegangan) muncul di sudut dan dapat diseret untuk mengubah ukuran bidang input.",
        maxTimeToFinish: "Interval waktu dalam hitungan detik setelah survei maju secara otomatis ke halaman Terima Kasih.",
        maxTimeToFinishPage: "Interval waktu dalam hitungan detik setelah survei maju secara otomatis ke halaman berikutnya.",
        page: {
            maxTimeToFinish: "Interval waktu dalam hitungan detik setelah survei maju secara otomatis ke halaman berikutnya.",
            visibleIf: "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang menentukan visibilitas halaman.",
            enableIf: "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menonaktifkan mode baca-saja untuk halaman.",
            requiredIf: "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang mencegah pengiriman survei kecuali setidaknya satu pertanyaan bertingkat memiliki jawaban.",
            questionTitleLocation: "Berlaku untuk semua pertanyaan dalam halaman ini. Jika Anda ingin mengganti setelan ini, tentukan aturan perataan judul untuk masing-masing pertanyaan atau panel. Opsi \"Warisi\" menerapkan setelan tingkat survei (\"Teratas\" secara default).",
            questionTitleWidth: "Mengatur lebar yang konsisten untuk judul pertanyaan bila disejajarkan di sebelah kiri kotak pertanyaan. Menerima nilai CSS (px, %, in, pt, dll.).",
            questionErrorLocation: "Mengatur lokasi pesan kesalahan sehubungan dengan pertanyaan dengan input yang tidak valid. Pilih antara: \"Atas\" - teks kesalahan ditempatkan di bagian atas kotak pertanyaan; \"Bawah\" - teks kesalahan ditempatkan di bagian bawah kotak pertanyaan. Opsi \"Warisi\" menerapkan setelan tingkat survei (\"Teratas\" secara default).",
            questionsOrder: "Menyimpan urutan pertanyaan asli atau mengacaknya. Opsi \"Warisi\" menerapkan setelan tingkat survei (\"Asli\" secara default). Efek pengaturan ini hanya terlihat di tab Pratinjau.",
            navigationButtonsVisibility: "Mengatur visibilitas tombol navigasi di halaman. Opsi \"Warisi\" menerapkan pengaturan tingkat survei, yang defaultnya adalah \"Terlihat\"."
        },
        showTimerPanel: "Mengatur visibilitas dan lokasi timer pada halaman.",
        panelsState: "Pilih dari: \"Terkunci\" - pengguna tidak dapat memperluas atau menciutkan panel; \"Runtuhkan semua\" - semua panel dimulai dalam keadaan diciutkan; \"Perluas semua\" - semua panel dimulai dalam keadaan diperluas; \"Pertama diperluas\" - hanya panel pertama yang awalnya diperluas.",
        imageLinkName: "Masukkan nama properti bersama dalam array objek yang berisi URL file gambar atau video yang ingin Anda tampilkan di daftar pilihan.",
        choices: "Nilai kiri berfungsi sebagai ID item yang digunakan dalam aturan bersyarat, nilai yang tepat ditampilkan kepada responden.",
        title: "Ketik judul yang mudah digunakan untuk ditampilkan.",
        waitForUpload: "Memastikan bahwa pengguna tidak akan menyelesaikan survei sampai file diunggah.",
        minWidth: "Menerima nilai CSS (px, %, in, pt, dll.).",
        maxWidth: "Menerima nilai CSS (px, %, in, pt, dll.).",
        width: "Menerima nilai CSS (px, %, in, pt, dll.).",
        valueName: "Jika Anda tidak mengatur properti ini, jawabannya akan disimpan dalam bidang yang ditentukan oleh properti Name.",
        useDisplayValuesInDynamicTexts: "Dalam tipe pertanyaan pilihan tunggal dan ganda, setiap opsi pilihan memiliki ID dan nilai tampilan. Saat dipilih, setelan ini akan menampilkan nilai tampilan, bukan nilai ID dalam pertanyaan HTML serta judul dinamis dan deskripsi elemen survei.",
        clearIfInvisible: "Pilih apakah akan menghapus nilai pertanyaan yang disembunyikan oleh logika kondisional atau tidak dan kapan melakukannya. Opsi \"Warisi\" menerapkan setelan tingkat survei (\"Setelah survei selesai\" secara default).",
        choicesFromQuestionMode: "Pilih dari: \"Semua\" - menyalin semua opsi pilihan dari pertanyaan yang dipilih; \"Dipilih\" - secara dinamis menyalin hanya opsi pilihan yang dipilih; \"Tidak dipilih\" - secara dinamis hanya menyalin opsi pilihan yang tidak dipilih. Opsi \"Tidak Ada\" dan \"Lainnya\" disalin secara default jika diaktifkan dalam pertanyaan sumber.",
        showOtherItem: "Saat dipilih, pengguna dapat menyertakan input tambahan di kotak komentar terpisah.",
        separateSpecialChoices: "Menampilkan setiap opsi pilihan khusus (\"Tidak Ada\", \"Lainnya\", \"Pilih Semua\") pada baris baru, bahkan saat menggunakan tata letak beberapa kolom.",
        path: "Tentukan lokasi dalam himpunan data layanan tempat array objek target berada. Biarkan kosong jika URL sudah menunjuk ke array.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Masukkan nama properti seragam dalam array objek yang berisi nilai yang ingin Anda tampilkan di daftar pilihan.",
        allowEmptyResponse: "Pilih untuk mengizinkan layanan mengembalikan respons atau array kosong.",
        choicesVisibleIf: "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menentukan visibilitas semua opsi pilihan.",
        rateValues: "Nilai kiri berfungsi sebagai ID item yang digunakan dalam aturan bersyarat, nilai yang tepat ditampilkan kepada responden.",
        rating: {
            displayMode: "\"Otomatis\" memilih antara mode \"Tombol\" dan \"Tarik-turun\" berdasarkan lebar yang tersedia. Ketika lebar tidak cukup untuk menampilkan tombol, pertanyaan menampilkan dropdown."
        },
        valuePropertyName: "Memungkinkan Anda menghubungkan pertanyaan yang menghasilkan hasil dalam berbagai format. Saat pertanyaan tersebut ditautkan bersama menggunakan ID gabungan, properti bersama ini akan menyimpan nilai pertanyaan yang dipilih.",
        searchEnabled: "Pilih apakah Anda ingin memperbarui konten menu drop-down agar sesuai dengan kueri pencarian yang diketik pengguna di bidang input.",
        valueTrue: "Nilai yang harus disimpan dalam hasil survei ketika responden memberikan jawaban positif.",
        valueFalse: "Nilai untuk disimpan dalam hasil survei ketika responden memberikan jawaban negatif.",
        showPreview: "Tidak disarankan untuk menonaktifkan opsi ini karena menimpa gambar Pratinjau dan menyulitkan pengguna untuk memahami apakah file telah diunggah.",
        needConfirmRemoveFile: "Memicu prompt yang meminta konfirmasi penghapusan file.",
        selectToRankEnabled: "Aktifkan untuk memberi peringkat hanya pada pilihan yang dipilih. Pengguna akan menyeret item yang dipilih dari daftar pilihan untuk memesannya di dalam area peringkat.",
        dataList: "Masukkan daftar pilihan yang akan disarankan kepada responden saat masukan.",
        itemSize: "Pengaturan hanya mengubah ukuran bidang input dan tidak memengaruhi lebar kotak pertanyaan.",
        itemTitleWidth: "Mengatur lebar yang konsisten untuk semua label item dalam piksel",
        altText: "Berfungsi sebagai pengganti ketika gambar tidak dapat ditampilkan pada perangkat pengguna dan untuk tujuan aksesibilitas.",
        rateColorMode: "Menentukan warna emoji yang dipilih saat jenis ikon Peringkat diatur ke \"Smiley\". Pilih antara: \"Default\" - emoji yang dipilih muncul dalam warna survei default; \"Skala\" - emoji yang dipilih mewarisi warna dari skala peringkat.",
        expression: {
            name: "ID ekspresi yang tidak terlihat oleh responden.",
            description: "Ketikkan subjudul ekspresi.",
            expression: "Ekspresi dapat mencakup perhitungan dasar ('{q1_id} + {q2_id}'), kondisi ('{age} > 60'), dan fungsi ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', dll.)."
        },
        storeOthersAsComment: "Pilih untuk menyimpan nilai opsi \"Lainnya\" sebagai properti terpisah dalam hasil survei.",
        format: "Gunakan {0} sebagai placeholder untuk nilai aktual.",
        acceptedTypes: "Lihat deskripsi atribut [accept](https://www.w3schools.com/tags/att_input_accept.asp) untuk informasi selengkapnya.",
        columnColCount: "Hanya berlaku untuk jenis sel Radiogroup dan Checkbox.",
        autocomplete: "Lihat deskripsi atribut [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) untuk informasi selengkapnya.",
        filePlaceholder: "Berlaku ketika \"Jenis sumber\" adalah \"File lokal\" atau ketika kamera tidak tersedia",
        photoPlaceholder: "Berlaku ketika \"Jenis sumber\" adalah \"Kamera\".",
        fileOrPhotoPlaceholder: "Berlaku ketika \"Jenis sumber\" adalah \"File atau kamera lokal\".",
        masksettings: {
            saveMaskedValue: "Pilih apakah Anda ingin menyimpan nilai pertanyaan dengan masker yang diterapkan dalam hasil survei."
        },
        patternmask: {
            pattern: "Pola dapat berisi literal string dan placeholder berikut: '9' - untuk digit; 'a' - untuk huruf besar atau kecil; '#' - untuk digit atau huruf besar atau kecil. Gunakan garis miring terbalik '\\' untuk melarikan diri dari karakter."
        },
        datetimemask: {
            pattern: "Pola dapat berisi karakter pemisah dan placeholder berikut:<br>'m' - Nomor bulan.<br>'mm' - Angka bulan, dengan nol di depannya untuk nilai satu digit. <br>'d' - Hari dalam sebulan. <br>'dd' - Hari dalam sebulan, dengan nol di depan untuk nilai satu digit. <br>'yy' - Dua digit terakhir tahun ini. <br>'yyyy' - Tahun empat digit. <br>'H' - Jam dalam format 24 jam. <br>'HH' - Jam dalam format 24 jam, dengan nol di depannya untuk nilai satu digit. <br>'h' - Jam dalam format 12 jam. <br>'hh' - Jam dalam format 12 jam, dengan nol di depannya untuk nilai satu digit. <br>'MM' - Menit. <br>'ss' - Detik. <br>'TT' - Periode jam 12 jam dalam huruf besar (AM / PM). <br>'tt' - Periode jam 12 jam dalam huruf kecil (am/pm)."
        },
        numericmask: {
            decimalSeparator: "Simbol yang digunakan untuk memisahkan bagian pecahan dari bagian bilangan bulat dari angka yang ditampilkan.",
            thousandsSeparator: "Simbol yang digunakan untuk memisahkan digit angka besar menjadi kelompok tiga.",
            precision: "Membatasi jumlah digit yang akan dipertahankan setelah koma desimal untuk angka yang ditampilkan."
        },
        currencymask: {
            prefix: "Satu atau beberapa simbol yang akan ditampilkan sebelum nilai.",
            suffix: "Satu atau beberapa simbol yang akan ditampilkan setelah nilai."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "judul",
            title: "Biarkan kosong, jika sama dengan 'Nama'"
        },
        multiSelect: "Perbolehkan beberapa pilihan",
        showLabel: "Tampilkan keterangan gambar",
        swapOrder: "Tukar urutan Ya dan Tidak",
        value: "Nilai",
        tabAlign: "Perataan tab",
        sourceType: "Jenis sumber",
        fitToContainer: "Sesuai dengan kontainer",
        setValueExpression: "Mengatur ekspresi nilai",
        description: "deskripsi",
        logoFit: "Kecocokan logo",
        pages: "Halaman",
        questions: "Pertanyaan",
        triggers: "Trigger",
        calculatedValues: "Nilai terhitung",
        surveyId: "ID survei",
        surveyPostId: "ID pos survei",
        surveyShowDataSaving: "Survei menunjukkan penghematan data",
        questionDescriptionLocation: "Lokasi deskripsi pertanyaan",
        progressBarType: "Jenis bilah kemajuan",
        showTOC: "Tampilkan TOC",
        tocLocation: "Lokasi Toc",
        questionTitlePattern: "Pola judul pertanyaan",
        widthMode: "Mode lebar",
        showBrandInfo: "Tampilkan info merek",
        useDisplayValuesInDynamicTexts: "Menggunakan nilai tampilan dalam teks dinamis",
        visibleIf: "terlihat jika",
        defaultValueExpression: "Ekspresi nilai default",
        requiredIf: "wajib jika",
        resetValueIf: "Reset nilai jika",
        setValueIf: "Tetapkan nilai jika",
        validators: "validator",
        bindings: "Binding",
        renderAs: "Render sebagai",
        attachOriginalItems: "Melampirkan item asli",
        choices: "pilihan",
        choicesByUrl: "pilihan dari URL",
        currency: "mata uang",
        cellHint: "Petunjuk sel",
        totalMaximumFractionDigits: "Total digit pecahan maksimum",
        totalMinimumFractionDigits: "Total digit pecahan minimum",
        columns: "kolom",
        detailElements: "Elemen detail",
        allowAdaptiveActions: "Izinkan tindakan adaptif",
        defaultRowValue: "nilai baris default",
        detailPanelShowOnAdding: "Panel detail menunjukkan pada menambahkan",
        choicesLazyLoadEnabled: "Pilihan lazy load diaktifkan",
        choicesLazyLoadPageSize: "Pilihan malas memuat ukuran halaman",
        inputFieldComponent: "Komponen bidang input",
        itemComponent: "Komponen item",
        min: "Min",
        max: "Maks",
        minValueExpression: "Ekspresi nilai min",
        maxValueExpression: "Ekspresi nilai maksimum",
        step: "Langkah",
        dataList: "Daftar data",
        itemSize: "ukuranBarang",
        itemTitleWidth: "Lebar label item (dalam px)",
        elements: "Elemen",
        content: "Puas",
        navigationButtonsVisibility: "visibilitas tombol navigasi",
        navigationTitle: "Judul navigasi",
        navigationDescription: "Deskripsi navigasi",
        longTap: "Ketuk lama",
        autoGrow: "Tumbuh otomatis",
        allowResize: "Izinkan pengubahan ukuran",
        acceptCarriageReturn: "Terima pengembalian kereta",
        displayMode: "Mode tampilan",
        rateType: "Jenis tarif",
        label: "label",
        contentMode: "Mode konten",
        imageFit: "Kecocokan gambar",
        altText: "Teks alternatif",
        height: "Tinggi",
        penColor: "Warna pena",
        backgroundColor: "Warna latar belakang",
        templateElements: "Elemen template",
        operator: "Operator",
        isVariable: "Adalah variabel",
        runExpression: "Menjalankan ekspresi",
        showCaption: "Tampilkan caption",
        iconName: "Nama ikon",
        iconSize: "Ukuran ikon",
        precision: "Presisi",
        matrixDragHandleArea: "Area gagang seret matriks",
        backgroundImage: "Gambar latar belakang",
        backgroundImageFit: "Kecocokan gambar latar belakang",
        backgroundImageAttachment: "Lampiran gambar latar belakang",
        backgroundOpacity: "Opasitas latar belakang",
        selectToRankEnabled: "Pilih untuk peringkat diaktifkan",
        selectToRankAreasLayout: "Pilih untuk memberi peringkat tata letak area",
        selectToRankEmptyRankedAreaText: "Teks untuk memperlihatkan jika semua opsi dipilih",
        selectToRankEmptyUnrankedAreaText: "Teks tempat penampung untuk area peringkat",
        allowCameraAccess: "Izinkan akses kamera",
        scaleColorMode: "Mode skala warna",
        rateColorMode: "Mode warna tingkat",
        copyDisplayValue: "Salin nilai tampilan",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Mode lanjutan",
        pageTitle: "Font judul halaman",
        questionTitle: "Font judul pertanyaan",
        editorPanel: "Elemen input",
        lines: "Baris",
        primaryDefaultColor: "Default",
        primaryDarkColor: "Hover",
        primaryLightColor: "Dipilih",
        backgroundDimColor: "Warna latar belakang",
        cornerRadius: "Radius sudut",
        backcolor: "Latar belakang default",
        hovercolor: "Arahkan kursor ke latar belakang",
        borderDecoration: "Dekorasi perbatasan",
        fontColor: "Warna font",
        backgroundColor: "Warna latar belakang",
        primaryForecolor: "Warna default",
        primaryForecolorLight: "Warna dinonaktifkan",
        font: "Font",
        borderDefault: "Gelap",
        borderLight: "Ringan",
        fontFamily: "Keluarga font",
        fontWeightRegular: "Biasa",
        fontWeightHeavy: "Berat",
        fontWeightSemiBold: "Semi-tebal",
        fontWeightBold: "Berani",
        color: "Warna",
        placeholderColor: "Warna tempat penampung",
        size: "Tingginya",
        opacity: "Opacity",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Tambahkan Efek Bayangan",
        boxShadowBlur: "Kabur",
        boxShadowSpread: "Penyebaran",
        boxShadowDrop: "Menjatuhkan",
        boxShadowInner: "Batin",
        names: {
            default: "Default",
            sharp: "Tajam",
            borderless: "Tanpa batas",
            flat: "Rata",
            plain: "Polos",
            doubleborder: "Batas Ganda",
            layered: "Berlapis",
            solid: "Keras",
            threedimensional: ".3D",
            contrast: "Kontras"
        },
        colors: {
            teal: "Teal",
            blue: "Biru",
            purple: "Ungu",
            orchid: "Anggrek",
            tulip: "Tulip",
            brown: "Coklat",
            green: "Hijau"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["id"] = indonesianStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// survey.addLogicItem: "Create a rule to customize the flow of the survey." => "Buat aturan untuk menyesuaikan alur survei."
// survey.duplicate: "Duplicate" => "Duplikat"
// qt.ranking: "Ranking" => "Peringkat"
// qt.image: "Image" => "Citra"
// qt.tagbox: "Multi-Select Dropdown" => "Dropdown Multi-Pilih"
// qt.signaturepad: "Signature" => "Tanda tangan"
// qt.buttongroup: "Button Group" => "Grup Tombol"
// ed.settingsTooltip: "Open settings" => "Buka pengaturan"
// ed.surveySettings: "Survey Settings" => "Pengaturan Survei"
// ed.surveySettingsTooltip: "Open survey settings" => "Buka pengaturan survei"
// ed.showPanel: "Show Panel" => "Tampilkan Panel"
// ed.hidePanel: "Hide Panel" => "Sembunyikan Panel"
// ed.prevSelected: "Select previous" => "Pilih sebelumnya"
// ed.nextSelected: "Select next" => "Pilih selanjutnya"
// ed.surveyTypeName: "Survey" => "Survei"
// ed.pageTypeName: "Page" => "Halaman"
// ed.panelTypeName: "Panel" => "Panel"
// ed.questionTypeName: "Question" => "Pertanyaan"
// ed.columnTypeName: "Column" => "Kolom"
// ed.newTextItemName: "text" => "Teks"
// ed.themeSurvey: "Themes" => "Tema"
// ed.defaultV2Theme: "Default" => "Default"
// ed.modernTheme: "Modern" => "Modern"
// ed.defaultTheme: "Default (legacy)" => "Default (warisan)"
// ed.navigateToMsg: "You had to navigate to" => "Anda harus menavigasi ke"
// ed.logic: "Logic" => "Logika"
// ed.saveSurveyTooltip: "Save Survey" => "Simpan Survei"
// ed.jsonHideErrors: "Hide errors" => "Menyembunyikan kesalahan"
// ed.jsonShowErrors: "Show errors" => "Tampilkan kesalahan"
// ed.undoTooltip: "Undo last change" => "Mengurungkan perubahan terakhir"
// ed.redoTooltip: "Redo the change" => "Mengulangi perubahan"
// ed.showMoreChoices: "Show more" => "Tampilkan lebih banyak"
// ed.showLessChoices: "Show less" => "Tampilkan lebih sedikit"
// ed.copy: "Copy" => "Menyalin"
// ed.cut: "Cut" => "Memotong"
// ed.paste: "Paste" => "Pasta"
// ed.copyTooltip: "Copy selection to clipboard" => "Salin pilihan ke clipboard"
// ed.cutTooltip: "Cut selection to clipboard" => "Memotong pilihan ke clipboard"
// ed.pasteTooltip: "Paste from clipboard" => "Tempel dari papan klip"
// ed.property-grid: "Properties" => "Properti"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "Ketik untuk mencari..."
// ed.toolboxChoiceCategory: "Choice Questions" => "Pertanyaan Pilihan"
// ed.toolboxTextCategory: "Text Input Questions" => "Pertanyaan Input Teks"
// ed.toolboxContainersCategory: "Containers" => "Wadah"
// ed.toolboxMatrixCategory: "Matrix Questions" => "Pertanyaan Matriks"
// ed.toolboxMiscCategory: "Misc" => "Misc"
// ed.propertyEditorError: "Error" => "Kesalahan"
// ed.translationPropertyGridTitle: "Language Settings" => "Pengaturan Bahasa"
// ed.themePropertyGridTitle: "Theme Settings" => "Pengaturan Tema"
// ed.translationLanguages: "Languages" => "Bahasa"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "Hanya String yang Digunakan"
// ed.translationPlaceHolder: "Translation..." => "Terjemahan..."
// ed.themeExportButton: "Export" => "Ekspor"
// ed.themeImportButton: "Import" => "Mengimpor"
// ed.selectPage: "Select page..." => "Pilih halaman..."
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Pilihan disalin dari"
// ed.htmlPlaceHolder: "HTML content will be here." => "Konten HTML akan ada di sini."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "Jatuhkan pertanyaan dari kotak alat di sini."
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "Survei kosong. Seret elemen dari kotak alat atau klik tombol di bawah."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Seret dan lepas gambar di sini atau klik tombol di bawah ini dan pilih gambar untuk diunggah"
// ed.imageChooseImage: "Choose Image" => "Pilih Gambar"
// ed.addNewTypeQuestion: "Add {0}" => "Tambahkan {0}"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[LOGO]"
// ed.auto: "auto" => "Auto"
// ed.choices_Item: "Item " => "Benda "
// lg.addNewItem: "Add New Rule" => "Tambahkan Aturan Baru"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "Buat aturan untuk menyesuaikan alur survei."
// lg.page_visibilityName: "Show (hide) page" => "Tampilkan (sembunyikan) halaman"
// lg.page_enableName: "Enable (disable) page" => "Aktifkan (nonaktifkan) halaman"
// lg.panel_visibilityName: "Show (hide) panel" => "Tampilkan (sembunyikan) panel"
// lg.panel_enableName: "Enable (disable) panel" => "Aktifkan (nonaktifkan) panel"
// lg.question_visibilityName: "Show (hide) question" => "Tampilkan (sembunyikan) pertanyaan"
// lg.question_enableName: "Enable (disable) question" => "Aktifkan (nonaktifkan) pertanyaan"
// lg.question_requireName: "Make question required" => "Buat pertanyaan diperlukan"
// lg.column_visibilityName: "Show (hide) column" => "Perlihatkan (sembunyikan) kolom"
// lg.column_enableName: "Enable (disable) column" => "Mengaktifkan (menonaktifkan) kolom"
// lg.column_requireName: "Make column required" => "Buat kolom diperlukan"
// lg.trigger_completeName: "Complete survey" => "Survei lengkap"
// lg.trigger_setvalueName: "Set answer" => "Tetapkan jawaban"
// lg.trigger_copyvalueName: "Copy answer" => "Salin jawaban"
// lg.trigger_skipName: "Skip to question" => "Lanjut ke pertanyaan"
// lg.trigger_runExpressionName: "Run expression" => "Menjalankan ekspresi"
// lg.completedHtmlOnConditionName: "Set \"Survey Complete\" page markup" => "Mengatur markup halaman \"Survei Selesai\""
// lg.page_visibilityDescription: "Make the page visible when the logic expression returns true. Otherwise keep it invisible." => "Membuat halaman terlihat saat ekspresi logika mengembalikan true. Jika tidak, jaga agar tidak terlihat."
// lg.panel_visibilityDescription: "Make the panel visible when the logic expression returns true. Otherwise keep it invisible." => "Buat panel terlihat saat ekspresi logika mengembalikan true. Jika tidak, jaga agar tidak terlihat."
// lg.panel_enableDescription: "Make the panel, and all elements inside it, enable when the logic expression returns true. Otherwise keep them disabled." => "Buat panel, dan semua elemen di dalamnya, aktifkan saat ekspresi logika mengembalikan true. Jika tidak, biarkan mereka dinonaktifkan."
// lg.question_visibilityDescription: "Make the question visible when the logic expression returns true. Otherwise keep it invisible." => "Buat pertanyaan terlihat saat ekspresi logika mengembalikan true. Jika tidak, jaga agar tidak terlihat."
// lg.question_enableDescription: "Make the question enable when the logic expression returns true. Otherwise keep it disabled." => "Aktifkan pertanyaan saat ekspresi logika mengembalikan true. Jika tidak, tetap nonaktifkan."
// lg.question_requireDescription: "Question becomes required when the logic expression returns true." => "Pertanyaan menjadi diperlukan saat ekspresi logika mengembalikan true."
// lg.trigger_completeDescription: "When the logic expression returns true then the survey becomes completed and an end-user see the 'Thank you page'." => "Ketika ekspresi logika mengembalikan true maka survei menjadi selesai dan pengguna akhir melihat 'Halaman terima kasih'."
// lg.trigger_setvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value is set to the selected question." => "Ketika nilai pertanyaan, yang digunakan dalam ekspresi logika, diubah dan ekspresi logika mengembalikan true, maka nilai diatur ke pertanyaan yang dipilih."
// lg.trigger_copyvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value of one selected question is copied to another selected question." => "Ketika nilai pertanyaan, yang digunakan dalam ekspresi logika, diubah dan ekspresi logika mengembalikan true, maka nilai satu pertanyaan yang dipilih disalin ke pertanyaan lain yang dipilih."
// lg.trigger_skipDescription: "When the logic expression returns true then the survey skip to / focus the selected question." => "Ketika ekspresi logika mengembalikan true maka survei melompat ke / memfokuskan pertanyaan yang dipilih."
// lg.trigger_runExpressionDescription: "When the logic expression returns true, then the custom expression is performed. You may optionally set this expression result into the selected question" => "Ketika ekspresi logika mengembalikan true, maka ekspresi kustom dilakukan. Anda dapat secara opsional mengatur hasil ekspresi ini ke dalam pertanyaan yang dipilih"
// lg.completedHtmlOnConditionDescription: "If the logic expression returns true, then the default text for the 'Thank you page' is changed to the given one." => "Jika ekspresi logika mengembalikan true, maka teks default untuk 'Halaman terima kasih' diubah ke yang diberikan."
// lg.itemExpressionText: "When expression: '{0}' returns true" => "Ketika ekspresi: '{0}' mengembalikan true"
// lg.itemEmptyExpressionText: "New rule" => "Aturan baru"
// lg.page_visibilityText: "make page {0} visible" => "Membuat halaman {0} terlihat"
// lg.panel_visibilityText: "make panel {0} visible" => "Membuat panel {0} terlihat"
// lg.panel_enableText: "make panel {0} enable" => "Membuat panel {0} mengaktifkan"
// lg.question_visibilityText: "make question {0} visible" => "Buat pertanyaan {0} terlihat"
// lg.question_enableText: "make question {0} enable" => "Buat pertanyaan {0} aktifkan"
// lg.question_requireText: "make question {0} required" => "Buat pertanyaan {0} diperlukan"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "Membuat kolom {0} pertanyaan {1} terlihat"
// lg.column_enableText: "make column {0} of question {1} enable" => "Buat kolom {0} pertanyaan {1} aktifkan"
// lg.column_requireText: "make column {0} of question {1} required" => "membuat kolom {0} pertanyaan {1} diperlukan"
// lg.trigger_completeText: "survey becomes completed" => "Survei menjadi selesai"
// lg.trigger_setvalueText: "set into question: {0} value {1}" => "Pertanyaan: {0} nilai {1}"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "Nilai Pertanyaan yang Jelas: {0}"
// lg.trigger_copyvalueText: "copy into question: {0} value from question {1}" => "Salin ke pertanyaan: {0} nilai dari pertanyaan {1}"
// lg.trigger_skipText: "survey skip to the question {0}" => "Survei Lewati ke pertanyaan {0}"
// lg.trigger_runExpressionText1: "run expression: '{0}'" => "menjalankan ekspresi: '{0}'"
// lg.trigger_runExpressionText2: " and set its result into question: {0}" => " dan mempertanyakan hasilnya: {0}"
// lg.completedHtmlOnConditionText: "show custom text for the 'Thank you page'." => "tampilkan teks kustom untuk \"Halaman terima kasih\"."
// lg.showAllQuestions: "All Questions" => "Semua Pertanyaan"
// lg.showAllActionTypes: "All Action Types" => "Semua Jenis Tindakan"
// lg.conditions: "Condition(s)" => "Ketentuan"
// lg.actions: "Action(s)" => "Tindakan"
// lg.expressionEditorTitle: "Define condition(s)" => "Tentukan kondisi"
// lg.actionsEditorTitle: "Define action(s)" => "Menentukan tindakan"
// lg.deleteAction: "Delete Action" => "Hapus Tindakan"
// lg.addNewAction: "Add Action" => "Tambahkan Tindakan"
// lg.selectedActionCaption: "Select action..." => "Pilih tindakan..."
// lg.expressionInvalid: "The logic expression is empty or invalid. Please correct it." => "Ekspresi logika kosong atau tidak valid. Mohon koreksinya."
// lg.noActionError: "Please, add at least one action." => "Tolong, tambahkan setidaknya satu tindakan."
// lg.actionInvalid: "Please, fix problems in your action(s)." => "Tolong, perbaiki masalah dalam tindakan Anda."
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Aturan logis tidak lengkap"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Anda belum menyelesaikan beberapa aturan logis. Jika Anda meninggalkan tab sekarang, perubahan akan hilang. Apakah Anda masih ingin meninggalkan tab tanpa menyelesaikan perubahan?"
// lg.uncompletedRule_apply: "Yes" => "Ya"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Tidak, saya ingin menyelesaikan aturan"
// pe.save: "Save" => "Simpan"
// pe.clear: "Clear" => "Jelas"
// pe.saveTooltip: "Save" => "Simpan"
// pe.set: "Set" => "Mengeset"
// pe.change: "Change" => "Ubah"
// pe.refresh: "Refresh" => "Refresh"
// pe.add: "Add" => "Tambah"
// pe.removeItem: "Click to remove the item..." => "Klik untuk menghapus item..."
// pe.dragItem: "Drag the item" => "Seret item"
// pe.addOther: "Other" => "Lain"
// pe.addSelectAll: "Select All" => "Pilih Semua"
// pe.addNone: "None" => "Tidak"
// pe.back: "Return without saving" => "Pengembalian tanpa menabung"
// pe.backTooltip: "Return without saving" => "Pengembalian tanpa menabung"
// pe.saveAndBack: "Save and return" => "Simpan dan kembalikan"
// pe.saveAndBackTooltip: "Save and return" => "Simpan dan kembalikan"
// pe.doneEditing: "Done" => "Selesai"
// pe.showChoices: "Show Choices" => "Tampilkan Pilihan"
// pe.emptyValue: "Value is empty" => "Nilai kosong"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "Nilai '{0}' tidak unik"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "Harap batasi jumlah item dari {0} ke {1}"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "Anda dapat mengatur data dalam format berikut:\nvalue1|text\nnilai2"
// pe.itemSelectorEmpty: "Please select the element" => "Silakan pilih elemen"
// pe.conditionActionEmpty: "Please select the action" => "Silakan pilih tindakan"
// pe.conditionSelectPage: "Select page..." => "Pilih halaman..."
// pe.conditionSelectPanel: "Select panel..." => "Pilih panel..."
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "Melihat pratinjau jawaban sebelum mengirimkan survei"
// pe.overridingPropertyPrefix: "Set by " => "Ditetapkan oleh "
// pe.propertyIsNoUnique: "Please enter a unique value" => "Silakan masukkan nilai unik"
// pe.propertyNameIsNotUnique: "Please enter a unique name" => "Silakan masukkan nama yang unik"
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Jangan gunakan kata-kata khusus: \"item\", \"pilihan\", \"panel\", \"baris\"."
// pe.listIsEmpty: "No items have been added yet" => "Belum ada item yang ditambahkan"
// pe.listIsEmpty@choices: "No choices have been added yet" => "Belum ada pilihan yang ditambahkan"
// pe.addNew@choices: "Add a choice" => "Menambahkan pilihan"
// pe.expressionIsEmpty: "Expression is empty" => "Ekspresi kosong"
// choicesbyurl.valueName: "Get values from the following JSON field" => "Dapatkan nilai dari bidang JSON berikut"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "Dapatkan URL gambar dari bidang JSON berikut"
// pe.allowEmptyResponse: "Allow empty response" => "Izinkan respons kosong"
// pe.titlePlaceholder: "Title" => "Titel"
// pe.surveyTitlePlaceholder: "Survey Title" => "Judul Survei"
// pe.pageTitlePlaceholder: "Page {num}" => "Halaman {num}"
// pe.descriptionPlaceholder: "Description" => "Deskripsi"
// pe.surveyDescriptionPlaceholder: "Description" => "Deskripsi"
// pe.pageDescriptionPlaceholder: "Description" => "Deskripsi"
// pe.showNoneItem: "Allow the None option" => "Perbolehkan opsi Tidak Ada"
// pe.noneText: "None option text" => "Tidak ada teks opsi"
// pe.showSelectAllItem: "Allow the Select All option" => "Perbolehkan opsi Pilih Semua"
// pe.selectAllText: "Select All option text" => "Pilih Semua teks opsi"
// pe.choicesMin: "Minimum value for auto-generated items" => "Nilai minimum untuk item yang dibuat secara otomatis"
// pe.choicesMax: "Maximum value for auto-generated items" => "Nilai maksimum untuk item yang dibuat secara otomatis"
// pe.choicesStep: "Step for auto-generated items" => "Langkah untuk item yang dibuat secara otomatis"
// pe.isAllRowRequired: "Require answer for all rows" => "Memerlukan jawaban untuk semua baris"
// pe.requiredErrorText: "\"Required\" error message" => "Pesan kesalahan \"Wajib\""
// pe.cols: "Columns" => "Kolom"
// pe.rateMin: "Minimum rate value" => "Nilai tarif minimum"
// pe.rateMax: "Maximum rate value" => "Nilai tarif maksimum"
// pe.rateStep: "Rate step" => "Langkah tingkat"
// pe.buildExpression: "Build" => "Membangun"
// pe.editExpression: "Edit" => "Mengedit"
// pe.and: "and" => "dan"
// pe.or: "or" => "atau"
// pe.remove: "Remove" => "Buka"
// pe.addCondition: "Add Condition" => "Tambahkan Kondisi"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Pilih pertanyaan untuk mulai mengonfigurasi kondisi."
// pe.if: "If" => "Kalau"
// pe.then: "then" => "kemudian"
// pe.setToName: "Target question" => "Pertanyaan target"
// pe.fromName: "Question to copy answer from" => "Pertanyaan untuk disalin jawabannya"
// pe.gotoName: "Question to skip to" => "Pertanyaan untuk dilewati"
// pe.ruleIsNotSet: "Rule is incorrect" => "Aturan salah"
// pe.includeIntoResult: "Include into survey results" => "Sertakan ke dalam hasil survei"
// pe.expandCollapseTitle: "Expand/collapse title" => "Perluas/ciutkan judul"
// pe.simulator: "Select device type" => "Pilih jenis perangkat"
// pe.landscapeOrientation: "Switch to landscape orientation" => "Beralih ke orientasi lanskap"
// pe.portraitOrientation: "Switch to portrait orientation" => "Beralih ke orientasi potret"
// pe.previewText: "Preview Answers button text" => "Teks tombol Pratinjau Jawaban"
// pe.editText: "Edit Answer button text" => "Teks tombol Edit Jawaban"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Tinggi gambar (dalam nilai yang diterima CSS)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Lebar gambar (dalam nilai yang diterima CSS)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "Batas waktu untuk menyelesaikan halaman (dalam detik)"
// question.page: "Parent page" => "Halaman induk"
// pe.noEntriesText: "Empty entries text" => "Teks entri kosong"
// pe.setValue: "Answer" => "Menjawab"
// pe.dataFormat: "Image format" => "Format gambar"
// pe.allowAddRows: "Allow adding rows" => "Perbolehkan menambahkan baris"
// pe.allowRemoveRows: "Allow removing rows" => "Perbolehkan menghapus baris"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "Perbolehkan baris seret dan lepas"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "Tidak berlaku jika Anda menentukan lebar atau tinggi gambar yang tepat."
// pe.minImageWidth: "Minimum image width" => "Lebar gambar minimum"
// pe.maxImageWidth: "Maximum image width" => "Lebar gambar maksimum"
// pe.minImageHeight: "Minimum image height" => "Tinggi gambar minimum"
// pe.maxImageHeight: "Maximum image height" => "Tinggi gambar maksimum"
// surveyvalidator.text: "Error message" => "Pesan kesalahan"
// surveyvalidator.expression: "Validation expression" => "Ekspresi validasi"
// pe.logo: "Logo (URL or base64-encoded string)" => "Logo (URL atau string yang dikodekan base64)"
// pe.questionsOnPageMode: "Survey structure" => "Struktur survei"
// pe.maxTextLength: "Maximum answer length (in characters)" => "Panjang jawaban maksimum (dalam karakter)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "Panjang komentar maksimum (dalam karakter)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "Perluas area komentar secara otomatis jika perlu"
// pe.allowResizeComment: "Allow users to resize text areas" => "Mengizinkan pengguna mengubah ukuran area teks"
// pe.textUpdateMode: "Update text question value" => "Memperbarui nilai pertanyaan teks"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "Mengatur fokus pada jawaban pertama yang tidak valid"
// pe.checkErrorsMode: "Run validation" => "Jalankan validasi"
// pe.navigateToUrl: "Navigate to URL" => "Arahkan ke URL"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "URL dinamis"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "Markup untuk menunjukkan apakah pengguna sudah mengisi survei ini"
// pe.completedHtml: "Survey Complete page markup" => "Markup halaman Survei Selesai"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "Survei Dinamis Markup halaman lengkap"
// pe.loadingHtml: "Markup to show while survey model is loading" => "Markup untuk ditampilkan saat model survei dimuat"
// pe.commentText: "Comment area text" => "Teks area komentar"
// pe.autocomplete: "Autocomplete type" => "Tipe pelengkapan otomatis"
// pe.labelTrue: "\"True\" label" => "Label \"Benar\""
// pe.labelFalse: "\"False\" label" => "Label \"Salah\""
// pe.allowClear: "Show the Clear button" => "Tampilkan tombol Hapus"
// pe.displayStyle: "Value display style" => "Gaya tampilan nilai"
// pe.format: "Formatted string" => "String yang diformat"
// pe.maximumFractionDigits: "Maximum fractional digits" => "Digit pecahan maksimum"
// pe.minimumFractionDigits: "Minimum fractional digits" => "Digit pecahan minimum"
// pe.useGrouping: "Display grouping separators" => "Menampilkan pemisah pengelompokan"
// pe.allowMultiple: "Allow multiple files" => "Izinkan beberapa file"
// pe.allowImagesPreview: "Preview images" => "Pratinjau gambar"
// pe.acceptedTypes: "Accepted file types" => "Jenis file yang diterima"
// pe.waitForUpload: "Wait for the upload to complete" => "Tunggu hingga upload selesai"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "Konfirmasi penghapusan file"
// pe.detailPanelMode: "Detail panel location" => "Lokasi panel detail"
// pe.minRowCount: "Minimum row count" => "Jumlah baris minimum"
// pe.maxRowCount: "Maximum row count" => "Jumlah baris maksimum"
// pe.confirmDelete: "Confirm row deletion" => "Mengonfirmasi penghapusan baris"
// pe.confirmDeleteText: "Confirmation message" => "Pesan konfirmasi"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "Konfirmasi penghapusan panel"
// pe.panelCount: "Initial panel count" => "Jumlah panel awal"
// pe.minPanelCount: "Minimum panel count" => "Jumlah panel minimum"
// pe.maxPanelCount: "Maximum panel count" => "Jumlah panel maksimum"
// pe.panelsState: "Inner panel expand state" => "Status perluasan panel dalam"
// pe.templateDescription: "Description template" => "Template deskripsi"
// pe.templateTitle: "Title template" => "Templat judul"
// pe.panelPrevText: "Previous Panel button tooltip" => "Tooltip tombol Panel sebelumnya"
// pe.panelNextText: "Next Panel button tooltip" => "Tooltip tombol Panel Berikutnya"
// pe.showRangeInProgress: "Show progress bar" => "Perlihatkan bilah kemajuan"
// pe.templateTitleLocation: "Question title location" => "Lokasi judul pertanyaan"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "Hapus lokasi tombol Panel"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "Menyembunyikan pertanyaan jika tidak ada baris"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Menyembunyikan kolom jika tidak ada baris"
// pe.rateValues: "Custom rate values" => "Nilai tarif kustom"
// pe.rateCount: "Rate count" => "Jumlah tarif"
// pe.autoGenerate: "How to specify rate values?" => "Bagaimana cara menentukan nilai tarif?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "Sembunyikan pertanyaan jika tidak berisi pilihan"
// pe.hideNumber: "Hide question number" => "Sembunyikan nomor pertanyaan"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Lebar minimum (dalam nilai yang diterima CSS)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Lebar maksimum (dalam nilai yang diterima CSS)"
// pe.width: "Width (in CSS-accepted values)" => "Lebar (dalam nilai yang diterima CSS)"
// pe.showHeader: "Show column headers" => "Perlihatkan header kolom"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Tampilkan scrollbar horizontal"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Lebar kolom minimum (dalam nilai yang diterima CSS)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Lebar header baris (dalam nilai yang diterima CSS)"
// pe.valueTrue: "\"True\" value" => "Nilai \"Benar\""
// pe.valueFalse: "\"False\" value" => "Nilai \"False\""
// pe.minErrorText: "\"Value is below minimum\" error message" => "Pesan kesalahan \"Nilai di bawah minimum\""
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "Pesan kesalahan \"Nilai melebihi maksimum\""
// pe.otherErrorText: "\"Empty comment\" error message" => "Pesan kesalahan \"Komentar kosong\""
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "Pesan galat \"Nilai kunci tidak unik\""
// pe.minSelectedChoices: "Minimum selected choices" => "Pilihan minimum yang dipilih"
// pe.maxSelectedChoices: "Maximum selected choices" => "Pilihan maksimum yang dipilih"
// pe.showClearButton: "Show the Clear button" => "Tampilkan tombol Hapus"
// pe.showNumber: "Show panel number" => "Tampilkan nomor panel"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "Lebar logo (dalam nilai yang diterima CSS)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "Tinggi logo (dalam nilai yang diterima CSS)"
// pe.readOnly: "Read-only" => "Baca-saja"
// pe.enableIf: "Editable if" => "Dapat diedit jika"
// pe.emptyRowsText: "\"No rows\" message" => "Pesan \"Tidak ada baris\""
// pe.size: "Input field size (in characters)" => "Ukuran bidang input (dalam karakter)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "Pisahkan pilihan khusus (Tidak Ada, Lainnya, Pilih Semua)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Salin pilihan dari pertanyaan berikut"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Pilihan mana yang harus disalin?"
// pe.showCommentArea: "Show the comment area" => "Tampilkan area komentar"
// pe.commentPlaceholder: "Comment area placeholder" => "Tempat penampung area komentar"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Menampilkan deskripsi tingkat sebagai nilai ekstrem"
// pe.rowsOrder: "Row order" => "Urutan baris"
// pe.columnsLayout: "Column layout" => "Tata letak kolom"
// pe.columnColCount: "Nested column count" => "Jumlah kolom bertumpuk"
// pe.state: "Panel expand state" => "Panel memperluas status"
// pe.correctAnswer: "Correct Answer" => "Jawaban yang Benar"
// pe.defaultPanelValue: "Default Values" => "Nilai Default"
// pe.cells: "Cell Texts" => "Teks Sel"
// pe.keyName: "Key column" => "Kolom kunci"
// itemvalue.text: "Alt text" => "Teks alternatif"
// pe.logoPosition: "Logo position" => "Posisi logo"
// pe.addLogo: "Add logo..." => "Tambahkan logo..."
// pe.changeLogo: "Change logo..." => "Ubah logo..."
// logoPositions.none: "Remove logo" => "Hapus logo"
// logoPositions.left: "Left" => "Kiri"
// logoPositions.right: "Right" => "Kanan"
// logoPositions.top: "On the top" => "Di atas"
// logoPositions.bottom: "In the bottom" => "Di bagian bawah"
// tabs.numbering: "Numbering" => "Penomoran"
// tabs.pages: "Pages" => "Halaman"
// tabs.calculatedValues: "Calculated Values" => "Nilai terhitung"
// tabs.logic: "Logic" => "Logika"
// tabs.layout: "Layout" => "Tata letak"
// tabs.data: "Data" => "Data"
// tabs.validation: "Validation" => "Validasi"
// tabs.cells: "Cell Texts" => "Teks Sel"
// tabs.showOnCompleted: "Survey Complete" => "Survei Selesai"
// tabs.logo: "Logo in Survey Title" => "Logo dalam Judul Survei"
// tabs.slider: "Slider" => "Slider"
// tabs.expression: "Expression" => "Ekspresi"
// tabs.others: "Others" => "Lain"
// pe.choicesVisibleIf: "Choices are visible if" => "Pilihan terlihat jika"
// pe.choicesEnableIf: "Choices are selectable if" => "Pilihan dapat dipilih jika"
// pe.columnsEnableIf: "Columns are visible if" => "Kolom terlihat jika"
// pe.rowsEnableIf: "Rows are visible if" => "Baris terlihat jika"
// pe.indent: "Add indents" => "Menambahkan inden"
// panel.indent: "Add outer indents" => "Menambahkan inden luar"
// pe.innerIndent: "Add inner indents" => "Menambahkan inden dalam"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "Mengambil nilai default dari baris terakhir"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "Mengambil nilai default dari panel terakhir"
// pe.titleKeyboardAdornerTip: "Press enter button to edit" => "Tekan tombol enter untuk mengedit"
// pe.keyboardAdornerTip: "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item" => "Tekan tombol enter untuk mengedit item, tekan tombol hapus untuk menghapus item, tekan alt plus panah ke atas atau panah ke bawah untuk memindahkan item"
// pe.triggerGotoName: "Go to the question" => "Pergi ke pertanyaan"
// pe.triggerRunExpressionEmpty: "Please enter a valid expression" => "Silakan masukkan ekspresi yang valid"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "Ketik ekspresi di sini..."
// pe.noFile: "No file choosen" => "Tidak ada file yang dipilih"
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "Hapus nilai jika pertanyaan menjadi tersembunyi"
// pe.valuePropertyName: "Value property name" => "Nama properti nilai"
// pe.searchEnabled: "Enable search" => "Aktifkan pencarian"
// pe.hideSelectedItems: "Hide selected items" => "Menyembunyikan item yang dipilih"
// pe.closeOnSelect: "Close the dropdown after selection" => "Tutup menu turun bawah setelah pemilihan"
// pe.signatureWidth: "Signature width" => "Lebar tanda tangan"
// pe.signatureHeight: "Signature height" => "Tinggi tanda tangan"
// pe.verticalAlign: "Vertical alignment" => "Perataan vertikal"
// pe.alternateRows: "Alternate rows" => "Baris alternatif"
// pe.columnsVisibleIf: "Columns are visible if" => "Kolom terlihat jika"
// pe.rowsVisibleIf: "Rows are visible if" => "Baris terlihat jika"
// pe.otherPlaceholder: "Comment area placeholder" => "Tempat penampung area komentar"
// pe.rateType: "Rate type" => "Jenis tarif"
// pv.true: "true" => "benar"
// pv.false: "false" => "palsu"
// pv.decimal: "decimal" => "desimal"
// pv.currency: "currency" => "mata uang"
// pv.percent: "percent" => "persen"
// pv.onpanel: "Start on each panel" => "Mulai di setiap panel"
// pv.tab: "Tabs" => "Tab"
// pv.both: "Both" => "Keduanya"
// pv.right: "Right" => "Kanan"
// pv.color: "color" => "warna"
// pv.date: "date" => "tanggal"
// pv.datetime: "datetime" => "Waktu tanggal"
// pv.datetime-local: "datetime-local" => "datetime-lokal"
// pv.email: "email" => "Email"
// pv.month: "month" => "bulan"
// pv.number: "number" => "angka"
// pv.password: "password" => "kata sandi"
// pv.range: "range" => "lingkup"
// pv.tel: "tel" => "Tel"
// pv.text: "text" => "Teks"
// pv.time: "time" => "Waktu"
// pv.url: "url" => "URL"
// pv.week: "week" => "minggu"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "Ketika pertanyaan atau panel/halamannya disembunyikan"
// clearInvisibleValues.none: "Never" => "Tidak pernah"
// inputType.color: "Color" => "Warna"
// inputType.date: "Date" => "Tanggal"
// inputType.datetime-local: "Date and Time" => "Tanggal dan Waktu"
// inputType.email: "Email" => "Email"
// inputType.month: "Month" => "Bulan"
// inputType.number: "Number" => "Angka"
// inputType.password: "Password" => "Kata sandi"
// inputType.range: "Range" => "Lingkup"
// inputType.tel: "Phone Number" => "Nomor Telepon"
// inputType.text: "Text" => "Teks"
// inputType.time: "Time" => "Waktu"
// inputType.url: "URL" => "URL"
// inputType.week: "Week" => "Minggu"
// pv.onValueChanging: "Before an answer is changed" => "Sebelum jawaban diubah"
// pv.standard: "Original structure" => "Struktur asli"
// pv.singlePage: "All questions on a single page" => "Semua pertanyaan pada satu halaman"
// pv.questionPerPage: "Each question on an individual page" => "Setiap pertanyaan pada halaman individual"
// pv.noPreview: "No preview" => "Tidak ada pratinjau"
// pv.showAllQuestions: "Show all questions" => "Tampilkan semua pertanyaan"
// pv.showAnsweredQuestions: "Show answered questions only" => "Tampilkan pertanyaan yang sudah terjawab saja"
// pv.pages: "Completed pages" => "Halaman lengkap"
// pv.questions: "Answered questions" => "Pertanyaan yang dijawab"
// pv.requiredQuestions: "Answered required questions" => "Menjawab pertanyaan yang diperlukan"
// pv.correctQuestions: "Valid answers" => "Jawaban yang valid"
// pv.buttons: "Completed pages (button UI)" => "Halaman selesai (tombol UI)"
// pv.underInput: "Under the input" => "Di bawah input"
// pv.underTitle: "Under the title" => "Di bawah judul"
// pv.onBlur: "On blur" => "Saat buram"
// pv.onTyping: "While typing" => "Saat mengetik"
// pv.underRow: "Under the row" => "Di bawah baris"
// pv.underRowSingle: "Under the row, only one panel is visible" => "Di bawah baris, hanya satu panel yang terlihat"
// showNavigationButtons.none: "Hidden" => "Sembunyi"
// showProgressBar.off: "Hidden" => "Sembunyi"
// showTimerPanel.none: "Hidden" => "Sembunyi"
// showTimerPanelMode.all: "Both" => "Keduanya"
// detailPanelMode.none: "Hidden" => "Sembunyi"
// addRowLocation.default: "Depends on matrix layout" => "Tergantung pada tata letak matriks"
// panelsState.default: "Users cannot expand or collapse panels" => "Pengguna tidak dapat memperluas atau menciutkan panel"
// panelsState.collapsed: "All panels are collapsed" => "Semua panel diciutkan"
// panelsState.expanded: "All panels are expanded" => "Semua panel diperluas"
// widthMode.auto: "Auto" => "Auto"
// widthMode.static: "Static" => "Statis"
// widthMode.responsive: "Responsive" => "Responsif"
// imageFit.none: "None" => "Tidak"
// imageFit.contain: "Contain" => "Mengandung"
// imageFit.cover: "Cover" => "Menutupi"
// imageFit.fill: "Fill" => "Isi"
// contentMode.auto: "Auto" => "Auto"
// contentMode.image: "Image" => "Citra"
// contentMode.video: "Video" => "Video"
// contentMode.youtube: "YouTube" => "YouTube"
// displayMode.auto: "Auto" => "Auto"
// displayMode.buttons: "Buttons" => "Tombol"
// displayMode.dropdown: "Dropdown" => "Tarik-turun"
// rateColorMode.default: "Default" => "Default"
// autoGenerate.true: "Generate" => "Menghasilkan"
// autoGenerate.false: "Enter manually" => "Masukkan secara manual"
// rateType.labels: "Labels" => "Label"
// rateType.stars: "Stars" => "Bintang"
// rateType.smileys: "Smileys" => "Smiley"
// op.anyof: "Any of" => "Salah satu dari"
// op.allof: "All of" => "Semua"
// op.and: "and" => "dan"
// op.or: "or" => "atau"
// ew.modern: "Modern theme" => "Tema modern"
// ew.default: "Default theme" => "Tema default"
// ew.orange: "Orange theme" => "Tema oranye"
// ew.darkblue: "Darkblue theme" => "Tema biru tua"
// ew.darkrose: "Darkrose theme" => "Tema Darkrose"
// ew.stone: "Stone theme" => "Tema batu"
// ew.winter: "Winter theme" => "Tema musim dingin"
// ew.winterstone: "Winter-Stone theme" => "Tema Winter-Stone"
// ts.hideInvisibleElements: "Hide invisible elements" => "Sembunyikan elemen tak terlihat"
// triggers.skiptrigger: "Skip to question" => "Lanjut ke pertanyaan"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Cookie mencegah pengguna mengisi survei yang sama dua kali."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Mengubah ukuran area yang terlihat dari bidang input. Silakan gunakan pengaturan <b>Validasi → Panjang maksimum</b> untuk membatasi panjang input."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Gunakan {0} sebagai placeholder untuk nilai aktual."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Hanya terlihat bila setidaknya satu kolom memiliki Tipe total atau Ekspresi total."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Lihat deskripsi atribut [accept](https://www.w3schools.com/tags/att_input_accept.asp) untuk informasi selengkapnya."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Hanya berlaku untuk jenis sel Radiogroup dan Checkbox."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Lihat deskripsi atribut [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) untuk informasi selengkapnya."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Jika Anda tidak mengatur properti ini, jawabannya akan disimpan dalam bidang yang ditentukan oleh properti Name."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Jika kolom yang ditentukan berisi nilai yang identik, survei akan memunculkan kesalahan \"Nilai kunci tidak unik\"."
// p.multiSelect: "Allow multiple selection" => "Perbolehkan beberapa pilihan"
// p.showLabel: "Show image captions" => "Tampilkan keterangan gambar"
// p.value: "Value" => "Nilai"
// p.tabAlign: "Tab alignment" => "Perataan tab"
// p.logoFit: "Logo fit" => "Kecocokan logo"
// p.pages: "Pages" => "Halaman"
// p.questions: "Questions" => "Pertanyaan"
// p.calculatedValues: "Calculated values" => "Nilai terhitung"
// p.surveyId: "Survey id" => "ID survei"
// p.surveyPostId: "Survey post id" => "ID pos survei"
// p.surveyShowDataSaving: "Survey show data saving" => "Survei menunjukkan penghematan data"
// p.questionDescriptionLocation: "Question description location" => "Lokasi deskripsi pertanyaan"
// p.progressBarType: "Progress bar type" => "Jenis bilah kemajuan"
// p.showTOC: "Show TOC" => "Tampilkan TOC"
// p.tocLocation: "Toc location" => "Lokasi Toc"
// p.questionTitlePattern: "Question title pattern" => "Pola judul pertanyaan"
// p.widthMode: "Width mode" => "Mode lebar"
// p.showBrandInfo: "Show brand info" => "Tampilkan info merek"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "Menggunakan nilai tampilan dalam teks dinamis"
// p.descriptionLocation: "Description location" => "Deskripsi lokasi"
// p.defaultValueExpression: "Default value expression" => "Ekspresi nilai default"
// p.bindings: "Bindings" => "Binding"
// p.renderAs: "Render as" => "Render sebagai"
// p.attachOriginalItems: "Attach original items" => "Melampirkan item asli"
// p.cellHint: "Cell hint" => "Petunjuk sel"
// p.isUnique: "Is unique" => "Unik"
// p.showInMultipleColumns: "Show in multiple columns" => "Perlihatkan dalam beberapa kolom"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Total digit pecahan maksimum"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Total digit pecahan minimum"
// p.detailElements: "Detail elements" => "Elemen detail"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Izinkan tindakan adaptif"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "Panel detail menunjukkan pada menambahkan"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Pilihan lazy load diaktifkan"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Pilihan malas memuat ukuran halaman"
// p.inputFieldComponent: "Input field component" => "Komponen bidang input"
// p.itemComponent: "Item component" => "Komponen item"
// p.min: "Min" => "Min"
// p.max: "Max" => "Maks"
// p.minValueExpression: "Min value expression" => "Ekspresi nilai min"
// p.maxValueExpression: "Max value expression" => "Ekspresi nilai maksimum"
// p.step: "Step" => "Langkah"
// p.dataList: "Data list" => "Daftar data"
// p.elements: "Elements" => "Elemen"
// p.content: "Content" => "Puas"
// p.navigationTitle: "Navigation title" => "Judul navigasi"
// p.navigationDescription: "Navigation description" => "Deskripsi navigasi"
// p.longTap: "Long tap" => "Ketuk lama"
// p.autoGrow: "Auto grow" => "Tumbuh otomatis"
// p.allowResize: "Allow resizing" => "Izinkan pengubahan ukuran"
// p.acceptCarriageReturn: "Accept carriage return" => "Terima pengembalian kereta"
// p.displayMode: "Display mode" => "Mode tampilan"
// p.rateType: "Rate type" => "Jenis tarif"
// p.contentMode: "Content mode" => "Mode konten"
// p.imageFit: "Image fit" => "Kecocokan gambar"
// p.altText: "Alt text" => "Teks alternatif"
// p.height: "Height" => "Tinggi"
// p.penColor: "Pen color" => "Warna pena"
// p.backgroundColor: "Background color" => "Warna latar belakang"
// p.templateElements: "Template elements" => "Elemen template"
// p.operator: "Operator" => "Operator"
// p.isVariable: "Is variable" => "Adalah variabel"
// p.runExpression: "Run expression" => "Menjalankan ekspresi"
// p.showCaption: "Show caption" => "Tampilkan caption"
// p.iconName: "Icon name" => "Nama ikon"
// p.iconSize: "Icon size" => "Ukuran ikon"
// p.precision: "Precision" => "Presisi"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Area gagang seret matriks"
// p.backgroundImage: "Background image" => "Gambar latar belakang"
// p.backgroundImageFit: "Background image fit" => "Kecocokan gambar latar belakang"
// p.backgroundImageAttachment: "Background image attachment" => "Lampiran gambar latar belakang"
// p.backgroundOpacity: "Background opacity" => "Opasitas latar belakang"
// p.selectToRankEnabled: "Select to rank enabled" => "Pilih untuk peringkat diaktifkan"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Pilih untuk memberi peringkat tata letak area"
// p.allowCameraAccess: "Allow camera access" => "Izinkan akses kamera"
// p.scaleColorMode: "Scale color mode" => "Mode skala warna"
// p.rateColorMode: "Rate color mode" => "Mode warna tingkat"
// p.templateTabTitle: "Template tab title" => "Judul tab templat"
// p.templateVisibleIf: "Template visible if" => "Template terlihat jika"
// p.copyDisplayValue: "Copy display value" => "Salin nilai tampilan"
// theme.--background: "Background color" => "Warna latar belakang"
// theme.--background-dim-light: "Background dim light color" => "Latar belakang warna cahaya redup"
// theme.--primary-foreground: "Primary foreground color" => "Warna latar depan primer"
// theme.--foreground: "Foreground color" => "Warna latar depan"
// theme.--base-unit: "Base unit" => "Unit dasar"
// theme.groupAdvanced: "Advanced" => "Maju"
// theme.themeName: "Theme" => "Tema"
// theme.isPanellessss: "Question appearance" => "Penampilan pertanyaan"
// theme.isPanellessPanels: "Default" => "Default"
// theme.isPanellessLightweight: "Without Panels" => "Tanpa Panel"
// theme.themePaletteLight: "Light" => "Ringan"
// theme.themePaletteDark: "Dark" => "Gelap"
// theme.primaryColor: "Accent color" => "Warna aksen"
// theme.primaryDefaultColor: "Default" => "Default"
// theme.primaryDarkColor: "Hover" => "Hover"
// theme.primaryLightColor: "Selected" => "Dipilih"
// theme.backgroundDimColor: "Background color" => "Warna latar belakang"
// theme.backgroundImage: "Background image" => "Gambar latar belakang"
// theme.backgroundImageFitAuto: "Auto" => "Auto"
// theme.backgroundImageFitCover: "Cover" => "Menutupi"
// theme.backgroundImageFitContain: "Contain" => "Mengandung"
// theme.backgroundOpacity: "Opacity" => "Opacity"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Tetap"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Gulir"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Opasitas latar belakang panel"
// theme.questionBackgroundTransparency: "Question background opacity" => "Opasitas latar belakang pertanyaan"
// theme.questionPanel: "Panel background and corner radius" => "Latar belakang panel dan radius sudut"
// theme.questionTitle: "Question title font" => "Font judul pertanyaan"
// theme.questionDescription: "Question description font" => "Font deskripsi pertanyaan"
// theme.editorPanel: "Input element" => "Elemen input"
// theme.editorFont: "Input element font" => "Font elemen input"
// theme.backcolor: "Default background" => "Latar belakang default"
// theme.hovercolor: "Hover background" => "Arahkan kursor ke latar belakang"
// theme.borderDecoration: "Border decoration" => "Dekorasi perbatasan"
// theme.accentBackground: "Accent background" => "Latar belakang aksen"
// theme.accentForeground: "Accent foreground" => "Latar depan aksen"
// theme.primaryForecolor: "Default color" => "Warna default"
// theme.primaryForecolorLight: "Disabled color" => "Warna dinonaktifkan"
// theme.linesColors: "Minor line colors" => "Warna garis minor"
// theme.borderDefault: "Darker" => "Gelap"
// theme.borderLight: "Lighter" => "Ringan"
// theme.fontFamily: "Font family" => "Keluarga font"
// theme.fontSize: "Font size" => "Ukuran font"
// theme.color: "Color" => "Warna"
// theme.size: "Size" => "Tingginya"
// theme.fontWeightRegular: "Regular" => "Biasa"
// theme.fontWeightHeavy: "Heavy" => "Berat"
// theme.fontWeightSemiBold: "Semi-bold" => "Semi-tebal"
// theme.fontWeightBold: "Bold" => "Berani"
// theme.scale: "Scale" => "Sisik"
// theme.cornerRadius: "Corner radius" => "Radius sudut"
// theme.surveyTitleFont: "Survey title font" => "Font judul survei"
// theme.pageTitle: "Page title font" => "Font judul halaman"
// theme.pageDescription: "Page description font" => "Font deskripsi halaman"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Tambahkan Efek Bayangan"
// theme.opacity: "Opacity" => "Opacity"
// theme.boxShadowBlur: "Blur" => "Kabur"
// theme.boxShadowSpread: "Spread" => "Penyebaran"
// theme.boxShadowDrop: "Drop" => "Menjatuhkan"
// theme.boxShadowInner: "Inner" => "Batin"
// theme.questionShadow: "Shadow effects" => "Efek bayangan"
// theme.editorShadow: "Input element shadow effects" => "Efek bayangan elemen input"
// names.default: "Default" => "Default"
// names.contrast: "Contrast" => "Kontras"
// names.plain: "Plain" => "Polos"
// names.simple: "Simple" => "Sederhana"
// names.blank: "Blank" => "Kosong"
// names.double: "Double" => "Dobel"
// names.bulk: "Bulk" => "Massal"
// names.pseudo-3d: "Pseudo 3D" => "Semu 3D"
// names.playful: "Playful" => "Menyenangkan"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Teal"
// colors.blue: "Blue" => "Biru"
// colors.purple: "Purple" => "Ungu"
// colors.orchid: "Orchid" => "Anggrek"
// colors.tulip: "Tulip" => "Tulip"
// colors.brown: "Brown" => "Coklat"
// colors.green: "Green" => "Hijau"
// names.sharp: "Sharp" => "Tajam"
// names.borderless: "Borderless" => "Tanpa batas"
// names.flat: "Flat" => "Rata"
// names.doubleborder: "Double Border" => "Batas Ganda"
// names.layered: "Layered" => "Berlapis"
// names.solid: "Solid" => "Keras"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Apakah Anda yakin ingin menghapus semua string untuk bahasa ini?"
// ed.themeResetButton: "Reset theme settings to default" => "Setel ulang pengaturan tema ke default"
// theme.placeholderColor: "Placeholder color" => "Warna tempat penampung"
// ed.themeSettings: "Theme Settings" => "Pengaturan Tema"
// ed.themeSettingsTooltip: "Open theme settings" => "Buka pengaturan tema"
// pe.resetToDefaultCaption: "Reset" => "Reset"
// pv.file: "Local files" => "File lokal"
// pv.camera: "Camera" => "Kamera"
// pv.file-camera: "Local files or camera" => "File atau kamera lokal"
// ed.translateUsigAI: "Auto-translate All" => "Terjemahkan otomatis Semua"
// ed.translationDialogTitle: "Untranslated strings" => "String yang tidak diterjemahkan"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Harap masukkan setidaknya {0} item"
// lg.question_resetValueName: "Reset question value" => "Mereset nilai pertanyaan"
// lg.column_resetValue: "Reset column value" => "Mereset nilai kolom"
// pe.markRequired: "Mark as required" => "Tandai sesuai kebutuhan"
// pe.removeRequiredMark: "Remove the required mark" => "Hapus tanda yang diperlukan"
// p.resetValueIf: "Reset value if" => "Reset nilai jika"
// lg.question_setValueName: "Set question value" => "Tetapkan nilai pertanyaan"
// lg.column_resetValueName: "Reset column value" => "Mereset nilai kolom"
// lg.column_setValueName: "Set column value" => "Mengatur nilai kolom"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Ekspresi yang hasilnya akan ditetapkan ke pertanyaan target."
// survey.title: "Title" => "Titel"
// page.title: "Title" => "Titel"
// p.setValueIf: "Set value if" => "Tetapkan nilai jika"
// theme.header: "Header" => "Header"
// theme.backgroundImageFitFill: "Stretch" => "Merentangkan"
// theme.backgroundImageFitTile: "Tile" => "Ubin"
// theme.headerView: "View" => "Melihat"
// theme.headerViewBasic: "Basic" => "Dasar"
// theme.headerViewAdvanced: "Advanced" => "Maju"
// theme.headerInheritWidthFrom: "Content area width" => "Lebar area konten"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Sama seperti survei"
// theme.headerInheritWidthFromPage: "Fit to page" => "Paskan dengan halaman"
// theme.headerTextAreaWidth: "Text width" => "Lebar teks"
// theme.headerBackgroundColorSwitch: "Background color" => "Warna latar belakang"
// theme.headerBackgroundColorNone: "None" => "Tidak"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Warna aksen"
// theme.headerBackgroundColorCustom: "Custom" => "Adat"
// theme.horizontalAlignmentLeft: "Left" => "Kiri"
// theme.horizontalAlignmentCenter: "Center" => "Pusat"
// theme.horizontalAlignmentRight: "Right" => "Kanan"
// theme.verticalAlignmentTop: "Top" => "Puncak"
// theme.verticalAlignmentMiddle: "Middle" => "Tengah"
// theme.verticalAlignmentBottom: "Bottom" => "Dasar"
// lg.question_resetValueText: "reset value for question: {0}" => "reset nilai untuk pertanyaan: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Tetapkan nilai: {1} pertanyaan: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Setel ulang nilai sel untuk kolom: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Menetapkan nilai sel: {1} ke kolom: {0}"
// ed.surveyJsonExportButton: "Export" => "Ekspor"
// ed.surveyJsonImportButton: "Import" => "Mengimpor"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Salin ke papan klip"
// pe.filePlaceholder: "File placeholder text" => "Teks tempat penampung file"
// pe.photoPlaceholder: "Photo placeholder text" => "Teks placeholder foto"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Teks placeholder file atau foto"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Berlaku ketika \"Jenis sumber\" adalah \"File lokal\" atau ketika kamera tidak tersedia"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Berlaku ketika \"Jenis sumber\" adalah \"Kamera\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Berlaku ketika \"Jenis sumber\" adalah \"File atau kamera lokal\"."
// theme.background: "Background" => "Latar"
// theme.appearance: "Appearance" => "Rupa"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Apakah Anda benar-benar ingin mengatur ulang tema? Semua penyesuaian Anda akan hilang."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Ya, atur ulang tema"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Sesuai dengan kontainer"
// signaturepad.showPlaceholder: "Show the placeholder" => "Memperlihatkan tempat penampung"
// signaturepad.placeholder: "Placeholder text" => "Teks tempat penampung"
// theme.surveyDescriptionFont: "Survey description font" => "Font deskripsi survei"
// ed.prevFocus: "Focus previous" => "Fokus sebelumnya"
// ed.nextFocus: "Focus next" => "Fokus berikutnya"
// ed.saveTheme: "Save Theme" => "Simpan Tema"
// ed.saveThemeTooltip: "Save Theme" => "Simpan Tema"
// lg.page_requireName: "Make page required" => "Buat halaman diperlukan"
// lg.panel_requireName: "Make page required" => "Buat halaman diperlukan"
// signaturepad.signatureWidth: "Signature area width" => "Lebar area tanda tangan"
// signaturepad.signatureHeight: "Signature area height" => "Tinggi area tanda tangan"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Menskalakan area tanda tangan secara otomatis"
// signaturepad.penMinWidth: "Minimum pen width" => "Lebar pena minimum"
// signaturepad.penMaxWidth: "Maximum pen width" => "Lebar pena maksimum"
// theme.logoPosition: "Logo position" => "Posisi logo"
// theme.headerTitlePosition: "Title position" => "Posisi judul"
// theme.headerDescriptionPosition: "Description position" => "Deskripsi posisi"
// ed.propertyGridNoResultsFound: "No results found" => "Tidak ada hasil yang ditemukan"
// pv.leftRight: "Left and right" => "Kiri dan kanan"
// p.sourceType: "Source type" => "Jenis sumber"
// p.fitToContainer: "Fit to container" => "Sesuai dengan kontainer"
// p.setValueExpression: "Set value expression" => "Mengatur ekspresi nilai"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Pilihan dimuat dari layanan web."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Buka pengaturan"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Pratinjau opsi pilihan yang dimuat"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Mencegah respons duplikat dalam baris"
// theme.advancedMode: "Advanced mode" => "Mode lanjutan"
// theme.backgroundCornerRadius: "Background and corner radius" => "Latar belakang dan radius sudut"
// theme.colorsTitle: "Colors" => "Warna"
// theme.font: "Font" => "Font"
// theme.lines: "Lines" => "Baris"
// theme.titleFont: "Title font" => "Font judul"
// theme.descriptionFont: "Description font" => "Font deskripsi"
// theme.shadow: "Shadow effects" => "Efek bayangan"
// ed.translateUsigAIFrom: "Translate from: " => "Terjemahkan dari: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Perbolehkan opsi Tolak Jawab"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Perbolehkan opsi Tidak Tahu"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Perbolehkan opsi Tolak Jawab"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Perbolehkan opsi Tidak Tahu"
// pv.contain: "Contain" => "Mengandung"
// pv.cover: "Cover" => "Menutupi"
// pv.fill: "Fill" => "Isi"
// pe.transposeData: "Transpose rows to columns" => "Mengubah urutan baris menjadi kolom"
// layout.panel: "Layout" => "Tata letak"
// layout.question: "Layout" => "Tata letak"
// layout.base: "Layout" => "Tata letak"
// panel.name: "Panel name" => "Nama panel"
// panel.title: "Panel title" => "Judul panel"
// panel.description: "Panel description" => "Deskripsi panel"
// panel.visibleIf: "Make the panel visible if" => "Buat panel terlihat jika"
// panel.requiredIf: "Make the panel required if" => "Buat panel diperlukan jika"
// panel.questionsOrder: "Question order within the panel" => "Urutan pertanyaan dalam panel"
// panel.startWithNewLine: "Display the panel on a new line" => "Menampilkan panel pada baris baru"
// panel.state: "Panel collapse state" => "Status keruntuhan panel"
// panel.width: "Inline panel width" => "Lebar panel sejajar"
// panel.minWidth: "Minimum panel width" => "Lebar panel minimum"
// panel.maxWidth: "Maximum panel width" => "Lebar panel maksimum"
// panel.showNumber: "Number panels" => "Panel angka"
// paneldynamic.name: "Panel name" => "Nama panel"
// paneldynamic.title: "Panel title" => "Judul panel"
// paneldynamic.description: "Panel description" => "Deskripsi panel"
// paneldynamic.visibleIf: "Make the panel visible if" => "Buat panel terlihat jika"
// paneldynamic.requiredIf: "Make the panel required if" => "Buat panel diperlukan jika"
// paneldynamic.page: "Move the panel to page" => "Memindahkan panel ke halaman"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Menampilkan panel pada baris baru"
// paneldynamic.state: "Panel collapse state" => "Status keruntuhan panel"
// paneldynamic.width: "Inline panel width" => "Lebar panel sejajar"
// paneldynamic.minWidth: "Minimum panel width" => "Lebar panel minimum"
// paneldynamic.maxWidth: "Maximum panel width" => "Lebar panel maksimum"
// paneldynamic.templateDescription: "Panel description pattern" => "Pola deskripsi panel"
// paneldynamic.templateTitle: "Panel title pattern" => "Pola judul panel"
// paneldynamic.noEntriesText: "Empty panel text" => "Teks panel kosong"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Pola judul tab"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Membuat panel individual terlihat jika"
// paneldynamic.hideNumber: "Hide the panel number" => "Menyembunyikan nomor panel"
// paneldynamic.titleLocation: "Panel title alignment" => "Perataan judul panel"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Perataan deskripsi panel"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Perataan judul pertanyaan"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Perataan pesan kesalahan"
// paneldynamic.newPanelPosition: "New panel location" => "Lokasi panel baru"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Cegah respons duplikat dalam pertanyaan berikut"
// question.name: "Question name" => "Nama pertanyaan"
// question.title: "Question title" => "Judul pertanyaan"
// question.description: "Question description" => "Deskripsi pertanyaan"
// question.visibleIf: "Make the question visible if" => "Buat pertanyaan terlihat jika"
// question.requiredIf: "Make the question required if" => "Buat pertanyaan diperlukan jika"
// question.state: "Question box collapse state" => "Status ciutkan kotak pertanyaan"
// question.hideNumber: "Hide the question number" => "Menyembunyikan nomor pertanyaan"
// question.titleLocation: "Question title alignment" => "Perataan judul pertanyaan"
// question.descriptionLocation: "Question description alignment" => "Perataan deskripsi pertanyaan"
// question.errorLocation: "Error message alignment" => "Perataan pesan kesalahan"
// question.indent: "Increase the inner indent" => "Tingkatkan indentasi batin"
// question.width: "Inline question width" => "Lebar pertanyaan sebaris"
// question.minWidth: "Minimum question width" => "Lebar pertanyaan minimum"
// question.maxWidth: "Maximum question width" => "Lebar pertanyaan maksimum"
// question.textUpdateMode: "Update input field value" => "Perbarui nilai bidang input"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Perlihatkan tombol Hapus di dalam area tanda tangan"
// signaturepad.penColor: "Stroke color" => "Warna goresan"
// comment.rows: "Input field height (in lines)" => "Tinggi bidang input (dalam baris)"
// expression.name: "Expression name" => "Nama ekspresi"
// expression.title: "Expression title" => "Judul ekspresi"
// expression.description: "Expression description" => "Deskripsi ekspresi"
// expression.expression: "Expression" => "Ekspresi"
// trigger.expression: "Expression" => "Ekspresi"
// calculatedvalue.expression: "Expression" => "Ekspresi"
// survey.description: "Survey description" => "Deskripsi survei"
// page.name: "Page name" => "Nama halaman"
// page.description: "Page description" => "Deskripsi halaman"
// page.visibleIf: "Make the page visible if" => "Membuat halaman terlihat jika"
// page.requiredIf: "Make the page required if" => "Buat halaman diperlukan jika"
// page.questionsOrder: "Question order on the page" => "Urutan pertanyaan di halaman"
// matrixdropdowncolumn.name: "Column name" => "Nama kolom"
// matrixdropdowncolumn.title: "Column title" => "Judul kolom"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Mencegah respons duplikat"
// matrixdropdowncolumn.width: "Column width" => "Lebar kolom"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Lebar kolom minimum"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Tinggi bidang input (dalam baris)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Membuat kolom terlihat jika"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Buat kolom diperlukan jika"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Setiap opsi dalam kolom terpisah"
// multipletextitem.name: "Name" => "Nama"
// multipletextitem.title: "Title" => "Titel"
// pe.rateDescriptionLocation: "Label alignment" => "Perataan label"
// pe.cellErrorLocation: "Cell error message alignment" => "Perataan pesan kesalahan sel"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Anda belum memiliki kolom apa pun"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Anda belum memiliki baris"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Anda belum memiliki aturan validasi apa pun"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Anda belum memiliki variabel khusus"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Anda belum memiliki pemicu apa pun"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Anda belum memiliki tautan apa pun"
// pe.addNew@columns: "Add new column" => "Tambahkan kolom baru"
// pe.addNew@rows: "Add new row" => "Menambahkan baris baru"
// pe.addNew@validators: "Add new rule" => "Tambahkan aturan baru"
// pe.addNew@calculatedValues: "Add new variable" => "Tambahkan variabel baru"
// pe.addNew@triggers: "Add new trigger" => "Tambahkan pemicu baru"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Tambahkan URL baru"
// choicesbyurl.url: "Web service's URL" => "URL layanan web"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Menampilkan judul halaman di bilah kemajuan"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Menampilkan nomor halaman di bilah kemajuan"
// itemvalue.visibleIf: "Make the option visible if" => "Buat opsi terlihat jika"
// itemvalue.enableIf: "Make the option selectable if" => "Buat opsi dapat dipilih jika"
// panel.layout: "Panel Layout" => "Tata Letak Panel"
// tabs.questionSettings: "Question Settings" => "Pengaturan Pertanyaan"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Mis.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Mis.: categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Mis.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Contoh: 6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "Contoh: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Contoh: 50%"
// pv.selected: "Selected" => "Dipilih"
// pv.unselected: "Unselected" => "Tidak dipilih"
// pv.center: "Center" => "Pusat"
// pv.middle: "Middle" => "Tengah"
// pv.next: "Next" => "Depan"
// pv.last: "Last" => "Terakhir"
// clearIfInvisible.none: "Never" => "Tidak pernah"
// questionsOnPageMode.standard: "Original structure" => "Struktur asli"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Tampilkan semua pertanyaan di satu halaman"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Tampilkan pertanyaan tunggal per halaman"
// pv.auto: "Auto" => "Auto"
// panelsState.firstExpanded: "First expanded" => "Pertama diperluas"
// rateColorMode.scale: "Scale" => "Sisik"
// scaleColorMode.monochrome: "Monochrome" => "Monokrom"
// scaleColorMode.colored: "Colored" => "Berwarna"
// state.default: "Locked" => "Terkunci"
// showQuestionNumbers.default: "Auto-numbering" => "Penomoran otomatis"
// showQuestionNumbers.on: "Auto-numbering" => "Penomoran otomatis"
// showQuestionNumbers.onPage: "Reset on each page" => "Setel ulang di setiap halaman"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Setel ulang pada setiap panel"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Setel ulang pada setiap panel"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Lanjutkan di seluruh survei"
// showQuestionNumbers.off: "No numbering" => "Tanpa penomoran"
// descriptionLocation.underTitle: "Under the question title" => "Di bawah judul pertanyaan"
// descriptionLocation.underInput: "Under the input field" => "Di bawah bidang input"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Di samping pilihan"
// selectToRankAreasLayout.vertical: "Above choices" => "Pilihan di atas"
// displayStyle.decimal: "Decimal" => "Desimal"
// displayStyle.currency: "Currency" => "Mata uang"
// displayStyle.percent: "Percentage" => "Persentase"
// displayStyle.date: "Date" => "Tanggal"
// totalDisplayStyle.decimal: "Decimal" => "Desimal"
// totalDisplayStyle.currency: "Currency" => "Mata uang"
// totalDisplayStyle.percent: "Percentage" => "Persentase"
// totalDisplayStyle.date: "Date" => "Tanggal"
// rowsOrder.initial: "Original" => "Asli"
// questionsOrder.initial: "Original" => "Asli"
// showProgressBar.aboveheader: "Above the header" => "Di atas header"
// showProgressBar.belowheader: "Below the header" => "Di bawah header"
// pv.sum: "Sum" => "Jumlah"
// pv.count: "Count" => "Hitung"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Maks"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Berisi"
// searchMode.startsWith: "Starts with" => "Dimulai dengan"
// panel.name: "A panel ID that is not visible to respondents." => "ID panel yang tidak terlihat oleh responden."
// panel.description: "Type a panel subtitle." => "Ketik subtitle panel."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang menentukan visibilitas panel."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menonaktifkan mode baca-saja untuk panel."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang mencegah pengiriman survei kecuali setidaknya satu pertanyaan bertingkat memiliki jawaban."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Berlaku untuk semua pertanyaan dalam panel ini. Jika Anda ingin mengganti setelan ini, tentukan aturan perataan judul untuk masing-masing pertanyaan. Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei (\"Teratas\" secara default)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Mengatur lokasi pesan kesalahan sehubungan dengan semua pertanyaan dalam panel. Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Menyimpan urutan pertanyaan asli atau mengacaknya. Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei."
// panel.page: "Repositions the panel to the end of a selected page." => "Memposisikan ulang panel ke akhir halaman yang dipilih."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Menambahkan spasi atau margin antara konten panel dan batas kiri kotak panel."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Batalkan pilihan untuk menampilkan panel dalam satu baris dengan pertanyaan atau panel sebelumnya. Pengaturan tidak berlaku jika panel adalah elemen pertama dalam formulir Anda."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Pilih dari: \"Diperluas\" - panel ditampilkan secara penuh dan dapat diciutkan; \"Collapsed\" - panel hanya menampilkan judul dan deskripsi dan dapat diperluas; \"Terkunci\" - panel ditampilkan secara penuh dan tidak dapat diciutkan."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Mengatur lebar panel secara proporsional dengan elemen survei lainnya di baris yang sama. Menerima nilai CSS (px, %, in, pt, dll.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "ID panel yang tidak terlihat oleh responden."
// paneldynamic.description: "Type a panel subtitle." => "Ketik subtitle panel."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang menentukan visibilitas panel."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menonaktifkan mode baca-saja untuk panel."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang mencegah pengiriman survei kecuali setidaknya satu pertanyaan bertingkat memiliki jawaban."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Berlaku untuk semua pertanyaan dalam panel ini. Jika Anda ingin mengganti setelan ini, tentukan aturan perataan judul untuk masing-masing pertanyaan. Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei (\"Teratas\" secara default)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Mengatur lokasi pesan kesalahan sehubungan dengan pertanyaan dengan input yang tidak valid. Pilih antara: \"Atas\" - teks kesalahan ditempatkan di bagian atas kotak pertanyaan; \"Bawah\" - teks kesalahan ditempatkan di bagian bawah kotak pertanyaan. Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei (\"Teratas\" secara default)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Mengatur lokasi pesan kesalahan sehubungan dengan semua pertanyaan dalam panel. Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Memposisikan ulang panel ke akhir halaman yang dipilih."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Menambahkan spasi atau margin antara konten panel dan batas kiri kotak panel."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Batalkan pilihan untuk menampilkan panel dalam satu baris dengan pertanyaan atau panel sebelumnya. Pengaturan tidak berlaku jika panel adalah elemen pertama dalam formulir Anda."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Pilih dari: \"Diperluas\" - panel ditampilkan secara penuh dan dapat diciutkan; \"Collapsed\" - panel hanya menampilkan judul dan deskripsi dan dapat diperluas; \"Terkunci\" - panel ditampilkan secara penuh dan tidak dapat diciutkan."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Mengatur lebar panel secara proporsional dengan elemen survei lainnya di baris yang sama. Menerima nilai CSS (px, %, in, pt, dll.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Ketik template untuk judul panel dinamis. Gunakan {panelIndex} untuk posisi umum panel dan {visiblePanelIndex} untuk urutannya di antara panel yang terlihat. Masukkan tempat penampung ini ke dalam pola untuk menambahkan penomoran otomatis."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Ketik templat untuk judul tab. Gunakan {panelIndex} untuk posisi umum panel dan {visiblePanelIndex} untuk urutannya di antara panel yang terlihat. Masukkan tempat penampung ini ke dalam pola untuk menambahkan penomoran otomatis."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Pengaturan ini memungkinkan Anda mengontrol visibilitas masing-masing panel dalam panel dinamis. Gunakan placeholder '{panel}' untuk mereferensikan panel saat ini dalam ekspresi Anda."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Setelan ini secara otomatis diwarisi oleh semua pertanyaan dalam panel ini. Jika Anda ingin mengganti setelan ini, tentukan aturan perataan judul untuk masing-masing pertanyaan. Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei (\"Teratas\" secara default)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "Opsi \"Warisi\" menerapkan setelan tingkat halaman (jika ditetapkan) atau tingkat survei (\"Di bawah judul panel\" secara default)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Menentukan posisi panel yang baru ditambahkan. Secara default, panel baru ditambahkan ke akhir. Pilih \"Next\" untuk memasukkan panel baru setelah yang sekarang."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Menduplikasi jawaban dari panel terakhir dan menetapkannya ke panel dinamis tambahan berikutnya."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Rujuk nama pertanyaan untuk mengharuskan pengguna memberikan respons unik untuk pertanyaan ini di setiap panel."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Pengaturan ini memungkinkan Anda menetapkan nilai jawaban default berdasarkan ekspresi. Ekspresi dapat mencakup perhitungan dasar - '{q1_id} + {q2_id}', ekspresi Boolean, seperti '{age} > 60', dan fungsi: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', dll. Nilai yang ditentukan oleh ekspresi ini berfungsi sebagai nilai default awal yang dapat ditimpa oleh input manual responden."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menentukan kapan input responden diatur ulang ke nilai berdasarkan \"Ekspresi nilai default\" atau \"Atur ekspresi nilai\" atau ke nilai \"Jawaban default\" (jika salah satu diatur)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menentukan kapan harus menjalankan \"Atur ekspresi nilai\" dan secara dinamis menetapkan nilai yang dihasilkan sebagai respons."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Tentukan ekspresi yang menentukan nilai yang akan ditetapkan saat kondisi dalam aturan \"Tetapkan nilai jika\" terpenuhi. Ekspresi dapat mencakup perhitungan dasar - '{q1_id} + {q2_id}', ekspresi Boolean, seperti '{age} > 60', dan fungsi: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', dll. Nilai yang ditentukan oleh ekspresi ini dapat ditimpa oleh input manual responden."
// question.name: "A question ID that is not visible to respondents." => "ID pertanyaan yang tidak terlihat oleh responden."
// question.description: "Type a question subtitle." => "Ketik subtitle pertanyaan."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang menentukan visibilitas pertanyaan."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang menonaktifkan mode baca-saja untuk pertanyaan."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang mencegah survei maju atau dikirim kecuali pertanyaan menerima jawaban."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Batalkan pilihan untuk menampilkan pertanyaan dalam satu baris dengan pertanyaan atau panel sebelumnya. Pengaturan tidak berlaku jika pertanyaan adalah elemen pertama dalam formulir Anda."
// question.page: "Repositions the question to the end of a selected page." => "Memposisikan ulang pertanyaan ke akhir halaman yang dipilih."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Pilih dari: \"Diperluas\" - kotak pertanyaan ditampilkan secara penuh dan dapat diciutkan; \"Diciutkan\" - kotak pertanyaan hanya menampilkan judul dan deskripsi dan dapat diperluas; \"Terkunci\" - kotak pertanyaan ditampilkan secara penuh dan tidak dapat diciutkan."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Mengganti aturan penyelarasan judul yang ditentukan pada tingkat panel, halaman, atau survei. Opsi \"Warisi\" menerapkan pengaturan tingkat yang lebih tinggi (jika diatur) atau pengaturan tingkat survei (\"Atas\" secara default)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "Opsi \"Warisi\" menerapkan setelan tingkat survei (\"Di bawah judul pertanyaan\" secara default)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Mengatur lokasi pesan kesalahan sehubungan dengan pertanyaan dengan input yang tidak valid. Pilih antara: \"Atas\" - teks kesalahan ditempatkan di bagian atas kotak pertanyaan; \"Bawah\" - teks kesalahan ditempatkan di bagian bawah kotak pertanyaan. Opsi \"Warisi\" menerapkan setelan tingkat survei (\"Teratas\" secara default)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Menambahkan spasi atau margin antara konten pertanyaan dan batas kiri kotak pertanyaan."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Mengatur lebar pertanyaan secara proporsional dengan elemen survei lain di baris yang sama. Menerima nilai CSS (px, %, in, pt, dll.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Gunakan ikon tongkat ajaib untuk menetapkan aturan validasi untuk pertanyaan."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Pilih dari: \"On lost focus\" - nilai diperbarui ketika bidang input kehilangan fokus; \"Saat mengetik\" - nilainya diperbarui secara real-time, saat pengguna mengetik. Opsi \"Warisi\" menerapkan pengaturan tingkat survei (\"Pada fokus yang hilang\" secara default)."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Anda dapat menggunakan layanan web apa pun sebagai sumber data untuk pertanyaan pilihan ganda. Untuk mengisi nilai pilihan, masukkan URL layanan yang menyediakan data."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Operasi perbandingan yang digunakan untuk memfilter daftar turun bawah."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Mengatur lebar area tanda tangan yang ditampilkan dan gambar yang dihasilkan."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Mengatur ketinggian area tanda tangan yang ditampilkan dan gambar yang dihasilkan."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Pilih apakah Anda ingin area tanda tangan mengisi semua ruang yang tersedia di dalam kotak pertanyaan sambil mempertahankan rasio aspek default 3:2. Saat nilai lebar dan tinggi kustom ditetapkan, pengaturan akan mempertahankan rasio aspek dimensi ini."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Menyesuaikan tinggi gambar dalam hasil survei."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Menyesuaikan lebar gambar dalam hasil survei."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Mengganti nilai tinggi minimum dan maksimum."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Mengganti nilai lebar minimum dan maksimum."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Nilai\" berfungsi sebagai ID item yang digunakan dalam aturan bersyarat; \"Teks\" ditampilkan kepada responden."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Pengaturan ini hanya mengubah ukuran bidang input dan tidak memengaruhi lebar kotak pertanyaan. Untuk membatasi panjang input yang diterima, buka <b>Validasi → Batas karakter maksimum</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Mengatur jumlah baris yang ditampilkan di bidang input. Jika input mengambil lebih banyak baris, bilah gulir akan muncul."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Pilih antara: \"Dapat Diedit\" - memungkinkan responden mengisi survei Anda; \"Read-only\" - menonaktifkan pengeditan formulir."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "ID kolom yang tidak terlihat oleh responden."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Saat diaktifkan untuk kolom, responden diharuskan memberikan respons unik untuk setiap pertanyaan dalam kolom ini."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Mengatur jumlah baris yang ditampilkan di bidang input. Jika input mengambil lebih banyak baris, bilah gulir akan muncul."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menentukan visibilitas kolom."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menonaktifkan mode baca-saja untuk kolom."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang mencegah pengiriman survei kecuali setidaknya satu pertanyaan bertingkat memiliki jawaban."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Saat dipilih, buat kolom individual untuk setiap opsi pilihan."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Pilih dari: \"Statis\" - menetapkan lebar tetap; \"Responsif\" - membuat survei menempati lebar penuh layar; \"Otomatis\" - berlaku salah satu dari keduanya tergantung pada jenis pertanyaan yang digunakan."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Tempel tautan gambar (tanpa batas ukuran) atau klik ikon folder untuk menelusuri file dari komputer Anda (hingga 64 KB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Mengatur lebar logo dalam satuan CSS (px, %, in, pt, dll.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Mengatur tinggi logo dalam satuan CSS (px, %, in, pt, dll.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Pilih dari: \"Tidak ada\" - gambar mempertahankan ukuran aslinya; \"Berisi\" - gambar diubah ukurannya agar pas dengan tetap mempertahankan rasio aspeknya; \"Cover\" - gambar mengisi seluruh kotak sambil mempertahankan rasio aspeknya; \"Isi\" - gambar direntangkan untuk mengisi kotak tanpa mempertahankan rasio aspeknya."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Pilih apakah Anda ingin survei maju ke halaman berikutnya secara otomatis setelah responden menjawab semua pertanyaan di halaman saat ini."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Mengatur visibilitas dan lokasi tombol navigasi pada halaman."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Mengatur visibilitas dan lokasi bilah kemajuan. Nilai \"Otomatis\" menampilkan bilah kemajuan di atas atau di bawah header survei."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Aktifkan halaman pratinjau hanya dengan semua atau pertanyaan yang dijawab."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Berlaku untuk semua pertanyaan dalam survei. Setelan ini dapat diganti dengan aturan penyelarasan judul di tingkat yang lebih rendah: panel, halaman, atau pertanyaan. Pengaturan tingkat yang lebih rendah akan menggantikan pengaturan tingkat yang lebih tinggi."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Simbol atau urutan simbol yang menunjukkan bahwa jawaban diperlukan."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Masukkan angka atau huruf yang ingin Anda gunakan untuk memulai penomoran."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Mengatur lokasi pesan kesalahan sehubungan dengan pertanyaan dengan input yang tidak valid. Pilih antara: \"Atas\" - teks kesalahan ditempatkan di bagian atas kotak pertanyaan; \"Bawah\" - teks kesalahan ditempatkan di bagian bawah kotak pertanyaan."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Pilih apakah Anda ingin bidang input pertama pada setiap halaman siap untuk entri teks."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Menyimpan urutan pertanyaan asli atau mengacaknya. Efek pengaturan ini hanya terlihat di tab Pratinjau."
// pehelp.maxTextLength: "For text entry questions only." => "Hanya untuk pertanyaan entri teks."
// pehelp.maxOthersLength: "For question comments only." => "Hanya untuk komentar pertanyaan."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Pilih apakah Anda ingin komentar pertanyaan dan pertanyaan Teks Panjang bertambah tinggi secara otomatis berdasarkan panjang teks yang dimasukkan."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Hanya untuk komentar pertanyaan dan pertanyaan Teks Panjang."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Variabel kustom berfungsi sebagai variabel perantara atau tambahan yang digunakan dalam perhitungan formulir. Mereka mengambil input responden sebagai nilai sumber. Setiap variabel kustom memiliki nama unik dan ekspresi yang menjadi dasarnya."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Pilih apakah Anda ingin nilai terhitung ekspresi disimpan bersama dengan hasil survei."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Pemicu adalah peristiwa atau kondisi yang didasarkan pada ekspresi. Setelah ekspresi dievaluasi ke \"true\", pemicu memicu tindakan. Tindakan semacam itu secara opsional dapat memiliki pertanyaan target yang dipengaruhinya."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Pilih apakah akan menghapus nilai untuk pertanyaan yang disembunyikan oleh logika kondisional atau tidak dan kapan melakukannya."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Pilih dari: \"On lost focus\" - nilai diperbarui ketika bidang input kehilangan fokus; \"Saat mengetik\" - nilainya diperbarui secara real-time, saat pengguna mengetik."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Nilai kiri berfungsi sebagai ID kolom yang digunakan dalam aturan bersyarat, nilai kanan ditampilkan kepada responden."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Nilai kiri berfungsi sebagai ID baris yang digunakan dalam aturan bersyarat, nilai kanan ditampilkan kepada responden."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Menerima nilai CSS (px, %, in, pt, dll.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Menerima nilai CSS (px, %, in, pt, dll.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Mengatur lokasi pesan kesalahan dalam kaitannya dengan sel dengan input yang tidak valid. Opsi \"Warisi\" menerapkan pengaturan dari properti \"Perataan pesan kesalahan\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Ketika properti \"mencegah duplikat respons\" diaktifkan, responden mencoba untuk mengirimkan entri duplikat akan menerima pesan galat berikut."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Memungkinkan Anda menghitung nilai total berdasarkan ekspresi. Ekspresi dapat mencakup perhitungan dasar ('{q1_id} + {q2_id}'), ekspresi Boolean ('{age} > 60') dan fungsi ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', dll.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Memicu prompt yang meminta konfirmasi penghapusan baris."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Menduplikasi jawaban dari baris terakhir dan menetapkannya ke baris dinamis berikutnya yang ditambahkan."
// pehelp.description: "Type a subtitle." => "Ketik subtitle."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Pilih bahasa untuk mulai membuat survei. Untuk menambahkan terjemahan, beralihlah ke bahasa baru dan terjemahkan teks asli di sini atau di tab Terjemahan."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Mengatur lokasi bagian detail dalam kaitannya dengan baris. Pilih dari: \"Tidak ada\" - tidak ada ekspansi yang ditambahkan; \"Di bawah baris\" - ekspansi baris ditempatkan di bawah setiap baris matriks; \"Di bawah baris, tampilkan satu baris ekspansi saja\" - ekspansi ditampilkan di bawah satu baris saja, ekspansi baris yang tersisa diciutkan."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Pilih dari: \"Tidak ada\" - gambar mempertahankan ukuran aslinya; \"Berisi\" - gambar diubah ukurannya agar pas dengan tetap mempertahankan rasio aspeknya; \"Cover\" - gambar mengisi seluruh kotak sambil mempertahankan rasio aspeknya; \"Isi\" - gambar direntangkan untuk mengisi kotak tanpa mempertahankan rasio aspeknya."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Secara bertahap meningkatkan ketinggian bidang input saat data dimasukkan. Mengganti setelan \"Tinggi bidang input (dalam baris)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Gagang pengubah ukuran (atau pegangan) muncul di sudut dan dapat diseret untuk mengubah ukuran bidang input."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Interval waktu dalam hitungan detik setelah survei maju secara otomatis ke halaman Terima Kasih."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Interval waktu dalam hitungan detik setelah survei maju secara otomatis ke halaman berikutnya."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Interval waktu dalam hitungan detik setelah survei maju secara otomatis ke halaman berikutnya."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang menentukan visibilitas halaman."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menonaktifkan mode baca-saja untuk halaman."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Gunakan ikon tongkat ajaib untuk menetapkan aturan bersyarat yang mencegah pengiriman survei kecuali setidaknya satu pertanyaan bertingkat memiliki jawaban."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Berlaku untuk semua pertanyaan dalam halaman ini. Jika Anda ingin mengganti setelan ini, tentukan aturan perataan judul untuk masing-masing pertanyaan atau panel. Opsi \"Warisi\" menerapkan setelan tingkat survei (\"Teratas\" secara default)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Mengatur lokasi pesan kesalahan sehubungan dengan pertanyaan dengan input yang tidak valid. Pilih antara: \"Atas\" - teks kesalahan ditempatkan di bagian atas kotak pertanyaan; \"Bawah\" - teks kesalahan ditempatkan di bagian bawah kotak pertanyaan. Opsi \"Warisi\" menerapkan setelan tingkat survei (\"Teratas\" secara default)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Menyimpan urutan pertanyaan asli atau mengacaknya. Opsi \"Warisi\" menerapkan setelan tingkat survei (\"Asli\" secara default). Efek pengaturan ini hanya terlihat di tab Pratinjau."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Mengatur visibilitas tombol navigasi di halaman. Opsi \"Warisi\" menerapkan pengaturan tingkat survei, yang defaultnya adalah \"Terlihat\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Mengatur visibilitas dan lokasi timer pada halaman."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Pilih dari: \"Terkunci\" - pengguna tidak dapat memperluas atau menciutkan panel; \"Runtuhkan semua\" - semua panel dimulai dalam keadaan diciutkan; \"Perluas semua\" - semua panel dimulai dalam keadaan diperluas; \"Pertama diperluas\" - hanya panel pertama yang awalnya diperluas."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Masukkan nama properti bersama dalam array objek yang berisi URL file gambar atau video yang ingin Anda tampilkan di daftar pilihan."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Nilai kiri berfungsi sebagai ID item yang digunakan dalam aturan bersyarat, nilai yang tepat ditampilkan kepada responden."
// pehelp.title: "Type a user-friendly title to display." => "Ketik judul yang mudah digunakan untuk ditampilkan."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Memastikan bahwa pengguna tidak akan menyelesaikan survei sampai file diunggah."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Menerima nilai CSS (px, %, in, pt, dll.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Menerima nilai CSS (px, %, in, pt, dll.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Menerima nilai CSS (px, %, in, pt, dll.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "Dalam tipe pertanyaan pilihan tunggal dan ganda, setiap opsi pilihan memiliki ID dan nilai tampilan. Saat dipilih, setelan ini akan menampilkan nilai tampilan, bukan nilai ID dalam pertanyaan HTML serta judul dinamis dan deskripsi elemen survei."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Pilih apakah akan menghapus nilai pertanyaan yang disembunyikan oleh logika kondisional atau tidak dan kapan melakukannya. Opsi \"Warisi\" menerapkan setelan tingkat survei (\"Setelah survei selesai\" secara default)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Pilih dari: \"Semua\" - menyalin semua opsi pilihan dari pertanyaan yang dipilih; \"Dipilih\" - secara dinamis menyalin hanya opsi pilihan yang dipilih; \"Tidak dipilih\" - secara dinamis hanya menyalin opsi pilihan yang tidak dipilih. Opsi \"Tidak Ada\" dan \"Lainnya\" disalin secara default jika diaktifkan dalam pertanyaan sumber."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Saat dipilih, pengguna dapat menyertakan input tambahan di kotak komentar terpisah."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Menampilkan setiap opsi pilihan khusus (\"Tidak Ada\", \"Lainnya\", \"Pilih Semua\") pada baris baru, bahkan saat menggunakan tata letak beberapa kolom."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Tentukan lokasi dalam himpunan data layanan tempat array objek target berada. Biarkan kosong jika URL sudah menunjuk ke array."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Masukkan nama properti seragam dalam array objek yang berisi nilai yang ingin Anda tampilkan di daftar pilihan."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Pilih untuk mengizinkan layanan mengembalikan respons atau array kosong."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Gunakan ikon tongkat ajaib untuk mengatur aturan bersyarat yang menentukan visibilitas semua opsi pilihan."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Nilai kiri berfungsi sebagai ID item yang digunakan dalam aturan bersyarat, nilai yang tepat ditampilkan kepada responden."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Otomatis\" memilih antara mode \"Tombol\" dan \"Tarik-turun\" berdasarkan lebar yang tersedia. Ketika lebar tidak cukup untuk menampilkan tombol, pertanyaan menampilkan dropdown."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Memungkinkan Anda menghubungkan pertanyaan yang menghasilkan hasil dalam berbagai format. Saat pertanyaan tersebut ditautkan bersama menggunakan ID gabungan, properti bersama ini akan menyimpan nilai pertanyaan yang dipilih."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Pilih apakah Anda ingin memperbarui konten menu drop-down agar sesuai dengan kueri pencarian yang diketik pengguna di bidang input."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Nilai yang harus disimpan dalam hasil survei ketika responden memberikan jawaban positif."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Nilai untuk disimpan dalam hasil survei ketika responden memberikan jawaban negatif."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Tidak disarankan untuk menonaktifkan opsi ini karena menimpa gambar Pratinjau dan menyulitkan pengguna untuk memahami apakah file telah diunggah."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Memicu prompt yang meminta konfirmasi penghapusan file."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Aktifkan untuk memberi peringkat hanya pada pilihan yang dipilih. Pengguna akan menyeret item yang dipilih dari daftar pilihan untuk memesannya di dalam area peringkat."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Masukkan daftar pilihan yang akan disarankan kepada responden saat masukan."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Pengaturan hanya mengubah ukuran bidang input dan tidak memengaruhi lebar kotak pertanyaan."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Mengatur lebar yang konsisten untuk semua label item dalam piksel"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Opsi \"Otomatis\" secara otomatis menentukan mode yang sesuai untuk tampilan - Gambar, Video, atau YouTube - berdasarkan URL sumber yang disediakan."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Berfungsi sebagai pengganti ketika gambar tidak dapat ditampilkan pada perangkat pengguna dan untuk tujuan aksesibilitas."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Menentukan warna emoji yang dipilih saat jenis ikon Peringkat diatur ke \"Smiley\". Pilih antara: \"Default\" - emoji yang dipilih muncul dalam warna survei default; \"Skala\" - emoji yang dipilih mewarisi warna dari skala peringkat."
// expression.name: "An expression ID that is not visible to respondents." => "ID ekspresi yang tidak terlihat oleh responden."
// expression.description: "Type an expression subtitle." => "Ketikkan subjudul ekspresi."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Ekspresi dapat mencakup perhitungan dasar ('{q1_id} + {q2_id}'), kondisi ('{age} > 60'), dan fungsi ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', dll.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Pilih untuk menyimpan nilai opsi \"Lainnya\" sebagai properti terpisah dalam hasil survei."
// p.swapOrder: "Swap the order of Yes and No" => "Tukar urutan Ya dan Tidak"
// p.itemTitleWidth: "Item label width (in px)" => "Lebar label item (dalam px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Teks untuk memperlihatkan jika semua opsi dipilih"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Teks tempat penampung untuk area peringkat"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Selesaikan survei secara otomatis"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Pilih apakah Anda ingin survei selesai secara otomatis setelah responden menjawab semua pertanyaan."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Simpan nilai terselubung dalam hasil survei"
// patternmask.pattern: "Value pattern" => "Pola nilai"
// datetimemask.min: "Minimum value" => "Nilai minimum"
// datetimemask.max: "Maximum value" => "Nilai maksimum"
// numericmask.allowNegativeValues: "Allow negative values" => "Izinkan nilai negatif"
// numericmask.thousandsSeparator: "Thousands separator" => "Pemisah ribuan"
// numericmask.decimalSeparator: "Decimal separator" => "Pemisah desimal"
// numericmask.precision: "Value precision" => "Presisi nilai"
// numericmask.min: "Minimum value" => "Nilai minimum"
// numericmask.max: "Maximum value" => "Nilai maksimum"
// currencymask.prefix: "Currency prefix" => "Awalan mata uang"
// currencymask.suffix: "Currency suffix" => "Akhiran mata uang"
// pe.maskType: "Input mask type" => "Jenis masker input"
// maskTypes.patternmask: "Pattern" => "Pola"
// maskTypes.numericmask: "Numeric" => "Numerik"
// maskTypes.datetimemask: "Date and Time" => "Tanggal dan Waktu"
// maskTypes.currencymask: "Currency" => "Mata uang"
// tabs.mask: "Input Mask Settings" => "Pengaturan Masker Input"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Contoh: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Contoh: mm/dd/yyyy"
// pe.currencyprefix_placeholder: "Ex.: $" => "Contoh.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Contoh: USD"
// pv.textWrapEnabled: "Wrap choices" => "Pilihan bungkus"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Teks panjang dalam opsi pilihan akan secara otomatis menghasilkan jeda baris agar sesuai dengan menu tarik-turun. Batalkan pilihan jika Anda ingin teks dipotong."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Pilih apakah Anda ingin menyimpan nilai pertanyaan dengan masker yang diterapkan dalam hasil survei."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Pola dapat berisi literal string dan placeholder berikut: '9' - untuk digit; 'a' - untuk huruf besar atau kecil; '#' - untuk digit atau huruf besar atau kecil. Gunakan garis miring terbalik '\\' untuk melarikan diri dari karakter."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Pola dapat berisi karakter pemisah dan placeholder berikut: 'm' - untuk nomor bulan; 'mm' - untuk angka bulan, dengan nol di depannya untuk nilai satu digit; 'd' - untuk hari dalam sebulan; 'dd' - untuk hari dalam sebulan, dengan nol di depan untuk nilai satu digit; 'yy' - untuk dua digit terakhir tahun ini; 'yyyy' - untuk tahun empat digit."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Simbol yang digunakan untuk memisahkan bagian pecahan dari bagian bilangan bulat dari angka yang ditampilkan."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Simbol yang digunakan untuk memisahkan digit angka besar menjadi kelompok tiga."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Membatasi jumlah digit yang akan dipertahankan setelah koma desimal untuk angka yang ditampilkan."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Satu atau beberapa simbol yang akan ditampilkan sebelum nilai."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Satu atau beberapa simbol yang akan ditampilkan setelah nilai."
// ed.translationSource: "Source: " => "Sumber: "
// ed.translationTarget: "Target: " => "Target: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Halaman kosong. Seret elemen dari kotak alat atau klik tombol di bawah."
// maskTypes.none: "None" => "Tidak"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Membuat baris terlihat jika"
// itemvalue@rows.enableIf: "Make the row editable if" => "Membuat baris dapat diedit jika"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Teks tempat penampung dalam mode baca-saja atau pratinjau"
// pe.textWrapEnabled: "Wrap choices" => "Pilihan bungkus"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Opsi \"Otomatis\" secara otomatis menentukan mode yang sesuai untuk tampilan - Gambar, Video, atau YouTube - berdasarkan URL sumber yang disediakan."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Pilih antara \"Gambar\" dan \"Video\" untuk mengatur mode konten pemilih media. Jika \"Gambar\" dipilih, pastikan bahwa semua opsi yang disediakan adalah file gambar dalam format berikut: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Demikian pula, jika \"Video\" dipilih, pastikan bahwa semua opsi adalah tautan langsung ke file video dalam format berikut: MP4, MOV, WMV, FLV, AVI, MKV. Perhatikan bahwa tautan YouTube tidak didukung untuk opsi video."
// ed.selectFile: "Select a file" => "Pilih file"
// ed.removeFile: "Remove the file" => "Menghapus file"
// pe.searchMode: "Search Mode" => "Mode Pencarian"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Klik tombol \"Tambahkan Pertanyaan\" di bawah ini untuk mulai membuat formulir Anda."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Klik tombol \"Tambahkan Pertanyaan\" di bawah ini untuk menambahkan elemen baru ke halaman."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Klik tombol \"Tambahkan Pertanyaan\" di bawah ini untuk menambahkan elemen baru ke panel."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Klik tombol di bawah ini dan pilih gambar untuk diunggah"
// coloralpha.opacity: "Opacity" => "Opacity"
// font.family: "Font family" => "Keluarga font"
// font.color: "Color" => "Warna"
// font.placeholderColor: "Placeholder color" => "Warna tempat penampung"
// font.size: "Size" => "Tingginya"
// theme.themeName: "Theme" => "Tema"
// theme.isPanelless: "Question appearance" => "Penampilan pertanyaan"
// theme.editorPanel: "Background and corner radius" => "Latar belakang dan radius sudut"
// theme.questionPanel: "Background and corner radius" => "Latar belakang dan radius sudut"
// theme.primaryColor: "Accent color" => "Warna aksen"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Opasitas latar belakang panel"
// theme.questionBackgroundTransparency: "Question background opacity" => "Opasitas latar belakang pertanyaan"
// theme.fontSize: "Font size" => "Ukuran font"
// theme.scale: "Scale" => "Sisik"
// theme.cornerRadius: "Corner radius" => "Radius sudut"
// theme.pageTitle: "Title font" => "Font judul"
// theme.pageDescription: "Description font" => "Font deskripsi"
// theme.questionTitle: "Title font" => "Font judul"
// theme.questionDescription: "Description font" => "Font deskripsi"
// theme.editorFont: "Font" => "Font"
// theme.backgroundOpacity: "Opacity" => "Opacity"
// theme.--sjs-font-family: "Font family" => "Keluarga font"
// theme.--sjs-general-backcolor-dim: "Background color" => "Warna latar belakang"
// theme.--sjs-primary-backcolor: "Accent background" => "Latar belakang aksen"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Latar depan aksen"
// theme.--sjs-shadow-small: "Shadow effects" => "Efek bayangan"
// theme.--sjs-shadow-inner: "Shadow effects" => "Efek bayangan"
// theme.--sjs-border-default: "Colors" => "Warna"
// header@header.headerView: "View" => "Melihat"
// header@header.logoPosition: "Logo position" => "Posisi logo"
// header@header.surveyTitle: "Survey title font" => "Font judul survei"
// header@header.surveyDescription: "Survey description font" => "Font deskripsi survei"
// header@header.headerTitle: "Survey title font" => "Font judul survei"
// header@header.headerDescription: "Survey description font" => "Font deskripsi survei"
// header@header.inheritWidthFrom: "Content area width" => "Lebar area konten"
// header@header.textAreaWidth: "Text width" => "Lebar teks"
// header@header.backgroundColorSwitch: "Background color" => "Warna latar belakang"
// header@header.backgroundImage: "Background image" => "Gambar latar belakang"
// header@header.backgroundImageOpacity: "Opacity" => "Opacity"
// header@header.overlapEnabled: "Overlap" => "Tumpang tindih"
// header@header.logoPositionX: "Logo position" => "Posisi logo"
// header@header.titlePositionX: "Title position" => "Posisi judul"
// header@header.descriptionPositionX: "Description position" => "Deskripsi posisi"
// weight.400: "Regular" => "Biasa"
// weight.600: "Heavy" => "Berat"
// weight.700: "Semi-bold" => "Semi-tebal"
// weight.800: "Bold" => "Berani"
// backgroundImageFit.auto: "Auto" => "Auto"
// backgroundImageFit.cover: "Cover" => "Menutupi"
// backgroundImageFit.contain: "Contain" => "Mengandung"
// backgroundImageFit.fill: "Stretch" => "Merentangkan"
// backgroundImageFit.tile: "Tile" => "Ubin"
// backgroundImageAttachment.fixed: "Fixed" => "Tetap"
// backgroundImageAttachment.scroll: "Scroll" => "Gulir"
// headerView.basic: "Basic" => "Dasar"
// headerView.advanced: "Advanced" => "Maju"
// inheritWidthFrom.survey: "Same as survey" => "Sama seperti survei"
// inheritWidthFrom.container: "Fit to container" => "Sesuai dengan kontainer"
// backgroundColorSwitch.none: "None" => "Tidak"
// backgroundColorSwitch.accentColor: "Accent color" => "Warna aksen"
// backgroundColorSwitch.custom: "Custom" => "Adat"
// colorPalette.light: "Light" => "Ringan"
// colorPalette.dark: "Dark" => "Gelap"
// isPanelless.false: "Default" => "Default"
// isPanelless.true: "Without Panels" => "Tanpa Panel"
// theme.cornerRadius: "Corner radius" => "Radius sudut"
// theme.fontFamily: "Font family" => "Keluarga font"
// theme.fontWeightRegular: "Regular" => "Biasa"
// theme.fontWeightHeavy: "Heavy" => "Berat"
// theme.fontWeightSemiBold: "Semi-bold" => "Semi-tebal"
// theme.fontWeightBold: "Bold" => "Berani"
// theme.color: "Color" => "Warna"
// theme.placeholderColor: "Placeholder color" => "Warna tempat penampung"
// theme.size: "Size" => "Tingginya"
// theme.opacity: "Opacity" => "Opacity"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Ketik untuk mencari..."
// ed.toolboxNoResultsFound: "No results found" => "Tidak ada hasil yang ditemukan"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Tempat penampung judul tab"
// theme.--sjs-special-red: "Error messages" => "Pesan kesalahan"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Teks fallback untuk judul tab yang berlaku saat pola judul tab tidak menghasilkan nilai yang berarti."
// theme.fontColor: "Font color" => "Warna font"
// theme.backgroundColor: "Background color" => "Warna latar belakang"
// pe.questionTitleWidth: "Question title width" => "Lebar judul pertanyaan"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Pilih file atau tempel tautan file..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Contoh: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Mengatur lebar yang konsisten untuk judul pertanyaan bila disejajarkan di sebelah kiri kotak pertanyaan. Menerima nilai CSS (px, %, in, pt, dll.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Mengatur lebar yang konsisten untuk judul pertanyaan bila disejajarkan di sebelah kiri kotak pertanyaan. Menerima nilai CSS (px, %, in, pt, dll.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Tinggi area komentar (dalam baris)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Mengatur jumlah baris yang ditampilkan di area teks untuk komentar pertanyaan. Dalam input mengambil lebih banyak baris, bilah gulir muncul."


/***/ }),

/***/ "./src/localization/italian.ts":
/*!*************************************!*\
  !*** ./src/localization/italian.ts ***!
  \*************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var italianTranslation = {
    // survey templates
    survey: {
        edit: "Modifica",
        externalHelpLink: "Guarda e impara come creare sondaggio",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Aggiungi una domanda qui",
        addLogicItem: "Crea una regola per personalizzare il percorso del sondaggio.",
        copy: "Copia",
        duplicate: "Duplica",
        addToToolbox: "Aggiungi alla toolbox",
        deletePanel: "Elimina Pannello",
        deleteQuestion: "Elimina Domanda",
        convertTo: "Converti in",
        drag: "Trascina l'elemento",
    },
    // Creator tabs
    tabs: {
        preview: "Anteprima del sondaggio",
        theme: "Temi",
        translation: "Traduzione",
        designer: "Progetta il sondaggio",
        editor: "Modifica JSON",
        logic: "Logica"
    },
    // Question types
    qt: {
        default: "Default",
        checkbox: "Casella di controllo",
        comment: "Commento",
        imagepicker: "Selezionatore di immagini",
        ranking: "Classifica",
        image: "Immagine",
        dropdown: "Tendina",
        tagbox: "Menù a discesa a selezione multipla",
        file: "File Upload",
        html: "Html",
        matrix: "Matrice (scelta singola)",
        matrixdropdown: "Matrice (scelta multipla)",
        matrixdynamic: "Matrice (dinamica)",
        multipletext: "Testo multiplo",
        panel: "Pannello",
        paneldynamic: "Pannello dinamico",
        radiogroup: "Opzione multipla",
        rating: "Valutazione",
        text: "Testo semplice",
        boolean: "Booleano",
        expression: "Espressione (sola lettura)",
        signaturepad: "Pad per la firma",
        buttongroup: "Gruppo di pulsanti"
    },
    toolboxCategories: {
        general: "Generale",
        choice: "Domande a scelta",
        text: "Domande sull'input di testo",
        containers: "Contenitori",
        matrix: "Domande sulla matrice",
        misc: "Altri"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Default ({0})",
        survey: "Sondaggio",
        settings: "Impostazioni sondaggio",
        settingsTooltip: "Apri le impostazioni del sondaggio",
        surveySettings: "Impostazioni del sondaggio",
        surveySettingsTooltip: "Impostazioni dell'indagine",
        themeSettings: "Impostazioni del tema",
        themeSettingsTooltip: "Impostazioni del tema",
        showPanel: "Mostra Pannello",
        hidePanel: "Nascondi Pannello",
        prevSelected: "Seleziona precedente",
        nextSelected: "Seleziona seguente",
        prevFocus: "Focus precedente",
        nextFocus: "Focus successivo",
        surveyTypeName: "Sondaggio",
        pageTypeName: "Pagina",
        panelTypeName: "Pannello",
        questionTypeName: "Domanda",
        columnTypeName: "Colonna",
        addNewPage: "Aggiungi Nuova Pagina",
        moveRight: "Scorri a destra",
        moveLeft: "Scorri a sinistra",
        deletePage: "Elimina Pagina",
        editPage: "Modifica Pagina",
        edit: "Modifica",
        newPageName: "Pagina",
        newQuestionName: "Domanda",
        newPanelName: "Pannello",
        newTextItemName: "Testo",
        defaultV2Theme: "Default",
        modernTheme: "Tema Moderno",
        defaultTheme: "Default (legacy)",
        testSurveyAgain: "Prova il sondaggio di nuovo",
        testSurveyWidth: "Larghezza sondaggio:",
        navigateToMsg: "Bisogna navigare fino a:",
        saveSurvey: "Salva sondaggio",
        saveSurveyTooltip: "Salva sondaggio",
        saveTheme: "Salva tema",
        saveThemeTooltip: "Salva tema",
        jsonHideErrors: "Nascondi gli errori",
        jsonShowErrors: "Mostra gli errori",
        undo: "Annulla",
        redo: "Ripristina",
        undoTooltip: "Annulla l'ultima modifica",
        redoTooltip: "Ripristina l'ultima modifica",
        showMoreChoices: "Mostra di più",
        showLessChoices: "Mostra meno",
        copy: "Copia",
        cut: "Taglia",
        paste: "Incolla",
        copyTooltip: "Copia la selezione negli appunti",
        cutTooltip: "Taglia la selezione negli appunti",
        pasteTooltip: "Incolla dagli appunti",
        options: "Opzioni",
        generateValidJSON: "Genera JSON Valido",
        generateReadableJSON: "Genera JSON Leggibile",
        toolbox: "Toolbox",
        "property-grid": "Proprietà",
        toolboxFilteredTextPlaceholder: "Digita per cercare...",
        toolboxNoResultsFound: "Nessun risultato trovato",
        propertyGridFilteredTextPlaceholder: "Digita per cercare...",
        propertyGridNoResultsFound: "Nessun risultato trovato",
        correctJSON: "Correggi il tuo JSON",
        surveyResults: "Risultati del sondaggio: ",
        surveyResultsTable: "Come tabella",
        surveyResultsJson: "Come JSON",
        resultsTitle: "Titolo Domanda",
        resultsName: "Nome Domanda",
        resultsValue: "Valore Risposta",
        resultsDisplayValue: "Mostra Valore",
        modified: "Modificato",
        saving: "Salvataggio",
        saved: "Salvato",
        propertyEditorError: "Errore:",
        saveError: "Errore! Il contenuto dell'editor non è salvato.",
        translationPropertyGridTitle: "Impostazione della traduzione",
        themePropertyGridTitle: "Impostazioni del tema",
        translationLanguages: "Lingue",
        translationDeleteLanguage: "Sei sicuro di voler eliminare tutte le stringhe per questa lingua?",
        translationAddLanguage: "Seleziona la lingua da tradurre",
        translationShowAllStrings: "Tutte le stringhe",
        translationShowUsedStringsOnly: "Solo le stringhe usate",
        translationShowAllPages: "Tutte le pagine",
        translationNoStrings: "Nessuna stringa da tradurre. Cambia il filtro.",
        translationExportToSCVButton: "Esporta in CSV",
        translationImportFromSCVButton: "Importa da CSV",
        translateUsigAI: "Traduzione automatica di tutto",
        translateUsigAIFrom: "Traduci da: ",
        translationDialogTitle: "Stringhe non tradotte",
        translationMergeLocaleWithDefault: "Unisci {0} con il predefinito",
        translationPlaceHolder: "Traduzione...",
        translationSource: "Fonte: ",
        translationTarget: "Bersaglio: ",
        themeExportButton: "Esportazione",
        themeImportButton: "Importazione",
        surveyJsonExportButton: "Esportazione",
        surveyJsonImportButton: "Importazione",
        surveyJsonCopyButton: "Copia negli Appunti",
        themeResetButton: "Ripristina le impostazioni del tema predefinite",
        themeResetConfirmation: "Vuoi davvero resettare il tema? Tutte le tue personalizzazioni andranno perse.",
        themeResetConfirmationOk: "Sì, reimposta il tema",
        bold: "Grassetto",
        italic: "Corsivo",
        underline: "Sottolineato",
        addNewQuestion: "Aggiungi domanda",
        selectPage: "Seleziona la pagina...",
        carryForwardChoicesCopied: "Le scelte vengono copiate da",
        choicesLoadedFromWebText: "Le scelte vengono caricate da un servizio Web.",
        choicesLoadedFromWebLinkText: "Vai alle impostazioni",
        choicesLoadedFromWebPreviewTitle: "Anteprima delle opzioni di scelta caricate",
        htmlPlaceHolder: "Il contenuto HTML sarà qui.",
        panelPlaceHolder: "Trascina una domanda dalla toolbox qui.",
        surveyPlaceHolder: "Il sondaggio è vuoto. Trascina un elemento dalla toolbox o clicca sul tasto sottostante.",
        pagePlaceHolder: "La pagina è vuota. Trascinare un elemento dalla casella degli strumenti o fare clic sul pulsante sottostante.",
        imagePlaceHolder: "Trascina e rilascia un'immagine qui o fai clic sul pulsante qui sotto e scegli un'immagine da caricare",
        surveyPlaceHolderMobile: "Fai clic sul pulsante \"Aggiungi domanda\" qui sotto per iniziare a creare il tuo modulo.",
        pagePlaceHolderMobile: "Fai clic sul pulsante \"Aggiungi domanda\" in basso per aggiungere un nuovo elemento alla pagina.",
        panelPlaceHolderMobile: "Fai clic sul pulsante \"Aggiungi domanda\" in basso per aggiungere un nuovo elemento al pannello.",
        imagePlaceHolderMobile: "Clicca sul pulsante qui sotto e scegli un'immagine da caricare",
        imageChooseImage: "Scegli immagine",
        addNewTypeQuestion: "Aggiungi {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Articolo ",
        selectFile: "Seleziona un file",
        removeFile: "Rimuovere il file",
        lg: {
            addNewItem: "Aggiungi Nuova Regola",
            empty_tab: "Crea una regola per personalizzare il percorso del sondaggio.",
            page_visibilityName: "Mostra (nascondi) pagina",
            page_enableName: "Abilita (disabilita) pagina",
            page_requireName: "Rendi la pagina obbligatoria",
            panel_visibilityName: "Mostra (nascondi) pannello",
            panel_enableName: "Abilita (disabilita) pannello",
            panel_requireName: "Rendi la pagina obbligatoria",
            question_visibilityName: "Mostra (nascondi) domanda",
            question_enableName: "Abilita (disabilita) domanda",
            question_requireName: "Rendi la domanda obbligatoria",
            question_resetValueName: "Reimpostare il valore della domanda",
            question_setValueName: "Impostare il valore della domanda",
            column_visibilityName: "Mostra (nascondi) colonna",
            column_enableName: "Abilita (disabilita) colonna",
            column_requireName: "Rendi la colonna obbligatoria",
            column_resetValueName: "Reimposta valore colonna",
            column_setValueName: "Impostare il valore della colonna",
            trigger_completeName: "Completa sondaggio",
            trigger_setvalueName: "Imposta la risposta",
            trigger_copyvalueName: "Copia la risposta",
            trigger_skipName: "Passa alla domanda",
            trigger_runExpressionName: "Esegui l'espressione",
            completedHtmlOnConditionName: "Imposta il markup della pagina \"sondaggio Completo\"",
            page_visibilityDescription: "Rendi la pagina visibile quando l'espressione logica restituisce vero. Altrimenti, mantienila invisibile.",
            panel_visibilityDescription: "Rendi il pannello visibile quando l'espressione logica restituisce vero. Altrimenti, mantienilo invisibile.",
            panel_enableDescription: "Rendi il pannello e tutti gli elementi al suo interno abilitati quando l'espressione logica restituisce vero. Altrimenti, mantienili disabilitati.",
            question_visibilityDescription: "Rendi visibile la domanda quando l'espressione logica restituisce vero. Altrimenti, mantienila invisibile.",
            question_enableDescription: "Rendi la domanda abilitata quando l'espressione logica restituisce vero. Altrimenti, mantienila disabilitata.",
            question_requireDescription: "La domanda diventa obbligatoria quando l'espressione logica restituisce vero.",
            trigger_completeDescription: "Quando l'espressione logica restituisce vero, il sondaggio diventa completo e l'utente finale vede la 'Pagina di ringraziamento'.",
            trigger_setvalueDescription: "Quando i valori della domanda, utilizzati nell'espressione logica, vengono modificati e l'espressione logica restituisce vero, il valore viene impostato sulla domanda selezionata.",
            trigger_copyvalueDescription: "Quando i valori della domanda, utilizzata nell'espressione logica, vengono modificati e l'espressione logica restituisce vero, il valore di una domanda selezionata viene copiato in un'altra domanda selezionata.",
            trigger_skipDescription: "Quando l'espressione logica restituisce vero, il sondaggio passa / si focalizza sulla domanda selezionata.",
            trigger_runExpressionDescription: "Quando l'espressione logica restituisce vero, viene eseguita l'espressione personalizzata. È possibile impostare il risultato dell'espressione nella domanda selezionata.",
            completedHtmlOnConditionDescription: "Se l'espressione logica restituisce vero, il testo di default per la 'Pagina di ringraziamento' viene modificato in quello indicato.",
            itemExpressionText: "Quando l'espressione: '{0}' restituisce vero:",
            itemEmptyExpressionText: "Nuova regola",
            page_visibilityText: "rendi la pagina {0} visibile",
            panel_visibilityText: "rendi il pannello {0} visibile",
            panel_enableText: "rendi il pannello {0} abilitato",
            question_visibilityText: "rendi la domanda {0} visibile",
            question_enableText: "rendi la domanda {0} abilitata",
            question_requireText: "rendi la domanda {0} obbligatoria",
            question_resetValueText: "Valore di ripristino per la domanda: {0}",
            question_setValueText: "Assegna valore: {1} alla domanda: {0}",
            column_visibilityText: "rendi la colonna {0} della domanda {1} visibile",
            column_enableText: "rendi la colonna {0} della domanda {1} abilitata",
            column_requireText: "rendi la colonna {0} della domanda {1} obbligatoria",
            column_resetValueText: "Reimposta il valore della cella per la colonna: {0}",
            column_setValueText: "Assegna valore cella: {1} alla colonna: {0}",
            setValueExpressionPlaceholder: " Espressione il cui risultato verrà assegnato alla domanda di destinazione.",
            trigger_completeText: "il sondaggio viene completato",
            trigger_setvalueText: "imposta nella domanda: {0} valore {1}",
            trigger_setvalueEmptyText: "Valore chiaro della domanda: {0}",
            trigger_copyvalueText: "copia nella domanda: {0} valore dalla domanda {1}",
            trigger_skipText: "sondaggio passa alla domanda {0}",
            trigger_runExpressionText1: "esegui l'espressione: '{0}'",
            trigger_runExpressionText2: " e imposta il risultato nella domanda: {0}",
            completedHtmlOnConditionText: "mostra il testo personalizzato per la 'Pagina di ringraziamento'.",
            showAllQuestions: "Tutte le Domande",
            showAllActionTypes: "Tutti i Tipi di Azione",
            conditions: "Condizione(i)",
            actions: "Azione(i)",
            expressionEditorTitle: "Definisci condizione(i)",
            actionsEditorTitle: "Definisci azione(i)",
            deleteAction: "Cancella Azione",
            addNewAction: "Aggiungi Azione",
            selectedActionCaption: "Seleziona azione...",
            expressionInvalid: "L'espressione logica è vuota o invalida. Correggila.",
            noActionError: "Aggiungi almeno un'azione.",
            actionInvalid: "Risolvi i problemi nell'azione(i)",
            uncompletedRule_title: "Le regole logiche sono incomplete",
            uncompletedRule_text: "Alcune regole logiche non sono state completate. Se lasci la scheda ora, le modifiche andranno perse. Vuoi comunque uscire dalla scheda senza completare le modifiche?",
            uncompletedRule_apply: "Sì",
            uncompletedRule_cancel: "No, voglio completare le regole"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Nome del pannello",
            title: "Titolo del panel",
            description: "Descrizione del pannello",
            visibleIf: "Rendi visibile il pannello se",
            requiredIf: "Rendere il pannello richiesto se",
            questionsOrder: "Ordine delle domande all'interno del panel",
            page: "Pagina principale",
            startWithNewLine: "Visualizzare il pannello su una nuova riga",
            state: "Stato di compressione del pannello",
            width: "Larghezza del pannello in linea",
            minWidth: "Larghezza minima del pannello",
            maxWidth: "Larghezza massima del pannello",
            showNumber: "Pannelli numerici"
        },
        paneldynamic: {
            name: "Nome del pannello",
            title: "Titolo del panel",
            description: "Descrizione del pannello",
            visibleIf: "Rendi visibile il pannello se",
            requiredIf: "Rendere il pannello richiesto se",
            page: "Sposta il pannello nella pagina",
            startWithNewLine: "Visualizzare il pannello su una nuova riga",
            state: "Stato di compressione del pannello",
            width: "Larghezza del pannello in linea",
            minWidth: "Larghezza minima del pannello",
            maxWidth: "Larghezza massima del pannello",
            confirmDelete: "Conferma eliminazione del pannello",
            templateDescription: "Modello di descrizione del pannello",
            templateTitle: "Pattern titolo pannello",
            noEntriesText: "Testo del pannello vuoto",
            templateTabTitle: "Modello del titolo della tabulazione",
            tabTitlePlaceholder: "Segnaposto titolo tabulazione",
            templateVisibleIf: "Rendi visibile un singolo pannello se",
            hideNumber: "Nascondere il numero del pannello",
            titleLocation: "Allineamento del titolo del pannello",
            descriptionLocation: "Allineamento della descrizione del pannello",
            templateTitleLocation: "Allineamento del titolo della domanda",
            templateErrorLocation: "Allineamento dei messaggi di errore",
            newPanelPosition: "Nuova posizione del pannello",
            keyName: "Impedisci risposte duplicate nella seguente domanda"
        },
        question: {
            name: "Nome della domanda",
            title: "Titolo della domanda",
            description: "Descrizione della domanda",
            visibleIf: "Rendi visibile la domanda se",
            requiredIf: "Rendi la domanda richiesta se",
            page: "Pagina principale",
            state: "Stato di compressione della casella delle domande",
            hideNumber: "Nascondi il numero della domanda",
            titleLocation: "Allineamento del titolo della domanda",
            descriptionLocation: "Allineamento della descrizione della domanda",
            errorLocation: "Allineamento dei messaggi di errore",
            indent: "Aumentare il rientro interno",
            width: "Larghezza della domanda in linea",
            minWidth: "Larghezza minima della domanda",
            maxWidth: "Larghezza massima della domanda",
            textUpdateMode: "Aggiorna il valore del campo di input"
        },
        signaturepad: {
            signatureWidth: "Larghezza dell'area della firma",
            signatureHeight: "Altezza dell'area della firma",
            signatureAutoScaleEnabled: "Ridimensionamento automatico dell'area della firma",
            showPlaceholder: "Visualizzare il segnaposto",
            placeholder: "Testo segnaposto",
            placeholderReadOnly: "Testo segnaposto in modalità di sola lettura o anteprima",
            allowClear: "Mostra il pulsante Cancella all'interno dell'area della firma",
            penMinWidth: "Larghezza minima della penna",
            penMaxWidth: "Larghezza massima della penna",
            penColor: "Colore del tratto"
        },
        comment: {
            rows: "Altezza del campo di immissione (in righe)"
        },
        showQuestionNumbers: "Visualizza il numero delle domande",
        questionStartIndex: "La domanda inizia con l'indice (1, 2 oppure 'A', 'a')",
        expression: {
            name: "Nome dell'espressione",
            title: "Titolo dell'espressione",
            description: "Descrizione dell'espressione",
            expression: "Espressione"
        },
        trigger: {
            expression: "Espressione"
        },
        calculatedvalue: {
            expression: "Espressione"
        },
        // survey templates
        survey: {
            title: "Titolo",
            description: "Descrizione dell'indagine"
        },
        page: {
            name: "Nome della pagina",
            title: "Titolo",
            description: "Descrizione della pagina",
            visibleIf: "Rendi visibile la pagina se",
            requiredIf: "Rendi la pagina obbligatoria se",
            maxTimeToFinish: "Tempo massimo per terminare la pagina (in secondi)",
            questionsOrder: "Ordine delle domande nella pagina"
        },
        matrixdropdowncolumn: {
            name: "Nome della colonna",
            title: "Titolo della colonna",
            isUnique: "Impedisci risposte duplicate",
            width: "Larghezza colonna",
            minWidth: "Larghezza minima della colonna",
            rows: "Altezza del campo di immissione (in righe)",
            visibleIf: "Rendi visibile la colonna se",
            requiredIf: "Rendere obbligatoria la colonna se",
            showInMultipleColumns: "Ogni opzione in una colonna separata"
        },
        multipletextitem: {
            name: "Nome",
            title: "Titolo"
        },
        masksettings: {
            saveMaskedValue: "Salvare il valore mascherato nei risultati dell'indagine"
        },
        patternmask: {
            pattern: "Modello di valore"
        },
        datetimemask: {
            min: "Valore minimo",
            max: "Valore massimo"
        },
        numericmask: {
            allowNegativeValues: "Consenti valori negativi",
            thousandsSeparator: "Separatore delle migliaia",
            decimalSeparator: "Separatore decimale",
            precision: "Precisione del valore",
            min: "Valore minimo",
            max: "Valore massimo"
        },
        currencymask: {
            prefix: "Prefisso di valuta",
            suffix: "Suffisso valuta"
        },
        imageHeight: "Altezza immagine",
        imageWidth: "Larghezza immagine",
        valueName: "Nome Valore",
        rateDescriptionLocation: "Allineamento delle etichette",
        size: "Dimensione dell'input (in caratteri)",
        cellErrorLocation: "Allineamento dei messaggi di errore delle celle",
        apply: "Applica",
        ok: "OK",
        save: "Salva",
        clear: "Cancella",
        saveTooltip: "Salva",
        cancel: "Annulla",
        set: "Imposta",
        reset: "Reimposta",
        change: "Modifica",
        refresh: "Aggiorna",
        close: "Chiudi",
        delete: "Elimina",
        add: "Aggiungi",
        addNew: "Aggiungi Nuovo",
        addItem: "Clicca per aggiungere un'opzione...",
        removeItem: "Clicca per rimuovere un'opzione...",
        dragItem: "Trascina l'opzione",
        addOther: "Altro",
        addSelectAll: "Seleziona Tutti",
        addNone: "Nessuno",
        removeAll: "Elimina tutto",
        edit: "Modifica",
        back: "Torna indietro senza salvare",
        backTooltip: "Torna indietro senza salvare",
        saveAndBack: "Salva e torna indietro",
        saveAndBackTooltip: "Salva e torna indietro",
        doneEditing: "Fatto",
        editChoices: "Modifica Scelte",
        showChoices: "Mostra Scelte",
        move: "Muovi",
        empty: "<empty>",
        emptyValue: "Il valore è vuoto",
        fastEntry: "Inserimento manuale",
        fastEntryNonUniqueError: "Il valore '{0}' non è univoco",
        fastEntryChoicesCountError: "Limita il numero di opzioni da {0} a {1}",
        fastEntryChoicesMinCountError: "Inserisci almeno {0} elementi",
        fastEntryPlaceholder: "È possibile impostare i dati nel seguente formato:\nvalore1|testo\nvalore2",
        formEntry: "Inserimento dati",
        testService: "Prova il servizio",
        itemSelectorEmpty: "Seleziona elemento",
        conditionActionEmpty: "Seleziona azione",
        conditionSelectQuestion: "Seleziona domanda...",
        conditionSelectPage: "Seleziona pagina...",
        conditionSelectPanel: "Seleziona pannello...",
        conditionValueQuestionTitle: "Inserisci/seleziona valore",
        aceEditorHelp: "Premi ctrl+spazio per ottenere un suggerimento sul completamento dell'espressione",
        aceEditorRowTitle: "Riga corrente",
        aceEditorPanelTitle: "Pannello Corrente",
        showMore: "Per maggiori dettagli, guarda la documentazione",
        assistantTitle: "Domande disponibili:",
        cellsEmptyRowsColumns: "Dovrebbe esserci almeno una colonna o riga",
        showPreviewBeforeComplete: "Vedi l'anteprima delle risposte prima di inviare il sondaggio",
        overridingPropertyPrefix: "Impostato da ",
        resetToDefaultCaption: "Resettare",
        propertyIsEmpty: "Per favore, inserisci un valore",
        propertyIsNoUnique: "Inserisci un valore univoco",
        propertyNameIsNotUnique: "Inserisci un nome univoco",
        propertyNameIsIncorrect: "Non utilizzare parole riservate: \"articolo\", \"scelta\", \"pannello\", \"riga\".",
        listIsEmpty: "Aggiungi una nuova opzione",
        "listIsEmpty@choices": "Non sono state ancora aggiunte scelte",
        "listIsEmpty@columns": "Non hai ancora colonne",
        "listIsEmpty@rows": "Non ci sono ancora righe",
        "listIsEmpty@validators": "Non si dispone ancora di regole di convalida",
        "listIsEmpty@calculatedValues": "Non disponi ancora di variabili personalizzate",
        "listIsEmpty@triggers": "Non hai ancora alcun trigger",
        "listIsEmpty@navigateToUrlOnCondition": "Non hai ancora nessun link",
        "addNew@choices": "Aggiungi una scelta",
        "addNew@columns": "Aggiungi nuova colonna",
        "addNew@rows": "Aggiungi nuova riga",
        "addNew@validators": "Aggiunta di una nuova regola",
        "addNew@calculatedValues": "Aggiunta di una nuova variabile",
        "addNew@triggers": "Aggiungere un nuovo trigger",
        "addNew@navigateToUrlOnCondition": "Aggiungi nuovo URL",
        expressionIsEmpty: "Espressione vuota",
        value: "Valore",
        text: "Testo",
        rowid: "ID Riga",
        imageLink: "URL immagine o video",
        columnEdit: "Modifica colonna: {0}",
        itemEdit: "Modifica elemento: {0}",
        url: "URL",
        path: "Percorso",
        choicesbyurl: {
            url: "URL del servizio Web",
            valueName: "Ottenere valori dal seguente campo JSON"
        },
        titleName: "Nome Titolo",
        imageLinkName: "Ottieni gli URL delle immagini dal seguente campo JSON:",
        allowEmptyResponse: "Consenti risposta vuota",
        titlePlaceholder: "Titolo",
        surveyTitlePlaceholder: "Titolo del sondaggio",
        pageTitlePlaceholder: "Pagina {num}",
        descriptionPlaceholder: "Descrizione",
        surveyDescriptionPlaceholder: "Descrizione",
        pageDescriptionPlaceholder: "Descrizione",
        textWrapEnabled: "Scelte di avvolgimento",
        showOtherItem: "Consenti l'opzione Altro",
        otherText: "Testo dell'opzione Altro",
        showNoneItem: "Consenti l'opzione Nessuno",
        showRefuseItem: "Consenti l'opzione Rifiuta di rispondere",
        showDontKnowItem: "Consenti l'opzione Non so",
        noneText: "Testo dell'opzione Nessuno",
        showSelectAllItem: "Consenti l'opzione Seleziona tutti",
        selectAllText: "Testo dell'opzione Seleziona tutti",
        choicesMin: "Valore minimo per le opzioni generate automaticamente",
        choicesMax: "Valore massimo per le opzioni generate automaticamente",
        choicesStep: "Distanza valori opzioni generate automaticamente",
        name: "Nome",
        title: "Titolo",
        cellType: "Tipo di cella",
        colCount: "Numero di colonne",
        choicesOrder: "Ordinamento delle scelte",
        visible: "Visibile",
        isRequired: "Obbligatoria",
        markRequired: "Contrassegna come richiesto",
        removeRequiredMark: "Rimuovere il segno richiesto",
        isAllRowRequired: "Richiedi risposta per tutte le righe",
        eachRowUnique: "Impedisci risposte duplicate nelle righe",
        requiredErrorText: "\"Obbligatoria\" messaggio di errore",
        startWithNewLine: "Visualizza la domanda su una nuova riga",
        rows: "Righe",
        cols: "Colonne",
        placeholder: "Testo segnaposto",
        showPreview: "Mostra anteprima",
        storeDataAsText: "Vedi il contenuto JSON come testo",
        maxSize: "Dimensione massima (in bytes)",
        rowCount: "Numero delle righe",
        columnLayout: "Layout delle colonne",
        addRowLocation: "Posizione del tasto Aggiungi riga",
        transposeData: "Trasponi righe in colonne",
        addRowText: "Testo del tasto per aggiungere una nuova riga",
        removeRowText: "Testo del tasto per eliminare una riga",
        rateMin: "Valore minimo",
        rateMax: "Valore massimo",
        rateStep: "Distanza tra i valori",
        minRateDescription: "Descrizione del valore minimo",
        maxRateDescription: "Descrizione del valore massimo",
        inputType: "Tipo di inserimento",
        optionsCaption: "Testo segnaposto dell'opzione",
        defaultValue: "Valore default",
        cellsDefaultRow: "Testi default",
        surveyEditorTitle: "Modifica le impostazioni del sondaggio",
        qEditorTitle: "Modifica domanda: {0}",
        maxLength: "Lunghezza massima (in caratteri)",
        buildExpression: "Build",
        editExpression: "Modifica",
        and: "e",
        or: "o",
        remove: "Elimina",
        addCondition: "Aggiungi Condizione",
        emptyLogicPopupMessage: "Selezionare una domanda per iniziare a configurare le condizioni.",
        if: "se",
        then: "allora",
        setToName: "Domanda mirata",
        fromName: "Domanda da cui copiare la risposta",
        gotoName: "Domanda a cui passare",
        ruleIsNotSet: "La regola è sbagliata",
        includeIntoResult: "Includi nei risultati del sondaggio",
        showTitle: "Mostra/nascondi titolo",
        expandCollapseTitle: "Espandi/comprimi il titolo",
        locale: "Lingua Default",
        simulator: "Scegli il dispositivo",
        landscapeOrientation: "Orizzontale",
        portraitOrientation: "Verticale",
        mode: "Modalità (editabile/sola lettura)",
        clearInvisibleValues: "Cancella i valori invisibili",
        cookieName: "Nome cookie (per disabilitare esegui il sondaggio due volte in locale)",
        sendResultOnPageNext: "Invia i risultati del sondaggio alla pagina successiva",
        storeOthersAsComment: "Memorizza il valore Altro in campi separati",
        showPageTitles: "Visualizza titolo e descrizione pagina",
        showPageNumbers: "Visualizza numero pagina",
        pagePrevText: "Testo del tasto Pagina Precedente",
        pageNextText: "Testo del tasto Pagina Successiva",
        completeText: "Testo del tasto Completato",
        previewText: "Testo del tasto Anteprima risposte",
        editText: "Testo del tasto Modifica risposta",
        startSurveyText: "Testo del tasto Inizia sondaggio",
        showNavigationButtons: "Visualizza tasti di navigazione (navigazione di default)",
        showPrevButton: "Visualizza tasto Pagina Precedente (l'utente può tornare alla pagina precedente)",
        firstPageIsStarted: "La prima pagina nel sondaggio è la pagina iniziale",
        showCompletedPage: "Mostra la pagina sondaggio Completo",
        goNextPageAutomatic: "Rispondendo a tutte le domande, vai alla pagina successiva in automatico",
        allowCompleteSurveyAutomatic: "Completa automaticamente il sondaggio",
        showProgressBar: "Visualizza barra di avanzamento",
        questionTitleLocation: "Posizione del titolo della domanda",
        questionTitleWidth: "Larghezza del titolo della domanda",
        requiredText: "Simbolo domanda obbligatoria, ad esempio (*)",
        questionTitleTemplate: "Template titolo della domanda, il default è: '{no}. {require} {title}'",
        questionErrorLocation: "Posizione del messaggio di errore",
        focusFirstQuestionAutomatic: "Al cambio pagina, posiziona il cursore sulla prima domanda",
        questionsOrder: "Ordine delle domande sulla pagina",
        maxTimeToFinish: "Tempo massimo per terminare il sondaggio",
        maxTimeToFinishPage: "Tempo massimo per terminare una pagina del sondaggio",
        showTimerPanel: "Visualizzazione pannello timer",
        showTimerPanelMode: "Modalità visualizzazione pannello timer",
        renderMode: "Modalità di visualizzazione",
        allowAddPanel: "Consenti l'aggiunta di un pannello",
        allowRemovePanel: "Consenti la rimozione di un pannello",
        panelAddText: "Testo del tasto Aggiungi pannello",
        panelRemoveText: "Testo del tasto Rimuovi pannello",
        isSinglePage: "Visualizza tutti gli elementi su una pagina",
        html: "Markup HTML",
        setValue: "Rispondi",
        dataFormat: "Formato immagine",
        allowAddRows: "Permetti di aggiungere righe",
        allowRemoveRows: "Permetti di eliminare righe",
        allowRowsDragAndDrop: "Consenti il trascinamento delle righe",
        responsiveImageSizeHelp: "Non si applica se si specifica l'esatta larghezza o altezza dell'immagine.",
        minImageWidth: "Larghezza minima dell'immagine",
        maxImageWidth: "Larghezza massima dell'immagine",
        minImageHeight: "Altezza minima dell'immagine",
        maxImageHeight: "Altezza massima dell'immagine",
        minValue: "Valore minimo",
        maxValue: "Valore massimo",
        minLength: "Lunghezza minima (in caratteri)",
        allowDigits: "Ammetti le cifre",
        minCount: "Numero minimo",
        maxCount: "Numero massimo",
        regex: "Espressione regolare",
        surveyvalidator: {
            text: "Messaggio di errore",
            expression: "Espressione di convalida"
        },
        totalText: "Testo della riga Totale",
        totalType: "Tipo Totale",
        totalExpression: "Espressione Totale",
        totalDisplayStyle: "Stile di visualizzazione del valore Totale",
        totalCurrency: "Valuta",
        totalFormat: "Stringa formattata",
        logo: "Logo (URL o stringa codificata in base64)",
        questionsOnPageMode: "Struttura sondaggio",
        maxTextLength: "Lunghezza massima della risposta (in caratteri)",
        maxOthersLength: "Lunghezza massima del commento (in caratteri)",
        commentAreaRows: "Altezza dell'area di commento (in righe)",
        autoGrowComment: "Espansione automatica dell'area dei commenti, se necessaria",
        allowResizeComment: "Consenti agli utenti di ridimensionare le aree di testo",
        textUpdateMode: "Aggiornare il valore del testo della domanda",
        maskType: "Tipo di maschera di input",
        maskTypes: {
            none: "Nessuno",
            patternmask: "Modello",
            numericmask: "Numerico",
            datetimemask: "Data e ora",
            currencymask: "Valuta"
        },
        focusOnFirstError: "Imposta il focus sulla prima risposta invalida",
        checkErrorsMode: "Esegui la convalida",
        navigateToUrl: "Naviga fino all'URL",
        navigateToUrlOnCondition: "URL Dinamico",
        completedBeforeHtml: "Markup da mostrare se l'utente ha già compilato questo sondaggio",
        completedHtml: "Markup della pagina sondaggio Completo",
        completedHtmlOnCondition: "Markup dinamico della pagina sondaggio Completo",
        loadingHtml: "Markup da mostrare durante il caricamento del modello del sondaggio",
        commentText: "Titolo dell'Area commento",
        autocomplete: "Tipo di completamento automatico",
        labelTrue: "Etichetta \"Vero\"",
        labelFalse: "Etichetta \"Falso\"",
        allowClear: "Mostra il tasto Cancella",
        searchMode: "Modalità di ricerca",
        displayStyle: "Stile di visualizzazione del valore",
        format: "Stringa formattata",
        maximumFractionDigits: "Numero massimo di cifre frazionarie",
        minimumFractionDigits: "Numero minimo di cifre frazionarie",
        useGrouping: "Mostra i separatori di raggruppamento",
        allowMultiple: "Consenti più file",
        allowImagesPreview: "Anteprima immagini",
        acceptedTypes: "Tipi di file accettati",
        waitForUpload: "Attendi il completamento del caricamento",
        needConfirmRemoveFile: "Conferma l'eliminazione del file",
        detailPanelMode: "Posizione del pannello di dettaglio",
        minRowCount: "Numero minimo di righe",
        maxRowCount: "Numero massimo di righe",
        confirmDelete: "Conferma eliminazione della riga",
        confirmDeleteText: "Testo del messaggio di conferma",
        panelCount: "Numero iniziale di pannelli",
        minPanelCount: "Numero minimo di pannelli",
        maxPanelCount: "Numero massimo di pannelli",
        panelsState: "Stato di espansione del pannello interno",
        panelPrevText: "Testo del tasto Pannello Precedente",
        panelNextText: "Testo del tasto Pannello Successivo",
        showRangeInProgress: "Mostra la barra di avanzamento",
        panelRemoveButtonLocation: "Posizione del tasto Rimozione Pannello",
        hideIfRowsEmpty: "Nascondi la domanda se non ci sono righe",
        hideColumnsIfEmpty: "Nascondi le colonne se non ci sono righe",
        rateValues: "Valori personalizzati",
        rateCount: "Conteggio delle tariffe",
        autoGenerate: "Come specificare i valori dei tassi?",
        hideIfChoicesEmpty: "Nascondi la domanda se non ci sono scelte",
        minWidth: "Larghezza minima (in valori accettati da CSS)",
        maxWidth: "Larghezza massima (in valori accettati da CSS)",
        width: "Larghezza (in valori accettati da CSS)",
        showHeader: "Mostra intestazioni colonna",
        horizontalScroll: "Mostra la barra di scorrimento orizzontale",
        columnMinWidth: "Larghezza minima della colonna (in valori accettati da CSS)",
        rowTitleWidth: "Larghezza dell'intestazione della riga (in valori accettati dai CSS)",
        valueTrue: "Valore \"Vero\"",
        valueFalse: "Valore \"Falso\"",
        minErrorText: "\"Valore inferiore al minimo\" messaggio di errore",
        maxErrorText: "\"Valore superiore al massimo\" messaggio di errore",
        otherErrorText: "\"Commento vuoto\" messaggio di errore",
        keyDuplicationError: "\"Valore chiave non univoco\" messaggio di errore",
        minSelectedChoices: "Numero minimo di scelte selezionate",
        maxSelectedChoices: "Max. scelte selezionabili",
        showClearButton: "Mostra il tasto Cancella",
        logoWidth: "Larghezza logo (in valori accettati da CSS)",
        logoHeight: "Altezza logo (in valori accettati da CSS)",
        readOnly: "Sola lettura",
        enableIf: "Editabile se",
        emptyRowsText: "\"Nessuna riga\" messaggio",
        separateSpecialChoices: "Scelte speciali separate (Nessuno, Altro, Seleziona tutti)",
        choicesFromQuestion: "Copia le scelte dalla domanda seguente:",
        choicesFromQuestionMode: "Quale scelta copiare?",
        progressBarShowPageTitles: "Visualizzare i titoli delle pagine nella barra di avanzamento",
        progressBarShowPageNumbers: "Visualizzare i numeri di pagina nella barra di avanzamento",
        showCommentArea: "Mostra l'area commento",
        commentPlaceholder: "Testo segnaposto area commento",
        displayRateDescriptionsAsExtremeItems: "Mostra le descrizioni come valori estremi",
        rowsOrder: "Ordine righe",
        columnsLayout: "Layout colonna",
        columnColCount: "Numero colonne annidate",
        correctAnswer: "Risposta corretta",
        defaultPanelValue: "Valori di default",
        cells: "Testi Celle",
        fileInputPlaceholder: "Seleziona un file o incolla un collegamento a un file...",
        keyName: "Colonna chiave",
        itemvalue: {
            visibleIf: "Rendi visibile l'opzione se",
            enableIf: "Rendere l'opzione selezionabile se"
        },
        "itemvalue@rows": {
            visibleIf: "Rendi visibile la riga se",
            enableIf: "Rendi la riga modificabile se"
        },
        imageitemvalue: {
            text: "Testo alternativo"
        },
        logoPosition: "Posizione Logo",
        addLogo: "Aggiungi logo...",
        changeLogo: "Modifica logo...",
        logoPositions: {
            none: "Rimuovi logo",
            left: "Sinistra",
            right: "Destra",
            top: "In alto",
            bottom: "In basso"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Layout del pannello"
            },
            general: "Generale",
            fileOptions: "Opzioni",
            html: "Modifica Html",
            columns: "Colonne",
            rows: "Righe",
            choices: "Scelte",
            items: "Opzioni",
            visibleIf: "Visibile se",
            enableIf: "Editabile se",
            requiredIf: "Obbligatoria se",
            rateValues: "Valori della classifica",
            choicesByUrl: "Opzioni da URL",
            matrixChoices: "Opzioni predefinite",
            multipleTextItems: "Voci di testo",
            numbering: "Numerazione",
            validators: "Validatori",
            navigation: "Navigazione",
            question: "Domanda",
            pages: "Pagine",
            timer: "Timer/Quiz",
            calculatedValues: "Valori Calcolati",
            triggers: "Trigger",
            templateTitle: "Template titolo",
            totals: "Totale",
            logic: "Logica",
            mask: "Impostazioni della maschera di input",
            layout: {
                panel: "Impaginazione",
                question: "Impaginazione",
                base: "Impaginazione"
            },
            data: "Dati",
            validation: "Validazione",
            cells: "Testi Cella",
            showOnCompleted: "Sondaggio Completo",
            logo: "Logo nel Titolo sondaggio",
            slider: "Cursore",
            expression: "Espressione",
            questionSettings: "Impostazioni delle domande",
            header: "Intestazione",
            background: "Sfondo",
            appearance: "Apparenza",
            others: "Altri"
        },
        editProperty: "Modifica propietà '{0}'",
        items: "[ Elemento: {0} ]",
        choicesVisibleIf: "Scelte visibili se",
        choicesEnableIf: "Scelte selezionabili se",
        columnsEnableIf: "Colonne visibili se",
        rowsEnableIf: "Righe visibili se",
        innerIndent: "Aggiungi rientri interni",
        defaultValueFromLastRow: "Prendi i valori predefiniti dall'ultima riga",
        defaultValueFromLastPanel: "Prendi i valori predefiniti dall'ultimo pannello",
        enterNewValue: "Inserisci il valore.",
        noquestions: "Non c'è alcuna domanda nel sondaggio.",
        createtrigger: "Il trigger non è impostato",
        titleKeyboardAdornerTip: "Premi il tasto Invio per modificare",
        keyboardAdornerTip: "Premi il tasto Invio per modificare l'elemento, premi il tasto Cancella per eliminare l'elemento, premi alt più freccia su o freccia giù per spostare l'elemento.",
        triggerOn: "Attivazione",
        triggerMakePagesVisible: "Rendi visibili le pagine:",
        triggerMakeQuestionsVisible: "Rendi visibili le domande:",
        triggerCompleteText: "Completa il sondaggio.",
        triggerNotSet: "Non impostato",
        triggerRunIf: "Esegui se",
        triggerSetToName: "Cambia il valore di: ",
        triggerFromName: "Copia valore da: ",
        triggerRunExpression: "Esegui questa Espressione:",
        triggerSetValue: "a: ",
        triggerGotoName: "Vai alla domanda:",
        triggerIsVariable: "Non inserire la variabile del risultato del sondaggio",
        triggerRunExpressionEmpty: "Inserisci un'espressione valida",
        emptyExpressionPlaceHolder: "Digita qui l'espressione...",
        noFile: "Nessun file scelto",
        clearIfInvisible: "Cancella se Invisibile",
        valuePropertyName: "Nome della proprietà Value",
        searchEnabled: "Abilita ricerca",
        hideSelectedItems: "Nascondere gli elementi selezionati",
        closeOnSelect: "Chiudere il menu a discesa dopo la selezione",
        verticalAlign: "Allineamento verticale",
        alternateRows: "Righe alternate",
        columnsVisibleIf: "Colonne visibili se",
        rowsVisibleIf: "Righe visibili se",
        otherPlaceholder: "Testo segnaposto area commenti",
        filePlaceholder: "Testo segnaposto del file",
        photoPlaceholder: "Testo segnaposto foto",
        fileOrPhotoPlaceholder: "Testo segnaposto per file o foto",
        rateType: "Tipo di tariffa",
        url_placeholder: "Es.: https://api.example.com/books",
        path_placeholder: "Es.: categories.fiction",
        questionStartIndex_placeholder: "Es.: a)",
        width_placeholder: "Es.: 6 pollici",
        minWidth_placeholder: "Es.: 600px",
        maxWidth_placeholder: "Es.: 50%",
        imageHeight_placeholder: "Automatico",
        imageWidth_placeholder: "Automatico",
        theme: {
            themeName: "Tema",
            isPanelless: "Aspetto della domanda",
            editorPanel: "Sfondo e raggio d'angolo",
            questionPanel: "Sfondo e raggio d'angolo",
            primaryColor: "Colore d'accento",
            panelBackgroundTransparency: "Opacità dello sfondo del pannello",
            questionBackgroundTransparency: "Opacità dello sfondo della domanda",
            fontSize: "Dimensione del carattere",
            scale: "Scala",
            cornerRadius: "Raggio d'angolo",
            pageTitle: "Carattere del titolo",
            pageDescription: "Carattere di descrizione",
            questionTitle: "Carattere del titolo",
            questionDescription: "Carattere di descrizione",
            editorFont: "Font",
            backgroundOpacity: "Opacità",
            "--sjs-font-family": "Famiglia di caratteri",
            "--sjs-general-backcolor-dim": "Colore di sfondo",
            "--sjs-primary-backcolor": "Sfondo d'accento",
            "--sjs-primary-forecolor": "Primo piano in primo piano",
            "--sjs-special-red": "Messaggi di errore",
            "--sjs-shadow-small": "Effetti ombra",
            "--sjs-shadow-inner": "Effetti ombra",
            "--sjs-border-default": "Colori"
        },
        "header@header": {
            headerView: "Vista",
            logoPosition: "Posizione del logo",
            surveyTitle: "Carattere del titolo dell'indagine",
            surveyDescription: "Carattere della descrizione dell'indagine",
            headerTitle: "Carattere del titolo dell'indagine",
            headerDescription: "Carattere della descrizione dell'indagine",
            inheritWidthFrom: "Larghezza dell'area del contenuto",
            textAreaWidth: "Larghezza del testo",
            backgroundColorSwitch: "Colore di sfondo",
            backgroundImage: "Immagine di sfondo",
            backgroundImageOpacity: "Opacità",
            overlapEnabled: "Sovrapposizione",
            logoPositionX: "Posizione del logo",
            titlePositionX: "Posizione del titolo",
            descriptionPositionX: "Descrizione posizione"
        }
    },
    // Property values
    pv: {
        "true": "vero",
        "false": "falso",
        file: "File locali",
        camera: "Macchina fotografica",
        "file-camera": "File locali o fotocamera",
        inherit: "Default",
        show: "Visibile",
        hide: "Nascosto",
        default: "Default",
        initial: "Iniziale",
        random: "Random",
        collapsed: "Ridotto",
        expanded: "Esteso",
        none: "Nessuno",
        asc: "Ascendente",
        desc: "Discendente",
        indeterminate: "Indeterminato",
        selected: "Selezionato",
        unselected: "Deselezionata",
        decimal: "decimale",
        currency: "valuta",
        percent: "percento",
        firstExpanded: "Il primo pannello è esteso",
        off: "Nascondi il numero delle domande",
        list: "Lista",
        progressTop: "Navigatore del pannello + Barra di avanzamento in alto",
        progressBottom: "Navigatore del pannello + Barra di avanzamento in basso",
        progressTopBottom: "Navigatore del pannello + Barra di avanzamento in alto e in basso",
        tab: "Schede",
        horizontal: "Orizzontale",
        vertical: "Verticale",
        top: "In alto",
        bottom: "In basso",
        topBottom: "In alto e in basso",
        both: "Entrambe",
        left: "Sinistra",
        right: "Destra",
        center: "Centro",
        leftRight: "Destra e sinistra",
        middle: "Mezzo",
        color: "Colore",
        date: "dattero",
        datetime: "datetime",
        "datetime-local": "datetime-local",
        email: "E-mail",
        month: "mese",
        number: "numero",
        password: "parola d’ordine",
        range: "gamma",
        tel: "Tel",
        text: "Testo",
        time: "Ore",
        url: "URL",
        week: "settimana",
        hidden: "Nascosto",
        edit: "Editabile",
        display: "Sola lettura",
        contain: "Contenere",
        cover: "Coprire",
        fill: "Riempire",
        next: "Prossimo",
        last: "Ultimo",
        onComplete: "Al termine del sondaggio",
        onHidden: "Quando la domanda diventa nascosta",
        onHiddenContainer: "Quando la domanda, o il suo pannello/pagina, diventa nascosta",
        clearInvisibleValues: {
            none: "Mai"
        },
        clearIfInvisible: {
            none: "Mai"
        },
        inputType: {
            color: "Colore",
            date: "Dattero",
            "datetime-local": "Data e ora",
            email: "E-mail",
            month: "Mese",
            number: "Numero",
            password: "Parola d’ordine",
            range: "Gamma",
            tel: "Numero di telefono",
            text: "Testo",
            time: "Ore",
            url: "URL",
            week: "Settimana"
        },
        all: "Tutto",
        page: "Pagina",
        survey: "Sondaggio",
        onNextPage: "Quando si passa alla pagina successiva",
        onValueChanged: "Dopo la modifica di una risposta",
        onValueChanging: "Prima della modifica di una risposta",
        questionsOnPageMode: {
            standard: "Struttura originale",
            singlePage: "Mostra tutte le domande in un'unica pagina",
            questionPerPage: "Mostra una singola domanda per pagina"
        },
        noPreview: "No anteprima",
        showAllQuestions: "Mostra tutte le domande",
        showAnsweredQuestions: "Mostra solo le domande con risposta",
        pages: "Pagine completate",
        questions: "Domande con risposte",
        requiredQuestions: "Domande obbligatorie con risposta",
        correctQuestions: "Risposte valide",
        buttons: "Pagine completate (tasto UI)",
        underInput: "Sotto l'input",
        underTitle: "Sotto il titolo",
        onBlur: "Quando perde focus",
        onTyping: "Mentre si digita",
        underRow: "Sotto la riga",
        underRowSingle: "Sotto la riga, solo un pannello è visibile",
        auto: "Automatico",
        showNavigationButtons: {
            none: "Nascosto"
        },
        showTimerPanel: {
            none: "Nascosto"
        },
        showTimerPanelMode: {
            all: "Entrambe"
        },
        addRowLocation: {
            default: "Dipende dal layout della matrice"
        },
        panelsState: {
            default: "Gli utenti non possono espandere o comprimere i pannelli",
            collapsed: "Tutti i pannelli sono compressi",
            expanded: "Tutti i pannelli sono estesi",
            firstExpanded: "Prima espansione"
        },
        widthMode: {
            static: "Statico",
            responsive: "Reattivo"
        },
        contentMode: {
            image: "Immagine",
            video: "Video",
            youtube: "Collegamenti esterni"
        },
        displayMode: {
            buttons: "Pulsanti",
            dropdown: "Menù a discesa"
        },
        rateColorMode: {
            default: "Default",
            scale: "Scala"
        },
        scaleColorMode: {
            monochrome: "Monocromatico",
            colored: "Colorato"
        },
        autoGenerate: {
            "true": "Generare",
            "false": "Inserisci manualmente"
        },
        rateType: {
            labels: "Etichette",
            stars: "Stelle",
            smileys: "Faccine"
        },
        state: {
            default: "Bloccato"
        },
        showQuestionNumbers: {
            default: "Numerazione automatica",
            on: "Continua dalla pagina precedente",
            onPage: "Inizia da capo in ogni pagina",
            onpanel: "Ripristina su ogni pannello",
            onPanel: "Ripristina su ogni pannello",
            onSurvey: "Continua con l'indagine",
            off: "Nessuna numerazione"
        },
        descriptionLocation: {
            underTitle: "Sotto il titolo della domanda",
            underInput: "Sotto il campo di immissione"
        },
        selectToRankAreasLayout: {
            horizontal: "Accanto alle scelte",
            vertical: "Scelte di cui sopra"
        },
        displayStyle: {
            decimal: "Decimale",
            currency: "Valuta",
            percent: "Percentuale",
            date: "Dattero"
        },
        totalDisplayStyle: {
            decimal: "Decimale",
            currency: "Valuta",
            percent: "Percentuale",
            date: "Dattero"
        },
        rowsOrder: {
            initial: "Originale"
        },
        questionsOrder: {
            initial: "Originale"
        },
        showProgressBar: {
            off: "Nascosto",
            topbottom: "In alto e in basso",
            aboveheader: "Sopra l'intestazione",
            belowheader: "Sotto l'intestazione"
        },
        sum: "Somma",
        count: "Contare",
        min: "Min",
        max: "Max",
        avg: "Medio",
        searchMode: {
            contains: "Contiene",
            startsWith: "Inizia con"
        },
        backgroundImageFit: {
            auto: "Automatico",
            cover: "Coprire",
            contain: "Contenere",
            fill: "Stendere",
            tile: "Tegola"
        },
        backgroundImageAttachment: {
            fixed: "Fissato",
            scroll: "Scorrere"
        },
        headerView: {
            basic: "Basico",
            advanced: "Avanzato"
        },
        inheritWidthFrom: {
            survey: "Uguale al sondaggio",
            container: "Adatto al contenitore"
        },
        backgroundColorSwitch: {
            none: "Nessuno",
            accentColor: "Colore d'accento",
            custom: "Costume"
        },
        colorPalette: {
            light: "Leggero",
            dark: "Oscuro"
        },
        isPanelless: {
            "false": "Default",
            "true": "Senza pannelli"
        }
    },
    // Operators
    op: {
        empty: "è vuoto",
        notempty: "non è vuoto ",
        equal: "è uguale a",
        notequal: "non è uguale a",
        contains: "contiene",
        notcontains: "non contiene",
        anyof: "Qualsiasi",
        allof: "Tutti",
        greater: "maggiore",
        less: "minore",
        greaterorequal: "maggiore o uguale",
        lessorequal: "minore o uguale",
        and: "e",
        or: "o"
    },
    // Embed window
    ew: {
        angular: "Versione per Angular",
        jquery: "Versione per jQuery",
        knockout: "Versione per Knockout",
        react: "Versione per React",
        vue: "Versione per Vue",
        bootstrap: "Per framework bootstrap",
        modern: "Tema moderno",
        default: "Tema default",
        orange: "Tema Orange",
        darkblue: "Tema Darkblue",
        darkrose: "Tema Darkrose",
        stone: "Tema Stone",
        winter: "Tema Winter",
        winterstone: "Tema Winter-Stone",
        showOnPage: "Visualizza in questa pagina",
        showInWindow: "Visualizza in una finestra",
        loadFromServer: "Carica JSON dal server",
        titleScript: "Scripts e stili",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Seleziona la pagina da testare:",
        showInvisibleElements: "Mostra elementi nascosti",
        hideInvisibleElements: "Nascondi elementi invisibili"
    },
    validators: {
        answercountvalidator: "Numero risposte",
        emailvalidator: "E-mail",
        expressionvalidator: "Espressione",
        numericvalidator: "Numerico",
        regexvalidator: "Regex",
        textvalidator: "Testo"
    },
    triggers: {
        completetrigger: "Completa sondaggio",
        setvaluetrigger: "Imposta valore",
        copyvaluetrigger: "Copia risposta",
        skiptrigger: "Vai alla domanda",
        runexpressiontrigger: "Esegui espressione",
        visibletrigger: "Cambia visibilità"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Es.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Es.: gg/mm/aaaa"
        },
        currencymask: {
            prefix: "Es.: $",
            suffix: "Es.: USD"
        },
        panelbase: {
            questionTitleWidth: "Es.: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "Un ID pannello che non è visibile ai rispondenti.",
            description: "Digita un sottotitolo del pannello.",
            visibleIf: "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che determina la visibilità del pannello.",
            enableIf: "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che disabiliti la modalità di sola lettura per il pannello.",
            requiredIf: "Utilizza l'icona della bacchetta magica per impostare una regola condizionale che impedisca l'invio dell'indagine a meno che almeno una domanda nidificata non abbia una risposta.",
            questionTitleLocation: "Si applica a tutte le domande all'interno di questo pannello. Se si desidera ignorare questa impostazione, definire le regole di allineamento del titolo per le singole domande. L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine (\"In alto\" per impostazione predefinita).",
            questionTitleWidth: "Imposta una larghezza coerente per i titoli delle domande quando sono allineati a sinistra delle caselle delle domande. Accetta valori CSS (px, %, in, pt, ecc.).",
            questionErrorLocation: "Imposta la posizione di un messaggio di errore in relazione a tutte le domande all'interno del pannello. L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine.",
            questionsOrder: "Mantiene l'ordine originale delle domande o le rende casuali. L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine.",
            page: "Riposiziona il pannello alla fine di una pagina selezionata.",
            innerIndent: "Aggiunge spazio o margine tra il contenuto del pannello e il bordo sinistro del riquadro del pannello.",
            startWithNewLine: "Deselezionare questa opzione per visualizzare il pannello in una riga con la domanda o il pannello precedente. L'impostazione non si applica se il pannello è il primo elemento del modulo.",
            state: "Scegli tra: \"Espanso\" - il pannello viene visualizzato per intero e può essere compresso; \"Compresso\" - il pannello visualizza solo il titolo e la descrizione e può essere espanso; \"Bloccato\": il pannello viene visualizzato per intero e non può essere compresso.",
            width: "Imposta la larghezza del pannello in proporzione agli altri elementi di rilievo nella stessa linea. Accetta valori CSS (px, %, in, pt, ecc.)."
        },
        paneldynamic: {
            name: "Un ID pannello che non è visibile ai rispondenti.",
            description: "Digita un sottotitolo del pannello.",
            visibleIf: "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che determina la visibilità del pannello.",
            enableIf: "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che disabiliti la modalità di sola lettura per il pannello.",
            requiredIf: "Utilizza l'icona della bacchetta magica per impostare una regola condizionale che impedisca l'invio dell'indagine a meno che almeno una domanda nidificata non abbia una risposta.",
            templateTitleLocation: "Si applica a tutte le domande all'interno di questo pannello. Se si desidera ignorare questa impostazione, definire le regole di allineamento del titolo per le singole domande. L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine (\"In alto\" per impostazione predefinita).",
            templateErrorLocation: "Imposta la posizione di un messaggio di errore in relazione a una domanda con input non valido. Scegli tra: \"In alto\" - un testo di errore viene posizionato nella parte superiore della casella della domanda; \"In basso\": un testo di errore viene inserito nella parte inferiore della casella della domanda. L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine (\"In alto\" per impostazione predefinita).",
            errorLocation: "Imposta la posizione di un messaggio di errore in relazione a tutte le domande all'interno del pannello. L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine.",
            page: "Riposiziona il pannello alla fine di una pagina selezionata.",
            innerIndent: "Aggiunge spazio o margine tra il contenuto del pannello e il bordo sinistro del riquadro del pannello.",
            startWithNewLine: "Deselezionare questa opzione per visualizzare il pannello in una riga con la domanda o il pannello precedente. L'impostazione non si applica se il pannello è il primo elemento del modulo.",
            state: "Scegli tra: \"Espanso\" - il pannello viene visualizzato per intero e può essere compresso; \"Compresso\" - il pannello visualizza solo il titolo e la descrizione e può essere espanso; \"Bloccato\": il pannello viene visualizzato per intero e non può essere compresso.",
            width: "Imposta la larghezza del pannello in proporzione agli altri elementi di rilievo nella stessa linea. Accetta valori CSS (px, %, in, pt, ecc.).",
            templateTitle: "Digita un modello per i titoli dei pannelli dinamici. Utilizzare {panelIndex} per la posizione generale del pannello e {visiblePanelIndex} per l'ordine tra i pannelli visibili. Inserire questi segnaposto nel motivo per aggiungere la numerazione automatica.",
            templateTabTitle: "Digita un modello per i titoli delle schede. Utilizzate {panelIndex} per la posizione generale di un pannello e {visiblePanelIndex} per l'ordine tra i pannelli visibili. Inserire questi segnaposto nel motivo per aggiungere la numerazione automatica.",
            tabTitlePlaceholder: "Testo di fallback per i titoli delle schede che si applica quando il modello del titolo della scheda non produce un valore significativo.",
            templateVisibleIf: "Questa impostazione consente di controllare la visibilità dei singoli pannelli all'interno del pannello dinamico. Utilizzare il segnaposto '{panel}' per fare riferimento al pannello corrente nell'espressione.",
            titleLocation: "Questa impostazione viene ereditata automaticamente da tutte le domande all'interno di questo pannello. Se si desidera ignorare questa impostazione, definire le regole di allineamento del titolo per le singole domande. L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine (\"In alto\" per impostazione predefinita).",
            descriptionLocation: "L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine (\"Sotto il titolo del pannello\" per impostazione predefinita).",
            newPanelPosition: "Definisce la posizione di un pannello appena aggiunto. Per impostazione predefinita, i nuovi pannelli vengono aggiunti alla fine. Selezionare \"Avanti\" per inserire un nuovo pannello dopo quello corrente.",
            defaultValueFromLastPanel: "Duplica le risposte dall'ultimo pannello e le assegna al successivo pannello dinamico aggiunto.",
            keyName: "Fai riferimento al nome di una domanda per richiedere a un utente di fornire una risposta univoca per questa domanda in ogni pannello."
        },
        defaultValueExpression: "Questa impostazione consente di assegnare un valore di risposta predefinito in base a un'espressione. L'espressione può includere calcoli di base: '{q1_id} + {q2_id}', espressioni booleane, come '{age} > 60' e funzioni: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', ecc. Il valore determinato da questa espressione funge da valore predefinito iniziale che può essere sostituito dall'input manuale di un rispondente.",
        resetValueIf: "Utilizza l'icona della bacchetta magica per impostare una regola condizionale che determini quando l'input di un rispondente viene reimpostato sul valore in base all'\"Espressione del valore predefinito\" o \"Imposta espressione del valore\" o al valore \"Risposta predefinita\" (se uno dei due è impostato).",
        setValueIf: "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che determina quando eseguire l'espressione \"Imposta valore\" e assegnare dinamicamente il valore risultante come risposta.",
        setValueExpression: "Specificare un'espressione che definisca il valore da impostare quando vengono soddisfatte le condizioni della regola \"Imposta valore se\". L'espressione può includere calcoli di base: '{q1_id} + {q2_id}', espressioni booleane, come '{age} > 60' e funzioni: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', ecc. Il valore determinato da questa espressione può essere sovrascritto dall'input manuale di un rispondente.",
        question: {
            name: "Un ID domanda che non è visibile ai rispondenti.",
            description: "Digita il sottotitolo di una domanda.",
            visibleIf: "Usa l'icona della bacchetta magica per impostare una regola condizionale che determina la visibilità delle domande.",
            enableIf: "Utilizza l'icona della bacchetta magica per impostare una regola condizionale che disabilita la modalità di sola lettura per la domanda.",
            requiredIf: "Utilizza l'icona della bacchetta magica per impostare una regola condizionale che impedisca l'avanzamento o l'invio dell'indagine a meno che la domanda non riceva una risposta.",
            startWithNewLine: "Deseleziona questa opzione per visualizzare la domanda in una riga con la domanda o il pannello precedente. L'impostazione non si applica se la domanda è il primo elemento del modulo.",
            page: "Riposiziona la domanda alla fine di una pagina selezionata.",
            state: "Scegli tra: \"Espandito\" - la casella della domanda viene visualizzata per intero e può essere compressa; \"Compresso\": la casella della domanda mostra solo il titolo e la descrizione e può essere espansa; \"Bloccata\": la casella della domanda viene visualizzata per intero e non può essere compressa.",
            titleLocation: "Sostituisce le regole di allineamento del titolo definite a livello di pannello, pagina o rilevamento. L'opzione \"Eredita\" applica tutte le impostazioni di livello superiore (se impostate) o le impostazioni a livello di indagine (\"In alto\" per impostazione predefinita).",
            descriptionLocation: "L'opzione \"Eredita\" applica l'impostazione a livello di indagine (\"Sotto il titolo della domanda\" per impostazione predefinita).",
            errorLocation: "Imposta la posizione di un messaggio di errore in relazione alla domanda con input non valido. Scegli tra: \"In alto\" - un testo di errore viene posizionato nella parte superiore della casella della domanda; \"In basso\": un testo di errore viene inserito nella parte inferiore della casella della domanda. L'opzione \"Eredita\" applica l'impostazione a livello di indagine (\"In alto\" per impostazione predefinita).",
            indent: "Aggiunge uno spazio o un margine tra il contenuto della domanda e il bordo sinistro della casella della domanda.",
            width: "Imposta la larghezza della domanda in proporzione agli altri elementi del sondaggio nella stessa riga. Accetta valori CSS (px, %, in, pt, ecc.).",
            surveyvalidator: {
                expression: "Usa l'icona della bacchetta magica per impostare una regola di convalida per la domanda."
            },
            textUpdateMode: "Scegli tra: \"In caso di perdita di messa a fuoco\" - il valore viene aggiornato quando il campo di immissione perde lo stato attivo; \"Durante la digitazione\": il valore viene aggiornato in tempo reale, mentre gli utenti digitano. L'opzione \"Eredita\" applica l'impostazione a livello di indagine (\"In caso di perdita di focus\" per impostazione predefinita).",
            url: "È possibile utilizzare qualsiasi servizio Web come origine dati per le domande a scelta multipla. Per popolare i valori di scelta, immettere l'URL del servizio che fornisce i dati.",
            searchMode: "Operazione di confronto utilizzata per filtrare l'elenco a discesa.",
            textWrapEnabled: "I testi lunghi nelle opzioni di scelta genereranno automaticamente interruzioni di riga per adattarsi al menu a discesa. Deselezionare questa opzione se si desidera che i testi vengano ritagliati."
        },
        signaturepad: {
            signatureWidth: "Imposta la larghezza dell'area della firma visualizzata e dell'immagine risultante.",
            signatureHeight: "Imposta l'altezza dell'area della firma visualizzata e dell'immagine risultante.",
            signatureAutoScaleEnabled: "Selezionare questa opzione se si desidera che l'area della firma occupi tutto lo spazio disponibile all'interno della casella della domanda, mantenendo le proporzioni 3:2 predefinite. Quando vengono impostati valori di larghezza e altezza personalizzati, l'impostazione manterrà le proporzioni di queste dimensioni."
        },
        file: {
            imageHeight: "Regola l'altezza dell'immagine nei risultati del rilevamento.",
            imageWidth: "Regola la larghezza dell'immagine nei risultati del rilevamento."
        },
        image: {
            contentMode: "L'opzione \"Auto\" determina automaticamente la modalità di visualizzazione adatta - Immagine, Video o YouTube - in base all'URL di origine fornito."
        },
        imagepicker: {
            imageHeight: "Sostituisce i valori di altezza minima e massima.",
            imageWidth: "Sostituisce i valori di larghezza minima e massima.",
            choices: "\"Valore\" funge da ID elemento utilizzato nelle regole condizionali; \"Testo\" viene visualizzato ai rispondenti.",
            contentMode: "Scegli tra \"Immagine\" e \"Video\" per impostare la modalità contenuto del selettore multimediale. Se è selezionata l'opzione \"Immagine\", assicurarsi che tutte le opzioni fornite siano file immagine nei seguenti formati: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Allo stesso modo, se è selezionato \"Video\", assicurarsi che tutte le opzioni siano collegamenti diretti a file video nei seguenti formati: MP4, MOV, WMV, FLV, AVI, MKV. Tieni presente che i link di YouTube non sono supportati per le opzioni video."
        },
        text: {
            size: "Questa impostazione ridimensiona solo il campo di input e non influisce sulla larghezza della casella della domanda. Per limitare la lunghezza di input accettata, passare a <b>Convalida → Limite massimo di caratteri</b>."
        },
        comment: {
            rows: "Imposta il numero di righe visualizzate nel campo di immissione. Se l'input occupa più righe, verrà visualizzata la barra di scorrimento."
        },
        // survey templates
        survey: {
            mode: "Scegli tra: \"Modificabile\" - consente ai rispondenti di compilare la tua indagine; \"Sola lettura\": disabilita la modifica del modulo."
        },
        matrixdropdowncolumn: {
            name: "Un ID colonna che non è visibile ai rispondenti.",
            isUnique: "Se abilitata per una colonna, un rispondente deve fornire una risposta univoca per ogni domanda all'interno di questa colonna.",
            rows: "Imposta il numero di righe visualizzate nel campo di immissione. Se l'input occupa più righe, verrà visualizzata la barra di scorrimento.",
            visibleIf: "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che determini la visibilità della colonna.",
            enableIf: "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che disabiliti la modalità di sola lettura per la colonna.",
            requiredIf: "Utilizza l'icona della bacchetta magica per impostare una regola condizionale che impedisca l'invio dell'indagine a meno che almeno una domanda nidificata non abbia una risposta.",
            showInMultipleColumns: "Quando questa opzione è selezionata, crea una singola colonna per ogni opzione di scelta."
        },
        widthMode: "Scegli tra: \"Statico\" - imposta una larghezza fissa; \"Responsive\" - fa sì che il sondaggio occupi l'intera larghezza dello schermo; \"Auto\": applica uno dei due a seconda del tipo di domanda utilizzato.",
        cookieName: "I cookie impediscono agli utenti di compilare due volte lo stesso sondaggio.",
        logo: "Incolla un link immagine (senza limiti di dimensione) o fai clic sull'icona della cartella per sfogliare un file dal tuo computer (fino a 64 KB).",
        logoWidth: "Imposta la larghezza del logo in unità CSS (px, %, in, pt e così via).",
        logoHeight: "Imposta l'altezza di un logo in unità CSS (px, %, in, pt e così via).",
        logoFit: "Scegli tra: \"Nessuna\" - l'immagine mantiene le sue dimensioni originali; \"Contieni\": l'immagine viene ridimensionata per adattarla mantenendo le sue proporzioni; \"Copertina\": l'immagine riempie l'intera scatola mantenendo le sue proporzioni; \"Riempi\" - l'immagine viene allungata per riempire la casella senza mantenerne le proporzioni.",
        goNextPageAutomatic: "Seleziona se desideri che l'indagine passi automaticamente alla pagina successiva dopo che un rispondente ha risposto a tutte le domande della pagina corrente.",
        allowCompleteSurveyAutomatic: "Seleziona questa opzione se desideri che l'indagine venga completata automaticamente dopo che un rispondente ha risposto a tutte le domande.",
        showNavigationButtons: "Imposta la visibilità e la posizione dei pulsanti di navigazione in una pagina.",
        showProgressBar: "Imposta la visibilità e la posizione di una barra di avanzamento. Il valore \"Auto\" mostra la barra di avanzamento sopra o sotto l'intestazione del sondaggio.",
        showPreviewBeforeComplete: "Abilita la pagina di anteprima con tutte le domande o solo con risposta.",
        questionTitleLocation: "Si applica a tutte le domande all'interno dell'indagine. Questa impostazione può essere sostituita dalle regole di allineamento del titolo ai livelli inferiori: pannello, pagina o domanda. Un'impostazione di livello inferiore sostituirà quelle di livello superiore.",
        requiredText: "Un simbolo o una sequenza di simboli che indica che è necessaria una risposta.",
        questionStartIndex: "Immettere un numero o una lettera con cui si desidera iniziare la numerazione.",
        questionErrorLocation: "Imposta la posizione di un messaggio di errore in relazione alla domanda con input non valido. Scegli tra: \"In alto\" - un testo di errore viene posizionato nella parte superiore della casella della domanda; \"In basso\": un testo di errore viene inserito nella parte inferiore della casella della domanda.",
        focusFirstQuestionAutomatic: "Selezionare se si desidera che il primo campo di immissione di ogni pagina sia pronto per l'immissione di testo.",
        questionsOrder: "Mantiene l'ordine originale delle domande o le rende casuali. L'effetto di questa impostazione è visibile solo nella scheda Anteprima.",
        maxTextLength: "Solo per domande di immissione di testo.",
        maxOthersLength: "Solo per i commenti alle domande.",
        commentAreaRows: "Imposta il numero di righe visualizzate nelle aree di testo per i commenti alle domande. Nell'input occupa più righe, viene visualizzata la barra di scorrimento.",
        autoGrowComment: "Selezionare questa opzione se si desidera che i commenti alle domande e le domande di testo lungo aumentino automaticamente in altezza in base alla lunghezza del testo inserito.",
        allowResizeComment: "Solo per i commenti alle domande e le domande a testo lungo.",
        calculatedValues: "Le variabili personalizzate fungono da variabili intermedie o ausiliarie utilizzate nei calcoli dei moduli. Accettano gli input dei rispondenti come valori di origine. Ogni variabile personalizzata ha un nome univoco e un'espressione su cui si basa.",
        includeIntoResult: "Selezionare questa opzione se si desidera che il valore calcolato dell'espressione venga salvato insieme ai risultati del rilevamento.",
        triggers: "Un trigger è un evento o una condizione basata su un'espressione. Una volta che l'espressione è stata valutata come \"true\", un trigger attiva un'azione. Un'azione di questo tipo può facoltativamente avere un effetto su una domanda di destinazione.",
        clearInvisibleValues: "Scegli se cancellare o meno i valori per le domande nascoste dalla logica condizionale e quando farlo.",
        textUpdateMode: "Scegli tra: \"In caso di perdita di messa a fuoco\" - il valore viene aggiornato quando il campo di immissione perde lo stato attivo; \"Durante la digitazione\": il valore viene aggiornato in tempo reale, mentre gli utenti digitano.",
        columns: "Il valore a sinistra funge da ID colonna utilizzato nelle regole condizionali, mentre il valore a destra viene visualizzato dai rispondenti.",
        rows: "Il valore a sinistra funge da ID riga utilizzato nelle regole condizionali, mentre il valore a destra viene visualizzato dai rispondenti.",
        columnMinWidth: "Accetta valori CSS (px, %, in, pt, ecc.).",
        rowTitleWidth: "Accetta valori CSS (px, %, in, pt, ecc.).",
        totalText: "Visibile solo quando almeno una colonna ha il tipo Totale o l'espressione Totale.",
        cellErrorLocation: "Imposta la posizione di un messaggio di errore in relazione a una cella con input non valido. L'opzione \"Eredita\" applica l'impostazione della proprietà \"Allineamento messaggi di errore\".",
        keyDuplicationError: "Quando la proprietà \"Impedisci risposte duplicate\" è abilitata, un rispondente che tenta di inviare una voce duplicata riceverà il seguente messaggio di errore.",
        totalExpression: "Consente di calcolare i valori totali in base a un'espressione. L'espressione può includere calcoli di base ('{q1_id} + {q2_id}'), espressioni booleane ('{age} > 60') e funzioni ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', ecc.).",
        confirmDelete: "Attiva un prompt che chiede di confermare l'eliminazione della riga.",
        defaultValueFromLastRow: "Duplica le risposte dell'ultima riga e le assegna alla successiva riga dinamica aggiunta.",
        keyName: "Se la colonna specificata contiene valori identici, il sondaggio produce l'errore \"Valore chiave non univoco\".",
        description: "Digita un sottotitolo.",
        locale: "Scegli una lingua per iniziare a creare la tua indagine. Per aggiungere una traduzione, passa a una nuova lingua e traduci il testo originale qui o nella scheda Traduzioni.",
        detailPanelMode: "Imposta la posizione di una sezione di dettagli in relazione a una riga. Scegli tra: \"Nessuna\" - non viene aggiunta alcuna espansione; \"Sotto la riga\": un'espansione di riga viene posizionata sotto ogni riga della matrice; \"Sotto la riga, visualizza solo un'espansione di riga\": un'espansione viene visualizzata solo sotto una singola riga, le espansioni di riga rimanenti vengono compresse.",
        imageFit: "Scegli tra: \"Nessuna\" - l'immagine mantiene le sue dimensioni originali; \"Contieni\": l'immagine viene ridimensionata per adattarla mantenendo le sue proporzioni; \"Copertina\": l'immagine riempie l'intera scatola mantenendo le sue proporzioni; \"Riempi\" - l'immagine viene allungata per riempire la casella senza mantenerne le proporzioni.",
        autoGrow: "Aumenta gradualmente l'altezza del campo di immissione man mano che i dati vengono inseriti. Sostituisce l'impostazione \"Altezza campo di immissione (in righe)\".",
        allowResize: "La maniglia di ridimensionamento (o grip) viene visualizzata nell'angolo e può essere trascinata per modificare le dimensioni del campo di immissione.",
        maxTimeToFinish: "Un intervallo di tempo in secondi dopo il quale l'indagine avanza automaticamente alla pagina di ringraziamento.",
        maxTimeToFinishPage: "Un intervallo di tempo in secondi dopo il quale il rilevamento avanza automaticamente alla pagina successiva.",
        page: {
            maxTimeToFinish: "Un intervallo di tempo in secondi dopo il quale il rilevamento avanza automaticamente alla pagina successiva.",
            visibleIf: "Usa l'icona della bacchetta magica per impostare una regola condizionale che determina la visibilità della pagina.",
            enableIf: "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che disabilita la modalità di sola lettura per la pagina.",
            requiredIf: "Utilizza l'icona della bacchetta magica per impostare una regola condizionale che impedisca l'invio dell'indagine a meno che almeno una domanda nidificata non abbia una risposta.",
            questionTitleLocation: "Si applica a tutte le domande all'interno di questa pagina. Se si desidera ignorare questa impostazione, definire le regole di allineamento dei titoli per le singole domande o pannelli. L'opzione \"Eredita\" applica l'impostazione a livello di indagine (\"In alto\" per impostazione predefinita).",
            questionTitleWidth: "Imposta una larghezza coerente per i titoli delle domande quando sono allineati a sinistra delle caselle delle domande. Accetta valori CSS (px, %, in, pt, ecc.).",
            questionErrorLocation: "Imposta la posizione di un messaggio di errore in relazione alla domanda con input non valido. Scegli tra: \"In alto\" - un testo di errore viene posizionato nella parte superiore della casella della domanda; \"In basso\": un testo di errore viene inserito nella parte inferiore della casella della domanda. L'opzione \"Eredita\" applica l'impostazione a livello di indagine (\"In alto\" per impostazione predefinita).",
            questionsOrder: "Mantiene l'ordine originale delle domande o le rende casuali. L'opzione \"Eredita\" applica l'impostazione a livello di indagine (\"Originale\" per impostazione predefinita). L'effetto di questa impostazione è visibile solo nella scheda Anteprima.",
            navigationButtonsVisibility: "Imposta la visibilità dei pulsanti di navigazione nella pagina. L'opzione \"Eredita\" applica l'impostazione a livello di indagine, che per impostazione predefinita è \"Visibile\"."
        },
        showTimerPanel: "Imposta la visibilità e la posizione di un timer in una pagina.",
        panelsState: "Scegli tra: \"Bloccato\" - gli utenti non possono espandere o comprimere i pannelli; \"Comprimi tutto\": tutti i pannelli iniziano in uno stato compresso; \"Espandi tutto\": tutti i pannelli iniziano in uno stato espanso; \"Prima espansa\": inizialmente viene espanso solo il primo pannello.",
        imageLinkName: "Immettere un nome di proprietà condivisa all'interno della matrice di oggetti che contiene gli URL del file di immagine o video che si desidera visualizzare nell'elenco di scelta.",
        choices: "Il valore a sinistra funge da ID elemento utilizzato nelle regole condizionali, mentre il valore a destra viene visualizzato dai rispondenti.",
        title: "Digitare un titolo descrittivo da visualizzare.",
        waitForUpload: "Garantisce che gli utenti non completino l'indagine fino a quando i file non vengono caricati.",
        minWidth: "Accetta valori CSS (px, %, in, pt, ecc.).",
        maxWidth: "Accetta valori CSS (px, %, in, pt, ecc.).",
        width: "Accetta valori CSS (px, %, in, pt, ecc.).",
        valueName: "Se non si imposta questa proprietà, la risposta sarà memorizzata in un campo specificato dalla proprietà Nome.",
        useDisplayValuesInDynamicTexts: "Nei tipi di domande a selezione singola e multipla, ogni opzione di scelta ha un ID e un valore di visualizzazione. Quando questa opzione è selezionata, questa impostazione mostra un valore di visualizzazione anziché un valore ID nelle domande HTML e nei titoli dinamici e nelle descrizioni degli elementi dell'indagine.",
        clearIfInvisible: "Scegli se cancellare o meno i valori delle domande nascosti dalla logica condizionale e quando farlo. L'opzione \"Eredita\" applica l'impostazione a livello di indagine (\"Al completamento dell'indagine\" per impostazione predefinita).",
        choicesFromQuestionMode: "Scegli tra: \"Tutte\" - copia tutte le opzioni di scelta dalla domanda selezionata; \"Selezionato\" - copia dinamicamente solo le opzioni di scelta selezionate; \"Non selezionato\" - copia dinamicamente solo le opzioni di scelta non selezionate. Le opzioni \"Nessuna\" e \"Altro\" vengono copiate per impostazione predefinita se abilitate nella domanda di origine.",
        showOtherItem: "Quando questa opzione è selezionata, gli utenti possono includere input aggiuntivi in una casella di commento separata.",
        separateSpecialChoices: "Visualizza ogni opzione di scelta speciale (\"Nessuna\", \"Altro\", \"Seleziona tutto\") su una nuova riga, anche quando si utilizza un layout a più colonne.",
        path: "Specificare la posizione all'interno del set di dati del servizio in cui si trova la matrice di oggetti di destinazione. Lasciare vuoto se l'URL punta già all'array.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Immettere un nome di proprietà uniforme all'interno della matrice di oggetti contenente i valori che si desidera visualizzare nell'elenco di scelte.",
        allowEmptyResponse: "Selezionare questa opzione per consentire al servizio di restituire una risposta o una matrice vuota.",
        choicesVisibleIf: "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che determina la visibilità di tutte le opzioni di scelta.",
        rateValues: "Il valore a sinistra funge da ID elemento utilizzato nelle regole condizionali, mentre il valore a destra viene visualizzato dai rispondenti.",
        rating: {
            displayMode: "\"Auto\" seleziona tra le modalità \"Pulsanti\" e \"Menu a discesa\" in base alla larghezza disponibile. Quando la larghezza è insufficiente per visualizzare i pulsanti, la domanda visualizza un menu a discesa."
        },
        valuePropertyName: "Consente di collegare domande che producono risultati in formati diversi. Quando tali domande sono collegate tra loro utilizzando un identificatore di join, questa proprietà condivisa memorizza i valori delle domande selezionate.",
        searchEnabled: "Selezionare questa opzione se si desidera aggiornare il contenuto del menu a discesa in modo che corrisponda alla query di ricerca digitata dall'utente nel campo di immissione.",
        valueTrue: "Un valore da salvare nei risultati dell'indagine quando i rispondenti danno una risposta positiva.",
        valueFalse: "Un valore da salvare nei risultati dell'indagine quando i rispondenti danno una risposta negativa.",
        showPreview: "Non è consigliabile disabilitare questa opzione in quanto sostituisce l'immagine di anteprima e rende difficile per un utente capire se i file sono stati caricati.",
        needConfirmRemoveFile: "Attiva un prompt che chiede di confermare l'eliminazione del file.",
        selectToRankEnabled: "Abilita per classificare solo le scelte selezionate. Gli utenti trascineranno gli elementi selezionati dall'elenco di scelta per ordinarli all'interno dell'area di classificazione.",
        dataList: "Inserisci un elenco di scelte che verranno suggerite al rispondente durante l'inserimento.",
        itemSize: "L'impostazione ridimensiona solo i campi di input e non influisce sulla larghezza della casella della domanda.",
        itemTitleWidth: "Imposta una larghezza coerente per tutte le etichette degli elementi in pixel",
        altText: "Funge da sostituto quando l'immagine non può essere visualizzata sul dispositivo di un utente e per motivi di accessibilità.",
        rateColorMode: "Definisce il colore dell'emoji selezionata quando il tipo di icona Valutazione è impostato su \"Smiley\". Scegli tra: \"Predefinito\" - l'emoji selezionata appare nel colore predefinito del sondaggio; \"Scala\": l'emoji selezionata eredita il colore dalla scala di valutazione.",
        expression: {
            name: "Un ID espressione che non è visibile ai rispondenti.",
            description: "Digitare un sottotitolo dell'espressione.",
            expression: "Un'espressione può includere calcoli di base ('{q1_id} + {q2_id}'), condizioni ('{età} > 60') e funzioni ('iif()', 'oggi()', 'età()', 'min()', 'max()', 'avg()' e così via)."
        },
        storeOthersAsComment: "Selezionare questa opzione per memorizzare il valore dell'opzione \"Altro\" come proprietà separata nei risultati del rilevamento.",
        format: "Usa {0} come segnaposto per il valore effettivo.",
        acceptedTypes: "Per ulteriori informazioni, consultare la descrizione dell'attributo [accept](https://www.w3schools.com/tags/att_input_accept.asp).",
        columnColCount: "Applicabile solo ai tipi di cella Opzione multipla e Casella di controllo.",
        autocomplete: "Per ulteriori informazioni, consultare la descrizione dell'attributo [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete).",
        filePlaceholder: "Si applica quando \"Tipo di origine\" è \"File locali\" o quando la fotocamera non è disponibile",
        photoPlaceholder: "Si applica quando \"Tipo di sorgente\" è \"Fotocamera\".",
        fileOrPhotoPlaceholder: "Si applica quando \"Tipo di origine\" è \"File locali o fotocamera\".",
        masksettings: {
            saveMaskedValue: "Selezionare questa opzione se si desidera memorizzare il valore della domanda con una maschera applicata nei risultati dell'indagine."
        },
        patternmask: {
            pattern: "Il modello può contenere valori letterali stringa e i segnaposto seguenti: '9' - per una cifra; 'a' - per una lettera maiuscola o minuscola; '#' - per una cifra o una lettera maiuscola o minuscola. Usa la barra rovesciata '\\' per eseguire l'escape di un carattere."
        },
        datetimemask: {
            pattern: "Il modello può contenere caratteri separatori e i seguenti segnaposto:<br>'m' - Numero del mese.<br>'mm' - Numero del mese, con zero iniziale per i valori a una cifra. <br>'d' - Giorno del mese. <br>'dd' - Giorno del mese, con zero iniziale per i valori a una cifra. <br>'yy' - Le ultime due cifre dell'anno. <br>'yyyy' - Anno a quattro cifre. <br>'H' - Ore nel formato 24 ore. <br>'HH' - Ore nel formato 24 ore, con zero iniziale per i valori a una cifra. <br>'h' - Ore nel formato 12 ore. <br>'hh' - Ore nel formato 12 ore, con zero iniziale per i valori a una cifra. <br>«MM» - Processo verbale. <br>'ss' - Secondi. <br>'TT' - Periodo di 12 ore in maiuscolo (AM/PM). <br>'TT' - Periodo di 12 ore in minuscolo (AM/PM)."
        },
        numericmask: {
            decimalSeparator: "Simbolo utilizzato per separare la parte frazionaria dalla parte intera di un numero visualizzato.",
            thousandsSeparator: "Simbolo utilizzato per separare le cifre di un numero elevato in gruppi di tre.",
            precision: "Limita il numero di cifre da mantenere dopo la virgola decimale per un numero visualizzato."
        },
        currencymask: {
            prefix: "Uno o più simboli da visualizzare prima del valore.",
            suffix: "Uno o più simboli da visualizzare dopo il valore."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "Titolo",
            title: "Lascialo vuoto, se è uguale a 'Nome'"
        },
        multiSelect: "Consenti selezione multipla",
        showLabel: "Mostra le didascalie delle immagini",
        swapOrder: "Scambia l'ordine di Sì e No",
        value: "Valore",
        tabAlign: "Allineamento delle tabulazioni",
        sourceType: "Tipo di origine",
        fitToContainer: "Adatto al contenitore",
        setValueExpression: "Espressione del valore impostato",
        description: "Descrizione",
        logoFit: "Adattamento del logo",
        pages: "Pagine",
        questions: "Domande",
        triggers: "Triggers",
        calculatedValues: "Valori calcolati",
        surveyId: "ID sondaggio",
        surveyPostId: "ID post sondaggio",
        surveyShowDataSaving: "Il sondaggio mostra il salvataggio dei dati",
        questionDescriptionLocation: "Posizione descrizione domanda",
        progressBarType: "Tipo barra di avanzamento",
        showTOC: "Mostra sommario",
        tocLocation: "Posizione Toc",
        questionTitlePattern: "Modello titolo della domanda",
        widthMode: "Larghezza sondaggio",
        showBrandInfo: "Mostra informazioni sul marchio",
        useDisplayValuesInDynamicTexts: "Usa Valori di Riferimento nel titolo",
        visibleIf: "Visibile Se",
        defaultValueExpression: "Espressione valore predefinito",
        requiredIf: "Obbligatoria Se",
        resetValueIf: "Reimposta valore se",
        setValueIf: "Imposta valore se",
        validators: "Validatori",
        bindings: "Collegamenti",
        renderAs: "Esegui il rendering come",
        attachOriginalItems: "Allega elementi originali",
        choices: "Scelte",
        choicesByUrl: "Scelte per url",
        currency: "Valuta",
        cellHint: "Suggerimento cella",
        totalMaximumFractionDigits: "Cifre totali della frazione massima",
        totalMinimumFractionDigits: "Cifre di frazione minima totale",
        columns: "Colonne",
        detailElements: "Elementi di dettaglio",
        allowAdaptiveActions: "Consenti azioni adattive",
        defaultRowValue: "Valore predefinito Riga",
        detailPanelShowOnAdding: "Dettaglio Mostra Pannello su Aggiunta",
        choicesLazyLoadEnabled: "Scelte lazy load abilitate",
        choicesLazyLoadPageSize: "Scelte lazy load dimensione della pagina",
        inputFieldComponent: "Componente del campo di input",
        itemComponent: "Componente dell'articolo",
        min: "min",
        max: "max",
        minValueExpression: "Valore min Espressione",
        maxValueExpression: "Valore max Espressione",
        step: "Distanza",
        dataList: "Lista dati",
        itemSize: "Dimensione opzione",
        itemTitleWidth: "Larghezza dell'etichetta dell'articolo (in px)",
        elements: "Elementi",
        content: "Contenuto",
        navigationButtonsVisibility: "Visibilità Pulsanti di navigazione",
        navigationTitle: "Titolo navigazione",
        navigationDescription: "Descrizione navigazione",
        longTap: "Tocco prolungato",
        autoGrow: "Espansione automatica",
        allowResize: "Consenti ridimensionamento",
        acceptCarriageReturn: "Accetta la restituzione in capo",
        displayMode: "Modalità di visualizzazione",
        rateType: "Tipo di tariffa",
        label: "Etichetta",
        contentMode: "Modalità contenuto",
        imageFit: "Adattamento dell'immagine",
        altText: "Testo alternativo",
        height: "Altezza",
        penColor: "Colore penna",
        backgroundColor: "Colore sfondo",
        templateElements: "Elementi del modello",
        operator: "Operatore",
        isVariable: "È variabile",
        runExpression: "Esegui espressione",
        showCaption: "Mostra didascalia",
        iconName: "Nome icona",
        iconSize: "Grandezza icona",
        precision: "Precisione",
        matrixDragHandleArea: "Area della maniglia di trascinamento della matrice",
        backgroundImage: "Immagine di sfondo",
        backgroundImageFit: "Adattamento dell'immagine di sfondo",
        backgroundImageAttachment: "Allegato immagine di sfondo",
        backgroundOpacity: "Opacità dello sfondo",
        selectToRankEnabled: "Seleziona per classificare abilitato",
        selectToRankAreasLayout: "Selezionare per classificare il layout delle aree",
        selectToRankEmptyRankedAreaText: "Testo da mostrare se tutte le opzioni sono selezionate",
        selectToRankEmptyUnrankedAreaText: "Testo segnaposto per l'area di classificazione",
        allowCameraAccess: "Consenti accesso alla videocamera",
        scaleColorMode: "Modalità scala colore",
        rateColorMode: "Valuta la modalità colore",
        copyDisplayValue: "Copia valore di visualizzazione",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Modalità avanzata",
        pageTitle: "Carattere del titolo della pagina",
        questionTitle: "Tipo di carattere del titolo della domanda",
        editorPanel: "Elemento di input",
        lines: "Poema",
        primaryDefaultColor: "Default",
        primaryDarkColor: "Fluttuare",
        primaryLightColor: "Selezionato",
        backgroundDimColor: "Colore di sfondo",
        cornerRadius: "Raggio d'angolo",
        backcolor: "Sfondo predefinito",
        hovercolor: "Sfondo al passaggio del mouse",
        borderDecoration: "Decorazione del bordo",
        fontColor: "Colore del carattere",
        backgroundColor: "Colore di sfondo",
        primaryForecolor: "Colore predefinito",
        primaryForecolorLight: "Colore disabilitato",
        font: "Font",
        borderDefault: "Scuro",
        borderLight: "Accendino",
        fontFamily: "Famiglia di caratteri",
        fontWeightRegular: "Regolare",
        fontWeightHeavy: "Pesante",
        fontWeightSemiBold: "Semi-grassetto",
        fontWeightBold: "Audace",
        color: "Colore",
        placeholderColor: "Colore segnaposto",
        size: "Grandezza",
        opacity: "Opacità",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Aggiungi effetto ombra",
        boxShadowBlur: "Sfocatura",
        boxShadowSpread: "Diffusione",
        boxShadowDrop: "Goccia",
        boxShadowInner: "Interno",
        names: {
            default: "Default",
            sharp: "Affilato",
            borderless: "Borderless",
            flat: "Appartamento",
            plain: "Pianura",
            doubleborder: "Doppio bordo",
            layered: "Stratificato",
            solid: "Solido",
            threedimensional: ".3D",
            contrast: "Contrasto"
        },
        colors: {
            teal: "Color foglia di tè",
            blue: "Blu",
            purple: "Porpora",
            orchid: "Orchidea",
            tulip: "Tulipano",
            brown: "Marrone",
            green: "Verde"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["it"] = italianTranslation;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// qt.tagbox: "Multi-Select Dropdown" => "Menù a discesa a selezione multipla"
// ed.surveySettings: "Survey Settings" => "Impostazioni del sondaggio"
// ed.surveySettingsTooltip: "Open survey settings" => "Apri le impostazioni del sondaggio"
// ed.themeSurvey: "Themes" => "Temi"
// ed.showMoreChoices: "Show more" => "Mostra di più"
// ed.showLessChoices: "Show less" => "Mostra meno"
// ed.toolboxChoiceCategory: "Choice Questions" => "Domande a scelta"
// ed.toolboxTextCategory: "Text Input Questions" => "Domande sull'input di testo"
// ed.toolboxContainersCategory: "Containers" => "Contenitori"
// ed.toolboxMatrixCategory: "Matrix Questions" => "Domande sulla matrice"
// ed.toolboxMiscCategory: "Misc" => "Altri"
// ed.themePropertyGridTitle: "Theme Settings" => "Impostazioni del tema"
// ed.themeExportButton: "Export" => "Esportazione"
// ed.themeImportButton: "Import" => "Importazione"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Le scelte vengono copiate da"
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Trascina e rilascia un'immagine qui o fai clic sul pulsante qui sotto e scegli un'immagine da caricare"
// ed.imageChooseImage: "Choose Image" => "Scegli immagine"
// ed.auto: "auto" => "Automatico"
// ed.choices_Item: "Item " => "Articolo "
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "Valore chiaro della domanda: {0}"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Le regole logiche sono incomplete"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Alcune regole logiche non sono state completate. Se lasci la scheda ora, le modifiche andranno perse. Vuoi comunque uscire dalla scheda senza completare le modifiche?"
// lg.uncompletedRule_apply: "Yes" => "Sì"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "No, voglio completare le regole"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "È possibile impostare i dati nel seguente formato:\nvalore1|testo\nvalore2"
// pe.overridingPropertyPrefix: "Set by " => "Impostato da "
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Non utilizzare parole riservate: \"articolo\", \"scelta\", \"pannello\", \"riga\"."
// choicesbyurl.valueName: "Get values from the following JSON field" => "Ottenere valori dal seguente campo JSON"
// pe.and: "and" => "e"
// pe.or: "or" => "o"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Selezionare una domanda per iniziare a configurare le condizioni."
// pe.then: "then" => "allora"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Altezza immagine (in valori accettati da CSS)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Larghezza immagine (in valori accettati da CSS)"
// pe.allowResizeComment: "Allow users to resize text areas" => "Consenti agli utenti di ridimensionare le aree di testo"
// pe.rateCount: "Rate count" => "Conteggio delle tariffe"
// pe.autoGenerate: "How to specify rate values?" => "Come specificare i valori dei tassi?"
// pe.minSelectedChoices: "Minimum selected choices" => "Numero minimo di scelte selezionate"
// itemvalue.text: "Alt text" => "Testo alternativo"
// tabs.expression: "Expression" => "Espressione"
// pe.valuePropertyName: "Value property name" => "Nome della proprietà Value"
// pe.searchEnabled: "Enable search" => "Abilita ricerca"
// pe.hideSelectedItems: "Hide selected items" => "Nascondere gli elementi selezionati"
// pe.closeOnSelect: "Close the dropdown after selection" => "Chiudere il menu a discesa dopo la selezione"
// pe.signatureWidth: "Signature width" => "Larghezza firma"
// pe.signatureHeight: "Signature height" => "Altezza firma"
// pe.verticalAlign: "Vertical alignment" => "Allineamento verticale"
// pe.alternateRows: "Alternate rows" => "Righe alternate"
// pe.rateType: "Rate type" => "Tipo di tariffa"
// pv.true: "true" => "vero"
// pv.false: "false" => "falso"
// pv.decimal: "decimal" => "decimale"
// pv.currency: "currency" => "valuta"
// pv.percent: "percent" => "percento"
// pv.tab: "Tabs" => "Schede"
// pv.color: "color" => "Colore"
// pv.date: "date" => "dattero"
// pv.datetime: "datetime" => "datetime"
// pv.datetime-local: "datetime-local" => "datetime-local"
// pv.email: "email" => "E-mail"
// pv.month: "month" => "mese"
// pv.number: "number" => "numero"
// pv.password: "password" => "parola d’ordine"
// pv.range: "range" => "gamma"
// pv.tel: "tel" => "Tel"
// pv.text: "text" => "Testo"
// pv.time: "time" => "Ore"
// pv.url: "url" => "URL"
// pv.week: "week" => "settimana"
// inputType.color: "Color" => "Colore"
// inputType.date: "Date" => "Dattero"
// inputType.datetime-local: "Date and Time" => "Data e ora"
// inputType.email: "Email" => "E-mail"
// inputType.month: "Month" => "Mese"
// inputType.number: "Number" => "Numero"
// inputType.password: "Password" => "Parola d’ordine"
// inputType.range: "Range" => "Gamma"
// inputType.tel: "Phone Number" => "Numero di telefono"
// inputType.text: "Text" => "Testo"
// inputType.time: "Time" => "Ore"
// inputType.url: "URL" => "URL"
// inputType.week: "Week" => "Settimana"
// widthMode.auto: "Auto" => "Automatico"
// widthMode.static: "Static" => "Statico"
// widthMode.responsive: "Responsive" => "Reattivo"
// imageFit.none: "None" => "Nessuno"
// imageFit.contain: "Contain" => "Contenere"
// imageFit.cover: "Cover" => "Coprire"
// imageFit.fill: "Fill" => "Riempire"
// contentMode.auto: "Auto" => "Automatico"
// contentMode.image: "Image" => "Immagine"
// contentMode.video: "Video" => "Video"
// contentMode.youtube: "YouTube" => "Collegamenti esterni"
// displayMode.auto: "Auto" => "Automatico"
// displayMode.buttons: "Buttons" => "Pulsanti"
// displayMode.dropdown: "Dropdown" => "Menù a discesa"
// rateColorMode.default: "Default" => "Default"
// autoGenerate.true: "Generate" => "Generare"
// autoGenerate.false: "Enter manually" => "Inserisci manualmente"
// rateType.labels: "Labels" => "Etichette"
// rateType.stars: "Stars" => "Stelle"
// rateType.smileys: "Smileys" => "Faccine"
// op.and: "and" => "e"
// op.or: "or" => "o"
// ts.hideInvisibleElements: "Hide invisible elements" => "Nascondi elementi invisibili"
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Ridimensiona l'area visibile del campo di input. Utilizzare l'impostazione <b>Convalida → lunghezza massima</b> per limitare la lunghezza di input."
// choicesbyurl.valueName: " " => " "
// p.value: "Value" => "Valore"
// p.tabAlign: "Tab alignment" => "Allineamento delle tabulazioni"
// p.questions: "Questions" => "Domande"
// p.surveyId: "Survey id" => "ID sondaggio"
// p.surveyPostId: "Survey post id" => "ID post sondaggio"
// p.surveyShowDataSaving: "Survey show data saving" => "Il sondaggio mostra il salvataggio dei dati"
// p.showTOC: "Show TOC" => "Mostra sommario"
// p.tocLocation: "Toc location" => "Posizione Toc"
// p.showBrandInfo: "Show brand info" => "Mostra informazioni sul marchio"
// p.renderAs: "Render as" => "Esegui il rendering come"
// p.attachOriginalItems: "Attach original items" => "Allega elementi originali"
// p.choicesByUrl: "Choices by url" => "Scelte per url"
// p.cellHint: "Cell hint" => "Suggerimento cella"
// p.isUnique: "Is unique" => "È unico"
// p.showInMultipleColumns: "Show in multiple columns" => "Mostra in più colonne"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Cifre totali della frazione massima"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Cifre di frazione minima totale"
// p.detailElements: "Detail elements" => "Elementi di dettaglio"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Consenti azioni adattive"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Scelte lazy load abilitate"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Scelte lazy load dimensione della pagina"
// p.inputFieldComponent: "Input field component" => "Componente del campo di input"
// p.itemComponent: "Item component" => "Componente dell'articolo"
// p.elements: "Elements" => "Elementi"
// p.content: "Content" => "Contenuto"
// p.longTap: "Long tap" => "Tocco prolungato"
// p.allowResize: "Allow resizing" => "Consenti ridimensionamento"
// p.acceptCarriageReturn: "Accept carriage return" => "Accetta la restituzione in capo"
// p.displayMode: "Display mode" => "Modalità di visualizzazione"
// p.rateType: "Rate type" => "Tipo di tariffa"
// p.altText: "Alt text" => "Testo alternativo"
// p.templateElements: "Template elements" => "Elementi del modello"
// p.operator: "Operator" => "Operatore"
// p.isVariable: "Is variable" => "È variabile"
// p.runExpression: "Run expression" => "Esegui espressione"
// p.precision: "Precision" => "Precisione"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Area della maniglia di trascinamento della matrice"
// p.backgroundImage: "Background image" => "Immagine di sfondo"
// p.backgroundImageFit: "Background image fit" => "Adattamento dell'immagine di sfondo"
// p.backgroundImageAttachment: "Background image attachment" => "Allegato immagine di sfondo"
// p.backgroundOpacity: "Background opacity" => "Opacità dello sfondo"
// p.selectToRankEnabled: "Select to rank enabled" => "Seleziona per classificare abilitato"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Selezionare per classificare il layout delle aree"
// p.allowCameraAccess: "Allow camera access" => "Consenti accesso alla videocamera"
// p.scaleColorMode: "Scale color mode" => "Modalità scala colore"
// p.rateColorMode: "Rate color mode" => "Valuta la modalità colore"
// p.templateTabTitle: "Template tab title" => "Titolo della scheda Modello"
// p.templateVisibleIf: "Template visible if" => "Modello visibile se"
// p.copyDisplayValue: "Copy display value" => "Copia valore di visualizzazione"
// theme.--background: "Background color" => "Colore di sfondo"
// theme.--background-dim-light: "Background dim light color" => "Colore della luce fioca dello sfondo"
// theme.--primary-foreground: "Primary foreground color" => "Colore di primo piano primario"
// theme.--foreground: "Foreground color" => "Colore di primo piano"
// theme.--base-unit: "Base unit" => "Unità base"
// theme.groupAdvanced: "Advanced" => "Avanzato"
// theme.themeName: "Theme" => "Tema"
// theme.isPanellessss: "Question appearance" => "Aspetto della domanda"
// theme.isPanellessPanels: "Default" => "Default"
// theme.isPanellessLightweight: "Without Panels" => "Senza pannelli"
// theme.themePaletteLight: "Light" => "Leggero"
// theme.themePaletteDark: "Dark" => "Oscuro"
// theme.primaryColor: "Accent color" => "Colore principale"
// theme.primaryDefaultColor: "Default" => "Default"
// theme.primaryDarkColor: "Hover" => "Fluttuare"
// theme.primaryLightColor: "Selected" => "Selezionato"
// theme.backgroundDimColor: "Background color" => "Colore di sfondo"
// theme.backgroundImage: "Background image" => "Immagine di sfondo"
// theme.backgroundImageFitAuto: "Auto" => "Automatico"
// theme.backgroundImageFitCover: "Cover" => "Coprire"
// theme.backgroundImageFitContain: "Contain" => "Contenere"
// theme.backgroundOpacity: "Opacity" => "Opacità"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Fissato"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Scorrere"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Opacità dello sfondo del pannello"
// theme.questionBackgroundTransparency: "Question background opacity" => "Opacità dello sfondo della domanda"
// theme.questionPanel: "Panel background and corner radius" => "Sfondo del pannello e raggio d'angolo"
// theme.questionTitle: "Question title font" => "Tipo di carattere del titolo della domanda"
// theme.questionDescription: "Question description font" => "Carattere della descrizione della domanda"
// theme.editorPanel: "Input element" => "Elemento di input"
// theme.editorFont: "Input element font" => "Tipo di carattere dell'elemento di input"
// theme.backcolor: "Default background" => "Sfondo predefinito"
// theme.hovercolor: "Hover background" => "Sfondo al passaggio del mouse"
// theme.borderDecoration: "Border decoration" => "Decorazione del bordo"
// theme.accentBackground: "Accent background" => "Sfondo principale"
// theme.accentForeground: "Accent foreground" => "Primo piano in primo piano"
// theme.primaryForecolor: "Default color" => "Colore predefinito"
// theme.primaryForecolorLight: "Disabled color" => "Colore disabilitato"
// theme.linesColors: "Minor line colors" => "Colori di linea secondari"
// theme.borderDefault: "Darker" => "Scuro"
// theme.borderLight: "Lighter" => "Accendino"
// theme.fontFamily: "Font family" => "Famiglia di caratteri"
// theme.fontSize: "Font size" => "Dimensione del carattere"
// theme.color: "Color" => "Colore"
// theme.size: "Size" => "Grandezza"
// theme.fontWeightRegular: "Regular" => "Regolare"
// theme.fontWeightHeavy: "Heavy" => "Pesante"
// theme.fontWeightSemiBold: "Semi-bold" => "Semi-grassetto"
// theme.fontWeightBold: "Bold" => "Audace"
// theme.scale: "Scale" => "Scala"
// theme.cornerRadius: "Corner radius" => "Raggio d'angolo"
// theme.surveyTitleFont: "Survey title font" => "Carattere del titolo del sondaggio"
// theme.pageTitle: "Page title font" => "Carattere del titolo della pagina"
// theme.pageDescription: "Page description font" => "Carattere della descrizione della pagina"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Aggiungi effetto ombra"
// theme.opacity: "Opacity" => "Opacità"
// theme.boxShadowBlur: "Blur" => "Sfocatura"
// theme.boxShadowSpread: "Spread" => "Diffusione"
// theme.boxShadowDrop: "Drop" => "Goccia"
// theme.boxShadowInner: "Inner" => "Interno"
// theme.questionShadow: "Shadow effects" => "Effetti ombra"
// theme.editorShadow: "Input element shadow effects" => "Effetti di ombreggiatura dell'elemento di input"
// names.default: "Default" => "Default"
// names.contrast: "Contrast" => "Contrasto"
// names.plain: "Plain" => "Pianura"
// names.simple: "Simple" => "Semplice"
// names.blank: "Blank" => "Vuoto"
// names.double: "Double" => "Doppio"
// names.bulk: "Bulk" => "Massa"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo 3D"
// names.playful: "Playful" => "Giocoso"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Color foglia di tè"
// colors.blue: "Blue" => "Blu"
// colors.purple: "Purple" => "Porpora"
// colors.orchid: "Orchid" => "Orchidea"
// colors.tulip: "Tulip" => "Tulipano"
// colors.brown: "Brown" => "Marrone"
// colors.green: "Green" => "Verde"
// names.sharp: "Sharp" => "Affilato"
// names.borderless: "Borderless" => "Borderless"
// names.flat: "Flat" => "Appartamento"
// names.doubleborder: "Double Border" => "Doppio bordo"
// names.layered: "Layered" => "Stratificato"
// names.solid: "Solid" => "Solido"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Sei sicuro di voler eliminare tutte le stringhe per questa lingua?"
// ed.themeResetButton: "Reset theme settings to default" => "Ripristina le impostazioni del tema predefinite"
// theme.placeholderColor: "Placeholder color" => "Colore segnaposto"
// ed.themeSettings: "Theme Settings" => "Impostazioni del tema"
// ed.themeSettingsTooltip: "Open theme settings" => "Apri le impostazioni del tema"
// pe.resetToDefaultCaption: "Reset" => "Resettare"
// pv.file: "Local files" => "File locali"
// pv.camera: "Camera" => "Macchina fotografica"
// pv.file-camera: "Local files or camera" => "File locali o fotocamera"
// ed.translateUsigAI: "Auto-translate All" => "Traduzione automatica di tutto"
// ed.translationDialogTitle: "Untranslated strings" => "Stringhe non tradotte"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Inserisci almeno {0} elementi"
// lg.question_resetValueName: "Reset question value" => "Reimpostare il valore della domanda"
// lg.column_resetValue: "Reset column value" => "Reimposta valore colonna"
// pe.markRequired: "Mark as required" => "Contrassegna come richiesto"
// pe.removeRequiredMark: "Remove the required mark" => "Rimuovere il segno richiesto"
// p.resetValueIf: "Reset value if" => "Reimposta valore se"
// lg.question_setValueName: "Set question value" => "Impostare il valore della domanda"
// lg.column_resetValueName: "Reset column value" => "Reimposta valore colonna"
// lg.column_setValueName: "Set column value" => "Impostare il valore della colonna"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Espressione il cui risultato verrà assegnato alla domanda di destinazione."
// survey.title: "Title" => "Titolo"
// page.title: "Title" => "Titolo"
// p.setValueIf: "Set value if" => "Imposta valore se"
// theme.header: "Header" => "Intestazione"
// theme.backgroundImageFitFill: "Stretch" => "Stendere"
// theme.backgroundImageFitTile: "Tile" => "Tegola"
// theme.headerView: "View" => "Vista"
// theme.headerViewBasic: "Basic" => "Basico"
// theme.headerViewAdvanced: "Advanced" => "Avanzato"
// theme.headerInheritWidthFrom: "Content area width" => "Larghezza dell'area di contenuto"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Come il sondaggio"
// theme.headerInheritWidthFromPage: "Fit to page" => "Adatta alla pagina"
// theme.headerTextAreaWidth: "Text width" => "Larghezza del testo"
// theme.headerBackgroundColorSwitch: "Background color" => "Colore di sfondo"
// theme.headerBackgroundColorNone: "None" => "Nessuno"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Colore principale"
// theme.headerBackgroundColorCustom: "Custom" => "Costume"
// theme.horizontalAlignmentLeft: "Left" => "A sinistra"
// theme.horizontalAlignmentCenter: "Center" => "Centro"
// theme.horizontalAlignmentRight: "Right" => "A destra"
// theme.verticalAlignmentTop: "Top" => "In alto"
// theme.verticalAlignmentMiddle: "Middle" => "Mezzo"
// theme.verticalAlignmentBottom: "Bottom" => "Fondoschiena"
// theme.logoPosition: "Logo Position" => "Posizione del logo"
// theme.headerTitlePosition: "Title Position" => "Posizione del titolo"
// lg.question_resetValueText: "reset value for question: {0}" => "Valore di ripristino per la domanda: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Assegna valore: {1} alla domanda: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Reimposta il valore della cella per la colonna: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Assegna valore cella: {1} alla colonna: {0}"
// ed.surveyJsonExportButton: "Export" => "Esportazione"
// ed.surveyJsonImportButton: "Import" => "Importazione"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Copia negli Appunti"
// pe.filePlaceholder: "File placeholder text" => "Testo segnaposto del file"
// pe.photoPlaceholder: "Photo placeholder text" => "Testo segnaposto foto"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Testo segnaposto per file o foto"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Si applica quando \"Tipo di origine\" è \"File locali\" o quando la fotocamera non è disponibile"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Si applica quando \"Tipo di sorgente\" è \"Fotocamera\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Si applica quando \"Tipo di origine\" è \"File locali o fotocamera\"."
// theme.background: "Background" => "Sfondo"
// theme.appearance: "Appearance" => "Apparenza"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Vuoi davvero resettare il tema? Tutte le tue personalizzazioni andranno perse."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Sì, reimposta il tema"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Adatto al contenitore"
// signaturepad.showPlaceholder: "Show the placeholder" => "Visualizzare il segnaposto"
// signaturepad.placeholder: "Placeholder text" => "Testo segnaposto"
// theme.surveyDescriptionFont: "Survey description font" => "Carattere della descrizione dell'indagine"
// ed.prevFocus: "Focus previous" => "Focus precedente"
// ed.nextFocus: "Focus next" => "Focus successivo"
// ed.saveTheme: "Save Theme" => "Salva tema"
// ed.saveThemeTooltip: "Save Theme" => "Salva tema"
// lg.page_requireName: "Make page required" => "Rendi la pagina obbligatoria"
// lg.panel_requireName: "Make page required" => "Rendi la pagina obbligatoria"
// signaturepad.signatureWidth: "Signature area width" => "Larghezza dell'area della firma"
// signaturepad.signatureHeight: "Signature area height" => "Altezza dell'area della firma"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Ridimensionamento automatico dell'area della firma"
// signaturepad.penMinWidth: "Minimum pen width" => "Larghezza minima della penna"
// signaturepad.penMaxWidth: "Maximum pen width" => "Larghezza massima della penna"
// theme.headerDescriptionPosition: "Description position" => "Descrizione posizione"
// ed.propertyGridNoResultsFound: "No results found" => "Nessun risultato trovato"
// pv.leftRight: "Left and right" => "Destra e sinistra"
// p.sourceType: "Source type" => "Tipo di origine"
// p.fitToContainer: "Fit to container" => "Adatto al contenitore"
// p.setValueExpression: "Set value expression" => "Espressione del valore impostato"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Le scelte vengono caricate da un servizio Web."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Vai alle impostazioni"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Anteprima delle opzioni di scelta caricate"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Impedisci risposte duplicate nelle righe"
// theme.advancedMode: "Advanced mode" => "Modalità avanzata"
// theme.backgroundCornerRadius: "Background and corner radius" => "Sfondo e raggio d'angolo"
// theme.colorsTitle: "Colors" => "Colori"
// theme.font: "Font" => "Font"
// theme.lines: "Lines" => "Poema"
// theme.titleFont: "Title font" => "Carattere del titolo"
// theme.descriptionFont: "Description font" => "Carattere di descrizione"
// theme.shadow: "Shadow effects" => "Effetti ombra"
// ed.translateUsigAIFrom: "Translate from: " => "Traduci da: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Consenti l'opzione Rifiuta di rispondere"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Consenti l'opzione Non so"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Consenti l'opzione Rifiuta di rispondere"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Consenti l'opzione Non so"
// pv.contain: "Contain" => "Contenere"
// pv.cover: "Cover" => "Coprire"
// pv.fill: "Fill" => "Riempire"
// pe.transposeData: "Transpose rows to columns" => "Trasponi righe in colonne"
// layout.panel: "Layout" => "Impaginazione"
// layout.question: "Layout" => "Impaginazione"
// layout.base: "Layout" => "Impaginazione"
// panel.name: "Panel name" => "Nome del pannello"
// panel.title: "Panel title" => "Titolo del panel"
// panel.description: "Panel description" => "Descrizione del pannello"
// panel.visibleIf: "Make the panel visible if" => "Rendi visibile il pannello se"
// panel.requiredIf: "Make the panel required if" => "Rendere il pannello richiesto se"
// panel.questionsOrder: "Question order within the panel" => "Ordine delle domande all'interno del panel"
// panel.startWithNewLine: "Display the panel on a new line" => "Visualizzare il pannello su una nuova riga"
// panel.state: "Panel collapse state" => "Stato di compressione del pannello"
// panel.width: "Inline panel width" => "Larghezza del pannello in linea"
// panel.minWidth: "Minimum panel width" => "Larghezza minima del pannello"
// panel.maxWidth: "Maximum panel width" => "Larghezza massima del pannello"
// panel.showNumber: "Number panels" => "Pannelli numerici"
// paneldynamic.name: "Panel name" => "Nome del pannello"
// paneldynamic.title: "Panel title" => "Titolo del panel"
// paneldynamic.description: "Panel description" => "Descrizione del pannello"
// paneldynamic.visibleIf: "Make the panel visible if" => "Rendi visibile il pannello se"
// paneldynamic.requiredIf: "Make the panel required if" => "Rendere il pannello richiesto se"
// paneldynamic.page: "Move the panel to page" => "Sposta il pannello nella pagina"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Visualizzare il pannello su una nuova riga"
// paneldynamic.state: "Panel collapse state" => "Stato di compressione del pannello"
// paneldynamic.width: "Inline panel width" => "Larghezza del pannello in linea"
// paneldynamic.minWidth: "Minimum panel width" => "Larghezza minima del pannello"
// paneldynamic.maxWidth: "Maximum panel width" => "Larghezza massima del pannello"
// paneldynamic.templateDescription: "Panel description pattern" => "Modello di descrizione del pannello"
// paneldynamic.templateTitle: "Panel title pattern" => "Pattern titolo pannello"
// paneldynamic.noEntriesText: "Empty panel text" => "Testo del pannello vuoto"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Modello del titolo della tabulazione"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Rendi visibile un singolo pannello se"
// paneldynamic.hideNumber: "Hide the panel number" => "Nascondere il numero del pannello"
// paneldynamic.titleLocation: "Panel title alignment" => "Allineamento del titolo del pannello"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Allineamento della descrizione del pannello"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Allineamento del titolo della domanda"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Allineamento dei messaggi di errore"
// paneldynamic.newPanelPosition: "New panel location" => "Nuova posizione del pannello"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Impedisci risposte duplicate nella seguente domanda"
// question.name: "Question name" => "Nome della domanda"
// question.title: "Question title" => "Titolo della domanda"
// question.description: "Question description" => "Descrizione della domanda"
// question.visibleIf: "Make the question visible if" => "Rendi visibile la domanda se"
// question.requiredIf: "Make the question required if" => "Rendi la domanda richiesta se"
// question.state: "Question box collapse state" => "Stato di compressione della casella delle domande"
// question.hideNumber: "Hide the question number" => "Nascondi il numero della domanda"
// question.titleLocation: "Question title alignment" => "Allineamento del titolo della domanda"
// question.descriptionLocation: "Question description alignment" => "Allineamento della descrizione della domanda"
// question.errorLocation: "Error message alignment" => "Allineamento dei messaggi di errore"
// question.indent: "Increase the inner indent" => "Aumentare il rientro interno"
// question.width: "Inline question width" => "Larghezza della domanda in linea"
// question.minWidth: "Minimum question width" => "Larghezza minima della domanda"
// question.maxWidth: "Maximum question width" => "Larghezza massima della domanda"
// question.textUpdateMode: "Update input field value" => "Aggiorna il valore del campo di input"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Mostra il pulsante Cancella all'interno dell'area della firma"
// signaturepad.penColor: "Stroke color" => "Colore del tratto"
// comment.rows: "Input field height (in lines)" => "Altezza del campo di immissione (in righe)"
// expression.name: "Expression name" => "Nome dell'espressione"
// expression.title: "Expression title" => "Titolo dell'espressione"
// expression.description: "Expression description" => "Descrizione dell'espressione"
// expression.expression: "Expression" => "Espressione"
// trigger.expression: "Expression" => "Espressione"
// calculatedvalue.expression: "Expression" => "Espressione"
// survey.description: "Survey description" => "Descrizione dell'indagine"
// page.name: "Page name" => "Nome della pagina"
// page.description: "Page description" => "Descrizione della pagina"
// page.visibleIf: "Make the page visible if" => "Rendi visibile la pagina se"
// page.requiredIf: "Make the page required if" => "Rendi la pagina obbligatoria se"
// page.questionsOrder: "Question order on the page" => "Ordine delle domande nella pagina"
// matrixdropdowncolumn.name: "Column name" => "Nome della colonna"
// matrixdropdowncolumn.title: "Column title" => "Titolo della colonna"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Impedisci risposte duplicate"
// matrixdropdowncolumn.width: "Column width" => "Larghezza colonna"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Larghezza minima della colonna"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Altezza del campo di immissione (in righe)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Rendi visibile la colonna se"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Rendere obbligatoria la colonna se"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Ogni opzione in una colonna separata"
// multipletextitem.name: "Name" => "Nome"
// multipletextitem.title: "Title" => "Titolo"
// pe.rateDescriptionLocation: "Label alignment" => "Allineamento delle etichette"
// pe.cellErrorLocation: "Cell error message alignment" => "Allineamento dei messaggi di errore delle celle"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Non hai ancora colonne"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Non ci sono ancora righe"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Non si dispone ancora di regole di convalida"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Non disponi ancora di variabili personalizzate"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Non hai ancora alcun trigger"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Non hai ancora nessun link"
// pe.addNew@columns: "Add new column" => "Aggiungi nuova colonna"
// pe.addNew@rows: "Add new row" => "Aggiungi nuova riga"
// pe.addNew@validators: "Add new rule" => "Aggiunta di una nuova regola"
// pe.addNew@calculatedValues: "Add new variable" => "Aggiunta di una nuova variabile"
// pe.addNew@triggers: "Add new trigger" => "Aggiungere un nuovo trigger"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Aggiungi nuovo URL"
// choicesbyurl.url: "Web service's URL" => "URL del servizio Web"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Visualizzare i titoli delle pagine nella barra di avanzamento"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Visualizzare i numeri di pagina nella barra di avanzamento"
// itemvalue.visibleIf: "Make the option visible if" => "Rendi visibile l'opzione se"
// itemvalue.enableIf: "Make the option selectable if" => "Rendere l'opzione selezionabile se"
// panel.layout: "Panel Layout" => "Layout del pannello"
// tabs.questionSettings: "Question Settings" => "Impostazioni delle domande"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Es.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Es.: categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Es.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Es.: 6 pollici"
// pe.minWidth_placeholder: "Ex.: 600px" => "Es.: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Es.: 50%"
// pv.selected: "Selected" => "Selezionato"
// pv.unselected: "Unselected" => "Deselezionata"
// pv.center: "Center" => "Centro"
// pv.middle: "Middle" => "Mezzo"
// pv.next: "Next" => "Prossimo"
// pv.last: "Last" => "Ultimo"
// clearIfInvisible.none: "Never" => "Mai"
// questionsOnPageMode.standard: "Original structure" => "Struttura originale"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Mostra tutte le domande in un'unica pagina"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Mostra una singola domanda per pagina"
// pv.auto: "Auto" => "Automatico"
// panelsState.firstExpanded: "First expanded" => "Prima espansione"
// rateColorMode.scale: "Scale" => "Scala"
// scaleColorMode.monochrome: "Monochrome" => "Monocromatico"
// scaleColorMode.colored: "Colored" => "Colorato"
// state.default: "Locked" => "Bloccato"
// showQuestionNumbers.default: "Auto-numbering" => "Numerazione automatica"
// showQuestionNumbers.on: "Auto-numbering" => "Numerazione automatica"
// showQuestionNumbers.onPage: "Reset on each page" => "Ripristina su ogni pagina"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Ripristina su ogni pannello"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Ripristina su ogni pannello"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Continua con l'indagine"
// showQuestionNumbers.off: "No numbering" => "Nessuna numerazione"
// descriptionLocation.underTitle: "Under the question title" => "Sotto il titolo della domanda"
// descriptionLocation.underInput: "Under the input field" => "Sotto il campo di immissione"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Accanto alle scelte"
// selectToRankAreasLayout.vertical: "Above choices" => "Scelte di cui sopra"
// displayStyle.decimal: "Decimal" => "Decimale"
// displayStyle.currency: "Currency" => "Valuta"
// displayStyle.percent: "Percentage" => "Percentuale"
// displayStyle.date: "Date" => "Dattero"
// totalDisplayStyle.decimal: "Decimal" => "Decimale"
// totalDisplayStyle.currency: "Currency" => "Valuta"
// totalDisplayStyle.percent: "Percentage" => "Percentuale"
// totalDisplayStyle.date: "Date" => "Dattero"
// rowsOrder.initial: "Original" => "Originale"
// questionsOrder.initial: "Original" => "Originale"
// showProgressBar.aboveheader: "Above the header" => "Sopra l'intestazione"
// showProgressBar.belowheader: "Below the header" => "Sotto l'intestazione"
// pv.sum: "Sum" => "Somma"
// pv.count: "Count" => "Contare"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Max"
// pv.avg: "Avg" => "Medio"
// searchMode.contains: "Contains" => "Contiene"
// searchMode.startsWith: "Starts with" => "Inizia con"
// panel.name: "A panel ID that is not visible to respondents." => "Un ID pannello che non è visibile ai rispondenti."
// panel.description: "Type a panel subtitle." => "Digita un sottotitolo del pannello."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che determina la visibilità del pannello."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che disabiliti la modalità di sola lettura per il pannello."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Utilizza l'icona della bacchetta magica per impostare una regola condizionale che impedisca l'invio dell'indagine a meno che almeno una domanda nidificata non abbia una risposta."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Si applica a tutte le domande all'interno di questo pannello. Se si desidera ignorare questa impostazione, definire le regole di allineamento del titolo per le singole domande. L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine (\"In alto\" per impostazione predefinita)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Imposta la posizione di un messaggio di errore in relazione a tutte le domande all'interno del pannello. L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Mantiene l'ordine originale delle domande o le rende casuali. L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine."
// panel.page: "Repositions the panel to the end of a selected page." => "Riposiziona il pannello alla fine di una pagina selezionata."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Aggiunge spazio o margine tra il contenuto del pannello e il bordo sinistro del riquadro del pannello."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Deselezionare questa opzione per visualizzare il pannello in una riga con la domanda o il pannello precedente. L'impostazione non si applica se il pannello è il primo elemento del modulo."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Scegli tra: \"Espanso\" - il pannello viene visualizzato per intero e può essere compresso; \"Compresso\" - il pannello visualizza solo il titolo e la descrizione e può essere espanso; \"Bloccato\": il pannello viene visualizzato per intero e non può essere compresso."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Imposta la larghezza del pannello in proporzione agli altri elementi di rilievo nella stessa linea. Accetta valori CSS (px, %, in, pt, ecc.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "Un ID pannello che non è visibile ai rispondenti."
// paneldynamic.description: "Type a panel subtitle." => "Digita un sottotitolo del pannello."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che determina la visibilità del pannello."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che disabiliti la modalità di sola lettura per il pannello."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Utilizza l'icona della bacchetta magica per impostare una regola condizionale che impedisca l'invio dell'indagine a meno che almeno una domanda nidificata non abbia una risposta."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Si applica a tutte le domande all'interno di questo pannello. Se si desidera ignorare questa impostazione, definire le regole di allineamento del titolo per le singole domande. L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine (\"In alto\" per impostazione predefinita)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Imposta la posizione di un messaggio di errore in relazione a una domanda con input non valido. Scegli tra: \"In alto\" - un testo di errore viene posizionato nella parte superiore della casella della domanda; \"In basso\": un testo di errore viene inserito nella parte inferiore della casella della domanda. L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine (\"In alto\" per impostazione predefinita)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Imposta la posizione di un messaggio di errore in relazione a tutte le domande all'interno del pannello. L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Riposiziona il pannello alla fine di una pagina selezionata."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Aggiunge spazio o margine tra il contenuto del pannello e il bordo sinistro del riquadro del pannello."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Deselezionare questa opzione per visualizzare il pannello in una riga con la domanda o il pannello precedente. L'impostazione non si applica se il pannello è il primo elemento del modulo."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Scegli tra: \"Espanso\" - il pannello viene visualizzato per intero e può essere compresso; \"Compresso\" - il pannello visualizza solo il titolo e la descrizione e può essere espanso; \"Bloccato\": il pannello viene visualizzato per intero e non può essere compresso."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Imposta la larghezza del pannello in proporzione agli altri elementi di rilievo nella stessa linea. Accetta valori CSS (px, %, in, pt, ecc.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Digita un modello per i titoli dei pannelli dinamici. Utilizzare {panelIndex} per la posizione generale del pannello e {visiblePanelIndex} per l'ordine tra i pannelli visibili. Inserire questi segnaposto nel motivo per aggiungere la numerazione automatica."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Digita un modello per i titoli delle schede. Utilizzate {panelIndex} per la posizione generale di un pannello e {visiblePanelIndex} per l'ordine tra i pannelli visibili. Inserire questi segnaposto nel motivo per aggiungere la numerazione automatica."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Questa impostazione consente di controllare la visibilità dei singoli pannelli all'interno del pannello dinamico. Utilizzare il segnaposto '{panel}' per fare riferimento al pannello corrente nell'espressione."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Questa impostazione viene ereditata automaticamente da tutte le domande all'interno di questo pannello. Se si desidera ignorare questa impostazione, definire le regole di allineamento del titolo per le singole domande. L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine (\"In alto\" per impostazione predefinita)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "L'opzione \"Eredita\" applica l'impostazione a livello di pagina (se impostata) o a livello di indagine (\"Sotto il titolo del pannello\" per impostazione predefinita)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Definisce la posizione di un pannello appena aggiunto. Per impostazione predefinita, i nuovi pannelli vengono aggiunti alla fine. Selezionare \"Avanti\" per inserire un nuovo pannello dopo quello corrente."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Duplica le risposte dall'ultimo pannello e le assegna al successivo pannello dinamico aggiunto."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Fai riferimento al nome di una domanda per richiedere a un utente di fornire una risposta univoca per questa domanda in ogni pannello."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Questa impostazione consente di assegnare un valore di risposta predefinito in base a un'espressione. L'espressione può includere calcoli di base: '{q1_id} + {q2_id}', espressioni booleane, come '{age} > 60' e funzioni: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', ecc. Il valore determinato da questa espressione funge da valore predefinito iniziale che può essere sostituito dall'input manuale di un rispondente."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Utilizza l'icona della bacchetta magica per impostare una regola condizionale che determini quando l'input di un rispondente viene reimpostato sul valore in base all'\"Espressione del valore predefinito\" o \"Imposta espressione del valore\" o al valore \"Risposta predefinita\" (se uno dei due è impostato)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che determina quando eseguire l'espressione \"Imposta valore\" e assegnare dinamicamente il valore risultante come risposta."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Specificare un'espressione che definisca il valore da impostare quando vengono soddisfatte le condizioni della regola \"Imposta valore se\". L'espressione può includere calcoli di base: '{q1_id} + {q2_id}', espressioni booleane, come '{age} > 60' e funzioni: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', ecc. Il valore determinato da questa espressione può essere sovrascritto dall'input manuale di un rispondente."
// question.name: "A question ID that is not visible to respondents." => "Un ID domanda che non è visibile ai rispondenti."
// question.description: "Type a question subtitle." => "Digita il sottotitolo di una domanda."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Usa l'icona della bacchetta magica per impostare una regola condizionale che determina la visibilità delle domande."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Utilizza l'icona della bacchetta magica per impostare una regola condizionale che disabilita la modalità di sola lettura per la domanda."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Utilizza l'icona della bacchetta magica per impostare una regola condizionale che impedisca l'avanzamento o l'invio dell'indagine a meno che la domanda non riceva una risposta."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Deseleziona questa opzione per visualizzare la domanda in una riga con la domanda o il pannello precedente. L'impostazione non si applica se la domanda è il primo elemento del modulo."
// question.page: "Repositions the question to the end of a selected page." => "Riposiziona la domanda alla fine di una pagina selezionata."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Scegli tra: \"Espandito\" - la casella della domanda viene visualizzata per intero e può essere compressa; \"Compresso\": la casella della domanda mostra solo il titolo e la descrizione e può essere espansa; \"Bloccata\": la casella della domanda viene visualizzata per intero e non può essere compressa."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Sostituisce le regole di allineamento del titolo definite a livello di pannello, pagina o rilevamento. L'opzione \"Eredita\" applica tutte le impostazioni di livello superiore (se impostate) o le impostazioni a livello di indagine (\"In alto\" per impostazione predefinita)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "L'opzione \"Eredita\" applica l'impostazione a livello di indagine (\"Sotto il titolo della domanda\" per impostazione predefinita)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Imposta la posizione di un messaggio di errore in relazione alla domanda con input non valido. Scegli tra: \"In alto\" - un testo di errore viene posizionato nella parte superiore della casella della domanda; \"In basso\": un testo di errore viene inserito nella parte inferiore della casella della domanda. L'opzione \"Eredita\" applica l'impostazione a livello di indagine (\"In alto\" per impostazione predefinita)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Aggiunge uno spazio o un margine tra il contenuto della domanda e il bordo sinistro della casella della domanda."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Imposta la larghezza della domanda in proporzione agli altri elementi del sondaggio nella stessa riga. Accetta valori CSS (px, %, in, pt, ecc.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Usa l'icona della bacchetta magica per impostare una regola di convalida per la domanda."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Scegli tra: \"In caso di perdita di messa a fuoco\" - il valore viene aggiornato quando il campo di immissione perde lo stato attivo; \"Durante la digitazione\": il valore viene aggiornato in tempo reale, mentre gli utenti digitano. L'opzione \"Eredita\" applica l'impostazione a livello di indagine (\"In caso di perdita di focus\" per impostazione predefinita)."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "È possibile utilizzare qualsiasi servizio Web come origine dati per le domande a scelta multipla. Per popolare i valori di scelta, immettere l'URL del servizio che fornisce i dati."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Operazione di confronto utilizzata per filtrare l'elenco a discesa."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Imposta la larghezza dell'area della firma visualizzata e dell'immagine risultante."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Imposta l'altezza dell'area della firma visualizzata e dell'immagine risultante."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Selezionare questa opzione se si desidera che l'area della firma occupi tutto lo spazio disponibile all'interno della casella della domanda, mantenendo le proporzioni 3:2 predefinite. Quando vengono impostati valori di larghezza e altezza personalizzati, l'impostazione manterrà le proporzioni di queste dimensioni."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Regola l'altezza dell'immagine nei risultati del rilevamento."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Regola la larghezza dell'immagine nei risultati del rilevamento."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Sostituisce i valori di altezza minima e massima."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Sostituisce i valori di larghezza minima e massima."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Valore\" funge da ID elemento utilizzato nelle regole condizionali; \"Testo\" viene visualizzato ai rispondenti."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Questa impostazione ridimensiona solo il campo di input e non influisce sulla larghezza della casella della domanda. Per limitare la lunghezza di input accettata, passare a <b>Convalida → Limite massimo di caratteri</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Imposta il numero di righe visualizzate nel campo di immissione. Se l'input occupa più righe, verrà visualizzata la barra di scorrimento."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Scegli tra: \"Modificabile\" - consente ai rispondenti di compilare la tua indagine; \"Sola lettura\": disabilita la modifica del modulo."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "Un ID colonna che non è visibile ai rispondenti."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Se abilitata per una colonna, un rispondente deve fornire una risposta univoca per ogni domanda all'interno di questa colonna."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Imposta il numero di righe visualizzate nel campo di immissione. Se l'input occupa più righe, verrà visualizzata la barra di scorrimento."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che determini la visibilità della colonna."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che disabiliti la modalità di sola lettura per la colonna."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Utilizza l'icona della bacchetta magica per impostare una regola condizionale che impedisca l'invio dell'indagine a meno che almeno una domanda nidificata non abbia una risposta."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Quando questa opzione è selezionata, crea una singola colonna per ogni opzione di scelta."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Scegli tra: \"Statico\" - imposta una larghezza fissa; \"Responsive\" - fa sì che il sondaggio occupi l'intera larghezza dello schermo; \"Auto\": applica uno dei due a seconda del tipo di domanda utilizzato."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Incolla un link immagine (senza limiti di dimensione) o fai clic sull'icona della cartella per sfogliare un file dal tuo computer (fino a 64 KB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Imposta la larghezza del logo in unità CSS (px, %, in, pt e così via)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Imposta l'altezza di un logo in unità CSS (px, %, in, pt e così via)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Scegli tra: \"Nessuna\" - l'immagine mantiene le sue dimensioni originali; \"Contieni\": l'immagine viene ridimensionata per adattarla mantenendo le sue proporzioni; \"Copertina\": l'immagine riempie l'intera scatola mantenendo le sue proporzioni; \"Riempi\" - l'immagine viene allungata per riempire la casella senza mantenerne le proporzioni."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Seleziona se desideri che l'indagine passi automaticamente alla pagina successiva dopo che un rispondente ha risposto a tutte le domande della pagina corrente."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Imposta la visibilità e la posizione dei pulsanti di navigazione in una pagina."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Imposta la visibilità e la posizione di una barra di avanzamento. Il valore \"Auto\" mostra la barra di avanzamento sopra o sotto l'intestazione del sondaggio."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Abilita la pagina di anteprima con tutte le domande o solo con risposta."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Si applica a tutte le domande all'interno dell'indagine. Questa impostazione può essere sostituita dalle regole di allineamento del titolo ai livelli inferiori: pannello, pagina o domanda. Un'impostazione di livello inferiore sostituirà quelle di livello superiore."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Un simbolo o una sequenza di simboli che indica che è necessaria una risposta."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Immettere un numero o una lettera con cui si desidera iniziare la numerazione."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Imposta la posizione di un messaggio di errore in relazione alla domanda con input non valido. Scegli tra: \"In alto\" - un testo di errore viene posizionato nella parte superiore della casella della domanda; \"In basso\": un testo di errore viene inserito nella parte inferiore della casella della domanda."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Selezionare se si desidera che il primo campo di immissione di ogni pagina sia pronto per l'immissione di testo."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Mantiene l'ordine originale delle domande o le rende casuali. L'effetto di questa impostazione è visibile solo nella scheda Anteprima."
// pehelp.maxTextLength: "For text entry questions only." => "Solo per domande di immissione di testo."
// pehelp.maxOthersLength: "For question comments only." => "Solo per i commenti alle domande."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Selezionare questa opzione se si desidera che i commenti alle domande e le domande di testo lungo aumentino automaticamente in altezza in base alla lunghezza del testo inserito."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Solo per i commenti alle domande e le domande a testo lungo."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Le variabili personalizzate fungono da variabili intermedie o ausiliarie utilizzate nei calcoli dei moduli. Accettano gli input dei rispondenti come valori di origine. Ogni variabile personalizzata ha un nome univoco e un'espressione su cui si basa."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Selezionare questa opzione se si desidera che il valore calcolato dell'espressione venga salvato insieme ai risultati del rilevamento."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Un trigger è un evento o una condizione basata su un'espressione. Una volta che l'espressione è stata valutata come \"true\", un trigger attiva un'azione. Un'azione di questo tipo può facoltativamente avere un effetto su una domanda di destinazione."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Scegli se cancellare o meno i valori per le domande nascoste dalla logica condizionale e quando farlo."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Scegli tra: \"In caso di perdita di messa a fuoco\" - il valore viene aggiornato quando il campo di immissione perde lo stato attivo; \"Durante la digitazione\": il valore viene aggiornato in tempo reale, mentre gli utenti digitano."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Il valore a sinistra funge da ID colonna utilizzato nelle regole condizionali, mentre il valore a destra viene visualizzato dai rispondenti."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Il valore a sinistra funge da ID riga utilizzato nelle regole condizionali, mentre il valore a destra viene visualizzato dai rispondenti."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accetta valori CSS (px, %, in, pt, ecc.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accetta valori CSS (px, %, in, pt, ecc.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Imposta la posizione di un messaggio di errore in relazione a una cella con input non valido. L'opzione \"Eredita\" applica l'impostazione della proprietà \"Allineamento messaggi di errore\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Quando la proprietà \"Impedisci risposte duplicate\" è abilitata, un rispondente che tenta di inviare una voce duplicata riceverà il seguente messaggio di errore."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Consente di calcolare i valori totali in base a un'espressione. L'espressione può includere calcoli di base ('{q1_id} + {q2_id}'), espressioni booleane ('{age} > 60') e funzioni ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', ecc.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Attiva un prompt che chiede di confermare l'eliminazione della riga."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Duplica le risposte dell'ultima riga e le assegna alla successiva riga dinamica aggiunta."
// pehelp.description: "Type a subtitle." => "Digita un sottotitolo."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Scegli una lingua per iniziare a creare la tua indagine. Per aggiungere una traduzione, passa a una nuova lingua e traduci il testo originale qui o nella scheda Traduzioni."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Imposta la posizione di una sezione di dettagli in relazione a una riga. Scegli tra: \"Nessuna\" - non viene aggiunta alcuna espansione; \"Sotto la riga\": un'espansione di riga viene posizionata sotto ogni riga della matrice; \"Sotto la riga, visualizza solo un'espansione di riga\": un'espansione viene visualizzata solo sotto una singola riga, le espansioni di riga rimanenti vengono compresse."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Scegli tra: \"Nessuna\" - l'immagine mantiene le sue dimensioni originali; \"Contieni\": l'immagine viene ridimensionata per adattarla mantenendo le sue proporzioni; \"Copertina\": l'immagine riempie l'intera scatola mantenendo le sue proporzioni; \"Riempi\" - l'immagine viene allungata per riempire la casella senza mantenerne le proporzioni."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Aumenta gradualmente l'altezza del campo di immissione man mano che i dati vengono inseriti. Sostituisce l'impostazione \"Altezza campo di immissione (in righe)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "La maniglia di ridimensionamento (o grip) viene visualizzata nell'angolo e può essere trascinata per modificare le dimensioni del campo di immissione."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Un intervallo di tempo in secondi dopo il quale l'indagine avanza automaticamente alla pagina di ringraziamento."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Un intervallo di tempo in secondi dopo il quale il rilevamento avanza automaticamente alla pagina successiva."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Un intervallo di tempo in secondi dopo il quale il rilevamento avanza automaticamente alla pagina successiva."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Usa l'icona della bacchetta magica per impostare una regola condizionale che determina la visibilità della pagina."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che disabilita la modalità di sola lettura per la pagina."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Utilizza l'icona della bacchetta magica per impostare una regola condizionale che impedisca l'invio dell'indagine a meno che almeno una domanda nidificata non abbia una risposta."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Si applica a tutte le domande all'interno di questa pagina. Se si desidera ignorare questa impostazione, definire le regole di allineamento dei titoli per le singole domande o pannelli. L'opzione \"Eredita\" applica l'impostazione a livello di indagine (\"In alto\" per impostazione predefinita)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Imposta la posizione di un messaggio di errore in relazione alla domanda con input non valido. Scegli tra: \"In alto\" - un testo di errore viene posizionato nella parte superiore della casella della domanda; \"In basso\": un testo di errore viene inserito nella parte inferiore della casella della domanda. L'opzione \"Eredita\" applica l'impostazione a livello di indagine (\"In alto\" per impostazione predefinita)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Mantiene l'ordine originale delle domande o le rende casuali. L'opzione \"Eredita\" applica l'impostazione a livello di indagine (\"Originale\" per impostazione predefinita). L'effetto di questa impostazione è visibile solo nella scheda Anteprima."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Imposta la visibilità dei pulsanti di navigazione nella pagina. L'opzione \"Eredita\" applica l'impostazione a livello di indagine, che per impostazione predefinita è \"Visibile\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Imposta la visibilità e la posizione di un timer in una pagina."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Scegli tra: \"Bloccato\" - gli utenti non possono espandere o comprimere i pannelli; \"Comprimi tutto\": tutti i pannelli iniziano in uno stato compresso; \"Espandi tutto\": tutti i pannelli iniziano in uno stato espanso; \"Prima espansa\": inizialmente viene espanso solo il primo pannello."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Immettere un nome di proprietà condivisa all'interno della matrice di oggetti che contiene gli URL del file di immagine o video che si desidera visualizzare nell'elenco di scelta."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Il valore a sinistra funge da ID elemento utilizzato nelle regole condizionali, mentre il valore a destra viene visualizzato dai rispondenti."
// pehelp.title: "Type a user-friendly title to display." => "Digitare un titolo descrittivo da visualizzare."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Garantisce che gli utenti non completino l'indagine fino a quando i file non vengono caricati."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accetta valori CSS (px, %, in, pt, ecc.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accetta valori CSS (px, %, in, pt, ecc.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Accetta valori CSS (px, %, in, pt, ecc.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "Nei tipi di domande a selezione singola e multipla, ogni opzione di scelta ha un ID e un valore di visualizzazione. Quando questa opzione è selezionata, questa impostazione mostra un valore di visualizzazione anziché un valore ID nelle domande HTML e nei titoli dinamici e nelle descrizioni degli elementi dell'indagine."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Scegli se cancellare o meno i valori delle domande nascosti dalla logica condizionale e quando farlo. L'opzione \"Eredita\" applica l'impostazione a livello di indagine (\"Al completamento dell'indagine\" per impostazione predefinita)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Scegli tra: \"Tutte\" - copia tutte le opzioni di scelta dalla domanda selezionata; \"Selezionato\" - copia dinamicamente solo le opzioni di scelta selezionate; \"Non selezionato\" - copia dinamicamente solo le opzioni di scelta non selezionate. Le opzioni \"Nessuna\" e \"Altro\" vengono copiate per impostazione predefinita se abilitate nella domanda di origine."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Quando questa opzione è selezionata, gli utenti possono includere input aggiuntivi in una casella di commento separata."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Visualizza ogni opzione di scelta speciale (\"Nessuna\", \"Altro\", \"Seleziona tutto\") su una nuova riga, anche quando si utilizza un layout a più colonne."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Specificare la posizione all'interno del set di dati del servizio in cui si trova la matrice di oggetti di destinazione. Lasciare vuoto se l'URL punta già all'array."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Immettere un nome di proprietà uniforme all'interno della matrice di oggetti contenente i valori che si desidera visualizzare nell'elenco di scelte."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Selezionare questa opzione per consentire al servizio di restituire una risposta o una matrice vuota."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Utilizzare l'icona della bacchetta magica per impostare una regola condizionale che determina la visibilità di tutte le opzioni di scelta."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Il valore a sinistra funge da ID elemento utilizzato nelle regole condizionali, mentre il valore a destra viene visualizzato dai rispondenti."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" seleziona tra le modalità \"Pulsanti\" e \"Menu a discesa\" in base alla larghezza disponibile. Quando la larghezza è insufficiente per visualizzare i pulsanti, la domanda visualizza un menu a discesa."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Consente di collegare domande che producono risultati in formati diversi. Quando tali domande sono collegate tra loro utilizzando un identificatore di join, questa proprietà condivisa memorizza i valori delle domande selezionate."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Selezionare questa opzione se si desidera aggiornare il contenuto del menu a discesa in modo che corrisponda alla query di ricerca digitata dall'utente nel campo di immissione."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Un valore da salvare nei risultati dell'indagine quando i rispondenti danno una risposta positiva."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Un valore da salvare nei risultati dell'indagine quando i rispondenti danno una risposta negativa."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Non è consigliabile disabilitare questa opzione in quanto sostituisce l'immagine di anteprima e rende difficile per un utente capire se i file sono stati caricati."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Attiva un prompt che chiede di confermare l'eliminazione del file."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Abilita per classificare solo le scelte selezionate. Gli utenti trascineranno gli elementi selezionati dall'elenco di scelta per ordinarli all'interno dell'area di classificazione."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Inserisci un elenco di scelte che verranno suggerite al rispondente durante l'inserimento."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "L'impostazione ridimensiona solo i campi di input e non influisce sulla larghezza della casella della domanda."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Imposta una larghezza coerente per tutte le etichette degli elementi in pixel"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "L'opzione \"Auto\" determina automaticamente la modalità di visualizzazione adatta - Immagine, Video o YouTube - in base all'URL di origine fornito."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Funge da sostituto quando l'immagine non può essere visualizzata sul dispositivo di un utente e per motivi di accessibilità."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Definisce il colore dell'emoji selezionata quando il tipo di icona Valutazione è impostato su \"Smiley\". Scegli tra: \"Predefinito\" - l'emoji selezionata appare nel colore predefinito del sondaggio; \"Scala\": l'emoji selezionata eredita il colore dalla scala di valutazione."
// expression.name: "An expression ID that is not visible to respondents." => "Un ID espressione che non è visibile ai rispondenti."
// expression.description: "Type an expression subtitle." => "Digitare un sottotitolo dell'espressione."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Un'espressione può includere calcoli di base ('{q1_id} + {q2_id}'), condizioni ('{età} > 60') e funzioni ('iif()', 'oggi()', 'età()', 'min()', 'max()', 'avg()' e così via)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Selezionare questa opzione per memorizzare il valore dell'opzione \"Altro\" come proprietà separata nei risultati del rilevamento."
// p.swapOrder: "Swap the order of Yes and No" => "Scambia l'ordine di Sì e No"
// p.itemTitleWidth: "Item label width (in px)" => "Larghezza dell'etichetta dell'articolo (in px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Testo da mostrare se tutte le opzioni sono selezionate"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Testo segnaposto per l'area di classificazione"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Completa automaticamente il sondaggio"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Seleziona questa opzione se desideri che l'indagine venga completata automaticamente dopo che un rispondente ha risposto a tutte le domande."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Salvare il valore mascherato nei risultati dell'indagine"
// patternmask.pattern: "Value pattern" => "Modello di valore"
// datetimemask.min: "Minimum value" => "Valore minimo"
// datetimemask.max: "Maximum value" => "Valore massimo"
// numericmask.allowNegativeValues: "Allow negative values" => "Consenti valori negativi"
// numericmask.thousandsSeparator: "Thousands separator" => "Separatore delle migliaia"
// numericmask.decimalSeparator: "Decimal separator" => "Separatore decimale"
// numericmask.precision: "Value precision" => "Precisione del valore"
// numericmask.min: "Minimum value" => "Valore minimo"
// numericmask.max: "Maximum value" => "Valore massimo"
// currencymask.prefix: "Currency prefix" => "Prefisso di valuta"
// currencymask.suffix: "Currency suffix" => "Suffisso valuta"
// pe.maskType: "Input mask type" => "Tipo di maschera di input"
// maskTypes.patternmask: "Pattern" => "Modello"
// maskTypes.numericmask: "Numeric" => "Numerico"
// maskTypes.datetimemask: "Date and Time" => "Data e ora"
// maskTypes.currencymask: "Currency" => "Valuta"
// tabs.mask: "Input Mask Settings" => "Impostazioni della maschera di input"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Es.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Es.: gg/mm/aaaa"
// pe.currencyprefix_placeholder: "Ex.: $" => "Es.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Es.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Scelte di avvolgimento"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "I testi lunghi nelle opzioni di scelta genereranno automaticamente interruzioni di riga per adattarsi al menu a discesa. Deselezionare questa opzione se si desidera che i testi vengano ritagliati."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Selezionare questa opzione se si desidera memorizzare il valore della domanda con una maschera applicata nei risultati dell'indagine."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Il modello può contenere valori letterali stringa e i segnaposto seguenti: '9' - per una cifra; 'a' - per una lettera maiuscola o minuscola; '#' - per una cifra o una lettera maiuscola o minuscola. Usa la barra rovesciata '\\' per eseguire l'escape di un carattere."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Il modello può contenere caratteri separatori e i seguenti segnaposto: 'm' - per il numero del mese; 'mm' - per il numero del mese, con zero iniziale per i valori a una cifra; 'd' - per il giorno del mese; 'dd' - per il giorno del mese, con zero iniziale per i valori a una cifra; 'yy' - per le ultime due cifre dell'anno; 'yyyy' - per un anno a quattro cifre."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Simbolo utilizzato per separare la parte frazionaria dalla parte intera di un numero visualizzato."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Simbolo utilizzato per separare le cifre di un numero elevato in gruppi di tre."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Limita il numero di cifre da mantenere dopo la virgola decimale per un numero visualizzato."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Uno o più simboli da visualizzare prima del valore."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Uno o più simboli da visualizzare dopo il valore."
// ed.translationSource: "Source: " => "Fonte: "
// ed.translationTarget: "Target: " => "Bersaglio: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "La pagina è vuota. Trascinare un elemento dalla casella degli strumenti o fare clic sul pulsante sottostante."
// maskTypes.none: "None" => "Nessuno"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Rendi visibile la riga se"
// itemvalue@rows.enableIf: "Make the row editable if" => "Rendi la riga modificabile se"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Testo segnaposto in modalità di sola lettura o anteprima"
// pe.textWrapEnabled: "Wrap choices" => "Scelte di avvolgimento"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "L'opzione \"Auto\" determina automaticamente la modalità di visualizzazione adatta - Immagine, Video o YouTube - in base all'URL di origine fornito."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Scegli tra \"Immagine\" e \"Video\" per impostare la modalità contenuto del selettore multimediale. Se è selezionata l'opzione \"Immagine\", assicurarsi che tutte le opzioni fornite siano file immagine nei seguenti formati: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Allo stesso modo, se è selezionato \"Video\", assicurarsi che tutte le opzioni siano collegamenti diretti a file video nei seguenti formati: MP4, MOV, WMV, FLV, AVI, MKV. Tieni presente che i link di YouTube non sono supportati per le opzioni video."
// ed.selectFile: "Select a file" => "Seleziona un file"
// ed.removeFile: "Remove the file" => "Rimuovere il file"
// pe.searchMode: "Search Mode" => "Modalità di ricerca"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Fai clic sul pulsante \"Aggiungi domanda\" qui sotto per iniziare a creare il tuo modulo."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Fai clic sul pulsante \"Aggiungi domanda\" in basso per aggiungere un nuovo elemento alla pagina."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Fai clic sul pulsante \"Aggiungi domanda\" in basso per aggiungere un nuovo elemento al pannello."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Clicca sul pulsante qui sotto e scegli un'immagine da caricare"
// coloralpha.opacity: "Opacity" => "Opacità"
// font.family: "Font family" => "Famiglia di caratteri"
// font.color: "Color" => "Colore"
// font.placeholderColor: "Placeholder color" => "Colore segnaposto"
// font.size: "Size" => "Grandezza"
// theme.themeName: "Theme" => "Tema"
// theme.isPanelless: "Question appearance" => "Aspetto della domanda"
// theme.editorPanel: "Background and corner radius" => "Sfondo e raggio d'angolo"
// theme.questionPanel: "Background and corner radius" => "Sfondo e raggio d'angolo"
// theme.primaryColor: "Accent color" => "Colore d'accento"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Opacità dello sfondo del pannello"
// theme.questionBackgroundTransparency: "Question background opacity" => "Opacità dello sfondo della domanda"
// theme.fontSize: "Font size" => "Dimensione del carattere"
// theme.scale: "Scale" => "Scala"
// theme.cornerRadius: "Corner radius" => "Raggio d'angolo"
// theme.pageTitle: "Title font" => "Carattere del titolo"
// theme.pageDescription: "Description font" => "Carattere di descrizione"
// theme.questionTitle: "Title font" => "Carattere del titolo"
// theme.questionDescription: "Description font" => "Carattere di descrizione"
// theme.editorFont: "Font" => "Font"
// theme.backgroundOpacity: "Opacity" => "Opacità"
// theme.--sjs-font-family: "Font family" => "Famiglia di caratteri"
// theme.--sjs-general-backcolor-dim: "Background color" => "Colore di sfondo"
// theme.--sjs-primary-backcolor: "Accent background" => "Sfondo d'accento"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Primo piano in primo piano"
// theme.--sjs-shadow-small: "Shadow effects" => "Effetti ombra"
// theme.--sjs-shadow-inner: "Shadow effects" => "Effetti ombra"
// theme.--sjs-border-default: "Colors" => "Colori"
// header@header.headerView: "View" => "Vista"
// header@header.logoPosition: "Logo position" => "Posizione del logo"
// header@header.surveyTitle: "Survey title font" => "Carattere del titolo dell'indagine"
// header@header.surveyDescription: "Survey description font" => "Carattere della descrizione dell'indagine"
// header@header.headerTitle: "Survey title font" => "Carattere del titolo dell'indagine"
// header@header.headerDescription: "Survey description font" => "Carattere della descrizione dell'indagine"
// header@header.inheritWidthFrom: "Content area width" => "Larghezza dell'area del contenuto"
// header@header.textAreaWidth: "Text width" => "Larghezza del testo"
// header@header.backgroundColorSwitch: "Background color" => "Colore di sfondo"
// header@header.backgroundImage: "Background image" => "Immagine di sfondo"
// header@header.backgroundImageOpacity: "Opacity" => "Opacità"
// header@header.overlapEnabled: "Overlap" => "Sovrapposizione"
// header@header.logoPositionX: "Logo position" => "Posizione del logo"
// header@header.titlePositionX: "Title position" => "Posizione del titolo"
// header@header.descriptionPositionX: "Description position" => "Descrizione posizione"
// weight.400: "Regular" => "Regolare"
// weight.600: "Heavy" => "Pesante"
// weight.700: "Semi-bold" => "Semi-grassetto"
// weight.800: "Bold" => "Audace"
// backgroundImageFit.auto: "Auto" => "Automatico"
// backgroundImageFit.cover: "Cover" => "Coprire"
// backgroundImageFit.contain: "Contain" => "Contenere"
// backgroundImageFit.fill: "Stretch" => "Stendere"
// backgroundImageFit.tile: "Tile" => "Tegola"
// backgroundImageAttachment.fixed: "Fixed" => "Fissato"
// backgroundImageAttachment.scroll: "Scroll" => "Scorrere"
// headerView.basic: "Basic" => "Basico"
// headerView.advanced: "Advanced" => "Avanzato"
// inheritWidthFrom.survey: "Same as survey" => "Uguale al sondaggio"
// inheritWidthFrom.container: "Fit to container" => "Adatto al contenitore"
// backgroundColorSwitch.none: "None" => "Nessuno"
// backgroundColorSwitch.accentColor: "Accent color" => "Colore d'accento"
// backgroundColorSwitch.custom: "Custom" => "Costume"
// colorPalette.light: "Light" => "Leggero"
// colorPalette.dark: "Dark" => "Oscuro"
// isPanelless.false: "Default" => "Default"
// isPanelless.true: "Without Panels" => "Senza pannelli"
// theme.cornerRadius: "Corner radius" => "Raggio d'angolo"
// theme.fontFamily: "Font family" => "Famiglia di caratteri"
// theme.fontWeightRegular: "Regular" => "Regolare"
// theme.fontWeightHeavy: "Heavy" => "Pesante"
// theme.fontWeightSemiBold: "Semi-bold" => "Semi-grassetto"
// theme.fontWeightBold: "Bold" => "Audace"
// theme.color: "Color" => "Colore"
// theme.placeholderColor: "Placeholder color" => "Colore segnaposto"
// theme.size: "Size" => "Grandezza"
// theme.opacity: "Opacity" => "Opacità"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Digita per cercare..."
// ed.toolboxNoResultsFound: "No results found" => "Nessun risultato trovato"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Segnaposto titolo tabulazione"
// theme.--sjs-special-red: "Error messages" => "Messaggi di errore"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Testo di fallback per i titoli delle schede che si applica quando il modello del titolo della scheda non produce un valore significativo."
// theme.fontColor: "Font color" => "Colore del carattere"
// theme.backgroundColor: "Background color" => "Colore di sfondo"
// pe.questionTitleWidth: "Question title width" => "Larghezza del titolo della domanda"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Seleziona un file o incolla un collegamento a un file..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Es.: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Imposta una larghezza coerente per i titoli delle domande quando sono allineati a sinistra delle caselle delle domande. Accetta valori CSS (px, %, in, pt, ecc.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Imposta una larghezza coerente per i titoli delle domande quando sono allineati a sinistra delle caselle delle domande. Accetta valori CSS (px, %, in, pt, ecc.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Altezza dell'area di commento (in righe)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Imposta il numero di righe visualizzate nelle aree di testo per i commenti alle domande. Nell'input occupa più righe, viene visualizzata la barra di scorrimento."


/***/ }),

/***/ "./src/localization/japanese.ts":
/*!**************************************!*\
  !*** ./src/localization/japanese.ts ***!
  \**************************************/
/*! exports provided: jaStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jaStrings", function() { return jaStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var jaStrings = {
    // survey templates
    survey: {
        edit: "編集",
        externalHelpLink: "アンケートの作成方法を見て学ぶ",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "ツールボックスからここに質問をドロップしてください。",
        addLogicItem: "アンケートの流れをカスタマイズするルールを作成します。",
        copy: "コピー",
        duplicate: "複製",
        addToToolbox: "ツールボックスに追加する",
        deletePanel: "パネルを削除する",
        deleteQuestion: "質問を削除する",
        convertTo: "に変換する",
        drag: "要素をドラッグする",
    },
    // Creator tabs
    tabs: {
        preview: "アンケートをテストする",
        theme: "テーマ",
        translation: "翻訳",
        designer: "アンケートの設計者",
        editor: "JSONエディタ",
        logic: "アンケートのロジック"
    },
    // Question types
    qt: {
        default: "デフォルト",
        checkbox: "チェックボックス",
        comment: "コメント",
        imagepicker: "画像ピッカー",
        ranking: "ランキング",
        image: "画像",
        dropdown: "ドロップダウン",
        tagbox: "複数選択ドロップダウン",
        file: "ファイル",
        html: "HTML",
        matrix: "マトリックス（単一選択）",
        matrixdropdown: "マトリックス（多項選択）",
        matrixdynamic: "マトリックス（動的行）",
        multipletext: "複数のテキスト",
        panel: "パネル",
        paneldynamic: "パネル（動的パネル）",
        radiogroup: "ラジオグループ",
        rating: "評価",
        text: "単一入力",
        boolean: "ブール",
        expression: "式（読み取り専用）",
        signaturepad: "署名パッド",
        buttongroup: "ボタングループ"
    },
    toolboxCategories: {
        general: "一般",
        choice: "選択の質問",
        text: "テキスト入力の質問",
        containers: "コンテナー",
        matrix: "マトリックスの質問",
        misc: "雑貨"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "デフォルト（{0}）",
        survey: "アンケート",
        settings: "アンケートの設定",
        settingsTooltip: "アンケートの設定を開く",
        surveySettings: "アンケート設定",
        surveySettingsTooltip: "アンケート設定",
        themeSettings: "テーマ設定",
        themeSettingsTooltip: "テーマ設定",
        showPanel: "パネルを表示する",
        hidePanel: "パネルを非表示にする",
        prevSelected: "前を選択",
        nextSelected: "[次へ] を選択します。",
        prevFocus: "前に焦点を合わせる",
        nextFocus: "次の焦点",
        surveyTypeName: "アンケート",
        pageTypeName: "ページ",
        panelTypeName: "パネル",
        questionTypeName: "質問",
        columnTypeName: "コラム",
        addNewPage: "新規ページを追加する",
        moveRight: "右にスクロールする",
        moveLeft: "左にスクロールする",
        deletePage: "ページを削除する",
        editPage: "ページを編集する",
        edit: "編集",
        newPageName: "ページ",
        newQuestionName: "質問",
        newPanelName: "パネル",
        newTextItemName: "テキスト",
        defaultV2Theme: "デフォルト",
        modernTheme: "モダン",
        defaultTheme: "デフォルト (レガシー)",
        testSurveyAgain: "アンケートを再度テストする",
        testSurveyWidth: "アンケートの幅： ",
        navigateToMsg: "次の場所に移動する必要がありました：",
        saveSurvey: "アンケートを保存する",
        saveSurveyTooltip: "アンケートを保存する",
        saveTheme: "テーマを保存",
        saveThemeTooltip: "テーマを保存",
        jsonHideErrors: "エラーを隠す",
        jsonShowErrors: "エラーを表示",
        undo: "元に戻す",
        redo: "やり直す",
        undoTooltip: "最後の変更を元に戻す",
        redoTooltip: "変更をやり直す",
        showMoreChoices: "さらに表示",
        showLessChoices: "表示を減らす",
        copy: "コピー",
        cut: "カット",
        paste: "貼り付ける",
        copyTooltip: "選択範囲をクリップボードにコピーする",
        cutTooltip: "選択範囲をクリップボードにカットする",
        pasteTooltip: "クリップボードから貼り付ける",
        options: "オプション",
        generateValidJSON: "有効なJSONを生成する",
        generateReadableJSON: "読み取り可能なJSONを生成する",
        toolbox: "ツールボックス",
        "property-grid": "プロパティ",
        toolboxFilteredTextPlaceholder: "「検索」...",
        toolboxNoResultsFound: "結果が見つかりませんでした",
        propertyGridFilteredTextPlaceholder: "検索するタイプ...",
        propertyGridNoResultsFound: "結果が見つかりませんでした",
        correctJSON: "JSONを修正してください。",
        surveyResults: "アンケート結果： ",
        surveyResultsTable: "表として",
        surveyResultsJson: "JSONとして",
        resultsTitle: "質問のタイトル",
        resultsName: "質問名",
        resultsValue: "回答値",
        resultsDisplayValue: "表示値",
        modified: "修正済み",
        saving: "保存",
        saved: "保存済み",
        propertyEditorError: "エラー：",
        saveError: "エラー！ エディタのコンテンツは保存されません。",
        translationPropertyGridTitle: "言語設定",
        themePropertyGridTitle: "テーマ設定",
        translationLanguages: "言語",
        translationDeleteLanguage: "この言語のすべての文字列を削除してもよろしいですか?",
        translationAddLanguage: "翻訳する言語を選択する",
        translationShowAllStrings: "すべての文字列を表示する",
        translationShowUsedStringsOnly: "使用される文字列のみ",
        translationShowAllPages: "すべてのページを表示する",
        translationNoStrings: "翻訳する文字列がありません。フィルターを変更してください。",
        translationExportToSCVButton: "CSVにエクスポートする",
        translationImportFromSCVButton: "CSVからインポートする",
        translateUsigAI: "すべて自動翻訳",
        translateUsigAIFrom: "言語の選択：",
        translationDialogTitle: "未翻訳の文字列",
        translationMergeLocaleWithDefault: "{0}をデフォルトのロケールにマージする",
        translationPlaceHolder: "翻訳。。。",
        translationSource: "源：",
        translationTarget: "ターゲット：",
        themeExportButton: "輸出",
        themeImportButton: "輸入",
        surveyJsonExportButton: "輸出",
        surveyJsonImportButton: "輸入",
        surveyJsonCopyButton: "クリップボードにコピー",
        themeResetButton: "テーマ設定をデフォルトにリセットする",
        themeResetConfirmation: "本当にテーマをリセットしますか?すべてのカスタマイズが失われます。",
        themeResetConfirmationOk: "はい、テーマをリセットします",
        bold: "太字",
        italic: "イタリック",
        underline: "下線",
        addNewQuestion: "質問を追加",
        selectPage: "ページを選択...",
        carryForwardChoicesCopied: "選択肢は",
        choicesLoadedFromWebText: "選択肢は Web サービスから読み込まれます。",
        choicesLoadedFromWebLinkText: "設定に移動",
        choicesLoadedFromWebPreviewTitle: "読み込まれた選択肢オプションのプレビュー",
        htmlPlaceHolder: "HTMLコンテンツはここにあります。",
        panelPlaceHolder: "ここにツールボックスから質問をドロップします。",
        surveyPlaceHolder: "アンケートは空です。ツールボックスから要素をドラッグするか、下のボタンをクリックします。",
        pagePlaceHolder: "ページは空です。ツールボックスから要素をドラッグするか、下のボタンをクリックします。",
        imagePlaceHolder: "ここに画像をドラッグ&ドロップするか、下のボタンをクリックしてアップロードする画像を選択してください",
        surveyPlaceHolderMobile: "下の「質問を追加」ボタンをクリックして、フォームの作成を開始してください。",
        pagePlaceHolderMobile: "下の「質問を追加」ボタンをクリックして、ページに新しい要素を追加します。",
        panelPlaceHolderMobile: "下の「質問を追加」ボタンをクリックして、パネルに新しい要素を追加します。",
        imagePlaceHolderMobile: "下のボタンをクリックして、アップロードする画像を選択してください",
        imageChooseImage: "画像を選択",
        addNewTypeQuestion: "{0}を追加",
        chooseLogoPlaceholder: "[ロゴ]",
        choices_Item: "アイテム",
        selectFile: "ファイルを選択",
        removeFile: "ファイルを削除する",
        lg: {
            addNewItem: "新しいルールを追加",
            empty_tab: "調査のフローをカスタマイズするルールを作成します。",
            page_visibilityName: "ページの可視性",
            page_enableName: "有効 (無効) ページ",
            page_requireName: "ページを必須にする",
            panel_visibilityName: "パネルの可視性",
            panel_enableName: "パネルの有効化/無効化",
            panel_requireName: "ページを必須にする",
            question_visibilityName: "質問の可視性",
            question_enableName: "質問の有効化/無効化",
            question_requireName: "質問オプションが必要",
            question_resetValueName: "質問値のリセット",
            question_setValueName: "質問値の設定",
            column_visibilityName: "列を表示 (非表示)",
            column_enableName: "有効 (無効) 列",
            column_requireName: "列を必須にする",
            column_resetValueName: "列の値をリセット",
            column_setValueName: "列の値を設定する",
            trigger_completeName: "アンケートを完了する",
            trigger_setvalueName: "質問の値を設定する",
            trigger_copyvalueName: "質問の値をコピーする",
            trigger_skipName: "質問にスキップする",
            trigger_runExpressionName: "カスタム式を実行する",
            completedHtmlOnConditionName: "カスタムの「サンキューページ」テキスト",
            page_visibilityDescription: "論理式がtrue（真）を返した場合、ページを表示にします。それ以外の場合は、非表示にしておきます。",
            panel_visibilityDescription: "論理式がtrue（真）を返した場合、パネルを表示にします。それ以外の場合は、非表示にしておきます。",
            panel_enableDescription: "論理式がtrue（真）を返した場合、パネルとその中のすべての要素を有効にします。それ以外の場合は、無効にしておきます。",
            question_visibilityDescription: "論理式がtrue（真）を返した場合、質問を表示にします。それ以外の場合は、非表示にしておきます。",
            question_enableDescription: "論理式がtrue（真）を返した場合、質問を有効にします。それ以外の場合は、無効にしておきます。",
            question_requireDescription: "論理式がtrue（真）を返した場合、質問が必須になります。",
            trigger_completeDescription: "論理式がtrue（真）を返した場合、アンケートが完了し、エンドユーザーに「サンキューページ」が表示されます。",
            trigger_setvalueDescription: "論理式で使用される質問の値が変更され、論理式がtrue（真）を返した場合、その値は選択された質問に設定されます。",
            trigger_copyvalueDescription: "論理式で使用される質問の値が変更され、論理式がtrue（真）を返した場合、選択された1つの質問の値が別の選択された質問にコピーされます。",
            trigger_skipDescription: "論理式がtrue（真）を返した場合、アンケートは選択された質問にスキップ/フォーカスされます。",
            trigger_runExpressionDescription: "論理式がtrue（真）を返した場合、カスタム式が実行されます。オプションで、この式の結果を選択した質問に設定することができます。",
            completedHtmlOnConditionDescription: "論理式がtrue（真）を返した場合、「サンキューページ」のデフォルトテキストは指定されたものに変更されます。",
            itemExpressionText: "式：「{0}」がtrue（真）を返した場合：",
            itemEmptyExpressionText: "新しいルール",
            page_visibilityText: "ページ{0}を表示にする",
            panel_visibilityText: "パネル{0}を表示にする",
            panel_enableText: "パネル{0}を有効にする",
            question_visibilityText: "質問{0}を表示にする",
            question_enableText: "質問{0}を有効にする",
            question_requireText: "質問{0}を必須にする",
            question_resetValueText: "質問のリセット値:{0}",
            question_setValueText: "値の割り当て: 質問への{1}: {0}",
            column_visibilityText: "質問{1}の列{0}を表示する",
            column_enableText: "質問の列{0}を有効にする{1}",
            column_requireText: "質問{1}の列{0}を必須にする",
            column_resetValueText: "列のセル値をリセット:{0}",
            column_setValueText: "セル値の割り当て:列への{1}:{0}",
            setValueExpressionPlaceholder: "結果が対象の質問に割り当てられる式。",
            trigger_completeText: "アンケートが完了する",
            trigger_setvalueText: "質問：{0}値{1}に設定する",
            trigger_setvalueEmptyText: "明確な質問値:{0}",
            trigger_copyvalueText: "質問{1}から質問：{0}値にコピーする",
            trigger_skipText: "アンケートは質問{0}にスキップする",
            trigger_runExpressionText1: "式：「{0}」を実行する",
            trigger_runExpressionText2: " そして、その結果を質問：{0}に設定する",
            completedHtmlOnConditionText: "「サンキューページ」のカスタムテキストを表示します。",
            showAllQuestions: "すべての質問",
            showAllActionTypes: "すべてのアクションタイプ",
            conditions: "条件",
            actions: "アクション",
            expressionEditorTitle: "条件を定義する",
            actionsEditorTitle: "アクションを定義する",
            deleteAction: "アクションを削除する",
            addNewAction: "新しいアクションを追加する",
            selectedActionCaption: "追加するアクションを選択…",
            expressionInvalid: "論理式が空または無効です。修正してください。",
            noActionError: "少なくとも1つのアクションを追加してください。",
            actionInvalid: "アクションの問題を解決してください。",
            uncompletedRule_title: "論理ルールが不完全です",
            uncompletedRule_text: "一部の論理ルールが完了していません。ここでタブを離れると、変更は失われます。変更を完了せずにタブを離れますか?",
            uncompletedRule_apply: "はい",
            uncompletedRule_cancel: "いいえ、ルールを完成させたい"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "パネル名",
            title: "パネルタイトル",
            description: "パネルの説明",
            visibleIf: "パネルを表示するのは、次の場合です",
            requiredIf: "次の場合は、パネルを必須にします",
            questionsOrder: "パネル内の質問の順序",
            page: "親ページ",
            startWithNewLine: "パネルを新しい行に表示する",
            state: "パネル折りたたみ状態",
            width: "インラインパネルの幅",
            minWidth: "最小パネル幅",
            maxWidth: "最大パネル幅",
            showNumber: "番号パネル"
        },
        paneldynamic: {
            name: "パネル名",
            title: "パネルタイトル",
            description: "パネルの説明",
            visibleIf: "パネルを表示するのは、次の場合です",
            requiredIf: "次の場合は、パネルを必須にします",
            page: "パネルをページに移動する",
            startWithNewLine: "パネルを新しい行に表示する",
            state: "パネル折りたたみ状態",
            width: "インラインパネルの幅",
            minWidth: "最小パネル幅",
            maxWidth: "最大パネル幅",
            confirmDelete: "パネルの削除を確認する",
            templateDescription: "パネル記述パターン",
            templateTitle: "パネル・タイトル・パターン",
            noEntriesText: "空のパネル・テキスト",
            templateTabTitle: "タブ タイトルのパターン",
            tabTitlePlaceholder: "タブ タイトルのプレースホルダー",
            templateVisibleIf: "個々のパネルを表示するのは、次の場合です",
            hideNumber: "パネル番号を隠す",
            titleLocation: "パネルタイトルの配置",
            descriptionLocation: "パネル記述の位置合わせ",
            templateTitleLocation: "質問タイトルの配置",
            templateErrorLocation: "エラー・メッセージのアライメント",
            newPanelPosition: "新しいパネルの位置",
            keyName: "次の質問で回答の重複を防ぐ"
        },
        question: {
            name: "質問名",
            title: "質問のタイトル",
            description: "質問の説明",
            visibleIf: "次の場合に質問を表示します。",
            requiredIf: "次の場合は質問を必須にします",
            page: "親ページ",
            state: "質問ボックスの折りたたみ状態",
            hideNumber: "質問番号を非表示にする",
            titleLocation: "質問タイトルの配置",
            descriptionLocation: "質問の説明の配置",
            errorLocation: "エラー・メッセージのアライメント",
            indent: "内側のインデントを増やす",
            width: "インラインの質問の幅",
            minWidth: "質問の最小幅",
            maxWidth: "質問の最大幅",
            textUpdateMode: "入力フィールド値の更新"
        },
        signaturepad: {
            signatureWidth: "署名領域の幅",
            signatureHeight: "署名領域の高さ",
            signatureAutoScaleEnabled: "署名領域の自動スケーリング",
            showPlaceholder: "プレースホルダーを表示する",
            placeholder: "プレースホルダテキスト",
            placeholderReadOnly: "読み取り専用モードまたはプレビューモードのプレースホルダーテキスト",
            allowClear: "署名領域内に [クリア] ボタンを表示する",
            penMinWidth: "最小ペン幅",
            penMaxWidth: "ペンの最大幅",
            penColor: "ストロークの色"
        },
        comment: {
            rows: "入力フィールドの高さ (行単位)"
        },
        showQuestionNumbers: "質問番号を表示する",
        questionStartIndex: "質問開始インデックス（1、2または「A」、「a」）",
        expression: {
            name: "エクスプレッション名",
            title: "エクスプレッションのタイトル",
            description: "式の説明",
            expression: "表現"
        },
        trigger: {
            expression: "表現"
        },
        calculatedvalue: {
            expression: "表現"
        },
        // survey templates
        survey: {
            title: "タイトル",
            description: "調査内容"
        },
        page: {
            name: "ページ名",
            title: "タイトル",
            description: "ページの説明",
            visibleIf: "次の場合にページを表示します",
            requiredIf: "次の場合は、ページを必須にします",
            maxTimeToFinish: "ページを終了するための制限時間 (秒単位)",
            questionsOrder: "ページ上の質問の順序"
        },
        matrixdropdowncolumn: {
            name: "列名",
            title: "列のタイトル",
            isUnique: "回答の重複を防ぐ",
            width: "列幅",
            minWidth: "最小列幅",
            rows: "入力フィールドの高さ (行単位)",
            visibleIf: "次の場合に列を表示します",
            requiredIf: "次の場合は、列を必須にします",
            showInMultipleColumns: "個別の列に各オプション"
        },
        multipletextitem: {
            name: "名前",
            title: "タイトル"
        },
        masksettings: {
            saveMaskedValue: "アンケート結果にマスクされた値を保存する"
        },
        patternmask: {
            pattern: "値パターン"
        },
        datetimemask: {
            min: "最小値",
            max: "最大値"
        },
        numericmask: {
            allowNegativeValues: "負の値を許可する",
            thousandsSeparator: "1000 の位の区切り記号",
            decimalSeparator: "小数点記号",
            precision: "値の精度",
            min: "最小値",
            max: "最大値"
        },
        currencymask: {
            prefix: "通貨接頭辞",
            suffix: "通貨の接尾辞"
        },
        imageHeight: "イメージの高さ",
        imageWidth: "イメージの幅",
        valueName: "値名",
        rateDescriptionLocation: "ラベルの配置",
        size: "入力フィールドのサイズ (文字数)",
        cellErrorLocation: "セル・エラー・メッセージの配置",
        apply: "適用",
        ok: "OK",
        save: "保存",
        clear: "クリア",
        saveTooltip: "保存",
        cancel: "キャンセル",
        set: "セット",
        reset: "リセット",
        change: "変える",
        refresh: "リフレッシュ",
        close: "閉める",
        delete: "削除",
        add: "追加",
        addNew: "新規追加:",
        addItem: "クリックしてアイテムを追加…",
        removeItem: "クリックしてアイテムを削除します...",
        dragItem: "アイテムをドラッグする",
        addOther: "その他",
        addSelectAll: "すべて選択",
        addNone: "なし",
        removeAll: "すべて削除",
        edit: "編集",
        back: "保存せずに戻る",
        backTooltip: "保存せずに戻る",
        saveAndBack: "保存して戻る",
        saveAndBackTooltip: "保存して戻る",
        doneEditing: "完成です",
        editChoices: "選択肢を編集",
        showChoices: "選択肢を表示",
        move: "移動",
        empty: "<empty>",
        emptyValue: "値が空です",
        fastEntry: "高速入力",
        fastEntryNonUniqueError: "値 '{0}' は一意ではありません",
        fastEntryChoicesCountError: "アイテムの数は{0}から{1}に制限してください",
        fastEntryChoicesMinCountError: "{0}項目以上入力してください",
        fastEntryPlaceholder: "次の形式でデータを設定できます。\n値 1|テキスト\n値 2",
        formEntry: "フォーム入力",
        testService: "サービスをテスト",
        itemSelectorEmpty: "エレメントを選択してください",
        conditionActionEmpty: "アクションを選択してください",
        conditionSelectQuestion: "質問を選択...",
        conditionSelectPage: "ページを選択...",
        conditionSelectPanel: "パネルを選択...",
        conditionValueQuestionTitle: "値を入力/選択してください",
        aceEditorHelp: "表現の補完のヒントを取得するには「ctrl+space」を押してください",
        aceEditorRowTitle: "現在の行",
        aceEditorPanelTitle: "現在のパネル",
        showMore: "詳細は文書をご確認ください",
        assistantTitle: "利用できる質問:",
        cellsEmptyRowsColumns: "少なくとも1つの列または行を含む必要があります",
        showPreviewBeforeComplete: "アンケートを送信する前に回答をプレビューする",
        overridingPropertyPrefix: "設定者",
        resetToDefaultCaption: "リセット",
        propertyIsEmpty: "値を入力してください",
        propertyIsNoUnique: "固有値を入力してください",
        propertyNameIsNotUnique: "固有名を入力してください",
        propertyNameIsIncorrect: "予約語は使用しないでください: \"アイテム\"、 \"選択肢\"、 \"パネル\"、 \"行\"。",
        listIsEmpty: "新しいアイテムを追加",
        "listIsEmpty@choices": "選択肢はまだ追加されていません",
        "listIsEmpty@columns": "まだ列がありません",
        "listIsEmpty@rows": "まだ行がありません",
        "listIsEmpty@validators": "入力規則はまだありません",
        "listIsEmpty@calculatedValues": "カスタム変数はまだありません",
        "listIsEmpty@triggers": "トリガーはまだありません",
        "listIsEmpty@navigateToUrlOnCondition": "リンクはまだありません",
        "addNew@choices": "選択肢を追加する",
        "addNew@columns": "新しい列を追加",
        "addNew@rows": "新しい行を追加",
        "addNew@validators": "新しいルールを追加",
        "addNew@calculatedValues": "新しい変数を追加",
        "addNew@triggers": "新しいトリガーを追加する",
        "addNew@navigateToUrlOnCondition": "新しい URL を追加",
        expressionIsEmpty: "表現が空白です",
        value: "値",
        text: "テキスト",
        rowid: "行ID",
        imageLink: "画像リンク",
        columnEdit: "行編集: {0}",
        itemEdit: "アイテム編集: {0}",
        url: "URL",
        path: "パス",
        choicesbyurl: {
            url: "Web サービスの URL",
            valueName: "次の JSON フィールドから値を取得する"
        },
        titleName: "タイトル名",
        imageLinkName: "次の JSON フィールドから画像の URL を取得する",
        allowEmptyResponse: "空の応答を許可",
        titlePlaceholder: "タイトルを入力",
        surveyTitlePlaceholder: "調査タイトルを入力",
        pageTitlePlaceholder: "ページタイトルを入力",
        descriptionPlaceholder: "詳細を入力",
        surveyDescriptionPlaceholder: "調査の詳細を入力",
        pageDescriptionPlaceholder: "ページの詳細を入力",
        textWrapEnabled: "ラップの選択肢",
        showOtherItem: "他のアイテム",
        otherText: "他のアイテムのテキスト",
        showNoneItem: "ノーアイテム",
        showRefuseItem: "[回答を拒否] オプションを許可する",
        showDontKnowItem: "[わからない] オプションを許可する",
        noneText: "ノーアイテムのテキスト",
        showSelectAllItem: "アイテムを全て選択",
        selectAllText: "アイテムを全て選択のテキスト",
        choicesMin: "自動生成アイテムの最小値",
        choicesMax: "自動生成アイテムの最大値",
        choicesStep: "自動生成アイテムの差",
        name: "名前",
        title: "タイトル",
        cellType: "セルタイプ",
        colCount: "行の数",
        choicesOrder: "選択順",
        visible: "表示",
        isRequired: "必須",
        markRequired: "必須としてマーク",
        removeRequiredMark: "必要なマークを削除する",
        isAllRowRequired: "全ての列で回答必須",
        eachRowUnique: "行での回答の重複を防ぐ",
        requiredErrorText: "必要なエラーテキスト",
        startWithNewLine: "ニューラインで開始",
        rows: "列数",
        cols: "行の数",
        placeholder: "プレースホルダの入力",
        showPreview: "プレビューエリア表示",
        storeDataAsText: "ファイルのコンテンツをテキストとしてJSONの結果に保存",
        maxSize: "ファイルの最大サイズ（byte）",
        rowCount: "列数",
        columnLayout: "行のレイアウト",
        addRowLocation: "列ボタンのロケーションを追加",
        transposeData: "行を列に転置する",
        addRowText: "行ボタンのテキストを追加",
        removeRowText: "行ボタンのテキストを削除",
        rateMin: "最小レート",
        rateMax: "最大レート",
        rateStep: "レートステップ",
        minRateDescription: "最小レートの詳細",
        maxRateDescription: "最大レートの説明",
        inputType: "入力タイプ",
        optionsCaption: "オプションのキャプション",
        defaultValue: "デフォルト値",
        cellsDefaultRow: "デフォルトのセルテキスト",
        surveyEditorTitle: "アンケート設定を編集する",
        qEditorTitle: "編集： {0}",
        maxLength: "最大長",
        buildExpression: "構築する",
        editExpression: "編集",
        and: "そして",
        or: "又は",
        remove: "削除する",
        addCondition: "条件を追加する",
        emptyLogicPopupMessage: "質問を選択して、条件の設定を開始します。",
        if: "もし",
        then: "そうしたら",
        setToName: "ターゲットの質問",
        fromName: "回答をコピーする質問",
        gotoName: "スキップする質問",
        ruleIsNotSet: "ルールが正しくありません",
        includeIntoResult: "アンケート結果に含める",
        showTitle: "タイトルの表示/非表示",
        expandCollapseTitle: "タイトルを展開/折りたたむ",
        locale: "デフォルトの言語",
        simulator: "デバイスを選択する",
        landscapeOrientation: "横向き",
        portraitOrientation: "縦向きに切り替える",
        mode: "モード（編集/読み取り専用）",
        clearInvisibleValues: "非表示の値をクリアする",
        cookieName: "Cookie名（ローカルで2回アンケートを実行しないようにするため）",
        sendResultOnPageNext: "次のページにアンケート結果を送信する",
        storeOthersAsComment: "「その他」の値を別のフィールドに保存する",
        showPageTitles: "ページタイトルを表示する",
        showPageNumbers: "ページ番号を表示する",
        pagePrevText: "「前のページへ」ボタンのテキスト",
        pageNextText: "「次のページへ」ボタンのテキスト",
        completeText: "「完了」ボタンのテキスト",
        previewText: "「プレビュー」ボタンのテキスト",
        editText: "「編集」ボタンのテキスト",
        startSurveyText: "「開始」ボタンのテキスト",
        showNavigationButtons: "ナビゲーションボタンを表示する（デフォルトのナビゲーション）",
        showPrevButton: "「前へ」ボタンを表示する（ユーザーは前のページに戻ることができます）",
        firstPageIsStarted: "アンケートの最初のページは、開始ページです。",
        showCompletedPage: "完了したページを最後に表示する（completedHtml）",
        goNextPageAutomatic: "すべての質問に回答すると、自動的に次のページに移動します",
        allowCompleteSurveyAutomatic: "調査に自動的に回答する",
        showProgressBar: "プログレスバーを表示する",
        questionTitleLocation: "質問のタイトルの場所",
        questionTitleWidth: "質問タイトルの幅",
        requiredText: "質問には記号が必要",
        questionTitleTemplate: "質問タイトルのテンプレート、デフォルトは「{no}. {require} {title}」です",
        questionErrorLocation: "質問エラーの場所",
        focusFirstQuestionAutomatic: "ページを変える際に最初の質問に焦点を合わせる",
        questionsOrder: "ページ上の要素の順序",
        maxTimeToFinish: "アンケート終了までの最長時間",
        maxTimeToFinishPage: "アンケートの1ページを終了するまでの最長時間",
        showTimerPanel: "タイマーパネルを表示する",
        showTimerPanelMode: "タイマーパネルモードを表示",
        renderMode: "レンダーモード",
        allowAddPanel: "パネルの追加を許可",
        allowRemovePanel: "パネルの削除を許可",
        panelAddText: "パネルテキストを追加しています",
        panelRemoveText: "パネルテキストを削除しています",
        isSinglePage: "1ページ上にすべてのエレメントを表示",
        html: "HTML",
        setValue: "答える",
        dataFormat: "画像フォーマット",
        allowAddRows: "行の追加を許可する",
        allowRemoveRows: "行の削除を許可する",
        allowRowsDragAndDrop: "行のドラッグ アンド ドロップを許可する",
        responsiveImageSizeHelp: "正確な画像の幅または高さを指定した場合には適用されません。",
        minImageWidth: "最小画像幅",
        maxImageWidth: "最大画像幅",
        minImageHeight: "最小画像の高さ",
        maxImageHeight: "最大画像の高さ",
        minValue: "最小値",
        maxValue: "最大値",
        minLength: "最小長",
        allowDigits: "数字を許可",
        minCount: "最小数",
        maxCount: "最大数",
        regex: "正規表現",
        surveyvalidator: {
            text: "エラーメッセージ",
            expression: "検証式"
        },
        totalText: "テキストの合計",
        totalType: "タイプの合計",
        totalExpression: "表現の合計",
        totalDisplayStyle: "表示スタイルの合計",
        totalCurrency: "通貨の合計",
        totalFormat: "形式の合計",
        logo: "ロゴ (URL または base64 でエンコードされた文字列)",
        questionsOnPageMode: "調査体制",
        maxTextLength: "回答の最大長 (文字数)",
        maxOthersLength: "コメントの最大長 (文字数)",
        commentAreaRows: "コメント領域の高さ (行単位)",
        autoGrowComment: "必要に応じてコメント領域を自動展開する",
        allowResizeComment: "ユーザーがテキスト領域のサイズを変更できるようにする",
        textUpdateMode: "テキストの質問値を更新する",
        maskType: "定型入力の種類",
        maskTypes: {
            none: "何一つ",
            patternmask: "パターン",
            numericmask: "数値",
            datetimemask: "日付と時刻",
            currencymask: "通貨"
        },
        focusOnFirstError: "最初の無効な回答にフォーカスを設定する",
        checkErrorsMode: "検証の実行",
        navigateToUrl: "URL に移動します。",
        navigateToUrlOnCondition: "ダイナミック URL",
        completedBeforeHtml: "ユーザーがこのアンケートに既に記入しているかどうかを示すマークアップ",
        completedHtml: "アンケート完了ページのマークアップ",
        completedHtmlOnCondition: "動的調査 完全なページ マークアップ",
        loadingHtml: "アンケートモデルの読み込み中に表示するマークアップ",
        commentText: "コメント領域のテキスト",
        autocomplete: "オートコンプリートの種類",
        labelTrue: "「真の」ラベル",
        labelFalse: "「虚偽」ラベル",
        allowClear: "オプションのキャプションを表示する",
        searchMode: "検索モード",
        displayStyle: "値の表示スタイル",
        format: "書式設定された文字列",
        maximumFractionDigits: "小数部の最大数桁数",
        minimumFractionDigits: "小数部の最小桁数",
        useGrouping: "グループ化区切りの表示",
        allowMultiple: "複数のファイルを許可する",
        allowImagesPreview: "プレビュー画像",
        acceptedTypes: "受け入れられるファイルの種類",
        waitForUpload: "アップロードが完了するのを待ちます",
        needConfirmRemoveFile: "ファイルの削除を確認する",
        detailPanelMode: "詳細パネルの位置",
        minRowCount: "最小行数",
        maxRowCount: "最大行数",
        confirmDelete: "行の削除を確認する",
        confirmDeleteText: "確認メッセージ",
        panelCount: "初期パネル数",
        minPanelCount: "最小パネル数",
        maxPanelCount: "最大パネル数",
        panelsState: "内側パネルの展開状態",
        panelPrevText: "前のパネルボタンのツールチップ",
        panelNextText: "[次へ] パネル ボタンのツールチップ",
        showRangeInProgress: "進行状況バーを表示する",
        panelRemoveButtonLocation: "[パネルを削除] ボタンの位置",
        hideIfRowsEmpty: "行がない場合は質問を非表示にする",
        hideColumnsIfEmpty: "行がない場合は列を非表示にする",
        rateValues: "カスタムレート値",
        rateCount: "レート数",
        autoGenerate: "レート値を指定する方法は?",
        hideIfChoicesEmpty: "選択肢がない場合は質問を非表示にする",
        minWidth: "最小幅 (CSS で受け入れられる値)",
        maxWidth: "最大幅 (CSS で受け入れられる値)",
        width: "幅 (CSS で受け入れられる値)",
        showHeader: "列ヘッダーを表示する",
        horizontalScroll: "水平スクロールバーを表示",
        columnMinWidth: "最小列幅 (CSS で受け入れられる値)",
        rowTitleWidth: "行ヘッダーの幅 (CSS で受け入れられる値)",
        valueTrue: "「真」の値",
        valueFalse: "\"偽\" の値",
        minErrorText: "\"値が最小値を下回っています\" というエラー メッセージ",
        maxErrorText: "\"値が最大値を超えています\" というエラー メッセージ",
        otherErrorText: "「コメントを空にしました」というエラーメッセージ",
        keyDuplicationError: "\"一意でないキー値\" エラー メッセージ",
        minSelectedChoices: "選択される最小選択肢",
        maxSelectedChoices: "最大選択選択肢数",
        showClearButton: "[クリア] ボタンを表示する",
        logoWidth: "ロゴの幅 (CSS で受け入れられる値)",
        logoHeight: "ロゴの高さ (CSS で受け入れられる値)",
        readOnly: "読み取り専用",
        enableIf: "次の場合に編集可能",
        emptyRowsText: "\"行なし\" メッセージ",
        separateSpecialChoices: "個別の特別な選択肢 (なし、その他、すべて選択)",
        choicesFromQuestion: "次の質問から選択肢をコピーする",
        choicesFromQuestionMode: "どの選択肢をコピーするか?",
        progressBarShowPageTitles: "プログレスバーにページタイトルを表示する",
        progressBarShowPageNumbers: "プログレスバーにページ番号を表示する",
        showCommentArea: "コメント領域を表示する",
        commentPlaceholder: "コメント領域のプレースホルダー",
        displayRateDescriptionsAsExtremeItems: "レートの説明を極値として表示する",
        rowsOrder: "行の順序",
        columnsLayout: "列のレイアウト",
        columnColCount: "ネストされた列数",
        correctAnswer: "正解",
        defaultPanelValue: "デフォルト値",
        cells: "セルテキスト",
        fileInputPlaceholder: "ファイルを選択するか、ファイルリンクを貼り付けます...",
        keyName: "キー列",
        itemvalue: {
            visibleIf: "次の場合にオプションを表示します",
            enableIf: "次の場合は、オプションを選択可能にします"
        },
        "itemvalue@rows": {
            visibleIf: "次の場合に行を表示します。",
            enableIf: "次の場合に行を編集可能にします"
        },
        imageitemvalue: {
            text: "代替テキスト"
        },
        logoPosition: "ロゴの位置",
        addLogo: "ロゴを追加...",
        changeLogo: "ロゴを変更...",
        logoPositions: {
            none: "ロゴを削除",
            left: "左",
            right: "右",
            top: "上に",
            bottom: "下に"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "パネルレイアウト"
            },
            general: "一般",
            fileOptions: "オプション",
            html: "HTMLエディター",
            columns: "列",
            rows: "行",
            choices: "選択",
            items: "アイテム",
            visibleIf: "以下の場合、見える：",
            enableIf: "以下の場合、有効にする：",
            requiredIf: "以下の場合、必須：",
            rateValues: "レート値",
            choicesByUrl: "ウェブの選択",
            matrixChoices: "デフォルトの選択",
            multipleTextItems: "テキスト入力",
            numbering: "番号付け",
            validators: "バリデータ",
            navigation: "ナビゲーション",
            question: "質問",
            pages: "ページ",
            timer: "タイマー/クイズ",
            calculatedValues: "算出された値",
            triggers: "トリガー",
            templateTitle: "テンプレートタイトル",
            totals: "合計",
            logic: "ロジック",
            mask: "定型入力設定",
            layout: {
                panel: "レイアウト",
                question: "レイアウト",
                base: "レイアウト"
            },
            data: "データ",
            validation: "検証",
            cells: "セル",
            showOnCompleted: "完成したものに表示",
            logo: "アンケートタイトルのロゴ",
            slider: "スライダー",
            expression: "表現",
            questionSettings: "質問設定",
            header: "ヘッダ",
            background: "バックグラウンド",
            appearance: "様子",
            others: "その他"
        },
        editProperty: "プロパティ'{0}'を編集",
        items: "[ アイテム: {0} ]",
        choicesVisibleIf: "選択肢は次の場合に表示されます。",
        choicesEnableIf: "次の場合に選択肢を選択できます。",
        columnsEnableIf: "列は次の場合に表示されます。",
        rowsEnableIf: "行は次の場合に表示されます。",
        innerIndent: "内側のインデントを追加する",
        defaultValueFromLastRow: "最後の行からデフォルト値を取得する",
        defaultValueFromLastPanel: "最後のパネルからデフォルト値を取得する",
        enterNewValue: "値を入力してください。",
        noquestions: "アンケートに質問はありません。",
        createtrigger: "トリガーを作成してください。",
        titleKeyboardAdornerTip: "編集するには「enter」キーを押してください",
        keyboardAdornerTip: "アイテムを編集するには「enter」キーを押してください、アイテムを削除するには「delete」キーを押してください、アイテムを移動するには「alt」+上矢印キーまたは「alt」+下矢印キーを押してください",
        triggerOn: "オン ",
        triggerMakePagesVisible: "ページを可視化:",
        triggerMakeQuestionsVisible: "エレメントを可視化:",
        triggerCompleteText: "うまくいけばアンケートが完了します。",
        triggerNotSet: "トリガーが設定されていません",
        triggerRunIf: "次の場合、実行",
        triggerSetToName: "次の値を変更: ",
        triggerFromName: "次から値をコピー: ",
        triggerRunExpression: "この表現を実行:",
        triggerSetValue: "宛先: ",
        triggerGotoName: "質問に移動:",
        triggerIsVariable: "アンケートの結果に変数を入れないでください。",
        triggerRunExpressionEmpty: "有効な表現を入力してください",
        emptyExpressionPlaceHolder: "ここに式を入力してください...",
        noFile: "ファイルが選択されていません",
        clearIfInvisible: "質問が非表示になった場合は値をクリアする",
        valuePropertyName: "値プロパティ名",
        searchEnabled: "検索を有効にする",
        hideSelectedItems: "選択した項目を非表示にする",
        closeOnSelect: "選択後にドロップダウンを閉じる",
        verticalAlign: "垂直方向の配置",
        alternateRows: "代替行",
        columnsVisibleIf: "列は次の場合に表示されます。",
        rowsVisibleIf: "行は次の場合に表示されます。",
        otherPlaceholder: "コメント領域のプレースホルダー",
        filePlaceholder: "ファイル プレースホルダー テキスト",
        photoPlaceholder: "写真の代替テキスト",
        fileOrPhotoPlaceholder: "ファイルまたは写真のプレースホルダーテキスト",
        rateType: "レートタイプ",
        url_placeholder: "例:https://api.example.com/books",
        path_placeholder: "例:categories.fiction",
        questionStartIndex_placeholder: "例:a)",
        width_placeholder: "例:6インチ",
        minWidth_placeholder: "例:600px",
        maxWidth_placeholder: "例:50%",
        imageHeight_placeholder: "自動",
        imageWidth_placeholder: "自動",
        theme: {
            themeName: "テーマ",
            isPanelless: "質問の表示設定",
            editorPanel: "背景と角の半径",
            questionPanel: "背景と角の半径",
            primaryColor: "アクセントカラー",
            panelBackgroundTransparency: "パネル背景の不透明度",
            questionBackgroundTransparency: "質問の背景の不透明度",
            fontSize: "フォントサイズ",
            scale: "規模",
            cornerRadius: "コーナR(Corner Radius)",
            pageTitle: "タイトルのフォント",
            pageDescription: "説明フォント",
            questionTitle: "タイトルのフォント",
            questionDescription: "説明フォント",
            editorFont: "フォント",
            backgroundOpacity: "不透明",
            "--sjs-font-family": "フォントファミリー",
            "--sjs-general-backcolor-dim": "背景色",
            "--sjs-primary-backcolor": "アクセントの背景",
            "--sjs-primary-forecolor": "アクセントの前景",
            "--sjs-special-red": "エラーメッセージ",
            "--sjs-shadow-small": "影の効果",
            "--sjs-shadow-inner": "影の効果",
            "--sjs-border-default": "色"
        },
        "header@header": {
            headerView: "眺める",
            logoPosition: "ロゴの位置",
            surveyTitle: "調査タイトルのフォント",
            surveyDescription: "調査の説明フォント",
            headerTitle: "調査タイトルのフォント",
            headerDescription: "調査の説明フォント",
            inheritWidthFrom: "コンテンツ領域の幅",
            textAreaWidth: "文字幅",
            backgroundColorSwitch: "背景色",
            backgroundImage: "背景画像",
            backgroundImageOpacity: "不透明",
            overlapEnabled: "オーバーラップ",
            logoPositionX: "ロゴの位置",
            titlePositionX: "タイトルの位置",
            descriptionPositionX: "記述の位置"
        }
    },
    // Property values
    pv: {
        "true": "真",
        "false": "偽",
        file: "ローカルファイル",
        camera: "カメラ",
        "file-camera": "ローカルファイルまたはカメラ",
        inherit: "継承する",
        show: "表示する",
        hide: "非表示にする",
        default: "デフォルト",
        initial: "最初の",
        random: "ランダム",
        collapsed: "折り畳んだ",
        expanded: "展開した",
        none: "なし",
        asc: "昇順",
        desc: "降順",
        indeterminate: "不確定",
        selected: "入選",
        unselected: "未選択",
        decimal: "小数",
        currency: "通貨",
        percent: "パーセント",
        firstExpanded: "firstExpanded",
        off: "オフ",
        list: "リスト",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        tab: "タブ",
        horizontal: "水平",
        vertical: "垂直",
        top: "上",
        bottom: "下",
        topBottom: "上と下",
        both: "両方",
        left: "左",
        right: "右",
        center: "センター",
        leftRight: "左右",
        middle: "中央",
        color: "色",
        date: "日付",
        datetime: "日時",
        "datetime-local": "日時ローカル",
        email: "電子メール",
        month: "月",
        number: "数",
        password: "パスワード",
        range: "範囲",
        tel: "電話",
        text: "テキスト",
        time: "時間",
        url: "リンク",
        week: "週",
        hidden: "非表示",
        edit: "編集",
        display: "表示",
        contain: "含む",
        cover: "覆う",
        fill: "注ぐ",
        next: "次に",
        last: "前の",
        onComplete: "onComplete",
        onHidden: "onHidden",
        onHiddenContainer: "質問またはそのパネル/ページが非表示になったとき",
        clearInvisibleValues: {
            none: "なし"
        },
        clearIfInvisible: {
            none: "一度もない"
        },
        inputType: {
            color: "色",
            date: "日付",
            "datetime-local": "日付と時刻",
            email: "電子メール",
            month: "月",
            number: "数",
            password: "パスワード",
            range: "範囲",
            tel: "電話番号",
            text: "テキスト",
            time: "時間",
            url: "リンク",
            week: "週"
        },
        all: "すべて",
        page: "ページ",
        survey: "アンケート",
        onNextPage: "onNextPage",
        onValueChanged: "onValueChanged",
        onValueChanging: "回答が変更される前に",
        questionsOnPageMode: {
            standard: "元の構造",
            singlePage: "すべての質問を 1 ページに表示する",
            questionPerPage: "1ページにつき1つの質問を表示する"
        },
        noPreview: "プレビューなし",
        showAllQuestions: "すべての質問を含むプレビューを表示",
        showAnsweredQuestions: "回答された質問を含むプレビューを表示",
        pages: "ページ",
        questions: "質問",
        requiredQuestions: "必須の質問",
        correctQuestions: "正しい質問",
        buttons: "ボタン",
        underInput: "インプットの下",
        underTitle: "タイトルの下",
        onBlur: "ぼかし時",
        onTyping: "入力中",
        underRow: "行の下",
        underRowSingle: "行の下には、1つのパネルのみが表示されます",
        auto: "自動",
        showNavigationButtons: {
            none: "隠れた"
        },
        showTimerPanel: {
            none: "隠れた"
        },
        showTimerPanelMode: {
            all: "両方とも"
        },
        addRowLocation: {
            default: "マトリックスレイアウトに依存"
        },
        panelsState: {
            default: "ユーザーはパネルを展開または折りたたむことはできません",
            collapsed: "すべてのパネルが折りたたまれている",
            expanded: "すべてのパネルが展開されます",
            firstExpanded: "最初の展開"
        },
        widthMode: {
            static: "静的",
            responsive: "応答"
        },
        contentMode: {
            image: "画像",
            video: "ビデオ",
            youtube: "ユーチューブ"
        },
        displayMode: {
            buttons: "ボタン",
            dropdown: "ドロップダウン"
        },
        rateColorMode: {
            default: "デフォルト",
            scale: "規模"
        },
        scaleColorMode: {
            monochrome: "モノクロ",
            colored: "有色"
        },
        autoGenerate: {
            "true": "生成する",
            "false": "手動で入力する"
        },
        rateType: {
            labels: "ラベル",
            stars: "星",
            smileys: "スマイリー"
        },
        state: {
            default: "締まる"
        },
        showQuestionNumbers: {
            default: "自動番号付け",
            on: "自動番号付け",
            onPage: "各ページでリセット",
            onpanel: "各パネルでリセット",
            onPanel: "各パネルでリセット",
            onSurvey: "調査を続ける",
            off: "ナンバリングなし"
        },
        descriptionLocation: {
            underTitle: "質問タイトルの下",
            underInput: "入力欄の下"
        },
        selectToRankAreasLayout: {
            horizontal: "選択肢の横",
            vertical: "上記の選択肢"
        },
        displayStyle: {
            decimal: "小数",
            currency: "通貨",
            percent: "百分率",
            date: "日付"
        },
        totalDisplayStyle: {
            decimal: "小数",
            currency: "通貨",
            percent: "百分率",
            date: "日付"
        },
        rowsOrder: {
            initial: "翻訳元"
        },
        questionsOrder: {
            initial: "翻訳元"
        },
        showProgressBar: {
            off: "隠れた",
            topbottom: "上と下",
            aboveheader: "ヘッダーの上",
            belowheader: "ヘッダーの下"
        },
        sum: "和",
        count: "数える",
        min: "分",
        max: "マックス",
        avg: "平均",
        searchMode: {
            contains: "含む",
            startsWith: "次で始まる"
        },
        backgroundImageFit: {
            auto: "自動",
            cover: "覆う",
            contain: "含む",
            fill: "伸ばす",
            tile: "瓦"
        },
        backgroundImageAttachment: {
            fixed: "付け",
            scroll: "スクロール"
        },
        headerView: {
            basic: "基本的な",
            advanced: "アドバンスド"
        },
        inheritWidthFrom: {
            survey: "調査と同じ",
            container: "コンテナにフィット"
        },
        backgroundColorSwitch: {
            none: "何一つ",
            accentColor: "アクセントカラー",
            custom: "習慣"
        },
        colorPalette: {
            light: "光",
            dark: "暗い"
        },
        isPanelless: {
            "false": "デフォルト",
            "true": "パネルなし"
        }
    },
    // Operators
    op: {
        empty: "は空白です",
        notempty: "は空白ではありません",
        equal: "等しい",
        notequal: "等しくない",
        contains: "含む",
        notcontains: "含まない",
        anyof: "次のいずれか",
        allof: "次のすべて",
        greater: "より大きい",
        less: "より小さい",
        greaterorequal: "等しいかより大きい",
        lessorequal: "等しいかより小さい",
        and: "そして",
        or: "又は"
    },
    // Embed window
    ew: {
        angular: "Angularバージョンを使用",
        jquery: "jQueryバージョンを使用",
        knockout: "Knockoutバージョンを使用",
        react: "Reactバージョンを使用",
        vue: "Vueバージョンを使用",
        bootstrap: "Bootstrapフレームワーク向け",
        modern: "モダンテーマ",
        default: "デフォルトテーマ",
        orange: "オレンジテーマ",
        darkblue: "ダークブルーテーマ",
        darkrose: "ダークローズテーマ",
        stone: "ストーンテーマ",
        winter: "ウィンターテーマ",
        winterstone: "ウィンターストーンテーマ",
        showOnPage: "1つのページにアンケートを表示",
        showInWindow: "1つのウィンドウにアンケートを表示",
        loadFromServer: "サーバーからアンケートのJSONファイルを読み込む",
        titleScript: "スクリプトとスタイル",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "それをテストするためのページを選択:",
        showInvisibleElements: "不可視エレメントを表示",
        hideInvisibleElements: "非表示の要素を非表示にする"
    },
    validators: {
        answercountvalidator: "答えの数",
        emailvalidator: "メール",
        expressionvalidator: "表現",
        numericvalidator: "数字の",
        regexvalidator: "正規表現",
        textvalidator: "テキスト"
    },
    triggers: {
        completetrigger: "アンケートを完了",
        setvaluetrigger: "値を設定",
        copyvaluetrigger: "値をコピー",
        skiptrigger: "質問へスキップ",
        runexpressiontrigger: "数式を実行",
        visibletrigger: "可視性を変更 (非推奨)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Ex.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Ex.: mm/dd/yyyy"
        },
        currencymask: {
            prefix: "Ex.: $",
            suffix: "Ex.: USD"
        },
        panelbase: {
            questionTitleWidth: "例:200px"
        }
    },
    pehelp: {
        panel: {
            name: "回答者には表示されないパネルID。",
            description: "パネルのサブタイトルを入力します。",
            visibleIf: "魔法の杖アイコンを使用して、パネルの表示を決定する条件付きルールを設定します。",
            enableIf: "魔法の杖アイコンを使用して、パネルの読み取り専用モードを無効にする条件付きルールを設定します。",
            requiredIf: "魔法の杖アイコンを使用して、ネストされた質問に回答が少なくとも1つない限り、調査の送信を禁止する条件付きルールを設定します。",
            questionTitleLocation: "このパネル内のすべての質問に適用されます。この設定を上書きする場合は、個々の質問のタイトル配置ルールを定義します。「継承」オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定(デフォルトでは「上」)を適用します。",
            questionTitleWidth: "質問タイトルが質問ボックスの左側に配置されている場合に、質問タイトルの幅を一定に設定します。CSS 値 (px、%、in、pt など) を受け入れます。",
            questionErrorLocation: "パネル内のすべての質問に関連するエラーメッセージの位置を設定します。[継承] オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定を適用します。",
            questionsOrder: "質問の元の順序を維持するか、ランダム化します。[継承] オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定を適用します。",
            page: "パネルを選択したページの末尾に再配置します。",
            innerIndent: "パネルの内容とパネルボックスの左の境界線の間にスペースまたは余白を追加します。",
            startWithNewLine: "選択を解除すると、前の質問またはパネルと 1 行でパネルが表示されます。パネルがフォームの最初の要素である場合、この設定は適用されません。",
            state: "次から選択します: 「展開」 - パネルは完全に表示され、折りたたむことができます。「折りたたまれた」 - パネルにはタイトルと説明のみが表示され、展開できます。「ロック」 - パネルは完全に表示され、折りたたむことはできません。",
            width: "パネルの幅を、同じ行内の他の調査要素に比例して設定します。CSS 値 (px、%、in、pt など) を受け入れます。"
        },
        paneldynamic: {
            name: "回答者には表示されないパネルID。",
            description: "パネルのサブタイトルを入力します。",
            visibleIf: "魔法の杖アイコンを使用して、パネルの表示を決定する条件付きルールを設定します。",
            enableIf: "魔法の杖アイコンを使用して、パネルの読み取り専用モードを無効にする条件付きルールを設定します。",
            requiredIf: "魔法の杖アイコンを使用して、ネストされた質問に回答が少なくとも1つない限り、調査の送信を禁止する条件付きルールを設定します。",
            templateTitleLocation: "このパネル内のすべての質問に適用されます。この設定を上書きする場合は、個々の質問のタイトル配置ルールを定義します。「継承」オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定(デフォルトでは「上」)を適用します。",
            templateErrorLocation: "無効な入力を含む質問に関連するエラーメッセージの場所を設定します。次から選択します: \"Top\" - 質問ボックスの上部にエラーテキストが配置されます。\"Bottom\" - 質問ボックスの下部にエラーテキストが配置されます。「継承」オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定(デフォルトでは「上」)を適用します。",
            errorLocation: "パネル内のすべての質問に関連するエラーメッセージの位置を設定します。[継承] オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定を適用します。",
            page: "パネルを選択したページの末尾に再配置します。",
            innerIndent: "パネルの内容とパネルボックスの左の境界線の間にスペースまたは余白を追加します。",
            startWithNewLine: "選択を解除すると、前の質問またはパネルと 1 行でパネルが表示されます。パネルがフォームの最初の要素である場合、この設定は適用されません。",
            state: "次から選択します: 「展開」 - パネルは完全に表示され、折りたたむことができます。「折りたたまれた」 - パネルにはタイトルと説明のみが表示され、展開できます。「ロック」 - パネルは完全に表示され、折りたたむことはできません。",
            width: "パネルの幅を、同じ行内の他の調査要素に比例して設定します。CSS 値 (px、%、in、pt など) を受け入れます。",
            templateTitle: "動的パネルタイトルのテンプレートを入力します。パネルの一般的な位置には {panelIndex} を使用し、表示されているパネル間の順序には {visiblePanelIndex} を使用します。これらのプレースホルダーをパターンに挿入して、自動番号付けを追加します。",
            templateTabTitle: "タブタイトルのテンプレートを入力します。パネルの一般的な位置には {panelIndex} を使用し、可視パネル間の順序には {visiblePanelIndex} を使用します。これらのプレースホルダーをパターンに挿入して、自動番号付けを追加します。",
            tabTitlePlaceholder: "タブ タイトル パターンが意味のある値を生成しない場合に適用されるタブ タイトルのフォールバック テキスト。",
            templateVisibleIf: "この設定では、動的パネル内の個々のパネルの表示を制御できます。'{panel}' プレースホルダーを使用して、式で現在のパネルを参照します。",
            titleLocation: "この設定は、このパネル内のすべての質問に自動的に継承されます。この設定を上書きする場合は、個々の質問のタイトル配置ルールを定義します。「継承」オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定(デフォルトでは「上」)を適用します。",
            descriptionLocation: "「継承」オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定(デフォルトでは「パネルタイトルの下」)を適用します。",
            newPanelPosition: "新しく追加されたパネルの位置を定義します。デフォルトでは、新しいパネルが最後に追加されます。「次へ」を選択して、現在のパネルの後に新しいパネルを挿入します。",
            defaultValueFromLastPanel: "最後のパネルから回答を複製し、次に追加された動的パネルに割り当てます。",
            keyName: "質問名を参照して、各パネルでこの質問に対して一意の回答を提供するようユーザーに要求します。"
        },
        defaultValueExpression: "この設定では、式に基づいてデフォルトの回答値を割り当てることができます。式には、基本的な計算 - '{q1_id} + {q2_id}'、'{age} > 60' などのブール式、関数 'iif()'、'today()'、'age()'、'min()'、'max()'、'avg()' などを含めることができます。この式によって決定される値は、回答者の手動入力で上書きできる初期デフォルト値として機能します。",
        resetValueIf: "魔法の杖アイコンを使用して、回答者の入力を「デフォルト値式」または「値式の設定」に基づく値、または「デフォルト回答」値(どちらかが設定されている場合)にリセットするタイミングを決定する条件付きルールを設定します。",
        setValueIf: "魔法の杖アイコンを使用して、「値の設定式」をいつ実行するかを決定し、結果の値を応答として動的に割り当てる条件付きルールを設定します。",
        setValueExpression: "「値を設定する条件」ルールの条件が満たされた場合に設定される値を定義する式を指定します。式には、基本的な計算 - '{q1_id} + {q2_id}'、'{age} > 60' などのブール式、関数 'iif()'、'today()'、'age()'、'min()'、'max()'、'avg()' などを含めることができます。この式によって決定される値は、回答者の手動入力によって上書きできます。",
        question: {
            name: "回答者に表示されない質問ID。",
            description: "質問のサブタイトルを入力します。",
            visibleIf: "魔法の杖アイコンを使用して、質問の表示を決定する条件付きルールを設定します。",
            enableIf: "魔法の杖アイコンを使用して、質問の読み取り専用モードを無効にする条件付きルールを設定します。",
            requiredIf: "魔法の杖アイコンを使用して、質問に回答がない限り、アンケートの進行や送信を禁止する条件付きルールを設定します。",
            startWithNewLine: "選択を解除すると、前の質問またはパネルと 1 行で質問が表示されます。この設定は、質問がフォームの最初の要素である場合には適用されません。",
            page: "選択したページの最後に質問を再配置します。",
            state: "選択肢: 「展開」 - 質問ボックスは完全に表示され、折りたたむことができます。「折りたたまれた」 - 質問ボックスにはタイトルと説明のみが表示され、展開できます。\"Locked\" - 質問ボックスは完全に表示され、折りたたむことはできません。",
            titleLocation: "パネル、ページ、またはアンケートレベルで定義されたタイトル配置ルールを上書きします。「継承」オプションは、上位レベルの設定(設定されている場合)またはアンケートレベルの設定(デフォルトでは「トップ」)を適用します。",
            descriptionLocation: "「継承」オプションは、アンケートレベルの設定(デフォルトでは「質問タイトルの下」)を適用します。",
            errorLocation: "無効な入力を含む質問に関連するエラーメッセージの場所を設定します。次から選択します: \"Top\" - 質問ボックスの上部にエラーテキストが配置されます。\"Bottom\" - 質問ボックスの下部にエラーテキストが配置されます。「継承」オプションは、アンケートレベルの設定(デフォルトでは「トップ」)を適用します。",
            indent: "質問の内容と質問ボックスの左の境界線の間にスペースまたは余白を追加します。",
            width: "同じ行内の他のアンケート要素に比例して質問の幅を設定します。CSS 値 (px、%、in、pt など) を受け入れます。",
            surveyvalidator: {
                expression: "魔法の杖アイコンを使用して、質問の検証ルールを設定します。"
            },
            textUpdateMode: "次から選択します: \"On lost focus\" - 入力フィールドがフォーカスを失ったときに値が更新されます。「入力中」 - ユーザーが入力しているときに、値がリアルタイムで更新されます。「継承」オプションは、アンケートレベルの設定(デフォルトでは「フォーカスを失ったとき」)を適用します。",
            url: "任意の Web サービスを多肢選択式の質問のデータ ソースとして使用できます。選択肢の値を入力するには、データを提供するサービスの URL を入力します。",
            searchMode: "ドロップダウン リストをフィルター処理するために使用される比較演算。",
            textWrapEnabled: "選択肢オプションのテキスト(長い)は、ドロップダウンメニュー内に収まるように改行を自動的に生成します。テキストをクリップする場合は、選択を解除します。"
        },
        signaturepad: {
            signatureWidth: "表示される署名領域と結果の画像の幅を設定します。",
            signatureHeight: "表示される署名領域と結果の画像の高さを設定します。",
            signatureAutoScaleEnabled: "デフォルトの3:2の縦横比を維持したまま、質問ボックス内の使用可能なすべてのスペースを署名領域に埋める場合に選択します。カスタムの幅と高さの値が設定されている場合、設定ではこれらの寸法の縦横比が維持されます。"
        },
        file: {
            imageHeight: "アンケート結果の画像の高さを調整します。",
            imageWidth: "アンケート結果の画像の幅を調整します。"
        },
        image: {
            contentMode: "「自動」オプションでは、指定されたソースURLに基づいて、表示に適したモード(画像、動画、YouTube)が自動的に決定されます。"
        },
        imagepicker: {
            imageHeight: "高さの最小値と最大値の値を上書きします。",
            imageWidth: "幅の最小値と最大値を上書きします。",
            choices: "\"Value\" は、条件付きルールで使用される項目 ID として機能します。回答者に「テキスト」が表示されます。",
            contentMode: "「画像」と「動画」のどちらかを選択して、メディアセレクタのコンテンツモードを設定します。「画像」を選択した場合は、提供されるすべてのオプションが、JPEG、GIF、PNG、APNG、SVG、BMP、ICO形式の画像ファイルであることを確認してください。同様に、「ビデオ」を選択した場合は、すべてのオプションがMP4、MOV、WMV、FLV、AVI、MKV形式のビデオファイルへの直接リンクであることを確認してください。YouTubeのリンクは動画オプションではサポートされていませんのでご注意ください。"
        },
        text: {
            size: "この設定では、入力フィールドのサイズが変更されるだけで、質問ボックスの幅には影響しません。許容される入力長を制限するには、<b>検証→最大文字数制限</b>に移動します。"
        },
        comment: {
            rows: "入力欄に表示する行数を設定します。入力の行数が多い場合は、スクロールバーが表示されます。"
        },
        // survey templates
        survey: {
            mode: "次から選択します。 「編集可能」 - 回答者がアンケートに回答できるようにします。「読み取り専用」 - フォームの編集を無効にします。"
        },
        matrixdropdowncolumn: {
            name: "回答者に表示されない列 ID。",
            isUnique: "列に対して有効にすると、回答者はこの列内の質問ごとに一意の回答を提供する必要があります。",
            rows: "入力欄に表示する行数を設定します。入力の行数が多い場合は、スクロールバーが表示されます。",
            visibleIf: "魔法の杖アイコンを使用して、列の表示を決定する条件付きルールを設定します。",
            enableIf: "魔法の杖アイコンを使用して、列の読み取り専用モードを無効にする条件付きルールを設定します。",
            requiredIf: "魔法の杖アイコンを使用して、ネストされた質問に回答が少なくとも1つない限り、調査の送信を禁止する条件付きルールを設定します。",
            showInMultipleColumns: "選択すると、選択肢オプションごとに個別の列が作成されます。"
        },
        widthMode: "次から選択します: \"Static\" - 固定幅を設定します。「レスポンシブ」 - アンケートを画面の全幅に表示します。「自動」 - 使用する質問タイプに応じて、2つのいずれかを適用します。",
        cookieName: "Cookieは、ユーザーが同じアンケートに2回記入するのを防ぎます。",
        logo: "画像リンクを貼り付けるか(サイズ制限なし)、フォルダアイコンをクリックして、コンピューターからファイルを参照します(最大64KB)。",
        logoWidth: "ロゴの幅をCSS単位(px、%、in、ptなど)で設定します。",
        logoHeight: "ロゴの高さを CSS 単位 (px、%、in、pt など) で設定します。",
        logoFit: "次から選択: 「なし」 - 画像は元のサイズを維持します。\"Contain\" - 画像はアスペクト比を維持しながらサイズ変更されます。「表紙」-画像は縦横比を維持しながらボックス全体を埋めます。\"Fill\" - 画像は、アスペクト比を維持せずにボックスを埋めるように引き伸ばされます。",
        goNextPageAutomatic: "回答者が現在のページのすべての質問に回答した後、アンケートを自動的に次のページに進めるかどうかを選択します。",
        allowCompleteSurveyAutomatic: "回答者がすべての質問に回答した後にアンケートを自動的に完了する場合に選択します。",
        showNavigationButtons: "ページ上のナビゲーションボタンの表示と位置を設定します。",
        showProgressBar: "プログレスバーの表示と位置を設定します。「自動」の値は、アンケートヘッダーの上または下に進行状況バーを表示します。",
        showPreviewBeforeComplete: "すべての質問または回答済みの質問のみを含むプレビューページを有効にします。",
        questionTitleLocation: "アンケート内のすべての質問に適用されます。この設定は、下位レベル(パネル、ページ、または質問)のタイトル配置ルールによって上書きできます。下位レベルの設定は、上位レベルの設定よりも優先されます。",
        requiredText: "回答が必要であることを示す記号または記号のシーケンス。",
        questionStartIndex: "番号付けを開始する番号または文字を入力します。",
        questionErrorLocation: "無効な入力を含む質問に関連するエラーメッセージの場所を設定します。次から選択します: \"Top\" - 質問ボックスの上部にエラーテキストが配置されます。\"Bottom\" - 質問ボックスの下部にエラーテキストが配置されます。",
        focusFirstQuestionAutomatic: "各ページの最初の入力フィールドをテキスト入力可能にするかどうかを選択します。",
        questionsOrder: "質問の元の順序を維持するか、ランダム化します。この設定の効果は、「プレビュー」タブにのみ表示されます。",
        maxTextLength: "テキスト入力の質問専用です。",
        maxOthersLength: "質問コメント専用です。",
        commentAreaRows: "質問コメントのテキスト領域に表示される行数を設定します。入力がより多くの行を占めると、スクロールバーが表示されます。",
        autoGrowComment: "質問のコメントと長いテキストの質問の高さを、入力したテキストの長さに基づいて自動的に拡大する場合に選択します。",
        allowResizeComment: "質問コメントとテキスト(長文)の質問のみ。",
        calculatedValues: "カスタム変数は、フォーム計算で使用される中間変数または補助変数として機能します。回答者の入力をソース値として受け取ります。各カスタム変数には、一意の名前と基になる式があります。",
        includeIntoResult: "式の計算値をアンケート結果とともに保存する場合に選択します。",
        triggers: "トリガーは、式に基づくイベントまたは条件です。式が \"true\" と評価されると、トリガーによってアクションが開始されます。このようなアクションには、必要に応じて、影響するターゲットの質問を含めることができます。",
        clearInvisibleValues: "条件付きロジックによって非表示にされた質問の値をクリアするかどうか、およびいつクリアするかを選択します。",
        textUpdateMode: "次から選択します: \"On lost focus\" - 入力フィールドがフォーカスを失ったときに値が更新されます。「入力中」 - ユーザーが入力しているときに、値がリアルタイムで更新されます。",
        columns: "左の値は条件付きルールで使用される列IDとして機能し、右の値は回答者に表示されます。",
        rows: "左の値は条件付きルールで使用される行IDとして機能し、右の値は回答者に表示されます。",
        columnMinWidth: "CSS 値 (px、%、in、pt など) を受け入れます。",
        rowTitleWidth: "CSS 値 (px、%、in、pt など) を受け入れます。",
        totalText: "少なくとも 1 つの列に [合計型] または [合計式] がある場合にのみ表示されます。",
        cellErrorLocation: "無効な入力があるセルに関連するエラーメッセージの位置を設定します。「継承」オプションは、「エラーメッセージの配置」プロパティの設定を適用します。",
        keyDuplicationError: "「重複回答の防止」プロパティが有効な場合、重複したエントリを送信しようとする回答者は、次のエラーメッセージを受け取ります。",
        totalExpression: "式に基づいて合計値を計算できます。式には、基本的な計算 ('{q1_id} + {q2_id}')、ブール式 ('{age} > 60')、関数 ('iif()'、'today()'、'age()'、'min()'、'max()'、'avg()' など) を含めることができます。",
        confirmDelete: "行の削除を確認するプロンプトをトリガーします。",
        defaultValueFromLastRow: "最後の行から回答を複製し、次に追加された動的行に割り当てます。",
        keyName: "指定した列に同じ値が含まれている場合、調査は「一意でないキー値」エラーをスローします。",
        description: "字幕を入力します。",
        locale: "言語を選択してアンケートの作成を開始します。翻訳を追加するには、新しい言語に切り替えて、ここまたは [翻訳] タブで元のテキストを翻訳します。",
        detailPanelMode: "行を基準にした詳細セクションの位置を設定します。次から選択します: \"None\" - 展開は追加されません。\"Under the row\" - 行列の各行の下に行展開が配置されます。\"Under the row, display one row expansion only\" - 展開は 1 行の下にのみ表示され、残りの行展開は折りたたまれます。",
        imageFit: "次から選択: 「なし」 - 画像は元のサイズを維持します。\"Contain\" - 画像はアスペクト比を維持しながらサイズ変更されます。「表紙」-画像は縦横比を維持しながらボックス全体を埋めます。\"Fill\" - 画像は、アスペクト比を維持せずにボックスを埋めるように引き伸ばされます。",
        autoGrow: "データの入力中に入力フィールドの高さを徐々に増やします。「入力フィールドの高さ(行単位)」の設定を上書きします。",
        allowResize: "サイズ変更ハンドル(またはグリップ)が隅に表示され、ドラッグして入力フィールドのサイズを変更できます。",
        maxTimeToFinish: "アンケートが [ありがとうございます] ページに自動移動するまでの時間間隔 (秒単位)。",
        maxTimeToFinishPage: "アンケートが次のページに自動進むまでの時間間隔 (秒単位)。",
        page: {
            maxTimeToFinish: "アンケートが次のページに自動進むまでの時間間隔 (秒単位)。",
            visibleIf: "魔法の杖アイコンを使用して、ページの表示を決定する条件付きルールを設定します。",
            enableIf: "魔法の杖アイコンを使用して、ページの読み取り専用モードを無効にする条件付きルールを設定します。",
            requiredIf: "魔法の杖アイコンを使用して、ネストされた質問に回答が少なくとも1つない限り、調査の送信を禁止する条件付きルールを設定します。",
            questionTitleLocation: "このページ内のすべての質問に適用されます。この設定を上書きする場合は、個々の質問またはパネルのタイトル配置ルールを定義します。「継承」オプションは、アンケートレベルの設定(デフォルトでは「トップ」)を適用します。",
            questionTitleWidth: "質問タイトルが質問ボックスの左側に配置されている場合に、質問タイトルの幅を一定に設定します。CSS 値 (px、%、in、pt など) を受け入れます。",
            questionErrorLocation: "無効な入力を含む質問に関連するエラーメッセージの場所を設定します。次から選択します: \"Top\" - 質問ボックスの上部にエラーテキストが配置されます。\"Bottom\" - 質問ボックスの下部にエラーテキストが配置されます。「継承」オプションは、アンケートレベルの設定(デフォルトでは「トップ」)を適用します。",
            questionsOrder: "質問の元の順序を維持するか、ランダム化します。「継承」オプションは、アンケートレベルの設定(デフォルトでは「オリジナル」)を適用します。この設定の効果は、「プレビュー」タブにのみ表示されます。",
            navigationButtonsVisibility: "ページ上のナビゲーションボタンの表示を設定します。「継承」オプションは、アンケートレベルの設定を適用し、デフォルトは「表示」です。"
        },
        showTimerPanel: "ページ上のタイマーの表示と位置を設定します。",
        panelsState: "次から選択します: 「ロック」 - ユーザーはパネルを展開または折りたたむことはできません。\"Collapse all\" - すべてのパネルが折りたたまれた状態で開始されます。\"Expand all\" - すべてのパネルが展開された状態で開始されます。\"First expanded\" - 最初のパネルのみが最初に展開されます。",
        imageLinkName: "選択リストに表示する画像またはビデオ ファイルの URL を含むオブジェクトの配列内に共有プロパティ名を入力します。",
        choices: "左の値は条件付きルールで使用される項目IDとして機能し、右の値は回答者に表示されます。",
        title: "表示するわかりやすいタイトルを入力します。",
        waitForUpload: "ファイルがアップロードされるまで、ユーザーが調査を完了しないようにします。",
        minWidth: "CSS 値 (px、%、in、pt など) を受け入れます。",
        maxWidth: "CSS 値 (px、%、in、pt など) を受け入れます。",
        width: "CSS 値 (px、%、in、pt など) を受け入れます。",
        valueName: "このプロパティを設定しない場合、回答は Name プロパティで指定されたフィールドに格納されます。",
        useDisplayValuesInDynamicTexts: "単一選択および複数選択の質問タイプでは、各選択肢にIDと表示値があります。この設定を選択すると、HTML の質問やアンケート エレメントの動的なタイトルと説明に ID 値ではなく表示値が表示されます。",
        clearIfInvisible: "条件付きロジックで非表示にした質問値をクリアするかどうか、およびいつクリアするかを選択します。「継承」オプションは、アンケートレベルの設定(デフォルトでは「アンケート完了時」)を適用します。",
        choicesFromQuestionMode: "選択元: 「すべて」 - 選択した質問からすべての選択肢をコピーします。\"Selected\" - 選択した選択肢オプションのみを動的にコピーします。「未選択」 - 選択されていない選択肢オプションのみを動的にコピーします。「なし」と「その他」のオプションは、ソースの質問で有効になっている場合、デフォルトでコピーされます。",
        showOtherItem: "選択すると、ユーザーは別のコメント ボックスに追加の入力を含めることができます。",
        separateSpecialChoices: "各特殊選択オプション(「なし」、「その他」、「すべて選択」)を、複数列のレイアウトを使用している場合でも、新しい行に表示します。",
        path: "サービス データセット内で、オブジェクトのターゲット配列が配置されている場所を指定します。URL が既に配列を指している場合は、空のままにします。",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "選択リストに表示する値を含むオブジェクトの配列内に、統一プロパティ名を入力します。",
        allowEmptyResponse: "選択すると、サービスが空の応答または配列を返すことができます。",
        choicesVisibleIf: "魔法の杖アイコンを使用して、すべての選択肢オプションの表示を決定する条件付きルールを設定します。",
        rateValues: "左の値は条件付きルールで使用される項目IDとして機能し、右の値は回答者に表示されます。",
        rating: {
            displayMode: "「自動」は、使用可能な幅に基づいて「ボタン」モードと「ドロップダウン」モードのいずれかを選択します。幅がボタンを表示するのに不十分な場合、質問にはドロップダウンが表示されます。"
        },
        valuePropertyName: "さまざまな形式で結果を生成する質問を接続できます。このような質問が結合識別子を使用してリンクされている場合、この共有プロパティには選択された質問値が格納されます。",
        searchEnabled: "ドロップダウンメニューの内容を更新して、ユーザーが入力フィールドに入力している検索クエリに一致させる場合に選択します。",
        valueTrue: "回答者が肯定的な回答をした場合にアンケート結果に保存する値。",
        valueFalse: "回答者が否定的な回答をした場合にアンケート結果に保存する値。",
        showPreview: "このオプションを無効にすると、プレビュー画像が上書きされ、ファイルがアップロードされたかどうかをユーザーが理解しにくくなるため、無効にすることはお勧めしません。",
        needConfirmRemoveFile: "ファイルの削除を確認するプロンプトを表示します。",
        selectToRankEnabled: "選択した選択肢のみをランク付けできるようにします。ユーザーは、選択した項目を選択リストからドラッグして、ランキング領域内で並べ替えます。",
        dataList: "入力時に回答者に提案される選択肢のリストを入力します。",
        itemSize: "この設定では、入力フィールドのサイズが変更されるだけで、質問ボックスの幅には影響しません。",
        itemTitleWidth: "すべてのアイテムラベルの幅をピクセル単位で統一します。",
        altText: "ユーザーのデバイスに画像を表示できない場合や、アクセシビリティの目的で代用します。",
        rateColorMode: "レーティングアイコンの種類が「スマイリー」に設定されている場合に選択した絵文字の色を定義します。以下から選択します: \"デフォルト\" - 選択した絵文字はデフォルトのアンケートカラーで表示されます。「スケール」 - 選択した絵文字は、評価スケールから色を継承します。",
        expression: {
            name: "回答者に表示されない式 ID。",
            description: "エクスプレッションのサブタイトルを入力します。",
            expression: "式には、基本的な計算 ('{q1_id} + {q2_id}')、条件 ('{age} > 60')、関数 ('iif()'、'today()'、'age()'、'min()'、'max()'、'avg()' など) を含めることができます。"
        },
        storeOthersAsComment: "「その他」オプションの値をアンケート結果に別のプロパティとして保存する場合に選択します。",
        format: "{0} を実際の値のプレースホルダーとして使用します。",
        acceptedTypes: "詳細については、[accept](https://www.w3schools.com/tags/att_input_accept.asp) 属性の説明を参照してください。",
        columnColCount: "ラジオグループとチェックボックスのセルタイプにのみ適用されます。",
        autocomplete: "詳細については、[オートコンプリート](https://developer.mozilla.org/en-US/docs/Web/HTML/属性/オートコンプリート) 属性の説明を参照してください。",
        filePlaceholder: "「ソースタイプ」が「ローカルファイル」の場合、またはカメラが利用できない場合に適用されます",
        photoPlaceholder: "「ソースタイプ」が「カメラ」の場合に適用されます。",
        fileOrPhotoPlaceholder: "「ソースタイプ」が「ローカルファイルまたはカメラ」の場合に適用されます。",
        masksettings: {
            saveMaskedValue: "マスクを適用した質問値をアンケート結果に保存する場合に選択します。"
        },
        patternmask: {
            pattern: "パターンには、文字列リテラルと次のプレースホルダーを含めることができます: '9' - 数字の場合。'a' - 大文字または小文字。'#' - 数字または大文字または小文字。文字をエスケープするには、バックスラッシュ '\\' を使用します。"
        },
        datetimemask: {
            pattern: "パターンには、区切り文字と次のプレースホルダーを含めることができます<br>:'m' - 月番号。<br>'mm' - 月番号 (先頭に 0 を付けて 1 桁の値)。<br>'d' - 日付。<br>'dd' - 日付で、1 桁の値の先頭に 0 が付きます。<br>'yy' - 年の最後の 2 桁。<br>'yyyy' - 4 桁の年。<br>'H' - 24 時間形式の時間。<br>'HH' - 24 時間形式の時間で、1 桁の値の先頭に 0 が付きます。<br>'h' - 12 時間形式の時間。<br>'hh' - 12 時間形式の時間で、1 桁の値の先頭に 0 が付きます。<br>'MM' - 分。<br>'ss' - 秒。<br>'TT' - 大文字の 12 時間制 (AM/PM)。<br>'tt' - 小文字の 12 時間制 (am/pm)。"
        },
        numericmask: {
            decimalSeparator: "表示される数値の小数部と整数部を区切るために使用される記号。",
            thousandsSeparator: "大きな数字を 3 つのグループに区切るために使用される記号。",
            precision: "表示される数値の小数点以下の桁数を制限します。"
        },
        currencymask: {
            prefix: "値の前に表示される 1 つまたは複数のシンボル。",
            suffix: "値の後に表示される 1 つまたは複数の記号。"
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "タイトル",
            title: "「名前」と同じ場合は空白のままにしてください"
        },
        multiSelect: "複数選択を許可",
        showLabel: "画像のキャプションを表示する",
        swapOrder: "「はい」と「いいえ」の順序を入れ替える",
        value: "価値",
        tabAlign: "タブの配置",
        sourceType: "ソースの種類",
        fitToContainer: "コンテナにフィット",
        setValueExpression: "設定値式",
        description: "形容",
        logoFit: "ロゴフィット",
        pages: "ページ",
        questions: "問",
        triggers: "トリガー",
        calculatedValues: "計算値",
        surveyId: "アンケート ID",
        surveyPostId: "アンケート投稿 ID",
        surveyShowDataSaving: "測量ショーのデータ保存",
        questionDescriptionLocation: "質問の説明の場所",
        progressBarType: "進行状況バーの種類",
        showTOC: "目次を表示",
        tocLocation: "目次 場所",
        questionTitlePattern: "質問のタイトルパターン",
        widthMode: "幅モード",
        showBrandInfo: "ブランド情報を表示する",
        useDisplayValuesInDynamicTexts: "ダイナミックテキストでの表示値の使用",
        visibleIf: "次の場合に表示",
        defaultValueExpression: "デフォルト値式",
        requiredIf: "次の場合に必要",
        resetValueIf: "次の場合に値をリセット",
        setValueIf: "次の場合に値を設定します",
        validators: "バリデータ",
        bindings: "バインド",
        renderAs: "レンダリング形式",
        attachOriginalItems: "オリジナルアイテムを添付する",
        choices: "選択肢",
        choicesByUrl: "URL による選択肢",
        currency: "通貨",
        cellHint: "セルヒント",
        totalMaximumFractionDigits: "最大小数部の合計桁数",
        totalMinimumFractionDigits: "最小小数桁の合計",
        columns: "列",
        detailElements: "詳細要素",
        allowAdaptiveActions: "アダプティブアクションを許可する",
        defaultRowValue: "既定の行の値",
        detailPanelShowOnAdding: "追加時の詳細パネル表示",
        choicesLazyLoadEnabled: "遅延読み込みの選択肢が有効",
        choicesLazyLoadPageSize: "選択肢遅延読み込みページ・サイズ",
        inputFieldComponent: "入力フィールドコンポーネント",
        itemComponent: "アイテムコンポーネント",
        min: "分",
        max: "マックス",
        minValueExpression: "最小値の式",
        maxValueExpression: "最大値式",
        step: "歩",
        dataList: "データ一覧",
        itemSize: "アイテムサイズ",
        itemTitleWidth: "アイテムラベルの幅 (px)",
        elements: "元素",
        content: "コンテンツ",
        navigationButtonsVisibility: "ナビゲーションボタンの可視性",
        navigationTitle: "ナビゲーション タイトル",
        navigationDescription: "ナビゲーションの説明",
        longTap: "ロングタップ",
        autoGrow: "自動拡張",
        allowResize: "サイズ変更を許可する",
        acceptCarriageReturn: "キャリッジリターンを受け入れる",
        displayMode: "表示モード",
        rateType: "レートタイプ",
        label: "ラベル",
        contentMode: "コンテンツモード",
        imageFit: "画像のフィット",
        altText: "代替テキスト",
        height: "高さ",
        penColor: "ペンの色",
        backgroundColor: "背景色",
        templateElements: "テンプレート要素",
        operator: "演算子",
        isVariable: "可変",
        runExpression: "実行式",
        showCaption: "キャプションを表示",
        iconName: "アイコン名",
        iconSize: "アイコンのサイズ",
        precision: "精度",
        matrixDragHandleArea: "マトリックスドラッグハンドル領域",
        backgroundImage: "背景画像",
        backgroundImageFit: "背景画像のフィット",
        backgroundImageAttachment: "背景画像の添付",
        backgroundOpacity: "背景の不透明度",
        selectToRankEnabled: "選択してランク付けを有効にする",
        selectToRankAreasLayout: "エリアレイアウトをランク付けするために選択する",
        selectToRankEmptyRankedAreaText: "すべてのオプションが選択されている場合に表示されるテキスト",
        selectToRankEmptyUnrankedAreaText: "ランキングエリアのプレースホルダーテキスト",
        allowCameraAccess: "カメラへのアクセスを許可する",
        scaleColorMode: "スケールカラーモード",
        rateColorMode: "レートカラーモード",
        copyDisplayValue: "表示値をコピー",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "詳細モード",
        pageTitle: "ページタイトルのフォント",
        questionTitle: "質問タイトルのフォント",
        editorPanel: "入力要素",
        lines: "台詞",
        primaryDefaultColor: "デフォルト",
        primaryDarkColor: "ホバー",
        primaryLightColor: "入選",
        backgroundDimColor: "背景色",
        cornerRadius: "コーナR(Corner Radius)",
        backcolor: "デフォルトの背景",
        hovercolor: "ホバー背景",
        borderDecoration: "ボーダーデコレーション",
        fontColor: "フォントの色",
        backgroundColor: "背景色",
        primaryForecolor: "デフォルトの色",
        primaryForecolorLight: "無効色",
        font: "フォント",
        borderDefault: "暗い",
        borderLight: "ライター",
        fontFamily: "フォントファミリー",
        fontWeightRegular: "レギュラー",
        fontWeightHeavy: "重い",
        fontWeightSemiBold: "半太字",
        fontWeightBold: "ボールド",
        color: "色",
        placeholderColor: "プレースホルダーの色",
        size: "大きさ",
        opacity: "不透明",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "シャドウ効果を追加",
        boxShadowBlur: "滲む",
        boxShadowSpread: "まん延",
        boxShadowDrop: "落とす",
        boxShadowInner: "内的",
        names: {
            default: "デフォルト",
            sharp: "鋭い",
            borderless: "ボーダレス",
            flat: "平",
            plain: "平地",
            doubleborder: "二重ボーダー",
            layered: "層状",
            solid: "固体",
            threedimensional: ".3D",
            contrast: "対照"
        },
        colors: {
            teal: "小鴨",
            blue: "青い",
            purple: "紫",
            orchid: "蘭",
            tulip: "チューリップ",
            brown: "褐色",
            green: "緑"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["ja"] = jaStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// qt.tagbox: "Multi-Select Dropdown" => "複数選択ドロップダウン"
// qt.buttongroup: "Button Group" => "ボタングループ"
// ed.surveySettings: "Survey Settings" => "アンケート設定"
// ed.surveySettingsTooltip: "Open survey settings" => "アンケート設定を開く"
// ed.prevSelected: "Select previous" => "前を選択"
// ed.nextSelected: "Select next" => "[次へ] を選択します。"
// ed.surveyTypeName: "Survey" => "アンケート"
// ed.pageTypeName: "Page" => "ページ"
// ed.panelTypeName: "Panel" => "パネル"
// ed.questionTypeName: "Question" => "質問"
// ed.columnTypeName: "Column" => "コラム"
// ed.themeSurvey: "Themes" => "テーマ"
// ed.defaultV2Theme: "Default" => "デフォルト"
// ed.modernTheme: "Modern" => "モダン"
// ed.defaultTheme: "Default (legacy)" => "デフォルト (レガシー)"
// ed.jsonHideErrors: "Hide errors" => "エラーを隠す"
// ed.jsonShowErrors: "Show errors" => "エラーを表示"
// ed.showMoreChoices: "Show more" => "さらに表示"
// ed.showLessChoices: "Show less" => "表示を減らす"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "検索するタイプ..."
// ed.toolboxChoiceCategory: "Choice Questions" => "選択の質問"
// ed.toolboxTextCategory: "Text Input Questions" => "テキスト入力の質問"
// ed.toolboxContainersCategory: "Containers" => "コンテナー"
// ed.toolboxMatrixCategory: "Matrix Questions" => "マトリックスの質問"
// ed.toolboxMiscCategory: "Misc" => "雑貨"
// ed.translationPropertyGridTitle: "Language Settings" => "言語設定"
// ed.themePropertyGridTitle: "Theme Settings" => "テーマ設定"
// ed.translationLanguages: "Languages" => "言語"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "使用される文字列のみ"
// ed.translationPlaceHolder: "Translation..." => "翻訳。。。"
// ed.themeExportButton: "Export" => "輸出"
// ed.themeImportButton: "Import" => "輸入"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "選択肢は"
// ed.htmlPlaceHolder: "HTML content will be here." => "HTMLコンテンツはここにあります。"
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "ここにツールボックスから質問をドロップします。"
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "アンケートは空です。ツールボックスから要素をドラッグするか、下のボタンをクリックします。"
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "ここに画像をドラッグ&ドロップするか、下のボタンをクリックしてアップロードする画像を選択してください"
// ed.imageChooseImage: "Choose Image" => "画像を選択"
// ed.addNewTypeQuestion: "Add {0}" => "{0}を追加"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[ロゴ]"
// ed.auto: "auto" => "自動"
// ed.choices_Item: "Item " => "アイテム"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "調査のフローをカスタマイズするルールを作成します。"
// lg.page_enableName: "Enable (disable) page" => "有効 (無効) ページ"
// lg.column_visibilityName: "Show (hide) column" => "列を表示 (非表示)"
// lg.column_enableName: "Enable (disable) column" => "有効 (無効) 列"
// lg.column_requireName: "Make column required" => "列を必須にする"
// lg.itemEmptyExpressionText: "New rule" => "新しいルール"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "質問{1}の列{0}を表示する"
// lg.column_enableText: "make column {0} of question {1} enable" => "質問の列{0}を有効にする{1}"
// lg.column_requireText: "make column {0} of question {1} required" => "質問{1}の列{0}を必須にする"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "明確な質問値:{0}"
// lg.showAllQuestions: "All Questions" => "すべての質問"
// lg.showAllActionTypes: "All Action Types" => "すべてのアクションタイプ"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "論理ルールが不完全です"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "一部の論理ルールが完了していません。ここでタブを離れると、変更は失われます。変更を完了せずにタブを離れますか?"
// lg.uncompletedRule_apply: "Yes" => "はい"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "いいえ、ルールを完成させたい"
// pe.clear: "Clear" => "クリア"
// pe.set: "Set" => "セット"
// pe.change: "Change" => "変える"
// pe.close: "Close" => "閉める"
// pe.removeItem: "Click to remove the item..." => "クリックしてアイテムを削除します..."
// pe.dragItem: "Drag the item" => "アイテムをドラッグする"
// pe.doneEditing: "Done" => "完成です"
// pe.empty: "<empty>" => "<empty>"
// pe.emptyValue: "Value is empty" => "値が空です"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "値 '{0}' は一意ではありません"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "アイテムの数は{0}から{1}に制限してください"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "次の形式でデータを設定できます。\n値 1|テキスト\n値 2"
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "アンケートを送信する前に回答をプレビューする"
// pe.overridingPropertyPrefix: "Set by " => "設定者"
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "予約語は使用しないでください: \"アイテム\"、 \"選択肢\"、 \"パネル\"、 \"行\"。"
// pe.listIsEmpty@choices: "No choices have been added yet" => "選択肢はまだ追加されていません"
// pe.addNew@choices: "Add a choice" => "選択肢を追加する"
// choicesbyurl.valueName: "Get values from the following JSON field" => "次の JSON フィールドから値を取得する"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "次の JSON フィールドから画像の URL を取得する"
// pe.and: "and" => "そして"
// pe.or: "or" => "又は"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "質問を選択して、条件の設定を開始します。"
// pe.if: "If" => "もし"
// pe.then: "then" => "そうしたら"
// pe.setToName: "Target question" => "ターゲットの質問"
// pe.fromName: "Question to copy answer from" => "回答をコピーする質問"
// pe.gotoName: "Question to skip to" => "スキップする質問"
// pe.ruleIsNotSet: "Rule is incorrect" => "ルールが正しくありません"
// pe.includeIntoResult: "Include into survey results" => "アンケート結果に含める"
// pe.portraitOrientation: "Switch to portrait orientation" => "縦向きに切り替える"
// image.imageHeight: "Image height (in CSS-accepted values)" => "画像の高さ (CSS で受け入れられる値)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "画像の幅 (CSS で受け入れられる値)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "ページを終了するための制限時間 (秒単位)"
// question.page: "Parent page" => "親ページ"
// pe.noEntriesText: "Empty entries text" => "空のエントリのテキスト"
// pe.setValue: "Answer" => "答える"
// pe.dataFormat: "Image format" => "画像フォーマット"
// pe.allowAddRows: "Allow adding rows" => "行の追加を許可する"
// pe.allowRemoveRows: "Allow removing rows" => "行の削除を許可する"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "行のドラッグ アンド ドロップを許可する"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "正確な画像の幅または高さを指定した場合には適用されません。"
// pe.minImageWidth: "Minimum image width" => "最小画像幅"
// pe.maxImageWidth: "Maximum image width" => "最大画像幅"
// pe.minImageHeight: "Minimum image height" => "最小画像の高さ"
// pe.maxImageHeight: "Maximum image height" => "最大画像の高さ"
// surveyvalidator.text: "Error message" => "エラーメッセージ"
// surveyvalidator.expression: "Validation expression" => "検証式"
// pe.logo: "Logo (URL or base64-encoded string)" => "ロゴ (URL または base64 でエンコードされた文字列)"
// pe.questionsOnPageMode: "Survey structure" => "調査体制"
// pe.maxTextLength: "Maximum answer length (in characters)" => "回答の最大長 (文字数)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "コメントの最大長 (文字数)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "必要に応じてコメント領域を自動展開する"
// pe.allowResizeComment: "Allow users to resize text areas" => "ユーザーがテキスト領域のサイズを変更できるようにする"
// pe.textUpdateMode: "Update text question value" => "テキストの質問値を更新する"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "最初の無効な回答にフォーカスを設定する"
// pe.checkErrorsMode: "Run validation" => "検証の実行"
// pe.navigateToUrl: "Navigate to URL" => "URL に移動します。"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "ダイナミック URL"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "ユーザーがこのアンケートに既に記入しているかどうかを示すマークアップ"
// pe.completedHtml: "Survey Complete page markup" => "アンケート完了ページのマークアップ"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "動的調査 完全なページ マークアップ"
// pe.loadingHtml: "Markup to show while survey model is loading" => "アンケートモデルの読み込み中に表示するマークアップ"
// pe.commentText: "Comment area text" => "コメント領域のテキスト"
// pe.autocomplete: "Autocomplete type" => "オートコンプリートの種類"
// pe.labelTrue: "\"True\" label" => "「真の」ラベル"
// pe.labelFalse: "\"False\" label" => "「虚偽」ラベル"
// pe.displayStyle: "Value display style" => "値の表示スタイル"
// pe.format: "Formatted string" => "書式設定された文字列"
// pe.maximumFractionDigits: "Maximum fractional digits" => "小数部の最大数桁数"
// pe.minimumFractionDigits: "Minimum fractional digits" => "小数部の最小桁数"
// pe.useGrouping: "Display grouping separators" => "グループ化区切りの表示"
// pe.allowMultiple: "Allow multiple files" => "複数のファイルを許可する"
// pe.allowImagesPreview: "Preview images" => "プレビュー画像"
// pe.acceptedTypes: "Accepted file types" => "受け入れられるファイルの種類"
// pe.waitForUpload: "Wait for the upload to complete" => "アップロードが完了するのを待ちます"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "ファイルの削除を確認する"
// pe.detailPanelMode: "Detail panel location" => "詳細パネルの位置"
// pe.minRowCount: "Minimum row count" => "最小行数"
// pe.maxRowCount: "Maximum row count" => "最大行数"
// pe.confirmDelete: "Confirm row deletion" => "行の削除を確認する"
// pe.confirmDeleteText: "Confirmation message" => "確認メッセージ"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "パネルの削除を確認する"
// pe.panelCount: "Initial panel count" => "初期パネル数"
// pe.minPanelCount: "Minimum panel count" => "最小パネル数"
// pe.maxPanelCount: "Maximum panel count" => "最大パネル数"
// pe.panelsState: "Inner panel expand state" => "内側パネルの展開状態"
// pe.templateDescription: "Description template" => "説明テンプレート"
// pe.templateTitle: "Title template" => "タイトルテンプレート"
// pe.panelPrevText: "Previous Panel button tooltip" => "前のパネルボタンのツールチップ"
// pe.panelNextText: "Next Panel button tooltip" => "[次へ] パネル ボタンのツールチップ"
// pe.showRangeInProgress: "Show progress bar" => "進行状況バーを表示する"
// pe.templateTitleLocation: "Question title location" => "質問タイトルの場所"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "[パネルを削除] ボタンの位置"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "行がない場合は質問を非表示にする"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "行がない場合は列を非表示にする"
// pe.rateValues: "Custom rate values" => "カスタムレート値"
// pe.rateCount: "Rate count" => "レート数"
// pe.autoGenerate: "How to specify rate values?" => "レート値を指定する方法は?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "選択肢がない場合は質問を非表示にする"
// pe.hideNumber: "Hide question number" => "質問番号を隠す"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "最小幅 (CSS で受け入れられる値)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "最大幅 (CSS で受け入れられる値)"
// pe.width: "Width (in CSS-accepted values)" => "幅 (CSS で受け入れられる値)"
// pe.showHeader: "Show column headers" => "列ヘッダーを表示する"
// pe.horizontalScroll: "Show horizontal scrollbar" => "水平スクロールバーを表示"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "最小列幅 (CSS で受け入れられる値)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "行ヘッダーの幅 (CSS で受け入れられる値)"
// pe.valueTrue: "\"True\" value" => "「真」の値"
// pe.valueFalse: "\"False\" value" => "\"偽\" の値"
// pe.minErrorText: "\"Value is below minimum\" error message" => "\"値が最小値を下回っています\" というエラー メッセージ"
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "\"値が最大値を超えています\" というエラー メッセージ"
// pe.otherErrorText: "\"Empty comment\" error message" => "「コメントを空にしました」というエラーメッセージ"
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "\"一意でないキー値\" エラー メッセージ"
// pe.minSelectedChoices: "Minimum selected choices" => "選択される最小選択肢"
// pe.maxSelectedChoices: "Maximum selected choices" => "最大選択選択肢数"
// pe.showClearButton: "Show the Clear button" => "[クリア] ボタンを表示する"
// pe.showNumber: "Show panel number" => "パネル番号を表示"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "ロゴの幅 (CSS で受け入れられる値)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "ロゴの高さ (CSS で受け入れられる値)"
// pe.readOnly: "Read-only" => "読み取り専用"
// pe.enableIf: "Editable if" => "次の場合に編集可能"
// pe.emptyRowsText: "\"No rows\" message" => "\"行なし\" メッセージ"
// pe.size: "Input field size (in characters)" => "入力フィールドのサイズ (文字数)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "個別の特別な選択肢 (なし、その他、すべて選択)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "次の質問から選択肢をコピーする"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "どの選択肢をコピーするか?"
// pe.showCommentArea: "Show the comment area" => "コメント領域を表示する"
// pe.commentPlaceholder: "Comment area placeholder" => "コメント領域のプレースホルダー"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "レートの説明を極値として表示する"
// pe.rowsOrder: "Row order" => "行の順序"
// pe.columnsLayout: "Column layout" => "列のレイアウト"
// pe.columnColCount: "Nested column count" => "ネストされた列数"
// pe.state: "Panel expand state" => "パネル展開状態"
// pe.correctAnswer: "Correct Answer" => "正解"
// pe.defaultPanelValue: "Default Values" => "デフォルト値"
// pe.cells: "Cell Texts" => "セルテキスト"
// pe.keyName: "Key column" => "キー列"
// itemvalue.text: "Alt text" => "代替テキスト"
// tabs.expression: "Expression" => "表現"
// pe.choicesVisibleIf: "Choices are visible if" => "選択肢は次の場合に表示されます。"
// pe.choicesEnableIf: "Choices are selectable if" => "次の場合に選択肢を選択できます。"
// pe.columnsEnableIf: "Columns are visible if" => "列は次の場合に表示されます。"
// pe.rowsEnableIf: "Rows are visible if" => "行は次の場合に表示されます。"
// pe.indent: "Add indents" => "インデントを追加する"
// panel.indent: "Add outer indents" => "外側のインデントを追加する"
// pe.innerIndent: "Add inner indents" => "内側のインデントを追加する"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "最後の行からデフォルト値を取得する"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "最後のパネルからデフォルト値を取得する"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "ここに式を入力してください..."
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "質問が非表示になった場合は値をクリアする"
// pe.valuePropertyName: "Value property name" => "値プロパティ名"
// pe.searchEnabled: "Enable search" => "検索を有効にする"
// pe.hideSelectedItems: "Hide selected items" => "選択した項目を非表示にする"
// pe.closeOnSelect: "Close the dropdown after selection" => "選択後にドロップダウンを閉じる"
// pe.signatureWidth: "Signature width" => "署名の幅"
// pe.signatureHeight: "Signature height" => "署名の高さ"
// pe.verticalAlign: "Vertical alignment" => "垂直方向の配置"
// pe.alternateRows: "Alternate rows" => "代替行"
// pe.columnsVisibleIf: "Columns are visible if" => "列は次の場合に表示されます。"
// pe.rowsVisibleIf: "Rows are visible if" => "行は次の場合に表示されます。"
// pe.otherPlaceholder: "Comment area placeholder" => "コメント領域のプレースホルダー"
// pe.rateType: "Rate type" => "レートタイプ"
// pv.true: "true" => "真"
// pv.false: "false" => "偽"
// pv.decimal: "decimal" => "小数"
// pv.currency: "currency" => "通貨"
// pv.percent: "percent" => "パーセント"
// pv.onpanel: "Start on each panel" => "各パネルから開始"
// pv.tab: "Tabs" => "タブ"
// pv.right: "Right" => "右"
// pv.color: "color" => "色"
// pv.date: "date" => "日付"
// pv.datetime: "datetime" => "日時"
// pv.datetime-local: "datetime-local" => "日時ローカル"
// pv.email: "email" => "電子メール"
// pv.month: "month" => "月"
// pv.number: "number" => "数"
// pv.password: "password" => "パスワード"
// pv.range: "range" => "範囲"
// pv.tel: "tel" => "電話"
// pv.text: "text" => "テキスト"
// pv.time: "time" => "時間"
// pv.url: "url" => "リンク"
// pv.week: "week" => "週"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "質問またはそのパネル/ページが非表示になったとき"
// clearInvisibleValues.none: "Never" => "なし"
// inputType.color: "Color" => "色"
// inputType.date: "Date" => "日付"
// inputType.datetime-local: "Date and Time" => "日付と時刻"
// inputType.email: "Email" => "電子メール"
// inputType.month: "Month" => "月"
// inputType.number: "Number" => "数"
// inputType.password: "Password" => "パスワード"
// inputType.range: "Range" => "範囲"
// inputType.tel: "Phone Number" => "電話番号"
// inputType.text: "Text" => "テキスト"
// inputType.time: "Time" => "時間"
// inputType.url: "URL" => "リンク"
// inputType.week: "Week" => "週"
// pv.onValueChanging: "Before an answer is changed" => "回答が変更される前に"
// pv.onBlur: "On blur" => "ぼかし時"
// pv.onTyping: "While typing" => "入力中"
// pv.underRow: "Under the row" => "行の下"
// pv.underRowSingle: "Under the row, only one panel is visible" => "行の下には、1つのパネルのみが表示されます"
// showNavigationButtons.none: "Hidden" => "隠れた"
// showProgressBar.off: "Hidden" => "隠れた"
// showTimerPanel.none: "Hidden" => "隠れた"
// showTimerPanelMode.all: "Both" => "両方とも"
// detailPanelMode.none: "Hidden" => "隠れた"
// addRowLocation.default: "Depends on matrix layout" => "マトリックスレイアウトに依存"
// panelsState.default: "Users cannot expand or collapse panels" => "ユーザーはパネルを展開または折りたたむことはできません"
// panelsState.collapsed: "All panels are collapsed" => "すべてのパネルが折りたたまれている"
// panelsState.expanded: "All panels are expanded" => "すべてのパネルが展開されます"
// widthMode.auto: "Auto" => "自動"
// widthMode.static: "Static" => "静的"
// widthMode.responsive: "Responsive" => "応答"
// imageFit.none: "None" => "何一つ"
// imageFit.contain: "Contain" => "含む"
// imageFit.cover: "Cover" => "覆う"
// imageFit.fill: "Fill" => "注ぐ"
// contentMode.auto: "Auto" => "自動"
// contentMode.image: "Image" => "画像"
// contentMode.video: "Video" => "ビデオ"
// contentMode.youtube: "YouTube" => "ユーチューブ"
// displayMode.auto: "Auto" => "自動"
// displayMode.buttons: "Buttons" => "ボタン"
// displayMode.dropdown: "Dropdown" => "ドロップダウン"
// rateColorMode.default: "Default" => "デフォルト"
// autoGenerate.true: "Generate" => "生成する"
// autoGenerate.false: "Enter manually" => "手動で入力する"
// rateType.labels: "Labels" => "ラベル"
// rateType.stars: "Stars" => "星"
// rateType.smileys: "Smileys" => "スマイリー"
// op.and: "and" => "そして"
// op.or: "or" => "又は"
// ts.hideInvisibleElements: "Hide invisible elements" => "非表示の要素を非表示にする"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Cookieは、ユーザーが同じアンケートに2回記入するのを防ぎます。"
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "入力フィールドの表示領域のサイズを変更します。入力長を制限するには<b>、[検証→最大長</b>] 設定を使用してください。"
// pehelp.format: "Use {0} as a placeholder for the actual value." => "{0} を実際の値のプレースホルダーとして使用します。"
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "少なくとも 1 つの列に [合計型] または [合計式] がある場合にのみ表示されます。"
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "詳細については、[accept](https://www.w3schools.com/tags/att_input_accept.asp) 属性の説明を参照してください。"
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "ラジオグループとチェックボックスのセルタイプにのみ適用されます。"
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "詳細については、[オートコンプリート](https://developer.mozilla.org/en-US/docs/Web/HTML/属性/オートコンプリート) 属性の説明を参照してください。"
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "このプロパティを設定しない場合、回答は Name プロパティで指定されたフィールドに格納されます。"
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "指定した列に同じ値が含まれている場合、調査は「一意でないキー値」エラーをスローします。"
// title.name: "title" => "タイトル"
// p.multiSelect: "Allow multiple selection" => "複数選択を許可"
// p.showLabel: "Show image captions" => "画像のキャプションを表示する"
// p.value: "Value" => "価値"
// p.tabAlign: "Tab alignment" => "タブの配置"
// p.description: "Description" => "形容"
// p.logoFit: "Logo fit" => "ロゴフィット"
// p.pages: "Pages" => "ページ"
// p.questions: "Questions" => "問"
// p.triggers: "Triggers" => "トリガー"
// p.calculatedValues: "Calculated values" => "計算値"
// p.surveyId: "Survey id" => "アンケート ID"
// p.surveyPostId: "Survey post id" => "アンケート投稿 ID"
// p.surveyShowDataSaving: "Survey show data saving" => "測量ショーのデータ保存"
// p.questionDescriptionLocation: "Question description location" => "質問の説明の場所"
// p.progressBarType: "Progress bar type" => "進行状況バーの種類"
// p.showTOC: "Show TOC" => "目次を表示"
// p.tocLocation: "Toc location" => "目次 場所"
// p.questionTitlePattern: "Question title pattern" => "質問のタイトルパターン"
// p.widthMode: "Width mode" => "幅モード"
// p.showBrandInfo: "Show brand info" => "ブランド情報を表示する"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "ダイナミックテキストでの表示値の使用"
// p.visibleIf: "Visible if" => "次の場合に表示"
// p.titleLocation: "Title location" => "タイトルの場所"
// p.descriptionLocation: "Description location" => "説明の場所"
// p.defaultValueExpression: "Default value expression" => "デフォルト値式"
// p.requiredIf: "Required if" => "次の場合に必要"
// p.validators: "Validators" => "バリデータ"
// p.bindings: "Bindings" => "バインド"
// p.renderAs: "Render as" => "レンダリング形式"
// p.attachOriginalItems: "Attach original items" => "オリジナルアイテムを添付する"
// p.choices: "Choices" => "選択肢"
// p.choicesByUrl: "Choices by url" => "URL による選択肢"
// p.currency: "Currency" => "通貨"
// p.cellHint: "Cell hint" => "セルヒント"
// p.isUnique: "Is unique" => "ユニークです"
// p.showInMultipleColumns: "Show in multiple columns" => "複数の列に表示"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "最大小数部の合計桁数"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "最小小数桁の合計"
// p.columns: "Columns" => "列"
// p.detailElements: "Detail elements" => "詳細要素"
// p.allowAdaptiveActions: "Allow adaptive actions" => "アダプティブアクションを許可する"
// p.defaultRowValue: "Default row value" => "既定の行の値"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "追加時の詳細パネル表示"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "遅延読み込みの選択肢が有効"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "選択肢遅延読み込みページ・サイズ"
// p.inputFieldComponent: "Input field component" => "入力フィールドコンポーネント"
// p.itemComponent: "Item component" => "アイテムコンポーネント"
// p.min: "Min" => "分"
// p.max: "Max" => "マックス"
// p.minValueExpression: "Min value expression" => "最小値の式"
// p.maxValueExpression: "Max value expression" => "最大値式"
// p.step: "Step" => "歩"
// p.dataList: "Data list" => "データ一覧"
// p.itemSize: "Item size" => "アイテムサイズ"
// p.elements: "Elements" => "元素"
// p.content: "Content" => "コンテンツ"
// p.navigationButtonsVisibility: "Navigation buttons visibility" => "ナビゲーションボタンの可視性"
// p.navigationTitle: "Navigation title" => "ナビゲーション タイトル"
// p.navigationDescription: "Navigation description" => "ナビゲーションの説明"
// p.longTap: "Long tap" => "ロングタップ"
// p.autoGrow: "Auto grow" => "自動拡張"
// p.allowResize: "Allow resizing" => "サイズ変更を許可する"
// p.acceptCarriageReturn: "Accept carriage return" => "キャリッジリターンを受け入れる"
// p.displayMode: "Display mode" => "表示モード"
// p.rateType: "Rate type" => "レートタイプ"
// p.label: "Label" => "ラベル"
// p.contentMode: "Content mode" => "コンテンツモード"
// p.imageFit: "Image fit" => "画像のフィット"
// p.altText: "Alt text" => "代替テキスト"
// p.height: "Height" => "高さ"
// p.penColor: "Pen color" => "ペンの色"
// p.backgroundColor: "Background color" => "背景色"
// p.templateElements: "Template elements" => "テンプレート要素"
// p.operator: "Operator" => "演算子"
// p.isVariable: "Is variable" => "可変"
// p.runExpression: "Run expression" => "実行式"
// p.showCaption: "Show caption" => "キャプションを表示"
// p.iconName: "Icon name" => "アイコン名"
// p.iconSize: "Icon size" => "アイコンのサイズ"
// p.precision: "Precision" => "精度"
// p.matrixDragHandleArea: "Matrix drag handle area" => "マトリックスドラッグハンドル領域"
// p.backgroundImage: "Background image" => "背景画像"
// p.backgroundImageFit: "Background image fit" => "背景画像のフィット"
// p.backgroundImageAttachment: "Background image attachment" => "背景画像の添付"
// p.backgroundOpacity: "Background opacity" => "背景の不透明度"
// p.selectToRankEnabled: "Select to rank enabled" => "選択してランク付けを有効にする"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "エリアレイアウトをランク付けするために選択する"
// p.allowCameraAccess: "Allow camera access" => "カメラへのアクセスを許可する"
// p.scaleColorMode: "Scale color mode" => "スケールカラーモード"
// p.rateColorMode: "Rate color mode" => "レートカラーモード"
// p.templateTabTitle: "Template tab title" => "テンプレートタブのタイトル"
// p.templateVisibleIf: "Template visible if" => "次の場合に表示されるテンプレート"
// p.copyDisplayValue: "Copy display value" => "表示値をコピー"
// theme.--background: "Background color" => "背景色"
// theme.--background-dim-light: "Background dim light color" => "背景の薄暗い明るい色"
// theme.--primary-foreground: "Primary foreground color" => "原色の前景色"
// theme.--foreground: "Foreground color" => "景色"
// theme.--base-unit: "Base unit" => "ベースユニット"
// theme.groupAdvanced: "Advanced" => "アドバンスド"
// theme.themeName: "Theme" => "テーマ"
// theme.isPanellessss: "Question appearance" => "質問の外観"
// theme.isPanellessPanels: "Default" => "デフォルト"
// theme.isPanellessLightweight: "Without Panels" => "パネルなし"
// theme.themePaletteLight: "Light" => "光"
// theme.themePaletteDark: "Dark" => "暗い"
// theme.primaryColor: "Accent color" => "アクセントカラー"
// theme.primaryDefaultColor: "Default" => "デフォルト"
// theme.primaryDarkColor: "Hover" => "ホバー"
// theme.primaryLightColor: "Selected" => "入選"
// theme.backgroundDimColor: "Background color" => "背景色"
// theme.backgroundImage: "Background image" => "背景画像"
// theme.backgroundImageFitAuto: "Auto" => "自動"
// theme.backgroundImageFitCover: "Cover" => "覆う"
// theme.backgroundImageFitContain: "Contain" => "含む"
// theme.backgroundOpacity: "Opacity" => "不透明"
// theme.backgroundImageAttachmentFixed: "Fixed" => "付け"
// theme.backgroundImageAttachmentScroll: "Scroll" => "スクロール"
// theme.panelBackgroundTransparency: "Panel background opacity" => "パネルの背景の不透明度"
// theme.questionBackgroundTransparency: "Question background opacity" => "質問の背景の不透明度"
// theme.questionPanel: "Panel background and corner radius" => "パネルの背景と角の半径"
// theme.questionTitle: "Question title font" => "質問タイトルのフォント"
// theme.questionDescription: "Question description font" => "質問の説明フォント"
// theme.editorPanel: "Input element" => "入力要素"
// theme.editorFont: "Input element font" => "入力要素のフォント"
// theme.backcolor: "Default background" => "デフォルトの背景"
// theme.hovercolor: "Hover background" => "ホバー背景"
// theme.borderDecoration: "Border decoration" => "ボーダーデコレーション"
// theme.accentBackground: "Accent background" => "アクセントの背景"
// theme.accentForeground: "Accent foreground" => "アクセントの前景"
// theme.primaryForecolor: "Default color" => "デフォルトの色"
// theme.primaryForecolorLight: "Disabled color" => "無効色"
// theme.linesColors: "Minor line colors" => "マイナーラインカラー"
// theme.borderDefault: "Darker" => "暗い"
// theme.borderLight: "Lighter" => "ライター"
// theme.fontFamily: "Font family" => "フォントファミリ"
// theme.fontSize: "Font size" => "文字サイズ"
// theme.color: "Color" => "色"
// theme.size: "Size" => "大きさ"
// theme.fontWeightRegular: "Regular" => "レギュラー"
// theme.fontWeightHeavy: "Heavy" => "重い"
// theme.fontWeightSemiBold: "Semi-bold" => "半太字"
// theme.fontWeightBold: "Bold" => "ボールド"
// theme.scale: "Scale" => "規模"
// theme.cornerRadius: "Corner radius" => "コーナー半径"
// theme.surveyTitleFont: "Survey title font" => "アンケートタイトルのフォント"
// theme.pageTitle: "Page title font" => "ページタイトルのフォント"
// theme.pageDescription: "Page description font" => "ページ記述フォント"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "シャドウ効果を追加"
// theme.opacity: "Opacity" => "不透明"
// theme.boxShadowBlur: "Blur" => "滲む"
// theme.boxShadowSpread: "Spread" => "まん延"
// theme.boxShadowDrop: "Drop" => "落とす"
// theme.boxShadowInner: "Inner" => "内的"
// theme.questionShadow: "Shadow effects" => "シャドウ効果"
// theme.editorShadow: "Input element shadow effects" => "入力要素の影の効果"
// names.default: "Default" => "デフォルト"
// names.contrast: "Contrast" => "対照"
// names.plain: "Plain" => "平地"
// names.simple: "Simple" => "簡単"
// names.blank: "Blank" => "空砲"
// names.double: "Double" => "複"
// names.bulk: "Bulk" => "嵩"
// names.pseudo-3d: "Pseudo 3D" => "擬似 3D"
// names.playful: "Playful" => "遊戯的"
// names.ultra: "Ultra" => "ウルトラ"
// colors.teal: "Teal" => "小鴨"
// colors.blue: "Blue" => "青い"
// colors.purple: "Purple" => "紫"
// colors.orchid: "Orchid" => "蘭"
// colors.tulip: "Tulip" => "チューリップ"
// colors.brown: "Brown" => "褐色"
// colors.green: "Green" => "緑"
// names.sharp: "Sharp" => "鋭い"
// names.borderless: "Borderless" => "ボーダレス"
// names.flat: "Flat" => "平"
// names.doubleborder: "Double Border" => "二重ボーダー"
// names.layered: "Layered" => "層状"
// names.solid: "Solid" => "固体"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "この言語のすべての文字列を削除してもよろしいですか?"
// ed.themeResetButton: "Reset theme settings to default" => "テーマ設定をデフォルトにリセットする"
// theme.placeholderColor: "Placeholder color" => "プレースホルダの色"
// ed.themeSettings: "Theme Settings" => "テーマ設定"
// ed.themeSettingsTooltip: "Open theme settings" => "テーマ設定を開く"
// pe.resetToDefaultCaption: "Reset" => "リセット"
// pv.file: "Local files" => "ローカルファイル"
// pv.camera: "Camera" => "カメラ"
// pv.file-camera: "Local files or camera" => "ローカルファイルまたはカメラ"
// ed.translateUsigAI: "Auto-translate All" => "すべて自動翻訳"
// ed.translationDialogTitle: "Untranslated strings" => "未翻訳の文字列"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "{0}項目以上入力してください"
// lg.question_resetValueName: "Reset question value" => "質問値のリセット"
// lg.column_resetValue: "Reset column value" => "列の値をリセット"
// pe.markRequired: "Mark as required" => "必須としてマーク"
// pe.removeRequiredMark: "Remove the required mark" => "必要なマークを削除する"
// p.resetValueIf: "Reset value if" => "次の場合に値をリセット"
// lg.question_setValueName: "Set question value" => "質問値の設定"
// lg.column_resetValueName: "Reset column value" => "列の値をリセット"
// lg.column_setValueName: "Set column value" => "列の値を設定する"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => "結果が対象の質問に割り当てられる式。"
// survey.title: "Title" => "タイトル"
// page.title: "Title" => "タイトル"
// p.setValueIf: "Set value if" => "次の場合に値を設定します"
// theme.header: "Header" => "ヘッダ"
// theme.backgroundImageFitFill: "Stretch" => "伸ばす"
// theme.backgroundImageFitTile: "Tile" => "瓦"
// theme.headerView: "View" => "眺める"
// theme.headerViewBasic: "Basic" => "基本的な"
// theme.headerViewAdvanced: "Advanced" => "アドバンスド"
// theme.headerInheritWidthFrom: "Content area width" => "コンテンツ領域の幅"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "調査と同じ"
// theme.headerInheritWidthFromPage: "Fit to page" => "ページに合わせる"
// theme.headerTextAreaWidth: "Text width" => "テキスト幅"
// theme.headerBackgroundColorSwitch: "Background color" => "背景色"
// theme.headerBackgroundColorNone: "None" => "何一つ"
// theme.headerBackgroundColorAccentColor: "Accent color" => "アクセントカラー"
// theme.headerBackgroundColorCustom: "Custom" => "習慣"
// theme.horizontalAlignmentLeft: "Left" => "左"
// theme.horizontalAlignmentCenter: "Center" => "センター"
// theme.horizontalAlignmentRight: "Right" => "右"
// theme.verticalAlignmentTop: "Top" => "ページのトップへ"
// theme.verticalAlignmentMiddle: "Middle" => "中央"
// theme.verticalAlignmentBottom: "Bottom" => "底"
// lg.question_resetValueText: "reset value for question: {0}" => "質問のリセット値:{0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "値の割り当て: 質問への{1}: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "列のセル値をリセット:{0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "セル値の割り当て:列への{1}:{0}"
// ed.surveyJsonExportButton: "Export" => "輸出"
// ed.surveyJsonImportButton: "Import" => "輸入"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "クリップボードにコピー"
// pe.filePlaceholder: "File placeholder text" => "ファイル プレースホルダー テキスト"
// pe.photoPlaceholder: "Photo placeholder text" => "写真の代替テキスト"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "ファイルまたは写真のプレースホルダーテキスト"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "「ソースタイプ」が「ローカルファイル」の場合、またはカメラが利用できない場合に適用されます"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "「ソースタイプ」が「カメラ」の場合に適用されます。"
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "「ソースタイプ」が「ローカルファイルまたはカメラ」の場合に適用されます。"
// theme.background: "Background" => "バックグラウンド"
// theme.appearance: "Appearance" => "様子"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "本当にテーマをリセットしますか?すべてのカスタマイズが失われます。"
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "はい、テーマをリセットします"
// theme.headerInheritWidthFromContainer: "Fit to container" => "コンテナに合わせる"
// signaturepad.showPlaceholder: "Show the placeholder" => "プレースホルダーを表示する"
// signaturepad.placeholder: "Placeholder text" => "プレースホルダテキスト"
// theme.surveyDescriptionFont: "Survey description font" => "調査の説明フォント"
// ed.prevFocus: "Focus previous" => "前に焦点を合わせる"
// ed.nextFocus: "Focus next" => "次の焦点"
// ed.saveTheme: "Save Theme" => "テーマを保存"
// ed.saveThemeTooltip: "Save Theme" => "テーマを保存"
// lg.page_requireName: "Make page required" => "ページを必須にする"
// lg.panel_requireName: "Make page required" => "ページを必須にする"
// signaturepad.signatureWidth: "Signature area width" => "署名領域の幅"
// signaturepad.signatureHeight: "Signature area height" => "署名領域の高さ"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "署名領域の自動スケーリング"
// signaturepad.penMinWidth: "Minimum pen width" => "最小ペン幅"
// signaturepad.penMaxWidth: "Maximum pen width" => "ペンの最大幅"
// theme.logoPosition: "Logo position" => "ロゴの位置"
// theme.headerTitlePosition: "Title position" => "タイトルの位置"
// theme.headerDescriptionPosition: "Description position" => "記述の位置"
// ed.propertyGridNoResultsFound: "No results found" => "結果が見つかりませんでした"
// pv.leftRight: "Left and right" => "左右"
// p.sourceType: "Source type" => "ソースの種類"
// p.fitToContainer: "Fit to container" => "コンテナにフィット"
// p.setValueExpression: "Set value expression" => "設定値式"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "選択肢は Web サービスから読み込まれます。"
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "設定に移動"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "読み込まれた選択肢オプションのプレビュー"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "行での回答の重複を防ぐ"
// theme.advancedMode: "Advanced mode" => "詳細モード"
// theme.backgroundCornerRadius: "Background and corner radius" => "背景と角の半径"
// theme.colorsTitle: "Colors" => "色"
// theme.font: "Font" => "フォント"
// theme.lines: "Lines" => "台詞"
// theme.titleFont: "Title font" => "タイトルのフォント"
// theme.descriptionFont: "Description font" => "説明フォント"
// theme.shadow: "Shadow effects" => "影の効果"
// ed.translateUsigAIFrom: "Translate from: " => "言語の選択："
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "[回答を拒否] オプションを許可する"
// pe.showDontKnowItem: "Allow the Don't Know option" => "[わからない] オプションを許可する"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "[回答を拒否] オプションを許可する"
// pe.showDontKnowItem: "Allow the Don't Know option" => "[わからない] オプションを許可する"
// pv.contain: "Contain" => "含む"
// pv.cover: "Cover" => "覆う"
// pv.fill: "Fill" => "注ぐ"
// pe.transposeData: "Transpose rows to columns" => "行を列に転置する"
// layout.panel: "Layout" => "レイアウト"
// layout.question: "Layout" => "レイアウト"
// layout.base: "Layout" => "レイアウト"
// panel.name: "Panel name" => "パネル名"
// panel.title: "Panel title" => "パネルタイトル"
// panel.description: "Panel description" => "パネルの説明"
// panel.visibleIf: "Make the panel visible if" => "パネルを表示するのは、次の場合です"
// panel.requiredIf: "Make the panel required if" => "次の場合は、パネルを必須にします"
// panel.questionsOrder: "Question order within the panel" => "パネル内の質問の順序"
// panel.startWithNewLine: "Display the panel on a new line" => "パネルを新しい行に表示する"
// panel.state: "Panel collapse state" => "パネル折りたたみ状態"
// panel.width: "Inline panel width" => "インラインパネルの幅"
// panel.minWidth: "Minimum panel width" => "最小パネル幅"
// panel.maxWidth: "Maximum panel width" => "最大パネル幅"
// panel.showNumber: "Number panels" => "番号パネル"
// paneldynamic.name: "Panel name" => "パネル名"
// paneldynamic.title: "Panel title" => "パネルタイトル"
// paneldynamic.description: "Panel description" => "パネルの説明"
// paneldynamic.visibleIf: "Make the panel visible if" => "パネルを表示するのは、次の場合です"
// paneldynamic.requiredIf: "Make the panel required if" => "次の場合は、パネルを必須にします"
// paneldynamic.page: "Move the panel to page" => "パネルをページに移動する"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "パネルを新しい行に表示する"
// paneldynamic.state: "Panel collapse state" => "パネル折りたたみ状態"
// paneldynamic.width: "Inline panel width" => "インラインパネルの幅"
// paneldynamic.minWidth: "Minimum panel width" => "最小パネル幅"
// paneldynamic.maxWidth: "Maximum panel width" => "最大パネル幅"
// paneldynamic.templateDescription: "Panel description pattern" => "パネル記述パターン"
// paneldynamic.templateTitle: "Panel title pattern" => "パネル・タイトル・パターン"
// paneldynamic.noEntriesText: "Empty panel text" => "空のパネル・テキスト"
// paneldynamic.templateTabTitle: "Tab title pattern" => "タブ タイトルのパターン"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "個々のパネルを表示するのは、次の場合です"
// paneldynamic.hideNumber: "Hide the panel number" => "パネル番号を隠す"
// paneldynamic.titleLocation: "Panel title alignment" => "パネルタイトルの配置"
// paneldynamic.descriptionLocation: "Panel description alignment" => "パネル記述の位置合わせ"
// paneldynamic.templateTitleLocation: "Question title alignment" => "質問タイトルの配置"
// paneldynamic.templateErrorLocation: "Error message alignment" => "エラー・メッセージのアライメント"
// paneldynamic.newPanelPosition: "New panel location" => "新しいパネルの位置"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "次の質問で回答の重複を防ぐ"
// question.name: "Question name" => "質問名"
// question.title: "Question title" => "質問のタイトル"
// question.description: "Question description" => "質問の説明"
// question.visibleIf: "Make the question visible if" => "次の場合に質問を表示します。"
// question.requiredIf: "Make the question required if" => "次の場合は質問を必須にします"
// question.state: "Question box collapse state" => "質問ボックスの折りたたみ状態"
// question.hideNumber: "Hide the question number" => "質問番号を非表示にする"
// question.titleLocation: "Question title alignment" => "質問タイトルの配置"
// question.descriptionLocation: "Question description alignment" => "質問の説明の配置"
// question.errorLocation: "Error message alignment" => "エラー・メッセージのアライメント"
// question.indent: "Increase the inner indent" => "内側のインデントを増やす"
// question.width: "Inline question width" => "インラインの質問の幅"
// question.minWidth: "Minimum question width" => "質問の最小幅"
// question.maxWidth: "Maximum question width" => "質問の最大幅"
// question.textUpdateMode: "Update input field value" => "入力フィールド値の更新"
// signaturepad.allowClear: "Show the Clear button within signature area" => "署名領域内に [クリア] ボタンを表示する"
// signaturepad.penColor: "Stroke color" => "ストロークの色"
// comment.rows: "Input field height (in lines)" => "入力フィールドの高さ (行単位)"
// expression.name: "Expression name" => "エクスプレッション名"
// expression.title: "Expression title" => "エクスプレッションのタイトル"
// expression.description: "Expression description" => "式の説明"
// expression.expression: "Expression" => "表現"
// trigger.expression: "Expression" => "表現"
// calculatedvalue.expression: "Expression" => "表現"
// survey.description: "Survey description" => "調査内容"
// page.name: "Page name" => "ページ名"
// page.description: "Page description" => "ページの説明"
// page.visibleIf: "Make the page visible if" => "次の場合にページを表示します"
// page.requiredIf: "Make the page required if" => "次の場合は、ページを必須にします"
// page.questionsOrder: "Question order on the page" => "ページ上の質問の順序"
// matrixdropdowncolumn.name: "Column name" => "列名"
// matrixdropdowncolumn.title: "Column title" => "列のタイトル"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "回答の重複を防ぐ"
// matrixdropdowncolumn.width: "Column width" => "列幅"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "最小列幅"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "入力フィールドの高さ (行単位)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "次の場合に列を表示します"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "次の場合は、列を必須にします"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "個別の列に各オプション"
// multipletextitem.name: "Name" => "名前"
// multipletextitem.title: "Title" => "タイトル"
// pe.rateDescriptionLocation: "Label alignment" => "ラベルの配置"
// pe.cellErrorLocation: "Cell error message alignment" => "セル・エラー・メッセージの配置"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "まだ列がありません"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "まだ行がありません"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "入力規則はまだありません"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "カスタム変数はまだありません"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "トリガーはまだありません"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "リンクはまだありません"
// pe.addNew@columns: "Add new column" => "新しい列を追加"
// pe.addNew@rows: "Add new row" => "新しい行を追加"
// pe.addNew@validators: "Add new rule" => "新しいルールを追加"
// pe.addNew@calculatedValues: "Add new variable" => "新しい変数を追加"
// pe.addNew@triggers: "Add new trigger" => "新しいトリガーを追加する"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "新しい URL を追加"
// choicesbyurl.url: "Web service's URL" => "Web サービスの URL"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "プログレスバーにページタイトルを表示する"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "プログレスバーにページ番号を表示する"
// itemvalue.visibleIf: "Make the option visible if" => "次の場合にオプションを表示します"
// itemvalue.enableIf: "Make the option selectable if" => "次の場合は、オプションを選択可能にします"
// panel.layout: "Panel Layout" => "パネルレイアウト"
// tabs.questionSettings: "Question Settings" => "質問設定"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "例:https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "例:categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "例:a)"
// pe.width_placeholder: "Ex.: 6in" => "例:6インチ"
// pe.minWidth_placeholder: "Ex.: 600px" => "例:600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "例:50%"
// pv.selected: "Selected" => "入選"
// pv.unselected: "Unselected" => "未選択"
// pv.center: "Center" => "センター"
// pv.middle: "Middle" => "中央"
// pv.next: "Next" => "次に"
// pv.last: "Last" => "前の"
// clearIfInvisible.none: "Never" => "一度もない"
// questionsOnPageMode.standard: "Original structure" => "元の構造"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "すべての質問を 1 ページに表示する"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "1ページにつき1つの質問を表示する"
// pv.auto: "Auto" => "自動"
// panelsState.firstExpanded: "First expanded" => "最初の展開"
// rateColorMode.scale: "Scale" => "規模"
// scaleColorMode.monochrome: "Monochrome" => "モノクロ"
// scaleColorMode.colored: "Colored" => "有色"
// state.default: "Locked" => "締まる"
// showQuestionNumbers.default: "Auto-numbering" => "自動番号付け"
// showQuestionNumbers.on: "Auto-numbering" => "自動番号付け"
// showQuestionNumbers.onPage: "Reset on each page" => "各ページでリセット"
// showQuestionNumbers.onpanel: "Reset on each panel" => "各パネルでリセット"
// showQuestionNumbers.onPanel: "Reset on each panel" => "各パネルでリセット"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "調査を続ける"
// showQuestionNumbers.off: "No numbering" => "ナンバリングなし"
// descriptionLocation.underTitle: "Under the question title" => "質問タイトルの下"
// descriptionLocation.underInput: "Under the input field" => "入力欄の下"
// selectToRankAreasLayout.horizontal: "Next to choices" => "選択肢の横"
// selectToRankAreasLayout.vertical: "Above choices" => "上記の選択肢"
// displayStyle.decimal: "Decimal" => "小数"
// displayStyle.currency: "Currency" => "通貨"
// displayStyle.percent: "Percentage" => "百分率"
// displayStyle.date: "Date" => "日付"
// totalDisplayStyle.decimal: "Decimal" => "小数"
// totalDisplayStyle.currency: "Currency" => "通貨"
// totalDisplayStyle.percent: "Percentage" => "百分率"
// totalDisplayStyle.date: "Date" => "日付"
// rowsOrder.initial: "Original" => "翻訳元"
// questionsOrder.initial: "Original" => "翻訳元"
// showProgressBar.aboveheader: "Above the header" => "ヘッダーの上"
// showProgressBar.belowheader: "Below the header" => "ヘッダーの下"
// pv.sum: "Sum" => "和"
// pv.count: "Count" => "数える"
// pv.min: "Min" => "分"
// pv.max: "Max" => "マックス"
// pv.avg: "Avg" => "平均"
// searchMode.contains: "Contains" => "含む"
// searchMode.startsWith: "Starts with" => "次で始まる"
// panel.name: "A panel ID that is not visible to respondents." => "回答者には表示されないパネルID。"
// panel.description: "Type a panel subtitle." => "パネルのサブタイトルを入力します。"
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "魔法の杖アイコンを使用して、パネルの表示を決定する条件付きルールを設定します。"
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "魔法の杖アイコンを使用して、パネルの読み取り専用モードを無効にする条件付きルールを設定します。"
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "魔法の杖アイコンを使用して、ネストされた質問に回答が少なくとも1つない限り、調査の送信を禁止する条件付きルールを設定します。"
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "このパネル内のすべての質問に適用されます。この設定を上書きする場合は、個々の質問のタイトル配置ルールを定義します。「継承」オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定(デフォルトでは「上」)を適用します。"
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "パネル内のすべての質問に関連するエラーメッセージの位置を設定します。[継承] オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定を適用します。"
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "質問の元の順序を維持するか、ランダム化します。[継承] オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定を適用します。"
// panel.page: "Repositions the panel to the end of a selected page." => "パネルを選択したページの末尾に再配置します。"
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "パネルの内容とパネルボックスの左の境界線の間にスペースまたは余白を追加します。"
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "選択を解除すると、前の質問またはパネルと 1 行でパネルが表示されます。パネルがフォームの最初の要素である場合、この設定は適用されません。"
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "次から選択します: 「展開」 - パネルは完全に表示され、折りたたむことができます。「折りたたまれた」 - パネルにはタイトルと説明のみが表示され、展開できます。「ロック」 - パネルは完全に表示され、折りたたむことはできません。"
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "パネルの幅を、同じ行内の他の調査要素に比例して設定します。CSS 値 (px、%、in、pt など) を受け入れます。"
// paneldynamic.name: "A panel ID that is not visible to respondents." => "回答者には表示されないパネルID。"
// paneldynamic.description: "Type a panel subtitle." => "パネルのサブタイトルを入力します。"
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "魔法の杖アイコンを使用して、パネルの表示を決定する条件付きルールを設定します。"
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "魔法の杖アイコンを使用して、パネルの読み取り専用モードを無効にする条件付きルールを設定します。"
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "魔法の杖アイコンを使用して、ネストされた質問に回答が少なくとも1つない限り、調査の送信を禁止する条件付きルールを設定します。"
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "このパネル内のすべての質問に適用されます。この設定を上書きする場合は、個々の質問のタイトル配置ルールを定義します。「継承」オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定(デフォルトでは「上」)を適用します。"
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "無効な入力を含む質問に関連するエラーメッセージの場所を設定します。次から選択します: \"Top\" - 質問ボックスの上部にエラーテキストが配置されます。\"Bottom\" - 質問ボックスの下部にエラーテキストが配置されます。「継承」オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定(デフォルトでは「上」)を適用します。"
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "パネル内のすべての質問に関連するエラーメッセージの位置を設定します。[継承] オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定を適用します。"
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "パネルを選択したページの末尾に再配置します。"
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "パネルの内容とパネルボックスの左の境界線の間にスペースまたは余白を追加します。"
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "選択を解除すると、前の質問またはパネルと 1 行でパネルが表示されます。パネルがフォームの最初の要素である場合、この設定は適用されません。"
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "次から選択します: 「展開」 - パネルは完全に表示され、折りたたむことができます。「折りたたまれた」 - パネルにはタイトルと説明のみが表示され、展開できます。「ロック」 - パネルは完全に表示され、折りたたむことはできません。"
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "パネルの幅を、同じ行内の他の調査要素に比例して設定します。CSS 値 (px、%、in、pt など) を受け入れます。"
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "動的パネルタイトルのテンプレートを入力します。パネルの一般的な位置には {panelIndex} を使用し、表示されているパネル間の順序には {visiblePanelIndex} を使用します。これらのプレースホルダーをパターンに挿入して、自動番号付けを追加します。"
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "タブタイトルのテンプレートを入力します。パネルの一般的な位置には {panelIndex} を使用し、可視パネル間の順序には {visiblePanelIndex} を使用します。これらのプレースホルダーをパターンに挿入して、自動番号付けを追加します。"
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "この設定では、動的パネル内の個々のパネルの表示を制御できます。'{panel}' プレースホルダーを使用して、式で現在のパネルを参照します。"
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "この設定は、このパネル内のすべての質問に自動的に継承されます。この設定を上書きする場合は、個々の質問のタイトル配置ルールを定義します。「継承」オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定(デフォルトでは「上」)を適用します。"
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "「継承」オプションは、ページレベル(設定されている場合)またはアンケートレベルの設定(デフォルトでは「パネルタイトルの下」)を適用します。"
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "新しく追加されたパネルの位置を定義します。デフォルトでは、新しいパネルが最後に追加されます。「次へ」を選択して、現在のパネルの後に新しいパネルを挿入します。"
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "最後のパネルから回答を複製し、次に追加された動的パネルに割り当てます。"
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "質問名を参照して、各パネルでこの質問に対して一意の回答を提供するようユーザーに要求します。"
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "この設定では、式に基づいてデフォルトの回答値を割り当てることができます。式には、基本的な計算 - '{q1_id} + {q2_id}'、'{age} > 60' などのブール式、関数 'iif()'、'today()'、'age()'、'min()'、'max()'、'avg()' などを含めることができます。この式によって決定される値は、回答者の手動入力で上書きできる初期デフォルト値として機能します。"
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "魔法の杖アイコンを使用して、回答者の入力を「デフォルト値式」または「値式の設定」に基づく値、または「デフォルト回答」値(どちらかが設定されている場合)にリセットするタイミングを決定する条件付きルールを設定します。"
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "魔法の杖アイコンを使用して、「値の設定式」をいつ実行するかを決定し、結果の値を応答として動的に割り当てる条件付きルールを設定します。"
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "「値を設定する条件」ルールの条件が満たされた場合に設定される値を定義する式を指定します。式には、基本的な計算 - '{q1_id} + {q2_id}'、'{age} > 60' などのブール式、関数 'iif()'、'today()'、'age()'、'min()'、'max()'、'avg()' などを含めることができます。この式によって決定される値は、回答者の手動入力によって上書きできます。"
// question.name: "A question ID that is not visible to respondents." => "回答者に表示されない質問ID。"
// question.description: "Type a question subtitle." => "質問のサブタイトルを入力します。"
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "魔法の杖アイコンを使用して、質問の表示を決定する条件付きルールを設定します。"
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "魔法の杖アイコンを使用して、質問の読み取り専用モードを無効にする条件付きルールを設定します。"
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "魔法の杖アイコンを使用して、質問に回答がない限り、アンケートの進行や送信を禁止する条件付きルールを設定します。"
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "選択を解除すると、前の質問またはパネルと 1 行で質問が表示されます。この設定は、質問がフォームの最初の要素である場合には適用されません。"
// question.page: "Repositions the question to the end of a selected page." => "選択したページの最後に質問を再配置します。"
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "選択肢: 「展開」 - 質問ボックスは完全に表示され、折りたたむことができます。「折りたたまれた」 - 質問ボックスにはタイトルと説明のみが表示され、展開できます。\"Locked\" - 質問ボックスは完全に表示され、折りたたむことはできません。"
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "パネル、ページ、またはアンケートレベルで定義されたタイトル配置ルールを上書きします。「継承」オプションは、上位レベルの設定(設定されている場合)またはアンケートレベルの設定(デフォルトでは「トップ」)を適用します。"
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "「継承」オプションは、アンケートレベルの設定(デフォルトでは「質問タイトルの下」)を適用します。"
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "無効な入力を含む質問に関連するエラーメッセージの場所を設定します。次から選択します: \"Top\" - 質問ボックスの上部にエラーテキストが配置されます。\"Bottom\" - 質問ボックスの下部にエラーテキストが配置されます。「継承」オプションは、アンケートレベルの設定(デフォルトでは「トップ」)を適用します。"
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "質問の内容と質問ボックスの左の境界線の間にスペースまたは余白を追加します。"
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "同じ行内の他のアンケート要素に比例して質問の幅を設定します。CSS 値 (px、%、in、pt など) を受け入れます。"
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "魔法の杖アイコンを使用して、質問の検証ルールを設定します。"
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "次から選択します: \"On lost focus\" - 入力フィールドがフォーカスを失ったときに値が更新されます。「入力中」 - ユーザーが入力しているときに、値がリアルタイムで更新されます。「継承」オプションは、アンケートレベルの設定(デフォルトでは「フォーカスを失ったとき」)を適用します。"
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "任意の Web サービスを多肢選択式の質問のデータ ソースとして使用できます。選択肢の値を入力するには、データを提供するサービスの URL を入力します。"
// question.searchMode: "A comparison operation used to filter the drop-down list." => "ドロップダウン リストをフィルター処理するために使用される比較演算。"
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "表示される署名領域と結果の画像の幅を設定します。"
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "表示される署名領域と結果の画像の高さを設定します。"
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "デフォルトの3:2の縦横比を維持したまま、質問ボックス内の使用可能なすべてのスペースを署名領域に埋める場合に選択します。カスタムの幅と高さの値が設定されている場合、設定ではこれらの寸法の縦横比が維持されます。"
// file.imageHeight: "Adjusts the height of the image in the survey results." => "アンケート結果の画像の高さを調整します。"
// file.imageWidth: "Adjusts the width of the image in the survey results." => "アンケート結果の画像の幅を調整します。"
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "高さの最小値と最大値の値を上書きします。"
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "幅の最小値と最大値を上書きします。"
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Value\" は、条件付きルールで使用される項目 ID として機能します。回答者に「テキスト」が表示されます。"
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "この設定では、入力フィールドのサイズが変更されるだけで、質問ボックスの幅には影響しません。許容される入力長を制限するには、<b>検証→最大文字数制限</b>に移動します。"
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "入力欄に表示する行数を設定します。入力の行数が多い場合は、スクロールバーが表示されます。"
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "次から選択します。 「編集可能」 - 回答者がアンケートに回答できるようにします。「読み取り専用」 - フォームの編集を無効にします。"
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "回答者に表示されない列 ID。"
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "列に対して有効にすると、回答者はこの列内の質問ごとに一意の回答を提供する必要があります。"
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "入力欄に表示する行数を設定します。入力の行数が多い場合は、スクロールバーが表示されます。"
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "魔法の杖アイコンを使用して、列の表示を決定する条件付きルールを設定します。"
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "魔法の杖アイコンを使用して、列の読み取り専用モードを無効にする条件付きルールを設定します。"
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "魔法の杖アイコンを使用して、ネストされた質問に回答が少なくとも1つない限り、調査の送信を禁止する条件付きルールを設定します。"
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "選択すると、選択肢オプションごとに個別の列が作成されます。"
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "次から選択します: \"Static\" - 固定幅を設定します。「レスポンシブ」 - アンケートを画面の全幅に表示します。「自動」 - 使用する質問タイプに応じて、2つのいずれかを適用します。"
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "画像リンクを貼り付けるか(サイズ制限なし)、フォルダアイコンをクリックして、コンピューターからファイルを参照します(最大64KB)。"
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "ロゴの幅をCSS単位(px、%、in、ptなど)で設定します。"
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "ロゴの高さを CSS 単位 (px、%、in、pt など) で設定します。"
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "次から選択: 「なし」 - 画像は元のサイズを維持します。\"Contain\" - 画像はアスペクト比を維持しながらサイズ変更されます。「表紙」-画像は縦横比を維持しながらボックス全体を埋めます。\"Fill\" - 画像は、アスペクト比を維持せずにボックスを埋めるように引き伸ばされます。"
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "回答者が現在のページのすべての質問に回答した後、アンケートを自動的に次のページに進めるかどうかを選択します。"
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "ページ上のナビゲーションボタンの表示と位置を設定します。"
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "プログレスバーの表示と位置を設定します。「自動」の値は、アンケートヘッダーの上または下に進行状況バーを表示します。"
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "すべての質問または回答済みの質問のみを含むプレビューページを有効にします。"
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "アンケート内のすべての質問に適用されます。この設定は、下位レベル(パネル、ページ、または質問)のタイトル配置ルールによって上書きできます。下位レベルの設定は、上位レベルの設定よりも優先されます。"
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "回答が必要であることを示す記号または記号のシーケンス。"
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "番号付けを開始する番号または文字を入力します。"
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "無効な入力を含む質問に関連するエラーメッセージの場所を設定します。次から選択します: \"Top\" - 質問ボックスの上部にエラーテキストが配置されます。\"Bottom\" - 質問ボックスの下部にエラーテキストが配置されます。"
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "各ページの最初の入力フィールドをテキスト入力可能にするかどうかを選択します。"
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "質問の元の順序を維持するか、ランダム化します。この設定の効果は、「プレビュー」タブにのみ表示されます。"
// pehelp.maxTextLength: "For text entry questions only." => "テキスト入力の質問専用です。"
// pehelp.maxOthersLength: "For question comments only." => "質問コメント専用です。"
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "質問のコメントと長いテキストの質問の高さを、入力したテキストの長さに基づいて自動的に拡大する場合に選択します。"
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "質問コメントとテキスト(長文)の質問のみ。"
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "カスタム変数は、フォーム計算で使用される中間変数または補助変数として機能します。回答者の入力をソース値として受け取ります。各カスタム変数には、一意の名前と基になる式があります。"
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "式の計算値をアンケート結果とともに保存する場合に選択します。"
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "トリガーは、式に基づくイベントまたは条件です。式が \"true\" と評価されると、トリガーによってアクションが開始されます。このようなアクションには、必要に応じて、影響するターゲットの質問を含めることができます。"
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "条件付きロジックによって非表示にされた質問の値をクリアするかどうか、およびいつクリアするかを選択します。"
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "次から選択します: \"On lost focus\" - 入力フィールドがフォーカスを失ったときに値が更新されます。「入力中」 - ユーザーが入力しているときに、値がリアルタイムで更新されます。"
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "左の値は条件付きルールで使用される列IDとして機能し、右の値は回答者に表示されます。"
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "左の値は条件付きルールで使用される行IDとして機能し、右の値は回答者に表示されます。"
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS 値 (px、%、in、pt など) を受け入れます。"
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS 値 (px、%、in、pt など) を受け入れます。"
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "無効な入力があるセルに関連するエラーメッセージの位置を設定します。「継承」オプションは、「エラーメッセージの配置」プロパティの設定を適用します。"
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "「重複回答の防止」プロパティが有効な場合、重複したエントリを送信しようとする回答者は、次のエラーメッセージを受け取ります。"
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "式に基づいて合計値を計算できます。式には、基本的な計算 ('{q1_id} + {q2_id}')、ブール式 ('{age} > 60')、関数 ('iif()'、'today()'、'age()'、'min()'、'max()'、'avg()' など) を含めることができます。"
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "行の削除を確認するプロンプトをトリガーします。"
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "最後の行から回答を複製し、次に追加された動的行に割り当てます。"
// pehelp.description: "Type a subtitle." => "字幕を入力します。"
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "言語を選択してアンケートの作成を開始します。翻訳を追加するには、新しい言語に切り替えて、ここまたは [翻訳] タブで元のテキストを翻訳します。"
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "行を基準にした詳細セクションの位置を設定します。次から選択します: \"None\" - 展開は追加されません。\"Under the row\" - 行列の各行の下に行展開が配置されます。\"Under the row, display one row expansion only\" - 展開は 1 行の下にのみ表示され、残りの行展開は折りたたまれます。"
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "次から選択: 「なし」 - 画像は元のサイズを維持します。\"Contain\" - 画像はアスペクト比を維持しながらサイズ変更されます。「表紙」-画像は縦横比を維持しながらボックス全体を埋めます。\"Fill\" - 画像は、アスペクト比を維持せずにボックスを埋めるように引き伸ばされます。"
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "データの入力中に入力フィールドの高さを徐々に増やします。「入力フィールドの高さ(行単位)」の設定を上書きします。"
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "サイズ変更ハンドル(またはグリップ)が隅に表示され、ドラッグして入力フィールドのサイズを変更できます。"
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "アンケートが [ありがとうございます] ページに自動移動するまでの時間間隔 (秒単位)。"
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "アンケートが次のページに自動進むまでの時間間隔 (秒単位)。"
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "アンケートが次のページに自動進むまでの時間間隔 (秒単位)。"
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "魔法の杖アイコンを使用して、ページの表示を決定する条件付きルールを設定します。"
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "魔法の杖アイコンを使用して、ページの読み取り専用モードを無効にする条件付きルールを設定します。"
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "魔法の杖アイコンを使用して、ネストされた質問に回答が少なくとも1つない限り、調査の送信を禁止する条件付きルールを設定します。"
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "このページ内のすべての質問に適用されます。この設定を上書きする場合は、個々の質問またはパネルのタイトル配置ルールを定義します。「継承」オプションは、アンケートレベルの設定(デフォルトでは「トップ」)を適用します。"
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "無効な入力を含む質問に関連するエラーメッセージの場所を設定します。次から選択します: \"Top\" - 質問ボックスの上部にエラーテキストが配置されます。\"Bottom\" - 質問ボックスの下部にエラーテキストが配置されます。「継承」オプションは、アンケートレベルの設定(デフォルトでは「トップ」)を適用します。"
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "質問の元の順序を維持するか、ランダム化します。「継承」オプションは、アンケートレベルの設定(デフォルトでは「オリジナル」)を適用します。この設定の効果は、「プレビュー」タブにのみ表示されます。"
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "ページ上のナビゲーションボタンの表示を設定します。「継承」オプションは、アンケートレベルの設定を適用し、デフォルトは「表示」です。"
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "ページ上のタイマーの表示と位置を設定します。"
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "次から選択します: 「ロック」 - ユーザーはパネルを展開または折りたたむことはできません。\"Collapse all\" - すべてのパネルが折りたたまれた状態で開始されます。\"Expand all\" - すべてのパネルが展開された状態で開始されます。\"First expanded\" - 最初のパネルのみが最初に展開されます。"
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "選択リストに表示する画像またはビデオ ファイルの URL を含むオブジェクトの配列内に共有プロパティ名を入力します。"
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "左の値は条件付きルールで使用される項目IDとして機能し、右の値は回答者に表示されます。"
// pehelp.title: "Type a user-friendly title to display." => "表示するわかりやすいタイトルを入力します。"
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "ファイルがアップロードされるまで、ユーザーが調査を完了しないようにします。"
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS 値 (px、%、in、pt など) を受け入れます。"
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS 値 (px、%、in、pt など) を受け入れます。"
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS 値 (px、%、in、pt など) を受け入れます。"
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "単一選択および複数選択の質問タイプでは、各選択肢にIDと表示値があります。この設定を選択すると、HTML の質問やアンケート エレメントの動的なタイトルと説明に ID 値ではなく表示値が表示されます。"
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "条件付きロジックで非表示にした質問値をクリアするかどうか、およびいつクリアするかを選択します。「継承」オプションは、アンケートレベルの設定(デフォルトでは「アンケート完了時」)を適用します。"
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "選択元: 「すべて」 - 選択した質問からすべての選択肢をコピーします。\"Selected\" - 選択した選択肢オプションのみを動的にコピーします。「未選択」 - 選択されていない選択肢オプションのみを動的にコピーします。「なし」と「その他」のオプションは、ソースの質問で有効になっている場合、デフォルトでコピーされます。"
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "選択すると、ユーザーは別のコメント ボックスに追加の入力を含めることができます。"
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "各特殊選択オプション(「なし」、「その他」、「すべて選択」)を、複数列のレイアウトを使用している場合でも、新しい行に表示します。"
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "サービス データセット内で、オブジェクトのターゲット配列が配置されている場所を指定します。URL が既に配列を指している場合は、空のままにします。"
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "選択リストに表示する値を含むオブジェクトの配列内に、統一プロパティ名を入力します。"
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "選択すると、サービスが空の応答または配列を返すことができます。"
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "魔法の杖アイコンを使用して、すべての選択肢オプションの表示を決定する条件付きルールを設定します。"
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "左の値は条件付きルールで使用される項目IDとして機能し、右の値は回答者に表示されます。"
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "「自動」は、使用可能な幅に基づいて「ボタン」モードと「ドロップダウン」モードのいずれかを選択します。幅がボタンを表示するのに不十分な場合、質問にはドロップダウンが表示されます。"
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "さまざまな形式で結果を生成する質問を接続できます。このような質問が結合識別子を使用してリンクされている場合、この共有プロパティには選択された質問値が格納されます。"
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "ドロップダウンメニューの内容を更新して、ユーザーが入力フィールドに入力している検索クエリに一致させる場合に選択します。"
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "回答者が肯定的な回答をした場合にアンケート結果に保存する値。"
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "回答者が否定的な回答をした場合にアンケート結果に保存する値。"
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "このオプションを無効にすると、プレビュー画像が上書きされ、ファイルがアップロードされたかどうかをユーザーが理解しにくくなるため、無効にすることはお勧めしません。"
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "ファイルの削除を確認するプロンプトを表示します。"
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "選択した選択肢のみをランク付けできるようにします。ユーザーは、選択した項目を選択リストからドラッグして、ランキング領域内で並べ替えます。"
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "入力時に回答者に提案される選択肢のリストを入力します。"
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "この設定では、入力フィールドのサイズが変更されるだけで、質問ボックスの幅には影響しません。"
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "すべてのアイテムラベルの幅をピクセル単位で統一します。"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "「自動」オプションでは、指定されたソースURLに基づいて、表示に適したモード(画像、動画、YouTube)が自動的に決定されます。"
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "ユーザーのデバイスに画像を表示できない場合や、アクセシビリティの目的で代用します。"
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "レーティングアイコンの種類が「スマイリー」に設定されている場合に選択した絵文字の色を定義します。以下から選択します: \"デフォルト\" - 選択した絵文字はデフォルトのアンケートカラーで表示されます。「スケール」 - 選択した絵文字は、評価スケールから色を継承します。"
// expression.name: "An expression ID that is not visible to respondents." => "回答者に表示されない式 ID。"
// expression.description: "Type an expression subtitle." => "エクスプレッションのサブタイトルを入力します。"
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "式には、基本的な計算 ('{q1_id} + {q2_id}')、条件 ('{age} > 60')、関数 ('iif()'、'today()'、'age()'、'min()'、'max()'、'avg()' など) を含めることができます。"
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "「その他」オプションの値をアンケート結果に別のプロパティとして保存する場合に選択します。"
// p.swapOrder: "Swap the order of Yes and No" => "「はい」と「いいえ」の順序を入れ替える"
// p.itemTitleWidth: "Item label width (in px)" => "アイテムラベルの幅 (px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "すべてのオプションが選択されている場合に表示されるテキスト"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "ランキングエリアのプレースホルダーテキスト"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "調査に自動的に回答する"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "回答者がすべての質問に回答した後にアンケートを自動的に完了する場合に選択します。"
// masksettings.saveMaskedValue: "Save masked value in survey results" => "アンケート結果にマスクされた値を保存する"
// patternmask.pattern: "Value pattern" => "値パターン"
// datetimemask.min: "Minimum value" => "最小値"
// datetimemask.max: "Maximum value" => "最大値"
// numericmask.allowNegativeValues: "Allow negative values" => "負の値を許可する"
// numericmask.thousandsSeparator: "Thousands separator" => "1000 の位の区切り記号"
// numericmask.decimalSeparator: "Decimal separator" => "小数点記号"
// numericmask.precision: "Value precision" => "値の精度"
// numericmask.min: "Minimum value" => "最小値"
// numericmask.max: "Maximum value" => "最大値"
// currencymask.prefix: "Currency prefix" => "通貨接頭辞"
// currencymask.suffix: "Currency suffix" => "通貨の接尾辞"
// pe.maskType: "Input mask type" => "定型入力の種類"
// maskTypes.patternmask: "Pattern" => "パターン"
// maskTypes.numericmask: "Numeric" => "数値"
// maskTypes.datetimemask: "Date and Time" => "日付と時刻"
// maskTypes.currencymask: "Currency" => "通貨"
// tabs.mask: "Input Mask Settings" => "定型入力設定"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "例:+1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "例:mm/dd/yyyy"
// pe.currencyprefix_placeholder: "Ex.: $" => "例:$"
// pe.currencysuffix_placeholder: "Ex.: USD" => "例:米ドル"
// pv.textWrapEnabled: "Wrap choices" => "ラップの選択肢"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "選択肢オプションのテキスト(長い)は、ドロップダウンメニュー内に収まるように改行を自動的に生成します。テキストをクリップする場合は、選択を解除します。"
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "マスクを適用した質問値をアンケート結果に保存する場合に選択します。"
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "パターンには、文字列リテラルと次のプレースホルダーを含めることができます: '9' - 数字の場合。'a' - 大文字または小文字。'#' - 数字または大文字または小文字。文字をエスケープするには、バックスラッシュ '\\' を使用します。"
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "パターンには、区切り文字と次のプレースホルダーを含めることができます: 'm' - 月番号。'mm' - 月番号、1桁の値の場合は先頭にゼロを付けます。'd' - 日付'dd' - 日付、1桁の値の先頭にゼロを付けます。'yy' - 年の下2桁'yyyy' - 4 桁の年。"
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "表示される数値の小数部と整数部を区切るために使用される記号。"
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "大きな数字を 3 つのグループに区切るために使用される記号。"
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "表示される数値の小数点以下の桁数を制限します。"
// currencymask.prefix: "One or several symbols to be displayed before the value." => "値の前に表示される 1 つまたは複数のシンボル。"
// currencymask.suffix: "One or several symbols to be displayed after the value." => "値の後に表示される 1 つまたは複数の記号。"
// ed.translationSource: "Source: " => "源："
// ed.translationTarget: "Target: " => "ターゲット："
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "ページは空です。ツールボックスから要素をドラッグするか、下のボタンをクリックします。"
// maskTypes.none: "None" => "何一つ"
// itemvalue@rows.visibleIf: "Make the row visible if" => "次の場合に行を表示します。"
// itemvalue@rows.enableIf: "Make the row editable if" => "次の場合に行を編集可能にします"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "読み取り専用モードまたはプレビューモードのプレースホルダーテキスト"
// pe.textWrapEnabled: "Wrap choices" => "ラップの選択肢"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "「自動」オプションでは、指定されたソースURLに基づいて、表示に適したモード(画像、動画、YouTube)が自動的に決定されます。"
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "「画像」と「動画」のどちらかを選択して、メディアセレクタのコンテンツモードを設定します。「画像」を選択した場合は、提供されるすべてのオプションが、JPEG、GIF、PNG、APNG、SVG、BMP、ICO形式の画像ファイルであることを確認してください。同様に、「ビデオ」を選択した場合は、すべてのオプションがMP4、MOV、WMV、FLV、AVI、MKV形式のビデオファイルへの直接リンクであることを確認してください。YouTubeのリンクは動画オプションではサポートされていませんのでご注意ください。"
// ed.selectFile: "Select a file" => "ファイルを選択"
// ed.removeFile: "Remove the file" => "ファイルを削除する"
// pe.searchMode: "Search Mode" => "検索モード"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "下の「質問を追加」ボタンをクリックして、フォームの作成を開始してください。"
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "下の「質問を追加」ボタンをクリックして、ページに新しい要素を追加します。"
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "下の「質問を追加」ボタンをクリックして、パネルに新しい要素を追加します。"
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "下のボタンをクリックして、アップロードする画像を選択してください"
// coloralpha.opacity: "Opacity" => "不透明"
// font.family: "Font family" => "フォントファミリー"
// font.color: "Color" => "色"
// font.placeholderColor: "Placeholder color" => "プレースホルダーの色"
// font.size: "Size" => "大きさ"
// theme.themeName: "Theme" => "テーマ"
// theme.isPanelless: "Question appearance" => "質問の表示設定"
// theme.editorPanel: "Background and corner radius" => "背景と角の半径"
// theme.questionPanel: "Background and corner radius" => "背景と角の半径"
// theme.primaryColor: "Accent color" => "アクセントカラー"
// theme.panelBackgroundTransparency: "Panel background opacity" => "パネル背景の不透明度"
// theme.questionBackgroundTransparency: "Question background opacity" => "質問の背景の不透明度"
// theme.fontSize: "Font size" => "フォントサイズ"
// theme.scale: "Scale" => "規模"
// theme.cornerRadius: "Corner radius" => "コーナR(Corner Radius)"
// theme.pageTitle: "Title font" => "タイトルのフォント"
// theme.pageDescription: "Description font" => "説明フォント"
// theme.questionTitle: "Title font" => "タイトルのフォント"
// theme.questionDescription: "Description font" => "説明フォント"
// theme.editorFont: "Font" => "フォント"
// theme.backgroundOpacity: "Opacity" => "不透明"
// theme.--sjs-font-family: "Font family" => "フォントファミリー"
// theme.--sjs-general-backcolor-dim: "Background color" => "背景色"
// theme.--sjs-primary-backcolor: "Accent background" => "アクセントの背景"
// theme.--sjs-primary-forecolor: "Accent foreground" => "アクセントの前景"
// theme.--sjs-shadow-small: "Shadow effects" => "影の効果"
// theme.--sjs-shadow-inner: "Shadow effects" => "影の効果"
// theme.--sjs-border-default: "Colors" => "色"
// header@header.headerView: "View" => "眺める"
// header@header.logoPosition: "Logo position" => "ロゴの位置"
// header@header.surveyTitle: "Survey title font" => "調査タイトルのフォント"
// header@header.surveyDescription: "Survey description font" => "調査の説明フォント"
// header@header.headerTitle: "Survey title font" => "調査タイトルのフォント"
// header@header.headerDescription: "Survey description font" => "調査の説明フォント"
// header@header.inheritWidthFrom: "Content area width" => "コンテンツ領域の幅"
// header@header.textAreaWidth: "Text width" => "文字幅"
// header@header.backgroundColorSwitch: "Background color" => "背景色"
// header@header.backgroundImage: "Background image" => "背景画像"
// header@header.backgroundImageOpacity: "Opacity" => "不透明"
// header@header.overlapEnabled: "Overlap" => "オーバーラップ"
// header@header.logoPositionX: "Logo position" => "ロゴの位置"
// header@header.titlePositionX: "Title position" => "タイトルの位置"
// header@header.descriptionPositionX: "Description position" => "記述の位置"
// weight.400: "Regular" => "レギュラー"
// weight.600: "Heavy" => "重い"
// weight.700: "Semi-bold" => "半太字"
// weight.800: "Bold" => "ボールド"
// backgroundImageFit.auto: "Auto" => "自動"
// backgroundImageFit.cover: "Cover" => "覆う"
// backgroundImageFit.contain: "Contain" => "含む"
// backgroundImageFit.fill: "Stretch" => "伸ばす"
// backgroundImageFit.tile: "Tile" => "瓦"
// backgroundImageAttachment.fixed: "Fixed" => "付け"
// backgroundImageAttachment.scroll: "Scroll" => "スクロール"
// headerView.basic: "Basic" => "基本的な"
// headerView.advanced: "Advanced" => "アドバンスド"
// inheritWidthFrom.survey: "Same as survey" => "調査と同じ"
// inheritWidthFrom.container: "Fit to container" => "コンテナにフィット"
// backgroundColorSwitch.none: "None" => "何一つ"
// backgroundColorSwitch.accentColor: "Accent color" => "アクセントカラー"
// backgroundColorSwitch.custom: "Custom" => "習慣"
// colorPalette.light: "Light" => "光"
// colorPalette.dark: "Dark" => "暗い"
// isPanelless.false: "Default" => "デフォルト"
// isPanelless.true: "Without Panels" => "パネルなし"
// theme.cornerRadius: "Corner radius" => "コーナR(Corner Radius)"
// theme.fontFamily: "Font family" => "フォントファミリー"
// theme.fontWeightRegular: "Regular" => "レギュラー"
// theme.fontWeightHeavy: "Heavy" => "重い"
// theme.fontWeightSemiBold: "Semi-bold" => "半太字"
// theme.fontWeightBold: "Bold" => "ボールド"
// theme.color: "Color" => "色"
// theme.placeholderColor: "Placeholder color" => "プレースホルダーの色"
// theme.size: "Size" => "大きさ"
// theme.opacity: "Opacity" => "不透明"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "「検索」..."
// ed.toolboxNoResultsFound: "No results found" => "結果が見つかりませんでした"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "タブ タイトルのプレースホルダー"
// theme.--sjs-special-red: "Error messages" => "エラーメッセージ"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "タブ タイトル パターンが意味のある値を生成しない場合に適用されるタブ タイトルのフォールバック テキスト。"
// theme.fontColor: "Font color" => "フォントの色"
// theme.backgroundColor: "Background color" => "背景色"
// pe.questionTitleWidth: "Question title width" => "質問タイトルの幅"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "ファイルを選択するか、ファイルリンクを貼り付けます..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "例:200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "質問タイトルが質問ボックスの左側に配置されている場合に、質問タイトルの幅を一定に設定します。CSS 値 (px、%、in、pt など) を受け入れます。"
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "質問タイトルが質問ボックスの左側に配置されている場合に、質問タイトルの幅を一定に設定します。CSS 値 (px、%、in、pt など) を受け入れます。"
// pe.commentAreaRows: "Comment area height (in lines)" => "コメント領域の高さ (行単位)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "質問コメントのテキスト領域に表示される行数を設定します。入力がより多くの行を占めると、スクロールバーが表示されます。"


/***/ }),

/***/ "./src/localization/korean.ts":
/*!************************************!*\
  !*** ./src/localization/korean.ts ***!
  \************************************/
/*! exports provided: koreanStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "koreanStrings", function() { return koreanStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var koreanStrings = {
    // survey templates
    survey: {
        edit: "편집",
        externalHelpLink: "설문조사를 만드는 방법을 보고 알아보세요.",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "왼쪽 도구상자에서 질문을 여기에 놓으십시오.",
        addLogicItem: "설문 조사의 흐름을 사용자 지정하는 규칙을 만듭니다.",
        copy: "복사",
        duplicate: "복사하다",
        addToToolbox: "도구상자에 추가",
        deletePanel: "패널 삭제",
        deleteQuestion: "질문 삭제",
        convertTo: "다음으로 변경",
        drag: "항목 끌어오기",
    },
    // Creator tabs
    tabs: {
        preview: "테스트 설문지",
        theme: "테마",
        translation: "번역",
        designer: "설문지 디자인",
        editor: "JSON 편집기",
        logic: "논리학"
    },
    // Question types
    qt: {
        default: "기본값",
        checkbox: "체크박스",
        comment: "설명",
        imagepicker: "이미지 선택기",
        ranking: "순위",
        image: "이미지",
        dropdown: "드롭다운",
        tagbox: "다중 선택 드롭다운",
        file: "파일",
        html: "HTML",
        matrix: "행렬 (단일 선택)",
        matrixdropdown: "행렬 (복수 선택)",
        matrixdynamic: "행렬 (동적 행)",
        multipletext: "텍스트 상자 그룹",
        panel: "패널",
        paneldynamic: "패널 (동적 패널)",
        radiogroup: "라디오 그룹",
        rating: "등급",
        text: "텍스트 상자",
        boolean: "불린(boolean)",
        expression: "표현식",
        signaturepad: "서명",
        buttongroup: "단추 그룹"
    },
    toolboxCategories: {
        general: "일반",
        choice: "선택 질문",
        text: "텍스트 입력 질문",
        containers: "컨테이너",
        matrix: "행렬 질문",
        misc: "기타"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "기본값({0})",
        survey: "설문지",
        settings: "설정",
        settingsTooltip: "설정 열기",
        surveySettings: "설문조사 설정",
        surveySettingsTooltip: "설문조사 설정",
        themeSettings: "테마 설정",
        themeSettingsTooltip: "테마 설정",
        showPanel: "패널 표시",
        hidePanel: "패널 숨기기",
        prevSelected: "이전 선택",
        nextSelected: "다음을 선택합니다",
        prevFocus: "포커스 이전",
        nextFocus: "다음 초점",
        surveyTypeName: "조사",
        pageTypeName: "페이지",
        panelTypeName: "패널",
        questionTypeName: "질문",
        columnTypeName: "열",
        addNewPage: "새 페이지 추가",
        moveRight: "오른쪽으로 스크롤",
        moveLeft: "왼쪽으로 스크롤",
        deletePage: "페이지 삭제",
        editPage: "페이지 편집",
        edit: "편집",
        newPageName: "페이지",
        newQuestionName: "질문",
        newPanelName: "패널",
        newTextItemName: "문자 메시지",
        defaultV2Theme: "기본값",
        modernTheme: "현대의",
        defaultTheme: "기본값(레거시)",
        testSurveyAgain: "테스트 설문지 다시하기",
        testSurveyWidth: "설문지 너비: ",
        navigateToMsg: "다음으로 이동해야 했습니다.",
        saveSurvey: "설문지 저장",
        saveSurveyTooltip: "설문조사 저장",
        saveTheme: "테마 저장",
        saveThemeTooltip: "테마 저장",
        jsonHideErrors: "오류 숨기기",
        jsonShowErrors: "오류 표시",
        undo: "실행 취소",
        redo: "복원",
        undoTooltip: "마지막 변경 사항 실행 취소",
        redoTooltip: "변경 내용 다시 실행",
        showMoreChoices: "더 보기",
        showLessChoices: "간략하게 표시",
        copy: "복사",
        cut: "삭감",
        paste: "붙여넣기",
        copyTooltip: "클립보드에 선택 항목 복사",
        cutTooltip: "선택 영역을 클립보드로 잘라내기",
        pasteTooltip: "클립보드에서 붙여넣기",
        options: "옵션",
        generateValidJSON: "JSON 데이터 생성",
        generateReadableJSON: "생성 JSON 데이터 읽기",
        toolbox: "도구상자",
        "property-grid": "속성",
        toolboxFilteredTextPlaceholder: "검색하려면 입력...",
        toolboxNoResultsFound: "결과를 찾을 수 없습니다.",
        propertyGridFilteredTextPlaceholder: "검색하려면 입력...",
        propertyGridNoResultsFound: "결과를 찾을 수 없습니다.",
        correctJSON: "JSON 데이터를 수정하십시오.",
        surveyResults: "설문 결과: ",
        surveyResultsTable: "테이블로",
        surveyResultsJson: "JSON으로",
        resultsTitle: "질문 제목",
        resultsName: "질문 이름",
        resultsValue: "답변 값",
        resultsDisplayValue: "표시 값",
        modified: "수정됨",
        saving: "저장중",
        saved: "저장됨",
        propertyEditorError: "오류",
        saveError: "오류! 편집기 컨텐츠는 저장되지 않습니다.",
        translationPropertyGridTitle: "언어 설정",
        themePropertyGridTitle: "테마 설정",
        translationLanguages: "언어들",
        translationDeleteLanguage: "이 언어에 대한 모든 문자열을 삭제하시겠습니까?",
        translationAddLanguage: "번역할 언어 선택",
        translationShowAllStrings: "모든 문자열",
        translationShowUsedStringsOnly: "사용된 문자열만",
        translationShowAllPages: "모든 페이지",
        translationNoStrings: "번역할 문자열이 없습니다. 필터를 교체하십시오.",
        translationExportToSCVButton: "CSV로 내보내기",
        translationImportFromSCVButton: "CSV에서 가져오기",
        translateUsigAI: "모두 자동 번역",
        translateUsigAIFrom: "언어 선택(원문-번역): ",
        translationDialogTitle: "번역되지 않은 문자열",
        translationMergeLocaleWithDefault: "{0} 기본 로캘과 병합",
        translationPlaceHolder: "번역...",
        translationSource: "근원: ",
        translationTarget: "과녁: ",
        themeExportButton: "수출",
        themeImportButton: "수입",
        surveyJsonExportButton: "수출",
        surveyJsonImportButton: "수입",
        surveyJsonCopyButton: "클립보드에 복사",
        themeResetButton: "테마 설정을 기본값으로 재설정",
        themeResetConfirmation: "테마를 재설정 하시겠습니까? 모든 사용자 지정이 손실됩니다.",
        themeResetConfirmationOk: "예, 테마를 재설정합니다.",
        bold: "대담한",
        italic: "이탤릭체",
        underline: "밑줄",
        addNewQuestion: "질문 추가",
        selectPage: "페이지 선택...",
        carryForwardChoicesCopied: "선택 항목은 다음에서 복사됩니다.",
        choicesLoadedFromWebText: "선택 항목은 웹 서비스에서 로드됩니다.",
        choicesLoadedFromWebLinkText: "설정으로 바로 가기",
        choicesLoadedFromWebPreviewTitle: "로드된 선택 옵션 미리보기",
        htmlPlaceHolder: "HTML 콘텐츠가 여기에 있습니다.",
        panelPlaceHolder: "도구 상자에서 질문을 삭제하세요.",
        surveyPlaceHolder: "설문 조사가 비어 있습니다. 도구 상자에서 요소를 드래그하거나 아래 버튼을 클릭합니다.",
        pagePlaceHolder: "페이지가 비어 있습니다. 도구 상자에서 요소를 드래그하거나 아래 버튼을 클릭합니다.",
        imagePlaceHolder: "여기에 이미지를 끌어다 놓거나 아래 버튼을 클릭하고 업로드할 이미지를 선택하세요.",
        surveyPlaceHolderMobile: "아래의 \"질문 추가\" 버튼을 클릭하여 양식 작성을 시작하십시오.",
        pagePlaceHolderMobile: "아래의 \"질문 추가\" 버튼을 클릭하여 페이지에 새 요소를 추가하세요.",
        panelPlaceHolderMobile: "아래의 \"질문 추가\" 버튼을 클릭하여 패널에 새 요소를 추가합니다.",
        imagePlaceHolderMobile: "아래 버튼을 클릭하고 업로드할 이미지를 선택하세요.",
        imageChooseImage: "이미지 선택",
        addNewTypeQuestion: "{0} 추가",
        chooseLogoPlaceholder: "[로고]",
        choices_Item: "항목 ",
        selectFile: "파일 선택",
        removeFile: "파일 제거",
        lg: {
            addNewItem: "새 규칙 추가",
            empty_tab: "설문 조사의 흐름을 사용자 지정하는 규칙을 만듭니다.",
            page_visibilityName: "페이지 표시(숨기기)",
            page_enableName: "사용(사용 안 함) 페이지",
            page_requireName: "페이지를 필수로 설정",
            panel_visibilityName: "표시(숨기기) 패널",
            panel_enableName: "활성화(비활성화) 패널",
            panel_requireName: "페이지를 필수로 설정",
            question_visibilityName: "질문 표시(숨기기)",
            question_enableName: "사용(사용 안 함) 질문",
            question_requireName: "질문 필수 항목 만들기",
            question_resetValueName: "질문 값 재설정",
            question_setValueName: "질문 값 설정",
            column_visibilityName: "열 표시(숨기기)",
            column_enableName: "사용(사용 안 함) 열",
            column_requireName: "열을 필수로 설정",
            column_resetValueName: "열 값 재설정",
            column_setValueName: "열 값 설정",
            trigger_completeName: "설문 조사 완료",
            trigger_setvalueName: "정답 설정",
            trigger_copyvalueName: "답변 복사",
            trigger_skipName: "질문으로 건너뛰기",
            trigger_runExpressionName: "표현식 실행",
            completedHtmlOnConditionName: "\"설문조사 완료\" 페이지 마크업 설정",
            page_visibilityDescription: "논리 표현식이 true를 반환할 때 페이지가 표시되도록 합니다. 그렇지 않으면 보이지 않게 유지하십시오.",
            panel_visibilityDescription: "논리 표현식이 true를 반환할 때 패널이 표시되도록 합니다. 그렇지 않으면 보이지 않게 유지하십시오.",
            panel_enableDescription: "패널과 그 안의 모든 요소는 논리 표현식이 true를 반환할 때 활성화됩니다. 그렇지 않으면 비활성화 상태로 유지하십시오.",
            question_visibilityDescription: "논리 표현식이 true를 반환할 때 질문을 표시합니다. 그렇지 않으면 보이지 않게 유지하십시오.",
            question_enableDescription: "논리 표현식이 true를 반환할 때 질문을 활성화합니다. 그렇지 않으면 비활성화 상태로 유지하십시오.",
            question_requireDescription: "논리 표현식이 true를 반환할 때 질문이 필요합니다.",
            trigger_completeDescription: "논리 표현식이 true를 반환하면 설문 조사가 완료되고 최종 사용자에게 '감사 페이지'가 표시됩니다.",
            trigger_setvalueDescription: "논리식에 사용된 질문 값이 변경되고 논리식이 true를 반환하면 값이 선택한 질문으로 설정됩니다.",
            trigger_copyvalueDescription: "논리 표현식에 사용된 질문 값이 변경되고 논리 표현식이 true를 반환하면 선택한 한 질문의 값이 선택한 다른 질문에 복사됩니다.",
            trigger_skipDescription: "논리 표현식이 true를 반환하면 설문 조사는 선택한 질문으로 건너 뜁니다.",
            trigger_runExpressionDescription: "논리 표현식이 true를 반환하면 사용자 지정 표현식이 수행됩니다. 선택적으로 이 표현식 결과를 선택한 질문으로 설정할 수 있습니다",
            completedHtmlOnConditionDescription: "논리 표현식이 true를 반환하면 'Thank you page'의 기본 텍스트가 지정된 텍스트로 변경됩니다.",
            itemExpressionText: "표현식: '{0}'가 true를 반환하는 경우",
            itemEmptyExpressionText: "새 규칙",
            page_visibilityText: "페이지 {0} 표시",
            panel_visibilityText: "패널 {0} 표시",
            panel_enableText: "패널을 활성화{0}",
            question_visibilityText: "질문 {0} 표시",
            question_enableText: "질문 {0} 사용 설정",
            question_requireText: "질문 {0} 필수",
            question_resetValueText: "질문에 대한 재설정 값: {0}",
            question_setValueText: "할당 값: {1} 질문: {0}",
            column_visibilityText: "질문의 열 {0} {1} 표시",
            column_enableText: "질문의 열 {0} {1} 사용하도록 설정",
            column_requireText: "질문의 열 {0} {1} 필수",
            column_resetValueText: "열의 셀 값 재설정: {0}",
            column_setValueText: "셀 값 할당 : {1} 열 : {0}",
            setValueExpressionPlaceholder: " 결과가 대상 질문에 할당되는 식입니다.",
            trigger_completeText: "조사가 완료됩니다",
            trigger_setvalueText: "질문으로 설정: {0} 값 {1}",
            trigger_setvalueEmptyText: "명확한 질문 값: {0}",
            trigger_copyvalueText: "질문으로 복사: 질문 {1}의 {0} 값",
            trigger_skipText: "설문 조사 질문으로 건너 뛰기 {0}",
            trigger_runExpressionText1: "실행 식: '{0}'",
            trigger_runExpressionText2: " 그 결과에 의문을 제기하십시오 : {0}",
            completedHtmlOnConditionText: "'감사 페이지'에 대한 사용자 지정 텍스트를 표시합니다.",
            showAllQuestions: "모든 질문",
            showAllActionTypes: "모든 작업 유형",
            conditions: "조건",
            actions: "작업",
            expressionEditorTitle: "조건 정의",
            actionsEditorTitle: "작업 정의",
            deleteAction: "삭제 작업",
            addNewAction: "작업 추가",
            selectedActionCaption: "작업 선택...",
            expressionInvalid: "논리 표현식이 비어 있거나 올바르지 않습니다. 수정해 주세요.",
            noActionError: "하나 이상의 작업을 추가하십시오.",
            actionInvalid: "귀하의 행동에서 문제를 해결하십시오.",
            uncompletedRule_title: "논리적 규칙이 불완전합니다.",
            uncompletedRule_text: "일부 논리적 규칙을 완료하지 않았습니다. 지금 탭을 나가면 변경 내용이 손실됩니다. 변경을 완료하지 않고 탭을 종료하시겠습니까?",
            uncompletedRule_apply: "예",
            uncompletedRule_cancel: "아니요, 규칙을 완료하고 싶습니다."
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "패널 이름",
            title: "패널 제목",
            description: "패널 설명",
            visibleIf: "다음과 같은 경우 패널을 표시합니다.",
            requiredIf: "다음과 같은 경우 패널을 필수로 만듭니다.",
            questionsOrder: "패널 내의 질문 순서",
            page: "상위 페이지",
            startWithNewLine: "새 줄에 패널 표시",
            state: "패널 축소 상태",
            width: "인라인 패널 너비",
            minWidth: "최소 패널 너비",
            maxWidth: "최대 패널 너비",
            showNumber: "숫자 패널"
        },
        paneldynamic: {
            name: "패널 이름",
            title: "패널 제목",
            description: "패널 설명",
            visibleIf: "다음과 같은 경우 패널을 표시합니다.",
            requiredIf: "다음과 같은 경우 패널을 필수로 만듭니다.",
            page: "패널을 페이지로 이동",
            startWithNewLine: "새 줄에 패널 표시",
            state: "패널 축소 상태",
            width: "인라인 패널 너비",
            minWidth: "최소 패널 너비",
            maxWidth: "최대 패널 너비",
            confirmDelete: "패널 삭제 확인",
            templateDescription: "패널 설명 패턴",
            templateTitle: "패널 제목 패턴",
            noEntriesText: "빈 패널 텍스트",
            templateTabTitle: "탭 제목 패턴",
            tabTitlePlaceholder: "탭 제목 자리 표시자",
            templateVisibleIf: "다음과 같은 경우 개별 패널을 표시합니다.",
            hideNumber: "패널 번호 숨기기",
            titleLocation: "패널 제목 정렬",
            descriptionLocation: "패널 설명 정렬",
            templateTitleLocation: "질문 제목 정렬",
            templateErrorLocation: "오류 메시지 맞춤",
            newPanelPosition: "새 패널 위치",
            keyName: "다음 질문에서 중복 응답 방지"
        },
        question: {
            name: "질문 이름",
            title: "질문 제목",
            description: "질문 설명",
            visibleIf: "다음과 같은 경우 질문을 표시합니다.",
            requiredIf: "다음과 같은 경우 질문을 필수로 만듭니다.",
            page: "상위 페이지",
            state: "질문 상자 축소 상태",
            hideNumber: "질문 번호 숨기기",
            titleLocation: "질문 제목 정렬",
            descriptionLocation: "질문 설명 정렬",
            errorLocation: "오류 메시지 맞춤",
            indent: "내부 들여쓰기 늘리기",
            width: "인라인 질문 너비",
            minWidth: "최소 질문 너비",
            maxWidth: "최대 질문 너비",
            textUpdateMode: "입력 필드 값 업데이트"
        },
        signaturepad: {
            signatureWidth: "서명 영역 너비",
            signatureHeight: "서명 영역 높이",
            signatureAutoScaleEnabled: "서명 영역 자동 크기 조정",
            showPlaceholder: "자리 표시자 표시",
            placeholder: "자리 표시자 텍스트",
            placeholderReadOnly: "읽기 전용 또는 미리 보기 모드의 자리 표시자 텍스트",
            allowClear: "서명 영역 내에 지우기 단추 표시",
            penMinWidth: "최소 펜 너비",
            penMaxWidth: "최대 펜 너비",
            penColor: "획 색상"
        },
        comment: {
            rows: "입력 필드 높이(줄)"
        },
        showQuestionNumbers: "질문 번호 표시",
        questionStartIndex: "질문 시작 색인 (1, 2 또는 'A', 'a')",
        expression: {
            name: "표현식 이름",
            title: "표현식 제목",
            description: "표현식 설명",
            expression: "식"
        },
        trigger: {
            expression: "식"
        },
        calculatedvalue: {
            expression: "식"
        },
        // survey templates
        survey: {
            title: "타이틀",
            description: "설문조사 설명"
        },
        page: {
            name: "페이지 이름",
            title: "타이틀",
            description: "페이지 설명",
            visibleIf: "다음과 같은 경우 페이지를 표시합니다.",
            requiredIf: "다음과 같은 경우 페이지를 필수로 만듭니다.",
            maxTimeToFinish: "페이지 완료 시간 제한(초)",
            questionsOrder: "페이지의 질문 순서"
        },
        matrixdropdowncolumn: {
            name: "열 이름",
            title: "열 제목",
            isUnique: "중복 응답 방지",
            width: "열 너비",
            minWidth: "최소 열 너비",
            rows: "입력 필드 높이(줄)",
            visibleIf: "다음과 같은 경우 열을 표시합니다.",
            requiredIf: "다음과 같은 경우 열을 필수로 만듭니다.",
            showInMultipleColumns: "별도의 열에 있는 각 옵션"
        },
        multipletextitem: {
            name: "이름",
            title: "타이틀"
        },
        masksettings: {
            saveMaskedValue: "설문조사 결과에 마스킹된 값 저장"
        },
        patternmask: {
            pattern: "값 패턴"
        },
        datetimemask: {
            min: "최솟값",
            max: "최대값"
        },
        numericmask: {
            allowNegativeValues: "음수 값 허용",
            thousandsSeparator: "1000 단위 구분 기호",
            decimalSeparator: "소수 구분 기호",
            precision: "값 정밀도",
            min: "최솟값",
            max: "최대값"
        },
        currencymask: {
            prefix: "통화 접두사",
            suffix: "통화 접미사"
        },
        imageHeight: "이미지 높이",
        imageWidth: "이미지 너비",
        valueName: "값 이름",
        rateDescriptionLocation: "레이블 정렬",
        size: "입력 필드 크기(문자)",
        cellErrorLocation: "셀 오류 메시지 맞춤",
        apply: "적용",
        ok: "확인",
        save: "구해내다",
        clear: "맑다",
        saveTooltip: "구해내다",
        cancel: "취소",
        set: "집합",
        reset: "재설정",
        change: "잔돈",
        refresh: "리프레쉬",
        close: "닫기",
        delete: "삭제",
        add: "더하다",
        addNew: "새로 만들기",
        addItem: "항목을 추가하려면 클립하십시오.",
        removeItem: "항목을 제거하려면 클릭하세요...",
        dragItem: "항목을 드래그합니다",
        addOther: "다른",
        addSelectAll: "모두 선택",
        addNone: "없음",
        removeAll: "모두 삭제",
        edit: "편집",
        back: "저장하지 않고 반환",
        backTooltip: "저장하지 않고 반환",
        saveAndBack: "저장 및 반환",
        saveAndBackTooltip: "저장 및 반환",
        doneEditing: "수행",
        editChoices: "선택사항 편집",
        showChoices: "선택 항목 표시",
        move: "이동",
        empty: "<비어있음>",
        emptyValue: "값이 비어 있습니다.",
        fastEntry: "빠른 입력",
        fastEntryNonUniqueError: "'{0}' 값은 고유하지 않습니다.",
        fastEntryChoicesCountError: "항목 수를 {0}개에서 {1}개로 제한하십시오.",
        fastEntryChoicesMinCountError: "최소 {0} 항목을 입력하십시오.",
        fastEntryPlaceholder: "다음 형식으로 데이터를 설정할 수 있습니다.\nvalue1|텍스트\n값2",
        formEntry: "양식 입력",
        testService: "서비스 테스트",
        itemSelectorEmpty: "요소를 선택해 주세요",
        conditionActionEmpty: "작업을 선택하십시오.",
        conditionSelectQuestion: "질문 선택...",
        conditionSelectPage: "페이지 선택...",
        conditionSelectPanel: "패널 선택...",
        conditionValueQuestionTitle: "값을 입력하거나 선택하십시오.",
        aceEditorHelp: "ctrl+space를 눌러 완성된 수식에 대한 힌트를 얻으십시오",
        aceEditorRowTitle: "현재 행",
        aceEditorPanelTitle: "현재 패널",
        showMore: "자세한 내용은 설명서를 확인하십시오.",
        assistantTitle: "유효 질문:",
        cellsEmptyRowsColumns: "최소한 하나의 열 또는 행이 있어야 합니다.",
        showPreviewBeforeComplete: "설문조사를 제출하기 전에 답변 미리 보기",
        overridingPropertyPrefix: "설정 기준 ",
        resetToDefaultCaption: "재설정",
        propertyIsEmpty: "값을 입력하십시오",
        propertyIsNoUnique: "고유한 값을 입력하십시오.",
        propertyNameIsNotUnique: "고유한 이름을 입력하십시오.",
        propertyNameIsIncorrect: "예약어를 사용하지 마십시오: \"item\", \"choice\", \"panel\", \"row\".",
        listIsEmpty: "아직 추가된 항목이 없습니다.",
        "listIsEmpty@choices": "선택 항목이 아직 추가되지 않았습니다",
        "listIsEmpty@columns": "아직 열이 없습니다.",
        "listIsEmpty@rows": "아직 행이 없습니다.",
        "listIsEmpty@validators": "아직 유효성 검사 규칙이 없습니다.",
        "listIsEmpty@calculatedValues": "아직 맞춤 변수가 없습니다.",
        "listIsEmpty@triggers": "아직 트리거가 없습니다.",
        "listIsEmpty@navigateToUrlOnCondition": "아직 링크가 없습니다.",
        "addNew@choices": "선택 항목 추가",
        "addNew@columns": "새 열 추가",
        "addNew@rows": "새 행 추가",
        "addNew@validators": "새 규칙 추가",
        "addNew@calculatedValues": "새 변수 추가",
        "addNew@triggers": "새 트리거 추가",
        "addNew@navigateToUrlOnCondition": "새 URL 추가",
        expressionIsEmpty: "식이 비어 있습니다.",
        value: "값",
        text: "텍스트",
        rowid: "행 ID",
        imageLink: "이미지 또는 동영상 URL",
        columnEdit: "열 편집: {0}",
        itemEdit: "항목 편집: {0}",
        url: "URL",
        path: "경로",
        choicesbyurl: {
            url: "웹 서비스의 URL",
            valueName: "다음 JSON 필드에서 값 가져오기"
        },
        titleName: "제목 이름",
        imageLinkName: "다음 JSON 필드에서 이미지 URL을 가져옵니다.",
        allowEmptyResponse: "빈 응답 허용",
        titlePlaceholder: "타이틀",
        surveyTitlePlaceholder: "설문조사 제목",
        pageTitlePlaceholder: "페이지 {num}",
        descriptionPlaceholder: "묘사",
        surveyDescriptionPlaceholder: "묘사",
        pageDescriptionPlaceholder: "묘사",
        textWrapEnabled: "줄 바꿈 선택",
        showOtherItem: "다른 항목이 있습니다",
        otherText: "기타 항목 텍스트",
        showNoneItem: "없음 옵션 허용",
        showRefuseItem: "응답 거부 옵션 허용",
        showDontKnowItem: "모름 옵션 허용",
        noneText: "없음 옵션 텍스트",
        showSelectAllItem: "모두 선택 옵션 허용",
        selectAllText: "모두 선택 옵션 텍스트",
        choicesMin: "자동 생성된 항목의 최소값",
        choicesMax: "자동 생성된 항목의 최대값",
        choicesStep: "자동 생성된 항목에 대한 단계",
        name: "이름",
        title: "제목",
        cellType: "셀 유형",
        colCount: "열 개수",
        choicesOrder: "항목 순서 선택",
        visible: "보입니까??",
        isRequired: "필수입니까?",
        markRequired: "필요에 따라 표시",
        removeRequiredMark: "필요한 표시를 제거하십시오",
        isAllRowRequired: "모든 행에 대한 응답 필요",
        eachRowUnique: "행의 중복 응답 방지",
        requiredErrorText: "\"필수\" 오류 메시지",
        startWithNewLine: "새 줄로 시작하겠습니까?",
        rows: "행 수",
        cols: "열",
        placeholder: "입력 자리 표시자 ",
        showPreview: "이미지 미리보기가 표시됩니까?",
        storeDataAsText: "파일 내용을 JSON 결과에 텍스트로 저장",
        maxSize: "최대 파일 크기(bytes)",
        rowCount: "행 수",
        columnLayout: "열 위치",
        addRowLocation: "행 버튼 위치 추가",
        transposeData: "행을 열로 바꾸기",
        addRowText: "행 버튼 텍스트 추가",
        removeRowText: "행 버튼 텍스트 제거",
        rateMin: "최소 요금 값",
        rateMax: "최대 속도 값",
        rateStep: "속도 단계",
        minRateDescription: "최소 설명 길이",
        maxRateDescription: "최대 설명 길이",
        inputType: "입력 유형",
        optionsCaption: "옵션 캡션",
        defaultValue: "기본값",
        cellsDefaultRow: "기본 셀 텍스트",
        surveyEditorTitle: "설문지 설정 편집",
        qEditorTitle: "편집: {0}",
        maxLength: "최대 길이(문자)",
        buildExpression: "체격",
        editExpression: "편집하다",
        and: "그리고",
        or: "또는",
        remove: "제거하다",
        addCondition: "조건 추가",
        emptyLogicPopupMessage: "질문을 선택하여 조건 구성을 시작합니다.",
        if: "면",
        then: "그러면",
        setToName: "대상 질문",
        fromName: "답변을 복사할 질문",
        gotoName: "건너뛸 질문",
        ruleIsNotSet: "규칙이 올바르지 않습니다.",
        includeIntoResult: "설문조사 결과에 포함",
        showTitle: "제목 표시/숨김",
        expandCollapseTitle: "제목 확장/축소",
        locale: "기본 언어",
        simulator: "장치 유형 선택",
        landscapeOrientation: "가로 방향으로 전환",
        portraitOrientation: "세로 방향으로 전환",
        mode: "모드(편집/읽기전용)",
        clearInvisibleValues: "보이지 않는 값 지우기",
        cookieName: "쿠키 이름(로컬에서 설문 조사를 두 번 사용하지 않도록 설정)",
        sendResultOnPageNext: "다음 페이지에서 설문 조사 결과 보내기",
        storeOthersAsComment: "다른 사용자의 값을 별도의 필드에 저장",
        showPageTitles: "페이지 제목 표시",
        showPageNumbers: "페이지 번호 표시",
        pagePrevText: "이전 페이지 버튼 텍스트",
        pageNextText: "다음 페이지 버튼 텍스트",
        completeText: "완료 버튼 텍스트",
        previewText: "답변 미리보기 버튼 텍스트",
        editText: "답변 편집 단추 텍스트",
        startSurveyText: "시작 버튼 텍스트",
        showNavigationButtons: "탐색 버튼 표시 (기본 탐색)",
        showPrevButton: "이전 버튼 표시 (사용자가 이전 페이지로 돌아갈 수 있음)",
        firstPageIsStarted: "설문지의 첫 번째 페이지는 시작 페이지입니다",
        showCompletedPage: "끝 부분에 완료된 페이지 표시 (완료된 HTML)",
        goNextPageAutomatic: "모든 질문에 응답 후 자동으로 다음 페이지로 이동",
        allowCompleteSurveyAutomatic: "설문조사 자동 완성",
        showProgressBar: "진행률 막대 표시",
        questionTitleLocation: "질문 제목 위치",
        questionTitleWidth: "질문 제목 너비",
        requiredText: "질문에 필요한 기호",
        questionTitleTemplate: "질문 제목 템플릿입니다. 기본값: '{no}. {require} {title}'",
        questionErrorLocation: "질문 위치 오류",
        focusFirstQuestionAutomatic: "페이지 변경시 첫 번째 질문에 초점",
        questionsOrder: "페이지의 요소 순서",
        maxTimeToFinish: "설문 조사를 마칠 수있는 최대 시간",
        maxTimeToFinishPage: "설문 조사에서 페이지를 마칠 수있는 최대 시간",
        showTimerPanel: "타이머 패널 표시",
        showTimerPanelMode: "타이머 패널 모드 표시",
        renderMode: "렌더링 모드",
        allowAddPanel: "패널 추가 허용",
        allowRemovePanel: "패널 제거 허용",
        panelAddText: "패널 텍스트 추가",
        panelRemoveText: "패널 텍스트 삭제",
        isSinglePage: "한 페이지에 모든 요소 표시",
        html: "HTML 마크업",
        setValue: "대답",
        dataFormat: "이미지 형식",
        allowAddRows: "행 추가 허용",
        allowRemoveRows: "행 제거 허용",
        allowRowsDragAndDrop: "행 끌어서 놓기 허용",
        responsiveImageSizeHelp: "정확한 이미지 너비 또는 높이를 지정하는 경우에는 적용되지 않습니다.",
        minImageWidth: "최소 이미지 너비",
        maxImageWidth: "최대 이미지 너비",
        minImageHeight: "최소 이미지 높이",
        maxImageHeight: "최대 이미지 높이",
        minValue: "최소값",
        maxValue: "최대값",
        minLength: "최소 길이(문자)",
        allowDigits: "숫자 허용",
        minCount: "최소 개수",
        maxCount: "최대 개수",
        regex: "정규식",
        surveyvalidator: {
            text: "오류 메시지",
            expression: "유효성 검사 표현식"
        },
        totalText: "전체 행 텍스트",
        totalType: "합계 유형",
        totalExpression: "총 표현식",
        totalDisplayStyle: "총액 표시 스타일",
        totalCurrency: "통화",
        totalFormat: "서식이 지정된 문자열",
        logo: "로고(URL 또는 base64로 인코딩된 문자열)",
        questionsOnPageMode: "설문조사 구조",
        maxTextLength: "최대 답변 길이(문자 단위)",
        maxOthersLength: "최대 주석 길이(문자)",
        commentAreaRows: "주석 영역 높이(줄)",
        autoGrowComment: "필요한 경우 주석 영역 자동 확장",
        allowResizeComment: "사용자가 텍스트 영역의 크기를 조정할 수 있도록 허용",
        textUpdateMode: "텍스트 질문 값 업데이트",
        maskType: "입력 마스크 유형",
        maskTypes: {
            none: "없음",
            patternmask: "무늬",
            numericmask: "숫자",
            datetimemask: "날짜 및 시간",
            currencymask: "통화"
        },
        focusOnFirstError: "첫 번째 오답에 포커스 설정",
        checkErrorsMode: "유효성 검사 실행",
        navigateToUrl: "URL로 이동합니다.",
        navigateToUrlOnCondition: "동적 URL",
        completedBeforeHtml: "사용자가 이미 이 설문조사를 작성했는지 여부를 표시하는 마크업",
        completedHtml: "설문조사 완료 페이지 마크업",
        completedHtmlOnCondition: "동적 설문조사 완료 페이지 마크업",
        loadingHtml: "측량 모델이 로드되는 동안 표시할 마크업",
        commentText: "주석 영역 텍스트",
        autocomplete: "자동 완성 유형",
        labelTrue: "\"True\" 레이블",
        labelFalse: "\"거짓\" 레이블",
        allowClear: "지우기 단추 표시",
        searchMode: "검색 모드",
        displayStyle: "값 표시 스타일",
        format: "서식이 지정된 문자열",
        maximumFractionDigits: "최대 소수 자릿수",
        minimumFractionDigits: "최소 소수 자릿수",
        useGrouping: "그룹화 구분 기호 표시",
        allowMultiple: "여러 파일 허용",
        allowImagesPreview: "이미지 미리보기",
        acceptedTypes: "허용되는 파일 형식",
        waitForUpload: "업로드가 완료될 때까지 기다리세요",
        needConfirmRemoveFile: "파일 삭제 확인",
        detailPanelMode: "세부 정보 패널 위치",
        minRowCount: "최소 행 개수",
        maxRowCount: "최대 행 개수",
        confirmDelete: "행 삭제 확인",
        confirmDeleteText: "확인 메시지",
        panelCount: "초기 패널 수",
        minPanelCount: "최소 패널 수",
        maxPanelCount: "최대 패널 수",
        panelsState: "내부 패널 확장 상태",
        panelPrevText: "이전 패널 단추 도구 설명",
        panelNextText: "다음 패널 단추 도구 설명",
        showRangeInProgress: "진행률 표시줄 표시",
        panelRemoveButtonLocation: "패널 단추 위치 제거",
        hideIfRowsEmpty: "행이 없는 경우 질문 숨기기",
        hideColumnsIfEmpty: "행이 없는 경우 열 숨기기",
        rateValues: "사용자 지정 요금 값",
        rateCount: "비율 개수",
        autoGenerate: "비율 값을 지정하는 방법은 무엇입니까?",
        hideIfChoicesEmpty: "선택 항목이 없는 경우 질문 숨기기",
        minWidth: "최소 너비(CSS에서 허용하는 값)",
        maxWidth: "최대 너비(CSS에서 허용하는 값)",
        width: "너비(CSS에서 허용하는 값)",
        showHeader: "열 머리글 표시",
        horizontalScroll: "가로 스크롤 막대 표시",
        columnMinWidth: "최소 열 너비(CSS에서 허용하는 값)",
        rowTitleWidth: "행 머리글 너비(CSS에서 허용하는 값)",
        valueTrue: "\"True\" 값",
        valueFalse: "\"False\" 값",
        minErrorText: "\"값이 최소값 미만입니다.\" 오류 메시지",
        maxErrorText: "\"값이 최대값을 초과합니다.\" 오류 메시지",
        otherErrorText: "'빈 댓글' 오류 메시지",
        keyDuplicationError: "\"고유하지 않은 키 값\" 오류 메시지",
        minSelectedChoices: "선택한 최소 선택 항목",
        maxSelectedChoices: "선택한 최대 선택 항목 수",
        showClearButton: "지우기 단추 표시",
        logoWidth: "로고 너비(CSS에서 허용하는 값)",
        logoHeight: "로고 높이(CSS에서 허용하는 값)",
        readOnly: "읽기 전용",
        enableIf: "다음과 같은 경우 편집 가능",
        emptyRowsText: "'행 없음' 메시지",
        separateSpecialChoices: "별도의 특수 선택(없음, 기타, 모두 선택)",
        choicesFromQuestion: "다음 질문에서 선택 항목을 복사합니다.",
        choicesFromQuestionMode: "어떤 선택 항목을 복사해야 합니까?",
        progressBarShowPageTitles: "진행률 표시줄에 페이지 제목 표시",
        progressBarShowPageNumbers: "진행률 표시줄에 페이지 번호 표시",
        showCommentArea: "주석 영역 표시",
        commentPlaceholder: "주석 영역 자리 표시자",
        displayRateDescriptionsAsExtremeItems: "속도 설명을 극한 값으로 표시",
        rowsOrder: "행 순서",
        columnsLayout: "열 레이아웃",
        columnColCount: "중첩된 열 개수",
        correctAnswer: "정답",
        defaultPanelValue: "기본값",
        cells: "셀 텍스트",
        fileInputPlaceholder: "파일 선택 또는 파일 링크 붙여넣기...",
        keyName: "키 열",
        itemvalue: {
            visibleIf: "다음과 같은 경우 옵션을 표시합니다.",
            enableIf: "다음과 같은 경우 옵션을 선택할 수 있도록 합니다."
        },
        "itemvalue@rows": {
            visibleIf: "다음과 같은 경우 행을 표시합니다.",
            enableIf: "다음과 같은 경우 행을 편집 가능하게 만듭니다."
        },
        imageitemvalue: {
            text: "대체 텍스트"
        },
        logoPosition: "로고 위치",
        addLogo: "로고 추가...",
        changeLogo: "로고 변경...",
        logoPositions: {
            none: "로고 제거",
            left: "왼쪽",
            right: "오른쪽",
            top: "맨 위에",
            bottom: "하단에"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "패널 레이아웃"
            },
            general: "일반",
            fileOptions: "옵션",
            html: "Html 편집기",
            columns: "열",
            rows: "행",
            choices: "선택",
            items: "항목",
            visibleIf: "조건 충족시 보기",
            enableIf: "조건 충족시 허용",
            requiredIf: "다음과 같은 경우 필수입니다.",
            rateValues: "길이 값",
            choicesByUrl: "웹에서 선택",
            matrixChoices: "기본 선택",
            multipleTextItems: "텍스트 입력",
            numbering: "번호 매기기",
            validators: "유효성 검사기",
            navigation: "탐색",
            question: "질문",
            pages: "페이지",
            timer: "타이머 / 퀴즈",
            calculatedValues: "계산된 값",
            triggers: "트리거",
            templateTitle: "템플릿 제목",
            totals: "합계",
            logic: "논리학",
            mask: "입력 마스크 설정",
            layout: {
                panel: "레이아웃",
                question: "레이아웃",
                base: "레이아웃"
            },
            data: "데이터",
            validation: "유효성 검사",
            cells: "셀 텍스트",
            showOnCompleted: "설문조사 완료",
            logo: "설문조사 제목의 로고",
            slider: "슬라이더",
            expression: "식",
            questionSettings: "질문 설정",
            header: "머리글",
            background: "배경",
            appearance: "외관",
            others: "다른"
        },
        editProperty: "편집 속성 '{0}'",
        items: "[ 항목: {0} ]",
        choicesVisibleIf: "다음과 같은 경우 선택 항목이 표시됩니다.",
        choicesEnableIf: "다음과 같은 경우 선택 항목을 선택할 수 있습니다.",
        columnsEnableIf: "다음과 같은 경우 열이 표시됩니다.",
        rowsEnableIf: "다음과 같은 경우 행이 표시됩니다.",
        innerIndent: "내부 들여쓰기 추가",
        defaultValueFromLastRow: "마지막 행에서 기본값 가져오기",
        defaultValueFromLastPanel: "마지막 패널에서 기본값 가져 오기",
        enterNewValue: "값을 입력하십시오.",
        noquestions: "설문 조사에는 어떤 질문도 없습니다.",
        createtrigger: "트리거를 만드십시오",
        titleKeyboardAdornerTip: "Enter 버튼을 눌러 편집합니다.",
        keyboardAdornerTip: "항목을 편집하려면 Enter 버튼을 누르고, 항목을 삭제하려면 삭제 버튼을 누르고, 항목을 이동하려면 alt 더하기 화살표 위쪽 또는 아래쪽 화살표를 누릅니다.",
        triggerOn: "트리거 켜기",
        triggerMakePagesVisible: "페이지 표시:",
        triggerMakeQuestionsVisible: "요소 표시:",
        triggerCompleteText: "조건 충족 시 설문 조사를 작성하십시오.",
        triggerNotSet: "트리거가 설정되지 않았습니다.",
        triggerRunIf: "다음 조건 충족 시 실행",
        triggerSetToName: "다음 값 변경: ",
        triggerFromName: "다음에서 값 복사: ",
        triggerRunExpression: "이 표현식을 실행합니다.",
        triggerSetValue: "다음으로 수정: ",
        triggerGotoName: "질문으로 이동",
        triggerIsVariable: "변수를 설문 결과에 넣지 마십시오.",
        triggerRunExpressionEmpty: "올바른 표현식을 입력하십시오.",
        emptyExpressionPlaceHolder: "여기에 표현식을 입력하십시오 ...",
        noFile: "선택한 파일 없음",
        clearIfInvisible: "질문이 숨겨지면 값을 지웁니다",
        valuePropertyName: "값 속성 이름",
        searchEnabled: "검색 사용",
        hideSelectedItems: "선택한 항목 숨기기",
        closeOnSelect: "선택 후 드롭다운을 닫습니다.",
        verticalAlign: "수직 정렬",
        alternateRows: "대체 행",
        columnsVisibleIf: "다음과 같은 경우 열이 표시됩니다.",
        rowsVisibleIf: "다음과 같은 경우 행이 표시됩니다.",
        otherPlaceholder: "주석 영역 자리 표시자",
        filePlaceholder: "파일 자리 표시자 텍스트",
        photoPlaceholder: "사진 자리 표시자 텍스트",
        fileOrPhotoPlaceholder: "파일 또는 사진 자리 표시자 텍스트",
        rateType: "비율 유형",
        url_placeholder: "예: https://api.example.com/books",
        path_placeholder: "예: categories.fiction",
        questionStartIndex_placeholder: "예: a)",
        width_placeholder: "예: 6in",
        minWidth_placeholder: "예: 600px",
        maxWidth_placeholder: "예: 50%",
        imageHeight_placeholder: "자동",
        imageWidth_placeholder: "자동",
        theme: {
            themeName: "주제",
            isPanelless: "질문 모양",
            editorPanel: "배경 및 모서리 반경",
            questionPanel: "배경 및 모서리 반경",
            primaryColor: "강조 색상",
            panelBackgroundTransparency: "패널 배경 불투명도",
            questionBackgroundTransparency: "질문 배경 불투명도",
            fontSize: "글꼴 크기",
            scale: "저울",
            cornerRadius: "코너 반경",
            pageTitle: "제목 글꼴",
            pageDescription: "설명 글꼴",
            questionTitle: "제목 글꼴",
            questionDescription: "설명 글꼴",
            editorFont: "글꼴",
            backgroundOpacity: "불투명도",
            "--sjs-font-family": "글꼴 모음",
            "--sjs-general-backcolor-dim": "배경색",
            "--sjs-primary-backcolor": "강조 배경",
            "--sjs-primary-forecolor": "강조 전경",
            "--sjs-special-red": "오류 메시지",
            "--sjs-shadow-small": "그림자 효과",
            "--sjs-shadow-inner": "그림자 효과",
            "--sjs-border-default": "색상"
        },
        "header@header": {
            headerView: "보기",
            logoPosition: "로고 위치",
            surveyTitle: "설문조사 제목 글꼴",
            surveyDescription: "설문조사 설명 글꼴",
            headerTitle: "설문조사 제목 글꼴",
            headerDescription: "설문조사 설명 글꼴",
            inheritWidthFrom: "콘텐츠 영역 너비",
            textAreaWidth: "텍스트 너비",
            backgroundColorSwitch: "배경색",
            backgroundImage: "배경 이미지",
            backgroundImageOpacity: "불투명도",
            overlapEnabled: "겹침",
            logoPositionX: "로고 위치",
            titlePositionX: "제목 위치",
            descriptionPositionX: "설명 위치"
        }
    },
    // Property values
    pv: {
        "true": "참",
        "false": "거짓",
        file: "로컬 파일",
        camera: "사진기",
        "file-camera": "로컬 파일 또는 카메라",
        inherit: "상속",
        show: "보기",
        hide: "숨기기",
        default: "기본값",
        initial: "초기값",
        random: "무작위",
        collapsed: "축소",
        expanded: "확장",
        none: "없음",
        asc: "오름차순",
        desc: "내림차순",
        indeterminate: "불확정",
        selected: "선택한",
        unselected: "하지 않은",
        decimal: "십진법",
        currency: "통화",
        percent: "퍼센트",
        firstExpanded: "우선 확장",
        off: "꺼짐",
        list: "목록",
        progressTop: "상단 진행률",
        progressBottom: "하단 진행률",
        progressTopBottom: "상하단 진행률",
        tab: "탭",
        horizontal: "가로",
        vertical: "세로",
        top: "위",
        bottom: "아래",
        topBottom: "위아래",
        both: "둘다",
        left: "왼쪽",
        right: "오른쪽",
        center: "중",
        leftRight: "왼쪽 및 오른쪽",
        middle: "중간",
        color: "색",
        date: "날짜",
        datetime: "날짜/시간",
        "datetime-local": "날짜/시간 로컬",
        email: "이메일",
        month: "달",
        number: "수",
        password: "암호",
        range: "레인지",
        tel: "전화",
        text: "문자 메시지",
        time: "시간",
        url: "URL (영문)",
        week: "주",
        hidden: "숨김",
        edit: "편집",
        display: "디스플레이",
        contain: "포함하다",
        cover: "표지",
        fill: "채우다",
        next: "다음",
        last: "지난",
        onComplete: "완료",
        onHidden: "숨김",
        onHiddenContainer: "질문 또는 해당 패널/페이지가 숨겨지는 경우",
        clearInvisibleValues: {
            none: "결코"
        },
        clearIfInvisible: {
            none: "결코"
        },
        inputType: {
            color: "색",
            date: "날짜",
            "datetime-local": "날짜 및 시간",
            email: "이메일",
            month: "달",
            number: "수",
            password: "암호",
            range: "레인지",
            tel: "전화번호",
            text: "문자 메시지",
            time: "시간",
            url: "URL (영문)",
            week: "주"
        },
        all: "모두",
        page: "페이지",
        survey: "설문지",
        onNextPage: "다음 페이지로",
        onValueChanged: "값 변경",
        onValueChanging: "답변이 변경되기 전에",
        questionsOnPageMode: {
            standard: "원래 구조",
            singlePage: "모든 질문을 한 페이지에 표시",
            questionPerPage: "페이지당 단일 질문 표시"
        },
        noPreview: "미리보기 없음",
        showAllQuestions: "모든 질문 표시",
        showAnsweredQuestions: "답변된 질문만 표시",
        pages: "완성된 페이지",
        questions: "답변된 질문",
        requiredQuestions: "필수 질문에 답변했습니다.",
        correctQuestions: "유효한 답변",
        buttons: "완성된 페이지(버튼 UI)",
        underInput: "입력 아래",
        underTitle: "제목 아래",
        onBlur: "흐림 현상",
        onTyping: "입력하는 동안",
        underRow: "행 아래",
        underRowSingle: "행 아래에는 하나의 패널만 표시됩니다",
        auto: "자동",
        showNavigationButtons: {
            none: "숨겨진"
        },
        showTimerPanel: {
            none: "숨겨진"
        },
        showTimerPanelMode: {
            all: "둘다"
        },
        addRowLocation: {
            default: "행렬 레이아웃에 따라 다름"
        },
        panelsState: {
            default: "사용자는 패널을 확장하거나 축소할 수 없습니다.",
            collapsed: "모든 패널이 축소됩니다",
            expanded: "모든 패널이 확장됩니다.",
            firstExpanded: "첫 번째 확장"
        },
        widthMode: {
            static: "정적인",
            responsive: "반응"
        },
        contentMode: {
            image: "이미지",
            video: "비디오",
            youtube: "유튜브"
        },
        displayMode: {
            buttons: "단추",
            dropdown: "드롭다운(Dropdown)"
        },
        rateColorMode: {
            default: "기본값",
            scale: "저울"
        },
        scaleColorMode: {
            monochrome: "단색",
            colored: "유색"
        },
        autoGenerate: {
            "true": "창조하다",
            "false": "수동으로 입력"
        },
        rateType: {
            labels: "레이블",
            stars: "별",
            smileys: "스마일리"
        },
        state: {
            default: "잠긴"
        },
        showQuestionNumbers: {
            default: "자동 번호 매기기",
            on: "자동 번호 매기기",
            onPage: "각 페이지에서 재설정",
            onpanel: "각 패널에서 재설정",
            onPanel: "각 패널에서 재설정",
            onSurvey: "설문조사 계속하기",
            off: "번호 매기기 없음"
        },
        descriptionLocation: {
            underTitle: "질문 제목 아래",
            underInput: "입력 필드 아래"
        },
        selectToRankAreasLayout: {
            horizontal: "선택 항목 옆",
            vertical: "위의 선택 사항"
        },
        displayStyle: {
            decimal: "십진법",
            currency: "통화",
            percent: "백분율",
            date: "날짜"
        },
        totalDisplayStyle: {
            decimal: "십진법",
            currency: "통화",
            percent: "백분율",
            date: "날짜"
        },
        rowsOrder: {
            initial: "원문 언어"
        },
        questionsOrder: {
            initial: "원문 언어"
        },
        showProgressBar: {
            off: "숨겨진",
            topbottom: "위아래",
            aboveheader: "머리글 위",
            belowheader: "머리글 아래"
        },
        sum: "합계",
        count: "세다",
        min: "분",
        max: "최대",
        avg: "평균",
        searchMode: {
            contains: "포함",
            startsWith: "다음으로 시작"
        },
        backgroundImageFit: {
            auto: "자동",
            cover: "표지",
            contain: "포함하다",
            fill: "뻗다",
            tile: "타일"
        },
        backgroundImageAttachment: {
            fixed: "부정하게 결정된",
            scroll: "스크롤"
        },
        headerView: {
            basic: "기초의",
            advanced: "고급"
        },
        inheritWidthFrom: {
            survey: "설문 조사와 동일",
            container: "컨테이너에 맞추기"
        },
        backgroundColorSwitch: {
            none: "없음",
            accentColor: "강조 색상",
            custom: "관습"
        },
        colorPalette: {
            light: "광",
            dark: "어둠"
        },
        isPanelless: {
            "false": "기본값",
            "true": "패널 없음"
        }
    },
    // Operators
    op: {
        empty: "비어있습니다",
        notempty: "비어있지 않습니다",
        equal: "같습니다",
        notequal: "같지 않습니다",
        contains: "포함합니다",
        notcontains: "포함하지 않습니다",
        anyof: "다음 중 하나",
        allof: "모든",
        greater: "큰",
        less: "작은",
        greaterorequal: "크거나 같음",
        lessorequal: "작거나 같음",
        and: "그리고",
        or: "또는"
    },
    // Embed window
    ew: {
        angular: "Angular 버전 사용",
        jquery: "jQuery 버전 사용",
        knockout: "Knockout 버전 사용",
        react: "React 버전 사용",
        vue: "Vue 버전 사용",
        bootstrap: "부트 스트랩 프레임",
        modern: "현대 테마",
        default: "기본 테마",
        orange: "오렌지 테마",
        darkblue: "진한 파란색 테마",
        darkrose: "다크로즈 테마",
        stone: "돌 테마",
        winter: "겨울 테마",
        winterstone: "겨울 돌 테마",
        showOnPage: "페이지에서 설문조사 보기",
        showInWindow: "윈도우 창에서 설문조사 보기",
        loadFromServer: "서버에서 설문조사 JSON 실행",
        titleScript: "스크립트 및 스타일",
        titleHtml: "HTML",
        titleJavaScript: "자바스크립트"
    },
    // Preview (Survey)
    ts: {
        selectPage: "테스트 할 페이지를 선택하십시오:",
        showInvisibleElements: "보이지 않는 요소 표시",
        hideInvisibleElements: "보이지 않는 요소 숨기기"
    },
    validators: {
        answercountvalidator: "답 개수",
        emailvalidator: "이메일",
        expressionvalidator: "표현식",
        numericvalidator: "숫자",
        regexvalidator: "정규식",
        textvalidator: "텍스트"
    },
    triggers: {
        completetrigger: "설문 완료",
        setvaluetrigger: "값 설정",
        copyvaluetrigger: "답변 복사",
        skiptrigger: "질문으로 건너뛰기",
        runexpressiontrigger: "표현식 실행",
        visibletrigger: "선명도 변경"
    },
    peplaceholder: {
        patternmask: {
            pattern: "예: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "예: mm/dd/yyyy"
        },
        currencymask: {
            prefix: "예: $",
            suffix: "예.: USD"
        },
        panelbase: {
            questionTitleWidth: "예: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "응답자에게 표시되지 않는 패널 ID입니다.",
            description: "패널 부제목을 입력합니다.",
            visibleIf: "마술 지팡이 아이콘을 사용하여 패널 가시성을 결정하는 조건부 규칙을 설정합니다.",
            enableIf: "마술 지팡이 아이콘을 사용하여 패널에 대해 읽기 전용 모드를 비활성화하는 조건부 규칙을 설정합니다.",
            requiredIf: "마술 지팡이 아이콘을 사용하여 하나 이상의 중첩된 질문에 답변이 없는 한 설문조사 제출을 금지하는 조건부 규칙을 설정합니다.",
            questionTitleLocation: "이 패널 내의 모든 질문에 적용됩니다. 이 설정을 재정의하려면 개별 질문에 대한 제목 정렬 규칙을 정의합니다. \"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정(기본적으로 \"상단\")을 적용합니다.",
            questionTitleWidth: "질문 제목이 질문 상자의 왼쪽에 정렬될 때 일관된 너비를 설정합니다. CSS 값(px, %, in, pt 등)을 허용합니다.",
            questionErrorLocation: "패널 내의 모든 질문과 관련된 오류 메시지의 위치를 설정합니다. \"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정을 적용합니다.",
            questionsOrder: "질문의 원래 순서를 유지하거나 무작위화합니다. \"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정을 적용합니다.",
            page: "선택한 페이지의 끝으로 패널의 위치를 변경합니다.",
            innerIndent: "패널 내용과 패널 상자의 왼쪽 테두리 사이에 공백 또는 여백을 추가합니다.",
            startWithNewLine: "이전 질문 또는 패널과 함께 한 줄로 패널을 표시하려면 선택을 취소합니다. 패널이 양식의 첫 번째 요소인 경우에는 설정이 적용되지 않습니다.",
            state: "다음 중에서 선택: \"확장\" - 패널이 전체적으로 표시되며 축소할 수 있습니다. \"축소됨\" - 패널에 제목과 설명만 표시되며 확장할 수 있습니다. \"잠김\" - 패널이 완전히 표시되며 축소할 수 없습니다.",
            width: "패널의 폭을 같은 줄에 있는 다른 측량 요소에 비례하여 설정합니다. CSS 값(px, %, in, pt 등)을 허용합니다."
        },
        paneldynamic: {
            name: "응답자에게 표시되지 않는 패널 ID입니다.",
            description: "패널 부제목을 입력합니다.",
            visibleIf: "마술 지팡이 아이콘을 사용하여 패널 가시성을 결정하는 조건부 규칙을 설정합니다.",
            enableIf: "마술 지팡이 아이콘을 사용하여 패널에 대해 읽기 전용 모드를 비활성화하는 조건부 규칙을 설정합니다.",
            requiredIf: "마술 지팡이 아이콘을 사용하여 하나 이상의 중첩된 질문에 답변이 없는 한 설문조사 제출을 금지하는 조건부 규칙을 설정합니다.",
            templateTitleLocation: "이 패널 내의 모든 질문에 적용됩니다. 이 설정을 재정의하려면 개별 질문에 대한 제목 정렬 규칙을 정의합니다. \"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정(기본적으로 \"상단\")을 적용합니다.",
            templateErrorLocation: "잘못된 입력이 있는 질문과 관련된 오류 메시지의 위치를 설정합니다. 다음 중 하나를 선택합니다. \"상단\" - 오류 텍스트가 질문 상자 상단에 배치됩니다. \"하단\" - 오류 텍스트가 질문 상자 하단에 배치됩니다. \"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정(기본적으로 \"상단\")을 적용합니다.",
            errorLocation: "패널 내의 모든 질문과 관련된 오류 메시지의 위치를 설정합니다. \"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정을 적용합니다.",
            page: "선택한 페이지의 끝으로 패널의 위치를 변경합니다.",
            innerIndent: "패널 내용과 패널 상자의 왼쪽 테두리 사이에 공백 또는 여백을 추가합니다.",
            startWithNewLine: "이전 질문 또는 패널과 함께 한 줄로 패널을 표시하려면 선택을 취소합니다. 패널이 양식의 첫 번째 요소인 경우에는 설정이 적용되지 않습니다.",
            state: "다음 중에서 선택: \"확장\" - 패널이 전체적으로 표시되며 축소할 수 있습니다. \"축소됨\" - 패널에 제목과 설명만 표시되며 확장할 수 있습니다. \"잠김\" - 패널이 완전히 표시되며 축소할 수 없습니다.",
            width: "패널의 폭을 같은 줄에 있는 다른 측량 요소에 비례하여 설정합니다. CSS 값(px, %, in, pt 등)을 허용합니다.",
            templateTitle: "동적 패널 제목에 대한 템플릿을 입력합니다. 패널의 일반 위치에는 {panelIndex}를 사용하고 표시되는 패널 간의 순서에는 {visiblePanelIndex}를 사용합니다. 이러한 자리 표시자를 패턴에 삽입하여 자동 번호 매기기를 추가합니다.",
            templateTabTitle: "탭 제목에 대한 템플릿을 입력합니다. 패널의 일반적인 위치에는 {panelIndex}를 사용하고 표시되는 패널 간의 순서에는 {visiblePanelIndex}를 사용합니다. 이러한 자리 표시자를 패턴에 삽입하여 자동 번호 매기기를 추가합니다.",
            tabTitlePlaceholder: "탭 제목 패턴이 의미 있는 값을 생성하지 않을 때 적용되는 탭 제목에 대한 대체 텍스트입니다.",
            templateVisibleIf: "이 설정을 사용하면 동적 패널 내에서 개별 패널의 가시성을 제어할 수 있습니다. '{panel}' 자리 표시자를 사용하여 표현식의 현재 패널을 참조합니다.",
            titleLocation: "이 설정은 이 패널 내의 모든 질문에 자동으로 상속됩니다. 이 설정을 재정의하려면 개별 질문에 대한 제목 정렬 규칙을 정의합니다. \"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정(기본적으로 \"상단\")을 적용합니다.",
            descriptionLocation: "\"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정(기본적으로 \"패널 제목 아래\")을 적용합니다.",
            newPanelPosition: "새로 추가된 패널의 위치를 정의합니다. 기본적으로 새 패널이 끝에 추가됩니다. \"다음\"을 선택하여 현재 패널 뒤에 새 패널을 삽입합니다.",
            defaultValueFromLastPanel: "마지막 패널의 답변을 복제하여 다음에 추가된 동적 패널에 할당합니다.",
            keyName: "사용자가 각 패널에서 이 질문에 대해 고유한 응답을 제공하도록 요구하려면 질문 이름을 참조합니다."
        },
        defaultValueExpression: "이 설정을 사용하면 표현식에 따라 기본 답안 값을 할당할 수 있습니다. 표현식에는 기본 계산('{q1_id} + {q2_id}'), 부울 표현식(예: '{age} > 60') 및 함수 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' 등이 포함될 수 있습니다. 이 표현식에 의해 결정된 값은 응답자의 수동 입력으로 재정의할 수 있는 초기 기본값으로 사용됩니다.",
        resetValueIf: "마술 지팡이 아이콘을 사용하여 응답자의 입력이 \"기본값 표현식\" 또는 \"설정 값 표현식\" 또는 \"기본 답변\" 값(둘 중 하나가 설정된 경우)에 기반한 값으로 재설정되는 시점을 결정하는 조건부 규칙을 설정합니다.",
        setValueIf: "마술 지팡이 아이콘을 사용하여 \"값 설정 표현식\"을 실행할 시기를 결정하는 조건부 규칙을 설정하고 결과 값을 응답으로 동적으로 할당합니다.",
        setValueExpression: "\"Set value if\" 규칙의 조건이 충족될 때 설정할 값을 정의하는 표현식을 지정합니다. 표현식에는 기본 계산('{q1_id} + {q2_id}'), 부울 표현식(예: '{age} > 60') 및 함수 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' 등이 포함될 수 있습니다. 이 표현식에 의해 결정된 값은 응답자의 수동 입력에 의해 재정의될 수 있습니다.",
        question: {
            name: "응답자에게 표시되지 않는 질문 ID입니다.",
            description: "질문 부제목을 입력합니다.",
            visibleIf: "마술 지팡이 아이콘을 사용하여 질문 가시성을 결정하는 조건부 규칙을 설정합니다.",
            enableIf: "마술 지팡이 아이콘을 사용하여 질문에 대한 읽기 전용 모드를 비활성화하는 조건부 규칙을 설정합니다.",
            requiredIf: "마술 지팡이 아이콘을 사용하여 질문에 대한 답변을 받지 않는 한 설문조사 진행 또는 제출을 금지하는 조건부 규칙을 설정합니다.",
            startWithNewLine: "질문을 이전 질문 또는 패널과 함께 한 줄로 표시하려면 선택을 취소합니다. 질문이 양식의 첫 번째 요소인 경우에는 설정이 적용되지 않습니다.",
            page: "선택한 페이지의 끝으로 질문의 위치를 변경합니다.",
            state: "다음 중에서 선택: \"확장\" - 질문 상자가 전체적으로 표시되며 축소할 수 있습니다. \"축소됨\" - 질문 상자에는 제목과 설명만 표시되며 확장할 수 있습니다. \"잠김\" - 질문 상자가 완전히 표시되며 축소할 수 없습니다.",
            titleLocation: "패널, 페이지 또는 설문조사 수준에 정의된 제목 정렬 규칙을 재정의합니다. \"상속\" 옵션은 더 높은 수준의 설정(설정된 경우) 또는 설문조사 수준 설정(기본적으로 \"맨 위\")을 적용합니다.",
            descriptionLocation: "\"상속\" 옵션은 현장조사 수준 설정(기본 설정에 따라 \"질문 제목 아래\")을 적용합니다.",
            errorLocation: "잘못된 입력이 있는 질문과 관련된 오류 메시지의 위치를 설정합니다. 다음 중 하나를 선택합니다. \"상단\" - 오류 텍스트가 질문 상자 상단에 배치됩니다. \"하단\" - 오류 텍스트가 질문 상자 하단에 배치됩니다. \"상속\" 옵션은 설문조사 수준 설정(기본적으로 \"상단\")을 적용합니다.",
            indent: "질문 콘텐츠와 질문 상자의 왼쪽 테두리 사이에 공백 또는 여백을 추가합니다.",
            width: "같은 줄에 있는 다른 설문조사 요소에 비례하여 질문의 너비를 설정합니다. CSS 값(px, %, in, pt 등)을 허용합니다.",
            surveyvalidator: {
                expression: "마술 지팡이 아이콘을 사용하여 질문에 대한 유효성 검사 규칙을 설정합니다."
            },
            textUpdateMode: "다음 중에서 선택: \"초점을 잃을 때\" - 입력 필드가 초점을 잃을 때 값이 업데이트됩니다. \"While typing\" - 사용자가 입력할 때 값이 실시간으로 업데이트됩니다. \"상속\" 옵션은 설문조사 수준 설정(기본적으로 \"초점 손실 시\")을 적용합니다.",
            url: "모든 웹 서비스를 객관식 질문의 데이터 소스로 사용할 수 있습니다. 선택 항목 값을 채우려면 데이터를 제공하는 서비스의 URL을 입력합니다.",
            searchMode: "드롭다운 목록을 필터링하는 데 사용되는 비교 작업입니다.",
            textWrapEnabled: "선택 옵션의 긴 텍스트는 드롭다운 메뉴에 맞게 줄 바꿈을 자동으로 생성합니다. 텍스트를 자르려면 선택을 취소합니다."
        },
        signaturepad: {
            signatureWidth: "표시된 서명 영역과 결과 이미지의 너비를 설정합니다.",
            signatureHeight: "표시된 서명 영역과 결과 이미지의 높이를 설정합니다.",
            signatureAutoScaleEnabled: "기본 3:2 종횡비를 유지하면서 서명 영역이 질문 상자 내의 사용 가능한 모든 공간을 채우도록 하려면 선택합니다. 사용자 지정 너비 및 높이 값을 설정하면 설정은 이러한 치수의 가로 세로 비율을 유지합니다."
        },
        file: {
            imageHeight: "현장조사 결과에서 이미지의 높이를 조정합니다.",
            imageWidth: "현장조사 결과에서 이미지의 너비를 조정합니다."
        },
        image: {
            contentMode: "\"자동\" 옵션은 제공된 소스 URL을 기반으로 표시에 적합한 모드(이미지, 비디오 또는 YouTube)를 자동으로 결정합니다."
        },
        imagepicker: {
            imageHeight: "최소 및 최대 높이 값을 재정의합니다.",
            imageWidth: "최소 및 최대 너비 값을 재정의합니다.",
            choices: "\"Value\"는 조건부 규칙에 사용되는 항목 ID로 사용됩니다. 응답자에게 \"텍스트\"가 표시됩니다.",
            contentMode: "\"이미지\"와 \"비디오\" 중에서 선택하여 미디어 선택기의 콘텐츠 모드를 설정합니다. \"이미지\"를 선택한 경우 제공된 모든 옵션이 JPEG, GIF, PNG, APNG, SVG, BMP, ICO 형식의 이미지 파일인지 확인하십시오. 마찬가지로 \"비디오\"를 선택한 경우 모든 옵션이 MP4, MOV, WMV, FLV, AVI, MKV 형식의 비디오 파일에 대한 직접 링크인지 확인하십시오. YouTube 링크는 비디오 옵션에서 지원되지 않습니다."
        },
        text: {
            size: "이 설정은 입력 필드의 크기만 조정하며 질문 상자의 너비에는 영향을 주지 않습니다. 허용되는 입력 길이를 제한하려면 <b>유효성 검사 → 최대 문자 제한</b>으로 이동합니다."
        },
        comment: {
            rows: "입력 필드에 표시되는 줄 수를 설정합니다. 입력이 더 많은 줄을 차지하면 스크롤 막대가 나타납니다."
        },
        // survey templates
        survey: {
            mode: "다음 중 하나를 선택합니다. \"수정 가능\" - 응답자가 설문조사를 작성할 수 있습니다. \"읽기 전용\" - 양식 편집을 비활성화합니다."
        },
        matrixdropdowncolumn: {
            name: "응답자에게 표시되지 않는 열 ID입니다.",
            isUnique: "열에 대해 활성화된 경우, 응답자는 이 열 내의 각 질문에 대해 고유한 응답을 제공해야 합니다.",
            rows: "입력 필드에 표시되는 줄 수를 설정합니다. 입력이 더 많은 줄을 차지하면 스크롤 막대가 나타납니다.",
            visibleIf: "마술 지팡이 아이콘을 사용하여 열 표시 유형을 결정하는 조건부 규칙을 설정합니다.",
            enableIf: "마술 지팡이 아이콘을 사용하여 열에 대해 읽기 전용 모드를 비활성화하는 조건부 규칙을 설정합니다.",
            requiredIf: "마술 지팡이 아이콘을 사용하여 하나 이상의 중첩된 질문에 답변이 없는 한 설문조사 제출을 금지하는 조건부 규칙을 설정합니다.",
            showInMultipleColumns: "이 옵션을 선택하면 각 선택 옵션에 대한 개별 열이 만들어집니다."
        },
        widthMode: "다음 중에서 선택합니다. \"정적\" - 고정 너비를 설정합니다. \"반응형\" - 설문조사가 화면의 전체 너비를 차지하도록 합니다. \"자동\" - 사용된 질문 유형에 따라 둘 중 하나를 적용합니다.",
        cookieName: "쿠키는 사용자가 동일한 설문조사를 두 번 작성하는 것을 방지합니다.",
        logo: "이미지 링크(크기 제한 없음)를 붙여넣거나 폴더 아이콘을 클릭하여 컴퓨터에서 파일을 찾습니다(최대 64KB).",
        logoWidth: "로고 너비를 CSS 단위(px, %, in, pt 등)로 설정합니다.",
        logoHeight: "로고 높이를 CSS 단위(px, %, in, pt 등)로 설정합니다.",
        logoFit: "다음 중에서 선택: \"없음\" - 이미지가 원래 크기를 유지합니다. \"Contain\" - 가로 세로 비율을 유지하면서 이미지의 크기가 조정됩니다. \"표지\" - 이미지가 종횡비를 유지하면서 전체 상자를 채웁니다. \"채우기\" - 가로 세로 비율을 유지하지 않고 상자를 채우기 위해 이미지가 늘어납니다.",
        goNextPageAutomatic: "응답자가 현재 페이지의 모든 질문에 답변한 후 설문조사가 자동으로 다음 페이지로 넘어가도록 하려면 선택합니다.",
        allowCompleteSurveyAutomatic: "응답자가 모든 질문에 답변한 후 설문조사가 자동으로 완료되도록 하려면 선택합니다.",
        showNavigationButtons: "페이지에서 탐색 단추의 표시 여부와 위치를 설정합니다.",
        showProgressBar: "진행률 표시줄의 표시 여부와 위치를 설정합니다. \"자동\" 값은 설문조사 헤더 위 또는 아래에 진행률 표시줄을 표시합니다.",
        showPreviewBeforeComplete: "모든 질문 또는 답변된 질문만 있는 미리보기 페이지를 활성화합니다.",
        questionTitleLocation: "설문조사 내의 모든 질문에 적용됩니다. 이 설정은 하위 수준(패널, 페이지 또는 질문)의 제목 정렬 규칙으로 재정의할 수 있습니다. 낮은 수준의 설정은 더 높은 수준의 설정보다 우선합니다.",
        requiredText: "답변이 필요함을 나타내는 기호 또는 일련의 기호입니다.",
        questionStartIndex: "번호 매기기를 시작할 숫자 또는 문자를 입력합니다.",
        questionErrorLocation: "잘못된 입력이 있는 질문과 관련된 오류 메시지의 위치를 설정합니다. 다음 중 하나를 선택합니다. \"상단\" - 오류 텍스트가 질문 상자 상단에 배치됩니다. \"하단\" - 오류 텍스트가 질문 상자 하단에 배치됩니다.",
        focusFirstQuestionAutomatic: "각 페이지의 첫 번째 입력 필드를 텍스트 입력에 사용할 수 있도록 준비하려면 선택합니다.",
        questionsOrder: "질문의 원래 순서를 유지하거나 무작위화합니다. 이 설정의 효과는 미리보기 탭에서만 볼 수 있습니다.",
        maxTextLength: "텍스트 입력 질문에만 해당됩니다.",
        maxOthersLength: "질문 댓글에만 해당됩니다.",
        commentAreaRows: "질문 주석에 대해 텍스트 영역에 표시되는 줄 수를 설정합니다. 입력이 더 많은 줄을 차지하면 스크롤 막대가 나타납니다.",
        autoGrowComment: "질문 댓글과 긴 텍스트 질문의 높이가 입력한 텍스트 길이에 따라 자동으로 커지도록 하려면 선택합니다.",
        allowResizeComment: "질문 댓글 및 긴 텍스트 질문에만 해당됩니다.",
        calculatedValues: "사용자 지정 변수는 양식 계산에 사용되는 중간 또는 보조 변수 역할을 합니다. 응답자 입력을 소스 값으로 사용합니다. 각 맞춤 변수에는 고유한 이름과 기준이 되는 표현식이 있습니다.",
        includeIntoResult: "표현식의 계산된 값을 현장조사 결과와 함께 저장하려면 선택합니다.",
        triggers: "트리거는 표현식을 기반으로 하는 이벤트 또는 조건입니다. 표현식이 \"true\"로 평가되면 트리거가 작업을 시작합니다. 이러한 작업에는 선택적으로 영향을 미치는 대상 질문이 있을 수 있습니다.",
        clearInvisibleValues: "조건부 논리에 의해 숨겨진 질문의 값을 지울지 여부와 지울 시기를 선택합니다.",
        textUpdateMode: "다음 중에서 선택: \"초점을 잃을 때\" - 입력 필드가 초점을 잃을 때 값이 업데이트됩니다. \"While typing\" - 사용자가 입력할 때 값이 실시간으로 업데이트됩니다.",
        columns: "왼쪽 값은 조건부 규칙에 사용되는 열 ID 역할을 하며, 오른쪽 값은 응답자에게 표시됩니다.",
        rows: "왼쪽 값은 조건부 규칙에 사용되는 행 ID 역할을 하며, 오른쪽 값은 응답자에게 표시됩니다.",
        columnMinWidth: "CSS 값(px, %, in, pt 등)을 허용합니다.",
        rowTitleWidth: "CSS 값(px, %, in, pt 등)을 허용합니다.",
        totalText: "하나 이상의 열에 Total 유형 또는 Total 표현식이 있는 경우에만 표시됩니다.",
        cellErrorLocation: "잘못된 입력이 있는 셀과 관련하여 오류 메시지의 위치를 설정합니다. \"상속\" 옵션은 \"오류 메시지 맞춤\" 속성의 설정을 적용합니다.",
        keyDuplicationError: "\"중복 응답 방지\" 속성이 활성화된 경우, 중복 항목을 제출하려는 응답자는 다음과 같은 오류 메시지를 받게 됩니다.",
        totalExpression: "표현식을 기준으로 합계 값을 계산할 수 있습니다. 표현식에는 기본 계산('{q1_id} + {q2_id}'), 부울 표현식('{age} > 60') 및 함수('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' 등)이 포함될 수 있습니다.",
        confirmDelete: "행 삭제를 확인하라는 프롬프트를 트리거합니다.",
        defaultValueFromLastRow: "마지막 행의 답변을 복제하여 다음에 추가된 동적 행에 할당합니다.",
        keyName: "지정된 열에 동일한 값이 포함되어 있으면 현장조사에서 \"고유하지 않은 키 값\" 오류가 발생합니다.",
        description: "자막을 입력합니다.",
        locale: "설문조사 만들기를 시작할 언어를 선택합니다. 번역을 추가하려면 새 언어로 전환하고 여기 또는 번역 탭에서 원본 텍스트를 번역합니다.",
        detailPanelMode: "행을 기준으로 세부 정보 섹션의 위치를 설정합니다. 다음 중에서 선택: \"없음\" - 확장이 추가되지 않습니다. \"행 아래\" - 행 확장이 행렬의 각 행 아래에 배치됩니다. \"행 아래에 한 행 확장만 표시\" - 확장은 단일 행 아래에만 표시되고 나머지 행 확장은 축소됩니다.",
        imageFit: "다음 중에서 선택: \"없음\" - 이미지가 원래 크기를 유지합니다. \"Contain\" - 가로 세로 비율을 유지하면서 이미지의 크기가 조정됩니다. \"표지\" - 이미지가 종횡비를 유지하면서 전체 상자를 채웁니다. \"채우기\" - 가로 세로 비율을 유지하지 않고 상자를 채우기 위해 이미지가 늘어납니다.",
        autoGrow: "데이터가 입력될 때 입력 필드의 높이를 점진적으로 늘립니다. \"입력 필드 높이(줄 단위)\" 설정을 재정의합니다.",
        allowResize: "크기 조정 핸들(또는 그립)이 모서리에 나타나며 드래그하여 입력 필드의 크기를 변경할 수 있습니다.",
        maxTimeToFinish: "설문조사가 감사 인사 페이지로 자동 전환되기까지의 시간 간격(초)입니다.",
        maxTimeToFinishPage: "설문조사가 다음 페이지로 자동 넘어가는 시간 간격(초)입니다.",
        page: {
            maxTimeToFinish: "설문조사가 다음 페이지로 자동 넘어가는 시간 간격(초)입니다.",
            visibleIf: "마술 지팡이 아이콘을 사용하여 페이지 표시 여부를 결정하는 조건부 규칙을 설정할 수 있습니다.",
            enableIf: "마술 지팡이 아이콘을 사용하여 페이지에 대해 읽기 전용 모드를 비활성화하는 조건부 규칙을 설정합니다.",
            requiredIf: "마술 지팡이 아이콘을 사용하여 하나 이상의 중첩된 질문에 답변이 없는 한 설문조사 제출을 금지하는 조건부 규칙을 설정합니다.",
            questionTitleLocation: "이 페이지 내의 모든 질문에 적용됩니다. 이 설정을 재정의하려면 개별 질문 또는 패널에 대한 제목 정렬 규칙을 정의합니다. \"상속\" 옵션은 설문조사 수준 설정(기본적으로 \"상단\")을 적용합니다.",
            questionTitleWidth: "질문 제목이 질문 상자의 왼쪽에 정렬될 때 일관된 너비를 설정합니다. CSS 값(px, %, in, pt 등)을 허용합니다.",
            questionErrorLocation: "잘못된 입력이 있는 질문과 관련된 오류 메시지의 위치를 설정합니다. 다음 중 하나를 선택합니다. \"상단\" - 오류 텍스트가 질문 상자 상단에 배치됩니다. \"하단\" - 오류 텍스트가 질문 상자 하단에 배치됩니다. \"상속\" 옵션은 설문조사 수준 설정(기본적으로 \"상단\")을 적용합니다.",
            questionsOrder: "질문의 원래 순서를 유지하거나 무작위화합니다. \"상속\" 옵션은 설문조사 수준 설정(기본적으로 \"원본\")을 적용합니다. 이 설정의 효과는 미리보기 탭에서만 볼 수 있습니다.",
            navigationButtonsVisibility: "페이지에서 탐색 단추의 표시 여부를 설정합니다. \"상속\" 옵션은 설문조사 수준 설정을 적용하며, 기본값은 \"표시\"입니다."
        },
        showTimerPanel: "페이지에서 타이머의 표시 여부와 위치를 설정합니다.",
        panelsState: "다음 중에서 선택: \"잠김\" - 사용자가 패널을 확장하거나 축소할 수 없습니다. \"모두 축소\" - 모든 패널이 축소된 상태에서 시작됩니다. \"모두 확장\" - 모든 패널이 확장된 상태에서 시작됩니다. \"첫 번째 확장\" - 첫 번째 패널만 처음에 확장됩니다.",
        imageLinkName: "선택 목록에 표시할 이미지 또는 비디오 파일 URL이 포함된 객체 배열 내에 공유 속성 이름을 입력합니다.",
        choices: "왼쪽 값은 조건부 규칙에 사용되는 항목 ID 역할을 하며, 오른쪽 값은 응답자에게 표시됩니다.",
        title: "표시할 사용자에게 친숙한 제목을 입력합니다.",
        waitForUpload: "파일이 업로드될 때까지 사용자가 설문조사를 완료하지 않도록 합니다.",
        minWidth: "CSS 값(px, %, in, pt 등)을 허용합니다.",
        maxWidth: "CSS 값(px, %, in, pt 등)을 허용합니다.",
        width: "CSS 값(px, %, in, pt 등)을 허용합니다.",
        valueName: "이 속성을 설정하지 않으면 대답이 Name 속성으로 지정된 필드에 저장됩니다.",
        useDisplayValuesInDynamicTexts: "단답형 및 다중선택 질문 유형에서 각 선택 옵션에는 ID와 표시 값이 있습니다. 이 설정을 선택하면 HTML 질문과 동적 제목 및 현장조사 요소에 대한 설명에서 ID 값 대신 표시 값이 표시됩니다.",
        clearIfInvisible: "조건부 논리에 의해 숨겨진 질문 값을 지울지 여부와 지울 시기를 선택합니다. \"상속\" 옵션은 설문조사 수준 설정(기본적으로 \"설문조사 완료 시\")을 적용합니다.",
        choicesFromQuestionMode: "다음 중에서 선택: \"모두\" - 선택한 질문의 모든 선택 옵션을 복사합니다. \"선택됨\" - 선택한 선택 옵션만 동적으로 복사합니다. \"선택되지 않음\" - 선택되지 않은 선택 옵션만 동적으로 복사합니다. \"없음\" 및 \"기타\" 옵션은 원본 질문에서 활성화된 경우 기본적으로 복사됩니다.",
        showOtherItem: "이 옵션을 선택하면 사용자가 별도의 주석 상자에 추가 입력을 포함할 수 있습니다.",
        separateSpecialChoices: "각 특수 선택 옵션(\"없음\", \"기타\", \"모두 선택\")을 새 줄에 표시합니다(여러 열 레이아웃을 사용하는 경우에도 마찬가지임).",
        path: "서비스 데이터 세트 내에서 대상 객체 배열이 있는 위치를 지정합니다. URL이 이미 배열을 가리키는 경우 비워 둡니다.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "선택 목록에 표시할 값을 포함하는 객체 배열 내에 균일한 특성 이름을 입력합니다.",
        allowEmptyResponse: "서비스가 빈 응답 또는 배열을 반환하도록 허용하려면 선택합니다.",
        choicesVisibleIf: "마술 지팡이 아이콘을 사용하여 모든 선택 옵션의 표시 유형을 결정하는 조건부 규칙을 설정합니다.",
        rateValues: "왼쪽 값은 조건부 규칙에 사용되는 항목 ID 역할을 하며, 오른쪽 값은 응답자에게 표시됩니다.",
        rating: {
            displayMode: "\"자동\"은 사용 가능한 너비에 따라 \"버튼\"과 \"드롭다운\" 모드 중에서 선택합니다. 너비가 부족하여 버튼을 표시할 수 없는 경우 질문에 드롭다운이 표시됩니다."
        },
        valuePropertyName: "다양한 형식의 결과를 생성하는 질문을 연결할 수 있습니다. 이러한 질문이 조인 식별자를 사용하여 서로 연결되면 이 공유 속성은 선택한 질문 값을 저장합니다.",
        searchEnabled: "사용자가 입력 필드에 입력하는 검색어와 일치하도록 드롭다운 메뉴 내용을 업데이트하려면 선택합니다.",
        valueTrue: "응답자들이 긍정적인 답변을 할 때 설문조사 결과에 저장하는 값입니다.",
        valueFalse: "응답자들이 부정적인 답변을 할 때 설문조사 결과에 저장하는 값입니다.",
        showPreview: "이 옵션은 미리 보기 이미지를 재정의하고 사용자가 파일이 업로드되었는지 여부를 이해하기 어렵게 만들기 때문에 사용하지 않도록 설정하지 않는 것이 좋습니다.",
        needConfirmRemoveFile: "파일 삭제를 확인하는 프롬프트를 트리거합니다.",
        selectToRankEnabled: "선택한 선택 항목만 순위를 지정할 수 있습니다. 사용자는 선택 목록에서 선택한 항목을 끌어 순위 영역 내에서 정렬합니다.",
        dataList: "입력 시 응답자에게 제안될 선택 사항 목록을 입력합니다.",
        itemSize: "이 설정은 입력 필드의 크기만 조정하며 질문 상자의 너비에는 영향을 주지 않습니다.",
        itemTitleWidth: "모든 항목 레이블에 대해 일관된 너비를 픽셀 단위로 설정합니다.",
        altText: "사용자의 장치에 이미지를 표시할 수 없는 경우 접근성을 위해 대신 사용할 수 있습니다.",
        rateColorMode: "등급 아이콘 유형이 \"스마일리\"로 설정된 경우 선택한 이모티콘의 색상을 정의합니다. 다음 중 하나를 선택합니다. \"기본값\" - 선택한 이모티콘이 기본 설문조사 색상으로 표시됩니다. \"척도\"-선택한 이모티콘은 등급 척도에서 색상을 상속합니다.",
        expression: {
            name: "응답자에게 표시되지 않는 표현식 ID입니다.",
            description: "표현식 부제목을 입력합니다.",
            expression: "표현식에는 기본 계산('{q1_id} + {q2_id}'), 조건('{age} > 60') 및 함수('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' 등)가 포함될 수 있습니다."
        },
        storeOthersAsComment: "\"기타\" 옵션 값을 측량 결과에 별도의 속성으로 저장하려면 선택합니다.",
        format: "{0} 실제 값의 자리 표시자로 사용합니다.",
        acceptedTypes: "자세한 내용은 [accept](https://www.w3schools.com/tags/att_input_accept.asp) 속성 설명을 참조하십시오.",
        columnColCount: "Radiogroup 및 Checkbox 셀 유형에만 적용할 수 있습니다.",
        autocomplete: "자세한 내용은 [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) 속성 설명을 참조하십시오.",
        filePlaceholder: "\"소스 유형\"이 \"로컬 파일\"이거나 카메라를 사용할 수 없는 경우에 적용됩니다.",
        photoPlaceholder: "\"소스 유형\"이 \"카메라\"인 경우에 적용됩니다.",
        fileOrPhotoPlaceholder: "\"소스 유형\"이 \"로컬 파일 또는 카메라\"인 경우에 적용됩니다.",
        masksettings: {
            saveMaskedValue: "마스크가 적용된 질문 값을 현장조사 결과에 저장하려면 선택합니다."
        },
        patternmask: {
            pattern: "패턴에는 문자열 리터럴과 다음 자리 표시자가 포함될 수 있습니다. '9' - 숫자의 경우; 'a' - 대문자 또는 소문자의 경우; '#' - 숫자 또는 대문자 또는 소문자의 경우. 백슬래시 '\\'를 사용하여 문자를 이스케이프합니다."
        },
        datetimemask: {
            pattern: "패턴에는 구분 기호와 다음 자리 표시자가 포함될 수 있습니다<br>.'m' - 월 번호입니다.<br>'mm' - 월 숫자 값으로, 한 자리 값의 경우 앞에 0이 옵니다. <br>'d' - 해당 월의 일. <br>'dd' - 한 자리 값의 경우 앞에 0이 오는 월의 일입니다. <br>'yy' - 연도의 마지막 두 자리 숫자입니다. <br>'yyyy' - 4자리 연도입니다. <br>'H' - 24시간 형식의 시간입니다. <br>'HH' - 24시간 형식의 시간으로, 한 자리 값의 경우 앞에 0이 옵니다. <br>'h' - 12시간 형식의 시간입니다. <br>'hh' - 12시간 형식의 시간으로, 한 자리 값의 경우 앞에 0이 옵니다. <br>'MM' - 분. <br>'ss' - 초. <br>'TT' - 대문자로 된 12시간제 기간(AM/PM)입니다. <br>'tt' - 소문자로 된 12시간제 기간(오전/오후)입니다."
        },
        numericmask: {
            decimalSeparator: "표시된 숫자의 정수 부분에서 소수 부분을 구분하는 데 사용되는 기호입니다.",
            thousandsSeparator: "큰 숫자의 숫자를 3개의 그룹으로 구분하는 데 사용되는 기호입니다.",
            precision: "표시된 숫자의 소수점 뒤에 유지할 자릿수를 제한합니다."
        },
        currencymask: {
            prefix: "값 앞에 표시할 하나 또는 여러 개의 기호입니다.",
            suffix: "값 뒤에 표시할 하나 또는 여러 개의 기호입니다."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "제목",
            title: "'이름'과 같은 경우 비워 둡니다."
        },
        multiSelect: "다중 선택 허용",
        showLabel: "이미지 캡션 표시",
        swapOrder: "예와 아니요의 순서를 바꿉니다.",
        value: "값",
        tabAlign: "탭 정렬",
        sourceType: "소스 유형",
        fitToContainer: "컨테이너에 맞추기",
        setValueExpression: "설정 값 표현식",
        description: "설명",
        logoFit: "로고 핏",
        pages: "페이지",
        questions: "질문",
        triggers: "트리거",
        calculatedValues: "계산된 값",
        surveyId: "설문조사 ID",
        surveyPostId: "설문조사 게시물 ID",
        surveyShowDataSaving: "설문 조사 쇼 데이터 저장",
        questionDescriptionLocation: "질문 설명 위치",
        progressBarType: "진행률 표시줄 유형",
        showTOC: "TOC 표시",
        tocLocation: "목차 위치",
        questionTitlePattern: "질문 제목 패턴",
        widthMode: "폭 모드",
        showBrandInfo: "브랜드 정보 표시",
        useDisplayValuesInDynamicTexts: "동적 텍스트에서 표시 값 사용Use display values in dynamic texts",
        visibleIf: "조건 충족시 보기",
        defaultValueExpression: "기본값 표현식",
        requiredIf: "다음과 같은 경우 필수입니다.",
        resetValueIf: "다음과 같은 경우 값을 재설정합니다.",
        setValueIf: "다음과 같은 경우 값을 설정합니다.",
        validators: "유효성 검사기",
        bindings: "바인딩",
        renderAs: "렌더링 형식",
        attachOriginalItems: "원본 항목 첨부",
        choices: "선택",
        choicesByUrl: "URL을 통한 선택",
        currency: "화폐",
        cellHint: "셀 힌트",
        totalMaximumFractionDigits: "총 최대 자릿수",
        totalMinimumFractionDigits: "총 최소 자릿수",
        columns: "열",
        detailElements: "세부 요소",
        allowAdaptiveActions: "적응형 작업 허용",
        defaultRowValue: "기본 행 값",
        detailPanelShowOnAdding: "추가 시 세부 정보 패널 표시",
        choicesLazyLoadEnabled: "선택 지연 로드 사용",
        choicesLazyLoadPageSize: "선택 지연 로드 페이지 크기",
        inputFieldComponent: "입력 필드 구성 요소",
        itemComponent: "항목 구성 요소",
        min: "분",
        max: "최대",
        minValueExpression: "최소값 표현식",
        maxValueExpression: "최대값 표현식",
        step: "걸음",
        dataList: "데이터 목록",
        itemSize: "항목 크기",
        itemTitleWidth: "항목 레이블 너비(px)",
        elements: "요소",
        content: "콘텐츠",
        navigationButtonsVisibility: "탐색 버튼 선명도",
        navigationTitle: "탐색 제목",
        navigationDescription: "탐색 설명",
        longTap: "길게 탭하기",
        autoGrow: "자동 성장",
        allowResize: "크기 조정 허용",
        acceptCarriageReturn: "캐리지 리턴 수락",
        displayMode: "디스플레이 모드",
        rateType: "비율 유형",
        label: "라벨",
        contentMode: "콘텐츠 모드",
        imageFit: "이미지 핏",
        altText: "대체 텍스트",
        height: "높이",
        penColor: "펜 색상",
        backgroundColor: "배경색",
        templateElements: "템플릿 요소",
        operator: "연산자",
        isVariable: "가변적이다",
        runExpression: "표현식 실행",
        showCaption: "캡션 표시",
        iconName: "아이콘 이름",
        iconSize: "아이콘 크기",
        precision: "정밀",
        matrixDragHandleArea: "매트릭스 끌기 핸들 영역",
        backgroundImage: "배경 이미지",
        backgroundImageFit: "배경 이미지 맞춤",
        backgroundImageAttachment: "배경 이미지 첨부",
        backgroundOpacity: "배경 불투명도",
        selectToRankEnabled: "사용 가능한 순위를 선택하려면 선택합니다.",
        selectToRankAreasLayout: "영역 레이아웃의 순위를 지정하려면 선택합니다.",
        selectToRankEmptyRankedAreaText: "모든 옵션이 선택된 경우 표시할 텍스트",
        selectToRankEmptyUnrankedAreaText: "순위 영역의 자리 표시자 텍스트",
        allowCameraAccess: "카메라 액세스 허용",
        scaleColorMode: "스케일 컬러 모드",
        rateColorMode: "비율 색상 모드",
        copyDisplayValue: "표시 값 복사",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "어드밴스드 모드",
        pageTitle: "페이지 제목 글꼴",
        questionTitle: "질문 제목 글꼴",
        editorPanel: "입력 요소",
        lines: "라인",
        primaryDefaultColor: "기본값",
        primaryDarkColor: "호버",
        primaryLightColor: "선택한",
        backgroundDimColor: "배경색",
        cornerRadius: "코너 반경",
        backcolor: "기본 배경",
        hovercolor: "배경 가리키기",
        borderDecoration: "테두리 장식",
        fontColor: "글꼴 색상",
        backgroundColor: "배경색",
        primaryForecolor: "기본 색상",
        primaryForecolorLight: "비활성화 된 색상",
        font: "글꼴",
        borderDefault: "어두운",
        borderLight: "라이터",
        fontFamily: "글꼴 모음",
        fontWeightRegular: "일반",
        fontWeightHeavy: "무겁다",
        fontWeightSemiBold: "세미 볼드(Semi-bold)",
        fontWeightBold: "대담한",
        color: "색",
        placeholderColor: "자리 표시자 색",
        size: "크기",
        opacity: "불투명도",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "그림자 효과 추가",
        boxShadowBlur: "흐리게",
        boxShadowSpread: "전파",
        boxShadowDrop: "방울",
        boxShadowInner: "내부",
        names: {
            default: "기본값",
            sharp: "날카로운",
            borderless: "국경",
            flat: "플랫",
            plain: "평야",
            doubleborder: "이중 테두리",
            layered: "계층",
            solid: "고체",
            threedimensional: ".3D",
            contrast: "대조"
        },
        colors: {
            teal: "청록",
            blue: "파랑",
            purple: "보라색",
            orchid: "난초",
            tulip: "튤립",
            brown: "갈색",
            green: "녹색"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["ko"] = koreanStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// survey.externalHelpLink: "Watch and learn how to create surveys" => "설문조사를 만드는 방법을 보고 알아보세요."
// survey.externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber" => "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber"
// survey.addLogicItem: "Create a rule to customize the flow of the survey." => "설문 조사의 흐름을 사용자 지정하는 규칙을 만듭니다."
// survey.duplicate: "Duplicate" => "복사하다"
// qt.imagepicker: "Image Picker" => "이미지 선택기"
// qt.ranking: "Ranking" => "순위"
// qt.image: "Image" => "이미지"
// qt.tagbox: "Multi-Select Dropdown" => "다중 선택 드롭다운"
// qt.signaturepad: "Signature" => "서명"
// qt.buttongroup: "Button Group" => "단추 그룹"
// ed.defaultLocale: "Default ({0})" => "기본값({0})"
// ed.settingsTooltip: "Open settings" => "설정 열기"
// ed.surveySettings: "Survey Settings" => "설문조사 설정"
// ed.surveySettingsTooltip: "Open survey settings" => "설문조사 설정 열기"
// ed.showPanel: "Show Panel" => "패널 표시"
// ed.hidePanel: "Hide Panel" => "패널 숨기기"
// ed.prevSelected: "Select previous" => "이전 선택"
// ed.nextSelected: "Select next" => "다음을 선택합니다"
// ed.surveyTypeName: "Survey" => "조사"
// ed.pageTypeName: "Page" => "페이지"
// ed.panelTypeName: "Panel" => "패널"
// ed.questionTypeName: "Question" => "질문"
// ed.columnTypeName: "Column" => "열"
// ed.newTextItemName: "text" => "문자 메시지"
// ed.themeSurvey: "Themes" => "테마"
// ed.defaultV2Theme: "Default" => "기본값"
// ed.modernTheme: "Modern" => "현대의"
// ed.defaultTheme: "Default (legacy)" => "기본값(레거시)"
// ed.navigateToMsg: "You had to navigate to" => "다음으로 이동해야 했습니다."
// ed.logic: "Logic" => "논리학"
// ed.translation: "Translation" => "번역"
// ed.saveSurveyTooltip: "Save Survey" => "설문조사 저장"
// ed.jsonHideErrors: "Hide errors" => "오류 숨기기"
// ed.jsonShowErrors: "Show errors" => "오류 표시"
// ed.undoTooltip: "Undo last change" => "마지막 변경 사항 실행 취소"
// ed.redoTooltip: "Redo the change" => "변경 내용 다시 실행"
// ed.showMoreChoices: "Show more" => "더 보기"
// ed.showLessChoices: "Show less" => "간략하게 표시"
// ed.copy: "Copy" => "복사"
// ed.cut: "Cut" => "삭감"
// ed.paste: "Paste" => "붙여넣기"
// ed.copyTooltip: "Copy selection to clipboard" => "클립보드에 선택 항목 복사"
// ed.cutTooltip: "Cut selection to clipboard" => "선택 영역을 클립보드로 잘라내기"
// ed.pasteTooltip: "Paste from clipboard" => "클립보드에서 붙여넣기"
// ed.property-grid: "Properties" => "속성"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "검색하려면 입력..."
// ed.toolboxChoiceCategory: "Choice Questions" => "선택 질문"
// ed.toolboxTextCategory: "Text Input Questions" => "텍스트 입력 질문"
// ed.toolboxContainersCategory: "Containers" => "컨테이너"
// ed.toolboxMatrixCategory: "Matrix Questions" => "행렬 질문"
// ed.toolboxMiscCategory: "Misc" => "기타"
// ed.surveyResultsTable: "As Table" => "테이블로"
// ed.surveyResultsJson: "As JSON" => "JSON으로"
// ed.resultsTitle: "Question Title" => "질문 제목"
// ed.resultsName: "Question Name" => "질문 이름"
// ed.resultsValue: "Answer Value" => "답변 값"
// ed.resultsDisplayValue: "Display Value" => "표시 값"
// ed.propertyEditorError: "Error" => "오류"
// ed.saveError: "Error! Editor content is not saved." => "오류! 편집기 컨텐츠는 저장되지 않습니다."
// ed.translationPropertyGridTitle: "Language Settings" => "언어 설정"
// ed.themePropertyGridTitle: "Theme Settings" => "테마 설정"
// ed.translationLanguages: "Languages" => "언어들"
// ed.translationAddLanguage: "Select language to translate" => "번역할 언어 선택"
// ed.translationShowAllStrings: "All Strings" => "모든 문자열"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "사용된 문자열만"
// ed.translationShowAllPages: "All Pages" => "모든 페이지"
// ed.translationNoStrings: "No strings to translate. Please, change the filter." => "번역할 문자열이 없습니다. 필터를 교체하십시오."
// ed.translationExportToSCVButton: "Export to CSV" => "CSV로 내보내기"
// ed.translationImportFromSCVButton: "Import from CSV" => "CSV에서 가져오기"
// ed.translationMergeLocaleWithDefault: "Merge {0} with default locale" => "{0} 기본 로캘과 병합"
// ed.translationPlaceHolder: "Translation..." => "번역..."
// ed.themeExportButton: "Export" => "수출"
// ed.themeImportButton: "Import" => "수입"
// ed.bold: "Bold" => "대담한"
// ed.italic: "Italic" => "이탤릭체"
// ed.underline: "Underline" => "밑줄"
// ed.addNewQuestion: "Add Question" => "질문 추가"
// ed.selectPage: "Select page..." => "페이지 선택..."
// ed.carryForwardChoicesCopied: "Choices are copied from" => "선택 항목은 다음에서 복사됩니다."
// ed.htmlPlaceHolder: "HTML content will be here." => "HTML 콘텐츠가 여기에 있습니다."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "도구 상자에서 질문을 삭제하세요."
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "설문 조사가 비어 있습니다. 도구 상자에서 요소를 드래그하거나 아래 버튼을 클릭합니다."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "여기에 이미지를 끌어다 놓거나 아래 버튼을 클릭하고 업로드할 이미지를 선택하세요."
// ed.imageChooseImage: "Choose Image" => "이미지 선택"
// ed.addNewTypeQuestion: "Add {0}" => "{0} 추가"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[로고]"
// ed.auto: "auto" => "자동"
// ed.choices_Item: "Item " => "항목 "
// lg.addNewItem: "Add New Rule" => "새 규칙 추가"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "설문 조사의 흐름을 사용자 지정하는 규칙을 만듭니다."
// lg.page_visibilityName: "Show (hide) page" => "페이지 표시(숨기기)"
// lg.page_enableName: "Enable (disable) page" => "사용(사용 안 함) 페이지"
// lg.panel_visibilityName: "Show (hide) panel" => "표시(숨기기) 패널"
// lg.panel_enableName: "Enable (disable) panel" => "활성화(비활성화) 패널"
// lg.question_visibilityName: "Show (hide) question" => "질문 표시(숨기기)"
// lg.question_enableName: "Enable (disable) question" => "사용(사용 안 함) 질문"
// lg.question_requireName: "Make question required" => "질문 필수 항목 만들기"
// lg.column_visibilityName: "Show (hide) column" => "열 표시(숨기기)"
// lg.column_enableName: "Enable (disable) column" => "사용(사용 안 함) 열"
// lg.column_requireName: "Make column required" => "열을 필수로 설정"
// lg.trigger_completeName: "Complete survey" => "설문 조사 완료"
// lg.trigger_setvalueName: "Set answer" => "정답 설정"
// lg.trigger_copyvalueName: "Copy answer" => "답변 복사"
// lg.trigger_skipName: "Skip to question" => "질문으로 건너뛰기"
// lg.trigger_runExpressionName: "Run expression" => "표현식 실행"
// lg.completedHtmlOnConditionName: "Set \"Survey Complete\" page markup" => "\"설문조사 완료\" 페이지 마크업 설정"
// lg.page_visibilityDescription: "Make the page visible when the logic expression returns true. Otherwise keep it invisible." => "논리 표현식이 true를 반환할 때 페이지가 표시되도록 합니다. 그렇지 않으면 보이지 않게 유지하십시오."
// lg.panel_visibilityDescription: "Make the panel visible when the logic expression returns true. Otherwise keep it invisible." => "논리 표현식이 true를 반환할 때 패널이 표시되도록 합니다. 그렇지 않으면 보이지 않게 유지하십시오."
// lg.panel_enableDescription: "Make the panel, and all elements inside it, enable when the logic expression returns true. Otherwise keep them disabled." => "패널과 그 안의 모든 요소는 논리 표현식이 true를 반환할 때 활성화됩니다. 그렇지 않으면 비활성화 상태로 유지하십시오."
// lg.question_visibilityDescription: "Make the question visible when the logic expression returns true. Otherwise keep it invisible." => "논리 표현식이 true를 반환할 때 질문을 표시합니다. 그렇지 않으면 보이지 않게 유지하십시오."
// lg.question_enableDescription: "Make the question enable when the logic expression returns true. Otherwise keep it disabled." => "논리 표현식이 true를 반환할 때 질문을 활성화합니다. 그렇지 않으면 비활성화 상태로 유지하십시오."
// lg.question_requireDescription: "Question becomes required when the logic expression returns true." => "논리 표현식이 true를 반환할 때 질문이 필요합니다."
// lg.trigger_completeDescription: "When the logic expression returns true then the survey becomes completed and an end-user see the 'Thank you page'." => "논리 표현식이 true를 반환하면 설문 조사가 완료되고 최종 사용자에게 '감사 페이지'가 표시됩니다."
// lg.trigger_setvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value is set to the selected question." => "논리식에 사용된 질문 값이 변경되고 논리식이 true를 반환하면 값이 선택한 질문으로 설정됩니다."
// lg.trigger_copyvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value of one selected question is copied to another selected question." => "논리 표현식에 사용된 질문 값이 변경되고 논리 표현식이 true를 반환하면 선택한 한 질문의 값이 선택한 다른 질문에 복사됩니다."
// lg.trigger_skipDescription: "When the logic expression returns true then the survey skip to / focus the selected question." => "논리 표현식이 true를 반환하면 설문 조사는 선택한 질문으로 건너 뜁니다."
// lg.trigger_runExpressionDescription: "When the logic expression returns true, then the custom expression is performed. You may optionally set this expression result into the selected question" => "논리 표현식이 true를 반환하면 사용자 지정 표현식이 수행됩니다. 선택적으로 이 표현식 결과를 선택한 질문으로 설정할 수 있습니다"
// lg.completedHtmlOnConditionDescription: "If the logic expression returns true, then the default text for the 'Thank you page' is changed to the given one." => "논리 표현식이 true를 반환하면 'Thank you page'의 기본 텍스트가 지정된 텍스트로 변경됩니다."
// lg.itemExpressionText: "When expression: '{0}' returns true" => "표현식: '{0}'가 true를 반환하는 경우"
// lg.itemEmptyExpressionText: "New rule" => "새 규칙"
// lg.page_visibilityText: "make page {0} visible" => "페이지 {0} 표시"
// lg.panel_visibilityText: "make panel {0} visible" => "패널 {0} 표시"
// lg.panel_enableText: "make panel {0} enable" => "패널을 활성화{0}"
// lg.question_visibilityText: "make question {0} visible" => "질문 {0} 표시"
// lg.question_enableText: "make question {0} enable" => "질문 {0} 사용 설정"
// lg.question_requireText: "make question {0} required" => "질문 {0} 필수"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "질문의 열 {0} {1} 표시"
// lg.column_enableText: "make column {0} of question {1} enable" => "질문의 열 {0} {1} 사용하도록 설정"
// lg.column_requireText: "make column {0} of question {1} required" => "질문의 열 {0} {1} 필수"
// lg.trigger_completeText: "survey becomes completed" => "조사가 완료됩니다"
// lg.trigger_setvalueText: "set into question: {0} value {1}" => "질문으로 설정: {0} 값 {1}"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "명확한 질문 값: {0}"
// lg.trigger_copyvalueText: "copy into question: {0} value from question {1}" => "질문으로 복사: 질문 {1}의 {0} 값"
// lg.trigger_skipText: "survey skip to the question {0}" => "설문 조사 질문으로 건너 뛰기 {0}"
// lg.trigger_runExpressionText1: "run expression: '{0}'" => "실행 식: '{0}'"
// lg.trigger_runExpressionText2: " and set its result into question: {0}" => " 그 결과에 의문을 제기하십시오 : {0}"
// lg.completedHtmlOnConditionText: "show custom text for the 'Thank you page'." => "'감사 페이지'에 대한 사용자 지정 텍스트를 표시합니다."
// lg.showAllQuestions: "All Questions" => "모든 질문"
// lg.showAllActionTypes: "All Action Types" => "모든 작업 유형"
// lg.conditions: "Condition(s)" => "조건"
// lg.actions: "Action(s)" => "작업"
// lg.expressionEditorTitle: "Define condition(s)" => "조건 정의"
// lg.actionsEditorTitle: "Define action(s)" => "작업 정의"
// lg.deleteAction: "Delete Action" => "삭제 작업"
// lg.addNewAction: "Add Action" => "작업 추가"
// lg.selectedActionCaption: "Select action..." => "작업 선택..."
// lg.expressionInvalid: "The logic expression is empty or invalid. Please correct it." => "논리 표현식이 비어 있거나 올바르지 않습니다. 수정해 주세요."
// lg.noActionError: "Please, add at least one action." => "하나 이상의 작업을 추가하십시오."
// lg.actionInvalid: "Please, fix problems in your action(s)." => "귀하의 행동에서 문제를 해결하십시오."
// lg.uncompletedRule_title: "Logical rules are incomplete" => "논리적 규칙이 불완전합니다."
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "일부 논리적 규칙을 완료하지 않았습니다. 지금 탭을 나가면 변경 내용이 손실됩니다. 변경을 완료하지 않고 탭을 종료하시겠습니까?"
// lg.uncompletedRule_apply: "Yes" => "예"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "아니요, 규칙을 완료하고 싶습니다."
// pe.save: "Save" => "구해내다"
// pe.clear: "Clear" => "맑다"
// pe.saveTooltip: "Save" => "구해내다"
// pe.set: "Set" => "집합"
// pe.change: "Change" => "잔돈"
// pe.refresh: "Refresh" => "리프레쉬"
// pe.add: "Add" => "더하다"
// pe.removeItem: "Click to remove the item..." => "항목을 제거하려면 클릭하세요..."
// pe.dragItem: "Drag the item" => "항목을 드래그합니다"
// pe.addOther: "Other" => "다른"
// pe.addSelectAll: "Select All" => "모두 선택"
// pe.addNone: "None" => "없음"
// pe.back: "Return without saving" => "저장하지 않고 반환"
// pe.backTooltip: "Return without saving" => "저장하지 않고 반환"
// pe.saveAndBack: "Save and return" => "저장 및 반환"
// pe.saveAndBackTooltip: "Save and return" => "저장 및 반환"
// pe.doneEditing: "Done" => "수행"
// pe.showChoices: "Show Choices" => "선택 항목 표시"
// pe.emptyValue: "Value is empty" => "값이 비어 있습니다."
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "'{0}' 값은 고유하지 않습니다."
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "항목 수를 {0}개에서 {1}개로 제한하십시오."
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "다음 형식으로 데이터를 설정할 수 있습니다.\nvalue1|텍스트\n값2"
// pe.itemSelectorEmpty: "Please select the element" => "요소를 선택해 주세요"
// pe.conditionActionEmpty: "Please select the action" => "작업을 선택하십시오."
// pe.conditionSelectPage: "Select page..." => "페이지 선택..."
// pe.conditionSelectPanel: "Select panel..." => "패널 선택..."
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "설문조사를 제출하기 전에 답변 미리 보기"
// pe.overridingPropertyPrefix: "Set by " => "설정 기준 "
// pe.propertyIsNoUnique: "Please enter a unique value" => "고유한 값을 입력하십시오."
// pe.propertyNameIsNotUnique: "Please enter a unique name" => "고유한 이름을 입력하십시오."
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "예약어를 사용하지 마십시오: \"item\", \"choice\", \"panel\", \"row\"."
// pe.listIsEmpty: "No items have been added yet" => "아직 추가된 항목이 없습니다."
// pe.listIsEmpty@choices: "No choices have been added yet" => "선택 항목이 아직 추가되지 않았습니다"
// pe.addNew@choices: "Add a choice" => "선택 항목 추가"
// pe.expressionIsEmpty: "Expression is empty" => "식이 비어 있습니다."
// pe.rowid: "Row ID" => "행 ID"
// pe.imageLink: "Image or video URL" => "이미지 또는 동영상 URL"
// choicesbyurl.valueName: "Get values from the following JSON field" => "다음 JSON 필드에서 값 가져오기"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "다음 JSON 필드에서 이미지 URL을 가져옵니다."
// pe.allowEmptyResponse: "Allow empty response" => "빈 응답 허용"
// pe.titlePlaceholder: "Title" => "타이틀"
// pe.surveyTitlePlaceholder: "Survey Title" => "설문조사 제목"
// pe.pageTitlePlaceholder: "Page {num}" => "페이지 {num}"
// pe.descriptionPlaceholder: "Description" => "묘사"
// pe.surveyDescriptionPlaceholder: "Description" => "묘사"
// pe.pageDescriptionPlaceholder: "Description" => "묘사"
// pe.showNoneItem: "Allow the None option" => "없음 옵션 허용"
// pe.noneText: "None option text" => "없음 옵션 텍스트"
// pe.showSelectAllItem: "Allow the Select All option" => "모두 선택 옵션 허용"
// pe.selectAllText: "Select All option text" => "모두 선택 옵션 텍스트"
// pe.choicesMin: "Minimum value for auto-generated items" => "자동 생성된 항목의 최소값"
// pe.choicesMax: "Maximum value for auto-generated items" => "자동 생성된 항목의 최대값"
// pe.choicesStep: "Step for auto-generated items" => "자동 생성된 항목에 대한 단계"
// pe.isAllRowRequired: "Require answer for all rows" => "모든 행에 대한 응답 필요"
// pe.requiredErrorText: "\"Required\" error message" => "\"필수\" 오류 메시지"
// pe.cols: "Columns" => "열"
// pe.rateMin: "Minimum rate value" => "최소 요금 값"
// pe.rateMax: "Maximum rate value" => "최대 속도 값"
// pe.rateStep: "Rate step" => "속도 단계"
// pe.maxLength: "Maximum length (in characters)" => "최대 길이(문자)"
// pe.buildExpression: "Build" => "체격"
// pe.editExpression: "Edit" => "편집하다"
// pe.and: "and" => "그리고"
// pe.or: "or" => "또는"
// pe.remove: "Remove" => "제거하다"
// pe.addCondition: "Add Condition" => "조건 추가"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "질문을 선택하여 조건 구성을 시작합니다."
// pe.if: "If" => "면"
// pe.then: "then" => "그러면"
// pe.setToName: "Target question" => "대상 질문"
// pe.fromName: "Question to copy answer from" => "답변을 복사할 질문"
// pe.gotoName: "Question to skip to" => "건너뛸 질문"
// pe.ruleIsNotSet: "Rule is incorrect" => "규칙이 올바르지 않습니다."
// pe.includeIntoResult: "Include into survey results" => "설문조사 결과에 포함"
// pe.expandCollapseTitle: "Expand/collapse title" => "제목 확장/축소"
// pe.simulator: "Select device type" => "장치 유형 선택"
// pe.landscapeOrientation: "Switch to landscape orientation" => "가로 방향으로 전환"
// pe.portraitOrientation: "Switch to portrait orientation" => "세로 방향으로 전환"
// pe.previewText: "Preview Answers button text" => "답변 미리보기 버튼 텍스트"
// pe.editText: "Edit Answer button text" => "답변 편집 단추 텍스트"
// image.imageHeight: "Image height (in CSS-accepted values)" => "이미지 높이(CSS에서 허용하는 값)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "이미지 너비(CSS에서 허용하는 값)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "페이지 완료 시간 제한(초)"
// question.page: "Parent page" => "상위 페이지"
// pe.noEntriesText: "Empty entries text" => "빈 항목 텍스트"
// pe.html: "HTML markup" => "HTML 마크업"
// pe.expression: "Expression" => "식"
// pe.setValue: "Answer" => "대답"
// pe.dataFormat: "Image format" => "이미지 형식"
// pe.allowAddRows: "Allow adding rows" => "행 추가 허용"
// pe.allowRemoveRows: "Allow removing rows" => "행 제거 허용"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "행 끌어서 놓기 허용"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "정확한 이미지 너비 또는 높이를 지정하는 경우에는 적용되지 않습니다."
// pe.minImageWidth: "Minimum image width" => "최소 이미지 너비"
// pe.maxImageWidth: "Maximum image width" => "최대 이미지 너비"
// pe.minImageHeight: "Minimum image height" => "최소 이미지 높이"
// pe.maxImageHeight: "Maximum image height" => "최대 이미지 높이"
// pe.minValue: "Minimum value" => "최소값"
// pe.maxValue: "Maximum value" => "최대값"
// pe.minLength: "Minimum length (in characters)" => "최소 길이(문자)"
// pe.allowDigits: "Allow digits" => "숫자 허용"
// pe.minCount: "Minimum count" => "최소 개수"
// pe.maxCount: "Maximum count" => "최대 개수"
// pe.regex: "Regular expression" => "정규식"
// surveyvalidator.text: "Error message" => "오류 메시지"
// surveyvalidator.expression: "Validation expression" => "유효성 검사 표현식"
// pe.totalText: "Total row text" => "전체 행 텍스트"
// pe.totalType: "Total type" => "합계 유형"
// pe.totalExpression: "Total expression" => "총 표현식"
// pe.totalDisplayStyle: "Total value display style" => "총액 표시 스타일"
// pe.totalCurrency: "Currency" => "통화"
// pe.totalFormat: "Formatted string" => "서식이 지정된 문자열"
// pe.logo: "Logo (URL or base64-encoded string)" => "로고(URL 또는 base64로 인코딩된 문자열)"
// pe.questionsOnPageMode: "Survey structure" => "설문조사 구조"
// pe.maxTextLength: "Maximum answer length (in characters)" => "최대 답변 길이(문자 단위)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "최대 주석 길이(문자)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "필요한 경우 주석 영역 자동 확장"
// pe.allowResizeComment: "Allow users to resize text areas" => "사용자가 텍스트 영역의 크기를 조정할 수 있도록 허용"
// pe.textUpdateMode: "Update text question value" => "텍스트 질문 값 업데이트"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "첫 번째 오답에 포커스 설정"
// pe.checkErrorsMode: "Run validation" => "유효성 검사 실행"
// pe.navigateToUrl: "Navigate to URL" => "URL로 이동합니다."
// pe.navigateToUrlOnCondition: "Dynamic URL" => "동적 URL"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "사용자가 이미 이 설문조사를 작성했는지 여부를 표시하는 마크업"
// pe.completedHtml: "Survey Complete page markup" => "설문조사 완료 페이지 마크업"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "동적 설문조사 완료 페이지 마크업"
// pe.loadingHtml: "Markup to show while survey model is loading" => "측량 모델이 로드되는 동안 표시할 마크업"
// pe.commentText: "Comment area text" => "주석 영역 텍스트"
// pe.autocomplete: "Autocomplete type" => "자동 완성 유형"
// pe.labelTrue: "\"True\" label" => "\"True\" 레이블"
// pe.labelFalse: "\"False\" label" => "\"거짓\" 레이블"
// pe.allowClear: "Show the Clear button" => "지우기 단추 표시"
// pe.displayStyle: "Value display style" => "값 표시 스타일"
// pe.format: "Formatted string" => "서식이 지정된 문자열"
// pe.maximumFractionDigits: "Maximum fractional digits" => "최대 소수 자릿수"
// pe.minimumFractionDigits: "Minimum fractional digits" => "최소 소수 자릿수"
// pe.useGrouping: "Display grouping separators" => "그룹화 구분 기호 표시"
// pe.allowMultiple: "Allow multiple files" => "여러 파일 허용"
// pe.allowImagesPreview: "Preview images" => "이미지 미리보기"
// pe.acceptedTypes: "Accepted file types" => "허용되는 파일 형식"
// pe.waitForUpload: "Wait for the upload to complete" => "업로드가 완료될 때까지 기다리세요"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "파일 삭제 확인"
// pe.detailPanelMode: "Detail panel location" => "세부 정보 패널 위치"
// pe.minRowCount: "Minimum row count" => "최소 행 개수"
// pe.maxRowCount: "Maximum row count" => "최대 행 개수"
// pe.confirmDelete: "Confirm row deletion" => "행 삭제 확인"
// pe.confirmDeleteText: "Confirmation message" => "확인 메시지"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "패널 삭제 확인"
// pe.panelCount: "Initial panel count" => "초기 패널 수"
// pe.minPanelCount: "Minimum panel count" => "최소 패널 수"
// pe.maxPanelCount: "Maximum panel count" => "최대 패널 수"
// pe.panelsState: "Inner panel expand state" => "내부 패널 확장 상태"
// pe.templateDescription: "Description template" => "설명 템플릿"
// pe.templateTitle: "Title template" => "제목 템플릿"
// pe.panelPrevText: "Previous Panel button tooltip" => "이전 패널 단추 도구 설명"
// pe.panelNextText: "Next Panel button tooltip" => "다음 패널 단추 도구 설명"
// pe.showRangeInProgress: "Show progress bar" => "진행률 표시줄 표시"
// pe.templateTitleLocation: "Question title location" => "질문 제목 위치"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "패널 단추 위치 제거"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "행이 없는 경우 질문 숨기기"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "행이 없는 경우 열 숨기기"
// pe.rateValues: "Custom rate values" => "사용자 지정 요금 값"
// pe.rateCount: "Rate count" => "비율 개수"
// pe.autoGenerate: "How to specify rate values?" => "비율 값을 지정하는 방법은 무엇입니까?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "선택 항목이 없는 경우 질문 숨기기"
// pe.hideNumber: "Hide question number" => "질문 번호 숨기기"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "최소 너비(CSS에서 허용하는 값)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "최대 너비(CSS에서 허용하는 값)"
// pe.width: "Width (in CSS-accepted values)" => "너비(CSS에서 허용하는 값)"
// pe.showHeader: "Show column headers" => "열 머리글 표시"
// pe.horizontalScroll: "Show horizontal scrollbar" => "가로 스크롤 막대 표시"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "최소 열 너비(CSS에서 허용하는 값)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "행 머리글 너비(CSS에서 허용하는 값)"
// pe.valueTrue: "\"True\" value" => "\"True\" 값"
// pe.valueFalse: "\"False\" value" => "\"False\" 값"
// pe.minErrorText: "\"Value is below minimum\" error message" => "\"값이 최소값 미만입니다.\" 오류 메시지"
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "\"값이 최대값을 초과합니다.\" 오류 메시지"
// pe.otherErrorText: "\"Empty comment\" error message" => "'빈 댓글' 오류 메시지"
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "\"고유하지 않은 키 값\" 오류 메시지"
// pe.minSelectedChoices: "Minimum selected choices" => "선택한 최소 선택 항목"
// pe.maxSelectedChoices: "Maximum selected choices" => "선택한 최대 선택 항목 수"
// pe.showClearButton: "Show the Clear button" => "지우기 단추 표시"
// pe.showNumber: "Show panel number" => "패널 번호 표시"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "로고 너비(CSS에서 허용하는 값)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "로고 높이(CSS에서 허용하는 값)"
// pe.readOnly: "Read-only" => "읽기 전용"
// pe.enableIf: "Editable if" => "다음과 같은 경우 편집 가능"
// pe.emptyRowsText: "\"No rows\" message" => "'행 없음' 메시지"
// pe.size: "Input field size (in characters)" => "입력 필드 크기(문자)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "별도의 특수 선택(없음, 기타, 모두 선택)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "다음 질문에서 선택 항목을 복사합니다."
// pe.choicesFromQuestionMode: "Which choices to copy?" => "어떤 선택 항목을 복사해야 합니까?"
// pe.showCommentArea: "Show the comment area" => "주석 영역 표시"
// pe.commentPlaceholder: "Comment area placeholder" => "주석 영역 자리 표시자"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "속도 설명을 극한 값으로 표시"
// pe.rowsOrder: "Row order" => "행 순서"
// pe.columnsLayout: "Column layout" => "열 레이아웃"
// pe.columnColCount: "Nested column count" => "중첩된 열 개수"
// pe.state: "Panel expand state" => "패널 확장 상태"
// pe.correctAnswer: "Correct Answer" => "정답"
// pe.defaultPanelValue: "Default Values" => "기본값"
// pe.cells: "Cell Texts" => "셀 텍스트"
// pe.keyName: "Key column" => "키 열"
// itemvalue.text: "Alt text" => "대체 텍스트"
// pe.logoPosition: "Logo position" => "로고 위치"
// pe.addLogo: "Add logo..." => "로고 추가..."
// pe.changeLogo: "Change logo..." => "로고 변경..."
// logoPositions.none: "Remove logo" => "로고 제거"
// logoPositions.left: "Left" => "왼쪽"
// logoPositions.right: "Right" => "오른쪽"
// logoPositions.top: "On the top" => "맨 위에"
// logoPositions.bottom: "In the bottom" => "하단에"
// tabs.requiredIf: "Required If" => "다음과 같은 경우 필수입니다."
// tabs.numbering: "Numbering" => "번호 매기기"
// tabs.pages: "Pages" => "페이지"
// tabs.calculatedValues: "Calculated Values" => "계산된 값"
// tabs.totals: "Totals" => "합계"
// tabs.logic: "Logic" => "논리학"
// tabs.layout: "Layout" => "레이아웃"
// tabs.data: "Data" => "데이터"
// tabs.validation: "Validation" => "유효성 검사"
// tabs.cells: "Cell Texts" => "셀 텍스트"
// tabs.showOnCompleted: "Survey Complete" => "설문조사 완료"
// tabs.logo: "Logo in Survey Title" => "설문조사 제목의 로고"
// tabs.slider: "Slider" => "슬라이더"
// tabs.expression: "Expression" => "식"
// tabs.others: "Others" => "다른"
// pe.choicesVisibleIf: "Choices are visible if" => "다음과 같은 경우 선택 항목이 표시됩니다."
// pe.choicesEnableIf: "Choices are selectable if" => "다음과 같은 경우 선택 항목을 선택할 수 있습니다."
// pe.columnsEnableIf: "Columns are visible if" => "다음과 같은 경우 열이 표시됩니다."
// pe.rowsEnableIf: "Rows are visible if" => "다음과 같은 경우 행이 표시됩니다."
// pe.indent: "Add indents" => "들여쓰기 추가"
// panel.indent: "Add outer indents" => "바깥쪽 들여쓰기 추가"
// pe.innerIndent: "Add inner indents" => "내부 들여쓰기 추가"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "마지막 행에서 기본값 가져오기"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "마지막 패널에서 기본값 가져 오기"
// pe.titleKeyboardAdornerTip: "Press enter button to edit" => "Enter 버튼을 눌러 편집합니다."
// pe.keyboardAdornerTip: "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item" => "항목을 편집하려면 Enter 버튼을 누르고, 항목을 삭제하려면 삭제 버튼을 누르고, 항목을 이동하려면 alt 더하기 화살표 위쪽 또는 아래쪽 화살표를 누릅니다."
// pe.triggerFromName: "Copy value from: " => "다음에서 값 복사: "
// pe.triggerRunExpression: "Run this Expression" => "이 표현식을 실행합니다."
// pe.triggerGotoName: "Go to the question" => "질문으로 이동"
// pe.triggerRunExpressionEmpty: "Please enter a valid expression" => "올바른 표현식을 입력하십시오."
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "여기에 표현식을 입력하십시오 ..."
// pe.noFile: "No file choosen" => "선택한 파일 없음"
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "질문이 숨겨지면 값을 지웁니다"
// pe.valuePropertyName: "Value property name" => "값 속성 이름"
// pe.searchEnabled: "Enable search" => "검색 사용"
// pe.hideSelectedItems: "Hide selected items" => "선택한 항목 숨기기"
// pe.closeOnSelect: "Close the dropdown after selection" => "선택 후 드롭다운을 닫습니다."
// pe.signatureWidth: "Signature width" => "서명 너비"
// pe.signatureHeight: "Signature height" => "서명 높이"
// pe.verticalAlign: "Vertical alignment" => "수직 정렬"
// pe.alternateRows: "Alternate rows" => "대체 행"
// pe.columnsVisibleIf: "Columns are visible if" => "다음과 같은 경우 열이 표시됩니다."
// pe.rowsVisibleIf: "Rows are visible if" => "다음과 같은 경우 행이 표시됩니다."
// pe.otherPlaceholder: "Comment area placeholder" => "주석 영역 자리 표시자"
// pe.rateType: "Rate type" => "비율 유형"
// pv.true: "true" => "참"
// pv.false: "false" => "거짓"
// pv.decimal: "decimal" => "십진법"
// pv.currency: "currency" => "통화"
// pv.percent: "percent" => "퍼센트"
// pv.onpanel: "Start on each panel" => "각 패널에서 시작"
// pv.tab: "Tabs" => "탭"
// pv.both: "Both" => "둘다"
// pv.right: "Right" => "오른쪽"
// pv.color: "color" => "색"
// pv.date: "date" => "날짜"
// pv.datetime: "datetime" => "날짜/시간"
// pv.datetime-local: "datetime-local" => "날짜/시간 로컬"
// pv.email: "email" => "이메일"
// pv.month: "month" => "달"
// pv.number: "number" => "수"
// pv.password: "password" => "암호"
// pv.range: "range" => "레인지"
// pv.tel: "tel" => "전화"
// pv.text: "text" => "문자 메시지"
// pv.time: "time" => "시간"
// pv.url: "url" => "URL (영문)"
// pv.week: "week" => "주"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "질문 또는 해당 패널/페이지가 숨겨지는 경우"
// clearInvisibleValues.none: "Never" => "결코"
// inputType.color: "Color" => "색"
// inputType.date: "Date" => "날짜"
// inputType.datetime-local: "Date and Time" => "날짜 및 시간"
// inputType.email: "Email" => "이메일"
// inputType.month: "Month" => "달"
// inputType.number: "Number" => "수"
// inputType.password: "Password" => "암호"
// inputType.range: "Range" => "레인지"
// inputType.tel: "Phone Number" => "전화번호"
// inputType.text: "Text" => "문자 메시지"
// inputType.time: "Time" => "시간"
// inputType.url: "URL" => "URL (영문)"
// inputType.week: "Week" => "주"
// pv.onValueChanging: "Before an answer is changed" => "답변이 변경되기 전에"
// pv.standard: "Original structure" => "원래 구조"
// pv.singlePage: "All questions on a single page" => "한 페이지에 있는 모든 질문"
// pv.questionPerPage: "Each question on an individual page" => "개별 페이지의 각 질문"
// pv.noPreview: "No preview" => "미리보기 없음"
// pv.showAllQuestions: "Show all questions" => "모든 질문 표시"
// pv.showAnsweredQuestions: "Show answered questions only" => "답변된 질문만 표시"
// pv.pages: "Completed pages" => "완성된 페이지"
// pv.questions: "Answered questions" => "답변된 질문"
// pv.requiredQuestions: "Answered required questions" => "필수 질문에 답변했습니다."
// pv.correctQuestions: "Valid answers" => "유효한 답변"
// pv.buttons: "Completed pages (button UI)" => "완성된 페이지(버튼 UI)"
// pv.underInput: "Under the input" => "입력 아래"
// pv.underTitle: "Under the title" => "제목 아래"
// pv.onBlur: "On blur" => "흐림 현상"
// pv.onTyping: "While typing" => "입력하는 동안"
// pv.underRow: "Under the row" => "행 아래"
// pv.underRowSingle: "Under the row, only one panel is visible" => "행 아래에는 하나의 패널만 표시됩니다"
// showNavigationButtons.none: "Hidden" => "숨겨진"
// showProgressBar.off: "Hidden" => "숨겨진"
// showTimerPanel.none: "Hidden" => "숨겨진"
// showTimerPanelMode.all: "Both" => "둘다"
// detailPanelMode.none: "Hidden" => "숨겨진"
// addRowLocation.default: "Depends on matrix layout" => "행렬 레이아웃에 따라 다름"
// panelsState.default: "Users cannot expand or collapse panels" => "사용자는 패널을 확장하거나 축소할 수 없습니다."
// panelsState.collapsed: "All panels are collapsed" => "모든 패널이 축소됩니다"
// panelsState.expanded: "All panels are expanded" => "모든 패널이 확장됩니다."
// widthMode.auto: "Auto" => "자동"
// widthMode.static: "Static" => "정적인"
// widthMode.responsive: "Responsive" => "반응"
// imageFit.none: "None" => "없음"
// imageFit.contain: "Contain" => "포함하다"
// imageFit.cover: "Cover" => "표지"
// imageFit.fill: "Fill" => "채우다"
// contentMode.auto: "Auto" => "자동"
// contentMode.image: "Image" => "이미지"
// contentMode.video: "Video" => "비디오"
// contentMode.youtube: "YouTube" => "유튜브"
// displayMode.auto: "Auto" => "자동"
// displayMode.buttons: "Buttons" => "단추"
// displayMode.dropdown: "Dropdown" => "드롭다운(Dropdown)"
// rateColorMode.default: "Default" => "기본값"
// autoGenerate.true: "Generate" => "창조하다"
// autoGenerate.false: "Enter manually" => "수동으로 입력"
// rateType.labels: "Labels" => "레이블"
// rateType.stars: "Stars" => "별"
// rateType.smileys: "Smileys" => "스마일리"
// op.anyof: "Any of" => "다음 중 하나"
// op.allof: "All of" => "모든"
// op.and: "and" => "그리고"
// op.or: "or" => "또는"
// ew.modern: "Modern theme" => "현대 테마"
// ew.default: "Default theme" => "기본 테마"
// ew.orange: "Orange theme" => "오렌지 테마"
// ew.darkblue: "Darkblue theme" => "진한 파란색 테마"
// ew.darkrose: "Darkrose theme" => "다크로즈 테마"
// ew.stone: "Stone theme" => "돌 테마"
// ew.winter: "Winter theme" => "겨울 테마"
// ew.winterstone: "Winter-Stone theme" => "겨울 돌 테마"
// ts.showInvisibleElements: "Show invisible elements" => "보이지 않는 요소 표시"
// ts.hideInvisibleElements: "Hide invisible elements" => "보이지 않는 요소 숨기기"
// triggers.copyvaluetrigger: "Copy answer" => "답변 복사"
// triggers.skiptrigger: "Skip to question" => "질문으로 건너뛰기"
// triggers.runexpressiontrigger: "Run expression" => "표현식 실행"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "쿠키는 사용자가 동일한 설문조사를 두 번 작성하는 것을 방지합니다."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "입력 필드의 표시 영역을 조정합니다. <b>유효성 검사 → 최대 길이</b> 설정을 사용하여 입력 길이를 제한하십시오."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "{0} 실제 값의 자리 표시자로 사용합니다."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "하나 이상의 열에 Total 유형 또는 Total 표현식이 있는 경우에만 표시됩니다."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "자세한 내용은 [accept](https://www.w3schools.com/tags/att_input_accept.asp) 속성 설명을 참조하십시오."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Radiogroup 및 Checkbox 셀 유형에만 적용할 수 있습니다."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "자세한 내용은 [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) 속성 설명을 참조하십시오."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "이 속성을 설정하지 않으면 대답이 Name 속성으로 지정된 필드에 저장됩니다."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "지정된 열에 동일한 값이 포함되어 있으면 현장조사에서 \"고유하지 않은 키 값\" 오류가 발생합니다."
// p.multiSelect: "Allow multiple selection" => "다중 선택 허용"
// p.showLabel: "Show image captions" => "이미지 캡션 표시"
// p.value: "Value" => "값"
// p.tabAlign: "Tab alignment" => "탭 정렬"
// p.logoFit: "Logo fit" => "로고 핏"
// p.pages: "Pages" => "페이지"
// p.questions: "Questions" => "질문"
// p.calculatedValues: "Calculated values" => "계산된 값"
// p.surveyId: "Survey id" => "설문조사 ID"
// p.surveyPostId: "Survey post id" => "설문조사 게시물 ID"
// p.surveyShowDataSaving: "Survey show data saving" => "설문 조사 쇼 데이터 저장"
// p.questionDescriptionLocation: "Question description location" => "질문 설명 위치"
// p.progressBarType: "Progress bar type" => "진행률 표시줄 유형"
// p.showTOC: "Show TOC" => "TOC 표시"
// p.tocLocation: "Toc location" => "목차 위치"
// p.questionTitlePattern: "Question title pattern" => "질문 제목 패턴"
// p.widthMode: "Width mode" => "폭 모드"
// p.showBrandInfo: "Show brand info" => "브랜드 정보 표시"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "동적 텍스트에서 표시 값 사용Use display values in dynamic texts"
// p.descriptionLocation: "Description location" => "설명 위치"
// p.defaultValueExpression: "Default value expression" => "기본값 표현식"
// p.requiredIf: "Required if" => "다음과 같은 경우 필수입니다."
// p.bindings: "Bindings" => "바인딩"
// p.renderAs: "Render as" => "렌더링 형식"
// p.attachOriginalItems: "Attach original items" => "원본 항목 첨부"
// p.cellHint: "Cell hint" => "셀 힌트"
// p.isUnique: "Is unique" => "독특하다."
// p.showInMultipleColumns: "Show in multiple columns" => "여러 열에 표시"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "총 최대 자릿수"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "총 최소 자릿수"
// p.detailElements: "Detail elements" => "세부 요소"
// p.allowAdaptiveActions: "Allow adaptive actions" => "적응형 작업 허용"
// p.defaultRowValue: "Default row value" => "기본 행 값"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "추가 시 세부 정보 패널 표시"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "선택 지연 로드 사용"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "선택 지연 로드 페이지 크기"
// p.inputFieldComponent: "Input field component" => "입력 필드 구성 요소"
// p.itemComponent: "Item component" => "항목 구성 요소"
// p.min: "Min" => "분"
// p.max: "Max" => "최대"
// p.minValueExpression: "Min value expression" => "최소값 표현식"
// p.maxValueExpression: "Max value expression" => "최대값 표현식"
// p.step: "Step" => "걸음"
// p.dataList: "Data list" => "데이터 목록"
// p.elements: "Elements" => "요소"
// p.content: "Content" => "콘텐츠"
// p.navigationTitle: "Navigation title" => "탐색 제목"
// p.navigationDescription: "Navigation description" => "탐색 설명"
// p.longTap: "Long tap" => "길게 탭하기"
// p.autoGrow: "Auto grow" => "자동 성장"
// p.allowResize: "Allow resizing" => "크기 조정 허용"
// p.acceptCarriageReturn: "Accept carriage return" => "캐리지 리턴 수락"
// p.displayMode: "Display mode" => "디스플레이 모드"
// p.rateType: "Rate type" => "비율 유형"
// p.contentMode: "Content mode" => "콘텐츠 모드"
// p.imageFit: "Image fit" => "이미지 핏"
// p.altText: "Alt text" => "대체 텍스트"
// p.height: "Height" => "높이"
// p.penColor: "Pen color" => "펜 색상"
// p.backgroundColor: "Background color" => "배경색"
// p.templateElements: "Template elements" => "템플릿 요소"
// p.operator: "Operator" => "연산자"
// p.isVariable: "Is variable" => "가변적이다"
// p.runExpression: "Run expression" => "표현식 실행"
// p.showCaption: "Show caption" => "캡션 표시"
// p.iconName: "Icon name" => "아이콘 이름"
// p.iconSize: "Icon size" => "아이콘 크기"
// p.precision: "Precision" => "정밀"
// p.matrixDragHandleArea: "Matrix drag handle area" => "매트릭스 끌기 핸들 영역"
// p.backgroundImage: "Background image" => "배경 이미지"
// p.backgroundImageFit: "Background image fit" => "배경 이미지 맞춤"
// p.backgroundImageAttachment: "Background image attachment" => "배경 이미지 첨부"
// p.backgroundOpacity: "Background opacity" => "배경 불투명도"
// p.selectToRankEnabled: "Select to rank enabled" => "사용 가능한 순위를 선택하려면 선택합니다."
// p.selectToRankAreasLayout: "Select to rank areas layout" => "영역 레이아웃의 순위를 지정하려면 선택합니다."
// p.allowCameraAccess: "Allow camera access" => "카메라 액세스 허용"
// p.scaleColorMode: "Scale color mode" => "스케일 컬러 모드"
// p.rateColorMode: "Rate color mode" => "비율 색상 모드"
// p.templateTabTitle: "Template tab title" => "템플릿 탭 제목"
// p.templateVisibleIf: "Template visible if" => "다음과 같은 경우 템플릿이 표시됩니다."
// p.copyDisplayValue: "Copy display value" => "표시 값 복사"
// theme.--background: "Background color" => "배경색"
// theme.--background-dim-light: "Background dim light color" => "배경 희미한 밝은 색"
// theme.--primary-foreground: "Primary foreground color" => "기본 전경색"
// theme.--foreground: "Foreground color" => "전경색"
// theme.--base-unit: "Base unit" => "베이스 유닛"
// theme.groupAdvanced: "Advanced" => "고급"
// theme.themeName: "Theme" => "주제"
// theme.isPanellessss: "Question appearance" => "질문 모양"
// theme.isPanellessPanels: "Default" => "기본값"
// theme.isPanellessLightweight: "Without Panels" => "패널 없음"
// theme.themePaletteLight: "Light" => "광"
// theme.themePaletteDark: "Dark" => "어둠"
// theme.primaryColor: "Accent color" => "강조 색상"
// theme.primaryDefaultColor: "Default" => "기본값"
// theme.primaryDarkColor: "Hover" => "호버"
// theme.primaryLightColor: "Selected" => "선택한"
// theme.backgroundDimColor: "Background color" => "배경색"
// theme.backgroundImage: "Background image" => "배경 이미지"
// theme.backgroundImageFitAuto: "Auto" => "자동"
// theme.backgroundImageFitCover: "Cover" => "표지"
// theme.backgroundImageFitContain: "Contain" => "포함하다"
// theme.backgroundOpacity: "Opacity" => "불투명도"
// theme.backgroundImageAttachmentFixed: "Fixed" => "부정하게 결정된"
// theme.backgroundImageAttachmentScroll: "Scroll" => "스크롤"
// theme.panelBackgroundTransparency: "Panel background opacity" => "패널 배경 불투명도"
// theme.questionBackgroundTransparency: "Question background opacity" => "질문 배경 불투명도"
// theme.questionPanel: "Panel background and corner radius" => "패널 배경 및 모서리 반경"
// theme.questionTitle: "Question title font" => "질문 제목 글꼴"
// theme.questionDescription: "Question description font" => "질문 설명 글꼴"
// theme.editorPanel: "Input element" => "입력 요소"
// theme.editorFont: "Input element font" => "입력 요소 글꼴"
// theme.backcolor: "Default background" => "기본 배경"
// theme.hovercolor: "Hover background" => "배경 가리키기"
// theme.borderDecoration: "Border decoration" => "테두리 장식"
// theme.accentBackground: "Accent background" => "악센트 배경"
// theme.accentForeground: "Accent foreground" => "악센트 전경"
// theme.primaryForecolor: "Default color" => "기본 색상"
// theme.primaryForecolorLight: "Disabled color" => "비활성화 된 색상"
// theme.linesColors: "Minor line colors" => "보조 선 색상"
// theme.borderDefault: "Darker" => "어두운"
// theme.borderLight: "Lighter" => "라이터"
// theme.fontFamily: "Font family" => "글꼴 패밀리"
// theme.fontSize: "Font size" => "글자 크기"
// theme.color: "Color" => "색"
// theme.size: "Size" => "크기"
// theme.fontWeightRegular: "Regular" => "일반"
// theme.fontWeightHeavy: "Heavy" => "무겁다"
// theme.fontWeightSemiBold: "Semi-bold" => "세미 굵게"
// theme.fontWeightBold: "Bold" => "대담한"
// theme.scale: "Scale" => "저울"
// theme.cornerRadius: "Corner radius" => "코너 반경"
// theme.surveyTitleFont: "Survey title font" => "설문조사 제목 글꼴"
// theme.pageTitle: "Page title font" => "페이지 제목 글꼴"
// theme.pageDescription: "Page description font" => "페이지 설명 글꼴"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "그림자 효과 추가"
// theme.opacity: "Opacity" => "불투명도"
// theme.boxShadowBlur: "Blur" => "흐리게"
// theme.boxShadowSpread: "Spread" => "전파"
// theme.boxShadowDrop: "Drop" => "방울"
// theme.boxShadowInner: "Inner" => "내부"
// theme.questionShadow: "Shadow effects" => "그림자 효과"
// theme.editorShadow: "Input element shadow effects" => "입력 요소 그림자 효과"
// names.default: "Default" => "기본값"
// names.contrast: "Contrast" => "대조"
// names.plain: "Plain" => "평야"
// names.simple: "Simple" => "간단한"
// names.blank: "Blank" => "빈"
// names.double: "Double" => "배"
// names.bulk: "Bulk" => "부피"
// names.pseudo-3d: "Pseudo 3D" => "유사 3D"
// names.playful: "Playful" => "장난이 심"
// names.ultra: "Ultra" => "울트라"
// colors.teal: "Teal" => "청록"
// colors.blue: "Blue" => "파랑"
// colors.purple: "Purple" => "보라색"
// colors.orchid: "Orchid" => "난초"
// colors.tulip: "Tulip" => "튤립"
// colors.brown: "Brown" => "갈색"
// colors.green: "Green" => "녹색"
// names.sharp: "Sharp" => "날카로운"
// names.borderless: "Borderless" => "국경"
// names.flat: "Flat" => "플랫"
// names.doubleborder: "Double Border" => "이중 테두리"
// names.layered: "Layered" => "계층"
// names.solid: "Solid" => "고체"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "이 언어에 대한 모든 문자열을 삭제하시겠습니까?"
// ed.themeResetButton: "Reset theme settings to default" => "테마 설정을 기본값으로 재설정"
// theme.placeholderColor: "Placeholder color" => "자리 표시자 색"
// ed.themeSettings: "Theme Settings" => "테마 설정"
// ed.themeSettingsTooltip: "Open theme settings" => "테마 설정 열기"
// pe.resetToDefaultCaption: "Reset" => "재설정"
// pv.file: "Local files" => "로컬 파일"
// pv.camera: "Camera" => "사진기"
// pv.file-camera: "Local files or camera" => "로컬 파일 또는 카메라"
// ed.translateUsigAI: "Auto-translate All" => "모두 자동 번역"
// ed.translationDialogTitle: "Untranslated strings" => "번역되지 않은 문자열"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "최소 {0} 항목을 입력하십시오."
// lg.question_resetValueName: "Reset question value" => "질문 값 재설정"
// lg.column_resetValue: "Reset column value" => "열 값 재설정"
// pe.markRequired: "Mark as required" => "필요에 따라 표시"
// pe.removeRequiredMark: "Remove the required mark" => "필요한 표시를 제거하십시오"
// p.resetValueIf: "Reset value if" => "다음과 같은 경우 값을 재설정합니다."
// lg.question_setValueName: "Set question value" => "질문 값 설정"
// lg.column_resetValueName: "Reset column value" => "열 값 재설정"
// lg.column_setValueName: "Set column value" => "열 값 설정"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " 결과가 대상 질문에 할당되는 식입니다."
// survey.title: "Title" => "타이틀"
// page.title: "Title" => "타이틀"
// p.setValueIf: "Set value if" => "다음과 같은 경우 값을 설정합니다."
// theme.header: "Header" => "머리글"
// theme.backgroundImageFitFill: "Stretch" => "뻗다"
// theme.backgroundImageFitTile: "Tile" => "타일"
// theme.headerView: "View" => "보기"
// theme.headerViewBasic: "Basic" => "기초의"
// theme.headerViewAdvanced: "Advanced" => "고급"
// theme.headerInheritWidthFrom: "Content area width" => "콘텐츠 영역 너비"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "설문조사와 동일"
// theme.headerInheritWidthFromPage: "Fit to page" => "페이지에 맞추기"
// theme.headerTextAreaWidth: "Text width" => "텍스트 너비"
// theme.headerBackgroundColorSwitch: "Background color" => "배경색"
// theme.headerBackgroundColorNone: "None" => "없음"
// theme.headerBackgroundColorAccentColor: "Accent color" => "강조 색상"
// theme.headerBackgroundColorCustom: "Custom" => "관습"
// theme.horizontalAlignmentLeft: "Left" => "왼쪽"
// theme.horizontalAlignmentCenter: "Center" => "중"
// theme.horizontalAlignmentRight: "Right" => "오른쪽"
// theme.verticalAlignmentTop: "Top" => "맨 위로"
// theme.verticalAlignmentMiddle: "Middle" => "중간"
// theme.verticalAlignmentBottom: "Bottom" => "밑바닥"
// theme.logoPosition: "Logo Position" => "로고 위치"
// theme.headerTitlePosition: "Title Position" => "타이틀 포지션"
// theme.headerDescriptionPosition: "Description Position" => "설명 위치"
// lg.question_resetValueText: "reset value for question: {0}" => "질문에 대한 재설정 값: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "할당 값: {1} 질문: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "열의 셀 값 재설정: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "셀 값 할당 : {1} 열 : {0}"
// ed.surveyJsonExportButton: "Export" => "수출"
// ed.surveyJsonImportButton: "Import" => "수입"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "클립보드에 복사"
// pe.filePlaceholder: "File placeholder text" => "파일 자리 표시자 텍스트"
// pe.photoPlaceholder: "Photo placeholder text" => "사진 자리 표시자 텍스트"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "파일 또는 사진 자리 표시자 텍스트"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "\"소스 유형\"이 \"로컬 파일\"이거나 카메라를 사용할 수 없는 경우에 적용됩니다."
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "\"소스 유형\"이 \"카메라\"인 경우에 적용됩니다."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "\"소스 유형\"이 \"로컬 파일 또는 카메라\"인 경우에 적용됩니다."
// theme.background: "Background" => "배경"
// theme.appearance: "Appearance" => "외관"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "테마를 재설정 하시겠습니까? 모든 사용자 지정이 손실됩니다."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "예, 테마를 재설정합니다."
// theme.headerInheritWidthFromContainer: "Fit to container" => "콘테이너에 적합"
// signaturepad.showPlaceholder: "Show the placeholder" => "자리 표시자 표시"
// signaturepad.placeholder: "Placeholder text" => "자리 표시자 텍스트"
// theme.surveyDescriptionFont: "Survey description font" => "설문조사 설명 글꼴"
// ed.prevFocus: "Focus previous" => "포커스 이전"
// ed.nextFocus: "Focus next" => "다음 초점"
// ed.saveTheme: "Save Theme" => "테마 저장"
// ed.saveThemeTooltip: "Save Theme" => "테마 저장"
// lg.page_requireName: "Make page required" => "페이지를 필수로 설정"
// lg.panel_requireName: "Make page required" => "페이지를 필수로 설정"
// signaturepad.signatureWidth: "Signature area width" => "서명 영역 너비"
// signaturepad.signatureHeight: "Signature area height" => "서명 영역 높이"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "서명 영역 자동 크기 조정"
// signaturepad.penMinWidth: "Minimum pen width" => "최소 펜 너비"
// signaturepad.penMaxWidth: "Maximum pen width" => "최대 펜 너비"
// ed.propertyGridNoResultsFound: "No results found" => "결과를 찾을 수 없습니다."
// pv.leftRight: "Left and right" => "왼쪽 및 오른쪽"
// p.sourceType: "Source type" => "소스 유형"
// p.fitToContainer: "Fit to container" => "컨테이너에 맞추기"
// p.setValueExpression: "Set value expression" => "설정 값 표현식"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "선택 항목은 웹 서비스에서 로드됩니다."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "설정으로 바로 가기"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "로드된 선택 옵션 미리보기"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "행의 중복 응답 방지"
// theme.advancedMode: "Advanced mode" => "어드밴스드 모드"
// theme.backgroundCornerRadius: "Background and corner radius" => "배경 및 모서리 반경"
// theme.colorsTitle: "Colors" => "색상"
// theme.font: "Font" => "글꼴"
// theme.lines: "Lines" => "라인"
// theme.titleFont: "Title font" => "제목 글꼴"
// theme.descriptionFont: "Description font" => "설명 글꼴"
// theme.shadow: "Shadow effects" => "그림자 효과"
// ed.translateUsigAIFrom: "Translate from: " => "언어 선택(원문-번역): "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "응답 거부 옵션 허용"
// pe.showDontKnowItem: "Allow the Don't Know option" => "모름 옵션 허용"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "응답 거부 옵션 허용"
// pe.showDontKnowItem: "Allow the Don't Know option" => "모름 옵션 허용"
// pv.contain: "Contain" => "포함하다"
// pv.cover: "Cover" => "표지"
// pv.fill: "Fill" => "채우다"
// pe.transposeData: "Transpose rows to columns" => "행을 열로 바꾸기"
// layout.panel: "Layout" => "레이아웃"
// layout.question: "Layout" => "레이아웃"
// layout.base: "Layout" => "레이아웃"
// panel.name: "Panel name" => "패널 이름"
// panel.title: "Panel title" => "패널 제목"
// panel.description: "Panel description" => "패널 설명"
// panel.visibleIf: "Make the panel visible if" => "다음과 같은 경우 패널을 표시합니다."
// panel.requiredIf: "Make the panel required if" => "다음과 같은 경우 패널을 필수로 만듭니다."
// panel.questionsOrder: "Question order within the panel" => "패널 내의 질문 순서"
// panel.startWithNewLine: "Display the panel on a new line" => "새 줄에 패널 표시"
// panel.state: "Panel collapse state" => "패널 축소 상태"
// panel.width: "Inline panel width" => "인라인 패널 너비"
// panel.minWidth: "Minimum panel width" => "최소 패널 너비"
// panel.maxWidth: "Maximum panel width" => "최대 패널 너비"
// panel.showNumber: "Number panels" => "숫자 패널"
// paneldynamic.name: "Panel name" => "패널 이름"
// paneldynamic.title: "Panel title" => "패널 제목"
// paneldynamic.description: "Panel description" => "패널 설명"
// paneldynamic.visibleIf: "Make the panel visible if" => "다음과 같은 경우 패널을 표시합니다."
// paneldynamic.requiredIf: "Make the panel required if" => "다음과 같은 경우 패널을 필수로 만듭니다."
// paneldynamic.page: "Move the panel to page" => "패널을 페이지로 이동"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "새 줄에 패널 표시"
// paneldynamic.state: "Panel collapse state" => "패널 축소 상태"
// paneldynamic.width: "Inline panel width" => "인라인 패널 너비"
// paneldynamic.minWidth: "Minimum panel width" => "최소 패널 너비"
// paneldynamic.maxWidth: "Maximum panel width" => "최대 패널 너비"
// paneldynamic.templateDescription: "Panel description pattern" => "패널 설명 패턴"
// paneldynamic.templateTitle: "Panel title pattern" => "패널 제목 패턴"
// paneldynamic.noEntriesText: "Empty panel text" => "빈 패널 텍스트"
// paneldynamic.templateTabTitle: "Tab title pattern" => "탭 제목 패턴"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "다음과 같은 경우 개별 패널을 표시합니다."
// paneldynamic.hideNumber: "Hide the panel number" => "패널 번호 숨기기"
// paneldynamic.titleLocation: "Panel title alignment" => "패널 제목 정렬"
// paneldynamic.descriptionLocation: "Panel description alignment" => "패널 설명 정렬"
// paneldynamic.templateTitleLocation: "Question title alignment" => "질문 제목 정렬"
// paneldynamic.templateErrorLocation: "Error message alignment" => "오류 메시지 맞춤"
// paneldynamic.newPanelPosition: "New panel location" => "새 패널 위치"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "다음 질문에서 중복 응답 방지"
// question.name: "Question name" => "질문 이름"
// question.title: "Question title" => "질문 제목"
// question.description: "Question description" => "질문 설명"
// question.visibleIf: "Make the question visible if" => "다음과 같은 경우 질문을 표시합니다."
// question.requiredIf: "Make the question required if" => "다음과 같은 경우 질문을 필수로 만듭니다."
// question.state: "Question box collapse state" => "질문 상자 축소 상태"
// question.hideNumber: "Hide the question number" => "질문 번호 숨기기"
// question.titleLocation: "Question title alignment" => "질문 제목 정렬"
// question.descriptionLocation: "Question description alignment" => "질문 설명 정렬"
// question.errorLocation: "Error message alignment" => "오류 메시지 맞춤"
// question.indent: "Increase the inner indent" => "내부 들여쓰기 늘리기"
// question.width: "Inline question width" => "인라인 질문 너비"
// question.minWidth: "Minimum question width" => "최소 질문 너비"
// question.maxWidth: "Maximum question width" => "최대 질문 너비"
// question.textUpdateMode: "Update input field value" => "입력 필드 값 업데이트"
// signaturepad.allowClear: "Show the Clear button within signature area" => "서명 영역 내에 지우기 단추 표시"
// signaturepad.penColor: "Stroke color" => "획 색상"
// comment.rows: "Input field height (in lines)" => "입력 필드 높이(줄)"
// expression.name: "Expression name" => "표현식 이름"
// expression.title: "Expression title" => "표현식 제목"
// expression.description: "Expression description" => "표현식 설명"
// expression.expression: "Expression" => "식"
// trigger.expression: "Expression" => "식"
// calculatedvalue.expression: "Expression" => "식"
// survey.description: "Survey description" => "설문조사 설명"
// page.name: "Page name" => "페이지 이름"
// page.description: "Page description" => "페이지 설명"
// page.visibleIf: "Make the page visible if" => "다음과 같은 경우 페이지를 표시합니다."
// page.requiredIf: "Make the page required if" => "다음과 같은 경우 페이지를 필수로 만듭니다."
// page.questionsOrder: "Question order on the page" => "페이지의 질문 순서"
// matrixdropdowncolumn.name: "Column name" => "열 이름"
// matrixdropdowncolumn.title: "Column title" => "열 제목"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "중복 응답 방지"
// matrixdropdowncolumn.width: "Column width" => "열 너비"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "최소 열 너비"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "입력 필드 높이(줄)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "다음과 같은 경우 열을 표시합니다."
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "다음과 같은 경우 열을 필수로 만듭니다."
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "별도의 열에 있는 각 옵션"
// multipletextitem.name: "Name" => "이름"
// multipletextitem.title: "Title" => "타이틀"
// pe.rateDescriptionLocation: "Label alignment" => "레이블 정렬"
// pe.cellErrorLocation: "Cell error message alignment" => "셀 오류 메시지 맞춤"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "아직 열이 없습니다."
// pe.listIsEmpty@rows: "You don't have any rows yet" => "아직 행이 없습니다."
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "아직 유효성 검사 규칙이 없습니다."
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "아직 맞춤 변수가 없습니다."
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "아직 트리거가 없습니다."
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "아직 링크가 없습니다."
// pe.addNew@columns: "Add new column" => "새 열 추가"
// pe.addNew@rows: "Add new row" => "새 행 추가"
// pe.addNew@validators: "Add new rule" => "새 규칙 추가"
// pe.addNew@calculatedValues: "Add new variable" => "새 변수 추가"
// pe.addNew@triggers: "Add new trigger" => "새 트리거 추가"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "새 URL 추가"
// choicesbyurl.url: "Web service's URL" => "웹 서비스의 URL"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "진행률 표시줄에 페이지 제목 표시"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "진행률 표시줄에 페이지 번호 표시"
// itemvalue.visibleIf: "Make the option visible if" => "다음과 같은 경우 옵션을 표시합니다."
// itemvalue.enableIf: "Make the option selectable if" => "다음과 같은 경우 옵션을 선택할 수 있도록 합니다."
// panel.layout: "Panel Layout" => "패널 레이아웃"
// tabs.questionSettings: "Question Settings" => "질문 설정"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "예: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "예: categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "예: a)"
// pe.width_placeholder: "Ex.: 6in" => "예: 6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "예: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "예: 50%"
// pv.selected: "Selected" => "선택한"
// pv.unselected: "Unselected" => "하지 않은"
// pv.center: "Center" => "중"
// pv.middle: "Middle" => "중간"
// pv.next: "Next" => "다음"
// pv.last: "Last" => "지난"
// clearIfInvisible.none: "Never" => "결코"
// questionsOnPageMode.standard: "Original structure" => "원래 구조"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "모든 질문을 한 페이지에 표시"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "페이지당 단일 질문 표시"
// pv.auto: "Auto" => "자동"
// panelsState.firstExpanded: "First expanded" => "첫 번째 확장"
// rateColorMode.scale: "Scale" => "저울"
// scaleColorMode.monochrome: "Monochrome" => "단색"
// scaleColorMode.colored: "Colored" => "유색"
// state.default: "Locked" => "잠긴"
// showQuestionNumbers.default: "Auto-numbering" => "자동 번호 매기기"
// showQuestionNumbers.on: "Auto-numbering" => "자동 번호 매기기"
// showQuestionNumbers.onPage: "Reset on each page" => "각 페이지에서 재설정"
// showQuestionNumbers.onpanel: "Reset on each panel" => "각 패널에서 재설정"
// showQuestionNumbers.onPanel: "Reset on each panel" => "각 패널에서 재설정"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "설문조사 계속하기"
// showQuestionNumbers.off: "No numbering" => "번호 매기기 없음"
// descriptionLocation.underTitle: "Under the question title" => "질문 제목 아래"
// descriptionLocation.underInput: "Under the input field" => "입력 필드 아래"
// selectToRankAreasLayout.horizontal: "Next to choices" => "선택 항목 옆"
// selectToRankAreasLayout.vertical: "Above choices" => "위의 선택 사항"
// displayStyle.decimal: "Decimal" => "십진법"
// displayStyle.currency: "Currency" => "통화"
// displayStyle.percent: "Percentage" => "백분율"
// displayStyle.date: "Date" => "날짜"
// totalDisplayStyle.decimal: "Decimal" => "십진법"
// totalDisplayStyle.currency: "Currency" => "통화"
// totalDisplayStyle.percent: "Percentage" => "백분율"
// totalDisplayStyle.date: "Date" => "날짜"
// rowsOrder.initial: "Original" => "원문 언어"
// questionsOrder.initial: "Original" => "원문 언어"
// showProgressBar.aboveheader: "Above the header" => "머리글 위"
// showProgressBar.belowheader: "Below the header" => "머리글 아래"
// pv.sum: "Sum" => "합계"
// pv.count: "Count" => "세다"
// pv.min: "Min" => "분"
// pv.max: "Max" => "최대"
// pv.avg: "Avg" => "평균"
// searchMode.contains: "Contains" => "포함"
// searchMode.startsWith: "Starts with" => "다음으로 시작"
// panel.name: "A panel ID that is not visible to respondents." => "응답자에게 표시되지 않는 패널 ID입니다."
// panel.description: "Type a panel subtitle." => "패널 부제목을 입력합니다."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "마술 지팡이 아이콘을 사용하여 패널 가시성을 결정하는 조건부 규칙을 설정합니다."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "마술 지팡이 아이콘을 사용하여 패널에 대해 읽기 전용 모드를 비활성화하는 조건부 규칙을 설정합니다."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "마술 지팡이 아이콘을 사용하여 하나 이상의 중첩된 질문에 답변이 없는 한 설문조사 제출을 금지하는 조건부 규칙을 설정합니다."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "이 패널 내의 모든 질문에 적용됩니다. 이 설정을 재정의하려면 개별 질문에 대한 제목 정렬 규칙을 정의합니다. \"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정(기본적으로 \"상단\")을 적용합니다."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "패널 내의 모든 질문과 관련된 오류 메시지의 위치를 설정합니다. \"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정을 적용합니다."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "질문의 원래 순서를 유지하거나 무작위화합니다. \"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정을 적용합니다."
// panel.page: "Repositions the panel to the end of a selected page." => "선택한 페이지의 끝으로 패널의 위치를 변경합니다."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "패널 내용과 패널 상자의 왼쪽 테두리 사이에 공백 또는 여백을 추가합니다."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "이전 질문 또는 패널과 함께 한 줄로 패널을 표시하려면 선택을 취소합니다. 패널이 양식의 첫 번째 요소인 경우에는 설정이 적용되지 않습니다."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "다음 중에서 선택: \"확장\" - 패널이 전체적으로 표시되며 축소할 수 있습니다. \"축소됨\" - 패널에 제목과 설명만 표시되며 확장할 수 있습니다. \"잠김\" - 패널이 완전히 표시되며 축소할 수 없습니다."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "패널의 폭을 같은 줄에 있는 다른 측량 요소에 비례하여 설정합니다. CSS 값(px, %, in, pt 등)을 허용합니다."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "응답자에게 표시되지 않는 패널 ID입니다."
// paneldynamic.description: "Type a panel subtitle." => "패널 부제목을 입력합니다."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "마술 지팡이 아이콘을 사용하여 패널 가시성을 결정하는 조건부 규칙을 설정합니다."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "마술 지팡이 아이콘을 사용하여 패널에 대해 읽기 전용 모드를 비활성화하는 조건부 규칙을 설정합니다."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "마술 지팡이 아이콘을 사용하여 하나 이상의 중첩된 질문에 답변이 없는 한 설문조사 제출을 금지하는 조건부 규칙을 설정합니다."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "이 패널 내의 모든 질문에 적용됩니다. 이 설정을 재정의하려면 개별 질문에 대한 제목 정렬 규칙을 정의합니다. \"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정(기본적으로 \"상단\")을 적용합니다."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "잘못된 입력이 있는 질문과 관련된 오류 메시지의 위치를 설정합니다. 다음 중 하나를 선택합니다. \"상단\" - 오류 텍스트가 질문 상자 상단에 배치됩니다. \"하단\" - 오류 텍스트가 질문 상자 하단에 배치됩니다. \"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정(기본적으로 \"상단\")을 적용합니다."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "패널 내의 모든 질문과 관련된 오류 메시지의 위치를 설정합니다. \"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정을 적용합니다."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "선택한 페이지의 끝으로 패널의 위치를 변경합니다."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "패널 내용과 패널 상자의 왼쪽 테두리 사이에 공백 또는 여백을 추가합니다."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "이전 질문 또는 패널과 함께 한 줄로 패널을 표시하려면 선택을 취소합니다. 패널이 양식의 첫 번째 요소인 경우에는 설정이 적용되지 않습니다."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "다음 중에서 선택: \"확장\" - 패널이 전체적으로 표시되며 축소할 수 있습니다. \"축소됨\" - 패널에 제목과 설명만 표시되며 확장할 수 있습니다. \"잠김\" - 패널이 완전히 표시되며 축소할 수 없습니다."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "패널의 폭을 같은 줄에 있는 다른 측량 요소에 비례하여 설정합니다. CSS 값(px, %, in, pt 등)을 허용합니다."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "동적 패널 제목에 대한 템플릿을 입력합니다. 패널의 일반 위치에는 {panelIndex}를 사용하고 표시되는 패널 간의 순서에는 {visiblePanelIndex}를 사용합니다. 이러한 자리 표시자를 패턴에 삽입하여 자동 번호 매기기를 추가합니다."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "탭 제목에 대한 템플릿을 입력합니다. 패널의 일반적인 위치에는 {panelIndex}를 사용하고 표시되는 패널 간의 순서에는 {visiblePanelIndex}를 사용합니다. 이러한 자리 표시자를 패턴에 삽입하여 자동 번호 매기기를 추가합니다."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "이 설정을 사용하면 동적 패널 내에서 개별 패널의 가시성을 제어할 수 있습니다. '{panel}' 자리 표시자를 사용하여 표현식의 현재 패널을 참조합니다."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "이 설정은 이 패널 내의 모든 질문에 자동으로 상속됩니다. 이 설정을 재정의하려면 개별 질문에 대한 제목 정렬 규칙을 정의합니다. \"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정(기본적으로 \"상단\")을 적용합니다."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "\"상속\" 옵션은 페이지 수준(설정된 경우) 또는 설문조사 수준 설정(기본적으로 \"패널 제목 아래\")을 적용합니다."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "새로 추가된 패널의 위치를 정의합니다. 기본적으로 새 패널이 끝에 추가됩니다. \"다음\"을 선택하여 현재 패널 뒤에 새 패널을 삽입합니다."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "마지막 패널의 답변을 복제하여 다음에 추가된 동적 패널에 할당합니다."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "사용자가 각 패널에서 이 질문에 대해 고유한 응답을 제공하도록 요구하려면 질문 이름을 참조합니다."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "이 설정을 사용하면 표현식에 따라 기본 답안 값을 할당할 수 있습니다. 표현식에는 기본 계산('{q1_id} + {q2_id}'), 부울 표현식(예: '{age} > 60') 및 함수 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' 등이 포함될 수 있습니다. 이 표현식에 의해 결정된 값은 응답자의 수동 입력으로 재정의할 수 있는 초기 기본값으로 사용됩니다."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "마술 지팡이 아이콘을 사용하여 응답자의 입력이 \"기본값 표현식\" 또는 \"설정 값 표현식\" 또는 \"기본 답변\" 값(둘 중 하나가 설정된 경우)에 기반한 값으로 재설정되는 시점을 결정하는 조건부 규칙을 설정합니다."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "마술 지팡이 아이콘을 사용하여 \"값 설정 표현식\"을 실행할 시기를 결정하는 조건부 규칙을 설정하고 결과 값을 응답으로 동적으로 할당합니다."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "\"Set value if\" 규칙의 조건이 충족될 때 설정할 값을 정의하는 표현식을 지정합니다. 표현식에는 기본 계산('{q1_id} + {q2_id}'), 부울 표현식(예: '{age} > 60') 및 함수 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' 등이 포함될 수 있습니다. 이 표현식에 의해 결정된 값은 응답자의 수동 입력에 의해 재정의될 수 있습니다."
// question.name: "A question ID that is not visible to respondents." => "응답자에게 표시되지 않는 질문 ID입니다."
// question.description: "Type a question subtitle." => "질문 부제목을 입력합니다."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "마술 지팡이 아이콘을 사용하여 질문 가시성을 결정하는 조건부 규칙을 설정합니다."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "마술 지팡이 아이콘을 사용하여 질문에 대한 읽기 전용 모드를 비활성화하는 조건부 규칙을 설정합니다."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "마술 지팡이 아이콘을 사용하여 질문에 대한 답변을 받지 않는 한 설문조사 진행 또는 제출을 금지하는 조건부 규칙을 설정합니다."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "질문을 이전 질문 또는 패널과 함께 한 줄로 표시하려면 선택을 취소합니다. 질문이 양식의 첫 번째 요소인 경우에는 설정이 적용되지 않습니다."
// question.page: "Repositions the question to the end of a selected page." => "선택한 페이지의 끝으로 질문의 위치를 변경합니다."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "다음 중에서 선택: \"확장\" - 질문 상자가 전체적으로 표시되며 축소할 수 있습니다. \"축소됨\" - 질문 상자에는 제목과 설명만 표시되며 확장할 수 있습니다. \"잠김\" - 질문 상자가 완전히 표시되며 축소할 수 없습니다."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "패널, 페이지 또는 설문조사 수준에 정의된 제목 정렬 규칙을 재정의합니다. \"상속\" 옵션은 더 높은 수준의 설정(설정된 경우) 또는 설문조사 수준 설정(기본적으로 \"맨 위\")을 적용합니다."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "\"상속\" 옵션은 현장조사 수준 설정(기본 설정에 따라 \"질문 제목 아래\")을 적용합니다."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "잘못된 입력이 있는 질문과 관련된 오류 메시지의 위치를 설정합니다. 다음 중 하나를 선택합니다. \"상단\" - 오류 텍스트가 질문 상자 상단에 배치됩니다. \"하단\" - 오류 텍스트가 질문 상자 하단에 배치됩니다. \"상속\" 옵션은 설문조사 수준 설정(기본적으로 \"상단\")을 적용합니다."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "질문 콘텐츠와 질문 상자의 왼쪽 테두리 사이에 공백 또는 여백을 추가합니다."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "같은 줄에 있는 다른 설문조사 요소에 비례하여 질문의 너비를 설정합니다. CSS 값(px, %, in, pt 등)을 허용합니다."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "마술 지팡이 아이콘을 사용하여 질문에 대한 유효성 검사 규칙을 설정합니다."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "다음 중에서 선택: \"초점을 잃을 때\" - 입력 필드가 초점을 잃을 때 값이 업데이트됩니다. \"While typing\" - 사용자가 입력할 때 값이 실시간으로 업데이트됩니다. \"상속\" 옵션은 설문조사 수준 설정(기본적으로 \"초점 손실 시\")을 적용합니다."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "모든 웹 서비스를 객관식 질문의 데이터 소스로 사용할 수 있습니다. 선택 항목 값을 채우려면 데이터를 제공하는 서비스의 URL을 입력합니다."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "드롭다운 목록을 필터링하는 데 사용되는 비교 작업입니다."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "표시된 서명 영역과 결과 이미지의 너비를 설정합니다."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "표시된 서명 영역과 결과 이미지의 높이를 설정합니다."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "기본 3:2 종횡비를 유지하면서 서명 영역이 질문 상자 내의 사용 가능한 모든 공간을 채우도록 하려면 선택합니다. 사용자 지정 너비 및 높이 값을 설정하면 설정은 이러한 치수의 가로 세로 비율을 유지합니다."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "현장조사 결과에서 이미지의 높이를 조정합니다."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "현장조사 결과에서 이미지의 너비를 조정합니다."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "최소 및 최대 높이 값을 재정의합니다."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "최소 및 최대 너비 값을 재정의합니다."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Value\"는 조건부 규칙에 사용되는 항목 ID로 사용됩니다. 응답자에게 \"텍스트\"가 표시됩니다."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "이 설정은 입력 필드의 크기만 조정하며 질문 상자의 너비에는 영향을 주지 않습니다. 허용되는 입력 길이를 제한하려면 <b>유효성 검사 → 최대 문자 제한</b>으로 이동합니다."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "입력 필드에 표시되는 줄 수를 설정합니다. 입력이 더 많은 줄을 차지하면 스크롤 막대가 나타납니다."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "다음 중 하나를 선택합니다. \"수정 가능\" - 응답자가 설문조사를 작성할 수 있습니다. \"읽기 전용\" - 양식 편집을 비활성화합니다."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "응답자에게 표시되지 않는 열 ID입니다."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "열에 대해 활성화된 경우, 응답자는 이 열 내의 각 질문에 대해 고유한 응답을 제공해야 합니다."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "입력 필드에 표시되는 줄 수를 설정합니다. 입력이 더 많은 줄을 차지하면 스크롤 막대가 나타납니다."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "마술 지팡이 아이콘을 사용하여 열 표시 유형을 결정하는 조건부 규칙을 설정합니다."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "마술 지팡이 아이콘을 사용하여 열에 대해 읽기 전용 모드를 비활성화하는 조건부 규칙을 설정합니다."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "마술 지팡이 아이콘을 사용하여 하나 이상의 중첩된 질문에 답변이 없는 한 설문조사 제출을 금지하는 조건부 규칙을 설정합니다."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "이 옵션을 선택하면 각 선택 옵션에 대한 개별 열이 만들어집니다."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "다음 중에서 선택합니다. \"정적\" - 고정 너비를 설정합니다. \"반응형\" - 설문조사가 화면의 전체 너비를 차지하도록 합니다. \"자동\" - 사용된 질문 유형에 따라 둘 중 하나를 적용합니다."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "이미지 링크(크기 제한 없음)를 붙여넣거나 폴더 아이콘을 클릭하여 컴퓨터에서 파일을 찾습니다(최대 64KB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "로고 너비를 CSS 단위(px, %, in, pt 등)로 설정합니다."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "로고 높이를 CSS 단위(px, %, in, pt 등)로 설정합니다."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "다음 중에서 선택: \"없음\" - 이미지가 원래 크기를 유지합니다. \"Contain\" - 가로 세로 비율을 유지하면서 이미지의 크기가 조정됩니다. \"표지\" - 이미지가 종횡비를 유지하면서 전체 상자를 채웁니다. \"채우기\" - 가로 세로 비율을 유지하지 않고 상자를 채우기 위해 이미지가 늘어납니다."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "응답자가 현재 페이지의 모든 질문에 답변한 후 설문조사가 자동으로 다음 페이지로 넘어가도록 하려면 선택합니다."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "페이지에서 탐색 단추의 표시 여부와 위치를 설정합니다."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "진행률 표시줄의 표시 여부와 위치를 설정합니다. \"자동\" 값은 설문조사 헤더 위 또는 아래에 진행률 표시줄을 표시합니다."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "모든 질문 또는 답변된 질문만 있는 미리보기 페이지를 활성화합니다."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "설문조사 내의 모든 질문에 적용됩니다. 이 설정은 하위 수준(패널, 페이지 또는 질문)의 제목 정렬 규칙으로 재정의할 수 있습니다. 낮은 수준의 설정은 더 높은 수준의 설정보다 우선합니다."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "답변이 필요함을 나타내는 기호 또는 일련의 기호입니다."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "번호 매기기를 시작할 숫자 또는 문자를 입력합니다."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "잘못된 입력이 있는 질문과 관련된 오류 메시지의 위치를 설정합니다. 다음 중 하나를 선택합니다. \"상단\" - 오류 텍스트가 질문 상자 상단에 배치됩니다. \"하단\" - 오류 텍스트가 질문 상자 하단에 배치됩니다."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "각 페이지의 첫 번째 입력 필드를 텍스트 입력에 사용할 수 있도록 준비하려면 선택합니다."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "질문의 원래 순서를 유지하거나 무작위화합니다. 이 설정의 효과는 미리보기 탭에서만 볼 수 있습니다."
// pehelp.maxTextLength: "For text entry questions only." => "텍스트 입력 질문에만 해당됩니다."
// pehelp.maxOthersLength: "For question comments only." => "질문 댓글에만 해당됩니다."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "질문 댓글과 긴 텍스트 질문의 높이가 입력한 텍스트 길이에 따라 자동으로 커지도록 하려면 선택합니다."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "질문 댓글 및 긴 텍스트 질문에만 해당됩니다."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "사용자 지정 변수는 양식 계산에 사용되는 중간 또는 보조 변수 역할을 합니다. 응답자 입력을 소스 값으로 사용합니다. 각 맞춤 변수에는 고유한 이름과 기준이 되는 표현식이 있습니다."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "표현식의 계산된 값을 현장조사 결과와 함께 저장하려면 선택합니다."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "트리거는 표현식을 기반으로 하는 이벤트 또는 조건입니다. 표현식이 \"true\"로 평가되면 트리거가 작업을 시작합니다. 이러한 작업에는 선택적으로 영향을 미치는 대상 질문이 있을 수 있습니다."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "조건부 논리에 의해 숨겨진 질문의 값을 지울지 여부와 지울 시기를 선택합니다."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "다음 중에서 선택: \"초점을 잃을 때\" - 입력 필드가 초점을 잃을 때 값이 업데이트됩니다. \"While typing\" - 사용자가 입력할 때 값이 실시간으로 업데이트됩니다."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "왼쪽 값은 조건부 규칙에 사용되는 열 ID 역할을 하며, 오른쪽 값은 응답자에게 표시됩니다."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "왼쪽 값은 조건부 규칙에 사용되는 행 ID 역할을 하며, 오른쪽 값은 응답자에게 표시됩니다."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS 값(px, %, in, pt 등)을 허용합니다."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS 값(px, %, in, pt 등)을 허용합니다."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "잘못된 입력이 있는 셀과 관련하여 오류 메시지의 위치를 설정합니다. \"상속\" 옵션은 \"오류 메시지 맞춤\" 속성의 설정을 적용합니다."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "\"중복 응답 방지\" 속성이 활성화된 경우, 중복 항목을 제출하려는 응답자는 다음과 같은 오류 메시지를 받게 됩니다."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "표현식을 기준으로 합계 값을 계산할 수 있습니다. 표현식에는 기본 계산('{q1_id} + {q2_id}'), 부울 표현식('{age} > 60') 및 함수('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' 등)이 포함될 수 있습니다."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "행 삭제를 확인하라는 프롬프트를 트리거합니다."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "마지막 행의 답변을 복제하여 다음에 추가된 동적 행에 할당합니다."
// pehelp.description: "Type a subtitle." => "자막을 입력합니다."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "설문조사 만들기를 시작할 언어를 선택합니다. 번역을 추가하려면 새 언어로 전환하고 여기 또는 번역 탭에서 원본 텍스트를 번역합니다."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "행을 기준으로 세부 정보 섹션의 위치를 설정합니다. 다음 중에서 선택: \"없음\" - 확장이 추가되지 않습니다. \"행 아래\" - 행 확장이 행렬의 각 행 아래에 배치됩니다. \"행 아래에 한 행 확장만 표시\" - 확장은 단일 행 아래에만 표시되고 나머지 행 확장은 축소됩니다."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "다음 중에서 선택: \"없음\" - 이미지가 원래 크기를 유지합니다. \"Contain\" - 가로 세로 비율을 유지하면서 이미지의 크기가 조정됩니다. \"표지\" - 이미지가 종횡비를 유지하면서 전체 상자를 채웁니다. \"채우기\" - 가로 세로 비율을 유지하지 않고 상자를 채우기 위해 이미지가 늘어납니다."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "데이터가 입력될 때 입력 필드의 높이를 점진적으로 늘립니다. \"입력 필드 높이(줄 단위)\" 설정을 재정의합니다."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "크기 조정 핸들(또는 그립)이 모서리에 나타나며 드래그하여 입력 필드의 크기를 변경할 수 있습니다."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "설문조사가 감사 인사 페이지로 자동 전환되기까지의 시간 간격(초)입니다."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "설문조사가 다음 페이지로 자동 넘어가는 시간 간격(초)입니다."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "설문조사가 다음 페이지로 자동 넘어가는 시간 간격(초)입니다."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "마술 지팡이 아이콘을 사용하여 페이지 표시 여부를 결정하는 조건부 규칙을 설정할 수 있습니다."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "마술 지팡이 아이콘을 사용하여 페이지에 대해 읽기 전용 모드를 비활성화하는 조건부 규칙을 설정합니다."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "마술 지팡이 아이콘을 사용하여 하나 이상의 중첩된 질문에 답변이 없는 한 설문조사 제출을 금지하는 조건부 규칙을 설정합니다."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "이 페이지 내의 모든 질문에 적용됩니다. 이 설정을 재정의하려면 개별 질문 또는 패널에 대한 제목 정렬 규칙을 정의합니다. \"상속\" 옵션은 설문조사 수준 설정(기본적으로 \"상단\")을 적용합니다."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "잘못된 입력이 있는 질문과 관련된 오류 메시지의 위치를 설정합니다. 다음 중 하나를 선택합니다. \"상단\" - 오류 텍스트가 질문 상자 상단에 배치됩니다. \"하단\" - 오류 텍스트가 질문 상자 하단에 배치됩니다. \"상속\" 옵션은 설문조사 수준 설정(기본적으로 \"상단\")을 적용합니다."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "질문의 원래 순서를 유지하거나 무작위화합니다. \"상속\" 옵션은 설문조사 수준 설정(기본적으로 \"원본\")을 적용합니다. 이 설정의 효과는 미리보기 탭에서만 볼 수 있습니다."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "페이지에서 탐색 단추의 표시 여부를 설정합니다. \"상속\" 옵션은 설문조사 수준 설정을 적용하며, 기본값은 \"표시\"입니다."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "페이지에서 타이머의 표시 여부와 위치를 설정합니다."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "다음 중에서 선택: \"잠김\" - 사용자가 패널을 확장하거나 축소할 수 없습니다. \"모두 축소\" - 모든 패널이 축소된 상태에서 시작됩니다. \"모두 확장\" - 모든 패널이 확장된 상태에서 시작됩니다. \"첫 번째 확장\" - 첫 번째 패널만 처음에 확장됩니다."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "선택 목록에 표시할 이미지 또는 비디오 파일 URL이 포함된 객체 배열 내에 공유 속성 이름을 입력합니다."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "왼쪽 값은 조건부 규칙에 사용되는 항목 ID 역할을 하며, 오른쪽 값은 응답자에게 표시됩니다."
// pehelp.title: "Type a user-friendly title to display." => "표시할 사용자에게 친숙한 제목을 입력합니다."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "파일이 업로드될 때까지 사용자가 설문조사를 완료하지 않도록 합니다."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS 값(px, %, in, pt 등)을 허용합니다."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS 값(px, %, in, pt 등)을 허용합니다."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS 값(px, %, in, pt 등)을 허용합니다."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "단답형 및 다중선택 질문 유형에서 각 선택 옵션에는 ID와 표시 값이 있습니다. 이 설정을 선택하면 HTML 질문과 동적 제목 및 현장조사 요소에 대한 설명에서 ID 값 대신 표시 값이 표시됩니다."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "조건부 논리에 의해 숨겨진 질문 값을 지울지 여부와 지울 시기를 선택합니다. \"상속\" 옵션은 설문조사 수준 설정(기본적으로 \"설문조사 완료 시\")을 적용합니다."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "다음 중에서 선택: \"모두\" - 선택한 질문의 모든 선택 옵션을 복사합니다. \"선택됨\" - 선택한 선택 옵션만 동적으로 복사합니다. \"선택되지 않음\" - 선택되지 않은 선택 옵션만 동적으로 복사합니다. \"없음\" 및 \"기타\" 옵션은 원본 질문에서 활성화된 경우 기본적으로 복사됩니다."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "이 옵션을 선택하면 사용자가 별도의 주석 상자에 추가 입력을 포함할 수 있습니다."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "각 특수 선택 옵션(\"없음\", \"기타\", \"모두 선택\")을 새 줄에 표시합니다(여러 열 레이아웃을 사용하는 경우에도 마찬가지임)."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "서비스 데이터 세트 내에서 대상 객체 배열이 있는 위치를 지정합니다. URL이 이미 배열을 가리키는 경우 비워 둡니다."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "선택 목록에 표시할 값을 포함하는 객체 배열 내에 균일한 특성 이름을 입력합니다."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "서비스가 빈 응답 또는 배열을 반환하도록 허용하려면 선택합니다."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "마술 지팡이 아이콘을 사용하여 모든 선택 옵션의 표시 유형을 결정하는 조건부 규칙을 설정합니다."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "왼쪽 값은 조건부 규칙에 사용되는 항목 ID 역할을 하며, 오른쪽 값은 응답자에게 표시됩니다."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"자동\"은 사용 가능한 너비에 따라 \"버튼\"과 \"드롭다운\" 모드 중에서 선택합니다. 너비가 부족하여 버튼을 표시할 수 없는 경우 질문에 드롭다운이 표시됩니다."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "다양한 형식의 결과를 생성하는 질문을 연결할 수 있습니다. 이러한 질문이 조인 식별자를 사용하여 서로 연결되면 이 공유 속성은 선택한 질문 값을 저장합니다."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "사용자가 입력 필드에 입력하는 검색어와 일치하도록 드롭다운 메뉴 내용을 업데이트하려면 선택합니다."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "응답자들이 긍정적인 답변을 할 때 설문조사 결과에 저장하는 값입니다."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "응답자들이 부정적인 답변을 할 때 설문조사 결과에 저장하는 값입니다."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "이 옵션은 미리 보기 이미지를 재정의하고 사용자가 파일이 업로드되었는지 여부를 이해하기 어렵게 만들기 때문에 사용하지 않도록 설정하지 않는 것이 좋습니다."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "파일 삭제를 확인하는 프롬프트를 트리거합니다."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "선택한 선택 항목만 순위를 지정할 수 있습니다. 사용자는 선택 목록에서 선택한 항목을 끌어 순위 영역 내에서 정렬합니다."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "입력 시 응답자에게 제안될 선택 사항 목록을 입력합니다."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "이 설정은 입력 필드의 크기만 조정하며 질문 상자의 너비에는 영향을 주지 않습니다."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "모든 항목 레이블에 대해 일관된 너비를 픽셀 단위로 설정합니다."
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "\"자동\" 옵션은 제공된 소스 URL을 기반으로 표시에 적합한 모드(이미지, 비디오 또는 YouTube)를 자동으로 결정합니다."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "사용자의 장치에 이미지를 표시할 수 없는 경우 접근성을 위해 대신 사용할 수 있습니다."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "등급 아이콘 유형이 \"스마일리\"로 설정된 경우 선택한 이모티콘의 색상을 정의합니다. 다음 중 하나를 선택합니다. \"기본값\" - 선택한 이모티콘이 기본 설문조사 색상으로 표시됩니다. \"척도\"-선택한 이모티콘은 등급 척도에서 색상을 상속합니다."
// expression.name: "An expression ID that is not visible to respondents." => "응답자에게 표시되지 않는 표현식 ID입니다."
// expression.description: "Type an expression subtitle." => "표현식 부제목을 입력합니다."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "표현식에는 기본 계산('{q1_id} + {q2_id}'), 조건('{age} > 60') 및 함수('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' 등)가 포함될 수 있습니다."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "\"기타\" 옵션 값을 측량 결과에 별도의 속성으로 저장하려면 선택합니다."
// p.swapOrder: "Swap the order of Yes and No" => "예와 아니요의 순서를 바꿉니다."
// p.itemTitleWidth: "Item label width (in px)" => "항목 레이블 너비(px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "모든 옵션이 선택된 경우 표시할 텍스트"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "순위 영역의 자리 표시자 텍스트"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "설문조사 자동 완성"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "응답자가 모든 질문에 답변한 후 설문조사가 자동으로 완료되도록 하려면 선택합니다."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "설문조사 결과에 마스킹된 값 저장"
// patternmask.pattern: "Value pattern" => "값 패턴"
// datetimemask.min: "Minimum value" => "최솟값"
// datetimemask.max: "Maximum value" => "최대값"
// numericmask.allowNegativeValues: "Allow negative values" => "음수 값 허용"
// numericmask.thousandsSeparator: "Thousands separator" => "1000 단위 구분 기호"
// numericmask.decimalSeparator: "Decimal separator" => "소수 구분 기호"
// numericmask.precision: "Value precision" => "값 정밀도"
// numericmask.min: "Minimum value" => "최솟값"
// numericmask.max: "Maximum value" => "최대값"
// currencymask.prefix: "Currency prefix" => "통화 접두사"
// currencymask.suffix: "Currency suffix" => "통화 접미사"
// pe.maskType: "Input mask type" => "입력 마스크 유형"
// maskTypes.patternmask: "Pattern" => "무늬"
// maskTypes.numericmask: "Numeric" => "숫자"
// maskTypes.datetimemask: "Date and Time" => "날짜 및 시간"
// maskTypes.currencymask: "Currency" => "통화"
// tabs.mask: "Input Mask Settings" => "입력 마스크 설정"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "예: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "예: mm/dd/yyyy"
// pe.currencyprefix_placeholder: "Ex.: $" => "예: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "예.: USD"
// pv.textWrapEnabled: "Wrap choices" => "줄 바꿈 선택"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "선택 옵션의 긴 텍스트는 드롭다운 메뉴에 맞게 줄 바꿈을 자동으로 생성합니다. 텍스트를 자르려면 선택을 취소합니다."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "마스크가 적용된 질문 값을 현장조사 결과에 저장하려면 선택합니다."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "패턴에는 문자열 리터럴과 다음 자리 표시자가 포함될 수 있습니다. '9' - 숫자의 경우; 'a' - 대문자 또는 소문자의 경우; '#' - 숫자 또는 대문자 또는 소문자의 경우. 백슬래시 '\\'를 사용하여 문자를 이스케이프합니다."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "패턴에는 구분 기호와 다음 자리 표시자가 포함될 수 있습니다. 'm' - 월 번호; 'mm' - 월 번호의 경우, 한 자리 값의 경우 선행 0이 있습니다. 'd' - 해당 월의 날짜; 'dd' - 한 달 중 일, 한 자리 값의 경우 선행 0이 있습니다. 'yy' - 연도의 마지막 두 자리 숫자; 'yyyy' - 4자리 연도입니다."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "표시된 숫자의 정수 부분에서 소수 부분을 구분하는 데 사용되는 기호입니다."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "큰 숫자의 숫자를 3개의 그룹으로 구분하는 데 사용되는 기호입니다."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "표시된 숫자의 소수점 뒤에 유지할 자릿수를 제한합니다."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "값 앞에 표시할 하나 또는 여러 개의 기호입니다."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "값 뒤에 표시할 하나 또는 여러 개의 기호입니다."
// ed.translationSource: "Source: " => "근원: "
// ed.translationTarget: "Target: " => "과녁: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "페이지가 비어 있습니다. 도구 상자에서 요소를 드래그하거나 아래 버튼을 클릭합니다."
// maskTypes.none: "None" => "없음"
// itemvalue@rows.visibleIf: "Make the row visible if" => "다음과 같은 경우 행을 표시합니다."
// itemvalue@rows.enableIf: "Make the row editable if" => "다음과 같은 경우 행을 편집 가능하게 만듭니다."
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "읽기 전용 또는 미리 보기 모드의 자리 표시자 텍스트"
// pe.textWrapEnabled: "Wrap choices" => "줄 바꿈 선택"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "\"자동\" 옵션은 제공된 소스 URL을 기반으로 표시에 적합한 모드(이미지, 비디오 또는 YouTube)를 자동으로 결정합니다."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "\"이미지\"와 \"비디오\" 중에서 선택하여 미디어 선택기의 콘텐츠 모드를 설정합니다. \"이미지\"를 선택한 경우 제공된 모든 옵션이 JPEG, GIF, PNG, APNG, SVG, BMP, ICO 형식의 이미지 파일인지 확인하십시오. 마찬가지로 \"비디오\"를 선택한 경우 모든 옵션이 MP4, MOV, WMV, FLV, AVI, MKV 형식의 비디오 파일에 대한 직접 링크인지 확인하십시오. YouTube 링크는 비디오 옵션에서 지원되지 않습니다."
// ed.selectFile: "Select a file" => "파일 선택"
// ed.removeFile: "Remove the file" => "파일 제거"
// pe.searchMode: "Search Mode" => "검색 모드"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "아래의 \"질문 추가\" 버튼을 클릭하여 양식 작성을 시작하십시오."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "아래의 \"질문 추가\" 버튼을 클릭하여 페이지에 새 요소를 추가하세요."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "아래의 \"질문 추가\" 버튼을 클릭하여 패널에 새 요소를 추가합니다."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "아래 버튼을 클릭하고 업로드할 이미지를 선택하세요."
// coloralpha.opacity: "Opacity" => "불투명도"
// font.family: "Font family" => "글꼴 모음"
// font.color: "Color" => "색"
// font.placeholderColor: "Placeholder color" => "자리 표시자 색"
// font.size: "Size" => "크기"
// theme.themeName: "Theme" => "주제"
// theme.isPanelless: "Question appearance" => "질문 모양"
// theme.editorPanel: "Background and corner radius" => "배경 및 모서리 반경"
// theme.questionPanel: "Background and corner radius" => "배경 및 모서리 반경"
// theme.primaryColor: "Accent color" => "강조 색상"
// theme.panelBackgroundTransparency: "Panel background opacity" => "패널 배경 불투명도"
// theme.questionBackgroundTransparency: "Question background opacity" => "질문 배경 불투명도"
// theme.fontSize: "Font size" => "글꼴 크기"
// theme.scale: "Scale" => "저울"
// theme.cornerRadius: "Corner radius" => "코너 반경"
// theme.pageTitle: "Title font" => "제목 글꼴"
// theme.pageDescription: "Description font" => "설명 글꼴"
// theme.questionTitle: "Title font" => "제목 글꼴"
// theme.questionDescription: "Description font" => "설명 글꼴"
// theme.editorFont: "Font" => "글꼴"
// theme.backgroundOpacity: "Opacity" => "불투명도"
// theme.--sjs-font-family: "Font family" => "글꼴 모음"
// theme.--sjs-general-backcolor-dim: "Background color" => "배경색"
// theme.--sjs-primary-backcolor: "Accent background" => "강조 배경"
// theme.--sjs-primary-forecolor: "Accent foreground" => "강조 전경"
// theme.--sjs-shadow-small: "Shadow effects" => "그림자 효과"
// theme.--sjs-shadow-inner: "Shadow effects" => "그림자 효과"
// theme.--sjs-border-default: "Colors" => "색상"
// header@header.headerView: "View" => "보기"
// header@header.logoPosition: "Logo position" => "로고 위치"
// header@header.surveyTitle: "Survey title font" => "설문조사 제목 글꼴"
// header@header.surveyDescription: "Survey description font" => "설문조사 설명 글꼴"
// header@header.headerTitle: "Survey title font" => "설문조사 제목 글꼴"
// header@header.headerDescription: "Survey description font" => "설문조사 설명 글꼴"
// header@header.inheritWidthFrom: "Content area width" => "콘텐츠 영역 너비"
// header@header.textAreaWidth: "Text width" => "텍스트 너비"
// header@header.backgroundColorSwitch: "Background color" => "배경색"
// header@header.backgroundImage: "Background image" => "배경 이미지"
// header@header.backgroundImageOpacity: "Opacity" => "불투명도"
// header@header.overlapEnabled: "Overlap" => "겹침"
// header@header.logoPositionX: "Logo position" => "로고 위치"
// header@header.titlePositionX: "Title position" => "제목 위치"
// header@header.descriptionPositionX: "Description position" => "설명 위치"
// weight.400: "Regular" => "일반"
// weight.600: "Heavy" => "무겁다"
// weight.700: "Semi-bold" => "세미 볼드(Semi-bold)"
// weight.800: "Bold" => "대담한"
// backgroundImageFit.auto: "Auto" => "자동"
// backgroundImageFit.cover: "Cover" => "표지"
// backgroundImageFit.contain: "Contain" => "포함하다"
// backgroundImageFit.fill: "Stretch" => "뻗다"
// backgroundImageFit.tile: "Tile" => "타일"
// backgroundImageAttachment.fixed: "Fixed" => "부정하게 결정된"
// backgroundImageAttachment.scroll: "Scroll" => "스크롤"
// headerView.basic: "Basic" => "기초의"
// headerView.advanced: "Advanced" => "고급"
// inheritWidthFrom.survey: "Same as survey" => "설문 조사와 동일"
// inheritWidthFrom.container: "Fit to container" => "컨테이너에 맞추기"
// backgroundColorSwitch.none: "None" => "없음"
// backgroundColorSwitch.accentColor: "Accent color" => "강조 색상"
// backgroundColorSwitch.custom: "Custom" => "관습"
// colorPalette.light: "Light" => "광"
// colorPalette.dark: "Dark" => "어둠"
// isPanelless.false: "Default" => "기본값"
// isPanelless.true: "Without Panels" => "패널 없음"
// theme.cornerRadius: "Corner radius" => "코너 반경"
// theme.fontFamily: "Font family" => "글꼴 모음"
// theme.fontWeightRegular: "Regular" => "일반"
// theme.fontWeightHeavy: "Heavy" => "무겁다"
// theme.fontWeightSemiBold: "Semi-bold" => "세미 볼드(Semi-bold)"
// theme.fontWeightBold: "Bold" => "대담한"
// theme.color: "Color" => "색"
// theme.placeholderColor: "Placeholder color" => "자리 표시자 색"
// theme.size: "Size" => "크기"
// theme.opacity: "Opacity" => "불투명도"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "검색하려면 입력..."
// ed.toolboxNoResultsFound: "No results found" => "결과를 찾을 수 없습니다."
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "탭 제목 자리 표시자"
// theme.--sjs-special-red: "Error messages" => "오류 메시지"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "탭 제목 패턴이 의미 있는 값을 생성하지 않을 때 적용되는 탭 제목에 대한 대체 텍스트입니다."
// theme.fontColor: "Font color" => "글꼴 색상"
// theme.backgroundColor: "Background color" => "배경색"
// pe.questionTitleWidth: "Question title width" => "질문 제목 너비"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "파일 선택 또는 파일 링크 붙여넣기..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "예: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "질문 제목이 질문 상자의 왼쪽에 정렬될 때 일관된 너비를 설정합니다. CSS 값(px, %, in, pt 등)을 허용합니다."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "질문 제목이 질문 상자의 왼쪽에 정렬될 때 일관된 너비를 설정합니다. CSS 값(px, %, in, pt 등)을 허용합니다."
// pe.commentAreaRows: "Comment area height (in lines)" => "주석 영역 높이(줄)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "질문 주석에 대해 텍스트 영역에 표시되는 줄 수를 설정합니다. 입력이 더 많은 줄을 차지하면 스크롤 막대가 나타납니다."


/***/ }),

/***/ "./src/localization/malay.ts":
/*!***********************************!*\
  !*** ./src/localization/malay.ts ***!
  \***********************************/
/*! exports provided: msStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "msStrings", function() { return msStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var msStrings = {
    // survey templates
    survey: {
        edit: "Edit",
        externalHelpLink: "Tonton dan belajar cara mencipta tinjauan",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Sila letakkan soalan di sini daripada Kotak Alat",
        addLogicItem: "Cipta peraturan untuk menyesuaikan aliran tinjauan.",
        copy: "Salin",
        duplicate: "Pendua",
        addToToolbox: "Tambahkan kepada kotak alat",
        deletePanel: "Padamkan Panel",
        deleteQuestion: "Padamkan Soalan",
        convertTo: "Tukar kepada",
        drag: "Seret unsur",
    },
    // Creator tabs
    tabs: {
        preview: "Uji Tinjauan",
        theme: "Tema",
        translation: "Terjemahan",
        designer: "Pereka Bentuk Tinjauan",
        editor: "Editor JSON",
        logic: "Logik Tinjauan"
    },
    // Question types
    qt: {
        default: "Lalai",
        checkbox: "Kotak semak",
        comment: "Komen",
        imagepicker: "Pemilih imej",
        ranking: "Kedudukan",
        image: "Imej",
        dropdown: "Juntai bawah",
        tagbox: "Juntai Bawah Berbilang Pilihan",
        file: "Fail",
        html: "HTML",
        matrix: "Matriks (pilihan tunggal)",
        matrixdropdown: "Matriks (pilihan berbilang)",
        matrixdynamic: "Matriks (baris dinamik)",
        multipletext: "Teks Berbilang",
        panel: "Panel",
        paneldynamic: "Panel (panel dinamik)",
        radiogroup: "Kumpulan radio",
        rating: "Penarafan",
        text: "Input Tunggal",
        boolean: "Yes/No (Boolean)",
        expression: "Ekspresi (baca sahaja)",
        signaturepad: "Pad tandatangan",
        buttongroup: "Kumpulan Butang"
    },
    toolboxCategories: {
        general: "Umum",
        choice: "Soalan Pilihan",
        text: "Soalan Input Teks",
        containers: "Bekas",
        matrix: "Soalan Matriks",
        misc: "Misc"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Lalai ({0})",
        survey: "Tinjauan",
        settings: "Tetapan Tinjauan",
        settingsTooltip: "Buka tetapan tinjauan",
        surveySettings: "Seting Tinjauan",
        surveySettingsTooltip: "Seting tinjauan",
        themeSettings: "Seting Tema",
        themeSettingsTooltip: "Seting tema",
        showPanel: "Tunjukkan Panel",
        hidePanel: "Sembunyikan Panel",
        prevSelected: "Pilih sebelumnya",
        nextSelected: "Pilih seterusnya",
        prevFocus: "Fokus sebelum ini",
        nextFocus: "Fokus seterusnya",
        surveyTypeName: "Kaji selidik",
        pageTypeName: "Laman",
        panelTypeName: "Panel",
        questionTypeName: "Soalan",
        columnTypeName: "Lajur",
        addNewPage: "Tambahkan Halaman Baharu",
        moveRight: "Tatal ke Kanan",
        moveLeft: "Tatal ke Kiri",
        deletePage: "Padamkan Halaman",
        editPage: "Edit Halaman",
        edit: "Edit",
        newPageName: "halaman",
        newQuestionName: "soalan",
        newPanelName: "panel",
        newTextItemName: "teks",
        defaultV2Theme: "Lalai",
        modernTheme: "Moden",
        defaultTheme: "Lalai (warisan)",
        testSurveyAgain: "Uji Tinjauan Semula",
        testSurveyWidth: "Lebar tinjauan: ",
        navigateToMsg: "Anda perlu navigasi ke:",
        saveSurvey: "Simpan Tinjauan",
        saveSurveyTooltip: "Simpan Tinjauan",
        saveTheme: "Simpan Tema",
        saveThemeTooltip: "Simpan Tema",
        jsonHideErrors: "Sembunyikan ralat",
        jsonShowErrors: "Tunjukkan ralat",
        undo: "Buat Asal",
        redo: "Buat Semula",
        undoTooltip: "Buat asal perubahan terakhir",
        redoTooltip: "Buat semula perubahan",
        showMoreChoices: "Tunjuk lebih banyak",
        showLessChoices: "Tunjukkan kurang",
        copy: "Salin",
        cut: "Potong",
        paste: "Tampal",
        copyTooltip: "Salin pilihan kepada papan klip",
        cutTooltip: "Potong pilihan kepada papan klip",
        pasteTooltip: "Tampal daripada papan klip",
        options: "Pilihan",
        generateValidJSON: "Jana JSON yang Sah",
        generateReadableJSON: "Jana JSON yang Boleh Dibaca",
        toolbox: "Kotak Alat",
        "property-grid": "Ciri",
        toolboxFilteredTextPlaceholder: "Taip untuk mencari...",
        toolboxNoResultsFound: "Tiada keputusan ditemui",
        propertyGridFilteredTextPlaceholder: "Taip untuk mencari...",
        propertyGridNoResultsFound: "Tiada keputusan ditemui",
        correctJSON: "Pilih JSON yang betul.",
        surveyResults: "Keputusan Tinjauan: ",
        surveyResultsTable: "Sebagai Jadual",
        surveyResultsJson: "Sebagai JSON",
        resultsTitle: "Tajuk Soalan",
        resultsName: "Nama Soalan",
        resultsValue: "Nilai Jawapan",
        resultsDisplayValue: "Nilai Paparan",
        modified: "Diubah suai",
        saving: "Menyimpan",
        saved: "Disimpan",
        propertyEditorError: "Ralat:",
        saveError: "Ralat! Kandungan editor tidak disimpan.",
        translationPropertyGridTitle: "Seting Bahasa",
        themePropertyGridTitle: "Seting Tema",
        translationLanguages: "Bahasa-bahasa",
        translationDeleteLanguage: "Adakah anda pasti ingin memadam semua rentetan untuk bahasa ini?",
        translationAddLanguage: "Pilihan bahasa untuk diterjemah",
        translationShowAllStrings: "Tunjukkan semua rentetan",
        translationShowUsedStringsOnly: "Rentetan yang Digunakan Sahaja",
        translationShowAllPages: "Tunjukkan semua halaman",
        translationNoStrings: "Tiada rentetan untuk diterjemah. Sila ubah penapis.",
        translationExportToSCVButton: "Eksport kepada CSV",
        translationImportFromSCVButton: "Import daripada CSV",
        translateUsigAI: "Terjemahkan Secara automatik Semua",
        translateUsigAIFrom: "Terjemah daripada: ",
        translationDialogTitle: "Rentetan tidak diterjemahkan",
        translationMergeLocaleWithDefault: "Gabung {0} dengan tempatan lalai",
        translationPlaceHolder: "Penterjemahan...",
        translationSource: "Sumber: ",
        translationTarget: "Sasaran: ",
        themeExportButton: "Eksport",
        themeImportButton: "Import",
        surveyJsonExportButton: "Eksport",
        surveyJsonImportButton: "Import",
        surveyJsonCopyButton: "Salin ke papan keratan",
        themeResetButton: "Mengeset semula seting tema kepada lalai",
        themeResetConfirmation: "Adakah anda benar-benar mahu menetapkan semula tema? Semua penyesuaian anda akan hilang.",
        themeResetConfirmationOk: "Ya, tetapkan semula tema",
        bold: "Tebal",
        italic: "Condong",
        underline: "Garis bawah",
        addNewQuestion: "Tambahkan soalan",
        selectPage: "Pilih halaman...",
        carryForwardChoicesCopied: "Pilihan disalin daripada",
        choicesLoadedFromWebText: "Pilihan dimuatkan dari perkhidmatan web.",
        choicesLoadedFromWebLinkText: "Pergi ke seting",
        choicesLoadedFromWebPreviewTitle: "Pratonton pilihan pilihan yang dimuatkan",
        htmlPlaceHolder: "Kandungan HTML akan berada di sini.",
        panelPlaceHolder: "Lepaskan soalan dari kotak alat di sini.",
        surveyPlaceHolder: "Tinjauan itu kosong. Seret elemen dari kotak alat atau klik butang di bawah.",
        pagePlaceHolder: "Halaman kosong. Seret elemen dari kotak alat atau klik butang di bawah.",
        imagePlaceHolder: "Seret dan lepaskan imej di sini atau klik butang di bawah dan pilih imej untuk dimuat naik",
        surveyPlaceHolderMobile: "Klik butang \"Tambah Soalan\" di bawah untuk mula membuat borang anda.",
        pagePlaceHolderMobile: "Klik butang \"Tambah Soalan\" di bawah untuk menambah elemen baru ke halaman.",
        panelPlaceHolderMobile: "Klik butang \"Tambah Soalan\" di bawah untuk menambah elemen baru ke panel.",
        imagePlaceHolderMobile: "Klik butang di bawah dan pilih imej untuk dimuat naik",
        imageChooseImage: "Pilih Imej",
        addNewTypeQuestion: "Tambah {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Perkara ",
        selectFile: "Pilih fail",
        removeFile: "Mengalih keluar fail",
        lg: {
            addNewItem: "Tambah peraturan baru",
            empty_tab: "Cipta peraturan untuk menyesuaikan aliran tinjauan.",
            page_visibilityName: "Kebolehlihatan halaman",
            page_enableName: "Halaman Dayakan (nyahdayakan)",
            page_requireName: "Buat halaman diperlukan",
            panel_visibilityName: "Kebolehlihatan panel",
            panel_enableName: "Dayakan/Lumpuhkan panel",
            panel_requireName: "Buat halaman diperlukan",
            question_visibilityName: "Kebolehlihatan soalan",
            question_enableName: "Dayakan/Lumpuhkan soalan",
            question_requireName: "Pilihan soalan diperlukan",
            question_resetValueName: "Mengeset semula nilai soalan",
            question_setValueName: "Mengesetkan nilai soalan",
            column_visibilityName: "Tunjukkan lajur (sembunyikan)",
            column_enableName: "Mendayakan (nyahdayakan) lajur",
            column_requireName: "Jadikan lajur diperlukan",
            column_resetValueName: "Mengeset semula nilai lajur",
            column_setValueName: "Mengesetkan nilai lajur",
            trigger_completeName: "Lengkapkan tinjauan",
            trigger_setvalueName: "Tetapkan nilai soalan",
            trigger_copyvalueName: "Salin nilai soalan",
            trigger_skipName: "Langkau kepada soalan",
            trigger_runExpressionName: "Jalankan ekspresi tersuai",
            completedHtmlOnConditionName: "Teks 'Halaman terima kasih' tersuai",
            page_visibilityDescription: "Jadikan halaman boleh dilihat apabila ekspresi logik mengembalikan nilai benar. Jika tidak, biarkan tersembunyi.",
            panel_visibilityDescription: "Jadikan panel boleh dilihat apabila ekspresi logik mengembalikan nilai benar. Jika tidak, biarkan tersembunyi.",
            panel_enableDescription: "Jadikan panel dan semua elemen dalamnya didayakan apabila ekspresi logik mengembalikan nilai benar. Jika tidak, biarkan lumpuh.",
            question_visibilityDescription: "Jadikan soalan boleh dilihat apabila ekspresi logik mengembalikan nilai benar. Jika tidak, biarkan tersembunyi.",
            question_enableDescription: "Jadikan soalan didayakan apabila ekspresi logik mengembalikan nilai benar. Jika tidak, biarkan lumpuh.",
            question_requireDescription: "Soalan diperlukan apabila ekspresi logik mengembalikan nilai benar.",
            trigger_completeDescription: "Apabila ekspresi logik mengembalikan nilai benar, maka tinjauan akan lengkap dan pengguna akhir akan melihat 'Halaman terima kasih'.",
            trigger_setvalueDescription: "Apabila nilai soalan, yang digunakan dalam ekspresi logik, berubah dan ekspresi logik mengembalikan nilai benar, maka nilai ditetapkan kepada soalan yang dipilih.",
            trigger_copyvalueDescription: "Apabila nilai soalan, yang digunakan dalam ekspresi logik, berubah dan ekspresi logik mengembalikan nilai benar, maka nilai salah satu soalan yang dipilih akan disalin kepada satu lagi soalan yang dipilih.",
            trigger_skipDescription: "Apabila ekspresi logik mengembalikan nilai benar, maka tinjauan melangkau kepada / fokus pada soalan yang dipilih.",
            trigger_runExpressionDescription: "Apabila ekspresi mengembalikan nilai benar, maka ekspresi tersuai akan dilaksanakan. Anda boleh menetapkan keputusan ekspresi ini kepada soalan yang dipilih secara pilihan",
            completedHtmlOnConditionDescription: "Apabila ekspresi logik mengembalikan nilai benar, maka teks lalai untuk 'Halaman terima kasih' berubah kepada teks yang diberikan.",
            itemExpressionText: "Apabila ekspresi: '{0}' mengembalikan nilai benar:",
            itemEmptyExpressionText: "Peraturan baru",
            page_visibilityText: "Jadikan halaman {0} boleh dilihat",
            panel_visibilityText: "Jadikan panel {0} boleh dilihat",
            panel_enableText: "Jadikan panel {0} didayakan",
            question_visibilityText: "Jadikan soalan {0} boleh dilihat",
            question_enableText: "Jadikan soalan {0} didayakan",
            question_requireText: "Jadikan soalan {0} diperlukan",
            question_resetValueText: "Tetapkan semula nilai untuk soalan: {0}",
            question_setValueText: "Berikan nilai: {1} kepada soalan: {0}",
            column_visibilityText: "menjadikan {0} lajur soalan {1} kelihatan",
            column_enableText: "menjadikan lajur {0} soalan {1} mendayakan",
            column_requireText: "menjadikan lajur {0} soalan {1} diperlukan",
            column_resetValueText: "Set semula nilai sel untuk lajur: {0}",
            column_setValueText: "Peruntukkan nilai sel: {1} kepada lajur: {0}",
            setValueExpressionPlaceholder: " Ungkapan yang hasilnya akan diberikan kepada soalan sasaran.",
            trigger_completeText: "Tinjauan dilengkapkan",
            trigger_setvalueText: "Tetapkan kepada soalan: {0} nilai {1}",
            trigger_setvalueEmptyText: "nilai soalan yang jelas: {0}",
            trigger_copyvalueText: "Salin kepada soalan: {0} nilai daripada soalan {1}",
            trigger_skipText: "Tinjauan melangkau ke soalan {0}",
            trigger_runExpressionText1: "Jalankan ekspresi: '{0}'",
            trigger_runExpressionText2: " dan tetapkan keputusannya kepada soalan: {0}",
            completedHtmlOnConditionText: "Tunjukkan teks tersuai untuk 'Halaman terima kasih'.",
            showAllQuestions: "Semua Soalan",
            showAllActionTypes: "Semua Jenis Tindakan",
            conditions: "Syarat",
            actions: "Tindakan",
            expressionEditorTitle: "Takrifkan syarat",
            actionsEditorTitle: "Takrifkan tindakan",
            deleteAction: "Padamkan tindakan",
            addNewAction: "Tambahkan tindakan baharu",
            selectedActionCaption: "Pilih tindakan untuk ditambahkan...",
            expressionInvalid: "Ekspresi logik kosong atau tidak sah. Sila betulkannya.",
            noActionError: "Sila tambahkan sekurang-kurangnya satu tindakan.",
            actionInvalid: "Sila baiki masalah dalam tindakan anda.",
            uncompletedRule_title: "Peraturan logik tidak lengkap",
            uncompletedRule_text: "Anda belum menyelesaikan beberapa peraturan logik. Jika anda meninggalkan tab sekarang, perubahan akan hilang. Adakah anda masih mahu meninggalkan tab tanpa melengkapkan perubahan?",
            uncompletedRule_apply: "Ya",
            uncompletedRule_cancel: "Tidak, saya mahu melengkapkan peraturan"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Nama panel",
            title: "Tajuk panel",
            description: "Penerangan panel",
            visibleIf: "Jadikan panel kelihatan jika",
            requiredIf: "Buat panel diperlukan jika",
            questionsOrder: "Tertib soalan dalam panel",
            page: "Halaman induk",
            startWithNewLine: "Paparkan panel pada baris baru",
            state: "Keadaan panel runtuh",
            width: "Lebar panel sebaris",
            minWidth: "Lebar panel minimum",
            maxWidth: "Lebar panel maksimum",
            showNumber: "Panel nombor"
        },
        paneldynamic: {
            name: "Nama panel",
            title: "Tajuk panel",
            description: "Penerangan panel",
            visibleIf: "Jadikan panel kelihatan jika",
            requiredIf: "Buat panel diperlukan jika",
            page: "Mengalihkan panel ke halaman",
            startWithNewLine: "Paparkan panel pada baris baru",
            state: "Keadaan panel runtuh",
            width: "Lebar panel sebaris",
            minWidth: "Lebar panel minimum",
            maxWidth: "Lebar panel maksimum",
            confirmDelete: "Sahkan penghapusan panel",
            templateDescription: "Corak perihalan panel",
            templateTitle: "Corak tajuk panel",
            noEntriesText: "Teks panel kosong",
            templateTabTitle: "Corak tajuk tab",
            tabTitlePlaceholder: "Ruang letak tajuk tab",
            templateVisibleIf: "Jadikan panel individu kelihatan jika",
            hideNumber: "Sembunyikan nombor panel",
            titleLocation: "Penjajaran tajuk panel",
            descriptionLocation: "Penjajaran perihalan panel",
            templateTitleLocation: "Penjajaran tajuk soalan",
            templateErrorLocation: "Penjajaran mesej ralat",
            newPanelPosition: "Lokasi panel baru",
            keyName: "Mencegah jawapan pendua dalam soalan berikut"
        },
        question: {
            name: "Nama soalan",
            title: "Tajuk soalan",
            description: "Penerangan soalan",
            visibleIf: "Jadikan soalan kelihatan jika",
            requiredIf: "Jadikan soalan diperlukan jika",
            page: "Halaman induk",
            state: "Keadaan kotak soalan runtuh",
            hideNumber: "Sembunyikan nombor soalan",
            titleLocation: "Penjajaran tajuk soalan",
            descriptionLocation: "Penjajaran perihalan soalan",
            errorLocation: "Penjajaran mesej ralat",
            indent: "Meningkatkan inden dalaman",
            width: "Lebar soalan sebaris",
            minWidth: "Lebar soalan minimum",
            maxWidth: "Lebar soalan maksimum",
            textUpdateMode: "Mengemas kini nilai medan input"
        },
        signaturepad: {
            signatureWidth: "Lebar kawasan tandatangan",
            signatureHeight: "Ketinggian kawasan tandatangan",
            signatureAutoScaleEnabled: "Menskalakan kawasan tandatangan secara automatik",
            showPlaceholder: "Menunjukkan ruang letak",
            placeholder: "Teks ruang letak",
            placeholderReadOnly: "Teks ruang letak dalam mod baca sahaja atau pratonton",
            allowClear: "Tunjukkan butang Kosongkan dalam kawasan tandatangan",
            penMinWidth: "Lebar pen minimum",
            penMaxWidth: "Lebar pen maksimum",
            penColor: "Warna strok"
        },
        comment: {
            rows: "Ketinggian medan input (dalam garisan)"
        },
        showQuestionNumbers: "Tunjukkan nombor soalan",
        questionStartIndex: "Indeks mula soalan (1, 2 atau 'A', 'a')",
        expression: {
            name: "Nama ungkapan",
            title: "Tajuk ungkapan",
            description: "Perihalan ungkapan",
            expression: "Ungkapan"
        },
        trigger: {
            expression: "Ungkapan"
        },
        calculatedvalue: {
            expression: "Ungkapan"
        },
        // survey templates
        survey: {
            title: "Tajuk",
            description: "Penerangan tinjauan"
        },
        page: {
            name: "Nama halaman",
            title: "Tajuk",
            description: "Perihalan halaman",
            visibleIf: "Jadikan halaman kelihatan jika",
            requiredIf: "Jadikan halaman diperlukan jika",
            maxTimeToFinish: "Had masa untuk menyelesaikan halaman (dalam beberapa saat)",
            questionsOrder: "Tertib soalan pada halaman"
        },
        matrixdropdowncolumn: {
            name: "Nama lajur",
            title: "Tajuk lajur",
            isUnique: "Elakkan tindak balas pendua",
            width: "Lebar lajur",
            minWidth: "Lebar lajur minimum",
            rows: "Ketinggian medan input (dalam garisan)",
            visibleIf: "Jadikan lajur kelihatan jika",
            requiredIf: "Jadikan lajur diperlukan jika",
            showInMultipleColumns: "Setiap opsyen dalam lajur berasingan"
        },
        multipletextitem: {
            name: "Nama",
            title: "Tajuk"
        },
        masksettings: {
            saveMaskedValue: "Simpan nilai bertopeng dalam hasil tinjauan"
        },
        patternmask: {
            pattern: "Corak nilai"
        },
        datetimemask: {
            min: "Nilai minimum",
            max: "Nilai maksimum"
        },
        numericmask: {
            allowNegativeValues: "Benarkan nilai negatif",
            thousandsSeparator: "Pemisah beribu-ribu",
            decimalSeparator: "Pemisah perpuluhan",
            precision: "Ketepatan nilai",
            min: "Nilai minimum",
            max: "Nilai maksimum"
        },
        currencymask: {
            prefix: "Awalan mata wang",
            suffix: "Akhiran mata wang"
        },
        imageHeight: "Tinggi imej",
        imageWidth: "Lebar imej",
        valueName: "Nama nilai",
        rateDescriptionLocation: "Penjajaran label",
        size: "Saiz medan input (dalam aksara)",
        cellErrorLocation: "Penjajaran mesej ralat sel",
        apply: "Guna",
        ok: "OK",
        save: "Simpan",
        clear: "Jelas",
        saveTooltip: "Simpan",
        cancel: "Batal",
        set: "Set",
        reset: "Tetap Semula",
        change: "Menukar",
        refresh: "Segar semula",
        close: "Tutup",
        delete: "Padam",
        add: "Tambahkan",
        addNew: "Tambah Baharu",
        addItem: "Klik untuk menambahkan item...",
        removeItem: "Klik untuk mengalih keluar item...",
        dragItem: "Seret item",
        addOther: "Lain-lain",
        addSelectAll: "Pilih Semua",
        addNone: "Tiada",
        removeAll: "Alih Keluar Semua",
        edit: "Edit",
        back: "Kembali tanpa menyimpan",
        backTooltip: "Kembali tanpa menyimpan",
        saveAndBack: "Simpan dan kembali",
        saveAndBackTooltip: "Simpan dan kembali",
        doneEditing: "Dilakukan",
        editChoices: "Edit Pilihan",
        showChoices: "Tunjukkan Pilihan",
        move: "Alih",
        empty: "<empty>",
        emptyValue: "Nilai kosong",
        fastEntry: "Entri Pantas",
        fastEntryNonUniqueError: "Nilai '{0}' tidak unik",
        fastEntryChoicesCountError: "Sila hadkan bilangan item dari {0} hingga {1}",
        fastEntryChoicesMinCountError: "Sila masukkan sekurang-kurangnya {0} item",
        fastEntryPlaceholder: "Anda boleh mengesetkan data dalam format berikut:\nvalue1|text\nnilai2",
        formEntry: "Entri Borang",
        testService: "Uji perkhidmatan",
        itemSelectorEmpty: "Sila pilih elemen",
        conditionActionEmpty: "Sila pilih tindakan",
        conditionSelectQuestion: "Pilih soalan...",
        conditionSelectPage: "Pilih halaman...",
        conditionSelectPanel: "Pilih panel...",
        conditionValueQuestionTitle: "Sila masukkan/pilih nilai",
        aceEditorHelp: "Tekan ctrl+space untuk mendapatkan petunjuk lengkapan ekspresi",
        aceEditorRowTitle: "Baris semasa",
        aceEditorPanelTitle: "Panel semasa",
        showMore: "Untuk butiran lanjut, sila semak dokumentasi",
        assistantTitle: "Soalan tersedia:",
        cellsEmptyRowsColumns: "Terdapat sekurang-kurangnya satu lajur atau baris",
        showPreviewBeforeComplete: "Pratonton jawapan sebelum menyerahkan tinjauan",
        overridingPropertyPrefix: "Ditetapkan mengikut ",
        resetToDefaultCaption: "Set semula",
        propertyIsEmpty: "Sila masukkan nilai",
        propertyIsNoUnique: "Sila masukkan nilai unik",
        propertyNameIsNotUnique: "Sila masukkan nama unik",
        propertyNameIsIncorrect: "Jangan gunakan perkataan terpelihara: \"item\", \"pilihan\", \"panel\", \"baris\".",
        listIsEmpty: "Tambahkan item baharu",
        "listIsEmpty@choices": "Tiada pilihan telah ditambah lagi",
        "listIsEmpty@columns": "Anda belum mempunyai sebarang lajur",
        "listIsEmpty@rows": "Anda belum mempunyai sebarang baris",
        "listIsEmpty@validators": "Anda belum mempunyai sebarang peraturan pengesahihan",
        "listIsEmpty@calculatedValues": "Anda belum mempunyai sebarang pemboleh ubah tersuai",
        "listIsEmpty@triggers": "Anda belum mempunyai sebarang pencetus",
        "listIsEmpty@navigateToUrlOnCondition": "Anda belum mempunyai pautan",
        "addNew@choices": "Tambah pilihan",
        "addNew@columns": "Menambah lajur baru",
        "addNew@rows": "Menambah baris baru",
        "addNew@validators": "Tambah peraturan baru",
        "addNew@calculatedValues": "Menambah pemboleh ubah baru",
        "addNew@triggers": "Tambah pencetus baharu",
        "addNew@navigateToUrlOnCondition": "Tambah URL baru",
        expressionIsEmpty: "Ekspresi kosong",
        value: "Nilai",
        text: "Teks",
        rowid: "ID Baris",
        imageLink: "Pautan Imej",
        columnEdit: "Edit lajur: {0}",
        itemEdit: "Edit item: {0}",
        url: "URL",
        path: "Laluan",
        choicesbyurl: {
            url: "URL perkhidmatan web",
            valueName: "Mendapatkan nilai daripada medan JSON berikut"
        },
        titleName: "Nama tajuk",
        imageLinkName: "Dapatkan URL imej daripada medan JSON berikut",
        allowEmptyResponse: "Benarkan respons kosong",
        titlePlaceholder: "Tajuk input di sini",
        surveyTitlePlaceholder: "Tajuk tinjauan input di sini",
        pageTitlePlaceholder: "Tajuk halaman input di sini",
        descriptionPlaceholder: "Masukkan perihalan",
        surveyDescriptionPlaceholder: "Masukkan perihalan tinjauan",
        pageDescriptionPlaceholder: "Masukkan perihalan halaman",
        textWrapEnabled: "Pilihan balut",
        showOtherItem: "Ada item lain",
        otherText: "Teks item lain",
        showNoneItem: "Tiada item",
        showRefuseItem: "Benarkan pilihan Enggan Menjawab",
        showDontKnowItem: "Benarkan pilihan Jangan Tahu",
        noneText: "Tiada teks item",
        showSelectAllItem: "Telah pilih semua item",
        selectAllText: "Pilih semua teks item",
        choicesMin: "Nilai minimum untuk item auto dijana",
        choicesMax: "Nilai maksimum untuk item auto dijana",
        choicesStep: "Perbezaan antara item auto dijana",
        name: "Nama",
        title: "Tajuk",
        cellType: "Jenis sel",
        colCount: "Kiraan lajur",
        choicesOrder: "Pilih susunan pilihan",
        visible: "Boleh dilihat?",
        isRequired: "Diperlukan?",
        markRequired: "Tandakan mengikut keperluan",
        removeRequiredMark: "Mengalih keluar tanda yang diperlukan",
        isAllRowRequired: "Perlukan jawapan untuk semua baris",
        eachRowUnique: "Mengelakkan respons pendua dalam baris",
        requiredErrorText: "Teks ralat diperlukan",
        startWithNewLine: "Mulakan dengan baris baharu?",
        rows: "Kiraan baris",
        cols: "Kiraan lajur",
        placeholder: "Ruang letak input",
        showPreview: "Tunjukkan kawasan pratonton",
        storeDataAsText: "Simpan kandungan fail dalam keputusan JSON sebagai teks",
        maxSize: "Maksimum saiz fail dalam bait",
        rowCount: "Kiraan baris",
        columnLayout: "Tataletak lajur",
        addRowLocation: "Tambahkan lokasi butang baris",
        transposeData: "Mengubah urutan baris kepada lajur",
        addRowText: "Tambahkan teks butang baris",
        removeRowText: "Alih keluar teks butang baris",
        rateMin: "Kadar minimum",
        rateMax: "Kadar maksimum",
        rateStep: "Langkah kadar",
        minRateDescription: "Perihalan kadar minimum",
        maxRateDescription: "Perihalan kadar maksimum",
        inputType: "Jenis input",
        optionsCaption: "Kapsyen pilihan",
        defaultValue: "Nilai lalai",
        cellsDefaultRow: "Teks sel lalai",
        surveyEditorTitle: "Edit tetapan tinjauan",
        qEditorTitle: "Edit: {0}",
        maxLength: "Panjang maksimum",
        buildExpression: "Bina",
        editExpression: "Edit",
        and: "Dan",
        or: "Atau",
        remove: "Alih keluar",
        addCondition: "Tambahkan syarat",
        emptyLogicPopupMessage: "Pilih soalan untuk mula mengkonfigurasi syarat.",
        if: "Jika",
        then: "Kemudian",
        setToName: "Soalan sasaran",
        fromName: "Soalan untuk menyalin jawapan daripada",
        gotoName: "Soalan untuk melangkau ke",
        ruleIsNotSet: "Peraturan tidak betul",
        includeIntoResult: "Dimasukkan ke dalam hasil tinjauan",
        showTitle: "Tunjukkan/sembunyikan tajuk",
        expandCollapseTitle: "Kembangkan/runtuhkan tajuk",
        locale: "Bahasa lalai",
        simulator: "Pilih peranti",
        landscapeOrientation: "Landskap",
        portraitOrientation: "Bertukar kepada orientasi potret",
        mode: "Mod (edit/baca sahaja)",
        clearInvisibleValues: "Kosongkan nilai tersembunyi",
        cookieName: "Nama kuki (untuk melumpuhkan perlaksanaan tinjauan dua kali secara setempat)",
        sendResultOnPageNext: "Hantar keputusan tinjauan pada halaman seterusnya",
        storeOthersAsComment: "Simpan nilai 'lain-lain' dalam medan berasingan",
        showPageTitles: "Tunjukkan tajuk halaman",
        showPageNumbers: "Tunjukkan nombor halaman",
        pagePrevText: "Teks butang halaman sebelumnya",
        pageNextText: "Teks butang halaman seterusnya",
        completeText: "Teks butang lengkapkan",
        previewText: "Teks butang pratonton",
        editText: "Edit teks butang",
        startSurveyText: "Teks butang mulakan",
        showNavigationButtons: "Tunjukkan butang navigasi (navigasi lalai)",
        showPrevButton: "Tunjukkan butang sebelumnya (pengguna boleh kembali ke halaman seterusnya)",
        firstPageIsStarted: "Halaman pertama dalam tinjauan ialah halaman permulaan.",
        showCompletedPage: "Tunjukkan halaman lengkap pada hujung (HTML dilengkapkan)",
        goNextPageAutomatic: "Selepas menjawab semua soalan, pergi ke halaman seterusnya secara automatik",
        allowCompleteSurveyAutomatic: "Lengkapkan tinjauan secara automatik",
        showProgressBar: "Tunjukkan bar perkembangan",
        questionTitleLocation: "Lokasi tajuk soalan",
        questionTitleWidth: "Lebar tajuk soalan",
        requiredText: "Soalan memerlukan simbol",
        questionTitleTemplate: "Templat tajuk soalan, lalai ialah: '{tidak}. {perlukan} {tajuk}'",
        questionErrorLocation: "Lokasi ralat soalan",
        focusFirstQuestionAutomatic: "Fokus soalan pertama pada perubahan halaman",
        questionsOrder: "Susunan elemen pada halaman",
        maxTimeToFinish: "Masa maksimum untuk menyelesaikan tinjauan",
        maxTimeToFinishPage: "Masa maksimum untuk menyelesaikan halaman dalam tinjauan",
        showTimerPanel: "Tunjukkan panel pemasa",
        showTimerPanelMode: "Tunjukkan mod panel pemasa",
        renderMode: "Mod penyampaian",
        allowAddPanel: "Benarkan menambahkan panel",
        allowRemovePanel: "Benarkan alih keluar panel",
        panelAddText: "Menambahkan teks panel",
        panelRemoveText: "Mengalih keluar teks panel",
        isSinglePage: "Tunjukkan semua elemen pada satu halaman",
        html: "HTML",
        setValue: "Jawapan",
        dataFormat: "Format imej",
        allowAddRows: "Benarkan menambah baris",
        allowRemoveRows: "Benarkan mengalih keluar baris",
        allowRowsDragAndDrop: "Benarkan seret dan lepas baris",
        responsiveImageSizeHelp: "Tidak terpakai jika anda menentukan lebar atau ketinggian imej yang tepat.",
        minImageWidth: "Lebar imej minimum",
        maxImageWidth: "Lebar imej maksimum",
        minImageHeight: "Ketinggian imej minimum",
        maxImageHeight: "Ketinggian imej maksimum",
        minValue: "Nilai minimum",
        maxValue: "Nilai maksimum",
        minLength: "Panjang minimum",
        allowDigits: "Benarkan digit",
        minCount: "Bilangan minimum",
        maxCount: "Bilangan maksimum",
        regex: "Ekspresi biasa",
        surveyvalidator: {
            text: "Mesej ralat",
            expression: "Ungkapan pengesahihan"
        },
        totalText: "Jumlah teks",
        totalType: "Jumlah jenis",
        totalExpression: "Jumlah ekspresi",
        totalDisplayStyle: "Jumlah gaya paparan",
        totalCurrency: "Jumlah mata wang",
        totalFormat: "Jumlah format",
        logo: "Logo (URL atau rentetan berkod asas64)",
        questionsOnPageMode: "Struktur tinjauan",
        maxTextLength: "Panjang jawapan maksimum (dalam aksara)",
        maxOthersLength: "Panjang komen maksimum (dalam aksara)",
        commentAreaRows: "Komen ketinggian kawasan (dalam garisan)",
        autoGrowComment: "Kembangkan kawasan komen secara automatik jika perlu",
        allowResizeComment: "Benarkan pengguna mensaiz semula kawasan teks",
        textUpdateMode: "Mengemas kini nilai soalan teks",
        maskType: "Input jenis topeng",
        maskTypes: {
            none: "Tiada",
            patternmask: "Corak",
            numericmask: "Angka",
            datetimemask: "Tarikh dan Masa",
            currencymask: "Mata wang"
        },
        focusOnFirstError: "Mengesetkan fokus pada jawapan tidak sah yang pertama",
        checkErrorsMode: "Jalankan pengesahihan",
        navigateToUrl: "Navigasi ke URL",
        navigateToUrlOnCondition: "URL dinamik",
        completedBeforeHtml: "Penanda untuk menunjukkan sama ada pengguna telah mengisi tinjauan ini",
        completedHtml: "Tinjauan Penanda halaman lengkap",
        completedHtmlOnCondition: "Tinjauan Dinamik Lengkapkan penanda halaman",
        loadingHtml: "Penanda untuk ditunjukkan semasa model tinjauan sedang dimuatkan",
        commentText: "Teks kawasan komen",
        autocomplete: "Jenis autolengkap",
        labelTrue: "Label \"Benar\"",
        labelFalse: "Label \"Palsu\"",
        allowClear: "Tunjukkan kapsyen pilihan",
        searchMode: "Mod Carian",
        displayStyle: "Gaya paparan nilai",
        format: "Rentetan yang diformatkan",
        maximumFractionDigits: "Nombor pecahan maksimum",
        minimumFractionDigits: "Digit pecahan minimum",
        useGrouping: "Paparkan pemisah perkumpulan",
        allowMultiple: "Benarkan berbilang fail",
        allowImagesPreview: "Pratonton imej",
        acceptedTypes: "Jenis fail yang diterima",
        waitForUpload: "Tunggu muat naik selesai",
        needConfirmRemoveFile: "Sahkan penghapusan fail",
        detailPanelMode: "Lokasi panel terperinci",
        minRowCount: "Kiraan baris minimum",
        maxRowCount: "Kiraan baris maksimum",
        confirmDelete: "Sahkan pemadaman baris",
        confirmDeleteText: "Mesej pengesahan",
        panelCount: "Kiraan panel awal",
        minPanelCount: "Kiraan panel minimum",
        maxPanelCount: "Kiraan panel maksimum",
        panelsState: "Panel dalaman mengembangkan keadaan",
        panelPrevText: "Petua alat butang Panel Sebelumnya",
        panelNextText: "Petua alat butang Panel Seterusnya",
        showRangeInProgress: "Tunjukkan bar kemajuan",
        panelRemoveButtonLocation: "Alih keluar lokasi butang Panel",
        hideIfRowsEmpty: "Sembunyikan soalan jika tiada baris",
        hideColumnsIfEmpty: "Menyembunyikan lajur jika tiada baris",
        rateValues: "Nilai kadar tersuai",
        rateCount: "Kiraan kadar",
        autoGenerate: "Bagaimana untuk menentukan nilai kadar?",
        hideIfChoicesEmpty: "Sembunyikan soalan jika ia tidak mengandungi pilihan",
        minWidth: "Lebar minimum (dalam nilai diterima CSS)",
        maxWidth: "Lebar maksimum (dalam nilai diterima CSS)",
        width: "Lebar (dalam nilai diterima CSS)",
        showHeader: "Tunjukkan pengepala lajur",
        horizontalScroll: "Menunjukkan bar skrol mendatar",
        columnMinWidth: "Lebar lajur minimum (dalam nilai diterima CSS)",
        rowTitleWidth: "Lebar pengepala baris (dalam nilai diterima CSS)",
        valueTrue: "Nilai \"Benar\"",
        valueFalse: "Nilai \"Palsu\"",
        minErrorText: "Mesej ralat \"Nilai adalah di bawah minimum\"",
        maxErrorText: "Mesej ralat \"Nilai melebihi maksimum\"",
        otherErrorText: "Mesej ralat \"komen kosong\"",
        keyDuplicationError: "Mesej ralat \"Nilai kunci bukan unik\"",
        minSelectedChoices: "Pilihan minimum yang dipilih",
        maxSelectedChoices: "Pilihan maksimum yang dipilih",
        showClearButton: "Tunjukkan butang Kosongkan",
        logoWidth: "Lebar logo (dalam nilai diterima CSS)",
        logoHeight: "Ketinggian logo (dalam nilai diterima CSS)",
        readOnly: "Baca sahaja",
        enableIf: "Boleh diedit jika",
        emptyRowsText: "Mesej \"Tiada baris\"",
        separateSpecialChoices: "Pilihan khas berasingan (Tiada, Lain-lain, Pilih Semua)",
        choicesFromQuestion: "Salin pilihan daripada soalan berikut",
        choicesFromQuestionMode: "Pilihan mana yang hendak disalin?",
        progressBarShowPageTitles: "Paparkan tajuk halaman dalam bar kemajuan",
        progressBarShowPageNumbers: "Paparkan nombor halaman dalam bar kemajuan",
        showCommentArea: "Tunjukkan kawasan komen",
        commentPlaceholder: "Ruang letak komen",
        displayRateDescriptionsAsExtremeItems: "Memaparkan perihalan kadar sebagai nilai melampau",
        rowsOrder: "Tertib baris",
        columnsLayout: "Tataletak lajur",
        columnColCount: "Kiraan lajur tersarang",
        correctAnswer: "Jawapan yang betul",
        defaultPanelValue: "Nilai Lalai",
        cells: "Teks sel",
        fileInputPlaceholder: "Pilih fail atau tampal pautan fail...",
        keyName: "Lajur utama",
        itemvalue: {
            visibleIf: "Jadikan opsyen kelihatan jika",
            enableIf: "Jadikan opsyen boleh dipilih jika"
        },
        "itemvalue@rows": {
            visibleIf: "Jadikan baris kelihatan jika",
            enableIf: "Jadikan baris boleh diedit jika"
        },
        imageitemvalue: {
            text: "Teks alt"
        },
        logoPosition: "Kedudukan logo",
        addLogo: "Tambahkan logo...",
        changeLogo: "Ubah logo...",
        logoPositions: {
            none: "Alih keluar logo",
            left: "Kiri",
            right: "Kanan",
            top: "Di atas",
            bottom: "Di bawah"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Tataletak Panel"
            },
            general: "Umum",
            fileOptions: "Pilihan",
            html: "Editor HTML",
            columns: "Lajur",
            rows: "Baris",
            choices: "Pilihan",
            items: "Item",
            visibleIf: "Boleh Dilihat Jika",
            enableIf: "Dayakan Jika",
            requiredIf: "Diperlukan Jika",
            rateValues: "Nilai Kadar",
            choicesByUrl: "Pilihan daripada Web",
            matrixChoices: "Pilihan Lalai",
            multipleTextItems: "Input Teks",
            numbering: "Nombor",
            validators: "Pengesah",
            navigation: "Navigasi",
            question: "Soalan",
            pages: "Halaman",
            timer: "Pemasa/Kuiz",
            calculatedValues: "Nilai Dikira",
            triggers: "Pencetus",
            templateTitle: "Tajuk templat",
            totals: "Jumlah",
            logic: "Logik",
            mask: "Seting Topeng Input",
            layout: {
                panel: "Susun atur",
                question: "Susun atur",
                base: "Susun atur"
            },
            data: "Data",
            validation: "Pengesahan",
            cells: "Sel",
            showOnCompleted: "Tunjukkan pada Dilengkapkan",
            logo: "Logo dalam Tajuk Tinjauan",
            slider: "Penggelongsor",
            expression: "Ungkapan",
            questionSettings: "Seting Soalan",
            header: "Pengepala",
            background: "Latar belakang",
            appearance: "Penampilan",
            others: "Lain-lain"
        },
        editProperty: "Edit ciri '{0}'",
        items: "[ Item: {0} ]",
        choicesVisibleIf: "Pilihan boleh dilihat jika",
        choicesEnableIf: "Pilihan boleh dipilih jika",
        columnsEnableIf: "Lajur kelihatan jika",
        rowsEnableIf: "Baris boleh dilihat jika",
        innerIndent: "Menambah inden dalaman",
        defaultValueFromLastRow: "Mengambil nilai lalai daripada baris terakhir",
        defaultValueFromLastPanel: "Mengambil nilai lalai daripada panel terakhir",
        enterNewValue: "Sila masukkan nilai.",
        noquestions: "Tiada soalan lain dalam tinjauan.",
        createtrigger: "Sila cipta pencetus",
        titleKeyboardAdornerTip: "Tekan butang enter untuk mengedit",
        keyboardAdornerTip: "Tekan butang enter untuk mengedit item, tekan butang padam untuk memadamkan item, tekan butang alt dan anak panah ke atas atau ke bawah untuk menggerakkan item",
        triggerOn: "Hidup ",
        triggerMakePagesVisible: "Jadikan halaman boleh dilihat:",
        triggerMakeQuestionsVisible: "Buat elemen boleh dilihat:",
        triggerCompleteText: "Lengkapkan tinjauan jika berjaya.",
        triggerNotSet: "Pencetus tidak ditetapkan",
        triggerRunIf: "Jalankan jika",
        triggerSetToName: "Ubah nilai: ",
        triggerFromName: "Salin nilai daripada: ",
        triggerRunExpression: "Jalankan Ekspresi ini:",
        triggerSetValue: "kepada: ",
        triggerGotoName: "Pergi kepada soalan:",
        triggerIsVariable: "Jangan letakkan pemboleh ubah dalam keputusan tinjauan.",
        triggerRunExpressionEmpty: "Sila masukkan ekspresi yang sah",
        emptyExpressionPlaceHolder: "Taip ungkapan di sini...",
        noFile: "Tiada fail dipilih",
        clearIfInvisible: "Kosongkan nilai jika soalan menjadi tersembunyi",
        valuePropertyName: "Nama sifat nilai",
        searchEnabled: "Dayakan carian",
        hideSelectedItems: "Menyembunyikan item terpilih",
        closeOnSelect: "Menutup juntai bawah selepas pemilihan",
        verticalAlign: "Penjajaran menegak",
        alternateRows: "Baris alternatif",
        columnsVisibleIf: "Lajur kelihatan jika",
        rowsVisibleIf: "Baris boleh dilihat jika",
        otherPlaceholder: "Ruang letak komen",
        filePlaceholder: "Teks ruang letak fail",
        photoPlaceholder: "Teks ruang letak foto",
        fileOrPhotoPlaceholder: "Teks ruang letak fail atau foto",
        rateType: "Jenis kadar",
        url_placeholder: "Ex.: https://api.example.com/books",
        path_placeholder: "Ex.: categories.fiction",
        questionStartIndex_placeholder: "Ex.: a)",
        width_placeholder: "Ex.: 6in",
        minWidth_placeholder: "Ex.: 600px",
        maxWidth_placeholder: "Ex.: 50%",
        imageHeight_placeholder: "Auto",
        imageWidth_placeholder: "Auto",
        theme: {
            themeName: "Tema",
            isPanelless: "Penampilan soalan",
            editorPanel: "Latar belakang dan jejari sudut",
            questionPanel: "Latar belakang dan jejari sudut",
            primaryColor: "Warna aksen",
            panelBackgroundTransparency: "Kelegapan latar belakang panel",
            questionBackgroundTransparency: "Kelegapan latar belakang soalan",
            fontSize: "Saiz fon",
            scale: "Skala",
            cornerRadius: "Jejari penjuru",
            pageTitle: "Fon tajuk",
            pageDescription: "Fon perihalan",
            questionTitle: "Fon tajuk",
            questionDescription: "Fon perihalan",
            editorFont: "Fon",
            backgroundOpacity: "Kelegapan",
            "--sjs-font-family": "Keluarga fon",
            "--sjs-general-backcolor-dim": "Warna latar belakang",
            "--sjs-primary-backcolor": "Latar belakang aksen",
            "--sjs-primary-forecolor": "Aksen latar depan",
            "--sjs-special-red": "Mesej ralat",
            "--sjs-shadow-small": "Kesan bayang",
            "--sjs-shadow-inner": "Kesan bayang",
            "--sjs-border-default": "Warna"
        },
        "header@header": {
            headerView: "Lihat",
            logoPosition: "Kedudukan logo",
            surveyTitle: "Fon tajuk tinjauan",
            surveyDescription: "Fon perihalan tinjauan",
            headerTitle: "Fon tajuk tinjauan",
            headerDescription: "Fon perihalan tinjauan",
            inheritWidthFrom: "Lebar kawasan kandungan",
            textAreaWidth: "Lebar teks",
            backgroundColorSwitch: "Warna latar belakang",
            backgroundImage: "Imej latar belakang",
            backgroundImageOpacity: "Kelegapan",
            overlapEnabled: "Bertindih",
            logoPositionX: "Kedudukan logo",
            titlePositionX: "Kedudukan tajuk",
            descriptionPositionX: "Kedudukan perihalan"
        }
    },
    // Property values
    pv: {
        "true": "Benar",
        "false": "Palsu",
        file: "Fail tempatan",
        camera: "Kamera",
        "file-camera": "Fail atau kamera tempatan",
        inherit: "warisi",
        show: "tunjukkan",
        hide: "sembunyikan",
        default: "lalai",
        initial: "awal",
        random: "rawak",
        collapsed: "kuncup",
        expanded: "kembang",
        none: "tiada",
        asc: "tertib menaik",
        desc: "menurun",
        indeterminate: "tidak tentu",
        selected: "Dipilih",
        unselected: "Tidak dipilih",
        decimal: "Perpuluhan",
        currency: "Mata wang",
        percent: "Peratus",
        firstExpanded: "Pertama dikembangkan",
        off: "mati",
        list: "senarai",
        progressTop: "Perkembangan atas",
        progressBottom: "Perkembangan bawah",
        progressTopBottom: "Perkembangan atas bawah",
        tab: "Tab",
        horizontal: "mendatar",
        vertical: "menegak",
        top: "atas",
        bottom: "bawah",
        topBottom: "atas dan bawah",
        both: "kedua-duanya",
        left: "baki",
        right: "Kanan",
        center: "Pusat",
        leftRight: "Kiri dan kanan",
        middle: "Tengah",
        color: "Warna",
        date: "Tarikh",
        datetime: "masa tarikh",
        "datetime-local": "tarikh-tempatan",
        email: "E-mel",
        month: "Bulan",
        number: "Nombor",
        password: "Kata laluan",
        range: "Pelbagai",
        tel: "Tel",
        text: "Teks",
        time: "Masa",
        url: "Url",
        week: "Minggu",
        hidden: "tersembunyi",
        edit: "edit",
        display: "paparan",
        contain: "Mengandungi",
        cover: "Perlindungan",
        fill: "Mengisi",
        next: "Seterusnya",
        last: "Terakhir",
        onComplete: "Pada selesai",
        onHidden: "Pada tersembunyi",
        onHiddenContainer: "Apabila soalan atau panel/halamannya menjadi tersembunyi",
        clearInvisibleValues: {
            none: "Tidak pernah"
        },
        clearIfInvisible: {
            none: "Tidak pernah"
        },
        inputType: {
            color: "Warna",
            date: "Tarikh",
            "datetime-local": "Tarikh dan Masa",
            email: "E-mel",
            month: "Bulan",
            number: "Nombor",
            password: "Kata laluan",
            range: "Pelbagai",
            tel: "Nombor Telefon",
            text: "Teks",
            time: "Masa",
            url: "URL",
            week: "Minggu"
        },
        all: "semua",
        page: "halaman",
        survey: "tinjauan",
        onNextPage: "Pada halaman berikutnya",
        onValueChanged: "Pada nilai berubah",
        onValueChanging: "Sebelum jawapan diubah",
        questionsOnPageMode: {
            standard: "Struktur asal",
            singlePage: "Tunjukkan semua soalan pada satu halaman",
            questionPerPage: "Menunjukkan soalan tunggal bagi setiap halaman"
        },
        noPreview: "tiada pratonton",
        showAllQuestions: "tunjukkan pratonton dengan semua soalan",
        showAnsweredQuestions: "tunjukkan pratonton dengan soalan dijawab",
        pages: "halaman",
        questions: "soalan",
        requiredQuestions: "soalan diperlukan",
        correctQuestions: "soalan betul",
        buttons: "butang",
        underInput: "input di bawah",
        underTitle: "tajuk di bawah",
        onBlur: "Pada kabur",
        onTyping: "Semasa menaip",
        underRow: "Di bawah baris",
        underRowSingle: "Di bawah baris, hanya satu panel boleh dilihat",
        auto: "Auto",
        showNavigationButtons: {
            none: "Tersembunyi"
        },
        showTimerPanel: {
            none: "Tersembunyi"
        },
        showTimerPanelMode: {
            all: "Kedua-duanya"
        },
        addRowLocation: {
            default: "Bergantung pada tataletak matriks"
        },
        panelsState: {
            default: "Pengguna tidak boleh mengembangkan atau meruntuhkan panel",
            collapsed: "Semua panel runtuh",
            expanded: "Semua panel diperluaskan",
            firstExpanded: "Mula-mula diperluaskan"
        },
        widthMode: {
            static: "Statik",
            responsive: "Responsif"
        },
        contentMode: {
            image: "Imej",
            video: "Video",
            youtube: "Youtube"
        },
        displayMode: {
            buttons: "Butang",
            dropdown: "Dropdown"
        },
        rateColorMode: {
            default: "Lalai",
            scale: "Skala"
        },
        scaleColorMode: {
            monochrome: "Monokrom",
            colored: "Berwarna"
        },
        autoGenerate: {
            "true": "Menjana",
            "false": "Masukkan secara manual"
        },
        rateType: {
            labels: "Label",
            stars: "Bintang",
            smileys: "Smileys"
        },
        state: {
            default: "Dikunci"
        },
        showQuestionNumbers: {
            default: "Penomboran automatik",
            on: "Penomboran automatik",
            onPage: "Mengeset semula pada setiap halaman",
            onpanel: "Set semula pada setiap panel",
            onPanel: "Set semula pada setiap panel",
            onSurvey: "Teruskan merentasi tinjauan",
            off: "Tiada penomboran"
        },
        descriptionLocation: {
            underTitle: "Di bawah tajuk soalan",
            underInput: "Di bawah medan input"
        },
        selectToRankAreasLayout: {
            horizontal: "Di sebelah pilihan",
            vertical: "Pilihan di atas"
        },
        displayStyle: {
            decimal: "Perpuluhan",
            currency: "Mata wang",
            percent: "Peratusan",
            date: "Tarikh"
        },
        totalDisplayStyle: {
            decimal: "Perpuluhan",
            currency: "Mata wang",
            percent: "Peratusan",
            date: "Tarikh"
        },
        rowsOrder: {
            initial: "Asal"
        },
        questionsOrder: {
            initial: "Asal"
        },
        showProgressBar: {
            off: "Tersembunyi",
            topbottom: "atas dan bawah",
            aboveheader: "Di atas pengepala",
            belowheader: "Di bawah pengepala"
        },
        sum: "Jumlah",
        count: "Kiraan",
        min: "Min",
        max: "Max",
        avg: "Pur",
        searchMode: {
            contains: "Mengandungi",
            startsWith: "Bermula dengan"
        },
        backgroundImageFit: {
            auto: "Auto",
            cover: "Perlindungan",
            contain: "Mengandungi",
            fill: "Regangan",
            tile: "Jubin"
        },
        backgroundImageAttachment: {
            fixed: "Tetap",
            scroll: "Tatal"
        },
        headerView: {
            basic: "Asas",
            advanced: "Lanjutan"
        },
        inheritWidthFrom: {
            survey: "Sama seperti tinjauan",
            container: "Muat ke bekas"
        },
        backgroundColorSwitch: {
            none: "Tiada",
            accentColor: "Warna aksen",
            custom: "Tersuai"
        },
        colorPalette: {
            light: "Cahaya",
            dark: "Gelap"
        },
        isPanelless: {
            "false": "Lalai",
            "true": "Tanpa Panel"
        }
    },
    // Operators
    op: {
        empty: "kosong",
        notempty: "tidak kosong",
        equal: "sama dengan",
        notequal: "tidak sama dengan",
        contains: "mengandungi",
        notcontains: "tidak mengandungi",
        anyof: "sebarang",
        allof: "semua",
        greater: "lebih besar",
        less: "kurang",
        greaterorequal: "lebih besar atau sama dengan",
        lessorequal: "kurang atau sama dengan",
        and: "Dan",
        or: "Atau"
    },
    // Embed window
    ew: {
        angular: "Guna versi Angular",
        jquery: "Guna versi jQuery",
        knockout: "Guna versi Knockout",
        react: "Guna versi React",
        vue: "Guna versi Vue",
        bootstrap: "Untuk kerangka kerja butstrap",
        modern: "Tema moden",
        default: "Tema lalai",
        orange: "Tema oren",
        darkblue: "Tema biru gelap",
        darkrose: "Tema mawar gelap",
        stone: "Tema batu",
        winter: "Tema musim sejuk",
        winterstone: "Tema batu-musim sejuk",
        showOnPage: "Tunjukkan tinjauan pada halaman",
        showInWindow: "Tunjukkan tinjauan pada tetingkap",
        loadFromServer: "Muatkan Tinjauan JSON daripada pelayan",
        titleScript: "Skrip dan gaya",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Pilih halaman untuk mengujinya:",
        showInvisibleElements: "Pilih elemen tersembunyi",
        hideInvisibleElements: "Sembunyikan unsur tidak kelihatan"
    },
    validators: {
        answercountvalidator: "kiraan jawapan",
        emailvalidator: "e-mel",
        expressionvalidator: "ekspresi",
        numericvalidator: "numerik",
        regexvalidator: "regex",
        textvalidator: "teks"
    },
    triggers: {
        completetrigger: "lengkapkan tinjauan",
        setvaluetrigger: "tetapkan nilai",
        copyvaluetrigger: "salin nilai",
        skiptrigger: "langkau kepada soalan",
        runexpressiontrigger: "jalankan ekspresi",
        visibletrigger: "ubah kebolehlihatan (tidak digunakan lagi)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Ex.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Ex.: mm/dd/yyyy"
        },
        currencymask: {
            prefix: "Ex.: $",
            suffix: "Ex.: USD"
        },
        panelbase: {
            questionTitleWidth: "Ex.: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "ID panel yang tidak kelihatan kepada responden.",
            description: "Taipkan sari kata panel.",
            visibleIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menentukan keterlihatan panel.",
            enableIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang melumpuhkan mod baca sahaja untuk panel.",
            requiredIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menghalang penyerahan tinjauan melainkan sekurang-kurangnya satu soalan tersarang mempunyai jawapan.",
            questionTitleLocation: "Digunakan untuk semua soalan dalam panel ini. Jika anda ingin mengubah seting ini, takrifkan peraturan penjajaran tajuk untuk soalan individu. Pilihan \"Warisan\" menggunakan peringkat halaman (jika ditetapkan) atau tetapan peringkat tinjauan (\"Atas\" secara lalai).",
            questionTitleWidth: "Menetapkan lebar yang konsisten untuk tajuk soalan apabila ia dijajarkan di sebelah kiri kotak soalan mereka. Menerima nilai CSS (px, %, dalam, pt, dll.).",
            questionErrorLocation: "Mengesetkan lokasi mesej ralat berhubung dengan semua soalan dalam panel. Opsyen \"Warisan\" menggunakan aras halaman (jika set) atau seting aras tinjauan.",
            questionsOrder: "Mengekalkan susunan soalan asal atau rawak mereka. Opsyen \"Warisan\" menggunakan aras halaman (jika set) atau seting aras tinjauan.",
            page: "Meletakkan semula panel di hujung halaman yang dipilih.",
            innerIndent: "Menambah ruang atau jidar antara kandungan panel dan sempadan kiri kotak panel.",
            startWithNewLine: "Nyahpilih untuk memaparkan panel dalam satu baris dengan soalan atau panel sebelumnya. Seting tidak digunakan jika panel ialah elemen pertama dalam borang anda.",
            state: "Pilih daripada: \"Diperluaskan\" - panel dipaparkan sepenuhnya dan boleh runtuh; \"Runtuh\" - panel hanya memaparkan tajuk dan keterangan dan boleh diperluaskan; \"Dikunci\" - panel dipaparkan sepenuhnya dan tidak boleh runtuh.",
            width: "Mengesetkan lebar panel mengikut kadar unsur tinjauan lain dalam baris yang sama. Menerima nilai CSS (px, %, dalam, pt, dll.)."
        },
        paneldynamic: {
            name: "ID panel yang tidak kelihatan kepada responden.",
            description: "Taipkan sari kata panel.",
            visibleIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menentukan keterlihatan panel.",
            enableIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang melumpuhkan mod baca sahaja untuk panel.",
            requiredIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menghalang penyerahan tinjauan melainkan sekurang-kurangnya satu soalan tersarang mempunyai jawapan.",
            templateTitleLocation: "Digunakan untuk semua soalan dalam panel ini. Jika anda ingin mengubah seting ini, takrifkan peraturan penjajaran tajuk untuk soalan individu. Pilihan \"Warisan\" menggunakan peringkat halaman (jika ditetapkan) atau tetapan peringkat tinjauan (\"Atas\" secara lalai).",
            templateErrorLocation: "Mengesetkan lokasi mesej ralat berhubung dengan soalan dengan input tidak sah. Pilih antara: \"Atas\" - teks ralat diletakkan di bahagian atas kotak soalan; \"Bawah\" - teks ralat diletakkan di bahagian bawah kotak soalan. Pilihan \"Warisan\" menggunakan peringkat halaman (jika ditetapkan) atau tetapan peringkat tinjauan (\"Atas\" secara lalai).",
            errorLocation: "Mengesetkan lokasi mesej ralat berhubung dengan semua soalan dalam panel. Opsyen \"Warisan\" menggunakan aras halaman (jika set) atau seting aras tinjauan.",
            page: "Meletakkan semula panel di hujung halaman yang dipilih.",
            innerIndent: "Menambah ruang atau jidar antara kandungan panel dan sempadan kiri kotak panel.",
            startWithNewLine: "Nyahpilih untuk memaparkan panel dalam satu baris dengan soalan atau panel sebelumnya. Seting tidak digunakan jika panel ialah elemen pertama dalam borang anda.",
            state: "Pilih daripada: \"Diperluaskan\" - panel dipaparkan sepenuhnya dan boleh runtuh; \"Runtuh\" - panel hanya memaparkan tajuk dan keterangan dan boleh diperluaskan; \"Dikunci\" - panel dipaparkan sepenuhnya dan tidak boleh runtuh.",
            width: "Mengesetkan lebar panel mengikut kadar unsur tinjauan lain dalam baris yang sama. Menerima nilai CSS (px, %, dalam, pt, dll.).",
            templateTitle: "Taipkan templat untuk tajuk panel dinamik. Gunakan {panelIndex} untuk kedudukan umum panel dan {visiblePanelIndex} untuk pesanannya di kalangan panel yang kelihatan. Masukkan ruang letak ini ke dalam corak untuk menambah penomboran automatik.",
            templateTabTitle: "Taipkan templat untuk tajuk tab. Gunakan {panelIndex} untuk kedudukan umum panel dan {visiblePanelIndex} untuk pesanannya di kalangan panel yang boleh dilihat. Masukkan ruang letak ini ke dalam corak untuk menambah penomboran automatik.",
            tabTitlePlaceholder: "Teks sandaran untuk tajuk tab yang digunakan apabila corak tajuk tab tidak menghasilkan nilai yang bermakna.",
            templateVisibleIf: "Tetapan ini membolehkan anda mengawal penglihatan panel individu dalam panel dinamik. Gunakan ruang letak '{panel}' untuk merujuk panel semasa dalam ungkapan anda.",
            titleLocation: "Tetapan ini diwarisi secara automatik oleh semua soalan dalam panel ini. Jika anda ingin mengubah seting ini, takrifkan peraturan penjajaran tajuk untuk soalan individu. Pilihan \"Warisan\" menggunakan peringkat halaman (jika ditetapkan) atau tetapan peringkat tinjauan (\"Atas\" secara lalai).",
            descriptionLocation: "Opsyen \"Warisan\" menggunakan aras halaman (jika ditetapkan) atau seting aras tinjauan (\"Di bawah tajuk panel\" secara lalai).",
            newPanelPosition: "Mentakrifkan kedudukan panel yang baru ditambah. Secara lalai, panel baru ditambahkan ke hujungnya. Pilih \"Seterusnya\" untuk memasukkan panel baru selepas yang semasa.",
            defaultValueFromLastPanel: "Pendua jawapan daripada panel terakhir dan memberikannya kepada panel dinamik tambahan seterusnya.",
            keyName: "Rujukan nama soalan untuk memerlukan pengguna memberikan jawapan yang unik untuk soalan ini dalam setiap panel."
        },
        defaultValueExpression: "Seting ini membolehkan anda memperuntukkan nilai jawapan lalai berdasarkan ungkapan. Ungkapan ini boleh termasuk pengiraan asas - '{q1_id} + {q2_id}', ungkapan Boolean, seperti '{age} > 60', dan fungsi: 'iif()', 'hari ini()', 'umur()', 'min()', 'max()', 'avg()', dsb. Nilai yang ditentukan oleh ungkapan ini berfungsi sebagai nilai lalai awal yang boleh diubah oleh input manual responden.",
        resetValueIf: "Gunakan ikon tongkat ajaib untuk mengesetkan peraturan bersyarat yang menentukan masa input responden ditetapkan semula kepada nilai berdasarkan \"Ungkapan nilai lalai\" atau \"Setkan ungkapan nilai\" atau kepada nilai \"Jawapan lalai\" (jika sama ada ditetapkan).",
        setValueIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menentukan masa untuk menjalankan \"Tetapkan ungkapan nilai\" dan secara dinamik memperuntukkan nilai yang terhasil sebagai respons.",
        setValueExpression: "Tentukan ungkapan yang mentakrifkan nilai yang akan disetkan apabila syarat dalam peraturan \"Set nilai jika\" dipenuhi. Ungkapan ini boleh termasuk pengiraan asas - '{q1_id} + {q2_id}', ungkapan Boolean, seperti '{age} > 60', dan fungsi: 'iif()', 'hari ini()', 'umur()', 'min()', 'max()', 'avg()', dsb. Nilai yang ditentukan oleh ungkapan ini boleh diubah oleh input manual responden.",
        question: {
            name: "ID soalan yang tidak dapat dilihat oleh responden.",
            description: "Taipkan sari kata soalan.",
            visibleIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menentukan keterlihatan soalan.",
            enableIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang melumpuhkan mod baca sahaja untuk soalan itu.",
            requiredIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menghalang tinjauan memajukan atau menyerahkan melainkan soalan itu mendapat jawapan.",
            startWithNewLine: "Nyahpilih untuk memaparkan soalan dalam satu baris dengan soalan atau panel sebelumnya. Seting tidak digunakan jika soalan ialah unsur pertama dalam borang anda.",
            page: "Letakkan semula soalan ke hujung halaman yang dipilih.",
            state: "Pilih daripada: \"Diperluaskan\" - kotak soalan dipaparkan sepenuhnya dan boleh runtuh; \"Runtuh\" - kotak soalan hanya memaparkan tajuk dan keterangan dan boleh diperluaskan; \"Dikunci\" - kotak soalan dipaparkan sepenuhnya dan tidak boleh runtuh.",
            titleLocation: "Mengatasi peraturan penjajaran tajuk yang ditakrifkan pada panel, halaman atau tahap tinjauan. Opsyen \"Warisan\" menggunakan sebarang seting aras lebih tinggi (jika ditetapkan) atau seting aras tinjauan (\"Atas\" secara lalai).",
            descriptionLocation: "Opsyen \"Warisan\" menggunakan seting aras tinjauan (\"Di bawah tajuk soalan\" secara lalai).",
            errorLocation: "Mengesetkan lokasi mesej ralat berhubung dengan soalan dengan input tidak sah. Pilih antara: \"Atas\" - teks ralat diletakkan di bahagian atas kotak soalan; \"Bawah\" - teks ralat diletakkan di bahagian bawah kotak soalan. Pilihan \"Warisan\" menggunakan tetapan peringkat tinjauan (\"Atas\" secara lalai).",
            indent: "Menambah ruang atau jidar antara kandungan soalan dan sempadan kiri kotak soalan.",
            width: "Menetapkan lebar soalan mengikut kadar unsur tinjauan lain dalam baris yang sama. Menerima nilai CSS (px, %, dalam, pt, dll.).",
            surveyvalidator: {
                expression: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan pengesahan untuk soalan itu."
            },
            textUpdateMode: "Pilih daripada: \"Pada fokus yang hilang\" - nilai dikemas kini apabila medan input kehilangan fokus; \"Semasa menaip\" - nilai dikemas kini dalam masa nyata, semasa pengguna menaip. Pilihan \"Warisan\" menggunakan seting peringkat tinjauan (\"Pada fokus yang hilang\" secara lalai).",
            url: "Anda boleh menggunakan mana-mana perkhidmatan web sebagai sumber data untuk soalan pelbagai pilihan. Untuk mengisi nilai pilihan, masukkan URL perkhidmatan yang menyediakan data.",
            searchMode: "Operasi perbandingan yang digunakan untuk menapis senarai juntai bawah.",
            textWrapEnabled: "Teks panjang dalam pilihan pilihan akan menjana pemisah baris secara automatik agar muat dalam menu lungsur. Nyahpilih jika anda mahu teks klip."
        },
        signaturepad: {
            signatureWidth: "Mengesetkan lebar kawasan tandatangan yang dipaparkan dan imej yang terhasil.",
            signatureHeight: "Mengesetkan ketinggian kawasan tandatangan yang dipaparkan dan imej yang terhasil.",
            signatureAutoScaleEnabled: "Pilih jika anda inginkan kawasan tandatangan mengisi semua ruang yang tersedia dalam kotak soalan sambil mengekalkan nisbah aspek 3:2 lalai. Apabila nilai lebar dan ketinggian tersuai ditetapkan, seting akan mengekalkan nisbah aspek dimensi ini."
        },
        file: {
            imageHeight: "Melaraskan ketinggian imej dalam hasil tinjauan.",
            imageWidth: "Melaraskan lebar imej dalam hasil tinjauan."
        },
        image: {
            contentMode: "Pilihan \"Auto\" secara automatik menentukan mod yang sesuai untuk paparan - Imej, Video atau YouTube - berdasarkan URL sumber yang disediakan."
        },
        imagepicker: {
            imageHeight: "Mengatasi nilai ketinggian minimum dan maksimum.",
            imageWidth: "Mengatasi nilai lebar minimum dan maksimum.",
            choices: "\"Nilai\" berfungsi sebagai ID item yang digunakan dalam peraturan bersyarat; \"Teks\" dipaparkan kepada responden.",
            contentMode: "Pilih antara \"Imej\" dan \"Video\" untuk menetapkan mod kandungan pemilih media. Jika \"Imej\" dipilih, pastikan semua pilihan yang disediakan adalah fail imej dalam format berikut: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Begitu juga, jika \"Video\" dipilih, pastikan semua pilihan adalah pautan langsung ke fail video dalam format berikut: MP4, MOV, WMV, FLV, AVI, MKV. Sila ambil perhatian bahawa pautan YouTube tidak disokong untuk pilihan video."
        },
        text: {
            size: "Seting ini hanya mengubah saiz medan input dan tidak mempengaruhi lebar kotak soalan. Untuk mengehadkan panjang input yang diterima, pergi ke <b>Pengesahihan → Had aksara maksimum</b>."
        },
        comment: {
            rows: "Mengesetkan bilangan baris yang dipaparkan dalam medan input. Jika input mengambil lebih banyak baris, bar skrol akan muncul."
        },
        // survey templates
        survey: {
            mode: "Pilih antara: \"Boleh diedit\" - membolehkan responden mengisi tinjauan anda; \"Baca sahaja\" - melumpuhkan penyuntingan borang."
        },
        matrixdropdowncolumn: {
            name: "ID lajur yang tidak kelihatan kepada responden.",
            isUnique: "Apabila didayakan untuk lajur, responden dikehendaki memberikan respons unik untuk setiap soalan dalam lajur ini.",
            rows: "Mengesetkan bilangan baris yang dipaparkan dalam medan input. Jika input mengambil lebih banyak baris, bar skrol akan muncul.",
            visibleIf: "Gunakan ikon tongkat ajaib untuk mengesetkan peraturan bersyarat yang menentukan keterlihatan lajur.",
            enableIf: "Gunakan ikon tongkat ajaib untuk mengesetkan peraturan bersyarat yang menyahdayakan mod baca sahaja untuk lajur.",
            requiredIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menghalang penyerahan tinjauan melainkan sekurang-kurangnya satu soalan tersarang mempunyai jawapan.",
            showInMultipleColumns: "Apabila dipilih, cipta lajur individu untuk setiap opsyen pilihan."
        },
        widthMode: "Pilih daripada: \"Statik\" - menetapkan lebar tetap; \"Responsif\" - membuat tinjauan menduduki lebar penuh skrin; \"Auto\" - terpakai salah satu daripada kedua-duanya bergantung kepada jenis soalan yang digunakan.",
        cookieName: "Kuki menghalang pengguna daripada mengisi tinjauan yang sama dua kali.",
        logo: "Tampal pautan imej (tiada had saiz) atau klik ikon folder untuk menyemak lalu fail daripada komputer anda (sehingga 64KB).",
        logoWidth: "Menetapkan lebar logo dalam unit CSS (px, %, in, pt, dll.).",
        logoHeight: "Menetapkan ketinggian logo dalam unit CSS (px, %, in, pt, dll.).",
        logoFit: "Pilih daripada: \"Tiada\" - imej mengekalkan saiz asalnya; \"Mengandungi\" - imej diubah saiznya agar sesuai sambil mengekalkan nisbah aspeknya; \"Cover\" - imej mengisi keseluruhan kotak sambil mengekalkan nisbah aspeknya; \"Isian\" - imej diregangkan untuk mengisi kotak tanpa mengekalkan nisbah aspeknya.",
        goNextPageAutomatic: "Pilih jika anda ingin tinjauan diteruskan ke halaman berikut secara automatik selepas responden menjawab semua soalan pada halaman semasa.",
        allowCompleteSurveyAutomatic: "Pilih jika anda mahu tinjauan selesai secara automatik selepas responden menjawab semua soalan.",
        showNavigationButtons: "Mengesetkan kebolehlihatan dan lokasi butang navigasi pada halaman.",
        showProgressBar: "Menetapkan kebolehlihatan dan lokasi bar kemajuan. Nilai \"Auto\" memaparkan bar kemajuan di atas atau di bawah pengepala tinjauan.",
        showPreviewBeforeComplete: "Dayakan halaman pratonton dengan semua atau menjawab soalan sahaja.",
        questionTitleLocation: "Digunakan untuk semua soalan dalam tinjauan. Tetapan ini boleh diubah oleh peraturan penjajaran tajuk pada tahap yang lebih rendah: panel, halaman atau soalan. Tetapan peringkat rendah akan mengatasi mereka yang berada pada tahap yang lebih tinggi.",
        requiredText: "Simbol atau urutan simbol yang menunjukkan bahawa jawapan diperlukan.",
        questionStartIndex: "Masukkan nombor atau huruf yang anda ingin mulakan penomboran.",
        questionErrorLocation: "Mengesetkan lokasi mesej ralat berhubung dengan soalan dengan input tidak sah. Pilih antara: \"Atas\" - teks ralat diletakkan di bahagian atas kotak soalan; \"Bawah\" - teks ralat diletakkan di bahagian bawah kotak soalan.",
        focusFirstQuestionAutomatic: "Pilih jika anda inginkan medan input pertama pada setiap halaman sedia untuk entri teks.",
        questionsOrder: "Mengekalkan susunan soalan asal atau rawak mereka. Kesan seting ini hanya kelihatan dalam tab Pratonton.",
        maxTextLength: "Untuk soalan entri teks sahaja.",
        maxOthersLength: "Untuk komen soalan sahaja.",
        commentAreaRows: "Mengesetkan bilangan baris yang dipaparkan dalam kawasan teks untuk komen soalan. Dalam input mengambil lebih banyak baris, bar skrol muncul.",
        autoGrowComment: "Pilih jika anda inginkan komen soalan dan soalan Teks Panjang untuk mengembangkan ketinggian automatik berdasarkan panjang teks yang dimasukkan.",
        allowResizeComment: "Untuk komen soalan dan soalan Teks Panjang sahaja.",
        calculatedValues: "Pemboleh ubah tersuai berfungsi sebagai pemboleh ubah perantaraan atau tambahan yang digunakan dalam pengiraan borang. Mereka mengambil input responden sebagai nilai sumber. Setiap pemboleh ubah tersuai mempunyai nama unik dan ungkapan yang berdasarkannya.",
        includeIntoResult: "Pilih jika anda ingin nilai terhitung ungkapan disimpan bersama-sama dengan hasil tinjauan.",
        triggers: "Pencetus ialah peristiwa atau keadaan yang berdasarkan ungkapan. Sebaik sahaja ungkapan dinilai kepada \"benar\", pencetus akan mematikan tindakan. Tindakan sedemikian secara pilihan boleh mempunyai soalan sasaran yang mempengaruhinya.",
        clearInvisibleValues: "Pilih sama ada atau tidak untuk mengosongkan nilai untuk soalan yang tersembunyi oleh logik bersyarat dan bila untuk melakukannya.",
        textUpdateMode: "Pilih daripada: \"Pada fokus yang hilang\" - nilai dikemas kini apabila medan input kehilangan fokus; \"Semasa menaip\" - nilai dikemas kini dalam masa nyata, semasa pengguna menaip.",
        columns: "Nilai kiri berfungsi sebagai ID lajur yang digunakan dalam peraturan bersyarat, nilai kanan dipaparkan kepada responden.",
        rows: "Nilai kiri berfungsi sebagai ID baris yang digunakan dalam peraturan bersyarat, nilai kanan dipaparkan kepada responden.",
        columnMinWidth: "Menerima nilai CSS (px, %, dalam, pt, dll.).",
        rowTitleWidth: "Menerima nilai CSS (px, %, dalam, pt, dll.).",
        totalText: "Boleh dilihat hanya apabila sekurang-kurangnya satu lajur mempunyai jenis Jumlah atau ungkapan Jumlah.",
        cellErrorLocation: "Mengesetkan lokasi mesej ralat berhubung dengan sel dengan input tidak sah. Opsyen \"Warisan\" menggunakan seting daripada sifat \"Penjajaran mesej ralat\".",
        keyDuplicationError: "Apabila sifat \"Mencegah respons pendua\" didayakan, responden yang cuba menyerahkan entri pendua akan menerima mesej ralat berikut.",
        totalExpression: "Membolehkan anda mengira jumlah nilai berdasarkan ungkapan. Ungkapan ini boleh termasuk pengiraan asas ('{q1_id} + {q2_id}'), Ungkapan Boolean ('{age} > 60') dan fungsi ('iif()', 'hari ini()', 'umur()', 'min()', 'max()', 'avg()', dll.).",
        confirmDelete: "Mencetuskan gesaan yang meminta untuk mengesahkan pemadaman baris.",
        defaultValueFromLastRow: "Pendua jawapan dari baris terakhir dan menguntukkannya ke baris dinamik tambahan seterusnya.",
        keyName: "Jika lajur yang ditentukan mengandungi nilai yang sama, tinjauan akan membuang ralat \"Nilai kunci bukan unik\".",
        description: "Taipkan sari kata.",
        locale: "Pilih bahasa untuk mula mencipta tinjauan anda. Untuk menambah terjemahan, tukar kepada bahasa baru dan terjemahkan teks asal di sini atau dalam tab Terjemahan.",
        detailPanelMode: "Mengesetkan lokasi seksyen butiran berhubung dengan baris. Pilih daripada: \"Tiada\" - tiada pengembangan ditambah; \"Di bawah baris\" - pengembangan baris diletakkan di bawah setiap baris matriks; \"Di bawah baris, paparkan pengembangan satu baris sahaja\" - pengembangan dipaparkan di bawah satu baris sahaja, pengembangan baris yang tinggal runtuh.",
        imageFit: "Pilih daripada: \"Tiada\" - imej mengekalkan saiz asalnya; \"Mengandungi\" - imej diubah saiznya agar sesuai sambil mengekalkan nisbah aspeknya; \"Cover\" - imej mengisi keseluruhan kotak sambil mengekalkan nisbah aspeknya; \"Isian\" - imej diregangkan untuk mengisi kotak tanpa mengekalkan nisbah aspeknya.",
        autoGrow: "Secara beransur-ansur meningkatkan ketinggian medan input apabila data dimasukkan. Membatalkan seting \"Ketinggian medan input (dalam garisan)\".",
        allowResize: "Pemegang saiz semula (atau cengkaman) muncul di sudut dan boleh diseret untuk mengubah saiz medan input.",
        maxTimeToFinish: "Selang masa dalam beberapa saat selepas itu tinjauan secara automatik maju ke halaman Terima Kasih.",
        maxTimeToFinishPage: "Selang masa dalam beberapa saat selepas itu tinjauan secara automatik maju ke halaman seterusnya.",
        page: {
            maxTimeToFinish: "Selang masa dalam beberapa saat selepas itu tinjauan secara automatik maju ke halaman seterusnya.",
            visibleIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menentukan keterlihatan halaman.",
            enableIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menyahdayakan mod baca sahaja untuk halaman.",
            requiredIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menghalang penyerahan tinjauan melainkan sekurang-kurangnya satu soalan tersarang mempunyai jawapan.",
            questionTitleLocation: "Digunakan untuk semua soalan dalam halaman ini. Jika anda ingin mengubah seting ini, takrifkan peraturan penjajaran tajuk untuk soalan atau panel individu. Pilihan \"Warisan\" menggunakan tetapan peringkat tinjauan (\"Atas\" secara lalai).",
            questionTitleWidth: "Menetapkan lebar yang konsisten untuk tajuk soalan apabila ia dijajarkan di sebelah kiri kotak soalan mereka. Menerima nilai CSS (px, %, dalam, pt, dll.).",
            questionErrorLocation: "Mengesetkan lokasi mesej ralat berhubung dengan soalan dengan input tidak sah. Pilih antara: \"Atas\" - teks ralat diletakkan di bahagian atas kotak soalan; \"Bawah\" - teks ralat diletakkan di bahagian bawah kotak soalan. Pilihan \"Warisan\" menggunakan tetapan peringkat tinjauan (\"Atas\" secara lalai).",
            questionsOrder: "Mengekalkan susunan soalan asal atau rawak mereka. Pilihan \"Warisan\" menggunakan seting peringkat tinjauan (\"Asal\" secara lalai). Kesan seting ini hanya kelihatan dalam tab Pratonton.",
            navigationButtonsVisibility: "Mengesetkan keterlihatan butang navigasi pada halaman. Opsyen \"Warisan\" menggunakan seting aras tinjauan, yang lalai kepada \"Boleh Dilihat\"."
        },
        showTimerPanel: "Mengesetkan kebolehlihatan dan lokasi pemasa pada halaman.",
        panelsState: "Pilih daripada: \"Dikunci\" - pengguna tidak boleh mengembangkan atau meruntuhkan panel; \"Runtuhkan semua\" - semua panel bermula dalam keadaan runtuh; \"Kembangkan semua\" - semua panel bermula dalam keadaan yang diperluaskan; \"Pertama diperluaskan\" - hanya panel pertama yang pada mulanya diperluaskan.",
        imageLinkName: "Masukkan nama sifat dikongsi dalam tatasusunan objek yang mengandungi URL fail imej atau video yang anda ingin paparkan dalam senarai pilihan.",
        choices: "Nilai kiri berfungsi sebagai ID item yang digunakan dalam peraturan bersyarat, nilai yang betul dipaparkan kepada responden.",
        title: "Taipkan tajuk mesra pengguna untuk dipaparkan.",
        waitForUpload: "Memastikan pengguna tidak akan melengkapkan tinjauan sehingga fail dimuat naik.",
        minWidth: "Menerima nilai CSS (px, %, dalam, pt, dll.).",
        maxWidth: "Menerima nilai CSS (px, %, dalam, pt, dll.).",
        width: "Menerima nilai CSS (px, %, dalam, pt, dll.).",
        valueName: "Jika anda tidak menetapkan sifat ini, jawapannya akan disimpan dalam medan yang ditentukan oleh sifat Nama.",
        useDisplayValuesInDynamicTexts: "Dalam jenis soalan pilihan tunggal dan berbilang pilihan, setiap pilihan pilihan mempunyai ID dan nilai paparan. Apabila dipilih, seting ini menunjukkan nilai paparan dan bukannya nilai ID dalam soalan HTML dan tajuk dinamik serta perihalan unsur tinjauan.",
        clearIfInvisible: "Pilih sama ada untuk mengosongkan nilai soalan yang tersembunyi oleh logik bersyarat dan bila untuk melakukannya. Pilihan \"Warisan\" menggunakan tetapan peringkat tinjauan (\"Setelah selesai tinjauan\" secara lalai).",
        choicesFromQuestionMode: "Pilih daripada: \"Semua\" - menyalin semua pilihan pilihan daripada soalan yang dipilih; \"Dipilih\" - secara dinamik hanya menyalin pilihan pilihan yang dipilih; \"Tidak dipilih\" - secara dinamik menyalin hanya pilihan pilihan yang tidak dipilih. Pilihan \"Tiada\" dan \"Lain-lain\" disalin secara lalai jika didayakan dalam soalan sumber.",
        showOtherItem: "Apabila dipilih, pengguna boleh memasukkan input tambahan dalam kotak komen berasingan.",
        separateSpecialChoices: "Memaparkan setiap pilihan pilihan khas (\"Tiada\", \"Lain\", \"Pilih Semua\") pada baris baru, walaupun menggunakan tataletak berbilang lajur.",
        path: "Tentukan lokasi dalam set data perkhidmatan yang lokasi tatasusunan sasaran objek. Biarkan kosong jika URL telah menuding ke tatasusunan.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Masukkan nama sifat seragam dalam tatasusunan objek yang mengandungi nilai yang anda ingin paparkan dalam senarai pilihan.",
        allowEmptyResponse: "Pilih untuk membenarkan perkhidmatan mengembalikan respons atau tatasusunan kosong.",
        choicesVisibleIf: "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menentukan keterlihatan semua pilihan pilihan.",
        rateValues: "Nilai kiri berfungsi sebagai ID item yang digunakan dalam peraturan bersyarat, nilai yang betul dipaparkan kepada responden.",
        rating: {
            displayMode: "\"Auto\" memilih antara mod \"Butang\" dan \"Dropdown\" berdasarkan lebar yang tersedia. Apabila lebar tidak mencukupi untuk memaparkan butang, soalan memaparkan menu lungsur."
        },
        valuePropertyName: "Membolehkan anda menyambungkan soalan yang menghasilkan hasil dalam format yang berbeza. Apabila soalan tersebut dipautkan bersama menggunakan pengecam cantuman, sifat kongsi ini menyimpan nilai soalan terpilih.",
        searchEnabled: "Pilih jika anda ingin mengemas kini kandungan menu juntai bawah agar sepadan dengan pertanyaan carian yang pengguna menaip dalam medan input.",
        valueTrue: "Nilai untuk menyimpan hasil tinjauan apabila responden memberikan jawapan yang positif.",
        valueFalse: "Nilai untuk menyimpan hasil tinjauan apabila responden memberikan jawapan negatif.",
        showPreview: "Ia tidak disyorkan untuk menyahdayakan pilihan ini kerana ia mengubah imej Pratonton dan menyukarkan pengguna untuk memahami sama ada fail telah dimuat naik.",
        needConfirmRemoveFile: "Mencetuskan gesaan yang meminta untuk mengesahkan penghapusan fail.",
        selectToRankEnabled: "Membolehkan untuk menilai pilihan yang dipilih sahaja. Pengguna akan menyeret item terpilih dari senarai pilihan untuk memesannya dalam kawasan kedudukan.",
        dataList: "Masukkan senarai pilihan yang akan dicadangkan kepada responden semasa input.",
        itemSize: "Seting hanya mengubah saiz medan input dan tidak mempengaruhi lebar kotak soalan.",
        itemTitleWidth: "Mengesetkan lebar yang konsisten untuk semua label item dalam piksel",
        altText: "Berfungsi sebagai pengganti apabila imej tidak boleh dipaparkan pada peranti pengguna dan untuk tujuan kebolehcapaian.",
        rateColorMode: "Mentakrifkan warna emoji yang dipilih apabila jenis ikon Penarafan ditetapkan kepada \"Smileys\". Pilih antara: \"Lalai\" - emoji yang dipilih muncul dalam warna tinjauan lalai; \"Skala\" - emoji yang dipilih mewarisi warna dari skala penarafan.",
        expression: {
            name: "ID ungkapan yang tidak kelihatan kepada responden.",
            description: "Taipkan sari kata ungkapan.",
            expression: "Ungkapan boleh termasuk pengiraan asas ('{q1_id} + {q2_id}'), syarat ('{age} > 60'), dan fungsi ('iif()', 'hari ini()', 'umur()', 'min()', 'max()', 'pur()', dll.)."
        },
        storeOthersAsComment: "Pilih untuk menyimpan nilai pilihan \"Lain-lain\" sebagai harta berasingan dalam hasil tinjauan.",
        format: "Gunakan {0} sebagai ruang letak untuk nilai sebenar.",
        acceptedTypes: "Rujuk perihalan atribut [terima](https://www.w3schools.com/tags/att_input_accept.asp) untuk maklumat lanjut.",
        columnColCount: "Hanya digunakan untuk jenis sel Kumpulan Radio dan Kotak Semak.",
        autocomplete: "Rujuk perihalan atribut [autolengkap](https://developer.mozilla.org/en-US/docs/Web/HTML/Atribut/autolengkap) untuk maklumat lanjut.",
        filePlaceholder: "Digunakan apabila \"Jenis sumber\" ialah \"Fail tempatan\" atau apabila kamera tidak tersedia",
        photoPlaceholder: "Digunakan apabila \"Jenis sumber\" ialah \"Kamera\".",
        fileOrPhotoPlaceholder: "Digunakan apabila \"Jenis sumber\" ialah \"Fail atau kamera tempatan\".",
        masksettings: {
            saveMaskedValue: "Pilih jika anda ingin menyimpan nilai soalan dengan topeng yang digunakan dalam hasil tinjauan."
        },
        patternmask: {
            pattern: "Corak boleh mengandungi literal rentetan dan ruang letak berikut: '9' - untuk digit; 'a' - untuk huruf besar atau kecil; '#' - untuk digit atau huruf besar atau huruf kecil. Gunakan tindak balas '\\' untuk melarikan diri daripada watak."
        },
        datetimemask: {
            pattern: "Corak boleh mengandungi aksara pemisah dan ruang letak berikut:<br>'m' - Nombor bulan.<br>'mm' - Nombor bulan, dengan sifar awalan untuk nilai satu digit. <br>'d' - Hari dalam bulan. <br>'dd' - Hari dalam bulan, dengan sifar utama untuk nilai satu digit. <br>'yy' - Dua digit terakhir tahun ini. <br>'yyyy' - Tahun empat angka. <br>'H' - Jam dalam format 24 jam. <br>'HH' - Jam dalam format 24 jam, dengan sifar utama untuk nilai satu digit. <br>'h' - Jam dalam format 12 jam. <br>'hh' - Jam dalam format 12 jam, dengan sifar utama untuk nilai satu digit. <br>'MM' - Minit. <br>'ss' - Saat. <br>'TT' - Tempoh jam 12 jam dalam kes atas (AM / PM). <br>'TT' - Tempoh jam 12 jam dalam kes yang lebih rendah (AM / PM)."
        },
        numericmask: {
            decimalSeparator: "Simbol yang digunakan untuk memisahkan bahagian pecahan daripada bahagian integer bagi nombor yang dipaparkan.",
            thousandsSeparator: "Simbol yang digunakan untuk memisahkan digit nombor besar ke dalam kumpulan tiga.",
            precision: "Hadkan bilangan digit untuk dikekalkan selepas titik perpuluhan bagi nombor yang dipaparkan."
        },
        currencymask: {
            prefix: "Satu atau beberapa simbol yang akan dipaparkan sebelum nilai.",
            suffix: "Satu atau beberapa simbol yang akan dipaparkan selepas nilai."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "tajuk",
            title: "Biarkan kosong, jika sama seperti 'Nama'"
        },
        multiSelect: "Pilih berbilang",
        showLabel: "Tunjukkan label",
        swapOrder: "Tukar pesanan Ya dan Tidak",
        value: "Nilai",
        tabAlign: "Penjajaran tab",
        sourceType: "Jenis sumber",
        fitToContainer: "Muat ke bekas",
        setValueExpression: "Mengesetkan ungkapan nilai",
        description: "perihalan",
        logoFit: "Muat logo",
        pages: "halaman",
        questions: "Soalan",
        triggers: "pencetus",
        calculatedValues: "Nilai dikira",
        surveyId: "Id tinjauan",
        surveyPostId: "Id siaran tinjauan",
        surveyShowDataSaving: "Tinjauan menunjukkan penjimatan data",
        questionDescriptionLocation: "Lokasi perihalan soalan",
        progressBarType: "Jenis bar perkembangan",
        showTOC: "Tunjukkan TOC",
        tocLocation: "Lokasi Toc",
        questionTitlePattern: "Corak tajuk soalan",
        widthMode: "Mod lebar",
        showBrandInfo: "Tunjukkan maklumat jenama",
        useDisplayValuesInDynamicTexts: "Guna nilai paparan dalam tajuk",
        visibleIf: "Boleh dilihat jika",
        defaultValueExpression: "Ekspresi nilai lalai",
        requiredIf: "Diperlukan jika",
        resetValueIf: "Mengeset semula nilai jika",
        setValueIf: "Setkan nilai jika",
        validators: "Pengesah",
        bindings: "ikatan",
        renderAs: "Render sebagai",
        attachOriginalItems: "Lampirkan item asal",
        choices: "pilihan",
        choicesByUrl: "Pilihan melalui URL",
        currency: "mata wang",
        cellHint: "Petunjuk sel",
        totalMaximumFractionDigits: "Jumlah digit pecahan maksimum",
        totalMinimumFractionDigits: "Jumlah digit pecahan minimum",
        columns: "lajur",
        detailElements: "Unsur terperinci",
        allowAdaptiveActions: "Benarkan tindakan penyesuaian",
        defaultRowValue: "Nilai baris lalai",
        detailPanelShowOnAdding: "Butiran panel tunjukkan pada penambahan",
        choicesLazyLoadEnabled: "Pilihan beban malas didayakan",
        choicesLazyLoadPageSize: "Pilihan malas memuatkan saiz halaman",
        inputFieldComponent: "Komponen medan input",
        itemComponent: "Komponen item",
        min: "min",
        max: "maks",
        minValueExpression: "Ekspresi nilai min",
        maxValueExpression: "Ekspresi nilai maks",
        step: "langkah",
        dataList: "Senarai data",
        itemSize: "Saiz item",
        itemTitleWidth: "Lebar label item (dalam piksel)",
        elements: "Unsur",
        content: "Kandungan",
        navigationButtonsVisibility: "Kebolehlihatan butang navigasi",
        navigationTitle: "Tajuk navigasi",
        navigationDescription: "Perihalan navigasi",
        longTap: "Ketuk panjang",
        autoGrow: "Auto besarkan",
        allowResize: "Benarkan pensaizan semula",
        acceptCarriageReturn: "Terima pulangan pengangkutan",
        displayMode: "Mod paparan",
        rateType: "Jenis kadar",
        label: "label",
        contentMode: "Mod kandungan",
        imageFit: "Muat imej",
        altText: "Teks alt",
        height: "tinggi",
        penColor: "Warna pen",
        backgroundColor: "Warna latar belakang",
        templateElements: "Unsur templat",
        operator: "Pengendali",
        isVariable: "Adakah pembolehubah",
        runExpression: "Jalankan ungkapan",
        showCaption: "Tunjukkan kapsyen",
        iconName: "Nama ikon",
        iconSize: "Saiz ikon",
        precision: "Ketepatan",
        matrixDragHandleArea: "Kawasan pemegang seretan matriks",
        backgroundImage: "Imej latar belakang",
        backgroundImageFit: "Kesesuaian imej latar belakang",
        backgroundImageAttachment: "Lampiran imej latar belakang",
        backgroundOpacity: "Kelegapan latar belakang",
        selectToRankEnabled: "Pilih untuk mendayakan kedudukan",
        selectToRankAreasLayout: "Pilih untuk menentukan tataletak kawasan",
        selectToRankEmptyRankedAreaText: "Teks untuk ditunjukkan jika semua opsyen dipilih",
        selectToRankEmptyUnrankedAreaText: "Teks ruang letak untuk kawasan penarafan",
        allowCameraAccess: "Benarkan capaian kamera",
        scaleColorMode: "Mod warna skala",
        rateColorMode: "Mod warna kadar",
        copyDisplayValue: "Nilai paparan salin",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Mod lanjutan",
        pageTitle: "Fon tajuk halaman",
        questionTitle: "Fon tajuk soalan",
        editorPanel: "Unsur input",
        lines: "Garisan",
        primaryDefaultColor: "Lalai",
        primaryDarkColor: "Hover",
        primaryLightColor: "Dipilih",
        backgroundDimColor: "Warna latar belakang",
        cornerRadius: "Jejari penjuru",
        backcolor: "Latar belakang lalai",
        hovercolor: "Latarbelakang penuding",
        borderDecoration: "Hiasan sempadan",
        fontColor: "Warna fon",
        backgroundColor: "Warna latar belakang",
        primaryForecolor: "Warna lalai",
        primaryForecolorLight: "Warna dinyahdayakan",
        font: "Fon",
        borderDefault: "Gelap",
        borderLight: "Lebih ringan",
        fontFamily: "Keluarga fon",
        fontWeightRegular: "Tetap",
        fontWeightHeavy: "Berat",
        fontWeightSemiBold: "Separa berani",
        fontWeightBold: "Berani",
        color: "Warna",
        placeholderColor: "Warna ruang letak",
        size: "Saiz",
        opacity: "Kelegapan",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Menambah Kesan Bayang",
        boxShadowBlur: "Kabur",
        boxShadowSpread: "Penyebaran",
        boxShadowDrop: "Singgah",
        boxShadowInner: "Dalaman",
        names: {
            default: "Lalai",
            sharp: "Tajam",
            borderless: "Tanpa sempadan",
            flat: "Rata",
            plain: "Biasa",
            doubleborder: "Sempadan Berkembar",
            layered: "Berlapis",
            solid: "Pepejal",
            threedimensional: ".3D",
            contrast: "Sebaliknya"
        },
        colors: {
            teal: "Teal",
            blue: "Blue",
            purple: "Ungu",
            orchid: "Orchid",
            tulip: "Tulip",
            brown: "Brown",
            green: "Hijau"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["ms"] = msStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// qt.tagbox: "Multi-Select Dropdown" => "Juntai Bawah Berbilang Pilihan"
// qt.buttongroup: "Button Group" => "Kumpulan Butang"
// ed.surveySettings: "Survey Settings" => "Seting Tinjauan"
// ed.surveySettingsTooltip: "Open survey settings" => "Buka seting tinjauan"
// ed.prevSelected: "Select previous" => "Pilih sebelumnya"
// ed.nextSelected: "Select next" => "Pilih seterusnya"
// ed.surveyTypeName: "Survey" => "Kaji selidik"
// ed.pageTypeName: "Page" => "Laman"
// ed.panelTypeName: "Panel" => "Panel"
// ed.questionTypeName: "Question" => "Soalan"
// ed.columnTypeName: "Column" => "Lajur"
// ed.themeSurvey: "Themes" => "Tema"
// ed.defaultV2Theme: "Default" => "Lalai"
// ed.modernTheme: "Modern" => "Moden"
// ed.defaultTheme: "Default (legacy)" => "Lalai (warisan)"
// ed.jsonHideErrors: "Hide errors" => "Sembunyikan ralat"
// ed.jsonShowErrors: "Show errors" => "Tunjukkan ralat"
// ed.showMoreChoices: "Show more" => "Tunjuk lebih banyak"
// ed.showLessChoices: "Show less" => "Tunjukkan kurang"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "Taip untuk mencari..."
// ed.toolboxChoiceCategory: "Choice Questions" => "Soalan Pilihan"
// ed.toolboxTextCategory: "Text Input Questions" => "Soalan Input Teks"
// ed.toolboxContainersCategory: "Containers" => "Bekas"
// ed.toolboxMatrixCategory: "Matrix Questions" => "Soalan Matriks"
// ed.toolboxMiscCategory: "Misc" => "Misc"
// ed.translationPropertyGridTitle: "Language Settings" => "Seting Bahasa"
// ed.themePropertyGridTitle: "Theme Settings" => "Seting Tema"
// ed.translationLanguages: "Languages" => "Bahasa-bahasa"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "Rentetan yang Digunakan Sahaja"
// ed.translationPlaceHolder: "Translation..." => "Penterjemahan..."
// ed.themeExportButton: "Export" => "Eksport"
// ed.themeImportButton: "Import" => "Import"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Pilihan disalin daripada"
// ed.htmlPlaceHolder: "HTML content will be here." => "Kandungan HTML akan berada di sini."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "Lepaskan soalan dari kotak alat di sini."
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "Tinjauan itu kosong. Seret elemen dari kotak alat atau klik butang di bawah."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Seret dan lepaskan imej di sini atau klik butang di bawah dan pilih imej untuk dimuat naik"
// ed.imageChooseImage: "Choose Image" => "Pilih Imej"
// ed.addNewTypeQuestion: "Add {0}" => "Tambah {0}"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[LOGO]"
// ed.auto: "auto" => "Auto"
// ed.choices_Item: "Item " => "Perkara "
// lg.addNewItem: "Add New Rule" => "Tambah peraturan baru"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "Cipta peraturan untuk menyesuaikan aliran tinjauan."
// lg.page_enableName: "Enable (disable) page" => "Halaman Dayakan (nyahdayakan)"
// lg.column_visibilityName: "Show (hide) column" => "Tunjukkan lajur (sembunyikan)"
// lg.column_enableName: "Enable (disable) column" => "Mendayakan (nyahdayakan) lajur"
// lg.column_requireName: "Make column required" => "Jadikan lajur diperlukan"
// lg.itemEmptyExpressionText: "New rule" => "Peraturan baru"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "menjadikan {0} lajur soalan {1} kelihatan"
// lg.column_enableText: "make column {0} of question {1} enable" => "menjadikan lajur {0} soalan {1} mendayakan"
// lg.column_requireText: "make column {0} of question {1} required" => "menjadikan lajur {0} soalan {1} diperlukan"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "nilai soalan yang jelas: {0}"
// lg.showAllQuestions: "All Questions" => "Semua Soalan"
// lg.showAllActionTypes: "All Action Types" => "Semua Jenis Tindakan"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Peraturan logik tidak lengkap"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Anda belum menyelesaikan beberapa peraturan logik. Jika anda meninggalkan tab sekarang, perubahan akan hilang. Adakah anda masih mahu meninggalkan tab tanpa melengkapkan perubahan?"
// lg.uncompletedRule_apply: "Yes" => "Ya"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Tidak, saya mahu melengkapkan peraturan"
// pe.clear: "Clear" => "Jelas"
// pe.set: "Set" => "Set"
// pe.change: "Change" => "Menukar"
// pe.close: "Close" => "Tutup"
// pe.removeItem: "Click to remove the item..." => "Klik untuk mengalih keluar item..."
// pe.dragItem: "Drag the item" => "Seret item"
// pe.doneEditing: "Done" => "Dilakukan"
// pe.emptyValue: "Value is empty" => "Nilai kosong"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "Nilai '{0}' tidak unik"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "Sila hadkan bilangan item dari {0} hingga {1}"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "Anda boleh mengesetkan data dalam format berikut:\nvalue1|text\nnilai2"
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "Pratonton jawapan sebelum menyerahkan tinjauan"
// pe.overridingPropertyPrefix: "Set by " => "Ditetapkan mengikut "
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Jangan gunakan perkataan terpelihara: \"item\", \"pilihan\", \"panel\", \"baris\"."
// pe.listIsEmpty@choices: "No choices have been added yet" => "Tiada pilihan telah ditambah lagi"
// pe.addNew@choices: "Add a choice" => "Tambah pilihan"
// choicesbyurl.valueName: "Get values from the following JSON field" => "Mendapatkan nilai daripada medan JSON berikut"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "Dapatkan URL imej daripada medan JSON berikut"
// pe.and: "and" => "Dan"
// pe.or: "or" => "Atau"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Pilih soalan untuk mula mengkonfigurasi syarat."
// pe.if: "If" => "Jika"
// pe.then: "then" => "Kemudian"
// pe.setToName: "Target question" => "Soalan sasaran"
// pe.fromName: "Question to copy answer from" => "Soalan untuk menyalin jawapan daripada"
// pe.gotoName: "Question to skip to" => "Soalan untuk melangkau ke"
// pe.ruleIsNotSet: "Rule is incorrect" => "Peraturan tidak betul"
// pe.includeIntoResult: "Include into survey results" => "Dimasukkan ke dalam hasil tinjauan"
// pe.portraitOrientation: "Switch to portrait orientation" => "Bertukar kepada orientasi potret"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Ketinggian imej (dalam nilai diterima CSS)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Lebar imej (dalam nilai diterima CSS)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "Had masa untuk menyelesaikan halaman (dalam beberapa saat)"
// question.page: "Parent page" => "Halaman induk"
// pe.noEntriesText: "Empty entries text" => "Kosongkan teks entri"
// pe.setValue: "Answer" => "Jawapan"
// pe.dataFormat: "Image format" => "Format imej"
// pe.allowAddRows: "Allow adding rows" => "Benarkan menambah baris"
// pe.allowRemoveRows: "Allow removing rows" => "Benarkan mengalih keluar baris"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "Benarkan seret dan lepas baris"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "Tidak terpakai jika anda menentukan lebar atau ketinggian imej yang tepat."
// pe.minImageWidth: "Minimum image width" => "Lebar imej minimum"
// pe.maxImageWidth: "Maximum image width" => "Lebar imej maksimum"
// pe.minImageHeight: "Minimum image height" => "Ketinggian imej minimum"
// pe.maxImageHeight: "Maximum image height" => "Ketinggian imej maksimum"
// surveyvalidator.text: "Error message" => "Mesej ralat"
// surveyvalidator.expression: "Validation expression" => "Ungkapan pengesahihan"
// pe.logo: "Logo (URL or base64-encoded string)" => "Logo (URL atau rentetan berkod asas64)"
// pe.questionsOnPageMode: "Survey structure" => "Struktur tinjauan"
// pe.maxTextLength: "Maximum answer length (in characters)" => "Panjang jawapan maksimum (dalam aksara)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "Panjang komen maksimum (dalam aksara)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "Kembangkan kawasan komen secara automatik jika perlu"
// pe.allowResizeComment: "Allow users to resize text areas" => "Benarkan pengguna mensaiz semula kawasan teks"
// pe.textUpdateMode: "Update text question value" => "Mengemas kini nilai soalan teks"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "Mengesetkan fokus pada jawapan tidak sah yang pertama"
// pe.checkErrorsMode: "Run validation" => "Jalankan pengesahihan"
// pe.navigateToUrl: "Navigate to URL" => "Navigasi ke URL"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "URL dinamik"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "Penanda untuk menunjukkan sama ada pengguna telah mengisi tinjauan ini"
// pe.completedHtml: "Survey Complete page markup" => "Tinjauan Penanda halaman lengkap"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "Tinjauan Dinamik Lengkapkan penanda halaman"
// pe.loadingHtml: "Markup to show while survey model is loading" => "Penanda untuk ditunjukkan semasa model tinjauan sedang dimuatkan"
// pe.commentText: "Comment area text" => "Teks kawasan komen"
// pe.autocomplete: "Autocomplete type" => "Jenis autolengkap"
// pe.labelTrue: "\"True\" label" => "Label \"Benar\""
// pe.labelFalse: "\"False\" label" => "Label \"Palsu\""
// pe.displayStyle: "Value display style" => "Gaya paparan nilai"
// pe.format: "Formatted string" => "Rentetan yang diformatkan"
// pe.maximumFractionDigits: "Maximum fractional digits" => "Nombor pecahan maksimum"
// pe.minimumFractionDigits: "Minimum fractional digits" => "Digit pecahan minimum"
// pe.useGrouping: "Display grouping separators" => "Paparkan pemisah perkumpulan"
// pe.allowMultiple: "Allow multiple files" => "Benarkan berbilang fail"
// pe.allowImagesPreview: "Preview images" => "Pratonton imej"
// pe.acceptedTypes: "Accepted file types" => "Jenis fail yang diterima"
// pe.waitForUpload: "Wait for the upload to complete" => "Tunggu muat naik selesai"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "Sahkan penghapusan fail"
// pe.detailPanelMode: "Detail panel location" => "Lokasi panel terperinci"
// pe.minRowCount: "Minimum row count" => "Kiraan baris minimum"
// pe.maxRowCount: "Maximum row count" => "Kiraan baris maksimum"
// pe.confirmDelete: "Confirm row deletion" => "Sahkan pemadaman baris"
// pe.confirmDeleteText: "Confirmation message" => "Mesej pengesahan"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "Sahkan penghapusan panel"
// pe.panelCount: "Initial panel count" => "Kiraan panel awal"
// pe.minPanelCount: "Minimum panel count" => "Kiraan panel minimum"
// pe.maxPanelCount: "Maximum panel count" => "Kiraan panel maksimum"
// pe.panelsState: "Inner panel expand state" => "Panel dalaman mengembangkan keadaan"
// pe.templateDescription: "Description template" => "Templat perihalan"
// pe.templateTitle: "Title template" => "Templat tajuk"
// pe.panelPrevText: "Previous Panel button tooltip" => "Petua alat butang Panel Sebelumnya"
// pe.panelNextText: "Next Panel button tooltip" => "Petua alat butang Panel Seterusnya"
// pe.showRangeInProgress: "Show progress bar" => "Tunjukkan bar kemajuan"
// pe.templateTitleLocation: "Question title location" => "Lokasi tajuk soalan"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "Alih keluar lokasi butang Panel"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "Sembunyikan soalan jika tiada baris"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Menyembunyikan lajur jika tiada baris"
// pe.rateValues: "Custom rate values" => "Nilai kadar tersuai"
// pe.rateCount: "Rate count" => "Kiraan kadar"
// pe.autoGenerate: "How to specify rate values?" => "Bagaimana untuk menentukan nilai kadar?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "Sembunyikan soalan jika ia tidak mengandungi pilihan"
// pe.hideNumber: "Hide question number" => "Sembunyikan nombor soalan"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Lebar minimum (dalam nilai diterima CSS)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Lebar maksimum (dalam nilai diterima CSS)"
// pe.width: "Width (in CSS-accepted values)" => "Lebar (dalam nilai diterima CSS)"
// pe.showHeader: "Show column headers" => "Tunjukkan pengepala lajur"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Menunjukkan bar skrol mendatar"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Lebar lajur minimum (dalam nilai diterima CSS)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Lebar pengepala baris (dalam nilai diterima CSS)"
// pe.valueTrue: "\"True\" value" => "Nilai \"Benar\""
// pe.valueFalse: "\"False\" value" => "Nilai \"Palsu\""
// pe.minErrorText: "\"Value is below minimum\" error message" => "Mesej ralat \"Nilai adalah di bawah minimum\""
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "Mesej ralat \"Nilai melebihi maksimum\""
// pe.otherErrorText: "\"Empty comment\" error message" => "Mesej ralat \"komen kosong\""
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "Mesej ralat \"Nilai kunci bukan unik\""
// pe.minSelectedChoices: "Minimum selected choices" => "Pilihan minimum yang dipilih"
// pe.maxSelectedChoices: "Maximum selected choices" => "Pilihan maksimum yang dipilih"
// pe.showClearButton: "Show the Clear button" => "Tunjukkan butang Kosongkan"
// pe.showNumber: "Show panel number" => "Tunjukkan nombor panel"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "Lebar logo (dalam nilai diterima CSS)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "Ketinggian logo (dalam nilai diterima CSS)"
// pe.readOnly: "Read-only" => "Baca sahaja"
// pe.enableIf: "Editable if" => "Boleh diedit jika"
// pe.emptyRowsText: "\"No rows\" message" => "Mesej \"Tiada baris\""
// pe.size: "Input field size (in characters)" => "Saiz medan input (dalam aksara)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "Pilihan khas berasingan (Tiada, Lain-lain, Pilih Semua)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Salin pilihan daripada soalan berikut"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Pilihan mana yang hendak disalin?"
// pe.showCommentArea: "Show the comment area" => "Tunjukkan kawasan komen"
// pe.commentPlaceholder: "Comment area placeholder" => "Ruang letak komen"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Memaparkan perihalan kadar sebagai nilai melampau"
// pe.rowsOrder: "Row order" => "Tertib baris"
// pe.columnsLayout: "Column layout" => "Tataletak lajur"
// pe.columnColCount: "Nested column count" => "Kiraan lajur tersarang"
// pe.state: "Panel expand state" => "Panel kembangkan negeri"
// pe.correctAnswer: "Correct Answer" => "Jawapan yang betul"
// pe.defaultPanelValue: "Default Values" => "Nilai Lalai"
// pe.cells: "Cell Texts" => "Teks sel"
// pe.keyName: "Key column" => "Lajur utama"
// itemvalue.text: "Alt text" => "Teks alt"
// tabs.expression: "Expression" => "Ungkapan"
// pe.choicesVisibleIf: "Choices are visible if" => "Pilihan boleh dilihat jika"
// pe.choicesEnableIf: "Choices are selectable if" => "Pilihan boleh dipilih jika"
// pe.columnsEnableIf: "Columns are visible if" => "Lajur kelihatan jika"
// pe.rowsEnableIf: "Rows are visible if" => "Baris boleh dilihat jika"
// pe.indent: "Add indents" => "Menambah inden"
// panel.indent: "Add outer indents" => "Menambah inden luaran"
// pe.innerIndent: "Add inner indents" => "Menambah inden dalaman"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "Mengambil nilai lalai daripada baris terakhir"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "Mengambil nilai lalai daripada panel terakhir"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "Taip ungkapan di sini..."
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "Kosongkan nilai jika soalan menjadi tersembunyi"
// pe.valuePropertyName: "Value property name" => "Nama sifat nilai"
// pe.searchEnabled: "Enable search" => "Dayakan carian"
// pe.hideSelectedItems: "Hide selected items" => "Menyembunyikan item terpilih"
// pe.closeOnSelect: "Close the dropdown after selection" => "Menutup juntai bawah selepas pemilihan"
// pe.signatureWidth: "Signature width" => "Lebar tandatangan"
// pe.signatureHeight: "Signature height" => "Ketinggian tandatangan"
// pe.verticalAlign: "Vertical alignment" => "Penjajaran menegak"
// pe.alternateRows: "Alternate rows" => "Baris alternatif"
// pe.columnsVisibleIf: "Columns are visible if" => "Lajur kelihatan jika"
// pe.rowsVisibleIf: "Rows are visible if" => "Baris boleh dilihat jika"
// pe.otherPlaceholder: "Comment area placeholder" => "Ruang letak komen"
// pe.rateType: "Rate type" => "Jenis kadar"
// pv.true: "true" => "Benar"
// pv.false: "false" => "Palsu"
// pv.decimal: "decimal" => "Perpuluhan"
// pv.currency: "currency" => "Mata wang"
// pv.percent: "percent" => "Peratus"
// pv.onpanel: "Start on each panel" => "Mulakan pada setiap panel"
// pv.tab: "Tabs" => "Tab"
// pv.right: "Right" => "Kanan"
// pv.color: "color" => "Warna"
// pv.date: "date" => "Tarikh"
// pv.datetime: "datetime" => "masa tarikh"
// pv.datetime-local: "datetime-local" => "tarikh-tempatan"
// pv.email: "email" => "E-mel"
// pv.month: "month" => "Bulan"
// pv.number: "number" => "Nombor"
// pv.password: "password" => "Kata laluan"
// pv.range: "range" => "Pelbagai"
// pv.tel: "tel" => "Tel"
// pv.text: "text" => "Teks"
// pv.time: "time" => "Masa"
// pv.url: "url" => "Url"
// pv.week: "week" => "Minggu"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "Apabila soalan atau panel/halamannya menjadi tersembunyi"
// clearInvisibleValues.none: "Never" => "Tidak pernah"
// inputType.color: "Color" => "Warna"
// inputType.date: "Date" => "Tarikh"
// inputType.datetime-local: "Date and Time" => "Tarikh dan Masa"
// inputType.email: "Email" => "E-mel"
// inputType.month: "Month" => "Bulan"
// inputType.number: "Number" => "Nombor"
// inputType.password: "Password" => "Kata laluan"
// inputType.range: "Range" => "Pelbagai"
// inputType.tel: "Phone Number" => "Nombor Telefon"
// inputType.text: "Text" => "Teks"
// inputType.time: "Time" => "Masa"
// inputType.url: "URL" => "URL"
// inputType.week: "Week" => "Minggu"
// pv.onValueChanging: "Before an answer is changed" => "Sebelum jawapan diubah"
// pv.onBlur: "On blur" => "Pada kabur"
// pv.onTyping: "While typing" => "Semasa menaip"
// pv.underRow: "Under the row" => "Di bawah baris"
// pv.underRowSingle: "Under the row, only one panel is visible" => "Di bawah baris, hanya satu panel boleh dilihat"
// showNavigationButtons.none: "Hidden" => "Tersembunyi"
// showProgressBar.off: "Hidden" => "Tersembunyi"
// showTimerPanel.none: "Hidden" => "Tersembunyi"
// showTimerPanelMode.all: "Both" => "Kedua-duanya"
// detailPanelMode.none: "Hidden" => "Tersembunyi"
// addRowLocation.default: "Depends on matrix layout" => "Bergantung pada tataletak matriks"
// panelsState.default: "Users cannot expand or collapse panels" => "Pengguna tidak boleh mengembangkan atau meruntuhkan panel"
// panelsState.collapsed: "All panels are collapsed" => "Semua panel runtuh"
// panelsState.expanded: "All panels are expanded" => "Semua panel diperluaskan"
// widthMode.auto: "Auto" => "Auto"
// widthMode.static: "Static" => "Statik"
// widthMode.responsive: "Responsive" => "Responsif"
// imageFit.none: "None" => "Tiada"
// imageFit.contain: "Contain" => "Mengandungi"
// imageFit.cover: "Cover" => "Perlindungan"
// imageFit.fill: "Fill" => "Mengisi"
// contentMode.auto: "Auto" => "Auto"
// contentMode.image: "Image" => "Imej"
// contentMode.video: "Video" => "Video"
// contentMode.youtube: "YouTube" => "Youtube"
// displayMode.auto: "Auto" => "Auto"
// displayMode.buttons: "Buttons" => "Butang"
// displayMode.dropdown: "Dropdown" => "Dropdown"
// rateColorMode.default: "Default" => "Lalai"
// autoGenerate.true: "Generate" => "Menjana"
// autoGenerate.false: "Enter manually" => "Masukkan secara manual"
// rateType.labels: "Labels" => "Label"
// rateType.stars: "Stars" => "Bintang"
// rateType.smileys: "Smileys" => "Smileys"
// op.and: "and" => "Dan"
// op.or: "or" => "Atau"
// ts.hideInvisibleElements: "Hide invisible elements" => "Sembunyikan unsur tidak kelihatan"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Kuki menghalang pengguna daripada mengisi tinjauan yang sama dua kali."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Mensaiz semula kawasan medan input yang kelihatan. Sila gunakan <b>Pengesahan →</b> Tetapan panjang maksimum untuk mengehadkan panjang input."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Gunakan {0} sebagai ruang letak untuk nilai sebenar."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Boleh dilihat hanya apabila sekurang-kurangnya satu lajur mempunyai jenis Jumlah atau ungkapan Jumlah."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Rujuk perihalan atribut [terima](https://www.w3schools.com/tags/att_input_accept.asp) untuk maklumat lanjut."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Hanya digunakan untuk jenis sel Kumpulan Radio dan Kotak Semak."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Rujuk perihalan atribut [autolengkap](https://developer.mozilla.org/en-US/docs/Web/HTML/Atribut/autolengkap) untuk maklumat lanjut."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Jika anda tidak menetapkan sifat ini, jawapannya akan disimpan dalam medan yang ditentukan oleh sifat Nama."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Jika lajur yang ditentukan mengandungi nilai yang sama, tinjauan akan membuang ralat \"Nilai kunci bukan unik\"."
// p.value: "Value" => "Nilai"
// p.tabAlign: "Tab alignment" => "Penjajaran tab"
// p.questions: "Questions" => "Soalan"
// p.surveyId: "Survey id" => "Id tinjauan"
// p.surveyPostId: "Survey post id" => "Id siaran tinjauan"
// p.surveyShowDataSaving: "Survey show data saving" => "Tinjauan menunjukkan penjimatan data"
// p.showTOC: "Show TOC" => "Tunjukkan TOC"
// p.tocLocation: "Toc location" => "Lokasi Toc"
// p.showBrandInfo: "Show brand info" => "Tunjukkan maklumat jenama"
// p.renderAs: "Render as" => "Render sebagai"
// p.attachOriginalItems: "Attach original items" => "Lampirkan item asal"
// p.cellHint: "Cell hint" => "Petunjuk sel"
// p.isUnique: "Is unique" => "Unik"
// p.showInMultipleColumns: "Show in multiple columns" => "Tunjukkan dalam berbilang lajur"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Jumlah digit pecahan maksimum"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Jumlah digit pecahan minimum"
// p.detailElements: "Detail elements" => "Unsur terperinci"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Benarkan tindakan penyesuaian"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Pilihan beban malas didayakan"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Pilihan malas memuatkan saiz halaman"
// p.inputFieldComponent: "Input field component" => "Komponen medan input"
// p.itemComponent: "Item component" => "Komponen item"
// p.elements: "Elements" => "Unsur"
// p.content: "Content" => "Kandungan"
// p.longTap: "Long tap" => "Ketuk panjang"
// p.allowResize: "Allow resizing" => "Benarkan pensaizan semula"
// p.acceptCarriageReturn: "Accept carriage return" => "Terima pulangan pengangkutan"
// p.displayMode: "Display mode" => "Mod paparan"
// p.rateType: "Rate type" => "Jenis kadar"
// p.altText: "Alt text" => "Teks alt"
// p.templateElements: "Template elements" => "Unsur templat"
// p.operator: "Operator" => "Pengendali"
// p.isVariable: "Is variable" => "Adakah pembolehubah"
// p.runExpression: "Run expression" => "Jalankan ungkapan"
// p.precision: "Precision" => "Ketepatan"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Kawasan pemegang seretan matriks"
// p.backgroundImage: "Background image" => "Imej latar belakang"
// p.backgroundImageFit: "Background image fit" => "Kesesuaian imej latar belakang"
// p.backgroundImageAttachment: "Background image attachment" => "Lampiran imej latar belakang"
// p.backgroundOpacity: "Background opacity" => "Kelegapan latar belakang"
// p.selectToRankEnabled: "Select to rank enabled" => "Pilih untuk mendayakan kedudukan"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Pilih untuk menentukan tataletak kawasan"
// p.allowCameraAccess: "Allow camera access" => "Benarkan capaian kamera"
// p.scaleColorMode: "Scale color mode" => "Mod warna skala"
// p.rateColorMode: "Rate color mode" => "Mod warna kadar"
// p.templateTabTitle: "Template tab title" => "Tajuk tab templat"
// p.templateVisibleIf: "Template visible if" => "Templat boleh dilihat jika"
// p.copyDisplayValue: "Copy display value" => "Nilai paparan salin"
// theme.--background: "Background color" => "Warna latar belakang"
// theme.--background-dim-light: "Background dim light color" => "Warna cahaya malap latar belakang"
// theme.--primary-foreground: "Primary foreground color" => "Warna latar depan utama"
// theme.--foreground: "Foreground color" => "Warna latar depan"
// theme.--base-unit: "Base unit" => "Unit asas"
// theme.groupAdvanced: "Advanced" => "Lanjutan"
// theme.themeName: "Theme" => "Tema"
// theme.isPanellessss: "Question appearance" => "Penampilan soalan"
// theme.isPanellessPanels: "Default" => "Lalai"
// theme.isPanellessLightweight: "Without Panels" => "Tanpa Panel"
// theme.themePaletteLight: "Light" => "Cahaya"
// theme.themePaletteDark: "Dark" => "Gelap"
// theme.primaryColor: "Accent color" => "Warna aksen"
// theme.primaryDefaultColor: "Default" => "Lalai"
// theme.primaryDarkColor: "Hover" => "Hover"
// theme.primaryLightColor: "Selected" => "Dipilih"
// theme.backgroundDimColor: "Background color" => "Warna latar belakang"
// theme.backgroundImage: "Background image" => "Imej latar belakang"
// theme.backgroundImageFitAuto: "Auto" => "Auto"
// theme.backgroundImageFitCover: "Cover" => "Perlindungan"
// theme.backgroundImageFitContain: "Contain" => "Mengandungi"
// theme.backgroundOpacity: "Opacity" => "Kelegapan"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Tetap"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Tatal"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Kelegapan latar belakang panel"
// theme.questionBackgroundTransparency: "Question background opacity" => "Kelegapan latar belakang soalan"
// theme.questionPanel: "Panel background and corner radius" => "Latar belakang panel dan jejari sudut"
// theme.questionTitle: "Question title font" => "Fon tajuk soalan"
// theme.questionDescription: "Question description font" => "Fon perihalan soalan"
// theme.editorPanel: "Input element" => "Unsur input"
// theme.editorFont: "Input element font" => "Fon unsur input"
// theme.backcolor: "Default background" => "Latar belakang lalai"
// theme.hovercolor: "Hover background" => "Latarbelakang penuding"
// theme.borderDecoration: "Border decoration" => "Hiasan sempadan"
// theme.accentBackground: "Accent background" => "Latar belakang aksen"
// theme.accentForeground: "Accent foreground" => "Aksen latar depan"
// theme.primaryForecolor: "Default color" => "Warna lalai"
// theme.primaryForecolorLight: "Disabled color" => "Warna dinyahdayakan"
// theme.linesColors: "Minor line colors" => "Warna garis kecil"
// theme.borderDefault: "Darker" => "Gelap"
// theme.borderLight: "Lighter" => "Lebih ringan"
// theme.fontFamily: "Font family" => "Keluarga fon"
// theme.fontSize: "Font size" => "Saiz fon"
// theme.color: "Color" => "Warna"
// theme.size: "Size" => "Saiz"
// theme.fontWeightRegular: "Regular" => "Tetap"
// theme.fontWeightHeavy: "Heavy" => "Berat"
// theme.fontWeightSemiBold: "Semi-bold" => "Separa berani"
// theme.fontWeightBold: "Bold" => "Berani"
// theme.scale: "Scale" => "Skala"
// theme.cornerRadius: "Corner radius" => "Jejari penjuru"
// theme.surveyTitleFont: "Survey title font" => "Fon tajuk tinjauan"
// theme.pageTitle: "Page title font" => "Fon tajuk halaman"
// theme.pageDescription: "Page description font" => "Fon perihalan halaman"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Menambah Kesan Bayang"
// theme.opacity: "Opacity" => "Kelegapan"
// theme.boxShadowBlur: "Blur" => "Kabur"
// theme.boxShadowSpread: "Spread" => "Penyebaran"
// theme.boxShadowDrop: "Drop" => "Singgah"
// theme.boxShadowInner: "Inner" => "Dalaman"
// theme.questionShadow: "Shadow effects" => "Kesan bayang"
// theme.editorShadow: "Input element shadow effects" => "Kesan bayang unsur input"
// names.default: "Default" => "Lalai"
// names.contrast: "Contrast" => "Sebaliknya"
// names.plain: "Plain" => "Biasa"
// names.simple: "Simple" => "Mudah"
// names.blank: "Blank" => "Kosong"
// names.double: "Double" => "Double"
// names.bulk: "Bulk" => "Pukal"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo 3D"
// names.playful: "Playful" => "Suka bermain"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Teal"
// colors.blue: "Blue" => "Blue"
// colors.purple: "Purple" => "Ungu"
// colors.orchid: "Orchid" => "Orchid"
// colors.tulip: "Tulip" => "Tulip"
// colors.brown: "Brown" => "Brown"
// colors.green: "Green" => "Hijau"
// names.sharp: "Sharp" => "Tajam"
// names.borderless: "Borderless" => "Tanpa sempadan"
// names.flat: "Flat" => "Rata"
// names.doubleborder: "Double Border" => "Sempadan Berkembar"
// names.layered: "Layered" => "Berlapis"
// names.solid: "Solid" => "Pepejal"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Adakah anda pasti ingin memadam semua rentetan untuk bahasa ini?"
// ed.themeResetButton: "Reset theme settings to default" => "Mengeset semula seting tema kepada lalai"
// theme.placeholderColor: "Placeholder color" => "Warna ruang letak"
// ed.themeSettings: "Theme Settings" => "Seting Tema"
// ed.themeSettingsTooltip: "Open theme settings" => "Buka seting tema"
// pe.resetToDefaultCaption: "Reset" => "Set semula"
// pv.file: "Local files" => "Fail tempatan"
// pv.camera: "Camera" => "Kamera"
// pv.file-camera: "Local files or camera" => "Fail atau kamera tempatan"
// ed.translateUsigAI: "Auto-translate All" => "Terjemahkan Secara automatik Semua"
// ed.translationDialogTitle: "Untranslated strings" => "Rentetan tidak diterjemahkan"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Sila masukkan sekurang-kurangnya {0} item"
// lg.question_resetValueName: "Reset question value" => "Mengeset semula nilai soalan"
// lg.column_resetValue: "Reset column value" => "Mengeset semula nilai lajur"
// pe.markRequired: "Mark as required" => "Tandakan mengikut keperluan"
// pe.removeRequiredMark: "Remove the required mark" => "Mengalih keluar tanda yang diperlukan"
// p.resetValueIf: "Reset value if" => "Mengeset semula nilai jika"
// lg.question_setValueName: "Set question value" => "Mengesetkan nilai soalan"
// lg.column_resetValueName: "Reset column value" => "Mengeset semula nilai lajur"
// lg.column_setValueName: "Set column value" => "Mengesetkan nilai lajur"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Ungkapan yang hasilnya akan diberikan kepada soalan sasaran."
// survey.title: "Title" => "Tajuk"
// page.title: "Title" => "Tajuk"
// p.setValueIf: "Set value if" => "Setkan nilai jika"
// theme.header: "Header" => "Pengepala"
// theme.backgroundImageFitFill: "Stretch" => "Regangan"
// theme.backgroundImageFitTile: "Tile" => "Jubin"
// theme.headerView: "View" => "Lihat"
// theme.headerViewBasic: "Basic" => "Asas"
// theme.headerViewAdvanced: "Advanced" => "Lanjutan"
// theme.headerInheritWidthFrom: "Content area width" => "Lebar kawasan kandungan"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Sama seperti tinjauan"
// theme.headerInheritWidthFromPage: "Fit to page" => "Muat ke halaman"
// theme.headerTextAreaWidth: "Text width" => "Lebar teks"
// theme.headerBackgroundColorSwitch: "Background color" => "Warna latar belakang"
// theme.headerBackgroundColorNone: "None" => "Tiada"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Warna aksen"
// theme.headerBackgroundColorCustom: "Custom" => "Tersuai"
// theme.horizontalAlignmentLeft: "Left" => "Kiri"
// theme.horizontalAlignmentCenter: "Center" => "Pusat"
// theme.horizontalAlignmentRight: "Right" => "Kanan"
// theme.verticalAlignmentTop: "Top" => "Atas"
// theme.verticalAlignmentMiddle: "Middle" => "Tengah"
// theme.verticalAlignmentBottom: "Bottom" => "Bawah"
// lg.question_resetValueText: "reset value for question: {0}" => "Tetapkan semula nilai untuk soalan: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Berikan nilai: {1} kepada soalan: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Set semula nilai sel untuk lajur: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Peruntukkan nilai sel: {1} kepada lajur: {0}"
// ed.surveyJsonExportButton: "Export" => "Eksport"
// ed.surveyJsonImportButton: "Import" => "Import"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Salin ke papan keratan"
// pe.filePlaceholder: "File placeholder text" => "Teks ruang letak fail"
// pe.photoPlaceholder: "Photo placeholder text" => "Teks ruang letak foto"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Teks ruang letak fail atau foto"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Digunakan apabila \"Jenis sumber\" ialah \"Fail tempatan\" atau apabila kamera tidak tersedia"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Digunakan apabila \"Jenis sumber\" ialah \"Kamera\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Digunakan apabila \"Jenis sumber\" ialah \"Fail atau kamera tempatan\"."
// theme.background: "Background" => "Latar belakang"
// theme.appearance: "Appearance" => "Penampilan"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Adakah anda benar-benar mahu menetapkan semula tema? Semua penyesuaian anda akan hilang."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Ya, tetapkan semula tema"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Muat ke bekas"
// signaturepad.showPlaceholder: "Show the placeholder" => "Menunjukkan ruang letak"
// signaturepad.placeholder: "Placeholder text" => "Teks ruang letak"
// theme.surveyDescriptionFont: "Survey description font" => "Fon perihalan tinjauan"
// ed.prevFocus: "Focus previous" => "Fokus sebelum ini"
// ed.nextFocus: "Focus next" => "Fokus seterusnya"
// ed.saveTheme: "Save Theme" => "Simpan Tema"
// ed.saveThemeTooltip: "Save Theme" => "Simpan Tema"
// lg.page_requireName: "Make page required" => "Buat halaman diperlukan"
// lg.panel_requireName: "Make page required" => "Buat halaman diperlukan"
// signaturepad.signatureWidth: "Signature area width" => "Lebar kawasan tandatangan"
// signaturepad.signatureHeight: "Signature area height" => "Ketinggian kawasan tandatangan"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Menskalakan kawasan tandatangan secara automatik"
// signaturepad.penMinWidth: "Minimum pen width" => "Lebar pen minimum"
// signaturepad.penMaxWidth: "Maximum pen width" => "Lebar pen maksimum"
// theme.logoPosition: "Logo position" => "Kedudukan logo"
// theme.headerTitlePosition: "Title position" => "Kedudukan tajuk"
// theme.headerDescriptionPosition: "Description position" => "Kedudukan perihalan"
// ed.propertyGridNoResultsFound: "No results found" => "Tiada keputusan ditemui"
// pv.leftRight: "Left and right" => "Kiri dan kanan"
// p.sourceType: "Source type" => "Jenis sumber"
// p.fitToContainer: "Fit to container" => "Muat ke bekas"
// p.setValueExpression: "Set value expression" => "Mengesetkan ungkapan nilai"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Pilihan dimuatkan dari perkhidmatan web."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Pergi ke seting"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Pratonton pilihan pilihan yang dimuatkan"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Mengelakkan respons pendua dalam baris"
// theme.advancedMode: "Advanced mode" => "Mod lanjutan"
// theme.backgroundCornerRadius: "Background and corner radius" => "Latar belakang dan jejari sudut"
// theme.colorsTitle: "Colors" => "Warna"
// theme.font: "Font" => "Fon"
// theme.lines: "Lines" => "Garisan"
// theme.titleFont: "Title font" => "Fon tajuk"
// theme.descriptionFont: "Description font" => "Fon perihalan"
// theme.shadow: "Shadow effects" => "Kesan bayang"
// ed.translateUsigAIFrom: "Translate from: " => "Terjemah daripada: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Benarkan pilihan Enggan Menjawab"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Benarkan pilihan Jangan Tahu"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Benarkan pilihan Enggan Menjawab"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Benarkan pilihan Jangan Tahu"
// pv.contain: "Contain" => "Mengandungi"
// pv.cover: "Cover" => "Perlindungan"
// pv.fill: "Fill" => "Mengisi"
// pe.transposeData: "Transpose rows to columns" => "Mengubah urutan baris kepada lajur"
// layout.panel: "Layout" => "Susun atur"
// layout.question: "Layout" => "Susun atur"
// layout.base: "Layout" => "Susun atur"
// panel.name: "Panel name" => "Nama panel"
// panel.title: "Panel title" => "Tajuk panel"
// panel.description: "Panel description" => "Penerangan panel"
// panel.visibleIf: "Make the panel visible if" => "Jadikan panel kelihatan jika"
// panel.requiredIf: "Make the panel required if" => "Buat panel diperlukan jika"
// panel.questionsOrder: "Question order within the panel" => "Tertib soalan dalam panel"
// panel.startWithNewLine: "Display the panel on a new line" => "Paparkan panel pada baris baru"
// panel.state: "Panel collapse state" => "Keadaan panel runtuh"
// panel.width: "Inline panel width" => "Lebar panel sebaris"
// panel.minWidth: "Minimum panel width" => "Lebar panel minimum"
// panel.maxWidth: "Maximum panel width" => "Lebar panel maksimum"
// panel.showNumber: "Number panels" => "Panel nombor"
// paneldynamic.name: "Panel name" => "Nama panel"
// paneldynamic.title: "Panel title" => "Tajuk panel"
// paneldynamic.description: "Panel description" => "Penerangan panel"
// paneldynamic.visibleIf: "Make the panel visible if" => "Jadikan panel kelihatan jika"
// paneldynamic.requiredIf: "Make the panel required if" => "Buat panel diperlukan jika"
// paneldynamic.page: "Move the panel to page" => "Mengalihkan panel ke halaman"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Paparkan panel pada baris baru"
// paneldynamic.state: "Panel collapse state" => "Keadaan panel runtuh"
// paneldynamic.width: "Inline panel width" => "Lebar panel sebaris"
// paneldynamic.minWidth: "Minimum panel width" => "Lebar panel minimum"
// paneldynamic.maxWidth: "Maximum panel width" => "Lebar panel maksimum"
// paneldynamic.templateDescription: "Panel description pattern" => "Corak perihalan panel"
// paneldynamic.templateTitle: "Panel title pattern" => "Corak tajuk panel"
// paneldynamic.noEntriesText: "Empty panel text" => "Teks panel kosong"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Corak tajuk tab"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Jadikan panel individu kelihatan jika"
// paneldynamic.hideNumber: "Hide the panel number" => "Sembunyikan nombor panel"
// paneldynamic.titleLocation: "Panel title alignment" => "Penjajaran tajuk panel"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Penjajaran perihalan panel"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Penjajaran tajuk soalan"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Penjajaran mesej ralat"
// paneldynamic.newPanelPosition: "New panel location" => "Lokasi panel baru"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Mencegah jawapan pendua dalam soalan berikut"
// question.name: "Question name" => "Nama soalan"
// question.title: "Question title" => "Tajuk soalan"
// question.description: "Question description" => "Penerangan soalan"
// question.visibleIf: "Make the question visible if" => "Jadikan soalan kelihatan jika"
// question.requiredIf: "Make the question required if" => "Jadikan soalan diperlukan jika"
// question.state: "Question box collapse state" => "Keadaan kotak soalan runtuh"
// question.hideNumber: "Hide the question number" => "Sembunyikan nombor soalan"
// question.titleLocation: "Question title alignment" => "Penjajaran tajuk soalan"
// question.descriptionLocation: "Question description alignment" => "Penjajaran perihalan soalan"
// question.errorLocation: "Error message alignment" => "Penjajaran mesej ralat"
// question.indent: "Increase the inner indent" => "Meningkatkan inden dalaman"
// question.width: "Inline question width" => "Lebar soalan sebaris"
// question.minWidth: "Minimum question width" => "Lebar soalan minimum"
// question.maxWidth: "Maximum question width" => "Lebar soalan maksimum"
// question.textUpdateMode: "Update input field value" => "Mengemas kini nilai medan input"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Tunjukkan butang Kosongkan dalam kawasan tandatangan"
// signaturepad.penColor: "Stroke color" => "Warna strok"
// comment.rows: "Input field height (in lines)" => "Ketinggian medan input (dalam garisan)"
// expression.name: "Expression name" => "Nama ungkapan"
// expression.title: "Expression title" => "Tajuk ungkapan"
// expression.description: "Expression description" => "Perihalan ungkapan"
// expression.expression: "Expression" => "Ungkapan"
// trigger.expression: "Expression" => "Ungkapan"
// calculatedvalue.expression: "Expression" => "Ungkapan"
// survey.description: "Survey description" => "Penerangan tinjauan"
// page.name: "Page name" => "Nama halaman"
// page.description: "Page description" => "Perihalan halaman"
// page.visibleIf: "Make the page visible if" => "Jadikan halaman kelihatan jika"
// page.requiredIf: "Make the page required if" => "Jadikan halaman diperlukan jika"
// page.questionsOrder: "Question order on the page" => "Tertib soalan pada halaman"
// matrixdropdowncolumn.name: "Column name" => "Nama lajur"
// matrixdropdowncolumn.title: "Column title" => "Tajuk lajur"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Elakkan tindak balas pendua"
// matrixdropdowncolumn.width: "Column width" => "Lebar lajur"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Lebar lajur minimum"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Ketinggian medan input (dalam garisan)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Jadikan lajur kelihatan jika"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Jadikan lajur diperlukan jika"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Setiap opsyen dalam lajur berasingan"
// multipletextitem.name: "Name" => "Nama"
// multipletextitem.title: "Title" => "Tajuk"
// pe.rateDescriptionLocation: "Label alignment" => "Penjajaran label"
// pe.cellErrorLocation: "Cell error message alignment" => "Penjajaran mesej ralat sel"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Anda belum mempunyai sebarang lajur"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Anda belum mempunyai sebarang baris"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Anda belum mempunyai sebarang peraturan pengesahihan"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Anda belum mempunyai sebarang pemboleh ubah tersuai"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Anda belum mempunyai sebarang pencetus"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Anda belum mempunyai pautan"
// pe.addNew@columns: "Add new column" => "Menambah lajur baru"
// pe.addNew@rows: "Add new row" => "Menambah baris baru"
// pe.addNew@validators: "Add new rule" => "Tambah peraturan baru"
// pe.addNew@calculatedValues: "Add new variable" => "Menambah pemboleh ubah baru"
// pe.addNew@triggers: "Add new trigger" => "Tambah pencetus baharu"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Tambah URL baru"
// choicesbyurl.url: "Web service's URL" => "URL perkhidmatan web"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Paparkan tajuk halaman dalam bar kemajuan"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Paparkan nombor halaman dalam bar kemajuan"
// itemvalue.visibleIf: "Make the option visible if" => "Jadikan opsyen kelihatan jika"
// itemvalue.enableIf: "Make the option selectable if" => "Jadikan opsyen boleh dipilih jika"
// panel.layout: "Panel Layout" => "Tataletak Panel"
// tabs.questionSettings: "Question Settings" => "Seting Soalan"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Ex.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Ex.: categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Ex.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Ex.: 6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "Ex.: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Ex.: 50%"
// pv.selected: "Selected" => "Dipilih"
// pv.unselected: "Unselected" => "Tidak dipilih"
// pv.center: "Center" => "Pusat"
// pv.middle: "Middle" => "Tengah"
// pv.next: "Next" => "Seterusnya"
// pv.last: "Last" => "Terakhir"
// clearIfInvisible.none: "Never" => "Tidak pernah"
// questionsOnPageMode.standard: "Original structure" => "Struktur asal"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Tunjukkan semua soalan pada satu halaman"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Menunjukkan soalan tunggal bagi setiap halaman"
// pv.auto: "Auto" => "Auto"
// panelsState.firstExpanded: "First expanded" => "Mula-mula diperluaskan"
// rateColorMode.scale: "Scale" => "Skala"
// scaleColorMode.monochrome: "Monochrome" => "Monokrom"
// scaleColorMode.colored: "Colored" => "Berwarna"
// state.default: "Locked" => "Dikunci"
// showQuestionNumbers.default: "Auto-numbering" => "Penomboran automatik"
// showQuestionNumbers.on: "Auto-numbering" => "Penomboran automatik"
// showQuestionNumbers.onPage: "Reset on each page" => "Mengeset semula pada setiap halaman"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Set semula pada setiap panel"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Set semula pada setiap panel"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Teruskan merentasi tinjauan"
// showQuestionNumbers.off: "No numbering" => "Tiada penomboran"
// descriptionLocation.underTitle: "Under the question title" => "Di bawah tajuk soalan"
// descriptionLocation.underInput: "Under the input field" => "Di bawah medan input"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Di sebelah pilihan"
// selectToRankAreasLayout.vertical: "Above choices" => "Pilihan di atas"
// displayStyle.decimal: "Decimal" => "Perpuluhan"
// displayStyle.currency: "Currency" => "Mata wang"
// displayStyle.percent: "Percentage" => "Peratusan"
// displayStyle.date: "Date" => "Tarikh"
// totalDisplayStyle.decimal: "Decimal" => "Perpuluhan"
// totalDisplayStyle.currency: "Currency" => "Mata wang"
// totalDisplayStyle.percent: "Percentage" => "Peratusan"
// totalDisplayStyle.date: "Date" => "Tarikh"
// rowsOrder.initial: "Original" => "Asal"
// questionsOrder.initial: "Original" => "Asal"
// showProgressBar.aboveheader: "Above the header" => "Di atas pengepala"
// showProgressBar.belowheader: "Below the header" => "Di bawah pengepala"
// pv.sum: "Sum" => "Jumlah"
// pv.count: "Count" => "Kiraan"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Max"
// pv.avg: "Avg" => "Pur"
// searchMode.contains: "Contains" => "Mengandungi"
// searchMode.startsWith: "Starts with" => "Bermula dengan"
// panel.name: "A panel ID that is not visible to respondents." => "ID panel yang tidak kelihatan kepada responden."
// panel.description: "Type a panel subtitle." => "Taipkan sari kata panel."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menentukan keterlihatan panel."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang melumpuhkan mod baca sahaja untuk panel."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menghalang penyerahan tinjauan melainkan sekurang-kurangnya satu soalan tersarang mempunyai jawapan."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Digunakan untuk semua soalan dalam panel ini. Jika anda ingin mengubah seting ini, takrifkan peraturan penjajaran tajuk untuk soalan individu. Pilihan \"Warisan\" menggunakan peringkat halaman (jika ditetapkan) atau tetapan peringkat tinjauan (\"Atas\" secara lalai)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Mengesetkan lokasi mesej ralat berhubung dengan semua soalan dalam panel. Opsyen \"Warisan\" menggunakan aras halaman (jika set) atau seting aras tinjauan."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Mengekalkan susunan soalan asal atau rawak mereka. Opsyen \"Warisan\" menggunakan aras halaman (jika set) atau seting aras tinjauan."
// panel.page: "Repositions the panel to the end of a selected page." => "Meletakkan semula panel di hujung halaman yang dipilih."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Menambah ruang atau jidar antara kandungan panel dan sempadan kiri kotak panel."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Nyahpilih untuk memaparkan panel dalam satu baris dengan soalan atau panel sebelumnya. Seting tidak digunakan jika panel ialah elemen pertama dalam borang anda."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Pilih daripada: \"Diperluaskan\" - panel dipaparkan sepenuhnya dan boleh runtuh; \"Runtuh\" - panel hanya memaparkan tajuk dan keterangan dan boleh diperluaskan; \"Dikunci\" - panel dipaparkan sepenuhnya dan tidak boleh runtuh."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Mengesetkan lebar panel mengikut kadar unsur tinjauan lain dalam baris yang sama. Menerima nilai CSS (px, %, dalam, pt, dll.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "ID panel yang tidak kelihatan kepada responden."
// paneldynamic.description: "Type a panel subtitle." => "Taipkan sari kata panel."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menentukan keterlihatan panel."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang melumpuhkan mod baca sahaja untuk panel."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menghalang penyerahan tinjauan melainkan sekurang-kurangnya satu soalan tersarang mempunyai jawapan."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Digunakan untuk semua soalan dalam panel ini. Jika anda ingin mengubah seting ini, takrifkan peraturan penjajaran tajuk untuk soalan individu. Pilihan \"Warisan\" menggunakan peringkat halaman (jika ditetapkan) atau tetapan peringkat tinjauan (\"Atas\" secara lalai)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Mengesetkan lokasi mesej ralat berhubung dengan soalan dengan input tidak sah. Pilih antara: \"Atas\" - teks ralat diletakkan di bahagian atas kotak soalan; \"Bawah\" - teks ralat diletakkan di bahagian bawah kotak soalan. Pilihan \"Warisan\" menggunakan peringkat halaman (jika ditetapkan) atau tetapan peringkat tinjauan (\"Atas\" secara lalai)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Mengesetkan lokasi mesej ralat berhubung dengan semua soalan dalam panel. Opsyen \"Warisan\" menggunakan aras halaman (jika set) atau seting aras tinjauan."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Meletakkan semula panel di hujung halaman yang dipilih."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Menambah ruang atau jidar antara kandungan panel dan sempadan kiri kotak panel."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Nyahpilih untuk memaparkan panel dalam satu baris dengan soalan atau panel sebelumnya. Seting tidak digunakan jika panel ialah elemen pertama dalam borang anda."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Pilih daripada: \"Diperluaskan\" - panel dipaparkan sepenuhnya dan boleh runtuh; \"Runtuh\" - panel hanya memaparkan tajuk dan keterangan dan boleh diperluaskan; \"Dikunci\" - panel dipaparkan sepenuhnya dan tidak boleh runtuh."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Mengesetkan lebar panel mengikut kadar unsur tinjauan lain dalam baris yang sama. Menerima nilai CSS (px, %, dalam, pt, dll.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Taipkan templat untuk tajuk panel dinamik. Gunakan {panelIndex} untuk kedudukan umum panel dan {visiblePanelIndex} untuk pesanannya di kalangan panel yang kelihatan. Masukkan ruang letak ini ke dalam corak untuk menambah penomboran automatik."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Taipkan templat untuk tajuk tab. Gunakan {panelIndex} untuk kedudukan umum panel dan {visiblePanelIndex} untuk pesanannya di kalangan panel yang boleh dilihat. Masukkan ruang letak ini ke dalam corak untuk menambah penomboran automatik."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Tetapan ini membolehkan anda mengawal penglihatan panel individu dalam panel dinamik. Gunakan ruang letak '{panel}' untuk merujuk panel semasa dalam ungkapan anda."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Tetapan ini diwarisi secara automatik oleh semua soalan dalam panel ini. Jika anda ingin mengubah seting ini, takrifkan peraturan penjajaran tajuk untuk soalan individu. Pilihan \"Warisan\" menggunakan peringkat halaman (jika ditetapkan) atau tetapan peringkat tinjauan (\"Atas\" secara lalai)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "Opsyen \"Warisan\" menggunakan aras halaman (jika ditetapkan) atau seting aras tinjauan (\"Di bawah tajuk panel\" secara lalai)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Mentakrifkan kedudukan panel yang baru ditambah. Secara lalai, panel baru ditambahkan ke hujungnya. Pilih \"Seterusnya\" untuk memasukkan panel baru selepas yang semasa."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Pendua jawapan daripada panel terakhir dan memberikannya kepada panel dinamik tambahan seterusnya."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Rujukan nama soalan untuk memerlukan pengguna memberikan jawapan yang unik untuk soalan ini dalam setiap panel."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Seting ini membolehkan anda memperuntukkan nilai jawapan lalai berdasarkan ungkapan. Ungkapan ini boleh termasuk pengiraan asas - '{q1_id} + {q2_id}', ungkapan Boolean, seperti '{age} > 60', dan fungsi: 'iif()', 'hari ini()', 'umur()', 'min()', 'max()', 'avg()', dsb. Nilai yang ditentukan oleh ungkapan ini berfungsi sebagai nilai lalai awal yang boleh diubah oleh input manual responden."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Gunakan ikon tongkat ajaib untuk mengesetkan peraturan bersyarat yang menentukan masa input responden ditetapkan semula kepada nilai berdasarkan \"Ungkapan nilai lalai\" atau \"Setkan ungkapan nilai\" atau kepada nilai \"Jawapan lalai\" (jika sama ada ditetapkan)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menentukan masa untuk menjalankan \"Tetapkan ungkapan nilai\" dan secara dinamik memperuntukkan nilai yang terhasil sebagai respons."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Tentukan ungkapan yang mentakrifkan nilai yang akan disetkan apabila syarat dalam peraturan \"Set nilai jika\" dipenuhi. Ungkapan ini boleh termasuk pengiraan asas - '{q1_id} + {q2_id}', ungkapan Boolean, seperti '{age} > 60', dan fungsi: 'iif()', 'hari ini()', 'umur()', 'min()', 'max()', 'avg()', dsb. Nilai yang ditentukan oleh ungkapan ini boleh diubah oleh input manual responden."
// question.name: "A question ID that is not visible to respondents." => "ID soalan yang tidak dapat dilihat oleh responden."
// question.description: "Type a question subtitle." => "Taipkan sari kata soalan."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menentukan keterlihatan soalan."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang melumpuhkan mod baca sahaja untuk soalan itu."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menghalang tinjauan memajukan atau menyerahkan melainkan soalan itu mendapat jawapan."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Nyahpilih untuk memaparkan soalan dalam satu baris dengan soalan atau panel sebelumnya. Seting tidak digunakan jika soalan ialah unsur pertama dalam borang anda."
// question.page: "Repositions the question to the end of a selected page." => "Letakkan semula soalan ke hujung halaman yang dipilih."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Pilih daripada: \"Diperluaskan\" - kotak soalan dipaparkan sepenuhnya dan boleh runtuh; \"Runtuh\" - kotak soalan hanya memaparkan tajuk dan keterangan dan boleh diperluaskan; \"Dikunci\" - kotak soalan dipaparkan sepenuhnya dan tidak boleh runtuh."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Mengatasi peraturan penjajaran tajuk yang ditakrifkan pada panel, halaman atau tahap tinjauan. Opsyen \"Warisan\" menggunakan sebarang seting aras lebih tinggi (jika ditetapkan) atau seting aras tinjauan (\"Atas\" secara lalai)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "Opsyen \"Warisan\" menggunakan seting aras tinjauan (\"Di bawah tajuk soalan\" secara lalai)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Mengesetkan lokasi mesej ralat berhubung dengan soalan dengan input tidak sah. Pilih antara: \"Atas\" - teks ralat diletakkan di bahagian atas kotak soalan; \"Bawah\" - teks ralat diletakkan di bahagian bawah kotak soalan. Pilihan \"Warisan\" menggunakan tetapan peringkat tinjauan (\"Atas\" secara lalai)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Menambah ruang atau jidar antara kandungan soalan dan sempadan kiri kotak soalan."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Menetapkan lebar soalan mengikut kadar unsur tinjauan lain dalam baris yang sama. Menerima nilai CSS (px, %, dalam, pt, dll.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan pengesahan untuk soalan itu."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Pilih daripada: \"Pada fokus yang hilang\" - nilai dikemas kini apabila medan input kehilangan fokus; \"Semasa menaip\" - nilai dikemas kini dalam masa nyata, semasa pengguna menaip. Pilihan \"Warisan\" menggunakan seting peringkat tinjauan (\"Pada fokus yang hilang\" secara lalai)."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Anda boleh menggunakan mana-mana perkhidmatan web sebagai sumber data untuk soalan pelbagai pilihan. Untuk mengisi nilai pilihan, masukkan URL perkhidmatan yang menyediakan data."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Operasi perbandingan yang digunakan untuk menapis senarai juntai bawah."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Mengesetkan lebar kawasan tandatangan yang dipaparkan dan imej yang terhasil."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Mengesetkan ketinggian kawasan tandatangan yang dipaparkan dan imej yang terhasil."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Pilih jika anda inginkan kawasan tandatangan mengisi semua ruang yang tersedia dalam kotak soalan sambil mengekalkan nisbah aspek 3:2 lalai. Apabila nilai lebar dan ketinggian tersuai ditetapkan, seting akan mengekalkan nisbah aspek dimensi ini."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Melaraskan ketinggian imej dalam hasil tinjauan."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Melaraskan lebar imej dalam hasil tinjauan."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Mengatasi nilai ketinggian minimum dan maksimum."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Mengatasi nilai lebar minimum dan maksimum."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Nilai\" berfungsi sebagai ID item yang digunakan dalam peraturan bersyarat; \"Teks\" dipaparkan kepada responden."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Seting ini hanya mengubah saiz medan input dan tidak mempengaruhi lebar kotak soalan. Untuk mengehadkan panjang input yang diterima, pergi ke <b>Pengesahihan → Had aksara maksimum</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Mengesetkan bilangan baris yang dipaparkan dalam medan input. Jika input mengambil lebih banyak baris, bar skrol akan muncul."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Pilih antara: \"Boleh diedit\" - membolehkan responden mengisi tinjauan anda; \"Baca sahaja\" - melumpuhkan penyuntingan borang."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "ID lajur yang tidak kelihatan kepada responden."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Apabila didayakan untuk lajur, responden dikehendaki memberikan respons unik untuk setiap soalan dalam lajur ini."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Mengesetkan bilangan baris yang dipaparkan dalam medan input. Jika input mengambil lebih banyak baris, bar skrol akan muncul."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Gunakan ikon tongkat ajaib untuk mengesetkan peraturan bersyarat yang menentukan keterlihatan lajur."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Gunakan ikon tongkat ajaib untuk mengesetkan peraturan bersyarat yang menyahdayakan mod baca sahaja untuk lajur."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menghalang penyerahan tinjauan melainkan sekurang-kurangnya satu soalan tersarang mempunyai jawapan."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Apabila dipilih, cipta lajur individu untuk setiap opsyen pilihan."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Pilih daripada: \"Statik\" - menetapkan lebar tetap; \"Responsif\" - membuat tinjauan menduduki lebar penuh skrin; \"Auto\" - terpakai salah satu daripada kedua-duanya bergantung kepada jenis soalan yang digunakan."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Tampal pautan imej (tiada had saiz) atau klik ikon folder untuk menyemak lalu fail daripada komputer anda (sehingga 64KB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Menetapkan lebar logo dalam unit CSS (px, %, in, pt, dll.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Menetapkan ketinggian logo dalam unit CSS (px, %, in, pt, dll.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Pilih daripada: \"Tiada\" - imej mengekalkan saiz asalnya; \"Mengandungi\" - imej diubah saiznya agar sesuai sambil mengekalkan nisbah aspeknya; \"Cover\" - imej mengisi keseluruhan kotak sambil mengekalkan nisbah aspeknya; \"Isian\" - imej diregangkan untuk mengisi kotak tanpa mengekalkan nisbah aspeknya."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Pilih jika anda ingin tinjauan diteruskan ke halaman berikut secara automatik selepas responden menjawab semua soalan pada halaman semasa."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Mengesetkan kebolehlihatan dan lokasi butang navigasi pada halaman."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Menetapkan kebolehlihatan dan lokasi bar kemajuan. Nilai \"Auto\" memaparkan bar kemajuan di atas atau di bawah pengepala tinjauan."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Dayakan halaman pratonton dengan semua atau menjawab soalan sahaja."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Digunakan untuk semua soalan dalam tinjauan. Tetapan ini boleh diubah oleh peraturan penjajaran tajuk pada tahap yang lebih rendah: panel, halaman atau soalan. Tetapan peringkat rendah akan mengatasi mereka yang berada pada tahap yang lebih tinggi."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Simbol atau urutan simbol yang menunjukkan bahawa jawapan diperlukan."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Masukkan nombor atau huruf yang anda ingin mulakan penomboran."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Mengesetkan lokasi mesej ralat berhubung dengan soalan dengan input tidak sah. Pilih antara: \"Atas\" - teks ralat diletakkan di bahagian atas kotak soalan; \"Bawah\" - teks ralat diletakkan di bahagian bawah kotak soalan."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Pilih jika anda inginkan medan input pertama pada setiap halaman sedia untuk entri teks."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Mengekalkan susunan soalan asal atau rawak mereka. Kesan seting ini hanya kelihatan dalam tab Pratonton."
// pehelp.maxTextLength: "For text entry questions only." => "Untuk soalan entri teks sahaja."
// pehelp.maxOthersLength: "For question comments only." => "Untuk komen soalan sahaja."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Pilih jika anda inginkan komen soalan dan soalan Teks Panjang untuk mengembangkan ketinggian automatik berdasarkan panjang teks yang dimasukkan."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Untuk komen soalan dan soalan Teks Panjang sahaja."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Pemboleh ubah tersuai berfungsi sebagai pemboleh ubah perantaraan atau tambahan yang digunakan dalam pengiraan borang. Mereka mengambil input responden sebagai nilai sumber. Setiap pemboleh ubah tersuai mempunyai nama unik dan ungkapan yang berdasarkannya."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Pilih jika anda ingin nilai terhitung ungkapan disimpan bersama-sama dengan hasil tinjauan."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Pencetus ialah peristiwa atau keadaan yang berdasarkan ungkapan. Sebaik sahaja ungkapan dinilai kepada \"benar\", pencetus akan mematikan tindakan. Tindakan sedemikian secara pilihan boleh mempunyai soalan sasaran yang mempengaruhinya."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Pilih sama ada atau tidak untuk mengosongkan nilai untuk soalan yang tersembunyi oleh logik bersyarat dan bila untuk melakukannya."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Pilih daripada: \"Pada fokus yang hilang\" - nilai dikemas kini apabila medan input kehilangan fokus; \"Semasa menaip\" - nilai dikemas kini dalam masa nyata, semasa pengguna menaip."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Nilai kiri berfungsi sebagai ID lajur yang digunakan dalam peraturan bersyarat, nilai kanan dipaparkan kepada responden."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Nilai kiri berfungsi sebagai ID baris yang digunakan dalam peraturan bersyarat, nilai kanan dipaparkan kepada responden."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Menerima nilai CSS (px, %, dalam, pt, dll.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Menerima nilai CSS (px, %, dalam, pt, dll.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Mengesetkan lokasi mesej ralat berhubung dengan sel dengan input tidak sah. Opsyen \"Warisan\" menggunakan seting daripada sifat \"Penjajaran mesej ralat\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Apabila sifat \"Mencegah respons pendua\" didayakan, responden yang cuba menyerahkan entri pendua akan menerima mesej ralat berikut."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Membolehkan anda mengira jumlah nilai berdasarkan ungkapan. Ungkapan ini boleh termasuk pengiraan asas ('{q1_id} + {q2_id}'), Ungkapan Boolean ('{age} > 60') dan fungsi ('iif()', 'hari ini()', 'umur()', 'min()', 'max()', 'avg()', dll.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Mencetuskan gesaan yang meminta untuk mengesahkan pemadaman baris."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Pendua jawapan dari baris terakhir dan menguntukkannya ke baris dinamik tambahan seterusnya."
// pehelp.description: "Type a subtitle." => "Taipkan sari kata."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Pilih bahasa untuk mula mencipta tinjauan anda. Untuk menambah terjemahan, tukar kepada bahasa baru dan terjemahkan teks asal di sini atau dalam tab Terjemahan."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Mengesetkan lokasi seksyen butiran berhubung dengan baris. Pilih daripada: \"Tiada\" - tiada pengembangan ditambah; \"Di bawah baris\" - pengembangan baris diletakkan di bawah setiap baris matriks; \"Di bawah baris, paparkan pengembangan satu baris sahaja\" - pengembangan dipaparkan di bawah satu baris sahaja, pengembangan baris yang tinggal runtuh."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Pilih daripada: \"Tiada\" - imej mengekalkan saiz asalnya; \"Mengandungi\" - imej diubah saiznya agar sesuai sambil mengekalkan nisbah aspeknya; \"Cover\" - imej mengisi keseluruhan kotak sambil mengekalkan nisbah aspeknya; \"Isian\" - imej diregangkan untuk mengisi kotak tanpa mengekalkan nisbah aspeknya."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Secara beransur-ansur meningkatkan ketinggian medan input apabila data dimasukkan. Membatalkan seting \"Ketinggian medan input (dalam garisan)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Pemegang saiz semula (atau cengkaman) muncul di sudut dan boleh diseret untuk mengubah saiz medan input."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Selang masa dalam beberapa saat selepas itu tinjauan secara automatik maju ke halaman Terima Kasih."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Selang masa dalam beberapa saat selepas itu tinjauan secara automatik maju ke halaman seterusnya."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Selang masa dalam beberapa saat selepas itu tinjauan secara automatik maju ke halaman seterusnya."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menentukan keterlihatan halaman."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menyahdayakan mod baca sahaja untuk halaman."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menghalang penyerahan tinjauan melainkan sekurang-kurangnya satu soalan tersarang mempunyai jawapan."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Digunakan untuk semua soalan dalam halaman ini. Jika anda ingin mengubah seting ini, takrifkan peraturan penjajaran tajuk untuk soalan atau panel individu. Pilihan \"Warisan\" menggunakan tetapan peringkat tinjauan (\"Atas\" secara lalai)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Mengesetkan lokasi mesej ralat berhubung dengan soalan dengan input tidak sah. Pilih antara: \"Atas\" - teks ralat diletakkan di bahagian atas kotak soalan; \"Bawah\" - teks ralat diletakkan di bahagian bawah kotak soalan. Pilihan \"Warisan\" menggunakan tetapan peringkat tinjauan (\"Atas\" secara lalai)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Mengekalkan susunan soalan asal atau rawak mereka. Pilihan \"Warisan\" menggunakan seting peringkat tinjauan (\"Asal\" secara lalai). Kesan seting ini hanya kelihatan dalam tab Pratonton."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Mengesetkan keterlihatan butang navigasi pada halaman. Opsyen \"Warisan\" menggunakan seting aras tinjauan, yang lalai kepada \"Boleh Dilihat\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Mengesetkan kebolehlihatan dan lokasi pemasa pada halaman."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Pilih daripada: \"Dikunci\" - pengguna tidak boleh mengembangkan atau meruntuhkan panel; \"Runtuhkan semua\" - semua panel bermula dalam keadaan runtuh; \"Kembangkan semua\" - semua panel bermula dalam keadaan yang diperluaskan; \"Pertama diperluaskan\" - hanya panel pertama yang pada mulanya diperluaskan."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Masukkan nama sifat dikongsi dalam tatasusunan objek yang mengandungi URL fail imej atau video yang anda ingin paparkan dalam senarai pilihan."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Nilai kiri berfungsi sebagai ID item yang digunakan dalam peraturan bersyarat, nilai yang betul dipaparkan kepada responden."
// pehelp.title: "Type a user-friendly title to display." => "Taipkan tajuk mesra pengguna untuk dipaparkan."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Memastikan pengguna tidak akan melengkapkan tinjauan sehingga fail dimuat naik."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Menerima nilai CSS (px, %, dalam, pt, dll.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Menerima nilai CSS (px, %, dalam, pt, dll.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Menerima nilai CSS (px, %, dalam, pt, dll.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "Dalam jenis soalan pilihan tunggal dan berbilang pilihan, setiap pilihan pilihan mempunyai ID dan nilai paparan. Apabila dipilih, seting ini menunjukkan nilai paparan dan bukannya nilai ID dalam soalan HTML dan tajuk dinamik serta perihalan unsur tinjauan."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Pilih sama ada untuk mengosongkan nilai soalan yang tersembunyi oleh logik bersyarat dan bila untuk melakukannya. Pilihan \"Warisan\" menggunakan tetapan peringkat tinjauan (\"Setelah selesai tinjauan\" secara lalai)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Pilih daripada: \"Semua\" - menyalin semua pilihan pilihan daripada soalan yang dipilih; \"Dipilih\" - secara dinamik hanya menyalin pilihan pilihan yang dipilih; \"Tidak dipilih\" - secara dinamik menyalin hanya pilihan pilihan yang tidak dipilih. Pilihan \"Tiada\" dan \"Lain-lain\" disalin secara lalai jika didayakan dalam soalan sumber."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Apabila dipilih, pengguna boleh memasukkan input tambahan dalam kotak komen berasingan."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Memaparkan setiap pilihan pilihan khas (\"Tiada\", \"Lain\", \"Pilih Semua\") pada baris baru, walaupun menggunakan tataletak berbilang lajur."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Tentukan lokasi dalam set data perkhidmatan yang lokasi tatasusunan sasaran objek. Biarkan kosong jika URL telah menuding ke tatasusunan."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Masukkan nama sifat seragam dalam tatasusunan objek yang mengandungi nilai yang anda ingin paparkan dalam senarai pilihan."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Pilih untuk membenarkan perkhidmatan mengembalikan respons atau tatasusunan kosong."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Gunakan ikon tongkat ajaib untuk menetapkan peraturan bersyarat yang menentukan keterlihatan semua pilihan pilihan."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Nilai kiri berfungsi sebagai ID item yang digunakan dalam peraturan bersyarat, nilai yang betul dipaparkan kepada responden."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" memilih antara mod \"Butang\" dan \"Dropdown\" berdasarkan lebar yang tersedia. Apabila lebar tidak mencukupi untuk memaparkan butang, soalan memaparkan menu lungsur."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Membolehkan anda menyambungkan soalan yang menghasilkan hasil dalam format yang berbeza. Apabila soalan tersebut dipautkan bersama menggunakan pengecam cantuman, sifat kongsi ini menyimpan nilai soalan terpilih."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Pilih jika anda ingin mengemas kini kandungan menu juntai bawah agar sepadan dengan pertanyaan carian yang pengguna menaip dalam medan input."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Nilai untuk menyimpan hasil tinjauan apabila responden memberikan jawapan yang positif."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Nilai untuk menyimpan hasil tinjauan apabila responden memberikan jawapan negatif."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Ia tidak disyorkan untuk menyahdayakan pilihan ini kerana ia mengubah imej Pratonton dan menyukarkan pengguna untuk memahami sama ada fail telah dimuat naik."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Mencetuskan gesaan yang meminta untuk mengesahkan penghapusan fail."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Membolehkan untuk menilai pilihan yang dipilih sahaja. Pengguna akan menyeret item terpilih dari senarai pilihan untuk memesannya dalam kawasan kedudukan."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Masukkan senarai pilihan yang akan dicadangkan kepada responden semasa input."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Seting hanya mengubah saiz medan input dan tidak mempengaruhi lebar kotak soalan."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Mengesetkan lebar yang konsisten untuk semua label item dalam piksel"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Pilihan \"Auto\" secara automatik menentukan mod yang sesuai untuk paparan - Imej, Video atau YouTube - berdasarkan URL sumber yang disediakan."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Berfungsi sebagai pengganti apabila imej tidak boleh dipaparkan pada peranti pengguna dan untuk tujuan kebolehcapaian."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Mentakrifkan warna emoji yang dipilih apabila jenis ikon Penarafan ditetapkan kepada \"Smileys\". Pilih antara: \"Lalai\" - emoji yang dipilih muncul dalam warna tinjauan lalai; \"Skala\" - emoji yang dipilih mewarisi warna dari skala penarafan."
// expression.name: "An expression ID that is not visible to respondents." => "ID ungkapan yang tidak kelihatan kepada responden."
// expression.description: "Type an expression subtitle." => "Taipkan sari kata ungkapan."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Ungkapan boleh termasuk pengiraan asas ('{q1_id} + {q2_id}'), syarat ('{age} > 60'), dan fungsi ('iif()', 'hari ini()', 'umur()', 'min()', 'max()', 'pur()', dll.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Pilih untuk menyimpan nilai pilihan \"Lain-lain\" sebagai harta berasingan dalam hasil tinjauan."
// p.swapOrder: "Swap the order of Yes and No" => "Tukar pesanan Ya dan Tidak"
// p.itemTitleWidth: "Item label width (in px)" => "Lebar label item (dalam piksel)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Teks untuk ditunjukkan jika semua opsyen dipilih"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Teks ruang letak untuk kawasan penarafan"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Lengkapkan tinjauan secara automatik"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Pilih jika anda mahu tinjauan selesai secara automatik selepas responden menjawab semua soalan."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Simpan nilai bertopeng dalam hasil tinjauan"
// patternmask.pattern: "Value pattern" => "Corak nilai"
// datetimemask.min: "Minimum value" => "Nilai minimum"
// datetimemask.max: "Maximum value" => "Nilai maksimum"
// numericmask.allowNegativeValues: "Allow negative values" => "Benarkan nilai negatif"
// numericmask.thousandsSeparator: "Thousands separator" => "Pemisah beribu-ribu"
// numericmask.decimalSeparator: "Decimal separator" => "Pemisah perpuluhan"
// numericmask.precision: "Value precision" => "Ketepatan nilai"
// numericmask.min: "Minimum value" => "Nilai minimum"
// numericmask.max: "Maximum value" => "Nilai maksimum"
// currencymask.prefix: "Currency prefix" => "Awalan mata wang"
// currencymask.suffix: "Currency suffix" => "Akhiran mata wang"
// pe.maskType: "Input mask type" => "Input jenis topeng"
// maskTypes.patternmask: "Pattern" => "Corak"
// maskTypes.numericmask: "Numeric" => "Angka"
// maskTypes.datetimemask: "Date and Time" => "Tarikh dan Masa"
// maskTypes.currencymask: "Currency" => "Mata wang"
// tabs.mask: "Input Mask Settings" => "Seting Topeng Input"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Ex.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Ex.: mm/dd/yyyy"
// pe.currencyprefix_placeholder: "Ex.: $" => "Ex.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Ex.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Pilihan balut"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Teks panjang dalam pilihan pilihan akan menjana pemisah baris secara automatik agar muat dalam menu lungsur. Nyahpilih jika anda mahu teks klip."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Pilih jika anda ingin menyimpan nilai soalan dengan topeng yang digunakan dalam hasil tinjauan."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Corak boleh mengandungi literal rentetan dan ruang letak berikut: '9' - untuk digit; 'a' - untuk huruf besar atau kecil; '#' - untuk digit atau huruf besar atau huruf kecil. Gunakan tindak balas '\\' untuk melarikan diri daripada watak."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Corak boleh mengandungi aksara pemisah dan ruang letak berikut: 'm' - untuk nombor bulan; 'mm' - untuk nombor bulan, dengan sifar utama untuk nilai satu digit; 'd' - untuk hari dalam bulan; 'dd' - untuk hari dalam bulan, dengan sifar utama untuk nilai satu digit; 'yy' - untuk dua digit terakhir tahun ini; 'yyyy' - untuk tahun empat angka."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Simbol yang digunakan untuk memisahkan bahagian pecahan daripada bahagian integer bagi nombor yang dipaparkan."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Simbol yang digunakan untuk memisahkan digit nombor besar ke dalam kumpulan tiga."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Hadkan bilangan digit untuk dikekalkan selepas titik perpuluhan bagi nombor yang dipaparkan."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Satu atau beberapa simbol yang akan dipaparkan sebelum nilai."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Satu atau beberapa simbol yang akan dipaparkan selepas nilai."
// ed.translationSource: "Source: " => "Sumber: "
// ed.translationTarget: "Target: " => "Sasaran: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Halaman kosong. Seret elemen dari kotak alat atau klik butang di bawah."
// maskTypes.none: "None" => "Tiada"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Jadikan baris kelihatan jika"
// itemvalue@rows.enableIf: "Make the row editable if" => "Jadikan baris boleh diedit jika"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Teks ruang letak dalam mod baca sahaja atau pratonton"
// pe.textWrapEnabled: "Wrap choices" => "Pilihan balut"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Pilihan \"Auto\" secara automatik menentukan mod yang sesuai untuk paparan - Imej, Video atau YouTube - berdasarkan URL sumber yang disediakan."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Pilih antara \"Imej\" dan \"Video\" untuk menetapkan mod kandungan pemilih media. Jika \"Imej\" dipilih, pastikan semua pilihan yang disediakan adalah fail imej dalam format berikut: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Begitu juga, jika \"Video\" dipilih, pastikan semua pilihan adalah pautan langsung ke fail video dalam format berikut: MP4, MOV, WMV, FLV, AVI, MKV. Sila ambil perhatian bahawa pautan YouTube tidak disokong untuk pilihan video."
// ed.selectFile: "Select a file" => "Pilih fail"
// ed.removeFile: "Remove the file" => "Mengalih keluar fail"
// pe.searchMode: "Search Mode" => "Mod Carian"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Klik butang \"Tambah Soalan\" di bawah untuk mula membuat borang anda."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Klik butang \"Tambah Soalan\" di bawah untuk menambah elemen baru ke halaman."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Klik butang \"Tambah Soalan\" di bawah untuk menambah elemen baru ke panel."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Klik butang di bawah dan pilih imej untuk dimuat naik"
// coloralpha.opacity: "Opacity" => "Kelegapan"
// font.family: "Font family" => "Keluarga fon"
// font.color: "Color" => "Warna"
// font.placeholderColor: "Placeholder color" => "Warna ruang letak"
// font.size: "Size" => "Saiz"
// theme.themeName: "Theme" => "Tema"
// theme.isPanelless: "Question appearance" => "Penampilan soalan"
// theme.editorPanel: "Background and corner radius" => "Latar belakang dan jejari sudut"
// theme.questionPanel: "Background and corner radius" => "Latar belakang dan jejari sudut"
// theme.primaryColor: "Accent color" => "Warna aksen"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Kelegapan latar belakang panel"
// theme.questionBackgroundTransparency: "Question background opacity" => "Kelegapan latar belakang soalan"
// theme.fontSize: "Font size" => "Saiz fon"
// theme.scale: "Scale" => "Skala"
// theme.cornerRadius: "Corner radius" => "Jejari penjuru"
// theme.pageTitle: "Title font" => "Fon tajuk"
// theme.pageDescription: "Description font" => "Fon perihalan"
// theme.questionTitle: "Title font" => "Fon tajuk"
// theme.questionDescription: "Description font" => "Fon perihalan"
// theme.editorFont: "Font" => "Fon"
// theme.backgroundOpacity: "Opacity" => "Kelegapan"
// theme.--sjs-font-family: "Font family" => "Keluarga fon"
// theme.--sjs-general-backcolor-dim: "Background color" => "Warna latar belakang"
// theme.--sjs-primary-backcolor: "Accent background" => "Latar belakang aksen"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Aksen latar depan"
// theme.--sjs-shadow-small: "Shadow effects" => "Kesan bayang"
// theme.--sjs-shadow-inner: "Shadow effects" => "Kesan bayang"
// theme.--sjs-border-default: "Colors" => "Warna"
// header@header.headerView: "View" => "Lihat"
// header@header.logoPosition: "Logo position" => "Kedudukan logo"
// header@header.surveyTitle: "Survey title font" => "Fon tajuk tinjauan"
// header@header.surveyDescription: "Survey description font" => "Fon perihalan tinjauan"
// header@header.headerTitle: "Survey title font" => "Fon tajuk tinjauan"
// header@header.headerDescription: "Survey description font" => "Fon perihalan tinjauan"
// header@header.inheritWidthFrom: "Content area width" => "Lebar kawasan kandungan"
// header@header.textAreaWidth: "Text width" => "Lebar teks"
// header@header.backgroundColorSwitch: "Background color" => "Warna latar belakang"
// header@header.backgroundImage: "Background image" => "Imej latar belakang"
// header@header.backgroundImageOpacity: "Opacity" => "Kelegapan"
// header@header.overlapEnabled: "Overlap" => "Bertindih"
// header@header.logoPositionX: "Logo position" => "Kedudukan logo"
// header@header.titlePositionX: "Title position" => "Kedudukan tajuk"
// header@header.descriptionPositionX: "Description position" => "Kedudukan perihalan"
// weight.400: "Regular" => "Tetap"
// weight.600: "Heavy" => "Berat"
// weight.700: "Semi-bold" => "Separa berani"
// weight.800: "Bold" => "Berani"
// backgroundImageFit.auto: "Auto" => "Auto"
// backgroundImageFit.cover: "Cover" => "Perlindungan"
// backgroundImageFit.contain: "Contain" => "Mengandungi"
// backgroundImageFit.fill: "Stretch" => "Regangan"
// backgroundImageFit.tile: "Tile" => "Jubin"
// backgroundImageAttachment.fixed: "Fixed" => "Tetap"
// backgroundImageAttachment.scroll: "Scroll" => "Tatal"
// headerView.basic: "Basic" => "Asas"
// headerView.advanced: "Advanced" => "Lanjutan"
// inheritWidthFrom.survey: "Same as survey" => "Sama seperti tinjauan"
// inheritWidthFrom.container: "Fit to container" => "Muat ke bekas"
// backgroundColorSwitch.none: "None" => "Tiada"
// backgroundColorSwitch.accentColor: "Accent color" => "Warna aksen"
// backgroundColorSwitch.custom: "Custom" => "Tersuai"
// colorPalette.light: "Light" => "Cahaya"
// colorPalette.dark: "Dark" => "Gelap"
// isPanelless.false: "Default" => "Lalai"
// isPanelless.true: "Without Panels" => "Tanpa Panel"
// theme.cornerRadius: "Corner radius" => "Jejari penjuru"
// theme.fontFamily: "Font family" => "Keluarga fon"
// theme.fontWeightRegular: "Regular" => "Tetap"
// theme.fontWeightHeavy: "Heavy" => "Berat"
// theme.fontWeightSemiBold: "Semi-bold" => "Separa berani"
// theme.fontWeightBold: "Bold" => "Berani"
// theme.color: "Color" => "Warna"
// theme.placeholderColor: "Placeholder color" => "Warna ruang letak"
// theme.size: "Size" => "Saiz"
// theme.opacity: "Opacity" => "Kelegapan"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Taip untuk mencari..."
// ed.toolboxNoResultsFound: "No results found" => "Tiada keputusan ditemui"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Ruang letak tajuk tab"
// theme.--sjs-special-red: "Error messages" => "Mesej ralat"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Teks sandaran untuk tajuk tab yang digunakan apabila corak tajuk tab tidak menghasilkan nilai yang bermakna."
// theme.fontColor: "Font color" => "Warna fon"
// theme.backgroundColor: "Background color" => "Warna latar belakang"
// pe.questionTitleWidth: "Question title width" => "Lebar tajuk soalan"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Pilih fail atau tampal pautan fail..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Ex.: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Menetapkan lebar yang konsisten untuk tajuk soalan apabila ia dijajarkan di sebelah kiri kotak soalan mereka. Menerima nilai CSS (px, %, dalam, pt, dll.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Menetapkan lebar yang konsisten untuk tajuk soalan apabila ia dijajarkan di sebelah kiri kotak soalan mereka. Menerima nilai CSS (px, %, dalam, pt, dll.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Komen ketinggian kawasan (dalam garisan)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Mengesetkan bilangan baris yang dipaparkan dalam kawasan teks untuk komen soalan. Dalam input mengambil lebih banyak baris, bar skrol muncul."


/***/ }),

/***/ "./src/localization/mongolian.ts":
/*!***************************************!*\
  !*** ./src/localization/mongolian.ts ***!
  \***************************************/
/*! exports provided: mnStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mnStrings", function() { return mnStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var mnStrings = {
    // survey templates
    survey: {
        edit: "Засах",
        externalHelpLink: "Санал асуулга үүсгэх заавартай танилцах",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Хэрэглүүрээс асуулт нэмнэ үү",
        addLogicItem: "Санал асуулгын урсгалыг өөрчлөх дүрэм үүсгэнэ үү.",
        copy: "Хуулах",
        duplicate: "Хуулбарлах",
        addToToolbox: "Хэрэглүүрт нэмэх",
        deletePanel: "Панел устгах",
        deleteQuestion: "Асуулт устгах",
        convertTo: "Хувиргах",
        drag: "Чирэх",
    },
    // Creator tabs
    tabs: {
        preview: "Урьдчилан харах",
        theme: "Сэдвүүд",
        translation: "Орчуулга",
        designer: "Удирдлага",
        editor: "JSON засварлагч",
        logic: "Логик"
    },
    // Question types
    qt: {
        default: "Нэг сонголттой",
        checkbox: "Олон сонголттой",
        comment: "Нээлттэй",
        imagepicker: "Зураг сонгох",
        ranking: "Дэс дараалалд оруулах",
        image: "Зураг",
        dropdown: "Сонголттой асуумж",
        tagbox: "Tag Box",
        file: "Файл",
        html: "HTML",
        matrix: "Нэг сонголттот матриц",
        matrixdropdown: "Олон сонголтот матриц",
        matrixdynamic: "Динамик матриц",
        multipletext: "Олон бичилт",
        panel: "Панел",
        paneldynamic: "Динамик панел",
        radiogroup: "Radiogroup",
        rating: "Үнэлэх",
        text: "Богино хариулттай ",
        boolean: "Тийм/Үгүй",
        expression: "Илэрхийлэл (зөвхөн унших)",
        signaturepad: "Гарын үсэг",
        buttongroup: "Багц товч"
    },
    toolboxCategories: {
        general: "Ерөнхий",
        choice: "Сонголттой асуултууд",
        text: "Хариулт бичих асуултууд",
        containers: "Сав",
        matrix: "Матрицан асуултууд",
        misc: "Бусад"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Үндсэн ({0})",
        survey: "Санал асуулга",
        settings: "Тохиргоо",
        settingsTooltip: "Тохиргоог нээх",
        surveySettings: "Санал асуулгын тохиргоо",
        surveySettingsTooltip: "Судалгааны тохиргоо",
        themeSettings: "Сэдвийн тохиргоо",
        themeSettingsTooltip: "Сэдвийн тохиргоо",
        showPanel: "Панел харуулах",
        hidePanel: "Панел нуух",
        prevSelected: "Өмнөхийг сонгох",
        nextSelected: "Дараагийнхыг сонгох",
        prevFocus: "Өмнөх анхаарлаа төвлөрүүлэх",
        nextFocus: "Дараа нь анхаарлаа төвлөрүүл",
        surveyTypeName: "Санал асуулга",
        pageTypeName: "Хуудас",
        panelTypeName: "Панел",
        questionTypeName: "Асуулт",
        columnTypeName: "Багана",
        addNewPage: "Шинэ хуудас нэмэх",
        moveRight: "Баруун тийш гүйлгэх",
        moveLeft: "Зүүн тийш гүйлгэх",
        deletePage: "Хуудас устгах",
        editPage: "Хуудас засварлах",
        edit: "Засах",
        newPageName: "Хуудас",
        newQuestionName: "Асуулт",
        newPanelName: "Панелийн нэр",
        newTextItemName: "Текст",
        defaultV2Theme: "Үндсэн",
        modernTheme: "Орчийн үеийн",
        defaultTheme: "Үндсэн (legacy)",
        testSurveyAgain: "Санал асуулгыг дахин урьдчилан харах",
        testSurveyWidth: "Санал асуулгын өргөн: ",
        navigateToMsg: "You had to navigate to",
        saveSurvey: "Санал асуулга хадгалах",
        saveSurveyTooltip: "Санал асуулга хадгалах",
        saveTheme: "Сэдэв хадгалах",
        saveThemeTooltip: "Сэдэв хадгалах",
        jsonHideErrors: "Алдааг нуух",
        jsonShowErrors: "Алдааг харуулах",
        undo: "Буцаах",
        redo: "Дахих",
        undoTooltip: "Сүүлийн өөрчлөлтийг буцаах",
        redoTooltip: "Сүүлин өөрчлөлтийг дахих ",
        showMoreChoices: "Дэлгэрэнгүй харуулах",
        showLessChoices: "Бага мэдээлэл харуулах",
        copy: "Хуулах",
        cut: "Таслах",
        paste: "Буулгах",
        copyTooltip: "Самбараас сонгогдсон хэсгийг хуулах",
        cutTooltip: "Самбараас сонгогдсон хэсгийг таслах",
        pasteTooltip: "Самбараас буулгах",
        options: "Тохиргоо",
        generateValidJSON: "Бодит JSON үүсгэх",
        generateReadableJSON: "Ойлгомжтой JSON үүсгэх",
        toolbox: "Хэрэглүүр",
        "property-grid": "Өмнөх",
        toolboxFilteredTextPlaceholder: "Хайлт хийх төрөл...",
        toolboxNoResultsFound: "Ямар ч үр дүн олдсонгүй",
        propertyGridFilteredTextPlaceholder: "Хайхын тулд бичнэ үү.....",
        propertyGridNoResultsFound: "Ямар ч үр дүн олдсонгүй",
        correctJSON: "JSON засна уу.",
        surveyResults: "Санал асуулгын хариу",
        surveyResultsTable: "Санал асуулгын хариултыг хүснэгтээр харуулах",
        surveyResultsJson: "As JSON",
        resultsTitle: "Асуултын гарчиг",
        resultsName: "Асуултын нэр",
        resultsValue: "Хариултын утга",
        resultsDisplayValue: "Утга харуулах",
        modified: "Өөрчлөлт орсон",
        saving: "Хадгалж байна",
        saved: "Хадгалсан",
        propertyEditorError: "Алдаа",
        saveError: "Алдаа! Зассан агуулга хадгалагдаагүй байна.",
        translationPropertyGridTitle: "Хэлний тохиргоо",
        themePropertyGridTitle: "Сэдвийн тохиргоо",
        translationLanguages: "Хэл",
        translationDeleteLanguage: "Та энэ хэлний бүх уяаг арилгахыг хүсэж байгаа гэдэгтээ итгэлтэй байна уу?",
        translationAddLanguage: "Орчуулах хэлийг сонгоно уу",
        translationShowAllStrings: "Бүх текст",
        translationShowUsedStringsOnly: "Зөвхөн байгаа текстүүд",
        translationShowAllPages: "Бүх хуудас",
        translationNoStrings: "Орчуулах зүйл байхгүй. Шүүлтийг өөрчилнө үү.",
        translationExportToSCVButton: "CSV экспорт хийх",
        translationImportFromSCVButton: "CSV импорт хийх",
        translateUsigAI: "Авто-орчуулга Бүгд",
        translateUsigAIFrom: "Аас орчуул: ",
        translationDialogTitle: "Огт орчуулагдаагүй уяанууд",
        translationMergeLocaleWithDefault: "{0}-г суурь хэлтэй нэгтгэх",
        translationPlaceHolder: "Орчуулга...",
        translationSource: "Эх сурвалж: ",
        translationTarget: "Зорилго: ",
        themeExportButton: "Экспорт",
        themeImportButton: "Импорт",
        surveyJsonExportButton: "Экспорт",
        surveyJsonImportButton: "Импорт",
        surveyJsonCopyButton: "Хавчуургыг хуулах",
        themeResetButton: "Дахин сэдэвчилсэн тохиргоог default хийх",
        themeResetConfirmation: "Та сэдвийг дахин хөндөхийг үнэхээр хүсэж байна уу? Таны бүх тохируулга үгүй болно.",
        themeResetConfirmationOk: "Тийм ээ, сэдвийг дахин тохируулах",
        bold: "Тод",
        italic: "Налуу",
        underline: "Доогуур зураас",
        addNewQuestion: "Асуулт нэмэх",
        selectPage: "Хуудас сонгох...",
        carryForwardChoicesCopied: "Сонголтыг хуулбарладаг",
        choicesLoadedFromWebText: "Сонголтыг вэбийн үйлчилгээнээс ачаалдаг.",
        choicesLoadedFromWebLinkText: "Тохиргоо руу явах",
        choicesLoadedFromWebPreviewTitle: "Ачаалагдсан сонголтын урьдчилсан үзүүлэлт",
        htmlPlaceHolder: "HTML агуулга энд байрлана.",
        panelPlaceHolder: "Энд хэрэглүүрээс асуулт чирнэ үү.",
        surveyPlaceHolder: "Санал асуулга хоосон байна. Хэрэглүүрээс асуулт чирнэ үү эсвэл доорх товчийг дарна уу.",
        pagePlaceHolder: "Хуудас хоосон байна. Багажны хайрцагнаас элементийг чирэх эсвэл доорх товчийг дарна уу.",
        imagePlaceHolder: "Энд зураг чирж унагаах эсвэл доорх товчийг дарж татаж авах зургийг сонгоно уу",
        surveyPlaceHolderMobile: "Доорх \"Асуулт нэмэх\" товчийг дарж формоо үүсгэж эхэлнэ.",
        pagePlaceHolderMobile: "Хуудас дээр шинэ элемент нэмэхийн тулд доорх \"Асуулт нэмэх\" товчийг дарна уу.",
        panelPlaceHolderMobile: "Доорх \"Асуулт нэмэх\" товчийг дарж панел дээр шинэ элемент нэмнэ.",
        imagePlaceHolderMobile: "Доорх товчийг дарж татаж авах зургийг сонгоно уу",
        imageChooseImage: "Зураг сонгох",
        addNewTypeQuestion: "{0} нэмэх",
        chooseLogoPlaceholder: "[Лого]",
        choices_Item: "Хэсэг ",
        selectFile: "Файлыг сонгох",
        removeFile: "Файлыг хасах",
        lg: {
            addNewItem: "Шинэ дүрэм нэмэх",
            empty_tab: "Санал асуулгын урсгалыг өөрчлөх дүрэм үүсгэнэ үү.",
            page_visibilityName: "Хуудас харуулах (нуух)",
            page_enableName: "Хуудас идэвхжүүлэх (идэвхгүй болгох)",
            page_requireName: "Шаардлагатай хуудас хийх",
            panel_visibilityName: "Панел (нуух) харуулах",
            panel_enableName: "Панел (идэвхгүй болгох) идэвхжүүлэх",
            panel_requireName: "Шаардлагатай хуудас хийх",
            question_visibilityName: "Асуулт харуулах (нуух)",
            question_enableName: "Асуулт идэвхжүүлэх (идэвхгүй болгох)",
            question_requireName: "Асуултыг заавал бөглөөөөх болгох",
            question_resetValueName: "Асуултын үнэ цэнийг дахин тогтоох",
            question_setValueName: "Асуултын үнэ цэнийг тогтоох",
            column_visibilityName: "Багана харуулах (нуух).",
            column_enableName: "Багана идэвхжүүлэх (идэвхгүй болгох).",
            column_requireName: "Баганыг заавал бөглөөөөх болгох",
            column_resetValueName: "Reset баганын үнэ цэнэ",
            column_setValueName: "Баганын үнэ цэнийг тогтоох",
            trigger_completeName: "Санал асуулга дуусгах",
            trigger_setvalueName: "Хариулт оруулах",
            trigger_copyvalueName: "Хариулт хуулах",
            trigger_skipName: "Асуулт руу алгасах",
            trigger_runExpressionName: "Илэрхийллийг ажиллуулах",
            completedHtmlOnConditionName: "\"Санал асуулга амжилттай бөглөгдсөн\" хуудсын тэмдэглэгээг оруулах",
            page_visibilityDescription: "Логик илэрхийлэл биелэгдсэн тохиолдолд хуудсыг харуулах. Бусад үед нуух.",
            panel_visibilityDescription: "Логик илэрхийлэл биелэгдсэн тохиолдолд панелийг харуулах. Бусад үед нуух.",
            panel_enableDescription: "Логик илэрхийлэл биелэгдсэн тохиолдолд панел ба түүн доторх бүх элементийг идэвхжүүлэх. Бусад үед бүгдийг идэвхгүй байлгах.",
            question_visibilityDescription: "Логик илэрхийлэл биелэгдсэн тохиолдолд асуултыг харуулах. Бусад үед нуух.",
            question_enableDescription: "Логик илэрхийлэл биелэгдсэн тохиолдолд хуудсыг идэвхжүүлэх. Бусад үед идэвхгүй болгох.",
            question_requireDescription: "Логик илэрхийлэл биелэгдсэн тохиолдолд асуулт нь заавал бөглөх болох.",
            trigger_completeDescription: "Логик илэрхийлэл биелэгдсэн тохиолдолд санал асуулга амжилттай бөглөн хэрэглэгч 'Баярлалаа' хуудсыг харна.",
            trigger_setvalueDescription: "Логик илэрхийлэл биелэгдсэн тохиолдолд сонгосон асуултын утгыг тохируулна.",
            trigger_copyvalueDescription: "Логик илэрхийлэл биелэгдсэн тохиолдолд сонгосон асуултын утгыг өөр сонгосон асуултын хариулт болгон харуулна.",
            trigger_skipDescription: "Логик илэрхийлэл биелэгдсэн тохиолдолд санал асуулга сонгосон асуултыг алгасна / харуулна.",
            trigger_runExpressionDescription: "Логик илэрхийлэл биелэгдсэн тохиолдолд хэрэглэгчийн илэрхийллийг ажиллуулна. Та энэ илэрхийллийн үр дүнг  сонгосон асуултын хариулт болгоно.",
            completedHtmlOnConditionDescription: "Хэрэв логик илэрхийлэл биелэгдсэн тохиолдолд үндсэн 'Баярлалаа' хуудас зааж өгсөн хуудсаар солигдоно.",
            itemExpressionText: "Илэрхийлэл: '{0}' биелсэн бол",
            itemEmptyExpressionText: "Шинэ дүрэм",
            page_visibilityText: "Хуудсыг {0} харагддаг болгох",
            panel_visibilityText: "{0} панелийг харагддаг болгох",
            panel_enableText: "{0} панелийг идэвхжүүлэх",
            question_visibilityText: "{0} асуултыг харагддаг болгох",
            question_enableText: "{0} асуултыг идэвхжүүлэх",
            question_requireText: "{0} асуултыг заавал бөглөх болгох",
            question_resetValueText: "асуултын үнэ цэнийг дахин тогтоох нь: {0}",
            question_setValueText: "үнэ цэнийг даалгах нь: {1} асуулт: {0}",
            column_visibilityText: "{0} баганын {1} асуултыг харагддаг болгох",
            column_enableText: "{0} баганын {1} асуултыг идэвхжүүлэх",
            column_requireText: "{0} баганын {1} асуултыг заавал бөглөх болгох",
            column_resetValueText: "баганын эсийн үнэ цэнийг дахин тогтоох: {0}",
            column_setValueText: "эсийн үнэ цэнийг хуваарил: {1} багана: {0}",
            setValueExpressionPlaceholder: " Үр дүн нь ямар байгааг байгсад асуултад хариулах илэрхийлэл.",
            trigger_completeText: "Санал асуулга амжилттай бөглөсөн.",
            trigger_setvalueText: "{0} Асуултад оруулах утга: {1}",
            trigger_setvalueEmptyText: "тодорхой асуултын үнэ цэнэ: {0}",
            trigger_copyvalueText: "{0} Асуулт руу хуулах утга: {1}",
            trigger_skipText: "{0} Санал асуулгын асуулт руу үсрэх",
            trigger_runExpressionText1: "'{0}' илэрхийлэлг ажиллуулах: ",
            trigger_runExpressionText2: " Түүний хариултыг асуултад оруулах: {0}",
            completedHtmlOnConditionText: "'Баярлалаа' хуудсанд тусгай текст харуулах.",
            showAllQuestions: "Бүх асуулт",
            showAllActionTypes: "Бүх үйлдлийн төрлүүд",
            conditions: "Нөхцөл(үүд)",
            actions: "Үйлдэл(үүд)",
            expressionEditorTitle: "Нөхцөл(үүд) тодорхойлох",
            actionsEditorTitle: "Үйлдэл(үүд) тодорхойлох",
            deleteAction: "Үйлдлийг устгах",
            addNewAction: "Үйлдэл нэмэх",
            selectedActionCaption: "Үйлдэл сонгох...",
            expressionInvalid: "Логик илэрхийлэл хоосон эсвэл алдаатай байна. Засна уу.",
            noActionError: "Ядаж нэг үйлдэл оруулна уу.",
            actionInvalid: "Үйлдэл(үүд)-ийнхээ асуудлыг шийднэ үү.",
            uncompletedRule_title: "Табыг орхих уу?",
            uncompletedRule_text: "Нэг эсвэл олон логик дүрэм дутуу бичигдсэн байна. Табыг хаавал, оруулсан засварууд арилна. Та табыг хаахдаа итгэлтэй байна уу?",
            uncompletedRule_apply: "Тийм",
            uncompletedRule_cancel: "Үгүй, дүрмийг үргэлжлүүлж бичиж дуусгах."
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Панелийн нэр",
            title: "Панел цол",
            description: "Панел дүрслэл",
            visibleIf: "Хэрэв панелыг ил гаргах",
            requiredIf: "Шаардлагатай бол панел хий",
            questionsOrder: "Хяналтын шатны доторх асуултын дараалал",
            page: "Эх хуудас",
            startWithNewLine: "Самбарыг шинэ шугам дээр үзүүл",
            state: "Панел нурах байдал",
            width: "Инлин хавтан өргөн",
            minWidth: "Хамгийн бага хавтан өргөн",
            maxWidth: "Хамгийн их хавтан өргөн",
            showNumber: "Тооны тавиур"
        },
        paneldynamic: {
            name: "Панелийн нэр",
            title: "Панел цол",
            description: "Панел дүрслэл",
            visibleIf: "Хэрэв панелыг ил гаргах",
            requiredIf: "Шаардлагатай бол панел хий",
            page: "Самбарыг хуудас руу зөөх",
            startWithNewLine: "Самбарыг шинэ шугам дээр үзүүл",
            state: "Панел нурах байдал",
            width: "Инлин хавтан өргөн",
            minWidth: "Хамгийн бага хавтан өргөн",
            maxWidth: "Хамгийн их хавтан өргөн",
            confirmDelete: "Панел устгахыг батлах",
            templateDescription: "Панел дүрслэлийн загвар",
            templateTitle: "Панелийн нэрийн загвар",
            noEntriesText: "Хоосон хавтан текст",
            templateTabTitle: "Таб нэрийн загвар",
            tabTitlePlaceholder: "Таб нэрийн хуудас эзэмшигч",
            templateVisibleIf: "Хувь хүний панелыг ил гаргах",
            hideNumber: "Хавтангийн дугаарыг нуух",
            titleLocation: "Панел цолны зохицуулалт",
            descriptionLocation: "Панел дүрслэлийн зохицуулалт",
            templateTitleLocation: "Асуулт нэрийн уялдаа",
            templateErrorLocation: "Алдааны мессежийн зохицуулалт",
            newPanelPosition: "Шинэ панелийн байршил",
            keyName: "Дараах асуултад хувилж хариулахаас сэргийлье"
        },
        question: {
            name: "Асуулт нэр",
            title: "Асуулт гарчиг",
            description: "Асуултын тодорхойлолт",
            visibleIf: "Асуултыг ил тод болгох",
            requiredIf: "Шаардлагатай асуултыг тавих",
            page: "Эх хуудас",
            state: "Асуултын хайрцаг нурах байдал",
            hideNumber: "Асуултын дугаарыг нуух",
            titleLocation: "Асуулт нэрийн уялдаа",
            descriptionLocation: "Асуулт тодорхойлолтын зохицуулалт",
            errorLocation: "Алдааны мессежийн зохицуулалт",
            indent: "Дотоод индентийг нэмэгдүүлэх",
            width: "Инлайн асуултын өргөн",
            minWidth: "Хамгийн бага асуултын өргөн",
            maxWidth: "Хамгийн их асуултын өргөн",
            textUpdateMode: "Оролтын талбайн үнэ цэнийг шинэчлэх"
        },
        signaturepad: {
            signatureWidth: "Гарын үсэг зурах хэсгийн өргөн",
            signatureHeight: "Гарын үсэг зурах хэсгийн өндөр",
            signatureAutoScaleEnabled: "Авто замын тэмдэг тэмдэглэгээний талбай",
            showPlaceholder: "Эзэмшигчийг үзүүл",
            placeholder: "Placeholder текст",
            placeholderReadOnly: "Зөвхөн унших эсвэл урьдчилан харах хэлбэрээр placeholder текст",
            allowClear: "Гарын үсэг зурах хэсэгт Clear товчийг харуул",
            penMinWidth: "Хамгийн бага үзэгний өргөн",
            penMaxWidth: "Хамгийн их үзэгний өргөн",
            penColor: "Судасны өнгө"
        },
        comment: {
            rows: "Оролтын талбайн өндөр (шугамд)"
        },
        showQuestionNumbers: "Асуултын дугаарлалт",
        questionStartIndex: "Эхлэх индекс (тоо эсвэл үсэг)",
        expression: {
            name: "Илэрхийллийн нэр",
            title: "Өгүүлбэрийн гарчиг",
            description: "Илэрхийллийн тодорхойлолт",
            expression: "Өгүүлбэр"
        },
        trigger: {
            expression: "Өгүүлбэр"
        },
        calculatedvalue: {
            expression: "Өгүүлбэр"
        },
        // survey templates
        survey: {
            title: "Нүүр",
            description: "Судалгааны тодорхойлолт"
        },
        page: {
            name: "Хуудасны нэр",
            title: "Нүүр",
            description: "Хуудасны тодорхойлолт",
            visibleIf: "Хуудсыг ил тод болгох",
            requiredIf: "Шаардлагатай хуудсыг хий",
            maxTimeToFinish: "Нэг хуудас бөглөж дуусах хугацаа (секундээр)",
            questionsOrder: "Асуулт самбар хуудсан дээр"
        },
        matrixdropdowncolumn: {
            name: "Баганын нэр",
            title: "Баганын нэр",
            isUnique: "Хуулбарласан хариу үйлдэл үзүүлэхээс сэргийлье",
            width: "Баганын өргөн",
            minWidth: "Баганын хамгийн бага өргөн",
            rows: "Оролтын талбайн өндөр (шугамд)",
            visibleIf: "Хэрэв баганыг харах боломжтой болго",
            requiredIf: "Шаардлагатай баганыг хий",
            showInMultipleColumns: "Тус тусдаа баганад байгаа сонголт бүр"
        },
        multipletextitem: {
            name: "Нэр",
            title: "Нүүр"
        },
        masksettings: {
            saveMaskedValue: "Судалгааны үр дүнд багласан үнэ цэнийг хэмнэх"
        },
        patternmask: {
            pattern: "Үнэ цэнийн загвар"
        },
        datetimemask: {
            min: "Хамгийн бага үнэ цэнэ",
            max: "Хамгийн их үнэ цэнэ"
        },
        numericmask: {
            allowNegativeValues: "Сөрөг үнэт зүйлсийг зөвшөөр",
            thousandsSeparator: "Мянга мянган тусгаарлагч",
            decimalSeparator: "Decimal тусгаарлагч",
            precision: "Үнэ цэнийн нарийвчлал",
            min: "Хамгийн бага үнэ цэнэ",
            max: "Хамгийн их үнэ цэнэ"
        },
        currencymask: {
            prefix: "Валютын ханш",
            suffix: "Валютын suffix"
        },
        imageHeight: "Зургийн өндөр",
        imageWidth: "Зургийн өргөн",
        valueName: "Хариултыг дараагийн JSON талбарт хадгалах",
        rateDescriptionLocation: "Шошгоны зохицл",
        size: "Оролтын хэмжээ (тэмдэгтээр)",
        cellErrorLocation: "Эсийн алдааны мессежийн зохицуулалт",
        apply: "Хэрэгжүүл",
        ok: "OK",
        save: "Хадгалах",
        clear: "Цэвэрлэх",
        saveTooltip: "Хадгалах",
        cancel: "Болих",
        set: "Тааруулах",
        reset: "Шинээр тохируулах",
        change: "Солих",
        refresh: "Шинэчлэх",
        close: "Хаах",
        delete: "Устгах",
        add: "Нэмэх",
        addNew: "Нэмэх",
        addItem: "Хэсэг нэмэх бол дарах...",
        removeItem: "Хэсэг устгах бол дарах...",
        dragItem: "Хэсгийг чирэх",
        addOther: "Бусад",
        addSelectAll: "Бүгдийг сонгох",
        addNone: "Аль нь ч биш",
        removeAll: "Бүгдийг устгах",
        edit: "Засах",
        back: "Хадгалахгүйгээр буцах",
        backTooltip: "Хадгалахгүйгээр буцах",
        saveAndBack: "Хадгалаад буцах",
        saveAndBackTooltip: "Хадгалаад буцах",
        doneEditing: "Болсон",
        editChoices: "Сонголтуудыг засах",
        showChoices: "Сонголтуудыг харуулах",
        move: "Шилжүүлэх",
        empty: "<хоосон>",
        emptyValue: "Утга хоосон байна",
        fastEntry: "Гараар оруулах",
        fastEntryNonUniqueError: "'{0}' утга давтагдаж байна!",
        fastEntryChoicesCountError: "Хэсгийг {0}-оос {1} хүртэл хязгаарлах",
        fastEntryChoicesMinCountError: "Наад зах нь {0} зүйлс оруулна уу",
        fastEntryPlaceholder: "Та дараах форматын дагуу өгөгдлийг оруулж болно:\nvalue1|text\nvalue2",
        formEntry: "Маягт оруулах",
        testService: "Үйлчилгээг турших",
        itemSelectorEmpty: "Элемент сонгоно уу",
        conditionActionEmpty: "Үйлдэл сонгоно уу",
        conditionSelectQuestion: "Асуулт сонгох...",
        conditionSelectPage: "Хуудас сонгох...",
        conditionSelectPanel: "Панел сонгох...",
        conditionValueQuestionTitle: "Утга оруулах/сонгох",
        aceEditorHelp: "ctrl+space дарж илэрхийлэл биелэгдэх сануулга харах.",
        aceEditorRowTitle: "Тухайн мөр",
        aceEditorPanelTitle: "Тухайн панел",
        showMore: "Дэлгэрэнгүй мэдээллийг баримт бичгээс авна уу.",
        assistantTitle: "Боломжтой асуултууд",
        cellsEmptyRowsColumns: "Багадаа нэг багана эсвэл мөр байх ёстой",
        showPreviewBeforeComplete: "Санал асуулга явуулхаас өмнө хариултуудыг урьдчилж харах",
        overridingPropertyPrefix: "Дэргэд нь ",
        resetToDefaultCaption: "Дахин тохируулах",
        propertyIsEmpty: "Утга оруулна уу",
        propertyIsNoUnique: "Дахин давтагдахгүй утга оруулна уу",
        propertyNameIsNotUnique: "Өөр нэр оруулна уу",
        propertyNameIsIncorrect: "\"Item\", \"монгол\", \"panel\", \"row\" гэсэн үгсийн нөөц үгийг бүү хэрэглэ.",
        listIsEmpty: "Одоогоор ямар ч зүйл ороогүй байна",
        "listIsEmpty@choices": "Одоогор ямар ч сонголт ороогүй байна",
        "listIsEmpty@columns": "Танд ямар ч багана байхгүй",
        "listIsEmpty@rows": "Чамд ямар ч мөр байхгүй",
        "listIsEmpty@validators": "Танд ямар нэгэн баталгаажуулалтын дүрэм байхгүй байна",
        "listIsEmpty@calculatedValues": "Танд ямар ч хувийн хувьсагч байхгүй",
        "listIsEmpty@triggers": "Танд ямар ч өдөөгч байхгүй",
        "listIsEmpty@navigateToUrlOnCondition": "Танд ямар ч холбоос байхгүй",
        "addNew@choices": "Сонголт оруулах",
        "addNew@columns": "Шинэ багана нэмэх",
        "addNew@rows": "Шинэ мөр нэмэх",
        "addNew@validators": "Шинэ дүрэм нэмэх",
        "addNew@calculatedValues": "Шинэ хувьсагч нэмэх",
        "addNew@triggers": "Шинэ триггер нэмэх",
        "addNew@navigateToUrlOnCondition": "Шинэ URL нэмэх",
        expressionIsEmpty: "Томъёо хоосон байна",
        value: "Утга",
        text: "Текст",
        rowid: "Мөрний ID",
        imageLink: "Зураг эсвэл видео линк",
        columnEdit: "Багана засах: {0}",
        itemEdit: "Зүйл засах: {0}",
        url: "Үйлчилгээний линк",
        path: "Үйлчилгэний хүрээнд өгөгдөлд хүрэх зам",
        choicesbyurl: {
            url: "Вэб үйлчилгээний URL",
            valueName: "Утгуудыг дарагийн JSON талбараас авах"
        },
        titleName: "Үзүүлэн текстүүдийг дараагийн JSON талбараас авах",
        imageLinkName: "Зургийн линкийг дараагийн JSON талбараас",
        allowEmptyResponse: "Хоосон хариулт зөвшөөрөх",
        titlePlaceholder: "Гарчиг",
        surveyTitlePlaceholder: "Санал асуулгын гарчиг",
        pageTitlePlaceholder: "Хуудас {num}",
        descriptionPlaceholder: "Тайлбар",
        surveyDescriptionPlaceholder: "Тайлбар",
        pageDescriptionPlaceholder: "Тайлбар",
        textWrapEnabled: "Боолт сонголт",
        showOtherItem: "Өөр сонголт зөвшөөрөх",
        otherText: "Өөр сонголтын текст",
        showNoneItem: "None сонголтыг зөвшөөрөх",
        showRefuseItem: "Хариулах татгалзах боломжийг олго",
        showDontKnowItem: "Бүү мэд сонголтыг зөвшөөр",
        noneText: "None сонголтын текст",
        showSelectAllItem: "Бүгдийг сонгохыг зөвшөөрөх",
        selectAllText: "Бүгдийг сонгох",
        choicesMin: "Автоматаар үүсэх элементийн хамгийн бага утга",
        choicesMax: "Автоматаар үүсэх элементийн хамгийн их утга",
        choicesStep: "Автоматаар үүсэх элементийн алхам",
        name: "Нэр",
        title: "Гарчиг",
        cellType: "Нүдний төрөл",
        colCount: "Баганы тоо",
        choicesOrder: "Сонголтыг эрэмбэлэх дараалал",
        visible: "Харагдана",
        isRequired: "Заавал бөглөх",
        markRequired: "Шаардлагын дагуу тэмдэглэгээ хийх",
        removeRequiredMark: "Шаардлагатай тэмдэглэгээг хасах",
        isAllRowRequired: "Бүх мөрөнд хариулт шаардах",
        eachRowUnique: "Дараалалд хувилж хариу үйлдэл үзүүлэхээс сэргийлнэ",
        requiredErrorText: "Заавал бөглөх талбарыг бөглөөгүй байна",
        startWithNewLine: "Асуултыг шинэ мөрөнд харуулах",
        rows: "Мөр",
        cols: "Багана",
        placeholder: "Оролтын жишээ утга",
        showPreview: "Урьдчилан харах хэсгийг харуулах",
        storeDataAsText: "JSON үр дүнд файлын агуулгыг текст хэлбэрээр хадгалах",
        maxSize: "Файлын дээд хэмжээ (байтаар)",
        rowCount: "Мөрний тоо",
        columnLayout: "Баганы зохион байгуулалт",
        addRowLocation: "Мөр нэмэх товчны байршил",
        transposeData: "Багануудад транспозын эгнээ",
        addRowText: "Мөр нэмэх",
        removeRowText: "Мөр устгах",
        rateMin: "Хамгийн бага утга",
        rateMax: "Хамгийн их утга",
        rateStep: "Алхам",
        minRateDescription: "Хамгийн бага утгын тайлбар",
        maxRateDescription: "Хамгийн их утгын тайлбар",
        inputType: "Оролтын төрөл",
        optionsCaption: "Сонголтын талбар",
        defaultValue: "Үндсэн хариулт",
        cellsDefaultRow: "Үндсэн текст",
        surveyEditorTitle: "Санал асуулгын тохиргоог засах",
        qEditorTitle: "Засах: {0}",
        maxLength: "Дээд урт (тэмдэгтээр)",
        buildExpression: "Тооцоол",
        editExpression: "Засах",
        and: "бас",
        or: "эсвэл",
        remove: "Устгах",
        addCondition: "Нөхцөл нэмэх",
        emptyLogicPopupMessage: "Нөхцөл тохируулахын тулд асуултыг сонгоно уу.",
        if: "Хэрэв",
        then: "бол",
        setToName: "Зорилтот асуулт",
        fromName: "Хариулт хуулах асуулт",
        gotoName: "Үсэрч очих асуулт",
        ruleIsNotSet: "Дүрэм буруу байна",
        includeIntoResult: "Санал асуулгын үр дүнд оруулах",
        showTitle: "Гарчиг харуулах",
        expandCollapseTitle: "Гарчиг өргөсгөх/багасгах",
        locale: "Санал асуулгын хэл",
        simulator: "Төхөөрөмжийн төрөл сонгоно уу",
        landscapeOrientation: "Хэвтээ байрлалд шилжих",
        portraitOrientation: "Босоо байрлалд шилжих",
        mode: "Засах боломжтой эсвэл зөвхөн унших",
        clearInvisibleValues: "Харагдахгүй утгыг цэвэрлэх",
        cookieName: "Cookie name",
        sendResultOnPageNext: "Хэсэгчилсэн санал асуулгын явцыг хадгалах",
        storeOthersAsComment: "Бусад утгыг тусдаа талбарт хадгалах",
        showPageTitles: "Хуудасны гарчиг харуулах",
        showPageNumbers: "Хуудасны тоо харуулах",
        pagePrevText: "Өмнөх хуудас - харагдах бичиг",
        pageNextText: "Дараагийн хуудас - харагдах бичиг",
        completeText: "Санал асуулга амжиллттай бөглөгдсөн - харагдах бичиг",
        previewText: "Хариулт урьдчилж харах - харагдах бичиг",
        editText: "Хариулт засах харагдах бичиг",
        startSurveyText: "Санал асуулга эхлэх үед харагдах бичиг",
        showNavigationButtons: "Чиглүүлгийн товчийн байрлал",
        showPrevButton: "Өмнөх хуудасны товч харуулах",
        firstPageIsStarted: "Эхлэх хуудас нь эхний хуудас байна",
        showCompletedPage: "Санал асуулга амжилттай бөглөгдсөн хуудсыг харуулах",
        goNextPageAutomatic: "Дараагийн хуудас руу автоматаар шилжих",
        allowCompleteSurveyAutomatic: "Судалгааг автоматаар дуусгах",
        showProgressBar: "Явцын мөрний байршил",
        questionTitleLocation: "Асуултын гарчгийн байршил",
        questionTitleWidth: "Асуулт нэрийн өргөн",
        requiredText: "Шаардлагатай тэмдэг(үүд)",
        questionTitleTemplate: "Асуултын гарчигны загвар, үндсэн нь: '{үгүй}. {шаардах} {гарчиг}'",
        questionErrorLocation: "Алдааны мэдэгдлийн байршил",
        focusFirstQuestionAutomatic: "Эхний асуултыг шинэ хуудсанд төвлөрүүлэх",
        questionsOrder: "Хуудас дээрх элементийн дараалал",
        maxTimeToFinish: "Санал асуулга бөглөж дуусах хугацаа (секундээр)",
        maxTimeToFinishPage: "Нэг хуудас бөглөж дуусах хугацаа (секундээр)",
        showTimerPanel: "Тоолуурын байршил",
        showTimerPanelMode: "Тоолуурын горим",
        renderMode: "Панелийн дэлгэцийн горим",
        allowAddPanel: "Панел нэмэхийг зөвшөөрөх",
        allowRemovePanel: "Панел хасахыг зөвшөөрөх",
        panelAddText: "Панел товчийн текст нэмэх",
        panelRemoveText: "Панел товчийн текст хасах",
        isSinglePage: "Бүх элементийг нэг хуудас дээр харуулах",
        html: "HTML тэмдэглэгээ",
        setValue: "Хариулт",
        dataFormat: "Зургийн формат",
        allowAddRows: "Мөр нэмэхийг зөвшөөрөх",
        allowRemoveRows: "Мөр хасахыг зөвшөөрөх",
        allowRowsDragAndDrop: "Мөр чирэхийг зөвшөөрөх",
        responsiveImageSizeHelp: "Зургийн өндөр, өргөнийг зааж өгсөн үед хамаарахгүй.",
        minImageWidth: "Зургийн өргөний хамгийн бага хэмжээ",
        maxImageWidth: "Зургийн өргөний хамгийн их хэмжээ",
        minImageHeight: "Зургийн өндрийн хамгийн бага хэмжээ",
        maxImageHeight: "Зургийн өндрийн хамгийн их хэмжээ",
        minValue: "Хамгийн бага утга",
        maxValue: "Хамгийн их утга",
        minLength: "Хамгийн бага урт (тэмдэгтээр)",
        allowDigits: "Тоо зөвшөөрөх",
        minCount: "Хамгийн бага тоо",
        maxCount: "Хамгийн их тоо",
        regex: "Тогтмол илэрхийлэл",
        surveyvalidator: {
            text: "Алдаа",
            expression: "Баталгаажуулах илэрхийлэл"
        },
        totalText: "Нийт мөр",
        totalType: "Нийт төрөл",
        totalExpression: "Нийт илэрхийлэл",
        totalDisplayStyle: "Нийт утгыг харуулах загвар",
        totalCurrency: "Мөнгөн тэмдэгт",
        totalFormat: "Хэлбэржүүлсэн текст",
        logo: "Лого (URL эсвэл base64 кодлосон мөр)",
        questionsOnPageMode: "Санал асуулгын бүтэц",
        maxTextLength: "Хариултын хамгийн их урт(тэмдэгтээр)",
        maxOthersLength: "Хариултын хамгийн бага урт(тэмдэгтээр)",
        commentAreaRows: "Тайлбар хэсгийн өндөр (мөрөнд)",
        autoGrowComment: "Шаардлагатай үед санал сэтгэгдлийн хэсгийг өргөсгөх",
        allowResizeComment: "Хэрэглэгчдэд текстийн газруудыг дахин ашиглах боломж олго",
        textUpdateMode: "Текст асуултын утгыг шинэчлэх",
        maskType: "Оролтын багны төрөл",
        maskTypes: {
            none: "Хэн ч биш",
            patternmask: "Загвар",
            numericmask: "Тоо нь",
            datetimemask: "Огноо, цаг",
            currencymask: "Валютын ханш"
        },
        focusOnFirstError: "Анхны буруу хариулт руу чиглүүлэх",
        checkErrorsMode: "Баталгаажуулалт ажиллуулах",
        navigateToUrl: "URL-рүү чиглүүлэх",
        navigateToUrlOnCondition: "Динамик URL",
        completedBeforeHtml: "Хэрэглэгч санал асуулгыг бөглөсөн байх үед харуулах тэмдэглэгээ",
        completedHtml: "Санал асуулга амжилттай бөглөгдсөн үед харуулах тэмдэглэгээ",
        completedHtmlOnCondition: "Санал асуулга амжилттай бөглөгдсөн үед харуулах динамик тэмдэглэгээ",
        loadingHtml: "Судалгааны загвар ачааллаж байх үед харуулах тэмдэглэгээ",
        commentText: "Санал сэтгэгдлийн хэсгийн текст",
        autocomplete: "Автоматаар бөглөх төрөл",
        labelTrue: "\"Тийм\" шошго",
        labelFalse: "\"Үгүй\" шошго",
        allowClear: "Цэвэрлэх товч харуулах",
        searchMode: "Хайлтын Мод",
        displayStyle: "Утга харуулах хэв маяг",
        format: "Хэлбэржүүлсэн текст",
        maximumFractionDigits: "Оронгийн нарийвчлалын дээд утга",
        minimumFractionDigits: "Оронгийн нарийвчлалын доод утга",
        useGrouping: "Бүлэг тусгаарлагчийг харуулах",
        allowMultiple: "Олон файл зөвшөөрөх",
        allowImagesPreview: "Зургуудыг урьдчилж харах",
        acceptedTypes: "Зөвшөөрөгдсөн файлын төрөл",
        waitForUpload: "Файл байршуулж дуустал хүлээх",
        needConfirmRemoveFile: "Файл устгахыг батлах",
        detailPanelMode: "Нарийвчилсан панелийн байршил",
        minRowCount: "Хамгийн бага мөрний тоо",
        maxRowCount: "Хамгийн их мөрний тоо",
        confirmDelete: "Мөр устгахыг батлах",
        confirmDeleteText: "Баталгаажуулах мессеж",
        panelCount: "Панелийн эхлэх тоо",
        minPanelCount: "Хамгийн бага панелийн тоо",
        maxPanelCount: "Хамгийн их панелийн тоо",
        panelsState: "Дотоод панелийн өргөссөн төлөв",
        panelPrevText: "Өмнөх панелийн товч",
        panelNextText: "Дараагийн панелийн товч",
        showRangeInProgress: "Явцын талбарыг харуулах",
        panelRemoveButtonLocation: "Панел устгах товчны байршил",
        hideIfRowsEmpty: "Мөр байхгүй тохиолдолд асуултыг нуух",
        hideColumnsIfEmpty: "Мөр байхгүй тохиолдолд баганыг нуух",
        rateValues: "Хэрэглэгчийн үнэлгээний утгууд",
        rateCount: "Үнэ тогтоох",
        autoGenerate: "Үнэ цэнийг хэрхэн тодорхойлох вэ?",
        hideIfChoicesEmpty: "Сонголтгүй бол асуултыг нуух",
        minWidth: "Хамгийн бага өргөн (CSS хүлээн зөвшөөрсөн утга)",
        maxWidth: "Хамгийн их өргөн (CSS хүлээн зөвшөөрсөн утга)",
        width: "Өргөн (CSS хүлээн зөвшөөрсөн утга)",
        showHeader: "Баганы гарчигийг харуулах",
        horizontalScroll: "Хэвтээ гүйлгэх мөр харуулах",
        columnMinWidth: "Баганы хамгийн бага утга (CSS хүлээн зөвшөөрсөн утга)",
        rowTitleWidth: "Мөрийн гарчгийн утга (CSS хүлээн зөвшөөрсөн утга)",
        valueTrue: "Үнэн утга",
        valueFalse: "Худал утга",
        minErrorText: "Хамгийн бага утгаас бага байна! алдааны мэдэгдэл",
        maxErrorText: "Хамгийн их утгаас их байна! алдааны мэдэгдэл",
        otherErrorText: "Хоосон санал хүсэлт! алдааны мэдэгдэл",
        keyDuplicationError: "Давтагдсан утга! алдааны мэдэгдэл",
        minSelectedChoices: "Хамгийн бага сонгосон сонголт",
        maxSelectedChoices: "Хамгийн ихдээ сонгох боломжийн тоо",
        showClearButton: "Цэвэрлэх товч харуулах",
        logoWidth: "Логоны өргөн (CSS хүлээн зөвшөөрсөн утга)",
        logoHeight: "Логөны өндөр (CSS хүлээн зөвшөөрсөн утга)",
        readOnly: "Зөвхөн унших",
        enableIf: "Засах боломжтой хэрэв",
        emptyRowsText: "\"Мөр байхгүй байна!\" мэдэгдэл",
        separateSpecialChoices: "Тусгай сонголтуудыг салгах (Аль нь ч биш, Бусад, Бүгдийг сонгох)",
        choicesFromQuestion: "Дараах асуултаас сонголтуудыг хуулах.",
        choicesFromQuestionMode: "Аль сонголтуудыг хуулах вэ?",
        progressBarShowPageTitles: "Хөгжил дэвшлийн тавцан дахь хуудасны гарчгыг харуул",
        progressBarShowPageNumbers: "Хуудасны дугааруудыг progress bar-д харуулах",
        showCommentArea: "Санал хүсэлтийн хэсэг харуулах",
        commentPlaceholder: "Санал хүсэлтийн хэсэг",
        displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values",
        rowsOrder: "Мөрний дараалал",
        columnsLayout: "Баганы зохион байгуулалт",
        columnColCount: "Шаталсан баганын тоо",
        correctAnswer: "Зөв хариулт",
        defaultPanelValue: "Үндсэн утга",
        cells: "Нүдний текст",
        fileInputPlaceholder: "Файл сонгох эсвэл файлын холбоосыг наа...",
        keyName: "Түлхүүр багана",
        itemvalue: {
            visibleIf: "Хэрэв сонголтыг ил тод болго",
            enableIf: "Сонголтыг сонговол"
        },
        "itemvalue@rows": {
            visibleIf: "Хэрэв эгнээг ил гаргах",
            enableIf: "Хэрэв эгнээг хянан засварлах боломжтой болго"
        },
        imageitemvalue: {
            text: "Тайлбар"
        },
        logoPosition: "Логоны байршил",
        addLogo: "Лого нэмэх...",
        changeLogo: "Лого солих...",
        logoPositions: {
            none: "Лого устгах",
            left: "Зүүн",
            right: "Баруун",
            top: "Дээр",
            bottom: "Доор"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Panel Layout"
            },
            general: "Ерөнхий",
            fileOptions: "Сонголт",
            html: "HTML засварлагч",
            columns: "Багана",
            rows: "Мөр",
            choices: "Сонголт",
            items: "Элемент",
            visibleIf: "Харагдана хэрэв",
            enableIf: "Засварлаж болно хэрэв",
            requiredIf: "Заавал бөглөх болох хэрэв",
            rateValues: "Утгыг үнэлэх",
            choicesByUrl: "RESTful сервисийн сонголтууд",
            matrixChoices: "Үндсэн сонголтууд",
            multipleTextItems: "Текст оролт",
            numbering: "Дугаарлалт",
            validators: "Батлагч",
            navigation: "Чиглүүлэгч",
            question: "Асуулт",
            pages: "Хуудас",
            timer: "Тоолуур/Асуулт хариулт",
            calculatedValues: "Тооцоолсон утга",
            triggers: "Схемүүд",
            templateTitle: "Гарчигны загвар",
            totals: "Нийт",
            logic: "Логик",
            mask: "Оролт Маск тохиргоо",
            layout: {
                panel: "Layout",
                question: "Layout",
                base: "Layout"
            },
            data: "Өгөгдөл",
            validation: "Батлах",
            cells: "Нүдний текст",
            showOnCompleted: "Санал асуулга амжилттай бөглөгдлөө.",
            logo: "Санал асуулгын гарчиг дахь лого",
            slider: "Гулсуулагч",
            expression: "илэрхийлэл",
            questionSettings: "Асуултын тохиргоо",
            header: "Толгойлогч",
            background: "Ар талын",
            appearance: "Харагдах байдал",
            others: "Бусад"
        },
        editProperty: "Шинж чанарыг засварлах '{0}'",
        items: "Элементүүд",
        choicesVisibleIf: "Сонголтууд харагдана хэрэв",
        choicesEnableIf: "Сонголтууд сонгогдоно хэрэв",
        columnsEnableIf: "Баганууд харагдана хэрэв",
        rowsEnableIf: "Мөрнүүд харагдана хэрэв",
        innerIndent: "Дотоод догол мөр нэмэх",
        defaultValueFromLastRow: "Өмнөх мөрнөөс үндсэн утга авах",
        defaultValueFromLastPanel: "Сүүлийн панелаас үндсэн утга авах",
        enterNewValue: "Утга оруулна уу.",
        noquestions: "Санал асуулгад асуулт оруулна уу.",
        createtrigger: "Схем устгана уу.",
        titleKeyboardAdornerTip: "Засахын тулд Enter товчийг дарна уу",
        keyboardAdornerTip: "Засахын тулд Enter товчийг дарна уу, Устгахын тулд Delete товчийг дарна уу, Хөдөлгөхийн тулд alt + дээш сум эсвэл доош сум дарна уу",
        triggerOn: "On ",
        triggerMakePagesVisible: "Хуудсуудыг харуулах",
        triggerMakeQuestionsVisible: "Элементүүдийг харуулах",
        triggerCompleteText: "Complete the survey if succeed.",
        triggerNotSet: "Схем тохируулагдаагүй байна",
        triggerRunIf: "Ажилуулах хэрэв",
        triggerSetToName: "Утга өөрчлөх: ",
        triggerFromName: "Утга хуулах: ",
        triggerRunExpression: "илэрхийлэлг ажиллуулах",
        triggerSetValue: "хүртэл: ",
        triggerGotoName: "Асуулт руу үсрэх",
        triggerIsVariable: "Хувьсагч санал асуулгын үр дүнд оруулахгүй байх.",
        triggerRunExpressionEmpty: "Бодит илэрхийлэл оруулна уу.",
        emptyExpressionPlaceHolder: "илэрхийлэлг энд бичнэ үү...",
        noFile: "Файл сонгоогүй байна.",
        clearIfInvisible: "Асуулт нуувал утгыг цэвэрлэх.",
        valuePropertyName: "Утгын шинж чанарын нэр",
        searchEnabled: "Хайлтыг идэвхжүүлэх",
        hideSelectedItems: "Сонгогдсон хэсгийг нуух",
        closeOnSelect: "Сонголт хийсэн үед доош буусан сонголтуудыг хаах",
        verticalAlign: "Босоо эгнүүлэх",
        alternateRows: "Хувилбар мөрнүүд",
        columnsVisibleIf: "Баганууд харагдана хэрэв",
        rowsVisibleIf: "Мөрнүүд харагдана хэрэв",
        otherPlaceholder: "Санал асуулгын хэсэг",
        filePlaceholder: "Файл байршуулагчийн текст",
        photoPlaceholder: "Гэрэл зураг байршуулагч бичвэр",
        fileOrPhotoPlaceholder: "Файл эсвэл гэрэл зураг байршуулагч текст",
        rateType: "Rate төрөл",
        url_placeholder: "Экс.: https://api.example.com/books",
        path_placeholder: "Экс.: categories.fiction",
        questionStartIndex_placeholder: "Экс.: а)",
        width_placeholder: "Экс.: 6ин",
        minWidth_placeholder: "Экс: 600px",
        maxWidth_placeholder: "Экс: 50%",
        imageHeight_placeholder: "автомат",
        imageWidth_placeholder: "автомат",
        theme: {
            themeName: "Сэдэв",
            isPanelless: "Асуулт хариултын төрх",
            editorPanel: "Ар талын болон булангийн радиус",
            questionPanel: "Ар талын болон булангийн радиус",
            primaryColor: "Акцент өнгө",
            panelBackgroundTransparency: "Панелийн ар талын харанхуй байдал",
            questionBackgroundTransparency: "Асуулт хариултын нөхцөл байдал",
            fontSize: "Фонтын хэмжээ",
            scale: "Хэмжүүр",
            cornerRadius: "Булангийн радиус",
            pageTitle: "Нүүр фонт",
            pageDescription: "Дүрслэлийн фонт",
            questionTitle: "Нүүр фонт",
            questionDescription: "Дүрслэлийн фонт",
            editorFont: "Фонт",
            backgroundOpacity: "Бүдүүлэг байдал",
            "--sjs-font-family": "Фонтын гэр бүл",
            "--sjs-general-backcolor-dim": "Ар талын өнгө",
            "--sjs-primary-backcolor": "Акцентийн гарал үүсэл",
            "--sjs-primary-forecolor": "Акцентийн өмнө",
            "--sjs-special-red": "Алдааны мессеж",
            "--sjs-shadow-small": "Сүүдрийн нөлөө",
            "--sjs-shadow-inner": "Сүүдрийн нөлөө",
            "--sjs-border-default": "Өнгө"
        },
        "header@header": {
            headerView: "Үзэх",
            logoPosition: "Лого байрлал",
            surveyTitle: "Судалгааны нэрийн фонт",
            surveyDescription: "Судалгааны тодорхойлолтын фонт",
            headerTitle: "Судалгааны нэрийн фонт",
            headerDescription: "Судалгааны тодорхойлолтын фонт",
            inheritWidthFrom: "Агуулгын бүсийн өргөн",
            textAreaWidth: "Текстийн өргөн",
            backgroundColorSwitch: "Ар талын өнгө",
            backgroundImage: "Ар талын зураг",
            backgroundImageOpacity: "Бүдүүлэг байдал",
            overlapEnabled: "Давхар",
            logoPositionX: "Лого байрлал",
            titlePositionX: "Нүүр албан тушаал",
            descriptionPositionX: "Тодорхойлолтын байрлал"
        }
    },
    // Property values
    pv: {
        "true": "Үнэн",
        "false": "Худал",
        file: "Орон нутгийн файлууд",
        camera: "Камер",
        "file-camera": "Орон нутгийн файлууд эсвэл камер",
        inherit: "Удамших",
        show: "Харагдана",
        hide: "Нуусан",
        default: "Үндсэн",
        initial: "Анхны",
        random: "Санамсаргүй",
        collapsed: "Багассан",
        expanded: "Өргөтгөсөн",
        none: "Аль нь ч биш",
        asc: "Өгсөж байгаа",
        desc: "Буурч байгаа",
        indeterminate: "Тодорхойгүй",
        selected: "Сонгосон",
        unselected: "Сонгогдоогүй",
        decimal: "Бутархай",
        currency: "Мөнгөн тэмдэгт",
        percent: "Хувь",
        firstExpanded: "Эхний панел өргөссөн",
        off: "Асуултын тоог нуух",
        list: "Жагсаалт",
        progressTop: "Панел чиглүүлэгч + Явцын мөр дээд хэсэгт байрлах",
        progressBottom: "Панел чиглүүлэгч + Явцын мөр доод хэсэгт байрлах",
        progressTopBottom: "Панел чиглүүлэгч + Явцын мөр дээд ба доод хэсэгт байрлах",
        tab: "Табууд",
        horizontal: "Хэвтээ",
        vertical: "Босоо",
        top: "Дээд",
        bottom: "Доод",
        topBottom: "Дээд ба доод",
        both: "Аль аль нь",
        left: "Зүүн",
        right: "Баруун",
        center: "Төв",
        leftRight: "Зүүн, баруун",
        middle: "Дунд",
        color: "өнгө",
        date: "огноо",
        datetime: "datetime",
        "datetime-local": "datetime-local",
        email: "цахим шуудан",
        month: "сар",
        number: "тоо",
        password: "нууц үг",
        range: "range",
        tel: "Дугаар",
        text: "Текст",
        time: "цаг",
        url: "url",
        week: "долоо хоног",
        hidden: "Нуусан",
        edit: "Засаж болдог",
        display: "Зөвхөн унших",
        contain: "Агуулах",
        cover: "Хөшиг",
        fill: "Дүүргэлт",
        next: "Дараа нь",
        last: "Сүүлчийнх нь",
        onComplete: "Санал асуулга амжилттай бөглөгдсөн үед.",
        onHidden: "Асуулт нуугдсан үед",
        onHiddenContainer: "Асуулт, панел эсвэл хуудас нуугдсан үед",
        clearInvisibleValues: {
            none: "Хэзээ ч үгүй"
        },
        clearIfInvisible: {
            none: "Хэзээ ч"
        },
        inputType: {
            color: "Өнгө",
            date: "Огноо",
            "datetime-local": "Огноо, цаг",
            email: "И-мэйл",
            month: "Сар",
            number: "Тоо хэмжээ",
            password: "Нууц үг",
            range: "Хамрах хүрээ",
            tel: "Утасны дугаар",
            text: "Текст",
            time: "Цаг хугацаа",
            url: "URL",
            week: "Долоо хоног"
        },
        all: "Бүх",
        page: "Хуудас",
        survey: "Санал асуулга",
        onNextPage: "Дараагийн хуудас руу шилжих үед",
        onValueChanged: "Асуулт солигдсоны дараа",
        onValueChanging: "Асуулт солигдхоос өмнө",
        questionsOnPageMode: {
            standard: "Оригинал бүтэц",
            singlePage: "Бүх асуултыг нэг хуудсан дээр харуул",
            questionPerPage: "Хуудас тус бүрт ганц асуултыг харуул"
        },
        noPreview: "Урьдчилан харах боломжгүй",
        showAllQuestions: "Бүх асуултыг харуулах.",
        showAnsweredQuestions: "Зөвхөн хариулсан асуултуудыг харуулах.",
        pages: "Бөглөгдсөн хуудсууд",
        questions: "Хариулсан асуултууд",
        requiredQuestions: "Заавал бөглөх асуултууд",
        correctQuestions: "Зөв хариултууд",
        buttons: "Бөглөгдсөн хуудсууд (UI товч)",
        underInput: "Оролтын доор",
        underTitle: "Гарчгийн доор",
        onBlur: "Бүдгэрүүлсэн үед",
        onTyping: "Бичиж байх үед",
        underRow: "Мөрийн доор",
        underRowSingle: "Мөрийн доор, зөвхөн ганц панел харагдана",
        auto: "Авто",
        showNavigationButtons: {
            none: "Нуусан"
        },
        showTimerPanel: {
            none: "Нуусан"
        },
        showTimerPanelMode: {
            all: "Аль аль нь"
        },
        addRowLocation: {
            default: "Матрицын загвараас шалтгаалах"
        },
        panelsState: {
            default: "Хэрэглэгчид панелийг өргөсгөж багасгаж чадахгүй",
            collapsed: "Бүх панел багассан",
            expanded: "Бүх панел өргөтгөссөн",
            firstExpanded: "Анх өргөтгөн"
        },
        widthMode: {
            static: "Статик",
            responsive: "Уян хатан"
        },
        contentMode: {
            image: "Зураг",
            video: "Видео",
            youtube: "YouTube"
        },
        displayMode: {
            buttons: "Товчнууд",
            dropdown: "Доош задрах"
        },
        rateColorMode: {
            default: "Дефолт",
            scale: "Хэмжүүр"
        },
        scaleColorMode: {
            monochrome: "Монхор",
            colored: "Өнгөлсөн"
        },
        autoGenerate: {
            "true": "Үүсгэх",
            "false": "Гараар оруул"
        },
        rateType: {
            labels: "Labels",
            stars: "Одод",
            smileys: "Инээмсэглэл"
        },
        state: {
            default: "Цоожтой"
        },
        showQuestionNumbers: {
            default: "Авто машины дугаар олгох",
            on: "Авто машины дугаар олгох",
            onPage: "Хуудас бүр дээр дахин тохируулах",
            onpanel: "Тавиур бүр дээр дахин тавих",
            onPanel: "Тавиур бүр дээр дахин тавих",
            onSurvey: "Судалгааг үргэлжлүүлэн хийх",
            off: "Дугаарлахгүй"
        },
        descriptionLocation: {
            underTitle: "Асуултын нэрийн дор",
            underInput: "Оролтын талбарын дор"
        },
        selectToRankAreasLayout: {
            horizontal: "Дараа нь сонголт",
            vertical: "Дээрх сонголтууд"
        },
        displayStyle: {
            decimal: "Decimal",
            currency: "Валютын ханш",
            percent: "Хувь",
            date: "Огноо"
        },
        totalDisplayStyle: {
            decimal: "Decimal",
            currency: "Валютын ханш",
            percent: "Хувь",
            date: "Огноо"
        },
        rowsOrder: {
            initial: "Оргил"
        },
        questionsOrder: {
            initial: "Оргил"
        },
        showProgressBar: {
            off: "Нуусан",
            topbottom: "Дээд ба доод",
            aboveheader: "Толгой дээгүүр",
            belowheader: "Гарчигны доор"
        },
        sum: "Сум",
        count: "Тооллого",
        min: "Мин",
        max: "Макс",
        avg: "Авг",
        searchMode: {
            contains: "Агуулах",
            startsWith: "Эхлэл"
        },
        backgroundImageFit: {
            auto: "Авто",
            cover: "Хөшиг",
            contain: "Агуулах",
            fill: "Шээс",
            tile: "Тил"
        },
        backgroundImageAttachment: {
            fixed: "Зассан",
            scroll: "Хуйлмал бичиг"
        },
        headerView: {
            basic: "Үндсэн",
            advanced: "Өндөр хөгжсөн"
        },
        inheritWidthFrom: {
            survey: "Судалгаатай адил",
            container: "Сав баглаа боодолд тохирно"
        },
        backgroundColorSwitch: {
            none: "Хэн ч биш",
            accentColor: "Акцент өнгө",
            custom: "Үйлчилгээ"
        },
        colorPalette: {
            light: "Гэрэл",
            dark: "Харанхуй"
        },
        isPanelless: {
            "false": "Дефолт",
            "true": "Панелгүйгээр"
        }
    },
    // Operators
    op: {
        empty: "Хоосон",
        notempty: "Хоосон биш",
        equal: "Тэнцэх",
        notequal: "Тэнцэхгүй байх",
        contains: "Агуулсан",
        notcontains: "Агуулаагүй",
        anyof: "Аль нэгийг нь",
        allof: "Бүгдийг нь",
        greater: "-аас их",
        less: "-аас бага",
        greaterorequal: "-аас их эсвэл тэнцүү байх",
        lessorequal: "-аас бага эсвэл тэнцүү байх",
        and: "ба",
        or: "эсвэл"
    },
    // Embed window
    ew: {
        angular: "Angular хувилбар ашиглах",
        jquery: "jQuery хувилбар ашиглах",
        knockout: "Knockout хувилбар ашиглах",
        react: "React хувилбар ашиглах",
        vue: "Vue хувилбар ашиглах",
        bootstrap: "bootstrap бүтцэд",
        modern: "Орчин үеийн",
        default: "Үндсэн",
        orange: "Улбар шар",
        darkblue: "Хар хөх",
        darkrose: "Хүрэн",
        stone: "Чулуун",
        winter: "Өвлийн",
        winterstone: "Өвлийн-чулуун",
        showOnPage: "Санал асуулгыг хуудас дээр харуулах",
        showInWindow: "Санал асуулгыг цонхонд харуулах",
        loadFromServer: "JSON серверээс санал асуулгыг ачааллуулах",
        titleScript: "Скрипт ба хэв маяг",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Тест хийх хуудсыг сонгох.",
        showInvisibleElements: "Харагдахгүй элементүүдийг харуулах.",
        hideInvisibleElements: "Харагдахгүй элементүүдийг нуух."
    },
    validators: {
        answercountvalidator: "Хариултын тоо",
        emailvalidator: "Цахим шууудан",
        expressionvalidator: "илэрхийлэл",
        numericvalidator: "Тоо",
        regexvalidator: "Regex",
        textvalidator: "Текст"
    },
    triggers: {
        completetrigger: "Санал асуулга дуусгах.",
        setvaluetrigger: "Хариулт тавих",
        copyvaluetrigger: "Хариулт хуулах",
        skiptrigger: "Асуулт руу үсрэх",
        runexpressiontrigger: "илэрхийлэл ажлуулах",
        visibletrigger: "Харагдах байдлыг өөрчлөх"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Экс.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Экс.: мм/д/yyy"
        },
        currencymask: {
            prefix: "Экс.: $",
            suffix: "Экс.: USD"
        },
        panelbase: {
            questionTitleWidth: "Экс: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "Хариулагчдад харагдахгүй панелийн ID.",
            description: "Панелийн дэд гарчиг бичнэ.",
            visibleIf: "Ид шидийн wand зургыг ашиглан панелийн харагдах байдлыг тодорхойлох нөхцөлийн дүрмийг тогтоо.",
            enableIf: "Зөвхөн унших хэв маягийг хаах нөхцөлтэй дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла.",
            requiredIf: "Наад зах нь нэг үүрээ засах асуулт хариулт байхгүй л бол судалгаа явуулахаас сэргийлдэг нөхцөлийн дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла.",
            questionTitleLocation: "Энэ хэлэлцүүлгийн бүх асуултад хамаарна. Хэрэв та энэ тохиргоог хүчингүй болгохыг хүсвэл хувь хүний асуултуудад зориулсан нэрийн зохицуулах дүрмүүдийг тодорхойл. \"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог (\"Top\" нь default-аар) хэрэгжүүлдэг.",
            questionTitleWidth: "Асуултын хайрцгуудынхаа зүүн талд эгнэн зогсож байх үед асуултын нэрний тогтмол өргөнийг тогтоо. CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг.",
            questionErrorLocation: "Хяналтын шатны бүх асуулттай холбогдуулан алдааны мессежийн байршлыг тогтооно. \"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог хэрэгжүүлдэг.",
            questionsOrder: "Асуултуудын анхны дарааллыг хадгалах эсвэл санамсаргүйгээр авч явдаг. \"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог хэрэгжүүлдэг.",
            page: "Сонгосон хуудасны төгсгөлд панелийг дахин байршуулах.",
            innerIndent: "Панелийн агуулга болон панелийн хайрцагны зүүн хилийн хооронд зай эсвэл зай нэмнэ.",
            startWithNewLine: "Өмнөх асуулт эсвэл панелтай нэг мөрт үзүүлэхээр сонгогдоогүй. Хэрэв панел нь таны маягт дахь анхны элемент бол тохиргоо хамаарахгүй.",
            state: "Сонголтоос: \"Өргөтгөсөн\" - хавтанг бүрэн харуулж, нурааж болно; \"Нурсан\" - панел нь зөвхөн гарчиг, тодорхойлолтыг харуулж, өргөтгөх боломжтой; \"Цоожтой\" - панелыг бүрэн харуулсан бөгөөд нурааж болохгүй.",
            width: "Панелийн өргөнийг ижил шугамаар бусад судалгааны элементүүдтэй тэнцүү тогтооно. CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг."
        },
        paneldynamic: {
            name: "Хариулагчдад харагдахгүй панелийн ID.",
            description: "Панелийн дэд гарчиг бичнэ.",
            visibleIf: "Ид шидийн wand зургыг ашиглан панелийн харагдах байдлыг тодорхойлох нөхцөлийн дүрмийг тогтоо.",
            enableIf: "Зөвхөн унших хэв маягийг хаах нөхцөлтэй дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла.",
            requiredIf: "Наад зах нь нэг үүрээ засах асуулт хариулт байхгүй л бол судалгаа явуулахаас сэргийлдэг нөхцөлийн дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла.",
            templateTitleLocation: "Энэ хэлэлцүүлгийн бүх асуултад хамаарна. Хэрэв та энэ тохиргоог хүчингүй болгохыг хүсвэл хувь хүний асуултуудад зориулсан нэрийн зохицуулах дүрмүүдийг тодорхойл. \"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог (\"Top\" нь default-аар) хэрэгжүүлдэг.",
            templateErrorLocation: "Алдааны мессежийн байршлыг хүчингүй оруулсан асуулттай холбон тогтооно. Аль нэгийг сонгоно уу: \"Топ\" - асуултын хайрцагны дээд хэсэгт алдаа текст байрлуулсан байна; \"Bottom\" - асуултын хайрцагны доод хэсэгт алдаа текст байрлуулна. \"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог (\"Top\" нь default-аар) хэрэгжүүлдэг.",
            errorLocation: "Хяналтын шатны бүх асуулттай холбогдуулан алдааны мессежийн байршлыг тогтооно. \"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог хэрэгжүүлдэг.",
            page: "Сонгосон хуудасны төгсгөлд панелийг дахин байршуулах.",
            innerIndent: "Панелийн агуулга болон панелийн хайрцагны зүүн хилийн хооронд зай эсвэл зай нэмнэ.",
            startWithNewLine: "Өмнөх асуулт эсвэл панелтай нэг мөрт үзүүлэхээр сонгогдоогүй. Хэрэв панел нь таны маягт дахь анхны элемент бол тохиргоо хамаарахгүй.",
            state: "Сонголтоос: \"Өргөтгөсөн\" - хавтанг бүрэн харуулж, нурааж болно; \"Нурсан\" - панел нь зөвхөн гарчиг, тодорхойлолтыг харуулж, өргөтгөх боломжтой; \"Цоожтой\" - панелыг бүрэн харуулсан бөгөөд нурааж болохгүй.",
            width: "Панелийн өргөнийг ижил шугамаар бусад судалгааны элементүүдтэй тэнцүү тогтооно. CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг.",
            templateTitle: "Динамик панел цолны темплэйтэд бичнэ. Харагдах панелуудын дунд түүний дарааллыг {panelIndex} болон {visiblePanelIndex} -ийг ашиглана уу. Автомат дугаар нэмэхийн тулд эдгээр байрлагчдыг загварт оруул.",
            templateTabTitle: "Таб нэрний темплэйтэд бичнэ. {panelIndex} нь панелийн ерөнхий байрлал болон {visiblePanelIndex} -ийг ил харагдах панелуудын дунд эмх цэгцтэй байлгахад ашиглана. Автомат дугаар нэмэхийн тулд эдгээр байрлагчдыг загварт оруул.",
            tabTitlePlaceholder: "Таб нэрийн загвар утга учиртай үнэ цэнийг бий болгодоггүй үед хамаарах tab title-ийн уналтын текст.",
            templateVisibleIf: "Энэ тохиргоо нь динамик панелын доторх хувь хүний панелын харагдах байдлыг хянах боломжийг олгодог. '{panel}' байрлуулагчийг ашиглан одоогийн панелийг өөрийн илэрхийлэлд эш татна уу.",
            titleLocation: "Энэ тохиргоо нь энэ панел доторх бүх асуултаар автоматаар өвлөгддөг. Хэрэв та энэ тохиргоог хүчингүй болгохыг хүсвэл хувь хүний асуултуудад зориулсан нэрийн зохицуулах дүрмүүдийг тодорхойл. \"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог (\"Top\" нь default-аар) хэрэгжүүлдэг.",
            descriptionLocation: "\"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог (\"Under the panel title\" -ийг default-аар) хэрэгжүүлдэг.",
            newPanelPosition: "Шинээр нэмэгдсэн панелийн байр суурийг тодорхойлно. Default-ээр төгсгөл рүү шинэ панелуудыг нэмдэг. Одоогийн панел дараа нь шинэ панел оруулахын тулд \"Next\"-ийг сонго.",
            defaultValueFromLastPanel: "Сүүлийн панелын хариултыг хувилж, дараагийн нэмэлт динамик хавтанд хуваарилна.",
            keyName: "Энэ асуултад хэрэглэгчээс панел бүрт өвөрмөц хариулт өгөхийг шаардахын тулд асуултын нэрийг эш тат."
        },
        defaultValueExpression: "Энэ тохиргоо нь илэрхийллийн үндсэн дээр дефолт хариултын үнэ цэнийг даалгах боломжийг олгодог. Илэрхийлэл нь үндсэн тооцоо - '{q1_id} + {q2_id}', Бөүлийн илэрхийллүүд, тухайлбал '{age} > 60', функц: 'iif()', 'өнөөдөр()', 'мин()', 'мин()', 'max()', 'avg()', г.м. Энэ илэрхийлэлээр тодорхойлогддог үнэ цэнэ нь хариулагчийн гарын авлагын оролтоор давхардуулан авч болох анхны дефолтын үнэ цэнэ болж өгдөг.",
        resetValueIf: "\"Default value expression\" эсвэл \"Set value expression\" эсвэл \"Default answer\" value (хэрэв аль нэгийг нь тогтоосон бол) үнэ цэнэд үндэслэн хариулагчийн оруулсан хувь нэмрийг үнэ цэнэд хэзээ дахин тохируулахыг тодорхойлох нөхцөлтэй дүрмийг тогтоохын тулд шидэт wand зургыг ашигла.",
        setValueIf: "Ид шидийн wand зургыг ашиглан \"Set value expression\"-ийг хэзээ ажиллуулахыг тодорхойлох нөхцөлтэй дүрмийг тогтоож, үр дүнд хүрсэн үнэ цэнийг хариу болгон динамикаар даалга.",
        setValueExpression: "\"Set value if\" дүрмийн нөхцөл хангагдсан үед тогтоох үнэ цэнийг тодорхойлсон илэрхийллийг тодорхойл. Илэрхийлэл нь үндсэн тооцоо - '{q1_id} + {q2_id}', Бөүлийн илэрхийллүүд, тухайлбал '{age} > 60', функц: 'iif()', 'өнөөдөр()', 'мин()', 'мин()', 'max()', 'avg()', г.м. Энэ илэрхийлэлээр тогтоосон үнэ цэнийг хариулагчийн гарын авлагын оролтоор давхардуулан авч болно.",
        question: {
            name: "Асуултад хариулагчдад харагдахгүй асуултын ID.",
            description: "Асуултын дэд гарчиг бичнэ үү.",
            visibleIf: "Асуултын харагдах байдлыг тодорхойлох нөхцөлийн дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла.",
            enableIf: "Асуултын зөвхөн унших хэв маягийг хаах нөхцөлтэй дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла.",
            requiredIf: "Асуулт хариулт аваагүй л бол судалгааг урагшлуулах эсвэл ирүүлэхэд саад болох нөхцөлийн дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла.",
            startWithNewLine: "Асуултыг өмнөх асуулт эсвэл панелтай нэг мөрт харуулахаар сонгогдоогүй. Асуулт нь таны маягт дахь анхны элемент бол тохиргоо хамаарахгүй.",
            page: "Асуултыг сонгосон хуудасны төгсгөлд буцааж тавих.",
            state: "Сонгох: \"Өргөтгөсөн\" - асуултын хайрцгийг бүрэн харуулсан бөгөөд нурж болно; \"Нурж унасан\" - асуултын хайрцаг нь зөвхөн гарчиг, дүрслэлийг харуулж, өргөтгөх боломжтой; \"Locked\" - асуултын хайрцгийг бүрэн харуулсан бөгөөд нурж болохгүй.",
            titleLocation: "Нэрийн зохицлын дүрмүүдийг панел, хуудас эсвэл судалгааны түвшин дээр тодорхойлсон байдаг. \"Өв залгамжлах\" сонголт нь ямар ч өндөр түвшний тохиргоог (хэрэв set) эсвэл судалгааны түвшний тохиргоог (\"Top\" нь default-аар) хэрэгжүүлдэг.",
            descriptionLocation: "\"Өв залгамж\" сонголт нь судалгааны түвшний тохиргоог хэрэгжүүлдэг (\"Асуултын гарчиг доор\" гэсэн сонголтыг сонголтоор).",
            errorLocation: "Асуулттай холбоотой алдааны мессежийн байршлыг хүчингүй оруулсан байдлаар тогтооно. Аль нэгийг сонгоно уу: \"Топ\" - асуултын хайрцагны дээд хэсэгт алдаа текст байрлуулсан байна; \"Bottom\" - асуултын хайрцагны доод хэсэгт алдаа текст байрлуулна. \"Өв залгамж\" сонголт нь судалгааны түвшний тохиргоог (\"Top\" by default) хэрэгжүүлдэг.",
            indent: "Асуултын агуулга болон асуултын хайрцагны зүүн хил хоёрын хооронд зай эсвэл зай нэмнэ.",
            width: "Асуултын өргөнийг нэг мөрт бусад судалгааны элементүүдтэй тэнцүү байдлаар тогтооно. CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг.",
            surveyvalidator: {
                expression: "Асуултын баталгаажуулалтын дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла."
            },
            textUpdateMode: "Сонгоно уу: \"Алдагдсан фокус дээр\" - оролтын талбар анхаарлаа алдсан үед үнэ цэнэ нь шинэчлэгддэг; \"Цахимаар бичих\" - хэрэглэгчид бичихийн хэрээр үнэ цэнэ нь бодит цаг хугацаанд шинэчлэгддэг. \"Өв залгамж\" сонголт нь судалгааны түвшний тохиргоог (\"Алдагдсан фокус дээр\" дефолтоор) хэрэгжүүлдэг.",
            url: "Та ямар ч вэб үйлчилгээг олон сонголттой асуултуудад мэдээллийн эх сурвалж болгон ашиглаж болно. Сонголтын үнэт зүйлсийг хүн амлахын тулд өгөгдөл өгөх үйлчилгээний URL-ийг оруулна уу.",
            searchMode: "Дуслын жагсаалтыг шүүлт хийхэд ашигладаг харьцуулах мэс засал.",
            textWrapEnabled: "Сонголтын сонголтуудын урт текстүүд нь дусал цэсний дотор багтахын тулд автоматаар шугамын завсар үүсгэх болно. Хэрэв та бичвэрүүдийг хайчлахыг хүсвэл сонгогдоогүй."
        },
        signaturepad: {
            signatureWidth: "Үзүүлсэн гарын үсэг зурсан хэсгийн өргөнийг болон үүний үр дүнд бий болсон зургийг тогтоо.",
            signatureHeight: "Үзүүлсэн гарын үсэг зурсан хэсгийн өндрийг болон үүний үр дүнд бий болсон зургийг тогтооно.",
            signatureAutoScaleEnabled: "Хэрэв та гарын үсэг зурах талбайгаа асуултын хайрцаг доторх бүх боломжит зайг бөглөж, стандарт 3:2 талын харьцааг хадгалахыг хүсэж байвал сонго. Custom өргөн, өндөр үнэ цэнийг тогтоох үед тохиргоо нь эдгээр хэмжээсийн тал харьцааг хадгална."
        },
        file: {
            imageHeight: "Судалгааны үр дүнгээр дүрсний өндрийг тохируулна.",
            imageWidth: "Судалгааны үр дүн дэх зургийн өргөнийг тохируулна."
        },
        image: {
            contentMode: "\"Авто\" сонголт нь эх сурвалж URL-д суурилсан зураг, видео, эсвэл YouTube - харуулах тохиромжтой хэв маягийг автоматаар тодорхойлдог."
        },
        imagepicker: {
            imageHeight: "Хамгийн бага болон хамгийн их өндөр үнэ цэнийг давхардна.",
            imageWidth: "Хамгийн бага, хамгийн их өргөний үнэ цэнийг давхардалд оруулах.",
            choices: "\"Үнэ цэнэ\" гэж нөхцөлийн дүрэмд хэрэглэгддэг эд зүйлийн ID-ээр үйлчилдэг; \"Текст\" гэж хариулагчдад тавигддаг.",
            contentMode: "Хэвлэл мэдээллийн хэрэгслийн сонгогчийн агуулгын хэв маягийг тогтоохын тулд \"Image\" болон \"Video\" хоёрын аль нэгийг сонго. Хэрэв \"Зураг\" гэж сонгосон бол өгөгдсөн бүх хувилбарууд нь дараах форматаар зургийн файлууд болохыг анхаарна уу: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Үүнтэй адилаар \"Video\" нь сонгогдвол бүх сонголт нь дараах форматаар видео файлуудын шууд холбоосууд болох MP4, MOV, WMV, FLV, AVI, MKV гэсэн форматаар байгаа эсэхийг баталгаажуулаарай. YouTube-ийн холбоосууд видео хувилбараар дэмжигдээгүйг анхаарна уу."
        },
        text: {
            size: "Энэ тохиргоо нь зөвхөн оролтын талбарыг дахин тохируулдаг бөгөөд асуултын хайрцагны өргөнд нөлөөлдөггүй. Хүлээн зөвшөөрөгдсөн оролтын уртыг хязгаарлахын тулд <b>Validation→ Maximum character limit</b> руу орно уу."
        },
        comment: {
            rows: "Оролтын талбар дахь харуулсан мөрүүдийн тоог тогтооно. Хэрэв оролт нь илүү олон мөртэй бол хуйлмал тавиур гарч ирнэ."
        },
        // survey templates
        survey: {
            mode: "Аль нэгийг нь сонгох: \"Editable\" - таны судалгааг бөглөх боломжийг санал асуулгад оролцогчдын хувьд олгодог; \"Зөвхөн уншлага\" - хөгжлийн бэрхшээлтэй хүмүүс редакци үүсгэнэ."
        },
        matrixdropdowncolumn: {
            name: "Хариулагчдад харагдахгүй байгаа баганын ID.",
            isUnique: "Баганыг авах боломжтой бол асуултад хариулагч нь энэ баганан доторх асуулт бүрд өвөрмөц хариулт өгөх шаардлагатай.",
            rows: "Оролтын талбар дахь харуулсан мөрүүдийн тоог тогтооно. Хэрэв оролт нь илүү олон мөртэй бол хуйлмал тавиур гарч ирнэ.",
            visibleIf: "Ид шидийн wand icon-ийг ашиглан баганын харагдах байдлыг тодорхойлох нөхцөлтэй дүрмийг тогтоо.",
            enableIf: "Шидэт wand зургыг ашиглан баганын зөвхөн унших хэв маягийг хаах нөхцөлтэй дүрмийг тогтоо.",
            requiredIf: "Наад зах нь нэг үүрээ засах асуулт хариулт байхгүй л бол судалгаа явуулахаас сэргийлдэг нөхцөлийн дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла.",
            showInMultipleColumns: "Сонгогдсон тохиолдолд сонголт бүрд зориулж багана үүсгэнэ."
        },
        widthMode: "Сонгоно уу: \"Статик\" - тогтмол өргөнийг тогтоох; \"Responsive\" - судалгааг дэлгэцийн бүрэн өргөнийг эзэлдэг болгодог; \"Авто\" - ашигласан асуултын төрлөөс хамааран аль нэгийг нь хэрэглэнэ.",
        cookieName: "Хэрэглэгч нэг судалгааг хоёр удаа бөглөхөөс Күүки сэргийлнэ.",
        logo: "Зургийн холбоосыг (хэмжээ хязгаар байхгүй) эсвэл фолдерын icon дарж компьютерээсээ файлыг (64KB хүртэл) харна уу.",
        logoWidth: "CSS нэгж (px, %, in, pt, гэх мэт) дээр логоны өргөнийг тогтооно.",
        logoHeight: "CSS нэгж (px, %, in, pt г.м) дээр логоны өндрийг тогтооно.",
        logoFit: "Сонгоно уу: \"None\" - зураг анхны хэмжээгээ хадгалдаг; \"Агуулах\" - дүрсийг тал харьцаагаа хадгалахын зэрэгцээ тохируулахын тулд дахин тохируулдаг; \"Cover\" - дүрс нь тал харьцаагаа хадгалахын зэрэгцээ хайрцгийг бүхэлд нь дүүргэдэг; \"Fill\" - дүрс нь тал харьцаагаа хадгалахгүйгээр хайрцгийг дүүргэхийн тулд сунаж тогтсон.",
        goNextPageAutomatic: "Тухайн хуудас дээрх бүх асуултад хариулагч хариулсны дараа судалгааг автоматаар дараагийн хуудас руу урагшлуулахыг хүсвэл сонгоно уу.",
        allowCompleteSurveyAutomatic: "Асуултад хариулсан хүн бүх асуултанд хариулсны дараа судалгааг автоматаар дуусгахыг хүсвэл сонго.",
        showNavigationButtons: "Хуудас дээр навигацийн товчны харагдах байдал, байршлыг тогтооно.",
        showProgressBar: "Хэмжилтийн тавцангийн харагдах байдал, байршлыг тогтооно. \"Авто\" үнэ цэнэ нь судалгааны толгой гарчгийн дээр эсвэл түүнээс доош хөгжил дэвшлийн барыг харуулдаг.",
        showPreviewBeforeComplete: "Зөвхөн бүх асуултаар эсвэл хариулт бүхий урьдчилан харах хуудсыг боломжтой болго.",
        questionTitleLocation: "Судалгааны бүх асуултад хамаарна. Энэ тохиргоог доод түвшний нэрийн зохицуулах дүрмээр давамгайлах боломжтой: panel, хуудас, эсвэл асуулт. Доод түвшний тохиргоо нь илүү өндөр түвшинд байгаа хүмүүсийг хүчингүй болгоно.",
        requiredText: "Хариу шаардлагатайг заасан бэлгэдэл буюу бэлгэ тэмдгийн дараалал.",
        questionStartIndex: "Дугаарлахыг хүссэн дугаар эсвэл захидлаа оруул.",
        questionErrorLocation: "Асуулттай холбоотой алдааны мессежийн байршлыг хүчингүй оруулсан байдлаар тогтооно. Аль нэгийг сонгоно уу: \"Топ\" - асуултын хайрцагны дээд хэсэгт алдаа текст байрлуулсан байна; \"Bottom\" - асуултын хайрцагны доод хэсэгт алдаа текст байрлуулна.",
        focusFirstQuestionAutomatic: "Текст оруулахад бэлэн болсон хуудас бүр дээрх эхний оролтын талбарыг хүсвэл сонгоно уу.",
        questionsOrder: "Асуултуудын анхны дарааллыг хадгалах эсвэл санамсаргүйгээр авч явдаг. Энэ тохиргооны үр нөлөө нь зөвхөн Preview таб-д харагдана.",
        maxTextLength: "Зөвхөн текст оруулах асуултуудад зориулна.",
        maxOthersLength: "Асуулт хариултын хувьд зөвхөн.",
        commentAreaRows: "Асуулт хариултын текст хэсэгт үзүүлсэн мөрүүдийн тоог тогтоо. Хуйлмал бичиг нь илүү олон мөртэй байдаг.",
        autoGrowComment: "Асуулт хариулт болон Урт Текст асуултыг орсон текст урт дээр үндэслэн өндрөөс автоматаар өсгөхийг хүсвэл сонгоно уу.",
        allowResizeComment: "Асуулт хариулт болон Урт текстийн асуултуудад зөвхөн.",
        calculatedValues: "Үйлчилгээний хувьсагчид нь форм тооцоололд хэрэглэгддэг дундын буюу туслах хувьсагчид болж үйлчилдэг. Тэд хариулагчийн оруулсан хувь нэмрийг эх сурвалжийн үнэт зүйлс гэж үздэг. Custom хувьсагч бүр өвөрмөц нэртэй, дээр нь суурилсан илэрхийлэлтэй байдаг.",
        includeIntoResult: "Тухайн илэрхийллийн тооцоолсон үнэ цэнийг судалгааны үр дүнгийн хамт хадгалахыг хүсвэл сонгоорой.",
        triggers: "Триггер гэдэг нь илэрхийлэлд тулгуурласан үйл явдал буюу нөхцөл байдлыг хэлж байгаа юм. Илэрхийлэлийг \"үнэн\" гэж үнэлсний дараа триггер үйлдэл гаргадаг. Ийм үйлдэл нь үүнд нөлөөлдөг байны асуултыг сонголтоор тавьж болно.",
        clearInvisibleValues: "Нөхцөл байдлын логикоор нуусан асуултуудын үнэ цэнийг тодорхой болгох уу, хэзээ хийх үү гэдгийг сонго.",
        textUpdateMode: "Сонгоно уу: \"Алдагдсан фокус дээр\" - оролтын талбар анхаарлаа алдсан үед үнэ цэнэ нь шинэчлэгддэг; \"Цахимаар бичих\" - хэрэглэгчид бичихийн хэрээр үнэ цэнэ нь бодит цаг хугацаанд шинэчлэгддэг.",
        columns: "Зүүн үнэ цэнэ нь нөхцөлийн дүрэмд хэрэглэгддэг баганын ID болж үйлчилдэг бөгөөд зөв үнэ цэнийг хариулагчдад үзүүлдэг.",
        rows: "Зүүн үнэ цэнэ нь нөхцөлийн дүрэмд хэрэглэгддэг мөрийн ID болж үйлчилдэг, зөв үнэ цэнийг хариулагчдад үзүүлдэг.",
        columnMinWidth: "CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг.",
        rowTitleWidth: "CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг.",
        totalText: "Хамгийн багадаа нэг багана Нэмэх төрлийн эвсэл нэмэх үйлдэлтэй үед л харагдах боломжтой.",
        cellErrorLocation: "Хүчингүй оруулсан эстэй холбоотой алдааны мессежийн байршлыг тогтооно. \"Өв залгамж\" сонголт нь \"Error message alignment\" өмчийн тохиргоог хэрэгжүүлдэг.",
        keyDuplicationError: "\"Хуулбарласан хариу арга хэмжээ авахаас урьдчилан сэргийлье\" өмчийг боломжтой болгоход хуулбарлан оруулахыг оролдсон хариулагч дараах алдааны мэдээг хүлээн авна.",
        totalExpression: "Илэрхийллийн үндсэн дээр нийт үнэт зүйлсийг тооцох боломжийг танд олгож байна. Илэрхийлэл нь үндсэн тооцоо ('{q1_id} + {q2_id}'), Бөүлийн илэрхийллүүд ('{нас} > 60') функцууд ('iif()', 'өнөөдөр()', 'мин()', 'мин()', 'max()', 'avg()', г.м.",
        confirmDelete: "Дарааллыг арилгахыг батлахыг хүссэн өдөөлтийг өдөөв.",
        defaultValueFromLastRow: "Сүүлийн мөрнөөс хариултуудыг хуулбарлаж, дараагийн нэмэлт динамик мөрөнд хуваарилна.",
        keyName: "Хэрэв өгөгдсөн багана адил утгатай бол санал асуулга \"Давтагдсан утга\" гэсэн алдааг харуулна.",
        description: "Дэд гарчиг бичнэ.",
        locale: "Судалгаагаа хийж эхлэх хэл сонго. Орчуулга нэмэхийн тулд шинэ хэл рүү шилжиж, эх бичвэрийг энд эсвэл Translations tab-д орчуулна.",
        detailPanelMode: "Нарийвчилсан хэсгийн байршлыг дараалалтай холбон тогтооно. Сонголтоос: \"Үгүй\" - ямар ч өргөтгөл нэмэгдсэнгүй; \"Мөрийн доор\" - матрицын мөр бүрийн доор эгнээний өргөтгөл байрлуулна; \"Мөрийн доор зөвхөн нэг эгнээний өргөтгөлийг үзүүл\" - зөвхөн нэг эгнээний дор өргөтгөл үзүүлдэг, үлдсэн эгнээний өргөтгөлүүд нь нурдаг.",
        imageFit: "Сонгоно уу: \"None\" - зураг анхны хэмжээгээ хадгалдаг; \"Агуулах\" - дүрсийг тал харьцаагаа хадгалахын зэрэгцээ тохируулахын тулд дахин тохируулдаг; \"Cover\" - дүрс нь тал харьцаагаа хадгалахын зэрэгцээ хайрцгийг бүхэлд нь дүүргэдэг; \"Fill\" - дүрс нь тал харьцаагаа хадгалахгүйгээр хайрцгийг дүүргэхийн тулд сунаж тогтсон.",
        autoGrow: "Өгөгдлийг оруулж байгаа үед оролтын талбайн өндрийг аажмаар нэмэгдүүлдэг. \"Input талбарын өндрийг (in lines)\" тохиргоог давхардна.",
        allowResize: "Resize бариул (эсвэл бариул) буланд гарч, оролтын талбарын хэмжээг өөрчлөхийн тулд чирэгдэж болно.",
        maxTimeToFinish: "Цаг хугацааны интервал секундын дотор. Үүний дараа судалгаа автоматаар \"Thank You\" хуудас руу орж байна.",
        maxTimeToFinishPage: "Судалгааны автоматаар дараагийн хуудас руу урагшлах секундын дотор цаг хугацаа.",
        page: {
            maxTimeToFinish: "Судалгааны автоматаар дараагийн хуудас руу урагшлах секундын дотор цаг хугацаа.",
            visibleIf: "Илбийн wand icon-ийг ашиглан хуудасны харагдах байдлыг тодорхойлох нөхцөлтэй дүрэм тогтооно.",
            enableIf: "Зөвхөн хуудсанд зориулсан унших хэв маягийг хаах нөхцөлтэй дүрмийг тогтоохын тулд шидэт wand зургыг ашигла.",
            requiredIf: "Наад зах нь нэг үүрээ засах асуулт хариулт байхгүй л бол судалгаа явуулахаас сэргийлдэг нөхцөлийн дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла.",
            questionTitleLocation: "Энэ хуудсан дахь бүх асуултад хамаарна. Хэрэв та энэ тохиргоог хүчингүй болгохыг хүсвэл хувь хүний асуулт эсвэл панелуудын нэрийн зохицуулах дүрмүүдийг тодорхойл. \"Өв залгамж\" сонголт нь судалгааны түвшний тохиргоог (\"Top\" by default) хэрэгжүүлдэг.",
            questionTitleWidth: "Асуултын хайрцгуудынхаа зүүн талд эгнэн зогсож байх үед асуултын нэрний тогтмол өргөнийг тогтоо. CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг.",
            questionErrorLocation: "Асуулттай холбоотой алдааны мессежийн байршлыг хүчингүй оруулсан байдлаар тогтооно. Аль нэгийг сонгоно уу: \"Топ\" - асуултын хайрцагны дээд хэсэгт алдаа текст байрлуулсан байна; \"Bottom\" - асуултын хайрцагны доод хэсэгт алдаа текст байрлуулна. \"Өв залгамж\" сонголт нь судалгааны түвшний тохиргоог (\"Top\" by default) хэрэгжүүлдэг.",
            questionsOrder: "Асуултуудын анхны дарааллыг хадгалах эсвэл санамсаргүйгээр авч явдаг. \"Өв залгамж\" сонголт нь судалгааны түвшний тохиргоог (\"Оригинал\" дефолтоор) хэрэгжүүлдэг. Энэ тохиргооны үр нөлөө нь зөвхөн Preview таб-д харагдана.",
            navigationButtonsVisibility: "Хуудсан дээр навигацийн товчны харагдах байдлыг тогтоо. \"Өв залгамжлах\" хувилбар нь \"Үзэгдэх\" гэсэн сонголт бүхий судалгааны түвшний тохиргоог хэрэгжүүлдэг."
        },
        showTimerPanel: "Хуудас дээр цаг хэмжигч харагдах байдал, байршлыг тогтооно.",
        panelsState: "Сонгоно уу: \"Locked\" - хэрэглэгчид панелуудыг өргөтгөх, нураах боломжгүй; \"Бүх нуралт\" - бүх панел нурсан байдлаас эхэлнэ; \"Бүх хүрээг өргөтгөнө\" - бүх панелууд өргөтгөсөн байдлаас эхэлнэ; \"First expanded\" - зөвхөн эхний панел нь эхэндээ өргөжсөн.",
        imageLinkName: "Сонгосон жагсаалтанд харуулахыг хүссэн зураг эсвэл видео файл URL-уудыг агуулсан олон тооны эд зүйлсийн дотор хуваалцсан өмчийн нэрийг оруулна уу.",
        choices: "Зүүн үнэ цэнэ нь нөхцөлийн дүрэмд хэрэглэгддэг зүйл ID, зөв үнэ цэнийг хариулагчдад үзүүлдэг.",
        title: "Хэрэглэгчдэд тохиромжтой нэр бичиж харуулах.",
        waitForUpload: "Файлуудыг татаж авах хүртэл хэрэглэгчид судалгааг хийж дуусгахгүй байхыг анхаарна.",
        minWidth: "CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг.",
        maxWidth: "CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг.",
        width: "CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг.",
        valueName: "Хэрэв энэ талбарын утгыг оруулаагүй бол хариулт нь автоматаар Нэр талбарт хадгална.",
        useDisplayValuesInDynamicTexts: "Ганц болон олон сонголттой асуултын төрлүүдэд сонголт бүр ID болон харуулах үнэ цэнэтэй байдаг. Энэ тохиргоо нь сонгогдсон тохиолдолд HTML асуулт болон динамик гарчиг, судалгааны элементүүдийн тодорхойлолтод ID үнэ цэнийн оронд харуулах үнэ цэнийг харуулдаг.",
        clearIfInvisible: "Нөхцөл байдлын логикоор нуусан үнэт зүйлсийг тодорхой болгох уу, хэзээ хийх вэ гэдгийг сонго. \"Өв залгамж\" сонголт нь судалгааны түвшний тохиргоог (\"Upon survey completion\" -ийг дефолтоор) хэрэгжүүлдэг.",
        choicesFromQuestionMode: "Сонгоно уу: \"Бүгд\" - сонгосон асуултаас сонголт хийх бүх сонголтыг хуулбарласан; \"Сонгосон\" - динамикаар зөвхөн сонгосон сонголтын хувилбаруудыг хуулбарласан; \"Сонгогдоогүй\" - динамикаар зөвхөн сонгогдоогүй сонголтыг хувилдаг. \"None\" болон \"Бусад\" сонголтууд нь эх сурвалжийн асуулгад боломжтой бол default-ээр хуулагддаг.",
        showOtherItem: "Сонгогдсон тохиолдолд хэрэглэгчид тусад нь тайлбарын хайрцагт нэмэлт оруулах боломжтой.",
        separateSpecialChoices: "Тусгай сонголт бүрийг (\"None\", \"Other\", \"Select All\") шинэ мөр дээр, бүр олон баганатай загварыг ашиглахдаа ч үзүүлдэг.",
        path: "Зорилтот олон тооны объект байрладаг үйлчилгээний мэдээллийн сан доторх байршлыг тодорхойл. URL аль хэдийн багц руу зааж байгаа бол хоосон орхи.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Сонголтын жагсаалтад харуулахыг хүссэн үнэт зүйлсээ агуулсан олон тооны эд зүйлсийн дотор дүрэмт өмчийн нэрийг оруулна уу.",
        allowEmptyResponse: "Хоосон хариу эсвэл багцыг үйлчлэлд буцааж өгөхийг сонго.",
        choicesVisibleIf: "Бүх сонголтын харагдах байдлыг тодорхойлох нөхцөлтэй дүрмийг тогтоохын тулд шидэт wand зургыг ашиглана уу.",
        rateValues: "Зүүн үнэ цэнэ нь нөхцөлийн дүрэмд хэрэглэгддэг зүйл ID, зөв үнэ цэнийг хариулагчдад үзүүлдэг.",
        rating: {
            displayMode: "\"Auto\" нь боломжит өргөн дээр суурилсан \"Buttons\" болон \"Dropdown\" загваруудын хооронд сонголт хийнэ. Өргөн нь товчлууруудыг харуулахад хангалтгүй үед асуулт нь дусал дуслыг харуулдаг."
        },
        valuePropertyName: "Өөр өөр форматаар үр дүн гаргадаг асуултуудыг холбох боломжийг танд олгож байна. Ийм асуултуудыг join identifier ашиглан холбох үед энэ хуваалцсан өмч хөрөнгийн дэлгүүрүүд нь сонгосон асуултын үнэ цэнийг хадгалдаг.",
        searchEnabled: "Хэрэглэгчийн оролтын талбарт бичиж байгаа хайлтын query-тэй тохируулахын тулд дусал цэсний агуулгыг шинэчлэхийг хүсвэл сонгоно уу.",
        valueTrue: "Асуултад хариулсан хүмүүс эерэг хариулт өгөхөд судалгааны үр дүнг хадгалах нь үнэ цэнэтэй.",
        valueFalse: "Судалгаанд оролцогчдын сөрөг хариулт өгөхөд судалгааны үр дүнг хадгалах үнэ цэнэ.",
        showPreview: "Preview зургийг давхардуулдаг тул энэ сонголтыг хүчингүй болгохыг санал болгодоггүй бөгөөд хэрэглэгчид файлуудыг татаж авсан эсэхийг ойлгоход хэцүү болгодог.",
        needConfirmRemoveFile: "Файлын устгалыг батлахыг хүссэн өдөөлтийг өдөөж байна.",
        selectToRankEnabled: "Зөвхөн сонгосон сонголтуудыг зэрэгцүүлэх боломжийг олгоно. Хэрэглэгчид сонгосон зүйлсийг сонгосон жагсаалтаас чирч, зэрэглэлийн бүс дотор тушаана.",
        dataList: "Санал болгох сонголтуудын жагсаалтыг оруулах үед хариулагчид санал болгох болно.",
        itemSize: "Тохиргоо нь зөвхөн оролтын талбаруудыг дахин тохируулдаг бөгөөд асуултын хайрцагны өргөнд нөлөөлдөггүй.",
        itemTitleWidth: "Пикселд бүх зүйлийн шошгоны тогтмол өргөнийг тогтоох",
        altText: "Хэрэглэгчийн төхөөрөмж дээр болон хүртээмжийн зорилгоор дүрсийг харуулах боломжгүй үед орлуулагчаар үйлчилнэ.",
        rateColorMode: "Rating icon төрлийн \"Smileys\" гэж тогтооход сонгосон эможигийн өнгийг тодорхойлно. Аль нэгийг нь сонгоно уу: \"Default\" - сонгосон эможи нь стандарт судалгааны өнгөөр гарч ирдэг; \"Scale\" - сонгосон эможи нь үнэлгээний хэмжүүрээс өнгийг өвлөн авдаг.",
        expression: {
            name: "Хариулагчдад харагдахгүй илэрхийлэл ID.",
            description: "Өгүүлбэрийн дэд гарчиг бичнэ.",
            expression: "Илэрхийлэл нь үндсэн тооцоо ('{q1_id} + {q2_id}'), нөхцөл ('{age} > 60'' болон функцууд ('iif()', 'өнөөдөр()', 'мин()', 'мин()', 'max()', 'avg()', г.м."
        },
        storeOthersAsComment: "\"Бусад\" сонголтын үнэ цэнийг судалгааны үр дүнд тусад нь өмч болгон хадгалахыг сонго.",
        format: "{0} нь тухайн утгын жишээ болно.",
        acceptedTypes: "Атрибутын талаар нэмэлт мэдээллийг үзэхийн тулд [accept](https://www.w3schools.com/tags/att_input_accept.asp)-лүү хандана уу.",
        columnColCount: "Зөвхөн олон сонголттой эсвэл Radiogroup -д ашиглана.",
        autocomplete: "Аттрибутын талаар дэлгэрэнгүй мэдээллийг [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete)-ээс авна уу .",
        filePlaceholder: "\"Эх сурвалжийн төрөл\" нь \"Орон нутгийн файлууд\" эсвэл камер байхгүй үед хамаарна",
        photoPlaceholder: "\"Эх сурвалжийн төрөл\" \"Камер\" байхад хамаарна.",
        fileOrPhotoPlaceholder: "\"Эх сурвалжийн төрөл\" нь \"Орон нутгийн файлууд буюу камер\" байхад хамаарна.",
        masksettings: {
            saveMaskedValue: "Асуултын үнэ цэнийг судалгааны үр дүнд хэрэгжүүлсэн багаар хадгалахыг хүсэж байгаа эсэхээ сонго."
        },
        patternmask: {
            pattern: "Загвар нь уянгын шууд болон дараах байрлагчийг агуулж болно: '9' - тоон хувьд; 'a' - дээд буюу доод талын үсгийн хувьд; '#' - цифр эсвэл дээд, эсвэл доод кейс үсгийн хувьд. Дүрээс зугтахын тулд backslash '\\' ашигла."
        },
        datetimemask: {
            pattern: "Загвар нь тусгаарлагч үсэг болон дараах байрлагчуудыг агуулж болно:<br>'m' - Сарын дугаар.<br>'мм' - Сарын дугаар, ганц цифрээр үнэ цэнэтэй тэргүүлэх нөлөө бүхий. <br>''д'' - Сарын нэг өдөр. <br>'dd' - Ганц цифрээр үнэ цэнэд тэргүүлэх нөлөө бүхий сарын өдөр. <br>'yy' - Жилийн сүүлийн хоёр цифр. <br>''yyyy'' - Дөрвөн цифр бүхий жил. <br>'H' - 24 цагийн форматаар цаг. <br>'HH' - 24 цагийн форматаар хэдэн цаг, ганц цифрээр үнэ цэнэтэй тэргүүлэх нөлөө. <br>'h' - 12 цагийн форматаар цаг. <br>'hh' - 12 цагийн форматаар хэдэн цаг, ганц цифрээр үнэ цэнэд тэргүүлэх нөлөөгүй. <br>'ММ' - Минут. <br>'ss' - Секунд. <br>'ТТ' - Дээд тохиолдолд 12 цагийн цаг (АМ/ЦАГ). <br>'tt' - доод тохиолдолд 12 цагийн цаг (ам/цаг) цаг."
        },
        numericmask: {
            decimalSeparator: "Жижиг хэсгийг үзүүлсэн дугаарын интежер хэсгээс салгахад ашигладаг бэлгэдэл.",
            thousandsSeparator: "Том тооны тоонуудыг 3 бүлэг болгон салгахад хэрэглэгддэг бэлгэдэл.",
            precision: "Үзүүлсэн дугаарын хувьд decimal цэгийн дараа хэдэн цифрийг хадгалахыг хязгаарлана."
        },
        currencymask: {
            prefix: "Үнэ цэнийн өмнө үзүүлэх нэг эсвэл хэд хэдэн бэлгэдлүүдийг.",
            suffix: "Үнэ цэнийн дараа үзүүлэх нэг эсвэл хэд хэдэн бэлгэдлүүдийг."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "Гарчиг",
            title: "'Нэр'-тэй адилхан бол хоосон орхих."
        },
        multiSelect: "Олон сонголтыг зөвшөөрөх",
        showLabel: "Зургийн тайлбар харуулах",
        swapOrder: "Тийм, Үгүй гэсэн дарааллыг соль",
        value: "Утга",
        tabAlign: "Хавтас байрлуулах",
        sourceType: "Эх сурвалжийн төрөл",
        fitToContainer: "Сав баглаа боодолд тохирно",
        setValueExpression: "Эрхэмлэх чанарыг илэрхийлэхийг тогтоо",
        description: "Тайлбар",
        logoFit: "Лого",
        pages: "Хуудаснууд",
        questions: "Асуултууд",
        triggers: "Схемүүд",
        calculatedValues: "Тооцоолсон утгууд",
        surveyId: "Санал асуулгын ID",
        surveyPostId: "Санал асуулгын нийтлэлийн ID",
        surveyShowDataSaving: "Санал асуулга өгөгдөл хадгалж байхад харуулах",
        questionDescriptionLocation: "Асуултын тайлбарын байршил",
        progressBarType: "Явцын мөрний төрөл",
        showTOC: "TOC харуулах",
        tocLocation: "Toc байршил",
        questionTitlePattern: "Асуултын гарчгийн загвар",
        widthMode: "Өргөн горим",
        showBrandInfo: "Брэнд мэдээллийг харуулах",
        useDisplayValuesInDynamicTexts: "Динамик текстэд харуулах утгыг хэрэглэх",
        visibleIf: "Харагдана хэрэв",
        defaultValueExpression: "Үндсэн утгын илэрхийлэл",
        requiredIf: "Заавал бөглөх хэрэв",
        resetValueIf: "Хэрэв үнэ цэнээ дахин тогтоох",
        setValueIf: "Хэрэв үнэ цэнийг тогтоо",
        validators: "Батлагч",
        bindings: "Холбогч",
        renderAs: "руу хөрвүүлэх",
        attachOriginalItems: "Эх элементүүдийг хавсаргах",
        choices: "Сонголтууд",
        choicesByUrl: "Url сонолтууд",
        currency: "Мөнгөн тэмдэгт",
        cellHint: "Жишээ утга",
        totalMaximumFractionDigits: "Нийт хамгийн их бутархай тоонууд",
        totalMinimumFractionDigits: "Нийт хамгийн бага бутархай тоонууд",
        columns: "Баганууд",
        detailElements: "Дэлгэрэнгүй элементүүд",
        allowAdaptiveActions: "Дасан зохицох үйлдлийг зөвшөөрөх",
        defaultRowValue: "Үндсэн мөрийн утга",
        detailPanelShowOnAdding: "Нэмэж байх үед нарийвчилсан панел харуулах",
        choicesLazyLoadEnabled: "Choices lazy load enabled",
        choicesLazyLoadPageSize: "Choices lazy load page size",
        inputFieldComponent: "Оролтын утгын бүрэлдэхүүн",
        itemComponent: "Элементийн бүрэлдэхүүн",
        min: "Хамгийн бага",
        max: "Хамгийн их",
        minValueExpression: "Хамгийн бага утгын илэрхийлэл",
        maxValueExpression: "Хамгийн их утгын илэрхийлэл",
        step: "Алхам",
        dataList: "Өгөгдлийн жагсаалт",
        itemSize: "Элементийн хэмжээ",
        itemTitleWidth: "Барааны шошгоны өргөн (px-д)",
        elements: "Элементүүд",
        content: "Контент",
        navigationButtonsVisibility: "Чиглүүлэх товчны харагдац",
        navigationTitle: "Чиглүүлэгчийн гарчиг",
        navigationDescription: "Чиглүүлэгчийн тайлбар",
        longTap: "Long tap",
        autoGrow: "Автоматаар нэмэх",
        allowResize: "Дахин сэргээх боломж олго",
        acceptCarriageReturn: "Accept carriage return",
        displayMode: "Дэлгэцийн горим",
        rateType: "Дамжуулах хурд",
        label: "Шошго",
        contentMode: "Контентийн горим",
        imageFit: "Зураг багтаах",
        altText: "Тайлбар",
        height: "Өндөр",
        penColor: "Балны өнгө",
        backgroundColor: "Дэвсгэр өнгө",
        templateElements: "Загварын элементүүд",
        operator: "Operator",
        isVariable: "Хувьсах чадвартай",
        runExpression: "илэрхийлэлг ажиллуулах",
        showCaption: "Тайлбар харуулах",
        iconName: "Дүрсийн нэр",
        iconSize: "Дүрсийн хэмжээ",
        precision: "Нарийвчлал",
        matrixDragHandleArea: "Матриц чирэх бариулын талбай",
        backgroundImage: "Ар талын зураг",
        backgroundImageFit: "Ар талын зураг тохирно",
        backgroundImageAttachment: "Ар талын зургийн хавсралт",
        backgroundOpacity: "Ар талын харанхуй байдал",
        selectToRankEnabled: "Боломжтой зэрэглэлийг сонгох",
        selectToRankAreasLayout: "Бүсүүдийн загварыг сонгох",
        selectToRankEmptyRankedAreaText: "Бүх сонголтыг сонгосон эсэхийг харуулах текст",
        selectToRankEmptyUnrankedAreaText: "Хаягийн бүсэд байрлах газар эзэмшигчийн текст",
        allowCameraAccess: "Камераар нэвтрэх боломж олгох",
        scaleColorMode: "Масштабын өнгө загвар",
        rateColorMode: "Хэмжээ өнгөний хэв маяг",
        copyDisplayValue: "Copy display value",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Дэвшилтэт хэв маяг",
        pageTitle: "Хуудасны нэрийн фонт",
        questionTitle: "Асуулт нэрийн фонт",
        editorPanel: "Оролтын элемент",
        lines: "Шугам",
        primaryDefaultColor: "Дефолт",
        primaryDarkColor: "Ховер",
        primaryLightColor: "Сонгосон",
        backgroundDimColor: "Ар талын өнгө",
        cornerRadius: "Булангийн радиус",
        backcolor: "Дефолт нөхцөл байдал",
        hovercolor: "Hover-ийн гарал үүсэл",
        borderDecoration: "Хилийн чимэг",
        fontColor: "Фонтын өнгө",
        backgroundColor: "Ар талын өнгө",
        primaryForecolor: "Дефолт өнгө",
        primaryForecolorLight: "Хөгжлийн бэрхшээлтэй хүний өнгө",
        font: "Фонт",
        borderDefault: "Илүү харанхуй",
        borderLight: "Гэрэлтэй",
        fontFamily: "Фонтын гэр бүл",
        fontWeightRegular: "Тогтмол",
        fontWeightHeavy: "Хүнд",
        fontWeightSemiBold: "Хагас зоригтой",
        fontWeightBold: "Болд",
        color: "Өнгө",
        placeholderColor: "Газар эзэмшигчийн өнгө",
        size: "Хэмжээ",
        opacity: "Бүдүүлэг байдал",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Сүүдрийн эффект нэмэх",
        boxShadowBlur: "Блур",
        boxShadowSpread: "Тархалт",
        boxShadowDrop: "Дусал",
        boxShadowInner: "Дотоод",
        names: {
            default: "Дефолт",
            sharp: "Хурц",
            borderless: "Хил хязгааргүй",
            flat: "Хавтгай",
            plain: "Энгийн",
            doubleborder: "Хоёр хил",
            layered: "Давхарласан",
            solid: "Бат бөх",
            threedimensional: ".3D",
            contrast: "Эсрэг тэсрэг"
        },
        colors: {
            teal: "Цайл",
            blue: "Цэнхэр",
            purple: "Пүрвээ",
            orchid: "Орхон",
            tulip: "Тюлип",
            brown: "Браун",
            green: "Ногоон"
        }
    }
};
// Uncomment the line below if you create a custom dictionary.
// Replace "en" with a custom locale code (for example, "fr" or "de"),
// Replace `enStrings` with the name of the variable that contains the custom dictionary.
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["mn"] = mnStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// ed.themeSurvey: "Themes" => "Сэдвүүд"
// ed.themePropertyGridTitle: "Theme Settings" => "Сэдвийн тохиргоо"
// ed.themeExportButton: "Export" => "Экспорт"
// ed.themeImportButton: "Import" => "Импорт"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Сонголтыг хуулбарладаг"
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Энд зураг чирж унагаах эсвэл доорх товчийг дарж татаж авах зургийг сонгоно уу"
// ed.imageChooseImage: "Choose Image" => "Зураг сонгох"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "тодорхой асуултын үнэ цэнэ: {0}"
// pe.overridingPropertyPrefix: "Set by " => "Дэргэд нь "
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "\"Item\", \"монгол\", \"panel\", \"row\" гэсэн үгсийн нөөц үгийг бүү хэрэглэ."
// pe.allowResizeComment: "Allow users to resize text areas" => "Хэрэглэгчдэд текстийн газруудыг дахин ашиглах боломж олго"
// pe.rateCount: "Rate count" => "Үнэ тогтоох"
// pe.autoGenerate: "How to specify rate values?" => "Үнэ цэнийг хэрхэн тодорхойлох вэ?"
// pe.minSelectedChoices: "Minimum selected choices" => "Хамгийн бага сонгосон сонголт"
// pe.rateType: "Rate type" => "Rate төрөл"
// pv.tab: "Tabs" => "Табууд"
// inputType.color: "Color" => "Өнгө"
// inputType.date: "Date" => "Огноо"
// inputType.datetime-local: "Date and Time" => "Огноо, цаг"
// inputType.email: "Email" => "И-мэйл"
// inputType.month: "Month" => "Сар"
// inputType.number: "Number" => "Тоо хэмжээ"
// inputType.password: "Password" => "Нууц үг"
// inputType.range: "Range" => "Хамрах хүрээ"
// inputType.tel: "Phone Number" => "Утасны дугаар"
// inputType.text: "Text" => "Текст"
// inputType.time: "Time" => "Цаг хугацаа"
// inputType.url: "URL" => "URL"
// inputType.week: "Week" => "Долоо хоног"
// rateColorMode.default: "Default" => "Дефолт"
// autoGenerate.true: "Generate" => "Үүсгэх"
// autoGenerate.false: "Enter manually" => "Гараар оруул"
// rateType.labels: "Labels" => "Labels"
// rateType.stars: "Stars" => "Одод"
// rateType.smileys: "Smileys" => "Инээмсэглэл"
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Оролт гаралтын талбарын үзэгдэх талбайг дахин тохируулах. Оролтын уртыг <b>хязгаарлахын тулд Validation → Maximum урт</b> тохиргоог ашиглана уу."
// p.allowResize: "Allow resizing" => "Дахин сэргээх боломж олго"
// p.precision: "Precision" => "Нарийвчлал"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Матриц чирэх бариулын талбай"
// p.backgroundImage: "Background image" => "Ар талын зураг"
// p.backgroundImageFit: "Background image fit" => "Ар талын зураг тохирно"
// p.backgroundImageAttachment: "Background image attachment" => "Ар талын зургийн хавсралт"
// p.backgroundOpacity: "Background opacity" => "Ар талын харанхуй байдал"
// p.selectToRankEnabled: "Select to rank enabled" => "Боломжтой зэрэглэлийг сонгох"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Бүсүүдийн загварыг сонгох"
// p.allowCameraAccess: "Allow camera access" => "Камераар нэвтрэх боломж олгох"
// p.scaleColorMode: "Scale color mode" => "Масштабын өнгө загвар"
// p.rateColorMode: "Rate color mode" => "Хэмжээ өнгөний хэв маяг"
// p.templateTabTitle: "Template tab title" => "Template tab цол"
// p.templateVisibleIf: "Template visible if" => "Хэрэв Template харагдах"
// p.copyDisplayValue: "Copy display value" => "Copy display value"
// theme.--background: "Background color" => "Ар талын өнгө"
// theme.--background-dim-light: "Background dim light color" => "Ар талын бүдэг гэрэл өнгө"
// theme.--primary-foreground: "Primary foreground color" => "Хүүхдийн хэсгийн өмнөх өнгө"
// theme.--foreground: "Foreground color" => "Өнгөө"
// theme.--base-unit: "Base unit" => "Үндсэн нэгж"
// theme.groupAdvanced: "Advanced" => "Өндөр хөгжсөн"
// theme.themeName: "Theme" => "Сэдэв"
// theme.isPanellessss: "Question appearance" => "Асуулт хариултын төрх"
// theme.isPanellessPanels: "Default" => "Дефолт"
// theme.isPanellessLightweight: "Without Panels" => "Панелгүйгээр"
// theme.themePaletteLight: "Light" => "Гэрэл"
// theme.themePaletteDark: "Dark" => "Харанхуй"
// theme.primaryColor: "Accent color" => "Акцент өнгө"
// theme.primaryDefaultColor: "Default" => "Дефолт"
// theme.primaryDarkColor: "Hover" => "Ховер"
// theme.primaryLightColor: "Selected" => "Сонгосон"
// theme.backgroundDimColor: "Background color" => "Ар талын өнгө"
// theme.backgroundImage: "Background image" => "Ар талын зураг"
// theme.backgroundImageFitAuto: "Auto" => "Авто"
// theme.backgroundImageFitCover: "Cover" => "Хөшиг"
// theme.backgroundImageFitContain: "Contain" => "Агуулах"
// theme.backgroundOpacity: "Opacity" => "Бүдүүлэг байдал"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Зассан"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Хуйлмал бичиг"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Панелийн ар талын харанхуй байдал"
// theme.questionBackgroundTransparency: "Question background opacity" => "Асуулт хариултын нөхцөл байдал"
// theme.questionPanel: "Panel background and corner radius" => "Панелийн ар талын болон булангийн радиус"
// theme.questionTitle: "Question title font" => "Асуулт нэрийн фонт"
// theme.questionDescription: "Question description font" => "Асуултын тодорхойлолтын фонт"
// theme.editorPanel: "Input element" => "Оролтын элемент"
// theme.editorFont: "Input element font" => "Оролтын элементийн фонт"
// theme.backcolor: "Default background" => "Дефолт нөхцөл байдал"
// theme.hovercolor: "Hover background" => "Hover-ийн гарал үүсэл"
// theme.borderDecoration: "Border decoration" => "Хилийн чимэг"
// theme.accentBackground: "Accent background" => "Акцентийн гарал үүсэл"
// theme.accentForeground: "Accent foreground" => "Акцентийн өмнө"
// theme.primaryForecolor: "Default color" => "Дефолт өнгө"
// theme.primaryForecolorLight: "Disabled color" => "Хөгжлийн бэрхшээлтэй хүний өнгө"
// theme.linesColors: "Minor line colors" => "Бага шугаман өнгө"
// theme.borderDefault: "Darker" => "Илүү харанхуй"
// theme.borderLight: "Lighter" => "Гэрэлтэй"
// theme.fontFamily: "Font family" => "Фонтын гэр бүл"
// theme.fontSize: "Font size" => "Фонтын хэмжээ"
// theme.color: "Color" => "Өнгө"
// theme.size: "Size" => "Хэмжээ"
// theme.fontWeightRegular: "Regular" => "Тогтмол"
// theme.fontWeightHeavy: "Heavy" => "Хүнд"
// theme.fontWeightSemiBold: "Semi-bold" => "Хагас зоригтой"
// theme.fontWeightBold: "Bold" => "Болд"
// theme.scale: "Scale" => "Хэмжүүр"
// theme.cornerRadius: "Corner radius" => "Булангийн радиус"
// theme.surveyTitleFont: "Survey title font" => "Судалгааны нэрийн фонт"
// theme.pageTitle: "Page title font" => "Хуудасны нэрийн фонт"
// theme.pageDescription: "Page description font" => "Хуудасны дүрслэлийн фонт"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Сүүдрийн эффект нэмэх"
// theme.opacity: "Opacity" => "Бүдүүлэг байдал"
// theme.boxShadowBlur: "Blur" => "Блур"
// theme.boxShadowSpread: "Spread" => "Тархалт"
// theme.boxShadowDrop: "Drop" => "Дусал"
// theme.boxShadowInner: "Inner" => "Дотоод"
// theme.questionShadow: "Shadow effects" => "Сүүдрийн нөлөө"
// theme.editorShadow: "Input element shadow effects" => "Оролт элементийн сүүдрийн нөлөө"
// names.default: "Default" => "Дефолт"
// names.contrast: "Contrast" => "Эсрэг тэсрэг"
// names.plain: "Plain" => "Энгийн"
// names.simple: "Simple" => "Энгийн"
// names.blank: "Blank" => "Хоосон"
// names.double: "Double" => "Хоёр дахин"
// names.bulk: "Bulk" => "Булк"
// names.pseudo-3d: "Pseudo 3D" => "Псевдо 3D"
// names.playful: "Playful" => "Тоглосон"
// names.ultra: "Ultra" => "Ультра"
// colors.teal: "Teal" => "Цайл"
// colors.blue: "Blue" => "Цэнхэр"
// colors.purple: "Purple" => "Пүрвээ"
// colors.orchid: "Orchid" => "Орхон"
// colors.tulip: "Tulip" => "Тюлип"
// colors.brown: "Brown" => "Браун"
// colors.green: "Green" => "Ногоон"
// names.sharp: "Sharp" => "Хурц"
// names.borderless: "Borderless" => "Хил хязгааргүй"
// names.flat: "Flat" => "Хавтгай"
// names.doubleborder: "Double Border" => "Хоёр хил"
// names.layered: "Layered" => "Давхарласан"
// names.solid: "Solid" => "Бат бөх"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Та энэ хэлний бүх уяаг арилгахыг хүсэж байгаа гэдэгтээ итгэлтэй байна уу?"
// ed.themeResetButton: "Reset theme settings to default" => "Дахин сэдэвчилсэн тохиргоог default хийх"
// theme.placeholderColor: "Placeholder color" => "Газар эзэмшигчийн өнгө"
// ed.themeSettings: "Theme Settings" => "Сэдвийн тохиргоо"
// ed.themeSettingsTooltip: "Open theme settings" => "Нээлттэй сэдвийн тохиргоо"
// pe.resetToDefaultCaption: "Reset" => "Дахин тохируулах"
// pv.file: "Local files" => "Орон нутгийн файлууд"
// pv.camera: "Camera" => "Камер"
// pv.file-camera: "Local files or camera" => "Орон нутгийн файлууд эсвэл камер"
// ed.translateUsigAI: "Auto-translate All" => "Авто-орчуулга Бүгд"
// ed.translationDialogTitle: "Untranslated strings" => "Огт орчуулагдаагүй уяанууд"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Наад зах нь {0} зүйлс оруулна уу"
// lg.question_resetValueName: "Reset question value" => "Асуултын үнэ цэнийг дахин тогтоох"
// lg.column_resetValue: "Reset column value" => "Reset баганын үнэ цэнэ"
// pe.markRequired: "Mark as required" => "Шаардлагын дагуу тэмдэглэгээ хийх"
// pe.removeRequiredMark: "Remove the required mark" => "Шаардлагатай тэмдэглэгээг хасах"
// p.resetValueIf: "Reset value if" => "Хэрэв үнэ цэнээ дахин тогтоох"
// lg.question_setValueName: "Set question value" => "Асуултын үнэ цэнийг тогтоох"
// lg.column_resetValueName: "Reset column value" => "Reset баганын үнэ цэнэ"
// lg.column_setValueName: "Set column value" => "Баганын үнэ цэнийг тогтоох"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Үр дүн нь ямар байгааг байгсад асуултад хариулах илэрхийлэл."
// survey.title: "Title" => "Нүүр"
// page.title: "Title" => "Нүүр"
// p.setValueIf: "Set value if" => "Хэрэв үнэ цэнийг тогтоо"
// theme.header: "Header" => "Толгойлогч"
// theme.backgroundImageFitFill: "Stretch" => "Сэнгэрч"
// theme.backgroundImageFitTile: "Tile" => "Тил"
// theme.headerView: "View" => "Үзэх"
// theme.headerViewBasic: "Basic" => "Үндсэн"
// theme.headerViewAdvanced: "Advanced" => "Өндөр хөгжсөн"
// theme.headerInheritWidthFrom: "Content area width" => "Агуулгын бүсийн өргөн"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Судалгаатай адил"
// theme.headerInheritWidthFromPage: "Fit to page" => "Хуудсанд тохирсон"
// theme.headerTextAreaWidth: "Text width" => "Текстийн өргөн"
// theme.headerBackgroundColorSwitch: "Background color" => "Ар талын өнгө"
// theme.headerBackgroundColorNone: "None" => "Хэн ч биш"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Акцент өнгө"
// theme.headerBackgroundColorCustom: "Custom" => "Үйлчилгээ"
// theme.horizontalAlignmentLeft: "Left" => "Зүүн"
// theme.horizontalAlignmentCenter: "Center" => "Төв"
// theme.horizontalAlignmentRight: "Right" => "Баруун талд"
// theme.verticalAlignmentTop: "Top" => "Дээд"
// theme.verticalAlignmentMiddle: "Middle" => "Дунд"
// theme.verticalAlignmentBottom: "Bottom" => "Доод"
// theme.logoPosition: "Logo Position" => "Лого байрлал"
// theme.headerDescriptionPosition: "Description Position" => "Тодорхойлолтын байрлал"
// lg.question_resetValueText: "reset value for question: {0}" => "асуултын үнэ цэнийг дахин тогтоох нь: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "үнэ цэнийг даалгах нь: {1} асуулт: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "баганын эсийн үнэ цэнийг дахин тогтоох: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "эсийн үнэ цэнийг хуваарил: {1} багана: {0}"
// ed.surveyJsonExportButton: "Export" => "Экспорт"
// ed.surveyJsonImportButton: "Import" => "Импорт"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Хавчуургыг хуулах"
// pe.filePlaceholder: "File placeholder text" => "Файл байршуулагчийн текст"
// pe.photoPlaceholder: "Photo placeholder text" => "Гэрэл зураг байршуулагч бичвэр"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Файл эсвэл гэрэл зураг байршуулагч текст"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "\"Эх сурвалжийн төрөл\" нь \"Орон нутгийн файлууд\" эсвэл камер байхгүй үед хамаарна"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "\"Эх сурвалжийн төрөл\" \"Камер\" байхад хамаарна."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "\"Эх сурвалжийн төрөл\" нь \"Орон нутгийн файлууд буюу камер\" байхад хамаарна."
// theme.background: "Background" => "Ар талын"
// theme.appearance: "Appearance" => "Харагдах байдал"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Та сэдвийг дахин хөндөхийг үнэхээр хүсэж байна уу? Таны бүх тохируулга үгүй болно."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Тийм ээ, сэдвийг дахин тохируулах"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Сав баглаа боодолд тохирно"
// signaturepad.showPlaceholder: "Show the placeholder" => "Эзэмшигчийг үзүүл"
// signaturepad.placeholder: "Placeholder text" => "Placeholder текст"
// theme.surveyDescriptionFont: "Survey description font" => "Судалгааны тодорхойлолтын фонт"
// ed.prevFocus: "Focus previous" => "Өмнөх анхаарлаа төвлөрүүлэх"
// ed.nextFocus: "Focus next" => "Дараа нь анхаарлаа төвлөрүүл"
// ed.saveTheme: "Save Theme" => "Сэдэв хадгалах"
// ed.saveThemeTooltip: "Save Theme" => "Сэдэв хадгалах"
// lg.page_requireName: "Make page required" => "Шаардлагатай хуудас хийх"
// lg.panel_requireName: "Make page required" => "Шаардлагатай хуудас хийх"
// signaturepad.signatureWidth: "Signature area width" => "Гарын үсэг зурах хэсгийн өргөн"
// signaturepad.signatureHeight: "Signature area height" => "Гарын үсэг зурах хэсгийн өндөр"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Авто замын тэмдэг тэмдэглэгээний талбай"
// signaturepad.penMinWidth: "Minimum pen width" => "Хамгийн бага үзэгний өргөн"
// signaturepad.penMaxWidth: "Maximum pen width" => "Хамгийн их үзэгний өргөн"
// theme.headerTitlePosition: "Title position" => "Нүүр албан тушаал"
// ed.propertyGridNoResultsFound: "No results found" => "Ямар ч үр дүн олдсонгүй"
// pv.leftRight: "Left and right" => "Зүүн, баруун"
// p.sourceType: "Source type" => "Эх сурвалжийн төрөл"
// p.fitToContainer: "Fit to container" => "Сав баглаа боодолд тохирно"
// p.setValueExpression: "Set value expression" => "Эрхэмлэх чанарыг илэрхийлэхийг тогтоо"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Сонголтыг вэбийн үйлчилгээнээс ачаалдаг."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Тохиргоо руу явах"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Ачаалагдсан сонголтын урьдчилсан үзүүлэлт"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Дараалалд хувилж хариу үйлдэл үзүүлэхээс сэргийлнэ"
// theme.advancedMode: "Advanced mode" => "Дэвшилтэт хэв маяг"
// theme.backgroundCornerRadius: "Background and corner radius" => "Ар талын болон булангийн радиус"
// theme.colorsTitle: "Colors" => "Өнгө"
// theme.font: "Font" => "Фонт"
// theme.lines: "Lines" => "Шугам"
// theme.titleFont: "Title font" => "Нүүр фонт"
// theme.descriptionFont: "Description font" => "Дүрслэлийн фонт"
// theme.shadow: "Shadow effects" => "Сүүдрийн нөлөө"
// ed.translateUsigAIFrom: "Translate from: " => "Аас орчуул: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Хариулах татгалзах боломжийг олго"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Бүү мэд сонголтыг зөвшөөр"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Хариулах татгалзах боломжийг олго"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Бүү мэд сонголтыг зөвшөөр"
// pv.contain: "Contain" => "Агуулах"
// pv.cover: "Cover" => "Хөшиг"
// pv.fill: "Fill" => "Дүүргэлт"
// pe.transposeData: "Transpose rows to columns" => "Багануудад транспозын эгнээ"
// layout.panel: "Layout" => "Layout"
// layout.question: "Layout" => "Layout"
// layout.base: "Layout" => "Layout"
// panel.name: "Panel name" => "Панелийн нэр"
// panel.title: "Panel title" => "Панел цол"
// panel.description: "Panel description" => "Панел дүрслэл"
// panel.visibleIf: "Make the panel visible if" => "Хэрэв панелыг ил гаргах"
// panel.requiredIf: "Make the panel required if" => "Шаардлагатай бол панел хий"
// panel.questionsOrder: "Question order within the panel" => "Хяналтын шатны доторх асуултын дараалал"
// panel.startWithNewLine: "Display the panel on a new line" => "Самбарыг шинэ шугам дээр үзүүл"
// panel.state: "Panel collapse state" => "Панел нурах байдал"
// panel.width: "Inline panel width" => "Инлин хавтан өргөн"
// panel.minWidth: "Minimum panel width" => "Хамгийн бага хавтан өргөн"
// panel.maxWidth: "Maximum panel width" => "Хамгийн их хавтан өргөн"
// panel.showNumber: "Number panels" => "Тооны тавиур"
// paneldynamic.name: "Panel name" => "Панелийн нэр"
// paneldynamic.title: "Panel title" => "Панел цол"
// paneldynamic.description: "Panel description" => "Панел дүрслэл"
// paneldynamic.visibleIf: "Make the panel visible if" => "Хэрэв панелыг ил гаргах"
// paneldynamic.requiredIf: "Make the panel required if" => "Шаардлагатай бол панел хий"
// paneldynamic.page: "Move the panel to page" => "Самбарыг хуудас руу зөөх"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Самбарыг шинэ шугам дээр үзүүл"
// paneldynamic.state: "Panel collapse state" => "Панел нурах байдал"
// paneldynamic.width: "Inline panel width" => "Инлин хавтан өргөн"
// paneldynamic.minWidth: "Minimum panel width" => "Хамгийн бага хавтан өргөн"
// paneldynamic.maxWidth: "Maximum panel width" => "Хамгийн их хавтан өргөн"
// paneldynamic.templateDescription: "Panel description pattern" => "Панел дүрслэлийн загвар"
// paneldynamic.templateTitle: "Panel title pattern" => "Панелийн нэрийн загвар"
// paneldynamic.noEntriesText: "Empty panel text" => "Хоосон хавтан текст"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Таб нэрийн загвар"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Хувь хүний панелыг ил гаргах"
// paneldynamic.hideNumber: "Hide the panel number" => "Хавтангийн дугаарыг нуух"
// paneldynamic.titleLocation: "Panel title alignment" => "Панел цолны зохицуулалт"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Панел дүрслэлийн зохицуулалт"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Асуулт нэрийн уялдаа"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Алдааны мессежийн зохицуулалт"
// paneldynamic.newPanelPosition: "New panel location" => "Шинэ панелийн байршил"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Дараах асуултад хувилж хариулахаас сэргийлье"
// question.name: "Question name" => "Асуулт нэр"
// question.title: "Question title" => "Асуулт гарчиг"
// question.description: "Question description" => "Асуултын тодорхойлолт"
// question.visibleIf: "Make the question visible if" => "Асуултыг ил тод болгох"
// question.requiredIf: "Make the question required if" => "Шаардлагатай асуултыг тавих"
// question.state: "Question box collapse state" => "Асуултын хайрцаг нурах байдал"
// question.hideNumber: "Hide the question number" => "Асуултын дугаарыг нуух"
// question.titleLocation: "Question title alignment" => "Асуулт нэрийн уялдаа"
// question.descriptionLocation: "Question description alignment" => "Асуулт тодорхойлолтын зохицуулалт"
// question.errorLocation: "Error message alignment" => "Алдааны мессежийн зохицуулалт"
// question.indent: "Increase the inner indent" => "Дотоод индентийг нэмэгдүүлэх"
// question.width: "Inline question width" => "Инлайн асуултын өргөн"
// question.minWidth: "Minimum question width" => "Хамгийн бага асуултын өргөн"
// question.maxWidth: "Maximum question width" => "Хамгийн их асуултын өргөн"
// question.textUpdateMode: "Update input field value" => "Оролтын талбайн үнэ цэнийг шинэчлэх"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Гарын үсэг зурах хэсэгт Clear товчийг харуул"
// signaturepad.penColor: "Stroke color" => "Судасны өнгө"
// comment.rows: "Input field height (in lines)" => "Оролтын талбайн өндөр (шугамд)"
// expression.name: "Expression name" => "Илэрхийллийн нэр"
// expression.title: "Expression title" => "Өгүүлбэрийн гарчиг"
// expression.description: "Expression description" => "Илэрхийллийн тодорхойлолт"
// expression.expression: "Expression" => "Өгүүлбэр"
// trigger.expression: "Expression" => "Өгүүлбэр"
// calculatedvalue.expression: "Expression" => "Өгүүлбэр"
// survey.description: "Survey description" => "Судалгааны тодорхойлолт"
// page.name: "Page name" => "Хуудасны нэр"
// page.description: "Page description" => "Хуудасны тодорхойлолт"
// page.visibleIf: "Make the page visible if" => "Хуудсыг ил тод болгох"
// page.requiredIf: "Make the page required if" => "Шаардлагатай хуудсыг хий"
// page.questionsOrder: "Question order on the page" => "Асуулт самбар хуудсан дээр"
// matrixdropdowncolumn.name: "Column name" => "Баганын нэр"
// matrixdropdowncolumn.title: "Column title" => "Баганын нэр"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Хуулбарласан хариу үйлдэл үзүүлэхээс сэргийлье"
// matrixdropdowncolumn.width: "Column width" => "Баганын өргөн"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Баганын хамгийн бага өргөн"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Оролтын талбайн өндөр (шугамд)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Хэрэв баганыг харах боломжтой болго"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Шаардлагатай баганыг хий"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Тус тусдаа баганад байгаа сонголт бүр"
// multipletextitem.name: "Name" => "Нэр"
// multipletextitem.title: "Title" => "Нүүр"
// pe.rateDescriptionLocation: "Label alignment" => "Шошгоны зохицл"
// pe.cellErrorLocation: "Cell error message alignment" => "Эсийн алдааны мессежийн зохицуулалт"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Танд ямар ч багана байхгүй"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Чамд ямар ч мөр байхгүй"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Танд ямар нэгэн баталгаажуулалтын дүрэм байхгүй байна"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Танд ямар ч хувийн хувьсагч байхгүй"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Танд ямар ч өдөөгч байхгүй"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Танд ямар ч холбоос байхгүй"
// pe.addNew@columns: "Add new column" => "Шинэ багана нэмэх"
// pe.addNew@rows: "Add new row" => "Шинэ мөр нэмэх"
// pe.addNew@validators: "Add new rule" => "Шинэ дүрэм нэмэх"
// pe.addNew@calculatedValues: "Add new variable" => "Шинэ хувьсагч нэмэх"
// pe.addNew@triggers: "Add new trigger" => "Шинэ триггер нэмэх"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Шинэ URL нэмэх"
// choicesbyurl.url: "Web service's URL" => "Вэб үйлчилгээний URL"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Хөгжил дэвшлийн тавцан дахь хуудасны гарчгыг харуул"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Хуудасны дугааруудыг progress bar-д харуулах"
// itemvalue.visibleIf: "Make the option visible if" => "Хэрэв сонголтыг ил тод болго"
// itemvalue.enableIf: "Make the option selectable if" => "Сонголтыг сонговол"
// panel.layout: "Panel Layout" => "Panel Layout"
// tabs.questionSettings: "Question Settings" => "Асуултын тохиргоо"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Экс.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Экс.: categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Экс.: а)"
// pe.width_placeholder: "Ex.: 6in" => "Экс.: 6ин"
// pe.minWidth_placeholder: "Ex.: 600px" => "Экс: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Экс: 50%"
// pv.selected: "Selected" => "Сонгосон"
// pv.unselected: "Unselected" => "Сонгогдоогүй"
// pv.center: "Center" => "Төв"
// pv.middle: "Middle" => "Дунд"
// pv.next: "Next" => "Дараа нь"
// pv.last: "Last" => "Сүүлчийнх нь"
// clearIfInvisible.none: "Never" => "Хэзээ ч"
// questionsOnPageMode.standard: "Original structure" => "Оригинал бүтэц"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Бүх асуултыг нэг хуудсан дээр харуул"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Хуудас тус бүрт ганц асуултыг харуул"
// pv.auto: "Auto" => "Авто"
// panelsState.firstExpanded: "First expanded" => "Анх өргөтгөн"
// rateColorMode.scale: "Scale" => "Хэмжүүр"
// scaleColorMode.monochrome: "Monochrome" => "Монхор"
// scaleColorMode.colored: "Colored" => "Өнгөлсөн"
// state.default: "Locked" => "Цоожтой"
// showQuestionNumbers.default: "Auto-numbering" => "Авто машины дугаар олгох"
// showQuestionNumbers.on: "Auto-numbering" => "Авто машины дугаар олгох"
// showQuestionNumbers.onPage: "Reset on each page" => "Хуудас бүр дээр дахин тохируулах"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Тавиур бүр дээр дахин тавих"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Тавиур бүр дээр дахин тавих"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Судалгааг үргэлжлүүлэн хийх"
// showQuestionNumbers.off: "No numbering" => "Дугаарлахгүй"
// descriptionLocation.underTitle: "Under the question title" => "Асуултын нэрийн дор"
// descriptionLocation.underInput: "Under the input field" => "Оролтын талбарын дор"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Дараа нь сонголт"
// selectToRankAreasLayout.vertical: "Above choices" => "Дээрх сонголтууд"
// displayStyle.decimal: "Decimal" => "Decimal"
// displayStyle.currency: "Currency" => "Валютын ханш"
// displayStyle.percent: "Percentage" => "Хувь"
// displayStyle.date: "Date" => "Огноо"
// totalDisplayStyle.decimal: "Decimal" => "Decimal"
// totalDisplayStyle.currency: "Currency" => "Валютын ханш"
// totalDisplayStyle.percent: "Percentage" => "Хувь"
// totalDisplayStyle.date: "Date" => "Огноо"
// rowsOrder.initial: "Original" => "Оргил"
// questionsOrder.initial: "Original" => "Оргил"
// showProgressBar.aboveheader: "Above the header" => "Толгой дээгүүр"
// showProgressBar.belowheader: "Below the header" => "Гарчигны доор"
// pv.sum: "Sum" => "Сум"
// pv.count: "Count" => "Тооллого"
// pv.min: "Min" => "Мин"
// pv.max: "Max" => "Макс"
// pv.avg: "Avg" => "Авг"
// searchMode.contains: "Contains" => "Агуулах"
// searchMode.startsWith: "Starts with" => "Эхлэл"
// panel.name: "A panel ID that is not visible to respondents." => "Хариулагчдад харагдахгүй панелийн ID."
// panel.description: "Type a panel subtitle." => "Панелийн дэд гарчиг бичнэ."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Ид шидийн wand зургыг ашиглан панелийн харагдах байдлыг тодорхойлох нөхцөлийн дүрмийг тогтоо."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Зөвхөн унших хэв маягийг хаах нөхцөлтэй дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Наад зах нь нэг үүрээ засах асуулт хариулт байхгүй л бол судалгаа явуулахаас сэргийлдэг нөхцөлийн дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Энэ хэлэлцүүлгийн бүх асуултад хамаарна. Хэрэв та энэ тохиргоог хүчингүй болгохыг хүсвэл хувь хүний асуултуудад зориулсан нэрийн зохицуулах дүрмүүдийг тодорхойл. \"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог (\"Top\" нь default-аар) хэрэгжүүлдэг."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Хяналтын шатны бүх асуулттай холбогдуулан алдааны мессежийн байршлыг тогтооно. \"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог хэрэгжүүлдэг."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Асуултуудын анхны дарааллыг хадгалах эсвэл санамсаргүйгээр авч явдаг. \"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог хэрэгжүүлдэг."
// panel.page: "Repositions the panel to the end of a selected page." => "Сонгосон хуудасны төгсгөлд панелийг дахин байршуулах."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Панелийн агуулга болон панелийн хайрцагны зүүн хилийн хооронд зай эсвэл зай нэмнэ."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Өмнөх асуулт эсвэл панелтай нэг мөрт үзүүлэхээр сонгогдоогүй. Хэрэв панел нь таны маягт дахь анхны элемент бол тохиргоо хамаарахгүй."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Сонголтоос: \"Өргөтгөсөн\" - хавтанг бүрэн харуулж, нурааж болно; \"Нурсан\" - панел нь зөвхөн гарчиг, тодорхойлолтыг харуулж, өргөтгөх боломжтой; \"Цоожтой\" - панелыг бүрэн харуулсан бөгөөд нурааж болохгүй."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Панелийн өргөнийг ижил шугамаар бусад судалгааны элементүүдтэй тэнцүү тогтооно. CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "Хариулагчдад харагдахгүй панелийн ID."
// paneldynamic.description: "Type a panel subtitle." => "Панелийн дэд гарчиг бичнэ."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Ид шидийн wand зургыг ашиглан панелийн харагдах байдлыг тодорхойлох нөхцөлийн дүрмийг тогтоо."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Зөвхөн унших хэв маягийг хаах нөхцөлтэй дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Наад зах нь нэг үүрээ засах асуулт хариулт байхгүй л бол судалгаа явуулахаас сэргийлдэг нөхцөлийн дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Энэ хэлэлцүүлгийн бүх асуултад хамаарна. Хэрэв та энэ тохиргоог хүчингүй болгохыг хүсвэл хувь хүний асуултуудад зориулсан нэрийн зохицуулах дүрмүүдийг тодорхойл. \"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог (\"Top\" нь default-аар) хэрэгжүүлдэг."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Алдааны мессежийн байршлыг хүчингүй оруулсан асуулттай холбон тогтооно. Аль нэгийг сонгоно уу: \"Топ\" - асуултын хайрцагны дээд хэсэгт алдаа текст байрлуулсан байна; \"Bottom\" - асуултын хайрцагны доод хэсэгт алдаа текст байрлуулна. \"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог (\"Top\" нь default-аар) хэрэгжүүлдэг."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Хяналтын шатны бүх асуулттай холбогдуулан алдааны мессежийн байршлыг тогтооно. \"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог хэрэгжүүлдэг."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Сонгосон хуудасны төгсгөлд панелийг дахин байршуулах."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Панелийн агуулга болон панелийн хайрцагны зүүн хилийн хооронд зай эсвэл зай нэмнэ."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Өмнөх асуулт эсвэл панелтай нэг мөрт үзүүлэхээр сонгогдоогүй. Хэрэв панел нь таны маягт дахь анхны элемент бол тохиргоо хамаарахгүй."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Сонголтоос: \"Өргөтгөсөн\" - хавтанг бүрэн харуулж, нурааж болно; \"Нурсан\" - панел нь зөвхөн гарчиг, тодорхойлолтыг харуулж, өргөтгөх боломжтой; \"Цоожтой\" - панелыг бүрэн харуулсан бөгөөд нурааж болохгүй."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Панелийн өргөнийг ижил шугамаар бусад судалгааны элементүүдтэй тэнцүү тогтооно. CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Динамик панел цолны темплэйтэд бичнэ. Харагдах панелуудын дунд түүний дарааллыг {panelIndex} болон {visiblePanelIndex} -ийг ашиглана уу. Автомат дугаар нэмэхийн тулд эдгээр байрлагчдыг загварт оруул."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Таб нэрний темплэйтэд бичнэ. {panelIndex} нь панелийн ерөнхий байрлал болон {visiblePanelIndex} -ийг ил харагдах панелуудын дунд эмх цэгцтэй байлгахад ашиглана. Автомат дугаар нэмэхийн тулд эдгээр байрлагчдыг загварт оруул."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Энэ тохиргоо нь динамик панелын доторх хувь хүний панелын харагдах байдлыг хянах боломжийг олгодог. '{panel}' байрлуулагчийг ашиглан одоогийн панелийг өөрийн илэрхийлэлд эш татна уу."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Энэ тохиргоо нь энэ панел доторх бүх асуултаар автоматаар өвлөгддөг. Хэрэв та энэ тохиргоог хүчингүй болгохыг хүсвэл хувь хүний асуултуудад зориулсан нэрийн зохицуулах дүрмүүдийг тодорхойл. \"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог (\"Top\" нь default-аар) хэрэгжүүлдэг."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "\"Өв залгамжлах\" сонголт нь хуудасны түвшин (хэрэв set) эсвэл судалгааны түвшний тохиргоог (\"Under the panel title\" -ийг default-аар) хэрэгжүүлдэг."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Шинээр нэмэгдсэн панелийн байр суурийг тодорхойлно. Default-ээр төгсгөл рүү шинэ панелуудыг нэмдэг. Одоогийн панел дараа нь шинэ панел оруулахын тулд \"Next\"-ийг сонго."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Сүүлийн панелын хариултыг хувилж, дараагийн нэмэлт динамик хавтанд хуваарилна."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Энэ асуултад хэрэглэгчээс панел бүрт өвөрмөц хариулт өгөхийг шаардахын тулд асуултын нэрийг эш тат."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Энэ тохиргоо нь илэрхийллийн үндсэн дээр дефолт хариултын үнэ цэнийг даалгах боломжийг олгодог. Илэрхийлэл нь үндсэн тооцоо - '{q1_id} + {q2_id}', Бөүлийн илэрхийллүүд, тухайлбал '{age} > 60', функц: 'iif()', 'өнөөдөр()', 'мин()', 'мин()', 'max()', 'avg()', г.м. Энэ илэрхийлэлээр тодорхойлогддог үнэ цэнэ нь хариулагчийн гарын авлагын оролтоор давхардуулан авч болох анхны дефолтын үнэ цэнэ болж өгдөг."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "\"Default value expression\" эсвэл \"Set value expression\" эсвэл \"Default answer\" value (хэрэв аль нэгийг нь тогтоосон бол) үнэ цэнэд үндэслэн хариулагчийн оруулсан хувь нэмрийг үнэ цэнэд хэзээ дахин тохируулахыг тодорхойлох нөхцөлтэй дүрмийг тогтоохын тулд шидэт wand зургыг ашигла."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Ид шидийн wand зургыг ашиглан \"Set value expression\"-ийг хэзээ ажиллуулахыг тодорхойлох нөхцөлтэй дүрмийг тогтоож, үр дүнд хүрсэн үнэ цэнийг хариу болгон динамикаар даалга."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "\"Set value if\" дүрмийн нөхцөл хангагдсан үед тогтоох үнэ цэнийг тодорхойлсон илэрхийллийг тодорхойл. Илэрхийлэл нь үндсэн тооцоо - '{q1_id} + {q2_id}', Бөүлийн илэрхийллүүд, тухайлбал '{age} > 60', функц: 'iif()', 'өнөөдөр()', 'мин()', 'мин()', 'max()', 'avg()', г.м. Энэ илэрхийлэлээр тогтоосон үнэ цэнийг хариулагчийн гарын авлагын оролтоор давхардуулан авч болно."
// question.name: "A question ID that is not visible to respondents." => "Асуултад хариулагчдад харагдахгүй асуултын ID."
// question.description: "Type a question subtitle." => "Асуултын дэд гарчиг бичнэ үү."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Асуултын харагдах байдлыг тодорхойлох нөхцөлийн дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Асуултын зөвхөн унших хэв маягийг хаах нөхцөлтэй дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Асуулт хариулт аваагүй л бол судалгааг урагшлуулах эсвэл ирүүлэхэд саад болох нөхцөлийн дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Асуултыг өмнөх асуулт эсвэл панелтай нэг мөрт харуулахаар сонгогдоогүй. Асуулт нь таны маягт дахь анхны элемент бол тохиргоо хамаарахгүй."
// question.page: "Repositions the question to the end of a selected page." => "Асуултыг сонгосон хуудасны төгсгөлд буцааж тавих."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Сонгох: \"Өргөтгөсөн\" - асуултын хайрцгийг бүрэн харуулсан бөгөөд нурж болно; \"Нурж унасан\" - асуултын хайрцаг нь зөвхөн гарчиг, дүрслэлийг харуулж, өргөтгөх боломжтой; \"Locked\" - асуултын хайрцгийг бүрэн харуулсан бөгөөд нурж болохгүй."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Нэрийн зохицлын дүрмүүдийг панел, хуудас эсвэл судалгааны түвшин дээр тодорхойлсон байдаг. \"Өв залгамжлах\" сонголт нь ямар ч өндөр түвшний тохиргоог (хэрэв set) эсвэл судалгааны түвшний тохиргоог (\"Top\" нь default-аар) хэрэгжүүлдэг."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "\"Өв залгамж\" сонголт нь судалгааны түвшний тохиргоог хэрэгжүүлдэг (\"Асуултын гарчиг доор\" гэсэн сонголтыг сонголтоор)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Асуулттай холбоотой алдааны мессежийн байршлыг хүчингүй оруулсан байдлаар тогтооно. Аль нэгийг сонгоно уу: \"Топ\" - асуултын хайрцагны дээд хэсэгт алдаа текст байрлуулсан байна; \"Bottom\" - асуултын хайрцагны доод хэсэгт алдаа текст байрлуулна. \"Өв залгамж\" сонголт нь судалгааны түвшний тохиргоог (\"Top\" by default) хэрэгжүүлдэг."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Асуултын агуулга болон асуултын хайрцагны зүүн хил хоёрын хооронд зай эсвэл зай нэмнэ."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Асуултын өргөнийг нэг мөрт бусад судалгааны элементүүдтэй тэнцүү байдлаар тогтооно. CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Асуултын баталгаажуулалтын дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Сонгоно уу: \"Алдагдсан фокус дээр\" - оролтын талбар анхаарлаа алдсан үед үнэ цэнэ нь шинэчлэгддэг; \"Цахимаар бичих\" - хэрэглэгчид бичихийн хэрээр үнэ цэнэ нь бодит цаг хугацаанд шинэчлэгддэг. \"Өв залгамж\" сонголт нь судалгааны түвшний тохиргоог (\"Алдагдсан фокус дээр\" дефолтоор) хэрэгжүүлдэг."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Та ямар ч вэб үйлчилгээг олон сонголттой асуултуудад мэдээллийн эх сурвалж болгон ашиглаж болно. Сонголтын үнэт зүйлсийг хүн амлахын тулд өгөгдөл өгөх үйлчилгээний URL-ийг оруулна уу."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Дуслын жагсаалтыг шүүлт хийхэд ашигладаг харьцуулах мэс засал."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Үзүүлсэн гарын үсэг зурсан хэсгийн өргөнийг болон үүний үр дүнд бий болсон зургийг тогтоо."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Үзүүлсэн гарын үсэг зурсан хэсгийн өндрийг болон үүний үр дүнд бий болсон зургийг тогтооно."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Хэрэв та гарын үсэг зурах талбайгаа асуултын хайрцаг доторх бүх боломжит зайг бөглөж, стандарт 3:2 талын харьцааг хадгалахыг хүсэж байвал сонго. Custom өргөн, өндөр үнэ цэнийг тогтоох үед тохиргоо нь эдгээр хэмжээсийн тал харьцааг хадгална."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Судалгааны үр дүнгээр дүрсний өндрийг тохируулна."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Судалгааны үр дүн дэх зургийн өргөнийг тохируулна."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Хамгийн бага болон хамгийн их өндөр үнэ цэнийг давхардна."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Хамгийн бага, хамгийн их өргөний үнэ цэнийг давхардалд оруулах."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Үнэ цэнэ\" гэж нөхцөлийн дүрэмд хэрэглэгддэг эд зүйлийн ID-ээр үйлчилдэг; \"Текст\" гэж хариулагчдад тавигддаг."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Энэ тохиргоо нь зөвхөн оролтын талбарыг дахин тохируулдаг бөгөөд асуултын хайрцагны өргөнд нөлөөлдөггүй. Хүлээн зөвшөөрөгдсөн оролтын уртыг хязгаарлахын тулд <b>Validation→ Maximum character limit</b> руу орно уу."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Оролтын талбар дахь харуулсан мөрүүдийн тоог тогтооно. Хэрэв оролт нь илүү олон мөртэй бол хуйлмал тавиур гарч ирнэ."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Аль нэгийг нь сонгох: \"Editable\" - таны судалгааг бөглөх боломжийг санал асуулгад оролцогчдын хувьд олгодог; \"Зөвхөн уншлага\" - хөгжлийн бэрхшээлтэй хүмүүс редакци үүсгэнэ."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "Хариулагчдад харагдахгүй байгаа баганын ID."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Баганыг авах боломжтой бол асуултад хариулагч нь энэ баганан доторх асуулт бүрд өвөрмөц хариулт өгөх шаардлагатай."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Оролтын талбар дахь харуулсан мөрүүдийн тоог тогтооно. Хэрэв оролт нь илүү олон мөртэй бол хуйлмал тавиур гарч ирнэ."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Ид шидийн wand icon-ийг ашиглан баганын харагдах байдлыг тодорхойлох нөхцөлтэй дүрмийг тогтоо."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Шидэт wand зургыг ашиглан баганын зөвхөн унших хэв маягийг хаах нөхцөлтэй дүрмийг тогтоо."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Наад зах нь нэг үүрээ засах асуулт хариулт байхгүй л бол судалгаа явуулахаас сэргийлдэг нөхцөлийн дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Сонгогдсон тохиолдолд сонголт бүрд зориулж багана үүсгэнэ."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Сонгоно уу: \"Статик\" - тогтмол өргөнийг тогтоох; \"Responsive\" - судалгааг дэлгэцийн бүрэн өргөнийг эзэлдэг болгодог; \"Авто\" - ашигласан асуултын төрлөөс хамааран аль нэгийг нь хэрэглэнэ."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Зургийн холбоосыг (хэмжээ хязгаар байхгүй) эсвэл фолдерын icon дарж компьютерээсээ файлыг (64KB хүртэл) харна уу."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "CSS нэгж (px, %, in, pt, гэх мэт) дээр логоны өргөнийг тогтооно."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "CSS нэгж (px, %, in, pt г.м) дээр логоны өндрийг тогтооно."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Сонгоно уу: \"None\" - зураг анхны хэмжээгээ хадгалдаг; \"Агуулах\" - дүрсийг тал харьцаагаа хадгалахын зэрэгцээ тохируулахын тулд дахин тохируулдаг; \"Cover\" - дүрс нь тал харьцаагаа хадгалахын зэрэгцээ хайрцгийг бүхэлд нь дүүргэдэг; \"Fill\" - дүрс нь тал харьцаагаа хадгалахгүйгээр хайрцгийг дүүргэхийн тулд сунаж тогтсон."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Тухайн хуудас дээрх бүх асуултад хариулагч хариулсны дараа судалгааг автоматаар дараагийн хуудас руу урагшлуулахыг хүсвэл сонгоно уу."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Хуудас дээр навигацийн товчны харагдах байдал, байршлыг тогтооно."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Хэмжилтийн тавцангийн харагдах байдал, байршлыг тогтооно. \"Авто\" үнэ цэнэ нь судалгааны толгой гарчгийн дээр эсвэл түүнээс доош хөгжил дэвшлийн барыг харуулдаг."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Зөвхөн бүх асуултаар эсвэл хариулт бүхий урьдчилан харах хуудсыг боломжтой болго."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Судалгааны бүх асуултад хамаарна. Энэ тохиргоог доод түвшний нэрийн зохицуулах дүрмээр давамгайлах боломжтой: panel, хуудас, эсвэл асуулт. Доод түвшний тохиргоо нь илүү өндөр түвшинд байгаа хүмүүсийг хүчингүй болгоно."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Хариу шаардлагатайг заасан бэлгэдэл буюу бэлгэ тэмдгийн дараалал."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Дугаарлахыг хүссэн дугаар эсвэл захидлаа оруул."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Асуулттай холбоотой алдааны мессежийн байршлыг хүчингүй оруулсан байдлаар тогтооно. Аль нэгийг сонгоно уу: \"Топ\" - асуултын хайрцагны дээд хэсэгт алдаа текст байрлуулсан байна; \"Bottom\" - асуултын хайрцагны доод хэсэгт алдаа текст байрлуулна."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Текст оруулахад бэлэн болсон хуудас бүр дээрх эхний оролтын талбарыг хүсвэл сонгоно уу."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Асуултуудын анхны дарааллыг хадгалах эсвэл санамсаргүйгээр авч явдаг. Энэ тохиргооны үр нөлөө нь зөвхөн Preview таб-д харагдана."
// pehelp.maxTextLength: "For text entry questions only." => "Зөвхөн текст оруулах асуултуудад зориулна."
// pehelp.maxOthersLength: "For question comments only." => "Асуулт хариултын хувьд зөвхөн."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Асуулт хариулт болон Урт Текст асуултыг орсон текст урт дээр үндэслэн өндрөөс автоматаар өсгөхийг хүсвэл сонгоно уу."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Асуулт хариулт болон Урт текстийн асуултуудад зөвхөн."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Үйлчилгээний хувьсагчид нь форм тооцоололд хэрэглэгддэг дундын буюу туслах хувьсагчид болж үйлчилдэг. Тэд хариулагчийн оруулсан хувь нэмрийг эх сурвалжийн үнэт зүйлс гэж үздэг. Custom хувьсагч бүр өвөрмөц нэртэй, дээр нь суурилсан илэрхийлэлтэй байдаг."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Тухайн илэрхийллийн тооцоолсон үнэ цэнийг судалгааны үр дүнгийн хамт хадгалахыг хүсвэл сонгоорой."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Триггер гэдэг нь илэрхийлэлд тулгуурласан үйл явдал буюу нөхцөл байдлыг хэлж байгаа юм. Илэрхийлэлийг \"үнэн\" гэж үнэлсний дараа триггер үйлдэл гаргадаг. Ийм үйлдэл нь үүнд нөлөөлдөг байны асуултыг сонголтоор тавьж болно."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Нөхцөл байдлын логикоор нуусан асуултуудын үнэ цэнийг тодорхой болгох уу, хэзээ хийх үү гэдгийг сонго."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Сонгоно уу: \"Алдагдсан фокус дээр\" - оролтын талбар анхаарлаа алдсан үед үнэ цэнэ нь шинэчлэгддэг; \"Цахимаар бичих\" - хэрэглэгчид бичихийн хэрээр үнэ цэнэ нь бодит цаг хугацаанд шинэчлэгддэг."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Зүүн үнэ цэнэ нь нөхцөлийн дүрэмд хэрэглэгддэг баганын ID болж үйлчилдэг бөгөөд зөв үнэ цэнийг хариулагчдад үзүүлдэг."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Зүүн үнэ цэнэ нь нөхцөлийн дүрэмд хэрэглэгддэг мөрийн ID болж үйлчилдэг, зөв үнэ цэнийг хариулагчдад үзүүлдэг."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Хүчингүй оруулсан эстэй холбоотой алдааны мессежийн байршлыг тогтооно. \"Өв залгамж\" сонголт нь \"Error message alignment\" өмчийн тохиргоог хэрэгжүүлдэг."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "\"Хуулбарласан хариу арга хэмжээ авахаас урьдчилан сэргийлье\" өмчийг боломжтой болгоход хуулбарлан оруулахыг оролдсон хариулагч дараах алдааны мэдээг хүлээн авна."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Илэрхийллийн үндсэн дээр нийт үнэт зүйлсийг тооцох боломжийг танд олгож байна. Илэрхийлэл нь үндсэн тооцоо ('{q1_id} + {q2_id}'), Бөүлийн илэрхийллүүд ('{нас} > 60') функцууд ('iif()', 'өнөөдөр()', 'мин()', 'мин()', 'max()', 'avg()', г.м."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Дарааллыг арилгахыг батлахыг хүссэн өдөөлтийг өдөөв."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Сүүлийн мөрнөөс хариултуудыг хуулбарлаж, дараагийн нэмэлт динамик мөрөнд хуваарилна."
// pehelp.description: "Type a subtitle." => "Дэд гарчиг бичнэ."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Судалгаагаа хийж эхлэх хэл сонго. Орчуулга нэмэхийн тулд шинэ хэл рүү шилжиж, эх бичвэрийг энд эсвэл Translations tab-д орчуулна."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Нарийвчилсан хэсгийн байршлыг дараалалтай холбон тогтооно. Сонголтоос: \"Үгүй\" - ямар ч өргөтгөл нэмэгдсэнгүй; \"Мөрийн доор\" - матрицын мөр бүрийн доор эгнээний өргөтгөл байрлуулна; \"Мөрийн доор зөвхөн нэг эгнээний өргөтгөлийг үзүүл\" - зөвхөн нэг эгнээний дор өргөтгөл үзүүлдэг, үлдсэн эгнээний өргөтгөлүүд нь нурдаг."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Сонгоно уу: \"None\" - зураг анхны хэмжээгээ хадгалдаг; \"Агуулах\" - дүрсийг тал харьцаагаа хадгалахын зэрэгцээ тохируулахын тулд дахин тохируулдаг; \"Cover\" - дүрс нь тал харьцаагаа хадгалахын зэрэгцээ хайрцгийг бүхэлд нь дүүргэдэг; \"Fill\" - дүрс нь тал харьцаагаа хадгалахгүйгээр хайрцгийг дүүргэхийн тулд сунаж тогтсон."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Өгөгдлийг оруулж байгаа үед оролтын талбайн өндрийг аажмаар нэмэгдүүлдэг. \"Input талбарын өндрийг (in lines)\" тохиргоог давхардна."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Resize бариул (эсвэл бариул) буланд гарч, оролтын талбарын хэмжээг өөрчлөхийн тулд чирэгдэж болно."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Цаг хугацааны интервал секундын дотор. Үүний дараа судалгаа автоматаар \"Thank You\" хуудас руу орж байна."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Судалгааны автоматаар дараагийн хуудас руу урагшлах секундын дотор цаг хугацаа."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Судалгааны автоматаар дараагийн хуудас руу урагшлах секундын дотор цаг хугацаа."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Илбийн wand icon-ийг ашиглан хуудасны харагдах байдлыг тодорхойлох нөхцөлтэй дүрэм тогтооно."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Зөвхөн хуудсанд зориулсан унших хэв маягийг хаах нөхцөлтэй дүрмийг тогтоохын тулд шидэт wand зургыг ашигла."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Наад зах нь нэг үүрээ засах асуулт хариулт байхгүй л бол судалгаа явуулахаас сэргийлдэг нөхцөлийн дүрмийг тогтоохын тулд шидэт туузны зургыг ашигла."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Энэ хуудсан дахь бүх асуултад хамаарна. Хэрэв та энэ тохиргоог хүчингүй болгохыг хүсвэл хувь хүний асуулт эсвэл панелуудын нэрийн зохицуулах дүрмүүдийг тодорхойл. \"Өв залгамж\" сонголт нь судалгааны түвшний тохиргоог (\"Top\" by default) хэрэгжүүлдэг."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Асуулттай холбоотой алдааны мессежийн байршлыг хүчингүй оруулсан байдлаар тогтооно. Аль нэгийг сонгоно уу: \"Топ\" - асуултын хайрцагны дээд хэсэгт алдаа текст байрлуулсан байна; \"Bottom\" - асуултын хайрцагны доод хэсэгт алдаа текст байрлуулна. \"Өв залгамж\" сонголт нь судалгааны түвшний тохиргоог (\"Top\" by default) хэрэгжүүлдэг."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Асуултуудын анхны дарааллыг хадгалах эсвэл санамсаргүйгээр авч явдаг. \"Өв залгамж\" сонголт нь судалгааны түвшний тохиргоог (\"Оригинал\" дефолтоор) хэрэгжүүлдэг. Энэ тохиргооны үр нөлөө нь зөвхөн Preview таб-д харагдана."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Хуудсан дээр навигацийн товчны харагдах байдлыг тогтоо. \"Өв залгамжлах\" хувилбар нь \"Үзэгдэх\" гэсэн сонголт бүхий судалгааны түвшний тохиргоог хэрэгжүүлдэг."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Хуудас дээр цаг хэмжигч харагдах байдал, байршлыг тогтооно."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Сонгоно уу: \"Locked\" - хэрэглэгчид панелуудыг өргөтгөх, нураах боломжгүй; \"Бүх нуралт\" - бүх панел нурсан байдлаас эхэлнэ; \"Бүх хүрээг өргөтгөнө\" - бүх панелууд өргөтгөсөн байдлаас эхэлнэ; \"First expanded\" - зөвхөн эхний панел нь эхэндээ өргөжсөн."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Сонгосон жагсаалтанд харуулахыг хүссэн зураг эсвэл видео файл URL-уудыг агуулсан олон тооны эд зүйлсийн дотор хуваалцсан өмчийн нэрийг оруулна уу."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Зүүн үнэ цэнэ нь нөхцөлийн дүрэмд хэрэглэгддэг зүйл ID, зөв үнэ цэнийг хариулагчдад үзүүлдэг."
// pehelp.title: "Type a user-friendly title to display." => "Хэрэглэгчдэд тохиромжтой нэр бичиж харуулах."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Файлуудыг татаж авах хүртэл хэрэглэгчид судалгааг хийж дуусгахгүй байхыг анхаарна."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "Ганц болон олон сонголттой асуултын төрлүүдэд сонголт бүр ID болон харуулах үнэ цэнэтэй байдаг. Энэ тохиргоо нь сонгогдсон тохиолдолд HTML асуулт болон динамик гарчиг, судалгааны элементүүдийн тодорхойлолтод ID үнэ цэнийн оронд харуулах үнэ цэнийг харуулдаг."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Нөхцөл байдлын логикоор нуусан үнэт зүйлсийг тодорхой болгох уу, хэзээ хийх вэ гэдгийг сонго. \"Өв залгамж\" сонголт нь судалгааны түвшний тохиргоог (\"Upon survey completion\" -ийг дефолтоор) хэрэгжүүлдэг."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Сонгоно уу: \"Бүгд\" - сонгосон асуултаас сонголт хийх бүх сонголтыг хуулбарласан; \"Сонгосон\" - динамикаар зөвхөн сонгосон сонголтын хувилбаруудыг хуулбарласан; \"Сонгогдоогүй\" - динамикаар зөвхөн сонгогдоогүй сонголтыг хувилдаг. \"None\" болон \"Бусад\" сонголтууд нь эх сурвалжийн асуулгад боломжтой бол default-ээр хуулагддаг."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Сонгогдсон тохиолдолд хэрэглэгчид тусад нь тайлбарын хайрцагт нэмэлт оруулах боломжтой."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Тусгай сонголт бүрийг (\"None\", \"Other\", \"Select All\") шинэ мөр дээр, бүр олон баганатай загварыг ашиглахдаа ч үзүүлдэг."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Зорилтот олон тооны объект байрладаг үйлчилгээний мэдээллийн сан доторх байршлыг тодорхойл. URL аль хэдийн багц руу зааж байгаа бол хоосон орхи."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Сонголтын жагсаалтад харуулахыг хүссэн үнэт зүйлсээ агуулсан олон тооны эд зүйлсийн дотор дүрэмт өмчийн нэрийг оруулна уу."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Хоосон хариу эсвэл багцыг үйлчлэлд буцааж өгөхийг сонго."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Бүх сонголтын харагдах байдлыг тодорхойлох нөхцөлтэй дүрмийг тогтоохын тулд шидэт wand зургыг ашиглана уу."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Зүүн үнэ цэнэ нь нөхцөлийн дүрэмд хэрэглэгддэг зүйл ID, зөв үнэ цэнийг хариулагчдад үзүүлдэг."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" нь боломжит өргөн дээр суурилсан \"Buttons\" болон \"Dropdown\" загваруудын хооронд сонголт хийнэ. Өргөн нь товчлууруудыг харуулахад хангалтгүй үед асуулт нь дусал дуслыг харуулдаг."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Өөр өөр форматаар үр дүн гаргадаг асуултуудыг холбох боломжийг танд олгож байна. Ийм асуултуудыг join identifier ашиглан холбох үед энэ хуваалцсан өмч хөрөнгийн дэлгүүрүүд нь сонгосон асуултын үнэ цэнийг хадгалдаг."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Хэрэглэгчийн оролтын талбарт бичиж байгаа хайлтын query-тэй тохируулахын тулд дусал цэсний агуулгыг шинэчлэхийг хүсвэл сонгоно уу."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Асуултад хариулсан хүмүүс эерэг хариулт өгөхөд судалгааны үр дүнг хадгалах нь үнэ цэнэтэй."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Судалгаанд оролцогчдын сөрөг хариулт өгөхөд судалгааны үр дүнг хадгалах үнэ цэнэ."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Preview зургийг давхардуулдаг тул энэ сонголтыг хүчингүй болгохыг санал болгодоггүй бөгөөд хэрэглэгчид файлуудыг татаж авсан эсэхийг ойлгоход хэцүү болгодог."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Файлын устгалыг батлахыг хүссэн өдөөлтийг өдөөж байна."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Зөвхөн сонгосон сонголтуудыг зэрэгцүүлэх боломжийг олгоно. Хэрэглэгчид сонгосон зүйлсийг сонгосон жагсаалтаас чирч, зэрэглэлийн бүс дотор тушаана."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Санал болгох сонголтуудын жагсаалтыг оруулах үед хариулагчид санал болгох болно."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Тохиргоо нь зөвхөн оролтын талбаруудыг дахин тохируулдаг бөгөөд асуултын хайрцагны өргөнд нөлөөлдөггүй."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Пикселд бүх зүйлийн шошгоны тогтмол өргөнийг тогтоох"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "\"Авто\" сонголт нь эх сурвалж URL-д суурилсан зураг, видео, эсвэл YouTube - харуулах тохиромжтой хэв маягийг автоматаар тодорхойлдог."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Хэрэглэгчийн төхөөрөмж дээр болон хүртээмжийн зорилгоор дүрсийг харуулах боломжгүй үед орлуулагчаар үйлчилнэ."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Rating icon төрлийн \"Smileys\" гэж тогтооход сонгосон эможигийн өнгийг тодорхойлно. Аль нэгийг нь сонгоно уу: \"Default\" - сонгосон эможи нь стандарт судалгааны өнгөөр гарч ирдэг; \"Scale\" - сонгосон эможи нь үнэлгээний хэмжүүрээс өнгийг өвлөн авдаг."
// expression.name: "An expression ID that is not visible to respondents." => "Хариулагчдад харагдахгүй илэрхийлэл ID."
// expression.description: "Type an expression subtitle." => "Өгүүлбэрийн дэд гарчиг бичнэ."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Илэрхийлэл нь үндсэн тооцоо ('{q1_id} + {q2_id}'), нөхцөл ('{age} > 60'' болон функцууд ('iif()', 'өнөөдөр()', 'мин()', 'мин()', 'max()', 'avg()', г.м."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "\"Бусад\" сонголтын үнэ цэнийг судалгааны үр дүнд тусад нь өмч болгон хадгалахыг сонго."
// p.swapOrder: "Swap the order of Yes and No" => "Тийм, Үгүй гэсэн дарааллыг соль"
// p.itemTitleWidth: "Item label width (in px)" => "Барааны шошгоны өргөн (px-д)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Бүх сонголтыг сонгосон эсэхийг харуулах текст"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Хаягийн бүсэд байрлах газар эзэмшигчийн текст"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Судалгааг автоматаар дуусгах"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Асуултад хариулсан хүн бүх асуултанд хариулсны дараа судалгааг автоматаар дуусгахыг хүсвэл сонго."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Судалгааны үр дүнд багласан үнэ цэнийг хэмнэх"
// patternmask.pattern: "Value pattern" => "Үнэ цэнийн загвар"
// datetimemask.min: "Minimum value" => "Хамгийн бага үнэ цэнэ"
// datetimemask.max: "Maximum value" => "Хамгийн их үнэ цэнэ"
// numericmask.allowNegativeValues: "Allow negative values" => "Сөрөг үнэт зүйлсийг зөвшөөр"
// numericmask.thousandsSeparator: "Thousands separator" => "Мянга мянган тусгаарлагч"
// numericmask.decimalSeparator: "Decimal separator" => "Decimal тусгаарлагч"
// numericmask.precision: "Value precision" => "Үнэ цэнийн нарийвчлал"
// numericmask.min: "Minimum value" => "Хамгийн бага үнэ цэнэ"
// numericmask.max: "Maximum value" => "Хамгийн их үнэ цэнэ"
// currencymask.prefix: "Currency prefix" => "Валютын ханш"
// currencymask.suffix: "Currency suffix" => "Валютын suffix"
// pe.maskType: "Input mask type" => "Оролтын багны төрөл"
// maskTypes.patternmask: "Pattern" => "Загвар"
// maskTypes.numericmask: "Numeric" => "Тоо нь"
// maskTypes.datetimemask: "Date and Time" => "Огноо, цаг"
// maskTypes.currencymask: "Currency" => "Валютын ханш"
// tabs.mask: "Input Mask Settings" => "Оролт Маск тохиргоо"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Экс.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Экс.: мм/д/yyy"
// pe.currencyprefix_placeholder: "Ex.: $" => "Экс.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Экс.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Боолт сонголт"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Сонголтын сонголтуудын урт текстүүд нь дусал цэсний дотор багтахын тулд автоматаар шугамын завсар үүсгэх болно. Хэрэв та бичвэрүүдийг хайчлахыг хүсвэл сонгогдоогүй."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Асуултын үнэ цэнийг судалгааны үр дүнд хэрэгжүүлсэн багаар хадгалахыг хүсэж байгаа эсэхээ сонго."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Загвар нь уянгын шууд болон дараах байрлагчийг агуулж болно: '9' - тоон хувьд; 'a' - дээд буюу доод талын үсгийн хувьд; '#' - цифр эсвэл дээд, эсвэл доод кейс үсгийн хувьд. Дүрээс зугтахын тулд backslash '\\' ашигла."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Загвар нь тусгаарлагч үсэг болон дараах байрлагчуудыг агуулж болно: 'm' - сарын дугаараар; 'мм' - сарын тоогоор, ганц цифрээр үнэ цэнэтэй тэргүүлэх нөлөө бүхий; 'd' - сарын өдөр; 'dd' - ганц цифрээр үнэ цэнэд тэргүүлэх нөлөө бүхий сарын өдөр; 'yy' - жилийн сүүлийн хоёр цифрээр; 'yyyy' - дөрвөн цифрээр жил."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Жижиг хэсгийг үзүүлсэн дугаарын интежер хэсгээс салгахад ашигладаг бэлгэдэл."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Том тооны тоонуудыг 3 бүлэг болгон салгахад хэрэглэгддэг бэлгэдэл."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Үзүүлсэн дугаарын хувьд decimal цэгийн дараа хэдэн цифрийг хадгалахыг хязгаарлана."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Үнэ цэнийн өмнө үзүүлэх нэг эсвэл хэд хэдэн бэлгэдлүүдийг."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Үнэ цэнийн дараа үзүүлэх нэг эсвэл хэд хэдэн бэлгэдлүүдийг."
// ed.translationSource: "Source: " => "Эх сурвалж: "
// ed.translationTarget: "Target: " => "Зорилго: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Хуудас хоосон байна. Багажны хайрцагнаас элементийг чирэх эсвэл доорх товчийг дарна уу."
// maskTypes.none: "None" => "Хэн ч биш"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Хэрэв эгнээг ил гаргах"
// itemvalue@rows.enableIf: "Make the row editable if" => "Хэрэв эгнээг хянан засварлах боломжтой болго"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Зөвхөн унших эсвэл урьдчилан харах хэлбэрээр placeholder текст"
// pe.textWrapEnabled: "Wrap choices" => "Боолт сонголт"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "\"Авто\" сонголт нь эх сурвалж URL-д суурилсан зураг, видео, эсвэл YouTube - харуулах тохиромжтой хэв маягийг автоматаар тодорхойлдог."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Хэвлэл мэдээллийн хэрэгслийн сонгогчийн агуулгын хэв маягийг тогтоохын тулд \"Image\" болон \"Video\" хоёрын аль нэгийг сонго. Хэрэв \"Зураг\" гэж сонгосон бол өгөгдсөн бүх хувилбарууд нь дараах форматаар зургийн файлууд болохыг анхаарна уу: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Үүнтэй адилаар \"Video\" нь сонгогдвол бүх сонголт нь дараах форматаар видео файлуудын шууд холбоосууд болох MP4, MOV, WMV, FLV, AVI, MKV гэсэн форматаар байгаа эсэхийг баталгаажуулаарай. YouTube-ийн холбоосууд видео хувилбараар дэмжигдээгүйг анхаарна уу."
// ed.selectFile: "Select a file" => "Файлыг сонгох"
// ed.removeFile: "Remove the file" => "Файлыг хасах"
// pe.searchMode: "Search Mode" => "Хайлтын Мод"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Доорх \"Асуулт нэмэх\" товчийг дарж формоо үүсгэж эхэлнэ."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Хуудас дээр шинэ элемент нэмэхийн тулд доорх \"Асуулт нэмэх\" товчийг дарна уу."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Доорх \"Асуулт нэмэх\" товчийг дарж панел дээр шинэ элемент нэмнэ."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Доорх товчийг дарж татаж авах зургийг сонгоно уу"
// coloralpha.opacity: "Opacity" => "Бүдүүлэг байдал"
// font.family: "Font family" => "Фонтын гэр бүл"
// font.color: "Color" => "Өнгө"
// font.placeholderColor: "Placeholder color" => "Газар эзэмшигчийн өнгө"
// font.size: "Size" => "Хэмжээ"
// theme.themeName: "Theme" => "Сэдэв"
// theme.isPanelless: "Question appearance" => "Асуулт хариултын төрх"
// theme.editorPanel: "Background and corner radius" => "Ар талын болон булангийн радиус"
// theme.questionPanel: "Background and corner radius" => "Ар талын болон булангийн радиус"
// theme.primaryColor: "Accent color" => "Акцент өнгө"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Панелийн ар талын харанхуй байдал"
// theme.questionBackgroundTransparency: "Question background opacity" => "Асуулт хариултын нөхцөл байдал"
// theme.fontSize: "Font size" => "Фонтын хэмжээ"
// theme.scale: "Scale" => "Хэмжүүр"
// theme.cornerRadius: "Corner radius" => "Булангийн радиус"
// theme.pageTitle: "Title font" => "Нүүр фонт"
// theme.pageDescription: "Description font" => "Дүрслэлийн фонт"
// theme.questionTitle: "Title font" => "Нүүр фонт"
// theme.questionDescription: "Description font" => "Дүрслэлийн фонт"
// theme.editorFont: "Font" => "Фонт"
// theme.backgroundOpacity: "Opacity" => "Бүдүүлэг байдал"
// theme.--sjs-font-family: "Font family" => "Фонтын гэр бүл"
// theme.--sjs-general-backcolor-dim: "Background color" => "Ар талын өнгө"
// theme.--sjs-primary-backcolor: "Accent background" => "Акцентийн гарал үүсэл"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Акцентийн өмнө"
// theme.--sjs-shadow-small: "Shadow effects" => "Сүүдрийн нөлөө"
// theme.--sjs-shadow-inner: "Shadow effects" => "Сүүдрийн нөлөө"
// theme.--sjs-border-default: "Colors" => "Өнгө"
// header@header.headerView: "View" => "Үзэх"
// header@header.logoPosition: "Logo position" => "Лого байрлал"
// header@header.surveyTitle: "Survey title font" => "Судалгааны нэрийн фонт"
// header@header.surveyDescription: "Survey description font" => "Судалгааны тодорхойлолтын фонт"
// header@header.headerTitle: "Survey title font" => "Судалгааны нэрийн фонт"
// header@header.headerDescription: "Survey description font" => "Судалгааны тодорхойлолтын фонт"
// header@header.inheritWidthFrom: "Content area width" => "Агуулгын бүсийн өргөн"
// header@header.textAreaWidth: "Text width" => "Текстийн өргөн"
// header@header.backgroundColorSwitch: "Background color" => "Ар талын өнгө"
// header@header.backgroundImage: "Background image" => "Ар талын зураг"
// header@header.backgroundImageOpacity: "Opacity" => "Бүдүүлэг байдал"
// header@header.overlapEnabled: "Overlap" => "Давхар"
// header@header.logoPositionX: "Logo position" => "Лого байрлал"
// header@header.titlePositionX: "Title position" => "Нүүр албан тушаал"
// header@header.descriptionPositionX: "Description position" => "Тодорхойлолтын байрлал"
// weight.400: "Regular" => "Тогтмол"
// weight.600: "Heavy" => "Хүнд"
// weight.700: "Semi-bold" => "Хагас зоригтой"
// weight.800: "Bold" => "Болд"
// backgroundImageFit.auto: "Auto" => "Авто"
// backgroundImageFit.cover: "Cover" => "Хөшиг"
// backgroundImageFit.contain: "Contain" => "Агуулах"
// backgroundImageFit.fill: "Stretch" => "Шээс"
// backgroundImageFit.tile: "Tile" => "Тил"
// backgroundImageAttachment.fixed: "Fixed" => "Зассан"
// backgroundImageAttachment.scroll: "Scroll" => "Хуйлмал бичиг"
// headerView.basic: "Basic" => "Үндсэн"
// headerView.advanced: "Advanced" => "Өндөр хөгжсөн"
// inheritWidthFrom.survey: "Same as survey" => "Судалгаатай адил"
// inheritWidthFrom.container: "Fit to container" => "Сав баглаа боодолд тохирно"
// backgroundColorSwitch.none: "None" => "Хэн ч биш"
// backgroundColorSwitch.accentColor: "Accent color" => "Акцент өнгө"
// backgroundColorSwitch.custom: "Custom" => "Үйлчилгээ"
// colorPalette.light: "Light" => "Гэрэл"
// colorPalette.dark: "Dark" => "Харанхуй"
// isPanelless.false: "Default" => "Дефолт"
// isPanelless.true: "Without Panels" => "Панелгүйгээр"
// theme.cornerRadius: "Corner radius" => "Булангийн радиус"
// theme.fontFamily: "Font family" => "Фонтын гэр бүл"
// theme.fontWeightRegular: "Regular" => "Тогтмол"
// theme.fontWeightHeavy: "Heavy" => "Хүнд"
// theme.fontWeightSemiBold: "Semi-bold" => "Хагас зоригтой"
// theme.fontWeightBold: "Bold" => "Болд"
// theme.color: "Color" => "Өнгө"
// theme.placeholderColor: "Placeholder color" => "Газар эзэмшигчийн өнгө"
// theme.size: "Size" => "Хэмжээ"
// theme.opacity: "Opacity" => "Бүдүүлэг байдал"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Хайлт хийх төрөл..."
// ed.toolboxNoResultsFound: "No results found" => "Ямар ч үр дүн олдсонгүй"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Таб нэрийн хуудас эзэмшигч"
// theme.--sjs-special-red: "Error messages" => "Алдааны мессеж"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Таб нэрийн загвар утга учиртай үнэ цэнийг бий болгодоггүй үед хамаарах tab title-ийн уналтын текст."
// theme.fontColor: "Font color" => "Фонтын өнгө"
// theme.backgroundColor: "Background color" => "Ар талын өнгө"
// pe.questionTitleWidth: "Question title width" => "Асуулт нэрийн өргөн"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Файл сонгох эсвэл файлын холбоосыг наа..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Экс: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Асуултын хайрцгуудынхаа зүүн талд эгнэн зогсож байх үед асуултын нэрний тогтмол өргөнийг тогтоо. CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Асуултын хайрцгуудынхаа зүүн талд эгнэн зогсож байх үед асуултын нэрний тогтмол өргөнийг тогтоо. CSS-ийн үнэт зүйлсийг (px, %, in, pt г.м) хүлээн зөвшөөрдөг."
// pe.commentAreaRows: "Comment area height (in lines)" => "Тайлбар хэсгийн өндөр (мөрөнд)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Асуулт хариултын текст хэсэгт үзүүлсэн мөрүүдийн тоог тогтоо. Хуйлмал бичиг нь илүү олон мөртэй байдаг."


/***/ }),

/***/ "./src/localization/norwegian.ts":
/*!***************************************!*\
  !*** ./src/localization/norwegian.ts ***!
  \***************************************/
/*! exports provided: nbStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nbStrings", function() { return nbStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var nbStrings = {
    // survey templates
    survey: {
        edit: "Rediger",
        externalHelpLink: "Se og lær hvordan å opprette nye skjema",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Dra og slipp et spørsmål her fra Verktøylisten til venstre.",
        addLogicItem: "Opprett en regel for å skreddersy skjemaflyten",
        copy: "Kopier",
        duplicate: "Duplikat",
        addToToolbox: "Legg til verktøylisten",
        deletePanel: "Slett panel",
        deleteQuestion: "Slett spørsmål",
        convertTo: "Konverter til",
        drag: "Dra element",
    },
    // Creator tabs
    tabs: {
        preview: "Test skjema",
        theme: "Temaer",
        translation: "Oversettelse",
        designer: "Skjemadesigner",
        editor: "JSON-redigering",
        logic: "Skjemalogikk"
    },
    // Question types
    qt: {
        default: "Standard",
        checkbox: "Sjekkboks",
        comment: "Kommentar",
        imagepicker: "Bildevelger",
        ranking: "Rangering",
        image: "Bilde",
        dropdown: "Nedtrekksliste",
        tagbox: "Rullegardinmenyen for flere valg",
        file: "Fil",
        html: "Html",
        matrix: "Matrise (enkelvalg)",
        matrixdropdown: "Matrise (flervalg)",
        matrixdynamic: "Matrise (dynamiske rader)",
        multipletext: "Flerlinjetekst",
        panel: "Panel",
        paneldynamic: "Panel (dynamiske paneler)",
        radiogroup: "Radiogruppe",
        rating: "Rangering",
        text: "Enkel tekst",
        boolean: "Yes/No (Boolean)",
        expression: "Formel",
        signaturepad: "Signatur",
        buttongroup: "Knappegruppe"
    },
    toolboxCategories: {
        general: "Generelt",
        choice: "Choice Spørsmål",
        text: "Spørsmål om tekstinndata",
        containers: "Beholdere",
        matrix: "Matrise Spørsmål",
        misc: "Misc"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Standard ({0})",
        survey: "Skjema",
        settings: "Skjemainnstillinger",
        settingsTooltip: "Åpne skjemainnstillinger",
        surveySettings: "Innstillinger for undersøkelse",
        surveySettingsTooltip: "Innstillinger for undersøkelse",
        themeSettings: "Tema innstillinger",
        themeSettingsTooltip: "Temainnstillinger",
        showPanel: "Vis panel",
        hidePanel: "Skjul panel",
        prevSelected: "Velg forrige",
        nextSelected: "Velg neste",
        prevFocus: "Fokus forrige",
        nextFocus: "Fokus neste",
        surveyTypeName: "Undersøkelse",
        pageTypeName: "Side",
        panelTypeName: "Panel",
        questionTypeName: "Spørsmål",
        columnTypeName: "Kolonne",
        addNewPage: "Legg til ny side",
        moveRight: "Bla til høyre",
        moveLeft: "Bla til venstre",
        deletePage: "Slett side",
        editPage: "Rediger side",
        edit: "Rediger",
        newPageName: "side",
        newQuestionName: "spørsmål",
        newPanelName: "panel",
        newTextItemName: "tekst",
        defaultV2Theme: "Standard",
        modernTheme: "Moderne",
        defaultTheme: "Standard (eldre)",
        testSurveyAgain: "Test skjema igjen",
        testSurveyWidth: "Skjemabredde: ",
        navigateToMsg: "Du måtte navigere til:",
        saveSurvey: "Lagre skjema",
        saveSurveyTooltip: "Lagre skjema",
        saveTheme: "Lagre tema",
        saveThemeTooltip: "Lagre tema",
        jsonHideErrors: "Skjul feil",
        jsonShowErrors: "Vis feil",
        undo: "Angre",
        redo: "Gjenta",
        undoTooltip: "Angre siste endring",
        redoTooltip: "Gjør om siste endring",
        showMoreChoices: "Vis mer",
        showLessChoices: "Vis mindre",
        copy: "Kopier",
        cut: "Kutt",
        paste: "Lim innn",
        copyTooltip: "Kopier valgt seksjon inn i utklippstavla",
        cutTooltip: "Kutt valgt seksjon inn i utklippstavla",
        pasteTooltip: "Lim inn fra utklippstavla",
        options: "Alternativer",
        generateValidJSON: "Lag gyldig JSON",
        generateReadableJSON: "Lag lesbar JSON",
        toolbox: "Verktøyliste",
        "property-grid": "Innstillinger",
        toolboxFilteredTextPlaceholder: "Skriv for å søke ...",
        toolboxNoResultsFound: "Fant ingen resultater",
        propertyGridFilteredTextPlaceholder: "Skriv for å søke ...",
        propertyGridNoResultsFound: "Fant ingen resultater",
        correctJSON: "Vennligst korriger JSON.",
        surveyResults: "Skjemaresultat: ",
        surveyResultsTable: "Som tabell",
        surveyResultsJson: "Som JSON",
        resultsTitle: "Spørsmålstittel",
        resultsName: "Spørsmålsnavn",
        resultsValue: "Svar",
        resultsDisplayValue: "Vist verdi",
        modified: "Endret",
        saving: "Lagrer",
        saved: "Lagret",
        propertyEditorError: "Feil:",
        saveError: "Feil! Skjema innhold er ikke lagret.",
        translationPropertyGridTitle: "Språkinnstillinger",
        themePropertyGridTitle: "Tema innstillinger",
        translationLanguages: "Språk",
        translationDeleteLanguage: "Er du sikker på at du ønsker å slette alle strenger for dette språket?",
        translationAddLanguage: "Velg språk for oversetting",
        translationShowAllStrings: "Vis alle strenger",
        translationShowUsedStringsOnly: "Bare brukte strenger",
        translationShowAllPages: "Vis alle sider",
        translationNoStrings: "Ingen strenger å oversette. Vennligst endre filteret.",
        translationExportToSCVButton: "Eksporter til CSV",
        translationImportFromSCVButton: "Importer fra CSV",
        translateUsigAI: "Oversett alle automatisk",
        translateUsigAIFrom: "Oversett fra: ",
        translationDialogTitle: "Uoversatte strenger",
        translationMergeLocaleWithDefault: "Flett {0} med standard språk",
        translationPlaceHolder: "Oversettelse...",
        translationSource: "Kilde: ",
        translationTarget: "Mål: ",
        themeExportButton: "Eksport",
        themeImportButton: "Importere",
        surveyJsonExportButton: "Eksport",
        surveyJsonImportButton: "Importere",
        surveyJsonCopyButton: "Kopiere til utklippstavlen",
        themeResetButton: "Tilbakestill temainnstillinger til standard",
        themeResetConfirmation: "Vil du virkelig tilbakestille temaet? Alle tilpasningene dine vil gå tapt.",
        themeResetConfirmationOk: "Ja, tilbakestill temaet",
        bold: "Fet",
        italic: "Kursiv",
        underline: "Underlinjet",
        addNewQuestion: "Legg til spørsmål",
        selectPage: "Velg side...",
        carryForwardChoicesCopied: "Valgene kopieres fra",
        choicesLoadedFromWebText: "Valgene lastes inn fra en webtjeneste.",
        choicesLoadedFromWebLinkText: "Gå til innstillinger",
        choicesLoadedFromWebPreviewTitle: "Forhåndsvisning av alternativer for lastet valg",
        htmlPlaceHolder: "HTML-innhold vil være her.",
        panelPlaceHolder: "Slipp et spørsmål fra verktøykassen her.",
        surveyPlaceHolder: "Undersøkelsen er tom. Dra et element fra verktøykassen, eller klikk på knappen nedenfor.",
        pagePlaceHolder: "Siden er tom. Dra et element fra verktøykassen, eller klikk på knappen nedenfor.",
        imagePlaceHolder: "Dra og slipp et bilde her, eller klikk på knappen nedenfor og velg et bilde du vil laste opp",
        surveyPlaceHolderMobile: "Klikk på \"Legg til spørsmål\" -knappen nedenfor for å begynne å lage skjemaet ditt.",
        pagePlaceHolderMobile: "Klikk på \"Legg til spørsmål\" -knappen nedenfor for å legge til et nytt element på siden.",
        panelPlaceHolderMobile: "Klikk på \"Legg til spørsmål\" -knappen nedenfor for å legge til et nytt element i panelet.",
        imagePlaceHolderMobile: "Klikk på knappen nedenfor og velg et bilde du vil laste opp",
        imageChooseImage: "Velg bilde",
        addNewTypeQuestion: "Legg til {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Vare ",
        selectFile: "Velg en fil",
        removeFile: "Fjern filen",
        lg: {
            addNewItem: "Legg til ny regel",
            empty_tab: "Opprett en regel for å tilpasse flyten i evalueringen.",
            page_visibilityName: "Sidesynlighet",
            page_enableName: "Aktivere (deaktivere) side",
            page_requireName: "Gjøre siden obligatorisk",
            panel_visibilityName: "Panelsynlighet",
            panel_enableName: "Panel aktivere/deaktivere",
            panel_requireName: "Gjøre siden obligatorisk",
            question_visibilityName: "Spørsmålssynlghet",
            question_enableName: "Spørsmål aktivere/deaktivere",
            question_requireName: "Spørsmål valgfritt/påkrevd",
            question_resetValueName: "Tilbakestille spørsmålsverdien",
            question_setValueName: "Angi spørsmålsverdi",
            column_visibilityName: "Vis kolonne (skjul)",
            column_enableName: "Aktivere (deaktivere) kolonne",
            column_requireName: "Gjøre kolonne obligatorisk",
            column_resetValueName: "Tilbakestille kolonneverdi",
            column_setValueName: "Angi kolonneverdi",
            trigger_completeName: "Fullfør skjema",
            trigger_setvalueName: "Angi spørsmålsnavn",
            trigger_copyvalueName: "Kopier spørsmålsverdi",
            trigger_skipName: "Hopp til spørsmål",
            trigger_runExpressionName: "Kjør tilpasset formel",
            completedHtmlOnConditionName: "Tilpasset 'Takk-side' tekst",
            page_visibilityDescription: "Gjør siden synlig når formelen evalueres til 'sann', og holder den ellers usynlig.",
            panel_visibilityDescription: "Gjør panelet synlig når formelen evalueres til 'sann', og holder den ellers usynlig.",
            panel_enableDescription: "Aktiverer panelet, og alle elementer inni, når formelen evalueres til 'sann'. I andre tilfeller holdes de deaktivert.",
            question_visibilityDescription: "Gjør spørsmålet synlig når formelen evalueres til 'sann', og holder den ellers usynlig.",
            question_enableDescription: "Aktiverer spørsmålet når formelen evalueres til 'sann', og holder den ellers deaktivert.",
            question_requireDescription: "Spørmsålet blir påkrevd når formelen evalueres til 'sann'.",
            trigger_completeDescription: "Når formelen evalueres til 'sann' fullføres skjemaet og sluttbrukeren ser 'Takk-siden'.",
            trigger_setvalueDescription: "Når spørsmålsverdier som er brukt i formelen endres, og formelen evalueres som 'sann', vil verdien settes i det valgte spørsmålet.",
            trigger_copyvalueDescription: "Når spørsmålsverdier som er brukt i formelen endres, og formelen evalueres som 'sann', vil verdien i et valgt spørsmål kopieres til et annet valgt spørsmål.",
            trigger_skipDescription: "Når formelen evalueres til 'sann' vil skjemaet hoppe til/fokusere på valgt spørsmål.",
            trigger_runExpressionDescription: "Når formelen evauleres til 'sann' vil den tilpassede formelen utføres. Du kan valgfritt sette formelens resultat inn i det valgte spørsmålet.",
            completedHtmlOnConditionDescription: "Hvis formelen evalueres til 'sann' vil standardteksten på 'Takk siden' endres til den gitte teksten.",
            itemExpressionText: "Når formelen: '{0}' evalueres til 'sann':",
            itemEmptyExpressionText: "Ny regel",
            page_visibilityText: "Gjøre side {0} synlig",
            panel_visibilityText: "Gjør panel {0} synlig",
            panel_enableText: "Gjør panel {0} aktivert",
            question_visibilityText: "Gjør spørsmål {0} synlig",
            question_enableText: "Gjør spørsmål {0} aktivert",
            question_requireText: "Gjør spørsmål {0} påkrevd",
            question_resetValueText: "Tilbakestill verdi for spørsmål: {0}",
            question_setValueText: "tilordne verdi: {1} til spørsmålet: {0}",
            column_visibilityText: "Gjør kolonne {0} av spørsmålet {1} synlig",
            column_enableText: "Gjør kolonne {0} av spørsmålet {1} aktiver",
            column_requireText: "Gjør kolonne {0} av spørsmålet {1} nødvendig",
            column_resetValueText: "Tilbakestill celleverdi for kolonne: {0}",
            column_setValueText: "Tilordne celleverdi: {1} til kolonne: {0}",
            setValueExpressionPlaceholder: " Et uttrykk der resultatet tilordnes målspørsmålet.",
            trigger_completeText: "Skjemaet blir fullført",
            trigger_setvalueText: "Sett inn: {0} verdi {1}",
            trigger_setvalueEmptyText: "Klar spørsmålsverdi: {0}",
            trigger_copyvalueText: "Kopier inn: {0} verdi fra spørsmål {1}",
            trigger_skipText: "Hopp til spørsmål {0}",
            trigger_runExpressionText1: "Kjør formel: '{0}'",
            trigger_runExpressionText2: " og sett inn resultatet i spørsmål: {0}",
            completedHtmlOnConditionText: "Vis tilpasset tekst for 'Takk-siden'.",
            showAllQuestions: "Alle spørsmål",
            showAllActionTypes: "Alle handlingstyper",
            conditions: "Vilkår",
            actions: "Handling(er)",
            expressionEditorTitle: "Definer vilkår",
            actionsEditorTitle: "Definer handling(er)",
            deleteAction: "Slett handling",
            addNewAction: "Legg til handling",
            selectedActionCaption: "Velg handling som skal legges til...",
            expressionInvalid: "Formelen er tom eller ugyldig. Vennligst korriger den.",
            noActionError: "Vennligst legg til minst en handling",
            actionInvalid: "Vennligst korriger problemer med handlingen.",
            uncompletedRule_title: "Logiske regler er ufullstendige",
            uncompletedRule_text: "Noen av de logiske reglene har du ikke fullført. Hvis du forlater fanen nå, vil endringene gå tapt. Vil du fortsatt forlate fanen uten å fullføre endringene?",
            uncompletedRule_apply: "Ja",
            uncompletedRule_cancel: "Nei, jeg vil fullføre reglene"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Navn på panel",
            title: "Panelets tittel",
            description: "Beskrivelse av panelet",
            visibleIf: "Gjør panelet synlig hvis",
            requiredIf: "Gjør panelet nødvendig hvis",
            questionsOrder: "Spørsmålsrekkefølge i panelet",
            page: "Overordnet side",
            startWithNewLine: "Vise panelet på en ny linje",
            state: "Status for panelskjuling",
            width: "Innebygd panelbredde",
            minWidth: "Minimum panelbredde",
            maxWidth: "Maksimal panelbredde",
            showNumber: "Nummerpaneler"
        },
        paneldynamic: {
            name: "Navn på panel",
            title: "Panelets tittel",
            description: "Beskrivelse av panelet",
            visibleIf: "Gjør panelet synlig hvis",
            requiredIf: "Gjør panelet nødvendig hvis",
            page: "Flytte panelet til siden",
            startWithNewLine: "Vise panelet på en ny linje",
            state: "Status for panelskjuling",
            width: "Innebygd panelbredde",
            minWidth: "Minimum panelbredde",
            maxWidth: "Maksimal panelbredde",
            confirmDelete: "Bekreft sletting av panel",
            templateDescription: "Mønster for panelbeskrivelse",
            templateTitle: "Mønster for paneltittel",
            noEntriesText: "Tom paneltekst",
            templateTabTitle: "Mønster for tabulatortittel",
            tabTitlePlaceholder: "Plassholder for tabulatortittel",
            templateVisibleIf: "Gjør et individuelt panel synlig hvis",
            hideNumber: "Skjule panelnummeret",
            titleLocation: "Justering av paneltittel",
            descriptionLocation: "Justering av panelbeskrivelse",
            templateTitleLocation: "Justering av spørsmålstittel",
            templateErrorLocation: "Justering av feilmelding",
            newPanelPosition: "Ny panelplassering",
            keyName: "Forhindre dupliserte svar i følgende spørsmål"
        },
        question: {
            name: "Spørsmål navn",
            title: "Spørsmål tittel",
            description: "Beskrivelse av spørsmål",
            visibleIf: "Gjør spørsmålet synlig hvis",
            requiredIf: "Gjør spørsmålet nødvendig hvis",
            page: "Overordnet side",
            state: "Skjul tilstand for spørsmålsboks",
            hideNumber: "Skjul spørsmålsnummeret",
            titleLocation: "Justering av spørsmålstittel",
            descriptionLocation: "Justering av spørsmålsbeskrivelse",
            errorLocation: "Justering av feilmelding",
            indent: "Øke det indre innrykket",
            width: "Bredde på innebygde spørsmål",
            minWidth: "Minimum spørsmålsbredde",
            maxWidth: "Maksimal spørsmålsbredde",
            textUpdateMode: "Oppdatere verdien for inndatafelt"
        },
        signaturepad: {
            signatureWidth: "Bredde på signaturområde",
            signatureHeight: "Høyde på signaturområdet",
            signatureAutoScaleEnabled: "Skalere signaturområdet automatisk",
            showPlaceholder: "Vise plassholderen",
            placeholder: "Plassholdertekst",
            placeholderReadOnly: "Plassholdertekst i skrivebeskyttet modus eller forhåndsvisningsmodus",
            allowClear: "Vise Fjern-knappen i signaturområdet",
            penMinWidth: "Minimum pennebredde",
            penMaxWidth: "Maksimal pennebredde",
            penColor: "Strekfarge"
        },
        comment: {
            rows: "Høyde på inndatafelt (i linjer)"
        },
        showQuestionNumbers: "Vis spørsmålsnummer",
        questionStartIndex: "Spørsmål startindeks (1, 2 eller 'A', 'a')",
        expression: {
            name: "Navn på uttrykk",
            title: "Tittel på uttrykk",
            description: "Beskrivelse av uttrykk",
            expression: "Uttrykk"
        },
        trigger: {
            expression: "Uttrykk"
        },
        calculatedvalue: {
            expression: "Uttrykk"
        },
        // survey templates
        survey: {
            title: "Tittel",
            description: "Beskrivelse av undersøkelsen"
        },
        page: {
            name: "Sidenavn",
            title: "Tittel",
            description: "Beskrivelse av siden",
            visibleIf: "Gjøre siden synlig hvis",
            requiredIf: "Gjør siden obligatorisk hvis",
            maxTimeToFinish: "Tidsbegrensning for å fullføre siden (i sekunder)",
            questionsOrder: "Spørsmålsrekkefølge på siden"
        },
        matrixdropdowncolumn: {
            name: "Navn på kolonne",
            title: "Kolonne tittel",
            isUnique: "Forhindre dupliserte svar",
            width: "Kolonnebredden",
            minWidth: "Minimum kolonnebredde",
            rows: "Høyde på inndatafelt (i linjer)",
            visibleIf: "Gjøre kolonnen synlig hvis",
            requiredIf: "Gjør kolonnen obligatorisk hvis",
            showInMultipleColumns: "Hvert alternativ i en egen kolonne"
        },
        multipletextitem: {
            name: "Navn",
            title: "Tittel"
        },
        masksettings: {
            saveMaskedValue: "Lagre maskert verdi i undersøkelsesresultater"
        },
        patternmask: {
            pattern: "Verdimønster"
        },
        datetimemask: {
            min: "Minimumsverdi",
            max: "Maksimumsverdi"
        },
        numericmask: {
            allowNegativeValues: "Tillat negative verdier",
            thousandsSeparator: "Tusenskilletegn",
            decimalSeparator: "Desimalskilletegn",
            precision: "Prisgunstig presisjon",
            min: "Minimumsverdi",
            max: "Maksimumsverdi"
        },
        currencymask: {
            prefix: "Prefiks for valuta",
            suffix: "Valutasuffiks"
        },
        imageHeight: "Bildehøyde",
        imageWidth: "Bildebredde",
        valueName: "Verdinavn",
        rateDescriptionLocation: "Justering av etiketter",
        size: "Størrelse på inndatafelt (i tegn)",
        cellErrorLocation: "Justering av cellefeilmelding",
        apply: "Bruk",
        ok: "OK",
        save: "Lagre",
        clear: "Klar",
        saveTooltip: "Lagre",
        cancel: "Avbryt",
        set: "Sett",
        reset: "Tilbakestill",
        change: "Forandre",
        refresh: "Last inn på nytt",
        close: "Lukke",
        delete: "Slett",
        add: "Legg til",
        addNew: "Legg til ny",
        addItem: "Klikk for å legge til...",
        removeItem: "Klikk for å fjerne elementet...",
        dragItem: "Dra elementet",
        addOther: "Annet",
        addSelectAll: "Velg alt",
        addNone: "Ingen",
        removeAll: "Fjern alt",
        edit: "Rediger",
        back: "Gå tilbake uten å lagre",
        backTooltip: "Gå tilbake uten å lagre",
        saveAndBack: "Lagre og gå tilbake",
        saveAndBackTooltip: "Lagre og gå tilbake",
        doneEditing: "Gjort",
        editChoices: "Rediger valg",
        showChoices: "Vis valg",
        move: "Flytt",
        empty: "<tom>",
        emptyValue: "Verdien er tom",
        fastEntry: "Rask innfylling",
        fastEntryNonUniqueError: "Verdien «{0}» er ikke unik",
        fastEntryChoicesCountError: "Begrens antall varer fra {0} til {1}",
        fastEntryChoicesMinCountError: "Vennligst skriv inn minst {0} elementer",
        fastEntryPlaceholder: "Du kan angi data i følgende format:\nverdi1|tekst\nverdi2",
        formEntry: "Innfylling i skjema",
        testService: "Sjekk tjenesten",
        itemSelectorEmpty: "Vennligst velg elementet",
        conditionActionEmpty: "Velg handlingen",
        conditionSelectQuestion: "Velg spørsmål...",
        conditionSelectPage: "Velg side...",
        conditionSelectPanel: "Velg panel...",
        conditionValueQuestionTitle: "Vennligst skriv inn/velg verdi",
        aceEditorHelp: "Trykk ctrl+mellomrom for å få hint til å fullføre formler",
        aceEditorRowTitle: "Gjeldende rad",
        aceEditorPanelTitle: "Gjeldende panel",
        showMore: "For mer detaljer - se dokumentasjonen",
        assistantTitle: "Tilgjengelige spørsmål:",
        cellsEmptyRowsColumns: "Det må være minst 1 kolonne eller rad",
        showPreviewBeforeComplete: "Forhåndsvise svar før du sender inn undersøkelsen",
        overridingPropertyPrefix: "Sett av ",
        resetToDefaultCaption: "Nullstille",
        propertyIsEmpty: "Vennligst fyll inn en verdi",
        propertyIsNoUnique: "Angi en unik verdi",
        propertyNameIsNotUnique: "Vennligst fyll inn et unikt navn",
        propertyNameIsIncorrect: "Ikke bruk reserverte ord: \"element\", \"valg\", \"panel\", \"rad\".",
        listIsEmpty: "Legg til nytt element",
        "listIsEmpty@choices": "Ingen valg er lagt til ennå",
        "listIsEmpty@columns": "Du har ingen kolonner ennå",
        "listIsEmpty@rows": "Du har ingen rader ennå",
        "listIsEmpty@validators": "Du har ingen valideringsregler ennå",
        "listIsEmpty@calculatedValues": "Du har ingen egendefinerte variabler ennå",
        "listIsEmpty@triggers": "Du har ingen utløsere ennå",
        "listIsEmpty@navigateToUrlOnCondition": "Du har ingen koblinger ennå",
        "addNew@choices": "Legg til et valg",
        "addNew@columns": "Legg til ny kolonne",
        "addNew@rows": "Legg til ny rad",
        "addNew@validators": "Legg til ny regel",
        "addNew@calculatedValues": "Legg til ny variabel",
        "addNew@triggers": "Legg til ny utløser",
        "addNew@navigateToUrlOnCondition": "Legg til ny URL-adresse",
        expressionIsEmpty: "Formelen er tom",
        value: "Verdi",
        text: "Tekst",
        rowid: "Rad-ID",
        imageLink: "Bildelenke",
        columnEdit: "Rediger kolonne: {0}",
        itemEdit: "Rediger element: {0}",
        url: "URL",
        path: "Sti",
        choicesbyurl: {
            url: "URL-adressen til webtjenesten",
            valueName: "Hent verdier fra følgende JSON-felt"
        },
        titleName: "Tittelnavn",
        imageLinkName: "Hent bildenettadresser fra følgende JSON-felt",
        allowEmptyResponse: "Tillat tom respons",
        titlePlaceholder: "Skriv tittel her",
        surveyTitlePlaceholder: "Skriv skjematittel her",
        pageTitlePlaceholder: "Skriv sidetittel her",
        descriptionPlaceholder: "Skriv beskrivelse",
        surveyDescriptionPlaceholder: "Skriv skjema-beskrivelse",
        pageDescriptionPlaceholder: "Skriv side-beskrivelse",
        textWrapEnabled: "Valg for innpakning",
        showOtherItem: "Har annet element",
        otherText: "Annet element-tekst",
        showNoneItem: "Har velg ingen",
        showRefuseItem: "Tillat alternativet Nekt å svare",
        showDontKnowItem: "Tillat alternativet Vet ikke",
        noneText: "Velg ingen-tekst",
        showSelectAllItem: "Har velg alt-element",
        selectAllText: "Velg alt elememt-tekst",
        choicesMin: "Minsteverdi for auto-genererte elementer",
        choicesMax: "Maksverdi for auto-genererte elementer",
        choicesStep: "Forskjellene mellom auto-genererte elementer",
        name: "Navn",
        title: "Tittel",
        cellType: "Celletype",
        colCount: "Antall kolonner",
        choicesOrder: "Velg rekkefølge på valg",
        visible: "Er synlig?",
        isRequired: "Er nødvendig?",
        markRequired: "Merk etter behov",
        removeRequiredMark: "Fjern ønsket merke",
        isAllRowRequired: "Nødvendig svar for alle rader",
        eachRowUnique: "Forhindre dupliserte svar i rader",
        requiredErrorText: "Nødvendig feilmelding",
        startWithNewLine: "Må starte med ny linje?",
        rows: "Antall rader",
        cols: "Antall kolonner",
        placeholder: "Hjelpetekst",
        showPreview: "Er forhåndsvisning av bilde vist?",
        storeDataAsText: "Lagre filinnhold i JSON-resultat som tekst",
        maxSize: "Maksimum filstørrelse i bytes",
        rowCount: "Antall rader",
        columnLayout: "Antall kolonner",
        addRowLocation: "Legg til rad knapp-plassering",
        transposeData: "Transponere rader til kolonner",
        addRowText: "Legg til rad knapp-tekst",
        removeRowText: "Fjern rad knapp-tekst",
        rateMin: "Minimum sats",
        rateMax: "Maksimum sats",
        rateStep: "Sats steg",
        minRateDescription: "Beskrivelse minimumsvudering",
        maxRateDescription: "Beskrivelse maksimumsvurdering",
        inputType: "Inndata-type",
        optionsCaption: "Tekst for alternativer",
        defaultValue: "Standardverdi",
        cellsDefaultRow: "Standard celletekster",
        surveyEditorTitle: "Rediger skjemainnstillinger",
        qEditorTitle: "Rediger: {0}",
        maxLength: "Maksimum lengde",
        buildExpression: "Bygg",
        editExpression: "Rediger",
        and: "og",
        or: "eller",
        remove: "Fjern",
        addCondition: "Legg til",
        emptyLogicPopupMessage: "Velg et spørsmål for å begynne å konfigurere betingelsene.",
        if: "Hvis",
        then: "da",
        setToName: "Målspørsmål",
        fromName: "Spørsmål å kopiere svar fra",
        gotoName: "Spørsmål å hoppe til",
        ruleIsNotSet: "Regelen er feil",
        includeIntoResult: "Inkluder i undersøkelsesresultater",
        showTitle: "Vis/skjul tittel",
        expandCollapseTitle: "Utvid/krymp tittel",
        locale: "Standard språk",
        simulator: "Velg enhet",
        landscapeOrientation: "Liggende",
        portraitOrientation: "Bytte til stående papirretning",
        mode: "Modus (rediger/kun lesbart)",
        clearInvisibleValues: "Fjern usynlige verdier",
        cookieName: "Informasjonskapsel navn (for å hindre bruk av skjema to ganger lokalt)",
        sendResultOnPageNext: "Send skjema resultat ved neste side",
        storeOthersAsComment: "Lagre 'andre' verdier i et separat felt",
        showPageTitles: "Vis sidetittel",
        showPageNumbers: "Vis sidenummer",
        pagePrevText: "Forrige side knapp tekst",
        pageNextText: "Neste side knapp tekst",
        completeText: "Fullfør knapp tekst",
        previewText: "Forhåndsvisning knapp tekst",
        editText: "Rediger knapp tekst",
        startSurveyText: "Start knapp tekst",
        showNavigationButtons: "Vis navigasjonsknapper (standard navigering)",
        showPrevButton: "Vis forrige knapp (bruker kan gå til forrige side)",
        firstPageIsStarted: "Den første siden i skjema er startside.",
        showCompletedPage: "Vis ferdigsiden på slutten (completedHtml)",
        goNextPageAutomatic: "Når en har svart alle spørsmål, gå til neste side automatisk",
        allowCompleteSurveyAutomatic: "Fullfør undersøkelsen automatisk",
        showProgressBar: "Vis fremdriftslinje",
        questionTitleLocation: "Spørsmål tittel plassering",
        questionTitleWidth: "Bredde på spørsmålstittel",
        requiredText: "Svar nødvendig symbol(er)",
        questionTitleTemplate: "Spørsmål tittel mal, standard er: '{no}. {require} {title}'",
        questionErrorLocation: "Spørsmål feil plassering",
        focusFirstQuestionAutomatic: "Sett fokus på første spørsmål når en endrer side",
        questionsOrder: "Rekkefølge på elementer på siden",
        maxTimeToFinish: "Maks tid for å gjøre ferdig skjema",
        maxTimeToFinishPage: "Maks tid til å gjøre ferdig en side i skjema",
        showTimerPanel: "Vis tidtaking",
        showTimerPanelMode: "Vis tidtaking-modus",
        renderMode: "Gjengivelse modus",
        allowAddPanel: "Tillat å legge til panel",
        allowRemovePanel: "Tillat å fjerne panel",
        panelAddText: "Legg til panel tekst",
        panelRemoveText: "Fjern panel tekst",
        isSinglePage: "Vis alle elementer på en side",
        html: "HTML",
        setValue: "Svare",
        dataFormat: "Bildeformat",
        allowAddRows: "Tillat at rader legges til",
        allowRemoveRows: "Tillat fjerning av rader",
        allowRowsDragAndDrop: "Tillat dra og slipp i rad",
        responsiveImageSizeHelp: "Gjelder ikke hvis du angir nøyaktig bildebredde eller -høyde.",
        minImageWidth: "Minimum bildebredde",
        maxImageWidth: "Maksimal bildebredde",
        minImageHeight: "Minimum bildehøyde",
        maxImageHeight: "Maksimal bildehøyde",
        minValue: "Minimumsverdi",
        maxValue: "Maksimal verdi",
        minLength: "Minimum lengde",
        allowDigits: "Tillat tall",
        minCount: "Minimum count",
        maxCount: "Maximum count",
        regex: "Regular expression",
        surveyvalidator: {
            text: "Feilmelding",
            expression: "Uttrykk for validering"
        },
        totalText: "Total tekst",
        totalType: "Total type",
        totalExpression: "Total formel",
        totalDisplayStyle: "Total visningsstil",
        totalCurrency: "Total valuta",
        totalFormat: "Total format",
        logo: "Logo (URL eller base64-kodet streng)",
        questionsOnPageMode: "Undersøkelse struktur",
        maxTextLength: "Maksimal svarlengde (i tegn)",
        maxOthersLength: "Maksimal kommentarlengde (i tegn)",
        commentAreaRows: "Høyde i kommentarområdet (i linjer)",
        autoGrowComment: "Utvid kommentarområdet automatisk om nødvendig",
        allowResizeComment: "Tillat brukere å endre størrelse på tekstområder",
        textUpdateMode: "Oppdatere tekstspørsmålsverdi",
        maskType: "Type inndatamaske",
        maskTypes: {
            none: "Ingen",
            patternmask: "Mønster",
            numericmask: "Numerisk",
            datetimemask: "Dato og klokkeslett",
            currencymask: "Valuta"
        },
        focusOnFirstError: "Sette fokus på det første ugyldige svaret",
        checkErrorsMode: "Kjør validering",
        navigateToUrl: "Naviger til URL",
        navigateToUrlOnCondition: "Dynamisk URL-adresse",
        completedBeforeHtml: "Markering for å vise om brukeren allerede har fylt ut denne undersøkelsen",
        completedHtml: "Sidemarkering for fullført undersøkelse",
        completedHtmlOnCondition: "Sidemarkering for fullført dynamisk undersøkelse",
        loadingHtml: "Markering som skal vises mens evalueringsmodellen lastes inn",
        commentText: "Tekst i kommentarfeltet",
        autocomplete: "Autofullfør type",
        labelTrue: "Etiketten «True»",
        labelFalse: "\"False\" etikett",
        allowClear: "Vis Fjern-knappen",
        searchMode: "Søkemodus",
        displayStyle: "Visningsstil for verdi",
        format: "Formatert streng",
        maximumFractionDigits: "Maksimalt antall brøksifre",
        minimumFractionDigits: "Minimum brøksifre",
        useGrouping: "Skilletegn for skjermgruppering",
        allowMultiple: "Tillat flere filer",
        allowImagesPreview: "Forhåndsvis bilder",
        acceptedTypes: "Godkjente filtyper",
        waitForUpload: "Vent til opplastingen er fullført",
        needConfirmRemoveFile: "Bekreft sletting av fil",
        detailPanelMode: "Plassering av detaljpanelet",
        minRowCount: "Minimum radantall",
        maxRowCount: "Maksimalt radantall",
        confirmDelete: "Bekreft radsletting",
        confirmDeleteText: "Bekreftelsesmelding",
        panelCount: "Innledende panelopptelling",
        minPanelCount: "Minimum antall paneler",
        maxPanelCount: "Maksimalt antall paneler",
        panelsState: "Utvidelsestilstand for Indre panel",
        panelPrevText: "Verktøytips for forrige panelknapp",
        panelNextText: "Verktøytips for neste panelknapp",
        showRangeInProgress: "Vis fremdriftsindikator",
        panelRemoveButtonLocation: "Fjern plassering av panelknappen",
        hideIfRowsEmpty: "Skjul spørsmålet hvis det ikke er noen rader",
        hideColumnsIfEmpty: "Skjule kolonner hvis det ikke er noen rader",
        rateValues: "Egendefinerte frekvensverdier",
        rateCount: "Antall priser",
        autoGenerate: "Hvordan spesifisere renteverdier?",
        hideIfChoicesEmpty: "Skjul spørsmålet hvis det ikke inneholder noen valg",
        minWidth: "Minimumsbredde (i CSS-godkjente verdier)",
        maxWidth: "Maksimal bredde (i CSS-godkjente verdier)",
        width: "Bredde (i CSS-godkjente verdier)",
        showHeader: "Vise kolonneoverskrifter",
        horizontalScroll: "Vis vannrett rullefelt",
        columnMinWidth: "Minimum kolonnebredde (i CSS-godkjente verdier)",
        rowTitleWidth: "Radoverskriftsbredde (i CSS-godtatte verdier)",
        valueTrue: "\"True\"-verdi",
        valueFalse: "\"False\" verdi",
        minErrorText: "Feilmeldingen «Verdien er under minimum»",
        maxErrorText: "Feilmeldingen \"Verdien overskrider maksimum\"",
        otherErrorText: "Feilmeldingen «Tom kommentar»",
        keyDuplicationError: "Feilmeldingen \"Ikke-unik nøkkelverdi\"",
        minSelectedChoices: "Minimum valgte valg",
        maxSelectedChoices: "Maksimalt antall merkede valg",
        showClearButton: "Vis Fjern-knappen",
        logoWidth: "Logobredde (i CSS-godkjente verdier)",
        logoHeight: "Logohøyde (i CSS-godkjente verdier)",
        readOnly: "Skrivebeskyttet",
        enableIf: "Kan redigeres hvis",
        emptyRowsText: "Meldingen «Ingen rader»",
        separateSpecialChoices: "Skille spesialvalg (Ingen, Annet, Merk alt)",
        choicesFromQuestion: "Kopier valg fra følgende spørsmål",
        choicesFromQuestionMode: "Hvilke valg å kopiere?",
        progressBarShowPageTitles: "Vise sidetitler på fremdriftslinjen",
        progressBarShowPageNumbers: "Vise sidetall på fremdriftslinjen",
        showCommentArea: "Vis kommentarfeltet",
        commentPlaceholder: "Plassholder for kommentarområde",
        displayRateDescriptionsAsExtremeItems: "Vise frekvensbeskrivelser som ekstremverdier",
        rowsOrder: "Rekkefølge på rad",
        columnsLayout: "Kolonneoppsett",
        columnColCount: "Nestet kolonneantall",
        correctAnswer: "Riktig svar",
        defaultPanelValue: "Standardverdier",
        cells: "Cell Tekster",
        fileInputPlaceholder: "Velg en fil eller lim inn en filkobling ...",
        keyName: "Nøkkelkolonne",
        itemvalue: {
            visibleIf: "Gjøre alternativet synlig hvis",
            enableIf: "Gjør alternativet valgbart hvis"
        },
        "itemvalue@rows": {
            visibleIf: "Gjøre raden synlig hvis",
            enableIf: "Gjøre raden redigerbar hvis"
        },
        imageitemvalue: {
            text: "Alternativ tekst"
        },
        logoPosition: "Logo-posisjon",
        addLogo: "Legg til logo...",
        changeLogo: "Bytt logo...",
        logoPositions: {
            none: "Fjern logo",
            left: "Venstre",
            right: "Høyre",
            top: "Topp",
            bottom: "Bunn"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Panel Oppsett"
            },
            general: "Generelt",
            fileOptions: "Valg",
            html: "HTML-editor",
            columns: "Kolonner",
            rows: "Rader",
            choices: "Valg",
            items: "Elementer",
            visibleIf: "Synlig hvis",
            enableIf: "Tilgjengelig hvis",
            requiredIf: "Nødvendig hvis",
            rateValues: "Rangering verdier",
            choicesByUrl: "Valg fra web",
            matrixChoices: "Standardvalg",
            multipleTextItems: "Tekst inndata",
            numbering: "Nummerering",
            validators: "Valideringer",
            navigation: "Navigering",
            question: "Spørsmål",
            pages: "Sider",
            timer: "Tidtaker/Quiz",
            calculatedValues: "Beregnede verdier",
            triggers: "Triggere",
            templateTitle: "Mal-tittel",
            totals: "Totaler",
            logic: "Logikk",
            mask: "Innstillinger for inndatamaske",
            layout: {
                panel: "Oppsett",
                question: "Oppsett",
                base: "Oppsett"
            },
            data: "Data",
            validation: "Validering",
            cells: "Celler",
            showOnCompleted: "Vis når ferdig",
            logo: "Logo i skjematittel",
            slider: "Slider",
            expression: "Uttrykk",
            questionSettings: "Spørsmål Innstillinger",
            header: "Topptekst",
            background: "Bakgrunn",
            appearance: "Utseende",
            others: "Andre"
        },
        editProperty: "Rediger verdi '{0}'",
        items: "[ Elementer: {0} ]",
        choicesVisibleIf: "Valgene er synlige hvis",
        choicesEnableIf: "Valgene kan velges hvis",
        columnsEnableIf: "Kolonner er synlige hvis",
        rowsEnableIf: "Rader er synlige hvis:",
        innerIndent: "Legge til indre innrykk",
        defaultValueFromLastRow: "Ta standardverdier fra den siste raden",
        defaultValueFromLastPanel: "Ta standardverdier fra det siste panelet",
        enterNewValue: "Vennligst fyll inn verdien.",
        noquestions: "Det er ingen spørsmål i skjemaet.",
        createtrigger: "Vennligst lag en trigger",
        titleKeyboardAdornerTip: "Trykk enter-tasten for å redigere",
        keyboardAdornerTip: "Trykk enter-tasten for å redigere elementet, trykk slette-tasten for å slette elementet, trykk Alt + pil opp/ned for å flytte elementet",
        triggerOn: "På ",
        triggerMakePagesVisible: "Gjør sider synlige:",
        triggerMakeQuestionsVisible: "Gjør elementer synlige:",
        triggerCompleteText: "Fullfør skjema dersom vellykket.",
        triggerNotSet: "Trigger er ikke satt",
        triggerRunIf: "Kjør dersom",
        triggerSetToName: "Endre verdien av: ",
        triggerFromName: "Kopier verdi fra: ",
        triggerRunExpression: "Kjør denne formelen:",
        triggerSetValue: "til: ",
        triggerGotoName: "Gå til spørsmål:",
        triggerIsVariable: "Ikke legg variabelen i resultatet.",
        triggerRunExpressionEmpty: "Vennligst fyll inn en gyldig formel",
        emptyExpressionPlaceHolder: "Skriv inn uttrykk her...",
        noFile: "Ingen fil valgt",
        clearIfInvisible: "Fjern verdien hvis spørsmålet blir skjult",
        valuePropertyName: "Navn på egenskap Value",
        searchEnabled: "Aktivere søk",
        hideSelectedItems: "Skjule merkede elementer",
        closeOnSelect: "Lukk rullegardinmenyen etter valget",
        verticalAlign: "Loddrett justering",
        alternateRows: "Annenhver rad",
        columnsVisibleIf: "Kolonner er synlige hvis",
        rowsVisibleIf: "Rader er synlige hvis:",
        otherPlaceholder: "Plassholder for kommentarområde",
        filePlaceholder: "Plassholdertekst for fil",
        photoPlaceholder: "Tekst for plassholdere for bilde",
        fileOrPhotoPlaceholder: "Plassholdertekst for fil eller bilde",
        rateType: "Type sats",
        url_placeholder: "Eks.: https://api.example.com/books",
        path_placeholder: "Eks.: kategorier.fiksjon",
        questionStartIndex_placeholder: "Eks.: a)",
        width_placeholder: "Eks.: 6in",
        minWidth_placeholder: "Eksempel: 600 piksler",
        maxWidth_placeholder: "Eks.: 50%",
        imageHeight_placeholder: "auto",
        imageWidth_placeholder: "auto",
        theme: {
            themeName: "Tema",
            isPanelless: "Spørsmål utseende",
            editorPanel: "Bakgrunn og hjørneradius",
            questionPanel: "Bakgrunn og hjørneradius",
            primaryColor: "Uthevingsfarge",
            panelBackgroundTransparency: "Tetthet i panelbakgrunn",
            questionBackgroundTransparency: "Spørsmål om bakgrunnstetthet",
            fontSize: "Skriftstørrelse",
            scale: "Skala",
            cornerRadius: "Hjørne radius",
            pageTitle: "Tittel skrift",
            pageDescription: "Beskrivelse font",
            questionTitle: "Tittel skrift",
            questionDescription: "Beskrivelse font",
            editorFont: "Font",
            backgroundOpacity: "Ugjennomsiktighet",
            "--sjs-font-family": "Skriftfamilie",
            "--sjs-general-backcolor-dim": "Bakgrunnsfarge",
            "--sjs-primary-backcolor": "Bakgrunn med aksent",
            "--sjs-primary-forecolor": "Aksent i forgrunnen",
            "--sjs-special-red": "Feilmeldinger",
            "--sjs-shadow-small": "Skygge effekter",
            "--sjs-shadow-inner": "Skygge effekter",
            "--sjs-border-default": "Farger"
        },
        "header@header": {
            headerView: "Utsikt",
            logoPosition: "Logo posisjon",
            surveyTitle: "Skrift for undersøkelsestittel",
            surveyDescription: "Skrift for undersøkelsesbeskrivelse",
            headerTitle: "Skrift for undersøkelsestittel",
            headerDescription: "Skrift for undersøkelsesbeskrivelse",
            inheritWidthFrom: "Bredde på innholdsområdet",
            textAreaWidth: "Tekstbredde",
            backgroundColorSwitch: "Bakgrunnsfarge",
            backgroundImage: "Bakgrunnsbilde",
            backgroundImageOpacity: "Ugjennomsiktighet",
            overlapEnabled: "Overlappe",
            logoPositionX: "Logo posisjon",
            titlePositionX: "Tittelposisjon",
            descriptionPositionX: "Beskrivelse posisjon"
        }
    },
    // Property values
    pv: {
        "true": "sann",
        "false": "falsk",
        file: "Lokale filer",
        camera: "Kamera",
        "file-camera": "Lokale filer eller kamera",
        inherit: "inherit",
        show: "show",
        hide: "hide",
        default: "default",
        initial: "initial",
        random: "random",
        collapsed: "collapsed",
        expanded: "expanded",
        none: "none",
        asc: "ascending",
        desc: "descending",
        indeterminate: "indeterminate",
        selected: "Utvalgt",
        unselected: "Umerkede",
        decimal: "desimal",
        currency: "valuta",
        percent: "prosent",
        firstExpanded: "firstExpanded",
        off: "off",
        list: "list",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        tab: "Kategoriene",
        horizontal: "horizontal",
        vertical: "vertical",
        top: "top",
        bottom: "bottom",
        topBottom: "top and bottom",
        both: "both",
        left: "left",
        right: "Høyre",
        center: "Sentrum",
        leftRight: "Venstre og høyre",
        middle: "Midt",
        color: "farge",
        date: "daddel",
        datetime: "datetime",
        "datetime-local": "datetime-lokal",
        email: "E-post",
        month: "måned",
        number: "nummer",
        password: "passord",
        range: "rekkevidde",
        tel: "Tel",
        text: "Tekst",
        time: "Tid",
        url: "URL",
        week: "uke",
        hidden: "hidden",
        edit: "edit",
        display: "display",
        contain: "Inneholde",
        cover: "Lokk",
        fill: "Fylle",
        next: "Neste",
        last: "Siste",
        onComplete: "onComplete",
        onHidden: "onHidden",
        onHiddenContainer: "Når spørsmålet eller panelet/siden blir skjult",
        clearInvisibleValues: {
            none: "Aldri"
        },
        clearIfInvisible: {
            none: "Aldri"
        },
        inputType: {
            color: "Farge",
            date: "Daddel",
            "datetime-local": "Dato og klokkeslett",
            email: "E-post",
            month: "Måned",
            number: "Nummer",
            password: "Passord",
            range: "Rekkevidde",
            tel: "Telefonnummer",
            text: "Tekst",
            time: "Tid",
            url: "URL",
            week: "Uke"
        },
        all: "all",
        page: "page",
        survey: "survey",
        onNextPage: "onNextPage",
        onValueChanged: "onValueChanged",
        onValueChanging: "Før et svar endres",
        questionsOnPageMode: {
            standard: "Opprinnelig struktur",
            singlePage: "Vis alle spørsmål på én side",
            questionPerPage: "Vis ett spørsmål per side"
        },
        noPreview: "no preview",
        showAllQuestions: "show preview with all questions",
        showAnsweredQuestions: "show preview with answered questions",
        pages: "Fullførte sider",
        questions: "Besvarte spørsmål",
        requiredQuestions: "Besvarte nødvendige spørsmål",
        correctQuestions: "Gyldige svar",
        buttons: "Fullførte sider (brukergrensesnitt for knapp)",
        underInput: "Under inngangen",
        underTitle: "Under tittelen",
        onBlur: "På uskarphet",
        onTyping: "Mens du skriver",
        underRow: "Under raden",
        underRowSingle: "Under raden er bare ett panel synlig",
        auto: "Auto",
        showNavigationButtons: {
            none: "Skjult"
        },
        showTimerPanel: {
            none: "Skjult"
        },
        showTimerPanelMode: {
            all: "Begge"
        },
        addRowLocation: {
            default: "Avhenger av matriseoppsett"
        },
        panelsState: {
            default: "Brukere kan ikke vise eller skjule paneler",
            collapsed: "Alle paneler er skjult",
            expanded: "Alle paneler er utvidet",
            firstExpanded: "Først utvidet"
        },
        widthMode: {
            static: "Statisk",
            responsive: "Lydhør"
        },
        contentMode: {
            image: "Bilde",
            video: "Video",
            youtube: "YouTube"
        },
        displayMode: {
            buttons: "Knapper",
            dropdown: "Rullegardinmeny"
        },
        rateColorMode: {
            default: "Standard",
            scale: "Skala"
        },
        scaleColorMode: {
            monochrome: "Monokrom",
            colored: "Farget"
        },
        autoGenerate: {
            "true": "Frembringe",
            "false": "Angi manuelt"
        },
        rateType: {
            labels: "Etiketter",
            stars: "Stjerner",
            smileys: "Smilefjes"
        },
        state: {
            default: "Låst"
        },
        showQuestionNumbers: {
            default: "Automatisk nummerering",
            on: "Automatisk nummerering",
            onPage: "Tilbakestill på hver side",
            onpanel: "Tilbakestill på hvert panel",
            onPanel: "Tilbakestill på hvert panel",
            onSurvey: "Fortsett på tvers av undersøkelsen",
            off: "Ingen nummerering"
        },
        descriptionLocation: {
            underTitle: "Under spørsmålstittelen",
            underInput: "Under inntastingsfeltet"
        },
        selectToRankAreasLayout: {
            horizontal: "Ved siden av valg",
            vertical: "Ovennevnte valg"
        },
        displayStyle: {
            decimal: "Desimal",
            currency: "Valuta",
            percent: "Prosent",
            date: "Daddel"
        },
        totalDisplayStyle: {
            decimal: "Desimal",
            currency: "Valuta",
            percent: "Prosent",
            date: "Daddel"
        },
        rowsOrder: {
            initial: "Original"
        },
        questionsOrder: {
            initial: "Original"
        },
        showProgressBar: {
            off: "Skjult",
            topbottom: "top and bottom",
            aboveheader: "Over overskriften",
            belowheader: "Under overskriften"
        },
        sum: "Sum",
        count: "Greve",
        min: "Min",
        max: "Maks",
        avg: "Avg",
        searchMode: {
            contains: "Inneholder",
            startsWith: "Starter med"
        },
        backgroundImageFit: {
            auto: "Auto",
            cover: "Lokk",
            contain: "Inneholde",
            fill: "Strekning",
            tile: "Flis"
        },
        backgroundImageAttachment: {
            fixed: "Fast",
            scroll: "Bla"
        },
        headerView: {
            basic: "Grunnleggende",
            advanced: "Avansert"
        },
        inheritWidthFrom: {
            survey: "Samme som undersøkelse",
            container: "Tilpass til container"
        },
        backgroundColorSwitch: {
            none: "Ingen",
            accentColor: "Uthevingsfarge",
            custom: "Skikk"
        },
        colorPalette: {
            light: "Lys",
            dark: "Mørk"
        },
        isPanelless: {
            "false": "Standard",
            "true": "Uten paneler"
        }
    },
    // Operators
    op: {
        empty: "er tom",
        notempty: "er ikke tom",
        equal: "er lik",
        notequal: "er ikke lik",
        contains: "inneholder",
        notcontains: "inneholder ikke",
        anyof: "noen av",
        allof: "alle av",
        greater: "større enn",
        less: "mindre enn",
        greaterorequal: "større eller lik",
        lessorequal: "mindre eller lik",
        and: "og",
        or: "eller"
    },
    // Embed window
    ew: {
        angular: "Bruk Angular-versjon",
        jquery: "Bruk jQuery-versjon",
        knockout: "Bruk Knockout-versjon",
        react: "Bruk React-versjon",
        vue: "Bruk Vue-versjon",
        bootstrap: "For Bootstrap-rammeverk",
        modern: "Moderne tema",
        default: "Standard tema",
        orange: "Oransje-tema",
        darkblue: "Mørkeblått-tema",
        darkrose: "Darkrose-tema",
        stone: "Stein-tema",
        winter: "Vinter-tema",
        winterstone: "Vinterstein-tema",
        showOnPage: "Vis skjema på en side",
        showInWindow: "Vis skjema i et vindu",
        loadFromServer: "Last skjemadefinisjon som JSON fra server",
        titleScript: "Skript og stiler",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Velg side:",
        showInvisibleElements: "Vis usynlige elementer",
        hideInvisibleElements: "Skjule usynlige elementer"
    },
    validators: {
        answercountvalidator: "antall svar",
        emailvalidator: "e-post",
        expressionvalidator: "formel",
        numericvalidator: "numerisk",
        regexvalidator: "regex",
        textvalidator: "tekst"
    },
    triggers: {
        completetrigger: "complete skjema",
        setvaluetrigger: "set value",
        copyvaluetrigger: "copy value",
        skiptrigger: "hopp til spørsmål",
        runexpressiontrigger: "kjør formel",
        visibletrigger: "endre synlighet (deprecated)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Eks.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Eks.: mm/dd/åååå"
        },
        currencymask: {
            prefix: "Eks.: $",
            suffix: "Eks.: USD"
        },
        panelbase: {
            questionTitleWidth: "Eks.: 200 piksler"
        }
    },
    pehelp: {
        panel: {
            name: "En panel-ID som ikke er synlig for respondentene.",
            description: "Skriv inn en panelundertekst.",
            visibleIf: "Bruk tryllestavikonet til å angi en betinget regel som bestemmer panelets synlighet.",
            enableIf: "Bruk tryllestavikonet til å angi en betinget regel som deaktiverer skrivebeskyttet modus for panelet.",
            requiredIf: "Bruk tryllestavikonet til å angi en betinget regel som forhindrer innsending av spørreundersøkelser med mindre minst ett nestet spørsmål har et svar.",
            questionTitleLocation: "Gjelder alle spørsmålene i dette panelet. Hvis du vil overstyre denne innstillingen, definerer du regler for titteljustering for enkeltspørsmål. Alternativet \"Arv\" bruker innstillingen på sidenivå (hvis angitt) eller undersøkelsesnivå (\"Topp\" som standard).",
            questionTitleWidth: "Angir konsekvent bredde for spørsmålstitler når de er justert til venstre for spørsmålsboksene. Godtar CSS-verdier (px, %, i, pt osv.).",
            questionErrorLocation: "Angir plasseringen av en feilmelding i forhold til alle spørsmålene i panelet. Alternativet «Arv» bruker innstillingen på sidenivå (hvis angitt) eller undersøkelsesnivå.",
            questionsOrder: "Beholder den opprinnelige rekkefølgen på spørsmål eller randomiserer dem. Alternativet «Arv» bruker innstillingen på sidenivå (hvis angitt) eller undersøkelsesnivå.",
            page: "Flytter panelet til slutten av en merket side.",
            innerIndent: "Legger til mellomrom eller marg mellom panelinnholdet og venstre kant på panelboksen.",
            startWithNewLine: "Fjern merket for å vise panelet på én linje med forrige spørsmål eller panel. Innstillingen gjelder ikke hvis panelet er det første elementet i skjemaet.",
            state: "Velg mellom: \"Utvidet\" - panelet vises i sin helhet og kan skjules; \"Kollapset\" - panelet viser bare tittelen og beskrivelsen og kan utvides; \"Låst\" - panelet vises i sin helhet og kan ikke skjules.",
            width: "Angir bredden på panelet i forhold til andre undersøkelseselementer på samme linje. Godtar CSS-verdier (px, %, i, pt osv.)."
        },
        paneldynamic: {
            name: "En panel-ID som ikke er synlig for respondentene.",
            description: "Skriv inn en panelundertekst.",
            visibleIf: "Bruk tryllestavikonet til å angi en betinget regel som bestemmer panelets synlighet.",
            enableIf: "Bruk tryllestavikonet til å angi en betinget regel som deaktiverer skrivebeskyttet modus for panelet.",
            requiredIf: "Bruk tryllestavikonet til å angi en betinget regel som forhindrer innsending av spørreundersøkelser med mindre minst ett nestet spørsmål har et svar.",
            templateTitleLocation: "Gjelder alle spørsmålene i dette panelet. Hvis du vil overstyre denne innstillingen, definerer du regler for titteljustering for enkeltspørsmål. Alternativet \"Arv\" bruker innstillingen på sidenivå (hvis angitt) eller undersøkelsesnivå (\"Topp\" som standard).",
            templateErrorLocation: "Angir plasseringen av en feilmelding i forhold til et spørsmål med ugyldige inndata. Velg mellom: \"Topp\" - en feiltekst plasseres øverst i spørsmålsboksen; \"Bunn\" - en feiltekst er plassert nederst i spørsmålsboksen. Alternativet \"Arv\" bruker innstillingen på sidenivå (hvis angitt) eller undersøkelsesnivå (\"Topp\" som standard).",
            errorLocation: "Angir plasseringen av en feilmelding i forhold til alle spørsmålene i panelet. Alternativet «Arv» bruker innstillingen på sidenivå (hvis angitt) eller undersøkelsesnivå.",
            page: "Flytter panelet til slutten av en merket side.",
            innerIndent: "Legger til mellomrom eller marg mellom panelinnholdet og venstre kant på panelboksen.",
            startWithNewLine: "Fjern merket for å vise panelet på én linje med forrige spørsmål eller panel. Innstillingen gjelder ikke hvis panelet er det første elementet i skjemaet.",
            state: "Velg mellom: \"Utvidet\" - panelet vises i sin helhet og kan skjules; \"Kollapset\" - panelet viser bare tittelen og beskrivelsen og kan utvides; \"Låst\" - panelet vises i sin helhet og kan ikke skjules.",
            width: "Angir bredden på panelet i forhold til andre undersøkelseselementer på samme linje. Godtar CSS-verdier (px, %, i, pt osv.).",
            templateTitle: "Skriv inn en mal for dynamiske paneltitler. Bruk {panelIndex} for panelets generelle posisjon og {visiblePanelIndex} for rekkefølgen blant synlige paneler. Sett inn disse plassholderne i mønsteret for å legge til automatisk nummerering.",
            templateTabTitle: "Skriv inn en mal for fanetitler. Bruk {panelIndex} for panelets generelle posisjon og {visiblePanelIndex} for rekkefølgen blant synlige paneler. Sett inn disse plassholderne i mønsteret for å legge til automatisk nummerering.",
            tabTitlePlaceholder: "En basistekst for tabulatortitler som gjelder når mønsteret for tabulatortittel ikke gir meningsfull verdi.",
            templateVisibleIf: "Med denne innstillingen kan du kontrollere synligheten til individuelle paneler i det dynamiske panelet. Bruk plassholderen {panel} til å referere til gjeldende panel i uttrykket.",
            titleLocation: "Denne innstillingen arves automatisk av alle spørsmålene i dette panelet. Hvis du vil overstyre denne innstillingen, definerer du regler for titteljustering for enkeltspørsmål. Alternativet \"Arv\" bruker innstillingen på sidenivå (hvis angitt) eller undersøkelsesnivå (\"Topp\" som standard).",
            descriptionLocation: "Alternativet \"Arv\" bruker innstillingen på sidenivå (hvis angitt) eller innstilling på undersøkelsesnivå (\"Under paneltittelen\" som standard).",
            newPanelPosition: "Definerer posisjonen til et nylig lagt til-panel. Som standard legges nye paneler til slutten. Velg \"Neste\" for å sette inn et nytt panel etter det nåværende.",
            defaultValueFromLastPanel: "Dupliserer svar fra det siste panelet og tilordner dem til det neste dynamiske panelet som er lagt til.",
            keyName: "Referer til et spørsmålsnavn for å kreve at en bruker gir et unikt svar på dette spørsmålet i hvert panel."
        },
        defaultValueExpression: "Med denne innstillingen kan du tilordne en standard svarverdi basert på et uttrykk. Uttrykket kan inneholde grunnleggende beregninger - '{q1_id} + {q2_id}', boolske uttrykk, for eksempel '{alder} > 60', og funksjoner: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. Verdien som bestemmes av dette uttrykket, fungerer som den opprinnelige standardverdien som kan overstyres av en respondents manuelle inndata.",
        resetValueIf: "Bruk tryllestavikonet til å angi en betinget regel som bestemmer når en respondents inndata tilbakestilles til verdien basert på \"Standardverdiuttrykk\" eller \"Angi verdiuttrykk\" eller til \"Standard svar\"-verdien (hvis en av dem er angitt).",
        setValueIf: "Bruk tryllestavikonet til å angi en betinget regel som bestemmer når \"Angi verdiuttrykk\" skal kjøres, og tilordne den resulterende verdien dynamisk som et svar.",
        setValueExpression: "Angi et uttrykk som definerer verdien som skal angis når betingelsene i regelen Angi verdi hvis er oppfylt. Uttrykket kan inneholde grunnleggende beregninger - '{q1_id} + {q2_id}', boolske uttrykk, for eksempel '{alder} > 60', og funksjoner: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. Verdien som bestemmes av dette uttrykket, kan overstyres av en respondents manuelle inndata.",
        question: {
            name: "En spørsmåls-ID som ikke er synlig for respondentene.",
            description: "Skriv inn en spørsmålsundertittel.",
            visibleIf: "Bruk tryllestavikonet til å angi en betinget regel som bestemmer spørsmålets synlighet.",
            enableIf: "Bruk tryllestavikonet til å angi en betinget regel som deaktiverer skrivebeskyttet modus for spørsmålet.",
            requiredIf: "Bruk tryllestavikonet til å angi en betinget regel som forhindrer avansement eller innsending av spørreundersøkelser med mindre spørsmålet fikk svar.",
            startWithNewLine: "Fjern merket for å vise spørsmålet på én linje med forrige spørsmål eller panel. Innstillingen gjelder ikke hvis spørsmålet er det første elementet i skjemaet.",
            page: "Flytter spørsmålet til slutten av en merket side.",
            state: "Velg mellom: \"Utvidet\" - spørsmålsboksen vises i sin helhet og kan skjules; \"Kollapset\" - spørsmålsboksen viser bare tittelen og beskrivelsen og kan utvides; \"Låst\" - spørsmålsboksen vises i sin helhet og kan ikke skjules.",
            titleLocation: "Overstyrer titteljusteringsregler som er definert på panel-, side- eller undersøkelsesnivå. Alternativet \"Arv\" bruker innstillinger på høyere nivå (hvis angitt) eller innstilling på undersøkelsesnivå (\"Topp\" som standard).",
            descriptionLocation: "Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå (\"Under spørsmålstittelen\" som standard).",
            errorLocation: "Angir plasseringen til en feilmelding i forhold til spørsmålet med ugyldige inndata. Velg mellom: \"Topp\" - en feiltekst plasseres øverst i spørsmålsboksen; \"Bunn\" - en feiltekst er plassert nederst i spørsmålsboksen. Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå (\"Topp\" som standard).",
            indent: "Legger til mellomrom eller marg mellom spørsmålsinnholdet og venstre kantlinje i spørsmålsboksen.",
            width: "Angir bredden på spørsmålet i forhold til andre undersøkelseselementer på samme linje. Godtar CSS-verdier (px, %, i, pt osv.).",
            surveyvalidator: {
                expression: "Bruk tryllestavikonet til å angi en valideringsregel for spørsmålet."
            },
            textUpdateMode: "Velg mellom: \"Ved tapt fokus\" - verdien oppdateres når inntastingsfeltet mister fokus; \"Mens du skriver\" - verdien oppdateres i sanntid, mens brukerne skriver. Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå (\"Ved tapt fokus\" som standard).",
            url: "Du kan bruke en hvilken som helst webtjeneste som datakilde for flervalgsspørsmål. Hvis du vil fylle ut valgverdier, angir du URL-adressen til tjenesten som leverer dataene.",
            searchMode: "En sammenligningsoperasjon som brukes til å filtrere rullegardinlisten.",
            textWrapEnabled: "Lange tekster i valgalternativer genererer automatisk linjeskift slik at de passer inn i rullegardinmenyen. Fjern merket hvis du vil at tekstene skal klippes ut."
        },
        signaturepad: {
            signatureWidth: "Angir bredden på signaturområdet som vises, og det resulterende bildet.",
            signatureHeight: "Angir høyden på signaturområdet som vises, og det resulterende bildet.",
            signatureAutoScaleEnabled: "Velg dette alternativet hvis du vil at signaturområdet skal fylle all tilgjengelig plass i spørsmålsboksen, samtidig som standardforholdet 3:2 beholdes. Når egendefinerte bredde- og høydeverdier angis, beholdes innstillingen størrelsesforholdet for disse dimensjonene."
        },
        file: {
            imageHeight: "Justerer høyden på bildet i undersøkelsesresultatene.",
            imageWidth: "Justerer bredden på bildet i undersøkelsesresultatene."
        },
        image: {
            contentMode: "Alternativet \"Auto\" bestemmer automatisk passende modus for visning - Bilde, Video eller YouTube - basert på kildens URL som er oppgitt."
        },
        imagepicker: {
            imageHeight: "Overstyrer minimums- og maksimumshøydeverdiene.",
            imageWidth: "Overstyrer verdiene for minimums- og maksimumsbredde.",
            choices: "\"Verdi\" fungerer som en vare-ID som brukes i betingede regler; \"Tekst\" vises for respondentene.",
            contentMode: "Velg mellom \"Image\" og \"Video\" for å stille inn innholdsmodusen til medievelgeren. Hvis \"Bilde\" er valgt, må du kontrollere at alle alternativene som er oppgitt, er bildefiler i følgende formater: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. På samme måte, hvis \"Video\" er valgt, må du sørge for at alle alternativene er direkte koblinger til videofiler i følgende formater: MP4, MOV, WMV, FLV, AVI, MKV. Vær oppmerksom på at YouTube-koblinger ikke støttes for videoalternativer."
        },
        text: {
            size: "Denne innstillingen endrer bare størrelsen på inndatafeltet og påvirker ikke bredden på spørsmålsboksen. Hvis du vil begrense den godkjente inndatalengden, går du til <b>Validering → Maksimal tegngrense</b>."
        },
        comment: {
            rows: "Angir antall viste linjer i inndatafeltet. Hvis inngangen tar opp flere linjer, vises rullefeltet."
        },
        // survey templates
        survey: {
            mode: "Velg mellom: \"Redigerbar\" - gjør det mulig for respondenter å fylle ut undersøkelsen din; \"Skrivebeskyttet\" - deaktiverer skjemaredigering."
        },
        matrixdropdowncolumn: {
            name: "En kolonne-ID som ikke er synlig for respondentene.",
            isUnique: "Når en respondent er aktivert for en kolonne, må den gi et unikt svar for hvert spørsmål i denne kolonnen.",
            rows: "Angir antall viste linjer i inndatafeltet. Hvis inngangen tar opp flere linjer, vises rullefeltet.",
            visibleIf: "Bruk tryllestavikonet til å angi en betinget regel som bestemmer kolonnens synlighet.",
            enableIf: "Bruk tryllestavikonet til å angi en betinget regel som deaktiverer skrivebeskyttet modus for kolonnen.",
            requiredIf: "Bruk tryllestavikonet til å angi en betinget regel som forhindrer innsending av spørreundersøkelser med mindre minst ett nestet spørsmål har et svar.",
            showInMultipleColumns: "Når dette alternativet er valgt, opprettes det én kolonne for hvert valgalternativ."
        },
        widthMode: "Velg mellom: \"Statisk\" - setter en fast bredde; \"Responsive\" - gjør at undersøkelsen opptar hele bredden på skjermen; \"Auto\" - gjelder en av de to avhengig av spørsmålstypene som brukes.",
        cookieName: "Informasjonskapsler hindrer brukere i å fylle ut den samme undersøkelsen to ganger.",
        logo: "Lim inn en bildekobling (ingen størrelsesbegrensninger) eller klikk på mappeikonet for å bla gjennom en fil fra datamaskinen din (opptil 64KB).",
        logoWidth: "Setter en logo bredde i CSS enheter (px, %, i, pt, etc.).",
        logoHeight: "Angir en logo høyde i CSS enheter (px, %, i, pt, etc.).",
        logoFit: "Velg mellom: \"Ingen\" - bildet opprettholder sin opprinnelige størrelse; \"Innehold\" - bildet endres for å passe samtidig som størrelsesforholdet opprettholdes; \"Cover\" - bildet fyller hele boksen mens du opprettholder størrelsesforholdet; \"Fyll\" - bildet strekkes for å fylle boksen uten å opprettholde størrelsesforholdet.",
        goNextPageAutomatic: "Velg om du vil at evalueringen skal gå automatisk til neste side etter at en svarperson har svart på alle spørsmålene på gjeldende side.",
        allowCompleteSurveyAutomatic: "Velg om du vil at evalueringen skal fullføres automatisk etter at en svarperson har svart på alle spørsmålene.",
        showNavigationButtons: "Angir synligheten og plasseringen av navigasjonsknapper på en side.",
        showProgressBar: "Angir synligheten og plasseringen til en fremdriftsindikator. \"Auto\"-verdien viser fremdriftslinjen over eller under undersøkelseshodet.",
        showPreviewBeforeComplete: "Aktiver forhåndsvisningssiden med alle eller besvarte spørsmål.",
        questionTitleLocation: "Gjelder alle spørsmålene i undersøkelsen. Denne innstillingen kan overstyres av titteljusteringsregler på lavere nivåer: panel, side eller spørsmål. En innstilling på lavere nivå vil overstyre de på et høyere nivå.",
        requiredText: "Et symbol eller en sekvens av symboler som indikerer at et svar er nødvendig.",
        questionStartIndex: "Skriv inn et tall eller bokstav du vil starte nummereringen med.",
        questionErrorLocation: "Angir plasseringen til en feilmelding i forhold til spørsmålet med ugyldige inndata. Velg mellom: \"Topp\" - en feiltekst plasseres øverst i spørsmålsboksen; \"Bunn\" - en feiltekst er plassert nederst i spørsmålsboksen.",
        focusFirstQuestionAutomatic: "Velg om du vil at det første inntastingsfeltet på hver side skal være klart for tekstinntasting.",
        questionsOrder: "Beholder den opprinnelige rekkefølgen på spørsmål eller randomiserer dem. Effekten av denne innstillingen er bare synlig i kategorien Forhåndsvisning.",
        maxTextLength: "Kun for spørsmål om tekstoppføring.",
        maxOthersLength: "Kun for spørsmålskommentarer.",
        commentAreaRows: "Angir antall viste linjer i tekstområder for spørsmålskommentarer. I inngangen tar opp flere linjer, vises rullefeltet.",
        autoGrowComment: "Velg om du vil at spørsmålskommentarer og Lang tekst-spørsmål skal vokse automatisk i høyde basert på den angitte tekstlengden.",
        allowResizeComment: "Kun for spørsmålskommentarer og langtekstspørsmål.",
        calculatedValues: "Egendefinerte variabler fungerer som mellomliggende variabler eller hjelpevariabler som brukes i skjemaberegninger. De tar respondentinnganger som kildeverdier. Hver egendefinerte variabel har et unikt navn og et uttrykk den er basert på.",
        includeIntoResult: "Velg dette hvis du vil at den beregnede verdien for uttrykket skal lagres sammen med evalueringsresultatene.",
        triggers: "En utløser er en hendelse eller betingelse som er basert på et uttrykk. Når uttrykket er evaluert til \"sann\", utløses en utløser en handling. En slik handling kan eventuelt ha et målspørsmål den påvirker.",
        clearInvisibleValues: "Velg om du vil fjerne verdier for spørsmål skjult av betinget logikk, og når du vil gjøre det.",
        textUpdateMode: "Velg mellom: \"Ved tapt fokus\" - verdien oppdateres når inntastingsfeltet mister fokus; \"Mens du skriver\" - verdien oppdateres i sanntid, mens brukerne skriver.",
        columns: "Den venstre verdien fungerer som en kolonne-ID som brukes i betingede regler, den riktige verdien vises for respondentene.",
        rows: "Den venstre verdien fungerer som en rad-ID som brukes i betingede regler, den riktige verdien vises for respondentene.",
        columnMinWidth: "Godtar CSS-verdier (px, %, i, pt osv.).",
        rowTitleWidth: "Godtar CSS-verdier (px, %, i, pt osv.).",
        totalText: "Bare synlig når minst én kolonne har Totaltype- eller Total-uttrykk.",
        cellErrorLocation: "Angir plasseringen til en feilmelding i forhold til en celle med ugyldige inndata. Alternativet \"Arv\" bruker innstillingen fra egenskapen \"Justering av feilmelding\".",
        keyDuplicationError: "Når egenskapen \"Forhindre dupliserte svar\" er aktivert, får en svarperson som prøver å sende inn en duplikatoppføring, følgende feilmelding.",
        totalExpression: "Lar deg beregne totalverdier basert på et uttrykk. Uttrykket kan omfatte grunnleggende beregninger ('{q1_id} + {q2_id}'), boolske uttrykk ('{alder} > 60') og funksjoner ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.).",
        confirmDelete: "Utløser en melding som ber om å bekrefte radslettingen.",
        defaultValueFromLastRow: "Dupliserer svar fra den siste raden og tilordner dem til den neste dynamiske raden som er lagt til.",
        keyName: "Hvis den angitte kolonnen inneholder identiske verdier, gir undersøkelsen feilen \"Ikke-unik nøkkelverdi\".",
        description: "Skriv inn en undertekst.",
        locale: "Velg et språk for å begynne å opprette evalueringen. Hvis du vil legge til en oversettelse, bytter du til et nytt språk og oversetter originalteksten her eller i Oversettelser-fanen.",
        detailPanelMode: "Angir plasseringen av en detaljinndeling i forhold til en rad. Velg mellom: \"Ingen\" - ingen utvidelse er lagt til; \"Under raden\" - en radutvidelse er plassert under hver rad av matrisen; \"Under raden, vis bare en radutvidelse\" - en utvidelse vises bare under en enkelt rad, de resterende radutvidelsene er skjult.",
        imageFit: "Velg mellom: \"Ingen\" - bildet opprettholder sin opprinnelige størrelse; \"Innehold\" - bildet endres for å passe samtidig som størrelsesforholdet opprettholdes; \"Cover\" - bildet fyller hele boksen mens du opprettholder størrelsesforholdet; \"Fyll\" - bildet strekkes for å fylle boksen uten å opprettholde størrelsesforholdet.",
        autoGrow: "Øker gradvis høyden på inndatafeltet etter hvert som data registreres. Overstyrer innstillingen \"Inndatafelthøyde (i linjer)\".",
        allowResize: "Skaleringshåndtaket (eller grepet) vises i hjørnet og kan dras for å endre størrelsen på inndatafeltet.",
        maxTimeToFinish: "Et tidsintervall i sekunder hvoretter undersøkelsen automatisk går videre til takkesiden.",
        maxTimeToFinishPage: "Et tidsintervall i sekunder hvoretter undersøkelsen automatisk går videre til neste side.",
        page: {
            maxTimeToFinish: "Et tidsintervall i sekunder hvoretter undersøkelsen automatisk går videre til neste side.",
            visibleIf: "Bruk tryllestavikonet til å angi en betinget regel som bestemmer sidens synlighet.",
            enableIf: "Bruk tryllestavikonet til å angi en betinget regel som deaktiverer skrivebeskyttet modus for siden.",
            requiredIf: "Bruk tryllestavikonet til å angi en betinget regel som forhindrer innsending av spørreundersøkelser med mindre minst ett nestet spørsmål har et svar.",
            questionTitleLocation: "Gjelder alle spørsmål på denne siden. Hvis du vil overstyre denne innstillingen, definerer du regler for titteljustering for enkeltspørsmål eller paneler. Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå (\"Topp\" som standard).",
            questionTitleWidth: "Angir konsekvent bredde for spørsmålstitler når de er justert til venstre for spørsmålsboksene. Godtar CSS-verdier (px, %, i, pt osv.).",
            questionErrorLocation: "Angir plasseringen til en feilmelding i forhold til spørsmålet med ugyldige inndata. Velg mellom: \"Topp\" - en feiltekst plasseres øverst i spørsmålsboksen; \"Bunn\" - en feiltekst er plassert nederst i spørsmålsboksen. Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå (\"Topp\" som standard).",
            questionsOrder: "Beholder den opprinnelige rekkefølgen på spørsmål eller randomiserer dem. Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå (\"Original\" som standard). Effekten av denne innstillingen er bare synlig i kategorien Forhåndsvisning.",
            navigationButtonsVisibility: "Angir synligheten til navigasjonsknapper på siden. Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå, som som standard er \"Synlig\"."
        },
        showTimerPanel: "Stiller inn synligheten og plasseringen til en tidtaker på en side.",
        panelsState: "Velg mellom: \"Låst\" - brukere kan ikke utvide eller skjule paneler; \"Skjul alle\" - alle paneler starter i kollapset tilstand; \"Utvid alle\" - alle paneler starter i utvidet tilstand; \"Først utvidet\" - bare det første panelet er i utgangspunktet utvidet.",
        imageLinkName: "Skriv inn et navn på en delt egenskap i matrisen med objekter som inneholder URL-adressene til bildet eller videofilen du vil vise i valglisten.",
        choices: "Den venstre verdien fungerer som en vare-ID som brukes i betingede regler, den riktige verdien vises for respondentene.",
        title: "Skriv inn en brukervennlig tittel som skal vises.",
        waitForUpload: "Sikrer at brukerne ikke fullfører undersøkelsen før filene er lastet opp.",
        minWidth: "Godtar CSS-verdier (px, %, i, pt osv.).",
        maxWidth: "Godtar CSS-verdier (px, %, i, pt osv.).",
        width: "Godtar CSS-verdier (px, %, i, pt osv.).",
        valueName: "Hvis du ikke angir denne egenskapen, lagres svaret i et felt som er angitt av egenskapen Name.",
        useDisplayValuesInDynamicTexts: "I enkeltvalgs- og flervalgsspørsmålstyper har hvert valgalternativ en ID og visningsverdi. Når denne innstillingen er valgt, vises en visningsverdi i stedet for en ID-verdi i HTML-spørsmål og dynamiske titler og beskrivelser av evalueringselementer.",
        clearIfInvisible: "Velg om du vil fjerne spørsmålsverdier skjult av betinget logikk, og når du vil gjøre det. Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå (\"Når undersøkelsen er fullført\" som standard).",
        choicesFromQuestionMode: "Velg mellom: \"Alle\" - kopierer alle valgalternativer fra det valgte spørsmålet; \"Valgt\" - kopierer dynamisk bare valgte valgalternativer; \"Unselected\" - kopierer dynamisk bare uvalgte valgalternativer. Alternativene \"Ingen\" og \"Annet\" kopieres som standard hvis de er aktivert i kildespørsmålet.",
        showOtherItem: "Når dette alternativet er valgt, kan brukerne inkludere flere inndata i et eget kommentarfelt.",
        separateSpecialChoices: "Viser hvert spesialvalgalternativ (\"Ingen\", \"Annet\", \"Merk alt\") på en ny linje, selv når du bruker et oppsett med flere kolonner.",
        path: "Angi plasseringen i tjenestedatasettet der målmatrisen med objekter er plassert. La stå tom hvis URL-adressen allerede peker på matrisen.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Skriv inn et ensartet egenskapsnavn i matrisen med objekter som inneholder verdiene du vil vise i valglisten.",
        allowEmptyResponse: "Velg dette alternativet hvis du vil at tjenesten skal returnere et tomt svar eller en matrise.",
        choicesVisibleIf: "Bruk tryllestavikonet til å angi en betinget regel som bestemmer synligheten til alle valgalternativer.",
        rateValues: "Den venstre verdien fungerer som en vare-ID som brukes i betingede regler, den riktige verdien vises for respondentene.",
        rating: {
            displayMode: "\"Auto\" velger mellom \"Knapper\" og \"Dropdown\" -modus basert på tilgjengelig bredde. Når bredden ikke er tilstrekkelig til å vise knapper, viser spørsmålet en rullegardinmeny."
        },
        valuePropertyName: "Lar deg koble til spørsmål som gir resultater i forskjellige formater. Når slike spørsmål kobles sammen ved hjelp av en sammenføyningsidentifikator, lagrer denne delte egenskapen valgte spørsmålsverdier.",
        searchEnabled: "Velg om du vil oppdatere innholdet på rullegardinmenyen slik at det samsvarer med søket som en bruker skriver inn i inndatafeltet.",
        valueTrue: "En verdi å spare i undersøkelsesresultater når respondentene gir et positivt svar.",
        valueFalse: "En verdi å lagre i undersøkelsesresultater når respondentene gir et negativt svar.",
        showPreview: "Det anbefales ikke å deaktivere dette alternativet, da det overstyrer forhåndsvisningsbildet og gjør det vanskelig for en bruker å forstå om filene er lastet opp.",
        needConfirmRemoveFile: "Utløser en melding som ber om å bekrefte slettingen av filen.",
        selectToRankEnabled: "Aktiver for å rangere bare valgte valg. Brukere vil dra valgte elementer fra valglisten for å sortere dem innenfor rangeringsområdet.",
        dataList: "Angi en liste over valg som skal foreslås for respondenten under inndata.",
        itemSize: "Innstillingen endrer bare størrelsen på inndatafeltene og påvirker ikke bredden på spørsmålsboksen.",
        itemTitleWidth: "Angir konsekvent bredde for alle elementetiketter i piksler",
        altText: "Fungerer som en erstatning når bildet ikke kan vises på en brukers enhet og av tilgjengelighetshensyn.",
        rateColorMode: "Definerer fargen på den valgte emojien når Vurdering-ikontypen er satt til \"Smileys\". Velg mellom: \"Standard\" - den valgte emojien vises i standard undersøkelsesfarge; \"Skala\" - den valgte emojien arver farge fra vurderingsskalaen.",
        expression: {
            name: "En uttrykks-ID som ikke er synlig for respondentene.",
            description: "Skriv inn en undertittel for uttrykk.",
            expression: "Et uttrykk kan inneholde grunnleggende beregninger ('{q1_id} + {q2_id}'), betingelser ('{alder} > 60') og funksjoner ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.)."
        },
        storeOthersAsComment: "Velg dette alternativet hvis du vil lagre alternativverdien «Annet» som en egen egenskap i undersøkelsesresultatene.",
        format: "Bruk {0} som plassholder for den faktiske verdien.",
        acceptedTypes: "Se attributtbeskrivelsen [accept](https://www.w3schools.com/tags/att_input_accept.asp) hvis du vil ha mer informasjon.",
        columnColCount: "Gjelder bare for celletypene Radiogruppe og Avmerkingsboks.",
        autocomplete: "Se attributtbeskrivelsen [autofullfør](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) hvis du vil ha mer informasjon.",
        filePlaceholder: "Gjelder når \"Kildetype\" er \"Lokale filer\" eller når kameraet er utilgjengelig",
        photoPlaceholder: "Gjelder når \"Kildetype\" er \"Kamera\".",
        fileOrPhotoPlaceholder: "Gjelder når \"Kildetype\" er \"Lokale filer eller kamera\".",
        masksettings: {
            saveMaskedValue: "Velg om du vil lagre spørsmålsverdien med en brukt maske i evalueringsresultatene."
        },
        patternmask: {
            pattern: "Mønsteret kan inneholde strenglitteraler og følgende plassholdere: '9' - for et siffer; 'a' - for en stor eller liten bokstav; '#' - for et siffer eller en stor eller liten bokstav. Bruk omvendt skråstrek '\\' for å unnslippe et tegn."
        },
        datetimemask: {
            pattern: "Mønsteret kan inneholde skilletegn og følgende plassholdere:<br>'m' – Månedsnummer.<br>'mm' - Månedsnummer, med foranstilt null for ensifrede verdier. <br>'d' - Dag i måneden. <br>'dd' - Dagen i måneden, med foranstilt null for ensifrede verdier. <br>'yy' - De to siste sifrene i året. <br>'yyyy' - Firesifret år. <br>'H' - Timer i 24-timers format. <br>'HH' - Timer i 24-timers format, med foranstilt null for ensifrede verdier. <br>'h' - Timer i 12-timers format. <br>'hh' - Timer i 12-timers format, med ledende null for ensifrede verdier. <br>'MM' - minutter. <br>'ss' - Sekunder. <br>'TT' - 12-timers klokkeperiode med store bokstaver (AM / PM). <br>'TT' - 12-timers klokkeperiode med små bokstaver (AM / PM)."
        },
        numericmask: {
            decimalSeparator: "Et symbol som brukes til å skille brøkdelen fra heltallsdelen av et tall som vises.",
            thousandsSeparator: "Et symbol som brukes til å skille sifrene i et stort tall i grupper på tre.",
            precision: "Begrenser hvor mange sifre som skal beholdes etter desimaltegnet for et tall som vises."
        },
        currencymask: {
            prefix: "Ett eller flere symboler som skal vises før verdien.",
            suffix: "Ett eller flere symboler som skal vises etter verdien."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "title",
            title: "La den være tom, dersom den skal være samme som navnet"
        },
        multiSelect: "Tillat flere valg",
        showLabel: "Vis bildetekster",
        swapOrder: "Bytte rekkefølgen på Ja og Nei",
        value: "Verdi",
        tabAlign: "Justering av tabulatorer",
        sourceType: "Type kilde",
        fitToContainer: "Tilpass til container",
        setValueExpression: "Angi verdiuttrykk",
        description: "description",
        logoFit: "Logo passform",
        pages: "Sider",
        questions: "Spørsmål",
        triggers: "triggers",
        calculatedValues: "Beregnede verdier",
        surveyId: "Undersøkelses-ID",
        surveyPostId: "Post-ID for undersøkelse",
        surveyShowDataSaving: "Undersøkelse viser datalagring",
        questionDescriptionLocation: "Spørsmål beskrivelse sted",
        progressBarType: "Type fremdriftsindikator",
        showTOC: "Vis innholdsfortegnelse",
        tocLocation: "Toc-plassering",
        questionTitlePattern: "Mønster for spørsmålstittel",
        widthMode: "Bredde, modus",
        showBrandInfo: "Vis merkeinformasjon",
        useDisplayValuesInDynamicTexts: "Bruke visningsverdier i dynamiske tekster",
        visibleIf: "visibleIf",
        defaultValueExpression: "Uttrykk for standardverdi",
        requiredIf: "requiredIf",
        resetValueIf: "Tilbakestill verdien hvis",
        setValueIf: "Angi verdi hvis",
        validators: "validators",
        bindings: "Bindinger",
        renderAs: "Gjengi som",
        attachOriginalItems: "Legg ved originale elementer",
        choices: "choices",
        choicesByUrl: "choicesByUrl",
        currency: "currency",
        cellHint: "Celle hint",
        totalMaximumFractionDigits: "Totalt maksimum antall sifre i brøk",
        totalMinimumFractionDigits: "Totalt antall minimumssifre i brøk",
        columns: "columns",
        detailElements: "Detaljelementer",
        allowAdaptiveActions: "Tillat adaptive handlinger",
        defaultRowValue: "defaultRowValue",
        detailPanelShowOnAdding: "Detaljpanelet vises når du legger til",
        choicesLazyLoadEnabled: "Valg lat belastning aktivert",
        choicesLazyLoadPageSize: "Valg lat lastesidestørrelse",
        inputFieldComponent: "Komponent for inntastingsfelt",
        itemComponent: "Element komponent",
        min: "Min",
        max: "Maks",
        minValueExpression: "Mitt verdiuttrykk",
        maxValueExpression: "Uttrykk med maksverdi",
        step: "Skritt",
        dataList: "Dataliste",
        itemSize: "itemSize",
        itemTitleWidth: "Bredden på vareetiketten (i piksler)",
        elements: "Elementer",
        content: "Innhold",
        navigationButtonsVisibility: "navigationButtonsVisibility",
        navigationTitle: "Navigasjon tittel",
        navigationDescription: "Beskrivelse av navigasjon",
        longTap: "Langt trykk",
        autoGrow: "Automatisk vekst",
        allowResize: "Tillat endring av størrelse",
        acceptCarriageReturn: "Godta retur av frakt",
        displayMode: "Visningsmodus",
        rateType: "Type sats",
        label: "label",
        contentMode: "Innhold-modus",
        imageFit: "Tilpasning til bildet",
        altText: "Alternativ tekst",
        height: "Høyde",
        penColor: "Farge på penn",
        backgroundColor: "Bakgrunnsfarge",
        templateElements: "Mal elementer",
        operator: "Operatør",
        isVariable: "Er variabel",
        runExpression: "Kjør uttrykk",
        showCaption: "Vis bildetekst",
        iconName: "Navn på ikon",
        iconSize: "Ikon størrelse",
        precision: "Presisjon",
        matrixDragHandleArea: "Område for drahåndtak for matrise",
        backgroundImage: "Bakgrunnsbilde",
        backgroundImageFit: "Tilpasning til bakgrunnsbilde",
        backgroundImageAttachment: "Vedlegg til bakgrunnsbilde",
        backgroundOpacity: "Ugjennomsiktighet i bakgrunnen",
        selectToRankEnabled: "Velg for å rangere aktivert",
        selectToRankAreasLayout: "Velg for å rangere områdeoppsettet",
        selectToRankEmptyRankedAreaText: "Tekst som skal vises hvis alle alternativene er valgt",
        selectToRankEmptyUnrankedAreaText: "Plassholdertekst for rangeringsområdet",
        allowCameraAccess: "Tillat kameratilgang",
        scaleColorMode: "Skaler farge, modus",
        rateColorMode: "Vurder farge, modus",
        copyDisplayValue: "Kopier visningsverdi",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Avansert modus",
        pageTitle: "Skrift for sidetittel",
        questionTitle: "Spørsmål tittel skrift",
        editorPanel: "Inndata-element",
        lines: "Linjer",
        primaryDefaultColor: "Standard",
        primaryDarkColor: "Sveve",
        primaryLightColor: "Utvalgt",
        backgroundDimColor: "Bakgrunnsfarge",
        cornerRadius: "Hjørne radius",
        backcolor: "Standard bakgrunn",
        hovercolor: "Pekerfølsom bakgrunn",
        borderDecoration: "Grense dekorasjon",
        fontColor: "Skriftfarge",
        backgroundColor: "Bakgrunnsfarge",
        primaryForecolor: "Standardfarge",
        primaryForecolorLight: "Deaktivert farge",
        font: "Font",
        borderDefault: "Mørkere",
        borderLight: "Lekter",
        fontFamily: "Skriftfamilie",
        fontWeightRegular: "Regelmessig",
        fontWeightHeavy: "Tung",
        fontWeightSemiBold: "Halvmodig",
        fontWeightBold: "Fet",
        color: "Farge",
        placeholderColor: "Plassholderfarge",
        size: "Størrelse",
        opacity: "Ugjennomsiktighet",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Legg til skyggeeffekt",
        boxShadowBlur: "Dimme",
        boxShadowSpread: "Spredning",
        boxShadowDrop: "Dråpe",
        boxShadowInner: "Indre",
        names: {
            default: "Standard",
            sharp: "Skarp",
            borderless: "Kantløse",
            flat: "Flat",
            plain: "Slette",
            doubleborder: "Dobbel kantlinje",
            layered: "Lagdelte",
            solid: "Solid",
            threedimensional: ".3D",
            contrast: "Kontrast"
        },
        colors: {
            teal: "Teal",
            blue: "Blå",
            purple: "Lilla",
            orchid: "Orkidé",
            tulip: "Tulipan",
            brown: "Brun",
            green: "Grønn"
        }
    }
};
//Uncomment this line on creating a translation file. You should replace "en" and enStrings with your locale ("fr", "de" and so on) and your variable.
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["nb"] = nbStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// survey.duplicate: "Duplicate" => "Duplikat"
// qt.ranking: "Ranking" => "Rangering"
// qt.tagbox: "Multi-Select Dropdown" => "Rullegardinmenyen for flere valg"
// qt.buttongroup: "Button Group" => "Knappegruppe"
// ed.surveySettings: "Survey Settings" => "Innstillinger for undersøkelse"
// ed.surveySettingsTooltip: "Open survey settings" => "Åpne innstillinger for evaluering"
// ed.prevSelected: "Select previous" => "Velg forrige"
// ed.nextSelected: "Select next" => "Velg neste"
// ed.surveyTypeName: "Survey" => "Undersøkelse"
// ed.pageTypeName: "Page" => "Side"
// ed.panelTypeName: "Panel" => "Panel"
// ed.questionTypeName: "Question" => "Spørsmål"
// ed.columnTypeName: "Column" => "Kolonne"
// ed.themeSurvey: "Themes" => "Temaer"
// ed.defaultV2Theme: "Default" => "Standard"
// ed.modernTheme: "Modern" => "Moderne"
// ed.defaultTheme: "Default (legacy)" => "Standard (eldre)"
// ed.jsonHideErrors: "Hide errors" => "Skjul feil"
// ed.jsonShowErrors: "Show errors" => "Vis feil"
// ed.showMoreChoices: "Show more" => "Vis mer"
// ed.showLessChoices: "Show less" => "Vis mindre"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "Skriv for å søke ..."
// ed.toolboxChoiceCategory: "Choice Questions" => "Choice Spørsmål"
// ed.toolboxTextCategory: "Text Input Questions" => "Spørsmål om tekstinndata"
// ed.toolboxContainersCategory: "Containers" => "Beholdere"
// ed.toolboxMatrixCategory: "Matrix Questions" => "Matrise Spørsmål"
// ed.toolboxMiscCategory: "Misc" => "Misc"
// ed.translationPropertyGridTitle: "Language Settings" => "Språkinnstillinger"
// ed.themePropertyGridTitle: "Theme Settings" => "Tema innstillinger"
// ed.translationLanguages: "Languages" => "Språk"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "Bare brukte strenger"
// ed.translationPlaceHolder: "Translation..." => "Oversettelse..."
// ed.themeExportButton: "Export" => "Eksport"
// ed.themeImportButton: "Import" => "Importere"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Valgene kopieres fra"
// ed.htmlPlaceHolder: "HTML content will be here." => "HTML-innhold vil være her."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "Slipp et spørsmål fra verktøykassen her."
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "Undersøkelsen er tom. Dra et element fra verktøykassen, eller klikk på knappen nedenfor."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Dra og slipp et bilde her, eller klikk på knappen nedenfor og velg et bilde du vil laste opp"
// ed.imageChooseImage: "Choose Image" => "Velg bilde"
// ed.addNewTypeQuestion: "Add {0}" => "Legg til {0}"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[LOGO]"
// ed.auto: "auto" => "auto"
// ed.choices_Item: "Item " => "Vare "
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "Opprett en regel for å tilpasse flyten i evalueringen."
// lg.page_enableName: "Enable (disable) page" => "Aktivere (deaktivere) side"
// lg.column_visibilityName: "Show (hide) column" => "Vis kolonne (skjul)"
// lg.column_enableName: "Enable (disable) column" => "Aktivere (deaktivere) kolonne"
// lg.column_requireName: "Make column required" => "Gjøre kolonne obligatorisk"
// lg.itemEmptyExpressionText: "New rule" => "Ny regel"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "Gjør kolonne {0} av spørsmålet {1} synlig"
// lg.column_enableText: "make column {0} of question {1} enable" => "Gjør kolonne {0} av spørsmålet {1} aktiver"
// lg.column_requireText: "make column {0} of question {1} required" => "Gjør kolonne {0} av spørsmålet {1} nødvendig"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "Klar spørsmålsverdi: {0}"
// lg.showAllQuestions: "All Questions" => "Alle spørsmål"
// lg.showAllActionTypes: "All Action Types" => "Alle handlingstyper"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Logiske regler er ufullstendige"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Noen av de logiske reglene har du ikke fullført. Hvis du forlater fanen nå, vil endringene gå tapt. Vil du fortsatt forlate fanen uten å fullføre endringene?"
// lg.uncompletedRule_apply: "Yes" => "Ja"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Nei, jeg vil fullføre reglene"
// pe.clear: "Clear" => "Klar"
// pe.set: "Set" => "Sett"
// pe.change: "Change" => "Forandre"
// pe.close: "Close" => "Lukke"
// pe.removeItem: "Click to remove the item..." => "Klikk for å fjerne elementet..."
// pe.dragItem: "Drag the item" => "Dra elementet"
// pe.doneEditing: "Done" => "Gjort"
// pe.emptyValue: "Value is empty" => "Verdien er tom"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "Verdien «{0}» er ikke unik"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "Begrens antall varer fra {0} til {1}"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "Du kan angi data i følgende format:\nverdi1|tekst\nverdi2"
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "Forhåndsvise svar før du sender inn undersøkelsen"
// pe.overridingPropertyPrefix: "Set by " => "Sett av "
// pe.propertyIsNoUnique: "Please enter a unique value" => "Angi en unik verdi"
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Ikke bruk reserverte ord: \"element\", \"valg\", \"panel\", \"rad\"."
// pe.listIsEmpty@choices: "No choices have been added yet" => "Ingen valg er lagt til ennå"
// pe.addNew@choices: "Add a choice" => "Legg til et valg"
// choicesbyurl.valueName: "Get values from the following JSON field" => "Hent verdier fra følgende JSON-felt"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "Hent bildenettadresser fra følgende JSON-felt"
// pe.allowEmptyResponse: "Allow empty response" => "Tillat tom respons"
// pe.and: "and" => "og"
// pe.or: "or" => "eller"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Velg et spørsmål for å begynne å konfigurere betingelsene."
// pe.if: "If" => "Hvis"
// pe.then: "then" => "da"
// pe.setToName: "Target question" => "Målspørsmål"
// pe.fromName: "Question to copy answer from" => "Spørsmål å kopiere svar fra"
// pe.gotoName: "Question to skip to" => "Spørsmål å hoppe til"
// pe.ruleIsNotSet: "Rule is incorrect" => "Regelen er feil"
// pe.includeIntoResult: "Include into survey results" => "Inkluder i undersøkelsesresultater"
// pe.portraitOrientation: "Switch to portrait orientation" => "Bytte til stående papirretning"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Bildehøyde (i CSS-godkjente verdier)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Bildebredde (i CSS-godkjente verdier)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "Tidsbegrensning for å fullføre siden (i sekunder)"
// question.page: "Parent page" => "Overordnet side"
// pe.noEntriesText: "Empty entries text" => "Tekst med tomme oppføringer"
// pe.setValue: "Answer" => "Svare"
// pe.dataFormat: "Image format" => "Bildeformat"
// pe.allowAddRows: "Allow adding rows" => "Tillat at rader legges til"
// pe.allowRemoveRows: "Allow removing rows" => "Tillat fjerning av rader"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "Tillat dra og slipp i rad"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "Gjelder ikke hvis du angir nøyaktig bildebredde eller -høyde."
// pe.minImageWidth: "Minimum image width" => "Minimum bildebredde"
// pe.maxImageWidth: "Maximum image width" => "Maksimal bildebredde"
// pe.minImageHeight: "Minimum image height" => "Minimum bildehøyde"
// pe.maxImageHeight: "Maximum image height" => "Maksimal bildehøyde"
// surveyvalidator.text: "Error message" => "Feilmelding"
// surveyvalidator.expression: "Validation expression" => "Uttrykk for validering"
// pe.logo: "Logo (URL or base64-encoded string)" => "Logo (URL eller base64-kodet streng)"
// pe.questionsOnPageMode: "Survey structure" => "Undersøkelse struktur"
// pe.maxTextLength: "Maximum answer length (in characters)" => "Maksimal svarlengde (i tegn)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "Maksimal kommentarlengde (i tegn)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "Utvid kommentarområdet automatisk om nødvendig"
// pe.allowResizeComment: "Allow users to resize text areas" => "Tillat brukere å endre størrelse på tekstområder"
// pe.textUpdateMode: "Update text question value" => "Oppdatere tekstspørsmålsverdi"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "Sette fokus på det første ugyldige svaret"
// pe.checkErrorsMode: "Run validation" => "Kjør validering"
// pe.navigateToUrl: "Navigate to URL" => "Naviger til URL"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "Dynamisk URL-adresse"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "Markering for å vise om brukeren allerede har fylt ut denne undersøkelsen"
// pe.completedHtml: "Survey Complete page markup" => "Sidemarkering for fullført undersøkelse"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "Sidemarkering for fullført dynamisk undersøkelse"
// pe.loadingHtml: "Markup to show while survey model is loading" => "Markering som skal vises mens evalueringsmodellen lastes inn"
// pe.commentText: "Comment area text" => "Tekst i kommentarfeltet"
// pe.autocomplete: "Autocomplete type" => "Autofullfør type"
// pe.labelTrue: "\"True\" label" => "Etiketten «True»"
// pe.labelFalse: "\"False\" label" => "\"False\" etikett"
// pe.allowClear: "Show the Clear button" => "Vis Fjern-knappen"
// pe.displayStyle: "Value display style" => "Visningsstil for verdi"
// pe.format: "Formatted string" => "Formatert streng"
// pe.maximumFractionDigits: "Maximum fractional digits" => "Maksimalt antall brøksifre"
// pe.minimumFractionDigits: "Minimum fractional digits" => "Minimum brøksifre"
// pe.useGrouping: "Display grouping separators" => "Skilletegn for skjermgruppering"
// pe.allowMultiple: "Allow multiple files" => "Tillat flere filer"
// pe.allowImagesPreview: "Preview images" => "Forhåndsvis bilder"
// pe.acceptedTypes: "Accepted file types" => "Godkjente filtyper"
// pe.waitForUpload: "Wait for the upload to complete" => "Vent til opplastingen er fullført"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "Bekreft sletting av fil"
// pe.detailPanelMode: "Detail panel location" => "Plassering av detaljpanelet"
// pe.minRowCount: "Minimum row count" => "Minimum radantall"
// pe.maxRowCount: "Maximum row count" => "Maksimalt radantall"
// pe.confirmDelete: "Confirm row deletion" => "Bekreft radsletting"
// pe.confirmDeleteText: "Confirmation message" => "Bekreftelsesmelding"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "Bekreft sletting av panel"
// pe.panelCount: "Initial panel count" => "Innledende panelopptelling"
// pe.minPanelCount: "Minimum panel count" => "Minimum antall paneler"
// pe.maxPanelCount: "Maximum panel count" => "Maksimalt antall paneler"
// pe.panelsState: "Inner panel expand state" => "Utvidelsestilstand for Indre panel"
// pe.templateDescription: "Description template" => "Mal for beskrivelse"
// pe.templateTitle: "Title template" => "Tittel mal"
// pe.panelPrevText: "Previous Panel button tooltip" => "Verktøytips for forrige panelknapp"
// pe.panelNextText: "Next Panel button tooltip" => "Verktøytips for neste panelknapp"
// pe.showRangeInProgress: "Show progress bar" => "Vis fremdriftsindikator"
// pe.templateTitleLocation: "Question title location" => "Spørsmål tittel sted"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "Fjern plassering av panelknappen"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "Skjul spørsmålet hvis det ikke er noen rader"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Skjule kolonner hvis det ikke er noen rader"
// pe.rateValues: "Custom rate values" => "Egendefinerte frekvensverdier"
// pe.rateCount: "Rate count" => "Antall priser"
// pe.autoGenerate: "How to specify rate values?" => "Hvordan spesifisere renteverdier?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "Skjul spørsmålet hvis det ikke inneholder noen valg"
// pe.hideNumber: "Hide question number" => "Skjul spørsmålsnummer"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Minimumsbredde (i CSS-godkjente verdier)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Maksimal bredde (i CSS-godkjente verdier)"
// pe.width: "Width (in CSS-accepted values)" => "Bredde (i CSS-godkjente verdier)"
// pe.showHeader: "Show column headers" => "Vise kolonneoverskrifter"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Vis vannrett rullefelt"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Minimum kolonnebredde (i CSS-godkjente verdier)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Radoverskriftsbredde (i CSS-godtatte verdier)"
// pe.valueTrue: "\"True\" value" => "\"True\"-verdi"
// pe.valueFalse: "\"False\" value" => "\"False\" verdi"
// pe.minErrorText: "\"Value is below minimum\" error message" => "Feilmeldingen «Verdien er under minimum»"
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "Feilmeldingen \"Verdien overskrider maksimum\""
// pe.otherErrorText: "\"Empty comment\" error message" => "Feilmeldingen «Tom kommentar»"
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "Feilmeldingen \"Ikke-unik nøkkelverdi\""
// pe.minSelectedChoices: "Minimum selected choices" => "Minimum valgte valg"
// pe.maxSelectedChoices: "Maximum selected choices" => "Maksimalt antall merkede valg"
// pe.showClearButton: "Show the Clear button" => "Vis Fjern-knappen"
// pe.showNumber: "Show panel number" => "Vis panelnummer"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "Logobredde (i CSS-godkjente verdier)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "Logohøyde (i CSS-godkjente verdier)"
// pe.readOnly: "Read-only" => "Skrivebeskyttet"
// pe.enableIf: "Editable if" => "Kan redigeres hvis"
// pe.emptyRowsText: "\"No rows\" message" => "Meldingen «Ingen rader»"
// pe.size: "Input field size (in characters)" => "Størrelse på inndatafelt (i tegn)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "Skille spesialvalg (Ingen, Annet, Merk alt)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Kopier valg fra følgende spørsmål"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Hvilke valg å kopiere?"
// pe.showCommentArea: "Show the comment area" => "Vis kommentarfeltet"
// pe.commentPlaceholder: "Comment area placeholder" => "Plassholder for kommentarområde"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Vise frekvensbeskrivelser som ekstremverdier"
// pe.rowsOrder: "Row order" => "Rekkefølge på rad"
// pe.columnsLayout: "Column layout" => "Kolonneoppsett"
// pe.columnColCount: "Nested column count" => "Nestet kolonneantall"
// pe.state: "Panel expand state" => "Utvidelsestilstand for panel"
// pe.correctAnswer: "Correct Answer" => "Riktig svar"
// pe.defaultPanelValue: "Default Values" => "Standardverdier"
// pe.cells: "Cell Texts" => "Cell Tekster"
// pe.keyName: "Key column" => "Nøkkelkolonne"
// itemvalue.text: "Alt text" => "Alternativ tekst"
// tabs.expression: "Expression" => "Uttrykk"
// pe.choicesVisibleIf: "Choices are visible if" => "Valgene er synlige hvis"
// pe.choicesEnableIf: "Choices are selectable if" => "Valgene kan velges hvis"
// pe.columnsEnableIf: "Columns are visible if" => "Kolonner er synlige hvis"
// pe.rowsEnableIf: "Rows are visible if" => "Rader er synlige hvis:"
// pe.indent: "Add indents" => "Legge til innrykk"
// panel.indent: "Add outer indents" => "Legge til ytre innrykk"
// pe.innerIndent: "Add inner indents" => "Legge til indre innrykk"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "Ta standardverdier fra den siste raden"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "Ta standardverdier fra det siste panelet"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "Skriv inn uttrykk her..."
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "Fjern verdien hvis spørsmålet blir skjult"
// pe.valuePropertyName: "Value property name" => "Navn på egenskap Value"
// pe.searchEnabled: "Enable search" => "Aktivere søk"
// pe.hideSelectedItems: "Hide selected items" => "Skjule merkede elementer"
// pe.closeOnSelect: "Close the dropdown after selection" => "Lukk rullegardinmenyen etter valget"
// pe.signatureWidth: "Signature width" => "Signatur bredde"
// pe.signatureHeight: "Signature height" => "Signatur høyde"
// pe.verticalAlign: "Vertical alignment" => "Loddrett justering"
// pe.alternateRows: "Alternate rows" => "Annenhver rad"
// pe.columnsVisibleIf: "Columns are visible if" => "Kolonner er synlige hvis"
// pe.rowsVisibleIf: "Rows are visible if" => "Rader er synlige hvis:"
// pe.otherPlaceholder: "Comment area placeholder" => "Plassholder for kommentarområde"
// pe.rateType: "Rate type" => "Type sats"
// pv.true: "true" => "sann"
// pv.false: "false" => "falsk"
// pv.decimal: "decimal" => "desimal"
// pv.currency: "currency" => "valuta"
// pv.percent: "percent" => "prosent"
// pv.onpanel: "Start on each panel" => "Start på hvert panel"
// pv.tab: "Tabs" => "Kategoriene"
// pv.right: "Right" => "Høyre"
// pv.color: "color" => "farge"
// pv.date: "date" => "daddel"
// pv.datetime: "datetime" => "datetime"
// pv.datetime-local: "datetime-local" => "datetime-lokal"
// pv.email: "email" => "E-post"
// pv.month: "month" => "måned"
// pv.number: "number" => "nummer"
// pv.password: "password" => "passord"
// pv.range: "range" => "rekkevidde"
// pv.tel: "tel" => "Tel"
// pv.text: "text" => "Tekst"
// pv.time: "time" => "Tid"
// pv.url: "url" => "URL"
// pv.week: "week" => "uke"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "Når spørsmålet eller panelet/siden blir skjult"
// clearInvisibleValues.none: "Never" => "Aldri"
// inputType.color: "Color" => "Farge"
// inputType.date: "Date" => "Daddel"
// inputType.datetime-local: "Date and Time" => "Dato og klokkeslett"
// inputType.email: "Email" => "E-post"
// inputType.month: "Month" => "Måned"
// inputType.number: "Number" => "Nummer"
// inputType.password: "Password" => "Passord"
// inputType.range: "Range" => "Rekkevidde"
// inputType.tel: "Phone Number" => "Telefonnummer"
// inputType.text: "Text" => "Tekst"
// inputType.time: "Time" => "Tid"
// inputType.url: "URL" => "URL"
// inputType.week: "Week" => "Uke"
// pv.onValueChanging: "Before an answer is changed" => "Før et svar endres"
// pv.pages: "Completed pages" => "Fullførte sider"
// pv.questions: "Answered questions" => "Besvarte spørsmål"
// pv.requiredQuestions: "Answered required questions" => "Besvarte nødvendige spørsmål"
// pv.correctQuestions: "Valid answers" => "Gyldige svar"
// pv.buttons: "Completed pages (button UI)" => "Fullførte sider (brukergrensesnitt for knapp)"
// pv.underInput: "Under the input" => "Under inngangen"
// pv.underTitle: "Under the title" => "Under tittelen"
// pv.onBlur: "On blur" => "På uskarphet"
// pv.onTyping: "While typing" => "Mens du skriver"
// pv.underRow: "Under the row" => "Under raden"
// pv.underRowSingle: "Under the row, only one panel is visible" => "Under raden er bare ett panel synlig"
// showNavigationButtons.none: "Hidden" => "Skjult"
// showProgressBar.off: "Hidden" => "Skjult"
// showTimerPanel.none: "Hidden" => "Skjult"
// showTimerPanelMode.all: "Both" => "Begge"
// detailPanelMode.none: "Hidden" => "Skjult"
// addRowLocation.default: "Depends on matrix layout" => "Avhenger av matriseoppsett"
// panelsState.default: "Users cannot expand or collapse panels" => "Brukere kan ikke vise eller skjule paneler"
// panelsState.collapsed: "All panels are collapsed" => "Alle paneler er skjult"
// panelsState.expanded: "All panels are expanded" => "Alle paneler er utvidet"
// widthMode.auto: "Auto" => "Auto"
// widthMode.static: "Static" => "Statisk"
// widthMode.responsive: "Responsive" => "Lydhør"
// imageFit.none: "None" => "Ingen"
// imageFit.contain: "Contain" => "Inneholde"
// imageFit.cover: "Cover" => "Lokk"
// imageFit.fill: "Fill" => "Fylle"
// contentMode.auto: "Auto" => "Auto"
// contentMode.image: "Image" => "Bilde"
// contentMode.video: "Video" => "Video"
// contentMode.youtube: "YouTube" => "YouTube"
// displayMode.auto: "Auto" => "Auto"
// displayMode.buttons: "Buttons" => "Knapper"
// displayMode.dropdown: "Dropdown" => "Rullegardinmeny"
// rateColorMode.default: "Default" => "Standard"
// autoGenerate.true: "Generate" => "Frembringe"
// autoGenerate.false: "Enter manually" => "Angi manuelt"
// rateType.labels: "Labels" => "Etiketter"
// rateType.stars: "Stars" => "Stjerner"
// rateType.smileys: "Smileys" => "Smilefjes"
// op.and: "and" => "og"
// op.or: "or" => "eller"
// ew.modern: "Modern theme" => "Moderne tema"
// ew.default: "Default theme" => "Standard tema"
// ew.orange: "Orange theme" => "Oransje-tema"
// ew.darkblue: "Darkblue theme" => "Mørkeblått-tema"
// ew.darkrose: "Darkrose theme" => "Darkrose-tema"
// ew.stone: "Stone theme" => "Stein-tema"
// ew.winter: "Winter theme" => "Vinter-tema"
// ew.winterstone: "Winter-Stone theme" => "Vinterstein-tema"
// ts.hideInvisibleElements: "Hide invisible elements" => "Skjule usynlige elementer"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Informasjonskapsler hindrer brukere i å fylle ut den samme undersøkelsen to ganger."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Endrer størrelsen på det synlige området i inndatafeltet. <b>Bruk innstillingen Validering → maksimal lengde</b> for å begrense inngangslengden."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Bruk {0} som plassholder for den faktiske verdien."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Bare synlig når minst én kolonne har Totaltype- eller Total-uttrykk."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Se attributtbeskrivelsen [accept](https://www.w3schools.com/tags/att_input_accept.asp) hvis du vil ha mer informasjon."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Gjelder bare for celletypene Radiogruppe og Avmerkingsboks."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Se attributtbeskrivelsen [autofullfør](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) hvis du vil ha mer informasjon."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Hvis du ikke angir denne egenskapen, lagres svaret i et felt som er angitt av egenskapen Name."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Hvis den angitte kolonnen inneholder identiske verdier, gir undersøkelsen feilen \"Ikke-unik nøkkelverdi\"."
// p.multiSelect: "Allow multiple selection" => "Tillat flere valg"
// p.showLabel: "Show image captions" => "Vis bildetekster"
// p.value: "Value" => "Verdi"
// p.tabAlign: "Tab alignment" => "Justering av tabulatorer"
// p.logoFit: "Logo fit" => "Logo passform"
// p.pages: "Pages" => "Sider"
// p.questions: "Questions" => "Spørsmål"
// p.calculatedValues: "Calculated values" => "Beregnede verdier"
// p.surveyId: "Survey id" => "Undersøkelses-ID"
// p.surveyPostId: "Survey post id" => "Post-ID for undersøkelse"
// p.surveyShowDataSaving: "Survey show data saving" => "Undersøkelse viser datalagring"
// p.questionDescriptionLocation: "Question description location" => "Spørsmål beskrivelse sted"
// p.progressBarType: "Progress bar type" => "Type fremdriftsindikator"
// p.showTOC: "Show TOC" => "Vis innholdsfortegnelse"
// p.tocLocation: "Toc location" => "Toc-plassering"
// p.questionTitlePattern: "Question title pattern" => "Mønster for spørsmålstittel"
// p.widthMode: "Width mode" => "Bredde, modus"
// p.showBrandInfo: "Show brand info" => "Vis merkeinformasjon"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "Bruke visningsverdier i dynamiske tekster"
// p.descriptionLocation: "Description location" => "Beskrivelse plassering"
// p.defaultValueExpression: "Default value expression" => "Uttrykk for standardverdi"
// p.bindings: "Bindings" => "Bindinger"
// p.renderAs: "Render as" => "Gjengi som"
// p.attachOriginalItems: "Attach original items" => "Legg ved originale elementer"
// p.cellHint: "Cell hint" => "Celle hint"
// p.isUnique: "Is unique" => "Er unik"
// p.showInMultipleColumns: "Show in multiple columns" => "Vis i flere kolonner"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Totalt maksimum antall sifre i brøk"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Totalt antall minimumssifre i brøk"
// p.detailElements: "Detail elements" => "Detaljelementer"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Tillat adaptive handlinger"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "Detaljpanelet vises når du legger til"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Valg lat belastning aktivert"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Valg lat lastesidestørrelse"
// p.inputFieldComponent: "Input field component" => "Komponent for inntastingsfelt"
// p.itemComponent: "Item component" => "Element komponent"
// p.min: "Min" => "Min"
// p.max: "Max" => "Maks"
// p.minValueExpression: "Min value expression" => "Mitt verdiuttrykk"
// p.maxValueExpression: "Max value expression" => "Uttrykk med maksverdi"
// p.step: "Step" => "Skritt"
// p.dataList: "Data list" => "Dataliste"
// p.elements: "Elements" => "Elementer"
// p.content: "Content" => "Innhold"
// p.navigationTitle: "Navigation title" => "Navigasjon tittel"
// p.navigationDescription: "Navigation description" => "Beskrivelse av navigasjon"
// p.longTap: "Long tap" => "Langt trykk"
// p.autoGrow: "Auto grow" => "Automatisk vekst"
// p.allowResize: "Allow resizing" => "Tillat endring av størrelse"
// p.acceptCarriageReturn: "Accept carriage return" => "Godta retur av frakt"
// p.displayMode: "Display mode" => "Visningsmodus"
// p.rateType: "Rate type" => "Type sats"
// p.contentMode: "Content mode" => "Innhold-modus"
// p.imageFit: "Image fit" => "Tilpasning til bildet"
// p.altText: "Alt text" => "Alternativ tekst"
// p.height: "Height" => "Høyde"
// p.penColor: "Pen color" => "Farge på penn"
// p.backgroundColor: "Background color" => "Bakgrunnsfarge"
// p.templateElements: "Template elements" => "Mal elementer"
// p.operator: "Operator" => "Operatør"
// p.isVariable: "Is variable" => "Er variabel"
// p.runExpression: "Run expression" => "Kjør uttrykk"
// p.showCaption: "Show caption" => "Vis bildetekst"
// p.iconName: "Icon name" => "Navn på ikon"
// p.iconSize: "Icon size" => "Ikon størrelse"
// p.precision: "Precision" => "Presisjon"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Område for drahåndtak for matrise"
// p.backgroundImage: "Background image" => "Bakgrunnsbilde"
// p.backgroundImageFit: "Background image fit" => "Tilpasning til bakgrunnsbilde"
// p.backgroundImageAttachment: "Background image attachment" => "Vedlegg til bakgrunnsbilde"
// p.backgroundOpacity: "Background opacity" => "Ugjennomsiktighet i bakgrunnen"
// p.selectToRankEnabled: "Select to rank enabled" => "Velg for å rangere aktivert"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Velg for å rangere områdeoppsettet"
// p.allowCameraAccess: "Allow camera access" => "Tillat kameratilgang"
// p.scaleColorMode: "Scale color mode" => "Skaler farge, modus"
// p.rateColorMode: "Rate color mode" => "Vurder farge, modus"
// p.templateTabTitle: "Template tab title" => "Tittel på Mal-fanen"
// p.templateVisibleIf: "Template visible if" => "Mal synlig hvis"
// p.copyDisplayValue: "Copy display value" => "Kopier visningsverdi"
// theme.--background: "Background color" => "Bakgrunnsfarge"
// theme.--background-dim-light: "Background dim light color" => "Svak lys farge i bakgrunnen"
// theme.--primary-foreground: "Primary foreground color" => "Primær forgrunnsfarge"
// theme.--foreground: "Foreground color" => "Forgrunnsfarge"
// theme.--base-unit: "Base unit" => "Basisenhet"
// theme.groupAdvanced: "Advanced" => "Avansert"
// theme.themeName: "Theme" => "Tema"
// theme.isPanellessss: "Question appearance" => "Spørsmål utseende"
// theme.isPanellessPanels: "Default" => "Standard"
// theme.isPanellessLightweight: "Without Panels" => "Uten paneler"
// theme.themePaletteLight: "Light" => "Lys"
// theme.themePaletteDark: "Dark" => "Mørk"
// theme.primaryColor: "Accent color" => "Uthevingsfarge"
// theme.primaryDefaultColor: "Default" => "Standard"
// theme.primaryDarkColor: "Hover" => "Sveve"
// theme.primaryLightColor: "Selected" => "Utvalgt"
// theme.backgroundDimColor: "Background color" => "Bakgrunnsfarge"
// theme.backgroundImage: "Background image" => "Bakgrunnsbilde"
// theme.backgroundImageFitAuto: "Auto" => "Auto"
// theme.backgroundImageFitCover: "Cover" => "Lokk"
// theme.backgroundImageFitContain: "Contain" => "Inneholde"
// theme.backgroundOpacity: "Opacity" => "Ugjennomsiktighet"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Fast"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Bla"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Tetthet i panelbakgrunn"
// theme.questionBackgroundTransparency: "Question background opacity" => "Spørsmål om bakgrunnstetthet"
// theme.questionPanel: "Panel background and corner radius" => "Panelbakgrunn og hjørneradius"
// theme.questionTitle: "Question title font" => "Spørsmål tittel skrift"
// theme.questionDescription: "Question description font" => "Skrift for spørsmålsbeskrivelse"
// theme.editorPanel: "Input element" => "Inndata-element"
// theme.editorFont: "Input element font" => "Skrift for inndataelement"
// theme.backcolor: "Default background" => "Standard bakgrunn"
// theme.hovercolor: "Hover background" => "Pekerfølsom bakgrunn"
// theme.borderDecoration: "Border decoration" => "Grense dekorasjon"
// theme.accentBackground: "Accent background" => "Bakgrunn med aksent"
// theme.accentForeground: "Accent foreground" => "Uthevingsforgrunn"
// theme.primaryForecolor: "Default color" => "Standardfarge"
// theme.primaryForecolorLight: "Disabled color" => "Deaktivert farge"
// theme.linesColors: "Minor line colors" => "Mindre linjefarger"
// theme.borderDefault: "Darker" => "Mørkere"
// theme.borderLight: "Lighter" => "Lekter"
// theme.fontFamily: "Font family" => "Skriftfamilie"
// theme.fontSize: "Font size" => "Skriftstørrelse"
// theme.color: "Color" => "Farge"
// theme.size: "Size" => "Størrelse"
// theme.fontWeightRegular: "Regular" => "Regelmessig"
// theme.fontWeightHeavy: "Heavy" => "Tung"
// theme.fontWeightSemiBold: "Semi-bold" => "Halvmodig"
// theme.fontWeightBold: "Bold" => "Fet"
// theme.scale: "Scale" => "Skala"
// theme.cornerRadius: "Corner radius" => "Hjørne radius"
// theme.surveyTitleFont: "Survey title font" => "Skrift for undersøkelsestittel"
// theme.pageTitle: "Page title font" => "Skrift for sidetittel"
// theme.pageDescription: "Page description font" => "Skrift for sidebeskrivelse"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Legg til skyggeeffekt"
// theme.opacity: "Opacity" => "Ugjennomsiktighet"
// theme.boxShadowBlur: "Blur" => "Dimme"
// theme.boxShadowSpread: "Spread" => "Spredning"
// theme.boxShadowDrop: "Drop" => "Dråpe"
// theme.boxShadowInner: "Inner" => "Indre"
// theme.questionShadow: "Shadow effects" => "Skygge effekter"
// theme.editorShadow: "Input element shadow effects" => "Skyggeeffekter for inndataelement"
// names.default: "Default" => "Standard"
// names.contrast: "Contrast" => "Kontrast"
// names.plain: "Plain" => "Slette"
// names.simple: "Simple" => "Enkel"
// names.blank: "Blank" => "Blank"
// names.double: "Double" => "Dobbel"
// names.bulk: "Bulk" => "Bulk"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo 3D"
// names.playful: "Playful" => "Leken"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Teal"
// colors.blue: "Blue" => "Blå"
// colors.purple: "Purple" => "Lilla"
// colors.orchid: "Orchid" => "Orkidé"
// colors.tulip: "Tulip" => "Tulipan"
// colors.brown: "Brown" => "Brun"
// colors.green: "Green" => "Grønn"
// names.sharp: "Sharp" => "Skarp"
// names.borderless: "Borderless" => "Kantløse"
// names.flat: "Flat" => "Flat"
// names.doubleborder: "Double Border" => "Dobbel kantlinje"
// names.layered: "Layered" => "Lagdelte"
// names.solid: "Solid" => "Solid"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Er du sikker på at du ønsker å slette alle strenger for dette språket?"
// ed.themeResetButton: "Reset theme settings to default" => "Tilbakestill temainnstillinger til standard"
// theme.placeholderColor: "Placeholder color" => "Plassholderfarge"
// ed.themeSettings: "Theme Settings" => "Tema innstillinger"
// ed.themeSettingsTooltip: "Open theme settings" => "Åpne temainnstillinger"
// pe.resetToDefaultCaption: "Reset" => "Nullstille"
// pv.file: "Local files" => "Lokale filer"
// pv.camera: "Camera" => "Kamera"
// pv.file-camera: "Local files or camera" => "Lokale filer eller kamera"
// ed.translateUsigAI: "Auto-translate All" => "Oversett alle automatisk"
// ed.translationDialogTitle: "Untranslated strings" => "Uoversatte strenger"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Vennligst skriv inn minst {0} elementer"
// lg.question_resetValueName: "Reset question value" => "Tilbakestille spørsmålsverdien"
// lg.column_resetValue: "Reset column value" => "Tilbakestille kolonneverdi"
// pe.markRequired: "Mark as required" => "Merk etter behov"
// pe.removeRequiredMark: "Remove the required mark" => "Fjern ønsket merke"
// p.resetValueIf: "Reset value if" => "Tilbakestill verdien hvis"
// lg.question_setValueName: "Set question value" => "Angi spørsmålsverdi"
// lg.column_resetValueName: "Reset column value" => "Tilbakestille kolonneverdi"
// lg.column_setValueName: "Set column value" => "Angi kolonneverdi"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Et uttrykk der resultatet tilordnes målspørsmålet."
// survey.title: "Title" => "Tittel"
// page.title: "Title" => "Tittel"
// p.setValueIf: "Set value if" => "Angi verdi hvis"
// theme.header: "Header" => "Topptekst"
// theme.backgroundImageFitFill: "Stretch" => "Strekning"
// theme.backgroundImageFitTile: "Tile" => "Flis"
// theme.headerView: "View" => "Utsikt"
// theme.headerViewBasic: "Basic" => "Grunnleggende"
// theme.headerViewAdvanced: "Advanced" => "Avansert"
// theme.headerInheritWidthFrom: "Content area width" => "Bredde på innholdsområdet"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Samme som undersøkelse"
// theme.headerInheritWidthFromPage: "Fit to page" => "Tilpass til side"
// theme.headerTextAreaWidth: "Text width" => "Tekstbredde"
// theme.headerBackgroundColorSwitch: "Background color" => "Bakgrunnsfarge"
// theme.headerBackgroundColorNone: "None" => "Ingen"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Uthevingsfarge"
// theme.headerBackgroundColorCustom: "Custom" => "Skikk"
// theme.horizontalAlignmentLeft: "Left" => "Venstre"
// theme.horizontalAlignmentCenter: "Center" => "Sentrum"
// theme.horizontalAlignmentRight: "Right" => "Høyre"
// theme.verticalAlignmentTop: "Top" => "Topp"
// theme.verticalAlignmentMiddle: "Middle" => "Midt"
// theme.verticalAlignmentBottom: "Bottom" => "Bunn"
// lg.question_resetValueText: "reset value for question: {0}" => "Tilbakestill verdi for spørsmål: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "tilordne verdi: {1} til spørsmålet: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Tilbakestill celleverdi for kolonne: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Tilordne celleverdi: {1} til kolonne: {0}"
// ed.surveyJsonExportButton: "Export" => "Eksport"
// ed.surveyJsonImportButton: "Import" => "Importere"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Kopiere til utklippstavlen"
// pe.filePlaceholder: "File placeholder text" => "Plassholdertekst for fil"
// pe.photoPlaceholder: "Photo placeholder text" => "Tekst for plassholdere for bilde"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Plassholdertekst for fil eller bilde"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Gjelder når \"Kildetype\" er \"Lokale filer\" eller når kameraet er utilgjengelig"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Gjelder når \"Kildetype\" er \"Kamera\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Gjelder når \"Kildetype\" er \"Lokale filer eller kamera\"."
// theme.background: "Background" => "Bakgrunn"
// theme.appearance: "Appearance" => "Utseende"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Vil du virkelig tilbakestille temaet? Alle tilpasningene dine vil gå tapt."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Ja, tilbakestill temaet"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Tilpass til container"
// signaturepad.showPlaceholder: "Show the placeholder" => "Vise plassholderen"
// signaturepad.placeholder: "Placeholder text" => "Plassholdertekst"
// theme.surveyDescriptionFont: "Survey description font" => "Skrift for undersøkelsesbeskrivelse"
// ed.prevFocus: "Focus previous" => "Fokus forrige"
// ed.nextFocus: "Focus next" => "Fokus neste"
// ed.saveTheme: "Save Theme" => "Lagre tema"
// ed.saveThemeTooltip: "Save Theme" => "Lagre tema"
// lg.page_requireName: "Make page required" => "Gjøre siden obligatorisk"
// lg.panel_requireName: "Make page required" => "Gjøre siden obligatorisk"
// signaturepad.signatureWidth: "Signature area width" => "Bredde på signaturområde"
// signaturepad.signatureHeight: "Signature area height" => "Høyde på signaturområdet"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Skalere signaturområdet automatisk"
// signaturepad.penMinWidth: "Minimum pen width" => "Minimum pennebredde"
// signaturepad.penMaxWidth: "Maximum pen width" => "Maksimal pennebredde"
// theme.logoPosition: "Logo position" => "Logo posisjon"
// theme.headerTitlePosition: "Title position" => "Tittelposisjon"
// theme.headerDescriptionPosition: "Description position" => "Beskrivelse posisjon"
// ed.propertyGridNoResultsFound: "No results found" => "Fant ingen resultater"
// pv.leftRight: "Left and right" => "Venstre og høyre"
// p.sourceType: "Source type" => "Type kilde"
// p.fitToContainer: "Fit to container" => "Tilpass til container"
// p.setValueExpression: "Set value expression" => "Angi verdiuttrykk"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Valgene lastes inn fra en webtjeneste."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Gå til innstillinger"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Forhåndsvisning av alternativer for lastet valg"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Forhindre dupliserte svar i rader"
// theme.advancedMode: "Advanced mode" => "Avansert modus"
// theme.backgroundCornerRadius: "Background and corner radius" => "Bakgrunn og hjørneradius"
// theme.colorsTitle: "Colors" => "Farger"
// theme.font: "Font" => "Font"
// theme.lines: "Lines" => "Linjer"
// theme.titleFont: "Title font" => "Tittel skrift"
// theme.descriptionFont: "Description font" => "Beskrivelse font"
// theme.shadow: "Shadow effects" => "Skygge effekter"
// ed.translateUsigAIFrom: "Translate from: " => "Oversett fra: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Tillat alternativet Nekt å svare"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Tillat alternativet Vet ikke"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Tillat alternativet Nekt å svare"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Tillat alternativet Vet ikke"
// pv.contain: "Contain" => "Inneholde"
// pv.cover: "Cover" => "Lokk"
// pv.fill: "Fill" => "Fylle"
// pe.transposeData: "Transpose rows to columns" => "Transponere rader til kolonner"
// layout.panel: "Layout" => "Oppsett"
// layout.question: "Layout" => "Oppsett"
// layout.base: "Layout" => "Oppsett"
// panel.name: "Panel name" => "Navn på panel"
// panel.title: "Panel title" => "Panelets tittel"
// panel.description: "Panel description" => "Beskrivelse av panelet"
// panel.visibleIf: "Make the panel visible if" => "Gjør panelet synlig hvis"
// panel.requiredIf: "Make the panel required if" => "Gjør panelet nødvendig hvis"
// panel.questionsOrder: "Question order within the panel" => "Spørsmålsrekkefølge i panelet"
// panel.startWithNewLine: "Display the panel on a new line" => "Vise panelet på en ny linje"
// panel.state: "Panel collapse state" => "Status for panelskjuling"
// panel.width: "Inline panel width" => "Innebygd panelbredde"
// panel.minWidth: "Minimum panel width" => "Minimum panelbredde"
// panel.maxWidth: "Maximum panel width" => "Maksimal panelbredde"
// panel.showNumber: "Number panels" => "Nummerpaneler"
// paneldynamic.name: "Panel name" => "Navn på panel"
// paneldynamic.title: "Panel title" => "Panelets tittel"
// paneldynamic.description: "Panel description" => "Beskrivelse av panelet"
// paneldynamic.visibleIf: "Make the panel visible if" => "Gjør panelet synlig hvis"
// paneldynamic.requiredIf: "Make the panel required if" => "Gjør panelet nødvendig hvis"
// paneldynamic.page: "Move the panel to page" => "Flytte panelet til siden"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Vise panelet på en ny linje"
// paneldynamic.state: "Panel collapse state" => "Status for panelskjuling"
// paneldynamic.width: "Inline panel width" => "Innebygd panelbredde"
// paneldynamic.minWidth: "Minimum panel width" => "Minimum panelbredde"
// paneldynamic.maxWidth: "Maximum panel width" => "Maksimal panelbredde"
// paneldynamic.templateDescription: "Panel description pattern" => "Mønster for panelbeskrivelse"
// paneldynamic.templateTitle: "Panel title pattern" => "Mønster for paneltittel"
// paneldynamic.noEntriesText: "Empty panel text" => "Tom paneltekst"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Mønster for tabulatortittel"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Gjør et individuelt panel synlig hvis"
// paneldynamic.hideNumber: "Hide the panel number" => "Skjule panelnummeret"
// paneldynamic.titleLocation: "Panel title alignment" => "Justering av paneltittel"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Justering av panelbeskrivelse"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Justering av spørsmålstittel"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Justering av feilmelding"
// paneldynamic.newPanelPosition: "New panel location" => "Ny panelplassering"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Forhindre dupliserte svar i følgende spørsmål"
// question.name: "Question name" => "Spørsmål navn"
// question.title: "Question title" => "Spørsmål tittel"
// question.description: "Question description" => "Beskrivelse av spørsmål"
// question.visibleIf: "Make the question visible if" => "Gjør spørsmålet synlig hvis"
// question.requiredIf: "Make the question required if" => "Gjør spørsmålet nødvendig hvis"
// question.state: "Question box collapse state" => "Skjul tilstand for spørsmålsboks"
// question.hideNumber: "Hide the question number" => "Skjul spørsmålsnummeret"
// question.titleLocation: "Question title alignment" => "Justering av spørsmålstittel"
// question.descriptionLocation: "Question description alignment" => "Justering av spørsmålsbeskrivelse"
// question.errorLocation: "Error message alignment" => "Justering av feilmelding"
// question.indent: "Increase the inner indent" => "Øke det indre innrykket"
// question.width: "Inline question width" => "Bredde på innebygde spørsmål"
// question.minWidth: "Minimum question width" => "Minimum spørsmålsbredde"
// question.maxWidth: "Maximum question width" => "Maksimal spørsmålsbredde"
// question.textUpdateMode: "Update input field value" => "Oppdatere verdien for inndatafelt"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Vise Fjern-knappen i signaturområdet"
// signaturepad.penColor: "Stroke color" => "Strekfarge"
// comment.rows: "Input field height (in lines)" => "Høyde på inndatafelt (i linjer)"
// expression.name: "Expression name" => "Navn på uttrykk"
// expression.title: "Expression title" => "Tittel på uttrykk"
// expression.description: "Expression description" => "Beskrivelse av uttrykk"
// expression.expression: "Expression" => "Uttrykk"
// trigger.expression: "Expression" => "Uttrykk"
// calculatedvalue.expression: "Expression" => "Uttrykk"
// survey.description: "Survey description" => "Beskrivelse av undersøkelsen"
// page.name: "Page name" => "Sidenavn"
// page.description: "Page description" => "Beskrivelse av siden"
// page.visibleIf: "Make the page visible if" => "Gjøre siden synlig hvis"
// page.requiredIf: "Make the page required if" => "Gjør siden obligatorisk hvis"
// page.questionsOrder: "Question order on the page" => "Spørsmålsrekkefølge på siden"
// matrixdropdowncolumn.name: "Column name" => "Navn på kolonne"
// matrixdropdowncolumn.title: "Column title" => "Kolonne tittel"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Forhindre dupliserte svar"
// matrixdropdowncolumn.width: "Column width" => "Kolonnebredden"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Minimum kolonnebredde"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Høyde på inndatafelt (i linjer)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Gjøre kolonnen synlig hvis"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Gjør kolonnen obligatorisk hvis"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Hvert alternativ i en egen kolonne"
// multipletextitem.name: "Name" => "Navn"
// multipletextitem.title: "Title" => "Tittel"
// pe.rateDescriptionLocation: "Label alignment" => "Justering av etiketter"
// pe.cellErrorLocation: "Cell error message alignment" => "Justering av cellefeilmelding"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Du har ingen kolonner ennå"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Du har ingen rader ennå"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Du har ingen valideringsregler ennå"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Du har ingen egendefinerte variabler ennå"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Du har ingen utløsere ennå"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Du har ingen koblinger ennå"
// pe.addNew@columns: "Add new column" => "Legg til ny kolonne"
// pe.addNew@rows: "Add new row" => "Legg til ny rad"
// pe.addNew@validators: "Add new rule" => "Legg til ny regel"
// pe.addNew@calculatedValues: "Add new variable" => "Legg til ny variabel"
// pe.addNew@triggers: "Add new trigger" => "Legg til ny utløser"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Legg til ny URL-adresse"
// choicesbyurl.url: "Web service's URL" => "URL-adressen til webtjenesten"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Vise sidetitler på fremdriftslinjen"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Vise sidetall på fremdriftslinjen"
// itemvalue.visibleIf: "Make the option visible if" => "Gjøre alternativet synlig hvis"
// itemvalue.enableIf: "Make the option selectable if" => "Gjør alternativet valgbart hvis"
// panel.layout: "Panel Layout" => "Panel Oppsett"
// tabs.questionSettings: "Question Settings" => "Spørsmål Innstillinger"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Eks.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Eks.: kategorier.fiksjon"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Eks.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Eks.: 6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "Eksempel: 600 piksler"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Eks.: 50%"
// pv.selected: "Selected" => "Utvalgt"
// pv.unselected: "Unselected" => "Umerkede"
// pv.center: "Center" => "Sentrum"
// pv.middle: "Middle" => "Midt"
// pv.next: "Next" => "Neste"
// pv.last: "Last" => "Siste"
// clearIfInvisible.none: "Never" => "Aldri"
// questionsOnPageMode.standard: "Original structure" => "Opprinnelig struktur"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Vis alle spørsmål på én side"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Vis ett spørsmål per side"
// pv.auto: "Auto" => "Auto"
// panelsState.firstExpanded: "First expanded" => "Først utvidet"
// rateColorMode.scale: "Scale" => "Skala"
// scaleColorMode.monochrome: "Monochrome" => "Monokrom"
// scaleColorMode.colored: "Colored" => "Farget"
// state.default: "Locked" => "Låst"
// showQuestionNumbers.default: "Auto-numbering" => "Automatisk nummerering"
// showQuestionNumbers.on: "Auto-numbering" => "Automatisk nummerering"
// showQuestionNumbers.onPage: "Reset on each page" => "Tilbakestill på hver side"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Tilbakestill på hvert panel"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Tilbakestill på hvert panel"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Fortsett på tvers av undersøkelsen"
// showQuestionNumbers.off: "No numbering" => "Ingen nummerering"
// descriptionLocation.underTitle: "Under the question title" => "Under spørsmålstittelen"
// descriptionLocation.underInput: "Under the input field" => "Under inntastingsfeltet"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Ved siden av valg"
// selectToRankAreasLayout.vertical: "Above choices" => "Ovennevnte valg"
// displayStyle.decimal: "Decimal" => "Desimal"
// displayStyle.currency: "Currency" => "Valuta"
// displayStyle.percent: "Percentage" => "Prosent"
// displayStyle.date: "Date" => "Daddel"
// totalDisplayStyle.decimal: "Decimal" => "Desimal"
// totalDisplayStyle.currency: "Currency" => "Valuta"
// totalDisplayStyle.percent: "Percentage" => "Prosent"
// totalDisplayStyle.date: "Date" => "Daddel"
// rowsOrder.initial: "Original" => "Original"
// questionsOrder.initial: "Original" => "Original"
// showProgressBar.aboveheader: "Above the header" => "Over overskriften"
// showProgressBar.belowheader: "Below the header" => "Under overskriften"
// pv.sum: "Sum" => "Sum"
// pv.count: "Count" => "Greve"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Maks"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Inneholder"
// searchMode.startsWith: "Starts with" => "Starter med"
// panel.name: "A panel ID that is not visible to respondents." => "En panel-ID som ikke er synlig for respondentene."
// panel.description: "Type a panel subtitle." => "Skriv inn en panelundertekst."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Bruk tryllestavikonet til å angi en betinget regel som bestemmer panelets synlighet."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Bruk tryllestavikonet til å angi en betinget regel som deaktiverer skrivebeskyttet modus for panelet."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Bruk tryllestavikonet til å angi en betinget regel som forhindrer innsending av spørreundersøkelser med mindre minst ett nestet spørsmål har et svar."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Gjelder alle spørsmålene i dette panelet. Hvis du vil overstyre denne innstillingen, definerer du regler for titteljustering for enkeltspørsmål. Alternativet \"Arv\" bruker innstillingen på sidenivå (hvis angitt) eller undersøkelsesnivå (\"Topp\" som standard)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Angir plasseringen av en feilmelding i forhold til alle spørsmålene i panelet. Alternativet «Arv» bruker innstillingen på sidenivå (hvis angitt) eller undersøkelsesnivå."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Beholder den opprinnelige rekkefølgen på spørsmål eller randomiserer dem. Alternativet «Arv» bruker innstillingen på sidenivå (hvis angitt) eller undersøkelsesnivå."
// panel.page: "Repositions the panel to the end of a selected page." => "Flytter panelet til slutten av en merket side."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Legger til mellomrom eller marg mellom panelinnholdet og venstre kant på panelboksen."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Fjern merket for å vise panelet på én linje med forrige spørsmål eller panel. Innstillingen gjelder ikke hvis panelet er det første elementet i skjemaet."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Velg mellom: \"Utvidet\" - panelet vises i sin helhet og kan skjules; \"Kollapset\" - panelet viser bare tittelen og beskrivelsen og kan utvides; \"Låst\" - panelet vises i sin helhet og kan ikke skjules."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Angir bredden på panelet i forhold til andre undersøkelseselementer på samme linje. Godtar CSS-verdier (px, %, i, pt osv.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "En panel-ID som ikke er synlig for respondentene."
// paneldynamic.description: "Type a panel subtitle." => "Skriv inn en panelundertekst."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Bruk tryllestavikonet til å angi en betinget regel som bestemmer panelets synlighet."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Bruk tryllestavikonet til å angi en betinget regel som deaktiverer skrivebeskyttet modus for panelet."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Bruk tryllestavikonet til å angi en betinget regel som forhindrer innsending av spørreundersøkelser med mindre minst ett nestet spørsmål har et svar."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Gjelder alle spørsmålene i dette panelet. Hvis du vil overstyre denne innstillingen, definerer du regler for titteljustering for enkeltspørsmål. Alternativet \"Arv\" bruker innstillingen på sidenivå (hvis angitt) eller undersøkelsesnivå (\"Topp\" som standard)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Angir plasseringen av en feilmelding i forhold til et spørsmål med ugyldige inndata. Velg mellom: \"Topp\" - en feiltekst plasseres øverst i spørsmålsboksen; \"Bunn\" - en feiltekst er plassert nederst i spørsmålsboksen. Alternativet \"Arv\" bruker innstillingen på sidenivå (hvis angitt) eller undersøkelsesnivå (\"Topp\" som standard)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Angir plasseringen av en feilmelding i forhold til alle spørsmålene i panelet. Alternativet «Arv» bruker innstillingen på sidenivå (hvis angitt) eller undersøkelsesnivå."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Flytter panelet til slutten av en merket side."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Legger til mellomrom eller marg mellom panelinnholdet og venstre kant på panelboksen."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Fjern merket for å vise panelet på én linje med forrige spørsmål eller panel. Innstillingen gjelder ikke hvis panelet er det første elementet i skjemaet."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Velg mellom: \"Utvidet\" - panelet vises i sin helhet og kan skjules; \"Kollapset\" - panelet viser bare tittelen og beskrivelsen og kan utvides; \"Låst\" - panelet vises i sin helhet og kan ikke skjules."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Angir bredden på panelet i forhold til andre undersøkelseselementer på samme linje. Godtar CSS-verdier (px, %, i, pt osv.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Skriv inn en mal for dynamiske paneltitler. Bruk {panelIndex} for panelets generelle posisjon og {visiblePanelIndex} for rekkefølgen blant synlige paneler. Sett inn disse plassholderne i mønsteret for å legge til automatisk nummerering."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Skriv inn en mal for fanetitler. Bruk {panelIndex} for panelets generelle posisjon og {visiblePanelIndex} for rekkefølgen blant synlige paneler. Sett inn disse plassholderne i mønsteret for å legge til automatisk nummerering."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Med denne innstillingen kan du kontrollere synligheten til individuelle paneler i det dynamiske panelet. Bruk plassholderen {panel} til å referere til gjeldende panel i uttrykket."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Denne innstillingen arves automatisk av alle spørsmålene i dette panelet. Hvis du vil overstyre denne innstillingen, definerer du regler for titteljustering for enkeltspørsmål. Alternativet \"Arv\" bruker innstillingen på sidenivå (hvis angitt) eller undersøkelsesnivå (\"Topp\" som standard)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "Alternativet \"Arv\" bruker innstillingen på sidenivå (hvis angitt) eller innstilling på undersøkelsesnivå (\"Under paneltittelen\" som standard)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Definerer posisjonen til et nylig lagt til-panel. Som standard legges nye paneler til slutten. Velg \"Neste\" for å sette inn et nytt panel etter det nåværende."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Dupliserer svar fra det siste panelet og tilordner dem til det neste dynamiske panelet som er lagt til."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Referer til et spørsmålsnavn for å kreve at en bruker gir et unikt svar på dette spørsmålet i hvert panel."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Med denne innstillingen kan du tilordne en standard svarverdi basert på et uttrykk. Uttrykket kan inneholde grunnleggende beregninger - '{q1_id} + {q2_id}', boolske uttrykk, for eksempel '{alder} > 60', og funksjoner: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. Verdien som bestemmes av dette uttrykket, fungerer som den opprinnelige standardverdien som kan overstyres av en respondents manuelle inndata."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Bruk tryllestavikonet til å angi en betinget regel som bestemmer når en respondents inndata tilbakestilles til verdien basert på \"Standardverdiuttrykk\" eller \"Angi verdiuttrykk\" eller til \"Standard svar\"-verdien (hvis en av dem er angitt)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Bruk tryllestavikonet til å angi en betinget regel som bestemmer når \"Angi verdiuttrykk\" skal kjøres, og tilordne den resulterende verdien dynamisk som et svar."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Angi et uttrykk som definerer verdien som skal angis når betingelsene i regelen Angi verdi hvis er oppfylt. Uttrykket kan inneholde grunnleggende beregninger - '{q1_id} + {q2_id}', boolske uttrykk, for eksempel '{alder} > 60', og funksjoner: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. Verdien som bestemmes av dette uttrykket, kan overstyres av en respondents manuelle inndata."
// question.name: "A question ID that is not visible to respondents." => "En spørsmåls-ID som ikke er synlig for respondentene."
// question.description: "Type a question subtitle." => "Skriv inn en spørsmålsundertittel."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Bruk tryllestavikonet til å angi en betinget regel som bestemmer spørsmålets synlighet."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Bruk tryllestavikonet til å angi en betinget regel som deaktiverer skrivebeskyttet modus for spørsmålet."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Bruk tryllestavikonet til å angi en betinget regel som forhindrer avansement eller innsending av spørreundersøkelser med mindre spørsmålet fikk svar."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Fjern merket for å vise spørsmålet på én linje med forrige spørsmål eller panel. Innstillingen gjelder ikke hvis spørsmålet er det første elementet i skjemaet."
// question.page: "Repositions the question to the end of a selected page." => "Flytter spørsmålet til slutten av en merket side."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Velg mellom: \"Utvidet\" - spørsmålsboksen vises i sin helhet og kan skjules; \"Kollapset\" - spørsmålsboksen viser bare tittelen og beskrivelsen og kan utvides; \"Låst\" - spørsmålsboksen vises i sin helhet og kan ikke skjules."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Overstyrer titteljusteringsregler som er definert på panel-, side- eller undersøkelsesnivå. Alternativet \"Arv\" bruker innstillinger på høyere nivå (hvis angitt) eller innstilling på undersøkelsesnivå (\"Topp\" som standard)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå (\"Under spørsmålstittelen\" som standard)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Angir plasseringen til en feilmelding i forhold til spørsmålet med ugyldige inndata. Velg mellom: \"Topp\" - en feiltekst plasseres øverst i spørsmålsboksen; \"Bunn\" - en feiltekst er plassert nederst i spørsmålsboksen. Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå (\"Topp\" som standard)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Legger til mellomrom eller marg mellom spørsmålsinnholdet og venstre kantlinje i spørsmålsboksen."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Angir bredden på spørsmålet i forhold til andre undersøkelseselementer på samme linje. Godtar CSS-verdier (px, %, i, pt osv.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Bruk tryllestavikonet til å angi en valideringsregel for spørsmålet."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Velg mellom: \"Ved tapt fokus\" - verdien oppdateres når inntastingsfeltet mister fokus; \"Mens du skriver\" - verdien oppdateres i sanntid, mens brukerne skriver. Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå (\"Ved tapt fokus\" som standard)."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Du kan bruke en hvilken som helst webtjeneste som datakilde for flervalgsspørsmål. Hvis du vil fylle ut valgverdier, angir du URL-adressen til tjenesten som leverer dataene."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "En sammenligningsoperasjon som brukes til å filtrere rullegardinlisten."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Angir bredden på signaturområdet som vises, og det resulterende bildet."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Angir høyden på signaturområdet som vises, og det resulterende bildet."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Velg dette alternativet hvis du vil at signaturområdet skal fylle all tilgjengelig plass i spørsmålsboksen, samtidig som standardforholdet 3:2 beholdes. Når egendefinerte bredde- og høydeverdier angis, beholdes innstillingen størrelsesforholdet for disse dimensjonene."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Justerer høyden på bildet i undersøkelsesresultatene."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Justerer bredden på bildet i undersøkelsesresultatene."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Overstyrer minimums- og maksimumshøydeverdiene."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Overstyrer verdiene for minimums- og maksimumsbredde."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Verdi\" fungerer som en vare-ID som brukes i betingede regler; \"Tekst\" vises for respondentene."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Denne innstillingen endrer bare størrelsen på inndatafeltet og påvirker ikke bredden på spørsmålsboksen. Hvis du vil begrense den godkjente inndatalengden, går du til <b>Validering → Maksimal tegngrense</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Angir antall viste linjer i inndatafeltet. Hvis inngangen tar opp flere linjer, vises rullefeltet."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Velg mellom: \"Redigerbar\" - gjør det mulig for respondenter å fylle ut undersøkelsen din; \"Skrivebeskyttet\" - deaktiverer skjemaredigering."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "En kolonne-ID som ikke er synlig for respondentene."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Når en respondent er aktivert for en kolonne, må den gi et unikt svar for hvert spørsmål i denne kolonnen."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Angir antall viste linjer i inndatafeltet. Hvis inngangen tar opp flere linjer, vises rullefeltet."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Bruk tryllestavikonet til å angi en betinget regel som bestemmer kolonnens synlighet."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Bruk tryllestavikonet til å angi en betinget regel som deaktiverer skrivebeskyttet modus for kolonnen."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Bruk tryllestavikonet til å angi en betinget regel som forhindrer innsending av spørreundersøkelser med mindre minst ett nestet spørsmål har et svar."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Når dette alternativet er valgt, opprettes det én kolonne for hvert valgalternativ."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Velg mellom: \"Statisk\" - setter en fast bredde; \"Responsive\" - gjør at undersøkelsen opptar hele bredden på skjermen; \"Auto\" - gjelder en av de to avhengig av spørsmålstypene som brukes."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Lim inn en bildekobling (ingen størrelsesbegrensninger) eller klikk på mappeikonet for å bla gjennom en fil fra datamaskinen din (opptil 64KB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Setter en logo bredde i CSS enheter (px, %, i, pt, etc.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Angir en logo høyde i CSS enheter (px, %, i, pt, etc.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Velg mellom: \"Ingen\" - bildet opprettholder sin opprinnelige størrelse; \"Innehold\" - bildet endres for å passe samtidig som størrelsesforholdet opprettholdes; \"Cover\" - bildet fyller hele boksen mens du opprettholder størrelsesforholdet; \"Fyll\" - bildet strekkes for å fylle boksen uten å opprettholde størrelsesforholdet."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Velg om du vil at evalueringen skal gå automatisk til neste side etter at en svarperson har svart på alle spørsmålene på gjeldende side."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Angir synligheten og plasseringen av navigasjonsknapper på en side."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Angir synligheten og plasseringen til en fremdriftsindikator. \"Auto\"-verdien viser fremdriftslinjen over eller under undersøkelseshodet."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Aktiver forhåndsvisningssiden med alle eller besvarte spørsmål."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Gjelder alle spørsmålene i undersøkelsen. Denne innstillingen kan overstyres av titteljusteringsregler på lavere nivåer: panel, side eller spørsmål. En innstilling på lavere nivå vil overstyre de på et høyere nivå."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Et symbol eller en sekvens av symboler som indikerer at et svar er nødvendig."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Skriv inn et tall eller bokstav du vil starte nummereringen med."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Angir plasseringen til en feilmelding i forhold til spørsmålet med ugyldige inndata. Velg mellom: \"Topp\" - en feiltekst plasseres øverst i spørsmålsboksen; \"Bunn\" - en feiltekst er plassert nederst i spørsmålsboksen."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Velg om du vil at det første inntastingsfeltet på hver side skal være klart for tekstinntasting."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Beholder den opprinnelige rekkefølgen på spørsmål eller randomiserer dem. Effekten av denne innstillingen er bare synlig i kategorien Forhåndsvisning."
// pehelp.maxTextLength: "For text entry questions only." => "Kun for spørsmål om tekstoppføring."
// pehelp.maxOthersLength: "For question comments only." => "Kun for spørsmålskommentarer."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Velg om du vil at spørsmålskommentarer og Lang tekst-spørsmål skal vokse automatisk i høyde basert på den angitte tekstlengden."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Kun for spørsmålskommentarer og langtekstspørsmål."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Egendefinerte variabler fungerer som mellomliggende variabler eller hjelpevariabler som brukes i skjemaberegninger. De tar respondentinnganger som kildeverdier. Hver egendefinerte variabel har et unikt navn og et uttrykk den er basert på."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Velg dette hvis du vil at den beregnede verdien for uttrykket skal lagres sammen med evalueringsresultatene."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "En utløser er en hendelse eller betingelse som er basert på et uttrykk. Når uttrykket er evaluert til \"sann\", utløses en utløser en handling. En slik handling kan eventuelt ha et målspørsmål den påvirker."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Velg om du vil fjerne verdier for spørsmål skjult av betinget logikk, og når du vil gjøre det."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Velg mellom: \"Ved tapt fokus\" - verdien oppdateres når inntastingsfeltet mister fokus; \"Mens du skriver\" - verdien oppdateres i sanntid, mens brukerne skriver."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Den venstre verdien fungerer som en kolonne-ID som brukes i betingede regler, den riktige verdien vises for respondentene."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Den venstre verdien fungerer som en rad-ID som brukes i betingede regler, den riktige verdien vises for respondentene."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Godtar CSS-verdier (px, %, i, pt osv.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Godtar CSS-verdier (px, %, i, pt osv.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Angir plasseringen til en feilmelding i forhold til en celle med ugyldige inndata. Alternativet \"Arv\" bruker innstillingen fra egenskapen \"Justering av feilmelding\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Når egenskapen \"Forhindre dupliserte svar\" er aktivert, får en svarperson som prøver å sende inn en duplikatoppføring, følgende feilmelding."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Lar deg beregne totalverdier basert på et uttrykk. Uttrykket kan omfatte grunnleggende beregninger ('{q1_id} + {q2_id}'), boolske uttrykk ('{alder} > 60') og funksjoner ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Utløser en melding som ber om å bekrefte radslettingen."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Dupliserer svar fra den siste raden og tilordner dem til den neste dynamiske raden som er lagt til."
// pehelp.description: "Type a subtitle." => "Skriv inn en undertekst."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Velg et språk for å begynne å opprette evalueringen. Hvis du vil legge til en oversettelse, bytter du til et nytt språk og oversetter originalteksten her eller i Oversettelser-fanen."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Angir plasseringen av en detaljinndeling i forhold til en rad. Velg mellom: \"Ingen\" - ingen utvidelse er lagt til; \"Under raden\" - en radutvidelse er plassert under hver rad av matrisen; \"Under raden, vis bare en radutvidelse\" - en utvidelse vises bare under en enkelt rad, de resterende radutvidelsene er skjult."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Velg mellom: \"Ingen\" - bildet opprettholder sin opprinnelige størrelse; \"Innehold\" - bildet endres for å passe samtidig som størrelsesforholdet opprettholdes; \"Cover\" - bildet fyller hele boksen mens du opprettholder størrelsesforholdet; \"Fyll\" - bildet strekkes for å fylle boksen uten å opprettholde størrelsesforholdet."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Øker gradvis høyden på inndatafeltet etter hvert som data registreres. Overstyrer innstillingen \"Inndatafelthøyde (i linjer)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Skaleringshåndtaket (eller grepet) vises i hjørnet og kan dras for å endre størrelsen på inndatafeltet."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Et tidsintervall i sekunder hvoretter undersøkelsen automatisk går videre til takkesiden."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Et tidsintervall i sekunder hvoretter undersøkelsen automatisk går videre til neste side."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Et tidsintervall i sekunder hvoretter undersøkelsen automatisk går videre til neste side."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Bruk tryllestavikonet til å angi en betinget regel som bestemmer sidens synlighet."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Bruk tryllestavikonet til å angi en betinget regel som deaktiverer skrivebeskyttet modus for siden."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Bruk tryllestavikonet til å angi en betinget regel som forhindrer innsending av spørreundersøkelser med mindre minst ett nestet spørsmål har et svar."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Gjelder alle spørsmål på denne siden. Hvis du vil overstyre denne innstillingen, definerer du regler for titteljustering for enkeltspørsmål eller paneler. Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå (\"Topp\" som standard)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Angir plasseringen til en feilmelding i forhold til spørsmålet med ugyldige inndata. Velg mellom: \"Topp\" - en feiltekst plasseres øverst i spørsmålsboksen; \"Bunn\" - en feiltekst er plassert nederst i spørsmålsboksen. Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå (\"Topp\" som standard)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Beholder den opprinnelige rekkefølgen på spørsmål eller randomiserer dem. Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå (\"Original\" som standard). Effekten av denne innstillingen er bare synlig i kategorien Forhåndsvisning."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Angir synligheten til navigasjonsknapper på siden. Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå, som som standard er \"Synlig\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Stiller inn synligheten og plasseringen til en tidtaker på en side."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Velg mellom: \"Låst\" - brukere kan ikke utvide eller skjule paneler; \"Skjul alle\" - alle paneler starter i kollapset tilstand; \"Utvid alle\" - alle paneler starter i utvidet tilstand; \"Først utvidet\" - bare det første panelet er i utgangspunktet utvidet."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Skriv inn et navn på en delt egenskap i matrisen med objekter som inneholder URL-adressene til bildet eller videofilen du vil vise i valglisten."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Den venstre verdien fungerer som en vare-ID som brukes i betingede regler, den riktige verdien vises for respondentene."
// pehelp.title: "Type a user-friendly title to display." => "Skriv inn en brukervennlig tittel som skal vises."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Sikrer at brukerne ikke fullfører undersøkelsen før filene er lastet opp."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Godtar CSS-verdier (px, %, i, pt osv.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Godtar CSS-verdier (px, %, i, pt osv.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Godtar CSS-verdier (px, %, i, pt osv.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "I enkeltvalgs- og flervalgsspørsmålstyper har hvert valgalternativ en ID og visningsverdi. Når denne innstillingen er valgt, vises en visningsverdi i stedet for en ID-verdi i HTML-spørsmål og dynamiske titler og beskrivelser av evalueringselementer."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Velg om du vil fjerne spørsmålsverdier skjult av betinget logikk, og når du vil gjøre det. Alternativet \"Arv\" bruker innstillingen på undersøkelsesnivå (\"Når undersøkelsen er fullført\" som standard)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Velg mellom: \"Alle\" - kopierer alle valgalternativer fra det valgte spørsmålet; \"Valgt\" - kopierer dynamisk bare valgte valgalternativer; \"Unselected\" - kopierer dynamisk bare uvalgte valgalternativer. Alternativene \"Ingen\" og \"Annet\" kopieres som standard hvis de er aktivert i kildespørsmålet."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Når dette alternativet er valgt, kan brukerne inkludere flere inndata i et eget kommentarfelt."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Viser hvert spesialvalgalternativ (\"Ingen\", \"Annet\", \"Merk alt\") på en ny linje, selv når du bruker et oppsett med flere kolonner."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Angi plasseringen i tjenestedatasettet der målmatrisen med objekter er plassert. La stå tom hvis URL-adressen allerede peker på matrisen."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Skriv inn et ensartet egenskapsnavn i matrisen med objekter som inneholder verdiene du vil vise i valglisten."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Velg dette alternativet hvis du vil at tjenesten skal returnere et tomt svar eller en matrise."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Bruk tryllestavikonet til å angi en betinget regel som bestemmer synligheten til alle valgalternativer."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Den venstre verdien fungerer som en vare-ID som brukes i betingede regler, den riktige verdien vises for respondentene."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" velger mellom \"Knapper\" og \"Dropdown\" -modus basert på tilgjengelig bredde. Når bredden ikke er tilstrekkelig til å vise knapper, viser spørsmålet en rullegardinmeny."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Lar deg koble til spørsmål som gir resultater i forskjellige formater. Når slike spørsmål kobles sammen ved hjelp av en sammenføyningsidentifikator, lagrer denne delte egenskapen valgte spørsmålsverdier."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Velg om du vil oppdatere innholdet på rullegardinmenyen slik at det samsvarer med søket som en bruker skriver inn i inndatafeltet."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "En verdi å spare i undersøkelsesresultater når respondentene gir et positivt svar."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "En verdi å lagre i undersøkelsesresultater når respondentene gir et negativt svar."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Det anbefales ikke å deaktivere dette alternativet, da det overstyrer forhåndsvisningsbildet og gjør det vanskelig for en bruker å forstå om filene er lastet opp."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Utløser en melding som ber om å bekrefte slettingen av filen."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Aktiver for å rangere bare valgte valg. Brukere vil dra valgte elementer fra valglisten for å sortere dem innenfor rangeringsområdet."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Angi en liste over valg som skal foreslås for respondenten under inndata."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Innstillingen endrer bare størrelsen på inndatafeltene og påvirker ikke bredden på spørsmålsboksen."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Angir konsekvent bredde for alle elementetiketter i piksler"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Alternativet \"Auto\" bestemmer automatisk passende modus for visning - Bilde, Video eller YouTube - basert på kildens URL som er oppgitt."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Fungerer som en erstatning når bildet ikke kan vises på en brukers enhet og av tilgjengelighetshensyn."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Definerer fargen på den valgte emojien når Vurdering-ikontypen er satt til \"Smileys\". Velg mellom: \"Standard\" - den valgte emojien vises i standard undersøkelsesfarge; \"Skala\" - den valgte emojien arver farge fra vurderingsskalaen."
// expression.name: "An expression ID that is not visible to respondents." => "En uttrykks-ID som ikke er synlig for respondentene."
// expression.description: "Type an expression subtitle." => "Skriv inn en undertittel for uttrykk."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Et uttrykk kan inneholde grunnleggende beregninger ('{q1_id} + {q2_id}'), betingelser ('{alder} > 60') og funksjoner ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Velg dette alternativet hvis du vil lagre alternativverdien «Annet» som en egen egenskap i undersøkelsesresultatene."
// p.swapOrder: "Swap the order of Yes and No" => "Bytte rekkefølgen på Ja og Nei"
// p.itemTitleWidth: "Item label width (in px)" => "Bredden på vareetiketten (i piksler)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Tekst som skal vises hvis alle alternativene er valgt"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Plassholdertekst for rangeringsområdet"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Fullfør undersøkelsen automatisk"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Velg om du vil at evalueringen skal fullføres automatisk etter at en svarperson har svart på alle spørsmålene."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Lagre maskert verdi i undersøkelsesresultater"
// patternmask.pattern: "Value pattern" => "Verdimønster"
// datetimemask.min: "Minimum value" => "Minimumsverdi"
// datetimemask.max: "Maximum value" => "Maksimumsverdi"
// numericmask.allowNegativeValues: "Allow negative values" => "Tillat negative verdier"
// numericmask.thousandsSeparator: "Thousands separator" => "Tusenskilletegn"
// numericmask.decimalSeparator: "Decimal separator" => "Desimalskilletegn"
// numericmask.precision: "Value precision" => "Prisgunstig presisjon"
// numericmask.min: "Minimum value" => "Minimumsverdi"
// numericmask.max: "Maximum value" => "Maksimumsverdi"
// currencymask.prefix: "Currency prefix" => "Prefiks for valuta"
// currencymask.suffix: "Currency suffix" => "Valutasuffiks"
// pe.maskType: "Input mask type" => "Type inndatamaske"
// maskTypes.patternmask: "Pattern" => "Mønster"
// maskTypes.numericmask: "Numeric" => "Numerisk"
// maskTypes.datetimemask: "Date and Time" => "Dato og klokkeslett"
// maskTypes.currencymask: "Currency" => "Valuta"
// tabs.mask: "Input Mask Settings" => "Innstillinger for inndatamaske"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Eks.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Eks.: mm/dd/åååå"
// pe.currencyprefix_placeholder: "Ex.: $" => "Eks.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Eks.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Valg for innpakning"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Lange tekster i valgalternativer genererer automatisk linjeskift slik at de passer inn i rullegardinmenyen. Fjern merket hvis du vil at tekstene skal klippes ut."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Velg om du vil lagre spørsmålsverdien med en brukt maske i evalueringsresultatene."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Mønsteret kan inneholde strenglitteraler og følgende plassholdere: '9' - for et siffer; 'a' - for en stor eller liten bokstav; '#' - for et siffer eller en stor eller liten bokstav. Bruk omvendt skråstrek '\\' for å unnslippe et tegn."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Mønsteret kan inneholde skilletegn og følgende plassholdere: 'm' - for månedsnummer; 'mm' - for månedsnummer, med ledende null for ensifrede verdier; 'd' - for dagen i måneden; 'dd' - for dagen i måneden, med ledende null for ensifrede verdier; 'yy' - for de to siste sifrene i året; 'åååå' - i et firesifret år."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Et symbol som brukes til å skille brøkdelen fra heltallsdelen av et tall som vises."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Et symbol som brukes til å skille sifrene i et stort tall i grupper på tre."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Begrenser hvor mange sifre som skal beholdes etter desimaltegnet for et tall som vises."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Ett eller flere symboler som skal vises før verdien."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Ett eller flere symboler som skal vises etter verdien."
// ed.translationSource: "Source: " => "Kilde: "
// ed.translationTarget: "Target: " => "Mål: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Siden er tom. Dra et element fra verktøykassen, eller klikk på knappen nedenfor."
// maskTypes.none: "None" => "Ingen"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Gjøre raden synlig hvis"
// itemvalue@rows.enableIf: "Make the row editable if" => "Gjøre raden redigerbar hvis"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Plassholdertekst i skrivebeskyttet modus eller forhåndsvisningsmodus"
// pe.textWrapEnabled: "Wrap choices" => "Valg for innpakning"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Alternativet \"Auto\" bestemmer automatisk passende modus for visning - Bilde, Video eller YouTube - basert på kildens URL som er oppgitt."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Velg mellom \"Image\" og \"Video\" for å stille inn innholdsmodusen til medievelgeren. Hvis \"Bilde\" er valgt, må du kontrollere at alle alternativene som er oppgitt, er bildefiler i følgende formater: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. På samme måte, hvis \"Video\" er valgt, må du sørge for at alle alternativene er direkte koblinger til videofiler i følgende formater: MP4, MOV, WMV, FLV, AVI, MKV. Vær oppmerksom på at YouTube-koblinger ikke støttes for videoalternativer."
// ed.selectFile: "Select a file" => "Velg en fil"
// ed.removeFile: "Remove the file" => "Fjern filen"
// pe.searchMode: "Search Mode" => "Søkemodus"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Klikk på \"Legg til spørsmål\" -knappen nedenfor for å begynne å lage skjemaet ditt."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Klikk på \"Legg til spørsmål\" -knappen nedenfor for å legge til et nytt element på siden."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Klikk på \"Legg til spørsmål\" -knappen nedenfor for å legge til et nytt element i panelet."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Klikk på knappen nedenfor og velg et bilde du vil laste opp"
// coloralpha.opacity: "Opacity" => "Ugjennomsiktighet"
// font.family: "Font family" => "Skriftfamilie"
// font.color: "Color" => "Farge"
// font.placeholderColor: "Placeholder color" => "Plassholderfarge"
// font.size: "Size" => "Størrelse"
// theme.themeName: "Theme" => "Tema"
// theme.isPanelless: "Question appearance" => "Spørsmål utseende"
// theme.editorPanel: "Background and corner radius" => "Bakgrunn og hjørneradius"
// theme.questionPanel: "Background and corner radius" => "Bakgrunn og hjørneradius"
// theme.primaryColor: "Accent color" => "Uthevingsfarge"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Tetthet i panelbakgrunn"
// theme.questionBackgroundTransparency: "Question background opacity" => "Spørsmål om bakgrunnstetthet"
// theme.fontSize: "Font size" => "Skriftstørrelse"
// theme.scale: "Scale" => "Skala"
// theme.cornerRadius: "Corner radius" => "Hjørne radius"
// theme.pageTitle: "Title font" => "Tittel skrift"
// theme.pageDescription: "Description font" => "Beskrivelse font"
// theme.questionTitle: "Title font" => "Tittel skrift"
// theme.questionDescription: "Description font" => "Beskrivelse font"
// theme.editorFont: "Font" => "Font"
// theme.backgroundOpacity: "Opacity" => "Ugjennomsiktighet"
// theme.--sjs-font-family: "Font family" => "Skriftfamilie"
// theme.--sjs-general-backcolor-dim: "Background color" => "Bakgrunnsfarge"
// theme.--sjs-primary-backcolor: "Accent background" => "Bakgrunn med aksent"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Aksent i forgrunnen"
// theme.--sjs-shadow-small: "Shadow effects" => "Skygge effekter"
// theme.--sjs-shadow-inner: "Shadow effects" => "Skygge effekter"
// theme.--sjs-border-default: "Colors" => "Farger"
// header@header.headerView: "View" => "Utsikt"
// header@header.logoPosition: "Logo position" => "Logo posisjon"
// header@header.surveyTitle: "Survey title font" => "Skrift for undersøkelsestittel"
// header@header.surveyDescription: "Survey description font" => "Skrift for undersøkelsesbeskrivelse"
// header@header.headerTitle: "Survey title font" => "Skrift for undersøkelsestittel"
// header@header.headerDescription: "Survey description font" => "Skrift for undersøkelsesbeskrivelse"
// header@header.inheritWidthFrom: "Content area width" => "Bredde på innholdsområdet"
// header@header.textAreaWidth: "Text width" => "Tekstbredde"
// header@header.backgroundColorSwitch: "Background color" => "Bakgrunnsfarge"
// header@header.backgroundImage: "Background image" => "Bakgrunnsbilde"
// header@header.backgroundImageOpacity: "Opacity" => "Ugjennomsiktighet"
// header@header.overlapEnabled: "Overlap" => "Overlappe"
// header@header.logoPositionX: "Logo position" => "Logo posisjon"
// header@header.titlePositionX: "Title position" => "Tittelposisjon"
// header@header.descriptionPositionX: "Description position" => "Beskrivelse posisjon"
// weight.400: "Regular" => "Regelmessig"
// weight.600: "Heavy" => "Tung"
// weight.700: "Semi-bold" => "Halvmodig"
// weight.800: "Bold" => "Fet"
// backgroundImageFit.auto: "Auto" => "Auto"
// backgroundImageFit.cover: "Cover" => "Lokk"
// backgroundImageFit.contain: "Contain" => "Inneholde"
// backgroundImageFit.fill: "Stretch" => "Strekning"
// backgroundImageFit.tile: "Tile" => "Flis"
// backgroundImageAttachment.fixed: "Fixed" => "Fast"
// backgroundImageAttachment.scroll: "Scroll" => "Bla"
// headerView.basic: "Basic" => "Grunnleggende"
// headerView.advanced: "Advanced" => "Avansert"
// inheritWidthFrom.survey: "Same as survey" => "Samme som undersøkelse"
// inheritWidthFrom.container: "Fit to container" => "Tilpass til container"
// backgroundColorSwitch.none: "None" => "Ingen"
// backgroundColorSwitch.accentColor: "Accent color" => "Uthevingsfarge"
// backgroundColorSwitch.custom: "Custom" => "Skikk"
// colorPalette.light: "Light" => "Lys"
// colorPalette.dark: "Dark" => "Mørk"
// isPanelless.false: "Default" => "Standard"
// isPanelless.true: "Without Panels" => "Uten paneler"
// theme.cornerRadius: "Corner radius" => "Hjørne radius"
// theme.fontFamily: "Font family" => "Skriftfamilie"
// theme.fontWeightRegular: "Regular" => "Regelmessig"
// theme.fontWeightHeavy: "Heavy" => "Tung"
// theme.fontWeightSemiBold: "Semi-bold" => "Halvmodig"
// theme.fontWeightBold: "Bold" => "Fet"
// theme.color: "Color" => "Farge"
// theme.placeholderColor: "Placeholder color" => "Plassholderfarge"
// theme.size: "Size" => "Størrelse"
// theme.opacity: "Opacity" => "Ugjennomsiktighet"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Skriv for å søke ..."
// ed.toolboxNoResultsFound: "No results found" => "Fant ingen resultater"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Plassholder for tabulatortittel"
// theme.--sjs-special-red: "Error messages" => "Feilmeldinger"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "En basistekst for tabulatortitler som gjelder når mønsteret for tabulatortittel ikke gir meningsfull verdi."
// theme.fontColor: "Font color" => "Skriftfarge"
// theme.backgroundColor: "Background color" => "Bakgrunnsfarge"
// pe.questionTitleWidth: "Question title width" => "Bredde på spørsmålstittel"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Velg en fil eller lim inn en filkobling ..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Eks.: 200 piksler"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Angir konsekvent bredde for spørsmålstitler når de er justert til venstre for spørsmålsboksene. Godtar CSS-verdier (px, %, i, pt osv.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Angir konsekvent bredde for spørsmålstitler når de er justert til venstre for spørsmålsboksene. Godtar CSS-verdier (px, %, i, pt osv.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Høyde i kommentarområdet (i linjer)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Angir antall viste linjer i tekstområder for spørsmålskommentarer. I inngangen tar opp flere linjer, vises rullefeltet."


/***/ }),

/***/ "./src/localization/persian.ts":
/*!*************************************!*\
  !*** ./src/localization/persian.ts ***!
  \*************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var persianStrings = {
    // survey templates
    survey: {
        edit: "ویرایش",
        externalHelpLink: "نگاه کنید و ساختن نظرسنجی را آموزش ببینید",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "لطفا از جعبه ابزار سوالی در اینجا قرار دهید",
        addLogicItem: "برای شخصی سازی نظرسنجی خود، قانونی را ایجاد کنید",
        copy: "کپی",
        duplicate: "کپی کردن",
        addToToolbox: "افزودن به جعبه ابزار",
        deletePanel: "حذف پنل",
        deleteQuestion: "حذف سوال",
        convertTo: "تبدیل به",
        drag: "المان را بکشید",
    },
    // Creator tabs
    tabs: {
        preview: "آزمایش نظرسنجی",
        theme: "تم",
        translation: "ترجمه",
        designer: "طراح نظرسنجی",
        editor: "ویرایشگر JSON",
        logic: "منطق نظرسنجی"
    },
    // Question types
    qt: {
        default: "پیش فرض",
        checkbox: "چند انتخابی",
        comment: "نظر",
        imagepicker: "انتخاب عکس",
        ranking: "رتبه بندی(رنک)",
        image: "عکس",
        dropdown: "لیست انتخابی",
        tagbox: "چند انتخاب کشویی",
        file: "فایل",
        html: "Html",
        matrix: "ماتریس (تک انتخابی)",
        matrixdropdown: "ماتریس (چند انتخابی)",
        matrixdynamic: "ماتریس (سطرهای داینامیک)",
        multipletext: "متن چند خطی",
        panel: "پنل",
        paneldynamic: "پنل (پنل های داینامیک)",
        radiogroup: "تک انتخابی",
        rating: "رتبه بندی",
        text: "متن تک خطی",
        boolean: "صحیح و غلط",
        expression: "توصیفی",
        signaturepad: "قسمت امضا",
        buttongroup: "گروه دکمه"
    },
    toolboxCategories: {
        general: "عمومی",
        choice: "سوالات انتخاب",
        text: "سوالات ورودی متن",
        containers: "ظروف",
        matrix: "سوالات ماتریکس",
        misc: "متفرقه"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "پیش فرض ({0})",
        survey: "نظرسنجی",
        settings: "تنظیمات نظرسنجی",
        settingsTooltip: "باز کردن تنظیمات نظرسنجی",
        surveySettings: "تنظیمات نظرسنجی",
        surveySettingsTooltip: "تنظیمات نظرسنجی",
        themeSettings: "تنظیمات تم",
        themeSettingsTooltip: "تنظیمات تم",
        showPanel: "نمایش پنل",
        hidePanel: "پنهان سازی پنل",
        prevSelected: "قبلی",
        nextSelected: "بعدی",
        prevFocus: "تمرکز قبلی",
        nextFocus: "تمرکز بعدی",
        surveyTypeName: "نظرسنجی",
        pageTypeName: "صفحه",
        panelTypeName: "پنل",
        questionTypeName: "سوال",
        columnTypeName: "ستون",
        addNewPage: "درج صفحه جدید",
        moveRight: "اسکرول به راست",
        moveLeft: "اسکرول به چپ",
        deletePage: "حذف صفحه",
        editPage: "ویرایش صفحه",
        edit: "ویرایش",
        newPageName: "صفحه",
        newQuestionName: "سوال",
        newPanelName: "پنل",
        newTextItemName: "متن",
        defaultV2Theme: "پیش فرض",
        modernTheme: "مدرن",
        defaultTheme: "پیش فرض (legacy)",
        testSurveyAgain: "آزمایش دوباره نظرسنجی",
        testSurveyWidth: "عرض نظرسنجی: ",
        navigateToMsg: "شما باید به موارد زیر بروید:",
        saveSurvey: "ذخیره نظرسنجی",
        saveSurveyTooltip: "ذخیره نظرسنجی",
        saveTheme: "ذخیرۀ تم",
        saveThemeTooltip: "ذخیرۀ تم",
        jsonHideErrors: "پنهان کردن خطاها",
        jsonShowErrors: "نمایش خطاها",
        undo: "بازگردانی",
        redo: "بازانجام",
        undoTooltip: "بازگرداندن آخرین تغییر",
        redoTooltip: "انجام دادن تغییر",
        showMoreChoices: "نمایش بیشتر",
        showLessChoices: "نمایش کمتر",
        copy: "کپی",
        cut: "برداشتن",
        paste: "چسباندن",
        copyTooltip: "کپی متن انتخاب شده در کلیپ بورد",
        cutTooltip: "متن انتخابی را از کلیپ بورد برش دهید",
        pasteTooltip: "الصاق از کلیپ بورد",
        options: "انتخاب ها",
        generateValidJSON: "تولید کد معتبر JSON",
        generateReadableJSON: "تولید کد خوانا JSON",
        toolbox: "جعبه ابزار",
        "property-grid": "ویژگی ها",
        toolboxFilteredTextPlaceholder: "تایپ برای جستجو...",
        toolboxNoResultsFound: "نتیجه ای یافت نشد",
        propertyGridFilteredTextPlaceholder: "جستجو...",
        propertyGridNoResultsFound: "نتیجه ای یافت نشد",
        correctJSON: "لطفا JSON را تصحیح کنید.",
        surveyResults: "نتایج نظرسنجی: ",
        surveyResultsTable: "به صورت جدول",
        surveyResultsJson: "به صورت JSON",
        resultsTitle: "عنوان سوال",
        resultsName: "نام سوال",
        resultsValue: "محتوای پاسخ",
        resultsDisplayValue: "محتوای نمایشی",
        modified: "تغییر داده شده",
        saving: "در حال ذخیره",
        saved: "ذخیره شد",
        propertyEditorError: "ارور:",
        saveError: "خطا! محتوای ویرایشگر ذخیره نشده است.",
        translationPropertyGridTitle: "تنظیمات زبان",
        themePropertyGridTitle: "تنظیمات تم",
        translationLanguages: "زبان",
        translationDeleteLanguage: "ایا مطمئن هستید که می خواهید تمام رشته ها را برای این زبان حذف کنید؟",
        translationAddLanguage: "زبانی را برای ترجمه انتخاب کنید",
        translationShowAllStrings: "نمایش تمام عبارات",
        translationShowUsedStringsOnly: "فقط از عبارات استفاده کنید",
        translationShowAllPages: "نمایش تمام صفحات",
        translationNoStrings: "هیچ عبارتی برای ترجمه نیست، لطفا فیلتر را عوض کنید.",
        translationExportToSCVButton: "برون بری به CSV",
        translationImportFromSCVButton: "برون ریزی از CSV",
        translateUsigAI: "ترجمه خودکار همه",
        translateUsigAIFrom: "ترجمه از: ",
        translationDialogTitle: "رشتههای ترجمهنشده",
        translationMergeLocaleWithDefault: "ادغام {0} با زبان پیش فرض",
        translationPlaceHolder: "در حال ترجمه...",
        translationSource: "منبع: ",
        translationTarget: "هدف: ",
        themeExportButton: "صادرات",
        themeImportButton: "واردات",
        surveyJsonExportButton: "صادرات",
        surveyJsonImportButton: "واردات",
        surveyJsonCopyButton: "رونوشت در تخته یادداشت",
        themeResetButton: "بازنشانی تنظیمات تم به حالت پیشفرض",
        themeResetConfirmation: "ایا واقعا می خواهید موضوع را دوباره تنظیم کنید؟ تمام سفارشی سازی های شما از دست خواهد رفت.",
        themeResetConfirmationOk: "بله، موضوع را تنظیم مجدد کنید",
        bold: "پررنگ",
        italic: "مورب",
        underline: "پایین خط",
        addNewQuestion: "اضافه کردن سوال",
        selectPage: "انتخاب صفحه ...",
        carryForwardChoicesCopied: "انتخاب ها کپی می شوند از",
        choicesLoadedFromWebText: "انتخاب ها از یک سرویس وب بارگذاری می شوند.",
        choicesLoadedFromWebLinkText: "رفتن به تنظیمات",
        choicesLoadedFromWebPreviewTitle: "پیش نمایش گزینه های انتخاب بار شده",
        htmlPlaceHolder: "محتوای html اینجا خواهد بود",
        panelPlaceHolder: "سوالی را از داخل جعبه ابزار در اینجا قرار دهید",
        surveyPlaceHolder: "نظرسنجی خالی است. یک آیتم را از جعبه ابزار انتخاب یا روی دکمه ی زیر کلیک کنید",
        pagePlaceHolder: "صفحه خالی است. یک عنصر را از جعبه ابزار بکشید یا روی دکمه زیر کلیک کنید.",
        imagePlaceHolder: "یک تصویر را در اینجا بکشید و رها کنید یا روی دکمه زیر کلیک کنید و تصویری را برای اپلود انتخاب کنید",
        surveyPlaceHolderMobile: "روی دکمه \"افزودن سؤال\" در زیر کلیک کنید تا شروع به ایجاد فرم خود کنید.",
        pagePlaceHolderMobile: "روی دکمه \"افزودن سؤال\" در زیر کلیک کنید تا عنصر جدیدی به صفحه اضافه شود.",
        panelPlaceHolderMobile: "روی دکمه \"افزودن سؤال\" در زیر کلیک کنید تا یک عنصر جدید به پانل اضافه شود.",
        imagePlaceHolderMobile: "روی دکمه زیر کلیک کنید و تصویری را برای اپلود انتخاب کنید",
        imageChooseImage: "انتخاب تصویر",
        addNewTypeQuestion: "اضافه {0}",
        chooseLogoPlaceholder: "[لوگو]",
        choices_Item: "مورد ",
        selectFile: "یک پرونده انتخاب کنید",
        removeFile: "حذف پرونده",
        lg: {
            addNewItem: "اضافه کردن آیتم جدید",
            empty_tab: "یک آیتم را برای سفارشی کردن جریان نظرسنجی انتخاب کنید",
            page_visibilityName: "قابلیت رویت صفحه ",
            page_enableName: "فعال/غیرفعال کردن صفحه",
            page_requireName: "ایجاد صفحه مورد نیاز است",
            panel_visibilityName: "قابلیت رویت پنل",
            panel_enableName: "فعال/غیرفعال کردن پنل ",
            panel_requireName: "ایجاد صفحه مورد نیاز است",
            question_visibilityName: " قابلیت رویت سوال",
            question_enableName: "فعال/غیرفعال کردن سوال ",
            question_requireName: "سوال اختیاری موردنیاز",
            question_resetValueName: "بازنشانی مقدار سؤال",
            question_setValueName: "تنظیم مقدار سؤال",
            column_visibilityName: "نمایش/پنهان کردن ستون",
            column_enableName: "فعال/غیرفعال کردن ستون",
            column_requireName: "ستون مورد نیاز است",
            column_resetValueName: "بازنشانی مقدار ستون",
            column_setValueName: "تنظیم مقدار ستون",
            trigger_completeName: "تکمیل نظرسنجی",
            trigger_setvalueName: "تنظیم عنوان سوال",
            trigger_copyvalueName: "کپی مقدار سوال",
            trigger_skipName: "رد کردن سوال ",
            trigger_runExpressionName: "اجرای متن شفارشی مورد نظر",
            completedHtmlOnConditionName: "متن سفارشی صفحه 'تشکر' ",
            page_visibilityDescription: "زمانی که عبارت منطقی مقدار صحیح برمی گرداند صفحه را قابل مشاهده کنید، در غیراینصورت آن را غیرقابل مشاهده نگه دارید.",
            panel_visibilityDescription: "اگر عبارت منطقی مقدار صحیح بر میگرداند، پنل را فعال کنید، در غیر اینصورت آن را غیرقابل مشاهده نگه دارید.",
            panel_enableDescription: "یک پنل ایجاد کنید و همه المان های داخل آن را در صورتی که عبارت منطقی مقدار صحیح بر می گرداند را فعال کنید، در غیر اینصورت آن ها را غیرفعال نگه دارید.",
            question_visibilityDescription: "زمانی که عبارت منطقی مقدار صحیح را برمی گرداند، سوال را قابل مشاهده کنید، در غیر اینصورت آن را غیرمشاهده نگه دارید.",
            question_enableDescription: "زمانی که عبارت منطقی مقدار صحیح برمی گرداند، سوال را فعال کنید، در غیر اینصورت آن را غیرفعال نگه دارید.",
            question_requireDescription: "زمانی که عبارت منطقی مقدار صحیح را بر می گرداند، سوال اجبار ی می شود.",
            trigger_completeDescription: "زمانی که عبارت منطقی مقدار صحیح را بر می گرداند، و بررسی تکمیل می شود،کاربر نهایی صفحه 'تشکر' را مشاهده می کند.",
            trigger_setvalueDescription: "زمانی که مقدار سوالی که در عبارت منطقی استفاده شده است تغییر می یابد و عبارت منطقی مقدار صحیح را بر می گرداند، آنگاه مقدار برای سوال انتخاب شده تنظیم می شود.",
            trigger_copyvalueDescription: "زمانی که مقدارهای سوال که در عبارت منطقی استفاده شده اند، تغییر می یابد و عبارت منطقی مقدار صحیح را بر می گرداند، سپس مقدار یکی از سوال های انتخاب شده در سوال دیگر انتخاب شده کپی می شود.",
            trigger_skipDescription: "زمانی که عبارت منطقی صحیح برمی گرداند، سپس نظرسنجی به سوال انتخابی می رود.",
            trigger_runExpressionDescription: "اگر عبارت منطقی مقدار صحیح برگرداند، آنگاه عبارت سفارشی اجرا می شود. شما ممکن است به طور اختیاری این نتیجه را به سوال انتخاب شده تبدیل کنید.",
            completedHtmlOnConditionDescription: " اگر عبارت منطقی مقدار صحیح برگرداند متن صفحه 'تشکر' به متن داده شده تغییر می یابد.",
            itemExpressionText: "زمانی که عبارت {0} مقدار صحیح بر می گرداند",
            itemEmptyExpressionText: "قانون جدید",
            page_visibilityText: "صفحه {0} را قابل مشاهده کنید.",
            panel_visibilityText: "پنل {0} را قابل مشاهده کنید.",
            panel_enableText: "فعال کردن پنل {0}",
            question_visibilityText: "سوال {0} را قابل مشاهده کنید.",
            question_enableText: "فعال کردن سوال {0}",
            question_requireText: "ایجاد سوال {0} اجباری",
            question_resetValueText: "بازنشانی مقدار برای سوال: {0}",
            question_setValueText: "اختصاص مقدار: {1} به سوال: {0}",
            column_visibilityText: "ستون {0} سوال {1} را قابل مشاهده کنید",
            column_enableText: "ستون {0} سوال {1} را فعال کنید",
            column_requireText: "ستون {0} سوال {1} را الزامی کنید",
            column_resetValueText: "تنظیم مجدد مقدار سلول برای ستون: {0}",
            column_setValueText: "اختصاص مقدار سلول: {1} به ستون: {0}",
            setValueExpressionPlaceholder: " یک عبارت که نتیجه ان به سوال هدف اختصاص داده خواهد شد.",
            trigger_completeText: "بررسی نظرسنجی تمام شد",
            trigger_setvalueText: "در سوال {0} مقدار {1} را قرار دهید",
            trigger_setvalueEmptyText: "ارزش سوال روشن: {0}",
            trigger_copyvalueText: "مقدار سوال {0} را از سوال {1} کپی کنید.",
            trigger_skipText: "رد کردن نظرسنجی برای سوال {0}",
            trigger_runExpressionText1: "اجرای عبارت '{0}' ",
            trigger_runExpressionText2: "و نتیجه آن را داخل سوال {0} ذخیره کنید",
            completedHtmlOnConditionText: "نمایش متن سفارشی برای صفحه 'تشکر'",
            showAllQuestions: "تمام سوالات",
            showAllActionTypes: "همه انواع اقدام",
            conditions: "شرط(ها)",
            actions: "عملکرد(ها)",
            expressionEditorTitle: "عبارت منطقی را تنظیم کنید",
            actionsEditorTitle: "تعریف کردن عملکرد(ها)",
            deleteAction: "حذف عملکرد",
            addNewAction: "اضافه کردن سوال (های) جدید",
            selectedActionCaption: "یک عملکرد را برای اضافه کردن، انتخاب کنید",
            expressionInvalid: "عبارت منطقی خالی یا نادرست است. لطفا آن را تضحیح کنید",
            noActionError: "لطفا حداقل یک عملکرد را اضافه نمایید",
            actionInvalid: "لطفا مشکلات مربوط به عملکرد(های) خود را برطرف نمایید.",
            uncompletedRule_title: "قوانین منطقی ناقص هستند",
            uncompletedRule_text: "شما برخی از قوانین منطقی را تکمیل نکرده اید. اگر اکنون برگه را ترک کنید، تغییرات از بین خواهند رفت. ایا هنوز هم می خواهید برگه را بدون تکمیل تغییرات ترک کنید؟",
            uncompletedRule_apply: "بله",
            uncompletedRule_cancel: "نه، من می خواهم قوانین را تکمیل کنم"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "نام تابلو",
            title: "عنوان پنل",
            description: "توضیحات پنل",
            visibleIf: "تابلو را مرئی کنید اگر",
            requiredIf: "ایجاد پنل مورد نیاز اگر",
            questionsOrder: "سفارش سوال در داخل پنل",
            page: "صفحه اصلی",
            startWithNewLine: "نمایش تابلو در یک خط جدید",
            state: "دولت فروپاشی پانل",
            width: "عرض پانل درون خطی",
            minWidth: "حداقل عرض پانل",
            maxWidth: "حداکثر عرض پانل",
            showNumber: "پانل های شماره"
        },
        paneldynamic: {
            name: "نام تابلو",
            title: "عنوان پنل",
            description: "توضیحات پنل",
            visibleIf: "تابلو را مرئی کنید اگر",
            requiredIf: "ایجاد پنل مورد نیاز اگر",
            page: "جابهجایی تابلو به صفحه",
            startWithNewLine: "نمایش تابلو در یک خط جدید",
            state: "دولت فروپاشی پانل",
            width: "عرض پانل درون خطی",
            minWidth: "حداقل عرض پانل",
            maxWidth: "حداکثر عرض پانل",
            confirmDelete: "تایید حذف پانل",
            templateDescription: "الگوی توصیف پنل",
            templateTitle: "الگوی عنوان پنل",
            noEntriesText: "متن تابلوی خالی",
            templateTabTitle: "الگوی عنوان زبانه",
            tabTitlePlaceholder: "ذی نفع عنوان تب",
            templateVisibleIf: "ایجاد یک پنل منفرد مرئی اگر",
            hideNumber: "مخفی کردن شمارهی تابلو",
            titleLocation: "ترازبندی عنوان پنل",
            descriptionLocation: "ترازبندی توضیحات پنل",
            templateTitleLocation: "هم ترازی عنوان پرسش",
            templateErrorLocation: "همترازسازی پیام خطا",
            newPanelPosition: "محل جدید پنل",
            keyName: "جلوگیری از پاسخ های تکراری در سوال زیر"
        },
        question: {
            name: "نام سوال",
            title: "عنوان سوال",
            description: "توضیحات سوال",
            visibleIf: "سؤال را قابل مشاهده کنید اگر",
            requiredIf: "سؤال مورد نیاز را مطرح کنید اگر",
            page: "صفحه اصلی",
            state: "جعبه سوال دولت فروپاشی",
            hideNumber: "مخفی کردن شماره سوال",
            titleLocation: "هم ترازی عنوان پرسش",
            descriptionLocation: "هم ترازی توضیحات سؤال",
            errorLocation: "همترازسازی پیام خطا",
            indent: "افزایش تورفتگی داخلی",
            width: "عرض پرسش درون خطی",
            minWidth: "حداقل عرض سوال",
            maxWidth: "حداکثر عرض سؤال",
            textUpdateMode: "بهروزرسانی مقدار فیلد ورودی"
        },
        signaturepad: {
            signatureWidth: "عرض منطقه امضا",
            signatureHeight: "ارتفاع منطقه امضا",
            signatureAutoScaleEnabled: "مقیاس خودکار منطقه امضا",
            showPlaceholder: "نشان دادن نگهدارندهی مکان",
            placeholder: "متن ذی نفع",
            placeholderReadOnly: "متن نگهدارنده در حالت فقط خواندنی یا پیشنمایش",
            allowClear: "نمایش دکمه پاک کردن در منطقه امضا",
            penMinWidth: "حداقل عرض قلم",
            penMaxWidth: "حداکثر عرض قلم",
            penColor: "رنگ سکته مغزی"
        },
        comment: {
            rows: "ارتفاع میدان ورودی (در خطوط)"
        },
        showQuestionNumbers: "نمایش شماره های سوالات",
        questionStartIndex: "نمایه شروع سوالات (۱،۲ یا a و b)",
        expression: {
            name: "نام عبارت",
            title: "عنوان عبارت",
            description: "توصیف عبارت",
            expression: "بیان"
        },
        trigger: {
            expression: "بیان"
        },
        calculatedvalue: {
            expression: "بیان"
        },
        // survey templates
        survey: {
            title: "عنوان",
            description: "توضیحات نظرسنجی"
        },
        page: {
            name: "نام صفحه",
            title: "عنوان",
            description: "توضیحات صفحه",
            visibleIf: "صفحه را مرئی کنید اگر",
            requiredIf: "ایجاد صفحه مورد نیاز اگر",
            maxTimeToFinish: "محدودیت زمانی برای تمام کردن صفحه (به ثانیه)",
            questionsOrder: "سفارش سوال در صفحه"
        },
        matrixdropdowncolumn: {
            name: "نام ستون",
            title: "عنوان ستون",
            isUnique: "جلوگیری از پاسخ های تکراری",
            width: "عرض ستون",
            minWidth: "حداقل عرض ستون",
            rows: "ارتفاع میدان ورودی (در خطوط)",
            visibleIf: "ستون را مرئی کنید اگر",
            requiredIf: "ایجاد ستون مورد نیاز اگر",
            showInMultipleColumns: "هر گزینه در یک ستون جداگانه"
        },
        multipletextitem: {
            name: "نام",
            title: "عنوان"
        },
        masksettings: {
            saveMaskedValue: "ذخیره مقدار ماسک در نتایج نظرسنجی"
        },
        patternmask: {
            pattern: "الگوی ارزش"
        },
        datetimemask: {
            min: "حداقل مقدار",
            max: "بیشینه مقدار"
        },
        numericmask: {
            allowNegativeValues: "اجازه دادن مقادیر منفی",
            thousandsSeparator: "هزار جداکننده",
            decimalSeparator: "جداساز دهدهی",
            precision: "دقت ارزش",
            min: "حداقل مقدار",
            max: "بیشینه مقدار"
        },
        currencymask: {
            prefix: "پیشوند ارز",
            suffix: "پسوند ارز"
        },
        imageHeight: "ارتفاع تصویر",
        imageWidth: "عرض تصویر",
        valueName: "نام مقدار",
        rateDescriptionLocation: "تراز برچسب",
        size: "اندازه فیلد ورودی (در نویسه ها)",
        cellErrorLocation: "همراستاسازی پیام خطای سلولی",
        apply: "اعمال",
        ok: "تایید",
        save: "ذخیره",
        clear: "روشن",
        saveTooltip: "ذخیره",
        cancel: "لغو",
        set: "مجموعه",
        reset: "بازنشانی",
        change: "تغییر",
        refresh: "تازه سازی",
        close: "بستن",
        delete: "حذف",
        add: "اضافه کردن",
        addNew: "افزودن",
        addItem: "برای اضافه کردن یک آیتم کلیک کنید...",
        removeItem: "فشار دهید تا مورد حذف شود...",
        dragItem: "مورد را بکشید",
        addOther: "سایر",
        addSelectAll: "انتخاب همه",
        addNone: "هیچکدام",
        removeAll: "حذف همه",
        edit: "ویرایش",
        back: "بازگشت بدون ذخیره",
        backTooltip: "بازگشت بدون ذخیره",
        saveAndBack: "ذخیره و بازگشت",
        saveAndBackTooltip: "ذخیره و بازگشت",
        doneEditing: "انجام",
        editChoices: "ویرایش انتخاب ها",
        showChoices: "نمایش انتخاب ها",
        move: "جابجایی",
        empty: "<خالی>",
        emptyValue: "مقدار خالی است",
        fastEntry: "تکمیل سریع",
        fastEntryNonUniqueError: "مقدار {0}» منحصر به فرد نیست",
        fastEntryChoicesCountError: "لطفا تعداد موارد را از {0} به {1} محدود کنید",
        fastEntryChoicesMinCountError: "لطفا حداقل {0} مورد را وارد کنید",
        fastEntryPlaceholder: "شما می توانید داده ها را در قالب زیر تنظیم کنید:\nvalue1|متن\nارزش 2",
        formEntry: "تکمیل فرم",
        testService: "بررسی سرویس",
        itemSelectorEmpty: "لطفا یک المان را انتخاب کنید ",
        conditionActionEmpty: "لطفا عملکرد را انتخاب کنید",
        conditionSelectQuestion: "انتخاب سوال...",
        conditionSelectPage: "انتخاب صفحه...",
        conditionSelectPanel: "انتخاب پنل...",
        conditionValueQuestionTitle: "لطفا مقدار را انتخاب / وارد کنید",
        aceEditorHelp: "برای مشاهده نکات تکمیلی ctrl+space را بفشارید",
        aceEditorRowTitle: "سطر فعلی",
        aceEditorPanelTitle: "پنل فعلی",
        showMore: "برای اطلاعات بیشتر لطفا سند راهنما را مطالعه کنید",
        assistantTitle: "سوالات موجود:",
        cellsEmptyRowsColumns: "حداقل باید یک سطر یا ستون وجود داشته باشد.",
        showPreviewBeforeComplete: "پیش نمایش پاسخ قبل از ارسال نظرسنجی",
        overridingPropertyPrefix: "تنظیم بر اساس ",
        resetToDefaultCaption: "تنظیم مجدد",
        propertyIsEmpty: "لطفا یک مقدار وارد کنید",
        propertyIsNoUnique: "لطفاً یک مقدار منحصر به فرد وارد کنید",
        propertyNameIsNotUnique: "لطفاً یک نام منحصر به فرد وارد کنید",
        propertyNameIsIncorrect: "از کلمات رزرو شده استفاده نکنید: \"item\"، \"choice\"، \"panel\"، \"row\".",
        listIsEmpty: "یک آیتم جدید اضافه کنید",
        "listIsEmpty@choices": "هنوز هیچ انتخابی اضافه نشده است",
        "listIsEmpty@columns": "شما هنوز هیچ ستونی ندارید",
        "listIsEmpty@rows": "شما هنوز هیچ ردیفی ندارید",
        "listIsEmpty@validators": "شما هنوز هیچ قانون اعتبار سنجی ندارید",
        "listIsEmpty@calculatedValues": "شما هنوز هیچ متغیر سفارشی ندارید",
        "listIsEmpty@triggers": "شما هنوز هیچ محرکی ندارید",
        "listIsEmpty@navigateToUrlOnCondition": "شما هنوز هیچ لینکی ندارید",
        "addNew@choices": "اضافه کردن یک انتخاب",
        "addNew@columns": "افزودن ستون جدید",
        "addNew@rows": "افزودن سطر جدید",
        "addNew@validators": "افزودن قانون جدید",
        "addNew@calculatedValues": "افزودن متغیر جدید",
        "addNew@triggers": "افزودن ماشه جدید",
        "addNew@navigateToUrlOnCondition": "افزودن نشانی وب جدید",
        expressionIsEmpty: "عبارت خالی است",
        value: "مقدار",
        text: "متن",
        rowid: "شناسه ی سطر",
        imageLink: "لینک تصویر",
        columnEdit: "ویرایش ستون: {0}",
        itemEdit: "ویرایش آیتم: {0}",
        url: "آدرس وب سایت(url)",
        path: "آدرس",
        choicesbyurl: {
            url: "نشانی وب سرویس",
            valueName: "دریافت مقادیر از فیلد JSON زیر"
        },
        titleName: "نام عنوان",
        imageLinkName: "URL های تصویر را از فیلد JSON زیر دریافت کنید",
        allowEmptyResponse: "اجازه دادن پاسخ خالی",
        titlePlaceholder: "عنوان را اینجا وارد کنید",
        surveyTitlePlaceholder: "عنوان نظرسنجی را اینجا وارد کنید",
        pageTitlePlaceholder: "عنوان صفحه را اینجا وارد کنید",
        descriptionPlaceholder: "توضیحات را وارد کنید",
        surveyDescriptionPlaceholder: "توضیحات نظرسنجی را وارد کنید",
        pageDescriptionPlaceholder: "توضیحات صفحه را وارد کنید",
        textWrapEnabled: "انتخاب های بسته بندی",
        showOtherItem: "دارای آیتم دیگر",
        otherText: "سایر آیتم های متن",
        showNoneItem: "هیچ آیتمی ندارد",
        showRefuseItem: "اجازه دهید گزینه امتناع از پاسخ",
        showDontKnowItem: "گزینه Don't Know را انتخاب کنید",
        noneText: "هیچ آیتم متنی وجود ندارد",
        showSelectAllItem: "همه موارد انتخاب شده است",
        selectAllText: "انتخاب همه آیتم های متن",
        choicesMin: "حداقل مقدار برای ایجاد خودکار آیتم ها",
        choicesMax: "حداکثر مقدار برای ایجاد خود آیتم ها",
        choicesStep: "تفاوت بین موارد تولید شده خودکار",
        name: "نام",
        title: "عنوان",
        cellType: "نوع سلول",
        colCount: "تعداد ستون",
        choicesOrder: "ترتیب گزینه را انتخاب کنید",
        visible: "نمایش داده شود؟",
        isRequired: "ضروری است؟",
        markRequired: "علامت گذاری به عنوان مورد نیاز",
        removeRequiredMark: "حذف علامت مورد نیاز",
        isAllRowRequired: "نیاز به پاسخ برای همه سطرها",
        eachRowUnique: "جلوگیری از پاسخ های تکراری در ردیف ها",
        requiredErrorText: "متن خطای موردنیاز",
        startWithNewLine: "با سطر جدید شروع شود؟",
        rows: "تعداد سطر",
        cols: "تعداد ستون",
        placeholder: "نگهدارنده متن",
        showPreview: "پیش نمایش تصویر نشان داده شود؟",
        storeDataAsText: "ذخیره کردن محتوای فایل در JSON به عنوان متن",
        maxSize: "حداکثر سایز به بایت",
        rowCount: "تعداد سطر",
        columnLayout: "قالب ستون ها",
        addRowLocation: "اضافه کردن موقعیت دکمه سطری",
        transposeData: "جابهجا کردن سطرها به ستونها",
        addRowText: "متن دکمه درج سطر",
        removeRowText: "متن دکمه حذف سطر",
        rateMin: "حداقل میزان",
        rateMax: "حداکثر میزان",
        rateStep: "میزان مراحل",
        minRateDescription: "توضیح حداقل امتیاز",
        maxRateDescription: "توضیح حداکثر امتیاز",
        inputType: "نوع ورودی",
        optionsCaption: "نوشته انتخاب ها",
        defaultValue: "مقدار پیش فرض",
        cellsDefaultRow: "متن پیش فرض سلول ها",
        surveyEditorTitle: "ویرایش نظرسنجی",
        qEditorTitle: "ویرایش سوال: {0}",
        maxLength: "ماکزیمم طول",
        buildExpression: "ساختن",
        editExpression: "ویرایش",
        and: "و",
        or: "یا",
        remove: "حذف",
        addCondition: "اضافه کردن شرط",
        emptyLogicPopupMessage: "یک سؤال برای شروع پیکربندی شرایط انتخاب کنید.",
        if: "اگر",
        then: "سپس",
        setToName: "سوال هدف",
        fromName: "سوال برای کپی کردن پاسخ از",
        gotoName: "سؤال برای پرش به",
        ruleIsNotSet: "قانون نادرست است",
        includeIntoResult: "شامل نتایج نظرسنجی",
        showTitle: "نمایش/پنهان کردن عنوان",
        expandCollapseTitle: "نمایش/پنهان کردن عنوان",
        locale: "زبان پیش فرض",
        simulator: "انتخاب دستگاه",
        landscapeOrientation: "افقی",
        portraitOrientation: "تغییر جهت به جهت تصویر",
        mode: "حالت (ویرایش/خواندن)",
        clearInvisibleValues: "پاکسازی مقادیر پنهان",
        cookieName: "نام کوکی (به منظور جلوگیری از اجرای دوباره نظرسنجی)",
        sendResultOnPageNext: "ارسال نتایج نظرسنجی در صفحه بعدی",
        storeOthersAsComment: "ذخیره مقدار 'سایر' در فیلد جداگانه",
        showPageTitles: "نمایش عنوان صفحات",
        showPageNumbers: "نمایش شماره صفحات",
        pagePrevText: "متن دکمه صفحه قبلی",
        pageNextText: "متن دکمه صفحه بعدی",
        completeText: "متن دکمه تکمیل نظرسنجی",
        previewText: "پیش نمایش متن دکمه",
        editText: "ویرایش متن دکمه",
        startSurveyText: "متن دکمه شروع نظرسنجی",
        showNavigationButtons: "نمایش دکمه های ناوبری (ناوبری پیش فرض)",
        showPrevButton: "نمایش دکمه قبلی (کاربر ممکن است به صفحه قبل برگردد)",
        firstPageIsStarted: "صفحه اول در نظرسنجی نقطه آغازین آن است.",
        showCompletedPage: "نمایش صفحه اتمام نظرسنجی در پایان (completedHtml)",
        goNextPageAutomatic: "با پاسخگویی به تمام سوالات، به صورت اتوماتیک به صفحه بعد برود",
        allowCompleteSurveyAutomatic: "بررسی را به طور خودکار تکمیل کنید",
        showProgressBar: "نمایش نشانگر پیشرفت",
        questionTitleLocation: "محل عنوان سوال",
        questionTitleWidth: "عرض عنوان سوال",
        requiredText: "سوالات نشان دار اجباری هستند",
        questionTitleTemplate: "قالب عنوان سوال، به صورت پیش فرض: '{no}. {require} {title}'",
        questionErrorLocation: "محل خطای سوال",
        focusFirstQuestionAutomatic: "تمرکز بر روی اولین سوال با تغییر صفحه",
        questionsOrder: "ترتیب المان ها در صفحه",
        maxTimeToFinish: "نهایت زمان برای اتمام نظرسنجی",
        maxTimeToFinishPage: "نهایت زمان برای اتمام این صفحه نظرسنجی",
        showTimerPanel: "نمایش پنل زمان سنج",
        showTimerPanelMode: "نمایش حالت پنل زمان سنج",
        renderMode: "حالت رندر",
        allowAddPanel: "اجازه افزودن پنل",
        allowRemovePanel: "اجازه حذف پنل",
        panelAddText: "متن افزودن پنل",
        panelRemoveText: "متن حذف پنل",
        isSinglePage: "نمایش تمام المان ها در یک صفحه",
        html: "Html",
        setValue: "پاسخ",
        dataFormat: "قالب تصویر",
        allowAddRows: "اجازه اضافه کردن سطرها",
        allowRemoveRows: "اجازه حذف سطرها",
        allowRowsDragAndDrop: "اجازه دادن به کشیدن و رها کردن ردیف",
        responsiveImageSizeHelp: "اگر عرض یا ارتفاع تصویر دقیق را مشخص کنید اعمال نمی شود.",
        minImageWidth: "حداقل عرض تصویر",
        maxImageWidth: "حداکثر عرض تصویر",
        minImageHeight: "حداقل ارتفاع تصویر",
        maxImageHeight: "حداکثر ارتفاع تصویر",
        minValue: "حداقل مقدار",
        maxValue: "حداکثر مقدار",
        minLength: "حداقل طول",
        allowDigits: "امکان ورود اعداد",
        minCount: "حداقل تعداد ",
        maxCount: "حداکثر مقدار",
        regex: "فرمت صحیح عبارت ",
        surveyvalidator: {
            text: "پیام خطا",
            expression: "عبارت اعتبارسنجی"
        },
        totalText: "متن کامل",
        totalType: "نوع کامل",
        totalExpression: "عبارت کامل",
        totalDisplayStyle: "سبک نمایش کل",
        totalCurrency: "مجموع ارز",
        totalFormat: "مجموع فرمت",
        logo: "لوگو (URL یا رشته کدگذاری شده base64)",
        questionsOnPageMode: "ساختار نظرسنجی",
        maxTextLength: "حداکثر طول پاسخ (در کاراکترها)",
        maxOthersLength: "حداکثر طول توضیحات (در نویسهها)",
        commentAreaRows: "ارتفاع منطقه نظر (در خطوط)",
        autoGrowComment: "گسترش خودکار منطقه نظر در صورت لزوم",
        allowResizeComment: "اجازه دادن به کاربران برای تغییر اندازه مناطق متن",
        textUpdateMode: "بههنگامسازی مقدار سؤال متن",
        maskType: "نوع ماسک ورودی",
        maskTypes: {
            none: "هیچ کدام",
            patternmask: "الگوی",
            numericmask: "عددی",
            datetimemask: "تاریخ و زمان",
            currencymask: "ارز"
        },
        focusOnFirstError: "تنظیم تمرکز روی اولین پاسخ نامعتبر",
        checkErrorsMode: "اجرای اعتبارسنجی",
        navigateToUrl: "حرکت به نشانی وب",
        navigateToUrlOnCondition: "نشانی وب پویا",
        completedBeforeHtml: "نشانهگذاری برای نشان دادن اینکه ایا کاربر قبلا این بررسی را پر کرده است",
        completedHtml: "بررسی نشانه گذاری صفحه کامل",
        completedHtmlOnCondition: "بررسی دینامیکی نشانه گذاری صفحه کامل",
        loadingHtml: "نشانه گذاری برای نشان دادن در حالی که مدل بررسی در حال بارگذاری است",
        commentText: "متن ناحیه نظر",
        autocomplete: "نوع تکمیل خودکار",
        labelTrue: "برچسب \"True\"",
        labelFalse: "برچسب \"غلط\"",
        allowClear: "نشان دادن دکمهی Clear",
        searchMode: "حالت جستجو",
        displayStyle: "سبک نمایش ارزش",
        format: "رشتۀ قالببندی شده",
        maximumFractionDigits: "بیشینه رقم کسری",
        minimumFractionDigits: "حداقل رقم کسری",
        useGrouping: "نمایش جداسازهای گروهبندی",
        allowMultiple: "اجازه دادن به چندین پرونده",
        allowImagesPreview: "پیشنمایش تصاویر",
        acceptedTypes: "انواع فایل های پذیرفته شده",
        waitForUpload: "منتظر بمانید تا بارگذاری کامل شود",
        needConfirmRemoveFile: "تایید حذف پرونده",
        detailPanelMode: "جزئیات محل پانل",
        minRowCount: "حداقل تعداد سطرها",
        maxRowCount: "حداکثر تعداد سطرها",
        confirmDelete: "تایید حذف سطر",
        confirmDeleteText: "پیام تایید",
        panelCount: "شمارش اولیه پانل",
        minPanelCount: "حداقل تعداد پانل",
        maxPanelCount: "حداکثر تعداد پانل",
        panelsState: "پانل داخلی گسترش دولت",
        panelPrevText: "قبلی دکمه پنل tooltip",
        panelNextText: "بعدی دکمه پنل tooltip",
        showRangeInProgress: "نمایش نوار پیشرفت",
        panelRemoveButtonLocation: "حذف محل دکمه پنل",
        hideIfRowsEmpty: "مخفی کردن سؤال اگر سطری وجود نداشته باشد",
        hideColumnsIfEmpty: "مخفی کردن ستونها اگر سطری وجود نداشته باشد",
        rateValues: "مقادیر نرخ سفارشی",
        rateCount: "شمارش نرخ",
        autoGenerate: "چگونه مقادیر نرخ را مشخص کنیم؟",
        hideIfChoicesEmpty: "مخفی کردن سؤال در صورتی که هیچ انتخابی نداشته باشد",
        minWidth: "حداقل عرض (در مقادیر پذیرفته شده CSS)",
        maxWidth: "حداکثر عرض (در مقادیر پذیرفته شده CSS)",
        width: "عرض (در مقادیر پذیرفته شده CSS)",
        showHeader: "نمایش سرایندهای ستون",
        horizontalScroll: "نمایش میله لغزش افقی",
        columnMinWidth: "اس",
        rowTitleWidth: "عرض سرصفحه سطر) در مقادیر پذیرفته شده CSS (",
        valueTrue: "مقدار » درست",
        valueFalse: "مقدار » نادرست",
        minErrorText: "پیام خطای \"مقدار کمتر از حداقل است\"",
        maxErrorText: "\"مقدار بیش از حداکثر\" پیام خطا",
        otherErrorText: "پیام خطای \"نظر خالی\"",
        keyDuplicationError: "پیام خطای \"مقدار کلید غیر منحصر به فرد\"",
        minSelectedChoices: "حداقل انتخاب های انتخاب شده",
        maxSelectedChoices: "حداکثر انتخابهای انتخاب شده",
        showClearButton: "نشان دادن دکمهی Clear",
        logoWidth: "عرض لوگو (در مقادیر پذیرفته شده CSS)",
        logoHeight: "ارتفاع لوگو (در مقادیر پذیرفته شده CSS)",
        readOnly: "فقط خواندنی",
        enableIf: "قابل ویرایش اگر",
        emptyRowsText: "پیام \"بدون ردیف\"",
        separateSpecialChoices: "انتخاب های ویژه جداگانه (هیچ کدام، دیگر، همه را انتخاب کنید)",
        choicesFromQuestion: "کپی کردن انتخابها از سؤال زیر",
        choicesFromQuestionMode: "کدام گزینه ها را کپی کنید؟",
        progressBarShowPageTitles: "نمایش عناوین صفحه در نوار پیشرفت",
        progressBarShowPageNumbers: "نمایش شمارههای صفحه در نوار پیشرفت",
        showCommentArea: "نمایش ناحیهی نظرات",
        commentPlaceholder: "ذی نفع منطقه نظر",
        displayRateDescriptionsAsExtremeItems: "نمایش توضیحات نرخ به عنوان مقادیر شدید",
        rowsOrder: "سفارش ردیف",
        columnsLayout: "طرحبندی ستون",
        columnColCount: "تعداد ستون های تو در تو",
        correctAnswer: "پاسخ صحیح",
        defaultPanelValue: "مقادیر پیشفرض",
        cells: "متن سلولی",
        fileInputPlaceholder: "یک پرونده را انتخاب کنید یا پیوند پرونده را جایگذاری کنید...",
        keyName: "ستون کلید",
        itemvalue: {
            visibleIf: "این گزینه قابل مشاهده است اگر",
            enableIf: "گزینه را انتخاب کنید اگر"
        },
        "itemvalue@rows": {
            visibleIf: "سطر را مرئی کنید اگر",
            enableIf: "ردیف را قابل ویرایش کنید اگر"
        },
        imageitemvalue: {
            text: "متن دگرساز"
        },
        logoPosition: "محل قرارگیری لوگو",
        addLogo: "اضافه کردن لوگو...",
        changeLogo: "تغییر لوگو...",
        logoPositions: {
            none: "حذف لوگو",
            left: "چپ",
            right: "راست",
            top: "بخش بالا",
            bottom: "بخش پایین"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "چیدمان پنل"
            },
            general: "عمومی",
            fileOptions: "انتخاب ها",
            html: "ویرایشگر HTML",
            columns: "ستون ها",
            rows: "سطرها",
            choices: "انتخاب ها",
            items: "آیتم ها",
            visibleIf: "نمایش در صورت",
            enableIf: "فعال اگر",
            requiredIf: "مورد نیاز ااگر",
            rateValues: "مقادیر رتبه بندی",
            choicesByUrl: "انتخاب ها از وب",
            matrixChoices: "انتخاب های پیشفرض",
            multipleTextItems: "فیلدهای متنی",
            numbering: "شماره گذاری",
            validators: "اعتبارسنجی ها",
            navigation: "ناوبری",
            question: "سوال",
            pages: "صفحات",
            timer: "زمان سنج/کوئیز",
            calculatedValues: "مقادیر محاسبه شد",
            triggers: "اجرا کننده",
            templateTitle: "عنوان قالب",
            totals: "جمع کل",
            logic: "منطق",
            mask: "تنظیمات ماسک ورودی",
            layout: {
                panel: "طرح",
                question: "طرح",
                base: "طرح"
            },
            data: "اطلاعات",
            validation: "اعتبارسنجی",
            cells: "سلول ها",
            showOnCompleted: "نمایش بدهید تکمیل شده",
            logo: "لوگو در عنوان نظرسنجی",
            slider: "اسلایدر",
            expression: "بیان",
            questionSettings: "تنظیمات پرسش",
            header: "هدر",
            background: "پس زمینه",
            appearance: "ظاهر",
            others: "باقی موارد"
        },
        editProperty: "ویرایش خصوصیت '{0}'",
        items: "[ آیتم ها: {0} ]",
        choicesVisibleIf: "انتخاب ها قابل مشاهده هستند اگر",
        choicesEnableIf: "انتخاب ها قابل انتخاب هستند اگر",
        columnsEnableIf: "ستونها مرئی هستند اگر",
        rowsEnableIf: "سطرها مرئی هستند اگر",
        innerIndent: "اضافه کردن تورفتات داخلی",
        defaultValueFromLastRow: "گرفتن مقادیر پیشفرض از اخرین سطر",
        defaultValueFromLastPanel: "گرفتن مقادیر پیشفرض از اخرین تابلو",
        enterNewValue: "لطفا یک مقدار وارد کنید",
        noquestions: "سوالی در پرسشنامه درج نشده",
        createtrigger: "اجرا کننده ای بسازید",
        titleKeyboardAdornerTip: "برای ویرایش دکمه ی enter را فشار دهید.",
        keyboardAdornerTip: "برای ویرایش دکمه ی enter را فشار دهید, برای حذف دکمه ی delete را فشار دهید, برای حرکت دادن یک آیتم، دکمه ی  alt + arrow down /  alt + arrow up فشار دهید",
        triggerOn: "در ",
        triggerMakePagesVisible: "صفحات را قابل نمایش کن:",
        triggerMakeQuestionsVisible: "سوالات را قابل نمایش کن:",
        triggerCompleteText: "پرسشنامه را تکمیل کن اگر موفق بود.",
        triggerNotSet: "اجرا کننده تنظیم نشده.",
        triggerRunIf: "اجرا در صورت",
        triggerSetToName: "تعییر مقدار از: ",
        triggerFromName: "کپی مقدار از: ",
        triggerRunExpression: "اجرای این عبارت",
        triggerSetValue: "به: ",
        triggerGotoName: "به سوال بروید:",
        triggerIsVariable: "عدم درج متغییر در نتایج پرسشنامه",
        triggerRunExpressionEmpty: "لطفا عبارت معتبری وارد نمایید",
        emptyExpressionPlaceHolder: "عبارت را در اینجا تایپ کنید...",
        noFile: "هیچ فایلی انتخاب نشده است",
        clearIfInvisible: "پاک کردن مقدار اگر سؤال مخفی شود",
        valuePropertyName: "ارزش نام ملک",
        searchEnabled: "فعالسازی جستجو",
        hideSelectedItems: "مخفی کردن فقرههای انتخاب شده",
        closeOnSelect: "بستن کشویی پس از انتخاب",
        verticalAlign: "تراز عمودی",
        alternateRows: "ردیفهای جایگزین",
        columnsVisibleIf: "ستونها مرئی هستند اگر",
        rowsVisibleIf: "سطرها مرئی هستند اگر",
        otherPlaceholder: "ذی نفع منطقه نظر",
        filePlaceholder: "متن نگهدارنده پرونده",
        photoPlaceholder: "متن نگهدارنده عکس",
        fileOrPhotoPlaceholder: "متن جایدار پرونده یا عکس",
        rateType: "نوع نرخ",
        url_placeholder: "سابق: https://api.example.com/books",
        path_placeholder: "سابق: categories.fiction",
        questionStartIndex_placeholder: "سابق: الف)",
        width_placeholder: "سابق: 6in",
        minWidth_placeholder: "سابق: 600 پیکسل",
        maxWidth_placeholder: "سابق: 50٪",
        imageHeight_placeholder: "خودکار",
        imageWidth_placeholder: "خودکار",
        theme: {
            themeName: "تم",
            isPanelless: "ظاهر سوال",
            editorPanel: "پس زمینه و شعاع گوشه",
            questionPanel: "پس زمینه و شعاع گوشه",
            primaryColor: "رنگ لهجه",
            panelBackgroundTransparency: "تاری پسزمینه پانل",
            questionBackgroundTransparency: "تاری پسزمینۀ سؤال",
            fontSize: "اندازه قلم",
            scale: "مقیاس",
            cornerRadius: "شعاع گوشه",
            pageTitle: "قلم عنوان",
            pageDescription: "قلم توصیف",
            questionTitle: "قلم عنوان",
            questionDescription: "قلم توصیف",
            editorFont: "فونت",
            backgroundOpacity: "کدورت",
            "--sjs-font-family": "خانواده قلم",
            "--sjs-general-backcolor-dim": "رنگ پسزمینه",
            "--sjs-primary-backcolor": "پسزمینۀ لهجه",
            "--sjs-primary-forecolor": "پیشزمینه لهجه",
            "--sjs-special-red": "پیغامهای خطا",
            "--sjs-shadow-small": "جلوه های سایه",
            "--sjs-shadow-inner": "جلوه های سایه",
            "--sjs-border-default": "رنگ"
        },
        "header@header": {
            headerView: "مشاهده",
            logoPosition: "موقعیت لوگو",
            surveyTitle: "قلم عنوان نظرسنجی",
            surveyDescription: "قلم توصیف نظرسنجی",
            headerTitle: "قلم عنوان نظرسنجی",
            headerDescription: "قلم توصیف نظرسنجی",
            inheritWidthFrom: "عرض منطقه محتوا",
            textAreaWidth: "عرض متن",
            backgroundColorSwitch: "رنگ پسزمینه",
            backgroundImage: "تصویر زمینه",
            backgroundImageOpacity: "کدورت",
            overlapEnabled: "همپوشانی",
            logoPositionX: "موقعیت لوگو",
            titlePositionX: "موقعیت عنوان",
            descriptionPositionX: "شرح موقعیت"
        }
    },
    // Property values
    pv: {
        "true": "واقعی",
        "false": "نادرست",
        file: "پروندههای محلی",
        camera: "دوربین",
        "file-camera": "فایل های محلی یا دوربین",
        inherit: "ارث بری",
        show: "آشکار",
        hide: "پنهان",
        default: "پیش فرض",
        initial: "اولیه",
        random: "تصادفی",
        collapsed: "جمع شده",
        expanded: "باز شده",
        none: "هیچ کدام",
        asc: "صعودی",
        desc: "نزولی",
        indeterminate: "نامشخص",
        selected: "انتخاب",
        unselected: "انتخاب نشده",
        decimal: "اعشاری",
        currency: "ارز",
        percent: "درصد",
        firstExpanded: "گسترش یافته",
        off: "خاموش",
        list: "لیست",
        progressTop: "نوار پیشرفت  بالا",
        progressBottom: "نوار پیشرفت پایین",
        progressTopBottom: "نوار پیشرفت در بالا و پایین",
        tab: "زبانه",
        horizontal: "افقی",
        vertical: "عمودی",
        top: "بالا",
        bottom: "پایین",
        topBottom: "بالا و پایین",
        both: "هر دو",
        left: "چپ",
        right: "راست",
        center: "مرکز",
        leftRight: "چپ و راست",
        middle: "میانه",
        color: "رنگ",
        date: "تاریخ",
        datetime: "تاریخ",
        "datetime-local": "تاریخ محلی",
        email: "ایمیل",
        month: "ماه",
        number: "شماره",
        password: "رمز عبور",
        range: "محدوده",
        tel: "تلفن",
        text: "پیامک",
        time: "زمان",
        url: "آدرس",
        week: "هفته",
        hidden: "مخفی",
        edit: "ویرایش",
        display: "نمایش",
        contain: "حاوی",
        cover: "پوشش",
        fill: "پر کردن",
        next: "بعدی",
        last: "آخرین",
        onComplete: "به محض تمام شدن",
        onHidden: "به محض مخفی شدن",
        onHiddenContainer: "هنگامی که سوال یا پانل / صفحه ان پنهان می شود",
        clearInvisibleValues: {
            none: "هرگز"
        },
        clearIfInvisible: {
            none: "هرگز"
        },
        inputType: {
            color: "رنگ",
            date: "تاریخ",
            "datetime-local": "تاریخ و زمان",
            email: "ایمیل",
            month: "ماه",
            number: "شماره",
            password: "رمز عبور",
            range: "محدوده",
            tel: "شماره تماس",
            text: "پیامک",
            time: "زمان",
            url: "آدرس",
            week: "هفته"
        },
        all: "تمام",
        page: "صفحه",
        survey: "نظرسنجی",
        onNextPage: "به محض صفحه بعدی",
        onValueChanged: "به محض تغییر مقدار",
        onValueChanging: "قبل از اینکه پاسخ تغییر کند",
        questionsOnPageMode: {
            standard: "ساختار اصلی",
            singlePage: "نمایش تمام سوالات در یک صفحه",
            questionPerPage: "نمایش یک سؤال در هر صفحه"
        },
        noPreview: "پیش نمایش ندارد",
        showAllQuestions: "فعال سازی پیش نمایش با تمام سوالات",
        showAnsweredQuestions: "فعال سازی پیش نمایش به سوالات پاسخ داده شده",
        pages: "صفحات تکمیل شده",
        questions: "سوالات پاسخ داده شده",
        requiredQuestions: "پاسخ به سوالات مورد نیاز",
        correctQuestions: "پاسخ های معتبر",
        buttons: "صفحات تکمیل شده(دکمه UI)",
        underInput: "زیر ورودی",
        underTitle: "تحت عنوان",
        onBlur: "در تاری",
        onTyping: "هنگام تایپ",
        underRow: "زیر ردیف",
        underRowSingle: "در زیر ردیف، تنها یک پانل قابل مشاهده است",
        auto: "خودکار",
        showNavigationButtons: {
            none: "پنهان"
        },
        showTimerPanel: {
            none: "پنهان"
        },
        showTimerPanelMode: {
            all: "هر دو"
        },
        addRowLocation: {
            default: "بستگی به طرح ماتریس دارد"
        },
        panelsState: {
            default: "کاربران نمی توانند پانل ها را گسترش یا سقوط کنند",
            collapsed: "تمام پانل ها سقوط می کنند",
            expanded: "تمام پانل ها گسترش یافته اند",
            firstExpanded: "اولین گسترش"
        },
        widthMode: {
            static: "استاتیک",
            responsive: "پاسخگو"
        },
        contentMode: {
            image: "تصویر",
            video: "ویدئو",
            youtube: "Youtube"
        },
        displayMode: {
            buttons: "دکمه",
            dropdown: "کشویی"
        },
        rateColorMode: {
            default: "پیش فرض",
            scale: "مقیاس"
        },
        scaleColorMode: {
            monochrome: "تک رنگ",
            colored: "رنگی"
        },
        autoGenerate: {
            "true": "تولید",
            "false": "به صورت دستی وارد کنید"
        },
        rateType: {
            labels: "برچسب",
            stars: "ستاره",
            smileys: "صورتک"
        },
        state: {
            default: "قفل"
        },
        showQuestionNumbers: {
            default: "شماره خودکار",
            on: "شماره خودکار",
            onPage: "بازنشانی در هر صفحه",
            onpanel: "بازنشانی در هر پنل",
            onPanel: "بازنشانی در هر پنل",
            onSurvey: "ادامه در سراسر نظرسنجی",
            off: "بدون شماره"
        },
        descriptionLocation: {
            underTitle: "تحت عنوان سوال",
            underInput: "زیر فیلد ورودی"
        },
        selectToRankAreasLayout: {
            horizontal: "در کنار انتخاب ها",
            vertical: "انتخاب های بالا"
        },
        displayStyle: {
            decimal: "اعشاری",
            currency: "ارز",
            percent: "درصد",
            date: "تاریخ"
        },
        totalDisplayStyle: {
            decimal: "اعشاری",
            currency: "ارز",
            percent: "درصد",
            date: "تاریخ"
        },
        rowsOrder: {
            initial: "اصلی"
        },
        questionsOrder: {
            initial: "اصلی"
        },
        showProgressBar: {
            off: "پنهان",
            topbottom: "بالا و پایین",
            aboveheader: "بالای سرصفحه",
            belowheader: "زیر سرایند"
        },
        sum: "مجموع",
        count: "تعداد",
        min: "دقیقه",
        max: "حداکثر",
        avg: "میانگین",
        searchMode: {
            contains: "شامل",
            startsWith: "شروع با"
        },
        backgroundImageFit: {
            auto: "خودکار",
            cover: "پوشش",
            contain: "حاوی",
            fill: "کشش",
            tile: "کاشی"
        },
        backgroundImageAttachment: {
            fixed: "ثابت",
            scroll: "حرکت"
        },
        headerView: {
            basic: "اساسی",
            advanced: "پیشرفته"
        },
        inheritWidthFrom: {
            survey: "همانند نظرسنجی",
            container: "مناسب برای ظرف"
        },
        backgroundColorSwitch: {
            none: "هیچ کدام",
            accentColor: "رنگ لهجه",
            custom: "سفارشی"
        },
        colorPalette: {
            light: "نور",
            dark: "تاریک"
        },
        isPanelless: {
            "false": "پیش فرض",
            "true": "بدون پانل"
        }
    },
    // Operators
    op: {
        empty: "خالی باشد",
        notempty: "خالی نباشد",
        equal: "مساوی باشد",
        notequal: "مساوی نباشد",
        contains: "شامل",
        notcontains: "شامل نباشد",
        anyof: "هرکدام",
        allof: "همه",
        greater: "بزرگتر",
        less: "کوچکتر",
        greaterorequal: "بزرگتر یا مساوی",
        lessorequal: "کوچکتر یا مساوی",
        and: "و",
        or: "یا"
    },
    // Embed window
    ew: {
        angular: "استفاده از نسخه Angular",
        jquery: "استفاده از نسخه jQuery",
        knockout: "استفاده از نسخه ناک اوت",
        react: "استفاده از نسخه React",
        vue: "استفاده از نسخه Vue",
        bootstrap: "برای فریم ورک بوتسترپ",
        modern: "تم مدرن",
        default: "تم پیش فرض",
        orange: "تم نارنجی",
        darkblue: "تم آبی تیره",
        darkrose: "تم صورتی",
        stone: "تم سنگی",
        winter: "تم زمستانی",
        winterstone: "تم زمستانی و سنگی",
        showOnPage: "نمایش نظرسنجی در یک صفحه",
        showInWindow: "نمایش نظرسنجی در یک پنجره",
        loadFromServer: "بارگزاری JSON از سرور",
        titleScript: "اسکریپت و شیوه نمایش",
        titleHtml: "HTML",
        titleJavaScript: "جاوااسکریپت"
    },
    // Preview (Survey)
    ts: {
        selectPage: "صفحه ای را برای آزمایش انتخاب کنید:",
        showInvisibleElements: "نمایش المان های مخفی",
        hideInvisibleElements: "مخفی کردن عناصر نامرئی"
    },
    validators: {
        answercountvalidator: "تعداد پاسخ",
        emailvalidator: "ایمیل",
        expressionvalidator: "عبارت",
        numericvalidator: "عدد",
        regexvalidator: "regex",
        textvalidator: "متن"
    },
    triggers: {
        completetrigger: "تکمیل نظرسنجی",
        setvaluetrigger: "تنظیم مقدار",
        copyvaluetrigger: "کپی مقدار",
        skiptrigger: "رد کردن سوال ",
        runexpressiontrigger: "اجرای عبارت",
        visibletrigger: "تغییر وضعیت دیده شدن"
    },
    peplaceholder: {
        patternmask: {
            pattern: "شماره تماس: +1 (999)-999-99-99"
        },
        datetimemask: {
            pattern: "سابق: mm/dd/yyyyy"
        },
        currencymask: {
            prefix: "سابق: $",
            suffix: "Ex.: دلار امریکا"
        },
        panelbase: {
            questionTitleWidth: "سابق: 200 پیکسل"
        }
    },
    pehelp: {
        panel: {
            name: "یک شناسه پانل که برای پاسخ دهندگان قابل مشاهده نیست.",
            description: "یک زیرنویس پانل تایپ کنید.",
            visibleIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی که دید پانل را تعیین می کند استفاده کنید.",
            enableIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که حالت فقط خواندنی را برای پانل غیرفعال می کند.",
            requiredIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که مانع از ارسال نظرسنجی می شود مگر اینکه حداقل یک سوال تو در تو پاسخ داشته باشد.",
            questionTitleLocation: "برای تمام سوالات در این پنل اعمال می شود. اگر می خواهید این تنظیم را لغو کنید، قوانین تراز عنوان را برای سوالات فردی تعریف کنید. گزینه \"Inherit\" به طور پیش فرض تنظیم سطح صفحه (در صورت تنظیم) یا سطح نظرسنجی (\"بالا\" را اعمال می کند).",
            questionTitleWidth: "عرض ثابت را برای عناوین سؤال تنظیم می کند وقتی که انها در سمت چپ جعبه های سوال خود قرار دارند. مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره).",
            questionErrorLocation: "مکان یک پیام خطا را در رابطه با تمام سوالات درون پانل تنظیم می کند. گزینه \"Inherit\" شامل تنظیمات سطح صفحه (در صورت تنظیم) یا سطح نظرسنجی است.",
            questionsOrder: "ترتیب اصلی سوالات را نگه می دارد یا انها را تصادفی می کند. گزینه \"Inherit\" شامل تنظیمات سطح صفحه (در صورت تنظیم) یا سطح نظرسنجی است.",
            page: "پانل را به انتهای صفحه انتخاب شده تغییر می دهد.",
            innerIndent: "اضافه کردن فضا یا حاشیه بین محتوای پانل و مرز سمت چپ جعبه پانل.",
            startWithNewLine: "عدم انتخاب برای نمایش پانل در یک خط با سوال قبلی یا پانل. تنظیمات اعمال نمی شود اگر پانل اولین عنصر در فرم شما باشد.",
            state: "را انتخاب کنید از: \"گسترش یافته\" - پانل به طور کامل نمایش داده می شود و می تواند سقوط کند؛ \"سقوط\" - پانل تنها عنوان و توضیحات را نمایش می دهد و می تواند گسترش یابد. \"Locked\" - پانل به طور کامل نمایش داده می شود و نمی تواند سقوط کند.",
            width: "عرض پانل را متناسب با سایر عناصر بررسی در همان خط تنظیم می کند. مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره)."
        },
        paneldynamic: {
            name: "یک شناسه پانل که برای پاسخ دهندگان قابل مشاهده نیست.",
            description: "یک زیرنویس پانل تایپ کنید.",
            visibleIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی که دید پانل را تعیین می کند استفاده کنید.",
            enableIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که حالت فقط خواندنی را برای پانل غیرفعال می کند.",
            requiredIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که مانع از ارسال نظرسنجی می شود مگر اینکه حداقل یک سوال تو در تو پاسخ داشته باشد.",
            templateTitleLocation: "برای تمام سوالات در این پنل اعمال می شود. اگر می خواهید این تنظیم را لغو کنید، قوانین تراز عنوان را برای سوالات فردی تعریف کنید. گزینه \"Inherit\" به طور پیش فرض تنظیم سطح صفحه (در صورت تنظیم) یا سطح نظرسنجی (\"بالا\" را اعمال می کند).",
            templateErrorLocation: "محل یک پیام خطا را در رابطه با سؤال با ورودی نامعتبر تنظیم میکند. انتخاب بین: \"بالا\" - یک متن خطا در بالای جعبه سوال قرار می گیرد؛ \"پایین\" - یک متن خطا در پایین جعبه سوال قرار می گیرد. گزینه \"Inherit\" به طور پیش فرض تنظیم سطح صفحه (در صورت تنظیم) یا سطح نظرسنجی (\"بالا\" را اعمال می کند).",
            errorLocation: "مکان یک پیام خطا را در رابطه با تمام سوالات درون پانل تنظیم می کند. گزینه \"Inherit\" شامل تنظیمات سطح صفحه (در صورت تنظیم) یا سطح نظرسنجی است.",
            page: "پانل را به انتهای صفحه انتخاب شده تغییر می دهد.",
            innerIndent: "اضافه کردن فضا یا حاشیه بین محتوای پانل و مرز سمت چپ جعبه پانل.",
            startWithNewLine: "عدم انتخاب برای نمایش پانل در یک خط با سوال قبلی یا پانل. تنظیمات اعمال نمی شود اگر پانل اولین عنصر در فرم شما باشد.",
            state: "را انتخاب کنید از: \"گسترش یافته\" - پانل به طور کامل نمایش داده می شود و می تواند سقوط کند؛ \"سقوط\" - پانل تنها عنوان و توضیحات را نمایش می دهد و می تواند گسترش یابد. \"Locked\" - پانل به طور کامل نمایش داده می شود و نمی تواند سقوط کند.",
            width: "عرض پانل را متناسب با سایر عناصر بررسی در همان خط تنظیم می کند. مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره).",
            templateTitle: "قالب را برای عناوین پانل پویا تایپ کنید. از {panelIndex} برای موقعیت عمومی پانل و {visiblePanelIndex} برای سفارش ان در میان پانل های قابل مشاهده استفاده کنید. این نگهدارنده ها را در الگو قرار دهید تا شماره گذاری خودکار اضافه شود.",
            templateTabTitle: "در قالبی برای عناوین زبانه تایپ کنید. از {panelIndex} برای موقعیت عمومی پانل و {visiblePanelIndex} برای سفارش ان در میان پانل های قابل مشاهده استفاده کنید. این نگهدارنده ها را در الگو قرار دهید تا شماره گذاری خودکار اضافه شود.",
            tabTitlePlaceholder: "یک متن جایگزین برای عناوین برگه که زمانی اعمال می شود که الگوی عنوان برگه ارزش معنی داری تولید نمی کند.",
            templateVisibleIf: "این تنظیم به شما اجازه می دهد تا دید پانل های فردی را در پانل پویا کنترل کنید. از نگهدارنده '{panel}' برای ارجاع به پنل فعلی در عبارت خود استفاده کنید.",
            titleLocation: "این تنظیم به طور خودکار توسط تمام سوالات موجود در این پنل به ارث برده می شود. اگر می خواهید این تنظیم را لغو کنید، قوانین تراز عنوان را برای سوالات فردی تعریف کنید. گزینه \"Inherit\" به طور پیش فرض تنظیم سطح صفحه (در صورت تنظیم) یا سطح نظرسنجی (\"بالا\" را اعمال می کند).",
            descriptionLocation: "گزینه \"Inherit\" سطح صفحه (در صورت تنظیم) یا تنظیم سطح نظرسنجی (\"زیر عنوان پانل\" به طور پیش فرض) اعمال می شود.",
            newPanelPosition: "موقعیت یک پانل تازه اضافه شده را تعریف می کند. به طور پیش فرض، پانل های جدید به پایان اضافه می شوند. \"Next\" را انتخاب کنید تا یک پانل جدید پس از پانل فعلی وارد شود.",
            defaultValueFromLastPanel: "پاسخ ها را از اخرین پانل تکرار می کند و انها را به پانل پویا اضافه شده بعدی اختصاص می دهد.",
            keyName: "مرجع یک نام سوال نیاز به یک کاربر برای ارائه یک پاسخ منحصر به فرد برای این سوال در هر پانل."
        },
        defaultValueExpression: "این تنظیم به شما اجازه می دهد تا یک مقدار پاسخ پیش فرض را بر اساس یک عبارت اختصاص دهید. این عبارت می تواند شامل محاسبات اساسی - \"{q1_id} + {q2_id}'، عبارات بولی مانند \"{age} > 60\" و توابع: \"iif()\"، \"today()\"، \"age()\"، \"min()\"، \"max()\"، \"avg()\" و غیره باشد. مقدار تعیین شده توسط این عبارت به عنوان مقدار پیش فرض اولیه عمل می کند که می تواند توسط ورودی دستی پاسخ دهنده لغو شود.",
        resetValueIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که تعیین می کند چه زمانی ورودی پاسخ دهنده به مقدار بر اساس \"بیان مقدار پیش فرض\" یا \"تنظیم مقدار بیان\" یا \"پاسخ پیش فرض\" مقدار (اگر هر کدام تنظیم شده است) تنظیم مجدد شود.",
        setValueIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که تعیین می کند چه زمانی \"Set value expression\" را اجرا کنید و به صورت پویا مقدار حاصل را به عنوان یک پاسخ اختصاص دهید.",
        setValueExpression: "یک عبارت را مشخص کنید که مقدار تعیین شده را هنگامی که شرایط در قانون \"Set value if\" براورده می شود، تعریف می کند. این عبارت می تواند شامل محاسبات اساسی - \"{q1_id} + {q2_id}'، عبارات بولی مانند \"{age} > 60\" و توابع: \"iif()\"، \"today()\"، \"age()\"، \"min()\"، \"max()\"، \"avg()\" و غیره باشد. مقدار تعیین شده توسط این عبارت می تواند توسط ورودی دستی پاسخ دهنده لغو شود.",
        question: {
            name: "یک شناسه سوال که برای پاسخ دهندگان قابل مشاهده نیست.",
            description: "یک سوال زیر نویس تایپ کنید.",
            visibleIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که دید سوال را تعیین می کند.",
            enableIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که حالت فقط خواندنی را برای سوال غیرفعال می کند.",
            requiredIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که مانع پیشرفت یا تسلیم نظرسنجی می شود مگر اینکه سوال پاسخی دریافت کند.",
            startWithNewLine: "عدم انتخاب برای نمایش سوال در یک خط با سوال قبلی یا پانل. تنظیمات اعمال نمی شود اگر سوال اولین عنصر در فرم شما باشد.",
            page: "سؤال را به انتهای صفحه انتخاب شده تغییر می دهد.",
            state: "را انتخاب کنید از: \"گسترش یافته\" - جعبه سوال به طور کامل نمایش داده می شود و می تواند سقوط کند؛ \"سقوط\" - جعبه سوال تنها عنوان و توضیحات را نمایش می دهد و می تواند گسترش یابد. \"Locked\" - جعبه سوال به طور کامل نمایش داده می شود و نمی تواند سقوط کند.",
            titleLocation: "قوانین هم ترازی عنوان تعریف شده در یک پانل، صفحه یا سطح نظرسنجی را لغو می کند. گزینه \"Inherit\" تنظیمات سطح بالاتر (در صورت تنظیم) یا تنظیمات سطح نظرسنجی (\"بالا\" به طور پیش فرض) را اعمال می کند.",
            descriptionLocation: "گزینه \"به ارث بردن\" تنظیم سطح نظرسنجی (\"تحت عنوان سوال\" به طور پیش فرض) اعمال می شود.",
            errorLocation: "مکان یک پیام خطا را در رابطه با سؤال با ورودی نامعتبر تنظیم می کند. انتخاب بین: \"بالا\" - یک متن خطا در بالای جعبه سوال قرار می گیرد؛ \"پایین\" - یک متن خطا در پایین جعبه سوال قرار می گیرد. گزینه \"ارث\" تنظیم سطح نظرسنجی (\"بالا\" به طور پیش فرض) را اعمال می کند.",
            indent: "فضای یا حاشیه بین محتوای سوال و مرز سمت چپ جعبه سوال اضافه می کند.",
            width: "عرض سوال را متناسب با سایر عناصر نظرسنجی در همان خط تنظیم می کند. مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره).",
            surveyvalidator: {
                expression: "از نماد چوب جادویی برای تنظیم یک قانون اعتبار سنجی برای سوال استفاده کنید."
            },
            textUpdateMode: "انتخاب از: \"در تمرکز از دست رفته\" - مقدار به روز شده است زمانی که فیلد ورودی تمرکز خود را از دست می دهد؛ \"در هنگام تایپ\" - مقدار در زمان واقعی به روز می شود، زیرا کاربران تایپ می کنند. گزینه \"ارث\" تنظیم سطح نظرسنجی (\"در تمرکز از دست رفته\" به طور پیش فرض) اعمال می شود.",
            url: "شما می توانید از هر سرویس وب به عنوان منبع داده برای سوالات چند گزینه ای استفاده کنید. برای پر کردن مقادیر انتخاب، URL سرویس ارائه دهنده داده ها را وارد کنید.",
            searchMode: "یک عملیات مقایسه ای که برای فیلتر کردن لیست کشویی استفاده می شود.",
            textWrapEnabled: "متون طولانی در گزینه های انتخاب به طور خودکار شکستن خط را ایجاد می کنند تا در منوی کشویی قرار بگیرند. اگر می خواهید متن ها کلیپ شوند، انتخاب را لغو کنید."
        },
        signaturepad: {
            signatureWidth: "عرض ناحیه امضای نمایش داده شده و تصویر حاصل را تنظیم می کند.",
            signatureHeight: "ارتفاع ناحیه امضای نمایش داده شده و تصویر حاصل را تنظیم میکند.",
            signatureAutoScaleEnabled: "اگر می خواهید منطقه امضا برای پر کردن تمام فضای موجود در جعبه سوال در حالی که حفظ پیش فرض 3: 2 نسبت ابعاد را انتخاب کنید. هنگامی که عرض سفارشی و مقادیر ارتفاع تنظیم می شود، تنظیم نسبت ابعاد این ابعاد را حفظ می کند."
        },
        file: {
            imageHeight: "ارتفاع تصویر را در نتایج نظرسنجی تنظیم می کند.",
            imageWidth: "عرض تصویر را در نتایج نظرسنجی تنظیم می کند."
        },
        image: {
            contentMode: "گزینه \"Auto\" به طور خودکار حالت مناسب برای نمایش - تصویر، ویدئو یا یوتیوب - را بر اساس URL منبع ارائه شده تعیین می کند."
        },
        imagepicker: {
            imageHeight: "مقادیر حداقل و حداکثر ارتفاع را نادیده می گیرد.",
            imageWidth: "مقادیر حداقل و حداکثر عرض را نادیده می گیرد.",
            choices: "\"ارزش\" به عنوان یک شناسه مورد استفاده در قوانین شرطی عمل می کند. \"متن\" به پاسخ دهندگان نمایش داده می شود.",
            contentMode: "بین \"تصویر\" و \"ویدئو\" را انتخاب کنید تا حالت محتوا را انتخاب کنید. اگر \"تصویر\" انتخاب شده است، اطمینان حاصل کنید که تمام گزینه های ارائه شده فایل های تصویری در فرمت های زیر هستند: JPEG، GIF، PNG، APNG، SVG، BMP، ICO. به طور مشابه، اگر \"ویدئو\" انتخاب شده است، اطمینان حاصل کنید که تمام گزینه ها لینک مستقیم به فایل های ویدئویی در فرمت های زیر هستند: MP4، MOV، WMV، FLV، AVI، MKV. لطفا توجه داشته باشید که پیوندهای YouTube برای گزینه های ویدیویی پشتیبانی نمی شوند."
        },
        text: {
            size: "این تنظیم فقط فیلد ورودی را تغییر اندازه می دهد و روی عرض جعبه پرسش تاثیر نمی گذارد. برای محدود کردن طول ورودی پذیرفته شده، به <b>Validation → Maximum character limit</b> بروید."
        },
        comment: {
            rows: "تعداد خطوط نمایش داده شده در فیلد ورودی را تنظیم می کند. اگر ورودی خطوط بیشتری را بگیرد، نوار اسکرول ظاهر می شود."
        },
        // survey templates
        survey: {
            mode: "انتخاب بین: \"قابل ویرایش\" - پاسخ دهندگان را قادر می سازد تا نظرسنجی خود را پر کنند. \"فقط خواندنی\" - ویرایش فرم را غیرفعال می کند."
        },
        matrixdropdowncolumn: {
            name: "یک شناسه ستون که برای پاسخ دهندگان قابل مشاهده نیست.",
            isUnique: "هنگامی که برای یک ستون فعال می شود، یک پاسخ دهنده باید یک پاسخ منحصر به فرد برای هر سوال در این ستون ارائه دهد.",
            rows: "تعداد خطوط نمایش داده شده در فیلد ورودی را تنظیم می کند. اگر ورودی خطوط بیشتری را بگیرد، نوار اسکرول ظاهر می شود.",
            visibleIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی که دید ستون را تعیین می کند استفاده کنید.",
            enableIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که حالت فقط خواندنی را برای ستون غیرفعال می کند.",
            requiredIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که مانع از ارسال نظرسنجی می شود مگر اینکه حداقل یک سوال تو در تو پاسخ داشته باشد.",
            showInMultipleColumns: "هنگامی که انتخاب می شود، یک ستون فردی برای هر گزینه انتخاب ایجاد می کند."
        },
        widthMode: "را انتخاب کنید از: \"استاتیک\" - مجموعه عرض ثابت؛ \"پاسخگو\" - باعث می شود نظرسنجی عرض کامل صفحه نمایش را اشغال کند؛ \"Auto\" - هر یک از این دو را بسته به نوع سوال مورد استفاده اعمال می کند.",
        cookieName: "کوکی ها کاربران را از پر کردن همان نظرسنجی دو بار جلوگیری می کند.",
        logo: "چسباندن یک پیوند تصویر (بدون محدودیت اندازه) یا روی نماد پوشه کلیک کنید تا یک فایل را از رایانه خود مرور کنید (تا 64KB).",
        logoWidth: "عرض لوگو را در واحدهای CSS تنظیم می کند (px، ٪، in، pt و غیره).",
        logoHeight: "ارتفاع لوگو را در واحدهای CSS تنظیم می کند (px، ٪، in، pt و غیره).",
        logoFit: "انتخاب از: \"هیچ\" - تصویر اندازه اصلی خود را حفظ می کند؛ \"شامل\" - تصویر تغییر اندازه به جا در حالی که حفظ نسبت ابعاد ان؛ \"Cover\" - تصویر کل جعبه را پر می کند در حالی که نسبت ابعاد ان را حفظ می کند. \"Fill\" - تصویر برای پر کردن جعبه بدون حفظ نسبت ابعاد ان کشیده می شود.",
        goNextPageAutomatic: "انتخاب کنید که ایا می خواهید نظرسنجی به طور خودکار به صفحه بعدی پیش رود پس از اینکه یک پاسخ دهنده به تمام سوالات در صفحه فعلی پاسخ داد.",
        allowCompleteSurveyAutomatic: "انتخاب کنید که ایا می خواهید نظرسنجی به طور خودکار پس از پاسخ دادن به تمام سوالات پاسخ دهد.",
        showNavigationButtons: "قابلیت مشاهده و مکان دکمه های پیمایش را در یک صفحه تنظیم می کند.",
        showProgressBar: "دید و مکان یک نوار پیشرفت را تنظیم می کند. مقدار \"Auto\" نوار پیشرفت را در بالا یا پایین هدر نظرسنجی نشان می دهد.",
        showPreviewBeforeComplete: "صفحه پیش نمایش را فقط با تمام سوالات یا پاسخ داده شده فعال کنید.",
        questionTitleLocation: "به تمام سوالات در نظرسنجی اعمال می شود. این تنظیم را می توان با قوانین هم ترازی عنوان در سطوح پایین تر لغو کرد: پانل، صفحه یا سوال. یک تنظیم سطح پایین تر، کسانی را که در سطح بالاتری قرار دارند، نادیده می گیرد.",
        requiredText: "یک نماد یا دنباله ای از نمادها نشان می دهد که یک پاسخ مورد نیاز است.",
        questionStartIndex: "یک شماره یا حرف را وارد کنید که می خواهید با ان شروع به شماره گیری کنید.",
        questionErrorLocation: "مکان یک پیام خطا را در رابطه با سؤال با ورودی نامعتبر تنظیم می کند. انتخاب بین: \"بالا\" - یک متن خطا در بالای جعبه سوال قرار می گیرد؛ \"پایین\" - یک متن خطا در پایین جعبه سوال قرار می گیرد.",
        focusFirstQuestionAutomatic: "انتخاب کنید که ایا می خواهید اولین فیلد ورودی در هر صفحه اماده برای ورود متن باشد.",
        questionsOrder: "ترتیب اصلی سوالات را نگه می دارد یا انها را تصادفی می کند. اثر این تنظیم فقط در تب Preview قابل مشاهده است.",
        maxTextLength: "فقط برای سوالات ورودی متن.",
        maxOthersLength: "فقط برای نظرات سوال.",
        commentAreaRows: "تعداد خطوط نمایش داده شده در ناحیههای متن را برای نظرات سؤال تنظیم میکند. در ورودی طول می کشد تا خطوط بیشتر، نوار اسکرول به نظر می رسد.",
        autoGrowComment: "انتخاب کنید اگر شما می خواهید نظرات سوال و سوالات متن بلند به رشد خودکار در ارتفاع بر اساس طول متن وارد شده است.",
        allowResizeComment: "برای نظرات سوال و سوالات طولانی متن تنها.",
        calculatedValues: "متغیرهای سفارشی به عنوان متغیرهای متوسط یا کمکی مورد استفاده در محاسبات فرم عمل می کنند. انها ورودی های پاسخ دهنده را به عنوان مقادیر منبع می گیرند. هر متغیر سفارشی دارای یک نام منحصر به فرد و یک عبارت است که بر اساس ان است.",
        includeIntoResult: "اگر میخواهید مقدار محاسبهشده عبارت همراه با نتایج نظرسنجی ذخیره شود ، برگزینید.",
        triggers: "Trigger یک رویداد یا شرایطی است که بر اساس یک عبارت است. هنگامی که عبارت به \"درست\" ارزیابی می شود، یک ماشه یک عمل را تنظیم می کند. چنین اقدامی می تواند به صورت اختیاری یک سوال هدف داشته باشد که بر ان تاثیر می گذارد.",
        clearInvisibleValues: "انتخاب کنید که ایا برای پاک کردن ارزش ها برای سوالات پنهان شده توسط منطق شرطی و زمانی که ان را انجام دهید.",
        textUpdateMode: "انتخاب از: \"در تمرکز از دست رفته\" - مقدار به روز شده است زمانی که فیلد ورودی تمرکز خود را از دست می دهد؛ \"در هنگام تایپ\" - مقدار در زمان واقعی به روز می شود، زیرا کاربران تایپ می کنند.",
        columns: "مقدار چپ به عنوان یک شناسه ستون مورد استفاده در قوانین شرطی عمل می کند، مقدار مناسب به پاسخ دهندگان نمایش داده می شود.",
        rows: "مقدار سمت چپ به عنوان یک شناسه ردیف مورد استفاده در قوانین شرطی عمل می کند، مقدار مناسب به پاسخ دهندگان نمایش داده می شود.",
        columnMinWidth: "مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره).",
        rowTitleWidth: "مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره).",
        totalText: "تنها زمانی قابل مشاهده است که حداقل یک ستون دارای عبارت Total type یا Total باشد.",
        cellErrorLocation: "محل یک پیام خطا را در رابطه با یک سلول با ورودی نامعتبر تنظیم می کند. گزینه \"Inherit\" تنظیمات را از ویژگی \"Error message alignment\" اعمال می کند.",
        keyDuplicationError: "هنگامی که ویژگی \"جلوگیری از پاسخ های تکراری\" فعال می شود، پاسخ دهنده ای که سعی در ارسال یک ورودی تکراری دارد، پیام خطای زیر را دریافت می کند.",
        totalExpression: "به شما اجازه می دهد تا مقادیر کل را بر اساس یک عبارت محاسبه کنید. این عبارت می تواند شامل محاسبات اساسی ('{q1_id} + {q2_id}')، عبارات بولی ('{age} > 60') و توابع ('iif()'، 'today()'، 'age()'، 'min()'، 'max()'، 'avg()'، و غیره باشد.",
        confirmDelete: "یک درخواست فوری برای تایید حذف ردیف ایجاد می کند.",
        defaultValueFromLastRow: "پاسخ ها را از اخرین ردیف تکرار می کند و انها را به ردیف دینامیک بعدی اضافه می کند.",
        keyName: "اگر ستون مشخص شده حاوی مقادیر یکسان باشد، نظرسنجی خطای \"مقدار کلیدی غیر منحصر به فرد\" را پرتاب می کند.",
        description: "یک زیرنویس تایپ کنید.",
        locale: "یک زبان را برای شروع ایجاد نظرسنجی خود انتخاب کنید. برای اضافه کردن ترجمه، به یک زبان جدید بروید و متن اصلی را در اینجا یا در زبانه ترجمه ترجمه ترجمه کنید.",
        detailPanelMode: "مکان یک بخش جزئیات را در رابطه با یک ردیف تنظیم می کند. انتخاب از: \"هیچ\" - هیچ گسترش اضافه شده است؛ \"زیر ردیف\" - گسترش ردیف در زیر هر ردیف ماتریس قرار می گیرد؛ \"زیر ردیف، فقط یک ردیف را نمایش می دهد\" - یک گسترش فقط در زیر یک ردیف نمایش داده می شود، گسترش ردیف باقی مانده سقوط می کند.",
        imageFit: "انتخاب از: \"هیچ\" - تصویر اندازه اصلی خود را حفظ می کند؛ \"شامل\" - تصویر تغییر اندازه به جا در حالی که حفظ نسبت ابعاد ان؛ \"Cover\" - تصویر کل جعبه را پر می کند در حالی که نسبت ابعاد ان را حفظ می کند. \"Fill\" - تصویر برای پر کردن جعبه بدون حفظ نسبت ابعاد ان کشیده می شود.",
        autoGrow: "به تدریج ارتفاع میدان ورودی را افزایش می دهد زیرا داده ها وارد می شوند. تنظیم \"ارتفاع میدان ورودی (در خطوط)\" را لغو می کند.",
        allowResize: "دسته تغییر اندازه (یا گرفتن) در گوشه ظاهر می شود و می تواند برای تغییر اندازه میدان ورودی کشیده شود.",
        maxTimeToFinish: "یک فاصله زمانی در ثانیه که پس از ان نظرسنجی به طور خودکار به صفحه تشکر از شما پیش می رود.",
        maxTimeToFinishPage: "یک فاصله زمانی در ثانیه که پس از ان نظرسنجی به طور خودکار به صفحه بعدی پیش می رود.",
        page: {
            maxTimeToFinish: "یک فاصله زمانی در ثانیه که پس از ان نظرسنجی به طور خودکار به صفحه بعدی پیش می رود.",
            visibleIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که دید صفحه را تعیین می کند.",
            enableIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که حالت فقط خواندنی را برای صفحه غیرفعال می کند.",
            requiredIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که مانع از ارسال نظرسنجی می شود مگر اینکه حداقل یک سوال تو در تو پاسخ داشته باشد.",
            questionTitleLocation: "به تمام سوالات موجود در این صفحه اعمال می شود. اگر می خواهید این تنظیمات را لغو کنید، قوانین تراز عنوان را برای سوالات یا پانل های فردی تعریف کنید. گزینه \"ارث\" تنظیم سطح نظرسنجی (\"بالا\" به طور پیش فرض) را اعمال می کند.",
            questionTitleWidth: "عرض ثابت را برای عناوین سؤال تنظیم می کند وقتی که انها در سمت چپ جعبه های سوال خود قرار دارند. مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره).",
            questionErrorLocation: "مکان یک پیام خطا را در رابطه با سؤال با ورودی نامعتبر تنظیم می کند. انتخاب بین: \"بالا\" - یک متن خطا در بالای جعبه سوال قرار می گیرد؛ \"پایین\" - یک متن خطا در پایین جعبه سوال قرار می گیرد. گزینه \"ارث\" تنظیم سطح نظرسنجی (\"بالا\" به طور پیش فرض) را اعمال می کند.",
            questionsOrder: "ترتیب اصلی سوالات را نگه می دارد یا انها را تصادفی می کند. گزینه \"ارث\" تنظیم سطح نظرسنجی (\"اصلی\" به طور پیش فرض) را اعمال می کند. اثر این تنظیم فقط در تب Preview قابل مشاهده است.",
            navigationButtonsVisibility: "قابلیت مشاهده دکمههای پیمایش را روی صفحه تنظیم میکند. گزینه \"به ارث بردن\" تنظیم سطح نظرسنجی را اعمال می کند که به طور پیش فرض به \"قابل مشاهده\" است."
        },
        showTimerPanel: "قابلیت مشاهده و مکان یک تایمر را در یک صفحه تنظیم می کند.",
        panelsState: "انتخاب از: \"قفل شده\" - کاربران نمی توانند پانل ها را گسترش یا سقوط دهند؛ \"سقوط همه\" - تمام پانل ها در یک حالت فروپاشی شروع می شوند؛ \"گسترش همه\" - تمام پانل ها در یک حالت گسترش یافته شروع می شوند؛ \"اولین گسترش\" - تنها پانل اول در ابتدا گسترش یافته است.",
        imageLinkName: "یک نام خصوصیت مشترک را درون ارایۀ اشیایی که حاوی نشانیهای اینترنتی پرونده تصویر یا ویدئویی است که میخواهید در فهرست انتخاب نمایش داده شود، وارد کنید.",
        choices: "مقدار سمت چپ به عنوان یک شناسه مورد استفاده در قوانین شرطی عمل می کند، مقدار مناسب برای پاسخ دهندگان نمایش داده می شود.",
        title: "یک عنوان کاربر پسند برای نمایش تایپ کنید.",
        waitForUpload: "اطمینان حاصل می کند که کاربران تا زمانی که فایل ها اپلود نشده اند، نظرسنجی را تکمیل نخواهند کرد.",
        minWidth: "مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره).",
        maxWidth: "مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره).",
        width: "مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره).",
        valueName: "اگر این ویژگی را تنظیم نکنید، پاسخ در زمینه ای که توسط ویژگی Name مشخص شده است ذخیره می شود.",
        useDisplayValuesInDynamicTexts: "در انواع سوالات تک و چند انتخاب، هر گزینه انتخاب دارای یک شناسه و مقدار نمایش است. هنگامی که انتخاب می شود، این تنظیم یک مقدار نمایش را به جای یک مقدار ID در سوالات HTML و عناوین پویا و توصیف عناصر بررسی نشان می دهد.",
        clearIfInvisible: "انتخاب کنید که ایا برای پاک کردن یا نه ارزش سوال پنهان شده توسط منطق شرطی و زمانی که به ان را انجام دهد. گزینه \"ارث\" تنظیم سطح نظرسنجی (\"پس از اتمام نظرسنجی\" به طور پیش فرض) اعمال می شود.",
        choicesFromQuestionMode: "انتخاب از: \"همه\" - کپی تمام گزینه های انتخاب از سوال انتخاب شده؛ \"انتخاب شده\" - به صورت پویا فقط گزینه های انتخاب شده را کپی می کند؛ \"Unselected\" - به صورت پویا تنها گزینه های انتخاب نشده را کپی می کند. گزینه های \"None\" و \"Other\" در صورت فعال شدن در سؤال منبع به طور پیش فرض کپی می شوند.",
        showOtherItem: "هنگامی که انتخاب می شوند، کاربران می توانند ورودی های اضافی را در یک جعبه نظر جداگانه قرار دهند.",
        separateSpecialChoices: "نمایش هر گزینه انتخاب خاص (\"هیچ\"، \"دیگر\"، \"انتخاب همه\") در یک خط جدید، حتی در هنگام استفاده از یک طرح چند ستون.",
        path: "مشخص کردن محل در مجموعه داده های سرویس که در ان ارایه هدف از اشیاء واقع شده است. ترک خالی اگر URL در حال حاضر به ارایه اشاره می کند.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "یک نام ویژگی یکنواخت را در ارایه اشیایی که حاوی مقادیری است که می خواهید در لیست انتخاب نمایش داده شود وارد کنید.",
        allowEmptyResponse: "انتخاب کنید تا سرویس بتواند یک پاسخ یا ارایه خالی را بازگرداند.",
        choicesVisibleIf: "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که دید همه گزینه های انتخابی را تعیین می کند.",
        rateValues: "مقدار سمت چپ به عنوان یک شناسه مورد استفاده در قوانین شرطی عمل می کند، مقدار مناسب برای پاسخ دهندگان نمایش داده می شود.",
        rating: {
            displayMode: "\"Auto\" بین حالت های \"Buttons\" و \"Dropdown\" بر اساس عرض موجود انتخاب می شود. هنگامی که عرض برای نمایش دکمه ها کافی نیست، سوال یک کشویی را نشان می دهد."
        },
        valuePropertyName: "اجازه می دهد تا شما را به اتصال سوالات است که تولید نتایج در فرمت های مختلف. هنگامی که چنین سوالاتی با استفاده از یک شناسه پیوستن به هم مرتبط می شوند، این ویژگی مشترک مقادیر سوال انتخاب شده را ذخیره می کند.",
        searchEnabled: "انتخاب کنید که ایا می خواهید محتویات منوی کشویی را به روز کنید تا با پرسوجوی جستجویی که کاربر در قسمت ورودی تایپ می کند مطابقت داشته باشد.",
        valueTrue: "ارزش برای صرفه جویی در نتایج نظرسنجی زمانی که پاسخ دهندگان پاسخ مثبت می دهند.",
        valueFalse: "ارزش برای صرفه جویی در نتایج نظرسنجی زمانی که پاسخ دهندگان پاسخ منفی می دهند.",
        showPreview: "توصیه نمی شود این گزینه را غیرفعال کنید زیرا تصویر Preview را نادیده می گیرد و درک اینکه ایا فایل ها اپلود شده اند را برای کاربر دشوار می کند.",
        needConfirmRemoveFile: "یک اعلان برای تایید حذف پرونده ایجاد می کند.",
        selectToRankEnabled: "فقط گزینه های انتخاب شده را رتبه بندی کنید. کاربران موارد انتخاب شده را از لیست انتخاب می کنند تا انها را در منطقه رتبه بندی سفارش دهند.",
        dataList: "لیستی از انتخاب هایی را وارد کنید که در طول ورودی به مخاطب پیشنهاد می شود.",
        itemSize: "تنظیم فقط زمینه های ورودی را تغییر می دهد و بر عرض جعبه سوال تاثیر نمی گذارد.",
        itemTitleWidth: "عرض سازگار را برای همۀ برچسبهای فقره به تصویردانه تنظیم میکند",
        altText: "به عنوان یک جایگزین زمانی که تصویر نمی تواند بر روی دستگاه کاربر و برای اهداف دسترسی نمایش داده شود.",
        rateColorMode: "رنگ ایموجی انتخاب شده را هنگامی که نوع نماد رتبه بندی روی \"Smileys\" تنظیم شده است، تعریف می کند. انتخاب بین: \"پیش فرض\" - ایموجی انتخاب شده در رنگ پیش فرض بررسی ظاهر می شود؛ \"Scale\" - ایموجی انتخاب شده رنگ را از مقیاس رتبه بندی به ارث می برد.",
        expression: {
            name: "یک شناسه بیان که برای پاسخ دهندگان قابل مشاهده نیست.",
            description: "زیر نویس عبارت را تایپ کنید.",
            expression: "یک عبارت می تواند شامل محاسبات اساسی ('{q1_id} + {q2_id}')، شرایط ('{age} > 60') و توابع ('iif()'، 'today()'، 'age()'، 'min()'، 'max()'، 'avg()'' و غیره باشد."
        },
        storeOthersAsComment: "انتخاب کنید برای ذخیره \"دیگر\" مقدار گزینه به عنوان یک ملک جداگانه در نتایج نظرسنجی.",
        format: "از {0} به عنوان نگهدارنده برای ارزش واقعی استفاده کنید.",
        acceptedTypes: "برای اطلاعات بیشتر به [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description مراجعه کنید.",
        columnColCount: "فقط برای انواع سلول های Radiogroup و Checkbox قابل اجرا است.",
        autocomplete: "برای اطلاعات بیشتر به شرح ویژگی [autocomplete] (https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) مراجعه کنید.",
        filePlaceholder: "اعمال می شود زمانی که \"نوع منبع\" است \"فایل های محلی\" و یا زمانی که دوربین در دسترس نیست",
        photoPlaceholder: "هنگامی که \"نوع منبع\" \"دوربین\" است، اعمال می شود.",
        fileOrPhotoPlaceholder: "زمانی اعمال می شود که \"نوع منبع\" \"فایل های محلی یا دوربین\" باشد.",
        masksettings: {
            saveMaskedValue: "انتخاب کنید که ایا می خواهید مقدار سؤال را با یک ماسک کاربردی در نتایج نظرسنجی ذخیره کنید."
        },
        patternmask: {
            pattern: "الگو می تواند شامل literals رشته و متغیرهای زیر باشد: '9' - برای یک رقم؛ 'a' - برای یک حرف بزرگ یا کوچک؛ \"#\" - برای یک رقم یا یک حرف بزرگ یا کوچک. استفاده از backslash '\\' برای فرار از یک شخصیت."
        },
        datetimemask: {
            pattern: "این الگو می تواند شامل کاراکترهای جداکننده و متغیرهای زیر باشد: <br>'m' - شماره ماه.<br>'mm' - شماره ماه، با صفر پیشرو برای مقادیر تک رقمی. <br>\"D\" - روز ماه. <br>'dd' - روز ماه، با صفر پیشرو برای مقادیر تک رقمی. <br>'yy' - دو رقم اخر سال. <br>'yyyyy' - سال چهار رقمی. <br>\"H\" - ساعت در فرمت 24 ساعته. <br>'HH' - ساعت در فرمت 24 ساعته، با صفر پیشرو برای مقادیر تک رقمی. <br>'h' - ساعت در فرمت 12 ساعته. <br>'hh' - ساعت در فرمت 12 ساعته، با صفر پیشرو برای مقادیر تک رقمی. <br>\"MM\" - دقیقه. <br>SS ثانیه <br>\"TT\" - دوره ساعت 12 ساعته در حالت بزرگ (AM / PM). <br>'tt' - دوره ساعت 12 ساعته در حروف کوچک (am / pm)."
        },
        numericmask: {
            decimalSeparator: "نمادی که برای جدا کردن قسمت کسری از قسمت صحیح یک عدد نمایش داده شده استفاده می شود.",
            thousandsSeparator: "نمادی که برای جدا کردن ارقام یک عدد بزرگ به گروه های سه نفره استفاده می شود.",
            precision: "محدود کردن تعداد ارقام برای حفظ پس از نقطه اعشار برای یک عدد نمایش داده شده."
        },
        currencymask: {
            prefix: "یک یا چند نماد قبل از مقدار نمایش داده می شود.",
            suffix: "یک یا چند نماد بعد از مقدار نمایش داده می شود."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "عنوان",
            title: "اگر خالی باشد مانند نام درج می شود"
        },
        multiSelect: "اجازه دادن به چند گزینش",
        showLabel: "نمایش زیرنویسهای تصویر",
        swapOrder: "تعویض سفارش بله و خیر",
        value: "ارزش",
        tabAlign: "ترازبندی زبانه",
        sourceType: "نوع منبع",
        fitToContainer: "مناسب برای ظرف",
        setValueExpression: "تنظیم عبارت مقدار",
        description: "توضیحات",
        logoFit: "لوگو مناسب است",
        pages: "صفحات",
        questions: "سوالات",
        triggers: "فعال سازی",
        calculatedValues: "مقادیر محاسبه شده",
        surveyId: "شناسه نظرسنجی",
        surveyPostId: "شناسه نظرسنجی",
        surveyShowDataSaving: "نظرسنجی نشان می دهد صرفه جویی در داده ها",
        questionDescriptionLocation: "توضیحات سوال محل",
        progressBarType: "نوع نوار پیشرفت",
        showTOC: "نمایش TOC",
        tocLocation: "محل Toc",
        questionTitlePattern: "الگوی عنوان سوال",
        widthMode: "حالت عرض",
        showBrandInfo: "نمایش اطلاعات برند",
        useDisplayValuesInDynamicTexts: "استفاده از مقادیر نمایش در متون پویا",
        visibleIf: "آشکار اگر",
        defaultValueExpression: "عبارت مقدار پیشفرض",
        requiredIf: "اجبار اگر؟",
        resetValueIf: "بازنشانی مقدار اگر",
        setValueIf: "تنظیم مقدار اگر",
        validators: "اعتبارسنج ها",
        bindings: "پیوندها",
        renderAs: "Render به عنوان",
        attachOriginalItems: "پیوست موارد اصلی",
        choices: "گزینه ها",
        choicesByUrl: "گزینه ها با لینک",
        currency: "ارز",
        cellHint: "راهنمایی سلول",
        totalMaximumFractionDigits: "مجموع رقم کسری بیشینه",
        totalMinimumFractionDigits: "مجموع حداقل رقم کسری",
        columns: "ستون ها",
        detailElements: "عناصر جزئیات",
        allowAdaptiveActions: "اجازه دادن به کنشهای انطباقی",
        defaultRowValue: "مقدار پیش فرض سطر",
        detailPanelShowOnAdding: "پانل جزئیات در اضافه کردن نشان می دهد",
        choicesLazyLoadEnabled: "انتخاب بار تنبل فعال است",
        choicesLazyLoadPageSize: "انتخاب تنبل بار اندازه صفحه",
        inputFieldComponent: "مؤلفه فیلد ورودی",
        itemComponent: "مؤلفۀ مورد",
        min: "دقیقه",
        max: "حداکثر",
        minValueExpression: "بیان مقدار مین",
        maxValueExpression: "عبارت بیشینه مقدار",
        step: "گام",
        dataList: "لیست داده ها",
        itemSize: "ابعاد مورد",
        itemTitleWidth: "عرض برچسب مورد (در پیکسل)",
        elements: "عناصر",
        content: "محتوای",
        navigationButtonsVisibility: "پدیداری دکمه های ناوبری",
        navigationTitle: "عنوان ناوش",
        navigationDescription: "توضیحات ناوبری",
        longTap: "ضربه طولانی",
        autoGrow: "رشد خودکار",
        allowResize: "اجازه دادن به تغییر اندازه",
        acceptCarriageReturn: "پذیرش بازگشت کالسکه",
        displayMode: "حالت نمایش",
        rateType: "نوع نرخ",
        label: "برچسب",
        contentMode: "حالت محتوا",
        imageFit: "متناسب با تصویر",
        altText: "متن دگرساز",
        height: "ارتفاع",
        penColor: "رنگ قلم",
        backgroundColor: "رنگ پسزمینه",
        templateElements: "عناصر قالب",
        operator: "اپراتور",
        isVariable: "متغیر است",
        runExpression: "اجرای عبارت",
        showCaption: "نمایش عنوان",
        iconName: "نام شمایل",
        iconSize: "اندازه شمایل",
        precision: "دقت",
        matrixDragHandleArea: "ماتریکس منطقه دسته کشیدن",
        backgroundImage: "تصویر زمینه",
        backgroundImageFit: "مناسبسازی تصویر پسزمینه",
        backgroundImageAttachment: "پیوست تصویر پسزمینه",
        backgroundOpacity: "تاری پسزمینه",
        selectToRankEnabled: "انتخاب برای رتبه فعال",
        selectToRankAreasLayout: "انتخاب برای رتبه بندی طرح مناطق",
        selectToRankEmptyRankedAreaText: "متن برای نشان دادن اینکه ایا همه گزینهها انتخاب شدهاند",
        selectToRankEmptyUnrankedAreaText: "متن نگهدارنده برای منطقه رتبه بندی",
        allowCameraAccess: "اجازه دسترسی به دوربین",
        scaleColorMode: "مقیاس حالت رنگ",
        rateColorMode: "نرخ حالت رنگ",
        copyDisplayValue: "رونوشت مقدار نمایش",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "حالت پیشرفته",
        pageTitle: "قلم عنوان صفحه",
        questionTitle: "قلم عنوان پرسش",
        editorPanel: "عنصر ورودی",
        lines: "خطوط",
        primaryDefaultColor: "پیش فرض",
        primaryDarkColor: "شناور",
        primaryLightColor: "انتخاب",
        backgroundDimColor: "رنگ پسزمینه",
        cornerRadius: "شعاع گوشه",
        backcolor: "پسزمینۀ پیشفرض",
        hovercolor: "پسزمینه شناور",
        borderDecoration: "دکوراسیون مرزی",
        fontColor: "رنگ قلم",
        backgroundColor: "رنگ پسزمینه",
        primaryForecolor: "رنگ پیشفرض",
        primaryForecolorLight: "رنگ غیرفعال",
        font: "فونت",
        borderDefault: "تیره تر",
        borderLight: "سبکتر",
        fontFamily: "خانواده قلم",
        fontWeightRegular: "منظم",
        fontWeightHeavy: "سنگین",
        fontWeightSemiBold: "نیمه جسورانه",
        fontWeightBold: "جسورانه",
        color: "رنگ",
        placeholderColor: "رنگ نگهدارنده",
        size: "اندازه",
        opacity: "کدورت",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "افزودن جلوهی سایه",
        boxShadowBlur: "تیرگی",
        boxShadowSpread: "گسترش",
        boxShadowDrop: "قطره",
        boxShadowInner: "درونی",
        names: {
            default: "پیش فرض",
            sharp: "تیز",
            borderless: "مرز",
            flat: "تخت",
            plain: "ساده",
            doubleborder: "دو لبه",
            layered: "لایه",
            solid: "جامد",
            threedimensional: ".3D",
            contrast: "کنتراست"
        },
        colors: {
            teal: "تیل",
            blue: "آبی",
            purple: "بنفش",
            orchid: "ارکیده",
            tulip: "لاله",
            brown: "قهوه ای",
            green: "سبز"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["fa"] = persianStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// qt.tagbox: "Multi-Select Dropdown" => "چند انتخاب کشویی"
// ed.surveySettings: "Survey Settings" => "تنظیمات نظرسنجی"
// ed.surveySettingsTooltip: "Open survey settings" => "باز کردن تنظیمات نظرسنجی"
// ed.themeSurvey: "Themes" => "تم"
// ed.toolboxChoiceCategory: "Choice Questions" => "سوالات انتخاب"
// ed.toolboxTextCategory: "Text Input Questions" => "سوالات ورودی متن"
// ed.toolboxContainersCategory: "Containers" => "ظروف"
// ed.toolboxMatrixCategory: "Matrix Questions" => "سوالات ماتریکس"
// ed.toolboxMiscCategory: "Misc" => "متفرقه"
// ed.themePropertyGridTitle: "Theme Settings" => "تنظیمات تم"
// ed.themeExportButton: "Export" => "صادرات"
// ed.themeImportButton: "Import" => "واردات"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "انتخاب ها کپی می شوند از"
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "یک تصویر را در اینجا بکشید و رها کنید یا روی دکمه زیر کلیک کنید و تصویری را برای اپلود انتخاب کنید"
// ed.imageChooseImage: "Choose Image" => "انتخاب تصویر"
// ed.auto: "auto" => "خودکار"
// ed.choices_Item: "Item " => "مورد "
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "ارزش سوال روشن: {0}"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "قوانین منطقی ناقص هستند"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "شما برخی از قوانین منطقی را تکمیل نکرده اید. اگر اکنون برگه را ترک کنید، تغییرات از بین خواهند رفت. ایا هنوز هم می خواهید برگه را بدون تکمیل تغییرات ترک کنید؟"
// lg.uncompletedRule_apply: "Yes" => "بله"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "نه، من می خواهم قوانین را تکمیل کنم"
// pe.clear: "Clear" => "روشن"
// pe.set: "Set" => "مجموعه"
// pe.change: "Change" => "تغییر"
// pe.removeItem: "Click to remove the item..." => "فشار دهید تا مورد حذف شود..."
// pe.dragItem: "Drag the item" => "مورد را بکشید"
// pe.doneEditing: "Done" => "انجام"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "مقدار {0}» منحصر به فرد نیست"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "لطفا تعداد موارد را از {0} به {1} محدود کنید"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "شما می توانید داده ها را در قالب زیر تنظیم کنید:\nvalue1|متن\nارزش 2"
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "پیش نمایش پاسخ قبل از ارسال نظرسنجی"
// pe.overridingPropertyPrefix: "Set by " => "تنظیم بر اساس "
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "از کلمات رزرو شده استفاده نکنید: \"item\"، \"choice\"، \"panel\"، \"row\"."
// pe.listIsEmpty@choices: "No choices have been added yet" => "هنوز هیچ انتخابی اضافه نشده است"
// pe.addNew@choices: "Add a choice" => "اضافه کردن یک انتخاب"
// choicesbyurl.valueName: "Get values from the following JSON field" => "دریافت مقادیر از فیلد JSON زیر"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "URL های تصویر را از فیلد JSON زیر دریافت کنید"
// pe.allowEmptyResponse: "Allow empty response" => "اجازه دادن پاسخ خالی"
// pe.and: "and" => "و"
// pe.or: "or" => "یا"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "یک سؤال برای شروع پیکربندی شرایط انتخاب کنید."
// pe.if: "If" => "اگر"
// pe.then: "then" => "سپس"
// pe.setToName: "Target question" => "سوال هدف"
// pe.fromName: "Question to copy answer from" => "سوال برای کپی کردن پاسخ از"
// pe.gotoName: "Question to skip to" => "سؤال برای پرش به"
// pe.ruleIsNotSet: "Rule is incorrect" => "قانون نادرست است"
// pe.includeIntoResult: "Include into survey results" => "شامل نتایج نظرسنجی"
// pe.portraitOrientation: "Switch to portrait orientation" => "تغییر جهت به جهت تصویر"
// image.imageHeight: "Image height (in CSS-accepted values)" => "ارتفاع تصویر (در مقادیر پذیرفته شده توسط CSS)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "عرض تصویر) در مقادیر پذیرفته شده CSS ("
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "محدودیت زمانی برای تمام کردن صفحه (به ثانیه)"
// question.page: "Parent page" => "صفحه اصلی"
// pe.noEntriesText: "Empty entries text" => "متن مدخلهای خالی"
// pe.setValue: "Answer" => "پاسخ"
// pe.dataFormat: "Image format" => "قالب تصویر"
// pe.allowAddRows: "Allow adding rows" => "اجازه اضافه کردن سطرها"
// pe.allowRemoveRows: "Allow removing rows" => "اجازه حذف سطرها"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "اجازه دادن به کشیدن و رها کردن ردیف"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "اگر عرض یا ارتفاع تصویر دقیق را مشخص کنید اعمال نمی شود."
// pe.minImageWidth: "Minimum image width" => "حداقل عرض تصویر"
// pe.maxImageWidth: "Maximum image width" => "حداکثر عرض تصویر"
// pe.minImageHeight: "Minimum image height" => "حداقل ارتفاع تصویر"
// pe.maxImageHeight: "Maximum image height" => "حداکثر ارتفاع تصویر"
// surveyvalidator.text: "Error message" => "پیام خطا"
// surveyvalidator.expression: "Validation expression" => "عبارت اعتبارسنجی"
// pe.logo: "Logo (URL or base64-encoded string)" => "لوگو (URL یا رشته کدگذاری شده base64)"
// pe.questionsOnPageMode: "Survey structure" => "ساختار نظرسنجی"
// pe.maxTextLength: "Maximum answer length (in characters)" => "حداکثر طول پاسخ (در کاراکترها)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "حداکثر طول توضیحات (در نویسهها)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "گسترش خودکار منطقه نظر در صورت لزوم"
// pe.allowResizeComment: "Allow users to resize text areas" => "اجازه دادن به کاربران برای تغییر اندازه مناطق متن"
// pe.textUpdateMode: "Update text question value" => "بههنگامسازی مقدار سؤال متن"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "تنظیم تمرکز روی اولین پاسخ نامعتبر"
// pe.checkErrorsMode: "Run validation" => "اجرای اعتبارسنجی"
// pe.navigateToUrl: "Navigate to URL" => "حرکت به نشانی وب"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "نشانی وب پویا"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "نشانهگذاری برای نشان دادن اینکه ایا کاربر قبلا این بررسی را پر کرده است"
// pe.completedHtml: "Survey Complete page markup" => "بررسی نشانه گذاری صفحه کامل"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "بررسی دینامیکی نشانه گذاری صفحه کامل"
// pe.loadingHtml: "Markup to show while survey model is loading" => "نشانه گذاری برای نشان دادن در حالی که مدل بررسی در حال بارگذاری است"
// pe.commentText: "Comment area text" => "متن ناحیه نظر"
// pe.autocomplete: "Autocomplete type" => "نوع تکمیل خودکار"
// pe.labelTrue: "\"True\" label" => "برچسب \"True\""
// pe.labelFalse: "\"False\" label" => "برچسب \"غلط\""
// pe.allowClear: "Show the Clear button" => "نشان دادن دکمهی Clear"
// pe.displayStyle: "Value display style" => "سبک نمایش ارزش"
// pe.format: "Formatted string" => "رشتۀ قالببندی شده"
// pe.maximumFractionDigits: "Maximum fractional digits" => "بیشینه رقم کسری"
// pe.minimumFractionDigits: "Minimum fractional digits" => "حداقل رقم کسری"
// pe.useGrouping: "Display grouping separators" => "نمایش جداسازهای گروهبندی"
// pe.allowMultiple: "Allow multiple files" => "اجازه دادن به چندین پرونده"
// pe.allowImagesPreview: "Preview images" => "پیشنمایش تصاویر"
// pe.acceptedTypes: "Accepted file types" => "انواع فایل های پذیرفته شده"
// pe.waitForUpload: "Wait for the upload to complete" => "منتظر بمانید تا بارگذاری کامل شود"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "تایید حذف پرونده"
// pe.detailPanelMode: "Detail panel location" => "جزئیات محل پانل"
// pe.minRowCount: "Minimum row count" => "حداقل تعداد سطرها"
// pe.maxRowCount: "Maximum row count" => "حداکثر تعداد سطرها"
// pe.confirmDelete: "Confirm row deletion" => "تایید حذف سطر"
// pe.confirmDeleteText: "Confirmation message" => "پیام تایید"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "تایید حذف پانل"
// pe.panelCount: "Initial panel count" => "شمارش اولیه پانل"
// pe.minPanelCount: "Minimum panel count" => "حداقل تعداد پانل"
// pe.maxPanelCount: "Maximum panel count" => "حداکثر تعداد پانل"
// pe.panelsState: "Inner panel expand state" => "پانل داخلی گسترش دولت"
// pe.templateDescription: "Description template" => "قالب شرح"
// pe.templateTitle: "Title template" => "قالب عنوان"
// pe.panelPrevText: "Previous Panel button tooltip" => "قبلی دکمه پنل tooltip"
// pe.panelNextText: "Next Panel button tooltip" => "بعدی دکمه پنل tooltip"
// pe.showRangeInProgress: "Show progress bar" => "نمایش نوار پیشرفت"
// pe.templateTitleLocation: "Question title location" => "عنوان سوال محل"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "حذف محل دکمه پنل"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "مخفی کردن سؤال اگر سطری وجود نداشته باشد"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "مخفی کردن ستونها اگر سطری وجود نداشته باشد"
// pe.rateValues: "Custom rate values" => "مقادیر نرخ سفارشی"
// pe.rateCount: "Rate count" => "شمارش نرخ"
// pe.autoGenerate: "How to specify rate values?" => "چگونه مقادیر نرخ را مشخص کنیم؟"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "مخفی کردن سؤال در صورتی که هیچ انتخابی نداشته باشد"
// pe.hideNumber: "Hide question number" => "مخفی کردن شمارۀ سؤال"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "حداقل عرض (در مقادیر پذیرفته شده CSS)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "حداکثر عرض (در مقادیر پذیرفته شده CSS)"
// pe.width: "Width (in CSS-accepted values)" => "عرض (در مقادیر پذیرفته شده CSS)"
// pe.showHeader: "Show column headers" => "نمایش سرایندهای ستون"
// pe.horizontalScroll: "Show horizontal scrollbar" => "نمایش میله لغزش افقی"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "اس"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "عرض سرصفحه سطر) در مقادیر پذیرفته شده CSS ("
// pe.valueTrue: "\"True\" value" => "مقدار » درست"
// pe.valueFalse: "\"False\" value" => "مقدار » نادرست"
// pe.minErrorText: "\"Value is below minimum\" error message" => "پیام خطای \"مقدار کمتر از حداقل است\""
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "\"مقدار بیش از حداکثر\" پیام خطا"
// pe.otherErrorText: "\"Empty comment\" error message" => "پیام خطای \"نظر خالی\""
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "پیام خطای \"مقدار کلید غیر منحصر به فرد\""
// pe.minSelectedChoices: "Minimum selected choices" => "حداقل انتخاب های انتخاب شده"
// pe.maxSelectedChoices: "Maximum selected choices" => "حداکثر انتخابهای انتخاب شده"
// pe.showClearButton: "Show the Clear button" => "نشان دادن دکمهی Clear"
// pe.showNumber: "Show panel number" => "نمایش شماره پانل"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "عرض لوگو (در مقادیر پذیرفته شده CSS)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "ارتفاع لوگو (در مقادیر پذیرفته شده CSS)"
// pe.readOnly: "Read-only" => "فقط خواندنی"
// pe.enableIf: "Editable if" => "قابل ویرایش اگر"
// pe.emptyRowsText: "\"No rows\" message" => "پیام \"بدون ردیف\""
// pe.size: "Input field size (in characters)" => "اندازه فیلد ورودی (در نویسه ها)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "انتخاب های ویژه جداگانه (هیچ کدام، دیگر، همه را انتخاب کنید)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "کپی کردن انتخابها از سؤال زیر"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "کدام گزینه ها را کپی کنید؟"
// pe.showCommentArea: "Show the comment area" => "نمایش ناحیهی نظرات"
// pe.commentPlaceholder: "Comment area placeholder" => "ذی نفع منطقه نظر"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "نمایش توضیحات نرخ به عنوان مقادیر شدید"
// pe.rowsOrder: "Row order" => "سفارش ردیف"
// pe.columnsLayout: "Column layout" => "طرحبندی ستون"
// pe.columnColCount: "Nested column count" => "تعداد ستون های تو در تو"
// pe.state: "Panel expand state" => "پنل گسترش دولت"
// pe.correctAnswer: "Correct Answer" => "پاسخ صحیح"
// pe.defaultPanelValue: "Default Values" => "مقادیر پیشفرض"
// pe.cells: "Cell Texts" => "متن سلولی"
// pe.keyName: "Key column" => "ستون کلید"
// itemvalue.text: "Alt text" => "متن دگرساز"
// tabs.expression: "Expression" => "بیان"
// pe.choicesVisibleIf: "Choices are visible if" => "انتخاب ها قابل مشاهده هستند اگر"
// pe.choicesEnableIf: "Choices are selectable if" => "انتخاب ها قابل انتخاب هستند اگر"
// pe.columnsEnableIf: "Columns are visible if" => "ستونها مرئی هستند اگر"
// pe.rowsEnableIf: "Rows are visible if" => "سطرها مرئی هستند اگر"
// pe.indent: "Add indents" => "افزودن تورفتهای"
// panel.indent: "Add outer indents" => "اضافه کردن تورفتات بیرونی"
// pe.innerIndent: "Add inner indents" => "اضافه کردن تورفتات داخلی"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "گرفتن مقادیر پیشفرض از اخرین سطر"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "گرفتن مقادیر پیشفرض از اخرین تابلو"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "عبارت را در اینجا تایپ کنید..."
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "پاک کردن مقدار اگر سؤال مخفی شود"
// pe.valuePropertyName: "Value property name" => "ارزش نام ملک"
// pe.searchEnabled: "Enable search" => "فعالسازی جستجو"
// pe.hideSelectedItems: "Hide selected items" => "مخفی کردن فقرههای انتخاب شده"
// pe.closeOnSelect: "Close the dropdown after selection" => "بستن کشویی پس از انتخاب"
// pe.signatureWidth: "Signature width" => "عرض امضا"
// pe.signatureHeight: "Signature height" => "ارتفاع امضا"
// pe.verticalAlign: "Vertical alignment" => "تراز عمودی"
// pe.alternateRows: "Alternate rows" => "ردیفهای جایگزین"
// pe.columnsVisibleIf: "Columns are visible if" => "ستونها مرئی هستند اگر"
// pe.rowsVisibleIf: "Rows are visible if" => "سطرها مرئی هستند اگر"
// pe.otherPlaceholder: "Comment area placeholder" => "ذی نفع منطقه نظر"
// pe.rateType: "Rate type" => "نوع نرخ"
// pv.true: "true" => "واقعی"
// pv.false: "false" => "نادرست"
// pv.decimal: "decimal" => "اعشاری"
// pv.currency: "currency" => "ارز"
// pv.percent: "percent" => "درصد"
// pv.onpanel: "Start on each panel" => "شروع در هر پنل"
// pv.tab: "Tabs" => "زبانه"
// pv.right: "Right" => "راست"
// pv.color: "color" => "رنگ"
// pv.date: "date" => "تاریخ"
// pv.datetime: "datetime" => "تاریخ"
// pv.datetime-local: "datetime-local" => "تاریخ محلی"
// pv.email: "email" => "ایمیل"
// pv.month: "month" => "ماه"
// pv.number: "number" => "شماره"
// pv.password: "password" => "رمز عبور"
// pv.range: "range" => "محدوده"
// pv.tel: "tel" => "تلفن"
// pv.text: "text" => "پیامک"
// pv.time: "time" => "زمان"
// pv.url: "url" => "آدرس"
// pv.week: "week" => "هفته"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "هنگامی که سوال یا پانل / صفحه ان پنهان می شود"
// clearInvisibleValues.none: "Never" => "هرگز"
// inputType.color: "Color" => "رنگ"
// inputType.date: "Date" => "تاریخ"
// inputType.datetime-local: "Date and Time" => "تاریخ و زمان"
// inputType.email: "Email" => "ایمیل"
// inputType.month: "Month" => "ماه"
// inputType.number: "Number" => "شماره"
// inputType.password: "Password" => "رمز عبور"
// inputType.range: "Range" => "محدوده"
// inputType.tel: "Phone Number" => "شماره تماس"
// inputType.text: "Text" => "پیامک"
// inputType.time: "Time" => "زمان"
// inputType.url: "URL" => "آدرس"
// inputType.week: "Week" => "هفته"
// pv.onValueChanging: "Before an answer is changed" => "قبل از اینکه پاسخ تغییر کند"
// pv.pages: "Completed pages" => "صفحات تکمیل شده"
// pv.questions: "Answered questions" => "سوالات پاسخ داده شده"
// pv.requiredQuestions: "Answered required questions" => "پاسخ به سوالات مورد نیاز"
// pv.correctQuestions: "Valid answers" => "پاسخ های معتبر"
// pv.buttons: "Completed pages (button UI)" => "صفحات تکمیل شده(دکمه UI)"
// pv.underInput: "Under the input" => "زیر ورودی"
// pv.underTitle: "Under the title" => "تحت عنوان"
// pv.onBlur: "On blur" => "در تاری"
// pv.onTyping: "While typing" => "هنگام تایپ"
// pv.underRow: "Under the row" => "زیر ردیف"
// pv.underRowSingle: "Under the row, only one panel is visible" => "در زیر ردیف، تنها یک پانل قابل مشاهده است"
// showNavigationButtons.none: "Hidden" => "پنهان"
// showProgressBar.off: "Hidden" => "پنهان"
// showTimerPanel.none: "Hidden" => "پنهان"
// showTimerPanelMode.all: "Both" => "هر دو"
// detailPanelMode.none: "Hidden" => "پنهان"
// addRowLocation.default: "Depends on matrix layout" => "بستگی به طرح ماتریس دارد"
// panelsState.default: "Users cannot expand or collapse panels" => "کاربران نمی توانند پانل ها را گسترش یا سقوط کنند"
// panelsState.collapsed: "All panels are collapsed" => "تمام پانل ها سقوط می کنند"
// panelsState.expanded: "All panels are expanded" => "تمام پانل ها گسترش یافته اند"
// widthMode.auto: "Auto" => "خودکار"
// widthMode.static: "Static" => "استاتیک"
// widthMode.responsive: "Responsive" => "پاسخگو"
// imageFit.none: "None" => "هیچ کدام"
// imageFit.contain: "Contain" => "حاوی"
// imageFit.cover: "Cover" => "پوشش"
// imageFit.fill: "Fill" => "پر کردن"
// contentMode.auto: "Auto" => "خودکار"
// contentMode.image: "Image" => "تصویر"
// contentMode.video: "Video" => "ویدئو"
// contentMode.youtube: "YouTube" => "Youtube"
// displayMode.auto: "Auto" => "خودکار"
// displayMode.buttons: "Buttons" => "دکمه"
// displayMode.dropdown: "Dropdown" => "کشویی"
// rateColorMode.default: "Default" => "پیش فرض"
// autoGenerate.true: "Generate" => "تولید"
// autoGenerate.false: "Enter manually" => "به صورت دستی وارد کنید"
// rateType.labels: "Labels" => "برچسب"
// rateType.stars: "Stars" => "ستاره"
// rateType.smileys: "Smileys" => "صورتک"
// op.and: "and" => "و"
// op.or: "or" => "یا"
// ts.hideInvisibleElements: "Hide invisible elements" => "مخفی کردن عناصر نامرئی"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "کوکی ها کاربران را از پر کردن همان نظرسنجی دو بار جلوگیری می کند."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "منطقه قابل مشاهده میدان ورودی را تغییر اندازه می دهد. لطفا از <b>تنظیم حداکثر طول → اعتبار سنجی</b> برای محدود کردن طول ورودی استفاده کنید."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "از {0} به عنوان نگهدارنده برای ارزش واقعی استفاده کنید."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "تنها زمانی قابل مشاهده است که حداقل یک ستون دارای عبارت Total type یا Total باشد."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "برای اطلاعات بیشتر به [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description مراجعه کنید."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "فقط برای انواع سلول های Radiogroup و Checkbox قابل اجرا است."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "برای اطلاعات بیشتر به شرح ویژگی [autocomplete] (https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) مراجعه کنید."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "اگر این ویژگی را تنظیم نکنید، پاسخ در زمینه ای که توسط ویژگی Name مشخص شده است ذخیره می شود."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "اگر ستون مشخص شده حاوی مقادیر یکسان باشد، نظرسنجی خطای \"مقدار کلیدی غیر منحصر به فرد\" را پرتاب می کند."
// p.multiSelect: "Allow multiple selection" => "اجازه دادن به چند گزینش"
// p.showLabel: "Show image captions" => "نمایش زیرنویسهای تصویر"
// p.value: "Value" => "ارزش"
// p.tabAlign: "Tab alignment" => "ترازبندی زبانه"
// p.logoFit: "Logo fit" => "لوگو مناسب است"
// p.pages: "Pages" => "صفحات"
// p.questions: "Questions" => "سوالات"
// p.calculatedValues: "Calculated values" => "مقادیر محاسبه شده"
// p.surveyId: "Survey id" => "شناسه نظرسنجی"
// p.surveyPostId: "Survey post id" => "شناسه نظرسنجی"
// p.surveyShowDataSaving: "Survey show data saving" => "نظرسنجی نشان می دهد صرفه جویی در داده ها"
// p.questionDescriptionLocation: "Question description location" => "توضیحات سوال محل"
// p.progressBarType: "Progress bar type" => "نوع نوار پیشرفت"
// p.showTOC: "Show TOC" => "نمایش TOC"
// p.tocLocation: "Toc location" => "محل Toc"
// p.questionTitlePattern: "Question title pattern" => "الگوی عنوان سوال"
// p.widthMode: "Width mode" => "حالت عرض"
// p.showBrandInfo: "Show brand info" => "نمایش اطلاعات برند"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "استفاده از مقادیر نمایش در متون پویا"
// p.descriptionLocation: "Description location" => "شرح محل"
// p.defaultValueExpression: "Default value expression" => "عبارت مقدار پیشفرض"
// p.bindings: "Bindings" => "پیوندها"
// p.renderAs: "Render as" => "Render به عنوان"
// p.attachOriginalItems: "Attach original items" => "پیوست موارد اصلی"
// p.cellHint: "Cell hint" => "راهنمایی سلول"
// p.isUnique: "Is unique" => "منحصر به فرد است"
// p.showInMultipleColumns: "Show in multiple columns" => "نمایش در ستونهای چندگانه"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "مجموع رقم کسری بیشینه"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "مجموع حداقل رقم کسری"
// p.detailElements: "Detail elements" => "عناصر جزئیات"
// p.allowAdaptiveActions: "Allow adaptive actions" => "اجازه دادن به کنشهای انطباقی"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "پانل جزئیات در اضافه کردن نشان می دهد"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "انتخاب بار تنبل فعال است"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "انتخاب تنبل بار اندازه صفحه"
// p.inputFieldComponent: "Input field component" => "مؤلفه فیلد ورودی"
// p.itemComponent: "Item component" => "مؤلفۀ مورد"
// p.min: "Min" => "دقیقه"
// p.max: "Max" => "حداکثر"
// p.minValueExpression: "Min value expression" => "بیان مقدار مین"
// p.maxValueExpression: "Max value expression" => "عبارت بیشینه مقدار"
// p.step: "Step" => "گام"
// p.dataList: "Data list" => "لیست داده ها"
// p.elements: "Elements" => "عناصر"
// p.content: "Content" => "محتوای"
// p.navigationTitle: "Navigation title" => "عنوان ناوش"
// p.navigationDescription: "Navigation description" => "توضیحات ناوبری"
// p.longTap: "Long tap" => "ضربه طولانی"
// p.autoGrow: "Auto grow" => "رشد خودکار"
// p.allowResize: "Allow resizing" => "اجازه دادن به تغییر اندازه"
// p.acceptCarriageReturn: "Accept carriage return" => "پذیرش بازگشت کالسکه"
// p.displayMode: "Display mode" => "حالت نمایش"
// p.rateType: "Rate type" => "نوع نرخ"
// p.contentMode: "Content mode" => "حالت محتوا"
// p.imageFit: "Image fit" => "متناسب با تصویر"
// p.altText: "Alt text" => "متن دگرساز"
// p.height: "Height" => "ارتفاع"
// p.penColor: "Pen color" => "رنگ قلم"
// p.backgroundColor: "Background color" => "رنگ پسزمینه"
// p.templateElements: "Template elements" => "عناصر قالب"
// p.operator: "Operator" => "اپراتور"
// p.isVariable: "Is variable" => "متغیر است"
// p.runExpression: "Run expression" => "اجرای عبارت"
// p.showCaption: "Show caption" => "نمایش عنوان"
// p.iconName: "Icon name" => "نام شمایل"
// p.iconSize: "Icon size" => "اندازه شمایل"
// p.precision: "Precision" => "دقت"
// p.matrixDragHandleArea: "Matrix drag handle area" => "ماتریکس منطقه دسته کشیدن"
// p.backgroundImage: "Background image" => "تصویر زمینه"
// p.backgroundImageFit: "Background image fit" => "مناسبسازی تصویر پسزمینه"
// p.backgroundImageAttachment: "Background image attachment" => "پیوست تصویر پسزمینه"
// p.backgroundOpacity: "Background opacity" => "تاری پسزمینه"
// p.selectToRankEnabled: "Select to rank enabled" => "انتخاب برای رتبه فعال"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "انتخاب برای رتبه بندی طرح مناطق"
// p.allowCameraAccess: "Allow camera access" => "اجازه دسترسی به دوربین"
// p.scaleColorMode: "Scale color mode" => "مقیاس حالت رنگ"
// p.rateColorMode: "Rate color mode" => "نرخ حالت رنگ"
// p.templateTabTitle: "Template tab title" => "عنوان زبانه قالب"
// p.templateVisibleIf: "Template visible if" => "قالب مرئی اگر"
// p.copyDisplayValue: "Copy display value" => "رونوشت مقدار نمایش"
// theme.--background: "Background color" => "رنگ پسزمینه"
// theme.--background-dim-light: "Background dim light color" => "پس زمینه رنگ نور کم"
// theme.--primary-foreground: "Primary foreground color" => "رنگ پیشزمینه اصلی"
// theme.--foreground: "Foreground color" => "رنگ پیشزمینه"
// theme.--base-unit: "Base unit" => "واحد پایه"
// theme.groupAdvanced: "Advanced" => "پیشرفته"
// theme.themeName: "Theme" => "تم"
// theme.isPanellessss: "Question appearance" => "ظاهر سوال"
// theme.isPanellessPanels: "Default" => "پیش فرض"
// theme.isPanellessLightweight: "Without Panels" => "بدون پانل"
// theme.themePaletteLight: "Light" => "نور"
// theme.themePaletteDark: "Dark" => "تاریک"
// theme.primaryColor: "Accent color" => "رنگ لهجه"
// theme.primaryDefaultColor: "Default" => "پیش فرض"
// theme.primaryDarkColor: "Hover" => "شناور"
// theme.primaryLightColor: "Selected" => "انتخاب"
// theme.backgroundDimColor: "Background color" => "رنگ پسزمینه"
// theme.backgroundImage: "Background image" => "تصویر زمینه"
// theme.backgroundImageFitAuto: "Auto" => "خودکار"
// theme.backgroundImageFitCover: "Cover" => "پوشش"
// theme.backgroundImageFitContain: "Contain" => "حاوی"
// theme.backgroundOpacity: "Opacity" => "کدورت"
// theme.backgroundImageAttachmentFixed: "Fixed" => "ثابت"
// theme.backgroundImageAttachmentScroll: "Scroll" => "حرکت"
// theme.panelBackgroundTransparency: "Panel background opacity" => "تاری پسزمینه پانل"
// theme.questionBackgroundTransparency: "Question background opacity" => "تاری پسزمینۀ سؤال"
// theme.questionPanel: "Panel background and corner radius" => "پس زمینه پنل و شعاع گوشه"
// theme.questionTitle: "Question title font" => "قلم عنوان پرسش"
// theme.questionDescription: "Question description font" => "قلم شرح سؤال"
// theme.editorPanel: "Input element" => "عنصر ورودی"
// theme.editorFont: "Input element font" => "قلم عنصر ورودی"
// theme.backcolor: "Default background" => "پسزمینۀ پیشفرض"
// theme.hovercolor: "Hover background" => "پسزمینه شناور"
// theme.borderDecoration: "Border decoration" => "دکوراسیون مرزی"
// theme.accentBackground: "Accent background" => "پسزمینۀ لهجه"
// theme.accentForeground: "Accent foreground" => "پیشزمینه لهجه"
// theme.primaryForecolor: "Default color" => "رنگ پیشفرض"
// theme.primaryForecolorLight: "Disabled color" => "رنگ غیرفعال"
// theme.linesColors: "Minor line colors" => "رنگهای خط فرعی"
// theme.borderDefault: "Darker" => "تیره تر"
// theme.borderLight: "Lighter" => "سبکتر"
// theme.fontFamily: "Font family" => "خانواده قلم"
// theme.fontSize: "Font size" => "اندازه قلم"
// theme.color: "Color" => "رنگ"
// theme.size: "Size" => "اندازه"
// theme.fontWeightRegular: "Regular" => "منظم"
// theme.fontWeightHeavy: "Heavy" => "سنگین"
// theme.fontWeightSemiBold: "Semi-bold" => "نیمه جسورانه"
// theme.fontWeightBold: "Bold" => "جسورانه"
// theme.scale: "Scale" => "مقیاس"
// theme.cornerRadius: "Corner radius" => "شعاع گوشه"
// theme.surveyTitleFont: "Survey title font" => "قلم عنوان نظرسنجی"
// theme.pageTitle: "Page title font" => "قلم عنوان صفحه"
// theme.pageDescription: "Page description font" => "قلم توصیف صفحه"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "افزودن جلوهی سایه"
// theme.opacity: "Opacity" => "کدورت"
// theme.boxShadowBlur: "Blur" => "تیرگی"
// theme.boxShadowSpread: "Spread" => "گسترش"
// theme.boxShadowDrop: "Drop" => "قطره"
// theme.boxShadowInner: "Inner" => "درونی"
// theme.questionShadow: "Shadow effects" => "جلوه های سایه"
// theme.editorShadow: "Input element shadow effects" => "عناصر ورودی اثرات سایه"
// names.default: "Default" => "پیش فرض"
// names.contrast: "Contrast" => "کنتراست"
// names.plain: "Plain" => "ساده"
// names.simple: "Simple" => "ساده"
// names.blank: "Blank" => "خالی"
// names.double: "Double" => "دو"
// names.bulk: "Bulk" => "فله"
// names.pseudo-3d: "Pseudo 3D" => "شبه 3D"
// names.playful: "Playful" => "بازیگوش"
// names.ultra: "Ultra" => "فوق العاده"
// colors.teal: "Teal" => "تیل"
// colors.blue: "Blue" => "آبی"
// colors.purple: "Purple" => "بنفش"
// colors.orchid: "Orchid" => "ارکیده"
// colors.tulip: "Tulip" => "لاله"
// colors.brown: "Brown" => "قهوه ای"
// colors.green: "Green" => "سبز"
// names.sharp: "Sharp" => "تیز"
// names.borderless: "Borderless" => "مرز"
// names.flat: "Flat" => "تخت"
// names.doubleborder: "Double Border" => "دو لبه"
// names.layered: "Layered" => "لایه"
// names.solid: "Solid" => "جامد"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "ایا مطمئن هستید که می خواهید تمام رشته ها را برای این زبان حذف کنید؟"
// ed.themeResetButton: "Reset theme settings to default" => "بازنشانی تنظیمات تم به حالت پیشفرض"
// theme.placeholderColor: "Placeholder color" => "رنگ نگهدارنده"
// ed.themeSettings: "Theme Settings" => "تنظیمات تم"
// ed.themeSettingsTooltip: "Open theme settings" => "باز کردن تنظیمات تم"
// pe.resetToDefaultCaption: "Reset" => "تنظیم مجدد"
// pv.file: "Local files" => "پروندههای محلی"
// pv.camera: "Camera" => "دوربین"
// pv.file-camera: "Local files or camera" => "فایل های محلی یا دوربین"
// ed.translateUsigAI: "Auto-translate All" => "ترجمه خودکار همه"
// ed.translationDialogTitle: "Untranslated strings" => "رشتههای ترجمهنشده"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "لطفا حداقل {0} مورد را وارد کنید"
// lg.question_resetValueName: "Reset question value" => "بازنشانی مقدار سؤال"
// lg.column_resetValue: "Reset column value" => "بازنشانی مقدار ستون"
// pe.markRequired: "Mark as required" => "علامت گذاری به عنوان مورد نیاز"
// pe.removeRequiredMark: "Remove the required mark" => "حذف علامت مورد نیاز"
// p.resetValueIf: "Reset value if" => "بازنشانی مقدار اگر"
// lg.question_setValueName: "Set question value" => "تنظیم مقدار سؤال"
// lg.column_resetValueName: "Reset column value" => "بازنشانی مقدار ستون"
// lg.column_setValueName: "Set column value" => "تنظیم مقدار ستون"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " یک عبارت که نتیجه ان به سوال هدف اختصاص داده خواهد شد."
// survey.title: "Title" => "عنوان"
// page.title: "Title" => "عنوان"
// p.setValueIf: "Set value if" => "تنظیم مقدار اگر"
// theme.header: "Header" => "هدر"
// theme.backgroundImageFitFill: "Stretch" => "کشش"
// theme.backgroundImageFitTile: "Tile" => "کاشی"
// theme.headerView: "View" => "مشاهده"
// theme.headerViewBasic: "Basic" => "اساسی"
// theme.headerViewAdvanced: "Advanced" => "پیشرفته"
// theme.headerInheritWidthFrom: "Content area width" => "عرض منطقه محتوا"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "همانند نظرسنجی"
// theme.headerInheritWidthFromPage: "Fit to page" => "متناسب با صفحه"
// theme.headerTextAreaWidth: "Text width" => "عرض متن"
// theme.headerBackgroundColorSwitch: "Background color" => "رنگ پسزمینه"
// theme.headerBackgroundColorNone: "None" => "هیچ کدام"
// theme.headerBackgroundColorAccentColor: "Accent color" => "رنگ لهجه"
// theme.headerBackgroundColorCustom: "Custom" => "سفارشی"
// theme.horizontalAlignmentLeft: "Left" => "چپ"
// theme.horizontalAlignmentCenter: "Center" => "مرکز"
// theme.horizontalAlignmentRight: "Right" => "راست"
// theme.verticalAlignmentTop: "Top" => "بالا"
// theme.verticalAlignmentMiddle: "Middle" => "میانه"
// theme.verticalAlignmentBottom: "Bottom" => "پایین"
// lg.question_resetValueText: "reset value for question: {0}" => "بازنشانی مقدار برای سوال: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "اختصاص مقدار: {1} به سوال: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "تنظیم مجدد مقدار سلول برای ستون: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "اختصاص مقدار سلول: {1} به ستون: {0}"
// ed.surveyJsonExportButton: "Export" => "صادرات"
// ed.surveyJsonImportButton: "Import" => "واردات"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "رونوشت در تخته یادداشت"
// pe.filePlaceholder: "File placeholder text" => "متن نگهدارنده پرونده"
// pe.photoPlaceholder: "Photo placeholder text" => "متن نگهدارنده عکس"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "متن جایدار پرونده یا عکس"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "اعمال می شود زمانی که \"نوع منبع\" است \"فایل های محلی\" و یا زمانی که دوربین در دسترس نیست"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "هنگامی که \"نوع منبع\" \"دوربین\" است، اعمال می شود."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "زمانی اعمال می شود که \"نوع منبع\" \"فایل های محلی یا دوربین\" باشد."
// theme.background: "Background" => "پس زمینه"
// theme.appearance: "Appearance" => "ظاهر"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "ایا واقعا می خواهید موضوع را دوباره تنظیم کنید؟ تمام سفارشی سازی های شما از دست خواهد رفت."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "بله، موضوع را تنظیم مجدد کنید"
// theme.headerInheritWidthFromContainer: "Fit to container" => "مناسب برای ظرف"
// signaturepad.showPlaceholder: "Show the placeholder" => "نشان دادن نگهدارندهی مکان"
// signaturepad.placeholder: "Placeholder text" => "متن ذی نفع"
// theme.surveyDescriptionFont: "Survey description font" => "قلم توصیف نظرسنجی"
// ed.prevFocus: "Focus previous" => "تمرکز قبلی"
// ed.nextFocus: "Focus next" => "تمرکز بعدی"
// ed.saveTheme: "Save Theme" => "ذخیرۀ تم"
// ed.saveThemeTooltip: "Save Theme" => "ذخیرۀ تم"
// lg.page_requireName: "Make page required" => "ایجاد صفحه مورد نیاز است"
// lg.panel_requireName: "Make page required" => "ایجاد صفحه مورد نیاز است"
// signaturepad.signatureWidth: "Signature area width" => "عرض منطقه امضا"
// signaturepad.signatureHeight: "Signature area height" => "ارتفاع منطقه امضا"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "مقیاس خودکار منطقه امضا"
// signaturepad.penMinWidth: "Minimum pen width" => "حداقل عرض قلم"
// signaturepad.penMaxWidth: "Maximum pen width" => "حداکثر عرض قلم"
// theme.logoPosition: "Logo position" => "موقعیت لوگو"
// theme.headerTitlePosition: "Title position" => "موقعیت عنوان"
// theme.headerDescriptionPosition: "Description position" => "شرح موقعیت"
// ed.propertyGridNoResultsFound: "No results found" => "نتیجه ای یافت نشد"
// pv.leftRight: "Left and right" => "چپ و راست"
// p.sourceType: "Source type" => "نوع منبع"
// p.fitToContainer: "Fit to container" => "مناسب برای ظرف"
// p.setValueExpression: "Set value expression" => "تنظیم عبارت مقدار"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "انتخاب ها از یک سرویس وب بارگذاری می شوند."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "رفتن به تنظیمات"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "پیش نمایش گزینه های انتخاب بار شده"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "جلوگیری از پاسخ های تکراری در ردیف ها"
// theme.advancedMode: "Advanced mode" => "حالت پیشرفته"
// theme.backgroundCornerRadius: "Background and corner radius" => "پس زمینه و شعاع گوشه"
// theme.colorsTitle: "Colors" => "رنگ"
// theme.font: "Font" => "فونت"
// theme.lines: "Lines" => "خطوط"
// theme.titleFont: "Title font" => "قلم عنوان"
// theme.descriptionFont: "Description font" => "قلم توصیف"
// theme.shadow: "Shadow effects" => "جلوه های سایه"
// ed.translateUsigAIFrom: "Translate from: " => "ترجمه از: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "اجازه دهید گزینه امتناع از پاسخ"
// pe.showDontKnowItem: "Allow the Don't Know option" => "گزینه Don't Know را انتخاب کنید"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "اجازه دهید گزینه امتناع از پاسخ"
// pe.showDontKnowItem: "Allow the Don't Know option" => "گزینه Don't Know را انتخاب کنید"
// pv.contain: "Contain" => "حاوی"
// pv.cover: "Cover" => "پوشش"
// pv.fill: "Fill" => "پر کردن"
// pe.transposeData: "Transpose rows to columns" => "جابهجا کردن سطرها به ستونها"
// layout.panel: "Layout" => "طرح"
// layout.question: "Layout" => "طرح"
// layout.base: "Layout" => "طرح"
// panel.name: "Panel name" => "نام تابلو"
// panel.title: "Panel title" => "عنوان پنل"
// panel.description: "Panel description" => "توضیحات پنل"
// panel.visibleIf: "Make the panel visible if" => "تابلو را مرئی کنید اگر"
// panel.requiredIf: "Make the panel required if" => "ایجاد پنل مورد نیاز اگر"
// panel.questionsOrder: "Question order within the panel" => "سفارش سوال در داخل پنل"
// panel.startWithNewLine: "Display the panel on a new line" => "نمایش تابلو در یک خط جدید"
// panel.state: "Panel collapse state" => "دولت فروپاشی پانل"
// panel.width: "Inline panel width" => "عرض پانل درون خطی"
// panel.minWidth: "Minimum panel width" => "حداقل عرض پانل"
// panel.maxWidth: "Maximum panel width" => "حداکثر عرض پانل"
// panel.showNumber: "Number panels" => "پانل های شماره"
// paneldynamic.name: "Panel name" => "نام تابلو"
// paneldynamic.title: "Panel title" => "عنوان پنل"
// paneldynamic.description: "Panel description" => "توضیحات پنل"
// paneldynamic.visibleIf: "Make the panel visible if" => "تابلو را مرئی کنید اگر"
// paneldynamic.requiredIf: "Make the panel required if" => "ایجاد پنل مورد نیاز اگر"
// paneldynamic.page: "Move the panel to page" => "جابهجایی تابلو به صفحه"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "نمایش تابلو در یک خط جدید"
// paneldynamic.state: "Panel collapse state" => "دولت فروپاشی پانل"
// paneldynamic.width: "Inline panel width" => "عرض پانل درون خطی"
// paneldynamic.minWidth: "Minimum panel width" => "حداقل عرض پانل"
// paneldynamic.maxWidth: "Maximum panel width" => "حداکثر عرض پانل"
// paneldynamic.templateDescription: "Panel description pattern" => "الگوی توصیف پنل"
// paneldynamic.templateTitle: "Panel title pattern" => "الگوی عنوان پنل"
// paneldynamic.noEntriesText: "Empty panel text" => "متن تابلوی خالی"
// paneldynamic.templateTabTitle: "Tab title pattern" => "الگوی عنوان زبانه"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "ایجاد یک پنل منفرد مرئی اگر"
// paneldynamic.hideNumber: "Hide the panel number" => "مخفی کردن شمارهی تابلو"
// paneldynamic.titleLocation: "Panel title alignment" => "ترازبندی عنوان پنل"
// paneldynamic.descriptionLocation: "Panel description alignment" => "ترازبندی توضیحات پنل"
// paneldynamic.templateTitleLocation: "Question title alignment" => "هم ترازی عنوان پرسش"
// paneldynamic.templateErrorLocation: "Error message alignment" => "همترازسازی پیام خطا"
// paneldynamic.newPanelPosition: "New panel location" => "محل جدید پنل"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "جلوگیری از پاسخ های تکراری در سوال زیر"
// question.name: "Question name" => "نام سوال"
// question.title: "Question title" => "عنوان سوال"
// question.description: "Question description" => "توضیحات سوال"
// question.visibleIf: "Make the question visible if" => "سؤال را قابل مشاهده کنید اگر"
// question.requiredIf: "Make the question required if" => "سؤال مورد نیاز را مطرح کنید اگر"
// question.state: "Question box collapse state" => "جعبه سوال دولت فروپاشی"
// question.hideNumber: "Hide the question number" => "مخفی کردن شماره سوال"
// question.titleLocation: "Question title alignment" => "هم ترازی عنوان پرسش"
// question.descriptionLocation: "Question description alignment" => "هم ترازی توضیحات سؤال"
// question.errorLocation: "Error message alignment" => "همترازسازی پیام خطا"
// question.indent: "Increase the inner indent" => "افزایش تورفتگی داخلی"
// question.width: "Inline question width" => "عرض پرسش درون خطی"
// question.minWidth: "Minimum question width" => "حداقل عرض سوال"
// question.maxWidth: "Maximum question width" => "حداکثر عرض سؤال"
// question.textUpdateMode: "Update input field value" => "بهروزرسانی مقدار فیلد ورودی"
// signaturepad.allowClear: "Show the Clear button within signature area" => "نمایش دکمه پاک کردن در منطقه امضا"
// signaturepad.penColor: "Stroke color" => "رنگ سکته مغزی"
// comment.rows: "Input field height (in lines)" => "ارتفاع میدان ورودی (در خطوط)"
// expression.name: "Expression name" => "نام عبارت"
// expression.title: "Expression title" => "عنوان عبارت"
// expression.description: "Expression description" => "توصیف عبارت"
// expression.expression: "Expression" => "بیان"
// trigger.expression: "Expression" => "بیان"
// calculatedvalue.expression: "Expression" => "بیان"
// survey.description: "Survey description" => "توضیحات نظرسنجی"
// page.name: "Page name" => "نام صفحه"
// page.description: "Page description" => "توضیحات صفحه"
// page.visibleIf: "Make the page visible if" => "صفحه را مرئی کنید اگر"
// page.requiredIf: "Make the page required if" => "ایجاد صفحه مورد نیاز اگر"
// page.questionsOrder: "Question order on the page" => "سفارش سوال در صفحه"
// matrixdropdowncolumn.name: "Column name" => "نام ستون"
// matrixdropdowncolumn.title: "Column title" => "عنوان ستون"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "جلوگیری از پاسخ های تکراری"
// matrixdropdowncolumn.width: "Column width" => "عرض ستون"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "حداقل عرض ستون"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "ارتفاع میدان ورودی (در خطوط)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "ستون را مرئی کنید اگر"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "ایجاد ستون مورد نیاز اگر"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "هر گزینه در یک ستون جداگانه"
// multipletextitem.name: "Name" => "نام"
// multipletextitem.title: "Title" => "عنوان"
// pe.rateDescriptionLocation: "Label alignment" => "تراز برچسب"
// pe.cellErrorLocation: "Cell error message alignment" => "همراستاسازی پیام خطای سلولی"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "شما هنوز هیچ ستونی ندارید"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "شما هنوز هیچ ردیفی ندارید"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "شما هنوز هیچ قانون اعتبار سنجی ندارید"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "شما هنوز هیچ متغیر سفارشی ندارید"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "شما هنوز هیچ محرکی ندارید"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "شما هنوز هیچ لینکی ندارید"
// pe.addNew@columns: "Add new column" => "افزودن ستون جدید"
// pe.addNew@rows: "Add new row" => "افزودن سطر جدید"
// pe.addNew@validators: "Add new rule" => "افزودن قانون جدید"
// pe.addNew@calculatedValues: "Add new variable" => "افزودن متغیر جدید"
// pe.addNew@triggers: "Add new trigger" => "افزودن ماشه جدید"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "افزودن نشانی وب جدید"
// choicesbyurl.url: "Web service's URL" => "نشانی وب سرویس"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "نمایش عناوین صفحه در نوار پیشرفت"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "نمایش شمارههای صفحه در نوار پیشرفت"
// itemvalue.visibleIf: "Make the option visible if" => "این گزینه قابل مشاهده است اگر"
// itemvalue.enableIf: "Make the option selectable if" => "گزینه را انتخاب کنید اگر"
// panel.layout: "Panel Layout" => "چیدمان پنل"
// tabs.questionSettings: "Question Settings" => "تنظیمات پرسش"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "سابق: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "سابق: categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "سابق: الف)"
// pe.width_placeholder: "Ex.: 6in" => "سابق: 6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "سابق: 600 پیکسل"
// pe.maxWidth_placeholder: "Ex.: 50%" => "سابق: 50٪"
// pv.selected: "Selected" => "انتخاب"
// pv.unselected: "Unselected" => "انتخاب نشده"
// pv.center: "Center" => "مرکز"
// pv.middle: "Middle" => "میانه"
// pv.next: "Next" => "بعدی"
// pv.last: "Last" => "آخرین"
// clearIfInvisible.none: "Never" => "هرگز"
// questionsOnPageMode.standard: "Original structure" => "ساختار اصلی"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "نمایش تمام سوالات در یک صفحه"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "نمایش یک سؤال در هر صفحه"
// pv.auto: "Auto" => "خودکار"
// panelsState.firstExpanded: "First expanded" => "اولین گسترش"
// rateColorMode.scale: "Scale" => "مقیاس"
// scaleColorMode.monochrome: "Monochrome" => "تک رنگ"
// scaleColorMode.colored: "Colored" => "رنگی"
// state.default: "Locked" => "قفل"
// showQuestionNumbers.default: "Auto-numbering" => "شماره خودکار"
// showQuestionNumbers.on: "Auto-numbering" => "شماره خودکار"
// showQuestionNumbers.onPage: "Reset on each page" => "بازنشانی در هر صفحه"
// showQuestionNumbers.onpanel: "Reset on each panel" => "بازنشانی در هر پنل"
// showQuestionNumbers.onPanel: "Reset on each panel" => "بازنشانی در هر پنل"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "ادامه در سراسر نظرسنجی"
// showQuestionNumbers.off: "No numbering" => "بدون شماره"
// descriptionLocation.underTitle: "Under the question title" => "تحت عنوان سوال"
// descriptionLocation.underInput: "Under the input field" => "زیر فیلد ورودی"
// selectToRankAreasLayout.horizontal: "Next to choices" => "در کنار انتخاب ها"
// selectToRankAreasLayout.vertical: "Above choices" => "انتخاب های بالا"
// displayStyle.decimal: "Decimal" => "اعشاری"
// displayStyle.currency: "Currency" => "ارز"
// displayStyle.percent: "Percentage" => "درصد"
// displayStyle.date: "Date" => "تاریخ"
// totalDisplayStyle.decimal: "Decimal" => "اعشاری"
// totalDisplayStyle.currency: "Currency" => "ارز"
// totalDisplayStyle.percent: "Percentage" => "درصد"
// totalDisplayStyle.date: "Date" => "تاریخ"
// rowsOrder.initial: "Original" => "اصلی"
// questionsOrder.initial: "Original" => "اصلی"
// showProgressBar.aboveheader: "Above the header" => "بالای سرصفحه"
// showProgressBar.belowheader: "Below the header" => "زیر سرایند"
// pv.sum: "Sum" => "مجموع"
// pv.count: "Count" => "تعداد"
// pv.min: "Min" => "دقیقه"
// pv.max: "Max" => "حداکثر"
// pv.avg: "Avg" => "میانگین"
// searchMode.contains: "Contains" => "شامل"
// searchMode.startsWith: "Starts with" => "شروع با"
// panel.name: "A panel ID that is not visible to respondents." => "یک شناسه پانل که برای پاسخ دهندگان قابل مشاهده نیست."
// panel.description: "Type a panel subtitle." => "یک زیرنویس پانل تایپ کنید."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی که دید پانل را تعیین می کند استفاده کنید."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که حالت فقط خواندنی را برای پانل غیرفعال می کند."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که مانع از ارسال نظرسنجی می شود مگر اینکه حداقل یک سوال تو در تو پاسخ داشته باشد."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "برای تمام سوالات در این پنل اعمال می شود. اگر می خواهید این تنظیم را لغو کنید، قوانین تراز عنوان را برای سوالات فردی تعریف کنید. گزینه \"Inherit\" به طور پیش فرض تنظیم سطح صفحه (در صورت تنظیم) یا سطح نظرسنجی (\"بالا\" را اعمال می کند)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "مکان یک پیام خطا را در رابطه با تمام سوالات درون پانل تنظیم می کند. گزینه \"Inherit\" شامل تنظیمات سطح صفحه (در صورت تنظیم) یا سطح نظرسنجی است."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "ترتیب اصلی سوالات را نگه می دارد یا انها را تصادفی می کند. گزینه \"Inherit\" شامل تنظیمات سطح صفحه (در صورت تنظیم) یا سطح نظرسنجی است."
// panel.page: "Repositions the panel to the end of a selected page." => "پانل را به انتهای صفحه انتخاب شده تغییر می دهد."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "اضافه کردن فضا یا حاشیه بین محتوای پانل و مرز سمت چپ جعبه پانل."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "عدم انتخاب برای نمایش پانل در یک خط با سوال قبلی یا پانل. تنظیمات اعمال نمی شود اگر پانل اولین عنصر در فرم شما باشد."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "را انتخاب کنید از: \"گسترش یافته\" - پانل به طور کامل نمایش داده می شود و می تواند سقوط کند؛ \"سقوط\" - پانل تنها عنوان و توضیحات را نمایش می دهد و می تواند گسترش یابد. \"Locked\" - پانل به طور کامل نمایش داده می شود و نمی تواند سقوط کند."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "عرض پانل را متناسب با سایر عناصر بررسی در همان خط تنظیم می کند. مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "یک شناسه پانل که برای پاسخ دهندگان قابل مشاهده نیست."
// paneldynamic.description: "Type a panel subtitle." => "یک زیرنویس پانل تایپ کنید."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی که دید پانل را تعیین می کند استفاده کنید."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که حالت فقط خواندنی را برای پانل غیرفعال می کند."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که مانع از ارسال نظرسنجی می شود مگر اینکه حداقل یک سوال تو در تو پاسخ داشته باشد."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "برای تمام سوالات در این پنل اعمال می شود. اگر می خواهید این تنظیم را لغو کنید، قوانین تراز عنوان را برای سوالات فردی تعریف کنید. گزینه \"Inherit\" به طور پیش فرض تنظیم سطح صفحه (در صورت تنظیم) یا سطح نظرسنجی (\"بالا\" را اعمال می کند)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "محل یک پیام خطا را در رابطه با سؤال با ورودی نامعتبر تنظیم میکند. انتخاب بین: \"بالا\" - یک متن خطا در بالای جعبه سوال قرار می گیرد؛ \"پایین\" - یک متن خطا در پایین جعبه سوال قرار می گیرد. گزینه \"Inherit\" به طور پیش فرض تنظیم سطح صفحه (در صورت تنظیم) یا سطح نظرسنجی (\"بالا\" را اعمال می کند)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "مکان یک پیام خطا را در رابطه با تمام سوالات درون پانل تنظیم می کند. گزینه \"Inherit\" شامل تنظیمات سطح صفحه (در صورت تنظیم) یا سطح نظرسنجی است."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "پانل را به انتهای صفحه انتخاب شده تغییر می دهد."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "اضافه کردن فضا یا حاشیه بین محتوای پانل و مرز سمت چپ جعبه پانل."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "عدم انتخاب برای نمایش پانل در یک خط با سوال قبلی یا پانل. تنظیمات اعمال نمی شود اگر پانل اولین عنصر در فرم شما باشد."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "را انتخاب کنید از: \"گسترش یافته\" - پانل به طور کامل نمایش داده می شود و می تواند سقوط کند؛ \"سقوط\" - پانل تنها عنوان و توضیحات را نمایش می دهد و می تواند گسترش یابد. \"Locked\" - پانل به طور کامل نمایش داده می شود و نمی تواند سقوط کند."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "عرض پانل را متناسب با سایر عناصر بررسی در همان خط تنظیم می کند. مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "قالب را برای عناوین پانل پویا تایپ کنید. از {panelIndex} برای موقعیت عمومی پانل و {visiblePanelIndex} برای سفارش ان در میان پانل های قابل مشاهده استفاده کنید. این نگهدارنده ها را در الگو قرار دهید تا شماره گذاری خودکار اضافه شود."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "در قالبی برای عناوین زبانه تایپ کنید. از {panelIndex} برای موقعیت عمومی پانل و {visiblePanelIndex} برای سفارش ان در میان پانل های قابل مشاهده استفاده کنید. این نگهدارنده ها را در الگو قرار دهید تا شماره گذاری خودکار اضافه شود."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "این تنظیم به شما اجازه می دهد تا دید پانل های فردی را در پانل پویا کنترل کنید. از نگهدارنده '{panel}' برای ارجاع به پنل فعلی در عبارت خود استفاده کنید."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "این تنظیم به طور خودکار توسط تمام سوالات موجود در این پنل به ارث برده می شود. اگر می خواهید این تنظیم را لغو کنید، قوانین تراز عنوان را برای سوالات فردی تعریف کنید. گزینه \"Inherit\" به طور پیش فرض تنظیم سطح صفحه (در صورت تنظیم) یا سطح نظرسنجی (\"بالا\" را اعمال می کند)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "گزینه \"Inherit\" سطح صفحه (در صورت تنظیم) یا تنظیم سطح نظرسنجی (\"زیر عنوان پانل\" به طور پیش فرض) اعمال می شود."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "موقعیت یک پانل تازه اضافه شده را تعریف می کند. به طور پیش فرض، پانل های جدید به پایان اضافه می شوند. \"Next\" را انتخاب کنید تا یک پانل جدید پس از پانل فعلی وارد شود."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "پاسخ ها را از اخرین پانل تکرار می کند و انها را به پانل پویا اضافه شده بعدی اختصاص می دهد."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "مرجع یک نام سوال نیاز به یک کاربر برای ارائه یک پاسخ منحصر به فرد برای این سوال در هر پانل."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "این تنظیم به شما اجازه می دهد تا یک مقدار پاسخ پیش فرض را بر اساس یک عبارت اختصاص دهید. این عبارت می تواند شامل محاسبات اساسی - \"{q1_id} + {q2_id}'، عبارات بولی مانند \"{age} > 60\" و توابع: \"iif()\"، \"today()\"، \"age()\"، \"min()\"، \"max()\"، \"avg()\" و غیره باشد. مقدار تعیین شده توسط این عبارت به عنوان مقدار پیش فرض اولیه عمل می کند که می تواند توسط ورودی دستی پاسخ دهنده لغو شود."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که تعیین می کند چه زمانی ورودی پاسخ دهنده به مقدار بر اساس \"بیان مقدار پیش فرض\" یا \"تنظیم مقدار بیان\" یا \"پاسخ پیش فرض\" مقدار (اگر هر کدام تنظیم شده است) تنظیم مجدد شود."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که تعیین می کند چه زمانی \"Set value expression\" را اجرا کنید و به صورت پویا مقدار حاصل را به عنوان یک پاسخ اختصاص دهید."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "یک عبارت را مشخص کنید که مقدار تعیین شده را هنگامی که شرایط در قانون \"Set value if\" براورده می شود، تعریف می کند. این عبارت می تواند شامل محاسبات اساسی - \"{q1_id} + {q2_id}'، عبارات بولی مانند \"{age} > 60\" و توابع: \"iif()\"، \"today()\"، \"age()\"، \"min()\"، \"max()\"، \"avg()\" و غیره باشد. مقدار تعیین شده توسط این عبارت می تواند توسط ورودی دستی پاسخ دهنده لغو شود."
// question.name: "A question ID that is not visible to respondents." => "یک شناسه سوال که برای پاسخ دهندگان قابل مشاهده نیست."
// question.description: "Type a question subtitle." => "یک سوال زیر نویس تایپ کنید."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که دید سوال را تعیین می کند."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که حالت فقط خواندنی را برای سوال غیرفعال می کند."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که مانع پیشرفت یا تسلیم نظرسنجی می شود مگر اینکه سوال پاسخی دریافت کند."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "عدم انتخاب برای نمایش سوال در یک خط با سوال قبلی یا پانل. تنظیمات اعمال نمی شود اگر سوال اولین عنصر در فرم شما باشد."
// question.page: "Repositions the question to the end of a selected page." => "سؤال را به انتهای صفحه انتخاب شده تغییر می دهد."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "را انتخاب کنید از: \"گسترش یافته\" - جعبه سوال به طور کامل نمایش داده می شود و می تواند سقوط کند؛ \"سقوط\" - جعبه سوال تنها عنوان و توضیحات را نمایش می دهد و می تواند گسترش یابد. \"Locked\" - جعبه سوال به طور کامل نمایش داده می شود و نمی تواند سقوط کند."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "قوانین هم ترازی عنوان تعریف شده در یک پانل، صفحه یا سطح نظرسنجی را لغو می کند. گزینه \"Inherit\" تنظیمات سطح بالاتر (در صورت تنظیم) یا تنظیمات سطح نظرسنجی (\"بالا\" به طور پیش فرض) را اعمال می کند."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "گزینه \"به ارث بردن\" تنظیم سطح نظرسنجی (\"تحت عنوان سوال\" به طور پیش فرض) اعمال می شود."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "مکان یک پیام خطا را در رابطه با سؤال با ورودی نامعتبر تنظیم می کند. انتخاب بین: \"بالا\" - یک متن خطا در بالای جعبه سوال قرار می گیرد؛ \"پایین\" - یک متن خطا در پایین جعبه سوال قرار می گیرد. گزینه \"ارث\" تنظیم سطح نظرسنجی (\"بالا\" به طور پیش فرض) را اعمال می کند."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "فضای یا حاشیه بین محتوای سوال و مرز سمت چپ جعبه سوال اضافه می کند."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "عرض سوال را متناسب با سایر عناصر نظرسنجی در همان خط تنظیم می کند. مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "از نماد چوب جادویی برای تنظیم یک قانون اعتبار سنجی برای سوال استفاده کنید."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "انتخاب از: \"در تمرکز از دست رفته\" - مقدار به روز شده است زمانی که فیلد ورودی تمرکز خود را از دست می دهد؛ \"در هنگام تایپ\" - مقدار در زمان واقعی به روز می شود، زیرا کاربران تایپ می کنند. گزینه \"ارث\" تنظیم سطح نظرسنجی (\"در تمرکز از دست رفته\" به طور پیش فرض) اعمال می شود."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "شما می توانید از هر سرویس وب به عنوان منبع داده برای سوالات چند گزینه ای استفاده کنید. برای پر کردن مقادیر انتخاب، URL سرویس ارائه دهنده داده ها را وارد کنید."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "یک عملیات مقایسه ای که برای فیلتر کردن لیست کشویی استفاده می شود."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "عرض ناحیه امضای نمایش داده شده و تصویر حاصل را تنظیم می کند."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "ارتفاع ناحیه امضای نمایش داده شده و تصویر حاصل را تنظیم میکند."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "اگر می خواهید منطقه امضا برای پر کردن تمام فضای موجود در جعبه سوال در حالی که حفظ پیش فرض 3: 2 نسبت ابعاد را انتخاب کنید. هنگامی که عرض سفارشی و مقادیر ارتفاع تنظیم می شود، تنظیم نسبت ابعاد این ابعاد را حفظ می کند."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "ارتفاع تصویر را در نتایج نظرسنجی تنظیم می کند."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "عرض تصویر را در نتایج نظرسنجی تنظیم می کند."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "مقادیر حداقل و حداکثر ارتفاع را نادیده می گیرد."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "مقادیر حداقل و حداکثر عرض را نادیده می گیرد."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"ارزش\" به عنوان یک شناسه مورد استفاده در قوانین شرطی عمل می کند. \"متن\" به پاسخ دهندگان نمایش داده می شود."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "این تنظیم فقط فیلد ورودی را تغییر اندازه می دهد و روی عرض جعبه پرسش تاثیر نمی گذارد. برای محدود کردن طول ورودی پذیرفته شده، به <b>Validation → Maximum character limit</b> بروید."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "تعداد خطوط نمایش داده شده در فیلد ورودی را تنظیم می کند. اگر ورودی خطوط بیشتری را بگیرد، نوار اسکرول ظاهر می شود."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "انتخاب بین: \"قابل ویرایش\" - پاسخ دهندگان را قادر می سازد تا نظرسنجی خود را پر کنند. \"فقط خواندنی\" - ویرایش فرم را غیرفعال می کند."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "یک شناسه ستون که برای پاسخ دهندگان قابل مشاهده نیست."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "هنگامی که برای یک ستون فعال می شود، یک پاسخ دهنده باید یک پاسخ منحصر به فرد برای هر سوال در این ستون ارائه دهد."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "تعداد خطوط نمایش داده شده در فیلد ورودی را تنظیم می کند. اگر ورودی خطوط بیشتری را بگیرد، نوار اسکرول ظاهر می شود."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی که دید ستون را تعیین می کند استفاده کنید."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که حالت فقط خواندنی را برای ستون غیرفعال می کند."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که مانع از ارسال نظرسنجی می شود مگر اینکه حداقل یک سوال تو در تو پاسخ داشته باشد."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "هنگامی که انتخاب می شود، یک ستون فردی برای هر گزینه انتخاب ایجاد می کند."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "را انتخاب کنید از: \"استاتیک\" - مجموعه عرض ثابت؛ \"پاسخگو\" - باعث می شود نظرسنجی عرض کامل صفحه نمایش را اشغال کند؛ \"Auto\" - هر یک از این دو را بسته به نوع سوال مورد استفاده اعمال می کند."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "چسباندن یک پیوند تصویر (بدون محدودیت اندازه) یا روی نماد پوشه کلیک کنید تا یک فایل را از رایانه خود مرور کنید (تا 64KB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "عرض لوگو را در واحدهای CSS تنظیم می کند (px، ٪، in، pt و غیره)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "ارتفاع لوگو را در واحدهای CSS تنظیم می کند (px، ٪، in، pt و غیره)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "انتخاب از: \"هیچ\" - تصویر اندازه اصلی خود را حفظ می کند؛ \"شامل\" - تصویر تغییر اندازه به جا در حالی که حفظ نسبت ابعاد ان؛ \"Cover\" - تصویر کل جعبه را پر می کند در حالی که نسبت ابعاد ان را حفظ می کند. \"Fill\" - تصویر برای پر کردن جعبه بدون حفظ نسبت ابعاد ان کشیده می شود."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "انتخاب کنید که ایا می خواهید نظرسنجی به طور خودکار به صفحه بعدی پیش رود پس از اینکه یک پاسخ دهنده به تمام سوالات در صفحه فعلی پاسخ داد."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "قابلیت مشاهده و مکان دکمه های پیمایش را در یک صفحه تنظیم می کند."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "دید و مکان یک نوار پیشرفت را تنظیم می کند. مقدار \"Auto\" نوار پیشرفت را در بالا یا پایین هدر نظرسنجی نشان می دهد."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "صفحه پیش نمایش را فقط با تمام سوالات یا پاسخ داده شده فعال کنید."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "به تمام سوالات در نظرسنجی اعمال می شود. این تنظیم را می توان با قوانین هم ترازی عنوان در سطوح پایین تر لغو کرد: پانل، صفحه یا سوال. یک تنظیم سطح پایین تر، کسانی را که در سطح بالاتری قرار دارند، نادیده می گیرد."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "یک نماد یا دنباله ای از نمادها نشان می دهد که یک پاسخ مورد نیاز است."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "یک شماره یا حرف را وارد کنید که می خواهید با ان شروع به شماره گیری کنید."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "مکان یک پیام خطا را در رابطه با سؤال با ورودی نامعتبر تنظیم می کند. انتخاب بین: \"بالا\" - یک متن خطا در بالای جعبه سوال قرار می گیرد؛ \"پایین\" - یک متن خطا در پایین جعبه سوال قرار می گیرد."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "انتخاب کنید که ایا می خواهید اولین فیلد ورودی در هر صفحه اماده برای ورود متن باشد."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "ترتیب اصلی سوالات را نگه می دارد یا انها را تصادفی می کند. اثر این تنظیم فقط در تب Preview قابل مشاهده است."
// pehelp.maxTextLength: "For text entry questions only." => "فقط برای سوالات ورودی متن."
// pehelp.maxOthersLength: "For question comments only." => "فقط برای نظرات سوال."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "انتخاب کنید اگر شما می خواهید نظرات سوال و سوالات متن بلند به رشد خودکار در ارتفاع بر اساس طول متن وارد شده است."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "برای نظرات سوال و سوالات طولانی متن تنها."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "متغیرهای سفارشی به عنوان متغیرهای متوسط یا کمکی مورد استفاده در محاسبات فرم عمل می کنند. انها ورودی های پاسخ دهنده را به عنوان مقادیر منبع می گیرند. هر متغیر سفارشی دارای یک نام منحصر به فرد و یک عبارت است که بر اساس ان است."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "اگر میخواهید مقدار محاسبهشده عبارت همراه با نتایج نظرسنجی ذخیره شود ، برگزینید."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Trigger یک رویداد یا شرایطی است که بر اساس یک عبارت است. هنگامی که عبارت به \"درست\" ارزیابی می شود، یک ماشه یک عمل را تنظیم می کند. چنین اقدامی می تواند به صورت اختیاری یک سوال هدف داشته باشد که بر ان تاثیر می گذارد."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "انتخاب کنید که ایا برای پاک کردن ارزش ها برای سوالات پنهان شده توسط منطق شرطی و زمانی که ان را انجام دهید."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "انتخاب از: \"در تمرکز از دست رفته\" - مقدار به روز شده است زمانی که فیلد ورودی تمرکز خود را از دست می دهد؛ \"در هنگام تایپ\" - مقدار در زمان واقعی به روز می شود، زیرا کاربران تایپ می کنند."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "مقدار چپ به عنوان یک شناسه ستون مورد استفاده در قوانین شرطی عمل می کند، مقدار مناسب به پاسخ دهندگان نمایش داده می شود."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "مقدار سمت چپ به عنوان یک شناسه ردیف مورد استفاده در قوانین شرطی عمل می کند، مقدار مناسب به پاسخ دهندگان نمایش داده می شود."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "محل یک پیام خطا را در رابطه با یک سلول با ورودی نامعتبر تنظیم می کند. گزینه \"Inherit\" تنظیمات را از ویژگی \"Error message alignment\" اعمال می کند."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "هنگامی که ویژگی \"جلوگیری از پاسخ های تکراری\" فعال می شود، پاسخ دهنده ای که سعی در ارسال یک ورودی تکراری دارد، پیام خطای زیر را دریافت می کند."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "به شما اجازه می دهد تا مقادیر کل را بر اساس یک عبارت محاسبه کنید. این عبارت می تواند شامل محاسبات اساسی ('{q1_id} + {q2_id}')، عبارات بولی ('{age} > 60') و توابع ('iif()'، 'today()'، 'age()'، 'min()'، 'max()'، 'avg()'، و غیره باشد."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "یک درخواست فوری برای تایید حذف ردیف ایجاد می کند."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "پاسخ ها را از اخرین ردیف تکرار می کند و انها را به ردیف دینامیک بعدی اضافه می کند."
// pehelp.description: "Type a subtitle." => "یک زیرنویس تایپ کنید."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "یک زبان را برای شروع ایجاد نظرسنجی خود انتخاب کنید. برای اضافه کردن ترجمه، به یک زبان جدید بروید و متن اصلی را در اینجا یا در زبانه ترجمه ترجمه ترجمه کنید."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "مکان یک بخش جزئیات را در رابطه با یک ردیف تنظیم می کند. انتخاب از: \"هیچ\" - هیچ گسترش اضافه شده است؛ \"زیر ردیف\" - گسترش ردیف در زیر هر ردیف ماتریس قرار می گیرد؛ \"زیر ردیف، فقط یک ردیف را نمایش می دهد\" - یک گسترش فقط در زیر یک ردیف نمایش داده می شود، گسترش ردیف باقی مانده سقوط می کند."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "انتخاب از: \"هیچ\" - تصویر اندازه اصلی خود را حفظ می کند؛ \"شامل\" - تصویر تغییر اندازه به جا در حالی که حفظ نسبت ابعاد ان؛ \"Cover\" - تصویر کل جعبه را پر می کند در حالی که نسبت ابعاد ان را حفظ می کند. \"Fill\" - تصویر برای پر کردن جعبه بدون حفظ نسبت ابعاد ان کشیده می شود."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "به تدریج ارتفاع میدان ورودی را افزایش می دهد زیرا داده ها وارد می شوند. تنظیم \"ارتفاع میدان ورودی (در خطوط)\" را لغو می کند."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "دسته تغییر اندازه (یا گرفتن) در گوشه ظاهر می شود و می تواند برای تغییر اندازه میدان ورودی کشیده شود."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "یک فاصله زمانی در ثانیه که پس از ان نظرسنجی به طور خودکار به صفحه تشکر از شما پیش می رود."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "یک فاصله زمانی در ثانیه که پس از ان نظرسنجی به طور خودکار به صفحه بعدی پیش می رود."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "یک فاصله زمانی در ثانیه که پس از ان نظرسنجی به طور خودکار به صفحه بعدی پیش می رود."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که دید صفحه را تعیین می کند."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که حالت فقط خواندنی را برای صفحه غیرفعال می کند."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که مانع از ارسال نظرسنجی می شود مگر اینکه حداقل یک سوال تو در تو پاسخ داشته باشد."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "به تمام سوالات موجود در این صفحه اعمال می شود. اگر می خواهید این تنظیمات را لغو کنید، قوانین تراز عنوان را برای سوالات یا پانل های فردی تعریف کنید. گزینه \"ارث\" تنظیم سطح نظرسنجی (\"بالا\" به طور پیش فرض) را اعمال می کند."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "مکان یک پیام خطا را در رابطه با سؤال با ورودی نامعتبر تنظیم می کند. انتخاب بین: \"بالا\" - یک متن خطا در بالای جعبه سوال قرار می گیرد؛ \"پایین\" - یک متن خطا در پایین جعبه سوال قرار می گیرد. گزینه \"ارث\" تنظیم سطح نظرسنجی (\"بالا\" به طور پیش فرض) را اعمال می کند."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "ترتیب اصلی سوالات را نگه می دارد یا انها را تصادفی می کند. گزینه \"ارث\" تنظیم سطح نظرسنجی (\"اصلی\" به طور پیش فرض) را اعمال می کند. اثر این تنظیم فقط در تب Preview قابل مشاهده است."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "قابلیت مشاهده دکمههای پیمایش را روی صفحه تنظیم میکند. گزینه \"به ارث بردن\" تنظیم سطح نظرسنجی را اعمال می کند که به طور پیش فرض به \"قابل مشاهده\" است."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "قابلیت مشاهده و مکان یک تایمر را در یک صفحه تنظیم می کند."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "انتخاب از: \"قفل شده\" - کاربران نمی توانند پانل ها را گسترش یا سقوط دهند؛ \"سقوط همه\" - تمام پانل ها در یک حالت فروپاشی شروع می شوند؛ \"گسترش همه\" - تمام پانل ها در یک حالت گسترش یافته شروع می شوند؛ \"اولین گسترش\" - تنها پانل اول در ابتدا گسترش یافته است."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "یک نام خصوصیت مشترک را درون ارایۀ اشیایی که حاوی نشانیهای اینترنتی پرونده تصویر یا ویدئویی است که میخواهید در فهرست انتخاب نمایش داده شود، وارد کنید."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "مقدار سمت چپ به عنوان یک شناسه مورد استفاده در قوانین شرطی عمل می کند، مقدار مناسب برای پاسخ دهندگان نمایش داده می شود."
// pehelp.title: "Type a user-friendly title to display." => "یک عنوان کاربر پسند برای نمایش تایپ کنید."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "اطمینان حاصل می کند که کاربران تا زمانی که فایل ها اپلود نشده اند، نظرسنجی را تکمیل نخواهند کرد."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "در انواع سوالات تک و چند انتخاب، هر گزینه انتخاب دارای یک شناسه و مقدار نمایش است. هنگامی که انتخاب می شود، این تنظیم یک مقدار نمایش را به جای یک مقدار ID در سوالات HTML و عناوین پویا و توصیف عناصر بررسی نشان می دهد."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "انتخاب کنید که ایا برای پاک کردن یا نه ارزش سوال پنهان شده توسط منطق شرطی و زمانی که به ان را انجام دهد. گزینه \"ارث\" تنظیم سطح نظرسنجی (\"پس از اتمام نظرسنجی\" به طور پیش فرض) اعمال می شود."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "انتخاب از: \"همه\" - کپی تمام گزینه های انتخاب از سوال انتخاب شده؛ \"انتخاب شده\" - به صورت پویا فقط گزینه های انتخاب شده را کپی می کند؛ \"Unselected\" - به صورت پویا تنها گزینه های انتخاب نشده را کپی می کند. گزینه های \"None\" و \"Other\" در صورت فعال شدن در سؤال منبع به طور پیش فرض کپی می شوند."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "هنگامی که انتخاب می شوند، کاربران می توانند ورودی های اضافی را در یک جعبه نظر جداگانه قرار دهند."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "نمایش هر گزینه انتخاب خاص (\"هیچ\"، \"دیگر\"، \"انتخاب همه\") در یک خط جدید، حتی در هنگام استفاده از یک طرح چند ستون."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "مشخص کردن محل در مجموعه داده های سرویس که در ان ارایه هدف از اشیاء واقع شده است. ترک خالی اگر URL در حال حاضر به ارایه اشاره می کند."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "یک نام ویژگی یکنواخت را در ارایه اشیایی که حاوی مقادیری است که می خواهید در لیست انتخاب نمایش داده شود وارد کنید."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "انتخاب کنید تا سرویس بتواند یک پاسخ یا ارایه خالی را بازگرداند."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "از نماد چوب جادویی برای تنظیم یک قانون شرطی استفاده کنید که دید همه گزینه های انتخابی را تعیین می کند."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "مقدار سمت چپ به عنوان یک شناسه مورد استفاده در قوانین شرطی عمل می کند، مقدار مناسب برای پاسخ دهندگان نمایش داده می شود."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" بین حالت های \"Buttons\" و \"Dropdown\" بر اساس عرض موجود انتخاب می شود. هنگامی که عرض برای نمایش دکمه ها کافی نیست، سوال یک کشویی را نشان می دهد."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "اجازه می دهد تا شما را به اتصال سوالات است که تولید نتایج در فرمت های مختلف. هنگامی که چنین سوالاتی با استفاده از یک شناسه پیوستن به هم مرتبط می شوند، این ویژگی مشترک مقادیر سوال انتخاب شده را ذخیره می کند."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "انتخاب کنید که ایا می خواهید محتویات منوی کشویی را به روز کنید تا با پرسوجوی جستجویی که کاربر در قسمت ورودی تایپ می کند مطابقت داشته باشد."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "ارزش برای صرفه جویی در نتایج نظرسنجی زمانی که پاسخ دهندگان پاسخ مثبت می دهند."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "ارزش برای صرفه جویی در نتایج نظرسنجی زمانی که پاسخ دهندگان پاسخ منفی می دهند."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "توصیه نمی شود این گزینه را غیرفعال کنید زیرا تصویر Preview را نادیده می گیرد و درک اینکه ایا فایل ها اپلود شده اند را برای کاربر دشوار می کند."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "یک اعلان برای تایید حذف پرونده ایجاد می کند."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "فقط گزینه های انتخاب شده را رتبه بندی کنید. کاربران موارد انتخاب شده را از لیست انتخاب می کنند تا انها را در منطقه رتبه بندی سفارش دهند."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "لیستی از انتخاب هایی را وارد کنید که در طول ورودی به مخاطب پیشنهاد می شود."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "تنظیم فقط زمینه های ورودی را تغییر می دهد و بر عرض جعبه سوال تاثیر نمی گذارد."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "عرض سازگار را برای همۀ برچسبهای فقره به تصویردانه تنظیم میکند"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "گزینه \"Auto\" به طور خودکار حالت مناسب برای نمایش - تصویر، ویدئو یا یوتیوب - را بر اساس URL منبع ارائه شده تعیین می کند."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "به عنوان یک جایگزین زمانی که تصویر نمی تواند بر روی دستگاه کاربر و برای اهداف دسترسی نمایش داده شود."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "رنگ ایموجی انتخاب شده را هنگامی که نوع نماد رتبه بندی روی \"Smileys\" تنظیم شده است، تعریف می کند. انتخاب بین: \"پیش فرض\" - ایموجی انتخاب شده در رنگ پیش فرض بررسی ظاهر می شود؛ \"Scale\" - ایموجی انتخاب شده رنگ را از مقیاس رتبه بندی به ارث می برد."
// expression.name: "An expression ID that is not visible to respondents." => "یک شناسه بیان که برای پاسخ دهندگان قابل مشاهده نیست."
// expression.description: "Type an expression subtitle." => "زیر نویس عبارت را تایپ کنید."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "یک عبارت می تواند شامل محاسبات اساسی ('{q1_id} + {q2_id}')، شرایط ('{age} > 60') و توابع ('iif()'، 'today()'، 'age()'، 'min()'، 'max()'، 'avg()'' و غیره باشد."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "انتخاب کنید برای ذخیره \"دیگر\" مقدار گزینه به عنوان یک ملک جداگانه در نتایج نظرسنجی."
// p.swapOrder: "Swap the order of Yes and No" => "تعویض سفارش بله و خیر"
// p.itemTitleWidth: "Item label width (in px)" => "عرض برچسب مورد (در پیکسل)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "متن برای نشان دادن اینکه ایا همه گزینهها انتخاب شدهاند"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "متن نگهدارنده برای منطقه رتبه بندی"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "بررسی را به طور خودکار تکمیل کنید"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "انتخاب کنید که ایا می خواهید نظرسنجی به طور خودکار پس از پاسخ دادن به تمام سوالات پاسخ دهد."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "ذخیره مقدار ماسک در نتایج نظرسنجی"
// patternmask.pattern: "Value pattern" => "الگوی ارزش"
// datetimemask.min: "Minimum value" => "حداقل مقدار"
// datetimemask.max: "Maximum value" => "بیشینه مقدار"
// numericmask.allowNegativeValues: "Allow negative values" => "اجازه دادن مقادیر منفی"
// numericmask.thousandsSeparator: "Thousands separator" => "هزار جداکننده"
// numericmask.decimalSeparator: "Decimal separator" => "جداساز دهدهی"
// numericmask.precision: "Value precision" => "دقت ارزش"
// numericmask.min: "Minimum value" => "حداقل مقدار"
// numericmask.max: "Maximum value" => "بیشینه مقدار"
// currencymask.prefix: "Currency prefix" => "پیشوند ارز"
// currencymask.suffix: "Currency suffix" => "پسوند ارز"
// pe.maskType: "Input mask type" => "نوع ماسک ورودی"
// maskTypes.patternmask: "Pattern" => "الگوی"
// maskTypes.numericmask: "Numeric" => "عددی"
// maskTypes.datetimemask: "Date and Time" => "تاریخ و زمان"
// maskTypes.currencymask: "Currency" => "ارز"
// tabs.mask: "Input Mask Settings" => "تنظیمات ماسک ورودی"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "شماره تماس: +1 (999) -999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "سابق: mm / dd / yyyyy"
// pe.currencyprefix_placeholder: "Ex.: $" => "سابق: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Ex.: دلار امریکا"
// pv.textWrapEnabled: "Wrap choices" => "انتخاب های بسته بندی"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "متون طولانی در گزینه های انتخاب به طور خودکار شکستن خط را ایجاد می کنند تا در منوی کشویی قرار بگیرند. اگر می خواهید متن ها کلیپ شوند، انتخاب را لغو کنید."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "انتخاب کنید که ایا می خواهید مقدار سؤال را با یک ماسک کاربردی در نتایج نظرسنجی ذخیره کنید."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "الگو می تواند شامل literals رشته و متغیرهای زیر باشد: '9' - برای یک رقم؛ 'a' - برای یک حرف بزرگ یا کوچک؛ \"#\" - برای یک رقم یا یک حرف بزرگ یا کوچک. استفاده از backslash '\\' برای فرار از یک شخصیت."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "الگو می تواند شامل کاراکترهای جداکننده و متغیرهای زیر باشد: \"m\" - برای شماره ماه؛ 'mm' - برای شماره ماه، با صفر پیشرو برای مقادیر تک رقمی؛ 'd' - برای روز ماه؛ 'dd' - برای روز ماه، با صفر پیشرو برای مقادیر تک رقمی؛ 'yy' - برای دو رقم اخر سال؛ 'yyyyy' - برای یک سال چهار رقمی."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "نمادی که برای جدا کردن قسمت کسری از قسمت صحیح یک عدد نمایش داده شده استفاده می شود."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "نمادی که برای جدا کردن ارقام یک عدد بزرگ به گروه های سه نفره استفاده می شود."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "محدود کردن تعداد ارقام برای حفظ پس از نقطه اعشار برای یک عدد نمایش داده شده."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "یک یا چند نماد قبل از مقدار نمایش داده می شود."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "یک یا چند نماد بعد از مقدار نمایش داده می شود."
// ed.translationSource: "Source: " => "منبع: "
// ed.translationTarget: "Target: " => "هدف: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "صفحه خالی است. یک عنصر را از جعبه ابزار بکشید یا روی دکمه زیر کلیک کنید."
// maskTypes.none: "None" => "هیچ کدام"
// itemvalue@rows.visibleIf: "Make the row visible if" => "سطر را مرئی کنید اگر"
// itemvalue@rows.enableIf: "Make the row editable if" => "ردیف را قابل ویرایش کنید اگر"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "متن نگهدارنده در حالت فقط خواندنی یا پیشنمایش"
// pe.textWrapEnabled: "Wrap choices" => "انتخاب های بسته بندی"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "گزینه \"Auto\" به طور خودکار حالت مناسب برای نمایش - تصویر، ویدئو یا یوتیوب - را بر اساس URL منبع ارائه شده تعیین می کند."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "بین \"تصویر\" و \"ویدئو\" را انتخاب کنید تا حالت محتوا را انتخاب کنید. اگر \"تصویر\" انتخاب شده است، اطمینان حاصل کنید که تمام گزینه های ارائه شده فایل های تصویری در فرمت های زیر هستند: JPEG، GIF، PNG، APNG، SVG، BMP، ICO. به طور مشابه، اگر \"ویدئو\" انتخاب شده است، اطمینان حاصل کنید که تمام گزینه ها لینک مستقیم به فایل های ویدئویی در فرمت های زیر هستند: MP4، MOV، WMV، FLV، AVI، MKV. لطفا توجه داشته باشید که پیوندهای YouTube برای گزینه های ویدیویی پشتیبانی نمی شوند."
// ed.selectFile: "Select a file" => "یک پرونده انتخاب کنید"
// ed.removeFile: "Remove the file" => "حذف پرونده"
// pe.searchMode: "Search Mode" => "حالت جستجو"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "روی دکمه \"افزودن سؤال\" در زیر کلیک کنید تا شروع به ایجاد فرم خود کنید."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "روی دکمه \"افزودن سؤال\" در زیر کلیک کنید تا عنصر جدیدی به صفحه اضافه شود."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "روی دکمه \"افزودن سؤال\" در زیر کلیک کنید تا یک عنصر جدید به پانل اضافه شود."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "روی دکمه زیر کلیک کنید و تصویری را برای اپلود انتخاب کنید"
// coloralpha.opacity: "Opacity" => "کدورت"
// font.family: "Font family" => "خانواده قلم"
// font.color: "Color" => "رنگ"
// font.placeholderColor: "Placeholder color" => "رنگ نگهدارنده"
// font.size: "Size" => "اندازه"
// theme.themeName: "Theme" => "تم"
// theme.isPanelless: "Question appearance" => "ظاهر سوال"
// theme.editorPanel: "Background and corner radius" => "پس زمینه و شعاع گوشه"
// theme.questionPanel: "Background and corner radius" => "پس زمینه و شعاع گوشه"
// theme.primaryColor: "Accent color" => "رنگ لهجه"
// theme.panelBackgroundTransparency: "Panel background opacity" => "تاری پسزمینه پانل"
// theme.questionBackgroundTransparency: "Question background opacity" => "تاری پسزمینۀ سؤال"
// theme.fontSize: "Font size" => "اندازه قلم"
// theme.scale: "Scale" => "مقیاس"
// theme.cornerRadius: "Corner radius" => "شعاع گوشه"
// theme.pageTitle: "Title font" => "قلم عنوان"
// theme.pageDescription: "Description font" => "قلم توصیف"
// theme.questionTitle: "Title font" => "قلم عنوان"
// theme.questionDescription: "Description font" => "قلم توصیف"
// theme.editorFont: "Font" => "فونت"
// theme.backgroundOpacity: "Opacity" => "کدورت"
// theme.--sjs-font-family: "Font family" => "خانواده قلم"
// theme.--sjs-general-backcolor-dim: "Background color" => "رنگ پسزمینه"
// theme.--sjs-primary-backcolor: "Accent background" => "پسزمینۀ لهجه"
// theme.--sjs-primary-forecolor: "Accent foreground" => "پیشزمینه لهجه"
// theme.--sjs-shadow-small: "Shadow effects" => "جلوه های سایه"
// theme.--sjs-shadow-inner: "Shadow effects" => "جلوه های سایه"
// theme.--sjs-border-default: "Colors" => "رنگ"
// header@header.headerView: "View" => "مشاهده"
// header@header.logoPosition: "Logo position" => "موقعیت لوگو"
// header@header.surveyTitle: "Survey title font" => "قلم عنوان نظرسنجی"
// header@header.surveyDescription: "Survey description font" => "قلم توصیف نظرسنجی"
// header@header.headerTitle: "Survey title font" => "قلم عنوان نظرسنجی"
// header@header.headerDescription: "Survey description font" => "قلم توصیف نظرسنجی"
// header@header.inheritWidthFrom: "Content area width" => "عرض منطقه محتوا"
// header@header.textAreaWidth: "Text width" => "عرض متن"
// header@header.backgroundColorSwitch: "Background color" => "رنگ پسزمینه"
// header@header.backgroundImage: "Background image" => "تصویر زمینه"
// header@header.backgroundImageOpacity: "Opacity" => "کدورت"
// header@header.overlapEnabled: "Overlap" => "همپوشانی"
// header@header.logoPositionX: "Logo position" => "موقعیت لوگو"
// header@header.titlePositionX: "Title position" => "موقعیت عنوان"
// header@header.descriptionPositionX: "Description position" => "شرح موقعیت"
// weight.400: "Regular" => "منظم"
// weight.600: "Heavy" => "سنگین"
// weight.700: "Semi-bold" => "نیمه جسورانه"
// weight.800: "Bold" => "جسورانه"
// backgroundImageFit.auto: "Auto" => "خودکار"
// backgroundImageFit.cover: "Cover" => "پوشش"
// backgroundImageFit.contain: "Contain" => "حاوی"
// backgroundImageFit.fill: "Stretch" => "کشش"
// backgroundImageFit.tile: "Tile" => "کاشی"
// backgroundImageAttachment.fixed: "Fixed" => "ثابت"
// backgroundImageAttachment.scroll: "Scroll" => "حرکت"
// headerView.basic: "Basic" => "اساسی"
// headerView.advanced: "Advanced" => "پیشرفته"
// inheritWidthFrom.survey: "Same as survey" => "همانند نظرسنجی"
// inheritWidthFrom.container: "Fit to container" => "مناسب برای ظرف"
// backgroundColorSwitch.none: "None" => "هیچ کدام"
// backgroundColorSwitch.accentColor: "Accent color" => "رنگ لهجه"
// backgroundColorSwitch.custom: "Custom" => "سفارشی"
// colorPalette.light: "Light" => "نور"
// colorPalette.dark: "Dark" => "تاریک"
// isPanelless.false: "Default" => "پیش فرض"
// isPanelless.true: "Without Panels" => "بدون پانل"
// theme.cornerRadius: "Corner radius" => "شعاع گوشه"
// theme.fontFamily: "Font family" => "خانواده قلم"
// theme.fontWeightRegular: "Regular" => "منظم"
// theme.fontWeightHeavy: "Heavy" => "سنگین"
// theme.fontWeightSemiBold: "Semi-bold" => "نیمه جسورانه"
// theme.fontWeightBold: "Bold" => "جسورانه"
// theme.color: "Color" => "رنگ"
// theme.placeholderColor: "Placeholder color" => "رنگ نگهدارنده"
// theme.size: "Size" => "اندازه"
// theme.opacity: "Opacity" => "کدورت"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "تایپ برای جستجو..."
// ed.toolboxNoResultsFound: "No results found" => "نتیجه ای یافت نشد"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "ذی نفع عنوان تب"
// theme.--sjs-special-red: "Error messages" => "پیغامهای خطا"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "یک متن جایگزین برای عناوین برگه که زمانی اعمال می شود که الگوی عنوان برگه ارزش معنی داری تولید نمی کند."
// theme.fontColor: "Font color" => "رنگ قلم"
// theme.backgroundColor: "Background color" => "رنگ پسزمینه"
// pe.questionTitleWidth: "Question title width" => "عرض عنوان سوال"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "یک پرونده را انتخاب کنید یا پیوند پرونده را جایگذاری کنید..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "سابق: 200 پیکسل"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "عرض ثابت را برای عناوین سؤال تنظیم می کند وقتی که انها در سمت چپ جعبه های سوال خود قرار دارند. مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "عرض ثابت را برای عناوین سؤال تنظیم می کند وقتی که انها در سمت چپ جعبه های سوال خود قرار دارند. مقادیر CSS را می پذیرد (px، ٪، in، pt و غیره)."
// pe.commentAreaRows: "Comment area height (in lines)" => "ارتفاع منطقه نظر (در خطوط)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "تعداد خطوط نمایش داده شده در ناحیههای متن را برای نظرات سؤال تنظیم میکند. در ورودی طول می کشد تا خطوط بیشتر، نوار اسکرول به نظر می رسد."


/***/ }),

/***/ "./src/localization/polish.ts":
/*!************************************!*\
  !*** ./src/localization/polish.ts ***!
  \************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var polishStrings = {
    // survey templates
    survey: {
        edit: "Edytuj",
        externalHelpLink: "Obejrzyj i dowiedz się, jak tworzyć ankiety",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Przeciągnij pytanie.",
        addLogicItem: "Utwórz regułę, aby dostosować przepływ ankiety.",
        copy: "Kopiuj",
        duplicate: "Duplikat",
        addToToolbox: "Dodaj do palety",
        deletePanel: "Usuń panel",
        deleteQuestion: "Usuń pytanie",
        convertTo: "Konwertuj na",
        drag: "Przeciągnij element",
    },
    // Creator tabs
    tabs: {
        preview: "Testuj ankietę",
        theme: "Tematy",
        translation: "Tłumaczenie",
        designer: "Projektant ankiety",
        editor: "JSON Editor",
        logic: "Logika"
    },
    // Question types
    qt: {
        default: "Domyślny",
        checkbox: "Wielokrotny wybór",
        comment: "Komentarz",
        imagepicker: "Selektor obrazów",
        ranking: "Ranking",
        image: "Obraz",
        dropdown: "Lista wyboru",
        tagbox: "Lista rozwijana Multi-Select",
        file: "Plik",
        html: "Html",
        matrix: "Macierz (jednokrotny wybór)",
        matrixdropdown: "Matrix (wielokrotny wybór)",
        matrixdynamic: "Matrix (dynamiczne wiersze)",
        multipletext: "Wiele linii tekstu",
        panel: "Panel",
        paneldynamic: "Panel (dynamiczne panele)",
        radiogroup: "Jednokrotny wybór",
        rating: "Ocena",
        text: "Pojedyncza odpowiedź",
        boolean: "Prawda/Fałsz",
        expression: "Wyrażenie",
        signaturepad: "Podpis",
        buttongroup: "Grupa przycisków"
    },
    toolboxCategories: {
        general: "Ogólne",
        choice: "Pytania wyboru",
        text: "Pytania dotyczące wprowadzania tekstu",
        containers: "Pojemniki",
        matrix: "Pytania macierzowe",
        misc: "Różne"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Domyślne ({0})",
        survey: "Ankieta",
        settings: "Ustawienia",
        settingsTooltip: "Otwórz ustawienia",
        surveySettings: "Ustawienia ankiety",
        surveySettingsTooltip: "Ustawienia ankiety",
        themeSettings: "Ustawienia motywu",
        themeSettingsTooltip: "Ustawienia motywu",
        showPanel: "Pokaż panel",
        hidePanel: "Panel Ukryj",
        prevSelected: "Wybierz poprzedni",
        nextSelected: "Wybierz następny",
        prevFocus: "Fokus poprzedni",
        nextFocus: "Ostrość następna",
        surveyTypeName: "Sondaż",
        pageTypeName: "Strona",
        panelTypeName: "Panel",
        questionTypeName: "Pytanie",
        columnTypeName: "Kolumna",
        addNewPage: "Dodaj nową sekcję",
        moveRight: "Przewiń w prawo",
        moveLeft: "Przewiń w lewo",
        deletePage: "Usuń sekcję",
        editPage: "Edytuj sekcję",
        edit: "Redagować",
        newPageName: "sekcja",
        newQuestionName: "pytanie",
        newPanelName: "panel",
        newTextItemName: "Tekst",
        defaultV2Theme: "Domyślny",
        modernTheme: "Nowoczesny",
        defaultTheme: "Domyślne (starsze)",
        testSurveyAgain: "Testuj ponownie",
        testSurveyWidth: "Szerokość ankiety: ",
        navigateToMsg: "Trzeba było nawigować do",
        saveSurvey: "Zapisz ankietę",
        saveSurveyTooltip: "Zapisz ankietę",
        saveTheme: "Zapisz motyw",
        saveThemeTooltip: "Zapisz motyw",
        jsonHideErrors: "Ukryj błędy",
        jsonShowErrors: "Pokaż błędy",
        undo: "Cofnij",
        redo: "Ponów",
        undoTooltip: "Cofanie ostatniej zmiany",
        redoTooltip: "Ponowne wprowadzanie zmian",
        showMoreChoices: "Pokaż więcej",
        showLessChoices: "Pokaż mniej",
        copy: "Kopiować",
        cut: "Ciąć",
        paste: "Wklejać",
        copyTooltip: "Kopiuj zaznaczenie do schowka",
        cutTooltip: "Wytnij zaznaczenie do schowka",
        pasteTooltip: "Wklejanie ze schowka",
        options: "Opcje",
        generateValidJSON: "Generate Valid JSON",
        generateReadableJSON: "Generate Readable JSON",
        toolbox: "Paleta",
        "property-grid": "Właściwości",
        toolboxFilteredTextPlaceholder: "Wpisz, aby wyszukać...",
        toolboxNoResultsFound: "Nie znaleziono wyników",
        propertyGridFilteredTextPlaceholder: "Wpisz, aby wyszukać...",
        propertyGridNoResultsFound: "Nie znaleziono wyników",
        correctJSON: "Please correct JSON.",
        surveyResults: "Wynik ankiety: ",
        surveyResultsTable: "Jako tabela",
        surveyResultsJson: "Jako JSON",
        resultsTitle: "Tytuł pytania",
        resultsName: "Nazwa pytania",
        resultsValue: "Wartość odpowiedzi",
        resultsDisplayValue: "Wyświetl wartość",
        modified: "Zmodyfikowana",
        saving: "Trwa zapis",
        saved: "Zapisano",
        propertyEditorError: "Błąd",
        saveError: "Błąd! Zawartość edytora nie jest zapisywana.",
        translationPropertyGridTitle: "Ustawienia językowe",
        themePropertyGridTitle: "Ustawienia motywu",
        translationLanguages: "Języki",
        translationDeleteLanguage: "Czy na pewno chcesz usunąć wszystkie ciągi znaków dla tego języka?",
        translationAddLanguage: "Wybierz język do przetłumaczenia",
        translationShowAllStrings: "Wszystkie struny",
        translationShowUsedStringsOnly: "Tylko używane ciągi",
        translationShowAllPages: "Wszystkie strony",
        translationNoStrings: "Brak ciągów do przetłumaczenia. Proszę zmienić filtr.",
        translationExportToSCVButton: "Eksport do pliku CSV",
        translationImportFromSCVButton: "Importowanie z pliku CSV",
        translateUsigAI: "Automatycznie tłumacz wszystko",
        translateUsigAIFrom: "Przetłumacz z: ",
        translationDialogTitle: "Nieprzetłumaczone ciągi znaków",
        translationMergeLocaleWithDefault: "Scalanie {0} z domyślnymi ustawieniami regionalnymi",
        translationPlaceHolder: "Tłumaczenie...",
        translationSource: "Źródło: ",
        translationTarget: "Cel: ",
        themeExportButton: "Eksport",
        themeImportButton: "Import",
        surveyJsonExportButton: "Eksport",
        surveyJsonImportButton: "Import",
        surveyJsonCopyButton: "Kopiuj do schowka",
        themeResetButton: "Przywracanie domyślnych ustawień motywu",
        themeResetConfirmation: "Czy naprawdę chcesz zresetować motyw? Wszystkie Twoje dostosowania zostaną utracone.",
        themeResetConfirmationOk: "Tak, zresetuj motyw",
        bold: "Śmiały",
        italic: "Kursywa",
        underline: "Podkreślać",
        addNewQuestion: "Dodaj pytanie",
        selectPage: "Wybierz stronę...",
        carryForwardChoicesCopied: "Wybory są kopiowane z",
        choicesLoadedFromWebText: "Opcje są ładowane z usługi internetowej.",
        choicesLoadedFromWebLinkText: "Przejdź do ustawień",
        choicesLoadedFromWebPreviewTitle: "Podgląd wczytanych opcji wyboru",
        htmlPlaceHolder: "Zawartość HTML będzie tutaj.",
        panelPlaceHolder: "Upuść pytanie z przybornika tutaj.",
        surveyPlaceHolder: "Ankieta jest pusta. Przeciągnij element z przybornika lub kliknij przycisk poniżej.",
        pagePlaceHolder: "Strona jest pusta. Przeciągnij element z przybornika lub kliknij przycisk poniżej.",
        imagePlaceHolder: "Przeciągnij i upuść obraz tutaj lub kliknij przycisk poniżej i wybierz obraz do przesłania",
        surveyPlaceHolderMobile: "Kliknij przycisk \"Dodaj pytanie\" poniżej, aby rozpocząć tworzenie formularza.",
        pagePlaceHolderMobile: "Kliknij przycisk \"Dodaj pytanie\" poniżej, aby dodać nowy element do strony.",
        panelPlaceHolderMobile: "Kliknij przycisk \"Dodaj pytanie\" poniżej, aby dodać nowy element do panelu.",
        imagePlaceHolderMobile: "Kliknij poniższy przycisk i wybierz obraz do przesłania",
        imageChooseImage: "Wybierz obraz",
        addNewTypeQuestion: "Dodaj {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Przedmiot ",
        selectFile: "Wybierz plik",
        removeFile: "Usuń plik",
        lg: {
            addNewItem: "Dodaj nową regułę",
            empty_tab: "Utwórz regułę, aby dostosować przepływ ankiety.",
            page_visibilityName: "Pokaż (ukryj) stronę",
            page_enableName: "Włącz (wyłącz) stronę",
            page_requireName: "Ustaw stronę jako wymaganą",
            panel_visibilityName: "Pokaż (ukryj) panel",
            panel_enableName: "Włącz (wyłącz) panel",
            panel_requireName: "Ustaw stronę jako wymaganą",
            question_visibilityName: "Pokaż (ukryj) pytanie",
            question_enableName: "Włącz (wyłącz) pytanie",
            question_requireName: "Zadbaj o pytanie wymagane",
            question_resetValueName: "Zresetuj wartość pytania",
            question_setValueName: "Ustawianie wartości pytania",
            column_visibilityName: "Pokaż (ukryj) kolumnę",
            column_enableName: "Włącz (wyłącz) kolumnę",
            column_requireName: "Ustaw kolumnę jako wymaganą",
            column_resetValueName: "Resetowanie wartości kolumny",
            column_setValueName: "Ustawianie wartości kolumny",
            trigger_completeName: "Wypełnij ankietę",
            trigger_setvalueName: "Ustaw odpowiedź",
            trigger_copyvalueName: "Kopiuj odpowiedź",
            trigger_skipName: "Przejdź do pytania",
            trigger_runExpressionName: "Uruchom wyrażenie",
            completedHtmlOnConditionName: "Ustaw znaczniki strony \"Ankieta ukończona\"",
            page_visibilityDescription: "Spraw, aby strona była widoczna, gdy wyrażenie logiczne zwróci wartość true. W przeciwnym razie zachowaj go niewidocznym.",
            panel_visibilityDescription: "Uczyń panel widocznym, gdy wyrażenie logiczne zwróci wartość true. W przeciwnym razie zachowaj go niewidocznym.",
            panel_enableDescription: "Włącz panel i wszystkie znajdujące się w nim elementy, gdy wyrażenie logiczne zwróci wartość true. W przeciwnym razie pozostaw je wyłączone.",
            question_visibilityDescription: "Uczyń pytanie widocznym, gdy wyrażenie logiczne zwróci wartość true. W przeciwnym razie zachowaj go niewidocznym.",
            question_enableDescription: "Włącz pytanie, gdy wyrażenie logiczne zwróci wartość true. W przeciwnym razie pozostaw go wyłączonym.",
            question_requireDescription: "Pytanie staje się wymagane, gdy wyrażenie logiczne zwraca wartość true.",
            trigger_completeDescription: "Gdy wyrażenie logiczne zwraca wartość true, ankieta zostaje wypełniona, a użytkownik końcowy zobaczy stronę \"Dziękuję\".",
            trigger_setvalueDescription: "Gdy wartości pytań, które są używane w wyrażeniu logicznym, zostaną zmienione, a wyrażenie logiczne zwróci wartość true, wartość zostanie ustawiona na wybrane pytanie.",
            trigger_copyvalueDescription: "Gdy wartości pytania, które są używane w wyrażeniu logicznym, zostaną zmienione, a wyrażenie logiczne zwróci wartość true, wartość jednego wybranego pytania zostanie skopiowana do innego wybranego pytania.",
            trigger_skipDescription: "Gdy wyrażenie logiczne zwraca wartość true, ankieta przechodzi do / fokus wybranego pytania.",
            trigger_runExpressionDescription: "Gdy wyrażenie logiczne zwraca wartość true, wykonywane jest wyrażenie niestandardowe. Opcjonalnie można ustawić wynik tego wyrażenia w wybranym pytaniu",
            completedHtmlOnConditionDescription: "Jeśli wyrażenie logiczne zwróci wartość true, domyślny tekst strony \"Dziękuję\" zostanie zmieniony na podany.",
            itemExpressionText: "Gdy wyrażenie \"{0}\" zwraca wartość true",
            itemEmptyExpressionText: "Nowa reguła",
            page_visibilityText: "Ustawianie {0} strony",
            panel_visibilityText: "Uwidocznienie {0} panelu",
            panel_enableText: "Włączanie {0} panelu",
            question_visibilityText: "Uczyń {0} pytań widocznymi",
            question_enableText: "Utwórz pytanie {0} włącz",
            question_requireText: "Pytanie {0} wymagane",
            question_resetValueText: "Zresetuj wartość dla pytania: {0}",
            question_setValueText: "Przypisz wartość: {1} do pytania: {0}",
            column_visibilityText: "Uwidocznienie {0}  {1}pytania",
            column_enableText: "Ustaw kolumnę {0} pytania{1} włączyć",
            column_requireText: "Ustaw kolumnę {0} pytania {1} wymagane",
            column_resetValueText: "Zresetuj wartość komórki dla kolumny: {0}",
            column_setValueText: "Przypisz wartość komórki: {1} do kolumny: {0}",
            setValueExpressionPlaceholder: " Wyrażenie, którego wynik zostanie przypisany do pytania docelowego.",
            trigger_completeText: "Ankieta zostaje zakończona",
            trigger_setvalueText: "Ustaw pod znakiem zapytania: {0} wartość {1}",
            trigger_setvalueEmptyText: "Wyczyść wartość pytania: {0}",
            trigger_copyvalueText: "Kopiuj do pytania: {0} wartość z pytania {1}",
            trigger_skipText: "Przejdź do pytania {0}",
            trigger_runExpressionText1: "Uruchom wyrażenie: '{0}'",
            trigger_runExpressionText2: " i zakwestionować jego wynik: {0}",
            completedHtmlOnConditionText: "pokaż niestandardowy tekst dla strony \"Dziękuję\".",
            showAllQuestions: "Wszystkie pytania",
            showAllActionTypes: "Wszystkie rodzaje akcji",
            conditions: "Warunek (warunki)",
            actions: "Działania(e)",
            expressionEditorTitle: "Zdefiniuj warunki",
            actionsEditorTitle: "Definiowanie akcji",
            deleteAction: "Akcja usuwania",
            addNewAction: "Dodaj akcję",
            selectedActionCaption: "Wybierz akcję...",
            expressionInvalid: "Wyrażenie logiczne jest puste lub nieprawidłowe. Proszę to poprawić.",
            noActionError: "Dodaj co najmniej jedną akcję.",
            actionInvalid: "Proszę, napraw problemy w swoich działaniach.",
            uncompletedRule_title: "Reguły logiczne są niekompletne",
            uncompletedRule_text: "Nie ukończyłeś niektórych reguł logicznych. Jeśli opuścisz kartę teraz, zmiany zostaną utracone. Czy nadal chcesz opuścić kartę bez dokończenia zmian?",
            uncompletedRule_apply: "Tak",
            uncompletedRule_cancel: "Nie, chcę wypełnić zasady"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Nazwa panelu",
            title: "Tytuł panelu",
            description: "Opis panelu",
            visibleIf: "Uwidocznij panel, jeśli",
            requiredIf: "Ustaw panel jako wymagany, jeśli",
            questionsOrder: "Kolejność pytań w panelu",
            page: "Strona nadrzędna",
            startWithNewLine: "Wyświetlanie panelu w nowym wierszu",
            state: "Stan zwijania panelu",
            width: "Szerokość panelu w linii",
            minWidth: "Minimalna szerokość panelu",
            maxWidth: "Maksymalna szerokość panelu",
            showNumber: "Panele numeryczne"
        },
        paneldynamic: {
            name: "Nazwa panelu",
            title: "Tytuł panelu",
            description: "Opis panelu",
            visibleIf: "Uwidocznij panel, jeśli",
            requiredIf: "Ustaw panel jako wymagany, jeśli",
            page: "Przenieś panel na stronę",
            startWithNewLine: "Wyświetlanie panelu w nowym wierszu",
            state: "Stan zwijania panelu",
            width: "Szerokość panelu w linii",
            minWidth: "Minimalna szerokość panelu",
            maxWidth: "Maksymalna szerokość panelu",
            confirmDelete: "Potwierdź usunięcie panelu",
            templateDescription: "Wzorzec opisu panelu",
            templateTitle: "Wzorzec tytułu panelu",
            noEntriesText: "Pusty tekst panelu",
            templateTabTitle: "Wzorzec tytułu tabulatora",
            tabTitlePlaceholder: "Symbol zastępczy tytułu tabulatora",
            templateVisibleIf: "Uwidocznij pojedynczy panel, jeśli",
            hideNumber: "Ukryj numer panelu",
            titleLocation: "Wyrównanie tytułu panelu",
            descriptionLocation: "Wyrównanie opisu panelu",
            templateTitleLocation: "Wyrównanie tytułu pytania",
            templateErrorLocation: "Wyrównanie komunikatu o błędzie",
            newPanelPosition: "Nowa lokalizacja panelu",
            keyName: "Zapobiegaj zduplikowanym odpowiedziom w następującym pytaniu"
        },
        question: {
            name: "Nazwa pytania",
            title: "Tytuł pytania",
            description: "Opis pytania",
            visibleIf: "Uwidocznij pytanie, jeśli",
            requiredIf: "Zadbaj o to, aby pytanie było wymagane, jeśli",
            page: "Strona nadrzędna",
            state: "Stan zwinięcia pola pytania",
            hideNumber: "Ukryj numer pytania",
            titleLocation: "Wyrównanie tytułu pytania",
            descriptionLocation: "Wyrównanie opisu pytania",
            errorLocation: "Wyrównanie komunikatu o błędzie",
            indent: "Zwiększ wcięcie wewnętrzne",
            width: "Szerokość pytania w tekście",
            minWidth: "Minimalna szerokość pytania",
            maxWidth: "Maksymalna szerokość pytania",
            textUpdateMode: "Aktualizowanie wartości pola wejściowego"
        },
        signaturepad: {
            signatureWidth: "Szerokość obszaru podpisu",
            signatureHeight: "Wysokość obszaru podpisu",
            signatureAutoScaleEnabled: "Automatyczne skalowanie obszaru podpisu",
            showPlaceholder: "Pokazywanie symbolu zastępczego",
            placeholder: "Tekst zastępczy",
            placeholderReadOnly: "Tekst zastępczy w trybie tylko do odczytu lub podglądu",
            allowClear: "Pokaż przycisk Wyczyść w obszarze podpisu",
            penMinWidth: "Minimalna szerokość pisaka",
            penMaxWidth: "Maksymalna szerokość pisaka",
            penColor: "Kolor obrysu"
        },
        comment: {
            rows: "Wysokość pola wejściowego (w wierszach)"
        },
        showQuestionNumbers: "Show question numbers",
        questionStartIndex: "Question start index (1, 2 or 'A', 'a')",
        expression: {
            name: "Nazwa wyrażenia",
            title: "Tytuł wyrażenia",
            description: "Opis wyrażenia",
            expression: "Wyrażenie"
        },
        trigger: {
            expression: "Wyrażenie"
        },
        calculatedvalue: {
            expression: "Wyrażenie"
        },
        // survey templates
        survey: {
            title: "Tytuł",
            description: "Opis ankiety"
        },
        page: {
            name: "Nazwa strony",
            title: "Tytuł",
            description: "Opis strony",
            visibleIf: "Spraw, aby strona była widoczna, jeśli",
            requiredIf: "Ustaw stronę jako wymaganą, jeśli",
            maxTimeToFinish: "Limit czasu na zakończenie strony (w sekundach)",
            questionsOrder: "Kolejność pytań na stronie"
        },
        matrixdropdowncolumn: {
            name: "Nazwa kolumny",
            title: "Tytuł kolumny",
            isUnique: "Zapobieganie zduplikowanym odpowiedziom",
            width: "Szerokość kolumny",
            minWidth: "Minimalna szerokość kolumny",
            rows: "Wysokość pola wejściowego (w wierszach)",
            visibleIf: "Ustaw kolumnę jako widoczną, jeśli",
            requiredIf: "Ustaw kolumnę jako wymaganą, jeśli",
            showInMultipleColumns: "Każda opcja w osobnej kolumnie"
        },
        multipletextitem: {
            name: "Nazwa",
            title: "Tytuł"
        },
        masksettings: {
            saveMaskedValue: "Zapisywanie zamaskowanej wartości w wynikach ankiety"
        },
        patternmask: {
            pattern: "Wzorzec wartości"
        },
        datetimemask: {
            min: "Wartość minimalna",
            max: "Wartość maksymalna"
        },
        numericmask: {
            allowNegativeValues: "Zezwalaj na wartości ujemne",
            thousandsSeparator: "Separator tysięcy",
            decimalSeparator: "Separator dziesiętny",
            precision: "Precyzja wartości",
            min: "Wartość minimalna",
            max: "Wartość maksymalna"
        },
        currencymask: {
            prefix: "Prefiks waluty",
            suffix: "Sufiks waluty"
        },
        imageHeight: "Image height",
        imageWidth: "Image width",
        valueName: "Value name",
        rateDescriptionLocation: "Wyrównanie etykiety",
        size: "Rozmiar pola wejściowego (w znakach)",
        cellErrorLocation: "Wyrównanie komunikatu o błędzie komórki",
        apply: "Zastosuj",
        ok: "OK",
        save: "Zapisać",
        clear: "Jasny",
        saveTooltip: "Zapisać",
        cancel: "Anuluj",
        set: "Zbiór",
        reset: "Resetuj",
        change: "Zmieniać",
        refresh: "Odświeżyć",
        close: "Zamknij",
        delete: "Usuń",
        add: "Dodawać",
        addNew: "Dodaj nową",
        addItem: "Kliknij, aby dodać element...",
        removeItem: "Kliknij, aby usunąć element...",
        dragItem: "Przeciągnij element",
        addOther: "Inny",
        addSelectAll: "Zaznacz wszystko",
        addNone: "Żaden",
        removeAll: "Usuń wszystkie",
        edit: "Edytuj",
        back: "Zwrot bez zapisywania",
        backTooltip: "Zwrot bez zapisywania",
        saveAndBack: "Zapisz i zwróć",
        saveAndBackTooltip: "Zapisz i zwróć",
        doneEditing: "Gotowy",
        editChoices: "Edytuj opcje",
        showChoices: "Pokaż wybór",
        move: "Ruszać",
        empty: "<pusty>",
        emptyValue: "Wartość jest pusta",
        fastEntry: "Szybkie wprowadzanie",
        fastEntryNonUniqueError: "Wartość \"{0}\" nie jest unikalna",
        fastEntryChoicesCountError: "Ogranicz liczbę przedmiotów od {0} do {1}",
        fastEntryChoicesMinCountError: "Podaj co najmniej {0} przedmiotów",
        fastEntryPlaceholder: "Dane można ustawić w następującym formacie:\nwartość1|tekst\nwartość2",
        formEntry: "Formularz",
        testService: "Testuj usługę",
        itemSelectorEmpty: "Proszę wybrać element",
        conditionActionEmpty: "Wybierz akcję",
        conditionSelectQuestion: "Wybierz pytanie...",
        conditionSelectPage: "Wybierz stronę...",
        conditionSelectPanel: "Wybierz panel...",
        conditionValueQuestionTitle: "Wpisz/wybierz wartość",
        aceEditorHelp: "Press ctrl+space to get expression completion hint",
        aceEditorRowTitle: "Current row",
        aceEditorPanelTitle: "Current panel",
        showMore: "For more details please check the documentation",
        assistantTitle: "Available questions:",
        cellsEmptyRowsColumns: "Powinna istnieć co najmniej jedna kolumna lub wiersz",
        showPreviewBeforeComplete: "Podgląd odpowiedzi przed wysłaniem ankiety",
        overridingPropertyPrefix: "Ustaw przez ",
        resetToDefaultCaption: "Resetować",
        propertyIsEmpty: "Podaj wartość",
        propertyIsNoUnique: "Podaj unikatową wartość",
        propertyNameIsNotUnique: "Podaj unikalną nazwę",
        propertyNameIsIncorrect: "Nie używaj zastrzeżonych słów: \"element\", \"wybór\", \"panel\", \"wiersz\".",
        listIsEmpty: "Nie dodano jeszcze żadnych przedmiotów",
        "listIsEmpty@choices": "Nie dodano jeszcze żadnych opcji",
        "listIsEmpty@columns": "Nie masz jeszcze żadnych kolumn",
        "listIsEmpty@rows": "Nie masz jeszcze żadnych wierszy",
        "listIsEmpty@validators": "Nie masz jeszcze żadnych reguł sprawdzania poprawności",
        "listIsEmpty@calculatedValues": "Nie masz jeszcze żadnych zmiennych niestandardowych",
        "listIsEmpty@triggers": "Nie masz jeszcze żadnych wyzwalaczy",
        "listIsEmpty@navigateToUrlOnCondition": "Nie masz jeszcze żadnych linków",
        "addNew@choices": "Dodaj wybór",
        "addNew@columns": "Dodaj nową kolumnę",
        "addNew@rows": "Dodaj nowy wiersz",
        "addNew@validators": "Dodaj nową regułę",
        "addNew@calculatedValues": "Dodaj nową zmienną",
        "addNew@triggers": "Dodaj nowy wyzwalacz",
        "addNew@navigateToUrlOnCondition": "Dodaj nowy adres URL",
        expressionIsEmpty: "Wyrażenie jest puste",
        value: "Wartość",
        text: "Etykieta",
        rowid: "Identyfikator wiersza",
        imageLink: "Adres URL obrazu lub filmu",
        columnEdit: "Edit column: {0}",
        itemEdit: "Edit item: {0}",
        url: "URL",
        path: "Path",
        choicesbyurl: {
            url: "Adres URL usługi sieci Web",
            valueName: "Pobierz wartości z następującego pola JSON:"
        },
        titleName: "Title name",
        imageLinkName: "Pobierz adresy URL obrazów z następującego pola JSON:",
        allowEmptyResponse: "Zezwalaj na pustą odpowiedź",
        titlePlaceholder: "Tytuł",
        surveyTitlePlaceholder: "Tytuł ankiety",
        pageTitlePlaceholder: "Strona {num}",
        descriptionPlaceholder: "Opis",
        surveyDescriptionPlaceholder: "Opis",
        pageDescriptionPlaceholder: "Opis",
        textWrapEnabled: "Opcje zawijania",
        showOtherItem: "Czy możliwa własna odpowiedź",
        otherText: "Other item text",
        showNoneItem: "Zezwalaj na opcję Brak",
        showRefuseItem: "Zezwól na opcję Odmów odpowiedzi",
        showDontKnowItem: "Zezwól na opcję Nie wiem",
        noneText: "Tekst opcji Brak",
        showSelectAllItem: "Zezwalaj na opcję Zaznacz wszystko",
        selectAllText: "Zaznacz tekst opcji Wszystkie",
        choicesMin: "Minimalna wartość dla automatycznie wygenerowanych elementów",
        choicesMax: "Maksymalna wartość dla automatycznie wygenerowanych elementów",
        choicesStep: "Krok dla automatycznie wygenerowanych elementów",
        name: "Nazwa",
        title: "Etykieta",
        cellType: "Typ komórki",
        colCount: "Liczba kolumn",
        choicesOrder: "Kolejność odpowiedzi",
        visible: "Czy widoczne?",
        isRequired: "Czy wymagalne?",
        markRequired: "Oznacz jako wymagane",
        removeRequiredMark: "Usuń wymagany znacznik",
        isAllRowRequired: "Wymagaj odpowiedzi dla wszystkich wierszy",
        eachRowUnique: "Zapobieganie zduplikowanym odpowiedziom w wierszach",
        requiredErrorText: "Komunikat o błędzie \"Wymagane\"",
        startWithNewLine: "Czy rozpoczyna się nową linią?",
        rows: "Liczba wierszy",
        cols: "Kolumny",
        placeholder: "Input place holder",
        showPreview: "Show preview area",
        storeDataAsText: "Store file content in JSON result as text",
        maxSize: "Maximum file size in bytes",
        rowCount: "Row count",
        columnLayout: "Układ kolumn",
        addRowLocation: "Lokalizacja przycisku Dodaj wiersz",
        transposeData: "Transponowanie wierszy do kolumn",
        addRowText: "Add row button text",
        removeRowText: "Remove row button text",
        rateMin: "Minimalna wartość stawki",
        rateMax: "Maksymalna wartość stawki",
        rateStep: "Krok stawki",
        minRateDescription: "Opis najniższej oceny",
        maxRateDescription: "Opis najwyższej oceny",
        inputType: "Input type",
        optionsCaption: "Options caption",
        defaultValue: "Default value",
        cellsDefaultRow: "Teksty domyślne",
        surveyEditorTitle: "Edytuj ankietę",
        qEditorTitle: "Edytuj: {0}",
        maxLength: "Maksymalna długość (w znakach)",
        buildExpression: "Budować",
        editExpression: "Redagować",
        and: "i",
        or: "lub",
        remove: "Usunąć",
        addCondition: "Dodaj warunek",
        emptyLogicPopupMessage: "Wybierz pytanie, aby rozpocząć konfigurowanie warunków.",
        if: "Jeśli",
        then: "wtedy",
        setToName: "Pytanie docelowe",
        fromName: "Pytanie, z którego należy skopiować odpowiedź",
        gotoName: "Pytanie, do którego należy przejść",
        ruleIsNotSet: "Reguła jest nieprawidłowa",
        includeIntoResult: "Uwzględnij w wynikach ankiety",
        showTitle: "Pokaż/ukryj tytuł",
        expandCollapseTitle: "Rozwiń/zwiń tytuł",
        locale: "Domyślny język",
        simulator: "Wybierz typ urządzenia",
        landscapeOrientation: "Przełączanie na orientację poziomą",
        portraitOrientation: "Przełączanie na orientację pionową",
        mode: "Tryb (edycja/podgląd)",
        clearInvisibleValues: "Usuń niewidoczne odpowiedzi",
        cookieName: "Cookie name (to disable run survey two times locally)",
        sendResultOnPageNext: "Send survey results on page next",
        storeOthersAsComment: "Store 'others' value in separate field",
        showPageTitles: "Show page titles",
        showPageNumbers: "Show page numbers",
        pagePrevText: "Page previous button text",
        pageNextText: "Page next button text",
        completeText: "Complete button text",
        previewText: "Tekst przycisku Podgląd odpowiedzi",
        editText: "Tekst przycisku Edytuj odpowiedź",
        startSurveyText: "Start button text",
        showNavigationButtons: "Show navigation buttons (default navigation)",
        showPrevButton: "Show previous button (user may return on previous page)",
        firstPageIsStarted: "The first page in the survey is a started page.",
        showCompletedPage: "Show the completed page at the end (completedHtml)",
        goNextPageAutomatic: "On answering all questions, go to the next page automatically",
        allowCompleteSurveyAutomatic: "Wypełnij ankietę automatycznie",
        showProgressBar: "Show progress bar",
        questionTitleLocation: "Question title location",
        questionTitleWidth: "Szerokość tytułu pytania",
        requiredText: "The question required symbol(s)",
        questionTitleTemplate: "Question title template, default is: '{no}. {require} {title}'",
        questionErrorLocation: "Question error location",
        focusFirstQuestionAutomatic: "Focus first question on changing the page",
        questionsOrder: "Elements order on the page",
        maxTimeToFinish: "Maximum time to finish the survey",
        maxTimeToFinishPage: "Maximum time to finish a page in the survey",
        showTimerPanel: "Show timer panel",
        showTimerPanelMode: "Show timer panel mode",
        renderMode: "Render mode",
        allowAddPanel: "Allow adding a panel",
        allowRemovePanel: "Allow removing the panel",
        panelAddText: "Adding panel text",
        panelRemoveText: "Removing panel text",
        isSinglePage: "Show all elements on one page",
        html: "Znaczniki HTML",
        setValue: "Odpowiedź",
        dataFormat: "Format obrazu",
        allowAddRows: "Zezwalaj na dodawanie wierszy",
        allowRemoveRows: "Zezwalaj na usuwanie wierszy",
        allowRowsDragAndDrop: "Zezwalaj na przeciąganie i upuszczanie wierszy",
        responsiveImageSizeHelp: "Nie ma zastosowania, jeśli określisz dokładną szerokość lub wysokość obrazu.",
        minImageWidth: "Minimalna szerokość obrazu",
        maxImageWidth: "Maksymalna szerokość obrazu",
        minImageHeight: "Minimalna wysokość obrazu",
        maxImageHeight: "Maksymalna wysokość obrazu",
        minValue: "Wartość minimalna",
        maxValue: "Wartość maksymalna",
        minLength: "Minimalna długość (w znakach)",
        allowDigits: "Zezwalaj na cyfry",
        minCount: "Minimalna liczba",
        maxCount: "Maksymalna liczba",
        regex: "Wyrażenie regularne",
        surveyvalidator: {
            text: "Komunikat o błędzie",
            expression: "Wyrażenie sprawdzania poprawności"
        },
        totalText: "Tekst wiersza sumy",
        totalType: "Typ sumy",
        totalExpression: "Wyrażenie całkowite",
        totalDisplayStyle: "Styl wyświetlania łącznej wartości",
        totalCurrency: "Waluta",
        totalFormat: "Sformatowany ciąg znaków",
        logo: "Logo (adres URL lub ciąg znaków zakodowany w formacie base64)",
        questionsOnPageMode: "Struktura badania",
        maxTextLength: "Maksymalna długość odpowiedzi (w znakach)",
        maxOthersLength: "Maksymalna długość komentarza (w znakach)",
        commentAreaRows: "Wysokość obszaru komentarza (w wierszach)",
        autoGrowComment: "W razie potrzeby automatycznie rozwiń obszar komentarza",
        allowResizeComment: "Zezwalaj użytkownikom na zmianę rozmiaru obszarów tekstu",
        textUpdateMode: "Aktualizowanie wartości pytania tekstowego",
        maskType: "Typ maski wprowadzania",
        maskTypes: {
            none: "Żaden",
            patternmask: "Deseń",
            numericmask: "Numeryczny",
            datetimemask: "Data i godzina",
            currencymask: "Waluta"
        },
        focusOnFirstError: "Ustaw fokus na pierwszej nieprawidłowej odpowiedzi",
        checkErrorsMode: "Sprawdzanie poprawności uruchamiania",
        navigateToUrl: "Przejdź do adresu URL",
        navigateToUrlOnCondition: "Dynamiczny adres URL",
        completedBeforeHtml: "Znaczniki, aby pokazać, czy użytkownik już wypełnił tę ankietę",
        completedHtml: "Znaczniki strony Survey Complete",
        completedHtmlOnCondition: "Znaczniki strony Dynamic Survey Complete",
        loadingHtml: "Znaczniki do pokazania podczas ładowania modelu ankiety",
        commentText: "Tekst w obszarze komentarza",
        autocomplete: "Typ autouzupełniania",
        labelTrue: "Etykieta \"prawdziwa\"",
        labelFalse: "Etykieta \"Fałsz\"",
        allowClear: "Pokaż przycisk Wyczyść",
        searchMode: "Tryb wyszukiwania",
        displayStyle: "Styl wyświetlania wartości",
        format: "Sformatowany ciąg znaków",
        maximumFractionDigits: "Maksymalna liczba cyfr ułamkowych",
        minimumFractionDigits: "Minimalne cyfry ułamkowe",
        useGrouping: "Wyświetlanie separatorów grupujących",
        allowMultiple: "Zezwalaj na wiele plików",
        allowImagesPreview: "Podgląd obrazów",
        acceptedTypes: "Akceptowane typy plików",
        waitForUpload: "Poczekaj na zakończenie przesyłania",
        needConfirmRemoveFile: "Potwierdź usunięcie pliku",
        detailPanelMode: "Położenie panelu szczegółów",
        minRowCount: "Minimalna liczba wierszy",
        maxRowCount: "Maksymalna liczba wierszy",
        confirmDelete: "Potwierdź usunięcie wiersza",
        confirmDeleteText: "Komunikat potwierdzenia",
        panelCount: "Początkowa liczba paneli",
        minPanelCount: "Minimalna liczba paneli",
        maxPanelCount: "Maksymalna liczba paneli",
        panelsState: "Stan rozwinięcia panelu wewnętrznego",
        panelPrevText: "Poprzednia etykietka przycisku panelu",
        panelNextText: "Przycisk Następny panel — etykietka narzędzia",
        showRangeInProgress: "Pokaż pasek postępu",
        panelRemoveButtonLocation: "Usuń położenie przycisku panelu",
        hideIfRowsEmpty: "Ukryj pytanie, jeśli nie ma wierszy",
        hideColumnsIfEmpty: "Ukryj kolumny, jeśli nie ma wierszy",
        rateValues: "Niestandardowe wartości stawek",
        rateCount: "Liczba stawek",
        autoGenerate: "Jak określić wartości stawek?",
        hideIfChoicesEmpty: "Ukryj pytanie, jeśli nie zawiera opcji wyboru",
        minWidth: "Minimalna szerokość (w wartościach akceptowanych przez CSS)",
        maxWidth: "Maksymalna szerokość (w wartościach akceptowanych przez CSS)",
        width: "Szerokość (w wartościach akceptowanych przez CSS)",
        showHeader: "Pokaż nagłówki kolumn",
        horizontalScroll: "Pokaż poziomy pasek przewijania",
        columnMinWidth: "Minimalna szerokość kolumny (w wartościach akceptowanych przez CSS)",
        rowTitleWidth: "Szerokość nagłówka wiersza (w wartościach akceptowanych przez CSS)",
        valueTrue: "\"Prawdziwa\" wartość",
        valueFalse: "Wartość \"False\"",
        minErrorText: "Komunikat o błędzie \"Wartość jest niższa niż minimalna\"",
        maxErrorText: "Komunikat o błędzie \"Wartość przekracza maksimum\"",
        otherErrorText: "Komunikat o błędzie \"Pusty komentarz\"",
        keyDuplicationError: "Komunikat o błędzie \"Nieunikalna wartość klucza\"",
        minSelectedChoices: "Minimalna wybrana opcja",
        maxSelectedChoices: "Maksymalna liczba wybranych opcji",
        showClearButton: "Pokaż przycisk Wyczyść",
        logoWidth: "Szerokość logo (w wartościach akceptowanych przez CSS)",
        logoHeight: "Wysokość logo (w wartościach akceptowanych przez CSS)",
        readOnly: "Tylko do odczytu",
        enableIf: "Edytowalne, jeśli",
        emptyRowsText: "Komunikat \"Brak wierszy\"",
        separateSpecialChoices: "Oddzielne opcje specjalne (Brak, Inne, Wybierz wszystko)",
        choicesFromQuestion: "Kopiowanie opcji z następującego pytania",
        choicesFromQuestionMode: "Które opcje skopiować?",
        progressBarShowPageTitles: "Wyświetlanie tytułów stron na pasku postępu",
        progressBarShowPageNumbers: "Wyświetlanie numerów stron na pasku postępu",
        showCommentArea: "Pokaż obszar komentarza",
        commentPlaceholder: "Symbol zastępczy obszaru komentarza",
        displayRateDescriptionsAsExtremeItems: "Wyświetlanie opisów szybkości jako wartości ekstremalnych",
        rowsOrder: "Kolejność wierszy",
        columnsLayout: "Układ kolumn",
        columnColCount: "Liczba kolumn zagnieżdżonych",
        correctAnswer: "Prawidłowa odpowiedź",
        defaultPanelValue: "Wartości domyślne",
        cells: "Teksty komórek",
        fileInputPlaceholder: "Wybierz plik lub wklej link do pliku...",
        keyName: "Kolumna klucza",
        itemvalue: {
            visibleIf: "Uwidocznij opcję, jeśli",
            enableIf: "Spraw, aby opcja była wybieralna, jeśli"
        },
        "itemvalue@rows": {
            visibleIf: "Uwidocznij wiersz, jeśli",
            enableIf: "Umożliwia edycję wiersza, jeśli"
        },
        imageitemvalue: {
            text: "Tekst alternatywny"
        },
        logoPosition: "Pozycja logo",
        addLogo: "Dodaj logo...",
        changeLogo: "Zmień logo...",
        logoPositions: {
            none: "Usuń logo",
            left: "Lewy",
            right: "Prawy",
            top: "Na górze",
            bottom: "Na dole"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Układ panelu"
            },
            general: "Ogólne",
            fileOptions: "Options",
            html: "Html Editor",
            columns: "Kolumny",
            rows: "Wiersze",
            choices: "Odpowiedzi",
            items: "Elementy",
            visibleIf: "Widoczne jeśli",
            enableIf: "Enable If",
            requiredIf: "Wymagane, jeśli",
            rateValues: "Wartość oceny",
            choicesByUrl: "Odpowiedzi z webserwisu",
            matrixChoices: "Default Choices",
            multipleTextItems: "Text Inputs",
            numbering: "Numerowanie",
            validators: "Validators",
            navigation: "Navigation",
            question: "Question",
            pages: "Stron",
            timer: "Timer/Quiz",
            calculatedValues: "Obliczone wartości",
            triggers: "Triggers",
            templateTitle: "Template title",
            totals: "Sumy",
            logic: "Logika",
            mask: "Ustawienia maski wprowadzania",
            layout: {
                panel: "Układ",
                question: "Układ",
                base: "Układ"
            },
            data: "Dane",
            validation: "Walidacja",
            cells: "Teksty komórek",
            showOnCompleted: "Ankieta zakończona",
            logo: "Logo w tytule ankiety",
            slider: "Suwak",
            expression: "Wyrażenie",
            questionSettings: "Ustawienia pytań",
            header: "Nagłówek",
            background: "Tło",
            appearance: "Wygląd",
            others: "Inni"
        },
        editProperty: "Edit property '{0}'",
        items: "Items",
        choicesVisibleIf: "Wybory są widoczne, jeśli",
        choicesEnableIf: "Wybory można wybrać, jeśli:",
        columnsEnableIf: "Kolumny są widoczne, jeśli",
        rowsEnableIf: "Wiersze są widoczne, jeśli",
        innerIndent: "Dodawanie wcięć wewnętrznych",
        defaultValueFromLastRow: "Pobieranie wartości domyślnych z ostatniego wiersza",
        defaultValueFromLastPanel: "Pobieranie wartości domyślnych z ostatniego panelu",
        enterNewValue: "Please, enter the value.",
        noquestions: "There is no any question in the survey.",
        createtrigger: "Please create a trigger",
        titleKeyboardAdornerTip: "Naciśnij przycisk Enter, aby edytować",
        keyboardAdornerTip: "Naciśnij przycisk Enter, aby edytować element, naciśnij przycisk Delete, aby usunąć element, naciśnij Alt plus strzałka w górę lub strzałka w dół, aby przenieść element",
        triggerOn: "On ",
        triggerMakePagesVisible: "Make pages visible:",
        triggerMakeQuestionsVisible: "Make elements visible:",
        triggerCompleteText: "Complete the survey if succeed.",
        triggerNotSet: "The trigger is not set",
        triggerRunIf: "Run if",
        triggerSetToName: "Change value of: ",
        triggerFromName: "Skopiuj wartość z: ",
        triggerRunExpression: "Uruchom to wyrażenie",
        triggerSetValue: "to: ",
        triggerGotoName: "Przejdź do pytania",
        triggerIsVariable: "Do not put the variable into the survey result.",
        triggerRunExpressionEmpty: "Wpisz poprawne wyrażenie",
        emptyExpressionPlaceHolder: "Wpisz wyrażenie tutaj...",
        noFile: "Nie wybrano pliku",
        clearIfInvisible: "Wyczyść wartość, jeśli pytanie zostanie ukryte",
        valuePropertyName: "Nazwa właściwości Value",
        searchEnabled: "Włącz wyszukiwanie",
        hideSelectedItems: "Ukrywanie zaznaczonych elementów",
        closeOnSelect: "Zamknij listę rozwijaną po dokonaniu wyboru",
        verticalAlign: "Wyrównanie w pionie",
        alternateRows: "Alternatywne wiersze",
        columnsVisibleIf: "Kolumny są widoczne, jeśli",
        rowsVisibleIf: "Wiersze są widoczne, jeśli",
        otherPlaceholder: "Symbol zastępczy obszaru komentarza",
        filePlaceholder: "Tekst zastępczy pliku",
        photoPlaceholder: "Tekst zastępczy zdjęcia",
        fileOrPhotoPlaceholder: "Tekst zastępczy pliku lub zdjęcia",
        rateType: "Rodzaj stawki",
        url_placeholder: "Przykład: https://api.example.com/books",
        path_placeholder: "Np.: kategorie.beletrystyka",
        questionStartIndex_placeholder: "Np.: a)",
        width_placeholder: "Np.: 6 cali",
        minWidth_placeholder: "Przykład: 600 pikseli",
        maxWidth_placeholder: "Przykład: 50%",
        imageHeight_placeholder: "Automatycznie",
        imageWidth_placeholder: "Automatycznie",
        theme: {
            themeName: "Kompozycja",
            isPanelless: "Wygląd pytania",
            editorPanel: "Tło i promień narożnika",
            questionPanel: "Tło i promień narożnika",
            primaryColor: "Kolor akcentujący",
            panelBackgroundTransparency: "Krycie tła panelu",
            questionBackgroundTransparency: "Nieprzezroczystość tła pytania",
            fontSize: "Rozmiar czcionki",
            scale: "Skala",
            cornerRadius: "Promień naroża",
            pageTitle: "Czcionka tytułu",
            pageDescription: "Czcionka opisu",
            questionTitle: "Czcionka tytułu",
            questionDescription: "Czcionka opisu",
            editorFont: "Czcionka",
            backgroundOpacity: "Nieprzezroczystość",
            "--sjs-font-family": "Rodzina czcionek",
            "--sjs-general-backcolor-dim": "Kolor tła",
            "--sjs-primary-backcolor": "Tło akcentu",
            "--sjs-primary-forecolor": "Akcent na pierwszym planie",
            "--sjs-special-red": "Komunikaty o błędach",
            "--sjs-shadow-small": "Efekty cienia",
            "--sjs-shadow-inner": "Efekty cienia",
            "--sjs-border-default": "Kolory"
        },
        "header@header": {
            headerView: "Widok",
            logoPosition: "Pozycja logo",
            surveyTitle: "Czcionka tytułu ankiety",
            surveyDescription: "Czcionka opisu ankiety",
            headerTitle: "Czcionka tytułu ankiety",
            headerDescription: "Czcionka opisu ankiety",
            inheritWidthFrom: "Szerokość obszaru zawartości",
            textAreaWidth: "Szerokość tekstu",
            backgroundColorSwitch: "Kolor tła",
            backgroundImage: "Obraz w tle",
            backgroundImageOpacity: "Nieprzezroczystość",
            overlapEnabled: "Zachodzić na siebie",
            logoPositionX: "Pozycja logo",
            titlePositionX: "Pozycja tytułu",
            descriptionPositionX: "Opis pozycja"
        }
    },
    // Property values
    pv: {
        "true": "prawdziwy",
        "false": "fałszywy",
        file: "Pliki lokalne",
        camera: "Kamera",
        "file-camera": "Pliki lokalne lub aparat",
        inherit: "Odziedziczyć",
        show: "Widoczny",
        hide: "Ukryty",
        default: "Odziedziczyć",
        initial: "Inicjał",
        random: "Losowy",
        collapsed: "Zwinięty",
        expanded: "Rozszerzony",
        none: "Żaden",
        asc: "Rosnąco",
        desc: "Malejąco",
        indeterminate: "Nieokreślony",
        selected: "Wybrany",
        unselected: "Niezaznaczone",
        decimal: "dziesiętny",
        currency: "waluta",
        percent: "procent",
        firstExpanded: "Pierwszy panel jest rozwinięty",
        off: "Ukryj numery pytań",
        list: "Lista",
        progressTop: "Nawigator paneli + pasek postępu u góry",
        progressBottom: "Nawigator panelu + pasek postępu u dołu",
        progressTopBottom: "Nawigator panelu + pasek postępu u góry i u dołu",
        tab: "Karty",
        horizontal: "Poziomy",
        vertical: "Pionowy",
        top: "Do góry",
        bottom: "Dno",
        topBottom: "Góra i dół",
        both: "Obie",
        left: "Lewy",
        right: "Prawy",
        center: "Centrum",
        leftRight: "Lewy i prawy",
        middle: "Środek",
        color: "Kolor",
        date: "data",
        datetime: "datagodzina",
        "datetime-local": "datetime-local",
        email: "E-mail",
        month: "miesiąc",
        number: "numer",
        password: "hasło",
        range: "zakres",
        tel: "Tel",
        text: "Tekst",
        time: "Godzina",
        url: "adres URL",
        week: "tydzień",
        hidden: "Ukryty",
        edit: "Edytowalny",
        display: "Tylko do odczytu",
        contain: "Zawierać",
        cover: "Pokryć",
        fill: "Wypełnić",
        next: "Następny",
        last: "Ostatni",
        onComplete: "Po zakończeniu ankiety",
        onHidden: "Gdy pytanie zostanie ukryte",
        onHiddenContainer: "Gdy pytanie lub jego panel/strona zostaną ukryte",
        clearInvisibleValues: {
            none: "Nigdy"
        },
        clearIfInvisible: {
            none: "Nigdy"
        },
        inputType: {
            color: "Kolor",
            date: "Data",
            "datetime-local": "Data i godzina",
            email: "E-mail",
            month: "Miesiąc",
            number: "Numer",
            password: "Hasło",
            range: "Zakres",
            tel: "Numer",
            text: "Tekst",
            time: "Godzina",
            url: "Adres URL",
            week: "Tydzień"
        },
        all: "Cały",
        page: "Strona",
        survey: "Sondaż",
        onNextPage: "Podczas przełączania do następnej strony",
        onValueChanged: "Po zmianie odpowiedzi",
        onValueChanging: "Zanim odpowiedź zostanie zmieniona",
        questionsOnPageMode: {
            standard: "Oryginalna struktura",
            singlePage: "Pokaż wszystkie pytania na jednej stronie",
            questionPerPage: "Pokaż pojedyncze pytanie na stronie"
        },
        noPreview: "Brak podglądu",
        showAllQuestions: "Pokaż wszystkie pytania",
        showAnsweredQuestions: "Pokaż tylko odpowiedzi na pytania",
        pages: "Ukończone strony",
        questions: "Odpowiedzi na pytania",
        requiredQuestions: "Odpowiedzi na wymagane pytania",
        correctQuestions: "Prawidłowe odpowiedzi",
        buttons: "Ukończone strony (interfejs użytkownika)",
        underInput: "Pod wejściem",
        underTitle: "Pod tytułem",
        onBlur: "Na rozmyciu",
        onTyping: "Podczas pisania",
        underRow: "Pod rzędem",
        underRowSingle: "Pod wierszem widoczny jest tylko jeden panel",
        auto: "Automatycznie",
        showNavigationButtons: {
            none: "Ukryty"
        },
        showTimerPanel: {
            none: "Ukryty"
        },
        showTimerPanelMode: {
            all: "Obie"
        },
        addRowLocation: {
            default: "Zależy od układu macierzy"
        },
        panelsState: {
            default: "Użytkownicy nie mogą rozwijać ani zwijać paneli",
            collapsed: "Wszystkie panele są zwinięte",
            expanded: "Wszystkie panele są rozszerzone",
            firstExpanded: "Pierwsze rozszerzone"
        },
        widthMode: {
            static: "Statyczny",
            responsive: "Elastyczne"
        },
        contentMode: {
            image: "Obraz",
            video: "Wideo",
            youtube: "Serwis YouTube"
        },
        displayMode: {
            buttons: "Przyciski",
            dropdown: "Lista rozwijana"
        },
        rateColorMode: {
            default: "Domyślny",
            scale: "Skala"
        },
        scaleColorMode: {
            monochrome: "Monochromatyczny",
            colored: "Kolorowe"
        },
        autoGenerate: {
            "true": "Stworzyć",
            "false": "Wprowadź ręcznie"
        },
        rateType: {
            labels: "Etykiety",
            stars: "Gwiazdy",
            smileys: "Uśmieszki"
        },
        state: {
            default: "Zablokowany"
        },
        showQuestionNumbers: {
            default: "Automatyczne numerowanie",
            on: "Automatyczne numerowanie",
            onPage: "Resetuj na każdej stronie",
            onpanel: "Resetuj na każdym panelu",
            onPanel: "Resetuj na każdym panelu",
            onSurvey: "Kontynuuj badanie",
            off: "Brak numeracji"
        },
        descriptionLocation: {
            underTitle: "Pod tytułem pytania",
            underInput: "Pod polem wprowadzania danych"
        },
        selectToRankAreasLayout: {
            horizontal: "Obok opcji do wyboru",
            vertical: "Powyższe wybory"
        },
        displayStyle: {
            decimal: "Dziesiętny",
            currency: "Waluta",
            percent: "Procent",
            date: "Data"
        },
        totalDisplayStyle: {
            decimal: "Dziesiętny",
            currency: "Waluta",
            percent: "Procent",
            date: "Data"
        },
        rowsOrder: {
            initial: "Oryginał"
        },
        questionsOrder: {
            initial: "Oryginał"
        },
        showProgressBar: {
            off: "Ukryty",
            topbottom: "Góra i dół",
            aboveheader: "Nad nagłówkiem",
            belowheader: "Pod nagłówkiem"
        },
        sum: "Suma",
        count: "Hrabia",
        min: "Min",
        max: "Max",
        avg: "Avg",
        searchMode: {
            contains: "Contains",
            startsWith: "Zaczyna się od"
        },
        backgroundImageFit: {
            auto: "Automatycznie",
            cover: "Pokryć",
            contain: "Zawierać",
            fill: "Rozciągnąć",
            tile: "Kafelek"
        },
        backgroundImageAttachment: {
            fixed: "Stały",
            scroll: "Przewijać"
        },
        headerView: {
            basic: "Podstawowy",
            advanced: "Zaawansowany"
        },
        inheritWidthFrom: {
            survey: "Tak samo jak ankieta",
            container: "Pasuje do pojemnika"
        },
        backgroundColorSwitch: {
            none: "Żaden",
            accentColor: "Kolor akcentujący",
            custom: "Zwyczaj"
        },
        colorPalette: {
            light: "Światło",
            dark: "Ciemny"
        },
        isPanelless: {
            "false": "Domyślny",
            "true": "Bez paneli"
        }
    },
    // Operators
    op: {
        empty: "is empty",
        notempty: "is not empty",
        equal: "equals",
        notequal: "not equals",
        contains: "contains",
        notcontains: "not contains",
        anyof: "Dowolny z",
        allof: "Wszystko z",
        greater: "greater",
        less: "less",
        greaterorequal: "greater or equals",
        lessorequal: "Less or Equals",
        and: "i",
        or: "lub"
    },
    // Embed window
    ew: {
        angular: "Use Angular version",
        jquery: "Use jQuery version",
        knockout: "Use Knockout version",
        react: "Use React version",
        vue: "Use Vue version",
        bootstrap: "For bootstrap framework",
        modern: "Nowoczesny motyw",
        default: "Motyw domyślny",
        orange: "Kompozycja pomarańczowa",
        darkblue: "Kompozycja Ciemnoniebieski",
        darkrose: "Kompozycja Darkrose",
        stone: "Kompozycja Kamień",
        winter: "Kompozycja zimowa",
        winterstone: "Kompozycja Kamień zimowy",
        showOnPage: "Show survey on a page",
        showInWindow: "Show survey in a window",
        loadFromServer: "Load Survey JSON from server",
        titleScript: "Scripts and styles",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Wybierz stronę, aby ją przetestować:",
        showInvisibleElements: "Pokaż niewidoczne elementy",
        hideInvisibleElements: "Ukryj niewidoczne elementy"
    },
    validators: {
        answercountvalidator: "answer count",
        emailvalidator: "e-mail",
        expressionvalidator: "Wyrażenie",
        numericvalidator: "numeric",
        regexvalidator: "regex",
        textvalidator: "text"
    },
    triggers: {
        completetrigger: "complete survey",
        setvaluetrigger: "set value",
        copyvaluetrigger: "Kopiuj odpowiedź",
        skiptrigger: "Przejdź do pytania",
        runexpressiontrigger: "Uruchom wyrażenie",
        visibletrigger: "change visibility"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Np.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Np.: mm/dd/rrrr"
        },
        currencymask: {
            prefix: "Przykład: $",
            suffix: "Np.: USD"
        },
        panelbase: {
            questionTitleWidth: "Przykład: 200 pikseli"
        }
    },
    pehelp: {
        panel: {
            name: "Identyfikator panelu, który nie jest widoczny dla respondentów.",
            description: "Wpisz podtytuł panelu.",
            visibleIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa widoczność panelu.",
            enableIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która wyłącza tryb tylko do odczytu dla panelu.",
            requiredIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która uniemożliwia przesłanie ankiety, chyba że co najmniej jedno zagnieżdżone pytanie ma odpowiedź.",
            questionTitleLocation: "Dotyczy wszystkich pytań w tym panelu. Jeśli chcesz zastąpić to ustawienie, zdefiniuj reguły wyrównania tytułów dla poszczególnych pytań. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety (domyślnie \"Góra\").",
            questionTitleWidth: "Ustawia spójną szerokość tytułów pytań, gdy są one wyrównane do lewej strony pól pytań. Akceptuje wartości CSS (px, %, in, pt itp.).",
            questionErrorLocation: "Ustawia lokalizację komunikatu o błędzie w odniesieniu do wszystkich pytań w panelu. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety.",
            questionsOrder: "Zachowuje pierwotną kolejność pytań lub losuje je. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety.",
            page: "Przesuwa panel na koniec zaznaczonej strony.",
            innerIndent: "Dodaje odstęp lub margines między zawartością panelu a lewą krawędzią ramki panelu.",
            startWithNewLine: "Usuń zaznaczenie, aby wyświetlić panel w jednym wierszu z poprzednim pytaniem lub panelem. To ustawienie nie ma zastosowania, jeśli panel jest pierwszym elementem formularza.",
            state: "Do wyboru: \"Rozwinięty\" - panel wyświetla się w całości i można go zwinąć; \"Zwinięty\" - panel wyświetla tylko tytuł i opis i można go rozwinąć; \"Zablokowany\" - panel jest wyświetlany w całości i nie można go zwinąć.",
            width: "Ustawia szerokość panelu proporcjonalnie do innych elementów pomiarowych w tej samej linii. Akceptuje wartości CSS (px, %, in, pt itp.)."
        },
        paneldynamic: {
            name: "Identyfikator panelu, który nie jest widoczny dla respondentów.",
            description: "Wpisz podtytuł panelu.",
            visibleIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa widoczność panelu.",
            enableIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która wyłącza tryb tylko do odczytu dla panelu.",
            requiredIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która uniemożliwia przesłanie ankiety, chyba że co najmniej jedno zagnieżdżone pytanie ma odpowiedź.",
            templateTitleLocation: "Dotyczy wszystkich pytań w tym panelu. Jeśli chcesz zastąpić to ustawienie, zdefiniuj reguły wyrównania tytułów dla poszczególnych pytań. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety (domyślnie \"Góra\").",
            templateErrorLocation: "Ustawia lokalizację komunikatu o błędzie w odniesieniu do pytania z nieprawidłowymi danymi wejściowymi. Wybierz pomiędzy: \"Góra\" - tekst błędu jest umieszczany w górnej części pola pytania; \"Na dole\" — tekst błędu jest umieszczany u dołu pola pytania. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety (domyślnie \"Góra\").",
            errorLocation: "Ustawia lokalizację komunikatu o błędzie w odniesieniu do wszystkich pytań w panelu. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety.",
            page: "Przesuwa panel na koniec zaznaczonej strony.",
            innerIndent: "Dodaje odstęp lub margines między zawartością panelu a lewą krawędzią ramki panelu.",
            startWithNewLine: "Usuń zaznaczenie, aby wyświetlić panel w jednym wierszu z poprzednim pytaniem lub panelem. To ustawienie nie ma zastosowania, jeśli panel jest pierwszym elementem formularza.",
            state: "Do wyboru: \"Rozwinięty\" - panel wyświetla się w całości i można go zwinąć; \"Zwinięty\" - panel wyświetla tylko tytuł i opis i można go rozwinąć; \"Zablokowany\" - panel jest wyświetlany w całości i nie można go zwinąć.",
            width: "Ustawia szerokość panelu proporcjonalnie do innych elementów pomiarowych w tej samej linii. Akceptuje wartości CSS (px, %, in, pt itp.).",
            templateTitle: "Wpisz szablon dynamicznych tytułów paneli. Użyj {panelIndex} dla ogólnego położenia panelu i {visiblePanelIndex} dla jego kolejności wśród widocznych paneli. Wstaw te symbole zastępcze do wzoru, aby dodać automatyczną numerację.",
            templateTabTitle: "Wpisz szablon tytułów kart. Użyj {panelIndex} dla ogólnego położenia panelu i {visiblePanelIndex} dla jego kolejności wśród widocznych paneli. Wstaw te symbole zastępcze do wzoru, aby dodać automatyczną numerację.",
            tabTitlePlaceholder: "Tekst zastępczy dla tytułów tabulatorów, który ma zastosowanie, gdy wzorzec tytułu tabulatora nie generuje znaczącej wartości.",
            templateVisibleIf: "To ustawienie umożliwia sterowanie widocznością poszczególnych paneli w panelu dynamicznym. Użyj symbolu zastępczego \"{panel}\", aby odwołać się do bieżącego panelu w wyrażeniu.",
            titleLocation: "To ustawienie jest automatycznie dziedziczone przez wszystkie pytania w tym panelu. Jeśli chcesz zastąpić to ustawienie, zdefiniuj reguły wyrównania tytułów dla poszczególnych pytań. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety (domyślnie \"Góra\").",
            descriptionLocation: "Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety (domyślnie \"Pod tytułem panelu\").",
            newPanelPosition: "Określa położenie nowo dodanego panelu. Domyślnie nowe panele są dodawane na końcu. Wybierz \"Dalej\", aby wstawić nowy panel po bieżącym.",
            defaultValueFromLastPanel: "Duplikuje odpowiedzi z ostatniego panelu i przypisuje je do następnego dodanego panelu dynamicznego.",
            keyName: "Odwołaj się do nazwy pytania, aby wymagać od użytkownika podania unikatowej odpowiedzi na to pytanie w każdym panelu."
        },
        defaultValueExpression: "To ustawienie umożliwia przypisanie domyślnej wartości odpowiedzi na podstawie wyrażenia. Wyrażenie może zawierać podstawowe obliczenia - '{q1_id} + {q2_id}', wyrażenia logiczne, takie jak '{wiek} > 60' oraz funkcje: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' itp. Wartość określona przez to wyrażenie służy jako początkowa wartość domyślna, która może zostać zastąpiona przez ręczne wprowadzanie danych przez respondenta.",
        resetValueIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa, kiedy dane wejściowe respondenta są resetowane do wartości na podstawie \"Wyrażenia wartości domyślnej\" lub \"Wyrażenia wartości domyślnej\" lub wartości \"Odpowiedź domyślna\" (jeśli którakolwiek z nich jest ustawiona).",
        setValueIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa, kiedy uruchomić \"Wyrażenie wartości zestawu\" i dynamicznie przypisać wynikową wartość jako odpowiedź.",
        setValueExpression: "Określ wyrażenie definiujące wartość, która ma zostać ustawiona, gdy zostaną spełnione warunki reguły \"Ustaw wartość, jeśli\". Wyrażenie może zawierać podstawowe obliczenia - '{q1_id} + {q2_id}', wyrażenia logiczne, takie jak '{wiek} > 60' oraz funkcje: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' itp. Wartość określona przez to wyrażenie może zostać zastąpiona przez ręczne wprowadzenie danych przez respondenta.",
        question: {
            name: "Identyfikator pytania, który nie jest widoczny dla respondentów.",
            description: "Wpisz podtytuł pytania.",
            visibleIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa widoczność pytania.",
            enableIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która wyłącza tryb tylko do odczytu dla pytania.",
            requiredIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która uniemożliwia przejście do przodu lub przesłanie ankiety, chyba że na pytanie otrzymano odpowiedź.",
            startWithNewLine: "Usuń zaznaczenie, aby wyświetlić pytanie w jednym wierszu z poprzednim pytaniem lub panelem. To ustawienie nie ma zastosowania, jeśli pytanie jest pierwszym elementem formularza.",
            page: "Zmienia położenie pytania na końcu zaznaczonej strony.",
            state: "Do wyboru: \"Rozwinięte\" - pole pytania wyświetla się w całości i można je zwinąć; \"Zwinięte\" - pole pytania wyświetla tylko tytuł i opis i można je rozwinąć; \"Zablokowane\" - pole pytania jest wyświetlane w całości i nie można go zwinąć.",
            titleLocation: "Zastępuje reguły wyrównania tytułów zdefiniowane na poziomie panelu, strony lub ankiety. Opcja \"Dziedzicz\" stosuje wszystkie ustawienia wyższego poziomu (jeśli są ustawione) lub ustawienia na poziomie ankiety (domyślnie \"Góra\").",
            descriptionLocation: "Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety (domyślnie \"Pod tytułem pytania\").",
            errorLocation: "Ustawia lokalizację komunikatu o błędzie w odniesieniu do pytania z nieprawidłowymi danymi wejściowymi. Wybierz pomiędzy: \"Góra\" - tekst błędu jest umieszczany w górnej części pola pytania; \"Na dole\" — tekst błędu jest umieszczany u dołu pola pytania. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety (domyślnie \"Góra\").",
            indent: "Dodaje spację lub margines między treścią pytania a lewą krawędzią pola pytania.",
            width: "Ustawia szerokość pytania proporcjonalnie do innych elementów ankiety w tym samym wierszu. Akceptuje wartości CSS (px, %, in, pt itp.).",
            surveyvalidator: {
                expression: "Użyj ikony magicznej różdżki, aby ustawić regułę sprawdzania poprawności dla pytania."
            },
            textUpdateMode: "Do wyboru: \"W przypadku utraty fokusu\" - wartość jest aktualizowana, gdy pole wejściowe traci fokus; \"Podczas pisania\" - wartość jest aktualizowana w czasie rzeczywistym, w miarę pisania przez użytkowników. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety (domyślnie \"Po utracie fokusu\").",
            url: "Możesz użyć dowolnej usługi internetowej jako źródła danych dla pytań wielokrotnego wyboru. Aby wypełnić wartości wyborów, wprowadź adres URL usługi udostępniającej dane.",
            searchMode: "Operacja porównania używana do filtrowania listy rozwijanej.",
            textWrapEnabled: "Długie teksty w opcjach wyboru automatycznie wygenerują podziały wierszy, aby zmieścić się w menu rozwijanym. Usuń zaznaczenie, jeśli chcesz, aby teksty zostały przycięte."
        },
        signaturepad: {
            signatureWidth: "Ustawia szerokość wyświetlanego obszaru podpisu i wynikowego obrazu.",
            signatureHeight: "Ustawia wysokość wyświetlanego obszaru podpisu i wynikowego obrazu.",
            signatureAutoScaleEnabled: "Wybierz, czy chcesz, aby obszar podpisu wypełniał całą dostępną przestrzeń w polu pytania, zachowując domyślny współczynnik proporcji 3:2. Po ustawieniu niestandardowych wartości szerokości i wysokości ustawienie zachowa proporcje tych wymiarów."
        },
        file: {
            imageHeight: "Dostosowuje wysokość obrazu w wynikach ankiety.",
            imageWidth: "Dostosowuje szerokość obrazu w wynikach ankiety."
        },
        image: {
            contentMode: "Opcja \"Auto\" automatycznie określa odpowiedni tryb wyświetlania - Obraz, Wideo lub YouTube - na podstawie podanego źródłowego adresu URL."
        },
        imagepicker: {
            imageHeight: "Zastępuje minimalne i maksymalne wartości wysokości.",
            imageWidth: "Zastępuje minimalne i maksymalne wartości szerokości.",
            choices: "\"Wartość\" służy jako identyfikator elementu używany w regułach warunkowych; Respondentom wyświetla się \"Tekst\".",
            contentMode: "Wybierz pomiędzy \"Obraz\" i \"Wideo\", aby ustawić tryb zawartości selektora multimediów. W przypadku wybrania opcji \"Obraz\" upewnij się, że wszystkie dostępne opcje są plikami graficznymi w następujących formatach: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Podobnie, jeśli wybrana jest opcja \"Wideo\", upewnij się, że wszystkie opcje są bezpośrednimi linkami do plików wideo w następujących formatach: MP4, MOV, WMV, FLV, AVI, MKV. Należy pamiętać, że linki do YouTube nie są obsługiwane w przypadku opcji wideo."
        },
        text: {
            size: "To ustawienie zmienia tylko rozmiar pola wejściowego i nie wpływa na szerokość pola pytania. Aby ograniczyć akceptowaną długość danych wejściowych, przejdź do <b>sekcji Walidacja → Maksymalny limit znaków</b>."
        },
        comment: {
            rows: "Ustawia liczbę wyświetlanych wierszy w polu wprowadzania. Jeśli dane wejściowe zajmują więcej wierszy, pojawi się pasek przewijania."
        },
        // survey templates
        survey: {
            mode: "Wybierz pomiędzy: \"Edytowalne\" - umożliwia respondentom wypełnienie ankiety; \"Tylko do odczytu\" - wyłącza edycję formularza."
        },
        matrixdropdowncolumn: {
            name: "Identyfikator kolumny, który nie jest widoczny dla respondentów.",
            isUnique: "Po włączeniu tej opcji dla kolumny respondent musi udzielić unikatowej odpowiedzi na każde pytanie w tej kolumnie.",
            rows: "Ustawia liczbę wyświetlanych wierszy w polu wprowadzania. Jeśli dane wejściowe zajmują więcej wierszy, pojawi się pasek przewijania.",
            visibleIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa widoczność kolumny.",
            enableIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która wyłącza tryb tylko do odczytu dla kolumny.",
            requiredIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która uniemożliwia przesłanie ankiety, chyba że co najmniej jedno zagnieżdżone pytanie ma odpowiedź.",
            showInMultipleColumns: "Gdy ta opcja jest zaznaczona, tworzy osobną kolumnę dla każdej opcji wyboru."
        },
        widthMode: "Do wyboru: \"Statyczny\" - ustawia stałą szerokość; \"Responsywny\" - sprawia, że ankieta zajmuje całą szerokość ekranu; \"Auto\" – stosuje jedną z tych dwóch opcji w zależności od użytych typów pytań.",
        cookieName: "Pliki cookie uniemożliwiają użytkownikom dwukrotne wypełnienie tej samej ankiety.",
        logo: "Wklej link do obrazu (bez ograniczeń rozmiaru) lub kliknij ikonę folderu, aby przeglądać plik z komputera (do 64 KB).",
        logoWidth: "Ustawia szerokość logo w jednostkach CSS (px, %, in, pt itd.).",
        logoHeight: "Ustawia wysokość logo w jednostkach CSS (px, %, in, pt itd.).",
        logoFit: "Do wyboru: \"Brak\" - obraz zachowuje swój oryginalny rozmiar; \"Zawieraj\" - rozmiar obrazu jest zmieniany tak, aby pasował przy zachowaniu proporcji; \"Okładka\" - obraz wypełnia całe pole z zachowaniem proporcji; \"Wypełnij\" - obraz jest rozciągany w celu wypełnienia pola bez zachowania jego proporcji.",
        goNextPageAutomatic: "Wybierz, czy chcesz, aby ankieta automatycznie przechodziła do następnej strony po udzieleniu przez respondenta odpowiedzi na wszystkie pytania na bieżącej stronie.",
        allowCompleteSurveyAutomatic: "Wybierz, jeśli chcesz, aby ankieta była wypełniana automatycznie po udzieleniu odpowiedzi respondenta na wszystkie pytania.",
        showNavigationButtons: "Ustawia widoczność i położenie przycisków nawigacyjnych na stronie.",
        showProgressBar: "Ustawia widoczność i położenie paska postępu. Wartość \"Auto\" wyświetla pasek postępu nad lub pod nagłówkiem ankiety.",
        showPreviewBeforeComplete: "Włącz stronę podglądu ze wszystkimi pytaniami lub tylko odpowiedziami.",
        questionTitleLocation: "Dotyczy wszystkich pytań w ankiecie. To ustawienie może zostać zastąpione przez reguły wyrównania tytułu na niższych poziomach: panelu, strony lub pytania. Ustawienie niższego poziomu zastąpi ustawienia wyższego poziomu.",
        requiredText: "Symbol lub sekwencja symboli wskazująca, że odpowiedź jest wymagana.",
        questionStartIndex: "Wprowadź cyfrę lub literę, od której chcesz rozpocząć numerację.",
        questionErrorLocation: "Ustawia lokalizację komunikatu o błędzie w odniesieniu do pytania z nieprawidłowymi danymi wejściowymi. Wybierz pomiędzy: \"Góra\" - tekst błędu jest umieszczany w górnej części pola pytania; \"Na dole\" — tekst błędu jest umieszczany u dołu pola pytania.",
        focusFirstQuestionAutomatic: "Wybierz, jeśli chcesz, aby pierwsze pole wejściowe na każdej stronie było gotowe do wprowadzenia tekstu.",
        questionsOrder: "Zachowuje pierwotną kolejność pytań lub losuje je. Efekt tego ustawienia jest widoczny tylko na karcie Podgląd.",
        maxTextLength: "Tylko w przypadku pytań tekstowych.",
        maxOthersLength: "Tylko w przypadku komentarzy do pytań.",
        commentAreaRows: "Ustawia liczbę wierszy wyświetlanych w obszarach tekstowych dla komentarzy do pytań. W danych wejściowych pojawia się więcej wierszy, pojawia się pasek przewijania.",
        autoGrowComment: "Zaznacz, jeśli chcesz, aby komentarze do pytań i pytania z długim tekstem automatycznie zwiększały się na podstawie wprowadzonej długości tekstu.",
        allowResizeComment: "Tylko w przypadku komentarzy do pytań i pytań z długim tekstem.",
        calculatedValues: "Zmienne niestandardowe służą jako zmienne pośrednie lub pomocnicze używane w obliczeniach formularzy. Przyjmują dane wejściowe respondentów jako wartości źródłowe. Każda zmienna niestandardowa ma unikatową nazwę i wyrażenie, na którym jest oparta.",
        includeIntoResult: "Wybierz, czy obliczona wartość wyrażenia ma być zapisywana wraz z wynikami ankiety.",
        triggers: "Wyzwalacz to zdarzenie lub warunek oparty na wyrażeniu. Gdy wyrażenie zostanie ocenione na wartość \"true\", wyzwalacz uruchamia akcję. Taka akcja może opcjonalnie mieć pytanie docelowe, na które wpływa.",
        clearInvisibleValues: "Wybierz, czy chcesz wyczyścić wartości pytań ukrytych przez logikę warunkową i kiedy to zrobić.",
        textUpdateMode: "Do wyboru: \"W przypadku utraty fokusu\" - wartość jest aktualizowana, gdy pole wejściowe traci fokus; \"Podczas pisania\" - wartość jest aktualizowana w czasie rzeczywistym, w miarę pisania przez użytkowników.",
        columns: "Lewa wartość służy jako identyfikator kolumny używany w regułach warunkowych, prawa wartość jest wyświetlana respondentom.",
        rows: "Lewa wartość służy jako identyfikator wiersza używany w regułach warunkowych, prawa wartość jest wyświetlana respondentom.",
        columnMinWidth: "Akceptuje wartości CSS (px, %, in, pt itp.).",
        rowTitleWidth: "Akceptuje wartości CSS (px, %, in, pt itp.).",
        totalText: "Opcja widoczna tylko wtedy, gdy co najmniej jedna kolumna zawiera wyrażenie typu Total lub Total.",
        cellErrorLocation: "Ustawia lokalizację komunikatu o błędzie w odniesieniu do komórki z nieprawidłowymi danymi wejściowymi. Opcja \"Dziedzicz\" stosuje ustawienie z właściwości \"Wyrównanie komunikatu o błędzie\".",
        keyDuplicationError: "Gdy właściwość \"Zapobiegaj zduplikowanym odpowiedziom\" jest włączona, respondent próbujący przesłać zduplikowany wpis otrzyma następujący komunikat o błędzie.",
        totalExpression: "Umożliwia obliczanie wartości całkowitych na podstawie wyrażenia. Wyrażenie może zawierać podstawowe obliczenia ('{q1_id} + {q2_id}'), wyrażenia logiczne ('{age} > 60') i funkcje ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' itp.).",
        confirmDelete: "Wyzwala monit z prośbą o potwierdzenie usunięcia wiersza.",
        defaultValueFromLastRow: "Duplikuje odpowiedzi z ostatniego wiersza i przypisuje je do następnego dodanego wiersza dynamicznego.",
        keyName: "Jeśli określona kolumna zawiera identyczne wartości, ankieta zgłasza błąd \"Nieunikalna wartość klucza\".",
        description: "Wpisz napisy.",
        locale: "Wybierz język, aby rozpocząć tworzenie ankiety. Aby dodać tłumaczenie, przełącz się na nowy język i przetłumacz oryginalny tekst tutaj lub na karcie Tłumaczenia.",
        detailPanelMode: "Ustawia położenie sekcji szczegółów w odniesieniu do wiersza. Do wyboru: \"Brak\" - nie jest dodawane rozszerzenie; \"Pod wierszem\" - pod każdym rzędem macierzy umieszcza się rozwinięcie wiersza; \"Pod wierszem wyświetl tylko rozwinięcie jednego wiersza\" - rozwinięcie jest wyświetlane tylko pod jednym wierszem, pozostałe rozwinięcia wierszy są zwinięte.",
        imageFit: "Do wyboru: \"Brak\" - obraz zachowuje swój oryginalny rozmiar; \"Zawieraj\" - rozmiar obrazu jest zmieniany tak, aby pasował przy zachowaniu proporcji; \"Okładka\" - obraz wypełnia całe pole z zachowaniem proporcji; \"Wypełnij\" - obraz jest rozciągany w celu wypełnienia pola bez zachowania jego proporcji.",
        autoGrow: "Stopniowo zwiększa wysokość pola wprowadzania danych podczas wprowadzania danych. Zastępuje ustawienie \"Wysokość pola wprowadzania (w wierszach)\".",
        allowResize: "Uchwyt zmiany rozmiaru pojawi się w rogu i można go przeciągnąć, aby zmienić rozmiar pola wejściowego.",
        maxTimeToFinish: "Przedział czasu w sekundach, po przekroczeniu którego ankieta automatycznie przechodzi do strony z podziękowaniem.",
        maxTimeToFinishPage: "Przedział czasu w sekundach, po którym ankieta automatycznie przechodzi do następnej strony.",
        page: {
            maxTimeToFinish: "Przedział czasu w sekundach, po którym ankieta automatycznie przechodzi do następnej strony.",
            visibleIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa widoczność strony.",
            enableIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która wyłącza tryb tylko do odczytu dla strony.",
            requiredIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która uniemożliwia przesłanie ankiety, chyba że co najmniej jedno zagnieżdżone pytanie ma odpowiedź.",
            questionTitleLocation: "Dotyczy wszystkich pytań na tej stronie. Jeśli chcesz zastąpić to ustawienie, zdefiniuj reguły wyrównania tytułów dla poszczególnych pytań lub paneli. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety (domyślnie \"Góra\").",
            questionTitleWidth: "Ustawia spójną szerokość tytułów pytań, gdy są one wyrównane do lewej strony pól pytań. Akceptuje wartości CSS (px, %, in, pt itp.).",
            questionErrorLocation: "Ustawia lokalizację komunikatu o błędzie w odniesieniu do pytania z nieprawidłowymi danymi wejściowymi. Wybierz pomiędzy: \"Góra\" - tekst błędu jest umieszczany w górnej części pola pytania; \"Na dole\" — tekst błędu jest umieszczany u dołu pola pytania. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety (domyślnie \"Góra\").",
            questionsOrder: "Zachowuje pierwotną kolejność pytań lub losuje je. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety (domyślnie \"Oryginalne\"). Efekt tego ustawienia jest widoczny tylko na karcie Podgląd.",
            navigationButtonsVisibility: "Ustawia widoczność przycisków nawigacyjnych na stronie. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety, które domyślnie ma wartość \"Widoczny\"."
        },
        showTimerPanel: "Ustawia widoczność i położenie czasomierza na stronie.",
        panelsState: "Do wyboru: \"Zablokowany\" - użytkownicy nie mogą rozwijać ani zwijać paneli; \"Zwiń wszystko\" - wszystkie panele rozpoczynają się w stanie zwiniętym; \"Rozwiń wszystko\" - wszystkie panele rozpoczynają się w stanie rozwiniętym; \"Pierwszy rozwinięty\" - początkowo rozwijany jest tylko pierwszy panel.",
        imageLinkName: "Wprowadź nazwę właściwości współużytkowanej w tablicy obiektów zawierających adresy URL obrazów lub plików wideo, które mają być wyświetlane na liście wyborów.",
        choices: "Lewa wartość służy jako identyfikator elementu używany w regułach warunkowych, prawa wartość jest wyświetlana respondentom.",
        title: "Wpisz przyjazny dla użytkownika tytuł do wyświetlenia.",
        waitForUpload: "Gwarantuje, że użytkownicy nie ukończą ankiety, dopóki pliki nie zostaną przekazane.",
        minWidth: "Akceptuje wartości CSS (px, %, in, pt itp.).",
        maxWidth: "Akceptuje wartości CSS (px, %, in, pt itp.).",
        width: "Akceptuje wartości CSS (px, %, in, pt itp.).",
        valueName: "Jeśli ta właściwość nie zostanie ustawiona, odpowiedź będzie przechowywana w polu określonym przez właściwość Name.",
        useDisplayValuesInDynamicTexts: "W pytaniach typu jednokrotnego i wielokrotnego wyboru każda opcja wyboru ma identyfikator i wartość wyświetlaną. Po wybraniu tej opcji w pytaniach HTML oraz dynamicznych tytułach i opisach elementów ankiety wyświetlana jest wartość wyświetlana zamiast wartości identyfikatora.",
        clearIfInvisible: "Wybierz, czy chcesz wyczyścić wartości pytań ukryte przez logikę warunkową i kiedy to zrobić. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety (domyślnie \"Po zakończeniu ankiety\").",
        choicesFromQuestionMode: "Wybierz spośród: \"Wszystkie\" - kopiuje wszystkie opcje wyboru z wybranego pytania; \"Wybrane\" - dynamicznie kopiuje tylko wybrane opcje wyboru; \"Niewybrane\" - dynamicznie kopiuje tylko niezaznaczone opcje wyboru. Opcje \"Brak\" i \"Inne\" są domyślnie kopiowane, jeśli są włączone w pytaniu źródłowym.",
        showOtherItem: "Po wybraniu tej opcji użytkownicy mogą uwzględnić dodatkowe dane wejściowe w osobnym polu komentarza.",
        separateSpecialChoices: "Wyświetla każdą opcję wyboru specjalnego (\"Brak\", \"Inne\", \"Zaznacz wszystko\") w nowym wierszu, nawet w przypadku korzystania z układu wielokolumnowego.",
        path: "Określ lokalizację w zestawie danych usługi, w której znajduje się docelowa tablica obiektów. Pozostaw puste, jeśli adres URL wskazuje już tablicę.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Wprowadź jednolitą nazwę właściwości w tablicy obiektów, która zawiera wartości, które mają być wyświetlane na liście wyborów.",
        allowEmptyResponse: "Zaznacz, aby zezwolić usłudze na zwrócenie pustej odpowiedzi lub tablicy.",
        choicesVisibleIf: "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa widoczność wszystkich opcji wyboru.",
        rateValues: "Lewa wartość służy jako identyfikator elementu używany w regułach warunkowych, prawa wartość jest wyświetlana respondentom.",
        rating: {
            displayMode: "\"Auto\" wybiera między trybami \"Przyciski\" i \"Rozwijane\" w zależności od dostępnej szerokości. Gdy szerokość jest niewystarczająca do wyświetlenia przycisków, w pytaniu zostanie wyświetlona lista rozwijana."
        },
        valuePropertyName: "Umożliwia łączenie pytań, które dają wyniki w różnych formatach. Gdy takie pytania są połączone ze sobą za pomocą identyfikatora sprzężenia, ta właściwość współużytkowana przechowuje wybrane wartości pytań.",
        searchEnabled: "Wybierz, czy chcesz zaktualizować zawartość menu rozwijanego, aby pasowała do zapytania wyszukiwania wpisywanego przez użytkownika w polu wejściowym.",
        valueTrue: "Wartość, którą należy zapisać w wynikach ankiety, gdy respondenci udzielą pozytywnej odpowiedzi.",
        valueFalse: "Wartość, która ma zostać zapisana w wynikach ankiety, gdy respondenci udzielą odpowiedzi negatywnej.",
        showPreview: "Nie zaleca się wyłączania tej opcji, ponieważ zastępuje ona obraz podglądu i utrudnia użytkownikowi zrozumienie, czy pliki zostały przekazane.",
        needConfirmRemoveFile: "Uruchamia monit z prośbą o potwierdzenie usunięcia pliku.",
        selectToRankEnabled: "Włącz, aby uszeregować tylko wybrane wybory. Użytkownicy będą przeciągać wybrane elementy z listy wyboru, aby uporządkować je w obszarze rankingu.",
        dataList: "Wprowadź listę opcji, które zostaną zasugerowane respondentowi podczas wprowadzania danych.",
        itemSize: "To ustawienie zmienia tylko rozmiar pól wejściowych i nie wpływa na szerokość pola pytania.",
        itemTitleWidth: "Ustawia stałą szerokość dla wszystkich etykiet elementów w pikselach",
        altText: "Służy jako substytut, gdy obraz nie może być wyświetlany na urządzeniu użytkownika oraz w celu ułatwienia dostępu.",
        rateColorMode: "Określa kolor wybranego emoji, gdy typ ikony oceny jest ustawiony na \"Emotikony\". Wybierz pomiędzy: \"Domyślny\" - wybrany emoji pojawia się w domyślnym kolorze ankiety; \"Skala\" - wybrany emoji dziedziczy kolor ze skali ocen.",
        expression: {
            name: "Identyfikator wyrażenia, który nie jest widoczny dla respondentów.",
            description: "Wpisz podtytuł wyrażenia.",
            expression: "Wyrażenie może zawierać podstawowe obliczenia ('{q1_id} + {q2_id}'), warunki ('{wiek} > 60') i funkcje ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' itp.)."
        },
        storeOthersAsComment: "Wybierz, aby zapisać wartość opcji \"Inne\" jako oddzielną właściwość w wynikach ankiety.",
        format: "Użyj {0} jako symbolu zastępczego dla rzeczywistej wartości.",
        acceptedTypes: "Więcej informacji można znaleźć w opisie atrybutu [accept](https://www.w3schools.com/tags/att_input_accept.asp).",
        columnColCount: "Dotyczy tylko komórek typu Radiogroup i Checkbox.",
        autocomplete: "Więcej informacji można znaleźć w opisie atrybutu [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete).",
        filePlaceholder: "Ma zastosowanie, gdy \"Typ źródła\" to \"Pliki lokalne\" lub gdy kamera jest niedostępna",
        photoPlaceholder: "Ma zastosowanie, gdy \"Typ źródła\" to \"Kamera\".",
        fileOrPhotoPlaceholder: "Ma zastosowanie, gdy \"Typ źródła\" to \"Pliki lokalne lub kamera\".",
        masksettings: {
            saveMaskedValue: "Wybierz, czy chcesz przechowywać wartość pytania z zastosowaną maską w wynikach ankiety."
        },
        patternmask: {
            pattern: "Wzorzec może zawierać literały ciągu i następujące symbole zastępcze: \"9\" — dla cyfry; 'a' - dla wielkiej lub małej litery; '#' - dla cyfry lub wielkiej lub małej litery. Użyj ukośnika odwrotnego \"\\\", aby uciec od znaku."
        },
        datetimemask: {
            pattern: "Wzorzec może zawierać znaki separatora i następujące symbole zastępcze:<br>'m' - Numer miesiąca.<br>'mm' - Numer miesiąca z zerem wiodącym dla wartości jednocyfrowych. <br>'d' - Dzień miesiąca. <br>'dd' — dzień miesiąca, z zerem wiodącym dla wartości jednocyfrowych. <br>'yy' - Dwie ostatnie cyfry roku. <br>'yyyy' - Rok czterocyfrowy. <br>\"H\" - Godziny w formacie 24-godzinnym. <br>\"HH\" — godziny w formacie 24-godzinnym, z zerem wiodącym dla wartości jednocyfrowych. <br>'h' - Godziny w formacie 12-godzinnym. <br>\"hh\" — godziny w formacie 12-godzinnym, z zerem wiodącym dla wartości jednocyfrowych. <br>'MM' - minuty. <br>'ss' - Sekundy. <br>\"TT\" - 12-godzinny okres zegara pisany wielkimi literami (AM/PM). <br>'tt' - 12-godzinny okres zegara pisany małymi literami (am/pm)."
        },
        numericmask: {
            decimalSeparator: "Symbol używany do oddzielenia części ułamkowej od części całkowitej wyświetlanej liczby.",
            thousandsSeparator: "Symbol używany do rozdzielania cyfr dużej liczby na grupy po trzy.",
            precision: "Ogranicza liczbę cyfr, które mają być zachowywane po przecinku dziesiętnym wyświetlanej liczby."
        },
        currencymask: {
            prefix: "Jeden lub kilka symboli, które mają być wyświetlane przed wartością.",
            suffix: "Jeden lub kilka symboli, które mają być wyświetlane po wartości."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "tytuł",
            title: "Pozostaw pusty, jeśli ma być taki sam, jak 'Nazwa'"
        },
        multiSelect: "Zezwalaj na wielokrotny wybór",
        showLabel: "Pokaż podpisy pod obrazami",
        swapOrder: "Zamień kolejność Tak i Nie",
        value: "Wartość",
        tabAlign: "Wyrównanie tabulatorów",
        sourceType: "Typ źródła",
        fitToContainer: "Pasuje do pojemnika",
        setValueExpression: "Wyrażenie wartości zadanej",
        description: "Opis",
        logoFit: "Dopasowanie logo",
        pages: "Stron",
        questions: "Pytania",
        triggers: "Wyzwalaczy",
        calculatedValues: "Obliczone wartości",
        surveyId: "Identyfikator ankiety",
        surveyPostId: "Identyfikator posta ankiety",
        surveyShowDataSaving: "Ankieta pokazuje zapisywanie danych",
        questionDescriptionLocation: "Lokalizacja opisu pytania",
        progressBarType: "Typ paska postępu",
        showTOC: "Pokaż spis treści",
        tocLocation: "Lokalizacja spisu treści",
        questionTitlePattern: "Wzorzec tytułu pytania",
        widthMode: "Tryb szerokości",
        showBrandInfo: "Pokaż informacje o marce",
        useDisplayValuesInDynamicTexts: "Używanie wartości wyświetlanych w tekstach dynamicznych",
        visibleIf: "Widoczne, jeśli",
        defaultValueExpression: "Wyrażenie wartości domyślnej",
        requiredIf: "Wymagane, jeśli:",
        resetValueIf: "Zresetuj wartość, jeśli",
        setValueIf: "Ustaw wartość, jeśli",
        validators: "Walidatory",
        bindings: "Powiązania",
        renderAs: "Renderuj jako",
        attachOriginalItems: "Dołączanie oryginalnych elementów",
        choices: "Wyborów",
        choicesByUrl: "Opcje według adresu URL",
        currency: "Waluta",
        cellHint: "Wskazówka do komórki",
        totalMaximumFractionDigits: "Łączne maksymalne cyfry ułamkowe",
        totalMinimumFractionDigits: "Łączne minimalne cyfry ułamkowe",
        columns: "Kolumny",
        detailElements: "Elementy szczegółowe",
        allowAdaptiveActions: "Zezwalaj na działania adaptacyjne",
        defaultRowValue: "Domyślna wartość wiersza",
        detailPanelShowOnAdding: "Panel szczegółów pokazuje się po dodaniu",
        choicesLazyLoadEnabled: "Opcje: leniwe ładowanie włączone",
        choicesLazyLoadPageSize: "Opcje: leniwy rozmiar strony ładowania",
        inputFieldComponent: "Składnik pola wejściowego",
        itemComponent: "Składnik elementu",
        min: "Min",
        max: "Max",
        minValueExpression: "Minimalne wyrażenie wartości",
        maxValueExpression: "Wyrażenie wartości maksymalnej",
        step: "Krok",
        dataList: "Lista danych",
        itemSize: "Rozmiar produktu",
        itemTitleWidth: "Szerokość etykiety elementu (w pikselach)",
        elements: "Pierwiastki",
        content: "Zawartość",
        navigationButtonsVisibility: "Widoczność przycisków nawigacyjnych",
        navigationTitle: "Tytuł nawigacji",
        navigationDescription: "Opis nawigacji",
        longTap: "Długie dotknięcie",
        autoGrow: "Automatyczny wzrost",
        allowResize: "Zezwalaj na zmianę rozmiaru",
        acceptCarriageReturn: "Zaakceptuj zwrot karetki",
        displayMode: "Tryb wyświetlania",
        rateType: "Rodzaj stawki",
        label: "Etykieta",
        contentMode: "Tryb zawartości",
        imageFit: "Dopasowanie obrazu",
        altText: "Tekst alternatywny",
        height: "Wysokość",
        penColor: "Kolor pióra",
        backgroundColor: "Kolor tła",
        templateElements: "Elementy szablonu",
        operator: "Operator",
        isVariable: "Jest zmienna",
        runExpression: "Uruchom wyrażenie",
        showCaption: "Pokaż podpis",
        iconName: "Nazwa ikony",
        iconSize: "Rozmiar ikony",
        precision: "Precyzja",
        matrixDragHandleArea: "Obszar uchwytu przeciągania macierzy",
        backgroundImage: "Obraz tła",
        backgroundImageFit: "Dopasowanie obrazu tła",
        backgroundImageAttachment: "Załącznik obrazu tła",
        backgroundOpacity: "Krycie tła",
        selectToRankEnabled: "Wybierz, aby ranga była włączona",
        selectToRankAreasLayout: "Wybierz, aby uszeregować układ obszarów",
        selectToRankEmptyRankedAreaText: "Tekst pokazujący, czy wszystkie opcje są zaznaczone",
        selectToRankEmptyUnrankedAreaText: "Tekst zastępczy dla obszaru klasyfikacji",
        allowCameraAccess: "Zezwalaj na dostęp do kamery",
        scaleColorMode: "Tryb skalowania kolorów",
        rateColorMode: "Oceń tryb kolorów",
        copyDisplayValue: "Kopiowanie wyświetlanej wartości",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Tryb zaawansowany",
        pageTitle: "Czcionka tytułu strony",
        questionTitle: "Czcionka tytułu pytania",
        editorPanel: "Element wejściowy",
        lines: "Linie",
        primaryDefaultColor: "Domyślny",
        primaryDarkColor: "Hover",
        primaryLightColor: "Wybrany",
        backgroundDimColor: "Kolor tła",
        cornerRadius: "Promień naroża",
        backcolor: "Domyślne tło",
        hovercolor: "Najedź kursorem na tło",
        borderDecoration: "Dekoracja obramowania",
        fontColor: "Kolor czcionki",
        backgroundColor: "Kolor tła",
        primaryForecolor: "Kolor domyślny",
        primaryForecolorLight: "Kolor wyłączony",
        font: "Czcionka",
        borderDefault: "Ciemniejsze",
        borderLight: "Zapalniczka",
        fontFamily: "Rodzina czcionek",
        fontWeightRegular: "Regularny",
        fontWeightHeavy: "Ciężki",
        fontWeightSemiBold: "Półpogrubienie",
        fontWeightBold: "Śmiały",
        color: "Kolor",
        placeholderColor: "Kolor symbolu zastępczego",
        size: "Rozmiar",
        opacity: "Nieprzezroczystość",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Dodaj efekt cienia",
        boxShadowBlur: "Zacierać",
        boxShadowSpread: "Rozprzestrzenianie się",
        boxShadowDrop: "Kropla",
        boxShadowInner: "Wewnętrzny",
        names: {
            default: "Domyślny",
            sharp: "Ostry",
            borderless: "Bez obramowania",
            flat: "Płaski",
            plain: "Równina",
            doubleborder: "Podwójna ramka",
            layered: "Warstwowe",
            solid: "Bryła",
            threedimensional: ".3D",
            contrast: "Kontrast"
        },
        colors: {
            teal: "Teal",
            blue: "Niebieski",
            purple: "Purpura",
            orchid: "Orchidea",
            tulip: "Tulipan",
            brown: "Brązowy",
            green: "Zielony"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["pl"] = polishStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// survey.externalHelpLink: "Watch and learn how to create surveys" => "Obejrzyj i dowiedz się, jak tworzyć ankiety"
// survey.externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber" => "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber"
// survey.addLogicItem: "Create a rule to customize the flow of the survey." => "Utwórz regułę, aby dostosować przepływ ankiety."
// survey.duplicate: "Duplicate" => "Duplikat"
// survey.drag: "Drag element" => "Przeciągnij element"
// qt.default: "Default" => "Domyślny"
// qt.imagepicker: "Image Picker" => "Selektor obrazów"
// qt.ranking: "Ranking" => "Ranking"
// qt.image: "Image" => "Obraz"
// qt.tagbox: "Multi-Select Dropdown" => "Lista rozwijana Multi-Select"
// qt.signaturepad: "Signature" => "Podpis"
// qt.buttongroup: "Button Group" => "Grupa przycisków"
// ed.defaultLocale: "Default ({0})" => "Domyślne ({0})"
// ed.settings: "Settings" => "Ustawienia"
// ed.settingsTooltip: "Open settings" => "Otwórz ustawienia"
// ed.surveySettings: "Survey Settings" => "Ustawienia ankiety"
// ed.surveySettingsTooltip: "Open survey settings" => "Otwórz ustawienia ankiety"
// ed.showPanel: "Show Panel" => "Pokaż panel"
// ed.hidePanel: "Hide Panel" => "Panel Ukryj"
// ed.prevSelected: "Select previous" => "Wybierz poprzedni"
// ed.nextSelected: "Select next" => "Wybierz następny"
// ed.surveyTypeName: "Survey" => "Sondaż"
// ed.pageTypeName: "Page" => "Strona"
// ed.panelTypeName: "Panel" => "Panel"
// ed.questionTypeName: "Question" => "Pytanie"
// ed.columnTypeName: "Column" => "Kolumna"
// ed.moveRight: "Scroll to the Right" => "Przewiń w prawo"
// ed.moveLeft: "Scroll to the Left" => "Przewiń w lewo"
// ed.edit: "Edit" => "Redagować"
// ed.newTextItemName: "text" => "Tekst"
// ed.themeSurvey: "Themes" => "Tematy"
// ed.defaultV2Theme: "Default" => "Domyślny"
// ed.modernTheme: "Modern" => "Nowoczesny"
// ed.defaultTheme: "Default (legacy)" => "Domyślne (starsze)"
// ed.navigateToMsg: "You had to navigate to" => "Trzeba było nawigować do"
// ed.logic: "Logic" => "Logika"
// ed.translation: "Translation" => "Tłumaczenie"
// ed.saveSurveyTooltip: "Save Survey" => "Zapisz ankietę"
// ed.jsonHideErrors: "Hide errors" => "Ukryj błędy"
// ed.jsonShowErrors: "Show errors" => "Pokaż błędy"
// ed.undoTooltip: "Undo last change" => "Cofanie ostatniej zmiany"
// ed.redoTooltip: "Redo the change" => "Ponowne wprowadzanie zmian"
// ed.showMoreChoices: "Show more" => "Pokaż więcej"
// ed.showLessChoices: "Show less" => "Pokaż mniej"
// ed.copy: "Copy" => "Kopiować"
// ed.cut: "Cut" => "Ciąć"
// ed.paste: "Paste" => "Wklejać"
// ed.copyTooltip: "Copy selection to clipboard" => "Kopiuj zaznaczenie do schowka"
// ed.cutTooltip: "Cut selection to clipboard" => "Wytnij zaznaczenie do schowka"
// ed.pasteTooltip: "Paste from clipboard" => "Wklejanie ze schowka"
// ed.property-grid: "Properties" => "Właściwości"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "Wpisz, aby wyszukać..."
// ed.surveyResultsTable: "As Table" => "Jako tabela"
// ed.surveyResultsJson: "As JSON" => "Jako JSON"
// ed.resultsTitle: "Question Title" => "Tytuł pytania"
// ed.resultsName: "Question Name" => "Nazwa pytania"
// ed.resultsValue: "Answer Value" => "Wartość odpowiedzi"
// ed.resultsDisplayValue: "Display Value" => "Wyświetl wartość"
// ed.propertyEditorError: "Error" => "Błąd"
// ed.saveError: "Error! Editor content is not saved." => "Błąd! Zawartość edytora nie jest zapisywana."
// ed.translationPropertyGridTitle: "Language Settings" => "Ustawienia językowe"
// ed.themePropertyGridTitle: "Theme Settings" => "Ustawienia motywu"
// ed.translationLanguages: "Languages" => "Języki"
// ed.translationAddLanguage: "Select language to translate" => "Wybierz język do przetłumaczenia"
// ed.translationShowAllStrings: "All Strings" => "Wszystkie struny"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "Tylko używane ciągi"
// ed.translationShowAllPages: "All Pages" => "Wszystkie strony"
// ed.translationNoStrings: "No strings to translate. Please, change the filter." => "Brak ciągów do przetłumaczenia. Proszę zmienić filtr."
// ed.translationExportToSCVButton: "Export to CSV" => "Eksport do pliku CSV"
// ed.translationImportFromSCVButton: "Import from CSV" => "Importowanie z pliku CSV"
// ed.translationMergeLocaleWithDefault: "Merge {0} with default locale" => "Scalanie {0} z domyślnymi ustawieniami regionalnymi"
// ed.translationPlaceHolder: "Translation..." => "Tłumaczenie..."
// ed.themeExportButton: "Export" => "Eksport"
// ed.themeImportButton: "Import" => "Import"
// ed.bold: "Bold" => "Śmiały"
// ed.italic: "Italic" => "Kursywa"
// ed.underline: "Underline" => "Podkreślać"
// ed.addNewQuestion: "Add Question" => "Dodaj pytanie"
// ed.selectPage: "Select page..." => "Wybierz stronę..."
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Wybory są kopiowane z"
// ed.htmlPlaceHolder: "HTML content will be here." => "Zawartość HTML będzie tutaj."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "Upuść pytanie z przybornika tutaj."
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "Ankieta jest pusta. Przeciągnij element z przybornika lub kliknij przycisk poniżej."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Przeciągnij i upuść obraz tutaj lub kliknij przycisk poniżej i wybierz obraz do przesłania"
// ed.imageChooseImage: "Choose Image" => "Wybierz obraz"
// ed.addNewTypeQuestion: "Add {0}" => "Dodaj {0}"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[LOGO]"
// ed.auto: "auto" => "Automatycznie"
// ed.choices_Item: "Item " => "Przedmiot "
// lg.addNewItem: "Add New Rule" => "Dodaj nową regułę"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "Utwórz regułę, aby dostosować przepływ ankiety."
// lg.page_visibilityName: "Show (hide) page" => "Pokaż (ukryj) stronę"
// lg.page_enableName: "Enable (disable) page" => "Włącz (wyłącz) stronę"
// lg.panel_visibilityName: "Show (hide) panel" => "Pokaż (ukryj) panel"
// lg.panel_enableName: "Enable (disable) panel" => "Włącz (wyłącz) panel"
// lg.question_visibilityName: "Show (hide) question" => "Pokaż (ukryj) pytanie"
// lg.question_enableName: "Enable (disable) question" => "Włącz (wyłącz) pytanie"
// lg.question_requireName: "Make question required" => "Zadbaj o pytanie wymagane"
// lg.column_visibilityName: "Show (hide) column" => "Pokaż (ukryj) kolumnę"
// lg.column_enableName: "Enable (disable) column" => "Włącz (wyłącz) kolumnę"
// lg.column_requireName: "Make column required" => "Ustaw kolumnę jako wymaganą"
// lg.trigger_completeName: "Complete survey" => "Wypełnij ankietę"
// lg.trigger_setvalueName: "Set answer" => "Ustaw odpowiedź"
// lg.trigger_copyvalueName: "Copy answer" => "Kopiuj odpowiedź"
// lg.trigger_skipName: "Skip to question" => "Przejdź do pytania"
// lg.trigger_runExpressionName: "Run expression" => "Uruchom wyrażenie"
// lg.completedHtmlOnConditionName: "Set \"Survey Complete\" page markup" => "Ustaw znaczniki strony \"Ankieta ukończona\""
// lg.page_visibilityDescription: "Make the page visible when the logic expression returns true. Otherwise keep it invisible." => "Spraw, aby strona była widoczna, gdy wyrażenie logiczne zwróci wartość true. W przeciwnym razie zachowaj go niewidocznym."
// lg.panel_visibilityDescription: "Make the panel visible when the logic expression returns true. Otherwise keep it invisible." => "Uczyń panel widocznym, gdy wyrażenie logiczne zwróci wartość true. W przeciwnym razie zachowaj go niewidocznym."
// lg.panel_enableDescription: "Make the panel, and all elements inside it, enable when the logic expression returns true. Otherwise keep them disabled." => "Włącz panel i wszystkie znajdujące się w nim elementy, gdy wyrażenie logiczne zwróci wartość true. W przeciwnym razie pozostaw je wyłączone."
// lg.question_visibilityDescription: "Make the question visible when the logic expression returns true. Otherwise keep it invisible." => "Uczyń pytanie widocznym, gdy wyrażenie logiczne zwróci wartość true. W przeciwnym razie zachowaj go niewidocznym."
// lg.question_enableDescription: "Make the question enable when the logic expression returns true. Otherwise keep it disabled." => "Włącz pytanie, gdy wyrażenie logiczne zwróci wartość true. W przeciwnym razie pozostaw go wyłączonym."
// lg.question_requireDescription: "Question becomes required when the logic expression returns true." => "Pytanie staje się wymagane, gdy wyrażenie logiczne zwraca wartość true."
// lg.trigger_completeDescription: "When the logic expression returns true then the survey becomes completed and an end-user see the 'Thank you page'." => "Gdy wyrażenie logiczne zwraca wartość true, ankieta zostaje wypełniona, a użytkownik końcowy zobaczy stronę \"Dziękuję\"."
// lg.trigger_setvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value is set to the selected question." => "Gdy wartości pytań, które są używane w wyrażeniu logicznym, zostaną zmienione, a wyrażenie logiczne zwróci wartość true, wartość zostanie ustawiona na wybrane pytanie."
// lg.trigger_copyvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value of one selected question is copied to another selected question." => "Gdy wartości pytania, które są używane w wyrażeniu logicznym, zostaną zmienione, a wyrażenie logiczne zwróci wartość true, wartość jednego wybranego pytania zostanie skopiowana do innego wybranego pytania."
// lg.trigger_skipDescription: "When the logic expression returns true then the survey skip to / focus the selected question." => "Gdy wyrażenie logiczne zwraca wartość true, ankieta przechodzi do / fokus wybranego pytania."
// lg.trigger_runExpressionDescription: "When the logic expression returns true, then the custom expression is performed. You may optionally set this expression result into the selected question" => "Gdy wyrażenie logiczne zwraca wartość true, wykonywane jest wyrażenie niestandardowe. Opcjonalnie można ustawić wynik tego wyrażenia w wybranym pytaniu"
// lg.completedHtmlOnConditionDescription: "If the logic expression returns true, then the default text for the 'Thank you page' is changed to the given one." => "Jeśli wyrażenie logiczne zwróci wartość true, domyślny tekst strony \"Dziękuję\" zostanie zmieniony na podany."
// lg.itemExpressionText: "When expression: '{0}' returns true" => "Gdy wyrażenie \"{0}\" zwraca wartość true"
// lg.itemEmptyExpressionText: "New rule" => "Nowa reguła"
// lg.page_visibilityText: "make page {0} visible" => "Ustawianie {0} strony"
// lg.panel_visibilityText: "make panel {0} visible" => "Uwidocznienie {0} panelu"
// lg.panel_enableText: "make panel {0} enable" => "Włączanie {0} panelu"
// lg.question_visibilityText: "make question {0} visible" => "Uczyń {0} pytań widocznymi"
// lg.question_enableText: "make question {0} enable" => "Utwórz pytanie {0} włącz"
// lg.question_requireText: "make question {0} required" => "Pytanie {0} wymagane"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "Uwidocznienie {0}  {1}pytania"
// lg.column_enableText: "make column {0} of question {1} enable" => "Ustaw kolumnę {0} pytania{1} włączyć"
// lg.column_requireText: "make column {0} of question {1} required" => "Ustaw kolumnę {0} pytania {1} wymagane"
// lg.trigger_completeText: "survey becomes completed" => "Ankieta zostaje zakończona"
// lg.trigger_setvalueText: "set into question: {0} value {1}" => "Ustaw pod znakiem zapytania: {0} wartość {1}"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "Wyczyść wartość pytania: {0}"
// lg.trigger_copyvalueText: "copy into question: {0} value from question {1}" => "Kopiuj do pytania: {0} wartość z pytania {1}"
// lg.trigger_skipText: "survey skip to the question {0}" => "Przejdź do pytania {0}"
// lg.trigger_runExpressionText1: "run expression: '{0}'" => "Uruchom wyrażenie: '{0}'"
// lg.trigger_runExpressionText2: " and set its result into question: {0}" => " i zakwestionować jego wynik: {0}"
// lg.completedHtmlOnConditionText: "show custom text for the 'Thank you page'." => "pokaż niestandardowy tekst dla strony \"Dziękuję\"."
// lg.showAllQuestions: "All Questions" => "Wszystkie pytania"
// lg.showAllActionTypes: "All Action Types" => "Wszystkie rodzaje akcji"
// lg.conditions: "Condition(s)" => "Warunek (warunki)"
// lg.actions: "Action(s)" => "Działania(e)"
// lg.expressionEditorTitle: "Define condition(s)" => "Zdefiniuj warunki"
// lg.actionsEditorTitle: "Define action(s)" => "Definiowanie akcji"
// lg.deleteAction: "Delete Action" => "Akcja usuwania"
// lg.addNewAction: "Add Action" => "Dodaj akcję"
// lg.selectedActionCaption: "Select action..." => "Wybierz akcję..."
// lg.expressionInvalid: "The logic expression is empty or invalid. Please correct it." => "Wyrażenie logiczne jest puste lub nieprawidłowe. Proszę to poprawić."
// lg.noActionError: "Please, add at least one action." => "Dodaj co najmniej jedną akcję."
// lg.actionInvalid: "Please, fix problems in your action(s)." => "Proszę, napraw problemy w swoich działaniach."
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Reguły logiczne są niekompletne"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Nie ukończyłeś niektórych reguł logicznych. Jeśli opuścisz kartę teraz, zmiany zostaną utracone. Czy nadal chcesz opuścić kartę bez dokończenia zmian?"
// lg.uncompletedRule_apply: "Yes" => "Tak"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Nie, chcę wypełnić zasady"
// pe.save: "Save" => "Zapisać"
// pe.clear: "Clear" => "Jasny"
// pe.saveTooltip: "Save" => "Zapisać"
// pe.set: "Set" => "Zbiór"
// pe.change: "Change" => "Zmieniać"
// pe.refresh: "Refresh" => "Odświeżyć"
// pe.add: "Add" => "Dodawać"
// pe.addItem: "Click to add an item..." => "Kliknij, aby dodać element..."
// pe.removeItem: "Click to remove the item..." => "Kliknij, aby usunąć element..."
// pe.dragItem: "Drag the item" => "Przeciągnij element"
// pe.addOther: "Other" => "Inny"
// pe.addSelectAll: "Select All" => "Zaznacz wszystko"
// pe.addNone: "None" => "Żaden"
// pe.back: "Return without saving" => "Zwrot bez zapisywania"
// pe.backTooltip: "Return without saving" => "Zwrot bez zapisywania"
// pe.saveAndBack: "Save and return" => "Zapisz i zwróć"
// pe.saveAndBackTooltip: "Save and return" => "Zapisz i zwróć"
// pe.doneEditing: "Done" => "Gotowy"
// pe.editChoices: "Edit Choices" => "Edytuj opcje"
// pe.showChoices: "Show Choices" => "Pokaż wybór"
// pe.move: "Move" => "Ruszać"
// pe.emptyValue: "Value is empty" => "Wartość jest pusta"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "Wartość \"{0}\" nie jest unikalna"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "Ogranicz liczbę przedmiotów od {0} do {1}"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "Dane można ustawić w następującym formacie:\nwartość1|tekst\nwartość2"
// pe.itemSelectorEmpty: "Please select the element" => "Proszę wybrać element"
// pe.conditionActionEmpty: "Please select the action" => "Wybierz akcję"
// pe.conditionSelectQuestion: "Select question..." => "Wybierz pytanie..."
// pe.conditionSelectPage: "Select page..." => "Wybierz stronę..."
// pe.conditionSelectPanel: "Select panel..." => "Wybierz panel..."
// pe.conditionValueQuestionTitle: "Please enter/select the value" => "Wpisz/wybierz wartość"
// pe.expressionHelp: "Use curly brackets to access answers: `{question1} + {question2}`. Expressions also support functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `count()`, `avg()`, and others" => "Użyj nawiasów klamrowych, aby uzyskać dostęp do odpowiedzi: '{question1} + {question2}'. Wyrażenia obsługują również funkcje: 'iif()', 'today()', 'age()', 'min()', 'max()', 'count()', 'avg()' i inne"
// pe.cellsEmptyRowsColumns: "There is should be at least one column or row" => "Powinna istnieć co najmniej jedna kolumna lub wiersz"
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "Podgląd odpowiedzi przed wysłaniem ankiety"
// pe.overridingPropertyPrefix: "Set by " => "Ustaw przez "
// pe.propertyIsNoUnique: "Please enter a unique value" => "Podaj unikatową wartość"
// pe.propertyNameIsNotUnique: "Please enter a unique name" => "Podaj unikalną nazwę"
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Nie używaj zastrzeżonych słów: \"element\", \"wybór\", \"panel\", \"wiersz\"."
// pe.listIsEmpty: "No items have been added yet" => "Nie dodano jeszcze żadnych przedmiotów"
// pe.listIsEmpty@choices: "No choices have been added yet" => "Nie dodano jeszcze żadnych opcji"
// pe.addNew@choices: "Add a choice" => "Dodaj wybór"
// pe.expressionIsEmpty: "Expression is empty" => "Wyrażenie jest puste"
// pe.rowid: "Row ID" => "Identyfikator wiersza"
// pe.imageLink: "Image or video URL" => "Adres URL obrazu lub filmu"
// choicesbyurl.valueName: "Get values from the following JSON field" => "Pobierz wartości z następującego pola JSON:"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "Pobierz adresy URL obrazów z następującego pola JSON:"
// pe.allowEmptyResponse: "Allow empty response" => "Zezwalaj na pustą odpowiedź"
// pe.titlePlaceholder: "Title" => "Tytuł"
// pe.surveyTitlePlaceholder: "Survey Title" => "Tytuł ankiety"
// pe.pageTitlePlaceholder: "Page {num}" => "Strona {num}"
// pe.descriptionPlaceholder: "Description" => "Opis"
// pe.surveyDescriptionPlaceholder: "Description" => "Opis"
// pe.pageDescriptionPlaceholder: "Description" => "Opis"
// pe.showNoneItem: "Allow the None option" => "Zezwalaj na opcję Brak"
// pe.noneText: "None option text" => "Tekst opcji Brak"
// pe.showSelectAllItem: "Allow the Select All option" => "Zezwalaj na opcję Zaznacz wszystko"
// pe.selectAllText: "Select All option text" => "Zaznacz tekst opcji Wszystkie"
// pe.choicesMin: "Minimum value for auto-generated items" => "Minimalna wartość dla automatycznie wygenerowanych elementów"
// pe.choicesMax: "Maximum value for auto-generated items" => "Maksymalna wartość dla automatycznie wygenerowanych elementów"
// pe.choicesStep: "Step for auto-generated items" => "Krok dla automatycznie wygenerowanych elementów"
// pe.isAllRowRequired: "Require answer for all rows" => "Wymagaj odpowiedzi dla wszystkich wierszy"
// pe.requiredErrorText: "\"Required\" error message" => "Komunikat o błędzie \"Wymagane\""
// pe.cols: "Columns" => "Kolumny"
// pe.columnLayout: "Columns layout" => "Układ kolumn"
// pe.addRowLocation: "Add Row button location" => "Lokalizacja przycisku Dodaj wiersz"
// pe.rateMin: "Minimum rate value" => "Minimalna wartość stawki"
// pe.rateMax: "Maximum rate value" => "Maksymalna wartość stawki"
// pe.rateStep: "Rate step" => "Krok stawki"
// pe.cellsDefaultRow: "Default texts" => "Teksty domyślne"
// pe.maxLength: "Maximum length (in characters)" => "Maksymalna długość (w znakach)"
// pe.buildExpression: "Build" => "Budować"
// pe.editExpression: "Edit" => "Redagować"
// pe.and: "and" => "i"
// pe.or: "or" => "lub"
// pe.remove: "Remove" => "Usunąć"
// pe.addCondition: "Add Condition" => "Dodaj warunek"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Wybierz pytanie, aby rozpocząć konfigurowanie warunków."
// pe.if: "If" => "Jeśli"
// pe.then: "then" => "wtedy"
// pe.setToName: "Target question" => "Pytanie docelowe"
// pe.fromName: "Question to copy answer from" => "Pytanie, z którego należy skopiować odpowiedź"
// pe.gotoName: "Question to skip to" => "Pytanie, do którego należy przejść"
// pe.ruleIsNotSet: "Rule is incorrect" => "Reguła jest nieprawidłowa"
// pe.includeIntoResult: "Include into survey results" => "Uwzględnij w wynikach ankiety"
// pe.expandCollapseTitle: "Expand/collapse title" => "Rozwiń/zwiń tytuł"
// pe.simulator: "Select device type" => "Wybierz typ urządzenia"
// pe.landscapeOrientation: "Switch to landscape orientation" => "Przełączanie na orientację poziomą"
// pe.portraitOrientation: "Switch to portrait orientation" => "Przełączanie na orientację pionową"
// pe.previewText: "Preview Answers button text" => "Tekst przycisku Podgląd odpowiedzi"
// pe.editText: "Edit Answer button text" => "Tekst przycisku Edytuj odpowiedź"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Wysokość obrazu (w wartościach akceptowanych przez CSS)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Szerokość obrazu (w wartościach akceptowanych przez CSS)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "Limit czasu na zakończenie strony (w sekundach)"
// question.page: "Parent page" => "Strona nadrzędna"
// pe.noEntriesText: "Empty entries text" => "Tekst pustych wpisów"
// pe.html: "HTML markup" => "Znaczniki HTML"
// pe.expression: "Expression" => "Wyrażenie"
// pe.setValue: "Answer" => "Odpowiedź"
// pe.dataFormat: "Image format" => "Format obrazu"
// pe.allowAddRows: "Allow adding rows" => "Zezwalaj na dodawanie wierszy"
// pe.allowRemoveRows: "Allow removing rows" => "Zezwalaj na usuwanie wierszy"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "Zezwalaj na przeciąganie i upuszczanie wierszy"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "Nie ma zastosowania, jeśli określisz dokładną szerokość lub wysokość obrazu."
// pe.minImageWidth: "Minimum image width" => "Minimalna szerokość obrazu"
// pe.maxImageWidth: "Maximum image width" => "Maksymalna szerokość obrazu"
// pe.minImageHeight: "Minimum image height" => "Minimalna wysokość obrazu"
// pe.maxImageHeight: "Maximum image height" => "Maksymalna wysokość obrazu"
// pe.minValue: "Minimum value" => "Wartość minimalna"
// pe.maxValue: "Maximum value" => "Wartość maksymalna"
// pe.minLength: "Minimum length (in characters)" => "Minimalna długość (w znakach)"
// pe.allowDigits: "Allow digits" => "Zezwalaj na cyfry"
// pe.minCount: "Minimum count" => "Minimalna liczba"
// pe.maxCount: "Maximum count" => "Maksymalna liczba"
// pe.regex: "Regular expression" => "Wyrażenie regularne"
// surveyvalidator.text: "Error message" => "Komunikat o błędzie"
// surveyvalidator.expression: "Validation expression" => "Wyrażenie sprawdzania poprawności"
// pe.totalText: "Total row text" => "Tekst wiersza sumy"
// pe.totalType: "Total type" => "Typ sumy"
// pe.totalExpression: "Total expression" => "Wyrażenie całkowite"
// pe.totalDisplayStyle: "Total value display style" => "Styl wyświetlania łącznej wartości"
// pe.totalCurrency: "Currency" => "Waluta"
// pe.totalFormat: "Formatted string" => "Sformatowany ciąg znaków"
// pe.logo: "Logo (URL or base64-encoded string)" => "Logo (adres URL lub ciąg znaków zakodowany w formacie base64)"
// pe.questionsOnPageMode: "Survey structure" => "Struktura badania"
// pe.maxTextLength: "Maximum answer length (in characters)" => "Maksymalna długość odpowiedzi (w znakach)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "Maksymalna długość komentarza (w znakach)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "W razie potrzeby automatycznie rozwiń obszar komentarza"
// pe.allowResizeComment: "Allow users to resize text areas" => "Zezwalaj użytkownikom na zmianę rozmiaru obszarów tekstu"
// pe.textUpdateMode: "Update text question value" => "Aktualizowanie wartości pytania tekstowego"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "Ustaw fokus na pierwszej nieprawidłowej odpowiedzi"
// pe.checkErrorsMode: "Run validation" => "Sprawdzanie poprawności uruchamiania"
// pe.navigateToUrl: "Navigate to URL" => "Przejdź do adresu URL"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "Dynamiczny adres URL"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "Znaczniki, aby pokazać, czy użytkownik już wypełnił tę ankietę"
// pe.completedHtml: "Survey Complete page markup" => "Znaczniki strony Survey Complete"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "Znaczniki strony Dynamic Survey Complete"
// pe.loadingHtml: "Markup to show while survey model is loading" => "Znaczniki do pokazania podczas ładowania modelu ankiety"
// pe.commentText: "Comment area text" => "Tekst w obszarze komentarza"
// pe.autocomplete: "Autocomplete type" => "Typ autouzupełniania"
// pe.labelTrue: "\"True\" label" => "Etykieta \"prawdziwa\""
// pe.labelFalse: "\"False\" label" => "Etykieta \"Fałsz\""
// pe.allowClear: "Show the Clear button" => "Pokaż przycisk Wyczyść"
// pe.displayStyle: "Value display style" => "Styl wyświetlania wartości"
// pe.format: "Formatted string" => "Sformatowany ciąg znaków"
// pe.maximumFractionDigits: "Maximum fractional digits" => "Maksymalna liczba cyfr ułamkowych"
// pe.minimumFractionDigits: "Minimum fractional digits" => "Minimalne cyfry ułamkowe"
// pe.useGrouping: "Display grouping separators" => "Wyświetlanie separatorów grupujących"
// pe.allowMultiple: "Allow multiple files" => "Zezwalaj na wiele plików"
// pe.allowImagesPreview: "Preview images" => "Podgląd obrazów"
// pe.acceptedTypes: "Accepted file types" => "Akceptowane typy plików"
// pe.waitForUpload: "Wait for the upload to complete" => "Poczekaj na zakończenie przesyłania"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "Potwierdź usunięcie pliku"
// pe.detailPanelMode: "Detail panel location" => "Położenie panelu szczegółów"
// pe.minRowCount: "Minimum row count" => "Minimalna liczba wierszy"
// pe.maxRowCount: "Maximum row count" => "Maksymalna liczba wierszy"
// pe.confirmDelete: "Confirm row deletion" => "Potwierdź usunięcie wiersza"
// pe.confirmDeleteText: "Confirmation message" => "Komunikat potwierdzenia"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "Potwierdź usunięcie panelu"
// pe.panelCount: "Initial panel count" => "Początkowa liczba paneli"
// pe.minPanelCount: "Minimum panel count" => "Minimalna liczba paneli"
// pe.maxPanelCount: "Maximum panel count" => "Maksymalna liczba paneli"
// pe.panelsState: "Inner panel expand state" => "Stan rozwinięcia panelu wewnętrznego"
// pe.templateDescription: "Description template" => "Szablon opisu"
// pe.templateTitle: "Title template" => "Szablon tytułu"
// pe.panelPrevText: "Previous Panel button tooltip" => "Poprzednia etykietka przycisku panelu"
// pe.panelNextText: "Next Panel button tooltip" => "Przycisk Następny panel — etykietka narzędzia"
// pe.showRangeInProgress: "Show progress bar" => "Pokaż pasek postępu"
// pe.templateTitleLocation: "Question title location" => "Lokalizacja tytułu pytania"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "Usuń położenie przycisku panelu"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "Ukryj pytanie, jeśli nie ma wierszy"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Ukryj kolumny, jeśli nie ma wierszy"
// pe.rateValues: "Custom rate values" => "Niestandardowe wartości stawek"
// pe.rateCount: "Rate count" => "Liczba stawek"
// pe.autoGenerate: "How to specify rate values?" => "Jak określić wartości stawek?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "Ukryj pytanie, jeśli nie zawiera opcji wyboru"
// pe.hideNumber: "Hide question number" => "Ukryj numer pytania"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Minimalna szerokość (w wartościach akceptowanych przez CSS)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Maksymalna szerokość (w wartościach akceptowanych przez CSS)"
// pe.width: "Width (in CSS-accepted values)" => "Szerokość (w wartościach akceptowanych przez CSS)"
// pe.showHeader: "Show column headers" => "Pokaż nagłówki kolumn"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Pokaż poziomy pasek przewijania"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Minimalna szerokość kolumny (w wartościach akceptowanych przez CSS)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Szerokość nagłówka wiersza (w wartościach akceptowanych przez CSS)"
// pe.valueTrue: "\"True\" value" => "\"Prawdziwa\" wartość"
// pe.valueFalse: "\"False\" value" => "Wartość \"False\""
// pe.minErrorText: "\"Value is below minimum\" error message" => "Komunikat o błędzie \"Wartość jest niższa niż minimalna\""
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "Komunikat o błędzie \"Wartość przekracza maksimum\""
// pe.otherErrorText: "\"Empty comment\" error message" => "Komunikat o błędzie \"Pusty komentarz\""
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "Komunikat o błędzie \"Nieunikalna wartość klucza\""
// pe.minSelectedChoices: "Minimum selected choices" => "Minimalna wybrana opcja"
// pe.maxSelectedChoices: "Maximum selected choices" => "Maksymalna liczba wybranych opcji"
// pe.showClearButton: "Show the Clear button" => "Pokaż przycisk Wyczyść"
// pe.showNumber: "Show panel number" => "Pokaż numer panelu"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "Szerokość logo (w wartościach akceptowanych przez CSS)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "Wysokość logo (w wartościach akceptowanych przez CSS)"
// pe.readOnly: "Read-only" => "Tylko do odczytu"
// pe.enableIf: "Editable if" => "Edytowalne, jeśli"
// pe.emptyRowsText: "\"No rows\" message" => "Komunikat \"Brak wierszy\""
// pe.size: "Input field size (in characters)" => "Rozmiar pola wejściowego (w znakach)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "Oddzielne opcje specjalne (Brak, Inne, Wybierz wszystko)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Kopiowanie opcji z następującego pytania"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Które opcje skopiować?"
// pe.showCommentArea: "Show the comment area" => "Pokaż obszar komentarza"
// pe.commentPlaceholder: "Comment area placeholder" => "Symbol zastępczy obszaru komentarza"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Wyświetlanie opisów szybkości jako wartości ekstremalnych"
// pe.rowsOrder: "Row order" => "Kolejność wierszy"
// pe.columnsLayout: "Column layout" => "Układ kolumn"
// pe.columnColCount: "Nested column count" => "Liczba kolumn zagnieżdżonych"
// pe.state: "Panel expand state" => "Stan rozwinięcia panelu"
// pe.correctAnswer: "Correct Answer" => "Prawidłowa odpowiedź"
// pe.defaultPanelValue: "Default Values" => "Wartości domyślne"
// pe.cells: "Cell Texts" => "Teksty komórek"
// pe.keyName: "Key column" => "Kolumna klucza"
// itemvalue.text: "Alt text" => "Tekst alternatywny"
// pe.logoPosition: "Logo position" => "Pozycja logo"
// pe.addLogo: "Add logo..." => "Dodaj logo..."
// pe.changeLogo: "Change logo..." => "Zmień logo..."
// logoPositions.none: "Remove logo" => "Usuń logo"
// logoPositions.left: "Left" => "Lewy"
// logoPositions.right: "Right" => "Prawy"
// logoPositions.top: "On the top" => "Na górze"
// logoPositions.bottom: "In the bottom" => "Na dole"
// tabs.items: "Items" => "Elementy"
// tabs.requiredIf: "Required If" => "Wymagane, jeśli"
// tabs.numbering: "Numbering" => "Numerowanie"
// tabs.pages: "Pages" => "Stron"
// tabs.calculatedValues: "Calculated Values" => "Obliczone wartości"
// tabs.totals: "Totals" => "Sumy"
// tabs.logic: "Logic" => "Logika"
// tabs.layout: "Layout" => "Układ"
// tabs.data: "Data" => "Dane"
// tabs.validation: "Validation" => "Walidacja"
// tabs.cells: "Cell Texts" => "Teksty komórek"
// tabs.showOnCompleted: "Survey Complete" => "Ankieta zakończona"
// tabs.logo: "Logo in Survey Title" => "Logo w tytule ankiety"
// tabs.slider: "Slider" => "Suwak"
// tabs.expression: "Expression" => "Wyrażenie"
// tabs.others: "Others" => "Inni"
// pe.choicesVisibleIf: "Choices are visible if" => "Wybory są widoczne, jeśli"
// pe.choicesEnableIf: "Choices are selectable if" => "Wybory można wybrać, jeśli:"
// pe.columnsEnableIf: "Columns are visible if" => "Kolumny są widoczne, jeśli"
// pe.rowsEnableIf: "Rows are visible if" => "Wiersze są widoczne, jeśli"
// pe.indent: "Add indents" => "Dodawanie wcięć"
// panel.indent: "Add outer indents" => "Dodawanie wcięć zewnętrznych"
// pe.innerIndent: "Add inner indents" => "Dodawanie wcięć wewnętrznych"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "Pobieranie wartości domyślnych z ostatniego wiersza"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "Pobieranie wartości domyślnych z ostatniego panelu"
// pe.titleKeyboardAdornerTip: "Press enter button to edit" => "Naciśnij przycisk Enter, aby edytować"
// pe.keyboardAdornerTip: "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item" => "Naciśnij przycisk Enter, aby edytować element, naciśnij przycisk Delete, aby usunąć element, naciśnij Alt plus strzałka w górę lub strzałka w dół, aby przenieść element"
// pe.triggerFromName: "Copy value from: " => "Skopiuj wartość z: "
// pe.triggerRunExpression: "Run this Expression" => "Uruchom to wyrażenie"
// pe.triggerGotoName: "Go to the question" => "Przejdź do pytania"
// pe.triggerRunExpressionEmpty: "Please enter a valid expression" => "Wpisz poprawne wyrażenie"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "Wpisz wyrażenie tutaj..."
// pe.noFile: "No file choosen" => "Nie wybrano pliku"
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "Wyczyść wartość, jeśli pytanie zostanie ukryte"
// pe.valuePropertyName: "Value property name" => "Nazwa właściwości Value"
// pe.searchEnabled: "Enable search" => "Włącz wyszukiwanie"
// pe.hideSelectedItems: "Hide selected items" => "Ukrywanie zaznaczonych elementów"
// pe.closeOnSelect: "Close the dropdown after selection" => "Zamknij listę rozwijaną po dokonaniu wyboru"
// pe.signatureWidth: "Signature width" => "Szerokość podpisu"
// pe.signatureHeight: "Signature height" => "Wysokość podpisu"
// pe.verticalAlign: "Vertical alignment" => "Wyrównanie w pionie"
// pe.alternateRows: "Alternate rows" => "Alternatywne wiersze"
// pe.columnsVisibleIf: "Columns are visible if" => "Kolumny są widoczne, jeśli"
// pe.rowsVisibleIf: "Rows are visible if" => "Wiersze są widoczne, jeśli"
// pe.otherPlaceholder: "Comment area placeholder" => "Symbol zastępczy obszaru komentarza"
// pe.rateType: "Rate type" => "Rodzaj stawki"
// pv.true: "true" => "prawdziwy"
// pv.false: "false" => "fałszywy"
// pv.inherit: "Inherit" => "Odziedziczyć"
// pv.show: "Visible" => "Widoczny"
// pv.hide: "Hidden" => "Ukryty"
// pv.default: "Inherit" => "Odziedziczyć"
// pv.initial: "Initial" => "Inicjał"
// pv.random: "Random" => "Losowy"
// pv.collapsed: "Collapsed" => "Zwinięty"
// pv.expanded: "Expanded" => "Rozszerzony"
// pv.none: "None" => "Żaden"
// pv.asc: "Ascending" => "Rosnąco"
// pv.desc: "Descending" => "Malejąco"
// pv.indeterminate: "Indeterminate" => "Nieokreślony"
// pv.decimal: "decimal" => "dziesiętny"
// pv.currency: "currency" => "waluta"
// pv.percent: "percent" => "procent"
// pv.firstExpanded: "First panel is expanded" => "Pierwszy panel jest rozwinięty"
// pv.off: "Hide question numbers" => "Ukryj numery pytań"
// pv.onpanel: "Start on each panel" => "Rozpocznij od każdego panelu"
// pv.onPanel: "Start on each panel" => "Rozpocznij od każdego panelu"
// pv.onSurvey: "Continue throughout the survey" => "Kontynuuj przez cały czas trwania ankiety"
// pv.list: "List" => "Lista"
// pv.progressTop: "Panel navigator + Progress bar at the top" => "Nawigator paneli + pasek postępu u góry"
// pv.progressBottom: "Panel navigator + Progress bar at the bottom" => "Nawigator panelu + pasek postępu u dołu"
// pv.progressTopBottom: "Panel navigator + Progress bar at the top and bottom" => "Nawigator panelu + pasek postępu u góry i u dołu"
// pv.tab: "Tabs" => "Karty"
// pv.horizontal: "Horizontal" => "Poziomy"
// pv.vertical: "Vertical" => "Pionowy"
// pv.top: "Top" => "Do góry"
// pv.bottom: "Bottom" => "Dno"
// pv.topBottom: "Top and bottom" => "Góra i dół"
// pv.both: "Both" => "Obie"
// pv.left: "Left" => "Lewy"
// pv.right: "Right" => "Prawy"
// pv.color: "color" => "Kolor"
// pv.date: "date" => "data"
// pv.datetime: "datetime" => "datagodzina"
// pv.datetime-local: "datetime-local" => "datetime-local"
// pv.email: "email" => "E-mail"
// pv.month: "month" => "miesiąc"
// pv.number: "number" => "numer"
// pv.password: "password" => "hasło"
// pv.range: "range" => "zakres"
// pv.tel: "tel" => "Tel"
// pv.text: "text" => "Tekst"
// pv.time: "time" => "Godzina"
// pv.url: "url" => "adres URL"
// pv.week: "week" => "tydzień"
// pv.hidden: "Hidden" => "Ukryty"
// pv.on: "Continue from the previous page" => "Kontynuuj od poprzedniej strony"
// pv.onPage: "Start on each page" => "Zacznij od każdej strony"
// pv.edit: "Editable" => "Edytowalny"
// pv.display: "Read-only" => "Tylko do odczytu"
// pv.onComplete: "When the survey is completed" => "Po zakończeniu ankiety"
// pv.onHidden: "When the question becomes hidden" => "Gdy pytanie zostanie ukryte"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "Gdy pytanie lub jego panel/strona zostaną ukryte"
// clearInvisibleValues.none: "Never" => "Nigdy"
// inputType.color: "Color" => "Kolor"
// inputType.date: "Date" => "Data"
// inputType.datetime-local: "Date and Time" => "Data i godzina"
// inputType.email: "Email" => "E-mail"
// inputType.month: "Month" => "Miesiąc"
// inputType.number: "Number" => "Numer"
// inputType.password: "Password" => "Hasło"
// inputType.range: "Range" => "Zakres"
// inputType.tel: "Phone Number" => "Numer"
// inputType.text: "Text" => "Tekst"
// inputType.time: "Time" => "Godzina"
// inputType.url: "URL" => "Adres URL"
// inputType.week: "Week" => "Tydzień"
// pv.all: "All" => "Cały"
// pv.page: "Page" => "Strona"
// pv.survey: "Survey" => "Sondaż"
// pv.onNextPage: "When switching to the next page" => "Podczas przełączania do następnej strony"
// pv.onValueChanged: "After an answer is changed" => "Po zmianie odpowiedzi"
// pv.onValueChanging: "Before an answer is changed" => "Zanim odpowiedź zostanie zmieniona"
// pv.standard: "Original structure" => "Oryginalna struktura"
// pv.singlePage: "All questions on a single page" => "Wszystkie pytania na jednej stronie"
// pv.questionPerPage: "Each question on an individual page" => "Każde pytanie na osobnej stronie"
// pv.noPreview: "No preview" => "Brak podglądu"
// pv.showAllQuestions: "Show all questions" => "Pokaż wszystkie pytania"
// pv.showAnsweredQuestions: "Show answered questions only" => "Pokaż tylko odpowiedzi na pytania"
// pv.pages: "Completed pages" => "Ukończone strony"
// pv.questions: "Answered questions" => "Odpowiedzi na pytania"
// pv.requiredQuestions: "Answered required questions" => "Odpowiedzi na wymagane pytania"
// pv.correctQuestions: "Valid answers" => "Prawidłowe odpowiedzi"
// pv.buttons: "Completed pages (button UI)" => "Ukończone strony (interfejs użytkownika)"
// pv.underInput: "Under the input" => "Pod wejściem"
// pv.underTitle: "Under the title" => "Pod tytułem"
// pv.onBlur: "On blur" => "Na rozmyciu"
// pv.onTyping: "While typing" => "Podczas pisania"
// pv.underRow: "Under the row" => "Pod rzędem"
// pv.underRowSingle: "Under the row, only one panel is visible" => "Pod wierszem widoczny jest tylko jeden panel"
// showNavigationButtons.none: "Hidden" => "Ukryty"
// showProgressBar.off: "Hidden" => "Ukryty"
// showTimerPanel.none: "Hidden" => "Ukryty"
// showTimerPanelMode.all: "Both" => "Obie"
// detailPanelMode.none: "Hidden" => "Ukryty"
// addRowLocation.default: "Depends on matrix layout" => "Zależy od układu macierzy"
// panelsState.default: "Users cannot expand or collapse panels" => "Użytkownicy nie mogą rozwijać ani zwijać paneli"
// panelsState.collapsed: "All panels are collapsed" => "Wszystkie panele są zwinięte"
// panelsState.expanded: "All panels are expanded" => "Wszystkie panele są rozszerzone"
// widthMode.auto: "Auto" => "Automatycznie"
// widthMode.static: "Static" => "Statyczny"
// widthMode.responsive: "Responsive" => "Elastyczne"
// imageFit.none: "None" => "Żaden"
// imageFit.contain: "Contain" => "Zawierać"
// imageFit.cover: "Cover" => "Pokryć"
// imageFit.fill: "Fill" => "Wypełnić"
// contentMode.auto: "Auto" => "Automatycznie"
// contentMode.image: "Image" => "Obraz"
// contentMode.video: "Video" => "Wideo"
// contentMode.youtube: "YouTube" => "Serwis YouTube"
// displayMode.auto: "Auto" => "Automatycznie"
// displayMode.buttons: "Buttons" => "Przyciski"
// displayMode.dropdown: "Dropdown" => "Lista rozwijana"
// rateColorMode.default: "Default" => "Domyślny"
// autoGenerate.true: "Generate" => "Stworzyć"
// autoGenerate.false: "Enter manually" => "Wprowadź ręcznie"
// rateType.labels: "Labels" => "Etykiety"
// rateType.stars: "Stars" => "Gwiazdy"
// rateType.smileys: "Smileys" => "Uśmieszki"
// op.anyof: "Any of" => "Dowolny z"
// op.allof: "All of" => "Wszystko z"
// op.and: "and" => "i"
// op.or: "or" => "lub"
// ew.modern: "Modern theme" => "Nowoczesny motyw"
// ew.default: "Default theme" => "Motyw domyślny"
// ew.orange: "Orange theme" => "Kompozycja pomarańczowa"
// ew.darkblue: "Darkblue theme" => "Kompozycja Ciemnoniebieski"
// ew.darkrose: "Darkrose theme" => "Kompozycja Darkrose"
// ew.stone: "Stone theme" => "Kompozycja Kamień"
// ew.winter: "Winter theme" => "Kompozycja zimowa"
// ew.winterstone: "Winter-Stone theme" => "Kompozycja Kamień zimowy"
// ts.showInvisibleElements: "Show invisible elements" => "Pokaż niewidoczne elementy"
// ts.hideInvisibleElements: "Hide invisible elements" => "Ukryj niewidoczne elementy"
// validators.expressionvalidator: "Expression" => "Wyrażenie"
// triggers.copyvaluetrigger: "Copy answer" => "Kopiuj odpowiedź"
// triggers.skiptrigger: "Skip to question" => "Przejdź do pytania"
// triggers.runexpressiontrigger: "Run expression" => "Uruchom wyrażenie"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Pliki cookie uniemożliwiają użytkownikom dwukrotne wypełnienie tej samej ankiety."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Zmienia rozmiar widocznego obszaru pola wprowadzania. Użyj ustawienia <b>Walidacja → Maksymalna</b> długość, aby ograniczyć długość wprowadzania."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Użyj {0} jako symbolu zastępczego dla rzeczywistej wartości."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Opcja widoczna tylko wtedy, gdy co najmniej jedna kolumna zawiera wyrażenie typu Total lub Total."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Więcej informacji można znaleźć w opisie atrybutu [accept](https://www.w3schools.com/tags/att_input_accept.asp)."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Dotyczy tylko komórek typu Radiogroup i Checkbox."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Więcej informacji można znaleźć w opisie atrybutu [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete)."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Jeśli ta właściwość nie zostanie ustawiona, odpowiedź będzie przechowywana w polu określonym przez właściwość Name."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Jeśli określona kolumna zawiera identyczne wartości, ankieta zgłasza błąd \"Nieunikalna wartość klucza\"."
// p.multiSelect: "Allow multiple selection" => "Zezwalaj na wielokrotny wybór"
// p.showLabel: "Show image captions" => "Pokaż podpisy pod obrazami"
// p.value: "Value" => "Wartość"
// p.tabAlign: "Tab alignment" => "Wyrównanie tabulatorów"
// p.description: "Description" => "Opis"
// p.logoFit: "Logo fit" => "Dopasowanie logo"
// p.pages: "Pages" => "Stron"
// p.questions: "Questions" => "Pytania"
// p.triggers: "Triggers" => "Wyzwalaczy"
// p.calculatedValues: "Calculated values" => "Obliczone wartości"
// p.surveyId: "Survey id" => "Identyfikator ankiety"
// p.surveyPostId: "Survey post id" => "Identyfikator posta ankiety"
// p.surveyShowDataSaving: "Survey show data saving" => "Ankieta pokazuje zapisywanie danych"
// p.questionDescriptionLocation: "Question description location" => "Lokalizacja opisu pytania"
// p.progressBarType: "Progress bar type" => "Typ paska postępu"
// p.showTOC: "Show TOC" => "Pokaż spis treści"
// p.tocLocation: "Toc location" => "Lokalizacja spisu treści"
// p.questionTitlePattern: "Question title pattern" => "Wzorzec tytułu pytania"
// p.widthMode: "Width mode" => "Tryb szerokości"
// p.showBrandInfo: "Show brand info" => "Pokaż informacje o marce"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "Używanie wartości wyświetlanych w tekstach dynamicznych"
// p.visibleIf: "Visible if" => "Widoczne, jeśli"
// p.titleLocation: "Title location" => "Lokalizacja tytułu"
// p.descriptionLocation: "Description location" => "Opis lokalizacji"
// p.defaultValueExpression: "Default value expression" => "Wyrażenie wartości domyślnej"
// p.requiredIf: "Required if" => "Wymagane, jeśli:"
// p.validators: "Validators" => "Walidatory"
// p.bindings: "Bindings" => "Powiązania"
// p.renderAs: "Render as" => "Renderuj jako"
// p.attachOriginalItems: "Attach original items" => "Dołączanie oryginalnych elementów"
// p.choices: "Choices" => "Wyborów"
// p.choicesByUrl: "Choices by url" => "Opcje według adresu URL"
// p.currency: "Currency" => "Waluta"
// p.cellHint: "Cell hint" => "Wskazówka do komórki"
// p.isUnique: "Is unique" => "Jest wyjątkowy"
// p.showInMultipleColumns: "Show in multiple columns" => "Pokaż w wielu kolumnach"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Łączne maksymalne cyfry ułamkowe"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Łączne minimalne cyfry ułamkowe"
// p.columns: "Columns" => "Kolumny"
// p.detailElements: "Detail elements" => "Elementy szczegółowe"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Zezwalaj na działania adaptacyjne"
// p.defaultRowValue: "Default row value" => "Domyślna wartość wiersza"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "Panel szczegółów pokazuje się po dodaniu"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Opcje: leniwe ładowanie włączone"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Opcje: leniwy rozmiar strony ładowania"
// p.inputFieldComponent: "Input field component" => "Składnik pola wejściowego"
// p.itemComponent: "Item component" => "Składnik elementu"
// p.min: "Min" => "Min"
// p.max: "Max" => "Max"
// p.minValueExpression: "Min value expression" => "Minimalne wyrażenie wartości"
// p.maxValueExpression: "Max value expression" => "Wyrażenie wartości maksymalnej"
// p.step: "Step" => "Krok"
// p.dataList: "Data list" => "Lista danych"
// p.itemSize: "Item size" => "Rozmiar produktu"
// p.elements: "Elements" => "Pierwiastki"
// p.content: "Content" => "Zawartość"
// p.navigationButtonsVisibility: "Navigation buttons visibility" => "Widoczność przycisków nawigacyjnych"
// p.navigationTitle: "Navigation title" => "Tytuł nawigacji"
// p.navigationDescription: "Navigation description" => "Opis nawigacji"
// p.longTap: "Long tap" => "Długie dotknięcie"
// p.autoGrow: "Auto grow" => "Automatyczny wzrost"
// p.allowResize: "Allow resizing" => "Zezwalaj na zmianę rozmiaru"
// p.acceptCarriageReturn: "Accept carriage return" => "Zaakceptuj zwrot karetki"
// p.displayMode: "Display mode" => "Tryb wyświetlania"
// p.rateType: "Rate type" => "Rodzaj stawki"
// p.label: "Label" => "Etykieta"
// p.contentMode: "Content mode" => "Tryb zawartości"
// p.imageFit: "Image fit" => "Dopasowanie obrazu"
// p.altText: "Alt text" => "Tekst alternatywny"
// p.height: "Height" => "Wysokość"
// p.penColor: "Pen color" => "Kolor pióra"
// p.backgroundColor: "Background color" => "Kolor tła"
// p.templateElements: "Template elements" => "Elementy szablonu"
// p.operator: "Operator" => "Operator"
// p.isVariable: "Is variable" => "Jest zmienna"
// p.runExpression: "Run expression" => "Uruchom wyrażenie"
// p.showCaption: "Show caption" => "Pokaż podpis"
// p.iconName: "Icon name" => "Nazwa ikony"
// p.iconSize: "Icon size" => "Rozmiar ikony"
// p.precision: "Precision" => "Precyzja"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Obszar uchwytu przeciągania macierzy"
// p.backgroundImage: "Background image" => "Obraz tła"
// p.backgroundImageFit: "Background image fit" => "Dopasowanie obrazu tła"
// p.backgroundImageAttachment: "Background image attachment" => "Załącznik obrazu tła"
// p.backgroundOpacity: "Background opacity" => "Krycie tła"
// p.selectToRankEnabled: "Select to rank enabled" => "Wybierz, aby ranga była włączona"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Wybierz, aby uszeregować układ obszarów"
// p.allowCameraAccess: "Allow camera access" => "Zezwalaj na dostęp do kamery"
// p.scaleColorMode: "Scale color mode" => "Tryb skalowania kolorów"
// p.rateColorMode: "Rate color mode" => "Oceń tryb kolorów"
// p.templateTabTitle: "Template tab title" => "Tytuł karty szablonu"
// p.templateVisibleIf: "Template visible if" => "Szablon widoczny, jeśli"
// p.copyDisplayValue: "Copy display value" => "Kopiowanie wyświetlanej wartości"
// theme.--background: "Background color" => "Kolor tła"
// theme.--background-dim-light: "Background dim light color" => "Słaby kolor światła tła"
// theme.--primary-foreground: "Primary foreground color" => "Podstawowy kolor pierwszego planu"
// theme.--foreground: "Foreground color" => "Kolor pierwszego planu"
// theme.--base-unit: "Base unit" => "Jednostka bazowa"
// theme.groupAdvanced: "Advanced" => "Zaawansowany"
// theme.themeName: "Theme" => "Kompozycja"
// theme.isPanellessss: "Question appearance" => "Wygląd pytania"
// theme.isPanellessPanels: "Default" => "Domyślny"
// theme.isPanellessLightweight: "Without Panels" => "Bez paneli"
// theme.themePaletteLight: "Light" => "Światło"
// theme.themePaletteDark: "Dark" => "Ciemny"
// theme.primaryColor: "Accent color" => "Kolor wiodący"
// theme.primaryDefaultColor: "Default" => "Domyślny"
// theme.primaryDarkColor: "Hover" => "Hover"
// theme.primaryLightColor: "Selected" => "Wybrany"
// theme.backgroundDimColor: "Background color" => "Kolor tła"
// theme.backgroundImage: "Background image" => "Obraz tła"
// theme.backgroundImageFitAuto: "Auto" => "Automatycznie"
// theme.backgroundImageFitCover: "Cover" => "Pokryć"
// theme.backgroundImageFitContain: "Contain" => "Zawierać"
// theme.backgroundOpacity: "Opacity" => "Nieprzezroczystość"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Stały"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Przewijać"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Krycie tła panelu"
// theme.questionBackgroundTransparency: "Question background opacity" => "Nieprzezroczystość tła pytania"
// theme.questionPanel: "Panel background and corner radius" => "Tło panelu i promień narożnika"
// theme.questionTitle: "Question title font" => "Czcionka tytułu pytania"
// theme.questionDescription: "Question description font" => "Czcionka opisu pytania"
// theme.editorPanel: "Input element" => "Element wejściowy"
// theme.editorFont: "Input element font" => "Czcionka elementu wejściowego"
// theme.backcolor: "Default background" => "Domyślne tło"
// theme.hovercolor: "Hover background" => "Najedź kursorem na tło"
// theme.borderDecoration: "Border decoration" => "Dekoracja obramowania"
// theme.accentBackground: "Accent background" => "Tło akcentu"
// theme.accentForeground: "Accent foreground" => "Akcent na pierwszym planie"
// theme.primaryForecolor: "Default color" => "Kolor domyślny"
// theme.primaryForecolorLight: "Disabled color" => "Kolor wyłączony"
// theme.linesColors: "Minor line colors" => "Pomocnicze kolory linii"
// theme.borderDefault: "Darker" => "Ciemniejsze"
// theme.borderLight: "Lighter" => "Zapalniczka"
// theme.fontFamily: "Font family" => "Rodzina czcionek"
// theme.fontSize: "Font size" => "Rozmiar czcionki"
// theme.color: "Color" => "Kolor"
// theme.size: "Size" => "Rozmiar"
// theme.fontWeightRegular: "Regular" => "Regularny"
// theme.fontWeightHeavy: "Heavy" => "Ciężki"
// theme.fontWeightSemiBold: "Semi-bold" => "Półpogrubienie"
// theme.fontWeightBold: "Bold" => "Śmiały"
// theme.scale: "Scale" => "Skala"
// theme.cornerRadius: "Corner radius" => "Promień narożnika"
// theme.surveyTitleFont: "Survey title font" => "Czcionka tytułu ankiety"
// theme.pageTitle: "Page title font" => "Czcionka tytułu strony"
// theme.pageDescription: "Page description font" => "Czcionka opisu strony"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Dodaj efekt cienia"
// theme.opacity: "Opacity" => "Nieprzezroczystość"
// theme.boxShadowBlur: "Blur" => "Zacierać"
// theme.boxShadowSpread: "Spread" => "Rozprzestrzenianie się"
// theme.boxShadowDrop: "Drop" => "Kropla"
// theme.boxShadowInner: "Inner" => "Wewnętrzny"
// theme.questionShadow: "Shadow effects" => "Efekty cienia"
// theme.editorShadow: "Input element shadow effects" => "Efekty cienia elementu wejściowego"
// names.default: "Default" => "Domyślny"
// names.contrast: "Contrast" => "Kontrast"
// names.plain: "Plain" => "Równina"
// names.simple: "Simple" => "Prosty"
// names.blank: "Blank" => "Pusty"
// names.double: "Double" => "Podwójny"
// names.bulk: "Bulk" => "Wielkość"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo 3D"
// names.playful: "Playful" => "Figlarny"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Teal"
// colors.blue: "Blue" => "Niebieski"
// colors.purple: "Purple" => "Purpura"
// colors.orchid: "Orchid" => "Orchidea"
// colors.tulip: "Tulip" => "Tulipan"
// colors.brown: "Brown" => "Brązowy"
// colors.green: "Green" => "Zielony"
// names.sharp: "Sharp" => "Ostry"
// names.borderless: "Borderless" => "Bez obramowania"
// names.flat: "Flat" => "Płaski"
// names.doubleborder: "Double Border" => "Podwójna ramka"
// names.layered: "Layered" => "Warstwowe"
// names.solid: "Solid" => "Bryła"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Czy na pewno chcesz usunąć wszystkie ciągi znaków dla tego języka?"
// ed.themeResetButton: "Reset theme settings to default" => "Przywracanie domyślnych ustawień motywu"
// theme.placeholderColor: "Placeholder color" => "Kolor zastępczy"
// ed.themeSettings: "Theme Settings" => "Ustawienia motywu"
// ed.themeSettingsTooltip: "Open theme settings" => "Otwórz ustawienia motywu"
// pe.resetToDefaultCaption: "Reset" => "Resetować"
// pv.file: "Local files" => "Pliki lokalne"
// pv.camera: "Camera" => "Kamera"
// pv.file-camera: "Local files or camera" => "Pliki lokalne lub aparat"
// ed.translateUsigAI: "Auto-translate All" => "Automatycznie tłumacz wszystko"
// ed.translationDialogTitle: "Untranslated strings" => "Nieprzetłumaczone ciągi znaków"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Podaj co najmniej {0} przedmiotów"
// lg.question_resetValueName: "Reset question value" => "Zresetuj wartość pytania"
// lg.column_resetValue: "Reset column value" => "Resetowanie wartości kolumny"
// pe.markRequired: "Mark as required" => "Oznacz jako wymagane"
// pe.removeRequiredMark: "Remove the required mark" => "Usuń wymagany znacznik"
// p.resetValueIf: "Reset value if" => "Zresetuj wartość, jeśli"
// lg.question_setValueName: "Set question value" => "Ustawianie wartości pytania"
// lg.column_resetValueName: "Reset column value" => "Resetowanie wartości kolumny"
// lg.column_setValueName: "Set column value" => "Ustawianie wartości kolumny"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Wyrażenie, którego wynik zostanie przypisany do pytania docelowego."
// survey.title: "Title" => "Tytuł"
// page.title: "Title" => "Tytuł"
// p.setValueIf: "Set value if" => "Ustaw wartość, jeśli"
// theme.header: "Header" => "Nagłówek"
// theme.backgroundImageFitFill: "Stretch" => "Rozciągnąć"
// theme.backgroundImageFitTile: "Tile" => "Kafelek"
// theme.headerView: "View" => "Widok"
// theme.headerViewBasic: "Basic" => "Podstawowy"
// theme.headerViewAdvanced: "Advanced" => "Zaawansowany"
// theme.headerInheritWidthFrom: "Content area width" => "Szerokość obszaru zawartości"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Tak samo jak ankieta"
// theme.headerInheritWidthFromPage: "Fit to page" => "Dopasuj do strony"
// theme.headerTextAreaWidth: "Text width" => "Szerokość tekstu"
// theme.headerBackgroundColorSwitch: "Background color" => "Kolor tła"
// theme.headerBackgroundColorNone: "None" => "Żaden"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Kolor wiodący"
// theme.headerBackgroundColorCustom: "Custom" => "Zwyczaj"
// theme.horizontalAlignmentLeft: "Left" => "Lewy"
// theme.horizontalAlignmentCenter: "Center" => "Centrum"
// theme.horizontalAlignmentRight: "Right" => "Prawy"
// theme.verticalAlignmentTop: "Top" => "Do góry"
// theme.verticalAlignmentMiddle: "Middle" => "Środek"
// theme.verticalAlignmentBottom: "Bottom" => "Dno"
// theme.logoPosition: "Logo Position" => "Pozycja logo"
// theme.headerTitlePosition: "Title Position" => "Pozycja tytułu"
// lg.question_resetValueText: "reset value for question: {0}" => "Zresetuj wartość dla pytania: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Przypisz wartość: {1} do pytania: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Zresetuj wartość komórki dla kolumny: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Przypisz wartość komórki: {1} do kolumny: {0}"
// ed.surveyJsonExportButton: "Export" => "Eksport"
// ed.surveyJsonImportButton: "Import" => "Import"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Kopiuj do schowka"
// pe.filePlaceholder: "File placeholder text" => "Tekst zastępczy pliku"
// pe.photoPlaceholder: "Photo placeholder text" => "Tekst zastępczy zdjęcia"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Tekst zastępczy pliku lub zdjęcia"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Ma zastosowanie, gdy \"Typ źródła\" to \"Pliki lokalne\" lub gdy kamera jest niedostępna"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Ma zastosowanie, gdy \"Typ źródła\" to \"Kamera\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Ma zastosowanie, gdy \"Typ źródła\" to \"Pliki lokalne lub kamera\"."
// theme.background: "Background" => "Tło"
// theme.appearance: "Appearance" => "Wygląd"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Czy naprawdę chcesz zresetować motyw? Wszystkie Twoje dostosowania zostaną utracone."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Tak, zresetuj motyw"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Pasuje do pojemnika"
// signaturepad.showPlaceholder: "Show the placeholder" => "Pokazywanie symbolu zastępczego"
// signaturepad.placeholder: "Placeholder text" => "Tekst zastępczy"
// theme.surveyDescriptionFont: "Survey description font" => "Czcionka opisu ankiety"
// ed.prevFocus: "Focus previous" => "Fokus poprzedni"
// ed.nextFocus: "Focus next" => "Ostrość następna"
// ed.saveTheme: "Save Theme" => "Zapisz motyw"
// ed.saveThemeTooltip: "Save Theme" => "Zapisz motyw"
// lg.page_requireName: "Make page required" => "Ustaw stronę jako wymaganą"
// lg.panel_requireName: "Make page required" => "Ustaw stronę jako wymaganą"
// signaturepad.signatureWidth: "Signature area width" => "Szerokość obszaru podpisu"
// signaturepad.signatureHeight: "Signature area height" => "Wysokość obszaru podpisu"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Automatyczne skalowanie obszaru podpisu"
// signaturepad.penMinWidth: "Minimum pen width" => "Minimalna szerokość pisaka"
// signaturepad.penMaxWidth: "Maximum pen width" => "Maksymalna szerokość pisaka"
// theme.headerDescriptionPosition: "Description position" => "Opis pozycja"
// ed.propertyGridNoResultsFound: "No results found" => "Nie znaleziono wyników"
// pv.leftRight: "Left and right" => "Lewy i prawy"
// p.sourceType: "Source type" => "Typ źródła"
// p.fitToContainer: "Fit to container" => "Pasuje do pojemnika"
// p.setValueExpression: "Set value expression" => "Wyrażenie wartości zadanej"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Opcje są ładowane z usługi internetowej."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Przejdź do ustawień"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Podgląd wczytanych opcji wyboru"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Zapobieganie zduplikowanym odpowiedziom w wierszach"
// theme.advancedMode: "Advanced mode" => "Tryb zaawansowany"
// theme.backgroundCornerRadius: "Background and corner radius" => "Tło i promień narożnika"
// theme.colorsTitle: "Colors" => "Kolory"
// theme.font: "Font" => "Czcionka"
// theme.lines: "Lines" => "Linie"
// theme.titleFont: "Title font" => "Czcionka tytułu"
// theme.descriptionFont: "Description font" => "Czcionka opisu"
// theme.shadow: "Shadow effects" => "Efekty cienia"
// ed.translateUsigAIFrom: "Translate from: " => "Przetłumacz z: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Zezwól na opcję Odmów odpowiedzi"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Zezwól na opcję Nie wiem"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Zezwól na opcję Odmów odpowiedzi"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Zezwól na opcję Nie wiem"
// pv.contain: "Contain" => "Zawierać"
// pv.cover: "Cover" => "Pokryć"
// pv.fill: "Fill" => "Wypełnić"
// pe.transposeData: "Transpose rows to columns" => "Transponowanie wierszy do kolumn"
// layout.panel: "Layout" => "Układ"
// layout.question: "Layout" => "Układ"
// layout.base: "Layout" => "Układ"
// panel.name: "Panel name" => "Nazwa panelu"
// panel.title: "Panel title" => "Tytuł panelu"
// panel.description: "Panel description" => "Opis panelu"
// panel.visibleIf: "Make the panel visible if" => "Uwidocznij panel, jeśli"
// panel.requiredIf: "Make the panel required if" => "Ustaw panel jako wymagany, jeśli"
// panel.questionsOrder: "Question order within the panel" => "Kolejność pytań w panelu"
// panel.startWithNewLine: "Display the panel on a new line" => "Wyświetlanie panelu w nowym wierszu"
// panel.state: "Panel collapse state" => "Stan zwijania panelu"
// panel.width: "Inline panel width" => "Szerokość panelu w linii"
// panel.minWidth: "Minimum panel width" => "Minimalna szerokość panelu"
// panel.maxWidth: "Maximum panel width" => "Maksymalna szerokość panelu"
// panel.showNumber: "Number panels" => "Panele numeryczne"
// paneldynamic.name: "Panel name" => "Nazwa panelu"
// paneldynamic.title: "Panel title" => "Tytuł panelu"
// paneldynamic.description: "Panel description" => "Opis panelu"
// paneldynamic.visibleIf: "Make the panel visible if" => "Uwidocznij panel, jeśli"
// paneldynamic.requiredIf: "Make the panel required if" => "Ustaw panel jako wymagany, jeśli"
// paneldynamic.page: "Move the panel to page" => "Przenieś panel na stronę"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Wyświetlanie panelu w nowym wierszu"
// paneldynamic.state: "Panel collapse state" => "Stan zwijania panelu"
// paneldynamic.width: "Inline panel width" => "Szerokość panelu w linii"
// paneldynamic.minWidth: "Minimum panel width" => "Minimalna szerokość panelu"
// paneldynamic.maxWidth: "Maximum panel width" => "Maksymalna szerokość panelu"
// paneldynamic.templateDescription: "Panel description pattern" => "Wzorzec opisu panelu"
// paneldynamic.templateTitle: "Panel title pattern" => "Wzorzec tytułu panelu"
// paneldynamic.noEntriesText: "Empty panel text" => "Pusty tekst panelu"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Wzorzec tytułu tabulatora"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Uwidocznij pojedynczy panel, jeśli"
// paneldynamic.hideNumber: "Hide the panel number" => "Ukryj numer panelu"
// paneldynamic.titleLocation: "Panel title alignment" => "Wyrównanie tytułu panelu"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Wyrównanie opisu panelu"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Wyrównanie tytułu pytania"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Wyrównanie komunikatu o błędzie"
// paneldynamic.newPanelPosition: "New panel location" => "Nowa lokalizacja panelu"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Zapobiegaj zduplikowanym odpowiedziom w następującym pytaniu"
// question.name: "Question name" => "Nazwa pytania"
// question.title: "Question title" => "Tytuł pytania"
// question.description: "Question description" => "Opis pytania"
// question.visibleIf: "Make the question visible if" => "Uwidocznij pytanie, jeśli"
// question.requiredIf: "Make the question required if" => "Zadbaj o to, aby pytanie było wymagane, jeśli"
// question.state: "Question box collapse state" => "Stan zwinięcia pola pytania"
// question.hideNumber: "Hide the question number" => "Ukryj numer pytania"
// question.titleLocation: "Question title alignment" => "Wyrównanie tytułu pytania"
// question.descriptionLocation: "Question description alignment" => "Wyrównanie opisu pytania"
// question.errorLocation: "Error message alignment" => "Wyrównanie komunikatu o błędzie"
// question.indent: "Increase the inner indent" => "Zwiększ wcięcie wewnętrzne"
// question.width: "Inline question width" => "Szerokość pytania w tekście"
// question.minWidth: "Minimum question width" => "Minimalna szerokość pytania"
// question.maxWidth: "Maximum question width" => "Maksymalna szerokość pytania"
// question.textUpdateMode: "Update input field value" => "Aktualizowanie wartości pola wejściowego"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Pokaż przycisk Wyczyść w obszarze podpisu"
// signaturepad.penColor: "Stroke color" => "Kolor obrysu"
// comment.rows: "Input field height (in lines)" => "Wysokość pola wejściowego (w wierszach)"
// expression.name: "Expression name" => "Nazwa wyrażenia"
// expression.title: "Expression title" => "Tytuł wyrażenia"
// expression.description: "Expression description" => "Opis wyrażenia"
// expression.expression: "Expression" => "Wyrażenie"
// trigger.expression: "Expression" => "Wyrażenie"
// calculatedvalue.expression: "Expression" => "Wyrażenie"
// survey.description: "Survey description" => "Opis ankiety"
// page.name: "Page name" => "Nazwa strony"
// page.description: "Page description" => "Opis strony"
// page.visibleIf: "Make the page visible if" => "Spraw, aby strona była widoczna, jeśli"
// page.requiredIf: "Make the page required if" => "Ustaw stronę jako wymaganą, jeśli"
// page.questionsOrder: "Question order on the page" => "Kolejność pytań na stronie"
// matrixdropdowncolumn.name: "Column name" => "Nazwa kolumny"
// matrixdropdowncolumn.title: "Column title" => "Tytuł kolumny"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Zapobieganie zduplikowanym odpowiedziom"
// matrixdropdowncolumn.width: "Column width" => "Szerokość kolumny"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Minimalna szerokość kolumny"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Wysokość pola wejściowego (w wierszach)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Ustaw kolumnę jako widoczną, jeśli"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Ustaw kolumnę jako wymaganą, jeśli"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Każda opcja w osobnej kolumnie"
// multipletextitem.name: "Name" => "Nazwa"
// multipletextitem.title: "Title" => "Tytuł"
// pe.rateDescriptionLocation: "Label alignment" => "Wyrównanie etykiety"
// pe.cellErrorLocation: "Cell error message alignment" => "Wyrównanie komunikatu o błędzie komórki"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Nie masz jeszcze żadnych kolumn"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Nie masz jeszcze żadnych wierszy"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Nie masz jeszcze żadnych reguł sprawdzania poprawności"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Nie masz jeszcze żadnych zmiennych niestandardowych"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Nie masz jeszcze żadnych wyzwalaczy"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Nie masz jeszcze żadnych linków"
// pe.addNew@columns: "Add new column" => "Dodaj nową kolumnę"
// pe.addNew@rows: "Add new row" => "Dodaj nowy wiersz"
// pe.addNew@validators: "Add new rule" => "Dodaj nową regułę"
// pe.addNew@calculatedValues: "Add new variable" => "Dodaj nową zmienną"
// pe.addNew@triggers: "Add new trigger" => "Dodaj nowy wyzwalacz"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Dodaj nowy adres URL"
// choicesbyurl.url: "Web service's URL" => "Adres URL usługi sieci Web"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Wyświetlanie tytułów stron na pasku postępu"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Wyświetlanie numerów stron na pasku postępu"
// itemvalue.visibleIf: "Make the option visible if" => "Uwidocznij opcję, jeśli"
// itemvalue.enableIf: "Make the option selectable if" => "Spraw, aby opcja była wybieralna, jeśli"
// panel.layout: "Panel Layout" => "Układ panelu"
// tabs.questionSettings: "Question Settings" => "Ustawienia pytań"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Przykład: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Np.: kategorie.beletrystyka"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Np.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Np.: 6 cali"
// pe.minWidth_placeholder: "Ex.: 600px" => "Przykład: 600 pikseli"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Przykład: 50%"
// pv.selected: "Selected" => "Wybrany"
// pv.unselected: "Unselected" => "Niezaznaczone"
// pv.center: "Center" => "Centrum"
// pv.middle: "Middle" => "Środek"
// pv.next: "Next" => "Następny"
// pv.last: "Last" => "Ostatni"
// clearIfInvisible.none: "Never" => "Nigdy"
// questionsOnPageMode.standard: "Original structure" => "Oryginalna struktura"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Pokaż wszystkie pytania na jednej stronie"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Pokaż pojedyncze pytanie na stronie"
// pv.auto: "Auto" => "Automatycznie"
// panelsState.firstExpanded: "First expanded" => "Pierwsze rozszerzone"
// rateColorMode.scale: "Scale" => "Skala"
// scaleColorMode.monochrome: "Monochrome" => "Monochromatyczny"
// scaleColorMode.colored: "Colored" => "Kolorowe"
// state.default: "Locked" => "Zablokowany"
// showQuestionNumbers.default: "Auto-numbering" => "Automatyczne numerowanie"
// showQuestionNumbers.on: "Auto-numbering" => "Automatyczne numerowanie"
// showQuestionNumbers.onPage: "Reset on each page" => "Resetuj na każdej stronie"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Resetuj na każdym panelu"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Resetuj na każdym panelu"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Kontynuuj badanie"
// showQuestionNumbers.off: "No numbering" => "Brak numeracji"
// descriptionLocation.underTitle: "Under the question title" => "Pod tytułem pytania"
// descriptionLocation.underInput: "Under the input field" => "Pod polem wprowadzania danych"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Obok opcji do wyboru"
// selectToRankAreasLayout.vertical: "Above choices" => "Powyższe wybory"
// displayStyle.decimal: "Decimal" => "Dziesiętny"
// displayStyle.currency: "Currency" => "Waluta"
// displayStyle.percent: "Percentage" => "Procent"
// displayStyle.date: "Date" => "Data"
// totalDisplayStyle.decimal: "Decimal" => "Dziesiętny"
// totalDisplayStyle.currency: "Currency" => "Waluta"
// totalDisplayStyle.percent: "Percentage" => "Procent"
// totalDisplayStyle.date: "Date" => "Data"
// rowsOrder.initial: "Original" => "Oryginał"
// questionsOrder.initial: "Original" => "Oryginał"
// showProgressBar.aboveheader: "Above the header" => "Nad nagłówkiem"
// showProgressBar.belowheader: "Below the header" => "Pod nagłówkiem"
// pv.sum: "Sum" => "Suma"
// pv.count: "Count" => "Hrabia"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Max"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Contains"
// searchMode.startsWith: "Starts with" => "Zaczyna się od"
// panel.name: "A panel ID that is not visible to respondents." => "Identyfikator panelu, który nie jest widoczny dla respondentów."
// panel.description: "Type a panel subtitle." => "Wpisz podtytuł panelu."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa widoczność panelu."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która wyłącza tryb tylko do odczytu dla panelu."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która uniemożliwia przesłanie ankiety, chyba że co najmniej jedno zagnieżdżone pytanie ma odpowiedź."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Dotyczy wszystkich pytań w tym panelu. Jeśli chcesz zastąpić to ustawienie, zdefiniuj reguły wyrównania tytułów dla poszczególnych pytań. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety (domyślnie \"Góra\")."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Ustawia lokalizację komunikatu o błędzie w odniesieniu do wszystkich pytań w panelu. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Zachowuje pierwotną kolejność pytań lub losuje je. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety."
// panel.page: "Repositions the panel to the end of a selected page." => "Przesuwa panel na koniec zaznaczonej strony."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Dodaje odstęp lub margines między zawartością panelu a lewą krawędzią ramki panelu."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Usuń zaznaczenie, aby wyświetlić panel w jednym wierszu z poprzednim pytaniem lub panelem. To ustawienie nie ma zastosowania, jeśli panel jest pierwszym elementem formularza."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Do wyboru: \"Rozwinięty\" - panel wyświetla się w całości i można go zwinąć; \"Zwinięty\" - panel wyświetla tylko tytuł i opis i można go rozwinąć; \"Zablokowany\" - panel jest wyświetlany w całości i nie można go zwinąć."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Ustawia szerokość panelu proporcjonalnie do innych elementów pomiarowych w tej samej linii. Akceptuje wartości CSS (px, %, in, pt itp.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "Identyfikator panelu, który nie jest widoczny dla respondentów."
// paneldynamic.description: "Type a panel subtitle." => "Wpisz podtytuł panelu."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa widoczność panelu."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która wyłącza tryb tylko do odczytu dla panelu."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która uniemożliwia przesłanie ankiety, chyba że co najmniej jedno zagnieżdżone pytanie ma odpowiedź."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Dotyczy wszystkich pytań w tym panelu. Jeśli chcesz zastąpić to ustawienie, zdefiniuj reguły wyrównania tytułów dla poszczególnych pytań. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety (domyślnie \"Góra\")."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Ustawia lokalizację komunikatu o błędzie w odniesieniu do pytania z nieprawidłowymi danymi wejściowymi. Wybierz pomiędzy: \"Góra\" - tekst błędu jest umieszczany w górnej części pola pytania; \"Na dole\" — tekst błędu jest umieszczany u dołu pola pytania. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety (domyślnie \"Góra\")."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Ustawia lokalizację komunikatu o błędzie w odniesieniu do wszystkich pytań w panelu. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Przesuwa panel na koniec zaznaczonej strony."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Dodaje odstęp lub margines między zawartością panelu a lewą krawędzią ramki panelu."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Usuń zaznaczenie, aby wyświetlić panel w jednym wierszu z poprzednim pytaniem lub panelem. To ustawienie nie ma zastosowania, jeśli panel jest pierwszym elementem formularza."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Do wyboru: \"Rozwinięty\" - panel wyświetla się w całości i można go zwinąć; \"Zwinięty\" - panel wyświetla tylko tytuł i opis i można go rozwinąć; \"Zablokowany\" - panel jest wyświetlany w całości i nie można go zwinąć."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Ustawia szerokość panelu proporcjonalnie do innych elementów pomiarowych w tej samej linii. Akceptuje wartości CSS (px, %, in, pt itp.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Wpisz szablon dynamicznych tytułów paneli. Użyj {panelIndex} dla ogólnego położenia panelu i {visiblePanelIndex} dla jego kolejności wśród widocznych paneli. Wstaw te symbole zastępcze do wzoru, aby dodać automatyczną numerację."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Wpisz szablon tytułów kart. Użyj {panelIndex} dla ogólnego położenia panelu i {visiblePanelIndex} dla jego kolejności wśród widocznych paneli. Wstaw te symbole zastępcze do wzoru, aby dodać automatyczną numerację."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "To ustawienie umożliwia sterowanie widocznością poszczególnych paneli w panelu dynamicznym. Użyj symbolu zastępczego \"{panel}\", aby odwołać się do bieżącego panelu w wyrażeniu."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "To ustawienie jest automatycznie dziedziczone przez wszystkie pytania w tym panelu. Jeśli chcesz zastąpić to ustawienie, zdefiniuj reguły wyrównania tytułów dla poszczególnych pytań. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety (domyślnie \"Góra\")."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "Opcja \"Dziedzicz\" stosuje ustawienie na poziomie strony (jeśli jest ustawione) lub na poziomie ankiety (domyślnie \"Pod tytułem panelu\")."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Określa położenie nowo dodanego panelu. Domyślnie nowe panele są dodawane na końcu. Wybierz \"Dalej\", aby wstawić nowy panel po bieżącym."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Duplikuje odpowiedzi z ostatniego panelu i przypisuje je do następnego dodanego panelu dynamicznego."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Odwołaj się do nazwy pytania, aby wymagać od użytkownika podania unikatowej odpowiedzi na to pytanie w każdym panelu."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "To ustawienie umożliwia przypisanie domyślnej wartości odpowiedzi na podstawie wyrażenia. Wyrażenie może zawierać podstawowe obliczenia - '{q1_id} + {q2_id}', wyrażenia logiczne, takie jak '{wiek} > 60' oraz funkcje: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' itp. Wartość określona przez to wyrażenie służy jako początkowa wartość domyślna, która może zostać zastąpiona przez ręczne wprowadzanie danych przez respondenta."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa, kiedy dane wejściowe respondenta są resetowane do wartości na podstawie \"Wyrażenia wartości domyślnej\" lub \"Wyrażenia wartości domyślnej\" lub wartości \"Odpowiedź domyślna\" (jeśli którakolwiek z nich jest ustawiona)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa, kiedy uruchomić \"Wyrażenie wartości zestawu\" i dynamicznie przypisać wynikową wartość jako odpowiedź."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Określ wyrażenie definiujące wartość, która ma zostać ustawiona, gdy zostaną spełnione warunki reguły \"Ustaw wartość, jeśli\". Wyrażenie może zawierać podstawowe obliczenia - '{q1_id} + {q2_id}', wyrażenia logiczne, takie jak '{wiek} > 60' oraz funkcje: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' itp. Wartość określona przez to wyrażenie może zostać zastąpiona przez ręczne wprowadzenie danych przez respondenta."
// question.name: "A question ID that is not visible to respondents." => "Identyfikator pytania, który nie jest widoczny dla respondentów."
// question.description: "Type a question subtitle." => "Wpisz podtytuł pytania."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa widoczność pytania."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która wyłącza tryb tylko do odczytu dla pytania."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która uniemożliwia przejście do przodu lub przesłanie ankiety, chyba że na pytanie otrzymano odpowiedź."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Usuń zaznaczenie, aby wyświetlić pytanie w jednym wierszu z poprzednim pytaniem lub panelem. To ustawienie nie ma zastosowania, jeśli pytanie jest pierwszym elementem formularza."
// question.page: "Repositions the question to the end of a selected page." => "Zmienia położenie pytania na końcu zaznaczonej strony."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Do wyboru: \"Rozwinięte\" - pole pytania wyświetla się w całości i można je zwinąć; \"Zwinięte\" - pole pytania wyświetla tylko tytuł i opis i można je rozwinąć; \"Zablokowane\" - pole pytania jest wyświetlane w całości i nie można go zwinąć."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Zastępuje reguły wyrównania tytułów zdefiniowane na poziomie panelu, strony lub ankiety. Opcja \"Dziedzicz\" stosuje wszystkie ustawienia wyższego poziomu (jeśli są ustawione) lub ustawienia na poziomie ankiety (domyślnie \"Góra\")."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety (domyślnie \"Pod tytułem pytania\")."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Ustawia lokalizację komunikatu o błędzie w odniesieniu do pytania z nieprawidłowymi danymi wejściowymi. Wybierz pomiędzy: \"Góra\" - tekst błędu jest umieszczany w górnej części pola pytania; \"Na dole\" — tekst błędu jest umieszczany u dołu pola pytania. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety (domyślnie \"Góra\")."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Dodaje spację lub margines między treścią pytania a lewą krawędzią pola pytania."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Ustawia szerokość pytania proporcjonalnie do innych elementów ankiety w tym samym wierszu. Akceptuje wartości CSS (px, %, in, pt itp.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Użyj ikony magicznej różdżki, aby ustawić regułę sprawdzania poprawności dla pytania."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Do wyboru: \"W przypadku utraty fokusu\" - wartość jest aktualizowana, gdy pole wejściowe traci fokus; \"Podczas pisania\" - wartość jest aktualizowana w czasie rzeczywistym, w miarę pisania przez użytkowników. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety (domyślnie \"Po utracie fokusu\")."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Możesz użyć dowolnej usługi internetowej jako źródła danych dla pytań wielokrotnego wyboru. Aby wypełnić wartości wyborów, wprowadź adres URL usługi udostępniającej dane."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Operacja porównania używana do filtrowania listy rozwijanej."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Ustawia szerokość wyświetlanego obszaru podpisu i wynikowego obrazu."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Ustawia wysokość wyświetlanego obszaru podpisu i wynikowego obrazu."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Wybierz, czy chcesz, aby obszar podpisu wypełniał całą dostępną przestrzeń w polu pytania, zachowując domyślny współczynnik proporcji 3:2. Po ustawieniu niestandardowych wartości szerokości i wysokości ustawienie zachowa proporcje tych wymiarów."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Dostosowuje wysokość obrazu w wynikach ankiety."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Dostosowuje szerokość obrazu w wynikach ankiety."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Zastępuje minimalne i maksymalne wartości wysokości."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Zastępuje minimalne i maksymalne wartości szerokości."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Wartość\" służy jako identyfikator elementu używany w regułach warunkowych; Respondentom wyświetla się \"Tekst\"."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "To ustawienie zmienia tylko rozmiar pola wejściowego i nie wpływa na szerokość pola pytania. Aby ograniczyć akceptowaną długość danych wejściowych, przejdź do <b>sekcji Walidacja → Maksymalny limit znaków</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Ustawia liczbę wyświetlanych wierszy w polu wprowadzania. Jeśli dane wejściowe zajmują więcej wierszy, pojawi się pasek przewijania."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Wybierz pomiędzy: \"Edytowalne\" - umożliwia respondentom wypełnienie ankiety; \"Tylko do odczytu\" - wyłącza edycję formularza."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "Identyfikator kolumny, który nie jest widoczny dla respondentów."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Po włączeniu tej opcji dla kolumny respondent musi udzielić unikatowej odpowiedzi na każde pytanie w tej kolumnie."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Ustawia liczbę wyświetlanych wierszy w polu wprowadzania. Jeśli dane wejściowe zajmują więcej wierszy, pojawi się pasek przewijania."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa widoczność kolumny."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która wyłącza tryb tylko do odczytu dla kolumny."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która uniemożliwia przesłanie ankiety, chyba że co najmniej jedno zagnieżdżone pytanie ma odpowiedź."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Gdy ta opcja jest zaznaczona, tworzy osobną kolumnę dla każdej opcji wyboru."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Do wyboru: \"Statyczny\" - ustawia stałą szerokość; \"Responsywny\" - sprawia, że ankieta zajmuje całą szerokość ekranu; \"Auto\" – stosuje jedną z tych dwóch opcji w zależności od użytych typów pytań."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Wklej link do obrazu (bez ograniczeń rozmiaru) lub kliknij ikonę folderu, aby przeglądać plik z komputera (do 64 KB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Ustawia szerokość logo w jednostkach CSS (px, %, in, pt itd.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Ustawia wysokość logo w jednostkach CSS (px, %, in, pt itd.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Do wyboru: \"Brak\" - obraz zachowuje swój oryginalny rozmiar; \"Zawieraj\" - rozmiar obrazu jest zmieniany tak, aby pasował przy zachowaniu proporcji; \"Okładka\" - obraz wypełnia całe pole z zachowaniem proporcji; \"Wypełnij\" - obraz jest rozciągany w celu wypełnienia pola bez zachowania jego proporcji."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Wybierz, czy chcesz, aby ankieta automatycznie przechodziła do następnej strony po udzieleniu przez respondenta odpowiedzi na wszystkie pytania na bieżącej stronie."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Ustawia widoczność i położenie przycisków nawigacyjnych na stronie."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Ustawia widoczność i położenie paska postępu. Wartość \"Auto\" wyświetla pasek postępu nad lub pod nagłówkiem ankiety."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Włącz stronę podglądu ze wszystkimi pytaniami lub tylko odpowiedziami."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Dotyczy wszystkich pytań w ankiecie. To ustawienie może zostać zastąpione przez reguły wyrównania tytułu na niższych poziomach: panelu, strony lub pytania. Ustawienie niższego poziomu zastąpi ustawienia wyższego poziomu."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Symbol lub sekwencja symboli wskazująca, że odpowiedź jest wymagana."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Wprowadź cyfrę lub literę, od której chcesz rozpocząć numerację."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Ustawia lokalizację komunikatu o błędzie w odniesieniu do pytania z nieprawidłowymi danymi wejściowymi. Wybierz pomiędzy: \"Góra\" - tekst błędu jest umieszczany w górnej części pola pytania; \"Na dole\" — tekst błędu jest umieszczany u dołu pola pytania."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Wybierz, jeśli chcesz, aby pierwsze pole wejściowe na każdej stronie było gotowe do wprowadzenia tekstu."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Zachowuje pierwotną kolejność pytań lub losuje je. Efekt tego ustawienia jest widoczny tylko na karcie Podgląd."
// pehelp.maxTextLength: "For text entry questions only." => "Tylko w przypadku pytań tekstowych."
// pehelp.maxOthersLength: "For question comments only." => "Tylko w przypadku komentarzy do pytań."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Zaznacz, jeśli chcesz, aby komentarze do pytań i pytania z długim tekstem automatycznie zwiększały się na podstawie wprowadzonej długości tekstu."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Tylko w przypadku komentarzy do pytań i pytań z długim tekstem."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Zmienne niestandardowe służą jako zmienne pośrednie lub pomocnicze używane w obliczeniach formularzy. Przyjmują dane wejściowe respondentów jako wartości źródłowe. Każda zmienna niestandardowa ma unikatową nazwę i wyrażenie, na którym jest oparta."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Wybierz, czy obliczona wartość wyrażenia ma być zapisywana wraz z wynikami ankiety."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Wyzwalacz to zdarzenie lub warunek oparty na wyrażeniu. Gdy wyrażenie zostanie ocenione na wartość \"true\", wyzwalacz uruchamia akcję. Taka akcja może opcjonalnie mieć pytanie docelowe, na które wpływa."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Wybierz, czy chcesz wyczyścić wartości pytań ukrytych przez logikę warunkową i kiedy to zrobić."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Do wyboru: \"W przypadku utraty fokusu\" - wartość jest aktualizowana, gdy pole wejściowe traci fokus; \"Podczas pisania\" - wartość jest aktualizowana w czasie rzeczywistym, w miarę pisania przez użytkowników."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Lewa wartość służy jako identyfikator kolumny używany w regułach warunkowych, prawa wartość jest wyświetlana respondentom."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Lewa wartość służy jako identyfikator wiersza używany w regułach warunkowych, prawa wartość jest wyświetlana respondentom."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Akceptuje wartości CSS (px, %, in, pt itp.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Akceptuje wartości CSS (px, %, in, pt itp.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Ustawia lokalizację komunikatu o błędzie w odniesieniu do komórki z nieprawidłowymi danymi wejściowymi. Opcja \"Dziedzicz\" stosuje ustawienie z właściwości \"Wyrównanie komunikatu o błędzie\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Gdy właściwość \"Zapobiegaj zduplikowanym odpowiedziom\" jest włączona, respondent próbujący przesłać zduplikowany wpis otrzyma następujący komunikat o błędzie."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Umożliwia obliczanie wartości całkowitych na podstawie wyrażenia. Wyrażenie może zawierać podstawowe obliczenia ('{q1_id} + {q2_id}'), wyrażenia logiczne ('{age} > 60') i funkcje ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' itp.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Wyzwala monit z prośbą o potwierdzenie usunięcia wiersza."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Duplikuje odpowiedzi z ostatniego wiersza i przypisuje je do następnego dodanego wiersza dynamicznego."
// pehelp.description: "Type a subtitle." => "Wpisz napisy."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Wybierz język, aby rozpocząć tworzenie ankiety. Aby dodać tłumaczenie, przełącz się na nowy język i przetłumacz oryginalny tekst tutaj lub na karcie Tłumaczenia."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Ustawia położenie sekcji szczegółów w odniesieniu do wiersza. Do wyboru: \"Brak\" - nie jest dodawane rozszerzenie; \"Pod wierszem\" - pod każdym rzędem macierzy umieszcza się rozwinięcie wiersza; \"Pod wierszem wyświetl tylko rozwinięcie jednego wiersza\" - rozwinięcie jest wyświetlane tylko pod jednym wierszem, pozostałe rozwinięcia wierszy są zwinięte."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Do wyboru: \"Brak\" - obraz zachowuje swój oryginalny rozmiar; \"Zawieraj\" - rozmiar obrazu jest zmieniany tak, aby pasował przy zachowaniu proporcji; \"Okładka\" - obraz wypełnia całe pole z zachowaniem proporcji; \"Wypełnij\" - obraz jest rozciągany w celu wypełnienia pola bez zachowania jego proporcji."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Stopniowo zwiększa wysokość pola wprowadzania danych podczas wprowadzania danych. Zastępuje ustawienie \"Wysokość pola wprowadzania (w wierszach)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Uchwyt zmiany rozmiaru pojawi się w rogu i można go przeciągnąć, aby zmienić rozmiar pola wejściowego."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Przedział czasu w sekundach, po przekroczeniu którego ankieta automatycznie przechodzi do strony z podziękowaniem."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Przedział czasu w sekundach, po którym ankieta automatycznie przechodzi do następnej strony."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Przedział czasu w sekundach, po którym ankieta automatycznie przechodzi do następnej strony."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa widoczność strony."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która wyłącza tryb tylko do odczytu dla strony."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która uniemożliwia przesłanie ankiety, chyba że co najmniej jedno zagnieżdżone pytanie ma odpowiedź."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Dotyczy wszystkich pytań na tej stronie. Jeśli chcesz zastąpić to ustawienie, zdefiniuj reguły wyrównania tytułów dla poszczególnych pytań lub paneli. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety (domyślnie \"Góra\")."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Ustawia lokalizację komunikatu o błędzie w odniesieniu do pytania z nieprawidłowymi danymi wejściowymi. Wybierz pomiędzy: \"Góra\" - tekst błędu jest umieszczany w górnej części pola pytania; \"Na dole\" — tekst błędu jest umieszczany u dołu pola pytania. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety (domyślnie \"Góra\")."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Zachowuje pierwotną kolejność pytań lub losuje je. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety (domyślnie \"Oryginalne\"). Efekt tego ustawienia jest widoczny tylko na karcie Podgląd."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Ustawia widoczność przycisków nawigacyjnych na stronie. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety, które domyślnie ma wartość \"Widoczny\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Ustawia widoczność i położenie czasomierza na stronie."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Do wyboru: \"Zablokowany\" - użytkownicy nie mogą rozwijać ani zwijać paneli; \"Zwiń wszystko\" - wszystkie panele rozpoczynają się w stanie zwiniętym; \"Rozwiń wszystko\" - wszystkie panele rozpoczynają się w stanie rozwiniętym; \"Pierwszy rozwinięty\" - początkowo rozwijany jest tylko pierwszy panel."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Wprowadź nazwę właściwości współużytkowanej w tablicy obiektów zawierających adresy URL obrazów lub plików wideo, które mają być wyświetlane na liście wyborów."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Lewa wartość służy jako identyfikator elementu używany w regułach warunkowych, prawa wartość jest wyświetlana respondentom."
// pehelp.title: "Type a user-friendly title to display." => "Wpisz przyjazny dla użytkownika tytuł do wyświetlenia."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Gwarantuje, że użytkownicy nie ukończą ankiety, dopóki pliki nie zostaną przekazane."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Akceptuje wartości CSS (px, %, in, pt itp.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Akceptuje wartości CSS (px, %, in, pt itp.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Akceptuje wartości CSS (px, %, in, pt itp.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "W pytaniach typu jednokrotnego i wielokrotnego wyboru każda opcja wyboru ma identyfikator i wartość wyświetlaną. Po wybraniu tej opcji w pytaniach HTML oraz dynamicznych tytułach i opisach elementów ankiety wyświetlana jest wartość wyświetlana zamiast wartości identyfikatora."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Wybierz, czy chcesz wyczyścić wartości pytań ukryte przez logikę warunkową i kiedy to zrobić. Opcja \"Dziedzicz\" stosuje ustawienie na poziomie ankiety (domyślnie \"Po zakończeniu ankiety\")."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Wybierz spośród: \"Wszystkie\" - kopiuje wszystkie opcje wyboru z wybranego pytania; \"Wybrane\" - dynamicznie kopiuje tylko wybrane opcje wyboru; \"Niewybrane\" - dynamicznie kopiuje tylko niezaznaczone opcje wyboru. Opcje \"Brak\" i \"Inne\" są domyślnie kopiowane, jeśli są włączone w pytaniu źródłowym."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Po wybraniu tej opcji użytkownicy mogą uwzględnić dodatkowe dane wejściowe w osobnym polu komentarza."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Wyświetla każdą opcję wyboru specjalnego (\"Brak\", \"Inne\", \"Zaznacz wszystko\") w nowym wierszu, nawet w przypadku korzystania z układu wielokolumnowego."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Określ lokalizację w zestawie danych usługi, w której znajduje się docelowa tablica obiektów. Pozostaw puste, jeśli adres URL wskazuje już tablicę."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Wprowadź jednolitą nazwę właściwości w tablicy obiektów, która zawiera wartości, które mają być wyświetlane na liście wyborów."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Zaznacz, aby zezwolić usłudze na zwrócenie pustej odpowiedzi lub tablicy."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Użyj ikony magicznej różdżki, aby ustawić regułę warunkową, która określa widoczność wszystkich opcji wyboru."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Lewa wartość służy jako identyfikator elementu używany w regułach warunkowych, prawa wartość jest wyświetlana respondentom."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" wybiera między trybami \"Przyciski\" i \"Rozwijane\" w zależności od dostępnej szerokości. Gdy szerokość jest niewystarczająca do wyświetlenia przycisków, w pytaniu zostanie wyświetlona lista rozwijana."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Umożliwia łączenie pytań, które dają wyniki w różnych formatach. Gdy takie pytania są połączone ze sobą za pomocą identyfikatora sprzężenia, ta właściwość współużytkowana przechowuje wybrane wartości pytań."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Wybierz, czy chcesz zaktualizować zawartość menu rozwijanego, aby pasowała do zapytania wyszukiwania wpisywanego przez użytkownika w polu wejściowym."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Wartość, którą należy zapisać w wynikach ankiety, gdy respondenci udzielą pozytywnej odpowiedzi."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Wartość, która ma zostać zapisana w wynikach ankiety, gdy respondenci udzielą odpowiedzi negatywnej."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Nie zaleca się wyłączania tej opcji, ponieważ zastępuje ona obraz podglądu i utrudnia użytkownikowi zrozumienie, czy pliki zostały przekazane."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Uruchamia monit z prośbą o potwierdzenie usunięcia pliku."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Włącz, aby uszeregować tylko wybrane wybory. Użytkownicy będą przeciągać wybrane elementy z listy wyboru, aby uporządkować je w obszarze rankingu."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Wprowadź listę opcji, które zostaną zasugerowane respondentowi podczas wprowadzania danych."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "To ustawienie zmienia tylko rozmiar pól wejściowych i nie wpływa na szerokość pola pytania."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Ustawia stałą szerokość dla wszystkich etykiet elementów w pikselach"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Opcja \"Auto\" automatycznie określa odpowiedni tryb wyświetlania - Obraz, Wideo lub YouTube - na podstawie podanego źródłowego adresu URL."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Służy jako substytut, gdy obraz nie może być wyświetlany na urządzeniu użytkownika oraz w celu ułatwienia dostępu."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Określa kolor wybranego emoji, gdy typ ikony oceny jest ustawiony na \"Emotikony\". Wybierz pomiędzy: \"Domyślny\" - wybrany emoji pojawia się w domyślnym kolorze ankiety; \"Skala\" - wybrany emoji dziedziczy kolor ze skali ocen."
// expression.name: "An expression ID that is not visible to respondents." => "Identyfikator wyrażenia, który nie jest widoczny dla respondentów."
// expression.description: "Type an expression subtitle." => "Wpisz podtytuł wyrażenia."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Wyrażenie może zawierać podstawowe obliczenia ('{q1_id} + {q2_id}'), warunki ('{wiek} > 60') i funkcje ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' itp.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Wybierz, aby zapisać wartość opcji \"Inne\" jako oddzielną właściwość w wynikach ankiety."
// p.swapOrder: "Swap the order of Yes and No" => "Zamień kolejność Tak i Nie"
// p.itemTitleWidth: "Item label width (in px)" => "Szerokość etykiety elementu (w pikselach)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Tekst pokazujący, czy wszystkie opcje są zaznaczone"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Tekst zastępczy dla obszaru klasyfikacji"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Wypełnij ankietę automatycznie"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Wybierz, jeśli chcesz, aby ankieta była wypełniana automatycznie po udzieleniu odpowiedzi respondenta na wszystkie pytania."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Zapisywanie zamaskowanej wartości w wynikach ankiety"
// patternmask.pattern: "Value pattern" => "Wzorzec wartości"
// datetimemask.min: "Minimum value" => "Wartość minimalna"
// datetimemask.max: "Maximum value" => "Wartość maksymalna"
// numericmask.allowNegativeValues: "Allow negative values" => "Zezwalaj na wartości ujemne"
// numericmask.thousandsSeparator: "Thousands separator" => "Separator tysięcy"
// numericmask.decimalSeparator: "Decimal separator" => "Separator dziesiętny"
// numericmask.precision: "Value precision" => "Precyzja wartości"
// numericmask.min: "Minimum value" => "Wartość minimalna"
// numericmask.max: "Maximum value" => "Wartość maksymalna"
// currencymask.prefix: "Currency prefix" => "Prefiks waluty"
// currencymask.suffix: "Currency suffix" => "Sufiks waluty"
// pe.maskType: "Input mask type" => "Typ maski wprowadzania"
// maskTypes.patternmask: "Pattern" => "Deseń"
// maskTypes.numericmask: "Numeric" => "Numeryczny"
// maskTypes.datetimemask: "Date and Time" => "Data i godzina"
// maskTypes.currencymask: "Currency" => "Waluta"
// tabs.mask: "Input Mask Settings" => "Ustawienia maski wprowadzania"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Np.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Np.: mm/dd/rrrr"
// pe.currencyprefix_placeholder: "Ex.: $" => "Przykład: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Np.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Opcje zawijania"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Długie teksty w opcjach wyboru automatycznie wygenerują podziały wierszy, aby zmieścić się w menu rozwijanym. Usuń zaznaczenie, jeśli chcesz, aby teksty zostały przycięte."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Wybierz, czy chcesz przechowywać wartość pytania z zastosowaną maską w wynikach ankiety."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Wzorzec może zawierać literały ciągu i następujące symbole zastępcze: \"9\" — dla cyfry; 'a' - dla wielkiej lub małej litery; '#' - dla cyfry lub wielkiej lub małej litery. Użyj ukośnika odwrotnego \"\\\", aby uciec od znaku."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Wzorzec może zawierać znaki separatora i następujące symbole zastępcze: \"m\" - dla numeru miesiąca; 'mm' - dla numeru miesiąca, z zerem wiodącym dla wartości jednocyfrowych; 'd' - dzień miesiąca; 'dd' - dla dnia miesiąca, z zerem wiodącym dla wartości jednocyfrowych; 'yy' - dla dwóch ostatnich cyfr roku; \"yyyy\" - dla roku czterocyfrowego."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Symbol używany do oddzielenia części ułamkowej od części całkowitej wyświetlanej liczby."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Symbol używany do rozdzielania cyfr dużej liczby na grupy po trzy."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Ogranicza liczbę cyfr, które mają być zachowywane po przecinku dziesiętnym wyświetlanej liczby."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Jeden lub kilka symboli, które mają być wyświetlane przed wartością."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Jeden lub kilka symboli, które mają być wyświetlane po wartości."
// ed.translationSource: "Source: " => "Źródło: "
// ed.translationTarget: "Target: " => "Cel: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Strona jest pusta. Przeciągnij element z przybornika lub kliknij przycisk poniżej."
// maskTypes.none: "None" => "Żaden"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Uwidocznij wiersz, jeśli"
// itemvalue@rows.enableIf: "Make the row editable if" => "Umożliwia edycję wiersza, jeśli"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Tekst zastępczy w trybie tylko do odczytu lub podglądu"
// pe.textWrapEnabled: "Wrap choices" => "Opcje zawijania"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Opcja \"Auto\" automatycznie określa odpowiedni tryb wyświetlania - Obraz, Wideo lub YouTube - na podstawie podanego źródłowego adresu URL."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Wybierz pomiędzy \"Obraz\" i \"Wideo\", aby ustawić tryb zawartości selektora multimediów. W przypadku wybrania opcji \"Obraz\" upewnij się, że wszystkie dostępne opcje są plikami graficznymi w następujących formatach: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Podobnie, jeśli wybrana jest opcja \"Wideo\", upewnij się, że wszystkie opcje są bezpośrednimi linkami do plików wideo w następujących formatach: MP4, MOV, WMV, FLV, AVI, MKV. Należy pamiętać, że linki do YouTube nie są obsługiwane w przypadku opcji wideo."
// ed.selectFile: "Select a file" => "Wybierz plik"
// ed.removeFile: "Remove the file" => "Usuń plik"
// pe.searchMode: "Search Mode" => "Tryb wyszukiwania"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Kliknij przycisk \"Dodaj pytanie\" poniżej, aby rozpocząć tworzenie formularza."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Kliknij przycisk \"Dodaj pytanie\" poniżej, aby dodać nowy element do strony."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Kliknij przycisk \"Dodaj pytanie\" poniżej, aby dodać nowy element do panelu."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Kliknij poniższy przycisk i wybierz obraz do przesłania"
// coloralpha.opacity: "Opacity" => "Nieprzezroczystość"
// font.family: "Font family" => "Rodzina czcionek"
// font.color: "Color" => "Kolor"
// font.placeholderColor: "Placeholder color" => "Kolor symbolu zastępczego"
// font.size: "Size" => "Rozmiar"
// theme.themeName: "Theme" => "Kompozycja"
// theme.isPanelless: "Question appearance" => "Wygląd pytania"
// theme.editorPanel: "Background and corner radius" => "Tło i promień narożnika"
// theme.questionPanel: "Background and corner radius" => "Tło i promień narożnika"
// theme.primaryColor: "Accent color" => "Kolor akcentujący"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Krycie tła panelu"
// theme.questionBackgroundTransparency: "Question background opacity" => "Nieprzezroczystość tła pytania"
// theme.fontSize: "Font size" => "Rozmiar czcionki"
// theme.scale: "Scale" => "Skala"
// theme.cornerRadius: "Corner radius" => "Promień naroża"
// theme.pageTitle: "Title font" => "Czcionka tytułu"
// theme.pageDescription: "Description font" => "Czcionka opisu"
// theme.questionTitle: "Title font" => "Czcionka tytułu"
// theme.questionDescription: "Description font" => "Czcionka opisu"
// theme.editorFont: "Font" => "Czcionka"
// theme.backgroundOpacity: "Opacity" => "Nieprzezroczystość"
// theme.--sjs-font-family: "Font family" => "Rodzina czcionek"
// theme.--sjs-general-backcolor-dim: "Background color" => "Kolor tła"
// theme.--sjs-primary-backcolor: "Accent background" => "Tło akcentu"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Akcent na pierwszym planie"
// theme.--sjs-shadow-small: "Shadow effects" => "Efekty cienia"
// theme.--sjs-shadow-inner: "Shadow effects" => "Efekty cienia"
// theme.--sjs-border-default: "Colors" => "Kolory"
// header@header.headerView: "View" => "Widok"
// header@header.logoPosition: "Logo position" => "Pozycja logo"
// header@header.surveyTitle: "Survey title font" => "Czcionka tytułu ankiety"
// header@header.surveyDescription: "Survey description font" => "Czcionka opisu ankiety"
// header@header.headerTitle: "Survey title font" => "Czcionka tytułu ankiety"
// header@header.headerDescription: "Survey description font" => "Czcionka opisu ankiety"
// header@header.inheritWidthFrom: "Content area width" => "Szerokość obszaru zawartości"
// header@header.textAreaWidth: "Text width" => "Szerokość tekstu"
// header@header.backgroundColorSwitch: "Background color" => "Kolor tła"
// header@header.backgroundImage: "Background image" => "Obraz w tle"
// header@header.backgroundImageOpacity: "Opacity" => "Nieprzezroczystość"
// header@header.overlapEnabled: "Overlap" => "Zachodzić na siebie"
// header@header.logoPositionX: "Logo position" => "Pozycja logo"
// header@header.titlePositionX: "Title position" => "Pozycja tytułu"
// header@header.descriptionPositionX: "Description position" => "Opis pozycja"
// weight.400: "Regular" => "Regularny"
// weight.600: "Heavy" => "Ciężki"
// weight.700: "Semi-bold" => "Półpogrubienie"
// weight.800: "Bold" => "Śmiały"
// backgroundImageFit.auto: "Auto" => "Automatycznie"
// backgroundImageFit.cover: "Cover" => "Pokryć"
// backgroundImageFit.contain: "Contain" => "Zawierać"
// backgroundImageFit.fill: "Stretch" => "Rozciągnąć"
// backgroundImageFit.tile: "Tile" => "Kafelek"
// backgroundImageAttachment.fixed: "Fixed" => "Stały"
// backgroundImageAttachment.scroll: "Scroll" => "Przewijać"
// headerView.basic: "Basic" => "Podstawowy"
// headerView.advanced: "Advanced" => "Zaawansowany"
// inheritWidthFrom.survey: "Same as survey" => "Tak samo jak ankieta"
// inheritWidthFrom.container: "Fit to container" => "Pasuje do pojemnika"
// backgroundColorSwitch.none: "None" => "Żaden"
// backgroundColorSwitch.accentColor: "Accent color" => "Kolor akcentujący"
// backgroundColorSwitch.custom: "Custom" => "Zwyczaj"
// colorPalette.light: "Light" => "Światło"
// colorPalette.dark: "Dark" => "Ciemny"
// isPanelless.false: "Default" => "Domyślny"
// isPanelless.true: "Without Panels" => "Bez paneli"
// theme.cornerRadius: "Corner radius" => "Promień naroża"
// theme.fontFamily: "Font family" => "Rodzina czcionek"
// theme.fontWeightRegular: "Regular" => "Regularny"
// theme.fontWeightHeavy: "Heavy" => "Ciężki"
// theme.fontWeightSemiBold: "Semi-bold" => "Półpogrubienie"
// theme.fontWeightBold: "Bold" => "Śmiały"
// theme.color: "Color" => "Kolor"
// theme.placeholderColor: "Placeholder color" => "Kolor symbolu zastępczego"
// theme.size: "Size" => "Rozmiar"
// theme.opacity: "Opacity" => "Nieprzezroczystość"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Wpisz, aby wyszukać..."
// ed.toolboxNoResultsFound: "No results found" => "Nie znaleziono wyników"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Symbol zastępczy tytułu tabulatora"
// theme.--sjs-special-red: "Error messages" => "Komunikaty o błędach"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Tekst zastępczy dla tytułów tabulatorów, który ma zastosowanie, gdy wzorzec tytułu tabulatora nie generuje znaczącej wartości."
// theme.fontColor: "Font color" => "Kolor czcionki"
// theme.backgroundColor: "Background color" => "Kolor tła"
// pe.questionTitleWidth: "Question title width" => "Szerokość tytułu pytania"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Wybierz plik lub wklej link do pliku..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Przykład: 200 pikseli"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Ustawia spójną szerokość tytułów pytań, gdy są one wyrównane do lewej strony pól pytań. Akceptuje wartości CSS (px, %, in, pt itp.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Ustawia spójną szerokość tytułów pytań, gdy są one wyrównane do lewej strony pól pytań. Akceptuje wartości CSS (px, %, in, pt itp.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Wysokość obszaru komentarza (w wierszach)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Ustawia liczbę wierszy wyświetlanych w obszarach tekstowych dla komentarzy do pytań. W danych wejściowych pojawia się więcej wierszy, pojawia się pasek przewijania."


/***/ }),

/***/ "./src/localization/portuguese.ts":
/*!****************************************!*\
  !*** ./src/localization/portuguese.ts ***!
  \****************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var portugueseTranslation = {
    // survey templates
    survey: {
        edit: "Editar",
        externalHelpLink: "Veja e aprenda a criar questionários",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Por favor arraste uma pergunta aqui.",
        addLogicItem: "Crie uma regra para configurar o fluxo do questionário.",
        copy: "Copiar",
        duplicate: "Duplicar",
        addToToolbox: "Adicionar às ferramentas",
        deletePanel: "Remover Painel",
        deleteQuestion: "Remover Pergunta",
        convertTo: "Converter para",
        drag: "Arrastar elemento",
    },
    // Creator tabs
    tabs: {
        preview: "Testar questionário",
        theme: "Temas",
        translation: "Tradução",
        designer: "Designer de Questionário",
        editor: "Editor de JSON",
        logic: "Lógica"
    },
    // Question types
    qt: {
        default: "Pré-definido",
        checkbox: "Caixas de Verificação",
        comment: "Comentário",
        imagepicker: "Selecionador de imagem",
        ranking: "Classificação",
        image: "Imagem",
        dropdown: "Lista",
        tagbox: "Tags",
        file: "Arquivo",
        html: "Html",
        matrix: "Matriz (opção única)",
        matrixdropdown: "Matriz (múltiplas opções)",
        matrixdynamic: "Matriz (linhas dinâmicas)",
        multipletext: "Texto múltiplo",
        panel: "Painel",
        paneldynamic: "Painel (painéis dinâmicos)",
        radiogroup: "Grupo de rádio",
        rating: "Avaliação",
        text: "Texto único",
        boolean: "Boleano",
        expression: "Expressão",
        signaturepad: "Caixa de Assinatura",
        buttongroup: "Grupo de Botões"
    },
    toolboxCategories: {
        general: "Geral",
        choice: "Questões de Escolha",
        text: "Questões de Texto",
        containers: "Áreas",
        matrix: "Questões em Matriz",
        misc: "Diversos"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Pré-definido ({0})",
        survey: "Pesquisa",
        settings: "Configurações da Pesquisa",
        settingsTooltip: "Configurações",
        surveySettings: "Configurações de Questionários",
        surveySettingsTooltip: "Configurações do questionário",
        themeSettings: "Configurações do tema",
        themeSettingsTooltip: "Configurações do tema",
        showPanel: "Mostrar Painel",
        hidePanel: "Esconder Painel",
        prevSelected: "Selecionar anterior",
        nextSelected: "Selecionar próximo",
        prevFocus: "Foco anterior",
        nextFocus: "Foco a seguir",
        surveyTypeName: "Questionário",
        pageTypeName: "Página",
        panelTypeName: "Painel",
        questionTypeName: "Questão",
        columnTypeName: "Coluna",
        addNewPage: "Adicionar Nova Página",
        moveRight: "Mover para direita",
        moveLeft: "Mover para esquerda",
        deletePage: "Remover Página",
        editPage: "Editar Página",
        edit: "Editar",
        newPageName: "página",
        newQuestionName: "pergunta",
        newPanelName: "painel",
        newTextItemName: "texto",
        defaultV2Theme: "Pré-definifido",
        modernTheme: "Moderno",
        defaultTheme: "Pré-definido (antigo)",
        testSurveyAgain: "Testar questionário novamente",
        testSurveyWidth: "Tamanho do questionário: ",
        navigateToMsg: "Tem que navegar para",
        saveSurvey: "Salvar Questionário",
        saveSurveyTooltip: "Gravar Questionário",
        saveTheme: "Salvar tema",
        saveThemeTooltip: "Salvar tema",
        jsonHideErrors: "Esconder erros",
        jsonShowErrors: "Mostrar erros",
        undo: "Desfazer",
        redo: "Refazer",
        undoTooltip: "Desfazer última alteração",
        redoTooltip: "Refazer a alteração",
        showMoreChoices: "Mostrar mais",
        showLessChoices: "Mostrar menos",
        copy: "Copiar",
        cut: "Cortar",
        paste: "Colar",
        copyTooltip: "Copiar seleção para a área de transferência",
        cutTooltip: "Cortar seleção para a área de transferência",
        pasteTooltip: "Colar da área de transferência",
        options: "Opções",
        generateValidJSON: "Gerar JSON válido",
        generateReadableJSON: "Gerar JSON legível",
        toolbox: "Ferramentas",
        "property-grid": "Propriedades",
        toolboxFilteredTextPlaceholder: "Digite para pesquisar...",
        toolboxNoResultsFound: "Nenhum resultado encontrado",
        propertyGridFilteredTextPlaceholder: "Escreva para pesquisar...",
        propertyGridNoResultsFound: "Nenhum resultado encontrado",
        correctJSON: "Por favor corrija o JSON.",
        surveyResults: "Resultado da pesquisa: ",
        surveyResultsTable: "Como Tabela",
        surveyResultsJson: "Como JSON",
        resultsTitle: "Título da Pergunta",
        resultsName: "Nome da Pergunta",
        resultsValue: "Valor da Resposta",
        resultsDisplayValue: "Mostrar Valor",
        modified: "Modificado",
        saving: "A gravar",
        saved: "Gravado",
        propertyEditorError: "Erro",
        saveError: "Erro! Conteúdo do editor não foi salvo.",
        translationPropertyGridTitle: "Configurações de Idioma",
        themePropertyGridTitle: "Configurações do tema",
        translationLanguages: "Idiomas",
        translationDeleteLanguage: "Tem certeza de que deseja excluir todas as cadeias de caracteres para este idioma?",
        translationAddLanguage: "Selecione o idioma para traduzir",
        translationShowAllStrings: "Mostrar todos os textos",
        translationShowUsedStringsOnly: "Apenas textos utilizados",
        translationShowAllPages: "Mostrar todas páginas",
        translationNoStrings: "Nenhum texto para traduzir. Por favor, altere o filtro.",
        translationExportToSCVButton: "Exportar para CSV",
        translationImportFromSCVButton: "Importar de CSV",
        translateUsigAI: "Tradução automática de todos",
        translateUsigAIFrom: "Traduzir do: ",
        translationDialogTitle: "Cadeias de caracteres não traduzidas",
        translationMergeLocaleWithDefault: "Combinar {0} com o idioma pré-definido",
        translationPlaceHolder: "Tradução...",
        translationSource: "Fonte: ",
        translationTarget: "Alvo: ",
        themeExportButton: "Exportação",
        themeImportButton: "Importação",
        surveyJsonExportButton: "Exportação",
        surveyJsonImportButton: "Importação",
        surveyJsonCopyButton: "Copiar para área de transferência",
        themeResetButton: "Redefinir as configurações do tema para o padrão",
        themeResetConfirmation: "Você realmente quer redefinir o tema? Todas as suas personalizações serão perdidas.",
        themeResetConfirmationOk: "Sim, redefinir o tema",
        bold: "Negrito",
        italic: "Itálico",
        underline: "Sublinhado",
        addNewQuestion: "Adicionar Questão",
        selectPage: "Selecionar página...",
        carryForwardChoicesCopied: "As opções são copiadas de",
        choicesLoadedFromWebText: "As opções são carregadas a partir de um serviço Web.",
        choicesLoadedFromWebLinkText: "Ir para configurações",
        choicesLoadedFromWebPreviewTitle: "Pré-visualização das opções de escolha carregadas",
        htmlPlaceHolder: "O conteúdo HTML ficará aqui.",
        panelPlaceHolder: "Arraste uma questão da caixa de ferramentas aqui.",
        surveyPlaceHolder: "O questionário está vazio. Arraste um elemento da caixa de ferramentas ou clique no botão abaixo.",
        pagePlaceHolder: "A página está vazia. Arraste um elemento da caixa de ferramentas ou clique no botão abaixo.",
        imagePlaceHolder: "Arraste e solte uma imagem aqui ou clique no botão abaixo e escolha uma imagem para carregar",
        surveyPlaceHolderMobile: "Clique no botão \"Adicionar pergunta\" abaixo para começar a criar seu formulário.",
        pagePlaceHolderMobile: "Clique no botão \"Adicionar pergunta\" abaixo para adicionar um novo elemento à página.",
        panelPlaceHolderMobile: "Clique no botão \"Adicionar pergunta\" abaixo para adicionar um novo elemento ao painel.",
        imagePlaceHolderMobile: "Clique no botão abaixo e escolha uma imagem para carregar",
        imageChooseImage: "Escolha a imagem",
        addNewTypeQuestion: "Adicionar {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Item ",
        selectFile: "Selecione um arquivo",
        removeFile: "Remover o arquivo",
        lg: {
            addNewItem: "Adicionar nova regra",
            empty_tab: "Crie uma regra para personalizar o fluxo do questionário.",
            page_visibilityName: "Mostrar (esconder) página",
            page_enableName: "Ativar (desativar) página",
            page_requireName: "Tornar a página obrigatória",
            panel_visibilityName: "Mostrar (esconder) painel",
            panel_enableName: "Ativar (desativar) painel",
            panel_requireName: "Tornar a página obrigatória",
            question_visibilityName: "Mostrar (esconder) questão",
            question_enableName: "Ativar (desativar) questão",
            question_requireName: "Tornar a pergunta obrigatória",
            question_resetValueName: "Redefinir o valor da pergunta",
            question_setValueName: "Definir o valor da pergunta",
            column_visibilityName: "Mostrar (esconder) coluna",
            column_enableName: "Ativar (desativar) coluna",
            column_requireName: "Tornar a coluna obrigatória",
            column_resetValueName: "Redefinir o valor da coluna",
            column_setValueName: "Definir valor de coluna",
            trigger_completeName: "Completar questionário",
            trigger_setvalueName: "Definir resposta",
            trigger_copyvalueName: "Copiar resposta",
            trigger_skipName: "Pular para a pergunta",
            trigger_runExpressionName: "Executar expressão",
            completedHtmlOnConditionName: "Definir marcação de página de \"Questionário Completo\"",
            page_visibilityDescription: "Torne a página visível quando a expressão lógica estiver ativa. Caso contrário, mantenha-o invisível.",
            panel_visibilityDescription: "Torne o painel visível quando a expressão lógica estiver ativa. Caso contrário, mantenha-o invisível.",
            panel_enableDescription: "Faça com que o painel e todos os elementos dentro dele sejam ativos quando a expressão lógica estiver ativa. Caso contrário, mantenha-o invisível.",
            question_visibilityDescription: "Torne a pergunta visível quando a expressão lógica estiver ativa. Caso contrário, mantenha-a invisível.",
            question_enableDescription: "Ative a pergunta quando a expressão lógica estiver ativa. Caso contrário, mantenha-a invisível.",
            question_requireDescription: "A pergunta torna-se obrigatória quando a expressão lógica estiver ativa.",
            trigger_completeDescription: "Quando a expressão lógica estiver ativa, a pesquisa será concluída e o utilizador verá a 'Página de Agradecimento'.",
            trigger_setvalueDescription: "Quando os valores da pergunta, que são usados na expressão lógica, são alterados e a expressão lógica fica ativa, então o valor é definido para a pergunta seleccionada.",
            trigger_copyvalueDescription: "Quando os valores das perguntas, que são usados na expressão lógica, são alterados e a expressão lógica fica ativa, então o valor de uma pergunta seleccionada é copiado para outra pergunta seleccionada.",
            trigger_skipDescription: "Quando a expressão lógica volta a ser ativa, então o questionário salta para / focaliza a pergunta seleccionada.",
            trigger_runExpressionDescription: "Quando a expressão lógica volta a ser ativaa, a expressão personalizada é executada. Opcionalmente, pode definir o resultado desta expressão para a pergunta seleccionada",
            completedHtmlOnConditionDescription: "Se a expressão lógica estiver ativa, então o texto padrão para a 'Página de agradecimento' é alterado para a dada.",
            itemExpressionText: "Quando a expressão: '{0}' volta a ficar ativa",
            itemEmptyExpressionText: "Nova regra",
            page_visibilityText: "tornar a página {0} visível",
            panel_visibilityText: "tornar painel {0} visível",
            panel_enableText: "tornar painel {0} ativa",
            question_visibilityText: "torna questão {0} visível",
            question_enableText: "tornar questão {0} ativa",
            question_requireText: "tornar questão {0} obrigatória",
            question_resetValueText: "redefinir valor da pergunta: {0}",
            question_setValueText: "atribuir valor: {1} à pergunta: {0}",
            column_visibilityText: "tornar coluna {0} da questão {1} visível",
            column_enableText: "tornar coluna {0} da questão {1} ativa",
            column_requireText: "torna coluna {0} da questão {1} obrigatória",
            column_resetValueText: "Redefinir o valor da célula para a coluna: {0}",
            column_setValueText: "Atribuir valor de célula: {1} à coluna: {0}",
            setValueExpressionPlaceholder: " Uma expressão cujo resultado será atribuído à pergunta de destino.",
            trigger_completeText: "o questionário fica completo",
            trigger_setvalueText: "Colocar em questão: {0} valor {1}",
            trigger_setvalueEmptyText: "valor claro da pergunta: {0}",
            trigger_copyvalueText: "Copiar a questão: {0} valor da questão {1}",
            trigger_skipText: "pular para a questão do questionário {0}",
            trigger_runExpressionText1: "executar expressão: '{0}'",
            trigger_runExpressionText2: " e colocar seu resultado em questão: {0}",
            completedHtmlOnConditionText: "mostrar texto costumizado para a 'página de agradecimento'.",
            showAllQuestions: "Todas as Questões",
            showAllActionTypes: "Todos os Tipos de Questões",
            conditions: "Condição(ões)",
            actions: "Ação(ões)",
            expressionEditorTitle: "Definir condição(ões)",
            actionsEditorTitle: "Definir ação(ões)",
            deleteAction: "Eliminar Ação",
            addNewAction: "Adicionar Ação",
            selectedActionCaption: "Selecionar Ação...",
            expressionInvalid: "A expressão lógica está vazia ou é inválida. Por favor corrija.",
            noActionError: "Por favor, adicione pelo menos uma ação.",
            actionInvalid: "Por favor, corrija os problemas nas sua(s) ação(ões).",
            uncompletedRule_title: "As regras lógicas estão incompletas",
            uncompletedRule_text: "Você não concluiu algumas das regras lógicas. Se você sair da guia agora, as alterações serão perdidas. Você ainda deseja sair da guia sem concluir as alterações?",
            uncompletedRule_apply: "Sim",
            uncompletedRule_cancel: "Não, quero completar as regras"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Nome do painel",
            title: "Título do painel",
            description: "Descrição do painel",
            visibleIf: "Tornar o painel visível se",
            requiredIf: "Tornar o painel obrigatório se",
            questionsOrder: "Ordem das perguntas no painel",
            page: "Página principal",
            startWithNewLine: "Exibir o painel em uma nova linha",
            state: "Estado de recolhimento do painel",
            width: "Largura do painel embutido",
            minWidth: "Largura mínima do painel",
            maxWidth: "Largura máxima do painel",
            showNumber: "Painéis numéricos"
        },
        paneldynamic: {
            name: "Nome do painel",
            title: "Título do painel",
            description: "Descrição do painel",
            visibleIf: "Tornar o painel visível se",
            requiredIf: "Tornar o painel obrigatório se",
            page: "Mover o painel para a página",
            startWithNewLine: "Exibir o painel em uma nova linha",
            state: "Estado de recolhimento do painel",
            width: "Largura do painel embutido",
            minWidth: "Largura mínima do painel",
            maxWidth: "Largura máxima do painel",
            confirmDelete: "Confirme a eliminação do painel",
            templateDescription: "Padrão de descrição do painel",
            templateTitle: "Padrão de título do painel",
            noEntriesText: "Texto vazio do painel",
            templateTabTitle: "Padrão de título de guia",
            tabTitlePlaceholder: "Espaço reservado para título da guia",
            templateVisibleIf: "Tornar um painel individual visível se",
            hideNumber: "Ocultar o número do painel",
            titleLocation: "Alinhamento do título do painel",
            descriptionLocation: "Alinhamento da descrição do painel",
            templateTitleLocation: "Alinhamento do título da pergunta",
            templateErrorLocation: "Alinhamento da mensagem de erro",
            newPanelPosition: "Nova localização do painel",
            keyName: "Evite respostas duplicadas na seguinte pergunta"
        },
        question: {
            name: "Nome da pergunta",
            title: "Título da pergunta",
            description: "Descrição da pergunta",
            visibleIf: "Torne a pergunta visível se",
            requiredIf: "Faça a pergunta obrigatória se",
            page: "Página principal",
            state: "Estado de recolhimento da caixa de pergunta",
            hideNumber: "Ocultar o número da pergunta",
            titleLocation: "Alinhamento do título da pergunta",
            descriptionLocation: "Alinhamento da descrição da pergunta",
            errorLocation: "Alinhamento da mensagem de erro",
            indent: "Aumentar o recuo interno",
            width: "Largura da pergunta embutida",
            minWidth: "Largura mínima da pergunta",
            maxWidth: "Largura máxima da pergunta",
            textUpdateMode: "Atualizar valor do campo de entrada"
        },
        signaturepad: {
            signatureWidth: "Largura da área de assinatura",
            signatureHeight: "Altura da área de assinatura",
            signatureAutoScaleEnabled: "Dimensionar automaticamente a área de assinatura",
            showPlaceholder: "Mostrar o espaço reservado",
            placeholder: "Texto de espaço reservado",
            placeholderReadOnly: "Texto de espaço reservado no modo somente leitura ou de visualização",
            allowClear: "Mostrar o botão Limpar na área de assinatura",
            penMinWidth: "Largura mínima da caneta",
            penMaxWidth: "Largura máxima da caneta",
            penColor: "Cor do traçado"
        },
        comment: {
            rows: "Altura do campo de entrada (em linhas)"
        },
        showQuestionNumbers: "Mostrar número das perguntas",
        questionStartIndex: "Index das perguntas (1, 2 or 'A', 'a')",
        expression: {
            name: "Nome da expressão",
            title: "Título da expressão",
            description: "Descrição da expressão",
            expression: "Expressão"
        },
        trigger: {
            expression: "Expressão"
        },
        calculatedvalue: {
            expression: "Expressão"
        },
        // survey templates
        survey: {
            title: "Título",
            description: "Descrição da pesquisa"
        },
        page: {
            name: "Nome da página",
            title: "Título",
            description: "Descrição da página",
            visibleIf: "Tornar a página visível se",
            requiredIf: "Tornar a página obrigatória se",
            maxTimeToFinish: "Tempo limite para finalizar esta página (em segundos)",
            questionsOrder: "Ordem das perguntas na página"
        },
        matrixdropdowncolumn: {
            name: "Nome da coluna",
            title: "Título da coluna",
            isUnique: "Impedir respostas duplicadas",
            width: "Largura da coluna",
            minWidth: "Largura mínima da coluna",
            rows: "Altura do campo de entrada (em linhas)",
            visibleIf: "Tornar a coluna visível se",
            requiredIf: "Tornar a coluna obrigatória se",
            showInMultipleColumns: "Cada opção em uma coluna separada"
        },
        multipletextitem: {
            name: "Nome",
            title: "Título"
        },
        masksettings: {
            saveMaskedValue: "Salvar valor mascarado nos resultados da pesquisa"
        },
        patternmask: {
            pattern: "Padrão de valor"
        },
        datetimemask: {
            min: "Valor mínimo",
            max: "Valor máximo"
        },
        numericmask: {
            allowNegativeValues: "Permitir valores negativos",
            thousandsSeparator: "Separador de milhares",
            decimalSeparator: "Separador decimal",
            precision: "Precisão de valor",
            min: "Valor mínimo",
            max: "Valor máximo"
        },
        currencymask: {
            prefix: "Prefixo da moeda",
            suffix: "Sufixo de moeda"
        },
        imageHeight: "Altura da imagem",
        imageWidth: "Largura da imagem",
        valueName: "Nome do valor",
        rateDescriptionLocation: "Alinhamento de rótulos",
        size: "Tamanho de entrada (em caracteres)",
        cellErrorLocation: "Alinhamento da mensagem de erro da célula",
        apply: "Aplicar",
        ok: "OK",
        save: "Guardar",
        clear: "Limpar",
        saveTooltip: "Guardar",
        cancel: "Cancelar",
        set: "Definir",
        reset: "Limpar",
        change: "Modificar",
        refresh: "Recarregar",
        close: "Fechar",
        delete: "Apagar",
        add: "Adicionar",
        addNew: "Adicionar Novo",
        addItem: "Clique para adicionar o item...",
        removeItem: "Clique para remover o item...",
        dragItem: "Arraste o item",
        addOther: "Outro",
        addSelectAll: "Selecionar Todos",
        addNone: "Nenhum",
        removeAll: "Remover Todos",
        edit: "Editar",
        back: "Retornar sem guardar",
        backTooltip: "Sair sem guardar",
        saveAndBack: "Sair e retornar",
        saveAndBackTooltip: "Guardar e retornar",
        doneEditing: "Terminar",
        editChoices: "Editar Opções",
        showChoices: "Mostrar Opções",
        move: "Mover",
        empty: "<vazio>",
        emptyValue: "Valor vazio",
        fastEntry: "Entrada Rápida",
        fastEntryNonUniqueError: "Valor '{0}' não é o único",
        fastEntryChoicesCountError: "Limite o número de itens de {0} a {1}",
        fastEntryChoicesMinCountError: "Por favor, insira pelo menos {0} itens",
        fastEntryPlaceholder: "Pode definir dados no seguinte formato:\nvalor1|texto\nvalor2",
        formEntry: "Entrada com formulário",
        testService: "Testar o serviço",
        itemSelectorEmpty: "Selecione o elemento",
        conditionActionEmpty: "Selecione a ação",
        conditionSelectQuestion: "Selecionar pergunta...",
        conditionSelectPage: "Selecione a página...",
        conditionSelectPanel: "Selecione o painel...",
        conditionValueQuestionTitle: "Por favor, entre/selecione o valor",
        aceEditorHelp: "Pressione ctrl+space para autocompletar",
        aceEditorRowTitle: "Linha atual",
        aceEditorPanelTitle: "Painel atual",
        showMore: "Para mais detalhes, por favor visite a documentação",
        assistantTitle: "Perguntas disponíveis:",
        cellsEmptyRowsColumns: "Deve haver ao menos uma coluna ou linha",
        showPreviewBeforeComplete: "Visualize as respostas antes de submeter o questionário",
        overridingPropertyPrefix: "Definido por ",
        resetToDefaultCaption: "Repor",
        propertyIsEmpty: "Por favor informe um valor na propriedade",
        propertyIsNoUnique: "Insira um valor exclusivo.",
        propertyNameIsNotUnique: "Insira um nome único",
        propertyNameIsIncorrect: "Não use palavras reservadas: \"item\", \"escolha\", \"painel\", \"linha\".",
        listIsEmpty: "Nenhum item foi adicionado ainda",
        "listIsEmpty@choices": "Nenhuma opção foi adicionada ainda",
        "listIsEmpty@columns": "Você ainda não tem nenhuma coluna",
        "listIsEmpty@rows": "Você ainda não tem nenhuma linha",
        "listIsEmpty@validators": "Você ainda não tem nenhuma regra de validação",
        "listIsEmpty@calculatedValues": "Você ainda não tem nenhuma variável personalizada",
        "listIsEmpty@triggers": "Você ainda não tem nenhum gatilho",
        "listIsEmpty@navigateToUrlOnCondition": "Você ainda não tem nenhum link",
        "addNew@choices": "Adicionar uma opção",
        "addNew@columns": "Adicionar nova coluna",
        "addNew@rows": "Adicionar nova linha",
        "addNew@validators": "Adicionar nova regra",
        "addNew@calculatedValues": "Adicionar nova variável",
        "addNew@triggers": "Adicionar novo gatilho",
        "addNew@navigateToUrlOnCondition": "Adicionar novo URL",
        expressionIsEmpty: "Expressão está vazia",
        value: "Valor",
        text: "Texto",
        rowid: "ID da Linha",
        imageLink: "Link da Imagem",
        columnEdit: "Editar coluna: {0}",
        itemEdit: "Editar item: {0}",
        url: "URL",
        path: "Caminho",
        choicesbyurl: {
            url: "URL do serviço Web",
            valueName: "Obtenha valores do seguinte campo JSON"
        },
        titleName: "Nome do título",
        imageLinkName: "Obtenha URLs de imagem do seguinte campo JSON",
        allowEmptyResponse: "Permitir resposta vazia",
        titlePlaceholder: "Título",
        surveyTitlePlaceholder: "Título do Questionário",
        pageTitlePlaceholder: "Página {num}",
        descriptionPlaceholder: "Descrição",
        surveyDescriptionPlaceholder: "Descrição",
        pageDescriptionPlaceholder: "Descrição",
        textWrapEnabled: "Opções de encapsulamento",
        showOtherItem: "Tem item 'outros'",
        otherText: "Texto do item 'outros'",
        showNoneItem: "Permitir a opção Nenhum",
        showRefuseItem: "Permitir a opção Recusar resposta",
        showDontKnowItem: "Permitir a opção Não Sei",
        noneText: "texto de opção Nenhum",
        showSelectAllItem: "Permitir a opção Selecionar tudo",
        selectAllText: "texto de opção Selecionar Todos",
        choicesMin: "Valor mínimo para itens gerados automaticamente",
        choicesMax: "Valor máximo para itens gerados automaticamente",
        choicesStep: "Etapa para itens gerados automaticamente",
        name: "Nome",
        title: "Título",
        cellType: "Tipo de célula",
        colCount: "Contagem de células",
        choicesOrder: "Selecione a ordem das alternativas",
        visible: "É visível?",
        isRequired: "É obrigatório?",
        markRequired: "Marcar conforme necessário",
        removeRequiredMark: "Remover a marca necessária",
        isAllRowRequired: "Exigir resposta para todas as linhas",
        eachRowUnique: "Impedir respostas duplicadas em linhas",
        requiredErrorText: "\"Obrigatório\" mensagem de erro",
        startWithNewLine: "Começa com uma nova linha?",
        rows: "Contagem de linhas",
        cols: "Colunas",
        placeholder: "Texto de referência",
        showPreview: "Mostra pré-visualização de imagem?",
        storeDataAsText: "Gravar conteúdo de arquivo no resultado JSON como texto",
        maxSize: "Tamanho máximo de arquivo em bytes",
        rowCount: "Contagem de linhas",
        columnLayout: "Layout das colunas",
        addRowLocation: "Localização do botão de adicionar linha",
        transposeData: "Transpor linhas para colunas",
        addRowText: "Texto do botão para adicionar linhas",
        removeRowText: "Texto do botão para remover linhas",
        rateMin: "Valor mínimo do valor",
        rateMax: "Valor máximo do valor",
        rateStep: "Etapa de taxa",
        minRateDescription: "Descrição de qualificação mínima",
        maxRateDescription: "Descrição de qualificação máxima",
        inputType: "Tipo de entrada",
        optionsCaption: "Título de opção",
        defaultValue: "Valor pré-definido",
        cellsDefaultRow: "Texto pré-definido das células",
        surveyEditorTitle: "Editar configurações da pesquisa",
        qEditorTitle: "Editar pergunta: {0}",
        maxLength: "Tamanho máximo",
        buildExpression: "Construir",
        editExpression: "Editar",
        and: "e",
        or: "ou",
        remove: "Remover",
        addCondition: "Adicionar Condição",
        emptyLogicPopupMessage: "Selecione uma pergunta para começar a configurar as condições.",
        if: "Se",
        then: "em seguida",
        setToName: "Questão alvo",
        fromName: "Questão para copiar a resposta de",
        gotoName: "Questão para pular para",
        ruleIsNotSet: "Regra está incorreta",
        includeIntoResult: "Incluir nos resultados da pesquisa",
        showTitle: "Mostrar/ocultar título",
        expandCollapseTitle: "Expandir/contrair título",
        locale: "Idioma pré-definido",
        simulator: "Selecione o tipo de dispositivo",
        landscapeOrientation: "Alternar para orientação paisagem",
        portraitOrientation: "Altrar para orientação de moldura",
        mode: "Modo (editável/somente leitura)",
        clearInvisibleValues: "Limpar valores invisíveis",
        cookieName: "Nome do cookie (para desativar rode a pesquisa duas vezes localmente)",
        sendResultOnPageNext: "Enviar resultado da pesquisa na página seguinte",
        storeOthersAsComment: "Armazenar 'outros' valores em um campo separado",
        showPageTitles: "Mostrar título da página",
        showPageNumbers: "Mostrar número da página",
        pagePrevText: "Texto para botão de página anterior",
        pageNextText: "Texto para botão de página seguinte",
        completeText: "Texto para botão de completar",
        previewText: "Pré-visualizar o texto do botão Responder",
        editText: "Editar o texto do botão Responder Answer button text",
        startSurveyText: "Texto para botão de começar",
        showNavigationButtons: "Mostrar botões de navegação (navegação default)",
        showPrevButton: "Mostrar botão de voltar (usuário pode retornar para página anterior)",
        firstPageIsStarted: "Primeira página da pesquisa é a página de início.",
        showCompletedPage: "Mostrar a página de conclusão no final (completedHtml)",
        goNextPageAutomatic: "Ao responder todas as perguntas, ir automaticamente para a próxima página",
        allowCompleteSurveyAutomatic: "Preencha o questionário automaticamente",
        showProgressBar: "Mostrar barra de progresso",
        questionTitleLocation: "Localização do título da pergunta",
        questionTitleWidth: "Largura do título da pergunta",
        requiredText: "Símbolo(s) para perguntas obrigatórias",
        questionTitleTemplate: "Template do título da pergunta, default é: '{no}. {obrigatório} {título}'",
        questionErrorLocation: "Localização do erro da pergunta",
        focusFirstQuestionAutomatic: "Focar automaticamente na primeira pergunta ao trocar de página",
        questionsOrder: "Ordenar elementos na página",
        maxTimeToFinish: "Tempo máximo para finalizar pesquisa",
        maxTimeToFinishPage: "Tempo máximo para finalizar página da pesquisa",
        showTimerPanel: "Mostrar o painel de cronômetro",
        showTimerPanelMode: "Mostrar painel de modo de cronômetro",
        renderMode: "Modo de renderização",
        allowAddPanel: "Permitir adicionar painel",
        allowRemovePanel: "Permitir remover painel",
        panelAddText: "Texto de adicionar painel",
        panelRemoveText: "Texto de remover painel",
        isSinglePage: "Mostrar todos elementos em uma página",
        html: "HTML markup",
        setValue: "Responder",
        dataFormat: "Formato de imagem",
        allowAddRows: "Permitir adicionar linhas",
        allowRemoveRows: "Permitir remover linhas",
        allowRowsDragAndDrop: "Permitir arrastar e soltar linha",
        responsiveImageSizeHelp: "Não se aplica se especificar a largura ou altura exata da imagem.",
        minImageWidth: "Largura mínima da imagem",
        maxImageWidth: "Largura máxima da imagem",
        minImageHeight: "Altura mínima da imagem",
        maxImageHeight: "Altura máxima da imagem",
        minValue: "Valor mínimo",
        maxValue: "Valor máximo.",
        minLength: "Comprimento mínimo (em caracteres)",
        allowDigits: "Permitir dígitos",
        minCount: "Contagem mínima",
        maxCount: "Contagem máxima",
        regex: "Expressão regular",
        surveyvalidator: {
            text: "Mensagem de erro",
            expression: "Expressão de validação"
        },
        totalText: "Texto total da linha",
        totalType: "Tipo total",
        totalExpression: "Expressão total",
        totalDisplayStyle: "Total value display style",
        totalCurrency: "Moeda",
        totalFormat: "String formatada",
        logo: "Logo (URL ou string codificada em base64)",
        questionsOnPageMode: "Estrutura de questionário",
        maxTextLength: "Tamanho máximo da resposta (em caracteres)",
        maxOthersLength: "Tamanho máximo do comentário (em caracteres)",
        commentAreaRows: "Altura da área de comentário (em linhas)",
        autoGrowComment: "Expanda automaticamente a área de comentários, se necessário",
        allowResizeComment: "Permitir que os usuários redimensionem áreas de texto",
        textUpdateMode: "Atualizar valor da pergunta de texto",
        maskType: "Tipo de máscara de entrada",
        maskTypes: {
            none: "Nenhum",
            patternmask: "Padrão",
            numericmask: "Numérico",
            datetimemask: "Data e Hora",
            currencymask: "Moeda"
        },
        focusOnFirstError: "Defina o foco na primeira resposta inválida",
        checkErrorsMode: "Executar validação",
        navigateToUrl: "Navegar para URL",
        navigateToUrlOnCondition: "URL Dinamico",
        completedBeforeHtml: "Marcação para mostrar se o utilizador já preencheu este questionário",
        completedHtml: "Marcação de página completa do questionário",
        completedHtmlOnCondition: "Marcação de página completa de questionário dinâmico",
        loadingHtml: "Marcação para mostrar enquanto o modelo de questionário está carregando",
        commentText: "Texto da área de comentários",
        autocomplete: "Tipo de preenchimento automático",
        labelTrue: "\"Verdadeiro\" rótulo",
        labelFalse: "\"Falso\" rótulo",
        allowClear: "Mostrar o botão Limpar",
        searchMode: "Modo de pesquisa",
        displayStyle: "Estilo de exibição de valor",
        format: "String formatada",
        maximumFractionDigits: "Máximo de dígitos fracionários",
        minimumFractionDigits: "Mínimo de dígitos fracionários",
        useGrouping: "Display grouping separators",
        allowMultiple: "Permitir vários arquivos",
        allowImagesPreview: "Pré-visualizar imagens",
        acceptedTypes: "Tipos de arquivo aceites",
        waitForUpload: "Aguarde a conclusão do upload",
        needConfirmRemoveFile: "Confirme a eliminação do ficheiro",
        detailPanelMode: "Localização do painel de detalhes",
        minRowCount: "Contagem mínima de linhas",
        maxRowCount: "Contagem máxima de linhas",
        confirmDelete: "Confirme a eliminação da linha",
        confirmDeleteText: "Mensagem de confirmação",
        panelCount: "Contagem inicial do painel",
        minPanelCount: "Contagem mínima de painéis",
        maxPanelCount: "Contagem máxima de painéis",
        panelsState: "Estado de expansão do painel interno",
        panelPrevText: "Dica de ferramenta do botão do painel anterior",
        panelNextText: "Dica de ferramenta do botão do painel seguinte",
        showRangeInProgress: "MOstrar barra de progresso",
        panelRemoveButtonLocation: "Remover localização do botão do painel",
        hideIfRowsEmpty: "Oculte a pergunta se não houver linhas",
        hideColumnsIfEmpty: "Ocultar colunas se não houver linhas",
        rateValues: "Valores de taxa personalizados",
        rateCount: "Contagem de taxas",
        autoGenerate: "Como especificar valores de taxa?",
        hideIfChoicesEmpty: "Oculte a pergunta se ela não contiver opções",
        minWidth: "Largura mínima (em valores aceitos pelo CSS)",
        maxWidth: "Largura máxima (em valores aceitos pelo CSS)",
        width: "Largura (em valores aceitos pelo CSS)",
        showHeader: "Mostrar cabeçalhos de coluna",
        horizontalScroll: "Mostrar barra de scroll horizontal",
        columnMinWidth: "Largura mínima da coluna (em valores aceitos pelo CSS)",
        rowTitleWidth: "Largura do cabeçalho da linha (em valores aceitos por CSS)",
        valueTrue: "\"Verdadeiro\" valor",
        valueFalse: "\"Falso\" valor",
        minErrorText: "\"O valor está abaixo do mínimo\" mensagem de erro",
        maxErrorText: "\"O valor excede o máximo\" mensagem de erro",
        otherErrorText: "\"Comentário vazio\" mensagem de erro",
        keyDuplicationError: "\"Valor de chave não exclusivo\" mensagem de erro",
        minSelectedChoices: "Mínimo de opções selecionadas",
        maxSelectedChoices: "Máximo de escolhas selecionadas",
        showClearButton: "Mostrar o botão Limpar",
        logoWidth: "Largura do logotipo (em valores aceitos pelo CSS)",
        logoHeight: "Altura do logotipo (em valores aceitos pelo CSS)",
        readOnly: "Apenas para leitura",
        enableIf: "Editável se",
        emptyRowsText: "\"Sem linhas\" mensagem",
        separateSpecialChoices: "Escolhas especiais separadas (Nenhuma, Outra, Selecionar Tudo)",
        choicesFromQuestion: "Copie as opções da seguinte pergunta",
        choicesFromQuestionMode: "Quais as opções pretendem copiar?",
        progressBarShowPageTitles: "Exibir títulos de página na barra de progresso",
        progressBarShowPageNumbers: "Exibir números de página na barra de progresso",
        showCommentArea: "Mostrar a área de comentários",
        commentPlaceholder: "Espaço reservado para área de comentários",
        displayRateDescriptionsAsExtremeItems: "Exibir descrições de taxa como valores extremos",
        rowsOrder: "Ordem das linhas",
        columnsLayout: "Disposição da coluna",
        columnColCount: "Contagem de colunas aninhadas",
        correctAnswer: "Resposta correta",
        defaultPanelValue: "Valores pré-definidos",
        cells: "Textos de Célula",
        fileInputPlaceholder: "Selecione um arquivo ou cole um link de arquivo...",
        keyName: "Coluna chave",
        itemvalue: {
            visibleIf: "Torne a opção visível se",
            enableIf: "Torne a opção selecionável se"
        },
        "itemvalue@rows": {
            visibleIf: "Tornar a linha visível se",
            enableIf: "Tornar a linha editável se"
        },
        imageitemvalue: {
            text: "Texto alternativo"
        },
        logoPosition: "Posição do logo",
        addLogo: "Adicionar logo...",
        changeLogo: "Alterae logo...",
        logoPositions: {
            none: "Remover logo",
            left: "Esquerda",
            right: "Direita",
            top: "No cabeçalho",
            bottom: "No rodapé"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Layout do painel"
            },
            general: "Geral",
            fileOptions: "Opções",
            html: "Editor Html",
            columns: "Colunas",
            rows: "Linhas",
            choices: "Opções",
            items: "Itens",
            visibleIf: "Visível se",
            enableIf: "Habilitar se",
            requiredIf: "Obrigatório se",
            rateValues: "Valores de qualificação",
            choicesByUrl: "Opções com origem na Web",
            matrixChoices: "Opções padrão",
            multipleTextItems: "Entradas de texto",
            numbering: "Numeração",
            validators: "Validadores",
            navigation: "Navegação",
            question: "Pergunta",
            pages: "Páginas",
            timer: "Cronômetro/Quiz",
            calculatedValues: "Valores Calculados",
            triggers: "Triggers",
            templateTitle: "Título do template",
            totals: "Totais",
            logic: "Lógica",
            mask: "Configurações da máscara de entrada",
            layout: {
                panel: "Layout",
                question: "Layout",
                base: "Layout"
            },
            data: "Data",
            validation: "Validação",
            cells: "Texto de Células",
            showOnCompleted: "Questionário Completo",
            logo: "Logo no Título de Questionário",
            slider: "Slider",
            expression: "Expressão",
            questionSettings: "Configurações da pergunta",
            header: "Cabeçalho",
            background: "Fundo",
            appearance: "Aparência",
            others: "Outros"
        },
        editProperty: "Editar propriedade '{0}'",
        items: "Itens",
        choicesVisibleIf: "Escolhas estão visiveis se",
        choicesEnableIf: "Escolhas são selecionáveis se",
        columnsEnableIf: "Colunas estão visiveis se",
        rowsEnableIf: "Linhas estão visiveis se",
        innerIndent: "Adicionar recuos internos",
        defaultValueFromLastRow: "Utilizar os valores padrão da última linha",
        defaultValueFromLastPanel: "Utilizar os valores padrão do último painel",
        enterNewValue: "Por favor, informe o valor.",
        noquestions: "Não há nenhuma pergunta na pesquisa.",
        createtrigger: "Por favor, crie uma condição",
        titleKeyboardAdornerTip: "Pressione o botão enter para editar",
        keyboardAdornerTip: "Pressione o botão enter para editar o item, pressione o botão delete para excluir o item, pressione alt mais a seta para cima ou a seta para baixo para mover o item",
        triggerOn: "Ligado ",
        triggerMakePagesVisible: "Tornar páginas visíveis:",
        triggerMakeQuestionsVisible: "Tornar perguntas visíves:",
        triggerCompleteText: "Completar a pesquisa se obtiver êxito.",
        triggerNotSet: "A condição não está definida",
        triggerRunIf: "Executar se",
        triggerSetToName: "Mudar o valor de: ",
        triggerFromName: "Copiar valor de: ",
        triggerRunExpression: "Rodar essa expressão:",
        triggerSetValue: "para: ",
        triggerGotoName: "Ir para a questão",
        triggerIsVariable: "Não colocar a variável no resultado da pesquisa.",
        triggerRunExpressionEmpty: "Introdução uma expressão valida",
        emptyExpressionPlaceHolder: "Escreva a expressão aqui...",
        noFile: "Nenhum ficheiro selecionado",
        clearIfInvisible: "Limpe o valor se a questão for escondida",
        valuePropertyName: "Nome da propriedade do valor",
        searchEnabled: "Ativar pesquisa",
        hideSelectedItems: "Escolher os itens selecionados",
        closeOnSelect: "Fechar a lista suspensa após a seleção",
        verticalAlign: "Alinhamento vertical",
        alternateRows: "Linhas alternativas",
        columnsVisibleIf: "Colunas estão visíveis se",
        rowsVisibleIf: "As linhas são visíveis se",
        otherPlaceholder: "Espaço reservado para área de comentários",
        filePlaceholder: "Texto do espaço reservado para arquivo",
        photoPlaceholder: "Texto do espaço reservado para foto",
        fileOrPhotoPlaceholder: "Texto de espaço reservado para arquivo ou foto",
        rateType: "Tipo de tarifa",
        url_placeholder: "Ex.: https://api.example.com/books",
        path_placeholder: "Ex.: categorias.ficção",
        questionStartIndex_placeholder: "Ex.: a)",
        width_placeholder: "Ex.: 6in",
        minWidth_placeholder: "Ex.: 600px",
        maxWidth_placeholder: "Ex.: 50%",
        imageHeight_placeholder: "auto",
        imageWidth_placeholder: "auto",
        theme: {
            themeName: "Tema",
            isPanelless: "Aparência da pergunta",
            editorPanel: "Fundo e raio de canto",
            questionPanel: "Fundo e raio de canto",
            primaryColor: "Cor de destaque",
            panelBackgroundTransparency: "Opacidade do plano de fundo do painel",
            questionBackgroundTransparency: "Opacidade de fundo da pergunta",
            fontSize: "Tamanho da fonte",
            scale: "Escala",
            cornerRadius: "Raio de canto",
            pageTitle: "Fonte do título",
            pageDescription: "Fonte de descrição",
            questionTitle: "Fonte do título",
            questionDescription: "Fonte de descrição",
            editorFont: "Fonte",
            backgroundOpacity: "Opacidade",
            "--sjs-font-family": "Família de fontes",
            "--sjs-general-backcolor-dim": "Cor de fundo",
            "--sjs-primary-backcolor": "Fundo de destaque",
            "--sjs-primary-forecolor": "Destaque em primeiro plano",
            "--sjs-special-red": "Mensagens de erro",
            "--sjs-shadow-small": "Efeitos de sombra",
            "--sjs-shadow-inner": "Efeitos de sombra",
            "--sjs-border-default": "Cores"
        },
        "header@header": {
            headerView: "Vista",
            logoPosition: "Posição do logotipo",
            surveyTitle: "Fonte do título do questionário",
            surveyDescription: "Fonte da descrição da pesquisa",
            headerTitle: "Fonte do título do questionário",
            headerDescription: "Fonte da descrição da pesquisa",
            inheritWidthFrom: "Largura da área de conteúdo",
            textAreaWidth: "Largura do texto",
            backgroundColorSwitch: "Cor de fundo",
            backgroundImage: "Imagem de fundo",
            backgroundImageOpacity: "Opacidade",
            overlapEnabled: "Sobrepor",
            logoPositionX: "Posição do logotipo",
            titlePositionX: "Posição do título",
            descriptionPositionX: "Descrição da posição"
        }
    },
    // Property values
    pv: {
        "true": "verdadeiro",
        "false": "falso",
        file: "Arquivos locais",
        camera: "Câmera",
        "file-camera": "Arquivos locais ou câmera",
        inherit: "herdar",
        show: "mostrar",
        hide: "ocultar",
        default: "padrão",
        initial: "inicial",
        random: "aleatório",
        collapsed: "colapsado",
        expanded: "expandido",
        none: "nenhum",
        asc: "ascendente",
        desc: "descendente",
        indeterminate: "indeterminado",
        selected: "Selecionado",
        unselected: "Desmarcado",
        decimal: "decimal",
        currency: "moeda",
        percent: "percentagem",
        firstExpanded: "primeiro expandido",
        off: "desligado",
        list: "lista",
        progressTop: "progresso superior",
        progressBottom: "progresso inferior",
        progressTopBottom: "progresso superior inferior",
        tab: "Guias",
        horizontal: "horizontal",
        vertical: "vertical",
        top: "superior",
        bottom: "inferior",
        topBottom: "superior and bottom",
        both: "Ambos",
        left: "esquerda",
        right: "direita",
        center: "Centro",
        leftRight: "Esquerda e direita",
        middle: "Meio",
        color: "cor",
        date: "data",
        datetime: "data hora",
        "datetime-local": "data hora-local",
        email: "e-mail",
        month: "mês",
        number: "número",
        password: "password",
        range: "intervalo",
        tel: "tel",
        text: "texto",
        time: "tempo",
        url: "url",
        week: "semana",
        hidden: "oculto",
        edit: "editar",
        display: "mostrar",
        contain: "Conter",
        cover: "Cobrir",
        fill: "Encher",
        next: "Próximo",
        last: "Último",
        onComplete: "ao completar",
        onHidden: "ao ocultar",
        onHiddenContainer: "Quando a pergunta ou seu painel/página fica oculto",
        clearInvisibleValues: {
            none: "Nunca"
        },
        clearIfInvisible: {
            none: "Nunca"
        },
        inputType: {
            color: "Cor",
            date: "Data",
            "datetime-local": "Data e Hora",
            email: "Email",
            month: "Mês",
            number: "Número",
            password: "Senha",
            range: "Gama",
            tel: "Número de telefone",
            text: "Texto",
            time: "Hora",
            url: "URL",
            week: "Semana"
        },
        all: "todos",
        page: "página",
        survey: "pesquisa",
        onNextPage: "na página seguinte",
        onValueChanged: "ao mudar valor",
        onValueChanging: "Antes de uma resposta ser alterada",
        questionsOnPageMode: {
            standard: "Estrutura original",
            singlePage: "Mostrar todas as perguntas em uma página",
            questionPerPage: "Mostrar uma única pergunta por página"
        },
        noPreview: "Sem pré-visualização",
        showAllQuestions: "Mostrar todas as questões",
        showAnsweredQuestions: "Mostrar apenas perguntas respondidas",
        pages: "Páginas completas",
        questions: "Questões respondidas",
        requiredQuestions: "Perguntas obrigatórias respondidas",
        correctQuestions: "Respostas válidas",
        buttons: "Páginas concluídas (interface do botão)",
        underInput: "Sob a entrada",
        underTitle: "Sob o título",
        onBlur: "Em desfoque",
        onTyping: "Enquanto digita",
        underRow: "Sob a linha",
        underRowSingle: "Sob a linha, apenas um painel é visível",
        auto: "Automático",
        showNavigationButtons: {
            none: "Escondido"
        },
        showTimerPanel: {
            none: "Escondido"
        },
        showTimerPanelMode: {
            all: "Ambos"
        },
        addRowLocation: {
            default: "Depende do layout da matriz"
        },
        panelsState: {
            default: "Os utilizadores não podem expandir ou recolher painéis",
            collapsed: "Todos os painéis estão recolhidos",
            expanded: "Todos os painéis estão espandidos",
            firstExpanded: "Primeiro expandido"
        },
        widthMode: {
            static: "Estático",
            responsive: "Responsivo"
        },
        contentMode: {
            image: "Imagem",
            video: "Video",
            youtube: "YouTube"
        },
        displayMode: {
            buttons: "Botões",
            dropdown: "Suspenso"
        },
        rateColorMode: {
            default: "Inadimplência",
            scale: "Escala"
        },
        scaleColorMode: {
            monochrome: "Monocromático",
            colored: "Colorido"
        },
        autoGenerate: {
            "true": "Gerar",
            "false": "Digite manualmente"
        },
        rateType: {
            labels: "Rótulos",
            stars: "Estrelas",
            smileys: "Smileys"
        },
        state: {
            default: "Trancado"
        },
        showQuestionNumbers: {
            default: "Numeração automática",
            on: "Numeração automática",
            onPage: "Redefinir em cada página",
            onpanel: "Redefinir em cada painel",
            onPanel: "Redefinir em cada painel",
            onSurvey: "Continue na pesquisa",
            off: "Sem numeração"
        },
        descriptionLocation: {
            underTitle: "Sob o título da pergunta",
            underInput: "No campo de entrada"
        },
        selectToRankAreasLayout: {
            horizontal: "Ao lado das opções",
            vertical: "Acima das escolhas"
        },
        displayStyle: {
            decimal: "Decimal",
            currency: "Moeda",
            percent: "Porcentagem",
            date: "Data"
        },
        totalDisplayStyle: {
            decimal: "Decimal",
            currency: "Moeda",
            percent: "Porcentagem",
            date: "Data"
        },
        rowsOrder: {
            initial: "Original"
        },
        questionsOrder: {
            initial: "Original"
        },
        showProgressBar: {
            off: "Escondido",
            topbottom: "superior and bottom",
            aboveheader: "Acima do cabeçalho",
            belowheader: "Abaixo do cabeçalho"
        },
        sum: "Soma",
        count: "Contar",
        min: "Min",
        max: "Max",
        avg: "Avg",
        searchMode: {
            contains: "Contém",
            startsWith: "Começa com"
        },
        backgroundImageFit: {
            auto: "Automático",
            cover: "Cobrir",
            contain: "Conter",
            fill: "Esticar",
            tile: "Telha"
        },
        backgroundImageAttachment: {
            fixed: "Fixo",
            scroll: "Rolar"
        },
        headerView: {
            basic: "Básico",
            advanced: "Avançado"
        },
        inheritWidthFrom: {
            survey: "O mesmo que pesquisa",
            container: "Ajuste ao contêiner"
        },
        backgroundColorSwitch: {
            none: "Nenhum",
            accentColor: "Cor de destaque",
            custom: "Costume"
        },
        colorPalette: {
            light: "Luz",
            dark: "Escuro"
        },
        isPanelless: {
            "false": "Inadimplência",
            "true": "Sem Painéis"
        }
    },
    // Operators
    op: {
        empty: "está vazio",
        notempty: "não está vazio",
        equal: "é igual",
        notequal: "não é igual",
        contains: "contém",
        notcontains: "não contém",
        anyof: "Nenhum de",
        allof: "Todos de",
        greater: "maior",
        less: "menor",
        greaterorequal: "maior ou igual",
        lessorequal: "menor ou igual",
        and: "e",
        or: "ou"
    },
    // Embed window
    ew: {
        angular: "Usar versão Angular",
        jquery: "Usar versão jQuery",
        knockout: "Usar versão Knockout",
        react: "Usar versão React",
        vue: "Usar versão Vue",
        bootstrap: "Para framework bootstrap",
        modern: "Tema moderno",
        default: "Tema pré-definido",
        orange: "Tema laranja",
        darkblue: "Tema azul escuro",
        darkrose: "Tema rosa escuro",
        stone: "Tema pedra",
        winter: "Tema inverno",
        winterstone: "Tema inverno-pedra",
        showOnPage: "Mostrar pesquisa em uma página",
        showInWindow: "Mostrar pesquisa em uma janela",
        loadFromServer: "Carregar JSON da pesquisa de um servidor",
        titleScript: "Scripts e estilos",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Selecione a página para testar:",
        showInvisibleElements: "Mostrar elementos invisíveis",
        hideInvisibleElements: "Esconder elementos invisíveis"
    },
    validators: {
        answercountvalidator: "contador de respostas",
        emailvalidator: "e-mail",
        expressionvalidator: "expressão",
        numericvalidator: "numérico",
        regexvalidator: "regex",
        textvalidator: "texto"
    },
    triggers: {
        completetrigger: "completar pesquisa",
        setvaluetrigger: "definir valor",
        copyvaluetrigger: "copiar valor",
        skiptrigger: "Saltar para questão",
        runexpressiontrigger: "rodar expressão",
        visibletrigger: "alterar visibilidade"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Ex.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Ex.: dd/mm/aaaa"
        },
        currencymask: {
            prefix: "Ex.: $",
            suffix: "Ex.: USD"
        },
        panelbase: {
            questionTitleWidth: "Ex.: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "Um ID de painel que não está visível para os respondentes.",
            description: "Digite uma legenda do painel.",
            visibleIf: "Use o ícone de varinha mágica para definir uma regra condicional que determine a visibilidade do painel.",
            enableIf: "Use o ícone de varinha mágica para definir uma regra condicional que desabilite o modo somente leitura para o painel.",
            requiredIf: "Use o ícone de varinha mágica para definir uma regra condicional que impeça o envio de questionários, a menos que pelo menos uma pergunta aninhada tenha uma resposta.",
            questionTitleLocation: "Aplica-se a todas as perguntas deste painel. Se você quiser substituir essa configuração, defina regras de alinhamento de título para perguntas individuais. A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa (\"Superior\" por padrão).",
            questionTitleWidth: "Define largura consistente para títulos de perguntas quando eles estão alinhados à esquerda de suas caixas de perguntas. Aceita valores CSS (px, %, in, pt, etc.).",
            questionErrorLocation: "Define o local de uma mensagem de erro em relação a todas as perguntas no painel. A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa.",
            questionsOrder: "Mantém a ordem original das perguntas ou as randomiza. A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa.",
            page: "Reposiciona o painel no final de uma página selecionada.",
            innerIndent: "Adiciona espaço ou margem entre o conteúdo do painel e a borda esquerda da caixa do painel.",
            startWithNewLine: "Desmarque para exibir o painel em uma linha com a pergunta ou painel anterior. A configuração não se aplica se o painel for o primeiro elemento do formulário.",
            state: "Escolha entre: \"Expandido\" - o painel é exibido na íntegra e pode ser recolhido; \"Recolhido\" - o painel exibe apenas o título e a descrição e pode ser expandido; \"Bloqueado\" - o painel é exibido na íntegra e não pode ser recolhido.",
            width: "Define a largura do painel proporcionalmente a outros elementos de pesquisa na mesma linha. Aceita valores CSS (px, %, in, pt, etc.)."
        },
        paneldynamic: {
            name: "Um ID de painel que não está visível para os respondentes.",
            description: "Digite uma legenda do painel.",
            visibleIf: "Use o ícone de varinha mágica para definir uma regra condicional que determine a visibilidade do painel.",
            enableIf: "Use o ícone de varinha mágica para definir uma regra condicional que desabilite o modo somente leitura para o painel.",
            requiredIf: "Use o ícone de varinha mágica para definir uma regra condicional que impeça o envio de questionários, a menos que pelo menos uma pergunta aninhada tenha uma resposta.",
            templateTitleLocation: "Aplica-se a todas as perguntas deste painel. Se você quiser substituir essa configuração, defina regras de alinhamento de título para perguntas individuais. A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa (\"Superior\" por padrão).",
            templateErrorLocation: "Define o local de uma mensagem de erro em relação a uma pergunta com entrada inválida. Escolha entre: \"Top\" - um texto de erro é colocado na parte superior da caixa de perguntas; \"Inferior\" - um texto de erro é colocado na parte inferior da caixa de perguntas. A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa (\"Superior\" por padrão).",
            errorLocation: "Define o local de uma mensagem de erro em relação a todas as perguntas no painel. A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa.",
            page: "Reposiciona o painel no final de uma página selecionada.",
            innerIndent: "Adiciona espaço ou margem entre o conteúdo do painel e a borda esquerda da caixa do painel.",
            startWithNewLine: "Desmarque para exibir o painel em uma linha com a pergunta ou painel anterior. A configuração não se aplica se o painel for o primeiro elemento do formulário.",
            state: "Escolha entre: \"Expandido\" - o painel é exibido na íntegra e pode ser recolhido; \"Recolhido\" - o painel exibe apenas o título e a descrição e pode ser expandido; \"Bloqueado\" - o painel é exibido na íntegra e não pode ser recolhido.",
            width: "Define a largura do painel proporcionalmente a outros elementos de pesquisa na mesma linha. Aceita valores CSS (px, %, in, pt, etc.).",
            templateTitle: "Digite um modelo para títulos de painel dinâmico. Use {panelIndex} para a posição geral do painel e {visiblePanelIndex} para sua ordem entre os painéis visíveis. Insira esses espaços reservados no padrão para adicionar numeração automática.",
            templateTabTitle: "Digite um modelo para títulos de guias. Use {panelIndex} para a posição geral de um painel e {visiblePanelIndex} para sua ordem entre os painéis visíveis. Insira esses espaços reservados no padrão para adicionar numeração automática.",
            tabTitlePlaceholder: "Um texto de fallback para títulos de guia que se aplica quando o padrão de título de guia não produz um valor significativo.",
            templateVisibleIf: "Essa configuração permite controlar a visibilidade de painéis individuais dentro do painel dinâmico. Use o espaço reservado '{panel}' para fazer referência ao painel atual em sua expressão.",
            titleLocation: "Essa configuração é herdada automaticamente por todas as perguntas dentro deste painel. Se você quiser substituir essa configuração, defina regras de alinhamento de título para perguntas individuais. A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa (\"Superior\" por padrão).",
            descriptionLocation: "A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa (\"Sob o título do painel\" por padrão).",
            newPanelPosition: "Define a posição de um painel recém-adicionado. Por padrão, novos painéis são adicionados ao final. Selecione \"Next\" para inserir um novo painel após o atual.",
            defaultValueFromLastPanel: "Duplica as respostas do último painel e as atribui ao próximo painel dinâmico adicionado.",
            keyName: "Faça referência a um nome de pergunta para exigir que um usuário forneça uma resposta exclusiva para essa pergunta em cada painel."
        },
        defaultValueExpression: "Essa configuração permite atribuir um valor de resposta padrão com base em uma expressão. A expressão pode incluir cálculos básicos - '{q1_id} + {q2_id}', expressões booleanas, como '{age} > 60', e funções: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. O valor determinado por essa expressão serve como o valor padrão inicial que pode ser substituído pela entrada manual de um respondente.",
        resetValueIf: "Use o ícone de varinha mágica para definir uma regra condicional que determina quando a entrada de um respondente é redefinida para o valor com base no valor \"Expressão de valor padrão\" ou \"Definir expressão de valor\" ou no valor \"Resposta padrão\" (se um dos dois estiver definido).",
        setValueIf: "Use o ícone de varinha mágica para definir uma regra condicional que determine quando executar a expressão \"Definir valor\" e atribuir dinamicamente o valor resultante como resposta.",
        setValueExpression: "Especifique uma expressão que defina o valor a ser definido quando as condições na regra \"Definir valor se\" forem atendidas. A expressão pode incluir cálculos básicos - '{q1_id} + {q2_id}', expressões booleanas, como '{age} > 60', e funções: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. O valor determinado por essa expressão pode ser substituído pela entrada manual de um respondente.",
        question: {
            name: "Um ID de pergunta que não é visível para os respondentes.",
            description: "Digite um subtítulo de pergunta.",
            visibleIf: "Use o ícone de varinha mágica para definir uma regra condicional que determina a visibilidade da pergunta.",
            enableIf: "Use o ícone de varinha mágica para definir uma regra condicional que desabilita o modo somente leitura para a pergunta.",
            requiredIf: "Use o ícone de varinha mágica para definir uma regra condicional que impeça o avanço ou o envio da pesquisa, a menos que a pergunta receba uma resposta.",
            startWithNewLine: "Desmarque para exibir a pergunta em uma linha com a pergunta ou painel anterior. A configuração não se aplica se a pergunta for o primeiro elemento do formulário.",
            page: "Reposiciona a pergunta no final de uma página selecionada.",
            state: "Escolha entre: \"Expandido\" - a caixa de perguntas é exibida na íntegra e pode ser recolhida; \"Recolhido\" - a caixa de perguntas exibe apenas o título e a descrição e pode ser expandida; \"Bloqueado\" - a caixa de perguntas é exibida na íntegra e não pode ser recolhida.",
            titleLocation: "Substitui as regras de alinhamento de título definidas em um painel, página ou nível de pesquisa. A opção \"Herdar\" aplica quaisquer configurações de nível superior (se definidas) ou configurações de nível de pesquisa (\"Superior\" por padrão).",
            descriptionLocation: "A opção \"Herdar\" aplica a configuração de nível de pesquisa (\"Sob o título da pergunta\" por padrão).",
            errorLocation: "Define o local de uma mensagem de erro em relação à pergunta com entrada inválida. Escolha entre: \"Top\" - um texto de erro é colocado na parte superior da caixa de perguntas; \"Inferior\" - um texto de erro é colocado na parte inferior da caixa de perguntas. A opção \"Herdar\" aplica a configuração de nível de pesquisa (\"Superior\" por padrão).",
            indent: "Adiciona espaço ou margem entre o conteúdo da pergunta e a borda esquerda da caixa de perguntas.",
            width: "Define a largura da pergunta proporcionalmente a outros elementos do questionário na mesma linha. Aceita valores CSS (px, %, in, pt, etc.).",
            surveyvalidator: {
                expression: "Use o ícone de varinha mágica para definir uma regra de validação para a pergunta."
            },
            textUpdateMode: "Escolha entre: \"Em foco perdido\" - o valor é atualizado quando o campo de entrada perde o foco; \"Ao digitar\" - o valor é atualizado em tempo real, à medida que os usuários digitam. A opção \"Herdar\" aplica a configuração de nível de pesquisa (\"Em foco perdido\" por padrão).",
            url: "Você pode usar qualquer serviço Web como uma fonte de dados para perguntas de múltipla escolha. Para preencher valores de escolha, insira a URL do serviço que fornece os dados.",
            searchMode: "Uma operação de comparação usada para filtrar a lista suspensa.",
            textWrapEnabled: "Textos longos nas opções de escolha gerarão automaticamente quebras de linha para caber no menu suspenso. Desmarque se quiser que os textos sejam recortados."
        },
        signaturepad: {
            signatureWidth: "Define a largura da área de assinatura exibida e a imagem resultante.",
            signatureHeight: "Define a altura da área de assinatura exibida e a imagem resultante.",
            signatureAutoScaleEnabled: "Selecione se deseja que a área de assinatura preencha todo o espaço disponível na caixa de pergunta, mantendo a proporção padrão de 3:2. Quando os valores personalizados de largura e altura são definidos, a configuração manterá a proporção dessas dimensões."
        },
        file: {
            imageHeight: "Ajusta a altura da imagem nos resultados da pesquisa.",
            imageWidth: "Ajusta a largura da imagem nos resultados da pesquisa."
        },
        image: {
            contentMode: "A opção \"Auto\" determina automaticamente o modo adequado para exibição - Imagem, Vídeo ou YouTube - com base no URL de origem fornecido."
        },
        imagepicker: {
            imageHeight: "Substitui os valores de altura mínima e máxima.",
            imageWidth: "Substitui os valores de largura mínima e máxima.",
            choices: "\"Valor\" serve como um ID de item usado em regras condicionais; \"Texto\" é exibido aos respondentes.",
            contentMode: "Escolha entre \"Imagem\" e \"Vídeo\" para definir o modo de conteúdo do seletor de mídia. Se \"Imagem\" estiver selecionado, certifique-se de que todas as opções fornecidas são arquivos de imagem nos seguintes formatos: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Da mesma forma, se \"Vídeo\" estiver selecionado, certifique-se de que todas as opções sejam links diretos para arquivos de vídeo nos seguintes formatos: MP4, MOV, WMV, FLV, AVI, MKV. Observe que os links do YouTube não são compatíveis com as opções de vídeo."
        },
        text: {
            size: "Essa configuração redimensiona apenas o campo de entrada e não afeta a largura da caixa de pergunta. Para limitar o comprimento de entrada aceito, vá para <b>Validação → Limite máximo de caracteres</b>."
        },
        comment: {
            rows: "Define o número de linhas exibidas no campo de entrada. Se a entrada ocupar mais linhas, a barra de rolagem aparecerá."
        },
        // survey templates
        survey: {
            mode: "Escolha entre: \"Editável\" - permite que os respondentes preencham seu questionário; \"Somente leitura\" - desabilita a edição de formulários."
        },
        matrixdropdowncolumn: {
            name: "Um ID de coluna que não está visível para os respondentes.",
            isUnique: "Quando habilitado para uma coluna, um respondente é obrigado a fornecer uma resposta exclusiva para cada pergunta dentro desta coluna.",
            rows: "Define o número de linhas exibidas no campo de entrada. Se a entrada ocupar mais linhas, a barra de rolagem aparecerá.",
            visibleIf: "Use o ícone de varinha mágica para definir uma regra condicional que determina a visibilidade da coluna.",
            enableIf: "Use o ícone de varinha mágica para definir uma regra condicional que desabilita o modo somente leitura para a coluna.",
            requiredIf: "Use o ícone de varinha mágica para definir uma regra condicional que impeça o envio de questionários, a menos que pelo menos uma pergunta aninhada tenha uma resposta.",
            showInMultipleColumns: "Quando selecionada, cria uma coluna individual para cada opção de escolha."
        },
        widthMode: "Escolha entre: \"Estático\" - define uma largura fixa; \"Responsivo\" - faz com que a pesquisa ocupe toda a largura da tela; \"Auto\" - aplica-se a qualquer um dos dois, dependendo dos tipos de pergunta usados.",
        cookieName: "Os cookies impedem que os usuários preencham a mesma pesquisa duas vezes.",
        logo: "Cole um link de imagem (sem limites de tamanho) ou clique no ícone de pasta para procurar um arquivo do seu computador (até 64 KB).",
        logoWidth: "Define a largura de um logotipo em unidades CSS (px, %, in, pt, etc.).",
        logoHeight: "Define a altura do logotipo em unidades CSS (px, %, in, pt, etc.).",
        logoFit: "Escolha entre: \"Nenhum\" - a imagem mantém seu tamanho original; \"Conter\" - a imagem é redimensionada para se ajustar, mantendo sua proporção; \"Capa\" - a imagem preenche toda a caixa, mantendo sua proporção; \"Preencher\" - a imagem é esticada para preencher a caixa sem manter sua proporção.",
        goNextPageAutomatic: "Selecione se você deseja que o questionário avance para a próxima página automaticamente depois que um respondente responder a todas as perguntas na página atual.",
        allowCompleteSurveyAutomatic: "Selecione se você deseja que o questionário seja concluído automaticamente depois que um respondente responder a todas as perguntas.",
        showNavigationButtons: "Define a visibilidade e a localização dos botões de navegação em uma página.",
        showProgressBar: "Define a visibilidade e o local de uma barra de progresso. O valor \"Auto\" exibe a barra de progresso acima ou abaixo do cabeçalho do questionário.",
        showPreviewBeforeComplete: "Habilite a página de visualização apenas com todas as perguntas ou com as respostas respondidas.",
        questionTitleLocation: "Aplica-se a todas as perguntas do questionário. Essa configuração pode ser substituída por regras de alinhamento de título em níveis inferiores: painel, página ou pergunta. Uma configuração de nível inferior substituirá as de nível superior.",
        requiredText: "Um símbolo ou uma sequência de símbolos indicando que uma resposta é necessária.",
        questionStartIndex: "Introduza um número ou letra com o qual pretende iniciar a numeração.",
        questionErrorLocation: "Define o local de uma mensagem de erro em relação à pergunta com entrada inválida. Escolha entre: \"Top\" - um texto de erro é colocado na parte superior da caixa de perguntas; \"Inferior\" - um texto de erro é colocado na parte inferior da caixa de perguntas.",
        focusFirstQuestionAutomatic: "Selecione se deseja que o primeiro campo de entrada em cada página esteja pronto para entrada de texto.",
        questionsOrder: "Mantém a ordem original das perguntas ou as randomiza. O efeito dessa configuração só é visível na guia Visualização.",
        maxTextLength: "Apenas para perguntas de entrada de texto.",
        maxOthersLength: "Apenas para comentários de perguntas.",
        commentAreaRows: "Define o número de linhas exibidas em áreas de texto para comentários de perguntas. Na entrada ocupa mais linhas, a barra de rolagem aparece.",
        autoGrowComment: "Selecione se você deseja que os comentários de perguntas e as perguntas de texto longo aumentem automaticamente em altura com base no comprimento do texto inserido.",
        allowResizeComment: "Apenas para comentários de perguntas e perguntas de texto longo.",
        calculatedValues: "As variáveis personalizadas servem como variáveis intermediárias ou auxiliares usadas em cálculos de formulário. Eles tomam as entradas dos respondentes como valores de origem. Cada variável personalizada tem um nome exclusivo e uma expressão na qual se baseia.",
        includeIntoResult: "Selecione se deseja que o valor calculado da expressão seja salvo junto com os resultados do questionário.",
        triggers: "Um gatilho é um evento ou condição baseado em uma expressão. Uma vez que a expressão é avaliada como \"verdadeira\", um gatilho desencadeia uma ação. Tal ação pode, opcionalmente, ter uma questão-alvo que afeta.",
        clearInvisibleValues: "Escolha se deseja ou não limpar valores para perguntas ocultas pela lógica condicional e quando fazê-lo.",
        textUpdateMode: "Escolha entre: \"Em foco perdido\" - o valor é atualizado quando o campo de entrada perde o foco; \"Ao digitar\" - o valor é atualizado em tempo real, à medida que os usuários digitam.",
        columns: "O valor esquerdo serve como um ID de coluna usado em regras condicionais, o valor direito é exibido aos respondentes.",
        rows: "O valor esquerdo serve como um ID de linha usado em regras condicionais, o valor direito é exibido aos respondentes.",
        columnMinWidth: "Aceita valores CSS (px, %, in, pt, etc.).",
        rowTitleWidth: "Aceita valores CSS (px, %, in, pt, etc.).",
        totalText: "Visível apenas quando pelo menos uma coluna tiver tipo total ou expressão total.",
        cellErrorLocation: "Define o local de uma mensagem de erro em relação a uma célula com entrada inválida. A opção \"Herdar\" aplica a configuração da propriedade \"Alinhamento da mensagem de erro\".",
        keyDuplicationError: "Quando a propriedade \"Impedir respostas duplicadas\" está habilitada, um respondente tentando enviar uma entrada duplicada receberá a seguinte mensagem de erro.",
        totalExpression: "Permite calcular valores totais com base em uma expressão. A expressão pode incluir cálculos básicos ('{q1_id} + {q2_id}'), expressões booleanas ('{age} > 60') e funções ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.).",
        confirmDelete: "Aciona um prompt pedindo para confirmar a exclusão da linha.",
        defaultValueFromLastRow: "Duplica as respostas da última linha e as atribui à próxima linha dinâmica adicionada.",
        keyName: "Se a coluna especifica contiver valores idênticos, o questionário lançará o \"Valor de chave não exclusivo\" erro.",
        description: "Digite uma legenda.",
        locale: "Escolha um idioma para começar a criar seu questionário. Para adicionar uma tradução, alterne para um novo idioma e traduza o texto original aqui ou na guia Traduções.",
        detailPanelMode: "Define o local de uma seção de detalhes em relação a uma linha. Escolha entre: \"Nenhum\" - nenhuma expansão é adicionada; \"Sob a linha\" - uma expansão de linha é colocada sob cada linha da matriz; \"Sob a linha, exibir apenas uma expansão de linha\" - uma expansão é exibida em uma única linha apenas, as expansões de linha restantes são recolhidas.",
        imageFit: "Escolha entre: \"Nenhum\" - a imagem mantém seu tamanho original; \"Conter\" - a imagem é redimensionada para se ajustar, mantendo sua proporção; \"Capa\" - a imagem preenche toda a caixa, mantendo sua proporção; \"Preencher\" - a imagem é esticada para preencher a caixa sem manter sua proporção.",
        autoGrow: "Aumenta gradualmente a altura do campo de entrada à medida que os dados são inseridos. Substitui a configuração \"Altura do campo de entrada (em linhas)\".",
        allowResize: "A alça de redimensionamento (ou pega) aparece no canto e pode ser arrastada para alterar o tamanho do campo de entrada.",
        maxTimeToFinish: "Um intervalo de tempo em segundos após o qual o questionário avança automaticamente para a página Obrigado.",
        maxTimeToFinishPage: "Um intervalo de tempo em segundos após o qual o questionário avança automaticamente para a próxima página.",
        page: {
            maxTimeToFinish: "Um intervalo de tempo em segundos após o qual o questionário avança automaticamente para a próxima página.",
            visibleIf: "Use o ícone de varinha mágica para definir uma regra condicional que determina a visibilidade da página.",
            enableIf: "Use o ícone de varinha mágica para definir uma regra condicional que desabilita o modo somente leitura da página.",
            requiredIf: "Use o ícone de varinha mágica para definir uma regra condicional que impeça o envio de questionários, a menos que pelo menos uma pergunta aninhada tenha uma resposta.",
            questionTitleLocation: "Aplica-se a todas as perguntas dentro desta página. Se você quiser substituir essa configuração, defina regras de alinhamento de título para perguntas ou painéis individuais. A opção \"Herdar\" aplica a configuração de nível de pesquisa (\"Superior\" por padrão).",
            questionTitleWidth: "Define largura consistente para títulos de perguntas quando eles estão alinhados à esquerda de suas caixas de perguntas. Aceita valores CSS (px, %, in, pt, etc.).",
            questionErrorLocation: "Define o local de uma mensagem de erro em relação à pergunta com entrada inválida. Escolha entre: \"Top\" - um texto de erro é colocado na parte superior da caixa de perguntas; \"Inferior\" - um texto de erro é colocado na parte inferior da caixa de perguntas. A opção \"Herdar\" aplica a configuração de nível de pesquisa (\"Superior\" por padrão).",
            questionsOrder: "Mantém a ordem original das perguntas ou as randomiza. A opção \"Herdar\" aplica a configuração de nível de pesquisa (\"Original\" por padrão). O efeito dessa configuração só é visível na guia Visualização.",
            navigationButtonsVisibility: "Define a visibilidade dos botões de navegação na página. A opção \"Herdar\" aplica a configuração de nível de pesquisa, que tem como padrão \"Visível\"."
        },
        showTimerPanel: "Define a visibilidade e a localização de um temporizador em uma página.",
        panelsState: "Escolha entre: \"Bloqueado\" - os usuários não podem expandir ou recolher painéis; \"Recolher tudo\" - todos os painéis começam em estado colapsado; \"Expandir tudo\" - todos os painéis começam em um estado expandido; \"Primeiro expandido\" - apenas o primeiro painel é inicialmente expandido.",
        imageLinkName: "Insira um nome de propriedade compartilhada na matriz de objetos que contém as URLs de arquivo de imagem ou vídeo que você deseja exibir na lista de opções.",
        choices: "O valor esquerdo serve como um ID de item usado em regras condicionais, o valor direito é exibido aos respondentes.",
        title: "Digite um título amigável para exibir.",
        waitForUpload: "Garante que os usuários não concluam a pesquisa até que os arquivos sejam carregados.",
        minWidth: "Aceita valores CSS (px, %, in, pt, etc.).",
        maxWidth: "Aceita valores CSS (px, %, in, pt, etc.).",
        width: "Aceita valores CSS (px, %, in, pt, etc.).",
        valueName: "Se você não definir esta propriedade, a resposta será armazenada em um campo especificado pela propriedade Nome.",
        useDisplayValuesInDynamicTexts: "Nos tipos de pergunta de seleção única e múltipla, cada opção de opção tem um ID e um valor de exibição. Quando selecionada, essa configuração mostra um valor de exibição em vez de um valor de ID em perguntas HTML e títulos dinâmicos e descrições de elementos de pesquisa.",
        clearIfInvisible: "Escolha se deseja ou não limpar valores de pergunta ocultos pela lógica condicional e quando fazê-lo. A opção \"Herdar\" aplica a configuração no nível do questionário (\"Após a conclusão do questionário\" por padrão).",
        choicesFromQuestionMode: "Escolha entre: \"Todos\" - copia todas as opções de escolha da pergunta selecionada; \"Selecionado\" - copia dinamicamente apenas as opções de escolha selecionadas; \"Não selecionado\" - copia dinamicamente apenas as opções de escolha não selecionadas. As opções \"Nenhum\" e \"Outros\" são copiadas por padrão se ativadas na pergunta de origem.",
        showOtherItem: "Quando selecionada, os usuários podem incluir entrada adicional em uma caixa de comentário separada.",
        separateSpecialChoices: "Exibe cada opção de opção especial (\"Nenhuma\", \"Outra\", \"Selecionar Tudo\") em uma nova linha, mesmo ao usar um layout de várias colunas.",
        path: "Especifique o local dentro do conjunto de dados de serviço onde a matriz de objetos de destino está localizada. Deixe em branco se a URL já apontar para a matriz.",
        choicesbyurl: {
            valueName: "Nome"
        },
        titleName: "Insira um nome de propriedade uniforme dentro da matriz de objetos que contém os valores que você deseja exibir na lista de opções.",
        allowEmptyResponse: "Selecione esta opção para permitir que o serviço retorne uma resposta ou matriz vazia.",
        choicesVisibleIf: "Use o ícone de varinha mágica para definir uma regra condicional que determina a visibilidade de todas as opções de escolha.",
        rateValues: "O valor esquerdo serve como um ID de item usado em regras condicionais, o valor direito é exibido aos respondentes.",
        rating: {
            displayMode: "\"Auto\" seleciona entre os modos \"Botões\" e \"Dropdown\" com base na largura disponível. Quando a largura é insuficiente para exibir botões, a pergunta exibe uma lista suspensa."
        },
        valuePropertyName: "Permite conectar perguntas que produzem resultados em diferentes formatos. Quando essas perguntas são vinculadas usando um identificador de junção, essa propriedade compartilhada armazena valores de pergunta selecionados.",
        searchEnabled: "Selecione se deseja atualizar o conteúdo do menu suspenso para corresponder à consulta de pesquisa que um usuário está digitando no campo de entrada.",
        valueTrue: "Um valor a guardar nos resultados do inquérito quando os inquiridos dão uma resposta positiva.",
        valueFalse: "Um valor a guardar nos resultados do inquérito quando os inquiridos dão uma resposta negativa.",
        showPreview: "Não é recomendável desativar essa opção, pois ela substitui a imagem de visualização e torna difícil para um usuário entender se os arquivos foram carregados.",
        needConfirmRemoveFile: "Aciona um prompt pedindo para confirmar a exclusão do arquivo.",
        selectToRankEnabled: "Habilite para classificar apenas as opções selecionadas. Os usuários arrastarão os itens selecionados da lista de opções para ordená-los dentro da área de classificação.",
        dataList: "Insira uma lista de opções que serão sugeridas ao respondente durante a entrada.",
        itemSize: "A configuração redimensiona apenas os campos de entrada e não afeta a largura da caixa de pergunta.",
        itemTitleWidth: "Define largura consistente para todos os rótulos de item em pixels",
        altText: "Serve como um substituto quando a imagem não pode ser exibida no dispositivo de um usuário e para fins de acessibilidade.",
        rateColorMode: "Define a cor do emoji selecionado quando o tipo de ícone Classificação é definido como \"Smileys\". Escolha entre: \"Padrão\" - o emoji selecionado aparece na cor padrão do questionário; \"Escala\" - o emoji selecionado herda a cor da escala de classificação.",
        expression: {
            name: "Um ID de expressão que não está visível para os respondentes.",
            description: "Digite um subtítulo de expressão.",
            expression: "Uma expressão pode incluir cálculos básicos ('{q1_id} + {q2_id}'), condições ('{age} > 60') e funções ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.)."
        },
        storeOthersAsComment: "Selecione para armazenar o valor da opção \"Outro\" como uma propriedade separada nos resultados da pesquisa.",
        format: "Utilizar {0} como um espaço reservado para o valor real.",
        acceptedTypes: "Consulte o [aceitar](https://www.w3schools.com/tags/att_input_accept.asp) descrição do atributo para mais informações.",
        columnColCount: "Aplicável apenas aos tipos de célula Grupo de Rádio e Caixa de Seleção.",
        autocomplete: "Consulte o [autocompleto](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) descrição do atributo para mais informações.",
        filePlaceholder: "Aplica-se quando \"Tipo de origem\" é \"Arquivos locais\" ou quando a câmera não está disponível",
        photoPlaceholder: "Aplica-se quando \"Tipo de origem\" é \"Câmera\".",
        fileOrPhotoPlaceholder: "Aplica-se quando \"Tipo de origem\" é \"Arquivos locais ou câmera\".",
        masksettings: {
            saveMaskedValue: "Selecione se deseja armazenar o valor da pergunta com uma máscara aplicada nos resultados do questionário."
        },
        patternmask: {
            pattern: "O padrão pode conter literais de cadeia de caracteres e os seguintes espaços reservados: '9' - para um dígito; «a» - para uma letra maiúscula ou minúscula; '#' - para um dígito ou uma letra maiúscula ou minúscula. Use barra invertida '\\' para escapar de um personagem."
        },
        datetimemask: {
            pattern: "O padrão pode conter caracteres separadores e os seguintes espaços reservados:<br>'m' - Número do mês.<br>'mm' - Número do mês, com zero à esquerda para valores de um dígito. <br>'d' - Dia do mês. <br>'dd' - Dia do mês, com zero à esquerda para valores de um dígito. <br>'yy' - Os dois últimos dígitos do ano. <br>'yyyy' - Ano de quatro dígitos. <br>'H' - Horas em formato de 24 horas. <br>'HH' - Horas em formato de 24 horas, com zero à esquerda para valores de um dígito. <br>'h' - Horas em formato de 12 horas. <br>'hh' - Horas em formato de 12 horas, com zero à esquerda para valores de um dígito. <br>'MM' - Minutos. <br>'ss' - Segundos. <br>'TT' - Relógio de 12 horas em caixa alta (AM/PM). <br>'tt' - Relógio de 12 horas em minúsculas (am/pm)."
        },
        numericmask: {
            decimalSeparator: "Um símbolo usado para separar a parte fracionária da parte inteira de um número exibido.",
            thousandsSeparator: "Um símbolo usado para separar os dígitos de um grande número em grupos de três.",
            precision: "Limita quantos dígitos devem ser retidos após o ponto decimal de um número exibido."
        },
        currencymask: {
            prefix: "Um ou vários símbolos a serem exibidos antes do valor.",
            suffix: "Um ou vários símbolos a serem exibidos após o valor."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "título",
            title: "Deixar vazio se for o mesmo que 'Nome'"
        },
        multiSelect: "Permitir escolha múltipla",
        showLabel: "Mostrar legenda das imagens",
        swapOrder: "Troque a ordem de Sim e Não",
        value: "Valor",
        tabAlign: "Alinhamento de tabulação",
        sourceType: "Tipo de origem",
        fitToContainer: "Ajuste ao contêiner",
        setValueExpression: "Definir expressão de valor",
        description: "Descrição",
        logoFit: "Ajustar o logo",
        pages: "páginas",
        questions: "questões",
        triggers: "Condições",
        calculatedValues: "Valores calculados",
        surveyId: "Identificação do questionário",
        surveyPostId: "Identificação da publicação do questionário",
        surveyShowDataSaving: "Mostrar economia de dados do questionário",
        questionDescriptionLocation: "Descrição da localização do questionário",
        progressBarType: "Tipo de barra de progresso",
        showTOC: "Mostrar sumário",
        tocLocation: "Localização do sumário",
        questionTitlePattern: "Padrão de título da pergunta",
        widthMode: "Modo de largura",
        showBrandInfo: "Mostrar informações da marca",
        useDisplayValuesInDynamicTexts: "Usar valores de exibição em textos dinâmicos",
        visibleIf: "Visível se",
        defaultValueExpression: "Valor de expressão pré-definida",
        requiredIf: "Obrigatório se",
        resetValueIf: "Redefinir valor se",
        setValueIf: "Defina o valor se",
        validators: "Validadores",
        bindings: "ligações",
        renderAs: "renderizar como",
        attachOriginalItems: "anexar itens originais",
        choices: "Opções",
        choicesByUrl: "Opções com origem na Web",
        currency: "Moeda",
        cellHint: "Dica de célula",
        totalMaximumFractionDigits: "Total Máximo de Dígitos da Fração",
        totalMinimumFractionDigits: "Total Mínimo de Dígitos da Fração",
        columns: "Colunas",
        detailElements: "Detalhes elementos",
        allowAdaptiveActions: "Permitir ações adaptativas",
        defaultRowValue: "valor default da linha",
        detailPanelShowOnAdding: "Mostrar ao adicionar painel de detalhes",
        choicesLazyLoadEnabled: "Escolha carga lenta habilitada",
        choicesLazyLoadPageSize: "Escolha carga lenta tamanho de página",
        inputFieldComponent: "Componente de campo de entrada",
        itemComponent: "Componente de item",
        min: "min",
        max: "max",
        minValueExpression: "Expressão valor mínimo",
        maxValueExpression: "Expressão valor máximo",
        step: "passo",
        dataList: "Lista",
        itemSize: "Tamanho do item",
        itemTitleWidth: "Largura da etiqueta do item (em px)",
        elements: "elementos",
        content: "conteúdo",
        navigationButtonsVisibility: "Visibilidade dos botões de navegação",
        navigationTitle: "Título de navegação",
        navigationDescription: "Descrição de navegação",
        longTap: "Toque longo",
        autoGrow: "Crescimento automático",
        allowResize: "Permitir redimensionamento",
        acceptCarriageReturn: "aceitar devolução de conteúdo",
        displayMode: "Modo de exibição",
        rateType: "Tipo de tarifa",
        label: "Rótulo",
        contentMode: "Modo de conteúdo",
        imageFit: "Ajustar imagem",
        altText: "Texto alternativo",
        height: "altura",
        penColor: "Cor de caneta",
        backgroundColor: "Cor de fundo",
        templateElements: "Modelo de elementos",
        operator: "operador",
        isVariable: "É vairável",
        runExpression: "Expressão de execução",
        showCaption: "Mostrar descrição",
        iconName: "Nome do ícone",
        iconSize: "Tamanho do ícone",
        precision: "Precisão",
        matrixDragHandleArea: "Área da alça de arraste da matriz",
        backgroundImage: "Imagem de fundo",
        backgroundImageFit: "Ajuste de imagem de plano de fundo",
        backgroundImageAttachment: "Anexo de imagem de plano de fundo",
        backgroundOpacity: "Opacidade de fundo",
        selectToRankEnabled: "Selecione para classificar ativado",
        selectToRankAreasLayout: "Selecione para classificar o layout das áreas",
        selectToRankEmptyRankedAreaText: "Texto para mostrar se todas as opções estão selecionadas",
        selectToRankEmptyUnrankedAreaText: "Texto de espaço reservado para a área de classificação",
        allowCameraAccess: "Permitir acesso à câmera",
        scaleColorMode: "Modo de cor de escala",
        rateColorMode: "Classifique o modo de cores",
        copyDisplayValue: "Copiar valor de exibição",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Modo avançado",
        pageTitle: "Fonte do título da página",
        questionTitle: "Fonte do título da pergunta",
        editorPanel: "Elemento de entrada",
        lines: "Linhas",
        primaryDefaultColor: "Inadimplência",
        primaryDarkColor: "Pairar",
        primaryLightColor: "Selecionado",
        backgroundDimColor: "Cor de fundo",
        cornerRadius: "Raio de canto",
        backcolor: "Plano de fundo padrão",
        hovercolor: "Plano de fundo do mouse",
        borderDecoration: "Decoração de borda",
        fontColor: "Cor da fonte",
        backgroundColor: "Cor de fundo",
        primaryForecolor: "Cor padrão",
        primaryForecolorLight: "Cor desativada",
        font: "Fonte",
        borderDefault: "Escuro",
        borderLight: "Isqueiro",
        fontFamily: "Família de fontes",
        fontWeightRegular: "Regular",
        fontWeightHeavy: "Pesado",
        fontWeightSemiBold: "Semi-negrito",
        fontWeightBold: "Ousado",
        color: "Cor",
        placeholderColor: "Cor do espaço reservado",
        size: "Tamanho",
        opacity: "Opacidade",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Adicionar efeito de sombra",
        boxShadowBlur: "Borrão",
        boxShadowSpread: "Espalhar",
        boxShadowDrop: "Deixar cair",
        boxShadowInner: "Interno",
        names: {
            default: "Inadimplência",
            sharp: "Afiado",
            borderless: "Sem fronteiras",
            flat: "Plano",
            plain: "Planície",
            doubleborder: "Borda Dupla",
            layered: "Camadas",
            solid: "Sólido",
            threedimensional: ".3D",
            contrast: "Contraste"
        },
        colors: {
            teal: "Azul-petróleo",
            blue: "Azul",
            purple: "Roxo",
            orchid: "Orquídea",
            tulip: "Tulipa",
            brown: "Marrom",
            green: "Verde"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["pt"] = portugueseTranslation;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// survey.externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber" => "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber"
// ed.themeSurvey: "Themes" => "Temas"
// ed.themePropertyGridTitle: "Theme Settings" => "Configurações do tema"
// ed.themeExportButton: "Export" => "Exportação"
// ed.themeImportButton: "Import" => "Importação"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "As opções são copiadas de"
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Arraste e solte uma imagem aqui ou clique no botão abaixo e escolha uma imagem para carregar"
// ed.imageChooseImage: "Choose Image" => "Escolha a imagem"
// ed.choices_Item: "Item " => "Item "
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "valor claro da pergunta: {0}"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "As regras lógicas estão incompletas"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Você não concluiu algumas das regras lógicas. Se você sair da guia agora, as alterações serão perdidas. Você ainda deseja sair da guia sem concluir as alterações?"
// lg.uncompletedRule_apply: "Yes" => "Sim"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Não, quero completar as regras"
// pe.overridingPropertyPrefix: "Set by " => "Definido por "
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Não use palavras reservadas: \"item\", \"escolha\", \"painel\", \"linha\"."
// image.imageHeight: "Image height (in CSS-accepted values)" => "Altura da imagem (em valores aceitos por CSS)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Largura da imagem (em valores aceitos por CSS)"
// pe.allowResizeComment: "Allow users to resize text areas" => "Permitir que os usuários redimensionem áreas de texto"
// pe.rateCount: "Rate count" => "Contagem de taxas"
// pe.autoGenerate: "How to specify rate values?" => "Como especificar valores de taxa?"
// pe.minSelectedChoices: "Minimum selected choices" => "Mínimo de opções selecionadas"
// pe.closeOnSelect: "Close the dropdown after selection" => "Fechar a lista suspensa após a seleção"
// pe.rateType: "Rate type" => "Tipo de tarifa"
// pv.tab: "Tabs" => "Guias"
// inputType.color: "Color" => "Cor"
// inputType.date: "Date" => "Data"
// inputType.datetime-local: "Date and Time" => "Data e Hora"
// inputType.email: "Email" => "Email"
// inputType.month: "Month" => "Mês"
// inputType.number: "Number" => "Número"
// inputType.password: "Password" => "Senha"
// inputType.range: "Range" => "Gama"
// inputType.tel: "Phone Number" => "Número de telefone"
// inputType.text: "Text" => "Texto"
// inputType.time: "Time" => "Hora"
// inputType.url: "URL" => "URL"
// inputType.week: "Week" => "Semana"
// rateColorMode.default: "Default" => "Inadimplência"
// autoGenerate.true: "Generate" => "Gerar"
// autoGenerate.false: "Enter manually" => "Digite manualmente"
// rateType.labels: "Labels" => "Rótulos"
// rateType.stars: "Stars" => "Estrelas"
// rateType.smileys: "Smileys" => "Smileys"
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Redimensiona a área visível do campo de entrada. Use a configuração <b>Validação → Comprimento máximo</b> para limitar o comprimento de entrada."
// p.tabAlign: "Tab alignment" => "Alinhamento de tabulação"
// p.showTOC: "Show TOC" => "Mostrar sumário"
// p.tocLocation: "Toc location" => "Localização do sumário"
// p.allowResize: "Allow resizing" => "Permitir redimensionamento"
// p.rateType: "Rate type" => "Tipo de tarifa"
// p.precision: "Precision" => "Precisão"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Área da alça de arraste da matriz"
// p.backgroundImage: "Background image" => "Imagem de fundo"
// p.backgroundImageFit: "Background image fit" => "Ajuste de imagem de plano de fundo"
// p.backgroundImageAttachment: "Background image attachment" => "Anexo de imagem de plano de fundo"
// p.backgroundOpacity: "Background opacity" => "Opacidade de fundo"
// p.selectToRankEnabled: "Select to rank enabled" => "Selecione para classificar ativado"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Selecione para classificar o layout das áreas"
// p.allowCameraAccess: "Allow camera access" => "Permitir acesso à câmera"
// p.scaleColorMode: "Scale color mode" => "Modo de cor de escala"
// p.rateColorMode: "Rate color mode" => "Classifique o modo de cores"
// p.templateTabTitle: "Template tab title" => "Título da guia Modelo"
// p.templateVisibleIf: "Template visible if" => "Modelo visível se"
// p.copyDisplayValue: "Copy display value" => "Copiar valor de exibição"
// theme.--background: "Background color" => "Cor de fundo"
// theme.--background-dim-light: "Background dim light color" => "Fundo cor fraca da luz"
// theme.--primary-foreground: "Primary foreground color" => "Cor primária de primeiro plano"
// theme.--foreground: "Foreground color" => "Cor de primeiro plano"
// theme.--base-unit: "Base unit" => "Unidade base"
// theme.groupAdvanced: "Advanced" => "Avançado"
// theme.themeName: "Theme" => "Tema"
// theme.isPanellessss: "Question appearance" => "Aparência da pergunta"
// theme.isPanellessPanels: "Default" => "Inadimplência"
// theme.isPanellessLightweight: "Without Panels" => "Sem Painéis"
// theme.themePaletteLight: "Light" => "Luz"
// theme.themePaletteDark: "Dark" => "Escuro"
// theme.primaryColor: "Accent color" => "Cor de destaque"
// theme.primaryDefaultColor: "Default" => "Inadimplência"
// theme.primaryDarkColor: "Hover" => "Pairar"
// theme.primaryLightColor: "Selected" => "Selecionado"
// theme.backgroundDimColor: "Background color" => "Cor de fundo"
// theme.backgroundImage: "Background image" => "Imagem de fundo"
// theme.backgroundImageFitAuto: "Auto" => "Automático"
// theme.backgroundImageFitCover: "Cover" => "Cobrir"
// theme.backgroundImageFitContain: "Contain" => "Conter"
// theme.backgroundOpacity: "Opacity" => "Opacidade"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Fixo"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Rolar"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Opacidade do plano de fundo do painel"
// theme.questionBackgroundTransparency: "Question background opacity" => "Opacidade de fundo da pergunta"
// theme.questionPanel: "Panel background and corner radius" => "Fundo do painel e raio de canto"
// theme.questionTitle: "Question title font" => "Fonte do título da pergunta"
// theme.questionDescription: "Question description font" => "Fonte da descrição da pergunta"
// theme.editorPanel: "Input element" => "Elemento de entrada"
// theme.editorFont: "Input element font" => "Fonte do elemento de entrada"
// theme.backcolor: "Default background" => "Plano de fundo padrão"
// theme.hovercolor: "Hover background" => "Plano de fundo do mouse"
// theme.borderDecoration: "Border decoration" => "Decoração de borda"
// theme.accentBackground: "Accent background" => "Fundo de destaque"
// theme.accentForeground: "Accent foreground" => "Destaque em primeiro plano"
// theme.primaryForecolor: "Default color" => "Cor padrão"
// theme.primaryForecolorLight: "Disabled color" => "Cor desativada"
// theme.linesColors: "Minor line colors" => "Cores de linha secundárias"
// theme.borderDefault: "Darker" => "Escuro"
// theme.borderLight: "Lighter" => "Isqueiro"
// theme.fontFamily: "Font family" => "Família de fontes"
// theme.fontSize: "Font size" => "Tamanho da fonte"
// theme.color: "Color" => "Cor"
// theme.size: "Size" => "Tamanho"
// theme.fontWeightRegular: "Regular" => "Regular"
// theme.fontWeightHeavy: "Heavy" => "Pesado"
// theme.fontWeightSemiBold: "Semi-bold" => "Semi-negrito"
// theme.fontWeightBold: "Bold" => "Ousado"
// theme.scale: "Scale" => "Escala"
// theme.cornerRadius: "Corner radius" => "Raio de canto"
// theme.surveyTitleFont: "Survey title font" => "Fonte do título do questionário"
// theme.pageTitle: "Page title font" => "Fonte do título da página"
// theme.pageDescription: "Page description font" => "Fonte da descrição da página"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Adicionar efeito de sombra"
// theme.opacity: "Opacity" => "Opacidade"
// theme.boxShadowBlur: "Blur" => "Borrão"
// theme.boxShadowSpread: "Spread" => "Espalhar"
// theme.boxShadowDrop: "Drop" => "Deixar cair"
// theme.boxShadowInner: "Inner" => "Interno"
// theme.questionShadow: "Shadow effects" => "Efeitos de sombra"
// theme.editorShadow: "Input element shadow effects" => "Efeitos de sombra do elemento de entrada"
// names.default: "Default" => "Inadimplência"
// names.contrast: "Contrast" => "Contraste"
// names.plain: "Plain" => "Planície"
// names.simple: "Simple" => "Simples"
// names.blank: "Blank" => "Em branco"
// names.double: "Double" => "Dobrar"
// names.bulk: "Bulk" => "Granel"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo 3D"
// names.playful: "Playful" => "Brincalhão"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Azul-petróleo"
// colors.blue: "Blue" => "Azul"
// colors.purple: "Purple" => "Roxo"
// colors.orchid: "Orchid" => "Orquídea"
// colors.tulip: "Tulip" => "Tulipa"
// colors.brown: "Brown" => "Marrom"
// colors.green: "Green" => "Verde"
// names.sharp: "Sharp" => "Afiado"
// names.borderless: "Borderless" => "Sem fronteiras"
// names.flat: "Flat" => "Plano"
// names.doubleborder: "Double Border" => "Borda Dupla"
// names.layered: "Layered" => "Camadas"
// names.solid: "Solid" => "Sólido"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Tem certeza de que deseja excluir todas as cadeias de caracteres para este idioma?"
// ed.themeResetButton: "Reset theme settings to default" => "Redefinir as configurações do tema para o padrão"
// theme.placeholderColor: "Placeholder color" => "Cor do espaço reservado"
// ed.themeSettings: "Theme Settings" => "Configurações do tema"
// ed.themeSettingsTooltip: "Open theme settings" => "Abrir configurações de tema"
// pe.resetToDefaultCaption: "Reset" => "Repor"
// pv.file: "Local files" => "Arquivos locais"
// pv.camera: "Camera" => "Câmera"
// pv.file-camera: "Local files or camera" => "Arquivos locais ou câmera"
// ed.translateUsigAI: "Auto-translate All" => "Tradução automática de todos"
// ed.translationDialogTitle: "Untranslated strings" => "Cadeias de caracteres não traduzidas"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Por favor, insira pelo menos {0} itens"
// lg.question_resetValueName: "Reset question value" => "Redefinir o valor da pergunta"
// lg.column_resetValue: "Reset column value" => "Redefinir o valor da coluna"
// pe.markRequired: "Mark as required" => "Marcar conforme necessário"
// pe.removeRequiredMark: "Remove the required mark" => "Remover a marca necessária"
// p.resetValueIf: "Reset value if" => "Redefinir valor se"
// lg.question_setValueName: "Set question value" => "Definir o valor da pergunta"
// lg.column_resetValueName: "Reset column value" => "Redefinir o valor da coluna"
// lg.column_setValueName: "Set column value" => "Definir valor de coluna"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Uma expressão cujo resultado será atribuído à pergunta de destino."
// survey.title: "Title" => "Título"
// page.title: "Title" => "Título"
// p.setValueIf: "Set value if" => "Defina o valor se"
// theme.header: "Header" => "Cabeçalho"
// theme.backgroundImageFitFill: "Stretch" => "Esticar"
// theme.backgroundImageFitTile: "Tile" => "Telha"
// theme.headerView: "View" => "Vista"
// theme.headerViewBasic: "Basic" => "Básico"
// theme.headerViewAdvanced: "Advanced" => "Avançado"
// theme.headerInheritWidthFrom: "Content area width" => "Largura da área de conteúdo"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "O mesmo que pesquisa"
// theme.headerInheritWidthFromPage: "Fit to page" => "Ajustar à página"
// theme.headerTextAreaWidth: "Text width" => "Largura do texto"
// theme.headerBackgroundColorSwitch: "Background color" => "Cor de fundo"
// theme.headerBackgroundColorNone: "None" => "Nenhum"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Cor de destaque"
// theme.headerBackgroundColorCustom: "Custom" => "Costume"
// theme.horizontalAlignmentLeft: "Left" => "Esquerda"
// theme.horizontalAlignmentCenter: "Center" => "Centro"
// theme.horizontalAlignmentRight: "Right" => "Direita"
// theme.verticalAlignmentTop: "Top" => "Início"
// theme.verticalAlignmentMiddle: "Middle" => "Meio"
// theme.verticalAlignmentBottom: "Bottom" => "Fundo"
// theme.logoPosition: "Logo Position" => "Posição do logotipo"
// lg.question_resetValueText: "reset value for question: {0}" => "redefinir valor da pergunta: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "atribuir valor: {1} à pergunta: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Redefinir o valor da célula para a coluna: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Atribuir valor de célula: {1} à coluna: {0}"
// ed.surveyJsonExportButton: "Export" => "Exportação"
// ed.surveyJsonImportButton: "Import" => "Importação"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Copiar para área de transferência"
// pe.filePlaceholder: "File placeholder text" => "Texto do espaço reservado para arquivo"
// pe.photoPlaceholder: "Photo placeholder text" => "Texto do espaço reservado para foto"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Texto de espaço reservado para arquivo ou foto"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Aplica-se quando \"Tipo de origem\" é \"Arquivos locais\" ou quando a câmera não está disponível"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Aplica-se quando \"Tipo de origem\" é \"Câmera\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Aplica-se quando \"Tipo de origem\" é \"Arquivos locais ou câmera\"."
// theme.background: "Background" => "Fundo"
// theme.appearance: "Appearance" => "Aparência"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Você realmente quer redefinir o tema? Todas as suas personalizações serão perdidas."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Sim, redefinir o tema"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Ajuste ao contêiner"
// signaturepad.showPlaceholder: "Show the placeholder" => "Mostrar o espaço reservado"
// signaturepad.placeholder: "Placeholder text" => "Texto de espaço reservado"
// theme.surveyDescriptionFont: "Survey description font" => "Fonte da descrição da pesquisa"
// ed.prevFocus: "Focus previous" => "Foco anterior"
// ed.nextFocus: "Focus next" => "Foco a seguir"
// ed.saveTheme: "Save Theme" => "Salvar tema"
// ed.saveThemeTooltip: "Save Theme" => "Salvar tema"
// lg.page_requireName: "Make page required" => "Tornar a página obrigatória"
// lg.panel_requireName: "Make page required" => "Tornar a página obrigatória"
// signaturepad.signatureWidth: "Signature area width" => "Largura da área de assinatura"
// signaturepad.signatureHeight: "Signature area height" => "Altura da área de assinatura"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Dimensionar automaticamente a área de assinatura"
// signaturepad.penMinWidth: "Minimum pen width" => "Largura mínima da caneta"
// signaturepad.penMaxWidth: "Maximum pen width" => "Largura máxima da caneta"
// theme.headerTitlePosition: "Title position" => "Posição do título"
// theme.headerDescriptionPosition: "Description position" => "Descrição da posição"
// ed.propertyGridNoResultsFound: "No results found" => "Nenhum resultado encontrado"
// pv.leftRight: "Left and right" => "Esquerda e direita"
// p.sourceType: "Source type" => "Tipo de origem"
// p.fitToContainer: "Fit to container" => "Ajuste ao contêiner"
// p.setValueExpression: "Set value expression" => "Definir expressão de valor"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "As opções são carregadas a partir de um serviço Web."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Ir para configurações"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Pré-visualização das opções de escolha carregadas"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Impedir respostas duplicadas em linhas"
// theme.advancedMode: "Advanced mode" => "Modo avançado"
// theme.backgroundCornerRadius: "Background and corner radius" => "Fundo e raio de canto"
// theme.colorsTitle: "Colors" => "Cores"
// theme.font: "Font" => "Fonte"
// theme.lines: "Lines" => "Linhas"
// theme.titleFont: "Title font" => "Fonte do título"
// theme.descriptionFont: "Description font" => "Fonte de descrição"
// theme.shadow: "Shadow effects" => "Efeitos de sombra"
// ed.translateUsigAIFrom: "Translate from: " => "Traduzir do: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Permitir a opção Recusar resposta"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Permitir a opção Não Sei"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Permitir a opção Recusar resposta"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Permitir a opção Não Sei"
// pv.contain: "Contain" => "Conter"
// pv.cover: "Cover" => "Cobrir"
// pv.fill: "Fill" => "Encher"
// pe.transposeData: "Transpose rows to columns" => "Transpor linhas para colunas"
// layout.panel: "Layout" => "Layout"
// layout.question: "Layout" => "Layout"
// layout.base: "Layout" => "Layout"
// panel.name: "Panel name" => "Nome do painel"
// panel.title: "Panel title" => "Título do painel"
// panel.description: "Panel description" => "Descrição do painel"
// panel.visibleIf: "Make the panel visible if" => "Tornar o painel visível se"
// panel.requiredIf: "Make the panel required if" => "Tornar o painel obrigatório se"
// panel.questionsOrder: "Question order within the panel" => "Ordem das perguntas no painel"
// panel.startWithNewLine: "Display the panel on a new line" => "Exibir o painel em uma nova linha"
// panel.state: "Panel collapse state" => "Estado de recolhimento do painel"
// panel.width: "Inline panel width" => "Largura do painel embutido"
// panel.minWidth: "Minimum panel width" => "Largura mínima do painel"
// panel.maxWidth: "Maximum panel width" => "Largura máxima do painel"
// panel.showNumber: "Number panels" => "Painéis numéricos"
// paneldynamic.name: "Panel name" => "Nome do painel"
// paneldynamic.title: "Panel title" => "Título do painel"
// paneldynamic.description: "Panel description" => "Descrição do painel"
// paneldynamic.visibleIf: "Make the panel visible if" => "Tornar o painel visível se"
// paneldynamic.requiredIf: "Make the panel required if" => "Tornar o painel obrigatório se"
// paneldynamic.page: "Move the panel to page" => "Mover o painel para a página"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Exibir o painel em uma nova linha"
// paneldynamic.state: "Panel collapse state" => "Estado de recolhimento do painel"
// paneldynamic.width: "Inline panel width" => "Largura do painel embutido"
// paneldynamic.minWidth: "Minimum panel width" => "Largura mínima do painel"
// paneldynamic.maxWidth: "Maximum panel width" => "Largura máxima do painel"
// paneldynamic.templateDescription: "Panel description pattern" => "Padrão de descrição do painel"
// paneldynamic.templateTitle: "Panel title pattern" => "Padrão de título do painel"
// paneldynamic.noEntriesText: "Empty panel text" => "Texto vazio do painel"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Padrão de título de guia"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Tornar um painel individual visível se"
// paneldynamic.hideNumber: "Hide the panel number" => "Ocultar o número do painel"
// paneldynamic.titleLocation: "Panel title alignment" => "Alinhamento do título do painel"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Alinhamento da descrição do painel"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Alinhamento do título da pergunta"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Alinhamento da mensagem de erro"
// paneldynamic.newPanelPosition: "New panel location" => "Nova localização do painel"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Evite respostas duplicadas na seguinte pergunta"
// question.name: "Question name" => "Nome da pergunta"
// question.title: "Question title" => "Título da pergunta"
// question.description: "Question description" => "Descrição da pergunta"
// question.visibleIf: "Make the question visible if" => "Torne a pergunta visível se"
// question.requiredIf: "Make the question required if" => "Faça a pergunta obrigatória se"
// question.state: "Question box collapse state" => "Estado de recolhimento da caixa de pergunta"
// question.hideNumber: "Hide the question number" => "Ocultar o número da pergunta"
// question.titleLocation: "Question title alignment" => "Alinhamento do título da pergunta"
// question.descriptionLocation: "Question description alignment" => "Alinhamento da descrição da pergunta"
// question.errorLocation: "Error message alignment" => "Alinhamento da mensagem de erro"
// question.indent: "Increase the inner indent" => "Aumentar o recuo interno"
// question.width: "Inline question width" => "Largura da pergunta embutida"
// question.minWidth: "Minimum question width" => "Largura mínima da pergunta"
// question.maxWidth: "Maximum question width" => "Largura máxima da pergunta"
// question.textUpdateMode: "Update input field value" => "Atualizar valor do campo de entrada"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Mostrar o botão Limpar na área de assinatura"
// signaturepad.penColor: "Stroke color" => "Cor do traçado"
// comment.rows: "Input field height (in lines)" => "Altura do campo de entrada (em linhas)"
// expression.name: "Expression name" => "Nome da expressão"
// expression.title: "Expression title" => "Título da expressão"
// expression.description: "Expression description" => "Descrição da expressão"
// expression.expression: "Expression" => "Expressão"
// trigger.expression: "Expression" => "Expressão"
// calculatedvalue.expression: "Expression" => "Expressão"
// survey.description: "Survey description" => "Descrição da pesquisa"
// page.name: "Page name" => "Nome da página"
// page.description: "Page description" => "Descrição da página"
// page.visibleIf: "Make the page visible if" => "Tornar a página visível se"
// page.requiredIf: "Make the page required if" => "Tornar a página obrigatória se"
// page.questionsOrder: "Question order on the page" => "Ordem das perguntas na página"
// matrixdropdowncolumn.name: "Column name" => "Nome da coluna"
// matrixdropdowncolumn.title: "Column title" => "Título da coluna"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Impedir respostas duplicadas"
// matrixdropdowncolumn.width: "Column width" => "Largura da coluna"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Largura mínima da coluna"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Altura do campo de entrada (em linhas)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Tornar a coluna visível se"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Tornar a coluna obrigatória se"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Cada opção em uma coluna separada"
// multipletextitem.name: "Name" => "Nome"
// multipletextitem.title: "Title" => "Título"
// pe.rateDescriptionLocation: "Label alignment" => "Alinhamento de rótulos"
// pe.cellErrorLocation: "Cell error message alignment" => "Alinhamento da mensagem de erro da célula"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Você ainda não tem nenhuma coluna"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Você ainda não tem nenhuma linha"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Você ainda não tem nenhuma regra de validação"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Você ainda não tem nenhuma variável personalizada"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Você ainda não tem nenhum gatilho"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Você ainda não tem nenhum link"
// pe.addNew@columns: "Add new column" => "Adicionar nova coluna"
// pe.addNew@rows: "Add new row" => "Adicionar nova linha"
// pe.addNew@validators: "Add new rule" => "Adicionar nova regra"
// pe.addNew@calculatedValues: "Add new variable" => "Adicionar nova variável"
// pe.addNew@triggers: "Add new trigger" => "Adicionar novo gatilho"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Adicionar novo URL"
// choicesbyurl.url: "Web service's URL" => "URL do serviço Web"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Exibir títulos de página na barra de progresso"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Exibir números de página na barra de progresso"
// itemvalue.visibleIf: "Make the option visible if" => "Torne a opção visível se"
// itemvalue.enableIf: "Make the option selectable if" => "Torne a opção selecionável se"
// panel.layout: "Panel Layout" => "Layout do painel"
// tabs.questionSettings: "Question Settings" => "Configurações da pergunta"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Ex.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Ex.: categorias.ficção"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Ex.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Ex.: 6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "Ex.: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Ex.: 50%"
// pv.selected: "Selected" => "Selecionado"
// pv.unselected: "Unselected" => "Desmarcado"
// pv.center: "Center" => "Centro"
// pv.middle: "Middle" => "Meio"
// pv.next: "Next" => "Próximo"
// pv.last: "Last" => "Último"
// clearIfInvisible.none: "Never" => "Nunca"
// questionsOnPageMode.standard: "Original structure" => "Estrutura original"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Mostrar todas as perguntas em uma página"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Mostrar uma única pergunta por página"
// pv.auto: "Auto" => "Automático"
// panelsState.firstExpanded: "First expanded" => "Primeiro expandido"
// rateColorMode.scale: "Scale" => "Escala"
// scaleColorMode.monochrome: "Monochrome" => "Monocromático"
// scaleColorMode.colored: "Colored" => "Colorido"
// state.default: "Locked" => "Trancado"
// showQuestionNumbers.default: "Auto-numbering" => "Numeração automática"
// showQuestionNumbers.on: "Auto-numbering" => "Numeração automática"
// showQuestionNumbers.onPage: "Reset on each page" => "Redefinir em cada página"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Redefinir em cada painel"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Redefinir em cada painel"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Continue na pesquisa"
// showQuestionNumbers.off: "No numbering" => "Sem numeração"
// descriptionLocation.underTitle: "Under the question title" => "Sob o título da pergunta"
// descriptionLocation.underInput: "Under the input field" => "No campo de entrada"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Ao lado das opções"
// selectToRankAreasLayout.vertical: "Above choices" => "Acima das escolhas"
// displayStyle.decimal: "Decimal" => "Decimal"
// displayStyle.currency: "Currency" => "Moeda"
// displayStyle.percent: "Percentage" => "Porcentagem"
// displayStyle.date: "Date" => "Data"
// totalDisplayStyle.decimal: "Decimal" => "Decimal"
// totalDisplayStyle.currency: "Currency" => "Moeda"
// totalDisplayStyle.percent: "Percentage" => "Porcentagem"
// totalDisplayStyle.date: "Date" => "Data"
// rowsOrder.initial: "Original" => "Original"
// questionsOrder.initial: "Original" => "Original"
// showProgressBar.aboveheader: "Above the header" => "Acima do cabeçalho"
// showProgressBar.belowheader: "Below the header" => "Abaixo do cabeçalho"
// pv.sum: "Sum" => "Soma"
// pv.count: "Count" => "Contar"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Max"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Contém"
// searchMode.startsWith: "Starts with" => "Começa com"
// panel.name: "A panel ID that is not visible to respondents." => "Um ID de painel que não está visível para os respondentes."
// panel.description: "Type a panel subtitle." => "Digite uma legenda do painel."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Use o ícone de varinha mágica para definir uma regra condicional que determine a visibilidade do painel."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Use o ícone de varinha mágica para definir uma regra condicional que desabilite o modo somente leitura para o painel."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Use o ícone de varinha mágica para definir uma regra condicional que impeça o envio de questionários, a menos que pelo menos uma pergunta aninhada tenha uma resposta."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Aplica-se a todas as perguntas deste painel. Se você quiser substituir essa configuração, defina regras de alinhamento de título para perguntas individuais. A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa (\"Superior\" por padrão)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Define o local de uma mensagem de erro em relação a todas as perguntas no painel. A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Mantém a ordem original das perguntas ou as randomiza. A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa."
// panel.page: "Repositions the panel to the end of a selected page." => "Reposiciona o painel no final de uma página selecionada."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Adiciona espaço ou margem entre o conteúdo do painel e a borda esquerda da caixa do painel."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Desmarque para exibir o painel em uma linha com a pergunta ou painel anterior. A configuração não se aplica se o painel for o primeiro elemento do formulário."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Escolha entre: \"Expandido\" - o painel é exibido na íntegra e pode ser recolhido; \"Recolhido\" - o painel exibe apenas o título e a descrição e pode ser expandido; \"Bloqueado\" - o painel é exibido na íntegra e não pode ser recolhido."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Define a largura do painel proporcionalmente a outros elementos de pesquisa na mesma linha. Aceita valores CSS (px, %, in, pt, etc.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "Um ID de painel que não está visível para os respondentes."
// paneldynamic.description: "Type a panel subtitle." => "Digite uma legenda do painel."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Use o ícone de varinha mágica para definir uma regra condicional que determine a visibilidade do painel."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Use o ícone de varinha mágica para definir uma regra condicional que desabilite o modo somente leitura para o painel."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Use o ícone de varinha mágica para definir uma regra condicional que impeça o envio de questionários, a menos que pelo menos uma pergunta aninhada tenha uma resposta."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Aplica-se a todas as perguntas deste painel. Se você quiser substituir essa configuração, defina regras de alinhamento de título para perguntas individuais. A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa (\"Superior\" por padrão)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Define o local de uma mensagem de erro em relação a uma pergunta com entrada inválida. Escolha entre: \"Top\" - um texto de erro é colocado na parte superior da caixa de perguntas; \"Inferior\" - um texto de erro é colocado na parte inferior da caixa de perguntas. A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa (\"Superior\" por padrão)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Define o local de uma mensagem de erro em relação a todas as perguntas no painel. A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Reposiciona o painel no final de uma página selecionada."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Adiciona espaço ou margem entre o conteúdo do painel e a borda esquerda da caixa do painel."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Desmarque para exibir o painel em uma linha com a pergunta ou painel anterior. A configuração não se aplica se o painel for o primeiro elemento do formulário."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Escolha entre: \"Expandido\" - o painel é exibido na íntegra e pode ser recolhido; \"Recolhido\" - o painel exibe apenas o título e a descrição e pode ser expandido; \"Bloqueado\" - o painel é exibido na íntegra e não pode ser recolhido."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Define a largura do painel proporcionalmente a outros elementos de pesquisa na mesma linha. Aceita valores CSS (px, %, in, pt, etc.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Digite um modelo para títulos de painel dinâmico. Use {panelIndex} para a posição geral do painel e {visiblePanelIndex} para sua ordem entre os painéis visíveis. Insira esses espaços reservados no padrão para adicionar numeração automática."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Digite um modelo para títulos de guias. Use {panelIndex} para a posição geral de um painel e {visiblePanelIndex} para sua ordem entre os painéis visíveis. Insira esses espaços reservados no padrão para adicionar numeração automática."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Essa configuração permite controlar a visibilidade de painéis individuais dentro do painel dinâmico. Use o espaço reservado '{panel}' para fazer referência ao painel atual em sua expressão."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Essa configuração é herdada automaticamente por todas as perguntas dentro deste painel. Se você quiser substituir essa configuração, defina regras de alinhamento de título para perguntas individuais. A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa (\"Superior\" por padrão)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "A opção \"Herdar\" aplica a configuração de nível de página (se definida) ou de nível de pesquisa (\"Sob o título do painel\" por padrão)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Define a posição de um painel recém-adicionado. Por padrão, novos painéis são adicionados ao final. Selecione \"Next\" para inserir um novo painel após o atual."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Duplica as respostas do último painel e as atribui ao próximo painel dinâmico adicionado."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Faça referência a um nome de pergunta para exigir que um usuário forneça uma resposta exclusiva para essa pergunta em cada painel."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Essa configuração permite atribuir um valor de resposta padrão com base em uma expressão. A expressão pode incluir cálculos básicos - '{q1_id} + {q2_id}', expressões booleanas, como '{age} > 60', e funções: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. O valor determinado por essa expressão serve como o valor padrão inicial que pode ser substituído pela entrada manual de um respondente."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Use o ícone de varinha mágica para definir uma regra condicional que determina quando a entrada de um respondente é redefinida para o valor com base no valor \"Expressão de valor padrão\" ou \"Definir expressão de valor\" ou no valor \"Resposta padrão\" (se um dos dois estiver definido)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Use o ícone de varinha mágica para definir uma regra condicional que determine quando executar a expressão \"Definir valor\" e atribuir dinamicamente o valor resultante como resposta."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Especifique uma expressão que defina o valor a ser definido quando as condições na regra \"Definir valor se\" forem atendidas. A expressão pode incluir cálculos básicos - '{q1_id} + {q2_id}', expressões booleanas, como '{age} > 60', e funções: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. O valor determinado por essa expressão pode ser substituído pela entrada manual de um respondente."
// question.name: "A question ID that is not visible to respondents." => "Um ID de pergunta que não é visível para os respondentes."
// question.description: "Type a question subtitle." => "Digite um subtítulo de pergunta."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Use o ícone de varinha mágica para definir uma regra condicional que determina a visibilidade da pergunta."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Use o ícone de varinha mágica para definir uma regra condicional que desabilita o modo somente leitura para a pergunta."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Use o ícone de varinha mágica para definir uma regra condicional que impeça o avanço ou o envio da pesquisa, a menos que a pergunta receba uma resposta."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Desmarque para exibir a pergunta em uma linha com a pergunta ou painel anterior. A configuração não se aplica se a pergunta for o primeiro elemento do formulário."
// question.page: "Repositions the question to the end of a selected page." => "Reposiciona a pergunta no final de uma página selecionada."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Escolha entre: \"Expandido\" - a caixa de perguntas é exibida na íntegra e pode ser recolhida; \"Recolhido\" - a caixa de perguntas exibe apenas o título e a descrição e pode ser expandida; \"Bloqueado\" - a caixa de perguntas é exibida na íntegra e não pode ser recolhida."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Substitui as regras de alinhamento de título definidas em um painel, página ou nível de pesquisa. A opção \"Herdar\" aplica quaisquer configurações de nível superior (se definidas) ou configurações de nível de pesquisa (\"Superior\" por padrão)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "A opção \"Herdar\" aplica a configuração de nível de pesquisa (\"Sob o título da pergunta\" por padrão)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Define o local de uma mensagem de erro em relação à pergunta com entrada inválida. Escolha entre: \"Top\" - um texto de erro é colocado na parte superior da caixa de perguntas; \"Inferior\" - um texto de erro é colocado na parte inferior da caixa de perguntas. A opção \"Herdar\" aplica a configuração de nível de pesquisa (\"Superior\" por padrão)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Adiciona espaço ou margem entre o conteúdo da pergunta e a borda esquerda da caixa de perguntas."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Define a largura da pergunta proporcionalmente a outros elementos do questionário na mesma linha. Aceita valores CSS (px, %, in, pt, etc.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Use o ícone de varinha mágica para definir uma regra de validação para a pergunta."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Escolha entre: \"Em foco perdido\" - o valor é atualizado quando o campo de entrada perde o foco; \"Ao digitar\" - o valor é atualizado em tempo real, à medida que os usuários digitam. A opção \"Herdar\" aplica a configuração de nível de pesquisa (\"Em foco perdido\" por padrão)."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Você pode usar qualquer serviço Web como uma fonte de dados para perguntas de múltipla escolha. Para preencher valores de escolha, insira a URL do serviço que fornece os dados."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Uma operação de comparação usada para filtrar a lista suspensa."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Define a largura da área de assinatura exibida e a imagem resultante."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Define a altura da área de assinatura exibida e a imagem resultante."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Selecione se deseja que a área de assinatura preencha todo o espaço disponível na caixa de pergunta, mantendo a proporção padrão de 3:2. Quando os valores personalizados de largura e altura são definidos, a configuração manterá a proporção dessas dimensões."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Ajusta a altura da imagem nos resultados da pesquisa."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Ajusta a largura da imagem nos resultados da pesquisa."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Substitui os valores de altura mínima e máxima."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Substitui os valores de largura mínima e máxima."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Valor\" serve como um ID de item usado em regras condicionais; \"Texto\" é exibido aos respondentes."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Essa configuração redimensiona apenas o campo de entrada e não afeta a largura da caixa de pergunta. Para limitar o comprimento de entrada aceito, vá para <b>Validação → Limite máximo de caracteres</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Define o número de linhas exibidas no campo de entrada. Se a entrada ocupar mais linhas, a barra de rolagem aparecerá."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Escolha entre: \"Editável\" - permite que os respondentes preencham seu questionário; \"Somente leitura\" - desabilita a edição de formulários."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "Um ID de coluna que não está visível para os respondentes."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Quando habilitado para uma coluna, um respondente é obrigado a fornecer uma resposta exclusiva para cada pergunta dentro desta coluna."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Define o número de linhas exibidas no campo de entrada. Se a entrada ocupar mais linhas, a barra de rolagem aparecerá."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Use o ícone de varinha mágica para definir uma regra condicional que determina a visibilidade da coluna."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Use o ícone de varinha mágica para definir uma regra condicional que desabilita o modo somente leitura para a coluna."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Use o ícone de varinha mágica para definir uma regra condicional que impeça o envio de questionários, a menos que pelo menos uma pergunta aninhada tenha uma resposta."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Quando selecionada, cria uma coluna individual para cada opção de escolha."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Escolha entre: \"Estático\" - define uma largura fixa; \"Responsivo\" - faz com que a pesquisa ocupe toda a largura da tela; \"Auto\" - aplica-se a qualquer um dos dois, dependendo dos tipos de pergunta usados."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Cole um link de imagem (sem limites de tamanho) ou clique no ícone de pasta para procurar um arquivo do seu computador (até 64 KB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Define a largura de um logotipo em unidades CSS (px, %, in, pt, etc.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Define a altura do logotipo em unidades CSS (px, %, in, pt, etc.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Escolha entre: \"Nenhum\" - a imagem mantém seu tamanho original; \"Conter\" - a imagem é redimensionada para se ajustar, mantendo sua proporção; \"Capa\" - a imagem preenche toda a caixa, mantendo sua proporção; \"Preencher\" - a imagem é esticada para preencher a caixa sem manter sua proporção."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Selecione se você deseja que o questionário avance para a próxima página automaticamente depois que um respondente responder a todas as perguntas na página atual."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Define a visibilidade e a localização dos botões de navegação em uma página."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Define a visibilidade e o local de uma barra de progresso. O valor \"Auto\" exibe a barra de progresso acima ou abaixo do cabeçalho do questionário."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Habilite a página de visualização apenas com todas as perguntas ou com as respostas respondidas."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Aplica-se a todas as perguntas do questionário. Essa configuração pode ser substituída por regras de alinhamento de título em níveis inferiores: painel, página ou pergunta. Uma configuração de nível inferior substituirá as de nível superior."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Um símbolo ou uma sequência de símbolos indicando que uma resposta é necessária."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Introduza um número ou letra com o qual pretende iniciar a numeração."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Define o local de uma mensagem de erro em relação à pergunta com entrada inválida. Escolha entre: \"Top\" - um texto de erro é colocado na parte superior da caixa de perguntas; \"Inferior\" - um texto de erro é colocado na parte inferior da caixa de perguntas."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Selecione se deseja que o primeiro campo de entrada em cada página esteja pronto para entrada de texto."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Mantém a ordem original das perguntas ou as randomiza. O efeito dessa configuração só é visível na guia Visualização."
// pehelp.maxTextLength: "For text entry questions only." => "Apenas para perguntas de entrada de texto."
// pehelp.maxOthersLength: "For question comments only." => "Apenas para comentários de perguntas."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Selecione se você deseja que os comentários de perguntas e as perguntas de texto longo aumentem automaticamente em altura com base no comprimento do texto inserido."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Apenas para comentários de perguntas e perguntas de texto longo."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "As variáveis personalizadas servem como variáveis intermediárias ou auxiliares usadas em cálculos de formulário. Eles tomam as entradas dos respondentes como valores de origem. Cada variável personalizada tem um nome exclusivo e uma expressão na qual se baseia."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Selecione se deseja que o valor calculado da expressão seja salvo junto com os resultados do questionário."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Um gatilho é um evento ou condição baseado em uma expressão. Uma vez que a expressão é avaliada como \"verdadeira\", um gatilho desencadeia uma ação. Tal ação pode, opcionalmente, ter uma questão-alvo que afeta."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Escolha se deseja ou não limpar valores para perguntas ocultas pela lógica condicional e quando fazê-lo."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Escolha entre: \"Em foco perdido\" - o valor é atualizado quando o campo de entrada perde o foco; \"Ao digitar\" - o valor é atualizado em tempo real, à medida que os usuários digitam."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "O valor esquerdo serve como um ID de coluna usado em regras condicionais, o valor direito é exibido aos respondentes."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "O valor esquerdo serve como um ID de linha usado em regras condicionais, o valor direito é exibido aos respondentes."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Aceita valores CSS (px, %, in, pt, etc.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Aceita valores CSS (px, %, in, pt, etc.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Define o local de uma mensagem de erro em relação a uma célula com entrada inválida. A opção \"Herdar\" aplica a configuração da propriedade \"Alinhamento da mensagem de erro\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Quando a propriedade \"Impedir respostas duplicadas\" está habilitada, um respondente tentando enviar uma entrada duplicada receberá a seguinte mensagem de erro."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Permite calcular valores totais com base em uma expressão. A expressão pode incluir cálculos básicos ('{q1_id} + {q2_id}'), expressões booleanas ('{age} > 60') e funções ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Aciona um prompt pedindo para confirmar a exclusão da linha."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Duplica as respostas da última linha e as atribui à próxima linha dinâmica adicionada."
// pehelp.description: "Type a subtitle." => "Digite uma legenda."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Escolha um idioma para começar a criar seu questionário. Para adicionar uma tradução, alterne para um novo idioma e traduza o texto original aqui ou na guia Traduções."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Define o local de uma seção de detalhes em relação a uma linha. Escolha entre: \"Nenhum\" - nenhuma expansão é adicionada; \"Sob a linha\" - uma expansão de linha é colocada sob cada linha da matriz; \"Sob a linha, exibir apenas uma expansão de linha\" - uma expansão é exibida em uma única linha apenas, as expansões de linha restantes são recolhidas."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Escolha entre: \"Nenhum\" - a imagem mantém seu tamanho original; \"Conter\" - a imagem é redimensionada para se ajustar, mantendo sua proporção; \"Capa\" - a imagem preenche toda a caixa, mantendo sua proporção; \"Preencher\" - a imagem é esticada para preencher a caixa sem manter sua proporção."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Aumenta gradualmente a altura do campo de entrada à medida que os dados são inseridos. Substitui a configuração \"Altura do campo de entrada (em linhas)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "A alça de redimensionamento (ou pega) aparece no canto e pode ser arrastada para alterar o tamanho do campo de entrada."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Um intervalo de tempo em segundos após o qual o questionário avança automaticamente para a página Obrigado."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Um intervalo de tempo em segundos após o qual o questionário avança automaticamente para a próxima página."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Um intervalo de tempo em segundos após o qual o questionário avança automaticamente para a próxima página."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Use o ícone de varinha mágica para definir uma regra condicional que determina a visibilidade da página."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Use o ícone de varinha mágica para definir uma regra condicional que desabilita o modo somente leitura da página."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Use o ícone de varinha mágica para definir uma regra condicional que impeça o envio de questionários, a menos que pelo menos uma pergunta aninhada tenha uma resposta."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Aplica-se a todas as perguntas dentro desta página. Se você quiser substituir essa configuração, defina regras de alinhamento de título para perguntas ou painéis individuais. A opção \"Herdar\" aplica a configuração de nível de pesquisa (\"Superior\" por padrão)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Define o local de uma mensagem de erro em relação à pergunta com entrada inválida. Escolha entre: \"Top\" - um texto de erro é colocado na parte superior da caixa de perguntas; \"Inferior\" - um texto de erro é colocado na parte inferior da caixa de perguntas. A opção \"Herdar\" aplica a configuração de nível de pesquisa (\"Superior\" por padrão)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Mantém a ordem original das perguntas ou as randomiza. A opção \"Herdar\" aplica a configuração de nível de pesquisa (\"Original\" por padrão). O efeito dessa configuração só é visível na guia Visualização."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Define a visibilidade dos botões de navegação na página. A opção \"Herdar\" aplica a configuração de nível de pesquisa, que tem como padrão \"Visível\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Define a visibilidade e a localização de um temporizador em uma página."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Escolha entre: \"Bloqueado\" - os usuários não podem expandir ou recolher painéis; \"Recolher tudo\" - todos os painéis começam em estado colapsado; \"Expandir tudo\" - todos os painéis começam em um estado expandido; \"Primeiro expandido\" - apenas o primeiro painel é inicialmente expandido."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Insira um nome de propriedade compartilhada na matriz de objetos que contém as URLs de arquivo de imagem ou vídeo que você deseja exibir na lista de opções."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "O valor esquerdo serve como um ID de item usado em regras condicionais, o valor direito é exibido aos respondentes."
// pehelp.title: "Type a user-friendly title to display." => "Digite um título amigável para exibir."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Garante que os usuários não concluam a pesquisa até que os arquivos sejam carregados."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Aceita valores CSS (px, %, in, pt, etc.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Aceita valores CSS (px, %, in, pt, etc.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Aceita valores CSS (px, %, in, pt, etc.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "Nos tipos de pergunta de seleção única e múltipla, cada opção de opção tem um ID e um valor de exibição. Quando selecionada, essa configuração mostra um valor de exibição em vez de um valor de ID em perguntas HTML e títulos dinâmicos e descrições de elementos de pesquisa."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Escolha se deseja ou não limpar valores de pergunta ocultos pela lógica condicional e quando fazê-lo. A opção \"Herdar\" aplica a configuração no nível do questionário (\"Após a conclusão do questionário\" por padrão)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Escolha entre: \"Todos\" - copia todas as opções de escolha da pergunta selecionada; \"Selecionado\" - copia dinamicamente apenas as opções de escolha selecionadas; \"Não selecionado\" - copia dinamicamente apenas as opções de escolha não selecionadas. As opções \"Nenhum\" e \"Outros\" são copiadas por padrão se ativadas na pergunta de origem."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Quando selecionada, os usuários podem incluir entrada adicional em uma caixa de comentário separada."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Exibe cada opção de opção especial (\"Nenhuma\", \"Outra\", \"Selecionar Tudo\") em uma nova linha, mesmo ao usar um layout de várias colunas."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Especifique o local dentro do conjunto de dados de serviço onde a matriz de objetos de destino está localizada. Deixe em branco se a URL já apontar para a matriz."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Insira um nome de propriedade uniforme dentro da matriz de objetos que contém os valores que você deseja exibir na lista de opções."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Selecione esta opção para permitir que o serviço retorne uma resposta ou matriz vazia."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Use o ícone de varinha mágica para definir uma regra condicional que determina a visibilidade de todas as opções de escolha."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "O valor esquerdo serve como um ID de item usado em regras condicionais, o valor direito é exibido aos respondentes."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" seleciona entre os modos \"Botões\" e \"Dropdown\" com base na largura disponível. Quando a largura é insuficiente para exibir botões, a pergunta exibe uma lista suspensa."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Permite conectar perguntas que produzem resultados em diferentes formatos. Quando essas perguntas são vinculadas usando um identificador de junção, essa propriedade compartilhada armazena valores de pergunta selecionados."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Selecione se deseja atualizar o conteúdo do menu suspenso para corresponder à consulta de pesquisa que um usuário está digitando no campo de entrada."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Um valor a guardar nos resultados do inquérito quando os inquiridos dão uma resposta positiva."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Um valor a guardar nos resultados do inquérito quando os inquiridos dão uma resposta negativa."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Não é recomendável desativar essa opção, pois ela substitui a imagem de visualização e torna difícil para um usuário entender se os arquivos foram carregados."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Aciona um prompt pedindo para confirmar a exclusão do arquivo."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Habilite para classificar apenas as opções selecionadas. Os usuários arrastarão os itens selecionados da lista de opções para ordená-los dentro da área de classificação."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Insira uma lista de opções que serão sugeridas ao respondente durante a entrada."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "A configuração redimensiona apenas os campos de entrada e não afeta a largura da caixa de pergunta."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Define largura consistente para todos os rótulos de item em pixels"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "A opção \"Auto\" determina automaticamente o modo adequado para exibição - Imagem, Vídeo ou YouTube - com base no URL de origem fornecido."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Serve como um substituto quando a imagem não pode ser exibida no dispositivo de um usuário e para fins de acessibilidade."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Define a cor do emoji selecionado quando o tipo de ícone Classificação é definido como \"Smileys\". Escolha entre: \"Padrão\" - o emoji selecionado aparece na cor padrão do questionário; \"Escala\" - o emoji selecionado herda a cor da escala de classificação."
// expression.name: "An expression ID that is not visible to respondents." => "Um ID de expressão que não está visível para os respondentes."
// expression.description: "Type an expression subtitle." => "Digite um subtítulo de expressão."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Uma expressão pode incluir cálculos básicos ('{q1_id} + {q2_id}'), condições ('{age} > 60') e funções ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Selecione para armazenar o valor da opção \"Outro\" como uma propriedade separada nos resultados da pesquisa."
// p.swapOrder: "Swap the order of Yes and No" => "Troque a ordem de Sim e Não"
// p.itemTitleWidth: "Item label width (in px)" => "Largura da etiqueta do item (em px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Texto para mostrar se todas as opções estão selecionadas"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Texto de espaço reservado para a área de classificação"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Preencha o questionário automaticamente"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Selecione se você deseja que o questionário seja concluído automaticamente depois que um respondente responder a todas as perguntas."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Salvar valor mascarado nos resultados da pesquisa"
// patternmask.pattern: "Value pattern" => "Padrão de valor"
// datetimemask.min: "Minimum value" => "Valor mínimo"
// datetimemask.max: "Maximum value" => "Valor máximo"
// numericmask.allowNegativeValues: "Allow negative values" => "Permitir valores negativos"
// numericmask.thousandsSeparator: "Thousands separator" => "Separador de milhares"
// numericmask.decimalSeparator: "Decimal separator" => "Separador decimal"
// numericmask.precision: "Value precision" => "Precisão de valor"
// numericmask.min: "Minimum value" => "Valor mínimo"
// numericmask.max: "Maximum value" => "Valor máximo"
// currencymask.prefix: "Currency prefix" => "Prefixo da moeda"
// currencymask.suffix: "Currency suffix" => "Sufixo de moeda"
// pe.maskType: "Input mask type" => "Tipo de máscara de entrada"
// maskTypes.patternmask: "Pattern" => "Padrão"
// maskTypes.numericmask: "Numeric" => "Numérico"
// maskTypes.datetimemask: "Date and Time" => "Data e Hora"
// maskTypes.currencymask: "Currency" => "Moeda"
// tabs.mask: "Input Mask Settings" => "Configurações da máscara de entrada"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Ex.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Ex.: dd/mm/aaaa"
// pe.currencyprefix_placeholder: "Ex.: $" => "Ex.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Ex.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Opções de encapsulamento"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Textos longos nas opções de escolha gerarão automaticamente quebras de linha para caber no menu suspenso. Desmarque se quiser que os textos sejam recortados."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Selecione se deseja armazenar o valor da pergunta com uma máscara aplicada nos resultados do questionário."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "O padrão pode conter literais de cadeia de caracteres e os seguintes espaços reservados: '9' - para um dígito; «a» - para uma letra maiúscula ou minúscula; '#' - para um dígito ou uma letra maiúscula ou minúscula. Use barra invertida '\\' para escapar de um personagem."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "O padrão pode conter caracteres separadores e os seguintes espaços reservados: 'm' - para o número do mês; 'mm' - para o número do mês, com zero à esquerda para valores de um dígito; 'd' - para o dia do mês; 'dd' - para o dia do mês, com zero à esquerda para valores de um dígito; 'yy' - para os dois últimos dígitos do ano; 'yyyy' - por um ano de quatro dígitos."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Um símbolo usado para separar a parte fracionária da parte inteira de um número exibido."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Um símbolo usado para separar os dígitos de um grande número em grupos de três."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Limita quantos dígitos devem ser retidos após o ponto decimal de um número exibido."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Um ou vários símbolos a serem exibidos antes do valor."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Um ou vários símbolos a serem exibidos após o valor."
// ed.translationSource: "Source: " => "Fonte: "
// ed.translationTarget: "Target: " => "Alvo: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "A página está vazia. Arraste um elemento da caixa de ferramentas ou clique no botão abaixo."
// maskTypes.none: "None" => "Nenhum"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Tornar a linha visível se"
// itemvalue@rows.enableIf: "Make the row editable if" => "Tornar a linha editável se"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Texto de espaço reservado no modo somente leitura ou de visualização"
// pe.textWrapEnabled: "Wrap choices" => "Opções de encapsulamento"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "A opção \"Auto\" determina automaticamente o modo adequado para exibição - Imagem, Vídeo ou YouTube - com base no URL de origem fornecido."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Escolha entre \"Imagem\" e \"Vídeo\" para definir o modo de conteúdo do seletor de mídia. Se \"Imagem\" estiver selecionado, certifique-se de que todas as opções fornecidas são arquivos de imagem nos seguintes formatos: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Da mesma forma, se \"Vídeo\" estiver selecionado, certifique-se de que todas as opções sejam links diretos para arquivos de vídeo nos seguintes formatos: MP4, MOV, WMV, FLV, AVI, MKV. Observe que os links do YouTube não são compatíveis com as opções de vídeo."
// ed.selectFile: "Select a file" => "Selecione um arquivo"
// ed.removeFile: "Remove the file" => "Remover o arquivo"
// pe.searchMode: "Search Mode" => "Modo de pesquisa"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Clique no botão \"Adicionar pergunta\" abaixo para começar a criar seu formulário."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Clique no botão \"Adicionar pergunta\" abaixo para adicionar um novo elemento à página."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Clique no botão \"Adicionar pergunta\" abaixo para adicionar um novo elemento ao painel."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Clique no botão abaixo e escolha uma imagem para carregar"
// coloralpha.opacity: "Opacity" => "Opacidade"
// font.family: "Font family" => "Família de fontes"
// font.color: "Color" => "Cor"
// font.placeholderColor: "Placeholder color" => "Cor do espaço reservado"
// font.size: "Size" => "Tamanho"
// theme.themeName: "Theme" => "Tema"
// theme.isPanelless: "Question appearance" => "Aparência da pergunta"
// theme.editorPanel: "Background and corner radius" => "Fundo e raio de canto"
// theme.questionPanel: "Background and corner radius" => "Fundo e raio de canto"
// theme.primaryColor: "Accent color" => "Cor de destaque"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Opacidade do plano de fundo do painel"
// theme.questionBackgroundTransparency: "Question background opacity" => "Opacidade de fundo da pergunta"
// theme.fontSize: "Font size" => "Tamanho da fonte"
// theme.scale: "Scale" => "Escala"
// theme.cornerRadius: "Corner radius" => "Raio de canto"
// theme.pageTitle: "Title font" => "Fonte do título"
// theme.pageDescription: "Description font" => "Fonte de descrição"
// theme.questionTitle: "Title font" => "Fonte do título"
// theme.questionDescription: "Description font" => "Fonte de descrição"
// theme.editorFont: "Font" => "Fonte"
// theme.backgroundOpacity: "Opacity" => "Opacidade"
// theme.--sjs-font-family: "Font family" => "Família de fontes"
// theme.--sjs-general-backcolor-dim: "Background color" => "Cor de fundo"
// theme.--sjs-primary-backcolor: "Accent background" => "Fundo de destaque"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Destaque em primeiro plano"
// theme.--sjs-shadow-small: "Shadow effects" => "Efeitos de sombra"
// theme.--sjs-shadow-inner: "Shadow effects" => "Efeitos de sombra"
// theme.--sjs-border-default: "Colors" => "Cores"
// header@header.headerView: "View" => "Vista"
// header@header.logoPosition: "Logo position" => "Posição do logotipo"
// header@header.surveyTitle: "Survey title font" => "Fonte do título do questionário"
// header@header.surveyDescription: "Survey description font" => "Fonte da descrição da pesquisa"
// header@header.headerTitle: "Survey title font" => "Fonte do título do questionário"
// header@header.headerDescription: "Survey description font" => "Fonte da descrição da pesquisa"
// header@header.inheritWidthFrom: "Content area width" => "Largura da área de conteúdo"
// header@header.textAreaWidth: "Text width" => "Largura do texto"
// header@header.backgroundColorSwitch: "Background color" => "Cor de fundo"
// header@header.backgroundImage: "Background image" => "Imagem de fundo"
// header@header.backgroundImageOpacity: "Opacity" => "Opacidade"
// header@header.overlapEnabled: "Overlap" => "Sobrepor"
// header@header.logoPositionX: "Logo position" => "Posição do logotipo"
// header@header.titlePositionX: "Title position" => "Posição do título"
// header@header.descriptionPositionX: "Description position" => "Descrição da posição"
// weight.400: "Regular" => "Regular"
// weight.600: "Heavy" => "Pesado"
// weight.700: "Semi-bold" => "Semi-negrito"
// weight.800: "Bold" => "Ousado"
// backgroundImageFit.auto: "Auto" => "Automático"
// backgroundImageFit.cover: "Cover" => "Cobrir"
// backgroundImageFit.contain: "Contain" => "Conter"
// backgroundImageFit.fill: "Stretch" => "Esticar"
// backgroundImageFit.tile: "Tile" => "Telha"
// backgroundImageAttachment.fixed: "Fixed" => "Fixo"
// backgroundImageAttachment.scroll: "Scroll" => "Rolar"
// headerView.basic: "Basic" => "Básico"
// headerView.advanced: "Advanced" => "Avançado"
// inheritWidthFrom.survey: "Same as survey" => "O mesmo que pesquisa"
// inheritWidthFrom.container: "Fit to container" => "Ajuste ao contêiner"
// backgroundColorSwitch.none: "None" => "Nenhum"
// backgroundColorSwitch.accentColor: "Accent color" => "Cor de destaque"
// backgroundColorSwitch.custom: "Custom" => "Costume"
// colorPalette.light: "Light" => "Luz"
// colorPalette.dark: "Dark" => "Escuro"
// isPanelless.false: "Default" => "Inadimplência"
// isPanelless.true: "Without Panels" => "Sem Painéis"
// theme.cornerRadius: "Corner radius" => "Raio de canto"
// theme.fontFamily: "Font family" => "Família de fontes"
// theme.fontWeightRegular: "Regular" => "Regular"
// theme.fontWeightHeavy: "Heavy" => "Pesado"
// theme.fontWeightSemiBold: "Semi-bold" => "Semi-negrito"
// theme.fontWeightBold: "Bold" => "Ousado"
// theme.color: "Color" => "Cor"
// theme.placeholderColor: "Placeholder color" => "Cor do espaço reservado"
// theme.size: "Size" => "Tamanho"
// theme.opacity: "Opacity" => "Opacidade"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Digite para pesquisar..."
// ed.toolboxNoResultsFound: "No results found" => "Nenhum resultado encontrado"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Espaço reservado para título da guia"
// theme.--sjs-special-red: "Error messages" => "Mensagens de erro"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Um texto de fallback para títulos de guia que se aplica quando o padrão de título de guia não produz um valor significativo."
// theme.fontColor: "Font color" => "Cor da fonte"
// theme.backgroundColor: "Background color" => "Cor de fundo"
// pe.questionTitleWidth: "Question title width" => "Largura do título da pergunta"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Selecione um arquivo ou cole um link de arquivo..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Ex.: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Define largura consistente para títulos de perguntas quando eles estão alinhados à esquerda de suas caixas de perguntas. Aceita valores CSS (px, %, in, pt, etc.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Define largura consistente para títulos de perguntas quando eles estão alinhados à esquerda de suas caixas de perguntas. Aceita valores CSS (px, %, in, pt, etc.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Altura da área de comentário (em linhas)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Define o número de linhas exibidas em áreas de texto para comentários de perguntas. Na entrada ocupa mais linhas, a barra de rolagem aparece."


/***/ }),

/***/ "./src/localization/russian.ts":
/*!*************************************!*\
  !*** ./src/localization/russian.ts ***!
  \*************************************/
/*! exports provided: ruStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ruStrings", function() { return ruStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var ruStrings = {
    // survey templates
    survey: {
        edit: "Редактировать",
        externalHelpLink: "Научиться создавать опросы",
        externalHelpLinkUrl: "Https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Пожалуйста, перетяните необходимый элемент из панели слева",
        addLogicItem: "Создайте правило для настройки потока опроса.",
        copy: "Копировать",
        duplicate: "Дублировать",
        addToToolbox: "Добавить к инструментам",
        deletePanel: "Удалить панель",
        deleteQuestion: "Удалить вопрос",
        convertTo: "Преобразовать в",
        drag: "Перетянуть элемент",
    },
    // Creator tabs
    tabs: {
        preview: "Тестировать опросник",
        theme: "Темы",
        translation: "Перевод",
        designer: "Обзор конструктора",
        editor: "JSON редактор",
        logic: "Логика опросника"
    },
    // Question types
    qt: {
        default: "По умолчанию",
        checkbox: "Множественный выбор",
        comment: "Комментарий",
        imagepicker: "Выбор изображения",
        ranking: "Ранжирование",
        image: "Образ",
        dropdown: "Выпадающий список",
        tagbox: "Выпадающий список с множественным выбором",
        file: "Загрузка файлов",
        html: ".HTML",
        matrix: "Матрица (единичный выбор)",
        matrixdropdown: "Матрица (множественный выбор)",
        matrixdynamic: "Матрица (динамические ряды)",
        multipletext: "Multiple Textboxes",
        panel: "Панель (для группы вопросов)",
        paneldynamic: "Панель (динамические панели)",
        radiogroup: "Единичный выбор",
        rating: "Рейтинг (шкала)",
        text: "Текстовый ввод",
        boolean: "Булиевое значение",
        expression: "Выражение (только для чтения)",
        signaturepad: "Подпись",
        buttongroup: "Группа кнопок"
    },
    toolboxCategories: {
        general: "Общие",
        choice: "Вопросы выбора",
        text: "Вопросы для ввода текста",
        containers: "Контейнеры",
        matrix: "Матричные вопросы",
        misc: "Разное"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "По умолчанию ({0})",
        survey: "Опросник",
        settings: "Настройки опросника",
        settingsTooltip: "Открыть настройки",
        surveySettings: "Настройки опроса",
        surveySettingsTooltip: "Настройки съемки",
        themeSettings: "Настройки темы",
        themeSettingsTooltip: "Настройки темы",
        showPanel: "Панель «Показать»",
        hidePanel: "Скрыть панель",
        prevSelected: "Выберите предыдущую",
        nextSelected: "Выберите далее",
        prevFocus: "Фокусировка предыдущая",
        nextFocus: "Сосредоточьтесь на следующем",
        surveyTypeName: "Обзор",
        pageTypeName: "Страница",
        panelTypeName: "Панель",
        questionTypeName: "Вопрос",
        columnTypeName: "Столбец",
        addNewPage: "Добавить новую страницу",
        moveRight: "Прокрутить вправо",
        moveLeft: "Прокрутить влево",
        deletePage: "Удалить страницу",
        editPage: "Редактировать страницу",
        edit: "Редактировать",
        newPageName: "страница",
        newQuestionName: "вопрос",
        newPanelName: "панель",
        newTextItemName: "текст",
        defaultV2Theme: "По умолчанию",
        modernTheme: "Современный",
        defaultTheme: "По умолчанию (устаревшая)",
        testSurveyAgain: "Тестировать еще раз",
        testSurveyWidth: "Ширина опросника",
        navigateToMsg: "Вы должны были перейти к",
        saveSurvey: "Сохранить опросник",
        saveSurveyTooltip: "Сохранить опрос",
        saveTheme: "Сохранить тему",
        saveThemeTooltip: "Сохранить тему",
        jsonHideErrors: "Скрыть ошибки",
        jsonShowErrors: "Показать ошибки",
        undo: "Отменить",
        redo: "Повтор",
        undoTooltip: "Отменить последнее изменение",
        redoTooltip: "Повторите изменение",
        showMoreChoices: "Развернуть",
        showLessChoices: "Показать меньше",
        copy: "Копировать",
        cut: "Резать",
        paste: "Паста",
        copyTooltip: "Копирование выделенного фрагмента в буфер обмена",
        cutTooltip: "Вырезать выделение в буфер обмена",
        pasteTooltip: "Вставка из буфера обмена",
        options: "Параметры",
        generateValidJSON: "Сформировать валидный JSON",
        generateReadableJSON: "Сформировать читаемый JSON",
        toolbox: "Панель инструментов",
        "property-grid": "Свойства",
        toolboxFilteredTextPlaceholder: "Введите для поиска...",
        toolboxNoResultsFound: "Никаких результатов не найдено",
        propertyGridFilteredTextPlaceholder: "Введите для поиска...",
        propertyGridNoResultsFound: "Никаких результатов не найдено",
        correctJSON: "Пожалуйста, исправьте JSON.",
        surveyResults: "Результаты обследования",
        surveyResultsTable: "Как таблица",
        surveyResultsJson: "Как JSON",
        resultsTitle: "Заголовок вопроса",
        resultsName: "Название вопроса",
        resultsValue: "Значение ответа",
        resultsDisplayValue: "Отображаемое значение",
        modified: "Модифицирован",
        saving: "Сохранение",
        saved: "Сохраненный",
        propertyEditorError: "Ошибка",
        saveError: "Ошибка! Содержание редактора не сохранено.",
        translationPropertyGridTitle: "Языковые настройки",
        themePropertyGridTitle: "Настройки темы",
        translationLanguages: "Языки",
        translationDeleteLanguage: "Вы уверены, что хотите удалить все строки для этого языка?",
        translationAddLanguage: "Выберите дополнительный язык опросника",
        translationShowAllStrings: "Показывать все строки",
        translationShowUsedStringsOnly: "Используются только строки",
        translationShowAllPages: "Показывать все страницы",
        translationNoStrings: "Нет строк для перевода. Пожалуйста, измените фильтр.",
        translationExportToSCVButton: "Экспорт в CSV",
        translationImportFromSCVButton: "Импорт из CSV",
        translateUsigAI: "Автоматический перевод всех",
        translateUsigAIFrom: "Перевести с: ",
        translationDialogTitle: "Непереведенные строки",
        translationMergeLocaleWithDefault: "Объединить {0} с локалью по умолчанию",
        translationPlaceHolder: "Перевод...",
        translationSource: "Источник: ",
        translationTarget: "Цель: ",
        themeExportButton: "Экспорт",
        themeImportButton: "Импорт",
        surveyJsonExportButton: "Экспорт",
        surveyJsonImportButton: "Импорт",
        surveyJsonCopyButton: "Копировать в буфер",
        themeResetButton: "Сброс настроек темы по умолчанию",
        themeResetConfirmation: "Вы действительно хотите сбросить тему? Все ваши настройки будут потеряны.",
        themeResetConfirmationOk: "Да, сбросьте тему",
        bold: "Жирный",
        italic: "Курсив",
        underline: "Подчеркивание",
        addNewQuestion: "Добавить вопрос",
        selectPage: "Выберите страницу...",
        carryForwardChoicesCopied: "Варианты копируются из",
        choicesLoadedFromWebText: "Варианты загружаются из веб-службы.",
        choicesLoadedFromWebLinkText: "Перейдите в настройки",
        choicesLoadedFromWebPreviewTitle: "Предварительный просмотр загруженных вариантов выбора",
        htmlPlaceHolder: "HTML-контент будет здесь.",
        panelPlaceHolder: "Задайте вопрос с панели инструментов здесь.",
        surveyPlaceHolder: "Опрос пуст. Перетащите элемент с панели инструментов или нажмите кнопку ниже.",
        pagePlaceHolder: "Страница пуста. Перетащите элемент с панели инструментов или нажмите кнопку ниже.",
        imagePlaceHolder: "Перетащите изображение сюда или нажмите кнопку ниже и выберите изображение для загрузки",
        surveyPlaceHolderMobile: "Нажмите кнопку «Добавить вопрос» ниже, чтобы начать создание формы.",
        pagePlaceHolderMobile: "Нажмите кнопку «Добавить вопрос» ниже, чтобы добавить новый элемент на страницу.",
        panelPlaceHolderMobile: "Нажмите кнопку «Добавить вопрос» ниже, чтобы добавить новый элемент на панель.",
        imagePlaceHolderMobile: "Нажмите кнопку ниже и выберите изображение для загрузки",
        imageChooseImage: "Выберите изображение",
        addNewTypeQuestion: "Добавить {0}",
        chooseLogoPlaceholder: "[ЛОГОТИП]",
        choices_Item: "Пункт ",
        selectFile: "Выберите файл",
        removeFile: "Удалите файл",
        lg: {
            addNewItem: "Добавить новое правило",
            empty_tab: "Создайте правило для настройки потока опроса.",
            page_visibilityName: "Видимость страницы",
            page_enableName: "Включить (отключить) страницу",
            page_requireName: "Сделать страницу обязательной",
            panel_visibilityName: "Видимость панели",
            panel_enableName: "Панель включена/выключена",
            panel_requireName: "Сделать страницу обязательной",
            question_visibilityName: "Видимость вопроса",
            question_enableName: "Вопрос включен/выключен",
            question_requireName: "Вопрос обязательный",
            question_resetValueName: "Сбросить значение вопроса",
            question_setValueName: "Задать значение вопроса",
            column_visibilityName: "Показать (скрыть) столбец",
            column_enableName: "Включить (отключить) столбец",
            column_requireName: "Сделать столбец обязательным",
            column_resetValueName: "Сброс значения столбца",
            column_setValueName: "Задание значения столбца",
            trigger_completeName: "Опрос завершен",
            trigger_setvalueName: "Установить значение вопроса",
            trigger_copyvalueName: "Копировать значение вопроса",
            trigger_skipName: "Перейти к вопросу",
            trigger_runExpressionName: "Запустить пользовательское выражение",
            completedHtmlOnConditionName: "Пользовательский текст 'Страницы благодарности'",
            page_visibilityDescription: "Сделать страницу видимой, когда логическое выражение вернет 'true'. В противном случае сделать ее невидимой.",
            panel_visibilityDescription: "Сделать панель видимой, когда логическое выражение вернет 'true'. В противном случае сделать ее невидимой.",
            panel_enableDescription: "Сделать панель и все элементы внутри нее включенной, когда логическое выражение вернет 'true'. В противном случае оставить их отключенными.",
            question_visibilityDescription: "Сделать вопрос видимой, когда логическое выражение вернет 'true'. В противном случае сделать ее невидимой.",
            question_enableDescription: "Сделать вопрос включенным, когда логическое выражение вернет 'true'. В противном случае оставить его отключенными.",
            question_requireDescription: "Вопрос становится обязательным, когда логическое выражение вернет 'true'.",
            trigger_completeDescription: "Когда логическое выражение вернет 'true', то опрос становится завершенным и конечный пользователь видит 'Страницу благодарности'.",
            trigger_setvalueDescription: "Когда значения вопросов, которые используются в логическом выражении, изменяются и логическое выражение возвращает значение 'true', тогда на выбранный вопрос устанавливается значение.",
            trigger_copyvalueDescription: "Когда значения вопросов, которые используются в логическом выражении, изменяются и логическое выражение возвращает значение 'true', тогда значение одного выбранного вопроса копируется в другой выбранный вопрос.",
            trigger_skipDescription: "Когда логическое выражение вернет 'true', тогда опрос переходит к/фокусируется на выбранном вопросе.",
            trigger_runExpressionDescription: "Когда логическое выражение возвращает 'true',тогда выполняется пользовательское выражение. Вы можете при желании установить этот результат выражения в выбранный вопрос.",
            completedHtmlOnConditionDescription: "Если логическое выражение возвращает 'true', то текст по умолчанию для 'Страницы благодарности' изменяется на заданный.",
            itemExpressionText: "Когда выражение: '{0}' возвращает 'true'",
            itemEmptyExpressionText: "Новое правило",
            page_visibilityText: "Сделать страницу {0} видимой",
            panel_visibilityText: "Сделать панель {0} видимой",
            panel_enableText: "Сделать панель {0} включенной",
            question_visibilityText: "Сделать вопрос {0} видимым",
            question_enableText: "Сделать вопрос {0} включенным",
            question_requireText: "Сделать вопрос {0} обязательным",
            question_resetValueText: "Сброс значения для вопроса: {0}",
            question_setValueText: "присвоить значение: {1} к вопросу: {0}",
            column_visibilityText: "Сделайте видимым {0} {1} в столбце вопроса",
            column_enableText: "Сделайте столбец {0} вопроса {1} включите",
            column_requireText: "Сделайте {0} вопроса {1} обязательным для заполнения",
            column_resetValueText: "Сброс значения ячейки для столбца: {0}",
            column_setValueText: "Присвойте значение ячейки: {1} столбцу: {0}",
            setValueExpressionPlaceholder: " Выражение, результат которого будет присвоен целевому вопросу.",
            trigger_completeText: "Опрос становится завершенным",
            trigger_setvalueText: "Установить в вопрос: {0} значение {1}",
            trigger_setvalueEmptyText: "Четкое значение вопроса: {0}",
            trigger_copyvalueText: "Копировать в вопрос: {0} значение из вопроса {1}",
            trigger_skipText: "Опрос переходит к вопросу {0}",
            trigger_runExpressionText1: "Выполнить выражение: '{0}'",
            trigger_runExpressionText2: "и установить его результат в вопрос: {0}",
            completedHtmlOnConditionText: "Показывать пользовательский текст для 'Страницы благодарности'.",
            showAllQuestions: "Все вопросы",
            showAllActionTypes: "Все типы действий",
            conditions: "Состояние(я)",
            actions: "Действие(я)",
            expressionEditorTitle: "Настройка логики выражения",
            actionsEditorTitle: "Определение действий",
            deleteAction: "Действие «Удалить»",
            addNewAction: "Добавить действие",
            selectedActionCaption: "Выберите действие...",
            expressionInvalid: "Логическое выражение пустое или недействительное. Пожалуйста, исправьте его.",
            noActionError: "Пожалуйста, добавьте хотя бы одно действие.",
            actionInvalid: "Пожалуйста, исправьте проблемы в ваших действиях.",
            uncompletedRule_title: "Логические правила неполны",
            uncompletedRule_text: "Вы не выполнили некоторые логические правила. Если вы покинете вкладку сейчас, изменения будут потеряны. Вы все еще хотите покинуть вкладку, не завершив изменения?",
            uncompletedRule_apply: "Да",
            uncompletedRule_cancel: "Нет, я хочу дополнить правила"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Название панели",
            title: "Заголовок панели",
            description: "Описание панели",
            visibleIf: "Сделать панель видимой, если",
            requiredIf: "Сделайте панель обязательной, если",
            questionsOrder: "Порядок вопросов на панели",
            page: "Родительская страница",
            startWithNewLine: "Отображение панели на новой строке",
            state: "Состояние свертывания панели",
            width: "Встроенная ширина панели",
            minWidth: "Минимальная ширина панели",
            maxWidth: "Максимальная ширина панели",
            showNumber: "Номерные панели"
        },
        paneldynamic: {
            name: "Название панели",
            title: "Заголовок панели",
            description: "Описание панели",
            visibleIf: "Сделать панель видимой, если",
            requiredIf: "Сделайте панель обязательной, если",
            page: "Переместите панель на страницу",
            startWithNewLine: "Отображение панели на новой строке",
            state: "Состояние свертывания панели",
            width: "Встроенная ширина панели",
            minWidth: "Минимальная ширина панели",
            maxWidth: "Максимальная ширина панели",
            confirmDelete: "Подтвердите удаление панели",
            templateDescription: "Шаблон описания панели",
            templateTitle: "Шаблон заголовка панели",
            noEntriesText: "Пустой текст на панели",
            templateTabTitle: "Шаблон заголовка вкладки",
            tabTitlePlaceholder: "Заполнитель заголовка вкладки",
            templateVisibleIf: "Сделать отдельную панель видимой, если",
            hideNumber: "Скрытие номера панели",
            titleLocation: "Выравнивание заголовков панелей",
            descriptionLocation: "Выравнивание описания панели",
            templateTitleLocation: "Выравнивание заголовка вопроса",
            templateErrorLocation: "Выравнивание сообщений об ошибках",
            newPanelPosition: "Новое расположение панели",
            keyName: "Предотвращение дублирования ответов в следующем вопросе"
        },
        question: {
            name: "Название вопроса",
            title: "Заголовок вопроса",
            description: "Описание вопроса",
            visibleIf: "Сделайте вопрос видимым, если",
            requiredIf: "Сделайте вопрос обязательным, если",
            page: "Родительская страница",
            state: "Состояние сворачивания окна вопроса",
            hideNumber: "Скрыть номер вопроса",
            titleLocation: "Выравнивание заголовка вопроса",
            descriptionLocation: "Выравнивание описания вопроса",
            errorLocation: "Выравнивание сообщений об ошибках",
            indent: "Увеличьте внутренний отступ",
            width: "Ширина встроенного вопроса",
            minWidth: "Минимальная ширина вопроса",
            maxWidth: "Максимальная ширина вопроса",
            textUpdateMode: "Обновление значения поля ввода"
        },
        signaturepad: {
            signatureWidth: "Ширина области подписи",
            signatureHeight: "Высота области подписи",
            signatureAutoScaleEnabled: "Автоматическое масштабирование области подписи",
            showPlaceholder: "Показать замещающий текст",
            placeholder: "Замещающий текст",
            placeholderReadOnly: "Замещающий текст в режиме только для чтения или предварительного просмотра",
            allowClear: "Отображение кнопки «Очистить» в области подписи",
            penMinWidth: "Минимальная ширина пера",
            penMaxWidth: "Максимальная ширина пера",
            penColor: "Цвет обводки"
        },
        comment: {
            rows: "Высота поля ввода (в строках)"
        },
        showQuestionNumbers: "Показывать номера вопросов",
        questionStartIndex: "Начальный индекс вопроса (1, 2 или 'A', 'а')",
        expression: {
            name: "Имя выражения",
            title: "Заголовок выражения",
            description: "Описание выражения",
            expression: "Выражение"
        },
        trigger: {
            expression: "Выражение"
        },
        calculatedvalue: {
            expression: "Выражение"
        },
        // survey templates
        survey: {
            title: "Титул",
            description: "Описание опроса"
        },
        page: {
            name: "Название страницы",
            title: "Титул",
            description: "Описание страницы",
            visibleIf: "Сделайте страницу видимой, если",
            requiredIf: "Сделайте страницу обязательной, если",
            maxTimeToFinish: "Ограничение по времени завершения страницы (в секундах)",
            questionsOrder: "Порядок вопросов на странице"
        },
        matrixdropdowncolumn: {
            name: "Имя столбца",
            title: "Заголовок столбца",
            isUnique: "Предотвращение дублирования ответов",
            width: "Ширина столбца",
            minWidth: "Минимальная ширина столбца",
            rows: "Высота поля ввода (в строках)",
            visibleIf: "Сделайте столбец видимым, если",
            requiredIf: "Сделайте столбец обязательным, если",
            showInMultipleColumns: "Каждый вариант в отдельной колонке"
        },
        multipletextitem: {
            name: "Имя",
            title: "Титул"
        },
        masksettings: {
            saveMaskedValue: "Сохранение замаскированного значения в результатах опроса"
        },
        patternmask: {
            pattern: "Шаблон значения"
        },
        datetimemask: {
            min: "Минимальное значение",
            max: "Максимальное значение"
        },
        numericmask: {
            allowNegativeValues: "Разрешить отрицательные значения",
            thousandsSeparator: "Разделитель тысяч",
            decimalSeparator: "Десятичный разделитель",
            precision: "Точность значений",
            min: "Минимальное значение",
            max: "Максимальное значение"
        },
        currencymask: {
            prefix: "Префикс валюты",
            suffix: "Суффикс валюты"
        },
        imageHeight: "Высота изображения",
        imageWidth: "Ширина изображения",
        valueName: "Название пункта",
        rateDescriptionLocation: "Выравнивание меток",
        size: "Размер поля ввода (в символах)",
        cellErrorLocation: "Выравнивание сообщений об ошибках ячеек",
        apply: "Применить",
        ok: "OK",
        save: "Сохранить",
        clear: "Ясный",
        saveTooltip: "Спасать",
        cancel: "Отменить",
        set: "Набор",
        reset: "Сброс",
        change: "Менять",
        refresh: "Освежать",
        close: "Закрыть",
        delete: "Удалить",
        add: "Добавить",
        addNew: "Добавить новый",
        addItem: "Нажмите, чтобы добавить элемент...",
        removeItem: "Нажмите, чтобы удалить элемент...",
        dragItem: "Перетащите элемент",
        addOther: "Другое",
        addSelectAll: "Выбрать все пункты",
        addNone: "Ничего",
        removeAll: "Удалить все",
        edit: "Редактировать",
        back: "Вернуться без сохранения",
        backTooltip: "Возврат без экономии",
        saveAndBack: "Сохранить и вернуться",
        saveAndBackTooltip: "Сохранить и вернуть",
        doneEditing: "Договорились",
        editChoices: "Редактировать выбор",
        showChoices: "Показать варианты",
        move: "Переместить",
        empty: "<пусто>",
        emptyValue: "Значение пусто",
        fastEntry: "Быстрый вход",
        fastEntryNonUniqueError: "Значение «{0}» не уникально",
        fastEntryChoicesCountError: "Пожалуйста, ограничьте количество предметов от {0} до {1}",
        fastEntryChoicesMinCountError: "Пожалуйста, введите не менее {0} пунктов",
        fastEntryPlaceholder: "Вы можете задать данные в следующем формате:\nзначение1|текст\nзначение2",
        formEntry: "Форма входа",
        testService: "Тест услуги",
        itemSelectorEmpty: "Пожалуйста, выберите элемент",
        conditionActionEmpty: "Пожалуйста, выберите действие",
        conditionSelectQuestion: "Выберите вопрос ...",
        conditionSelectPage: "Выбрать страницу ...",
        conditionSelectPanel: "Выберите панель ...",
        conditionValueQuestionTitle: "Пожалуйста, введите/выберите значение",
        aceEditorHelp: "Нажмите Ctrl+Пробел, чтобы получить подсказки",
        aceEditorRowTitle: "Текущая строка",
        aceEditorPanelTitle: "Текущая панель",
        showMore: "Для получения более подробной информации, пожалуйста, перейдите к документации",
        assistantTitle: "Доступные вопросы",
        cellsEmptyRowsColumns: "Должен быть хотя бы один столбец или строка",
        showPreviewBeforeComplete: "Предварительный просмотр ответов перед отправкой опроса",
        overridingPropertyPrefix: "Откладывать ",
        resetToDefaultCaption: "Сброс",
        propertyIsEmpty: "Пожалуйста, введите значение",
        propertyIsNoUnique: "Пожалуйста, введите уникальное значение",
        propertyNameIsNotUnique: "Пожалуйста, введите уникальное имя",
        propertyNameIsIncorrect: "Не используйте зарезервированные слова: «элемент», «выбор», «панель», «строка».",
        listIsEmpty: "Добавьте новое условие",
        "listIsEmpty@choices": "Варианты еще не добавлены",
        "listIsEmpty@columns": "У вас еще нет столбцов",
        "listIsEmpty@rows": "У вас еще нет строк",
        "listIsEmpty@validators": "У вас еще нет правил валидации",
        "listIsEmpty@calculatedValues": "У вас еще нет пользовательских переменных",
        "listIsEmpty@triggers": "У вас еще нет триггеров",
        "listIsEmpty@navigateToUrlOnCondition": "У вас еще нет ссылок",
        "addNew@choices": "Добавить выбор",
        "addNew@columns": "Добавить новый столбец",
        "addNew@rows": "Добавить новую строку",
        "addNew@validators": "Добавить новое правило",
        "addNew@calculatedValues": "Добавить новую переменную",
        "addNew@triggers": "Добавить новый триггер",
        "addNew@navigateToUrlOnCondition": "Добавить новый URL-адрес",
        expressionIsEmpty: "Выражение - пустое",
        value: "Значение",
        text: "Текст",
        rowid: "ID строки",
        imageLink: "Ссылка на изображение",
        columnEdit: "Изменить столбец: {0}",
        itemEdit: "Редактировать элемент: {0}",
        url: "URL",
        path: "Путь",
        choicesbyurl: {
            url: "URL-адрес веб-службы",
            valueName: "Получение значений из следующего поля JSON"
        },
        titleName: "Заголовок пункта",
        imageLinkName: "Получение URL-адресов изображений из следующего поля JSON",
        allowEmptyResponse: "Разрешить пустой ответ",
        titlePlaceholder: "Введите заголовок",
        surveyTitlePlaceholder: "Введите заголовок опроса",
        pageTitlePlaceholder: "Введите заголовок страницы",
        descriptionPlaceholder: "Введите описание",
        surveyDescriptionPlaceholder: "Введите описание опроса",
        pageDescriptionPlaceholder: "Введите описание страницы",
        textWrapEnabled: "Варианты обертывания",
        showOtherItem: "Есть пункт 'Другое'",
        otherText: "Текст пункта 'Другое'",
        showNoneItem: "Нет ни одного пункта",
        showRefuseItem: "Разрешить опцию «Отказаться от ответа»",
        showDontKnowItem: "Разрешить опцию «Не знаю»",
        noneText: "Текст пункта 'Ничего'",
        showSelectAllItem: "Выбрать все пункты",
        selectAllText: "Текст пункта 'Выбрать все пункты'",
        choicesMin: "Минимальное значение для автоматически сгенерированных элементов",
        choicesMax: "Максимальное значение для автоматически сгенерированных элементов",
        choicesStep: "Разница между автоматически сгенерироваными элементами",
        name: "Название",
        title: "Заголовок",
        cellType: "Тип ячейки",
        colCount: "Количество столбцов",
        choicesOrder: "Выбрать порядок отбора",
        visible: "Отображать?",
        isRequired: "Обязательный?",
        markRequired: "Отметьте как обязательный",
        removeRequiredMark: "Снимите нужную отметку",
        isAllRowRequired: "Все строки обязательны для заполнения",
        eachRowUnique: "Предотвращение дублирования ответов в строках",
        requiredErrorText: "Это поле обязательное для заполнения",
        startWithNewLine: "Начинать с новой строки?",
        rows: "Количество строк",
        cols: "Столбцы",
        placeholder: "Заполнитель области ввода",
        showPreview: "Показать предпросмотр?",
        storeDataAsText: "Хранить содержимое файла в формате JSON как текст",
        maxSize: "Максимальный размер файла (в байтах)",
        rowCount: "Количество строк",
        columnLayout: "Макет столбцов",
        addRowLocation: "Добавить расположение кнопки строки",
        transposeData: "Транспонирование строк в столбцы",
        addRowText: "Добавить текст кнопки строки",
        removeRowText: "Удалить кнопку строки текста",
        rateMin: "Минимальный рейтинг",
        rateMax: "Максимальный рейтинг",
        rateStep: "Шаг рейтинга",
        minRateDescription: "Описание для минимального рейтинга",
        maxRateDescription: "Описание для максимального рейтинга",
        inputType: "Тип ввода",
        optionsCaption: "Параметры подписи",
        defaultValue: "Ответ по умолчанию",
        cellsDefaultRow: "Текст ячеек по умолчанию",
        surveyEditorTitle: "Настройки опросника",
        qEditorTitle: "Изменить: {0}",
        maxLength: "Максимальная длина",
        buildExpression: "Собрать",
        editExpression: "Редактировать",
        and: "и",
        or: "или",
        remove: "Переместить",
        addCondition: "добавить условие",
        emptyLogicPopupMessage: "Выберите вопрос, чтобы начать настройку условий.",
        if: "Если",
        then: "тогда",
        setToName: "Целевой вопрос",
        fromName: "Вопрос для копирования ответа",
        gotoName: "Вопрос, к которому нужно перейти",
        ruleIsNotSet: "Правило неверно",
        includeIntoResult: "Включить в результаты опроса",
        showTitle: "Показать/скрыть заголовок",
        expandCollapseTitle: "Развернуть/свернуть заголовок",
        locale: "Язык по умолчанию",
        simulator: "Выберите устройство",
        landscapeOrientation: "Альбомная",
        portraitOrientation: "Переключение в книжную ориентацию",
        mode: "Режим (редактирование/просмотр)",
        clearInvisibleValues: "Очистить невидимые значения",
        cookieName: "Имя Cookie (отключить повторное прохождение опроса локально)",
        sendResultOnPageNext: "Показать результаты опроса на странице рядом",
        storeOthersAsComment: "Хранить занчение 'Другое' в отдельном поле",
        showPageTitles: "Показывать заголовки страниц",
        showPageNumbers: "Показывать номера страниц",
        pagePrevText: "Текст в кнопке 'Предыдущая страница'",
        pageNextText: "Текст в кнопке 'Следующая страница'",
        completeText: "Текст в кнопке 'Завершить'",
        previewText: "Текст кнопки «Предварительный просмотр ответов»",
        editText: "Редактировать текст кнопки «Ответ»",
        startSurveyText: "Текст в кнопке 'Начать'",
        showNavigationButtons: "Показывать кнопки навигации (навигация по умолчанию)",
        showPrevButton: "Показывать кнопки 'Предыдущая страница' (пользователь может вернуться на предыдущую страницу)",
        firstPageIsStarted: "Первая страница опросника является стартовой страницей.",
        showCompletedPage: "Показывать страницу с текстом по завершению заполнения (HTML финальной страницы)",
        goNextPageAutomatic: "Переходить на следующую страницу автоматически при заполнении всех вопросов",
        allowCompleteSurveyAutomatic: "Автоматическое заполнение опроса",
        showProgressBar: "Показывать прогресс заполнения",
        questionTitleLocation: "Расположение заголовка вопроса",
        questionTitleWidth: "Ширина заголовка вопроса",
        requiredText: "Символ для обязательного вопроса",
        questionTitleTemplate: "Шаблон названия опроса, по умолчанию: {не} {требует} {текста}.",
        questionErrorLocation: "Размещение ошибки опроса",
        focusFirstQuestionAutomatic: "Фокусирование на первом вопросе при изменении страницы",
        questionsOrder: "Сортировка элементов на странице",
        maxTimeToFinish: "Максимальное время в секундах, чтобы заполнить опросник",
        maxTimeToFinishPage: "Максимальное время в секундах, чтобы заполнить страницу опросника",
        showTimerPanel: "Показывать панель таймера",
        showTimerPanelMode: "Показывать режим панели таймера",
        renderMode: "Режим отображения панели",
        allowAddPanel: "Разрешить добавление панели",
        allowRemovePanel: "Разрешить удаление панели",
        panelAddText: "Добавление текста на панели",
        panelRemoveText: "Удаление текста на панели",
        isSinglePage: "Показывать все элементы на одной странице",
        html: "HTML-разметка",
        setValue: "Ответ",
        dataFormat: "Формат изображения",
        allowAddRows: "Разрешить добавление строк",
        allowRemoveRows: "Разрешить удаление строк",
        allowRowsDragAndDrop: "Разрешить перетаскивание строк",
        responsiveImageSizeHelp: "Не применяется, если указана точная ширина или высота изображения.",
        minImageWidth: "Минимальная ширина изображения",
        maxImageWidth: "Максимальная ширина изображения",
        minImageHeight: "Минимальная высота изображения",
        maxImageHeight: "Максимальная высота изображения",
        minValue: "Минимальное значение",
        maxValue: "Максимальное значение",
        minLength: "Минимальная длина (в символах)",
        allowDigits: "Разрешить цифры",
        minCount: "Минимальное количество",
        maxCount: "Максимальное количество",
        regex: "Регулярное выражение",
        surveyvalidator: {
            text: "Сообщение об ошибке",
            expression: "Проверочное выражение"
        },
        totalText: "Общий текст",
        totalType: "Общий тип",
        totalExpression: "Общее выражение",
        totalDisplayStyle: "Общий стиль отображения",
        totalCurrency: "Общая валюта",
        totalFormat: "Общий формат",
        logo: "Логотип (URL-адрес или строка в кодировке base64)",
        questionsOnPageMode: "Структура опроса",
        maxTextLength: "Максимальная длина ответа (в символах)",
        maxOthersLength: "Максимальная длина комментария (в символах)",
        commentAreaRows: "Высота области комментариев (в строках)",
        autoGrowComment: "При необходимости автоматически разверните область комментариев",
        allowResizeComment: "Разрешить пользователям изменять размер текстовых областей",
        textUpdateMode: "Обновление значения текстового вопроса",
        maskType: "Тип входной маски",
        maskTypes: {
            none: "Никакой",
            patternmask: "Рисунок",
            numericmask: "Числовой",
            datetimemask: "Дата и время",
            currencymask: "Валюта"
        },
        focusOnFirstError: "Установка фокуса на первом недопустимом ответе",
        checkErrorsMode: "Запуск проверки",
        navigateToUrl: "Перейдите по URL-адресу",
        navigateToUrlOnCondition: "Динамический URL-адрес",
        completedBeforeHtml: "Разметка, показывающая, заполнил ли пользователь уже этот опрос",
        completedHtml: "Опрос Полная разметка страницы",
        completedHtmlOnCondition: "Динамический опрос Полная разметка страницы",
        loadingHtml: "Разметка, отображаемая при загрузке модели опроса",
        commentText: "Текст области комментариев",
        autocomplete: "Тип автозаполнения",
        labelTrue: "Метка «Истина»",
        labelFalse: "«Ложный» ярлык",
        allowClear: "Показать кнопку «Очистить»",
        searchMode: "Режим поиска",
        displayStyle: "Стиль отображения значений",
        format: "Форматированная строка",
        maximumFractionDigits: "Максимальное количество дробных цифр",
        minimumFractionDigits: "Минимальные дробные цифры",
        useGrouping: "Разделители группировки дисплеев",
        allowMultiple: "Разрешить несколько файлов",
        allowImagesPreview: "Предварительный просмотр изображений",
        acceptedTypes: "Допустимые типы файлов",
        waitForUpload: "Дождитесь завершения загрузки",
        needConfirmRemoveFile: "Подтвердите удаление файла",
        detailPanelMode: "Расположение панели сведений",
        minRowCount: "Минимальное количество строк",
        maxRowCount: "Максимальное количество строк",
        confirmDelete: "Подтверждение удаления строки",
        confirmDeleteText: "Подтверждающее сообщение",
        panelCount: "Начальное количество панелей",
        minPanelCount: "Минимальное количество панелей",
        maxPanelCount: "Максимальное количество панелей",
        panelsState: "Состояние расширения внутренней панели",
        panelPrevText: "Предыдущая всплывающая подсказка кнопки «Панель»",
        panelNextText: "Всплывающая подсказка кнопки «Следующая панель»",
        showRangeInProgress: "Показать индикатор выполнения",
        panelRemoveButtonLocation: "Удалить расположение кнопки «Панель»",
        hideIfRowsEmpty: "Скрыть вопрос, если нет строк",
        hideColumnsIfEmpty: "Скрытие столбцов, если строк нет",
        rateValues: "Пользовательские значения тарифов",
        rateCount: "Количество ставок",
        autoGenerate: "Как указать значения тарифов?",
        hideIfChoicesEmpty: "Скрыть вопрос, если он не содержит вариантов",
        minWidth: "Минимальная ширина (в значениях, принимаемых CSS)",
        maxWidth: "Максимальная ширина (в значениях, принимаемых CSS)",
        width: "Ширина (в значениях, принимаемых CSS)",
        showHeader: "Показать заголовки столбцов",
        horizontalScroll: "Показать горизонтальную полосу прокрутки",
        columnMinWidth: "Минимальная ширина столбца (в значениях, принимаемых CSS)",
        rowTitleWidth: "Ширина заголовка строки (в значениях, принимаемых CSS)",
        valueTrue: "Значение \"True\"",
        valueFalse: "Значение \"False\"",
        minErrorText: "Сообщение об ошибке \"Значение ниже минимального\"",
        maxErrorText: "Сообщение об ошибке «Значение превышает максимальное»",
        otherErrorText: "Сообщение об ошибке «Пустой комментарий»",
        keyDuplicationError: "Сообщение об ошибке \"Неуникальное значение ключа\"",
        minSelectedChoices: "Минимальное количество выбранных вариантов",
        maxSelectedChoices: "Максимальное количество выбранных вариантов",
        showClearButton: "Показать кнопку «Очистить»",
        logoWidth: "Ширина логотипа (в значениях, принимаемых CSS)",
        logoHeight: "Высота логотипа (в значениях, принимаемых CSS)",
        readOnly: "Только для чтения",
        enableIf: "Редактируется, если",
        emptyRowsText: "Сообщение \"Нет строк\"",
        separateSpecialChoices: "Отдельные специальные варианты («Нет», «Другое», «Выбрать все»)",
        choicesFromQuestion: "Копирование вариантов из следующего вопроса",
        choicesFromQuestionMode: "Какие варианты скопировать?",
        progressBarShowPageTitles: "Отображение заголовков страниц в индикаторе выполнения",
        progressBarShowPageNumbers: "Отображение номеров страниц в индикаторе выполнения",
        showCommentArea: "Показать область комментариев",
        commentPlaceholder: "Заполнитель области комментариев",
        displayRateDescriptionsAsExtremeItems: "Отображение описаний скоростей в виде экстремальных значений",
        rowsOrder: "Порядок строк",
        columnsLayout: "Расположение столбцов",
        columnColCount: "Количество вложенных столбцов",
        correctAnswer: "Правильный ответ",
        defaultPanelValue: "Значения по умолчанию",
        cells: "Тексты ячеек",
        fileInputPlaceholder: "Выберите файл или вставьте ссылку на файл...",
        keyName: "Ключевая колонка",
        itemvalue: {
            visibleIf: "Сделайте опцию видимой, если",
            enableIf: "Сделайте опцию выбираемой, если"
        },
        "itemvalue@rows": {
            visibleIf: "Сделайте строку видимой, если",
            enableIf: "Сделайте строку редактируемой, если"
        },
        imageitemvalue: {
            text: "Замещающий текст"
        },
        logoPosition: "Местоположение логотипа",
        addLogo: "Добавить логотип...",
        changeLogo: "Изменить логотип...",
        logoPositions: {
            none: "Разместить логотип",
            left: "Слева",
            right: "Справа",
            top: "Сверху",
            bottom: "Снизу"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Компоновка панелей"
            },
            general: "Общие",
            fileOptions: "Параметры",
            html: "HTML-редактор",
            columns: "Столбцы",
            rows: "Строки",
            choices: "Выбор",
            items: "Элементы",
            visibleIf: "Отображать, если",
            enableIf: "Доступен, если",
            requiredIf: "Обязателен для заполнения, если",
            rateValues: "Оценить важность(вес) вопроса",
            choicesByUrl: "Выбор из Интернета",
            matrixChoices: "Выбор по умолчанию",
            multipleTextItems: "Ввод нескольких текстовых полей",
            numbering: "Нумерация",
            validators: "Валидаторы",
            navigation: "Навигация",
            question: "Вопрос",
            pages: "Страниц",
            timer: "Таймер/Викторина",
            calculatedValues: "Расчетные значения",
            triggers: "Триггеры",
            templateTitle: "Название шаблона",
            totals: "Итоги",
            logic: "Логика",
            mask: "Настройки входной маски",
            layout: {
                panel: "Схема",
                question: "Схема",
                base: "Схема"
            },
            data: "Данные",
            validation: "Проверка",
            cells: "Ячейки",
            showOnCompleted: "Показать по завершению",
            logo: "Логотип в заголовке опросника",
            slider: "Ползун",
            expression: "Выражение",
            questionSettings: "Настройки вопроса",
            header: "Заголовок",
            background: "Фон",
            appearance: "Внешний вид",
            others: "Другие"
        },
        editProperty: "Редактировать свойство '{0}'",
        items: "[Элементы: {0}]",
        choicesVisibleIf: "Варианты доступны в следующих случаях:",
        choicesEnableIf: "Варианты можно выбрать, если:",
        columnsEnableIf: "Столбцы видны, если",
        rowsEnableIf: "Строки видны, если",
        innerIndent: "Добавление внутренних отступов",
        defaultValueFromLastRow: "Взять значения по умолчанию из последней строки",
        defaultValueFromLastPanel: "Возьмите значения по умолчанию с последней панели",
        enterNewValue: "Пожалуйста, введите значение.",
        noquestions: "В опроснике нет ни одного вопроса",
        createtrigger: "Пожалуйста, создайте триггер",
        titleKeyboardAdornerTip: "Нажмите кнопку ввода, чтобы отредактировать",
        keyboardAdornerTip: "Нажмите кнопку ввода, чтобы отредактировать элемент, нажмите кнопку удаления, чтобы удалить элемент, нажмите alt со стрелкой вверх или со стрелкой вниз, чтобы переместить элемент",
        triggerOn: "О",
        triggerMakePagesVisible: "Сделать страницы видимыми",
        triggerMakeQuestionsVisible: "Сделать элементы видимыми",
        triggerCompleteText: "Завершить опрос, если все получися.",
        triggerNotSet: "Тригер не установлен",
        triggerRunIf: "Начать, если",
        triggerSetToName: "Изменить значение",
        triggerFromName: "Скопировать значение из",
        triggerRunExpression: "Выполнить это выражение",
        triggerSetValue: "в",
        triggerGotoName: "Перейти к вопросу",
        triggerIsVariable: "Не помещать переменную в результат опросника.",
        triggerRunExpressionEmpty: "Пожалуйста, введите корректное выражение",
        emptyExpressionPlaceHolder: "Введите выражение здесь...",
        noFile: "Файл не выбран",
        clearIfInvisible: "Очистите значение, если вопрос становится скрытым",
        valuePropertyName: "Имя свойства value",
        searchEnabled: "Включить поиск",
        hideSelectedItems: "Скрытие выбранных элементов",
        closeOnSelect: "Закрыть раскрывающийся список после выбора",
        verticalAlign: "Выравнивание по вертикали",
        alternateRows: "Чередующиеся строки",
        columnsVisibleIf: "Столбцы видны, если",
        rowsVisibleIf: "Строки видны, если",
        otherPlaceholder: "Заполнитель области комментариев",
        filePlaceholder: "Замещающий текст файла",
        photoPlaceholder: "Замещающий текст фотографии",
        fileOrPhotoPlaceholder: "Замещающий текст файла или фотографии",
        rateType: "Тип тарифа",
        url_placeholder: "Пример: https://api.example.com/books",
        path_placeholder: "Пример: categories.fiction",
        questionStartIndex_placeholder: "Пример: а)",
        width_placeholder: "Пример: 6 дюймов",
        minWidth_placeholder: "Пример: 600px",
        maxWidth_placeholder: "Пример: 50%",
        imageHeight_placeholder: "Авто",
        imageWidth_placeholder: "Авто",
        theme: {
            themeName: "Тема",
            isPanelless: "Внешний вид вопроса",
            editorPanel: "Радиус фона и угла",
            questionPanel: "Радиус фона и угла",
            primaryColor: "Акцентный цвет",
            panelBackgroundTransparency: "Непрозрачность фона панели",
            questionBackgroundTransparency: "Непрозрачность фона вопроса",
            fontSize: "Размер шрифта",
            scale: "Шкала",
            cornerRadius: "Радиус закругления угла",
            pageTitle: "Шрифт заголовка",
            pageDescription: "Описание шрифта",
            questionTitle: "Шрифт заголовка",
            questionDescription: "Описание шрифта",
            editorFont: "Шрифт",
            backgroundOpacity: "Непрозрачность",
            "--sjs-font-family": "Семейство шрифтов",
            "--sjs-general-backcolor-dim": "Цвет фона",
            "--sjs-primary-backcolor": "Акцентный фон",
            "--sjs-primary-forecolor": "Акцент на переднем плане",
            "--sjs-special-red": "Сообщения об ошибках",
            "--sjs-shadow-small": "Эффекты теней",
            "--sjs-shadow-inner": "Эффекты теней",
            "--sjs-border-default": "Знамя"
        },
        "header@header": {
            headerView: "Вид",
            logoPosition: "Расположение логотипа",
            surveyTitle: "Шрифт заголовка опроса",
            surveyDescription: "Шрифт описания опроса",
            headerTitle: "Шрифт заголовка опроса",
            headerDescription: "Шрифт описания опроса",
            inheritWidthFrom: "Ширина области содержимого",
            textAreaWidth: "Ширина текста",
            backgroundColorSwitch: "Цвет фона",
            backgroundImage: "Фоновое изображение",
            backgroundImageOpacity: "Непрозрачность",
            overlapEnabled: "Перекрытие",
            logoPositionX: "Расположение логотипа",
            titlePositionX: "Титульная позиция",
            descriptionPositionX: "Описание позиции"
        }
    },
    // Property values
    pv: {
        "true": "истинный",
        "false": "ложный",
        file: "Локальные файлы",
        camera: "Камера",
        "file-camera": "Локальные файлы или камера",
        inherit: "Наследовать",
        show: "Показать",
        hide: "Скрыть",
        default: "По умолчанию",
        initial: "Изначальный порядок",
        random: "Случайный порядок",
        collapsed: "Прерван",
        expanded: "Расширен",
        none: "Нет",
        asc: "По возрастанию",
        desc: "По убыванию",
        indeterminate: "Неопределенный",
        selected: "Выбранный",
        unselected: "Невыбранных",
        decimal: "десятичный",
        currency: "валюта",
        percent: "процент",
        firstExpanded: "Расширен первый",
        off: "Выключить",
        list: "Список",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        tab: "Вкладки",
        horizontal: "Горизонтально",
        vertical: "Вертикально",
        top: "Сверху",
        bottom: "Снизу",
        topBottom: "Сверху и снизу",
        both: "Оба",
        left: "Слева",
        right: "Правильно",
        center: "Центр",
        leftRight: "Влево и вправо",
        middle: "Середина",
        color: "Цвет",
        date: "дата",
        datetime: "ДатаТайм",
        "datetime-local": "datetime-local",
        email: "Отправить по электронной почте",
        month: "месяц",
        number: "число",
        password: "пароль",
        range: "диапазон",
        tel: "Тель",
        text: "СМС",
        time: "Время",
        url: "URL-адрес",
        week: "неделя",
        hidden: "Скрыт",
        edit: "Редактирование",
        display: "Просмотр",
        contain: "Содержать",
        cover: "Крышка",
        fill: "Заполнять",
        next: "Следующий",
        last: "Последний",
        onComplete: "По завершению",
        onHidden: "По скрытию",
        onHiddenContainer: "Когда вопрос или его панель/страница становятся скрытыми",
        clearInvisibleValues: {
            none: "Никогда"
        },
        clearIfInvisible: {
            none: "Никогда"
        },
        inputType: {
            color: "Цвет",
            date: "Дата",
            "datetime-local": "Дата и время",
            email: "Отправить по электронной почте",
            month: "Месяц",
            number: "Число",
            password: "Пароль",
            range: "Диапазон",
            tel: "Номер телефона",
            text: "СМС",
            time: "Время",
            url: "URL-адрес",
            week: "Неделя"
        },
        all: "Все",
        page: "Страница",
        survey: "Опрос",
        onNextPage: "При переходе на следующую страницу",
        onValueChanged: "При изменении значения",
        onValueChanging: "Прежде чем ответ будет изменен",
        questionsOnPageMode: {
            standard: "Оригинальная структура",
            singlePage: "Показать все вопросы на одной странице",
            questionPerPage: "Показывать один вопрос на странице"
        },
        noPreview: "Без предварительного просмотра",
        showAllQuestions: "Показать все вопросы",
        showAnsweredQuestions: "Показывать только ответы на вопросы",
        pages: "Заполненные страницы",
        questions: "Ответы на вопросы",
        requiredQuestions: "Ответы на необходимые вопросы",
        correctQuestions: "Правильные ответы",
        buttons: "Завершенные страницы (пользовательский интерфейс кнопки)",
        underInput: "Под входом",
        underTitle: "Под заголовком",
        onBlur: "О размытии",
        onTyping: "При наборе текста",
        underRow: "Под строкой",
        underRowSingle: "Под строкой видна только одна панель",
        auto: "Авто",
        showNavigationButtons: {
            none: "Скрытый"
        },
        showTimerPanel: {
            none: "Скрытый"
        },
        showTimerPanelMode: {
            all: "Оба"
        },
        addRowLocation: {
            default: "Зависит от компоновки матрицы"
        },
        panelsState: {
            default: "Пользователи не могут разворачивать или сворачивать панели",
            collapsed: "Все панели свернуты",
            expanded: "Все панели расширены",
            firstExpanded: "Первый расширенный"
        },
        widthMode: {
            static: "Статический",
            responsive: "Отзывчивый"
        },
        contentMode: {
            image: "Образ",
            video: "Видео",
            youtube: "Ютуб"
        },
        displayMode: {
            buttons: "Кнопки",
            dropdown: "Выпадающий список"
        },
        rateColorMode: {
            default: "По умолчанию",
            scale: "Шкала"
        },
        scaleColorMode: {
            monochrome: "Монохромный",
            colored: "Цветной"
        },
        autoGenerate: {
            "true": "Порождать",
            "false": "Ввод вручную"
        },
        rateType: {
            labels: "Метки",
            stars: "Звезды",
            smileys: "Смайлики"
        },
        state: {
            default: "Запертый"
        },
        showQuestionNumbers: {
            default: "Автоматическая нумерация",
            on: "Автоматическая нумерация",
            onPage: "Сброс на каждой странице",
            onpanel: "Сброс на каждой панели",
            onPanel: "Сброс на каждой панели",
            onSurvey: "Продолжить опрос",
            off: "Без нумерации"
        },
        descriptionLocation: {
            underTitle: "Под заголовком вопроса",
            underInput: "Под полем ввода"
        },
        selectToRankAreasLayout: {
            horizontal: "Рядом с вариантами выбора",
            vertical: "Вышеуказанные варианты"
        },
        displayStyle: {
            decimal: "Десятичный",
            currency: "Валюта",
            percent: "Процент",
            date: "Дата"
        },
        totalDisplayStyle: {
            decimal: "Десятичный",
            currency: "Валюта",
            percent: "Процент",
            date: "Дата"
        },
        rowsOrder: {
            initial: "Исходный текст"
        },
        questionsOrder: {
            initial: "Исходный текст"
        },
        showProgressBar: {
            off: "Скрытый",
            topbottom: "Сверху и снизу",
            aboveheader: "Над заголовком",
            belowheader: "Под заголовком"
        },
        sum: "Сумма",
        count: "Считать",
        min: "Мин",
        max: "Макс",
        avg: "Средняя",
        searchMode: {
            contains: "Содержит",
            startsWith: "Начинается с"
        },
        backgroundImageFit: {
            auto: "Авто",
            cover: "Заполнение",
            contain: "По размеру",
            fill: "Растянуть",
            tile: "Замостить"
        },
        backgroundImageAttachment: {
            fixed: "Зафиксировать",
            scroll: "Прокручивать"
        },
        headerView: {
            basic: "Основной",
            advanced: "Продвинутый"
        },
        inheritWidthFrom: {
            survey: "То же, что и опрос",
            container: "Подходит для контейнера"
        },
        backgroundColorSwitch: {
            none: "Никакой",
            accentColor: "Акцентный цвет",
            custom: "Обычай"
        },
        colorPalette: {
            light: "Свет",
            dark: "Темный"
        },
        isPanelless: {
            "false": "По умолчанию",
            "true": "Без панелей"
        }
    },
    // Operators
    op: {
        empty: "не заполнено",
        notempty: "заполнено",
        equal: "равно",
        notequal: "не равно",
        contains: "содержит",
        notcontains: "не содержит",
        anyof: "любой из",
        allof: "все из",
        greater: "больше",
        less: "меньше",
        greaterorequal: "больше или равно",
        lessorequal: "меньше или равно",
        and: "и",
        or: "или"
    },
    // Embed window
    ew: {
        angular: "Используйте версию Angular",
        jquery: "Используйте версию jQuery",
        knockout: "Используйте версию Knockout",
        react: "Используйте версию React",
        vue: "Используйте версию Vue",
        bootstrap: "Для библиотеки bootstrap",
        modern: "Современная тема",
        default: "Тема по умолчанию",
        orange: "Оранжевая тема",
        darkblue: "Темно-синяя тема",
        darkrose: "Тема \"Темная роза\"",
        stone: "Тема «Камень»",
        winter: "Зимняя тематика",
        winterstone: "Тема \"Зимний камень\"",
        showOnPage: "Показывать опросник на странице",
        showInWindow: "Показывать опросник в модальном окне",
        loadFromServer: "Загрузить Json опросника с сервера",
        titleScript: "Скрипты и стили",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Выберите страницу, чтобы проверить это",
        showInvisibleElements: "Показывать скрытые элементы",
        hideInvisibleElements: "Скрыть невидимые элементы"
    },
    validators: {
        answercountvalidator: "Количество ответов",
        emailvalidator: "Отправить по электронной почте",
        expressionvalidator: "Выражение",
        numericvalidator: "Число",
        regexvalidator: "Регулярное выражение",
        textvalidator: "Текст"
    },
    triggers: {
        completetrigger: "Завершить опрос",
        setvaluetrigger: "Установить значение",
        copyvaluetrigger: "Скопировать значение",
        skiptrigger: "Перейти к вопросу",
        runexpressiontrigger: "Запустить выражение",
        visibletrigger: "Изменить видимость (не рекомендуется)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Пример: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Пример: мм/дд/гггг"
        },
        currencymask: {
            prefix: "Пример: $",
            suffix: "Пример: USD"
        },
        panelbase: {
            questionTitleWidth: "Пример: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "Идентификатор панели, который не виден респондентам.",
            description: "Введите субтитры панели.",
            visibleIf: "Используйте значок волшебной палочки, чтобы задать условное правило, определяющее видимость панели.",
            enableIf: "Используйте значок волшебной палочки, чтобы задать условное правило, которое отключает режим только для чтения для панели.",
            requiredIf: "Используйте значок волшебной палочки, чтобы задать условное правило, которое запрещает отправку опроса, если хотя бы один вложенный вопрос не содержит ответа.",
            questionTitleLocation: "Применяется ко всем вопросам в этой панели. Если вы хотите переопределить этот параметр, определите правила выравнивания заголовков для отдельных вопросов. Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса («Сверху» по умолчанию).",
            questionTitleWidth: "Задает одинаковую ширину заголовков вопросов, если они выровнены по левому краю полей вопросов. Принимает значения CSS (px, %, in, pt и т. д.).",
            questionErrorLocation: "Задает расположение сообщения об ошибке по отношению ко всем вопросам на панели. Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса.",
            questionsOrder: "Сохраняет исходный порядок вопросов или рандомизирует их. Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса.",
            page: "Перемещает панель в конец выбранной страницы.",
            innerIndent: "Добавляет пространство или поле между содержимым панели и левой границей рамки панели.",
            startWithNewLine: "Снимите флажок, чтобы отобразить панель в одной строке с предыдущим вопросом или панелью. Этот параметр не применяется, если панель является первым элементом формы.",
            state: "Выберите из: «Развернутая» - панель отображается полностью и может быть свернута; «Свернутая» - панель отображает только заголовок и описание и может быть развернута; «Заблокировано» - панель отображается полностью и не может быть свернута.",
            width: "Устанавливает ширину панели пропорционально другим элементам съемки в той же линии. Принимает значения CSS (px, %, in, pt и т. д.)."
        },
        paneldynamic: {
            name: "Идентификатор панели, который не виден респондентам.",
            description: "Введите субтитры панели.",
            visibleIf: "Используйте значок волшебной палочки, чтобы задать условное правило, определяющее видимость панели.",
            enableIf: "Используйте значок волшебной палочки, чтобы задать условное правило, которое отключает режим только для чтения для панели.",
            requiredIf: "Используйте значок волшебной палочки, чтобы задать условное правило, которое запрещает отправку опроса, если хотя бы один вложенный вопрос не содержит ответа.",
            templateTitleLocation: "Применяется ко всем вопросам в этой панели. Если вы хотите переопределить этот параметр, определите правила выравнивания заголовков для отдельных вопросов. Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса («Сверху» по умолчанию).",
            templateErrorLocation: "Задает расположение сообщения об ошибке по отношению к вопросу с недопустимыми входными данными. Выберите между: «Сверху» - текст ошибки размещается в верхней части поля вопроса; «Внизу» - текст ошибки размещается в нижней части окна вопроса. Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса («Сверху» по умолчанию).",
            errorLocation: "Задает расположение сообщения об ошибке по отношению ко всем вопросам на панели. Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса.",
            page: "Перемещает панель в конец выбранной страницы.",
            innerIndent: "Добавляет пространство или поле между содержимым панели и левой границей рамки панели.",
            startWithNewLine: "Снимите флажок, чтобы отобразить панель в одной строке с предыдущим вопросом или панелью. Этот параметр не применяется, если панель является первым элементом формы.",
            state: "Выберите из: «Развернутая» - панель отображается полностью и может быть свернута; «Свернутая» - панель отображает только заголовок и описание и может быть развернута; «Заблокировано» - панель отображается полностью и не может быть свернута.",
            width: "Устанавливает ширину панели пропорционально другим элементам съемки в той же линии. Принимает значения CSS (px, %, in, pt и т. д.).",
            templateTitle: "Введите шаблон для динамических заголовков панелей. Используйте {panelIndex} для общего положения панели и {visiblePanelIndex} для ее порядка среди видимых панелей. Вставьте эти заполнители в шаблон, чтобы добавить автоматическую нумерацию.",
            templateTabTitle: "Введите шаблон для заголовков вкладок. Используйте {panelIndex} для общего положения панели и {visiblePanelIndex} для ее порядка среди видимых панелей. Вставьте эти заполнители в шаблон, чтобы добавить автоматическую нумерацию.",
            tabTitlePlaceholder: "Резервный текст для заголовков вкладок, который применяется, когда шаблон заголовка вкладки не дает осмысленного значения.",
            templateVisibleIf: "Этот параметр позволяет управлять видимостью отдельных панелей внутри динамической панели. Используйте заполнитель '{panel}' для ссылки на текущую панель в выражении.",
            titleLocation: "Этот параметр автоматически наследуется всеми вопросами на этой панели. Если вы хотите переопределить этот параметр, определите правила выравнивания заголовков для отдельных вопросов. Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса («Сверху» по умолчанию).",
            descriptionLocation: "Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса («Под заголовком панели» по умолчанию).",
            newPanelPosition: "Определяет положение вновь добавляемой панели. По умолчанию новые панели добавляются в конец. Выберите «Далее», чтобы вставить новую панель после текущей.",
            defaultValueFromLastPanel: "Дублирует ответы с последней панели и назначает их следующей добавленной динамической панели.",
            keyName: "Укажите имя вопроса, чтобы пользователь мог предоставить уникальный ответ на этот вопрос на каждой панели."
        },
        defaultValueExpression: "Этот параметр позволяет назначить значение ответа по умолчанию на основе выражения. Выражение может включать в себя базовые вычисления - '{q1_id} + {q2_id}', логические выражения, такие как '{age} > 60', и функции: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и т.д. Значение, определяемое этим выражением, служит начальным значением по умолчанию, которое может быть переопределено ручным вводом респондентом.",
        resetValueIf: "Используйте значок волшебной палочки, чтобы задать условное правило, определяющее, когда входные данные респондента сбрасываются до значения, основанного на «Выражении значения по умолчанию» или «Выражении заданного значения» или на значении «Ответ по умолчанию» (если оно задано).",
        setValueIf: "Используйте значок волшебной палочки, чтобы задать условное правило, которое определяет, когда запускать выражение «Задать значение» и динамически назначать полученное значение в качестве ответа.",
        setValueExpression: "Укажите выражение, определяющее значение, которое будет установлено при выполнении условий правила \"Задать значение если\". Выражение может включать в себя базовые вычисления - '{q1_id} + {q2_id}', логические выражения, такие как '{age} > 60', и функции: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и т.д. Значение, определенное этим выражением, может быть переопределено ручным вводом респондента.",
        question: {
            name: "Идентификатор вопроса, который не виден респондентам.",
            description: "Введите подзаголовок вопроса.",
            visibleIf: "Используйте значок волшебной палочки, чтобы задать условное правило, определяющее видимость вопроса.",
            enableIf: "Используйте значок волшебной палочки, чтобы задать условное правило, которое отключает режим только для чтения для вопроса.",
            requiredIf: "Используйте значок волшебной палочки, чтобы установить условное правило, которое запрещает продвижение или отправку опроса, если на вопрос не получен ответ.",
            startWithNewLine: "Снимите флажок, чтобы отобразить вопрос в одной строке с предыдущим вопросом или панелью. Настройка не применяется, если вопрос является первым элементом формы.",
            page: "Перемещает вопрос в конец выбранной страницы.",
            state: "Выберите один из вариантов: «Развернутый» - окно вопроса отображается полностью и может быть свернуто; «Свернутый» - поле вопроса отображает только заголовок и описание и может быть развернуто; «Заблокировано» - поле вопроса отображается полностью и не может быть свернуто.",
            titleLocation: "Переопределяет правила выравнивания заголовков, заданные на уровне панели, страницы или опроса. Опция «Наследовать» применяет любые настройки более высокого уровня (если они установлены) или настройки уровня опроса («Сверху» по умолчанию).",
            descriptionLocation: "Опция «Наследовать» применяет настройку на уровне опроса (по умолчанию «Под заголовком вопроса»).",
            errorLocation: "Задает расположение сообщения об ошибке по отношению к вопросу с недопустимыми входными данными. Выберите между: «Сверху» - текст ошибки размещается в верхней части поля вопроса; «Внизу» - текст ошибки размещается в нижней части окна вопроса. Опция «Наследовать» применяет настройку уровня опроса («Сверху» по умолчанию).",
            indent: "Добавляет пробел или поле между содержимым вопроса и левой границей поля вопроса.",
            width: "Устанавливает ширину вопроса пропорционально другим элементам опроса в той же строке. Принимает значения CSS (px, %, in, pt и т. д.).",
            surveyvalidator: {
                expression: "Используйте значок волшебной палочки, чтобы задать правило проверки для вопроса."
            },
            textUpdateMode: "Выберите из: \"При потере фокуса\" - значение обновляется при потере фокуса полем ввода; \"Во время набора\" - значение обновляется в режиме реального времени, по мере набора текста пользователями. Опция «Наследовать» применяет настройку на уровне опроса (по умолчанию «При потере фокуса»).",
            url: "Вы можете использовать любую веб-службу в качестве источника данных для вопросов с несколькими вариантами ответов. Чтобы заполнить значения выбора, введите URL-адрес службы, предоставляющей данные.",
            searchMode: "Операция сравнения, используемая для фильтрации раскрывающегося списка.",
            textWrapEnabled: "Длинные тексты в параметрах выбора будут автоматически создавать разрывы строк в соответствии с раскрывающимся меню. Снимите флажок, если вы хотите, чтобы тексты были обрезаны."
        },
        signaturepad: {
            signatureWidth: "Задает ширину отображаемой области подписи и результирующего изображения.",
            signatureHeight: "Задает высоту отображаемой области подписи и результирующего изображения.",
            signatureAutoScaleEnabled: "Выберите, хотите ли вы, чтобы область подписи занимала все доступное пространство в поле вопроса, сохраняя при этом соотношение сторон по умолчанию 3:2. Если заданы пользовательские значения ширины и высоты, при этом будет сохранено соотношение сторон этих размеров."
        },
        file: {
            imageHeight: "Настройка высоты изображения в результатах съемки.",
            imageWidth: "Настройка ширины изображения в результатах съемки."
        },
        image: {
            contentMode: "Опция \"Авто\" автоматически определяет подходящий режим отображения - Изображение, Видео или YouTube - на основе предоставленного исходного URL-адреса."
        },
        imagepicker: {
            imageHeight: "Переопределяет минимальное и максимальное значения высоты.",
            imageWidth: "Переопределяет минимальное и максимальное значения ширины.",
            choices: "«Значение» служит идентификатором элемента, используемым в условных правилах; Респондентам отображается «Текст».",
            contentMode: "Выберите между «Изображением» и «Видео», чтобы установить режим содержимого селектора мультимедиа. Если выбран параметр «Изображение», убедитесь, что все предоставленные параметры представляют собой файлы изображений в следующих форматах: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Точно так же, если выбран «Видео», убедитесь, что все параметры являются прямыми ссылками на видеофайлы в следующих форматах: MP4, MOV, WMV, FLV, AVI, MKV. Обратите внимание, что ссылки на YouTube не поддерживаются для параметров видео."
        },
        text: {
            size: "Этот параметр изменяет только размер поля ввода и не влияет на ширину поля вопроса. Чтобы ограничить допустимую длину ввода, перейдите в <b>раздел Проверка → Ограничение максимального количества символов</b>."
        },
        comment: {
            rows: "Задает количество отображаемых строк в поле ввода. Если ввод занимает больше строк, появится полоса прокрутки."
        },
        // survey templates
        survey: {
            mode: "Выберите один из следующих вариантов: «Редактируемый» - позволяет респондентам заполнять Ваш опрос; \"Только для чтения\" - отключает редактирование формы."
        },
        matrixdropdowncolumn: {
            name: "Идентификатор столбца, который не виден респондентам.",
            isUnique: "Если этот параметр включен для столбца, респондент должен предоставить уникальный ответ на каждый вопрос в этом столбце.",
            rows: "Задает количество отображаемых строк в поле ввода. Если ввод занимает больше строк, появится полоса прокрутки.",
            visibleIf: "Используйте значок волшебной палочки, чтобы задать условное правило, определяющее видимость столбцов.",
            enableIf: "Используйте значок волшебной палочки, чтобы задать условное правило, которое отключает режим только для чтения для столбца.",
            requiredIf: "Используйте значок волшебной палочки, чтобы задать условное правило, которое запрещает отправку опроса, если хотя бы один вложенный вопрос не содержит ответа.",
            showInMultipleColumns: "При выборе этого параметра создается отдельный столбец для каждого варианта выбора."
        },
        widthMode: "Выберите один из: \"Статический\" - задает фиксированную ширину; «Отзывчивый» - заставляет опрос занимать всю ширину экрана; \"Авто\" - применяет любой из двух вариантов в зависимости от используемых типов вопросов.",
        cookieName: "Файлы cookie не позволяют пользователям заполнять один и тот же опрос дважды.",
        logo: "Вставьте ссылку на изображение (без ограничений по размеру) или нажмите значок папки, чтобы просмотреть файл с компьютера (до 64 КБ).",
        logoWidth: "Задает ширину логотипа в единицах CSS (px, %, in, pt и т. д.).",
        logoHeight: "Задает высоту логотипа в единицах CSS (px, %, in, pt и т. д.).",
        logoFit: "Выберите один из следующих вариантов: \"Нет\" - изображение сохраняет свой первоначальный размер; \"Contain\" - размер изображения изменяется по размеру с сохранением его пропорций; «Обложка» - изображение заполняет всю коробку, сохраняя при этом соотношение сторон; \"Заливка\" - изображение растягивается для заполнения поля без сохранения его пропорций.",
        goNextPageAutomatic: "Выберите, хотите ли вы, чтобы опрос автоматически переходил на следующую страницу после того, как респондент ответит на все вопросы на текущей странице.",
        allowCompleteSurveyAutomatic: "Выберите, хотите ли Вы, чтобы опрос завершался автоматически после того, как респондент ответит на все вопросы.",
        showNavigationButtons: "Задает видимость и расположение кнопок навигации на странице.",
        showProgressBar: "Задает видимость и расположение индикатора выполнения. Значение «Авто» отображает индикатор выполнения над или под заголовком опроса.",
        showPreviewBeforeComplete: "Включите страницу предварительного просмотра, на которой отображаются все вопросы или только ответы на них.",
        questionTitleLocation: "Применяется ко всем вопросам в опросе. Этот параметр может быть переопределен правилами выравнивания заголовков на более низких уровнях: панели, странице или вопросе. Настройки более низкого уровня будут переопределять настройки на более высоком уровне.",
        requiredText: "Символ или последовательность символов, указывающие на то, что требуется ответ.",
        questionStartIndex: "Введите цифру или букву, с которой вы хотите начать нумерацию.",
        questionErrorLocation: "Задает расположение сообщения об ошибке по отношению к вопросу с недопустимыми входными данными. Выберите между: «Сверху» - текст ошибки размещается в верхней части поля вопроса; «Внизу» - текст ошибки размещается в нижней части окна вопроса.",
        focusFirstQuestionAutomatic: "Выберите, если вы хотите, чтобы первое поле ввода на каждой странице было готово для ввода текста.",
        questionsOrder: "Сохраняет исходный порядок вопросов или рандомизирует их. Эффект этого параметра виден только на вкладке «Предварительный просмотр».",
        maxTextLength: "Только для вопросов с вводом текста.",
        maxOthersLength: "Только для комментариев к вопросам.",
        commentAreaRows: "Задает количество отображаемых строк в текстовых областях для комментариев к вопросам. При вводе занимает больше строк, появляется полоса прокрутки.",
        autoGrowComment: "Выберите, хотите ли вы, чтобы комментарии к вопросам и вопросы с длинным текстом автоматически увеличивались в высоту в зависимости от введенной длины текста.",
        allowResizeComment: "Только для комментариев к вопросам и вопросов с длинным текстом.",
        calculatedValues: "Пользовательские переменные служат промежуточными или вспомогательными переменными, используемыми в вычислениях формы. Они принимают входные данные респондента в качестве исходных значений. Каждая пользовательская переменная имеет уникальное имя и выражение, на котором она основана.",
        includeIntoResult: "Выберите, если вы хотите, чтобы вычисленное значение выражения сохранялось вместе с результатами опроса.",
        triggers: "Триггер — это событие или условие, основанное на выражении. После того, как выражение оценивается как \"true\", триггер запускает действие. Такое действие может иметь целевой вопрос, на который оно влияет.",
        clearInvisibleValues: "Выберите, нужно ли очищать значения для вопросов, скрытых условной логикой, и когда это делать.",
        textUpdateMode: "Выберите из: \"При потере фокуса\" - значение обновляется при потере фокуса полем ввода; \"Во время набора\" - значение обновляется в режиме реального времени, по мере набора текста пользователями.",
        columns: "Левое значение служит идентификатором столбца, используемым в условных правилах, правое значение отображается респондентам.",
        rows: "Левое значение служит идентификатором строки, используемым в условных правилах, правое значение отображается респондентам.",
        columnMinWidth: "Принимает значения CSS (px, %, in, pt и т. д.).",
        rowTitleWidth: "Принимает значения CSS (px, %, in, pt и т. д.).",
        totalText: "Отображается только в том случае, если хотя бы один столбец имеет тип Total или выражение Total.",
        cellErrorLocation: "Задает местоположение сообщения об ошибке по отношению к ячейке с недопустимыми входными данными. Опция «Наследовать» применяет настройку из свойства «Выравнивание сообщений об ошибках».",
        keyDuplicationError: "Если включено свойство «Не допускать дублирования ответов», респондент, пытающийся отправить дублирующуюся запись, получит следующее сообщение об ошибке.",
        totalExpression: "Позволяет вычислять итоговые значения на основе выражения. Выражение может включать базовые вычисления ('{q1_id} + {q2_id}'), логические выражения ('{age} > 60') и функции ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и т.д.).",
        confirmDelete: "Запускает запрос на подтверждение удаления строки.",
        defaultValueFromLastRow: "Дублирует ответы из последней строки и присваивает их следующей добавленной динамической строке.",
        keyName: "Если указанный столбец содержит одинаковые значения, опрос выдает ошибку «Неуникальное значение ключа».",
        description: "Введите субтитры.",
        locale: "Выберите язык, чтобы начать создание опроса. Чтобы добавить перевод, переключитесь на новый язык и переведите исходный текст здесь или во вкладке «Переводы».",
        detailPanelMode: "Задает расположение раздела сведений по отношению к строке. Выберите один из вариантов: \"Нет\" - расширение не добавляется; \"Под строкой\" - под каждой строкой матрицы помещается расширение строки; \"Под строкой отображать только одну строку\" - расширение отображается только под одной строкой, остальные расширения строк сворачиваются.",
        imageFit: "Выберите один из следующих вариантов: \"Нет\" - изображение сохраняет свой первоначальный размер; \"Contain\" - размер изображения изменяется по размеру с сохранением его пропорций; «Обложка» - изображение заполняет всю коробку, сохраняя при этом соотношение сторон; \"Заливка\" - изображение растягивается для заполнения поля без сохранения его пропорций.",
        autoGrow: "Постепенно увеличивает высоту поля ввода по мере ввода данных. Переопределяет настройку «Высота поля ввода (в строках)».",
        allowResize: "Маркер изменения размера (или ручка) отображается в углу, и его можно перетащить, чтобы изменить размер поля ввода.",
        maxTimeToFinish: "Интервал времени в секундах, по истечении которого опрос автоматически переходит на страницу благодарности.",
        maxTimeToFinishPage: "Интервал времени в секундах, по истечении которого опрос автоматически переходит на следующую страницу.",
        page: {
            maxTimeToFinish: "Интервал времени в секундах, по истечении которого опрос автоматически переходит на следующую страницу.",
            visibleIf: "Используйте значок волшебной палочки, чтобы задать условное правило, определяющее видимость страницы.",
            enableIf: "Используйте значок волшебной палочки, чтобы задать условное правило, которое отключает режим только для чтения для страницы.",
            requiredIf: "Используйте значок волшебной палочки, чтобы задать условное правило, которое запрещает отправку опроса, если хотя бы один вложенный вопрос не содержит ответа.",
            questionTitleLocation: "Относится ко всем вопросам на этой странице. Если вы хотите переопределить этот параметр, задайте правила выравнивания заголовков для отдельных вопросов или панелей. Опция «Наследовать» применяет настройку уровня опроса («Сверху» по умолчанию).",
            questionTitleWidth: "Задает одинаковую ширину заголовков вопросов, если они выровнены по левому краю полей вопросов. Принимает значения CSS (px, %, in, pt и т. д.).",
            questionErrorLocation: "Задает расположение сообщения об ошибке по отношению к вопросу с недопустимыми входными данными. Выберите между: «Сверху» - текст ошибки размещается в верхней части поля вопроса; «Внизу» - текст ошибки размещается в нижней части окна вопроса. Опция «Наследовать» применяет настройку уровня опроса («Сверху» по умолчанию).",
            questionsOrder: "Сохраняет исходный порядок вопросов или рандомизирует их. Опция «Наследовать» применяет настройку уровня опроса («Оригинал» по умолчанию). Эффект этого параметра виден только на вкладке «Предварительный просмотр».",
            navigationButtonsVisibility: "Задает видимость кнопок навигации на странице. Опция \"Наследовать\" применяет настройку уровня опроса, которая по умолчанию имеет значение \"Видимый\"."
        },
        showTimerPanel: "Задает видимость и расположение таймера на странице.",
        panelsState: "Выберите один из следующих вариантов: \"Заблокировано\" - пользователи не могут разворачивать или сворачивать панели; \"Свернуть все\" - все панели запускаются в свернутом состоянии; \"Развернуть все\" - все панели запускаются в развернутом состоянии; \"First expanded\" - изначально разворачивается только первая панель.",
        imageLinkName: "Введите имя общего свойства в массиве объектов, содержащем URL-адреса изображений или видеофайлов, которые необходимо отобразить в списке вариантов.",
        choices: "Левое значение служит идентификатором элемента, используемым в условных правилах, правое значение отображается респондентам.",
        title: "Введите понятный заголовок для отображения.",
        waitForUpload: "Гарантирует, что пользователи не завершат опрос до тех пор, пока файлы не будут загружены.",
        minWidth: "Принимает значения CSS (px, %, in, pt и т. д.).",
        maxWidth: "Принимает значения CSS (px, %, in, pt и т. д.).",
        width: "Принимает значения CSS (px, %, in, pt и т. д.).",
        valueName: "Если это свойство не задано, ответ будет сохранен в поле, указанном свойством Name.",
        useDisplayValuesInDynamicTexts: "В вопросах с одним и несколькими вариантами ответов каждый вариант выбора имеет идентификатор и отображаемое значение. Если этот параметр установлен, в HTML-вопросах, а также в динамических заголовках и описаниях элементов опроса отображается отображаемое значение, а не значение идентификатора.",
        clearIfInvisible: "Выберите, следует ли очищать значения вопросов, скрытые условной логикой, и когда это делать. Опция «Наследовать» применяет настройку на уровне опроса («По завершении опроса» по умолчанию).",
        choicesFromQuestionMode: "Выбрать из: \"Все\" - копирует все варианты выбора из выбранного вопроса; \"Выбранный\" - динамически копирует только выбранные варианты выбора; \"Невыбранные\" - динамически копирует только невыбранные варианты выбора. Опции «Нет» и «Другое» копируются по умолчанию, если они включены в исходном вопросе.",
        showOtherItem: "Если этот флажок установлен, пользователи могут включить дополнительные данные в отдельное поле комментария.",
        separateSpecialChoices: "Отображение каждого варианта специального выбора (\"Нет\", \"Другое\", \"Выбрать все\") в новой строке, даже при использовании макета с несколькими столбцами.",
        path: "Укажите местоположение в наборе данных сервиса, где находится целевой массив объектов. Оставьте пустым, если URL-адрес уже указывает на массив.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Введите единообразное имя свойства в массиве объектов, содержащем значения, которые требуется отобразить в списке вариантов.",
        allowEmptyResponse: "Выберите, чтобы разрешить службе возвращать пустой ответ или массив.",
        choicesVisibleIf: "Используйте значок волшебной палочки, чтобы задать условное правило, определяющее видимость всех вариантов выбора.",
        rateValues: "Левое значение служит идентификатором элемента, используемым в условных правилах, правое значение отображается респондентам.",
        rating: {
            displayMode: "«Авто» выбирает между режимами «Кнопки» и «Выпадающий список» в зависимости от доступной ширины. Если ширина недостаточна для отображения кнопок, в вопросе отображается раскрывающийся список."
        },
        valuePropertyName: "Позволяет соединять вопросы, дающие результаты, в разных форматах. Когда такие вопросы связаны друг с другом с помощью идентификатора соединения, в этом общем свойстве хранятся выбранные значения вопросов.",
        searchEnabled: "Выберите, хотите ли вы обновить содержимое раскрывающегося меню в соответствии с поисковым запросом, который пользователь вводит в поле ввода.",
        valueTrue: "Значение, сохраняемое в результатах опроса, когда респонденты дают положительный ответ.",
        valueFalse: "Значение, сохраняемое в результатах опроса, когда респонденты дают отрицательный ответ.",
        showPreview: "Не рекомендуется отключать этот параметр, так как он переопределяет изображение предварительного просмотра и затрудняет понимание пользователем, были ли файлы загружены.",
        needConfirmRemoveFile: "Запускает запрос на подтверждение удаления файла.",
        selectToRankEnabled: "Включите этот параметр, чтобы ранжировать только выбранные варианты. Пользователи будут перетаскивать выбранные элементы из списка вариантов, чтобы упорядочить их в области ранжирования.",
        dataList: "Введите список вариантов, которые будут предложены респонденту во время ввода.",
        itemSize: "Этот параметр изменяет только размер полей ввода и не влияет на ширину поля вопроса.",
        itemTitleWidth: "Устанавливает одинаковую ширину для всех меток элементов в пикселях",
        altText: "Служит заменой, когда изображение не может быть отображено на устройстве пользователя, а также в целях обеспечения доступности.",
        rateColorMode: "Определяет цвет выбранного эмодзи, если для параметра «Тип значка рейтинга» установлено значение «Смайлики». Выберите между: \"По умолчанию\" - выбранный эмодзи отображается в цвете опроса по умолчанию; «Шкала» - выбранный эмодзи наследует цвет от шкалы оценки.",
        expression: {
            name: "Идентификатор выражения, который не виден респондентам.",
            description: "Введите подзаголовок выражения.",
            expression: "Выражение может включать базовые вычисления ('{q1_id} + {q2_id}'), условия ('{age} > 60') и функции ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и т.д.)."
        },
        storeOthersAsComment: "Выберите, чтобы сохранить значение параметра «Другое» как отдельное свойство в результатах опроса.",
        format: "Используйте {0} в качестве заполнителя для фактического значения.",
        acceptedTypes: "Дополнительные сведения см. в описании атрибута [accept](https://www.w3schools.com/tags/att_input_accept.asp).",
        columnColCount: "Применимо только к типам ячеек «Радиогруппа» и «Флажок».",
        autocomplete: "Дополнительные сведения см. в описании атрибута [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete).",
        filePlaceholder: "Применяется, если \"Тип источника\" имеет значение \"Локальные файлы\" или когда камера недоступна",
        photoPlaceholder: "Применяется, если \"Тип источника\" имеет значение \"Камера\".",
        fileOrPhotoPlaceholder: "Применяется, если \"Тип источника\" имеет значение \"Локальные файлы или камера\".",
        masksettings: {
            saveMaskedValue: "Выберите, хотите ли вы сохранить значение вопроса с примененной маской в результатах опроса."
        },
        patternmask: {
            pattern: "Шаблон может содержать строковые литералы и следующие заполнители: '9' - для цифры; 'a' - для прописной или строчной буквы; '#' - для цифры или прописной или строчной буквы. Используйте обратную косую черту '\\' для экранирования символа."
        },
        datetimemask: {
            pattern: "Шаблон может содержать символы-разделители и следующие заполнители:<br>'m' - номер месяца.<br>'mm' - Номер месяца, с нулем в начале для однозначных значений. <br>'d' - День месяца. <br>'dd' - День месяца, с нулевым началом для однозначных значений. <br>'yy' - Последние две цифры года. <br>'yyyy' - Четырехзначный год. <br>'H' - Часы в 24-часовом формате. <br>'HH' - Часы в 24-часовом формате, с нулем в начале для однозначных значений. <br>'h' - Часы в 12-часовом формате. <br>'hh' - Часы в 12-часовом формате, с нулем в начале для однозначных значений. <br>'MM' - минуты. <br>'ss' - Секунды. <br>'TT' - 12-часовой период в верхнем регистре (AM/PM). <br>'tt' - 12-часовой период в нижнем регистре (am/pm)."
        },
        numericmask: {
            decimalSeparator: "Символ, используемый для отделения дробной части от целой части отображаемого числа.",
            thousandsSeparator: "Символ, используемый для разделения цифр большого числа на группы по три.",
            precision: "Ограничивает количество цифр, сохраняемых после десятичной запятой для отображаемого числа."
        },
        currencymask: {
            prefix: "Один или несколько символов, которые будут отображаться перед значением.",
            suffix: "Один или несколько символов, которые будут отображаться после значения."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "Название",
            title: "Оставьте его пустым, если оно такое же, как 'Название'"
        },
        multiSelect: "Разрешить множественный выбор",
        showLabel: "Показать подписи к изображениям",
        swapOrder: "Поменяйте местами «Да» и «Нет»",
        value: "Ценность",
        tabAlign: "Выравнивание табуляции",
        sourceType: "Тип источника",
        fitToContainer: "Подходит для контейнера",
        setValueExpression: "Выражение заданного значения",
        description: "Описание",
        logoFit: "Подходит под логотип",
        pages: "Страниц",
        questions: "Вопросы",
        triggers: "триггеры",
        calculatedValues: "Вычисляемые значения",
        surveyId: "Идентификатор опроса",
        surveyPostId: "Идентификатор записи опроса",
        surveyShowDataSaving: "Опрос показывает сохранение данных",
        questionDescriptionLocation: "Описание вопроса Местоположение",
        progressBarType: "Тип индикатора выполнения",
        showTOC: "Показать оглавление",
        tocLocation: "Расположение оглавления",
        questionTitlePattern: "Шаблон заголовка вопроса",
        widthMode: "Режим ширины",
        showBrandInfo: "Показать информацию о бренде",
        useDisplayValuesInDynamicTexts: "Использование отображаемых значений в динамических текстах",
        visibleIf: "Отображать, если",
        defaultValueExpression: "Выражение значения по умолчанию",
        requiredIf: "Обязателен если",
        resetValueIf: "Сбросьте значение, если",
        setValueIf: "Установите значение, если",
        validators: "Валидаторы",
        bindings: "Привязки",
        renderAs: "Рендеринг как",
        attachOriginalItems: "Прикрепите оригинальные элементы",
        choices: "Выбор",
        choicesByUrl: "Выбрать из интернета",
        currency: "Валюта",
        cellHint: "Подсказка по ячейке",
        totalMaximumFractionDigits: "Общее количество максимальных дробных цифр",
        totalMinimumFractionDigits: "Общее количество минимальных дробных цифр",
        columns: "Столбцы",
        detailElements: "Детализация элементов",
        allowAdaptiveActions: "Разрешить адаптивные действия",
        defaultRowValue: "Значение строки по умолчанию",
        detailPanelShowOnAdding: "Панель сведений, отображаемая при добавлении",
        choicesLazyLoadEnabled: "Выбор отложенной загрузки включен",
        choicesLazyLoadPageSize: "Выбор ленивой загрузки размера страницы",
        inputFieldComponent: "Компонент поля ввода",
        itemComponent: "Компонент предмета",
        min: "Мин",
        max: "Макс",
        minValueExpression: "Выражение минимального значения",
        maxValueExpression: "Выражение максимального значения",
        step: "Шаг",
        dataList: "Список данных",
        itemSize: "Размер элементов",
        itemTitleWidth: "Ширина метки элемента (в пикселях)",
        elements: "Азы",
        content: "Содержание",
        navigationButtonsVisibility: "Отображение навигационных кнопок",
        navigationTitle: "Навигационный заголовок",
        navigationDescription: "Навигационное описание",
        longTap: "Длительное нажатие",
        autoGrow: "Автоматическое выращивание",
        allowResize: "Разрешить изменение размера",
        acceptCarriageReturn: "Принять возврат каретки",
        displayMode: "Режим отображения",
        rateType: "Тип тарифа",
        label: "Ярлык",
        contentMode: "Режим содержимого",
        imageFit: "Подгонка под изображение",
        altText: "Замещающий текст",
        height: "Высота",
        penColor: "Цвет пера",
        backgroundColor: "Цвет фона",
        templateElements: "Элементы шаблона",
        operator: "Оператор",
        isVariable: "Является вариативным",
        runExpression: "Выражение \"Выполнить\"",
        showCaption: "Показать подпись",
        iconName: "Название значка",
        iconSize: "Размер значка",
        precision: "Точность",
        matrixDragHandleArea: "Область маркера перетаскивания матрицы",
        backgroundImage: "Фоновое изображение",
        backgroundImageFit: "Подгонка фонового изображения",
        backgroundImageAttachment: "Вложение фонового изображения",
        backgroundOpacity: "Непрозрачность фона",
        selectToRankEnabled: "Выберите, чтобы ранжирование включено",
        selectToRankAreasLayout: "Выберите, чтобы ранжировать макет областей",
        selectToRankEmptyRankedAreaText: "Текст, показывающий, если выбраны все параметры",
        selectToRankEmptyUnrankedAreaText: "Замещающий текст для области ранжирования",
        allowCameraAccess: "Разрешить доступ к камере",
        scaleColorMode: "Цветовой режим масштабирования",
        rateColorMode: "Оцените цветовой режим",
        copyDisplayValue: "Копирование отображаемого значения",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Расширенный режим",
        pageTitle: "Шрифт заголовка страницы",
        questionTitle: "Шрифт заголовка вопроса",
        editorPanel: "Элемент ввода",
        lines: "Обводы",
        primaryDefaultColor: "По умолчанию",
        primaryDarkColor: "Парить",
        primaryLightColor: "Выбранный",
        backgroundDimColor: "Цвет фона",
        cornerRadius: "Радиус закругления угла",
        backcolor: "Фон по умолчанию",
        hovercolor: "Фон при наведении курсора",
        borderDecoration: "Оформление бордюра",
        fontColor: "Цвет шрифта",
        backgroundColor: "Цвет фона",
        primaryForecolor: "Цвет по умолчанию",
        primaryForecolorLight: "Отключенный цвет",
        font: "Шрифт",
        borderDefault: "Темнее",
        borderLight: "Зажигалка",
        fontFamily: "Семейство шрифтов",
        fontWeightRegular: "Регулярный",
        fontWeightHeavy: "Тяжелый",
        fontWeightSemiBold: "Полужирный",
        fontWeightBold: "Смелый",
        color: "Цвет",
        placeholderColor: "Цвет заполнителя",
        size: "Размер",
        opacity: "Непрозрачность",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Добавить эффект тени",
        boxShadowBlur: "Смазывать",
        boxShadowSpread: "Распространение",
        boxShadowDrop: "Капля",
        boxShadowInner: "Внутренний",
        names: {
            default: "По умолчанию",
            sharp: "Чёткая",
            borderless: "Без границ",
            flat: "Плоская",
            plain: "Простая",
            doubleborder: "Удвоенные границы",
            layered: "Многослойная",
            solid: "Монолитная",
            threedimensional: "Трёхмерная",
            contrast: "Контрастная"
        },
        colors: {
            teal: "Бирюзовый",
            blue: "Синий",
            purple: "Пурпурный",
            orchid: "Орхидея",
            tulip: "Тюльпан",
            brown: "Коричневый",
            green: "Зеленый"
        }
    }
};
//Uncomment this line on creating a translation file. You should replace "en" and enStrings with your locale ("fr", "de" and so on) and your variable.
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["ru"] = ruStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// survey.addLogicItem: "Create a rule to customize the flow of the survey." => "Создайте правило для настройки потока опроса."
// survey.duplicate: "Duplicate" => "Дублировать"
// qt.ranking: "Ranking" => "Ранжирование"
// qt.image: "Image" => "Образ"
// qt.tagbox: "Multi-Select Dropdown" => "Выпадающий список с множественным выбором"
// qt.html: "HTML" => ".HTML"
// qt.signaturepad: "Signature" => "Подпись"
// qt.buttongroup: "Button Group" => "Группа кнопок"
// ed.settingsTooltip: "Open settings" => "Открыть настройки"
// ed.surveySettings: "Survey Settings" => "Настройки опроса"
// ed.surveySettingsTooltip: "Open survey settings" => "Откройте настройки опроса"
// ed.showPanel: "Show Panel" => "Панель «Показать»"
// ed.hidePanel: "Hide Panel" => "Скрыть панель"
// ed.prevSelected: "Select previous" => "Выберите предыдущую"
// ed.nextSelected: "Select next" => "Выберите далее"
// ed.surveyTypeName: "Survey" => "Обзор"
// ed.pageTypeName: "Page" => "Страница"
// ed.panelTypeName: "Panel" => "Панель"
// ed.questionTypeName: "Question" => "Вопрос"
// ed.columnTypeName: "Column" => "Столбец"
// ed.themeSurvey: "Themes" => "Темы"
// ed.defaultV2Theme: "Default" => "По умолчанию"
// ed.modernTheme: "Modern" => "Современный"
// ed.defaultTheme: "Default (legacy)" => "По умолчанию (устаревшая)"
// ed.navigateToMsg: "You had to navigate to" => "Вы должны были перейти к"
// ed.saveSurveyTooltip: "Save Survey" => "Сохранить опрос"
// ed.jsonHideErrors: "Hide errors" => "Скрыть ошибки"
// ed.jsonShowErrors: "Show errors" => "Показать ошибки"
// ed.undoTooltip: "Undo last change" => "Отменить последнее изменение"
// ed.redoTooltip: "Redo the change" => "Повторите изменение"
// ed.showMoreChoices: "Show more" => "Развернуть"
// ed.showLessChoices: "Show less" => "Показать меньше"
// ed.copy: "Copy" => "Копировать"
// ed.cut: "Cut" => "Резать"
// ed.paste: "Paste" => "Паста"
// ed.copyTooltip: "Copy selection to clipboard" => "Копирование выделенного фрагмента в буфер обмена"
// ed.cutTooltip: "Cut selection to clipboard" => "Вырезать выделение в буфер обмена"
// ed.pasteTooltip: "Paste from clipboard" => "Вставка из буфера обмена"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "Введите для поиска..."
// ed.toolboxChoiceCategory: "Choice Questions" => "Вопросы выбора"
// ed.toolboxTextCategory: "Text Input Questions" => "Вопросы для ввода текста"
// ed.toolboxContainersCategory: "Containers" => "Контейнеры"
// ed.toolboxMatrixCategory: "Matrix Questions" => "Матричные вопросы"
// ed.toolboxMiscCategory: "Misc" => "Разное"
// ed.propertyEditorError: "Error" => "Ошибка"
// ed.translationPropertyGridTitle: "Language Settings" => "Языковые настройки"
// ed.themePropertyGridTitle: "Theme Settings" => "Настройки темы"
// ed.translationLanguages: "Languages" => "Языки"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "Используются только строки"
// ed.themeExportButton: "Export" => "Экспорт"
// ed.themeImportButton: "Import" => "Импорт"
// ed.selectPage: "Select page..." => "Выберите страницу..."
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Варианты копируются из"
// ed.htmlPlaceHolder: "HTML content will be here." => "HTML-контент будет здесь."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "Задайте вопрос с панели инструментов здесь."
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "Опрос пуст. Перетащите элемент с панели инструментов или нажмите кнопку ниже."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Перетащите изображение сюда или нажмите кнопку ниже и выберите изображение для загрузки"
// ed.imageChooseImage: "Choose Image" => "Выберите изображение"
// ed.addNewTypeQuestion: "Add {0}" => "Добавить {0}"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[ЛОГОТИП]"
// ed.auto: "auto" => "Авто"
// ed.choices_Item: "Item " => "Пункт "
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "Создайте правило для настройки потока опроса."
// lg.page_enableName: "Enable (disable) page" => "Включить (отключить) страницу"
// lg.column_visibilityName: "Show (hide) column" => "Показать (скрыть) столбец"
// lg.column_enableName: "Enable (disable) column" => "Включить (отключить) столбец"
// lg.column_requireName: "Make column required" => "Сделать столбец обязательным"
// lg.itemEmptyExpressionText: "New rule" => "Новое правило"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "Сделайте видимым {0} {1} в столбце вопроса"
// lg.column_enableText: "make column {0} of question {1} enable" => "Сделайте столбец {0} вопроса {1} включите"
// lg.column_requireText: "make column {0} of question {1} required" => "Сделайте {0} вопроса {1} обязательным для заполнения"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "Четкое значение вопроса: {0}"
// lg.showAllQuestions: "All Questions" => "Все вопросы"
// lg.showAllActionTypes: "All Action Types" => "Все типы действий"
// lg.conditions: "Condition(s)" => "Состояние(я)"
// lg.actions: "Action(s)" => "Действие(я)"
// lg.actionsEditorTitle: "Define action(s)" => "Определение действий"
// lg.deleteAction: "Delete Action" => "Действие «Удалить»"
// lg.addNewAction: "Add Action" => "Добавить действие"
// lg.selectedActionCaption: "Select action..." => "Выберите действие..."
// lg.noActionError: "Please, add at least one action." => "Пожалуйста, добавьте хотя бы одно действие."
// lg.actionInvalid: "Please, fix problems in your action(s)." => "Пожалуйста, исправьте проблемы в ваших действиях."
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Логические правила неполны"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Вы не выполнили некоторые логические правила. Если вы покинете вкладку сейчас, изменения будут потеряны. Вы все еще хотите покинуть вкладку, не завершив изменения?"
// lg.uncompletedRule_apply: "Yes" => "Да"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Нет, я хочу дополнить правила"
// pe.clear: "Clear" => "Ясный"
// pe.saveTooltip: "Save" => "Спасать"
// pe.set: "Set" => "Набор"
// pe.change: "Change" => "Менять"
// pe.refresh: "Refresh" => "Освежать"
// pe.removeItem: "Click to remove the item..." => "Нажмите, чтобы удалить элемент..."
// pe.dragItem: "Drag the item" => "Перетащите элемент"
// pe.backTooltip: "Return without saving" => "Возврат без экономии"
// pe.saveAndBackTooltip: "Save and return" => "Сохранить и вернуть"
// pe.doneEditing: "Done" => "Договорились"
// pe.showChoices: "Show Choices" => "Показать варианты"
// pe.emptyValue: "Value is empty" => "Значение пусто"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "Значение «{0}» не уникально"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "Пожалуйста, ограничьте количество предметов от {0} до {1}"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "Вы можете задать данные в следующем формате:\nзначение1|текст\nзначение2"
// pe.conditionActionEmpty: "Please select the action" => "Пожалуйста, выберите действие"
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "Предварительный просмотр ответов перед отправкой опроса"
// pe.overridingPropertyPrefix: "Set by " => "Откладывать "
// pe.propertyIsNoUnique: "Please enter a unique value" => "Пожалуйста, введите уникальное значение"
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Не используйте зарезервированные слова: «элемент», «выбор», «панель», «строка»."
// pe.listIsEmpty@choices: "No choices have been added yet" => "Варианты еще не добавлены"
// pe.addNew@choices: "Add a choice" => "Добавить выбор"
// choicesbyurl.valueName: "Get values from the following JSON field" => "Получение значений из следующего поля JSON"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "Получение URL-адресов изображений из следующего поля JSON"
// pe.allowEmptyResponse: "Allow empty response" => "Разрешить пустой ответ"
// pe.colCount: "Column count" => "Количество столбцов"
// pe.cols: "Columns" => "Столбцы"
// pe.placeholder: "Input area placeholder" => "Заполнитель области ввода"
// pe.maxSize: "Maximum file size (in bytes)" => "Максимальный размер файла (в байтах)"
// pe.imageHeight: "Image height" => "Высота изображения"
// pe.imageWidth: "Image width" => "Ширина изображения"
// pe.defaultValue: "Default Answer" => "Ответ по умолчанию"
// pe.and: "and" => "и"
// pe.or: "or" => "или"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Выберите вопрос, чтобы начать настройку условий."
// pe.if: "If" => "Если"
// pe.then: "then" => "тогда"
// pe.setToName: "Target question" => "Целевой вопрос"
// pe.fromName: "Question to copy answer from" => "Вопрос для копирования ответа"
// pe.gotoName: "Question to skip to" => "Вопрос, к которому нужно перейти"
// pe.ruleIsNotSet: "Rule is incorrect" => "Правило неверно"
// pe.includeIntoResult: "Include into survey results" => "Включить в результаты опроса"
// pe.expandCollapseTitle: "Expand/collapse title" => "Развернуть/свернуть заголовок"
// pe.portraitOrientation: "Switch to portrait orientation" => "Переключение в книжную ориентацию"
// pe.previewText: "Preview Answers button text" => "Текст кнопки «Предварительный просмотр ответов»"
// pe.editText: "Edit Answer button text" => "Редактировать текст кнопки «Ответ»"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Высота изображения (в значениях, принимаемых CSS)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Ширина изображения (в значениях, принимаемых CSS)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "Ограничение по времени завершения страницы (в секундах)"
// question.page: "Parent page" => "Родительская страница"
// pe.renderMode: "Panel display mode" => "Режим отображения панели"
// pe.noEntriesText: "Empty entries text" => "Пустой текст записей"
// pe.html: "HTML markup" => "HTML-разметка"
// pe.setValue: "Answer" => "Ответ"
// pe.dataFormat: "Image format" => "Формат изображения"
// pe.allowAddRows: "Allow adding rows" => "Разрешить добавление строк"
// pe.allowRemoveRows: "Allow removing rows" => "Разрешить удаление строк"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "Разрешить перетаскивание строк"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "Не применяется, если указана точная ширина или высота изображения."
// pe.minImageWidth: "Minimum image width" => "Минимальная ширина изображения"
// pe.maxImageWidth: "Maximum image width" => "Максимальная ширина изображения"
// pe.minImageHeight: "Minimum image height" => "Минимальная высота изображения"
// pe.maxImageHeight: "Maximum image height" => "Максимальная высота изображения"
// pe.minLength: "Minimum length (in characters)" => "Минимальная длина (в символах)"
// surveyvalidator.text: "Error message" => "Сообщение об ошибке"
// surveyvalidator.expression: "Validation expression" => "Проверочное выражение"
// pe.logo: "Logo (URL or base64-encoded string)" => "Логотип (URL-адрес или строка в кодировке base64)"
// pe.questionsOnPageMode: "Survey structure" => "Структура опроса"
// pe.maxTextLength: "Maximum answer length (in characters)" => "Максимальная длина ответа (в символах)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "Максимальная длина комментария (в символах)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "При необходимости автоматически разверните область комментариев"
// pe.allowResizeComment: "Allow users to resize text areas" => "Разрешить пользователям изменять размер текстовых областей"
// pe.textUpdateMode: "Update text question value" => "Обновление значения текстового вопроса"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "Установка фокуса на первом недопустимом ответе"
// pe.checkErrorsMode: "Run validation" => "Запуск проверки"
// pe.navigateToUrl: "Navigate to URL" => "Перейдите по URL-адресу"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "Динамический URL-адрес"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "Разметка, показывающая, заполнил ли пользователь уже этот опрос"
// pe.completedHtml: "Survey Complete page markup" => "Опрос Полная разметка страницы"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "Динамический опрос Полная разметка страницы"
// pe.loadingHtml: "Markup to show while survey model is loading" => "Разметка, отображаемая при загрузке модели опроса"
// pe.commentText: "Comment area text" => "Текст области комментариев"
// pe.autocomplete: "Autocomplete type" => "Тип автозаполнения"
// pe.labelTrue: "\"True\" label" => "Метка «Истина»"
// pe.labelFalse: "\"False\" label" => "«Ложный» ярлык"
// pe.allowClear: "Show the Clear button" => "Показать кнопку «Очистить»"
// pe.displayStyle: "Value display style" => "Стиль отображения значений"
// pe.format: "Formatted string" => "Форматированная строка"
// pe.maximumFractionDigits: "Maximum fractional digits" => "Максимальное количество дробных цифр"
// pe.minimumFractionDigits: "Minimum fractional digits" => "Минимальные дробные цифры"
// pe.useGrouping: "Display grouping separators" => "Разделители группировки дисплеев"
// pe.allowMultiple: "Allow multiple files" => "Разрешить несколько файлов"
// pe.allowImagesPreview: "Preview images" => "Предварительный просмотр изображений"
// pe.acceptedTypes: "Accepted file types" => "Допустимые типы файлов"
// pe.waitForUpload: "Wait for the upload to complete" => "Дождитесь завершения загрузки"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "Подтвердите удаление файла"
// pe.detailPanelMode: "Detail panel location" => "Расположение панели сведений"
// pe.minRowCount: "Minimum row count" => "Минимальное количество строк"
// pe.maxRowCount: "Maximum row count" => "Максимальное количество строк"
// pe.confirmDelete: "Confirm row deletion" => "Подтверждение удаления строки"
// pe.confirmDeleteText: "Confirmation message" => "Подтверждающее сообщение"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "Подтвердите удаление панели"
// pe.panelCount: "Initial panel count" => "Начальное количество панелей"
// pe.minPanelCount: "Minimum panel count" => "Минимальное количество панелей"
// pe.maxPanelCount: "Maximum panel count" => "Максимальное количество панелей"
// pe.panelsState: "Inner panel expand state" => "Состояние расширения внутренней панели"
// pe.templateDescription: "Description template" => "Шаблон описания"
// pe.templateTitle: "Title template" => "Шаблон заголовка"
// pe.panelPrevText: "Previous Panel button tooltip" => "Предыдущая всплывающая подсказка кнопки «Панель»"
// pe.panelNextText: "Next Panel button tooltip" => "Всплывающая подсказка кнопки «Следующая панель»"
// pe.showRangeInProgress: "Show progress bar" => "Показать индикатор выполнения"
// pe.templateTitleLocation: "Question title location" => "Местоположение заголовка вопроса"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "Удалить расположение кнопки «Панель»"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "Скрыть вопрос, если нет строк"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Скрытие столбцов, если строк нет"
// pe.rateValues: "Custom rate values" => "Пользовательские значения тарифов"
// pe.rateCount: "Rate count" => "Количество ставок"
// pe.autoGenerate: "How to specify rate values?" => "Как указать значения тарифов?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "Скрыть вопрос, если он не содержит вариантов"
// pe.hideNumber: "Hide question number" => "Скрыть номер вопроса"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Минимальная ширина (в значениях, принимаемых CSS)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Максимальная ширина (в значениях, принимаемых CSS)"
// pe.width: "Width (in CSS-accepted values)" => "Ширина (в значениях, принимаемых CSS)"
// pe.showHeader: "Show column headers" => "Показать заголовки столбцов"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Показать горизонтальную полосу прокрутки"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Минимальная ширина столбца (в значениях, принимаемых CSS)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Ширина заголовка строки (в значениях, принимаемых CSS)"
// pe.valueTrue: "\"True\" value" => "Значение \"True\""
// pe.valueFalse: "\"False\" value" => "Значение \"False\""
// pe.minErrorText: "\"Value is below minimum\" error message" => "Сообщение об ошибке \"Значение ниже минимального\""
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "Сообщение об ошибке «Значение превышает максимальное»"
// pe.otherErrorText: "\"Empty comment\" error message" => "Сообщение об ошибке «Пустой комментарий»"
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "Сообщение об ошибке \"Неуникальное значение ключа\""
// pe.minSelectedChoices: "Minimum selected choices" => "Минимальное количество выбранных вариантов"
// pe.maxSelectedChoices: "Maximum selected choices" => "Максимальное количество выбранных вариантов"
// pe.showClearButton: "Show the Clear button" => "Показать кнопку «Очистить»"
// pe.showNumber: "Show panel number" => "Показать номер панели"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "Ширина логотипа (в значениях, принимаемых CSS)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "Высота логотипа (в значениях, принимаемых CSS)"
// pe.readOnly: "Read-only" => "Только для чтения"
// pe.enableIf: "Editable if" => "Редактируется, если"
// pe.emptyRowsText: "\"No rows\" message" => "Сообщение \"Нет строк\""
// pe.size: "Input field size (in characters)" => "Размер поля ввода (в символах)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "Отдельные специальные варианты («Нет», «Другое», «Выбрать все»)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Копирование вариантов из следующего вопроса"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Какие варианты скопировать?"
// pe.showCommentArea: "Show the comment area" => "Показать область комментариев"
// pe.commentPlaceholder: "Comment area placeholder" => "Заполнитель области комментариев"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Отображение описаний скоростей в виде экстремальных значений"
// pe.rowsOrder: "Row order" => "Порядок строк"
// pe.columnsLayout: "Column layout" => "Расположение столбцов"
// pe.columnColCount: "Nested column count" => "Количество вложенных столбцов"
// pe.state: "Panel expand state" => "Состояние развертывания панели"
// pe.correctAnswer: "Correct Answer" => "Правильный ответ"
// pe.defaultPanelValue: "Default Values" => "Значения по умолчанию"
// pe.cells: "Cell Texts" => "Тексты ячеек"
// pe.keyName: "Key column" => "Ключевая колонка"
// itemvalue.text: "Alt text" => "Замещающий текст"
// tabs.html: "HTML Editor" => "HTML-редактор"
// tabs.numbering: "Numbering" => "Нумерация"
// tabs.pages: "Pages" => "Страниц"
// tabs.slider: "Slider" => "Ползун"
// tabs.expression: "Expression" => "Выражение"
// pe.choicesVisibleIf: "Choices are visible if" => "Варианты доступны в следующих случаях:"
// pe.choicesEnableIf: "Choices are selectable if" => "Варианты можно выбрать, если:"
// pe.columnsEnableIf: "Columns are visible if" => "Столбцы видны, если"
// pe.rowsEnableIf: "Rows are visible if" => "Строки видны, если"
// pe.indent: "Add indents" => "Добавление отступов"
// panel.indent: "Add outer indents" => "Добавление внешних отступов"
// pe.innerIndent: "Add inner indents" => "Добавление внутренних отступов"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "Взять значения по умолчанию из последней строки"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "Возьмите значения по умолчанию с последней панели"
// pe.titleKeyboardAdornerTip: "Press enter button to edit" => "Нажмите кнопку ввода, чтобы отредактировать"
// pe.keyboardAdornerTip: "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item" => "Нажмите кнопку ввода, чтобы отредактировать элемент, нажмите кнопку удаления, чтобы удалить элемент, нажмите alt со стрелкой вверх или со стрелкой вниз, чтобы переместить элемент"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "Введите выражение здесь..."
// pe.noFile: "No file choosen" => "Файл не выбран"
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "Очистите значение, если вопрос становится скрытым"
// pe.valuePropertyName: "Value property name" => "Имя свойства value"
// pe.searchEnabled: "Enable search" => "Включить поиск"
// pe.hideSelectedItems: "Hide selected items" => "Скрытие выбранных элементов"
// pe.closeOnSelect: "Close the dropdown after selection" => "Закрыть раскрывающийся список после выбора"
// pe.signatureWidth: "Signature width" => "Ширина подписи"
// pe.signatureHeight: "Signature height" => "Высота подписи"
// pe.verticalAlign: "Vertical alignment" => "Выравнивание по вертикали"
// pe.alternateRows: "Alternate rows" => "Чередующиеся строки"
// pe.columnsVisibleIf: "Columns are visible if" => "Столбцы видны, если"
// pe.rowsVisibleIf: "Rows are visible if" => "Строки видны, если"
// pe.otherPlaceholder: "Comment area placeholder" => "Заполнитель области комментариев"
// pe.rateType: "Rate type" => "Тип тарифа"
// pv.true: "true" => "истинный"
// pv.false: "false" => "ложный"
// pv.decimal: "decimal" => "десятичный"
// pv.currency: "currency" => "валюта"
// pv.percent: "percent" => "процент"
// pv.onpanel: "Start on each panel" => "Старт на каждой панели"
// pv.tab: "Tabs" => "Вкладки"
// pv.both: "Both" => "Оба"
// pv.right: "Right" => "Правильно"
// pv.color: "color" => "Цвет"
// pv.date: "date" => "дата"
// pv.datetime: "datetime" => "ДатаТайм"
// pv.datetime-local: "datetime-local" => "datetime-local"
// pv.email: "email" => "Отправить по электронной почте"
// pv.month: "month" => "месяц"
// pv.number: "number" => "число"
// pv.password: "password" => "пароль"
// pv.range: "range" => "диапазон"
// pv.tel: "tel" => "Тель"
// pv.text: "text" => "СМС"
// pv.time: "time" => "Время"
// pv.url: "url" => "URL-адрес"
// pv.week: "week" => "неделя"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "Когда вопрос или его панель/страница становятся скрытыми"
// clearInvisibleValues.none: "Never" => "Никогда"
// inputType.color: "Color" => "Цвет"
// inputType.date: "Date" => "Дата"
// inputType.datetime-local: "Date and Time" => "Дата и время"
// inputType.email: "Email" => "Отправить по электронной почте"
// inputType.month: "Month" => "Месяц"
// inputType.number: "Number" => "Число"
// inputType.password: "Password" => "Пароль"
// inputType.range: "Range" => "Диапазон"
// inputType.tel: "Phone Number" => "Номер телефона"
// inputType.text: "Text" => "СМС"
// inputType.time: "Time" => "Время"
// inputType.url: "URL" => "URL-адрес"
// inputType.week: "Week" => "Неделя"
// pv.onValueChanging: "Before an answer is changed" => "Прежде чем ответ будет изменен"
// pv.standard: "Original structure" => "Оригинальная структура"
// pv.singlePage: "All questions on a single page" => "Все вопросы на одной странице"
// pv.questionPerPage: "Each question on an individual page" => "Каждый вопрос на отдельной странице"
// pv.noPreview: "No preview" => "Без предварительного просмотра"
// pv.showAllQuestions: "Show all questions" => "Показать все вопросы"
// pv.showAnsweredQuestions: "Show answered questions only" => "Показывать только ответы на вопросы"
// pv.pages: "Completed pages" => "Заполненные страницы"
// pv.questions: "Answered questions" => "Ответы на вопросы"
// pv.requiredQuestions: "Answered required questions" => "Ответы на необходимые вопросы"
// pv.correctQuestions: "Valid answers" => "Правильные ответы"
// pv.buttons: "Completed pages (button UI)" => "Завершенные страницы (пользовательский интерфейс кнопки)"
// pv.underInput: "Under the input" => "Под входом"
// pv.underTitle: "Under the title" => "Под заголовком"
// pv.onBlur: "On blur" => "О размытии"
// pv.onTyping: "While typing" => "При наборе текста"
// pv.underRow: "Under the row" => "Под строкой"
// pv.underRowSingle: "Under the row, only one panel is visible" => "Под строкой видна только одна панель"
// showNavigationButtons.none: "Hidden" => "Скрытый"
// showProgressBar.off: "Hidden" => "Скрытый"
// showTimerPanel.none: "Hidden" => "Скрытый"
// showTimerPanelMode.all: "Both" => "Оба"
// detailPanelMode.none: "Hidden" => "Скрытый"
// addRowLocation.default: "Depends on matrix layout" => "Зависит от компоновки матрицы"
// panelsState.default: "Users cannot expand or collapse panels" => "Пользователи не могут разворачивать или сворачивать панели"
// panelsState.collapsed: "All panels are collapsed" => "Все панели свернуты"
// panelsState.expanded: "All panels are expanded" => "Все панели расширены"
// widthMode.auto: "Auto" => "Авто"
// widthMode.static: "Static" => "Статический"
// widthMode.responsive: "Responsive" => "Отзывчивый"
// imageFit.none: "None" => "Никакой"
// imageFit.contain: "Contain" => "Содержать"
// imageFit.cover: "Cover" => "Крышка"
// imageFit.fill: "Fill" => "Заполнять"
// contentMode.auto: "Auto" => "Авто"
// contentMode.image: "Image" => "Образ"
// contentMode.video: "Video" => "Видео"
// contentMode.youtube: "YouTube" => "Ютуб"
// displayMode.auto: "Auto" => "Авто"
// displayMode.buttons: "Buttons" => "Кнопки"
// displayMode.dropdown: "Dropdown" => "Выпадающий список"
// rateColorMode.default: "Default" => "По умолчанию"
// autoGenerate.true: "Generate" => "Порождать"
// autoGenerate.false: "Enter manually" => "Ввод вручную"
// rateType.labels: "Labels" => "Метки"
// rateType.stars: "Stars" => "Звезды"
// rateType.smileys: "Smileys" => "Смайлики"
// op.and: "and" => "и"
// op.or: "or" => "или"
// ew.modern: "Modern theme" => "Современная тема"
// ew.default: "Default theme" => "Тема по умолчанию"
// ew.orange: "Orange theme" => "Оранжевая тема"
// ew.darkblue: "Darkblue theme" => "Темно-синяя тема"
// ew.darkrose: "Darkrose theme" => "Тема \"Темная роза\""
// ew.stone: "Stone theme" => "Тема «Камень»"
// ew.winter: "Winter theme" => "Зимняя тематика"
// ew.winterstone: "Winter-Stone theme" => "Тема \"Зимний камень\""
// ts.hideInvisibleElements: "Hide invisible elements" => "Скрыть невидимые элементы"
// validators.emailvalidator: "Email" => "Отправить по электронной почте"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Файлы cookie не позволяют пользователям заполнять один и тот же опрос дважды."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Изменяет размер видимой области поля ввода. Пожалуйста, используйте настройку <b>«Проверка → максимальная длина</b>», чтобы ограничить длину ввода."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Используйте {0} в качестве заполнителя для фактического значения."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Отображается только в том случае, если хотя бы один столбец имеет тип Total или выражение Total."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Дополнительные сведения см. в описании атрибута [accept](https://www.w3schools.com/tags/att_input_accept.asp)."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Применимо только к типам ячеек «Радиогруппа» и «Флажок»."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Дополнительные сведения см. в описании атрибута [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete)."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Если это свойство не задано, ответ будет сохранен в поле, указанном свойством Name."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Если указанный столбец содержит одинаковые значения, опрос выдает ошибку «Неуникальное значение ключа»."
// p.multiSelect: "Allow multiple selection" => "Разрешить множественный выбор"
// p.showLabel: "Show image captions" => "Показать подписи к изображениям"
// p.value: "Value" => "Ценность"
// p.tabAlign: "Tab alignment" => "Выравнивание табуляции"
// p.logoFit: "Logo fit" => "Подходит под логотип"
// p.pages: "Pages" => "Страниц"
// p.questions: "Questions" => "Вопросы"
// p.calculatedValues: "Calculated values" => "Вычисляемые значения"
// p.surveyId: "Survey id" => "Идентификатор опроса"
// p.surveyPostId: "Survey post id" => "Идентификатор записи опроса"
// p.surveyShowDataSaving: "Survey show data saving" => "Опрос показывает сохранение данных"
// p.questionDescriptionLocation: "Question description location" => "Описание вопроса Местоположение"
// p.progressBarType: "Progress bar type" => "Тип индикатора выполнения"
// p.showTOC: "Show TOC" => "Показать оглавление"
// p.tocLocation: "Toc location" => "Расположение оглавления"
// p.questionTitlePattern: "Question title pattern" => "Шаблон заголовка вопроса"
// p.widthMode: "Width mode" => "Режим ширины"
// p.showBrandInfo: "Show brand info" => "Показать информацию о бренде"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "Использование отображаемых значений в динамических текстах"
// p.descriptionLocation: "Description location" => "Описание местоположения"
// p.defaultValueExpression: "Default value expression" => "Выражение значения по умолчанию"
// p.bindings: "Bindings" => "Привязки"
// p.renderAs: "Render as" => "Рендеринг как"
// p.attachOriginalItems: "Attach original items" => "Прикрепите оригинальные элементы"
// p.cellHint: "Cell hint" => "Подсказка по ячейке"
// p.isUnique: "Is unique" => "Уникален"
// p.showInMultipleColumns: "Show in multiple columns" => "Показать в нескольких столбцах"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Общее количество максимальных дробных цифр"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Общее количество минимальных дробных цифр"
// p.detailElements: "Detail elements" => "Детализация элементов"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Разрешить адаптивные действия"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "Панель сведений, отображаемая при добавлении"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Выбор отложенной загрузки включен"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Выбор ленивой загрузки размера страницы"
// p.inputFieldComponent: "Input field component" => "Компонент поля ввода"
// p.itemComponent: "Item component" => "Компонент предмета"
// p.min: "Min" => "Мин"
// p.max: "Max" => "Макс"
// p.minValueExpression: "Min value expression" => "Выражение минимального значения"
// p.maxValueExpression: "Max value expression" => "Выражение максимального значения"
// p.step: "Step" => "Шаг"
// p.dataList: "Data list" => "Список данных"
// p.elements: "Elements" => "Азы"
// p.content: "Content" => "Содержание"
// p.navigationTitle: "Navigation title" => "Навигационный заголовок"
// p.navigationDescription: "Navigation description" => "Навигационное описание"
// p.longTap: "Long tap" => "Длительное нажатие"
// p.autoGrow: "Auto grow" => "Автоматическое выращивание"
// p.allowResize: "Allow resizing" => "Разрешить изменение размера"
// p.acceptCarriageReturn: "Accept carriage return" => "Принять возврат каретки"
// p.displayMode: "Display mode" => "Режим отображения"
// p.rateType: "Rate type" => "Тип тарифа"
// p.contentMode: "Content mode" => "Режим содержимого"
// p.imageFit: "Image fit" => "Подгонка под изображение"
// p.altText: "Alt text" => "Замещающий текст"
// p.height: "Height" => "Высота"
// p.penColor: "Pen color" => "Цвет пера"
// p.backgroundColor: "Background color" => "Цвет фона"
// p.templateElements: "Template elements" => "Элементы шаблона"
// p.operator: "Operator" => "Оператор"
// p.isVariable: "Is variable" => "Является вариативным"
// p.runExpression: "Run expression" => "Выражение \"Выполнить\""
// p.showCaption: "Show caption" => "Показать подпись"
// p.iconName: "Icon name" => "Название значка"
// p.iconSize: "Icon size" => "Размер значка"
// p.precision: "Precision" => "Точность"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Область маркера перетаскивания матрицы"
// p.backgroundImage: "Background image" => "Фоновое изображение"
// p.backgroundImageFit: "Background image fit" => "Подгонка фонового изображения"
// p.backgroundImageAttachment: "Background image attachment" => "Вложение фонового изображения"
// p.backgroundOpacity: "Background opacity" => "Непрозрачность фона"
// p.selectToRankEnabled: "Select to rank enabled" => "Выберите, чтобы ранжирование включено"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Выберите, чтобы ранжировать макет областей"
// p.allowCameraAccess: "Allow camera access" => "Разрешить доступ к камере"
// p.scaleColorMode: "Scale color mode" => "Цветовой режим масштабирования"
// p.rateColorMode: "Rate color mode" => "Оцените цветовой режим"
// p.templateTabTitle: "Template tab title" => "Заголовок вкладки шаблона"
// p.templateVisibleIf: "Template visible if" => "Шаблон виден, если"
// p.copyDisplayValue: "Copy display value" => "Копирование отображаемого значения"
// theme.--background: "Background color" => "Цвет фона"
// theme.--background-dim-light: "Background dim light color" => "Фон тусклый цвет света"
// theme.--primary-foreground: "Primary foreground color" => "Основной цвет переднего плана"
// theme.--foreground: "Foreground color" => "Цвет переднего плана"
// theme.--base-unit: "Base unit" => "Базовый блок"
// theme.groupAdvanced: "Advanced" => "Продвинутый"
// theme.themeName: "Theme" => "Тема"
// theme.isPanelless: "Question appearance" => "Внешний вид вопроса"
// theme.isPanellessPanels: "Default" => "По умолчанию"
// theme.isPanellessLightweight: "Without Panels" => "Без панелей"
// theme.themePaletteLight: "Light" => "Свет"
// theme.themePaletteDark: "Dark" => "Темный"
// theme.primaryColor: "Accent color" => "Акцентный цвет"
// theme.primaryDefaultColor: "Default" => "По умолчанию"
// theme.primaryDarkColor: "Hover" => "Парить"
// theme.primaryLightColor: "Selected" => "Выбранный"
// theme.backgroundDimColor: "Background color" => "Цвет фона"
// theme.backgroundImage: "Background image" => "Фоновое изображение"
// theme.backgroundImageFitAuto: "Auto" => "Авто"
// theme.backgroundImageFitCover: "Cover" => "Крышка"
// theme.backgroundImageFitContain: "Contain" => "Содержать"
// theme.backgroundOpacity: "Opacity" => "Непрозрачность"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Неподвижный"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Свиток"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Непрозрачность фона панели"
// theme.questionBackgroundTransparency: "Question background opacity" => "Непрозрачность фона вопроса"
// theme.questionPanel: "Panel background and corner radius" => "Фон панели и радиус угла"
// theme.questionTitle: "Question title font" => "Шрифт заголовка вопроса"
// theme.questionDescription: "Question description font" => "Шрифт описания вопроса"
// theme.editorPanel: "Input element" => "Элемент ввода"
// theme.editorFont: "Input element font" => "Шрифт элемента ввода"
// theme.backcolor: "Default background" => "Фон по умолчанию"
// theme.hovercolor: "Hover background" => "Фон при наведении курсора"
// theme.borderDecoration: "Border decoration" => "Оформление бордюра"
// theme.accentBackground: "Accent background" => "Акцентный фон"
// theme.accentForeground: "Accent foreground" => "Акцент на переднем плане"
// theme.primaryForecolor: "Default color" => "Цвет по умолчанию"
// theme.primaryForecolorLight: "Disabled color" => "Отключенный цвет"
// theme.linesColors: "Minor line colors" => "Второстепенные цвета линий"
// theme.borderDefault: "Darker" => "Темнее"
// theme.borderLight: "Lighter" => "Зажигалка"
// theme.fontFamily: "Font family" => "Семейство шрифтов"
// theme.fontSize: "Font size" => "Размер шрифта"
// theme.color: "Color" => "Цвет"
// theme.size: "Size" => "Размер"
// theme.fontWeightRegular: "Regular" => "Регулярный"
// theme.fontWeightHeavy: "Heavy" => "Тяжелый"
// theme.fontWeightSemiBold: "Semi-bold" => "Полужирный"
// theme.fontWeightBold: "Bold" => "Смелый"
// theme.scale: "Scale" => "Шкала"
// theme.cornerRadius: "Corner radius" => "Радиус угла"
// theme.surveyTitleFont: "Survey title font" => "Шрифт заголовка опроса"
// theme.pageTitle: "Page title font" => "Шрифт заголовка страницы"
// theme.pageDescription: "Page description font" => "Шрифт описания страницы"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Добавить эффект тени"
// theme.opacity: "Opacity" => "Непрозрачность"
// theme.boxShadowBlur: "Blur" => "Смазывать"
// theme.boxShadowSpread: "Spread" => "Распространение"
// theme.boxShadowDrop: "Drop" => "Капля"
// theme.boxShadowInner: "Inner" => "Внутренний"
// theme.questionShadow: "Shadow effects" => "Эффекты тени"
// theme.editorShadow: "Input element shadow effects" => "Эффекты тени входного элемента"
// names.default: "Default" => "По умолчанию"
// names.contrast: "Contrast" => "Контраст"
// names.plain: "Plain" => "Равнина"
// names.simple: "Simple" => "Простой"
// names.blank: "Blank" => "Пустой"
// names.double: "Double" => "Двойной"
// names.bulk: "Bulk" => "Масса"
// names.pseudo-3d: "Pseudo 3D" => "Псевдо 3D"
// names.playful: "Playful" => "Игривый"
// names.ultra: "Ultra" => "Ультра"
// colors.teal: "Teal" => "Чирок"
// colors.blue: "Blue" => "Синий"
// colors.purple: "Purple" => "Пурпурный"
// colors.orchid: "Orchid" => "Орхидея"
// colors.tulip: "Tulip" => "Тюльпан"
// colors.brown: "Brown" => "Коричневый"
// colors.green: "Green" => "Зеленый"
// names.sharp: "Sharp" => "Острый"
// names.borderless: "Borderless" => "Без границ"
// names.flat: "Flat" => "Плоский"
// names.doubleborder: "Double Border" => "Двойная граница"
// names.layered: "Layered" => "Слоистый"
// names.solid: "Solid" => "Сплошной"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Вы уверены, что хотите удалить все строки для этого языка?"
// ed.themeResetButton: "Reset theme settings to default" => "Сброс настроек темы по умолчанию"
// theme.placeholderColor: "Placeholder color" => "Цвет заполнителя"
// ed.themeSettings: "Theme Settings" => "Настройки темы"
// ed.themeSettingsTooltip: "Open theme settings" => "Откройте настройки темы"
// pe.resetToDefaultCaption: "Reset" => "Сброс"
// pv.file: "Local files" => "Локальные файлы"
// pv.camera: "Camera" => "Фотоаппарат"
// pv.file-camera: "Local files or camera" => "Локальные файлы или камера"
// ed.translateUsigAI: "Auto-translate All" => "Автоматический перевод всех"
// ed.translationDialogTitle: "Untranslated strings" => "Непереведенные строки"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Пожалуйста, введите не менее {0} пунктов"
// lg.question_resetValueName: "Reset question value" => "Сбросить значение вопроса"
// lg.column_resetValue: "Reset column value" => "Сброс значения столбца"
// pe.markRequired: "Mark as required" => "Отметьте как обязательный"
// pe.removeRequiredMark: "Remove the required mark" => "Снимите нужную отметку"
// p.resetValueIf: "Reset value if" => "Сбросьте значение, если"
// lg.question_setValueName: "Set question value" => "Задать значение вопроса"
// lg.column_resetValueName: "Reset column value" => "Сброс значения столбца"
// lg.column_setValueName: "Set column value" => "Задание значения столбца"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Выражение, результат которого будет присвоен целевому вопросу."
// survey.title: "Title" => "Титул"
// page.title: "Title" => "Титул"
// p.setValueIf: "Set value if" => "Установите значение, если"
// theme.header: "Header" => "Заголовок"
// theme.headerView: "View" => "Вид"
// theme.headerViewBasic: "Basic" => "Основной"
// theme.headerViewAdvanced: "Advanced" => "Продвинутый"
// theme.headerInheritWidthFrom: "Content area width" => "Ширина области содержимого"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "То же, что и опрос"
// theme.headerInheritWidthFromPage: "Fit to page" => "По размеру страницы"
// theme.headerTextAreaWidth: "Text width" => "Ширина текста"
// theme.headerBackgroundColorSwitch: "Background color" => "Цвет фона"
// theme.headerBackgroundColorNone: "None" => "Никакой"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Акцентный цвет"
// theme.headerBackgroundColorCustom: "Custom" => "Обычай"
// theme.horizontalAlignmentLeft: "Left" => "Налево"
// theme.horizontalAlignmentCenter: "Center" => "Центр"
// theme.horizontalAlignmentRight: "Right" => "Правильно"
// theme.verticalAlignmentTop: "Top" => "Вверх"
// theme.verticalAlignmentMiddle: "Middle" => "Середина"
// theme.verticalAlignmentBottom: "Bottom" => "Дно"
// theme.logoPosition: "Logo Position" => "Положение логотипа"
// theme.headerTitlePosition: "Title Position" => "Титульная позиция"
// lg.question_resetValueText: "reset value for question: {0}" => "Сброс значения для вопроса: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "присвоить значение: {1} к вопросу: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Сброс значения ячейки для столбца: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Присвойте значение ячейки: {1} столбцу: {0}"
// ed.surveyJsonExportButton: "Export" => "Экспорт"
// ed.surveyJsonImportButton: "Import" => "Импорт"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Копировать в буфер"
// pe.filePlaceholder: "File placeholder text" => "Замещающий текст файла"
// pe.photoPlaceholder: "Photo placeholder text" => "Замещающий текст фотографии"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Замещающий текст файла или фотографии"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Применяется, когда \"Тип источника\" имеет значение \"Локальные файлы\" или когда камера недоступна"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Применяется, если \"Тип источника\" имеет значение \"Камера\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Применяется, если \"Тип источника\" имеет значение \"Локальные файлы или камера\"."
// theme.background: "Background" => "Фон"
// theme.appearance: "Appearance" => "Внешность"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Вы действительно хотите сбросить тему? Все ваши настройки будут потеряны."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Да, сбросьте тему"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Подходит для контейнера"
// signaturepad.showPlaceholder: "Show the placeholder" => "Показать заполнитель"
// signaturepad.placeholder: "Placeholder text" => "Замещающий текст"
// theme.surveyDescriptionFont: "Survey description font" => "Шрифт описания опроса"
// ed.prevFocus: "Focus previous" => "Фокусировка предыдущая"
// ed.nextFocus: "Focus next" => "Сосредоточьтесь на следующем"
// ed.saveTheme: "Save Theme" => "Сохранить тему"
// ed.saveThemeTooltip: "Save Theme" => "Сохранить тему"
// lg.page_requireName: "Make page required" => "Сделать страницу обязательной"
// lg.panel_requireName: "Make page required" => "Сделать страницу обязательной"
// signaturepad.signatureWidth: "Signature area width" => "Ширина области подписи"
// signaturepad.signatureHeight: "Signature area height" => "Высота области подписи"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Автоматическое масштабирование области подписи"
// signaturepad.penMinWidth: "Minimum pen width" => "Минимальная ширина пера"
// signaturepad.penMaxWidth: "Maximum pen width" => "Максимальная ширина пера"
// theme.headerDescriptionPosition: "Description position" => "Описание позиции"
// ed.propertyGridNoResultsFound: "No results found" => "Никаких результатов не найдено"
// pv.leftRight: "Left and right" => "Влево и вправо"
// p.sourceType: "Source type" => "Тип источника"
// p.fitToContainer: "Fit to container" => "Подходит для контейнера"
// p.setValueExpression: "Set value expression" => "Выражение заданного значения"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Варианты загружаются из веб-службы."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Перейдите в настройки"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Предварительный просмотр загруженных вариантов выбора"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Предотвращение дублирования ответов в строках"
// theme.advancedMode: "Advanced mode" => "Расширенный режим"
// theme.backgroundCornerRadius: "Background and corner radius" => "Радиус фона и угла"
// theme.colorsTitle: "Colors" => "Знамя"
// theme.font: "Font" => "Шрифт"
// theme.lines: "Lines" => "Обводы"
// theme.titleFont: "Title font" => "Шрифт заголовка"
// theme.descriptionFont: "Description font" => "Описание шрифта"
// theme.shadow: "Shadow effects" => "Эффекты теней"
// ed.translateUsigAIFrom: "Translate from: " => "Перевести с: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Разрешить опцию «Отказаться от ответа»"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Разрешить опцию «Не знаю»"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Разрешить опцию «Отказаться от ответа»"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Разрешить опцию «Не знаю»"
// pv.contain: "Contain" => "Содержать"
// pv.cover: "Cover" => "Крышка"
// pv.fill: "Fill" => "Заполнять"
// pe.transposeData: "Transpose rows to columns" => "Транспонирование строк в столбцы"
// layout.panel: "Layout" => "Схема"
// layout.question: "Layout" => "Схема"
// layout.base: "Layout" => "Схема"
// panel.name: "Panel name" => "Название панели"
// panel.title: "Panel title" => "Заголовок панели"
// panel.description: "Panel description" => "Описание панели"
// panel.visibleIf: "Make the panel visible if" => "Сделать панель видимой, если"
// panel.requiredIf: "Make the panel required if" => "Сделайте панель обязательной, если"
// panel.questionsOrder: "Question order within the panel" => "Порядок вопросов на панели"
// panel.startWithNewLine: "Display the panel on a new line" => "Отображение панели на новой строке"
// panel.state: "Panel collapse state" => "Состояние свертывания панели"
// panel.width: "Inline panel width" => "Встроенная ширина панели"
// panel.minWidth: "Minimum panel width" => "Минимальная ширина панели"
// panel.maxWidth: "Maximum panel width" => "Максимальная ширина панели"
// panel.showNumber: "Number panels" => "Номерные панели"
// paneldynamic.name: "Panel name" => "Название панели"
// paneldynamic.title: "Panel title" => "Заголовок панели"
// paneldynamic.description: "Panel description" => "Описание панели"
// paneldynamic.visibleIf: "Make the panel visible if" => "Сделать панель видимой, если"
// paneldynamic.requiredIf: "Make the panel required if" => "Сделайте панель обязательной, если"
// paneldynamic.page: "Move the panel to page" => "Переместите панель на страницу"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Отображение панели на новой строке"
// paneldynamic.state: "Panel collapse state" => "Состояние свертывания панели"
// paneldynamic.width: "Inline panel width" => "Встроенная ширина панели"
// paneldynamic.minWidth: "Minimum panel width" => "Минимальная ширина панели"
// paneldynamic.maxWidth: "Maximum panel width" => "Максимальная ширина панели"
// paneldynamic.templateDescription: "Panel description pattern" => "Шаблон описания панели"
// paneldynamic.templateTitle: "Panel title pattern" => "Шаблон заголовка панели"
// paneldynamic.noEntriesText: "Empty panel text" => "Пустой текст на панели"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Шаблон заголовка вкладки"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Сделать отдельную панель видимой, если"
// paneldynamic.hideNumber: "Hide the panel number" => "Скрытие номера панели"
// paneldynamic.titleLocation: "Panel title alignment" => "Выравнивание заголовков панелей"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Выравнивание описания панели"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Выравнивание заголовка вопроса"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Выравнивание сообщений об ошибках"
// paneldynamic.newPanelPosition: "New panel location" => "Новое расположение панели"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Предотвращение дублирования ответов в следующем вопросе"
// question.name: "Question name" => "Название вопроса"
// question.title: "Question title" => "Заголовок вопроса"
// question.description: "Question description" => "Описание вопроса"
// question.visibleIf: "Make the question visible if" => "Сделайте вопрос видимым, если"
// question.requiredIf: "Make the question required if" => "Сделайте вопрос обязательным, если"
// question.state: "Question box collapse state" => "Состояние сворачивания окна вопроса"
// question.hideNumber: "Hide the question number" => "Скрыть номер вопроса"
// question.titleLocation: "Question title alignment" => "Выравнивание заголовка вопроса"
// question.descriptionLocation: "Question description alignment" => "Выравнивание описания вопроса"
// question.errorLocation: "Error message alignment" => "Выравнивание сообщений об ошибках"
// question.indent: "Increase the inner indent" => "Увеличьте внутренний отступ"
// question.width: "Inline question width" => "Ширина встроенного вопроса"
// question.minWidth: "Minimum question width" => "Минимальная ширина вопроса"
// question.maxWidth: "Maximum question width" => "Максимальная ширина вопроса"
// question.textUpdateMode: "Update input field value" => "Обновление значения поля ввода"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Отображение кнопки «Очистить» в области подписи"
// signaturepad.penColor: "Stroke color" => "Цвет обводки"
// comment.rows: "Input field height (in lines)" => "Высота поля ввода (в строках)"
// expression.name: "Expression name" => "Имя выражения"
// expression.title: "Expression title" => "Заголовок выражения"
// expression.description: "Expression description" => "Описание выражения"
// expression.expression: "Expression" => "Выражение"
// trigger.expression: "Expression" => "Выражение"
// calculatedvalue.expression: "Expression" => "Выражение"
// survey.description: "Survey description" => "Описание опроса"
// page.name: "Page name" => "Название страницы"
// page.description: "Page description" => "Описание страницы"
// page.visibleIf: "Make the page visible if" => "Сделайте страницу видимой, если"
// page.requiredIf: "Make the page required if" => "Сделайте страницу обязательной, если"
// page.questionsOrder: "Question order on the page" => "Порядок вопросов на странице"
// matrixdropdowncolumn.name: "Column name" => "Имя столбца"
// matrixdropdowncolumn.title: "Column title" => "Заголовок столбца"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Предотвращение дублирования ответов"
// matrixdropdowncolumn.width: "Column width" => "Ширина столбца"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Минимальная ширина столбца"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Высота поля ввода (в строках)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Сделайте столбец видимым, если"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Сделайте столбец обязательным, если"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Каждый вариант в отдельной колонке"
// multipletextitem.name: "Name" => "Имя"
// multipletextitem.title: "Title" => "Титул"
// pe.rateDescriptionLocation: "Label alignment" => "Выравнивание меток"
// pe.cellErrorLocation: "Cell error message alignment" => "Выравнивание сообщений об ошибках ячеек"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "У вас еще нет столбцов"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "У вас еще нет строк"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "У вас еще нет правил валидации"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "У вас еще нет пользовательских переменных"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "У вас еще нет триггеров"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "У вас еще нет ссылок"
// pe.addNew@columns: "Add new column" => "Добавить новый столбец"
// pe.addNew@rows: "Add new row" => "Добавить новую строку"
// pe.addNew@validators: "Add new rule" => "Добавить новое правило"
// pe.addNew@calculatedValues: "Add new variable" => "Добавить новую переменную"
// pe.addNew@triggers: "Add new trigger" => "Добавить новый триггер"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Добавить новый URL-адрес"
// choicesbyurl.url: "Web service's URL" => "URL-адрес веб-службы"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Отображение заголовков страниц в индикаторе выполнения"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Отображение номеров страниц в индикаторе выполнения"
// itemvalue.visibleIf: "Make the option visible if" => "Сделайте опцию видимой, если"
// itemvalue.enableIf: "Make the option selectable if" => "Сделайте опцию выбираемой, если"
// panel.layout: "Panel Layout" => "Компоновка панелей"
// tabs.questionSettings: "Question Settings" => "Настройки вопроса"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Пример: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Пример: categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Пример: а)"
// pe.width_placeholder: "Ex.: 6in" => "Пример: 6 дюймов"
// pe.minWidth_placeholder: "Ex.: 600px" => "Пример: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Пример: 50%"
// pv.selected: "Selected" => "Выбранный"
// pv.unselected: "Unselected" => "Невыбранных"
// pv.center: "Center" => "Центр"
// pv.middle: "Middle" => "Середина"
// pv.next: "Next" => "Следующий"
// pv.last: "Last" => "Последний"
// clearIfInvisible.none: "Never" => "Никогда"
// questionsOnPageMode.standard: "Original structure" => "Оригинальная структура"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Показать все вопросы на одной странице"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Показывать один вопрос на странице"
// pv.auto: "Auto" => "Авто"
// panelsState.firstExpanded: "First expanded" => "Первый расширенный"
// rateColorMode.scale: "Scale" => "Шкала"
// scaleColorMode.monochrome: "Monochrome" => "Монохромный"
// scaleColorMode.colored: "Colored" => "Цветной"
// state.default: "Locked" => "Запертый"
// showQuestionNumbers.default: "Auto-numbering" => "Автоматическая нумерация"
// showQuestionNumbers.on: "Auto-numbering" => "Автоматическая нумерация"
// showQuestionNumbers.onPage: "Reset on each page" => "Сброс на каждой странице"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Сброс на каждой панели"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Сброс на каждой панели"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Продолжить опрос"
// showQuestionNumbers.off: "No numbering" => "Без нумерации"
// descriptionLocation.underTitle: "Under the question title" => "Под заголовком вопроса"
// descriptionLocation.underInput: "Under the input field" => "Под полем ввода"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Рядом с вариантами выбора"
// selectToRankAreasLayout.vertical: "Above choices" => "Вышеуказанные варианты"
// displayStyle.decimal: "Decimal" => "Десятичный"
// displayStyle.currency: "Currency" => "Валюта"
// displayStyle.percent: "Percentage" => "Процент"
// displayStyle.date: "Date" => "Дата"
// totalDisplayStyle.decimal: "Decimal" => "Десятичный"
// totalDisplayStyle.currency: "Currency" => "Валюта"
// totalDisplayStyle.percent: "Percentage" => "Процент"
// totalDisplayStyle.date: "Date" => "Дата"
// rowsOrder.initial: "Original" => "Исходный текст"
// questionsOrder.initial: "Original" => "Исходный текст"
// showProgressBar.aboveheader: "Above the header" => "Над заголовком"
// showProgressBar.belowheader: "Below the header" => "Под заголовком"
// pv.sum: "Sum" => "Сумма"
// pv.count: "Count" => "Считать"
// pv.min: "Min" => "Мин"
// pv.max: "Max" => "Макс"
// pv.avg: "Avg" => "Средняя"
// searchMode.contains: "Contains" => "Содержит"
// searchMode.startsWith: "Starts with" => "Начинается с"
// panel.name: "A panel ID that is not visible to respondents." => "Идентификатор панели, который не виден респондентам."
// panel.description: "Type a panel subtitle." => "Введите субтитры панели."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Используйте значок волшебной палочки, чтобы задать условное правило, определяющее видимость панели."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Используйте значок волшебной палочки, чтобы задать условное правило, которое отключает режим только для чтения для панели."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Используйте значок волшебной палочки, чтобы задать условное правило, которое запрещает отправку опроса, если хотя бы один вложенный вопрос не содержит ответа."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Применяется ко всем вопросам в этой панели. Если вы хотите переопределить этот параметр, определите правила выравнивания заголовков для отдельных вопросов. Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса («Сверху» по умолчанию)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Задает расположение сообщения об ошибке по отношению ко всем вопросам на панели. Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Сохраняет исходный порядок вопросов или рандомизирует их. Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса."
// panel.page: "Repositions the panel to the end of a selected page." => "Перемещает панель в конец выбранной страницы."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Добавляет пространство или поле между содержимым панели и левой границей рамки панели."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Снимите флажок, чтобы отобразить панель в одной строке с предыдущим вопросом или панелью. Этот параметр не применяется, если панель является первым элементом формы."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Выберите из: «Развернутая» - панель отображается полностью и может быть свернута; «Свернутая» - панель отображает только заголовок и описание и может быть развернута; «Заблокировано» - панель отображается полностью и не может быть свернута."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Устанавливает ширину панели пропорционально другим элементам съемки в той же линии. Принимает значения CSS (px, %, in, pt и т. д.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "Идентификатор панели, который не виден респондентам."
// paneldynamic.description: "Type a panel subtitle." => "Введите субтитры панели."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Используйте значок волшебной палочки, чтобы задать условное правило, определяющее видимость панели."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Используйте значок волшебной палочки, чтобы задать условное правило, которое отключает режим только для чтения для панели."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Используйте значок волшебной палочки, чтобы задать условное правило, которое запрещает отправку опроса, если хотя бы один вложенный вопрос не содержит ответа."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Применяется ко всем вопросам в этой панели. Если вы хотите переопределить этот параметр, определите правила выравнивания заголовков для отдельных вопросов. Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса («Сверху» по умолчанию)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Задает расположение сообщения об ошибке по отношению к вопросу с недопустимыми входными данными. Выберите между: «Сверху» - текст ошибки размещается в верхней части поля вопроса; «Внизу» - текст ошибки размещается в нижней части окна вопроса. Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса («Сверху» по умолчанию)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Задает расположение сообщения об ошибке по отношению ко всем вопросам на панели. Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Перемещает панель в конец выбранной страницы."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Добавляет пространство или поле между содержимым панели и левой границей рамки панели."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Снимите флажок, чтобы отобразить панель в одной строке с предыдущим вопросом или панелью. Этот параметр не применяется, если панель является первым элементом формы."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Выберите из: «Развернутая» - панель отображается полностью и может быть свернута; «Свернутая» - панель отображает только заголовок и описание и может быть развернута; «Заблокировано» - панель отображается полностью и не может быть свернута."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Устанавливает ширину панели пропорционально другим элементам съемки в той же линии. Принимает значения CSS (px, %, in, pt и т. д.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Введите шаблон для динамических заголовков панелей. Используйте {panelIndex} для общего положения панели и {visiblePanelIndex} для ее порядка среди видимых панелей. Вставьте эти заполнители в шаблон, чтобы добавить автоматическую нумерацию."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Введите шаблон для заголовков вкладок. Используйте {panelIndex} для общего положения панели и {visiblePanelIndex} для ее порядка среди видимых панелей. Вставьте эти заполнители в шаблон, чтобы добавить автоматическую нумерацию."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Этот параметр позволяет управлять видимостью отдельных панелей внутри динамической панели. Используйте заполнитель '{panel}' для ссылки на текущую панель в выражении."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Этот параметр автоматически наследуется всеми вопросами на этой панели. Если вы хотите переопределить этот параметр, определите правила выравнивания заголовков для отдельных вопросов. Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса («Сверху» по умолчанию)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "Опция «Наследовать» применяет настройку на уровне страницы (если задано) или на уровне опроса («Под заголовком панели» по умолчанию)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Определяет положение вновь добавляемой панели. По умолчанию новые панели добавляются в конец. Выберите «Далее», чтобы вставить новую панель после текущей."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Дублирует ответы с последней панели и назначает их следующей добавленной динамической панели."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Укажите имя вопроса, чтобы пользователь мог предоставить уникальный ответ на этот вопрос на каждой панели."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Этот параметр позволяет назначить значение ответа по умолчанию на основе выражения. Выражение может включать в себя базовые вычисления - '{q1_id} + {q2_id}', логические выражения, такие как '{age} > 60', и функции: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и т.д. Значение, определяемое этим выражением, служит начальным значением по умолчанию, которое может быть переопределено ручным вводом респондентом."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Используйте значок волшебной палочки, чтобы задать условное правило, определяющее, когда входные данные респондента сбрасываются до значения, основанного на «Выражении значения по умолчанию» или «Выражении заданного значения» или на значении «Ответ по умолчанию» (если оно задано)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Используйте значок волшебной палочки, чтобы задать условное правило, которое определяет, когда запускать выражение «Задать значение» и динамически назначать полученное значение в качестве ответа."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Укажите выражение, определяющее значение, которое будет установлено при выполнении условий правила \"Задать значение если\". Выражение может включать в себя базовые вычисления - '{q1_id} + {q2_id}', логические выражения, такие как '{age} > 60', и функции: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и т.д. Значение, определенное этим выражением, может быть переопределено ручным вводом респондента."
// question.name: "A question ID that is not visible to respondents." => "Идентификатор вопроса, который не виден респондентам."
// question.description: "Type a question subtitle." => "Введите подзаголовок вопроса."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Используйте значок волшебной палочки, чтобы задать условное правило, определяющее видимость вопроса."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Используйте значок волшебной палочки, чтобы задать условное правило, которое отключает режим только для чтения для вопроса."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Используйте значок волшебной палочки, чтобы установить условное правило, которое запрещает продвижение или отправку опроса, если на вопрос не получен ответ."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Снимите флажок, чтобы отобразить вопрос в одной строке с предыдущим вопросом или панелью. Настройка не применяется, если вопрос является первым элементом формы."
// question.page: "Repositions the question to the end of a selected page." => "Перемещает вопрос в конец выбранной страницы."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Выберите один из вариантов: «Развернутый» - окно вопроса отображается полностью и может быть свернуто; «Свернутый» - поле вопроса отображает только заголовок и описание и может быть развернуто; «Заблокировано» - поле вопроса отображается полностью и не может быть свернуто."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Переопределяет правила выравнивания заголовков, заданные на уровне панели, страницы или опроса. Опция «Наследовать» применяет любые настройки более высокого уровня (если они установлены) или настройки уровня опроса («Сверху» по умолчанию)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "Опция «Наследовать» применяет настройку на уровне опроса (по умолчанию «Под заголовком вопроса»)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Задает расположение сообщения об ошибке по отношению к вопросу с недопустимыми входными данными. Выберите между: «Сверху» - текст ошибки размещается в верхней части поля вопроса; «Внизу» - текст ошибки размещается в нижней части окна вопроса. Опция «Наследовать» применяет настройку уровня опроса («Сверху» по умолчанию)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Добавляет пробел или поле между содержимым вопроса и левой границей поля вопроса."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Устанавливает ширину вопроса пропорционально другим элементам опроса в той же строке. Принимает значения CSS (px, %, in, pt и т. д.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Используйте значок волшебной палочки, чтобы задать правило проверки для вопроса."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Выберите из: \"При потере фокуса\" - значение обновляется при потере фокуса полем ввода; \"Во время набора\" - значение обновляется в режиме реального времени, по мере набора текста пользователями. Опция «Наследовать» применяет настройку на уровне опроса (по умолчанию «При потере фокуса»)."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Вы можете использовать любую веб-службу в качестве источника данных для вопросов с несколькими вариантами ответов. Чтобы заполнить значения выбора, введите URL-адрес службы, предоставляющей данные."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Операция сравнения, используемая для фильтрации раскрывающегося списка."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Задает ширину отображаемой области подписи и результирующего изображения."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Задает высоту отображаемой области подписи и результирующего изображения."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Выберите, хотите ли вы, чтобы область подписи занимала все доступное пространство в поле вопроса, сохраняя при этом соотношение сторон по умолчанию 3:2. Если заданы пользовательские значения ширины и высоты, при этом будет сохранено соотношение сторон этих размеров."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Настройка высоты изображения в результатах съемки."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Настройка ширины изображения в результатах съемки."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Переопределяет минимальное и максимальное значения высоты."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Переопределяет минимальное и максимальное значения ширины."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "«Значение» служит идентификатором элемента, используемым в условных правилах; Респондентам отображается «Текст»."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Этот параметр изменяет только размер поля ввода и не влияет на ширину поля вопроса. Чтобы ограничить допустимую длину ввода, перейдите в <b>раздел Проверка → Ограничение максимального количества символов</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Задает количество отображаемых строк в поле ввода. Если ввод занимает больше строк, появится полоса прокрутки."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Выберите один из следующих вариантов: «Редактируемый» - позволяет респондентам заполнять Ваш опрос; \"Только для чтения\" - отключает редактирование формы."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "Идентификатор столбца, который не виден респондентам."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Если этот параметр включен для столбца, респондент должен предоставить уникальный ответ на каждый вопрос в этом столбце."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Задает количество отображаемых строк в поле ввода. Если ввод занимает больше строк, появится полоса прокрутки."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Используйте значок волшебной палочки, чтобы задать условное правило, определяющее видимость столбцов."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Используйте значок волшебной палочки, чтобы задать условное правило, которое отключает режим только для чтения для столбца."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Используйте значок волшебной палочки, чтобы задать условное правило, которое запрещает отправку опроса, если хотя бы один вложенный вопрос не содержит ответа."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "При выборе этого параметра создается отдельный столбец для каждого варианта выбора."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Выберите один из: \"Статический\" - задает фиксированную ширину; «Отзывчивый» - заставляет опрос занимать всю ширину экрана; \"Авто\" - применяет любой из двух вариантов в зависимости от используемых типов вопросов."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Вставьте ссылку на изображение (без ограничений по размеру) или нажмите значок папки, чтобы просмотреть файл с компьютера (до 64 КБ)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Задает ширину логотипа в единицах CSS (px, %, in, pt и т. д.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Задает высоту логотипа в единицах CSS (px, %, in, pt и т. д.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Выберите один из следующих вариантов: \"Нет\" - изображение сохраняет свой первоначальный размер; \"Contain\" - размер изображения изменяется по размеру с сохранением его пропорций; «Обложка» - изображение заполняет всю коробку, сохраняя при этом соотношение сторон; \"Заливка\" - изображение растягивается для заполнения поля без сохранения его пропорций."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Выберите, хотите ли вы, чтобы опрос автоматически переходил на следующую страницу после того, как респондент ответит на все вопросы на текущей странице."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Задает видимость и расположение кнопок навигации на странице."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Задает видимость и расположение индикатора выполнения. Значение «Авто» отображает индикатор выполнения над или под заголовком опроса."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Включите страницу предварительного просмотра, на которой отображаются все вопросы или только ответы на них."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Применяется ко всем вопросам в опросе. Этот параметр может быть переопределен правилами выравнивания заголовков на более низких уровнях: панели, странице или вопросе. Настройки более низкого уровня будут переопределять настройки на более высоком уровне."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Символ или последовательность символов, указывающие на то, что требуется ответ."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Введите цифру или букву, с которой вы хотите начать нумерацию."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Задает расположение сообщения об ошибке по отношению к вопросу с недопустимыми входными данными. Выберите между: «Сверху» - текст ошибки размещается в верхней части поля вопроса; «Внизу» - текст ошибки размещается в нижней части окна вопроса."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Выберите, если вы хотите, чтобы первое поле ввода на каждой странице было готово для ввода текста."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Сохраняет исходный порядок вопросов или рандомизирует их. Эффект этого параметра виден только на вкладке «Предварительный просмотр»."
// pehelp.maxTextLength: "For text entry questions only." => "Только для вопросов с вводом текста."
// pehelp.maxOthersLength: "For question comments only." => "Только для комментариев к вопросам."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Выберите, хотите ли вы, чтобы комментарии к вопросам и вопросы с длинным текстом автоматически увеличивались в высоту в зависимости от введенной длины текста."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Только для комментариев к вопросам и вопросов с длинным текстом."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Пользовательские переменные служат промежуточными или вспомогательными переменными, используемыми в вычислениях формы. Они принимают входные данные респондента в качестве исходных значений. Каждая пользовательская переменная имеет уникальное имя и выражение, на котором она основана."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Выберите, если вы хотите, чтобы вычисленное значение выражения сохранялось вместе с результатами опроса."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Триггер — это событие или условие, основанное на выражении. После того, как выражение оценивается как \"true\", триггер запускает действие. Такое действие может иметь целевой вопрос, на который оно влияет."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Выберите, нужно ли очищать значения для вопросов, скрытых условной логикой, и когда это делать."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Выберите из: \"При потере фокуса\" - значение обновляется при потере фокуса полем ввода; \"Во время набора\" - значение обновляется в режиме реального времени, по мере набора текста пользователями."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Левое значение служит идентификатором столбца, используемым в условных правилах, правое значение отображается респондентам."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Левое значение служит идентификатором строки, используемым в условных правилах, правое значение отображается респондентам."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Принимает значения CSS (px, %, in, pt и т. д.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Принимает значения CSS (px, %, in, pt и т. д.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Задает местоположение сообщения об ошибке по отношению к ячейке с недопустимыми входными данными. Опция «Наследовать» применяет настройку из свойства «Выравнивание сообщений об ошибках»."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Если включено свойство «Не допускать дублирования ответов», респондент, пытающийся отправить дублирующуюся запись, получит следующее сообщение об ошибке."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Позволяет вычислять итоговые значения на основе выражения. Выражение может включать базовые вычисления ('{q1_id} + {q2_id}'), логические выражения ('{age} > 60') и функции ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и т.д.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Запускает запрос на подтверждение удаления строки."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Дублирует ответы из последней строки и присваивает их следующей добавленной динамической строке."
// pehelp.description: "Type a subtitle." => "Введите субтитры."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Выберите язык, чтобы начать создание опроса. Чтобы добавить перевод, переключитесь на новый язык и переведите исходный текст здесь или во вкладке «Переводы»."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Задает расположение раздела сведений по отношению к строке. Выберите один из вариантов: \"Нет\" - расширение не добавляется; \"Под строкой\" - под каждой строкой матрицы помещается расширение строки; \"Под строкой отображать только одну строку\" - расширение отображается только под одной строкой, остальные расширения строк сворачиваются."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Выберите один из следующих вариантов: \"Нет\" - изображение сохраняет свой первоначальный размер; \"Contain\" - размер изображения изменяется по размеру с сохранением его пропорций; «Обложка» - изображение заполняет всю коробку, сохраняя при этом соотношение сторон; \"Заливка\" - изображение растягивается для заполнения поля без сохранения его пропорций."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Постепенно увеличивает высоту поля ввода по мере ввода данных. Переопределяет настройку «Высота поля ввода (в строках)»."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Маркер изменения размера (или ручка) отображается в углу, и его можно перетащить, чтобы изменить размер поля ввода."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Интервал времени в секундах, по истечении которого опрос автоматически переходит на страницу благодарности."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Интервал времени в секундах, по истечении которого опрос автоматически переходит на следующую страницу."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Интервал времени в секундах, по истечении которого опрос автоматически переходит на следующую страницу."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Используйте значок волшебной палочки, чтобы задать условное правило, определяющее видимость страницы."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Используйте значок волшебной палочки, чтобы задать условное правило, которое отключает режим только для чтения для страницы."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Используйте значок волшебной палочки, чтобы задать условное правило, которое запрещает отправку опроса, если хотя бы один вложенный вопрос не содержит ответа."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Относится ко всем вопросам на этой странице. Если вы хотите переопределить этот параметр, задайте правила выравнивания заголовков для отдельных вопросов или панелей. Опция «Наследовать» применяет настройку уровня опроса («Сверху» по умолчанию)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Задает расположение сообщения об ошибке по отношению к вопросу с недопустимыми входными данными. Выберите между: «Сверху» - текст ошибки размещается в верхней части поля вопроса; «Внизу» - текст ошибки размещается в нижней части окна вопроса. Опция «Наследовать» применяет настройку уровня опроса («Сверху» по умолчанию)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Сохраняет исходный порядок вопросов или рандомизирует их. Опция «Наследовать» применяет настройку уровня опроса («Оригинал» по умолчанию). Эффект этого параметра виден только на вкладке «Предварительный просмотр»."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Задает видимость кнопок навигации на странице. Опция \"Наследовать\" применяет настройку уровня опроса, которая по умолчанию имеет значение \"Видимый\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Задает видимость и расположение таймера на странице."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Выберите один из следующих вариантов: \"Заблокировано\" - пользователи не могут разворачивать или сворачивать панели; \"Свернуть все\" - все панели запускаются в свернутом состоянии; \"Развернуть все\" - все панели запускаются в развернутом состоянии; \"First expanded\" - изначально разворачивается только первая панель."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Введите имя общего свойства в массиве объектов, содержащем URL-адреса изображений или видеофайлов, которые необходимо отобразить в списке вариантов."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Левое значение служит идентификатором элемента, используемым в условных правилах, правое значение отображается респондентам."
// pehelp.title: "Type a user-friendly title to display." => "Введите понятный заголовок для отображения."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Гарантирует, что пользователи не завершат опрос до тех пор, пока файлы не будут загружены."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Принимает значения CSS (px, %, in, pt и т. д.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Принимает значения CSS (px, %, in, pt и т. д.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Принимает значения CSS (px, %, in, pt и т. д.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "В вопросах с одним и несколькими вариантами ответов каждый вариант выбора имеет идентификатор и отображаемое значение. Если этот параметр установлен, в HTML-вопросах, а также в динамических заголовках и описаниях элементов опроса отображается отображаемое значение, а не значение идентификатора."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Выберите, следует ли очищать значения вопросов, скрытые условной логикой, и когда это делать. Опция «Наследовать» применяет настройку на уровне опроса («По завершении опроса» по умолчанию)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Выбрать из: \"Все\" - копирует все варианты выбора из выбранного вопроса; \"Выбранный\" - динамически копирует только выбранные варианты выбора; \"Невыбранные\" - динамически копирует только невыбранные варианты выбора. Опции «Нет» и «Другое» копируются по умолчанию, если они включены в исходном вопросе."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Если этот флажок установлен, пользователи могут включить дополнительные данные в отдельное поле комментария."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Отображение каждого варианта специального выбора (\"Нет\", \"Другое\", \"Выбрать все\") в новой строке, даже при использовании макета с несколькими столбцами."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Укажите местоположение в наборе данных сервиса, где находится целевой массив объектов. Оставьте пустым, если URL-адрес уже указывает на массив."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Введите единообразное имя свойства в массиве объектов, содержащем значения, которые требуется отобразить в списке вариантов."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Выберите, чтобы разрешить службе возвращать пустой ответ или массив."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Используйте значок волшебной палочки, чтобы задать условное правило, определяющее видимость всех вариантов выбора."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Левое значение служит идентификатором элемента, используемым в условных правилах, правое значение отображается респондентам."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "«Авто» выбирает между режимами «Кнопки» и «Выпадающий список» в зависимости от доступной ширины. Если ширина недостаточна для отображения кнопок, в вопросе отображается раскрывающийся список."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Позволяет соединять вопросы, дающие результаты, в разных форматах. Когда такие вопросы связаны друг с другом с помощью идентификатора соединения, в этом общем свойстве хранятся выбранные значения вопросов."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Выберите, хотите ли вы обновить содержимое раскрывающегося меню в соответствии с поисковым запросом, который пользователь вводит в поле ввода."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Значение, сохраняемое в результатах опроса, когда респонденты дают положительный ответ."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Значение, сохраняемое в результатах опроса, когда респонденты дают отрицательный ответ."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Не рекомендуется отключать этот параметр, так как он переопределяет изображение предварительного просмотра и затрудняет понимание пользователем, были ли файлы загружены."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Запускает запрос на подтверждение удаления файла."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Включите этот параметр, чтобы ранжировать только выбранные варианты. Пользователи будут перетаскивать выбранные элементы из списка вариантов, чтобы упорядочить их в области ранжирования."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Введите список вариантов, которые будут предложены респонденту во время ввода."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Этот параметр изменяет только размер полей ввода и не влияет на ширину поля вопроса."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Устанавливает одинаковую ширину для всех меток элементов в пикселях"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Опция \"Авто\" автоматически определяет подходящий режим отображения - Изображение, Видео или YouTube - на основе предоставленного исходного URL-адреса."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Служит заменой, когда изображение не может быть отображено на устройстве пользователя, а также в целях обеспечения доступности."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Определяет цвет выбранного эмодзи, если для параметра «Тип значка рейтинга» установлено значение «Смайлики». Выберите между: \"По умолчанию\" - выбранный эмодзи отображается в цвете опроса по умолчанию; «Шкала» - выбранный эмодзи наследует цвет от шкалы оценки."
// expression.name: "An expression ID that is not visible to respondents." => "Идентификатор выражения, который не виден респондентам."
// expression.description: "Type an expression subtitle." => "Введите подзаголовок выражения."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Выражение может включать базовые вычисления ('{q1_id} + {q2_id}'), условия ('{age} > 60') и функции ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' и т.д.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Выберите, чтобы сохранить значение параметра «Другое» как отдельное свойство в результатах опроса."
// p.swapOrder: "Swap the order of Yes and No" => "Поменяйте местами «Да» и «Нет»"
// p.itemTitleWidth: "Item label width (in px)" => "Ширина метки элемента (в пикселях)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Текст, показывающий, если выбраны все параметры"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Замещающий текст для области ранжирования"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Автоматическое заполнение опроса"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Выберите, хотите ли Вы, чтобы опрос завершался автоматически после того, как респондент ответит на все вопросы."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Сохранение замаскированного значения в результатах опроса"
// patternmask.pattern: "Value pattern" => "Шаблон значения"
// datetimemask.min: "Minimum value" => "Минимальное значение"
// datetimemask.max: "Maximum value" => "Максимальное значение"
// numericmask.allowNegativeValues: "Allow negative values" => "Разрешить отрицательные значения"
// numericmask.thousandsSeparator: "Thousands separator" => "Разделитель тысяч"
// numericmask.decimalSeparator: "Decimal separator" => "Десятичный разделитель"
// numericmask.precision: "Value precision" => "Точность значений"
// numericmask.min: "Minimum value" => "Минимальное значение"
// numericmask.max: "Maximum value" => "Максимальное значение"
// currencymask.prefix: "Currency prefix" => "Префикс валюты"
// currencymask.suffix: "Currency suffix" => "Суффикс валюты"
// pe.maskType: "Input mask type" => "Тип входной маски"
// maskTypes.patternmask: "Pattern" => "Рисунок"
// maskTypes.numericmask: "Numeric" => "Числовой"
// maskTypes.datetimemask: "Date and Time" => "Дата и время"
// maskTypes.currencymask: "Currency" => "Валюта"
// tabs.mask: "Input Mask Settings" => "Настройки входной маски"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Пример: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Пример: мм/дд/гггг"
// pe.currencyprefix_placeholder: "Ex.: $" => "Пример: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Пример: USD"
// pv.textWrapEnabled: "Wrap choices" => "Варианты обертывания"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Длинные тексты в параметрах выбора будут автоматически создавать разрывы строк в соответствии с раскрывающимся меню. Снимите флажок, если вы хотите, чтобы тексты были обрезаны."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Выберите, хотите ли вы сохранить значение вопроса с примененной маской в результатах опроса."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Шаблон может содержать строковые литералы и следующие заполнители: '9' - для цифры; 'a' - для прописной или строчной буквы; '#' - для цифры или прописной или строчной буквы. Используйте обратную косую черту '\\' для экранирования символа."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Шаблон может содержать символы-разделители и следующие заполнители: 'm' - номер месяца; 'mm' - номер месяца, с нулем в начале для однозначных значений; 'd' - день месяца; 'dd' - день месяца, с нулевым началом для однозначных значений; 'yy' - для последних двух цифр года; 'yyyy' - для четырехзначного года."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Символ, используемый для отделения дробной части от целой части отображаемого числа."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Символ, используемый для разделения цифр большого числа на группы по три."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Ограничивает количество цифр, сохраняемых после десятичной запятой для отображаемого числа."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Один или несколько символов, которые будут отображаться перед значением."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Один или несколько символов, которые будут отображаться после значения."
// ed.translationSource: "Source: " => "Источник: "
// ed.translationTarget: "Target: " => "Цель: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Страница пуста. Перетащите элемент с панели инструментов или нажмите кнопку ниже."
// maskTypes.none: "None" => "Никакой"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Сделайте строку видимой, если"
// itemvalue@rows.enableIf: "Make the row editable if" => "Сделайте строку редактируемой, если"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Замещающий текст в режиме только для чтения или предварительного просмотра"
// pe.textWrapEnabled: "Wrap choices" => "Варианты обертывания"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Опция \"Авто\" автоматически определяет подходящий режим отображения - Изображение, Видео или YouTube - на основе предоставленного исходного URL-адреса."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Выберите между «Изображением» и «Видео», чтобы установить режим содержимого селектора мультимедиа. Если выбран параметр «Изображение», убедитесь, что все предоставленные параметры представляют собой файлы изображений в следующих форматах: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Точно так же, если выбран «Видео», убедитесь, что все параметры являются прямыми ссылками на видеофайлы в следующих форматах: MP4, MOV, WMV, FLV, AVI, MKV. Обратите внимание, что ссылки на YouTube не поддерживаются для параметров видео."
// ed.selectFile: "Select a file" => "Выберите файл"
// ed.removeFile: "Remove the file" => "Удалите файл"
// pe.searchMode: "Search Mode" => "Режим поиска"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Нажмите кнопку «Добавить вопрос» ниже, чтобы начать создание формы."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Нажмите кнопку «Добавить вопрос» ниже, чтобы добавить новый элемент на страницу."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Нажмите кнопку «Добавить вопрос» ниже, чтобы добавить новый элемент на панель."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Нажмите кнопку ниже и выберите изображение для загрузки"
// coloralpha.opacity: "Opacity" => "Непрозрачность"
// font.family: "Font family" => "Семейство шрифтов"
// font.color: "Color" => "Цвет"
// font.placeholderColor: "Placeholder color" => "Цвет заполнителя"
// font.size: "Size" => "Размер"
// theme.themeName: "Theme" => "Тема"
// theme.isPanelless: "Question appearance" => "Внешний вид вопроса"
// theme.editorPanel: "Background and corner radius" => "Радиус фона и угла"
// theme.questionPanel: "Background and corner radius" => "Радиус фона и угла"
// theme.primaryColor: "Accent color" => "Акцентный цвет"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Непрозрачность фона панели"
// theme.questionBackgroundTransparency: "Question background opacity" => "Непрозрачность фона вопроса"
// theme.fontSize: "Font size" => "Размер шрифта"
// theme.scale: "Scale" => "Шкала"
// theme.cornerRadius: "Corner radius" => "Радиус закругления угла"
// theme.pageTitle: "Title font" => "Шрифт заголовка"
// theme.pageDescription: "Description font" => "Описание шрифта"
// theme.questionTitle: "Title font" => "Шрифт заголовка"
// theme.questionDescription: "Description font" => "Описание шрифта"
// theme.editorFont: "Font" => "Шрифт"
// theme.backgroundOpacity: "Opacity" => "Непрозрачность"
// theme.--sjs-font-family: "Font family" => "Семейство шрифтов"
// theme.--sjs-general-backcolor-dim: "Background color" => "Цвет фона"
// theme.--sjs-primary-backcolor: "Accent background" => "Акцентный фон"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Акцент на переднем плане"
// theme.--sjs-shadow-small: "Shadow effects" => "Эффекты теней"
// theme.--sjs-shadow-inner: "Shadow effects" => "Эффекты теней"
// theme.--sjs-border-default: "Colors" => "Знамя"
// header@header.headerView: "View" => "Вид"
// header@header.logoPosition: "Logo position" => "Расположение логотипа"
// header@header.surveyTitle: "Survey title font" => "Шрифт заголовка опроса"
// header@header.surveyDescription: "Survey description font" => "Шрифт описания опроса"
// header@header.headerTitle: "Survey title font" => "Шрифт заголовка опроса"
// header@header.headerDescription: "Survey description font" => "Шрифт описания опроса"
// header@header.inheritWidthFrom: "Content area width" => "Ширина области содержимого"
// header@header.textAreaWidth: "Text width" => "Ширина текста"
// header@header.backgroundColorSwitch: "Background color" => "Цвет фона"
// header@header.backgroundImage: "Background image" => "Фоновое изображение"
// header@header.backgroundImageOpacity: "Opacity" => "Непрозрачность"
// header@header.overlapEnabled: "Overlap" => "Перекрытие"
// header@header.logoPositionX: "Logo position" => "Расположение логотипа"
// header@header.titlePositionX: "Title position" => "Титульная позиция"
// header@header.descriptionPositionX: "Description position" => "Описание позиции"
// weight.400: "Regular" => "Регулярный"
// weight.600: "Heavy" => "Тяжелый"
// weight.700: "Semi-bold" => "Полужирный"
// weight.800: "Bold" => "Смелый"
// backgroundImageFit.auto: "Auto" => "Авто"
// backgroundImageFit.cover: "Cover" => "Крышка"
// backgroundImageFit.contain: "Contain" => "Содержать"
// backgroundImageFit.fill: "Stretch" => "Натягивать"
// backgroundImageFit.tile: "Tile" => "Кафель"
// backgroundImageAttachment.fixed: "Fixed" => "Неподвижный"
// backgroundImageAttachment.scroll: "Scroll" => "Свиток"
// headerView.basic: "Basic" => "Основной"
// headerView.advanced: "Advanced" => "Продвинутый"
// inheritWidthFrom.survey: "Same as survey" => "То же, что и опрос"
// inheritWidthFrom.container: "Fit to container" => "Подходит для контейнера"
// backgroundColorSwitch.none: "None" => "Никакой"
// backgroundColorSwitch.accentColor: "Accent color" => "Акцентный цвет"
// backgroundColorSwitch.custom: "Custom" => "Обычай"
// colorPalette.light: "Light" => "Свет"
// colorPalette.dark: "Dark" => "Темный"
// isPanelless.false: "Default" => "По умолчанию"
// isPanelless.true: "Without Panels" => "Без панелей"
// theme.cornerRadius: "Corner radius" => "Радиус закругления угла"
// theme.fontFamily: "Font family" => "Семейство шрифтов"
// theme.fontWeightRegular: "Regular" => "Регулярный"
// theme.fontWeightHeavy: "Heavy" => "Тяжелый"
// theme.fontWeightSemiBold: "Semi-bold" => "Полужирный"
// theme.fontWeightBold: "Bold" => "Смелый"
// theme.color: "Color" => "Цвет"
// theme.placeholderColor: "Placeholder color" => "Цвет заполнителя"
// theme.size: "Size" => "Размер"
// theme.opacity: "Opacity" => "Непрозрачность"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Введите для поиска..."
// ed.toolboxNoResultsFound: "No results found" => "Никаких результатов не найдено"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Заполнитель заголовка вкладки"
// theme.--sjs-special-red: "Error messages" => "Сообщения об ошибках"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Резервный текст для заголовков вкладок, который применяется, когда шаблон заголовка вкладки не дает осмысленного значения."
// theme.fontColor: "Font color" => "Цвет шрифта"
// theme.backgroundColor: "Background color" => "Цвет фона"
// pe.questionTitleWidth: "Question title width" => "Ширина заголовка вопроса"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Выберите файл или вставьте ссылку на файл..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Пример: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Задает одинаковую ширину заголовков вопросов, если они выровнены по левому краю полей вопросов. Принимает значения CSS (px, %, in, pt и т. д.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Задает одинаковую ширину заголовков вопросов, если они выровнены по левому краю полей вопросов. Принимает значения CSS (px, %, in, pt и т. д.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Высота области комментариев (в строках)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Задает количество отображаемых строк в текстовых областях для комментариев к вопросам. При вводе занимает больше строк, появляется полоса прокрутки."


/***/ }),

/***/ "./src/localization/simplified-chinese.ts":
/*!************************************************!*\
  !*** ./src/localization/simplified-chinese.ts ***!
  \************************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var simplifiedChineseTranslation = {
    // survey templates
    survey: {
        edit: "编辑",
        externalHelpLink: "教学小片",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "从左侧工具箱拖个问题",
        addLogicItem: "创建规则以自定义调查流。",
        copy: "复制",
        duplicate: "重复",
        addToToolbox: "添加到工具箱",
        deletePanel: "删除面板",
        deleteQuestion: "删除题目",
        convertTo: "转变为",
        drag: "拖放元件",
    },
    // Creator tabs
    tabs: {
        preview: "测试问卷",
        theme: "主题",
        translation: "转换",
        designer: "问卷设计器",
        editor: "JSON 编辑器",
        logic: "逻辑"
    },
    // Question types
    qt: {
        default: "默认",
        checkbox: "多项选择",
        comment: "多行文本",
        imagepicker: "选图片",
        ranking: "排名",
        image: "图像",
        dropdown: "下拉框",
        tagbox: "多选下拉列表",
        file: "文件上传",
        html: "Html 代码",
        matrix: "矩阵 (单选题)",
        matrixdropdown: "矩阵 (下拉框)",
        matrixdynamic: "矩阵 (动态问题)",
        multipletext: "文本框组",
        panel: "面板",
        paneldynamic: "面板(动态)",
        radiogroup: "单项选择",
        rating: "评分",
        text: "单行文本",
        boolean: "逻辑项",
        expression: "表达式(只读)",
        signaturepad: "签名",
        buttongroup: "按钮组"
    },
    toolboxCategories: {
        general: "一般",
        choice: "选择题",
        text: "文本输入问题",
        containers: "器皿",
        matrix: "矩阵问题",
        misc: "杂项"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "默认语言 ({0})",
        survey: "调查问卷",
        settings: "问卷设置",
        settingsTooltip: "打开设置",
        surveySettings: "调查设置",
        surveySettingsTooltip: "调查设置",
        themeSettings: "主题设置",
        themeSettingsTooltip: "主题设置",
        showPanel: "显示面板",
        hidePanel: "“隐藏”面板",
        prevSelected: "选择上一个",
        nextSelected: "选择下一步",
        prevFocus: "焦点 上一页",
        nextFocus: "接下来的重点",
        surveyTypeName: "调查",
        pageTypeName: "页",
        panelTypeName: "面板",
        questionTypeName: "问题",
        columnTypeName: "列",
        addNewPage: "添加新页面",
        moveRight: "滚动到右侧",
        moveLeft: "滚动到左侧",
        deletePage: "删除页面",
        editPage: "编辑页面",
        edit: "编辑",
        newPageName: "页面",
        newQuestionName: "问题",
        newPanelName: "面板",
        newTextItemName: "文本",
        defaultV2Theme: "违约",
        modernTheme: "摩登",
        defaultTheme: "默认（旧版）",
        testSurveyAgain: "再次测试问卷",
        testSurveyWidth: "问卷宽度: ",
        navigateToMsg: "你必须导航到",
        saveSurvey: "保存问卷",
        saveSurveyTooltip: "保存调查",
        saveTheme: "保存主题",
        saveThemeTooltip: "保存主题",
        jsonHideErrors: "隐藏错误",
        jsonShowErrors: "显示错误",
        undo: "撤销",
        redo: "恢复",
        undoTooltip: "撤消上次更改",
        redoTooltip: "重做更改",
        showMoreChoices: "显示更多",
        showLessChoices: "显示更少",
        copy: "复制",
        cut: "切",
        paste: "糊",
        copyTooltip: "将所选内容复制到剪贴板",
        cutTooltip: "将所选内容剪切到剪贴板",
        pasteTooltip: "从剪贴板粘贴",
        options: "选项",
        generateValidJSON: "生成 JSON 数据",
        generateReadableJSON: "生成易读的 JSON 数据",
        toolbox: "工具箱",
        "property-grid": "性能",
        toolboxFilteredTextPlaceholder: "键入以搜索...",
        toolboxNoResultsFound: "未找到结果",
        propertyGridFilteredTextPlaceholder: "键入以搜索...",
        propertyGridNoResultsFound: "未找到结果",
        correctJSON: "请修正 JSON 数据",
        surveyResults: "问卷结果: ",
        surveyResultsTable: "表格形式",
        surveyResultsJson: "JSON形式",
        resultsTitle: "问题标题",
        resultsName: "问题名称",
        resultsValue: "答案名称",
        resultsDisplayValue: "显示答案",
        modified: "已修改",
        saving: "保存中...",
        saved: "已保存",
        propertyEditorError: "错误",
        saveError: "错误，未保存",
        translationPropertyGridTitle: "语言设置",
        themePropertyGridTitle: "主题设置",
        translationLanguages: "语言",
        translationDeleteLanguage: "您确定要删除此语言的所有字符串吗？",
        translationAddLanguage: "语言选择",
        translationShowAllStrings: "全部名词",
        translationShowUsedStringsOnly: "仅使用的字符串",
        translationShowAllPages: "全部页面",
        translationNoStrings: "未翻译，重新选",
        translationExportToSCVButton: "导出CSV",
        translationImportFromSCVButton: "导入CSV",
        translateUsigAI: "自动翻译全部",
        translateUsigAIFrom: "翻译语言组合：",
        translationDialogTitle: "未翻译的字符串",
        translationMergeLocaleWithDefault: "同默认合并 {0} ",
        translationPlaceHolder: "译本。。。",
        translationSource: "源：",
        translationTarget: "目标：",
        themeExportButton: "出口",
        themeImportButton: "进口",
        surveyJsonExportButton: "出口",
        surveyJsonImportButton: "进口",
        surveyJsonCopyButton: "复制到剪贴板",
        themeResetButton: "将主题设置重置为默认值",
        themeResetConfirmation: "你真的要重置主题吗？您的所有自定义项都将丢失。",
        themeResetConfirmationOk: "是，重置主题",
        bold: "加粗",
        italic: "斜体",
        underline: "下划线",
        addNewQuestion: "添加问题",
        selectPage: "选择页面...",
        carryForwardChoicesCopied: "选择是从",
        choicesLoadedFromWebText: "选项是从 Web 服务加载的。",
        choicesLoadedFromWebLinkText: "前往“设置”",
        choicesLoadedFromWebPreviewTitle: "加载选项的预览",
        htmlPlaceHolder: "HTML内容将在这里。",
        panelPlaceHolder: "在此处从工具箱中删除问题。",
        surveyPlaceHolder: "调查为空。从工具箱中拖动元素或单击下面的按钮。",
        pagePlaceHolder: "页面为空。从工具箱中拖动元素或单击下面的按钮。",
        imagePlaceHolder: "将图像拖放到此处或单击下面的按钮并选择要上传的图像",
        surveyPlaceHolderMobile: "单击下面的“添加问题”按钮开始创建表单。",
        pagePlaceHolderMobile: "单击下面的“添加问题”按钮，向页面添加新元素。",
        panelPlaceHolderMobile: "单击下面的“添加问题”按钮，将新元素添加到面板中。",
        imagePlaceHolderMobile: "点击下面的按钮，选择要上传的图片",
        imageChooseImage: "选择图像",
        addNewTypeQuestion: "添加{0}",
        chooseLogoPlaceholder: "[徽标]",
        choices_Item: "项目",
        selectFile: "选择文件",
        removeFile: "删除文件",
        lg: {
            addNewItem: "添加新规则",
            empty_tab: "创建规则以自定义调查流。",
            page_visibilityName: "显示（隐藏）页面",
            page_enableName: "启用（禁用）页面",
            page_requireName: "将页面设为必填项",
            panel_visibilityName: "“显示（隐藏）”面板",
            panel_enableName: "启用（禁用）面板",
            panel_requireName: "将页面设为必填项",
            question_visibilityName: "显示（隐藏）问题",
            question_enableName: "启用（禁用）问题",
            question_requireName: "提出必填题",
            question_resetValueName: "重置问题值",
            question_setValueName: "设置问题值",
            column_visibilityName: "显示（隐藏）列",
            column_enableName: "启用（禁用）列",
            column_requireName: "使列成为必填项",
            column_resetValueName: "重置列值",
            column_setValueName: "设置列值",
            trigger_completeName: "完成调查",
            trigger_setvalueName: "设置答案",
            trigger_copyvalueName: "复制答案",
            trigger_skipName: "跳至问题",
            trigger_runExpressionName: "运行表达式",
            completedHtmlOnConditionName: "设置“调查完成”页面标记",
            page_visibilityDescription: "使页面在逻辑表达式返回 true 时可见。否则保持不可见。",
            panel_visibilityDescription: "使面板在逻辑表达式返回 true 时可见。否则保持不可见。",
            panel_enableDescription: "使面板及其中的所有元素在逻辑表达式返回 true 时启用。否则，请禁用它们。",
            question_visibilityDescription: "使问题在逻辑表达式返回 true 时可见。否则保持不可见。",
            question_enableDescription: "使问题在逻辑表达式返回 true 时启用。否则将其禁用。",
            question_requireDescription: "当逻辑表达式返回 true 时，问题变为必需。",
            trigger_completeDescription: "当逻辑表达式返回 true 时，调查将完成，最终用户将看到“谢谢页面”。",
            trigger_setvalueDescription: "当逻辑表达式中使用的问题值发生更改并且逻辑表达式返回 true 时，该值将设置为所选问题。",
            trigger_copyvalueDescription: "当逻辑表达式中使用的问题值发生更改并且逻辑表达式返回 true 时，一个选定问题的值将复制到另一个选定问题。",
            trigger_skipDescription: "当逻辑表达式返回 true 时，调查将跳到/聚焦所选问题。",
            trigger_runExpressionDescription: "当逻辑表达式返回 true 时，将执行自定义表达式。您可以选择将此表达式结果设置为所选问题",
            completedHtmlOnConditionDescription: "如果逻辑表达式返回 true，则“感谢页面”的默认文本将更改为给定的文本。",
            itemExpressionText: "当表达式：“{0}”返回 true",
            itemEmptyExpressionText: "新规则",
            page_visibilityText: "使页面{0}可见",
            panel_visibilityText: "使面板{0}可见",
            panel_enableText: "使面板{0}启用",
            question_visibilityText: "使问题{0}可见",
            question_enableText: "使问题{0}启用",
            question_requireText: "将问题{0}为必填项",
            question_resetValueText: "重置问题的值：{0}",
            question_setValueText: "分配值：{1}问题：{0}",
            column_visibilityText: "使问题{1}的列{0}可见",
            column_enableText: "使问题{1}列{0}启用",
            column_requireText: "{0}将问题{1}列为必填项",
            column_resetValueText: "重置列的单元格值：{0}",
            column_setValueText: "将单元格值：{1}分配给列：{0}",
            setValueExpressionPlaceholder: "其结果将分配给目标问题的表达式。",
            trigger_completeText: "调查完成",
            trigger_setvalueText: "受到质疑：{0}价值{1}",
            trigger_setvalueEmptyText: "明确问题值：{0}",
            trigger_copyvalueText: "复制到问题：{0}问题 {1} 的值",
            trigger_skipText: "调查 跳至问题{0}",
            trigger_runExpressionText1: "运行表达式：“{0}”",
            trigger_runExpressionText2: "并质疑其结果：{0}",
            completedHtmlOnConditionText: "显示“感谢页面”的自定义文本。",
            showAllQuestions: "所有问题",
            showAllActionTypes: "所有操作类型",
            conditions: "条件",
            actions: "操作 （s）",
            expressionEditorTitle: "定义条件",
            actionsEditorTitle: "定义操作",
            deleteAction: "删除操作",
            addNewAction: "添加操作",
            selectedActionCaption: "选择操作...",
            expressionInvalid: "逻辑表达式为空或无效。请更正。",
            noActionError: "请至少添加一个操作。",
            actionInvalid: "请解决操作中的问题。",
            uncompletedRule_title: "逻辑规则不完整",
            uncompletedRule_text: "您尚未完成某些逻辑规则。如果现在离开该选项卡，更改将丢失。是否仍要离开选项卡而不完成更改？",
            uncompletedRule_apply: "是的",
            uncompletedRule_cancel: "不，我想完成规则"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "面板名称",
            title: "面板标题",
            description: "面板说明",
            visibleIf: "如果出现以下情况，则使面板可见",
            requiredIf: "如果出现以下情况，则使面板成为必需的",
            questionsOrder: "小组内的问题顺序",
            page: "父页面",
            startWithNewLine: "在新行上显示面板",
            state: "面板折叠状态",
            width: "内嵌面板宽度",
            minWidth: "最小面板宽度",
            maxWidth: "最大面板宽度",
            showNumber: "数字面板"
        },
        paneldynamic: {
            name: "面板名称",
            title: "面板标题",
            description: "面板说明",
            visibleIf: "如果出现以下情况，则使面板可见",
            requiredIf: "如果出现以下情况，则使面板成为必需的",
            page: "将面板移动到页面",
            startWithNewLine: "在新行上显示面板",
            state: "面板折叠状态",
            width: "内嵌面板宽度",
            minWidth: "最小面板宽度",
            maxWidth: "最大面板宽度",
            confirmDelete: "确认面板删除",
            templateDescription: "面板描述模式",
            templateTitle: "面板标题模式",
            noEntriesText: "空面板文本",
            templateTabTitle: "选项卡标题模式",
            tabTitlePlaceholder: "选项卡标题占位符",
            templateVisibleIf: "如果出现以下情况，则使单个面板可见",
            hideNumber: "隐藏面板编号",
            titleLocation: "面板标题对齐方式",
            descriptionLocation: "面板描述对齐方式",
            templateTitleLocation: "问题标题对齐方式",
            templateErrorLocation: "错误消息对齐",
            newPanelPosition: "新面板位置",
            keyName: "防止在以下问题中重复回答"
        },
        question: {
            name: "问题名称",
            title: "问题标题",
            description: "问题描述",
            visibleIf: "如果出现以下情况，请使问题可见",
            requiredIf: "如果出现以下情况，则将问题设为必填项",
            page: "父页面",
            state: "问题框折叠状态",
            hideNumber: "隐藏问题编号",
            titleLocation: "问题标题对齐方式",
            descriptionLocation: "问题描述对齐方式",
            errorLocation: "错误消息对齐",
            indent: "增加内部缩进",
            width: "内联问题宽度",
            minWidth: "最小问题宽度",
            maxWidth: "最大问题宽度",
            textUpdateMode: "更新输入字段值"
        },
        signaturepad: {
            signatureWidth: "签名区域宽度",
            signatureHeight: "签名区域高度",
            signatureAutoScaleEnabled: "自动缩放签名区域",
            showPlaceholder: "显示占位符",
            placeholder: "占位符文本",
            placeholderReadOnly: "只读或预览模式下的占位符文本",
            allowClear: "在签名区域内显示“清除”按钮",
            penMinWidth: "最小笔宽",
            penMaxWidth: "最大笔宽",
            penColor: "描边颜色"
        },
        comment: {
            rows: "输入字段高度（以行为单位）"
        },
        showQuestionNumbers: "显示问题编号",
        questionStartIndex: "问题起始标志 (1, 2 or 'A', 'a')",
        expression: {
            name: "表达式名称",
            title: "表达式标题",
            description: "表达式说明",
            expression: "表达"
        },
        trigger: {
            expression: "表达"
        },
        calculatedvalue: {
            expression: "表达"
        },
        // survey templates
        survey: {
            title: "标题",
            description: "调查说明"
        },
        page: {
            name: "页面名称",
            title: "标题",
            description: "页面描述",
            visibleIf: "如果出现以下情况，则使页面可见",
            requiredIf: "如果出现以下情况，则使页面为必填项",
            maxTimeToFinish: "完成页面的时间限制（以秒为单位）",
            questionsOrder: "页面上的问题顺序"
        },
        matrixdropdowncolumn: {
            name: "列名称",
            title: "专栏标题",
            isUnique: "防止重复响应",
            width: "列宽",
            minWidth: "最小列宽",
            rows: "输入字段高度（以行为单位）",
            visibleIf: "如果出现以下情况，则使列可见",
            requiredIf: "如果满足以下条件，则使该列为必填项",
            showInMultipleColumns: "每个选项都在单独的列中"
        },
        multipletextitem: {
            name: "名字",
            title: "标题"
        },
        masksettings: {
            saveMaskedValue: "在调查结果中保存掩码值"
        },
        patternmask: {
            pattern: "价值模式"
        },
        datetimemask: {
            min: "最小值",
            max: "最大值"
        },
        numericmask: {
            allowNegativeValues: "允许负值",
            thousandsSeparator: "千分隔符",
            decimalSeparator: "小数点分隔符",
            precision: "值精度",
            min: "最小值",
            max: "最大值"
        },
        currencymask: {
            prefix: "货币前缀",
            suffix: "货币后缀"
        },
        imageHeight: "图片高度",
        imageWidth: "图片宽度",
        valueName: "值名",
        rateDescriptionLocation: "标签对齐",
        size: "输入字段大小（以字符为单位）",
        cellErrorLocation: "单元格错误消息对齐方式",
        apply: "应用",
        ok: "确定",
        save: "救",
        clear: "清楚",
        saveTooltip: "救",
        cancel: "取消",
        set: "设置",
        reset: "重置",
        change: "改变",
        refresh: "刷新",
        close: "关闭",
        delete: "删除",
        add: "加",
        addNew: "新建",
        addItem: "添加项...",
        removeItem: "单击以删除该项目...",
        dragItem: "拖动项目",
        addOther: "其他",
        addSelectAll: "全选",
        addNone: "无",
        removeAll: "全部删除",
        edit: "编辑器",
        back: "退货而不保存",
        backTooltip: "退货而不保存",
        saveAndBack: "保存并返回",
        saveAndBackTooltip: "保存并返回",
        doneEditing: "做",
        editChoices: "编辑选项",
        showChoices: "显示选项",
        move: "移动",
        empty: "<空>",
        emptyValue: "值为空",
        fastEntry: "快速输入",
        fastEntryNonUniqueError: "值“{0}”不是唯一的",
        fastEntryChoicesCountError: "请将项目数量限制在{0}到{1}",
        fastEntryChoicesMinCountError: "请输入至少{0}项目",
        fastEntryPlaceholder: "您可以按以下格式设置数据：\n值 1|文本\n值2",
        formEntry: "表单输入",
        testService: "测试服务",
        itemSelectorEmpty: "请选择元素",
        conditionActionEmpty: "请选择操作",
        conditionSelectQuestion: "选择问题...",
        conditionSelectPage: "选择页面...",
        conditionSelectPanel: "选择面板...",
        conditionValueQuestionTitle: "选择值",
        aceEditorHelp: "trl+space公式补完提示",
        aceEditorRowTitle: "当前行",
        aceEditorPanelTitle: "当前面板",
        showMore: "更多细节请查看文档",
        assistantTitle: "Available questions:",
        cellsEmptyRowsColumns: "至少有1行",
        showPreviewBeforeComplete: "在提交调查之前预览答案",
        overridingPropertyPrefix: "设置者",
        resetToDefaultCaption: "重置",
        propertyIsEmpty: "请为该属性设定一个值",
        propertyIsNoUnique: "请输入唯一值",
        propertyNameIsNotUnique: "请输入唯一名称",
        propertyNameIsIncorrect: "不要使用保留字：“项目”、“选项”、“面板”、“行”。",
        listIsEmpty: "尚未添加任何项目",
        "listIsEmpty@choices": "尚未添加任何选项",
        "listIsEmpty@columns": "您还没有任何列",
        "listIsEmpty@rows": "您还没有任何行",
        "listIsEmpty@validators": "尚无任何验证规则",
        "listIsEmpty@calculatedValues": "您还没有任何自定义变量",
        "listIsEmpty@triggers": "您还没有任何触发器",
        "listIsEmpty@navigateToUrlOnCondition": "您还没有任何链接",
        "addNew@choices": "添加选项",
        "addNew@columns": "添加新列",
        "addNew@rows": "添加新行",
        "addNew@validators": "添加新规则",
        "addNew@calculatedValues": "添加新变量",
        "addNew@triggers": "添加新触发器",
        "addNew@navigateToUrlOnCondition": "添加新 URL",
        expressionIsEmpty: "表达式为空",
        value: "值",
        text: "显示文本",
        rowid: "行号",
        imageLink: "图片链接",
        columnEdit: "编辑列: {0}",
        itemEdit: "编辑选项: {0}",
        url: "URL",
        path: "路径",
        choicesbyurl: {
            url: "Web 服务的 URL",
            valueName: "从以下 JSON 字段中获取值"
        },
        titleName: "标题名",
        imageLinkName: "从以下 JSON 字段获取图像网址",
        allowEmptyResponse: "允许空响应",
        titlePlaceholder: "标题",
        surveyTitlePlaceholder: "调查标题",
        pageTitlePlaceholder: "页数 {num}",
        descriptionPlaceholder: "描述",
        surveyDescriptionPlaceholder: "描述",
        pageDescriptionPlaceholder: "描述",
        textWrapEnabled: "换行选项",
        showOtherItem: "可添加其他答案?",
        otherText: "其他答案文本",
        showNoneItem: "无",
        showRefuseItem: "允许“拒绝应答”选项",
        showDontKnowItem: "允许“不知道”选项",
        noneText: "无文本",
        showSelectAllItem: "有全选项",
        selectAllText: "选择全部文本",
        choicesMin: "选项最小值",
        choicesMax: "选项最大值",
        choicesStep: "选项间隔",
        name: "题目名",
        title: "题目文本",
        cellType: "单元格类型",
        colCount: "列数",
        choicesOrder: "设置选项顺序",
        visible: "是否可见?",
        isRequired: "是否为必填项?",
        markRequired: "标记为必填",
        removeRequiredMark: "删除所需的标记",
        isAllRowRequired: "要求所有行都回答",
        eachRowUnique: "防止行中出现重复响应",
        requiredErrorText: "错误文字",
        startWithNewLine: "问题是否新起一行?",
        rows: "文本框行数",
        cols: "列",
        placeholder: "占位文本",
        showPreview: "是否显示图像预览?",
        storeDataAsText: "以 JSON 文本方式存储文件",
        maxSize: "文件最大尺寸 (Bytes)",
        rowCount: "默认行数",
        columnLayout: "列布局",
        addRowLocation: "添加行按钮位置",
        transposeData: "将行转置为列",
        addRowText: "添加条目按钮文本",
        removeRowText: "删除条目按钮文本",
        rateMin: "最小评分",
        rateMax: "最大评分",
        rateStep: "评分间隔",
        minRateDescription: "最小值提示",
        maxRateDescription: "最大值提示",
        inputType: "文本框类型",
        optionsCaption: "下拉框提示语",
        defaultValue: "默认值",
        cellsDefaultRow: "Default cells texts",
        surveyEditorTitle: "问卷设置",
        qEditorTitle: "编辑问题: {0}",
        maxLength: "最大长度",
        buildExpression: "建",
        editExpression: "编辑",
        and: "和",
        or: "或",
        remove: "删除",
        addCondition: "添加条件",
        emptyLogicPopupMessage: "选择一个问题以开始配置条件。",
        if: "如果",
        then: "然后",
        setToName: "目标问题",
        fromName: "要从中复制答案的问题",
        gotoName: "要跳到的问题",
        ruleIsNotSet: "规则不正确",
        includeIntoResult: "包含在调查结果中",
        showTitle: "显示/隐藏 标题",
        expandCollapseTitle: "展开/折叠标题",
        locale: "默认语言",
        simulator: "选择设备类型",
        landscapeOrientation: "切换到横向",
        portraitOrientation: "切换到纵向",
        mode: "模式 (编辑/只读)",
        clearInvisibleValues: "清除隐藏值",
        cookieName: "Cookie名，避免多次运行)",
        sendResultOnPageNext: "切换页时保存结果",
        storeOthersAsComment: "其他值单独储存",
        showPageTitles: "显示页面标题",
        showPageNumbers: "显示页数",
        pagePrevText: "前一页按钮文本",
        pageNextText: "后一页按钮文本",
        completeText: "完成按钮文本",
        previewText: "“预览答案”按钮文本",
        editText: "编辑应答按钮文本",
        startSurveyText: "开始按钮文本",
        showNavigationButtons: "显示导航按钮 (默认导航)",
        showPrevButton: "显示前一页按钮 (用户可返回至前一页面)",
        firstPageIsStarted: "调查的第一页面为起始页.",
        showCompletedPage: "结尾展示完成后的页面 (completedHtml)",
        goNextPageAutomatic: "回答本页所有问题后，自动跳转到下一页",
        allowCompleteSurveyAutomatic: "自动完成调查",
        showProgressBar: "显示进度条",
        questionTitleLocation: "问题的标题位置",
        questionTitleWidth: "问题标题宽度",
        requiredText: "问题必填标志",
        questionTitleTemplate: "问题标题模板, 默认为: '{no}. {require} {title}'",
        questionErrorLocation: "问题错误定位",
        focusFirstQuestionAutomatic: "改变页面时聚焦在第一个问题",
        questionsOrder: "页内问题顺序",
        maxTimeToFinish: "完成调查的最长时间",
        maxTimeToFinishPage: "完成调查中页面的最长时间",
        showTimerPanel: "显示计时器面板",
        showTimerPanelMode: "显示计时器面板模式",
        renderMode: "渲染模式",
        allowAddPanel: "允许添加面板",
        allowRemovePanel: "允许删除面板",
        panelAddText: "添加面板文本",
        panelRemoveText: "删除面板文本",
        isSinglePage: "在一个页面上展示所有元素",
        html: "Html",
        setValue: "答",
        dataFormat: "图像格式",
        allowAddRows: "允许添加行",
        allowRemoveRows: "允许删除行",
        allowRowsDragAndDrop: "允许行拖放",
        responsiveImageSizeHelp: "如果指定确切的图像宽度或高度，则不适用。",
        minImageWidth: "最小图像宽度",
        maxImageWidth: "最大图像宽度",
        minImageHeight: "最小图像高度",
        maxImageHeight: "最大图像高度",
        minValue: "最小值",
        maxValue: "最大值",
        minLength: "最小长度",
        allowDigits: "允许的位数",
        minCount: "最小数量",
        maxCount: "最大数量",
        regex: "正则表达式",
        surveyvalidator: {
            text: "错误信息",
            expression: "验证表达式"
        },
        totalText: "总文本",
        totalType: "总类型",
        totalExpression: "总公式",
        totalDisplayStyle: "总显示风格",
        totalCurrency: "总currency",
        totalFormat: "总格式",
        logo: "徽标（URL 或 base64 编码的字符串）",
        questionsOnPageMode: "调查结构",
        maxTextLength: "最大答案长度（以字符为单位）",
        maxOthersLength: "最大注释长度（以字符为单位）",
        commentAreaRows: "评论区高度（以行为单位）",
        autoGrowComment: "如有必要，自动展开评论区域",
        allowResizeComment: "允许用户调整文本区域的大小",
        textUpdateMode: "更新文本问题值",
        maskType: "输入掩码类型",
        maskTypes: {
            none: "没有",
            patternmask: "模式",
            numericmask: "数值的",
            datetimemask: "日期和时间",
            currencymask: "货币"
        },
        focusOnFirstError: "将焦点放在第一个无效答案上",
        checkErrorsMode: "运行验证",
        navigateToUrl: "导航到网址",
        navigateToUrlOnCondition: "动态网址",
        completedBeforeHtml: "用于显示用户是否已填写此调查的标记",
        completedHtml: "调查完成页面标记",
        completedHtmlOnCondition: "动态调查完成页面标记",
        loadingHtml: "加载调查模型时要显示的标记",
        commentText: "注释区文本",
        autocomplete: "自动完成类型",
        labelTrue: "“真实”标签",
        labelFalse: "“虚假”标签",
        allowClear: "显示“清除”按钮",
        searchMode: "搜索模式",
        displayStyle: "值显示样式",
        format: "带格式的字符串",
        maximumFractionDigits: "最大小数位数",
        minimumFractionDigits: "最小小数位数",
        useGrouping: "显示分组分隔符",
        allowMultiple: "允许多个文件",
        allowImagesPreview: "预览图像",
        acceptedTypes: "接受的文件类型",
        waitForUpload: "等待上传完成",
        needConfirmRemoveFile: "确认文件删除",
        detailPanelMode: "详细信息面板位置",
        minRowCount: "最小行数",
        maxRowCount: "最大行数",
        confirmDelete: "确认删除行",
        confirmDeleteText: "确认消息",
        panelCount: "初始面板计数",
        minPanelCount: "最小面板数",
        maxPanelCount: "最大面板数",
        panelsState: "内面板展开状态",
        panelPrevText: "“上一个面板”按钮工具提示",
        panelNextText: "“下一个面板”按钮工具提示",
        showRangeInProgress: "显示进度条",
        panelRemoveButtonLocation: "“删除面板”按钮位置",
        hideIfRowsEmpty: "如果没有行，则隐藏问题",
        hideColumnsIfEmpty: "如果没有行，则隐藏列",
        rateValues: "自定义费率值",
        rateCount: "速率计数",
        autoGenerate: "如何指定速率值？",
        hideIfChoicesEmpty: "如果问题不包含任何选项，则隐藏问题",
        minWidth: "最小宽度（以 CSS 接受的值为单位）",
        maxWidth: "最大宽度（以 CSS 接受的值为单位）",
        width: "宽度（以 CSS 接受的值为单位）",
        showHeader: "显示列标题",
        horizontalScroll: "显示水平滚动条",
        columnMinWidth: "最小列宽（以 CSS 接受的值为单位）",
        rowTitleWidth: "行标题宽度（以 CSS 接受的值为单位）",
        valueTrue: "“真”值",
        valueFalse: "“假”值",
        minErrorText: "“值低于最小值”错误消息",
        maxErrorText: "“值超过最大值”错误消息",
        otherErrorText: "“空评论”错误消息",
        keyDuplicationError: "“非唯一键值”错误消息",
        minSelectedChoices: "最少选择的选项",
        maxSelectedChoices: "最大选定选项数",
        showClearButton: "显示“清除”按钮",
        logoWidth: "徽标宽度（以 CSS 接受的值为单位）",
        logoHeight: "徽标高度（以 CSS 接受的值为单位）",
        readOnly: "只读",
        enableIf: "可编辑，如果",
        emptyRowsText: "“无行”消息",
        separateSpecialChoices: "单独的特殊选项（无、其他、全选）",
        choicesFromQuestion: "复制以下问题的选项",
        choicesFromQuestionMode: "要复制哪些选项？",
        progressBarShowPageTitles: "在进度条中显示页面标题",
        progressBarShowPageNumbers: "在进度条中显示页码",
        showCommentArea: "显示评论区域",
        commentPlaceholder: "注释区占位符",
        displayRateDescriptionsAsExtremeItems: "将速率描述显示为极值",
        rowsOrder: "行顺序",
        columnsLayout: "列布局",
        columnColCount: "嵌套列计数",
        correctAnswer: "正确答案",
        defaultPanelValue: "默认值",
        cells: "单元格文本",
        fileInputPlaceholder: "选择文件或粘贴文件链接...",
        keyName: "键列",
        itemvalue: {
            visibleIf: "如果出现以下情况，则使该选项可见",
            enableIf: "如果出现以下情况，则使该选项可选"
        },
        "itemvalue@rows": {
            visibleIf: "如果出现以下情况，则使行可见",
            enableIf: "如果出现以下情况，则使行可编辑"
        },
        imageitemvalue: {
            text: "可选文字"
        },
        logoPosition: "徽标位置",
        addLogo: "添加徽标...",
        changeLogo: "更改徽标...",
        logoPositions: {
            none: "删除徽标",
            left: "左",
            right: "右",
            top: "在顶部",
            bottom: "在底部"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "面板布局"
            },
            general: "一般",
            fileOptions: "选项",
            html: "HTML 编辑器",
            columns: "设置列",
            rows: "设置行",
            choices: "设置选项",
            items: "项目",
            visibleIf: "设置可见条件",
            enableIf: "设置有效条件",
            requiredIf: "如果",
            rateValues: "设置评分值",
            choicesByUrl: "通过 URL 导入选项",
            matrixChoices: "默认选项",
            multipleTextItems: "文本输入",
            numbering: "编号",
            validators: "校验规则",
            navigation: "导航",
            question: "问题",
            pages: "页面",
            timer: "问卷计时器",
            calculatedValues: "计算值",
            triggers: "触发器",
            templateTitle: "标题模板",
            totals: "总数",
            logic: "逻辑",
            mask: "输入掩码设置",
            layout: {
                panel: "布局",
                question: "布局",
                base: "布局"
            },
            data: "数据",
            validation: "验证",
            cells: "单元格文本",
            showOnCompleted: "调查完成",
            logo: "调查标题中的徽标",
            slider: "滑 块",
            expression: "表达",
            questionSettings: "问题设置",
            header: "页眉",
            background: "背景",
            appearance: "外观",
            others: "别人"
        },
        editProperty: "编辑属性: '{0}'",
        items: "[ 项目数量: {0} ]",
        choicesVisibleIf: "在以下情况下，选项可见",
        choicesEnableIf: "在以下情况下，可以选择选项",
        columnsEnableIf: "在以下情况下，列可见",
        rowsEnableIf: "在以下情况下，行可见",
        innerIndent: "添加内部缩进",
        defaultValueFromLastRow: "从最后一行获取默认值",
        defaultValueFromLastPanel: "从最后一个面板中获取默认值",
        enterNewValue: "请设定值",
        noquestions: "问卷中还没有创建任何问题",
        createtrigger: "请创建触发器",
        titleKeyboardAdornerTip: "按回车键编辑",
        keyboardAdornerTip: "按回车键编辑项目，按删除按钮删除项目，按 Alt 加向上箭头或向下箭头移动项目",
        triggerOn: "当 ",
        triggerMakePagesVisible: "使页面可见:",
        triggerMakeQuestionsVisible: "使问题可见:",
        triggerCompleteText: "如果满足条件，则完成问卷",
        triggerNotSet: "触发器尚未设置",
        triggerRunIf: "满足下列条件时执行",
        triggerSetToName: "修改下列问题值: ",
        triggerFromName: "复制值: ",
        triggerRunExpression: "运行公式:",
        triggerSetValue: "修改为: ",
        triggerGotoName: "转到问题",
        triggerIsVariable: "在问卷提交结果中不要包含该变量",
        triggerRunExpressionEmpty: "请输入有效的表达式",
        emptyExpressionPlaceHolder: "在此处键入表达式...",
        noFile: "未选择任何文件",
        clearIfInvisible: "如果问题被隐藏，则清除该值",
        valuePropertyName: "值属性名称",
        searchEnabled: "启用搜索",
        hideSelectedItems: "隐藏所选项目",
        closeOnSelect: "选择后关闭下拉列表",
        verticalAlign: "垂直对齐",
        alternateRows: "交替行",
        columnsVisibleIf: "在以下情况下，列可见",
        rowsVisibleIf: "在以下情况下，行可见",
        otherPlaceholder: "注释区占位符",
        filePlaceholder: "文件占位符文本",
        photoPlaceholder: "照片占位符文本",
        fileOrPhotoPlaceholder: "文件或照片占位符文本",
        rateType: "费率类型",
        url_placeholder: "例如：https://api.example.com/books",
        path_placeholder: "例如：categories.fiction",
        questionStartIndex_placeholder: "例如：a）",
        width_placeholder: "例：6in",
        minWidth_placeholder: "例如：600px",
        maxWidth_placeholder: "例：50%",
        imageHeight_placeholder: "自动",
        imageWidth_placeholder: "自动",
        theme: {
            themeName: "主题",
            isPanelless: "问题外观",
            editorPanel: "背景和拐角半径",
            questionPanel: "背景和拐角半径",
            primaryColor: "强调色",
            panelBackgroundTransparency: "面板背景不透明度",
            questionBackgroundTransparency: "问题背景不透明度",
            fontSize: "字体大小",
            scale: "规模",
            cornerRadius: "拐角半径",
            pageTitle: "标题字体",
            pageDescription: "描述字体",
            questionTitle: "标题字体",
            questionDescription: "描述字体",
            editorFont: "字体",
            backgroundOpacity: "不透明度",
            "--sjs-font-family": "字体家族",
            "--sjs-general-backcolor-dim": "背景颜色",
            "--sjs-primary-backcolor": "重音背景",
            "--sjs-primary-forecolor": "重音前景",
            "--sjs-special-red": "错误消息",
            "--sjs-shadow-small": "阴影效果",
            "--sjs-shadow-inner": "阴影效果",
            "--sjs-border-default": "颜色"
        },
        "header@header": {
            headerView: "视图",
            logoPosition: "徽标位置",
            surveyTitle: "调查标题字体",
            surveyDescription: "调查描述字体",
            headerTitle: "调查标题字体",
            headerDescription: "调查描述字体",
            inheritWidthFrom: "内容区宽度",
            textAreaWidth: "文本宽度",
            backgroundColorSwitch: "背景颜色",
            backgroundImage: "背景图片",
            backgroundImageOpacity: "不透明度",
            overlapEnabled: "重叠",
            logoPositionX: "徽标位置",
            titlePositionX: "标题位置",
            descriptionPositionX: "描述位置"
        }
    },
    // Property values
    pv: {
        "true": "真",
        "false": "假",
        file: "本地文件",
        camera: "照相机",
        "file-camera": "本地文件或相机",
        inherit: "继承",
        show: "显示",
        hide: "隐藏",
        default: "默认",
        initial: "初始化",
        random: "随机",
        collapsed: "折叠",
        expanded: "扩展",
        none: "无",
        asc: "升序",
        desc: "降序",
        indeterminate: "indeterminate",
        selected: "选择",
        unselected: "未选中",
        decimal: "十进制",
        currency: "货币",
        percent: "百分之",
        firstExpanded: "firstExpanded",
        off: "关闭",
        list: "列表",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        tab: "制表符",
        horizontal: "水平",
        vertical: "垂直",
        top: "顶",
        bottom: "底",
        topBottom: "顶和底",
        both: "双",
        left: "左",
        right: "右",
        center: "中心",
        leftRight: "左和右",
        middle: "中间",
        color: "颜色",
        date: "日期",
        datetime: "日期时间",
        "datetime-local": "日期时间-本地",
        email: "电子邮件",
        month: "月",
        number: "数",
        password: "密码",
        range: "范围",
        tel: "电话",
        text: "发短信",
        time: "时间",
        url: "网址",
        week: "周",
        hidden: "隐藏",
        edit: "编辑",
        display: "仅显示",
        contain: "包含",
        cover: "盖",
        fill: "填补",
        next: "下一个",
        last: "最后",
        onComplete: "完成时",
        onHidden: "隐藏中",
        onHiddenContainer: "当问题或其面板/页面被隐藏时",
        clearInvisibleValues: {
            none: "从不"
        },
        clearIfInvisible: {
            none: "从不"
        },
        inputType: {
            color: "颜色",
            date: "日期",
            "datetime-local": "日期和时间",
            email: "电子邮件",
            month: "月",
            number: "数",
            password: "密码",
            range: "范围",
            tel: "电话号码",
            text: "发短信",
            time: "时间",
            url: "网址",
            week: "周"
        },
        all: "全部",
        page: "页",
        survey: "问卷",
        onNextPage: "下一页时",
        onValueChanged: "值变动时",
        onValueChanging: "更改答案之前",
        questionsOnPageMode: {
            standard: "原始结构",
            singlePage: "在一个页面上显示所有问题",
            questionPerPage: "每页显示一个问题"
        },
        noPreview: "无预览",
        showAllQuestions: "显示所有问题",
        showAnsweredQuestions: "仅显示已回答的问题",
        pages: "已完成的页面",
        questions: "已回答的问题",
        requiredQuestions: "回答必填问题",
        correctQuestions: "有效答案",
        buttons: "已完成的页面（按钮 UI）",
        underInput: "在输入下",
        underTitle: "在标题下",
        onBlur: "模糊时",
        onTyping: "打字时",
        underRow: "在行下",
        underRowSingle: "在该行下，只有一个面板可见",
        auto: "自动",
        showNavigationButtons: {
            none: "隐藏"
        },
        showTimerPanel: {
            none: "隐藏"
        },
        showTimerPanelMode: {
            all: "双"
        },
        addRowLocation: {
            default: "取决于矩阵布局"
        },
        panelsState: {
            default: "用户无法展开或折叠面板",
            collapsed: "所有面板均已折叠",
            expanded: "所有面板均已展开",
            firstExpanded: "首次扩展"
        },
        widthMode: {
            static: "静态的",
            responsive: "响应"
        },
        contentMode: {
            image: "图像",
            video: "视频",
            youtube: "优酷"
        },
        displayMode: {
            buttons: "按钮",
            dropdown: "下拉列表"
        },
        rateColorMode: {
            default: "违约",
            scale: "规模"
        },
        scaleColorMode: {
            monochrome: "单色",
            colored: "彩色"
        },
        autoGenerate: {
            "true": "生成",
            "false": "手动输入"
        },
        rateType: {
            labels: "标签",
            stars: "星星",
            smileys: "笑脸"
        },
        state: {
            default: "锁"
        },
        showQuestionNumbers: {
            default: "自动编号",
            on: "自动编号",
            onPage: "在每个页面上重置",
            onpanel: "在每个面板上重置",
            onPanel: "在每个面板上重置",
            onSurvey: "在整个调查中继续",
            off: "无编号"
        },
        descriptionLocation: {
            underTitle: "在问题标题下",
            underInput: "在输入字段下"
        },
        selectToRankAreasLayout: {
            horizontal: "在选项旁边",
            vertical: "以上选择"
        },
        displayStyle: {
            decimal: "十进制",
            currency: "货币",
            percent: "百分比",
            date: "日期"
        },
        totalDisplayStyle: {
            decimal: "十进制",
            currency: "货币",
            percent: "百分比",
            date: "日期"
        },
        rowsOrder: {
            initial: "源语言"
        },
        questionsOrder: {
            initial: "源语言"
        },
        showProgressBar: {
            off: "隐藏",
            topbottom: "顶和底",
            aboveheader: "标题上方",
            belowheader: "在标题下方"
        },
        sum: "和",
        count: "计数",
        min: "最小值",
        max: "麦克斯",
        avg: "平均",
        searchMode: {
            contains: "包含",
            startsWith: "开头为"
        },
        backgroundImageFit: {
            auto: "自动",
            cover: "盖",
            contain: "包含",
            fill: "伸展",
            tile: "瓦"
        },
        backgroundImageAttachment: {
            fixed: "固定",
            scroll: "滚动"
        },
        headerView: {
            basic: "基本",
            advanced: "高深"
        },
        inheritWidthFrom: {
            survey: "与调查相同",
            container: "适合容器"
        },
        backgroundColorSwitch: {
            none: "没有",
            accentColor: "强调色",
            custom: "习惯"
        },
        colorPalette: {
            light: "光",
            dark: "黑暗"
        },
        isPanelless: {
            "false": "违约",
            "true": "不带面板"
        }
    },
    // Operators
    op: {
        empty: "为空",
        notempty: "不为空",
        equal: "等于",
        notequal: "不等于",
        contains: "包含",
        notcontains: "不包含",
        anyof: "任意",
        allof: "全部",
        greater: "大于",
        less: "小于",
        greaterorequal: "大于等于",
        lessorequal: "小于等于",
        and: "和",
        or: "或"
    },
    // Embed window
    ew: {
        angular: "使用 Angular 时",
        jquery: "使用 JQuery 时",
        knockout: "使用 Knockout 时",
        react: "使用 React 时",
        vue: "使用 Vue 时",
        bootstrap: "使用 Bootstrap 时",
        modern: "现代主题",
        default: "默认主题",
        orange: "橙色主题",
        darkblue: "深蓝色主题",
        darkrose: "“暗玫瑰”主题",
        stone: "“石头”主题",
        winter: "“冬季”主题",
        winterstone: "“冬日之石”主题",
        showOnPage: "嵌入页面显示",
        showInWindow: "使用单独的问卷窗口",
        loadFromServer: "从服务器加载问卷 JSON 数据",
        titleScript: "脚本和样式",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "选择测试页",
        showInvisibleElements: "显示隐藏元件",
        hideInvisibleElements: "隐藏不可见元素"
    },
    validators: {
        answercountvalidator: "数量检查",
        emailvalidator: "Email",
        expressionvalidator: "公式",
        numericvalidator: "数字",
        regexvalidator: "正则表达式",
        textvalidator: "文本"
    },
    triggers: {
        completetrigger: "完成问卷",
        setvaluetrigger: "设置问题值",
        copyvaluetrigger: "复制值",
        skiptrigger: "跳至问题",
        runexpressiontrigger: "运行公式",
        visibletrigger: "修改可见性"
    },
    peplaceholder: {
        patternmask: {
            pattern: "例如：+1（999）-999-99-99"
        },
        datetimemask: {
            pattern: "例：mm/dd/yyyy"
        },
        currencymask: {
            prefix: "例：$",
            suffix: "例如：美元"
        },
        panelbase: {
            questionTitleWidth: "例如：200px"
        }
    },
    pehelp: {
        panel: {
            name: "受访者不可见的面板 ID。",
            description: "键入面板字幕。",
            visibleIf: "使用魔棒图标设置确定面板可见性的条件规则。",
            enableIf: "使用魔棒图标设置禁用面板只读模式的条件规则。",
            requiredIf: "使用魔杖图标设置条件规则，除非至少有一个嵌套问题有答案，否则该规则将阻止调查提交。",
            questionTitleLocation: "适用于此面板中的所有问题。如果要覆盖此设置，请为单个问题定义标题对齐规则。“继承”选项应用页面级别（如果已设置）或调查级别设置（默认为“顶部”）。",
            questionTitleWidth: "当问题标题与问题框左侧对齐时，为问题标题设置一致的宽度。接受 CSS 值（px、%、in、pt 等）。",
            questionErrorLocation: "设置与面板中所有问题相关的错误消息的位置。“继承”选项应用页面级别（如果已设置）或调查级别设置。",
            questionsOrder: "保持问题的原始顺序或随机化问题。“继承”选项应用页面级别（如果已设置）或调查级别设置。",
            page: "将面板重新定位到所选页面的末尾。",
            innerIndent: "在面板内容和面板框的左边框之间添加空格或边距。",
            startWithNewLine: "取消选择以将面板与上一个问题或面板显示在一行中。如果面板是窗体中的第一个元素，则该设置不适用。",
            state: "从中选择：“展开” - 面板完整显示，可以折叠;“已折叠” - 面板仅显示标题和描述，可以展开;“已锁定” - 面板完整显示，无法折叠。",
            width: "设置面板的宽度，使其与同一行中的其他测量图元成比例。接受 CSS 值（px、%、in、pt 等）。"
        },
        paneldynamic: {
            name: "受访者不可见的面板 ID。",
            description: "键入面板字幕。",
            visibleIf: "使用魔棒图标设置确定面板可见性的条件规则。",
            enableIf: "使用魔棒图标设置禁用面板只读模式的条件规则。",
            requiredIf: "使用魔杖图标设置条件规则，除非至少有一个嵌套问题有答案，否则该规则将阻止调查提交。",
            templateTitleLocation: "适用于此面板中的所有问题。如果要覆盖此设置，请为单个问题定义标题对齐规则。“继承”选项应用页面级别（如果已设置）或调查级别设置（默认为“顶部”）。",
            templateErrorLocation: "设置与输入无效的问题相关的错误消息的位置。选择：“顶部” - 错误文本放置在问题框的顶部;“底部” - 错误文本放置在问题框的底部。“继承”选项应用页面级别（如果已设置）或调查级别设置（默认为“顶部”）。",
            errorLocation: "设置与面板中所有问题相关的错误消息的位置。“继承”选项应用页面级别（如果已设置）或调查级别设置。",
            page: "将面板重新定位到所选页面的末尾。",
            innerIndent: "在面板内容和面板框的左边框之间添加空格或边距。",
            startWithNewLine: "取消选择以将面板与上一个问题或面板显示在一行中。如果面板是窗体中的第一个元素，则该设置不适用。",
            state: "从中选择：“展开” - 面板完整显示，可以折叠;“已折叠” - 面板仅显示标题和描述，可以展开;“已锁定” - 面板完整显示，无法折叠。",
            width: "设置面板的宽度，使其与同一行中的其他测量图元成比例。接受 CSS 值（px、%、in、pt 等）。",
            templateTitle: "键入动态面板标题的模板。使用 {panelIndex} 作为面板的常规位置，使用 {visiblePanelIndex} 作为其在可见面板中的顺序。将这些占位符插入到图案中以添加自动编号。",
            templateTabTitle: "键入选项卡标题的模板。使用 {panelIndex} 表示面板的大致位置，使用 {visiblePanelIndex} 表示其在可见面板中的顺序。将这些占位符插入到图案中以添加自动编号。",
            tabTitlePlaceholder: "选项卡标题的回退文本，当选项卡标题模式未生成有意义的值时应用。",
            templateVisibleIf: "此设置允许您控制动态面板中各个面板的可见性。使用“{panel}”占位符在表达式中引用当前面板。",
            titleLocation: "此面板中的所有问题都会自动继承此设置。如果要覆盖此设置，请为单个问题定义标题对齐规则。“继承”选项应用页面级别（如果已设置）或调查级别设置（默认为“顶部”）。",
            descriptionLocation: "“继承”选项应用页面级别（如果已设置）或调查级别设置（默认为“在面板标题下”）。",
            newPanelPosition: "定义新添加的面板的位置。默认情况下，新面板将添加到末尾。选择“下一步”以在当前面板之后插入新面板。",
            defaultValueFromLastPanel: "复制上一个面板中的答案，并将其分配给下一个添加的动态面板。",
            keyName: "引用问题名称以要求用户在每个面板中为此问题提供唯一的答案。"
        },
        defaultValueExpression: "此设置允许您根据表达式分配默认答案值。表达式可以包括基本计算 - '{q1_id} + {q2_id}'、布尔表达式，例如 '{age} > 60'，以及函数：'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）'等。此表达式确定的值用作初始默认值，可由响应者的手动输入覆盖。",
        resetValueIf: "使用魔杖图标设置条件规则，该规则确定何时将受访者的输入重置为基于“默认值表达式”或“设置值表达式”的值，或重置为“默认答案”值（如果设置了其中任何一个）。",
        setValueIf: "使用魔杖图标设置条件规则，该规则确定何时运行“设置值表达式”，并将结果值动态分配为响应。",
        setValueExpression: "指定一个表达式，该表达式定义在满足“如果设置值”规则中的条件时要设置的值。表达式可以包括基本计算 - '{q1_id} + {q2_id}'、布尔表达式，例如 '{age} > 60'，以及函数：'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）'等。由此表达式确定的值可以被受访者的手动输入覆盖。",
        question: {
            name: "受访者不可见的问题 ID。",
            description: "键入问题副标题。",
            visibleIf: "使用魔杖图标设置确定问题可见性的条件规则。",
            enableIf: "使用魔杖图标设置条件规则，以禁用问题的只读模式。",
            requiredIf: "使用魔杖图标设置条件规则，除非问题得到答案，否则阻止调查推进或提交。",
            startWithNewLine: "取消选择以将问题与上一个问题或面板显示在一行中。如果问题是表单中的第一个元素，则该设置不适用。",
            page: "将问题重新定位到所选页面的末尾。",
            state: "从以下选项中选择：“展开” - 问题框完整显示，可以折叠;“已折叠” - 问题框仅显示标题和描述，可以展开;“已锁定” - 问题框完整显示，无法折叠。",
            titleLocation: "覆盖在面板、页面或调查级别上定义的标题对齐规则。“继承”选项将应用任何更高级别的设置（如果已设置）或调查级别的设置（默认为“顶部”）。",
            descriptionLocation: "“继承”选项应用调查级别设置（默认为“在问题标题下”）。",
            errorLocation: "设置与输入无效的问题相关的错误消息的位置。选择：“顶部” - 错误文本放置在问题框的顶部;“底部” - 错误文本放置在问题框的底部。“继承”选项将应用调查级别设置（默认为“顶部”）。",
            indent: "在问题内容和问题框的左边框之间添加空格或边距。",
            width: "设置问题的宽度，使其与同一行中的其他调查元素成比例。接受 CSS 值（px、%、in、pt 等）。",
            surveyvalidator: {
                expression: "使用魔杖图标为问题设置验证规则。"
            },
            textUpdateMode: "从中选择：“失焦时” - 当输入字段失去焦点时，该值会更新;“键入时” - 当用户键入时，该值会实时更新。“继承”选项将应用调查级别设置（默认为“失去焦点时”）。",
            url: "您可以使用任何 Web 服务作为多项选择题的数据源。要填充选项值，请输入提供数据的服务的 URL。",
            searchMode: "用于筛选下拉列表的比较操作。",
            textWrapEnabled: "选项选项中的长文本将自动生成换行符以适合下拉菜单。如果要剪裁文本，请取消选择。"
        },
        signaturepad: {
            signatureWidth: "设置显示的签名区域和生成的图像的宽度。",
            signatureHeight: "设置显示的签名区域和生成的图像的高度。",
            signatureAutoScaleEnabled: "选择是否希望签名区域填充问题框中的所有可用空间，同时保持默认的 3：2 纵横比。设置自定义宽度和高度值后，该设置将保留这些尺寸的纵横比。"
        },
        file: {
            imageHeight: "调整调查结果中图像的高度。",
            imageWidth: "调整调查结果中图像的宽度。"
        },
        image: {
            contentMode: "“自动”选项会根据提供的源 URL 自动确定适合的显示模式 - 图像、视频或 YouTube。"
        },
        imagepicker: {
            imageHeight: "覆盖最小和最大高度值。",
            imageWidth: "覆盖最小和最大宽度值。",
            choices: "“值”用作条件规则中使用的项目 ID;向受访者显示“文本”。",
            contentMode: "在“图像”和“视频”之间进行选择以设置媒体选择器的内容模式。如果选择“图像”，请确保提供的所有选项都是以下格式的图像文件：JPEG、GIF、PNG、APNG、SVG、BMP、ICO。同样，如果选择“视频”，请确保所有选项都是指向以下格式的视频文件的直接链接：MP4、MOV、WMV、FLV、AVI、MKV。请注意，视频选项不支持 YouTube 链接。"
        },
        text: {
            size: "此设置仅调整输入字段的大小，不会影响问题框的宽度。要限制接受的输入长度，请转到<b>验证→最大字符限制</b>。"
        },
        comment: {
            rows: "设置输入字段中显示的行数。如果输入占用更多行，则会出现滚动条。"
        },
        // survey templates
        survey: {
            mode: "选择：“可编辑” - 使受访者能够填写您的调查;“只读” - 禁用表单编辑。"
        },
        matrixdropdowncolumn: {
            name: "受访者不可见的列 ID。",
            isUnique: "为列启用后，受访者需要为此列中的每个问题提供唯一的回答。",
            rows: "设置输入字段中显示的行数。如果输入占用更多行，则会出现滚动条。",
            visibleIf: "使用魔杖图标设置确定列可见性的条件规则。",
            enableIf: "使用魔杖图标设置禁用列只读模式的条件规则。",
            requiredIf: "使用魔杖图标设置条件规则，除非至少有一个嵌套问题有答案，否则该规则将阻止调查提交。",
            showInMultipleColumns: "选中后，为每个选项创建一个单独的列。"
        },
        widthMode: "从以下选项中选择： “静态” - 设置固定宽度;“响应式” - 使调查占据屏幕的整个宽度;“自动” - 根据所使用的问题类型应用两者中的任何一个。",
        cookieName: "Cookie 可防止用户两次填写同一调查问卷。",
        logo: "粘贴图像链接（无大小限制）或单击文件夹图标以浏览计算机中的文件（最大 64KB）。",
        logoWidth: "以 CSS 单位（px、%、in、pt 等）设置徽标宽度。",
        logoHeight: "以 CSS 单位（px、%、in、pt 等）设置徽标高度。",
        logoFit: "从以下选项中选择：“无” - 图像保持其原始大小;“包含” - 调整图像大小以适应其纵横比;“封面” - 图像填充整个框，同时保持其纵横比;“填充” - 拉伸图像以填充框，而不保持其纵横比。",
        goNextPageAutomatic: "选择是否希望调查在受访者回答当前页面上的所有问题后自动前进到下一页。",
        allowCompleteSurveyAutomatic: "选择是否希望在受访者回答所有问题后自动完成调查。",
        showNavigationButtons: "设置导航按钮在页面上的可见性和位置。",
        showProgressBar: "设置进度条的可见性和位置。“自动”值显示测量标题上方或下方的进度条。",
        showPreviewBeforeComplete: "启用仅包含所有问题或已回答问题的预览页面。",
        questionTitleLocation: "适用于调查中的所有问题。此设置可以被较低级别的标题对齐规则覆盖：面板、页面或问题。较低级别的设置将覆盖较高级别的设置。",
        requiredText: "一个符号或一系列符号，表示需要答案。",
        questionStartIndex: "输入要开始编号的数字或字母。",
        questionErrorLocation: "设置与输入无效的问题相关的错误消息的位置。选择：“顶部” - 错误文本放置在问题框的顶部;“底部” - 错误文本放置在问题框的底部。",
        focusFirstQuestionAutomatic: "选择是否希望每个页面上的第一个输入字段准备好进行文本输入。",
        questionsOrder: "保持问题的原始顺序或随机化问题。此设置的效果仅在“预览”选项卡中可见。",
        maxTextLength: "仅适用于文本输入问题。",
        maxOthersLength: "仅供问题评论。",
        commentAreaRows: "设置问题注释的文本区域中显示的行数。在输入占用更多行时，将出现滚动条。",
        autoGrowComment: "选择是否希望问题注释和长文本问题根据输入的文本长度自动增加高度。",
        allowResizeComment: "仅适用于问题评论和长文本问题。",
        calculatedValues: "自定义变量用作表单计算中使用的中间变量或辅助变量。他们将受访者的输入作为源值。每个自定义变量都有一个唯一的名称和它所基于的表达式。",
        includeIntoResult: "选择是否希望将表达式的计算值与调查结果一起保存。",
        triggers: "触发器是基于表达式的事件或条件。一旦表达式被计算为“true”，触发器就会触发一个操作。这样的操作可以选择性地影响它的目标问题。",
        clearInvisibleValues: "选择是否清除条件逻辑隐藏的问题的值以及何时清除。",
        textUpdateMode: "从中选择：“失焦时” - 当输入字段失去焦点时，该值会更新;“键入时” - 当用户键入时，该值会实时更新。",
        columns: "左边的值用作条件规则中使用的列 ID，右边的值显示给受访者。",
        rows: "左边的值用作条件规则中使用的行 ID，右边的值显示给受访者。",
        columnMinWidth: "接受 CSS 值（px、%、in、pt 等）。",
        rowTitleWidth: "接受 CSS 值（px、%、in、pt 等）。",
        totalText: "仅当至少一列具有 Total 类型或 Total 表达式时才可见。",
        cellErrorLocation: "设置与输入无效的单元格相关的错误消息的位置。“继承”选项应用“错误消息对齐”属性中的设置。",
        keyDuplicationError: "启用“防止重复响应”属性后，尝试提交重复条目的受访者将收到以下错误消息。",
        totalExpression: "允许您根据表达式计算总值。表达式可以包括基本计算 （'{q1_id} + {q2_id}'）、布尔表达式 （'{age} > 60'） 和函数 （'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）' 等）。",
        confirmDelete: "触发提示，要求确认删除行。",
        defaultValueFromLastRow: "复制最后一行的答案，并将其分配给下一个添加的动态行。",
        keyName: "如果指定的列包含相同的值，则调查将引发“非唯一键值”错误。",
        description: "键入副标题。",
        locale: "选择一种语言以开始创建调查。要添加翻译，请切换到新语言，然后在此处或“翻译”选项卡中翻译原始文本。",
        detailPanelMode: "设置详细信息部分相对于行的位置。从中选择：“无” - 不添加扩展;“Under the row” - 矩阵的每一行下都放置一个行扩展;“在行下，仅显示一行扩展” - 仅在单行下显示扩展，其余行展开将折叠。",
        imageFit: "从以下选项中选择：“无” - 图像保持其原始大小;“包含” - 调整图像大小以适应其纵横比;“封面” - 图像填充整个框，同时保持其纵横比;“填充” - 拉伸图像以填充框，而不保持其纵横比。",
        autoGrow: "在输入数据时逐渐增加输入字段的高度。覆盖“输入字段高度（以行为单位）”设置。",
        allowResize: "调整大小的手柄（或手柄）出现在角落，可以拖动以更改输入字段的大小。",
        maxTimeToFinish: "以秒为单位的时间间隔，在此时间间隔之后，调查将自动前进到“感谢”页面。",
        maxTimeToFinishPage: "以秒为单位的时间间隔，在此时间间隔之后，调查将自动前进到下一页。",
        page: {
            maxTimeToFinish: "以秒为单位的时间间隔，在此时间间隔之后，调查将自动前进到下一页。",
            visibleIf: "使用魔杖图标设置确定页面可见性的条件规则。",
            enableIf: "使用魔杖图标设置禁用页面只读模式的条件规则。",
            requiredIf: "使用魔杖图标设置条件规则，除非至少有一个嵌套问题有答案，否则该规则将阻止调查提交。",
            questionTitleLocation: "适用于本页中的所有问题。如果要覆盖此设置，请为单个问题或面板定义标题对齐规则。“继承”选项将应用调查级别设置（默认为“顶部”）。",
            questionTitleWidth: "当问题标题与问题框左侧对齐时，为问题标题设置一致的宽度。接受 CSS 值（px、%、in、pt 等）。",
            questionErrorLocation: "设置与输入无效的问题相关的错误消息的位置。选择：“顶部” - 错误文本放置在问题框的顶部;“底部” - 错误文本放置在问题框的底部。“继承”选项将应用调查级别设置（默认为“顶部”）。",
            questionsOrder: "保持问题的原始顺序或随机化问题。“继承”选项应用调查级别设置（默认为“原始”）。此设置的效果仅在“预览”选项卡中可见。",
            navigationButtonsVisibility: "设置导航按钮在页面上的可见性。“继承”选项应用调查级别设置，默认为“可见”。"
        },
        showTimerPanel: "设置计时器在页面上的可见性和位置。",
        panelsState: "从以下选项中选择：“锁定” - 用户无法展开或折叠面板;“全部折叠” - 所有面板都以折叠状态启动;“全部展开” - 所有面板都以展开状态启动;“首先展开” - 最初只有第一个面板被展开。",
        imageLinkName: "在对象数组中输入共享属性名称，该数组包含要在选项列表中显示的图像或视频文件 URL。",
        choices: "左边的值用作条件规则中使用的项目 ID，右边的值显示给受访者。",
        title: "键入要显示的用户友好标题。",
        waitForUpload: "确保用户在上传文件之前不会完成调查。",
        minWidth: "接受 CSS 值（px、%、in、pt 等）。",
        maxWidth: "接受 CSS 值（px、%、in、pt 等）。",
        width: "接受 CSS 值（px、%、in、pt 等）。",
        valueName: "如果未设置此属性，则答案将存储在 Name 属性指定的字段中。",
        useDisplayValuesInDynamicTexts: "在单选题和多选题类型中，每个选项都有一个 ID 和显示值。选中此设置后，将在 HTML 问题以及调查元素的动态标题和描述中显示显示值，而不是 ID 值。",
        clearIfInvisible: "选择是否清除条件逻辑隐藏的问题值以及何时清除。“继承”选项应用调查级别设置（默认为“完成调查后”）。",
        choicesFromQuestionMode: "从以下选项中选择：“全部” - 复制所选问题中的所有选项;“Selected” - 仅动态复制选定的选项选项;“未选择” - 仅动态复制未选择的选项。默认情况下，如果在源问题中启用了“无”和“其他”选项，则会复制该选项。",
        showOtherItem: "选中后，用户可以在单独的注释框中包含其他输入。",
        separateSpecialChoices: "在新行上显示每个特殊选项（“无”、“其他”、“全选”），即使使用多列布局也是如此。",
        path: "指定服务数据集中目标对象数组所在的位置。如果 URL 已指向数组，则留空。",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "在对象数组中输入一个统一的属性名称，该数组包含要在选项列表中显示的值。",
        allowEmptyResponse: "选择此选项可允许服务返回空响应或数组。",
        choicesVisibleIf: "使用魔杖图标设置条件规则，以确定所有选项的可见性。",
        rateValues: "左边的值用作条件规则中使用的项目 ID，右边的值显示给受访者。",
        rating: {
            displayMode: "“自动”根据可用宽度在“按钮”和“下拉”模式之间进行选择。当宽度不足以显示按钮时，问题将显示一个下拉列表。"
        },
        valuePropertyName: "允许您连接以不同格式生成结果的问题。当使用联接标识符将此类问题链接在一起时，此共享属性将存储选定的问题值。",
        searchEnabled: "选择是否要更新下拉菜单内容以匹配用户在输入字段中键入的搜索查询。",
        valueTrue: "当受访者给出肯定答案时保存在调查结果中的值。",
        valueFalse: "当受访者给出否定答案时保存在调查结果中的值。",
        showPreview: "不建议禁用此选项，因为它会覆盖预览图像，并使用户难以了解文件是否已上传。",
        needConfirmRemoveFile: "触发提示，要求确认文件删除。",
        selectToRankEnabled: "启用此选项可仅对选定的选项进行排名。用户将从选项列表中拖动所选项目，以在排名区域内对它们进行排序。",
        dataList: "输入将在输入期间向受访者建议的选项列表。",
        itemSize: "该设置仅调整输入字段的大小，不会影响问题框的宽度。",
        itemTitleWidth: "为所有项目标签设置一致的宽度（以像素为单位）",
        altText: "当图像无法在用户设备上显示时，出于辅助功能的目的，可作为替代。",
        rateColorMode: "定义当评级图标类型设置为“笑脸”时所选表情符号的颜色。选择：“默认” - 所选表情符号以默认调查颜色显示;“比例” - 所选的表情符号继承了评分量表的颜色。",
        expression: {
            name: "受访者不可见的表达式 ID。",
            description: "键入表达式副标题。",
            expression: "表达式可以包括基本计算 （'{q1_id} + {q2_id}'）、条件 （'{age} > 60'） 和函数 （'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）' 等）。"
        },
        storeOthersAsComment: "选择此选项可将“其他”选项值作为单独的属性存储在调查结果中。",
        format: "使用 {0} 作为实际值的占位符。",
        acceptedTypes: "有关详细信息，请参阅 [accept]（https://www.w3schools.com/tags/att_input_accept.asp） 属性说明。",
        columnColCount: "仅适用于单选组和复选框单元类型。",
        autocomplete: "有关详细信息，请参阅 [autocomplete]（https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete） 属性说明。",
        filePlaceholder: "当“源类型”为“本地文件”或相机不可用时适用",
        photoPlaceholder: "当“源类型”为“相机”时适用。",
        fileOrPhotoPlaceholder: "当“源类型”为“本地文件或相机”时适用。",
        masksettings: {
            saveMaskedValue: "选择是否要在调查结果中存储带有应用掩码的问题值。"
        },
        patternmask: {
            pattern: "该模式可以包含字符串文字和以下占位符： '9' - 表示数字;“a” - 表示大写或小写字母;'#' - 表示数字或大写或小写字母。使用反斜杠“\\”转义字符。"
        },
        datetimemask: {
            pattern: "模式可以包含分隔符和以下占位符：“<br>m”- 月份编号。<br>'mm' - 月份编号，前导零表示个位数值。<br>'d' - 月份中的某一天。<br>'dd' - 月份的某一天，个位数值的前导为零。<br>'yy' - 年份的最后两位数字。<br>'yyyy' - 四位数年份。<br>“H” - 24 小时制的小时数。<br>“HH” - 24 小时制的小时数，个位数值的前导为零。<br>'h' - 以 12 小时为制的小时数。<br>'hh' - 12 小时制的小时数，个位数值的前导为零。<br>'MM' - 分钟。<br>'ss' - 秒。<br>“TT” - 大写 （AM/PM） 的 12 小时制周期。<br>'tt' - 小写 （am/pm） 的 12 小时制周期。"
        },
        numericmask: {
            decimalSeparator: "用于将显示数字的小数部分与整数部分分开的符号。",
            thousandsSeparator: "用于将大数的数字分成三组的符号。",
            precision: "限制显示数字的小数点后要保留的位数。"
        },
        currencymask: {
            prefix: "要在值之前显示的一个或多个符号。",
            suffix: "要在值后显示的一个或多个符号。"
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "标题",
            title: "如果与名字相同，请设置为空值"
        },
        multiSelect: "允许多项选择",
        showLabel: "显示图像标题",
        swapOrder: "交换“是”和“否”的顺序",
        value: "价值",
        tabAlign: "制表符对齐方式",
        sourceType: "源类型",
        fitToContainer: "适合容器",
        setValueExpression: "设置值表达式",
        description: "说明",
        logoFit: "徽标合身",
        pages: "页面",
        questions: "问题",
        triggers: "触发器",
        calculatedValues: "计算值",
        surveyId: "调查编号",
        surveyPostId: "调查帖子编号",
        surveyShowDataSaving: "调查显示数据保存",
        questionDescriptionLocation: "问题描述位置",
        progressBarType: "进度条类型",
        showTOC: "显示目录",
        tocLocation: "目录位置",
        questionTitlePattern: "问题标题模式",
        widthMode: "宽度模式",
        showBrandInfo: "显示品牌信息",
        useDisplayValuesInDynamicTexts: "在动态文本中使用显示值",
        visibleIf: "条件可见",
        defaultValueExpression: "默认值表达式",
        requiredIf: "是否必选",
        resetValueIf: "如果出现以下情况，则重置值",
        setValueIf: "设置值，如果",
        validators: "有效性",
        bindings: "绑定",
        renderAs: "渲染为",
        attachOriginalItems: "附加原始项目",
        choices: "选项",
        choicesByUrl: "Url选项",
        currency: "货币",
        cellHint: "单元格提示",
        totalMaximumFractionDigits: "最大小数位数总数",
        totalMinimumFractionDigits: "最小小数位数总数",
        columns: "columns",
        detailElements: "细节元素",
        allowAdaptiveActions: "允许自适应操作",
        defaultRowValue: "默认行值",
        detailPanelShowOnAdding: "添加时显示的详细信息面板",
        choicesLazyLoadEnabled: "选项延迟加载已启用",
        choicesLazyLoadPageSize: "选择延迟加载页面大小",
        inputFieldComponent: "输入字段组件",
        itemComponent: "项目组件",
        min: "最小值",
        max: "麦克斯",
        minValueExpression: "最小值表达式",
        maxValueExpression: "最大值表达式",
        step: "步",
        dataList: "数据列表",
        itemSize: "itemSize",
        itemTitleWidth: "项目标签宽度（以 px 为单位）",
        elements: "元素",
        content: "内容",
        navigationButtonsVisibility: "导航按钮可见",
        navigationTitle: "导航标题",
        navigationDescription: "导航说明",
        longTap: "长按",
        autoGrow: "自动增长",
        allowResize: "允许调整大小",
        acceptCarriageReturn: "接受回车",
        displayMode: "显示模式",
        rateType: "费率类型",
        label: "标签",
        contentMode: "内容模式",
        imageFit: "图像贴合",
        altText: "可选文字",
        height: "高度",
        penColor: "笔颜色",
        backgroundColor: "背景色",
        templateElements: "模板元素",
        operator: "算子",
        isVariable: "是可变的",
        runExpression: "运行表达式",
        showCaption: "显示标题",
        iconName: "图标名称",
        iconSize: "图标大小",
        precision: "精度",
        matrixDragHandleArea: "矩阵拖动手柄区域",
        backgroundImage: "背景图片",
        backgroundImageFit: "背景图像适合",
        backgroundImageAttachment: "背景图像附件",
        backgroundOpacity: "背景不透明度",
        selectToRankEnabled: "选择启用排名",
        selectToRankAreasLayout: "选择以对区域布局进行排名",
        selectToRankEmptyRankedAreaText: "显示是否选择了所有选项的文本",
        selectToRankEmptyUnrankedAreaText: "排名区域的占位符文本",
        allowCameraAccess: "允许摄像头访问",
        scaleColorMode: "缩放颜色模式",
        rateColorMode: "评价颜色模式",
        copyDisplayValue: "复制显示值",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "高级模式",
        pageTitle: "页面标题字体",
        questionTitle: "问题标题字体",
        editorPanel: "输入元素",
        lines: "线",
        primaryDefaultColor: "违约",
        primaryDarkColor: "悬停",
        primaryLightColor: "选择",
        backgroundDimColor: "背景色",
        cornerRadius: "拐角半径",
        backcolor: "默认背景",
        hovercolor: "悬停背景",
        borderDecoration: "边框装饰",
        fontColor: "字体颜色",
        backgroundColor: "背景颜色",
        primaryForecolor: "默认颜色",
        primaryForecolorLight: "禁用颜色",
        font: "字体",
        borderDefault: "暗",
        borderLight: "打火机",
        fontFamily: "字体家族",
        fontWeightRegular: "定期",
        fontWeightHeavy: "重",
        fontWeightSemiBold: "半粗体",
        fontWeightBold: "大胆",
        color: "颜色",
        placeholderColor: "占位符颜色",
        size: "大小",
        opacity: "不透明度",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "添加阴影效果",
        boxShadowBlur: "模糊",
        boxShadowSpread: "传播",
        boxShadowDrop: "落",
        boxShadowInner: "内",
        names: {
            default: "违约",
            sharp: "锋利",
            borderless: "无国界",
            flat: "平",
            plain: "平原",
            doubleborder: "双边框",
            layered: "分层的",
            solid: "固体",
            threedimensional: ".3D",
            contrast: "反差"
        },
        colors: {
            teal: "水鸭",
            blue: "蓝",
            purple: "紫色",
            orchid: "兰花",
            tulip: "郁金香",
            brown: "棕色",
            green: "绿"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["zh-cn"] = simplifiedChineseTranslation;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// survey.addLogicItem: "Create a rule to customize the flow of the survey." => "创建规则以自定义调查流。"
// survey.duplicate: "Duplicate" => "重复"
// qt.ranking: "Ranking" => "排名"
// qt.image: "Image" => "图像"
// qt.tagbox: "Multi-Select Dropdown" => "多选下拉列表"
// qt.signaturepad: "Signature" => "签名"
// qt.buttongroup: "Button Group" => "按钮组"
// ed.settingsTooltip: "Open settings" => "打开设置"
// ed.surveySettings: "Survey Settings" => "调查设置"
// ed.surveySettingsTooltip: "Open survey settings" => "打开调查设置"
// ed.showPanel: "Show Panel" => "显示面板"
// ed.hidePanel: "Hide Panel" => "“隐藏”面板"
// ed.prevSelected: "Select previous" => "选择上一个"
// ed.nextSelected: "Select next" => "选择下一步"
// ed.surveyTypeName: "Survey" => "调查"
// ed.pageTypeName: "Page" => "页"
// ed.panelTypeName: "Panel" => "面板"
// ed.questionTypeName: "Question" => "问题"
// ed.columnTypeName: "Column" => "列"
// ed.themeSurvey: "Themes" => "主题"
// ed.defaultV2Theme: "Default" => "违约"
// ed.modernTheme: "Modern" => "摩登"
// ed.defaultTheme: "Default (legacy)" => "默认（旧版）"
// ed.navigateToMsg: "You had to navigate to" => "你必须导航到"
// ed.logic: "Logic" => "逻辑"
// ed.saveSurveyTooltip: "Save Survey" => "保存调查"
// ed.jsonHideErrors: "Hide errors" => "隐藏错误"
// ed.jsonShowErrors: "Show errors" => "显示错误"
// ed.undoTooltip: "Undo last change" => "撤消上次更改"
// ed.redoTooltip: "Redo the change" => "重做更改"
// ed.showMoreChoices: "Show more" => "显示更多"
// ed.showLessChoices: "Show less" => "显示更少"
// ed.copy: "Copy" => "复制"
// ed.cut: "Cut" => "切"
// ed.paste: "Paste" => "糊"
// ed.copyTooltip: "Copy selection to clipboard" => "将所选内容复制到剪贴板"
// ed.cutTooltip: "Cut selection to clipboard" => "将所选内容剪切到剪贴板"
// ed.pasteTooltip: "Paste from clipboard" => "从剪贴板粘贴"
// ed.property-grid: "Properties" => "性能"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "键入以搜索..."
// ed.toolboxChoiceCategory: "Choice Questions" => "选择题"
// ed.toolboxTextCategory: "Text Input Questions" => "文本输入问题"
// ed.toolboxContainersCategory: "Containers" => "器皿"
// ed.toolboxMatrixCategory: "Matrix Questions" => "矩阵问题"
// ed.toolboxMiscCategory: "Misc" => "杂项"
// ed.propertyEditorError: "Error" => "错误"
// ed.translationPropertyGridTitle: "Language Settings" => "语言设置"
// ed.themePropertyGridTitle: "Theme Settings" => "主题设置"
// ed.translationLanguages: "Languages" => "语言"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "仅使用的字符串"
// ed.translationPlaceHolder: "Translation..." => "译本。。。"
// ed.themeExportButton: "Export" => "出口"
// ed.themeImportButton: "Import" => "进口"
// ed.selectPage: "Select page..." => "选择页面..."
// ed.carryForwardChoicesCopied: "Choices are copied from" => "选择是从"
// ed.htmlPlaceHolder: "HTML content will be here." => "HTML内容将在这里。"
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "在此处从工具箱中删除问题。"
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "调查为空。从工具箱中拖动元素或单击下面的按钮。"
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "将图像拖放到此处或单击下面的按钮并选择要上传的图像"
// ed.imageChooseImage: "Choose Image" => "选择图像"
// ed.addNewTypeQuestion: "Add {0}" => "添加{0}"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[徽标]"
// ed.auto: "auto" => "自动"
// ed.choices_Item: "Item " => "项目"
// lg.addNewItem: "Add New Rule" => "添加新规则"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "创建规则以自定义调查流。"
// lg.page_visibilityName: "Show (hide) page" => "显示（隐藏）页面"
// lg.page_enableName: "Enable (disable) page" => "启用（禁用）页面"
// lg.panel_visibilityName: "Show (hide) panel" => "“显示（隐藏）”面板"
// lg.panel_enableName: "Enable (disable) panel" => "启用（禁用）面板"
// lg.question_visibilityName: "Show (hide) question" => "显示（隐藏）问题"
// lg.question_enableName: "Enable (disable) question" => "启用（禁用）问题"
// lg.question_requireName: "Make question required" => "提出必填题"
// lg.column_visibilityName: "Show (hide) column" => "显示（隐藏）列"
// lg.column_enableName: "Enable (disable) column" => "启用（禁用）列"
// lg.column_requireName: "Make column required" => "使列成为必填项"
// lg.trigger_completeName: "Complete survey" => "完成调查"
// lg.trigger_setvalueName: "Set answer" => "设置答案"
// lg.trigger_copyvalueName: "Copy answer" => "复制答案"
// lg.trigger_skipName: "Skip to question" => "跳至问题"
// lg.trigger_runExpressionName: "Run expression" => "运行表达式"
// lg.completedHtmlOnConditionName: "Set \"Survey Complete\" page markup" => "设置“调查完成”页面标记"
// lg.page_visibilityDescription: "Make the page visible when the logic expression returns true. Otherwise keep it invisible." => "使页面在逻辑表达式返回 true 时可见。否则保持不可见。"
// lg.panel_visibilityDescription: "Make the panel visible when the logic expression returns true. Otherwise keep it invisible." => "使面板在逻辑表达式返回 true 时可见。否则保持不可见。"
// lg.panel_enableDescription: "Make the panel, and all elements inside it, enable when the logic expression returns true. Otherwise keep them disabled." => "使面板及其中的所有元素在逻辑表达式返回 true 时启用。否则，请禁用它们。"
// lg.question_visibilityDescription: "Make the question visible when the logic expression returns true. Otherwise keep it invisible." => "使问题在逻辑表达式返回 true 时可见。否则保持不可见。"
// lg.question_enableDescription: "Make the question enable when the logic expression returns true. Otherwise keep it disabled." => "使问题在逻辑表达式返回 true 时启用。否则将其禁用。"
// lg.question_requireDescription: "Question becomes required when the logic expression returns true." => "当逻辑表达式返回 true 时，问题变为必需。"
// lg.trigger_completeDescription: "When the logic expression returns true then the survey becomes completed and an end-user see the 'Thank you page'." => "当逻辑表达式返回 true 时，调查将完成，最终用户将看到“谢谢页面”。"
// lg.trigger_setvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value is set to the selected question." => "当逻辑表达式中使用的问题值发生更改并且逻辑表达式返回 true 时，该值将设置为所选问题。"
// lg.trigger_copyvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value of one selected question is copied to another selected question." => "当逻辑表达式中使用的问题值发生更改并且逻辑表达式返回 true 时，一个选定问题的值将复制到另一个选定问题。"
// lg.trigger_skipDescription: "When the logic expression returns true then the survey skip to / focus the selected question." => "当逻辑表达式返回 true 时，调查将跳到/聚焦所选问题。"
// lg.trigger_runExpressionDescription: "When the logic expression returns true, then the custom expression is performed. You may optionally set this expression result into the selected question" => "当逻辑表达式返回 true 时，将执行自定义表达式。您可以选择将此表达式结果设置为所选问题"
// lg.completedHtmlOnConditionDescription: "If the logic expression returns true, then the default text for the 'Thank you page' is changed to the given one." => "如果逻辑表达式返回 true，则“感谢页面”的默认文本将更改为给定的文本。"
// lg.itemExpressionText: "When expression: '{0}' returns true" => "当表达式：“{0}”返回 true"
// lg.itemEmptyExpressionText: "New rule" => "新规则"
// lg.page_visibilityText: "make page {0} visible" => "使页面{0}可见"
// lg.panel_visibilityText: "make panel {0} visible" => "使面板{0}可见"
// lg.panel_enableText: "make panel {0} enable" => "使面板{0}启用"
// lg.question_visibilityText: "make question {0} visible" => "使问题{0}可见"
// lg.question_enableText: "make question {0} enable" => "使问题{0}启用"
// lg.question_requireText: "make question {0} required" => "将问题{0}为必填项"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "使问题{1}的列{0}可见"
// lg.column_enableText: "make column {0} of question {1} enable" => "使问题{1}列{0}启用"
// lg.column_requireText: "make column {0} of question {1} required" => "{0}将问题{1}列为必填项"
// lg.trigger_completeText: "survey becomes completed" => "调查完成"
// lg.trigger_setvalueText: "set into question: {0} value {1}" => "受到质疑：{0}价值{1}"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "明确问题值：{0}"
// lg.trigger_copyvalueText: "copy into question: {0} value from question {1}" => "复制到问题：{0}问题 {1} 的值"
// lg.trigger_skipText: "survey skip to the question {0}" => "调查 跳至问题{0}"
// lg.trigger_runExpressionText1: "run expression: '{0}'" => "运行表达式：“{0}”"
// lg.trigger_runExpressionText2: " and set its result into question: {0}" => "并质疑其结果：{0}"
// lg.completedHtmlOnConditionText: "show custom text for the 'Thank you page'." => "显示“感谢页面”的自定义文本。"
// lg.showAllQuestions: "All Questions" => "所有问题"
// lg.showAllActionTypes: "All Action Types" => "所有操作类型"
// lg.conditions: "Condition(s)" => "条件"
// lg.actions: "Action(s)" => "操作 （s）"
// lg.expressionEditorTitle: "Define condition(s)" => "定义条件"
// lg.actionsEditorTitle: "Define action(s)" => "定义操作"
// lg.deleteAction: "Delete Action" => "删除操作"
// lg.addNewAction: "Add Action" => "添加操作"
// lg.selectedActionCaption: "Select action..." => "选择操作..."
// lg.expressionInvalid: "The logic expression is empty or invalid. Please correct it." => "逻辑表达式为空或无效。请更正。"
// lg.noActionError: "Please, add at least one action." => "请至少添加一个操作。"
// lg.actionInvalid: "Please, fix problems in your action(s)." => "请解决操作中的问题。"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "逻辑规则不完整"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "您尚未完成某些逻辑规则。如果现在离开该选项卡，更改将丢失。是否仍要离开选项卡而不完成更改？"
// lg.uncompletedRule_apply: "Yes" => "是的"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "不，我想完成规则"
// pe.save: "Save" => "救"
// pe.clear: "Clear" => "清楚"
// pe.saveTooltip: "Save" => "救"
// pe.set: "Set" => "设置"
// pe.change: "Change" => "改变"
// pe.refresh: "Refresh" => "刷新"
// pe.add: "Add" => "加"
// pe.removeItem: "Click to remove the item..." => "单击以删除该项目..."
// pe.dragItem: "Drag the item" => "拖动项目"
// pe.back: "Return without saving" => "退货而不保存"
// pe.backTooltip: "Return without saving" => "退货而不保存"
// pe.saveAndBack: "Save and return" => "保存并返回"
// pe.saveAndBackTooltip: "Save and return" => "保存并返回"
// pe.doneEditing: "Done" => "做"
// pe.showChoices: "Show Choices" => "显示选项"
// pe.emptyValue: "Value is empty" => "值为空"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "值“{0}”不是唯一的"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "请将项目数量限制在{0}到{1}"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "您可以按以下格式设置数据：\n值 1|文本\n值2"
// pe.itemSelectorEmpty: "Please select the element" => "请选择元素"
// pe.conditionActionEmpty: "Please select the action" => "请选择操作"
// pe.conditionSelectPage: "Select page..." => "选择页面..."
// pe.conditionSelectPanel: "Select panel..." => "选择面板..."
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "在提交调查之前预览答案"
// pe.overridingPropertyPrefix: "Set by " => "设置者"
// pe.propertyIsNoUnique: "Please enter a unique value" => "请输入唯一值"
// pe.propertyNameIsNotUnique: "Please enter a unique name" => "请输入唯一名称"
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "不要使用保留字：“项目”、“选项”、“面板”、“行”。"
// pe.listIsEmpty: "No items have been added yet" => "尚未添加任何项目"
// pe.listIsEmpty@choices: "No choices have been added yet" => "尚未添加任何选项"
// pe.addNew@choices: "Add a choice" => "添加选项"
// pe.expressionIsEmpty: "Expression is empty" => "表达式为空"
// choicesbyurl.valueName: "Get values from the following JSON field" => "从以下 JSON 字段中获取值"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "从以下 JSON 字段获取图像网址"
// pe.allowEmptyResponse: "Allow empty response" => "允许空响应"
// pe.titlePlaceholder: "Title" => "标题"
// pe.surveyTitlePlaceholder: "Survey Title" => "调查标题"
// pe.pageTitlePlaceholder: "Page {num}" => "页数 {num}"
// pe.descriptionPlaceholder: "Description" => "描述"
// pe.surveyDescriptionPlaceholder: "Description" => "描述"
// pe.pageDescriptionPlaceholder: "Description" => "描述"
// pe.isAllRowRequired: "Require answer for all rows" => "要求所有行都回答"
// pe.cols: "Columns" => "列"
// pe.buildExpression: "Build" => "建"
// pe.editExpression: "Edit" => "编辑"
// pe.and: "and" => "和"
// pe.or: "or" => "或"
// pe.remove: "Remove" => "删除"
// pe.addCondition: "Add Condition" => "添加条件"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "选择一个问题以开始配置条件。"
// pe.if: "If" => "如果"
// pe.then: "then" => "然后"
// pe.setToName: "Target question" => "目标问题"
// pe.fromName: "Question to copy answer from" => "要从中复制答案的问题"
// pe.gotoName: "Question to skip to" => "要跳到的问题"
// pe.ruleIsNotSet: "Rule is incorrect" => "规则不正确"
// pe.includeIntoResult: "Include into survey results" => "包含在调查结果中"
// pe.expandCollapseTitle: "Expand/collapse title" => "展开/折叠标题"
// pe.simulator: "Select device type" => "选择设备类型"
// pe.landscapeOrientation: "Switch to landscape orientation" => "切换到横向"
// pe.portraitOrientation: "Switch to portrait orientation" => "切换到纵向"
// pe.previewText: "Preview Answers button text" => "“预览答案”按钮文本"
// pe.editText: "Edit Answer button text" => "编辑应答按钮文本"
// image.imageHeight: "Image height (in CSS-accepted values)" => "图片高度（以 CSS 接受的值为单位）"
// image.imageWidth: "Image width (in CSS-accepted values)" => "图像宽度（以 CSS 接受的值为单位）"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "完成页面的时间限制（以秒为单位）"
// question.page: "Parent page" => "父页面"
// pe.noEntriesText: "Empty entries text" => "空条目文本"
// pe.setValue: "Answer" => "答"
// pe.dataFormat: "Image format" => "图像格式"
// pe.allowAddRows: "Allow adding rows" => "允许添加行"
// pe.allowRemoveRows: "Allow removing rows" => "允许删除行"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "允许行拖放"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "如果指定确切的图像宽度或高度，则不适用。"
// pe.minImageWidth: "Minimum image width" => "最小图像宽度"
// pe.maxImageWidth: "Maximum image width" => "最大图像宽度"
// pe.minImageHeight: "Minimum image height" => "最小图像高度"
// pe.maxImageHeight: "Maximum image height" => "最大图像高度"
// surveyvalidator.text: "Error message" => "错误信息"
// surveyvalidator.expression: "Validation expression" => "验证表达式"
// pe.logo: "Logo (URL or base64-encoded string)" => "徽标（URL 或 base64 编码的字符串）"
// pe.questionsOnPageMode: "Survey structure" => "调查结构"
// pe.maxTextLength: "Maximum answer length (in characters)" => "最大答案长度（以字符为单位）"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "最大注释长度（以字符为单位）"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "如有必要，自动展开评论区域"
// pe.allowResizeComment: "Allow users to resize text areas" => "允许用户调整文本区域的大小"
// pe.textUpdateMode: "Update text question value" => "更新文本问题值"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "将焦点放在第一个无效答案上"
// pe.checkErrorsMode: "Run validation" => "运行验证"
// pe.navigateToUrl: "Navigate to URL" => "导航到网址"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "动态网址"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "用于显示用户是否已填写此调查的标记"
// pe.completedHtml: "Survey Complete page markup" => "调查完成页面标记"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "动态调查完成页面标记"
// pe.loadingHtml: "Markup to show while survey model is loading" => "加载调查模型时要显示的标记"
// pe.commentText: "Comment area text" => "注释区文本"
// pe.autocomplete: "Autocomplete type" => "自动完成类型"
// pe.labelTrue: "\"True\" label" => "“真实”标签"
// pe.labelFalse: "\"False\" label" => "“虚假”标签"
// pe.allowClear: "Show the Clear button" => "显示“清除”按钮"
// pe.displayStyle: "Value display style" => "值显示样式"
// pe.format: "Formatted string" => "带格式的字符串"
// pe.maximumFractionDigits: "Maximum fractional digits" => "最大小数位数"
// pe.minimumFractionDigits: "Minimum fractional digits" => "最小小数位数"
// pe.useGrouping: "Display grouping separators" => "显示分组分隔符"
// pe.allowMultiple: "Allow multiple files" => "允许多个文件"
// pe.allowImagesPreview: "Preview images" => "预览图像"
// pe.acceptedTypes: "Accepted file types" => "接受的文件类型"
// pe.waitForUpload: "Wait for the upload to complete" => "等待上传完成"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "确认文件删除"
// pe.detailPanelMode: "Detail panel location" => "详细信息面板位置"
// pe.minRowCount: "Minimum row count" => "最小行数"
// pe.maxRowCount: "Maximum row count" => "最大行数"
// pe.confirmDelete: "Confirm row deletion" => "确认删除行"
// pe.confirmDeleteText: "Confirmation message" => "确认消息"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "确认面板删除"
// pe.panelCount: "Initial panel count" => "初始面板计数"
// pe.minPanelCount: "Minimum panel count" => "最小面板数"
// pe.maxPanelCount: "Maximum panel count" => "最大面板数"
// pe.panelsState: "Inner panel expand state" => "内面板展开状态"
// pe.templateDescription: "Description template" => "描述模板"
// pe.templateTitle: "Title template" => "标题模板"
// pe.panelPrevText: "Previous Panel button tooltip" => "“上一个面板”按钮工具提示"
// pe.panelNextText: "Next Panel button tooltip" => "“下一个面板”按钮工具提示"
// pe.showRangeInProgress: "Show progress bar" => "显示进度条"
// pe.templateTitleLocation: "Question title location" => "问题标题位置"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "“删除面板”按钮位置"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "如果没有行，则隐藏问题"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "如果没有行，则隐藏列"
// pe.rateValues: "Custom rate values" => "自定义费率值"
// pe.rateCount: "Rate count" => "速率计数"
// pe.autoGenerate: "How to specify rate values?" => "如何指定速率值？"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "如果问题不包含任何选项，则隐藏问题"
// pe.hideNumber: "Hide question number" => "隐藏问题编号"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "最小宽度（以 CSS 接受的值为单位）"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "最大宽度（以 CSS 接受的值为单位）"
// pe.width: "Width (in CSS-accepted values)" => "宽度（以 CSS 接受的值为单位）"
// pe.showHeader: "Show column headers" => "显示列标题"
// pe.horizontalScroll: "Show horizontal scrollbar" => "显示水平滚动条"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "最小列宽（以 CSS 接受的值为单位）"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "行标题宽度（以 CSS 接受的值为单位）"
// pe.valueTrue: "\"True\" value" => "“真”值"
// pe.valueFalse: "\"False\" value" => "“假”值"
// pe.minErrorText: "\"Value is below minimum\" error message" => "“值低于最小值”错误消息"
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "“值超过最大值”错误消息"
// pe.otherErrorText: "\"Empty comment\" error message" => "“空评论”错误消息"
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "“非唯一键值”错误消息"
// pe.minSelectedChoices: "Minimum selected choices" => "最少选择的选项"
// pe.maxSelectedChoices: "Maximum selected choices" => "最大选定选项数"
// pe.showClearButton: "Show the Clear button" => "显示“清除”按钮"
// pe.showNumber: "Show panel number" => "显示面板编号"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "徽标宽度（以 CSS 接受的值为单位）"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "徽标高度（以 CSS 接受的值为单位）"
// pe.readOnly: "Read-only" => "只读"
// pe.enableIf: "Editable if" => "可编辑，如果"
// pe.emptyRowsText: "\"No rows\" message" => "“无行”消息"
// pe.size: "Input field size (in characters)" => "输入字段大小（以字符为单位）"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "单独的特殊选项（无、其他、全选）"
// pe.choicesFromQuestion: "Copy choices from the following question" => "复制以下问题的选项"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "要复制哪些选项？"
// pe.showCommentArea: "Show the comment area" => "显示评论区域"
// pe.commentPlaceholder: "Comment area placeholder" => "注释区占位符"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "将速率描述显示为极值"
// pe.rowsOrder: "Row order" => "行顺序"
// pe.columnsLayout: "Column layout" => "列布局"
// pe.columnColCount: "Nested column count" => "嵌套列计数"
// pe.state: "Panel expand state" => "面板展开状态"
// pe.correctAnswer: "Correct Answer" => "正确答案"
// pe.defaultPanelValue: "Default Values" => "默认值"
// pe.cells: "Cell Texts" => "单元格文本"
// pe.keyName: "Key column" => "键列"
// itemvalue.text: "Alt text" => "可选文字"
// pe.logoPosition: "Logo position" => "徽标位置"
// pe.addLogo: "Add logo..." => "添加徽标..."
// pe.changeLogo: "Change logo..." => "更改徽标..."
// logoPositions.none: "Remove logo" => "删除徽标"
// logoPositions.left: "Left" => "左"
// logoPositions.right: "Right" => "右"
// logoPositions.top: "On the top" => "在顶部"
// logoPositions.bottom: "In the bottom" => "在底部"
// tabs.items: "Items" => "项目"
// tabs.requiredIf: "Required If" => "如果"
// tabs.numbering: "Numbering" => "编号"
// tabs.pages: "Pages" => "页面"
// tabs.calculatedValues: "Calculated Values" => "计算值"
// tabs.triggers: "Triggers" => "触发器"
// tabs.templateTitle: "Title template" => "标题模板"
// tabs.totals: "Totals" => "总数"
// tabs.logic: "Logic" => "逻辑"
// tabs.layout: "Layout" => "布局"
// tabs.data: "Data" => "数据"
// tabs.validation: "Validation" => "验证"
// tabs.cells: "Cell Texts" => "单元格文本"
// tabs.showOnCompleted: "Survey Complete" => "调查完成"
// tabs.logo: "Logo in Survey Title" => "调查标题中的徽标"
// tabs.slider: "Slider" => "滑 块"
// tabs.expression: "Expression" => "表达"
// tabs.others: "Others" => "别人"
// pe.choicesVisibleIf: "Choices are visible if" => "在以下情况下，选项可见"
// pe.choicesEnableIf: "Choices are selectable if" => "在以下情况下，可以选择选项"
// pe.columnsEnableIf: "Columns are visible if" => "在以下情况下，列可见"
// pe.rowsEnableIf: "Rows are visible if" => "在以下情况下，行可见"
// pe.indent: "Add indents" => "添加缩进"
// panel.indent: "Add outer indents" => "添加外部缩进"
// pe.innerIndent: "Add inner indents" => "添加内部缩进"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "从最后一行获取默认值"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "从最后一个面板中获取默认值"
// pe.titleKeyboardAdornerTip: "Press enter button to edit" => "按回车键编辑"
// pe.keyboardAdornerTip: "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item" => "按回车键编辑项目，按删除按钮删除项目，按 Alt 加向上箭头或向下箭头移动项目"
// pe.triggerGotoName: "Go to the question" => "转到问题"
// pe.triggerRunExpressionEmpty: "Please enter a valid expression" => "请输入有效的表达式"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "在此处键入表达式..."
// pe.noFile: "No file choosen" => "未选择任何文件"
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "如果问题被隐藏，则清除该值"
// pe.valuePropertyName: "Value property name" => "值属性名称"
// pe.searchEnabled: "Enable search" => "启用搜索"
// pe.hideSelectedItems: "Hide selected items" => "隐藏所选项目"
// pe.closeOnSelect: "Close the dropdown after selection" => "选择后关闭下拉列表"
// pe.signatureWidth: "Signature width" => "签名宽度"
// pe.signatureHeight: "Signature height" => "标志性高度"
// pe.verticalAlign: "Vertical alignment" => "垂直对齐"
// pe.alternateRows: "Alternate rows" => "交替行"
// pe.columnsVisibleIf: "Columns are visible if" => "在以下情况下，列可见"
// pe.rowsVisibleIf: "Rows are visible if" => "在以下情况下，行可见"
// pe.otherPlaceholder: "Comment area placeholder" => "注释区占位符"
// pe.rateType: "Rate type" => "费率类型"
// pv.true: "true" => "真"
// pv.false: "false" => "假"
// pv.decimal: "decimal" => "十进制"
// pv.currency: "currency" => "货币"
// pv.percent: "percent" => "百分之"
// pv.onpanel: "Start on each panel" => "在每个面板上开始"
// pv.tab: "Tabs" => "制表符"
// pv.both: "Both" => "双"
// pv.right: "Right" => "右"
// pv.color: "color" => "颜色"
// pv.date: "date" => "日期"
// pv.datetime: "datetime" => "日期时间"
// pv.datetime-local: "datetime-local" => "日期时间-本地"
// pv.email: "email" => "电子邮件"
// pv.month: "month" => "月"
// pv.number: "number" => "数"
// pv.password: "password" => "密码"
// pv.range: "range" => "范围"
// pv.tel: "tel" => "电话"
// pv.text: "text" => "发短信"
// pv.time: "time" => "时间"
// pv.url: "url" => "网址"
// pv.week: "week" => "周"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "当问题或其面板/页面被隐藏时"
// clearInvisibleValues.none: "Never" => "从不"
// inputType.color: "Color" => "颜色"
// inputType.date: "Date" => "日期"
// inputType.datetime-local: "Date and Time" => "日期和时间"
// inputType.email: "Email" => "电子邮件"
// inputType.month: "Month" => "月"
// inputType.number: "Number" => "数"
// inputType.password: "Password" => "密码"
// inputType.range: "Range" => "范围"
// inputType.tel: "Phone Number" => "电话号码"
// inputType.text: "Text" => "发短信"
// inputType.time: "Time" => "时间"
// inputType.url: "URL" => "网址"
// inputType.week: "Week" => "周"
// pv.onValueChanging: "Before an answer is changed" => "更改答案之前"
// pv.standard: "Original structure" => "原始结构"
// pv.singlePage: "All questions on a single page" => "所有问题都在一个页面上"
// pv.questionPerPage: "Each question on an individual page" => "单个页面上的每个问题"
// pv.noPreview: "No preview" => "无预览"
// pv.showAllQuestions: "Show all questions" => "显示所有问题"
// pv.showAnsweredQuestions: "Show answered questions only" => "仅显示已回答的问题"
// pv.pages: "Completed pages" => "已完成的页面"
// pv.questions: "Answered questions" => "已回答的问题"
// pv.requiredQuestions: "Answered required questions" => "回答必填问题"
// pv.correctQuestions: "Valid answers" => "有效答案"
// pv.buttons: "Completed pages (button UI)" => "已完成的页面（按钮 UI）"
// pv.underInput: "Under the input" => "在输入下"
// pv.underTitle: "Under the title" => "在标题下"
// pv.onBlur: "On blur" => "模糊时"
// pv.onTyping: "While typing" => "打字时"
// pv.underRow: "Under the row" => "在行下"
// pv.underRowSingle: "Under the row, only one panel is visible" => "在该行下，只有一个面板可见"
// showNavigationButtons.none: "Hidden" => "隐藏"
// showProgressBar.off: "Hidden" => "隐藏"
// showTimerPanel.none: "Hidden" => "隐藏"
// showTimerPanelMode.all: "Both" => "双"
// detailPanelMode.none: "Hidden" => "隐藏"
// addRowLocation.default: "Depends on matrix layout" => "取决于矩阵布局"
// panelsState.default: "Users cannot expand or collapse panels" => "用户无法展开或折叠面板"
// panelsState.collapsed: "All panels are collapsed" => "所有面板均已折叠"
// panelsState.expanded: "All panels are expanded" => "所有面板均已展开"
// widthMode.auto: "Auto" => "自动"
// widthMode.static: "Static" => "静态的"
// widthMode.responsive: "Responsive" => "响应"
// imageFit.none: "None" => "没有"
// imageFit.contain: "Contain" => "包含"
// imageFit.cover: "Cover" => "盖"
// imageFit.fill: "Fill" => "填补"
// contentMode.auto: "Auto" => "自动"
// contentMode.image: "Image" => "图像"
// contentMode.video: "Video" => "视频"
// contentMode.youtube: "YouTube" => "优酷"
// displayMode.auto: "Auto" => "自动"
// displayMode.buttons: "Buttons" => "按钮"
// displayMode.dropdown: "Dropdown" => "下拉列表"
// rateColorMode.default: "Default" => "违约"
// autoGenerate.true: "Generate" => "生成"
// autoGenerate.false: "Enter manually" => "手动输入"
// rateType.labels: "Labels" => "标签"
// rateType.stars: "Stars" => "星星"
// rateType.smileys: "Smileys" => "笑脸"
// op.and: "and" => "和"
// op.or: "or" => "或"
// ew.modern: "Modern theme" => "现代主题"
// ew.default: "Default theme" => "默认主题"
// ew.orange: "Orange theme" => "橙色主题"
// ew.darkblue: "Darkblue theme" => "深蓝色主题"
// ew.darkrose: "Darkrose theme" => "“暗玫瑰”主题"
// ew.stone: "Stone theme" => "“石头”主题"
// ew.winter: "Winter theme" => "“冬季”主题"
// ew.winterstone: "Winter-Stone theme" => "“冬日之石”主题"
// ts.hideInvisibleElements: "Hide invisible elements" => "隐藏不可见元素"
// triggers.skiptrigger: "Skip to question" => "跳至问题"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Cookie 可防止用户两次填写同一调查问卷。"
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "调整输入字段的可见区域的大小。请使用<b>“验证→最大长度</b>”设置来限制输入长度。"
// pehelp.format: "Use {0} as a placeholder for the actual value." => "使用 {0} 作为实际值的占位符。"
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "仅当至少一列具有 Total 类型或 Total 表达式时才可见。"
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "有关详细信息，请参阅 [accept]（https://www.w3schools.com/tags/att_input_accept.asp） 属性说明。"
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "仅适用于单选组和复选框单元类型。"
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "有关详细信息，请参阅 [autocomplete]（https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete） 属性说明。"
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "如果未设置此属性，则答案将存储在 Name 属性指定的字段中。"
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "如果指定的列包含相同的值，则调查将引发“非唯一键值”错误。"
// p.multiSelect: "Allow multiple selection" => "允许多项选择"
// p.showLabel: "Show image captions" => "显示图像标题"
// p.value: "Value" => "价值"
// p.tabAlign: "Tab alignment" => "制表符对齐方式"
// p.logoFit: "Logo fit" => "徽标合身"
// p.pages: "Pages" => "页面"
// p.questions: "Questions" => "问题"
// p.calculatedValues: "Calculated values" => "计算值"
// p.surveyId: "Survey id" => "调查编号"
// p.surveyPostId: "Survey post id" => "调查帖子编号"
// p.surveyShowDataSaving: "Survey show data saving" => "调查显示数据保存"
// p.questionDescriptionLocation: "Question description location" => "问题描述位置"
// p.progressBarType: "Progress bar type" => "进度条类型"
// p.showTOC: "Show TOC" => "显示目录"
// p.tocLocation: "Toc location" => "目录位置"
// p.questionTitlePattern: "Question title pattern" => "问题标题模式"
// p.widthMode: "Width mode" => "宽度模式"
// p.showBrandInfo: "Show brand info" => "显示品牌信息"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "在动态文本中使用显示值"
// p.descriptionLocation: "Description location" => "描述位置"
// p.defaultValueExpression: "Default value expression" => "默认值表达式"
// p.bindings: "Bindings" => "绑定"
// p.renderAs: "Render as" => "渲染为"
// p.attachOriginalItems: "Attach original items" => "附加原始项目"
// p.cellHint: "Cell hint" => "单元格提示"
// p.isUnique: "Is unique" => "是独一无二的"
// p.showInMultipleColumns: "Show in multiple columns" => "在多列中显示"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "最大小数位数总数"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "最小小数位数总数"
// p.detailElements: "Detail elements" => "细节元素"
// p.allowAdaptiveActions: "Allow adaptive actions" => "允许自适应操作"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "添加时显示的详细信息面板"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "选项延迟加载已启用"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "选择延迟加载页面大小"
// p.inputFieldComponent: "Input field component" => "输入字段组件"
// p.itemComponent: "Item component" => "项目组件"
// p.min: "Min" => "最小值"
// p.max: "Max" => "麦克斯"
// p.minValueExpression: "Min value expression" => "最小值表达式"
// p.maxValueExpression: "Max value expression" => "最大值表达式"
// p.step: "Step" => "步"
// p.dataList: "Data list" => "数据列表"
// p.elements: "Elements" => "元素"
// p.content: "Content" => "内容"
// p.navigationTitle: "Navigation title" => "导航标题"
// p.navigationDescription: "Navigation description" => "导航说明"
// p.longTap: "Long tap" => "长按"
// p.autoGrow: "Auto grow" => "自动增长"
// p.allowResize: "Allow resizing" => "允许调整大小"
// p.acceptCarriageReturn: "Accept carriage return" => "接受回车"
// p.displayMode: "Display mode" => "显示模式"
// p.rateType: "Rate type" => "费率类型"
// p.contentMode: "Content mode" => "内容模式"
// p.imageFit: "Image fit" => "图像贴合"
// p.altText: "Alt text" => "可选文字"
// p.height: "Height" => "高度"
// p.penColor: "Pen color" => "笔颜色"
// p.backgroundColor: "Background color" => "背景色"
// p.templateElements: "Template elements" => "模板元素"
// p.operator: "Operator" => "算子"
// p.isVariable: "Is variable" => "是可变的"
// p.runExpression: "Run expression" => "运行表达式"
// p.showCaption: "Show caption" => "显示标题"
// p.iconName: "Icon name" => "图标名称"
// p.iconSize: "Icon size" => "图标大小"
// p.precision: "Precision" => "精度"
// p.matrixDragHandleArea: "Matrix drag handle area" => "矩阵拖动手柄区域"
// p.backgroundImage: "Background image" => "背景图片"
// p.backgroundImageFit: "Background image fit" => "背景图像适合"
// p.backgroundImageAttachment: "Background image attachment" => "背景图像附件"
// p.backgroundOpacity: "Background opacity" => "背景不透明度"
// p.selectToRankEnabled: "Select to rank enabled" => "选择启用排名"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "选择以对区域布局进行排名"
// p.allowCameraAccess: "Allow camera access" => "允许摄像头访问"
// p.scaleColorMode: "Scale color mode" => "缩放颜色模式"
// p.rateColorMode: "Rate color mode" => "评价颜色模式"
// p.templateTabTitle: "Template tab title" => "模板选项卡标题"
// p.templateVisibleIf: "Template visible if" => "模板可见，如果"
// p.copyDisplayValue: "Copy display value" => "复制显示值"
// theme.--background: "Background color" => "背景色"
// theme.--background-dim-light: "Background dim light color" => "背景昏暗的光线颜色"
// theme.--primary-foreground: "Primary foreground color" => "原色前景色"
// theme.--foreground: "Foreground color" => "前景色"
// theme.--base-unit: "Base unit" => "基本单元"
// theme.groupAdvanced: "Advanced" => "高深"
// theme.themeName: "Theme" => "主题"
// theme.isPanellessss: "Question appearance" => "问题外观"
// theme.isPanellessPanels: "Default" => "违约"
// theme.isPanellessLightweight: "Without Panels" => "不带面板"
// theme.themePaletteLight: "Light" => "光"
// theme.themePaletteDark: "Dark" => "黑暗"
// theme.primaryColor: "Accent color" => "强调文字颜色"
// theme.primaryDefaultColor: "Default" => "违约"
// theme.primaryDarkColor: "Hover" => "悬停"
// theme.primaryLightColor: "Selected" => "选择"
// theme.backgroundDimColor: "Background color" => "背景色"
// theme.backgroundImage: "Background image" => "背景图片"
// theme.backgroundImageFitAuto: "Auto" => "自动"
// theme.backgroundImageFitCover: "Cover" => "盖"
// theme.backgroundImageFitContain: "Contain" => "包含"
// theme.backgroundOpacity: "Opacity" => "不透明度"
// theme.backgroundImageAttachmentFixed: "Fixed" => "固定"
// theme.backgroundImageAttachmentScroll: "Scroll" => "滚动"
// theme.panelBackgroundTransparency: "Panel background opacity" => "面板背景不透明度"
// theme.questionBackgroundTransparency: "Question background opacity" => "问题背景不透明度"
// theme.questionPanel: "Panel background and corner radius" => "面板背景和角半径"
// theme.questionTitle: "Question title font" => "问题标题字体"
// theme.questionDescription: "Question description font" => "问题描述字体"
// theme.editorPanel: "Input element" => "输入元素"
// theme.editorFont: "Input element font" => "输入元素字体"
// theme.backcolor: "Default background" => "默认背景"
// theme.hovercolor: "Hover background" => "悬停背景"
// theme.borderDecoration: "Border decoration" => "边框装饰"
// theme.accentBackground: "Accent background" => "强调文字背景"
// theme.accentForeground: "Accent foreground" => "强调文字前景"
// theme.primaryForecolor: "Default color" => "默认颜色"
// theme.primaryForecolorLight: "Disabled color" => "禁用颜色"
// theme.linesColors: "Minor line colors" => "次要线条颜色"
// theme.borderDefault: "Darker" => "暗"
// theme.borderLight: "Lighter" => "打火机"
// theme.fontFamily: "Font family" => "字体系列"
// theme.fontSize: "Font size" => "字体大小"
// theme.color: "Color" => "颜色"
// theme.size: "Size" => "大小"
// theme.fontWeightRegular: "Regular" => "定期"
// theme.fontWeightHeavy: "Heavy" => "重"
// theme.fontWeightSemiBold: "Semi-bold" => "半粗体"
// theme.fontWeightBold: "Bold" => "大胆"
// theme.scale: "Scale" => "规模"
// theme.cornerRadius: "Corner radius" => "拐角半径"
// theme.surveyTitleFont: "Survey title font" => "调查标题字体"
// theme.pageTitle: "Page title font" => "页面标题字体"
// theme.pageDescription: "Page description font" => "页面描述字体"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "添加阴影效果"
// theme.opacity: "Opacity" => "不透明度"
// theme.boxShadowBlur: "Blur" => "模糊"
// theme.boxShadowSpread: "Spread" => "传播"
// theme.boxShadowDrop: "Drop" => "落"
// theme.boxShadowInner: "Inner" => "内"
// theme.questionShadow: "Shadow effects" => "阴影效果"
// theme.editorShadow: "Input element shadow effects" => "输入元素阴影效果"
// names.default: "Default" => "违约"
// names.contrast: "Contrast" => "反差"
// names.plain: "Plain" => "平原"
// names.simple: "Simple" => "简单"
// names.blank: "Blank" => "空白"
// names.double: "Double" => "双"
// names.bulk: "Bulk" => "散装"
// names.pseudo-3d: "Pseudo 3D" => "伪 3D"
// names.playful: "Playful" => "好玩"
// names.ultra: "Ultra" => "超"
// colors.teal: "Teal" => "水鸭"
// colors.blue: "Blue" => "蓝"
// colors.purple: "Purple" => "紫色"
// colors.orchid: "Orchid" => "兰花"
// colors.tulip: "Tulip" => "郁金香"
// colors.brown: "Brown" => "棕色"
// colors.green: "Green" => "绿"
// names.sharp: "Sharp" => "锋利"
// names.borderless: "Borderless" => "无国界"
// names.flat: "Flat" => "平"
// names.doubleborder: "Double Border" => "双边框"
// names.layered: "Layered" => "分层的"
// names.solid: "Solid" => "固体"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "您确定要删除此语言的所有字符串吗？"
// ed.themeResetButton: "Reset theme settings to default" => "将主题设置重置为默认值"
// theme.placeholderColor: "Placeholder color" => "占位符颜色"
// ed.themeSettings: "Theme Settings" => "主题设置"
// ed.themeSettingsTooltip: "Open theme settings" => "打开主题设置"
// pe.resetToDefaultCaption: "Reset" => "重置"
// pv.file: "Local files" => "本地文件"
// pv.camera: "Camera" => "照相机"
// pv.file-camera: "Local files or camera" => "本地文件或相机"
// ed.translateUsigAI: "Auto-translate All" => "自动翻译全部"
// ed.translationDialogTitle: "Untranslated strings" => "未翻译的字符串"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "请输入至少{0}项目"
// lg.question_resetValueName: "Reset question value" => "重置问题值"
// lg.column_resetValue: "Reset column value" => "重置列值"
// pe.markRequired: "Mark as required" => "标记为必填"
// pe.removeRequiredMark: "Remove the required mark" => "删除所需的标记"
// p.resetValueIf: "Reset value if" => "如果出现以下情况，则重置值"
// lg.question_setValueName: "Set question value" => "设置问题值"
// lg.column_resetValueName: "Reset column value" => "重置列值"
// lg.column_setValueName: "Set column value" => "设置列值"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => "其结果将分配给目标问题的表达式。"
// survey.title: "Title" => "标题"
// page.title: "Title" => "标题"
// p.setValueIf: "Set value if" => "设置值，如果"
// theme.header: "Header" => "页眉"
// theme.backgroundImageFitFill: "Stretch" => "伸展"
// theme.backgroundImageFitTile: "Tile" => "瓦"
// theme.headerView: "View" => "视图"
// theme.headerViewBasic: "Basic" => "基本"
// theme.headerViewAdvanced: "Advanced" => "高深"
// theme.headerInheritWidthFrom: "Content area width" => "内容区域宽度"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "与调查相同"
// theme.headerInheritWidthFromPage: "Fit to page" => "适合页面"
// theme.headerTextAreaWidth: "Text width" => "文本宽度"
// theme.headerBackgroundColorSwitch: "Background color" => "背景色"
// theme.headerBackgroundColorNone: "None" => "没有"
// theme.headerBackgroundColorAccentColor: "Accent color" => "强调文字颜色"
// theme.headerBackgroundColorCustom: "Custom" => "习惯"
// theme.horizontalAlignmentLeft: "Left" => "左"
// theme.horizontalAlignmentCenter: "Center" => "中心"
// theme.horizontalAlignmentRight: "Right" => "右"
// theme.verticalAlignmentTop: "Top" => "返回页首"
// theme.verticalAlignmentMiddle: "Middle" => "中间"
// theme.verticalAlignmentBottom: "Bottom" => "底"
// lg.question_resetValueText: "reset value for question: {0}" => "重置问题的值：{0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "分配值：{1}问题：{0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "重置列的单元格值：{0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "将单元格值：{1}分配给列：{0}"
// ed.surveyJsonExportButton: "Export" => "出口"
// ed.surveyJsonImportButton: "Import" => "进口"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "复制到剪贴板"
// pe.filePlaceholder: "File placeholder text" => "文件占位符文本"
// pe.photoPlaceholder: "Photo placeholder text" => "照片占位符文本"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "文件或照片占位符文本"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "当“源类型”为“本地文件”或相机不可用时适用"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "当“源类型”为“相机”时适用。"
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "当“源类型”为“本地文件或相机”时适用。"
// theme.background: "Background" => "背景"
// theme.appearance: "Appearance" => "外观"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "你真的要重置主题吗？您的所有自定义项都将丢失。"
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "是，重置主题"
// theme.headerInheritWidthFromContainer: "Fit to container" => "适合容器"
// signaturepad.showPlaceholder: "Show the placeholder" => "显示占位符"
// signaturepad.placeholder: "Placeholder text" => "占位符文本"
// theme.surveyDescriptionFont: "Survey description font" => "调查描述字体"
// ed.prevFocus: "Focus previous" => "焦点 上一页"
// ed.nextFocus: "Focus next" => "接下来的重点"
// ed.saveTheme: "Save Theme" => "保存主题"
// ed.saveThemeTooltip: "Save Theme" => "保存主题"
// lg.page_requireName: "Make page required" => "将页面设为必填项"
// lg.panel_requireName: "Make page required" => "将页面设为必填项"
// signaturepad.signatureWidth: "Signature area width" => "签名区域宽度"
// signaturepad.signatureHeight: "Signature area height" => "签名区域高度"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "自动缩放签名区域"
// signaturepad.penMinWidth: "Minimum pen width" => "最小笔宽"
// signaturepad.penMaxWidth: "Maximum pen width" => "最大笔宽"
// theme.logoPosition: "Logo position" => "徽标位置"
// theme.headerTitlePosition: "Title position" => "职称位置"
// theme.headerDescriptionPosition: "Description position" => "描述位置"
// ed.propertyGridNoResultsFound: "No results found" => "未找到结果"
// pv.leftRight: "Left and right" => "左和右"
// p.sourceType: "Source type" => "源类型"
// p.fitToContainer: "Fit to container" => "适合容器"
// p.setValueExpression: "Set value expression" => "设置值表达式"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "选项是从 Web 服务加载的。"
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "前往“设置”"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "加载选项的预览"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "防止行中出现重复响应"
// theme.advancedMode: "Advanced mode" => "高级模式"
// theme.backgroundCornerRadius: "Background and corner radius" => "背景和圆角半径"
// theme.colorsTitle: "Colors" => "颜色"
// theme.font: "Font" => "字体"
// theme.lines: "Lines" => "线"
// theme.titleFont: "Title font" => "标题字体"
// theme.descriptionFont: "Description font" => "描述字体"
// theme.shadow: "Shadow effects" => "阴影效果"
// ed.translateUsigAIFrom: "Translate from: " => "翻译语言组合："
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "允许“拒绝应答”选项"
// pe.showDontKnowItem: "Allow the Don't Know option" => "允许“不知道”选项"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "允许“拒绝应答”选项"
// pe.showDontKnowItem: "Allow the Don't Know option" => "允许“不知道”选项"
// pv.contain: "Contain" => "包含"
// pv.cover: "Cover" => "盖"
// pv.fill: "Fill" => "填补"
// pe.transposeData: "Transpose rows to columns" => "将行转置为列"
// layout.panel: "Layout" => "布局"
// layout.question: "Layout" => "布局"
// layout.base: "Layout" => "布局"
// panel.name: "Panel name" => "面板名称"
// panel.title: "Panel title" => "面板标题"
// panel.description: "Panel description" => "面板说明"
// panel.visibleIf: "Make the panel visible if" => "如果出现以下情况，则使面板可见"
// panel.requiredIf: "Make the panel required if" => "如果出现以下情况，则使面板成为必需的"
// panel.questionsOrder: "Question order within the panel" => "小组内的问题顺序"
// panel.startWithNewLine: "Display the panel on a new line" => "在新行上显示面板"
// panel.state: "Panel collapse state" => "面板折叠状态"
// panel.width: "Inline panel width" => "内嵌面板宽度"
// panel.minWidth: "Minimum panel width" => "最小面板宽度"
// panel.maxWidth: "Maximum panel width" => "最大面板宽度"
// panel.showNumber: "Number panels" => "数字面板"
// paneldynamic.name: "Panel name" => "面板名称"
// paneldynamic.title: "Panel title" => "面板标题"
// paneldynamic.description: "Panel description" => "面板说明"
// paneldynamic.visibleIf: "Make the panel visible if" => "如果出现以下情况，则使面板可见"
// paneldynamic.requiredIf: "Make the panel required if" => "如果出现以下情况，则使面板成为必需的"
// paneldynamic.page: "Move the panel to page" => "将面板移动到页面"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "在新行上显示面板"
// paneldynamic.state: "Panel collapse state" => "面板折叠状态"
// paneldynamic.width: "Inline panel width" => "内嵌面板宽度"
// paneldynamic.minWidth: "Minimum panel width" => "最小面板宽度"
// paneldynamic.maxWidth: "Maximum panel width" => "最大面板宽度"
// paneldynamic.templateDescription: "Panel description pattern" => "面板描述模式"
// paneldynamic.templateTitle: "Panel title pattern" => "面板标题模式"
// paneldynamic.noEntriesText: "Empty panel text" => "空面板文本"
// paneldynamic.templateTabTitle: "Tab title pattern" => "选项卡标题模式"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "如果出现以下情况，则使单个面板可见"
// paneldynamic.hideNumber: "Hide the panel number" => "隐藏面板编号"
// paneldynamic.titleLocation: "Panel title alignment" => "面板标题对齐方式"
// paneldynamic.descriptionLocation: "Panel description alignment" => "面板描述对齐方式"
// paneldynamic.templateTitleLocation: "Question title alignment" => "问题标题对齐方式"
// paneldynamic.templateErrorLocation: "Error message alignment" => "错误消息对齐"
// paneldynamic.newPanelPosition: "New panel location" => "新面板位置"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "防止在以下问题中重复回答"
// question.name: "Question name" => "问题名称"
// question.title: "Question title" => "问题标题"
// question.description: "Question description" => "问题描述"
// question.visibleIf: "Make the question visible if" => "如果出现以下情况，请使问题可见"
// question.requiredIf: "Make the question required if" => "如果出现以下情况，则将问题设为必填项"
// question.state: "Question box collapse state" => "问题框折叠状态"
// question.hideNumber: "Hide the question number" => "隐藏问题编号"
// question.titleLocation: "Question title alignment" => "问题标题对齐方式"
// question.descriptionLocation: "Question description alignment" => "问题描述对齐方式"
// question.errorLocation: "Error message alignment" => "错误消息对齐"
// question.indent: "Increase the inner indent" => "增加内部缩进"
// question.width: "Inline question width" => "内联问题宽度"
// question.minWidth: "Minimum question width" => "最小问题宽度"
// question.maxWidth: "Maximum question width" => "最大问题宽度"
// question.textUpdateMode: "Update input field value" => "更新输入字段值"
// signaturepad.allowClear: "Show the Clear button within signature area" => "在签名区域内显示“清除”按钮"
// signaturepad.penColor: "Stroke color" => "描边颜色"
// comment.rows: "Input field height (in lines)" => "输入字段高度（以行为单位）"
// expression.name: "Expression name" => "表达式名称"
// expression.title: "Expression title" => "表达式标题"
// expression.description: "Expression description" => "表达式说明"
// expression.expression: "Expression" => "表达"
// trigger.expression: "Expression" => "表达"
// calculatedvalue.expression: "Expression" => "表达"
// survey.description: "Survey description" => "调查说明"
// page.name: "Page name" => "页面名称"
// page.description: "Page description" => "页面描述"
// page.visibleIf: "Make the page visible if" => "如果出现以下情况，则使页面可见"
// page.requiredIf: "Make the page required if" => "如果出现以下情况，则使页面为必填项"
// page.questionsOrder: "Question order on the page" => "页面上的问题顺序"
// matrixdropdowncolumn.name: "Column name" => "列名称"
// matrixdropdowncolumn.title: "Column title" => "专栏标题"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "防止重复响应"
// matrixdropdowncolumn.width: "Column width" => "列宽"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "最小列宽"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "输入字段高度（以行为单位）"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "如果出现以下情况，则使列可见"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "如果满足以下条件，则使该列为必填项"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "每个选项都在单独的列中"
// multipletextitem.name: "Name" => "名字"
// multipletextitem.title: "Title" => "标题"
// pe.rateDescriptionLocation: "Label alignment" => "标签对齐"
// pe.cellErrorLocation: "Cell error message alignment" => "单元格错误消息对齐方式"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "您还没有任何列"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "您还没有任何行"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "尚无任何验证规则"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "您还没有任何自定义变量"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "您还没有任何触发器"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "您还没有任何链接"
// pe.addNew@columns: "Add new column" => "添加新列"
// pe.addNew@rows: "Add new row" => "添加新行"
// pe.addNew@validators: "Add new rule" => "添加新规则"
// pe.addNew@calculatedValues: "Add new variable" => "添加新变量"
// pe.addNew@triggers: "Add new trigger" => "添加新触发器"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "添加新 URL"
// choicesbyurl.url: "Web service's URL" => "Web 服务的 URL"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "在进度条中显示页面标题"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "在进度条中显示页码"
// itemvalue.visibleIf: "Make the option visible if" => "如果出现以下情况，则使该选项可见"
// itemvalue.enableIf: "Make the option selectable if" => "如果出现以下情况，则使该选项可选"
// panel.layout: "Panel Layout" => "面板布局"
// tabs.questionSettings: "Question Settings" => "问题设置"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "例如：https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "例如：categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "例如：a）"
// pe.width_placeholder: "Ex.: 6in" => "例：6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "例如：600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "例：50%"
// pv.selected: "Selected" => "选择"
// pv.unselected: "Unselected" => "未选中"
// pv.center: "Center" => "中心"
// pv.middle: "Middle" => "中间"
// pv.next: "Next" => "下一个"
// pv.last: "Last" => "最后"
// clearIfInvisible.none: "Never" => "从不"
// questionsOnPageMode.standard: "Original structure" => "原始结构"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "在一个页面上显示所有问题"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "每页显示一个问题"
// pv.auto: "Auto" => "自动"
// panelsState.firstExpanded: "First expanded" => "首次扩展"
// rateColorMode.scale: "Scale" => "规模"
// scaleColorMode.monochrome: "Monochrome" => "单色"
// scaleColorMode.colored: "Colored" => "彩色"
// state.default: "Locked" => "锁"
// showQuestionNumbers.default: "Auto-numbering" => "自动编号"
// showQuestionNumbers.on: "Auto-numbering" => "自动编号"
// showQuestionNumbers.onPage: "Reset on each page" => "在每个页面上重置"
// showQuestionNumbers.onpanel: "Reset on each panel" => "在每个面板上重置"
// showQuestionNumbers.onPanel: "Reset on each panel" => "在每个面板上重置"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "在整个调查中继续"
// showQuestionNumbers.off: "No numbering" => "无编号"
// descriptionLocation.underTitle: "Under the question title" => "在问题标题下"
// descriptionLocation.underInput: "Under the input field" => "在输入字段下"
// selectToRankAreasLayout.horizontal: "Next to choices" => "在选项旁边"
// selectToRankAreasLayout.vertical: "Above choices" => "以上选择"
// displayStyle.decimal: "Decimal" => "十进制"
// displayStyle.currency: "Currency" => "货币"
// displayStyle.percent: "Percentage" => "百分比"
// displayStyle.date: "Date" => "日期"
// totalDisplayStyle.decimal: "Decimal" => "十进制"
// totalDisplayStyle.currency: "Currency" => "货币"
// totalDisplayStyle.percent: "Percentage" => "百分比"
// totalDisplayStyle.date: "Date" => "日期"
// rowsOrder.initial: "Original" => "源语言"
// questionsOrder.initial: "Original" => "源语言"
// showProgressBar.aboveheader: "Above the header" => "标题上方"
// showProgressBar.belowheader: "Below the header" => "在标题下方"
// pv.sum: "Sum" => "和"
// pv.count: "Count" => "计数"
// pv.min: "Min" => "最小值"
// pv.max: "Max" => "麦克斯"
// pv.avg: "Avg" => "平均"
// searchMode.contains: "Contains" => "包含"
// searchMode.startsWith: "Starts with" => "开头为"
// panel.name: "A panel ID that is not visible to respondents." => "受访者不可见的面板 ID。"
// panel.description: "Type a panel subtitle." => "键入面板字幕。"
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "使用魔棒图标设置确定面板可见性的条件规则。"
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "使用魔棒图标设置禁用面板只读模式的条件规则。"
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "使用魔杖图标设置条件规则，除非至少有一个嵌套问题有答案，否则该规则将阻止调查提交。"
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "适用于此面板中的所有问题。如果要覆盖此设置，请为单个问题定义标题对齐规则。“继承”选项应用页面级别（如果已设置）或调查级别设置（默认为“顶部”）。"
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "设置与面板中所有问题相关的错误消息的位置。“继承”选项应用页面级别（如果已设置）或调查级别设置。"
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "保持问题的原始顺序或随机化问题。“继承”选项应用页面级别（如果已设置）或调查级别设置。"
// panel.page: "Repositions the panel to the end of a selected page." => "将面板重新定位到所选页面的末尾。"
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "在面板内容和面板框的左边框之间添加空格或边距。"
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "取消选择以将面板与上一个问题或面板显示在一行中。如果面板是窗体中的第一个元素，则该设置不适用。"
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "从中选择：“展开” - 面板完整显示，可以折叠;“已折叠” - 面板仅显示标题和描述，可以展开;“已锁定” - 面板完整显示，无法折叠。"
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "设置面板的宽度，使其与同一行中的其他测量图元成比例。接受 CSS 值（px、%、in、pt 等）。"
// paneldynamic.name: "A panel ID that is not visible to respondents." => "受访者不可见的面板 ID。"
// paneldynamic.description: "Type a panel subtitle." => "键入面板字幕。"
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "使用魔棒图标设置确定面板可见性的条件规则。"
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "使用魔棒图标设置禁用面板只读模式的条件规则。"
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "使用魔杖图标设置条件规则，除非至少有一个嵌套问题有答案，否则该规则将阻止调查提交。"
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "适用于此面板中的所有问题。如果要覆盖此设置，请为单个问题定义标题对齐规则。“继承”选项应用页面级别（如果已设置）或调查级别设置（默认为“顶部”）。"
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "设置与输入无效的问题相关的错误消息的位置。选择：“顶部” - 错误文本放置在问题框的顶部;“底部” - 错误文本放置在问题框的底部。“继承”选项应用页面级别（如果已设置）或调查级别设置（默认为“顶部”）。"
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "设置与面板中所有问题相关的错误消息的位置。“继承”选项应用页面级别（如果已设置）或调查级别设置。"
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "将面板重新定位到所选页面的末尾。"
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "在面板内容和面板框的左边框之间添加空格或边距。"
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "取消选择以将面板与上一个问题或面板显示在一行中。如果面板是窗体中的第一个元素，则该设置不适用。"
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "从中选择：“展开” - 面板完整显示，可以折叠;“已折叠” - 面板仅显示标题和描述，可以展开;“已锁定” - 面板完整显示，无法折叠。"
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "设置面板的宽度，使其与同一行中的其他测量图元成比例。接受 CSS 值（px、%、in、pt 等）。"
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "键入动态面板标题的模板。使用 {panelIndex} 作为面板的常规位置，使用 {visiblePanelIndex} 作为其在可见面板中的顺序。将这些占位符插入到图案中以添加自动编号。"
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "键入选项卡标题的模板。使用 {panelIndex} 表示面板的大致位置，使用 {visiblePanelIndex} 表示其在可见面板中的顺序。将这些占位符插入到图案中以添加自动编号。"
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "此设置允许您控制动态面板中各个面板的可见性。使用“{panel}”占位符在表达式中引用当前面板。"
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "此面板中的所有问题都会自动继承此设置。如果要覆盖此设置，请为单个问题定义标题对齐规则。“继承”选项应用页面级别（如果已设置）或调查级别设置（默认为“顶部”）。"
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "“继承”选项应用页面级别（如果已设置）或调查级别设置（默认为“在面板标题下”）。"
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "定义新添加的面板的位置。默认情况下，新面板将添加到末尾。选择“下一步”以在当前面板之后插入新面板。"
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "复制上一个面板中的答案，并将其分配给下一个添加的动态面板。"
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "引用问题名称以要求用户在每个面板中为此问题提供唯一的答案。"
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "此设置允许您根据表达式分配默认答案值。表达式可以包括基本计算 - '{q1_id} + {q2_id}'、布尔表达式，例如 '{age} > 60'，以及函数：'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）'等。此表达式确定的值用作初始默认值，可由响应者的手动输入覆盖。"
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "使用魔杖图标设置条件规则，该规则确定何时将受访者的输入重置为基于“默认值表达式”或“设置值表达式”的值，或重置为“默认答案”值（如果设置了其中任何一个）。"
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "使用魔杖图标设置条件规则，该规则确定何时运行“设置值表达式”，并将结果值动态分配为响应。"
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "指定一个表达式，该表达式定义在满足“如果设置值”规则中的条件时要设置的值。表达式可以包括基本计算 - '{q1_id} + {q2_id}'、布尔表达式，例如 '{age} > 60'，以及函数：'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）'等。由此表达式确定的值可以被受访者的手动输入覆盖。"
// question.name: "A question ID that is not visible to respondents." => "受访者不可见的问题 ID。"
// question.description: "Type a question subtitle." => "键入问题副标题。"
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "使用魔杖图标设置确定问题可见性的条件规则。"
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "使用魔杖图标设置条件规则，以禁用问题的只读模式。"
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "使用魔杖图标设置条件规则，除非问题得到答案，否则阻止调查推进或提交。"
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "取消选择以将问题与上一个问题或面板显示在一行中。如果问题是表单中的第一个元素，则该设置不适用。"
// question.page: "Repositions the question to the end of a selected page." => "将问题重新定位到所选页面的末尾。"
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "从以下选项中选择：“展开” - 问题框完整显示，可以折叠;“已折叠” - 问题框仅显示标题和描述，可以展开;“已锁定” - 问题框完整显示，无法折叠。"
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "覆盖在面板、页面或调查级别上定义的标题对齐规则。“继承”选项将应用任何更高级别的设置（如果已设置）或调查级别的设置（默认为“顶部”）。"
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "“继承”选项应用调查级别设置（默认为“在问题标题下”）。"
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "设置与输入无效的问题相关的错误消息的位置。选择：“顶部” - 错误文本放置在问题框的顶部;“底部” - 错误文本放置在问题框的底部。“继承”选项将应用调查级别设置（默认为“顶部”）。"
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "在问题内容和问题框的左边框之间添加空格或边距。"
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "设置问题的宽度，使其与同一行中的其他调查元素成比例。接受 CSS 值（px、%、in、pt 等）。"
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "使用魔杖图标为问题设置验证规则。"
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "从中选择：“失焦时” - 当输入字段失去焦点时，该值会更新;“键入时” - 当用户键入时，该值会实时更新。“继承”选项将应用调查级别设置（默认为“失去焦点时”）。"
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "您可以使用任何 Web 服务作为多项选择题的数据源。要填充选项值，请输入提供数据的服务的 URL。"
// question.searchMode: "A comparison operation used to filter the drop-down list." => "用于筛选下拉列表的比较操作。"
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "设置显示的签名区域和生成的图像的宽度。"
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "设置显示的签名区域和生成的图像的高度。"
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "选择是否希望签名区域填充问题框中的所有可用空间，同时保持默认的 3：2 纵横比。设置自定义宽度和高度值后，该设置将保留这些尺寸的纵横比。"
// file.imageHeight: "Adjusts the height of the image in the survey results." => "调整调查结果中图像的高度。"
// file.imageWidth: "Adjusts the width of the image in the survey results." => "调整调查结果中图像的宽度。"
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "覆盖最小和最大高度值。"
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "覆盖最小和最大宽度值。"
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "“值”用作条件规则中使用的项目 ID;向受访者显示“文本”。"
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "此设置仅调整输入字段的大小，不会影响问题框的宽度。要限制接受的输入长度，请转到<b>验证→最大字符限制</b>。"
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "设置输入字段中显示的行数。如果输入占用更多行，则会出现滚动条。"
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "选择：“可编辑” - 使受访者能够填写您的调查;“只读” - 禁用表单编辑。"
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "受访者不可见的列 ID。"
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "为列启用后，受访者需要为此列中的每个问题提供唯一的回答。"
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "设置输入字段中显示的行数。如果输入占用更多行，则会出现滚动条。"
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "使用魔杖图标设置确定列可见性的条件规则。"
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "使用魔杖图标设置禁用列只读模式的条件规则。"
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "使用魔杖图标设置条件规则，除非至少有一个嵌套问题有答案，否则该规则将阻止调查提交。"
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "选中后，为每个选项创建一个单独的列。"
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "从以下选项中选择： “静态” - 设置固定宽度;“响应式” - 使调查占据屏幕的整个宽度;“自动” - 根据所使用的问题类型应用两者中的任何一个。"
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "粘贴图像链接（无大小限制）或单击文件夹图标以浏览计算机中的文件（最大 64KB）。"
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "以 CSS 单位（px、%、in、pt 等）设置徽标宽度。"
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "以 CSS 单位（px、%、in、pt 等）设置徽标高度。"
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "从以下选项中选择：“无” - 图像保持其原始大小;“包含” - 调整图像大小以适应其纵横比;“封面” - 图像填充整个框，同时保持其纵横比;“填充” - 拉伸图像以填充框，而不保持其纵横比。"
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "选择是否希望调查在受访者回答当前页面上的所有问题后自动前进到下一页。"
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "设置导航按钮在页面上的可见性和位置。"
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "设置进度条的可见性和位置。“自动”值显示测量标题上方或下方的进度条。"
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "启用仅包含所有问题或已回答问题的预览页面。"
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "适用于调查中的所有问题。此设置可以被较低级别的标题对齐规则覆盖：面板、页面或问题。较低级别的设置将覆盖较高级别的设置。"
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "一个符号或一系列符号，表示需要答案。"
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "输入要开始编号的数字或字母。"
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "设置与输入无效的问题相关的错误消息的位置。选择：“顶部” - 错误文本放置在问题框的顶部;“底部” - 错误文本放置在问题框的底部。"
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "选择是否希望每个页面上的第一个输入字段准备好进行文本输入。"
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "保持问题的原始顺序或随机化问题。此设置的效果仅在“预览”选项卡中可见。"
// pehelp.maxTextLength: "For text entry questions only." => "仅适用于文本输入问题。"
// pehelp.maxOthersLength: "For question comments only." => "仅供问题评论。"
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "选择是否希望问题注释和长文本问题根据输入的文本长度自动增加高度。"
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "仅适用于问题评论和长文本问题。"
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "自定义变量用作表单计算中使用的中间变量或辅助变量。他们将受访者的输入作为源值。每个自定义变量都有一个唯一的名称和它所基于的表达式。"
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "选择是否希望将表达式的计算值与调查结果一起保存。"
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "触发器是基于表达式的事件或条件。一旦表达式被计算为“true”，触发器就会触发一个操作。这样的操作可以选择性地影响它的目标问题。"
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "选择是否清除条件逻辑隐藏的问题的值以及何时清除。"
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "从中选择：“失焦时” - 当输入字段失去焦点时，该值会更新;“键入时” - 当用户键入时，该值会实时更新。"
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "左边的值用作条件规则中使用的列 ID，右边的值显示给受访者。"
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "左边的值用作条件规则中使用的行 ID，右边的值显示给受访者。"
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "接受 CSS 值（px、%、in、pt 等）。"
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "接受 CSS 值（px、%、in、pt 等）。"
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "设置与输入无效的单元格相关的错误消息的位置。“继承”选项应用“错误消息对齐”属性中的设置。"
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "启用“防止重复响应”属性后，尝试提交重复条目的受访者将收到以下错误消息。"
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "允许您根据表达式计算总值。表达式可以包括基本计算 （'{q1_id} + {q2_id}'）、布尔表达式 （'{age} > 60'） 和函数 （'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）' 等）。"
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "触发提示，要求确认删除行。"
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "复制最后一行的答案，并将其分配给下一个添加的动态行。"
// pehelp.description: "Type a subtitle." => "键入副标题。"
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "选择一种语言以开始创建调查。要添加翻译，请切换到新语言，然后在此处或“翻译”选项卡中翻译原始文本。"
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "设置详细信息部分相对于行的位置。从中选择：“无” - 不添加扩展;“Under the row” - 矩阵的每一行下都放置一个行扩展;“在行下，仅显示一行扩展” - 仅在单行下显示扩展，其余行展开将折叠。"
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "从以下选项中选择：“无” - 图像保持其原始大小;“包含” - 调整图像大小以适应其纵横比;“封面” - 图像填充整个框，同时保持其纵横比;“填充” - 拉伸图像以填充框，而不保持其纵横比。"
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "在输入数据时逐渐增加输入字段的高度。覆盖“输入字段高度（以行为单位）”设置。"
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "调整大小的手柄（或手柄）出现在角落，可以拖动以更改输入字段的大小。"
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "以秒为单位的时间间隔，在此时间间隔之后，调查将自动前进到“感谢”页面。"
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "以秒为单位的时间间隔，在此时间间隔之后，调查将自动前进到下一页。"
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "以秒为单位的时间间隔，在此时间间隔之后，调查将自动前进到下一页。"
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "使用魔杖图标设置确定页面可见性的条件规则。"
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "使用魔杖图标设置禁用页面只读模式的条件规则。"
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "使用魔杖图标设置条件规则，除非至少有一个嵌套问题有答案，否则该规则将阻止调查提交。"
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "适用于本页中的所有问题。如果要覆盖此设置，请为单个问题或面板定义标题对齐规则。“继承”选项将应用调查级别设置（默认为“顶部”）。"
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "设置与输入无效的问题相关的错误消息的位置。选择：“顶部” - 错误文本放置在问题框的顶部;“底部” - 错误文本放置在问题框的底部。“继承”选项将应用调查级别设置（默认为“顶部”）。"
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "保持问题的原始顺序或随机化问题。“继承”选项应用调查级别设置（默认为“原始”）。此设置的效果仅在“预览”选项卡中可见。"
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "设置导航按钮在页面上的可见性。“继承”选项应用调查级别设置，默认为“可见”。"
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "设置计时器在页面上的可见性和位置。"
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "从以下选项中选择：“锁定” - 用户无法展开或折叠面板;“全部折叠” - 所有面板都以折叠状态启动;“全部展开” - 所有面板都以展开状态启动;“首先展开” - 最初只有第一个面板被展开。"
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "在对象数组中输入共享属性名称，该数组包含要在选项列表中显示的图像或视频文件 URL。"
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "左边的值用作条件规则中使用的项目 ID，右边的值显示给受访者。"
// pehelp.title: "Type a user-friendly title to display." => "键入要显示的用户友好标题。"
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "确保用户在上传文件之前不会完成调查。"
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "接受 CSS 值（px、%、in、pt 等）。"
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "接受 CSS 值（px、%、in、pt 等）。"
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "接受 CSS 值（px、%、in、pt 等）。"
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "在单选题和多选题类型中，每个选项都有一个 ID 和显示值。选中此设置后，将在 HTML 问题以及调查元素的动态标题和描述中显示显示值，而不是 ID 值。"
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "选择是否清除条件逻辑隐藏的问题值以及何时清除。“继承”选项应用调查级别设置（默认为“完成调查后”）。"
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "从以下选项中选择：“全部” - 复制所选问题中的所有选项;“Selected” - 仅动态复制选定的选项选项;“未选择” - 仅动态复制未选择的选项。默认情况下，如果在源问题中启用了“无”和“其他”选项，则会复制该选项。"
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "选中后，用户可以在单独的注释框中包含其他输入。"
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "在新行上显示每个特殊选项（“无”、“其他”、“全选”），即使使用多列布局也是如此。"
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "指定服务数据集中目标对象数组所在的位置。如果 URL 已指向数组，则留空。"
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "在对象数组中输入一个统一的属性名称，该数组包含要在选项列表中显示的值。"
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "选择此选项可允许服务返回空响应或数组。"
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "使用魔杖图标设置条件规则，以确定所有选项的可见性。"
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "左边的值用作条件规则中使用的项目 ID，右边的值显示给受访者。"
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "“自动”根据可用宽度在“按钮”和“下拉”模式之间进行选择。当宽度不足以显示按钮时，问题将显示一个下拉列表。"
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "允许您连接以不同格式生成结果的问题。当使用联接标识符将此类问题链接在一起时，此共享属性将存储选定的问题值。"
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "选择是否要更新下拉菜单内容以匹配用户在输入字段中键入的搜索查询。"
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "当受访者给出肯定答案时保存在调查结果中的值。"
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "当受访者给出否定答案时保存在调查结果中的值。"
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "不建议禁用此选项，因为它会覆盖预览图像，并使用户难以了解文件是否已上传。"
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "触发提示，要求确认文件删除。"
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "启用此选项可仅对选定的选项进行排名。用户将从选项列表中拖动所选项目，以在排名区域内对它们进行排序。"
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "输入将在输入期间向受访者建议的选项列表。"
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "该设置仅调整输入字段的大小，不会影响问题框的宽度。"
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "为所有项目标签设置一致的宽度（以像素为单位）"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "“自动”选项会根据提供的源 URL 自动确定合适的显示模式 - 图像、视频或 YouTube。"
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "当图像无法在用户设备上显示时，出于辅助功能的目的，可作为替代。"
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "定义当评级图标类型设置为“笑脸”时所选表情符号的颜色。选择：“默认” - 所选表情符号以默认调查颜色显示;“比例” - 所选的表情符号继承了评分量表的颜色。"
// expression.name: "An expression ID that is not visible to respondents." => "受访者不可见的表达式 ID。"
// expression.description: "Type an expression subtitle." => "键入表达式副标题。"
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "表达式可以包括基本计算 （'{q1_id} + {q2_id}'）、条件 （'{age} > 60'） 和函数 （'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）' 等）。"
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "选择此选项可将“其他”选项值作为单独的属性存储在调查结果中。"
// p.swapOrder: "Swap the order of Yes and No" => "交换“是”和“否”的顺序"
// p.itemTitleWidth: "Item label width (in px)" => "项目标签宽度（以 px 为单位）"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "显示是否选择了所有选项的文本"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "排名区域的占位符文本"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "自动完成调查"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "选择是否希望在受访者回答所有问题后自动完成调查。"
// masksettings.saveMaskedValue: "Save masked value in survey results" => "在调查结果中保存掩码值"
// patternmask.pattern: "Value pattern" => "价值模式"
// datetimemask.min: "Minimum value" => "最小值"
// datetimemask.max: "Maximum value" => "最大值"
// numericmask.allowNegativeValues: "Allow negative values" => "允许负值"
// numericmask.thousandsSeparator: "Thousands separator" => "千分隔符"
// numericmask.decimalSeparator: "Decimal separator" => "小数点分隔符"
// numericmask.precision: "Value precision" => "值精度"
// numericmask.min: "Minimum value" => "最小值"
// numericmask.max: "Maximum value" => "最大值"
// currencymask.prefix: "Currency prefix" => "货币前缀"
// currencymask.suffix: "Currency suffix" => "货币后缀"
// pe.maskType: "Input mask type" => "输入掩码类型"
// maskTypes.patternmask: "Pattern" => "模式"
// maskTypes.numericmask: "Numeric" => "数值的"
// maskTypes.datetimemask: "Date and Time" => "日期和时间"
// maskTypes.currencymask: "Currency" => "货币"
// tabs.mask: "Input Mask Settings" => "输入掩码设置"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "例如：+1（999）-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "例：mm/dd/yyyy"
// pe.currencyprefix_placeholder: "Ex.: $" => "例：$"
// pe.currencysuffix_placeholder: "Ex.: USD" => "例如：美元"
// pv.textWrapEnabled: "Wrap choices" => "包装选择"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "选项选项中的长文本将自动生成换行符以适合下拉菜单。如果要剪裁文本，请取消选择。"
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "选择是否要在调查结果中存储带有应用掩码的问题值。"
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "该模式可以包含字符串文字和以下占位符： '9' - 表示数字;“a” - 表示大写或小写字母;'#' - 表示数字或大写或小写字母。使用反斜杠“\\”转义字符。"
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "该模式可以包含分隔符和以下占位符：“m” - 表示月份数;'mm' - 表示月份数字，前导零表示个位数;'d' - 表示月份中的某一天;'dd' - 表示月份中的某一天，前导零表示个位数值;'yy' - 一年的最后两位数字;'yyyy' - 表示四位数的年份。"
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "用于将显示数字的小数部分与整数部分分开的符号。"
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "用于将大数的数字分成三组的符号。"
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "限制显示数字的小数点后要保留的位数。"
// currencymask.prefix: "One or several symbols to be displayed before the value." => "要在值之前显示的一个或多个符号。"
// currencymask.suffix: "One or several symbols to be displayed after the value." => "要在值后显示的一个或多个符号。"
// ed.translationSource: "Source: " => "源："
// ed.translationTarget: "Target: " => "目标："
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "页面为空。从工具箱中拖动元素或单击下面的按钮。"
// maskTypes.none: "None" => "没有"
// itemvalue@rows.visibleIf: "Make the row visible if" => "如果出现以下情况，则使行可见"
// itemvalue@rows.enableIf: "Make the row editable if" => "如果出现以下情况，则使行可编辑"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "只读或预览模式下的占位符文本"
// pe.textWrapEnabled: "Wrap choices" => "换行选项"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "“自动”选项会根据提供的源 URL 自动确定适合的显示模式 - 图像、视频或 YouTube。"
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "在“图像”和“视频”之间进行选择以设置媒体选择器的内容模式。如果选择“图像”，请确保提供的所有选项都是以下格式的图像文件：JPEG、GIF、PNG、APNG、SVG、BMP、ICO。同样，如果选择“视频”，请确保所有选项都是指向以下格式的视频文件的直接链接：MP4、MOV、WMV、FLV、AVI、MKV。请注意，视频选项不支持 YouTube 链接。"
// ed.selectFile: "Select a file" => "选择文件"
// ed.removeFile: "Remove the file" => "删除文件"
// pe.searchMode: "Search Mode" => "搜索模式"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "单击下面的“添加问题”按钮开始创建表单。"
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "单击下面的“添加问题”按钮，向页面添加新元素。"
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "单击下面的“添加问题”按钮，将新元素添加到面板中。"
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "点击下面的按钮，选择要上传的图片"
// coloralpha.opacity: "Opacity" => "不透明度"
// font.family: "Font family" => "字体家族"
// font.color: "Color" => "颜色"
// font.placeholderColor: "Placeholder color" => "占位符颜色"
// font.size: "Size" => "大小"
// theme.themeName: "Theme" => "主题"
// theme.isPanelless: "Question appearance" => "问题外观"
// theme.editorPanel: "Background and corner radius" => "背景和拐角半径"
// theme.questionPanel: "Background and corner radius" => "背景和拐角半径"
// theme.primaryColor: "Accent color" => "强调色"
// theme.panelBackgroundTransparency: "Panel background opacity" => "面板背景不透明度"
// theme.questionBackgroundTransparency: "Question background opacity" => "问题背景不透明度"
// theme.fontSize: "Font size" => "字体大小"
// theme.scale: "Scale" => "规模"
// theme.cornerRadius: "Corner radius" => "拐角半径"
// theme.pageTitle: "Title font" => "标题字体"
// theme.pageDescription: "Description font" => "描述字体"
// theme.questionTitle: "Title font" => "标题字体"
// theme.questionDescription: "Description font" => "描述字体"
// theme.editorFont: "Font" => "字体"
// theme.backgroundOpacity: "Opacity" => "不透明度"
// theme.--sjs-font-family: "Font family" => "字体家族"
// theme.--sjs-general-backcolor-dim: "Background color" => "背景颜色"
// theme.--sjs-primary-backcolor: "Accent background" => "重音背景"
// theme.--sjs-primary-forecolor: "Accent foreground" => "重音前景"
// theme.--sjs-shadow-small: "Shadow effects" => "阴影效果"
// theme.--sjs-shadow-inner: "Shadow effects" => "阴影效果"
// theme.--sjs-border-default: "Colors" => "颜色"
// header@header.headerView: "View" => "视图"
// header@header.logoPosition: "Logo position" => "徽标位置"
// header@header.surveyTitle: "Survey title font" => "调查标题字体"
// header@header.surveyDescription: "Survey description font" => "调查描述字体"
// header@header.headerTitle: "Survey title font" => "调查标题字体"
// header@header.headerDescription: "Survey description font" => "调查描述字体"
// header@header.inheritWidthFrom: "Content area width" => "内容区宽度"
// header@header.textAreaWidth: "Text width" => "文本宽度"
// header@header.backgroundColorSwitch: "Background color" => "背景颜色"
// header@header.backgroundImage: "Background image" => "背景图片"
// header@header.backgroundImageOpacity: "Opacity" => "不透明度"
// header@header.overlapEnabled: "Overlap" => "重叠"
// header@header.logoPositionX: "Logo position" => "徽标位置"
// header@header.titlePositionX: "Title position" => "标题位置"
// header@header.descriptionPositionX: "Description position" => "描述位置"
// weight.400: "Regular" => "定期"
// weight.600: "Heavy" => "重"
// weight.700: "Semi-bold" => "半粗体"
// weight.800: "Bold" => "大胆"
// backgroundImageFit.auto: "Auto" => "自动"
// backgroundImageFit.cover: "Cover" => "盖"
// backgroundImageFit.contain: "Contain" => "包含"
// backgroundImageFit.fill: "Stretch" => "伸展"
// backgroundImageFit.tile: "Tile" => "瓦"
// backgroundImageAttachment.fixed: "Fixed" => "固定"
// backgroundImageAttachment.scroll: "Scroll" => "滚动"
// headerView.basic: "Basic" => "基本"
// headerView.advanced: "Advanced" => "高深"
// inheritWidthFrom.survey: "Same as survey" => "与调查相同"
// inheritWidthFrom.container: "Fit to container" => "适合容器"
// backgroundColorSwitch.none: "None" => "没有"
// backgroundColorSwitch.accentColor: "Accent color" => "强调色"
// backgroundColorSwitch.custom: "Custom" => "习惯"
// colorPalette.light: "Light" => "光"
// colorPalette.dark: "Dark" => "黑暗"
// isPanelless.false: "Default" => "违约"
// isPanelless.true: "Without Panels" => "不带面板"
// theme.cornerRadius: "Corner radius" => "拐角半径"
// theme.fontFamily: "Font family" => "字体家族"
// theme.fontWeightRegular: "Regular" => "定期"
// theme.fontWeightHeavy: "Heavy" => "重"
// theme.fontWeightSemiBold: "Semi-bold" => "半粗体"
// theme.fontWeightBold: "Bold" => "大胆"
// theme.color: "Color" => "颜色"
// theme.placeholderColor: "Placeholder color" => "占位符颜色"
// theme.size: "Size" => "大小"
// theme.opacity: "Opacity" => "不透明度"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "键入以搜索..."
// ed.toolboxNoResultsFound: "No results found" => "未找到结果"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "选项卡标题占位符"
// theme.--sjs-special-red: "Error messages" => "错误消息"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "选项卡标题的回退文本，当选项卡标题模式未生成有意义的值时应用。"
// theme.fontColor: "Font color" => "字体颜色"
// theme.backgroundColor: "Background color" => "背景颜色"
// pe.questionTitleWidth: "Question title width" => "问题标题宽度"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "选择文件或粘贴文件链接..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "例如：200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "当问题标题与问题框左侧对齐时，为问题标题设置一致的宽度。接受 CSS 值（px、%、in、pt 等）。"
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "当问题标题与问题框左侧对齐时，为问题标题设置一致的宽度。接受 CSS 值（px、%、in、pt 等）。"
// pe.commentAreaRows: "Comment area height (in lines)" => "评论区高度（以行为单位）"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "设置问题注释的文本区域中显示的行数。在输入占用更多行时，将出现滚动条。"


/***/ }),

/***/ "./src/localization/slovak.ts":
/*!************************************!*\
  !*** ./src/localization/slovak.ts ***!
  \************************************/
/*! exports provided: skStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "skStrings", function() { return skStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var skStrings = {
    // survey templates
    survey: {
        edit: "Upraviť",
        externalHelpLink: "Sledovať a zistiť, ako vytvárať prieskumy",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Sem zadajte otázku zo súpravy nástrojov.",
        addLogicItem: "Vytvoriť pravidlo prispôsobenia priebehu prieskumu.",
        copy: "Kopírovať",
        duplicate: "Duplikovať",
        addToToolbox: "Pridať do súpravy nástrojov",
        deletePanel: "Odstrániť panel",
        deleteQuestion: "Odstrániť otázku",
        convertTo: "Konvertovať na",
        drag: "Presunúť prvok",
    },
    // Creator tabs
    tabs: {
        preview: "Textový prieskum",
        theme: "Témy",
        translation: "Preklad",
        designer: "Návrhár prieskumov",
        editor: "Editor JSON",
        logic: "Logika prieskumu"
    },
    // Question types
    qt: {
        default: "Predvolené",
        checkbox: "Začiarkavacie políčko",
        comment: "Komentár",
        imagepicker: "Nástroj na výber obrázkov",
        ranking: "Hodnotenie",
        image: "Obrázok",
        dropdown: "Rozbaľovací zoznam",
        tagbox: "Rozbaľovacia ponuka viacerých výberov",
        file: "Súbor",
        html: "Html",
        matrix: "Matica (jedna možnosť)",
        matrixdropdown: "Matica (viacero možností)",
        matrixdynamic: "Matica (dynamické riadky)",
        multipletext: "Text pri viacerých možnostiach",
        panel: "Panel",
        paneldynamic: "Panel (dynamické panely)",
        radiogroup: "Skupina tlačidiel",
        rating: "Hodnotenie",
        text: "Jeden vstup",
        boolean: "Yes/No (Boolean)",
        expression: "Výraz (iba na čítanie)",
        signaturepad: "Priestor na podpis",
        buttongroup: "Skupina tlačidiel"
    },
    toolboxCategories: {
        general: "Všeobecné",
        choice: "Voľba Otázky",
        text: "Otázky na zadávanie textu",
        containers: "Kontajnery",
        matrix: "Maticové otázky",
        misc: "Misc"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Predvolené ({0})",
        survey: "Prieskum",
        settings: "Nastavenia prieskumu",
        settingsTooltip: "Otvoriť nastavenia prieskumu",
        surveySettings: "Nastavenia prieskumu",
        surveySettingsTooltip: "Nastavenia prieskumu",
        themeSettings: "Nastavenia motívu",
        themeSettingsTooltip: "Nastavenia motívu",
        showPanel: "Zobraziť panel",
        hidePanel: "Skryť panel",
        prevSelected: "Výber predchádzajúceho",
        nextSelected: "Vyberte položku Ďalej",
        prevFocus: "Zameranie predchádzajúce",
        nextFocus: "Zameranie ďalej",
        surveyTypeName: "Prieskum",
        pageTypeName: "Strana",
        panelTypeName: "Bledý.",
        questionTypeName: "Otázka",
        columnTypeName: "Stĺpec",
        addNewPage: "Pridať novú stranu",
        moveRight: "Prejsť vpravo",
        moveLeft: "Prejsť vľavo",
        deletePage: "Odstrániť stranu",
        editPage: "Upraviť stranu",
        edit: "Upraviť",
        newPageName: "stránka",
        newQuestionName: "otázka",
        newPanelName: "panel",
        newTextItemName: "text",
        defaultV2Theme: "Predvolený",
        modernTheme: "Moderný",
        defaultTheme: "Predvolené nastavenie (staršia verzia)",
        testSurveyAgain: "Ďalší textový prieskum",
        testSurveyWidth: "Šírka prieskumu: ",
        navigateToMsg: "Museli ste prejsť na:",
        saveSurvey: "Uložiť prieskum",
        saveSurveyTooltip: "Uložiť prieskum",
        saveTheme: "Uložiť motív",
        saveThemeTooltip: "Uložiť motív",
        jsonHideErrors: "Skryť chyby",
        jsonShowErrors: "Zobraziť chyby",
        undo: "Späť",
        redo: "Opakovať",
        undoTooltip: "Zrušiť poslednú zmenu",
        redoTooltip: "Opakovať zmenu",
        showMoreChoices: "Zobraziť viac",
        showLessChoices: "Zobraziť menej",
        copy: "Kopírovať",
        cut: "Vystrihnúť",
        paste: "Prilepiť",
        copyTooltip: "Kopírovať výber do schránky",
        cutTooltip: "Vystrihnúť výber do schránky",
        pasteTooltip: "Prilepiť zo schránky",
        options: "Možnosti",
        generateValidJSON: "Vygenerovať platný JSON",
        generateReadableJSON: "Vygenerovať načítateľný JSON",
        toolbox: "Súprava nástrojov",
        "property-grid": "Vlastnosti",
        toolboxFilteredTextPlaceholder: "Zadajte reťazec pre vyhľadávanie...",
        toolboxNoResultsFound: "Nenašli sa žiadne výsledky",
        propertyGridFilteredTextPlaceholder: "Zadajte reťazec pre vyhľadávanie...",
        propertyGridNoResultsFound: "Nenašli sa žiadne výsledky",
        correctJSON: "Opravte JSON.",
        surveyResults: "Výsledok prieskumu: ",
        surveyResultsTable: "Ako tabuľku",
        surveyResultsJson: "Ako JSON",
        resultsTitle: "Titul otázky",
        resultsName: "Názov otázky",
        resultsValue: "Hodnota odpovede",
        resultsDisplayValue: "Zobraziť hodnotu",
        modified: "Upravené",
        saving: "Ukladanie",
        saved: "Uložené",
        propertyEditorError: "Chyba:",
        saveError: "Chyba! Obsah editora sa neuložil.",
        translationPropertyGridTitle: "Nastavenia jazyka",
        themePropertyGridTitle: "Nastavenia motívu",
        translationLanguages: "Jazyky",
        translationDeleteLanguage: "Ste si istý, že chcete odstrániť všetky reťazce pre tento jazyk?",
        translationAddLanguage: "Výber jazyka na preklad",
        translationShowAllStrings: "Zobraziť všetky reťazce",
        translationShowUsedStringsOnly: "Iba použité reťazce",
        translationShowAllPages: "Zobraziť všetky stránky",
        translationNoStrings: "Žiadne reťazce na preklad. Zmeňte filter.",
        translationExportToSCVButton: "Exportovať do CSV",
        translationImportFromSCVButton: "Importovať z CSV",
        translateUsigAI: "Automatický preklad všetkého",
        translateUsigAIFrom: "Preložiť z: ",
        translationDialogTitle: "Nepreložené reťazce",
        translationMergeLocaleWithDefault: "Zlúčiť {0} s predvoleným miestnym nastavením",
        translationPlaceHolder: "Preklad...",
        translationSource: "Zdroj: ",
        translationTarget: "Cieľ: ",
        themeExportButton: "Vývoz",
        themeImportButton: "Import",
        surveyJsonExportButton: "Vývoz",
        surveyJsonImportButton: "Import",
        surveyJsonCopyButton: "Kopírovanie do schránky",
        themeResetButton: "Obnovenie predvolených nastavení motívu",
        themeResetConfirmation: "Naozaj chcete resetovať tému? Všetky vaše prispôsobenia sa stratia.",
        themeResetConfirmationOk: "Áno, obnoviť motív",
        bold: "Tučné",
        italic: "Kurzíva",
        underline: "Podčiarknutie",
        addNewQuestion: "Pridať otázku",
        selectPage: "Vybrať stránku...",
        carryForwardChoicesCopied: "Voľby sa kopírujú z",
        choicesLoadedFromWebText: "Možnosti sa načítavajú z webovej služby.",
        choicesLoadedFromWebLinkText: "Prejdite na nastavenia",
        choicesLoadedFromWebPreviewTitle: "Ukážka načítaných možností výberu",
        htmlPlaceHolder: "Obsah HTML bude tu.",
        panelPlaceHolder: "Tu položte otázku z panela nástrojov.",
        surveyPlaceHolder: "Prieskum je prázdny. Potiahnite prvok z panela s nástrojmi alebo kliknite na tlačidlo nižšie.",
        pagePlaceHolder: "Stránka je prázdna. Potiahnite prvok z panela s nástrojmi alebo kliknite na tlačidlo nižšie.",
        imagePlaceHolder: "Presuňte obrázok sem alebo kliknite na tlačidlo nižšie a vyberte obrázok, ktorý chcete nahrať",
        surveyPlaceHolderMobile: "Kliknite na tlačidlo \"Pridať otázku\" nižšie a začnite vytvárať formulár.",
        pagePlaceHolderMobile: "Kliknite na tlačidlo \"Pridať otázku\" nižšie a pridajte na stránku nový prvok.",
        panelPlaceHolderMobile: "Kliknite na tlačidlo \"Pridať otázku\" nižšie a pridajte na panel nový prvok.",
        imagePlaceHolderMobile: "Kliknite na tlačidlo nižšie a vyberte obrázok, ktorý chcete nahrať",
        imageChooseImage: "Vyberte obrázok",
        addNewTypeQuestion: "Pridať {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Položka ",
        selectFile: "Vyberte súbor",
        removeFile: "Odstránenie súboru",
        lg: {
            addNewItem: "Pridať nové pravidlo",
            empty_tab: "Vytvorte pravidlo na prispôsobenie toku prieskumu.",
            page_visibilityName: "Viditeľnosť strany",
            page_enableName: "Povoliť (zakázať) stránku",
            page_requireName: "Nastavenie požadovanej strany",
            panel_visibilityName: "Viditeľnosť panela",
            panel_enableName: "Panel povoliť/zakázať",
            panel_requireName: "Nastavenie požadovanej strany",
            question_visibilityName: "Viditeľnosť otázky",
            question_enableName: "Otázku povoliť/zakázať",
            question_requireName: "Vyžaduje sa voliteľná otázka",
            question_resetValueName: "Obnoviť hodnotu otázky",
            question_setValueName: "Nastavenie hodnoty otázky",
            column_visibilityName: "Zobraziť (skryť) stĺpec",
            column_enableName: "Povoliť (zakázať) stĺpec",
            column_requireName: "Nastavenie povinného stĺpca",
            column_resetValueName: "Obnovenie hodnoty stĺpca",
            column_setValueName: "Nastavenie hodnoty stĺpca",
            trigger_completeName: "Dokončiť prieskum",
            trigger_setvalueName: "Nastaviť hodnotu otázky",
            trigger_copyvalueName: "Kopírovať hodnotu otázky",
            trigger_skipName: "Prejsť na otázku",
            trigger_runExpressionName: "Spustiť vlastný výraz",
            completedHtmlOnConditionName: "Vlastný text stránky s poďakovaním",
            page_visibilityDescription: "Stránka bude viditeľná, keď logický výraz vráti hodnotu true. V opačnom prípade sa nebude zobrazovať.",
            panel_visibilityDescription: "Panel bude viditeľný, keď logický výraz vráti hodnotu true. V opačnom prípade sa nebude zobrazovať.",
            panel_enableDescription: "Panel a všetky jeho prvky sa povolia, keď logický výraz vráti hodnotu true. V opačnom prípade budú zakázané.",
            question_visibilityDescription: "Otázka bude viditeľná, keď logický výraz vráti hodnotu true. V opačnom prípade sa nebude zobrazovať.",
            question_enableDescription: "Otázka sa povolí, keď logický výraz vráti hodnotu true. V opačnom prípade zostane zakázaná.",
            question_requireDescription: "Otázka bude povinná, keď logický výraz vráti hodnotu true.",
            trigger_completeDescription: "Keď logický výraz vráti hodnotu true, prieskum bude dokončený a používateľovi sa zobrazí stránka s poďakovaním.",
            trigger_setvalueDescription: "V prípade, že sa zmenia hodnoty, ktoré sa používajú v rámci logického výrazu, a logický výraz vráti hodnotu true, pre vybratú otázku sa nastaví daná hodnota.",
            trigger_copyvalueDescription: "V prípade, že sa zmenia hodnoty otázok, ktoré sa používajú v rámci logického výrazu, a logický výraz vráti hodnotu true, hodnota jednej vybratej otázky sa skopíruje na ďalšiu vybratú otázku.",
            trigger_skipDescription: "Keď logický výraz vráti hodnotu true, prieskum prejde/nastaví sa na vybratú otázku.",
            trigger_runExpressionDescription: "Keď logický výraz vráti hodnotu true, vykoná sa vlastný výraz. Voliteľne môžete nastaviť tento výraz na vybratú otázku.",
            completedHtmlOnConditionDescription: "Keď logický výraz vráti hodnotu true, predvolený text na stránke s poďakovaním sa zmení na zadaný text.",
            itemExpressionText: "Keď výraz: „{0}“ vráti hodnotu true:",
            itemEmptyExpressionText: "Nové pravidlo",
            page_visibilityText: "Stránka {0} bude viditeľná",
            panel_visibilityText: "Panel {0} bude viditeľný",
            panel_enableText: "Panel {0} bude povolený",
            question_visibilityText: "Otázka {0} bude viditeľná",
            question_enableText: "Otázka {0} bude povolená",
            question_requireText: "Otázka {0} sa bude vyžadovať",
            question_resetValueText: "Resetovať hodnotu pre otázku: {0}",
            question_setValueText: "Priradiť hodnotu: {1} otázku: {0}",
            column_visibilityText: "Zviditeľnenie stĺpcových {0} otázok {1}",
            column_enableText: "Nastavenie {0}  otázky {1} povolenie",
            column_requireText: "Urobiť stĺpec {0} otázky {1} povinné",
            column_resetValueText: "Obnoviť hodnotu bunky pre stĺpec: {0}",
            column_setValueText: "Priradenie hodnoty bunky: {1} do stĺpca: {0}",
            setValueExpressionPlaceholder: " Výraz, ktorého výsledok bude priradený k cieľovej otázke.",
            trigger_completeText: "Prieskum bude dokončený",
            trigger_setvalueText: "Nastaviť v otázke: {0} hodnotu {1}",
            trigger_setvalueEmptyText: "jasná hodnota otázky: {0}",
            trigger_copyvalueText: "Kopírovať do otázky: {0} hodnotu z otázky {1}",
            trigger_skipText: "V prieskume prejsť na otázku {0}",
            trigger_runExpressionText1: "Spustiť výraz: „{0}“",
            trigger_runExpressionText2: " a nastaviť výsledok v otázke: {0}",
            completedHtmlOnConditionText: "Zobraziť vlastný text pre stránku s poďakovaním.",
            showAllQuestions: "Všetky otázky",
            showAllActionTypes: "Všetky typy akcií",
            conditions: "Podmienka(-y)",
            actions: "Akcia(-e)",
            expressionEditorTitle: "Definovať podmienku(-y)",
            actionsEditorTitle: "Definovať akciu(-e)",
            deleteAction: "Odstrániť akciu",
            addNewAction: "Pridať novú akciu",
            selectedActionCaption: "Vybrať akciu na pridanie...",
            expressionInvalid: "Logický výraz je prázdny alebo neplatný. Opravte ho.",
            noActionError: "Pridajte aspoň jednu akciu.",
            actionInvalid: "Odstráňte problémy v akcii(-ách).",
            uncompletedRule_title: "Logické pravidlá sú neúplné",
            uncompletedRule_text: "Nedokončili ste niektoré logické pravidlá. Ak kartu teraz opustíte, zmeny sa stratia. Stále chcete opustiť kartu bez dokončenia zmien?",
            uncompletedRule_apply: "Áno",
            uncompletedRule_cancel: "Nie, chcem dokončiť pravidlá"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Názov panela",
            title: "Názov panelu",
            description: "Popis panelu",
            visibleIf: "Zviditeľnite panel, ak",
            requiredIf: "Nastavte panel tak, aby bol povinný, ak",
            questionsOrder: "Poradie otázok v rámci panelu",
            page: "Nadradená stránka",
            startWithNewLine: "Zobrazenie panela na novom riadku",
            state: "Stav zbalenia panela",
            width: "Šírka vnoreného panela",
            minWidth: "Minimálna šírka panela",
            maxWidth: "Maximálna šírka panela",
            showNumber: "Číselné panely"
        },
        paneldynamic: {
            name: "Názov panela",
            title: "Názov panelu",
            description: "Popis panelu",
            visibleIf: "Zviditeľnite panel, ak",
            requiredIf: "Nastavte panel tak, aby bol povinný, ak",
            page: "Presunutie panela na stranu",
            startWithNewLine: "Zobrazenie panela na novom riadku",
            state: "Stav zbalenia panela",
            width: "Šírka vnoreného panela",
            minWidth: "Minimálna šírka panela",
            maxWidth: "Maximálna šírka panela",
            confirmDelete: "Potvrdenie odstránenia panela",
            templateDescription: "Vzor popisu panela",
            templateTitle: "Vzor názvu panela",
            noEntriesText: "Prázdny text panela",
            templateTabTitle: "Vzor názvu tabulátora",
            tabTitlePlaceholder: "Zástupný symbol názvu tabulátora",
            templateVisibleIf: "Zviditeľniť samostatný panel, ak",
            hideNumber: "Skrytie čísla panela",
            titleLocation: "Zarovnanie názvu panela",
            descriptionLocation: "Zarovnanie popisu panela",
            templateTitleLocation: "Zarovnanie názvu otázky",
            templateErrorLocation: "Zarovnanie chybových hlásení",
            newPanelPosition: "Nové umiestnenie panela",
            keyName: "Zabránenie duplicitným odpovediam v nasledujúcej otázke"
        },
        question: {
            name: "Názov otázky",
            title: "Názov otázky",
            description: "Opis otázky",
            visibleIf: "Zviditeľnite otázku, ak",
            requiredIf: "Urobte otázku povinnou, ak",
            page: "Nadradená stránka",
            state: "Stav zbalenia poľa otázok",
            hideNumber: "Skrytie čísla otázky",
            titleLocation: "Zarovnanie názvu otázky",
            descriptionLocation: "Zarovnanie popisu otázky",
            errorLocation: "Zarovnanie chybových hlásení",
            indent: "Zväčšite vnútornú zarážku",
            width: "Vnorená šírka otázky",
            minWidth: "Minimálna šírka otázky",
            maxWidth: "Maximálna šírka otázky",
            textUpdateMode: "Aktualizácia hodnoty vstupného poľa"
        },
        signaturepad: {
            signatureWidth: "Šírka oblasti podpisu",
            signatureHeight: "Výška oblasti podpisu",
            signatureAutoScaleEnabled: "Automatická zmena mierky oblasti podpisu",
            showPlaceholder: "Zobrazenie zástupného symbolu",
            placeholder: "Zástupný text",
            placeholderReadOnly: "Zástupný text v režime iba na čítanie alebo v režime ukážky",
            allowClear: "Zobrazenie tlačidla Vymazať v oblasti podpisu",
            penMinWidth: "Minimálna šírka pera",
            penMaxWidth: "Maximálna šírka pera",
            penColor: "Farba ťahu"
        },
        comment: {
            rows: "Výška vstupného poľa (v riadkoch)"
        },
        showQuestionNumbers: "Zobraziť čísla otázok",
        questionStartIndex: "Otázka sa začína indexom (1, 2 alebo „A“, „a“)",
        expression: {
            name: "Názov výrazu",
            title: "Názov výrazu",
            description: "Popis výrazu",
            expression: "Výraz"
        },
        trigger: {
            expression: "Výraz"
        },
        calculatedvalue: {
            expression: "Výraz"
        },
        // survey templates
        survey: {
            title: "Titul",
            description: "Opis prieskumu"
        },
        page: {
            name: "Názov stránky",
            title: "Titul",
            description: "Popis stránky",
            visibleIf: "Zviditeľniť stránku, ak",
            requiredIf: "Nastavte stránku ako povinnú, ak",
            maxTimeToFinish: "Časový limit na dokončenie stránky (v sekundách)",
            questionsOrder: "Poradie otázok na stránke"
        },
        matrixdropdowncolumn: {
            name: "Názov stĺpca",
            title: "Názov stĺpca",
            isUnique: "Zabráňte duplicitným odpovediam",
            width: "Šírka stĺpca",
            minWidth: "Minimálna šírka stĺpca",
            rows: "Výška vstupného poľa (v riadkoch)",
            visibleIf: "Zviditeľnite stĺpec, ak",
            requiredIf: "Nastavte stĺpec ako povinný, ak",
            showInMultipleColumns: "Každá možnosť v samostatnom stĺpci"
        },
        multipletextitem: {
            name: "Meno",
            title: "Titul"
        },
        masksettings: {
            saveMaskedValue: "Uložte maskovanú hodnotu do výsledkov prieskumu"
        },
        patternmask: {
            pattern: "Hodnotový vzor"
        },
        datetimemask: {
            min: "Minimálna hodnota",
            max: "Maximálna hodnota"
        },
        numericmask: {
            allowNegativeValues: "Povolenie záporných hodnôt",
            thousandsSeparator: "Oddeľovač tisícov",
            decimalSeparator: "Oddeľovač desatinných miest",
            precision: "Presnosť hodnoty",
            min: "Minimálna hodnota",
            max: "Maximálna hodnota"
        },
        currencymask: {
            prefix: "Predčíslievanie meny",
            suffix: "Prípona meny"
        },
        imageHeight: "Výška obrázka",
        imageWidth: "Šírka obrázka",
        valueName: "Názov hodnoty",
        rateDescriptionLocation: "Zarovnanie štítkov",
        size: "Veľkosť vstupného poľa (v znakoch)",
        cellErrorLocation: "Zarovnanie chybového hlásenia bunky",
        apply: "Použiť",
        ok: "OK",
        save: "Uložiť",
        clear: "Jasný",
        saveTooltip: "Uložiť",
        cancel: "Zrušiť",
        set: "Množina",
        reset: "Obnovenie pôvodného nastavenia",
        change: "Zmeniť",
        refresh: "Obnoviť",
        close: "Zavrieť",
        delete: "Vymazať",
        add: "Pridať",
        addNew: "Pridať nové",
        addItem: "Kliknutím pridať položku...",
        removeItem: "Kliknutím položku odstránite...",
        dragItem: "Potiahnite položku",
        addOther: "Iné",
        addSelectAll: "Vybrať všetky",
        addNone: "Žiadne",
        removeAll: "Odstrániť všetko",
        edit: "Upraviť",
        back: "Návrat bez uloženia",
        backTooltip: "Návrat bez uloženia",
        saveAndBack: "Uložiť a vrátiť sa",
        saveAndBackTooltip: "Uložiť a vrátiť sa",
        doneEditing: "Robené",
        editChoices: "Upraviť možnosti",
        showChoices: "Zobraziť možnosti",
        move: "Presunúť",
        empty: "<empty>",
        emptyValue: "Hodnota je prázdna",
        fastEntry: "Rýchle zadanie",
        fastEntryNonUniqueError: "Hodnota \"{0}\" nie je jedinečná",
        fastEntryChoicesCountError: "Obmedzte počet položiek od {0} do {1}",
        fastEntryChoicesMinCountError: "Zadajte aspoň {0} položiek",
        fastEntryPlaceholder: "Údaje môžete nastaviť v nasledujúcom formáte:\nhodnota1|text\nhodnota2",
        formEntry: "Zadanie formulára",
        testService: "Test služby",
        itemSelectorEmpty: "Vyberte prvok",
        conditionActionEmpty: "Vyberte akciu",
        conditionSelectQuestion: "Vybrať otázku...",
        conditionSelectPage: "Vybrať stránku...",
        conditionSelectPanel: "Vybrať panel...",
        conditionValueQuestionTitle: "Zadajte/vyberte hodnotu",
        aceEditorHelp: "Klávesovou skratkou ctrl+space získate tip na dokončenie výrazu",
        aceEditorRowTitle: "Aktuálny riadok",
        aceEditorPanelTitle: "Aktuálny panel",
        showMore: "Ďalšie podrobnosti nájdete v dokumentácii",
        assistantTitle: "Dostupné otázky:",
        cellsEmptyRowsColumns: "K dispozícii má byť aspoň jeden stĺpec alebo riadok",
        showPreviewBeforeComplete: "Pozrite si ukážku odpovedí pred odoslaním prieskumu",
        overridingPropertyPrefix: "Nastaviť ",
        resetToDefaultCaption: "Vynulovanie",
        propertyIsEmpty: "Zadajte hodnotu",
        propertyIsNoUnique: "Zadajte jedinečnú hodnotu",
        propertyNameIsNotUnique: "Zadajte jedinečný názov",
        propertyNameIsIncorrect: "Nepoužívajte vyhradené slová: \"položka\", \"výber\", \"panel\", \"riadok\".",
        listIsEmpty: "Pridajte novú položku",
        "listIsEmpty@choices": "Zatiaľ neboli pridané žiadne možnosti",
        "listIsEmpty@columns": "Zatiaľ nemáte žiadne stĺpce",
        "listIsEmpty@rows": "Zatiaľ nemáte žiadne riadky",
        "listIsEmpty@validators": "Zatiaľ nemáte žiadne overovacie pravidlá",
        "listIsEmpty@calculatedValues": "Zatiaľ nemáte žiadne vlastné premenné",
        "listIsEmpty@triggers": "Zatiaľ nemáte žiadne spúšťače",
        "listIsEmpty@navigateToUrlOnCondition": "Zatiaľ nemáte žiadne odkazy",
        "addNew@choices": "Pridať výber",
        "addNew@columns": "Pridať nový stĺpec",
        "addNew@rows": "Pridať nový riadok",
        "addNew@validators": "Pridať nové pravidlo",
        "addNew@calculatedValues": "Pridanie novej premennej",
        "addNew@triggers": "Pridať nový spúšťač",
        "addNew@navigateToUrlOnCondition": "Pridať novú URL adresu",
        expressionIsEmpty: "Výraz je prázdny",
        value: "Hodnota",
        text: "Text",
        rowid: "ID riadka",
        imageLink: "Odkaz na obrázok",
        columnEdit: "Upraviť stĺpec: {0}",
        itemEdit: "Upraviť položku: {0}",
        url: "URL",
        path: "Cesta",
        choicesbyurl: {
            url: "URL adresa webovej služby",
            valueName: "Získanie hodnôt z nasledujúceho poľa JSON"
        },
        titleName: "Titulný názov",
        imageLinkName: "Získanie webových adries obrázkov z nasledujúceho poľa JSON",
        allowEmptyResponse: "Povoliť prázdnu odozvu",
        titlePlaceholder: "Sem zadajte titul",
        surveyTitlePlaceholder: "Sem vložte titul prieskumu",
        pageTitlePlaceholder: "Sem zadajte titul stránky",
        descriptionPlaceholder: "Zadať opis",
        surveyDescriptionPlaceholder: "Zadať opis prieskumu",
        pageDescriptionPlaceholder: "Zadať opis stránky",
        textWrapEnabled: "Možnosti zabalenia",
        showOtherItem: "Obsahuje inú položku",
        otherText: "Text inej položky",
        showNoneItem: "Neobsahuje žiadnu položku",
        showRefuseItem: "Povoliť možnosť Odmietnuť odpovedať",
        showDontKnowItem: "Povoliť možnosť Neviem",
        noneText: "Text pri žiadnej položke",
        showSelectAllItem: "Obsahuje vybraté všetky položky",
        selectAllText: "Text pri výbere všetkých položiek",
        choicesMin: "Minimálna hodnota pre automaticky vygenerované položky",
        choicesMax: "Maximálna hodnota pre automaticky vygenerované položky",
        choicesStep: "Rozdiel medzi automaticky vygenerovanými položkami",
        name: "Názov",
        title: "Titul",
        cellType: "Typ bunky",
        colCount: "Počet stĺpcov",
        choicesOrder: "Poradie vybratých možností",
        visible: "Je viditeľné?",
        isRequired: "Vyžaduje sa?",
        markRequired: "Označiť podľa potreby",
        removeRequiredMark: "Odstráňte požadovanú značku",
        isAllRowRequired: "Vyžadovať odpoveď pre všetky riadky",
        eachRowUnique: "Zabráňte duplicitným odpovediam v riadkoch",
        requiredErrorText: "Text chyby pri povinných položkách",
        startWithNewLine: "Začína sa novým riadkom?",
        rows: "Počet riadkov",
        cols: "Počet stĺpcov",
        placeholder: "Vložiť zástupný symbol",
        showPreview: "Zobraziť oblasť náhľadu",
        storeDataAsText: "Uložiť obsahu súboru vo výsledku JSON ako text",
        maxSize: "Maximálna veľkosť súboru v bajtoch",
        rowCount: "Počet riadkov",
        columnLayout: "Rozloženie stĺpcov",
        addRowLocation: "Poloha tlačidla na pridanie riadka",
        transposeData: "Transponovanie riadkov do stĺpcov",
        addRowText: "Text tlačidla na pridanie riadka",
        removeRowText: "Text tlačidla na odstránenie riadka",
        rateMin: "Minimálne hodnotenie",
        rateMax: "Maximálne hodnotenie",
        rateStep: "Krok hodnotenia",
        minRateDescription: "Opis minimálneho hodnotenia",
        maxRateDescription: "opis maximálneho hodnotenia",
        inputType: "Typ vstupu",
        optionsCaption: "Titulok možností",
        defaultValue: "Predvolená hodnota",
        cellsDefaultRow: "Predvolené texty buniek",
        surveyEditorTitle: "Upraviť nastavenia prieskumu",
        qEditorTitle: "Upraviť: {0}",
        maxLength: "Maximálna dĺžka",
        buildExpression: "Zostaviť",
        editExpression: "Upraviť",
        and: "a",
        or: "alebo",
        remove: "Odstrániť",
        addCondition: "Pridať podmienku",
        emptyLogicPopupMessage: "Vyberte otázku a začnite konfigurovať podmienky.",
        if: "Ak",
        then: "potom",
        setToName: "Cieľová otázka",
        fromName: "Otázka na kopírovanie odpovede",
        gotoName: "Otázka na preskočenie",
        ruleIsNotSet: "Pravidlo je nesprávne",
        includeIntoResult: "Zahrňte do výsledkov prieskumu",
        showTitle: "Zobraziť/skryť titul",
        expandCollapseTitle: "Rozbaliť/zbaliť titul",
        locale: "Predvolený jazyk",
        simulator: "Vybrať zariadenie",
        landscapeOrientation: "Na šírku",
        portraitOrientation: "Prepnutie na orientáciu na výšku",
        mode: "Režim (upraviť/iba na čítanie)",
        clearInvisibleValues: "Odstrániť neviditeľné hodnoty",
        cookieName: "Názov súboru cookie (na zabránenie lokálneho spustenia prieskumu dvakrát)",
        sendResultOnPageNext: "Odoslať výsledky prieskumu na ďalšiu stránku",
        storeOthersAsComment: "Uložiť hodnotu „iné“ v samostatnom poli",
        showPageTitles: "Zobraziť tituly stránok",
        showPageNumbers: "Zobraziť čísla stránok",
        pagePrevText: "Text tlačidla pre predchádzajúcu stránku",
        pageNextText: "Text tlačidla pre ďalšiu stránku",
        completeText: "Text tlačidla dokončenia",
        previewText: "Text tlačidla ukážky",
        editText: "Text tlačidla úpravy",
        startSurveyText: "Text tlačidla spustenia",
        showNavigationButtons: "Zobraziť navigačné tlačidlá (predvolená navigácia)",
        showPrevButton: "Zobraziť tlačidlo predchádzajúce (používateľ sa môže vráiť na predchádzajúcu stránku)",
        firstPageIsStarted: "Prvá stránka v prieskume je úvodná stránka.",
        showCompletedPage: "Na konci zobraziť stránku s dokončením (completedHtml)",
        goNextPageAutomatic: "Po zodpovedaní všetkých otázok prejsť na ďalšiu stránku automaticky",
        allowCompleteSurveyAutomatic: "Vyplňte prieskum automaticky",
        showProgressBar: "Zobraziť indikátor priebehu",
        questionTitleLocation: "Poloha titulu otázky",
        questionTitleWidth: "Šírka názvu otázky",
        requiredText: "Povinný symbol(-y) otázok",
        questionTitleTemplate: "Šablóna titulu otázky, predvolená je:  „{no}. {require} {title}“",
        questionErrorLocation: "Poloha chyby otázky",
        focusFirstQuestionAutomatic: "Prechod na prvú otázku pri zmene stránky",
        questionsOrder: "Poradie prvkov na stránke",
        maxTimeToFinish: "Maximálny čas na dokončenie prieskumu",
        maxTimeToFinishPage: "Maximálny čas na dokončenie stránky v rámci prieskumu",
        showTimerPanel: "Zobraziť panel s časovačom",
        showTimerPanelMode: "Zobraziť režim panela s časovačom",
        renderMode: "Režim vykresľovania",
        allowAddPanel: "Povoliť pridanie panela",
        allowRemovePanel: "Povoliť odstránenie panela",
        panelAddText: "Text pri pridaní panela",
        panelRemoveText: "Text pri odstránení panela",
        isSinglePage: "Zobraziť všetky prvky na jednej stránke",
        html: "Html",
        setValue: "Odpoveď",
        dataFormat: "Formát obrázka",
        allowAddRows: "Povoliť pridávanie riadkov",
        allowRemoveRows: "Povoliť odstránenie riadkov",
        allowRowsDragAndDrop: "Povoliť presúvanie riadkov",
        responsiveImageSizeHelp: "Neuplatňuje sa, ak zadáte presnú šírku alebo výšku obrázka.",
        minImageWidth: "Minimálna šírka obrázka",
        maxImageWidth: "Maximálna šírka obrázka",
        minImageHeight: "Minimálna výška obrázka",
        maxImageHeight: "Maximálna výška obrázka",
        minValue: "Minimálna hodnota",
        maxValue: "Maximálna hodnota",
        minLength: "Minimálna dĺžka",
        allowDigits: "Povoliť čísla",
        minCount: "Minimálny počet",
        maxCount: "Maximálny počet",
        regex: "Regulárny výraz",
        surveyvalidator: {
            text: "Chybové hlásenie",
            expression: "Overovací výraz"
        },
        totalText: "Celkom – text",
        totalType: "Celkom – typ",
        totalExpression: "Celkom – výraz",
        totalDisplayStyle: "Celkom – štýl zobrazenia",
        totalCurrency: "Celkom – mena",
        totalFormat: "Celkom – formát",
        logo: "Logo (reťazec s kódovaním URL alebo base64)",
        questionsOnPageMode: "Štruktúra prieskumu",
        maxTextLength: "Maximálna dĺžka odpovede (v znakoch)",
        maxOthersLength: "Maximálna dĺžka komentára (v znakoch)",
        commentAreaRows: "Výška oblasti komentárov (v riadkoch)",
        autoGrowComment: "V prípade potreby automaticky rozbaľte oblasť komentárov",
        allowResizeComment: "Povolenie používateľom meniť veľkosť textových oblastí",
        textUpdateMode: "Aktualizácia hodnoty textovej otázky",
        maskType: "Typ vstupnej masky",
        maskTypes: {
            none: "Žiadny",
            patternmask: "Vzorka",
            numericmask: "Numerický",
            datetimemask: "Dátum a čas",
            currencymask: "Mena"
        },
        focusOnFirstError: "Zameranie na prvú neplatnú odpoveď",
        checkErrorsMode: "Spustenie overenia pravosti",
        navigateToUrl: "Prejsť na adresu URL",
        navigateToUrlOnCondition: "Dynamická webová adresa",
        completedBeforeHtml: "Značky na zobrazenie, či používateľ už vyplnil tento prieskum",
        completedHtml: "Značenie stránky dokončenia prieskumu",
        completedHtmlOnCondition: "Dynamický prieskum Kompletné značenie stránky",
        loadingHtml: "Značenie, ktoré sa zobrazí počas načítavania modelu prieskumu",
        commentText: "Text oblasti komentárov",
        autocomplete: "Typ automatického dokončovania",
        labelTrue: "Označenie \"Pravda\"",
        labelFalse: "Označenie \"False\"",
        allowClear: "Zobraziť titulok možností",
        searchMode: "Režim vyhľadávania",
        displayStyle: "Štýl zobrazenia hodnoty",
        format: "Formátovaný reťazec",
        maximumFractionDigits: "Maximálny zlomkový počet číslic",
        minimumFractionDigits: "Minimálne zlomkové číslice",
        useGrouping: "Oddeľovače zoskupení zobrazení",
        allowMultiple: "Povolenie viacerých súborov",
        allowImagesPreview: "Ukážka obrázkov",
        acceptedTypes: "Akceptované typy súborov",
        waitForUpload: "Počkajte na dokončenie nahrávania",
        needConfirmRemoveFile: "Potvrďte odstránenie súboru",
        detailPanelMode: "Umiestnenie panela s podrobnosťami",
        minRowCount: "Minimálny počet riadkov",
        maxRowCount: "Maximálny počet riadkov",
        confirmDelete: "Potvrdenie odstránenia riadka",
        confirmDeleteText: "Potvrdzovacia správa",
        panelCount: "Počiatočný počet panelov",
        minPanelCount: "Minimálny počet panelov",
        maxPanelCount: "Maximálny počet panelov",
        panelsState: "Stav rozbalenia vnútorného panela",
        panelPrevText: "Popis tlačidla Predchádzajúci panel",
        panelNextText: "Popis tlačidla Nasledujúci panel",
        showRangeInProgress: "Zobraziť indikátor priebehu",
        panelRemoveButtonLocation: "Odstrániť umiestnenie tlačidla panela",
        hideIfRowsEmpty: "Skryť otázku, ak nie sú žiadne riadky",
        hideColumnsIfEmpty: "Skryť stĺpce, ak nie sú k dispozícii žiadne riadky",
        rateValues: "Vlastné hodnoty sadzieb",
        rateCount: "Počet sadzieb",
        autoGenerate: "Ako určiť hodnoty sadzieb?",
        hideIfChoicesEmpty: "Skryť otázku, ak neobsahuje žiadne možnosti",
        minWidth: "Minimálna šírka (v hodnotách akceptovaných CSS)",
        maxWidth: "Maximálna šírka (v hodnotách akceptovaných CSS)",
        width: "Šírka (v akceptovaných hodnotách CSS)",
        showHeader: "Zobrazenie hlavičiek stĺpcov",
        horizontalScroll: "Zobraziť vodorovný posúvač",
        columnMinWidth: "Minimálna šírka stĺpca (v hodnotách akceptovaných CSS)",
        rowTitleWidth: "Šírka hlavičky riadka (v hodnotách akceptovaných CSS)",
        valueTrue: "Hodnota \"True\"",
        valueFalse: "Hodnota \"False\"",
        minErrorText: "Chybové hlásenie \"Hodnota je nižšia ako minimum\"",
        maxErrorText: "Chybové hlásenie \"Hodnota prekračuje maximum\"",
        otherErrorText: "Chybové hlásenie \"Prázdny komentár\"",
        keyDuplicationError: "Chybové hlásenie \"Nejedinečná kľúčová hodnota\"",
        minSelectedChoices: "Minimálny počet vybraných možností",
        maxSelectedChoices: "Maximálny počet vybraných možností",
        showClearButton: "Zobrazenie tlačidla Vymazať",
        logoWidth: "Šírka loga (v akceptovaných hodnotách CSS)",
        logoHeight: "Výška loga (v hodnotách akceptovaných CSS)",
        readOnly: "Iba na čítanie",
        enableIf: "Upraviteľné, ak",
        emptyRowsText: "Správa \"Žiadne riadky\"",
        separateSpecialChoices: "Samostatné špeciálne možnosti (Žiadne, Iné, Vybrať všetko)",
        choicesFromQuestion: "Skopírujte voľby z nasledujúcej otázky",
        choicesFromQuestionMode: "Aké možnosti kopírovať?",
        progressBarShowPageTitles: "Zobrazenie prebiehajúcich názvov stránok",
        progressBarShowPageNumbers: "Zobrazenie prebiehajúcich čísel strán",
        showCommentArea: "Zobrazenie oblasti komentárov",
        commentPlaceholder: "Zástupný symbol oblasti komentárov",
        displayRateDescriptionsAsExtremeItems: "Popisy rýchlosti zobrazenia ako extrémnych hodnôt",
        rowsOrder: "Poradie riadkov",
        columnsLayout: "Rozloženie stĺpcov",
        columnColCount: "Vnorený počet stĺpcov",
        correctAnswer: "Správna odpoveď",
        defaultPanelValue: "Predvolené hodnoty",
        cells: "Texty buniek",
        fileInputPlaceholder: "Vyberte súbor alebo prilepte odkaz na súbor...",
        keyName: "Stĺpec kľúča",
        itemvalue: {
            visibleIf: "Možnosť zobraziť, ak",
            enableIf: "Túto možnosť nastavte tak, aby sa dala vybrať, ak"
        },
        "itemvalue@rows": {
            visibleIf: "Nastavenie riadka ako viditeľného, ak",
            enableIf: "Nastavte riadok tak, aby ho bolo možné upravovať, ak"
        },
        imageitemvalue: {
            text: "Alternatívny text"
        },
        logoPosition: "Poloha loga",
        addLogo: "Pridať logo...",
        changeLogo: "Zmeniť logo...",
        logoPositions: {
            none: "Odstrániť logo",
            left: "Vľavo",
            right: "Vpravo",
            top: "V hornej časti",
            bottom: "V spodnej časti"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Rozloženie panela"
            },
            general: "Všeobecné",
            fileOptions: "Možnosti",
            html: "Editor Html",
            columns: "Stĺpce",
            rows: "Riadky",
            choices: "Možnosti",
            items: "Položky",
            visibleIf: "Viditeľné ak",
            enableIf: "Povoliť ak",
            requiredIf: "Povinné ak",
            rateValues: "Hodnoty hodnotenia",
            choicesByUrl: "Možnosti z webu",
            matrixChoices: "Predvolené možnosti",
            multipleTextItems: "Zadania textu",
            numbering: "Číslovanie",
            validators: "Overovatelia",
            navigation: "Navigácia",
            question: "Otázka",
            pages: "Stránky",
            timer: "Časovač/kvíz",
            calculatedValues: "Vypočítané hodnoty",
            triggers: "Aktivátory",
            templateTitle: "Titul šablóny",
            totals: "Celkové hodnoty",
            logic: "Logický výraz",
            mask: "Nastavenia vstupnej masky",
            layout: {
                panel: "Rozloženie",
                question: "Rozloženie",
                base: "Rozloženie"
            },
            data: "Údaje",
            validation: "Overenie",
            cells: "Bunky",
            showOnCompleted: "Zobraziť pri dokončení",
            logo: "Logo v titule prieskumu",
            slider: "Jazdec",
            expression: "Výraz",
            questionSettings: "Nastavenia otázok",
            header: "Hlavička",
            background: "Pozadie",
            appearance: "Vzhľad",
            others: "Iné"
        },
        editProperty: "Upraviť vlastnosť „{0}“",
        items: "[ Položky: {0} ]",
        choicesVisibleIf: "Voľby sú viditeľné, ak",
        choicesEnableIf: "Možnosti výberu sú voliteľné, ak",
        columnsEnableIf: "Stĺpce sú viditeľné, ak",
        rowsEnableIf: "Riadky sú viditeľné, ak",
        innerIndent: "Pridanie vnútorných zarážok",
        defaultValueFromLastRow: "Prevzatie predvolených hodnôt z posledného riadka",
        defaultValueFromLastPanel: "Prevzatie predvolených hodnôt z posledného panela",
        enterNewValue: "Zadajte hodnotu.",
        noquestions: "V prieskume nie je žiadna otázka.",
        createtrigger: "Vytvorte aktivátor",
        titleKeyboardAdornerTip: "Upraviť stlačením tlačidla Enter",
        keyboardAdornerTip: "Stlačením tlačidla Enter položku upravíte, stlačením tlačidla Odstrániť položku odstránite, stlačením tlačidla Alt a šípky nahor alebo šípky nadol položku presuniete",
        triggerOn: "Zap. ",
        triggerMakePagesVisible: "Viditeľnosť stránok:",
        triggerMakeQuestionsVisible: "Viditeľnosť prvkov:",
        triggerCompleteText: "V prípade úspechu prieskum dokočniť.",
        triggerNotSet: "Aktivátor nie je nastavený",
        triggerRunIf: "Spustiť ak",
        triggerSetToName: "Zmeniť hodnotu: ",
        triggerFromName: "Kopírovať hodnotu z: ",
        triggerRunExpression: "Spustiť tento výraz:",
        triggerSetValue: "na: ",
        triggerGotoName: "Prejsť na otázku:",
        triggerIsVariable: "Nezaraďujte premennú do výsledku prieskumu.",
        triggerRunExpressionEmpty: "Zadajte platný výraz",
        emptyExpressionPlaceHolder: "Sem zadajte výraz...",
        noFile: "Nevybratý žiadny súbor",
        clearIfInvisible: "Ak sa otázka skryje, vymažte hodnotu",
        valuePropertyName: "Názov vlastnosti Value",
        searchEnabled: "Povoliť vyhľadávanie",
        hideSelectedItems: "Skryť vybraté položky",
        closeOnSelect: "Zatvorenie rozbaľovacieho zoznamu po výbere",
        verticalAlign: "Vertikálne zarovnanie",
        alternateRows: "Alternatívne riadky",
        columnsVisibleIf: "Stĺpce sú viditeľné, ak",
        rowsVisibleIf: "Riadky sú viditeľné, ak",
        otherPlaceholder: "Zástupný symbol oblasti komentárov",
        filePlaceholder: "Zástupný text súboru",
        photoPlaceholder: "Zástupný text fotografie",
        fileOrPhotoPlaceholder: "Zástupný text súboru alebo fotografie",
        rateType: "Typ sadzby",
        url_placeholder: "Napríklad: https://api.example.com/books",
        path_placeholder: "Napr.: kategórie.fikcia",
        questionStartIndex_placeholder: "Napr.: a)",
        width_placeholder: "Napr.: 6in",
        minWidth_placeholder: "Napríklad: 600px",
        maxWidth_placeholder: "Napríklad: 50%",
        imageHeight_placeholder: "auto",
        imageWidth_placeholder: "auto",
        theme: {
            themeName: "Téma",
            isPanelless: "Vzhľad otázky",
            editorPanel: "Pozadie a polomer rohov",
            questionPanel: "Pozadie a polomer rohov",
            primaryColor: "Farba akcentu",
            panelBackgroundTransparency: "Nepriehľadnosť pozadia panela",
            questionBackgroundTransparency: "Nepriehľadnosť pozadia otázky",
            fontSize: "Veľkosť písma",
            scale: "Stupnica",
            cornerRadius: "Polomer rohov",
            pageTitle: "Písmo názvu",
            pageDescription: "Popisné písmo",
            questionTitle: "Písmo názvu",
            questionDescription: "Popisné písmo",
            editorFont: "Písmo",
            backgroundOpacity: "Neprehľadnosť",
            "--sjs-font-family": "Skupina písiem",
            "--sjs-general-backcolor-dim": "Farba pozadia",
            "--sjs-primary-backcolor": "Zvýraznenie pozadia",
            "--sjs-primary-forecolor": "Zvýraznenie v popredí",
            "--sjs-special-red": "Chybové hlásenia",
            "--sjs-shadow-small": "Efekty tieňov",
            "--sjs-shadow-inner": "Efekty tieňov",
            "--sjs-border-default": "Farby"
        },
        "header@header": {
            headerView: "Pohľad",
            logoPosition: "Umiestnenie loga",
            surveyTitle: "Písmo názvu prieskumu",
            surveyDescription: "Písmo popisu prieskumu",
            headerTitle: "Písmo názvu prieskumu",
            headerDescription: "Písmo popisu prieskumu",
            inheritWidthFrom: "Šírka oblasti obsahu",
            textAreaWidth: "Šírka textu",
            backgroundColorSwitch: "Farba pozadia",
            backgroundImage: "Obrázok na pozadí",
            backgroundImageOpacity: "Neprehľadnosť",
            overlapEnabled: "Presahovať",
            logoPositionX: "Umiestnenie loga",
            titlePositionX: "Pozícia názvu",
            descriptionPositionX: "Popisná poloha"
        }
    },
    // Property values
    pv: {
        "true": "pravdivý",
        "false": "nepravdivé",
        file: "Lokálne súbory",
        camera: "Fotoaparát",
        "file-camera": "Lokálne súbory alebo fotoaparát",
        inherit: "prevziať",
        show: "zobraziť",
        hide: "skryť",
        default: "predvolené",
        initial: "počiatočné",
        random: "náhodné",
        collapsed: "zbalené",
        expanded: "rozbalené",
        none: "žiadne",
        asc: "vzostupne",
        desc: "zostupne",
        indeterminate: "nestanovené",
        selected: "Vybraný",
        unselected: "Nevybratý",
        decimal: "desatinný",
        currency: "mena",
        percent: "percento",
        firstExpanded: "prvý rozbalený",
        off: "vyp.",
        list: "zoznam",
        progressTop: "horná časť priebehu",
        progressBottom: "spodná časť priebehu",
        progressTopBottom: "priebeh –​ horná a spodná časť",
        tab: "Karty",
        horizontal: "vodorovné",
        vertical: "zvislé",
        top: "hore",
        bottom: "dolu",
        topBottom: "hore a dolu",
        both: "obidva",
        left: "vľavo",
        right: "Doprava",
        center: "Centrum",
        leftRight: "Vľavo a vpravo",
        middle: "Stred",
        color: "farba",
        date: "dátum",
        datetime: "dátum a čas",
        "datetime-local": "dátum a čas miestny",
        email: "E-mail",
        month: "mesiac",
        number: "číslo",
        password: "heslo",
        range: "rozsah",
        tel: "Tel",
        text: "Text",
        time: "Čas",
        url: "URL adresa",
        week: "týždeň",
        hidden: "skryté",
        edit: "upraviť",
        display: "zobraziť",
        contain: "Obsahovať",
        cover: "Prikryť",
        fill: "Vyplniť",
        next: "Budúci",
        last: "Minulý",
        onComplete: "pri dokončení",
        onHidden: "pri skrytí",
        onHiddenContainer: "Keď sa otázka alebo jej panel/stránka skryje",
        clearInvisibleValues: {
            none: "Nikdy"
        },
        clearIfInvisible: {
            none: "Nikdy"
        },
        inputType: {
            color: "Farba",
            date: "Dátum",
            "datetime-local": "Dátum a čas",
            email: "E-mail",
            month: "Mesiac",
            number: "Číslo",
            password: "Heslo",
            range: "Rozsah",
            tel: "Telefónne číslo",
            text: "Text",
            time: "Čas",
            url: "URL adresa",
            week: "Týždeň"
        },
        all: "všetko",
        page: "stránka",
        survey: "prieskum",
        onNextPage: "na ďalšej stránke",
        onValueChanged: "pri zmene hodnoty",
        onValueChanging: "Pred zmenou odpovede",
        questionsOnPageMode: {
            standard: "Pôvodná štruktúra",
            singlePage: "Zobraziť všetky otázky na jednej stránke",
            questionPerPage: "Zobraziť jednu otázku na stránku"
        },
        noPreview: "žiadna ukážka",
        showAllQuestions: "zobraziť ukážku so všetkými otázkami",
        showAnsweredQuestions: "zobraziť ukážku so zodpovedanými otázkami",
        pages: "stránky",
        questions: "otázky",
        requiredQuestions: "povinné otázky",
        correctQuestions: "správne otázky",
        buttons: "tlačidlá",
        underInput: "v rámci vstupu",
        underTitle: "v rámci titulu",
        onBlur: "Pri rozmazaní",
        onTyping: "Počas písania",
        underRow: "Pod riadkom",
        underRowSingle: "Pod riadkom je viditeľný iba jeden panel",
        auto: "Auto",
        showNavigationButtons: {
            none: "Skrytý"
        },
        showTimerPanel: {
            none: "Skrytý"
        },
        showTimerPanelMode: {
            all: "Obidva"
        },
        addRowLocation: {
            default: "Závisí od rozloženia matice"
        },
        panelsState: {
            default: "Používatelia nemôžu rozbaliť alebo zbaliť panely",
            collapsed: "Všetky panely sú zbalené",
            expanded: "Všetky panely sú rozšírené",
            firstExpanded: "Prvé rozšírenie"
        },
        widthMode: {
            static: "Statický",
            responsive: "Citlivý"
        },
        contentMode: {
            image: "Obraz",
            video: "Video",
            youtube: "YouTube"
        },
        displayMode: {
            buttons: "Tlačidlá",
            dropdown: "Rozbaľovací zoznam"
        },
        rateColorMode: {
            default: "Predvolený",
            scale: "Stupnica"
        },
        scaleColorMode: {
            monochrome: "Jednofarebný",
            colored: "Farebný"
        },
        autoGenerate: {
            "true": "Generovať",
            "false": "Manuálne zadanie"
        },
        rateType: {
            labels: "Menovky",
            stars: "Hviezdy",
            smileys: "Smajlíky"
        },
        state: {
            default: "Zamknutý"
        },
        showQuestionNumbers: {
            default: "Automatické číslovanie",
            on: "Automatické číslovanie",
            onPage: "Obnoviť na každej stránke",
            onpanel: "Resetovať na každom paneli",
            onPanel: "Resetovať na každom paneli",
            onSurvey: "Pokračujte v prieskume",
            off: "Bez číslovania"
        },
        descriptionLocation: {
            underTitle: "Pod názvom otázky",
            underInput: "Pod vstupným poľom"
        },
        selectToRankAreasLayout: {
            horizontal: "Vedľa možností",
            vertical: "Vyššie uvedené možnosti"
        },
        displayStyle: {
            decimal: "Desatinný",
            currency: "Mena",
            percent: "Percento",
            date: "Dátum"
        },
        totalDisplayStyle: {
            decimal: "Desatinný",
            currency: "Mena",
            percent: "Percento",
            date: "Dátum"
        },
        rowsOrder: {
            initial: "Originál"
        },
        questionsOrder: {
            initial: "Originál"
        },
        showProgressBar: {
            off: "Skrytý",
            topbottom: "hore a dolu",
            aboveheader: "Nad hlavičkou",
            belowheader: "Pod hlavičkou"
        },
        sum: "Súčet",
        count: "Počítať",
        min: "Min",
        max: "Max",
        avg: "Avg",
        searchMode: {
            contains: "Obsahuje",
            startsWith: "Začína sa"
        },
        backgroundImageFit: {
            auto: "Auto",
            cover: "Prikryť",
            contain: "Obsahovať",
            fill: "Natiahnuť",
            tile: "Dlaždica"
        },
        backgroundImageAttachment: {
            fixed: "Stabilný",
            scroll: "Zvitok"
        },
        headerView: {
            basic: "Základný",
            advanced: "Pokročilý"
        },
        inheritWidthFrom: {
            survey: "Rovnaké ako prieskum",
            container: "Vhodné na kontajner"
        },
        backgroundColorSwitch: {
            none: "Žiadny",
            accentColor: "Farba akcentu",
            custom: "Zvyk"
        },
        colorPalette: {
            light: "Svetlo",
            dark: "Tmavý"
        },
        isPanelless: {
            "false": "Predvolený",
            "true": "Bez panelov"
        }
    },
    // Operators
    op: {
        empty: "je prázdne",
        notempty: "nie je prázdne",
        equal: "rovná sa",
        notequal: "nerovná sa",
        contains: "obsahuje",
        notcontains: "neobsahuje",
        anyof: "ktorákoľvek",
        allof: "všetky",
        greater: "väčšie",
        less: "menšie",
        greaterorequal: "väčšie alebo rovné",
        lessorequal: "menšie alebo rovné",
        and: "a",
        or: "alebo"
    },
    // Embed window
    ew: {
        angular: "Použiť verziu Angular",
        jquery: "Použiť verziu jQuery",
        knockout: "Použiť verziu Knockout",
        react: "Použiť verziu React",
        vue: "Použiť verziu Vue",
        bootstrap: "Pre rámec bootstrap",
        modern: "Moderný motív",
        default: "Predvolený motív",
        orange: "Oranžový motív",
        darkblue: "Tmavomodrý motív",
        darkrose: "Motív Darkrose",
        stone: "Motív Stone",
        winter: "Motív Winter",
        winterstone: "Motív Winter-Stone",
        showOnPage: "Zobraziť prieskum na stránke",
        showInWindow: "Zobraziť prieskum v okne",
        loadFromServer: "Načítať JSON prieskumu zo servera",
        titleScript: "Skripty a štýly",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Vybrať stránku na testovanie:",
        showInvisibleElements: "Zobraziť neviditeľné prvky",
        hideInvisibleElements: "Skryť neviditeľné prvky"
    },
    validators: {
        answercountvalidator: "počet odpovedí",
        emailvalidator: "e-mail",
        expressionvalidator: "výraz",
        numericvalidator: "číslo",
        regexvalidator: "regex",
        textvalidator: "text"
    },
    triggers: {
        completetrigger: "dokončiť prieskum",
        setvaluetrigger: "nastaviť hodnotu",
        copyvaluetrigger: "kopírovať hodnotu",
        skiptrigger: "prejsť na otázku",
        runexpressiontrigger: "spustiť výraz",
        visibletrigger: "zmeniť viditeľnosť (zastarané)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Napríklad: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Napr.: mm/dd/rrrr"
        },
        currencymask: {
            prefix: "Napr.: $",
            suffix: "Napríklad: USD"
        },
        panelbase: {
            questionTitleWidth: "Napríklad: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "ID panela, ktoré respondenti nevidia.",
            description: "Zadajte podnadpis panela.",
            visibleIf: "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré určuje viditeľnosť panela.",
            enableIf: "Pomocou ikony čarovnej paličky nastavte podmienené pravidlo, ktoré vypne režim iba na čítanie pre panel.",
            requiredIf: "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré zabráni odoslaniu prieskumu, pokiaľ aspoň jedna vnorená otázka nemá odpoveď.",
            questionTitleLocation: "Vzťahuje sa na všetky otázky v tomto paneli. Ak chcete toto nastavenie prepísať, definujte pravidlá zarovnania názvu pre jednotlivé otázky. Možnosť Dediť použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu (\"Predvolene navrchu\").",
            questionTitleWidth: "Nastavuje konzistentnú šírku názvov otázok, keď sú zarovnané naľavo od polí otázok. Akceptuje hodnoty CSS (px, %, in, pt atď.).",
            questionErrorLocation: "Nastaví umiestnenie chybového hlásenia vo vzťahu ku všetkým otázkam v paneli. Možnosť Zdediť použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu.",
            questionsOrder: "Zachová pôvodné poradie otázok alebo ich náhodne vyberie. Možnosť Zdediť použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu.",
            page: "Premiestni panel na koniec vybratej strany.",
            innerIndent: "Pridá medzeru alebo okraj medzi obsah panela a ľavý okraj panela.",
            startWithNewLine: "Zrušte výber výberu, ak chcete panel zobraziť v jednom riadku s predchádzajúcou otázkou alebo panelom. Toto nastavenie sa neuplatňuje, ak je panel prvým prvkom vo formulári.",
            state: "Vyberte si z: \"Rozšírené\" - panel je zobrazený v plnom rozsahu a môže byť zbalený; \"Zbalené\" - panel zobrazuje iba názov a popis a je možné ho rozšíriť; \"Zamknutý\" - panel sa zobrazuje v plnom rozsahu a nedá sa zbaliť.",
            width: "Nastaví šírku panela v pomere k ostatným prvkom prieskumu v tej istej čiare. Akceptuje hodnoty CSS (px, %, in, pt atď.)."
        },
        paneldynamic: {
            name: "ID panela, ktoré respondenti nevidia.",
            description: "Zadajte podnadpis panela.",
            visibleIf: "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré určuje viditeľnosť panela.",
            enableIf: "Pomocou ikony čarovnej paličky nastavte podmienené pravidlo, ktoré vypne režim iba na čítanie pre panel.",
            requiredIf: "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré zabráni odoslaniu prieskumu, pokiaľ aspoň jedna vnorená otázka nemá odpoveď.",
            templateTitleLocation: "Vzťahuje sa na všetky otázky v tomto paneli. Ak chcete toto nastavenie prepísať, definujte pravidlá zarovnania názvu pre jednotlivé otázky. Možnosť Dediť použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu (\"Predvolene navrchu\").",
            templateErrorLocation: "Nastaví umiestnenie chybového hlásenia vo vzťahu k otázke s neplatným zadaním. Vyberte si medzi: \"Hore\" - v hornej časti poľa otázok sa umiestni chybový text; \"Dole\" - v dolnej časti poľa otázok je umiestnený chybový text. Možnosť Dediť použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu (\"Predvolene navrchu\").",
            errorLocation: "Nastaví umiestnenie chybového hlásenia vo vzťahu ku všetkým otázkam v paneli. Možnosť Zdediť použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu.",
            page: "Premiestni panel na koniec vybratej strany.",
            innerIndent: "Pridá medzeru alebo okraj medzi obsah panela a ľavý okraj panela.",
            startWithNewLine: "Zrušte výber výberu, ak chcete panel zobraziť v jednom riadku s predchádzajúcou otázkou alebo panelom. Toto nastavenie sa neuplatňuje, ak je panel prvým prvkom vo formulári.",
            state: "Vyberte si z: \"Rozšírené\" - panel je zobrazený v plnom rozsahu a môže byť zbalený; \"Zbalené\" - panel zobrazuje iba názov a popis a je možné ho rozšíriť; \"Zamknutý\" - panel sa zobrazuje v plnom rozsahu a nedá sa zbaliť.",
            width: "Nastaví šírku panela v pomere k ostatným prvkom prieskumu v tej istej čiare. Akceptuje hodnoty CSS (px, %, in, pt atď.).",
            templateTitle: "Zadajte šablónu pre názvy dynamických panelov. Použite {panelIndex} pre všeobecnú pozíciu panela a {visiblePanelIndex} pre jeho poradie medzi viditeľnými panelmi. Vložením týchto zástupných symbolov do vzoru pridáte automatické číslovanie.",
            templateTabTitle: "Zadajte šablónu pre názvy kariet. Použite {panelIndex} pre všeobecnú pozíciu panela a {visiblePanelIndex} pre jeho poradie medzi viditeľnými panelmi. Vložením týchto zástupných symbolov do vzoru pridáte automatické číslovanie.",
            tabTitlePlaceholder: "Záložný text pre názvy kariet, ktorý sa použije, keď vzor názvu tabulátora nevytvára zmysluplnú hodnotu.",
            templateVisibleIf: "Toto nastavenie umožňuje ovládať viditeľnosť jednotlivých panelov v dynamickom paneli. Použite zástupný symbol {panel} na odkaz na aktuálny panel vo svojom výraze.",
            titleLocation: "Toto nastavenie sa automaticky dedí všetkými otázkami na tomto paneli. Ak chcete toto nastavenie prepísať, definujte pravidlá zarovnania názvu pre jednotlivé otázky. Možnosť Dediť použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu (\"Predvolene navrchu\").",
            descriptionLocation: "Možnosť \"Dediť\" použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu (\"Predvolene pod názvom panela\").",
            newPanelPosition: "Definuje pozíciu novo pridaného panela. V predvolenom nastavení sa na koniec pridávajú nové panely. Výberom položky \"Ďalej\" vložíte nový panel za aktuálny.",
            defaultValueFromLastPanel: "Duplikuje odpovede z posledného panela a priradí ich ďalšiemu pridanému dynamickému panelu.",
            keyName: "Odkážte na názov otázky, ak chcete, aby používateľ poskytol jedinečnú odpoveď na túto otázku na každom paneli."
        },
        defaultValueExpression: "Toto nastavenie vám umožňuje priradiť predvolenú hodnotu odpovede na základe výrazu. Výraz môže obsahovať základné výpočty - '{q1_id} + {q2_id}', boolovské výrazy, ako napríklad '{age} > 60', a funkcie: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' atď. Hodnota určená týmto výrazom slúži ako počiatočná predvolená hodnota, ktorú je možné prepísať manuálnym vstupom respondenta.",
        resetValueIf: "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré určuje, kedy sa vstup respondenta obnoví na hodnotu na základe hodnoty \"Výraz predvolenej hodnoty\" alebo \"Výraz nastavenej hodnoty\" alebo hodnoty \"Predvolená odpoveď\" (ak je nastavená).",
        setValueIf: "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré určuje, kedy spustiť \"Nastaviť výraz hodnoty\" a dynamicky priradiť výslednú hodnotu ako odpoveď.",
        setValueExpression: "Zadajte výraz, ktorý definuje hodnotu, ktorá sa má nastaviť, keď sú splnené podmienky pravidla \"Nastaviť hodnotu ak\". Výraz môže obsahovať základné výpočty - '{q1_id} + {q2_id}', boolovské výrazy, ako napríklad '{age} > 60', a funkcie: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' atď. Hodnota určená týmto výrazom môže byť prepísaná manuálnym vstupom respondenta.",
        question: {
            name: "ID otázky, ktoré respondenti nevidia.",
            description: "Zadajte podnadpis otázky.",
            visibleIf: "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré určuje viditeľnosť otázky.",
            enableIf: "Pomocou ikony čarovnej paličky nastavte podmienené pravidlo, ktoré vypne režim iba na čítanie pre otázku.",
            requiredIf: "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré zabráni postupu alebo odoslaniu prieskumu, pokiaľ otázka nedostala odpoveď.",
            startWithNewLine: "Zrušte výber výberu, ak chcete otázku zobraziť v jednom riadku s predchádzajúcou otázkou alebo panelom. Toto nastavenie sa neuplatňuje, ak je otázka prvým prvkom vo formulári.",
            page: "Premiestni otázku na koniec vybratej strany.",
            state: "Vyberte si z: \"Rozšírené\" - pole otázky sa zobrazí v plnom rozsahu a dá sa zbaliť; \"Zbalené\" - pole otázky zobrazuje iba názov a popis a je možné ho rozbaliť; \"Zamknuté\" - pole otázok sa zobrazí v plnom rozsahu a nedá sa zbaliť.",
            titleLocation: "Prepíše pravidlá zarovnania názvu definované na úrovni panela, stránky alebo prieskumu. Možnosť \"Dediť\" použije akékoľvek nastavenia vyššej úrovne (ak sú nastavené) alebo nastavenia na úrovni prieskumu (\"Predvolene hore\").",
            descriptionLocation: "Možnosť \"Zdediť\" použije nastavenie na úrovni prieskumu (\"Predvolene pod názvom otázky\").",
            errorLocation: "Nastaví umiestnenie chybového hlásenia vo vzťahu k otázke s neplatným zadaním. Vyberte si medzi: \"Hore\" - v hornej časti poľa otázok sa umiestni chybový text; \"Dole\" - v dolnej časti poľa otázok je umiestnený chybový text. Možnosť \"Zdediť\" použije nastavenie na úrovni prieskumu (\"Predvolene hore\").",
            indent: "Pridá medzeru alebo okraj medzi obsah otázky a ľavý okraj poľa otázok.",
            width: "Nastaví šírku otázky v pomere k ostatným prvkom prieskumu v tom istom riadku. Akceptuje hodnoty CSS (px, %, in, pt atď.).",
            surveyvalidator: {
                expression: "Pomocou ikony čarovného prútika nastavte overovacie pravidlo pre otázku."
            },
            textUpdateMode: "Vyberte si z: \"Pri strate zaostrenia\" - hodnota sa aktualizuje, keď vstupné pole stratí zaostrenie; \"Počas písania\" - hodnota sa aktualizuje v reálnom čase, keď používatelia píšu. Možnosť \"Zdediť\" použije nastavenie na úrovni prieskumu (\"Predvolene stratené zameranie\").",
            url: "Ako zdroj údajov môžete použiť ľubovoľnú webovú službu na otázky s voliteľnými odpoveďami. Ak chcete vyplniť hodnoty možností, zadajte adresu URL služby poskytujúcej údaje.",
            searchMode: "Porovnávacia operácia použitá na filtrovanie rozbaľovacieho zoznamu.",
            textWrapEnabled: "Dlhé texty v možnostiach výberu automaticky vygenerujú zlomy riadkov, aby sa zmestili do rozbaľovacej ponuky. Zrušte výber, či chcete texty vystrihnúť."
        },
        signaturepad: {
            signatureWidth: "Nastaví šírku zobrazenej oblasti podpisu a výsledného obrázka.",
            signatureHeight: "Nastaví výšku zobrazenej oblasti podpisu a výsledného obrázka.",
            signatureAutoScaleEnabled: "Vyberte, či chcete, aby oblasť podpisu vyplnila všetok dostupný priestor v poli otázky pri zachovaní predvoleného pomeru strán 3:2. Keď sú nastavené vlastné hodnoty šírky a výšky, nastavenie zachová pomer strán týchto rozmerov."
        },
        file: {
            imageHeight: "Upraví výšku obrázka vo výsledkoch prieskumu.",
            imageWidth: "Upraví šírku obrázka vo výsledkoch prieskumu."
        },
        image: {
            contentMode: "Možnosť \"Auto\" automaticky určuje vhodný režim zobrazenia - obrázok, video alebo YouTube - na základe poskytnutej zdrojovej adresy URL."
        },
        imagepicker: {
            imageHeight: "Prepíše hodnoty minimálnej a maximálnej výšky.",
            imageWidth: "Prepíše hodnoty minimálnej a maximálnej šírky.",
            choices: "\"Hodnota\" slúži ako ID položky používané v podmienených pravidlách; \"Text\" sa zobrazuje respondentom.",
            contentMode: "Vyberte si medzi \"Obrázok\" a \"Video\" a nastavte režim obsahu výberu médií. Ak je vybratá možnosť \"Obrázok\", uistite sa, že všetky poskytnuté možnosti sú obrazové súbory v nasledujúcich formátoch: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Podobne, ak je vybratá možnosť \"Video\", uistite sa, že všetky možnosti sú priamymi odkazmi na video súbory v nasledujúcich formátoch: MP4, MOV, WMV, FLV, AVI, MKV. Upozorňujeme, že možnosti videí nie sú podporované odkazmi na YouTube."
        },
        text: {
            size: "Toto nastavenie zmení iba veľkosť vstupného poľa a neovplyvní šírku poľa otázky. Ak chcete obmedziť akceptovanú vstupnú dĺžku, prejdite na <b>Overenie → Maximálny počet znakov</b>."
        },
        comment: {
            rows: "Nastaví počet zobrazených riadkov vo vstupnom poli. Ak vstup zaberá viac riadkov, zobrazí sa posúvač."
        },
        // survey templates
        survey: {
            mode: "Vyberte si medzi: \"Upraviteľné\" - umožňuje respondentom vyplniť váš prieskum; \"Iba na čítanie\" - zakáže úpravu formulárov."
        },
        matrixdropdowncolumn: {
            name: "ID stĺpca, ktoré respondenti nevidia.",
            isUnique: "Ak je pre stĺpec povolené, respondent je povinný poskytnúť jedinečnú odpoveď na každú otázku v tomto stĺpci.",
            rows: "Nastaví počet zobrazených riadkov vo vstupnom poli. Ak vstup zaberá viac riadkov, zobrazí sa posúvač.",
            visibleIf: "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré určuje viditeľnosť stĺpca.",
            enableIf: "Pomocou ikony čarovnej paličky nastavte podmienené pravidlo, ktoré vypne režim iba na čítanie pre stĺpec.",
            requiredIf: "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré zabráni odoslaniu prieskumu, pokiaľ aspoň jedna vnorená otázka nemá odpoveď.",
            showInMultipleColumns: "Ak je táto voľba vybratá, vytvorí samostatný stĺpec pre každú možnosť výberu."
        },
        widthMode: "Vyberte si z: \"Statický\" - nastavuje pevnú šírku; \"Responzívny\" - spôsobuje, že prieskum zaberá celú šírku obrazovky; \"Auto\" - použije ktorýkoľvek z týchto dvoch v závislosti od použitých typov otázok.",
        cookieName: "Súbory cookie zabraňujú používateľom vyplniť ten istý prieskum dvakrát.",
        logo: "Prilepte odkaz na obrázok (bez obmedzenia veľkosti) alebo kliknite na ikonu priečinka a prehľadávajte súbor z počítača (až 64 kB).",
        logoWidth: "Nastavuje šírku loga v jednotkách CSS (px, %, in, pt atď.).",
        logoHeight: "Nastavuje výšku loga v jednotkách CSS (px, %, in, pt atď.).",
        logoFit: "Vyberte si z: \"Žiadne\" - obrázok si zachováva svoju pôvodnú veľkosť; \"Obsahovať\" - veľkosť obrázka sa zmení tak, aby sa zmestil pri zachovaní pomeru strán; \"Obal\" - obrázok vyplní celé pole pri zachovaní pomeru strán; \"Vyplniť\" - obrázok je natiahnutý tak, aby vyplnil pole bez zachovania pomeru strán.",
        goNextPageAutomatic: "Vyberte, či chcete, aby prieskum automaticky postúpil na ďalšiu stranu po tom, čo respondent odpovie na všetky otázky na aktuálnej stránke.",
        allowCompleteSurveyAutomatic: "Vyberte, či chcete, aby sa prieskum dokončil automaticky po tom, čo respondent odpovie na všetky otázky.",
        showNavigationButtons: "Nastavuje viditeľnosť a umiestnenie navigačných tlačidiel na stránke.",
        showProgressBar: "Nastavuje viditeľnosť a umiestnenie indikátora priebehu. Hodnota \"Auto\" zobrazuje indikátor priebehu nad alebo pod hlavičkou prieskumu.",
        showPreviewBeforeComplete: "Povoľte stránku ukážky so všetkými alebo iba zodpovedanými otázkami.",
        questionTitleLocation: "Vzťahuje sa na všetky otázky v rámci prieskumu. Toto nastavenie je možné prepísať pravidlami zarovnania názvov na nižších úrovniach: panel, stránka alebo otázka. Nastavenie nižšej úrovne prepíše nastavenia na vyššej úrovni.",
        requiredText: "Symbol alebo postupnosť symbolov označujúcich, že sa vyžaduje odpoveď.",
        questionStartIndex: "Zadajte číslo alebo písmeno, ktorým chcete začať číslovanie.",
        questionErrorLocation: "Nastaví umiestnenie chybového hlásenia vo vzťahu k otázke s neplatným zadaním. Vyberte si medzi: \"Hore\" - v hornej časti poľa otázok sa umiestni chybový text; \"Dole\" - v dolnej časti poľa otázok je umiestnený chybový text.",
        focusFirstQuestionAutomatic: "Vyberte, či chcete prvé vstupné pole na každej strane pripraviť na zadávanie textu.",
        questionsOrder: "Zachová pôvodné poradie otázok alebo ich náhodne vyberie. Efekt tohto nastavenia je viditeľný iba na karte Ukážka.",
        maxTextLength: "Len pre otázky týkajúce sa zadávania textu.",
        maxOthersLength: "Len pre komentáre k otázkam.",
        commentAreaRows: "Nastaví počet zobrazených riadkov v textových oblastiach pre komentáre otázok. Vo vstupe zaberá viac riadkov, zobrazí sa posúvač.",
        autoGrowComment: "Vyberte, či chcete, aby komentáre otázok a otázky s dlhým textom automaticky narástli na výšku na základe zadanej dĺžky textu.",
        allowResizeComment: "Iba pre komentáre k otázkam a otázky s dlhým textom.",
        calculatedValues: "Vlastné premenné slúžia ako medziľahlé alebo pomocné premenné používané vo výpočtoch formulárov. Vstupy respondentov berú ako zdrojové hodnoty. Každá vlastná premenná má jedinečný názov a výraz, na ktorom je založená.",
        includeIntoResult: "Vyberte, či chcete, aby sa vypočítaná hodnota výrazu uložila spolu s výsledkami prieskumu.",
        triggers: "Spúšťač je udalosť alebo podmienka, ktorá je založená na výraze. Keď je výraz vyhodnotený ako \"true\", spúšťač spustí akciu. Takáto akcia môže mať voliteľne cieľovú otázku, ktorú ovplyvňuje.",
        clearInvisibleValues: "Vyberte, či chcete vymazať hodnoty pre otázky skryté podmienenou logikou a kedy to urobiť.",
        textUpdateMode: "Vyberte si z: \"Pri strate zaostrenia\" - hodnota sa aktualizuje, keď vstupné pole stratí zaostrenie; \"Počas písania\" - hodnota sa aktualizuje v reálnom čase, keď používatelia píšu.",
        columns: "Ľavá hodnota slúži ako ID stĺpca používaného v podmienených pravidlách, pravá hodnota sa zobrazuje respondentom.",
        rows: "Ľavá hodnota slúži ako ID riadka používaného v podmienených pravidlách, pravá hodnota sa zobrazuje respondentom.",
        columnMinWidth: "Akceptuje hodnoty CSS (px, %, in, pt atď.).",
        rowTitleWidth: "Akceptuje hodnoty CSS (px, %, in, pt atď.).",
        totalText: "Viditeľné len vtedy, ak aspoň jeden stĺpec obsahuje výraz Typ celkom alebo Celkom.",
        cellErrorLocation: "Nastaví umiestnenie chybového hlásenia vo vzťahu k bunke s neplatným vstupom. Možnosť Zdediť použije nastavenie z vlastnosti Zarovnanie chybového hlásenia.",
        keyDuplicationError: "Keď je povolená vlastnosť Zabrániť duplicitným odpovediam, respondentovi, ktorý sa pokúša odoslať duplicitný záznam, sa zobrazí nasledujúce chybové hlásenie.",
        totalExpression: "Umožňuje vypočítať celkové hodnoty na základe výrazu. Výraz môže obsahovať základné výpočty (\"{q1_id} + {q2_id}\"), boolovské výrazy (\"{age} > 60') a funkcie (\"iif()\", \"today()\", \"age()\", \"min()\", \"max()\", \"avg()\" atď.).",
        confirmDelete: "Spustí výzvu so žiadosťou o potvrdenie odstránenia riadka.",
        defaultValueFromLastRow: "Duplikuje odpovede z posledného riadka a priradí ich k ďalšiemu pridanému dynamickému riadku.",
        keyName: "Ak zadaný stĺpec obsahuje rovnaké hodnoty, prieskum vyhodí chybu \"Nejedinečná hodnota kľúča\".",
        description: "Zadajte podnadpis.",
        locale: "Vyberte jazyk a začnite vytvárať prieskum. Ak chcete pridať preklad, prepnite na nový jazyk a preložte pôvodný text tu alebo na karte Preklady.",
        detailPanelMode: "Nastaví umiestnenie sekcie podrobností vo vzťahu k riadku. Vyberte si z: \"Žiadne\" - nie je pridané žiadne rozšírenie; \"Pod riadkom\" - pod každým riadkom matice je umiestnené rozšírenie riadku; \"Pod riadkom zobraziť iba rozšírenie jedného riadka\" - rozšírenie sa zobrazí iba pod jedným riadkom, zvyšné rozšírenia riadkov sa zbalia.",
        imageFit: "Vyberte si z: \"Žiadne\" - obrázok si zachováva svoju pôvodnú veľkosť; \"Obsahovať\" - veľkosť obrázka sa zmení tak, aby sa zmestil pri zachovaní pomeru strán; \"Obal\" - obrázok vyplní celé pole pri zachovaní pomeru strán; \"Vyplniť\" - obrázok je natiahnutý tak, aby vyplnil pole bez zachovania pomeru strán.",
        autoGrow: "Postupne zvyšuje výšku vstupného poľa pri zadávaní údajov. Prepíše nastavenie Výška vstupného poľa (v riadkoch).",
        allowResize: "Rukoväť na zmenu veľkosti (alebo uchopenie) sa zobrazí v rohu a potiahnutím môžete zmeniť veľkosť vstupného poľa.",
        maxTimeToFinish: "Časový interval v sekundách, po ktorom prieskum automaticky prejde na stránku s poďakovaním.",
        maxTimeToFinishPage: "Časový interval v sekundách, po ktorom prieskum automaticky prejde na ďalšiu stránku.",
        page: {
            maxTimeToFinish: "Časový interval v sekundách, po ktorom prieskum automaticky prejde na ďalšiu stránku.",
            visibleIf: "Pomocou ikony čarovnej paličky nastavte podmienené pravidlo, ktoré určuje viditeľnosť stránky.",
            enableIf: "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré vypne režim iba na čítanie pre stránku.",
            requiredIf: "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré zabráni odoslaniu prieskumu, pokiaľ aspoň jedna vnorená otázka nemá odpoveď.",
            questionTitleLocation: "Vzťahuje sa na všetky otázky na tejto stránke. Ak chcete toto nastavenie prepísať, definujte pravidlá zarovnania názvu pre jednotlivé otázky alebo panely. Možnosť \"Zdediť\" použije nastavenie na úrovni prieskumu (\"Predvolene hore\").",
            questionTitleWidth: "Nastavuje konzistentnú šírku názvov otázok, keď sú zarovnané naľavo od polí otázok. Akceptuje hodnoty CSS (px, %, in, pt atď.).",
            questionErrorLocation: "Nastaví umiestnenie chybového hlásenia vo vzťahu k otázke s neplatným zadaním. Vyberte si medzi: \"Hore\" - v hornej časti poľa otázok sa umiestni chybový text; \"Dole\" - v dolnej časti poľa otázok je umiestnený chybový text. Možnosť \"Zdediť\" použije nastavenie na úrovni prieskumu (\"Predvolene hore\").",
            questionsOrder: "Zachová pôvodné poradie otázok alebo ich náhodne vyberie. Možnosť \"Zdediť\" použije nastavenie na úrovni prieskumu (\"Originál\" v predvolenom nastavení). Efekt tohto nastavenia je viditeľný iba na karte Ukážka.",
            navigationButtonsVisibility: "Nastavuje viditeľnosť navigačných tlačidiel na stránke. Možnosť Zdediť použije nastavenie na úrovni prieskumu, ktoré je predvolene nastavené na \"Viditeľné\"."
        },
        showTimerPanel: "Nastavuje viditeľnosť a umiestnenie časovača na stránke.",
        panelsState: "Vyberte si z: \"Zamknuté\" - používatelia nemôžu rozširovať ani zbaliť panely; \"Zbaliť všetko\" - všetky panely začínajú v zbalenom stave; \"Rozbaliť všetko\" - všetky panely začínajú v rozšírenom stave; \"Prvý rozšírený\" - pôvodne sa rozšíril iba prvý panel.",
        imageLinkName: "Zadajte zdieľaný názov vlastnosti do poľa objektov obsahujúceho URL adresy obrázkov alebo videosúborov, ktoré chcete zobraziť v zozname výberu.",
        choices: "Ľavá hodnota slúži ako ID položky používané v podmienených pravidlách, pravá hodnota sa zobrazuje respondentom.",
        title: "Zadajte používateľsky prívetivý názov, ktorý chcete zobraziť.",
        waitForUpload: "Zabezpečuje, že používatelia prieskum nevyplnia, kým sa nenahrajú súbory.",
        minWidth: "Akceptuje hodnoty CSS (px, %, in, pt atď.).",
        maxWidth: "Akceptuje hodnoty CSS (px, %, in, pt atď.).",
        width: "Akceptuje hodnoty CSS (px, %, in, pt atď.).",
        valueName: "Ak túto vlastnosť nenastavíte, odpoveď sa uloží do poľa určeného vlastnosťou Názov.",
        useDisplayValuesInDynamicTexts: "V prípade otázok s jedným a viacerými výbermi má každá možnosť výberu identifikátor a zobrazenú hodnotu. Ak je táto voľba vybratá, toto nastavenie zobrazuje zobrazenú hodnotu namiesto hodnoty ID v otázkach HTML a dynamických názvoch a popisoch prvkov prieskumu.",
        clearIfInvisible: "Vyberte, či chcete vymazať hodnoty otázok skryté podmienenou logikou a kedy to chcete urobiť. Možnosť \"Dediť\" použije nastavenie na úrovni prieskumu (\"Po dokončení prieskumu predvolene\").",
        choicesFromQuestionMode: "Vyberte si z: \"Všetko\" - skopíruje všetky možnosti výberu z vybranej otázky; \"Vybraté\" - dynamicky kopíruje iba vybrané možnosti výberu; \"Nevybraté\" - dynamicky kopíruje iba nevybraté možnosti výberu. Možnosti \"Žiadne\" a \"Iné\" sa predvolene kopírujú, ak sú povolené v otázke zdroja.",
        showOtherItem: "Ak je táto voľba vybratá, používatelia môžu zahrnúť ďalšie vstupy do samostatného poľa komentára.",
        separateSpecialChoices: "Zobrazí každú možnosť špeciálnej voľby (\"Žiadne\", \"Iné\", \"Vybrať všetko\") na novom riadku, a to aj pri použití rozloženia s viacerými stĺpcami.",
        path: "Zadajte umiestnenie v množine údajov služby, kde sa nachádza cieľové pole objektov. Ak URL adresa už odkazuje na pole, nechajte prázdne.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Zadajte jednotný názov vlastnosti do poľa objektov obsahujúceho hodnoty, ktoré chcete zobraziť v zozname možností.",
        allowEmptyResponse: "Túto voľbu vyberte, ak chcete, aby služba vrátila prázdnu odpoveď alebo pole.",
        choicesVisibleIf: "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré určuje viditeľnosť všetkých možností výberu.",
        rateValues: "Ľavá hodnota slúži ako ID položky používané v podmienených pravidlách, pravá hodnota sa zobrazuje respondentom.",
        rating: {
            displayMode: "\"Auto\" si vyberá medzi režimami \"Tlačidlá\" a \"Rozbaľovacia ponuka\" na základe dostupnej šírky. Ak šírka nie je dostatočná na zobrazenie tlačidiel, v otázke sa zobrazí rozbaľovací zoznam."
        },
        valuePropertyName: "Umožňuje prepojiť otázky, ktoré vytvárajú výsledky v rôznych formátoch. Keď sú takéto otázky prepojené pomocou identifikátora spojenia, v tomto zdieľanom vlastníctve sa uložia vybraté hodnoty otázok.",
        searchEnabled: "Vyberte, či chcete aktualizovať obsah rozbaľovacej ponuky tak, aby zodpovedal vyhľadávaciemu dotazu, ktorý používateľ zadáva do vstupného poľa.",
        valueTrue: "Hodnota, ktorú treba uložiť do výsledkov prieskumu, keď respondenti poskytnú kladnú odpoveď.",
        valueFalse: "Hodnota, ktorú je potrebné uložiť do výsledkov prieskumu, keď respondenti poskytnú zápornú odpoveď.",
        showPreview: "Túto možnosť sa neodporúča zakázať, pretože prepíše obrázok ukážky a sťažuje používateľovi pochopiť, či boli súbory nahrané.",
        needConfirmRemoveFile: "Spustí výzvu na potvrdenie odstránenia súboru.",
        selectToRankEnabled: "Povoľte zoradiť iba vybrané možnosti. Používatelia presunú vybrané položky zo zoznamu možností a zoradia ich v oblasti poradia.",
        dataList: "Zadajte zoznam možností, ktoré budú respondentovi navrhnuté počas vstupu.",
        itemSize: "Toto nastavenie zmení iba veľkosť vstupných polí a neovplyvní šírku poľa otázok.",
        itemTitleWidth: "Nastavuje konzistentnú šírku pre všetky štítky položiek v pixeloch",
        altText: "Slúži ako náhrada, keď obrázok nie je možné zobraziť na zariadení používateľa a na účely prístupnosti.",
        rateColorMode: "Definuje farbu vybraných emodži, keď je typ ikony hodnotenia nastavený na \"Smajlíky\". Vyberte si medzi: \"Predvolené\" - vybrané emodži sa zobrazia v predvolenej farbe prieskumu; \"Mierka\" - vybrané emodži zdedí farbu z hodnotiacej stupnice.",
        expression: {
            name: "ID výrazu, ktoré respondenti nevidia.",
            description: "Zadajte podnadpis výrazu.",
            expression: "Výraz môže obsahovať základné výpočty (\"{q1_id} + {q2_id}\"), podmienky (\"{vek} > 60\") a funkcie (\"iif()\", \"today()\", \"age()\", \"min()\", \"max()\", \"avg()\" atď.)."
        },
        storeOthersAsComment: "Túto voľbu vyberte, ak chcete uložiť hodnotu možnosti \"Iné\" ako samostatnú vlastnosť vo výsledkoch prieskumu.",
        format: "Použite {0} ako zástupný symbol skutočnej hodnoty.",
        acceptedTypes: "Ďalšie informácie nájdete v popise atribútu [accept](https://www.w3schools.com/tags/att_input_accept.asp).",
        columnColCount: "Vzťahuje sa len na typy buniek rádioskupiny a začiarkavacích políčok.",
        autocomplete: "Ďalšie informácie nájdete v popise atribútu [automatické dopĺňanie](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete).",
        filePlaceholder: "Použije, keď \"Typ zdroja\" je \"Lokálne súbory\" alebo keď fotoaparát nie je k dispozícii",
        photoPlaceholder: "Používa sa, keď \"Typ zdroja\" je \"Fotoaparát\".",
        fileOrPhotoPlaceholder: "Použije, keď \"Typ zdroja\" je \"Lokálne súbory alebo fotoaparát\".",
        masksettings: {
            saveMaskedValue: "Vyberte, či chcete do výsledkov prieskumu uložiť hodnotu otázky s použitou maskou."
        },
        patternmask: {
            pattern: "Vzor môže obsahovať reťazcové literály a nasledujúce zástupné symboly: \"9\" - pre číslicu; \"a\" - pre veľké alebo malé písmeno; '#' - pre číslicu alebo veľké alebo malé písmeno. Použite opačné lomítko \"\\\" na únik z postavy."
        },
        datetimemask: {
            pattern: "Vzor môže obsahovať oddeľovacie znaky a nasledujúce zástupné symboly:<br>\"m\" - číslo mesiaca.<br>′mm′ — číslo mesiaca s nulou na začiatku pre jednociferné hodnoty. <br>\"d\" - Deň v mesiaci. <br>\"dd\" - Deň v mesiaci s počiatočnou nulou pre jednociferné hodnoty. <br>\"yy\" - posledné dve číslice roka. <br>\"rrrr\" - štvormiestny rok. <br>\"H\" - hodiny v 24-hodinovom formáte. <br>\"HH\" - hodiny v 24-hodinovom formáte s úvodnou nulou pre jednociferné hodnoty. <br>\"h\" - hodiny v 12-hodinovom formáte. <br>\"hh\" - hodiny v 12-hodinovom formáte s úvodnou nulou pre jednociferné hodnoty. <br>\"MM\" - minúty. <br>\"ss\" - sekundy. <br>\"TT\" - 12-hodinový časový úsek veľkými písmenami (AM/PM). <br>\"TT\" - 12-hodinová perióda malých písmen (dopoludnia/popoludní)."
        },
        numericmask: {
            decimalSeparator: "Symbol používaný na oddelenie zlomkovej časti od celočíselnej časti zobrazeného čísla.",
            thousandsSeparator: "Symbol používaný na oddelenie číslic veľkého čísla do skupín po troch.",
            precision: "Obmedzuje, koľko číslic sa má zachovať za desatinnou čiarkou pre zobrazené číslo."
        },
        currencymask: {
            prefix: "Jeden alebo niekoľko symbolov, ktoré sa majú zobraziť pred hodnotou.",
            suffix: "Jeden alebo viac symbolov, ktoré sa zobrazia za hodnotou."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "titul",
            title: "Nechajte prázdne, ak sa zhoduje s menom"
        },
        multiSelect: "Výber viacerých možností",
        showLabel: "Zobraziť štítok",
        swapOrder: "Zámena poradia Áno a Nie",
        value: "Hodnota",
        tabAlign: "Zarovnanie tabulátora",
        sourceType: "Typ zdroja",
        fitToContainer: "Vhodné na kontajner",
        setValueExpression: "Nastavenie výrazu hodnoty",
        description: "opis",
        logoFit: "umiestnenie loga",
        pages: "stránky",
        questions: "Otázky",
        triggers: "aktivátory",
        calculatedValues: "vypočítané hodnoty",
        surveyId: "ID prieskumu",
        surveyPostId: "ID príspevku prieskumu",
        surveyShowDataSaving: "Prieskum ukazuje ukladanie údajov",
        questionDescriptionLocation: "otázka – poloha opisu",
        progressBarType: "typ indikátora priebehu",
        showTOC: "Zobraziť obsah",
        tocLocation: "Umiestnenie TOC",
        questionTitlePattern: "otázka – vzor titulu",
        widthMode: "šírka režimu",
        showBrandInfo: "Zobraziť informácie o značke",
        useDisplayValuesInDynamicTexts: "Použiť zobrazené hodnoty v titule",
        visibleIf: "Viditeľné ak",
        defaultValueExpression: "predvolený výraz hodnoty",
        requiredIf: "Povinné ak",
        resetValueIf: "Obnoviť hodnotu, ak",
        setValueIf: "Nastaviť hodnotu, ak",
        validators: "overovatelia",
        bindings: "väzby",
        renderAs: "Vykresliť ako",
        attachOriginalItems: "Priloženie originálnych položiek",
        choices: "možnosti",
        choicesByUrl: "Možnosti podľa URL",
        currency: "mena",
        cellHint: "Pomôcka buniek",
        totalMaximumFractionDigits: "Celkové maximálne číslice zlomkov",
        totalMinimumFractionDigits: "Celkové minimálne zlomkové číslice",
        columns: "stĺpce",
        detailElements: "Detailné prvky",
        allowAdaptiveActions: "Povolenie adaptívnych akcií",
        defaultRowValue: "Predvolená hodnota riadka",
        detailPanelShowOnAdding: "panel s podrobnosťami – zobrazenie pri pridávaní",
        choicesLazyLoadEnabled: "Možnosti lenivého zaťaženia povolené",
        choicesLazyLoadPageSize: "Možnosti lenivé načítať veľkosť stránky",
        inputFieldComponent: "Súčasť vstupného poľa",
        itemComponent: "Súčasť položky",
        min: "min.",
        max: "max.",
        minValueExpression: "výraz minimálnej hodnoty",
        maxValueExpression: "výraz maximálnej hodnoty",
        step: "krok",
        dataList: "zoznam údajov",
        itemSize: "Veľkosť položky",
        itemTitleWidth: "Šírka označenia položky (v px)",
        elements: "Prvky",
        content: "Obsah",
        navigationButtonsVisibility: "Viditeľnosť navigačných tlačidiel",
        navigationTitle: "Navigácia –​ titul",
        navigationDescription: "Navigácia – opis",
        longTap: "Dlhé klepnutie",
        autoGrow: "automatické rozšírenie",
        allowResize: "Povoliť zmenu veľkosti",
        acceptCarriageReturn: "Akceptovať vrátenie prepravy",
        displayMode: "Režim zobrazenia",
        rateType: "Typ sadzby",
        label: "štítok",
        contentMode: "režim obsahu",
        imageFit: "umiestnenie obrázka",
        altText: "Alternatívny text",
        height: "výška",
        penColor: "farba pera",
        backgroundColor: "farba pozadia",
        templateElements: "Prvky šablóny",
        operator: "Operátor",
        isVariable: "Je variabilný",
        runExpression: "Spustiť výraz",
        showCaption: "zobraziť titulok",
        iconName: "názov ikony",
        iconSize: "veľkosť ikony",
        precision: "Presnosť",
        matrixDragHandleArea: "Oblasť ťahacej rukoväte matice",
        backgroundImage: "Obrázok na pozadí",
        backgroundImageFit: "Prispôsobenie obrázku na pozadí",
        backgroundImageAttachment: "Príloha obrázka na pozadí",
        backgroundOpacity: "Nepriehľadnosť pozadia",
        selectToRankEnabled: "Vyberte na povolené hodnotenie",
        selectToRankAreasLayout: "Rozloženie Vyberte na hodnotenie oblastí",
        selectToRankEmptyRankedAreaText: "Text, ktorý zobrazuje, či sú vybraté všetky možnosti",
        selectToRankEmptyUnrankedAreaText: "Zástupný text pre oblasť hodnotenia",
        allowCameraAccess: "Povolenie prístupu ku kamere",
        scaleColorMode: "Farebný režim mierky",
        rateColorMode: "Režim hodnotenia farieb",
        copyDisplayValue: "Kopírovať zobrazenú hodnotu",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Rozšírený režim",
        pageTitle: "Písmo názvu stránky",
        questionTitle: "Písmo názvu otázky",
        editorPanel: "Vstupný prvok",
        lines: "Riadky",
        primaryDefaultColor: "Predvolený",
        primaryDarkColor: "Hover",
        primaryLightColor: "Vybraný",
        backgroundDimColor: "Farba pozadia",
        cornerRadius: "Polomer rohov",
        backcolor: "Predvolené pozadie",
        hovercolor: "Ukázanie na pozadie",
        borderDecoration: "Dekorácia okrajov",
        fontColor: "Farba písma",
        backgroundColor: "Farba pozadia",
        primaryForecolor: "Predvolená farba",
        primaryForecolorLight: "Zakázaná farba",
        font: "Písmo",
        borderDefault: "Tmavšie",
        borderLight: "Zapaľovač",
        fontFamily: "Skupina písiem",
        fontWeightRegular: "Pravidelný",
        fontWeightHeavy: "Ťažký",
        fontWeightSemiBold: "Polotučné",
        fontWeightBold: "Smelý",
        color: "Farba",
        placeholderColor: "Farba zástupného symbolu",
        size: "Veľkosť",
        opacity: "Neprehľadnosť",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Pridanie efektu tieňa",
        boxShadowBlur: "Rozmazať",
        boxShadowSpread: "Nátierka",
        boxShadowDrop: "Kvapka",
        boxShadowInner: "Vnútorný",
        names: {
            default: "Predvolený",
            sharp: "Ostrý",
            borderless: "Bez okrajov",
            flat: "Plochý",
            plain: "Obyčajný",
            doubleborder: "Dvojité ohraničenie",
            layered: "Vrstvené",
            solid: "Pevný",
            threedimensional: ".3D",
            contrast: "Kontrast"
        },
        colors: {
            teal: "Šedozelená",
            blue: "Modrý",
            purple: "Purpurový",
            orchid: "Orchidea",
            tulip: "Tulipán",
            brown: "Hnedý",
            green: "Zelený"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["sk"] = skStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// qt.tagbox: "Multi-Select Dropdown" => "Rozbaľovacia ponuka viacerých výberov"
// qt.buttongroup: "Button Group" => "Skupina tlačidiel"
// ed.surveySettings: "Survey Settings" => "Nastavenia prieskumu"
// ed.surveySettingsTooltip: "Open survey settings" => "Otvorenie nastavení prieskumu"
// ed.prevSelected: "Select previous" => "Výber predchádzajúceho"
// ed.nextSelected: "Select next" => "Vyberte položku Ďalej"
// ed.surveyTypeName: "Survey" => "Prieskum"
// ed.pageTypeName: "Page" => "Strana"
// ed.panelTypeName: "Panel" => "Bledý."
// ed.questionTypeName: "Question" => "Otázka"
// ed.columnTypeName: "Column" => "Stĺpec"
// ed.themeSurvey: "Themes" => "Témy"
// ed.defaultV2Theme: "Default" => "Predvolený"
// ed.modernTheme: "Modern" => "Moderný"
// ed.defaultTheme: "Default (legacy)" => "Predvolené nastavenie (staršia verzia)"
// ed.jsonHideErrors: "Hide errors" => "Skryť chyby"
// ed.jsonShowErrors: "Show errors" => "Zobraziť chyby"
// ed.showMoreChoices: "Show more" => "Zobraziť viac"
// ed.showLessChoices: "Show less" => "Zobraziť menej"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "Zadajte reťazec pre vyhľadávanie..."
// ed.toolboxChoiceCategory: "Choice Questions" => "Voľba Otázky"
// ed.toolboxTextCategory: "Text Input Questions" => "Otázky na zadávanie textu"
// ed.toolboxContainersCategory: "Containers" => "Kontajnery"
// ed.toolboxMatrixCategory: "Matrix Questions" => "Maticové otázky"
// ed.toolboxMiscCategory: "Misc" => "Misc"
// ed.translationPropertyGridTitle: "Language Settings" => "Nastavenia jazyka"
// ed.themePropertyGridTitle: "Theme Settings" => "Nastavenia motívu"
// ed.translationLanguages: "Languages" => "Jazyky"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "Iba použité reťazce"
// ed.translationPlaceHolder: "Translation..." => "Preklad..."
// ed.themeExportButton: "Export" => "Vývoz"
// ed.themeImportButton: "Import" => "Import"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Voľby sa kopírujú z"
// ed.htmlPlaceHolder: "HTML content will be here." => "Obsah HTML bude tu."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "Tu položte otázku z panela nástrojov."
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "Prieskum je prázdny. Potiahnite prvok z panela s nástrojmi alebo kliknite na tlačidlo nižšie."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Presuňte obrázok sem alebo kliknite na tlačidlo nižšie a vyberte obrázok, ktorý chcete nahrať"
// ed.imageChooseImage: "Choose Image" => "Vyberte obrázok"
// ed.addNewTypeQuestion: "Add {0}" => "Pridať {0}"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[LOGO]"
// ed.auto: "auto" => "auto"
// ed.choices_Item: "Item " => "Položka "
// lg.addNewItem: "Add New Rule" => "Pridať nové pravidlo"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "Vytvorte pravidlo na prispôsobenie toku prieskumu."
// lg.page_enableName: "Enable (disable) page" => "Povoliť (zakázať) stránku"
// lg.column_visibilityName: "Show (hide) column" => "Zobraziť (skryť) stĺpec"
// lg.column_enableName: "Enable (disable) column" => "Povoliť (zakázať) stĺpec"
// lg.column_requireName: "Make column required" => "Nastavenie povinného stĺpca"
// lg.itemEmptyExpressionText: "New rule" => "Nové pravidlo"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "Zviditeľnenie stĺpcových {0} otázok {1}"
// lg.column_enableText: "make column {0} of question {1} enable" => "Nastavenie {0}  otázky {1} povolenie"
// lg.column_requireText: "make column {0} of question {1} required" => "Urobiť stĺpec {0} otázky {1} povinné"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "jasná hodnota otázky: {0}"
// lg.showAllQuestions: "All Questions" => "Všetky otázky"
// lg.showAllActionTypes: "All Action Types" => "Všetky typy akcií"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Logické pravidlá sú neúplné"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Nedokončili ste niektoré logické pravidlá. Ak kartu teraz opustíte, zmeny sa stratia. Stále chcete opustiť kartu bez dokončenia zmien?"
// lg.uncompletedRule_apply: "Yes" => "Áno"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Nie, chcem dokončiť pravidlá"
// pe.clear: "Clear" => "Jasný"
// pe.set: "Set" => "Množina"
// pe.change: "Change" => "Zmeniť"
// pe.close: "Close" => "Zavrieť"
// pe.removeItem: "Click to remove the item..." => "Kliknutím položku odstránite..."
// pe.dragItem: "Drag the item" => "Potiahnite položku"
// pe.doneEditing: "Done" => "Robené"
// pe.emptyValue: "Value is empty" => "Hodnota je prázdna"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "Hodnota \"{0}\" nie je jedinečná"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "Obmedzte počet položiek od {0} do {1}"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "Údaje môžete nastaviť v nasledujúcom formáte:\nhodnota1|text\nhodnota2"
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "Pozrite si ukážku odpovedí pred odoslaním prieskumu"
// pe.overridingPropertyPrefix: "Set by " => "Nastaviť "
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Nepoužívajte vyhradené slová: \"položka\", \"výber\", \"panel\", \"riadok\"."
// pe.listIsEmpty@choices: "No choices have been added yet" => "Zatiaľ neboli pridané žiadne možnosti"
// pe.addNew@choices: "Add a choice" => "Pridať výber"
// choicesbyurl.valueName: "Get values from the following JSON field" => "Získanie hodnôt z nasledujúceho poľa JSON"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "Získanie webových adries obrázkov z nasledujúceho poľa JSON"
// pe.and: "and" => "a"
// pe.or: "or" => "alebo"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Vyberte otázku a začnite konfigurovať podmienky."
// pe.if: "If" => "Ak"
// pe.then: "then" => "potom"
// pe.setToName: "Target question" => "Cieľová otázka"
// pe.fromName: "Question to copy answer from" => "Otázka na kopírovanie odpovede"
// pe.gotoName: "Question to skip to" => "Otázka na preskočenie"
// pe.ruleIsNotSet: "Rule is incorrect" => "Pravidlo je nesprávne"
// pe.includeIntoResult: "Include into survey results" => "Zahrňte do výsledkov prieskumu"
// pe.portraitOrientation: "Switch to portrait orientation" => "Prepnutie na orientáciu na výšku"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Výška snímky (v hodnotách akceptovaných šablónou CSS)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Šírka obrázka (v akceptovaných hodnotách CSS)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "Časový limit na dokončenie stránky (v sekundách)"
// question.page: "Parent page" => "Nadradená stránka"
// pe.noEntriesText: "Empty entries text" => "Text prázdnych položiek"
// pe.setValue: "Answer" => "Odpoveď"
// pe.dataFormat: "Image format" => "Formát obrázka"
// pe.allowAddRows: "Allow adding rows" => "Povoliť pridávanie riadkov"
// pe.allowRemoveRows: "Allow removing rows" => "Povoliť odstránenie riadkov"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "Povoliť presúvanie riadkov"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "Neuplatňuje sa, ak zadáte presnú šírku alebo výšku obrázka."
// pe.minImageWidth: "Minimum image width" => "Minimálna šírka obrázka"
// pe.maxImageWidth: "Maximum image width" => "Maximálna šírka obrázka"
// pe.minImageHeight: "Minimum image height" => "Minimálna výška obrázka"
// pe.maxImageHeight: "Maximum image height" => "Maximálna výška obrázka"
// surveyvalidator.text: "Error message" => "Chybové hlásenie"
// surveyvalidator.expression: "Validation expression" => "Overovací výraz"
// pe.logo: "Logo (URL or base64-encoded string)" => "Logo (reťazec s kódovaním URL alebo base64)"
// pe.questionsOnPageMode: "Survey structure" => "Štruktúra prieskumu"
// pe.maxTextLength: "Maximum answer length (in characters)" => "Maximálna dĺžka odpovede (v znakoch)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "Maximálna dĺžka komentára (v znakoch)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "V prípade potreby automaticky rozbaľte oblasť komentárov"
// pe.allowResizeComment: "Allow users to resize text areas" => "Povolenie používateľom meniť veľkosť textových oblastí"
// pe.textUpdateMode: "Update text question value" => "Aktualizácia hodnoty textovej otázky"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "Zameranie na prvú neplatnú odpoveď"
// pe.checkErrorsMode: "Run validation" => "Spustenie overenia pravosti"
// pe.navigateToUrl: "Navigate to URL" => "Prejsť na adresu URL"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "Dynamická webová adresa"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "Značky na zobrazenie, či používateľ už vyplnil tento prieskum"
// pe.completedHtml: "Survey Complete page markup" => "Značenie stránky dokončenia prieskumu"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "Dynamický prieskum Kompletné značenie stránky"
// pe.loadingHtml: "Markup to show while survey model is loading" => "Značenie, ktoré sa zobrazí počas načítavania modelu prieskumu"
// pe.commentText: "Comment area text" => "Text oblasti komentárov"
// pe.autocomplete: "Autocomplete type" => "Typ automatického dokončovania"
// pe.labelTrue: "\"True\" label" => "Označenie \"Pravda\""
// pe.labelFalse: "\"False\" label" => "Označenie \"False\""
// pe.displayStyle: "Value display style" => "Štýl zobrazenia hodnoty"
// pe.format: "Formatted string" => "Formátovaný reťazec"
// pe.maximumFractionDigits: "Maximum fractional digits" => "Maximálny zlomkový počet číslic"
// pe.minimumFractionDigits: "Minimum fractional digits" => "Minimálne zlomkové číslice"
// pe.useGrouping: "Display grouping separators" => "Oddeľovače zoskupení zobrazení"
// pe.allowMultiple: "Allow multiple files" => "Povolenie viacerých súborov"
// pe.allowImagesPreview: "Preview images" => "Ukážka obrázkov"
// pe.acceptedTypes: "Accepted file types" => "Akceptované typy súborov"
// pe.waitForUpload: "Wait for the upload to complete" => "Počkajte na dokončenie nahrávania"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "Potvrďte odstránenie súboru"
// pe.detailPanelMode: "Detail panel location" => "Umiestnenie panela s podrobnosťami"
// pe.minRowCount: "Minimum row count" => "Minimálny počet riadkov"
// pe.maxRowCount: "Maximum row count" => "Maximálny počet riadkov"
// pe.confirmDelete: "Confirm row deletion" => "Potvrdenie odstránenia riadka"
// pe.confirmDeleteText: "Confirmation message" => "Potvrdzovacia správa"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "Potvrdenie odstránenia panela"
// pe.panelCount: "Initial panel count" => "Počiatočný počet panelov"
// pe.minPanelCount: "Minimum panel count" => "Minimálny počet panelov"
// pe.maxPanelCount: "Maximum panel count" => "Maximálny počet panelov"
// pe.panelsState: "Inner panel expand state" => "Stav rozbalenia vnútorného panela"
// pe.templateDescription: "Description template" => "Šablóna popisu"
// pe.templateTitle: "Title template" => "Šablóna názvu"
// pe.panelPrevText: "Previous Panel button tooltip" => "Popis tlačidla Predchádzajúci panel"
// pe.panelNextText: "Next Panel button tooltip" => "Popis tlačidla Nasledujúci panel"
// pe.showRangeInProgress: "Show progress bar" => "Zobraziť indikátor priebehu"
// pe.templateTitleLocation: "Question title location" => "Otázka, názov, umiestnenie:"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "Odstrániť umiestnenie tlačidla panela"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "Skryť otázku, ak nie sú žiadne riadky"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Skryť stĺpce, ak nie sú k dispozícii žiadne riadky"
// pe.rateValues: "Custom rate values" => "Vlastné hodnoty sadzieb"
// pe.rateCount: "Rate count" => "Počet sadzieb"
// pe.autoGenerate: "How to specify rate values?" => "Ako určiť hodnoty sadzieb?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "Skryť otázku, ak neobsahuje žiadne možnosti"
// pe.hideNumber: "Hide question number" => "Skryť číslo otázky"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Minimálna šírka (v hodnotách akceptovaných CSS)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Maximálna šírka (v hodnotách akceptovaných CSS)"
// pe.width: "Width (in CSS-accepted values)" => "Šírka (v akceptovaných hodnotách CSS)"
// pe.showHeader: "Show column headers" => "Zobrazenie hlavičiek stĺpcov"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Zobraziť vodorovný posúvač"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Minimálna šírka stĺpca (v hodnotách akceptovaných CSS)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Šírka hlavičky riadka (v hodnotách akceptovaných CSS)"
// pe.valueTrue: "\"True\" value" => "Hodnota \"True\""
// pe.valueFalse: "\"False\" value" => "Hodnota \"False\""
// pe.minErrorText: "\"Value is below minimum\" error message" => "Chybové hlásenie \"Hodnota je nižšia ako minimum\""
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "Chybové hlásenie \"Hodnota prekračuje maximum\""
// pe.otherErrorText: "\"Empty comment\" error message" => "Chybové hlásenie \"Prázdny komentár\""
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "Chybové hlásenie \"Nejedinečná kľúčová hodnota\""
// pe.minSelectedChoices: "Minimum selected choices" => "Minimálny počet vybraných možností"
// pe.maxSelectedChoices: "Maximum selected choices" => "Maximálny počet vybraných možností"
// pe.showClearButton: "Show the Clear button" => "Zobrazenie tlačidla Vymazať"
// pe.showNumber: "Show panel number" => "Zobraziť číslo panela"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "Šírka loga (v akceptovaných hodnotách CSS)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "Výška loga (v hodnotách akceptovaných CSS)"
// pe.readOnly: "Read-only" => "Iba na čítanie"
// pe.enableIf: "Editable if" => "Upraviteľné, ak"
// pe.emptyRowsText: "\"No rows\" message" => "Správa \"Žiadne riadky\""
// pe.size: "Input field size (in characters)" => "Veľkosť vstupného poľa (v znakoch)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "Samostatné špeciálne možnosti (Žiadne, Iné, Vybrať všetko)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Skopírujte voľby z nasledujúcej otázky"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Aké možnosti kopírovať?"
// pe.showCommentArea: "Show the comment area" => "Zobrazenie oblasti komentárov"
// pe.commentPlaceholder: "Comment area placeholder" => "Zástupný symbol oblasti komentárov"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Popisy rýchlosti zobrazenia ako extrémnych hodnôt"
// pe.rowsOrder: "Row order" => "Poradie riadkov"
// pe.columnsLayout: "Column layout" => "Rozloženie stĺpcov"
// pe.columnColCount: "Nested column count" => "Vnorený počet stĺpcov"
// pe.state: "Panel expand state" => "Stav rozbalenia panela"
// pe.correctAnswer: "Correct Answer" => "Správna odpoveď"
// pe.defaultPanelValue: "Default Values" => "Predvolené hodnoty"
// pe.cells: "Cell Texts" => "Texty buniek"
// pe.keyName: "Key column" => "Stĺpec kľúča"
// itemvalue.text: "Alt text" => "Alternatívny text"
// tabs.expression: "Expression" => "Výraz"
// pe.choicesVisibleIf: "Choices are visible if" => "Voľby sú viditeľné, ak"
// pe.choicesEnableIf: "Choices are selectable if" => "Možnosti výberu sú voliteľné, ak"
// pe.columnsEnableIf: "Columns are visible if" => "Stĺpce sú viditeľné, ak"
// pe.rowsEnableIf: "Rows are visible if" => "Riadky sú viditeľné, ak"
// pe.indent: "Add indents" => "Pridanie zarážok"
// panel.indent: "Add outer indents" => "Pridanie vonkajších zarážok"
// pe.innerIndent: "Add inner indents" => "Pridanie vnútorných zarážok"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "Prevzatie predvolených hodnôt z posledného riadka"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "Prevzatie predvolených hodnôt z posledného panela"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "Sem zadajte výraz..."
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "Ak sa otázka skryje, vymažte hodnotu"
// pe.valuePropertyName: "Value property name" => "Názov vlastnosti Value"
// pe.searchEnabled: "Enable search" => "Povoliť vyhľadávanie"
// pe.hideSelectedItems: "Hide selected items" => "Skryť vybraté položky"
// pe.closeOnSelect: "Close the dropdown after selection" => "Zatvorenie rozbaľovacieho zoznamu po výbere"
// pe.signatureWidth: "Signature width" => "Šírka podpisu"
// pe.signatureHeight: "Signature height" => "Výška podpisu"
// pe.verticalAlign: "Vertical alignment" => "Vertikálne zarovnanie"
// pe.alternateRows: "Alternate rows" => "Alternatívne riadky"
// pe.columnsVisibleIf: "Columns are visible if" => "Stĺpce sú viditeľné, ak"
// pe.rowsVisibleIf: "Rows are visible if" => "Riadky sú viditeľné, ak"
// pe.otherPlaceholder: "Comment area placeholder" => "Zástupný symbol oblasti komentárov"
// pe.rateType: "Rate type" => "Typ sadzby"
// pv.true: "true" => "pravdivý"
// pv.false: "false" => "nepravdivé"
// pv.decimal: "decimal" => "desatinný"
// pv.currency: "currency" => "mena"
// pv.percent: "percent" => "percento"
// pv.onpanel: "Start on each panel" => "Začnite na každom paneli"
// pv.tab: "Tabs" => "Karty"
// pv.right: "Right" => "Doprava"
// pv.color: "color" => "farba"
// pv.date: "date" => "dátum"
// pv.datetime: "datetime" => "dátum a čas"
// pv.datetime-local: "datetime-local" => "dátum a čas miestny"
// pv.email: "email" => "E-mail"
// pv.month: "month" => "mesiac"
// pv.number: "number" => "číslo"
// pv.password: "password" => "heslo"
// pv.range: "range" => "rozsah"
// pv.tel: "tel" => "Tel"
// pv.text: "text" => "Text"
// pv.time: "time" => "Čas"
// pv.url: "url" => "URL adresa"
// pv.week: "week" => "týždeň"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "Keď sa otázka alebo jej panel/stránka skryje"
// clearInvisibleValues.none: "Never" => "Nikdy"
// inputType.color: "Color" => "Farba"
// inputType.date: "Date" => "Dátum"
// inputType.datetime-local: "Date and Time" => "Dátum a čas"
// inputType.email: "Email" => "E-mail"
// inputType.month: "Month" => "Mesiac"
// inputType.number: "Number" => "Číslo"
// inputType.password: "Password" => "Heslo"
// inputType.range: "Range" => "Rozsah"
// inputType.tel: "Phone Number" => "Telefónne číslo"
// inputType.text: "Text" => "Text"
// inputType.time: "Time" => "Čas"
// inputType.url: "URL" => "URL adresa"
// inputType.week: "Week" => "Týždeň"
// pv.onValueChanging: "Before an answer is changed" => "Pred zmenou odpovede"
// pv.onBlur: "On blur" => "Pri rozmazaní"
// pv.onTyping: "While typing" => "Počas písania"
// pv.underRow: "Under the row" => "Pod riadkom"
// pv.underRowSingle: "Under the row, only one panel is visible" => "Pod riadkom je viditeľný iba jeden panel"
// showNavigationButtons.none: "Hidden" => "Skrytý"
// showProgressBar.off: "Hidden" => "Skrytý"
// showTimerPanel.none: "Hidden" => "Skrytý"
// showTimerPanelMode.all: "Both" => "Obidva"
// detailPanelMode.none: "Hidden" => "Skrytý"
// addRowLocation.default: "Depends on matrix layout" => "Závisí od rozloženia matice"
// panelsState.default: "Users cannot expand or collapse panels" => "Používatelia nemôžu rozbaliť alebo zbaliť panely"
// panelsState.collapsed: "All panels are collapsed" => "Všetky panely sú zbalené"
// panelsState.expanded: "All panels are expanded" => "Všetky panely sú rozšírené"
// widthMode.auto: "Auto" => "Auto"
// widthMode.static: "Static" => "Statický"
// widthMode.responsive: "Responsive" => "Citlivý"
// imageFit.none: "None" => "Žiadny"
// imageFit.contain: "Contain" => "Obsahovať"
// imageFit.cover: "Cover" => "Prikryť"
// imageFit.fill: "Fill" => "Vyplniť"
// contentMode.auto: "Auto" => "Auto"
// contentMode.image: "Image" => "Obraz"
// contentMode.video: "Video" => "Video"
// contentMode.youtube: "YouTube" => "YouTube"
// displayMode.auto: "Auto" => "Auto"
// displayMode.buttons: "Buttons" => "Tlačidlá"
// displayMode.dropdown: "Dropdown" => "Rozbaľovací zoznam"
// rateColorMode.default: "Default" => "Predvolený"
// autoGenerate.true: "Generate" => "Generovať"
// autoGenerate.false: "Enter manually" => "Manuálne zadanie"
// rateType.labels: "Labels" => "Menovky"
// rateType.stars: "Stars" => "Hviezdy"
// rateType.smileys: "Smileys" => "Smajlíky"
// op.and: "and" => "a"
// op.or: "or" => "alebo"
// ts.hideInvisibleElements: "Hide invisible elements" => "Skryť neviditeľné prvky"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Súbory cookie zabraňujú používateľom vyplniť ten istý prieskum dvakrát."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Zmení veľkosť viditeľnej oblasti vstupného poľa. Na obmedzenie vstupnej dĺžky použite nastavenie <b>Validation → Maximum length (Overovacia maximálna dĺžka</b>)."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Použite {0} ako zástupný symbol skutočnej hodnoty."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Viditeľné len vtedy, ak aspoň jeden stĺpec obsahuje výraz Typ celkom alebo Celkom."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Ďalšie informácie nájdete v popise atribútu [accept](https://www.w3schools.com/tags/att_input_accept.asp)."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Vzťahuje sa len na typy buniek rádioskupiny a začiarkavacích políčok."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Ďalšie informácie nájdete v popise atribútu [automatické dopĺňanie](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete)."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Ak túto vlastnosť nenastavíte, odpoveď sa uloží do poľa určeného vlastnosťou Názov."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Ak zadaný stĺpec obsahuje rovnaké hodnoty, prieskum vyhodí chybu \"Nejedinečná hodnota kľúča\"."
// p.value: "Value" => "Hodnota"
// p.tabAlign: "Tab alignment" => "Zarovnanie tabulátora"
// p.questions: "Questions" => "Otázky"
// p.surveyId: "Survey id" => "ID prieskumu"
// p.surveyPostId: "Survey post id" => "ID príspevku prieskumu"
// p.surveyShowDataSaving: "Survey show data saving" => "Prieskum ukazuje ukladanie údajov"
// p.showTOC: "Show TOC" => "Zobraziť obsah"
// p.tocLocation: "Toc location" => "Umiestnenie TOC"
// p.showBrandInfo: "Show brand info" => "Zobraziť informácie o značke"
// p.renderAs: "Render as" => "Vykresliť ako"
// p.attachOriginalItems: "Attach original items" => "Priloženie originálnych položiek"
// p.cellHint: "Cell hint" => "Pomôcka buniek"
// p.isUnique: "Is unique" => "Je jedinečný"
// p.showInMultipleColumns: "Show in multiple columns" => "Zobraziť vo viacerých stĺpcoch"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Celkové maximálne číslice zlomkov"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Celkové minimálne zlomkové číslice"
// p.detailElements: "Detail elements" => "Detailné prvky"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Povolenie adaptívnych akcií"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Možnosti lenivého zaťaženia povolené"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Možnosti lenivé načítať veľkosť stránky"
// p.inputFieldComponent: "Input field component" => "Súčasť vstupného poľa"
// p.itemComponent: "Item component" => "Súčasť položky"
// p.elements: "Elements" => "Prvky"
// p.content: "Content" => "Obsah"
// p.longTap: "Long tap" => "Dlhé klepnutie"
// p.allowResize: "Allow resizing" => "Povoliť zmenu veľkosti"
// p.acceptCarriageReturn: "Accept carriage return" => "Akceptovať vrátenie prepravy"
// p.displayMode: "Display mode" => "Režim zobrazenia"
// p.rateType: "Rate type" => "Typ sadzby"
// p.altText: "Alt text" => "Alternatívny text"
// p.templateElements: "Template elements" => "Prvky šablóny"
// p.operator: "Operator" => "Operátor"
// p.isVariable: "Is variable" => "Je variabilný"
// p.runExpression: "Run expression" => "Spustiť výraz"
// p.precision: "Precision" => "Presnosť"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Oblasť ťahacej rukoväte matice"
// p.backgroundImage: "Background image" => "Obrázok na pozadí"
// p.backgroundImageFit: "Background image fit" => "Prispôsobenie obrázku na pozadí"
// p.backgroundImageAttachment: "Background image attachment" => "Príloha obrázka na pozadí"
// p.backgroundOpacity: "Background opacity" => "Nepriehľadnosť pozadia"
// p.selectToRankEnabled: "Select to rank enabled" => "Vyberte na povolené hodnotenie"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Rozloženie Vyberte na hodnotenie oblastí"
// p.allowCameraAccess: "Allow camera access" => "Povolenie prístupu ku kamere"
// p.scaleColorMode: "Scale color mode" => "Farebný režim mierky"
// p.rateColorMode: "Rate color mode" => "Režim hodnotenia farieb"
// p.templateTabTitle: "Template tab title" => "Názov karty šablóny"
// p.templateVisibleIf: "Template visible if" => "Šablóna viditeľná, ak"
// p.copyDisplayValue: "Copy display value" => "Kopírovať zobrazenú hodnotu"
// theme.--background: "Background color" => "Farba pozadia"
// theme.--background-dim-light: "Background dim light color" => "Tlmená farba svetla pozadia"
// theme.--primary-foreground: "Primary foreground color" => "Primárna farba popredia"
// theme.--foreground: "Foreground color" => "Farba popredia"
// theme.--base-unit: "Base unit" => "Základná jednotka"
// theme.groupAdvanced: "Advanced" => "Pokročilý"
// theme.themeName: "Theme" => "Téma"
// theme.isPanellessss: "Question appearance" => "Vzhľad otázky"
// theme.isPanellessPanels: "Default" => "Predvolený"
// theme.isPanellessLightweight: "Without Panels" => "Bez panelov"
// theme.themePaletteLight: "Light" => "Svetlo"
// theme.themePaletteDark: "Dark" => "Tmavý"
// theme.primaryColor: "Accent color" => "Farba akcentu"
// theme.primaryDefaultColor: "Default" => "Predvolený"
// theme.primaryDarkColor: "Hover" => "Hover"
// theme.primaryLightColor: "Selected" => "Vybraný"
// theme.backgroundDimColor: "Background color" => "Farba pozadia"
// theme.backgroundImage: "Background image" => "Obrázok na pozadí"
// theme.backgroundImageFitAuto: "Auto" => "Auto"
// theme.backgroundImageFitCover: "Cover" => "Prikryť"
// theme.backgroundImageFitContain: "Contain" => "Obsahovať"
// theme.backgroundOpacity: "Opacity" => "Neprehľadnosť"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Stabilný"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Zvitok"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Nepriehľadnosť pozadia panela"
// theme.questionBackgroundTransparency: "Question background opacity" => "Nepriehľadnosť pozadia otázky"
// theme.questionPanel: "Panel background and corner radius" => "Pozadie panela a polomer rohov"
// theme.questionTitle: "Question title font" => "Písmo názvu otázky"
// theme.questionDescription: "Question description font" => "Písmo popisu otázky"
// theme.editorPanel: "Input element" => "Vstupný prvok"
// theme.editorFont: "Input element font" => "Písmo vstupného prvku"
// theme.backcolor: "Default background" => "Predvolené pozadie"
// theme.hovercolor: "Hover background" => "Ukázanie na pozadie"
// theme.borderDecoration: "Border decoration" => "Dekorácia okrajov"
// theme.accentBackground: "Accent background" => "Zvýraznenie pozadia"
// theme.accentForeground: "Accent foreground" => "Zvýraznenie v popredí"
// theme.primaryForecolor: "Default color" => "Predvolená farba"
// theme.primaryForecolorLight: "Disabled color" => "Zakázaná farba"
// theme.linesColors: "Minor line colors" => "Vedľajšie farby čiar"
// theme.borderDefault: "Darker" => "Tmavšie"
// theme.borderLight: "Lighter" => "Zapaľovač"
// theme.fontFamily: "Font family" => "Skupina písiem"
// theme.fontSize: "Font size" => "Veľkosť písma"
// theme.color: "Color" => "Farba"
// theme.size: "Size" => "Veľkosť"
// theme.fontWeightRegular: "Regular" => "Pravidelný"
// theme.fontWeightHeavy: "Heavy" => "Ťažký"
// theme.fontWeightSemiBold: "Semi-bold" => "Polotučné"
// theme.fontWeightBold: "Bold" => "Smelý"
// theme.scale: "Scale" => "Stupnica"
// theme.cornerRadius: "Corner radius" => "Polomer rohov"
// theme.surveyTitleFont: "Survey title font" => "Písmo názvu prieskumu"
// theme.pageTitle: "Page title font" => "Písmo názvu stránky"
// theme.pageDescription: "Page description font" => "Písmo popisu stránky"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Pridanie efektu tieňa"
// theme.opacity: "Opacity" => "Neprehľadnosť"
// theme.boxShadowBlur: "Blur" => "Rozmazať"
// theme.boxShadowSpread: "Spread" => "Nátierka"
// theme.boxShadowDrop: "Drop" => "Kvapka"
// theme.boxShadowInner: "Inner" => "Vnútorný"
// theme.questionShadow: "Shadow effects" => "Efekty tieňov"
// theme.editorShadow: "Input element shadow effects" => "Efekty tieňov vstupného prvku"
// names.default: "Default" => "Predvolený"
// names.contrast: "Contrast" => "Kontrast"
// names.plain: "Plain" => "Obyčajný"
// names.simple: "Simple" => "Jednoduchý"
// names.blank: "Blank" => "Prázdny"
// names.double: "Double" => "Dvojitý"
// names.bulk: "Bulk" => "Hromadný"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo 3D"
// names.playful: "Playful" => "Hravý"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Šedozelená"
// colors.blue: "Blue" => "Modrý"
// colors.purple: "Purple" => "Purpurový"
// colors.orchid: "Orchid" => "Orchidea"
// colors.tulip: "Tulip" => "Tulipán"
// colors.brown: "Brown" => "Hnedý"
// colors.green: "Green" => "Zelený"
// names.sharp: "Sharp" => "Ostrý"
// names.borderless: "Borderless" => "Bez okrajov"
// names.flat: "Flat" => "Plochý"
// names.doubleborder: "Double Border" => "Dvojité ohraničenie"
// names.layered: "Layered" => "Vrstvené"
// names.solid: "Solid" => "Pevný"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Ste si istý, že chcete odstrániť všetky reťazce pre tento jazyk?"
// ed.themeResetButton: "Reset theme settings to default" => "Obnovenie predvolených nastavení motívu"
// theme.placeholderColor: "Placeholder color" => "Farba zástupného symbolu"
// ed.themeSettings: "Theme Settings" => "Nastavenia motívu"
// ed.themeSettingsTooltip: "Open theme settings" => "Otvorenie nastavení motívu"
// pe.resetToDefaultCaption: "Reset" => "Vynulovanie"
// pv.file: "Local files" => "Lokálne súbory"
// pv.camera: "Camera" => "Fotoaparát"
// pv.file-camera: "Local files or camera" => "Lokálne súbory alebo fotoaparát"
// ed.translateUsigAI: "Auto-translate All" => "Automatický preklad všetkého"
// ed.translationDialogTitle: "Untranslated strings" => "Nepreložené reťazce"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Zadajte aspoň {0} položiek"
// lg.question_resetValueName: "Reset question value" => "Obnoviť hodnotu otázky"
// lg.column_resetValue: "Reset column value" => "Obnovenie hodnoty stĺpca"
// pe.markRequired: "Mark as required" => "Označiť podľa potreby"
// pe.removeRequiredMark: "Remove the required mark" => "Odstráňte požadovanú značku"
// p.resetValueIf: "Reset value if" => "Obnoviť hodnotu, ak"
// lg.question_setValueName: "Set question value" => "Nastavenie hodnoty otázky"
// lg.column_resetValueName: "Reset column value" => "Obnovenie hodnoty stĺpca"
// lg.column_setValueName: "Set column value" => "Nastavenie hodnoty stĺpca"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Výraz, ktorého výsledok bude priradený k cieľovej otázke."
// survey.title: "Title" => "Titul"
// page.title: "Title" => "Titul"
// p.setValueIf: "Set value if" => "Nastaviť hodnotu, ak"
// theme.header: "Header" => "Hlavička"
// theme.backgroundImageFitFill: "Stretch" => "Natiahnuť"
// theme.backgroundImageFitTile: "Tile" => "Dlaždica"
// theme.headerView: "View" => "Pohľad"
// theme.headerViewBasic: "Basic" => "Základný"
// theme.headerViewAdvanced: "Advanced" => "Pokročilý"
// theme.headerInheritWidthFrom: "Content area width" => "Šírka oblasti obsahu"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Rovnaké ako prieskum"
// theme.headerInheritWidthFromPage: "Fit to page" => "Prispôsobiť na stranu"
// theme.headerTextAreaWidth: "Text width" => "Šírka textu"
// theme.headerBackgroundColorSwitch: "Background color" => "Farba pozadia"
// theme.headerBackgroundColorNone: "None" => "Žiadny"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Farba akcentu"
// theme.headerBackgroundColorCustom: "Custom" => "Zvyk"
// theme.horizontalAlignmentLeft: "Left" => "Vľavo"
// theme.horizontalAlignmentCenter: "Center" => "Centrum"
// theme.horizontalAlignmentRight: "Right" => "Doprava"
// theme.verticalAlignmentTop: "Top" => "Vrchol"
// theme.verticalAlignmentMiddle: "Middle" => "Stred"
// theme.verticalAlignmentBottom: "Bottom" => "Dno"
// theme.logoPosition: "Logo Position" => "Umiestnenie loga"
// theme.headerTitlePosition: "Title Position" => "Titulná pozícia"
// theme.headerDescriptionPosition: "Description Position" => "Popisná pozícia"
// lg.question_resetValueText: "reset value for question: {0}" => "Resetovať hodnotu pre otázku: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Priradiť hodnotu: {1} otázku: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Obnoviť hodnotu bunky pre stĺpec: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Priradenie hodnoty bunky: {1} do stĺpca: {0}"
// ed.surveyJsonExportButton: "Export" => "Vývoz"
// ed.surveyJsonImportButton: "Import" => "Import"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Kopírovanie do schránky"
// pe.filePlaceholder: "File placeholder text" => "Zástupný text súboru"
// pe.photoPlaceholder: "Photo placeholder text" => "Zástupný text fotografie"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Zástupný text súboru alebo fotografie"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Použije, keď \"Typ zdroja\" je \"Lokálne súbory\" alebo keď fotoaparát nie je k dispozícii"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Používa sa, keď \"Typ zdroja\" je \"Fotoaparát\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Použije, keď \"Typ zdroja\" je \"Lokálne súbory alebo fotoaparát\"."
// theme.background: "Background" => "Pozadie"
// theme.appearance: "Appearance" => "Vzhľad"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Naozaj chcete resetovať tému? Všetky vaše prispôsobenia sa stratia."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Áno, obnoviť motív"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Vhodné na kontajner"
// signaturepad.showPlaceholder: "Show the placeholder" => "Zobrazenie zástupného symbolu"
// signaturepad.placeholder: "Placeholder text" => "Zástupný text"
// theme.surveyDescriptionFont: "Survey description font" => "Písmo popisu prieskumu"
// ed.prevFocus: "Focus previous" => "Zameranie predchádzajúce"
// ed.nextFocus: "Focus next" => "Zameranie ďalej"
// ed.saveTheme: "Save Theme" => "Uložiť motív"
// ed.saveThemeTooltip: "Save Theme" => "Uložiť motív"
// lg.page_requireName: "Make page required" => "Nastavenie požadovanej strany"
// lg.panel_requireName: "Make page required" => "Nastavenie požadovanej strany"
// signaturepad.signatureWidth: "Signature area width" => "Šírka oblasti podpisu"
// signaturepad.signatureHeight: "Signature area height" => "Výška oblasti podpisu"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Automatická zmena mierky oblasti podpisu"
// signaturepad.penMinWidth: "Minimum pen width" => "Minimálna šírka pera"
// signaturepad.penMaxWidth: "Maximum pen width" => "Maximálna šírka pera"
// ed.propertyGridNoResultsFound: "No results found" => "Nenašli sa žiadne výsledky"
// pv.leftRight: "Left and right" => "Vľavo a vpravo"
// p.sourceType: "Source type" => "Typ zdroja"
// p.fitToContainer: "Fit to container" => "Vhodné na kontajner"
// p.setValueExpression: "Set value expression" => "Nastavenie výrazu hodnoty"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Možnosti sa načítavajú z webovej služby."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Prejdite na nastavenia"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Ukážka načítaných možností výberu"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Zabráňte duplicitným odpovediam v riadkoch"
// theme.advancedMode: "Advanced mode" => "Rozšírený režim"
// theme.backgroundCornerRadius: "Background and corner radius" => "Pozadie a polomer rohov"
// theme.colorsTitle: "Colors" => "Farby"
// theme.font: "Font" => "Písmo"
// theme.lines: "Lines" => "Riadky"
// theme.titleFont: "Title font" => "Písmo názvu"
// theme.descriptionFont: "Description font" => "Popisné písmo"
// theme.shadow: "Shadow effects" => "Efekty tieňov"
// ed.translateUsigAIFrom: "Translate from: " => "Preložiť z: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Povoliť možnosť Odmietnuť odpovedať"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Povoliť možnosť Neviem"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Povoliť možnosť Odmietnuť odpovedať"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Povoliť možnosť Neviem"
// pv.contain: "Contain" => "Obsahovať"
// pv.cover: "Cover" => "Prikryť"
// pv.fill: "Fill" => "Vyplniť"
// pe.transposeData: "Transpose rows to columns" => "Transponovanie riadkov do stĺpcov"
// layout.panel: "Layout" => "Rozloženie"
// layout.question: "Layout" => "Rozloženie"
// layout.base: "Layout" => "Rozloženie"
// panel.name: "Panel name" => "Názov panela"
// panel.title: "Panel title" => "Názov panelu"
// panel.description: "Panel description" => "Popis panelu"
// panel.visibleIf: "Make the panel visible if" => "Zviditeľnite panel, ak"
// panel.requiredIf: "Make the panel required if" => "Nastavte panel tak, aby bol povinný, ak"
// panel.questionsOrder: "Question order within the panel" => "Poradie otázok v rámci panelu"
// panel.startWithNewLine: "Display the panel on a new line" => "Zobrazenie panela na novom riadku"
// panel.state: "Panel collapse state" => "Stav zbalenia panela"
// panel.width: "Inline panel width" => "Šírka vnoreného panela"
// panel.minWidth: "Minimum panel width" => "Minimálna šírka panela"
// panel.maxWidth: "Maximum panel width" => "Maximálna šírka panela"
// panel.showNumber: "Number panels" => "Číselné panely"
// paneldynamic.name: "Panel name" => "Názov panela"
// paneldynamic.title: "Panel title" => "Názov panelu"
// paneldynamic.description: "Panel description" => "Popis panelu"
// paneldynamic.visibleIf: "Make the panel visible if" => "Zviditeľnite panel, ak"
// paneldynamic.requiredIf: "Make the panel required if" => "Nastavte panel tak, aby bol povinný, ak"
// paneldynamic.page: "Move the panel to page" => "Presunutie panela na stranu"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Zobrazenie panela na novom riadku"
// paneldynamic.state: "Panel collapse state" => "Stav zbalenia panela"
// paneldynamic.width: "Inline panel width" => "Šírka vnoreného panela"
// paneldynamic.minWidth: "Minimum panel width" => "Minimálna šírka panela"
// paneldynamic.maxWidth: "Maximum panel width" => "Maximálna šírka panela"
// paneldynamic.templateDescription: "Panel description pattern" => "Vzor popisu panela"
// paneldynamic.templateTitle: "Panel title pattern" => "Vzor názvu panela"
// paneldynamic.noEntriesText: "Empty panel text" => "Prázdny text panela"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Vzor názvu tabulátora"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Zviditeľniť samostatný panel, ak"
// paneldynamic.hideNumber: "Hide the panel number" => "Skrytie čísla panela"
// paneldynamic.titleLocation: "Panel title alignment" => "Zarovnanie názvu panela"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Zarovnanie popisu panela"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Zarovnanie názvu otázky"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Zarovnanie chybových hlásení"
// paneldynamic.newPanelPosition: "New panel location" => "Nové umiestnenie panela"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Zabránenie duplicitným odpovediam v nasledujúcej otázke"
// question.name: "Question name" => "Názov otázky"
// question.title: "Question title" => "Názov otázky"
// question.description: "Question description" => "Opis otázky"
// question.visibleIf: "Make the question visible if" => "Zviditeľnite otázku, ak"
// question.requiredIf: "Make the question required if" => "Urobte otázku povinnou, ak"
// question.state: "Question box collapse state" => "Stav zbalenia poľa otázok"
// question.hideNumber: "Hide the question number" => "Skrytie čísla otázky"
// question.titleLocation: "Question title alignment" => "Zarovnanie názvu otázky"
// question.descriptionLocation: "Question description alignment" => "Zarovnanie popisu otázky"
// question.errorLocation: "Error message alignment" => "Zarovnanie chybových hlásení"
// question.indent: "Increase the inner indent" => "Zväčšite vnútornú zarážku"
// question.width: "Inline question width" => "Vnorená šírka otázky"
// question.minWidth: "Minimum question width" => "Minimálna šírka otázky"
// question.maxWidth: "Maximum question width" => "Maximálna šírka otázky"
// question.textUpdateMode: "Update input field value" => "Aktualizácia hodnoty vstupného poľa"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Zobrazenie tlačidla Vymazať v oblasti podpisu"
// signaturepad.penColor: "Stroke color" => "Farba ťahu"
// comment.rows: "Input field height (in lines)" => "Výška vstupného poľa (v riadkoch)"
// expression.name: "Expression name" => "Názov výrazu"
// expression.title: "Expression title" => "Názov výrazu"
// expression.description: "Expression description" => "Popis výrazu"
// expression.expression: "Expression" => "Výraz"
// trigger.expression: "Expression" => "Výraz"
// calculatedvalue.expression: "Expression" => "Výraz"
// survey.description: "Survey description" => "Opis prieskumu"
// page.name: "Page name" => "Názov stránky"
// page.description: "Page description" => "Popis stránky"
// page.visibleIf: "Make the page visible if" => "Zviditeľniť stránku, ak"
// page.requiredIf: "Make the page required if" => "Nastavte stránku ako povinnú, ak"
// page.questionsOrder: "Question order on the page" => "Poradie otázok na stránke"
// matrixdropdowncolumn.name: "Column name" => "Názov stĺpca"
// matrixdropdowncolumn.title: "Column title" => "Názov stĺpca"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Zabráňte duplicitným odpovediam"
// matrixdropdowncolumn.width: "Column width" => "Šírka stĺpca"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Minimálna šírka stĺpca"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Výška vstupného poľa (v riadkoch)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Zviditeľnite stĺpec, ak"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Nastavte stĺpec ako povinný, ak"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Každá možnosť v samostatnom stĺpci"
// multipletextitem.name: "Name" => "Meno"
// multipletextitem.title: "Title" => "Titul"
// pe.rateDescriptionLocation: "Label alignment" => "Zarovnanie štítkov"
// pe.cellErrorLocation: "Cell error message alignment" => "Zarovnanie chybového hlásenia bunky"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Zatiaľ nemáte žiadne stĺpce"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Zatiaľ nemáte žiadne riadky"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Zatiaľ nemáte žiadne overovacie pravidlá"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Zatiaľ nemáte žiadne vlastné premenné"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Zatiaľ nemáte žiadne spúšťače"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Zatiaľ nemáte žiadne odkazy"
// pe.addNew@columns: "Add new column" => "Pridať nový stĺpec"
// pe.addNew@rows: "Add new row" => "Pridať nový riadok"
// pe.addNew@validators: "Add new rule" => "Pridať nové pravidlo"
// pe.addNew@calculatedValues: "Add new variable" => "Pridanie novej premennej"
// pe.addNew@triggers: "Add new trigger" => "Pridať nový spúšťač"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Pridať novú URL adresu"
// choicesbyurl.url: "Web service's URL" => "URL adresa webovej služby"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Zobrazenie prebiehajúcich názvov stránok"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Zobrazenie prebiehajúcich čísel strán"
// itemvalue.visibleIf: "Make the option visible if" => "Možnosť zobraziť, ak"
// itemvalue.enableIf: "Make the option selectable if" => "Túto možnosť nastavte tak, aby sa dala vybrať, ak"
// panel.layout: "Panel Layout" => "Rozloženie panela"
// tabs.questionSettings: "Question Settings" => "Nastavenia otázok"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Napríklad: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Napr.: kategórie.fikcia"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Napr.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Napr.: 6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "Napríklad: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Napríklad: 50%"
// pv.selected: "Selected" => "Vybraný"
// pv.unselected: "Unselected" => "Nevybratý"
// pv.center: "Center" => "Centrum"
// pv.middle: "Middle" => "Stred"
// pv.next: "Next" => "Budúci"
// pv.last: "Last" => "Minulý"
// clearIfInvisible.none: "Never" => "Nikdy"
// questionsOnPageMode.standard: "Original structure" => "Pôvodná štruktúra"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Zobraziť všetky otázky na jednej stránke"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Zobraziť jednu otázku na stránku"
// pv.auto: "Auto" => "Auto"
// panelsState.firstExpanded: "First expanded" => "Prvé rozšírenie"
// rateColorMode.scale: "Scale" => "Stupnica"
// scaleColorMode.monochrome: "Monochrome" => "Jednofarebný"
// scaleColorMode.colored: "Colored" => "Farebný"
// state.default: "Locked" => "Zamknutý"
// showQuestionNumbers.default: "Auto-numbering" => "Automatické číslovanie"
// showQuestionNumbers.on: "Auto-numbering" => "Automatické číslovanie"
// showQuestionNumbers.onPage: "Reset on each page" => "Obnoviť na každej stránke"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Resetovať na každom paneli"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Resetovať na každom paneli"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Pokračujte v prieskume"
// showQuestionNumbers.off: "No numbering" => "Bez číslovania"
// descriptionLocation.underTitle: "Under the question title" => "Pod názvom otázky"
// descriptionLocation.underInput: "Under the input field" => "Pod vstupným poľom"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Vedľa možností"
// selectToRankAreasLayout.vertical: "Above choices" => "Vyššie uvedené možnosti"
// displayStyle.decimal: "Decimal" => "Desatinný"
// displayStyle.currency: "Currency" => "Mena"
// displayStyle.percent: "Percentage" => "Percento"
// displayStyle.date: "Date" => "Dátum"
// totalDisplayStyle.decimal: "Decimal" => "Desatinný"
// totalDisplayStyle.currency: "Currency" => "Mena"
// totalDisplayStyle.percent: "Percentage" => "Percento"
// totalDisplayStyle.date: "Date" => "Dátum"
// rowsOrder.initial: "Original" => "Originál"
// questionsOrder.initial: "Original" => "Originál"
// showProgressBar.aboveheader: "Above the header" => "Nad hlavičkou"
// showProgressBar.belowheader: "Below the header" => "Pod hlavičkou"
// pv.sum: "Sum" => "Súčet"
// pv.count: "Count" => "Počítať"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Max"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Obsahuje"
// searchMode.startsWith: "Starts with" => "Začína sa"
// panel.name: "A panel ID that is not visible to respondents." => "ID panela, ktoré respondenti nevidia."
// panel.description: "Type a panel subtitle." => "Zadajte podnadpis panela."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré určuje viditeľnosť panela."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Pomocou ikony čarovnej paličky nastavte podmienené pravidlo, ktoré vypne režim iba na čítanie pre panel."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré zabráni odoslaniu prieskumu, pokiaľ aspoň jedna vnorená otázka nemá odpoveď."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Vzťahuje sa na všetky otázky v tomto paneli. Ak chcete toto nastavenie prepísať, definujte pravidlá zarovnania názvu pre jednotlivé otázky. Možnosť Dediť použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu (\"Predvolene navrchu\")."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Nastaví umiestnenie chybového hlásenia vo vzťahu ku všetkým otázkam v paneli. Možnosť Zdediť použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Zachová pôvodné poradie otázok alebo ich náhodne vyberie. Možnosť Zdediť použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu."
// panel.page: "Repositions the panel to the end of a selected page." => "Premiestni panel na koniec vybratej strany."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Pridá medzeru alebo okraj medzi obsah panela a ľavý okraj panela."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Zrušte výber výberu, ak chcete panel zobraziť v jednom riadku s predchádzajúcou otázkou alebo panelom. Toto nastavenie sa neuplatňuje, ak je panel prvým prvkom vo formulári."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Vyberte si z: \"Rozšírené\" - panel je zobrazený v plnom rozsahu a môže byť zbalený; \"Zbalené\" - panel zobrazuje iba názov a popis a je možné ho rozšíriť; \"Zamknutý\" - panel sa zobrazuje v plnom rozsahu a nedá sa zbaliť."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Nastaví šírku panela v pomere k ostatným prvkom prieskumu v tej istej čiare. Akceptuje hodnoty CSS (px, %, in, pt atď.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "ID panela, ktoré respondenti nevidia."
// paneldynamic.description: "Type a panel subtitle." => "Zadajte podnadpis panela."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré určuje viditeľnosť panela."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Pomocou ikony čarovnej paličky nastavte podmienené pravidlo, ktoré vypne režim iba na čítanie pre panel."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré zabráni odoslaniu prieskumu, pokiaľ aspoň jedna vnorená otázka nemá odpoveď."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Vzťahuje sa na všetky otázky v tomto paneli. Ak chcete toto nastavenie prepísať, definujte pravidlá zarovnania názvu pre jednotlivé otázky. Možnosť Dediť použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu (\"Predvolene navrchu\")."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Nastaví umiestnenie chybového hlásenia vo vzťahu k otázke s neplatným zadaním. Vyberte si medzi: \"Hore\" - v hornej časti poľa otázok sa umiestni chybový text; \"Dole\" - v dolnej časti poľa otázok je umiestnený chybový text. Možnosť Dediť použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu (\"Predvolene navrchu\")."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Nastaví umiestnenie chybového hlásenia vo vzťahu ku všetkým otázkam v paneli. Možnosť Zdediť použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Premiestni panel na koniec vybratej strany."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Pridá medzeru alebo okraj medzi obsah panela a ľavý okraj panela."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Zrušte výber výberu, ak chcete panel zobraziť v jednom riadku s predchádzajúcou otázkou alebo panelom. Toto nastavenie sa neuplatňuje, ak je panel prvým prvkom vo formulári."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Vyberte si z: \"Rozšírené\" - panel je zobrazený v plnom rozsahu a môže byť zbalený; \"Zbalené\" - panel zobrazuje iba názov a popis a je možné ho rozšíriť; \"Zamknutý\" - panel sa zobrazuje v plnom rozsahu a nedá sa zbaliť."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Nastaví šírku panela v pomere k ostatným prvkom prieskumu v tej istej čiare. Akceptuje hodnoty CSS (px, %, in, pt atď.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Zadajte šablónu pre názvy dynamických panelov. Použite {panelIndex} pre všeobecnú pozíciu panela a {visiblePanelIndex} pre jeho poradie medzi viditeľnými panelmi. Vložením týchto zástupných symbolov do vzoru pridáte automatické číslovanie."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Zadajte šablónu pre názvy kariet. Použite {panelIndex} pre všeobecnú pozíciu panela a {visiblePanelIndex} pre jeho poradie medzi viditeľnými panelmi. Vložením týchto zástupných symbolov do vzoru pridáte automatické číslovanie."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Toto nastavenie umožňuje ovládať viditeľnosť jednotlivých panelov v dynamickom paneli. Použite zástupný symbol {panel} na odkaz na aktuálny panel vo svojom výraze."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Toto nastavenie sa automaticky dedí všetkými otázkami na tomto paneli. Ak chcete toto nastavenie prepísať, definujte pravidlá zarovnania názvu pre jednotlivé otázky. Možnosť Dediť použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu (\"Predvolene navrchu\")."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "Možnosť \"Dediť\" použije nastavenie na úrovni stránky (ak je nastavená) alebo na úrovni prieskumu (\"Predvolene pod názvom panela\")."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Definuje pozíciu novo pridaného panela. V predvolenom nastavení sa na koniec pridávajú nové panely. Výberom položky \"Ďalej\" vložíte nový panel za aktuálny."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Duplikuje odpovede z posledného panela a priradí ich ďalšiemu pridanému dynamickému panelu."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Odkážte na názov otázky, ak chcete, aby používateľ poskytol jedinečnú odpoveď na túto otázku na každom paneli."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Toto nastavenie vám umožňuje priradiť predvolenú hodnotu odpovede na základe výrazu. Výraz môže obsahovať základné výpočty - '{q1_id} + {q2_id}', boolovské výrazy, ako napríklad '{age} > 60', a funkcie: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' atď. Hodnota určená týmto výrazom slúži ako počiatočná predvolená hodnota, ktorú je možné prepísať manuálnym vstupom respondenta."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré určuje, kedy sa vstup respondenta obnoví na hodnotu na základe hodnoty \"Výraz predvolenej hodnoty\" alebo \"Výraz nastavenej hodnoty\" alebo hodnoty \"Predvolená odpoveď\" (ak je nastavená)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré určuje, kedy spustiť \"Nastaviť výraz hodnoty\" a dynamicky priradiť výslednú hodnotu ako odpoveď."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Zadajte výraz, ktorý definuje hodnotu, ktorá sa má nastaviť, keď sú splnené podmienky pravidla \"Nastaviť hodnotu ak\". Výraz môže obsahovať základné výpočty - '{q1_id} + {q2_id}', boolovské výrazy, ako napríklad '{age} > 60', a funkcie: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' atď. Hodnota určená týmto výrazom môže byť prepísaná manuálnym vstupom respondenta."
// question.name: "A question ID that is not visible to respondents." => "ID otázky, ktoré respondenti nevidia."
// question.description: "Type a question subtitle." => "Zadajte podnadpis otázky."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré určuje viditeľnosť otázky."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Pomocou ikony čarovnej paličky nastavte podmienené pravidlo, ktoré vypne režim iba na čítanie pre otázku."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré zabráni postupu alebo odoslaniu prieskumu, pokiaľ otázka nedostala odpoveď."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Zrušte výber výberu, ak chcete otázku zobraziť v jednom riadku s predchádzajúcou otázkou alebo panelom. Toto nastavenie sa neuplatňuje, ak je otázka prvým prvkom vo formulári."
// question.page: "Repositions the question to the end of a selected page." => "Premiestni otázku na koniec vybratej strany."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Vyberte si z: \"Rozšírené\" - pole otázky sa zobrazí v plnom rozsahu a dá sa zbaliť; \"Zbalené\" - pole otázky zobrazuje iba názov a popis a je možné ho rozbaliť; \"Zamknuté\" - pole otázok sa zobrazí v plnom rozsahu a nedá sa zbaliť."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Prepíše pravidlá zarovnania názvu definované na úrovni panela, stránky alebo prieskumu. Možnosť \"Dediť\" použije akékoľvek nastavenia vyššej úrovne (ak sú nastavené) alebo nastavenia na úrovni prieskumu (\"Predvolene hore\")."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "Možnosť \"Zdediť\" použije nastavenie na úrovni prieskumu (\"Predvolene pod názvom otázky\")."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Nastaví umiestnenie chybového hlásenia vo vzťahu k otázke s neplatným zadaním. Vyberte si medzi: \"Hore\" - v hornej časti poľa otázok sa umiestni chybový text; \"Dole\" - v dolnej časti poľa otázok je umiestnený chybový text. Možnosť \"Zdediť\" použije nastavenie na úrovni prieskumu (\"Predvolene hore\")."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Pridá medzeru alebo okraj medzi obsah otázky a ľavý okraj poľa otázok."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Nastaví šírku otázky v pomere k ostatným prvkom prieskumu v tom istom riadku. Akceptuje hodnoty CSS (px, %, in, pt atď.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Pomocou ikony čarovného prútika nastavte overovacie pravidlo pre otázku."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Vyberte si z: \"Pri strate zaostrenia\" - hodnota sa aktualizuje, keď vstupné pole stratí zaostrenie; \"Počas písania\" - hodnota sa aktualizuje v reálnom čase, keď používatelia píšu. Možnosť \"Zdediť\" použije nastavenie na úrovni prieskumu (\"Predvolene stratené zameranie\")."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Ako zdroj údajov môžete použiť ľubovoľnú webovú službu na otázky s voliteľnými odpoveďami. Ak chcete vyplniť hodnoty možností, zadajte adresu URL služby poskytujúcej údaje."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Porovnávacia operácia použitá na filtrovanie rozbaľovacieho zoznamu."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Nastaví šírku zobrazenej oblasti podpisu a výsledného obrázka."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Nastaví výšku zobrazenej oblasti podpisu a výsledného obrázka."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Vyberte, či chcete, aby oblasť podpisu vyplnila všetok dostupný priestor v poli otázky pri zachovaní predvoleného pomeru strán 3:2. Keď sú nastavené vlastné hodnoty šírky a výšky, nastavenie zachová pomer strán týchto rozmerov."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Upraví výšku obrázka vo výsledkoch prieskumu."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Upraví šírku obrázka vo výsledkoch prieskumu."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Prepíše hodnoty minimálnej a maximálnej výšky."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Prepíše hodnoty minimálnej a maximálnej šírky."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Hodnota\" slúži ako ID položky používané v podmienených pravidlách; \"Text\" sa zobrazuje respondentom."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Toto nastavenie zmení iba veľkosť vstupného poľa a neovplyvní šírku poľa otázky. Ak chcete obmedziť akceptovanú vstupnú dĺžku, prejdite na <b>Overenie → Maximálny počet znakov</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Nastaví počet zobrazených riadkov vo vstupnom poli. Ak vstup zaberá viac riadkov, zobrazí sa posúvač."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Vyberte si medzi: \"Upraviteľné\" - umožňuje respondentom vyplniť váš prieskum; \"Iba na čítanie\" - zakáže úpravu formulárov."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "ID stĺpca, ktoré respondenti nevidia."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Ak je pre stĺpec povolené, respondent je povinný poskytnúť jedinečnú odpoveď na každú otázku v tomto stĺpci."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Nastaví počet zobrazených riadkov vo vstupnom poli. Ak vstup zaberá viac riadkov, zobrazí sa posúvač."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré určuje viditeľnosť stĺpca."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Pomocou ikony čarovnej paličky nastavte podmienené pravidlo, ktoré vypne režim iba na čítanie pre stĺpec."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré zabráni odoslaniu prieskumu, pokiaľ aspoň jedna vnorená otázka nemá odpoveď."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Ak je táto voľba vybratá, vytvorí samostatný stĺpec pre každú možnosť výberu."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Vyberte si z: \"Statický\" - nastavuje pevnú šírku; \"Responzívny\" - spôsobuje, že prieskum zaberá celú šírku obrazovky; \"Auto\" - použije ktorýkoľvek z týchto dvoch v závislosti od použitých typov otázok."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Prilepte odkaz na obrázok (bez obmedzenia veľkosti) alebo kliknite na ikonu priečinka a prehľadávajte súbor z počítača (až 64 kB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Nastavuje šírku loga v jednotkách CSS (px, %, in, pt atď.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Nastavuje výšku loga v jednotkách CSS (px, %, in, pt atď.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Vyberte si z: \"Žiadne\" - obrázok si zachováva svoju pôvodnú veľkosť; \"Obsahovať\" - veľkosť obrázka sa zmení tak, aby sa zmestil pri zachovaní pomeru strán; \"Obal\" - obrázok vyplní celé pole pri zachovaní pomeru strán; \"Vyplniť\" - obrázok je natiahnutý tak, aby vyplnil pole bez zachovania pomeru strán."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Vyberte, či chcete, aby prieskum automaticky postúpil na ďalšiu stranu po tom, čo respondent odpovie na všetky otázky na aktuálnej stránke."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Nastavuje viditeľnosť a umiestnenie navigačných tlačidiel na stránke."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Nastavuje viditeľnosť a umiestnenie indikátora priebehu. Hodnota \"Auto\" zobrazuje indikátor priebehu nad alebo pod hlavičkou prieskumu."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Povoľte stránku ukážky so všetkými alebo iba zodpovedanými otázkami."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Vzťahuje sa na všetky otázky v rámci prieskumu. Toto nastavenie je možné prepísať pravidlami zarovnania názvov na nižších úrovniach: panel, stránka alebo otázka. Nastavenie nižšej úrovne prepíše nastavenia na vyššej úrovni."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Symbol alebo postupnosť symbolov označujúcich, že sa vyžaduje odpoveď."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Zadajte číslo alebo písmeno, ktorým chcete začať číslovanie."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Nastaví umiestnenie chybového hlásenia vo vzťahu k otázke s neplatným zadaním. Vyberte si medzi: \"Hore\" - v hornej časti poľa otázok sa umiestni chybový text; \"Dole\" - v dolnej časti poľa otázok je umiestnený chybový text."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Vyberte, či chcete prvé vstupné pole na každej strane pripraviť na zadávanie textu."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Zachová pôvodné poradie otázok alebo ich náhodne vyberie. Efekt tohto nastavenia je viditeľný iba na karte Ukážka."
// pehelp.maxTextLength: "For text entry questions only." => "Len pre otázky týkajúce sa zadávania textu."
// pehelp.maxOthersLength: "For question comments only." => "Len pre komentáre k otázkam."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Vyberte, či chcete, aby komentáre otázok a otázky s dlhým textom automaticky narástli na výšku na základe zadanej dĺžky textu."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Iba pre komentáre k otázkam a otázky s dlhým textom."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Vlastné premenné slúžia ako medziľahlé alebo pomocné premenné používané vo výpočtoch formulárov. Vstupy respondentov berú ako zdrojové hodnoty. Každá vlastná premenná má jedinečný názov a výraz, na ktorom je založená."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Vyberte, či chcete, aby sa vypočítaná hodnota výrazu uložila spolu s výsledkami prieskumu."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Spúšťač je udalosť alebo podmienka, ktorá je založená na výraze. Keď je výraz vyhodnotený ako \"true\", spúšťač spustí akciu. Takáto akcia môže mať voliteľne cieľovú otázku, ktorú ovplyvňuje."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Vyberte, či chcete vymazať hodnoty pre otázky skryté podmienenou logikou a kedy to urobiť."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Vyberte si z: \"Pri strate zaostrenia\" - hodnota sa aktualizuje, keď vstupné pole stratí zaostrenie; \"Počas písania\" - hodnota sa aktualizuje v reálnom čase, keď používatelia píšu."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Ľavá hodnota slúži ako ID stĺpca používaného v podmienených pravidlách, pravá hodnota sa zobrazuje respondentom."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Ľavá hodnota slúži ako ID riadka používaného v podmienených pravidlách, pravá hodnota sa zobrazuje respondentom."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Akceptuje hodnoty CSS (px, %, in, pt atď.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Akceptuje hodnoty CSS (px, %, in, pt atď.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Nastaví umiestnenie chybového hlásenia vo vzťahu k bunke s neplatným vstupom. Možnosť Zdediť použije nastavenie z vlastnosti Zarovnanie chybového hlásenia."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Keď je povolená vlastnosť Zabrániť duplicitným odpovediam, respondentovi, ktorý sa pokúša odoslať duplicitný záznam, sa zobrazí nasledujúce chybové hlásenie."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Umožňuje vypočítať celkové hodnoty na základe výrazu. Výraz môže obsahovať základné výpočty (\"{q1_id} + {q2_id}\"), boolovské výrazy (\"{age} > 60') a funkcie (\"iif()\", \"today()\", \"age()\", \"min()\", \"max()\", \"avg()\" atď.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Spustí výzvu so žiadosťou o potvrdenie odstránenia riadka."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Duplikuje odpovede z posledného riadka a priradí ich k ďalšiemu pridanému dynamickému riadku."
// pehelp.description: "Type a subtitle." => "Zadajte podnadpis."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Vyberte jazyk a začnite vytvárať prieskum. Ak chcete pridať preklad, prepnite na nový jazyk a preložte pôvodný text tu alebo na karte Preklady."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Nastaví umiestnenie sekcie podrobností vo vzťahu k riadku. Vyberte si z: \"Žiadne\" - nie je pridané žiadne rozšírenie; \"Pod riadkom\" - pod každým riadkom matice je umiestnené rozšírenie riadku; \"Pod riadkom zobraziť iba rozšírenie jedného riadka\" - rozšírenie sa zobrazí iba pod jedným riadkom, zvyšné rozšírenia riadkov sa zbalia."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Vyberte si z: \"Žiadne\" - obrázok si zachováva svoju pôvodnú veľkosť; \"Obsahovať\" - veľkosť obrázka sa zmení tak, aby sa zmestil pri zachovaní pomeru strán; \"Obal\" - obrázok vyplní celé pole pri zachovaní pomeru strán; \"Vyplniť\" - obrázok je natiahnutý tak, aby vyplnil pole bez zachovania pomeru strán."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Postupne zvyšuje výšku vstupného poľa pri zadávaní údajov. Prepíše nastavenie Výška vstupného poľa (v riadkoch)."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Rukoväť na zmenu veľkosti (alebo uchopenie) sa zobrazí v rohu a potiahnutím môžete zmeniť veľkosť vstupného poľa."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Časový interval v sekundách, po ktorom prieskum automaticky prejde na stránku s poďakovaním."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Časový interval v sekundách, po ktorom prieskum automaticky prejde na ďalšiu stránku."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Časový interval v sekundách, po ktorom prieskum automaticky prejde na ďalšiu stránku."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Pomocou ikony čarovnej paličky nastavte podmienené pravidlo, ktoré určuje viditeľnosť stránky."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré vypne režim iba na čítanie pre stránku."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré zabráni odoslaniu prieskumu, pokiaľ aspoň jedna vnorená otázka nemá odpoveď."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Vzťahuje sa na všetky otázky na tejto stránke. Ak chcete toto nastavenie prepísať, definujte pravidlá zarovnania názvu pre jednotlivé otázky alebo panely. Možnosť \"Zdediť\" použije nastavenie na úrovni prieskumu (\"Predvolene hore\")."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Nastaví umiestnenie chybového hlásenia vo vzťahu k otázke s neplatným zadaním. Vyberte si medzi: \"Hore\" - v hornej časti poľa otázok sa umiestni chybový text; \"Dole\" - v dolnej časti poľa otázok je umiestnený chybový text. Možnosť \"Zdediť\" použije nastavenie na úrovni prieskumu (\"Predvolene hore\")."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Zachová pôvodné poradie otázok alebo ich náhodne vyberie. Možnosť \"Zdediť\" použije nastavenie na úrovni prieskumu (\"Originál\" v predvolenom nastavení). Efekt tohto nastavenia je viditeľný iba na karte Ukážka."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Nastavuje viditeľnosť navigačných tlačidiel na stránke. Možnosť Zdediť použije nastavenie na úrovni prieskumu, ktoré je predvolene nastavené na \"Viditeľné\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Nastavuje viditeľnosť a umiestnenie časovača na stránke."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Vyberte si z: \"Zamknuté\" - používatelia nemôžu rozširovať ani zbaliť panely; \"Zbaliť všetko\" - všetky panely začínajú v zbalenom stave; \"Rozbaliť všetko\" - všetky panely začínajú v rozšírenom stave; \"Prvý rozšírený\" - pôvodne sa rozšíril iba prvý panel."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Zadajte zdieľaný názov vlastnosti do poľa objektov obsahujúceho URL adresy obrázkov alebo videosúborov, ktoré chcete zobraziť v zozname výberu."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Ľavá hodnota slúži ako ID položky používané v podmienených pravidlách, pravá hodnota sa zobrazuje respondentom."
// pehelp.title: "Type a user-friendly title to display." => "Zadajte používateľsky prívetivý názov, ktorý chcete zobraziť."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Zabezpečuje, že používatelia prieskum nevyplnia, kým sa nenahrajú súbory."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Akceptuje hodnoty CSS (px, %, in, pt atď.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Akceptuje hodnoty CSS (px, %, in, pt atď.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Akceptuje hodnoty CSS (px, %, in, pt atď.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "V prípade otázok s jedným a viacerými výbermi má každá možnosť výberu identifikátor a zobrazenú hodnotu. Ak je táto voľba vybratá, toto nastavenie zobrazuje zobrazenú hodnotu namiesto hodnoty ID v otázkach HTML a dynamických názvoch a popisoch prvkov prieskumu."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Vyberte, či chcete vymazať hodnoty otázok skryté podmienenou logikou a kedy to chcete urobiť. Možnosť \"Dediť\" použije nastavenie na úrovni prieskumu (\"Po dokončení prieskumu predvolene\")."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Vyberte si z: \"Všetko\" - skopíruje všetky možnosti výberu z vybranej otázky; \"Vybraté\" - dynamicky kopíruje iba vybrané možnosti výberu; \"Nevybraté\" - dynamicky kopíruje iba nevybraté možnosti výberu. Možnosti \"Žiadne\" a \"Iné\" sa predvolene kopírujú, ak sú povolené v otázke zdroja."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Ak je táto voľba vybratá, používatelia môžu zahrnúť ďalšie vstupy do samostatného poľa komentára."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Zobrazí každú možnosť špeciálnej voľby (\"Žiadne\", \"Iné\", \"Vybrať všetko\") na novom riadku, a to aj pri použití rozloženia s viacerými stĺpcami."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Zadajte umiestnenie v množine údajov služby, kde sa nachádza cieľové pole objektov. Ak URL adresa už odkazuje na pole, nechajte prázdne."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Zadajte jednotný názov vlastnosti do poľa objektov obsahujúceho hodnoty, ktoré chcete zobraziť v zozname možností."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Túto voľbu vyberte, ak chcete, aby služba vrátila prázdnu odpoveď alebo pole."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Pomocou ikony čarovného prútika nastavte podmienené pravidlo, ktoré určuje viditeľnosť všetkých možností výberu."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Ľavá hodnota slúži ako ID položky používané v podmienených pravidlách, pravá hodnota sa zobrazuje respondentom."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" si vyberá medzi režimami \"Tlačidlá\" a \"Rozbaľovacia ponuka\" na základe dostupnej šírky. Ak šírka nie je dostatočná na zobrazenie tlačidiel, v otázke sa zobrazí rozbaľovací zoznam."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Umožňuje prepojiť otázky, ktoré vytvárajú výsledky v rôznych formátoch. Keď sú takéto otázky prepojené pomocou identifikátora spojenia, v tomto zdieľanom vlastníctve sa uložia vybraté hodnoty otázok."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Vyberte, či chcete aktualizovať obsah rozbaľovacej ponuky tak, aby zodpovedal vyhľadávaciemu dotazu, ktorý používateľ zadáva do vstupného poľa."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Hodnota, ktorú treba uložiť do výsledkov prieskumu, keď respondenti poskytnú kladnú odpoveď."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Hodnota, ktorú je potrebné uložiť do výsledkov prieskumu, keď respondenti poskytnú zápornú odpoveď."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Túto možnosť sa neodporúča zakázať, pretože prepíše obrázok ukážky a sťažuje používateľovi pochopiť, či boli súbory nahrané."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Spustí výzvu na potvrdenie odstránenia súboru."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Povoľte zoradiť iba vybrané možnosti. Používatelia presunú vybrané položky zo zoznamu možností a zoradia ich v oblasti poradia."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Zadajte zoznam možností, ktoré budú respondentovi navrhnuté počas vstupu."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Toto nastavenie zmení iba veľkosť vstupných polí a neovplyvní šírku poľa otázok."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Nastavuje konzistentnú šírku pre všetky štítky položiek v pixeloch"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Možnosť \"Auto\" automaticky určuje vhodný režim zobrazenia - obrázok, video alebo YouTube - na základe poskytnutej zdrojovej adresy URL."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Slúži ako náhrada, keď obrázok nie je možné zobraziť na zariadení používateľa a na účely prístupnosti."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Definuje farbu vybraných emodži, keď je typ ikony hodnotenia nastavený na \"Smajlíky\". Vyberte si medzi: \"Predvolené\" - vybrané emodži sa zobrazia v predvolenej farbe prieskumu; \"Mierka\" - vybrané emodži zdedí farbu z hodnotiacej stupnice."
// expression.name: "An expression ID that is not visible to respondents." => "ID výrazu, ktoré respondenti nevidia."
// expression.description: "Type an expression subtitle." => "Zadajte podnadpis výrazu."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Výraz môže obsahovať základné výpočty (\"{q1_id} + {q2_id}\"), podmienky (\"{vek} > 60\") a funkcie (\"iif()\", \"today()\", \"age()\", \"min()\", \"max()\", \"avg()\" atď.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Túto voľbu vyberte, ak chcete uložiť hodnotu možnosti \"Iné\" ako samostatnú vlastnosť vo výsledkoch prieskumu."
// p.swapOrder: "Swap the order of Yes and No" => "Zámena poradia Áno a Nie"
// p.itemTitleWidth: "Item label width (in px)" => "Šírka označenia položky (v px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Text, ktorý zobrazuje, či sú vybraté všetky možnosti"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Zástupný text pre oblasť hodnotenia"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Vyplňte prieskum automaticky"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Vyberte, či chcete, aby sa prieskum dokončil automaticky po tom, čo respondent odpovie na všetky otázky."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Uložte maskovanú hodnotu do výsledkov prieskumu"
// patternmask.pattern: "Value pattern" => "Hodnotový vzor"
// datetimemask.min: "Minimum value" => "Minimálna hodnota"
// datetimemask.max: "Maximum value" => "Maximálna hodnota"
// numericmask.allowNegativeValues: "Allow negative values" => "Povolenie záporných hodnôt"
// numericmask.thousandsSeparator: "Thousands separator" => "Oddeľovač tisícov"
// numericmask.decimalSeparator: "Decimal separator" => "Oddeľovač desatinných miest"
// numericmask.precision: "Value precision" => "Presnosť hodnoty"
// numericmask.min: "Minimum value" => "Minimálna hodnota"
// numericmask.max: "Maximum value" => "Maximálna hodnota"
// currencymask.prefix: "Currency prefix" => "Predčíslievanie meny"
// currencymask.suffix: "Currency suffix" => "Prípona meny"
// pe.maskType: "Input mask type" => "Typ vstupnej masky"
// maskTypes.patternmask: "Pattern" => "Vzorka"
// maskTypes.numericmask: "Numeric" => "Numerický"
// maskTypes.datetimemask: "Date and Time" => "Dátum a čas"
// maskTypes.currencymask: "Currency" => "Mena"
// tabs.mask: "Input Mask Settings" => "Nastavenia vstupnej masky"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Napríklad: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Napr.: mm/dd/rrrr"
// pe.currencyprefix_placeholder: "Ex.: $" => "Napr.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Napríklad: USD"
// pv.textWrapEnabled: "Wrap choices" => "Možnosti zabalenia"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Dlhé texty v možnostiach výberu automaticky vygenerujú zlomy riadkov, aby sa zmestili do rozbaľovacej ponuky. Zrušte výber, či chcete texty vystrihnúť."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Vyberte, či chcete do výsledkov prieskumu uložiť hodnotu otázky s použitou maskou."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Vzor môže obsahovať reťazcové literály a nasledujúce zástupné symboly: \"9\" - pre číslicu; \"a\" - pre veľké alebo malé písmeno; '#' - pre číslicu alebo veľké alebo malé písmeno. Použite opačné lomítko \"\\\" na únik z postavy."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Vzor môže obsahovať oddeľovacie znaky a nasledujúce zástupné symboly: \"m\" - pre číslo mesiaca; \"mm\" - pre číslo mesiaca, s úvodnou nulou pre jednociferné hodnoty; \"d\" - pre deň v mesiaci; \"dd\" - pre deň v mesiaci s počiatočnou nulou pre jednociferné hodnoty; \"yy\" - pre posledné dve číslice roka; \"rrrr\" - na štvorciferný rok."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Symbol používaný na oddelenie zlomkovej časti od celočíselnej časti zobrazeného čísla."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Symbol používaný na oddelenie číslic veľkého čísla do skupín po troch."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Obmedzuje, koľko číslic sa má zachovať za desatinnou čiarkou pre zobrazené číslo."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Jeden alebo niekoľko symbolov, ktoré sa majú zobraziť pred hodnotou."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Jeden alebo viac symbolov, ktoré sa zobrazia za hodnotou."
// ed.translationSource: "Source: " => "Zdroj: "
// ed.translationTarget: "Target: " => "Cieľ: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Stránka je prázdna. Potiahnite prvok z panela s nástrojmi alebo kliknite na tlačidlo nižšie."
// maskTypes.none: "None" => "Žiadny"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Nastavenie riadka ako viditeľného, ak"
// itemvalue@rows.enableIf: "Make the row editable if" => "Nastavte riadok tak, aby ho bolo možné upravovať, ak"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Zástupný text v režime iba na čítanie alebo v režime ukážky"
// pe.textWrapEnabled: "Wrap choices" => "Možnosti zabalenia"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Možnosť \"Auto\" automaticky určuje vhodný režim zobrazenia - obrázok, video alebo YouTube - na základe poskytnutej zdrojovej adresy URL."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Vyberte si medzi \"Obrázok\" a \"Video\" a nastavte režim obsahu výberu médií. Ak je vybratá možnosť \"Obrázok\", uistite sa, že všetky poskytnuté možnosti sú obrazové súbory v nasledujúcich formátoch: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Podobne, ak je vybratá možnosť \"Video\", uistite sa, že všetky možnosti sú priamymi odkazmi na video súbory v nasledujúcich formátoch: MP4, MOV, WMV, FLV, AVI, MKV. Upozorňujeme, že možnosti videí nie sú podporované odkazmi na YouTube."
// ed.selectFile: "Select a file" => "Vyberte súbor"
// ed.removeFile: "Remove the file" => "Odstránenie súboru"
// pe.searchMode: "Search Mode" => "Režim vyhľadávania"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Kliknite na tlačidlo \"Pridať otázku\" nižšie a začnite vytvárať formulár."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Kliknite na tlačidlo \"Pridať otázku\" nižšie a pridajte na stránku nový prvok."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Kliknite na tlačidlo \"Pridať otázku\" nižšie a pridajte na panel nový prvok."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Kliknite na tlačidlo nižšie a vyberte obrázok, ktorý chcete nahrať"
// coloralpha.opacity: "Opacity" => "Neprehľadnosť"
// font.family: "Font family" => "Skupina písiem"
// font.color: "Color" => "Farba"
// font.placeholderColor: "Placeholder color" => "Farba zástupného symbolu"
// font.size: "Size" => "Veľkosť"
// theme.themeName: "Theme" => "Téma"
// theme.isPanelless: "Question appearance" => "Vzhľad otázky"
// theme.editorPanel: "Background and corner radius" => "Pozadie a polomer rohov"
// theme.questionPanel: "Background and corner radius" => "Pozadie a polomer rohov"
// theme.primaryColor: "Accent color" => "Farba akcentu"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Nepriehľadnosť pozadia panela"
// theme.questionBackgroundTransparency: "Question background opacity" => "Nepriehľadnosť pozadia otázky"
// theme.fontSize: "Font size" => "Veľkosť písma"
// theme.scale: "Scale" => "Stupnica"
// theme.cornerRadius: "Corner radius" => "Polomer rohov"
// theme.pageTitle: "Title font" => "Písmo názvu"
// theme.pageDescription: "Description font" => "Popisné písmo"
// theme.questionTitle: "Title font" => "Písmo názvu"
// theme.questionDescription: "Description font" => "Popisné písmo"
// theme.editorFont: "Font" => "Písmo"
// theme.backgroundOpacity: "Opacity" => "Neprehľadnosť"
// theme.--sjs-font-family: "Font family" => "Skupina písiem"
// theme.--sjs-general-backcolor-dim: "Background color" => "Farba pozadia"
// theme.--sjs-primary-backcolor: "Accent background" => "Zvýraznenie pozadia"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Zvýraznenie v popredí"
// theme.--sjs-shadow-small: "Shadow effects" => "Efekty tieňov"
// theme.--sjs-shadow-inner: "Shadow effects" => "Efekty tieňov"
// theme.--sjs-border-default: "Colors" => "Farby"
// header@header.headerView: "View" => "Pohľad"
// header@header.logoPosition: "Logo position" => "Umiestnenie loga"
// header@header.surveyTitle: "Survey title font" => "Písmo názvu prieskumu"
// header@header.surveyDescription: "Survey description font" => "Písmo popisu prieskumu"
// header@header.headerTitle: "Survey title font" => "Písmo názvu prieskumu"
// header@header.headerDescription: "Survey description font" => "Písmo popisu prieskumu"
// header@header.inheritWidthFrom: "Content area width" => "Šírka oblasti obsahu"
// header@header.textAreaWidth: "Text width" => "Šírka textu"
// header@header.backgroundColorSwitch: "Background color" => "Farba pozadia"
// header@header.backgroundImage: "Background image" => "Obrázok na pozadí"
// header@header.backgroundImageOpacity: "Opacity" => "Neprehľadnosť"
// header@header.overlapEnabled: "Overlap" => "Presahovať"
// header@header.logoPositionX: "Logo position" => "Umiestnenie loga"
// header@header.titlePositionX: "Title position" => "Pozícia názvu"
// header@header.descriptionPositionX: "Description position" => "Popisná poloha"
// weight.400: "Regular" => "Pravidelný"
// weight.600: "Heavy" => "Ťažký"
// weight.700: "Semi-bold" => "Polotučné"
// weight.800: "Bold" => "Smelý"
// backgroundImageFit.auto: "Auto" => "Auto"
// backgroundImageFit.cover: "Cover" => "Prikryť"
// backgroundImageFit.contain: "Contain" => "Obsahovať"
// backgroundImageFit.fill: "Stretch" => "Natiahnuť"
// backgroundImageFit.tile: "Tile" => "Dlaždica"
// backgroundImageAttachment.fixed: "Fixed" => "Stabilný"
// backgroundImageAttachment.scroll: "Scroll" => "Zvitok"
// headerView.basic: "Basic" => "Základný"
// headerView.advanced: "Advanced" => "Pokročilý"
// inheritWidthFrom.survey: "Same as survey" => "Rovnaké ako prieskum"
// inheritWidthFrom.container: "Fit to container" => "Vhodné na kontajner"
// backgroundColorSwitch.none: "None" => "Žiadny"
// backgroundColorSwitch.accentColor: "Accent color" => "Farba akcentu"
// backgroundColorSwitch.custom: "Custom" => "Zvyk"
// colorPalette.light: "Light" => "Svetlo"
// colorPalette.dark: "Dark" => "Tmavý"
// isPanelless.false: "Default" => "Predvolený"
// isPanelless.true: "Without Panels" => "Bez panelov"
// theme.cornerRadius: "Corner radius" => "Polomer rohov"
// theme.fontFamily: "Font family" => "Skupina písiem"
// theme.fontWeightRegular: "Regular" => "Pravidelný"
// theme.fontWeightHeavy: "Heavy" => "Ťažký"
// theme.fontWeightSemiBold: "Semi-bold" => "Polotučné"
// theme.fontWeightBold: "Bold" => "Smelý"
// theme.color: "Color" => "Farba"
// theme.placeholderColor: "Placeholder color" => "Farba zástupného symbolu"
// theme.size: "Size" => "Veľkosť"
// theme.opacity: "Opacity" => "Neprehľadnosť"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Zadajte reťazec pre vyhľadávanie..."
// ed.toolboxNoResultsFound: "No results found" => "Nenašli sa žiadne výsledky"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Zástupný symbol názvu tabulátora"
// theme.--sjs-special-red: "Error messages" => "Chybové hlásenia"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Záložný text pre názvy kariet, ktorý sa použije, keď vzor názvu tabulátora nevytvára zmysluplnú hodnotu."
// theme.fontColor: "Font color" => "Farba písma"
// theme.backgroundColor: "Background color" => "Farba pozadia"
// pe.questionTitleWidth: "Question title width" => "Šírka názvu otázky"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Vyberte súbor alebo prilepte odkaz na súbor..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Napríklad: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Nastavuje konzistentnú šírku názvov otázok, keď sú zarovnané naľavo od polí otázok. Akceptuje hodnoty CSS (px, %, in, pt atď.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Nastavuje konzistentnú šírku názvov otázok, keď sú zarovnané naľavo od polí otázok. Akceptuje hodnoty CSS (px, %, in, pt atď.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Výška oblasti komentárov (v riadkoch)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Nastaví počet zobrazených riadkov v textových oblastiach pre komentáre otázok. Vo vstupe zaberá viac riadkov, zobrazí sa posúvač."


/***/ }),

/***/ "./src/localization/spanish.ts":
/*!*************************************!*\
  !*** ./src/localization/spanish.ts ***!
  \*************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var spanishTranslation = {
    // survey templates
    survey: {
        edit: "Editar",
        externalHelpLink: "Mira y aprende a crear encuestas",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "¡Arrastra un tipo de pregunta para empezar a diseñar tu encuesta!",
        addLogicItem: "Cree una regla para personalizar el flujo de la encuesta",
        copy: "Copiar",
        duplicate: "Duplicar",
        addToToolbox: "Añadir a la caja de herramientas",
        deletePanel: "Eliminar panel",
        deleteQuestion: "Eliminar pregunta",
        convertTo: "Convertir a",
        drag: "Elemento de arrastre",
    },
    // Creator tabs
    tabs: {
        preview: "Encuesta de prueba",
        theme: "Temas",
        translation: "Traducción",
        designer: "Diseñador de la encuesta",
        editor: "Editor de JSON",
        logic: "Lógica de la encuesta"
    },
    // Question types
    qt: {
        default: "Defecto",
        checkbox: "Caja",
        comment: "Comentario",
        imagepicker: "Selector de imágenes",
        ranking: "Ranking",
        image: "Imagen",
        dropdown: "Desplegable",
        tagbox: "Menú desplegable de selección múltiple",
        file: "Archivo",
        html: "Html",
        matrix: "Matriz (selección única)",
        matrixdropdown: "Matriz (opción múltiple)",
        matrixdynamic: "Matriz (filas dinámicas)",
        multipletext: "Múltiples textos",
        panel: "Panel",
        paneldynamic: "Panel (paneles dinámicos)",
        radiogroup: "Grupo de radio",
        rating: "Clasificación",
        text: "Entrada única",
        boolean: "Booleano",
        expression: "Expresión (solo lectura)",
        signaturepad: "Almohadilla de firma",
        buttongroup: "Grupo de botones"
    },
    toolboxCategories: {
        general: "general",
        choice: "Preguntas de selección",
        text: "Preguntas entrada de texto",
        containers: "Contenedores",
        matrix: "Preguntas matriz",
        misc: "Misc"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Predeterminado ({0})",
        survey: "Encuesta",
        settings: "Configuración de la encuesta",
        settingsTooltip: "Configuración de encuesta abierta",
        surveySettings: "Opciones encuesta",
        surveySettingsTooltip: "Configuración de la encuesta",
        themeSettings: "Configuración del tema",
        themeSettingsTooltip: "Configuración del tema",
        showPanel: "Mostrar panel",
        hidePanel: "Ocultar panel",
        prevSelected: "Seleccionar anterior",
        nextSelected: "Seleccionar siguiente",
        prevFocus: "Enfoque anterior",
        nextFocus: "Enfoque siguiente",
        surveyTypeName: "Encuesta",
        pageTypeName: "Página",
        panelTypeName: "Panel",
        questionTypeName: "Pregunta",
        columnTypeName: "Columna",
        addNewPage: "Añadir nueva página",
        moveRight: "Desplácese a la derecha",
        moveLeft: "Desplácese a la izquierda",
        deletePage: "Eliminar página",
        editPage: "Editar página",
        edit: "Editar",
        newPageName: "Página",
        newQuestionName: "Pregunta",
        newPanelName: "Panel",
        newTextItemName: "Texto",
        defaultV2Theme: "Predeterminado",
        modernTheme: "Moderno",
        defaultTheme: "Incumplimiento (heredado)",
        testSurveyAgain: "Encuesta de prueba de nuevo",
        testSurveyWidth: "Ancho de la encuesta:",
        navigateToMsg: "Tuviste que navegar a:",
        saveSurvey: "Guardar la encuesta",
        saveSurveyTooltip: "Guardar la encuesta",
        saveTheme: "Guardar tema",
        saveThemeTooltip: "Guardar tema",
        jsonHideErrors: "Ocultar errores",
        jsonShowErrors: "Mostrar errores",
        undo: "Deshacer",
        redo: "Rehacer",
        undoTooltip: "Deshacer el último cambio",
        redoTooltip: "Rehacer el cambio",
        showMoreChoices: "Mostrar más",
        showLessChoices: "Mostrar menos",
        copy: "Copiar",
        cut: "Cortar",
        paste: "Pegar",
        copyTooltip: "Copia selección al portapapeles",
        cutTooltip: "Corta la selección al portapapeles",
        pasteTooltip: "Pega de portapapeles",
        options: "Opciones",
        generateValidJSON: "Generar un JSON válido",
        generateReadableJSON: "Generar JSON legible",
        toolbox: "Caja de herramientas",
        "property-grid": "Propiedades",
        toolboxFilteredTextPlaceholder: "Escriba para buscar...",
        toolboxNoResultsFound: "No se han encontrado resultados",
        propertyGridFilteredTextPlaceholder: "Escribe para buscar...",
        propertyGridNoResultsFound: "No se han encontrado resultados",
        correctJSON: "Por favor, corrija JSON",
        surveyResults: "Resultado de la encuesta:",
        surveyResultsTable: "Como Tabla",
        surveyResultsJson: "Como JSON",
        resultsTitle: "Título de la pregunta",
        resultsName: "Nombre de la pregunta",
        resultsValue: "Valor de respuesta",
        resultsDisplayValue: "Valor de visualización",
        modified: "Modificada",
        saving: "Guardando",
        saved: "Guardado",
        propertyEditorError: "error:",
        saveError: "¡Error!El contenido del editor no se ha guardado",
        translationPropertyGridTitle: "Opciones de lenguaje",
        themePropertyGridTitle: "Configuración del tema",
        translationLanguages: "Lenguajes",
        translationDeleteLanguage: "¿Está seguro de que desea eliminar todas las cadenas de este idioma?",
        translationAddLanguage: "Seleccione el idioma para traducir",
        translationShowAllStrings: "Mostrar todos los textos",
        translationShowUsedStringsOnly: "Sólo textos utilizados",
        translationShowAllPages: "Mostrar todas las páginas",
        translationNoStrings: "Sin cuerdas para traducir. Por favor, cambie el filtro",
        translationExportToSCVButton: "Exportar a CSV",
        translationImportFromSCVButton: "Importación de CSV",
        translateUsigAI: "Traducir automáticamente todo",
        translateUsigAIFrom: "Traducir de: ",
        translationDialogTitle: "Cadenas sin traducir",
        translationMergeLocaleWithDefault: "Merge {0} con lugar predeterminado",
        translationPlaceHolder: "Traducción...",
        translationSource: "Fuente: ",
        translationTarget: "Blanco: ",
        themeExportButton: "Exportar",
        themeImportButton: "Importación",
        surveyJsonExportButton: "Exportar",
        surveyJsonImportButton: "Importación",
        surveyJsonCopyButton: "Copiar en el portapapeles",
        themeResetButton: "Restablecer la configuración predeterminada del tema",
        themeResetConfirmation: "¿Realmente quieres resetear el tema? Todas tus personalizaciones se perderán.",
        themeResetConfirmationOk: "Sí, restablece el tema",
        bold: "Negrita",
        italic: "Itálica",
        underline: "Subrayar",
        addNewQuestion: "Añadir pregunta",
        selectPage: "Seleccionar página ...",
        carryForwardChoicesCopied: "Las opciones se copian de",
        choicesLoadedFromWebText: "Las opciones se cargan desde un servicio web.",
        choicesLoadedFromWebLinkText: "Ir a la configuración",
        choicesLoadedFromWebPreviewTitle: "Vista previa de las opciones de elección cargadas",
        htmlPlaceHolder: "Contenido HTML irá aquí.",
        panelPlaceHolder: "Arrastra aquí una pregunta desde la caja de herramientas.",
        surveyPlaceHolder: "La encuesta está vacía. Arrastra una pregunta desde la caja de herramientas o haz click en el botón de abajo.",
        pagePlaceHolder: "La página está vacía. Arrastre un elemento desde la caja de herramientas o haga clic en el botón de abajo.",
        imagePlaceHolder: "Arrastre y suelte una imagen aquí o haga clic en el botón de abajo y elija una imagen para cargar",
        surveyPlaceHolderMobile: "Haga clic en el botón \"Agregar pregunta\" a continuación para comenzar a crear su formulario.",
        pagePlaceHolderMobile: "Haga clic en el botón \"Agregar pregunta\" a continuación para agregar un nuevo elemento a la página.",
        panelPlaceHolderMobile: "Haga clic en el botón \"Agregar pregunta\" a continuación para agregar un nuevo elemento al panel.",
        imagePlaceHolderMobile: "Haga clic en el botón de abajo y elija una imagen para cargar",
        imageChooseImage: "Elegir imagen",
        addNewTypeQuestion: "Añadir {0}",
        chooseLogoPlaceholder: "[LOGOTIPO]",
        choices_Item: "Artículo ",
        selectFile: "Seleccionar un archivo",
        removeFile: "Eliminar el archivo",
        lg: {
            addNewItem: "Añadir nueva regla",
            empty_tab: "Crea una regla para personalizar el flujo de la encuesta.",
            page_visibilityName: "Visibilidad de la pagina",
            page_enableName: "Habilitar (deshabilitar) página",
            page_requireName: "Hacer que la página sea obligatoria",
            panel_visibilityName: "Visibilidad del panel",
            panel_enableName: "Panel habilitar / deshabilitar",
            panel_requireName: "Hacer que la página sea obligatoria",
            question_visibilityName: "Pregunta visibilidad",
            question_enableName: "Pregunta habilitar / deshabilitar",
            question_requireName: "Pregunta opcional requerida",
            question_resetValueName: "Restablecer valor de pregunta",
            question_setValueName: "Establecer el valor de la pregunta",
            column_visibilityName: "Mostrar (ocultar) columna",
            column_enableName: "Habilitar (deshabilitar) columna",
            column_requireName: "Hacer columna requerida",
            column_resetValueName: "Restablecer valor de columna",
            column_setValueName: "Establecer el valor de la columna",
            trigger_completeName: "Encuesta completa",
            trigger_setvalueName: "Establecer valor de la pregunta",
            trigger_copyvalueName: "Copiar valor de la pregunta",
            trigger_skipName: "Saltar a la pregunta",
            trigger_runExpressionName: "Ejecutar la expresión personalizada",
            completedHtmlOnConditionName: "Texto personalizado 'Página de agradecimiento'",
            page_visibilityDescription: "Haga que la página sea visible cuando la expresión lógica vuelva verdadera. De lo contrario, manténgalo invisible",
            panel_visibilityDescription: "Haga que el panel sea visible cuando la expresión lógica vuelva verdadera. De lo contrario, manténgalo invisible",
            panel_enableDescription: "Haga el panel, y todos los elementos dentro de él, habiliten cuando la expresión lógica devuelve verdadero. De lo contrario, manténgalos deshabilitados",
            question_visibilityDescription: "Haz que la pregunta sea visible cuando la expresión lógica se devuelve 'verdadero'. De lo contrario, se mantiene invisible",
            question_enableDescription: "Haz que la pregunta se habilite cuando la expresión lógica devuelve 'verdadero'. De lo contrario, se mantiene deshabilitado",
            question_requireDescription: "La pregunta se requiere cuando la expresión lógica devuelve 'verdadero'",
            trigger_completeDescription: "Cuando la expresión lógica devuelve 'verdadero', la encuesta se completa y el usuario final ve la 'página de agradecimiento'",
            trigger_setvalueDescription: "Cuando se cambian los valores de las preguntas, que se usan en la expresión lógica, se cambian y la expresión lógica devuelve 'verdadero', entonces el valor se establece en la pregunta seleccionada",
            trigger_copyvalueDescription: "Cuando se cambian los valores de las preguntas, que se usan en la expresión lógica, se cambian y la expresión lógica devuelve 'verdadero', entonces el valor de una pregunta seleccionada se copia a otra pregunta seleccionada",
            trigger_skipDescription: "Cuando la expresión lógica devuelve 'verdadero', la encuesta salta a la pregunta seleccionada",
            trigger_runExpressionDescription: "Cuando la expresión lógica devuelve 'verdadero', entonces se realiza la expresión personalizada. Es posible que opcionalmente establezca este resultado de expresión en la pregunta seleccionada",
            completedHtmlOnConditionDescription: "Si la expresión lógica devuelve 'verdadero', entonces el texto predeterminado para la 'página de agradecimiento' se cambia por el texto dado",
            itemExpressionText: "Cuando la expresión: '{0}' devuelve VERDADERO:",
            itemEmptyExpressionText: "Nueva regla",
            page_visibilityText: "Hacer la página {0} Visible",
            panel_visibilityText: "Hacer panel {0} visible",
            panel_enableText: "Hacer panel {0} habilitar",
            question_visibilityText: "Hacer Pregunta {0} Visible",
            question_enableText: "Hacer Pregunta {0} Habilitar",
            question_requireText: "Hacer la pregunta {0} requerida",
            question_resetValueText: "Restablecer valor para la pregunta: {0}",
            question_setValueText: "Asignar valor: {1} a la pregunta: {0}",
            column_visibilityText: "hacer la columna {0} de la pregunta {1} visible",
            column_enableText: "hacer la columna {0} de la pregunta {1} activa",
            column_requireText: "hacer la columna {0} de la pregunta {1} requerida",
            column_resetValueText: "Restablecer el valor de celda de la columna: {0}",
            column_setValueText: "Asignar valor de celda: {1} a columna: {0}",
            setValueExpressionPlaceholder: " Una expresión cuyo resultado se asignará a la pregunta de destino.",
            trigger_completeText: "La encuesta se completa",
            trigger_setvalueText: "En cuestión: {0} valor {1}",
            trigger_setvalueEmptyText: "Valor de pregunta claro: {0}",
            trigger_copyvalueText: "Copiar en cuestión: {0} valor de la pregunta {1}",
            trigger_skipText: "Encuesta salta a la pregunta {0}",
            trigger_runExpressionText1: "Expresión de ejecución: '{0}'",
            trigger_runExpressionText2: "y establecer su resultado en cuestión: {0}",
            completedHtmlOnConditionText: "Mostrar texto personalizado para la 'gracias página'",
            showAllQuestions: "Todas las preguntas",
            showAllActionTypes: "Todos los tipos de acción",
            conditions: "Condición(es)",
            actions: "Comportamiento",
            expressionEditorTitle: "Definir la(s) condición(es)",
            actionsEditorTitle: "Definir la(s) acción(es)",
            deleteAction: "Eliminar acción",
            addNewAction: "Añadir nueva acción",
            selectedActionCaption: "Seleccione una acción para agregar ...",
            expressionInvalid: "La expresión lógica está vacía o inválida. Por favor corríjalo",
            noActionError: "Por favor, agregue al menos una acción",
            actionInvalid: "Por favor, solucione problemas en su(s) acción(es)",
            uncompletedRule_title: "Las reglas lógicas están incompletas",
            uncompletedRule_text: "No ha completado algunas de las reglas lógicas. Si deja la pestaña ahora, los cambios se perderán. ¿Aún desea salir de la pestaña sin completar los cambios?",
            uncompletedRule_apply: "Sí",
            uncompletedRule_cancel: "No, quiero completar las reglas"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Nombre del panel",
            title: "Título de la viñeta",
            description: "Descripción del panel",
            visibleIf: "Haga que el panel sea visible si",
            requiredIf: "Haga que el panel sea obligatorio si",
            questionsOrder: "Orden de las preguntas dentro del panel",
            page: "Página padre",
            startWithNewLine: "Mostrar el panel en una nueva línea",
            state: "Estado de contracción del panel",
            width: "Ancho del panel en línea",
            minWidth: "Anchura mínima del panel",
            maxWidth: "Anchura máxima del panel",
            showNumber: "Paneles numéricos"
        },
        paneldynamic: {
            name: "Nombre del panel",
            title: "Título de la viñeta",
            description: "Descripción del panel",
            visibleIf: "Haga que el panel sea visible si",
            requiredIf: "Haga que el panel sea obligatorio si",
            page: "Mover el panel a la página",
            startWithNewLine: "Mostrar el panel en una nueva línea",
            state: "Estado de contracción del panel",
            width: "Ancho del panel en línea",
            minWidth: "Anchura mínima del panel",
            maxWidth: "Anchura máxima del panel",
            confirmDelete: "Confirmar borrado de panel",
            templateDescription: "Patrón de descripción del panel",
            templateTitle: "Patrón de título de panel",
            noEntriesText: "Texto de panel vacío",
            templateTabTitle: "Patrón de título de tabulación",
            tabTitlePlaceholder: "Marcador de posición del título de la pestaña",
            templateVisibleIf: "Hacer visible un panel individual si",
            hideNumber: "Ocultar el número de panel",
            titleLocation: "Alineación del título del panel",
            descriptionLocation: "Alineación de la descripción del panel",
            templateTitleLocation: "Alineación del título de la pregunta",
            templateErrorLocation: "Alineación de mensajes de error",
            newPanelPosition: "Nueva ubicación del panel",
            keyName: "Evitar respuestas duplicadas en la siguiente pregunta"
        },
        question: {
            name: "Nombre de la pregunta",
            title: "Título de la pregunta",
            description: "Descripción de la pregunta",
            visibleIf: "Haz que la pregunta sea visible si",
            requiredIf: "Haga que la pregunta sea obligatoria si:",
            page: "Página padre",
            state: "Estado de contracción del cuadro de pregunta",
            hideNumber: "Ocultar el número de pregunta",
            titleLocation: "Alineación del título de la pregunta",
            descriptionLocation: "Alineación de la descripción de la pregunta",
            errorLocation: "Alineación de mensajes de error",
            indent: "Aumentar la sangría interior",
            width: "Ancho de la pregunta en línea",
            minWidth: "Ancho mínimo de la pregunta",
            maxWidth: "Ancho máximo de la pregunta",
            textUpdateMode: "Actualizar el valor del campo de entrada"
        },
        signaturepad: {
            signatureWidth: "Ancho del área de firma",
            signatureHeight: "Altura del área de firma",
            signatureAutoScaleEnabled: "Escalado automático del área de firma",
            showPlaceholder: "Mostrar el marcador de posición",
            placeholder: "Texto de marcador de posición",
            placeholderReadOnly: "Texto de marcador de posición en modo de solo lectura o vista previa",
            allowClear: "Mostrar el botón Borrar dentro del área de firma",
            penMinWidth: "Ancho mínimo del lápiz",
            penMaxWidth: "Ancho máximo del lápiz",
            penColor: "Color del trazo"
        },
        comment: {
            rows: "Altura del campo de entrada (en líneas)"
        },
        showQuestionNumbers: "Mostrar números de pregunta",
        questionStartIndex: "Índice de inicio de la pregunta (1, 2 o 'A', 'A')",
        expression: {
            name: "Nombre de la expresión",
            title: "Título de la expresión",
            description: "Descripción de la expresión",
            expression: "Expresión"
        },
        trigger: {
            expression: "Expresión"
        },
        calculatedvalue: {
            expression: "Expresión"
        },
        // survey templates
        survey: {
            title: "Título",
            description: "Descripción de la encuesta"
        },
        page: {
            name: "Nombre de la página",
            title: "Título",
            description: "Descripción de la página",
            visibleIf: "Hacer que la página sea visible si",
            requiredIf: "Haga que la página sea obligatoria si",
            maxTimeToFinish: "Tiempo límite para finalizar la página (en segundos)",
            questionsOrder: "Orden de las preguntas en la página"
        },
        matrixdropdowncolumn: {
            name: "Nombre de la columna",
            title: "Título de la columna",
            isUnique: "Evitar respuestas duplicadas",
            width: "Anchura de columna",
            minWidth: "Anchura mínima de columna",
            rows: "Altura del campo de entrada (en líneas)",
            visibleIf: "Haga que la columna sea visible si",
            requiredIf: "Haga que la columna sea obligatoria si",
            showInMultipleColumns: "Cada opción en una columna separada"
        },
        multipletextitem: {
            name: "Nombre",
            title: "Título"
        },
        masksettings: {
            saveMaskedValue: "Guardar el valor enmascarado en los resultados de la encuesta"
        },
        patternmask: {
            pattern: "Patrón de valores"
        },
        datetimemask: {
            min: "Valor mínimo",
            max: "Valor máximo"
        },
        numericmask: {
            allowNegativeValues: "Permitir valores negativos",
            thousandsSeparator: "Separador de millares",
            decimalSeparator: "Separador decimal",
            precision: "Precisión de valor",
            min: "Valor mínimo",
            max: "Valor máximo"
        },
        currencymask: {
            prefix: "Prefijo de moneda",
            suffix: "Sufijo de moneda"
        },
        imageHeight: "Altura de imagen",
        imageWidth: "Ancho de la imagen",
        valueName: "Nombre de valor",
        rateDescriptionLocation: "Alineación de etiquetas",
        size: "Tamaño de entrada (en caracteres)",
        cellErrorLocation: "Alineación de mensajes de error de celda",
        apply: "Solicitar",
        ok: "ok",
        save: "Guardar",
        clear: "Limpiar",
        saveTooltip: "Guardar",
        cancel: "Cancelar",
        set: "Poner",
        reset: "Reiniciar",
        change: "Cambiar",
        refresh: "Actualizar",
        close: "Cerrar",
        delete: "Borrar",
        add: "Agregar",
        addNew: "Añadir nuevo",
        addItem: "Haga clic para agregar un artículo ...",
        removeItem: "Haga click para eliminar el elemento...",
        dragItem: "Arrastra el elemento",
        addOther: "Otra",
        addSelectAll: "Seleccionar todo",
        addNone: "Ninguna",
        removeAll: "Eliminar todo",
        edit: "Editar",
        back: "Volver sin guardar",
        backTooltip: "Volver sin guardar",
        saveAndBack: "Guardar y volver",
        saveAndBackTooltip: "Guardar y volver",
        doneEditing: "Hecho",
        editChoices: "Editar opciones",
        showChoices: "Mostrar opciones",
        move: "Moverse",
        empty: "<vaciar>",
        emptyValue: "El valor está vacío",
        fastEntry: "Entrada rápida",
        fastEntryNonUniqueError: "Valor '{0}' no es único",
        fastEntryChoicesCountError: "Por favor, limita el númeror de elementos de {0} a {1}",
        fastEntryChoicesMinCountError: "Introduce al menos {0} artículos",
        fastEntryPlaceholder: "Puedes introducir datos en el siguiente formato:\nvalue1|text\nvalue2",
        formEntry: "Entrada de forma",
        testService: "Probar el servicio",
        itemSelectorEmpty: "Por favor seleccione el elemento",
        conditionActionEmpty: "Por favor seleccione la acción",
        conditionSelectQuestion: "Seleccionar pregunta ...",
        conditionSelectPage: "Seleccionar página ...",
        conditionSelectPanel: "Seleccionar panel ...",
        conditionValueQuestionTitle: "Por favor ingrese / seleccione el valor",
        aceEditorHelp: "Presione CTRL + ESPACIO para obtener sugerencia de completar la expresión",
        aceEditorRowTitle: "Fila actual",
        aceEditorPanelTitle: "Panel actual",
        showMore: "Para más detalles, por favor revise la documentación",
        assistantTitle: "Preguntas disponibles:",
        cellsEmptyRowsColumns: "Debe haber al menos una columna o fila",
        showPreviewBeforeComplete: "Previsualizar respuestas entes de enviar la encuesta",
        overridingPropertyPrefix: "Establecido por ",
        resetToDefaultCaption: "Restablecimiento",
        propertyIsEmpty: "Porfavor introduzca un valor",
        propertyIsNoUnique: "Por favor ingrese un valor único",
        propertyNameIsNotUnique: "Por favor ingrese un nombre único",
        propertyNameIsIncorrect: "No utilice palabras reservadas: \"elemento\", \"elección\", \"panel\", \"fila\".",
        listIsEmpty: "Añadir un nuevo artículo",
        "listIsEmpty@choices": "No se han añadido opciones todavía",
        "listIsEmpty@columns": "Todavía no tienes ninguna columna",
        "listIsEmpty@rows": "Todavía no tienes ninguna fila",
        "listIsEmpty@validators": "Todavía no tiene ninguna regla de validación",
        "listIsEmpty@calculatedValues": "Todavía no tiene ninguna variable personalizada",
        "listIsEmpty@triggers": "Todavía no tienes ningún desencadenante",
        "listIsEmpty@navigateToUrlOnCondition": "Todavía no tienes ningún enlace",
        "addNew@choices": "Añade una opción",
        "addNew@columns": "Agregar nueva columna",
        "addNew@rows": "Agregar nueva fila",
        "addNew@validators": "Agregar nueva regla",
        "addNew@calculatedValues": "Adición de una nueva variable",
        "addNew@triggers": "Agregar nuevo disparador",
        "addNew@navigateToUrlOnCondition": "Agregar nueva URL",
        expressionIsEmpty: "La expresión está vacía",
        value: "Valor",
        text: "Texto",
        rowid: "ID de fila",
        imageLink: "Enlace de imágen",
        columnEdit: "Editar columna: {0}",
        itemEdit: "Editar artículo: {0}",
        url: "URL",
        path: "Camino",
        choicesbyurl: {
            url: "URL del servicio web",
            valueName: "Obtener valores del siguiente campo JSON"
        },
        titleName: "Nombre del título",
        imageLinkName: "Obtener URLs de imagen desde el siguiente campo JSON",
        allowEmptyResponse: "Permitir respuestas vacías",
        titlePlaceholder: "Título de entrada aquí",
        surveyTitlePlaceholder: "Título de la encuesta de entrada aquí",
        pageTitlePlaceholder: "Título de la página de entrada aquí",
        descriptionPlaceholder: "Ingrese una descripción",
        surveyDescriptionPlaceholder: "Ingrese una descripción de la encuesta",
        pageDescriptionPlaceholder: "Ingrese una descripción de la página",
        textWrapEnabled: "Opciones de envoltura",
        showOtherItem: "Tiene opción 'Otro'",
        otherText: "Cambiar texto 'Otro'",
        showNoneItem: "Tiene opcion 'Ninguno'",
        showRefuseItem: "Permitir la opción Negarse a responder",
        showDontKnowItem: "Permitir la opción No sé",
        noneText: "Cambiar texto 'Ninguno'",
        showSelectAllItem: "Tiene opción 'Selecionar todo'",
        selectAllText: "Cambiar texto de 'Seleccionar todo'",
        choicesMin: "Valor mínimo para artículos generados automáticos",
        choicesMax: "Valor máximo para artículos generados automáticos",
        choicesStep: "La diferencia entre los artículos generados automáticos",
        name: "Nombre",
        title: "Título",
        cellType: "Tipo de célula",
        colCount: "Recuento de columnas",
        choicesOrder: "Seleccione el orden de las opciones",
        visible: "¿Es visible?",
        isRequired: "¿Se requiere?",
        markRequired: "Marcar según sea necesario",
        removeRequiredMark: "Quitar la marca requerida",
        isAllRowRequired: "Requerir respuesta para todas las filas",
        eachRowUnique: "Evitar respuestas duplicadas en filas",
        requiredErrorText: "Texto de error requerido",
        startWithNewLine: "¿Empieza con la nueva línea?",
        rows: "Número de filas",
        cols: "Recuento de columnas",
        placeholder: "Placeholder de entrada",
        showPreview: "Mostrar área de vista previa",
        storeDataAsText: "Tienda el contenido del archivo en el resultado de JSON como texto",
        maxSize: "Tamaño máximo de archivo en bytes",
        rowCount: "Número de filas",
        columnLayout: "Diseño de columnas",
        addRowLocation: "Añadir la ubicación del botón de la fila",
        transposeData: "Transponer filas a columnas",
        addRowText: "Añadir texto de botón de fila",
        removeRowText: "Eliminar el texto del botón de fila",
        rateMin: "Valor mínimo",
        rateMax: "Valor máximo",
        rateStep: "Rango de los valores",
        minRateDescription: "Descripción del valor mínimo",
        maxRateDescription: "Descripción del valor máximo",
        inputType: "Tipo de entrada",
        optionsCaption: "Cambie texto de 'Seleccione'",
        defaultValue: "Valor por defecto",
        cellsDefaultRow: "Textos de celdas predeterminados",
        surveyEditorTitle: "Editar configuración de encuesta",
        qEditorTitle: "Editar: {0}",
        maxLength: "Longitud máxima",
        buildExpression: "Construir",
        editExpression: "Editar",
        and: "y",
        or: "o",
        remove: "Eliminar",
        addCondition: "Añadir condición",
        emptyLogicPopupMessage: "Selecciona una pegunta para epezar a configurar condiciones.",
        if: "Si",
        then: "entonces",
        setToName: "Pregunta target",
        fromName: "Pregunta desde la que copiar su respuesta",
        gotoName: "Pregunta a la que saltar",
        ruleIsNotSet: "La regla no es correcta",
        includeIntoResult: "Incluir en los resultados de la encuesta",
        showTitle: "Mostrar / Ocultar Título",
        expandCollapseTitle: "Expandir / Contraer título",
        locale: "Idioma predeterminado",
        simulator: "Elige dispositivo",
        landscapeOrientation: "Orientación horizontal ",
        portraitOrientation: "Cambiar a orientatión retrato",
        mode: "Modo (editar / leer solamente)",
        clearInvisibleValues: "Claros valores invisibles",
        cookieName: "Nombre de la cookie (para deshabilitar la encuesta de ejecución dos veces localmente)",
        sendResultOnPageNext: "Enviar resultados de encuestas en la página Siguiente",
        storeOthersAsComment: "Almacenar 'Otros' valor en campo separado",
        showPageTitles: "Mostrar descripción de la página",
        showPageNumbers: "Mostrar números de página",
        pagePrevText: "Página de texto del botón anterior",
        pageNextText: "Página Siguiente botón de texto",
        completeText: "Texto completo del botón",
        previewText: "Vista previa del botón del botón",
        editText: "Editar botón de texto",
        startSurveyText: "Texto de inicio de la encuesta",
        showNavigationButtons: "Mostrar botones de navegación (navegación predeterminada)",
        showPrevButton: "Mostrar botón anterior (el usuario puede volver a la página anterior)",
        firstPageIsStarted: "La primera página en la encuesta es una página iniciada",
        showCompletedPage: "Mostrar la página completa al final (HTML finalizado)",
        goNextPageAutomatic: "Al responder todas las preguntas, vaya a la página siguiente automáticamente",
        allowCompleteSurveyAutomatic: "Completar la encuesta automáticamente",
        showProgressBar: "Mostrar barra de progreso",
        questionTitleLocation: "Ubicación del título de la pregunta",
        questionTitleWidth: "Ancho del título de la pregunta",
        requiredText: "La pregunta requerida (s) símbolo (s)",
        questionTitleTemplate: "Plantilla de título de la pregunta, el valor predeterminado es: '{no}.{requiere} {título} '",
        questionErrorLocation: "Ubicación de error de la pregunta",
        focusFirstQuestionAutomatic: "Enfoca la primera pregunta al cambiar la página",
        questionsOrder: "Orden de elementos en la página",
        maxTimeToFinish: "Tiempo máximo para terminar la encuesta",
        maxTimeToFinishPage: "Tiempo máximo para terminar una página en la encuesta",
        showTimerPanel: "Mostrar panel de temporizador",
        showTimerPanelMode: "Mostrar modo de panel del temporizador",
        renderMode: "Modo de renderizado",
        allowAddPanel: "Permitir agregar un panel",
        allowRemovePanel: "Permitir eliminar el panel",
        panelAddText: "Añadiendo texto del panel",
        panelRemoveText: "Eliminar texto del panel",
        isSinglePage: "Mostrar todos los elementos en una página",
        html: "Html",
        setValue: "Respuesta",
        dataFormat: "Formato imagen",
        allowAddRows: "Permitir añadir filas",
        allowRemoveRows: "Permitir eliminar filas",
        allowRowsDragAndDrop: "Permitor drag and drop de filas",
        responsiveImageSizeHelp: "No aplica si especificas el ancho o alto exacto de la imagen.",
        minImageWidth: "Ancho de imagen mínimo",
        maxImageWidth: "Ancho de imagen máximo",
        minImageHeight: "Alto de imagen mínimo",
        maxImageHeight: "Alto de imagen máximo",
        minValue: "Valor mínimo",
        maxValue: "Valor máximo",
        minLength: "Longitud mínima",
        allowDigits: "Permitir dígitos",
        minCount: "Cantidad mínima",
        maxCount: "Cantidad máxima",
        regex: "Expresión regular",
        surveyvalidator: {
            text: "Mensaje de error",
            expression: "Validación de expresión"
        },
        totalText: "Texto total",
        totalType: "Tipo total",
        totalExpression: "Expresión total",
        totalDisplayStyle: "Estilo de visualización total",
        totalCurrency: "Moneda total",
        totalFormat: "Formato total",
        logo: "Logo (URL o cadene codificada en base64)",
        questionsOnPageMode: "Estructura de la encuesta",
        maxTextLength: "Longitud máxima de la respuesta (en caracteres)",
        maxOthersLength: "Longitud máxima de comentario (en caracteres)",
        commentAreaRows: "Altura del área de comentarios (en líneas)",
        autoGrowComment: "Auto-expand de comentario si es necesario",
        allowResizeComment: "Permitir a los usuarios cambiar el tamaño de las áreas de texto",
        textUpdateMode: "Actualizar valor del texto de la pregunta",
        maskType: "Tipo de máscara de entrada",
        maskTypes: {
            none: "Ninguno",
            patternmask: "Patrón",
            numericmask: "Numérico",
            datetimemask: "Fecha y hora",
            currencymask: "Divisa"
        },
        focusOnFirstError: "Fijar foco en la primera respuesta no válida",
        checkErrorsMode: "Ejecutar validación",
        navigateToUrl: "Navegar a URL",
        navigateToUrlOnCondition: "URL dinámica",
        completedBeforeHtml: "Markup para mostrar si el usuario ya completó la encuesta",
        completedHtml: "Markup de página de encuesta completada",
        completedHtmlOnCondition: "Markup de página de encuesta dinámica completada",
        loadingHtml: "Markup para mostrar mienstras que la encuesta se está cargando",
        commentText: "Area de texto de comentario",
        autocomplete: "Tipo autocompletado",
        labelTrue: "Etiqueta \"Verdadero\"",
        labelFalse: "Etiqueta \"Falso\"",
        allowClear: "Mostrar el botón limpiar",
        searchMode: "Modo de búsqueda",
        displayStyle: "Estilo de visualización del valor",
        format: "Cadena formateada",
        maximumFractionDigits: "Número máximo de dígitos de fracción",
        minimumFractionDigits: "Número mínimo de dígitos de fracción",
        useGrouping: "Mostrar seperadores de agrupación",
        allowMultiple: "Permitir múltiples ficheros",
        allowImagesPreview: "Previsualizar imágenes",
        acceptedTypes: "Tipos de fichero aceptados",
        waitForUpload: "Espera a que se complete la carga",
        needConfirmRemoveFile: "Confirmar borrado de fichero",
        detailPanelMode: "Localización del panel de detalle",
        minRowCount: "Mínimo número de filas",
        maxRowCount: "Máximo número de filas",
        confirmDelete: "Confirmar borrado de fila",
        confirmDeleteText: "Mensaje de confirmación",
        panelCount: "Número incial de panel",
        minPanelCount: "Número mínimo de paneles",
        maxPanelCount: "Número máximo de paneles",
        panelsState: "Estado de expansión del panel interno",
        panelPrevText: "Tooltip del botón de panel previo",
        panelNextText: "Tooltip del botón de siguiente panel",
        showRangeInProgress: "Mostrar barra de progreso",
        panelRemoveButtonLocation: "Localización del botón eliminar panel",
        hideIfRowsEmpty: "Ocultar pregunta si no hay más filas",
        hideColumnsIfEmpty: "Ocultar columnas si no hay filas",
        rateValues: "Valores de tarifa personalizados",
        rateCount: "Recuento de tarifas",
        autoGenerate: "¿Cómo especificar valores de tasa?",
        hideIfChoicesEmpty: "Ocultar la pregunta si no contiene opciones",
        minWidth: "Anchura mímima (en valores aceptados CSS)",
        maxWidth: "Anchura máxima (en valores aceptados CSS)",
        width: "Ancho (en valores aceptados CSS)",
        showHeader: "Mostrar cabeceras de columna",
        horizontalScroll: "Mostrar scrollbar horizontal",
        columnMinWidth: "Anchura mímima de columna (en valores aceptados CSS)",
        rowTitleWidth: "Anchura de cabecera de fila (en valores aceptados CSS)",
        valueTrue: "Valor \"verdadero\"",
        valueFalse: "Valor \"falso\"",
        minErrorText: "Mensaje de error \"El valor está por debajo del mínimo\"",
        maxErrorText: "Mensaje de error \"El valor supera el máximo\"",
        otherErrorText: "Mensaje de error \"Comentario vacío\"",
        keyDuplicationError: "Mensaje de error \"Valor de clave no único\"",
        minSelectedChoices: "Opciones mínimas seleccionadas",
        maxSelectedChoices: "Número máximo de opciones seleccionadas",
        showClearButton: "Mostrar el botón Limpiar",
        logoWidth: "Ancho de Logo (en valores aceptados CSS)",
        logoHeight: "Alto de Logo (en valores aceptados CSS)",
        readOnly: "Sólo-lectura",
        enableIf: "Editable si",
        emptyRowsText: "Mensaje \"Sin filas\"",
        separateSpecialChoices: "Opciones de separación especiales (None, Other, Select All)",
        choicesFromQuestion: "Copiar opciones de la siguiente pregunta",
        choicesFromQuestionMode: "Qué opciones a copiar?",
        progressBarShowPageTitles: "Mostrar los títulos de las páginas en la barra de progreso",
        progressBarShowPageNumbers: "Mostrar números de página en la barra de progreso",
        showCommentArea: "Mostrar el área de comentarios",
        commentPlaceholder: "Marcador de posición del área de comentarios",
        displayRateDescriptionsAsExtremeItems: "Mostrar descripciones de velocidad como valores extremos",
        rowsOrder: "Orden de filas",
        columnsLayout: "Disposición de columnas",
        columnColCount: "Número de columnas anidadas",
        correctAnswer: "Respuesta correcta",
        defaultPanelValue: "Valores por defecto",
        cells: "Textos de celda",
        fileInputPlaceholder: "Seleccione un archivo o pegue un enlace de archivo...",
        keyName: "Columna clave",
        itemvalue: {
            visibleIf: "Haga que la opción sea visible si",
            enableIf: "Haga que la opción sea seleccionable si"
        },
        "itemvalue@rows": {
            visibleIf: "Haga que la fila sea visible si",
            enableIf: "Hacer que la fila sea editable si"
        },
        imageitemvalue: {
            text: "Texto alternativo"
        },
        logoPosition: "Posición del logotipo",
        addLogo: "Añadir logo ...",
        changeLogo: "Cambiar logo ...",
        logoPositions: {
            none: "Eliminar logo",
            left: "Izquierda",
            right: "Derecha",
            top: "En la parte superior",
            bottom: "En la parte inferior"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Diseño de paneles"
            },
            general: "General",
            fileOptions: "Opciones",
            html: "Editor HTML",
            columns: "Columnas",
            rows: "Filas",
            choices: "Opciones",
            items: "Artículos",
            visibleIf: "Visible si",
            enableIf: "Habilitar si",
            requiredIf: "Requerido si",
            rateValues: "Valores de la tasa",
            choicesByUrl: "Opciones de la web",
            matrixChoices: "Opciones predeterminadas",
            multipleTextItems: "Entradas de texto",
            numbering: "Numeración",
            validators: "Validadores",
            navigation: "Navegación",
            question: "Pregunta",
            pages: "Páginas",
            timer: "Horas / cuestionario",
            calculatedValues: "Valores calculados",
            triggers: "Disparadores",
            templateTitle: "Título de la plantilla",
            totals: "Totales",
            logic: "Lógica",
            mask: "Configuración de la máscara de entrada",
            layout: {
                panel: "Diseño",
                question: "Diseño",
                base: "Diseño"
            },
            data: "Datos",
            validation: "Validación",
            cells: "Células",
            showOnCompleted: "Mostrar en completado",
            logo: "Logo en el título de la encuesta",
            slider: "Slider",
            expression: "Expresión",
            questionSettings: "Configuración de la pregunta",
            header: "Encabezado",
            background: "Fondo",
            appearance: "Apariencia",
            others: "Otras"
        },
        editProperty: "Editar propiedad '{0}'",
        items: "[Artículos: {0}]",
        choicesVisibleIf: "Opciones son visibles si",
        choicesEnableIf: "Opciones son seleccionables si",
        columnsEnableIf: "Columnas son visibles si",
        rowsEnableIf: "Filas son visibles si",
        innerIndent: "Añadir indents internos",
        defaultValueFromLastRow: "Tomar valores por defecto de la última fila",
        defaultValueFromLastPanel: "Tomar valores por defecto del último panel",
        enterNewValue: "Por favor, ingrese el valor",
        noquestions: "No hay ninguna pregunta en la encuesta",
        createtrigger: "Por favor crea un gatillo",
        titleKeyboardAdornerTip: "Presione el botón Entrar para editar",
        keyboardAdornerTip: "Presione el botón Entrar para editar el elemento, presione el botón Eliminar para eliminar el elemento, presione ALT Plus Flecha hacia arriba o hacia abajo para mover el elemento",
        triggerOn: "En",
        triggerMakePagesVisible: "Hacer visibles las páginas:",
        triggerMakeQuestionsVisible: "Hacer elementos visibles:",
        triggerCompleteText: "Completa la encuesta si tiene éxito",
        triggerNotSet: "El gatillo no se establece",
        triggerRunIf: "Correr si",
        triggerSetToName: "Cambio de valor de:",
        triggerFromName: "Copie el valor de:",
        triggerRunExpression: "Ejecute esta expresión:",
        triggerSetValue: "a:",
        triggerGotoName: "Ir a la pregunta:",
        triggerIsVariable: "No coloque la variable en el resultado de la encuesta",
        triggerRunExpressionEmpty: "Por favor ingrese una expresión válida",
        emptyExpressionPlaceHolder: "Escribir expresión aquí...",
        noFile: "Ningún archivo elegido",
        clearIfInvisible: "Limpiar el valor si la pregunta se oculta",
        valuePropertyName: "Valor del nombre de propiedad",
        searchEnabled: "Habilitar búsqueda",
        hideSelectedItems: "Ocultar elementos seleccionados",
        closeOnSelect: "Cierre el menú desplegable después de la selección",
        verticalAlign: "Alineación vertical",
        alternateRows: "Alternar filas",
        columnsVisibleIf: "Columnas son visibles si",
        rowsVisibleIf: "Filas son visibes si",
        otherPlaceholder: "Marcador de posición del área de comentarios",
        filePlaceholder: "Texto del marcador de posición del archivo",
        photoPlaceholder: "Texto del marcador de posición de la foto",
        fileOrPhotoPlaceholder: "Texto de marcador de posición de archivo o foto",
        rateType: "Tipo de tarifa",
        url_placeholder: "Ej.: https://api.example.com/books",
        path_placeholder: "Ej.: categories.fiction",
        questionStartIndex_placeholder: "Ej.: a)",
        width_placeholder: "Ej.: 6 pulgadas",
        minWidth_placeholder: "Ej.: 600px",
        maxWidth_placeholder: "Ej.: 50%",
        imageHeight_placeholder: "Automático",
        imageWidth_placeholder: "Automático",
        theme: {
            themeName: "Tema",
            isPanelless: "Apariencia de la pregunta",
            editorPanel: "Fondo y radio de vértice",
            questionPanel: "Fondo y radio de vértice",
            primaryColor: "Color de acento",
            panelBackgroundTransparency: "Opacidad del fondo del panel",
            questionBackgroundTransparency: "Opacidad del fondo de la pregunta",
            fontSize: "Tamaño de fuente",
            scale: "Escama",
            cornerRadius: "Radio de esquina",
            pageTitle: "Fuente del título",
            pageDescription: "Fuente descriptiva",
            questionTitle: "Fuente del título",
            questionDescription: "Fuente descriptiva",
            editorFont: "Fuente",
            backgroundOpacity: "Opacidad",
            "--sjs-font-family": "Familia tipográfica",
            "--sjs-general-backcolor-dim": "Color de fondo",
            "--sjs-primary-backcolor": "Fondo de acento",
            "--sjs-primary-forecolor": "Acento en primer plano",
            "--sjs-special-red": "Mensajes de error",
            "--sjs-shadow-small": "Efectos de sombra",
            "--sjs-shadow-inner": "Efectos de sombra",
            "--sjs-border-default": "Colores"
        },
        "header@header": {
            headerView: "Vista",
            logoPosition: "Posición del logotipo",
            surveyTitle: "Fuente del título de la encuesta",
            surveyDescription: "Fuente de descripción de la encuesta",
            headerTitle: "Fuente del título de la encuesta",
            headerDescription: "Fuente de descripción de la encuesta",
            inheritWidthFrom: "Ancho del área de contenido",
            textAreaWidth: "Ancho del texto",
            backgroundColorSwitch: "Color de fondo",
            backgroundImage: "Imagen de fondo",
            backgroundImageOpacity: "Opacidad",
            overlapEnabled: "Solapar",
            logoPositionX: "Posición del logotipo",
            titlePositionX: "Posición en el título",
            descriptionPositionX: "Descripción posición"
        }
    },
    // Property values
    pv: {
        "true": "verdadero",
        "false": "falso",
        file: "Archivos locales",
        camera: "Cámara",
        "file-camera": "Archivos locales o cámara",
        inherit: "heredar",
        show: "mostrar",
        hide: "esconder",
        default: "defecto",
        initial: "inicial",
        random: "aleatoria",
        collapsed: "colapsada",
        expanded: "expandida",
        none: "ninguna",
        asc: "ascendente",
        desc: "descendiendo",
        indeterminate: "indeterminada",
        selected: "Seleccionado",
        unselected: "Sin seleccionar",
        decimal: "decimal",
        currency: "divisa",
        percent: "porcentaje",
        firstExpanded: "Primer Expandido",
        off: "no mostrar",
        list: "lista",
        progressTop: "Progreso superior",
        progressBottom: "Progreso inferior",
        progressTopBottom: "Progreso inferior/superior",
        tab: "Pestañas",
        horizontal: "horizontal",
        vertical: "vertical",
        top: "arriba",
        bottom: "abajo",
        topBottom: "arriba y abajo",
        both: "ambas",
        left: "izquierda",
        right: "Derecha",
        center: "Centro",
        leftRight: "Izquierda y derecha",
        middle: "Medio",
        color: "Color",
        date: "fecha",
        datetime: "fecha hora",
        "datetime-local": "fecha hora-local",
        email: "Correo electrónico",
        month: "mes",
        number: "número",
        password: "contraseña",
        range: "rango",
        tel: "Tel",
        text: "texto",
        time: "hora",
        url: "URL",
        week: "semana",
        hidden: "oculta",
        edit: "editar",
        display: "mostrar",
        contain: "Contener",
        cover: "Cubrir",
        fill: "Llenar",
        next: "Próximo",
        last: "Último",
        onComplete: "Al completarse",
        onHidden: "Al ocultarse",
        onHiddenContainer: "Cuando la pregunta o su panel/página se oculta",
        clearInvisibleValues: {
            none: "Nunca"
        },
        clearIfInvisible: {
            none: "Nunca"
        },
        inputType: {
            color: "Color",
            date: "Fecha",
            "datetime-local": "Fecha y hora",
            email: "Correo electrónico",
            month: "Mes",
            number: "Número",
            password: "Contraseña",
            range: "Gama",
            tel: "Número de teléfono",
            text: "Mensaje de texto",
            time: "Hora",
            url: "URL",
            week: "Semana"
        },
        all: "todas",
        page: "página",
        survey: "encuesta",
        onNextPage: "Al cambiar página",
        onValueChanged: "Al cambiar valor",
        onValueChanging: "Antes de que una pregunta sea cambiada",
        questionsOnPageMode: {
            standard: "Estructura original",
            singlePage: "Mostrar todas las preguntas en una sola página",
            questionPerPage: "Mostrar una sola pregunta por página"
        },
        noPreview: "sin vista previa",
        showAllQuestions: "Mostrar vista previa con todas las preguntas",
        showAnsweredQuestions: "Mostrar vista previa con preguntas contestadas",
        pages: "páginas",
        questions: "preguntas",
        requiredQuestions: "preguntas requeridas",
        correctQuestions: "preguntas correctas",
        buttons: "botones",
        underInput: "debajo de la respuesta",
        underTitle: "debajo del título",
        onBlur: "En desenfoque",
        onTyping: "Mientras se escribe",
        underRow: "Debajo de la fila",
        underRowSingle: "Debajo de la fila, sólo un panel es visible",
        auto: "Automático",
        showNavigationButtons: {
            none: "Oculto"
        },
        showTimerPanel: {
            none: "Oculto"
        },
        showTimerPanelMode: {
            all: "Ambos"
        },
        addRowLocation: {
            default: "Depende de la disposición de la matriz"
        },
        panelsState: {
            default: "Usuarios no pueden expandir o colapsar paneles",
            collapsed: "Todos los paneles colapsados",
            expanded: "Todos los paneles expandidos",
            firstExpanded: "Primera expansión"
        },
        widthMode: {
            static: "Estático",
            responsive: "Sensible"
        },
        contentMode: {
            image: "Imagen",
            video: "Vídeo",
            youtube: "YouTube (en inglés)"
        },
        displayMode: {
            buttons: "Botomes",
            dropdown: "Menú desplegable"
        },
        rateColorMode: {
            default: "Predeterminado",
            scale: "Escama"
        },
        scaleColorMode: {
            monochrome: "Monocromo",
            colored: "Coloreado"
        },
        autoGenerate: {
            "true": "Generar",
            "false": "Entrar manualmente"
        },
        rateType: {
            labels: "Etiquetas",
            stars: "Estrellas",
            smileys: "Emoticonos"
        },
        state: {
            default: "Cerrado con llave"
        },
        showQuestionNumbers: {
            default: "Numeración automática",
            on: "Numeración automática",
            onPage: "Restablecer en cada página",
            onpanel: "Restablecer en cada panel",
            onPanel: "Restablecer en cada panel",
            onSurvey: "Continuar a través de la encuesta",
            off: "Sin numeración"
        },
        descriptionLocation: {
            underTitle: "Bajo el título de la pregunta",
            underInput: "En el campo de entrada"
        },
        selectToRankAreasLayout: {
            horizontal: "Junto a las opciones",
            vertical: "Opciones anteriores"
        },
        displayStyle: {
            decimal: "Decimal",
            currency: "Divisa",
            percent: "Porcentaje",
            date: "Fecha"
        },
        totalDisplayStyle: {
            decimal: "Decimal",
            currency: "Divisa",
            percent: "Porcentaje",
            date: "Fecha"
        },
        rowsOrder: {
            initial: "Texto original en"
        },
        questionsOrder: {
            initial: "Texto original en"
        },
        showProgressBar: {
            off: "Oculto",
            topbottom: "arriba y abajo",
            aboveheader: "Encima del encabezado",
            belowheader: "Debajo del encabezado"
        },
        sum: "Suma",
        count: "Contar",
        min: "Min",
        max: "Máximo",
        avg: "Avg",
        searchMode: {
            contains: "Contiene",
            startsWith: "Comienza con"
        },
        backgroundImageFit: {
            auto: "Automático",
            cover: "Cubrir",
            contain: "Contener",
            fill: "Elasticidad",
            tile: "Teja"
        },
        backgroundImageAttachment: {
            fixed: "Fijo",
            scroll: "Pergamino"
        },
        headerView: {
            basic: "Básico",
            advanced: "Avanzado"
        },
        inheritWidthFrom: {
            survey: "Igual que la encuesta",
            container: "Ajuste al contenedor"
        },
        backgroundColorSwitch: {
            none: "Ninguno",
            accentColor: "Color de acento",
            custom: "Costumbre"
        },
        colorPalette: {
            light: "Luz",
            dark: "Oscuro"
        },
        isPanelless: {
            "false": "Predeterminado",
            "true": "Sin paneles"
        }
    },
    // Operators
    op: {
        empty: "esta vacio",
        notempty: "no está vacío",
        equal: "es igual a",
        notequal: "no es igual a",
        contains: "contiene",
        notcontains: "no contiene",
        anyof: "cualquiera de",
        allof: "todo",
        greater: "mayor que",
        less: "menos",
        greaterorequal: "Mayor o igual",
        lessorequal: "Menos o iguales",
        and: "y",
        or: "o"
    },
    // Embed window
    ew: {
        angular: "Usar la versión angular",
        jquery: "Usa la versión jQuery",
        knockout: "Usa la versión Knockout",
        react: "Use la versión de reacción",
        vue: "Usa la versión VUE",
        bootstrap: "Para marco de bootstrap",
        modern: "Tema moderno",
        default: "Tema predeterminado",
        orange: "Tema naranja",
        darkblue: "Tema DarkBlue",
        darkrose: "Tema de Darkrose",
        stone: "Tema de piedra",
        winter: "Tema de invierno",
        winterstone: "Tema de piedra de invierno",
        showOnPage: "Mostrar encuesta en una página",
        showInWindow: "Mostrar encuesta en una ventana",
        loadFromServer: "Encuesta de carga JSON del servidor",
        titleScript: "Scripts y estilos",
        titleHtml: "Html",
        titleJavaScript: "Javascript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Seleccione la página para probarlo:",
        showInvisibleElements: "Mostrar elementos invisibles",
        hideInvisibleElements: "Ocultar elementos invisibles"
    },
    validators: {
        answercountvalidator: "Cantidad de respuestas",
        emailvalidator: "Email",
        expressionvalidator: "expresión",
        numericvalidator: "numérica",
        regexvalidator: "regex",
        textvalidator: "texto"
    },
    triggers: {
        completetrigger: "encuesta completa",
        setvaluetrigger: "valor ajustado",
        copyvaluetrigger: "Valor de copia",
        skiptrigger: "Saltar a la pregunta",
        runexpressiontrigger: "expresión de ejecución",
        visibletrigger: "Cambiar visibilidad"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Ej.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Ej.: mm/dd/aaaa"
        },
        currencymask: {
            prefix: "Ej.: $",
            suffix: "Ej.: USD"
        },
        panelbase: {
            questionTitleWidth: "Ej.: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "Un ID de panel que no es visible para los encuestados.",
            description: "Escriba un subtítulo de panel.",
            visibleIf: "Utilice el icono de la varita mágica para establecer una regla condicional que determine la visibilidad del panel.",
            enableIf: "Utilice el icono de la varita mágica para establecer una regla condicional que desactive el modo de solo lectura para el panel.",
            requiredIf: "Utilice el icono de la varita mágica para establecer una regla condicional que impida el envío de encuestas a menos que al menos una pregunta anidada tenga una respuesta.",
            questionTitleLocation: "Se aplica a todas las preguntas de este panel. Si desea anular esta configuración, defina reglas de alineación de títulos para preguntas individuales. La opción \"Heredar\" aplica la configuración a nivel de página (si está establecida) o a nivel de encuesta (\"Superior\" de forma predeterminada).",
            questionTitleWidth: "Establece un ancho coherente para los títulos de las preguntas cuando están alineados a la izquierda de sus cuadros de preguntas. Acepta valores CSS (px, %, in, pt, etc.).",
            questionErrorLocation: "Establece la ubicación de un mensaje de error en relación con todas las preguntas del panel. La opción \"Heredar\" aplica la configuración a nivel de página (si se establece) o a nivel de encuesta.",
            questionsOrder: "Mantiene el orden original de las preguntas o las aleatoriza. La opción \"Heredar\" aplica la configuración a nivel de página (si se establece) o a nivel de encuesta.",
            page: "Cambia la posición del panel al final de una página seleccionada.",
            innerIndent: "Añade espacio o margen entre el contenido del panel y el borde izquierdo del cuadro del panel.",
            startWithNewLine: "Anule la selección para mostrar el panel en una línea con la pregunta o el panel anterior. La configuración no se aplica si el panel es el primer elemento del formulario.",
            state: "Elija entre: \"Expandido\": el panel se muestra en su totalidad y se puede contraer; \"Contraído\": el panel muestra solo el título y la descripción y se puede expandir; \"Bloqueado\": el panel se muestra en su totalidad y no se puede contraer.",
            width: "Define la anchura del panel en proporción a otros elementos topográficos de la misma línea. Acepta valores CSS (px, %, in, pt, etc.)."
        },
        paneldynamic: {
            name: "Un ID de panel que no es visible para los encuestados.",
            description: "Escriba un subtítulo de panel.",
            visibleIf: "Utilice el icono de la varita mágica para establecer una regla condicional que determine la visibilidad del panel.",
            enableIf: "Utilice el icono de la varita mágica para establecer una regla condicional que desactive el modo de solo lectura para el panel.",
            requiredIf: "Utilice el icono de la varita mágica para establecer una regla condicional que impida el envío de encuestas a menos que al menos una pregunta anidada tenga una respuesta.",
            templateTitleLocation: "Se aplica a todas las preguntas de este panel. Si desea anular esta configuración, defina reglas de alineación de títulos para preguntas individuales. La opción \"Heredar\" aplica la configuración a nivel de página (si está establecida) o a nivel de encuesta (\"Superior\" de forma predeterminada).",
            templateErrorLocation: "Establece la ubicación de un mensaje de error en relación con una pregunta con entrada no válida. Elija entre: \"Arriba\": se coloca un texto de error en la parte superior del cuadro de pregunta; \"Abajo\": se coloca un texto de error en la parte inferior del cuadro de pregunta. La opción \"Heredar\" aplica la configuración a nivel de página (si está establecida) o a nivel de encuesta (\"Superior\" de forma predeterminada).",
            errorLocation: "Establece la ubicación de un mensaje de error en relación con todas las preguntas del panel. La opción \"Heredar\" aplica la configuración a nivel de página (si se establece) o a nivel de encuesta.",
            page: "Cambia la posición del panel al final de una página seleccionada.",
            innerIndent: "Añade espacio o margen entre el contenido del panel y el borde izquierdo del cuadro del panel.",
            startWithNewLine: "Anule la selección para mostrar el panel en una línea con la pregunta o el panel anterior. La configuración no se aplica si el panel es el primer elemento del formulario.",
            state: "Elija entre: \"Expandido\": el panel se muestra en su totalidad y se puede contraer; \"Contraído\": el panel muestra solo el título y la descripción y se puede expandir; \"Bloqueado\": el panel se muestra en su totalidad y no se puede contraer.",
            width: "Define la anchura del panel en proporción a otros elementos topográficos de la misma línea. Acepta valores CSS (px, %, in, pt, etc.).",
            templateTitle: "Escriba una plantilla para los títulos de los paneles dinámicos. Utilice {panelIndex} para la posición general del panel y {visiblePanelIndex} para su orden entre los paneles visibles. Inserte estos marcadores de posición en el patrón para agregar numeración automática.",
            templateTabTitle: "Escriba una plantilla para los títulos de las pestañas. Utilice {panelIndex} para la posición general de un panel y {visiblePanelIndex} para su orden entre los paneles visibles. Inserte estos marcadores de posición en el patrón para agregar numeración automática.",
            tabTitlePlaceholder: "Texto de reserva para los títulos de tabulación que se aplica cuando el patrón de título de tabulación no genera un valor significativo.",
            templateVisibleIf: "Esta configuración le permite controlar la visibilidad de paneles individuales dentro del panel dinámico. Utilice el marcador de posición '{panel}' para hacer referencia al panel actual en la expresión.",
            titleLocation: "Esta configuración es heredada automáticamente por todas las preguntas dentro de este panel. Si desea anular esta configuración, defina reglas de alineación de títulos para preguntas individuales. La opción \"Heredar\" aplica la configuración a nivel de página (si está establecida) o a nivel de encuesta (\"Superior\" de forma predeterminada).",
            descriptionLocation: "La opción \"Heredar\" aplica la configuración a nivel de página (si está establecida) o a nivel de encuesta (\"Debajo del título del panel\" de forma predeterminada).",
            newPanelPosition: "Define la posición de un panel recién añadido. De forma predeterminada, los nuevos paneles se agregan al final. Seleccione \"Siguiente\" para insertar un nuevo panel después del actual.",
            defaultValueFromLastPanel: "Duplica las respuestas del último panel y las asigna al siguiente panel dinámico agregado.",
            keyName: "Haga referencia a un nombre de pregunta para requerir que un usuario proporcione una respuesta única para esta pregunta en cada panel."
        },
        defaultValueExpression: "Esta configuración le permite asignar un valor de respuesta predeterminado basado en una expresión. La expresión puede incluir cálculos básicos: '{q1_id} + {q2_id}', expresiones booleanas, como '{edad} > 60', y funciones: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. El valor determinado por esta expresión sirve como el valor predeterminado inicial que puede ser anulado por la entrada manual de un encuestado.",
        resetValueIf: "Usa el ícono de la varita mágica para establecer una regla condicional que determine cuándo la entrada de un encuestado se restablece al valor basado en la \"Expresión de valor predeterminado\" o \"Expresión de valor establecido\" o al valor de \"Respuesta predeterminada\" (si cualquiera de los dos está establecido).",
        setValueIf: "Utilice el icono de la varita mágica para establecer una regla condicional que determine cuándo ejecutar la \"Expresión de valor establecido\" y asigne dinámicamente el valor resultante como respuesta.",
        setValueExpression: "Especifique una expresión que defina el valor que se establecerá cuando se cumplan las condiciones de la regla \"Establecer valor si\". La expresión puede incluir cálculos básicos: '{q1_id} + {q2_id}', expresiones booleanas, como '{edad} > 60', y funciones: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. El valor determinado por esta expresión puede ser anulado por la entrada manual de un encuestado.",
        question: {
            name: "Un identificador de pregunta que no es visible para los encuestados.",
            description: "Escribe un subtítulo para la pregunta.",
            visibleIf: "Utilice el icono de la varita mágica para establecer una regla condicional que determine la visibilidad de la pregunta.",
            enableIf: "Utilice el icono de la varita mágica para establecer una regla condicional que deshabilite el modo de solo lectura para la pregunta.",
            requiredIf: "Utilice el icono de la varita mágica para establecer una regla condicional que impida que la encuesta avance o se envíe a menos que la pregunta reciba una respuesta.",
            startWithNewLine: "Anule la selección para mostrar la pregunta en una línea con la pregunta o el panel anterior. La configuración no se aplica si la pregunta es el primer elemento del formulario.",
            page: "Cambia la posición de la pregunta al final de una página seleccionada.",
            state: "Elija entre: \"Expandido\": el cuadro de pregunta se muestra en su totalidad y se puede contraer; \"Contraído\": el cuadro de pregunta muestra solo el título y la descripción y se puede expandir; \"Bloqueado\": el cuadro de pregunta se muestra en su totalidad y no se puede contraer.",
            titleLocation: "Anula las reglas de alineación de títulos definidas en un panel, página o encuesta. La opción \"Heredar\" aplica cualquier configuración de nivel superior (si está establecida) o configuración de nivel de encuesta (\"Superior\" de forma predeterminada).",
            descriptionLocation: "La opción \"Heredar\" aplica la configuración a nivel de encuesta (\"Bajo el título de la pregunta\" de forma predeterminada).",
            errorLocation: "Establece la ubicación de un mensaje de error en relación con la pregunta con entrada no válida. Elija entre: \"Arriba\": se coloca un texto de error en la parte superior del cuadro de pregunta; \"Abajo\": se coloca un texto de error en la parte inferior del cuadro de pregunta. La opción \"Heredar\" aplica la configuración a nivel de encuesta (\"Superior\" de forma predeterminada).",
            indent: "Agrega espacio o margen entre el contenido de la pregunta y el borde izquierdo del cuadro de pregunta.",
            width: "Establece el ancho de la pregunta en proporción a otros elementos de la encuesta en la misma línea. Acepta valores CSS (px, %, in, pt, etc.).",
            surveyvalidator: {
                expression: "Utilice el icono de la varita mágica para establecer una regla de validación para la pregunta."
            },
            textUpdateMode: "Elija entre: \"Al perder el foco\": el valor se actualiza cuando el campo de entrada pierde el foco; \"Mientras escribes\": el valor se actualiza en tiempo real, a medida que los usuarios escriben. La opción \"Heredar\" aplica la configuración a nivel de encuesta (\"Al perder el foco\" de forma predeterminada).",
            url: "Puede utilizar cualquier servicio web como fuente de datos para preguntas de opción múltiple. Para rellenar los valores de opción, introduzca la dirección URL del servicio que proporciona los datos.",
            searchMode: "Operación de comparación que se utiliza para filtrar la lista desplegable.",
            textWrapEnabled: "Los textos largos en las opciones de elección generarán automáticamente saltos de línea para que se ajusten al menú desplegable. Anule la selección si desea que los textos se recorten."
        },
        signaturepad: {
            signatureWidth: "Define la anchura del área de firma mostrada y de la imagen resultante.",
            signatureHeight: "Define la altura del área de firma mostrada y de la imagen resultante.",
            signatureAutoScaleEnabled: "Seleccione esta opción si desea que el área de firma ocupe todo el espacio disponible dentro del cuadro de pregunta manteniendo la relación de aspecto predeterminada de 3:2. Cuando se establecen valores de anchura y altura personalizados, la configuración mantendrá la relación de aspecto de estas dimensiones."
        },
        file: {
            imageHeight: "Ajusta la altura de la imagen en los resultados de la encuesta.",
            imageWidth: "Ajusta el ancho de la imagen en los resultados de la encuesta."
        },
        image: {
            contentMode: "La opción \"Auto\" determina automáticamente el modo adecuado para la visualización (Imagen, Video o YouTube) en función de la URL de origen proporcionada."
        },
        imagepicker: {
            imageHeight: "Anula los valores de altura mínima y máxima.",
            imageWidth: "Anula los valores de anchura mínima y máxima.",
            choices: "\"Valor\" sirve como un identificador de elemento que se usa en las reglas condicionales; \"Texto\" se muestra a los encuestados.",
            contentMode: "Elija entre \"Imagen\" y \"Video\" para configurar el modo de contenido del selector de medios. Si se selecciona \"Imagen\", asegúrese de que todas las opciones proporcionadas sean archivos de imagen en los siguientes formatos: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Del mismo modo, si se selecciona \"Vídeo\", asegúrese de que todas las opciones sean enlaces directos a archivos de vídeo en los siguientes formatos: MP4, MOV, WMV, FLV, AVI, MKV. Tenga en cuenta que los enlaces de YouTube no son compatibles con las opciones de video."
        },
        text: {
            size: "Esta configuración solo cambia el tamaño del campo de entrada y no afecta al ancho del cuadro de pregunta. Para limitar la longitud de entrada aceptada, vaya a <b>Validación → Límite máximo de caracteres</b>."
        },
        comment: {
            rows: "Establece el número de líneas mostradas en el campo de entrada. Si la entrada ocupa más líneas, aparecerá la barra de desplazamiento."
        },
        // survey templates
        survey: {
            mode: "Elija entre: \"Editable\": permite a los encuestados completar su encuesta; \"Solo lectura\": deshabilita la edición de formularios."
        },
        matrixdropdowncolumn: {
            name: "Un identificador de columna que no es visible para los encuestados.",
            isUnique: "Cuando se habilita para una columna, se requiere que un encuestado proporcione una respuesta única para cada pregunta dentro de esta columna.",
            rows: "Establece el número de líneas mostradas en el campo de entrada. Si la entrada ocupa más líneas, aparecerá la barra de desplazamiento.",
            visibleIf: "Utilice el icono de la varita mágica para establecer una regla condicional que determine la visibilidad de la columna.",
            enableIf: "Utilice el icono de la varita mágica para establecer una regla condicional que deshabilite el modo de solo lectura para la columna.",
            requiredIf: "Utilice el icono de la varita mágica para establecer una regla condicional que impida el envío de encuestas a menos que al menos una pregunta anidada tenga una respuesta.",
            showInMultipleColumns: "Cuando se selecciona, crea una columna individual para cada opción de opción."
        },
        widthMode: "Elija entre: \"Estático\": establece un ancho fijo; \"Responsivo\": hace que la encuesta ocupe todo el ancho de la pantalla; \"Auto\": aplica cualquiera de los dos dependiendo de los tipos de preguntas utilizados.",
        cookieName: "Las cookies impiden que los usuarios completen la misma encuesta dos veces.",
        logo: "Pegue un enlace de imagen (sin límites de tamaño) o haga clic en el icono de la carpeta para buscar un archivo desde su computadora (hasta 64 KB).",
        logoWidth: "Establece el ancho del logotipo en unidades CSS (px, %, in, pt, etc.).",
        logoHeight: "Establece la altura del logotipo en unidades CSS (px, %, in, pt, etc.).",
        logoFit: "Elija entre: \"Ninguno\": la imagen mantiene su tamaño original; \"Contener\": se cambia el tamaño de la imagen para que se ajuste manteniendo su relación de aspecto; \"Portada\": la imagen llena toda la caja manteniendo su relación de aspecto; \"Relleno\": la imagen se estira para llenar el cuadro sin mantener su relación de aspecto.",
        goNextPageAutomatic: "Seleccione si desea que la encuesta avance a la página siguiente automáticamente después de que un encuestado responda todas las preguntas de la página actual.",
        allowCompleteSurveyAutomatic: "Seleccione si desea que la encuesta se complete automáticamente después de que un encuestado responda todas las preguntas.",
        showNavigationButtons: "Establece la visibilidad y la ubicación de los botones de navegación en una página.",
        showProgressBar: "Establece la visibilidad y la ubicación de una barra de progreso. El valor \"Auto\" muestra la barra de progreso por encima o por debajo del encabezado de la encuesta.",
        showPreviewBeforeComplete: "Habilite la página de vista previa con todas las preguntas o solo las respondidas.",
        questionTitleLocation: "Se aplica a todas las preguntas de la encuesta. Esta configuración se puede anular mediante reglas de alineación de títulos en niveles inferiores: panel, página o pregunta. Una configuración de nivel inferior anulará las de un nivel superior.",
        requiredText: "Un símbolo o una secuencia de símbolos que indican que se requiere una respuesta.",
        questionStartIndex: "Introduzca un número o una letra con la que desee empezar a numerar.",
        questionErrorLocation: "Establece la ubicación de un mensaje de error en relación con la pregunta con entrada no válida. Elija entre: \"Arriba\": se coloca un texto de error en la parte superior del cuadro de pregunta; \"Abajo\": se coloca un texto de error en la parte inferior del cuadro de pregunta.",
        focusFirstQuestionAutomatic: "Seleccione si desea que el primer campo de entrada de cada página esté listo para la entrada de texto.",
        questionsOrder: "Mantiene el orden original de las preguntas o las aleatoriza. El efecto de esta configuración solo es visible en la pestaña Vista previa.",
        maxTextLength: "Solo para preguntas de entrada de texto.",
        maxOthersLength: "Solo para comentarios de preguntas.",
        commentAreaRows: "Establece el número de líneas mostradas en las áreas de texto para los comentarios de las preguntas. En la entrada ocupa más líneas, aparece la barra de desplazamiento.",
        autoGrowComment: "Seleccione si desea que los comentarios de las preguntas y las preguntas de texto largo aumenten automáticamente en altura en función de la longitud del texto introducido.",
        allowResizeComment: "Solo para comentarios de preguntas y preguntas de texto largo.",
        calculatedValues: "Las variables personalizadas sirven como variables intermedias o auxiliares que se utilizan en los cálculos de formularios. Toman las entradas de los encuestados como valores de origen. Cada variable personalizada tiene un nombre único y una expresión en la que se basa.",
        includeIntoResult: "Seleccione si desea que el valor calculado de la expresión se guarde junto con los resultados de la encuesta.",
        triggers: "Un desencadenador es un evento o condición que se basa en una expresión. Una vez que la expresión se evalúa como \"verdadera\", un desencadenador desencadena una acción. Opcionalmente, una acción de este tipo puede tener una pregunta de destino a la que afecta.",
        clearInvisibleValues: "Elija si desea o no borrar los valores de las preguntas ocultas por la lógica condicional y cuándo hacerlo.",
        textUpdateMode: "Elija entre: \"Al perder el foco\": el valor se actualiza cuando el campo de entrada pierde el foco; \"Mientras escribes\": el valor se actualiza en tiempo real, a medida que los usuarios escriben.",
        columns: "El valor de la izquierda sirve como identificador de columna que se usa en las reglas condicionales, el valor de la derecha se muestra a los encuestados.",
        rows: "El valor de la izquierda sirve como un ID de fila que se usa en las reglas condicionales, el valor de la derecha se muestra a los encuestados.",
        columnMinWidth: "Acepta valores CSS (px, %, in, pt, etc.).",
        rowTitleWidth: "Acepta valores CSS (px, %, in, pt, etc.).",
        totalText: "Visible sólo cuando al menos una columna tiene el tipo Total o la expresión Total.",
        cellErrorLocation: "Establece la ubicación de un mensaje de error en relación con una celda con entrada no válida. La opción \"Heredar\" aplica la configuración de la propiedad \"Alineación de mensajes de error\".",
        keyDuplicationError: "Cuando la propiedad \"Evitar respuestas duplicadas\" está habilitada, un encuestado que intente enviar una entrada duplicada recibirá el siguiente mensaje de error.",
        totalExpression: "Permite calcular los valores totales en función de una expresión. La expresión puede incluir cálculos básicos ('{q1_id} + {q2_id}'), expresiones booleanas ('{edad} > 60') y funciones ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.).",
        confirmDelete: "Activa un mensaje en el que se le pide que confirme la eliminación de filas.",
        defaultValueFromLastRow: "Duplica las respuestas de la última fila y las asigna a la siguiente fila dinámica agregada.",
        keyName: "Si la columna especificada contiene valores idénticos, la encuesta arroja el error \"Valor de clave no única\".",
        description: "Escribe un subtítulo.",
        locale: "Elige un idioma para comenzar a crear tu encuesta. Para agregar una traducción, cambie a un nuevo idioma y traduzca el texto original aquí o en la pestaña Traducciones.",
        detailPanelMode: "Establece la ubicación de una sección de detalles en relación con una fila. Elija entre: \"Ninguno\": no se agrega ninguna expansión; \"Debajo de la fila\": se coloca una expansión de fila debajo de cada fila de la matriz; \"Debajo de la fila, mostrar solo una expansión de fila\": una expansión se muestra solo debajo de una sola fila, las expansiones de fila restantes se contraen.",
        imageFit: "Elija entre: \"Ninguno\": la imagen mantiene su tamaño original; \"Contener\": se cambia el tamaño de la imagen para que se ajuste manteniendo su relación de aspecto; \"Portada\": la imagen llena toda la caja manteniendo su relación de aspecto; \"Relleno\": la imagen se estira para llenar el cuadro sin mantener su relación de aspecto.",
        autoGrow: "Aumenta gradualmente la altura del campo de entrada a medida que se introducen los datos. Anula el ajuste \"Altura del campo de entrada (en líneas)\".",
        allowResize: "El controlador de cambio de tamaño (o pinzamiento) aparece en la esquina y se puede arrastrar para modificar el tamaño del campo de entrada.",
        maxTimeToFinish: "Un intervalo de tiempo en segundos después del cual la encuesta avanza automáticamente a la página de agradecimiento.",
        maxTimeToFinishPage: "Un intervalo de tiempo en segundos después del cual la encuesta avanza automáticamente a la página siguiente.",
        page: {
            maxTimeToFinish: "Un intervalo de tiempo en segundos después del cual la encuesta avanza automáticamente a la página siguiente.",
            visibleIf: "Utilice el icono de la varita mágica para establecer una regla condicional que determine la visibilidad de la página.",
            enableIf: "Utilice el icono de la varita mágica para establecer una regla condicional que deshabilite el modo de solo lectura de la página.",
            requiredIf: "Utilice el icono de la varita mágica para establecer una regla condicional que impida el envío de encuestas a menos que al menos una pregunta anidada tenga una respuesta.",
            questionTitleLocation: "Se aplica a todas las preguntas de esta página. Si desea anular esta configuración, defina reglas de alineación de títulos para preguntas o paneles individuales. La opción \"Heredar\" aplica la configuración a nivel de encuesta (\"Superior\" de forma predeterminada).",
            questionTitleWidth: "Establece un ancho coherente para los títulos de las preguntas cuando están alineados a la izquierda de sus cuadros de preguntas. Acepta valores CSS (px, %, in, pt, etc.).",
            questionErrorLocation: "Establece la ubicación de un mensaje de error en relación con la pregunta con entrada no válida. Elija entre: \"Arriba\": se coloca un texto de error en la parte superior del cuadro de pregunta; \"Abajo\": se coloca un texto de error en la parte inferior del cuadro de pregunta. La opción \"Heredar\" aplica la configuración a nivel de encuesta (\"Superior\" de forma predeterminada).",
            questionsOrder: "Mantiene el orden original de las preguntas o las aleatoriza. La opción \"Heredar\" aplica la configuración a nivel de encuesta (\"Original\" de forma predeterminada). El efecto de esta configuración solo es visible en la pestaña Vista previa.",
            navigationButtonsVisibility: "Establece la visibilidad de los botones de navegación en la página. La opción \"Heredar\" aplica la configuración de nivel de encuesta, que por defecto es \"Visible\"."
        },
        showTimerPanel: "Establece la visibilidad y la ubicación de un temporizador en una página.",
        panelsState: "Elija entre: \"Bloqueado\": los usuarios no pueden expandir ni contraer paneles; \"Contraer todo\": todos los paneles comienzan en un estado contraído; \"Expandir todo\": todos los paneles comienzan en un estado expandido; \"Primero expandido\": solo el primer panel se expande inicialmente.",
        imageLinkName: "Introduzca un nombre de propiedad compartida dentro de la matriz de objetos que contiene las direcciones URL de los archivos de imagen o vídeo que desea mostrar en la lista de opciones.",
        choices: "El valor de la izquierda sirve como un identificador de elemento utilizado en las reglas condicionales, el valor de la derecha se muestra a los encuestados.",
        title: "Escriba un título fácil de usar para mostrar.",
        waitForUpload: "Garantiza que los usuarios no completen la encuesta hasta que se carguen los archivos.",
        minWidth: "Acepta valores CSS (px, %, in, pt, etc.).",
        maxWidth: "Acepta valores CSS (px, %, in, pt, etc.).",
        width: "Acepta valores CSS (px, %, in, pt, etc.).",
        valueName: "Si no establece esta propiedad, la respuesta se almacenará en un campo especificado por la propiedad Name.",
        useDisplayValuesInDynamicTexts: "En los tipos de preguntas de selección única y múltiple, cada opción de opción tiene un ID y un valor de visualización. Cuando se selecciona, esta configuración muestra un valor de visualización en lugar de un valor de ID en las preguntas HTML y en los títulos dinámicos y las descripciones de los elementos de la encuesta.",
        clearIfInvisible: "Elija si desea o no borrar los valores de las preguntas ocultos por la lógica condicional y cuándo hacerlo. La opción \"Heredar\" aplica la configuración de nivel de encuesta (\"Al finalizar la encuesta\" de forma predeterminada).",
        choicesFromQuestionMode: "Elija entre: \"Todas\": copia todas las opciones de elección de la pregunta seleccionada; \"Seleccionado\": copia dinámicamente solo las opciones de elección seleccionadas; \"No seleccionado\": copia dinámicamente solo las opciones de elección no seleccionadas. Las opciones \"Ninguno\" y \"Otro\" se copian de forma predeterminada si están habilitadas en la pregunta de origen.",
        showOtherItem: "Cuando se selecciona, los usuarios pueden incluir entradas adicionales en un cuadro de comentarios independiente.",
        separateSpecialChoices: "Muestra cada opción de opción especial (\"Ninguno\", \"Otro\", \"Seleccionar todo\") en una nueva línea, incluso cuando se utiliza un diseño de varias columnas.",
        path: "Especifique la ubicación dentro del dataset de servicio donde se encuentra la matriz de objetos de destino. Déjelo en vacío si la dirección URL ya apunta a la matriz.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Escriba un nombre de propiedad uniforme dentro de la matriz de objetos que contiene los valores que desea mostrar en la lista de opciones.",
        allowEmptyResponse: "Seleccione esta opción para permitir que el servicio devuelva una respuesta o matriz vacía.",
        choicesVisibleIf: "Utilice el icono de la varita mágica para establecer una regla condicional que determine la visibilidad de todas las opciones de elección.",
        rateValues: "El valor de la izquierda sirve como un identificador de elemento utilizado en las reglas condicionales, el valor de la derecha se muestra a los encuestados.",
        rating: {
            displayMode: "\"Auto\" selecciona entre los modos \"Botones\" y \"Desplegable\" en función del ancho disponible. Cuando el ancho es insuficiente para mostrar los botones, la pregunta muestra un menú desplegable."
        },
        valuePropertyName: "Permite conectar preguntas que producen resultados en diferentes formatos. Cuando estas preguntas se vinculan entre sí mediante un identificador de combinación, esta propiedad compartida almacena los valores de pregunta seleccionados.",
        searchEnabled: "Seleccione si desea actualizar el contenido del menú desplegable para que coincida con la consulta de búsqueda que un usuario está escribiendo en el campo de entrada.",
        valueTrue: "Un valor que se debe guardar en los resultados de la encuesta cuando los encuestados dan una respuesta positiva.",
        valueFalse: "Un valor que se debe guardar en los resultados de la encuesta cuando los encuestados dan una respuesta negativa.",
        showPreview: "No se recomienda deshabilitar esta opción, ya que anula la imagen de vista previa y dificulta que un usuario comprenda si los archivos se han cargado.",
        needConfirmRemoveFile: "Activa un mensaje que le pide que confirme la eliminación del archivo.",
        selectToRankEnabled: "Habilite esta opción para clasificar solo las opciones seleccionadas. Los usuarios arrastrarán los elementos seleccionados de la lista de opciones para ordenarlos dentro del área de clasificación.",
        dataList: "Ingrese una lista de opciones que se sugerirán al encuestado durante la entrada.",
        itemSize: "La configuración solo cambia el tamaño de los campos de entrada y no afecta al ancho del cuadro de pregunta.",
        itemTitleWidth: "Establece un ancho coherente para todas las etiquetas de elementos en píxeles",
        altText: "Sirve como sustituto cuando la imagen no se puede mostrar en el dispositivo de un usuario y por motivos de accesibilidad.",
        rateColorMode: "Define el color del emoji seleccionado cuando el tipo de icono de clasificación se establece en \"Emoticonos\". Elija entre: \"Predeterminado\": el emoji seleccionado aparece en el color predeterminado de la encuesta; \"Escala\": el emoji seleccionado hereda el color de la escala de calificación.",
        expression: {
            name: "Un identificador de expresión que no es visible para los encuestados.",
            description: "Escriba un subtítulo de expresión.",
            expression: "Una expresión puede incluir cálculos básicos ('{q1_id} + {q2_id}'), condiciones ('{edad} > 60') y funciones ('iif()', 'hoy()', 'edad()', 'min()', 'max()', 'avg()', etc.)."
        },
        storeOthersAsComment: "Seleccione esta opción para almacenar el valor de la opción \"Otro\" como una propiedad independiente en los resultados de la encuesta.",
        format: "Utilice {0} como marcador de posición para el valor real.",
        acceptedTypes: "Consulte la descripción del atributo [accept](https://www.w3schools.com/tags/att_input_accept.asp) para obtener más información.",
        columnColCount: "Aplicable solo a los tipos de celda Radiogroup y Checkbox.",
        autocomplete: "Consulte la descripción del atributo [autocompletar](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) para obtener más información.",
        filePlaceholder: "Se aplica cuando \"Tipo de fuente\" es \"Archivos locales\" o cuando la cámara no está disponible",
        photoPlaceholder: "Se aplica cuando \"Tipo de fuente\" es \"Cámara\".",
        fileOrPhotoPlaceholder: "Se aplica cuando \"Tipo de fuente\" es \"Archivos locales o cámara\".",
        masksettings: {
            saveMaskedValue: "Seleccione si desea almacenar el valor de la pregunta con una máscara aplicada en los resultados de la encuesta."
        },
        patternmask: {
            pattern: "El patrón puede contener literales de cadena y los siguientes marcadores de posición: '9': para un dígito; 'a' - para una letra mayúscula o minúscula; '#' - para un dígito o una letra mayúscula o minúscula. Use la barra invertida '\\' para escapar de un carácter."
        },
        datetimemask: {
            pattern: "El patrón puede contener caracteres separadores y los siguientes marcadores de posición:<br>'m' - Número de mes.<br>'mm': número de mes, con cero a la izquierda para valores de un solo dígito. <br>'d' - Día del mes. <br>'dd': día del mes, con cero a la izquierda para valores de un solo dígito. <br>'yy': los dos últimos dígitos del año. <br>'yyyy' - Año de cuatro dígitos. <br>'H' - Horas en formato de 24 horas. <br>'HH': horas en formato de 24 horas, con cero a la izquierda para valores de un solo dígito. <br>'h' - Horas en formato de 12 horas. <br>'hh': horas en formato de 12 horas, con cero a la izquierda para valores de un solo dígito. <br>'MM' - Actas. <br>'ss' - Segundos. <br>'TT': período de reloj de 12 horas en mayúsculas (AM/PM). <br>'tt' - Período de reloj de 12 horas en minúsculas (am/pm)."
        },
        numericmask: {
            decimalSeparator: "Símbolo utilizado para separar la parte fraccionaria de la parte entera de un número mostrado.",
            thousandsSeparator: "Símbolo que se utiliza para separar los dígitos de un número grande en grupos de tres.",
            precision: "Limita el número de dígitos que se conservan después del punto decimal de un número mostrado."
        },
        currencymask: {
            prefix: "Uno o varios símbolos que se mostrarán antes del valor.",
            suffix: "Uno o varios símbolos que se mostrarán después del valor."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "título",
            title: "Dejarlo vacío, si es lo mismo que 'Name'"
        },
        multiSelect: "Permitir múltiple selección",
        showLabel: "Mostrar leyenda de imagen",
        swapOrder: "Cambiar el orden de Sí y No",
        value: "Valor",
        tabAlign: "Alineación de tabulaciones",
        sourceType: "Tipo de origen",
        fitToContainer: "Ajuste al contenedor",
        setValueExpression: "Establecer expresión de valor",
        description: "Descripción",
        logoFit: "Ajuste del logotipo",
        pages: "Páginas",
        questions: "Preguntas",
        triggers: "disparadores",
        calculatedValues: "Valores calculados",
        surveyId: "ID de la encuesta",
        surveyPostId: "ID de publicación de la encuesta",
        surveyShowDataSaving: "La encuesta muestra el ahorro de datos",
        questionDescriptionLocation: "Ubicación de la descripción de la pregunta",
        progressBarType: "Tipo de barra de progreso",
        showTOC: "Mostrar TDC",
        tocLocation: "Ubicación de Toc",
        questionTitlePattern: "Patrón de título de pregunta",
        widthMode: "Modo de anchura",
        showBrandInfo: "Mostrar información de la marca",
        useDisplayValuesInDynamicTexts: "Usar valores de visualización en textos dinámicos",
        visibleIf: "visible si",
        defaultValueExpression: "Expresión de valor predeterminada",
        requiredIf: "Requerido si",
        resetValueIf: "Restablecer valor si",
        setValueIf: "Establezca el valor si",
        validators: "Validadores",
        bindings: "Enlaces",
        renderAs: "Renderizar como",
        attachOriginalItems: "Adjuntar elementos originales",
        choices: "opciones",
        choicesByUrl: "opciones por URL",
        currency: "divisa",
        cellHint: "Sugerencia de celda",
        totalMaximumFractionDigits: "Total máximo de fracción de dígitos",
        totalMinimumFractionDigits: "Total de dígitos de fracción mínima",
        columns: "columnas",
        detailElements: "Elementos de detalle",
        allowAdaptiveActions: "Permitir acciones adaptables",
        defaultRowValue: "Valor por defecto Fila",
        detailPanelShowOnAdding: "Panel de detalles mostrar sobre la adición",
        choicesLazyLoadEnabled: "Opciones de carga diferida habilitadas",
        choicesLazyLoadPageSize: "Opciones de tamaño de página de carga diferida",
        inputFieldComponent: "Componente de campo de entrada",
        itemComponent: "Componente de elemento",
        min: "Min",
        max: "Máximo",
        minValueExpression: "Expresión de valor mínimo",
        maxValueExpression: "Expresión de valor máximo",
        step: "Paso",
        dataList: "Lista de datos",
        itemSize: "artículos",
        itemTitleWidth: "Ancho de la etiqueta del elemento (en px)",
        elements: "Elementos",
        content: "Contenido",
        navigationButtonsVisibility: "Navegación botones visibilidad",
        navigationTitle: "Título de navegación",
        navigationDescription: "Descripción de navegación",
        longTap: "Toque largo",
        autoGrow: "Cultivo automático",
        allowResize: "Permitir cambiar el tamaño",
        acceptCarriageReturn: "Aceptar devolución de transporte",
        displayMode: "Modo de visualización",
        rateType: "Tipo de tarifa",
        label: "etiqueta",
        contentMode: "Modo de contenido",
        imageFit: "Ajuste de imagen",
        altText: "Texto alternativo",
        height: "Altura",
        penColor: "Color de la pluma",
        backgroundColor: "Color de fondo",
        templateElements: "Elementos de plantilla",
        operator: "Operador",
        isVariable: "Es variable",
        runExpression: "Ejecutar expresión",
        showCaption: "Mostrar pie de foto",
        iconName: "Nombre del icono",
        iconSize: "Tamaño del icono",
        precision: "Precisión",
        matrixDragHandleArea: "Área del controlador de arrastre de matriz",
        backgroundImage: "Imagen de fondo",
        backgroundImageFit: "Ajuste de imagen de fondo",
        backgroundImageAttachment: "Datos adjuntos de imagen de fondo",
        backgroundOpacity: "Opacidad de fondo",
        selectToRankEnabled: "Seleccione para clasificar habilitado",
        selectToRankAreasLayout: "Seleccione para clasificar el diseño de áreas",
        selectToRankEmptyRankedAreaText: "Texto para mostrar si todas las opciones están seleccionadas",
        selectToRankEmptyUnrankedAreaText: "Texto de marcador de posición para el área de clasificación",
        allowCameraAccess: "Permitir el acceso a la cámara",
        scaleColorMode: "Modo de color de escala",
        rateColorMode: "Modo de color de tasa",
        copyDisplayValue: "Copiar valor de visualización",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Modo avanzado",
        pageTitle: "Fuente del título de la página",
        questionTitle: "Fuente del título de la pregunta",
        editorPanel: "Elemento de entrada",
        lines: "Lineas",
        primaryDefaultColor: "Predeterminado",
        primaryDarkColor: "Cernerse",
        primaryLightColor: "Seleccionado",
        backgroundDimColor: "Color de fondo",
        cornerRadius: "Radio de esquina",
        backcolor: "Fondo predeterminado",
        hovercolor: "Pasar el cursor de fondo",
        borderDecoration: "Decoración de bordes",
        fontColor: "Color de la fuente",
        backgroundColor: "Color de fondo",
        primaryForecolor: "Color predeterminado",
        primaryForecolorLight: "Color deshabilitado",
        font: "Fuente",
        borderDefault: "Oscuro",
        borderLight: "Encendedor",
        fontFamily: "Familia tipográfica",
        fontWeightRegular: "Regular",
        fontWeightHeavy: "Pesado",
        fontWeightSemiBold: "Semi-negrita",
        fontWeightBold: "Audaz",
        color: "Color",
        placeholderColor: "Color del marcador de posición",
        size: "Tamaño",
        opacity: "Opacidad",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Agregar efecto de sombra",
        boxShadowBlur: "Desdibujar",
        boxShadowSpread: "Propagación",
        boxShadowDrop: "Soltar",
        boxShadowInner: "Interior",
        names: {
            default: "Predeterminado",
            sharp: "Afilado",
            borderless: "Sin bordes",
            flat: "Plano",
            plain: "Llanura",
            doubleborder: "Doble Borde",
            layered: "Capas",
            solid: "Sólido",
            threedimensional: ".3D",
            contrast: "Contraste"
        },
        colors: {
            teal: "Cerceta",
            blue: "Azul",
            purple: "Morado",
            orchid: "Orquídea",
            tulip: "Tulipán",
            brown: "Marrón",
            green: "Verde"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["es"] = spanishTranslation;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// qt.tagbox: "Multi-Select Dropdown" => "Menú desplegable de selección múltiple"
// qt.buttongroup: "Button Group" => "Grupo de botones"
// ed.themeSurvey: "Themes" => "Temas"
// ed.defaultV2Theme: "Default" => "Predeterminado"
// ed.modernTheme: "Modern" => "Moderno"
// ed.defaultTheme: "Default (legacy)" => "Incumplimiento (heredado)"
// ed.toolboxMiscCategory: "Misc" => "Misc"
// ed.themePropertyGridTitle: "Theme Settings" => "Configuración del tema"
// ed.themeExportButton: "Export" => "Exportar"
// ed.themeImportButton: "Import" => "Importación"
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Las opciones se copian de"
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Arrastre y suelte una imagen aquí o haga clic en el botón de abajo y elija una imagen para cargar"
// ed.imageChooseImage: "Choose Image" => "Elegir imagen"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[LOGOTIPO]"
// ed.auto: "auto" => "Automático"
// ed.choices_Item: "Item " => "Artículo "
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "Valor de pregunta claro: {0}"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Las reglas lógicas están incompletas"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "No ha completado algunas de las reglas lógicas. Si deja la pestaña ahora, los cambios se perderán. ¿Aún desea salir de la pestaña sin completar los cambios?"
// lg.uncompletedRule_apply: "Yes" => "Sí"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "No, quiero completar las reglas"
// pe.set: "Set" => "Poner"
// pe.overridingPropertyPrefix: "Set by " => "Establecido por "
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "No utilice palabras reservadas: \"elemento\", \"elección\", \"panel\", \"fila\"."
// image.imageHeight: "Image height (in CSS-accepted values)" => "Altura de la imagen (en valores aceptados por CSS)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Ancho de imagen (en valores aceptados por CSS)"
// pe.allowResizeComment: "Allow users to resize text areas" => "Permitir a los usuarios cambiar el tamaño de las áreas de texto"
// pe.labelTrue: "\"True\" label" => "Etiqueta \"Verdadero\""
// pe.labelFalse: "\"False\" label" => "Etiqueta \"Falso\""
// pe.displayStyle: "Value display style" => "Estilo de visualización del valor"
// pe.rateValues: "Custom rate values" => "Valores de tarifa personalizados"
// pe.rateCount: "Rate count" => "Recuento de tarifas"
// pe.autoGenerate: "How to specify rate values?" => "¿Cómo especificar valores de tasa?"
// pe.valueTrue: "\"True\" value" => "Valor \"verdadero\""
// pe.valueFalse: "\"False\" value" => "Valor \"falso\""
// pe.minErrorText: "\"Value is below minimum\" error message" => "Mensaje de error \"El valor está por debajo del mínimo\""
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "Mensaje de error \"El valor supera el máximo\""
// pe.otherErrorText: "\"Empty comment\" error message" => "Mensaje de error \"Comentario vacío\""
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "Mensaje de error \"Valor de clave no único\""
// pe.minSelectedChoices: "Minimum selected choices" => "Opciones mínimas seleccionadas"
// pe.maxSelectedChoices: "Maximum selected choices" => "Número máximo de opciones seleccionadas"
// pe.emptyRowsText: "\"No rows\" message" => "Mensaje \"Sin filas\""
// pe.commentPlaceholder: "Comment area placeholder" => "Marcador de posición del área de comentarios"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Mostrar descripciones de velocidad como valores extremos"
// itemvalue.text: "Alt text" => "Texto alternativo"
// pe.closeOnSelect: "Close the dropdown after selection" => "Cierre el menú desplegable después de la selección"
// pe.otherPlaceholder: "Comment area placeholder" => "Marcador de posición del área de comentarios"
// pe.rateType: "Rate type" => "Tipo de tarifa"
// pv.true: "true" => "verdadero"
// pv.false: "false" => "falso"
// pv.tab: "Tabs" => "Pestañas"
// pv.color: "color" => "Color"
// pv.email: "email" => "Correo electrónico"
// pv.password: "password" => "contraseña"
// pv.tel: "tel" => "Tel"
// pv.url: "url" => "URL"
// inputType.color: "Color" => "Color"
// inputType.date: "Date" => "Fecha"
// inputType.datetime-local: "Date and Time" => "Fecha y hora"
// inputType.email: "Email" => "Correo electrónico"
// inputType.month: "Month" => "Mes"
// inputType.number: "Number" => "Número"
// inputType.password: "Password" => "Contraseña"
// inputType.range: "Range" => "Gama"
// inputType.tel: "Phone Number" => "Número de teléfono"
// inputType.text: "Text" => "Mensaje de texto"
// inputType.time: "Time" => "Hora"
// inputType.url: "URL" => "URL"
// inputType.week: "Week" => "Semana"
// pv.onBlur: "On blur" => "En desenfoque"
// widthMode.auto: "Auto" => "Automático"
// widthMode.responsive: "Responsive" => "Sensible"
// imageFit.cover: "Cover" => "Cubrir"
// imageFit.fill: "Fill" => "Llenar"
// contentMode.auto: "Auto" => "Automático"
// contentMode.video: "Video" => "Vídeo"
// contentMode.youtube: "YouTube" => "YouTube (en inglés)"
// displayMode.auto: "Auto" => "Automático"
// displayMode.dropdown: "Dropdown" => "Menú desplegable"
// rateColorMode.default: "Default" => "Predeterminado"
// autoGenerate.true: "Generate" => "Generar"
// autoGenerate.false: "Enter manually" => "Entrar manualmente"
// rateType.labels: "Labels" => "Etiquetas"
// rateType.stars: "Stars" => "Estrellas"
// rateType.smileys: "Smileys" => "Emoticonos"
// op.and: "and" => "y"
// op.or: "or" => "o"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Las cookies impiden que los usuarios completen la misma encuesta dos veces."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Cambia el tamaño del área visible del campo de entrada. Utilice el ajuste <b>Validación → Longitud máxima</b> para limitar la longitud de entrada."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Utilice {0} como marcador de posición para el valor real."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Visible sólo cuando al menos una columna tiene el tipo Total o la expresión Total."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Consulte la descripción del atributo [accept](https://www.w3schools.com/tags/att_input_accept.asp) para obtener más información."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Aplicable solo a los tipos de celda Radiogroup y Checkbox."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Consulte la descripción del atributo [autocompletar](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) para obtener más información."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Si no establece esta propiedad, la respuesta se almacenará en un campo especificado por la propiedad Name."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Si la columna especificada contiene valores idénticos, la encuesta arroja el error \"Valor de clave no única\"."
// p.tabAlign: "Tab alignment" => "Alineación de tabulaciones"
// p.logoFit: "Logo fit" => "Ajuste del logotipo"
// p.pages: "Pages" => "Páginas"
// p.questions: "Questions" => "Preguntas"
// p.calculatedValues: "Calculated values" => "Valores calculados"
// p.surveyId: "Survey id" => "ID de la encuesta"
// p.surveyPostId: "Survey post id" => "ID de publicación de la encuesta"
// p.surveyShowDataSaving: "Survey show data saving" => "La encuesta muestra el ahorro de datos"
// p.questionDescriptionLocation: "Question description location" => "Ubicación de la descripción de la pregunta"
// p.progressBarType: "Progress bar type" => "Tipo de barra de progreso"
// p.showTOC: "Show TOC" => "Mostrar TDC"
// p.tocLocation: "Toc location" => "Ubicación de Toc"
// p.questionTitlePattern: "Question title pattern" => "Patrón de título de pregunta"
// p.widthMode: "Width mode" => "Modo de anchura"
// p.showBrandInfo: "Show brand info" => "Mostrar información de la marca"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "Usar valores de visualización en textos dinámicos"
// p.descriptionLocation: "Description location" => "Descripción ubicación"
// p.defaultValueExpression: "Default value expression" => "Expresión de valor predeterminada"
// p.bindings: "Bindings" => "Enlaces"
// p.renderAs: "Render as" => "Renderizar como"
// p.attachOriginalItems: "Attach original items" => "Adjuntar elementos originales"
// p.cellHint: "Cell hint" => "Sugerencia de celda"
// p.isUnique: "Is unique" => "Es único"
// p.showInMultipleColumns: "Show in multiple columns" => "Mostrar en varias columnas"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Total máximo de fracción de dígitos"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Total de dígitos de fracción mínima"
// p.detailElements: "Detail elements" => "Elementos de detalle"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Permitir acciones adaptables"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "Panel de detalles mostrar sobre la adición"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Opciones de carga diferida habilitadas"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Opciones de tamaño de página de carga diferida"
// p.inputFieldComponent: "Input field component" => "Componente de campo de entrada"
// p.itemComponent: "Item component" => "Componente de elemento"
// p.min: "Min" => "Min"
// p.max: "Max" => "Máximo"
// p.minValueExpression: "Min value expression" => "Expresión de valor mínimo"
// p.maxValueExpression: "Max value expression" => "Expresión de valor máximo"
// p.step: "Step" => "Paso"
// p.dataList: "Data list" => "Lista de datos"
// p.elements: "Elements" => "Elementos"
// p.content: "Content" => "Contenido"
// p.navigationTitle: "Navigation title" => "Título de navegación"
// p.navigationDescription: "Navigation description" => "Descripción de navegación"
// p.longTap: "Long tap" => "Toque largo"
// p.autoGrow: "Auto grow" => "Cultivo automático"
// p.allowResize: "Allow resizing" => "Permitir cambiar el tamaño"
// p.acceptCarriageReturn: "Accept carriage return" => "Aceptar devolución de transporte"
// p.displayMode: "Display mode" => "Modo de visualización"
// p.rateType: "Rate type" => "Tipo de tarifa"
// p.contentMode: "Content mode" => "Modo de contenido"
// p.imageFit: "Image fit" => "Ajuste de imagen"
// p.altText: "Alt text" => "Texto alternativo"
// p.height: "Height" => "Altura"
// p.penColor: "Pen color" => "Color de la pluma"
// p.backgroundColor: "Background color" => "Color de fondo"
// p.templateElements: "Template elements" => "Elementos de plantilla"
// p.operator: "Operator" => "Operador"
// p.isVariable: "Is variable" => "Es variable"
// p.runExpression: "Run expression" => "Ejecutar expresión"
// p.showCaption: "Show caption" => "Mostrar pie de foto"
// p.iconName: "Icon name" => "Nombre del icono"
// p.iconSize: "Icon size" => "Tamaño del icono"
// p.precision: "Precision" => "Precisión"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Área del controlador de arrastre de matriz"
// p.backgroundImage: "Background image" => "Imagen de fondo"
// p.backgroundImageFit: "Background image fit" => "Ajuste de imagen de fondo"
// p.backgroundImageAttachment: "Background image attachment" => "Datos adjuntos de imagen de fondo"
// p.backgroundOpacity: "Background opacity" => "Opacidad de fondo"
// p.selectToRankEnabled: "Select to rank enabled" => "Seleccione para clasificar habilitado"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Seleccione para clasificar el diseño de áreas"
// p.allowCameraAccess: "Allow camera access" => "Permitir el acceso a la cámara"
// p.scaleColorMode: "Scale color mode" => "Modo de color de escala"
// p.rateColorMode: "Rate color mode" => "Modo de color de tasa"
// p.templateTabTitle: "Template tab title" => "Título de la pestaña Plantilla"
// p.templateVisibleIf: "Template visible if" => "Plantilla visible si"
// p.copyDisplayValue: "Copy display value" => "Copiar valor de visualización"
// theme.--background: "Background color" => "Color de fondo"
// theme.--background-dim-light: "Background dim light color" => "Color de luz tenue del fondo"
// theme.--primary-foreground: "Primary foreground color" => "Color primario de primer plano"
// theme.--foreground: "Foreground color" => "Color de primer plano"
// theme.--base-unit: "Base unit" => "Unidad base"
// theme.groupAdvanced: "Advanced" => "Avanzado"
// theme.themeName: "Theme" => "Tema"
// theme.isPanellessss: "Question appearance" => "Apariencia de la pregunta"
// theme.isPanellessPanels: "Default" => "Predeterminado"
// theme.isPanellessLightweight: "Without Panels" => "Sin paneles"
// theme.themePaletteLight: "Light" => "Luz"
// theme.themePaletteDark: "Dark" => "Oscuro"
// theme.primaryColor: "Accent color" => "Color de énfasis"
// theme.primaryDefaultColor: "Default" => "Predeterminado"
// theme.primaryDarkColor: "Hover" => "Cernerse"
// theme.primaryLightColor: "Selected" => "Seleccionado"
// theme.backgroundDimColor: "Background color" => "Color de fondo"
// theme.backgroundImage: "Background image" => "Imagen de fondo"
// theme.backgroundImageFitAuto: "Auto" => "Automático"
// theme.backgroundImageFitCover: "Cover" => "Cubrir"
// theme.backgroundImageFitContain: "Contain" => "Contener"
// theme.backgroundOpacity: "Opacity" => "Opacidad"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Fijo"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Pergamino"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Opacidad del fondo del panel"
// theme.questionBackgroundTransparency: "Question background opacity" => "Opacidad de fondo de la pregunta"
// theme.questionPanel: "Panel background and corner radius" => "Fondo del panel y radio de esquina"
// theme.questionTitle: "Question title font" => "Fuente del título de la pregunta"
// theme.questionDescription: "Question description font" => "Fuente de descripción de la pregunta"
// theme.editorPanel: "Input element" => "Elemento de entrada"
// theme.editorFont: "Input element font" => "Fuente del elemento de entrada"
// theme.backcolor: "Default background" => "Fondo predeterminado"
// theme.hovercolor: "Hover background" => "Pasar el cursor de fondo"
// theme.borderDecoration: "Border decoration" => "Decoración de bordes"
// theme.accentBackground: "Accent background" => "Fondo de acento"
// theme.accentForeground: "Accent foreground" => "Primer plano de acento"
// theme.primaryForecolor: "Default color" => "Color predeterminado"
// theme.primaryForecolorLight: "Disabled color" => "Color deshabilitado"
// theme.linesColors: "Minor line colors" => "Colores de línea menores"
// theme.borderDefault: "Darker" => "Oscuro"
// theme.borderLight: "Lighter" => "Encendedor"
// theme.fontFamily: "Font family" => "Familia de fuentes"
// theme.fontSize: "Font size" => "Tamaño de fuente"
// theme.color: "Color" => "Color"
// theme.size: "Size" => "Tamaño"
// theme.fontWeightRegular: "Regular" => "Regular"
// theme.fontWeightHeavy: "Heavy" => "Pesado"
// theme.fontWeightSemiBold: "Semi-bold" => "Semi-negrita"
// theme.fontWeightBold: "Bold" => "Audaz"
// theme.scale: "Scale" => "Escama"
// theme.cornerRadius: "Corner radius" => "Radio de esquina"
// theme.surveyTitleFont: "Survey title font" => "Fuente del título de la encuesta"
// theme.pageTitle: "Page title font" => "Fuente del título de la página"
// theme.pageDescription: "Page description font" => "Fuente de descripción de la página"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Agregar efecto de sombra"
// theme.opacity: "Opacity" => "Opacidad"
// theme.boxShadowBlur: "Blur" => "Desdibujar"
// theme.boxShadowSpread: "Spread" => "Propagación"
// theme.boxShadowDrop: "Drop" => "Soltar"
// theme.boxShadowInner: "Inner" => "Interior"
// theme.questionShadow: "Shadow effects" => "Efectos de sombra"
// theme.editorShadow: "Input element shadow effects" => "Efectos de sombra del elemento de entrada"
// names.default: "Default" => "Predeterminado"
// names.contrast: "Contrast" => "Contraste"
// names.plain: "Plain" => "Llanura"
// names.simple: "Simple" => "Sencillo"
// names.blank: "Blank" => "Espacio en blanco"
// names.double: "Double" => "Doble"
// names.bulk: "Bulk" => "Bulto"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo 3D"
// names.playful: "Playful" => "Juguetón"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Cerceta"
// colors.blue: "Blue" => "Azul"
// colors.purple: "Purple" => "Morado"
// colors.orchid: "Orchid" => "Orquídea"
// colors.tulip: "Tulip" => "Tulipán"
// colors.brown: "Brown" => "Marrón"
// colors.green: "Green" => "Verde"
// names.sharp: "Sharp" => "Afilado"
// names.borderless: "Borderless" => "Sin bordes"
// names.flat: "Flat" => "Plano"
// names.doubleborder: "Double Border" => "Doble Borde"
// names.layered: "Layered" => "Capas"
// names.solid: "Solid" => "Sólido"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "¿Está seguro de que desea eliminar todas las cadenas de este idioma?"
// ed.themeResetButton: "Reset theme settings to default" => "Restablecer la configuración predeterminada del tema"
// theme.placeholderColor: "Placeholder color" => "Color del marcador de posición"
// ed.themeSettings: "Theme Settings" => "Configuración del tema"
// ed.themeSettingsTooltip: "Open theme settings" => "Abrir la configuración del tema"
// pe.resetToDefaultCaption: "Reset" => "Restablecimiento"
// pv.file: "Local files" => "Archivos locales"
// pv.camera: "Camera" => "Cámara"
// pv.file-camera: "Local files or camera" => "Archivos locales o cámara"
// ed.translateUsigAI: "Auto-translate All" => "Traducir automáticamente todo"
// ed.translationDialogTitle: "Untranslated strings" => "Cadenas sin traducir"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Introduce al menos {0} artículos"
// lg.question_resetValueName: "Reset question value" => "Restablecer valor de pregunta"
// lg.column_resetValue: "Reset column value" => "Restablecer el valor de la columna"
// pe.markRequired: "Mark as required" => "Marcar según sea necesario"
// pe.removeRequiredMark: "Remove the required mark" => "Quitar la marca requerida"
// p.resetValueIf: "Reset value if" => "Restablecer valor si"
// lg.question_setValueName: "Set question value" => "Establecer el valor de la pregunta"
// lg.column_resetValueName: "Reset column value" => "Restablecer valor de columna"
// lg.column_setValueName: "Set column value" => "Establecer el valor de la columna"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Una expresión cuyo resultado se asignará a la pregunta de destino."
// survey.title: "Title" => "Título"
// page.title: "Title" => "Título"
// p.setValueIf: "Set value if" => "Establezca el valor si"
// theme.header: "Header" => "Encabezado"
// theme.backgroundImageFitFill: "Stretch" => "Elasticidad"
// theme.backgroundImageFitTile: "Tile" => "Teja"
// theme.headerView: "View" => "Vista"
// theme.headerViewBasic: "Basic" => "Básico"
// theme.headerViewAdvanced: "Advanced" => "Avanzado"
// theme.headerInheritWidthFrom: "Content area width" => "Ancho del área de contenido"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Igual que la encuesta"
// theme.headerInheritWidthFromPage: "Fit to page" => "Ajustar a la página"
// theme.headerTextAreaWidth: "Text width" => "Ancho del texto"
// theme.headerBackgroundColorSwitch: "Background color" => "Color de fondo"
// theme.headerBackgroundColorNone: "None" => "Ninguno"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Color de acento"
// theme.headerBackgroundColorCustom: "Custom" => "Costumbre"
// theme.horizontalAlignmentLeft: "Left" => "Izquierda"
// theme.horizontalAlignmentCenter: "Center" => "Centro"
// theme.horizontalAlignmentRight: "Right" => "Derecha"
// theme.verticalAlignmentTop: "Top" => "Arriba"
// theme.verticalAlignmentMiddle: "Middle" => "Medio"
// theme.verticalAlignmentBottom: "Bottom" => "Fondo"
// theme.logoPosition: "Logo Position" => "Posición del logotipo"
// theme.headerTitlePosition: "Title Position" => "Posición del título"
// lg.question_resetValueText: "reset value for question: {0}" => "Restablecer valor para la pregunta: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Asignar valor: {1} a la pregunta: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Restablecer el valor de celda de la columna: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Asignar valor de celda: {1} a columna: {0}"
// ed.surveyJsonExportButton: "Export" => "Exportar"
// ed.surveyJsonImportButton: "Import" => "Importación"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Copiar en el portapapeles"
// pe.filePlaceholder: "File placeholder text" => "Texto del marcador de posición del archivo"
// pe.photoPlaceholder: "Photo placeholder text" => "Texto del marcador de posición de la foto"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Texto de marcador de posición de archivo o foto"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Se aplica cuando \"Tipo de fuente\" es \"Archivos locales\" o cuando la cámara no está disponible"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Se aplica cuando \"Tipo de fuente\" es \"Cámara\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Se aplica cuando \"Tipo de fuente\" es \"Archivos locales o cámara\"."
// theme.background: "Background" => "Fondo"
// theme.appearance: "Appearance" => "Apariencia"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "¿Realmente quieres resetear el tema? Todas tus personalizaciones se perderán."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Sí, restablece el tema"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Ajuste al contenedor"
// signaturepad.showPlaceholder: "Show the placeholder" => "Mostrar el marcador de posición"
// signaturepad.placeholder: "Placeholder text" => "Texto de marcador de posición"
// theme.surveyDescriptionFont: "Survey description font" => "Fuente de descripción de la encuesta"
// ed.prevFocus: "Focus previous" => "Enfoque anterior"
// ed.nextFocus: "Focus next" => "Enfoque siguiente"
// ed.saveTheme: "Save Theme" => "Guardar tema"
// ed.saveThemeTooltip: "Save Theme" => "Guardar tema"
// lg.page_requireName: "Make page required" => "Hacer que la página sea obligatoria"
// lg.panel_requireName: "Make page required" => "Hacer que la página sea obligatoria"
// signaturepad.signatureWidth: "Signature area width" => "Ancho del área de firma"
// signaturepad.signatureHeight: "Signature area height" => "Altura del área de firma"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Escalado automático del área de firma"
// signaturepad.penMinWidth: "Minimum pen width" => "Ancho mínimo del lápiz"
// signaturepad.penMaxWidth: "Maximum pen width" => "Ancho máximo del lápiz"
// theme.headerDescriptionPosition: "Description position" => "Descripción posición"
// ed.propertyGridNoResultsFound: "No results found" => "No se han encontrado resultados"
// pv.leftRight: "Left and right" => "Izquierda y derecha"
// p.sourceType: "Source type" => "Tipo de origen"
// p.fitToContainer: "Fit to container" => "Ajuste al contenedor"
// p.setValueExpression: "Set value expression" => "Establecer expresión de valor"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Las opciones se cargan desde un servicio web."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Ir a la configuración"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Vista previa de las opciones de elección cargadas"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Evitar respuestas duplicadas en filas"
// theme.advancedMode: "Advanced mode" => "Modo avanzado"
// theme.backgroundCornerRadius: "Background and corner radius" => "Fondo y radio de vértice"
// theme.colorsTitle: "Colors" => "Colores"
// theme.font: "Font" => "Fuente"
// theme.lines: "Lines" => "Lineas"
// theme.titleFont: "Title font" => "Fuente del título"
// theme.descriptionFont: "Description font" => "Fuente descriptiva"
// theme.shadow: "Shadow effects" => "Efectos de sombra"
// ed.translateUsigAIFrom: "Translate from: " => "Traducir de: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Permitir la opción Negarse a responder"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Permitir la opción No sé"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Permitir la opción Negarse a responder"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Permitir la opción No sé"
// pv.contain: "Contain" => "Contener"
// pv.cover: "Cover" => "Cubrir"
// pv.fill: "Fill" => "Llenar"
// pe.transposeData: "Transpose rows to columns" => "Transponer filas a columnas"
// layout.panel: "Layout" => "Diseño"
// layout.question: "Layout" => "Diseño"
// layout.base: "Layout" => "Diseño"
// panel.name: "Panel name" => "Nombre del panel"
// panel.title: "Panel title" => "Título de la viñeta"
// panel.description: "Panel description" => "Descripción del panel"
// panel.visibleIf: "Make the panel visible if" => "Haga que el panel sea visible si"
// panel.requiredIf: "Make the panel required if" => "Haga que el panel sea obligatorio si"
// panel.questionsOrder: "Question order within the panel" => "Orden de las preguntas dentro del panel"
// panel.startWithNewLine: "Display the panel on a new line" => "Mostrar el panel en una nueva línea"
// panel.state: "Panel collapse state" => "Estado de contracción del panel"
// panel.width: "Inline panel width" => "Ancho del panel en línea"
// panel.minWidth: "Minimum panel width" => "Anchura mínima del panel"
// panel.maxWidth: "Maximum panel width" => "Anchura máxima del panel"
// panel.showNumber: "Number panels" => "Paneles numéricos"
// paneldynamic.name: "Panel name" => "Nombre del panel"
// paneldynamic.title: "Panel title" => "Título de la viñeta"
// paneldynamic.description: "Panel description" => "Descripción del panel"
// paneldynamic.visibleIf: "Make the panel visible if" => "Haga que el panel sea visible si"
// paneldynamic.requiredIf: "Make the panel required if" => "Haga que el panel sea obligatorio si"
// paneldynamic.page: "Move the panel to page" => "Mover el panel a la página"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Mostrar el panel en una nueva línea"
// paneldynamic.state: "Panel collapse state" => "Estado de contracción del panel"
// paneldynamic.width: "Inline panel width" => "Ancho del panel en línea"
// paneldynamic.minWidth: "Minimum panel width" => "Anchura mínima del panel"
// paneldynamic.maxWidth: "Maximum panel width" => "Anchura máxima del panel"
// paneldynamic.templateDescription: "Panel description pattern" => "Patrón de descripción del panel"
// paneldynamic.templateTitle: "Panel title pattern" => "Patrón de título de panel"
// paneldynamic.noEntriesText: "Empty panel text" => "Texto de panel vacío"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Patrón de título de tabulación"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Hacer visible un panel individual si"
// paneldynamic.hideNumber: "Hide the panel number" => "Ocultar el número de panel"
// paneldynamic.titleLocation: "Panel title alignment" => "Alineación del título del panel"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Alineación de la descripción del panel"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Alineación del título de la pregunta"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Alineación de mensajes de error"
// paneldynamic.newPanelPosition: "New panel location" => "Nueva ubicación del panel"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Evitar respuestas duplicadas en la siguiente pregunta"
// question.name: "Question name" => "Nombre de la pregunta"
// question.title: "Question title" => "Título de la pregunta"
// question.description: "Question description" => "Descripción de la pregunta"
// question.visibleIf: "Make the question visible if" => "Haz que la pregunta sea visible si"
// question.requiredIf: "Make the question required if" => "Haga que la pregunta sea obligatoria si:"
// question.state: "Question box collapse state" => "Estado de contracción del cuadro de pregunta"
// question.hideNumber: "Hide the question number" => "Ocultar el número de pregunta"
// question.titleLocation: "Question title alignment" => "Alineación del título de la pregunta"
// question.descriptionLocation: "Question description alignment" => "Alineación de la descripción de la pregunta"
// question.errorLocation: "Error message alignment" => "Alineación de mensajes de error"
// question.indent: "Increase the inner indent" => "Aumentar la sangría interior"
// question.width: "Inline question width" => "Ancho de la pregunta en línea"
// question.minWidth: "Minimum question width" => "Ancho mínimo de la pregunta"
// question.maxWidth: "Maximum question width" => "Ancho máximo de la pregunta"
// question.textUpdateMode: "Update input field value" => "Actualizar el valor del campo de entrada"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Mostrar el botón Borrar dentro del área de firma"
// signaturepad.penColor: "Stroke color" => "Color del trazo"
// comment.rows: "Input field height (in lines)" => "Altura del campo de entrada (en líneas)"
// expression.name: "Expression name" => "Nombre de la expresión"
// expression.title: "Expression title" => "Título de la expresión"
// expression.description: "Expression description" => "Descripción de la expresión"
// expression.expression: "Expression" => "Expresión"
// trigger.expression: "Expression" => "Expresión"
// calculatedvalue.expression: "Expression" => "Expresión"
// survey.description: "Survey description" => "Descripción de la encuesta"
// page.name: "Page name" => "Nombre de la página"
// page.description: "Page description" => "Descripción de la página"
// page.visibleIf: "Make the page visible if" => "Hacer que la página sea visible si"
// page.requiredIf: "Make the page required if" => "Haga que la página sea obligatoria si"
// page.questionsOrder: "Question order on the page" => "Orden de las preguntas en la página"
// matrixdropdowncolumn.name: "Column name" => "Nombre de la columna"
// matrixdropdowncolumn.title: "Column title" => "Título de la columna"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Evitar respuestas duplicadas"
// matrixdropdowncolumn.width: "Column width" => "Anchura de columna"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Anchura mínima de columna"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Altura del campo de entrada (en líneas)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Haga que la columna sea visible si"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Haga que la columna sea obligatoria si"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Cada opción en una columna separada"
// multipletextitem.name: "Name" => "Nombre"
// multipletextitem.title: "Title" => "Título"
// pe.rateDescriptionLocation: "Label alignment" => "Alineación de etiquetas"
// pe.cellErrorLocation: "Cell error message alignment" => "Alineación de mensajes de error de celda"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Todavía no tienes ninguna columna"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Todavía no tienes ninguna fila"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Todavía no tiene ninguna regla de validación"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Todavía no tiene ninguna variable personalizada"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Todavía no tienes ningún desencadenante"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Todavía no tienes ningún enlace"
// pe.addNew@columns: "Add new column" => "Agregar nueva columna"
// pe.addNew@rows: "Add new row" => "Agregar nueva fila"
// pe.addNew@validators: "Add new rule" => "Agregar nueva regla"
// pe.addNew@calculatedValues: "Add new variable" => "Adición de una nueva variable"
// pe.addNew@triggers: "Add new trigger" => "Agregar nuevo disparador"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Agregar nueva URL"
// choicesbyurl.url: "Web service's URL" => "URL del servicio web"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Mostrar los títulos de las páginas en la barra de progreso"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Mostrar números de página en la barra de progreso"
// itemvalue.visibleIf: "Make the option visible if" => "Haga que la opción sea visible si"
// itemvalue.enableIf: "Make the option selectable if" => "Haga que la opción sea seleccionable si"
// panel.layout: "Panel Layout" => "Diseño de paneles"
// tabs.questionSettings: "Question Settings" => "Configuración de la pregunta"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Ej.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Ej.: categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Ej.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Ej.: 6 pulgadas"
// pe.minWidth_placeholder: "Ex.: 600px" => "Ej.: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Ej.: 50%"
// pv.selected: "Selected" => "Seleccionado"
// pv.unselected: "Unselected" => "Sin seleccionar"
// pv.center: "Center" => "Centro"
// pv.middle: "Middle" => "Medio"
// pv.next: "Next" => "Próximo"
// pv.last: "Last" => "Último"
// clearIfInvisible.none: "Never" => "Nunca"
// questionsOnPageMode.standard: "Original structure" => "Estructura original"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Mostrar todas las preguntas en una sola página"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Mostrar una sola pregunta por página"
// pv.auto: "Auto" => "Automático"
// panelsState.firstExpanded: "First expanded" => "Primera expansión"
// rateColorMode.scale: "Scale" => "Escama"
// scaleColorMode.monochrome: "Monochrome" => "Monocromo"
// scaleColorMode.colored: "Colored" => "Coloreado"
// state.default: "Locked" => "Cerrado con llave"
// showQuestionNumbers.default: "Auto-numbering" => "Numeración automática"
// showQuestionNumbers.on: "Auto-numbering" => "Numeración automática"
// showQuestionNumbers.onPage: "Reset on each page" => "Restablecer en cada página"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Restablecer en cada panel"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Restablecer en cada panel"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Continuar a través de la encuesta"
// showQuestionNumbers.off: "No numbering" => "Sin numeración"
// descriptionLocation.underTitle: "Under the question title" => "Bajo el título de la pregunta"
// descriptionLocation.underInput: "Under the input field" => "En el campo de entrada"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Junto a las opciones"
// selectToRankAreasLayout.vertical: "Above choices" => "Opciones anteriores"
// displayStyle.decimal: "Decimal" => "Decimal"
// displayStyle.currency: "Currency" => "Divisa"
// displayStyle.percent: "Percentage" => "Porcentaje"
// displayStyle.date: "Date" => "Fecha"
// totalDisplayStyle.decimal: "Decimal" => "Decimal"
// totalDisplayStyle.currency: "Currency" => "Divisa"
// totalDisplayStyle.percent: "Percentage" => "Porcentaje"
// totalDisplayStyle.date: "Date" => "Fecha"
// rowsOrder.initial: "Original" => "Texto original en"
// questionsOrder.initial: "Original" => "Texto original en"
// showProgressBar.aboveheader: "Above the header" => "Encima del encabezado"
// showProgressBar.belowheader: "Below the header" => "Debajo del encabezado"
// pv.sum: "Sum" => "Suma"
// pv.count: "Count" => "Contar"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Máximo"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Contiene"
// searchMode.startsWith: "Starts with" => "Comienza con"
// panel.name: "A panel ID that is not visible to respondents." => "Un ID de panel que no es visible para los encuestados."
// panel.description: "Type a panel subtitle." => "Escriba un subtítulo de panel."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Utilice el icono de la varita mágica para establecer una regla condicional que determine la visibilidad del panel."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Utilice el icono de la varita mágica para establecer una regla condicional que desactive el modo de solo lectura para el panel."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Utilice el icono de la varita mágica para establecer una regla condicional que impida el envío de encuestas a menos que al menos una pregunta anidada tenga una respuesta."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Se aplica a todas las preguntas de este panel. Si desea anular esta configuración, defina reglas de alineación de títulos para preguntas individuales. La opción \"Heredar\" aplica la configuración a nivel de página (si está establecida) o a nivel de encuesta (\"Superior\" de forma predeterminada)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Establece la ubicación de un mensaje de error en relación con todas las preguntas del panel. La opción \"Heredar\" aplica la configuración a nivel de página (si se establece) o a nivel de encuesta."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Mantiene el orden original de las preguntas o las aleatoriza. La opción \"Heredar\" aplica la configuración a nivel de página (si se establece) o a nivel de encuesta."
// panel.page: "Repositions the panel to the end of a selected page." => "Cambia la posición del panel al final de una página seleccionada."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Añade espacio o margen entre el contenido del panel y el borde izquierdo del cuadro del panel."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Anule la selección para mostrar el panel en una línea con la pregunta o el panel anterior. La configuración no se aplica si el panel es el primer elemento del formulario."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Elija entre: \"Expandido\": el panel se muestra en su totalidad y se puede contraer; \"Contraído\": el panel muestra solo el título y la descripción y se puede expandir; \"Bloqueado\": el panel se muestra en su totalidad y no se puede contraer."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Define la anchura del panel en proporción a otros elementos topográficos de la misma línea. Acepta valores CSS (px, %, in, pt, etc.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "Un ID de panel que no es visible para los encuestados."
// paneldynamic.description: "Type a panel subtitle." => "Escriba un subtítulo de panel."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Utilice el icono de la varita mágica para establecer una regla condicional que determine la visibilidad del panel."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Utilice el icono de la varita mágica para establecer una regla condicional que desactive el modo de solo lectura para el panel."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Utilice el icono de la varita mágica para establecer una regla condicional que impida el envío de encuestas a menos que al menos una pregunta anidada tenga una respuesta."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Se aplica a todas las preguntas de este panel. Si desea anular esta configuración, defina reglas de alineación de títulos para preguntas individuales. La opción \"Heredar\" aplica la configuración a nivel de página (si está establecida) o a nivel de encuesta (\"Superior\" de forma predeterminada)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Establece la ubicación de un mensaje de error en relación con una pregunta con entrada no válida. Elija entre: \"Arriba\": se coloca un texto de error en la parte superior del cuadro de pregunta; \"Abajo\": se coloca un texto de error en la parte inferior del cuadro de pregunta. La opción \"Heredar\" aplica la configuración a nivel de página (si está establecida) o a nivel de encuesta (\"Superior\" de forma predeterminada)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Establece la ubicación de un mensaje de error en relación con todas las preguntas del panel. La opción \"Heredar\" aplica la configuración a nivel de página (si se establece) o a nivel de encuesta."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Cambia la posición del panel al final de una página seleccionada."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Añade espacio o margen entre el contenido del panel y el borde izquierdo del cuadro del panel."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Anule la selección para mostrar el panel en una línea con la pregunta o el panel anterior. La configuración no se aplica si el panel es el primer elemento del formulario."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Elija entre: \"Expandido\": el panel se muestra en su totalidad y se puede contraer; \"Contraído\": el panel muestra solo el título y la descripción y se puede expandir; \"Bloqueado\": el panel se muestra en su totalidad y no se puede contraer."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Define la anchura del panel en proporción a otros elementos topográficos de la misma línea. Acepta valores CSS (px, %, in, pt, etc.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Escriba una plantilla para los títulos de los paneles dinámicos. Utilice {panelIndex} para la posición general del panel y {visiblePanelIndex} para su orden entre los paneles visibles. Inserte estos marcadores de posición en el patrón para agregar numeración automática."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Escriba una plantilla para los títulos de las pestañas. Utilice {panelIndex} para la posición general de un panel y {visiblePanelIndex} para su orden entre los paneles visibles. Inserte estos marcadores de posición en el patrón para agregar numeración automática."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Esta configuración le permite controlar la visibilidad de paneles individuales dentro del panel dinámico. Utilice el marcador de posición '{panel}' para hacer referencia al panel actual en la expresión."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Esta configuración es heredada automáticamente por todas las preguntas dentro de este panel. Si desea anular esta configuración, defina reglas de alineación de títulos para preguntas individuales. La opción \"Heredar\" aplica la configuración a nivel de página (si está establecida) o a nivel de encuesta (\"Superior\" de forma predeterminada)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "La opción \"Heredar\" aplica la configuración a nivel de página (si está establecida) o a nivel de encuesta (\"Debajo del título del panel\" de forma predeterminada)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Define la posición de un panel recién añadido. De forma predeterminada, los nuevos paneles se agregan al final. Seleccione \"Siguiente\" para insertar un nuevo panel después del actual."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Duplica las respuestas del último panel y las asigna al siguiente panel dinámico agregado."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Haga referencia a un nombre de pregunta para requerir que un usuario proporcione una respuesta única para esta pregunta en cada panel."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Esta configuración le permite asignar un valor de respuesta predeterminado basado en una expresión. La expresión puede incluir cálculos básicos: '{q1_id} + {q2_id}', expresiones booleanas, como '{edad} > 60', y funciones: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. El valor determinado por esta expresión sirve como el valor predeterminado inicial que puede ser anulado por la entrada manual de un encuestado."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Usa el ícono de la varita mágica para establecer una regla condicional que determine cuándo la entrada de un encuestado se restablece al valor basado en la \"Expresión de valor predeterminado\" o \"Expresión de valor establecido\" o al valor de \"Respuesta predeterminada\" (si cualquiera de los dos está establecido)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Utilice el icono de la varita mágica para establecer una regla condicional que determine cuándo ejecutar la \"Expresión de valor establecido\" y asigne dinámicamente el valor resultante como respuesta."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Especifique una expresión que defina el valor que se establecerá cuando se cumplan las condiciones de la regla \"Establecer valor si\". La expresión puede incluir cálculos básicos: '{q1_id} + {q2_id}', expresiones booleanas, como '{edad} > 60', y funciones: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc. El valor determinado por esta expresión puede ser anulado por la entrada manual de un encuestado."
// question.name: "A question ID that is not visible to respondents." => "Un identificador de pregunta que no es visible para los encuestados."
// question.description: "Type a question subtitle." => "Escribe un subtítulo para la pregunta."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Utilice el icono de la varita mágica para establecer una regla condicional que determine la visibilidad de la pregunta."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Utilice el icono de la varita mágica para establecer una regla condicional que deshabilite el modo de solo lectura para la pregunta."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Utilice el icono de la varita mágica para establecer una regla condicional que impida que la encuesta avance o se envíe a menos que la pregunta reciba una respuesta."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Anule la selección para mostrar la pregunta en una línea con la pregunta o el panel anterior. La configuración no se aplica si la pregunta es el primer elemento del formulario."
// question.page: "Repositions the question to the end of a selected page." => "Cambia la posición de la pregunta al final de una página seleccionada."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Elija entre: \"Expandido\": el cuadro de pregunta se muestra en su totalidad y se puede contraer; \"Contraído\": el cuadro de pregunta muestra solo el título y la descripción y se puede expandir; \"Bloqueado\": el cuadro de pregunta se muestra en su totalidad y no se puede contraer."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Anula las reglas de alineación de títulos definidas en un panel, página o encuesta. La opción \"Heredar\" aplica cualquier configuración de nivel superior (si está establecida) o configuración de nivel de encuesta (\"Superior\" de forma predeterminada)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "La opción \"Heredar\" aplica la configuración a nivel de encuesta (\"Bajo el título de la pregunta\" de forma predeterminada)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Establece la ubicación de un mensaje de error en relación con la pregunta con entrada no válida. Elija entre: \"Arriba\": se coloca un texto de error en la parte superior del cuadro de pregunta; \"Abajo\": se coloca un texto de error en la parte inferior del cuadro de pregunta. La opción \"Heredar\" aplica la configuración a nivel de encuesta (\"Superior\" de forma predeterminada)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Agrega espacio o margen entre el contenido de la pregunta y el borde izquierdo del cuadro de pregunta."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Establece el ancho de la pregunta en proporción a otros elementos de la encuesta en la misma línea. Acepta valores CSS (px, %, in, pt, etc.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Utilice el icono de la varita mágica para establecer una regla de validación para la pregunta."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Elija entre: \"Al perder el foco\": el valor se actualiza cuando el campo de entrada pierde el foco; \"Mientras escribes\": el valor se actualiza en tiempo real, a medida que los usuarios escriben. La opción \"Heredar\" aplica la configuración a nivel de encuesta (\"Al perder el foco\" de forma predeterminada)."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Puede utilizar cualquier servicio web como fuente de datos para preguntas de opción múltiple. Para rellenar los valores de opción, introduzca la dirección URL del servicio que proporciona los datos."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Operación de comparación que se utiliza para filtrar la lista desplegable."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Define la anchura del área de firma mostrada y de la imagen resultante."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Define la altura del área de firma mostrada y de la imagen resultante."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Seleccione esta opción si desea que el área de firma ocupe todo el espacio disponible dentro del cuadro de pregunta manteniendo la relación de aspecto predeterminada de 3:2. Cuando se establecen valores de anchura y altura personalizados, la configuración mantendrá la relación de aspecto de estas dimensiones."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Ajusta la altura de la imagen en los resultados de la encuesta."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Ajusta el ancho de la imagen en los resultados de la encuesta."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Anula los valores de altura mínima y máxima."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Anula los valores de anchura mínima y máxima."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Valor\" sirve como un identificador de elemento que se usa en las reglas condicionales; \"Texto\" se muestra a los encuestados."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Esta configuración solo cambia el tamaño del campo de entrada y no afecta al ancho del cuadro de pregunta. Para limitar la longitud de entrada aceptada, vaya a <b>Validación → Límite máximo de caracteres</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Establece el número de líneas mostradas en el campo de entrada. Si la entrada ocupa más líneas, aparecerá la barra de desplazamiento."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Elija entre: \"Editable\": permite a los encuestados completar su encuesta; \"Solo lectura\": deshabilita la edición de formularios."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "Un identificador de columna que no es visible para los encuestados."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Cuando se habilita para una columna, se requiere que un encuestado proporcione una respuesta única para cada pregunta dentro de esta columna."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Establece el número de líneas mostradas en el campo de entrada. Si la entrada ocupa más líneas, aparecerá la barra de desplazamiento."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Utilice el icono de la varita mágica para establecer una regla condicional que determine la visibilidad de la columna."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Utilice el icono de la varita mágica para establecer una regla condicional que deshabilite el modo de solo lectura para la columna."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Utilice el icono de la varita mágica para establecer una regla condicional que impida el envío de encuestas a menos que al menos una pregunta anidada tenga una respuesta."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Cuando se selecciona, crea una columna individual para cada opción de opción."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Elija entre: \"Estático\": establece un ancho fijo; \"Responsivo\": hace que la encuesta ocupe todo el ancho de la pantalla; \"Auto\": aplica cualquiera de los dos dependiendo de los tipos de preguntas utilizados."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Pegue un enlace de imagen (sin límites de tamaño) o haga clic en el icono de la carpeta para buscar un archivo desde su computadora (hasta 64 KB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Establece el ancho del logotipo en unidades CSS (px, %, in, pt, etc.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Establece la altura del logotipo en unidades CSS (px, %, in, pt, etc.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Elija entre: \"Ninguno\": la imagen mantiene su tamaño original; \"Contener\": se cambia el tamaño de la imagen para que se ajuste manteniendo su relación de aspecto; \"Portada\": la imagen llena toda la caja manteniendo su relación de aspecto; \"Relleno\": la imagen se estira para llenar el cuadro sin mantener su relación de aspecto."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Seleccione si desea que la encuesta avance a la página siguiente automáticamente después de que un encuestado responda todas las preguntas de la página actual."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Establece la visibilidad y la ubicación de los botones de navegación en una página."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Establece la visibilidad y la ubicación de una barra de progreso. El valor \"Auto\" muestra la barra de progreso por encima o por debajo del encabezado de la encuesta."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Habilite la página de vista previa con todas las preguntas o solo las respondidas."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Se aplica a todas las preguntas de la encuesta. Esta configuración se puede anular mediante reglas de alineación de títulos en niveles inferiores: panel, página o pregunta. Una configuración de nivel inferior anulará las de un nivel superior."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Un símbolo o una secuencia de símbolos que indican que se requiere una respuesta."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Introduzca un número o una letra con la que desee empezar a numerar."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Establece la ubicación de un mensaje de error en relación con la pregunta con entrada no válida. Elija entre: \"Arriba\": se coloca un texto de error en la parte superior del cuadro de pregunta; \"Abajo\": se coloca un texto de error en la parte inferior del cuadro de pregunta."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Seleccione si desea que el primer campo de entrada de cada página esté listo para la entrada de texto."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Mantiene el orden original de las preguntas o las aleatoriza. El efecto de esta configuración solo es visible en la pestaña Vista previa."
// pehelp.maxTextLength: "For text entry questions only." => "Solo para preguntas de entrada de texto."
// pehelp.maxOthersLength: "For question comments only." => "Solo para comentarios de preguntas."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Seleccione si desea que los comentarios de las preguntas y las preguntas de texto largo aumenten automáticamente en altura en función de la longitud del texto introducido."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Solo para comentarios de preguntas y preguntas de texto largo."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Las variables personalizadas sirven como variables intermedias o auxiliares que se utilizan en los cálculos de formularios. Toman las entradas de los encuestados como valores de origen. Cada variable personalizada tiene un nombre único y una expresión en la que se basa."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Seleccione si desea que el valor calculado de la expresión se guarde junto con los resultados de la encuesta."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Un desencadenador es un evento o condición que se basa en una expresión. Una vez que la expresión se evalúa como \"verdadera\", un desencadenador desencadena una acción. Opcionalmente, una acción de este tipo puede tener una pregunta de destino a la que afecta."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Elija si desea o no borrar los valores de las preguntas ocultas por la lógica condicional y cuándo hacerlo."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Elija entre: \"Al perder el foco\": el valor se actualiza cuando el campo de entrada pierde el foco; \"Mientras escribes\": el valor se actualiza en tiempo real, a medida que los usuarios escriben."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "El valor de la izquierda sirve como identificador de columna que se usa en las reglas condicionales, el valor de la derecha se muestra a los encuestados."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "El valor de la izquierda sirve como un ID de fila que se usa en las reglas condicionales, el valor de la derecha se muestra a los encuestados."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Acepta valores CSS (px, %, in, pt, etc.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Acepta valores CSS (px, %, in, pt, etc.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Establece la ubicación de un mensaje de error en relación con una celda con entrada no válida. La opción \"Heredar\" aplica la configuración de la propiedad \"Alineación de mensajes de error\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "Cuando la propiedad \"Evitar respuestas duplicadas\" está habilitada, un encuestado que intente enviar una entrada duplicada recibirá el siguiente mensaje de error."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Permite calcular los valores totales en función de una expresión. La expresión puede incluir cálculos básicos ('{q1_id} + {q2_id}'), expresiones booleanas ('{edad} > 60') y funciones ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Activa un mensaje en el que se le pide que confirme la eliminación de filas."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Duplica las respuestas de la última fila y las asigna a la siguiente fila dinámica agregada."
// pehelp.description: "Type a subtitle." => "Escribe un subtítulo."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Elige un idioma para comenzar a crear tu encuesta. Para agregar una traducción, cambie a un nuevo idioma y traduzca el texto original aquí o en la pestaña Traducciones."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Establece la ubicación de una sección de detalles en relación con una fila. Elija entre: \"Ninguno\": no se agrega ninguna expansión; \"Debajo de la fila\": se coloca una expansión de fila debajo de cada fila de la matriz; \"Debajo de la fila, mostrar solo una expansión de fila\": una expansión se muestra solo debajo de una sola fila, las expansiones de fila restantes se contraen."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Elija entre: \"Ninguno\": la imagen mantiene su tamaño original; \"Contener\": se cambia el tamaño de la imagen para que se ajuste manteniendo su relación de aspecto; \"Portada\": la imagen llena toda la caja manteniendo su relación de aspecto; \"Relleno\": la imagen se estira para llenar el cuadro sin mantener su relación de aspecto."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Aumenta gradualmente la altura del campo de entrada a medida que se introducen los datos. Anula el ajuste \"Altura del campo de entrada (en líneas)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "El controlador de cambio de tamaño (o pinzamiento) aparece en la esquina y se puede arrastrar para modificar el tamaño del campo de entrada."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Un intervalo de tiempo en segundos después del cual la encuesta avanza automáticamente a la página de agradecimiento."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Un intervalo de tiempo en segundos después del cual la encuesta avanza automáticamente a la página siguiente."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Un intervalo de tiempo en segundos después del cual la encuesta avanza automáticamente a la página siguiente."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Utilice el icono de la varita mágica para establecer una regla condicional que determine la visibilidad de la página."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Utilice el icono de la varita mágica para establecer una regla condicional que deshabilite el modo de solo lectura de la página."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Utilice el icono de la varita mágica para establecer una regla condicional que impida el envío de encuestas a menos que al menos una pregunta anidada tenga una respuesta."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Se aplica a todas las preguntas de esta página. Si desea anular esta configuración, defina reglas de alineación de títulos para preguntas o paneles individuales. La opción \"Heredar\" aplica la configuración a nivel de encuesta (\"Superior\" de forma predeterminada)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Establece la ubicación de un mensaje de error en relación con la pregunta con entrada no válida. Elija entre: \"Arriba\": se coloca un texto de error en la parte superior del cuadro de pregunta; \"Abajo\": se coloca un texto de error en la parte inferior del cuadro de pregunta. La opción \"Heredar\" aplica la configuración a nivel de encuesta (\"Superior\" de forma predeterminada)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Mantiene el orden original de las preguntas o las aleatoriza. La opción \"Heredar\" aplica la configuración a nivel de encuesta (\"Original\" de forma predeterminada). El efecto de esta configuración solo es visible en la pestaña Vista previa."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Establece la visibilidad de los botones de navegación en la página. La opción \"Heredar\" aplica la configuración de nivel de encuesta, que por defecto es \"Visible\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Establece la visibilidad y la ubicación de un temporizador en una página."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Elija entre: \"Bloqueado\": los usuarios no pueden expandir ni contraer paneles; \"Contraer todo\": todos los paneles comienzan en un estado contraído; \"Expandir todo\": todos los paneles comienzan en un estado expandido; \"Primero expandido\": solo el primer panel se expande inicialmente."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Introduzca un nombre de propiedad compartida dentro de la matriz de objetos que contiene las direcciones URL de los archivos de imagen o vídeo que desea mostrar en la lista de opciones."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "El valor de la izquierda sirve como un identificador de elemento utilizado en las reglas condicionales, el valor de la derecha se muestra a los encuestados."
// pehelp.title: "Type a user-friendly title to display." => "Escriba un título fácil de usar para mostrar."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Garantiza que los usuarios no completen la encuesta hasta que se carguen los archivos."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Acepta valores CSS (px, %, in, pt, etc.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Acepta valores CSS (px, %, in, pt, etc.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Acepta valores CSS (px, %, in, pt, etc.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "En los tipos de preguntas de selección única y múltiple, cada opción de opción tiene un ID y un valor de visualización. Cuando se selecciona, esta configuración muestra un valor de visualización en lugar de un valor de ID en las preguntas HTML y en los títulos dinámicos y las descripciones de los elementos de la encuesta."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Elija si desea o no borrar los valores de las preguntas ocultos por la lógica condicional y cuándo hacerlo. La opción \"Heredar\" aplica la configuración de nivel de encuesta (\"Al finalizar la encuesta\" de forma predeterminada)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Elija entre: \"Todas\": copia todas las opciones de elección de la pregunta seleccionada; \"Seleccionado\": copia dinámicamente solo las opciones de elección seleccionadas; \"No seleccionado\": copia dinámicamente solo las opciones de elección no seleccionadas. Las opciones \"Ninguno\" y \"Otro\" se copian de forma predeterminada si están habilitadas en la pregunta de origen."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Cuando se selecciona, los usuarios pueden incluir entradas adicionales en un cuadro de comentarios independiente."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Muestra cada opción de opción especial (\"Ninguno\", \"Otro\", \"Seleccionar todo\") en una nueva línea, incluso cuando se utiliza un diseño de varias columnas."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Especifique la ubicación dentro del dataset de servicio donde se encuentra la matriz de objetos de destino. Déjelo en vacío si la dirección URL ya apunta a la matriz."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Escriba un nombre de propiedad uniforme dentro de la matriz de objetos que contiene los valores que desea mostrar en la lista de opciones."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Seleccione esta opción para permitir que el servicio devuelva una respuesta o matriz vacía."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Utilice el icono de la varita mágica para establecer una regla condicional que determine la visibilidad de todas las opciones de elección."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "El valor de la izquierda sirve como un identificador de elemento utilizado en las reglas condicionales, el valor de la derecha se muestra a los encuestados."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" selecciona entre los modos \"Botones\" y \"Desplegable\" en función del ancho disponible. Cuando el ancho es insuficiente para mostrar los botones, la pregunta muestra un menú desplegable."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Permite conectar preguntas que producen resultados en diferentes formatos. Cuando estas preguntas se vinculan entre sí mediante un identificador de combinación, esta propiedad compartida almacena los valores de pregunta seleccionados."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Seleccione si desea actualizar el contenido del menú desplegable para que coincida con la consulta de búsqueda que un usuario está escribiendo en el campo de entrada."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Un valor que se debe guardar en los resultados de la encuesta cuando los encuestados dan una respuesta positiva."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Un valor que se debe guardar en los resultados de la encuesta cuando los encuestados dan una respuesta negativa."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "No se recomienda deshabilitar esta opción, ya que anula la imagen de vista previa y dificulta que un usuario comprenda si los archivos se han cargado."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Activa un mensaje que le pide que confirme la eliminación del archivo."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Habilite esta opción para clasificar solo las opciones seleccionadas. Los usuarios arrastrarán los elementos seleccionados de la lista de opciones para ordenarlos dentro del área de clasificación."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Ingrese una lista de opciones que se sugerirán al encuestado durante la entrada."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "La configuración solo cambia el tamaño de los campos de entrada y no afecta al ancho del cuadro de pregunta."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Establece un ancho coherente para todas las etiquetas de elementos en píxeles"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "La opción \"Auto\" determina automáticamente el modo adecuado para la visualización (Imagen, Video o YouTube) en función de la URL de origen proporcionada."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Sirve como sustituto cuando la imagen no se puede mostrar en el dispositivo de un usuario y por motivos de accesibilidad."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Define el color del emoji seleccionado cuando el tipo de icono de clasificación se establece en \"Emoticonos\". Elija entre: \"Predeterminado\": el emoji seleccionado aparece en el color predeterminado de la encuesta; \"Escala\": el emoji seleccionado hereda el color de la escala de calificación."
// expression.name: "An expression ID that is not visible to respondents." => "Un identificador de expresión que no es visible para los encuestados."
// expression.description: "Type an expression subtitle." => "Escriba un subtítulo de expresión."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Una expresión puede incluir cálculos básicos ('{q1_id} + {q2_id}'), condiciones ('{edad} > 60') y funciones ('iif()', 'hoy()', 'edad()', 'min()', 'max()', 'avg()', etc.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Seleccione esta opción para almacenar el valor de la opción \"Otro\" como una propiedad independiente en los resultados de la encuesta."
// p.swapOrder: "Swap the order of Yes and No" => "Cambiar el orden de Sí y No"
// p.itemTitleWidth: "Item label width (in px)" => "Ancho de la etiqueta del elemento (en px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Texto para mostrar si todas las opciones están seleccionadas"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Texto de marcador de posición para el área de clasificación"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Completar la encuesta automáticamente"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Seleccione si desea que la encuesta se complete automáticamente después de que un encuestado responda todas las preguntas."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Guardar el valor enmascarado en los resultados de la encuesta"
// patternmask.pattern: "Value pattern" => "Patrón de valores"
// datetimemask.min: "Minimum value" => "Valor mínimo"
// datetimemask.max: "Maximum value" => "Valor máximo"
// numericmask.allowNegativeValues: "Allow negative values" => "Permitir valores negativos"
// numericmask.thousandsSeparator: "Thousands separator" => "Separador de millares"
// numericmask.decimalSeparator: "Decimal separator" => "Separador decimal"
// numericmask.precision: "Value precision" => "Precisión de valor"
// numericmask.min: "Minimum value" => "Valor mínimo"
// numericmask.max: "Maximum value" => "Valor máximo"
// currencymask.prefix: "Currency prefix" => "Prefijo de moneda"
// currencymask.suffix: "Currency suffix" => "Sufijo de moneda"
// pe.maskType: "Input mask type" => "Tipo de máscara de entrada"
// maskTypes.patternmask: "Pattern" => "Patrón"
// maskTypes.numericmask: "Numeric" => "Numérico"
// maskTypes.datetimemask: "Date and Time" => "Fecha y hora"
// maskTypes.currencymask: "Currency" => "Divisa"
// tabs.mask: "Input Mask Settings" => "Configuración de la máscara de entrada"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Ej.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Ej.: dd/mm/aaaa"
// pe.currencyprefix_placeholder: "Ex.: $" => "Ej.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Ej.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Opciones de envoltura"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Los textos largos en las opciones de elección generarán automáticamente saltos de línea para que se ajusten al menú desplegable. Anule la selección si desea que los textos se recorten."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Seleccione si desea almacenar el valor de la pregunta con una máscara aplicada en los resultados de la encuesta."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "El patrón puede contener literales de cadena y los siguientes marcadores de posición: '9': para un dígito; 'a' - para una letra mayúscula o minúscula; '#' - para un dígito o una letra mayúscula o minúscula. Use la barra invertida '\\' para escapar de un carácter."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "El patrón puede contener caracteres separadores y los siguientes marcadores de posición: 'm' - para el número de mes; 'mm' - para el número del mes, con cero a la izquierda para los valores de un solo dígito; 'd' - para el día del mes; 'dd': para el día del mes, con cero a la izquierda para valores de un solo dígito; 'yy' - para los dos últimos dígitos del año; 'yyyy' - para un año de cuatro dígitos."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Símbolo utilizado para separar la parte fraccionaria de la parte entera de un número mostrado."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Símbolo que se utiliza para separar los dígitos de un número grande en grupos de tres."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Limita el número de dígitos que se conservan después del punto decimal de un número mostrado."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Uno o varios símbolos que se mostrarán antes del valor."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Uno o varios símbolos que se mostrarán después del valor."
// ed.translationSource: "Source: " => "Fuente: "
// ed.translationTarget: "Target: " => "Blanco: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "La página está vacía. Arrastre un elemento desde la caja de herramientas o haga clic en el botón de abajo."
// maskTypes.none: "None" => "Ninguno"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Haga que la fila sea visible si"
// itemvalue@rows.enableIf: "Make the row editable if" => "Hacer que la fila sea editable si"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Texto de marcador de posición en modo de solo lectura o vista previa"
// pe.textWrapEnabled: "Wrap choices" => "Opciones de envoltura"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "La opción \"Auto\" determina automáticamente el modo adecuado para la visualización (Imagen, Video o YouTube) en función de la URL de origen proporcionada."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Elija entre \"Imagen\" y \"Video\" para configurar el modo de contenido del selector de medios. Si se selecciona \"Imagen\", asegúrese de que todas las opciones proporcionadas sean archivos de imagen en los siguientes formatos: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Del mismo modo, si se selecciona \"Vídeo\", asegúrese de que todas las opciones sean enlaces directos a archivos de vídeo en los siguientes formatos: MP4, MOV, WMV, FLV, AVI, MKV. Tenga en cuenta que los enlaces de YouTube no son compatibles con las opciones de video."
// ed.selectFile: "Select a file" => "Seleccionar un archivo"
// ed.removeFile: "Remove the file" => "Eliminar el archivo"
// pe.searchMode: "Search Mode" => "Modo de búsqueda"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Haga clic en el botón \"Agregar pregunta\" a continuación para comenzar a crear su formulario."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Haga clic en el botón \"Agregar pregunta\" a continuación para agregar un nuevo elemento a la página."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Haga clic en el botón \"Agregar pregunta\" a continuación para agregar un nuevo elemento al panel."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Haga clic en el botón de abajo y elija una imagen para cargar"
// coloralpha.opacity: "Opacity" => "Opacidad"
// font.family: "Font family" => "Familia tipográfica"
// font.color: "Color" => "Color"
// font.placeholderColor: "Placeholder color" => "Color del marcador de posición"
// font.size: "Size" => "Tamaño"
// theme.themeName: "Theme" => "Tema"
// theme.isPanelless: "Question appearance" => "Apariencia de la pregunta"
// theme.editorPanel: "Background and corner radius" => "Fondo y radio de vértice"
// theme.questionPanel: "Background and corner radius" => "Fondo y radio de vértice"
// theme.primaryColor: "Accent color" => "Color de acento"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Opacidad del fondo del panel"
// theme.questionBackgroundTransparency: "Question background opacity" => "Opacidad del fondo de la pregunta"
// theme.fontSize: "Font size" => "Tamaño de fuente"
// theme.scale: "Scale" => "Escama"
// theme.cornerRadius: "Corner radius" => "Radio de esquina"
// theme.pageTitle: "Title font" => "Fuente del título"
// theme.pageDescription: "Description font" => "Fuente descriptiva"
// theme.questionTitle: "Title font" => "Fuente del título"
// theme.questionDescription: "Description font" => "Fuente descriptiva"
// theme.editorFont: "Font" => "Fuente"
// theme.backgroundOpacity: "Opacity" => "Opacidad"
// theme.--sjs-font-family: "Font family" => "Familia tipográfica"
// theme.--sjs-general-backcolor-dim: "Background color" => "Color de fondo"
// theme.--sjs-primary-backcolor: "Accent background" => "Fondo de acento"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Acento en primer plano"
// theme.--sjs-shadow-small: "Shadow effects" => "Efectos de sombra"
// theme.--sjs-shadow-inner: "Shadow effects" => "Efectos de sombra"
// theme.--sjs-border-default: "Colors" => "Colores"
// header@header.headerView: "View" => "Vista"
// header@header.logoPosition: "Logo position" => "Posición del logotipo"
// header@header.surveyTitle: "Survey title font" => "Fuente del título de la encuesta"
// header@header.surveyDescription: "Survey description font" => "Fuente de descripción de la encuesta"
// header@header.headerTitle: "Survey title font" => "Fuente del título de la encuesta"
// header@header.headerDescription: "Survey description font" => "Fuente de descripción de la encuesta"
// header@header.inheritWidthFrom: "Content area width" => "Ancho del área de contenido"
// header@header.textAreaWidth: "Text width" => "Ancho del texto"
// header@header.backgroundColorSwitch: "Background color" => "Color de fondo"
// header@header.backgroundImage: "Background image" => "Imagen de fondo"
// header@header.backgroundImageOpacity: "Opacity" => "Opacidad"
// header@header.overlapEnabled: "Overlap" => "Solapar"
// header@header.logoPositionX: "Logo position" => "Posición del logotipo"
// header@header.titlePositionX: "Title position" => "Posición en el título"
// header@header.descriptionPositionX: "Description position" => "Descripción posición"
// weight.400: "Regular" => "Regular"
// weight.600: "Heavy" => "Pesado"
// weight.700: "Semi-bold" => "Semi-negrita"
// weight.800: "Bold" => "Audaz"
// backgroundImageFit.auto: "Auto" => "Automático"
// backgroundImageFit.cover: "Cover" => "Cubrir"
// backgroundImageFit.contain: "Contain" => "Contener"
// backgroundImageFit.fill: "Stretch" => "Elasticidad"
// backgroundImageFit.tile: "Tile" => "Teja"
// backgroundImageAttachment.fixed: "Fixed" => "Fijo"
// backgroundImageAttachment.scroll: "Scroll" => "Pergamino"
// headerView.basic: "Basic" => "Básico"
// headerView.advanced: "Advanced" => "Avanzado"
// inheritWidthFrom.survey: "Same as survey" => "Igual que la encuesta"
// inheritWidthFrom.container: "Fit to container" => "Ajuste al contenedor"
// backgroundColorSwitch.none: "None" => "Ninguno"
// backgroundColorSwitch.accentColor: "Accent color" => "Color de acento"
// backgroundColorSwitch.custom: "Custom" => "Costumbre"
// colorPalette.light: "Light" => "Luz"
// colorPalette.dark: "Dark" => "Oscuro"
// isPanelless.false: "Default" => "Predeterminado"
// isPanelless.true: "Without Panels" => "Sin paneles"
// theme.cornerRadius: "Corner radius" => "Radio de esquina"
// theme.fontFamily: "Font family" => "Familia tipográfica"
// theme.fontWeightRegular: "Regular" => "Regular"
// theme.fontWeightHeavy: "Heavy" => "Pesado"
// theme.fontWeightSemiBold: "Semi-bold" => "Semi-negrita"
// theme.fontWeightBold: "Bold" => "Audaz"
// theme.color: "Color" => "Color"
// theme.placeholderColor: "Placeholder color" => "Color del marcador de posición"
// theme.size: "Size" => "Tamaño"
// theme.opacity: "Opacity" => "Opacidad"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Escriba para buscar..."
// ed.toolboxNoResultsFound: "No results found" => "No se han encontrado resultados"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Marcador de posición del título de la pestaña"
// theme.--sjs-special-red: "Error messages" => "Mensajes de error"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Texto de reserva para los títulos de tabulación que se aplica cuando el patrón de título de tabulación no genera un valor significativo."
// theme.fontColor: "Font color" => "Color de la fuente"
// theme.backgroundColor: "Background color" => "Color de fondo"
// pe.questionTitleWidth: "Question title width" => "Ancho del título de la pregunta"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Seleccione un archivo o pegue un enlace de archivo..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Ej.: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Establece un ancho coherente para los títulos de las preguntas cuando están alineados a la izquierda de sus cuadros de preguntas. Acepta valores CSS (px, %, in, pt, etc.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Establece un ancho coherente para los títulos de las preguntas cuando están alineados a la izquierda de sus cuadros de preguntas. Acepta valores CSS (px, %, in, pt, etc.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Altura del área de comentarios (en líneas)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Establece el número de líneas mostradas en las áreas de texto para los comentarios de las preguntas. En la entrada ocupa más líneas, aparece la barra de desplazamiento."


/***/ }),

/***/ "./src/localization/swedish.ts":
/*!*************************************!*\
  !*** ./src/localization/swedish.ts ***!
  \*************************************/
/*! exports provided: svStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "svStrings", function() { return svStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var svStrings = {
    // survey templates
    survey: {
        edit: "Redigera",
        externalHelpLink: "Se och lär dig hur du skapar enkäter",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Dra och släpp en fråga från Verktygslistan till vänster.",
        addLogicItem: "Skapa en regel för att anpassa undersökningens flöde.",
        copy: "Kopiera",
        duplicate: "Duplicera",
        addToToolbox: "Lägg till Verktygslistan",
        deletePanel: "Radera Panel",
        deleteQuestion: "Radera Fråga",
        convertTo: "Konvertera till",
        drag: "Dra element",
    },
    // Creator tabs
    tabs: {
        preview: "Test enkät",
        theme: "Teman",
        translation: "Översättning",
        designer: "Enkät Designer",
        editor: "JSON Redigering",
        logic: "Logik"
    },
    // Question types
    qt: {
        default: "Standard",
        checkbox: "Checkboxes",
        comment: "Kommentar",
        imagepicker: "Bild-väljare",
        ranking: "Rankning",
        image: "Bild",
        dropdown: "Rullgardinsmeny",
        tagbox: "Listruta med flerval",
        file: "Fil",
        html: "Html",
        matrix: "Matris (enkel val)",
        matrixdropdown: "Matris(flera val)",
        matrixdynamic: "Matris (dynamiska rader)",
        multipletext: "Flera texter",
        panel: "Panel",
        paneldynamic: "Panel (dynamisk panel)",
        radiogroup: "Radiogrupper",
        rating: "Rankning",
        text: "Enkel text",
        boolean: "Yes/No (Boolean)",
        expression: "Formel",
        signaturepad: "Underskrift",
        buttongroup: "Knappgrupp"
    },
    toolboxCategories: {
        general: "Generellt",
        choice: "Frågor om val",
        text: "Frågor om textinmatning",
        containers: "Behållare",
        matrix: "Matris frågor",
        misc: "Misc"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Standard ({0})",
        survey: "Enkät",
        settings: "Enkät inställningar",
        settingsTooltip: "Öppna inställningar",
        surveySettings: "Inställningar för undersökning",
        surveySettingsTooltip: "Inställningar för undersökning",
        themeSettings: "Tema Inställningar",
        themeSettingsTooltip: "Inställningar för tema",
        showPanel: "Visa panel",
        hidePanel: "Dölj panel",
        prevSelected: "Välj föregående",
        nextSelected: "Välj nästa",
        prevFocus: "Fokus föregående",
        nextFocus: "Fokus nästa",
        surveyTypeName: "Undersökning",
        pageTypeName: "Sida",
        panelTypeName: "Panel",
        questionTypeName: "Fråga",
        columnTypeName: "Spalt",
        addNewPage: "Lägg till en ny sida",
        moveRight: "Scrolla till höger",
        moveLeft: "Scrolla till vänster",
        deletePage: "Radera sida",
        editPage: "Redigera sida",
        edit: "Redigera",
        newPageName: "sida",
        newQuestionName: "fråga",
        newPanelName: "panel",
        newTextItemName: "SMS",
        defaultV2Theme: "Standard",
        modernTheme: "Modern",
        defaultTheme: "Standard (äldre)",
        testSurveyAgain: "Testa enkät igen",
        testSurveyWidth: "Enkät bredd: ",
        navigateToMsg: "Du var tvungen att navigera till",
        saveSurvey: "Spara Enkät",
        saveSurveyTooltip: "Spara undersökning",
        saveTheme: "Spara tema",
        saveThemeTooltip: "Spara tema",
        jsonHideErrors: "Dölj fel",
        jsonShowErrors: "Visa fel",
        undo: "Ångra",
        redo: "Göra om",
        undoTooltip: "Ångra senaste ändring",
        redoTooltip: "Gör om ändringen",
        showMoreChoices: "Visa mer",
        showLessChoices: "Visa mindre",
        copy: "Kopia",
        cut: "Skära",
        paste: "Klistra",
        copyTooltip: "Kopiera markering till Urklipp",
        cutTooltip: "Klipp markering till Urklipp",
        pasteTooltip: "Klistra in från Urklipp",
        options: "Alternativ",
        generateValidJSON: "Generera giltig JSON",
        generateReadableJSON: "Generera läsbar JSON",
        toolbox: "Verktygslista",
        "property-grid": "Egenskaper",
        toolboxFilteredTextPlaceholder: "Skriv för att söka...",
        toolboxNoResultsFound: "Inga resultat hittades",
        propertyGridFilteredTextPlaceholder: "Skriv för att söka...",
        propertyGridNoResultsFound: "Inga resultat hittades",
        correctJSON: "Var vänligen korrigera JSON.",
        surveyResults: "Enkät resultat: ",
        surveyResultsTable: "Som tabell",
        surveyResultsJson: "Som JSON",
        resultsTitle: "Frågetitel",
        resultsName: "Frågenamn",
        resultsValue: "Resultat värde",
        resultsDisplayValue: "Visnings värde",
        modified: "Ändrat",
        saving: "Sparar",
        saved: "Sparat",
        propertyEditorError: "Fel",
        saveError: "Fel! Innehållet i enkäten är inte sparat.",
        translationPropertyGridTitle: "Språkinställningar",
        themePropertyGridTitle: "Tema Inställningar",
        translationLanguages: "Språk",
        translationDeleteLanguage: "Är du säker på att du vill ta bort alla strängar för det här språket?",
        translationAddLanguage: "Välj språk för oversättning",
        translationShowAllStrings: "Visa alla strängar",
        translationShowUsedStringsOnly: "Endast använda strängar",
        translationShowAllPages: "Visa alla sidor",
        translationNoStrings: "Inga strängar är översatta. Vänligen ändra filtret.",
        translationExportToSCVButton: "Exportera till CSV",
        translationImportFromSCVButton: "Importera från CSV",
        translateUsigAI: "Översätt alla automatiskt",
        translateUsigAIFrom: "Översätt från: ",
        translationDialogTitle: "Oöversatta strängar",
        translationMergeLocaleWithDefault: "Mergea {0} med standard språk",
        translationPlaceHolder: "Översättning...",
        translationSource: "Källa: ",
        translationTarget: "Mål: ",
        themeExportButton: "Export",
        themeImportButton: "Import",
        surveyJsonExportButton: "Export",
        surveyJsonImportButton: "Import",
        surveyJsonCopyButton: "Kopiera till Urklipp",
        themeResetButton: "Återställ temainställningarna till standard",
        themeResetConfirmation: "Vill du verkligen återställa temat? Alla dina anpassningar kommer att gå förlorade.",
        themeResetConfirmationOk: "Ja, återställ temat",
        bold: "Djärv",
        italic: "Kursiv",
        underline: "Understryka",
        addNewQuestion: "Lägg till fråga",
        selectPage: "Välj sida...",
        carryForwardChoicesCopied: "Alternativen kopieras från",
        choicesLoadedFromWebText: "Alternativen läses in från en webbtjänst.",
        choicesLoadedFromWebLinkText: "Gå till inställningar",
        choicesLoadedFromWebPreviewTitle: "Förhandsgranskning av inlästa alternativalternativ",
        htmlPlaceHolder: "HTML-innehåll kommer att finnas här.",
        panelPlaceHolder: "Släpp en fråga från verktygslådan här.",
        surveyPlaceHolder: "Enkäten är tom. Dra ett element från verktygslådan eller klicka på knappen nedan.",
        pagePlaceHolder: "Sidan är tom. Dra ett element från verktygslådan eller klicka på knappen nedan.",
        imagePlaceHolder: "Dra och släpp en bild här eller klicka på knappen nedan och välj en bild att ladda upp",
        surveyPlaceHolderMobile: "Klicka på knappen \"Lägg till fråga\" nedan för att börja skapa ditt formulär.",
        pagePlaceHolderMobile: "Klicka på knappen \"Lägg till fråga\" nedan för att lägga till ett nytt element på sidan.",
        panelPlaceHolderMobile: "Klicka på knappen \"Lägg till fråga\" nedan för att lägga till ett nytt element i panelen.",
        imagePlaceHolderMobile: "Klicka på knappen nedan och välj en bild att ladda upp",
        imageChooseImage: "Välj bild",
        addNewTypeQuestion: "Lägg till {0}",
        chooseLogoPlaceholder: "[LOGOTYP]",
        choices_Item: "Sak ",
        selectFile: "Välj en fil",
        removeFile: "Ta bort filen",
        lg: {
            addNewItem: "Lägg till ny regel",
            empty_tab: "Skapa en regel för att anpassa undersökningens flöde.",
            page_visibilityName: "Visa (dölj) sida",
            page_enableName: "Aktivera (inaktivera) sida",
            page_requireName: "Gör sidan obligatorisk",
            panel_visibilityName: "Visa (dölj) panelen",
            panel_enableName: "Aktivera (inaktivera) panelen",
            panel_requireName: "Gör sidan obligatorisk",
            question_visibilityName: "Visa (dölj) fråga",
            question_enableName: "Aktivera (inaktivera) fråga",
            question_requireName: "Gör frågan obligatorisk",
            question_resetValueName: "Återställ frågevärde",
            question_setValueName: "Ange frågevärde",
            column_visibilityName: "Visa (dölj) kolumn",
            column_enableName: "Aktivera (inaktivera) kolumn",
            column_requireName: "Gör kolumnen obligatorisk",
            column_resetValueName: "Återställ kolumnvärde",
            column_setValueName: "Ange kolumnvärde",
            trigger_completeName: "Fullständig undersökning",
            trigger_setvalueName: "Ställ in svar",
            trigger_copyvalueName: "Kopiera svar",
            trigger_skipName: "Hoppa till fråga",
            trigger_runExpressionName: "Kör uttryck",
            completedHtmlOnConditionName: "Ställ in sidmarkeringen \"Undersökningen slutförd\"",
            page_visibilityDescription: "Gör sidan synlig när logikuttrycket returnerar true. Håll den annars osynlig.",
            panel_visibilityDescription: "Gör panelen synlig när logikuttrycket returnerar true. Håll den annars osynlig.",
            panel_enableDescription: "Aktivera panelen och alla element inuti den när logikuttrycket returnerar true. Håll dem annars inaktiverade.",
            question_visibilityDescription: "Gör frågan synlig när logikuttrycket returnerar true. Håll den annars osynlig.",
            question_enableDescription: "Aktivera frågan när logikuttrycket returnerar true. Annars ska du hålla den inaktiverad.",
            question_requireDescription: "Frågan blir obligatorisk när logikuttrycket returnerar true.",
            trigger_completeDescription: "När logikuttrycket returnerar true slutförs undersökningen och en slutanvändare ser tacksidan.",
            trigger_setvalueDescription: "När frågevärden, som används i logikuttrycket, ändras och logikuttrycket returnerar true, anges värdet till den valda frågan.",
            trigger_copyvalueDescription: "När frågevärden, som används i logikuttrycket, ändras och logikuttrycket returnerar true, kopieras värdet för en markerad fråga till en annan markerad fråga.",
            trigger_skipDescription: "När logikuttrycket returnerar true hoppar undersökningen till / fokuserar den valda frågan.",
            trigger_runExpressionDescription: "När logikuttrycket returnerar true utförs det anpassade uttrycket. Om du vill kan du ange detta uttrycksresultat i den valda frågan",
            completedHtmlOnConditionDescription: "Om logikuttrycket returnerar true ändras standardtexten för tacksidan till den angivna.",
            itemExpressionText: "När uttryck: \"{0}\" returnerar true",
            itemEmptyExpressionText: "Ny regel",
            page_visibilityText: "Gör sidan {0} synlig",
            panel_visibilityText: "Gör panelen {0} synlig",
            panel_enableText: "Gör panelen {0} aktivera",
            question_visibilityText: "Gör frågan {0} synlig",
            question_enableText: "Gör frågan {0} aktivera",
            question_requireText: "Gör frågan {0} krävs",
            question_resetValueText: "Återställ värde för fråga: {0}",
            question_setValueText: "Tilldela värde: {1} till fråga: {0}",
            column_visibilityText: "Synliggör kolumn {0} av fråga {1}",
            column_enableText: "Gör kolumn {0} av fråga {1} aktivera",
            column_requireText: "Gör kolumn {0} av fråga {1} krävs",
            column_resetValueText: "Återställ cellvärde för kolumn: {0}",
            column_setValueText: "Tilldela cellvärde: {1} till kolumn: {0}",
            setValueExpressionPlaceholder: " Ett uttryck vars resultat kommer att tilldelas målfrågan.",
            trigger_completeText: "Undersökningen blir slutförd",
            trigger_setvalueText: "ifrågasätts: {0} värde {1}",
            trigger_setvalueEmptyText: "Tydligt frågevärde: {0}",
            trigger_copyvalueText: "Kopiera till fråga: {0} värde från fråga {1}",
            trigger_skipText: "Enkät hoppa till frågan {0}",
            trigger_runExpressionText1: "kör uttryck: '{0}'",
            trigger_runExpressionText2: " och ifrågasatte resultatet: {0}",
            completedHtmlOnConditionText: "visa anpassad text för tacksidan.",
            showAllQuestions: "Alla frågor",
            showAllActionTypes: "Alla åtgärdstyper",
            conditions: "Skick",
            actions: "Åtgärd(er)",
            expressionEditorTitle: "Definiera villkor",
            actionsEditorTitle: "Definiera åtgärder",
            deleteAction: "Ta bort åtgärd",
            addNewAction: "Lägg till åtgärd",
            selectedActionCaption: "Välj åtgärd...",
            expressionInvalid: "Logikuttrycket är tomt eller ogiltigt. Var snäll och rätta till det.",
            noActionError: "Lägg till minst en åtgärd.",
            actionInvalid: "Snälla, åtgärda problem i dina åtgärder.",
            uncompletedRule_title: "Logiska regler är ofullständiga",
            uncompletedRule_text: "Du har inte slutfört några av de logiska reglerna. Om du lämnar fliken nu kommer ändringarna att gå förlorade. Vill du fortfarande lämna fliken utan att slutföra ändringarna?",
            uncompletedRule_apply: "Ja",
            uncompletedRule_cancel: "Nej, jag vill komplettera reglerna"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Panelens namn",
            title: "Panelens titel",
            description: "Beskrivning av panelen",
            visibleIf: "Gör panelen synlig om",
            requiredIf: "Gör panelen obligatorisk om",
            questionsOrder: "Frågeordning i panelen",
            page: "Överordnad sida",
            startWithNewLine: "Visa panelen på en ny rad",
            state: "Panelens komprimerade tillstånd",
            width: "Bredd på infogad panel",
            minWidth: "Minsta panelbredd",
            maxWidth: "Maximal panelbredd",
            showNumber: "Sifferpaneler"
        },
        paneldynamic: {
            name: "Panelens namn",
            title: "Panelens titel",
            description: "Beskrivning av panelen",
            visibleIf: "Gör panelen synlig om",
            requiredIf: "Gör panelen obligatorisk om",
            page: "Flytta panelen till sidan",
            startWithNewLine: "Visa panelen på en ny rad",
            state: "Panelens komprimerade tillstånd",
            width: "Bredd på infogad panel",
            minWidth: "Minsta panelbredd",
            maxWidth: "Maximal panelbredd",
            confirmDelete: "Bekräfta borttagning av panelen",
            templateDescription: "Mönster för panelbeskrivning",
            templateTitle: "Mönster för panelrubrik",
            noEntriesText: "Tom paneltext",
            templateTabTitle: "Mönster för flikrubrik",
            tabTitlePlaceholder: "Platshållare för flikrubrik",
            templateVisibleIf: "Gör en enskild panel synlig om",
            hideNumber: "Dölj panelnumret",
            titleLocation: "Justering av panelrubrik",
            descriptionLocation: "Justering av panelbeskrivning",
            templateTitleLocation: "Justering av frågerubrik",
            templateErrorLocation: "Justering av felmeddelande",
            newPanelPosition: "Ny panelplats",
            keyName: "Förhindra dubbletter av svar i följande fråga"
        },
        question: {
            name: "Frågans namn",
            title: "Frågans rubrik",
            description: "Beskrivning av frågan",
            visibleIf: "Gör frågan synlig om",
            requiredIf: "Gör frågan obligatorisk om",
            page: "Överordnad sida",
            state: "Komprimeringstillstånd för frågeruta",
            hideNumber: "Dölj frågans nummer",
            titleLocation: "Justering av frågerubrik",
            descriptionLocation: "Justering av frågebeskrivning",
            errorLocation: "Justering av felmeddelande",
            indent: "Öka det inre indraget",
            width: "Bredd på infogade frågor",
            minWidth: "Minsta frågebredd",
            maxWidth: "Maximal frågebredd",
            textUpdateMode: "Uppdatera indatafältsvärde"
        },
        signaturepad: {
            signatureWidth: "Signaturområdets bredd",
            signatureHeight: "Signaturområdets höjd",
            signatureAutoScaleEnabled: "Skala signaturområdet automatiskt",
            showPlaceholder: "Visa platshållaren",
            placeholder: "Platshållartext",
            placeholderReadOnly: "Platshållartext i skrivskyddat läge eller förhandsgranskningsläge",
            allowClear: "Visa knappen Rensa i signaturområdet",
            penMinWidth: "Minsta pennbredd",
            penMaxWidth: "Maximal pennbredd",
            penColor: "Linjefärg"
        },
        comment: {
            rows: "Inmatningsfältets höjd (i rader)"
        },
        showQuestionNumbers: "Visa frågenummer",
        questionStartIndex: "Fråga start index (1, 2 eller 'A', 'a')",
        expression: {
            name: "Namn på uttryck",
            title: "Uttryckets titel",
            description: "Beskrivning av uttryck",
            expression: "Uttryck"
        },
        trigger: {
            expression: "Uttryck"
        },
        calculatedvalue: {
            expression: "Uttryck"
        },
        // survey templates
        survey: {
            title: "Titel",
            description: "Beskrivning av undersökningen"
        },
        page: {
            name: "Sidans namn",
            title: "Titel",
            description: "Beskrivning av sidan",
            visibleIf: "Gör sidan synlig om",
            requiredIf: "Gör sidan obligatorisk om",
            maxTimeToFinish: "Tidsgräns för att avsluta sidan (i sekunder)",
            questionsOrder: "Frågeordning på sidan"
        },
        matrixdropdowncolumn: {
            name: "Kolumnens namn",
            title: "Kolumnens rubrik",
            isUnique: "Förhindra dubbletter av svar",
            width: "Kolumnbredd",
            minWidth: "Minsta kolumnbredd",
            rows: "Inmatningsfältets höjd (i rader)",
            visibleIf: "Gör kolumnen synlig om",
            requiredIf: "Gör kolumnen obligatorisk om",
            showInMultipleColumns: "Varje alternativ i en separat kolumn"
        },
        multipletextitem: {
            name: "Namn",
            title: "Titel"
        },
        masksettings: {
            saveMaskedValue: "Spara maskerat värde i undersökningsresultat"
        },
        patternmask: {
            pattern: "Värdemönster"
        },
        datetimemask: {
            min: "Minsta värde",
            max: "Maximalt värde"
        },
        numericmask: {
            allowNegativeValues: "Tillåt negativa värden",
            thousandsSeparator: "Avgränsare för tusental",
            decimalSeparator: "Decimaltecknet",
            precision: "Värde precision",
            min: "Minsta värde",
            max: "Maximalt värde"
        },
        currencymask: {
            prefix: "Prefix för valuta",
            suffix: "Valutasuffix"
        },
        imageHeight: "Bild höjd",
        imageWidth: "Bild bredd",
        valueName: "Värde namn",
        rateDescriptionLocation: "Justering av etiketter",
        size: "Inmatningsfältets storlek (i tecken)",
        cellErrorLocation: "Justering av cellfelmeddelande",
        apply: "Faställ",
        ok: "OK",
        save: "Spara",
        clear: "Klar",
        saveTooltip: "Spara",
        cancel: "Avbryt",
        set: "Ställa",
        reset: "Återställ",
        change: "Förändring",
        refresh: "Svalka",
        close: "Stäng",
        delete: "Radera",
        add: "Addera",
        addNew: "Lägg till ny",
        addItem: "Klicka för att lägga till...",
        removeItem: "Klicka för att ta bort objektet...",
        dragItem: "Dra objektet",
        addOther: "Annan",
        addSelectAll: "Markera alla",
        addNone: "Ingen",
        removeAll: "Ta bort allt",
        edit: "Redigera",
        back: "Returnera utan att spara",
        backTooltip: "Returnera utan att spara",
        saveAndBack: "Spara och returnera",
        saveAndBackTooltip: "Spara och returnera",
        doneEditing: "Färdig",
        editChoices: "Redigera val",
        showChoices: "Visa alternativ",
        move: "Flytta",
        empty: "<tom>",
        emptyValue: "Värdet är tomt",
        fastEntry: "Snabb ifyllning",
        fastEntryNonUniqueError: "Värdet \"{0}\" är inte unikt",
        fastEntryChoicesCountError: "Begränsa antalet artiklar från {0} till {1}",
        fastEntryChoicesMinCountError: "Ange minst {0} artiklar",
        fastEntryPlaceholder: "Du kan ange data i följande format:\nvärde1|text\nvärde2",
        formEntry: "Ifyllning i enkäten",
        testService: "Testa tjänsten",
        itemSelectorEmpty: "Välj elementet",
        conditionActionEmpty: "Välj åtgärd",
        conditionSelectQuestion: "Välj fråga...",
        conditionSelectPage: "Välj sida...",
        conditionSelectPanel: "Välj panel...",
        conditionValueQuestionTitle: "Vänligen skriv in/välj värdet",
        aceEditorHelp: "Tryck ctrl+mellanslag för att få en ledtråd",
        aceEditorRowTitle: "Nuvarande rad",
        aceEditorPanelTitle: "Nuvarande panel",
        showMore: "För mer detaljer - se dokumentationen",
        assistantTitle: "Tillgängliga frågor:",
        cellsEmptyRowsColumns: "Det bör vara minst 1 kolumn eller rad",
        showPreviewBeforeComplete: "Förhandsgranska svar innan du skickar in undersökningen",
        overridingPropertyPrefix: "Inställd av ",
        resetToDefaultCaption: "Nollställa",
        propertyIsEmpty: "Vänligen fyll i ett värde",
        propertyIsNoUnique: "Ange ett unikt värde",
        propertyNameIsNotUnique: "Ange ett unikt namn",
        propertyNameIsIncorrect: "Använd inte reserverade ord: \"objekt\", \"val\", \"panel\", \"rad\".",
        listIsEmpty: "Inga objekt har lagts till ännu",
        "listIsEmpty@choices": "Inga alternativ har lagts till ännu",
        "listIsEmpty@columns": "Du har inga kolumner ännu",
        "listIsEmpty@rows": "Du har inga rader ännu",
        "listIsEmpty@validators": "Du har inga valideringsregler ännu",
        "listIsEmpty@calculatedValues": "Du har inga anpassade variabler ännu",
        "listIsEmpty@triggers": "Du har inga utlösare ännu",
        "listIsEmpty@navigateToUrlOnCondition": "Du har inga länkar ännu",
        "addNew@choices": "Lägg till ett val",
        "addNew@columns": "Lägg till ny kolumn",
        "addNew@rows": "Lägg till ny rad",
        "addNew@validators": "Lägg till ny regel",
        "addNew@calculatedValues": "Lägg till ny variabel",
        "addNew@triggers": "Lägga till ny utlösare",
        "addNew@navigateToUrlOnCondition": "Lägg till ny URL",
        expressionIsEmpty: "Uttrycket är tomt",
        value: "Värde",
        text: "Text",
        rowid: "Rad ID",
        imageLink: "Bild länk",
        columnEdit: "Redigera kolumn: {0}",
        itemEdit: "Redigera element: {0}",
        url: "URL",
        path: "Sökväg",
        choicesbyurl: {
            url: "Webbtjänstens URL",
            valueName: "Hämta värden från följande JSON-fält"
        },
        titleName: "Titel namn",
        imageLinkName: "Hämta bild-URL:er från följande JSON-fält",
        allowEmptyResponse: "Tillåt tomt svar",
        titlePlaceholder: "Titel",
        surveyTitlePlaceholder: "Undersökningens titel",
        pageTitlePlaceholder: "Sida {num}",
        descriptionPlaceholder: "Beskrivning",
        surveyDescriptionPlaceholder: "Beskrivning",
        pageDescriptionPlaceholder: "Beskrivning",
        textWrapEnabled: "Radbryt val",
        showOtherItem: "Har annat element",
        otherText: "Annat",
        showNoneItem: "Tillåt alternativet Ingen",
        showRefuseItem: "Tillåt alternativet Vägra svara",
        showDontKnowItem: "Tillåt alternativet Vet ej",
        noneText: "Alternativtext för Ingen",
        showSelectAllItem: "Tillåt alternativet Markera allt",
        selectAllText: "Markera all alternativtext",
        choicesMin: "Minimivärde för automatiskt genererade objekt",
        choicesMax: "Maximalt värde för automatiskt genererade objekt",
        choicesStep: "Steg för automatiskt genererade objekt",
        name: "Namn",
        title: "Titel",
        cellType: "Cell typ",
        colCount: "Antal kolumner",
        choicesOrder: "Välj ordning på valet",
        visible: "Synlig?",
        isRequired: "Nödvändig?",
        markRequired: "Markera efter behov",
        removeRequiredMark: "Ta bort det obligatoriska märket",
        isAllRowRequired: "Kräv svar för alla rader",
        eachRowUnique: "Förhindra dubbletter av svar i rader",
        requiredErrorText: "Felmeddelandet \"Obligatoriskt\"",
        startWithNewLine: "Starta på en ny rad?",
        rows: "Antal rader",
        cols: "Kolumner",
        placeholder: "Mata in i fältet",
        showPreview: "Förhandsvinsning av bild?",
        storeDataAsText: "Lagra filinnehållet i JSON som text",
        maxSize: "Max filstorlek i bytes",
        rowCount: "Antal rader",
        columnLayout: "Stil på kolumn",
        addRowLocation: "Lägg till radknapp plats",
        transposeData: "Transponera rader till kolumner",
        addRowText: "Lägg till knapp text",
        removeRowText: "Ta bort rad knapp text",
        rateMin: "Minsta räntevärde",
        rateMax: "Högsta taxa",
        rateStep: "Betygsätt steg",
        minRateDescription: "Minsta betyg beskrivning",
        maxRateDescription: "Maximala betyg beskrivning",
        inputType: "Indata typ",
        optionsCaption: "Text för alternativ",
        defaultValue: "Standard värde",
        cellsDefaultRow: "Standard cell texter",
        surveyEditorTitle: "Redigera schema inställningar",
        qEditorTitle: "Redigera: {0}",
        maxLength: "Max längd",
        buildExpression: "Bygga",
        editExpression: "Redigera",
        and: "och",
        or: "eller",
        remove: "Avlägsna",
        addCondition: "Lägg till villkor",
        emptyLogicPopupMessage: "Välj en fråga för att börja konfigurera villkor.",
        if: "Om",
        then: "då",
        setToName: "Målfråga",
        fromName: "Fråga att kopiera svar från",
        gotoName: "Fråga att hoppa till",
        ruleIsNotSet: "Regeln är felaktig",
        includeIntoResult: "Inkludera i undersökningsresultat",
        showTitle: "Visa/dölj titel",
        expandCollapseTitle: "Expandera/komprimera titel",
        locale: "Standard språk",
        simulator: "Välj enhetstyp",
        landscapeOrientation: "Växla till liggande orientering",
        portraitOrientation: "Växla till stående orientering",
        mode: "Läge (redigera/läsa enbart)",
        clearInvisibleValues: "Rensa osynliga värden",
        cookieName: "Kaknamn (för att inaktivera kör enkäten två gånger lokalt)",
        sendResultOnPageNext: "Skicka enkät resultatet till nästa sida",
        storeOthersAsComment: "Lagra 'andra' värden i ett separat fält",
        showPageTitles: "Visa sidtitel",
        showPageNumbers: "Visa sidnummer",
        pagePrevText: "Föregående",
        pageNextText: "Nästa",
        completeText: "Färdig",
        previewText: "Text för knappen Förhandsgranska svar",
        editText: "Text för knappen Redigera svar",
        startSurveyText: "Start knapp text",
        showNavigationButtons: "Visa navigationsknappar (standard navigering)",
        showPrevButton: "Visa föregående knapp (användaren kan gå återgå till föregående sida)",
        firstPageIsStarted: "Den första sidan i enkäten är startsidan.",
        showCompletedPage: "Visa den slutförda sidan på slutet (completedHtml)",
        goNextPageAutomatic: "Vid besvarande av alla frågor, gå till nästa sida automatiskt",
        allowCompleteSurveyAutomatic: "Fyll i enkäten automatiskt",
        showProgressBar: "Visa händelsförlopp",
        questionTitleLocation: "Fråga titel placering",
        questionTitleWidth: "Bredd på frågerubrik",
        requiredText: "Var vänlig skriv en text",
        questionTitleTemplate: "Fråga titel mall, standard är: '{no}. {require} {title}'",
        questionErrorLocation: "Fråga fel placerad",
        focusFirstQuestionAutomatic: "Fokusera på första frågan vid ändring av sidan",
        questionsOrder: "Element ordning på sidan",
        maxTimeToFinish: "Max tid för att slutföra enkäten",
        maxTimeToFinishPage: "Max tid för att göra färdigt en sida i enkäten",
        showTimerPanel: "Visa tidtagning",
        showTimerPanelMode: "Visa tidtagning läge",
        renderMode: "Rendering läge",
        allowAddPanel: "Tillåt att lägga till panel",
        allowRemovePanel: "Tillåt att ta bort panel",
        panelAddText: "Lägg till panel text",
        panelRemoveText: "Ta bort panel text",
        isSinglePage: "Visa alla element på en sida",
        html: "HTML-kod",
        setValue: "Svar",
        dataFormat: "Bildformat",
        allowAddRows: "Tillåt att rader läggs till",
        allowRemoveRows: "Tillåt borttagning av rader",
        allowRowsDragAndDrop: "Tillåt dra och släpp rader",
        responsiveImageSizeHelp: "Gäller inte om du anger bildens exakta bredd eller höjd.",
        minImageWidth: "Minsta bildbredd",
        maxImageWidth: "Maximal bildbredd",
        minImageHeight: "Minsta bildhöjd",
        maxImageHeight: "Maximal bildhöjd",
        minValue: "Minsta värde",
        maxValue: "Maximalt värde",
        minLength: "Minsta längd (i tecken)",
        allowDigits: "Tillåt siffror",
        minCount: "Minsta antal",
        maxCount: "Maximalt antal",
        regex: "Reguljärt uttryck",
        surveyvalidator: {
            text: "Felmeddelande",
            expression: "Uttryck för validering"
        },
        totalText: "Text för summarad",
        totalType: "Total typ",
        totalExpression: "Totalt uttryck",
        totalDisplayStyle: "Visningsformat för totalt värde",
        totalCurrency: "Valuta",
        totalFormat: "Formaterad sträng",
        logo: "Logotyp (URL eller base64-kodad sträng)",
        questionsOnPageMode: "Undersökningens struktur",
        maxTextLength: "Maximal svarslängd (i tecken)",
        maxOthersLength: "Maximal kommentarslängd (i tecken)",
        commentAreaRows: "Kommentarsfältets höjd (i rader)",
        autoGrowComment: "Expandera kommentarsområdet automatiskt om det behövs",
        allowResizeComment: "Tillåt användare att ändra storlek på textområden",
        textUpdateMode: "Uppdatera textfrågevärde",
        maskType: "Typ av indatamask",
        maskTypes: {
            none: "Ingen",
            patternmask: "Mönster",
            numericmask: "Numerisk",
            datetimemask: "Datum och tid",
            currencymask: "Valuta"
        },
        focusOnFirstError: "Ställ in fokus på det första ogiltiga svaret",
        checkErrorsMode: "Kör validering",
        navigateToUrl: "Navigera till URL",
        navigateToUrlOnCondition: "Dynamisk URL",
        completedBeforeHtml: "Markering för att visa om användaren redan har fyllt i undersökningen",
        completedHtml: "Undersökning slutförd sidmarkering",
        completedHtmlOnCondition: "Dynamisk undersökning Fullständig sidmarkering",
        loadingHtml: "Markering som ska visas medan undersökningsmodellen läses in",
        commentText: "Text i kommentarsområdet",
        autocomplete: "Typ av komplettera automatiskt",
        labelTrue: "Etiketten \"Sant\"",
        labelFalse: "Etiketten \"Falskt\"",
        allowClear: "Visa knappen Rensa",
        searchMode: "Sökläge",
        displayStyle: "Visningsformat för värde",
        format: "Formaterad sträng",
        maximumFractionDigits: "Maximala bråktal",
        minimumFractionDigits: "Minsta bråktal",
        useGrouping: "Visa grupperingsavgränsare",
        allowMultiple: "Tillåt flera filer",
        allowImagesPreview: "Förhandsgranska bilder",
        acceptedTypes: "Godkända filtyper",
        waitForUpload: "Vänta tills uppladdningen är klar",
        needConfirmRemoveFile: "Bekräfta borttagning av fil",
        detailPanelMode: "Placering på detaljpanelen",
        minRowCount: "Minsta antal rader",
        maxRowCount: "Maximalt antal rader",
        confirmDelete: "Bekräfta borttagning av rad",
        confirmDeleteText: "Bekräftelsemeddelande",
        panelCount: "Inledande panelantal",
        minPanelCount: "Minsta antal paneler",
        maxPanelCount: "Maximalt antal paneler",
        panelsState: "Expanderingsläge för innerpanelen",
        panelPrevText: "Knappbeskrivning för föregående panel",
        panelNextText: "Knappbeskrivning för knappen Nästa panel",
        showRangeInProgress: "Visa förloppsindikator",
        panelRemoveButtonLocation: "Ta bort panelknappens placering",
        hideIfRowsEmpty: "Dölj frågan om det inte finns några rader",
        hideColumnsIfEmpty: "Dölj kolumner om det inte finns några rader",
        rateValues: "Anpassade prisvärden",
        rateCount: "Antal priser",
        autoGenerate: "Hur anger jag hastighetsvärden?",
        hideIfChoicesEmpty: "Dölj frågan om den inte innehåller några alternativ",
        minWidth: "Minsta bredd (i CSS-godkända värden)",
        maxWidth: "Maximal bredd (i CSS-godkända värden)",
        width: "Bredd (i CSS-accepterade värden)",
        showHeader: "Visa kolumnrubriker",
        horizontalScroll: "Visa vågrät rullningslist",
        columnMinWidth: "Minsta kolumnbredd (i CSS-godkända värden)",
        rowTitleWidth: "Radrubrikbredd (i CSS-godkända värden)",
        valueTrue: "\"Sant\" värde",
        valueFalse: "\"Falskt\" värde",
        minErrorText: "Felmeddelandet \"Värdet är under minimum\"",
        maxErrorText: "Felmeddelandet \"Värdet överskrider max\"",
        otherErrorText: "Felmeddelandet \"Tom kommentar\"",
        keyDuplicationError: "Felmeddelandet \"Icke-unikt nyckelvärde\"",
        minSelectedChoices: "Minsta valda val",
        maxSelectedChoices: "Maximalt antal valda val",
        showClearButton: "Visa knappen Rensa",
        logoWidth: "Logotypbredd (i CSS-godkända värden)",
        logoHeight: "Logotypens höjd (i CSS-godkända värden)",
        readOnly: "Skrivskyddad",
        enableIf: "Redigerbar om",
        emptyRowsText: "Meddelandet \"Inga rader\"",
        separateSpecialChoices: "Avgränsa specialval (Ingen, Annat, Markera alla)",
        choicesFromQuestion: "Kopiera alternativ från följande fråga",
        choicesFromQuestionMode: "Vilka val ska du kopiera?",
        progressBarShowPageTitles: "Visa sidrubriker i förloppsindikatorn",
        progressBarShowPageNumbers: "Visa sidnummer i förloppsindikatorn",
        showCommentArea: "Visa kommentarsområdet",
        commentPlaceholder: "Platshållare för kommentarsområde",
        displayRateDescriptionsAsExtremeItems: "Visa hastighetsbeskrivningar som extremvärden",
        rowsOrder: "Radordning",
        columnsLayout: "Kolumnlayout",
        columnColCount: "Kapslat antal kolumner",
        correctAnswer: "Rätt svar",
        defaultPanelValue: "Standardvärden",
        cells: "Cell texter",
        fileInputPlaceholder: "Välj en fil eller klistra in en fillänk...",
        keyName: "Kolumnen Nyckel",
        itemvalue: {
            visibleIf: "Gör alternativet synligt om",
            enableIf: "Gör alternativet valbart om"
        },
        "itemvalue@rows": {
            visibleIf: "Gör raden synlig om",
            enableIf: "Gör raden redigerbar om"
        },
        imageitemvalue: {
            text: "Alt-text"
        },
        logoPosition: "Logotypens placering",
        addLogo: "Lägg till logotyp...",
        changeLogo: "Ändra logotyp...",
        logoPositions: {
            none: "Ta bort logotyp",
            left: "Vänster",
            right: "Höger",
            top: "På toppen",
            bottom: "I botten"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Panelens layout"
            },
            general: "Generellt",
            fileOptions: "Alternativ",
            html: "Html-editor",
            columns: "Kolumner",
            rows: "Rader",
            choices: "Välj",
            items: "Element",
            visibleIf: "Synlig",
            enableIf: "Tillgänlig",
            requiredIf: "Obligatoriskt om",
            rateValues: "Ordna värden",
            choicesByUrl: "Välj från webben",
            matrixChoices: "Standard val",
            multipleTextItems: "Text indata",
            numbering: "Numrering",
            validators: "Valideringar",
            navigation: "Navigering",
            question: "Fråga",
            pages: "Sidor",
            timer: "Tidtagare/Quiz",
            calculatedValues: "Beräknade värden",
            triggers: "Triggare",
            templateTitle: "Mall titel",
            totals: "Summor",
            logic: "Logik",
            mask: "Inställningar för inmatningsmask",
            layout: {
                panel: "Layout",
                question: "Layout",
                base: "Layout"
            },
            data: "Data",
            validation: "Validering",
            cells: "Cell texter",
            showOnCompleted: "Undersökningen slutförd",
            logo: "Logotyp i undersökningens titel",
            slider: "Skjutreglage",
            expression: "Uttryck",
            questionSettings: "Inställningar för frågor",
            header: "Rubrik",
            background: "Bakgrund",
            appearance: "Utseende",
            others: "Andra"
        },
        editProperty: "Redigera egenskap '{0}'",
        items: "[ Element: {0} ]",
        choicesVisibleIf: "Alternativen är synliga om",
        choicesEnableIf: "Alternativen kan väljas om",
        columnsEnableIf: "Kolumner visas om",
        rowsEnableIf: "Raderna visas om",
        innerIndent: "Lägga till inre indrag",
        defaultValueFromLastRow: "Ta standardvärden från den sista raden",
        defaultValueFromLastPanel: "Ta standardvärden från den sista panelen",
        enterNewValue: "Vänligen skriv in ett värde.",
        noquestions: "Det finns ingen fråga i enkäten.",
        createtrigger: "Vänligen skapa en trigger",
        titleKeyboardAdornerTip: "Tryck på enter-knappen för att redigera",
        keyboardAdornerTip: "Tryck på enter-knappen för att redigera objektet, tryck på raderingsknappen för att radera objektet, tryck på alt plus pil uppåt eller pil nedåt för att flytta objektet",
        triggerOn: "På ",
        triggerMakePagesVisible: "Synligör sidor:",
        triggerMakeQuestionsVisible: "Synligör element:",
        triggerCompleteText: "Avsluta enkät vid verkställ.",
        triggerNotSet: "Trigger är inte satt",
        triggerRunIf: "Kör ",
        triggerSetToName: "Ändra värden av: ",
        triggerFromName: "Kopiera värden från: ",
        triggerRunExpression: "Kör detta uttryck:",
        triggerSetValue: "till: ",
        triggerGotoName: "Gå till frågan",
        triggerIsVariable: "Var vänligen skriv ett giltigt uttryck.",
        triggerRunExpressionEmpty: "Ange ett giltigt uttryck",
        emptyExpressionPlaceHolder: "Skriv uttryck här...",
        noFile: "Ingen fil har valts",
        clearIfInvisible: "Rensa värdet om frågan döljs",
        valuePropertyName: "Egenskapsnamn för värde",
        searchEnabled: "Aktivera sökning",
        hideSelectedItems: "Dölja markerade objekt",
        closeOnSelect: "Stäng listrutan efter val",
        verticalAlign: "Vertikal inriktning",
        alternateRows: "Varannan rad",
        columnsVisibleIf: "Kolumner visas om",
        rowsVisibleIf: "Raderna visas om",
        otherPlaceholder: "Platshållare för kommentarsområde",
        filePlaceholder: "Text för filplatshållare",
        photoPlaceholder: "Text för platshållare för foton",
        fileOrPhotoPlaceholder: "Platshållartext för fil eller foto",
        rateType: "Typ av hastighet",
        url_placeholder: "Ex.: https://api.example.com/books",
        path_placeholder: "Ex.: kategorier.skönlitteratur",
        questionStartIndex_placeholder: "Ex.: a)",
        width_placeholder: "Ex.: 6 tum",
        minWidth_placeholder: "Ex.: 600px",
        maxWidth_placeholder: "Ex.: 50%",
        imageHeight_placeholder: "bil",
        imageWidth_placeholder: "bil",
        theme: {
            themeName: "Tema",
            isPanelless: "Frågans utseende",
            editorPanel: "Bakgrund och hörnradie",
            questionPanel: "Bakgrund och hörnradie",
            primaryColor: "Accentfärg",
            panelBackgroundTransparency: "Opacitet för panelbakgrund",
            questionBackgroundTransparency: "Opacitet för frågebakgrund",
            fontSize: "Teckenstorlek",
            scale: "Skala",
            cornerRadius: "Hörn radie",
            pageTitle: "Titel typsnitt",
            pageDescription: "Beskrivning teckensnitt",
            questionTitle: "Titel typsnitt",
            questionDescription: "Beskrivning teckensnitt",
            editorFont: "Teckensnitt",
            backgroundOpacity: "Ogenomskinlighet",
            "--sjs-font-family": "Teckensnitt familj",
            "--sjs-general-backcolor-dim": "Bakgrundsfärg",
            "--sjs-primary-backcolor": "Accent bakgrund",
            "--sjs-primary-forecolor": "Accent förgrund",
            "--sjs-special-red": "Felmeddelanden",
            "--sjs-shadow-small": "Skugga effekter",
            "--sjs-shadow-inner": "Skugga effekter",
            "--sjs-border-default": "Färger"
        },
        "header@header": {
            headerView: "Utsikt",
            logoPosition: "Logotypens placering",
            surveyTitle: "Teckensnitt för undersökningens titel",
            surveyDescription: "Teckensnitt för undersökningsbeskrivning",
            headerTitle: "Teckensnitt för undersökningens titel",
            headerDescription: "Teckensnitt för undersökningsbeskrivning",
            inheritWidthFrom: "Bredd på innehållsområdet",
            textAreaWidth: "Textens bredd",
            backgroundColorSwitch: "Bakgrundsfärg",
            backgroundImage: "Bakgrundsbild",
            backgroundImageOpacity: "Ogenomskinlighet",
            overlapEnabled: "Överlappa",
            logoPositionX: "Logotypens placering",
            titlePositionX: "Titel position",
            descriptionPositionX: "Beskrivning position"
        }
    },
    // Property values
    pv: {
        "true": "sann",
        "false": "falsk",
        file: "Lokala filer",
        camera: "Kamera",
        "file-camera": "Lokala filer eller kamera",
        inherit: "inherit",
        show: "show",
        hide: "hide",
        default: "default",
        initial: "initial",
        random: "random",
        collapsed: "collapsed",
        expanded: "expanded",
        none: "none",
        asc: "ascending",
        desc: "descending",
        indeterminate: "indeterminate",
        selected: "Vald",
        unselected: "Omarkerade",
        decimal: "decimal",
        currency: "valuta",
        percent: "procent",
        firstExpanded: "firstExpanded",
        off: "off",
        list: "list",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        tab: "Flikar",
        horizontal: "horizontal",
        vertical: "vertical",
        top: "top",
        bottom: "bottom",
        topBottom: "top and bottom",
        both: "Båda",
        left: "left",
        right: "Höger",
        center: "Centrum",
        leftRight: "Vänster och höger",
        middle: "Mitt",
        color: "färg",
        date: "datum",
        datetime: "datetime",
        "datetime-local": "datetime-lokal",
        email: "E-post",
        month: "månad",
        number: "nummer",
        password: "lösenord",
        range: "sortiment",
        tel: "Tel",
        text: "SMS",
        time: "Tid",
        url: "URL",
        week: "vecka",
        hidden: "hidden",
        edit: "edit",
        display: "display",
        contain: "Innehålla",
        cover: "Täcka",
        fill: "Fylla",
        next: "Nästa",
        last: "Sist",
        onComplete: "onComplete",
        onHidden: "onHidden",
        onHiddenContainer: "När frågan eller dess panel/sida döljs",
        clearInvisibleValues: {
            none: "Aldrig"
        },
        clearIfInvisible: {
            none: "Aldrig"
        },
        inputType: {
            color: "Färg",
            date: "Datum",
            "datetime-local": "Datum och tid",
            email: "E-post",
            month: "Månad",
            number: "Nummer",
            password: "Lösenord",
            range: "Sortiment",
            tel: "Telefonnummer",
            text: "SMS",
            time: "Tid",
            url: "URL",
            week: "Vecka"
        },
        all: "all",
        page: "page",
        survey: "survey",
        onNextPage: "onNextPage",
        onValueChanged: "onValueChanged",
        onValueChanging: "Innan ett svar ändras",
        questionsOnPageMode: {
            standard: "Ursprunglig struktur",
            singlePage: "Visa alla frågor på en sida",
            questionPerPage: "Visa en fråga per sida"
        },
        noPreview: "Ingen förhandsgranskning",
        showAllQuestions: "Visa alla frågor",
        showAnsweredQuestions: "Visa endast besvarade frågor",
        pages: "Avslutade sidor",
        questions: "Besvarade frågor",
        requiredQuestions: "Besvarade obligatoriska frågor",
        correctQuestions: "Giltiga svar",
        buttons: "Slutförda sidor (knappgränssnitt)",
        underInput: "Under ingången",
        underTitle: "Under rubriken",
        onBlur: "Vid oskärpa",
        onTyping: "Medan du skriver",
        underRow: "Under raden",
        underRowSingle: "Under raden syns bara en panel",
        auto: "Bil",
        showNavigationButtons: {
            none: "Dold"
        },
        showTimerPanel: {
            none: "Dold"
        },
        showTimerPanelMode: {
            all: "Båda"
        },
        addRowLocation: {
            default: "Beror på matrislayout"
        },
        panelsState: {
            default: "Användare kan inte expandera eller komprimera paneler",
            collapsed: "Alla paneler är komprimerade",
            expanded: "Alla paneler är expanderade",
            firstExpanded: "Först utökad"
        },
        widthMode: {
            static: "Statisk",
            responsive: "Responsiv"
        },
        contentMode: {
            image: "Bild",
            video: "Video",
            youtube: "YouTube"
        },
        displayMode: {
            buttons: "Knappar",
            dropdown: "Rullgardinsmeny"
        },
        rateColorMode: {
            default: "Standard",
            scale: "Skala"
        },
        scaleColorMode: {
            monochrome: "Monokrom",
            colored: "Färgad"
        },
        autoGenerate: {
            "true": "Generera",
            "false": "Ange manuellt"
        },
        rateType: {
            labels: "Etiketter",
            stars: "Stjärnor",
            smileys: "Smileys"
        },
        state: {
            default: "Låst"
        },
        showQuestionNumbers: {
            default: "Automatisk numrering",
            on: "Automatisk numrering",
            onPage: "Återställ på varje sida",
            onpanel: "Återställ på varje panel",
            onPanel: "Återställ på varje panel",
            onSurvey: "Fortsätt genom undersökningen",
            off: "Ingen numrering"
        },
        descriptionLocation: {
            underTitle: "Under frågans rubrik",
            underInput: "Under inmatningsfältet"
        },
        selectToRankAreasLayout: {
            horizontal: "Bredvid alternativ",
            vertical: "Ovanstående val"
        },
        displayStyle: {
            decimal: "Decimal",
            currency: "Valuta",
            percent: "Procent",
            date: "Datum"
        },
        totalDisplayStyle: {
            decimal: "Decimal",
            currency: "Valuta",
            percent: "Procent",
            date: "Datum"
        },
        rowsOrder: {
            initial: "Original"
        },
        questionsOrder: {
            initial: "Original"
        },
        showProgressBar: {
            off: "Dold",
            topbottom: "top and bottom",
            aboveheader: "Ovanför sidhuvudet",
            belowheader: "Nedanför rubriken"
        },
        sum: "Summa",
        count: "Räkna",
        min: "Min",
        max: "Max",
        avg: "Avg",
        searchMode: {
            contains: "Innehåller",
            startsWith: "Börjar med"
        },
        backgroundImageFit: {
            auto: "Bil",
            cover: "Täcka",
            contain: "Innehålla",
            fill: "Tänja",
            tile: "Kakel"
        },
        backgroundImageAttachment: {
            fixed: "Fast",
            scroll: "Rulla"
        },
        headerView: {
            basic: "Grundläggande",
            advanced: "Avancerad"
        },
        inheritWidthFrom: {
            survey: "Samma som enkät",
            container: "Passa till behållare"
        },
        backgroundColorSwitch: {
            none: "Ingen",
            accentColor: "Accentfärg",
            custom: "Sed"
        },
        colorPalette: {
            light: "Ljus",
            dark: "Mörk"
        },
        isPanelless: {
            "false": "Standard",
            "true": "Utan paneler"
        }
    },
    // Operators
    op: {
        empty: "is empty",
        notempty: "is not empty",
        equal: "equals",
        notequal: "not equals",
        contains: "contains",
        notcontains: "not contains",
        anyof: "Någon av",
        allof: "Alla",
        greater: "greater",
        less: "less",
        greaterorequal: "greater or equals",
        lessorequal: "less or equals",
        and: "och",
        or: "eller"
    },
    // Embed window
    ew: {
        angular: "Använd Angular version",
        jquery: "Använd jQuery version",
        knockout: "Använd Knockout version",
        react: "Använd React version",
        vue: "Använd Vue version",
        bootstrap: "För bootstrap framework",
        modern: "Modernt tema",
        default: "Standardtema",
        orange: "Orange tema",
        darkblue: "Mörkblått tema",
        darkrose: "Darkrose-tema",
        stone: "Sten tema",
        winter: "Vinter tema",
        winterstone: "Vintersten, tema",
        showOnPage: "Visa enkät på en sida",
        showInWindow: "Visa enkäten i ett nytt fönster",
        loadFromServer: "Hämta enkäten som JSON från servern",
        titleScript: "Scripts och styles",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Välj sida för att testa den:",
        showInvisibleElements: "Visa osynliga element",
        hideInvisibleElements: "Dölj osynliga element"
    },
    validators: {
        answercountvalidator: "answer count",
        emailvalidator: "e-mail",
        expressionvalidator: "expression",
        numericvalidator: "numeric",
        regexvalidator: "regex",
        textvalidator: "text"
    },
    triggers: {
        completetrigger: "Enkät slutförd",
        setvaluetrigger: "Sätt värde",
        copyvaluetrigger: "Kopiera värde",
        skiptrigger: "Hoppa till fråga",
        runexpressiontrigger: "Kör uttryck",
        visibletrigger: "Ändra synlighet"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Ex.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Ex.: mm/dd/åååå"
        },
        currencymask: {
            prefix: "Ex.: $",
            suffix: "Ex.: USD"
        },
        panelbase: {
            questionTitleWidth: "Ex.: 200px"
        }
    },
    pehelp: {
        panel: {
            name: "Ett panel-ID som inte är synligt för svarande.",
            description: "Skriv en panelundertext.",
            visibleIf: "Använd trollstavsikonen för att ställa in en villkorsregel som bestämmer panelens synlighet.",
            enableIf: "Använd trollstavsikonen för att ställa in en villkorsregel som inaktiverar det skrivskyddade läget för panelen.",
            requiredIf: "Använd trollstavsikonen för att ställa in en villkorsregel som förhindrar att undersökningen skickas in om inte minst en kapslad fråga har ett svar.",
            questionTitleLocation: "Gäller alla frågor i den här panelen. Om du vill åsidosätta den här inställningen definierar du regler för rubrikjustering för enskilda frågor. Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå (\"Topp\" som standard).",
            questionTitleWidth: "Anger konsekvent bredd för frågerubriker när de är justerade till vänster om frågerutorna. Accepterar CSS-värden (px, %, in, pt, etc.).",
            questionErrorLocation: "Anger platsen för ett felmeddelande i förhållande till alla frågor i panelen. Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå.",
            questionsOrder: "Behåller den ursprungliga ordningen på frågorna eller slumpar dem. Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå.",
            page: "Flyttar panelen till slutet av en markerad sida.",
            innerIndent: "Lägger till utrymme eller marginal mellan panelinnehållet och panelrutans vänstra kant.",
            startWithNewLine: "Avmarkera om du vill visa panelen på en rad med föregående fråga eller panel. Inställningen gäller inte om panelen är det första elementet i formuläret.",
            state: "Välj mellan: \"Expanderad\" - panelen visas i sin helhet och kan fällas ihop; \"Komprimerad\" - panelen visar endast titel och beskrivning och kan expanderas; \"Låst\" - panelen visas i sin helhet och kan inte fällas ihop.",
            width: "Ställer in panelens bredd i proportion till andra undersökningselement på samma rad. Accepterar CSS-värden (px, %, in, pt, etc.)."
        },
        paneldynamic: {
            name: "Ett panel-ID som inte är synligt för svarande.",
            description: "Skriv en panelundertext.",
            visibleIf: "Använd trollstavsikonen för att ställa in en villkorsregel som bestämmer panelens synlighet.",
            enableIf: "Använd trollstavsikonen för att ställa in en villkorsregel som inaktiverar det skrivskyddade läget för panelen.",
            requiredIf: "Använd trollstavsikonen för att ställa in en villkorsregel som förhindrar att undersökningen skickas in om inte minst en kapslad fråga har ett svar.",
            templateTitleLocation: "Gäller alla frågor i den här panelen. Om du vill åsidosätta den här inställningen definierar du regler för rubrikjustering för enskilda frågor. Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå (\"Topp\" som standard).",
            templateErrorLocation: "Anger platsen för ett felmeddelande i förhållande till en fråga med ogiltiga indata. Välj mellan: \"Överst\" - en feltext placeras högst upp i frågerutan; \"Nederst\" - en feltext placeras längst ner i frågerutan. Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå (\"Topp\" som standard).",
            errorLocation: "Anger platsen för ett felmeddelande i förhållande till alla frågor i panelen. Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå.",
            page: "Flyttar panelen till slutet av en markerad sida.",
            innerIndent: "Lägger till utrymme eller marginal mellan panelinnehållet och panelrutans vänstra kant.",
            startWithNewLine: "Avmarkera om du vill visa panelen på en rad med föregående fråga eller panel. Inställningen gäller inte om panelen är det första elementet i formuläret.",
            state: "Välj mellan: \"Expanderad\" - panelen visas i sin helhet och kan fällas ihop; \"Komprimerad\" - panelen visar endast titel och beskrivning och kan expanderas; \"Låst\" - panelen visas i sin helhet och kan inte fällas ihop.",
            width: "Ställer in panelens bredd i proportion till andra undersökningselement på samma rad. Accepterar CSS-värden (px, %, in, pt, etc.).",
            templateTitle: "Skriv in en mall för dynamiska panelrubriker. Använd {panelIndex} för panelens allmänna position och {visiblePanelIndex} för dess ordning bland de synliga panelerna. Infoga dessa platshållare i mönstret för att lägga till automatisk numrering.",
            templateTabTitle: "Skriv in en mall för flikrubriker. Använd {panelIndex} för en panels allmänna position och {visiblePanelIndex} för dess ordning bland synliga paneler. Infoga dessa platshållare i mönstret för att lägga till automatisk numrering.",
            tabTitlePlaceholder: "En reservtext för flikrubriker som gäller när flikrubrikmönstret inte ger ett meningsfullt värde.",
            templateVisibleIf: "Med den här inställningen kan du styra synligheten för enskilda paneler i den dynamiska panelen. Använd platshållaren {panel} för att referera till den aktuella panelen i uttrycket.",
            titleLocation: "Den här inställningen ärvs automatiskt av alla frågor i den här panelen. Om du vill åsidosätta den här inställningen definierar du regler för rubrikjustering för enskilda frågor. Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå (\"Topp\" som standard).",
            descriptionLocation: "Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå (\"Under panelrubriken\" som standard).",
            newPanelPosition: "Definierar placeringen av en nyligen tillagd panel. Som standard läggs nya paneler till i slutet. Välj \"Nästa\" för att infoga en ny panel efter den nuvarande.",
            defaultValueFromLastPanel: "Duplicerar svar från den sista panelen och tilldelar dem till nästa tillagda dynamiska panel.",
            keyName: "Referera till ett frågenamn för att kräva att en användare anger ett unikt svar för den här frågan i varje panel."
        },
        defaultValueExpression: "Med den här inställningen kan du tilldela ett standardsvarsvärde baserat på ett uttryck. Uttrycket kan innehålla grundläggande beräkningar – {q1_id} + {q2_id}, booleska uttryck, till exempel {age} > 60 och funktioner: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' osv. Värdet som bestäms av detta uttryck fungerar som det initiala standardvärdet som kan åsidosättas av en svarandes manuella inmatning.",
        resetValueIf: "Använd trollstavsikonen för att ställa in en villkorsregel som avgör när en respondents inmatning återställs till värdet baserat på \"Standardvärdesuttryck\" eller \"Ange värdeuttryck\" eller till värdet \"Standardsvar\" (om något av dem är inställt).",
        setValueIf: "Använd trollstavsikonen för att ställa in en villkorsregel som avgör när \"Ange värdeuttryck\" ska köras och dynamiskt tilldela det resulterande värdet som ett svar.",
        setValueExpression: "Ange ett uttryck som definierar det värde som ska anges när villkoren i regeln \"Ange värde om\" uppfylls. Uttrycket kan innehålla grundläggande beräkningar – {q1_id} + {q2_id}, booleska uttryck, till exempel {age} > 60 och funktioner: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' osv. Värdet som bestäms av detta uttryck kan åsidosättas av en svarandes manuella inmatning.",
        question: {
            name: "Ett fråge-ID som inte är synligt för svarande.",
            description: "Skriv en underrubrik för frågan.",
            visibleIf: "Använd trollstavsikonen för att ställa in en villkorsregel som avgör frågans synlighet.",
            enableIf: "Använd trollstavsikonen för att ställa in en villkorsregel som inaktiverar det skrivskyddade läget för frågan.",
            requiredIf: "Använd trollstavsikonen för att ställa in en villkorsregel som förhindrar att undersökningen går vidare eller skickas in om inte frågan har fått ett svar.",
            startWithNewLine: "Avmarkera om du vill visa frågan på en rad med föregående fråga eller panel. Inställningen gäller inte om frågan är det första elementet i formuläret.",
            page: "Flyttar frågan till slutet av en markerad sida.",
            state: "Välj mellan: \"Expanderad\" - frågerutan visas i sin helhet och kan fällas ihop; \"Komprimerad\" - frågerutan visar endast titel och beskrivning och kan expanderas; \"Låst\" - frågerutan visas i sin helhet och kan inte fällas ihop.",
            titleLocation: "Åsidosätter regler för justering av titlar som definierats på panel-, sid- eller undersökningsnivå. Alternativet \"Ärv\" tillämpar alla inställningar på högre nivå (om de är inställda) eller inställningar på undersökningsnivå (\"Överst\" som standard).",
            descriptionLocation: "Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå (\"Under frågans titel\" som standard).",
            errorLocation: "Anger platsen för ett felmeddelande i förhållande till frågan med ogiltig inmatning. Välj mellan: \"Överst\" - en feltext placeras högst upp i frågerutan; \"Nederst\" - en feltext placeras längst ner i frågerutan. Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå (\"Topp\" som standard).",
            indent: "Lägger till utrymme eller marginal mellan frågeinnehållet och frågerutans vänstra kant.",
            width: "Anger frågans bredd i proportion till andra undersökningselement på samma rad. Accepterar CSS-värden (px, %, in, pt, etc.).",
            surveyvalidator: {
                expression: "Använd trollstavsikonen för att ställa in ett valideringsuttryck för frågan."
            },
            textUpdateMode: "Välj mellan: \"Vid förlorat fokus\" - värdet uppdateras när inmatningsfältet tappar fokus; \"Medan du skriver\" - värdet uppdateras i realtid när användarna skriver. Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå (\"Vid förlorat fokus\" som standard).",
            url: "Du kan använda valfri webbtjänst som datakälla för flervalsfrågor. Om du vill fylla i alternativvärden anger du URL:en för den tjänst som tillhandahåller data.",
            searchMode: "En jämförelseåtgärd som används för att filtrera listrutan.",
            textWrapEnabled: "Långa texter i valalternativ genererar automatiskt radbrytningar för att passa in i rullgardinsmenyn. Avmarkera om du vill att texterna ska klippas."
        },
        signaturepad: {
            signatureWidth: "Anger bredden på det visade signaturområdet och den resulterande bilden.",
            signatureHeight: "Anger höjden på det visade signaturområdet och den resulterande bilden.",
            signatureAutoScaleEnabled: "Välj om du vill att signaturområdet ska fylla allt tillgängligt utrymme i frågerutan samtidigt som standardproportionerna 3:2 bibehålls. När anpassade bredd- och höjdvärden anges behåller inställningen proportionerna för dessa dimensioner."
        },
        file: {
            imageHeight: "Justerar höjden på bilden i undersökningsresultaten.",
            imageWidth: "Justerar bredden på bilden i undersökningsresultaten."
        },
        image: {
            contentMode: "Alternativet \"Auto\" bestämmer automatiskt vilket läge som är lämpligt för visning - bild, video eller YouTube - baserat på den angivna källadressen."
        },
        imagepicker: {
            imageHeight: "Åsidosätter värdena för lägsta och högsta höjd.",
            imageWidth: "Åsidosätter värdena för minsta och största bredd.",
            choices: "\"Värde\" fungerar som ett objekt-ID som används i villkorsregler. \"Text\" visas för respondenterna.",
            contentMode: "Välj mellan \"Bild\" och \"Video\" för att ställa in innehållsläget för medieväljaren. Om \"Bild\" är valt, se till att alla alternativ som tillhandahålls är bildfiler i följande format: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. På samma sätt, om \"Video\" är valt, se till att alla alternativ är direktlänkar till videofiler i följande format: MP4, MOV, WMV, FLV, AVI, MKV. Observera att YouTube-länkar inte stöds för videoalternativ."
        },
        text: {
            size: "Den här inställningen ändrar bara storleken på inmatningsfältet och påverkar inte frågerutans bredd. Om du vill begränsa den godkända indatalängden går du till <b>Validering → Maximal teckengräns</b>."
        },
        comment: {
            rows: "Ställer in antalet rader som visas i inmatningsfältet. Om inmatningen tar upp fler rader visas rullningslisten."
        },
        // survey templates
        survey: {
            mode: "Välj mellan: \"Redigerbar\" - gör det möjligt för respondenterna att fylla i din undersökning; \"Skrivskyddad\" - inaktiverar formulärredigering."
        },
        matrixdropdowncolumn: {
            name: "Ett kolumn-ID som inte är synligt för svarande.",
            isUnique: "När den är aktiverad för en kolumn måste en svarande ange ett unikt svar för varje fråga i den här kolumnen.",
            rows: "Ställer in antalet rader som visas i inmatningsfältet. Om inmatningen tar upp fler rader visas rullningslisten.",
            visibleIf: "Använd trollstavsikonen för att ange en villkorsregel som bestämmer kolumnens synlighet.",
            enableIf: "Använd trollstavsikonen för att ange en villkorsregel som inaktiverar skrivskyddat läge för kolumnen.",
            requiredIf: "Använd trollstavsikonen för att ställa in en villkorsregel som förhindrar att undersökningen skickas in om inte minst en kapslad fråga har ett svar.",
            showInMultipleColumns: "När du väljer det här alternativet skapas en enskild kolumn för varje alternativ."
        },
        widthMode: "Välj mellan: \"Statisk\" - ställer in en fast bredd; \"Responsiv\" - gör att undersökningen upptar hela skärmens bredd; \"Auto\" - gäller någon av de två beroende på vilka frågetyper som används.",
        cookieName: "Cookies hindrar användare från att fylla i samma undersökning två gånger.",
        logo: "Klistra in en bildlänk (inga storleksbegränsningar) eller klicka på mappikonen för att bläddra i en fil från din dator (upp till 64 kB).",
        logoWidth: "Anger en logotypbredd i CSS-enheter (px, %, in, pt, etc.).",
        logoHeight: "Anger en logotyphöjd i CSS-enheter (px, %, in, pt, etc.).",
        logoFit: "Välj mellan: \"Ingen\" - bilden behåller sin ursprungliga storlek; \"Innehåll\" - bildens storlek ändras så att den passar samtidigt som bildförhållandet bibehålls. \"Cover\" - bilden fyller hela rutan samtidigt som bildförhållandet bibehålls; \"Fyll\" - bilden sträcks ut för att fylla rutan utan att behålla bildförhållandet.",
        goNextPageAutomatic: "Välj om du vill att undersökningen ska gå vidare till nästa sida automatiskt efter att en svarande har svarat på alla frågor på den aktuella sidan.",
        allowCompleteSurveyAutomatic: "Välj om du vill att undersökningen ska slutföras automatiskt efter att en svarande har svarat på alla frågor.",
        showNavigationButtons: "Anger synlighet och placering av navigeringsknappar på en sida.",
        showProgressBar: "Anger synlighet och plats för en förloppsindikator. Värdet \"Auto\" visar förloppsindikatorn ovanför eller under undersökningshuvudet.",
        showPreviewBeforeComplete: "Aktivera förhandsgranskningssidan med alla eller endast besvarade frågor.",
        questionTitleLocation: "Gäller alla frågor i undersökningen. Den här inställningen kan åsidosättas av regler för justering av rubriker på lägre nivåer: panel, sida eller fråga. En inställning på lägre nivå åsidosätter de på en högre nivå.",
        requiredText: "En symbol eller en sekvens av symboler som anger att ett svar krävs.",
        questionStartIndex: "Ange en siffra eller bokstav som du vill börja numrera med.",
        questionErrorLocation: "Anger platsen för ett felmeddelande i förhållande till frågan med ogiltig inmatning. Välj mellan: \"Överst\" - en feltext placeras högst upp i frågerutan; \"Nederst\" - en feltext placeras längst ner i frågerutan.",
        focusFirstQuestionAutomatic: "Välj om du vill att det första inmatningsfältet på varje sida ska vara klart för textinmatning.",
        questionsOrder: "Behåller den ursprungliga ordningen på frågorna eller slumpar dem. Effekten av den här inställningen visas bara på fliken Förhandsgranska.",
        maxTextLength: "Endast för textinmatningsfrågor.",
        maxOthersLength: "Endast för frågekommentarer.",
        commentAreaRows: "Anger antalet rader som ska visas i textområden för frågekommentarer. I inmatningen tar upp fler rader visas rullningslisten.",
        autoGrowComment: "Välj om du vill att frågekommentarer och långa textfrågor automatiskt ska öka i höjd baserat på den angivna textlängden.",
        allowResizeComment: "Endast för frågekommentarer och långa textfrågor.",
        calculatedValues: "Anpassade variabler fungerar som mellanliggande variabler eller hjälpvariabler som används i formulärberäkningar. De tar svarandes indata som källvärden. Varje anpassad variabel har ett unikt namn och ett uttryck som den baseras på.",
        includeIntoResult: "Välj om du vill att det beräknade värdet av uttrycket ska sparas tillsammans med undersökningsresultaten.",
        triggers: "En utlösare är en händelse eller ett villkor som baseras på ett uttryck. När uttrycket har utvärderats till \"true\" utlöser en utlösare en åtgärd. En sådan åtgärd kan valfritt ha en målfråga som den påverkar.",
        clearInvisibleValues: "Välj om du vill rensa värden för frågor som döljs av villkorsstyrd logik och när du vill göra det.",
        textUpdateMode: "Välj mellan: \"Vid förlorat fokus\" - värdet uppdateras när inmatningsfältet tappar fokus; \"Medan du skriver\" - värdet uppdateras i realtid när användarna skriver.",
        columns: "Det vänstra värdet fungerar som ett kolumn-ID som används i villkorsregler, det högra värdet visas för respondenterna.",
        rows: "Det vänstra värdet fungerar som ett rad-ID som används i villkorsregler, det högra värdet visas för respondenterna.",
        columnMinWidth: "Accepterar CSS-värden (px, %, in, pt, etc.).",
        rowTitleWidth: "Accepterar CSS-värden (px, %, in, pt, etc.).",
        totalText: "Visas bara när minst en kolumn har Total type eller Total uttryck.",
        cellErrorLocation: "Anger platsen för ett felmeddelande i förhållande till en cell med ogiltiga indata. Alternativet \"Ärv\" tillämpar inställningen från egenskapen \"Justering av felmeddelande\".",
        keyDuplicationError: "När egenskapen \"Förhindra dubblettsvar\" är aktiverad kommer en svarande som försöker skicka in en dubblett att få följande felmeddelande.",
        totalExpression: "Gör att du kan beräkna totalvärden baserat på ett uttryck. Uttrycket kan innehålla grundläggande beräkningar ('{q1_id} + {q2_id}'), booleska uttryck ('{age} > 60') och funktioner ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.).",
        confirmDelete: "Utlöser en uppmaning där du uppmanas att bekräfta borttagningen av raden.",
        defaultValueFromLastRow: "Duplicerar svar från den sista raden och tilldelar dem till nästa tillagda dynamiska rad.",
        keyName: "Om den angivna kolumnen innehåller identiska värden genereras felet \"Icke-unikt nyckelvärde\".",
        description: "Skriv en undertext.",
        locale: "Välj ett språk för att börja skapa din undersökning. Om du vill lägga till en översättning byter du till ett nytt språk och översätter originaltexten här eller på fliken Översättningar.",
        detailPanelMode: "Anger platsen för ett detaljavsnitt i förhållande till en rad. Välj mellan: \"Ingen\" - ingen expansion läggs till; \"Under raden\" - en radexpansion placeras under varje rad i matrisen; \"Visa endast en radexpansion under raden\" - en expansion visas endast under en enda rad, de återstående radexpansionerna är komprimerade.",
        imageFit: "Välj mellan: \"Ingen\" - bilden behåller sin ursprungliga storlek; \"Innehåll\" - bildens storlek ändras så att den passar samtidigt som bildförhållandet bibehålls. \"Cover\" - bilden fyller hela rutan samtidigt som bildförhållandet bibehålls; \"Fyll\" - bilden sträcks ut för att fylla rutan utan att behålla bildförhållandet.",
        autoGrow: "Ökar gradvis höjden på inmatningsfältet när data matas in. Åsidosätter inställningen \"Inmatningsfältets höjd (i rader)\".",
        allowResize: "Storlekshandtaget (eller greppet) visas i hörnet och kan dras för att ändra storleken på inmatningsfältet.",
        maxTimeToFinish: "Ett tidsintervall i sekunder varefter undersökningen automatiskt går vidare till Tack-sidan.",
        maxTimeToFinishPage: "Ett tidsintervall i sekunder varefter undersökningen automatiskt går vidare till nästa sida.",
        page: {
            maxTimeToFinish: "Ett tidsintervall i sekunder varefter undersökningen automatiskt går vidare till nästa sida.",
            visibleIf: "Använd trollstavsikonen för att ställa in en villkorsregel som bestämmer sidans synlighet.",
            enableIf: "Använd trollstavsikonen för att ställa in en villkorsregel som inaktiverar det skrivskyddade läget för sidan.",
            requiredIf: "Använd trollstavsikonen för att ställa in en villkorsregel som förhindrar att undersökningen skickas in om inte minst en kapslad fråga har ett svar.",
            questionTitleLocation: "Gäller alla frågor på denna sida. Om du vill åsidosätta den här inställningen definierar du regler för titeljustering för enskilda frågor eller paneler. Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå (\"Topp\" som standard).",
            questionTitleWidth: "Anger konsekvent bredd för frågerubriker när de är justerade till vänster om frågerutorna. Accepterar CSS-värden (px, %, in, pt, etc.).",
            questionErrorLocation: "Anger platsen för ett felmeddelande i förhållande till frågan med ogiltig inmatning. Välj mellan: \"Överst\" - en feltext placeras högst upp i frågerutan; \"Nederst\" - en feltext placeras längst ner i frågerutan. Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå (\"Topp\" som standard).",
            questionsOrder: "Behåller den ursprungliga ordningen på frågorna eller slumpar dem. Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå (\"Original\" som standard). Effekten av den här inställningen visas bara på fliken Förhandsgranska.",
            navigationButtonsVisibility: "Ställer in synligheten för navigeringsknapparna på sidan. Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå, som standard är \"Synlig\"."
        },
        showTimerPanel: "Ställer in synligheten och placeringen av en timer på en sida.",
        panelsState: "Välj mellan: \"Låst\" - användare kan inte expandera eller komprimera paneler; \"Komprimera alla\" - alla paneler börjar i ett komprimerat tillstånd; \"Expandera alla\" - alla paneler börjar i ett expanderat tillstånd; \"Först expanderad\" - endast den första panelen expanderas initialt.",
        imageLinkName: "Ange ett delat egenskapsnamn i matrisen med objekt som innehåller de bild- eller videofils-URL:er som du vill visa i alternativlistan.",
        choices: "Det vänstra värdet fungerar som ett objekt-ID som används i villkorsregler, det högra värdet visas för respondenterna.",
        title: "Skriv en användarvänlig titel som ska visas.",
        waitForUpload: "Säkerställer att användarna inte slutför undersökningen förrän filerna har laddats upp.",
        minWidth: "Accepterar CSS-värden (px, %, in, pt, etc.).",
        maxWidth: "Accepterar CSS-värden (px, %, in, pt, etc.).",
        width: "Accepterar CSS-värden (px, %, in, pt, etc.).",
        valueName: "Om du inte anger den här egenskapen lagras svaret i ett fält som anges av egenskapen Name.",
        useDisplayValuesInDynamicTexts: "I frågetyperna med ett eller flera val har varje alternativ ett ID och ett visningsvärde. När du väljer det här alternativet visar den här inställningen ett visningsvärde i stället för ett ID-värde i HTML-frågor och dynamiska rubriker och beskrivningar av undersökningselement.",
        clearIfInvisible: "Välj om du vill rensa frågevärden som döljs av villkorslogik och när du vill göra det. Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå (\"När undersökningen är klar\" som standard).",
        choicesFromQuestionMode: "Välj mellan: \"Alla\" - kopierar alla valalternativ från den valda frågan; \"Markerad\" - kopierar dynamiskt endast valda alternativ; \"Omarkerad\" - kopierar endast omarkerade alternativ dynamiskt. Alternativen \"Ingen\" och \"Annat\" kopieras som standard om de är aktiverade i källfrågan.",
        showOtherItem: "När du väljer det här alternativet kan användarna inkludera ytterligare indata i en separat kommentarsruta.",
        separateSpecialChoices: "Visar varje specialalternativ (\"Ingen\", \"Annan\", \"Markera alla\") på en ny rad, även när du använder en layout med flera kolumner.",
        path: "Ange den plats i tjänstdatauppsättningen där målmatrisen med objekt finns. Lämna tomt om URL:en redan pekar på matrisen.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Ange ett enhetligt egenskapsnamn i den objektmatris som innehåller de värden som du vill visa i urvalslistan.",
        allowEmptyResponse: "Välj det här alternativet om du vill tillåta att tjänsten returnerar ett tomt svar eller en tom matris.",
        choicesVisibleIf: "Använd trollstavsikonen för att ställa in en villkorsregel som bestämmer synligheten för alla alternativ.",
        rateValues: "Det vänstra värdet fungerar som ett objekt-ID som används i villkorsregler, det högra värdet visas för respondenterna.",
        rating: {
            displayMode: "\"Auto\" väljer mellan lägena \"Knappar\" och \"Rullgardinsmeny\" baserat på den tillgängliga bredden. När bredden inte räcker till för att visa knappar visas en listruta i frågan."
        },
        valuePropertyName: "Gör att du kan koppla ihop frågor som ger resultat i olika format. När sådana frågor länkas samman med hjälp av en kopplingsidentifierare lagrar den här delade egenskapen valda frågevärden.",
        searchEnabled: "Välj det här alternativet om du vill uppdatera innehållet i den nedrullningsbara menyn så att det matchar den sökfråga som användaren skriver i inmatningsfältet.",
        valueTrue: "Ett värde att spara i undersökningsresultaten när respondenterna ger ett positivt svar.",
        valueFalse: "Ett värde att spara i undersökningsresultaten när respondenterna ger ett negativt svar.",
        showPreview: "Vi rekommenderar inte att du inaktiverar det här alternativet eftersom det åsidosätter förhandsgranskningsbilden och gör det svårt för en användare att förstå om filerna har laddats upp.",
        needConfirmRemoveFile: "Utlöser en uppmaning om att bekräfta borttagningen av filen.",
        selectToRankEnabled: "Aktivera för att endast rangordna valda alternativ. Användarna drar de valda objekten från urvalslistan för att ordna dem i rangordningsområdet.",
        dataList: "Ange en lista med alternativ som kommer att föreslås för respondenten under inmatningen.",
        itemSize: "Inställningen ändrar bara storleken på inmatningsfälten och påverkar inte frågerutans bredd.",
        itemTitleWidth: "Anger konsekvent bredd för alla objektetiketter i pixlar",
        altText: "Fungerar som ersättning när bilden inte kan visas på en användares enhet och i tillgänglighetssyfte.",
        rateColorMode: "Definierar färgen på den valda emojin när typen av betygsikon är inställd på \"Smileys\". Välj mellan: \"Standard\" - den valda emojin visas i standardundersökningsfärgen; \"Skala\" - den valda emojin ärver färg från betygsskalan.",
        expression: {
            name: "Ett uttrycks-ID som inte är synligt för svarande.",
            description: "Skriv en underrubrik för uttrycket.",
            expression: "Ett uttryck kan innehålla grundläggande beräkningar ('{q1_id} + {q2_id}'), villkor ('{age} > 60') och funktioner ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.)."
        },
        storeOthersAsComment: "Välj det här alternativet om du vill lagra alternativvärdet \"Annat\" som en separat egenskap i undersökningsresultaten.",
        format: "Använd {0} som platshållare för det faktiska värdet.",
        acceptedTypes: "Mer information finns i attributbeskrivningen [accept](https://www.w3schools.com/tags/att_input_accept.asp).",
        columnColCount: "Gäller endast för Radiogroup- och Checkbox-celltyper.",
        autocomplete: "Mer information finns i attributbeskrivningen [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete).",
        filePlaceholder: "Gäller när \"Källtyp\" är \"Lokala filer\" eller när kameran inte är tillgänglig",
        photoPlaceholder: "Gäller när \"Källtyp\" är \"Kamera\".",
        fileOrPhotoPlaceholder: "Gäller när \"Källtyp\" är \"Lokala filer eller kamera\".",
        masksettings: {
            saveMaskedValue: "Välj om du vill lagra frågevärdet med en tillämpad mask i undersökningsresultaten."
        },
        patternmask: {
            pattern: "Mönstret kan innehålla strängliteraler och följande platshållare: \"9\" – för en siffra; \"a\" - för en stor eller liten bokstav; \"#\" – för en siffra eller en stor eller liten bokstav. Använd omvänt snedstreck \"\\\" för att undvika ett tecken."
        },
        datetimemask: {
            pattern: "Mönstret kan innehålla avgränsningstecken och följande platshållare:<br>'m' – Månadsnummer.<br>\"mm\" – Månadsnummer, med inledande nolla för ensiffriga värden. <br>\"d\" – Dag i månaden. <br>\"dd\" – Dag i månaden, med inledande noll för ensiffriga värden. <br>\"yy\" – De två sista siffrorna i årtalet. <br>\"yyyy\" – Fyrsiffrigt årtal. <br>\"H\" – Timmar i 24-timmarsformat. <br>\"HH\" – Timmar i 24-timmarsformat, med inledande nolla för ensiffriga värden. <br>\"h\" – Timmar i 12-timmarsformat. <br>\"hh\" – Timmar i 12-timmarsformat, med inledande nolla för ensiffriga värden. <br>\"MM\" - Minuter. <br>\"ss\" – sekunder. <br>\"TT\" - 12-timmars klockperiod med versaler (AM/PM). <br>\"tt\" - 12-timmars klockperiod med gemener (am/pm)."
        },
        numericmask: {
            decimalSeparator: "En symbol som används för att skilja bråkdelen från heltalsdelen av ett visat tal.",
            thousandsSeparator: "En symbol som används för att dela upp siffrorna i ett stort tal i grupper om tre.",
            precision: "Begränsar hur många siffror som ska behållas efter decimaltecknet för ett tal som visas."
        },
        currencymask: {
            prefix: "En eller flera symboler som ska visas före värdet.",
            suffix: "En eller flera symboler som ska visas efter värdet."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "title",
            title: "Lämna den tom, ifall det är samma som 'Name'"
        },
        multiSelect: "Tillåt flera val",
        showLabel: "Visa bildtexter",
        swapOrder: "Byt ordning på Ja och Nej",
        value: "Värde",
        tabAlign: "Justering av tabb",
        sourceType: "Typ av källa",
        fitToContainer: "Passa till behållare",
        setValueExpression: "Ange värde-uttryck",
        description: "description",
        logoFit: "Logotyp passform",
        pages: "Sidor",
        questions: "Frågor",
        triggers: "triggers",
        calculatedValues: "Beräknade värden",
        surveyId: "Undersöknings-id",
        surveyPostId: "Post-id för undersökning",
        surveyShowDataSaving: "Undersökning visar datasparande",
        questionDescriptionLocation: "Plats för frågebeskrivning",
        progressBarType: "Typ av förloppsindikator",
        showTOC: "Visa innehållsförteckning",
        tocLocation: "Toc-plats",
        questionTitlePattern: "Mönster för frågerubrik",
        widthMode: "Bredd, läge",
        showBrandInfo: "Visa varumärkesinformation",
        useDisplayValuesInDynamicTexts: "Använda visningsvärden i dynamiska texter",
        visibleIf: "visibleIf",
        defaultValueExpression: "Uttryck för standardvärde",
        requiredIf: "Obligatoriskt om",
        resetValueIf: "Återställ värde om",
        setValueIf: "Ange värde om",
        validators: "validators",
        bindings: "Bindningar",
        renderAs: "Återge som",
        attachOriginalItems: "Bifoga originalföremål",
        choices: "choices",
        choicesByUrl: "choicesByUrl",
        currency: "currency",
        cellHint: "Cell tips",
        totalMaximumFractionDigits: "Totalt antal maximala bråksiffror",
        totalMinimumFractionDigits: "Totala minsta bråksiffror",
        columns: "columns",
        detailElements: "Detaljelement",
        allowAdaptiveActions: "Tillåt anpassningsbara åtgärder",
        defaultRowValue: "defaultRowValue",
        detailPanelShowOnAdding: "Detaljpanel visar när du lägger till",
        choicesLazyLoadEnabled: "Val lat belastning aktiverad",
        choicesLazyLoadPageSize: "Val lat ladda sidstorlek",
        inputFieldComponent: "Komponent för inmatningsfält",
        itemComponent: "Komponent för objekt",
        min: "Min",
        max: "Max",
        minValueExpression: "Minsta värdeuttryck",
        maxValueExpression: "Uttryck för maximalt värde",
        step: "Steg",
        dataList: "Lista över uppgifter",
        itemSize: "itemSize",
        itemTitleWidth: "Bredd på objektetikett (i px)",
        elements: "Element",
        content: "Innehåll",
        navigationButtonsVisibility: "navigationButtonsVisibility",
        navigationTitle: "Navigering titel",
        navigationDescription: "Beskrivning av navigering",
        longTap: "Långt tryck",
        autoGrow: "Väx automatiskt",
        allowResize: "Tillåt storleksändring",
        acceptCarriageReturn: "Acceptera retur av transport",
        displayMode: "Visningsläge",
        rateType: "Typ av hastighet",
        label: "label",
        contentMode: "Innehållsläge",
        imageFit: "Bildens anpassning",
        altText: "Alt-text",
        height: "Höjd",
        penColor: "Pennans färg",
        backgroundColor: "Bakgrundsfärg",
        templateElements: "Mallelement",
        operator: "Operatör",
        isVariable: "Är variabel",
        runExpression: "Kör uttryck",
        showCaption: "Visa bildtext",
        iconName: "Ikonens namn",
        iconSize: "Ikonens storlek",
        precision: "Precision",
        matrixDragHandleArea: "Matrisens draghandtagsområde",
        backgroundImage: "Bakgrundsbild",
        backgroundImageFit: "Anpassa bakgrundsbild",
        backgroundImageAttachment: "Bilaga till bakgrundsbild",
        backgroundOpacity: "Bakgrunds opacitet",
        selectToRankEnabled: "Välj att rangordna aktiverad",
        selectToRankAreasLayout: "Välj för att rangordna områdeslayout",
        selectToRankEmptyRankedAreaText: "Text som ska visas om alla alternativ är markerade",
        selectToRankEmptyUnrankedAreaText: "Platshållartext för rangordningsområdet",
        allowCameraAccess: "Tillåt kameraåtkomst",
        scaleColorMode: "Färgläge för skala",
        rateColorMode: "Betygsätt färgläge",
        copyDisplayValue: "Kopiera visningsvärde",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Avancerat läge",
        pageTitle: "Teckensnitt för sidtitel",
        questionTitle: "Teckensnitt för frågerubrik",
        editorPanel: "Inmatningselement",
        lines: "Linjer",
        primaryDefaultColor: "Standard",
        primaryDarkColor: "Sväva",
        primaryLightColor: "Vald",
        backgroundDimColor: "Bakgrundsfärg",
        cornerRadius: "Hörn radie",
        backcolor: "Standardbakgrund",
        hovercolor: "Håll muspekaren bakgrund",
        borderDecoration: "Border dekoration",
        fontColor: "Teckenfärg",
        backgroundColor: "Bakgrundsfärg",
        primaryForecolor: "Standardfärg",
        primaryForecolorLight: "Inaktiverad färg",
        font: "Teckensnitt",
        borderDefault: "Mörkare",
        borderLight: "Tändare",
        fontFamily: "Teckensnitt familj",
        fontWeightRegular: "Ordinarie",
        fontWeightHeavy: "Tung",
        fontWeightSemiBold: "Halvfet stil",
        fontWeightBold: "Djärv",
        color: "Färg",
        placeholderColor: "Platshållarens färg",
        size: "Storlek",
        opacity: "Ogenomskinlighet",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Lägg till skuggeffekt",
        boxShadowBlur: "Oskärpa",
        boxShadowSpread: "Sprida",
        boxShadowDrop: "Droppe",
        boxShadowInner: "Inre",
        names: {
            default: "Standard",
            sharp: "Skarp",
            borderless: "Marginalfri",
            flat: "Flat",
            plain: "Slätt",
            doubleborder: "Dubbel kantlinje",
            layered: "Lager",
            solid: "Solid",
            threedimensional: ".3D",
            contrast: "Kontrast"
        },
        colors: {
            teal: "Kricka",
            blue: "Blå",
            purple: "Lila",
            orchid: "Orkidé",
            tulip: "Tulpan",
            brown: "Brun",
            green: "Grön"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["sv"] = svStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// survey.externalHelpLink: "Watch and learn how to create surveys" => "Se och lär dig hur du skapar enkäter"
// survey.externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber" => "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber"
// survey.addLogicItem: "Create a rule to customize the flow of the survey." => "Skapa en regel för att anpassa undersökningens flöde."
// survey.duplicate: "Duplicate" => "Duplicera"
// qt.ranking: "Ranking" => "Rankning"
// qt.image: "Image" => "Bild"
// qt.tagbox: "Multi-Select Dropdown" => "Listruta med flerval"
// qt.signaturepad: "Signature" => "Underskrift"
// qt.buttongroup: "Button Group" => "Knappgrupp"
// ed.settingsTooltip: "Open settings" => "Öppna inställningar"
// ed.surveySettings: "Survey Settings" => "Inställningar för undersökning"
// ed.surveySettingsTooltip: "Open survey settings" => "Öppna undersökningsinställningar"
// ed.showPanel: "Show Panel" => "Visa panel"
// ed.hidePanel: "Hide Panel" => "Dölj panel"
// ed.prevSelected: "Select previous" => "Välj föregående"
// ed.nextSelected: "Select next" => "Välj nästa"
// ed.surveyTypeName: "Survey" => "Undersökning"
// ed.pageTypeName: "Page" => "Sida"
// ed.panelTypeName: "Panel" => "Panel"
// ed.questionTypeName: "Question" => "Fråga"
// ed.columnTypeName: "Column" => "Spalt"
// ed.newTextItemName: "text" => "SMS"
// ed.themeSurvey: "Themes" => "Teman"
// ed.defaultV2Theme: "Default" => "Standard"
// ed.modernTheme: "Modern" => "Modern"
// ed.defaultTheme: "Default (legacy)" => "Standard (äldre)"
// ed.navigateToMsg: "You had to navigate to" => "Du var tvungen att navigera till"
// ed.logic: "Logic" => "Logik"
// ed.saveSurveyTooltip: "Save Survey" => "Spara undersökning"
// ed.jsonHideErrors: "Hide errors" => "Dölj fel"
// ed.jsonShowErrors: "Show errors" => "Visa fel"
// ed.undoTooltip: "Undo last change" => "Ångra senaste ändring"
// ed.redoTooltip: "Redo the change" => "Gör om ändringen"
// ed.showMoreChoices: "Show more" => "Visa mer"
// ed.showLessChoices: "Show less" => "Visa mindre"
// ed.copy: "Copy" => "Kopia"
// ed.cut: "Cut" => "Skära"
// ed.paste: "Paste" => "Klistra"
// ed.copyTooltip: "Copy selection to clipboard" => "Kopiera markering till Urklipp"
// ed.cutTooltip: "Cut selection to clipboard" => "Klipp markering till Urklipp"
// ed.pasteTooltip: "Paste from clipboard" => "Klistra in från Urklipp"
// ed.property-grid: "Properties" => "Egenskaper"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "Skriv för att söka..."
// ed.toolboxChoiceCategory: "Choice Questions" => "Frågor om val"
// ed.toolboxTextCategory: "Text Input Questions" => "Frågor om textinmatning"
// ed.toolboxContainersCategory: "Containers" => "Behållare"
// ed.toolboxMatrixCategory: "Matrix Questions" => "Matris frågor"
// ed.toolboxMiscCategory: "Misc" => "Misc"
// ed.propertyEditorError: "Error" => "Fel"
// ed.translationPropertyGridTitle: "Language Settings" => "Språkinställningar"
// ed.themePropertyGridTitle: "Theme Settings" => "Tema Inställningar"
// ed.translationLanguages: "Languages" => "Språk"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "Endast använda strängar"
// ed.translationPlaceHolder: "Translation..." => "Översättning..."
// ed.themeExportButton: "Export" => "Export"
// ed.themeImportButton: "Import" => "Import"
// ed.bold: "Bold" => "Djärv"
// ed.italic: "Italic" => "Kursiv"
// ed.underline: "Underline" => "Understryka"
// ed.addNewQuestion: "Add Question" => "Lägg till fråga"
// ed.selectPage: "Select page..." => "Välj sida..."
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Alternativen kopieras från"
// ed.htmlPlaceHolder: "HTML content will be here." => "HTML-innehåll kommer att finnas här."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "Släpp en fråga från verktygslådan här."
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "Enkäten är tom. Dra ett element från verktygslådan eller klicka på knappen nedan."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Dra och släpp en bild här eller klicka på knappen nedan och välj en bild att ladda upp"
// ed.imageChooseImage: "Choose Image" => "Välj bild"
// ed.addNewTypeQuestion: "Add {0}" => "Lägg till {0}"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[LOGOTYP]"
// ed.auto: "auto" => "bil"
// ed.choices_Item: "Item " => "Sak "
// lg.addNewItem: "Add New Rule" => "Lägg till ny regel"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "Skapa en regel för att anpassa undersökningens flöde."
// lg.page_visibilityName: "Show (hide) page" => "Visa (dölj) sida"
// lg.page_enableName: "Enable (disable) page" => "Aktivera (inaktivera) sida"
// lg.panel_visibilityName: "Show (hide) panel" => "Visa (dölj) panelen"
// lg.panel_enableName: "Enable (disable) panel" => "Aktivera (inaktivera) panelen"
// lg.question_visibilityName: "Show (hide) question" => "Visa (dölj) fråga"
// lg.question_enableName: "Enable (disable) question" => "Aktivera (inaktivera) fråga"
// lg.question_requireName: "Make question required" => "Gör frågan obligatorisk"
// lg.column_visibilityName: "Show (hide) column" => "Visa (dölj) kolumn"
// lg.column_enableName: "Enable (disable) column" => "Aktivera (inaktivera) kolumn"
// lg.column_requireName: "Make column required" => "Gör kolumnen obligatorisk"
// lg.trigger_completeName: "Complete survey" => "Fullständig undersökning"
// lg.trigger_setvalueName: "Set answer" => "Ställ in svar"
// lg.trigger_copyvalueName: "Copy answer" => "Kopiera svar"
// lg.trigger_skipName: "Skip to question" => "Hoppa till fråga"
// lg.trigger_runExpressionName: "Run expression" => "Kör uttryck"
// lg.completedHtmlOnConditionName: "Set \"Survey Complete\" page markup" => "Ställ in sidmarkeringen \"Undersökningen slutförd\""
// lg.page_visibilityDescription: "Make the page visible when the logic expression returns true. Otherwise keep it invisible." => "Gör sidan synlig när logikuttrycket returnerar true. Håll den annars osynlig."
// lg.panel_visibilityDescription: "Make the panel visible when the logic expression returns true. Otherwise keep it invisible." => "Gör panelen synlig när logikuttrycket returnerar true. Håll den annars osynlig."
// lg.panel_enableDescription: "Make the panel, and all elements inside it, enable when the logic expression returns true. Otherwise keep them disabled." => "Aktivera panelen och alla element inuti den när logikuttrycket returnerar true. Håll dem annars inaktiverade."
// lg.question_visibilityDescription: "Make the question visible when the logic expression returns true. Otherwise keep it invisible." => "Gör frågan synlig när logikuttrycket returnerar true. Håll den annars osynlig."
// lg.question_enableDescription: "Make the question enable when the logic expression returns true. Otherwise keep it disabled." => "Aktivera frågan när logikuttrycket returnerar true. Annars ska du hålla den inaktiverad."
// lg.question_requireDescription: "Question becomes required when the logic expression returns true." => "Frågan blir obligatorisk när logikuttrycket returnerar true."
// lg.trigger_completeDescription: "When the logic expression returns true then the survey becomes completed and an end-user see the 'Thank you page'." => "När logikuttrycket returnerar true slutförs undersökningen och en slutanvändare ser tacksidan."
// lg.trigger_setvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value is set to the selected question." => "När frågevärden, som används i logikuttrycket, ändras och logikuttrycket returnerar true, anges värdet till den valda frågan."
// lg.trigger_copyvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value of one selected question is copied to another selected question." => "När frågevärden, som används i logikuttrycket, ändras och logikuttrycket returnerar true, kopieras värdet för en markerad fråga till en annan markerad fråga."
// lg.trigger_skipDescription: "When the logic expression returns true then the survey skip to / focus the selected question." => "När logikuttrycket returnerar true hoppar undersökningen till / fokuserar den valda frågan."
// lg.trigger_runExpressionDescription: "When the logic expression returns true, then the custom expression is performed. You may optionally set this expression result into the selected question" => "När logikuttrycket returnerar true utförs det anpassade uttrycket. Om du vill kan du ange detta uttrycksresultat i den valda frågan"
// lg.completedHtmlOnConditionDescription: "If the logic expression returns true, then the default text for the 'Thank you page' is changed to the given one." => "Om logikuttrycket returnerar true ändras standardtexten för tacksidan till den angivna."
// lg.itemExpressionText: "When expression: '{0}' returns true" => "När uttryck: \"{0}\" returnerar true"
// lg.itemEmptyExpressionText: "New rule" => "Ny regel"
// lg.page_visibilityText: "make page {0} visible" => "Gör sidan {0} synlig"
// lg.panel_visibilityText: "make panel {0} visible" => "Gör panelen {0} synlig"
// lg.panel_enableText: "make panel {0} enable" => "Gör panelen {0} aktivera"
// lg.question_visibilityText: "make question {0} visible" => "Gör frågan {0} synlig"
// lg.question_enableText: "make question {0} enable" => "Gör frågan {0} aktivera"
// lg.question_requireText: "make question {0} required" => "Gör frågan {0} krävs"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "Synliggör kolumn {0} av fråga {1}"
// lg.column_enableText: "make column {0} of question {1} enable" => "Gör kolumn {0} av fråga {1} aktivera"
// lg.column_requireText: "make column {0} of question {1} required" => "Gör kolumn {0} av fråga {1} krävs"
// lg.trigger_completeText: "survey becomes completed" => "Undersökningen blir slutförd"
// lg.trigger_setvalueText: "set into question: {0} value {1}" => "ifrågasätts: {0} värde {1}"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "Tydligt frågevärde: {0}"
// lg.trigger_copyvalueText: "copy into question: {0} value from question {1}" => "Kopiera till fråga: {0} värde från fråga {1}"
// lg.trigger_skipText: "survey skip to the question {0}" => "Enkät hoppa till frågan {0}"
// lg.trigger_runExpressionText1: "run expression: '{0}'" => "kör uttryck: '{0}'"
// lg.trigger_runExpressionText2: " and set its result into question: {0}" => " och ifrågasatte resultatet: {0}"
// lg.completedHtmlOnConditionText: "show custom text for the 'Thank you page'." => "visa anpassad text för tacksidan."
// lg.showAllQuestions: "All Questions" => "Alla frågor"
// lg.showAllActionTypes: "All Action Types" => "Alla åtgärdstyper"
// lg.conditions: "Condition(s)" => "Skick"
// lg.actions: "Action(s)" => "Åtgärd(er)"
// lg.expressionEditorTitle: "Define condition(s)" => "Definiera villkor"
// lg.actionsEditorTitle: "Define action(s)" => "Definiera åtgärder"
// lg.deleteAction: "Delete Action" => "Ta bort åtgärd"
// lg.addNewAction: "Add Action" => "Lägg till åtgärd"
// lg.selectedActionCaption: "Select action..." => "Välj åtgärd..."
// lg.expressionInvalid: "The logic expression is empty or invalid. Please correct it." => "Logikuttrycket är tomt eller ogiltigt. Var snäll och rätta till det."
// lg.noActionError: "Please, add at least one action." => "Lägg till minst en åtgärd."
// lg.actionInvalid: "Please, fix problems in your action(s)." => "Snälla, åtgärda problem i dina åtgärder."
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Logiska regler är ofullständiga"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Du har inte slutfört några av de logiska reglerna. Om du lämnar fliken nu kommer ändringarna att gå förlorade. Vill du fortfarande lämna fliken utan att slutföra ändringarna?"
// lg.uncompletedRule_apply: "Yes" => "Ja"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Nej, jag vill komplettera reglerna"
// pe.save: "Save" => "Spara"
// pe.clear: "Clear" => "Klar"
// pe.saveTooltip: "Save" => "Spara"
// pe.set: "Set" => "Ställa"
// pe.change: "Change" => "Förändring"
// pe.refresh: "Refresh" => "Svalka"
// pe.add: "Add" => "Addera"
// pe.removeItem: "Click to remove the item..." => "Klicka för att ta bort objektet..."
// pe.dragItem: "Drag the item" => "Dra objektet"
// pe.addOther: "Other" => "Annan"
// pe.addSelectAll: "Select All" => "Markera alla"
// pe.addNone: "None" => "Ingen"
// pe.back: "Return without saving" => "Returnera utan att spara"
// pe.backTooltip: "Return without saving" => "Returnera utan att spara"
// pe.saveAndBack: "Save and return" => "Spara och returnera"
// pe.saveAndBackTooltip: "Save and return" => "Spara och returnera"
// pe.doneEditing: "Done" => "Färdig"
// pe.showChoices: "Show Choices" => "Visa alternativ"
// pe.emptyValue: "Value is empty" => "Värdet är tomt"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "Värdet \"{0}\" är inte unikt"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "Begränsa antalet artiklar från {0} till {1}"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "Du kan ange data i följande format:\nvärde1|text\nvärde2"
// pe.itemSelectorEmpty: "Please select the element" => "Välj elementet"
// pe.conditionActionEmpty: "Please select the action" => "Välj åtgärd"
// pe.conditionSelectPage: "Select page..." => "Välj sida..."
// pe.conditionSelectPanel: "Select panel..." => "Välj panel..."
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "Förhandsgranska svar innan du skickar in undersökningen"
// pe.overridingPropertyPrefix: "Set by " => "Inställd av "
// pe.propertyIsNoUnique: "Please enter a unique value" => "Ange ett unikt värde"
// pe.propertyNameIsNotUnique: "Please enter a unique name" => "Ange ett unikt namn"
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Använd inte reserverade ord: \"objekt\", \"val\", \"panel\", \"rad\"."
// pe.listIsEmpty: "No items have been added yet" => "Inga objekt har lagts till ännu"
// pe.listIsEmpty@choices: "No choices have been added yet" => "Inga alternativ har lagts till ännu"
// pe.addNew@choices: "Add a choice" => "Lägg till ett val"
// pe.expressionIsEmpty: "Expression is empty" => "Uttrycket är tomt"
// choicesbyurl.valueName: "Get values from the following JSON field" => "Hämta värden från följande JSON-fält"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "Hämta bild-URL:er från följande JSON-fält"
// pe.allowEmptyResponse: "Allow empty response" => "Tillåt tomt svar"
// pe.titlePlaceholder: "Title" => "Titel"
// pe.surveyTitlePlaceholder: "Survey Title" => "Undersökningens titel"
// pe.pageTitlePlaceholder: "Page {num}" => "Sida {num}"
// pe.descriptionPlaceholder: "Description" => "Beskrivning"
// pe.surveyDescriptionPlaceholder: "Description" => "Beskrivning"
// pe.pageDescriptionPlaceholder: "Description" => "Beskrivning"
// pe.showNoneItem: "Allow the None option" => "Tillåt alternativet Ingen"
// pe.noneText: "None option text" => "Alternativtext för Ingen"
// pe.showSelectAllItem: "Allow the Select All option" => "Tillåt alternativet Markera allt"
// pe.selectAllText: "Select All option text" => "Markera all alternativtext"
// pe.choicesMin: "Minimum value for auto-generated items" => "Minimivärde för automatiskt genererade objekt"
// pe.choicesMax: "Maximum value for auto-generated items" => "Maximalt värde för automatiskt genererade objekt"
// pe.choicesStep: "Step for auto-generated items" => "Steg för automatiskt genererade objekt"
// pe.isAllRowRequired: "Require answer for all rows" => "Kräv svar för alla rader"
// pe.requiredErrorText: "\"Required\" error message" => "Felmeddelandet \"Obligatoriskt\""
// pe.cols: "Columns" => "Kolumner"
// pe.rateMin: "Minimum rate value" => "Minsta räntevärde"
// pe.rateMax: "Maximum rate value" => "Högsta taxa"
// pe.rateStep: "Rate step" => "Betygsätt steg"
// pe.buildExpression: "Build" => "Bygga"
// pe.editExpression: "Edit" => "Redigera"
// pe.and: "and" => "och"
// pe.or: "or" => "eller"
// pe.remove: "Remove" => "Avlägsna"
// pe.addCondition: "Add Condition" => "Lägg till villkor"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Välj en fråga för att börja konfigurera villkor."
// pe.if: "If" => "Om"
// pe.then: "then" => "då"
// pe.setToName: "Target question" => "Målfråga"
// pe.fromName: "Question to copy answer from" => "Fråga att kopiera svar från"
// pe.gotoName: "Question to skip to" => "Fråga att hoppa till"
// pe.ruleIsNotSet: "Rule is incorrect" => "Regeln är felaktig"
// pe.includeIntoResult: "Include into survey results" => "Inkludera i undersökningsresultat"
// pe.expandCollapseTitle: "Expand/collapse title" => "Expandera/komprimera titel"
// pe.simulator: "Select device type" => "Välj enhetstyp"
// pe.landscapeOrientation: "Switch to landscape orientation" => "Växla till liggande orientering"
// pe.portraitOrientation: "Switch to portrait orientation" => "Växla till stående orientering"
// pe.previewText: "Preview Answers button text" => "Text för knappen Förhandsgranska svar"
// pe.editText: "Edit Answer button text" => "Text för knappen Redigera svar"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Bildhöjd (i CSS-accepterade värden)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Bildbredd (i CSS-godkända värden)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "Tidsgräns för att avsluta sidan (i sekunder)"
// question.page: "Parent page" => "Överordnad sida"
// pe.noEntriesText: "Empty entries text" => "Tomma poster text"
// pe.html: "HTML markup" => "HTML-kod"
// pe.expression: "Expression" => "Uttryck"
// pe.setValue: "Answer" => "Svar"
// pe.dataFormat: "Image format" => "Bildformat"
// pe.allowAddRows: "Allow adding rows" => "Tillåt att rader läggs till"
// pe.allowRemoveRows: "Allow removing rows" => "Tillåt borttagning av rader"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "Tillåt dra och släpp rader"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "Gäller inte om du anger bildens exakta bredd eller höjd."
// pe.minImageWidth: "Minimum image width" => "Minsta bildbredd"
// pe.maxImageWidth: "Maximum image width" => "Maximal bildbredd"
// pe.minImageHeight: "Minimum image height" => "Minsta bildhöjd"
// pe.maxImageHeight: "Maximum image height" => "Maximal bildhöjd"
// pe.minValue: "Minimum value" => "Minsta värde"
// pe.maxValue: "Maximum value" => "Maximalt värde"
// pe.minLength: "Minimum length (in characters)" => "Minsta längd (i tecken)"
// pe.allowDigits: "Allow digits" => "Tillåt siffror"
// pe.minCount: "Minimum count" => "Minsta antal"
// pe.maxCount: "Maximum count" => "Maximalt antal"
// pe.regex: "Regular expression" => "Reguljärt uttryck"
// surveyvalidator.text: "Error message" => "Felmeddelande"
// surveyvalidator.expression: "Validation expression" => "Uttryck för validering"
// pe.totalText: "Total row text" => "Text för summarad"
// pe.totalType: "Total type" => "Total typ"
// pe.totalExpression: "Total expression" => "Totalt uttryck"
// pe.totalDisplayStyle: "Total value display style" => "Visningsformat för totalt värde"
// pe.totalCurrency: "Currency" => "Valuta"
// pe.totalFormat: "Formatted string" => "Formaterad sträng"
// pe.logo: "Logo (URL or base64-encoded string)" => "Logotyp (URL eller base64-kodad sträng)"
// pe.questionsOnPageMode: "Survey structure" => "Undersökningens struktur"
// pe.maxTextLength: "Maximum answer length (in characters)" => "Maximal svarslängd (i tecken)"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "Maximal kommentarslängd (i tecken)"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "Expandera kommentarsområdet automatiskt om det behövs"
// pe.allowResizeComment: "Allow users to resize text areas" => "Tillåt användare att ändra storlek på textområden"
// pe.textUpdateMode: "Update text question value" => "Uppdatera textfrågevärde"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "Ställ in fokus på det första ogiltiga svaret"
// pe.checkErrorsMode: "Run validation" => "Kör validering"
// pe.navigateToUrl: "Navigate to URL" => "Navigera till URL"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "Dynamisk URL"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "Markering för att visa om användaren redan har fyllt i undersökningen"
// pe.completedHtml: "Survey Complete page markup" => "Undersökning slutförd sidmarkering"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "Dynamisk undersökning Fullständig sidmarkering"
// pe.loadingHtml: "Markup to show while survey model is loading" => "Markering som ska visas medan undersökningsmodellen läses in"
// pe.commentText: "Comment area text" => "Text i kommentarsområdet"
// pe.autocomplete: "Autocomplete type" => "Typ av komplettera automatiskt"
// pe.labelTrue: "\"True\" label" => "Etiketten \"Sant\""
// pe.labelFalse: "\"False\" label" => "Etiketten \"Falskt\""
// pe.allowClear: "Show the Clear button" => "Visa knappen Rensa"
// pe.displayStyle: "Value display style" => "Visningsformat för värde"
// pe.format: "Formatted string" => "Formaterad sträng"
// pe.maximumFractionDigits: "Maximum fractional digits" => "Maximala bråktal"
// pe.minimumFractionDigits: "Minimum fractional digits" => "Minsta bråktal"
// pe.useGrouping: "Display grouping separators" => "Visa grupperingsavgränsare"
// pe.allowMultiple: "Allow multiple files" => "Tillåt flera filer"
// pe.allowImagesPreview: "Preview images" => "Förhandsgranska bilder"
// pe.acceptedTypes: "Accepted file types" => "Godkända filtyper"
// pe.waitForUpload: "Wait for the upload to complete" => "Vänta tills uppladdningen är klar"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "Bekräfta borttagning av fil"
// pe.detailPanelMode: "Detail panel location" => "Placering på detaljpanelen"
// pe.minRowCount: "Minimum row count" => "Minsta antal rader"
// pe.maxRowCount: "Maximum row count" => "Maximalt antal rader"
// pe.confirmDelete: "Confirm row deletion" => "Bekräfta borttagning av rad"
// pe.confirmDeleteText: "Confirmation message" => "Bekräftelsemeddelande"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "Bekräfta borttagning av panelen"
// pe.panelCount: "Initial panel count" => "Inledande panelantal"
// pe.minPanelCount: "Minimum panel count" => "Minsta antal paneler"
// pe.maxPanelCount: "Maximum panel count" => "Maximalt antal paneler"
// pe.panelsState: "Inner panel expand state" => "Expanderingsläge för innerpanelen"
// pe.templateDescription: "Description template" => "Beskrivning mall"
// pe.templateTitle: "Title template" => "Mall för titel"
// pe.panelPrevText: "Previous Panel button tooltip" => "Knappbeskrivning för föregående panel"
// pe.panelNextText: "Next Panel button tooltip" => "Knappbeskrivning för knappen Nästa panel"
// pe.showRangeInProgress: "Show progress bar" => "Visa förloppsindikator"
// pe.templateTitleLocation: "Question title location" => "Plats för frågerubrik"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "Ta bort panelknappens placering"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "Dölj frågan om det inte finns några rader"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Dölj kolumner om det inte finns några rader"
// pe.rateValues: "Custom rate values" => "Anpassade prisvärden"
// pe.rateCount: "Rate count" => "Antal priser"
// pe.autoGenerate: "How to specify rate values?" => "Hur anger jag hastighetsvärden?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "Dölj frågan om den inte innehåller några alternativ"
// pe.hideNumber: "Hide question number" => "Dölj frågenummer"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Minsta bredd (i CSS-godkända värden)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Maximal bredd (i CSS-godkända värden)"
// pe.width: "Width (in CSS-accepted values)" => "Bredd (i CSS-accepterade värden)"
// pe.showHeader: "Show column headers" => "Visa kolumnrubriker"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Visa vågrät rullningslist"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Minsta kolumnbredd (i CSS-godkända värden)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Radrubrikbredd (i CSS-godkända värden)"
// pe.valueTrue: "\"True\" value" => "\"Sant\" värde"
// pe.valueFalse: "\"False\" value" => "\"Falskt\" värde"
// pe.minErrorText: "\"Value is below minimum\" error message" => "Felmeddelandet \"Värdet är under minimum\""
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "Felmeddelandet \"Värdet överskrider max\""
// pe.otherErrorText: "\"Empty comment\" error message" => "Felmeddelandet \"Tom kommentar\""
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "Felmeddelandet \"Icke-unikt nyckelvärde\""
// pe.minSelectedChoices: "Minimum selected choices" => "Minsta valda val"
// pe.maxSelectedChoices: "Maximum selected choices" => "Maximalt antal valda val"
// pe.showClearButton: "Show the Clear button" => "Visa knappen Rensa"
// pe.showNumber: "Show panel number" => "Visa panelnummer"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "Logotypbredd (i CSS-godkända värden)"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "Logotypens höjd (i CSS-godkända värden)"
// pe.readOnly: "Read-only" => "Skrivskyddad"
// pe.enableIf: "Editable if" => "Redigerbar om"
// pe.emptyRowsText: "\"No rows\" message" => "Meddelandet \"Inga rader\""
// pe.size: "Input field size (in characters)" => "Inmatningsfältets storlek (i tecken)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "Avgränsa specialval (Ingen, Annat, Markera alla)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Kopiera alternativ från följande fråga"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Vilka val ska du kopiera?"
// pe.showCommentArea: "Show the comment area" => "Visa kommentarsområdet"
// pe.commentPlaceholder: "Comment area placeholder" => "Platshållare för kommentarsområde"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Visa hastighetsbeskrivningar som extremvärden"
// pe.rowsOrder: "Row order" => "Radordning"
// pe.columnsLayout: "Column layout" => "Kolumnlayout"
// pe.columnColCount: "Nested column count" => "Kapslat antal kolumner"
// pe.state: "Panel expand state" => "Panelens expanderingsläge"
// pe.correctAnswer: "Correct Answer" => "Rätt svar"
// pe.defaultPanelValue: "Default Values" => "Standardvärden"
// pe.cells: "Cell Texts" => "Cell texter"
// pe.keyName: "Key column" => "Kolumnen Nyckel"
// itemvalue.text: "Alt text" => "Alt-text"
// pe.logoPosition: "Logo position" => "Logotypens placering"
// pe.addLogo: "Add logo..." => "Lägg till logotyp..."
// pe.changeLogo: "Change logo..." => "Ändra logotyp..."
// logoPositions.none: "Remove logo" => "Ta bort logotyp"
// logoPositions.left: "Left" => "Vänster"
// logoPositions.right: "Right" => "Höger"
// logoPositions.top: "On the top" => "På toppen"
// logoPositions.bottom: "In the bottom" => "I botten"
// tabs.requiredIf: "Required If" => "Obligatoriskt om"
// tabs.numbering: "Numbering" => "Numrering"
// tabs.pages: "Pages" => "Sidor"
// tabs.calculatedValues: "Calculated Values" => "Beräknade värden"
// tabs.totals: "Totals" => "Summor"
// tabs.logic: "Logic" => "Logik"
// tabs.layout: "Layout" => "Layout"
// tabs.data: "Data" => "Data"
// tabs.validation: "Validation" => "Validering"
// tabs.cells: "Cell Texts" => "Cell texter"
// tabs.showOnCompleted: "Survey Complete" => "Undersökningen slutförd"
// tabs.logo: "Logo in Survey Title" => "Logotyp i undersökningens titel"
// tabs.slider: "Slider" => "Skjutreglage"
// tabs.expression: "Expression" => "Uttryck"
// tabs.others: "Others" => "Andra"
// pe.choicesVisibleIf: "Choices are visible if" => "Alternativen är synliga om"
// pe.choicesEnableIf: "Choices are selectable if" => "Alternativen kan väljas om"
// pe.columnsEnableIf: "Columns are visible if" => "Kolumner visas om"
// pe.rowsEnableIf: "Rows are visible if" => "Raderna visas om"
// pe.indent: "Add indents" => "Lägga till indrag"
// panel.indent: "Add outer indents" => "Lägga till yttre indrag"
// pe.innerIndent: "Add inner indents" => "Lägga till inre indrag"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "Ta standardvärden från den sista raden"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "Ta standardvärden från den sista panelen"
// pe.titleKeyboardAdornerTip: "Press enter button to edit" => "Tryck på enter-knappen för att redigera"
// pe.keyboardAdornerTip: "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item" => "Tryck på enter-knappen för att redigera objektet, tryck på raderingsknappen för att radera objektet, tryck på alt plus pil uppåt eller pil nedåt för att flytta objektet"
// pe.triggerGotoName: "Go to the question" => "Gå till frågan"
// pe.triggerRunExpressionEmpty: "Please enter a valid expression" => "Ange ett giltigt uttryck"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "Skriv uttryck här..."
// pe.noFile: "No file choosen" => "Ingen fil har valts"
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "Rensa värdet om frågan döljs"
// pe.valuePropertyName: "Value property name" => "Egenskapsnamn för värde"
// pe.searchEnabled: "Enable search" => "Aktivera sökning"
// pe.hideSelectedItems: "Hide selected items" => "Dölja markerade objekt"
// pe.closeOnSelect: "Close the dropdown after selection" => "Stäng listrutan efter val"
// pe.signatureWidth: "Signature width" => "Signaturens bredd"
// pe.signatureHeight: "Signature height" => "Signaturens höjd"
// pe.verticalAlign: "Vertical alignment" => "Vertikal inriktning"
// pe.alternateRows: "Alternate rows" => "Varannan rad"
// pe.columnsVisibleIf: "Columns are visible if" => "Kolumner visas om"
// pe.rowsVisibleIf: "Rows are visible if" => "Raderna visas om"
// pe.otherPlaceholder: "Comment area placeholder" => "Platshållare för kommentarsområde"
// pe.rateType: "Rate type" => "Typ av hastighet"
// pv.true: "true" => "sann"
// pv.false: "false" => "falsk"
// pv.decimal: "decimal" => "decimal"
// pv.currency: "currency" => "valuta"
// pv.percent: "percent" => "procent"
// pv.onpanel: "Start on each panel" => "Börja på varje panel"
// pv.tab: "Tabs" => "Flikar"
// pv.both: "Both" => "Båda"
// pv.right: "Right" => "Höger"
// pv.color: "color" => "färg"
// pv.date: "date" => "datum"
// pv.datetime: "datetime" => "datetime"
// pv.datetime-local: "datetime-local" => "datetime-lokal"
// pv.email: "email" => "E-post"
// pv.month: "month" => "månad"
// pv.number: "number" => "nummer"
// pv.password: "password" => "lösenord"
// pv.range: "range" => "sortiment"
// pv.tel: "tel" => "Tel"
// pv.text: "text" => "SMS"
// pv.time: "time" => "Tid"
// pv.url: "url" => "URL"
// pv.week: "week" => "vecka"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "När frågan eller dess panel/sida döljs"
// clearInvisibleValues.none: "Never" => "Aldrig"
// inputType.color: "Color" => "Färg"
// inputType.date: "Date" => "Datum"
// inputType.datetime-local: "Date and Time" => "Datum och tid"
// inputType.email: "Email" => "E-post"
// inputType.month: "Month" => "Månad"
// inputType.number: "Number" => "Nummer"
// inputType.password: "Password" => "Lösenord"
// inputType.range: "Range" => "Sortiment"
// inputType.tel: "Phone Number" => "Telefonnummer"
// inputType.text: "Text" => "SMS"
// inputType.time: "Time" => "Tid"
// inputType.url: "URL" => "URL"
// inputType.week: "Week" => "Vecka"
// pv.onValueChanging: "Before an answer is changed" => "Innan ett svar ändras"
// pv.standard: "Original structure" => "Ursprunglig struktur"
// pv.singlePage: "All questions on a single page" => "Alla frågor på en sida"
// pv.questionPerPage: "Each question on an individual page" => "Varje fråga på en enskild sida"
// pv.noPreview: "No preview" => "Ingen förhandsgranskning"
// pv.showAllQuestions: "Show all questions" => "Visa alla frågor"
// pv.showAnsweredQuestions: "Show answered questions only" => "Visa endast besvarade frågor"
// pv.pages: "Completed pages" => "Avslutade sidor"
// pv.questions: "Answered questions" => "Besvarade frågor"
// pv.requiredQuestions: "Answered required questions" => "Besvarade obligatoriska frågor"
// pv.correctQuestions: "Valid answers" => "Giltiga svar"
// pv.buttons: "Completed pages (button UI)" => "Slutförda sidor (knappgränssnitt)"
// pv.underInput: "Under the input" => "Under ingången"
// pv.underTitle: "Under the title" => "Under rubriken"
// pv.onBlur: "On blur" => "Vid oskärpa"
// pv.onTyping: "While typing" => "Medan du skriver"
// pv.underRow: "Under the row" => "Under raden"
// pv.underRowSingle: "Under the row, only one panel is visible" => "Under raden syns bara en panel"
// showNavigationButtons.none: "Hidden" => "Dold"
// showProgressBar.off: "Hidden" => "Dold"
// showTimerPanel.none: "Hidden" => "Dold"
// showTimerPanelMode.all: "Both" => "Båda"
// detailPanelMode.none: "Hidden" => "Dold"
// addRowLocation.default: "Depends on matrix layout" => "Beror på matrislayout"
// panelsState.default: "Users cannot expand or collapse panels" => "Användare kan inte expandera eller komprimera paneler"
// panelsState.collapsed: "All panels are collapsed" => "Alla paneler är komprimerade"
// panelsState.expanded: "All panels are expanded" => "Alla paneler är expanderade"
// widthMode.auto: "Auto" => "Bil"
// widthMode.static: "Static" => "Statisk"
// widthMode.responsive: "Responsive" => "Responsiv"
// imageFit.none: "None" => "Ingen"
// imageFit.contain: "Contain" => "Innehålla"
// imageFit.cover: "Cover" => "Täcka"
// imageFit.fill: "Fill" => "Fylla"
// contentMode.auto: "Auto" => "Bil"
// contentMode.image: "Image" => "Bild"
// contentMode.video: "Video" => "Video"
// contentMode.youtube: "YouTube" => "YouTube"
// displayMode.auto: "Auto" => "Bil"
// displayMode.buttons: "Buttons" => "Knappar"
// displayMode.dropdown: "Dropdown" => "Rullgardinsmeny"
// rateColorMode.default: "Default" => "Standard"
// autoGenerate.true: "Generate" => "Generera"
// autoGenerate.false: "Enter manually" => "Ange manuellt"
// rateType.labels: "Labels" => "Etiketter"
// rateType.stars: "Stars" => "Stjärnor"
// rateType.smileys: "Smileys" => "Smileys"
// op.anyof: "Any of" => "Någon av"
// op.allof: "All of" => "Alla"
// op.and: "and" => "och"
// op.or: "or" => "eller"
// ew.modern: "Modern theme" => "Modernt tema"
// ew.default: "Default theme" => "Standardtema"
// ew.orange: "Orange theme" => "Orange tema"
// ew.darkblue: "Darkblue theme" => "Mörkblått tema"
// ew.darkrose: "Darkrose theme" => "Darkrose-tema"
// ew.stone: "Stone theme" => "Sten tema"
// ew.winter: "Winter theme" => "Vinter tema"
// ew.winterstone: "Winter-Stone theme" => "Vintersten, tema"
// ts.hideInvisibleElements: "Hide invisible elements" => "Dölj osynliga element"
// triggers.skiptrigger: "Skip to question" => "Hoppa till fråga"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Cookies hindrar användare från att fylla i samma undersökning två gånger."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Ändrar storlek på det synliga området i inmatningsfältet. Använd inställningen <b>Validering → Maximal längd</b> för att begränsa inmatningslängden."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "Använd {0} som platshållare för det faktiska värdet."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Visas bara när minst en kolumn har Total type eller Total uttryck."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Mer information finns i attributbeskrivningen [accept](https://www.w3schools.com/tags/att_input_accept.asp)."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Gäller endast för Radiogroup- och Checkbox-celltyper."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Mer information finns i attributbeskrivningen [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete)."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Om du inte anger den här egenskapen lagras svaret i ett fält som anges av egenskapen Name."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Om den angivna kolumnen innehåller identiska värden genereras felet \"Icke-unikt nyckelvärde\"."
// p.multiSelect: "Allow multiple selection" => "Tillåt flera val"
// p.showLabel: "Show image captions" => "Visa bildtexter"
// p.value: "Value" => "Värde"
// p.tabAlign: "Tab alignment" => "Justering av tabb"
// p.logoFit: "Logo fit" => "Logotyp passform"
// p.pages: "Pages" => "Sidor"
// p.questions: "Questions" => "Frågor"
// p.calculatedValues: "Calculated values" => "Beräknade värden"
// p.surveyId: "Survey id" => "Undersöknings-id"
// p.surveyPostId: "Survey post id" => "Post-id för undersökning"
// p.surveyShowDataSaving: "Survey show data saving" => "Undersökning visar datasparande"
// p.questionDescriptionLocation: "Question description location" => "Plats för frågebeskrivning"
// p.progressBarType: "Progress bar type" => "Typ av förloppsindikator"
// p.showTOC: "Show TOC" => "Visa innehållsförteckning"
// p.tocLocation: "Toc location" => "Toc-plats"
// p.questionTitlePattern: "Question title pattern" => "Mönster för frågerubrik"
// p.widthMode: "Width mode" => "Bredd, läge"
// p.showBrandInfo: "Show brand info" => "Visa varumärkesinformation"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "Använda visningsvärden i dynamiska texter"
// p.descriptionLocation: "Description location" => "Beskrivning plats"
// p.defaultValueExpression: "Default value expression" => "Uttryck för standardvärde"
// p.requiredIf: "Required if" => "Obligatoriskt om"
// p.bindings: "Bindings" => "Bindningar"
// p.renderAs: "Render as" => "Återge som"
// p.attachOriginalItems: "Attach original items" => "Bifoga originalföremål"
// p.cellHint: "Cell hint" => "Cell tips"
// p.isUnique: "Is unique" => "Är unik"
// p.showInMultipleColumns: "Show in multiple columns" => "Visa i flera kolumner"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Totalt antal maximala bråksiffror"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Totala minsta bråksiffror"
// p.detailElements: "Detail elements" => "Detaljelement"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Tillåt anpassningsbara åtgärder"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "Detaljpanel visar när du lägger till"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Val lat belastning aktiverad"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Val lat ladda sidstorlek"
// p.inputFieldComponent: "Input field component" => "Komponent för inmatningsfält"
// p.itemComponent: "Item component" => "Komponent för objekt"
// p.min: "Min" => "Min"
// p.max: "Max" => "Max"
// p.minValueExpression: "Min value expression" => "Minsta värdeuttryck"
// p.maxValueExpression: "Max value expression" => "Uttryck för maximalt värde"
// p.step: "Step" => "Steg"
// p.dataList: "Data list" => "Lista över uppgifter"
// p.elements: "Elements" => "Element"
// p.content: "Content" => "Innehåll"
// p.navigationTitle: "Navigation title" => "Navigering titel"
// p.navigationDescription: "Navigation description" => "Beskrivning av navigering"
// p.longTap: "Long tap" => "Långt tryck"
// p.autoGrow: "Auto grow" => "Väx automatiskt"
// p.allowResize: "Allow resizing" => "Tillåt storleksändring"
// p.acceptCarriageReturn: "Accept carriage return" => "Acceptera retur av transport"
// p.displayMode: "Display mode" => "Visningsläge"
// p.rateType: "Rate type" => "Typ av hastighet"
// p.contentMode: "Content mode" => "Innehållsläge"
// p.imageFit: "Image fit" => "Bildens anpassning"
// p.altText: "Alt text" => "Alt-text"
// p.height: "Height" => "Höjd"
// p.penColor: "Pen color" => "Pennans färg"
// p.backgroundColor: "Background color" => "Bakgrundsfärg"
// p.templateElements: "Template elements" => "Mallelement"
// p.operator: "Operator" => "Operatör"
// p.isVariable: "Is variable" => "Är variabel"
// p.runExpression: "Run expression" => "Kör uttryck"
// p.showCaption: "Show caption" => "Visa bildtext"
// p.iconName: "Icon name" => "Ikonens namn"
// p.iconSize: "Icon size" => "Ikonens storlek"
// p.precision: "Precision" => "Precision"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Matrisens draghandtagsområde"
// p.backgroundImage: "Background image" => "Bakgrundsbild"
// p.backgroundImageFit: "Background image fit" => "Anpassa bakgrundsbild"
// p.backgroundImageAttachment: "Background image attachment" => "Bilaga till bakgrundsbild"
// p.backgroundOpacity: "Background opacity" => "Bakgrunds opacitet"
// p.selectToRankEnabled: "Select to rank enabled" => "Välj att rangordna aktiverad"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Välj för att rangordna områdeslayout"
// p.allowCameraAccess: "Allow camera access" => "Tillåt kameraåtkomst"
// p.scaleColorMode: "Scale color mode" => "Färgläge för skala"
// p.rateColorMode: "Rate color mode" => "Betygsätt färgläge"
// p.templateTabTitle: "Template tab title" => "Rubrik på mallfliken"
// p.templateVisibleIf: "Template visible if" => "Mallen visas om"
// p.copyDisplayValue: "Copy display value" => "Kopiera visningsvärde"
// theme.--background: "Background color" => "Bakgrundsfärg"
// theme.--background-dim-light: "Background dim light color" => "Bakgrund svag ljusfärg"
// theme.--primary-foreground: "Primary foreground color" => "Primär förgrundsfärg"
// theme.--foreground: "Foreground color" => "Förgrundsfärg"
// theme.--base-unit: "Base unit" => "Basenhet"
// theme.groupAdvanced: "Advanced" => "Avancerad"
// theme.themeName: "Theme" => "Tema"
// theme.isPanellessss: "Question appearance" => "Fråga utseende"
// theme.isPanellessPanels: "Default" => "Standard"
// theme.isPanellessLightweight: "Without Panels" => "Utan paneler"
// theme.themePaletteLight: "Light" => "Ljus"
// theme.themePaletteDark: "Dark" => "Mörk"
// theme.primaryColor: "Accent color" => "Accentfärg"
// theme.primaryDefaultColor: "Default" => "Standard"
// theme.primaryDarkColor: "Hover" => "Sväva"
// theme.primaryLightColor: "Selected" => "Vald"
// theme.backgroundDimColor: "Background color" => "Bakgrundsfärg"
// theme.backgroundImage: "Background image" => "Bakgrundsbild"
// theme.backgroundImageFitAuto: "Auto" => "Bil"
// theme.backgroundImageFitCover: "Cover" => "Täcka"
// theme.backgroundImageFitContain: "Contain" => "Innehålla"
// theme.backgroundOpacity: "Opacity" => "Ogenomskinlighet"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Fast"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Rulla"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Opacitet för panelbakgrund"
// theme.questionBackgroundTransparency: "Question background opacity" => "Frågans bakgrundsopacitet"
// theme.questionPanel: "Panel background and corner radius" => "Panelbakgrund och hörnradie"
// theme.questionTitle: "Question title font" => "Teckensnitt för frågerubrik"
// theme.questionDescription: "Question description font" => "Typsnitt för frågebeskrivning"
// theme.editorPanel: "Input element" => "Inmatningselement"
// theme.editorFont: "Input element font" => "Teckensnitt för inmatningselement"
// theme.backcolor: "Default background" => "Standardbakgrund"
// theme.hovercolor: "Hover background" => "Håll muspekaren bakgrund"
// theme.borderDecoration: "Border decoration" => "Border dekoration"
// theme.accentBackground: "Accent background" => "Accent bakgrund"
// theme.accentForeground: "Accent foreground" => "Accent förgrund"
// theme.primaryForecolor: "Default color" => "Standardfärg"
// theme.primaryForecolorLight: "Disabled color" => "Inaktiverad färg"
// theme.linesColors: "Minor line colors" => "Mindre linjefärger"
// theme.borderDefault: "Darker" => "Mörkare"
// theme.borderLight: "Lighter" => "Tändare"
// theme.fontFamily: "Font family" => "Teckensnitt familj"
// theme.fontSize: "Font size" => "Teckenstorlek"
// theme.color: "Color" => "Färg"
// theme.size: "Size" => "Storlek"
// theme.fontWeightRegular: "Regular" => "Ordinarie"
// theme.fontWeightHeavy: "Heavy" => "Tung"
// theme.fontWeightSemiBold: "Semi-bold" => "Halvfet"
// theme.fontWeightBold: "Bold" => "Djärv"
// theme.scale: "Scale" => "Skala"
// theme.cornerRadius: "Corner radius" => "Hörnradie"
// theme.surveyTitleFont: "Survey title font" => "Teckensnitt för undersökningstitel"
// theme.pageTitle: "Page title font" => "Teckensnitt för sidtitel"
// theme.pageDescription: "Page description font" => "Teckensnitt för sidbeskrivning"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Lägg till skuggeffekt"
// theme.opacity: "Opacity" => "Ogenomskinlighet"
// theme.boxShadowBlur: "Blur" => "Oskärpa"
// theme.boxShadowSpread: "Spread" => "Sprida"
// theme.boxShadowDrop: "Drop" => "Droppe"
// theme.boxShadowInner: "Inner" => "Inre"
// theme.questionShadow: "Shadow effects" => "Skuggeffekter"
// theme.editorShadow: "Input element shadow effects" => "Skuggeffekter för indataelement"
// names.default: "Default" => "Standard"
// names.contrast: "Contrast" => "Kontrast"
// names.plain: "Plain" => "Slätt"
// names.simple: "Simple" => "Enkel"
// names.blank: "Blank" => "Blank"
// names.double: "Double" => "Dubbel"
// names.bulk: "Bulk" => "Omfång"
// names.pseudo-3d: "Pseudo 3D" => "Pseudo 3D"
// names.playful: "Playful" => "Lekfull"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Kricka"
// colors.blue: "Blue" => "Blå"
// colors.purple: "Purple" => "Lila"
// colors.orchid: "Orchid" => "Orkidé"
// colors.tulip: "Tulip" => "Tulpan"
// colors.brown: "Brown" => "Brun"
// colors.green: "Green" => "Grön"
// names.sharp: "Sharp" => "Skarp"
// names.borderless: "Borderless" => "Marginalfri"
// names.flat: "Flat" => "Flat"
// names.doubleborder: "Double Border" => "Dubbel kantlinje"
// names.layered: "Layered" => "Lager"
// names.solid: "Solid" => "Solid"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Är du säker på att du vill ta bort alla strängar för det här språket?"
// ed.themeResetButton: "Reset theme settings to default" => "Återställ temainställningarna till standard"
// theme.placeholderColor: "Placeholder color" => "Färg på platshållare"
// ed.themeSettings: "Theme Settings" => "Tema Inställningar"
// ed.themeSettingsTooltip: "Open theme settings" => "Öppna temainställningar"
// pe.resetToDefaultCaption: "Reset" => "Nollställa"
// pv.file: "Local files" => "Lokala filer"
// pv.camera: "Camera" => "Kamera"
// pv.file-camera: "Local files or camera" => "Lokala filer eller kamera"
// ed.translateUsigAI: "Auto-translate All" => "Översätt alla automatiskt"
// ed.translationDialogTitle: "Untranslated strings" => "Oöversatta strängar"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Ange minst {0} artiklar"
// lg.question_resetValueName: "Reset question value" => "Återställ frågevärde"
// lg.column_resetValue: "Reset column value" => "Återställ kolumnvärde"
// pe.markRequired: "Mark as required" => "Markera efter behov"
// pe.removeRequiredMark: "Remove the required mark" => "Ta bort det obligatoriska märket"
// p.resetValueIf: "Reset value if" => "Återställ värde om"
// lg.question_setValueName: "Set question value" => "Ange frågevärde"
// lg.column_resetValueName: "Reset column value" => "Återställ kolumnvärde"
// lg.column_setValueName: "Set column value" => "Ange kolumnvärde"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Ett uttryck vars resultat kommer att tilldelas målfrågan."
// survey.title: "Title" => "Titel"
// page.title: "Title" => "Titel"
// p.setValueIf: "Set value if" => "Ange värde om"
// theme.header: "Header" => "Rubrik"
// theme.backgroundImageFitFill: "Stretch" => "Tänja"
// theme.backgroundImageFitTile: "Tile" => "Kakel"
// theme.headerView: "View" => "Utsikt"
// theme.headerViewBasic: "Basic" => "Grundläggande"
// theme.headerViewAdvanced: "Advanced" => "Avancerad"
// theme.headerInheritWidthFrom: "Content area width" => "Innehållets bredd"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Samma som undersökning"
// theme.headerInheritWidthFromPage: "Fit to page" => "Anpassa till sida"
// theme.headerTextAreaWidth: "Text width" => "Textens bredd"
// theme.headerBackgroundColorSwitch: "Background color" => "Bakgrundsfärg"
// theme.headerBackgroundColorNone: "None" => "Ingen"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Accentfärg"
// theme.headerBackgroundColorCustom: "Custom" => "Sed"
// theme.horizontalAlignmentLeft: "Left" => "Vänster"
// theme.horizontalAlignmentCenter: "Center" => "Centrum"
// theme.horizontalAlignmentRight: "Right" => "Höger"
// theme.verticalAlignmentTop: "Top" => "Topp"
// theme.verticalAlignmentMiddle: "Middle" => "Mitt"
// theme.verticalAlignmentBottom: "Bottom" => "Botten"
// theme.logoPosition: "Logo Position" => "Logotypens placering"
// lg.question_resetValueText: "reset value for question: {0}" => "Återställ värde för fråga: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Tilldela värde: {1} till fråga: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Återställ cellvärde för kolumn: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Tilldela cellvärde: {1} till kolumn: {0}"
// ed.surveyJsonExportButton: "Export" => "Export"
// ed.surveyJsonImportButton: "Import" => "Import"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Kopiera till Urklipp"
// pe.filePlaceholder: "File placeholder text" => "Text för filplatshållare"
// pe.photoPlaceholder: "Photo placeholder text" => "Text för platshållare för foton"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Platshållartext för fil eller foto"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "Gäller när \"Källtyp\" är \"Lokala filer\" eller när kameran inte är tillgänglig"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "Gäller när \"Källtyp\" är \"Kamera\"."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "Gäller när \"Källtyp\" är \"Lokala filer eller kamera\"."
// theme.background: "Background" => "Bakgrund"
// theme.appearance: "Appearance" => "Utseende"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Vill du verkligen återställa temat? Alla dina anpassningar kommer att gå förlorade."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Ja, återställ temat"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Passa till behållare"
// signaturepad.showPlaceholder: "Show the placeholder" => "Visa platshållaren"
// signaturepad.placeholder: "Placeholder text" => "Platshållartext"
// theme.surveyDescriptionFont: "Survey description font" => "Teckensnitt för undersökningsbeskrivning"
// ed.prevFocus: "Focus previous" => "Fokus föregående"
// ed.nextFocus: "Focus next" => "Fokus nästa"
// ed.saveTheme: "Save Theme" => "Spara tema"
// ed.saveThemeTooltip: "Save Theme" => "Spara tema"
// lg.page_requireName: "Make page required" => "Gör sidan obligatorisk"
// lg.panel_requireName: "Make page required" => "Gör sidan obligatorisk"
// signaturepad.signatureWidth: "Signature area width" => "Signaturområdets bredd"
// signaturepad.signatureHeight: "Signature area height" => "Signaturområdets höjd"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "Skala signaturområdet automatiskt"
// signaturepad.penMinWidth: "Minimum pen width" => "Minsta pennbredd"
// signaturepad.penMaxWidth: "Maximum pen width" => "Maximal pennbredd"
// theme.headerTitlePosition: "Title position" => "Titel position"
// theme.headerDescriptionPosition: "Description position" => "Beskrivning position"
// ed.propertyGridNoResultsFound: "No results found" => "Inga resultat hittades"
// pv.leftRight: "Left and right" => "Vänster och höger"
// p.sourceType: "Source type" => "Typ av källa"
// p.fitToContainer: "Fit to container" => "Passa till behållare"
// p.setValueExpression: "Set value expression" => "Ange värde-uttryck"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Alternativen läses in från en webbtjänst."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Gå till inställningar"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Förhandsgranskning av inlästa alternativalternativ"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Förhindra dubbletter av svar i rader"
// theme.advancedMode: "Advanced mode" => "Avancerat läge"
// theme.backgroundCornerRadius: "Background and corner radius" => "Bakgrund och hörnradie"
// theme.colorsTitle: "Colors" => "Färger"
// theme.font: "Font" => "Teckensnitt"
// theme.lines: "Lines" => "Linjer"
// theme.titleFont: "Title font" => "Titel typsnitt"
// theme.descriptionFont: "Description font" => "Beskrivning teckensnitt"
// theme.shadow: "Shadow effects" => "Skugga effekter"
// ed.translateUsigAIFrom: "Translate from: " => "Översätt från: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Tillåt alternativet Vägra svara"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Tillåt alternativet Vet ej"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Tillåt alternativet Vägra svara"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Tillåt alternativet Vet ej"
// pv.contain: "Contain" => "Innehålla"
// pv.cover: "Cover" => "Täcka"
// pv.fill: "Fill" => "Fylla"
// pe.transposeData: "Transpose rows to columns" => "Transponera rader till kolumner"
// layout.panel: "Layout" => "Layout"
// layout.question: "Layout" => "Layout"
// layout.base: "Layout" => "Layout"
// panel.name: "Panel name" => "Panelens namn"
// panel.title: "Panel title" => "Panelens titel"
// panel.description: "Panel description" => "Beskrivning av panelen"
// panel.visibleIf: "Make the panel visible if" => "Gör panelen synlig om"
// panel.requiredIf: "Make the panel required if" => "Gör panelen obligatorisk om"
// panel.questionsOrder: "Question order within the panel" => "Frågeordning i panelen"
// panel.startWithNewLine: "Display the panel on a new line" => "Visa panelen på en ny rad"
// panel.state: "Panel collapse state" => "Panelens komprimerade tillstånd"
// panel.width: "Inline panel width" => "Bredd på infogad panel"
// panel.minWidth: "Minimum panel width" => "Minsta panelbredd"
// panel.maxWidth: "Maximum panel width" => "Maximal panelbredd"
// panel.showNumber: "Number panels" => "Sifferpaneler"
// paneldynamic.name: "Panel name" => "Panelens namn"
// paneldynamic.title: "Panel title" => "Panelens titel"
// paneldynamic.description: "Panel description" => "Beskrivning av panelen"
// paneldynamic.visibleIf: "Make the panel visible if" => "Gör panelen synlig om"
// paneldynamic.requiredIf: "Make the panel required if" => "Gör panelen obligatorisk om"
// paneldynamic.page: "Move the panel to page" => "Flytta panelen till sidan"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Visa panelen på en ny rad"
// paneldynamic.state: "Panel collapse state" => "Panelens komprimerade tillstånd"
// paneldynamic.width: "Inline panel width" => "Bredd på infogad panel"
// paneldynamic.minWidth: "Minimum panel width" => "Minsta panelbredd"
// paneldynamic.maxWidth: "Maximum panel width" => "Maximal panelbredd"
// paneldynamic.templateDescription: "Panel description pattern" => "Mönster för panelbeskrivning"
// paneldynamic.templateTitle: "Panel title pattern" => "Mönster för panelrubrik"
// paneldynamic.noEntriesText: "Empty panel text" => "Tom paneltext"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Mönster för flikrubrik"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Gör en enskild panel synlig om"
// paneldynamic.hideNumber: "Hide the panel number" => "Dölj panelnumret"
// paneldynamic.titleLocation: "Panel title alignment" => "Justering av panelrubrik"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Justering av panelbeskrivning"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Justering av frågerubrik"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Justering av felmeddelande"
// paneldynamic.newPanelPosition: "New panel location" => "Ny panelplats"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Förhindra dubbletter av svar i följande fråga"
// question.name: "Question name" => "Frågans namn"
// question.title: "Question title" => "Frågans rubrik"
// question.description: "Question description" => "Beskrivning av frågan"
// question.visibleIf: "Make the question visible if" => "Gör frågan synlig om"
// question.requiredIf: "Make the question required if" => "Gör frågan obligatorisk om"
// question.state: "Question box collapse state" => "Komprimeringstillstånd för frågeruta"
// question.hideNumber: "Hide the question number" => "Dölj frågans nummer"
// question.titleLocation: "Question title alignment" => "Justering av frågerubrik"
// question.descriptionLocation: "Question description alignment" => "Justering av frågebeskrivning"
// question.errorLocation: "Error message alignment" => "Justering av felmeddelande"
// question.indent: "Increase the inner indent" => "Öka det inre indraget"
// question.width: "Inline question width" => "Bredd på infogade frågor"
// question.minWidth: "Minimum question width" => "Minsta frågebredd"
// question.maxWidth: "Maximum question width" => "Maximal frågebredd"
// question.textUpdateMode: "Update input field value" => "Uppdatera indatafältsvärde"
// signaturepad.allowClear: "Show the Clear button within signature area" => "Visa knappen Rensa i signaturområdet"
// signaturepad.penColor: "Stroke color" => "Linjefärg"
// comment.rows: "Input field height (in lines)" => "Inmatningsfältets höjd (i rader)"
// expression.name: "Expression name" => "Namn på uttryck"
// expression.title: "Expression title" => "Uttryckets titel"
// expression.description: "Expression description" => "Beskrivning av uttryck"
// expression.expression: "Expression" => "Uttryck"
// trigger.expression: "Expression" => "Uttryck"
// calculatedvalue.expression: "Expression" => "Uttryck"
// survey.description: "Survey description" => "Beskrivning av undersökningen"
// page.name: "Page name" => "Sidans namn"
// page.description: "Page description" => "Beskrivning av sidan"
// page.visibleIf: "Make the page visible if" => "Gör sidan synlig om"
// page.requiredIf: "Make the page required if" => "Gör sidan obligatorisk om"
// page.questionsOrder: "Question order on the page" => "Frågeordning på sidan"
// matrixdropdowncolumn.name: "Column name" => "Kolumnens namn"
// matrixdropdowncolumn.title: "Column title" => "Kolumnens rubrik"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Förhindra dubbletter av svar"
// matrixdropdowncolumn.width: "Column width" => "Kolumnbredd"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Minsta kolumnbredd"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Inmatningsfältets höjd (i rader)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Gör kolumnen synlig om"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Gör kolumnen obligatorisk om"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Varje alternativ i en separat kolumn"
// multipletextitem.name: "Name" => "Namn"
// multipletextitem.title: "Title" => "Titel"
// pe.rateDescriptionLocation: "Label alignment" => "Justering av etiketter"
// pe.cellErrorLocation: "Cell error message alignment" => "Justering av cellfelmeddelande"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Du har inga kolumner ännu"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Du har inga rader ännu"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Du har inga valideringsregler ännu"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Du har inga anpassade variabler ännu"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Du har inga utlösare ännu"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Du har inga länkar ännu"
// pe.addNew@columns: "Add new column" => "Lägg till ny kolumn"
// pe.addNew@rows: "Add new row" => "Lägg till ny rad"
// pe.addNew@validators: "Add new rule" => "Lägg till ny regel"
// pe.addNew@calculatedValues: "Add new variable" => "Lägg till ny variabel"
// pe.addNew@triggers: "Add new trigger" => "Lägga till ny utlösare"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Lägg till ny URL"
// choicesbyurl.url: "Web service's URL" => "Webbtjänstens URL"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Visa sidrubriker i förloppsindikatorn"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "Visa sidnummer i förloppsindikatorn"
// itemvalue.visibleIf: "Make the option visible if" => "Gör alternativet synligt om"
// itemvalue.enableIf: "Make the option selectable if" => "Gör alternativet valbart om"
// panel.layout: "Panel Layout" => "Panelens layout"
// tabs.questionSettings: "Question Settings" => "Inställningar för frågor"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Ex.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Ex.: kategorier.skönlitteratur"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Ex.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Ex.: 6 tum"
// pe.minWidth_placeholder: "Ex.: 600px" => "Ex.: 600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Ex.: 50%"
// pv.selected: "Selected" => "Vald"
// pv.unselected: "Unselected" => "Omarkerade"
// pv.center: "Center" => "Centrum"
// pv.middle: "Middle" => "Mitt"
// pv.next: "Next" => "Nästa"
// pv.last: "Last" => "Sist"
// clearIfInvisible.none: "Never" => "Aldrig"
// questionsOnPageMode.standard: "Original structure" => "Ursprunglig struktur"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Visa alla frågor på en sida"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Visa en fråga per sida"
// pv.auto: "Auto" => "Bil"
// panelsState.firstExpanded: "First expanded" => "Först utökad"
// rateColorMode.scale: "Scale" => "Skala"
// scaleColorMode.monochrome: "Monochrome" => "Monokrom"
// scaleColorMode.colored: "Colored" => "Färgad"
// state.default: "Locked" => "Låst"
// showQuestionNumbers.default: "Auto-numbering" => "Automatisk numrering"
// showQuestionNumbers.on: "Auto-numbering" => "Automatisk numrering"
// showQuestionNumbers.onPage: "Reset on each page" => "Återställ på varje sida"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Återställ på varje panel"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Återställ på varje panel"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Fortsätt genom undersökningen"
// showQuestionNumbers.off: "No numbering" => "Ingen numrering"
// descriptionLocation.underTitle: "Under the question title" => "Under frågans rubrik"
// descriptionLocation.underInput: "Under the input field" => "Under inmatningsfältet"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Bredvid alternativ"
// selectToRankAreasLayout.vertical: "Above choices" => "Ovanstående val"
// displayStyle.decimal: "Decimal" => "Decimal"
// displayStyle.currency: "Currency" => "Valuta"
// displayStyle.percent: "Percentage" => "Procent"
// displayStyle.date: "Date" => "Datum"
// totalDisplayStyle.decimal: "Decimal" => "Decimal"
// totalDisplayStyle.currency: "Currency" => "Valuta"
// totalDisplayStyle.percent: "Percentage" => "Procent"
// totalDisplayStyle.date: "Date" => "Datum"
// rowsOrder.initial: "Original" => "Original"
// questionsOrder.initial: "Original" => "Original"
// showProgressBar.aboveheader: "Above the header" => "Ovanför sidhuvudet"
// showProgressBar.belowheader: "Below the header" => "Nedanför rubriken"
// pv.sum: "Sum" => "Summa"
// pv.count: "Count" => "Räkna"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Max"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Innehåller"
// searchMode.startsWith: "Starts with" => "Börjar med"
// panel.name: "A panel ID that is not visible to respondents." => "Ett panel-ID som inte är synligt för svarande."
// panel.description: "Type a panel subtitle." => "Skriv en panelundertext."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Använd trollstavsikonen för att ställa in en villkorsregel som bestämmer panelens synlighet."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Använd trollstavsikonen för att ställa in en villkorsregel som inaktiverar det skrivskyddade läget för panelen."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Använd trollstavsikonen för att ställa in en villkorsregel som förhindrar att undersökningen skickas in om inte minst en kapslad fråga har ett svar."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Gäller alla frågor i den här panelen. Om du vill åsidosätta den här inställningen definierar du regler för rubrikjustering för enskilda frågor. Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå (\"Topp\" som standard)."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Anger platsen för ett felmeddelande i förhållande till alla frågor i panelen. Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Behåller den ursprungliga ordningen på frågorna eller slumpar dem. Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå."
// panel.page: "Repositions the panel to the end of a selected page." => "Flyttar panelen till slutet av en markerad sida."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Lägger till utrymme eller marginal mellan panelinnehållet och panelrutans vänstra kant."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Avmarkera om du vill visa panelen på en rad med föregående fråga eller panel. Inställningen gäller inte om panelen är det första elementet i formuläret."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Välj mellan: \"Expanderad\" - panelen visas i sin helhet och kan fällas ihop; \"Komprimerad\" - panelen visar endast titel och beskrivning och kan expanderas; \"Låst\" - panelen visas i sin helhet och kan inte fällas ihop."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Ställer in panelens bredd i proportion till andra undersökningselement på samma rad. Accepterar CSS-värden (px, %, in, pt, etc.)."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "Ett panel-ID som inte är synligt för svarande."
// paneldynamic.description: "Type a panel subtitle." => "Skriv en panelundertext."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Använd trollstavsikonen för att ställa in en villkorsregel som bestämmer panelens synlighet."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Använd trollstavsikonen för att ställa in en villkorsregel som inaktiverar det skrivskyddade läget för panelen."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Använd trollstavsikonen för att ställa in en villkorsregel som förhindrar att undersökningen skickas in om inte minst en kapslad fråga har ett svar."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Gäller alla frågor i den här panelen. Om du vill åsidosätta den här inställningen definierar du regler för rubrikjustering för enskilda frågor. Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå (\"Topp\" som standard)."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Anger platsen för ett felmeddelande i förhållande till en fråga med ogiltiga indata. Välj mellan: \"Överst\" - en feltext placeras högst upp i frågerutan; \"Nederst\" - en feltext placeras längst ner i frågerutan. Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå (\"Topp\" som standard)."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Anger platsen för ett felmeddelande i förhållande till alla frågor i panelen. Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Flyttar panelen till slutet av en markerad sida."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Lägger till utrymme eller marginal mellan panelinnehållet och panelrutans vänstra kant."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Avmarkera om du vill visa panelen på en rad med föregående fråga eller panel. Inställningen gäller inte om panelen är det första elementet i formuläret."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Välj mellan: \"Expanderad\" - panelen visas i sin helhet och kan fällas ihop; \"Komprimerad\" - panelen visar endast titel och beskrivning och kan expanderas; \"Låst\" - panelen visas i sin helhet och kan inte fällas ihop."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Ställer in panelens bredd i proportion till andra undersökningselement på samma rad. Accepterar CSS-värden (px, %, in, pt, etc.)."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Skriv in en mall för dynamiska panelrubriker. Använd {panelIndex} för panelens allmänna position och {visiblePanelIndex} för dess ordning bland de synliga panelerna. Infoga dessa platshållare i mönstret för att lägga till automatisk numrering."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Skriv in en mall för flikrubriker. Använd {panelIndex} för en panels allmänna position och {visiblePanelIndex} för dess ordning bland synliga paneler. Infoga dessa platshållare i mönstret för att lägga till automatisk numrering."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Med den här inställningen kan du styra synligheten för enskilda paneler i den dynamiska panelen. Använd platshållaren {panel} för att referera till den aktuella panelen i uttrycket."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Den här inställningen ärvs automatiskt av alla frågor i den här panelen. Om du vill åsidosätta den här inställningen definierar du regler för rubrikjustering för enskilda frågor. Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå (\"Topp\" som standard)."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "Alternativet \"Ärv\" tillämpar inställningen på sidnivå (om den är inställd) eller på undersökningsnivå (\"Under panelrubriken\" som standard)."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Definierar placeringen av en nyligen tillagd panel. Som standard läggs nya paneler till i slutet. Välj \"Nästa\" för att infoga en ny panel efter den nuvarande."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Duplicerar svar från den sista panelen och tilldelar dem till nästa tillagda dynamiska panel."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Referera till ett frågenamn för att kräva att en användare anger ett unikt svar för den här frågan i varje panel."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Med den här inställningen kan du tilldela ett standardsvarsvärde baserat på ett uttryck. Uttrycket kan innehålla grundläggande beräkningar – {q1_id} + {q2_id}, booleska uttryck, till exempel {age} > 60 och funktioner: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' osv. Värdet som bestäms av detta uttryck fungerar som det initiala standardvärdet som kan åsidosättas av en svarandes manuella inmatning."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Använd trollstavsikonen för att ställa in en villkorsregel som avgör när en respondents inmatning återställs till värdet baserat på \"Standardvärdesuttryck\" eller \"Ange värdeuttryck\" eller till värdet \"Standardsvar\" (om något av dem är inställt)."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "Använd trollstavsikonen för att ställa in en villkorsregel som avgör när \"Ange värdeuttryck\" ska köras och dynamiskt tilldela det resulterande värdet som ett svar."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "Ange ett uttryck som definierar det värde som ska anges när villkoren i regeln \"Ange värde om\" uppfylls. Uttrycket kan innehålla grundläggande beräkningar – {q1_id} + {q2_id}, booleska uttryck, till exempel {age} > 60 och funktioner: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' osv. Värdet som bestäms av detta uttryck kan åsidosättas av en svarandes manuella inmatning."
// question.name: "A question ID that is not visible to respondents." => "Ett fråge-ID som inte är synligt för svarande."
// question.description: "Type a question subtitle." => "Skriv en underrubrik för frågan."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Använd trollstavsikonen för att ställa in en villkorsregel som avgör frågans synlighet."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Använd trollstavsikonen för att ställa in en villkorsregel som inaktiverar det skrivskyddade läget för frågan."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Använd trollstavsikonen för att ställa in en villkorsregel som förhindrar att undersökningen går vidare eller skickas in om inte frågan har fått ett svar."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Avmarkera om du vill visa frågan på en rad med föregående fråga eller panel. Inställningen gäller inte om frågan är det första elementet i formuläret."
// question.page: "Repositions the question to the end of a selected page." => "Flyttar frågan till slutet av en markerad sida."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Välj mellan: \"Expanderad\" - frågerutan visas i sin helhet och kan fällas ihop; \"Komprimerad\" - frågerutan visar endast titel och beskrivning och kan expanderas; \"Låst\" - frågerutan visas i sin helhet och kan inte fällas ihop."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Åsidosätter regler för justering av titlar som definierats på panel-, sid- eller undersökningsnivå. Alternativet \"Ärv\" tillämpar alla inställningar på högre nivå (om de är inställda) eller inställningar på undersökningsnivå (\"Överst\" som standard)."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå (\"Under frågans titel\" som standard)."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Anger platsen för ett felmeddelande i förhållande till frågan med ogiltig inmatning. Välj mellan: \"Överst\" - en feltext placeras högst upp i frågerutan; \"Nederst\" - en feltext placeras längst ner i frågerutan. Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå (\"Topp\" som standard)."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Lägger till utrymme eller marginal mellan frågeinnehållet och frågerutans vänstra kant."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Anger frågans bredd i proportion till andra undersökningselement på samma rad. Accepterar CSS-värden (px, %, in, pt, etc.)."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Använd trollstavsikonen för att ställa in ett valideringsuttryck för frågan."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Välj mellan: \"Vid förlorat fokus\" - värdet uppdateras när inmatningsfältet tappar fokus; \"Medan du skriver\" - värdet uppdateras i realtid när användarna skriver. Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå (\"Vid förlorat fokus\" som standard)."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Du kan använda valfri webbtjänst som datakälla för flervalsfrågor. Om du vill fylla i alternativvärden anger du URL:en för den tjänst som tillhandahåller data."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "En jämförelseåtgärd som används för att filtrera listrutan."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Anger bredden på det visade signaturområdet och den resulterande bilden."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Anger höjden på det visade signaturområdet och den resulterande bilden."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "Välj om du vill att signaturområdet ska fylla allt tillgängligt utrymme i frågerutan samtidigt som standardproportionerna 3:2 bibehålls. När anpassade bredd- och höjdvärden anges behåller inställningen proportionerna för dessa dimensioner."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Justerar höjden på bilden i undersökningsresultaten."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Justerar bredden på bilden i undersökningsresultaten."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Åsidosätter värdena för lägsta och högsta höjd."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Åsidosätter värdena för minsta och största bredd."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Värde\" fungerar som ett objekt-ID som används i villkorsregler. \"Text\" visas för respondenterna."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Den här inställningen ändrar bara storleken på inmatningsfältet och påverkar inte frågerutans bredd. Om du vill begränsa den godkända indatalängden går du till <b>Validering → Maximal teckengräns</b>."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Ställer in antalet rader som visas i inmatningsfältet. Om inmatningen tar upp fler rader visas rullningslisten."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Välj mellan: \"Redigerbar\" - gör det möjligt för respondenterna att fylla i din undersökning; \"Skrivskyddad\" - inaktiverar formulärredigering."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "Ett kolumn-ID som inte är synligt för svarande."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "När den är aktiverad för en kolumn måste en svarande ange ett unikt svar för varje fråga i den här kolumnen."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Ställer in antalet rader som visas i inmatningsfältet. Om inmatningen tar upp fler rader visas rullningslisten."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Använd trollstavsikonen för att ange en villkorsregel som bestämmer kolumnens synlighet."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Använd trollstavsikonen för att ange en villkorsregel som inaktiverar skrivskyddat läge för kolumnen."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Använd trollstavsikonen för att ställa in en villkorsregel som förhindrar att undersökningen skickas in om inte minst en kapslad fråga har ett svar."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "När du väljer det här alternativet skapas en enskild kolumn för varje alternativ."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Välj mellan: \"Statisk\" - ställer in en fast bredd; \"Responsiv\" - gör att undersökningen upptar hela skärmens bredd; \"Auto\" - gäller någon av de två beroende på vilka frågetyper som används."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Klistra in en bildlänk (inga storleksbegränsningar) eller klicka på mappikonen för att bläddra i en fil från din dator (upp till 64 kB)."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "Anger en logotypbredd i CSS-enheter (px, %, in, pt, etc.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "Anger en logotyphöjd i CSS-enheter (px, %, in, pt, etc.)."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Välj mellan: \"Ingen\" - bilden behåller sin ursprungliga storlek; \"Innehåll\" - bildens storlek ändras så att den passar samtidigt som bildförhållandet bibehålls. \"Cover\" - bilden fyller hela rutan samtidigt som bildförhållandet bibehålls; \"Fyll\" - bilden sträcks ut för att fylla rutan utan att behålla bildförhållandet."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Välj om du vill att undersökningen ska gå vidare till nästa sida automatiskt efter att en svarande har svarat på alla frågor på den aktuella sidan."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Anger synlighet och placering av navigeringsknappar på en sida."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "Anger synlighet och plats för en förloppsindikator. Värdet \"Auto\" visar förloppsindikatorn ovanför eller under undersökningshuvudet."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Aktivera förhandsgranskningssidan med alla eller endast besvarade frågor."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Gäller alla frågor i undersökningen. Den här inställningen kan åsidosättas av regler för justering av rubriker på lägre nivåer: panel, sida eller fråga. En inställning på lägre nivå åsidosätter de på en högre nivå."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "En symbol eller en sekvens av symboler som anger att ett svar krävs."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Ange en siffra eller bokstav som du vill börja numrera med."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Anger platsen för ett felmeddelande i förhållande till frågan med ogiltig inmatning. Välj mellan: \"Överst\" - en feltext placeras högst upp i frågerutan; \"Nederst\" - en feltext placeras längst ner i frågerutan."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Välj om du vill att det första inmatningsfältet på varje sida ska vara klart för textinmatning."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Behåller den ursprungliga ordningen på frågorna eller slumpar dem. Effekten av den här inställningen visas bara på fliken Förhandsgranska."
// pehelp.maxTextLength: "For text entry questions only." => "Endast för textinmatningsfrågor."
// pehelp.maxOthersLength: "For question comments only." => "Endast för frågekommentarer."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Välj om du vill att frågekommentarer och långa textfrågor automatiskt ska öka i höjd baserat på den angivna textlängden."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Endast för frågekommentarer och långa textfrågor."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Anpassade variabler fungerar som mellanliggande variabler eller hjälpvariabler som används i formulärberäkningar. De tar svarandes indata som källvärden. Varje anpassad variabel har ett unikt namn och ett uttryck som den baseras på."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "Välj om du vill att det beräknade värdet av uttrycket ska sparas tillsammans med undersökningsresultaten."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "En utlösare är en händelse eller ett villkor som baseras på ett uttryck. När uttrycket har utvärderats till \"true\" utlöser en utlösare en åtgärd. En sådan åtgärd kan valfritt ha en målfråga som den påverkar."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Välj om du vill rensa värden för frågor som döljs av villkorsstyrd logik och när du vill göra det."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Välj mellan: \"Vid förlorat fokus\" - värdet uppdateras när inmatningsfältet tappar fokus; \"Medan du skriver\" - värdet uppdateras i realtid när användarna skriver."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Det vänstra värdet fungerar som ett kolumn-ID som används i villkorsregler, det högra värdet visas för respondenterna."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Det vänstra värdet fungerar som ett rad-ID som används i villkorsregler, det högra värdet visas för respondenterna."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepterar CSS-värden (px, %, in, pt, etc.)."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepterar CSS-värden (px, %, in, pt, etc.)."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Anger platsen för ett felmeddelande i förhållande till en cell med ogiltiga indata. Alternativet \"Ärv\" tillämpar inställningen från egenskapen \"Justering av felmeddelande\"."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "När egenskapen \"Förhindra dubblettsvar\" är aktiverad kommer en svarande som försöker skicka in en dubblett att få följande felmeddelande."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Gör att du kan beräkna totalvärden baserat på ett uttryck. Uttrycket kan innehålla grundläggande beräkningar ('{q1_id} + {q2_id}'), booleska uttryck ('{age} > 60') och funktioner ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.)."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Utlöser en uppmaning där du uppmanas att bekräfta borttagningen av raden."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Duplicerar svar från den sista raden och tilldelar dem till nästa tillagda dynamiska rad."
// pehelp.description: "Type a subtitle." => "Skriv en undertext."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Välj ett språk för att börja skapa din undersökning. Om du vill lägga till en översättning byter du till ett nytt språk och översätter originaltexten här eller på fliken Översättningar."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Anger platsen för ett detaljavsnitt i förhållande till en rad. Välj mellan: \"Ingen\" - ingen expansion läggs till; \"Under raden\" - en radexpansion placeras under varje rad i matrisen; \"Visa endast en radexpansion under raden\" - en expansion visas endast under en enda rad, de återstående radexpansionerna är komprimerade."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Välj mellan: \"Ingen\" - bilden behåller sin ursprungliga storlek; \"Innehåll\" - bildens storlek ändras så att den passar samtidigt som bildförhållandet bibehålls. \"Cover\" - bilden fyller hela rutan samtidigt som bildförhållandet bibehålls; \"Fyll\" - bilden sträcks ut för att fylla rutan utan att behålla bildförhållandet."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Ökar gradvis höjden på inmatningsfältet när data matas in. Åsidosätter inställningen \"Inmatningsfältets höjd (i rader)\"."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Storlekshandtaget (eller greppet) visas i hörnet och kan dras för att ändra storleken på inmatningsfältet."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Ett tidsintervall i sekunder varefter undersökningen automatiskt går vidare till Tack-sidan."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Ett tidsintervall i sekunder varefter undersökningen automatiskt går vidare till nästa sida."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Ett tidsintervall i sekunder varefter undersökningen automatiskt går vidare till nästa sida."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Använd trollstavsikonen för att ställa in en villkorsregel som bestämmer sidans synlighet."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Använd trollstavsikonen för att ställa in en villkorsregel som inaktiverar det skrivskyddade läget för sidan."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "Använd trollstavsikonen för att ställa in en villkorsregel som förhindrar att undersökningen skickas in om inte minst en kapslad fråga har ett svar."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Gäller alla frågor på denna sida. Om du vill åsidosätta den här inställningen definierar du regler för titeljustering för enskilda frågor eller paneler. Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå (\"Topp\" som standard)."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Anger platsen för ett felmeddelande i förhållande till frågan med ogiltig inmatning. Välj mellan: \"Överst\" - en feltext placeras högst upp i frågerutan; \"Nederst\" - en feltext placeras längst ner i frågerutan. Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå (\"Topp\" som standard)."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Behåller den ursprungliga ordningen på frågorna eller slumpar dem. Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå (\"Original\" som standard). Effekten av den här inställningen visas bara på fliken Förhandsgranska."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Ställer in synligheten för navigeringsknapparna på sidan. Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå, som standard är \"Synlig\"."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Ställer in synligheten och placeringen av en timer på en sida."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Välj mellan: \"Låst\" - användare kan inte expandera eller komprimera paneler; \"Komprimera alla\" - alla paneler börjar i ett komprimerat tillstånd; \"Expandera alla\" - alla paneler börjar i ett expanderat tillstånd; \"Först expanderad\" - endast den första panelen expanderas initialt."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Ange ett delat egenskapsnamn i matrisen med objekt som innehåller de bild- eller videofils-URL:er som du vill visa i alternativlistan."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Det vänstra värdet fungerar som ett objekt-ID som används i villkorsregler, det högra värdet visas för respondenterna."
// pehelp.title: "Type a user-friendly title to display." => "Skriv en användarvänlig titel som ska visas."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Säkerställer att användarna inte slutför undersökningen förrän filerna har laddats upp."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepterar CSS-värden (px, %, in, pt, etc.)."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepterar CSS-värden (px, %, in, pt, etc.)."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "Accepterar CSS-värden (px, %, in, pt, etc.)."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "I frågetyperna med ett eller flera val har varje alternativ ett ID och ett visningsvärde. När du väljer det här alternativet visar den här inställningen ett visningsvärde i stället för ett ID-värde i HTML-frågor och dynamiska rubriker och beskrivningar av undersökningselement."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Välj om du vill rensa frågevärden som döljs av villkorslogik och när du vill göra det. Alternativet \"Ärv\" tillämpar inställningen på undersökningsnivå (\"När undersökningen är klar\" som standard)."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Välj mellan: \"Alla\" - kopierar alla valalternativ från den valda frågan; \"Markerad\" - kopierar dynamiskt endast valda alternativ; \"Omarkerad\" - kopierar endast omarkerade alternativ dynamiskt. Alternativen \"Ingen\" och \"Annat\" kopieras som standard om de är aktiverade i källfrågan."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "När du väljer det här alternativet kan användarna inkludera ytterligare indata i en separat kommentarsruta."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Visar varje specialalternativ (\"Ingen\", \"Annan\", \"Markera alla\") på en ny rad, även när du använder en layout med flera kolumner."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Ange den plats i tjänstdatauppsättningen där målmatrisen med objekt finns. Lämna tomt om URL:en redan pekar på matrisen."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Ange ett enhetligt egenskapsnamn i den objektmatris som innehåller de värden som du vill visa i urvalslistan."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Välj det här alternativet om du vill tillåta att tjänsten returnerar ett tomt svar eller en tom matris."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Använd trollstavsikonen för att ställa in en villkorsregel som bestämmer synligheten för alla alternativ."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Det vänstra värdet fungerar som ett objekt-ID som används i villkorsregler, det högra värdet visas för respondenterna."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Auto\" väljer mellan lägena \"Knappar\" och \"Rullgardinsmeny\" baserat på den tillgängliga bredden. När bredden inte räcker till för att visa knappar visas en listruta i frågan."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Gör att du kan koppla ihop frågor som ger resultat i olika format. När sådana frågor länkas samman med hjälp av en kopplingsidentifierare lagrar den här delade egenskapen valda frågevärden."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Välj det här alternativet om du vill uppdatera innehållet i den nedrullningsbara menyn så att det matchar den sökfråga som användaren skriver i inmatningsfältet."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Ett värde att spara i undersökningsresultaten när respondenterna ger ett positivt svar."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Ett värde att spara i undersökningsresultaten när respondenterna ger ett negativt svar."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Vi rekommenderar inte att du inaktiverar det här alternativet eftersom det åsidosätter förhandsgranskningsbilden och gör det svårt för en användare att förstå om filerna har laddats upp."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Utlöser en uppmaning om att bekräfta borttagningen av filen."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Aktivera för att endast rangordna valda alternativ. Användarna drar de valda objekten från urvalslistan för att ordna dem i rangordningsområdet."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Ange en lista med alternativ som kommer att föreslås för respondenten under inmatningen."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Inställningen ändrar bara storleken på inmatningsfälten och påverkar inte frågerutans bredd."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Anger konsekvent bredd för alla objektetiketter i pixlar"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Alternativet \"Auto\" bestämmer automatiskt vilket läge som är lämpligt för visning - bild, video eller YouTube - baserat på den angivna källadressen."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Fungerar som ersättning när bilden inte kan visas på en användares enhet och i tillgänglighetssyfte."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Definierar färgen på den valda emojin när typen av betygsikon är inställd på \"Smileys\". Välj mellan: \"Standard\" - den valda emojin visas i standardundersökningsfärgen; \"Skala\" - den valda emojin ärver färg från betygsskalan."
// expression.name: "An expression ID that is not visible to respondents." => "Ett uttrycks-ID som inte är synligt för svarande."
// expression.description: "Type an expression subtitle." => "Skriv en underrubrik för uttrycket."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Ett uttryck kan innehålla grundläggande beräkningar ('{q1_id} + {q2_id}'), villkor ('{age} > 60') och funktioner ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.)."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "Välj det här alternativet om du vill lagra alternativvärdet \"Annat\" som en separat egenskap i undersökningsresultaten."
// p.swapOrder: "Swap the order of Yes and No" => "Byt ordning på Ja och Nej"
// p.itemTitleWidth: "Item label width (in px)" => "Bredd på objektetikett (i px)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Text som ska visas om alla alternativ är markerade"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Platshållartext för rangordningsområdet"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Fyll i enkäten automatiskt"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Välj om du vill att undersökningen ska slutföras automatiskt efter att en svarande har svarat på alla frågor."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Spara maskerat värde i undersökningsresultat"
// patternmask.pattern: "Value pattern" => "Värdemönster"
// datetimemask.min: "Minimum value" => "Minsta värde"
// datetimemask.max: "Maximum value" => "Maximalt värde"
// numericmask.allowNegativeValues: "Allow negative values" => "Tillåt negativa värden"
// numericmask.thousandsSeparator: "Thousands separator" => "Avgränsare för tusental"
// numericmask.decimalSeparator: "Decimal separator" => "Decimaltecknet"
// numericmask.precision: "Value precision" => "Värde precision"
// numericmask.min: "Minimum value" => "Minsta värde"
// numericmask.max: "Maximum value" => "Maximalt värde"
// currencymask.prefix: "Currency prefix" => "Prefix för valuta"
// currencymask.suffix: "Currency suffix" => "Valutasuffix"
// pe.maskType: "Input mask type" => "Typ av indatamask"
// maskTypes.patternmask: "Pattern" => "Mönster"
// maskTypes.numericmask: "Numeric" => "Numerisk"
// maskTypes.datetimemask: "Date and Time" => "Datum och tid"
// maskTypes.currencymask: "Currency" => "Valuta"
// tabs.mask: "Input Mask Settings" => "Inställningar för inmatningsmask"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Ex.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Ex.: mm/dd/åååå"
// pe.currencyprefix_placeholder: "Ex.: $" => "Ex.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Ex.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Radbryt val"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Långa texter i valalternativ genererar automatiskt radbrytningar för att passa in i rullgardinsmenyn. Avmarkera om du vill att texterna ska klippas."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Välj om du vill lagra frågevärdet med en tillämpad mask i undersökningsresultaten."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Mönstret kan innehålla strängliteraler och följande platshållare: \"9\" – för en siffra; \"a\" - för en stor eller liten bokstav; \"#\" – för en siffra eller en stor eller liten bokstav. Använd omvänt snedstreck \"\\\" för att undvika ett tecken."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Mönstret kan innehålla avgränsningstecken och följande platshållare: \"m\" – för månadsnummer; \"mm\" – för månadsnummer, med inledande nolla för ensiffriga värden. \"d\" - för dag i månaden; \"dd\" – för dag i månaden, med inledande nolla för ensiffriga värden. \"yy\" – för de två sista siffrorna i årtalet. \"yyyy\" – för ett fyrsiffrigt årtal."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "En symbol som används för att skilja bråkdelen från heltalsdelen av ett visat tal."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "En symbol som används för att dela upp siffrorna i ett stort tal i grupper om tre."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Begränsar hur många siffror som ska behållas efter decimaltecknet för ett tal som visas."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "En eller flera symboler som ska visas före värdet."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "En eller flera symboler som ska visas efter värdet."
// ed.translationSource: "Source: " => "Källa: "
// ed.translationTarget: "Target: " => "Mål: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Sidan är tom. Dra ett element från verktygslådan eller klicka på knappen nedan."
// maskTypes.none: "None" => "Ingen"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Gör raden synlig om"
// itemvalue@rows.enableIf: "Make the row editable if" => "Gör raden redigerbar om"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Platshållartext i skrivskyddat läge eller förhandsgranskningsläge"
// pe.textWrapEnabled: "Wrap choices" => "Radbryt val"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "Alternativet \"Auto\" bestämmer automatiskt vilket läge som är lämpligt för visning - bild, video eller YouTube - baserat på den angivna källadressen."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Välj mellan \"Bild\" och \"Video\" för att ställa in innehållsläget för medieväljaren. Om \"Bild\" är valt, se till att alla alternativ som tillhandahålls är bildfiler i följande format: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. På samma sätt, om \"Video\" är valt, se till att alla alternativ är direktlänkar till videofiler i följande format: MP4, MOV, WMV, FLV, AVI, MKV. Observera att YouTube-länkar inte stöds för videoalternativ."
// ed.selectFile: "Select a file" => "Välj en fil"
// ed.removeFile: "Remove the file" => "Ta bort filen"
// pe.searchMode: "Search Mode" => "Sökläge"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Klicka på knappen \"Lägg till fråga\" nedan för att börja skapa ditt formulär."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Klicka på knappen \"Lägg till fråga\" nedan för att lägga till ett nytt element på sidan."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Klicka på knappen \"Lägg till fråga\" nedan för att lägga till ett nytt element i panelen."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Klicka på knappen nedan och välj en bild att ladda upp"
// coloralpha.opacity: "Opacity" => "Ogenomskinlighet"
// font.family: "Font family" => "Teckensnitt familj"
// font.color: "Color" => "Färg"
// font.placeholderColor: "Placeholder color" => "Platshållarens färg"
// font.size: "Size" => "Storlek"
// theme.themeName: "Theme" => "Tema"
// theme.isPanelless: "Question appearance" => "Frågans utseende"
// theme.editorPanel: "Background and corner radius" => "Bakgrund och hörnradie"
// theme.questionPanel: "Background and corner radius" => "Bakgrund och hörnradie"
// theme.primaryColor: "Accent color" => "Accentfärg"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Opacitet för panelbakgrund"
// theme.questionBackgroundTransparency: "Question background opacity" => "Opacitet för frågebakgrund"
// theme.fontSize: "Font size" => "Teckenstorlek"
// theme.scale: "Scale" => "Skala"
// theme.cornerRadius: "Corner radius" => "Hörn radie"
// theme.pageTitle: "Title font" => "Titel typsnitt"
// theme.pageDescription: "Description font" => "Beskrivning teckensnitt"
// theme.questionTitle: "Title font" => "Titel typsnitt"
// theme.questionDescription: "Description font" => "Beskrivning teckensnitt"
// theme.editorFont: "Font" => "Teckensnitt"
// theme.backgroundOpacity: "Opacity" => "Ogenomskinlighet"
// theme.--sjs-font-family: "Font family" => "Teckensnitt familj"
// theme.--sjs-general-backcolor-dim: "Background color" => "Bakgrundsfärg"
// theme.--sjs-primary-backcolor: "Accent background" => "Accent bakgrund"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Accent förgrund"
// theme.--sjs-shadow-small: "Shadow effects" => "Skugga effekter"
// theme.--sjs-shadow-inner: "Shadow effects" => "Skugga effekter"
// theme.--sjs-border-default: "Colors" => "Färger"
// header@header.headerView: "View" => "Utsikt"
// header@header.logoPosition: "Logo position" => "Logotypens placering"
// header@header.surveyTitle: "Survey title font" => "Teckensnitt för undersökningens titel"
// header@header.surveyDescription: "Survey description font" => "Teckensnitt för undersökningsbeskrivning"
// header@header.headerTitle: "Survey title font" => "Teckensnitt för undersökningens titel"
// header@header.headerDescription: "Survey description font" => "Teckensnitt för undersökningsbeskrivning"
// header@header.inheritWidthFrom: "Content area width" => "Bredd på innehållsområdet"
// header@header.textAreaWidth: "Text width" => "Textens bredd"
// header@header.backgroundColorSwitch: "Background color" => "Bakgrundsfärg"
// header@header.backgroundImage: "Background image" => "Bakgrundsbild"
// header@header.backgroundImageOpacity: "Opacity" => "Ogenomskinlighet"
// header@header.overlapEnabled: "Overlap" => "Överlappa"
// header@header.logoPositionX: "Logo position" => "Logotypens placering"
// header@header.titlePositionX: "Title position" => "Titel position"
// header@header.descriptionPositionX: "Description position" => "Beskrivning position"
// weight.400: "Regular" => "Ordinarie"
// weight.600: "Heavy" => "Tung"
// weight.700: "Semi-bold" => "Halvfet stil"
// weight.800: "Bold" => "Djärv"
// backgroundImageFit.auto: "Auto" => "Bil"
// backgroundImageFit.cover: "Cover" => "Täcka"
// backgroundImageFit.contain: "Contain" => "Innehålla"
// backgroundImageFit.fill: "Stretch" => "Tänja"
// backgroundImageFit.tile: "Tile" => "Kakel"
// backgroundImageAttachment.fixed: "Fixed" => "Fast"
// backgroundImageAttachment.scroll: "Scroll" => "Rulla"
// headerView.basic: "Basic" => "Grundläggande"
// headerView.advanced: "Advanced" => "Avancerad"
// inheritWidthFrom.survey: "Same as survey" => "Samma som enkät"
// inheritWidthFrom.container: "Fit to container" => "Passa till behållare"
// backgroundColorSwitch.none: "None" => "Ingen"
// backgroundColorSwitch.accentColor: "Accent color" => "Accentfärg"
// backgroundColorSwitch.custom: "Custom" => "Sed"
// colorPalette.light: "Light" => "Ljus"
// colorPalette.dark: "Dark" => "Mörk"
// isPanelless.false: "Default" => "Standard"
// isPanelless.true: "Without Panels" => "Utan paneler"
// theme.cornerRadius: "Corner radius" => "Hörn radie"
// theme.fontFamily: "Font family" => "Teckensnitt familj"
// theme.fontWeightRegular: "Regular" => "Ordinarie"
// theme.fontWeightHeavy: "Heavy" => "Tung"
// theme.fontWeightSemiBold: "Semi-bold" => "Halvfet stil"
// theme.fontWeightBold: "Bold" => "Djärv"
// theme.color: "Color" => "Färg"
// theme.placeholderColor: "Placeholder color" => "Platshållarens färg"
// theme.size: "Size" => "Storlek"
// theme.opacity: "Opacity" => "Ogenomskinlighet"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Skriv för att söka..."
// ed.toolboxNoResultsFound: "No results found" => "Inga resultat hittades"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Platshållare för flikrubrik"
// theme.--sjs-special-red: "Error messages" => "Felmeddelanden"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "En reservtext för flikrubriker som gäller när flikrubrikmönstret inte ger ett meningsfullt värde."
// theme.fontColor: "Font color" => "Teckenfärg"
// theme.backgroundColor: "Background color" => "Bakgrundsfärg"
// pe.questionTitleWidth: "Question title width" => "Bredd på frågerubrik"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Välj en fil eller klistra in en fillänk..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Ex.: 200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Anger konsekvent bredd för frågerubriker när de är justerade till vänster om frågerutorna. Accepterar CSS-värden (px, %, in, pt, etc.)."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Anger konsekvent bredd för frågerubriker när de är justerade till vänster om frågerutorna. Accepterar CSS-värden (px, %, in, pt, etc.)."
// pe.commentAreaRows: "Comment area height (in lines)" => "Kommentarsfältets höjd (i rader)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Anger antalet rader som ska visas i textområden för frågekommentarer. I inmatningen tar upp fler rader visas rullningslisten."


/***/ }),

/***/ "./src/localization/tajik.ts":
/*!***********************************!*\
  !*** ./src/localization/tajik.ts ***!
  \***********************************/
/*! exports provided: tgStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tgStrings", function() { return tgStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 1052 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var tgStrings = {
    // survey templates
    survey: {
        edit: "Тағйир додан",
        externalHelpLink: "Ёд гирифтани ташкил кардани саволномаҳо",
        externalHelpLinkUrl: "Https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Илтимос, элементи даркориро аз бастаи чап кашида биёред.",
        // addLogicItem: "Create a rule to customize the flow of the survey.",
        copy: "Нусхабардорӣ кардан",
        // duplicate: "Duplicate",
        addToToolbox: "Илова кардан ба асбобҳо",
        deletePanel: "Нест кардани баста",
        deleteQuestion: "Нест кардани савол",
        convertTo: "Тағйир додани шакл ба",
        drag: "Кашидани элемент",
    },
    // Creator tabs
    tabs: {
        preview: "Санҷиши саволнома",
        // theme: "Themes",
        translation: "Тарҷума",
        designer: "Дида баромадани конструктор",
        editor: "Тағйиркунаки JSON",
        logic: "Мантиқи саволнома"
    },
    // Question types
    qt: {
        default: "Бо нобаёнӣ",
        checkbox: "Интихоби бисёр",
        comment: "Шарҳ",
        imagepicker: "Интихоби сурат",
        // ranking: "Ranking",
        // image: "Image",
        dropdown: "Рӯйхати таркишӣ",
        // tagbox: "Multi-Select Dropdown",
        file: "Боркунии файлҳо",
        // html: "HTML",
        matrix: "Матриса (интихоби танҳо)",
        matrixdropdown: "Матриса (интихоби бисёр)",
        matrixdynamic: "Матриса (сатрҳои динамикӣ)",
        multipletext: "Матнҳои бисёр",
        panel: "Баста (барои гурӯҳи саволҳо)",
        paneldynamic: "Баста (бастаҳои динамикӣ)",
        radiogroup: "Интихоби танҳо",
        rating: "Рейтинг (миқёс)",
        text: "Воридкунии матнӣ",
        boolean: "Қиммати булӣ",
        expression: "Ифода (танҳо барои хондан)",
        // signaturepad: "Signature",
        // buttongroup: "Button Group"
    },
    toolboxCategories: {
        general: "Умумӣ",
        // choice: "Choice Questions",
        // text: "Text Input Questions",
        // containers: "Containers",
        // matrix: "Matrix Questions",
        // misc: "Misc"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Бо нобаёнӣ ({0})",
        survey: "Саволнома",
        settings: "Танзимоти саволнома",
        // settingsTooltip: "Open settings",
        // surveySettings: "Survey Settings",
        // surveySettingsTooltip: "Survey settings",
        // themeSettings: "Theme Settings",
        // themeSettingsTooltip: "Theme settings",
        // showPanel: "Show Panel",
        // hidePanel: "Hide Panel",
        // prevSelected: "Select previous",
        // nextSelected: "Select next",
        // prevFocus: "Focus previous",
        // nextFocus: "Focus next",
        // surveyTypeName: "Survey",
        // pageTypeName: "Page",
        // panelTypeName: "Panel",
        // questionTypeName: "Question",
        // columnTypeName: "Column",
        addNewPage: "Сохтани саҳифаи нав",
        moveRight: "Ба рост тоб додан",
        moveLeft: "Ба чап тоб додан",
        deletePage: "Нест кардани саҳифа",
        editPage: "Тағйир додани саҳифа",
        edit: "Тағйир додан",
        newPageName: "саҳифа",
        newQuestionName: "савол",
        newPanelName: "баста",
        newTextItemName: "матн",
        // defaultV2Theme: "Default",
        // modernTheme: "Modern",
        // defaultTheme: "Default (legacy)",
        testSurveyAgain: "Боз як бор санҷиш гузаронидан",
        testSurveyWidth: "Дарозии саволнома:",
        // navigateToMsg: "You had to navigate to",
        saveSurvey: "Сабти саволнома",
        // saveSurveyTooltip: "Save Survey",
        // saveTheme: "Save Theme",
        // saveThemeTooltip: "Save Theme",
        // jsonHideErrors: "Hide errors",
        // jsonShowErrors: "Show errors",
        undo: "Бекор кардан",
        redo: "Такрор",
        // undoTooltip: "Undo last change",
        // redoTooltip: "Redo the change",
        // showMoreChoices: "Show more",
        // showLessChoices: "Show less",
        // copy: "Copy",
        // cut: "Cut",
        // paste: "Paste",
        // copyTooltip: "Copy selection to clipboard",
        // cutTooltip: "Cut selection to clipboard",
        // pasteTooltip: "Paste from clipboard",
        options: "Танзимотҳо",
        generateValidJSON: "Сохтани JSON-и дуруст",
        generateReadableJSON: "Сохтани JSON-и мехондагӣ",
        toolbox: "Бастаи асбобҳо",
        // "property-grid": "Properties",
        // toolboxFilteredTextPlaceholder: "Type to search...",
        // toolboxNoResultsFound: "No results found",
        // propertyGridFilteredTextPlaceholder: "Type to search...",
        // propertyGridNoResultsFound: "No results found",
        correctJSON: "Илтимос, JSON-ро дуруст кунед.",
        surveyResults: "Натиҷаи ташхис:",
        surveyResultsTable: "Ҳамчун ҷадвал",
        surveyResultsJson: "Ҳамчун JSON",
        resultsTitle: "Сарлавҳаи савол",
        resultsName: "Мақсади савол",
        resultsValue: "Қиммати ҷавоб",
        resultsDisplayValue: "Қиммати нишондода",
        modified: "Тағйирдодашуда",
        saving: "Сабт",
        saved: "Сабтшуда",
        // propertyEditorError: "Error",
        saveError: "Хатогӣ! Қиммати тағйиркунак сабт нашудааст.",
        // translationPropertyGridTitle: "Language Settings",
        // themePropertyGridTitle: "Theme Settings",
        // translationLanguages: "Languages",
        // translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?",
        translationAddLanguage: "Интихоби забон барои тарҷума",
        translationShowAllStrings: "Нишон додани ҳамаи сатрҳо",
        // translationShowUsedStringsOnly: "Used Strings Only",
        translationShowAllPages: "Нишон додани ҳамаи саҳифаҳо",
        translationNoStrings: "Сатрҳо барои тарҷума вуҷуд надоранд. Илтимос, филтрро тағйир диҳед.",
        translationExportToSCVButton: "Экспорт ба CSV",
        translationImportFromSCVButton: "Импорт аз CSV",
        // translateUsigAI: "Auto-translate All",
        // translateUsigAIFrom: "Translate from: ",
        // translationDialogTitle: "Untranslated strings",
        translationMergeLocaleWithDefault: "Якҷоя кардани {0} бо локали нобаёнӣ",
        // translationPlaceHolder: "Translation...",
        // translationSource: "Source: ",
        // translationTarget: "Target: ",
        // themeExportButton: "Export",
        // themeImportButton: "Import",
        // surveyJsonExportButton: "Export",
        // surveyJsonImportButton: "Import",
        // surveyJsonCopyButton: "Copy to clipboard",
        // themeResetButton: "Reset theme settings to default",
        // themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost.",
        // themeResetConfirmationOk: "Yes, reset the theme",
        bold: "Ғавс",
        italic: "Қаҷ",
        underline: "Зерхат",
        addNewQuestion: "Иловаи савол",
        // selectPage: "Select page...",
        // carryForwardChoicesCopied: "Choices are copied from",
        // choicesLoadedFromWebText: "Choices are loaded from a web service.",
        // choicesLoadedFromWebLinkText: "Go to settings",
        // choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options",
        // htmlPlaceHolder: "HTML content will be here.",
        // panelPlaceHolder: "Drop a question from the toolbox here.",
        // surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below.",
        // pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below.",
        // imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload",
        // surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form.",
        // pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page.",
        // panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel.",
        // imagePlaceHolderMobile: "Click the button below and choose an image to upload",
        // imageChooseImage: "Choose Image",
        // addNewTypeQuestion: "Add {0}", //{0} is localizable question type
        // chooseLogoPlaceholder: "[LOGO]",
        // choices_Item: "Item ",
        // selectFile: "Select a file",
        // removeFile: "Remove the file",
        lg: {
            // addNewItem: "Add New Rule",
            // empty_tab: "Create a rule to customize the flow of the survey.",
            page_visibilityName: "Намоиши саҳифа",
            // page_enableName: "Enable/disable page",
            // page_requireName: "Make page required",
            panel_visibilityName: "Намоиши баста",
            panel_enableName: "Баста гирон/куштагӣ",
            // panel_requireName: "Make panel required",
            question_visibilityName: "Намоиши савол",
            question_enableName: "Савол гирон/куштагӣ",
            question_requireName: "Савол ихтиёрӣ аст",
            // question_resetValueName: "Reset question value",
            // question_setValueName: "Set question value",
            // column_visibilityName: "Show/hide column",
            // column_enableName: "Enable/disable column",
            // column_requireName: "Make column required",
            // column_resetValueName: "Reset column value",
            // column_setValueName: "Set column value",
            trigger_completeName: "Назарсанҷӣ тамом шуд",
            trigger_setvalueName: "Сабти қиммати савол",
            trigger_copyvalueName: "Нусхабардорӣ кардани қиммати савол",
            trigger_skipName: "Гузаштан ба савол",
            trigger_runExpressionName: "Иҷро кардани ифодаи истифодабаранда",
            completedHtmlOnConditionName: "Матни истифодабаранда 'Саҳифаи ташаккурӣ'",
            page_visibilityDescription: "Саҳифаро намоён кардан, агар ифодаи мантиқӣ 'true' баргардонад. Вагарна онро нонамоён кардан.",
            panel_visibilityDescription: "Бастаро намоён кардан, агар ифодаи мантиқӣ 'true' баргардонад. Вагарна онро нонамоён кардан.",
            panel_enableDescription: "Бастаро ва ҳамаи элементҳои дохилии онро намоён кардан, агар ифодаи мантиқӣ 'true' баргардонад. Вагарна онро нонамоён кардан.",
            question_visibilityDescription: "Саволро намоён кардан, агар ифодаи мантиқӣ 'true' баргардонад. Вагарна онро нонамоён кардан.",
            question_enableDescription: "Саволро гирон кардан, агар ифодаи мантиқӣ 'true' баргардонад. Вагарна онро нонамоён кардан.",
            question_requireDescription: "Савол ҳатмӣ мешавад, вақте ки ифодаи мантиқӣ 'true' баргардонад.",
            trigger_completeDescription: "Вақте, ки ифодаи мантиқӣ 'true' баргардонад, он вақт ӯ ҳамчун тамом шуда ҳисобида мешавад ва истифодабар саҳифаи 'Саҳифаи ташаккурӣ'-ро мебинад.",
            trigger_setvalueDescription: "Вақте, ки қиммати саволҳо, ки дар ифодаи мантиқӣ истифода мешавад, тағйир мешаванд ва ифодаи мантиқӣ 'true' бармегардонад, он гоҳ ба саволи интихобшуда қиммат сабт мешавад.",
            trigger_copyvalueDescription: "Вақте, ки қимматҳои саволҳо, ки дар ифодаи мантиқӣ истифода мешаванд, тағйир меёбанд ва ифода қиммати 'true' бармегардонад, он гоҳ як қиммати саволи интихобшуда ба дигар савол нусхабардорӣ карда мешавад.",
            trigger_skipDescription: "Вақте, ки ифодаи мантиқӣ 'true' бармегардонад, он гоҳ саволнома ба саволи интихобшуда равона мешавад.",
            trigger_runExpressionDescription: "Вақте, ки ифодаи мантиқӣ 'true' бармегардонад, он гоҳ ифодаи истифодабар иҷро мешавад. Шумо, бо хоҳиш, метавонед натиҷаи ин ифодаро ба саволи интихобшуда бахшед.",
            completedHtmlOnConditionDescription: "Агар ифодаи мантиқӣ 'true' баргардонад, он гоҳ матн бо нобаёнӣ барои 'саҳифаи ташаккурӣ' тағйир мешавад ба ишорашуда.",
            itemExpressionText: "Вақте, ки ифода: '{0}' бармегардонад 'true':",
            // itemEmptyExpressionText: "New rule",
            page_visibilityText: "Саҳифаи {0}-ро намоён кардан ",
            panel_visibilityText: "Бастаи {0}-ро намоён кардан",
            panel_enableText: "Бастаи {0}-ро гирон кардан",
            question_visibilityText: "Саволи {0}-ро намоён кардан",
            question_enableText: "Саволи {0}-ро намоён кардан",
            question_requireText: "Саволи {0}-ро ҳатмӣ кардан",
            // question_resetValueText: "reset value for question: {0}", //{0} question name.
            // question_setValueText: "assign value: {1} to question: {0}",
            // column_visibilityText: "make column {0} of question {1} visible", //{0} column name, {1} question name
            // column_enableText: "make column {0} of question {1} enable", //{0} column name, {1} question name
            // column_requireText: "make column {0} of question {1} required", //{0} column name, {1} question name
            // column_resetValueText: "reset cell value for column: {0}", //{0} column name
            // column_setValueText: "assign cell value: {1} to column: {0}", //{0} column name and {1} setValueExpression
            // setValueExpressionPlaceholder: "An expression whose result will be assigned to the target question.",
            trigger_completeText: "Саволнома ҳамчун анҷомшуда тағйир меёбад",
            trigger_setvalueText: "Ба саволи {0} қиммати {1}-ро сабт кардан",
            // trigger_setvalueEmptyText: "clear question value: {0}", //{0} question name
            trigger_copyvalueText: "Нусхабардорӣ кардан ба саволи {0} қиммат аз саволи {1}",
            trigger_skipText: "Саволнома мегузарад ба саволи {0}",
            trigger_runExpressionText1: "Иҷро кардани ифодаи: '{0}'",
            trigger_runExpressionText2: "ва натиҷаи онро ба саволи {0} гузоштан",
            completedHtmlOnConditionText: "Нишон додани матни истифодабар дар 'Саҳифаи ташаккурӣ'",
            // showAllQuestions: "All Questions",
            // showAllActionTypes: "All Action Types",
            // conditions: "Condition(s)",
            // actions: "Action(s)",
            expressionEditorTitle: "Танзимоти мантиқи ифода",
            // actionsEditorTitle: "Define action(s)",
            // deleteAction: "Delete Action",
            // addNewAction: "Add Action",
            // selectedActionCaption: "Select action...",
            expressionInvalid: "Ифодаи мантиқӣ холӣ ё беэътибор мебошад. Илтимос, ислоҳ кунед.",
            // noActionError: "Please add at least one action.",
            // actionInvalid: "Please fix issues in your action(s).",
            // uncompletedRule_title: "Logical rules are incomplete",
            // uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?",
            // uncompletedRule_apply: "Yes",
            // uncompletedRule_cancel: "No, I want to complete the rules"
        }
    },
    // Property Editors
    pe: {
        panel: {
        // name: "Panel name",
        // title: "Panel title",
        // description: "Panel description",
        // visibleIf: "Make the panel visible if",
        // requiredIf: "Make the panel required if",
        // questionsOrder: "Question order within the panel",
        // page: "Move the panel to page",
        // startWithNewLine: "Display the panel on a new line",
        // state: "Panel collapse state",
        // width: "Inline panel width",
        // minWidth: "Minimum panel width",
        // maxWidth: "Maximum panel width",
        // showNumber: "Number panels"
        },
        paneldynamic: {
        // name: "Panel name",
        // title: "Panel title",
        // description: "Panel description",
        // visibleIf: "Make the panel visible if",
        // requiredIf: "Make the panel required if",
        // page: "Move the panel to page",
        // startWithNewLine: "Display the panel on a new line",
        // state: "Panel collapse state",
        // width: "Inline panel width",
        // minWidth: "Minimum panel width",
        // maxWidth: "Maximum panel width",
        // confirmDelete: "Confirm panel deletion",
        // templateDescription: "Panel description pattern",
        // templateTitle: "Panel title pattern",
        // noEntriesText: "Empty panel text",
        // templateTabTitle: "Tab title pattern",
        // tabTitlePlaceholder: "Tab title placeholder",
        // templateVisibleIf: "Make an individual panel visible if",
        // hideNumber: "Hide the panel number",
        // titleLocation: "Panel title alignment",
        // descriptionLocation: "Panel description alignment",
        // templateTitleLocation: "Question title alignment",
        // templateErrorLocation: "Error message alignment",
        // newPanelPosition: "New panel location",
        // keyName: "Prevent duplicate responses in the following question"
        },
        question: {
        // name: "Question name",
        // title: "Question title",
        // description: "Question description",
        // visibleIf: "Make the question visible if",
        // requiredIf: "Make the question required if",
        // page: "Move the question to page",
        // state: "Question box collapse state",
        // hideNumber: "Hide the question number",
        // titleLocation: "Question title alignment",
        // descriptionLocation: "Question description alignment",
        // errorLocation: "Error message alignment",
        // indent: "Increase the inner indent",
        // width: "Inline question width",
        // minWidth: "Minimum question width",
        // maxWidth: "Maximum question width",
        // textUpdateMode: "Update input field value"
        },
        signaturepad: {
        // signatureWidth: "Signature area width",
        // signatureHeight: "Signature area height",
        // signatureAutoScaleEnabled: "Auto-scale the signature area",
        // showPlaceholder: "Show a placeholder within signature area",
        // placeholder: "Placeholder text",
        // placeholderReadOnly: "Placeholder text in read-only or preview mode",
        // allowClear: "Show the Clear button within signature area",
        // penMinWidth: "Minimum stroke width",
        // penMaxWidth: "Maximum stroke width",
        // penColor: "Stroke color"
        },
        comment: {
        // rows: "Input field height (in lines)"
        },
        showQuestionNumbers: "Нишон додани номери савол",
        questionStartIndex: "Индекси саршавии савол (1, 2 ё 'A', 'а')",
        expression: {
        // name: "Expression name",
        // title: "Expression title",
        // description: "Expression description",
        // expression: "Expression"
        },
        trigger: {
        // expression: "Expression"
        },
        calculatedvalue: {
        // expression: "Expression"
        },
        // survey templates
        survey: {
        // title: "Survey title",
        // description: "Survey description"
        },
        page: {
        // name: "Page name",
        // title: "Page title",
        // description: "Page description",
        // visibleIf: "Make the page visible if",
        // requiredIf: "Make the page required if",
        // maxTimeToFinish: "Time limit to complete the page",
        // questionsOrder: "Question order on the page"
        },
        matrixdropdowncolumn: {
        // name: "Column name",
        // title: "Column title",
        // isUnique: "Prevent duplicate responses",
        // width: "Column width",
        // minWidth: "Minimum column width",
        // rows: "Input field height (in lines)",
        // visibleIf: "Make the column visible if",
        // requiredIf: "Make the column required if",
        // showInMultipleColumns: "Each option in a separate column"
        },
        multipletextitem: {
        // name: "Name",
        // title: "Title"
        },
        masksettings: {
        // saveMaskedValue: "Save masked value in survey results"
        },
        patternmask: {
        // pattern: "Value pattern"
        },
        datetimemask: {
        // min: "Minimum value",
        // max: "Maximum value"
        },
        numericmask: {
        // allowNegativeValues: "Allow negative values",
        // thousandsSeparator: "Thousands separator",
        // decimalSeparator: "Decimal separator",
        // precision: "Value precision",
        // min: "Minimum value",
        // max: "Maximum value"
        },
        currencymask: {
        // prefix: "Currency prefix",
        // suffix: "Currency suffix"
        },
        // imageHeight: "Display area height",
        // imageWidth: "Display area width",
        valueName: "Номи нуқта",
        // rateDescriptionLocation: "Label alignment",
        // size: "Input field width (in characters)",
        // cellErrorLocation: "Cell error message alignment",
        apply: "Сабт",
        ok: "OK",
        save: "Сабт кардан",
        // clear: "Clear",
        // saveTooltip: "Save",
        cancel: "Бекор кардан",
        // set: "Set",
        reset: "Партофтан",
        // change: "Change",
        // refresh: "Refresh",
        close: "Махкам кардан",
        delete: "Нест кардан",
        add: "Илова кардан",
        // addNew: "Add New",
        addItem: "Пахш кунед, барои илова кардани элемент...",
        // removeItem: "Click to remove the item...",
        // dragItem: "Drag the item",
        addOther: "Дигар",
        addSelectAll: "Интихоб кардани ҳамаи нуқтаҳо",
        addNone: "Ҳичӣ",
        removeAll: "Ҳамаро нест кардан",
        edit: "Тағйир додан",
        back: "Бозгашт бе сабт",
        // backTooltip: "Return without saving",
        saveAndBack: "Сабт кардан ва бозгаштан",
        // saveAndBackTooltip: "Save and return",
        // doneEditing: "Done",
        editChoices: "Тағйир додани интихоб",
        // showChoices: "Show Choices",
        move: "Ҷойивазкунӣ",
        empty: "<холӣ>",
        // emptyValue: "Value is empty",
        fastEntry: "Даромади тез",
        // fastEntryNonUniqueError: "Value '{0}' is not unique",
        // fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}",
        // fastEntryChoicesMinCountError: "Please enter at least {0} items",
        // fastEntryPlaceholder: "Enter the list of choice options and their IDs in the following format:\n\nid|option\n\nA choice option ID is not visible to respondents and can be used in conditional rules.",
        formEntry: "Формаи даромад",
        testService: "Тести хизматрасонӣ",
        itemSelectorEmpty: "Илтимос, элементро интихоб кунед",
        // conditionActionEmpty: "Please select the action",
        conditionSelectQuestion: "Саволро интихоб кунед ...",
        conditionSelectPage: "Саҳифаро интихоб кунед ...",
        conditionSelectPanel: "Бастаро интихоб кунед ...",
        conditionValueQuestionTitle: "Илтимос, қимматро ворид/интихоб кунед",
        aceEditorHelp: "Тугмаҳои Ctrl+Пробел пахш кунед, барои гирифтани ишораҳои кӯмакӣ",
        aceEditorRowTitle: "Сатрҳои ҷорӣ",
        aceEditorPanelTitle: "Бастаи ҷорӣ",
        showMore: "Барои гирифтани маълумоти мушаххастар, илтимос, ба дастурамал гузаред",
        assistantTitle: "Саволҳои дастрас:",
        cellsEmptyRowsColumns: "Бояд ақалан як сатр ё сутун бошад",
        // showPreviewBeforeComplete: "Review before submit",
        // overridingPropertyPrefix: "Enabled by a condition",
        // resetToDefaultCaption: "Reset",
        propertyIsEmpty: "Илтимос, қимматро ворид кунед",
        // propertyIsNoUnique: "Please enter a unique value",
        propertyNameIsNotUnique: "Лутфан як номи беҳамто ворид кунед",
        // propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\".",
        listIsEmpty: "Ҳолати нав илова кунед",
        // "listIsEmpty@choices": "You don't have any choices yet",
        // "listIsEmpty@columns": "You don't have any columns yet",
        // "listIsEmpty@rows": "You don't have any rows yet",
        // "listIsEmpty@validators": "You don't have any validation rules yet",
        // "listIsEmpty@calculatedValues": "You don't have any custom variables yet",
        // "listIsEmpty@triggers": "You don't have any triggers yet",
        // "listIsEmpty@navigateToUrlOnCondition": "You don't have any links yet",
        // "addNew@choices": "Add new choice",
        // "addNew@columns": "Add new column",
        // "addNew@rows": "Add new row",
        // "addNew@validators": "Add new rule",
        // "addNew@calculatedValues": "Add new variable",
        // "addNew@triggers": "Add new trigger",
        // "addNew@navigateToUrlOnCondition": "Add new URL",
        expressionIsEmpty: "Ибораи холӣ аст",
        value: "Қиммат",
        text: "Матн",
        rowid: "ID-и сатр",
        imageLink: "Истинод ба сурат",
        columnEdit: "Иваз додани сутун: {0}",
        itemEdit: "Тағйир додани элемент: {0}",
        url: "URL",
        path: "Роҳ",
        choicesbyurl: {
        // url: "Web service URL",
        // valueName: "Get value to store from the following property"
        },
        titleName: "Сарлавҳаи нуқта",
        // imageLinkName: "Get file URLs from the following property",
        // allowEmptyResponse: "Accept empty response",
        titlePlaceholder: "Сарлавҳа ворид кунед",
        surveyTitlePlaceholder: "Сарлавҳаи пурсишро ворид кунед",
        pageTitlePlaceholder: "Сарлавҳаи саҳифаро ворид кунед",
        descriptionPlaceholder: "Тавсифро ворид кунед",
        surveyDescriptionPlaceholder: "Тавсифи пурсишро ворид кунед",
        pageDescriptionPlaceholder: "Тавсифи саҳифаро ворид кунед",
        // textWrapEnabled: "Wrap choices",
        showOtherItem: "Нуқтаи 'Дигар' вуҷуд аст",
        otherText: "Манти нуқтаи 'Дигар'",
        showNoneItem: "Ягон нуқта вуҷуд надорад",
        // showRefuseItem: "Enable the \"Refuse to Answer\" option",
        // showDontKnowItem: "Enable the \"Don't Know\" option",
        noneText: "Матни нуқтаи 'Ҳиҷӣ'",
        showSelectAllItem: "Ҳамаи нуқтаҳоро интихоб кардан",
        selectAllText: "Матни нуқта 'Ҳамаи нуқтаҳоро интихоб кардан'",
        choicesMin: "Қиммати минималӣ барои элементҳои сохташуда бо роҳи автоматӣ",
        choicesMax: "Қиммати максималӣ барои элементҳои сохташуда бо роҳи автоматӣ",
        choicesStep: "Фарқият байни элементҳои сохташуда бо роҳи автоматӣ",
        name: "Ном",
        title: "Сарлавҳа",
        cellType: "Намдуи катакча",
        // colCount: "Column count",
        choicesOrder: "Интихоб кардани фармоиши интихоб",
        visible: "Нишон додан?",
        isRequired: "Ҳатмӣ?",
        // markRequired: "Mark as required",
        // removeRequiredMark: "Remove the required mark",
        isAllRowRequired: "Ҳамаи сатрҳо барои пуркунӣ ҳатмӣ мебошад",
        // eachRowUnique: "Prevent duplicate responses in rows",
        requiredErrorText: "Ин майдон баро пуркунӣ ҳатмист",
        startWithNewLine: "Аз сатри нав сар кардан?",
        rows: "Шумораи сатрҳо",
        // cols: "Columns",
        // placeholder: "Placeholder text within input field",
        showPreview: "Нишон додани пешнамоиш?",
        storeDataAsText: "Нигоҳ доштани дохили файл дар формати JSON ҳамчун матн",
        // maxSize: "Maximum file size (in bytes)",
        rowCount: "Шумораи сатрҳо",
        columnLayout: "Макети сутунҳо",
        addRowLocation: "Илова кардани ҷойи тугмаи сатр",
        // transposeData: "Transpose rows to columns",
        addRowText: "Илова кардани матни тугмаи сатр",
        removeRowText: "Нест кардани тугмаи матн",
        rateMin: "Рейтинги минималӣ",
        rateMax: "Рейтинги максималӣ",
        rateStep: "Қадами рейтинг",
        minRateDescription: "Маълумот барои рейтинги минималӣ",
        maxRateDescription: "Маълумот барои рейтинги максималӣ",
        inputType: "Намуди дохилкунӣ",
        optionsCaption: "Танзимотҳои имзо",
        // defaultValue: "Default Answer",
        cellsDefaultRow: "Матни нобаёни катак",
        surveyEditorTitle: "Танзимоти саволнома",
        qEditorTitle: "Тағйир додани: {0}",
        maxLength: "Шумораи максималӣ",
        buildExpression: "Сохтан",
        editExpression: "Таҳрир кунед",
        // and: "and",
        // or: "or",
        remove: "Ҷойивазкунӣ",
        addCondition: "шарт илова кунед",
        // emptyLogicPopupMessage: "Select a question to start configuring conditions.",
        // if: "If",
        // then: "then",
        // setToName: "Target question",
        // fromName: "Question to copy answer from",
        // gotoName: "Question to skip to",
        // ruleIsNotSet: "Rule is incorrect",
        // includeIntoResult: "Add to the survey results",
        showTitle: "Нишон/пинҳон кардани сарлавҳа",
        // expandCollapseTitle: "Expand/collapse title",
        locale: "Забон ба нобаён",
        simulator: "Таҷҳизотро интихоб кунед",
        landscapeOrientation: "Манзаравӣ",
        // portraitOrientation: "Switch to portrait orientation",
        mode: "Намуд (тағйирот/намоиш)",
        clearInvisibleValues: "Тоза кардани қимматҳои ноёан",
        cookieName: "Номи Cookie (куштани такроран локалӣ гузаштани саволнома)",
        sendResultOnPageNext: "Нишон додани натиҷаи саволнома дар саҳифаи наздик",
        storeOthersAsComment: "Нигоҳ доштани қиммати 'Дигар' дар майдони алоҳида",
        showPageTitles: "Нишон додани сарлавҳаи саҳифа",
        showPageNumbers: "Нишон додани рақами саҳифа",
        pagePrevText: "Матн дар тугмаи 'Саҳифаи пештара'",
        pageNextText: "Матн дар тугмаи 'Саҳифаи оянда'",
        completeText: "Матн дар тугмаи 'Анҷом додан'",
        // previewText: "\"Review Answers\" button text",
        // editText: "\"Edit Answer\" button text",
        startSurveyText: "Матн дар тугмаи 'Сар кардан'",
        showNavigationButtons: "Нишон додани тугмаҳои новбарӣ (новбарии нобаён)",
        showPrevButton: "Нишон додани тугмаи 'Саҳифаи пештара' (истифодабар метавонад ба саҳифаи пештара баргардад)",
        firstPageIsStarted: "Саҳифаи якуми саволнома саҳифаи саршаванда мебошад.",
        showCompletedPage: "Нишон додани саҳифа бо матн дар анҷоми пуркунӣ (HTML-и саҳифаи анҷом)",
        goNextPageAutomatic: "Гузариш ба саҳифаи оянда ба роҳи автоматӣ дар ҳолати пуркунии ҳамаи саволҳо",
        // allowCompleteSurveyAutomatic: "Complete the survey automatically",
        showProgressBar: "Нишон додани пешравии пуркунӣ",
        questionTitleLocation: "Ҷойгиршавии сарлавҳаи савол",
        // questionTitleWidth: "Question title width",
        requiredText: "Аломат барои саволи ҳатмӣ",
        questionTitleTemplate: "Намунаи номи саволнома, ҳамчун нобаён: {матнро} {талаб} {намекунад}.",
        questionErrorLocation: "Ҷойгиркунии хатогии саволнома",
        focusFirstQuestionAutomatic: "Гузариш ба саволи якум дар ивазкунии саҳифа",
        questionsOrder: "Мураттабсозии элементҳо дар саҳифа",
        maxTimeToFinish: "Вақти максималӣ дар сонияҳо, барои пур кардани саволнома",
        maxTimeToFinishPage: "Вақти максималӣ дар сонияҳо, барои пур кардани саҳифаи саволнома",
        showTimerPanel: "Нишон додани бастаи вақтсанҷ",
        showTimerPanelMode: "Нишон додани ҳолати бастаи таймер",
        // renderMode: "Panel display mode",
        allowAddPanel: "Иҷозат додан ба илова кардани бастаҳо",
        allowRemovePanel: "Иҷозат додан ба нест кардани бастаҳо",
        panelAddText: "Иловаи матн ба баста",
        panelRemoveText: "Нест кардани матн ба баста",
        isSinglePage: "Нишон додани ҳамаи элементҳо дар як саҳифа",
        // html: "HTML markup",
        // setValue: "Answer",
        // dataFormat: "Storage format",
        // allowAddRows: "Enable row addition",
        // allowRemoveRows: "Enable row removal",
        // allowRowsDragAndDrop: "Enable row reordering",
        // responsiveImageSizeHelp: "Does not apply if you specify the exact display area width or height.",
        // minImageWidth: "Minimum display area width",
        // maxImageWidth: "Maximum display area width",
        // minImageHeight: "Minimum display area height",
        // maxImageHeight: "Maximum display area height",
        minValue: "Қиммати минималӣ",
        maxValue: "Қиммати максималӣ",
        // minLength: "Minimum length (in characters)",
        allowDigits: "Иҷозат додани рақамҳо",
        minCount: "Шумораи минималӣ",
        maxCount: "Шумораи максималӣ",
        regex: "Ифодаи регулярӣ",
        surveyvalidator: {
        // text: "Error message",
        // expression: "Validation expression"
        },
        totalText: "Тексти умумӣ",
        totalType: "Намуди умумӣ",
        totalExpression: "Ифодаи умумӣ",
        totalDisplayStyle: "Услуби намоиши умумӣ",
        totalCurrency: "Асъори умумӣ",
        totalFormat: "Намуди умумӣ",
        // logo: "Survey logo",
        // questionsOnPageMode: "Survey layout",
        // maxTextLength: "Restrict answer length",
        // maxOthersLength: "Restrict comment length",
        // commentAreaRows: "Comment area height (in lines)",
        // autoGrowComment: "Auto-expand text areas",
        // allowResizeComment: "Allow users to resize text areas",
        // textUpdateMode: "Update input field values",
        // maskType: "Input mask type",
        maskTypes: {
        // none: "None",
        // patternmask: "Pattern",
        // numericmask: "Numeric",
        // datetimemask: "Date and Time",
        // currencymask: "Currency"
        },
        // focusOnFirstError: "Set focus on the first invalid answer",
        // checkErrorsMode: "Run validation",
        // navigateToUrl: "Redirect to an external link after submission",
        // navigateToUrlOnCondition: "Dynamic external link",
        // completedBeforeHtml: "Markup to show if the user already filled out this survey",
        // completedHtml: "\"Thank You\" page markup",
        // completedHtmlOnCondition: "Dynamic \"Thank You\" page markup",
        // loadingHtml: "Markup to show while survey model is loading",
        // commentText: "Comment area text",
        // autocomplete: "Autocomplete type",
        // labelTrue: "Label for \"True\"",
        // labelFalse: "Label for \"False\"",
        // allowClear: "Show the Clear button",
        // searchMode: "Search Mode",
        // displayStyle: "Display format",
        // format: "Formatted string",
        // maximumFractionDigits: "Maximum fractional digits",
        // minimumFractionDigits: "Minimum fractional digits",
        // useGrouping: "Display grouping separators",
        // allowMultiple: "Enable multiple file upload",
        // allowImagesPreview: "Preview uploaded images",
        // acceptedTypes: "Accepted file types",
        // waitForUpload: "Wait for upload to complete",
        // needConfirmRemoveFile: "Confirm file deletion",
        // detailPanelMode: "Row expansion alignment",
        // minRowCount: "Minimum row count",
        // maxRowCount: "Maximum row count",
        // confirmDelete: "Confirm row deletion",
        // confirmDeleteText: "Confirmation message",
        // panelCount: "Initial panel count",
        // minPanelCount: "Minimum panel count",
        // maxPanelCount: "Maximum panel count",
        // panelsState: "Inner panel collapse state",
        // panelPrevText: "\"Previous Panel\" button text",
        // panelNextText: "\"Next Panel\" button text",
        // showRangeInProgress: "Show the progress bar",
        // panelRemoveButtonLocation: "\"Remove Panel\" button alignment",
        // hideIfRowsEmpty: "Hide the question if it has no rows",
        // hideColumnsIfEmpty: "Hide columns if there are no rows",
        // rateValues: "Custom rating values",
        // rateCount: "Rating count",
        // autoGenerate: "Rating configuration",
        // hideIfChoicesEmpty: "Hide the question if it has no choices",
        // minWidth: "Minimum width",
        // maxWidth: "Maximum width",
        // width: "Width",
        // showHeader: "Show column headers",
        // horizontalScroll: "Show horizontal scrollbar",
        // columnMinWidth: "Minimum column width",
        // rowTitleWidth: "Row header width",
        // valueTrue: "Value to store when \"True\" is selected",
        // valueFalse: "Value to store when \"False\" is selected",
        // minErrorText: "\"Value is below minimum\" error message",
        // maxErrorText: "\"Value exceeds maximum\" error message",
        // otherErrorText: "\"Empty comment\" error message",
        // keyDuplicationError: "Error message for duplicate responses",
        // minSelectedChoices: "Minimum choices to select",
        // maxSelectedChoices: "Maximum choices to select",
        // showClearButton: "Show the Clear button",
        // logoWidth: "Logo width",
        // logoHeight: "Logo height",
        // readOnly: "Read-only",
        // enableIf: "Disable the read-only mode if",
        // emptyRowsText: "\"No rows\" message",
        // separateSpecialChoices: "Separate special choices",
        // choicesFromQuestion: "Copy choices from the following question",
        // choicesFromQuestionMode: "Which choice options to copy",
        // progressBarShowPageTitles: "Display page titles in progress bar",
        // progressBarShowPageNumbers: "Display page numbers in progress bar",
        // showCommentArea: "Add a comment box",
        // commentPlaceholder: "Placeholder text for the comment box",
        // displayRateDescriptionsAsExtremeItems: "Show the labels as extreme values",
        // rowsOrder: "Row order",
        // columnsLayout: "Column layout",
        // columnColCount: "Nested column count",
        // correctAnswer: "Correct Answer",
        // defaultPanelValue: "Default Values",
        // cells: "Cell Texts",
        // fileInputPlaceholder: "Select a file or paste a file link...",
        // keyName: "Prevent duplicate responses in the following column",
        itemvalue: {
        // visibleIf: "Make the option visible if",
        // enableIf: "Make the option selectable if"
        },
        "itemvalue@rows": {
        // visibleIf: "Make the row visible if",
        // enableIf: "Make the row editable if"
        },
        imageitemvalue: {
        // text: "Alt text"
        },
        logoPosition: "Ҷойгиршавии логотип",
        addLogo: "Иловаи логотип...",
        changeLogo: "Тағйир додани логотип...",
        logoPositions: {
            none: "Разместить логотип",
            left: "Аз чап",
            right: "Дар тарафи рост",
            top: "Аз боло",
            bottom: "Аз поён"
        },
        // Creator tabs
        tabs: {
            panel: {
            // layout: "Panel Layout"
            },
            general: "Умумӣ",
            fileOptions: "Танзимотҳо",
            // html: "HTML Editor",
            columns: "Сутунҳо",
            rows: "Сатрҳо",
            choices: "Интихоб",
            items: "Элементҳо",
            visibleIf: "Нишон додан, агар",
            enableIf: "Дастрас аст, агар",
            requiredIf: "Ҳатмӣ барои пуркунӣ, агар",
            rateValues: "Баҳодиҳии қимматбаҳои савол",
            choicesByUrl: "Интихоб аз интернет",
            matrixChoices: "Интихоби нобаён",
            multipleTextItems: "Дохилкунии якчанд майдончаҳои матнӣ",
            // numbering: "Numbering",
            validators: "Валидаторҳо",
            navigation: "Новбарӣ",
            question: "Савол",
            // pages: "Pages",
            timer: "Вақтсанҷ/Викторина",
            calculatedValues: "Қимматҳои ҳисобкунӣ",
            triggers: "Триггерҳо",
            templateTitle: "Номи намуна",
            totals: "Натиҷаҳо",
            logic: "Мантиқ",
            // mask: "Input Mask Settings",
            layout: {
            // panel: "Panel Layout",
            // question: "Layout",
            // base: "Layout"
            },
            data: "Маълумот",
            validation: "Санҷед",
            cells: "Ҳуҷайраҳо",
            showOnCompleted: "Дар охир нишон диҳед",
            logo: "Логитип дар сарлавҳаи саволнома",
            // slider: "Slider",
            // expression: "Expression",
            // questionSettings: "Question Settings",
            // header: "Header",
            // background: "Background",
            // appearance: "Appearance",
            others: "Дигар"
        },
        editProperty: "Тағйири хосияти '{0}'",
        items: "[Элементҳо: {0}]",
        // choicesVisibleIf: "Make choices visible if",
        // choicesEnableIf: "Make choices selectable if",
        // columnsEnableIf: "Make columns visible if",
        // rowsEnableIf: "Make rows visible if",
        // innerIndent: "Increase the inner indent",
        // defaultValueFromLastRow: "Use answers from the last row as default",
        // defaultValueFromLastPanel: "Use answers from the last panel as default",
        enterNewValue: "Илтимос, қимматро ворид кунед.",
        noquestions: "Дар саволнома ягон савол нест",
        createtrigger: "Илтимос, триггерро созед",
        // titleKeyboardAdornerTip: "Press enter button to edit",
        // keyboardAdornerTip: "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item",
        triggerOn: "О",
        triggerMakePagesVisible: "Саҳифаҳоро намоён кардан:",
        triggerMakeQuestionsVisible: "Элементҳоро номаён кардан:",
        triggerCompleteText: "Тамом кардани саволнома, агар ҳама иҷро шавад.",
        triggerNotSet: "Триггер сабт нашудааст.",
        triggerRunIf: "Сар кардан, агар",
        triggerSetToName: "Тағйири қиммат:",
        triggerFromName: "Нусхабардорӣ кардани қиммат аз:",
        triggerRunExpression: "Иҷро кардани ин ифода:",
        triggerSetValue: "ба:",
        triggerGotoName: "Гузариш ба савол:",
        triggerIsVariable: "Тағйирёбандаро ба натиҷаи саволнома нагузоштан.",
        triggerRunExpressionEmpty: "Илтимос, қиммати дурустро ворид кунед.",
        // emptyExpressionPlaceHolder: "Type expression here...",
        // noFile: "No file chosen",
        // clearIfInvisible: "Clear hidden question values",
        // valuePropertyName: "Store values in the following property",
        // searchEnabled: "Enable search-as-you-type",
        // hideSelectedItems: "Hide selected items",
        // closeOnSelect: "Collapse the dropdown upon selection",
        // verticalAlign: "Vertical alignment within cells",
        // alternateRows: "Alternate row colors",
        // columnsVisibleIf: "Make columns visible if",
        // rowsVisibleIf: "Make rows visible if",
        // otherPlaceholder: "Placeholder text for the comment box",
        // filePlaceholder: "Placeholder text for Local file",
        // photoPlaceholder: "Placeholder text for Camera",
        // fileOrPhotoPlaceholder: "Placeholder text for Local file or Camera",
        // rateType: "Rating icon",
        // url_placeholder: "Ex.: https://api.example.com/books",
        // path_placeholder: "Ex.: categories.fiction",
        // questionStartIndex_placeholder: "Ex.: a)",
        // width_placeholder: "Ex.: 6in",
        // minWidth_placeholder: "Ex.: 600px",
        // maxWidth_placeholder: "Ex.: 50%",
        // imageHeight_placeholder: "auto",
        // imageWidth_placeholder: "auto",
        theme: {
        // themeName: "Theme",
        // isPanelless: "Question appearance",
        // editorPanel: "Background and corner radius",
        // questionPanel: "Background and corner radius",
        // primaryColor: "Accent color",
        // panelBackgroundTransparency: "Panel and question box opacity",
        // questionBackgroundTransparency: "Input element opacity",
        // fontSize: "Survey font size",
        // scale: "Survey scale factor",
        // cornerRadius: "Corner radius",
        // pageTitle: "Title font",
        // pageDescription: "Description font",
        // questionTitle: "Title font",
        // questionDescription: "Description font",
        // editorFont: "Font",
        // backgroundOpacity: "Opacity",
        // "--sjs-font-family": "Survey font family",
        // "--sjs-general-backcolor-dim": "Background color",
        // "--sjs-primary-backcolor": "Accent background colors",
        // "--sjs-primary-forecolor": "Accent foreground colors",
        // "--sjs-special-red": "Error message colors",
        // "--sjs-shadow-small": "Shadow effects",
        // "--sjs-shadow-inner": "Shadow effects",
        // "--sjs-border-default": "Colors"
        },
        "header@header": {
        // headerView: "View",
        // logoPosition: "Logo alignment",
        // surveyTitle: "Survey title font",
        // surveyDescription: "Survey description font",
        // headerTitle: "Survey title font",
        // headerDescription: "Survey description font",
        // inheritWidthFrom: "Content area width",
        // textAreaWidth: "Text width",
        // backgroundColorSwitch: "Background color",
        // backgroundImage: "Background image",
        // backgroundImageOpacity: "Opacity",
        // overlapEnabled: "Overlap",
        // logoPositionX: "Logo alignment",
        // titlePositionX: "Survey title alignment",
        // descriptionPositionX: "Survey description alignment"
        }
    },
    // Property values
    pv: {
        // "true": "true",
        // "false": "false",
        // file: "Local file",
        // camera: "Camera",
        // "file-camera": "Local file or Camera",
        inherit: "Меросгирӣ кардан",
        show: "Нишон додан",
        hide: "Пинҳон кардан",
        default: "Нобаёнӣ",
        initial: "Тартиботи аввала",
        random: "Тартиботи тасодуфӣ",
        collapsed: "Қатъ шуд",
        expanded: "Зиёд шуд",
        none: "Не",
        asc: "Ба калоншавӣ",
        desc: "Ба камшавӣ",
        indeterminate: "Номуайян",
        // selected: "Selected",
        // unselected: "Unselected",
        // decimal: "decimal",
        // currency: "currency",
        // percent: "percent",
        firstExpanded: "Якум зиёд шудааст",
        off: "Куштан",
        list: "Рӯйхат",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        // tab: "Tabs",
        horizontal: "Уфуқӣ",
        vertical: "Амудӣ",
        top: "Аз боло",
        bottom: "Аз поён",
        topBottom: "Аз боло ва поён",
        // both: "Both",
        left: "Чап",
        // right: "Right",
        // center: "Center",
        // leftRight: "Left and right",
        // middle: "Middle",
        // color: "color",
        // date: "date",
        // datetime: "datetime",
        // "datetime-local": "datetime-local",
        // email: "email",
        // month: "month",
        // number: "number",
        // password: "password",
        // range: "range",
        // tel: "tel",
        // text: "text",
        // time: "time",
        // url: "url",
        // week: "week",
        hidden: "Пинҳон",
        edit: "Тағйир додан",
        display: "Намоиш",
        // contain: "Contain",
        // cover: "Cover",
        // fill: "Fill",
        // next: "Next",
        // last: "Last",
        onComplete: "Пас аз анҷом",
        onHidden: "Пас аз пинҳон",
        // onHiddenContainer: "When question or its panel/page gets hidden",
        clearInvisibleValues: {
        // none: "Never"
        },
        clearIfInvisible: {
        // none: "Never"
        },
        inputType: {
        // color: "Color",
        // date: "Date",
        // "datetime-local": "Date and Time",
        // email: "Email",
        // month: "Month",
        // number: "Number",
        // password: "Password",
        // range: "Range",
        // tel: "Phone Number",
        // text: "Text",
        // time: "Time",
        // url: "URL",
        // week: "Week"
        },
        all: "Ҳама",
        page: "Саҳифа",
        survey: "Саволнома",
        onNextPage: "Дар гузариш ба саҳифаи оянда",
        onValueChanged: "Дар тағйири қиммат",
        // onValueChanging: "Before an answer is changed",
        questionsOnPageMode: {
        // standard: "Original structure",
        // singlePage: "Show all questions on one page",
        // questionPerPage: "Show single question per page"
        },
        // noPreview: "No preview",
        // showAllQuestions: "Show all questions",
        // showAnsweredQuestions: "Show answered questions only",
        // pages: "Completed pages",
        // questions: "Answered questions",
        // requiredQuestions: "Answered required questions",
        // correctQuestions: "Valid answers",
        // buttons: "Completed pages (button UI)",
        // underInput: "Under the input field",
        // underTitle: "Under the question title",
        // onBlur: "On lost focus",
        // onTyping: "While typing",
        // underRow: "Under the row",
        // underRowSingle: "Under the row, display one row expansion only",
        // auto: "Auto",
        showNavigationButtons: {
        // none: "Hidden"
        },
        showTimerPanel: {
        // none: "Hidden"
        },
        showTimerPanelMode: {
        // all: "Both"
        },
        addRowLocation: {
        // default: "Based on matrix layout"
        },
        panelsState: {
        // default: "Locked",
        // collapsed: "Collapse all",
        // expanded: "Expand all",
        // firstExpanded: "First expanded"
        },
        widthMode: {
        // static: "Static",
        // responsive: "Responsive"
        },
        contentMode: {
        // image: "Image",
        // video: "Video",
        // youtube: "YouTube"
        },
        displayMode: {
        // buttons: "Buttons",
        // dropdown: "Dropdown"
        },
        rateColorMode: {
        // default: "Default",
        // scale: "Scale"
        },
        scaleColorMode: {
        // monochrome: "Monochrome",
        // colored: "Colored"
        },
        autoGenerate: {
        // "true": "Auto-generate",
        // "false": "Manual"
        },
        rateType: {
        // labels: "Labels",
        // stars: "Stars",
        // smileys: "Smileys"
        },
        state: {
        // default: "Locked"
        },
        showQuestionNumbers: {
        // default: "Auto-numbering",
        // on: "Auto-numbering",
        // onPage: "Reset on each page",
        // onpanel: "Reset on each panel",
        // onPanel: "Reset on each panel",
        // onSurvey: "Continue across the survey",
        // off: "No numbering"
        },
        descriptionLocation: {
        // underTitle: "Under the question title",
        // underInput: "Under the input field"
        },
        selectToRankAreasLayout: {
        // horizontal: "Next to choices",
        // vertical: "Above choices"
        },
        displayStyle: {
        // decimal: "Decimal",
        // currency: "Currency",
        // percent: "Percentage",
        // date: "Date"
        },
        totalDisplayStyle: {
        // decimal: "Decimal",
        // currency: "Currency",
        // percent: "Percentage",
        // date: "Date"
        },
        rowsOrder: {
        // initial: "Original"
        },
        questionsOrder: {
        // initial: "Original"
        },
        showProgressBar: {
        // off: "Hidden",
        // topbottom: "Top and bottom",
        // aboveheader: "Above the header",
        // belowheader: "Below the header"
        },
        // sum: "Sum",
        // count: "Count",
        // min: "Min",
        // max: "Max",
        // avg: "Avg",
        searchMode: {
        // contains: "Contains",
        // startsWith: "Starts with"
        },
        backgroundImageFit: {
        // auto: "Auto",
        // cover: "Cover",
        // contain: "Contain",
        // fill: "Stretch",
        // tile: "Tile"
        },
        backgroundImageAttachment: {
        // fixed: "Fixed",
        // scroll: "Scroll"
        },
        headerView: {
        // basic: "Basic",
        // advanced: "Advanced"
        },
        inheritWidthFrom: {
        // survey: "Same as survey",
        // container: "Same as container"
        },
        backgroundColorSwitch: {
        // none: "None",
        // accentColor: "Accent color",
        // custom: "Custom"
        },
        colorPalette: {
        // light: "Light",
        // dark: "Dark"
        },
        isPanelless: {
        // "false": "Default",
        // "true": "Without Panels"
        }
    },
    // Operators
    op: {
        empty: "пур накарда",
        notempty: "пур карда",
        equal: "баробар",
        notequal: "нобаробар",
        contains: "дар бар дорад",
        notcontains: "дар бар надорад",
        anyof: "ҳар як аз",
        allof: "ҳама аз",
        greater: "зиёдтар",
        less: "камтар",
        greaterorequal: "калон ё баробар",
        lessorequal: "кам ё баробар",
        // and: "and",
        // or: "or"
    },
    // Embed window
    ew: {
        angular: "Истифода баред версияи Angular",
        jquery: "Истифода баред версияи jQuery",
        knockout: "Истифода баред версияи Knockout",
        react: "Истифода баред версияи React",
        vue: "Истифода баред версияи Vue",
        bootstrap: "Барои китобхонаи bootstrap",
        // modern: "Modern theme",
        // default: "Default theme",
        // orange: "Orange theme",
        // darkblue: "Darkblue theme",
        // darkrose: "Darkrose theme",
        // stone: "Stone theme",
        // winter: "Winter theme",
        // winterstone: "Winter-Stone theme",
        showOnPage: "Нишон додани саволнома дар саҳифа",
        showInWindow: "Нишон додани саволнома дар равзанаи модалӣ",
        loadFromServer: "Бор кардани Json саволнома аз сервер",
        titleScript: "Скриптҳо и услубҳо",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Саҳифаро интихоб кунед, барои санҷидани ин:",
        showInvisibleElements: "Нишон додани элементҳои пинҳон",
        // hideInvisibleElements: "Hide invisible elements"
    },
    validators: {
        answercountvalidator: "Шумораи ҷавобҳо",
        // emailvalidator: "Email",
        expressionvalidator: "Ишора",
        numericvalidator: "Рақам",
        regexvalidator: "Ишораи регулярӣ",
        textvalidator: "Матн"
    },
    triggers: {
        completetrigger: "Анҷом додани саволнома",
        setvaluetrigger: "Гузоштани қиммат",
        copyvaluetrigger: "Нусхабардорӣ кардани қиммат",
        skiptrigger: "Гузариш ба саволи",
        runexpressiontrigger: "Иҷро кардани ишора",
        visibletrigger: "Тағйир кардани намоиш (тавсия дода намешавад)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Ex.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Ex.: mm/dd/yyyy"
        },
        currencymask: {
            prefix: "Ex.: $",
            suffix: "Ex.: USD"
        },
        panelbase: {
        // questionTitleWidth: "Ex.: 200px"
        }
    },
    pehelp: {
        panel: {
        // name: "A panel ID that is not visible to respondents.",
        // description: "Type a panel subtitle.",
        // visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility.",
        // enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel.",
        // requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer.",
        // questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default).",
        // questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.).",
        // questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting.",
        // questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting.",
        // page: "Repositions the panel to the end of a selected page.",
        // innerIndent: "Adds space or margin between the panel content and the left border of the panel box.",
        // startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form.",
        // state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed.",
        // width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)."
        },
        paneldynamic: {
        // name: "A panel ID that is not visible to respondents.",
        // description: "Type a panel subtitle.",
        // visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility.",
        // enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel.",
        // requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer.",
        // templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default).",
        // templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default).",
        // errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting.",
        // page: "Repositions the panel to the end of a selected page.",
        // innerIndent: "Adds space or margin between the panel content and the left border of the panel box.",
        // startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form.",
        // state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed.",
        // width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.).",
        // templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering.",
        // templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering.",
        // tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value.",
        // templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression.",
        // titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default).",
        // descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default).",
        // newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one.",
        // defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel.",
        // keyName: "Reference a question name to require a user to provide a unique response for this question in each panel."
        },
        // defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input.",
        // resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set).",
        // setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response.",
        // setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input.",
        question: {
            // name: "A question ID that is not visible to respondents.",
            // description: "Type a question subtitle.",
            // visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility.",
            // enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question.",
            // requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer.",
            // startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form.",
            // page: "Repositions the question to the end of a selected page.",
            // state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed.",
            // titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default).",
            // descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default).",
            // errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default).",
            // indent: "Adds space or margin between the question content and the left border of the question box.",
            // width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.).",
            surveyvalidator: {
            // expression: "Use the magic wand icon to set a validation rule for the question."
            },
            // textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default).",
            // url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data.",
            // searchMode: "A comparison operation used to filter the drop-down list.",
            // textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip."
        },
        signaturepad: {
        // signatureWidth: "Sets the width of the displayed signature area and the resulting image.",
        // signatureHeight: "Sets the height of the displayed signature area and the resulting image.",
        // signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions."
        },
        file: {
        // imageHeight: "Adjusts the height of the image in the survey results.",
        // imageWidth: "Adjusts the width of the image in the survey results."
        },
        image: {
        // contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided."
        },
        imagepicker: {
        // imageHeight: "Overrides the minimum and maximum height values.",
        // imageWidth: "Overrides the minimum and maximum width values.",
        // choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents.",
        // contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options."
        },
        text: {
        // size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>."
        },
        comment: {
        // rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear."
        },
        // survey templates
        survey: {
        // mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing."
        },
        matrixdropdowncolumn: {
        // name: "A column ID that is not visible to respondents.",
        // isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column.",
        // rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear.",
        // visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility.",
        // enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column.",
        // requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer.",
        // showInMultipleColumns: "When selected, creates an individual column for each choice option."
        },
        // widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used.",
        // cookieName: "Assign a unique cookie value for your survey. The cookie will be set in a respondent's browser upon survey completion to prevent repetitive survey submissions.",
        // logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB).",
        // logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.).",
        // logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.).",
        // logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio.",
        // goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page.",
        // allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions.",
        // showNavigationButtons: "Sets the visibility and location of navigation buttons on a page.",
        // showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header.",
        // showPreviewBeforeComplete: "Enable the preview page with all or answered questions only.",
        // questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level.",
        // requiredText: "A symbol or a sequence of symbols indicating that an answer is required.",
        // questionStartIndex: "Enter a number or letter with which you want to start numbering.",
        // questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box.",
        // focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry.",
        // questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab.",
        // maxTextLength: "For text entry questions only.",
        // maxOthersLength: "For question comments only.",
        // commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears.",
        // autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length.",
        // allowResizeComment: "For question comments and Long Text questions only.",
        // calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on.",
        // includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results.",
        // triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects.",
        // clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it.",
        // textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing.",
        // columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents.",
        // rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents.",
        // columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.).",
        // rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.).",
        // totalText: "Visible only if at least one column displays total values set with \"Aggregation method\" or \"Total value expression\".",
        // cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property.",
        // keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message.",
        // totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.).",
        // confirmDelete: "Triggers a prompt asking to confirm the row deletion.",
        // defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row.",
        // keyName: "Reference a column ID to require a user to provide a unique response for each question within the specified column.",
        // description: "Type a subtitle.",
        // locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab.",
        // detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed.",
        // imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio.",
        // autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting.",
        // allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field.",
        // maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the \"Thank You\" page.",
        // maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page. Hides the \"Previous\" navigation button.",
        page: {
        // maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page. Hides the \"Previous\" navigation button.",
        // visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility.",
        // enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page.",
        // requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer.",
        // questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default).",
        // questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.).",
        // questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default).",
        // questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab.",
        // navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"."
        },
        // showTimerPanel: "Sets the visibility and location of a timer on a page.",
        // panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded. Applies if \"Panel display mode\" is set to \"List\" and the \"Panel title pattern\" property is specified.",
        // imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list.",
        // choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents.",
        // title: "Type a user-friendly title to display.",
        // waitForUpload: "Ensures that users won't complete the survey until files are uploaded.",
        // minWidth: "Accepts CSS values (px, %, in, pt, etc.).",
        // maxWidth: "Accepts CSS values (px, %, in, pt, etc.).",
        // width: "Accepts CSS values (px, %, in, pt, etc.).",
        // valueName: "A join identifier is a custom key that you can assign to several questions to link them together and sync their values. These values will be merged into a single array or object and stored in survey results using the key as the property name.",
        // useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements.",
        // clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default).",
        // choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question.",
        // showOtherItem: "When selected, users can include additional input in a separate comment box.",
        // separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout.",
        // path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array.",
        choicesbyurl: {
        // valueName: "Enter a uniform property name within the array of objects whose value will be stored as a response in survey results."
        },
        // titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list.",
        // allowEmptyResponse: "Select to allow the service to return an empty response or array.",
        // choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options.",
        // rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents.",
        rating: {
        // displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown."
        },
        // valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values.",
        // searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field.",
        // valueTrue: "A value to save in survey results when respondents give a positive answer.",
        // valueFalse: "A value to save in survey results when respondents give a negative answer.",
        // showPreview: "It's not recommended that you disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded.",
        // needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion.",
        // selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area.",
        // dataList: "Enter a list of choices that will be suggested to the respondent during input.",
        // itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box.",
        // itemTitleWidth: "Sets consistent width for all item labels in pixels",
        // altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes.",
        // rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale.",
        expression: {
        // name: "An expression ID that is not visible to respondents.",
        // description: "Type an expression subtitle.",
        // expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)."
        },
        // storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results.",
        // format: "Use {0} as a placeholder for the actual value.",
        // acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information.",
        // columnColCount: "Applies only if \"Cell input type\" is set to Radio Button Group or Checkboxes.",
        // autocomplete: "Select the data type that the user's browser can retrieve. This data is sourced either from past values entered by the user or from pre-configured values if any have been saved by the user for autocompletion.",
        // filePlaceholder: "Applies when \"File source type\" is \"Local file\" or when camera is unavailable",
        // photoPlaceholder: "Applies when \"File source type\" is \"Camera\".",
        // fileOrPhotoPlaceholder: "Applies when \"File source type\" is \"Local file or camera\".",
        masksettings: {
        // saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results."
        },
        patternmask: {
        // pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character."
        },
        datetimemask: {
        // pattern: "The pattern can contain separator characters and the following placeholders:<br>`m` - Month number.<br>`mm` - Month number, with leading zero for single-digit values.<br>`d` - Day of the month.<br>`dd` - Day of the month, with leading zero for single-digit values.<br>`yy` - The last two digits of the year.<br>`yyyy` - Four-digit year.<br>`H` - Hours in 24-hour format.<br>`HH` - Hours in 24-hour format, with leading zero for single-digit values.<br>`h` - Hours in 12-hour format.<br>`hh` - Hours in 12-hour format, with leading zero for single-digit values.<br>`MM` - Minutes.<br>`ss` - Seconds.<br>`TT` - 12-hour clock period in upper case (AM/PM).<br>`tt` - 12-hour clock period in lower case (am/pm)."
        },
        numericmask: {
        // decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number.",
        // thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three.",
        // precision: "Limits how many digits to retain after the decimal point for a displayed number."
        },
        currencymask: {
        // prefix: "One or several symbols to be displayed before the value.",
        // suffix: "One or several symbols to be displayed after the value."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "Ном",
            title: "Холӣ гузоред, агар номи ӯ ҳамчун 'Ном' бошад"
        },
        // multiSelect: "Allow multiple selection",
        // showLabel: "Show image and video captions",
        // swapOrder: "Swap the order of Yes and No",
        // value: "Value",
        // tabAlign: "Tab alignment",
        // sourceType: "File source type",
        // fitToContainer: "Fit to container",
        // setValueExpression: "Set value expression",
        description: "Шарҳ",
        // logoFit: "Logo fit",
        // pages: "Pages",
        // questions: "Questions",
        triggers: "триггерҳо",
        // calculatedValues: "Custom variables",
        // surveyId: "Survey id",
        // surveyPostId: "Survey post id",
        // surveyShowDataSaving: "Survey show data saving",
        // questionDescriptionLocation: "Question description alignment",
        // progressBarType: "Progress bar type",
        // showTOC: "Show table of contents (TOC)",
        // tocLocation: "TOC alignment",
        // questionTitlePattern: "Question title pattern",
        // widthMode: "Survey width mode",
        // showBrandInfo: "Show brand info",
        // useDisplayValuesInDynamicTexts: "Use display values in dynamic texts",
        visibleIf: "Нишон додан, агар",
        // defaultValueExpression: "Default value expression",
        requiredIf: "Ҳатмист, агар",
        // resetValueIf: "Reset value if",
        // setValueIf: "Set value if",
        validators: "Валидаторҳо",
        // bindings: "Bindings",
        // renderAs: "Render as",
        // attachOriginalItems: "Attach original items",
        choices: "Интихоб",
        choicesByUrl: "Интихоб аз интернет",
        currency: "Асъор",
        // cellHint: "Cell hint",
        // totalMaximumFractionDigits: "Total maximum fraction digits",
        // totalMinimumFractionDigits: "Total minimum fraction digits",
        columns: "Сутунҳо",
        // detailElements: "Detail elements",
        // allowAdaptiveActions: "Allow adaptive actions",
        defaultRowValue: "Қимматҳои сатри нобаён",
        // detailPanelShowOnAdding: "Detail panel show on adding",
        // choicesLazyLoadEnabled: "Choices lazy load enabled",
        // choicesLazyLoadPageSize: "Choices lazy load page size",
        // inputFieldComponent: "Input field component",
        // itemComponent: "Item component",
        // min: "Min",
        // max: "Max",
        // minValueExpression: "Min value expression",
        // maxValueExpression: "Max value expression",
        // step: "Step",
        // dataList: "Items for auto-suggest",
        itemSize: "Андозаи элементҳо",
        // itemTitleWidth: "Item label width (in px)",
        // elements: "Elements",
        // content: "Content",
        navigationButtonsVisibility: "Нишон додани тугмаҳои новбарӣ",
        // navigationTitle: "Navigation title",
        // navigationDescription: "Navigation description",
        // longTap: "Long tap",
        // autoGrow: "Expand input field dynamically",
        // allowResize: "Enable resize handle",
        // acceptCarriageReturn: "Accept carriage return",
        // displayMode: "Display mode",
        // rateType: "Rate type",
        label: "Миёнабур",
        // contentMode: "Content mode",
        // imageFit: "Image and thumbnail fit",
        // altText: "Alt text",
        // height: "Height",
        // penColor: "Pen color",
        // backgroundColor: "Background color",
        // templateElements: "Template elements",
        // operator: "Operator",
        // isVariable: "Is variable",
        // runExpression: "Run expression",
        // showCaption: "Show caption",
        // iconName: "Icon name",
        // iconSize: "Icon size",
        // precision: "Precision",
        // matrixDragHandleArea: "Matrix drag handle area",
        // backgroundImage: "Background image",
        // backgroundImageFit: "Background image fit",
        // backgroundImageAttachment: "Background image attachment",
        // backgroundOpacity: "Background opacity",
        // selectToRankEnabled: "Allow selective ranking",
        // selectToRankAreasLayout: "Ranking area alignment",
        // selectToRankEmptyRankedAreaText: "Text to show if all options are selected",
        // selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area",
        // allowCameraAccess: "Allow camera access",
        // scaleColorMode: "Rating icon color mode",
        // rateColorMode: "Smileys color scheme",
        // copyDisplayValue: "Copy display value",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        // advancedMode: "Advanced mode",
        // pageTitle: "Page",
        // questionTitle: "Question box",
        // editorPanel: "Input element",
        // lines: "Lines",
        // primaryDefaultColor: "Default",
        // primaryDarkColor: "Hover",
        // primaryLightColor: "Selected",
        // backgroundDimColor: "Background color",
        // cornerRadius: "Corner radius",
        // backcolor: "Default background",
        // hovercolor: "Hover background",
        // borderDecoration: "Border decoration",
        // fontColor: "Font color",
        // backgroundColor: "Background color",
        // primaryForecolor: "Default color",
        // primaryForecolorLight: "Disabled color",
        // font: "Font",
        // borderDefault: "Darker",
        // borderLight: "Lighter",
        // fontFamily: "Font family",
        // fontWeightRegular: "Regular",
        // fontWeightHeavy: "Heavy",
        // fontWeightSemiBold: "Semi-bold",
        // fontWeightBold: "Bold",
        // color: "Color",
        // placeholderColor: "Placeholder color",
        // size: "Size",
        // opacity: "Opacity",
        // boxShadowX: "X",
        // boxShadowY: "Y",
        // boxShadowAddRule: "Add Shadow Effect",
        // boxShadowBlur: "Blur",
        // boxShadowSpread: "Spread",
        // boxShadowDrop: "Drop",
        // boxShadowInner: "Inner",
        names: {
        // default: "Default",
        // sharp: "Sharp",
        // borderless: "Borderless",
        // flat: "Flat",
        // plain: "Plain",
        // doubleborder: "Double Border",
        // layered: "Layered",
        // solid: "Solid",
        // threedimensional: "3D",
        // contrast: "Contrast"
        },
        colors: {
        // teal: "Teal",
        // blue: "Blue",
        // purple: "Purple",
        // orchid: "Orchid",
        // tulip: "Tulip",
        // brown: "Brown",
        // green: "Green"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["tg"] = tgStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually


/***/ }),

/***/ "./src/localization/traditional-chinese.ts":
/*!*************************************************!*\
  !*** ./src/localization/traditional-chinese.ts ***!
  \*************************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var traditionalChineseTranslation = {
    // survey templates
    survey: {
        edit: "編輯",
        externalHelpLink: "觀看並瞭解如何創建調查",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "請將問題放置於此",
        addLogicItem: "創建規則以自定義調查流。",
        copy: "複製",
        duplicate: "重複",
        addToToolbox: "添加到工具箱",
        deletePanel: "刪除面板",
        deleteQuestion: "刪除題目",
        convertTo: "轉變為",
        drag: "拖動元素",
    },
    // Creator tabs
    tabs: {
        preview: "測試問卷",
        theme: "主題",
        translation: "譯本",
        designer: "問卷設計器",
        editor: "JSON 編輯器",
        logic: "邏輯"
    },
    // Question types
    qt: {
        default: "違約",
        checkbox: "多項選擇",
        comment: "多行文本框",
        imagepicker: "圖像選取器",
        ranking: "排名",
        image: "圖像",
        dropdown: "下拉框",
        tagbox: "多選下拉清單",
        file: "文件上傳",
        html: "Html 代碼",
        matrix: "矩陣 (單選題)",
        matrixdropdown: "矩陣 (下拉框)",
        matrixdynamic: "矩陣 (動態問題)",
        multipletext: "文本框組",
        panel: "面板",
        paneldynamic: "面板(動態)",
        radiogroup: "單項選擇",
        rating: "評分",
        text: "文本框",
        boolean: "布林選項",
        expression: "表達式",
        signaturepad: "簽名",
        buttongroup: "按鈕組"
    },
    toolboxCategories: {
        general: "常規",
        choice: "選擇題",
        text: "文本輸入問題",
        containers: "器皿",
        matrix: "矩陣問題",
        misc: "雜項"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "預設值 （{0}）",
        survey: "調查問卷",
        settings: "設置",
        settingsTooltip: "打開設置",
        surveySettings: "調查設置",
        surveySettingsTooltip: "調查設置",
        themeSettings: "主題設置",
        themeSettingsTooltip: "主題設置",
        showPanel: "顯示面板",
        hidePanel: "“隱藏”面板",
        prevSelected: "選擇上一個",
        nextSelected: "選擇下一步",
        prevFocus: "焦點 上一頁",
        nextFocus: "接下來的重點",
        surveyTypeName: "調查",
        pageTypeName: "頁",
        panelTypeName: "面板",
        questionTypeName: "問題",
        columnTypeName: "列",
        addNewPage: "添加新頁面",
        moveRight: "向右滾動",
        moveLeft: "向左滾動",
        deletePage: "刪除頁面",
        editPage: "編輯頁面",
        edit: "編輯",
        newPageName: "頁面",
        newQuestionName: "問題",
        newPanelName: "面板",
        newTextItemName: "發簡訊",
        defaultV2Theme: "違約",
        modernTheme: "摩登",
        defaultTheme: "預設（舊版）",
        testSurveyAgain: "再次測試問卷",
        testSurveyWidth: "問卷寬度: ",
        navigateToMsg: "你必須導航到",
        saveSurvey: "保存問卷",
        saveSurveyTooltip: "保存調查",
        saveTheme: "保存主題",
        saveThemeTooltip: "保存主題",
        jsonHideErrors: "隱藏錯誤",
        jsonShowErrors: "顯示錯誤",
        undo: "還原",
        redo: "重做",
        undoTooltip: "恢復上次更改",
        redoTooltip: "重做更改",
        showMoreChoices: "顯示更多",
        showLessChoices: "顯示更少",
        copy: "複製",
        cut: "切",
        paste: "糊",
        copyTooltip: "將選取內容複製到剪貼簿",
        cutTooltip: "將所選取內容剪下剪貼簿",
        pasteTooltip: "從剪貼簿粘貼",
        options: "選項",
        generateValidJSON: "生成 JSON",
        generateReadableJSON: "生成易讀的 JSON",
        toolbox: "工具箱",
        "property-grid": "性能",
        toolboxFilteredTextPlaceholder: "鍵入以搜尋...",
        toolboxNoResultsFound: "未找到結果",
        propertyGridFilteredTextPlaceholder: "鍵入以搜尋...",
        propertyGridNoResultsFound: "未找到結果",
        correctJSON: "修正 JSON",
        surveyResults: "問卷結果: ",
        surveyResultsTable: "如表",
        surveyResultsJson: "作為 JSON",
        resultsTitle: "問題標題",
        resultsName: "問題名稱",
        resultsValue: "答案值",
        resultsDisplayValue: "顯示值",
        modified: "已修改",
        saving: "保存中...",
        saved: "已保存",
        propertyEditorError: "錯誤",
        saveError: "錯誤！不保存編輯器內容。",
        translationPropertyGridTitle: "語言設置",
        themePropertyGridTitle: "主題設置",
        translationLanguages: "語言",
        translationDeleteLanguage: "您確定要刪除此語言的所有字串嗎？",
        translationAddLanguage: "選擇要翻譯的語言",
        translationShowAllStrings: "所有字串",
        translationShowUsedStringsOnly: "僅使用的字串",
        translationShowAllPages: "所有頁面",
        translationNoStrings: "沒有要翻譯的字串。請更換過濾器。",
        translationExportToSCVButton: "匯出為CSV",
        translationImportFromSCVButton: "從 CSV 導入",
        translateUsigAI: "自動翻譯全部",
        translateUsigAIFrom: "翻譯語言組合：",
        translationDialogTitle: "未翻譯的字串",
        translationMergeLocaleWithDefault: "將{0}與預設區域設置合併",
        translationPlaceHolder: "譯本。。。",
        translationSource: "源：",
        translationTarget: "目標：",
        themeExportButton: "出口",
        themeImportButton: "進口",
        surveyJsonExportButton: "出口",
        surveyJsonImportButton: "進口",
        surveyJsonCopyButton: "複製到剪貼板",
        themeResetButton: "將主題設置重置為預設值",
        themeResetConfirmation: "你真的要重置主題嗎？您的所有自定義項都將丟失。",
        themeResetConfirmationOk: "是，重置主題",
        bold: "大膽",
        italic: "斜體的",
        underline: "下劃線",
        addNewQuestion: "添加問題",
        selectPage: "選擇頁面...",
        carryForwardChoicesCopied: "選擇是從",
        choicesLoadedFromWebText: "選項是從 Web 服務載入的。",
        choicesLoadedFromWebLinkText: "前往“設置”",
        choicesLoadedFromWebPreviewTitle: "載入選項的預覽",
        htmlPlaceHolder: "HTML內容將在這裡。",
        panelPlaceHolder: "在此處從工具箱中刪除問題。",
        surveyPlaceHolder: "調查為空。從工具箱中拖動元素或按下下面的按鈕。",
        pagePlaceHolder: "頁面為空。從工具箱中拖動元素或按下下面的按鈕。",
        imagePlaceHolder: "將圖像拖放到此處或按下下面的按鈕並選擇要上傳的圖像",
        surveyPlaceHolderMobile: "按兩下下面的「添加問題」 按鈕開始創建表單。",
        pagePlaceHolderMobile: "按兩下下面的「添加問題」 按鈕，向頁面添加新元素。",
        panelPlaceHolderMobile: "按下下面的「添加問題」 按鈕，將新元素添加到面板中。",
        imagePlaceHolderMobile: "點擊下面的按鈕，選擇要上傳的圖片",
        imageChooseImage: "選擇圖像",
        addNewTypeQuestion: "新增{0}",
        chooseLogoPlaceholder: "[徽標]",
        choices_Item: "專案",
        selectFile: "選擇檔案",
        removeFile: "刪除檔案",
        lg: {
            addNewItem: "添加新規則",
            empty_tab: "創建規則以自定義調查流。",
            page_visibilityName: "顯示（隱藏）頁面",
            page_enableName: "啟用（禁用）頁面",
            page_requireName: "將頁面設為必填項",
            panel_visibilityName: "“顯示（隱藏）”面板",
            panel_enableName: "啟用（禁用）面板",
            panel_requireName: "將頁面設為必填項",
            question_visibilityName: "顯示（隱藏）問題",
            question_enableName: "啟用（禁用）問題",
            question_requireName: "提出必填題",
            question_resetValueName: "重置問題值",
            question_setValueName: "設置問題值",
            column_visibilityName: "顯示（隱藏）列",
            column_enableName: "啟用（禁用）列",
            column_requireName: "使列成為必填項",
            column_resetValueName: "重置列值",
            column_setValueName: "設置列值",
            trigger_completeName: "完成調查",
            trigger_setvalueName: "設置答案",
            trigger_copyvalueName: "複製答案",
            trigger_skipName: "跳至問題",
            trigger_runExpressionName: "運行表達式",
            completedHtmlOnConditionName: "設置「調查完成」頁面標記",
            page_visibilityDescription: "使頁面在邏輯表示式返回 true 時可見。否則保持不可見。",
            panel_visibilityDescription: "使面板在邏輯表達式返回 true 時可見。否則保持不可見。",
            panel_enableDescription: "使面板及其中的所有元素在邏輯表達式返回 true 時啟用。否則，請禁用它們。",
            question_visibilityDescription: "使問題在邏輯表達式返回 true 時可見。否則保持不可見。",
            question_enableDescription: "使問題在邏輯表達式返回 true 時啟用。否則將其禁用。",
            question_requireDescription: "當邏輯表達式返回 true 時，問題變為必需。",
            trigger_completeDescription: "當邏輯表達式返回 true 時，調查將完成，最終使用者將看到“謝謝頁面”。",
            trigger_setvalueDescription: "當邏輯表達式中使用的問題值發生更改並且邏輯表達式返回 true 時，該值將設置為所選問題。",
            trigger_copyvalueDescription: "當邏輯表達式中使用的問題值發生更改並且邏輯表達式返回 true 時，一個選定問題的值將複製到另一個選定問題。",
            trigger_skipDescription: "當邏輯表達式返回 true 時，調查將跳到/聚焦所選問題。",
            trigger_runExpressionDescription: "當邏輯表達式返回 true 時，將執行自定義表示式。您可以選擇將此表示式結果設置為選取問題",
            completedHtmlOnConditionDescription: "如果邏輯表達式返回 true，則「感謝頁面」的預設文本將更改為給定的文本。",
            itemExpressionText: "當表達式：「{0}」返回 true",
            itemEmptyExpressionText: "新規則",
            page_visibilityText: "使頁面{0}可見",
            panel_visibilityText: "使面板{0}可見",
            panel_enableText: "使面板{0}啟用",
            question_visibilityText: "使問題{0}可見",
            question_enableText: "使問題{0}啟用",
            question_requireText: "將問題{0}為必填項",
            question_resetValueText: "重置問題的值：{0}",
            question_setValueText: "分配值：{1}問題：{0}",
            column_visibilityText: "使問題{1}的列{0}可見",
            column_enableText: "使問題{1}列{0}啟用",
            column_requireText: "{0}將問題{1}列為必填項",
            column_resetValueText: "重置列的儲存格值：{0}",
            column_setValueText: "將儲存格值：{1}分配給列：{0}",
            setValueExpressionPlaceholder: "其結果將分配給目標問題的表達式。",
            trigger_completeText: "調查完成",
            trigger_setvalueText: "受到質疑：{0}價值{1}",
            trigger_setvalueEmptyText: "明確問題值：{0}",
            trigger_copyvalueText: "複製到問題：{0}問題 {1} 的值",
            trigger_skipText: "調查 跳至問題{0}",
            trigger_runExpressionText1: "運行表達式：“{0}”",
            trigger_runExpressionText2: "並質疑其結果：{0}",
            completedHtmlOnConditionText: "顯示「感謝頁面」的自定義文字。",
            showAllQuestions: "所有問題",
            showAllActionTypes: "所有操作類型",
            conditions: "條件",
            actions: "操作 （s）",
            expressionEditorTitle: "定義條件",
            actionsEditorTitle: "定義操作",
            deleteAction: "刪除操作",
            addNewAction: "添加操作",
            selectedActionCaption: "選擇操作...",
            expressionInvalid: "邏輯表達式為空或無效。請更正。",
            noActionError: "請至少添加一個操作。",
            actionInvalid: "請解決操作中的問題。",
            uncompletedRule_title: "邏輯規則不完整",
            uncompletedRule_text: "您尚未完成某些邏輯規則。如果現在離開該選項卡，更改將丟失。是否仍要離開選項卡而不完成更改？",
            uncompletedRule_apply: "是的",
            uncompletedRule_cancel: "不，我想完成規則"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "面板名稱",
            title: "面板標題",
            description: "面板說明",
            visibleIf: "如果出現以下情況，則使面板可見",
            requiredIf: "如果出現以下情況，則使面板成為必需的",
            questionsOrder: "小組內的問題順序",
            page: "父頁面",
            startWithNewLine: "在新行上顯示面板",
            state: "面板摺疊狀態",
            width: "內嵌面板寬度",
            minWidth: "最小面板寬度",
            maxWidth: "最大面板寬度",
            showNumber: "數字面板"
        },
        paneldynamic: {
            name: "面板名稱",
            title: "面板標題",
            description: "面板說明",
            visibleIf: "如果出現以下情況，則使面板可見",
            requiredIf: "如果出現以下情況，則使面板成為必需的",
            page: "將面板移動到頁面",
            startWithNewLine: "在新行上顯示面板",
            state: "面板摺疊狀態",
            width: "內嵌面板寬度",
            minWidth: "最小面板寬度",
            maxWidth: "最大面板寬度",
            confirmDelete: "確認面板刪除",
            templateDescription: "面板描述模式",
            templateTitle: "面板標題模式",
            noEntriesText: "空面板文本",
            templateTabTitle: "選項卡標題模式",
            tabTitlePlaceholder: "選項卡標題佔位元",
            templateVisibleIf: "如果出現以下情況，則使單個面板可見",
            hideNumber: "隱藏面板編號",
            titleLocation: "面板標題對齊方式",
            descriptionLocation: "面板描述對齊方式",
            templateTitleLocation: "問題標題對齊方式",
            templateErrorLocation: "錯誤消息對齊",
            newPanelPosition: "新面板位置",
            keyName: "防止在以下問題中重複回答"
        },
        question: {
            name: "問題名稱",
            title: "問題標題",
            description: "問題描述",
            visibleIf: "如果出現以下情況，請使問題可見",
            requiredIf: "如果出現以下情況，則將問題設為必填項",
            page: "父頁面",
            state: "問題框摺疊狀態",
            hideNumber: "隱藏問題編號",
            titleLocation: "問題標題對齊方式",
            descriptionLocation: "問題描述對齊方式",
            errorLocation: "錯誤消息對齊",
            indent: "增加內部縮進",
            width: "內聯問題寬度",
            minWidth: "最小問題寬度",
            maxWidth: "最大問題寬度",
            textUpdateMode: "更新輸入欄位值"
        },
        signaturepad: {
            signatureWidth: "簽名區域寬度",
            signatureHeight: "簽名區域高度",
            signatureAutoScaleEnabled: "自動縮放簽名區域",
            showPlaceholder: "顯示佔位元",
            placeholder: "佔位元文本",
            placeholderReadOnly: "唯讀或預覽模式下的佔位元文本",
            allowClear: "在簽名區域內顯示「清除」 按鈕",
            penMinWidth: "最小筆寬",
            penMaxWidth: "最大筆寬",
            penColor: "描邊顏色"
        },
        comment: {
            rows: "輸入欄位高度（以行為單位）"
        },
        showQuestionNumbers: "顯示問題編號",
        questionStartIndex: "問題起始標誌 (1, 2 or 'A', 'a')",
        expression: {
            name: "表達式名稱",
            title: "表達式標題",
            description: "表達式說明",
            expression: "表達"
        },
        trigger: {
            expression: "表達"
        },
        calculatedvalue: {
            expression: "表達"
        },
        // survey templates
        survey: {
            title: "標題",
            description: "調查說明"
        },
        page: {
            name: "頁面名稱",
            title: "標題",
            description: "頁面描述",
            visibleIf: "如果出現以下情況，則使頁面可見",
            requiredIf: "如果出現以下情況，則使頁面為必填項",
            maxTimeToFinish: "完成頁面的時間限制（秒為單位 ）",
            questionsOrder: "頁面上的問題順序"
        },
        matrixdropdowncolumn: {
            name: "列名稱",
            title: "專欄標題",
            isUnique: "防止重複回應",
            width: "列寬",
            minWidth: "最小列寬",
            rows: "輸入欄位高度（以行為單位）",
            visibleIf: "如果出現以下情況，則使列可見",
            requiredIf: "如果滿足以下條件，則使該列為必填項",
            showInMultipleColumns: "每個選項都在單獨的列中"
        },
        multipletextitem: {
            name: "名字",
            title: "標題"
        },
        masksettings: {
            saveMaskedValue: "在調查結果中保存掩碼值"
        },
        patternmask: {
            pattern: "價值模式"
        },
        datetimemask: {
            min: "最小值",
            max: "最大值"
        },
        numericmask: {
            allowNegativeValues: "允許負值",
            thousandsSeparator: "千分隔符",
            decimalSeparator: "小數點分隔符",
            precision: "值精度",
            min: "最小值",
            max: "最大值"
        },
        currencymask: {
            prefix: "貨幣前綴",
            suffix: "貨幣後綴"
        },
        imageHeight: "圖片高度",
        imageWidth: "圖片寬度",
        valueName: "Value name",
        rateDescriptionLocation: "標籤對齊",
        size: "輸入欄位大小（以字元為單位 ）",
        cellErrorLocation: "單元格錯誤消息對齊方式",
        apply: "應用",
        ok: "確定",
        save: "救",
        clear: "清楚",
        saveTooltip: "救",
        cancel: "取消",
        set: "設置",
        reset: "重置",
        change: "改變",
        refresh: "刷新",
        close: "關閉",
        delete: "刪除",
        add: "加",
        addNew: "新建",
        addItem: "點選以新增專案...",
        removeItem: "按下以刪除該專案...",
        dragItem: "拖動專案",
        addOther: "其他",
        addSelectAll: "全選",
        addNone: "沒有",
        removeAll: "全部刪除",
        edit: "編輯器",
        back: "退貨而不保存",
        backTooltip: "退貨而不保存",
        saveAndBack: "保存並返回",
        saveAndBackTooltip: "保存並返回",
        doneEditing: "做",
        editChoices: "編輯選項",
        showChoices: "顯示選項",
        move: "移動",
        empty: "<空>",
        emptyValue: "值為空",
        fastEntry: "快速輸入",
        fastEntryNonUniqueError: "值“{0}”不是唯一的",
        fastEntryChoicesCountError: "請將項目數量限制在{0}到{1}",
        fastEntryChoicesMinCountError: "請輸入至少{0}專案",
        fastEntryPlaceholder: "您可以按以下格式設定資料：\n值 1|文本\n值2",
        formEntry: "表單輸入",
        testService: "測試服務",
        itemSelectorEmpty: "請選擇元素",
        conditionActionEmpty: "請選擇操作",
        conditionSelectQuestion: "選擇問題...",
        conditionSelectPage: "選擇頁面...",
        conditionSelectPanel: "選擇面板...",
        conditionValueQuestionTitle: "請輸入/選擇值",
        aceEditorHelp: "按 ctrl+空格鍵獲取表達式完成提示",
        aceEditorRowTitle: "當前行",
        aceEditorPanelTitle: "當前面板",
        showMore: "更多細節...",
        assistantTitle: "可用問題",
        cellsEmptyRowsColumns: "至少應該有一列或一行",
        showPreviewBeforeComplete: "在提交調查之前預覽答案",
        overridingPropertyPrefix: "設置者",
        resetToDefaultCaption: "重置",
        propertyIsEmpty: "請為該屬性設定一個值",
        propertyIsNoUnique: "請輸入唯一值",
        propertyNameIsNotUnique: "請輸入唯一名稱",
        propertyNameIsIncorrect: "不要使用保留字：「專案」、「選項」、「面板」、“行”。",
        listIsEmpty: "尚未添加任何專案",
        "listIsEmpty@choices": "尚未添加任何選項",
        "listIsEmpty@columns": "您還沒有任何列",
        "listIsEmpty@rows": "您還沒有任何行",
        "listIsEmpty@validators": "尚無任何驗證規則",
        "listIsEmpty@calculatedValues": "您還沒有任何自訂變數",
        "listIsEmpty@triggers": "您還沒有任何觸發器",
        "listIsEmpty@navigateToUrlOnCondition": "您還沒有任何連結",
        "addNew@choices": "添加選項",
        "addNew@columns": "添加新列",
        "addNew@rows": "添加新行",
        "addNew@validators": "添加新規則",
        "addNew@calculatedValues": "添加新變數",
        "addNew@triggers": "添加新觸發器",
        "addNew@navigateToUrlOnCondition": "添加新 URL",
        expressionIsEmpty: "表達式為空",
        value: "值",
        text: "顯示文本",
        rowid: "行標識",
        imageLink: "圖片或視頻網址",
        columnEdit: "編輯列: {0}",
        itemEdit: "編輯選項: {0}",
        url: "URL",
        path: "Path",
        choicesbyurl: {
            url: "Web 服務的 URL",
            valueName: "從以下 JSON 欄位中獲取值"
        },
        titleName: "Title name",
        imageLinkName: "從以下 JSON 欄位獲取影像網址",
        allowEmptyResponse: "允許空回應",
        titlePlaceholder: "標題",
        surveyTitlePlaceholder: "調查標題",
        pageTitlePlaceholder: "頁數 {num}",
        descriptionPlaceholder: "描述",
        surveyDescriptionPlaceholder: "描述",
        pageDescriptionPlaceholder: "描述",
        textWrapEnabled: "換行選項",
        showOtherItem: "可添加其他答案?",
        otherText: "其他答案文本",
        showNoneItem: "允許“無”選項",
        showRefuseItem: "允許「拒絕應答」選項",
        showDontKnowItem: "允許“不知道”選項",
        noneText: "無選項文字",
        showSelectAllItem: "允許「全選」選項",
        selectAllText: "全選選項文本",
        choicesMin: "自動生成項的最小值",
        choicesMax: "自動生成項的最大值",
        choicesStep: "自動生成項的步驟",
        name: "題目名",
        title: "題目文本",
        cellType: "單元格類型",
        colCount: "列數",
        choicesOrder: "設置選項順序",
        visible: "是否可見?",
        isRequired: "是否為必填項?",
        markRequired: "標記為必填",
        removeRequiredMark: "刪除所需的標記",
        isAllRowRequired: "要求所有行都回答",
        eachRowUnique: "防止行中出現重複回應",
        requiredErrorText: "“必需”錯誤消息",
        startWithNewLine: "問題是否新起一行?",
        rows: "文本框行數",
        cols: "列",
        placeholder: "占位文本",
        showPreview: "是否顯示圖像預覽?",
        storeDataAsText: "以 JSON 文本方式存儲文件",
        maxSize: "文件最大尺寸 (Bytes)",
        rowCount: "默認行數",
        columnLayout: "列佈局",
        addRowLocation: "“添加行”按鈕位置",
        transposeData: "將行轉置為列",
        addRowText: "添加條目按鈕文本",
        removeRowText: "刪除條目按鈕文本",
        rateMin: "最低速率值",
        rateMax: "最大速率值",
        rateStep: "速率步長",
        minRateDescription: "最小值提示",
        maxRateDescription: "最大值提示",
        inputType: "文本框類型",
        optionsCaption: "下拉框提示語",
        defaultValue: "默認答案",
        cellsDefaultRow: "預設文字",
        surveyEditorTitle: "編輯調查設置",
        qEditorTitle: "編輯問題: {0}",
        maxLength: "最大長度（字元）",
        buildExpression: "建",
        editExpression: "編輯",
        and: "和",
        or: "或",
        remove: "刪除",
        addCondition: "添加條件",
        emptyLogicPopupMessage: "選擇一個問題以開始配置條件。",
        if: "如果",
        then: "然後",
        setToName: "目標問題",
        fromName: "要從中複製答案的問題",
        gotoName: "要跳到的問題",
        ruleIsNotSet: "規則不正確",
        includeIntoResult: "包含在調查結果中",
        showTitle: "顯示/隱藏 標題",
        expandCollapseTitle: "展開/摺疊標題",
        locale: "默認語言",
        simulator: "選擇設備類型",
        landscapeOrientation: "切換到橫向",
        portraitOrientation: "切換到縱向",
        mode: "模式 (編輯/只讀)",
        clearInvisibleValues: "清除隱藏值",
        cookieName: "Cookie name (to disable run survey two times locally)",
        sendResultOnPageNext: "Send survey results on page next",
        storeOthersAsComment: "Store 'others' value in separate field",
        showPageTitles: "顯示頁面標題",
        showPageNumbers: "顯示頁數",
        pagePrevText: "前一頁按鈕文本",
        pageNextText: "後一頁按鈕文本",
        completeText: "完成按鈕文本",
        previewText: "「預覽答案」按鈕文本",
        editText: "編輯應答按鈕文本",
        startSurveyText: "開始按鈕文本",
        showNavigationButtons: "顯示導航按鈕 (默認導航)",
        showPrevButton: "顯示前一頁按鈕 (用戶可返回至前一頁面)",
        firstPageIsStarted: "調查的第一頁面為起始頁.",
        showCompletedPage: "結尾展示完成後的頁面 (completedHtml)",
        goNextPageAutomatic: "回答本頁所有問題後，自動跳轉到下一頁",
        allowCompleteSurveyAutomatic: "自動完成調查",
        showProgressBar: "顯示進度條",
        questionTitleLocation: "問題的標題位置",
        questionTitleWidth: "問題標題寬度",
        requiredText: "The question required symbol(s)",
        questionTitleTemplate: "問題標題模板, 默認為: '{no}. {require} {title}'",
        questionErrorLocation: "問題錯誤定位",
        focusFirstQuestionAutomatic: "改變頁面時聚焦在第一個問題",
        questionsOrder: "Elements order on the page",
        maxTimeToFinish: "完成調查的最長時間",
        maxTimeToFinishPage: "完成調查中頁面的最長時間",
        showTimerPanel: "顯示計時器面板",
        showTimerPanelMode: "顯示計時器面板模式",
        renderMode: "渲染模式",
        allowAddPanel: "允許添加面板",
        allowRemovePanel: "允許刪除面板",
        panelAddText: "添加面板文本",
        panelRemoveText: "刪除面板文本",
        isSinglePage: "在一個頁面上展示所有元素",
        html: "網頁標記",
        setValue: "答",
        dataFormat: "圖像格式",
        allowAddRows: "允許添加行",
        allowRemoveRows: "允許刪除行",
        allowRowsDragAndDrop: "允許行拖放",
        responsiveImageSizeHelp: "如果指定確切的圖像寬度或高度，則不適用。",
        minImageWidth: "最小圖像寬度",
        maxImageWidth: "最大圖像寬度",
        minImageHeight: "最小圖像高度",
        maxImageHeight: "最大圖像高度",
        minValue: "最小值",
        maxValue: "最大值",
        minLength: "最小長度（以字元為單位）",
        allowDigits: "允許數位",
        minCount: "最小計數",
        maxCount: "最大計數",
        regex: "正則表達式",
        surveyvalidator: {
            text: "錯誤資訊",
            expression: "驗證表達式"
        },
        totalText: "總計行文本",
        totalType: "總類型",
        totalExpression: "總表達",
        totalDisplayStyle: "總值顯示樣式",
        totalCurrency: "貨幣",
        totalFormat: "帶格式的字串",
        logo: "徽標（URL 或base64 編碼的字串）",
        questionsOnPageMode: "調查結構",
        maxTextLength: "最大答案長度（以字元為單位）",
        maxOthersLength: "最大註解長度（以字元為單位）",
        commentAreaRows: "評論區高度（以行為單位）",
        autoGrowComment: "如有必要，自動展開評論區域",
        allowResizeComment: "允許用戶調整文字區域的大小",
        textUpdateMode: "更新文字問題值",
        maskType: "輸入掩碼類型",
        maskTypes: {
            none: "沒有",
            patternmask: "模式",
            numericmask: "數值的",
            datetimemask: "日期和時間",
            currencymask: "貨幣"
        },
        focusOnFirstError: "將焦點放在第一個無效答案上",
        checkErrorsMode: "運行驗證",
        navigateToUrl: "導航到網址",
        navigateToUrlOnCondition: "動態網址",
        completedBeforeHtml: "用於顯示使用者是否已填寫此調查的標記",
        completedHtml: "調查完成頁面標記",
        completedHtmlOnCondition: "動態調查完成頁面標記",
        loadingHtml: "載入調查模型時要顯示的標記",
        commentText: "註釋區文本",
        autocomplete: "自動完成類型",
        labelTrue: "“真實”標籤",
        labelFalse: "“虛假”標籤",
        allowClear: "顯示“清除”按鈕",
        searchMode: "搜索模式",
        displayStyle: "值顯示樣式",
        format: "帶格式的字串",
        maximumFractionDigits: "最大小數位數",
        minimumFractionDigits: "最小小數位數",
        useGrouping: "顯示分組分隔符",
        allowMultiple: "允許多個檔",
        allowImagesPreview: "預覽圖像",
        acceptedTypes: "接受的文件類型",
        waitForUpload: "等待上傳完成",
        needConfirmRemoveFile: "確認文件刪除",
        detailPanelMode: "詳細資訊面板位置",
        minRowCount: "最小行數",
        maxRowCount: "最大行數",
        confirmDelete: "確認刪除行",
        confirmDeleteText: "確認消息",
        panelCount: "初始面板計數",
        minPanelCount: "最小面板數",
        maxPanelCount: "最大面板數",
        panelsState: "內面板展開狀態",
        panelPrevText: "“上一個面板”按鈕工具提示",
        panelNextText: "“下一個面板”按鈕工具提示",
        showRangeInProgress: "顯示進度條",
        panelRemoveButtonLocation: "“刪除面板”按鈕位置",
        hideIfRowsEmpty: "如果沒有行，則隱藏問題",
        hideColumnsIfEmpty: "如果沒有行，則隱藏列",
        rateValues: "自定義費率值",
        rateCount: "速率計數",
        autoGenerate: "如何指定速率值？",
        hideIfChoicesEmpty: "如果問題不包含任何選項，則隱藏問題",
        minWidth: "最小寬度（以 CSS 接受的值為單位）",
        maxWidth: "最大寬度（以 CSS 接受的值為單位）",
        width: "寬度（以 CSS 接受的值為單位）",
        showHeader: "顯示列標題",
        horizontalScroll: "顯示水平滾動條",
        columnMinWidth: "最小列寬（以 CSS 接受的值為單位）",
        rowTitleWidth: "行標題寬度（以 CSS 接受的值為單位）",
        valueTrue: "“真”值",
        valueFalse: "“假”值",
        minErrorText: "“值低於最小值”錯誤消息",
        maxErrorText: "“值超過最大值”錯誤消息",
        otherErrorText: "“空評論”錯誤消息",
        keyDuplicationError: "“非唯一鍵值”錯誤消息",
        minSelectedChoices: "最少選擇的選項",
        maxSelectedChoices: "最大選定選項數",
        showClearButton: "顯示“清除”按鈕",
        logoWidth: "徽標寬度（以 CSS 接受的值為單位）",
        logoHeight: "徽標高度（以 CSS 接受的值為單位）",
        readOnly: "唯讀",
        enableIf: "可編輯，如果",
        emptyRowsText: "“無行”消息",
        separateSpecialChoices: "單獨的特殊選項（無、其他、全選）",
        choicesFromQuestion: "複製以下問題的選項",
        choicesFromQuestionMode: "要複製哪些選項？",
        progressBarShowPageTitles: "在進度條中顯示頁面標題",
        progressBarShowPageNumbers: "在進度條中顯示頁碼",
        showCommentArea: "顯示評論區域",
        commentPlaceholder: "註釋區佔位元",
        displayRateDescriptionsAsExtremeItems: "將速率描述顯示為極值",
        rowsOrder: "行順序",
        columnsLayout: "列佈局",
        columnColCount: "嵌套列計數",
        correctAnswer: "正確答案",
        defaultPanelValue: "預設值",
        cells: "單元格文本",
        fileInputPlaceholder: "選擇檔案或貼上檔案連結...",
        keyName: "鍵列",
        itemvalue: {
            visibleIf: "如果出現以下情況，則使該選項可見",
            enableIf: "如果出現以下情況，則使該選項可選"
        },
        "itemvalue@rows": {
            visibleIf: "如果出現以下情況，則使行可見",
            enableIf: "如果出現以下情況，則使行可編輯"
        },
        imageitemvalue: {
            text: "可選文字"
        },
        logoPosition: "徽標位置",
        addLogo: "新增徽標...",
        changeLogo: "變更徽標...",
        logoPositions: {
            none: "刪除徽標",
            left: "左",
            right: "右",
            top: "在頂部",
            bottom: "在底部"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "面板佈局"
            },
            general: "通用項",
            fileOptions: "選項",
            html: "HTML 編輯器",
            columns: "設置列",
            rows: "設置行",
            choices: "設置選項",
            items: "專案",
            visibleIf: "設置可見條件",
            enableIf: "Enable If",
            requiredIf: "如果",
            rateValues: "設置評分值",
            choicesByUrl: "通過 URL 導入選項",
            matrixChoices: "默認選項",
            multipleTextItems: "文本輸入",
            numbering: "編號",
            validators: "校驗規則",
            navigation: "導航",
            question: "問題",
            pages: "頁面",
            timer: "問卷計時器",
            calculatedValues: "計算值",
            triggers: "觸發器",
            templateTitle: "標題範本",
            totals: "總數",
            logic: "邏輯",
            mask: "輸入掩碼設置",
            layout: {
                panel: "佈局",
                question: "佈局",
                base: "佈局"
            },
            data: "數據",
            validation: "驗證",
            cells: "單元格文本",
            showOnCompleted: "調查完成",
            logo: "調查標題中的徽標",
            slider: "滑塊",
            expression: "表達",
            questionSettings: "問題設置",
            header: "頁眉",
            background: "背景",
            appearance: "外觀",
            others: "別人"
        },
        editProperty: "編輯屬性: '{0}'",
        items: "[ 項目數量: {0} ]",
        choicesVisibleIf: "在以下情況下，選項可見",
        choicesEnableIf: "在以下情況下，可以選擇選項",
        columnsEnableIf: "在以下情況下，列可見",
        rowsEnableIf: "在以下情況下，行可見",
        innerIndent: "添加內部縮進",
        defaultValueFromLastRow: "從最後一行獲取預設值",
        defaultValueFromLastPanel: "從最後一個面板中獲取預設值",
        enterNewValue: "請設定值",
        noquestions: "問卷中還沒有創建任何問題",
        createtrigger: "請創建觸發器",
        titleKeyboardAdornerTip: "按回車鍵編輯",
        keyboardAdornerTip: "按回車鍵編輯專案，按刪除按鈕刪除專案，按Alt加向上箭頭或向下箭頭移動專案",
        triggerOn: "當 ",
        triggerMakePagesVisible: "使頁面可見:",
        triggerMakeQuestionsVisible: "使問題可見:",
        triggerCompleteText: "如果滿足條件，則完成問卷",
        triggerNotSet: "觸發器尚未設置",
        triggerRunIf: "滿足下列條件時執行",
        triggerSetToName: "修改下列問題值: ",
        triggerFromName: "從以下位置複製值：",
        triggerRunExpression: "運行此表達式",
        triggerSetValue: "修改為: ",
        triggerGotoName: "轉到問題",
        triggerIsVariable: "在問卷提交結果中不要包含該變量",
        triggerRunExpressionEmpty: "請輸入有效的表達式",
        emptyExpressionPlaceHolder: "在這裡鍵入表示式...",
        noFile: "未選擇任何檔",
        clearIfInvisible: "如果問題被隱藏，則清除該值",
        valuePropertyName: "值屬性名稱",
        searchEnabled: "啟用搜索",
        hideSelectedItems: "隱藏選取選取專案",
        closeOnSelect: "選擇後關閉下拉清單",
        verticalAlign: "垂直對齊",
        alternateRows: "交替行",
        columnsVisibleIf: "在以下情況下，列可見",
        rowsVisibleIf: "在以下情況下，行可見",
        otherPlaceholder: "註釋區佔位元",
        filePlaceholder: "檔佔位元文本",
        photoPlaceholder: "照片占位元文本",
        fileOrPhotoPlaceholder: "檔或照片佔位元文字",
        rateType: "費率類型",
        url_placeholder: "例如：https://api.example.com/books",
        path_placeholder: "例如：categories.fiction",
        questionStartIndex_placeholder: "例如：a）",
        width_placeholder: "例：6in",
        minWidth_placeholder: "例如：600px",
        maxWidth_placeholder: "例：50%",
        imageHeight_placeholder: "自動",
        imageWidth_placeholder: "自動",
        theme: {
            themeName: "主題",
            isPanelless: "問題外觀",
            editorPanel: "背景和拐角半徑",
            questionPanel: "背景和拐角半徑",
            primaryColor: "強調色",
            panelBackgroundTransparency: "面板背景不透明度",
            questionBackgroundTransparency: "問題背景不透明度",
            fontSize: "字體大小",
            scale: "規模",
            cornerRadius: "拐角半徑",
            pageTitle: "標題字體",
            pageDescription: "描述字體",
            questionTitle: "標題字體",
            questionDescription: "描述字體",
            editorFont: "字體",
            backgroundOpacity: "不透明度",
            "--sjs-font-family": "字體家族",
            "--sjs-general-backcolor-dim": "背景顏色",
            "--sjs-primary-backcolor": "重音背景",
            "--sjs-primary-forecolor": "重音前景",
            "--sjs-special-red": "錯誤消息",
            "--sjs-shadow-small": "陰影效果",
            "--sjs-shadow-inner": "陰影效果",
            "--sjs-border-default": "顏色"
        },
        "header@header": {
            headerView: "視圖",
            logoPosition: "徽標位置",
            surveyTitle: "調查標題字體",
            surveyDescription: "調查描述字體",
            headerTitle: "調查標題字體",
            headerDescription: "調查描述字體",
            inheritWidthFrom: "內容區寬度",
            textAreaWidth: "文本寬度",
            backgroundColorSwitch: "背景顏色",
            backgroundImage: "背景圖片",
            backgroundImageOpacity: "不透明度",
            overlapEnabled: "重疊",
            logoPositionX: "徽標位置",
            titlePositionX: "標題位置",
            descriptionPositionX: "描述位置"
        }
    },
    // Property values
    pv: {
        "true": "真",
        "false": "假",
        file: "本地檔",
        camera: "照相機",
        "file-camera": "本地檔或相機",
        inherit: "繼承",
        show: "可見",
        hide: "隱藏",
        default: "繼承",
        initial: "初",
        random: "隨機",
        collapsed: "倒塌",
        expanded: "擴大",
        none: "沒有",
        asc: "上升",
        desc: "降",
        indeterminate: "定",
        selected: "選擇",
        unselected: "未選中",
        decimal: "十進位",
        currency: "貨幣",
        percent: "百分之",
        firstExpanded: "第一個面板展開",
        off: "隱藏問題編號",
        list: "清單",
        progressTop: "面板導航器 + 頂部的進度條",
        progressBottom: "面板導航器 + 底部的進度條",
        progressTopBottom: "面板導航器 + 頂部和底部的進度條",
        tab: "製表元",
        horizontal: "水準",
        vertical: "垂直",
        top: "返回頁首",
        bottom: "底",
        topBottom: "頂部和底部",
        both: "雙",
        left: "左",
        right: "右",
        center: "中心",
        leftRight: "左和右",
        middle: "中間",
        color: "顏色",
        date: "日期",
        datetime: "日期時間",
        "datetime-local": "日期時間-本地",
        email: "電子郵件",
        month: "月",
        number: "數",
        password: "密碼",
        range: "範圍",
        tel: "電話",
        text: "發簡訊",
        time: "時間",
        url: "網址",
        week: "周",
        hidden: "隱藏",
        edit: "編輯",
        display: "唯讀",
        contain: "包含",
        cover: "蓋",
        fill: "填補",
        next: "下一個",
        last: "最後",
        onComplete: "調查完成時",
        onHidden: "當問題變得隱藏時",
        onHiddenContainer: "當問題或其面板/頁面被隱藏時",
        clearInvisibleValues: {
            none: "從不"
        },
        clearIfInvisible: {
            none: "從不"
        },
        inputType: {
            color: "顏色",
            date: "日期",
            "datetime-local": "日期和時間",
            email: "電子郵件",
            month: "月",
            number: "數",
            password: "密碼",
            range: "範圍",
            tel: "電話號碼",
            text: "發簡訊",
            time: "時間",
            url: "網址",
            week: "周"
        },
        all: "都",
        page: "頁",
        survey: "調查",
        onNextPage: "切換到下一頁時",
        onValueChanged: "更改答案後",
        onValueChanging: "更改答案之前",
        questionsOnPageMode: {
            standard: "原始結構",
            singlePage: "在一個頁面上顯示所有問題",
            questionPerPage: "每頁顯示一個問題"
        },
        noPreview: "無預覽",
        showAllQuestions: "顯示所有問題",
        showAnsweredQuestions: "僅顯示已回答的問題",
        pages: "已完成的頁面",
        questions: "已回答的問題",
        requiredQuestions: "回答必填問題",
        correctQuestions: "有效答案",
        buttons: "已完成的頁面（按鈕 UI）",
        underInput: "在輸入下",
        underTitle: "在標題下",
        onBlur: "模糊時",
        onTyping: "打字時",
        underRow: "在行下",
        underRowSingle: "在該行下，只有一個面板可見",
        auto: "自動",
        showNavigationButtons: {
            none: "隱藏"
        },
        showTimerPanel: {
            none: "隱藏"
        },
        showTimerPanelMode: {
            all: "雙"
        },
        addRowLocation: {
            default: "取決於矩陣佈局"
        },
        panelsState: {
            default: "使用者無法展開或摺疊面板",
            collapsed: "所有面板均已摺疊",
            expanded: "所有面板均已展開",
            firstExpanded: "首次擴展"
        },
        widthMode: {
            static: "靜態的",
            responsive: "回應"
        },
        contentMode: {
            image: "圖像",
            video: "視頻",
            youtube: "優酷"
        },
        displayMode: {
            buttons: "按鈕",
            dropdown: "下拉清單"
        },
        rateColorMode: {
            default: "違約",
            scale: "規模"
        },
        scaleColorMode: {
            monochrome: "單色",
            colored: "彩色"
        },
        autoGenerate: {
            "true": "生成",
            "false": "手動輸入"
        },
        rateType: {
            labels: "標籤",
            stars: "星星",
            smileys: "笑臉"
        },
        state: {
            default: "鎖"
        },
        showQuestionNumbers: {
            default: "自動編號",
            on: "自動編號",
            onPage: "在每個頁面上重置",
            onpanel: "在每個面板上重置",
            onPanel: "在每個面板上重置",
            onSurvey: "在整個調查中繼續",
            off: "無編號"
        },
        descriptionLocation: {
            underTitle: "在問題標題下",
            underInput: "在輸入欄位下"
        },
        selectToRankAreasLayout: {
            horizontal: "在選項旁邊",
            vertical: "以上選擇"
        },
        displayStyle: {
            decimal: "十進位",
            currency: "貨幣",
            percent: "百分比",
            date: "日期"
        },
        totalDisplayStyle: {
            decimal: "十進位",
            currency: "貨幣",
            percent: "百分比",
            date: "日期"
        },
        rowsOrder: {
            initial: "源語言"
        },
        questionsOrder: {
            initial: "源語言"
        },
        showProgressBar: {
            off: "隱藏",
            topbottom: "頂部和底部",
            aboveheader: "標題上方",
            belowheader: "在標題下方"
        },
        sum: "和",
        count: "計數",
        min: "最小值",
        max: "麥克斯",
        avg: "平均",
        searchMode: {
            contains: "包含",
            startsWith: "開頭為"
        },
        backgroundImageFit: {
            auto: "自動",
            cover: "蓋",
            contain: "包含",
            fill: "伸展",
            tile: "瓦"
        },
        backgroundImageAttachment: {
            fixed: "固定",
            scroll: "滾動"
        },
        headerView: {
            basic: "基本",
            advanced: "高深"
        },
        inheritWidthFrom: {
            survey: "與調查相同",
            container: "適合容器"
        },
        backgroundColorSwitch: {
            none: "沒有",
            accentColor: "強調色",
            custom: "習慣"
        },
        colorPalette: {
            light: "光",
            dark: "黑暗"
        },
        isPanelless: {
            "false": "違約",
            "true": "不帶面板"
        }
    },
    // Operators
    op: {
        empty: "為空",
        notempty: "不為空",
        equal: "等於",
        notequal: "不等於",
        contains: "包含",
        notcontains: "不包含",
        anyof: "任何",
        allof: "全部",
        greater: "大於",
        less: "小於",
        greaterorequal: "大於等於",
        lessorequal: "小於等於",
        and: "和",
        or: "或"
    },
    // Embed window
    ew: {
        angular: "使用 Angular 時",
        jquery: "使用 JQuery 時",
        knockout: "使用 Knockout 時",
        react: "使用 React 時",
        vue: "使用 Vue 時",
        bootstrap: "使用 Bootstrap 時",
        modern: "現代主題",
        default: "默認主題",
        orange: "橙色主題",
        darkblue: "深藍色主題",
        darkrose: "“暗玫瑰”主題",
        stone: "“石頭”主題",
        winter: "“冬季”主題",
        winterstone: "“冬日之石”主題",
        showOnPage: "嵌入頁面顯示",
        showInWindow: "使用單獨的問卷視窗",
        loadFromServer: "從服務器加載問卷 JSON 數據",
        titleScript: "腳本和樣式",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "選擇要測試的頁面",
        showInvisibleElements: "顯示不可見元素",
        hideInvisibleElements: "隱藏不可見元素"
    },
    validators: {
        answercountvalidator: "數量檢查",
        emailvalidator: "Email",
        expressionvalidator: "表達",
        numericvalidator: "數字",
        regexvalidator: "正則表達式",
        textvalidator: "文本"
    },
    triggers: {
        completetrigger: "完成問卷",
        setvaluetrigger: "設置問題值",
        copyvaluetrigger: "複製答案",
        skiptrigger: "跳至問題",
        runexpressiontrigger: "運行表達式",
        visibletrigger: "修改可見性"
    },
    peplaceholder: {
        patternmask: {
            pattern: "例如：+1（999）-999-99-99"
        },
        datetimemask: {
            pattern: "例：mm/dd/yyyy"
        },
        currencymask: {
            prefix: "例：$",
            suffix: "例如：美元"
        },
        panelbase: {
            questionTitleWidth: "例如：200px"
        }
    },
    pehelp: {
        panel: {
            name: "受訪者不可見的面板ID。",
            description: "鍵入面板字幕。",
            visibleIf: "使用魔棒圖示設置確定面板可見性的條件規則。",
            enableIf: "使用魔棒圖示設置禁用面板唯讀模式的條件規則。",
            requiredIf: "使用魔杖圖示設置條件規則，除非至少有一個嵌套問題有答案，否則該規則將阻止調查提交。",
            questionTitleLocation: "適用於此面板中的所有問題。如果要覆蓋此設置，請為單個問題定義標題對齊規則。“繼承”選項應用頁面級別（如果已設置）或調查級別設置（預設為“頂部”）。",
            questionTitleWidth: "當問題標題與問題框左側對齊時，為問題標題設置一致的寬度。接受 CSS 值（px、%、in、pt 等）。",
            questionErrorLocation: "設置與面板中所有問題相關的錯誤消息的位置。“繼承”選項應用頁面級別（如果已設置）或調查級別設置。",
            questionsOrder: "保持問題的原始順序或隨機化問題。“繼承”選項應用頁面級別（如果已設置）或調查級別設置。",
            page: "將面板重新置放到選頁面的末尾。",
            innerIndent: "在面板內容和面板框的左邊框之間添加空格或邊距。",
            startWithNewLine: "取消選擇以將面板與上一個問題或面板顯示在一行中。如果面板是表單中的第一個元素，則該設置不適用。",
            state: "從中選擇：「展開」 - 面板完整顯示，可以摺疊;“已摺疊” - 面板僅顯示標題和描述，可以展開;“已鎖定” - 面板完整顯示，無法摺疊。",
            width: "設置面板的寬度，使其與同一行中的其他測量圖元成比例。接受 CSS 值（px、%、in、pt 等）。"
        },
        paneldynamic: {
            name: "受訪者不可見的面板ID。",
            description: "鍵入面板字幕。",
            visibleIf: "使用魔棒圖示設置確定面板可見性的條件規則。",
            enableIf: "使用魔棒圖示設置禁用面板唯讀模式的條件規則。",
            requiredIf: "使用魔杖圖示設置條件規則，除非至少有一個嵌套問題有答案，否則該規則將阻止調查提交。",
            templateTitleLocation: "適用於此面板中的所有問題。如果要覆蓋此設置，請為單個問題定義標題對齊規則。“繼承”選項應用頁面級別（如果已設置）或調查級別設置（預設為“頂部”）。",
            templateErrorLocation: "設置與輸入無效的問題相關的錯誤消息的位置。選擇：「頂部」 - 錯誤文本放置在問題框的頂部;“底部” - 錯誤文本放置在問題框的底部。“繼承”選項應用頁面級別（如果已設置）或調查級別設置（預設為“頂部”）。",
            errorLocation: "設置與面板中所有問題相關的錯誤消息的位置。“繼承”選項應用頁面級別（如果已設置）或調查級別設置。",
            page: "將面板重新置放到選頁面的末尾。",
            innerIndent: "在面板內容和面板框的左邊框之間添加空格或邊距。",
            startWithNewLine: "取消選擇以將面板與上一個問題或面板顯示在一行中。如果面板是表單中的第一個元素，則該設置不適用。",
            state: "從中選擇：「展開」 - 面板完整顯示，可以摺疊;“已摺疊” - 面板僅顯示標題和描述，可以展開;“已鎖定” - 面板完整顯示，無法摺疊。",
            width: "設置面板的寬度，使其與同一行中的其他測量圖元成比例。接受 CSS 值（px、%、in、pt 等）。",
            templateTitle: "鍵入動態面板標題的範本。使用 {panelIndex} 作為面板的常規位置，使用 {visiblePanelIndex} 作為其在可見面板中的順序。將這些佔位元插入到圖案中以添加自動編號。",
            templateTabTitle: "鍵入選項卡標題的範本。使用 {panelIndex} 表示面板的大致位置，使用 {visiblePanelIndex} 表示其在可見面板中的順序。將這些佔位元插入到圖案中以添加自動編號。",
            tabTitlePlaceholder: "選項卡標題的回退文本，當選項卡標題模式未生成有意義的值時應用。",
            templateVisibleIf: "此設置允許您控制動態面板中各個面板的可見性。使用“{panel}”佔位符在運算式中引用當前面板。",
            titleLocation: "此面板中的所有問題都會自動繼承此設置。如果要覆蓋此設置，請為單個問題定義標題對齊規則。“繼承”選項應用頁面級別（如果已設置）或調查級別設置（預設為“頂部”）。",
            descriptionLocation: "“繼承”選項應用頁面級別（如果已設置）或調查級別設置（預設為“在面板標題下”）。",
            newPanelPosition: "定義新添加的面板的位置。默認情況下，新面板將添加到末尾。選擇「下一步」以在當前面板之後插入新面板。",
            defaultValueFromLastPanel: "複製上一個面板中的答案，並將其分配給下一個添加的動態面板。",
            keyName: "引用問題名稱以要求使用者在每個面板中為此問題提供唯一的答案。"
        },
        defaultValueExpression: "此設定允許您根據表示式分配預設答案值。表達式可以包括基本計算 - '{q1_id} + {q2_id}'、布爾表達式，例如 '{age} > 60'，以及函數：'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）'等。此表達式確定的值用作初始預設值，可由回應者的手動輸入覆蓋。",
        resetValueIf: "使用魔杖圖示設置條件規則，該規則確定何時將受訪者的輸入重置為基於“預設值表達式”或“設置值表達式”的值，或重置為“預設答案”值（如果設置了其中任何一個）。",
        setValueIf: "使用魔杖圖示設置條件規則，該規則確定何時運行「設置值表達式」 ，並將結果值動態分配為回應。",
        setValueExpression: "指定一個表達式，該運算式定義在滿足「如果設置值」規則中的條件時要設置的值。表達式可以包括基本計算 - '{q1_id} + {q2_id}'、布爾表達式，例如 '{age} > 60'，以及函數：'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）'等。由此表達式確定的值可以被受訪者的手動輸入覆蓋。",
        question: {
            name: "受訪者不可見的問題ID。",
            description: "鍵入問題副標題。",
            visibleIf: "使用魔杖圖示設置確定問題可見性的條件規則。",
            enableIf: "使用魔杖圖示設置條件規則，以禁用問題的唯讀模式。",
            requiredIf: "使用魔杖圖標設置條件規則，除非問題得到答案，否則阻止調查推進或提交。",
            startWithNewLine: "取消選擇以將問題與上一個問題或面板顯示在一行中。如果問題是表單中的第一個元素，則該設置不適用。",
            page: "將問題重新置放到選頁面的末尾。",
            state: "從以下選項中選擇：「展開」 - 問題框完整顯示，可以摺疊;“已摺疊” - 問題框僅顯示標題和描述，可以展開;“已鎖定” - 問題框完整顯示，無法摺疊。",
            titleLocation: "覆蓋在面板、頁面或調查級別上定義的標題對齊規則。“繼承”選項將應用任何更高級別的設置（如果已設置）或調查級別的設置（預設為“頂部”）。",
            descriptionLocation: "“繼承”選項應用調查級別設置（預設為“在問題標題下”）。",
            errorLocation: "設置與輸入無效的問題相關的錯誤消息的位置。選擇：「頂部」 - 錯誤文本放置在問題框的頂部;“底部” - 錯誤文本放置在問題框的底部。“繼承”選項將應用調查級別設置（預設為“頂部”）。",
            indent: "在問題內容和問題框的左邊框之間添加空格或邊距。",
            width: "設置問題的寬度，使其與同一行中的其他調查元素成比例。接受 CSS 值（px、%、in、pt 等）。",
            surveyvalidator: {
                expression: "使用魔杖圖示為問題設置驗證規則。"
            },
            textUpdateMode: "從中選擇：「失焦時」 - 當輸入字段失去焦點時，該值會更新;“鍵入時” - 當使用者鍵入時，該值會即時更新。“繼承”選項將應用調查級別設置（預設為“失去焦點時”）。",
            url: "您可以使用任何 Web 服務作為多項選擇題的數據來源。要填充選項值，請輸入提供數據的服務的URL。",
            searchMode: "用於篩選下拉清單的比較操作。",
            textWrapEnabled: "選項選項中的長文本將自動生成換行符以適合下拉功能表。如果要剪裁文字，請取消選擇。"
        },
        signaturepad: {
            signatureWidth: "設置顯示的簽名區域和生成的圖像的寬度。",
            signatureHeight: "設置顯示的簽名區域和生成的圖像的高度。",
            signatureAutoScaleEnabled: "選擇是否希望簽名區域填充問題框中的所有可用空間，同時保持預設的 3：2 縱橫比。設置自定義寬度和高度值后，該設置將保留這些尺寸的縱橫比。"
        },
        file: {
            imageHeight: "調整調查結果中圖像的高度。",
            imageWidth: "調整調查結果中圖像的寬度。"
        },
        image: {
            contentMode: "“自動”選項會根據提供的源URL自動確定適合的顯示模式 - 圖像、視頻或YouTube。"
        },
        imagepicker: {
            imageHeight: "覆蓋最小和最大高度值。",
            imageWidth: "覆蓋最小和最大寬度值。",
            choices: "“值”用作條件規則中使用的專案ID;向受訪者顯示“文本”。",
            contentMode: "在「圖像」和「視頻」之間進行選擇以設置媒體選擇器的內容模式。如果選擇「圖像」，請確保提供的所有選項都是以下格式的圖像檔：JPEG、GIF、PNG、APNG、SVG、BMP、ICO。同樣，如果選擇「視頻」，請確保所有選項都是指向以下格式的視頻檔的直接連結：MP4、MOV、WMV、FLV、AVI、MKV。請注意，視頻選項不支援 YouTube 連結。"
        },
        text: {
            size: "此設置僅調整輸入欄位的大小，不會影響問題框的寬度。要限制接受的輸入長度，請轉到<b>驗證→最大字元限制</b>。"
        },
        comment: {
            rows: "設置輸入欄位中顯示的行數。如果輸入佔用更多行，則會出現滾動條。"
        },
        // survey templates
        survey: {
            mode: "選擇：「可編輯」 - 使受訪者能夠填寫您的調查;“只讀” - 禁用表單編輯。"
        },
        matrixdropdowncolumn: {
            name: "受訪者不可見的列ID。",
            isUnique: "為列啟用后，受訪者需要為此列中的每個問題提供唯一的回答。",
            rows: "設置輸入欄位中顯示的行數。如果輸入佔用更多行，則會出現滾動條。",
            visibleIf: "使用魔杖圖示設置確定列可見性的條件規則。",
            enableIf: "使用魔杖圖示設置禁用列唯讀模式的條件規則。",
            requiredIf: "使用魔杖圖示設置條件規則，除非至少有一個嵌套問題有答案，否則該規則將阻止調查提交。",
            showInMultipleColumns: "選取後，為每個選項創建一個單獨的列。"
        },
        widthMode: "從以下選項中選擇： 「靜態」 - 設置固定寬度;“回應式” - 使調查佔據螢幕的整個寬度;“自動” - 根據所使用的問題類型應用兩者中的任何一個。",
        cookieName: "Cookie 可防止使用者兩次填寫同一調查問卷。",
        logo: "粘貼圖像連結（無大小限制）或按下資料夾圖示以瀏覽電腦中的檔（最大 64KB）。",
        logoWidth: "以 CSS 單位（px、%、in、pt 等）設置徽標寬度。",
        logoHeight: "以 CSS 單位（px、%、in、pt 等）設置徽標高度。",
        logoFit: "從以下選項中選擇：「無」 - 影像保持其原始大小;“包含” - 調整圖像大小以適應其縱橫比;“封面” - 圖像填充整個框，同時保持其縱橫比;“填充” - 拉伸圖像以填充框，而不保持其縱橫比。",
        goNextPageAutomatic: "選擇是否希望調查在受訪者回答當前頁面上的所有問題後自動前進到下一頁。",
        allowCompleteSurveyAutomatic: "選擇是否希望在受訪者回答所有問題後自動完成調查。",
        showNavigationButtons: "設置導航按鈕在頁面上的可見性和位置。",
        showProgressBar: "設置進度條的可見性和位置。“自動”值顯示測量標題上方或下方的進度條。",
        showPreviewBeforeComplete: "啟用僅包含所有問題或已回答問題的預覽頁面。",
        questionTitleLocation: "適用於調查中的所有問題。此設置可以被較低級別的標題對齊規則覆蓋：面板、頁面或問題。較低級別的設置將覆蓋較高級別的設置。",
        requiredText: "一個符號或一系列符號，表示需要答案。",
        questionStartIndex: "輸入要開始編號的數位或字母。",
        questionErrorLocation: "設置與輸入無效的問題相關的錯誤消息的位置。選擇：「頂部」 - 錯誤文本放置在問題框的頂部;“底部” - 錯誤文本放置在問題框的底部。",
        focusFirstQuestionAutomatic: "選擇是否希望每個頁面上的第一個輸入字段準備好進行文本輸入。",
        questionsOrder: "保持問題的原始順序或隨機化問題。此設置的效果僅在「預覽」選項卡中可見。",
        maxTextLength: "僅適用於文本輸入問題。",
        maxOthersLength: "僅供問題評論。",
        commentAreaRows: "設置問題註釋的文字區域中顯示的行數。在輸入佔用更多行時，將出現滾動條。",
        autoGrowComment: "選擇是否希望問題註釋和長文本問題根據輸入的文字長度自動增加高度。",
        allowResizeComment: "僅適用於問題評論和長文本問題。",
        calculatedValues: "自訂變數用作表單計算中使用的中間變數或輔助變數。他們將受訪者的輸入作為源值。每個自定義變數都有一個唯一的名稱和它所基於的表達式。",
        includeIntoResult: "選擇是否希望將表達式的計算值與調查結果一起保存。",
        triggers: "觸發器是基於表達式的事件或條件。一旦表達式被計算為「true」，觸發器就會觸發一個操作。這樣的操作可以選擇性地影響它的目標問題。",
        clearInvisibleValues: "選擇是否清除條件邏輯隱藏的問題的值以及何時清除。",
        textUpdateMode: "從中選擇：「失焦時」 - 當輸入字段失去焦點時，該值會更新;“鍵入時” - 當使用者鍵入時，該值會即時更新。",
        columns: "左邊的值用作條件規則中使用的列ID，右邊的值顯示給受訪者。",
        rows: "左邊的值用作條件規則中使用的行ID，右邊的值顯示給受訪者。",
        columnMinWidth: "接受 CSS 值（px、%、in、pt 等）。",
        rowTitleWidth: "接受 CSS 值（px、%、in、pt 等）。",
        totalText: "僅當至少一列具有 Total 類型或 Total 運算式時才可見。",
        cellErrorLocation: "設置與輸入無效的儲存格相關的錯誤訊息的位置。“繼承”選項應用“錯誤消息對齊”屬性中的設置。",
        keyDuplicationError: "啟用「防止重複響應」屬性後，嘗試提交重複條目的受訪者將收到以下錯誤消息。",
        totalExpression: "允許您根據表達式計算總值。表達式可以包括基本計算 （'{q1_id} + {q2_id}'）、布爾表達式 （'{age} > 60'） 和函數 （'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）' 等）。",
        confirmDelete: "觸發提示，要求確認刪除行。",
        defaultValueFromLastRow: "複製最後一行的答案，並將其分配給下一個添加的動態行。",
        keyName: "如果指定的列包含相同的值，則調查將引發「非唯一鍵值」錯誤。",
        description: "鍵入副標題。",
        locale: "選擇一種語言以開始創建調查。要添加翻譯，請切換到新語言，然後在此處或“翻譯”選項卡中翻譯原始文本。",
        detailPanelMode: "設置詳細資訊部分相對於行的位置。從中選擇：「無」 - 不添加擴展;“Under the row” - 矩陣的每一行下都放置一個行擴展;“在行下，僅顯示一行擴展” - 僅在單行下顯示擴展，其餘行展開將摺疊。",
        imageFit: "從以下選項中選擇：「無」 - 影像保持其原始大小;“包含” - 調整圖像大小以適應其縱橫比;“封面” - 圖像填充整個框，同時保持其縱橫比;“填充” - 拉伸圖像以填充框，而不保持其縱橫比。",
        autoGrow: "在輸入數據時逐漸增加輸入欄位的高度。覆蓋「輸入欄位高度（以行為單位）」設置。",
        allowResize: "調整大小的手柄（或手柄）出現在角落，可以拖動以更改輸入字段的大小。",
        maxTimeToFinish: "以秒為單位的時間間隔，在此時間間隔之後，調查將自動前進到“感謝”頁面。",
        maxTimeToFinishPage: "以秒為單位的時間間隔，在此時間間隔之後，調查將自動前進到下一頁。",
        page: {
            maxTimeToFinish: "以秒為單位的時間間隔，在此時間間隔之後，調查將自動前進到下一頁。",
            visibleIf: "使用魔杖圖示設置確定頁面可見性的條件規則。",
            enableIf: "使用魔杖圖示設置禁用頁面只讀模式的條件規則。",
            requiredIf: "使用魔杖圖示設置條件規則，除非至少有一個嵌套問題有答案，否則該規則將阻止調查提交。",
            questionTitleLocation: "適用於本頁中的所有問題。如果要覆蓋此設置，請為單個問題或面板定義標題對齊規則。“繼承”選項將應用調查級別設置（預設為“頂部”）。",
            questionTitleWidth: "當問題標題與問題框左側對齊時，為問題標題設置一致的寬度。接受 CSS 值（px、%、in、pt 等）。",
            questionErrorLocation: "設置與輸入無效的問題相關的錯誤消息的位置。選擇：「頂部」 - 錯誤文本放置在問題框的頂部;“底部” - 錯誤文本放置在問題框的底部。“繼承”選項將應用調查級別設置（預設為“頂部”）。",
            questionsOrder: "保持問題的原始順序或隨機化問題。繼承「選項應用調查級別設置（預設為」原始」。）。此設置的效果僅在「預覽」選項卡中可見。",
            navigationButtonsVisibility: "設置導航按鈕在頁面上的可見性。“繼承”選項應用調查級別設置，預設為“可見”。"
        },
        showTimerPanel: "設置計時器在頁面上的可見性和位置。",
        panelsState: "從以下選項中選擇：「鎖定」 - 使用者無法展開或摺疊面板;“全部摺疊” - 所有面板都以摺疊狀態啟動;“全部展開” - 所有面板都以展開狀態啟動;“首先展開” - 最初只有第一個面板被展開。",
        imageLinkName: "在物件陣列中輸入共用屬性名稱，該數位包含要在選項清單中顯示的圖像或視頻檔URL。",
        choices: "左邊的值用作條件規則中使用的專案ID，右邊的值顯示給受訪者。",
        title: "鍵入要顯示的使用者友好標題。",
        waitForUpload: "確保使用者在上傳檔之前不會完成調查。",
        minWidth: "接受 CSS 值（px、%、in、pt 等）。",
        maxWidth: "接受 CSS 值（px、%、in、pt 等）。",
        width: "接受 CSS 值（px、%、in、pt 等）。",
        valueName: "如果未設置此屬性，則答案將存儲在 Name 屬性指定的欄位中。",
        useDisplayValuesInDynamicTexts: "在單選題和多選題類型中，每個選項都有一個 ID 和顯示值。選中此設置后，將在 HTML 問題以及調查元素的動態標題和描述中顯示顯示值，而不是 ID 值。",
        clearIfInvisible: "選擇是否清除條件邏輯隱藏的問題值以及何時清除。“繼承”選項應用調查級別設置（預設為“完成調查後”）。",
        choicesFromQuestionMode: "從以下選項中選擇：「全部」 - 複製所選問題中的所有選項;“Selected” - 僅動態複製選定的選項選項;“未選擇” - 僅動態複製未選擇的選項。默認情況下，如果在源問題中啟用了“無”和“其他”選項，則會複製該選項。",
        showOtherItem: "選取後，使用者可以在單獨的註釋框中包含其他輸入。",
        separateSpecialChoices: "在新行上顯示每個特殊選項（“無”、“其他”、“全選”），即使使用多列佈局也是如此。",
        path: "指定服務數據集中目標物件陣列所在的位置。如果 URL 已指向陣列，則留空。",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "在物件陣列中輸入一個統一的屬性名稱，該陣列包含要在選項清單中顯示的值。",
        allowEmptyResponse: "選擇此選項可允許服務傳回空回應或陣列。",
        choicesVisibleIf: "使用魔杖圖示設置條件規則，以確定所有選項的可見性。",
        rateValues: "左邊的值用作條件規則中使用的專案ID，右邊的值顯示給受訪者。",
        rating: {
            displayMode: "“自動”根據可用寬度在“按鈕”和“下拉”模式之間進行選擇。當寬度不足以顯示按鈕時，問題將顯示一個下拉清單。"
        },
        valuePropertyName: "允許您連接以不同格式生成結果的問題。當使用聯接標識碼將此類問題連結在一起時，此共用屬性將存儲選定的問題值。",
        searchEnabled: "選擇是否要更新下拉功能表內容以匹配使用者在輸入欄位中鍵入的搜索查詢。",
        valueTrue: "當受訪者給出肯定答案時保存在調查結果中的值。",
        valueFalse: "當受訪者給出否定答案時保存在調查結果中的值。",
        showPreview: "不建議禁用此選項，因為它會覆蓋預覽圖像，並使用戶難以了解檔是否已上傳。",
        needConfirmRemoveFile: "觸發提示，要求確認文件刪除。",
        selectToRankEnabled: "啟用此選項可僅對選定的選項進行排名。使用者將從選項清單中拖動所選專案，以在排名區域內對它們進行排序。",
        dataList: "輸入將在輸入期間向受訪者建議的選項清單。",
        itemSize: "該設置僅調整輸入欄位的大小，不會影響問題框的寬度。",
        itemTitleWidth: "為所有項目標籤設定一致的寬度（以像素為單位）",
        altText: "當圖像無法在使用者設備上顯示時，出於輔助功能的目的，可作為替代。",
        rateColorMode: "定義當評級圖示類型設置為「笑臉」時所選表情符號的顏色。選擇：「預設」 - 選取表情符號以預設調查顏色顯示;“比例” - 所選的表情符號繼承了評分量表的顏色。",
        expression: {
            name: "受訪者不可見的表達式ID。",
            description: "鍵入表達式副標題。",
            expression: "表達式可以包括基本計算 （'{q1_id} + {q2_id}'）、條件 （'{age} > 60'） 和函數 （'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）' 等）。"
        },
        storeOthersAsComment: "選擇此選項可將「其他」選項值作為單獨的屬性存儲在調查結果中。",
        format: "使用 {0} 作為實際值的佔位元。",
        acceptedTypes: "有關詳細資訊，請參閱 [accept]（https://www.w3schools.com/tags/att_input_accept.asp） 屬性說明。",
        columnColCount: "僅適用於單選組和複選框單元類型。",
        autocomplete: "有關詳細資訊，請參閱 [autocomplete]（https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete） 屬性說明。",
        filePlaceholder: "當「源類型」為「本地檔」或相機不可用時適用",
        photoPlaceholder: "當「源類型」為「相機」時適用。",
        fileOrPhotoPlaceholder: "當「源類型」為「本地檔或相機」時適用。",
        masksettings: {
            saveMaskedValue: "選擇是否要在調查結果中存儲帶有應用掩碼的問題值。"
        },
        patternmask: {
            pattern: "該模式可以包含字串文字和以下佔位元： '9' - 表示數位;“a” - 表示大寫或小寫字母;'#' - 表示數位或大寫或小寫字母。使用反斜杠“\\”轉義字元。"
        },
        datetimemask: {
            pattern: "模式可以包含分隔符和以下佔位元：“<br>m”- 月份編號。<br>'mm' - 月份編號，前導零表示個位數值。<br>'d' - 月份中的某一天。<br>'dd' - 月份的某一天，個位數值的前導為零。<br>'yy' - 年份的最後兩位數位。<br>'yyyy' - 四位數年份。<br>“H” - 24 小時制的小時數。<br>“HH” - 24 小時制的小時數，個位數值的前導為零。<br>'h' - 以 12 小時為制的小時數。<br>'hh' - 12 小時制的小時數，個位數值的前導為零。<br>'MM' - 分鐘。<br>'ss' - 秒。<br>“TT” - 大寫 （AM/PM） 的 12 小時制週期。<br>'tt' - 小寫 （am/pm） 的 12 小時制週期。"
        },
        numericmask: {
            decimalSeparator: "用於將顯示數位的小數部分與整數部分分開的符號。",
            thousandsSeparator: "用於將大數的數位分成三組的符號。",
            precision: "限制顯示數位的小數點後要保留的位數。"
        },
        currencymask: {
            prefix: "要在值之前顯示的一個或多個符號。",
            suffix: "要在值后顯示的一個或多個符號。"
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "標題",
            title: "如果與名字相同，請設置為空值"
        },
        multiSelect: "允許多項選擇",
        showLabel: "顯示圖像標題",
        swapOrder: "交換“是”和“否”的順序",
        value: "價值",
        tabAlign: "製表元對齊方式",
        sourceType: "源類型",
        fitToContainer: "適合容器",
        setValueExpression: "設置值表達式",
        description: "說明",
        logoFit: "徽標合身",
        pages: "頁面",
        questions: "問題",
        triggers: "觸發器",
        calculatedValues: "計算值",
        surveyId: "調查編號",
        surveyPostId: "調查帖子編號",
        surveyShowDataSaving: "調查顯示數據保存",
        questionDescriptionLocation: "問題描述位置",
        progressBarType: "進度條類型",
        showTOC: "顯示目錄",
        tocLocation: "目錄位置",
        questionTitlePattern: "問題標題模式",
        widthMode: "寬度模式",
        showBrandInfo: "顯示品牌資訊",
        useDisplayValuesInDynamicTexts: "在動態文字中使用顯示值",
        visibleIf: "可見，如果",
        defaultValueExpression: "預設值表達式",
        requiredIf: "在以下情況下是必需的",
        resetValueIf: "如果出現以下情況，則重置值",
        setValueIf: "設置值，如果",
        validators: "驗證者",
        bindings: "綁定",
        renderAs: "渲染為",
        attachOriginalItems: "附加原始專案",
        choices: "選項",
        choicesByUrl: "Url選項",
        currency: "貨幣",
        cellHint: "單元格提示",
        totalMaximumFractionDigits: "最大小數位數總數",
        totalMinimumFractionDigits: "最小小數位數總數",
        columns: "列",
        detailElements: "細節元素",
        allowAdaptiveActions: "允許自適應操作",
        defaultRowValue: "預設行值",
        detailPanelShowOnAdding: "添加時顯示的詳細資訊面板",
        choicesLazyLoadEnabled: "選項延遲載入已啟用",
        choicesLazyLoadPageSize: "選擇延遲載入頁面大小",
        inputFieldComponent: "輸入欄位元件",
        itemComponent: "項目元件",
        min: "最小值",
        max: "麥克斯",
        minValueExpression: "最小值表達式",
        maxValueExpression: "最大值表達式",
        step: "步",
        dataList: "數據清單",
        itemSize: "專案大小",
        itemTitleWidth: "項目標籤寬度（以 px 為單位）",
        elements: "元素",
        content: "內容",
        navigationButtonsVisibility: "導航按鈕可見性",
        navigationTitle: "導航標題",
        navigationDescription: "導航說明",
        longTap: "長按",
        autoGrow: "自動增長",
        allowResize: "允許調整大小",
        acceptCarriageReturn: "接受回車",
        displayMode: "顯示模式",
        rateType: "費率類型",
        label: "標籤",
        contentMode: "內容模式",
        imageFit: "圖像貼合",
        altText: "可選文字",
        height: "高度",
        penColor: "筆顏色",
        backgroundColor: "背景色",
        templateElements: "範本元素",
        operator: "算子",
        isVariable: "是可變的",
        runExpression: "運行表達式",
        showCaption: "顯示標題",
        iconName: "圖示名稱",
        iconSize: "圖示大小",
        precision: "精度",
        matrixDragHandleArea: "矩陣拖動手柄區域",
        backgroundImage: "背景圖片",
        backgroundImageFit: "背景圖像適合",
        backgroundImageAttachment: "背景圖像附件",
        backgroundOpacity: "背景不透明度",
        selectToRankEnabled: "選擇啟用排名",
        selectToRankAreasLayout: "選擇以對區域佈局進行排名",
        selectToRankEmptyRankedAreaText: "顯示是否選擇了所有選項的文字",
        selectToRankEmptyUnrankedAreaText: "排名區域的佔位元文本",
        allowCameraAccess: "允許攝像頭訪問",
        scaleColorMode: "縮放顏色模式",
        rateColorMode: "評價顏色模式",
        copyDisplayValue: "複製顯示值",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "高級模式",
        pageTitle: "頁面標題字體",
        questionTitle: "問題標題字體",
        editorPanel: "輸入元素",
        lines: "線",
        primaryDefaultColor: "違約",
        primaryDarkColor: "懸停",
        primaryLightColor: "選擇",
        backgroundDimColor: "背景色",
        cornerRadius: "拐角半徑",
        backcolor: "默認背景",
        hovercolor: "懸停背景",
        borderDecoration: "邊框裝飾",
        fontColor: "字體顏色",
        backgroundColor: "背景顏色",
        primaryForecolor: "默認顏色",
        primaryForecolorLight: "禁用顏色",
        font: "字體",
        borderDefault: "暗",
        borderLight: "打火機",
        fontFamily: "字體家族",
        fontWeightRegular: "定期",
        fontWeightHeavy: "重",
        fontWeightSemiBold: "半粗體",
        fontWeightBold: "大膽",
        color: "顏色",
        placeholderColor: "佔位元顏色",
        size: "大小",
        opacity: "不透明度",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "添加陰影效果",
        boxShadowBlur: "模糊",
        boxShadowSpread: "傳播",
        boxShadowDrop: "落",
        boxShadowInner: "內",
        names: {
            default: "違約",
            sharp: "鋒利",
            borderless: "無國界",
            flat: "平",
            plain: "平原",
            doubleborder: "雙邊框",
            layered: "分層的",
            solid: "固體",
            threedimensional: "。.3D",
            contrast: "反差"
        },
        colors: {
            teal: "水鴨",
            blue: "藍",
            purple: "紫色",
            orchid: "蘭花",
            tulip: "鬱金香",
            brown: "棕色",
            green: "綠"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["zh-tw"] = traditionalChineseTranslation;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// survey.externalHelpLink: "Watch and learn how to create surveys" => "觀看並瞭解如何創建調查"
// survey.externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber" => "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber"
// survey.addLogicItem: "Create a rule to customize the flow of the survey." => "創建規則以自定義調查流。"
// survey.duplicate: "Duplicate" => "重複"
// survey.drag: "Drag element" => "拖動元素"
// qt.default: "Default" => "違約"
// qt.imagepicker: "Image Picker" => "圖像選取器"
// qt.ranking: "Ranking" => "排名"
// qt.image: "Image" => "圖像"
// qt.tagbox: "Multi-Select Dropdown" => "多選下拉清單"
// qt.signaturepad: "Signature" => "簽名"
// qt.buttongroup: "Button Group" => "按鈕組"
// ed.defaultLocale: "Default ({0})" => "預設值 （{0}）"
// ed.settings: "Settings" => "設置"
// ed.settingsTooltip: "Open settings" => "打開設置"
// ed.surveySettings: "Survey Settings" => "調查設置"
// ed.surveySettingsTooltip: "Open survey settings" => "打開調查設置"
// ed.showPanel: "Show Panel" => "顯示面板"
// ed.hidePanel: "Hide Panel" => "“隱藏”面板"
// ed.prevSelected: "Select previous" => "選擇上一個"
// ed.nextSelected: "Select next" => "選擇下一步"
// ed.surveyTypeName: "Survey" => "調查"
// ed.pageTypeName: "Page" => "頁"
// ed.panelTypeName: "Panel" => "面板"
// ed.questionTypeName: "Question" => "問題"
// ed.columnTypeName: "Column" => "列"
// ed.moveRight: "Scroll to the Right" => "向右滾動"
// ed.moveLeft: "Scroll to the Left" => "向左滾動"
// ed.edit: "Edit" => "編輯"
// ed.newTextItemName: "text" => "發簡訊"
// ed.themeSurvey: "Themes" => "主題"
// ed.defaultV2Theme: "Default" => "違約"
// ed.modernTheme: "Modern" => "摩登"
// ed.defaultTheme: "Default (legacy)" => "預設（舊版）"
// ed.navigateToMsg: "You had to navigate to" => "你必須導航到"
// ed.logic: "Logic" => "邏輯"
// ed.translation: "Translation" => "譯本"
// ed.saveSurveyTooltip: "Save Survey" => "保存調查"
// ed.jsonHideErrors: "Hide errors" => "隱藏錯誤"
// ed.jsonShowErrors: "Show errors" => "顯示錯誤"
// ed.undoTooltip: "Undo last change" => "恢復上次更改"
// ed.redoTooltip: "Redo the change" => "重做更改"
// ed.showMoreChoices: "Show more" => "顯示更多"
// ed.showLessChoices: "Show less" => "顯示更少"
// ed.copy: "Copy" => "複製"
// ed.cut: "Cut" => "切"
// ed.paste: "Paste" => "糊"
// ed.copyTooltip: "Copy selection to clipboard" => "將選取內容複製到剪貼簿"
// ed.cutTooltip: "Cut selection to clipboard" => "將所選取內容剪下剪貼簿"
// ed.pasteTooltip: "Paste from clipboard" => "從剪貼簿粘貼"
// ed.property-grid: "Properties" => "性能"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "鍵入以搜尋..."
// ed.surveyResultsTable: "As Table" => "如表"
// ed.surveyResultsJson: "As JSON" => "作為 JSON"
// ed.resultsTitle: "Question Title" => "問題標題"
// ed.resultsName: "Question Name" => "問題名稱"
// ed.resultsValue: "Answer Value" => "答案值"
// ed.resultsDisplayValue: "Display Value" => "顯示值"
// ed.propertyEditorError: "Error" => "錯誤"
// ed.saveError: "Error! Editor content is not saved." => "錯誤！不保存編輯器內容。"
// ed.translationPropertyGridTitle: "Language Settings" => "語言設置"
// ed.themePropertyGridTitle: "Theme Settings" => "主題設置"
// ed.translationLanguages: "Languages" => "語言"
// ed.translationAddLanguage: "Select language to translate" => "選擇要翻譯的語言"
// ed.translationShowAllStrings: "All Strings" => "所有字串"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "僅使用的字串"
// ed.translationShowAllPages: "All Pages" => "所有頁面"
// ed.translationNoStrings: "No strings to translate. Please, change the filter." => "沒有要翻譯的字串。請更換過濾器。"
// ed.translationExportToSCVButton: "Export to CSV" => "匯出為CSV"
// ed.translationImportFromSCVButton: "Import from CSV" => "從 CSV 導入"
// ed.translationMergeLocaleWithDefault: "Merge {0} with default locale" => "將{0}與預設區域設置合併"
// ed.translationPlaceHolder: "Translation..." => "譯本。。。"
// ed.themeExportButton: "Export" => "出口"
// ed.themeImportButton: "Import" => "進口"
// ed.bold: "Bold" => "大膽"
// ed.italic: "Italic" => "斜體的"
// ed.underline: "Underline" => "下劃線"
// ed.addNewQuestion: "Add Question" => "添加問題"
// ed.selectPage: "Select page..." => "選擇頁面..."
// ed.carryForwardChoicesCopied: "Choices are copied from" => "選擇是從"
// ed.htmlPlaceHolder: "HTML content will be here." => "HTML內容將在這裡。"
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "在此處從工具箱中刪除問題。"
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "調查為空。從工具箱中拖動元素或按下下面的按鈕。"
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "將圖像拖放到此處或按下下面的按鈕並選擇要上傳的圖像"
// ed.imageChooseImage: "Choose Image" => "選擇圖像"
// ed.addNewTypeQuestion: "Add {0}" => "新增{0}"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[徽標]"
// ed.auto: "auto" => "自動"
// ed.choices_Item: "Item " => "專案"
// lg.addNewItem: "Add New Rule" => "添加新規則"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "創建規則以自定義調查流。"
// lg.page_visibilityName: "Show (hide) page" => "顯示（隱藏）頁面"
// lg.page_enableName: "Enable (disable) page" => "啟用（禁用）頁面"
// lg.panel_visibilityName: "Show (hide) panel" => "“顯示（隱藏）”面板"
// lg.panel_enableName: "Enable (disable) panel" => "啟用（禁用）面板"
// lg.question_visibilityName: "Show (hide) question" => "顯示（隱藏）問題"
// lg.question_enableName: "Enable (disable) question" => "啟用（禁用）問題"
// lg.question_requireName: "Make question required" => "提出必填題"
// lg.column_visibilityName: "Show (hide) column" => "顯示（隱藏）列"
// lg.column_enableName: "Enable (disable) column" => "啟用（禁用）列"
// lg.column_requireName: "Make column required" => "使列成為必填項"
// lg.trigger_completeName: "Complete survey" => "完成調查"
// lg.trigger_setvalueName: "Set answer" => "設置答案"
// lg.trigger_copyvalueName: "Copy answer" => "複製答案"
// lg.trigger_skipName: "Skip to question" => "跳至問題"
// lg.trigger_runExpressionName: "Run expression" => "運行表達式"
// lg.completedHtmlOnConditionName: "Set \"Survey Complete\" page markup" => "設置「調查完成」頁面標記"
// lg.page_visibilityDescription: "Make the page visible when the logic expression returns true. Otherwise keep it invisible." => "使頁面在邏輯表示式返回 true 時可見。否則保持不可見。"
// lg.panel_visibilityDescription: "Make the panel visible when the logic expression returns true. Otherwise keep it invisible." => "使面板在邏輯表達式返回 true 時可見。否則保持不可見。"
// lg.panel_enableDescription: "Make the panel, and all elements inside it, enable when the logic expression returns true. Otherwise keep them disabled." => "使面板及其中的所有元素在邏輯表達式返回 true 時啟用。否則，請禁用它們。"
// lg.question_visibilityDescription: "Make the question visible when the logic expression returns true. Otherwise keep it invisible." => "使問題在邏輯表達式返回 true 時可見。否則保持不可見。"
// lg.question_enableDescription: "Make the question enable when the logic expression returns true. Otherwise keep it disabled." => "使問題在邏輯表達式返回 true 時啟用。否則將其禁用。"
// lg.question_requireDescription: "Question becomes required when the logic expression returns true." => "當邏輯表達式返回 true 時，問題變為必需。"
// lg.trigger_completeDescription: "When the logic expression returns true then the survey becomes completed and an end-user see the 'Thank you page'." => "當邏輯表達式返回 true 時，調查將完成，最終使用者將看到“謝謝頁面”。"
// lg.trigger_setvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value is set to the selected question." => "當邏輯表達式中使用的問題值發生更改並且邏輯表達式返回 true 時，該值將設置為所選問題。"
// lg.trigger_copyvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value of one selected question is copied to another selected question." => "當邏輯表達式中使用的問題值發生更改並且邏輯表達式返回 true 時，一個選定問題的值將複製到另一個選定問題。"
// lg.trigger_skipDescription: "When the logic expression returns true then the survey skip to / focus the selected question." => "當邏輯表達式返回 true 時，調查將跳到/聚焦所選問題。"
// lg.trigger_runExpressionDescription: "When the logic expression returns true, then the custom expression is performed. You may optionally set this expression result into the selected question" => "當邏輯表達式返回 true 時，將執行自定義表示式。您可以選擇將此表示式結果設置為選取問題"
// lg.completedHtmlOnConditionDescription: "If the logic expression returns true, then the default text for the 'Thank you page' is changed to the given one." => "如果邏輯表達式返回 true，則「感謝頁面」的預設文本將更改為給定的文本。"
// lg.itemExpressionText: "When expression: '{0}' returns true" => "當表達式：「{0}」返回 true"
// lg.itemEmptyExpressionText: "New rule" => "新規則"
// lg.page_visibilityText: "make page {0} visible" => "使頁面{0}可見"
// lg.panel_visibilityText: "make panel {0} visible" => "使面板{0}可見"
// lg.panel_enableText: "make panel {0} enable" => "使面板{0}啟用"
// lg.question_visibilityText: "make question {0} visible" => "使問題{0}可見"
// lg.question_enableText: "make question {0} enable" => "使問題{0}啟用"
// lg.question_requireText: "make question {0} required" => "將問題{0}為必填項"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "使問題{1}的列{0}可見"
// lg.column_enableText: "make column {0} of question {1} enable" => "使問題{1}列{0}啟用"
// lg.column_requireText: "make column {0} of question {1} required" => "{0}將問題{1}列為必填項"
// lg.trigger_completeText: "survey becomes completed" => "調查完成"
// lg.trigger_setvalueText: "set into question: {0} value {1}" => "受到質疑：{0}價值{1}"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "明確問題值：{0}"
// lg.trigger_copyvalueText: "copy into question: {0} value from question {1}" => "複製到問題：{0}問題 {1} 的值"
// lg.trigger_skipText: "survey skip to the question {0}" => "調查 跳至問題{0}"
// lg.trigger_runExpressionText1: "run expression: '{0}'" => "運行表達式：“{0}”"
// lg.trigger_runExpressionText2: " and set its result into question: {0}" => "並質疑其結果：{0}"
// lg.completedHtmlOnConditionText: "show custom text for the 'Thank you page'." => "顯示「感謝頁面」的自定義文字。"
// lg.showAllQuestions: "All Questions" => "所有問題"
// lg.showAllActionTypes: "All Action Types" => "所有操作類型"
// lg.conditions: "Condition(s)" => "條件"
// lg.actions: "Action(s)" => "操作 （s）"
// lg.expressionEditorTitle: "Define condition(s)" => "定義條件"
// lg.actionsEditorTitle: "Define action(s)" => "定義操作"
// lg.deleteAction: "Delete Action" => "刪除操作"
// lg.addNewAction: "Add Action" => "添加操作"
// lg.selectedActionCaption: "Select action..." => "選擇操作..."
// lg.expressionInvalid: "The logic expression is empty or invalid. Please correct it." => "邏輯表達式為空或無效。請更正。"
// lg.noActionError: "Please, add at least one action." => "請至少添加一個操作。"
// lg.actionInvalid: "Please, fix problems in your action(s)." => "請解決操作中的問題。"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "邏輯規則不完整"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "您尚未完成某些邏輯規則。如果現在離開該選項卡，更改將丟失。是否仍要離開選項卡而不完成更改？"
// lg.uncompletedRule_apply: "Yes" => "是的"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "不，我想完成規則"
// pe.save: "Save" => "救"
// pe.clear: "Clear" => "清楚"
// pe.saveTooltip: "Save" => "救"
// pe.set: "Set" => "設置"
// pe.change: "Change" => "改變"
// pe.refresh: "Refresh" => "刷新"
// pe.add: "Add" => "加"
// pe.addItem: "Click to add an item..." => "點選以新增專案..."
// pe.removeItem: "Click to remove the item..." => "按下以刪除該專案..."
// pe.dragItem: "Drag the item" => "拖動專案"
// pe.addOther: "Other" => "其他"
// pe.addSelectAll: "Select All" => "全選"
// pe.addNone: "None" => "沒有"
// pe.back: "Return without saving" => "退貨而不保存"
// pe.backTooltip: "Return without saving" => "退貨而不保存"
// pe.saveAndBack: "Save and return" => "保存並返回"
// pe.saveAndBackTooltip: "Save and return" => "保存並返回"
// pe.doneEditing: "Done" => "做"
// pe.editChoices: "Edit Choices" => "編輯選項"
// pe.showChoices: "Show Choices" => "顯示選項"
// pe.move: "Move" => "移動"
// pe.emptyValue: "Value is empty" => "值為空"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "值“{0}”不是唯一的"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "請將項目數量限制在{0}到{1}"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "您可以按以下格式設定資料：\n值 1|文本\n值2"
// pe.itemSelectorEmpty: "Please select the element" => "請選擇元素"
// pe.conditionActionEmpty: "Please select the action" => "請選擇操作"
// pe.conditionSelectQuestion: "Select question..." => "選擇問題..."
// pe.conditionSelectPage: "Select page..." => "選擇頁面..."
// pe.conditionSelectPanel: "Select panel..." => "選擇面板..."
// pe.conditionValueQuestionTitle: "Please enter/select the value" => "請輸入/選擇值"
// pe.aceEditorHelp: "Press ctrl+space to get expression completion hint" => "按 ctrl+空格鍵獲取表達式完成提示"
// pe.aceEditorRowTitle: "Current row" => "當前行"
// pe.aceEditorPanelTitle: "Current panel" => "當前面板"
// pe.assistantTitle: "Available questions" => "可用問題"
// pe.cellsEmptyRowsColumns: "There is should be at least one column or row" => "至少應該有一列或一行"
// pe.showPreviewBeforeComplete: "Preview answers before submitting the survey" => "在提交調查之前預覽答案"
// pe.overridingPropertyPrefix: "Set by " => "設置者"
// pe.propertyIsNoUnique: "Please enter a unique value" => "請輸入唯一值"
// pe.propertyNameIsNotUnique: "Please enter a unique name" => "請輸入唯一名稱"
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "不要使用保留字：「專案」、「選項」、「面板」、“行”。"
// pe.listIsEmpty: "No items have been added yet" => "尚未添加任何專案"
// pe.listIsEmpty@choices: "No choices have been added yet" => "尚未添加任何選項"
// pe.addNew@choices: "Add a choice" => "添加選項"
// pe.expressionIsEmpty: "Expression is empty" => "表達式為空"
// pe.rowid: "Row ID" => "行標識"
// pe.imageLink: "Image or video URL" => "圖片或視頻網址"
// choicesbyurl.valueName: "Get values from the following JSON field" => "從以下 JSON 欄位中獲取值"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "從以下 JSON 欄位獲取影像網址"
// pe.allowEmptyResponse: "Allow empty response" => "允許空回應"
// pe.titlePlaceholder: "Title" => "標題"
// pe.surveyTitlePlaceholder: "Survey Title" => "調查標題"
// pe.pageTitlePlaceholder: "Page {num}" => "頁數 {num}"
// pe.descriptionPlaceholder: "Description" => "描述"
// pe.surveyDescriptionPlaceholder: "Description" => "描述"
// pe.pageDescriptionPlaceholder: "Description" => "描述"
// pe.showNoneItem: "Allow the None option" => "允許“無”選項"
// pe.noneText: "None option text" => "無選項文字"
// pe.showSelectAllItem: "Allow the Select All option" => "允許「全選」選項"
// pe.selectAllText: "Select All option text" => "全選選項文本"
// pe.choicesMin: "Minimum value for auto-generated items" => "自動生成項的最小值"
// pe.choicesMax: "Maximum value for auto-generated items" => "自動生成項的最大值"
// pe.choicesStep: "Step for auto-generated items" => "自動生成項的步驟"
// pe.isAllRowRequired: "Require answer for all rows" => "要求所有行都回答"
// pe.requiredErrorText: "\"Required\" error message" => "“必需”錯誤消息"
// pe.cols: "Columns" => "列"
// pe.columnLayout: "Columns layout" => "列佈局"
// pe.addRowLocation: "Add Row button location" => "“添加行”按鈕位置"
// pe.rateMin: "Minimum rate value" => "最低速率值"
// pe.rateMax: "Maximum rate value" => "最大速率值"
// pe.rateStep: "Rate step" => "速率步長"
// pe.defaultValue: "Default Answer" => "默認答案"
// pe.cellsDefaultRow: "Default texts" => "預設文字"
// pe.surveyEditorTitle: "Edit survey settings" => "編輯調查設置"
// pe.maxLength: "Maximum length (in characters)" => "最大長度（字元）"
// pe.buildExpression: "Build" => "建"
// pe.editExpression: "Edit" => "編輯"
// pe.and: "and" => "和"
// pe.or: "or" => "或"
// pe.remove: "Remove" => "刪除"
// pe.addCondition: "Add Condition" => "添加條件"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "選擇一個問題以開始配置條件。"
// pe.if: "If" => "如果"
// pe.then: "then" => "然後"
// pe.setToName: "Target question" => "目標問題"
// pe.fromName: "Question to copy answer from" => "要從中複製答案的問題"
// pe.gotoName: "Question to skip to" => "要跳到的問題"
// pe.ruleIsNotSet: "Rule is incorrect" => "規則不正確"
// pe.includeIntoResult: "Include into survey results" => "包含在調查結果中"
// pe.expandCollapseTitle: "Expand/collapse title" => "展開/摺疊標題"
// pe.simulator: "Select device type" => "選擇設備類型"
// pe.landscapeOrientation: "Switch to landscape orientation" => "切換到橫向"
// pe.portraitOrientation: "Switch to portrait orientation" => "切換到縱向"
// pe.previewText: "Preview Answers button text" => "「預覽答案」按鈕文本"
// pe.editText: "Edit Answer button text" => "編輯應答按鈕文本"
// image.imageHeight: "Image height (in CSS-accepted values)" => "圖片高度（以 CSS 接受的值為單位）"
// image.imageWidth: "Image width (in CSS-accepted values)" => "影像寬度（以 CSS 接受的值為單位）"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "完成頁面的時間限制（秒為單位 ）"
// question.page: "Parent page" => "父頁面"
// pe.noEntriesText: "Empty entries text" => "空條目文本"
// pe.html: "HTML markup" => "網頁標記"
// pe.expression: "Expression" => "表達"
// pe.setValue: "Answer" => "答"
// pe.dataFormat: "Image format" => "圖像格式"
// pe.allowAddRows: "Allow adding rows" => "允許添加行"
// pe.allowRemoveRows: "Allow removing rows" => "允許刪除行"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "允許行拖放"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "如果指定確切的圖像寬度或高度，則不適用。"
// pe.minImageWidth: "Minimum image width" => "最小圖像寬度"
// pe.maxImageWidth: "Maximum image width" => "最大圖像寬度"
// pe.minImageHeight: "Minimum image height" => "最小圖像高度"
// pe.maxImageHeight: "Maximum image height" => "最大圖像高度"
// pe.minValue: "Minimum value" => "最小值"
// pe.maxValue: "Maximum value" => "最大值"
// pe.minLength: "Minimum length (in characters)" => "最小長度（以字元為單位）"
// pe.allowDigits: "Allow digits" => "允許數位"
// pe.minCount: "Minimum count" => "最小計數"
// pe.maxCount: "Maximum count" => "最大計數"
// pe.regex: "Regular expression" => "正則表達式"
// surveyvalidator.text: "Error message" => "錯誤資訊"
// surveyvalidator.expression: "Validation expression" => "驗證表達式"
// pe.totalText: "Total row text" => "總計行文本"
// pe.totalType: "Total type" => "總類型"
// pe.totalExpression: "Total expression" => "總表達"
// pe.totalDisplayStyle: "Total value display style" => "總值顯示樣式"
// pe.totalCurrency: "Currency" => "貨幣"
// pe.totalFormat: "Formatted string" => "帶格式的字串"
// pe.logo: "Logo (URL or base64-encoded string)" => "徽標（URL 或base64 編碼的字串）"
// pe.questionsOnPageMode: "Survey structure" => "調查結構"
// pe.maxTextLength: "Maximum answer length (in characters)" => "最大答案長度（以字元為單位）"
// pe.maxOthersLength: "Maximum comment length (in characters)" => "最大註解長度（以字元為單位）"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "如有必要，自動展開評論區域"
// pe.allowResizeComment: "Allow users to resize text areas" => "允許用戶調整文字區域的大小"
// pe.textUpdateMode: "Update text question value" => "更新文字問題值"
// pe.focusOnFirstError: "Set focus on the first invalid answer" => "將焦點放在第一個無效答案上"
// pe.checkErrorsMode: "Run validation" => "運行驗證"
// pe.navigateToUrl: "Navigate to URL" => "導航到網址"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "動態網址"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "用於顯示使用者是否已填寫此調查的標記"
// pe.completedHtml: "Survey Complete page markup" => "調查完成頁面標記"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "動態調查完成頁面標記"
// pe.loadingHtml: "Markup to show while survey model is loading" => "載入調查模型時要顯示的標記"
// pe.commentText: "Comment area text" => "註釋區文本"
// pe.autocomplete: "Autocomplete type" => "自動完成類型"
// pe.labelTrue: "\"True\" label" => "“真實”標籤"
// pe.labelFalse: "\"False\" label" => "“虛假”標籤"
// pe.allowClear: "Show the Clear button" => "顯示“清除”按鈕"
// pe.displayStyle: "Value display style" => "值顯示樣式"
// pe.format: "Formatted string" => "帶格式的字串"
// pe.maximumFractionDigits: "Maximum fractional digits" => "最大小數位數"
// pe.minimumFractionDigits: "Minimum fractional digits" => "最小小數位數"
// pe.useGrouping: "Display grouping separators" => "顯示分組分隔符"
// pe.allowMultiple: "Allow multiple files" => "允許多個檔"
// pe.allowImagesPreview: "Preview images" => "預覽圖像"
// pe.acceptedTypes: "Accepted file types" => "接受的文件類型"
// pe.waitForUpload: "Wait for the upload to complete" => "等待上傳完成"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "確認文件刪除"
// pe.detailPanelMode: "Detail panel location" => "詳細資訊面板位置"
// pe.minRowCount: "Minimum row count" => "最小行數"
// pe.maxRowCount: "Maximum row count" => "最大行數"
// pe.confirmDelete: "Confirm row deletion" => "確認刪除行"
// pe.confirmDeleteText: "Confirmation message" => "確認消息"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "確認面板刪除"
// pe.panelCount: "Initial panel count" => "初始面板計數"
// pe.minPanelCount: "Minimum panel count" => "最小面板數"
// pe.maxPanelCount: "Maximum panel count" => "最大面板數"
// pe.panelsState: "Inner panel expand state" => "內面板展開狀態"
// pe.templateDescription: "Description template" => "描述範本"
// pe.templateTitle: "Title template" => "標題範本"
// pe.panelPrevText: "Previous Panel button tooltip" => "“上一個面板”按鈕工具提示"
// pe.panelNextText: "Next Panel button tooltip" => "“下一個面板”按鈕工具提示"
// pe.showRangeInProgress: "Show progress bar" => "顯示進度條"
// pe.templateTitleLocation: "Question title location" => "問題標題位置"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "“刪除面板”按鈕位置"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "如果沒有行，則隱藏問題"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "如果沒有行，則隱藏列"
// pe.rateValues: "Custom rate values" => "自定義費率值"
// pe.rateCount: "Rate count" => "速率計數"
// pe.autoGenerate: "How to specify rate values?" => "如何指定速率值？"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "如果問題不包含任何選項，則隱藏問題"
// pe.hideNumber: "Hide question number" => "隱藏問題編號"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "最小寬度（以 CSS 接受的值為單位）"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "最大寬度（以 CSS 接受的值為單位）"
// pe.width: "Width (in CSS-accepted values)" => "寬度（以 CSS 接受的值為單位）"
// pe.showHeader: "Show column headers" => "顯示列標題"
// pe.horizontalScroll: "Show horizontal scrollbar" => "顯示水平滾動條"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "最小列寬（以 CSS 接受的值為單位）"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "行標題寬度（以 CSS 接受的值為單位）"
// pe.valueTrue: "\"True\" value" => "“真”值"
// pe.valueFalse: "\"False\" value" => "“假”值"
// pe.minErrorText: "\"Value is below minimum\" error message" => "“值低於最小值”錯誤消息"
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "“值超過最大值”錯誤消息"
// pe.otherErrorText: "\"Empty comment\" error message" => "“空評論”錯誤消息"
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "“非唯一鍵值”錯誤消息"
// pe.minSelectedChoices: "Minimum selected choices" => "最少選擇的選項"
// pe.maxSelectedChoices: "Maximum selected choices" => "最大選定選項數"
// pe.showClearButton: "Show the Clear button" => "顯示“清除”按鈕"
// pe.showNumber: "Show panel number" => "顯示面板編號"
// pe.logoWidth: "Logo width (in CSS-accepted values)" => "徽標寬度（以 CSS 接受的值為單位）"
// pe.logoHeight: "Logo height (in CSS-accepted values)" => "徽標高度（以 CSS 接受的值為單位）"
// pe.readOnly: "Read-only" => "唯讀"
// pe.enableIf: "Editable if" => "可編輯，如果"
// pe.emptyRowsText: "\"No rows\" message" => "“無行”消息"
// pe.size: "Input field size (in characters)" => "輸入欄位大小（以字元為單位 ）"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "單獨的特殊選項（無、其他、全選）"
// pe.choicesFromQuestion: "Copy choices from the following question" => "複製以下問題的選項"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "要複製哪些選項？"
// pe.showCommentArea: "Show the comment area" => "顯示評論區域"
// pe.commentPlaceholder: "Comment area placeholder" => "註釋區佔位元"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "將速率描述顯示為極值"
// pe.rowsOrder: "Row order" => "行順序"
// pe.columnsLayout: "Column layout" => "列佈局"
// pe.columnColCount: "Nested column count" => "嵌套列計數"
// pe.state: "Panel expand state" => "面板展開狀態"
// pe.correctAnswer: "Correct Answer" => "正確答案"
// pe.defaultPanelValue: "Default Values" => "預設值"
// pe.cells: "Cell Texts" => "單元格文本"
// pe.keyName: "Key column" => "鍵列"
// itemvalue.text: "Alt text" => "可選文字"
// pe.logoPosition: "Logo position" => "徽標位置"
// pe.addLogo: "Add logo..." => "新增徽標..."
// pe.changeLogo: "Change logo..." => "變更徽標..."
// logoPositions.none: "Remove logo" => "刪除徽標"
// logoPositions.left: "Left" => "左"
// logoPositions.right: "Right" => "右"
// logoPositions.top: "On the top" => "在頂部"
// logoPositions.bottom: "In the bottom" => "在底部"
// tabs.items: "Items" => "專案"
// tabs.requiredIf: "Required If" => "如果"
// tabs.numbering: "Numbering" => "編號"
// tabs.pages: "Pages" => "頁面"
// tabs.calculatedValues: "Calculated Values" => "計算值"
// tabs.triggers: "Triggers" => "觸發器"
// tabs.templateTitle: "Title template" => "標題範本"
// tabs.totals: "Totals" => "總數"
// tabs.logic: "Logic" => "邏輯"
// tabs.layout: "Layout" => "佈局"
// tabs.data: "Data" => "數據"
// tabs.validation: "Validation" => "驗證"
// tabs.cells: "Cell Texts" => "單元格文本"
// tabs.showOnCompleted: "Survey Complete" => "調查完成"
// tabs.logo: "Logo in Survey Title" => "調查標題中的徽標"
// tabs.slider: "Slider" => "滑塊"
// tabs.expression: "Expression" => "表達"
// tabs.others: "Others" => "別人"
// pe.choicesVisibleIf: "Choices are visible if" => "在以下情況下，選項可見"
// pe.choicesEnableIf: "Choices are selectable if" => "在以下情況下，可以選擇選項"
// pe.columnsEnableIf: "Columns are visible if" => "在以下情況下，列可見"
// pe.rowsEnableIf: "Rows are visible if" => "在以下情況下，行可見"
// pe.indent: "Add indents" => "添加縮進"
// panel.indent: "Add outer indents" => "添加外部縮進"
// pe.innerIndent: "Add inner indents" => "添加內部縮進"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "從最後一行獲取預設值"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "從最後一個面板中獲取預設值"
// pe.titleKeyboardAdornerTip: "Press enter button to edit" => "按回車鍵編輯"
// pe.keyboardAdornerTip: "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item" => "按回車鍵編輯專案，按刪除按鈕刪除專案，按Alt加向上箭頭或向下箭頭移動專案"
// pe.triggerFromName: "Copy value from: " => "從以下位置複製值："
// pe.triggerRunExpression: "Run this Expression" => "運行此表達式"
// pe.triggerGotoName: "Go to the question" => "轉到問題"
// pe.triggerRunExpressionEmpty: "Please enter a valid expression" => "請輸入有效的表達式"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "在這裡鍵入表示式..."
// pe.noFile: "No file choosen" => "未選擇任何檔"
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "如果問題被隱藏，則清除該值"
// pe.valuePropertyName: "Value property name" => "值屬性名稱"
// pe.searchEnabled: "Enable search" => "啟用搜索"
// pe.hideSelectedItems: "Hide selected items" => "隱藏選取選取專案"
// pe.closeOnSelect: "Close the dropdown after selection" => "選擇後關閉下拉清單"
// pe.signatureWidth: "Signature width" => "簽名寬度"
// pe.signatureHeight: "Signature height" => "標誌性高度"
// pe.verticalAlign: "Vertical alignment" => "垂直對齊"
// pe.alternateRows: "Alternate rows" => "交替行"
// pe.columnsVisibleIf: "Columns are visible if" => "在以下情況下，列可見"
// pe.rowsVisibleIf: "Rows are visible if" => "在以下情況下，行可見"
// pe.otherPlaceholder: "Comment area placeholder" => "註釋區佔位元"
// pe.rateType: "Rate type" => "費率類型"
// pv.true: "true" => "真"
// pv.false: "false" => "假"
// pv.inherit: "Inherit" => "繼承"
// pv.show: "Visible" => "可見"
// pv.hide: "Hidden" => "隱藏"
// pv.default: "Inherit" => "繼承"
// pv.initial: "Initial" => "初"
// pv.random: "Random" => "隨機"
// pv.collapsed: "Collapsed" => "倒塌"
// pv.expanded: "Expanded" => "擴大"
// pv.none: "None" => "沒有"
// pv.asc: "Ascending" => "上升"
// pv.desc: "Descending" => "降"
// pv.indeterminate: "Indeterminate" => "定"
// pv.decimal: "decimal" => "十進位"
// pv.currency: "currency" => "貨幣"
// pv.percent: "percent" => "百分之"
// pv.firstExpanded: "First panel is expanded" => "第一個面板展開"
// pv.off: "Hide question numbers" => "隱藏問題編號"
// pv.onpanel: "Start on each panel" => "在每個面板上開始"
// pv.onPanel: "Start on each panel" => "在每個面板上開始"
// pv.onSurvey: "Continue throughout the survey" => "在整個調查過程中繼續"
// pv.list: "List" => "清單"
// pv.progressTop: "Panel navigator + Progress bar at the top" => "面板導航器 + 頂部的進度條"
// pv.progressBottom: "Panel navigator + Progress bar at the bottom" => "面板導航器 + 底部的進度條"
// pv.progressTopBottom: "Panel navigator + Progress bar at the top and bottom" => "面板導航器 + 頂部和底部的進度條"
// pv.tab: "Tabs" => "製表元"
// pv.horizontal: "Horizontal" => "水準"
// pv.vertical: "Vertical" => "垂直"
// pv.top: "Top" => "返回頁首"
// pv.bottom: "Bottom" => "底"
// pv.topBottom: "Top and bottom" => "頂部和底部"
// pv.both: "Both" => "雙"
// pv.left: "Left" => "左"
// pv.right: "Right" => "右"
// pv.color: "color" => "顏色"
// pv.date: "date" => "日期"
// pv.datetime: "datetime" => "日期時間"
// pv.datetime-local: "datetime-local" => "日期時間-本地"
// pv.email: "email" => "電子郵件"
// pv.month: "month" => "月"
// pv.number: "number" => "數"
// pv.password: "password" => "密碼"
// pv.range: "range" => "範圍"
// pv.tel: "tel" => "電話"
// pv.text: "text" => "發簡訊"
// pv.time: "time" => "時間"
// pv.url: "url" => "網址"
// pv.week: "week" => "周"
// pv.hidden: "Hidden" => "隱藏"
// pv.on: "Continue from the previous page" => "從上一頁繼續"
// pv.onPage: "Start on each page" => "從每個頁面開始"
// pv.edit: "Editable" => "編輯"
// pv.display: "Read-only" => "唯讀"
// pv.onComplete: "When the survey is completed" => "調查完成時"
// pv.onHidden: "When the question becomes hidden" => "當問題變得隱藏時"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "當問題或其面板/頁面被隱藏時"
// clearInvisibleValues.none: "Never" => "從不"
// inputType.color: "Color" => "顏色"
// inputType.date: "Date" => "日期"
// inputType.datetime-local: "Date and Time" => "日期和時間"
// inputType.email: "Email" => "電子郵件"
// inputType.month: "Month" => "月"
// inputType.number: "Number" => "數"
// inputType.password: "Password" => "密碼"
// inputType.range: "Range" => "範圍"
// inputType.tel: "Phone Number" => "電話號碼"
// inputType.text: "Text" => "發簡訊"
// inputType.time: "Time" => "時間"
// inputType.url: "URL" => "網址"
// inputType.week: "Week" => "周"
// pv.all: "All" => "都"
// pv.page: "Page" => "頁"
// pv.survey: "Survey" => "調查"
// pv.onNextPage: "When switching to the next page" => "切換到下一頁時"
// pv.onValueChanged: "After an answer is changed" => "更改答案後"
// pv.onValueChanging: "Before an answer is changed" => "更改答案之前"
// pv.standard: "Original structure" => "原始結構"
// pv.singlePage: "All questions on a single page" => "所有問題都在一個頁面上"
// pv.questionPerPage: "Each question on an individual page" => "單個頁面上的每個問題"
// pv.noPreview: "No preview" => "無預覽"
// pv.showAllQuestions: "Show all questions" => "顯示所有問題"
// pv.showAnsweredQuestions: "Show answered questions only" => "僅顯示已回答的問題"
// pv.pages: "Completed pages" => "已完成的頁面"
// pv.questions: "Answered questions" => "已回答的問題"
// pv.requiredQuestions: "Answered required questions" => "回答必填問題"
// pv.correctQuestions: "Valid answers" => "有效答案"
// pv.buttons: "Completed pages (button UI)" => "已完成的頁面（按鈕 UI）"
// pv.underInput: "Under the input" => "在輸入下"
// pv.underTitle: "Under the title" => "在標題下"
// pv.onBlur: "On blur" => "模糊時"
// pv.onTyping: "While typing" => "打字時"
// pv.underRow: "Under the row" => "在行下"
// pv.underRowSingle: "Under the row, only one panel is visible" => "在該行下，只有一個面板可見"
// showNavigationButtons.none: "Hidden" => "隱藏"
// showProgressBar.off: "Hidden" => "隱藏"
// showTimerPanel.none: "Hidden" => "隱藏"
// showTimerPanelMode.all: "Both" => "雙"
// detailPanelMode.none: "Hidden" => "隱藏"
// addRowLocation.default: "Depends on matrix layout" => "取決於矩陣佈局"
// panelsState.default: "Users cannot expand or collapse panels" => "使用者無法展開或摺疊面板"
// panelsState.collapsed: "All panels are collapsed" => "所有面板均已摺疊"
// panelsState.expanded: "All panels are expanded" => "所有面板均已展開"
// widthMode.auto: "Auto" => "自動"
// widthMode.static: "Static" => "靜態的"
// widthMode.responsive: "Responsive" => "回應"
// imageFit.none: "None" => "沒有"
// imageFit.contain: "Contain" => "包含"
// imageFit.cover: "Cover" => "蓋"
// imageFit.fill: "Fill" => "填補"
// contentMode.auto: "Auto" => "自動"
// contentMode.image: "Image" => "圖像"
// contentMode.video: "Video" => "視頻"
// contentMode.youtube: "YouTube" => "優酷"
// displayMode.auto: "Auto" => "自動"
// displayMode.buttons: "Buttons" => "按鈕"
// displayMode.dropdown: "Dropdown" => "下拉清單"
// rateColorMode.default: "Default" => "違約"
// autoGenerate.true: "Generate" => "生成"
// autoGenerate.false: "Enter manually" => "手動輸入"
// rateType.labels: "Labels" => "標籤"
// rateType.stars: "Stars" => "星星"
// rateType.smileys: "Smileys" => "笑臉"
// op.anyof: "Any of" => "任何"
// op.allof: "All of" => "全部"
// op.and: "and" => "和"
// op.or: "or" => "或"
// ew.modern: "Modern theme" => "現代主題"
// ew.default: "Default theme" => "默認主題"
// ew.orange: "Orange theme" => "橙色主題"
// ew.darkblue: "Darkblue theme" => "深藍色主題"
// ew.darkrose: "Darkrose theme" => "“暗玫瑰”主題"
// ew.stone: "Stone theme" => "“石頭”主題"
// ew.winter: "Winter theme" => "“冬季”主題"
// ew.winterstone: "Winter-Stone theme" => "“冬日之石”主題"
// ts.selectPage: "Select the page to test it" => "選擇要測試的頁面"
// ts.showInvisibleElements: "Show invisible elements" => "顯示不可見元素"
// ts.hideInvisibleElements: "Hide invisible elements" => "隱藏不可見元素"
// validators.expressionvalidator: "Expression" => "表達"
// triggers.copyvaluetrigger: "Copy answer" => "複製答案"
// triggers.skiptrigger: "Skip to question" => "跳至問題"
// triggers.runexpressiontrigger: "Run expression" => "運行表達式"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Cookie 可防止使用者兩次填寫同一調查問卷。"
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "調整輸入欄位的可見區域的大小。請使用<b>「驗證→最大長度</b>」設置來限制輸入長度。"
// pehelp.format: "Use {0} as a placeholder for the actual value." => "使用 {0} 作為實際值的佔位元。"
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "僅當至少一列具有 Total 類型或 Total 運算式時才可見。"
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "有關詳細資訊，請參閱 [accept]（https://www.w3schools.com/tags/att_input_accept.asp） 屬性說明。"
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "僅適用於單選組和複選框單元類型。"
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "有關詳細資訊，請參閱 [autocomplete]（https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete） 屬性說明。"
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "如果未設置此屬性，則答案將存儲在 Name 屬性指定的欄位中。"
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "如果指定的列包含相同的值，則調查將引發「非唯一鍵值」錯誤。"
// p.multiSelect: "Allow multiple selection" => "允許多項選擇"
// p.showLabel: "Show image captions" => "顯示圖像標題"
// p.value: "Value" => "價值"
// p.tabAlign: "Tab alignment" => "製表元對齊方式"
// p.logoFit: "Logo fit" => "徽標合身"
// p.pages: "Pages" => "頁面"
// p.questions: "Questions" => "問題"
// p.triggers: "Triggers" => "觸發器"
// p.calculatedValues: "Calculated values" => "計算值"
// p.surveyId: "Survey id" => "調查編號"
// p.surveyPostId: "Survey post id" => "調查帖子編號"
// p.surveyShowDataSaving: "Survey show data saving" => "調查顯示數據保存"
// p.questionDescriptionLocation: "Question description location" => "問題描述位置"
// p.progressBarType: "Progress bar type" => "進度條類型"
// p.showTOC: "Show TOC" => "顯示目錄"
// p.tocLocation: "Toc location" => "目錄位置"
// p.questionTitlePattern: "Question title pattern" => "問題標題模式"
// p.widthMode: "Width mode" => "寬度模式"
// p.showBrandInfo: "Show brand info" => "顯示品牌資訊"
// p.useDisplayValuesInDynamicTexts: "Use display values in dynamic texts" => "在動態文字中使用顯示值"
// p.visibleIf: "Visible if" => "可見，如果"
// p.titleLocation: "Title location" => "標題位置"
// p.descriptionLocation: "Description location" => "描述位置"
// p.defaultValueExpression: "Default value expression" => "預設值表達式"
// p.requiredIf: "Required if" => "在以下情況下是必需的"
// p.validators: "Validators" => "驗證者"
// p.bindings: "Bindings" => "綁定"
// p.renderAs: "Render as" => "渲染為"
// p.attachOriginalItems: "Attach original items" => "附加原始專案"
// p.currency: "Currency" => "貨幣"
// p.cellHint: "Cell hint" => "單元格提示"
// p.isUnique: "Is unique" => "是獨一無二的"
// p.showInMultipleColumns: "Show in multiple columns" => "在多列中顯示"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "最大小數位數總數"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "最小小數位數總數"
// p.columns: "Columns" => "列"
// p.detailElements: "Detail elements" => "細節元素"
// p.allowAdaptiveActions: "Allow adaptive actions" => "允許自適應操作"
// p.defaultRowValue: "Default row value" => "預設行值"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "添加時顯示的詳細資訊面板"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "選項延遲載入已啟用"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "選擇延遲載入頁面大小"
// p.inputFieldComponent: "Input field component" => "輸入欄位元件"
// p.itemComponent: "Item component" => "項目元件"
// p.min: "Min" => "最小值"
// p.max: "Max" => "麥克斯"
// p.minValueExpression: "Min value expression" => "最小值表達式"
// p.maxValueExpression: "Max value expression" => "最大值表達式"
// p.step: "Step" => "步"
// p.dataList: "Data list" => "數據清單"
// p.itemSize: "Item size" => "專案大小"
// p.elements: "Elements" => "元素"
// p.content: "Content" => "內容"
// p.navigationButtonsVisibility: "Navigation buttons visibility" => "導航按鈕可見性"
// p.navigationTitle: "Navigation title" => "導航標題"
// p.navigationDescription: "Navigation description" => "導航說明"
// p.longTap: "Long tap" => "長按"
// p.autoGrow: "Auto grow" => "自動增長"
// p.allowResize: "Allow resizing" => "允許調整大小"
// p.acceptCarriageReturn: "Accept carriage return" => "接受回車"
// p.displayMode: "Display mode" => "顯示模式"
// p.rateType: "Rate type" => "費率類型"
// p.label: "Label" => "標籤"
// p.contentMode: "Content mode" => "內容模式"
// p.imageFit: "Image fit" => "圖像貼合"
// p.altText: "Alt text" => "可選文字"
// p.height: "Height" => "高度"
// p.penColor: "Pen color" => "筆顏色"
// p.backgroundColor: "Background color" => "背景色"
// p.templateElements: "Template elements" => "範本元素"
// p.operator: "Operator" => "算子"
// p.isVariable: "Is variable" => "是可變的"
// p.runExpression: "Run expression" => "運行表達式"
// p.showCaption: "Show caption" => "顯示標題"
// p.iconName: "Icon name" => "圖示名稱"
// p.iconSize: "Icon size" => "圖示大小"
// p.precision: "Precision" => "精度"
// p.matrixDragHandleArea: "Matrix drag handle area" => "矩陣拖動手柄區域"
// p.backgroundImage: "Background image" => "背景圖片"
// p.backgroundImageFit: "Background image fit" => "背景圖像適合"
// p.backgroundImageAttachment: "Background image attachment" => "背景圖像附件"
// p.backgroundOpacity: "Background opacity" => "背景不透明度"
// p.selectToRankEnabled: "Select to rank enabled" => "選擇啟用排名"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "選擇以對區域佈局進行排名"
// p.allowCameraAccess: "Allow camera access" => "允許攝像頭訪問"
// p.scaleColorMode: "Scale color mode" => "縮放顏色模式"
// p.rateColorMode: "Rate color mode" => "評價顏色模式"
// p.templateTabTitle: "Template tab title" => "範本選項卡標題"
// p.templateVisibleIf: "Template visible if" => "範本可見，如果"
// p.copyDisplayValue: "Copy display value" => "複製顯示值"
// theme.--background: "Background color" => "背景色"
// theme.--background-dim-light: "Background dim light color" => "背景昏暗的光線顏色"
// theme.--primary-foreground: "Primary foreground color" => "原色前景色"
// theme.--foreground: "Foreground color" => "前景色"
// theme.--base-unit: "Base unit" => "基本單元"
// theme.groupAdvanced: "Advanced" => "高深"
// theme.themeName: "Theme" => "主題"
// theme.isPanellessss: "Question appearance" => "問題外觀"
// theme.isPanellessPanels: "Default" => "違約"
// theme.isPanellessLightweight: "Without Panels" => "不帶面板"
// theme.themePaletteLight: "Light" => "光"
// theme.themePaletteDark: "Dark" => "黑暗"
// theme.primaryColor: "Accent color" => "強調文字顏色"
// theme.primaryDefaultColor: "Default" => "違約"
// theme.primaryDarkColor: "Hover" => "懸停"
// theme.primaryLightColor: "Selected" => "選擇"
// theme.backgroundDimColor: "Background color" => "背景色"
// theme.backgroundImage: "Background image" => "背景圖片"
// theme.backgroundImageFitAuto: "Auto" => "自動"
// theme.backgroundImageFitCover: "Cover" => "蓋"
// theme.backgroundImageFitContain: "Contain" => "包含"
// theme.backgroundOpacity: "Opacity" => "不透明度"
// theme.backgroundImageAttachmentFixed: "Fixed" => "固定"
// theme.backgroundImageAttachmentScroll: "Scroll" => "滾動"
// theme.panelBackgroundTransparency: "Panel background opacity" => "面板背景不透明度"
// theme.questionBackgroundTransparency: "Question background opacity" => "問題背景不透明度"
// theme.questionPanel: "Panel background and corner radius" => "面板背景和角半徑"
// theme.questionTitle: "Question title font" => "問題標題字體"
// theme.questionDescription: "Question description font" => "問題描述字體"
// theme.editorPanel: "Input element" => "輸入元素"
// theme.editorFont: "Input element font" => "輸入元素字體"
// theme.backcolor: "Default background" => "默認背景"
// theme.hovercolor: "Hover background" => "懸停背景"
// theme.borderDecoration: "Border decoration" => "邊框裝飾"
// theme.accentBackground: "Accent background" => "強調文字背景"
// theme.accentForeground: "Accent foreground" => "強調文字前景"
// theme.primaryForecolor: "Default color" => "默認顏色"
// theme.primaryForecolorLight: "Disabled color" => "禁用顏色"
// theme.linesColors: "Minor line colors" => "次要線條顏色"
// theme.borderDefault: "Darker" => "暗"
// theme.borderLight: "Lighter" => "打火機"
// theme.fontFamily: "Font family" => "字體系列"
// theme.fontSize: "Font size" => "字體大小"
// theme.color: "Color" => "顏色"
// theme.size: "Size" => "大小"
// theme.fontWeightRegular: "Regular" => "定期"
// theme.fontWeightHeavy: "Heavy" => "重"
// theme.fontWeightSemiBold: "Semi-bold" => "半粗體"
// theme.fontWeightBold: "Bold" => "大膽"
// theme.scale: "Scale" => "規模"
// theme.cornerRadius: "Corner radius" => "拐角半徑"
// theme.surveyTitleFont: "Survey title font" => "調查標題字體"
// theme.pageTitle: "Page title font" => "頁面標題字體"
// theme.pageDescription: "Page description font" => "頁面描述字體"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "添加陰影效果"
// theme.opacity: "Opacity" => "不透明度"
// theme.boxShadowBlur: "Blur" => "模糊"
// theme.boxShadowSpread: "Spread" => "傳播"
// theme.boxShadowDrop: "Drop" => "落"
// theme.boxShadowInner: "Inner" => "內"
// theme.questionShadow: "Shadow effects" => "陰影效果"
// theme.editorShadow: "Input element shadow effects" => "輸入元素陰影效果"
// names.default: "Default" => "違約"
// names.contrast: "Contrast" => "反差"
// names.plain: "Plain" => "平原"
// names.simple: "Simple" => "簡單"
// names.blank: "Blank" => "空白"
// names.double: "Double" => "雙"
// names.bulk: "Bulk" => "散裝"
// names.pseudo-3d: "Pseudo 3D" => "偽 3D"
// names.playful: "Playful" => "好玩"
// names.ultra: "Ultra" => "超"
// colors.teal: "Teal" => "水鴨"
// colors.blue: "Blue" => "藍"
// colors.purple: "Purple" => "紫色"
// colors.orchid: "Orchid" => "蘭花"
// colors.tulip: "Tulip" => "鬱金香"
// colors.brown: "Brown" => "棕色"
// colors.green: "Green" => "綠"
// names.sharp: "Sharp" => "鋒利"
// names.borderless: "Borderless" => "無國界"
// names.flat: "Flat" => "平"
// names.doubleborder: "Double Border" => "雙邊框"
// names.layered: "Layered" => "分層的"
// names.solid: "Solid" => "固體"
// names.threedimensional: "3D" => "。.3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "您確定要刪除此語言的所有字串嗎？"
// ed.themeResetButton: "Reset theme settings to default" => "將主題設置重置為預設值"
// theme.placeholderColor: "Placeholder color" => "佔位元顏色"
// ed.themeSettings: "Theme Settings" => "主題設置"
// ed.themeSettingsTooltip: "Open theme settings" => "打開主題設置"
// pe.resetToDefaultCaption: "Reset" => "重置"
// pv.file: "Local files" => "本地檔"
// pv.camera: "Camera" => "照相機"
// pv.file-camera: "Local files or camera" => "本地檔或相機"
// ed.translateUsigAI: "Auto-translate All" => "自動翻譯全部"
// ed.translationDialogTitle: "Untranslated strings" => "未翻譯的字串"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "請輸入至少{0}專案"
// lg.question_resetValueName: "Reset question value" => "重置問題值"
// lg.column_resetValue: "Reset column value" => "重置列值"
// pe.markRequired: "Mark as required" => "標記為必填"
// pe.removeRequiredMark: "Remove the required mark" => "刪除所需的標記"
// p.resetValueIf: "Reset value if" => "如果出現以下情況，則重置值"
// lg.question_setValueName: "Set question value" => "設置問題值"
// lg.column_resetValueName: "Reset column value" => "重置列值"
// lg.column_setValueName: "Set column value" => "設置列值"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => "其結果將分配給目標問題的表達式。"
// survey.title: "Title" => "標題"
// page.title: "Title" => "標題"
// p.setValueIf: "Set value if" => "設置值，如果"
// theme.header: "Header" => "頁眉"
// theme.backgroundImageFitFill: "Stretch" => "伸展"
// theme.backgroundImageFitTile: "Tile" => "瓦"
// theme.headerView: "View" => "視圖"
// theme.headerViewBasic: "Basic" => "基本"
// theme.headerViewAdvanced: "Advanced" => "高深"
// theme.headerInheritWidthFrom: "Content area width" => "內容區域寬度"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "與調查相同"
// theme.headerInheritWidthFromPage: "Fit to page" => "適合頁面"
// theme.headerTextAreaWidth: "Text width" => "文本寬度"
// theme.headerBackgroundColorSwitch: "Background color" => "背景色"
// theme.headerBackgroundColorNone: "None" => "沒有"
// theme.headerBackgroundColorAccentColor: "Accent color" => "強調文字顏色"
// theme.headerBackgroundColorCustom: "Custom" => "習慣"
// theme.horizontalAlignmentLeft: "Left" => "左"
// theme.horizontalAlignmentCenter: "Center" => "中心"
// theme.horizontalAlignmentRight: "Right" => "右"
// theme.verticalAlignmentTop: "Top" => "返回頁首"
// theme.verticalAlignmentMiddle: "Middle" => "中間"
// theme.verticalAlignmentBottom: "Bottom" => "底"
// lg.question_resetValueText: "reset value for question: {0}" => "重置問題的值：{0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "分配值：{1}問題：{0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "重置列的儲存格值：{0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "將儲存格值：{1}分配給列：{0}"
// ed.surveyJsonExportButton: "Export" => "出口"
// ed.surveyJsonImportButton: "Import" => "進口"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "複製到剪貼板"
// pe.filePlaceholder: "File placeholder text" => "檔佔位元文本"
// pe.photoPlaceholder: "Photo placeholder text" => "照片占位元文本"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "檔或照片佔位元文字"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "當「源類型」為「本地檔」或相機不可用時適用"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "當「源類型」為「相機」時適用。"
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "當「源類型」為「本地檔或相機」時適用。"
// theme.background: "Background" => "背景"
// theme.appearance: "Appearance" => "外觀"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "你真的要重置主題嗎？您的所有自定義項都將丟失。"
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "是，重置主題"
// theme.headerInheritWidthFromContainer: "Fit to container" => "適合容器"
// signaturepad.showPlaceholder: "Show the placeholder" => "顯示佔位元"
// signaturepad.placeholder: "Placeholder text" => "佔位元文本"
// theme.surveyDescriptionFont: "Survey description font" => "調查描述字體"
// ed.prevFocus: "Focus previous" => "焦點 上一頁"
// ed.nextFocus: "Focus next" => "接下來的重點"
// ed.saveTheme: "Save Theme" => "保存主題"
// ed.saveThemeTooltip: "Save Theme" => "保存主題"
// lg.page_requireName: "Make page required" => "將頁面設為必填項"
// lg.panel_requireName: "Make page required" => "將頁面設為必填項"
// signaturepad.signatureWidth: "Signature area width" => "簽名區域寬度"
// signaturepad.signatureHeight: "Signature area height" => "簽名區域高度"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "自動縮放簽名區域"
// signaturepad.penMinWidth: "Minimum pen width" => "最小筆寬"
// signaturepad.penMaxWidth: "Maximum pen width" => "最大筆寬"
// theme.logoPosition: "Logo position" => "徽標位置"
// theme.headerTitlePosition: "Title position" => "職稱位置"
// theme.headerDescriptionPosition: "Description position" => "描述位置"
// ed.propertyGridNoResultsFound: "No results found" => "未找到結果"
// pv.leftRight: "Left and right" => "左和右"
// p.sourceType: "Source type" => "源類型"
// p.fitToContainer: "Fit to container" => "適合容器"
// p.setValueExpression: "Set value expression" => "設置值表達式"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "選項是從 Web 服務載入的。"
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "前往“設置”"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "載入選項的預覽"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "防止行中出現重複回應"
// theme.advancedMode: "Advanced mode" => "高級模式"
// theme.backgroundCornerRadius: "Background and corner radius" => "背景和圓角半徑"
// theme.colorsTitle: "Colors" => "顏色"
// theme.font: "Font" => "字體"
// theme.lines: "Lines" => "線"
// theme.titleFont: "Title font" => "標題字體"
// theme.descriptionFont: "Description font" => "描述字體"
// theme.shadow: "Shadow effects" => "陰影效果"
// ed.translateUsigAIFrom: "Translate from: " => "翻譯語言組合："
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "允許「拒絕應答」選項"
// pe.showDontKnowItem: "Allow the Don't Know option" => "允許“不知道”選項"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "允許「拒絕應答」選項"
// pe.showDontKnowItem: "Allow the Don't Know option" => "允許“不知道”選項"
// pv.contain: "Contain" => "包含"
// pv.cover: "Cover" => "蓋"
// pv.fill: "Fill" => "填補"
// pe.transposeData: "Transpose rows to columns" => "將行轉置為列"
// layout.panel: "Layout" => "佈局"
// layout.question: "Layout" => "佈局"
// layout.base: "Layout" => "佈局"
// panel.name: "Panel name" => "面板名稱"
// panel.title: "Panel title" => "面板標題"
// panel.description: "Panel description" => "面板說明"
// panel.visibleIf: "Make the panel visible if" => "如果出現以下情況，則使面板可見"
// panel.requiredIf: "Make the panel required if" => "如果出現以下情況，則使面板成為必需的"
// panel.questionsOrder: "Question order within the panel" => "小組內的問題順序"
// panel.startWithNewLine: "Display the panel on a new line" => "在新行上顯示面板"
// panel.state: "Panel collapse state" => "面板摺疊狀態"
// panel.width: "Inline panel width" => "內嵌面板寬度"
// panel.minWidth: "Minimum panel width" => "最小面板寬度"
// panel.maxWidth: "Maximum panel width" => "最大面板寬度"
// panel.showNumber: "Number panels" => "數字面板"
// paneldynamic.name: "Panel name" => "面板名稱"
// paneldynamic.title: "Panel title" => "面板標題"
// paneldynamic.description: "Panel description" => "面板說明"
// paneldynamic.visibleIf: "Make the panel visible if" => "如果出現以下情況，則使面板可見"
// paneldynamic.requiredIf: "Make the panel required if" => "如果出現以下情況，則使面板成為必需的"
// paneldynamic.page: "Move the panel to page" => "將面板移動到頁面"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "在新行上顯示面板"
// paneldynamic.state: "Panel collapse state" => "面板摺疊狀態"
// paneldynamic.width: "Inline panel width" => "內嵌面板寬度"
// paneldynamic.minWidth: "Minimum panel width" => "最小面板寬度"
// paneldynamic.maxWidth: "Maximum panel width" => "最大面板寬度"
// paneldynamic.templateDescription: "Panel description pattern" => "面板描述模式"
// paneldynamic.templateTitle: "Panel title pattern" => "面板標題模式"
// paneldynamic.noEntriesText: "Empty panel text" => "空面板文本"
// paneldynamic.templateTabTitle: "Tab title pattern" => "選項卡標題模式"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "如果出現以下情況，則使單個面板可見"
// paneldynamic.hideNumber: "Hide the panel number" => "隱藏面板編號"
// paneldynamic.titleLocation: "Panel title alignment" => "面板標題對齊方式"
// paneldynamic.descriptionLocation: "Panel description alignment" => "面板描述對齊方式"
// paneldynamic.templateTitleLocation: "Question title alignment" => "問題標題對齊方式"
// paneldynamic.templateErrorLocation: "Error message alignment" => "錯誤消息對齊"
// paneldynamic.newPanelPosition: "New panel location" => "新面板位置"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "防止在以下問題中重複回答"
// question.name: "Question name" => "問題名稱"
// question.title: "Question title" => "問題標題"
// question.description: "Question description" => "問題描述"
// question.visibleIf: "Make the question visible if" => "如果出現以下情況，請使問題可見"
// question.requiredIf: "Make the question required if" => "如果出現以下情況，則將問題設為必填項"
// question.state: "Question box collapse state" => "問題框摺疊狀態"
// question.hideNumber: "Hide the question number" => "隱藏問題編號"
// question.titleLocation: "Question title alignment" => "問題標題對齊方式"
// question.descriptionLocation: "Question description alignment" => "問題描述對齊方式"
// question.errorLocation: "Error message alignment" => "錯誤消息對齊"
// question.indent: "Increase the inner indent" => "增加內部縮進"
// question.width: "Inline question width" => "內聯問題寬度"
// question.minWidth: "Minimum question width" => "最小問題寬度"
// question.maxWidth: "Maximum question width" => "最大問題寬度"
// question.textUpdateMode: "Update input field value" => "更新輸入欄位值"
// signaturepad.allowClear: "Show the Clear button within signature area" => "在簽名區域內顯示「清除」 按鈕"
// signaturepad.penColor: "Stroke color" => "描邊顏色"
// comment.rows: "Input field height (in lines)" => "輸入欄位高度（以行為單位）"
// expression.name: "Expression name" => "表達式名稱"
// expression.title: "Expression title" => "表達式標題"
// expression.description: "Expression description" => "表達式說明"
// expression.expression: "Expression" => "表達"
// trigger.expression: "Expression" => "表達"
// calculatedvalue.expression: "Expression" => "表達"
// survey.description: "Survey description" => "調查說明"
// page.name: "Page name" => "頁面名稱"
// page.description: "Page description" => "頁面描述"
// page.visibleIf: "Make the page visible if" => "如果出現以下情況，則使頁面可見"
// page.requiredIf: "Make the page required if" => "如果出現以下情況，則使頁面為必填項"
// page.questionsOrder: "Question order on the page" => "頁面上的問題順序"
// matrixdropdowncolumn.name: "Column name" => "列名稱"
// matrixdropdowncolumn.title: "Column title" => "專欄標題"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "防止重複回應"
// matrixdropdowncolumn.width: "Column width" => "列寬"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "最小列寬"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "輸入欄位高度（以行為單位）"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "如果出現以下情況，則使列可見"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "如果滿足以下條件，則使該列為必填項"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "每個選項都在單獨的列中"
// multipletextitem.name: "Name" => "名字"
// multipletextitem.title: "Title" => "標題"
// pe.rateDescriptionLocation: "Label alignment" => "標籤對齊"
// pe.cellErrorLocation: "Cell error message alignment" => "單元格錯誤消息對齊方式"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "您還沒有任何列"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "您還沒有任何行"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "尚無任何驗證規則"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "您還沒有任何自訂變數"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "您還沒有任何觸發器"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "您還沒有任何連結"
// pe.addNew@columns: "Add new column" => "添加新列"
// pe.addNew@rows: "Add new row" => "添加新行"
// pe.addNew@validators: "Add new rule" => "添加新規則"
// pe.addNew@calculatedValues: "Add new variable" => "添加新變數"
// pe.addNew@triggers: "Add new trigger" => "添加新觸發器"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "添加新 URL"
// choicesbyurl.url: "Web service's URL" => "Web 服務的 URL"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "在進度條中顯示頁面標題"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "在進度條中顯示頁碼"
// itemvalue.visibleIf: "Make the option visible if" => "如果出現以下情況，則使該選項可見"
// itemvalue.enableIf: "Make the option selectable if" => "如果出現以下情況，則使該選項可選"
// panel.layout: "Panel Layout" => "面板佈局"
// tabs.questionSettings: "Question Settings" => "問題設置"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "例如：https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "例如：categories.fiction"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "例如：a）"
// pe.width_placeholder: "Ex.: 6in" => "例：6in"
// pe.minWidth_placeholder: "Ex.: 600px" => "例如：600px"
// pe.maxWidth_placeholder: "Ex.: 50%" => "例：50%"
// pv.selected: "Selected" => "選擇"
// pv.unselected: "Unselected" => "未選中"
// pv.center: "Center" => "中心"
// pv.middle: "Middle" => "中間"
// pv.next: "Next" => "下一個"
// pv.last: "Last" => "最後"
// clearIfInvisible.none: "Never" => "從不"
// questionsOnPageMode.standard: "Original structure" => "原始結構"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "在一個頁面上顯示所有問題"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "每頁顯示一個問題"
// pv.auto: "Auto" => "自動"
// panelsState.firstExpanded: "First expanded" => "首次擴展"
// rateColorMode.scale: "Scale" => "規模"
// scaleColorMode.monochrome: "Monochrome" => "單色"
// scaleColorMode.colored: "Colored" => "彩色"
// state.default: "Locked" => "鎖"
// showQuestionNumbers.default: "Auto-numbering" => "自動編號"
// showQuestionNumbers.on: "Auto-numbering" => "自動編號"
// showQuestionNumbers.onPage: "Reset on each page" => "在每個頁面上重置"
// showQuestionNumbers.onpanel: "Reset on each panel" => "在每個面板上重置"
// showQuestionNumbers.onPanel: "Reset on each panel" => "在每個面板上重置"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "在整個調查中繼續"
// showQuestionNumbers.off: "No numbering" => "無編號"
// descriptionLocation.underTitle: "Under the question title" => "在問題標題下"
// descriptionLocation.underInput: "Under the input field" => "在輸入欄位下"
// selectToRankAreasLayout.horizontal: "Next to choices" => "在選項旁邊"
// selectToRankAreasLayout.vertical: "Above choices" => "以上選擇"
// displayStyle.decimal: "Decimal" => "十進位"
// displayStyle.currency: "Currency" => "貨幣"
// displayStyle.percent: "Percentage" => "百分比"
// displayStyle.date: "Date" => "日期"
// totalDisplayStyle.decimal: "Decimal" => "十進位"
// totalDisplayStyle.currency: "Currency" => "貨幣"
// totalDisplayStyle.percent: "Percentage" => "百分比"
// totalDisplayStyle.date: "Date" => "日期"
// rowsOrder.initial: "Original" => "源語言"
// questionsOrder.initial: "Original" => "源語言"
// showProgressBar.aboveheader: "Above the header" => "標題上方"
// showProgressBar.belowheader: "Below the header" => "在標題下方"
// pv.sum: "Sum" => "和"
// pv.count: "Count" => "計數"
// pv.min: "Min" => "最小值"
// pv.max: "Max" => "麥克斯"
// pv.avg: "Avg" => "平均"
// searchMode.contains: "Contains" => "包含"
// searchMode.startsWith: "Starts with" => "開頭為"
// panel.name: "A panel ID that is not visible to respondents." => "受訪者不可見的面板ID。"
// panel.description: "Type a panel subtitle." => "鍵入面板字幕。"
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "使用魔棒圖示設置確定面板可見性的條件規則。"
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "使用魔棒圖示設置禁用面板唯讀模式的條件規則。"
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "使用魔杖圖示設置條件規則，除非至少有一個嵌套問題有答案，否則該規則將阻止調查提交。"
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "適用於此面板中的所有問題。如果要覆蓋此設置，請為單個問題定義標題對齊規則。“繼承”選項應用頁面級別（如果已設置）或調查級別設置（預設為“頂部”）。"
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "設置與面板中所有問題相關的錯誤消息的位置。“繼承”選項應用頁面級別（如果已設置）或調查級別設置。"
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "保持問題的原始順序或隨機化問題。“繼承”選項應用頁面級別（如果已設置）或調查級別設置。"
// panel.page: "Repositions the panel to the end of a selected page." => "將面板重新置放到選頁面的末尾。"
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "在面板內容和面板框的左邊框之間添加空格或邊距。"
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "取消選擇以將面板與上一個問題或面板顯示在一行中。如果面板是表單中的第一個元素，則該設置不適用。"
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "從中選擇：「展開」 - 面板完整顯示，可以摺疊;“已摺疊” - 面板僅顯示標題和描述，可以展開;“已鎖定” - 面板完整顯示，無法摺疊。"
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "設置面板的寬度，使其與同一行中的其他測量圖元成比例。接受 CSS 值（px、%、in、pt 等）。"
// paneldynamic.name: "A panel ID that is not visible to respondents." => "受訪者不可見的面板ID。"
// paneldynamic.description: "Type a panel subtitle." => "鍵入面板字幕。"
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "使用魔棒圖示設置確定面板可見性的條件規則。"
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "使用魔棒圖示設置禁用面板唯讀模式的條件規則。"
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "使用魔杖圖示設置條件規則，除非至少有一個嵌套問題有答案，否則該規則將阻止調查提交。"
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "適用於此面板中的所有問題。如果要覆蓋此設置，請為單個問題定義標題對齊規則。“繼承”選項應用頁面級別（如果已設置）或調查級別設置（預設為“頂部”）。"
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "設置與輸入無效的問題相關的錯誤消息的位置。選擇：「頂部」 - 錯誤文本放置在問題框的頂部;“底部” - 錯誤文本放置在問題框的底部。“繼承”選項應用頁面級別（如果已設置）或調查級別設置（預設為“頂部”）。"
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "設置與面板中所有問題相關的錯誤消息的位置。“繼承”選項應用頁面級別（如果已設置）或調查級別設置。"
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "將面板重新置放到選頁面的末尾。"
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "在面板內容和面板框的左邊框之間添加空格或邊距。"
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "取消選擇以將面板與上一個問題或面板顯示在一行中。如果面板是表單中的第一個元素，則該設置不適用。"
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "從中選擇：「展開」 - 面板完整顯示，可以摺疊;“已摺疊” - 面板僅顯示標題和描述，可以展開;“已鎖定” - 面板完整顯示，無法摺疊。"
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "設置面板的寬度，使其與同一行中的其他測量圖元成比例。接受 CSS 值（px、%、in、pt 等）。"
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "鍵入動態面板標題的範本。使用 {panelIndex} 作為面板的常規位置，使用 {visiblePanelIndex} 作為其在可見面板中的順序。將這些佔位元插入到圖案中以添加自動編號。"
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "鍵入選項卡標題的範本。使用 {panelIndex} 表示面板的大致位置，使用 {visiblePanelIndex} 表示其在可見面板中的順序。將這些佔位元插入到圖案中以添加自動編號。"
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "此設置允許您控制動態面板中各個面板的可見性。使用“{panel}”佔位符在運算式中引用當前面板。"
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "此面板中的所有問題都會自動繼承此設置。如果要覆蓋此設置，請為單個問題定義標題對齊規則。“繼承”選項應用頁面級別（如果已設置）或調查級別設置（預設為“頂部”）。"
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "“繼承”選項應用頁面級別（如果已設置）或調查級別設置（預設為“在面板標題下”）。"
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "定義新添加的面板的位置。默認情況下，新面板將添加到末尾。選擇「下一步」以在當前面板之後插入新面板。"
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "複製上一個面板中的答案，並將其分配給下一個添加的動態面板。"
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "引用問題名稱以要求使用者在每個面板中為此問題提供唯一的答案。"
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "此設定允許您根據表示式分配預設答案值。表達式可以包括基本計算 - '{q1_id} + {q2_id}'、布爾表達式，例如 '{age} > 60'，以及函數：'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）'等。此表達式確定的值用作初始預設值，可由回應者的手動輸入覆蓋。"
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "使用魔杖圖示設置條件規則，該規則確定何時將受訪者的輸入重置為基於“預設值表達式”或“設置值表達式”的值，或重置為“預設答案”值（如果設置了其中任何一個）。"
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "使用魔杖圖示設置條件規則，該規則確定何時運行「設置值表達式」 ，並將結果值動態分配為回應。"
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "指定一個表達式，該運算式定義在滿足「如果設置值」規則中的條件時要設置的值。表達式可以包括基本計算 - '{q1_id} + {q2_id}'、布爾表達式，例如 '{age} > 60'，以及函數：'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）'等。由此表達式確定的值可以被受訪者的手動輸入覆蓋。"
// question.name: "A question ID that is not visible to respondents." => "受訪者不可見的問題ID。"
// question.description: "Type a question subtitle." => "鍵入問題副標題。"
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "使用魔杖圖示設置確定問題可見性的條件規則。"
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "使用魔杖圖示設置條件規則，以禁用問題的唯讀模式。"
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "使用魔杖圖標設置條件規則，除非問題得到答案，否則阻止調查推進或提交。"
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "取消選擇以將問題與上一個問題或面板顯示在一行中。如果問題是表單中的第一個元素，則該設置不適用。"
// question.page: "Repositions the question to the end of a selected page." => "將問題重新置放到選頁面的末尾。"
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "從以下選項中選擇：「展開」 - 問題框完整顯示，可以摺疊;“已摺疊” - 問題框僅顯示標題和描述，可以展開;“已鎖定” - 問題框完整顯示，無法摺疊。"
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "覆蓋在面板、頁面或調查級別上定義的標題對齊規則。“繼承”選項將應用任何更高級別的設置（如果已設置）或調查級別的設置（預設為“頂部”）。"
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "“繼承”選項應用調查級別設置（預設為“在問題標題下”）。"
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "設置與輸入無效的問題相關的錯誤消息的位置。選擇：「頂部」 - 錯誤文本放置在問題框的頂部;“底部” - 錯誤文本放置在問題框的底部。“繼承”選項將應用調查級別設置（預設為“頂部”）。"
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "在問題內容和問題框的左邊框之間添加空格或邊距。"
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "設置問題的寬度，使其與同一行中的其他調查元素成比例。接受 CSS 值（px、%、in、pt 等）。"
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "使用魔杖圖示為問題設置驗證規則。"
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "從中選擇：「失焦時」 - 當輸入字段失去焦點時，該值會更新;“鍵入時” - 當使用者鍵入時，該值會即時更新。“繼承”選項將應用調查級別設置（預設為“失去焦點時”）。"
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "您可以使用任何 Web 服務作為多項選擇題的數據來源。要填充選項值，請輸入提供數據的服務的URL。"
// question.searchMode: "A comparison operation used to filter the drop-down list." => "用於篩選下拉清單的比較操作。"
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "設置顯示的簽名區域和生成的圖像的寬度。"
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "設置顯示的簽名區域和生成的圖像的高度。"
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "選擇是否希望簽名區域填充問題框中的所有可用空間，同時保持預設的 3：2 縱橫比。設置自定義寬度和高度值后，該設置將保留這些尺寸的縱橫比。"
// file.imageHeight: "Adjusts the height of the image in the survey results." => "調整調查結果中圖像的高度。"
// file.imageWidth: "Adjusts the width of the image in the survey results." => "調整調查結果中圖像的寬度。"
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "覆蓋最小和最大高度值。"
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "覆蓋最小和最大寬度值。"
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "“值”用作條件規則中使用的專案ID;向受訪者顯示“文本”。"
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "此設置僅調整輸入欄位的大小，不會影響問題框的寬度。要限制接受的輸入長度，請轉到<b>驗證→最大字元限制</b>。"
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "設置輸入欄位中顯示的行數。如果輸入佔用更多行，則會出現滾動條。"
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "選擇：「可編輯」 - 使受訪者能夠填寫您的調查;“只讀” - 禁用表單編輯。"
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "受訪者不可見的列ID。"
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "為列啟用后，受訪者需要為此列中的每個問題提供唯一的回答。"
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "設置輸入欄位中顯示的行數。如果輸入佔用更多行，則會出現滾動條。"
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "使用魔杖圖示設置確定列可見性的條件規則。"
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "使用魔杖圖示設置禁用列唯讀模式的條件規則。"
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "使用魔杖圖示設置條件規則，除非至少有一個嵌套問題有答案，否則該規則將阻止調查提交。"
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "選取後，為每個選項創建一個單獨的列。"
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "從以下選項中選擇： 「靜態」 - 設置固定寬度;“回應式” - 使調查佔據螢幕的整個寬度;“自動” - 根據所使用的問題類型應用兩者中的任何一個。"
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "粘貼圖像連結（無大小限制）或按下資料夾圖示以瀏覽電腦中的檔（最大 64KB）。"
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "以 CSS 單位（px、%、in、pt 等）設置徽標寬度。"
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "以 CSS 單位（px、%、in、pt 等）設置徽標高度。"
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "從以下選項中選擇：「無」 - 影像保持其原始大小;“包含” - 調整圖像大小以適應其縱橫比;“封面” - 圖像填充整個框，同時保持其縱橫比;“填充” - 拉伸圖像以填充框，而不保持其縱橫比。"
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "選擇是否希望調查在受訪者回答當前頁面上的所有問題後自動前進到下一頁。"
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "設置導航按鈕在頁面上的可見性和位置。"
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "設置進度條的可見性和位置。“自動”值顯示測量標題上方或下方的進度條。"
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "啟用僅包含所有問題或已回答問題的預覽頁面。"
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "適用於調查中的所有問題。此設置可以被較低級別的標題對齊規則覆蓋：面板、頁面或問題。較低級別的設置將覆蓋較高級別的設置。"
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "一個符號或一系列符號，表示需要答案。"
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "輸入要開始編號的數位或字母。"
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "設置與輸入無效的問題相關的錯誤消息的位置。選擇：「頂部」 - 錯誤文本放置在問題框的頂部;“底部” - 錯誤文本放置在問題框的底部。"
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "選擇是否希望每個頁面上的第一個輸入字段準備好進行文本輸入。"
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "保持問題的原始順序或隨機化問題。此設置的效果僅在「預覽」選項卡中可見。"
// pehelp.maxTextLength: "For text entry questions only." => "僅適用於文本輸入問題。"
// pehelp.maxOthersLength: "For question comments only." => "僅供問題評論。"
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "選擇是否希望問題註釋和長文本問題根據輸入的文字長度自動增加高度。"
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "僅適用於問題評論和長文本問題。"
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "自訂變數用作表單計算中使用的中間變數或輔助變數。他們將受訪者的輸入作為源值。每個自定義變數都有一個唯一的名稱和它所基於的表達式。"
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "選擇是否希望將表達式的計算值與調查結果一起保存。"
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "觸發器是基於表達式的事件或條件。一旦表達式被計算為「true」，觸發器就會觸發一個操作。這樣的操作可以選擇性地影響它的目標問題。"
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "選擇是否清除條件邏輯隱藏的問題的值以及何時清除。"
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "從中選擇：「失焦時」 - 當輸入字段失去焦點時，該值會更新;“鍵入時” - 當使用者鍵入時，該值會即時更新。"
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "左邊的值用作條件規則中使用的列ID，右邊的值顯示給受訪者。"
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "左邊的值用作條件規則中使用的行ID，右邊的值顯示給受訪者。"
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "接受 CSS 值（px、%、in、pt 等）。"
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "接受 CSS 值（px、%、in、pt 等）。"
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "設置與輸入無效的儲存格相關的錯誤訊息的位置。“繼承”選項應用“錯誤消息對齊”屬性中的設置。"
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "啟用「防止重複響應」屬性後，嘗試提交重複條目的受訪者將收到以下錯誤消息。"
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "允許您根據表達式計算總值。表達式可以包括基本計算 （'{q1_id} + {q2_id}'）、布爾表達式 （'{age} > 60'） 和函數 （'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）' 等）。"
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "觸發提示，要求確認刪除行。"
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "複製最後一行的答案，並將其分配給下一個添加的動態行。"
// pehelp.description: "Type a subtitle." => "鍵入副標題。"
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "選擇一種語言以開始創建調查。要添加翻譯，請切換到新語言，然後在此處或“翻譯”選項卡中翻譯原始文本。"
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "設置詳細資訊部分相對於行的位置。從中選擇：「無」 - 不添加擴展;“Under the row” - 矩陣的每一行下都放置一個行擴展;“在行下，僅顯示一行擴展” - 僅在單行下顯示擴展，其餘行展開將摺疊。"
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "從以下選項中選擇：「無」 - 影像保持其原始大小;“包含” - 調整圖像大小以適應其縱橫比;“封面” - 圖像填充整個框，同時保持其縱橫比;“填充” - 拉伸圖像以填充框，而不保持其縱橫比。"
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "在輸入數據時逐漸增加輸入欄位的高度。覆蓋「輸入欄位高度（以行為單位）」設置。"
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "調整大小的手柄（或手柄）出現在角落，可以拖動以更改輸入字段的大小。"
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "以秒為單位的時間間隔，在此時間間隔之後，調查將自動前進到“感謝”頁面。"
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "以秒為單位的時間間隔，在此時間間隔之後，調查將自動前進到下一頁。"
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "以秒為單位的時間間隔，在此時間間隔之後，調查將自動前進到下一頁。"
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "使用魔杖圖示設置確定頁面可見性的條件規則。"
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "使用魔杖圖示設置禁用頁面只讀模式的條件規則。"
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "使用魔杖圖示設置條件規則，除非至少有一個嵌套問題有答案，否則該規則將阻止調查提交。"
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "適用於本頁中的所有問題。如果要覆蓋此設置，請為單個問題或面板定義標題對齊規則。“繼承”選項將應用調查級別設置（預設為“頂部”）。"
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "設置與輸入無效的問題相關的錯誤消息的位置。選擇：「頂部」 - 錯誤文本放置在問題框的頂部;“底部” - 錯誤文本放置在問題框的底部。“繼承”選項將應用調查級別設置（預設為“頂部”）。"
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "保持問題的原始順序或隨機化問題。繼承「選項應用調查級別設置（預設為」原始」。）。此設置的效果僅在「預覽」選項卡中可見。"
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "設置導航按鈕在頁面上的可見性。“繼承”選項應用調查級別設置，預設為“可見”。"
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "設置計時器在頁面上的可見性和位置。"
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "從以下選項中選擇：「鎖定」 - 使用者無法展開或摺疊面板;“全部摺疊” - 所有面板都以摺疊狀態啟動;“全部展開” - 所有面板都以展開狀態啟動;“首先展開” - 最初只有第一個面板被展開。"
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "在物件陣列中輸入共用屬性名稱，該數位包含要在選項清單中顯示的圖像或視頻檔URL。"
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "左邊的值用作條件規則中使用的專案ID，右邊的值顯示給受訪者。"
// pehelp.title: "Type a user-friendly title to display." => "鍵入要顯示的使用者友好標題。"
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "確保使用者在上傳檔之前不會完成調查。"
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "接受 CSS 值（px、%、in、pt 等）。"
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "接受 CSS 值（px、%、in、pt 等）。"
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "接受 CSS 值（px、%、in、pt 等）。"
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "在單選題和多選題類型中，每個選項都有一個 ID 和顯示值。選中此設置后，將在 HTML 問題以及調查元素的動態標題和描述中顯示顯示值，而不是 ID 值。"
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "選擇是否清除條件邏輯隱藏的問題值以及何時清除。“繼承”選項應用調查級別設置（預設為“完成調查後”）。"
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "從以下選項中選擇：「全部」 - 複製所選問題中的所有選項;“Selected” - 僅動態複製選定的選項選項;“未選擇” - 僅動態複製未選擇的選項。默認情況下，如果在源問題中啟用了“無”和“其他”選項，則會複製該選項。"
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "選取後，使用者可以在單獨的註釋框中包含其他輸入。"
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "在新行上顯示每個特殊選項（“無”、“其他”、“全選”），即使使用多列佈局也是如此。"
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "指定服務數據集中目標物件陣列所在的位置。如果 URL 已指向陣列，則留空。"
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "在物件陣列中輸入一個統一的屬性名稱，該陣列包含要在選項清單中顯示的值。"
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "選擇此選項可允許服務傳回空回應或陣列。"
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "使用魔杖圖示設置條件規則，以確定所有選項的可見性。"
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "左邊的值用作條件規則中使用的專案ID，右邊的值顯示給受訪者。"
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "“自動”根據可用寬度在“按鈕”和“下拉”模式之間進行選擇。當寬度不足以顯示按鈕時，問題將顯示一個下拉清單。"
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "允許您連接以不同格式生成結果的問題。當使用聯接標識碼將此類問題連結在一起時，此共用屬性將存儲選定的問題值。"
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "選擇是否要更新下拉功能表內容以匹配使用者在輸入欄位中鍵入的搜索查詢。"
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "當受訪者給出肯定答案時保存在調查結果中的值。"
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "當受訪者給出否定答案時保存在調查結果中的值。"
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "不建議禁用此選項，因為它會覆蓋預覽圖像，並使用戶難以了解檔是否已上傳。"
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "觸發提示，要求確認文件刪除。"
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "啟用此選項可僅對選定的選項進行排名。使用者將從選項清單中拖動所選專案，以在排名區域內對它們進行排序。"
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "輸入將在輸入期間向受訪者建議的選項清單。"
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "該設置僅調整輸入欄位的大小，不會影響問題框的寬度。"
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "為所有項目標籤設定一致的寬度（以像素為單位）"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "“自動”選項會根據提供的源URL自動確定合適的顯示模式 - 圖像、視頻或YouTube。"
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "當圖像無法在使用者設備上顯示時，出於輔助功能的目的，可作為替代。"
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "定義當評級圖示類型設置為「笑臉」時所選表情符號的顏色。選擇：「預設」 - 選取表情符號以預設調查顏色顯示;“比例” - 所選的表情符號繼承了評分量表的顏色。"
// expression.name: "An expression ID that is not visible to respondents." => "受訪者不可見的表達式ID。"
// expression.description: "Type an expression subtitle." => "鍵入表達式副標題。"
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "表達式可以包括基本計算 （'{q1_id} + {q2_id}'）、條件 （'{age} > 60'） 和函數 （'iif（）'、'today（）'、'age（）'、'min（）'、'max（）'、'avg（）' 等）。"
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "選擇此選項可將「其他」選項值作為單獨的屬性存儲在調查結果中。"
// p.swapOrder: "Swap the order of Yes and No" => "交換“是”和“否”的順序"
// p.itemTitleWidth: "Item label width (in px)" => "項目標籤寬度（以 px 為單位）"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "顯示是否選擇了所有選項的文字"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "排名區域的佔位元文本"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "自動完成調查"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "選擇是否希望在受訪者回答所有問題後自動完成調查。"
// masksettings.saveMaskedValue: "Save masked value in survey results" => "在調查結果中保存掩碼值"
// patternmask.pattern: "Value pattern" => "價值模式"
// datetimemask.min: "Minimum value" => "最小值"
// datetimemask.max: "Maximum value" => "最大值"
// numericmask.allowNegativeValues: "Allow negative values" => "允許負值"
// numericmask.thousandsSeparator: "Thousands separator" => "千分隔符"
// numericmask.decimalSeparator: "Decimal separator" => "小數點分隔符"
// numericmask.precision: "Value precision" => "值精度"
// numericmask.min: "Minimum value" => "最小值"
// numericmask.max: "Maximum value" => "最大值"
// currencymask.prefix: "Currency prefix" => "貨幣前綴"
// currencymask.suffix: "Currency suffix" => "貨幣後綴"
// pe.maskType: "Input mask type" => "輸入掩碼類型"
// maskTypes.patternmask: "Pattern" => "模式"
// maskTypes.numericmask: "Numeric" => "數值的"
// maskTypes.datetimemask: "Date and Time" => "日期和時間"
// maskTypes.currencymask: "Currency" => "貨幣"
// tabs.mask: "Input Mask Settings" => "輸入掩碼設置"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "例如：+1（999）-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "例：mm/dd/yyyy"
// pe.currencyprefix_placeholder: "Ex.: $" => "例：$"
// pe.currencysuffix_placeholder: "Ex.: USD" => "例如：美元"
// pv.textWrapEnabled: "Wrap choices" => "包裝選擇"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "選項選項中的長文本將自動生成換行符以適合下拉功能表。如果要剪裁文字，請取消選擇。"
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "選擇是否要在調查結果中存儲帶有應用掩碼的問題值。"
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "該模式可以包含字串文字和以下佔位元： '9' - 表示數位;“a” - 表示大寫或小寫字母;'#' - 表示數位或大寫或小寫字母。使用反斜杠“\\”轉義字元。"
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "該模式可以包含分隔符和以下佔位元：“m” - 表示月份數;'mm' - 表示月份數位，前導零表示個位數;'d' - 表示月份中的某一天;'dd' - 表示月份中的某一天，前導零表示個位數值;'yy' - 一年的最後兩位數位;'yyyy' - 表示四位數的年份。"
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "用於將顯示數位的小數部分與整數部分分開的符號。"
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "用於將大數的數位分成三組的符號。"
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "限制顯示數位的小數點後要保留的位數。"
// currencymask.prefix: "One or several symbols to be displayed before the value." => "要在值之前顯示的一個或多個符號。"
// currencymask.suffix: "One or several symbols to be displayed after the value." => "要在值后顯示的一個或多個符號。"
// ed.translationSource: "Source: " => "源："
// ed.translationTarget: "Target: " => "目標："
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "頁面為空。從工具箱中拖動元素或按下下面的按鈕。"
// maskTypes.none: "None" => "沒有"
// itemvalue@rows.visibleIf: "Make the row visible if" => "如果出現以下情況，則使行可見"
// itemvalue@rows.enableIf: "Make the row editable if" => "如果出現以下情況，則使行可編輯"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "唯讀或預覽模式下的佔位元文本"
// pe.textWrapEnabled: "Wrap choices" => "換行選項"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "“自動”選項會根據提供的源URL自動確定適合的顯示模式 - 圖像、視頻或YouTube。"
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "在「圖像」和「視頻」之間進行選擇以設置媒體選擇器的內容模式。如果選擇「圖像」，請確保提供的所有選項都是以下格式的圖像檔：JPEG、GIF、PNG、APNG、SVG、BMP、ICO。同樣，如果選擇「視頻」，請確保所有選項都是指向以下格式的視頻檔的直接連結：MP4、MOV、WMV、FLV、AVI、MKV。請注意，視頻選項不支援 YouTube 連結。"
// ed.selectFile: "Select a file" => "選擇檔案"
// ed.removeFile: "Remove the file" => "刪除檔案"
// pe.searchMode: "Search Mode" => "搜索模式"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "按兩下下面的「添加問題」 按鈕開始創建表單。"
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "按兩下下面的「添加問題」 按鈕，向頁面添加新元素。"
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "按下下面的「添加問題」 按鈕，將新元素添加到面板中。"
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "點擊下面的按鈕，選擇要上傳的圖片"
// coloralpha.opacity: "Opacity" => "不透明度"
// font.family: "Font family" => "字體家族"
// font.color: "Color" => "顏色"
// font.placeholderColor: "Placeholder color" => "佔位元顏色"
// font.size: "Size" => "大小"
// theme.themeName: "Theme" => "主題"
// theme.isPanelless: "Question appearance" => "問題外觀"
// theme.editorPanel: "Background and corner radius" => "背景和拐角半徑"
// theme.questionPanel: "Background and corner radius" => "背景和拐角半徑"
// theme.primaryColor: "Accent color" => "強調色"
// theme.panelBackgroundTransparency: "Panel background opacity" => "面板背景不透明度"
// theme.questionBackgroundTransparency: "Question background opacity" => "問題背景不透明度"
// theme.fontSize: "Font size" => "字體大小"
// theme.scale: "Scale" => "規模"
// theme.cornerRadius: "Corner radius" => "拐角半徑"
// theme.pageTitle: "Title font" => "標題字體"
// theme.pageDescription: "Description font" => "描述字體"
// theme.questionTitle: "Title font" => "標題字體"
// theme.questionDescription: "Description font" => "描述字體"
// theme.editorFont: "Font" => "字體"
// theme.backgroundOpacity: "Opacity" => "不透明度"
// theme.--sjs-font-family: "Font family" => "字體家族"
// theme.--sjs-general-backcolor-dim: "Background color" => "背景顏色"
// theme.--sjs-primary-backcolor: "Accent background" => "重音背景"
// theme.--sjs-primary-forecolor: "Accent foreground" => "重音前景"
// theme.--sjs-shadow-small: "Shadow effects" => "陰影效果"
// theme.--sjs-shadow-inner: "Shadow effects" => "陰影效果"
// theme.--sjs-border-default: "Colors" => "顏色"
// header@header.headerView: "View" => "視圖"
// header@header.logoPosition: "Logo position" => "徽標位置"
// header@header.surveyTitle: "Survey title font" => "調查標題字體"
// header@header.surveyDescription: "Survey description font" => "調查描述字體"
// header@header.headerTitle: "Survey title font" => "調查標題字體"
// header@header.headerDescription: "Survey description font" => "調查描述字體"
// header@header.inheritWidthFrom: "Content area width" => "內容區寬度"
// header@header.textAreaWidth: "Text width" => "文本寬度"
// header@header.backgroundColorSwitch: "Background color" => "背景顏色"
// header@header.backgroundImage: "Background image" => "背景圖片"
// header@header.backgroundImageOpacity: "Opacity" => "不透明度"
// header@header.overlapEnabled: "Overlap" => "重疊"
// header@header.logoPositionX: "Logo position" => "徽標位置"
// header@header.titlePositionX: "Title position" => "標題位置"
// header@header.descriptionPositionX: "Description position" => "描述位置"
// weight.400: "Regular" => "定期"
// weight.600: "Heavy" => "重"
// weight.700: "Semi-bold" => "半粗體"
// weight.800: "Bold" => "大膽"
// backgroundImageFit.auto: "Auto" => "自動"
// backgroundImageFit.cover: "Cover" => "蓋"
// backgroundImageFit.contain: "Contain" => "包含"
// backgroundImageFit.fill: "Stretch" => "伸展"
// backgroundImageFit.tile: "Tile" => "瓦"
// backgroundImageAttachment.fixed: "Fixed" => "固定"
// backgroundImageAttachment.scroll: "Scroll" => "滾動"
// headerView.basic: "Basic" => "基本"
// headerView.advanced: "Advanced" => "高深"
// inheritWidthFrom.survey: "Same as survey" => "與調查相同"
// inheritWidthFrom.container: "Fit to container" => "適合容器"
// backgroundColorSwitch.none: "None" => "沒有"
// backgroundColorSwitch.accentColor: "Accent color" => "強調色"
// backgroundColorSwitch.custom: "Custom" => "習慣"
// colorPalette.light: "Light" => "光"
// colorPalette.dark: "Dark" => "黑暗"
// isPanelless.false: "Default" => "違約"
// isPanelless.true: "Without Panels" => "不帶面板"
// theme.cornerRadius: "Corner radius" => "拐角半徑"
// theme.fontFamily: "Font family" => "字體家族"
// theme.fontWeightRegular: "Regular" => "定期"
// theme.fontWeightHeavy: "Heavy" => "重"
// theme.fontWeightSemiBold: "Semi-bold" => "半粗體"
// theme.fontWeightBold: "Bold" => "大膽"
// theme.color: "Color" => "顏色"
// theme.placeholderColor: "Placeholder color" => "佔位元顏色"
// theme.size: "Size" => "大小"
// theme.opacity: "Opacity" => "不透明度"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "鍵入以搜尋..."
// ed.toolboxNoResultsFound: "No results found" => "未找到結果"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "選項卡標題佔位元"
// theme.--sjs-special-red: "Error messages" => "錯誤消息"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "選項卡標題的回退文本，當選項卡標題模式未生成有意義的值時應用。"
// theme.fontColor: "Font color" => "字體顏色"
// theme.backgroundColor: "Background color" => "背景顏色"
// pe.questionTitleWidth: "Question title width" => "問題標題寬度"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "選擇檔案或貼上檔案連結..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "例如：200px"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "當問題標題與問題框左側對齊時，為問題標題設置一致的寬度。接受 CSS 值（px、%、in、pt 等）。"
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "當問題標題與問題框左側對齊時，為問題標題設置一致的寬度。接受 CSS 值（px、%、in、pt 等）。"
// pe.commentAreaRows: "Comment area height (in lines)" => "評論區高度（以行為單位）"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "設置問題註釋的文字區域中顯示的行數。在輸入佔用更多行時，將出現滾動條。"


/***/ }),

/***/ "./src/localization/turkish.ts":
/*!*************************************!*\
  !*** ./src/localization/turkish.ts ***!
  \*************************************/
/*! exports provided: turkishStrings */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "turkishStrings", function() { return turkishStrings; });
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-creator-core */ "survey-creator-core");
/* harmony import */ var survey_creator_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core__WEBPACK_IMPORTED_MODULE_0__);
// This dictionary contains 65 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.

var turkishStrings = {
    // survey templates
    survey: {
        edit: "Düzenle",
        externalHelpLink: "Nasıl anket oluşturulur izle",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Lütfen araç kutusundan bir soru sürükleyin.",
        addLogicItem: "Anket akışını özelleştirmek için bir kural oluşturun.",
        copy: "Kopyala",
        duplicate: "Yinelenen",
        addToToolbox: "Araç kutusuna ekle",
        deletePanel: "Paneli Sil",
        deleteQuestion: "Soruyu Sil",
        convertTo: "Çevir",
        drag: "Nesne sürükleyin",
    },
    // Creator tabs
    tabs: {
        preview: "Anketi Test Et",
        theme: "Temalar",
        translation: "Çeviri",
        designer: "Anket Tasarımı",
        editor: "JSON Editor",
        logic: "Mantıksal Anket"
    },
    // Question types
    qt: {
        default: "Varsayılan",
        checkbox: "Onay Kutusu",
        comment: "Yorum",
        imagepicker: "Resim seçici",
        ranking: "Sıralama",
        image: "Resim",
        dropdown: "Seçim Kıutusu",
        tagbox: "Çoklu Seçim Açılır Menüsü",
        file: "Dosya",
        html: "Html",
        matrix: "Matrix (tek seçim)",
        matrixdropdown: "Matrix (çoklu seçim)",
        matrixdynamic: "Matrix (dinamik satır)",
        multipletext: "Çoklu Yazı",
        panel: "Panel",
        paneldynamic: "Panel (dinamik panel)",
        radiogroup: "Seçim Grubu",
        rating: "Değerlendirme",
        text: "Tek Girdi",
        boolean: "Mantıksal İfade",
        expression: "İfade (düzenlenemez)",
        signaturepad: "İmza Defteri",
        buttongroup: "Düğme Grubu"
    },
    toolboxCategories: {
        general: "Genel",
        choice: "Seçim Soruları",
        text: "Metin Girişi Soruları",
        containers: "Konteyner",
        matrix: "Matris Soruları",
        misc: "Misc"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Varyayılan ({0})",
        survey: "Anket",
        settings: "Anket Ayarları",
        settingsTooltip: "Anket ayarlarını aç",
        surveySettings: "Anket Ayarları",
        surveySettingsTooltip: "Anket ayarları",
        themeSettings: "Tema Ayarları",
        themeSettingsTooltip: "Tema ayarları",
        showPanel: "Paneli Göster",
        hidePanel: "Paneli Gizle",
        prevSelected: "Öncekini seç",
        nextSelected: "İleri'yi seçin",
        prevFocus: "Öncesine odaklan",
        nextFocus: "Sonrakine odaklan",
        surveyTypeName: "Anket",
        pageTypeName: "Sayfa",
        panelTypeName: "Panel",
        questionTypeName: "Soru",
        columnTypeName: "Sütun",
        addNewPage: "Yeni Sayfa Ekle",
        moveRight: "Sağa sürükle",
        moveLeft: "Sola sürükle",
        deletePage: "Sayfayı Sil",
        editPage: "Sayfayı Düzenle",
        edit: "Düzenle",
        newPageName: "Sayfa",
        newQuestionName: "Soru",
        newPanelName: "Panel",
        newTextItemName: "Yazı",
        defaultV2Theme: "Temerrüt",
        modernTheme: "Modern",
        defaultTheme: "Varsayılan (eski)",
        testSurveyAgain: "Anketi Tekrar Test Et",
        testSurveyWidth: "Anket genişliği: ",
        navigateToMsg: "Şuraya git:",
        saveSurvey: "Anketi Kaydet",
        saveSurveyTooltip: "Anketi Kaydet",
        saveTheme: "Temayı Kaydet",
        saveThemeTooltip: "Temayı Kaydet",
        jsonHideErrors: "Hataları gizleme",
        jsonShowErrors: "Hataları göster",
        undo: "Geri",
        redo: "İleri",
        undoTooltip: "Son değişikliği geri al",
        redoTooltip: "Son değişikliği ileri al",
        showMoreChoices: "Daha fazlasını göster",
        showLessChoices: "Daha az göster",
        copy: "Kopya etmek",
        cut: "Kesmek",
        paste: "Yapıştırmak",
        copyTooltip: "Seçimi panoya kopyala",
        cutTooltip: "Seçimi panoya kes",
        pasteTooltip: "Panodan yapıştır",
        options: "Seçenekler",
        generateValidJSON: "JSON Oluştur",
        generateReadableJSON: "Okunabilir JSON oluştur",
        toolbox: "Araç Kutusu",
        "property-grid": "Özellikler",
        toolboxFilteredTextPlaceholder: "Aramak için yazın...",
        toolboxNoResultsFound: "Sonuç bulunamadı",
        propertyGridFilteredTextPlaceholder: "Aramak için yazın...",
        propertyGridNoResultsFound: "Sonuç bulunamadı",
        correctJSON: "JSON nesnesini doğrular.",
        surveyResults: "Anket Sonucu: ",
        surveyResultsTable: "Tablo olarak",
        surveyResultsJson: "JSON olarak",
        resultsTitle: "Soru başlığı",
        resultsName: "Soru adı",
        resultsValue: "Cevap değeri",
        resultsDisplayValue: "Görünen değer",
        modified: "Düzenlendi",
        saving: "Kaydediliyor",
        saved: "Kaydedildi",
        propertyEditorError: "Hata",
        saveError: "Hata! Editor içerisi kaydedilmedi.",
        translationPropertyGridTitle: "Dil Ayarları",
        themePropertyGridTitle: "Tema Ayarları",
        translationLanguages: "Diller",
        translationDeleteLanguage: "Bu dil için tüm dizeleri silmek istediğinizden emin misiniz?",
        translationAddLanguage: "Çeviri için dil seçiniz",
        translationShowAllStrings: "Tüm yazıları göster",
        translationShowUsedStringsOnly: "Yalnızca Kullanılan Dizeler",
        translationShowAllPages: "Tüm sayfaları göster",
        translationNoStrings: "Çevrilecek yazı yok. Lütfen, filtreyi değiştirin.",
        translationExportToSCVButton: "CSV dışa çıkart",
        translationImportFromSCVButton: "CSV içe aktar",
        translateUsigAI: "Tümünü Otomatik Çevir",
        translateUsigAIFrom: "Çeviri kaynağı: ",
        translationDialogTitle: "Çevrilmemiş dizeler",
        translationMergeLocaleWithDefault: "{0} varsayılan çeviri ile sıkıştır",
        translationPlaceHolder: "Çeviri...",
        translationSource: "Kaynak: ",
        translationTarget: "Hedef: ",
        themeExportButton: "Ihracat",
        themeImportButton: "Ithalat",
        surveyJsonExportButton: "Ihracat",
        surveyJsonImportButton: "Ithalat",
        surveyJsonCopyButton: "Panoya kopyala",
        themeResetButton: "Tema ayarlarını varsayılana sıfırla",
        themeResetConfirmation: "Temayı gerçekten sıfırlamak istiyor musunuz? Tüm özelleştirmeleriniz kaybolacak.",
        themeResetConfirmationOk: "Evet, temayı sıfırlayın",
        bold: "Kalın",
        italic: "Italik",
        underline: "Alt Çizgi",
        addNewQuestion: "Soru Ekle",
        selectPage: "Sayfa seç...",
        carryForwardChoicesCopied: "Seçenekler şuradan kopyalanır:",
        choicesLoadedFromWebText: "Seçimler bir web hizmetinden yüklenir.",
        choicesLoadedFromWebLinkText: "Ayarlara git",
        choicesLoadedFromWebPreviewTitle: "Yüklenen seçim seçeneklerinin önizlemesi",
        htmlPlaceHolder: "HTML içeriği burada olacak.",
        panelPlaceHolder: "Araç kutusundan buraya bir soru bırakın.",
        surveyPlaceHolder: "Anket boş. Araç kutusundan bir öğeyi sürükleyin veya aşağıdaki düğmeyi tıklatın.",
        pagePlaceHolder: "Sayfa boş. Araç kutusundan bir öğeyi sürükleyin veya aşağıdaki düğmeyi tıklatın.",
        imagePlaceHolder: "Bir resmi buraya sürükleyip bırakın veya aşağıdaki düğmeyi tıklayın ve yüklemek için bir resim seçin",
        surveyPlaceHolderMobile: "Formunuzu oluşturmaya başlamak için aşağıdaki \"Soru Ekle\" butonuna tıklayın.",
        pagePlaceHolderMobile: "Sayfaya yeni bir öğe eklemek için aşağıdaki \"Soru Ekle\" düğmesini tıklayın.",
        panelPlaceHolderMobile: "Panele yeni bir öğe eklemek için aşağıdaki \"Soru Ekle\" düğmesini tıklayın.",
        imagePlaceHolderMobile: "Aşağıdaki düğmeyi tıklayın ve yüklemek için bir resim seçin",
        imageChooseImage: "Resim Seç",
        addNewTypeQuestion: "{0} ekle",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Madde ",
        selectFile: "Bir dosya seçin",
        removeFile: "Dosyayı kaldır",
        lg: {
            addNewItem: "Yeni Kural Ekle",
            empty_tab: "Anketin akışını özelleştirmek için bir kural oluşturun.",
            page_visibilityName: "Sayfa görünürse",
            page_enableName: "Sayfayı etkinleştir (devre dışı bırak)",
            page_requireName: "Sayfayı gerekli hale getirme",
            panel_visibilityName: "Panel görünürse",
            panel_enableName: "Panel aktif/pasif ise",
            panel_requireName: "Sayfayı gerekli hale getirme",
            question_visibilityName: "Soru görüürse",
            question_enableName: "Soru aktif/pasifse",
            question_requireName: "Soru isteğe bağlı zorunluysa",
            question_resetValueName: "Soru değerini sıfırla",
            question_setValueName: "Soru değerini ayarla",
            column_visibilityName: "Göster (gizle) sütunu",
            column_enableName: "Etkinleştir (devre dışı bırak) sütunu",
            column_requireName: "Sütunu gerekli kıl",
            column_resetValueName: "Sütun değerini sıfırla",
            column_setValueName: "Sütun değerini ayarla",
            trigger_completeName: "Anketi tamamla",
            trigger_setvalueName: "Soru değerini güncelle",
            trigger_copyvalueName: "Soru değerini kopyala",
            trigger_skipName: "Soruyu atla",
            trigger_runExpressionName: "Varsayılan ifadeyi çalıştır",
            completedHtmlOnConditionName: "Varyalın 'Teşekkür sayfası' yazısı",
            page_visibilityDescription: "Mantıksal sorgu geçerli olduğu zaman sayfayı görünür yap. Aksi takdirde gizle.",
            panel_visibilityDescription: "Mantıksal sorgu geçerli olduğu zaman paneli görünür yap. Aksi takdirde gizle.",
            panel_enableDescription: "Panel oluştur ve tüm nesneleri panelin içine al. Mantıksal sorgu geçerli olduğunda paneli aktif et. Aksi takdirde tümünü pasifleştir.",
            question_visibilityDescription: "Mantıksal sorgu geçerli olduğunda soruyu görünür yap. Aksi takdirde gizle.",
            question_enableDescription: "Mantıksal sorgu geçerli olduğunda soruyu aktif yap. Aksi takdirde pasifleştir.",
            question_requireDescription: "Mantıksal sorgu geçerli olduğunda soruyu zorunlu olarak düzenle.",
            trigger_completeDescription: "Mantıksal sorgu geçerli olduğunda anketi tamamla ve son kullanıya 'Teşekkür sayfası'nı göster.",
            trigger_setvalueDescription: "Mantık ifadesinde kullanılan soru değerleri değiştirildiğinde ve mantık ifadesi true değerini döndürdüğünde, değer seçilen soruya ayarlansın.",
            trigger_copyvalueDescription: "Mantık ifadesinde kullanılan soru değerleri değiştirildiğinde ve mantık ifadesi true değerini döndürdüğünde, seçilen bir sorunun değeri seçilen başka bir soruya kopyalansın.",
            trigger_skipDescription: "Mantıksal ifade geçerli olduğunda anket seçilen soruya atlasın / odaklansın.",
            trigger_runExpressionDescription: "Mantksal ifade geçerli olduğunda ve özel ifade gereçli olur. İsteğe bağlı olarak bu ifade sonucunu seçilen soruya ayarlayabilirsiniz.",
            completedHtmlOnConditionDescription: "Eğer mantıksa ifade geçerli olursa, varsayılan ''Teşekkürler sayfası' yazısı girilen ile dğeiştirilsin.",
            itemExpressionText: "Mantıksal ifade: '{0}' geçerli olsun:",
            itemEmptyExpressionText: "Yeni kural",
            page_visibilityText: "{0} sayfayı görünür yap",
            panel_visibilityText: "{0} paneli görünür yap",
            panel_enableText: "{0} panel aktif olur",
            question_visibilityText: "{0} soruyu görünür yap",
            question_enableText: "{0} soruyu aktif yap",
            question_requireText: "{0} cevabı zorunlu yap",
            question_resetValueText: "Soru için sıfırlama değeri: {0}",
            question_setValueText: "Değer atayın: Soruya {1}: {0}",
            column_visibilityText: "Soru {1} sütununu {0} görünür hale getirme",
            column_enableText: "Sütunun {0} soru {1} etkinleştirin",
            column_requireText: "Sütun {0} soru {1} gerekli hale getirmek",
            column_resetValueText: "Sütun için hücre değerini sıfırla: {0}",
            column_setValueText: "Hücre değeri atayın: Sütuna {1}: {0}",
            setValueExpressionPlaceholder: " Sonucu hedef soruya atanacak bir ifade.",
            trigger_completeText: "Anket tamamlandı",
            trigger_setvalueText: "Sorunun içine: {0} değer {1}",
            trigger_setvalueEmptyText: "net soru değeri: {0}",
            trigger_copyvalueText: "Sorusundan {1}, {0} değerini, soruya kopyala",
            trigger_skipText: "Soruya geç {0}",
            trigger_runExpressionText1: "Mantıksal ifadeyi çalıştır: '{0}'",
            trigger_runExpressionText2: " ve sonuç değerini soruya ekle: {0}",
            completedHtmlOnConditionText: "Özel 'Teşekkürler sayfasını' göster.",
            showAllQuestions: "Tüm Sorular",
            showAllActionTypes: "Tüm Eylem Türleri",
            conditions: "Koşul(lar)",
            actions: "Olay(lar)",
            expressionEditorTitle: "Koşul(ları) tanımla",
            actionsEditorTitle: "Olay(ları) tanımla",
            deleteAction: "Olayı Sil",
            addNewAction: "Yeni olay ekle",
            selectedActionCaption: "Eklemek için bir olay seçin...",
            expressionInvalid: "Mantıksal ifade boş veya geçersiz. Lütfen düzenleyin.",
            noActionError: "Lütfen, En az bir olay seçiniz.",
            actionInvalid: "Lütfen, Olay(lar)daki sorunları gideriniz.",
            uncompletedRule_title: "Mantıksal kurallar eksik",
            uncompletedRule_text: "Bazı mantıksal kuralları tamamlamadınız. Sekmeyi şimdi bırakırsanız, değişiklikler kaybolur. Yine de değişiklikleri tamamlamadan sekmeden çıkmak istiyor musunuz?",
            uncompletedRule_apply: "Evet",
            uncompletedRule_cancel: "Hayır, kuralları tamamlamak istiyorum"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Panel adı",
            title: "Panel başlığı",
            description: "Panel açıklaması",
            visibleIf: "Aşağıdaki durumlarda paneli görünür hale getirin",
            requiredIf: "Aşağıdaki durumlarda paneli gerekli hale getirin",
            questionsOrder: "Panel içinde soru sırası",
            page: "Ana sayfa",
            startWithNewLine: "Paneli yeni bir satırda görüntüleme",
            state: "Panel çökme durumu",
            width: "Satır içi panel genişliği",
            minWidth: "Minimum panel genişliği",
            maxWidth: "Maksimum panel genişliği",
            showNumber: "Sayı panelleri"
        },
        paneldynamic: {
            name: "Panel adı",
            title: "Panel başlığı",
            description: "Panel açıklaması",
            visibleIf: "Aşağıdaki durumlarda paneli görünür hale getirin",
            requiredIf: "Aşağıdaki durumlarda paneli gerekli hale getirin",
            page: "Paneli sayfaya taşıma",
            startWithNewLine: "Paneli yeni bir satırda görüntüleme",
            state: "Panel çökme durumu",
            width: "Satır içi panel genişliği",
            minWidth: "Minimum panel genişliği",
            maxWidth: "Maksimum panel genişliği",
            confirmDelete: "Panel silme işlemini onaylama",
            templateDescription: "Panel açıklama deseni",
            templateTitle: "Panel başlığı deseni",
            noEntriesText: "Boş panel metni",
            templateTabTitle: "Sekme başlığı deseni",
            tabTitlePlaceholder: "Sekme başlığı yer tutucusu",
            templateVisibleIf: "Aşağıdaki durumlarda tek bir paneli görünür hale getirme",
            hideNumber: "Panel numarasını gizleme",
            titleLocation: "Panel başlığı hizalaması",
            descriptionLocation: "Panel açıklaması hizalaması",
            templateTitleLocation: "Soru başlığı hizalaması",
            templateErrorLocation: "Hata iletisi hizalaması",
            newPanelPosition: "Yeni panel konumu",
            keyName: "Aşağıdaki soruda yinelenen yanıtları önleyin"
        },
        question: {
            name: "Soru adı",
            title: "Soru başlığı",
            description: "Soru açıklaması",
            visibleIf: "Aşağıdaki durumlarda soruyu görünür hale getirin",
            requiredIf: "Aşağıdaki durumlarda soruyu gerekli hale getirin",
            page: "Ana sayfa",
            state: "Soru kutusu daraltma durumu",
            hideNumber: "Soru numarasını gizleme",
            titleLocation: "Soru başlığı hizalaması",
            descriptionLocation: "Soru açıklaması hizalaması",
            errorLocation: "Hata iletisi hizalaması",
            indent: "İç girintiyi artırma",
            width: "Satır içi soru genişliği",
            minWidth: "Minimum soru genişliği",
            maxWidth: "Maksimum soru genişliği",
            textUpdateMode: "Giriş alanı değerini güncelleştirme"
        },
        signaturepad: {
            signatureWidth: "İmza alanı genişliği",
            signatureHeight: "İmza alanı yüksekliği",
            signatureAutoScaleEnabled: "İmza alanını otomatik ölçeklendirme",
            showPlaceholder: "Yer tutucuyu gösterme",
            placeholder: "Yer tutucu metin",
            placeholderReadOnly: "Salt okunur veya önizleme modunda yer tutucu metin",
            allowClear: "İmza alanı içinde Temizle düğmesini gösterme",
            penMinWidth: "Minimum kalem genişliği",
            penMaxWidth: "Maksimum kalem genişliği",
            penColor: "Kontur rengi"
        },
        comment: {
            rows: "Giriş alanı yüksekliği (satırlarda)"
        },
        showQuestionNumbers: "Soru numarasını göster",
        questionStartIndex: "Soru indeksi (1, 2 veya 'A', 'a' gibi)",
        expression: {
            name: "İfade adı",
            title: "İfade başlığı",
            description: "İfade açıklaması",
            expression: "İfade"
        },
        trigger: {
            expression: "İfade"
        },
        calculatedvalue: {
            expression: "İfade"
        },
        // survey templates
        survey: {
            title: "Başlık",
            description: "Anket açıklaması"
        },
        page: {
            name: "Sayfa adı",
            title: "Başlık",
            description: "Sayfa açıklaması",
            visibleIf: "Aşağıdaki durumlarda sayfayı görünür hale getirin",
            requiredIf: "Aşağıdaki durumlarda sayfayı gerekli hale getirin",
            maxTimeToFinish: "Sayfayı bitirmek için zaman sınırı (saniye cinsinden)",
            questionsOrder: "Sayfadaki soru sırası"
        },
        matrixdropdowncolumn: {
            name: "Sütun adı",
            title: "Sütun başlığı",
            isUnique: "Yinelenen yanıtları önleyin",
            width: "Sütun genişliği",
            minWidth: "Minimum sütun genişliği",
            rows: "Giriş alanı yüksekliği (satırlarda)",
            visibleIf: "Aşağıdaki durumlarda sütunu görünür hale getirin",
            requiredIf: "Aşağıdaki durumlarda sütunu gerekli yap",
            showInMultipleColumns: "Her seçenek ayrı bir sütunda"
        },
        multipletextitem: {
            name: "Ad",
            title: "Başlık"
        },
        masksettings: {
            saveMaskedValue: "Anket sonuçlarında maskelenmiş değeri kaydetme"
        },
        patternmask: {
            pattern: "Değer örüntüsü"
        },
        datetimemask: {
            min: "Minimum değer",
            max: "Maksimum değer"
        },
        numericmask: {
            allowNegativeValues: "Negatif değerlere izin ver",
            thousandsSeparator: "Binlik ayırıcı",
            decimalSeparator: "Ondalık ayırıcı",
            precision: "Değer hassasiyeti",
            min: "Minimum değer",
            max: "Maksimum değer"
        },
        currencymask: {
            prefix: "Para birimi öneki",
            suffix: "Para birimi son eki"
        },
        imageHeight: "Resim yüksekliği",
        imageWidth: "Resim genişliği",
        valueName: "Değer adı",
        rateDescriptionLocation: "Etiket hizalama",
        size: "Giriş alanı boyutu (karakter cinsinden)",
        cellErrorLocation: "Hücre hata iletisi hizalaması",
        apply: "Uygula",
        ok: "TAMAM",
        save: "Kaydet",
        clear: "Berrak",
        saveTooltip: "Kurtarmak",
        cancel: "İptal",
        set: "Ayarlamak",
        reset: "Sıfırla",
        change: "Değiştirmek",
        refresh: "Yenile",
        close: "Kapatmak",
        delete: "Sil",
        add: "Ekle",
        addNew: "Yeni Ekle",
        addItem: "Yeni nesne ekleme için tıklayınız...",
        removeItem: "Öğeyi kaldırmak için tıklayın...",
        dragItem: "Öğeyi sürükleyin",
        addOther: "Diğer",
        addSelectAll: "Tümünü Seç",
        addNone: "Hiçbiri",
        removeAll: "Tümünü Sil",
        edit: "Düzenle",
        back: "Kaydetmeden çık",
        backTooltip: "Kaydetmeden geri dönün",
        saveAndBack: "Kaydet ve çık",
        saveAndBackTooltip: "Kaydet ve geri dön",
        doneEditing: "Yapılmış",
        editChoices: "Seçenekleri düzenle",
        showChoices: "Seçenekleri göster",
        move: "Hareket",
        empty: "<boş>",
        emptyValue: "Değer boş",
        fastEntry: "Hızlı Giriş",
        fastEntryNonUniqueError: "'{0}' değeri benzersiz değil",
        fastEntryChoicesCountError: "Lütfen öğe sayısını {0}'den {1}'ye sınırlayın",
        fastEntryChoicesMinCountError: "Lütfen en az {0} ürün girin",
        fastEntryPlaceholder: "Verileri aşağıdaki biçimde ayarlayabilirsiniz:\ndeğer1|metin\ndeğer2",
        formEntry: "Form Girişi",
        testService: "Servisi test et",
        itemSelectorEmpty: "Lütfen nesneyi seçiniz",
        conditionActionEmpty: "Lütfen olayı seçiniz",
        conditionSelectQuestion: "Soruyu seç...",
        conditionSelectPage: "Sayfayı seç...",
        conditionSelectPanel: "Paneli seç...",
        conditionValueQuestionTitle: "Lütfen değer/seçenek giriniz",
        aceEditorHelp: "Mantıksal ifade kopyası için ctrl+space tuşlarına basınız",
        aceEditorRowTitle: "Geçerli satır",
        aceEditorPanelTitle: "Geçerli panel",
        showMore: "Daha fazla bilgi için dokümantasyonu inceleyiniz",
        assistantTitle: "Erişilebilir sorular:",
        cellsEmptyRowsColumns: "En az bir kolon veya satır olmalı",
        showPreviewBeforeComplete: "Tamamlanmadan önce önizlemeyi göster",
        overridingPropertyPrefix: "Ayarlayan ",
        resetToDefaultCaption: "Sıfırlama",
        propertyIsEmpty: "Lütfen değer giriniz",
        propertyIsNoUnique: "Lütfen benzersiz bir değer girin",
        propertyNameIsNotUnique: "Lütfen benzersiz bir isim giriniz",
        propertyNameIsIncorrect: "Ayrılmış kelimeler kullanmayın: \"öğe\", \"seçim\", \"panel\", \"satır\".",
        listIsEmpty: "Yeni eleman ekle",
        "listIsEmpty@choices": "Henüz seçenek eklenmedi",
        "listIsEmpty@columns": "Henüz sütununuz yok",
        "listIsEmpty@rows": "Henüz satırınız yok",
        "listIsEmpty@validators": "Henüz herhangi bir doğrulama kuralınız yok",
        "listIsEmpty@calculatedValues": "Henüz özelleştirilebilen değişkeniniz yok",
        "listIsEmpty@triggers": "Henüz herhangi bir tetikleyiciniz yok",
        "listIsEmpty@navigateToUrlOnCondition": "Henüz bağlantınız yok",
        "addNew@choices": "Bir seçenek ekleyin",
        "addNew@columns": "Yeni sütun ekle",
        "addNew@rows": "Yeni satır ekle",
        "addNew@validators": "Yeni kural ekle",
        "addNew@calculatedValues": "Yeni değişken ekle",
        "addNew@triggers": "Yeni tetikleyici ekle",
        "addNew@navigateToUrlOnCondition": "Yeni URL ekle",
        expressionIsEmpty: "Mantıksal ifade boş",
        value: "Değer",
        text: "Yazı",
        rowid: "Satır ID",
        imageLink: "Resim linki",
        columnEdit: "Kolonu düzenle: {0}",
        itemEdit: "Eleman düzenle: {0}",
        url: "URL",
        path: "Yol",
        choicesbyurl: {
            url: "Web hizmetinin URL'si",
            valueName: "Aşağıdaki JSON alanından değerler alın"
        },
        titleName: "Başlık adı",
        imageLinkName: "Aşağıdaki JSON alanından resim URL'leri alın",
        allowEmptyResponse: "Boş cevaba izin ver",
        titlePlaceholder: "Başlık",
        surveyTitlePlaceholder: "Anket başlığı",
        pageTitlePlaceholder: "Sayfa başlığı",
        descriptionPlaceholder: "Bir açıklama giriniz",
        surveyDescriptionPlaceholder: "Anket açıklaması giriniz",
        pageDescriptionPlaceholder: "Sayfa açıklaması giriniz",
        textWrapEnabled: "Sarma seçenekleri",
        showOtherItem: "Başka bir öğeye sahip",
        otherText: "Diğer eleman metni",
        showNoneItem: "Hiçbir elemana sahip değil",
        showRefuseItem: "Yanıtlamayı Reddet seçeneğine izin ver",
        showDontKnowItem: "Bilmiyorum seçeneğine izin ver",
        noneText: "Hiçbir eleman metni",
        showSelectAllItem: "Tüm elemanlar seçildi",
        selectAllText: "Tüm elemanların yazısını seç",
        choicesMin: "Otomatik oluşturulan öğeler için minimum değer",
        choicesMax: "Otomatik oluşturulan öğeler için maksimum değer",
        choicesStep: "Otomatik oluşturulan öğeler arasındaki fark",
        name: "isim",
        title: "Başlık",
        cellType: "Hücre tipi",
        colCount: "Kolon sayısı",
        choicesOrder: "Seçenek sırasını seç",
        visible: "Görünür?",
        isRequired: "Zorunlu?",
        markRequired: "Gerektiği gibi işaretleyin",
        removeRequiredMark: "Gerekli işareti kaldırın",
        isAllRowRequired: "Tüm satırlar zorunlu",
        eachRowUnique: "Satırlarda yinelenen yanıtları önleme",
        requiredErrorText: "Zorunlu hata yazısı",
        startWithNewLine: "Yeni satırla başla?",
        rows: "Satır sayısı",
        cols: "Kolon sayısı",
        placeholder: "Giriş varsayılan içeriği",
        showPreview: "Resim önizleme gösteriliyor mu?",
        storeDataAsText: "Dosya içeriğini JSON sonucunda metin olarak depola",
        maxSize: "Bayt cinsinden maksimum dosya boyutu",
        rowCount: "Satır sayısı",
        columnLayout: "Kolon yerleşimi",
        addRowLocation: "Satır butonu konumu ekle",
        transposeData: "Satırları sütunlara dönüştürme",
        addRowText: "Satır butonu yazısı ekle",
        removeRowText: "Satır butonu yazısını kaldır",
        rateMin: "Minimum oran",
        rateMax: "Maksimum oran",
        rateStep: "Oylama adımı",
        minRateDescription: "Minimum oran açıklaması",
        maxRateDescription: "Maksimum oran açıklaması",
        inputType: "Girdi tipi",
        optionsCaption: "Seçenekler başlığı",
        defaultValue: "Varsayılan değer",
        cellsDefaultRow: "Varsayılan hücre yazısı",
        surveyEditorTitle: "Anket ayarlarını düzenle",
        qEditorTitle: "Düzenle: {0}",
        maxLength: "Maksimum uzunluk",
        buildExpression: "Kur",
        editExpression: "Düzenle",
        and: "ve",
        or: "veya",
        remove: "Kaldır",
        addCondition: "Koşul ekle",
        emptyLogicPopupMessage: "Koşulları yapılandırmaya başlamak için bir soru seçin.",
        if: "Eğer",
        then: "sonra",
        setToName: "Hedef soru",
        fromName: "Cevabın kopyalanacağı soru",
        gotoName: "Atlanacak soru",
        ruleIsNotSet: "Kural yanlış",
        includeIntoResult: "Anket sonuçlarına dahil etme",
        showTitle: "Başlığı göster/gizle",
        expandCollapseTitle: "Başlığı genişletme/daraltma",
        locale: "Varsayılan dil",
        simulator: "Cihaz seçin",
        landscapeOrientation: "Yatay",
        portraitOrientation: "Dikey yöne geçme",
        mode: "Mod (düzenlebilir/düzenlenemez)",
        clearInvisibleValues: "Görünmez değerleri sil",
        cookieName: "Çerez adı (anketi yerel olarak iki kez devre dışı bırakmak için)",
        sendResultOnPageNext: "Bir sonraki sayfada anket sonuçlarını gönder",
        storeOthersAsComment: "'Diğerleri' değerini ayrı alanda depolayın",
        showPageTitles: "Sayfa başlıklarını göster",
        showPageNumbers: "Sayfa numaralarını göster",
        pagePrevText: "Önceki sayfa butonu metni",
        pageNextText: "Yeni sayfa butonu metni",
        completeText: "Tamamla butonu metni",
        previewText: "Önizleme düğmesi metni",
        editText: "Düğme metnini düzenle",
        startSurveyText: "Başla butonu yazısı",
        showNavigationButtons: "Gezinme butonlarını göster (varsayılan gezinme)",
        showPrevButton: "Önceki butonu göster (kullanıcı önceki sayfaya dönebilir)",
        firstPageIsStarted: "Anketteki ilk sayfa bir başlangıç sayfasıdır.",
        showCompletedPage: "Tamamlanan sayfayı en sonunda göster (HTML)",
        goNextPageAutomatic: "Tüm soruları cevaplarken otomatik olarak sonraki sayfaya git",
        allowCompleteSurveyAutomatic: "Anketi otomatik olarak tamamlama",
        showProgressBar: "İlerleme çubuğunu göster",
        questionTitleLocation: "Soru başlığı konumu",
        questionTitleWidth: "Soru başlığı genişliği",
        requiredText: "Zorunlu soru sembolü",
        questionTitleTemplate: "Soru başlığı şablonu, varsayılan değer: '{no}. {require} {title}'",
        questionErrorLocation: "Soru hatası konumu",
        focusFirstQuestionAutomatic: "İlk soruyu sayfayı değiştirmeye odakla",
        questionsOrder: "Sayfadaki öğelerin sırası",
        maxTimeToFinish: "Anketi bitirmek için maksimum süre",
        maxTimeToFinishPage: "Ankette bir sayfayı bitirmek için maksimum süre",
        showTimerPanel: "Zamanlayıcı panelini göster",
        showTimerPanelMode: "Zamanlayıcı paneli modunu göster",
        renderMode: "İşleme modu",
        allowAddPanel: "Panel eklemeye izin ver",
        allowRemovePanel: "Panel silmeye izin ver",
        panelAddText: "Panel ekleme metni",
        panelRemoveText: "Panel silme metni",
        isSinglePage: "Tüm öğeleri tek bir sayfada göster",
        html: "Html",
        setValue: "Cevap",
        dataFormat: "Görüntü formatı",
        allowAddRows: "Satır eklemeye izin ver",
        allowRemoveRows: "Satırların kaldırılmasına izin ver",
        allowRowsDragAndDrop: "Satır sürükleyip bırakmaya izin ver",
        responsiveImageSizeHelp: "Tam görüntü genişliğini veya yüksekliğini belirtirseniz uygulanmaz.",
        minImageWidth: "Minimum görüntü genişliği",
        maxImageWidth: "Maksimum görüntü genişliği",
        minImageHeight: "Minimum görüntü yüksekliği",
        maxImageHeight: "Maksimum görüntü yüksekliği",
        minValue: "Minimum değer",
        maxValue: "Maksimum değer",
        minLength: "Minimum uzunluk",
        allowDigits: "Rakamlara izin ver",
        minCount: "Minimum miktar",
        maxCount: "Maksimum miktar",
        regex: "Düzenli ifade",
        surveyvalidator: {
            text: "Hata mesajı",
            expression: "Doğrulama ifadesi"
        },
        totalText: "Toplam metni",
        totalType: "Toplam tipi",
        totalExpression: "Toplam mantıksal ifade",
        totalDisplayStyle: "Toplam görünüm",
        totalCurrency: "Toplam para birimi",
        totalFormat: "Toplam format",
        logo: "Logo (URL veya base64 kodlu dize)",
        questionsOnPageMode: "Anket yapısı",
        maxTextLength: "Maksimum metin uzunluğu",
        maxOthersLength: "Maksimum diğerleri uzunluğu",
        commentAreaRows: "Yorum alanı yüksekliği (satırlar halinde)",
        autoGrowComment: "Gerekirse yorum alanını otomatik olarak genişletin",
        allowResizeComment: "Kullanıcıların metin alanlarını yeniden boyutlandırmasına izin verme",
        textUpdateMode: "Metin sorusu değerini güncelleme",
        maskType: "Giriş maskesi türü",
        maskTypes: {
            none: "Hiç kimse",
            patternmask: "Desen",
            numericmask: "Sayısal",
            datetimemask: "Tarih ve Saat",
            currencymask: "Para birimi"
        },
        focusOnFirstError: "İlk hataya odaklan",
        checkErrorsMode: "Çalıştırma doğrulaması",
        navigateToUrl: "URL'ye gidin",
        navigateToUrlOnCondition: "Dinamik URL",
        completedBeforeHtml: "Kullanıcının bu anketi zaten doldurup doldurmadığını göstermek için işaretleme",
        completedHtml: "Anket Sayfa işaretlemesini tamamla",
        completedHtmlOnCondition: "Dinamik Anket Sayfa işaretlemesini tamamla",
        loadingHtml: "Anket modeli yüklenirken gösterilecek işaretleme",
        commentText: "Yorum alanı metni",
        autocomplete: "Otomatik tamamlama türü",
        labelTrue: "\"Doğru\" etiketi",
        labelFalse: "\"Yanlış\" etiketi",
        allowClear: "Seçeneklerin başlığını göster",
        searchMode: "Arama Modu",
        displayStyle: "Değer görüntüleme stili",
        format: "Biçimlendirilmiş dize",
        maximumFractionDigits: "Maksimum kesirli basamaklar",
        minimumFractionDigits: "Minimum kesirli basamaklar",
        useGrouping: "Ekran gruplandırma ayırıcıları",
        allowMultiple: "Birden çok dosyaya izin ver",
        allowImagesPreview: "Önizleme görüntüleri",
        acceptedTypes: "Kabul edilen dosya türleri",
        waitForUpload: "Yüklemenin tamamlanmasını bekleyin",
        needConfirmRemoveFile: "Dosya silme işlemini onaylama",
        detailPanelMode: "Ayrıntı paneli konumu",
        minRowCount: "Minimum satır sayısı",
        maxRowCount: "Maksimum satır sayısı",
        confirmDelete: "Satır silme işlemini onaylama",
        confirmDeleteText: "Onay mesajı",
        panelCount: "İlk panel sayısı",
        minPanelCount: "Minimum panel sayısı",
        maxPanelCount: "Maksimum panel sayısı",
        panelsState: "İç panel genişletme durumu",
        panelPrevText: "Önceki Panel düğmesi araç ipucu",
        panelNextText: "Sonraki Panel düğmesi araç ipucu",
        showRangeInProgress: "İlerleme çubuğunu göster",
        panelRemoveButtonLocation: "Panel düğmesinin konumunu kaldır",
        hideIfRowsEmpty: "Satır yoksa soruyu gizleme",
        hideColumnsIfEmpty: "Satır yoksa sütunları gizleme",
        rateValues: "Özel fiyat değerleri",
        rateCount: "Oran sayısı",
        autoGenerate: "Fiyat değerleri nasıl belirlenir?",
        hideIfChoicesEmpty: "Seçenek içermiyorsa soruyu gizleme",
        minWidth: "Minimum genişlik (CSS tarafından kabul edilen değerlerde)",
        maxWidth: "Maksimum genişlik (CSS tarafından kabul edilen değerlerde)",
        width: "Genişlik (CSS tarafından kabul edilen değerlerde)",
        showHeader: "Sütun başlıklarını göster",
        horizontalScroll: "Yatay kaydırma çubuğunu göster",
        columnMinWidth: "Minimum sütun genişliği (CSS tarafından kabul edilen değerlerde)",
        rowTitleWidth: "Satır başlığı genişliği (CSS tarafından kabul edilen değerlerde)",
        valueTrue: "\"Doğru\" değer",
        valueFalse: "\"False\" değeri",
        minErrorText: "\"Değer minimumun altında\" hata iletisi",
        maxErrorText: "\"Değer maksimumu aşıyor\" hata iletisi",
        otherErrorText: "\"Boş yorum\" hata iletisi",
        keyDuplicationError: "\"Benzersiz olmayan anahtar değeri\" hata iletisi",
        minSelectedChoices: "Seçilen minimum seçenekler",
        maxSelectedChoices: "Seçilen maksimum seçenek sayısı",
        showClearButton: "Temizleme butonunu göster",
        logoWidth: "Logo genişlik",
        logoHeight: "Logo uzunluk",
        readOnly: "Salt okunur",
        enableIf: "Şu durumlarda düzenlenebilir",
        emptyRowsText: "\"Satır yok\" iletisi",
        separateSpecialChoices: "Ayrı özel seçenekler (Yok, Diğer, Tümünü Seç)",
        choicesFromQuestion: "Aşağıdaki sorudan seçenekleri kopyalama",
        choicesFromQuestionMode: "Hangi seçenekleri kopyalamalıyım?",
        progressBarShowPageTitles: "Sayfa başlıklarını ilerleme çubuğunda görüntüleme",
        progressBarShowPageNumbers: "İlerleme çubuğunda sayfa numaralarını görüntüleme",
        showCommentArea: "Yorumu var",
        commentPlaceholder: "Yorum alanı yer tutucusu",
        displayRateDescriptionsAsExtremeItems: "Hız açıklamalarını aşırı değerler olarak görüntüleme",
        rowsOrder: "Satır sırası",
        columnsLayout: "Sütun düzeni",
        columnColCount: "İç içe geçmiş sütun sayısı",
        correctAnswer: "Doğru Cevap",
        defaultPanelValue: "Varsayılan Değerler",
        cells: "Hücre Metinleri",
        fileInputPlaceholder: "Bir dosya seçin veya bir dosya bağlantısı yapıştırın...",
        keyName: "Anahtar sütunu",
        itemvalue: {
            visibleIf: "Aşağıdaki durumlarda seçeneği görünür hale getirin",
            enableIf: "Aşağıdaki durumlarda seçeneği seçilebilir hale getirin"
        },
        "itemvalue@rows": {
            visibleIf: "Aşağıdaki durumlarda satırı görünür hale getirin",
            enableIf: "Aşağıdaki durumlarda satırı düzenlenebilir hale getirin"
        },
        imageitemvalue: {
            text: "Alternatif metin"
        },
        logoPosition: "Logo pozisyonu",
        addLogo: "Logo ekle...",
        changeLogo: "Logoyu değiştir...",
        logoPositions: {
            none: "Logoyu kaldır",
            left: "Sol",
            right: "Sağ",
            top: "Üstte",
            bottom: "Altta"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Panel Düzeni"
            },
            general: "Genel",
            fileOptions: "Seçenekler",
            html: "Html Editor",
            columns: "Kolonlar",
            rows: "Satırlar",
            choices: "Seçenekler",
            items: "Elemanlar",
            visibleIf: "Göster eğer",
            enableIf: "Pasifleştir Eğer",
            requiredIf: "Zorunlu Eğer",
            rateValues: "Oran değerleri",
            choicesByUrl: "Webten seçenekler",
            matrixChoices: "Varsayılan seçenekler",
            multipleTextItems: "Yazı girdileri",
            numbering: "Rakamlama",
            validators: "Doğrulayıcılar",
            navigation: "Gezinme",
            question: "Soru",
            pages: "Sayfalar",
            timer: "Zamanlayıcı / Sınav",
            calculatedValues: "Hesaplanan Değerler",
            triggers: "Tetikleyiciler",
            templateTitle: "Şablon başlığı",
            totals: "Toplamlar",
            logic: "Mantık",
            mask: "Giriş Maskesi Ayarları",
            layout: {
                panel: "Düzen",
                question: "Düzen",
                base: "Düzen"
            },
            data: "Veri",
            validation: "Doğrulayıcı",
            cells: "Hücreler",
            showOnCompleted: "Tamamlandı Göster",
            logo: "Anket Başlığında Logo",
            slider: "Kaydırıcı",
            expression: "İfade",
            questionSettings: "Soru Ayarları",
            header: "Üstbilgi",
            background: "Arka plan",
            appearance: "Görünüş",
            others: "Diğer"
        },
        editProperty: "Özelliği düzenle '{0}'",
        items: "[ Elemanlar: {0} ]",
        choicesVisibleIf: "Seçenekler şu durumlarda görünür:",
        choicesEnableIf: "Seçenekler şu durumlarda seçilebilir:",
        columnsEnableIf: "Sütunlar şu durumlarda görünür:",
        rowsEnableIf: "Satırlar şu durumlarda görünür:",
        innerIndent: "İç girintiler ekleme",
        defaultValueFromLastRow: "Son satırdaki varsayılan değerleri alma",
        defaultValueFromLastPanel: "Son panelden varsayılan değerleri alma",
        enterNewValue: "Lütfen, değer girin.",
        noquestions: "Ankette herhangi bir soru yok.",
        createtrigger: "Lütfen bir tetikleyici oluşturun",
        titleKeyboardAdornerTip: "Düzenlemek için enter düğmesine basın",
        keyboardAdornerTip: "Öğeyi düzenlemek için enter butonuna basın, öğeyi silmek için sil butonuna basın, öğeyi taşımak için kontrol artı ok yukarı veya ok tuşuna basın",
        triggerOn: "Açık ",
        triggerMakePagesVisible: "Sayfaları görünür yap:",
        triggerMakeQuestionsVisible: "Elemanları görünür yap:",
        triggerCompleteText: "Başarılı olursa anketi tamamlayın.",
        triggerNotSet: "Tetikleyici ayarlanmadı",
        triggerRunIf: "Çalıştır eğer",
        triggerSetToName: "Değerini şuradan değiştir: ",
        triggerFromName: "Değerini şuradan kopyala: ",
        triggerRunExpression: "Mantıksal ifadeyi çalıştır:",
        triggerSetValue: "şuraya: ",
        triggerGotoName: "Soruya git:",
        triggerIsVariable: "Değişkeni anket sonucuna koymayın.",
        triggerRunExpressionEmpty: "Lütfen geçerli bir ifade girin",
        emptyExpressionPlaceHolder: "İfadeyi buraya yazın...",
        noFile: "Hiçbir dosya seçilmedi",
        clearIfInvisible: "Soru gizlenirse değeri temizleyin",
        valuePropertyName: "Değer özelliği adı",
        searchEnabled: "Aramayı etkinleştir",
        hideSelectedItems: "Seçili öğeleri gizle",
        closeOnSelect: "Seçimden sonra açılır menüyü kapatın",
        verticalAlign: "Dikey hizalama",
        alternateRows: "Alternatif satırlar",
        columnsVisibleIf: "Sütunlar şu durumlarda görünür:",
        rowsVisibleIf: "Satırlar şu durumlarda görünür:",
        otherPlaceholder: "Yorum alanı yer tutucusu",
        filePlaceholder: "Dosya yer tutucu metni",
        photoPlaceholder: "Fotoğraf yer tutucu metni",
        fileOrPhotoPlaceholder: "Dosya veya fotoğraf yer tutucu metni",
        rateType: "Fiyat türü",
        url_placeholder: "Ör.: https://api.example.com/books",
        path_placeholder: "Ör.: kategoriler.kurgu",
        questionStartIndex_placeholder: "Örn.: a)",
        width_placeholder: "Ör.: 6 inç",
        minWidth_placeholder: "Ör.: 600 piksel",
        maxWidth_placeholder: "Ör.: %50",
        imageHeight_placeholder: "Otomatik",
        imageWidth_placeholder: "Otomatik",
        theme: {
            themeName: "Tema",
            isPanelless: "Soru görünümü",
            editorPanel: "Arka plan ve köşe yarıçapı",
            questionPanel: "Arka plan ve köşe yarıçapı",
            primaryColor: "Vurgu rengi",
            panelBackgroundTransparency: "Panel arka plan opaklığı",
            questionBackgroundTransparency: "Soru arka plan opaklığı",
            fontSize: "Yazı boyutu",
            scale: "Ölçeklemek",
            cornerRadius: "Köşe yarıçapı",
            pageTitle: "Başlık yazı tipi",
            pageDescription: "Açıklama yazı tipi",
            questionTitle: "Başlık yazı tipi",
            questionDescription: "Açıklama yazı tipi",
            editorFont: "Yazı tipi",
            backgroundOpacity: "Opak -lık",
            "--sjs-font-family": "Yazı tipi ailesi",
            "--sjs-general-backcolor-dim": "Arka plan rengi",
            "--sjs-primary-backcolor": "Vurgu arka planı",
            "--sjs-primary-forecolor": "Vurgu ön planı",
            "--sjs-special-red": "Hata mesajları",
            "--sjs-shadow-small": "Gölge efektleri",
            "--sjs-shadow-inner": "Gölge efektleri",
            "--sjs-border-default": "Renk"
        },
        "header@header": {
            headerView: "Görünüm",
            logoPosition: "Logo konumu",
            surveyTitle: "Anket başlığı yazı tipi",
            surveyDescription: "Anket açıklaması yazı tipi",
            headerTitle: "Anket başlığı yazı tipi",
            headerDescription: "Anket açıklaması yazı tipi",
            inheritWidthFrom: "İçerik alanı genişliği",
            textAreaWidth: "Metin genişliği",
            backgroundColorSwitch: "Arka plan rengi",
            backgroundImage: "Arka plan resmi",
            backgroundImageOpacity: "Opak -lık",
            overlapEnabled: "Örtüş",
            logoPositionX: "Logo konumu",
            titlePositionX: "Unvan pozisyonu",
            descriptionPositionX: "Açıklama konumu"
        }
    },
    // Property values
    pv: {
        "true": "doğru",
        "false": "yanlış",
        file: "Yerel dosyalar",
        camera: "Kamera",
        "file-camera": "Yerel dosyalar veya kamera",
        inherit: "Başlangıç",
        show: "Göster",
        hide: "Gizle",
        default: "Varsayılan",
        initial: "Başlangıç",
        random: "Rastgele",
        collapsed: "Kapalı",
        expanded: "Genişletilmiş",
        none: "Yok",
        asc: "Artan",
        desc: "Azalan",
        indeterminate: "Belirsiz",
        selected: "Seçilmiş",
        unselected: "Seçili",
        decimal: "On -da -lık",
        currency: "para birimi",
        percent: "yüzde",
        firstExpanded: "firstExpanded",
        off: "Kapalı",
        list: "Liste",
        progressTop: "progressTop",
        progressBottom: "progressBottom",
        progressTopBottom: "progressTopBottom",
        tab: "Sekmeler",
        horizontal: "Yatay",
        vertical: "Dikey",
        top: "Üst",
        bottom: "Alt",
        topBottom: "Üst ve alt",
        both: "Her ikiside",
        left: "Sol",
        right: "Sağ",
        center: "Orta",
        leftRight: "Sol ve sağ",
        middle: "Orta",
        color: "Renk",
        date: "tarih",
        datetime: "datetime",
        "datetime-local": "datetime-yerel",
        email: "E-posta",
        month: "ay",
        number: "sayı",
        password: "parola",
        range: "aralık",
        tel: "telefon",
        text: "Metin",
        time: "Saat",
        url: "URL",
        week: "hafta",
        hidden: "Gizli",
        edit: "Düzenle",
        display: "Görüntüle",
        contain: "Kapsamak",
        cover: "Örtmek",
        fill: "Doldurmak",
        next: "Önümüzdeki",
        last: "Son",
        onComplete: "Tamamlandığında",
        onHidden: "Gizlendiğinde",
        onHiddenContainer: "Soru veya paneli/sayfası gizlendiğinde",
        clearInvisibleValues: {
            none: "Hiç"
        },
        clearIfInvisible: {
            none: "Hiç"
        },
        inputType: {
            color: "Renk",
            date: "Tarih",
            "datetime-local": "Tarih ve Saat",
            email: "E-posta",
            month: "Ay",
            number: "Sayı",
            password: "Parola",
            range: "Aralık",
            tel: "Telefon numarası",
            text: "Metin",
            time: "Saat",
            url: "URL",
            week: "Hafta"
        },
        all: "Tümü",
        page: "Sayfa",
        survey: "Anket",
        onNextPage: "Sonraki sayfada",
        onValueChanged: "Değer değiştiğinde",
        onValueChanging: "Bir yanıt değiştirilmeden önce",
        questionsOnPageMode: {
            standard: "Orijinal yapı",
            singlePage: "Tüm soruları tek bir sayfada göster",
            questionPerPage: "Sayfa başına tek bir soru göster"
        },
        noPreview: "Önizleme yok",
        showAllQuestions: "Tüm soruları göster",
        showAnsweredQuestions: "Cevaplanan soruları göster",
        pages: "Tamamlanan sayfalar",
        questions: "Sorular",
        requiredQuestions: "Gerekli sorular",
        correctQuestions: "Doğru sorular",
        buttons: "Butonlar",
        underInput: "Giriş altında",
        underTitle: "Başlık altında",
        onBlur: "Bulanıklaştırmada",
        onTyping: "Yazarken",
        underRow: "Satırın altında",
        underRowSingle: "Satırın altında yalnızca bir panel görünür",
        auto: "Otomatik",
        showNavigationButtons: {
            none: "Gizli"
        },
        showTimerPanel: {
            none: "Gizli"
        },
        showTimerPanelMode: {
            all: "Her ikisi"
        },
        addRowLocation: {
            default: "Matris düzenine bağlıdır"
        },
        panelsState: {
            default: "Kullanıcılar panelleri genişletemez veya daraltamaz",
            collapsed: "Tüm paneller daraltıldı",
            expanded: "Tüm paneller genişletildi",
            firstExpanded: "İlk genişletildi"
        },
        widthMode: {
            static: "Duruk",
            responsive: "Duyarlı"
        },
        contentMode: {
            image: "Resim",
            video: "Video",
            youtube: "Videolar"
        },
        displayMode: {
            buttons: "Düğme",
            dropdown: "Açılır menü"
        },
        rateColorMode: {
            default: "Temerrüt",
            scale: "Ölçeklemek"
        },
        scaleColorMode: {
            monochrome: "Monokrom",
            colored: "Renkli"
        },
        autoGenerate: {
            "true": "Oluşturmak",
            "false": "Manuel olarak girme"
        },
        rateType: {
            labels: "Etiket",
            stars: "Yıldız",
            smileys: "Suratlar"
        },
        state: {
            default: "Kilitli"
        },
        showQuestionNumbers: {
            default: "Otomatik numaralandırma",
            on: "Otomatik numaralandırma",
            onPage: "Her sayfada sıfırla",
            onpanel: "Her panelde sıfırla",
            onPanel: "Her panelde sıfırla",
            onSurvey: "Ankete devam edin",
            off: "Numaralandırma yok"
        },
        descriptionLocation: {
            underTitle: "Soru başlığı altında",
            underInput: "Giriş alanının altında"
        },
        selectToRankAreasLayout: {
            horizontal: "Seçeneklerin yanında",
            vertical: "Yukarıdaki seçenekler"
        },
        displayStyle: {
            decimal: "On -da -lık",
            currency: "Para birimi",
            percent: "Yüzde",
            date: "Tarih"
        },
        totalDisplayStyle: {
            decimal: "On -da -lık",
            currency: "Para birimi",
            percent: "Yüzde",
            date: "Tarih"
        },
        rowsOrder: {
            initial: "Özgün"
        },
        questionsOrder: {
            initial: "Özgün"
        },
        showProgressBar: {
            off: "Gizli",
            topbottom: "Üst ve alt",
            aboveheader: "Başlığın üstünde",
            belowheader: "Başlığın altında"
        },
        sum: "Toplam",
        count: "Saymak",
        min: "Min",
        max: "Max",
        avg: "Avg",
        searchMode: {
            contains: "Içerir",
            startsWith: "İle başlar"
        },
        backgroundImageFit: {
            auto: "Otomatik",
            cover: "Örtmek",
            contain: "Kapsamak",
            fill: "Uzatmak",
            tile: "Kiremit"
        },
        backgroundImageAttachment: {
            fixed: "Sabit",
            scroll: "Tomar"
        },
        headerView: {
            basic: "Temel",
            advanced: "İleri"
        },
        inheritWidthFrom: {
            survey: "Anketle aynı",
            container: "Konteynere sığdır"
        },
        backgroundColorSwitch: {
            none: "Hiç kimse",
            accentColor: "Vurgu rengi",
            custom: "Töre"
        },
        colorPalette: {
            light: "Işık",
            dark: "Koyu"
        },
        isPanelless: {
            "false": "Temerrüt",
            "true": "Panelsiz"
        }
    },
    // Operators
    op: {
        empty: "boş",
        notempty: "boş değil",
        equal: "eşittir",
        notequal: "eşit değildir",
        contains: "içerir",
        notcontains: "içermez",
        anyof: "herhangi biri",
        allof: "tümü",
        greater: "büyüktür",
        less: "küçüktür",
        greaterorequal: "büyük eşittir",
        lessorequal: "küçük eşittir",
        and: "ve",
        or: "veya"
    },
    // Embed window
    ew: {
        angular: "Angular versiyonu kullan",
        jquery: "Jquery versiyonu kullan",
        knockout: "Knockout versiyonu kullan",
        react: "React versiyonu kullan",
        vue: "Vue versiyonu kullan",
        bootstrap: "Bootstrap",
        modern: "Modern tema",
        default: "Varsayılan tema",
        orange: "Turuncu tema",
        darkblue: "Lacivert tema",
        darkrose: "Darkrose teması",
        stone: "Taş teması",
        winter: "Kış teması",
        winterstone: "Kış-Taş teması",
        showOnPage: "Bir sayfada anket göster",
        showInWindow: "Anketi bir pencerede göster",
        loadFromServer: "Anket JSON'u sunucudan yükle",
        titleScript: "Scriptler ve stiller",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Test edilecek sayfayı seçin:",
        showInvisibleElements: "Görünmez öğeleri göster",
        hideInvisibleElements: "Görünmez öğeleri gizleme"
    },
    validators: {
        answercountvalidator: "cevap sayısı",
        emailvalidator: "e-mail",
        expressionvalidator: "ifade",
        numericvalidator: "numerik",
        regexvalidator: "regex",
        textvalidator: "text"
    },
    triggers: {
        completetrigger: "anketi tamamla",
        setvaluetrigger: "değeri ayarla",
        copyvaluetrigger: "değeri kopyala",
        skiptrigger: "soruyu atla",
        runexpressiontrigger: "mantıksal ifadeyi çalıştır",
        visibletrigger: "görünürlüğü değiştir (kullanımdan kaldırıldı)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Ör.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Ör.: aa/gg/yyyy"
        },
        currencymask: {
            prefix: "Ör.: $",
            suffix: "Ör.: USD"
        },
        panelbase: {
            questionTitleWidth: "Ör.: 200 piksel"
        }
    },
    pehelp: {
        panel: {
            name: "Yanıtlayanlar tarafından görülemeyen bir panel kimliği.",
            description: "Bir panel altyazısı yazın.",
            visibleIf: "Panel görünürlüğünü belirleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın.",
            enableIf: "Panelin salt okunur modunu devre dışı bırakan koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın.",
            requiredIf: "En az bir iç içe geçmiş sorunun yanıtı olmadığı sürece anket gönderimini engelleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın.",
            questionTitleLocation: "Bu paneldeki tüm sorular için geçerlidir. Bu ayarı geçersiz kılmak istiyorsanız, tek tek sorular için başlık hizalama kuralları tanımlayın. \"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını (varsayılan olarak \"Üst\") uygular.",
            questionTitleWidth: "Soru kutularının soluna hizalandıklarında soru başlıkları için tutarlı genişlik ayarlar. CSS değerlerini (px, %, in, pt, vb.) kabul eder.",
            questionErrorLocation: "Paneldeki tüm sorularla ilgili olarak bir hata mesajının konumunu ayarlar. \"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını uygular.",
            questionsOrder: "Soruların orijinal sırasını korur veya rastgele hale getirir. \"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını uygular.",
            page: "Paneli seçili sayfanın sonuna yeniden konumlandırır.",
            innerIndent: "Panel içeriği ile panel kutusunun sol kenarlığı arasına boşluk veya kenar boşluğu ekler.",
            startWithNewLine: "Panelin önceki soru veya panelle aynı satırda görüntülenmesi için seçimi kaldırın. Panel formunuzdaki ilk öğeyse bu ayar uygulanmaz.",
            state: "Şunlar arasından seçim yapın: \"Genişletilmiş\" - panel tam olarak görüntülenir ve daraltılabilir; \"Daraltılmış\" - panel yalnızca başlığı ve açıklamayı görüntüler ve genişletilebilir; \"Kilitli\" - panel tam olarak görüntülenir ve daraltılamaz.",
            width: "Panelin genişliğini aynı satırdaki diğer anket öğeleriyle orantılı olarak ayarlar. CSS değerlerini (px, %, in, pt, vb.) kabul eder."
        },
        paneldynamic: {
            name: "Yanıtlayanlar tarafından görülemeyen bir panel kimliği.",
            description: "Bir panel altyazısı yazın.",
            visibleIf: "Panel görünürlüğünü belirleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın.",
            enableIf: "Panelin salt okunur modunu devre dışı bırakan koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın.",
            requiredIf: "En az bir iç içe geçmiş sorunun yanıtı olmadığı sürece anket gönderimini engelleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın.",
            templateTitleLocation: "Bu paneldeki tüm sorular için geçerlidir. Bu ayarı geçersiz kılmak istiyorsanız, tek tek sorular için başlık hizalama kuralları tanımlayın. \"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını (varsayılan olarak \"Üst\") uygular.",
            templateErrorLocation: "Geçersiz girişi olan bir soruyla ilgili olarak bir hata mesajının konumunu ayarlar. Şunlar arasından seçim yapın: \"Üst\" - soru kutusunun en üstüne bir hata metni yerleştirilir; \"Alt\" - soru kutusunun altına bir hata metni yerleştirilir. \"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını (varsayılan olarak \"Üst\") uygular.",
            errorLocation: "Paneldeki tüm sorularla ilgili olarak bir hata mesajının konumunu ayarlar. \"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını uygular.",
            page: "Paneli seçili sayfanın sonuna yeniden konumlandırır.",
            innerIndent: "Panel içeriği ile panel kutusunun sol kenarlığı arasına boşluk veya kenar boşluğu ekler.",
            startWithNewLine: "Panelin önceki soru veya panelle aynı satırda görüntülenmesi için seçimi kaldırın. Panel formunuzdaki ilk öğeyse bu ayar uygulanmaz.",
            state: "Şunlar arasından seçim yapın: \"Genişletilmiş\" - panel tam olarak görüntülenir ve daraltılabilir; \"Daraltılmış\" - panel yalnızca başlığı ve açıklamayı görüntüler ve genişletilebilir; \"Kilitli\" - panel tam olarak görüntülenir ve daraltılamaz.",
            width: "Panelin genişliğini aynı satırdaki diğer anket öğeleriyle orantılı olarak ayarlar. CSS değerlerini (px, %, in, pt, vb.) kabul eder.",
            templateTitle: "Dinamik panel başlıkları için bir şablon yazın. Panelin genel konumu için {panelIndex} ve görünür paneller arasındaki sırası için {visiblePanelIndex} kullanın. Otomatik numaralandırma eklemek için bu yer tutucuları desene ekleyin.",
            templateTabTitle: "Sekme başlıkları için bir şablon yazın. Panelin genel konumu için {panelIndex} ve görünür paneller arasındaki sırası için {visiblePanelIndex} kullanın. Otomatik numaralandırma eklemek için bu yer tutucuları desene ekleyin.",
            tabTitlePlaceholder: "Sekme başlığı deseni anlamlı bir değer üretmediğinde geçerli olan sekme başlıkları için bir geri dönüş metni.",
            templateVisibleIf: "Bu ayar, dinamik panel içindeki tek tek panellerin görünürlüğünü kontrol etmenizi sağlar. İfadenizdeki geçerli panele başvurmak için '{panel}' yer tutucusunu kullanın.",
            titleLocation: "Bu ayar, bu paneldeki tüm sorular tarafından otomatik olarak devralınır. Bu ayarı geçersiz kılmak istiyorsanız, tek tek sorular için başlık hizalama kuralları tanımlayın. \"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını (varsayılan olarak \"Üst\") uygular.",
            descriptionLocation: "\"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını (varsayılan olarak \"Panel başlığı altında\") uygular.",
            newPanelPosition: "Yeni eklenen panelin konumunu tanımlar. Varsayılan olarak, sonuna yeni paneller eklenir. Geçerli panelden sonra yeni bir panel eklemek için \"İleri\" yi seçin.",
            defaultValueFromLastPanel: "Son paneldeki yanıtları çoğaltır ve bir sonraki eklenen dinamik panele atar.",
            keyName: "Kullanıcının her panelde bu soruya benzersiz bir yanıt vermesini zorunlu kılmak için bir soru adına başvurun."
        },
        defaultValueExpression: "Bu ayar, bir ifadeye göre varsayılan bir yanıt değeri atamanıza olanak tanır. İfade temel hesaplamaları içerebilir - '{q1_id} + {q2_id}', '{age} > 60' gibi Boole ifadeleri ve işlevler: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' vb. Bu ifade tarafından belirlenen değer, yanıtlayanın manuel girişi tarafından geçersiz kılınabilecek ilk varsayılan değer olarak işlev görür.",
        resetValueIf: "Yanıtlayanın girişinin ne zaman \"Varsayılan değer ifadesi\" veya \"Değer ifadesi ayarla\" ya da \"Varsayılan yanıt\" değerine (ayarlanmışsa) dayalı değere ne zaman sıfırlanacağını belirleyen bir koşullu kural ayarlamak için sihirli değnek simgesini kullanın.",
        setValueIf: "\"Değer ayarla ifadesinin\" ne zaman çalıştırılacağını belirleyen koşullu bir kural belirlemek ve elde edilen değeri yanıt olarak dinamik olarak atamak için sihirli değnek simgesini kullanın.",
        setValueExpression: "\"Şu durumda değer ayarla\" kuralındaki koşullar karşılandığında ayarlanacak değeri tanımlayan bir ifade belirtin. İfade temel hesaplamaları içerebilir - '{q1_id} + {q2_id}', '{age} > 60' gibi Boole ifadeleri ve işlevler: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' vb. Bu ifade tarafından belirlenen değer, yanıtlayanın manuel girişi tarafından geçersiz kılınabilir.",
        question: {
            name: "Yanıtlayanlar tarafından görülemeyen bir soru kimliği.",
            description: "Bir soru alt başlığı yazın.",
            visibleIf: "Soru görünürlüğünü belirleyen koşullu bir kural belirlemek için sihirli değnek simgesini kullanın.",
            enableIf: "Soru için salt okunur modunu devre dışı bırakan koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın.",
            requiredIf: "Soru yanıt almadıkça anketin ilerlemesini veya gönderilmesini engelleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın.",
            startWithNewLine: "Soruyu, önceki soru veya panelle birlikte tek satırda görüntülemek için seçimi kaldırın. Soru formunuzdaki ilk öğeyse bu ayar geçerli değildir.",
            page: "Soruyu seçili sayfanın sonuna konumlandırır.",
            state: "Şunlar arasından seçim yapın: \"Genişletilmiş\" - soru kutusu tam olarak görüntülenir ve daraltılabilir; \"Daraltılmış\" - soru kutusu yalnızca başlığı ve açıklamayı görüntüler ve genişletilebilir; \"Kilitli\" - soru kutusu tam olarak görüntülenir ve daraltılamaz.",
            titleLocation: "Panel, sayfa veya anket düzeyinde tanımlanan başlık hizalama kurallarını geçersiz kılar. \"Devral\" seçeneği, tüm üst düzey ayarları (ayarlanmışsa) veya anket düzeyindeki ayarları (varsayılan olarak \"Üst\") uygular.",
            descriptionLocation: "\"Devral\" seçeneği, anket düzeyindeki ayarı uygular (varsayılan olarak \"Soru başlığının altında\").",
            errorLocation: "Geçersiz girişi olan soruyla ilgili olarak bir hata mesajının konumunu ayarlar. Şunlar arasından seçim yapın: \"Üst\" - soru kutusunun en üstüne bir hata metni yerleştirilir; \"Alt\" - soru kutusunun altına bir hata metni yerleştirilir. \"Devral\" seçeneği, anket düzeyindeki ayarı uygular (varsayılan olarak \"Üst\").",
            indent: "Soru içeriği ile soru kutusunun sol kenarlığı arasına boşluk veya kenar boşluğu ekler.",
            width: "Sorunun genişliğini, aynı satırdaki diğer anket öğeleriyle orantılı olarak ayarlar. CSS değerlerini (px, %, in, pt, vb.) kabul eder.",
            surveyvalidator: {
                expression: "Soru için bir doğrulama kuralı ayarlamak için sihirli değnek simgesini kullanın."
            },
            textUpdateMode: "Şunlar arasından seçim yapın: \"Odak kaybolduğunda\" - giriş alanı odağı kaybettiğinde değer güncellenir; \"Yazarken\" - değer, kullanıcılar yazarken gerçek zamanlı olarak güncellenir. \"Devral\" seçeneği, anket düzeyindeki ayarı uygular (varsayılan olarak \"Odak kaybolduğunda\").",
            url: "Çoktan seçmeli sorular için herhangi bir web hizmetini veri kaynağı olarak kullanabilirsiniz. Seçim değerlerini doldurmak için, verileri sağlayan hizmetin URL'sini girin.",
            searchMode: "Açılan listeyi filtrelemek için kullanılan bir karşılaştırma işlemi.",
            textWrapEnabled: "Seçim seçeneklerindeki uzun metinler, açılır menüye sığacak şekilde otomatik olarak satır sonları oluşturur. Metinlerin kırpılmasını istiyorsanız seçimi kaldırın."
        },
        signaturepad: {
            signatureWidth: "Görüntülenen imza alanının ve elde edilen görüntünün genişliğini ayarlar.",
            signatureHeight: "Görüntülenen imza alanının ve elde edilen görüntünün yüksekliğini ayarlar.",
            signatureAutoScaleEnabled: "İmza alanının, varsayılan 3:2 en boy oranını korurken soru kutusundaki tüm kullanılabilir alanı doldurmasını isteyip istemediğinizi seçin. Özel genişlik ve yükseklik değerleri ayarlandığında, ayar bu boyutların en boy oranını korur."
        },
        file: {
            imageHeight: "Anket sonuçlarındaki görüntünün yüksekliğini ayarlar.",
            imageWidth: "Anket sonuçlarındaki görüntünün genişliğini ayarlar."
        },
        image: {
            contentMode: "\"Otomatik\" seçeneği, sağlanan kaynak URL'ye göre görüntüleme için uygun modu (Resim, Video veya YouTube) otomatik olarak belirler."
        },
        imagepicker: {
            imageHeight: "Minimum ve maksimum yükseklik değerlerini geçersiz kılar.",
            imageWidth: "Minimum ve maksimum genişlik değerlerini geçersiz kılar.",
            choices: "\"Değer\", koşullu kurallarda kullanılan bir öğe kimliği görevi görür; Yanıtlayanlara \"Metin\" gösterilir.",
            contentMode: "Medya seçicinin içerik modunu ayarlamak için \"Görüntü\" ve \"Video\" arasında seçim yapın. \"Resim\" seçilirse, sağlanan tüm seçeneklerin şu biçimlerdeki resim dosyaları olduğundan emin olun: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Benzer şekilde, \"Video\" seçilirse, tüm seçeneklerin aşağıdaki formatlardaki video dosyalarına doğrudan bağlantılar olduğundan emin olun: MP4, MOV, WMV, FLV, AVI, MKV. Video seçenekleri için YouTube bağlantılarının desteklenmediğini lütfen unutmayın."
        },
        text: {
            size: "Bu ayar yalnızca giriş alanını yeniden boyutlandırır ve soru kutusunun genişliğini etkilemez. Kabul edilen giriş uzunluğunu sınırlamak için <b>Doğrulama → Maksimum karakter sınırı'na</b> gidin."
        },
        comment: {
            rows: "Giriş alanında görüntülenen satırların sayısını ayarlar. Giriş daha fazla satır alırsa, kaydırma çubuğu görünecektir."
        },
        // survey templates
        survey: {
            mode: "Şunlar arasından seçim yapın: \"Düzenlenebilir\" - yanıtlayanların anketinizi doldurmasını sağlar; \"Salt okunur\" - form düzenlemeyi devre dışı bırakır."
        },
        matrixdropdowncolumn: {
            name: "Yanıtlayanlar tarafından görülemeyen bir sütun kimliği.",
            isUnique: "Bir sütun için etkinleştirildiğinde, yanıtlayanın bu sütundaki her soru için benzersiz bir yanıt vermesi gerekir.",
            rows: "Giriş alanında görüntülenen satırların sayısını ayarlar. Giriş daha fazla satır alırsa, kaydırma çubuğu görünecektir.",
            visibleIf: "Sütun görünürlüğünü belirleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın.",
            enableIf: "Sütunun salt okunur modunu devre dışı bırakan koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın.",
            requiredIf: "En az bir iç içe geçmiş sorunun yanıtı olmadığı sürece anket gönderimini engelleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın.",
            showInMultipleColumns: "Seçildiğinde, her seçim seçeneği için ayrı bir sütun oluşturur."
        },
        widthMode: "Şunlar arasından seçim yapın: \"Statik\" - sabit bir genişlik ayarlar; \"Duyarlı\" - anketin ekranın tüm genişliğini kaplamasını sağlar; \"Otomatik\" - kullanılan soru türlerine bağlı olarak ikisinden birini uygular.",
        cookieName: "Çerezler, kullanıcıların aynı anketi iki kez doldurmasını engeller.",
        logo: "Bilgisayarınızdan bir dosyaya (64 KB'a kadar) göz atmak için bir resim bağlantısı yapıştırın (boyut sınırı yok) veya klasör simgesini tıklayın.",
        logoWidth: "CSS birimlerinde bir logo genişliği ayarlar (px, %, in, pt, vb.).",
        logoHeight: "CSS birimlerinde (px, %, in, pt, vb.) bir logo yüksekliği ayarlar.",
        logoFit: "Şunlar arasından seçim yapın: \"Yok\" - görüntü orijinal boyutunu korur; \"İçer\" - görüntü, en boy oranı korunurken sığacak şekilde yeniden boyutlandırılır; \"Kapak\" - görüntü, en boy oranını korurken tüm kutuyu doldurur; \"Doldur\" - görüntü, en boy oranını korumadan kutuyu dolduracak şekilde uzatılır.",
        goNextPageAutomatic: "Yanıtlayan geçerli sayfadaki tüm soruları yanıtladıktan sonra anketin otomatik olarak bir sonraki sayfaya ilerlemesini isteyip istemediğinizi seçin.",
        allowCompleteSurveyAutomatic: "Yanıtlayan tüm soruları yanıtladıktan sonra anketin otomatik olarak tamamlanmasını isteyip istemediğinizi seçin.",
        showNavigationButtons: "Sayfadaki gezinme düğmelerinin görünürlüğünü ve konumunu ayarlar.",
        showProgressBar: "İlerleme çubuğunun görünürlüğünü ve konumunu ayarlar. \"Otomatik\" değeri, anket başlığının üstünde veya altında ilerleme çubuğunu görüntüler.",
        showPreviewBeforeComplete: "Önizleme sayfasını tüm sorularla veya yalnızca yanıtlanmış sorularla etkinleştirin.",
        questionTitleLocation: "Anketteki tüm sorular için geçerlidir. Bu ayar, panel, sayfa veya soru gibi daha düşük düzeylerdeki başlık hizalama kuralları tarafından geçersiz kılınabilir. Daha düşük düzeydeki bir ayar, daha yüksek düzeydeki ayarları geçersiz kılar.",
        requiredText: "Bir yanıtın gerekli olduğunu gösteren bir sembol veya sembol dizisi.",
        questionStartIndex: "Numaralandırmaya başlamak istediğiniz sayıyı veya harfi girin.",
        questionErrorLocation: "Geçersiz girişi olan soruyla ilgili olarak bir hata mesajının konumunu ayarlar. Şunlar arasından seçim yapın: \"Üst\" - soru kutusunun en üstüne bir hata metni yerleştirilir; \"Alt\" - soru kutusunun altına bir hata metni yerleştirilir.",
        focusFirstQuestionAutomatic: "Her sayfadaki ilk giriş alanının metin girişi için hazır olmasını istiyorsanız seçin.",
        questionsOrder: "Soruların orijinal sırasını korur veya rastgele hale getirir. Bu ayarın etkisi yalnızca Önizleme sekmesinde görünür.",
        maxTextLength: "Yalnızca metin girişi soruları için.",
        maxOthersLength: "Yalnızca soru yorumları içindir.",
        commentAreaRows: "Soru yorumları için metin alanlarında görüntülenen satır sayısını ayarlar. Girişte daha fazla satır alır, kaydırma çubuğu görünür.",
        autoGrowComment: "Soru yorumlarının ve Uzun Metin sorularının yüksekliğinin girilen metin uzunluğuna göre otomatik olarak büyümesini istiyorsanız seçin.",
        allowResizeComment: "Yalnızca soru yorumları ve Uzun Metin soruları için.",
        calculatedValues: "Özelleştirilebilir değişkenler, form hesaplamalarında kullanılan ara veya yardımcı değişkenler olarak işlev görür. Yanıtlayan girdilerini kaynak değerler olarak alırlar. Her özelleştirilebilen değişkenin benzersiz bir adı ve temel aldığı bir ifadesi vardır.",
        includeIntoResult: "İfadenin hesaplanan değerinin anket sonuçlarıyla birlikte kaydedilmesini isteyip istemediğinizi seçin.",
        triggers: "Tetikleyici, bir ifadeyi temel alan bir olay veya koşuldur. İfade \"true\" olarak değerlendirildikten sonra, bir tetikleyici bir eylemi başlatır. Böyle bir eylemin isteğe bağlı olarak etkilediği bir hedef sorusu olabilir.",
        clearInvisibleValues: "Koşullu mantık tarafından gizlenen sorular için değerlerin temizlenip temizlenmeyeceğini ve bunun ne zaman yapılacağını seçin.",
        textUpdateMode: "Şunlar arasından seçim yapın: \"Odak kaybolduğunda\" - giriş alanı odağı kaybettiğinde değer güncellenir; \"Yazarken\" - değer, kullanıcılar yazarken gerçek zamanlı olarak güncellenir.",
        columns: "Soldaki değer, koşullu kurallarda kullanılan bir sütun kimliği görevi görür, sağdaki değer yanıtlayanlara gösterilir.",
        rows: "Soldaki değer, koşullu kurallarda kullanılan bir satır kimliği görevi görür, sağdaki değer yanıtlayanlara gösterilir.",
        columnMinWidth: "CSS değerlerini (px, %, in, pt, vb.) kabul eder.",
        rowTitleWidth: "CSS değerlerini (px, %, in, pt, vb.) kabul eder.",
        totalText: "Yalnızca en az bir sütunda Toplam türü veya Toplam ifadesi olduğunda görünür.",
        cellErrorLocation: "Geçersiz girişi olan bir hücreyle ilgili olarak bir hata iletisinin konumunu ayarlar. \"Devral\" seçeneği, ayarı \"Hata iletisi hizalaması\" özelliğinden uygular.",
        keyDuplicationError: "\"Yinelenen yanıtları engelle\" özelliği etkinleştirildiğinde, yinelenen bir girdi göndermeye çalışan yanıtlayan aşağıdaki hata iletisini alır.",
        totalExpression: "Bir ifadeye dayalı olarak toplam değerleri hesaplamanıza olanak tanır. İfade, temel hesaplamaları ('{q1_id} + {q2_id}'), Boole ifadelerini ('{age} > 60') ve işlevleri ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' vb.) içerebilir.",
        confirmDelete: "Satır silme işlemini onaylamanızı isteyen bir istemi tetikler.",
        defaultValueFromLastRow: "Son satırdaki yanıtları çoğaltır ve bunları bir sonraki eklenen dinamik satıra atar.",
        keyName: "Belirtilen sütun aynı değerleri içeriyorsa, anket \"Benzersiz olmayan anahtar değeri\" hatasını atar.",
        description: "Bir altyazı yazın.",
        locale: "Anketinizi oluşturmaya başlamak için bir dil seçin. Çeviri eklemek için yeni bir dile geçin ve orijinal metni buradan veya Çeviriler sekmesinden çevirin.",
        detailPanelMode: "Ayrıntılar bölümünün bir satıra göre konumunu ayarlar. Şunlar arasından seçim yapın: \"Yok\" - genişletme eklenmez; \"Satırın altında\" - matrisin her satırının altına bir satır genişletmesi yerleştirilir; \"Satırın altında, yalnızca bir satır genişletmesi görüntüle\" - yalnızca tek bir satırın altında bir genişletme görüntülenir, kalan satır genişletmeleri daraltılır.",
        imageFit: "Şunlar arasından seçim yapın: \"Yok\" - görüntü orijinal boyutunu korur; \"İçer\" - görüntü, en boy oranı korunurken sığacak şekilde yeniden boyutlandırılır; \"Kapak\" - görüntü, en boy oranını korurken tüm kutuyu doldurur; \"Doldur\" - görüntü, en boy oranını korumadan kutuyu dolduracak şekilde uzatılır.",
        autoGrow: "Veriler girilirken giriş alanının yüksekliğini kademeli olarak artırır. \"Giriş alanı yüksekliği (satırlarda)\" ayarını geçersiz kılar.",
        allowResize: "Yeniden boyutlandırma tutamacı (veya tutamak) köşede görünür ve giriş alanının boyutunu değiştirmek için sürüklenebilir.",
        maxTimeToFinish: "Anketin otomatik olarak Teşekkür Ederiz sayfasına ilerlediği saniye cinsinden bir zaman aralığı.",
        maxTimeToFinishPage: "Anketin otomatik olarak bir sonraki sayfaya ilerlediği saniye cinsinden bir zaman aralığı.",
        page: {
            maxTimeToFinish: "Anketin otomatik olarak bir sonraki sayfaya ilerlediği saniye cinsinden bir zaman aralığı.",
            visibleIf: "Sayfa görünürlüğünü belirleyen koşullu bir kural belirlemek için sihirli değnek simgesini kullanın.",
            enableIf: "Sayfanın salt okunur modunu devre dışı bırakan koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın.",
            requiredIf: "En az bir iç içe geçmiş sorunun yanıtı olmadığı sürece anket gönderimini engelleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın.",
            questionTitleLocation: "Bu sayfadaki tüm sorular için geçerlidir. Bu ayarı geçersiz kılmak istiyorsanız, tek tek sorular veya paneller için başlık hizalama kuralları tanımlayın. \"Devral\" seçeneği, anket düzeyindeki ayarı uygular (varsayılan olarak \"Üst\").",
            questionTitleWidth: "Soru kutularının soluna hizalandıklarında soru başlıkları için tutarlı genişlik ayarlar. CSS değerlerini (px, %, in, pt, vb.) kabul eder.",
            questionErrorLocation: "Geçersiz girişi olan soruyla ilgili olarak bir hata mesajının konumunu ayarlar. Şunlar arasından seçim yapın: \"Üst\" - soru kutusunun en üstüne bir hata metni yerleştirilir; \"Alt\" - soru kutusunun altına bir hata metni yerleştirilir. \"Devral\" seçeneği, anket düzeyindeki ayarı uygular (varsayılan olarak \"Üst\").",
            questionsOrder: "Soruların orijinal sırasını korur veya rastgele hale getirir. \"Devral\" seçeneği, anket düzeyindeki ayarı (varsayılan olarak \"Orijinal\") uygular. Bu ayarın etkisi yalnızca Önizleme sekmesinde görünür.",
            navigationButtonsVisibility: "Sayfadaki gezinme düğmelerinin görünürlüğünü ayarlar. \"Devral\" seçeneği, varsayılan olarak \"Görünür\" olan anket düzeyi ayarını uygular."
        },
        showTimerPanel: "Sayfadaki bir zamanlayıcının görünürlüğünü ve konumunu ayarlar.",
        panelsState: "Şunlar arasından seçim yapın: \"Kilitli\" - kullanıcılar panelleri genişletemez veya daraltamaz; \"Tümünü daralt\" - tüm paneller daraltılmış durumda başlar; \"Tümünü genişlet\" - tüm paneller genişletilmiş bir durumda başlar; \"İlk genişletildi\" - başlangıçta yalnızca ilk panel genişletilir.",
        imageLinkName: "Seçim listesinde görüntülemek istediğiniz görüntü veya video dosyası URL'lerini içeren nesne dizisi içinde paylaşılan bir özellik adı girin.",
        choices: "Soldaki değer, koşullu kurallarda kullanılan bir öğe kimliği görevi görür, sağdaki değer yanıtlayanlara gösterilir.",
        title: "Görüntülemek için kullanıcı dostu bir başlık yazın.",
        waitForUpload: "Dosyalar yüklenene kadar kullanıcıların anketi tamamlamamasını sağlar.",
        minWidth: "CSS değerlerini (px, %, in, pt, vb.) kabul eder.",
        maxWidth: "CSS değerlerini (px, %, in, pt, vb.) kabul eder.",
        width: "CSS değerlerini (px, %, in, pt, vb.) kabul eder.",
        valueName: "Bu özelliği ayarlamazsanız, yanıt Name özelliği tarafından belirtilen bir alanda depolanır.",
        useDisplayValuesInDynamicTexts: "Tekli ve çoktan seçimli soru tiplerinde, her seçim seçeneğinin bir kimliği ve görünen değeri vardır. Seçildiğinde, bu ayar HTML sorularında ve anket öğelerinin dinamik başlıklarında ve açıklamalarında kimlik değeri yerine bir görünen değer gösterir.",
        clearIfInvisible: "Koşullu mantık tarafından gizlenen soru değerlerinin temizlenip temizlenmeyeceğini ve ne zaman yapılacağını seçin. \"Devral\" seçeneği, anket düzeyindeki ayarı uygular (varsayılan olarak \"Anket tamamlandıktan sonra\").",
        choicesFromQuestionMode: "Şunlar arasından seçim yapın: \"Tümü\" - seçilen sorudaki tüm seçim seçeneklerini kopyalar; \"Seçili\" - yalnızca seçilen seçim seçeneklerini dinamik olarak kopyalar; \"Seçilmemiş\" - yalnızca seçilmemiş seçim seçeneklerini dinamik olarak kopyalar. \"Yok\" ve \"Diğer\" seçenekleri, kaynak soruda etkinleştirilmişse varsayılan olarak kopyalanır.",
        showOtherItem: "Seçildiğinde, kullanıcılar ayrı bir yorum kutusuna ek girdi ekleyebilir.",
        separateSpecialChoices: "Her özel seçim seçeneğini (\"Yok\", \"Diğer\", \"Tümünü Seç\") çok sütunlu bir düzen kullanırken bile yeni bir satırda görüntüler.",
        path: "Hizmet veri kümesinde, hedef nesne dizisinin bulunduğu konumu belirtin. URL zaten diziye işaret ediyorsa boş bırakın.",
        choicesbyurl: {
            valueName: " "
        },
        titleName: "Seçim listesinde görüntülemek istediğiniz değerleri içeren nesneler dizisi içinde tekdüzen bir özellik adı girin.",
        allowEmptyResponse: "Hizmetin boş bir yanıt veya dizi döndürmesine izin vermek için seçin.",
        choicesVisibleIf: "Tüm seçim seçeneklerinin görünürlüğünü belirleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın.",
        rateValues: "Soldaki değer, koşullu kurallarda kullanılan bir öğe kimliği görevi görür, sağdaki değer yanıtlayanlara gösterilir.",
        rating: {
            displayMode: "\"Otomatik\", mevcut genişliğe göre \"Düğmeler\" ve \"Açılır Menü\" modları arasında seçim yapar. Genişlik düğmeleri görüntülemek için yetersiz olduğunda, soru bir açılır menü görüntüler."
        },
        valuePropertyName: "Farklı formatlarda sonuç üreten soruları bağlamanıza olanak tanır. Bu tür sorular bir birleştirme tanımlayıcısı kullanılarak birbirine bağlandığında, bu paylaşılan özellik seçilen soru değerlerini depolar.",
        searchEnabled: "Açılır menü içeriğini, kullanıcının giriş alanına yazdığı arama sorgusuyla eşleşecek şekilde güncelleştirmek istiyorsanız seçin.",
        valueTrue: "Yanıtlayanlar olumlu yanıt verdiğinde anket sonuçlarına kaydedilecek bir değer.",
        valueFalse: "Yanıtlayanlar olumsuz yanıt verdiğinde anket sonuçlarına kaydedilecek bir değer.",
        showPreview: "Önizleme görüntüsünü geçersiz kıldığından ve kullanıcının dosyaların yüklenip yüklenmediğini anlamasını zorlaştırdığından bu seçeneğin devre dışı bırakılması önerilmez.",
        needConfirmRemoveFile: "Dosya silme işlemini onaylamanızı isteyen bir istemi tetikler.",
        selectToRankEnabled: "Yalnızca seçilen seçenekleri sıralamak için etkinleştirin. Kullanıcılar, sıralama alanı içinde sıralamak için seçim listesinden seçilen öğeleri sürükleyecektir.",
        dataList: "Giriş sırasında yanıtlayana önerilecek seçeneklerin bir listesini girin.",
        itemSize: "Bu ayar yalnızca giriş alanlarını yeniden boyutlandırır ve soru kutusunun genişliğini etkilemez.",
        itemTitleWidth: "Piksel cinsinden tüm öğe etiketleri için tutarlı genişlik ayarlar",
        altText: "Görüntü, kullanıcının cihazında görüntülenemediğinde ve erişilebilirlik amacıyla yedek olarak görev yapar.",
        rateColorMode: "Derecelendirme simgesi türü \"Suratlar\" olarak ayarlandığında seçilen emojinin rengini tanımlar. Şunlar arasından seçim yapın: \"Varsayılan\" - seçilen emoji varsayılan anket renginde görünür; \"Ölçek\" - seçilen emoji, derecelendirme ölçeğinden rengi devralır.",
        expression: {
            name: "Yanıtlayanlar tarafından görülemeyen bir ifade kimliği.",
            description: "Bir ifade alt başlığı yazın.",
            expression: "Bir ifade, temel hesaplamaları ('{q1_id} + {q2_id}'), koşulları ('{age} > 60') ve işlevleri ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' vb.) içerebilir."
        },
        storeOthersAsComment: "\"Diğer\" seçenek değerini anket sonuçlarında ayrı bir özellik olarak saklamak için seçin.",
        format: "{0} gerçek değer için yer tutucu olarak kullanın.",
        acceptedTypes: "Daha fazla bilgi için [accept](https://www.w3schools.com/tags/att_input_accept.asp) özelliğinin açıklamasına bakın.",
        columnColCount: "Yalnızca Radiogroup ve Checkbox hücre tipleri için geçerlidir.",
        autocomplete: "Daha fazla bilgi için [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) özellik açıklamasına bakın.",
        filePlaceholder: "\"Kaynak türü\" \"Yerel dosyalar\" olduğunda veya fotoğraf makinesi kullanılamadığında geçerlidir",
        photoPlaceholder: "\"Kaynak türü\" \"Kamera\" olduğunda geçerlidir.",
        fileOrPhotoPlaceholder: "\"Kaynak türü\" \"Yerel dosyalar veya kamera\" olduğunda geçerlidir.",
        masksettings: {
            saveMaskedValue: "Soru değerini, anket sonuçlarında uygulanan bir maske ile saklamak istiyorsanız seçin."
        },
        patternmask: {
            pattern: "Desen, dize değişmez değerlerini ve aşağıdaki yer tutucuları içerebilir: '9' - bir rakam için; 'a' - büyük veya küçük harf için; '#' - bir rakam veya büyük veya küçük harf için. Bir karakterden kaçmak için ters eğik çizgi '\\' kullanın."
        },
        datetimemask: {
            pattern: "Desen, ayırıcı karakterler ve aşağıdaki yer tutucuları içerebilir:<br>'m' - Ay numarası.<br>'mm' - Tek basamaklı değerler için başında sıfır olan ay numarası. <br>'d' - Ayın günü. <br>'dd' - Tek basamaklı değerler için başında sıfır olan ayın günü. <br>'yy' - Yılın son iki basamağı. <br>'yyyy' - Dört basamaklı yıl. <br>'H' - 24 saat biçimindeki saatler. <br>'SS' - 24 saat biçiminde, tek basamaklı değerler için başında sıfır olan saatler. <br>'h' - 12 saat biçimindeki saatler. <br>'ss' - 12 saat biçiminde, tek basamaklı değerler için başında sıfır olan saatler. <br>'MM' - Dakika. <br>'ss' - Saniye. <br>'TT' - büyük harfle 12 saatlik zaman dilimi (/PM). <br>'tt' - küçük harfle 12 saatlik zaman dilimi (/pm)."
        },
        numericmask: {
            decimalSeparator: "Görüntülenen bir sayının kesirli kısmını tamsayı kısmından ayırmak için kullanılan bir sembol.",
            thousandsSeparator: "Büyük bir sayının rakamlarını üçlü gruplara ayırmak için kullanılan bir sembol.",
            precision: "Görüntülenen bir sayı için ondalık virgülden sonra kaç basamak tutulacağını sınırlar."
        },
        currencymask: {
            prefix: "Değerden önce görüntülenecek bir veya birkaç sembol.",
            suffix: "Değerden sonra görüntülenecek bir veya birkaç sembol."
        },
        theme: {
        // isPanelless: "This setting applies only to questions outside of a panel.",
        // primaryColor: "Sets a supplementary color that highlights key survey elements.",
        // panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
        // questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
        // cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
        // "--sjs-general-backcolor-dim": "Sets the main background color of the survey."
        },
        header: {
        // inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
        // textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
        // overlapEnabled: "Makes the bottom of the header overlaid with the top of the survey."
        }
    },
    // Properties
    p: {
        title: {
            name: "başlık",
            title: "'Ad' ile aynıysa boş bırakın"
        },
        multiSelect: "Çoklu Seçim",
        showLabel: "Başlığı göster",
        swapOrder: "Evet ve Hayır sırasını değiştirin",
        value: "Değer",
        tabAlign: "Sekme hizalaması",
        sourceType: "Kaynak türü",
        fitToContainer: "Konteynere sığdır",
        setValueExpression: "Değer ifadesini ayarla",
        description: "Açıklama",
        logoFit: "Logo uyumu",
        pages: "Sayfa",
        questions: "Soru",
        triggers: "tetikleyiciler",
        calculatedValues: "Hesaplanan değerler",
        surveyId: "Anket kimliği",
        surveyPostId: "Anket gönderisi kimliği",
        surveyShowDataSaving: "Anket gösterisi veri tasarrufu",
        questionDescriptionLocation: "Soru açıklaması konumu",
        progressBarType: "İlerleme çubuğu türü",
        showTOC: "İçindekiler'i göster",
        tocLocation: "İçindekiler konumu",
        questionTitlePattern: "Soru başlığı kalıbı",
        widthMode: "Genişlik modu",
        showBrandInfo: "Marka bilgilerini göster",
        useDisplayValuesInDynamicTexts: "Başlıkta görünen değeri kullan",
        visibleIf: "Görünür eğer",
        defaultValueExpression: "Varsayılan değer ifadesi",
        requiredIf: "Eğer gerekli mi?",
        resetValueIf: "Sıfırlama değeri",
        setValueIf: "Değeri ayarla",
        validators: "Doğrulayıcılar",
        bindings: "Bağlama",
        renderAs: "Farklı işle",
        attachOriginalItems: "Orijinal öğeleri ekleme",
        choices: "Seçenekler",
        choicesByUrl: "URL'e göre seçimler",
        currency: "Para birimi",
        cellHint: "Hücre ipucu",
        totalMaximumFractionDigits: "Toplam maksimum kesir basamakları",
        totalMinimumFractionDigits: "Toplam minimum kesir basamakları",
        columns: "Sütunlar",
        detailElements: "Ayrıntı öğeleri",
        allowAdaptiveActions: "Uyarlamalı eylemlere izin ver",
        defaultRowValue: "Varsayılan satır değeri",
        detailPanelShowOnAdding: "Ekleme sırasında ayrıntı paneli gösterisi",
        choicesLazyLoadEnabled: "Tembel yükün etkin olduğu seçenekler",
        choicesLazyLoadPageSize: "Seçenekler tembel yükleme sayfası boyutu",
        inputFieldComponent: "Giriş alanı bileşeni",
        itemComponent: "Öğe bileşeni",
        min: "Min",
        max: "Max",
        minValueExpression: "Minimum değer ifadesi",
        maxValueExpression: "Maksimum değer ifadesi",
        step: "Adım",
        dataList: "Veri listesi",
        itemSize: "Öğe boyutu",
        itemTitleWidth: "Öğe etiketi genişliği (piksel cinsinden)",
        elements: "Öğe",
        content: "İçerik",
        navigationButtonsVisibility: "Navigasyon butonları görünürlüğü",
        navigationTitle: "Gezinme başlığı",
        navigationDescription: "Navigasyon açıklaması",
        longTap: "Uzun musluk",
        autoGrow: "Otomatik büyüme",
        allowResize: "Yeniden boyutlandırmaya izin ver",
        acceptCarriageReturn: "Satır başı iadesini kabul et",
        displayMode: "Ekran modu",
        rateType: "Fiyat türü",
        label: "Başlık",
        contentMode: "İçerik modu",
        imageFit: "Görsel'u uyumlandır",
        altText: "Alternatif metin",
        height: "Yükseklik",
        penColor: "Kalem rengi",
        backgroundColor: "Arka plan rengi",
        templateElements: "Şablon öğeleri",
        operator: "Operatör",
        isVariable: "Değişkendir",
        runExpression: "İfadeyi çalıştır",
        showCaption: "Altyazıyı göster",
        iconName: "Simge adı",
        iconSize: "Simge boyutu",
        precision: "Kesinlik",
        matrixDragHandleArea: "Matris sürükleme kolu alanı",
        backgroundImage: "Arka plan resmi",
        backgroundImageFit: "Arka plan resmi sığdırma",
        backgroundImageAttachment: "Arka plan resmi eki",
        backgroundOpacity: "Arka plan opaklığı",
        selectToRankEnabled: "Etkin sıralamak için seç",
        selectToRankAreasLayout: "Sıralamak için alan düzenini seçin",
        selectToRankEmptyRankedAreaText: "Tüm seçeneklerin seçili olup olmadığını gösteren metin",
        selectToRankEmptyUnrankedAreaText: "Derecelendirme alanı için yer tutucu metin",
        allowCameraAccess: "Kamera erişimine izin ver",
        scaleColorMode: "Renk modunu ölçekle",
        rateColorMode: "Renk modunu ayarla",
        copyDisplayValue: "Görüntüleme değerini kopyala",
        // insensitive: "insensitive",
        // state: "state",
        // indent: "indent",
        // titleLocation: "titleLocation",
        // descriptionLocation: "descriptionLocation",
        // hideNumber: "hideNumber",
        // errorLocation: "errorLocation",
        // isUnique: "isUnique",
        // showInMultipleColumns: "showInMultipleColumns",
        // totalAlignment: "totalAlignment",
        // detailErrorLocation: "detailErrorLocation",
        // inheritWidthFrom: "inheritWidthFrom",
        // textAreaWidth: "textAreaWidth",
        // textGlowEnabled: "textGlowEnabled",
        // overlapEnabled: "overlapEnabled",
        // backgroundImageOpacity: "backgroundImageOpacity",
        // logoPositionX: "logoPositionX",
        // logoPositionY: "logoPositionY",
        // titlePositionX: "titlePositionX",
        // titlePositionY: "titlePositionY",
        // descriptionPositionX: "descriptionPositionX",
        // descriptionPositionY: "descriptionPositionY",
        // showNumber: "showNumber",
        // progressBarInheritWidthFrom: "progressBarInheritWidthFrom",
        // headerView: "headerView",
        // choiceValuesFromQuestion: "choiceValuesFromQuestion",
        // choiceTextsFromQuestion: "choiceTextsFromQuestion",
        // refuseText: "refuseText",
        // dontKnowText: "dontKnowText",
        // cellComponent: "cellComponent",
        // inputTextAlignment: "inputTextAlignment",
        // maskSettings: "maskSettings",
        // itemErrorLocation: "itemErrorLocation",
        // signatureWidth: "signatureWidth",
        // signatureHeight: "signatureHeight",
        // signatureAutoScaleEnabled: "signatureAutoScaleEnabled",
        // penMinWidth: "penMinWidth",
        // penMaxWidth: "penMaxWidth",
        // showPlaceholder: "showPlaceholder",
        // placeholderReadOnly: "placeholderReadOnly",
        // templateTitle: "templateTitle",
        // templateTabTitle: "templateTabTitle",
        // tabTitlePlaceholder: "tabTitlePlaceholder",
        // templateDescription: "templateDescription",
        // noEntriesText: "noEntriesText",
        // newPanelPosition: "newPanelPosition",
        // templateTitleLocation: "templateTitleLocation",
        // templateErrorLocation: "templateErrorLocation",
        // templateVisibleIf: "templateVisibleIf",
        // saveMaskedValue: "saveMaskedValue",
        // pattern: "pattern",
        // allowNegativeValues: "allowNegativeValues",
        // decimalSeparator: "decimalSeparator",
        // thousandsSeparator: "thousandsSeparator",
        // prefix: "prefix",
        // suffix: "suffix"
    },
    theme: {
        advancedMode: "Gelişmiş mod",
        pageTitle: "Sayfa başlığı yazı tipi",
        questionTitle: "Soru başlığı yazı tipi",
        editorPanel: "Giriş öğesi",
        lines: "Satır",
        primaryDefaultColor: "Temerrüt",
        primaryDarkColor: "Hover",
        primaryLightColor: "Seçilmiş",
        backgroundDimColor: "Arka plan rengi",
        cornerRadius: "Köşe yarıçapı",
        backcolor: "Varsayılan arka plan",
        hovercolor: "Arka planın üzerine gelin",
        borderDecoration: "Bordür dekorasyonu",
        fontColor: "Yazı tipi rengi",
        backgroundColor: "Arka plan rengi",
        primaryForecolor: "Varsayılan renk",
        primaryForecolorLight: "Devre dışı bırakılmış renk",
        font: "Yazı tipi",
        borderDefault: "Koyu",
        borderLight: "Çakmak",
        fontFamily: "Yazı tipi ailesi",
        fontWeightRegular: "Düzenli",
        fontWeightHeavy: "Ağır",
        fontWeightSemiBold: "Yarı kalın",
        fontWeightBold: "Kalın",
        color: "Renk",
        placeholderColor: "Yer tutucu rengi",
        size: "Boyut",
        opacity: "Opak -lık",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Gölge Efekti Ekle",
        boxShadowBlur: "Bulanıklaştır",
        boxShadowSpread: "Yaymak",
        boxShadowDrop: "Damla",
        boxShadowInner: "İç",
        names: {
            default: "Temerrüt",
            sharp: "Keskin",
            borderless: "Kenarlıksız",
            flat: "Düz",
            plain: "Düz",
            doubleborder: "Çift Kenarlık",
            layered: "Katmanlı",
            solid: "Katı",
            threedimensional: ".3D",
            contrast: "Karşıtlık"
        },
        colors: {
            teal: "Çamurcun",
            blue: "Mavi",
            purple: "Mor",
            orchid: "Orkide",
            tulip: "Lale",
            brown: "Kahverengi",
            green: "Yeşil"
        }
    }
};
survey_creator_core__WEBPACK_IMPORTED_MODULE_0__["editorLocalization"].locales["tr"] = turkishStrings;
// The following strings have been translated by a machine translation service
// Remove those strings that you have corrected manually
// survey.duplicate: "Duplicate" => "Yinelenen"
// qt.ranking: "Ranking" => "Sıralama"
// qt.tagbox: "Multi-Select Dropdown" => "Çoklu Seçim Açılır Menüsü"
// qt.buttongroup: "Button Group" => "Düğme Grubu"
// ed.surveySettings: "Survey Settings" => "Anket Ayarları"
// ed.surveySettingsTooltip: "Open survey settings" => "Anket ayarlarını açma"
// ed.prevSelected: "Select previous" => "Öncekini seç"
// ed.nextSelected: "Select next" => "İleri'yi seçin"
// ed.surveyTypeName: "Survey" => "Anket"
// ed.pageTypeName: "Page" => "Sayfa"
// ed.panelTypeName: "Panel" => "Panel"
// ed.questionTypeName: "Question" => "Soru"
// ed.columnTypeName: "Column" => "Sütun"
// ed.themeSurvey: "Themes" => "Temalar"
// ed.defaultV2Theme: "Default" => "Temerrüt"
// ed.modernTheme: "Modern" => "Modern"
// ed.defaultTheme: "Default (legacy)" => "Varsayılan (eski)"
// ed.jsonHideErrors: "Hide errors" => "Hataları gizleme"
// ed.jsonShowErrors: "Show errors" => "Hataları göster"
// ed.showMoreChoices: "Show more" => "Daha fazlasını göster"
// ed.showLessChoices: "Show less" => "Daha az göster"
// ed.copy: "Copy" => "Kopya etmek"
// ed.cut: "Cut" => "Kesmek"
// ed.paste: "Paste" => "Yapıştırmak"
// ed.copyTooltip: "Copy selection to clipboard" => "Seçimi panoya kopyala"
// ed.cutTooltip: "Cut selection to clipboard" => "Seçimi panoya kes"
// ed.pasteTooltip: "Paste from clipboard" => "Panodan yapıştır"
// ed.propertyGridFilteredTextPlaceholder: "Type to search..." => "Aramak için yazın..."
// ed.toolboxChoiceCategory: "Choice Questions" => "Seçim Soruları"
// ed.toolboxTextCategory: "Text Input Questions" => "Metin Girişi Soruları"
// ed.toolboxContainersCategory: "Containers" => "Konteyner"
// ed.toolboxMatrixCategory: "Matrix Questions" => "Matris Soruları"
// ed.toolboxMiscCategory: "Misc" => "Misc"
// ed.propertyEditorError: "Error" => "Hata"
// ed.translationPropertyGridTitle: "Language Settings" => "Dil Ayarları"
// ed.themePropertyGridTitle: "Theme Settings" => "Tema Ayarları"
// ed.translationLanguages: "Languages" => "Diller"
// ed.translationShowUsedStringsOnly: "Used Strings Only" => "Yalnızca Kullanılan Dizeler"
// ed.translationPlaceHolder: "Translation..." => "Çeviri..."
// ed.themeExportButton: "Export" => "Ihracat"
// ed.themeImportButton: "Import" => "Ithalat"
// ed.selectPage: "Select page..." => "Sayfa seç..."
// ed.carryForwardChoicesCopied: "Choices are copied from" => "Seçenekler şuradan kopyalanır:"
// ed.htmlPlaceHolder: "HTML content will be here." => "HTML içeriği burada olacak."
// ed.panelPlaceHolder: "Drop a question from the toolbox here." => "Araç kutusundan buraya bir soru bırakın."
// ed.surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below." => "Anket boş. Araç kutusundan bir öğeyi sürükleyin veya aşağıdaki düğmeyi tıklatın."
// ed.imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload" => "Bir resmi buraya sürükleyip bırakın veya aşağıdaki düğmeyi tıklayın ve yüklemek için bir resim seçin"
// ed.imageChooseImage: "Choose Image" => "Resim Seç"
// ed.addNewTypeQuestion: "Add {0}" => "{0} ekle"
// ed.chooseLogoPlaceholder: "[LOGO]" => "[LOGO]"
// ed.auto: "auto" => "Otomatik"
// ed.choices_Item: "Item " => "Madde "
// lg.addNewItem: "Add New Rule" => "Yeni Kural Ekle"
// lg.empty_tab: "Create a rule to customize the flow of the survey." => "Anketin akışını özelleştirmek için bir kural oluşturun."
// lg.page_enableName: "Enable (disable) page" => "Sayfayı etkinleştir (devre dışı bırak)"
// lg.column_visibilityName: "Show (hide) column" => "Göster (gizle) sütunu"
// lg.column_enableName: "Enable (disable) column" => "Etkinleştir (devre dışı bırak) sütunu"
// lg.column_requireName: "Make column required" => "Sütunu gerekli kıl"
// lg.itemEmptyExpressionText: "New rule" => "Yeni kural"
// lg.column_visibilityText: "make column {0} of question {1} visible" => "Soru {1} sütununu {0} görünür hale getirme"
// lg.column_enableText: "make column {0} of question {1} enable" => "Sütunun {0} soru {1} etkinleştirin"
// lg.column_requireText: "make column {0} of question {1} required" => "Sütun {0} soru {1} gerekli hale getirmek"
// lg.trigger_setvalueEmptyText: "clear question value: {0}" => "net soru değeri: {0}"
// lg.showAllQuestions: "All Questions" => "Tüm Sorular"
// lg.showAllActionTypes: "All Action Types" => "Tüm Eylem Türleri"
// lg.uncompletedRule_title: "Logical rules are incomplete" => "Mantıksal kurallar eksik"
// lg.uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?" => "Bazı mantıksal kuralları tamamlamadınız. Sekmeyi şimdi bırakırsanız, değişiklikler kaybolur. Yine de değişiklikleri tamamlamadan sekmeden çıkmak istiyor musunuz?"
// lg.uncompletedRule_apply: "Yes" => "Evet"
// lg.uncompletedRule_cancel: "No, I want to complete the rules" => "Hayır, kuralları tamamlamak istiyorum"
// pe.clear: "Clear" => "Berrak"
// pe.saveTooltip: "Save" => "Kurtarmak"
// pe.set: "Set" => "Ayarlamak"
// pe.change: "Change" => "Değiştirmek"
// pe.close: "Close" => "Kapatmak"
// pe.removeItem: "Click to remove the item..." => "Öğeyi kaldırmak için tıklayın..."
// pe.dragItem: "Drag the item" => "Öğeyi sürükleyin"
// pe.backTooltip: "Return without saving" => "Kaydetmeden geri dönün"
// pe.saveAndBackTooltip: "Save and return" => "Kaydet ve geri dön"
// pe.doneEditing: "Done" => "Yapılmış"
// pe.emptyValue: "Value is empty" => "Değer boş"
// pe.fastEntryNonUniqueError: "Value '{0}' is not unique" => "'{0}' değeri benzersiz değil"
// pe.fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}" => "Lütfen öğe sayısını {0}'den {1}'ye sınırlayın"
// pe.fastEntryPlaceholder: "You can set data in the following format:\nvalue1|text\nvalue2" => "Verileri aşağıdaki biçimde ayarlayabilirsiniz:\ndeğer1|metin\ndeğer2"
// pe.overridingPropertyPrefix: "Set by " => "Ayarlayan "
// pe.propertyIsNoUnique: "Please enter a unique value" => "Lütfen benzersiz bir değer girin"
// pe.propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"." => "Ayrılmış kelimeler kullanmayın: \"öğe\", \"seçim\", \"panel\", \"satır\"."
// pe.listIsEmpty@choices: "No choices have been added yet" => "Henüz seçenek eklenmedi"
// pe.addNew@choices: "Add a choice" => "Bir seçenek ekleyin"
// choicesbyurl.valueName: "Get values from the following JSON field" => "Aşağıdaki JSON alanından değerler alın"
// pe.imageLinkName: "Get image URLs from the following JSON field" => "Aşağıdaki JSON alanından resim URL'leri alın"
// pe.and: "and" => "ve"
// pe.or: "or" => "veya"
// pe.emptyLogicPopupMessage: "Select a question to start configuring conditions." => "Koşulları yapılandırmaya başlamak için bir soru seçin."
// pe.if: "If" => "Eğer"
// pe.then: "then" => "sonra"
// pe.setToName: "Target question" => "Hedef soru"
// pe.fromName: "Question to copy answer from" => "Cevabın kopyalanacağı soru"
// pe.gotoName: "Question to skip to" => "Atlanacak soru"
// pe.ruleIsNotSet: "Rule is incorrect" => "Kural yanlış"
// pe.includeIntoResult: "Include into survey results" => "Anket sonuçlarına dahil etme"
// pe.expandCollapseTitle: "Expand/collapse title" => "Başlığı genişletme/daraltma"
// pe.portraitOrientation: "Switch to portrait orientation" => "Dikey yöne geçme"
// image.imageHeight: "Image height (in CSS-accepted values)" => "Görüntü yüksekliği (CSS tarafından kabul edilen değerlerde)"
// image.imageWidth: "Image width (in CSS-accepted values)" => "Resim genişliği (CSS tarafından kabul edilen değerlerde)"
// page.maxTimeToFinish: "Time limit to finish the page (in seconds)" => "Sayfayı bitirmek için zaman sınırı (saniye cinsinden)"
// question.page: "Parent page" => "Ana sayfa"
// pe.noEntriesText: "Empty entries text" => "Boş giriş metni"
// pe.setValue: "Answer" => "Cevap"
// pe.dataFormat: "Image format" => "Görüntü formatı"
// pe.allowAddRows: "Allow adding rows" => "Satır eklemeye izin ver"
// pe.allowRemoveRows: "Allow removing rows" => "Satırların kaldırılmasına izin ver"
// pe.allowRowsDragAndDrop: "Allow row drag and drop" => "Satır sürükleyip bırakmaya izin ver"
// pe.responsiveImageSizeHelp: "Does not apply if you specify the exact image width or height." => "Tam görüntü genişliğini veya yüksekliğini belirtirseniz uygulanmaz."
// pe.minImageWidth: "Minimum image width" => "Minimum görüntü genişliği"
// pe.maxImageWidth: "Maximum image width" => "Maksimum görüntü genişliği"
// pe.minImageHeight: "Minimum image height" => "Minimum görüntü yüksekliği"
// pe.maxImageHeight: "Maximum image height" => "Maksimum görüntü yüksekliği"
// surveyvalidator.text: "Error message" => "Hata mesajı"
// surveyvalidator.expression: "Validation expression" => "Doğrulama ifadesi"
// pe.logo: "Logo (URL or base64-encoded string)" => "Logo (URL veya base64 kodlu dize)"
// pe.questionsOnPageMode: "Survey structure" => "Anket yapısı"
// pe.autoGrowComment: "Auto-expand comment area if necessary" => "Gerekirse yorum alanını otomatik olarak genişletin"
// pe.allowResizeComment: "Allow users to resize text areas" => "Kullanıcıların metin alanlarını yeniden boyutlandırmasına izin verme"
// pe.textUpdateMode: "Update text question value" => "Metin sorusu değerini güncelleme"
// pe.checkErrorsMode: "Run validation" => "Çalıştırma doğrulaması"
// pe.navigateToUrl: "Navigate to URL" => "URL'ye gidin"
// pe.navigateToUrlOnCondition: "Dynamic URL" => "Dinamik URL"
// pe.completedBeforeHtml: "Markup to show if the user already filled out this survey" => "Kullanıcının bu anketi zaten doldurup doldurmadığını göstermek için işaretleme"
// pe.completedHtml: "Survey Complete page markup" => "Anket Sayfa işaretlemesini tamamla"
// pe.completedHtmlOnCondition: "Dynamic Survey Complete page markup" => "Dinamik Anket Sayfa işaretlemesini tamamla"
// pe.loadingHtml: "Markup to show while survey model is loading" => "Anket modeli yüklenirken gösterilecek işaretleme"
// pe.commentText: "Comment area text" => "Yorum alanı metni"
// pe.autocomplete: "Autocomplete type" => "Otomatik tamamlama türü"
// pe.labelTrue: "\"True\" label" => "\"Doğru\" etiketi"
// pe.labelFalse: "\"False\" label" => "\"Yanlış\" etiketi"
// pe.displayStyle: "Value display style" => "Değer görüntüleme stili"
// pe.format: "Formatted string" => "Biçimlendirilmiş dize"
// pe.maximumFractionDigits: "Maximum fractional digits" => "Maksimum kesirli basamaklar"
// pe.minimumFractionDigits: "Minimum fractional digits" => "Minimum kesirli basamaklar"
// pe.useGrouping: "Display grouping separators" => "Ekran gruplandırma ayırıcıları"
// pe.allowMultiple: "Allow multiple files" => "Birden çok dosyaya izin ver"
// pe.allowImagesPreview: "Preview images" => "Önizleme görüntüleri"
// pe.acceptedTypes: "Accepted file types" => "Kabul edilen dosya türleri"
// pe.waitForUpload: "Wait for the upload to complete" => "Yüklemenin tamamlanmasını bekleyin"
// pe.needConfirmRemoveFile: "Confirm file deletion" => "Dosya silme işlemini onaylama"
// pe.detailPanelMode: "Detail panel location" => "Ayrıntı paneli konumu"
// pe.minRowCount: "Minimum row count" => "Minimum satır sayısı"
// pe.maxRowCount: "Maximum row count" => "Maksimum satır sayısı"
// pe.confirmDelete: "Confirm row deletion" => "Satır silme işlemini onaylama"
// pe.confirmDeleteText: "Confirmation message" => "Onay mesajı"
// paneldynamic.confirmDelete: "Confirm panel deletion" => "Panel silme işlemini onaylama"
// pe.panelCount: "Initial panel count" => "İlk panel sayısı"
// pe.minPanelCount: "Minimum panel count" => "Minimum panel sayısı"
// pe.maxPanelCount: "Maximum panel count" => "Maksimum panel sayısı"
// pe.panelsState: "Inner panel expand state" => "İç panel genişletme durumu"
// pe.templateDescription: "Description template" => "Açıklama şablonu"
// pe.templateTitle: "Title template" => "Başlık şablonu"
// pe.panelPrevText: "Previous Panel button tooltip" => "Önceki Panel düğmesi araç ipucu"
// pe.panelNextText: "Next Panel button tooltip" => "Sonraki Panel düğmesi araç ipucu"
// pe.showRangeInProgress: "Show progress bar" => "İlerleme çubuğunu göster"
// pe.templateTitleLocation: "Question title location" => "Soru başlığı konumu"
// pe.panelRemoveButtonLocation: "Remove Panel button location" => "Panel düğmesinin konumunu kaldır"
// pe.hideIfRowsEmpty: "Hide the question if there are no rows" => "Satır yoksa soruyu gizleme"
// pe.hideColumnsIfEmpty: "Hide columns if there are no rows" => "Satır yoksa sütunları gizleme"
// pe.rateValues: "Custom rate values" => "Özel fiyat değerleri"
// pe.rateCount: "Rate count" => "Oran sayısı"
// pe.autoGenerate: "How to specify rate values?" => "Fiyat değerleri nasıl belirlenir?"
// pe.hideIfChoicesEmpty: "Hide the question if it contains no choices" => "Seçenek içermiyorsa soruyu gizleme"
// pe.hideNumber: "Hide question number" => "Soru numarasını gizle"
// pe.minWidth: "Minimum width (in CSS-accepted values)" => "Minimum genişlik (CSS tarafından kabul edilen değerlerde)"
// pe.maxWidth: "Maximum width (in CSS-accepted values)" => "Maksimum genişlik (CSS tarafından kabul edilen değerlerde)"
// pe.width: "Width (in CSS-accepted values)" => "Genişlik (CSS tarafından kabul edilen değerlerde)"
// pe.showHeader: "Show column headers" => "Sütun başlıklarını göster"
// pe.horizontalScroll: "Show horizontal scrollbar" => "Yatay kaydırma çubuğunu göster"
// pe.columnMinWidth: "Minimum column width (in CSS-accepted values)" => "Minimum sütun genişliği (CSS tarafından kabul edilen değerlerde)"
// pe.rowTitleWidth: "Row header width (in CSS-accepted values)" => "Satır başlığı genişliği (CSS tarafından kabul edilen değerlerde)"
// pe.valueTrue: "\"True\" value" => "\"Doğru\" değer"
// pe.valueFalse: "\"False\" value" => "\"False\" değeri"
// pe.minErrorText: "\"Value is below minimum\" error message" => "\"Değer minimumun altında\" hata iletisi"
// pe.maxErrorText: "\"Value exceeds maximum\" error message" => "\"Değer maksimumu aşıyor\" hata iletisi"
// pe.otherErrorText: "\"Empty comment\" error message" => "\"Boş yorum\" hata iletisi"
// pe.keyDuplicationError: "\"Non-unique key value\" error message" => "\"Benzersiz olmayan anahtar değeri\" hata iletisi"
// pe.minSelectedChoices: "Minimum selected choices" => "Seçilen minimum seçenekler"
// pe.maxSelectedChoices: "Maximum selected choices" => "Seçilen maksimum seçenek sayısı"
// pe.showNumber: "Show panel number" => "Panel numarasını göster"
// pe.readOnly: "Read-only" => "Salt okunur"
// pe.enableIf: "Editable if" => "Şu durumlarda düzenlenebilir"
// pe.emptyRowsText: "\"No rows\" message" => "\"Satır yok\" iletisi"
// pe.size: "Input field size (in characters)" => "Giriş alanı boyutu (karakter cinsinden)"
// pe.separateSpecialChoices: "Separate special choices (None, Other, Select All)" => "Ayrı özel seçenekler (Yok, Diğer, Tümünü Seç)"
// pe.choicesFromQuestion: "Copy choices from the following question" => "Aşağıdaki sorudan seçenekleri kopyalama"
// pe.choicesFromQuestionMode: "Which choices to copy?" => "Hangi seçenekleri kopyalamalıyım?"
// pe.commentPlaceholder: "Comment area placeholder" => "Yorum alanı yer tutucusu"
// pe.displayRateDescriptionsAsExtremeItems: "Display rate descriptions as extreme values" => "Hız açıklamalarını aşırı değerler olarak görüntüleme"
// pe.rowsOrder: "Row order" => "Satır sırası"
// pe.columnsLayout: "Column layout" => "Sütun düzeni"
// pe.columnColCount: "Nested column count" => "İç içe geçmiş sütun sayısı"
// pe.state: "Panel expand state" => "Panel genişletme durumu"
// pe.correctAnswer: "Correct Answer" => "Doğru Cevap"
// pe.defaultPanelValue: "Default Values" => "Varsayılan Değerler"
// pe.cells: "Cell Texts" => "Hücre Metinleri"
// pe.keyName: "Key column" => "Anahtar sütunu"
// itemvalue.text: "Alt text" => "Alternatif metin"
// tabs.slider: "Slider" => "Kaydırıcı"
// tabs.expression: "Expression" => "İfade"
// pe.choicesVisibleIf: "Choices are visible if" => "Seçenekler şu durumlarda görünür:"
// pe.choicesEnableIf: "Choices are selectable if" => "Seçenekler şu durumlarda seçilebilir:"
// pe.columnsEnableIf: "Columns are visible if" => "Sütunlar şu durumlarda görünür:"
// pe.rowsEnableIf: "Rows are visible if" => "Satırlar şu durumlarda görünür:"
// pe.indent: "Add indents" => "Girinti ekleme"
// panel.indent: "Add outer indents" => "Dış girintiler ekleme"
// pe.innerIndent: "Add inner indents" => "İç girintiler ekleme"
// pe.defaultValueFromLastRow: "Take default values from the last row" => "Son satırdaki varsayılan değerleri alma"
// pe.defaultValueFromLastPanel: "Take default values from the last panel" => "Son panelden varsayılan değerleri alma"
// pe.titleKeyboardAdornerTip: "Press enter button to edit" => "Düzenlemek için enter düğmesine basın"
// pe.emptyExpressionPlaceHolder: "Type expression here..." => "İfadeyi buraya yazın..."
// pe.noFile: "No file choosen" => "Hiçbir dosya seçilmedi"
// pe.clearIfInvisible: "Clear the value if the question becomes hidden" => "Soru gizlenirse değeri temizleyin"
// pe.valuePropertyName: "Value property name" => "Değer özelliği adı"
// pe.searchEnabled: "Enable search" => "Aramayı etkinleştir"
// pe.hideSelectedItems: "Hide selected items" => "Seçili öğeleri gizle"
// pe.closeOnSelect: "Close the dropdown after selection" => "Seçimden sonra açılır menüyü kapatın"
// pe.signatureWidth: "Signature width" => "İmza genişliği"
// pe.signatureHeight: "Signature height" => "İmza yüksekliği"
// pe.verticalAlign: "Vertical alignment" => "Dikey hizalama"
// pe.alternateRows: "Alternate rows" => "Alternatif satırlar"
// pe.columnsVisibleIf: "Columns are visible if" => "Sütunlar şu durumlarda görünür:"
// pe.rowsVisibleIf: "Rows are visible if" => "Satırlar şu durumlarda görünür:"
// pe.otherPlaceholder: "Comment area placeholder" => "Yorum alanı yer tutucusu"
// pe.rateType: "Rate type" => "Fiyat türü"
// pv.true: "true" => "doğru"
// pv.false: "false" => "yanlış"
// pv.decimal: "decimal" => "On -da -lık"
// pv.currency: "currency" => "para birimi"
// pv.percent: "percent" => "yüzde"
// pv.onpanel: "Start on each panel" => "Her panelde başlayın"
// pv.tab: "Tabs" => "Sekmeler"
// pv.right: "Right" => "Sağ"
// pv.color: "color" => "Renk"
// pv.date: "date" => "tarih"
// pv.datetime: "datetime" => "datetime"
// pv.datetime-local: "datetime-local" => "datetime-yerel"
// pv.email: "email" => "E-posta"
// pv.month: "month" => "ay"
// pv.number: "number" => "sayı"
// pv.password: "password" => "parola"
// pv.range: "range" => "aralık"
// pv.tel: "tel" => "telefon"
// pv.text: "text" => "Metin"
// pv.time: "time" => "Saat"
// pv.url: "url" => "URL"
// pv.week: "week" => "hafta"
// pv.onHiddenContainer: "When the question or its panel/page becomes hidden" => "Soru veya paneli/sayfası gizlendiğinde"
// clearInvisibleValues.none: "Never" => "Hiç"
// inputType.color: "Color" => "Renk"
// inputType.date: "Date" => "Tarih"
// inputType.datetime-local: "Date and Time" => "Tarih ve Saat"
// inputType.email: "Email" => "E-posta"
// inputType.month: "Month" => "Ay"
// inputType.number: "Number" => "Sayı"
// inputType.password: "Password" => "Parola"
// inputType.range: "Range" => "Aralık"
// inputType.tel: "Phone Number" => "Telefon numarası"
// inputType.text: "Text" => "Metin"
// inputType.time: "Time" => "Saat"
// inputType.url: "URL" => "URL"
// inputType.week: "Week" => "Hafta"
// pv.onValueChanging: "Before an answer is changed" => "Bir yanıt değiştirilmeden önce"
// pv.pages: "Completed pages" => "Tamamlanan sayfalar"
// pv.onBlur: "On blur" => "Bulanıklaştırmada"
// pv.onTyping: "While typing" => "Yazarken"
// pv.underRow: "Under the row" => "Satırın altında"
// pv.underRowSingle: "Under the row, only one panel is visible" => "Satırın altında yalnızca bir panel görünür"
// showNavigationButtons.none: "Hidden" => "Gizli"
// showProgressBar.off: "Hidden" => "Gizli"
// showTimerPanel.none: "Hidden" => "Gizli"
// showTimerPanelMode.all: "Both" => "Her ikisi"
// detailPanelMode.none: "Hidden" => "Gizli"
// addRowLocation.default: "Depends on matrix layout" => "Matris düzenine bağlıdır"
// panelsState.default: "Users cannot expand or collapse panels" => "Kullanıcılar panelleri genişletemez veya daraltamaz"
// panelsState.collapsed: "All panels are collapsed" => "Tüm paneller daraltıldı"
// panelsState.expanded: "All panels are expanded" => "Tüm paneller genişletildi"
// widthMode.auto: "Auto" => "Otomatik"
// widthMode.static: "Static" => "Duruk"
// widthMode.responsive: "Responsive" => "Duyarlı"
// imageFit.none: "None" => "Hiç kimse"
// imageFit.contain: "Contain" => "Kapsamak"
// imageFit.cover: "Cover" => "Örtmek"
// imageFit.fill: "Fill" => "Doldurmak"
// contentMode.auto: "Auto" => "Otomatik"
// contentMode.image: "Image" => "Resim"
// contentMode.video: "Video" => "Video"
// contentMode.youtube: "YouTube" => "Videolar"
// displayMode.auto: "Auto" => "Otomatik"
// displayMode.buttons: "Buttons" => "Düğme"
// displayMode.dropdown: "Dropdown" => "Açılır menü"
// rateColorMode.default: "Default" => "Temerrüt"
// autoGenerate.true: "Generate" => "Oluşturmak"
// autoGenerate.false: "Enter manually" => "Manuel olarak girme"
// rateType.labels: "Labels" => "Etiket"
// rateType.stars: "Stars" => "Yıldız"
// rateType.smileys: "Smileys" => "Suratlar"
// op.and: "and" => "ve"
// op.or: "or" => "veya"
// ew.modern: "Modern theme" => "Modern tema"
// ew.default: "Default theme" => "Varsayılan tema"
// ew.orange: "Orange theme" => "Turuncu tema"
// ew.darkblue: "Darkblue theme" => "Lacivert tema"
// ew.darkrose: "Darkrose theme" => "Darkrose teması"
// ew.stone: "Stone theme" => "Taş teması"
// ew.winter: "Winter theme" => "Kış teması"
// ew.winterstone: "Winter-Stone theme" => "Kış-Taş teması"
// ts.hideInvisibleElements: "Hide invisible elements" => "Görünmez öğeleri gizleme"
// pehelp.cookieName: "Cookies prevent users from filling out the same survey twice." => "Çerezler, kullanıcıların aynı anketi iki kez doldurmasını engeller."
// pehelp.size: "Resizes the visible area of the input field. Please use the <b>Validation → Maximum length</b> setting to limit the input length." => "Giriş alanının görünür alanını yeniden boyutlandırır. Giriş uzunluğunu sınırlamak için lütfen <b>Doğrulama → Maksimum uzunluk</b> ayarını kullanın."
// pehelp.format: "Use {0} as a placeholder for the actual value." => "{0} gerçek değer için yer tutucu olarak kullanın."
// pehelp.totalText: "Visible only when at least one column has Total type or Total expression." => "Yalnızca en az bir sütunda Toplam türü veya Toplam ifadesi olduğunda görünür."
// pehelp.acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information." => "Daha fazla bilgi için [accept](https://www.w3schools.com/tags/att_input_accept.asp) özelliğinin açıklamasına bakın."
// pehelp.columnColCount: "Applicable only to Radiogroup and Checkbox cell types." => "Yalnızca Radiogroup ve Checkbox hücre tipleri için geçerlidir."
// pehelp.autocomplete: "Refer to the [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute description for more information." => "Daha fazla bilgi için [autocomplete](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) özellik açıklamasına bakın."
// pehelp.valueName: "If you do not set this property, the answer will be stored in a field specified by the Name property." => "Bu özelliği ayarlamazsanız, yanıt Name özelliği tarafından belirtilen bir alanda depolanır."
// choicesbyurl.valueName: " " => " "
// pehelp.keyName: "If the specified column contains identical values, the survey throws the \"Non-unique key value\" error." => "Belirtilen sütun aynı değerleri içeriyorsa, anket \"Benzersiz olmayan anahtar değeri\" hatasını atar."
// p.value: "Value" => "Değer"
// p.tabAlign: "Tab alignment" => "Sekme hizalaması"
// p.logoFit: "Logo fit" => "Logo uyumu"
// p.pages: "Pages" => "Sayfa"
// p.questions: "Questions" => "Soru"
// p.calculatedValues: "Calculated values" => "Hesaplanan değerler"
// p.surveyId: "Survey id" => "Anket kimliği"
// p.surveyPostId: "Survey post id" => "Anket gönderisi kimliği"
// p.surveyShowDataSaving: "Survey show data saving" => "Anket gösterisi veri tasarrufu"
// p.showTOC: "Show TOC" => "İçindekiler'i göster"
// p.tocLocation: "Toc location" => "İçindekiler konumu"
// p.questionTitlePattern: "Question title pattern" => "Soru başlığı kalıbı"
// p.widthMode: "Width mode" => "Genişlik modu"
// p.showBrandInfo: "Show brand info" => "Marka bilgilerini göster"
// p.defaultValueExpression: "Default value expression" => "Varsayılan değer ifadesi"
// p.bindings: "Bindings" => "Bağlama"
// p.renderAs: "Render as" => "Farklı işle"
// p.attachOriginalItems: "Attach original items" => "Orijinal öğeleri ekleme"
// p.cellHint: "Cell hint" => "Hücre ipucu"
// p.isUnique: "Is unique" => "Benzersizdir"
// p.showInMultipleColumns: "Show in multiple columns" => "Birden çok sütunda göster"
// p.totalMaximumFractionDigits: "Total maximum fraction digits" => "Toplam maksimum kesir basamakları"
// p.totalMinimumFractionDigits: "Total minimum fraction digits" => "Toplam minimum kesir basamakları"
// p.detailElements: "Detail elements" => "Ayrıntı öğeleri"
// p.allowAdaptiveActions: "Allow adaptive actions" => "Uyarlamalı eylemlere izin ver"
// p.detailPanelShowOnAdding: "Detail panel show on adding" => "Ekleme sırasında ayrıntı paneli gösterisi"
// p.choicesLazyLoadEnabled: "Choices lazy load enabled" => "Tembel yükün etkin olduğu seçenekler"
// p.choicesLazyLoadPageSize: "Choices lazy load page size" => "Seçenekler tembel yükleme sayfası boyutu"
// p.inputFieldComponent: "Input field component" => "Giriş alanı bileşeni"
// p.itemComponent: "Item component" => "Öğe bileşeni"
// p.min: "Min" => "Min"
// p.max: "Max" => "Max"
// p.minValueExpression: "Min value expression" => "Minimum değer ifadesi"
// p.maxValueExpression: "Max value expression" => "Maksimum değer ifadesi"
// p.step: "Step" => "Adım"
// p.dataList: "Data list" => "Veri listesi"
// p.elements: "Elements" => "Öğe"
// p.content: "Content" => "İçerik"
// p.navigationTitle: "Navigation title" => "Gezinme başlığı"
// p.navigationDescription: "Navigation description" => "Navigasyon açıklaması"
// p.longTap: "Long tap" => "Uzun musluk"
// p.autoGrow: "Auto grow" => "Otomatik büyüme"
// p.allowResize: "Allow resizing" => "Yeniden boyutlandırmaya izin ver"
// p.acceptCarriageReturn: "Accept carriage return" => "Satır başı iadesini kabul et"
// p.displayMode: "Display mode" => "Ekran modu"
// p.rateType: "Rate type" => "Fiyat türü"
// p.altText: "Alt text" => "Alternatif metin"
// p.height: "Height" => "Yükseklik"
// p.penColor: "Pen color" => "Kalem rengi"
// p.backgroundColor: "Background color" => "Arka plan rengi"
// p.templateElements: "Template elements" => "Şablon öğeleri"
// p.operator: "Operator" => "Operatör"
// p.isVariable: "Is variable" => "Değişkendir"
// p.runExpression: "Run expression" => "İfadeyi çalıştır"
// p.showCaption: "Show caption" => "Altyazıyı göster"
// p.iconName: "Icon name" => "Simge adı"
// p.iconSize: "Icon size" => "Simge boyutu"
// p.precision: "Precision" => "Kesinlik"
// p.matrixDragHandleArea: "Matrix drag handle area" => "Matris sürükleme kolu alanı"
// p.backgroundImage: "Background image" => "Arka plan resmi"
// p.backgroundImageFit: "Background image fit" => "Arka plan resmi sığdırma"
// p.backgroundImageAttachment: "Background image attachment" => "Arka plan resmi eki"
// p.backgroundOpacity: "Background opacity" => "Arka plan opaklığı"
// p.selectToRankEnabled: "Select to rank enabled" => "Etkin sıralamak için seç"
// p.selectToRankAreasLayout: "Select to rank areas layout" => "Sıralamak için alan düzenini seçin"
// p.allowCameraAccess: "Allow camera access" => "Kamera erişimine izin ver"
// p.scaleColorMode: "Scale color mode" => "Renk modunu ölçekle"
// p.rateColorMode: "Rate color mode" => "Renk modunu ayarla"
// p.templateTabTitle: "Template tab title" => "Şablon sekmesi başlığı"
// p.templateVisibleIf: "Template visible if" => "Şablon şu durumlarda görülebilir:"
// p.copyDisplayValue: "Copy display value" => "Görüntüleme değerini kopyala"
// theme.--background: "Background color" => "Arka plan rengi"
// theme.--background-dim-light: "Background dim light color" => "Arka plan loş ışık rengi"
// theme.--primary-foreground: "Primary foreground color" => "Birincil ön plan rengi"
// theme.--foreground: "Foreground color" => "Ön plan rengi"
// theme.--base-unit: "Base unit" => "Temel ünite"
// theme.groupAdvanced: "Advanced" => "İleri"
// theme.themeName: "Theme" => "Tema"
// theme.isPanellessss: "Question appearance" => "Soru görünümü"
// theme.isPanellessPanels: "Default" => "Temerrüt"
// theme.isPanellessLightweight: "Without Panels" => "Panelsiz"
// theme.themePaletteLight: "Light" => "Işık"
// theme.themePaletteDark: "Dark" => "Koyu"
// theme.primaryColor: "Accent color" => "Vurgu rengi"
// theme.primaryDefaultColor: "Default" => "Temerrüt"
// theme.primaryDarkColor: "Hover" => "Hover"
// theme.primaryLightColor: "Selected" => "Seçilmiş"
// theme.backgroundDimColor: "Background color" => "Arka plan rengi"
// theme.backgroundImage: "Background image" => "Arka plan resmi"
// theme.backgroundImageFitAuto: "Auto" => "Otomatik"
// theme.backgroundImageFitCover: "Cover" => "Örtmek"
// theme.backgroundImageFitContain: "Contain" => "Kapsamak"
// theme.backgroundOpacity: "Opacity" => "Opak -lık"
// theme.backgroundImageAttachmentFixed: "Fixed" => "Sabit"
// theme.backgroundImageAttachmentScroll: "Scroll" => "Tomar"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Panel arka plan opaklığı"
// theme.questionBackgroundTransparency: "Question background opacity" => "Soru arka planı opaklığı"
// theme.questionPanel: "Panel background and corner radius" => "Panel arka planı ve köşe yarıçapı"
// theme.questionTitle: "Question title font" => "Soru başlığı yazı tipi"
// theme.questionDescription: "Question description font" => "Soru açıklaması yazı tipi"
// theme.editorPanel: "Input element" => "Giriş öğesi"
// theme.editorFont: "Input element font" => "Giriş öğesi yazı tipi"
// theme.backcolor: "Default background" => "Varsayılan arka plan"
// theme.hovercolor: "Hover background" => "Arka planın üzerine gelin"
// theme.borderDecoration: "Border decoration" => "Bordür dekorasyonu"
// theme.accentBackground: "Accent background" => "Aksan arka planı"
// theme.accentForeground: "Accent foreground" => "Vurgu ön planı"
// theme.primaryForecolor: "Default color" => "Varsayılan renk"
// theme.primaryForecolorLight: "Disabled color" => "Devre dışı bırakılmış renk"
// theme.linesColors: "Minor line colors" => "Küçük çizgi renkleri"
// theme.borderDefault: "Darker" => "Koyu"
// theme.borderLight: "Lighter" => "Çakmak"
// theme.fontFamily: "Font family" => "Font ailesi"
// theme.fontSize: "Font size" => "Yazı tipi boyutu"
// theme.color: "Color" => "Renk"
// theme.size: "Size" => "Boyut"
// theme.fontWeightRegular: "Regular" => "Düzenli"
// theme.fontWeightHeavy: "Heavy" => "Ağır"
// theme.fontWeightSemiBold: "Semi-bold" => "Yarı kalın"
// theme.fontWeightBold: "Bold" => "Kalın"
// theme.scale: "Scale" => "Ölçeklemek"
// theme.cornerRadius: "Corner radius" => "Köşe yarıçapı"
// theme.surveyTitleFont: "Survey title font" => "Anket başlığı yazı tipi"
// theme.pageTitle: "Page title font" => "Sayfa başlığı yazı tipi"
// theme.pageDescription: "Page description font" => "Sayfa açıklaması yazı tipi"
// theme.boxShadowX: "X" => "X"
// theme.boxShadowY: "Y" => "Y"
// theme.boxShadowAddRule: "Add Shadow Effect" => "Gölge Efekti Ekle"
// theme.opacity: "Opacity" => "Opak -lık"
// theme.boxShadowBlur: "Blur" => "Bulanıklaştır"
// theme.boxShadowSpread: "Spread" => "Yaymak"
// theme.boxShadowDrop: "Drop" => "Damla"
// theme.boxShadowInner: "Inner" => "İç"
// theme.questionShadow: "Shadow effects" => "Gölge efektleri"
// theme.editorShadow: "Input element shadow effects" => "Giriş öğesi gölge efektleri"
// names.default: "Default" => "Temerrüt"
// names.contrast: "Contrast" => "Karşıtlık"
// names.plain: "Plain" => "Düz"
// names.simple: "Simple" => "Basit"
// names.blank: "Blank" => "Boş"
// names.double: "Double" => "Çift"
// names.bulk: "Bulk" => "Yığın"
// names.pseudo-3d: "Pseudo 3D" => "Sahte 3D"
// names.playful: "Playful" => "Oyunbaz"
// names.ultra: "Ultra" => "Ultra"
// colors.teal: "Teal" => "Çamurcun"
// colors.blue: "Blue" => "Mavi"
// colors.purple: "Purple" => "Mor"
// colors.orchid: "Orchid" => "Orkide"
// colors.tulip: "Tulip" => "Lale"
// colors.brown: "Brown" => "Kahverengi"
// colors.green: "Green" => "Yeşil"
// names.sharp: "Sharp" => "Keskin"
// names.borderless: "Borderless" => "Kenarlıksız"
// names.flat: "Flat" => "Düz"
// names.doubleborder: "Double Border" => "Çift Kenarlık"
// names.layered: "Layered" => "Katmanlı"
// names.solid: "Solid" => "Katı"
// names.threedimensional: "3D" => ".3D"
// ed.translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?" => "Bu dil için tüm dizeleri silmek istediğinizden emin misiniz?"
// ed.themeResetButton: "Reset theme settings to default" => "Tema ayarlarını varsayılana sıfırla"
// theme.placeholderColor: "Placeholder color" => "Yer tutucu rengi"
// ed.themeSettings: "Theme Settings" => "Tema Ayarları"
// ed.themeSettingsTooltip: "Open theme settings" => "Tema ayarlarını açma"
// pe.resetToDefaultCaption: "Reset" => "Sıfırlama"
// pv.file: "Local files" => "Yerel dosyalar"
// pv.camera: "Camera" => "Kamera"
// pv.file-camera: "Local files or camera" => "Yerel dosyalar veya kamera"
// ed.translateUsigAI: "Auto-translate All" => "Tümünü Otomatik Çevir"
// ed.translationDialogTitle: "Untranslated strings" => "Çevrilmemiş dizeler"
// pe.fastEntryChoicesMinCountError: "Please enter at least {0} items" => "Lütfen en az {0} ürün girin"
// lg.question_resetValueName: "Reset question value" => "Soru değerini sıfırla"
// lg.column_resetValue: "Reset column value" => "Sütun değerini sıfırla"
// pe.markRequired: "Mark as required" => "Gerektiği gibi işaretleyin"
// pe.removeRequiredMark: "Remove the required mark" => "Gerekli işareti kaldırın"
// p.resetValueIf: "Reset value if" => "Sıfırlama değeri"
// lg.question_setValueName: "Set question value" => "Soru değerini ayarla"
// lg.column_resetValueName: "Reset column value" => "Sütun değerini sıfırla"
// lg.column_setValueName: "Set column value" => "Sütun değerini ayarla"
// lg.setValueExpressionPlaceholder: " An expression whose result will be assigned to the target question." => " Sonucu hedef soruya atanacak bir ifade."
// survey.title: "Title" => "Başlık"
// page.title: "Title" => "Başlık"
// p.setValueIf: "Set value if" => "Değeri ayarla"
// theme.header: "Header" => "Üstbilgi"
// theme.backgroundImageFitFill: "Stretch" => "Uzatmak"
// theme.backgroundImageFitTile: "Tile" => "Kiremit"
// theme.headerView: "View" => "Görünüm"
// theme.headerViewBasic: "Basic" => "Temel"
// theme.headerViewAdvanced: "Advanced" => "İleri"
// theme.headerInheritWidthFrom: "Content area width" => "İçerik alanı genişliği"
// theme.headerInheritWidthFromSurvey: "Same as survey" => "Anketle aynı"
// theme.headerInheritWidthFromPage: "Fit to page" => "Sayfaya sığdır"
// theme.headerTextAreaWidth: "Text width" => "Metin genişliği"
// theme.headerBackgroundColorSwitch: "Background color" => "Arka plan rengi"
// theme.headerBackgroundColorNone: "None" => "Hiç kimse"
// theme.headerBackgroundColorAccentColor: "Accent color" => "Vurgu rengi"
// theme.headerBackgroundColorCustom: "Custom" => "Töre"
// theme.horizontalAlignmentLeft: "Left" => "Sol"
// theme.horizontalAlignmentCenter: "Center" => "Orta"
// theme.horizontalAlignmentRight: "Right" => "Sağ"
// theme.verticalAlignmentTop: "Top" => "Sayfanın Üstü"
// theme.verticalAlignmentMiddle: "Middle" => "Orta"
// theme.verticalAlignmentBottom: "Bottom" => "Dip"
// lg.question_resetValueText: "reset value for question: {0}" => "Soru için sıfırlama değeri: {0}"
// lg.question_setValueText: "assign value: {1} to question: {0}" => "Değer atayın: Soruya {1}: {0}"
// lg.column_resetValueText: "reset cell value for column: {0}" => "Sütun için hücre değerini sıfırla: {0}"
// lg.column_setValueText: "assign cell value: {1} to column: {0}" => "Hücre değeri atayın: Sütuna {1}: {0}"
// ed.surveyJsonExportButton: "Export" => "Ihracat"
// ed.surveyJsonImportButton: "Import" => "Ithalat"
// ed.surveyJsonCopyButton: "Copy to clipboard" => "Panoya kopyala"
// pe.filePlaceholder: "File placeholder text" => "Dosya yer tutucu metni"
// pe.photoPlaceholder: "Photo placeholder text" => "Fotoğraf yer tutucu metni"
// pe.fileOrPhotoPlaceholder: "File or photo placeholder text" => "Dosya veya fotoğraf yer tutucu metni"
// pehelp.filePlaceholder: "Applies when \"Source type\" is \"Local files\" or when camera is unavailable" => "\"Kaynak türü\" \"Yerel dosyalar\" olduğunda veya fotoğraf makinesi kullanılamadığında geçerlidir"
// pehelp.photoPlaceholder: "Applies when \"Source type\" is \"Camera\"." => "\"Kaynak türü\" \"Kamera\" olduğunda geçerlidir."
// pehelp.fileOrPhotoPlaceholder: "Applies when \"Source type\" is \"Local files or camera\"." => "\"Kaynak türü\" \"Yerel dosyalar veya kamera\" olduğunda geçerlidir."
// theme.background: "Background" => "Arka plan"
// theme.appearance: "Appearance" => "Görünüş"
// ed.themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost." => "Temayı gerçekten sıfırlamak istiyor musunuz? Tüm özelleştirmeleriniz kaybolacak."
// ed.themeResetConfirmationOk: "Yes, reset the theme" => "Evet, temayı sıfırlayın"
// theme.headerInheritWidthFromContainer: "Fit to container" => "Konteynere sığdır"
// signaturepad.showPlaceholder: "Show the placeholder" => "Yer tutucuyu gösterme"
// signaturepad.placeholder: "Placeholder text" => "Yer tutucu metin"
// theme.surveyDescriptionFont: "Survey description font" => "Anket açıklaması yazı tipi"
// ed.prevFocus: "Focus previous" => "Öncesine odaklan"
// ed.nextFocus: "Focus next" => "Sonrakine odaklan"
// ed.saveTheme: "Save Theme" => "Temayı Kaydet"
// ed.saveThemeTooltip: "Save Theme" => "Temayı Kaydet"
// lg.page_requireName: "Make page required" => "Sayfayı gerekli hale getirme"
// lg.panel_requireName: "Make page required" => "Sayfayı gerekli hale getirme"
// signaturepad.signatureWidth: "Signature area width" => "İmza alanı genişliği"
// signaturepad.signatureHeight: "Signature area height" => "İmza alanı yüksekliği"
// signaturepad.signatureAutoScaleEnabled: "Auto-scale the signature area" => "İmza alanını otomatik ölçeklendirme"
// signaturepad.penMinWidth: "Minimum pen width" => "Minimum kalem genişliği"
// signaturepad.penMaxWidth: "Maximum pen width" => "Maksimum kalem genişliği"
// theme.logoPosition: "Logo position" => "Logo konumu"
// theme.headerTitlePosition: "Title position" => "Unvan pozisyonu"
// theme.headerDescriptionPosition: "Description position" => "Açıklama konumu"
// ed.propertyGridNoResultsFound: "No results found" => "Sonuç bulunamadı"
// pv.leftRight: "Left and right" => "Sol ve sağ"
// p.sourceType: "Source type" => "Kaynak türü"
// p.fitToContainer: "Fit to container" => "Konteynere sığdır"
// p.setValueExpression: "Set value expression" => "Değer ifadesini ayarla"
// ed.choicesLoadedFromWebText: "Choices are loaded from a web service." => "Seçimler bir web hizmetinden yüklenir."
// ed.choicesLoadedFromWebLinkText: "Go to settings" => "Ayarlara git"
// ed.choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options" => "Yüklenen seçim seçeneklerinin önizlemesi"
// pe.eachRowUnique: "Prevent duplicate responses in rows" => "Satırlarda yinelenen yanıtları önleme"
// theme.advancedMode: "Advanced mode" => "Gelişmiş mod"
// theme.backgroundCornerRadius: "Background and corner radius" => "Arka plan ve köşe yarıçapı"
// theme.colorsTitle: "Colors" => "Renk"
// theme.font: "Font" => "Yazı tipi"
// theme.lines: "Lines" => "Satır"
// theme.titleFont: "Title font" => "Başlık yazı tipi"
// theme.descriptionFont: "Description font" => "Açıklama yazı tipi"
// theme.shadow: "Shadow effects" => "Gölge efektleri"
// ed.translateUsigAIFrom: "Translate from: " => "Çeviri kaynağı: "
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Yanıtlamayı Reddet seçeneğine izin ver"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Bilmiyorum seçeneğine izin ver"
// pe.showRefuseItem: "Allow the Refuse to Answer option" => "Yanıtlamayı Reddet seçeneğine izin ver"
// pe.showDontKnowItem: "Allow the Don't Know option" => "Bilmiyorum seçeneğine izin ver"
// pv.contain: "Contain" => "Kapsamak"
// pv.cover: "Cover" => "Örtmek"
// pv.fill: "Fill" => "Doldurmak"
// pe.transposeData: "Transpose rows to columns" => "Satırları sütunlara dönüştürme"
// layout.panel: "Layout" => "Düzen"
// layout.question: "Layout" => "Düzen"
// layout.base: "Layout" => "Düzen"
// panel.name: "Panel name" => "Panel adı"
// panel.title: "Panel title" => "Panel başlığı"
// panel.description: "Panel description" => "Panel açıklaması"
// panel.visibleIf: "Make the panel visible if" => "Aşağıdaki durumlarda paneli görünür hale getirin"
// panel.requiredIf: "Make the panel required if" => "Aşağıdaki durumlarda paneli gerekli hale getirin"
// panel.questionsOrder: "Question order within the panel" => "Panel içinde soru sırası"
// panel.startWithNewLine: "Display the panel on a new line" => "Paneli yeni bir satırda görüntüleme"
// panel.state: "Panel collapse state" => "Panel çökme durumu"
// panel.width: "Inline panel width" => "Satır içi panel genişliği"
// panel.minWidth: "Minimum panel width" => "Minimum panel genişliği"
// panel.maxWidth: "Maximum panel width" => "Maksimum panel genişliği"
// panel.showNumber: "Number panels" => "Sayı panelleri"
// paneldynamic.name: "Panel name" => "Panel adı"
// paneldynamic.title: "Panel title" => "Panel başlığı"
// paneldynamic.description: "Panel description" => "Panel açıklaması"
// paneldynamic.visibleIf: "Make the panel visible if" => "Aşağıdaki durumlarda paneli görünür hale getirin"
// paneldynamic.requiredIf: "Make the panel required if" => "Aşağıdaki durumlarda paneli gerekli hale getirin"
// paneldynamic.page: "Move the panel to page" => "Paneli sayfaya taşıma"
// paneldynamic.startWithNewLine: "Display the panel on a new line" => "Paneli yeni bir satırda görüntüleme"
// paneldynamic.state: "Panel collapse state" => "Panel çökme durumu"
// paneldynamic.width: "Inline panel width" => "Satır içi panel genişliği"
// paneldynamic.minWidth: "Minimum panel width" => "Minimum panel genişliği"
// paneldynamic.maxWidth: "Maximum panel width" => "Maksimum panel genişliği"
// paneldynamic.templateDescription: "Panel description pattern" => "Panel açıklama deseni"
// paneldynamic.templateTitle: "Panel title pattern" => "Panel başlığı deseni"
// paneldynamic.noEntriesText: "Empty panel text" => "Boş panel metni"
// paneldynamic.templateTabTitle: "Tab title pattern" => "Sekme başlığı deseni"
// paneldynamic.templateVisibleIf: "Make an individual panel visible if" => "Aşağıdaki durumlarda tek bir paneli görünür hale getirme"
// paneldynamic.hideNumber: "Hide the panel number" => "Panel numarasını gizleme"
// paneldynamic.titleLocation: "Panel title alignment" => "Panel başlığı hizalaması"
// paneldynamic.descriptionLocation: "Panel description alignment" => "Panel açıklaması hizalaması"
// paneldynamic.templateTitleLocation: "Question title alignment" => "Soru başlığı hizalaması"
// paneldynamic.templateErrorLocation: "Error message alignment" => "Hata iletisi hizalaması"
// paneldynamic.newPanelPosition: "New panel location" => "Yeni panel konumu"
// paneldynamic.keyName: "Prevent duplicate responses in the following question" => "Aşağıdaki soruda yinelenen yanıtları önleyin"
// question.name: "Question name" => "Soru adı"
// question.title: "Question title" => "Soru başlığı"
// question.description: "Question description" => "Soru açıklaması"
// question.visibleIf: "Make the question visible if" => "Aşağıdaki durumlarda soruyu görünür hale getirin"
// question.requiredIf: "Make the question required if" => "Aşağıdaki durumlarda soruyu gerekli hale getirin"
// question.state: "Question box collapse state" => "Soru kutusu daraltma durumu"
// question.hideNumber: "Hide the question number" => "Soru numarasını gizleme"
// question.titleLocation: "Question title alignment" => "Soru başlığı hizalaması"
// question.descriptionLocation: "Question description alignment" => "Soru açıklaması hizalaması"
// question.errorLocation: "Error message alignment" => "Hata iletisi hizalaması"
// question.indent: "Increase the inner indent" => "İç girintiyi artırma"
// question.width: "Inline question width" => "Satır içi soru genişliği"
// question.minWidth: "Minimum question width" => "Minimum soru genişliği"
// question.maxWidth: "Maximum question width" => "Maksimum soru genişliği"
// question.textUpdateMode: "Update input field value" => "Giriş alanı değerini güncelleştirme"
// signaturepad.allowClear: "Show the Clear button within signature area" => "İmza alanı içinde Temizle düğmesini gösterme"
// signaturepad.penColor: "Stroke color" => "Kontur rengi"
// comment.rows: "Input field height (in lines)" => "Giriş alanı yüksekliği (satırlarda)"
// expression.name: "Expression name" => "İfade adı"
// expression.title: "Expression title" => "İfade başlığı"
// expression.description: "Expression description" => "İfade açıklaması"
// expression.expression: "Expression" => "İfade"
// trigger.expression: "Expression" => "İfade"
// calculatedvalue.expression: "Expression" => "İfade"
// survey.description: "Survey description" => "Anket açıklaması"
// page.name: "Page name" => "Sayfa adı"
// page.description: "Page description" => "Sayfa açıklaması"
// page.visibleIf: "Make the page visible if" => "Aşağıdaki durumlarda sayfayı görünür hale getirin"
// page.requiredIf: "Make the page required if" => "Aşağıdaki durumlarda sayfayı gerekli hale getirin"
// page.questionsOrder: "Question order on the page" => "Sayfadaki soru sırası"
// matrixdropdowncolumn.name: "Column name" => "Sütun adı"
// matrixdropdowncolumn.title: "Column title" => "Sütun başlığı"
// matrixdropdowncolumn.isUnique: "Prevent duplicate responses" => "Yinelenen yanıtları önleyin"
// matrixdropdowncolumn.width: "Column width" => "Sütun genişliği"
// matrixdropdowncolumn.minWidth: "Minimum column width" => "Minimum sütun genişliği"
// matrixdropdowncolumn.rows: "Input field height (in lines)" => "Giriş alanı yüksekliği (satırlarda)"
// matrixdropdowncolumn.visibleIf: "Make the column visible if" => "Aşağıdaki durumlarda sütunu görünür hale getirin"
// matrixdropdowncolumn.requiredIf: "Make the column required if" => "Aşağıdaki durumlarda sütunu gerekli yap"
// matrixdropdowncolumn.showInMultipleColumns: "Each option in a separate column" => "Her seçenek ayrı bir sütunda"
// multipletextitem.name: "Name" => "Ad"
// multipletextitem.title: "Title" => "Başlık"
// pe.rateDescriptionLocation: "Label alignment" => "Etiket hizalama"
// pe.cellErrorLocation: "Cell error message alignment" => "Hücre hata iletisi hizalaması"
// pe.listIsEmpty@columns: "You don't have any columns yet" => "Henüz sütununuz yok"
// pe.listIsEmpty@rows: "You don't have any rows yet" => "Henüz satırınız yok"
// pe.listIsEmpty@validators: "You don't have any validation rules yet" => "Henüz herhangi bir doğrulama kuralınız yok"
// pe.listIsEmpty@calculatedValues: "You don't have any custom variables yet" => "Henüz özelleştirilebilen değişkeniniz yok"
// pe.listIsEmpty@triggers: "You don't have any triggers yet" => "Henüz herhangi bir tetikleyiciniz yok"
// pe.listIsEmpty@navigateToUrlOnCondition: "You don't have any links yet" => "Henüz bağlantınız yok"
// pe.addNew@columns: "Add new column" => "Yeni sütun ekle"
// pe.addNew@rows: "Add new row" => "Yeni satır ekle"
// pe.addNew@validators: "Add new rule" => "Yeni kural ekle"
// pe.addNew@calculatedValues: "Add new variable" => "Yeni değişken ekle"
// pe.addNew@triggers: "Add new trigger" => "Yeni tetikleyici ekle"
// pe.addNew@navigateToUrlOnCondition: "Add new URL" => "Yeni URL ekle"
// choicesbyurl.url: "Web service's URL" => "Web hizmetinin URL'si"
// pe.progressBarShowPageTitles: "Display page titles in progress bar" => "Sayfa başlıklarını ilerleme çubuğunda görüntüleme"
// pe.progressBarShowPageNumbers: "Display page numbers in progress bar" => "İlerleme çubuğunda sayfa numaralarını görüntüleme"
// itemvalue.visibleIf: "Make the option visible if" => "Aşağıdaki durumlarda seçeneği görünür hale getirin"
// itemvalue.enableIf: "Make the option selectable if" => "Aşağıdaki durumlarda seçeneği seçilebilir hale getirin"
// panel.layout: "Panel Layout" => "Panel Düzeni"
// tabs.questionSettings: "Question Settings" => "Soru Ayarları"
// pe.url_placeholder: "Ex.: https://api.example.com/books" => "Ör.: https://api.example.com/books"
// pe.path_placeholder: "Ex.: categories.fiction" => "Ör.: kategoriler.kurgu"
// pe.questionStartIndex_placeholder: "Ex.: a)" => "Örn.: a)"
// pe.width_placeholder: "Ex.: 6in" => "Ör.: 6 inç"
// pe.minWidth_placeholder: "Ex.: 600px" => "Ör.: 600 piksel"
// pe.maxWidth_placeholder: "Ex.: 50%" => "Ör.: %50"
// pv.selected: "Selected" => "Seçilmiş"
// pv.unselected: "Unselected" => "Seçili"
// pv.center: "Center" => "Orta"
// pv.middle: "Middle" => "Orta"
// pv.next: "Next" => "Önümüzdeki"
// pv.last: "Last" => "Son"
// clearIfInvisible.none: "Never" => "Hiç"
// questionsOnPageMode.standard: "Original structure" => "Orijinal yapı"
// questionsOnPageMode.singlePage: "Show all questions on one page" => "Tüm soruları tek bir sayfada göster"
// questionsOnPageMode.questionPerPage: "Show single question per page" => "Sayfa başına tek bir soru göster"
// pv.auto: "Auto" => "Otomatik"
// panelsState.firstExpanded: "First expanded" => "İlk genişletildi"
// rateColorMode.scale: "Scale" => "Ölçeklemek"
// scaleColorMode.monochrome: "Monochrome" => "Monokrom"
// scaleColorMode.colored: "Colored" => "Renkli"
// state.default: "Locked" => "Kilitli"
// showQuestionNumbers.default: "Auto-numbering" => "Otomatik numaralandırma"
// showQuestionNumbers.on: "Auto-numbering" => "Otomatik numaralandırma"
// showQuestionNumbers.onPage: "Reset on each page" => "Her sayfada sıfırla"
// showQuestionNumbers.onpanel: "Reset on each panel" => "Her panelde sıfırla"
// showQuestionNumbers.onPanel: "Reset on each panel" => "Her panelde sıfırla"
// showQuestionNumbers.onSurvey: "Continue across the survey" => "Ankete devam edin"
// showQuestionNumbers.off: "No numbering" => "Numaralandırma yok"
// descriptionLocation.underTitle: "Under the question title" => "Soru başlığı altında"
// descriptionLocation.underInput: "Under the input field" => "Giriş alanının altında"
// selectToRankAreasLayout.horizontal: "Next to choices" => "Seçeneklerin yanında"
// selectToRankAreasLayout.vertical: "Above choices" => "Yukarıdaki seçenekler"
// displayStyle.decimal: "Decimal" => "On -da -lık"
// displayStyle.currency: "Currency" => "Para birimi"
// displayStyle.percent: "Percentage" => "Yüzde"
// displayStyle.date: "Date" => "Tarih"
// totalDisplayStyle.decimal: "Decimal" => "On -da -lık"
// totalDisplayStyle.currency: "Currency" => "Para birimi"
// totalDisplayStyle.percent: "Percentage" => "Yüzde"
// totalDisplayStyle.date: "Date" => "Tarih"
// rowsOrder.initial: "Original" => "Özgün"
// questionsOrder.initial: "Original" => "Özgün"
// showProgressBar.aboveheader: "Above the header" => "Başlığın üstünde"
// showProgressBar.belowheader: "Below the header" => "Başlığın altında"
// pv.sum: "Sum" => "Toplam"
// pv.count: "Count" => "Saymak"
// pv.min: "Min" => "Min"
// pv.max: "Max" => "Max"
// pv.avg: "Avg" => "Avg"
// searchMode.contains: "Contains" => "Içerir"
// searchMode.startsWith: "Starts with" => "İle başlar"
// panel.name: "A panel ID that is not visible to respondents." => "Yanıtlayanlar tarafından görülemeyen bir panel kimliği."
// panel.description: "Type a panel subtitle." => "Bir panel altyazısı yazın."
// panel.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Panel görünürlüğünü belirleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın."
// panel.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Panelin salt okunur modunu devre dışı bırakan koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın."
// panel.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "En az bir iç içe geçmiş sorunun yanıtı olmadığı sürece anket gönderimini engelleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın."
// panel.questionTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Bu paneldeki tüm sorular için geçerlidir. Bu ayarı geçersiz kılmak istiyorsanız, tek tek sorular için başlık hizalama kuralları tanımlayın. \"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını (varsayılan olarak \"Üst\") uygular."
// panel.questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Paneldeki tüm sorularla ilgili olarak bir hata mesajının konumunu ayarlar. \"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını uygular."
// panel.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Soruların orijinal sırasını korur veya rastgele hale getirir. \"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını uygular."
// panel.page: "Repositions the panel to the end of a selected page." => "Paneli seçili sayfanın sonuna yeniden konumlandırır."
// panel.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Panel içeriği ile panel kutusunun sol kenarlığı arasına boşluk veya kenar boşluğu ekler."
// panel.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Panelin önceki soru veya panelle aynı satırda görüntülenmesi için seçimi kaldırın. Panel formunuzdaki ilk öğeyse bu ayar uygulanmaz."
// panel.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Şunlar arasından seçim yapın: \"Genişletilmiş\" - panel tam olarak görüntülenir ve daraltılabilir; \"Daraltılmış\" - panel yalnızca başlığı ve açıklamayı görüntüler ve genişletilebilir; \"Kilitli\" - panel tam olarak görüntülenir ve daraltılamaz."
// panel.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Panelin genişliğini aynı satırdaki diğer anket öğeleriyle orantılı olarak ayarlar. CSS değerlerini (px, %, in, pt, vb.) kabul eder."
// paneldynamic.name: "A panel ID that is not visible to respondents." => "Yanıtlayanlar tarafından görülemeyen bir panel kimliği."
// paneldynamic.description: "Type a panel subtitle." => "Bir panel altyazısı yazın."
// paneldynamic.visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility." => "Panel görünürlüğünü belirleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın."
// paneldynamic.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel." => "Panelin salt okunur modunu devre dışı bırakan koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın."
// paneldynamic.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "En az bir iç içe geçmiş sorunun yanıtı olmadığı sürece anket gönderimini engelleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın."
// paneldynamic.templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Bu paneldeki tüm sorular için geçerlidir. Bu ayarı geçersiz kılmak istiyorsanız, tek tek sorular için başlık hizalama kuralları tanımlayın. \"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını (varsayılan olarak \"Üst\") uygular."
// paneldynamic.templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Geçersiz girişi olan bir soruyla ilgili olarak bir hata mesajının konumunu ayarlar. Şunlar arasından seçim yapın: \"Üst\" - soru kutusunun en üstüne bir hata metni yerleştirilir; \"Alt\" - soru kutusunun altına bir hata metni yerleştirilir. \"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını (varsayılan olarak \"Üst\") uygular."
// paneldynamic.errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting." => "Paneldeki tüm sorularla ilgili olarak bir hata mesajının konumunu ayarlar. \"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını uygular."
// paneldynamic.page: "Repositions the panel to the end of a selected page." => "Paneli seçili sayfanın sonuna yeniden konumlandırır."
// paneldynamic.innerIndent: "Adds space or margin between the panel content and the left border of the panel box." => "Panel içeriği ile panel kutusunun sol kenarlığı arasına boşluk veya kenar boşluğu ekler."
// paneldynamic.startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form." => "Panelin önceki soru veya panelle aynı satırda görüntülenmesi için seçimi kaldırın. Panel formunuzdaki ilk öğeyse bu ayar uygulanmaz."
// paneldynamic.state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed." => "Şunlar arasından seçim yapın: \"Genişletilmiş\" - panel tam olarak görüntülenir ve daraltılabilir; \"Daraltılmış\" - panel yalnızca başlığı ve açıklamayı görüntüler ve genişletilebilir; \"Kilitli\" - panel tam olarak görüntülenir ve daraltılamaz."
// paneldynamic.width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Panelin genişliğini aynı satırdaki diğer anket öğeleriyle orantılı olarak ayarlar. CSS değerlerini (px, %, in, pt, vb.) kabul eder."
// paneldynamic.templateTitle: "Type in a template for dynamic panel titles. Use {panelIndex} for the panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Dinamik panel başlıkları için bir şablon yazın. Panelin genel konumu için {panelIndex} ve görünür paneller arasındaki sırası için {visiblePanelIndex} kullanın. Otomatik numaralandırma eklemek için bu yer tutucuları desene ekleyin."
// paneldynamic.templateTabTitle: "Type in a template for tab titles. Use {panelIndex} for a panel's general position and {visiblePanelIndex} for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering." => "Sekme başlıkları için bir şablon yazın. Panelin genel konumu için {panelIndex} ve görünür paneller arasındaki sırası için {visiblePanelIndex} kullanın. Otomatik numaralandırma eklemek için bu yer tutucuları desene ekleyin."
// paneldynamic.templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression." => "Bu ayar, dinamik panel içindeki tek tek panellerin görünürlüğünü kontrol etmenizi sağlar. İfadenizdeki geçerli panele başvurmak için '{panel}' yer tutucusunu kullanın."
// paneldynamic.titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)." => "Bu ayar, bu paneldeki tüm sorular tarafından otomatik olarak devralınır. Bu ayarı geçersiz kılmak istiyorsanız, tek tek sorular için başlık hizalama kuralları tanımlayın. \"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını (varsayılan olarak \"Üst\") uygular."
// paneldynamic.descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)." => "\"Devral\" seçeneği, sayfa düzeyi (ayarlanmışsa) veya anket düzeyi ayarını (varsayılan olarak \"Panel başlığı altında\") uygular."
// paneldynamic.newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one." => "Yeni eklenen panelin konumunu tanımlar. Varsayılan olarak, sonuna yeni paneller eklenir. Geçerli panelden sonra yeni bir panel eklemek için \"İleri\" yi seçin."
// paneldynamic.defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel." => "Son paneldeki yanıtları çoğaltır ve bir sonraki eklenen dinamik panele atar."
// paneldynamic.keyName: "Reference a question name to require a user to provide a unique response for this question in each panel." => "Kullanıcının her panelde bu soruya benzersiz bir yanıt vermesini zorunlu kılmak için bir soru adına başvurun."
// pehelp.defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input." => "Bu ayar, bir ifadeye göre varsayılan bir yanıt değeri atamanıza olanak tanır. İfade temel hesaplamaları içerebilir - '{q1_id} + {q2_id}', '{age} > 60' gibi Boole ifadeleri ve işlevler: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' vb. Bu ifade tarafından belirlenen değer, yanıtlayanın manuel girişi tarafından geçersiz kılınabilecek ilk varsayılan değer olarak işlev görür."
// pehelp.resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)." => "Yanıtlayanın girişinin ne zaman \"Varsayılan değer ifadesi\" veya \"Değer ifadesi ayarla\" ya da \"Varsayılan yanıt\" değerine (ayarlanmışsa) dayalı değere ne zaman sıfırlanacağını belirleyen bir koşullu kural ayarlamak için sihirli değnek simgesini kullanın."
// pehelp.setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response." => "\"Değer ayarla ifadesinin\" ne zaman çalıştırılacağını belirleyen koşullu bir kural belirlemek ve elde edilen değeri yanıt olarak dinamik olarak atamak için sihirli değnek simgesini kullanın."
// pehelp.setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input." => "\"Şu durumda değer ayarla\" kuralındaki koşullar karşılandığında ayarlanacak değeri tanımlayan bir ifade belirtin. İfade temel hesaplamaları içerebilir - '{q1_id} + {q2_id}', '{age} > 60' gibi Boole ifadeleri ve işlevler: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' vb. Bu ifade tarafından belirlenen değer, yanıtlayanın manuel girişi tarafından geçersiz kılınabilir."
// question.name: "A question ID that is not visible to respondents." => "Yanıtlayanlar tarafından görülemeyen bir soru kimliği."
// question.description: "Type a question subtitle." => "Bir soru alt başlığı yazın."
// question.visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility." => "Soru görünürlüğünü belirleyen koşullu bir kural belirlemek için sihirli değnek simgesini kullanın."
// question.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question." => "Soru için salt okunur modunu devre dışı bırakan koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın."
// question.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer." => "Soru yanıt almadıkça anketin ilerlemesini veya gönderilmesini engelleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın."
// question.startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form." => "Soruyu, önceki soru veya panelle birlikte tek satırda görüntülemek için seçimi kaldırın. Soru formunuzdaki ilk öğeyse bu ayar geçerli değildir."
// question.page: "Repositions the question to the end of a selected page." => "Soruyu seçili sayfanın sonuna konumlandırır."
// question.state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed." => "Şunlar arasından seçim yapın: \"Genişletilmiş\" - soru kutusu tam olarak görüntülenir ve daraltılabilir; \"Daraltılmış\" - soru kutusu yalnızca başlığı ve açıklamayı görüntüler ve genişletilebilir; \"Kilitli\" - soru kutusu tam olarak görüntülenir ve daraltılamaz."
// question.titleLocation: "Overrides title alignment rules defined on a panel, page or survey level. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)." => "Panel, sayfa veya anket düzeyinde tanımlanan başlık hizalama kurallarını geçersiz kılar. \"Devral\" seçeneği, tüm üst düzey ayarları (ayarlanmışsa) veya anket düzeyindeki ayarları (varsayılan olarak \"Üst\") uygular."
// question.descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)." => "\"Devral\" seçeneği, anket düzeyindeki ayarı uygular (varsayılan olarak \"Soru başlığının altında\")."
// question.errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Geçersiz girişi olan soruyla ilgili olarak bir hata mesajının konumunu ayarlar. Şunlar arasından seçim yapın: \"Üst\" - soru kutusunun en üstüne bir hata metni yerleştirilir; \"Alt\" - soru kutusunun altına bir hata metni yerleştirilir. \"Devral\" seçeneği, anket düzeyindeki ayarı uygular (varsayılan olarak \"Üst\")."
// question.indent: "Adds space or margin between the question content and the left border of the question box." => "Soru içeriği ile soru kutusunun sol kenarlığı arasına boşluk veya kenar boşluğu ekler."
// question.width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)." => "Sorunun genişliğini, aynı satırdaki diğer anket öğeleriyle orantılı olarak ayarlar. CSS değerlerini (px, %, in, pt, vb.) kabul eder."
// surveyvalidator.expression: "Use the magic wand icon to set a validation rule for the question." => "Soru için bir doğrulama kuralı ayarlamak için sihirli değnek simgesini kullanın."
// question.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)." => "Şunlar arasından seçim yapın: \"Odak kaybolduğunda\" - giriş alanı odağı kaybettiğinde değer güncellenir; \"Yazarken\" - değer, kullanıcılar yazarken gerçek zamanlı olarak güncellenir. \"Devral\" seçeneği, anket düzeyindeki ayarı uygular (varsayılan olarak \"Odak kaybolduğunda\")."
// question.url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data." => "Çoktan seçmeli sorular için herhangi bir web hizmetini veri kaynağı olarak kullanabilirsiniz. Seçim değerlerini doldurmak için, verileri sağlayan hizmetin URL'sini girin."
// question.searchMode: "A comparison operation used to filter the drop-down list." => "Açılan listeyi filtrelemek için kullanılan bir karşılaştırma işlemi."
// signaturepad.signatureWidth: "Sets the width of the displayed signature area and the resulting image." => "Görüntülenen imza alanının ve elde edilen görüntünün genişliğini ayarlar."
// signaturepad.signatureHeight: "Sets the height of the displayed signature area and the resulting image." => "Görüntülenen imza alanının ve elde edilen görüntünün yüksekliğini ayarlar."
// signaturepad.signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions." => "İmza alanının, varsayılan 3:2 en boy oranını korurken soru kutusundaki tüm kullanılabilir alanı doldurmasını isteyip istemediğinizi seçin. Özel genişlik ve yükseklik değerleri ayarlandığında, ayar bu boyutların en boy oranını korur."
// file.imageHeight: "Adjusts the height of the image in the survey results." => "Anket sonuçlarındaki görüntünün yüksekliğini ayarlar."
// file.imageWidth: "Adjusts the width of the image in the survey results." => "Anket sonuçlarındaki görüntünün genişliğini ayarlar."
// imagepicker.imageHeight: "Overrides the minimum and maximum height values." => "Minimum ve maksimum yükseklik değerlerini geçersiz kılar."
// imagepicker.imageWidth: "Overrides the minimum and maximum width values." => "Minimum ve maksimum genişlik değerlerini geçersiz kılar."
// imagepicker.choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents." => "\"Değer\", koşullu kurallarda kullanılan bir öğe kimliği görevi görür; Yanıtlayanlara \"Metin\" gösterilir."
// text.size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to <b>Validation → Maximum character limit</b>." => "Bu ayar yalnızca giriş alanını yeniden boyutlandırır ve soru kutusunun genişliğini etkilemez. Kabul edilen giriş uzunluğunu sınırlamak için <b>Doğrulama → Maksimum karakter sınırı'na</b> gidin."
// comment.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Giriş alanında görüntülenen satırların sayısını ayarlar. Giriş daha fazla satır alırsa, kaydırma çubuğu görünecektir."
// survey.mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing." => "Şunlar arasından seçim yapın: \"Düzenlenebilir\" - yanıtlayanların anketinizi doldurmasını sağlar; \"Salt okunur\" - form düzenlemeyi devre dışı bırakır."
// matrixdropdowncolumn.name: "A column ID that is not visible to respondents." => "Yanıtlayanlar tarafından görülemeyen bir sütun kimliği."
// matrixdropdowncolumn.isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column." => "Bir sütun için etkinleştirildiğinde, yanıtlayanın bu sütundaki her soru için benzersiz bir yanıt vermesi gerekir."
// matrixdropdowncolumn.rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear." => "Giriş alanında görüntülenen satırların sayısını ayarlar. Giriş daha fazla satır alırsa, kaydırma çubuğu görünecektir."
// matrixdropdowncolumn.visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility." => "Sütun görünürlüğünü belirleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın."
// matrixdropdowncolumn.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column." => "Sütunun salt okunur modunu devre dışı bırakan koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın."
// matrixdropdowncolumn.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "En az bir iç içe geçmiş sorunun yanıtı olmadığı sürece anket gönderimini engelleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın."
// matrixdropdowncolumn.showInMultipleColumns: "When selected, creates an individual column for each choice option." => "Seçildiğinde, her seçim seçeneği için ayrı bir sütun oluşturur."
// pehelp.widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used." => "Şunlar arasından seçim yapın: \"Statik\" - sabit bir genişlik ayarlar; \"Duyarlı\" - anketin ekranın tüm genişliğini kaplamasını sağlar; \"Otomatik\" - kullanılan soru türlerine bağlı olarak ikisinden birini uygular."
// pehelp.logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)." => "Bilgisayarınızdan bir dosyaya (64 KB'a kadar) göz atmak için bir resim bağlantısı yapıştırın (boyut sınırı yok) veya klasör simgesini tıklayın."
// pehelp.logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.)." => "CSS birimlerinde bir logo genişliği ayarlar (px, %, in, pt, vb.)."
// pehelp.logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.)." => "CSS birimlerinde (px, %, in, pt, vb.) bir logo yüksekliği ayarlar."
// pehelp.logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Şunlar arasından seçim yapın: \"Yok\" - görüntü orijinal boyutunu korur; \"İçer\" - görüntü, en boy oranı korunurken sığacak şekilde yeniden boyutlandırılır; \"Kapak\" - görüntü, en boy oranını korurken tüm kutuyu doldurur; \"Doldur\" - görüntü, en boy oranını korumadan kutuyu dolduracak şekilde uzatılır."
// pehelp.goNextPageAutomatic: "Select if you want the survey to advance to the next page automatically after a respondent answers all questions on the current page." => "Yanıtlayan geçerli sayfadaki tüm soruları yanıtladıktan sonra anketin otomatik olarak bir sonraki sayfaya ilerlemesini isteyip istemediğinizi seçin."
// pehelp.showNavigationButtons: "Sets the visibility and location of navigation buttons on a page." => "Sayfadaki gezinme düğmelerinin görünürlüğünü ve konumunu ayarlar."
// pehelp.showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header." => "İlerleme çubuğunun görünürlüğünü ve konumunu ayarlar. \"Otomatik\" değeri, anket başlığının üstünde veya altında ilerleme çubuğunu görüntüler."
// pehelp.showPreviewBeforeComplete: "Enable the preview page with all or answered questions only." => "Önizleme sayfasını tüm sorularla veya yalnızca yanıtlanmış sorularla etkinleştirin."
// pehelp.questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level." => "Anketteki tüm sorular için geçerlidir. Bu ayar, panel, sayfa veya soru gibi daha düşük düzeylerdeki başlık hizalama kuralları tarafından geçersiz kılınabilir. Daha düşük düzeydeki bir ayar, daha yüksek düzeydeki ayarları geçersiz kılar."
// pehelp.requiredText: "A symbol or a sequence of symbols indicating that an answer is required." => "Bir yanıtın gerekli olduğunu gösteren bir sembol veya sembol dizisi."
// pehelp.questionStartIndex: "Enter a number or letter with which you want to start numbering." => "Numaralandırmaya başlamak istediğiniz sayıyı veya harfi girin."
// pehelp.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box." => "Geçersiz girişi olan soruyla ilgili olarak bir hata mesajının konumunu ayarlar. Şunlar arasından seçim yapın: \"Üst\" - soru kutusunun en üstüne bir hata metni yerleştirilir; \"Alt\" - soru kutusunun altına bir hata metni yerleştirilir."
// pehelp.focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry." => "Her sayfadaki ilk giriş alanının metin girişi için hazır olmasını istiyorsanız seçin."
// pehelp.questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab." => "Soruların orijinal sırasını korur veya rastgele hale getirir. Bu ayarın etkisi yalnızca Önizleme sekmesinde görünür."
// pehelp.maxTextLength: "For text entry questions only." => "Yalnızca metin girişi soruları için."
// pehelp.maxOthersLength: "For question comments only." => "Yalnızca soru yorumları içindir."
// pehelp.autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length." => "Soru yorumlarının ve Uzun Metin sorularının yüksekliğinin girilen metin uzunluğuna göre otomatik olarak büyümesini istiyorsanız seçin."
// pehelp.allowResizeComment: "For question comments and Long Text questions only." => "Yalnızca soru yorumları ve Uzun Metin soruları için."
// pehelp.calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on." => "Özelleştirilebilir değişkenler, form hesaplamalarında kullanılan ara veya yardımcı değişkenler olarak işlev görür. Yanıtlayan girdilerini kaynak değerler olarak alırlar. Her özelleştirilebilen değişkenin benzersiz bir adı ve temel aldığı bir ifadesi vardır."
// pehelp.includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results." => "İfadenin hesaplanan değerinin anket sonuçlarıyla birlikte kaydedilmesini isteyip istemediğinizi seçin."
// pehelp.triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects." => "Tetikleyici, bir ifadeyi temel alan bir olay veya koşuldur. İfade \"true\" olarak değerlendirildikten sonra, bir tetikleyici bir eylemi başlatır. Böyle bir eylemin isteğe bağlı olarak etkilediği bir hedef sorusu olabilir."
// pehelp.clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it." => "Koşullu mantık tarafından gizlenen sorular için değerlerin temizlenip temizlenmeyeceğini ve bunun ne zaman yapılacağını seçin."
// pehelp.textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing." => "Şunlar arasından seçim yapın: \"Odak kaybolduğunda\" - giriş alanı odağı kaybettiğinde değer güncellenir; \"Yazarken\" - değer, kullanıcılar yazarken gerçek zamanlı olarak güncellenir."
// pehelp.columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents." => "Soldaki değer, koşullu kurallarda kullanılan bir sütun kimliği görevi görür, sağdaki değer yanıtlayanlara gösterilir."
// pehelp.rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents." => "Soldaki değer, koşullu kurallarda kullanılan bir satır kimliği görevi görür, sağdaki değer yanıtlayanlara gösterilir."
// pehelp.columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS değerlerini (px, %, in, pt, vb.) kabul eder."
// pehelp.rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS değerlerini (px, %, in, pt, vb.) kabul eder."
// pehelp.cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property." => "Geçersiz girişi olan bir hücreyle ilgili olarak bir hata iletisinin konumunu ayarlar. \"Devral\" seçeneği, ayarı \"Hata iletisi hizalaması\" özelliğinden uygular."
// pehelp.keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message." => "\"Yinelenen yanıtları engelle\" özelliği etkinleştirildiğinde, yinelenen bir girdi göndermeye çalışan yanıtlayan aşağıdaki hata iletisini alır."
// pehelp.totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Bir ifadeye dayalı olarak toplam değerleri hesaplamanıza olanak tanır. İfade, temel hesaplamaları ('{q1_id} + {q2_id}'), Boole ifadelerini ('{age} > 60') ve işlevleri ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' vb.) içerebilir."
// pehelp.confirmDelete: "Triggers a prompt asking to confirm the row deletion." => "Satır silme işlemini onaylamanızı isteyen bir istemi tetikler."
// pehelp.defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row." => "Son satırdaki yanıtları çoğaltır ve bunları bir sonraki eklenen dinamik satıra atar."
// pehelp.description: "Type a subtitle." => "Bir altyazı yazın."
// pehelp.locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab." => "Anketinizi oluşturmaya başlamak için bir dil seçin. Çeviri eklemek için yeni bir dile geçin ve orijinal metni buradan veya Çeviriler sekmesinden çevirin."
// pehelp.detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed." => "Ayrıntılar bölümünün bir satıra göre konumunu ayarlar. Şunlar arasından seçim yapın: \"Yok\" - genişletme eklenmez; \"Satırın altında\" - matrisin her satırının altına bir satır genişletmesi yerleştirilir; \"Satırın altında, yalnızca bir satır genişletmesi görüntüle\" - yalnızca tek bir satırın altında bir genişletme görüntülenir, kalan satır genişletmeleri daraltılır."
// pehelp.imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio." => "Şunlar arasından seçim yapın: \"Yok\" - görüntü orijinal boyutunu korur; \"İçer\" - görüntü, en boy oranı korunurken sığacak şekilde yeniden boyutlandırılır; \"Kapak\" - görüntü, en boy oranını korurken tüm kutuyu doldurur; \"Doldur\" - görüntü, en boy oranını korumadan kutuyu dolduracak şekilde uzatılır."
// pehelp.autoGrow: "Gradually increases the height of the input field as data is being entered. Overrides the \"Input field height (in lines)\" setting." => "Veriler girilirken giriş alanının yüksekliğini kademeli olarak artırır. \"Giriş alanı yüksekliği (satırlarda)\" ayarını geçersiz kılar."
// pehelp.allowResize: "The resize handle (or grip) appears in the corner and can be dragged to alter the size of the input field." => "Yeniden boyutlandırma tutamacı (veya tutamak) köşede görünür ve giriş alanının boyutunu değiştirmek için sürüklenebilir."
// pehelp.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the Thank You page." => "Anketin otomatik olarak Teşekkür Ederiz sayfasına ilerlediği saniye cinsinden bir zaman aralığı."
// pehelp.maxTimeToFinishPage: "A time interval in seconds after which the survey auto-advances to the next page." => "Anketin otomatik olarak bir sonraki sayfaya ilerlediği saniye cinsinden bir zaman aralığı."
// page.maxTimeToFinish: "A time interval in seconds after which the survey auto-advances to the next page." => "Anketin otomatik olarak bir sonraki sayfaya ilerlediği saniye cinsinden bir zaman aralığı."
// page.visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility." => "Sayfa görünürlüğünü belirleyen koşullu bir kural belirlemek için sihirli değnek simgesini kullanın."
// page.enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page." => "Sayfanın salt okunur modunu devre dışı bırakan koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın."
// page.requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer." => "En az bir iç içe geçmiş sorunun yanıtı olmadığı sürece anket gönderimini engelleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın."
// page.questionTitleLocation: "Applies to all questions within this page. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Bu sayfadaki tüm sorular için geçerlidir. Bu ayarı geçersiz kılmak istiyorsanız, tek tek sorular veya paneller için başlık hizalama kuralları tanımlayın. \"Devral\" seçeneği, anket düzeyindeki ayarı uygular (varsayılan olarak \"Üst\")."
// page.questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)." => "Geçersiz girişi olan soruyla ilgili olarak bir hata mesajının konumunu ayarlar. Şunlar arasından seçim yapın: \"Üst\" - soru kutusunun en üstüne bir hata metni yerleştirilir; \"Alt\" - soru kutusunun altına bir hata metni yerleştirilir. \"Devral\" seçeneği, anket düzeyindeki ayarı uygular (varsayılan olarak \"Üst\")."
// page.questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab." => "Soruların orijinal sırasını korur veya rastgele hale getirir. \"Devral\" seçeneği, anket düzeyindeki ayarı (varsayılan olarak \"Orijinal\") uygular. Bu ayarın etkisi yalnızca Önizleme sekmesinde görünür."
// page.navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"." => "Sayfadaki gezinme düğmelerinin görünürlüğünü ayarlar. \"Devral\" seçeneği, varsayılan olarak \"Görünür\" olan anket düzeyi ayarını uygular."
// pehelp.showTimerPanel: "Sets the visibility and location of a timer on a page." => "Sayfadaki bir zamanlayıcının görünürlüğünü ve konumunu ayarlar."
// pehelp.panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded." => "Şunlar arasından seçim yapın: \"Kilitli\" - kullanıcılar panelleri genişletemez veya daraltamaz; \"Tümünü daralt\" - tüm paneller daraltılmış durumda başlar; \"Tümünü genişlet\" - tüm paneller genişletilmiş bir durumda başlar; \"İlk genişletildi\" - başlangıçta yalnızca ilk panel genişletilir."
// pehelp.imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list." => "Seçim listesinde görüntülemek istediğiniz görüntü veya video dosyası URL'lerini içeren nesne dizisi içinde paylaşılan bir özellik adı girin."
// pehelp.choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Soldaki değer, koşullu kurallarda kullanılan bir öğe kimliği görevi görür, sağdaki değer yanıtlayanlara gösterilir."
// pehelp.title: "Type a user-friendly title to display." => "Görüntülemek için kullanıcı dostu bir başlık yazın."
// pehelp.waitForUpload: "Ensures that users won't complete the survey until files are uploaded." => "Dosyalar yüklenene kadar kullanıcıların anketi tamamlamamasını sağlar."
// pehelp.minWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS değerlerini (px, %, in, pt, vb.) kabul eder."
// pehelp.maxWidth: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS değerlerini (px, %, in, pt, vb.) kabul eder."
// pehelp.width: "Accepts CSS values (px, %, in, pt, etc.)." => "CSS değerlerini (px, %, in, pt, vb.) kabul eder."
// pehelp.useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements." => "Tekli ve çoktan seçimli soru tiplerinde, her seçim seçeneğinin bir kimliği ve görünen değeri vardır. Seçildiğinde, bu ayar HTML sorularında ve anket öğelerinin dinamik başlıklarında ve açıklamalarında kimlik değeri yerine bir görünen değer gösterir."
// pehelp.clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)." => "Koşullu mantık tarafından gizlenen soru değerlerinin temizlenip temizlenmeyeceğini ve ne zaman yapılacağını seçin. \"Devral\" seçeneği, anket düzeyindeki ayarı uygular (varsayılan olarak \"Anket tamamlandıktan sonra\")."
// pehelp.choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question." => "Şunlar arasından seçim yapın: \"Tümü\" - seçilen sorudaki tüm seçim seçeneklerini kopyalar; \"Seçili\" - yalnızca seçilen seçim seçeneklerini dinamik olarak kopyalar; \"Seçilmemiş\" - yalnızca seçilmemiş seçim seçeneklerini dinamik olarak kopyalar. \"Yok\" ve \"Diğer\" seçenekleri, kaynak soruda etkinleştirilmişse varsayılan olarak kopyalanır."
// pehelp.showOtherItem: "When selected, users can include additional input in a separate comment box." => "Seçildiğinde, kullanıcılar ayrı bir yorum kutusuna ek girdi ekleyebilir."
// pehelp.separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout." => "Her özel seçim seçeneğini (\"Yok\", \"Diğer\", \"Tümünü Seç\") çok sütunlu bir düzen kullanırken bile yeni bir satırda görüntüler."
// pehelp.path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array." => "Hizmet veri kümesinde, hedef nesne dizisinin bulunduğu konumu belirtin. URL zaten diziye işaret ediyorsa boş bırakın."
// pehelp.titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list." => "Seçim listesinde görüntülemek istediğiniz değerleri içeren nesneler dizisi içinde tekdüzen bir özellik adı girin."
// pehelp.allowEmptyResponse: "Select to allow the service to return an empty response or array." => "Hizmetin boş bir yanıt veya dizi döndürmesine izin vermek için seçin."
// pehelp.choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options." => "Tüm seçim seçeneklerinin görünürlüğünü belirleyen koşullu bir kural ayarlamak için sihirli değnek simgesini kullanın."
// pehelp.rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents." => "Soldaki değer, koşullu kurallarda kullanılan bir öğe kimliği görevi görür, sağdaki değer yanıtlayanlara gösterilir."
// rating.displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown." => "\"Otomatik\", mevcut genişliğe göre \"Düğmeler\" ve \"Açılır Menü\" modları arasında seçim yapar. Genişlik düğmeleri görüntülemek için yetersiz olduğunda, soru bir açılır menü görüntüler."
// pehelp.valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values." => "Farklı formatlarda sonuç üreten soruları bağlamanıza olanak tanır. Bu tür sorular bir birleştirme tanımlayıcısı kullanılarak birbirine bağlandığında, bu paylaşılan özellik seçilen soru değerlerini depolar."
// pehelp.searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field." => "Açılır menü içeriğini, kullanıcının giriş alanına yazdığı arama sorgusuyla eşleşecek şekilde güncelleştirmek istiyorsanız seçin."
// pehelp.valueTrue: "A value to save in survey results when respondents give a positive answer." => "Yanıtlayanlar olumlu yanıt verdiğinde anket sonuçlarına kaydedilecek bir değer."
// pehelp.valueFalse: "A value to save in survey results when respondents give a negative answer." => "Yanıtlayanlar olumsuz yanıt verdiğinde anket sonuçlarına kaydedilecek bir değer."
// pehelp.showPreview: "It's not recommended to disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded." => "Önizleme görüntüsünü geçersiz kıldığından ve kullanıcının dosyaların yüklenip yüklenmediğini anlamasını zorlaştırdığından bu seçeneğin devre dışı bırakılması önerilmez."
// pehelp.needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion." => "Dosya silme işlemini onaylamanızı isteyen bir istemi tetikler."
// pehelp.selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area." => "Yalnızca seçilen seçenekleri sıralamak için etkinleştirin. Kullanıcılar, sıralama alanı içinde sıralamak için seçim listesinden seçilen öğeleri sürükleyecektir."
// pehelp.dataList: "Enter a list of choices that will be suggested to the respondent during input." => "Giriş sırasında yanıtlayana önerilecek seçeneklerin bir listesini girin."
// pehelp.itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box." => "Bu ayar yalnızca giriş alanlarını yeniden boyutlandırır ve soru kutusunun genişliğini etkilemez."
// pehelp.itemTitleWidth: "Sets consistent width for all item labels in pixels" => "Piksel cinsinden tüm öğe etiketleri için tutarlı genişlik ayarlar"
// pehelp.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "\"Otomatik\" seçeneği, sağlanan kaynak URL'ye göre görüntüleme için uygun modu (Resim, Video veya YouTube) otomatik olarak belirler."
// pehelp.altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes." => "Görüntü, kullanıcının cihazında görüntülenemediğinde ve erişilebilirlik amacıyla yedek olarak görev yapar."
// pehelp.rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale." => "Derecelendirme simgesi türü \"Suratlar\" olarak ayarlandığında seçilen emojinin rengini tanımlar. Şunlar arasından seçim yapın: \"Varsayılan\" - seçilen emoji varsayılan anket renginde görünür; \"Ölçek\" - seçilen emoji, derecelendirme ölçeğinden rengi devralır."
// expression.name: "An expression ID that is not visible to respondents." => "Yanıtlayanlar tarafından görülemeyen bir ifade kimliği."
// expression.description: "Type an expression subtitle." => "Bir ifade alt başlığı yazın."
// expression.expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)." => "Bir ifade, temel hesaplamaları ('{q1_id} + {q2_id}'), koşulları ('{age} > 60') ve işlevleri ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' vb.) içerebilir."
// pehelp.storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results." => "\"Diğer\" seçenek değerini anket sonuçlarında ayrı bir özellik olarak saklamak için seçin."
// p.swapOrder: "Swap the order of Yes and No" => "Evet ve Hayır sırasını değiştirin"
// p.itemTitleWidth: "Item label width (in px)" => "Öğe etiketi genişliği (piksel cinsinden)"
// p.selectToRankEmptyRankedAreaText: "Text to show if all options are selected" => "Tüm seçeneklerin seçili olup olmadığını gösteren metin"
// p.selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area" => "Derecelendirme alanı için yer tutucu metin"
// pe.allowCompleteSurveyAutomatic: "Complete the survey automatically" => "Anketi otomatik olarak tamamlama"
// pehelp.allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions." => "Yanıtlayan tüm soruları yanıtladıktan sonra anketin otomatik olarak tamamlanmasını isteyip istemediğinizi seçin."
// masksettings.saveMaskedValue: "Save masked value in survey results" => "Anket sonuçlarında maskelenmiş değeri kaydetme"
// patternmask.pattern: "Value pattern" => "Değer örüntüsü"
// datetimemask.min: "Minimum value" => "Minimum değer"
// datetimemask.max: "Maximum value" => "Maksimum değer"
// numericmask.allowNegativeValues: "Allow negative values" => "Negatif değerlere izin ver"
// numericmask.thousandsSeparator: "Thousands separator" => "Binlik ayırıcı"
// numericmask.decimalSeparator: "Decimal separator" => "Ondalık ayırıcı"
// numericmask.precision: "Value precision" => "Değer hassasiyeti"
// numericmask.min: "Minimum value" => "Minimum değer"
// numericmask.max: "Maximum value" => "Maksimum değer"
// currencymask.prefix: "Currency prefix" => "Para birimi öneki"
// currencymask.suffix: "Currency suffix" => "Para birimi son eki"
// pe.maskType: "Input mask type" => "Giriş maskesi türü"
// maskTypes.patternmask: "Pattern" => "Desen"
// maskTypes.numericmask: "Numeric" => "Sayısal"
// maskTypes.datetimemask: "Date and Time" => "Tarih ve Saat"
// maskTypes.currencymask: "Currency" => "Para birimi"
// tabs.mask: "Input Mask Settings" => "Giriş Maskesi Ayarları"
// pe.pattern_placeholder: "Ex.: +1(999)-999-99-99" => "Ör.: +1(999)-999-99-99"
// pe.datetimepattern_placeholder: "Ex.: mm/dd/yyyy" => "Ör.: aa/gg/yyyy"
// pe.currencyprefix_placeholder: "Ex.: $" => "Ör.: $"
// pe.currencysuffix_placeholder: "Ex.: USD" => "Ör.: USD"
// pv.textWrapEnabled: "Wrap choices" => "Sarma seçenekleri"
// question.textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip." => "Seçim seçeneklerindeki uzun metinler, açılır menüye sığacak şekilde otomatik olarak satır sonları oluşturur. Metinlerin kırpılmasını istiyorsanız seçimi kaldırın."
// masksettings.saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results." => "Soru değerini, anket sonuçlarında uygulanan bir maske ile saklamak istiyorsanız seçin."
// patternmask.pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character." => "Desen, dize değişmez değerlerini ve aşağıdaki yer tutucuları içerebilir: '9' - bir rakam için; 'a' - büyük veya küçük harf için; '#' - bir rakam veya büyük veya küçük harf için. Bir karakterden kaçmak için ters eğik çizgi '\\' kullanın."
// datetimemask.pattern: "The pattern can contain separator characters and the following placeholders: `m` - for month number; `mm` - for month number, with leading zero for single-digit values; `d` - for day of the month; `dd` - for day of the month, with leading zero for single-digit values; `yy` - for the last two digits of the year; `yyyy` - for a four-digit year." => "Desen, ayırıcı karakterler ve aşağıdaki yer tutucuları içerebilir: 'm' - ay numarası için; 'mm' - ay numarası için, tek basamaklı değerler için başında sıfır var; 'd' - ayın günü için; 'dd' - ayın günü için, tek basamaklı değerler için başında sıfır var; 'yy' - yılın son iki hanesi için; 'yyyy' - dört basamaklı bir yıl için."
// numericmask.decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number." => "Görüntülenen bir sayının kesirli kısmını tamsayı kısmından ayırmak için kullanılan bir sembol."
// numericmask.thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three." => "Büyük bir sayının rakamlarını üçlü gruplara ayırmak için kullanılan bir sembol."
// numericmask.precision: "Limits how many digits to retain after the decimal point for a displayed number." => "Görüntülenen bir sayı için ondalık virgülden sonra kaç basamak tutulacağını sınırlar."
// currencymask.prefix: "One or several symbols to be displayed before the value." => "Değerden önce görüntülenecek bir veya birkaç sembol."
// currencymask.suffix: "One or several symbols to be displayed after the value." => "Değerden sonra görüntülenecek bir veya birkaç sembol."
// ed.translationSource: "Source: " => "Kaynak: "
// ed.translationTarget: "Target: " => "Hedef: "
// ed.pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below." => "Sayfa boş. Araç kutusundan bir öğeyi sürükleyin veya aşağıdaki düğmeyi tıklatın."
// maskTypes.none: "None" => "Hiç kimse"
// itemvalue@rows.visibleIf: "Make the row visible if" => "Aşağıdaki durumlarda satırı görünür hale getirin"
// itemvalue@rows.enableIf: "Make the row editable if" => "Aşağıdaki durumlarda satırı düzenlenebilir hale getirin"
// signaturepad.placeholderReadOnly: "Placeholder text in read-only or preview mode" => "Salt okunur veya önizleme modunda yer tutucu metin"
// pe.textWrapEnabled: "Wrap choices" => "Sarma seçenekleri"
// image.contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided." => "\"Otomatik\" seçeneği, sağlanan kaynak URL'ye göre görüntüleme için uygun modu (Resim, Video veya YouTube) otomatik olarak belirler."
// imagepicker.contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options." => "Medya seçicinin içerik modunu ayarlamak için \"Görüntü\" ve \"Video\" arasında seçim yapın. \"Resim\" seçilirse, sağlanan tüm seçeneklerin şu biçimlerdeki resim dosyaları olduğundan emin olun: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Benzer şekilde, \"Video\" seçilirse, tüm seçeneklerin aşağıdaki formatlardaki video dosyalarına doğrudan bağlantılar olduğundan emin olun: MP4, MOV, WMV, FLV, AVI, MKV. Video seçenekleri için YouTube bağlantılarının desteklenmediğini lütfen unutmayın."
// ed.selectFile: "Select a file" => "Bir dosya seçin"
// ed.removeFile: "Remove the file" => "Dosyayı kaldır"
// pe.searchMode: "Search Mode" => "Arama Modu"
// ed.surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form." => "Formunuzu oluşturmaya başlamak için aşağıdaki \"Soru Ekle\" butonuna tıklayın."
// ed.pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page." => "Sayfaya yeni bir öğe eklemek için aşağıdaki \"Soru Ekle\" düğmesini tıklayın."
// ed.panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel." => "Panele yeni bir öğe eklemek için aşağıdaki \"Soru Ekle\" düğmesini tıklayın."
// ed.imagePlaceHolderMobile: "Click the button below and choose an image to upload" => "Aşağıdaki düğmeyi tıklayın ve yüklemek için bir resim seçin"
// coloralpha.opacity: "Opacity" => "Opak -lık"
// font.family: "Font family" => "Yazı tipi ailesi"
// font.color: "Color" => "Renk"
// font.placeholderColor: "Placeholder color" => "Yer tutucu rengi"
// font.size: "Size" => "Boyut"
// theme.themeName: "Theme" => "Tema"
// theme.isPanelless: "Question appearance" => "Soru görünümü"
// theme.editorPanel: "Background and corner radius" => "Arka plan ve köşe yarıçapı"
// theme.questionPanel: "Background and corner radius" => "Arka plan ve köşe yarıçapı"
// theme.primaryColor: "Accent color" => "Vurgu rengi"
// theme.panelBackgroundTransparency: "Panel background opacity" => "Panel arka plan opaklığı"
// theme.questionBackgroundTransparency: "Question background opacity" => "Soru arka plan opaklığı"
// theme.fontSize: "Font size" => "Yazı boyutu"
// theme.scale: "Scale" => "Ölçeklemek"
// theme.cornerRadius: "Corner radius" => "Köşe yarıçapı"
// theme.pageTitle: "Title font" => "Başlık yazı tipi"
// theme.pageDescription: "Description font" => "Açıklama yazı tipi"
// theme.questionTitle: "Title font" => "Başlık yazı tipi"
// theme.questionDescription: "Description font" => "Açıklama yazı tipi"
// theme.editorFont: "Font" => "Yazı tipi"
// theme.backgroundOpacity: "Opacity" => "Opak -lık"
// theme.--sjs-font-family: "Font family" => "Yazı tipi ailesi"
// theme.--sjs-general-backcolor-dim: "Background color" => "Arka plan rengi"
// theme.--sjs-primary-backcolor: "Accent background" => "Vurgu arka planı"
// theme.--sjs-primary-forecolor: "Accent foreground" => "Vurgu ön planı"
// theme.--sjs-shadow-small: "Shadow effects" => "Gölge efektleri"
// theme.--sjs-shadow-inner: "Shadow effects" => "Gölge efektleri"
// theme.--sjs-border-default: "Colors" => "Renk"
// header@header.headerView: "View" => "Görünüm"
// header@header.logoPosition: "Logo position" => "Logo konumu"
// header@header.surveyTitle: "Survey title font" => "Anket başlığı yazı tipi"
// header@header.surveyDescription: "Survey description font" => "Anket açıklaması yazı tipi"
// header@header.headerTitle: "Survey title font" => "Anket başlığı yazı tipi"
// header@header.headerDescription: "Survey description font" => "Anket açıklaması yazı tipi"
// header@header.inheritWidthFrom: "Content area width" => "İçerik alanı genişliği"
// header@header.textAreaWidth: "Text width" => "Metin genişliği"
// header@header.backgroundColorSwitch: "Background color" => "Arka plan rengi"
// header@header.backgroundImage: "Background image" => "Arka plan resmi"
// header@header.backgroundImageOpacity: "Opacity" => "Opak -lık"
// header@header.overlapEnabled: "Overlap" => "Örtüş"
// header@header.logoPositionX: "Logo position" => "Logo konumu"
// header@header.titlePositionX: "Title position" => "Unvan pozisyonu"
// header@header.descriptionPositionX: "Description position" => "Açıklama konumu"
// weight.400: "Regular" => "Düzenli"
// weight.600: "Heavy" => "Ağır"
// weight.700: "Semi-bold" => "Yarı kalın"
// weight.800: "Bold" => "Kalın"
// backgroundImageFit.auto: "Auto" => "Otomatik"
// backgroundImageFit.cover: "Cover" => "Örtmek"
// backgroundImageFit.contain: "Contain" => "Kapsamak"
// backgroundImageFit.fill: "Stretch" => "Uzatmak"
// backgroundImageFit.tile: "Tile" => "Kiremit"
// backgroundImageAttachment.fixed: "Fixed" => "Sabit"
// backgroundImageAttachment.scroll: "Scroll" => "Tomar"
// headerView.basic: "Basic" => "Temel"
// headerView.advanced: "Advanced" => "İleri"
// inheritWidthFrom.survey: "Same as survey" => "Anketle aynı"
// inheritWidthFrom.container: "Fit to container" => "Konteynere sığdır"
// backgroundColorSwitch.none: "None" => "Hiç kimse"
// backgroundColorSwitch.accentColor: "Accent color" => "Vurgu rengi"
// backgroundColorSwitch.custom: "Custom" => "Töre"
// colorPalette.light: "Light" => "Işık"
// colorPalette.dark: "Dark" => "Koyu"
// isPanelless.false: "Default" => "Temerrüt"
// isPanelless.true: "Without Panels" => "Panelsiz"
// theme.cornerRadius: "Corner radius" => "Köşe yarıçapı"
// theme.fontFamily: "Font family" => "Yazı tipi ailesi"
// theme.fontWeightRegular: "Regular" => "Düzenli"
// theme.fontWeightHeavy: "Heavy" => "Ağır"
// theme.fontWeightSemiBold: "Semi-bold" => "Yarı kalın"
// theme.fontWeightBold: "Bold" => "Kalın"
// theme.color: "Color" => "Renk"
// theme.placeholderColor: "Placeholder color" => "Yer tutucu rengi"
// theme.size: "Size" => "Boyut"
// theme.opacity: "Opacity" => "Opak -lık"
// ed.toolboxFilteredTextPlaceholder: "Type to search..." => "Aramak için yazın..."
// ed.toolboxNoResultsFound: "No results found" => "Sonuç bulunamadı"
// paneldynamic.tabTitlePlaceholder: "Tab title placeholder" => "Sekme başlığı yer tutucusu"
// theme.--sjs-special-red: "Error messages" => "Hata mesajları"
// paneldynamic.tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value." => "Sekme başlığı deseni anlamlı bir değer üretmediğinde geçerli olan sekme başlıkları için bir geri dönüş metni."
// theme.fontColor: "Font color" => "Yazı tipi rengi"
// theme.backgroundColor: "Background color" => "Arka plan rengi"
// pe.questionTitleWidth: "Question title width" => "Soru başlığı genişliği"
// pe.fileInputPlaceholder: "Select a file or paste a file link..." => "Bir dosya seçin veya bir dosya bağlantısı yapıştırın..."
// panelbase.questionTitleWidth: "Ex.: 200px" => "Ör.: 200 piksel"
// panel.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Soru kutularının soluna hizalandıklarında soru başlıkları için tutarlı genişlik ayarlar. CSS değerlerini (px, %, in, pt, vb.) kabul eder."
// page.questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)." => "Soru kutularının soluna hizalandıklarında soru başlıkları için tutarlı genişlik ayarlar. CSS değerlerini (px, %, in, pt, vb.) kabul eder."
// pe.commentAreaRows: "Comment area height (in lines)" => "Yorum alanı yüksekliği (satırlar halinde)"
// pehelp.commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears." => "Soru yorumları için metin alanlarında görüntülenen satır sayısını ayarlar. Girişte daha fazla satır alır, kaydırma çubuğu görünür."


/***/ }),

/***/ "survey-creator-core":
/*!********************************************************************************************************************************************!*\
  !*** external {"root":"SurveyCreatorCore","commonjs2":"survey-creator-core","commonjs":"survey-creator-core","amd":"survey-creator-core"} ***!
  \********************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_survey_creator_core__;

/***/ })

/******/ });
});
//# sourceMappingURL=survey-creator-core.i18n.js.map